/******/ (function(modules) { // webpackBootstrap
/******/ 	var parentHotUpdateCallback = this["webpackHotUpdate"];
/******/ 	this["webpackHotUpdate"] = 
/******/ 	function webpackHotUpdateCallback(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		hotAddUpdateChunk(chunkId, moreModules);
/******/ 		if(parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadUpdateChunk(chunkId) { // eslint-disable-line no-unused-vars
/******/ 		var head = document.getElementsByTagName("head")[0];
/******/ 		var script = document.createElement("script");
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = "utf-8";
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
/******/ 		head.appendChild(script);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadManifest(callback) { // eslint-disable-line no-unused-vars
/******/ 		if(typeof XMLHttpRequest === "undefined")
/******/ 			return callback(new Error("No browser support"));
/******/ 		try {
/******/ 			var request = new XMLHttpRequest();
/******/ 			var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
/******/ 			request.open("GET", requestPath, true);
/******/ 			request.timeout = 10000;
/******/ 			request.send(null);
/******/ 		} catch(err) {
/******/ 			return callback(err);
/******/ 		}
/******/ 		request.onreadystatechange = function() {
/******/ 			if(request.readyState !== 4) return;
/******/ 			if(request.status === 0) {
/******/ 				// timeout
/******/ 				callback(new Error("Manifest request to " + requestPath + " timed out."));
/******/ 			} else if(request.status === 404) {
/******/ 				// no update available
/******/ 				callback();
/******/ 			} else if(request.status !== 200 && request.status !== 304) {
/******/ 				// other failure
/******/ 				callback(new Error("Manifest request to " + requestPath + " failed."));
/******/ 			} else {
/******/ 				// success
/******/ 				try {
/******/ 					var update = JSON.parse(request.responseText);
/******/ 				} catch(e) {
/******/ 					callback(e);
/******/ 					return;
/******/ 				}
/******/ 				callback(null, update);
/******/ 			}
/******/ 		};
/******/ 	}
/******/
/******/ 	
/******/ 	
/******/ 	// Copied from https://github.com/facebook/react/blob/bef45b0/src/shared/utils/canDefineProperty.js
/******/ 	var canDefineProperty = false;
/******/ 	try {
/******/ 		Object.defineProperty({}, "x", {
/******/ 			get: function() {}
/******/ 		});
/******/ 		canDefineProperty = true;
/******/ 	} catch(x) {
/******/ 		// IE will fail on defineProperty
/******/ 	}
/******/ 	
/******/ 	var hotApplyOnUpdate = true;
/******/ 	var hotCurrentHash = "958efc9aa00ff07bf52a"; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentModuleData = {};
/******/ 	var hotCurrentParents = []; // eslint-disable-line no-unused-vars
/******/ 	
/******/ 	function hotCreateRequire(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var me = installedModules[moduleId];
/******/ 		if(!me) return __webpack_require__;
/******/ 		var fn = function(request) {
/******/ 			if(me.hot.active) {
/******/ 				if(installedModules[request]) {
/******/ 					if(installedModules[request].parents.indexOf(moduleId) < 0)
/******/ 						installedModules[request].parents.push(moduleId);
/******/ 					if(me.children.indexOf(request) < 0)
/******/ 						me.children.push(request);
/******/ 				} else hotCurrentParents = [moduleId];
/******/ 			} else {
/******/ 				console.warn("[HMR] unexpected require(" + request + ") from disposed module " + moduleId);
/******/ 				hotCurrentParents = [];
/******/ 			}
/******/ 			return __webpack_require__(request);
/******/ 		};
/******/ 		for(var name in __webpack_require__) {
/******/ 			if(Object.prototype.hasOwnProperty.call(__webpack_require__, name)) {
/******/ 				if(canDefineProperty) {
/******/ 					Object.defineProperty(fn, name, (function(name) {
/******/ 						return {
/******/ 							configurable: true,
/******/ 							enumerable: true,
/******/ 							get: function() {
/******/ 								return __webpack_require__[name];
/******/ 							},
/******/ 							set: function(value) {
/******/ 								__webpack_require__[name] = value;
/******/ 							}
/******/ 						};
/******/ 					}(name)));
/******/ 				} else {
/******/ 					fn[name] = __webpack_require__[name];
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		function ensure(chunkId, callback) {
/******/ 			if(hotStatus === "ready")
/******/ 				hotSetStatus("prepare");
/******/ 			hotChunksLoading++;
/******/ 			__webpack_require__.e(chunkId, function() {
/******/ 				try {
/******/ 					callback.call(null, fn);
/******/ 				} finally {
/******/ 					finishChunkLoading();
/******/ 				}
/******/ 	
/******/ 				function finishChunkLoading() {
/******/ 					hotChunksLoading--;
/******/ 					if(hotStatus === "prepare") {
/******/ 						if(!hotWaitingFilesMap[chunkId]) {
/******/ 							hotEnsureUpdateChunk(chunkId);
/******/ 						}
/******/ 						if(hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 							hotUpdateDownloaded();
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 			});
/******/ 		}
/******/ 		if(canDefineProperty) {
/******/ 			Object.defineProperty(fn, "e", {
/******/ 				enumerable: true,
/******/ 				value: ensure
/******/ 			});
/******/ 		} else {
/******/ 			fn.e = ensure;
/******/ 		}
/******/ 		return fn;
/******/ 	}
/******/ 	
/******/ 	function hotCreateModule(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var hot = {
/******/ 			// private stuff
/******/ 			_acceptedDependencies: {},
/******/ 			_declinedDependencies: {},
/******/ 			_selfAccepted: false,
/******/ 			_selfDeclined: false,
/******/ 			_disposeHandlers: [],
/******/ 	
/******/ 			// Module API
/******/ 			active: true,
/******/ 			accept: function(dep, callback) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfAccepted = true;
/******/ 				else if(typeof dep === "function")
/******/ 					hot._selfAccepted = dep;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._acceptedDependencies[dep[i]] = callback;
/******/ 				else
/******/ 					hot._acceptedDependencies[dep] = callback;
/******/ 			},
/******/ 			decline: function(dep) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfDeclined = true;
/******/ 				else if(typeof dep === "number")
/******/ 					hot._declinedDependencies[dep] = true;
/******/ 				else
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._declinedDependencies[dep[i]] = true;
/******/ 			},
/******/ 			dispose: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			addDisposeHandler: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			removeDisposeHandler: function(callback) {
/******/ 				var idx = hot._disposeHandlers.indexOf(callback);
/******/ 				if(idx >= 0) hot._disposeHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			// Management API
/******/ 			check: hotCheck,
/******/ 			apply: hotApply,
/******/ 			status: function(l) {
/******/ 				if(!l) return hotStatus;
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			addStatusHandler: function(l) {
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			removeStatusHandler: function(l) {
/******/ 				var idx = hotStatusHandlers.indexOf(l);
/******/ 				if(idx >= 0) hotStatusHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			//inherit from previous dispose call
/******/ 			data: hotCurrentModuleData[moduleId]
/******/ 		};
/******/ 		return hot;
/******/ 	}
/******/ 	
/******/ 	var hotStatusHandlers = [];
/******/ 	var hotStatus = "idle";
/******/ 	
/******/ 	function hotSetStatus(newStatus) {
/******/ 		hotStatus = newStatus;
/******/ 		for(var i = 0; i < hotStatusHandlers.length; i++)
/******/ 			hotStatusHandlers[i].call(null, newStatus);
/******/ 	}
/******/ 	
/******/ 	// while downloading
/******/ 	var hotWaitingFiles = 0;
/******/ 	var hotChunksLoading = 0;
/******/ 	var hotWaitingFilesMap = {};
/******/ 	var hotRequestedFilesMap = {};
/******/ 	var hotAvailibleFilesMap = {};
/******/ 	var hotCallback;
/******/ 	
/******/ 	// The update info
/******/ 	var hotUpdate, hotUpdateNewHash;
/******/ 	
/******/ 	function toModuleId(id) {
/******/ 		var isNumber = (+id) + "" === id;
/******/ 		return isNumber ? +id : id;
/******/ 	}
/******/ 	
/******/ 	function hotCheck(apply, callback) {
/******/ 		if(hotStatus !== "idle") throw new Error("check() is only allowed in idle status");
/******/ 		if(typeof apply === "function") {
/******/ 			hotApplyOnUpdate = false;
/******/ 			callback = apply;
/******/ 		} else {
/******/ 			hotApplyOnUpdate = apply;
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/ 		hotSetStatus("check");
/******/ 		hotDownloadManifest(function(err, update) {
/******/ 			if(err) return callback(err);
/******/ 			if(!update) {
/******/ 				hotSetStatus("idle");
/******/ 				callback(null, null);
/******/ 				return;
/******/ 			}
/******/ 	
/******/ 			hotRequestedFilesMap = {};
/******/ 			hotAvailibleFilesMap = {};
/******/ 			hotWaitingFilesMap = {};
/******/ 			for(var i = 0; i < update.c.length; i++)
/******/ 				hotAvailibleFilesMap[update.c[i]] = true;
/******/ 			hotUpdateNewHash = update.h;
/******/ 	
/******/ 			hotSetStatus("prepare");
/******/ 			hotCallback = callback;
/******/ 			hotUpdate = {};
/******/ 			var chunkId = 0;
/******/ 			{ // eslint-disable-line no-lone-blocks
/******/ 				/*globals chunkId */
/******/ 				hotEnsureUpdateChunk(chunkId);
/******/ 			}
/******/ 			if(hotStatus === "prepare" && hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 				hotUpdateDownloaded();
/******/ 			}
/******/ 		});
/******/ 	}
/******/ 	
/******/ 	function hotAddUpdateChunk(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		if(!hotAvailibleFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
/******/ 			return;
/******/ 		hotRequestedFilesMap[chunkId] = false;
/******/ 		for(var moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				hotUpdate[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(--hotWaitingFiles === 0 && hotChunksLoading === 0) {
/******/ 			hotUpdateDownloaded();
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotEnsureUpdateChunk(chunkId) {
/******/ 		if(!hotAvailibleFilesMap[chunkId]) {
/******/ 			hotWaitingFilesMap[chunkId] = true;
/******/ 		} else {
/******/ 			hotRequestedFilesMap[chunkId] = true;
/******/ 			hotWaitingFiles++;
/******/ 			hotDownloadUpdateChunk(chunkId);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotUpdateDownloaded() {
/******/ 		hotSetStatus("ready");
/******/ 		var callback = hotCallback;
/******/ 		hotCallback = null;
/******/ 		if(!callback) return;
/******/ 		if(hotApplyOnUpdate) {
/******/ 			hotApply(hotApplyOnUpdate, callback);
/******/ 		} else {
/******/ 			var outdatedModules = [];
/******/ 			for(var id in hotUpdate) {
/******/ 				if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 					outdatedModules.push(toModuleId(id));
/******/ 				}
/******/ 			}
/******/ 			callback(null, outdatedModules);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotApply(options, callback) {
/******/ 		if(hotStatus !== "ready") throw new Error("apply() is only allowed in ready status");
/******/ 		if(typeof options === "function") {
/******/ 			callback = options;
/******/ 			options = {};
/******/ 		} else if(options && typeof options === "object") {
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		} else {
/******/ 			options = {};
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/ 	
/******/ 		function getAffectedStuff(module) {
/******/ 			var outdatedModules = [module];
/******/ 			var outdatedDependencies = {};
/******/ 	
/******/ 			var queue = outdatedModules.slice();
/******/ 			while(queue.length > 0) {
/******/ 				var moduleId = queue.pop();
/******/ 				var module = installedModules[moduleId];
/******/ 				if(!module || module.hot._selfAccepted)
/******/ 					continue;
/******/ 				if(module.hot._selfDeclined) {
/******/ 					return new Error("Aborted because of self decline: " + moduleId);
/******/ 				}
/******/ 				if(moduleId === 0) {
/******/ 					return;
/******/ 				}
/******/ 				for(var i = 0; i < module.parents.length; i++) {
/******/ 					var parentId = module.parents[i];
/******/ 					var parent = installedModules[parentId];
/******/ 					if(parent.hot._declinedDependencies[moduleId]) {
/******/ 						return new Error("Aborted because of declined dependency: " + moduleId + " in " + parentId);
/******/ 					}
/******/ 					if(outdatedModules.indexOf(parentId) >= 0) continue;
/******/ 					if(parent.hot._acceptedDependencies[moduleId]) {
/******/ 						if(!outdatedDependencies[parentId])
/******/ 							outdatedDependencies[parentId] = [];
/******/ 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
/******/ 						continue;
/******/ 					}
/******/ 					delete outdatedDependencies[parentId];
/******/ 					outdatedModules.push(parentId);
/******/ 					queue.push(parentId);
/******/ 				}
/******/ 			}
/******/ 	
/******/ 			return [outdatedModules, outdatedDependencies];
/******/ 		}
/******/ 	
/******/ 		function addAllToSet(a, b) {
/******/ 			for(var i = 0; i < b.length; i++) {
/******/ 				var item = b[i];
/******/ 				if(a.indexOf(item) < 0)
/******/ 					a.push(item);
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// at begin all updates modules are outdated
/******/ 		// the "outdated" status can propagate to parents if they don't accept the children
/******/ 		var outdatedDependencies = {};
/******/ 		var outdatedModules = [];
/******/ 		var appliedUpdate = {};
/******/ 		for(var id in hotUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 				var moduleId = toModuleId(id);
/******/ 				var result = getAffectedStuff(moduleId);
/******/ 				if(!result) {
/******/ 					if(options.ignoreUnaccepted)
/******/ 						continue;
/******/ 					hotSetStatus("abort");
/******/ 					return callback(new Error("Aborted because " + moduleId + " is not accepted"));
/******/ 				}
/******/ 				if(result instanceof Error) {
/******/ 					hotSetStatus("abort");
/******/ 					return callback(result);
/******/ 				}
/******/ 				appliedUpdate[moduleId] = hotUpdate[moduleId];
/******/ 				addAllToSet(outdatedModules, result[0]);
/******/ 				for(var moduleId in result[1]) {
/******/ 					if(Object.prototype.hasOwnProperty.call(result[1], moduleId)) {
/******/ 						if(!outdatedDependencies[moduleId])
/******/ 							outdatedDependencies[moduleId] = [];
/******/ 						addAllToSet(outdatedDependencies[moduleId], result[1][moduleId]);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Store self accepted outdated modules to require them later by the module system
/******/ 		var outdatedSelfAcceptedModules = [];
/******/ 		for(var i = 0; i < outdatedModules.length; i++) {
/******/ 			var moduleId = outdatedModules[i];
/******/ 			if(installedModules[moduleId] && installedModules[moduleId].hot._selfAccepted)
/******/ 				outdatedSelfAcceptedModules.push({
/******/ 					module: moduleId,
/******/ 					errorHandler: installedModules[moduleId].hot._selfAccepted
/******/ 				});
/******/ 		}
/******/ 	
/******/ 		// Now in "dispose" phase
/******/ 		hotSetStatus("dispose");
/******/ 		var queue = outdatedModules.slice();
/******/ 		while(queue.length > 0) {
/******/ 			var moduleId = queue.pop();
/******/ 			var module = installedModules[moduleId];
/******/ 			if(!module) continue;
/******/ 	
/******/ 			var data = {};
/******/ 	
/******/ 			// Call dispose handlers
/******/ 			var disposeHandlers = module.hot._disposeHandlers;
/******/ 			for(var j = 0; j < disposeHandlers.length; j++) {
/******/ 				var cb = disposeHandlers[j];
/******/ 				cb(data);
/******/ 			}
/******/ 			hotCurrentModuleData[moduleId] = data;
/******/ 	
/******/ 			// disable module (this disables requires from this module)
/******/ 			module.hot.active = false;
/******/ 	
/******/ 			// remove module from cache
/******/ 			delete installedModules[moduleId];
/******/ 	
/******/ 			// remove "parents" references from all children
/******/ 			for(var j = 0; j < module.children.length; j++) {
/******/ 				var child = installedModules[module.children[j]];
/******/ 				if(!child) continue;
/******/ 				var idx = child.parents.indexOf(moduleId);
/******/ 				if(idx >= 0) {
/******/ 					child.parents.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// remove outdated dependency from module children
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				for(var j = 0; j < moduleOutdatedDependencies.length; j++) {
/******/ 					var dependency = moduleOutdatedDependencies[j];
/******/ 					var idx = module.children.indexOf(dependency);
/******/ 					if(idx >= 0) module.children.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Not in "apply" phase
/******/ 		hotSetStatus("apply");
/******/ 	
/******/ 		hotCurrentHash = hotUpdateNewHash;
/******/ 	
/******/ 		// insert new code
/******/ 		for(var moduleId in appliedUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
/******/ 				modules[moduleId] = appliedUpdate[moduleId];
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// call accept handlers
/******/ 		var error = null;
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				var callbacks = [];
/******/ 				for(var i = 0; i < moduleOutdatedDependencies.length; i++) {
/******/ 					var dependency = moduleOutdatedDependencies[i];
/******/ 					var cb = module.hot._acceptedDependencies[dependency];
/******/ 					if(callbacks.indexOf(cb) >= 0) continue;
/******/ 					callbacks.push(cb);
/******/ 				}
/******/ 				for(var i = 0; i < callbacks.length; i++) {
/******/ 					var cb = callbacks[i];
/******/ 					try {
/******/ 						cb(outdatedDependencies);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Load self accepted modules
/******/ 		for(var i = 0; i < outdatedSelfAcceptedModules.length; i++) {
/******/ 			var item = outdatedSelfAcceptedModules[i];
/******/ 			var moduleId = item.module;
/******/ 			hotCurrentParents = [moduleId];
/******/ 			try {
/******/ 				__webpack_require__(moduleId);
/******/ 			} catch(err) {
/******/ 				if(typeof item.errorHandler === "function") {
/******/ 					try {
/******/ 						item.errorHandler(err);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				} else if(!error)
/******/ 					error = err;
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// handle errors in accept handlers and self accepted module load
/******/ 		if(error) {
/******/ 			hotSetStatus("fail");
/******/ 			return callback(error);
/******/ 		}
/******/ 	
/******/ 		hotSetStatus("idle");
/******/ 		callback(null, outdatedModules);
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			hot: hotCreateModule(moduleId),
/******/ 			parents: hotCurrentParents,
/******/ 			children: []
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = function() { return hotCurrentHash; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return hotCreateRequire(0)(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(200);
	__webpack_require__(205);
	__webpack_require__(716);
	__webpack_require__(864);
	__webpack_require__(866);
	__webpack_require__(868);
	__webpack_require__(870);
	module.exports = __webpack_require__(872);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2)


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	/* eslint-disable global-require */
	
	if (!module.hot || process.env.NODE_ENV === 'production') {
	  module.exports = __webpack_require__(4);
	} else {
	  module.exports = __webpack_require__(5);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/* noop */
	"use strict";

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var React = __webpack_require__(6);
	var createProxy = __webpack_require__(45).default;
	var global = __webpack_require__(199);
	
	var ComponentMap = function () {
	  function ComponentMap(useWeakMap) {
	    _classCallCheck(this, ComponentMap);
	
	    if (useWeakMap) {
	      this.wm = new WeakMap();
	    } else {
	      this.slots = {};
	    }
	  }
	
	  _createClass(ComponentMap, [{
	    key: 'getSlot',
	    value: function getSlot(type) {
	      var key = type.displayName || type.name || 'Unknown';
	      if (!this.slots[key]) {
	        this.slots[key] = [];
	      }
	      return this.slots[key];
	    }
	  }, {
	    key: 'get',
	    value: function get(type) {
	      if (this.wm) {
	        return this.wm.get(type);
	      }
	
	      var slot = this.getSlot(type);
	      for (var i = 0; i < slot.length; i++) {
	        if (slot[i].key === type) {
	          return slot[i].value;
	        }
	      }
	
	      return undefined;
	    }
	  }, {
	    key: 'set',
	    value: function set(type, value) {
	      if (this.wm) {
	        this.wm.set(type, value);
	      } else {
	        var slot = this.getSlot(type);
	        for (var i = 0; i < slot.length; i++) {
	          if (slot[i].key === type) {
	            slot[i].value = value;
	            return;
	          }
	        }
	        slot.push({ key: type, value: value });
	      }
	    }
	  }, {
	    key: 'has',
	    value: function has(type) {
	      if (this.wm) {
	        return this.wm.has(type);
	      }
	
	      var slot = this.getSlot(type);
	      for (var i = 0; i < slot.length; i++) {
	        if (slot[i].key === type) {
	          return true;
	        }
	      }
	      return false;
	    }
	  }]);
	
	  return ComponentMap;
	}();
	
	var proxiesByID = void 0;
	var didWarnAboutID = void 0;
	var hasCreatedElementsByType = void 0;
	var idsByType = void 0;
	var knownSignatures = void 0;
	var didUpdateProxy = void 0;
	
	var hooks = {
	  register: function register(type, uniqueLocalName, fileName) {
	    if (typeof type !== 'function') {
	      return;
	    }
	    if (!uniqueLocalName || !fileName) {
	      return;
	    }
	    if (typeof uniqueLocalName !== 'string' || typeof fileName !== 'string') {
	      return;
	    }
	    var id = fileName + '#' + uniqueLocalName; // eslint-disable-line prefer-template
	    if (!idsByType.has(type) && hasCreatedElementsByType.has(type)) {
	      if (!didWarnAboutID[id]) {
	        didWarnAboutID[id] = true;
	        var baseName = fileName.replace(/^.*[\\/]/, '');
	        console.error('React Hot Loader: ' + uniqueLocalName + ' in ' + fileName + ' will not hot reload ' + ('correctly because ' + baseName + ' uses <' + uniqueLocalName + ' /> during ') + ('module definition. For hot reloading to work, move ' + uniqueLocalName + ' ') + ('into a separate file and import it from ' + baseName + '.'));
	      }
	      return;
	    }
	
	    // Remember the ID.
	    idsByType.set(type, id);
	
	    // We use React Proxy to generate classes that behave almost
	    // the same way as the original classes but are updatable with
	    // new versions without destroying original instances.
	    if (!proxiesByID[id]) {
	      proxiesByID[id] = createProxy(type);
	    } else {
	      proxiesByID[id].update(type);
	      didUpdateProxy = true;
	    }
	  },
	  reset: function reset(useWeakMap) {
	    proxiesByID = {};
	    didWarnAboutID = {};
	    hasCreatedElementsByType = new ComponentMap(useWeakMap);
	    idsByType = new ComponentMap(useWeakMap);
	    knownSignatures = {};
	    didUpdateProxy = false;
	  },
	
	
	  warnings: true
	};
	
	hooks.reset(typeof WeakMap === 'function');
	
	function warnAboutUnnacceptedClass(typeSignature) {
	  if (didUpdateProxy && global.__REACT_HOT_LOADER__.warnings !== false) {
	    console.warn('React Hot Loader: this component is not accepted by Hot Loader. \n' + 'Please check is it extracted as a top level class, a function or a variable. \n' + 'Click below to reveal the source location: \n', typeSignature);
	  }
	}
	
	function resolveType(type) {
	  // We only care about composite components
	  if (typeof type !== 'function') {
	    return type;
	  }
	
	  var wasKnownBefore = hasCreatedElementsByType.get(type);
	  hasCreatedElementsByType.set(type, true);
	
	  // When available, give proxy class to React instead of the real class.
	  var id = idsByType.get(type);
	  if (!id) {
	    if (!wasKnownBefore) {
	      var signature = type.toString();
	      if (knownSignatures[signature]) {
	        warnAboutUnnacceptedClass(type);
	      } else {
	        knownSignatures[signature] = type;
	      }
	    }
	    return type;
	  }
	
	  var proxy = proxiesByID[id];
	  if (!proxy) {
	    return type;
	  }
	
	  return proxy.get();
	}
	
	var createElement = React.createElement;
	
	function patchedCreateElement(type) {
	  // Trick React into rendering a proxy so that
	  // its state is preserved when the class changes.
	  // This will update the proxy if it's for a known type.
	  var resolvedType = resolveType(type);
	
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return createElement.apply(undefined, [resolvedType].concat(args));
	}
	patchedCreateElement.isPatchedByReactHotLoader = true;
	
	function patchedCreateFactory(type) {
	  // Patch React.createFactory to use patched createElement
	  // because the original implementation uses the internal,
	  // unpatched ReactElement.createElement
	  var factory = patchedCreateElement.bind(null, type);
	  factory.type = type;
	  return factory;
	}
	patchedCreateFactory.isPatchedByReactHotLoader = true;
	
	if (typeof global.__REACT_HOT_LOADER__ === 'undefined') {
	  React.createElement = patchedCreateElement;
	  React.createFactory = patchedCreateFactory;
	  global.__REACT_HOT_LOADER__ = hooks;
	}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(7);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var ReactBaseClasses = __webpack_require__(9);
	var ReactChildren = __webpack_require__(18);
	var ReactDOMFactories = __webpack_require__(26);
	var ReactElement = __webpack_require__(20);
	var ReactPropTypes = __webpack_require__(32);
	var ReactVersion = __webpack_require__(41);
	
	var createReactClass = __webpack_require__(42);
	var onlyChild = __webpack_require__(44);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (process.env.NODE_ENV !== 'production') {
	  var lowPriorityWarning = __webpack_require__(17);
	  var canDefineProperty = __webpack_require__(14);
	  var ReactElementValidator = __webpack_require__(27);
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (process.env.NODE_ENV !== 'production') {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (process.env.NODE_ENV !== 'production') {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10),
	    _assign = __webpack_require__(8);
	
	var ReactNoopUpdateQueue = __webpack_require__(11);
	
	var canDefineProperty = __webpack_require__(14);
	var emptyObject = __webpack_require__(15);
	var invariant = __webpack_require__(16);
	var lowPriorityWarning = __webpack_require__(17);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (process.env.NODE_ENV !== 'production') {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(12);
	
	function warnNoop(publicInstance, callerName) {
	  if (process.env.NODE_ENV !== 'production') {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(13);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (process.env.NODE_ENV !== 'production') {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (process.env.NODE_ENV !== 'production') {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (process.env.NODE_ENV !== 'production') {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(19);
	var ReactElement = __webpack_require__(20);
	
	var emptyFunction = __webpack_require__(13);
	var traverseAllChildren = __webpack_require__(23);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var invariant = __webpack_require__(16);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	var ReactCurrentOwner = __webpack_require__(21);
	
	var warning = __webpack_require__(12);
	var canDefineProperty = __webpack_require__(14);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(22);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (process.env.NODE_ENV !== 'production') {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (process.env.NODE_ENV !== 'production') {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	      process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	      process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (process.env.NODE_ENV !== 'production') {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (process.env.NODE_ENV !== 'production') {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (process.env.NODE_ENV !== 'production') {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var ReactCurrentOwner = __webpack_require__(21);
	var REACT_ELEMENT_TYPE = __webpack_require__(22);
	
	var getIteratorFn = __webpack_require__(24);
	var invariant = __webpack_require__(16);
	var KeyEscapeUtils = __webpack_require__(25);
	var warning = __webpack_require__(12);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (process.env.NODE_ENV !== 'production') {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (process.env.NODE_ENV !== 'production') {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(20);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (process.env.NODE_ENV !== 'production') {
	  var ReactElementValidator = __webpack_require__(27);
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(21);
	var ReactComponentTreeHook = __webpack_require__(28);
	var ReactElement = __webpack_require__(20);
	
	var checkReactTypeSpec = __webpack_require__(29);
	
	var canDefineProperty = __webpack_require__(14);
	var getIteratorFn = __webpack_require__(24);
	var warning = __webpack_require__(12);
	var lowPriorityWarning = __webpack_require__(17);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function getSourceInfoErrorAddendum(elementProps) {
	  if (elementProps !== null && elementProps !== undefined && elementProps.__source !== undefined) {
	    var source = elementProps.__source;
	    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
	    var lineNumber = source.lineNumber;
	    return ' Check your code at ' + fileName + ':' + lineNumber + '.';
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	function getCurrentComponentErrorInfo(parentType) {
	  var info = getDeclarationErrorAddendum();
	
	  if (!info) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      info = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	  return info;
	}
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var memoizer = ownerHasKeyUseWarning.uniqueKey || (ownerHasKeyUseWarning.uniqueKey = {});
	
	  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
	  if (memoizer[currentComponentErrorInfo]) {
	    return;
	  }
	  memoizer[currentComponentErrorInfo] = true;
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  var childOwner = '';
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  process.env.NODE_ENV !== 'production' ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.%s', currentComponentErrorInfo, childOwner, ReactComponentTreeHook.getCurrentStackAddendum(element)) : void 0;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkReactTypeSpec(componentClass.propTypes, element.props, 'prop', name, element, null);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	    process.env.NODE_ENV !== 'production' ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : void 0;
	  }
	}
	
	var ReactElementValidator = {
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	    if (!validType) {
	      if (typeof type !== 'function' && typeof type !== 'string') {
	        var info = '';
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	
	        var sourceInfo = getSourceInfoErrorAddendum(props);
	        if (sourceInfo) {
	          info += sourceInfo;
	        } else {
	          info += getDeclarationErrorAddendum();
	        }
	
	        info += ReactComponentTreeHook.getCurrentStackAddendum();
	
	        var currentSource = props !== null && props !== undefined && props.__source !== undefined ? props.__source : null;
	        ReactComponentTreeHook.pushNonStandardWarningStack(true, currentSource);
	        process.env.NODE_ENV !== 'production' ? warning(false, 'React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', type == null ? type : typeof type, info) : void 0;
	        ReactComponentTreeHook.popNonStandardWarningStack();
	      }
	    }
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (process.env.NODE_ENV !== 'production') {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            lowPriorityWarning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	};
	
	module.exports = ReactElementValidator;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var ReactCurrentOwner = __webpack_require__(21);
	
	var invariant = __webpack_require__(16);
	var warning = __webpack_require__(12);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	  process.env.NODE_ENV !== 'production' ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ? process.env.NODE_ENV !== 'production' ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var ReactPropTypeLocationNames = __webpack_require__(30);
	var ReactPropTypesSecret = __webpack_require__(31);
	
	var invariant = __webpack_require__(16);
	var warning = __webpack_require__(12);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(28);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ? process.env.NODE_ENV !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	      process.env.NODE_ENV !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (process.env.NODE_ENV !== 'production') {
	          if (!ReactComponentTreeHook) {
	            ReactComponentTreeHook = __webpack_require__(28);
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
	          }
	        }
	
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (process.env.NODE_ENV !== 'production') {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(20),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(33);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(34);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(35);
	var assign = __webpack_require__(8);
	
	var ReactPropTypesSecret = __webpack_require__(38);
	var has = __webpack_require__(39);
	var checkPropTypes = __webpack_require__(40);
	
	var printWarning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (process.env.NODE_ENV === 'production') {
	  module.exports = __webpack_require__(36);
	} else {
	  module.exports = __webpack_require__(37);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/** @license React v16.13.1
	 * react-is.development.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	
	
	if (process.env.NODE_ENV !== "production") {
	  (function() {
	'use strict';
	
	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?
	
	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
	
	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}
	
	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;
	
	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;
	
	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;
	
	          default:
	            var $$typeofType = type && type.$$typeof;
	
	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;
	
	              default:
	                return $$typeof;
	            }
	
	        }
	
	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }
	
	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode
	
	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
	
	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
	
	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }
	
	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}
	
	exports.AsyncMode = AsyncMode;
	exports.ConcurrentMode = ConcurrentMode;
	exports.ContextConsumer = ContextConsumer;
	exports.ContextProvider = ContextProvider;
	exports.Element = Element;
	exports.ForwardRef = ForwardRef;
	exports.Fragment = Fragment;
	exports.Lazy = Lazy;
	exports.Memo = Memo;
	exports.Portal = Portal;
	exports.Profiler = Profiler;
	exports.StrictMode = StrictMode;
	exports.Suspense = Suspense;
	exports.isAsyncMode = isAsyncMode;
	exports.isConcurrentMode = isConcurrentMode;
	exports.isContextConsumer = isContextConsumer;
	exports.isContextProvider = isContextProvider;
	exports.isElement = isElement;
	exports.isForwardRef = isForwardRef;
	exports.isFragment = isFragment;
	exports.isLazy = isLazy;
	exports.isMemo = isMemo;
	exports.isPortal = isPortal;
	exports.isProfiler = isProfiler;
	exports.isStrictMode = isStrictMode;
	exports.isSuspense = isSuspense;
	exports.isValidElementType = isValidElementType;
	exports.typeOf = typeOf;
	  })();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = __webpack_require__(38);
	  var loggedTypeFailures = {};
	  var has = __webpack_require__(39);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(9),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(20),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(11);
	var factory = __webpack_require__(43);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(8);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (process.env.NODE_ENV !== 'production') {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (process.env.NODE_ENV !== 'production') {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (process.env.NODE_ENV !== 'production') {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (process.env.NODE_ENV !== 'production') {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (process.env.NODE_ENV !== 'production') {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (process.env.NODE_ENV !== 'production') {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (process.env.NODE_ENV !== 'production') {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (process.env.NODE_ENV !== 'production') {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (process.env.NODE_ENV !== 'production') {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (process.env.NODE_ENV !== 'production') {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (process.env.NODE_ENV !== 'production') {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (process.env.NODE_ENV !== 'production') {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (process.env.NODE_ENV !== 'production') {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (process.env.NODE_ENV !== 'production') {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(10);
	
	var ReactElement = __webpack_require__(20);
	
	var invariant = __webpack_require__(16);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ? process.env.NODE_ENV !== 'production' ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _supportsProtoAssignment = __webpack_require__(46);
	
	var _supportsProtoAssignment2 = _interopRequireDefault(_supportsProtoAssignment);
	
	var _createClassProxy = __webpack_require__(47);
	
	var _createClassProxy2 = _interopRequireDefault(_createClassProxy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!(0, _supportsProtoAssignment2.default)()) {
	  console.warn('This JavaScript environment does not support __proto__. ' + 'This means that react-proxy is unable to proxy React components. ' + 'Features that rely on react-proxy, such as react-transform-hmr, ' + 'will not function as expected.');
	}
	
	exports.default = _createClassProxy2.default;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = supportsProtoAssignment;
	var x = {};
	var y = { supports: true };
	try {
	  x.__proto__ = y;
	} catch (err) {}
	
	function supportsProtoAssignment() {
	  return x.supports || false;
	};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = createClassProxy;
	
	var _find = __webpack_require__(48);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _createPrototypeProxy = __webpack_require__(172);
	
	var _createPrototypeProxy2 = _interopRequireDefault(_createPrototypeProxy);
	
	var _bindAutoBindMethods = __webpack_require__(197);
	
	var _bindAutoBindMethods2 = _interopRequireDefault(_bindAutoBindMethods);
	
	var _deleteUnknownAutoBindMethods = __webpack_require__(198);
	
	var _deleteUnknownAutoBindMethods2 = _interopRequireDefault(_deleteUnknownAutoBindMethods);
	
	var _supportsProtoAssignment = __webpack_require__(46);
	
	var _supportsProtoAssignment2 = _interopRequireDefault(_supportsProtoAssignment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var RESERVED_STATICS = ['length', 'displayName', 'name', 'arguments', 'caller', 'prototype', 'toString'];
	
	function isEqualDescriptor(a, b) {
	  if (!a && !b) {
	    return true;
	  }
	  if (!a || !b) {
	    return false;
	  }
	  for (var key in a) {
	    if (a[key] !== b[key]) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function getDisplayName(Component) {
	  var displayName = Component.displayName || Component.name;
	  return displayName && displayName !== 'ReactComponent' ? displayName : 'Unknown';
	}
	
	// This was originally a WeakMap but we had issues with React Native:
	// https://github.com/gaearon/react-proxy/issues/50#issuecomment-192928066
	var allProxies = [];
	function findProxy(Component) {
	  var pair = (0, _find2.default)(allProxies, function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 1);
	
	    var key = _ref2[0];
	    return key === Component;
	  });
	  return pair ? pair[1] : null;
	}
	function addProxy(Component, proxy) {
	  allProxies.push([Component, proxy]);
	}
	
	function proxyClass(InitialComponent) {
	  // Prevent double wrapping.
	  // Given a proxy class, return the existing proxy managing it.
	  var existingProxy = findProxy(InitialComponent);
	  if (existingProxy) {
	    return existingProxy;
	  }
	
	  var CurrentComponent = undefined;
	  var ProxyComponent = undefined;
	  var savedDescriptors = {};
	
	  function instantiate(factory, context, params) {
	    var component = factory();
	
	    try {
	      return component.apply(context, params);
	    } catch (err) {
	      (function () {
	        // Native ES6 class instantiation
	        var instance = new (Function.prototype.bind.apply(component, [null].concat(_toConsumableArray(params))))();
	
	        Object.keys(instance).forEach(function (key) {
	          if (RESERVED_STATICS.indexOf(key) > -1) {
	            return;
	          }
	          context[key] = instance[key];
	        });
	      })();
	    }
	  }
	
	  var displayName = getDisplayName(InitialComponent);
	  try {
	    // Create a proxy constructor with matching name
	    ProxyComponent = new Function('factory', 'instantiate', 'return function ' + displayName + '() {\n         return instantiate(factory, this, arguments);\n      }')(function () {
	      return CurrentComponent;
	    }, instantiate);
	  } catch (err) {
	    // Some environments may forbid dynamic evaluation
	    ProxyComponent = function ProxyComponent() {
	      return instantiate(function () {
	        return CurrentComponent;
	      }, this, arguments);
	    };
	  }
	  try {
	    Object.defineProperty(ProxyComponent, 'name', {
	      value: displayName
	    });
	  } catch (err) {}
	
	  // Proxy toString() to the current constructor
	  ProxyComponent.toString = function toString() {
	    return CurrentComponent.toString();
	  };
	
	  var prototypeProxy = undefined;
	  if (InitialComponent.prototype && InitialComponent.prototype.isReactComponent) {
	    // Point proxy constructor to the proxy prototype
	    prototypeProxy = (0, _createPrototypeProxy2.default)();
	    ProxyComponent.prototype = prototypeProxy.get();
	  }
	
	  function update(NextComponent) {
	    if (typeof NextComponent !== 'function') {
	      throw new Error('Expected a constructor.');
	    }
	    if (NextComponent === CurrentComponent) {
	      return;
	    }
	
	    // Prevent proxy cycles
	    var existingProxy = findProxy(NextComponent);
	    if (existingProxy) {
	      return update(existingProxy.__getCurrent());
	    }
	
	    // Save the next constructor so we call it
	    var PreviousComponent = CurrentComponent;
	    CurrentComponent = NextComponent;
	
	    // Try to infer displayName
	    displayName = getDisplayName(NextComponent);
	    ProxyComponent.displayName = displayName;
	    try {
	      Object.defineProperty(ProxyComponent, 'name', {
	        value: displayName
	      });
	    } catch (err) {}
	
	    // Set up the same prototype for inherited statics
	    ProxyComponent.__proto__ = NextComponent.__proto__;
	
	    // Copy over static methods and properties added at runtime
	    if (PreviousComponent) {
	      Object.getOwnPropertyNames(PreviousComponent).forEach(function (key) {
	        if (RESERVED_STATICS.indexOf(key) > -1) {
	          return;
	        }
	
	        var prevDescriptor = Object.getOwnPropertyDescriptor(PreviousComponent, key);
	        var savedDescriptor = savedDescriptors[key];
	
	        if (!isEqualDescriptor(prevDescriptor, savedDescriptor)) {
	          Object.defineProperty(NextComponent, key, prevDescriptor);
	        }
	      });
	    }
	
	    // Copy newly defined static methods and properties
	    Object.getOwnPropertyNames(NextComponent).forEach(function (key) {
	      if (RESERVED_STATICS.indexOf(key) > -1) {
	        return;
	      }
	
	      var prevDescriptor = PreviousComponent && Object.getOwnPropertyDescriptor(PreviousComponent, key);
	      var savedDescriptor = savedDescriptors[key];
	
	      // Skip redefined descriptors
	      if (prevDescriptor && savedDescriptor && !isEqualDescriptor(savedDescriptor, prevDescriptor)) {
	        Object.defineProperty(NextComponent, key, prevDescriptor);
	        Object.defineProperty(ProxyComponent, key, prevDescriptor);
	        return;
	      }
	
	      if (prevDescriptor && !savedDescriptor) {
	        Object.defineProperty(ProxyComponent, key, prevDescriptor);
	        return;
	      }
	
	      var nextDescriptor = _extends({}, Object.getOwnPropertyDescriptor(NextComponent, key), {
	        configurable: true
	      });
	      savedDescriptors[key] = nextDescriptor;
	      Object.defineProperty(ProxyComponent, key, nextDescriptor);
	    });
	
	    // Remove static methods and properties that are no longer defined
	    Object.getOwnPropertyNames(ProxyComponent).forEach(function (key) {
	      if (RESERVED_STATICS.indexOf(key) > -1) {
	        return;
	      }
	      // Skip statics that exist on the next class
	      if (NextComponent.hasOwnProperty(key)) {
	        return;
	      }
	      // Skip non-configurable statics
	      var proxyDescriptor = Object.getOwnPropertyDescriptor(ProxyComponent, key);
	      if (proxyDescriptor && !proxyDescriptor.configurable) {
	        return;
	      }
	
	      var prevDescriptor = PreviousComponent && Object.getOwnPropertyDescriptor(PreviousComponent, key);
	      var savedDescriptor = savedDescriptors[key];
	
	      // Skip redefined descriptors
	      if (prevDescriptor && savedDescriptor && !isEqualDescriptor(savedDescriptor, prevDescriptor)) {
	        return;
	      }
	
	      delete ProxyComponent[key];
	    });
	
	    if (prototypeProxy) {
	      // Update the prototype proxy with new methods
	      var mountedInstances = prototypeProxy.update(NextComponent.prototype);
	
	      // Set up the constructor property so accessing the statics work
	      ProxyComponent.prototype.constructor = NextComponent;
	
	      // We might have added new methods that need to be auto-bound
	      mountedInstances.forEach(_bindAutoBindMethods2.default);
	      mountedInstances.forEach(_deleteUnknownAutoBindMethods2.default);
	    }
	  };
	
	  function get() {
	    return ProxyComponent;
	  }
	
	  function getCurrent() {
	    return CurrentComponent;
	  }
	
	  update(InitialComponent);
	
	  var proxy = { get: get, update: update };
	  addProxy(ProxyComponent, proxy);
	
	  Object.defineProperty(proxy, '__getCurrent', {
	    configurable: false,
	    writable: false,
	    enumerable: false,
	    value: getCurrent
	  });
	
	  return proxy;
	}
	
	function createFallback(Component) {
	  var CurrentComponent = Component;
	
	  return {
	    get: function get() {
	      return CurrentComponent;
	    },
	    update: function update(NextComponent) {
	      CurrentComponent = NextComponent;
	    }
	  };
	}
	
	function createClassProxy(Component) {
	  return Component.__proto__ && (0, _supportsProtoAssignment2.default)() ? proxyClass(Component) : createFallback(Component);
	}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(49),
	    findIndex = __webpack_require__(165);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(50),
	    isArrayLike = __webpack_require__(136),
	    keys = __webpack_require__(117);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(51),
	    baseMatchesProperty = __webpack_require__(145),
	    identity = __webpack_require__(161),
	    isArray = __webpack_require__(113),
	    property = __webpack_require__(162);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(52),
	    getMatchData = __webpack_require__(142),
	    matchesStrictComparable = __webpack_require__(144);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(53),
	    baseIsEqual = __webpack_require__(97);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(54),
	    stackClear = __webpack_require__(62),
	    stackDelete = __webpack_require__(63),
	    stackGet = __webpack_require__(64),
	    stackHas = __webpack_require__(65),
	    stackSet = __webpack_require__(66);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(55),
	    listCacheDelete = __webpack_require__(56),
	    listCacheGet = __webpack_require__(59),
	    listCacheHas = __webpack_require__(60),
	    listCacheSet = __webpack_require__(61);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(57);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(58);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(57);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(57);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(57);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(54);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(54),
	    Map = __webpack_require__(67),
	    MapCache = __webpack_require__(82);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68),
	    root = __webpack_require__(73);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(69),
	    getValue = __webpack_require__(81);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(70),
	    isMasked = __webpack_require__(78),
	    isObject = __webpack_require__(77),
	    toSource = __webpack_require__(80);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(71),
	    isObject = __webpack_require__(77);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(72),
	    getRawTag = __webpack_require__(75),
	    objectToString = __webpack_require__(76);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(73);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(74);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(72);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(79);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(73);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(83),
	    mapCacheDelete = __webpack_require__(91),
	    mapCacheGet = __webpack_require__(94),
	    mapCacheHas = __webpack_require__(95),
	    mapCacheSet = __webpack_require__(96);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(84),
	    ListCache = __webpack_require__(54),
	    Map = __webpack_require__(67);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(85),
	    hashDelete = __webpack_require__(87),
	    hashGet = __webpack_require__(88),
	    hashHas = __webpack_require__(89),
	    hashSet = __webpack_require__(90);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(86);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(86);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(86);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(86);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(92);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(93);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(92);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(92);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(92);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(98),
	    isObjectLike = __webpack_require__(122);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(53),
	    equalArrays = __webpack_require__(99),
	    equalByTag = __webpack_require__(105),
	    equalObjects = __webpack_require__(109),
	    getTag = __webpack_require__(137),
	    isArray = __webpack_require__(113),
	    isBuffer = __webpack_require__(123),
	    isTypedArray = __webpack_require__(127);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(100),
	    arraySome = __webpack_require__(103),
	    cacheHas = __webpack_require__(104);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(82),
	    setCacheAdd = __webpack_require__(101),
	    setCacheHas = __webpack_require__(102);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(72),
	    Uint8Array = __webpack_require__(106),
	    eq = __webpack_require__(58),
	    equalArrays = __webpack_require__(99),
	    mapToArray = __webpack_require__(107),
	    setToArray = __webpack_require__(108);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(73);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(110);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(111),
	    getSymbols = __webpack_require__(114),
	    keys = __webpack_require__(117);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(112),
	    isArray = __webpack_require__(113);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(115),
	    stubArray = __webpack_require__(116);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(118),
	    baseKeys = __webpack_require__(132),
	    isArrayLike = __webpack_require__(136);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(119),
	    isArguments = __webpack_require__(120),
	    isArray = __webpack_require__(113),
	    isBuffer = __webpack_require__(123),
	    isIndex = __webpack_require__(126),
	    isTypedArray = __webpack_require__(127);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(121),
	    isObjectLike = __webpack_require__(122);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(71),
	    isObjectLike = __webpack_require__(122);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(73),
	    stubFalse = __webpack_require__(125);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(124)(module)))

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(128),
	    baseUnary = __webpack_require__(130),
	    nodeUtil = __webpack_require__(131);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(71),
	    isLength = __webpack_require__(129),
	    isObjectLike = __webpack_require__(122);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(74);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(124)(module)))

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(133),
	    nativeKeys = __webpack_require__(134);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(135);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 135 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(70),
	    isLength = __webpack_require__(129);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(138),
	    Map = __webpack_require__(67),
	    Promise = __webpack_require__(139),
	    Set = __webpack_require__(140),
	    WeakMap = __webpack_require__(141),
	    baseGetTag = __webpack_require__(71),
	    toSource = __webpack_require__(80);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68),
	    root = __webpack_require__(73);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68),
	    root = __webpack_require__(73);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68),
	    root = __webpack_require__(73);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68),
	    root = __webpack_require__(73);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(143),
	    keys = __webpack_require__(117);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(77);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 144 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(97),
	    get = __webpack_require__(146),
	    hasIn = __webpack_require__(158),
	    isKey = __webpack_require__(149),
	    isStrictComparable = __webpack_require__(143),
	    matchesStrictComparable = __webpack_require__(144),
	    toKey = __webpack_require__(157);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(147);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(148),
	    toKey = __webpack_require__(157);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(113),
	    isKey = __webpack_require__(149),
	    stringToPath = __webpack_require__(151),
	    toString = __webpack_require__(154);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(113),
	    isSymbol = __webpack_require__(150);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(71),
	    isObjectLike = __webpack_require__(122);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(152);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(153);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(82);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(155);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(72),
	    arrayMap = __webpack_require__(156),
	    isArray = __webpack_require__(113),
	    isSymbol = __webpack_require__(150);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(150);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(159),
	    hasPath = __webpack_require__(160);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(148),
	    isArguments = __webpack_require__(120),
	    isArray = __webpack_require__(113),
	    isIndex = __webpack_require__(126),
	    isLength = __webpack_require__(129),
	    toKey = __webpack_require__(157);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(163),
	    basePropertyDeep = __webpack_require__(164),
	    isKey = __webpack_require__(149),
	    toKey = __webpack_require__(157);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(147);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(166),
	    baseIteratee = __webpack_require__(50),
	    toInteger = __webpack_require__(167);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(168);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(169);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(170),
	    isObject = __webpack_require__(77),
	    isSymbol = __webpack_require__(150);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(171);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 171 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrototypeProxy;
	
	var _assign = __webpack_require__(173);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _difference = __webpack_require__(187);
	
	var _difference2 = _interopRequireDefault(_difference);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrototypeProxy() {
	  var proxy = {};
	  var current = null;
	  var mountedInstances = [];
	
	  /**
	   * Creates a proxied toString() method pointing to the current version's toString().
	   */
	  function proxyToString(name) {
	    // Wrap to always call the current version
	    return function toString() {
	      if (typeof current[name] === 'function') {
	        return current[name].toString();
	      } else {
	        return '<method was deleted>';
	      }
	    };
	  }
	
	  /**
	   * Creates a proxied method that calls the current version, whenever available.
	   */
	  function proxyMethod(name) {
	    // Wrap to always call the current version
	    var proxiedMethod = function proxiedMethod() {
	      if (typeof current[name] === 'function') {
	        return current[name].apply(this, arguments);
	      }
	    };
	
	    // Copy properties of the original function, if any
	    (0, _assign2.default)(proxiedMethod, current[name]);
	    proxiedMethod.toString = proxyToString(name);
	    try {
	      Object.defineProperty(proxiedMethod, 'name', {
	        value: name
	      });
	    } catch (err) {}
	
	    return proxiedMethod;
	  }
	
	  /**
	   * Augments the original componentDidMount with instance tracking.
	   */
	  function proxiedComponentDidMount() {
	    mountedInstances.push(this);
	    if (typeof current.componentDidMount === 'function') {
	      return current.componentDidMount.apply(this, arguments);
	    }
	  }
	  proxiedComponentDidMount.toString = proxyToString('componentDidMount');
	
	  /**
	   * Augments the original componentWillUnmount with instance tracking.
	   */
	  function proxiedComponentWillUnmount() {
	    var index = mountedInstances.indexOf(this);
	    // Unless we're in a weird environment without componentDidMount
	    if (index !== -1) {
	      mountedInstances.splice(index, 1);
	    }
	    if (typeof current.componentWillUnmount === 'function') {
	      return current.componentWillUnmount.apply(this, arguments);
	    }
	  }
	  proxiedComponentWillUnmount.toString = proxyToString('componentWillUnmount');
	
	  /**
	   * Defines a property on the proxy.
	   */
	  function defineProxyProperty(name, descriptor) {
	    Object.defineProperty(proxy, name, descriptor);
	  }
	
	  /**
	   * Defines a property, attempting to keep the original descriptor configuration.
	   */
	  function defineProxyPropertyWithValue(name, value) {
	    var _ref = Object.getOwnPropertyDescriptor(current, name) || {};
	
	    var _ref$enumerable = _ref.enumerable;
	    var enumerable = _ref$enumerable === undefined ? false : _ref$enumerable;
	    var _ref$writable = _ref.writable;
	    var writable = _ref$writable === undefined ? true : _ref$writable;
	
	
	    defineProxyProperty(name, {
	      configurable: true,
	      enumerable: enumerable,
	      writable: writable,
	      value: value
	    });
	  }
	
	  /**
	   * Creates an auto-bind map mimicking the original map, but directed at proxy.
	   */
	  function createAutoBindMap() {
	    if (!current.__reactAutoBindMap) {
	      return;
	    }
	
	    var __reactAutoBindMap = {};
	    for (var name in current.__reactAutoBindMap) {
	      if (typeof proxy[name] === 'function' && current.__reactAutoBindMap.hasOwnProperty(name)) {
	        __reactAutoBindMap[name] = proxy[name];
	      }
	    }
	
	    return __reactAutoBindMap;
	  }
	
	  /**
	   * Creates an auto-bind map mimicking the original map, but directed at proxy.
	   */
	  function createAutoBindPairs() {
	    var __reactAutoBindPairs = [];
	
	    for (var i = 0; i < current.__reactAutoBindPairs.length; i += 2) {
	      var name = current.__reactAutoBindPairs[i];
	      var method = proxy[name];
	
	      if (typeof method === 'function') {
	        __reactAutoBindPairs.push(name, method);
	      }
	    }
	
	    return __reactAutoBindPairs;
	  }
	
	  /**
	   * Applies the updated prototype.
	   */
	  function update(next) {
	    // Save current source of truth
	    current = next;
	
	    // Find changed property names
	    var currentNames = Object.getOwnPropertyNames(current);
	    var previousName = Object.getOwnPropertyNames(proxy);
	    var removedNames = (0, _difference2.default)(previousName, currentNames);
	
	    // Remove properties and methods that are no longer there
	    removedNames.forEach(function (name) {
	      delete proxy[name];
	    });
	
	    // Copy every descriptor
	    currentNames.forEach(function (name) {
	      var descriptor = Object.getOwnPropertyDescriptor(current, name);
	      if (typeof descriptor.value === 'function') {
	        // Functions require additional wrapping so they can be bound later
	        defineProxyPropertyWithValue(name, proxyMethod(name));
	      } else {
	        // Other values can be copied directly
	        defineProxyProperty(name, descriptor);
	      }
	    });
	
	    // Track mounting and unmounting
	    defineProxyPropertyWithValue('componentDidMount', proxiedComponentDidMount);
	    defineProxyPropertyWithValue('componentWillUnmount', proxiedComponentWillUnmount);
	
	    if (current.hasOwnProperty('__reactAutoBindMap')) {
	      defineProxyPropertyWithValue('__reactAutoBindMap', createAutoBindMap());
	    }
	
	    if (current.hasOwnProperty('__reactAutoBindPairs')) {
	      defineProxyPropertyWithValue('__reactAutoBindPairs', createAutoBindPairs());
	    }
	
	    // Set up the prototype chain
	    proxy.__proto__ = next;
	
	    return mountedInstances;
	  }
	
	  /**
	   * Returns the up-to-date proxy prototype.
	   */
	  function get() {
	    return proxy;
	  }
	
	  return {
	    update: update,
	    get: get
	  };
	};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(174),
	    copyObject = __webpack_require__(177),
	    createAssigner = __webpack_require__(178),
	    isArrayLike = __webpack_require__(136),
	    isPrototype = __webpack_require__(133),
	    keys = __webpack_require__(117);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(175),
	    eq = __webpack_require__(58);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(176);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(174),
	    baseAssignValue = __webpack_require__(175);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(179),
	    isIterateeCall = __webpack_require__(186);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(161),
	    overRest = __webpack_require__(180),
	    setToString = __webpack_require__(182);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(181);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(183),
	    shortOut = __webpack_require__(185);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(184),
	    defineProperty = __webpack_require__(176),
	    identity = __webpack_require__(161);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(58),
	    isArrayLike = __webpack_require__(136),
	    isIndex = __webpack_require__(126),
	    isObject = __webpack_require__(77);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(188),
	    baseFlatten = __webpack_require__(194),
	    baseRest = __webpack_require__(179),
	    isArrayLikeObject = __webpack_require__(196);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(100),
	    arrayIncludes = __webpack_require__(189),
	    arrayIncludesWith = __webpack_require__(193),
	    arrayMap = __webpack_require__(156),
	    baseUnary = __webpack_require__(130),
	    cacheHas = __webpack_require__(104);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(190);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(166),
	    baseIsNaN = __webpack_require__(191),
	    strictIndexOf = __webpack_require__(192);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(112),
	    isFlattenable = __webpack_require__(195);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(72),
	    isArguments = __webpack_require__(120),
	    isArray = __webpack_require__(113);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(136),
	    isObjectLike = __webpack_require__(122);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = bindAutoBindMethods;
	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of React source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Original:
	 * https://github.com/facebook/react/blob/6508b1ad273a6f371e8d90ae676e5390199461b4/src/isomorphic/classic/class/ReactClass.js#L650-L713
	 */
	
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	
	  boundMethod.__reactBoundContext = component;
	  boundMethod.__reactBoundMethod = method;
	  boundMethod.__reactBoundArguments = null;
	
	  var componentName = component.constructor.displayName,
	      _bind = boundMethod.bind;
	
	  boundMethod.bind = function (newThis) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    if (newThis !== component && newThis !== null) {
	      console.warn('bind(): React component methods may only be bound to the ' + 'component instance. See ' + componentName);
	    } else if (!args.length) {
	      console.warn('bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See ' + componentName);
	      return boundMethod;
	    }
	
	    var reboundMethod = _bind.apply(boundMethod, arguments);
	    reboundMethod.__reactBoundContext = component;
	    reboundMethod.__reactBoundMethod = method;
	    reboundMethod.__reactBoundArguments = args;
	
	    return reboundMethod;
	  };
	
	  return boundMethod;
	}
	
	function bindAutoBindMethodsFromMap(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (!component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      return;
	    }
	
	    // Tweak: skip methods that are already bound.
	    // This is to preserve method reference in case it is used
	    // as a subscription handler that needs to be detached later.
	    if (component.hasOwnProperty(autoBindKey) && component[autoBindKey].__reactBoundContext === component) {
	      continue;
	    }
	
	    var method = component.__reactAutoBindMap[autoBindKey];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	function bindAutoBindMethods(component) {
	  if (component.__reactAutoBindPairs) {
	    bindAutoBindMethodsFromArray(component);
	  } else if (component.__reactAutoBindMap) {
	    bindAutoBindMethodsFromMap(component);
	  }
	}
	
	function bindAutoBindMethodsFromArray(component) {
	  var pairs = component.__reactAutoBindPairs;
	
	  if (!pairs) {
	    return;
	  }
	
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	
	    if (component.hasOwnProperty(autoBindKey) && component[autoBindKey].__reactBoundContext === component) {
	      continue;
	    }
	
	    var method = pairs[i + 1];
	
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deleteUnknownAutoBindMethods;
	function shouldDeleteClassicInstanceMethod(component, name) {
	  if (component.__reactAutoBindMap && component.__reactAutoBindMap.hasOwnProperty(name)) {
	    // It's a known autobound function, keep it
	    return false;
	  }
	
	  if (component.__reactAutoBindPairs && component.__reactAutoBindPairs.indexOf(name) >= 0) {
	    // It's a known autobound function, keep it
	    return false;
	  }
	
	  if (component[name].__reactBoundArguments !== null) {
	    // It's a function bound to specific args, keep it
	    return false;
	  }
	
	  // It's a cached bound method for a function
	  // that was deleted by user, so we delete it from component.
	  return true;
	}
	
	function shouldDeleteModernInstanceMethod(component, name) {
	  var prototype = component.constructor.prototype;
	
	  var prototypeDescriptor = Object.getOwnPropertyDescriptor(prototype, name);
	
	  if (!prototypeDescriptor || !prototypeDescriptor.get) {
	    // This is definitely not an autobinding getter
	    return false;
	  }
	
	  if (prototypeDescriptor.get().length !== component[name].length) {
	    // The length doesn't match, bail out
	    return false;
	  }
	
	  // This seems like a method bound using an autobinding getter on the prototype
	  // Hopefully we won't run into too many false positives.
	  return true;
	}
	
	function shouldDeleteInstanceMethod(component, name) {
	  var descriptor = Object.getOwnPropertyDescriptor(component, name);
	  if (typeof descriptor.value !== 'function') {
	    // Not a function, or something fancy: bail out
	    return;
	  }
	
	  if (component.__reactAutoBindMap || component.__reactAutoBindPairs) {
	    // Classic
	    return shouldDeleteClassicInstanceMethod(component, name);
	  } else {
	    // Modern
	    return shouldDeleteModernInstanceMethod(component, name);
	  }
	}
	
	/**
	 * Deletes autobound methods from the instance.
	 *
	 * For classic React classes, we only delete the methods that no longer exist in map.
	 * This means the user actually deleted them in code.
	 *
	 * For modern classes, we delete methods that exist on prototype with the same length,
	 * and which have getters on prototype, but are normal values on the instance.
	 * This is usually an indication that an autobinding decorator is being used,
	 * and the getter will re-generate the memoized handler on next access.
	 */
	function deleteUnknownAutoBindMethods(component) {
	  var names = Object.getOwnPropertyNames(component);
	
	  names.forEach(function (name) {
	    if (shouldDeleteInstanceMethod(component, name)) {
	      delete component[name];
	    }
	  });
	}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(201);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(203);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	__webpack_require__(204);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*! jQuery v3.2.1 | (c) JS Foundation and other contributors | jquery.org/license */
	!function (a, b) {
	  "use strict";
	  "object" == ( false ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports) ? module.exports = a.document ? b(a, !0) : function (a) {
	    if (!a.document) throw new Error("jQuery requires a window with a document");return b(a);
	  } : b(a);
	}("undefined" != typeof window ? window : undefined, function (a, b) {
	  "use strict";
	  var c = [],
	      d = a.document,
	      e = Object.getPrototypeOf,
	      f = c.slice,
	      g = c.concat,
	      h = c.push,
	      i = c.indexOf,
	      j = {},
	      k = j.toString,
	      l = j.hasOwnProperty,
	      m = l.toString,
	      n = m.call(Object),
	      o = {};function p(a, b) {
	    b = b || d;var c = b.createElement("script");c.text = a, b.head.appendChild(c).parentNode.removeChild(c);
	  }var q = "3.2.1",
	      r = function r(a, b) {
	    return new r.fn.init(a, b);
	  },
	      s = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	      t = /^-ms-/,
	      u = /-([a-z])/g,
	      v = function v(a, b) {
	    return b.toUpperCase();
	  };r.fn = r.prototype = { jquery: q, constructor: r, length: 0, toArray: function toArray() {
	      return f.call(this);
	    }, get: function get(a) {
	      return null == a ? f.call(this) : a < 0 ? this[a + this.length] : this[a];
	    }, pushStack: function pushStack(a) {
	      var b = r.merge(this.constructor(), a);return b.prevObject = this, b;
	    }, each: function each(a) {
	      return r.each(this, a);
	    }, map: function map(a) {
	      return this.pushStack(r.map(this, function (b, c) {
	        return a.call(b, c, b);
	      }));
	    }, slice: function slice() {
	      return this.pushStack(f.apply(this, arguments));
	    }, first: function first() {
	      return this.eq(0);
	    }, last: function last() {
	      return this.eq(-1);
	    }, eq: function eq(a) {
	      var b = this.length,
	          c = +a + (a < 0 ? b : 0);return this.pushStack(c >= 0 && c < b ? [this[c]] : []);
	    }, end: function end() {
	      return this.prevObject || this.constructor();
	    }, push: h, sort: c.sort, splice: c.splice }, r.extend = r.fn.extend = function () {
	    var a,
	        b,
	        c,
	        d,
	        e,
	        f,
	        g = arguments[0] || {},
	        h = 1,
	        i = arguments.length,
	        j = !1;for ("boolean" == typeof g && (j = g, g = arguments[h] || {}, h++), "object" == (typeof g === "undefined" ? "undefined" : _typeof(g)) || r.isFunction(g) || (g = {}), h === i && (g = this, h--); h < i; h++) {
	      if (null != (a = arguments[h])) for (b in a) {
	        c = g[b], d = a[b], g !== d && (j && d && (r.isPlainObject(d) || (e = Array.isArray(d))) ? (e ? (e = !1, f = c && Array.isArray(c) ? c : []) : f = c && r.isPlainObject(c) ? c : {}, g[b] = r.extend(j, f, d)) : void 0 !== d && (g[b] = d));
	      }
	    }return g;
	  }, r.extend({ expando: "jQuery" + (q + Math.random()).replace(/\D/g, ""), isReady: !0, error: function error(a) {
	      throw new Error(a);
	    }, noop: function noop() {}, isFunction: function isFunction(a) {
	      return "function" === r.type(a);
	    }, isWindow: function isWindow(a) {
	      return null != a && a === a.window;
	    }, isNumeric: function isNumeric(a) {
	      var b = r.type(a);return ("number" === b || "string" === b) && !isNaN(a - parseFloat(a));
	    }, isPlainObject: function isPlainObject(a) {
	      var b, c;return !(!a || "[object Object]" !== k.call(a)) && (!(b = e(a)) || (c = l.call(b, "constructor") && b.constructor, "function" == typeof c && m.call(c) === n));
	    }, isEmptyObject: function isEmptyObject(a) {
	      var b;for (b in a) {
	        return !1;
	      }return !0;
	    }, type: function type(a) {
	      return null == a ? a + "" : "object" == (typeof a === "undefined" ? "undefined" : _typeof(a)) || "function" == typeof a ? j[k.call(a)] || "object" : typeof a === "undefined" ? "undefined" : _typeof(a);
	    }, globalEval: function globalEval(a) {
	      p(a);
	    }, camelCase: function camelCase(a) {
	      return a.replace(t, "ms-").replace(u, v);
	    }, each: function each(a, b) {
	      var c,
	          d = 0;if (w(a)) {
	        for (c = a.length; d < c; d++) {
	          if (b.call(a[d], d, a[d]) === !1) break;
	        }
	      } else for (d in a) {
	        if (b.call(a[d], d, a[d]) === !1) break;
	      }return a;
	    }, trim: function trim(a) {
	      return null == a ? "" : (a + "").replace(s, "");
	    }, makeArray: function makeArray(a, b) {
	      var c = b || [];return null != a && (w(Object(a)) ? r.merge(c, "string" == typeof a ? [a] : a) : h.call(c, a)), c;
	    }, inArray: function inArray(a, b, c) {
	      return null == b ? -1 : i.call(b, a, c);
	    }, merge: function merge(a, b) {
	      for (var c = +b.length, d = 0, e = a.length; d < c; d++) {
	        a[e++] = b[d];
	      }return a.length = e, a;
	    }, grep: function grep(a, b, c) {
	      for (var d, e = [], f = 0, g = a.length, h = !c; f < g; f++) {
	        d = !b(a[f], f), d !== h && e.push(a[f]);
	      }return e;
	    }, map: function map(a, b, c) {
	      var d,
	          e,
	          f = 0,
	          h = [];if (w(a)) for (d = a.length; f < d; f++) {
	        e = b(a[f], f, c), null != e && h.push(e);
	      } else for (f in a) {
	        e = b(a[f], f, c), null != e && h.push(e);
	      }return g.apply([], h);
	    }, guid: 1, proxy: function proxy(a, b) {
	      var c, d, e;if ("string" == typeof b && (c = a[b], b = a, a = c), r.isFunction(a)) return d = f.call(arguments, 2), e = function e() {
	        return a.apply(b || this, d.concat(f.call(arguments)));
	      }, e.guid = a.guid = a.guid || r.guid++, e;
	    }, now: Date.now, support: o }), "function" == typeof Symbol && (r.fn[Symbol.iterator] = c[Symbol.iterator]), r.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (a, b) {
	    j["[object " + b + "]"] = b.toLowerCase();
	  });function w(a) {
	    var b = !!a && "length" in a && a.length,
	        c = r.type(a);return "function" !== c && !r.isWindow(a) && ("array" === c || 0 === b || "number" == typeof b && b > 0 && b - 1 in a);
	  }var x = function (a) {
	    var b,
	        c,
	        d,
	        e,
	        f,
	        g,
	        h,
	        i,
	        j,
	        k,
	        l,
	        m,
	        n,
	        o,
	        p,
	        q,
	        r,
	        s,
	        t,
	        u = "sizzle" + 1 * new Date(),
	        v = a.document,
	        w = 0,
	        x = 0,
	        y = ha(),
	        z = ha(),
	        A = ha(),
	        B = function B(a, b) {
	      return a === b && (l = !0), 0;
	    },
	        C = {}.hasOwnProperty,
	        D = [],
	        E = D.pop,
	        F = D.push,
	        G = D.push,
	        H = D.slice,
	        I = function I(a, b) {
	      for (var c = 0, d = a.length; c < d; c++) {
	        if (a[c] === b) return c;
	      }return -1;
	    },
	        J = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	        K = "[\\x20\\t\\r\\n\\f]",
	        L = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	        M = "\\[" + K + "*(" + L + ")(?:" + K + "*([*^$|!~]?=)" + K + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + L + "))|)" + K + "*\\]",
	        N = ":(" + L + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + M + ")*)|.*)\\)|)",
	        O = new RegExp(K + "+", "g"),
	        P = new RegExp("^" + K + "+|((?:^|[^\\\\])(?:\\\\.)*)" + K + "+$", "g"),
	        Q = new RegExp("^" + K + "*," + K + "*"),
	        R = new RegExp("^" + K + "*([>+~]|" + K + ")" + K + "*"),
	        S = new RegExp("=" + K + "*([^\\]'\"]*?)" + K + "*\\]", "g"),
	        T = new RegExp(N),
	        U = new RegExp("^" + L + "$"),
	        V = { ID: new RegExp("^#(" + L + ")"), CLASS: new RegExp("^\\.(" + L + ")"), TAG: new RegExp("^(" + L + "|[*])"), ATTR: new RegExp("^" + M), PSEUDO: new RegExp("^" + N), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + K + "*(even|odd|(([+-]|)(\\d*)n|)" + K + "*(?:([+-]|)" + K + "*(\\d+)|))" + K + "*\\)|)", "i"), bool: new RegExp("^(?:" + J + ")$", "i"), needsContext: new RegExp("^" + K + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + K + "*((?:-\\d)?\\d*)" + K + "*\\)|)(?=[^-]|$)", "i") },
	        W = /^(?:input|select|textarea|button)$/i,
	        X = /^h\d$/i,
	        Y = /^[^{]+\{\s*\[native \w/,
	        Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	        $ = /[+~]/,
	        _ = new RegExp("\\\\([\\da-f]{1,6}" + K + "?|(" + K + ")|.)", "ig"),
	        aa = function aa(a, b, c) {
	      var d = "0x" + b - 65536;return d !== d || c ? b : d < 0 ? String.fromCharCode(d + 65536) : String.fromCharCode(d >> 10 | 55296, 1023 & d | 56320);
	    },
	        ba = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	        ca = function ca(a, b) {
	      return b ? "\0" === a ? "\uFFFD" : a.slice(0, -1) + "\\" + a.charCodeAt(a.length - 1).toString(16) + " " : "\\" + a;
	    },
	        da = function da() {
	      m();
	    },
	        ea = ta(function (a) {
	      return a.disabled === !0 && ("form" in a || "label" in a);
	    }, { dir: "parentNode", next: "legend" });try {
	      G.apply(D = H.call(v.childNodes), v.childNodes), D[v.childNodes.length].nodeType;
	    } catch (fa) {
	      G = { apply: D.length ? function (a, b) {
	          F.apply(a, H.call(b));
	        } : function (a, b) {
	          var c = a.length,
	              d = 0;while (a[c++] = b[d++]) {}a.length = c - 1;
	        } };
	    }function ga(a, b, d, e) {
	      var f,
	          h,
	          j,
	          k,
	          l,
	          o,
	          r,
	          s = b && b.ownerDocument,
	          w = b ? b.nodeType : 9;if (d = d || [], "string" != typeof a || !a || 1 !== w && 9 !== w && 11 !== w) return d;if (!e && ((b ? b.ownerDocument || b : v) !== n && m(b), b = b || n, p)) {
	        if (11 !== w && (l = Z.exec(a))) if (f = l[1]) {
	          if (9 === w) {
	            if (!(j = b.getElementById(f))) return d;if (j.id === f) return d.push(j), d;
	          } else if (s && (j = s.getElementById(f)) && t(b, j) && j.id === f) return d.push(j), d;
	        } else {
	          if (l[2]) return G.apply(d, b.getElementsByTagName(a)), d;if ((f = l[3]) && c.getElementsByClassName && b.getElementsByClassName) return G.apply(d, b.getElementsByClassName(f)), d;
	        }if (c.qsa && !A[a + " "] && (!q || !q.test(a))) {
	          if (1 !== w) s = b, r = a;else if ("object" !== b.nodeName.toLowerCase()) {
	            (k = b.getAttribute("id")) ? k = k.replace(ba, ca) : b.setAttribute("id", k = u), o = g(a), h = o.length;while (h--) {
	              o[h] = "#" + k + " " + sa(o[h]);
	            }r = o.join(","), s = $.test(a) && qa(b.parentNode) || b;
	          }if (r) try {
	            return G.apply(d, s.querySelectorAll(r)), d;
	          } catch (x) {} finally {
	            k === u && b.removeAttribute("id");
	          }
	        }
	      }return i(a.replace(P, "$1"), b, d, e);
	    }function ha() {
	      var a = [];function b(c, e) {
	        return a.push(c + " ") > d.cacheLength && delete b[a.shift()], b[c + " "] = e;
	      }return b;
	    }function ia(a) {
	      return a[u] = !0, a;
	    }function ja(a) {
	      var b = n.createElement("fieldset");try {
	        return !!a(b);
	      } catch (c) {
	        return !1;
	      } finally {
	        b.parentNode && b.parentNode.removeChild(b), b = null;
	      }
	    }function ka(a, b) {
	      var c = a.split("|"),
	          e = c.length;while (e--) {
	        d.attrHandle[c[e]] = b;
	      }
	    }function la(a, b) {
	      var c = b && a,
	          d = c && 1 === a.nodeType && 1 === b.nodeType && a.sourceIndex - b.sourceIndex;if (d) return d;if (c) while (c = c.nextSibling) {
	        if (c === b) return -1;
	      }return a ? 1 : -1;
	    }function ma(a) {
	      return function (b) {
	        var c = b.nodeName.toLowerCase();return "input" === c && b.type === a;
	      };
	    }function na(a) {
	      return function (b) {
	        var c = b.nodeName.toLowerCase();return ("input" === c || "button" === c) && b.type === a;
	      };
	    }function oa(a) {
	      return function (b) {
	        return "form" in b ? b.parentNode && b.disabled === !1 ? "label" in b ? "label" in b.parentNode ? b.parentNode.disabled === a : b.disabled === a : b.isDisabled === a || b.isDisabled !== !a && ea(b) === a : b.disabled === a : "label" in b && b.disabled === a;
	      };
	    }function pa(a) {
	      return ia(function (b) {
	        return b = +b, ia(function (c, d) {
	          var e,
	              f = a([], c.length, b),
	              g = f.length;while (g--) {
	            c[e = f[g]] && (c[e] = !(d[e] = c[e]));
	          }
	        });
	      });
	    }function qa(a) {
	      return a && "undefined" != typeof a.getElementsByTagName && a;
	    }c = ga.support = {}, f = ga.isXML = function (a) {
	      var b = a && (a.ownerDocument || a).documentElement;return !!b && "HTML" !== b.nodeName;
	    }, m = ga.setDocument = function (a) {
	      var b,
	          e,
	          g = a ? a.ownerDocument || a : v;return g !== n && 9 === g.nodeType && g.documentElement ? (n = g, o = n.documentElement, p = !f(n), v !== n && (e = n.defaultView) && e.top !== e && (e.addEventListener ? e.addEventListener("unload", da, !1) : e.attachEvent && e.attachEvent("onunload", da)), c.attributes = ja(function (a) {
	        return a.className = "i", !a.getAttribute("className");
	      }), c.getElementsByTagName = ja(function (a) {
	        return a.appendChild(n.createComment("")), !a.getElementsByTagName("*").length;
	      }), c.getElementsByClassName = Y.test(n.getElementsByClassName), c.getById = ja(function (a) {
	        return o.appendChild(a).id = u, !n.getElementsByName || !n.getElementsByName(u).length;
	      }), c.getById ? (d.filter.ID = function (a) {
	        var b = a.replace(_, aa);return function (a) {
	          return a.getAttribute("id") === b;
	        };
	      }, d.find.ID = function (a, b) {
	        if ("undefined" != typeof b.getElementById && p) {
	          var c = b.getElementById(a);return c ? [c] : [];
	        }
	      }) : (d.filter.ID = function (a) {
	        var b = a.replace(_, aa);return function (a) {
	          var c = "undefined" != typeof a.getAttributeNode && a.getAttributeNode("id");return c && c.value === b;
	        };
	      }, d.find.ID = function (a, b) {
	        if ("undefined" != typeof b.getElementById && p) {
	          var c,
	              d,
	              e,
	              f = b.getElementById(a);if (f) {
	            if (c = f.getAttributeNode("id"), c && c.value === a) return [f];e = b.getElementsByName(a), d = 0;while (f = e[d++]) {
	              if (c = f.getAttributeNode("id"), c && c.value === a) return [f];
	            }
	          }return [];
	        }
	      }), d.find.TAG = c.getElementsByTagName ? function (a, b) {
	        return "undefined" != typeof b.getElementsByTagName ? b.getElementsByTagName(a) : c.qsa ? b.querySelectorAll(a) : void 0;
	      } : function (a, b) {
	        var c,
	            d = [],
	            e = 0,
	            f = b.getElementsByTagName(a);if ("*" === a) {
	          while (c = f[e++]) {
	            1 === c.nodeType && d.push(c);
	          }return d;
	        }return f;
	      }, d.find.CLASS = c.getElementsByClassName && function (a, b) {
	        if ("undefined" != typeof b.getElementsByClassName && p) return b.getElementsByClassName(a);
	      }, r = [], q = [], (c.qsa = Y.test(n.querySelectorAll)) && (ja(function (a) {
	        o.appendChild(a).innerHTML = "<a id='" + u + "'></a><select id='" + u + "-\r\\' msallowcapture=''><option selected=''></option></select>", a.querySelectorAll("[msallowcapture^='']").length && q.push("[*^$]=" + K + "*(?:''|\"\")"), a.querySelectorAll("[selected]").length || q.push("\\[" + K + "*(?:value|" + J + ")"), a.querySelectorAll("[id~=" + u + "-]").length || q.push("~="), a.querySelectorAll(":checked").length || q.push(":checked"), a.querySelectorAll("a#" + u + "+*").length || q.push(".#.+[+~]");
	      }), ja(function (a) {
	        a.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var b = n.createElement("input");b.setAttribute("type", "hidden"), a.appendChild(b).setAttribute("name", "D"), a.querySelectorAll("[name=d]").length && q.push("name" + K + "*[*^$|!~]?="), 2 !== a.querySelectorAll(":enabled").length && q.push(":enabled", ":disabled"), o.appendChild(a).disabled = !0, 2 !== a.querySelectorAll(":disabled").length && q.push(":enabled", ":disabled"), a.querySelectorAll("*,:x"), q.push(",.*:");
	      })), (c.matchesSelector = Y.test(s = o.matches || o.webkitMatchesSelector || o.mozMatchesSelector || o.oMatchesSelector || o.msMatchesSelector)) && ja(function (a) {
	        c.disconnectedMatch = s.call(a, "*"), s.call(a, "[s!='']:x"), r.push("!=", N);
	      }), q = q.length && new RegExp(q.join("|")), r = r.length && new RegExp(r.join("|")), b = Y.test(o.compareDocumentPosition), t = b || Y.test(o.contains) ? function (a, b) {
	        var c = 9 === a.nodeType ? a.documentElement : a,
	            d = b && b.parentNode;return a === d || !(!d || 1 !== d.nodeType || !(c.contains ? c.contains(d) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(d)));
	      } : function (a, b) {
	        if (b) while (b = b.parentNode) {
	          if (b === a) return !0;
	        }return !1;
	      }, B = b ? function (a, b) {
	        if (a === b) return l = !0, 0;var d = !a.compareDocumentPosition - !b.compareDocumentPosition;return d ? d : (d = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1, 1 & d || !c.sortDetached && b.compareDocumentPosition(a) === d ? a === n || a.ownerDocument === v && t(v, a) ? -1 : b === n || b.ownerDocument === v && t(v, b) ? 1 : k ? I(k, a) - I(k, b) : 0 : 4 & d ? -1 : 1);
	      } : function (a, b) {
	        if (a === b) return l = !0, 0;var c,
	            d = 0,
	            e = a.parentNode,
	            f = b.parentNode,
	            g = [a],
	            h = [b];if (!e || !f) return a === n ? -1 : b === n ? 1 : e ? -1 : f ? 1 : k ? I(k, a) - I(k, b) : 0;if (e === f) return la(a, b);c = a;while (c = c.parentNode) {
	          g.unshift(c);
	        }c = b;while (c = c.parentNode) {
	          h.unshift(c);
	        }while (g[d] === h[d]) {
	          d++;
	        }return d ? la(g[d], h[d]) : g[d] === v ? -1 : h[d] === v ? 1 : 0;
	      }, n) : n;
	    }, ga.matches = function (a, b) {
	      return ga(a, null, null, b);
	    }, ga.matchesSelector = function (a, b) {
	      if ((a.ownerDocument || a) !== n && m(a), b = b.replace(S, "='$1']"), c.matchesSelector && p && !A[b + " "] && (!r || !r.test(b)) && (!q || !q.test(b))) try {
	        var d = s.call(a, b);if (d || c.disconnectedMatch || a.document && 11 !== a.document.nodeType) return d;
	      } catch (e) {}return ga(b, n, null, [a]).length > 0;
	    }, ga.contains = function (a, b) {
	      return (a.ownerDocument || a) !== n && m(a), t(a, b);
	    }, ga.attr = function (a, b) {
	      (a.ownerDocument || a) !== n && m(a);var e = d.attrHandle[b.toLowerCase()],
	          f = e && C.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0;return void 0 !== f ? f : c.attributes || !p ? a.getAttribute(b) : (f = a.getAttributeNode(b)) && f.specified ? f.value : null;
	    }, ga.escape = function (a) {
	      return (a + "").replace(ba, ca);
	    }, ga.error = function (a) {
	      throw new Error("Syntax error, unrecognized expression: " + a);
	    }, ga.uniqueSort = function (a) {
	      var b,
	          d = [],
	          e = 0,
	          f = 0;if (l = !c.detectDuplicates, k = !c.sortStable && a.slice(0), a.sort(B), l) {
	        while (b = a[f++]) {
	          b === a[f] && (e = d.push(f));
	        }while (e--) {
	          a.splice(d[e], 1);
	        }
	      }return k = null, a;
	    }, e = ga.getText = function (a) {
	      var b,
	          c = "",
	          d = 0,
	          f = a.nodeType;if (f) {
	        if (1 === f || 9 === f || 11 === f) {
	          if ("string" == typeof a.textContent) return a.textContent;for (a = a.firstChild; a; a = a.nextSibling) {
	            c += e(a);
	          }
	        } else if (3 === f || 4 === f) return a.nodeValue;
	      } else while (b = a[d++]) {
	        c += e(b);
	      }return c;
	    }, d = ga.selectors = { cacheLength: 50, createPseudo: ia, match: V, attrHandle: {}, find: {}, relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } }, preFilter: { ATTR: function ATTR(a) {
	          return a[1] = a[1].replace(_, aa), a[3] = (a[3] || a[4] || a[5] || "").replace(_, aa), "~=" === a[2] && (a[3] = " " + a[3] + " "), a.slice(0, 4);
	        }, CHILD: function CHILD(a) {
	          return a[1] = a[1].toLowerCase(), "nth" === a[1].slice(0, 3) ? (a[3] || ga.error(a[0]), a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * ("even" === a[3] || "odd" === a[3])), a[5] = +(a[7] + a[8] || "odd" === a[3])) : a[3] && ga.error(a[0]), a;
	        }, PSEUDO: function PSEUDO(a) {
	          var b,
	              c = !a[6] && a[2];return V.CHILD.test(a[0]) ? null : (a[3] ? a[2] = a[4] || a[5] || "" : c && T.test(c) && (b = g(c, !0)) && (b = c.indexOf(")", c.length - b) - c.length) && (a[0] = a[0].slice(0, b), a[2] = c.slice(0, b)), a.slice(0, 3));
	        } }, filter: { TAG: function TAG(a) {
	          var b = a.replace(_, aa).toLowerCase();return "*" === a ? function () {
	            return !0;
	          } : function (a) {
	            return a.nodeName && a.nodeName.toLowerCase() === b;
	          };
	        }, CLASS: function CLASS(a) {
	          var b = y[a + " "];return b || (b = new RegExp("(^|" + K + ")" + a + "(" + K + "|$)")) && y(a, function (a) {
	            return b.test("string" == typeof a.className && a.className || "undefined" != typeof a.getAttribute && a.getAttribute("class") || "");
	          });
	        }, ATTR: function ATTR(a, b, c) {
	          return function (d) {
	            var e = ga.attr(d, a);return null == e ? "!=" === b : !b || (e += "", "=" === b ? e === c : "!=" === b ? e !== c : "^=" === b ? c && 0 === e.indexOf(c) : "*=" === b ? c && e.indexOf(c) > -1 : "$=" === b ? c && e.slice(-c.length) === c : "~=" === b ? (" " + e.replace(O, " ") + " ").indexOf(c) > -1 : "|=" === b && (e === c || e.slice(0, c.length + 1) === c + "-"));
	          };
	        }, CHILD: function CHILD(a, b, c, d, e) {
	          var f = "nth" !== a.slice(0, 3),
	              g = "last" !== a.slice(-4),
	              h = "of-type" === b;return 1 === d && 0 === e ? function (a) {
	            return !!a.parentNode;
	          } : function (b, c, i) {
	            var j,
	                k,
	                l,
	                m,
	                n,
	                o,
	                p = f !== g ? "nextSibling" : "previousSibling",
	                q = b.parentNode,
	                r = h && b.nodeName.toLowerCase(),
	                s = !i && !h,
	                t = !1;if (q) {
	              if (f) {
	                while (p) {
	                  m = b;while (m = m[p]) {
	                    if (h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) return !1;
	                  }o = p = "only" === a && !o && "nextSibling";
	                }return !0;
	              }if (o = [g ? q.firstChild : q.lastChild], g && s) {
	                m = q, l = m[u] || (m[u] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), j = k[a] || [], n = j[0] === w && j[1], t = n && j[2], m = n && q.childNodes[n];while (m = ++n && m && m[p] || (t = n = 0) || o.pop()) {
	                  if (1 === m.nodeType && ++t && m === b) {
	                    k[a] = [w, n, t];break;
	                  }
	                }
	              } else if (s && (m = b, l = m[u] || (m[u] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), j = k[a] || [], n = j[0] === w && j[1], t = n), t === !1) while (m = ++n && m && m[p] || (t = n = 0) || o.pop()) {
	                if ((h ? m.nodeName.toLowerCase() === r : 1 === m.nodeType) && ++t && (s && (l = m[u] || (m[u] = {}), k = l[m.uniqueID] || (l[m.uniqueID] = {}), k[a] = [w, t]), m === b)) break;
	              }return t -= e, t === d || t % d === 0 && t / d >= 0;
	            }
	          };
	        }, PSEUDO: function PSEUDO(a, b) {
	          var c,
	              e = d.pseudos[a] || d.setFilters[a.toLowerCase()] || ga.error("unsupported pseudo: " + a);return e[u] ? e(b) : e.length > 1 ? (c = [a, a, "", b], d.setFilters.hasOwnProperty(a.toLowerCase()) ? ia(function (a, c) {
	            var d,
	                f = e(a, b),
	                g = f.length;while (g--) {
	              d = I(a, f[g]), a[d] = !(c[d] = f[g]);
	            }
	          }) : function (a) {
	            return e(a, 0, c);
	          }) : e;
	        } }, pseudos: { not: ia(function (a) {
	          var b = [],
	              c = [],
	              d = h(a.replace(P, "$1"));return d[u] ? ia(function (a, b, c, e) {
	            var f,
	                g = d(a, null, e, []),
	                h = a.length;while (h--) {
	              (f = g[h]) && (a[h] = !(b[h] = f));
	            }
	          }) : function (a, e, f) {
	            return b[0] = a, d(b, null, f, c), b[0] = null, !c.pop();
	          };
	        }), has: ia(function (a) {
	          return function (b) {
	            return ga(a, b).length > 0;
	          };
	        }), contains: ia(function (a) {
	          return a = a.replace(_, aa), function (b) {
	            return (b.textContent || b.innerText || e(b)).indexOf(a) > -1;
	          };
	        }), lang: ia(function (a) {
	          return U.test(a || "") || ga.error("unsupported lang: " + a), a = a.replace(_, aa).toLowerCase(), function (b) {
	            var c;do {
	              if (c = p ? b.lang : b.getAttribute("xml:lang") || b.getAttribute("lang")) return c = c.toLowerCase(), c === a || 0 === c.indexOf(a + "-");
	            } while ((b = b.parentNode) && 1 === b.nodeType);return !1;
	          };
	        }), target: function target(b) {
	          var c = a.location && a.location.hash;return c && c.slice(1) === b.id;
	        }, root: function root(a) {
	          return a === o;
	        }, focus: function focus(a) {
	          return a === n.activeElement && (!n.hasFocus || n.hasFocus()) && !!(a.type || a.href || ~a.tabIndex);
	        }, enabled: oa(!1), disabled: oa(!0), checked: function checked(a) {
	          var b = a.nodeName.toLowerCase();return "input" === b && !!a.checked || "option" === b && !!a.selected;
	        }, selected: function selected(a) {
	          return a.parentNode && a.parentNode.selectedIndex, a.selected === !0;
	        }, empty: function empty(a) {
	          for (a = a.firstChild; a; a = a.nextSibling) {
	            if (a.nodeType < 6) return !1;
	          }return !0;
	        }, parent: function parent(a) {
	          return !d.pseudos.empty(a);
	        }, header: function header(a) {
	          return X.test(a.nodeName);
	        }, input: function input(a) {
	          return W.test(a.nodeName);
	        }, button: function button(a) {
	          var b = a.nodeName.toLowerCase();return "input" === b && "button" === a.type || "button" === b;
	        }, text: function text(a) {
	          var b;return "input" === a.nodeName.toLowerCase() && "text" === a.type && (null == (b = a.getAttribute("type")) || "text" === b.toLowerCase());
	        }, first: pa(function () {
	          return [0];
	        }), last: pa(function (a, b) {
	          return [b - 1];
	        }), eq: pa(function (a, b, c) {
	          return [c < 0 ? c + b : c];
	        }), even: pa(function (a, b) {
	          for (var c = 0; c < b; c += 2) {
	            a.push(c);
	          }return a;
	        }), odd: pa(function (a, b) {
	          for (var c = 1; c < b; c += 2) {
	            a.push(c);
	          }return a;
	        }), lt: pa(function (a, b, c) {
	          for (var d = c < 0 ? c + b : c; --d >= 0;) {
	            a.push(d);
	          }return a;
	        }), gt: pa(function (a, b, c) {
	          for (var d = c < 0 ? c + b : c; ++d < b;) {
	            a.push(d);
	          }return a;
	        }) } }, d.pseudos.nth = d.pseudos.eq;for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) {
	      d.pseudos[b] = ma(b);
	    }for (b in { submit: !0, reset: !0 }) {
	      d.pseudos[b] = na(b);
	    }function ra() {}ra.prototype = d.filters = d.pseudos, d.setFilters = new ra(), g = ga.tokenize = function (a, b) {
	      var c,
	          e,
	          f,
	          g,
	          h,
	          i,
	          j,
	          k = z[a + " "];if (k) return b ? 0 : k.slice(0);h = a, i = [], j = d.preFilter;while (h) {
	        c && !(e = Q.exec(h)) || (e && (h = h.slice(e[0].length) || h), i.push(f = [])), c = !1, (e = R.exec(h)) && (c = e.shift(), f.push({ value: c, type: e[0].replace(P, " ") }), h = h.slice(c.length));for (g in d.filter) {
	          !(e = V[g].exec(h)) || j[g] && !(e = j[g](e)) || (c = e.shift(), f.push({ value: c, type: g, matches: e }), h = h.slice(c.length));
	        }if (!c) break;
	      }return b ? h.length : h ? ga.error(a) : z(a, i).slice(0);
	    };function sa(a) {
	      for (var b = 0, c = a.length, d = ""; b < c; b++) {
	        d += a[b].value;
	      }return d;
	    }function ta(a, b, c) {
	      var d = b.dir,
	          e = b.next,
	          f = e || d,
	          g = c && "parentNode" === f,
	          h = x++;return b.first ? function (b, c, e) {
	        while (b = b[d]) {
	          if (1 === b.nodeType || g) return a(b, c, e);
	        }return !1;
	      } : function (b, c, i) {
	        var j,
	            k,
	            l,
	            m = [w, h];if (i) {
	          while (b = b[d]) {
	            if ((1 === b.nodeType || g) && a(b, c, i)) return !0;
	          }
	        } else while (b = b[d]) {
	          if (1 === b.nodeType || g) if (l = b[u] || (b[u] = {}), k = l[b.uniqueID] || (l[b.uniqueID] = {}), e && e === b.nodeName.toLowerCase()) b = b[d] || b;else {
	            if ((j = k[f]) && j[0] === w && j[1] === h) return m[2] = j[2];if (k[f] = m, m[2] = a(b, c, i)) return !0;
	          }
	        }return !1;
	      };
	    }function ua(a) {
	      return a.length > 1 ? function (b, c, d) {
	        var e = a.length;while (e--) {
	          if (!a[e](b, c, d)) return !1;
	        }return !0;
	      } : a[0];
	    }function va(a, b, c) {
	      for (var d = 0, e = b.length; d < e; d++) {
	        ga(a, b[d], c);
	      }return c;
	    }function wa(a, b, c, d, e) {
	      for (var f, g = [], h = 0, i = a.length, j = null != b; h < i; h++) {
	        (f = a[h]) && (c && !c(f, d, e) || (g.push(f), j && b.push(h)));
	      }return g;
	    }function xa(a, b, c, d, e, f) {
	      return d && !d[u] && (d = xa(d)), e && !e[u] && (e = xa(e, f)), ia(function (f, g, h, i) {
	        var j,
	            k,
	            l,
	            m = [],
	            n = [],
	            o = g.length,
	            p = f || va(b || "*", h.nodeType ? [h] : h, []),
	            q = !a || !f && b ? p : wa(p, m, a, h, i),
	            r = c ? e || (f ? a : o || d) ? [] : g : q;if (c && c(q, r, h, i), d) {
	          j = wa(r, n), d(j, [], h, i), k = j.length;while (k--) {
	            (l = j[k]) && (r[n[k]] = !(q[n[k]] = l));
	          }
	        }if (f) {
	          if (e || a) {
	            if (e) {
	              j = [], k = r.length;while (k--) {
	                (l = r[k]) && j.push(q[k] = l);
	              }e(null, r = [], j, i);
	            }k = r.length;while (k--) {
	              (l = r[k]) && (j = e ? I(f, l) : m[k]) > -1 && (f[j] = !(g[j] = l));
	            }
	          }
	        } else r = wa(r === g ? r.splice(o, r.length) : r), e ? e(null, g, r, i) : G.apply(g, r);
	      });
	    }function ya(a) {
	      for (var b, c, e, f = a.length, g = d.relative[a[0].type], h = g || d.relative[" "], i = g ? 1 : 0, k = ta(function (a) {
	        return a === b;
	      }, h, !0), l = ta(function (a) {
	        return I(b, a) > -1;
	      }, h, !0), m = [function (a, c, d) {
	        var e = !g && (d || c !== j) || ((b = c).nodeType ? k(a, c, d) : l(a, c, d));return b = null, e;
	      }]; i < f; i++) {
	        if (c = d.relative[a[i].type]) m = [ta(ua(m), c)];else {
	          if (c = d.filter[a[i].type].apply(null, a[i].matches), c[u]) {
	            for (e = ++i; e < f; e++) {
	              if (d.relative[a[e].type]) break;
	            }return xa(i > 1 && ua(m), i > 1 && sa(a.slice(0, i - 1).concat({ value: " " === a[i - 2].type ? "*" : "" })).replace(P, "$1"), c, i < e && ya(a.slice(i, e)), e < f && ya(a = a.slice(e)), e < f && sa(a));
	          }m.push(c);
	        }
	      }return ua(m);
	    }function za(a, b) {
	      var c = b.length > 0,
	          e = a.length > 0,
	          f = function f(_f, g, h, i, k) {
	        var l,
	            o,
	            q,
	            r = 0,
	            s = "0",
	            t = _f && [],
	            u = [],
	            v = j,
	            x = _f || e && d.find.TAG("*", k),
	            y = w += null == v ? 1 : Math.random() || .1,
	            z = x.length;for (k && (j = g === n || g || k); s !== z && null != (l = x[s]); s++) {
	          if (e && l) {
	            o = 0, g || l.ownerDocument === n || (m(l), h = !p);while (q = a[o++]) {
	              if (q(l, g || n, h)) {
	                i.push(l);break;
	              }
	            }k && (w = y);
	          }c && ((l = !q && l) && r--, _f && t.push(l));
	        }if (r += s, c && s !== r) {
	          o = 0;while (q = b[o++]) {
	            q(t, u, g, h);
	          }if (_f) {
	            if (r > 0) while (s--) {
	              t[s] || u[s] || (u[s] = E.call(i));
	            }u = wa(u);
	          }G.apply(i, u), k && !_f && u.length > 0 && r + b.length > 1 && ga.uniqueSort(i);
	        }return k && (w = y, j = v), t;
	      };return c ? ia(f) : f;
	    }return h = ga.compile = function (a, b) {
	      var c,
	          d = [],
	          e = [],
	          f = A[a + " "];if (!f) {
	        b || (b = g(a)), c = b.length;while (c--) {
	          f = ya(b[c]), f[u] ? d.push(f) : e.push(f);
	        }f = A(a, za(e, d)), f.selector = a;
	      }return f;
	    }, i = ga.select = function (a, b, c, e) {
	      var f,
	          i,
	          j,
	          k,
	          l,
	          m = "function" == typeof a && a,
	          n = !e && g(a = m.selector || a);if (c = c || [], 1 === n.length) {
	        if (i = n[0] = n[0].slice(0), i.length > 2 && "ID" === (j = i[0]).type && 9 === b.nodeType && p && d.relative[i[1].type]) {
	          if (b = (d.find.ID(j.matches[0].replace(_, aa), b) || [])[0], !b) return c;m && (b = b.parentNode), a = a.slice(i.shift().value.length);
	        }f = V.needsContext.test(a) ? 0 : i.length;while (f--) {
	          if (j = i[f], d.relative[k = j.type]) break;if ((l = d.find[k]) && (e = l(j.matches[0].replace(_, aa), $.test(i[0].type) && qa(b.parentNode) || b))) {
	            if (i.splice(f, 1), a = e.length && sa(i), !a) return G.apply(c, e), c;break;
	          }
	        }
	      }return (m || h(a, n))(e, b, !p, c, !b || $.test(a) && qa(b.parentNode) || b), c;
	    }, c.sortStable = u.split("").sort(B).join("") === u, c.detectDuplicates = !!l, m(), c.sortDetached = ja(function (a) {
	      return 1 & a.compareDocumentPosition(n.createElement("fieldset"));
	    }), ja(function (a) {
	      return a.innerHTML = "<a href='#'></a>", "#" === a.firstChild.getAttribute("href");
	    }) || ka("type|href|height|width", function (a, b, c) {
	      if (!c) return a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2);
	    }), c.attributes && ja(function (a) {
	      return a.innerHTML = "<input/>", a.firstChild.setAttribute("value", ""), "" === a.firstChild.getAttribute("value");
	    }) || ka("value", function (a, b, c) {
	      if (!c && "input" === a.nodeName.toLowerCase()) return a.defaultValue;
	    }), ja(function (a) {
	      return null == a.getAttribute("disabled");
	    }) || ka(J, function (a, b, c) {
	      var d;if (!c) return a[b] === !0 ? b.toLowerCase() : (d = a.getAttributeNode(b)) && d.specified ? d.value : null;
	    }), ga;
	  }(a);r.find = x, r.expr = x.selectors, r.expr[":"] = r.expr.pseudos, r.uniqueSort = r.unique = x.uniqueSort, r.text = x.getText, r.isXMLDoc = x.isXML, r.contains = x.contains, r.escapeSelector = x.escape;var y = function y(a, b, c) {
	    var d = [],
	        e = void 0 !== c;while ((a = a[b]) && 9 !== a.nodeType) {
	      if (1 === a.nodeType) {
	        if (e && r(a).is(c)) break;d.push(a);
	      }
	    }return d;
	  },
	      z = function z(a, b) {
	    for (var c = []; a; a = a.nextSibling) {
	      1 === a.nodeType && a !== b && c.push(a);
	    }return c;
	  },
	      A = r.expr.match.needsContext;function B(a, b) {
	    return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase();
	  }var C = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i,
	      D = /^.[^:#\[\.,]*$/;function E(a, b, c) {
	    return r.isFunction(b) ? r.grep(a, function (a, d) {
	      return !!b.call(a, d, a) !== c;
	    }) : b.nodeType ? r.grep(a, function (a) {
	      return a === b !== c;
	    }) : "string" != typeof b ? r.grep(a, function (a) {
	      return i.call(b, a) > -1 !== c;
	    }) : D.test(b) ? r.filter(b, a, c) : (b = r.filter(b, a), r.grep(a, function (a) {
	      return i.call(b, a) > -1 !== c && 1 === a.nodeType;
	    }));
	  }r.filter = function (a, b, c) {
	    var d = b[0];return c && (a = ":not(" + a + ")"), 1 === b.length && 1 === d.nodeType ? r.find.matchesSelector(d, a) ? [d] : [] : r.find.matches(a, r.grep(b, function (a) {
	      return 1 === a.nodeType;
	    }));
	  }, r.fn.extend({ find: function find(a) {
	      var b,
	          c,
	          d = this.length,
	          e = this;if ("string" != typeof a) return this.pushStack(r(a).filter(function () {
	        for (b = 0; b < d; b++) {
	          if (r.contains(e[b], this)) return !0;
	        }
	      }));for (c = this.pushStack([]), b = 0; b < d; b++) {
	        r.find(a, e[b], c);
	      }return d > 1 ? r.uniqueSort(c) : c;
	    }, filter: function filter(a) {
	      return this.pushStack(E(this, a || [], !1));
	    }, not: function not(a) {
	      return this.pushStack(E(this, a || [], !0));
	    }, is: function is(a) {
	      return !!E(this, "string" == typeof a && A.test(a) ? r(a) : a || [], !1).length;
	    } });var F,
	      G = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	      H = r.fn.init = function (a, b, c) {
	    var e, f;if (!a) return this;if (c = c || F, "string" == typeof a) {
	      if (e = "<" === a[0] && ">" === a[a.length - 1] && a.length >= 3 ? [null, a, null] : G.exec(a), !e || !e[1] && b) return !b || b.jquery ? (b || c).find(a) : this.constructor(b).find(a);if (e[1]) {
	        if (b = b instanceof r ? b[0] : b, r.merge(this, r.parseHTML(e[1], b && b.nodeType ? b.ownerDocument || b : d, !0)), C.test(e[1]) && r.isPlainObject(b)) for (e in b) {
	          r.isFunction(this[e]) ? this[e](b[e]) : this.attr(e, b[e]);
	        }return this;
	      }return f = d.getElementById(e[2]), f && (this[0] = f, this.length = 1), this;
	    }return a.nodeType ? (this[0] = a, this.length = 1, this) : r.isFunction(a) ? void 0 !== c.ready ? c.ready(a) : a(r) : r.makeArray(a, this);
	  };H.prototype = r.fn, F = r(d);var I = /^(?:parents|prev(?:Until|All))/,
	      J = { children: !0, contents: !0, next: !0, prev: !0 };r.fn.extend({ has: function has(a) {
	      var b = r(a, this),
	          c = b.length;return this.filter(function () {
	        for (var a = 0; a < c; a++) {
	          if (r.contains(this, b[a])) return !0;
	        }
	      });
	    }, closest: function closest(a, b) {
	      var c,
	          d = 0,
	          e = this.length,
	          f = [],
	          g = "string" != typeof a && r(a);if (!A.test(a)) for (; d < e; d++) {
	        for (c = this[d]; c && c !== b; c = c.parentNode) {
	          if (c.nodeType < 11 && (g ? g.index(c) > -1 : 1 === c.nodeType && r.find.matchesSelector(c, a))) {
	            f.push(c);break;
	          }
	        }
	      }return this.pushStack(f.length > 1 ? r.uniqueSort(f) : f);
	    }, index: function index(a) {
	      return a ? "string" == typeof a ? i.call(r(a), this[0]) : i.call(this, a.jquery ? a[0] : a) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
	    }, add: function add(a, b) {
	      return this.pushStack(r.uniqueSort(r.merge(this.get(), r(a, b))));
	    }, addBack: function addBack(a) {
	      return this.add(null == a ? this.prevObject : this.prevObject.filter(a));
	    } });function K(a, b) {
	    while ((a = a[b]) && 1 !== a.nodeType) {}return a;
	  }r.each({ parent: function parent(a) {
	      var b = a.parentNode;return b && 11 !== b.nodeType ? b : null;
	    }, parents: function parents(a) {
	      return y(a, "parentNode");
	    }, parentsUntil: function parentsUntil(a, b, c) {
	      return y(a, "parentNode", c);
	    }, next: function next(a) {
	      return K(a, "nextSibling");
	    }, prev: function prev(a) {
	      return K(a, "previousSibling");
	    }, nextAll: function nextAll(a) {
	      return y(a, "nextSibling");
	    }, prevAll: function prevAll(a) {
	      return y(a, "previousSibling");
	    }, nextUntil: function nextUntil(a, b, c) {
	      return y(a, "nextSibling", c);
	    }, prevUntil: function prevUntil(a, b, c) {
	      return y(a, "previousSibling", c);
	    }, siblings: function siblings(a) {
	      return z((a.parentNode || {}).firstChild, a);
	    }, children: function children(a) {
	      return z(a.firstChild);
	    }, contents: function contents(a) {
	      return B(a, "iframe") ? a.contentDocument : (B(a, "template") && (a = a.content || a), r.merge([], a.childNodes));
	    } }, function (a, b) {
	    r.fn[a] = function (c, d) {
	      var e = r.map(this, b, c);return "Until" !== a.slice(-5) && (d = c), d && "string" == typeof d && (e = r.filter(d, e)), this.length > 1 && (J[a] || r.uniqueSort(e), I.test(a) && e.reverse()), this.pushStack(e);
	    };
	  });var L = /[^\x20\t\r\n\f]+/g;function M(a) {
	    var b = {};return r.each(a.match(L) || [], function (a, c) {
	      b[c] = !0;
	    }), b;
	  }r.Callbacks = function (a) {
	    a = "string" == typeof a ? M(a) : r.extend({}, a);var b,
	        c,
	        d,
	        e,
	        f = [],
	        g = [],
	        h = -1,
	        i = function i() {
	      for (e = e || a.once, d = b = !0; g.length; h = -1) {
	        c = g.shift();while (++h < f.length) {
	          f[h].apply(c[0], c[1]) === !1 && a.stopOnFalse && (h = f.length, c = !1);
	        }
	      }a.memory || (c = !1), b = !1, e && (f = c ? [] : "");
	    },
	        j = { add: function add() {
	        return f && (c && !b && (h = f.length - 1, g.push(c)), function d(b) {
	          r.each(b, function (b, c) {
	            r.isFunction(c) ? a.unique && j.has(c) || f.push(c) : c && c.length && "string" !== r.type(c) && d(c);
	          });
	        }(arguments), c && !b && i()), this;
	      }, remove: function remove() {
	        return r.each(arguments, function (a, b) {
	          var c;while ((c = r.inArray(b, f, c)) > -1) {
	            f.splice(c, 1), c <= h && h--;
	          }
	        }), this;
	      }, has: function has(a) {
	        return a ? r.inArray(a, f) > -1 : f.length > 0;
	      }, empty: function empty() {
	        return f && (f = []), this;
	      }, disable: function disable() {
	        return e = g = [], f = c = "", this;
	      }, disabled: function disabled() {
	        return !f;
	      }, lock: function lock() {
	        return e = g = [], c || b || (f = c = ""), this;
	      }, locked: function locked() {
	        return !!e;
	      }, fireWith: function fireWith(a, c) {
	        return e || (c = c || [], c = [a, c.slice ? c.slice() : c], g.push(c), b || i()), this;
	      }, fire: function fire() {
	        return j.fireWith(this, arguments), this;
	      }, fired: function fired() {
	        return !!d;
	      } };return j;
	  };function N(a) {
	    return a;
	  }function O(a) {
	    throw a;
	  }function P(a, b, c, d) {
	    var e;try {
	      a && r.isFunction(e = a.promise) ? e.call(a).done(b).fail(c) : a && r.isFunction(e = a.then) ? e.call(a, b, c) : b.apply(void 0, [a].slice(d));
	    } catch (a) {
	      c.apply(void 0, [a]);
	    }
	  }r.extend({ Deferred: function Deferred(b) {
	      var c = [["notify", "progress", r.Callbacks("memory"), r.Callbacks("memory"), 2], ["resolve", "done", r.Callbacks("once memory"), r.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", r.Callbacks("once memory"), r.Callbacks("once memory"), 1, "rejected"]],
	          d = "pending",
	          e = { state: function state() {
	          return d;
	        }, always: function always() {
	          return f.done(arguments).fail(arguments), this;
	        }, "catch": function _catch(a) {
	          return e.then(null, a);
	        }, pipe: function pipe() {
	          var a = arguments;return r.Deferred(function (b) {
	            r.each(c, function (c, d) {
	              var e = r.isFunction(a[d[4]]) && a[d[4]];f[d[1]](function () {
	                var a = e && e.apply(this, arguments);a && r.isFunction(a.promise) ? a.promise().progress(b.notify).done(b.resolve).fail(b.reject) : b[d[0] + "With"](this, e ? [a] : arguments);
	              });
	            }), a = null;
	          }).promise();
	        }, then: function then(b, d, e) {
	          var f = 0;function g(b, c, d, e) {
	            return function () {
	              var h = this,
	                  i = arguments,
	                  j = function j() {
	                var a, j;if (!(b < f)) {
	                  if (a = d.apply(h, i), a === c.promise()) throw new TypeError("Thenable self-resolution");j = a && ("object" == (typeof a === "undefined" ? "undefined" : _typeof(a)) || "function" == typeof a) && a.then, r.isFunction(j) ? e ? j.call(a, g(f, c, N, e), g(f, c, O, e)) : (f++, j.call(a, g(f, c, N, e), g(f, c, O, e), g(f, c, N, c.notifyWith))) : (d !== N && (h = void 0, i = [a]), (e || c.resolveWith)(h, i));
	                }
	              },
	                  k = e ? j : function () {
	                try {
	                  j();
	                } catch (a) {
	                  r.Deferred.exceptionHook && r.Deferred.exceptionHook(a, k.stackTrace), b + 1 >= f && (d !== O && (h = void 0, i = [a]), c.rejectWith(h, i));
	                }
	              };b ? k() : (r.Deferred.getStackHook && (k.stackTrace = r.Deferred.getStackHook()), a.setTimeout(k));
	            };
	          }return r.Deferred(function (a) {
	            c[0][3].add(g(0, a, r.isFunction(e) ? e : N, a.notifyWith)), c[1][3].add(g(0, a, r.isFunction(b) ? b : N)), c[2][3].add(g(0, a, r.isFunction(d) ? d : O));
	          }).promise();
	        }, promise: function promise(a) {
	          return null != a ? r.extend(a, e) : e;
	        } },
	          f = {};return r.each(c, function (a, b) {
	        var g = b[2],
	            h = b[5];e[b[1]] = g.add, h && g.add(function () {
	          d = h;
	        }, c[3 - a][2].disable, c[0][2].lock), g.add(b[3].fire), f[b[0]] = function () {
	          return f[b[0] + "With"](this === f ? void 0 : this, arguments), this;
	        }, f[b[0] + "With"] = g.fireWith;
	      }), e.promise(f), b && b.call(f, f), f;
	    }, when: function when(a) {
	      var b = arguments.length,
	          c = b,
	          d = Array(c),
	          e = f.call(arguments),
	          g = r.Deferred(),
	          h = function h(a) {
	        return function (c) {
	          d[a] = this, e[a] = arguments.length > 1 ? f.call(arguments) : c, --b || g.resolveWith(d, e);
	        };
	      };if (b <= 1 && (P(a, g.done(h(c)).resolve, g.reject, !b), "pending" === g.state() || r.isFunction(e[c] && e[c].then))) return g.then();while (c--) {
	        P(e[c], h(c), g.reject);
	      }return g.promise();
	    } });var Q = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;r.Deferred.exceptionHook = function (b, c) {
	    a.console && a.console.warn && b && Q.test(b.name) && a.console.warn("jQuery.Deferred exception: " + b.message, b.stack, c);
	  }, r.readyException = function (b) {
	    a.setTimeout(function () {
	      throw b;
	    });
	  };var R = r.Deferred();r.fn.ready = function (a) {
	    return R.then(a)["catch"](function (a) {
	      r.readyException(a);
	    }), this;
	  }, r.extend({ isReady: !1, readyWait: 1, ready: function ready(a) {
	      (a === !0 ? --r.readyWait : r.isReady) || (r.isReady = !0, a !== !0 && --r.readyWait > 0 || R.resolveWith(d, [r]));
	    } }), r.ready.then = R.then;function S() {
	    d.removeEventListener("DOMContentLoaded", S), a.removeEventListener("load", S), r.ready();
	  }"complete" === d.readyState || "loading" !== d.readyState && !d.documentElement.doScroll ? a.setTimeout(r.ready) : (d.addEventListener("DOMContentLoaded", S), a.addEventListener("load", S));var T = function T(a, b, c, d, e, f, g) {
	    var h = 0,
	        i = a.length,
	        j = null == c;if ("object" === r.type(c)) {
	      e = !0;for (h in c) {
	        T(a, b, h, c[h], !0, f, g);
	      }
	    } else if (void 0 !== d && (e = !0, r.isFunction(d) || (g = !0), j && (g ? (b.call(a, d), b = null) : (j = b, b = function b(a, _b, c) {
	      return j.call(r(a), c);
	    })), b)) for (; h < i; h++) {
	      b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
	    }return e ? a : j ? b.call(a) : i ? b(a[0], c) : f;
	  },
	      U = function U(a) {
	    return 1 === a.nodeType || 9 === a.nodeType || !+a.nodeType;
	  };function V() {
	    this.expando = r.expando + V.uid++;
	  }V.uid = 1, V.prototype = { cache: function cache(a) {
	      var b = a[this.expando];return b || (b = {}, U(a) && (a.nodeType ? a[this.expando] = b : Object.defineProperty(a, this.expando, { value: b, configurable: !0 }))), b;
	    }, set: function set(a, b, c) {
	      var d,
	          e = this.cache(a);if ("string" == typeof b) e[r.camelCase(b)] = c;else for (d in b) {
	        e[r.camelCase(d)] = b[d];
	      }return e;
	    }, get: function get(a, b) {
	      return void 0 === b ? this.cache(a) : a[this.expando] && a[this.expando][r.camelCase(b)];
	    }, access: function access(a, b, c) {
	      return void 0 === b || b && "string" == typeof b && void 0 === c ? this.get(a, b) : (this.set(a, b, c), void 0 !== c ? c : b);
	    }, remove: function remove(a, b) {
	      var c,
	          d = a[this.expando];if (void 0 !== d) {
	        if (void 0 !== b) {
	          Array.isArray(b) ? b = b.map(r.camelCase) : (b = r.camelCase(b), b = b in d ? [b] : b.match(L) || []), c = b.length;while (c--) {
	            delete d[b[c]];
	          }
	        }(void 0 === b || r.isEmptyObject(d)) && (a.nodeType ? a[this.expando] = void 0 : delete a[this.expando]);
	      }
	    }, hasData: function hasData(a) {
	      var b = a[this.expando];return void 0 !== b && !r.isEmptyObject(b);
	    } };var W = new V(),
	      X = new V(),
	      Y = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	      Z = /[A-Z]/g;function $(a) {
	    return "true" === a || "false" !== a && ("null" === a ? null : a === +a + "" ? +a : Y.test(a) ? JSON.parse(a) : a);
	  }function _(a, b, c) {
	    var d;if (void 0 === c && 1 === a.nodeType) if (d = "data-" + b.replace(Z, "-$&").toLowerCase(), c = a.getAttribute(d), "string" == typeof c) {
	      try {
	        c = $(c);
	      } catch (e) {}X.set(a, b, c);
	    } else c = void 0;return c;
	  }r.extend({ hasData: function hasData(a) {
	      return X.hasData(a) || W.hasData(a);
	    }, data: function data(a, b, c) {
	      return X.access(a, b, c);
	    }, removeData: function removeData(a, b) {
	      X.remove(a, b);
	    }, _data: function _data(a, b, c) {
	      return W.access(a, b, c);
	    }, _removeData: function _removeData(a, b) {
	      W.remove(a, b);
	    } }), r.fn.extend({ data: function data(a, b) {
	      var c,
	          d,
	          e,
	          f = this[0],
	          g = f && f.attributes;if (void 0 === a) {
	        if (this.length && (e = X.get(f), 1 === f.nodeType && !W.get(f, "hasDataAttrs"))) {
	          c = g.length;while (c--) {
	            g[c] && (d = g[c].name, 0 === d.indexOf("data-") && (d = r.camelCase(d.slice(5)), _(f, d, e[d])));
	          }W.set(f, "hasDataAttrs", !0);
	        }return e;
	      }return "object" == (typeof a === "undefined" ? "undefined" : _typeof(a)) ? this.each(function () {
	        X.set(this, a);
	      }) : T(this, function (b) {
	        var c;if (f && void 0 === b) {
	          if (c = X.get(f, a), void 0 !== c) return c;if (c = _(f, a), void 0 !== c) return c;
	        } else this.each(function () {
	          X.set(this, a, b);
	        });
	      }, null, b, arguments.length > 1, null, !0);
	    }, removeData: function removeData(a) {
	      return this.each(function () {
	        X.remove(this, a);
	      });
	    } }), r.extend({ queue: function queue(a, b, c) {
	      var d;if (a) return b = (b || "fx") + "queue", d = W.get(a, b), c && (!d || Array.isArray(c) ? d = W.access(a, b, r.makeArray(c)) : d.push(c)), d || [];
	    }, dequeue: function dequeue(a, b) {
	      b = b || "fx";var c = r.queue(a, b),
	          d = c.length,
	          e = c.shift(),
	          f = r._queueHooks(a, b),
	          g = function g() {
	        r.dequeue(a, b);
	      };"inprogress" === e && (e = c.shift(), d--), e && ("fx" === b && c.unshift("inprogress"), delete f.stop, e.call(a, g, f)), !d && f && f.empty.fire();
	    }, _queueHooks: function _queueHooks(a, b) {
	      var c = b + "queueHooks";return W.get(a, c) || W.access(a, c, { empty: r.Callbacks("once memory").add(function () {
	          W.remove(a, [b + "queue", c]);
	        }) });
	    } }), r.fn.extend({ queue: function queue(a, b) {
	      var c = 2;return "string" != typeof a && (b = a, a = "fx", c--), arguments.length < c ? r.queue(this[0], a) : void 0 === b ? this : this.each(function () {
	        var c = r.queue(this, a, b);r._queueHooks(this, a), "fx" === a && "inprogress" !== c[0] && r.dequeue(this, a);
	      });
	    }, dequeue: function dequeue(a) {
	      return this.each(function () {
	        r.dequeue(this, a);
	      });
	    }, clearQueue: function clearQueue(a) {
	      return this.queue(a || "fx", []);
	    }, promise: function promise(a, b) {
	      var c,
	          d = 1,
	          e = r.Deferred(),
	          f = this,
	          g = this.length,
	          h = function h() {
	        --d || e.resolveWith(f, [f]);
	      };"string" != typeof a && (b = a, a = void 0), a = a || "fx";while (g--) {
	        c = W.get(f[g], a + "queueHooks"), c && c.empty && (d++, c.empty.add(h));
	      }return h(), e.promise(b);
	    } });var aa = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
	      ba = new RegExp("^(?:([+-])=|)(" + aa + ")([a-z%]*)$", "i"),
	      ca = ["Top", "Right", "Bottom", "Left"],
	      da = function da(a, b) {
	    return a = b || a, "none" === a.style.display || "" === a.style.display && r.contains(a.ownerDocument, a) && "none" === r.css(a, "display");
	  },
	      ea = function ea(a, b, c, d) {
	    var e,
	        f,
	        g = {};for (f in b) {
	      g[f] = a.style[f], a.style[f] = b[f];
	    }e = c.apply(a, d || []);for (f in b) {
	      a.style[f] = g[f];
	    }return e;
	  };function fa(a, b, c, d) {
	    var e,
	        f = 1,
	        g = 20,
	        h = d ? function () {
	      return d.cur();
	    } : function () {
	      return r.css(a, b, "");
	    },
	        i = h(),
	        j = c && c[3] || (r.cssNumber[b] ? "" : "px"),
	        k = (r.cssNumber[b] || "px" !== j && +i) && ba.exec(r.css(a, b));if (k && k[3] !== j) {
	      j = j || k[3], c = c || [], k = +i || 1;do {
	        f = f || ".5", k /= f, r.style(a, b, k + j);
	      } while (f !== (f = h() / i) && 1 !== f && --g);
	    }return c && (k = +k || +i || 0, e = c[1] ? k + (c[1] + 1) * c[2] : +c[2], d && (d.unit = j, d.start = k, d.end = e)), e;
	  }var ga = {};function ha(a) {
	    var b,
	        c = a.ownerDocument,
	        d = a.nodeName,
	        e = ga[d];return e ? e : (b = c.body.appendChild(c.createElement(d)), e = r.css(b, "display"), b.parentNode.removeChild(b), "none" === e && (e = "block"), ga[d] = e, e);
	  }function ia(a, b) {
	    for (var c, d, e = [], f = 0, g = a.length; f < g; f++) {
	      d = a[f], d.style && (c = d.style.display, b ? ("none" === c && (e[f] = W.get(d, "display") || null, e[f] || (d.style.display = "")), "" === d.style.display && da(d) && (e[f] = ha(d))) : "none" !== c && (e[f] = "none", W.set(d, "display", c)));
	    }for (f = 0; f < g; f++) {
	      null != e[f] && (a[f].style.display = e[f]);
	    }return a;
	  }r.fn.extend({ show: function show() {
	      return ia(this, !0);
	    }, hide: function hide() {
	      return ia(this);
	    }, toggle: function toggle(a) {
	      return "boolean" == typeof a ? a ? this.show() : this.hide() : this.each(function () {
	        da(this) ? r(this).show() : r(this).hide();
	      });
	    } });var ja = /^(?:checkbox|radio)$/i,
	      ka = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
	      la = /^$|\/(?:java|ecma)script/i,
	      ma = { option: [1, "<select multiple='multiple'>", "</select>"], thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };ma.optgroup = ma.option, ma.tbody = ma.tfoot = ma.colgroup = ma.caption = ma.thead, ma.th = ma.td;function na(a, b) {
	    var c;return c = "undefined" != typeof a.getElementsByTagName ? a.getElementsByTagName(b || "*") : "undefined" != typeof a.querySelectorAll ? a.querySelectorAll(b || "*") : [], void 0 === b || b && B(a, b) ? r.merge([a], c) : c;
	  }function oa(a, b) {
	    for (var c = 0, d = a.length; c < d; c++) {
	      W.set(a[c], "globalEval", !b || W.get(b[c], "globalEval"));
	    }
	  }var pa = /<|&#?\w+;/;function qa(a, b, c, d, e) {
	    for (var f, g, h, i, j, k, l = b.createDocumentFragment(), m = [], n = 0, o = a.length; n < o; n++) {
	      if (f = a[n], f || 0 === f) if ("object" === r.type(f)) r.merge(m, f.nodeType ? [f] : f);else if (pa.test(f)) {
	        g = g || l.appendChild(b.createElement("div")), h = (ka.exec(f) || ["", ""])[1].toLowerCase(), i = ma[h] || ma._default, g.innerHTML = i[1] + r.htmlPrefilter(f) + i[2], k = i[0];while (k--) {
	          g = g.lastChild;
	        }r.merge(m, g.childNodes), g = l.firstChild, g.textContent = "";
	      } else m.push(b.createTextNode(f));
	    }l.textContent = "", n = 0;while (f = m[n++]) {
	      if (d && r.inArray(f, d) > -1) e && e.push(f);else if (j = r.contains(f.ownerDocument, f), g = na(l.appendChild(f), "script"), j && oa(g), c) {
	        k = 0;while (f = g[k++]) {
	          la.test(f.type || "") && c.push(f);
	        }
	      }
	    }return l;
	  }!function () {
	    var a = d.createDocumentFragment(),
	        b = a.appendChild(d.createElement("div")),
	        c = d.createElement("input");c.setAttribute("type", "radio"), c.setAttribute("checked", "checked"), c.setAttribute("name", "t"), b.appendChild(c), o.checkClone = b.cloneNode(!0).cloneNode(!0).lastChild.checked, b.innerHTML = "<textarea>x</textarea>", o.noCloneChecked = !!b.cloneNode(!0).lastChild.defaultValue;
	  }();var ra = d.documentElement,
	      sa = /^key/,
	      ta = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	      ua = /^([^.]*)(?:\.(.+)|)/;function va() {
	    return !0;
	  }function wa() {
	    return !1;
	  }function xa() {
	    try {
	      return d.activeElement;
	    } catch (a) {}
	  }function ya(a, b, c, d, e, f) {
	    var g, h;if ("object" == (typeof b === "undefined" ? "undefined" : _typeof(b))) {
	      "string" != typeof c && (d = d || c, c = void 0);for (h in b) {
	        ya(a, h, c, d, b[h], f);
	      }return a;
	    }if (null == d && null == e ? (e = c, d = c = void 0) : null == e && ("string" == typeof c ? (e = d, d = void 0) : (e = d, d = c, c = void 0)), e === !1) e = wa;else if (!e) return a;return 1 === f && (g = e, e = function e(a) {
	      return r().off(a), g.apply(this, arguments);
	    }, e.guid = g.guid || (g.guid = r.guid++)), a.each(function () {
	      r.event.add(this, b, e, d, c);
	    });
	  }r.event = { global: {}, add: function add(a, b, c, d, e) {
	      var f,
	          g,
	          h,
	          i,
	          j,
	          k,
	          l,
	          m,
	          n,
	          o,
	          p,
	          q = W.get(a);if (q) {
	        c.handler && (f = c, c = f.handler, e = f.selector), e && r.find.matchesSelector(ra, e), c.guid || (c.guid = r.guid++), (i = q.events) || (i = q.events = {}), (g = q.handle) || (g = q.handle = function (b) {
	          return "undefined" != typeof r && r.event.triggered !== b.type ? r.event.dispatch.apply(a, arguments) : void 0;
	        }), b = (b || "").match(L) || [""], j = b.length;while (j--) {
	          h = ua.exec(b[j]) || [], n = p = h[1], o = (h[2] || "").split(".").sort(), n && (l = r.event.special[n] || {}, n = (e ? l.delegateType : l.bindType) || n, l = r.event.special[n] || {}, k = r.extend({ type: n, origType: p, data: d, handler: c, guid: c.guid, selector: e, needsContext: e && r.expr.match.needsContext.test(e), namespace: o.join(".") }, f), (m = i[n]) || (m = i[n] = [], m.delegateCount = 0, l.setup && l.setup.call(a, d, o, g) !== !1 || a.addEventListener && a.addEventListener(n, g)), l.add && (l.add.call(a, k), k.handler.guid || (k.handler.guid = c.guid)), e ? m.splice(m.delegateCount++, 0, k) : m.push(k), r.event.global[n] = !0);
	        }
	      }
	    }, remove: function remove(a, b, c, d, e) {
	      var f,
	          g,
	          h,
	          i,
	          j,
	          k,
	          l,
	          m,
	          n,
	          o,
	          p,
	          q = W.hasData(a) && W.get(a);if (q && (i = q.events)) {
	        b = (b || "").match(L) || [""], j = b.length;while (j--) {
	          if (h = ua.exec(b[j]) || [], n = p = h[1], o = (h[2] || "").split(".").sort(), n) {
	            l = r.event.special[n] || {}, n = (d ? l.delegateType : l.bindType) || n, m = i[n] || [], h = h[2] && new RegExp("(^|\\.)" + o.join("\\.(?:.*\\.|)") + "(\\.|$)"), g = f = m.length;while (f--) {
	              k = m[f], !e && p !== k.origType || c && c.guid !== k.guid || h && !h.test(k.namespace) || d && d !== k.selector && ("**" !== d || !k.selector) || (m.splice(f, 1), k.selector && m.delegateCount--, l.remove && l.remove.call(a, k));
	            }g && !m.length && (l.teardown && l.teardown.call(a, o, q.handle) !== !1 || r.removeEvent(a, n, q.handle), delete i[n]);
	          } else for (n in i) {
	            r.event.remove(a, n + b[j], c, d, !0);
	          }
	        }r.isEmptyObject(i) && W.remove(a, "handle events");
	      }
	    }, dispatch: function dispatch(a) {
	      var b = r.event.fix(a),
	          c,
	          d,
	          e,
	          f,
	          g,
	          h,
	          i = new Array(arguments.length),
	          j = (W.get(this, "events") || {})[b.type] || [],
	          k = r.event.special[b.type] || {};for (i[0] = b, c = 1; c < arguments.length; c++) {
	        i[c] = arguments[c];
	      }if (b.delegateTarget = this, !k.preDispatch || k.preDispatch.call(this, b) !== !1) {
	        h = r.event.handlers.call(this, b, j), c = 0;while ((f = h[c++]) && !b.isPropagationStopped()) {
	          b.currentTarget = f.elem, d = 0;while ((g = f.handlers[d++]) && !b.isImmediatePropagationStopped()) {
	            b.rnamespace && !b.rnamespace.test(g.namespace) || (b.handleObj = g, b.data = g.data, e = ((r.event.special[g.origType] || {}).handle || g.handler).apply(f.elem, i), void 0 !== e && (b.result = e) === !1 && (b.preventDefault(), b.stopPropagation()));
	          }
	        }return k.postDispatch && k.postDispatch.call(this, b), b.result;
	      }
	    }, handlers: function handlers(a, b) {
	      var c,
	          d,
	          e,
	          f,
	          g,
	          h = [],
	          i = b.delegateCount,
	          j = a.target;if (i && j.nodeType && !("click" === a.type && a.button >= 1)) for (; j !== this; j = j.parentNode || this) {
	        if (1 === j.nodeType && ("click" !== a.type || j.disabled !== !0)) {
	          for (f = [], g = {}, c = 0; c < i; c++) {
	            d = b[c], e = d.selector + " ", void 0 === g[e] && (g[e] = d.needsContext ? r(e, this).index(j) > -1 : r.find(e, this, null, [j]).length), g[e] && f.push(d);
	          }f.length && h.push({ elem: j, handlers: f });
	        }
	      }return j = this, i < b.length && h.push({ elem: j, handlers: b.slice(i) }), h;
	    }, addProp: function addProp(a, b) {
	      Object.defineProperty(r.Event.prototype, a, { enumerable: !0, configurable: !0, get: r.isFunction(b) ? function () {
	          if (this.originalEvent) return b(this.originalEvent);
	        } : function () {
	          if (this.originalEvent) return this.originalEvent[a];
	        }, set: function set(b) {
	          Object.defineProperty(this, a, { enumerable: !0, configurable: !0, writable: !0, value: b });
	        } });
	    }, fix: function fix(a) {
	      return a[r.expando] ? a : new r.Event(a);
	    }, special: { load: { noBubble: !0 }, focus: { trigger: function trigger() {
	          if (this !== xa() && this.focus) return this.focus(), !1;
	        }, delegateType: "focusin" }, blur: { trigger: function trigger() {
	          if (this === xa() && this.blur) return this.blur(), !1;
	        }, delegateType: "focusout" }, click: { trigger: function trigger() {
	          if ("checkbox" === this.type && this.click && B(this, "input")) return this.click(), !1;
	        }, _default: function _default(a) {
	          return B(a.target, "a");
	        } }, beforeunload: { postDispatch: function postDispatch(a) {
	          void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result);
	        } } } }, r.removeEvent = function (a, b, c) {
	    a.removeEventListener && a.removeEventListener(b, c);
	  }, r.Event = function (a, b) {
	    return this instanceof r.Event ? (a && a.type ? (this.originalEvent = a, this.type = a.type, this.isDefaultPrevented = a.defaultPrevented || void 0 === a.defaultPrevented && a.returnValue === !1 ? va : wa, this.target = a.target && 3 === a.target.nodeType ? a.target.parentNode : a.target, this.currentTarget = a.currentTarget, this.relatedTarget = a.relatedTarget) : this.type = a, b && r.extend(this, b), this.timeStamp = a && a.timeStamp || r.now(), void (this[r.expando] = !0)) : new r.Event(a, b);
	  }, r.Event.prototype = { constructor: r.Event, isDefaultPrevented: wa, isPropagationStopped: wa, isImmediatePropagationStopped: wa, isSimulated: !1, preventDefault: function preventDefault() {
	      var a = this.originalEvent;this.isDefaultPrevented = va, a && !this.isSimulated && a.preventDefault();
	    }, stopPropagation: function stopPropagation() {
	      var a = this.originalEvent;this.isPropagationStopped = va, a && !this.isSimulated && a.stopPropagation();
	    }, stopImmediatePropagation: function stopImmediatePropagation() {
	      var a = this.originalEvent;this.isImmediatePropagationStopped = va, a && !this.isSimulated && a.stopImmediatePropagation(), this.stopPropagation();
	    } }, r.each({ altKey: !0, bubbles: !0, cancelable: !0, changedTouches: !0, ctrlKey: !0, detail: !0, eventPhase: !0, metaKey: !0, pageX: !0, pageY: !0, shiftKey: !0, view: !0, "char": !0, charCode: !0, key: !0, keyCode: !0, button: !0, buttons: !0, clientX: !0, clientY: !0, offsetX: !0, offsetY: !0, pointerId: !0, pointerType: !0, screenX: !0, screenY: !0, targetTouches: !0, toElement: !0, touches: !0, which: function which(a) {
	      var b = a.button;return null == a.which && sa.test(a.type) ? null != a.charCode ? a.charCode : a.keyCode : !a.which && void 0 !== b && ta.test(a.type) ? 1 & b ? 1 : 2 & b ? 3 : 4 & b ? 2 : 0 : a.which;
	    } }, r.event.addProp), r.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (a, b) {
	    r.event.special[a] = { delegateType: b, bindType: b, handle: function handle(a) {
	        var c,
	            d = this,
	            e = a.relatedTarget,
	            f = a.handleObj;return e && (e === d || r.contains(d, e)) || (a.type = f.origType, c = f.handler.apply(this, arguments), a.type = b), c;
	      } };
	  }), r.fn.extend({ on: function on(a, b, c, d) {
	      return ya(this, a, b, c, d);
	    }, one: function one(a, b, c, d) {
	      return ya(this, a, b, c, d, 1);
	    }, off: function off(a, b, c) {
	      var d, e;if (a && a.preventDefault && a.handleObj) return d = a.handleObj, r(a.delegateTarget).off(d.namespace ? d.origType + "." + d.namespace : d.origType, d.selector, d.handler), this;if ("object" == (typeof a === "undefined" ? "undefined" : _typeof(a))) {
	        for (e in a) {
	          this.off(e, b, a[e]);
	        }return this;
	      }return b !== !1 && "function" != typeof b || (c = b, b = void 0), c === !1 && (c = wa), this.each(function () {
	        r.event.remove(this, a, c, b);
	      });
	    } });var za = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	      Aa = /<script|<style|<link/i,
	      Ba = /checked\s*(?:[^=]|=\s*.checked.)/i,
	      Ca = /^true\/(.*)/,
	      Da = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Ea(a, b) {
	    return B(a, "table") && B(11 !== b.nodeType ? b : b.firstChild, "tr") ? r(">tbody", a)[0] || a : a;
	  }function Fa(a) {
	    return a.type = (null !== a.getAttribute("type")) + "/" + a.type, a;
	  }function Ga(a) {
	    var b = Ca.exec(a.type);return b ? a.type = b[1] : a.removeAttribute("type"), a;
	  }function Ha(a, b) {
	    var c, d, e, f, g, h, i, j;if (1 === b.nodeType) {
	      if (W.hasData(a) && (f = W.access(a), g = W.set(b, f), j = f.events)) {
	        delete g.handle, g.events = {};for (e in j) {
	          for (c = 0, d = j[e].length; c < d; c++) {
	            r.event.add(b, e, j[e][c]);
	          }
	        }
	      }X.hasData(a) && (h = X.access(a), i = r.extend({}, h), X.set(b, i));
	    }
	  }function Ia(a, b) {
	    var c = b.nodeName.toLowerCase();"input" === c && ja.test(a.type) ? b.checked = a.checked : "input" !== c && "textarea" !== c || (b.defaultValue = a.defaultValue);
	  }function Ja(a, b, c, d) {
	    b = g.apply([], b);var e,
	        f,
	        h,
	        i,
	        j,
	        k,
	        l = 0,
	        m = a.length,
	        n = m - 1,
	        q = b[0],
	        s = r.isFunction(q);if (s || m > 1 && "string" == typeof q && !o.checkClone && Ba.test(q)) return a.each(function (e) {
	      var f = a.eq(e);s && (b[0] = q.call(this, e, f.html())), Ja(f, b, c, d);
	    });if (m && (e = qa(b, a[0].ownerDocument, !1, a, d), f = e.firstChild, 1 === e.childNodes.length && (e = f), f || d)) {
	      for (h = r.map(na(e, "script"), Fa), i = h.length; l < m; l++) {
	        j = e, l !== n && (j = r.clone(j, !0, !0), i && r.merge(h, na(j, "script"))), c.call(a[l], j, l);
	      }if (i) for (k = h[h.length - 1].ownerDocument, r.map(h, Ga), l = 0; l < i; l++) {
	        j = h[l], la.test(j.type || "") && !W.access(j, "globalEval") && r.contains(k, j) && (j.src ? r._evalUrl && r._evalUrl(j.src) : p(j.textContent.replace(Da, ""), k));
	      }
	    }return a;
	  }function Ka(a, b, c) {
	    for (var d, e = b ? r.filter(b, a) : a, f = 0; null != (d = e[f]); f++) {
	      c || 1 !== d.nodeType || r.cleanData(na(d)), d.parentNode && (c && r.contains(d.ownerDocument, d) && oa(na(d, "script")), d.parentNode.removeChild(d));
	    }return a;
	  }r.extend({ htmlPrefilter: function htmlPrefilter(a) {
	      return a.replace(za, "<$1></$2>");
	    }, clone: function clone(a, b, c) {
	      var d,
	          e,
	          f,
	          g,
	          h = a.cloneNode(!0),
	          i = r.contains(a.ownerDocument, a);if (!(o.noCloneChecked || 1 !== a.nodeType && 11 !== a.nodeType || r.isXMLDoc(a))) for (g = na(h), f = na(a), d = 0, e = f.length; d < e; d++) {
	        Ia(f[d], g[d]);
	      }if (b) if (c) for (f = f || na(a), g = g || na(h), d = 0, e = f.length; d < e; d++) {
	        Ha(f[d], g[d]);
	      } else Ha(a, h);return g = na(h, "script"), g.length > 0 && oa(g, !i && na(a, "script")), h;
	    }, cleanData: function cleanData(a) {
	      for (var b, c, d, e = r.event.special, f = 0; void 0 !== (c = a[f]); f++) {
	        if (U(c)) {
	          if (b = c[W.expando]) {
	            if (b.events) for (d in b.events) {
	              e[d] ? r.event.remove(c, d) : r.removeEvent(c, d, b.handle);
	            }c[W.expando] = void 0;
	          }c[X.expando] && (c[X.expando] = void 0);
	        }
	      }
	    } }), r.fn.extend({ detach: function detach(a) {
	      return Ka(this, a, !0);
	    }, remove: function remove(a) {
	      return Ka(this, a);
	    }, text: function text(a) {
	      return T(this, function (a) {
	        return void 0 === a ? r.text(this) : this.empty().each(function () {
	          1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = a);
	        });
	      }, null, a, arguments.length);
	    }, append: function append() {
	      return Ja(this, arguments, function (a) {
	        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
	          var b = Ea(this, a);b.appendChild(a);
	        }
	      });
	    }, prepend: function prepend() {
	      return Ja(this, arguments, function (a) {
	        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
	          var b = Ea(this, a);b.insertBefore(a, b.firstChild);
	        }
	      });
	    }, before: function before() {
	      return Ja(this, arguments, function (a) {
	        this.parentNode && this.parentNode.insertBefore(a, this);
	      });
	    }, after: function after() {
	      return Ja(this, arguments, function (a) {
	        this.parentNode && this.parentNode.insertBefore(a, this.nextSibling);
	      });
	    }, empty: function empty() {
	      for (var a, b = 0; null != (a = this[b]); b++) {
	        1 === a.nodeType && (r.cleanData(na(a, !1)), a.textContent = "");
	      }return this;
	    }, clone: function clone(a, b) {
	      return a = null != a && a, b = null == b ? a : b, this.map(function () {
	        return r.clone(this, a, b);
	      });
	    }, html: function html(a) {
	      return T(this, function (a) {
	        var b = this[0] || {},
	            c = 0,
	            d = this.length;if (void 0 === a && 1 === b.nodeType) return b.innerHTML;if ("string" == typeof a && !Aa.test(a) && !ma[(ka.exec(a) || ["", ""])[1].toLowerCase()]) {
	          a = r.htmlPrefilter(a);try {
	            for (; c < d; c++) {
	              b = this[c] || {}, 1 === b.nodeType && (r.cleanData(na(b, !1)), b.innerHTML = a);
	            }b = 0;
	          } catch (e) {}
	        }b && this.empty().append(a);
	      }, null, a, arguments.length);
	    }, replaceWith: function replaceWith() {
	      var a = [];return Ja(this, arguments, function (b) {
	        var c = this.parentNode;r.inArray(this, a) < 0 && (r.cleanData(na(this)), c && c.replaceChild(b, this));
	      }, a);
	    } }), r.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (a, b) {
	    r.fn[a] = function (a) {
	      for (var c, d = [], e = r(a), f = e.length - 1, g = 0; g <= f; g++) {
	        c = g === f ? this : this.clone(!0), r(e[g])[b](c), h.apply(d, c.get());
	      }return this.pushStack(d);
	    };
	  });var La = /^margin/,
	      Ma = new RegExp("^(" + aa + ")(?!px)[a-z%]+$", "i"),
	      Na = function Na(b) {
	    var c = b.ownerDocument.defaultView;return c && c.opener || (c = a), c.getComputedStyle(b);
	  };!function () {
	    function b() {
	      if (i) {
	        i.style.cssText = "box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%", i.innerHTML = "", ra.appendChild(h);var b = a.getComputedStyle(i);c = "1%" !== b.top, g = "2px" === b.marginLeft, e = "4px" === b.width, i.style.marginRight = "50%", f = "4px" === b.marginRight, ra.removeChild(h), i = null;
	      }
	    }var c,
	        e,
	        f,
	        g,
	        h = d.createElement("div"),
	        i = d.createElement("div");i.style && (i.style.backgroundClip = "content-box", i.cloneNode(!0).style.backgroundClip = "", o.clearCloneStyle = "content-box" === i.style.backgroundClip, h.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute", h.appendChild(i), r.extend(o, { pixelPosition: function pixelPosition() {
	        return b(), c;
	      }, boxSizingReliable: function boxSizingReliable() {
	        return b(), e;
	      }, pixelMarginRight: function pixelMarginRight() {
	        return b(), f;
	      }, reliableMarginLeft: function reliableMarginLeft() {
	        return b(), g;
	      } }));
	  }();function Oa(a, b, c) {
	    var d,
	        e,
	        f,
	        g,
	        h = a.style;return c = c || Na(a), c && (g = c.getPropertyValue(b) || c[b], "" !== g || r.contains(a.ownerDocument, a) || (g = r.style(a, b)), !o.pixelMarginRight() && Ma.test(g) && La.test(b) && (d = h.width, e = h.minWidth, f = h.maxWidth, h.minWidth = h.maxWidth = h.width = g, g = c.width, h.width = d, h.minWidth = e, h.maxWidth = f)), void 0 !== g ? g + "" : g;
	  }function Pa(a, b) {
	    return { get: function get() {
	        return a() ? void delete this.get : (this.get = b).apply(this, arguments);
	      } };
	  }var Qa = /^(none|table(?!-c[ea]).+)/,
	      Ra = /^--/,
	      Sa = { position: "absolute", visibility: "hidden", display: "block" },
	      Ta = { letterSpacing: "0", fontWeight: "400" },
	      Ua = ["Webkit", "Moz", "ms"],
	      Va = d.createElement("div").style;function Wa(a) {
	    if (a in Va) return a;var b = a[0].toUpperCase() + a.slice(1),
	        c = Ua.length;while (c--) {
	      if (a = Ua[c] + b, a in Va) return a;
	    }
	  }function Xa(a) {
	    var b = r.cssProps[a];return b || (b = r.cssProps[a] = Wa(a) || a), b;
	  }function Ya(a, b, c) {
	    var d = ba.exec(b);return d ? Math.max(0, d[2] - (c || 0)) + (d[3] || "px") : b;
	  }function Za(a, b, c, d, e) {
	    var f,
	        g = 0;for (f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0; f < 4; f += 2) {
	      "margin" === c && (g += r.css(a, c + ca[f], !0, e)), d ? ("content" === c && (g -= r.css(a, "padding" + ca[f], !0, e)), "margin" !== c && (g -= r.css(a, "border" + ca[f] + "Width", !0, e))) : (g += r.css(a, "padding" + ca[f], !0, e), "padding" !== c && (g += r.css(a, "border" + ca[f] + "Width", !0, e)));
	    }return g;
	  }function $a(a, b, c) {
	    var d,
	        e = Na(a),
	        f = Oa(a, b, e),
	        g = "border-box" === r.css(a, "boxSizing", !1, e);return Ma.test(f) ? f : (d = g && (o.boxSizingReliable() || f === a.style[b]), "auto" === f && (f = a["offset" + b[0].toUpperCase() + b.slice(1)]), f = parseFloat(f) || 0, f + Za(a, b, c || (g ? "border" : "content"), d, e) + "px");
	  }r.extend({ cssHooks: { opacity: { get: function get(a, b) {
	          if (b) {
	            var c = Oa(a, "opacity");return "" === c ? "1" : c;
	          }
	        } } }, cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 }, cssProps: { "float": "cssFloat" }, style: function style(a, b, c, d) {
	      if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
	        var e,
	            f,
	            g,
	            h = r.camelCase(b),
	            i = Ra.test(b),
	            j = a.style;return i || (b = Xa(h)), g = r.cssHooks[b] || r.cssHooks[h], void 0 === c ? g && "get" in g && void 0 !== (e = g.get(a, !1, d)) ? e : j[b] : (f = typeof c === "undefined" ? "undefined" : _typeof(c), "string" === f && (e = ba.exec(c)) && e[1] && (c = fa(a, b, e), f = "number"), null != c && c === c && ("number" === f && (c += e && e[3] || (r.cssNumber[h] ? "" : "px")), o.clearCloneStyle || "" !== c || 0 !== b.indexOf("background") || (j[b] = "inherit"), g && "set" in g && void 0 === (c = g.set(a, c, d)) || (i ? j.setProperty(b, c) : j[b] = c)), void 0);
	      }
	    }, css: function css(a, b, c, d) {
	      var e,
	          f,
	          g,
	          h = r.camelCase(b),
	          i = Ra.test(b);return i || (b = Xa(h)), g = r.cssHooks[b] || r.cssHooks[h], g && "get" in g && (e = g.get(a, !0, c)), void 0 === e && (e = Oa(a, b, d)), "normal" === e && b in Ta && (e = Ta[b]), "" === c || c ? (f = parseFloat(e), c === !0 || isFinite(f) ? f || 0 : e) : e;
	    } }), r.each(["height", "width"], function (a, b) {
	    r.cssHooks[b] = { get: function get(a, c, d) {
	        if (c) return !Qa.test(r.css(a, "display")) || a.getClientRects().length && a.getBoundingClientRect().width ? $a(a, b, d) : ea(a, Sa, function () {
	          return $a(a, b, d);
	        });
	      }, set: function set(a, c, d) {
	        var e,
	            f = d && Na(a),
	            g = d && Za(a, b, d, "border-box" === r.css(a, "boxSizing", !1, f), f);return g && (e = ba.exec(c)) && "px" !== (e[3] || "px") && (a.style[b] = c, c = r.css(a, b)), Ya(a, c, g);
	      } };
	  }), r.cssHooks.marginLeft = Pa(o.reliableMarginLeft, function (a, b) {
	    if (b) return (parseFloat(Oa(a, "marginLeft")) || a.getBoundingClientRect().left - ea(a, { marginLeft: 0 }, function () {
	      return a.getBoundingClientRect().left;
	    })) + "px";
	  }), r.each({ margin: "", padding: "", border: "Width" }, function (a, b) {
	    r.cssHooks[a + b] = { expand: function expand(c) {
	        for (var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c]; d < 4; d++) {
	          e[a + ca[d] + b] = f[d] || f[d - 2] || f[0];
	        }return e;
	      } }, La.test(a) || (r.cssHooks[a + b].set = Ya);
	  }), r.fn.extend({ css: function css(a, b) {
	      return T(this, function (a, b, c) {
	        var d,
	            e,
	            f = {},
	            g = 0;if (Array.isArray(b)) {
	          for (d = Na(a), e = b.length; g < e; g++) {
	            f[b[g]] = r.css(a, b[g], !1, d);
	          }return f;
	        }return void 0 !== c ? r.style(a, b, c) : r.css(a, b);
	      }, a, b, arguments.length > 1);
	    } });function _a(a, b, c, d, e) {
	    return new _a.prototype.init(a, b, c, d, e);
	  }r.Tween = _a, _a.prototype = { constructor: _a, init: function init(a, b, c, d, e, f) {
	      this.elem = a, this.prop = c, this.easing = e || r.easing._default, this.options = b, this.start = this.now = this.cur(), this.end = d, this.unit = f || (r.cssNumber[c] ? "" : "px");
	    }, cur: function cur() {
	      var a = _a.propHooks[this.prop];return a && a.get ? a.get(this) : _a.propHooks._default.get(this);
	    }, run: function run(a) {
	      var b,
	          c = _a.propHooks[this.prop];return this.options.duration ? this.pos = b = r.easing[this.easing](a, this.options.duration * a, 0, 1, this.options.duration) : this.pos = b = a, this.now = (this.end - this.start) * b + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), c && c.set ? c.set(this) : _a.propHooks._default.set(this), this;
	    } }, _a.prototype.init.prototype = _a.prototype, _a.propHooks = { _default: { get: function get(a) {
	        var b;return 1 !== a.elem.nodeType || null != a.elem[a.prop] && null == a.elem.style[a.prop] ? a.elem[a.prop] : (b = r.css(a.elem, a.prop, ""), b && "auto" !== b ? b : 0);
	      }, set: function set(a) {
	        r.fx.step[a.prop] ? r.fx.step[a.prop](a) : 1 !== a.elem.nodeType || null == a.elem.style[r.cssProps[a.prop]] && !r.cssHooks[a.prop] ? a.elem[a.prop] = a.now : r.style(a.elem, a.prop, a.now + a.unit);
	      } } }, _a.propHooks.scrollTop = _a.propHooks.scrollLeft = { set: function set(a) {
	      a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now);
	    } }, r.easing = { linear: function linear(a) {
	      return a;
	    }, swing: function swing(a) {
	      return .5 - Math.cos(a * Math.PI) / 2;
	    }, _default: "swing" }, r.fx = _a.prototype.init, r.fx.step = {};var ab,
	      bb,
	      cb = /^(?:toggle|show|hide)$/,
	      db = /queueHooks$/;function eb() {
	    bb && (d.hidden === !1 && a.requestAnimationFrame ? a.requestAnimationFrame(eb) : a.setTimeout(eb, r.fx.interval), r.fx.tick());
	  }function fb() {
	    return a.setTimeout(function () {
	      ab = void 0;
	    }), ab = r.now();
	  }function gb(a, b) {
	    var c,
	        d = 0,
	        e = { height: a };for (b = b ? 1 : 0; d < 4; d += 2 - b) {
	      c = ca[d], e["margin" + c] = e["padding" + c] = a;
	    }return b && (e.opacity = e.width = a), e;
	  }function hb(a, b, c) {
	    for (var d, e = (kb.tweeners[b] || []).concat(kb.tweeners["*"]), f = 0, g = e.length; f < g; f++) {
	      if (d = e[f].call(c, b, a)) return d;
	    }
	  }function ib(a, b, c) {
	    var d,
	        e,
	        f,
	        g,
	        h,
	        i,
	        j,
	        k,
	        l = "width" in b || "height" in b,
	        m = this,
	        n = {},
	        o = a.style,
	        p = a.nodeType && da(a),
	        q = W.get(a, "fxshow");c.queue || (g = r._queueHooks(a, "fx"), null == g.unqueued && (g.unqueued = 0, h = g.empty.fire, g.empty.fire = function () {
	      g.unqueued || h();
	    }), g.unqueued++, m.always(function () {
	      m.always(function () {
	        g.unqueued--, r.queue(a, "fx").length || g.empty.fire();
	      });
	    }));for (d in b) {
	      if (e = b[d], cb.test(e)) {
	        if (delete b[d], f = f || "toggle" === e, e === (p ? "hide" : "show")) {
	          if ("show" !== e || !q || void 0 === q[d]) continue;p = !0;
	        }n[d] = q && q[d] || r.style(a, d);
	      }
	    }if (i = !r.isEmptyObject(b), i || !r.isEmptyObject(n)) {
	      l && 1 === a.nodeType && (c.overflow = [o.overflow, o.overflowX, o.overflowY], j = q && q.display, null == j && (j = W.get(a, "display")), k = r.css(a, "display"), "none" === k && (j ? k = j : (ia([a], !0), j = a.style.display || j, k = r.css(a, "display"), ia([a]))), ("inline" === k || "inline-block" === k && null != j) && "none" === r.css(a, "float") && (i || (m.done(function () {
	        o.display = j;
	      }), null == j && (k = o.display, j = "none" === k ? "" : k)), o.display = "inline-block")), c.overflow && (o.overflow = "hidden", m.always(function () {
	        o.overflow = c.overflow[0], o.overflowX = c.overflow[1], o.overflowY = c.overflow[2];
	      })), i = !1;for (d in n) {
	        i || (q ? "hidden" in q && (p = q.hidden) : q = W.access(a, "fxshow", { display: j }), f && (q.hidden = !p), p && ia([a], !0), m.done(function () {
	          p || ia([a]), W.remove(a, "fxshow");for (d in n) {
	            r.style(a, d, n[d]);
	          }
	        })), i = hb(p ? q[d] : 0, d, m), d in q || (q[d] = i.start, p && (i.end = i.start, i.start = 0));
	      }
	    }
	  }function jb(a, b) {
	    var c, d, e, f, g;for (c in a) {
	      if (d = r.camelCase(c), e = b[d], f = a[c], Array.isArray(f) && (e = f[1], f = a[c] = f[0]), c !== d && (a[d] = f, delete a[c]), g = r.cssHooks[d], g && "expand" in g) {
	        f = g.expand(f), delete a[d];for (c in f) {
	          c in a || (a[c] = f[c], b[c] = e);
	        }
	      } else b[d] = e;
	    }
	  }function kb(a, b, c) {
	    var d,
	        e,
	        f = 0,
	        g = kb.prefilters.length,
	        h = r.Deferred().always(function () {
	      delete i.elem;
	    }),
	        i = function i() {
	      if (e) return !1;for (var b = ab || fb(), c = Math.max(0, j.startTime + j.duration - b), d = c / j.duration || 0, f = 1 - d, g = 0, i = j.tweens.length; g < i; g++) {
	        j.tweens[g].run(f);
	      }return h.notifyWith(a, [j, f, c]), f < 1 && i ? c : (i || h.notifyWith(a, [j, 1, 0]), h.resolveWith(a, [j]), !1);
	    },
	        j = h.promise({ elem: a, props: r.extend({}, b), opts: r.extend(!0, { specialEasing: {}, easing: r.easing._default }, c), originalProperties: b, originalOptions: c, startTime: ab || fb(), duration: c.duration, tweens: [], createTween: function createTween(b, c) {
	        var d = r.Tween(a, j.opts, b, c, j.opts.specialEasing[b] || j.opts.easing);return j.tweens.push(d), d;
	      }, stop: function stop(b) {
	        var c = 0,
	            d = b ? j.tweens.length : 0;if (e) return this;for (e = !0; c < d; c++) {
	          j.tweens[c].run(1);
	        }return b ? (h.notifyWith(a, [j, 1, 0]), h.resolveWith(a, [j, b])) : h.rejectWith(a, [j, b]), this;
	      } }),
	        k = j.props;for (jb(k, j.opts.specialEasing); f < g; f++) {
	      if (d = kb.prefilters[f].call(j, a, k, j.opts)) return r.isFunction(d.stop) && (r._queueHooks(j.elem, j.opts.queue).stop = r.proxy(d.stop, d)), d;
	    }return r.map(k, hb, j), r.isFunction(j.opts.start) && j.opts.start.call(a, j), j.progress(j.opts.progress).done(j.opts.done, j.opts.complete).fail(j.opts.fail).always(j.opts.always), r.fx.timer(r.extend(i, { elem: a, anim: j, queue: j.opts.queue })), j;
	  }r.Animation = r.extend(kb, { tweeners: { "*": [function (a, b) {
	        var c = this.createTween(a, b);return fa(c.elem, a, ba.exec(b), c), c;
	      }] }, tweener: function tweener(a, b) {
	      r.isFunction(a) ? (b = a, a = ["*"]) : a = a.match(L);for (var c, d = 0, e = a.length; d < e; d++) {
	        c = a[d], kb.tweeners[c] = kb.tweeners[c] || [], kb.tweeners[c].unshift(b);
	      }
	    }, prefilters: [ib], prefilter: function prefilter(a, b) {
	      b ? kb.prefilters.unshift(a) : kb.prefilters.push(a);
	    } }), r.speed = function (a, b, c) {
	    var d = a && "object" == (typeof a === "undefined" ? "undefined" : _typeof(a)) ? r.extend({}, a) : { complete: c || !c && b || r.isFunction(a) && a, duration: a, easing: c && b || b && !r.isFunction(b) && b };return r.fx.off ? d.duration = 0 : "number" != typeof d.duration && (d.duration in r.fx.speeds ? d.duration = r.fx.speeds[d.duration] : d.duration = r.fx.speeds._default), null != d.queue && d.queue !== !0 || (d.queue = "fx"), d.old = d.complete, d.complete = function () {
	      r.isFunction(d.old) && d.old.call(this), d.queue && r.dequeue(this, d.queue);
	    }, d;
	  }, r.fn.extend({ fadeTo: function fadeTo(a, b, c, d) {
	      return this.filter(da).css("opacity", 0).show().end().animate({ opacity: b }, a, c, d);
	    }, animate: function animate(a, b, c, d) {
	      var e = r.isEmptyObject(a),
	          f = r.speed(b, c, d),
	          g = function g() {
	        var b = kb(this, r.extend({}, a), f);(e || W.get(this, "finish")) && b.stop(!0);
	      };return g.finish = g, e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g);
	    }, stop: function stop(a, b, c) {
	      var d = function d(a) {
	        var b = a.stop;delete a.stop, b(c);
	      };return "string" != typeof a && (c = b, b = a, a = void 0), b && a !== !1 && this.queue(a || "fx", []), this.each(function () {
	        var b = !0,
	            e = null != a && a + "queueHooks",
	            f = r.timers,
	            g = W.get(this);if (e) g[e] && g[e].stop && d(g[e]);else for (e in g) {
	          g[e] && g[e].stop && db.test(e) && d(g[e]);
	        }for (e = f.length; e--;) {
	          f[e].elem !== this || null != a && f[e].queue !== a || (f[e].anim.stop(c), b = !1, f.splice(e, 1));
	        }!b && c || r.dequeue(this, a);
	      });
	    }, finish: function finish(a) {
	      return a !== !1 && (a = a || "fx"), this.each(function () {
	        var b,
	            c = W.get(this),
	            d = c[a + "queue"],
	            e = c[a + "queueHooks"],
	            f = r.timers,
	            g = d ? d.length : 0;for (c.finish = !0, r.queue(this, a, []), e && e.stop && e.stop.call(this, !0), b = f.length; b--;) {
	          f[b].elem === this && f[b].queue === a && (f[b].anim.stop(!0), f.splice(b, 1));
	        }for (b = 0; b < g; b++) {
	          d[b] && d[b].finish && d[b].finish.call(this);
	        }delete c.finish;
	      });
	    } }), r.each(["toggle", "show", "hide"], function (a, b) {
	    var c = r.fn[b];r.fn[b] = function (a, d, e) {
	      return null == a || "boolean" == typeof a ? c.apply(this, arguments) : this.animate(gb(b, !0), a, d, e);
	    };
	  }), r.each({ slideDown: gb("show"), slideUp: gb("hide"), slideToggle: gb("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (a, b) {
	    r.fn[a] = function (a, c, d) {
	      return this.animate(b, a, c, d);
	    };
	  }), r.timers = [], r.fx.tick = function () {
	    var a,
	        b = 0,
	        c = r.timers;for (ab = r.now(); b < c.length; b++) {
	      a = c[b], a() || c[b] !== a || c.splice(b--, 1);
	    }c.length || r.fx.stop(), ab = void 0;
	  }, r.fx.timer = function (a) {
	    r.timers.push(a), r.fx.start();
	  }, r.fx.interval = 13, r.fx.start = function () {
	    bb || (bb = !0, eb());
	  }, r.fx.stop = function () {
	    bb = null;
	  }, r.fx.speeds = { slow: 600, fast: 200, _default: 400 }, r.fn.delay = function (b, c) {
	    return b = r.fx ? r.fx.speeds[b] || b : b, c = c || "fx", this.queue(c, function (c, d) {
	      var e = a.setTimeout(c, b);d.stop = function () {
	        a.clearTimeout(e);
	      };
	    });
	  }, function () {
	    var a = d.createElement("input"),
	        b = d.createElement("select"),
	        c = b.appendChild(d.createElement("option"));a.type = "checkbox", o.checkOn = "" !== a.value, o.optSelected = c.selected, a = d.createElement("input"), a.value = "t", a.type = "radio", o.radioValue = "t" === a.value;
	  }();var lb,
	      mb = r.expr.attrHandle;r.fn.extend({ attr: function attr(a, b) {
	      return T(this, r.attr, a, b, arguments.length > 1);
	    }, removeAttr: function removeAttr(a) {
	      return this.each(function () {
	        r.removeAttr(this, a);
	      });
	    } }), r.extend({ attr: function attr(a, b, c) {
	      var d,
	          e,
	          f = a.nodeType;if (3 !== f && 8 !== f && 2 !== f) return "undefined" == typeof a.getAttribute ? r.prop(a, b, c) : (1 === f && r.isXMLDoc(a) || (e = r.attrHooks[b.toLowerCase()] || (r.expr.match.bool.test(b) ? lb : void 0)), void 0 !== c ? null === c ? void r.removeAttr(a, b) : e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : (a.setAttribute(b, c + ""), c) : e && "get" in e && null !== (d = e.get(a, b)) ? d : (d = r.find.attr(a, b), null == d ? void 0 : d));
	    }, attrHooks: { type: { set: function set(a, b) {
	          if (!o.radioValue && "radio" === b && B(a, "input")) {
	            var c = a.value;return a.setAttribute("type", b), c && (a.value = c), b;
	          }
	        } } }, removeAttr: function removeAttr(a, b) {
	      var c,
	          d = 0,
	          e = b && b.match(L);if (e && 1 === a.nodeType) while (c = e[d++]) {
	        a.removeAttribute(c);
	      }
	    } }), lb = { set: function set(a, b, c) {
	      return b === !1 ? r.removeAttr(a, c) : a.setAttribute(c, c), c;
	    } }, r.each(r.expr.match.bool.source.match(/\w+/g), function (a, b) {
	    var c = mb[b] || r.find.attr;mb[b] = function (a, b, d) {
	      var e,
	          f,
	          g = b.toLowerCase();return d || (f = mb[g], mb[g] = e, e = null != c(a, b, d) ? g : null, mb[g] = f), e;
	    };
	  });var nb = /^(?:input|select|textarea|button)$/i,
	      ob = /^(?:a|area)$/i;r.fn.extend({ prop: function prop(a, b) {
	      return T(this, r.prop, a, b, arguments.length > 1);
	    }, removeProp: function removeProp(a) {
	      return this.each(function () {
	        delete this[r.propFix[a] || a];
	      });
	    } }), r.extend({ prop: function prop(a, b, c) {
	      var d,
	          e,
	          f = a.nodeType;if (3 !== f && 8 !== f && 2 !== f) return 1 === f && r.isXMLDoc(a) || (b = r.propFix[b] || b, e = r.propHooks[b]), void 0 !== c ? e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : a[b] = c : e && "get" in e && null !== (d = e.get(a, b)) ? d : a[b];
	    }, propHooks: { tabIndex: { get: function get(a) {
	          var b = r.find.attr(a, "tabindex");return b ? parseInt(b, 10) : nb.test(a.nodeName) || ob.test(a.nodeName) && a.href ? 0 : -1;
	        } } }, propFix: { "for": "htmlFor", "class": "className" } }), o.optSelected || (r.propHooks.selected = { get: function get(a) {
	      var b = a.parentNode;return b && b.parentNode && b.parentNode.selectedIndex, null;
	    }, set: function set(a) {
	      var b = a.parentNode;b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex);
	    } }), r.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
	    r.propFix[this.toLowerCase()] = this;
	  });function pb(a) {
	    var b = a.match(L) || [];return b.join(" ");
	  }function qb(a) {
	    return a.getAttribute && a.getAttribute("class") || "";
	  }r.fn.extend({ addClass: function addClass(a) {
	      var b,
	          c,
	          d,
	          e,
	          f,
	          g,
	          h,
	          i = 0;if (r.isFunction(a)) return this.each(function (b) {
	        r(this).addClass(a.call(this, b, qb(this)));
	      });if ("string" == typeof a && a) {
	        b = a.match(L) || [];while (c = this[i++]) {
	          if (e = qb(c), d = 1 === c.nodeType && " " + pb(e) + " ") {
	            g = 0;while (f = b[g++]) {
	              d.indexOf(" " + f + " ") < 0 && (d += f + " ");
	            }h = pb(d), e !== h && c.setAttribute("class", h);
	          }
	        }
	      }return this;
	    }, removeClass: function removeClass(a) {
	      var b,
	          c,
	          d,
	          e,
	          f,
	          g,
	          h,
	          i = 0;if (r.isFunction(a)) return this.each(function (b) {
	        r(this).removeClass(a.call(this, b, qb(this)));
	      });if (!arguments.length) return this.attr("class", "");if ("string" == typeof a && a) {
	        b = a.match(L) || [];while (c = this[i++]) {
	          if (e = qb(c), d = 1 === c.nodeType && " " + pb(e) + " ") {
	            g = 0;while (f = b[g++]) {
	              while (d.indexOf(" " + f + " ") > -1) {
	                d = d.replace(" " + f + " ", " ");
	              }
	            }h = pb(d), e !== h && c.setAttribute("class", h);
	          }
	        }
	      }return this;
	    }, toggleClass: function toggleClass(a, b) {
	      var c = typeof a === "undefined" ? "undefined" : _typeof(a);return "boolean" == typeof b && "string" === c ? b ? this.addClass(a) : this.removeClass(a) : r.isFunction(a) ? this.each(function (c) {
	        r(this).toggleClass(a.call(this, c, qb(this), b), b);
	      }) : this.each(function () {
	        var b, d, e, f;if ("string" === c) {
	          d = 0, e = r(this), f = a.match(L) || [];while (b = f[d++]) {
	            e.hasClass(b) ? e.removeClass(b) : e.addClass(b);
	          }
	        } else void 0 !== a && "boolean" !== c || (b = qb(this), b && W.set(this, "__className__", b), this.setAttribute && this.setAttribute("class", b || a === !1 ? "" : W.get(this, "__className__") || ""));
	      });
	    }, hasClass: function hasClass(a) {
	      var b,
	          c,
	          d = 0;b = " " + a + " ";while (c = this[d++]) {
	        if (1 === c.nodeType && (" " + pb(qb(c)) + " ").indexOf(b) > -1) return !0;
	      }return !1;
	    } });var rb = /\r/g;r.fn.extend({ val: function val(a) {
	      var b,
	          c,
	          d,
	          e = this[0];{
	        if (arguments.length) return d = r.isFunction(a), this.each(function (c) {
	          var e;1 === this.nodeType && (e = d ? a.call(this, c, r(this).val()) : a, null == e ? e = "" : "number" == typeof e ? e += "" : Array.isArray(e) && (e = r.map(e, function (a) {
	            return null == a ? "" : a + "";
	          })), b = r.valHooks[this.type] || r.valHooks[this.nodeName.toLowerCase()], b && "set" in b && void 0 !== b.set(this, e, "value") || (this.value = e));
	        });if (e) return b = r.valHooks[e.type] || r.valHooks[e.nodeName.toLowerCase()], b && "get" in b && void 0 !== (c = b.get(e, "value")) ? c : (c = e.value, "string" == typeof c ? c.replace(rb, "") : null == c ? "" : c);
	      }
	    } }), r.extend({ valHooks: { option: { get: function get(a) {
	          var b = r.find.attr(a, "value");return null != b ? b : pb(r.text(a));
	        } }, select: { get: function get(a) {
	          var b,
	              c,
	              d,
	              e = a.options,
	              f = a.selectedIndex,
	              g = "select-one" === a.type,
	              h = g ? null : [],
	              i = g ? f + 1 : e.length;for (d = f < 0 ? i : g ? f : 0; d < i; d++) {
	            if (c = e[d], (c.selected || d === f) && !c.disabled && (!c.parentNode.disabled || !B(c.parentNode, "optgroup"))) {
	              if (b = r(c).val(), g) return b;h.push(b);
	            }
	          }return h;
	        }, set: function set(a, b) {
	          var c,
	              d,
	              e = a.options,
	              f = r.makeArray(b),
	              g = e.length;while (g--) {
	            d = e[g], (d.selected = r.inArray(r.valHooks.option.get(d), f) > -1) && (c = !0);
	          }return c || (a.selectedIndex = -1), f;
	        } } } }), r.each(["radio", "checkbox"], function () {
	    r.valHooks[this] = { set: function set(a, b) {
	        if (Array.isArray(b)) return a.checked = r.inArray(r(a).val(), b) > -1;
	      } }, o.checkOn || (r.valHooks[this].get = function (a) {
	      return null === a.getAttribute("value") ? "on" : a.value;
	    });
	  });var sb = /^(?:focusinfocus|focusoutblur)$/;r.extend(r.event, { trigger: function trigger(b, c, e, f) {
	      var g,
	          h,
	          i,
	          j,
	          k,
	          m,
	          n,
	          o = [e || d],
	          p = l.call(b, "type") ? b.type : b,
	          q = l.call(b, "namespace") ? b.namespace.split(".") : [];if (h = i = e = e || d, 3 !== e.nodeType && 8 !== e.nodeType && !sb.test(p + r.event.triggered) && (p.indexOf(".") > -1 && (q = p.split("."), p = q.shift(), q.sort()), k = p.indexOf(":") < 0 && "on" + p, b = b[r.expando] ? b : new r.Event(p, "object" == (typeof b === "undefined" ? "undefined" : _typeof(b)) && b), b.isTrigger = f ? 2 : 3, b.namespace = q.join("."), b.rnamespace = b.namespace ? new RegExp("(^|\\.)" + q.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, b.result = void 0, b.target || (b.target = e), c = null == c ? [b] : r.makeArray(c, [b]), n = r.event.special[p] || {}, f || !n.trigger || n.trigger.apply(e, c) !== !1)) {
	        if (!f && !n.noBubble && !r.isWindow(e)) {
	          for (j = n.delegateType || p, sb.test(j + p) || (h = h.parentNode); h; h = h.parentNode) {
	            o.push(h), i = h;
	          }i === (e.ownerDocument || d) && o.push(i.defaultView || i.parentWindow || a);
	        }g = 0;while ((h = o[g++]) && !b.isPropagationStopped()) {
	          b.type = g > 1 ? j : n.bindType || p, m = (W.get(h, "events") || {})[b.type] && W.get(h, "handle"), m && m.apply(h, c), m = k && h[k], m && m.apply && U(h) && (b.result = m.apply(h, c), b.result === !1 && b.preventDefault());
	        }return b.type = p, f || b.isDefaultPrevented() || n._default && n._default.apply(o.pop(), c) !== !1 || !U(e) || k && r.isFunction(e[p]) && !r.isWindow(e) && (i = e[k], i && (e[k] = null), r.event.triggered = p, e[p](), r.event.triggered = void 0, i && (e[k] = i)), b.result;
	      }
	    }, simulate: function simulate(a, b, c) {
	      var d = r.extend(new r.Event(), c, { type: a, isSimulated: !0 });r.event.trigger(d, null, b);
	    } }), r.fn.extend({ trigger: function trigger(a, b) {
	      return this.each(function () {
	        r.event.trigger(a, b, this);
	      });
	    }, triggerHandler: function triggerHandler(a, b) {
	      var c = this[0];if (c) return r.event.trigger(a, b, c, !0);
	    } }), r.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (a, b) {
	    r.fn[b] = function (a, c) {
	      return arguments.length > 0 ? this.on(b, null, a, c) : this.trigger(b);
	    };
	  }), r.fn.extend({ hover: function hover(a, b) {
	      return this.mouseenter(a).mouseleave(b || a);
	    } }), o.focusin = "onfocusin" in a, o.focusin || r.each({ focus: "focusin", blur: "focusout" }, function (a, b) {
	    var c = function c(a) {
	      r.event.simulate(b, a.target, r.event.fix(a));
	    };r.event.special[b] = { setup: function setup() {
	        var d = this.ownerDocument || this,
	            e = W.access(d, b);e || d.addEventListener(a, c, !0), W.access(d, b, (e || 0) + 1);
	      }, teardown: function teardown() {
	        var d = this.ownerDocument || this,
	            e = W.access(d, b) - 1;e ? W.access(d, b, e) : (d.removeEventListener(a, c, !0), W.remove(d, b));
	      } };
	  });var tb = a.location,
	      ub = r.now(),
	      vb = /\?/;r.parseXML = function (b) {
	    var c;if (!b || "string" != typeof b) return null;try {
	      c = new a.DOMParser().parseFromString(b, "text/xml");
	    } catch (d) {
	      c = void 0;
	    }return c && !c.getElementsByTagName("parsererror").length || r.error("Invalid XML: " + b), c;
	  };var wb = /\[\]$/,
	      xb = /\r?\n/g,
	      yb = /^(?:submit|button|image|reset|file)$/i,
	      zb = /^(?:input|select|textarea|keygen)/i;function Ab(a, b, c, d) {
	    var e;if (Array.isArray(b)) r.each(b, function (b, e) {
	      c || wb.test(a) ? d(a, e) : Ab(a + "[" + ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && null != e ? b : "") + "]", e, c, d);
	    });else if (c || "object" !== r.type(b)) d(a, b);else for (e in b) {
	      Ab(a + "[" + e + "]", b[e], c, d);
	    }
	  }r.param = function (a, b) {
	    var c,
	        d = [],
	        e = function e(a, b) {
	      var c = r.isFunction(b) ? b() : b;d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(null == c ? "" : c);
	    };if (Array.isArray(a) || a.jquery && !r.isPlainObject(a)) r.each(a, function () {
	      e(this.name, this.value);
	    });else for (c in a) {
	      Ab(c, a[c], b, e);
	    }return d.join("&");
	  }, r.fn.extend({ serialize: function serialize() {
	      return r.param(this.serializeArray());
	    }, serializeArray: function serializeArray() {
	      return this.map(function () {
	        var a = r.prop(this, "elements");return a ? r.makeArray(a) : this;
	      }).filter(function () {
	        var a = this.type;return this.name && !r(this).is(":disabled") && zb.test(this.nodeName) && !yb.test(a) && (this.checked || !ja.test(a));
	      }).map(function (a, b) {
	        var c = r(this).val();return null == c ? null : Array.isArray(c) ? r.map(c, function (a) {
	          return { name: b.name, value: a.replace(xb, "\r\n") };
	        }) : { name: b.name, value: c.replace(xb, "\r\n") };
	      }).get();
	    } });var Bb = /%20/g,
	      Cb = /#.*$/,
	      Db = /([?&])_=[^&]*/,
	      Eb = /^(.*?):[ \t]*([^\r\n]*)$/gm,
	      Fb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	      Gb = /^(?:GET|HEAD)$/,
	      Hb = /^\/\//,
	      Ib = {},
	      Jb = {},
	      Kb = "*/".concat("*"),
	      Lb = d.createElement("a");Lb.href = tb.href;function Mb(a) {
	    return function (b, c) {
	      "string" != typeof b && (c = b, b = "*");var d,
	          e = 0,
	          f = b.toLowerCase().match(L) || [];if (r.isFunction(c)) while (d = f[e++]) {
	        "+" === d[0] ? (d = d.slice(1) || "*", (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c);
	      }
	    };
	  }function Nb(a, b, c, d) {
	    var e = {},
	        f = a === Jb;function g(h) {
	      var i;return e[h] = !0, r.each(a[h] || [], function (a, h) {
	        var j = h(b, c, d);return "string" != typeof j || f || e[j] ? f ? !(i = j) : void 0 : (b.dataTypes.unshift(j), g(j), !1);
	      }), i;
	    }return g(b.dataTypes[0]) || !e["*"] && g("*");
	  }function Ob(a, b) {
	    var c,
	        d,
	        e = r.ajaxSettings.flatOptions || {};for (c in b) {
	      void 0 !== b[c] && ((e[c] ? a : d || (d = {}))[c] = b[c]);
	    }return d && r.extend(!0, a, d), a;
	  }function Pb(a, b, c) {
	    var d,
	        e,
	        f,
	        g,
	        h = a.contents,
	        i = a.dataTypes;while ("*" === i[0]) {
	      i.shift(), void 0 === d && (d = a.mimeType || b.getResponseHeader("Content-Type"));
	    }if (d) for (e in h) {
	      if (h[e] && h[e].test(d)) {
	        i.unshift(e);break;
	      }
	    }if (i[0] in c) f = i[0];else {
	      for (e in c) {
	        if (!i[0] || a.converters[e + " " + i[0]]) {
	          f = e;break;
	        }g || (g = e);
	      }f = f || g;
	    }if (f) return f !== i[0] && i.unshift(f), c[f];
	  }function Qb(a, b, c, d) {
	    var e,
	        f,
	        g,
	        h,
	        i,
	        j = {},
	        k = a.dataTypes.slice();if (k[1]) for (g in a.converters) {
	      j[g.toLowerCase()] = a.converters[g];
	    }f = k.shift();while (f) {
	      if (a.responseFields[f] && (c[a.responseFields[f]] = b), !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)), i = f, f = k.shift()) if ("*" === f) f = i;else if ("*" !== i && i !== f) {
	        if (g = j[i + " " + f] || j["* " + f], !g) for (e in j) {
	          if (h = e.split(" "), h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]])) {
	            g === !0 ? g = j[e] : j[e] !== !0 && (f = h[0], k.unshift(h[1]));break;
	          }
	        }if (g !== !0) if (g && a["throws"]) b = g(b);else try {
	          b = g(b);
	        } catch (l) {
	          return { state: "parsererror", error: g ? l : "No conversion from " + i + " to " + f };
	        }
	      }
	    }return { state: "success", data: b };
	  }r.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: tb.href, type: "GET", isLocal: Fb.test(tb.protocol), global: !0, processData: !0, async: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": Kb, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": r.parseXML }, flatOptions: { url: !0, context: !0 } }, ajaxSetup: function ajaxSetup(a, b) {
	      return b ? Ob(Ob(a, r.ajaxSettings), b) : Ob(r.ajaxSettings, a);
	    }, ajaxPrefilter: Mb(Ib), ajaxTransport: Mb(Jb), ajax: function ajax(b, c) {
	      "object" == (typeof b === "undefined" ? "undefined" : _typeof(b)) && (c = b, b = void 0), c = c || {};var e,
	          f,
	          g,
	          h,
	          i,
	          j,
	          k,
	          l,
	          m,
	          n,
	          o = r.ajaxSetup({}, c),
	          p = o.context || o,
	          q = o.context && (p.nodeType || p.jquery) ? r(p) : r.event,
	          s = r.Deferred(),
	          t = r.Callbacks("once memory"),
	          u = o.statusCode || {},
	          v = {},
	          w = {},
	          x = "canceled",
	          y = { readyState: 0, getResponseHeader: function getResponseHeader(a) {
	          var b;if (k) {
	            if (!h) {
	              h = {};while (b = Eb.exec(g)) {
	                h[b[1].toLowerCase()] = b[2];
	              }
	            }b = h[a.toLowerCase()];
	          }return null == b ? null : b;
	        }, getAllResponseHeaders: function getAllResponseHeaders() {
	          return k ? g : null;
	        }, setRequestHeader: function setRequestHeader(a, b) {
	          return null == k && (a = w[a.toLowerCase()] = w[a.toLowerCase()] || a, v[a] = b), this;
	        }, overrideMimeType: function overrideMimeType(a) {
	          return null == k && (o.mimeType = a), this;
	        }, statusCode: function statusCode(a) {
	          var b;if (a) if (k) y.always(a[y.status]);else for (b in a) {
	            u[b] = [u[b], a[b]];
	          }return this;
	        }, abort: function abort(a) {
	          var b = a || x;return e && e.abort(b), A(0, b), this;
	        } };if (s.promise(y), o.url = ((b || o.url || tb.href) + "").replace(Hb, tb.protocol + "//"), o.type = c.method || c.type || o.method || o.type, o.dataTypes = (o.dataType || "*").toLowerCase().match(L) || [""], null == o.crossDomain) {
	        j = d.createElement("a");try {
	          j.href = o.url, j.href = j.href, o.crossDomain = Lb.protocol + "//" + Lb.host != j.protocol + "//" + j.host;
	        } catch (z) {
	          o.crossDomain = !0;
	        }
	      }if (o.data && o.processData && "string" != typeof o.data && (o.data = r.param(o.data, o.traditional)), Nb(Ib, o, c, y), k) return y;l = r.event && o.global, l && 0 === r.active++ && r.event.trigger("ajaxStart"), o.type = o.type.toUpperCase(), o.hasContent = !Gb.test(o.type), f = o.url.replace(Cb, ""), o.hasContent ? o.data && o.processData && 0 === (o.contentType || "").indexOf("application/x-www-form-urlencoded") && (o.data = o.data.replace(Bb, "+")) : (n = o.url.slice(f.length), o.data && (f += (vb.test(f) ? "&" : "?") + o.data, delete o.data), o.cache === !1 && (f = f.replace(Db, "$1"), n = (vb.test(f) ? "&" : "?") + "_=" + ub++ + n), o.url = f + n), o.ifModified && (r.lastModified[f] && y.setRequestHeader("If-Modified-Since", r.lastModified[f]), r.etag[f] && y.setRequestHeader("If-None-Match", r.etag[f])), (o.data && o.hasContent && o.contentType !== !1 || c.contentType) && y.setRequestHeader("Content-Type", o.contentType), y.setRequestHeader("Accept", o.dataTypes[0] && o.accepts[o.dataTypes[0]] ? o.accepts[o.dataTypes[0]] + ("*" !== o.dataTypes[0] ? ", " + Kb + "; q=0.01" : "") : o.accepts["*"]);for (m in o.headers) {
	        y.setRequestHeader(m, o.headers[m]);
	      }if (o.beforeSend && (o.beforeSend.call(p, y, o) === !1 || k)) return y.abort();if (x = "abort", t.add(o.complete), y.done(o.success), y.fail(o.error), e = Nb(Jb, o, c, y)) {
	        if (y.readyState = 1, l && q.trigger("ajaxSend", [y, o]), k) return y;o.async && o.timeout > 0 && (i = a.setTimeout(function () {
	          y.abort("timeout");
	        }, o.timeout));try {
	          k = !1, e.send(v, A);
	        } catch (z) {
	          if (k) throw z;A(-1, z);
	        }
	      } else A(-1, "No Transport");function A(b, c, d, h) {
	        var j,
	            m,
	            n,
	            v,
	            w,
	            x = c;k || (k = !0, i && a.clearTimeout(i), e = void 0, g = h || "", y.readyState = b > 0 ? 4 : 0, j = b >= 200 && b < 300 || 304 === b, d && (v = Pb(o, y, d)), v = Qb(o, v, y, j), j ? (o.ifModified && (w = y.getResponseHeader("Last-Modified"), w && (r.lastModified[f] = w), w = y.getResponseHeader("etag"), w && (r.etag[f] = w)), 204 === b || "HEAD" === o.type ? x = "nocontent" : 304 === b ? x = "notmodified" : (x = v.state, m = v.data, n = v.error, j = !n)) : (n = x, !b && x || (x = "error", b < 0 && (b = 0))), y.status = b, y.statusText = (c || x) + "", j ? s.resolveWith(p, [m, x, y]) : s.rejectWith(p, [y, x, n]), y.statusCode(u), u = void 0, l && q.trigger(j ? "ajaxSuccess" : "ajaxError", [y, o, j ? m : n]), t.fireWith(p, [y, x]), l && (q.trigger("ajaxComplete", [y, o]), --r.active || r.event.trigger("ajaxStop")));
	      }return y;
	    }, getJSON: function getJSON(a, b, c) {
	      return r.get(a, b, c, "json");
	    }, getScript: function getScript(a, b) {
	      return r.get(a, void 0, b, "script");
	    } }), r.each(["get", "post"], function (a, b) {
	    r[b] = function (a, c, d, e) {
	      return r.isFunction(c) && (e = e || d, d = c, c = void 0), r.ajax(r.extend({ url: a, type: b, dataType: e, data: c, success: d }, r.isPlainObject(a) && a));
	    };
	  }), r._evalUrl = function (a) {
	    return r.ajax({ url: a, type: "GET", dataType: "script", cache: !0, async: !1, global: !1, "throws": !0 });
	  }, r.fn.extend({ wrapAll: function wrapAll(a) {
	      var b;return this[0] && (r.isFunction(a) && (a = a.call(this[0])), b = r(a, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && b.insertBefore(this[0]), b.map(function () {
	        var a = this;while (a.firstElementChild) {
	          a = a.firstElementChild;
	        }return a;
	      }).append(this)), this;
	    }, wrapInner: function wrapInner(a) {
	      return r.isFunction(a) ? this.each(function (b) {
	        r(this).wrapInner(a.call(this, b));
	      }) : this.each(function () {
	        var b = r(this),
	            c = b.contents();c.length ? c.wrapAll(a) : b.append(a);
	      });
	    }, wrap: function wrap(a) {
	      var b = r.isFunction(a);return this.each(function (c) {
	        r(this).wrapAll(b ? a.call(this, c) : a);
	      });
	    }, unwrap: function unwrap(a) {
	      return this.parent(a).not("body").each(function () {
	        r(this).replaceWith(this.childNodes);
	      }), this;
	    } }), r.expr.pseudos.hidden = function (a) {
	    return !r.expr.pseudos.visible(a);
	  }, r.expr.pseudos.visible = function (a) {
	    return !!(a.offsetWidth || a.offsetHeight || a.getClientRects().length);
	  }, r.ajaxSettings.xhr = function () {
	    try {
	      return new a.XMLHttpRequest();
	    } catch (b) {}
	  };var Rb = { 0: 200, 1223: 204 },
	      Sb = r.ajaxSettings.xhr();o.cors = !!Sb && "withCredentials" in Sb, o.ajax = Sb = !!Sb, r.ajaxTransport(function (b) {
	    var _c, d;if (o.cors || Sb && !b.crossDomain) return { send: function send(e, f) {
	        var g,
	            h = b.xhr();if (h.open(b.type, b.url, b.async, b.username, b.password), b.xhrFields) for (g in b.xhrFields) {
	          h[g] = b.xhrFields[g];
	        }b.mimeType && h.overrideMimeType && h.overrideMimeType(b.mimeType), b.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest");for (g in e) {
	          h.setRequestHeader(g, e[g]);
	        }_c = function c(a) {
	          return function () {
	            _c && (_c = d = h.onload = h.onerror = h.onabort = h.onreadystatechange = null, "abort" === a ? h.abort() : "error" === a ? "number" != typeof h.status ? f(0, "error") : f(h.status, h.statusText) : f(Rb[h.status] || h.status, h.statusText, "text" !== (h.responseType || "text") || "string" != typeof h.responseText ? { binary: h.response } : { text: h.responseText }, h.getAllResponseHeaders()));
	          };
	        }, h.onload = _c(), d = h.onerror = _c("error"), void 0 !== h.onabort ? h.onabort = d : h.onreadystatechange = function () {
	          4 === h.readyState && a.setTimeout(function () {
	            _c && d();
	          });
	        }, _c = _c("abort");try {
	          h.send(b.hasContent && b.data || null);
	        } catch (i) {
	          if (_c) throw i;
	        }
	      }, abort: function abort() {
	        _c && _c();
	      } };
	  }), r.ajaxPrefilter(function (a) {
	    a.crossDomain && (a.contents.script = !1);
	  }), r.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /\b(?:java|ecma)script\b/ }, converters: { "text script": function textScript(a) {
	        return r.globalEval(a), a;
	      } } }), r.ajaxPrefilter("script", function (a) {
	    void 0 === a.cache && (a.cache = !1), a.crossDomain && (a.type = "GET");
	  }), r.ajaxTransport("script", function (a) {
	    if (a.crossDomain) {
	      var b, _c2;return { send: function send(e, f) {
	          b = r("<script>").prop({ charset: a.scriptCharset, src: a.url }).on("load error", _c2 = function c(a) {
	            b.remove(), _c2 = null, a && f("error" === a.type ? 404 : 200, a.type);
	          }), d.head.appendChild(b[0]);
	        }, abort: function abort() {
	          _c2 && _c2();
	        } };
	    }
	  });var Tb = [],
	      Ub = /(=)\?(?=&|$)|\?\?/;r.ajaxSetup({ jsonp: "callback", jsonpCallback: function jsonpCallback() {
	      var a = Tb.pop() || r.expando + "_" + ub++;return this[a] = !0, a;
	    } }), r.ajaxPrefilter("json jsonp", function (b, c, d) {
	    var e,
	        f,
	        g,
	        h = b.jsonp !== !1 && (Ub.test(b.url) ? "url" : "string" == typeof b.data && 0 === (b.contentType || "").indexOf("application/x-www-form-urlencoded") && Ub.test(b.data) && "data");if (h || "jsonp" === b.dataTypes[0]) return e = b.jsonpCallback = r.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback, h ? b[h] = b[h].replace(Ub, "$1" + e) : b.jsonp !== !1 && (b.url += (vb.test(b.url) ? "&" : "?") + b.jsonp + "=" + e), b.converters["script json"] = function () {
	      return g || r.error(e + " was not called"), g[0];
	    }, b.dataTypes[0] = "json", f = a[e], a[e] = function () {
	      g = arguments;
	    }, d.always(function () {
	      void 0 === f ? r(a).removeProp(e) : a[e] = f, b[e] && (b.jsonpCallback = c.jsonpCallback, Tb.push(e)), g && r.isFunction(f) && f(g[0]), g = f = void 0;
	    }), "script";
	  }), o.createHTMLDocument = function () {
	    var a = d.implementation.createHTMLDocument("").body;return a.innerHTML = "<form></form><form></form>", 2 === a.childNodes.length;
	  }(), r.parseHTML = function (a, b, c) {
	    if ("string" != typeof a) return [];"boolean" == typeof b && (c = b, b = !1);var e, f, g;return b || (o.createHTMLDocument ? (b = d.implementation.createHTMLDocument(""), e = b.createElement("base"), e.href = d.location.href, b.head.appendChild(e)) : b = d), f = C.exec(a), g = !c && [], f ? [b.createElement(f[1])] : (f = qa([a], b, g), g && g.length && r(g).remove(), r.merge([], f.childNodes));
	  }, r.fn.load = function (a, b, c) {
	    var d,
	        e,
	        f,
	        g = this,
	        h = a.indexOf(" ");return h > -1 && (d = pb(a.slice(h)), a = a.slice(0, h)), r.isFunction(b) ? (c = b, b = void 0) : b && "object" == (typeof b === "undefined" ? "undefined" : _typeof(b)) && (e = "POST"), g.length > 0 && r.ajax({ url: a, type: e || "GET", dataType: "html", data: b }).done(function (a) {
	      f = arguments, g.html(d ? r("<div>").append(r.parseHTML(a)).find(d) : a);
	    }).always(c && function (a, b) {
	      g.each(function () {
	        c.apply(this, f || [a.responseText, b, a]);
	      });
	    }), this;
	  }, r.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (a, b) {
	    r.fn[b] = function (a) {
	      return this.on(b, a);
	    };
	  }), r.expr.pseudos.animated = function (a) {
	    return r.grep(r.timers, function (b) {
	      return a === b.elem;
	    }).length;
	  }, r.offset = { setOffset: function setOffset(a, b, c) {
	      var d,
	          e,
	          f,
	          g,
	          h,
	          i,
	          j,
	          k = r.css(a, "position"),
	          l = r(a),
	          m = {};"static" === k && (a.style.position = "relative"), h = l.offset(), f = r.css(a, "top"), i = r.css(a, "left"), j = ("absolute" === k || "fixed" === k) && (f + i).indexOf("auto") > -1, j ? (d = l.position(), g = d.top, e = d.left) : (g = parseFloat(f) || 0, e = parseFloat(i) || 0), r.isFunction(b) && (b = b.call(a, c, r.extend({}, h))), null != b.top && (m.top = b.top - h.top + g), null != b.left && (m.left = b.left - h.left + e), "using" in b ? b.using.call(a, m) : l.css(m);
	    } }, r.fn.extend({ offset: function offset(a) {
	      if (arguments.length) return void 0 === a ? this : this.each(function (b) {
	        r.offset.setOffset(this, a, b);
	      });var b,
	          c,
	          d,
	          e,
	          f = this[0];if (f) return f.getClientRects().length ? (d = f.getBoundingClientRect(), b = f.ownerDocument, c = b.documentElement, e = b.defaultView, { top: d.top + e.pageYOffset - c.clientTop, left: d.left + e.pageXOffset - c.clientLeft }) : { top: 0, left: 0 };
	    }, position: function position() {
	      if (this[0]) {
	        var a,
	            b,
	            c = this[0],
	            d = { top: 0, left: 0 };return "fixed" === r.css(c, "position") ? b = c.getBoundingClientRect() : (a = this.offsetParent(), b = this.offset(), B(a[0], "html") || (d = a.offset()), d = { top: d.top + r.css(a[0], "borderTopWidth", !0), left: d.left + r.css(a[0], "borderLeftWidth", !0) }), { top: b.top - d.top - r.css(c, "marginTop", !0), left: b.left - d.left - r.css(c, "marginLeft", !0) };
	      }
	    }, offsetParent: function offsetParent() {
	      return this.map(function () {
	        var a = this.offsetParent;while (a && "static" === r.css(a, "position")) {
	          a = a.offsetParent;
	        }return a || ra;
	      });
	    } }), r.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (a, b) {
	    var c = "pageYOffset" === b;r.fn[a] = function (d) {
	      return T(this, function (a, d, e) {
	        var f;return r.isWindow(a) ? f = a : 9 === a.nodeType && (f = a.defaultView), void 0 === e ? f ? f[b] : a[d] : void (f ? f.scrollTo(c ? f.pageXOffset : e, c ? e : f.pageYOffset) : a[d] = e);
	      }, a, d, arguments.length);
	    };
	  }), r.each(["top", "left"], function (a, b) {
	    r.cssHooks[b] = Pa(o.pixelPosition, function (a, c) {
	      if (c) return c = Oa(a, b), Ma.test(c) ? r(a).position()[b] + "px" : c;
	    });
	  }), r.each({ Height: "height", Width: "width" }, function (a, b) {
	    r.each({ padding: "inner" + a, content: b, "": "outer" + a }, function (c, d) {
	      r.fn[d] = function (e, f) {
	        var g = arguments.length && (c || "boolean" != typeof e),
	            h = c || (e === !0 || f === !0 ? "margin" : "border");return T(this, function (b, c, e) {
	          var f;return r.isWindow(b) ? 0 === d.indexOf("outer") ? b["inner" + a] : b.document.documentElement["client" + a] : 9 === b.nodeType ? (f = b.documentElement, Math.max(b.body["scroll" + a], f["scroll" + a], b.body["offset" + a], f["offset" + a], f["client" + a])) : void 0 === e ? r.css(b, c, h) : r.style(b, c, e, h);
	        }, b, g ? e : void 0, g);
	      };
	    });
	  }), r.fn.extend({ bind: function bind(a, b, c) {
	      return this.on(a, null, b, c);
	    }, unbind: function unbind(a, b) {
	      return this.off(a, null, b);
	    }, delegate: function delegate(a, b, c, d) {
	      return this.on(b, a, c, d);
	    }, undelegate: function undelegate(a, b, c) {
	      return 1 === arguments.length ? this.off(a, "**") : this.off(b, a || "**", c);
	    } }), r.holdReady = function (a) {
	    a ? r.readyWait++ : r.ready(!0);
	  }, r.isArray = Array.isArray, r.parseJSON = JSON.parse, r.nodeName = B, "function" == "function" && __webpack_require__(202) && !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return r;
	  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));var Vb = a.jQuery,
	      Wb = a.$;return r.noConflict = function (b) {
	    return a.$ === r && (a.$ = Wb), b && a.jQuery === r && (a.jQuery = Vb), r;
	  }, b || (a.jQuery = a.$ = r), r;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(124)(module)))

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define('underscore', factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
	    var current = global._;
	    var exports = global._ = factory();
	    exports.noConflict = function () { global._ = current; return exports; };
	  }()));
	}(this, (function () {
	  //     Underscore.js 1.13.6
	  //     https://underscorejs.org
	  //     (c) 2009-2022 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
	  //     Underscore may be freely distributed under the MIT license.
	
	  // Current version.
	  var VERSION = '1.13.6';
	
	  // Establish the root object, `window` (`self`) in the browser, `global`
	  // on the server, or `this` in some virtual machines. We use `self`
	  // instead of `window` for `WebWorker` support.
	  var root = (typeof self == 'object' && self.self === self && self) ||
	            (typeof global == 'object' && global.global === global && global) ||
	            Function('return this')() ||
	            {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
	  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // Modern feature detection.
	  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
	      supportsDataView = typeof DataView !== 'undefined';
	
	  // All **ECMAScript 5+** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeCreate = Object.create,
	      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;
	
	  // Create references to these builtin functions because we override them.
	  var _isNaN = isNaN,
	      _isFinite = isFinite;
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  // The largest integer that can be represented exactly.
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	
	  // Some functions take a variable number of arguments, or a few expected
	  // arguments at the beginning and then a variable number of values to operate
	  // on. This helper accumulates all remaining arguments past the function’s
	  // argument length (or an explicit `startIndex`), into an array that becomes
	  // the last argument. Similar to ES6’s "rest parameter".
	  function restArguments(func, startIndex) {
	    startIndex = startIndex == null ? func.length - 1 : +startIndex;
	    return function() {
	      var length = Math.max(arguments.length - startIndex, 0),
	          rest = Array(length),
	          index = 0;
	      for (; index < length; index++) {
	        rest[index] = arguments[index + startIndex];
	      }
	      switch (startIndex) {
	        case 0: return func.call(this, rest);
	        case 1: return func.call(this, arguments[0], rest);
	        case 2: return func.call(this, arguments[0], arguments[1], rest);
	      }
	      var args = Array(startIndex + 1);
	      for (index = 0; index < startIndex; index++) {
	        args[index] = arguments[index];
	      }
	      args[startIndex] = rest;
	      return func.apply(this, args);
	    };
	  }
	
	  // Is a given variable an object?
	  function isObject(obj) {
	    var type = typeof obj;
	    return type === 'function' || (type === 'object' && !!obj);
	  }
	
	  // Is a given value equal to null?
	  function isNull(obj) {
	    return obj === null;
	  }
	
	  // Is a given variable undefined?
	  function isUndefined(obj) {
	    return obj === void 0;
	  }
	
	  // Is a given value a boolean?
	  function isBoolean(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  }
	
	  // Is a given value a DOM element?
	  function isElement(obj) {
	    return !!(obj && obj.nodeType === 1);
	  }
	
	  // Internal function for creating a `toString`-based type tester.
	  function tagTester(name) {
	    var tag = '[object ' + name + ']';
	    return function(obj) {
	      return toString.call(obj) === tag;
	    };
	  }
	
	  var isString = tagTester('String');
	
	  var isNumber = tagTester('Number');
	
	  var isDate = tagTester('Date');
	
	  var isRegExp = tagTester('RegExp');
	
	  var isError = tagTester('Error');
	
	  var isSymbol = tagTester('Symbol');
	
	  var isArrayBuffer = tagTester('ArrayBuffer');
	
	  var isFunction = tagTester('Function');
	
	  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
	  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
	  var nodelist = root.document && root.document.childNodes;
	  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
	    isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  var isFunction$1 = isFunction;
	
	  var hasObjectTag = tagTester('Object');
	
	  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
	  // In IE 11, the most common among them, this problem also applies to
	  // `Map`, `WeakMap` and `Set`.
	  var hasStringTagBug = (
	        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
	      ),
	      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));
	
	  var isDataView = tagTester('DataView');
	
	  // In IE 10 - Edge 13, we need a different heuristic
	  // to determine whether an object is a `DataView`.
	  function ie10IsDataView(obj) {
	    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
	  }
	
	  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native `Array.isArray`.
	  var isArray = nativeIsArray || tagTester('Array');
	
	  // Internal function to check whether `key` is an own property name of `obj`.
	  function has$1(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  }
	
	  var isArguments = tagTester('Arguments');
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  (function() {
	    if (!isArguments(arguments)) {
	      isArguments = function(obj) {
	        return has$1(obj, 'callee');
	      };
	    }
	  }());
	
	  var isArguments$1 = isArguments;
	
	  // Is a given object a finite number?
	  function isFinite$1(obj) {
	    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
	  }
	
	  // Is the given value `NaN`?
	  function isNaN$1(obj) {
	    return isNumber(obj) && _isNaN(obj);
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function constant(value) {
	    return function() {
	      return value;
	    };
	  }
	
	  // Common internal logic for `isArrayLike` and `isBufferLike`.
	  function createSizePropertyCheck(getSizeProperty) {
	    return function(collection) {
	      var sizeProperty = getSizeProperty(collection);
	      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
	    }
	  }
	
	  // Internal helper to generate a function to obtain property `key` from `obj`.
	  function shallowProperty(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  }
	
	  // Internal helper to obtain the `byteLength` property of an object.
	  var getByteLength = shallowProperty('byteLength');
	
	  // Internal helper to determine whether we should spend extensive checks against
	  // `ArrayBuffer` et al.
	  var isBufferLike = createSizePropertyCheck(getByteLength);
	
	  // Is a given value a typed array?
	  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
	  function isTypedArray(obj) {
	    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
	    // Otherwise, fall back on the above regular expression.
	    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
	                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
	  }
	
	  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);
	
	  // Internal helper to obtain the `length` property of an object.
	  var getLength = shallowProperty('length');
	
	  // Internal helper to create a simple lookup structure.
	  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
	  // circular imports. `emulatedSet` is a one-off solution that only works for
	  // arrays of strings.
	  function emulatedSet(keys) {
	    var hash = {};
	    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
	    return {
	      contains: function(key) { return hash[key] === true; },
	      push: function(key) {
	        hash[key] = true;
	        return keys.push(key);
	      }
	    };
	  }
	
	  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
	  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
	  // needed.
	  function collectNonEnumProps(obj, keys) {
	    keys = emulatedSet(keys);
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (isFunction$1(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`.
	  function keys(obj) {
	    if (!isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (has$1(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  function isEmpty(obj) {
	    if (obj == null) return true;
	    // Skip the more expensive `toString`-based type checks if `obj` has no
	    // `.length`.
	    var length = getLength(obj);
	    if (typeof length == 'number' && (
	      isArray(obj) || isString(obj) || isArguments$1(obj)
	    )) return length === 0;
	    return getLength(keys(obj)) === 0;
	  }
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  function isMatch(object, attrs) {
	    var _keys = keys(attrs), length = _keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = _keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  }
	
	  // If Underscore is called as a function, it returns a wrapped object that can
	  // be used OO-style. This wrapper holds altered versions of all functions added
	  // through `_.mixin`. Wrapped objects may be chained.
	  function _$1(obj) {
	    if (obj instanceof _$1) return obj;
	    if (!(this instanceof _$1)) return new _$1(obj);
	    this._wrapped = obj;
	  }
	
	  _$1.VERSION = VERSION;
	
	  // Extracts the result from a wrapped and chained object.
	  _$1.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxies for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;
	
	  _$1.prototype.toString = function() {
	    return String(this._wrapped);
	  };
	
	  // Internal function to wrap or shallow-copy an ArrayBuffer,
	  // typed array or DataView to a new view, reusing the buffer.
	  function toBufferView(bufferSource) {
	    return new Uint8Array(
	      bufferSource.buffer || bufferSource,
	      bufferSource.byteOffset || 0,
	      getByteLength(bufferSource)
	    );
	  }
	
	  // We use this string twice, so give it a name for minification.
	  var tagDataView = '[object DataView]';
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null) return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a) return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
	    return deepEq(a, b, aStack, bStack);
	  }
	
	  // Internal recursive comparison function for `_.isEqual`.
	  function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    if (a instanceof _$1) a = a._wrapped;
	    if (b instanceof _$1) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    // Work around a bug in IE 10 - Edge 13.
	    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
	      if (!isDataView$1(b)) return false;
	      className = tagDataView;
	    }
	    switch (className) {
	      // These types are compared by value.
	      case '[object RegExp]':
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN.
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	      case '[object Symbol]':
	        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
	      case '[object ArrayBuffer]':
	      case tagDataView:
	        // Coerce to typed array so we can fall through.
	        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays && isTypedArray$1(a)) {
	        var byteLength = getByteLength(a);
	        if (byteLength !== getByteLength(b)) return false;
	        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
	        areArrays = true;
	    }
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
	                               isFunction$1(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var _keys = keys(a), key;
	      length = _keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = _keys[length];
	        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  }
	
	  // Perform a deep comparison to check if two objects are equal.
	  function isEqual(a, b) {
	    return eq(a, b);
	  }
	
	  // Retrieve all the enumerable property names of an object.
	  function allKeys(obj) {
	    if (!isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  }
	
	  // Since the regular `Object.prototype.toString` type tests don't work for
	  // some types in IE 11, we use a fingerprinting heuristic instead, based
	  // on the methods. It's not great, but it's the best we got.
	  // The fingerprint method lists are defined below.
	  function ie11fingerprint(methods) {
	    var length = getLength(methods);
	    return function(obj) {
	      if (obj == null) return false;
	      // `Map`, `WeakMap` and `Set` have no enumerable keys.
	      var keys = allKeys(obj);
	      if (getLength(keys)) return false;
	      for (var i = 0; i < length; i++) {
	        if (!isFunction$1(obj[methods[i]])) return false;
	      }
	      // If we are testing against `WeakMap`, we need to ensure that
	      // `obj` doesn't have a `forEach` method in order to distinguish
	      // it from a regular `Map`.
	      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
	    };
	  }
	
	  // In the interest of compact minification, we write
	  // each string in the fingerprints only once.
	  var forEachName = 'forEach',
	      hasName = 'has',
	      commonInit = ['clear', 'delete'],
	      mapTail = ['get', hasName, 'set'];
	
	  // `Map`, `WeakMap` and `Set` each have slightly different
	  // combinations of the above sublists.
	  var mapMethods = commonInit.concat(forEachName, mapTail),
	      weakMapMethods = commonInit.concat(mapTail),
	      setMethods = ['add'].concat(commonInit, forEachName, hasName);
	
	  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');
	
	  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');
	
	  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');
	
	  var isWeakSet = tagTester('WeakSet');
	
	  // Retrieve the values of an object's properties.
	  function values(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[_keys[i]];
	    }
	    return values;
	  }
	
	  // Convert an object into a list of `[key, value]` pairs.
	  // The opposite of `_.object` with one argument.
	  function pairs(obj) {
	    var _keys = keys(obj);
	    var length = _keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [_keys[i], obj[_keys[i]]];
	    }
	    return pairs;
	  }
	
	  // Invert the keys and values of an object. The values must be serializable.
	  function invert(obj) {
	    var result = {};
	    var _keys = keys(obj);
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      result[obj[_keys[i]]] = _keys[i];
	    }
	    return result;
	  }
	
	  // Return a sorted list of the function names available on the object.
	  function functions(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (isFunction$1(obj[key])) names.push(key);
	    }
	    return names.sort();
	  }
	
	  // An internal function for creating assigner functions.
	  function createAssigner(keysFunc, defaults) {
	    return function(obj) {
	      var length = arguments.length;
	      if (defaults) obj = Object(obj);
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!defaults || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  }
	
	  // Extend a given object with all the properties in passed-in object(s).
	  var extend = createAssigner(allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in
	  // object(s).
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  var extendOwn = createAssigner(keys);
	
	  // Fill in a given object with default properties.
	  var defaults = createAssigner(allKeys, true);
	
	  // Create a naked function reference for surrogate-prototype-swapping.
	  function ctor() {
	    return function(){};
	  }
	
	  // An internal function for creating a new object that inherits from another.
	  function baseCreate(prototype) {
	    if (!isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    var Ctor = ctor();
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  }
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  function create(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) extendOwn(result, props);
	    return result;
	  }
	
	  // Create a (shallow-cloned) duplicate of an object.
	  function clone(obj) {
	    if (!isObject(obj)) return obj;
	    return isArray(obj) ? obj.slice() : extend({}, obj);
	  }
	
	  // Invokes `interceptor` with the `obj` and then returns `obj`.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  function tap(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  }
	
	  // Normalize a (deep) property `path` to array.
	  // Like `_.iteratee`, this function can be customized.
	  function toPath$1(path) {
	    return isArray(path) ? path : [path];
	  }
	  _$1.toPath = toPath$1;
	
	  // Internal wrapper for `_.toPath` to enable minification.
	  // Similar to `cb` for `_.iteratee`.
	  function toPath(path) {
	    return _$1.toPath(path);
	  }
	
	  // Internal function to obtain a nested property in `obj` along `path`.
	  function deepGet(obj, path) {
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      if (obj == null) return void 0;
	      obj = obj[path[i]];
	    }
	    return length ? obj : void 0;
	  }
	
	  // Get the value of the (deep) property on `path` from `object`.
	  // If any property in `path` does not exist or if the value is
	  // `undefined`, return `defaultValue` instead.
	  // The `path` is normalized through `_.toPath`.
	  function get(object, path, defaultValue) {
	    var value = deepGet(object, toPath(path));
	    return isUndefined(value) ? defaultValue : value;
	  }
	
	  // Shortcut function for checking if an object has a given property directly on
	  // itself (in other words, not on a prototype). Unlike the internal `has`
	  // function, this public version can also traverse nested properties.
	  function has(obj, path) {
	    path = toPath(path);
	    var length = path.length;
	    for (var i = 0; i < length; i++) {
	      var key = path[i];
	      if (!has$1(obj, key)) return false;
	      obj = obj[key];
	    }
	    return !!length;
	  }
	
	  // Keep the identity function around for default iteratees.
	  function identity(value) {
	    return value;
	  }
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  function matcher(attrs) {
	    attrs = extendOwn({}, attrs);
	    return function(obj) {
	      return isMatch(obj, attrs);
	    };
	  }
	
	  // Creates a function that, when passed an object, will traverse that object’s
	  // properties down the given `path`, specified as an array of keys or indices.
	  function property(path) {
	    path = toPath(path);
	    return function(obj) {
	      return deepGet(obj, path);
	    };
	  }
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  function optimizeCb(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      // The 2-argument case is omitted because we’re not using it.
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  }
	
	  // An internal function to generate callbacks that can be applied to each
	  // element in a collection, returning the desired result — either `_.identity`,
	  // an arbitrary callback, a property matcher, or a property accessor.
	  function baseIteratee(value, context, argCount) {
	    if (value == null) return identity;
	    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
	    if (isObject(value) && !isArray(value)) return matcher(value);
	    return property(value);
	  }
	
	  // External wrapper for our callback generator. Users may customize
	  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
	  // This abstraction hides the internal-only `argCount` argument.
	  function iteratee(value, context) {
	    return baseIteratee(value, context, Infinity);
	  }
	  _$1.iteratee = iteratee;
	
	  // The function we call internally to generate a callback. It invokes
	  // `_.iteratee` if overridden, otherwise `baseIteratee`.
	  function cb(value, context, argCount) {
	    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
	    return baseIteratee(value, context, argCount);
	  }
	
	  // Returns the results of applying the `iteratee` to each element of `obj`.
	  // In contrast to `_.map` it returns an object.
	  function mapObject(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = keys(obj),
	        length = _keys.length,
	        results = {};
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Predicate-generating function. Often useful outside of Underscore.
	  function noop(){}
	
	  // Generates a function for a given object that returns a given property.
	  function propertyOf(obj) {
	    if (obj == null) return noop;
	    return function(path) {
	      return get(obj, path);
	    };
	  }
	
	  // Run a function **n** times.
	  function times(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  }
	
	  // Return a random integer between `min` and `max` (inclusive).
	  function random(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  }
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  var now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	  // Internal helper to generate functions for escaping and unescaping strings
	  // to/from HTML interpolation.
	  function createEscaper(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  }
	
	  // Internal list of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	
	  // Function for escaping strings to HTML interpolation.
	  var _escape = createEscaper(escapeMap);
	
	  // Internal list of HTML entities for unescaping.
	  var unescapeMap = invert(escapeMap);
	
	  // Function for unescaping strings from HTML interpolation.
	  var _unescape = createEscaper(unescapeMap);
	
	  // By default, Underscore uses ERB-style template delimiters. Change the
	  // following template settings to use alternative delimiters.
	  var templateSettings = _$1.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `_.templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  function escapeChar(match) {
	    return '\\' + escapes[match];
	  }
	
	  // In order to prevent third-party code injection through
	  // `_.templateSettings.variable`, we test it against the following regular
	  // expression. It is intentionally a bit more liberal than just matching valid
	  // identifiers, but still prevents possible loopholes through defaults or
	  // destructuring assignment.
	  var bareIdentifier = /^\s*(\w|\$)+\s*$/;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  function template(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = defaults({}, settings, _$1.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offset.
	      return match;
	    });
	    source += "';\n";
	
	    var argument = settings.variable;
	    if (argument) {
	      // Insure against third-party code injection. (CVE-2021-23358)
	      if (!bareIdentifier.test(argument)) throw new Error(
	        'variable is not a bare identifier: ' + argument
	      );
	    } else {
	      // If a variable is not specified, place data values in local scope.
	      source = 'with(obj||{}){\n' + source + '}\n';
	      argument = 'obj';
	    }
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    var render;
	    try {
	      render = new Function(argument, '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _$1);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  }
	
	  // Traverses the children of `obj` along `path`. If a child is a function, it
	  // is invoked with its parent as context. Returns the value of the final
	  // child, or `fallback` if any child is undefined.
	  function result(obj, path, fallback) {
	    path = toPath(path);
	    var length = path.length;
	    if (!length) {
	      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
	    }
	    for (var i = 0; i < length; i++) {
	      var prop = obj == null ? void 0 : obj[path[i]];
	      if (prop === void 0) {
	        prop = fallback;
	        i = length; // Ensure we don't continue iterating.
	      }
	      obj = isFunction$1(prop) ? prop.call(obj) : prop;
	    }
	    return obj;
	  }
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  function uniqueId(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  }
	
	  // Start chaining a wrapped Underscore object.
	  function chain(obj) {
	    var instance = _$1(obj);
	    instance._chain = true;
	    return instance;
	  }
	
	  // Internal function to execute `sourceFunc` bound to `context` with optional
	  // `args`. Determines whether to execute a function as a constructor or as a
	  // normal function.
	  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (isObject(result)) return result;
	    return self;
	  }
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
	  // as a placeholder by default, allowing any combination of arguments to be
	  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
	  var partial = restArguments(function(func, boundArgs) {
	    var placeholder = partial.placeholder;
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  });
	
	  partial.placeholder = _$1;
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally).
	  var bind = restArguments(function(func, context, args) {
	    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
	    var bound = restArguments(function(callArgs) {
	      return executeBound(func, bound, context, this, args.concat(callArgs));
	    });
	    return bound;
	  });
	
	  // Internal helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object.
	  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var isArrayLike = createSizePropertyCheck(getLength);
	
	  // Internal implementation of a recursive `flatten` function.
	  function flatten$1(input, depth, strict, output) {
	    output = output || [];
	    if (!depth && depth !== 0) {
	      depth = Infinity;
	    } else if (depth <= 0) {
	      return output.concat(input);
	    }
	    var idx = output.length;
	    for (var i = 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
	        // Flatten current level of array or arguments object.
	        if (depth > 1) {
	          flatten$1(value, depth - 1, strict, output);
	          idx = output.length;
	        } else {
	          var j = 0, len = value.length;
	          while (j < len) output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  }
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  var bindAll = restArguments(function(obj, keys) {
	    keys = flatten$1(keys, false, false);
	    var index = keys.length;
	    if (index < 1) throw new Error('bindAll must be passed function names');
	    while (index--) {
	      var key = keys[index];
	      obj[key] = bind(obj[key], obj);
	    }
	    return obj;
	  });
	
	  // Memoize an expensive function by storing its results.
	  function memoize(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  }
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  var delay = restArguments(function(func, wait, args) {
	    return setTimeout(function() {
	      return func.apply(null, args);
	    }, wait);
	  });
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  var defer = partial(delay, _$1, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  function throttle(func, wait, options) {
	    var timeout, context, args, result;
	    var previous = 0;
	    if (!options) options = {};
	
	    var later = function() {
	      previous = options.leading === false ? 0 : now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	
	    var throttled = function() {
	      var _now = now();
	      if (!previous && options.leading === false) previous = _now;
	      var remaining = wait - (_now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = _now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    throttled.cancel = function() {
	      clearTimeout(timeout);
	      previous = 0;
	      timeout = context = args = null;
	    };
	
	    return throttled;
	  }
	
	  // When a sequence of calls of the returned function ends, the argument
	  // function is triggered. The end of a sequence is defined by the `wait`
	  // parameter. If `immediate` is passed, the argument function will be
	  // triggered at the beginning of the sequence instead of at the end.
	  function debounce(func, wait, immediate) {
	    var timeout, previous, args, result, context;
	
	    var later = function() {
	      var passed = now() - previous;
	      if (wait > passed) {
	        timeout = setTimeout(later, wait - passed);
	      } else {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	        // This check is needed because `func` can recursively invoke `debounced`.
	        if (!timeout) args = context = null;
	      }
	    };
	
	    var debounced = restArguments(function(_args) {
	      context = this;
	      args = _args;
	      previous = now();
	      if (!timeout) {
	        timeout = setTimeout(later, wait);
	        if (immediate) result = func.apply(context, args);
	      }
	      return result;
	    });
	
	    debounced.cancel = function() {
	      clearTimeout(timeout);
	      timeout = args = context = null;
	    };
	
	    return debounced;
	  }
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  function wrap(func, wrapper) {
	    return partial(wrapper, func);
	  }
	
	  // Returns a negated version of the passed-in predicate.
	  function negate(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  }
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  }
	
	  // Returns a function that will only be executed on and after the Nth call.
	  function after(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  }
	
	  // Returns a function that will only be executed up to (but not including) the
	  // Nth call.
	  function before(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  }
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  var once = partial(before, 2);
	
	  // Returns the first key on an object that passes a truth test.
	  function findKey(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = keys(obj), key;
	    for (var i = 0, length = _keys.length; i < length; i++) {
	      key = _keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  }
	
	  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a truth test.
	  var findIndex = createPredicateIndexFinder(1);
	
	  // Returns the last index on an array-like that passes a truth test.
	  var findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  function sortedIndex(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  }
	
	  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), isNaN$1);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  var indexOf = createIndexFinder(1, findIndex, sortedIndex);
	
	  // Return the position of the last occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  var lastIndexOf = createIndexFinder(-1, findLastIndex);
	
	  // Return the first value which passes a truth test.
	  function find(obj, predicate, context) {
	    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
	    var key = keyFinder(obj, predicate, context);
	    if (key !== void 0 && key !== -1) return obj[key];
	  }
	
	  // Convenience version of a common use case of `_.find`: getting the first
	  // object containing specific `key:value` pairs.
	  function findWhere(obj, attrs) {
	    return find(obj, matcher(attrs));
	  }
	
	  // The cornerstone for collection functions, an `each`
	  // implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  function each(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var _keys = keys(obj);
	      for (i = 0, length = _keys.length; i < length; i++) {
	        iteratee(obj[_keys[i]], _keys[i], obj);
	      }
	    }
	    return obj;
	  }
	
	  // Return the results of applying the iteratee to each element.
	  function map(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  }
	
	  // Internal helper to create a reducing function, iterating left or right.
	  function createReduce(dir) {
	    // Wrap code that reassigns argument variables in a separate function than
	    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
	    var reducer = function(obj, iteratee, memo, initial) {
	      var _keys = !isArrayLike(obj) && keys(obj),
	          length = (_keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      if (!initial) {
	        memo = obj[_keys ? _keys[index] : index];
	        index += dir;
	      }
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = _keys ? _keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    };
	
	    return function(obj, iteratee, memo, context) {
	      var initial = arguments.length >= 3;
	      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  var reduce = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  var reduceRight = createReduce(-1);
	
	  // Return all the elements that pass a truth test.
	  function filter(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  }
	
	  // Return all the elements for which a truth test fails.
	  function reject(obj, predicate, context) {
	    return filter(obj, negate(cb(predicate)), context);
	  }
	
	  // Determine whether all of the elements pass a truth test.
	  function every(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  }
	
	  // Determine if at least one element in the object passes a truth test.
	  function some(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var _keys = !isArrayLike(obj) && keys(obj),
	        length = (_keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = _keys ? _keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  }
	
	  // Determine if the array or object contains a given item (using `===`).
	  function contains(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return indexOf(obj, item, fromIndex) >= 0;
	  }
	
	  // Invoke a method (with arguments) on every item in a collection.
	  var invoke = restArguments(function(obj, path, args) {
	    var contextPath, func;
	    if (isFunction$1(path)) {
	      func = path;
	    } else {
	      path = toPath(path);
	      contextPath = path.slice(0, -1);
	      path = path[path.length - 1];
	    }
	    return map(obj, function(context) {
	      var method = func;
	      if (!method) {
	        if (contextPath && contextPath.length) {
	          context = deepGet(context, contextPath);
	        }
	        if (context == null) return void 0;
	        method = context[path];
	      }
	      return method == null ? method : method.apply(context, args);
	    });
	  });
	
	  // Convenience version of a common use case of `_.map`: fetching a property.
	  function pluck(obj, key) {
	    return map(obj, property(key));
	  }
	
	  // Convenience version of a common use case of `_.filter`: selecting only
	  // objects containing specific `key:value` pairs.
	  function where(obj, attrs) {
	    return filter(obj, matcher(attrs));
	  }
	
	  // Return the maximum element (or element-based computation).
	  function max(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Return the minimum element (or element-based computation).
	  function min(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
	      obj = isArrayLike(obj) ? obj : values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value != null && value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      each(obj, function(v, index, list) {
	        computed = iteratee(v, index, list);
	        if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
	          result = v;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  }
	
	  // Safely create a real, live array from anything iterable.
	  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
	  function toArray(obj) {
	    if (!obj) return [];
	    if (isArray(obj)) return slice.call(obj);
	    if (isString(obj)) {
	      // Keep surrogate pair characters together.
	      return obj.match(reStrSymbol);
	    }
	    if (isArrayLike(obj)) return map(obj, identity);
	    return values(obj);
	  }
	
	  // Sample **n** random values from a collection using the modern version of the
	  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `_.map`.
	  function sample(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = values(obj);
	      return obj[random(obj.length - 1)];
	    }
	    var sample = toArray(obj);
	    var length = getLength(sample);
	    n = Math.max(Math.min(n, length), 0);
	    var last = length - 1;
	    for (var index = 0; index < n; index++) {
	      var rand = random(index, last);
	      var temp = sample[index];
	      sample[index] = sample[rand];
	      sample[rand] = temp;
	    }
	    return sample.slice(0, n);
	  }
	
	  // Shuffle a collection.
	  function shuffle(obj) {
	    return sample(obj, Infinity);
	  }
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  function sortBy(obj, iteratee, context) {
	    var index = 0;
	    iteratee = cb(iteratee, context);
	    return pluck(map(obj, function(value, key, list) {
	      return {
	        value: value,
	        index: index++,
	        criteria: iteratee(value, key, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  }
	
	  // An internal function used for aggregate "group by" operations.
	  function group(behavior, partition) {
	    return function(obj, iteratee, context) {
	      var result = partition ? [[], []] : {};
	      iteratee = cb(iteratee, context);
	      each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  }
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  var groupBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
	  // when you know that your index values will be unique.
	  var indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  var countBy = group(function(result, value, key) {
	    if (has$1(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Split a collection into two arrays: one whose elements all pass the given
	  // truth test, and one whose elements all do not pass the truth test.
	  var partition = group(function(result, value, pass) {
	    result[pass ? 0 : 1].push(value);
	  }, true);
	
	  // Return the number of elements in a collection.
	  function size(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : keys(obj).length;
	  }
	
	  // Internal `_.pick` helper function to determine whether `key` is an enumerable
	  // property name of `obj`.
	  function keyInObj(value, key, obj) {
	    return key in obj;
	  }
	
	  // Return a copy of the object only containing the allowed properties.
	  var pick = restArguments(function(obj, keys) {
	    var result = {}, iteratee = keys[0];
	    if (obj == null) return result;
	    if (isFunction$1(iteratee)) {
	      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
	      keys = allKeys(obj);
	    } else {
	      iteratee = keyInObj;
	      keys = flatten$1(keys, false, false);
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  });
	
	  // Return a copy of the object without the disallowed properties.
	  var omit = restArguments(function(obj, keys) {
	    var iteratee = keys[0], context;
	    if (isFunction$1(iteratee)) {
	      iteratee = negate(iteratee);
	      if (keys.length > 1) context = keys[1];
	    } else {
	      keys = map(flatten$1(keys, false, false), String);
	      iteratee = function(value, key) {
	        return !contains(keys, key);
	      };
	    }
	    return pick(obj, iteratee, context);
	  });
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  function initial(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  }
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  function first(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[0];
	    return initial(array, array.length - n);
	  }
	
	  // Returns everything but the first entry of the `array`. Especially useful on
	  // the `arguments` object. Passing an **n** will return the rest N values in the
	  // `array`.
	  function rest(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  }
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  function last(array, n, guard) {
	    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
	    if (n == null || guard) return array[array.length - 1];
	    return rest(array, Math.max(0, array.length - n));
	  }
	
	  // Trim out all falsy values from an array.
	  function compact(array) {
	    return filter(array, Boolean);
	  }
	
	  // Flatten out an array, either recursively (by default), or up to `depth`.
	  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
	  function flatten(array, depth) {
	    return flatten$1(array, depth, false);
	  }
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  var difference = restArguments(function(array, rest) {
	    rest = flatten$1(rest, true, true);
	    return filter(array, function(value){
	      return !contains(rest, value);
	    });
	  });
	
	  // Return a version of the array that does not contain the specified value(s).
	  var without = restArguments(function(array, otherArrays) {
	    return difference(array, otherArrays);
	  });
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // The faster algorithm will not work with an iteratee if the iteratee
	  // is not a one-to-one function, so providing an iteratee will disable
	  // the faster algorithm.
	  function uniq(array, isSorted, iteratee, context) {
	    if (!isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted && !iteratee) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  var union = restArguments(function(arrays) {
	    return uniq(flatten$1(arrays, true, true));
	  });
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  function intersection(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (contains(result, item)) continue;
	      var j;
	      for (j = 1; j < argsLength; j++) {
	        if (!contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  }
	
	  // Complement of zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices.
	  function unzip(array) {
	    var length = (array && max(array, getLength).length) || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = pluck(array, index);
	    }
	    return result;
	  }
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  var zip = restArguments(unzip);
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
	  function object(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  }
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](https://docs.python.org/library/functions.html#range).
	  function range(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    if (!step) {
	      step = stop < start ? -1 : 1;
	    }
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  }
	
	  // Chunk a single array into multiple arrays, each containing `count` or fewer
	  // items.
	  function chunk(array, count) {
	    if (count == null || count < 1) return [];
	    var result = [];
	    var i = 0, length = array.length;
	    while (i < length) {
	      result.push(slice.call(array, i, i += count));
	    }
	    return result;
	  }
	
	  // Helper function to continue chaining intermediate results.
	  function chainResult(instance, obj) {
	    return instance._chain ? _$1(obj).chain() : obj;
	  }
	
	  // Add your own custom functions to the Underscore object.
	  function mixin(obj) {
	    each(functions(obj), function(name) {
	      var func = _$1[name] = obj[name];
	      _$1.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return chainResult(this, func.apply(_$1, args));
	      };
	    });
	    return _$1;
	  }
	
	  // Add all mutator `Array` functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) {
	        method.apply(obj, arguments);
	        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
	          delete obj[0];
	        }
	      }
	      return chainResult(this, obj);
	    };
	  });
	
	  // Add all accessor `Array` functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _$1.prototype[name] = function() {
	      var obj = this._wrapped;
	      if (obj != null) obj = method.apply(obj, arguments);
	      return chainResult(this, obj);
	    };
	  });
	
	  // Named Exports
	
	  var allExports = {
	    __proto__: null,
	    VERSION: VERSION,
	    restArguments: restArguments,
	    isObject: isObject,
	    isNull: isNull,
	    isUndefined: isUndefined,
	    isBoolean: isBoolean,
	    isElement: isElement,
	    isString: isString,
	    isNumber: isNumber,
	    isDate: isDate,
	    isRegExp: isRegExp,
	    isError: isError,
	    isSymbol: isSymbol,
	    isArrayBuffer: isArrayBuffer,
	    isDataView: isDataView$1,
	    isArray: isArray,
	    isFunction: isFunction$1,
	    isArguments: isArguments$1,
	    isFinite: isFinite$1,
	    isNaN: isNaN$1,
	    isTypedArray: isTypedArray$1,
	    isEmpty: isEmpty,
	    isMatch: isMatch,
	    isEqual: isEqual,
	    isMap: isMap,
	    isWeakMap: isWeakMap,
	    isSet: isSet,
	    isWeakSet: isWeakSet,
	    keys: keys,
	    allKeys: allKeys,
	    values: values,
	    pairs: pairs,
	    invert: invert,
	    functions: functions,
	    methods: functions,
	    extend: extend,
	    extendOwn: extendOwn,
	    assign: extendOwn,
	    defaults: defaults,
	    create: create,
	    clone: clone,
	    tap: tap,
	    get: get,
	    has: has,
	    mapObject: mapObject,
	    identity: identity,
	    constant: constant,
	    noop: noop,
	    toPath: toPath$1,
	    property: property,
	    propertyOf: propertyOf,
	    matcher: matcher,
	    matches: matcher,
	    times: times,
	    random: random,
	    now: now,
	    escape: _escape,
	    unescape: _unescape,
	    templateSettings: templateSettings,
	    template: template,
	    result: result,
	    uniqueId: uniqueId,
	    chain: chain,
	    iteratee: iteratee,
	    partial: partial,
	    bind: bind,
	    bindAll: bindAll,
	    memoize: memoize,
	    delay: delay,
	    defer: defer,
	    throttle: throttle,
	    debounce: debounce,
	    wrap: wrap,
	    negate: negate,
	    compose: compose,
	    after: after,
	    before: before,
	    once: once,
	    findKey: findKey,
	    findIndex: findIndex,
	    findLastIndex: findLastIndex,
	    sortedIndex: sortedIndex,
	    indexOf: indexOf,
	    lastIndexOf: lastIndexOf,
	    find: find,
	    detect: find,
	    findWhere: findWhere,
	    each: each,
	    forEach: each,
	    map: map,
	    collect: map,
	    reduce: reduce,
	    foldl: reduce,
	    inject: reduce,
	    reduceRight: reduceRight,
	    foldr: reduceRight,
	    filter: filter,
	    select: filter,
	    reject: reject,
	    every: every,
	    all: every,
	    some: some,
	    any: some,
	    contains: contains,
	    includes: contains,
	    include: contains,
	    invoke: invoke,
	    pluck: pluck,
	    where: where,
	    max: max,
	    min: min,
	    shuffle: shuffle,
	    sample: sample,
	    sortBy: sortBy,
	    groupBy: groupBy,
	    indexBy: indexBy,
	    countBy: countBy,
	    partition: partition,
	    toArray: toArray,
	    size: size,
	    pick: pick,
	    omit: omit,
	    first: first,
	    head: first,
	    take: first,
	    initial: initial,
	    last: last,
	    rest: rest,
	    tail: rest,
	    drop: rest,
	    compact: compact,
	    flatten: flatten,
	    without: without,
	    uniq: uniq,
	    unique: uniq,
	    union: union,
	    intersection: intersection,
	    difference: difference,
	    unzip: unzip,
	    transpose: unzip,
	    zip: zip,
	    object: object,
	    range: range,
	    chunk: chunk,
	    mixin: mixin,
	    'default': _$1
	  };
	
	  // Default Export
	
	  // Add all of the Underscore functions to the wrapper object.
	  var _ = mixin(allExports);
	  // Legacy Node.js API.
	  _._ = _;
	
	  return _;
	
	})));
	//# sourceMappingURL=underscore-umd.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.pageRoutingCore = pageRoutingCore;
	
	var _pageUrl = __webpack_require__(206);
	
	var _cookies = __webpack_require__(207);
	
	var _layout = __webpack_require__(208);
	
	var _setting = __webpack_require__(211);
	
	var _pageFileCall = __webpack_require__(715);
	
	//페이지 이동 이벤트 세트
	
	//페이지 라우팅
	
	//쿠키 호출
	function routingSet(param) {
		_pageFileCall.fileLoadFrame.init(param);
		_layout.baseFrame.init(param);
		_setting.pageMoveController.init(param);
	}
	
	//페이지 라우팅 코어
	
	//레이아웃 콜
	function pageRoutingCore(param) {
		$('#container').hide();
		param = param.replace('#', '');
		routingSet(param);
	}
	
	//브라우저 히스토리 저장기능(앞으로가기 뒤로가기)
	function browserHistoryApi(param) {
		window.history.pushState(null, null, param);
	}
	var saveAdvId = null;
	var saveSubID = null;
	var saveDate1 = null;
	var saveDate2 = null;
	///초기 로딩 설정
	function routingPackageController(param) {
		var userCheck = _cookies.cookies.getCookies('user_id');
		var hashParam = document.location.hash;
		var hashLoginPage = '#' + _pageUrl.pageRouting[0].url;
		if (hashParam == '') {
			hashParam = '#/index';
			location.href = '#/index';
		} else if (hashParam != hashLoginPage && userCheck == null) {
			alert('로그인 후 이용 가능합니다');
			hashParam = hashLoginPage;
			location.href = hashLoginPage;
		} else if (hashParam == hashLoginPage && userCheck != null) {
			alert('접속 상태 입니다.');
			hashParam = '#/index';
			location.href = '#/index';
		} else {
			pageRoutingCore(hashParam);
		}
	}
	routingPackageController();
	
	//이동 이벤트 라우팅
	window.addEventListener('hashchange', function (e) {
		routingPackageController();
	});
	
	//글로벌 이벤트
	window.pageRoutingCore = pageRoutingCore;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	//페이지 별 url 및 파일 경로 지정
	var pageRouting = exports.pageRouting = [];
	//서브 페이지 별 추가 js,css 호출 url 조합
	var dataUrlArray = exports.dataUrlArray = [];
	function pagePushFunc() {
		var titleArray = ['오토입찰솔루션 - 로그인', '오토입찰솔루션 - 조회/입찰', '오토입찰솔루션 - 데이터 생성', '오토입찰솔루션 - 즐겨찾기', '오토입찰솔루션 - 환경설정'];
		var urlArray = ['/member/login', '/sub/bidding', '/sub/create', '/sub/favorite', '/sub/setting'];
		var pageUrl = ['/member/login/login.html', '/sub/bidding.html', '/sub/dataCreate.html', '/sub/favorite.html', '/sub/setting.html'];
		var callUrl = ['member/login.min', 'sub/bidding.min', 'sub/create.min', 'sub/favorite.min', 'sub/setting.min'];
		for (var i = 0; i <= titleArray.length; i++) {
			var routeUrl = {
				'title': titleArray[i],
				'url': urlArray[i],
				'callurl': pageUrl[i]
			};
			var dataUrl = {
				'url': urlArray[i],
				'callurl': callUrl[i]
			};
			pageRouting.push(routeUrl);
			dataUrlArray.push(dataUrl);
		}
	}
	pagePushFunc();

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var cookies = exports.cookies = {
		setCookies: function setCookies(userKey, userToken, time) {
			var expire = new Date();
	
			var userCookie = userKey;
			//today.getTime() + 60 * 60 * 1000 * 24 * number_of_days
			expire.setTime(expire.getTime() + time * 3600 * 1000);
			document.cookie = userCookie + "=" + escape(userToken) + "; expires=" + expire.toGMTString() + "; path=/; domain=.emforce.co.kr;";
		},
		getCookies: function getCookies(userKey) {
			var userCookie = userKey;
			var returnValue = null;
	
			var cookie_list = document.cookie.split(';');
			var cookie_map = {};
			for (var i = 0; i < cookie_list.length; i++) {
				var temp = cookie_list[i].split('=');
				cookie_map[temp[0].replace(' ', '')] = temp[1];
			}
			returnValue = cookie_map[userCookie];
	
			return returnValue;
		}
	};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.baseFrame = undefined;
	
	var _ajaxForm = __webpack_require__(209);
	
	var _loading = __webpack_require__(210);
	
	//Header, Footer Call
	//AJAX 프레임
	var baseFrame = exports.baseFrame = {
		init: function init(param) {
			if (param != '/member/login') {
				$('#header, #aside, #footer').show();
				_ajaxForm.ajaxFrame.ajaxHtmlCall('#aside', 'GET', '/layout/aside.html', 'html', true);
			} else {
				$('#header, #aside, #footer').hide();
			}
		}
	};
	//페이지로딩 인터렉션
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.ajaxFrame = undefined;
	
	var _cookies = __webpack_require__(207);
	
	var setFunction; //쿠키 호출
	
	var loadingCount = 0;
	var hashLoginPage = '#/member/login';
	
	var ajaxFrame = exports.ajaxFrame = {
		ajaxSessionCheck: function ajaxSessionCheck() {
			alert('로그인 세션이 만료되었습니다.');
			document.location.hash = '#/member/login';
			location.href = '#/member/login';
		},
		ajaxHtmlCall: function ajaxHtmlCall(id, type, dataUrl, dataType, async, callBack) {
			var hashParam = document.location.hash;
			if (_cookies.cookies.getCookies('user_id') == null && hashParam != hashLoginPage) {
				this.ajaxSessionCheck();
			} else {
				$.ajax({
					type: type,
					url: dataUrl,
					dataType: dataType,
					async: async,
					success: function success(data) {
						$(id).html(data);
						if (callBack !== undefined) {
							callBack();
							loadingCount = 0;
						}
					},
					error: function error() {
						if (loadingCount < 10) {
							loadingCount++;
							ajaxFrame.ajaxHtmlCall(id, type, dataUrl, dataType, async, callBack);
						} else {
							alert('페이지를 불러올 수 없습니다.');
							return;
						}
					}
				});
			}
		},
		ajaxDataCall: function ajaxDataCall(type, dataUrl, dataType, async, callBack, data, etc) {
			var hashParam = document.location.hash;
			if (_cookies.cookies.getCookies('user_id') == null && hashParam != hashLoginPage) {
				this.ajaxSessionCheck();
			} else {
				$.ajax({
					type: type,
					url: dataUrl,
					data: JSON.stringify(data),
					dataType: dataType,
					async: async,
					contentType: "application/json; charset=utf-8",
					xhrFields: {
						withCredentials: true
					},
					success: function success(data) {
						if (data.success == false) {
							if (data.msg != null) {
								alert(data.msg);
							}
						} else {
							callBack(data, etc);
							loadingCount = 0;
						}
					},
					error: function error() {
						if (loadingCount < 10) {
							loadingCount++;
							ajaxFrame.ajaxDataCall(type, dataUrl, dataType, async, callBack, data, etc);
						} else {
							console.error('접속 에러');
							return;
						}
					}
				});
			}
		},
		ajaxAppendCall: function ajaxAppendCall(id, type, dataUrl, dataType, async, callBack, callType) {
			var hashParam = document.location.hash;
			if (_cookies.cookies.getCookies('user_id') == null && hashParam != hashLoginPage) {
				this.ajaxSessionCheck();
			} else {
				$.ajax({
					type: type,
					url: dataUrl,
					dataType: dataType,
					async: async,
					success: function success(data) {
						$(id).parent('*').append(data);
						if (callBack !== undefined) {
							callBack(callType);
						}
					},
					error: function error() {
						alert('페이지를 읽을 수 없습니다.');
					}
				});
			}
		}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var AjaxLoading = exports.AjaxLoading = {
		pageLoading: function pageLoading(type) {
			if (type == 'type1') {
				this.loadingType1();
			} else if (type == 'time') {
				this.loadingType4();
			} else {
				this.loadingType3();
			}
		},
		loadingType1: function loadingType1() {
			var startHtml = "<div id='dataLoading' class='Loading-widget2'>";
			startHtml += "<div class='loading-box'>";
			startHtml += "<span class='loading-text'>";
			startHtml += "<svg version='1.1' id='wrapper' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='273px' height='125.2px' viewBox='0 0 273 125.2' enable-background='new 0 0 273 125.2' xml:space='preserve'>";
			startHtml += "<path class='path' fill='none' stroke='#333333' stroke-width='4' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round' d=' M2,65.7C49.2,3.8,29.8,2.1,27.4,2c-2.4-0.1-4.4,2.2-6.6,5.3c-10.2,14.8-10.4,40.3-8.7,45s4.6,15.3,11.7,16.5 c5.5,0.9,10.8-2.9,14.3-7.4c3.5-4.4,6-9.7,10.2-13.4c4.2-3.7,11.1-5.4,15.4-1.7c-5-0.4-10.3-0.4-14.9,1.7s-8.2,7.1-7.3,12.1 c1.1,5.9,8.5,9.2,14.2,7.3s9.5-7.6,10.8-13.5c0.6-3,0.5-6.5-1.7-8.5c-2.2-2-6.9-0.7-6.7,2.3c0.2,2.1,2.4,3.3,4.4,3.8 c5.5,1.2,11.2-0.7,16.5-2.7c5.3-1.9,11-3.8,16.5-2.4c5.5,1.4,10,7.7,7.5,12.8c-0.6-7.2-7.3-13.4-14.5-13.3 c-7.2,0.2-13.7,7.1-13,14.3s8.6,12.9,15.6,10.8c7.5-2.2,11-11.3,10-19.1c-1.8,3.2-1.5,13.5,0.8,16.3c2.3,2.8,6.5,4,9.9,2.8 c4.4-1.5,6.9-12.1,9.5-16s6.5-7.9,11.1-7.2c5.2,0.8,7.6,6.8,9.1,11.9c0.3-6.2-5.6-12-11.8-11.6c-6.2,0.4-11.3,6.9-10.2,13.1 c1.1,6.1,8.2,10.5,14.2,8.7c7.4-2.2,10.3-11.1,11.3-18.8c1.9-14.6,0.9-29.5-2.8-43.7c-3,16.8-3.3,34-0.9,50.9 c0.8,5.7,2.6,12.3,7.8,14.8c5.8,2.8,12.9-1.2,16-6.8c3-5.6,3-12.4,2.8-18.8c-1.5,5.8-3.1,11.9-1.4,17.7c1.6,5.8,7.7,10.8,13.4,8.9 c5-1.6,7.4-7.5,7.7-12.8s-0.9-10.6,0.1-15.8c-1.8,10.2-0.9,20.9,2.5,30.7c0.5-7.1,1.1-14.3,1.6-21.4c0.2-2.5,0.5-5.4,2.4-7 c3.6-3.1,9.5,0.6,10.8,5.2c1.3,4.6-0.1,9.5,0,14.2c0.1,4,1.8,8.7,5.7,9.7c3.7,1,7.5-2,9.2-5.4c1.8-3.4,2.2-7.4,3.6-11 c1.9-4.7,5.6-8.8,10.4-10.4s10.6-0.3,13.8,3.7s2.9,10.4-1.1,13.6c4.4-4.6,4.4-12.7,0.1-17.5s-12.2-5.5-17.5-1.9s-7.3,11.2-4.8,17.1 c3.1,7.2,12.7,10.8,19.7,7.3c7-3.5,10.1-13.3,6.2-20.1c1.1,20,2.2,40,3.3,60c0.2,3.7,0,8.2-3.3,10c-4.1,2.3-8.9-2.1-10.7-6.5 c-4.6-11-1.6-24.8,7.3-32.9c4.7-4.3,10.8-6.9,15.8-10.9c5-4,9.2-10.1,7.9-16.4'/>";
			startHtml += "<path fill='none' class='path2' stroke='#333333' stroke-width='4' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' d='M177.7,20.2c-2.3-2.5-7-2.1-8.8,0.8c-1.8,2.9,0,7.3,3.3,8.2c2.3,0.6,4.9-0.4,6.2-2.4S179.3,22,177.7,20.2z'/>";
			startHtml += "</svg>";
			startHtml += "</span>";
	
			for (var i = 1; i < 6; i++) {
				startHtml += "<span class='l-" + i + "'></span>";
			}
			startHtml += "</div>";
			startHtml += "</div>";
			$('html').append(startHtml);
			$(document).ajaxStop(function () {
				$('#dataLoading').remove();
			});
		},
		loadingType2: function loadingType2() {
			var startHtml = "<div id='dataLoading' class='Loading-widget2'>";
			startHtml += "<div class='loading-box loading-type-2'>";
			startHtml += "<div class='pacman'></div>";
			startHtml += "<div class='dot'></div>";
			startHtml += "</div>";
			startHtml += "</div>";
			$('html').append(startHtml);
			$(document).ajaxStop(function () {
				$('#dataLoading').remove();
			});
		},
		loadingType3: function loadingType3() {
			var startHtml = "<div id='dataLoading' class='Loading-widget2'>";
			startHtml += "<div class='loading-box'>";
			startHtml += "<span class='loading-text loading-img'>";
			startHtml += "<img src='/image/logo.jpg' alt='로고' />";
			startHtml += "</span>";
	
			for (var i = 1; i < 6; i++) {
				startHtml += "<span class='l-" + i + "'></span>";
			}
			startHtml += "</div>";
			startHtml += "</div>";
			$('html').append(startHtml);
			$(document).ajaxStop(function () {
				$('#dataLoading').remove();
			});
		},
		loadingType4: function loadingType4() {
			var startHtml = "<div id='timeLoading' class='Loading-widget2'>";
			startHtml += "<div class='loading-box'>";
			startHtml += "<span class='loading-text loading-img'>";
			startHtml += "<img src='/image/logo.jpg' alt='로고' />";
			startHtml += "</span>";
	
			for (var i = 1; i < 6; i++) {
				startHtml += "<span class='l-" + i + "'></span>";
			}
			startHtml += "</div>";
			startHtml += "</div>";
			$('html').append(startHtml);
		},
		dataLoading: function dataLoading(btnEl) {
			var loadingHtml = "<div id='loading-bar'>";
			loadingHtml += "<div class='spinner'>";
			for (var i = 0; i <= 8; i++) {
				loadingHtml += "<span class='ball-" + i + "'></span>";
			}
			loadingHtml += "</div>";
			loadingHtml += "</div>";
			$(btnEl).find('a').hide();
			$(btnEl).append(loadingHtml);
			$(document).ajaxStop(function () {
				$(btnEl).find('a').show();
				$('#loading-bar').remove();
			});
		},
		listLoading: function listLoading(listEl) {
			var loadingHtml = "<div id='loading-bar'>";
			loadingHtml += "<div class='spinner'>";
			for (var i = 0; i <= 8; i++) {
				loadingHtml += "<span class='ball-" + i + "'></span>";
			}
			loadingHtml += "</div>";
			loadingHtml += "</div>";
			$(listEl).append(loadingHtml);
			$(document).ajaxStop(function () {
				$(listEl).find('tbody').show();
				$('#loading-bar').remove();
			});
		}
	};
	
	window.AjaxLoading = AjaxLoading;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.pageMoveController = undefined;
	
	var _pageUrl = __webpack_require__(206);
	
	var _ajaxForm = __webpack_require__(209);
	
	var _uiAction = __webpack_require__(212);
	
	var _cookies = __webpack_require__(207);
	
	//UI Actions
	function pageMoveSet(titleText, pageUrl) {
		var pageCallId = '#contents';
		$('title').text(titleText);
		_ajaxForm.ajaxFrame.ajaxHtmlCall(pageCallId, 'GET', pageUrl, 'html', true, _uiAction.baseActions);
	}
	//쿠키 호출
	
	//AJAX 프레임
	var pageMoveController = exports.pageMoveController = {
		init: function init(param) {
			pageMoveController.pageLoad(param);
		},
		pageLoad: function pageLoad(param) {
			var userCheck = _cookies.cookies.getCookies('user_id');
			if (param != _pageUrl.pageRouting[0].url && (userCheck != null || userCheck != '')) {
				for (var i = 0; i <= _pageUrl.pageRouting.length + 1; i++) {
					if (param == _pageUrl.pageRouting[i].url) {
						pageMoveSet(_pageUrl.pageRouting[i].title, _pageUrl.pageRouting[i].callurl);
						break;
					} else if (param == '/' || param == '/index' || param == '') {
						//데이터 생성 페이지 인덱스 화면으로 활용
						pageMoveSet(_pageUrl.pageRouting[2].title, _pageUrl.pageRouting[2].callurl);
						break;
					} else if (i == _pageUrl.pageRouting.length - 1) {
						pageMoveSet('에러:404', '/error/error.html');
						break;
					}
				}
			} else {
				pageMoveSet(_pageUrl.pageRouting[0].title, _pageUrl.pageRouting[0].callurl);
			}
		}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.listCheckAction = exports.tabAction = exports.loginCheck = exports.layerPopup = exports.chartUi = exports.dragChart = exports.btnActions = exports.asideController = undefined;
	exports.baseActions = baseActions;
	
	var _ajaxForm = __webpack_require__(209);
	
	var _cookies = __webpack_require__(207);
	
	__webpack_require__(213);
	
	var _echarts = __webpack_require__(214);
	
	var echarts = _interopRequireWildcard(_echarts);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// import '../../lib/canvasjs.min';
	
	//사이드 컨트롤러
	
	//제이쿼리 UI
	//페이지 AJAX
	var asideController = exports.asideController = {
	    init: function init() {
	        this.sideLink();
	    },
	    asideToggleOnOff: function asideToggleOnOff(el) {
	        $(el).toggleClass('active');
	        $('#container, #footer').toggleClass('asideOff');
	    },
	    sideLink: function sideLink(thisEl, linkType) {
	        var $this = $(thisEl);
	        var domain = location.hostname;
	        var wonLink = '';
	        var neoLink = '';
	        if (domain != 'bid.emforce.co.kr') {
	            wonLink = 'http://beta.wonderbox.emforce.co.kr/';
	            neoLink = 'http://beta.neo.emforce.co.kr/';
	        } else {
	            wonLink = 'http://wonderbox.emforce.co.kr/';
	            neoLink = 'http://neo.emforce.co.kr/';
	        }
	        $('.won_btn').attr('href', wonLink);
	        $('.neo_btn').attr('href', neoLink);
	    }
	};
	//상단 컨트롤러
	
	//라이브러리 호출
	
	//쿠키 호출
	var headerController = {
	    init: function init() {
	        var param = window.location.hash;
	        this.navigationAction(param);
	        this.newsAction();
	    },
	    navigationAction: function navigationAction(param) {
	        $('#navigation').find('li').each(function (i) {
	            var checkAttr = $(this).find('a').attr('href');
	            if (param == checkAttr) {
	                $('#navigation').find('li a').removeClass('active');
	                $(this).find('a').addClass('active');
	            } else if (param == '#/' || param == '#/index') {
	                $('#navigation').find('li a').removeClass('active');
	                $('#navigation').find('li:eq(0) a').addClass('active');
	            }
	        });
	    },
	    newsAction: function newsAction() {}
	};
	
	//btn click Event
	var listCount = 50;
	var btnActions = exports.btnActions = {
	    listMoreBtn: function listMoreBtn(el, callName, count, moreClass) {
	        listCount += count;
	        if (callName == 'bidding') {
	            biddingFunc.ListDataSetting(listCount, moreClass);
	        }
	    },
	    logOutBtn: function logOutBtn() {
	        loginFunc.memberLogOut();
	    },
	    newsDeleteBtn: function newsDeleteBtn(el) {
	        var number = $(el).attr('data-number');
	        $(el).parents('li').remove();
	        alwaysFunc.headerNewsDeleteData(number);
	    },
	    linkBtn: function linkBtn(type) {},
	    prevBtn: function prevBtn() {},
	    toggleBtn: function toggleBtn(type, el) {
	        if (type == 'search') {
	            $(el).stop().slideToggle();
	            biddingFunc.biddingGroupSelectData();
	        }
	    },
	    sortPop: function sortPop(thisEl, type, key) {
	        var $this = $(thisEl);
	        var $popEl = $('.all_view, .media_array');
	        var media = $('.media');
	        if ($this.next().hasClass('active') != true) {
	            $popEl.removeClass('active').hide();
	            $this.next().addClass('active').show();
	        } else {
	            $popEl.removeClass('active').hide();
	        }
	        if (type == 'filter') {
	            favoriteFunc.favoriteFilterData(key);
	        }
	        $(document).keyup(function (e) {
	            if (e.keyCode == 27) {
	                $popEl.removeClass('active').hide();
	            }
	        });
	    },
	    textPop: function textPop(thisEl) {
	        var $this = $(thisEl);
	        $this.parent().find('.rank_text_box').toggle();
	        $(document).keyup(function (e) {
	            if (e.keyCode == 27) {
	                $this.parent().find('.rank_text_box').hide();
	            }
	        });
	    }
	};
	
	//예약 도표 드래그기능
	var dragColor = undefined;
	var dragType = undefined;
	var dragTypeArray = [];
	var addCount = 0;
	var colorObj = {};
	var modifyColor = null;
	var dragChart = exports.dragChart = {
	    init: function init(typeData, device) {
	        this.chartId = $('#drag-graph-box');
	        this.gridBoxEl = this.chartId.find('.grid-box');
	        var addList = this.chartId.find('.add-sch-list');
	        this.chartId.show();
	
	        this._handleEvent();
	        this._conBox(addList, typeData, device);
	    },
	    _conBox: function _conBox(addList, typeData, device) {
	        var typeKeys = Object.keys(typeData);
	        var addBtn = $('#add-sch-btn');
	        var closeBtn = $('#close-pop-btn');
	        var okBtn = $('#add-ok-btn');
	        var modifyBtn = $('#modify-ok-btn');
	        var popEl = $('#drag-add-pop');
	        var commentEl = $('.comment-text');
	        var defaultColor = {};
	        var eChangeColor = null;
	        var typeCheck = false;
	        addCount = 0;
	
	        // 디폴트 컬러 자동 추가
	        $('#type-color option').each(function () {
	            var $this = $(this);
	            var thisColor = $this.val();
	            defaultColor[thisColor] = thisColor;
	        });
	
	        //목표순위 디바이스별 순위 맥스값 변경
	        var goalOptions = function goalOptions() {
	            var maxLength = device == 'mobile' ? 15 : 25;
	            var $select = $('#goal-rank-input');
	            var options = '';
	            for (var i = 1; i <= maxLength; i++) {
	                var val = i < 10 ? '0' + i : i;
	                options += "<option value='" + val + "'>" + i + "</option>";
	            }
	            $select.html(options);
	        };
	
	        goalOptions();
	
	        //타입 생성 기능
	        var colorType = function colorType(nmVal, color, rankVal, maxVal, minVal, cpaVal, typeVal) {
	            addCount++;
	            var html = "<div class='add-type-btn type-" + color + "' data-type='" + typeVal + "' data-color='" + color + "' data-nm='" + nmVal + "' data-rank='" + rankVal + "' data-max='" + maxVal + "' data-min='" + minVal + "' data-cpa='" + cpaVal + "'><button type='button' onclick='dragChart._conBtnEvent(this);' class='add-type add-type-" + color + "' data-color='" + color + "'><span class='color-box'></span><span class='add-name'>" + nmVal + "</span></button><div class='hover-btn-area hide'><button type='button' data-color='" + color + "' class='type-btn-modify' onclick='dragChart._modifyBtn(this)'>수정</button><button type='button' class='type-btn-delete' onclick='dragChart._removeBtn(this);' data-color='" + color + "'>삭제</button></div></div>";
	
	            commentEl.hide();
	            addList.append(html);
	        };
	
	        //컬러 타입 수정
	        var modifyColorType = function modifyColorType(nmVal, color, rankVal, maxVal, minVal, cpaVal, typeVal, modifyColor, $this) {
	            if (confirm('예약을 변경하시겠습니까?') == true) {
	                var elColor = $this.attr('data-color');
	                var typeEl = $('.add-type-btn.type-' + elColor);
	                var typeModifyBtn = typeEl.find('.type-btn-modify, #modify-ok-btn');
	                var dataNames = ['type', 'color', 'nm', 'rank', 'max', 'min', 'cpa'];
	                var dataArray = [typeVal, color, nmVal, rankVal, maxVal, minVal, cpaVal];
	                //정보관련
	                for (var i = 0; i < dataArray.length; i++) {
	                    typeEl.attr('data-' + dataNames[i], dataArray[i]);
	                    typeEl.find('.add-name').text(nmVal);
	                }
	                //컬러관련
	                if (color != modifyColor) {
	                    //타입 정보 변경
	                    typeModifyBtn.attr('data-color', color);
	                    $this.attr('data-color', color);
	                    eChangeColor = color;
	                    typeEl.find('.add-type').addClass('add-type-' + color).removeClass('add-type-' + elColor).attr('data-color', color);
	                    typeEl.addClass('type-' + color).removeClass('type-' + elColor);
	                    //변경 그리드 컬러 변환
	                    $('.grid-box .box-grid').each(function () {
	                        var $this = $(this);
	                        var hasCheck = $this.hasClass('active-' + elColor);
	                        if (hasCheck === true) {
	                            $this.addClass('active-' + color).removeClass('active-' + elColor).attr('data-color', color);
	                        }
	                    });
	                }
	            }
	        };
	        //컬러 체크 OBJ
	        var colorCheckFunc = function colorCheckFunc(callType, modifyColor) {
	            $('.add-sch-list .add-type-btn').each(function (i) {
	                var thisColor = $(this).attr('data-color');
	                colorObj[thisColor] = thisColor;
	            });
	        };
	
	        //타입 저장 기능
	        var typesSave = function typesSave(callType, $this) {
	            colorObj = {};
	            var formId = $('#drag-add-form');
	            var formVal = formId.serializeArray();
	            typeCheck = $('.add-sch-list div').hasClass('add-type-btn');
	            if (callType == 'modify') {
	                var basicColor = $this.attr('data-color');
	                if (eChangeColor == null) {
	                    modifyColor = $this.attr('data-color');
	                } else {
	                    modifyColor = eChangeColor;
	                }
	            }
	            var nmVal = formVal[0].value;
	            var color = formVal[1].value;
	            var typeVal = formVal[2].value;
	            var maxVal = 0;
	            var minVal = 0;
	            var rankVal = 0;
	            var cpaVal = 0;
	            var forLoop = true;
	            if (typeVal == 'Active') {
	                rankVal = formVal[3].value;
	                maxVal = formVal[4].value;
	                minVal = formVal[5].value;
	            } else {
	                cpaVal = formVal[5].value;
	                maxVal = formVal[6].value;
	                minVal = formVal[7].value;
	            }
	
	            var saveData = [];
	            var formCheck = false;
	
	            //컬러 obj 추가
	            colorCheckFunc(callType, modifyColor);
	
	            //폼 유효성 체크
	            formId.find('select, input').each(function (index) {
	                var $this = $(this);
	                var valueCheck = $this.val();
	                var checkMessage = $this.attr('data-message');
	                var validation = $this.attr('validation');
	                if (validation == 'yes') {
	                    var success = false;
	                    var idCheck = $this.attr('id');
	                    var setMax = Number($('#max-bid-input').val());
	                    var setMin = Number($('#min-bid-input').val());
	
	                    if (idCheck.indexOf('2') > -1) {
	                        setMax = Number($('#max-bid-input-2').val());
	                        setMin = Number($('#min-bid-input-2').val());
	                    }
	                    if (idCheck.indexOf('max') > -1 || idCheck.indexOf('min') > -1) {
	                        //최대,최소입찰가 필터
	                        if ('' === setMax || '' === setMin) {
	                            alert('최대입찰가,최소입찰가를 입력해 주세요.');
	                            $this.focus();
	                            formCheck = true;
	                            return false;
	                        } else if (0 < setMax && 0 < setMin) {
	                            if (setMin < setMax) {
	                                if ((0 == setMax || 70 <= setMax) && (0 == setMin || 70 <= setMin)) {
	                                    success = true;
	                                } else {
	                                    alert('최소입찰가,최대입찰가는 70원 미만으로 설정할 수 없습니다.');
	                                    $this.focus();
	                                    formCheck = true;
	                                    return false;
	                                }
	                            } else {
	                                alert('최대입찰가는 최소입찰가 동일하거나 미만으로 설정할 수 없습니다.');
	                                $this.focus();
	                                formCheck = true;
	                                return false;
	                            }
	                        } else {
	                            if ((0 == setMax || 70 <= setMax) && (0 == setMin || 70 <= setMin)) {
	                                success = true;
	                            } else {
	                                alert('최대입찰가,최소입찰가는 70원 미만으로 설정할 수 없습니다.');
	                                $this.focus();
	                                formCheck = true;
	                                return false;
	                            }
	                        }
	                    } else if (valueCheck == '' || valueCheck == undefined || valueCheck == null) {
	                        alert(checkMessage);
	                        $this.focus();
	                        formCheck = true;
	                        return false;
	                    }
	                }
	            });
	            if (formCheck == true) {
	                return false;
	            };
	
	            //타입 유무 체크
	            if (callType == 'save' && typeCheck == false) {
	                addCount = 0;
	            } else if (callType == 'modify') {
	                delete colorObj[basicColor];
	            }
	
	            //타입 추가 필터 기능(저장,수정(save,modify))
	            var colorArray = Object.keys(colorObj);
	            var colorCount = 0;
	
	            if (addCount <= 4 && callType == 'save' || callType == 'modify') {
	                if (colorArray.length == 0) {
	                    if (callType == 'save') {
	                        if (confirm('예약을 생성하시겠습니까?') == true) {
	                            colorType(nmVal, color, rankVal, maxVal, minVal, cpaVal, typeVal, 'create');
	                            colorObj[color] = color;
	                        } else {
	                            return;
	                        }
	                    } else {
	                        alert('수정 할 수 있는 조건이 없습니다. 조건을 생성해주세요.');
	                    }
	                } else {
	                    for (var i = 0; i <= colorArray.length; i++) {
	                        if (callType == 'save') {
	                            colorCount++;
	                            if (colorArray[i] != color) {
	                                if (colorArray.length == colorCount) {
	                                    if (confirm('예약을 생성하시겠습니까?') == true) {
	                                        typeCheck = true;
	                                        colorObj[color] = color;
	                                        colorType(nmVal, color, rankVal, maxVal, minVal, cpaVal, typeVal, 'create');
	                                    } else {
	                                        break;
	                                    }
	                                }
	                            } else {
	                                alert('다른 색상을 사용해주세요.');
	                                break;
	                            }
	                        } else {
	                            colorCount++;
	                            if (colorArray[i] != color || colorArray[i] == modifyColor || modifyColor == color) {
	                                if (colorArray.length == colorCount) {
	                                    if (confirm('예약을 수정하시겠습니까?') == true) {
	                                        typeCheck = true;
	                                        delete colorObj[modifyColor];
	                                        colorObj[color] = color;
	                                        modifyColorType(nmVal, color, rankVal, maxVal, minVal, cpaVal, typeVal, modifyColor, $this);
	                                    } else {
	                                        break;
	                                    }
	                                }
	                            } else {
	                                alert('다른 색상을 사용해주세요.');
	                                break;
	                            }
	                        }
	                    }
	                }
	            } else {
	                alert('더 이상 조건을 생성할 수 없습니다.');
	            }
	        };
	
	        //타입 데이터 반영
	        for (var i = 0; i < typeKeys.length; i++) {
	            var color = typeKeys[i];
	            var nmVal = typeData[color].nm;
	            var typeVal = typeData[color].bid_status;
	            var rankVal = typeData[color].goal_rank;
	            var maxVal = typeData[color].max_bid_amt;
	            var minVal = typeData[color].min_bid_amt;
	            var cpaVal = typeData[color].goal_cpa;
	            colorType(nmVal, color, rankVal, maxVal, minVal, cpaVal, typeVal);
	        }
	
	        //컨트롤 박스 이벤트
	        addBtn.click(function (event) {
	            var formId = $('#drag-add-form');
	            var $rankForm = $('.rank-form-box');
	            var $cpaForm = $('.cpa-form-box');
	
	            $('#choice-1').prop('checked', true);
	            $rankForm.show().find('input').attr('validation', 'yes');
	            $cpaForm.hide().find('input').attr('validation', 'no');
	            //폼 유효성 체크
	            formId.find('input, select').each(function () {
	                var $this = $(this);
	                var type = $this.attr('type');
	
	                if (type == 'number' || type == 'text') {
	                    $this.val('0');
	                } else {
	                    $this.find('option:eq(0)').prop('selected', true);
	                    $('#type-color').attr('class', '').addClass('color-blue');
	                }
	            });
	            popEl.show();
	            okBtn.show();
	            modifyBtn.hide();
	            colorCheckFunc();
	        });
	        //설정 팝업 닫기
	        closeBtn.click(function (event) {
	            popEl.hide();
	        });
	        //설정 팝업 저장
	        okBtn.click(function (event) {
	            typesSave('save');
	        });
	        //설정 팝업 수정
	        modifyBtn.click(function (event) {
	            var $this = $(this);
	            typesSave('modify', $this);
	        });
	    },
	    //조건 클릭 버튼
	    _conBtnEvent: function _conBtnEvent(thisEl) {
	        var $this = $(thisEl);
	        dragColor = $this.find('.color-box').css('background-color');
	        dragType = $this.attr('data-color');
	        $('.add-type').removeClass('on');
	        $this.addClass('on');
	    },
	    //조건 수정 버튼
	    _modifyBtn: function _modifyBtn(thisEl) {
	        var popEl = $('#drag-add-pop');
	        var $this = $(thisEl);
	        modifyColor = $this.attr('data-color');
	        var parentsEl = '.add-type-btn';
	
	        //데이터
	        var dType = $this.parents(parentsEl).attr('data-type');
	        var dColor = $this.parents(parentsEl).attr('data-color');
	        var dNm = $this.parents(parentsEl).attr('data-nm');
	        var dRank = $this.parents(parentsEl).attr('data-rank') - 1;
	        var dMax = $this.parents(parentsEl).attr('data-max');
	        var dMin = $this.parents(parentsEl).attr('data-min');
	        var dCpa = $this.parents(parentsEl).attr('data-cpa');
	
	        //엘리먼트
	        var $nm = $('#nm-input');
	        var $rank = $('#goal-rank-input');
	        var $color = $('#type-color');
	        var $max1 = $('#max-bid-input');
	        var $min1 = $('#min-bid-input');
	        var $cpa = $('#goal-cpa-input');
	        var $max2 = $('#max-bid-input2');
	        var $min2 = $('#min-bid-input2');
	        var $rankForm = $('.rank-form-box');
	        var $cpaForm = $('.cpa-form-box');
	
	        //수정 버튼 액션
	        popEl.show();
	        $('#add-ok-btn').hide();
	        $('#modify-ok-btn').show();
	        $('#modify-ok-btn').attr('data-color', modifyColor);
	        $nm.val(dNm);
	        $color.find('.color-' + dColor).prop('selected', true);
	        $color.attr('class', '').addClass('color-' + dColor);
	
	        //타입체크 유효성 변환
	        if (dType == 'Active') {
	            $('#choice-1').prop('checked', true);
	            $rank.find('option:eq(' + dRank + ')').prop('selected', true);
	            $max1.val(dMax);
	            $min1.val(dMin);
	            $rankForm.show().find('input').attr('validation', 'yes');
	            $cpaForm.hide().find('input').attr('validation', 'no');
	        } else {
	            $('#choice-2').prop('checked', true);
	            $cpa.val(dCpa);
	            $max2.val(dMax);
	            $min2.val(dMin);
	            $rankForm.hide().find('input').attr('validation', 'no');
	            $cpaForm.show().find('input').attr('validation', 'yes');
	        }
	    },
	    //조건 삭제 버튼
	    _removeBtn: function _removeBtn(thisEl) {
	        var $this = $(thisEl);
	        var thisColor = $this.attr('data-color');
	        var onCheck = $this.parent().prev().hasClass('on');
	        if (confirm('설정된 예약 스케줄도 함께 삭제됩니다. 조건을 삭제하시겠습니까?') == true) {
	            addCount--;
	            delete colorObj[thisColor];
	            //삭제값 초기화
	            if (onCheck === true) {
	                dragType = undefined;
	            }
	            if (addCount == 0) {
	                $('.comment-text').show();
	            }
	            $this.parents('.add-type-btn').remove();
	            $('.grid-box .box-grid').each(function () {
	                var $this = $(this);
	                var dataColor = $this.attr('data-color');
	                var resetColors = dataColor.replace(thisColor, '');
	                $this.removeClass('active-' + thisColor).attr('data-color', resetColors);
	            });
	        }
	    },
	    //설정 컬러 변경
	    _boxColorChange: function _boxColorChange(thisEl) {
	        var $this = $(thisEl);
	        var color = $this.val();
	        $this.attr('class', '').addClass('color-' + color);
	    },
	    //설정 타입 변경
	    _typeChange: function _typeChange(thisEl) {
	        var $this = $(thisEl);
	        var typeCheck = $this.val();
	        var $rankForm = $('.rank-form-box');
	        var $cpaForm = $('.cpa-form-box');
	        if (typeCheck == 'Active') {
	            $rankForm.show().find('input').attr('validation', 'yes');
	            $cpaForm.hide().find('input').attr('validation', 'no');
	        } else {
	            $rankForm.hide().find('input').attr('validation', 'no');
	            $cpaForm.show().find('input').attr('validation', 'yes');
	        }
	    },
	    //예약 스케줄 이벤트 핸들러
	    _handleEvent: function _handleEvent() {
	        var $gridBoxEl = this.gridBoxEl;
	
	        $gridBoxEl.selectable().on('selectablestop', function (event) {
	            if (dragType != undefined) {
	                var selUi = $('.box-grid.ui-selected');
	                var selCheck = selUi.hasClass('active');
	                var colorCheck = [];
	                $('.add-sch-list .add-type-btn').each(function () {
	                    var thisColor = $(this).find('.add-type').attr('data-color');
	                    colorCheck.push(thisColor);
	                });
	                if (selCheck === true) {
	                    for (var i = 0; i <= colorCheck.length; i++) {
	                        selUi.removeClass('active-' + colorCheck[i]).attr('data-color', '');
	                    }
	                }
	                selUi.addClass('active active-' + dragType).attr('data-color', dragType);
	            } else {
	                alert('조건을 선택하세요.');
	                event.preventDefault();
	            }
	        });
	    }
	
	    //chart Controller
	};var chartUi = exports.chartUi = {
	    init: function init(data, type) {
	        var chartData = data;
	        var target = data.target;
	        var settingData = chartUi._set(chartData, type, target);
	        var ctx = document.getElementById("chartContainer");
	        this.chart = echarts.init(ctx);
	        var charts = this.chart;
	        charts.setOption(settingData, true);
	    },
	    _set: function _set(data, type, target) {
	        var seDatas = [];
	        var chartData = data.chart_data;
	        var dataTitle = Object.keys(chartData).sort();
	
	        if (type == 'chart1') {
	            var trueData = data.true_sites;
	            var select = {};
	            var x = {};
	            var y = [0];
	            var yLength = 15;
	            if (target != 'mobile') {
	                yLength = 25;
	            }
	            for (var i = yLength; i > 0; i--) {
	                y.push(i);
	            }
	            var dateOne = null;
	            var rankOne = null;
	            var lengCut = 25;
	            for (var idx = 0; idx < dataTitle.length; idx++) {
	                dateOne = chartData[dataTitle[idx]];
	                for (var key in dateOne) {
	                    rankOne = dateOne[key];
	                    rankOne.site = rankOne.site.substring(0, lengCut);
	                    if (!x.hasOwnProperty(rankOne.site)) {
	                        x[rankOne.site] = new Array();
	                        x[rankOne.site].length = idx;
	                    }
	                    x[rankOne.site].push(rankOne.rank);
	                }
	
	                for (var xKey in x) {
	                    x[xKey].length = idx + 1;
	                }
	            }
	
	            var nameKey = Object.keys(x);
	            var maxLength = nameKey.length;
	            var startLength = 0;
	            for (var i = 0; i < maxLength; i++) {
	                for (var i2 = 0; i2 < x[nameKey[i]].length; i2++) {
	                    var dataRank = x[nameKey[i]][i2];
	                    if (dataRank == undefined) {
	                        x[nameKey[i]][i2] = 0;
	                    }
	                }
	
	                var seData = {
	                    name: nameKey[i],
	                    type: 'line',
	                    data: x[nameKey[i]]
	                };
	
	                startLength = x[nameKey[i]].length;
	                seDatas.push(seData);
	            }
	            var perInt = function perInt(length) {
	                var returnPer = 100 - Math.round(length / startLength * 100);
	                return returnPer;
	            };
	            //option
	            var zoomStart = perInt(6);
	            var zoomEnd = 100;
	            var boundary = false;
	
	            for (var idx = 0; idx < nameKey.length; idx++) {
	                select[nameKey[idx]] = false;
	            }
	            for (var i = 0; i < trueData.length; i++) {
	                select[trueData[i]] = true;
	            }
	
	            var legendSet = {
	                type: 'scroll',
	                orient: 'vertical',
	                data: nameKey,
	                width: 200,
	                height: 292,
	                itemGap: 10,
	                padding: [0, // up
	                0, // right
	                10, // down
	                0],
	                textStyle: {
	                    fontSize: 13
	                },
	                z: 1,
	                top: 35,
	                left: 0,
	                selected: select
	            };
	            var yAxisSet = {
	                type: 'category',
	                data: y
	            };
	        } else {
	            var nameKey = data.kwd_nm;
	            //option
	            var zoomStart = 0;
	            var zoomEnd = 100;
	            var boundary = [0, '100%'];
	            var legendSet = {
	                data: [nameKey],
	                width: 200,
	                height: 300,
	                padding: 5,
	                top: 30,
	                left: 0
	            };
	            var yAxisSet = {
	                type: 'value',
	                data: y
	            };
	
	            var x = [];
	            for (var i = 0; i < dataTitle.length; i++) {
	                x.push(chartData[dataTitle[i]]);
	            }
	
	            var y = x;
	
	            var seData = {
	                name: nameKey,
	                type: 'line',
	                data: x
	            };
	            seDatas.push(seData);
	        }
	
	        var setting = {
	            tooltip: {
	                trigger: 'axis'
	            },
	            dataZoom: [{
	                show: true,
	                realtime: true,
	                start: zoomStart,
	                end: zoomEnd
	            }, {
	                type: 'inside',
	                realtime: true,
	                start: zoomStart,
	                end: zoomEnd
	            }],
	            toolbox: {
	                show: true,
	                right: '7%',
	                top: '0',
	                feature: {
	                    mark: {
	                        show: false,
	                        title: {
	                            mark: 'mark',
	                            markUndo: 'markUndo',
	                            markClear: 'markClear'
	                        },
	                        lineStyle: {
	                            width: 2,
	                            color: '#1e90ff',
	                            type: 'dashed'
	                        }
	                    },
	                    dataZoom: {
	                        yAxisIndex: 'none',
	                        show: true,
	                        title: {
	                            zoom: '영역확대',
	                            back: '뒤로가기'
	                        }
	                    },
	                    magicType: {
	                        show: true,
	                        title: {
	                            line: '라인',
	                            bar: '그래프',
	                            stack: 'stack',
	                            tiled: 'tiled',
	                            force: 'force',
	                            chord: 'chord',
	                            pie: '파이',
	                            funnel: 'funnel'
	                        }
	                    },
	                    restore: {
	                        show: true,
	                        title: '업데이트'
	                    },
	                    saveAsImage: {
	                        show: false,
	                        title: '이미지저장'
	                    }
	                }
	            },
	            grid: {
	                left: 220,
	                right: '8%',
	                top: 30,
	                bottom: '13%',
	                containLabel: true
	            },
	            legend: legendSet,
	            xAxis: {
	                type: 'category',
	                boundaryGap: boundary,
	                data: dataTitle
	            },
	            yAxis: yAxisSet,
	            series: seDatas
	        };
	        return setting;
	    },
	    _resetZoom: function _resetZoom() {
	        this.chart.resetZoom();
	    }
	
	    //PopUp Event
	};var layerPopup = exports.layerPopup = {
	    init: function init() {
	        this.toggle();
	    },
	    open: function open(thisEl, elId) {
	        var elThis = '#' + elId;
	        var $this = $(thisEl);
	        var $listEl = $('#bid-list-body-1');
	        var $listEl2 = $('#bid-list-body-2');
	        var type = $this.attr('data-name');
	        var callBackFunc = null;
	        var autoKey = false;
	        var manualKey = false;
	        var allPopChecked = function allPopChecked() {
	            var thisType = $(thisEl).attr('data-type');
	            var thisKey = $(thisEl).attr('data-key');
	            if (thisType == 'single') {
	                $('#bid-list-body tr').find("input[type='checkbox']").prop('checked', false);
	                $('.' + thisKey).find("input[type='checkbox']").prop('checked', true);
	            }
	        };
	        //공용 팝업
	        var popUpType = ['/popup/condition.html', '/popup/addKeyword.html', '/popup/moveKeyword.html', '/popup/manualBid.html', '/popup/addFavorite.html', '/popup/history.html', '/popup/advSetting.html', '/popup/layerPopupData.html'];
	
	        //일괄설정용 팝업(즐겨찾기)
	        var favoritePop = ['/popup/setPopRank.html', '/popup/setPopCpa.html', '/popup/setPopTarget.html', '/popup/setPopBooking.html', '/popup/setPopRate.html'];
	        //단독 팝업(즐겨찾기)
	        var favoritePop2 = ['/popup/booking.html', '/popup/chart.html', '/popup/target.html', '/popup/rate.html', '/popup/rate_cpa.html'];
	
	        var onCheck = $this.find('>input').prop('checked');
	        //자동입찰,수동입찰 체크
	        $listEl.find("tr input[type='checkbox']").each(function () {
	            var $this = $(this);
	            var key = $this.attr('data-id');
	            var bidStatusCheck = $this.find('.bidStatus-td > p').attr('data-status');
	            var check = $this.prop('checked');
	            if (check == true) {
	                if (bidStatusCheck != 'Inactive') {
	                    autoKey = true;
	                } else {
	                    manualKey = true;
	                }
	            }
	        });
	
	        if (onCheck == false || onCheck == undefined) {
	            $('.layer-pop, .fixed-pop').remove();
	            //전 페이지 공용
	            if (type == 'createCondition') {
	                var thisData = $this.data("id");
	                var thisListId = $('.' + thisData).attr('data-id');
	                _ajaxForm.ajaxFrame.ajaxAppendCall(elThis, 'GET', popUpType[0], 'html', true);
	                createFunc.createConditionPopUpDate(thisListId);
	            } else if (type == 'keywordsInsertBidFavorite') {
	                _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[4], 'html', true, biddingFunc.openBidFavoritePopUp);
	            } else if (type == 'bidChange') {
	                _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[3], 'html', true, biddingFunc.openBidAmtPopup);
	            } else if (type == "history") {
	                var dataKey = $(thisEl).data("key");
	                _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[5], 'html', true, favoriteFunc.favoriteHistoryPop, dataKey);
	            } else if (type == 'advSetting') {
	                _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[6], 'html', true, alwaysFunc.advSettingPop);
	            }
	
	            //즐겨찾기 수동입찰 팝업
	            else if (type == "bidFavorite") {
	                    _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[3], 'html', true, favoriteFunc.favoriteBidAllChangePopUp);
	                }
	                //즐겨찾기 키워드 추가,이동 팝업
	                else if (type == "MoveFavorite") {
	                        _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[2], 'html', true, favoriteFunc.favoriteKeywordMovePop);
	                    } else if (type == "favoriteKeyword") {
	                        _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', popUpType[1], 'html', true, favoriteFunc.favoriteKeywordPopUp);
	                    }
	
	                    //즐겨찾기 일괄설정 팝업
	                    else if (type == 'setPop-1') {
	                            allPopChecked();
	                            _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop[0], 'html', true, favoriteFunc.favoriteBidSetPopCallBack1);
	                        } else if (type == 'setPop-2') {
	                            allPopChecked();
	                            _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop[1], 'html', true, favoriteFunc.favoriteBidSetPopCallBack2);
	                        } else if (type == 'setPop-3') {
	                            allPopChecked();
	                            _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop[2], 'html', true, favoriteFunc.favoriteBidSetPopCallBack3);
	                        } else if (type == 'setPop-5') {
	                            allPopChecked();
	                            _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop[3], 'html', true, favoriteFunc.favoriteScheDuleData, 'multi');
	                        } else if (type == 'setPop-6') {
	                            allPopChecked();
	                            _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop[4], 'html', true, favoriteFunc.favoriteBidSetPopCallBack6);
	                        }
	
	                        //즐겨 찾기 예약, 타겟설정, 그래프 팝업
	                        else if (type == 'booking') {
	                                var keywordKey = $this.parents('tr').data("id");
	                                _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop2[0], 'html', true, favoriteFunc.favoriteScheDuleData, keywordKey);
	                            } else if (type == 'chart1' || type == 'chart2' || type == 'chart3') {
	                                var keywordKey = $this.data("key");
	                                var types = [type, keywordKey];
	                                _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop2[1], 'html', true, favoriteFunc.favoriteChartData, types);
	                            } else if (type == 'target') {
	                                var thisKey = $(thisEl).parents('tr').attr('data-id');
	                                _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop2[2], 'html', true, favoriteFunc.favoriteTargetCallBack, thisKey);
	                            } else if (type == 'rate') {
	                                var thisKey = $(thisEl).parents('tr').attr('data-id');
	                                _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop2[3], 'html', true, favoriteFunc.favoriteRateData, thisKey);
	                            } else if (type == 'rateCpa') {
	                                var thisKey = $(thisEl).parents('tr').attr('data-id');
	                                _ajaxForm.ajaxFrame.ajaxAppendCall('#wrap', 'GET', favoritePop2[4], 'html', true, favoriteFunc.favoriteRateCpaData, thisKey);
	                            }
	        } else {
	            return;
	        }
	
	        setTimeout(function () {
	            $(".fixed-pop > div, .pop_type01").draggable({
	                handle: $(".popup-title")
	            });
	            $("#drag-add-pop").draggable({
	                handle: $("#drag-add-pop h4")
	            });
	            $(document).keyup(function (e) {
	                if (e.keyCode == 27) {
	                    layerPopup.close();
	                }
	            });
	        }, 500);
	    },
	    close: function close() {
	        $('.layer-pop, .fixed-pop').fadeOut(200);
	        setTimeout(function () {
	            $('.layer-pop, .fixed-pop').remove();
	        }, 200);
	    },
	    toggle: function toggle(el, thisEl) {
	        $(el).toggle();
	        $(thisEl).toggleClass('active');
	        if (el == '.news-popup') {
	            $(thisEl).find('.member-icon').toggleClass('active');
	            $(thisEl).find('.member-icon').attr('src', '/image/common/notice_icon_on.png');
	        }
	    }
	};
	
	//로그인 로그아웃 교체
	var loginCheck = exports.loginCheck = {
	    init: function init() {
	        this.loginOnOff();
	    },
	    loginOnOff: function loginOnOff() {
	        var userCheck = _cookies.cookies.getCookies('user_id');
	        if (userCheck != null) {
	            $('.user-nomember').remove();
	        } else {
	            $('.user-member').remove();
	        }
	    }
	};
	
	var tabAction = exports.tabAction = {
	    init: function init() {},
	    tabChange: function tabChange(contents, btnEl) {
	        var contentsEl = $('#' + contents);
	        $('.tab-contents, .tab_btn_wrap button').removeClass('active');
	        $(btnEl).addClass('active');
	        $(contentsEl).addClass('active');
	    }
	};
	
	var listCheckAction = exports.listCheckAction = {
	    init: function init() {},
	    allCheck: function allCheck() {
	        var allCheckProp = $('.list-all-check').prop('checked');
	        $('.table-list-body').find('tr').each(function () {
	            var hideCheck = $(this).hasClass('hide');
	            var checkProp = $('.list-check').prop('checked');
	            if (allCheckProp == true) {
	                if (hideCheck == false) {
	                    $(this).find('.list-check').prop('checked', true);
	                }
	            } else {
	                $(this).find('.list-check').prop('checked', false);
	            }
	            favoriteFunc.favoriteBtnOnOffEvent();
	        });
	    }
	
	    //WINDOW CALL
	};window.headerController = headerController;
	window.asideController = asideController;
	window.btnActions = btnActions;
	window.layerPopup = layerPopup;
	window.loginCheck = loginCheck;
	window.listCheckAction = listCheckAction;
	window.tabAction = tabAction;
	window.dragChart = dragChart;
	window.chartUi = chartUi;
	
	function baseActions() {
	    asideController.init();
	    headerController.init();
	    layerPopup.init();
	    listCheckAction.init();
	    alwaysFunc.init();
	    loginCheck.init();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*! jQuery UI - v1.12.1 - 2016-09-14
	* http://jqueryui.com
	* Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
	* Copyright jQuery Foundation and other contributors; Licensed MIT */(function(factory){if(true){// AMD. Register as an anonymous module.
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(201)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else{// Browser globals
	factory(jQuery);}})(function($){$.ui=$.ui||{};var version=$.ui.version="1.12.1";/*!
	 * jQuery UI Widget 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Widget
	//>>group: Core
	//>>description: Provides a factory for creating stateful widgets with a common API.
	//>>docs: http://api.jqueryui.com/jQuery.widget/
	//>>demos: http://jqueryui.com/widget/
	var widgetUuid=0;var widgetSlice=Array.prototype.slice;$.cleanData=function(orig){return function(elems){var events,elem,i;for(i=0;(elem=elems[i])!=null;i++){try{// Only trigger remove when necessary to save time
	events=$._data(elem,"events");if(events&&events.remove){$(elem).triggerHandler("remove");}// Http://bugs.jquery.com/ticket/8235
	}catch(e){}}orig(elems);};}($.cleanData);$.widget=function(name,base,prototype){var existingConstructor,constructor,basePrototype;// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype={};var namespace=name.split(".")[0];name=name.split(".")[1];var fullName=namespace+"-"+name;if(!prototype){prototype=base;base=$.Widget;}if($.isArray(prototype)){prototype=$.extend.apply(null,[{}].concat(prototype));}// Create selector for plugin
	$.expr[":"][fullName.toLowerCase()]=function(elem){return!!$.data(elem,fullName);};$[namespace]=$[namespace]||{};existingConstructor=$[namespace][name];constructor=$[namespace][name]=function(options,element){// Allow instantiation without "new" keyword
	if(!this._createWidget){return new constructor(options,element);}// Allow instantiation without initializing for simple inheritance
	// must use "new" keyword (the code above always passes args)
	if(arguments.length){this._createWidget(options,element);}};// Extend with the existing constructor to carry over any static properties
	$.extend(constructor,existingConstructor,{version:prototype.version,// Copy the object used to create the prototype in case we need to
	// redefine the widget later
	_proto:$.extend({},prototype),// Track widgets that inherit from this widget in case this widget is
	// redefined after a widget inherits from it
	_childConstructors:[]});basePrototype=new base();// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options=$.widget.extend({},basePrototype.options);$.each(prototype,function(prop,value){if(!$.isFunction(value)){proxiedPrototype[prop]=value;return;}proxiedPrototype[prop]=function(){function _super(){return base.prototype[prop].apply(this,arguments);}function _superApply(args){return base.prototype[prop].apply(this,args);}return function(){var __super=this._super;var __superApply=this._superApply;var returnValue;this._super=_super;this._superApply=_superApply;returnValue=value.apply(this,arguments);this._super=__super;this._superApply=__superApply;return returnValue;};}();});constructor.prototype=$.widget.extend(basePrototype,{// TODO: remove support for widgetEventPrefix
	// always use the name + a colon as the prefix, e.g., draggable:start
	// don't prefix for widgets that aren't DOM-based
	widgetEventPrefix:existingConstructor?basePrototype.widgetEventPrefix||name:name},proxiedPrototype,{constructor:constructor,namespace:namespace,widgetName:name,widgetFullName:fullName});// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if(existingConstructor){$.each(existingConstructor._childConstructors,function(i,child){var childPrototype=child.prototype;// Redefine the child widget using the same prototype that was
	// originally used, but inherit from the new version of the base
	$.widget(childPrototype.namespace+"."+childPrototype.widgetName,constructor,child._proto);});// Remove the list of existing child constructors from the old constructor
	// so the old child constructors can be garbage collected
	delete existingConstructor._childConstructors;}else{base._childConstructors.push(constructor);}$.widget.bridge(name,constructor);return constructor;};$.widget.extend=function(target){var input=widgetSlice.call(arguments,1);var inputIndex=0;var inputLength=input.length;var key;var value;for(;inputIndex<inputLength;inputIndex++){for(key in input[inputIndex]){value=input[inputIndex][key];if(input[inputIndex].hasOwnProperty(key)&&value!==undefined){// Clone objects
	if($.isPlainObject(value)){target[key]=$.isPlainObject(target[key])?$.widget.extend({},target[key],value):// Don't extend strings, arrays, etc. with objects
	$.widget.extend({},value);// Copy everything else by reference
	}else{target[key]=value;}}}}return target;};$.widget.bridge=function(name,object){var fullName=object.prototype.widgetFullName||name;$.fn[name]=function(options){var isMethodCall=typeof options==="string";var args=widgetSlice.call(arguments,1);var returnValue=this;if(isMethodCall){// If this is an empty collection, we need to have the instance method
	// return undefined instead of the jQuery instance
	if(!this.length&&options==="instance"){returnValue=undefined;}else{this.each(function(){var methodValue;var instance=$.data(this,fullName);if(options==="instance"){returnValue=instance;return false;}if(!instance){return $.error("cannot call methods on "+name+" prior to initialization; "+"attempted to call method '"+options+"'");}if(!$.isFunction(instance[options])||options.charAt(0)==="_"){return $.error("no such method '"+options+"' for "+name+" widget instance");}methodValue=instance[options].apply(instance,args);if(methodValue!==instance&&methodValue!==undefined){returnValue=methodValue&&methodValue.jquery?returnValue.pushStack(methodValue.get()):methodValue;return false;}});}}else{// Allow multiple hashes to be passed on init
	if(args.length){options=$.widget.extend.apply(null,[options].concat(args));}this.each(function(){var instance=$.data(this,fullName);if(instance){instance.option(options||{});if(instance._init){instance._init();}}else{$.data(this,fullName,new object(options,this));}});}return returnValue;};};$.Widget=function()/* options, element */{};$.Widget._childConstructors=[];$.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{classes:{},disabled:false,// Callbacks
	create:null},_createWidget:function _createWidget(options,element){element=$(element||this.defaultElement||this)[0];this.element=$(element);this.uuid=widgetUuid++;this.eventNamespace="."+this.widgetName+this.uuid;this.bindings=$();this.hoverable=$();this.focusable=$();this.classesElementLookup={};if(element!==this){$.data(element,this.widgetFullName,this);this._on(true,this.element,{remove:function remove(event){if(event.target===element){this.destroy();}}});this.document=$(element.style?// Element within the document
	element.ownerDocument:// Element is window or document
	element.document||element);this.window=$(this.document[0].defaultView||this.document[0].parentWindow);}this.options=$.widget.extend({},this.options,this._getCreateOptions(),options);this._create();if(this.options.disabled){this._setOptionDisabled(this.options.disabled);}this._trigger("create",null,this._getCreateEventData());this._init();},_getCreateOptions:function _getCreateOptions(){return{};},_getCreateEventData:$.noop,_create:$.noop,_init:$.noop,destroy:function destroy(){var that=this;this._destroy();$.each(this.classesElementLookup,function(key,value){that._removeClass(value,key);});// We can probably remove the unbind calls in 2.0
	// all event bindings should go through this._on()
	this.element.off(this.eventNamespace).removeData(this.widgetFullName);this.widget().off(this.eventNamespace).removeAttr("aria-disabled");// Clean up events and states
	this.bindings.off(this.eventNamespace);},_destroy:$.noop,widget:function widget(){return this.element;},option:function option(key,value){var options=key;var parts;var curOption;var i;if(arguments.length===0){// Don't return a reference to the internal hash
	return $.widget.extend({},this.options);}if(typeof key==="string"){// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
	options={};parts=key.split(".");key=parts.shift();if(parts.length){curOption=options[key]=$.widget.extend({},this.options[key]);for(i=0;i<parts.length-1;i++){curOption[parts[i]]=curOption[parts[i]]||{};curOption=curOption[parts[i]];}key=parts.pop();if(arguments.length===1){return curOption[key]===undefined?null:curOption[key];}curOption[key]=value;}else{if(arguments.length===1){return this.options[key]===undefined?null:this.options[key];}options[key]=value;}}this._setOptions(options);return this;},_setOptions:function _setOptions(options){var key;for(key in options){this._setOption(key,options[key]);}return this;},_setOption:function _setOption(key,value){if(key==="classes"){this._setOptionClasses(value);}this.options[key]=value;if(key==="disabled"){this._setOptionDisabled(value);}return this;},_setOptionClasses:function _setOptionClasses(value){var classKey,elements,currentElements;for(classKey in value){currentElements=this.classesElementLookup[classKey];if(value[classKey]===this.options.classes[classKey]||!currentElements||!currentElements.length){continue;}// We are doing this to create a new jQuery object because the _removeClass() call
	// on the next line is going to destroy the reference to the current elements being
	// tracked. We need to save a copy of this collection so that we can add the new classes
	// below.
	elements=$(currentElements.get());this._removeClass(currentElements,classKey);// We don't use _addClass() here, because that uses this.options.classes
	// for generating the string of classes. We want to use the value passed in from
	// _setOption(), this is the new value of the classes option which was passed to
	// _setOption(). We pass this value directly to _classes().
	elements.addClass(this._classes({element:elements,keys:classKey,classes:value,add:true}));}},_setOptionDisabled:function _setOptionDisabled(value){this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!!value);// If the widget is becoming disabled, then nothing is interactive
	if(value){this._removeClass(this.hoverable,null,"ui-state-hover");this._removeClass(this.focusable,null,"ui-state-focus");}},enable:function enable(){return this._setOptions({disabled:false});},disable:function disable(){return this._setOptions({disabled:true});},_classes:function _classes(options){var full=[];var that=this;options=$.extend({element:this.element,classes:this.options.classes||{}},options);function processClassString(classes,checkOption){var current,i;for(i=0;i<classes.length;i++){current=that.classesElementLookup[classes[i]]||$();if(options.add){current=$($.unique(current.get().concat(options.element.get())));}else{current=$(current.not(options.element).get());}that.classesElementLookup[classes[i]]=current;full.push(classes[i]);if(checkOption&&options.classes[classes[i]]){full.push(options.classes[classes[i]]);}}}this._on(options.element,{"remove":"_untrackClassesElement"});if(options.keys){processClassString(options.keys.match(/\S+/g)||[],true);}if(options.extra){processClassString(options.extra.match(/\S+/g)||[]);}return full.join(" ");},_untrackClassesElement:function _untrackClassesElement(event){var that=this;$.each(that.classesElementLookup,function(key,value){if($.inArray(event.target,value)!==-1){that.classesElementLookup[key]=$(value.not(event.target).get());}});},_removeClass:function _removeClass(element,keys,extra){return this._toggleClass(element,keys,extra,false);},_addClass:function _addClass(element,keys,extra){return this._toggleClass(element,keys,extra,true);},_toggleClass:function _toggleClass(element,keys,extra,add){add=typeof add==="boolean"?add:extra;var shift=typeof element==="string"||element===null,options={extra:shift?keys:extra,keys:shift?element:keys,element:shift?this.element:element,add:add};options.element.toggleClass(this._classes(options),add);return this;},_on:function _on(suppressDisabledCheck,element,handlers){var delegateElement;var instance=this;// No suppressDisabledCheck flag, shuffle arguments
	if(typeof suppressDisabledCheck!=="boolean"){handlers=element;element=suppressDisabledCheck;suppressDisabledCheck=false;}// No element argument, shuffle and use this.element
	if(!handlers){handlers=element;element=this.element;delegateElement=this.widget();}else{element=delegateElement=$(element);this.bindings=this.bindings.add(element);}$.each(handlers,function(event,handler){function handlerProxy(){// Allow widgets to customize the disabled handling
	// - disabled as an array instead of boolean
	// - disabled class as method for disabling individual parts
	if(!suppressDisabledCheck&&(instance.options.disabled===true||$(this).hasClass("ui-state-disabled"))){return;}return(typeof handler==="string"?instance[handler]:handler).apply(instance,arguments);}// Copy the guid so direct unbinding works
	if(typeof handler!=="string"){handlerProxy.guid=handler.guid=handler.guid||handlerProxy.guid||$.guid++;}var match=event.match(/^([\w:-]*)\s*(.*)$/);var eventName=match[1]+instance.eventNamespace;var selector=match[2];if(selector){delegateElement.on(eventName,selector,handlerProxy);}else{element.on(eventName,handlerProxy);}});},_off:function _off(element,eventName){eventName=(eventName||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace;element.off(eventName).off(eventName);// Clear the stack to avoid memory leaks (#10056)
	this.bindings=$(this.bindings.not(element).get());this.focusable=$(this.focusable.not(element).get());this.hoverable=$(this.hoverable.not(element).get());},_delay:function _delay(handler,delay){function handlerProxy(){return(typeof handler==="string"?instance[handler]:handler).apply(instance,arguments);}var instance=this;return setTimeout(handlerProxy,delay||0);},_hoverable:function _hoverable(element){this.hoverable=this.hoverable.add(element);this._on(element,{mouseenter:function mouseenter(event){this._addClass($(event.currentTarget),null,"ui-state-hover");},mouseleave:function mouseleave(event){this._removeClass($(event.currentTarget),null,"ui-state-hover");}});},_focusable:function _focusable(element){this.focusable=this.focusable.add(element);this._on(element,{focusin:function focusin(event){this._addClass($(event.currentTarget),null,"ui-state-focus");},focusout:function focusout(event){this._removeClass($(event.currentTarget),null,"ui-state-focus");}});},_trigger:function _trigger(type,event,data){var prop,orig;var callback=this.options[type];data=data||{};event=$.Event(event);event.type=(type===this.widgetEventPrefix?type:this.widgetEventPrefix+type).toLowerCase();// The original event may come from any element
	// so we need to reset the target on the new event
	event.target=this.element[0];// Copy original event properties over to the new event
	orig=event.originalEvent;if(orig){for(prop in orig){if(!(prop in event)){event[prop]=orig[prop];}}}this.element.trigger(event,data);return!($.isFunction(callback)&&callback.apply(this.element[0],[event].concat(data))===false||event.isDefaultPrevented());}};$.each({show:"fadeIn",hide:"fadeOut"},function(method,defaultEffect){$.Widget.prototype["_"+method]=function(element,options,callback){if(typeof options==="string"){options={effect:options};}var hasOptions;var effectName=!options?method:options===true||typeof options==="number"?defaultEffect:options.effect||defaultEffect;options=options||{};if(typeof options==="number"){options={duration:options};}hasOptions=!$.isEmptyObject(options);options.complete=callback;if(options.delay){element.delay(options.delay);}if(hasOptions&&$.effects&&$.effects.effect[effectName]){element[method](options);}else if(effectName!==method&&element[effectName]){element[effectName](options.duration,options.easing,callback);}else{element.queue(function(next){$(this)[method]();if(callback){callback.call(element[0]);}next();});}};});var widget=$.widget;/*!
	 * jQuery UI Position 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/position/
	 *///>>label: Position
	//>>group: Core
	//>>description: Positions elements relative to other elements.
	//>>docs: http://api.jqueryui.com/position/
	//>>demos: http://jqueryui.com/position/
	(function(){var cachedScrollbarWidth,max=Math.max,abs=Math.abs,rhorizontal=/left|center|right/,rvertical=/top|center|bottom/,roffset=/[\+\-]\d+(\.[\d]+)?%?/,rposition=/^\w+/,rpercent=/%$/,_position=$.fn.position;function getOffsets(offsets,width,height){return[parseFloat(offsets[0])*(rpercent.test(offsets[0])?width/100:1),parseFloat(offsets[1])*(rpercent.test(offsets[1])?height/100:1)];}function parseCss(element,property){return parseInt($.css(element,property),10)||0;}function getDimensions(elem){var raw=elem[0];if(raw.nodeType===9){return{width:elem.width(),height:elem.height(),offset:{top:0,left:0}};}if($.isWindow(raw)){return{width:elem.width(),height:elem.height(),offset:{top:elem.scrollTop(),left:elem.scrollLeft()}};}if(raw.preventDefault){return{width:0,height:0,offset:{top:raw.pageY,left:raw.pageX}};}return{width:elem.outerWidth(),height:elem.outerHeight(),offset:elem.offset()};}$.position={scrollbarWidth:function scrollbarWidth(){if(cachedScrollbarWidth!==undefined){return cachedScrollbarWidth;}var w1,w2,div=$("<div "+"style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'>"+"<div style='height:100px;width:auto;'></div></div>"),innerDiv=div.children()[0];$("body").append(div);w1=innerDiv.offsetWidth;div.css("overflow","scroll");w2=innerDiv.offsetWidth;if(w1===w2){w2=div[0].clientWidth;}div.remove();return cachedScrollbarWidth=w1-w2;},getScrollInfo:function getScrollInfo(within){var overflowX=within.isWindow||within.isDocument?"":within.element.css("overflow-x"),overflowY=within.isWindow||within.isDocument?"":within.element.css("overflow-y"),hasOverflowX=overflowX==="scroll"||overflowX==="auto"&&within.width<within.element[0].scrollWidth,hasOverflowY=overflowY==="scroll"||overflowY==="auto"&&within.height<within.element[0].scrollHeight;return{width:hasOverflowY?$.position.scrollbarWidth():0,height:hasOverflowX?$.position.scrollbarWidth():0};},getWithinInfo:function getWithinInfo(element){var withinElement=$(element||window),isWindow=$.isWindow(withinElement[0]),isDocument=!!withinElement[0]&&withinElement[0].nodeType===9,hasOffset=!isWindow&&!isDocument;return{element:withinElement,isWindow:isWindow,isDocument:isDocument,offset:hasOffset?$(element).offset():{left:0,top:0},scrollLeft:withinElement.scrollLeft(),scrollTop:withinElement.scrollTop(),width:withinElement.outerWidth(),height:withinElement.outerHeight()};}};$.fn.position=function(options){if(!options||!options.of){return _position.apply(this,arguments);}// Make a copy, we don't want to modify arguments
	options=$.extend({},options);var atOffset,targetWidth,targetHeight,targetOffset,basePosition,dimensions,target=$(options.of),within=$.position.getWithinInfo(options.within),scrollInfo=$.position.getScrollInfo(within),collision=(options.collision||"flip").split(" "),offsets={};dimensions=getDimensions(target);if(target[0].preventDefault){// Force left top to allow flipping
	options.at="left top";}targetWidth=dimensions.width;targetHeight=dimensions.height;targetOffset=dimensions.offset;// Clone to reuse original targetOffset later
	basePosition=$.extend({},targetOffset);// Force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each(["my","at"],function(){var pos=(options[this]||"").split(" "),horizontalOffset,verticalOffset;if(pos.length===1){pos=rhorizontal.test(pos[0])?pos.concat(["center"]):rvertical.test(pos[0])?["center"].concat(pos):["center","center"];}pos[0]=rhorizontal.test(pos[0])?pos[0]:"center";pos[1]=rvertical.test(pos[1])?pos[1]:"center";// Calculate offsets
	horizontalOffset=roffset.exec(pos[0]);verticalOffset=roffset.exec(pos[1]);offsets[this]=[horizontalOffset?horizontalOffset[0]:0,verticalOffset?verticalOffset[0]:0];// Reduce to just the positions without the offsets
	options[this]=[rposition.exec(pos[0])[0],rposition.exec(pos[1])[0]];});// Normalize collision option
	if(collision.length===1){collision[1]=collision[0];}if(options.at[0]==="right"){basePosition.left+=targetWidth;}else if(options.at[0]==="center"){basePosition.left+=targetWidth/2;}if(options.at[1]==="bottom"){basePosition.top+=targetHeight;}else if(options.at[1]==="center"){basePosition.top+=targetHeight/2;}atOffset=getOffsets(offsets.at,targetWidth,targetHeight);basePosition.left+=atOffset[0];basePosition.top+=atOffset[1];return this.each(function(){var collisionPosition,using,elem=$(this),elemWidth=elem.outerWidth(),elemHeight=elem.outerHeight(),marginLeft=parseCss(this,"marginLeft"),marginTop=parseCss(this,"marginTop"),collisionWidth=elemWidth+marginLeft+parseCss(this,"marginRight")+scrollInfo.width,collisionHeight=elemHeight+marginTop+parseCss(this,"marginBottom")+scrollInfo.height,position=$.extend({},basePosition),myOffset=getOffsets(offsets.my,elem.outerWidth(),elem.outerHeight());if(options.my[0]==="right"){position.left-=elemWidth;}else if(options.my[0]==="center"){position.left-=elemWidth/2;}if(options.my[1]==="bottom"){position.top-=elemHeight;}else if(options.my[1]==="center"){position.top-=elemHeight/2;}position.left+=myOffset[0];position.top+=myOffset[1];collisionPosition={marginLeft:marginLeft,marginTop:marginTop};$.each(["left","top"],function(i,dir){if($.ui.position[collision[i]]){$.ui.position[collision[i]][dir](position,{targetWidth:targetWidth,targetHeight:targetHeight,elemWidth:elemWidth,elemHeight:elemHeight,collisionPosition:collisionPosition,collisionWidth:collisionWidth,collisionHeight:collisionHeight,offset:[atOffset[0]+myOffset[0],atOffset[1]+myOffset[1]],my:options.my,at:options.at,within:within,elem:elem});}});if(options.using){// Adds feedback as second argument to using callback, if present
	using=function using(props){var left=targetOffset.left-position.left,right=left+targetWidth-elemWidth,top=targetOffset.top-position.top,bottom=top+targetHeight-elemHeight,feedback={target:{element:target,left:targetOffset.left,top:targetOffset.top,width:targetWidth,height:targetHeight},element:{element:elem,left:position.left,top:position.top,width:elemWidth,height:elemHeight},horizontal:right<0?"left":left>0?"right":"center",vertical:bottom<0?"top":top>0?"bottom":"middle"};if(targetWidth<elemWidth&&abs(left+right)<targetWidth){feedback.horizontal="center";}if(targetHeight<elemHeight&&abs(top+bottom)<targetHeight){feedback.vertical="middle";}if(max(abs(left),abs(right))>max(abs(top),abs(bottom))){feedback.important="horizontal";}else{feedback.important="vertical";}options.using.call(this,props,feedback);};}elem.offset($.extend(position,{using:using}));});};$.ui.position={fit:{left:function left(position,data){var within=data.within,withinOffset=within.isWindow?within.scrollLeft:within.offset.left,outerWidth=within.width,collisionPosLeft=position.left-data.collisionPosition.marginLeft,overLeft=withinOffset-collisionPosLeft,overRight=collisionPosLeft+data.collisionWidth-outerWidth-withinOffset,newOverRight;// Element is wider than within
	if(data.collisionWidth>outerWidth){// Element is initially over the left side of within
	if(overLeft>0&&overRight<=0){newOverRight=position.left+overLeft+data.collisionWidth-outerWidth-withinOffset;position.left+=overLeft-newOverRight;// Element is initially over right side of within
	}else if(overRight>0&&overLeft<=0){position.left=withinOffset;// Element is initially over both left and right sides of within
	}else{if(overLeft>overRight){position.left=withinOffset+outerWidth-data.collisionWidth;}else{position.left=withinOffset;}}// Too far left -> align with left edge
	}else if(overLeft>0){position.left+=overLeft;// Too far right -> align with right edge
	}else if(overRight>0){position.left-=overRight;// Adjust based on position and margin
	}else{position.left=max(position.left-collisionPosLeft,position.left);}},top:function top(position,data){var within=data.within,withinOffset=within.isWindow?within.scrollTop:within.offset.top,outerHeight=data.within.height,collisionPosTop=position.top-data.collisionPosition.marginTop,overTop=withinOffset-collisionPosTop,overBottom=collisionPosTop+data.collisionHeight-outerHeight-withinOffset,newOverBottom;// Element is taller than within
	if(data.collisionHeight>outerHeight){// Element is initially over the top of within
	if(overTop>0&&overBottom<=0){newOverBottom=position.top+overTop+data.collisionHeight-outerHeight-withinOffset;position.top+=overTop-newOverBottom;// Element is initially over bottom of within
	}else if(overBottom>0&&overTop<=0){position.top=withinOffset;// Element is initially over both top and bottom of within
	}else{if(overTop>overBottom){position.top=withinOffset+outerHeight-data.collisionHeight;}else{position.top=withinOffset;}}// Too far up -> align with top
	}else if(overTop>0){position.top+=overTop;// Too far down -> align with bottom edge
	}else if(overBottom>0){position.top-=overBottom;// Adjust based on position and margin
	}else{position.top=max(position.top-collisionPosTop,position.top);}}},flip:{left:function left(position,data){var within=data.within,withinOffset=within.offset.left+within.scrollLeft,outerWidth=within.width,offsetLeft=within.isWindow?within.scrollLeft:within.offset.left,collisionPosLeft=position.left-data.collisionPosition.marginLeft,overLeft=collisionPosLeft-offsetLeft,overRight=collisionPosLeft+data.collisionWidth-outerWidth-offsetLeft,myOffset=data.my[0]==="left"?-data.elemWidth:data.my[0]==="right"?data.elemWidth:0,atOffset=data.at[0]==="left"?data.targetWidth:data.at[0]==="right"?-data.targetWidth:0,offset=-2*data.offset[0],newOverRight,newOverLeft;if(overLeft<0){newOverRight=position.left+myOffset+atOffset+offset+data.collisionWidth-outerWidth-withinOffset;if(newOverRight<0||newOverRight<abs(overLeft)){position.left+=myOffset+atOffset+offset;}}else if(overRight>0){newOverLeft=position.left-data.collisionPosition.marginLeft+myOffset+atOffset+offset-offsetLeft;if(newOverLeft>0||abs(newOverLeft)<overRight){position.left+=myOffset+atOffset+offset;}}},top:function top(position,data){var within=data.within,withinOffset=within.offset.top+within.scrollTop,outerHeight=within.height,offsetTop=within.isWindow?within.scrollTop:within.offset.top,collisionPosTop=position.top-data.collisionPosition.marginTop,overTop=collisionPosTop-offsetTop,overBottom=collisionPosTop+data.collisionHeight-outerHeight-offsetTop,top=data.my[1]==="top",myOffset=top?-data.elemHeight:data.my[1]==="bottom"?data.elemHeight:0,atOffset=data.at[1]==="top"?data.targetHeight:data.at[1]==="bottom"?-data.targetHeight:0,offset=-2*data.offset[1],newOverTop,newOverBottom;if(overTop<0){newOverBottom=position.top+myOffset+atOffset+offset+data.collisionHeight-outerHeight-withinOffset;if(newOverBottom<0||newOverBottom<abs(overTop)){position.top+=myOffset+atOffset+offset;}}else if(overBottom>0){newOverTop=position.top-data.collisionPosition.marginTop+myOffset+atOffset+offset-offsetTop;if(newOverTop>0||abs(newOverTop)<overBottom){position.top+=myOffset+atOffset+offset;}}}},flipfit:{left:function left(){$.ui.position.flip.left.apply(this,arguments);$.ui.position.fit.left.apply(this,arguments);},top:function top(){$.ui.position.flip.top.apply(this,arguments);$.ui.position.fit.top.apply(this,arguments);}}};})();var position=$.ui.position;/*!
	 * jQuery UI :data 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: :data Selector
	//>>group: Core
	//>>description: Selects elements which have data stored under the specified key.
	//>>docs: http://api.jqueryui.com/data-selector/
	var data=$.extend($.expr[":"],{data:$.expr.createPseudo?$.expr.createPseudo(function(dataName){return function(elem){return!!$.data(elem,dataName);};}):// Support: jQuery <1.8
	function(elem,i,match){return!!$.data(elem,match[3]);}});/*!
	 * jQuery UI Disable Selection 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: disableSelection
	//>>group: Core
	//>>description: Disable selection of text content within the set of matched elements.
	//>>docs: http://api.jqueryui.com/disableSelection/
	// This file is deprecated
	var disableSelection=$.fn.extend({disableSelection:function(){var eventType="onselectstart"in document.createElement("div")?"selectstart":"mousedown";return function(){return this.on(eventType+".ui-disableSelection",function(event){event.preventDefault();});};}(),enableSelection:function enableSelection(){return this.off(".ui-disableSelection");}});/*!
	 * jQuery UI Effects 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Effects Core
	//>>group: Effects
	// jscs:disable maximumLineLength
	//>>description: Extends the internal jQuery effects. Includes morphing and easing. Required by all other effects.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/category/effects-core/
	//>>demos: http://jqueryui.com/effect/
	var dataSpace="ui-effects-",dataSpaceStyle="ui-effects-style",dataSpaceAnimated="ui-effects-animated",// Create a local jQuery because jQuery Color relies on it and the
	// global may not exist with AMD and a custom build (#10199)
	jQuery=$;$.effects={effect:{}};/*!
	 * jQuery Color Animations v2.1.2
	 * https://github.com/jquery/jquery-color
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * Date: Wed Jan 16 08:47:09 2013 -0600
	 */(function(jQuery,undefined){var stepHooks="backgroundColor borderBottomColor borderLeftColor borderRightColor "+"borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",// Plusequals test for += 100 -= 100
	rplusequals=/^([\-+])=\s*(\d+\.?\d*)/,// A set of RE's that can match strings and generate color tuples.
	stringParsers=[{re:/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function parse(execResult){return[execResult[1],execResult[2],execResult[3],execResult[4]];}},{re:/rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function parse(execResult){return[execResult[1]*2.55,execResult[2]*2.55,execResult[3]*2.55,execResult[4]];}},{// This regex ignores A-F because it's compared against an already lowercased string
	re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,parse:function parse(execResult){return[parseInt(execResult[1],16),parseInt(execResult[2],16),parseInt(execResult[3],16)];}},{// This regex ignores A-F because it's compared against an already lowercased string
	re:/#([a-f0-9])([a-f0-9])([a-f0-9])/,parse:function parse(execResult){return[parseInt(execResult[1]+execResult[1],16),parseInt(execResult[2]+execResult[2],16),parseInt(execResult[3]+execResult[3],16)];}},{re:/hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,space:"hsla",parse:function parse(execResult){return[execResult[1],execResult[2]/100,execResult[3]/100,execResult[4]];}}],// JQuery.Color( )
	color=jQuery.Color=function(color,green,blue,alpha){return new jQuery.Color.fn.parse(color,green,blue,alpha);},spaces={rgba:{props:{red:{idx:0,type:"byte"},green:{idx:1,type:"byte"},blue:{idx:2,type:"byte"}}},hsla:{props:{hue:{idx:0,type:"degrees"},saturation:{idx:1,type:"percent"},lightness:{idx:2,type:"percent"}}}},propTypes={"byte":{floor:true,max:255},"percent":{max:1},"degrees":{mod:360,floor:true}},support=color.support={},// Element for support tests
	supportElem=jQuery("<p>")[0],// Colors = jQuery.Color.names
	colors,// Local aliases of functions called often
	each=jQuery.each;// Determine rgba support immediately
	supportElem.style.cssText="background-color:rgba(1,1,1,.5)";support.rgba=supportElem.style.backgroundColor.indexOf("rgba")>-1;// Define cache name and alpha properties
	// for rgba and hsla spaces
	each(spaces,function(spaceName,space){space.cache="_"+spaceName;space.props.alpha={idx:3,type:"percent",def:1};});function clamp(value,prop,allowEmpty){var type=propTypes[prop.type]||{};if(value==null){return allowEmpty||!prop.def?null:prop.def;}// ~~ is an short way of doing floor for positive numbers
	value=type.floor?~~value:parseFloat(value);// IE will pass in empty strings as value for alpha,
	// which will hit this case
	if(isNaN(value)){return prop.def;}if(type.mod){// We add mod before modding to make sure that negatives values
	// get converted properly: -10 -> 350
	return(value+type.mod)%type.mod;}// For now all property types without mod have min and max
	return 0>value?0:type.max<value?type.max:value;}function stringParse(string){var inst=color(),rgba=inst._rgba=[];string=string.toLowerCase();each(stringParsers,function(i,parser){var parsed,match=parser.re.exec(string),values=match&&parser.parse(match),spaceName=parser.space||"rgba";if(values){parsed=inst[spaceName](values);// If this was an rgba parse the assignment might happen twice
	// oh well....
	inst[spaces[spaceName].cache]=parsed[spaces[spaceName].cache];rgba=inst._rgba=parsed._rgba;// Exit each( stringParsers ) here because we matched
	return false;}});// Found a stringParser that handled it
	if(rgba.length){// If this came from a parsed string, force "transparent" when alpha is 0
	// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
	if(rgba.join()==="0,0,0,0"){jQuery.extend(rgba,colors.transparent);}return inst;}// Named colors
	return colors[string];}color.fn=jQuery.extend(color.prototype,{parse:function parse(red,green,blue,alpha){if(red===undefined){this._rgba=[null,null,null,null];return this;}if(red.jquery||red.nodeType){red=jQuery(red).css(green);green=undefined;}var inst=this,type=jQuery.type(red),rgba=this._rgba=[];// More than 1 argument specified - assume ( red, green, blue, alpha )
	if(green!==undefined){red=[red,green,blue,alpha];type="array";}if(type==="string"){return this.parse(stringParse(red)||colors._default);}if(type==="array"){each(spaces.rgba.props,function(key,prop){rgba[prop.idx]=clamp(red[prop.idx],prop);});return this;}if(type==="object"){if(red instanceof color){each(spaces,function(spaceName,space){if(red[space.cache]){inst[space.cache]=red[space.cache].slice();}});}else{each(spaces,function(spaceName,space){var cache=space.cache;each(space.props,function(key,prop){// If the cache doesn't exist, and we know how to convert
	if(!inst[cache]&&space.to){// If the value was null, we don't need to copy it
	// if the key was alpha, we don't need to copy it either
	if(key==="alpha"||red[key]==null){return;}inst[cache]=space.to(inst._rgba);}// This is the only case where we allow nulls for ALL properties.
	// call clamp with alwaysAllowEmpty
	inst[cache][prop.idx]=clamp(red[key],prop,true);});// Everything defined but alpha?
	if(inst[cache]&&jQuery.inArray(null,inst[cache].slice(0,3))<0){// Use the default of 1
	inst[cache][3]=1;if(space.from){inst._rgba=space.from(inst[cache]);}}});}return this;}},is:function is(compare){var is=color(compare),same=true,inst=this;each(spaces,function(_,space){var localCache,isCache=is[space.cache];if(isCache){localCache=inst[space.cache]||space.to&&space.to(inst._rgba)||[];each(space.props,function(_,prop){if(isCache[prop.idx]!=null){same=isCache[prop.idx]===localCache[prop.idx];return same;}});}return same;});return same;},_space:function _space(){var used=[],inst=this;each(spaces,function(spaceName,space){if(inst[space.cache]){used.push(spaceName);}});return used.pop();},transition:function transition(other,distance){var end=color(other),spaceName=end._space(),space=spaces[spaceName],startColor=this.alpha()===0?color("transparent"):this,start=startColor[space.cache]||space.to(startColor._rgba),result=start.slice();end=end[space.cache];each(space.props,function(key,prop){var index=prop.idx,startValue=start[index],endValue=end[index],type=propTypes[prop.type]||{};// If null, don't override start value
	if(endValue===null){return;}// If null - use end
	if(startValue===null){result[index]=endValue;}else{if(type.mod){if(endValue-startValue>type.mod/2){startValue+=type.mod;}else if(startValue-endValue>type.mod/2){startValue-=type.mod;}}result[index]=clamp((endValue-startValue)*distance+startValue,prop);}});return this[spaceName](result);},blend:function blend(opaque){// If we are already opaque - return ourself
	if(this._rgba[3]===1){return this;}var rgb=this._rgba.slice(),a=rgb.pop(),blend=color(opaque)._rgba;return color(jQuery.map(rgb,function(v,i){return(1-a)*blend[i]+a*v;}));},toRgbaString:function toRgbaString(){var prefix="rgba(",rgba=jQuery.map(this._rgba,function(v,i){return v==null?i>2?1:0:v;});if(rgba[3]===1){rgba.pop();prefix="rgb(";}return prefix+rgba.join()+")";},toHslaString:function toHslaString(){var prefix="hsla(",hsla=jQuery.map(this.hsla(),function(v,i){if(v==null){v=i>2?1:0;}// Catch 1 and 2
	if(i&&i<3){v=Math.round(v*100)+"%";}return v;});if(hsla[3]===1){hsla.pop();prefix="hsl(";}return prefix+hsla.join()+")";},toHexString:function toHexString(includeAlpha){var rgba=this._rgba.slice(),alpha=rgba.pop();if(includeAlpha){rgba.push(~~(alpha*255));}return"#"+jQuery.map(rgba,function(v){// Default to 0 when nulls exist
	v=(v||0).toString(16);return v.length===1?"0"+v:v;}).join("");},toString:function toString(){return this._rgba[3]===0?"transparent":this.toRgbaString();}});color.fn.parse.prototype=color.fn;// Hsla conversions adapted from:
	// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021
	function hue2rgb(p,q,h){h=(h+1)%1;if(h*6<1){return p+(q-p)*h*6;}if(h*2<1){return q;}if(h*3<2){return p+(q-p)*(2/3-h)*6;}return p;}spaces.hsla.to=function(rgba){if(rgba[0]==null||rgba[1]==null||rgba[2]==null){return[null,null,null,rgba[3]];}var r=rgba[0]/255,g=rgba[1]/255,b=rgba[2]/255,a=rgba[3],max=Math.max(r,g,b),min=Math.min(r,g,b),diff=max-min,add=max+min,l=add*0.5,h,s;if(min===max){h=0;}else if(r===max){h=60*(g-b)/diff+360;}else if(g===max){h=60*(b-r)/diff+120;}else{h=60*(r-g)/diff+240;}// Chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
	// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
	if(diff===0){s=0;}else if(l<=0.5){s=diff/add;}else{s=diff/(2-add);}return[Math.round(h)%360,s,l,a==null?1:a];};spaces.hsla.from=function(hsla){if(hsla[0]==null||hsla[1]==null||hsla[2]==null){return[null,null,null,hsla[3]];}var h=hsla[0]/360,s=hsla[1],l=hsla[2],a=hsla[3],q=l<=0.5?l*(1+s):l+s-l*s,p=2*l-q;return[Math.round(hue2rgb(p,q,h+1/3)*255),Math.round(hue2rgb(p,q,h)*255),Math.round(hue2rgb(p,q,h-1/3)*255),a];};each(spaces,function(spaceName,space){var props=space.props,cache=space.cache,to=space.to,from=space.from;// Makes rgba() and hsla()
	color.fn[spaceName]=function(value){// Generate a cache for this space if it doesn't exist
	if(to&&!this[cache]){this[cache]=to(this._rgba);}if(value===undefined){return this[cache].slice();}var ret,type=jQuery.type(value),arr=type==="array"||type==="object"?value:arguments,local=this[cache].slice();each(props,function(key,prop){var val=arr[type==="object"?key:prop.idx];if(val==null){val=local[prop.idx];}local[prop.idx]=clamp(val,prop);});if(from){ret=color(from(local));ret[cache]=local;return ret;}else{return color(local);}};// Makes red() green() blue() alpha() hue() saturation() lightness()
	each(props,function(key,prop){// Alpha is included in more than one space
	if(color.fn[key]){return;}color.fn[key]=function(value){var vtype=jQuery.type(value),fn=key==="alpha"?this._hsla?"hsla":"rgba":spaceName,local=this[fn](),cur=local[prop.idx],match;if(vtype==="undefined"){return cur;}if(vtype==="function"){value=value.call(this,cur);vtype=jQuery.type(value);}if(value==null&&prop.empty){return this;}if(vtype==="string"){match=rplusequals.exec(value);if(match){value=cur+parseFloat(match[2])*(match[1]==="+"?1:-1);}}local[prop.idx]=value;return this[fn](local);};});});// Add cssHook and .fx.step function for each named hook.
	// accept a space separated string of properties
	color.hook=function(hook){var hooks=hook.split(" ");each(hooks,function(i,hook){jQuery.cssHooks[hook]={set:function set(elem,value){var parsed,curElem,backgroundColor="";if(value!=="transparent"&&(jQuery.type(value)!=="string"||(parsed=stringParse(value)))){value=color(parsed||value);if(!support.rgba&&value._rgba[3]!==1){curElem=hook==="backgroundColor"?elem.parentNode:elem;while((backgroundColor===""||backgroundColor==="transparent")&&curElem&&curElem.style){try{backgroundColor=jQuery.css(curElem,"backgroundColor");curElem=curElem.parentNode;}catch(e){}}value=value.blend(backgroundColor&&backgroundColor!=="transparent"?backgroundColor:"_default");}value=value.toRgbaString();}try{elem.style[hook]=value;}catch(e){// Wrapped to prevent IE from throwing errors on "invalid" values like
	// 'auto' or 'inherit'
	}}};jQuery.fx.step[hook]=function(fx){if(!fx.colorInit){fx.start=color(fx.elem,hook);fx.end=color(fx.end);fx.colorInit=true;}jQuery.cssHooks[hook].set(fx.elem,fx.start.transition(fx.end,fx.pos));};});};color.hook(stepHooks);jQuery.cssHooks.borderColor={expand:function expand(value){var expanded={};each(["Top","Right","Bottom","Left"],function(i,part){expanded["border"+part+"Color"]=value;});return expanded;}};// Basic color names only.
	// Usage of any of the other color names requires adding yourself or including
	// jquery.color.svg-names.js.
	colors=jQuery.Color.names={// 4.1. Basic color keywords
	aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00",// 4.2.3. "transparent" color keyword
	transparent:[null,null,null,0],_default:"#ffffff"};})(jQuery);/******************************************************************************//****************************** CLASS ANIMATIONS ******************************//******************************************************************************/(function(){var classAnimationActions=["add","remove","toggle"],shorthandStyles={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1};$.each(["borderLeftStyle","borderRightStyle","borderBottomStyle","borderTopStyle"],function(_,prop){$.fx.step[prop]=function(fx){if(fx.end!=="none"&&!fx.setAttr||fx.pos===1&&!fx.setAttr){jQuery.style(fx.elem,prop,fx.end);fx.setAttr=true;}};});function getElementStyles(elem){var key,len,style=elem.ownerDocument.defaultView?elem.ownerDocument.defaultView.getComputedStyle(elem,null):elem.currentStyle,styles={};if(style&&style.length&&style[0]&&style[style[0]]){len=style.length;while(len--){key=style[len];if(typeof style[key]==="string"){styles[$.camelCase(key)]=style[key];}}// Support: Opera, IE <9
	}else{for(key in style){if(typeof style[key]==="string"){styles[key]=style[key];}}}return styles;}function styleDifference(oldStyle,newStyle){var diff={},name,value;for(name in newStyle){value=newStyle[name];if(oldStyle[name]!==value){if(!shorthandStyles[name]){if($.fx.step[name]||!isNaN(parseFloat(value))){diff[name]=value;}}}}return diff;}// Support: jQuery <1.8
	if(!$.fn.addBack){$.fn.addBack=function(selector){return this.add(selector==null?this.prevObject:this.prevObject.filter(selector));};}$.effects.animateClass=function(value,duration,easing,callback){var o=$.speed(duration,easing,callback);return this.queue(function(){var animated=$(this),baseClass=animated.attr("class")||"",applyClassChange,allAnimations=o.children?animated.find("*").addBack():animated;// Map the animated objects to store the original styles.
	allAnimations=allAnimations.map(function(){var el=$(this);return{el:el,start:getElementStyles(this)};});// Apply class change
	applyClassChange=function applyClassChange(){$.each(classAnimationActions,function(i,action){if(value[action]){animated[action+"Class"](value[action]);}});};applyClassChange();// Map all animated objects again - calculate new styles and diff
	allAnimations=allAnimations.map(function(){this.end=getElementStyles(this.el[0]);this.diff=styleDifference(this.start,this.end);return this;});// Apply original class
	animated.attr("class",baseClass);// Map all animated objects again - this time collecting a promise
	allAnimations=allAnimations.map(function(){var styleInfo=this,dfd=$.Deferred(),opts=$.extend({},o,{queue:false,complete:function complete(){dfd.resolve(styleInfo);}});this.el.animate(this.diff,opts);return dfd.promise();});// Once all animations have completed:
	$.when.apply($,allAnimations.get()).done(function(){// Set the final class
	applyClassChange();// For each animated element,
	// clear all css properties that were animated
	$.each(arguments,function(){var el=this.el;$.each(this.diff,function(key){el.css(key,"");});});// This is guarnteed to be there if you use jQuery.speed()
	// it also handles dequeuing the next anim...
	o.complete.call(animated[0]);});});};$.fn.extend({addClass:function(orig){return function(classNames,speed,easing,callback){return speed?$.effects.animateClass.call(this,{add:classNames},speed,easing,callback):orig.apply(this,arguments);};}($.fn.addClass),removeClass:function(orig){return function(classNames,speed,easing,callback){return arguments.length>1?$.effects.animateClass.call(this,{remove:classNames},speed,easing,callback):orig.apply(this,arguments);};}($.fn.removeClass),toggleClass:function(orig){return function(classNames,force,speed,easing,callback){if(typeof force==="boolean"||force===undefined){if(!speed){// Without speed parameter
	return orig.apply(this,arguments);}else{return $.effects.animateClass.call(this,force?{add:classNames}:{remove:classNames},speed,easing,callback);}}else{// Without force parameter
	return $.effects.animateClass.call(this,{toggle:classNames},force,speed,easing);}};}($.fn.toggleClass),switchClass:function switchClass(remove,add,speed,easing,callback){return $.effects.animateClass.call(this,{add:add,remove:remove},speed,easing,callback);}});})();/******************************************************************************//*********************************** EFFECTS **********************************//******************************************************************************/(function(){if($.expr&&$.expr.filters&&$.expr.filters.animated){$.expr.filters.animated=function(orig){return function(elem){return!!$(elem).data(dataSpaceAnimated)||orig(elem);};}($.expr.filters.animated);}if($.uiBackCompat!==false){$.extend($.effects,{// Saves a set of properties in a data storage
	save:function save(element,set){var i=0,length=set.length;for(;i<length;i++){if(set[i]!==null){element.data(dataSpace+set[i],element[0].style[set[i]]);}}},// Restores a set of previously saved properties from a data storage
	restore:function restore(element,set){var val,i=0,length=set.length;for(;i<length;i++){if(set[i]!==null){val=element.data(dataSpace+set[i]);element.css(set[i],val);}}},setMode:function setMode(el,mode){if(mode==="toggle"){mode=el.is(":hidden")?"show":"hide";}return mode;},// Wraps the element around a wrapper that copies position properties
	createWrapper:function createWrapper(element){// If the element is already wrapped, return it
	if(element.parent().is(".ui-effects-wrapper")){return element.parent();}// Wrap the element
	var props={width:element.outerWidth(true),height:element.outerHeight(true),"float":element.css("float")},wrapper=$("<div></div>").addClass("ui-effects-wrapper").css({fontSize:"100%",background:"transparent",border:"none",margin:0,padding:0}),// Store the size in case width/height are defined in % - Fixes #5245
	size={width:element.width(),height:element.height()},active=document.activeElement;// Support: Firefox
	// Firefox incorrectly exposes anonymous content
	// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
	try{active.id;}catch(e){active=document.body;}element.wrap(wrapper);// Fixes #7595 - Elements lose focus when wrapped.
	if(element[0]===active||$.contains(element[0],active)){$(active).trigger("focus");}// Hotfix for jQuery 1.4 since some change in wrap() seems to actually
	// lose the reference to the wrapped element
	wrapper=element.parent();// Transfer positioning properties to the wrapper
	if(element.css("position")==="static"){wrapper.css({position:"relative"});element.css({position:"relative"});}else{$.extend(props,{position:element.css("position"),zIndex:element.css("z-index")});$.each(["top","left","bottom","right"],function(i,pos){props[pos]=element.css(pos);if(isNaN(parseInt(props[pos],10))){props[pos]="auto";}});element.css({position:"relative",top:0,left:0,right:"auto",bottom:"auto"});}element.css(size);return wrapper.css(props).show();},removeWrapper:function removeWrapper(element){var active=document.activeElement;if(element.parent().is(".ui-effects-wrapper")){element.parent().replaceWith(element);// Fixes #7595 - Elements lose focus when wrapped.
	if(element[0]===active||$.contains(element[0],active)){$(active).trigger("focus");}}return element;}});}$.extend($.effects,{version:"1.12.1",define:function define(name,mode,effect){if(!effect){effect=mode;mode="effect";}$.effects.effect[name]=effect;$.effects.effect[name].mode=mode;return effect;},scaledDimensions:function scaledDimensions(element,percent,direction){if(percent===0){return{height:0,width:0,outerHeight:0,outerWidth:0};}var x=direction!=="horizontal"?(percent||100)/100:1,y=direction!=="vertical"?(percent||100)/100:1;return{height:element.height()*y,width:element.width()*x,outerHeight:element.outerHeight()*y,outerWidth:element.outerWidth()*x};},clipToBox:function clipToBox(animation){return{width:animation.clip.right-animation.clip.left,height:animation.clip.bottom-animation.clip.top,left:animation.clip.left,top:animation.clip.top};},// Injects recently queued functions to be first in line (after "inprogress")
	unshift:function unshift(element,queueLength,count){var queue=element.queue();if(queueLength>1){queue.splice.apply(queue,[1,0].concat(queue.splice(queueLength,count)));}element.dequeue();},saveStyle:function saveStyle(element){element.data(dataSpaceStyle,element[0].style.cssText);},restoreStyle:function restoreStyle(element){element[0].style.cssText=element.data(dataSpaceStyle)||"";element.removeData(dataSpaceStyle);},mode:function mode(element,_mode){var hidden=element.is(":hidden");if(_mode==="toggle"){_mode=hidden?"show":"hide";}if(hidden?_mode==="hide":_mode==="show"){_mode="none";}return _mode;},// Translates a [top,left] array into a baseline value
	getBaseline:function getBaseline(origin,original){var y,x;switch(origin[0]){case"top":y=0;break;case"middle":y=0.5;break;case"bottom":y=1;break;default:y=origin[0]/original.height;}switch(origin[1]){case"left":x=0;break;case"center":x=0.5;break;case"right":x=1;break;default:x=origin[1]/original.width;}return{x:x,y:y};},// Creates a placeholder element so that the original element can be made absolute
	createPlaceholder:function createPlaceholder(element){var placeholder,cssPosition=element.css("position"),position=element.position();// Lock in margins first to account for form elements, which
	// will change margin if you explicitly set height
	// see: http://jsfiddle.net/JZSMt/3/ https://bugs.webkit.org/show_bug.cgi?id=107380
	// Support: Safari
	element.css({marginTop:element.css("marginTop"),marginBottom:element.css("marginBottom"),marginLeft:element.css("marginLeft"),marginRight:element.css("marginRight")}).outerWidth(element.outerWidth()).outerHeight(element.outerHeight());if(/^(static|relative)/.test(cssPosition)){cssPosition="absolute";placeholder=$("<"+element[0].nodeName+">").insertAfter(element).css({// Convert inline to inline block to account for inline elements
	// that turn to inline block based on content (like img)
	display:/^(inline|ruby)/.test(element.css("display"))?"inline-block":"block",visibility:"hidden",// Margins need to be set to account for margin collapse
	marginTop:element.css("marginTop"),marginBottom:element.css("marginBottom"),marginLeft:element.css("marginLeft"),marginRight:element.css("marginRight"),"float":element.css("float")}).outerWidth(element.outerWidth()).outerHeight(element.outerHeight()).addClass("ui-effects-placeholder");element.data(dataSpace+"placeholder",placeholder);}element.css({position:cssPosition,left:position.left,top:position.top});return placeholder;},removePlaceholder:function removePlaceholder(element){var dataKey=dataSpace+"placeholder",placeholder=element.data(dataKey);if(placeholder){placeholder.remove();element.removeData(dataKey);}},// Removes a placeholder if it exists and restores
	// properties that were modified during placeholder creation
	cleanUp:function cleanUp(element){$.effects.restoreStyle(element);$.effects.removePlaceholder(element);},setTransition:function setTransition(element,list,factor,value){value=value||{};$.each(list,function(i,x){var unit=element.cssUnit(x);if(unit[0]>0){value[x]=unit[0]*factor+unit[1];}});return value;}});// Return an effect options object for the given parameters:
	function _normalizeArguments(effect,options,speed,callback){// Allow passing all options as the first parameter
	if($.isPlainObject(effect)){options=effect;effect=effect.effect;}// Convert to an object
	effect={effect:effect};// Catch (effect, null, ...)
	if(options==null){options={};}// Catch (effect, callback)
	if($.isFunction(options)){callback=options;speed=null;options={};}// Catch (effect, speed, ?)
	if(typeof options==="number"||$.fx.speeds[options]){callback=speed;speed=options;options={};}// Catch (effect, options, callback)
	if($.isFunction(speed)){callback=speed;speed=null;}// Add options to effect
	if(options){$.extend(effect,options);}speed=speed||options.duration;effect.duration=$.fx.off?0:typeof speed==="number"?speed:speed in $.fx.speeds?$.fx.speeds[speed]:$.fx.speeds._default;effect.complete=callback||options.complete;return effect;}function standardAnimationOption(option){// Valid standard speeds (nothing, number, named speed)
	if(!option||typeof option==="number"||$.fx.speeds[option]){return true;}// Invalid strings - treat as "normal" speed
	if(typeof option==="string"&&!$.effects.effect[option]){return true;}// Complete callback
	if($.isFunction(option)){return true;}// Options hash (but not naming an effect)
	if((typeof option==="undefined"?"undefined":_typeof(option))==="object"&&!option.effect){return true;}// Didn't match any standard API
	return false;}$.fn.extend({effect:function effect()/* effect, options, speed, callback */{var args=_normalizeArguments.apply(this,arguments),effectMethod=$.effects.effect[args.effect],defaultMode=effectMethod.mode,queue=args.queue,queueName=queue||"fx",complete=args.complete,mode=args.mode,modes=[],prefilter=function prefilter(next){var el=$(this),normalizedMode=$.effects.mode(el,mode)||defaultMode;// Sentinel for duck-punching the :animated psuedo-selector
	el.data(dataSpaceAnimated,true);// Save effect mode for later use,
	// we can't just call $.effects.mode again later,
	// as the .show() below destroys the initial state
	modes.push(normalizedMode);// See $.uiBackCompat inside of run() for removal of defaultMode in 1.13
	if(defaultMode&&(normalizedMode==="show"||normalizedMode===defaultMode&&normalizedMode==="hide")){el.show();}if(!defaultMode||normalizedMode!=="none"){$.effects.saveStyle(el);}if($.isFunction(next)){next();}};if($.fx.off||!effectMethod){// Delegate to the original method (e.g., .show()) if possible
	if(mode){return this[mode](args.duration,complete);}else{return this.each(function(){if(complete){complete.call(this);}});}}function run(next){var elem=$(this);function cleanup(){elem.removeData(dataSpaceAnimated);$.effects.cleanUp(elem);if(args.mode==="hide"){elem.hide();}done();}function done(){if($.isFunction(complete)){complete.call(elem[0]);}if($.isFunction(next)){next();}}// Override mode option on a per element basis,
	// as toggle can be either show or hide depending on element state
	args.mode=modes.shift();if($.uiBackCompat!==false&&!defaultMode){if(elem.is(":hidden")?mode==="hide":mode==="show"){// Call the core method to track "olddisplay" properly
	elem[mode]();done();}else{effectMethod.call(elem[0],args,done);}}else{if(args.mode==="none"){// Call the core method to track "olddisplay" properly
	elem[mode]();done();}else{effectMethod.call(elem[0],args,cleanup);}}}// Run prefilter on all elements first to ensure that
	// any showing or hiding happens before placeholder creation,
	// which ensures that any layout changes are correctly captured.
	return queue===false?this.each(prefilter).each(run):this.queue(queueName,prefilter).queue(queueName,run);},show:function(orig){return function(option){if(standardAnimationOption(option)){return orig.apply(this,arguments);}else{var args=_normalizeArguments.apply(this,arguments);args.mode="show";return this.effect.call(this,args);}};}($.fn.show),hide:function(orig){return function(option){if(standardAnimationOption(option)){return orig.apply(this,arguments);}else{var args=_normalizeArguments.apply(this,arguments);args.mode="hide";return this.effect.call(this,args);}};}($.fn.hide),toggle:function(orig){return function(option){if(standardAnimationOption(option)||typeof option==="boolean"){return orig.apply(this,arguments);}else{var args=_normalizeArguments.apply(this,arguments);args.mode="toggle";return this.effect.call(this,args);}};}($.fn.toggle),cssUnit:function cssUnit(key){var style=this.css(key),val=[];$.each(["em","px","%","pt"],function(i,unit){if(style.indexOf(unit)>0){val=[parseFloat(style),unit];}});return val;},cssClip:function cssClip(clipObj){if(clipObj){return this.css("clip","rect("+clipObj.top+"px "+clipObj.right+"px "+clipObj.bottom+"px "+clipObj.left+"px)");}return parseClip(this.css("clip"),this);},transfer:function transfer(options,done){var element=$(this),target=$(options.to),targetFixed=target.css("position")==="fixed",body=$("body"),fixTop=targetFixed?body.scrollTop():0,fixLeft=targetFixed?body.scrollLeft():0,endPosition=target.offset(),animation={top:endPosition.top-fixTop,left:endPosition.left-fixLeft,height:target.innerHeight(),width:target.innerWidth()},startPosition=element.offset(),transfer=$("<div class='ui-effects-transfer'></div>").appendTo("body").addClass(options.className).css({top:startPosition.top-fixTop,left:startPosition.left-fixLeft,height:element.innerHeight(),width:element.innerWidth(),position:targetFixed?"fixed":"absolute"}).animate(animation,options.duration,options.easing,function(){transfer.remove();if($.isFunction(done)){done();}});}});function parseClip(str,element){var outerWidth=element.outerWidth(),outerHeight=element.outerHeight(),clipRegex=/^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,values=clipRegex.exec(str)||["",0,outerWidth,outerHeight,0];return{top:parseFloat(values[1])||0,right:values[2]==="auto"?outerWidth:parseFloat(values[2]),bottom:values[3]==="auto"?outerHeight:parseFloat(values[3]),left:parseFloat(values[4])||0};}$.fx.step.clip=function(fx){if(!fx.clipInit){fx.start=$(fx.elem).cssClip();if(typeof fx.end==="string"){fx.end=parseClip(fx.end,fx.elem);}fx.clipInit=true;}$(fx.elem).cssClip({top:fx.pos*(fx.end.top-fx.start.top)+fx.start.top,right:fx.pos*(fx.end.right-fx.start.right)+fx.start.right,bottom:fx.pos*(fx.end.bottom-fx.start.bottom)+fx.start.bottom,left:fx.pos*(fx.end.left-fx.start.left)+fx.start.left});};})();/******************************************************************************//*********************************** EASING ***********************************//******************************************************************************/(function(){// Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)
	var baseEasings={};$.each(["Quad","Cubic","Quart","Quint","Expo"],function(i,name){baseEasings[name]=function(p){return Math.pow(p,i+2);};});$.extend(baseEasings,{Sine:function Sine(p){return 1-Math.cos(p*Math.PI/2);},Circ:function Circ(p){return 1-Math.sqrt(1-p*p);},Elastic:function Elastic(p){return p===0||p===1?p:-Math.pow(2,8*(p-1))*Math.sin(((p-1)*80-7.5)*Math.PI/15);},Back:function Back(p){return p*p*(3*p-2);},Bounce:function Bounce(p){var pow2,bounce=4;while(p<((pow2=Math.pow(2,--bounce))-1)/11){}return 1/Math.pow(4,3-bounce)-7.5625*Math.pow((pow2*3-2)/22-p,2);}});$.each(baseEasings,function(name,easeIn){$.easing["easeIn"+name]=easeIn;$.easing["easeOut"+name]=function(p){return 1-easeIn(1-p);};$.easing["easeInOut"+name]=function(p){return p<0.5?easeIn(p*2)/2:1-easeIn(p*-2+2)/2;};});})();var effect=$.effects;/*!
	 * jQuery UI Effects Blind 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Blind Effect
	//>>group: Effects
	//>>description: Blinds the element.
	//>>docs: http://api.jqueryui.com/blind-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectBlind=$.effects.define("blind","hide",function(options,done){var map={up:["bottom","top"],vertical:["bottom","top"],down:["top","bottom"],left:["right","left"],horizontal:["right","left"],right:["left","right"]},element=$(this),direction=options.direction||"up",start=element.cssClip(),animate={clip:$.extend({},start)},placeholder=$.effects.createPlaceholder(element);animate.clip[map[direction][0]]=animate.clip[map[direction][1]];if(options.mode==="show"){element.cssClip(animate.clip);if(placeholder){placeholder.css($.effects.clipToBox(animate));}animate.clip=start;}if(placeholder){placeholder.animate($.effects.clipToBox(animate),options.duration,options.easing);}element.animate(animate,{queue:false,duration:options.duration,easing:options.easing,complete:done});});/*!
	 * jQuery UI Effects Bounce 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Bounce Effect
	//>>group: Effects
	//>>description: Bounces an element horizontally or vertically n times.
	//>>docs: http://api.jqueryui.com/bounce-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectBounce=$.effects.define("bounce",function(options,done){var upAnim,downAnim,refValue,element=$(this),// Defaults:
	mode=options.mode,hide=mode==="hide",show=mode==="show",direction=options.direction||"up",distance=options.distance,times=options.times||5,// Number of internal animations
	anims=times*2+(show||hide?1:0),speed=options.duration/anims,easing=options.easing,// Utility:
	ref=direction==="up"||direction==="down"?"top":"left",motion=direction==="up"||direction==="left",i=0,queuelen=element.queue().length;$.effects.createPlaceholder(element);refValue=element.css(ref);// Default distance for the BIGGEST bounce is the outer Distance / 3
	if(!distance){distance=element[ref==="top"?"outerHeight":"outerWidth"]()/3;}if(show){downAnim={opacity:1};downAnim[ref]=refValue;// If we are showing, force opacity 0 and set the initial position
	// then do the "first" animation
	element.css("opacity",0).css(ref,motion?-distance*2:distance*2).animate(downAnim,speed,easing);}// Start at the smallest distance if we are hiding
	if(hide){distance=distance/Math.pow(2,times-1);}downAnim={};downAnim[ref]=refValue;// Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
	for(;i<times;i++){upAnim={};upAnim[ref]=(motion?"-=":"+=")+distance;element.animate(upAnim,speed,easing).animate(downAnim,speed,easing);distance=hide?distance*2:distance/2;}// Last Bounce when Hiding
	if(hide){upAnim={opacity:0};upAnim[ref]=(motion?"-=":"+=")+distance;element.animate(upAnim,speed,easing);}element.queue(done);$.effects.unshift(element,queuelen,anims+1);});/*!
	 * jQuery UI Effects Clip 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Clip Effect
	//>>group: Effects
	//>>description: Clips the element on and off like an old TV.
	//>>docs: http://api.jqueryui.com/clip-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectClip=$.effects.define("clip","hide",function(options,done){var start,animate={},element=$(this),direction=options.direction||"vertical",both=direction==="both",horizontal=both||direction==="horizontal",vertical=both||direction==="vertical";start=element.cssClip();animate.clip={top:vertical?(start.bottom-start.top)/2:start.top,right:horizontal?(start.right-start.left)/2:start.right,bottom:vertical?(start.bottom-start.top)/2:start.bottom,left:horizontal?(start.right-start.left)/2:start.left};$.effects.createPlaceholder(element);if(options.mode==="show"){element.cssClip(animate.clip);animate.clip=start;}element.animate(animate,{queue:false,duration:options.duration,easing:options.easing,complete:done});});/*!
	 * jQuery UI Effects Drop 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Drop Effect
	//>>group: Effects
	//>>description: Moves an element in one direction and hides it at the same time.
	//>>docs: http://api.jqueryui.com/drop-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectDrop=$.effects.define("drop","hide",function(options,done){var distance,element=$(this),mode=options.mode,show=mode==="show",direction=options.direction||"left",ref=direction==="up"||direction==="down"?"top":"left",motion=direction==="up"||direction==="left"?"-=":"+=",oppositeMotion=motion==="+="?"-=":"+=",animation={opacity:0};$.effects.createPlaceholder(element);distance=options.distance||element[ref==="top"?"outerHeight":"outerWidth"](true)/2;animation[ref]=motion+distance;if(show){element.css(animation);animation[ref]=oppositeMotion+distance;animation.opacity=1;}// Animate
	element.animate(animation,{queue:false,duration:options.duration,easing:options.easing,complete:done});});/*!
	 * jQuery UI Effects Explode 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Explode Effect
	//>>group: Effects
	// jscs:disable maximumLineLength
	//>>description: Explodes an element in all directions into n pieces. Implodes an element to its original wholeness.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/explode-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectExplode=$.effects.define("explode","hide",function(options,done){var i,j,left,top,mx,my,rows=options.pieces?Math.round(Math.sqrt(options.pieces)):3,cells=rows,element=$(this),mode=options.mode,show=mode==="show",// Show and then visibility:hidden the element before calculating offset
	offset=element.show().css("visibility","hidden").offset(),// Width and height of a piece
	width=Math.ceil(element.outerWidth()/cells),height=Math.ceil(element.outerHeight()/rows),pieces=[];// Children animate complete:
	function childComplete(){pieces.push(this);if(pieces.length===rows*cells){animComplete();}}// Clone the element for each row and cell.
	for(i=0;i<rows;i++){// ===>
	top=offset.top+i*height;my=i-(rows-1)/2;for(j=0;j<cells;j++){// |||
	left=offset.left+j*width;mx=j-(cells-1)/2;// Create a clone of the now hidden main element that will be absolute positioned
	// within a wrapper div off the -left and -top equal to size of our pieces
	element.clone().appendTo("body").wrap("<div></div>").css({position:"absolute",visibility:"visible",left:-j*width,top:-i*height})// Select the wrapper - make it overflow: hidden and absolute positioned based on
	// where the original was located +left and +top equal to the size of pieces
	.parent().addClass("ui-effects-explode").css({position:"absolute",overflow:"hidden",width:width,height:height,left:left+(show?mx*width:0),top:top+(show?my*height:0),opacity:show?0:1}).animate({left:left+(show?0:mx*width),top:top+(show?0:my*height),opacity:show?1:0},options.duration||500,options.easing,childComplete);}}function animComplete(){element.css({visibility:"visible"});$(pieces).remove();done();}});/*!
	 * jQuery UI Effects Fade 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Fade Effect
	//>>group: Effects
	//>>description: Fades the element.
	//>>docs: http://api.jqueryui.com/fade-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectFade=$.effects.define("fade","toggle",function(options,done){var show=options.mode==="show";$(this).css("opacity",show?0:1).animate({opacity:show?1:0},{queue:false,duration:options.duration,easing:options.easing,complete:done});});/*!
	 * jQuery UI Effects Fold 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Fold Effect
	//>>group: Effects
	//>>description: Folds an element first horizontally and then vertically.
	//>>docs: http://api.jqueryui.com/fold-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectFold=$.effects.define("fold","hide",function(options,done){// Create element
	var element=$(this),mode=options.mode,show=mode==="show",hide=mode==="hide",size=options.size||15,percent=/([0-9]+)%/.exec(size),horizFirst=!!options.horizFirst,ref=horizFirst?["right","bottom"]:["bottom","right"],duration=options.duration/2,placeholder=$.effects.createPlaceholder(element),start=element.cssClip(),animation1={clip:$.extend({},start)},animation2={clip:$.extend({},start)},distance=[start[ref[0]],start[ref[1]]],queuelen=element.queue().length;if(percent){size=parseInt(percent[1],10)/100*distance[hide?0:1];}animation1.clip[ref[0]]=size;animation2.clip[ref[0]]=size;animation2.clip[ref[1]]=0;if(show){element.cssClip(animation2.clip);if(placeholder){placeholder.css($.effects.clipToBox(animation2));}animation2.clip=start;}// Animate
	element.queue(function(next){if(placeholder){placeholder.animate($.effects.clipToBox(animation1),duration,options.easing).animate($.effects.clipToBox(animation2),duration,options.easing);}next();}).animate(animation1,duration,options.easing).animate(animation2,duration,options.easing).queue(done);$.effects.unshift(element,queuelen,4);});/*!
	 * jQuery UI Effects Highlight 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Highlight Effect
	//>>group: Effects
	//>>description: Highlights the background of an element in a defined color for a custom duration.
	//>>docs: http://api.jqueryui.com/highlight-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectHighlight=$.effects.define("highlight","show",function(options,done){var element=$(this),animation={backgroundColor:element.css("backgroundColor")};if(options.mode==="hide"){animation.opacity=0;}$.effects.saveStyle(element);element.css({backgroundImage:"none",backgroundColor:options.color||"#ffff99"}).animate(animation,{queue:false,duration:options.duration,easing:options.easing,complete:done});});/*!
	 * jQuery UI Effects Size 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Size Effect
	//>>group: Effects
	//>>description: Resize an element to a specified width and height.
	//>>docs: http://api.jqueryui.com/size-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectSize=$.effects.define("size",function(options,done){// Create element
	var baseline,factor,temp,element=$(this),// Copy for children
	cProps=["fontSize"],vProps=["borderTopWidth","borderBottomWidth","paddingTop","paddingBottom"],hProps=["borderLeftWidth","borderRightWidth","paddingLeft","paddingRight"],// Set options
	mode=options.mode,restore=mode!=="effect",scale=options.scale||"both",origin=options.origin||["middle","center"],position=element.css("position"),pos=element.position(),original=$.effects.scaledDimensions(element),from=options.from||original,to=options.to||$.effects.scaledDimensions(element,0);$.effects.createPlaceholder(element);if(mode==="show"){temp=from;from=to;to=temp;}// Set scaling factor
	factor={from:{y:from.height/original.height,x:from.width/original.width},to:{y:to.height/original.height,x:to.width/original.width}};// Scale the css box
	if(scale==="box"||scale==="both"){// Vertical props scaling
	if(factor.from.y!==factor.to.y){from=$.effects.setTransition(element,vProps,factor.from.y,from);to=$.effects.setTransition(element,vProps,factor.to.y,to);}// Horizontal props scaling
	if(factor.from.x!==factor.to.x){from=$.effects.setTransition(element,hProps,factor.from.x,from);to=$.effects.setTransition(element,hProps,factor.to.x,to);}}// Scale the content
	if(scale==="content"||scale==="both"){// Vertical props scaling
	if(factor.from.y!==factor.to.y){from=$.effects.setTransition(element,cProps,factor.from.y,from);to=$.effects.setTransition(element,cProps,factor.to.y,to);}}// Adjust the position properties based on the provided origin points
	if(origin){baseline=$.effects.getBaseline(origin,original);from.top=(original.outerHeight-from.outerHeight)*baseline.y+pos.top;from.left=(original.outerWidth-from.outerWidth)*baseline.x+pos.left;to.top=(original.outerHeight-to.outerHeight)*baseline.y+pos.top;to.left=(original.outerWidth-to.outerWidth)*baseline.x+pos.left;}element.css(from);// Animate the children if desired
	if(scale==="content"||scale==="both"){vProps=vProps.concat(["marginTop","marginBottom"]).concat(cProps);hProps=hProps.concat(["marginLeft","marginRight"]);// Only animate children with width attributes specified
	// TODO: is this right? should we include anything with css width specified as well
	element.find("*[width]").each(function(){var child=$(this),childOriginal=$.effects.scaledDimensions(child),childFrom={height:childOriginal.height*factor.from.y,width:childOriginal.width*factor.from.x,outerHeight:childOriginal.outerHeight*factor.from.y,outerWidth:childOriginal.outerWidth*factor.from.x},childTo={height:childOriginal.height*factor.to.y,width:childOriginal.width*factor.to.x,outerHeight:childOriginal.height*factor.to.y,outerWidth:childOriginal.width*factor.to.x};// Vertical props scaling
	if(factor.from.y!==factor.to.y){childFrom=$.effects.setTransition(child,vProps,factor.from.y,childFrom);childTo=$.effects.setTransition(child,vProps,factor.to.y,childTo);}// Horizontal props scaling
	if(factor.from.x!==factor.to.x){childFrom=$.effects.setTransition(child,hProps,factor.from.x,childFrom);childTo=$.effects.setTransition(child,hProps,factor.to.x,childTo);}if(restore){$.effects.saveStyle(child);}// Animate children
	child.css(childFrom);child.animate(childTo,options.duration,options.easing,function(){// Restore children
	if(restore){$.effects.restoreStyle(child);}});});}// Animate
	element.animate(to,{queue:false,duration:options.duration,easing:options.easing,complete:function complete(){var offset=element.offset();if(to.opacity===0){element.css("opacity",from.opacity);}if(!restore){element.css("position",position==="static"?"relative":position).offset(offset);// Need to save style here so that automatic style restoration
	// doesn't restore to the original styles from before the animation.
	$.effects.saveStyle(element);}done();}});});/*!
	 * jQuery UI Effects Scale 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Scale Effect
	//>>group: Effects
	//>>description: Grows or shrinks an element and its content.
	//>>docs: http://api.jqueryui.com/scale-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectScale=$.effects.define("scale",function(options,done){// Create element
	var el=$(this),mode=options.mode,percent=parseInt(options.percent,10)||(parseInt(options.percent,10)===0?0:mode!=="effect"?0:100),newOptions=$.extend(true,{from:$.effects.scaledDimensions(el),to:$.effects.scaledDimensions(el,percent,options.direction||"both"),origin:options.origin||["middle","center"]},options);// Fade option to support puff
	if(options.fade){newOptions.from.opacity=1;newOptions.to.opacity=0;}$.effects.effect.size.call(this,newOptions,done);});/*!
	 * jQuery UI Effects Puff 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Puff Effect
	//>>group: Effects
	//>>description: Creates a puff effect by scaling the element up and hiding it at the same time.
	//>>docs: http://api.jqueryui.com/puff-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectPuff=$.effects.define("puff","hide",function(options,done){var newOptions=$.extend(true,{},options,{fade:true,percent:parseInt(options.percent,10)||150});$.effects.effect.scale.call(this,newOptions,done);});/*!
	 * jQuery UI Effects Pulsate 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Pulsate Effect
	//>>group: Effects
	//>>description: Pulsates an element n times by changing the opacity to zero and back.
	//>>docs: http://api.jqueryui.com/pulsate-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectPulsate=$.effects.define("pulsate","show",function(options,done){var element=$(this),mode=options.mode,show=mode==="show",hide=mode==="hide",showhide=show||hide,// Showing or hiding leaves off the "last" animation
	anims=(options.times||5)*2+(showhide?1:0),duration=options.duration/anims,animateTo=0,i=1,queuelen=element.queue().length;if(show||!element.is(":visible")){element.css("opacity",0).show();animateTo=1;}// Anims - 1 opacity "toggles"
	for(;i<anims;i++){element.animate({opacity:animateTo},duration,options.easing);animateTo=1-animateTo;}element.animate({opacity:animateTo},duration,options.easing);element.queue(done);$.effects.unshift(element,queuelen,anims+1);});/*!
	 * jQuery UI Effects Shake 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Shake Effect
	//>>group: Effects
	//>>description: Shakes an element horizontally or vertically n times.
	//>>docs: http://api.jqueryui.com/shake-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectShake=$.effects.define("shake",function(options,done){var i=1,element=$(this),direction=options.direction||"left",distance=options.distance||20,times=options.times||3,anims=times*2+1,speed=Math.round(options.duration/anims),ref=direction==="up"||direction==="down"?"top":"left",positiveMotion=direction==="up"||direction==="left",animation={},animation1={},animation2={},queuelen=element.queue().length;$.effects.createPlaceholder(element);// Animation
	animation[ref]=(positiveMotion?"-=":"+=")+distance;animation1[ref]=(positiveMotion?"+=":"-=")+distance*2;animation2[ref]=(positiveMotion?"-=":"+=")+distance*2;// Animate
	element.animate(animation,speed,options.easing);// Shakes
	for(;i<times;i++){element.animate(animation1,speed,options.easing).animate(animation2,speed,options.easing);}element.animate(animation1,speed,options.easing).animate(animation,speed/2,options.easing).queue(done);$.effects.unshift(element,queuelen,anims+1);});/*!
	 * jQuery UI Effects Slide 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Slide Effect
	//>>group: Effects
	//>>description: Slides an element in and out of the viewport.
	//>>docs: http://api.jqueryui.com/slide-effect/
	//>>demos: http://jqueryui.com/effect/
	var effectsEffectSlide=$.effects.define("slide","show",function(options,done){var startClip,startRef,element=$(this),map={up:["bottom","top"],down:["top","bottom"],left:["right","left"],right:["left","right"]},mode=options.mode,direction=options.direction||"left",ref=direction==="up"||direction==="down"?"top":"left",positiveMotion=direction==="up"||direction==="left",distance=options.distance||element[ref==="top"?"outerHeight":"outerWidth"](true),animation={};$.effects.createPlaceholder(element);startClip=element.cssClip();startRef=element.position()[ref];// Define hide animation
	animation[ref]=(positiveMotion?-1:1)*distance+startRef;animation.clip=element.cssClip();animation.clip[map[direction][1]]=animation.clip[map[direction][0]];// Reverse the animation if we're showing
	if(mode==="show"){element.cssClip(animation.clip);element.css(ref,animation[ref]);animation.clip=startClip;animation[ref]=startRef;}// Actually animate
	element.animate(animation,{queue:false,duration:options.duration,easing:options.easing,complete:done});});/*!
	 * jQuery UI Effects Transfer 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Transfer Effect
	//>>group: Effects
	//>>description: Displays a transfer effect from one element to another.
	//>>docs: http://api.jqueryui.com/transfer-effect/
	//>>demos: http://jqueryui.com/effect/
	var effect;if($.uiBackCompat!==false){effect=$.effects.define("transfer",function(options,done){$(this).transfer(options,done);});}var effectsEffectTransfer=effect;/*!
	 * jQuery UI Focusable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: :focusable Selector
	//>>group: Core
	//>>description: Selects elements which can be focused.
	//>>docs: http://api.jqueryui.com/focusable-selector/
	// Selectors
	$.ui.focusable=function(element,hasTabindex){var map,mapName,img,focusableIfVisible,fieldset,nodeName=element.nodeName.toLowerCase();if("area"===nodeName){map=element.parentNode;mapName=map.name;if(!element.href||!mapName||map.nodeName.toLowerCase()!=="map"){return false;}img=$("img[usemap='#"+mapName+"']");return img.length>0&&img.is(":visible");}if(/^(input|select|textarea|button|object)$/.test(nodeName)){focusableIfVisible=!element.disabled;if(focusableIfVisible){// Form controls within a disabled fieldset are disabled.
	// However, controls within the fieldset's legend do not get disabled.
	// Since controls generally aren't placed inside legends, we skip
	// this portion of the check.
	fieldset=$(element).closest("fieldset")[0];if(fieldset){focusableIfVisible=!fieldset.disabled;}}}else if("a"===nodeName){focusableIfVisible=element.href||hasTabindex;}else{focusableIfVisible=hasTabindex;}return focusableIfVisible&&$(element).is(":visible")&&visible($(element));};// Support: IE 8 only
	// IE 8 doesn't resolve inherit to visible/hidden for computed values
	function visible(element){var visibility=element.css("visibility");while(visibility==="inherit"){element=element.parent();visibility=element.css("visibility");}return visibility!=="hidden";}$.extend($.expr[":"],{focusable:function focusable(element){return $.ui.focusable(element,$.attr(element,"tabindex")!=null);}});var focusable=$.ui.focusable;// Support: IE8 Only
	// IE8 does not support the form attribute and when it is supplied. It overwrites the form prop
	// with a string, so we need to find the proper form.
	var form=$.fn.form=function(){return typeof this[0].form==="string"?this.closest("form"):$(this[0].form);};/*!
	 * jQuery UI Form Reset Mixin 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Form Reset Mixin
	//>>group: Core
	//>>description: Refresh input widgets when their form is reset
	//>>docs: http://api.jqueryui.com/form-reset-mixin/
	var formResetMixin=$.ui.formResetMixin={_formResetHandler:function _formResetHandler(){var form=$(this);// Wait for the form reset to actually happen before refreshing
	setTimeout(function(){var instances=form.data("ui-form-reset-instances");$.each(instances,function(){this.refresh();});});},_bindFormResetHandler:function _bindFormResetHandler(){this.form=this.element.form();if(!this.form.length){return;}var instances=this.form.data("ui-form-reset-instances")||[];if(!instances.length){// We don't use _on() here because we use a single event handler per form
	this.form.on("reset.ui-form-reset",this._formResetHandler);}instances.push(this);this.form.data("ui-form-reset-instances",instances);},_unbindFormResetHandler:function _unbindFormResetHandler(){if(!this.form.length){return;}var instances=this.form.data("ui-form-reset-instances");instances.splice($.inArray(this,instances),1);if(instances.length){this.form.data("ui-form-reset-instances",instances);}else{this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset");}}};/*!
	 * jQuery UI Support for jQuery core 1.7.x 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 *///>>label: jQuery 1.7 Support
	//>>group: Core
	//>>description: Support version 1.7.x of jQuery core
	// Support: jQuery 1.7 only
	// Not a great way to check versions, but since we only support 1.7+ and only
	// need to detect <1.8, this is a simple check that should suffice. Checking
	// for "1.7." would be a bit safer, but the version string is 1.7, not 1.7.0
	// and we'll never reach 1.70.0 (if we do, we certainly won't be supporting
	// 1.7 anymore). See #11197 for why we're not using feature detection.
	if($.fn.jquery.substring(0,3)==="1.7"){// Setters for .innerWidth(), .innerHeight(), .outerWidth(), .outerHeight()
	// Unlike jQuery Core 1.8+, these only support numeric values to set the
	// dimensions in pixels
	$.each(["Width","Height"],function(i,name){var side=name==="Width"?["Left","Right"]:["Top","Bottom"],type=name.toLowerCase(),orig={innerWidth:$.fn.innerWidth,innerHeight:$.fn.innerHeight,outerWidth:$.fn.outerWidth,outerHeight:$.fn.outerHeight};function reduce(elem,size,border,margin){$.each(side,function(){size-=parseFloat($.css(elem,"padding"+this))||0;if(border){size-=parseFloat($.css(elem,"border"+this+"Width"))||0;}if(margin){size-=parseFloat($.css(elem,"margin"+this))||0;}});return size;}$.fn["inner"+name]=function(size){if(size===undefined){return orig["inner"+name].call(this);}return this.each(function(){$(this).css(type,reduce(this,size)+"px");});};$.fn["outer"+name]=function(size,margin){if(typeof size!=="number"){return orig["outer"+name].call(this,size);}return this.each(function(){$(this).css(type,reduce(this,size,true,margin)+"px");});};});$.fn.addBack=function(selector){return this.add(selector==null?this.prevObject:this.prevObject.filter(selector));};};/*!
	 * jQuery UI Keycode 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Keycode
	//>>group: Core
	//>>description: Provide keycodes as keynames
	//>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/
	var keycode=$.ui.keyCode={BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38};// Internal use only
	var escapeSelector=$.ui.escapeSelector=function(){var selectorEscape=/([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;return function(selector){return selector.replace(selectorEscape,"\\$1");};}();/*!
	 * jQuery UI Labels 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: labels
	//>>group: Core
	//>>description: Find all the labels associated with a given input
	//>>docs: http://api.jqueryui.com/labels/
	var labels=$.fn.labels=function(){var ancestor,selector,id,labels,ancestors;// Check control.labels first
	if(this[0].labels&&this[0].labels.length){return this.pushStack(this[0].labels);}// Support: IE <= 11, FF <= 37, Android <= 2.3 only
	// Above browsers do not support control.labels. Everything below is to support them
	// as well as document fragments. control.labels does not work on document fragments
	labels=this.eq(0).parents("label");// Look for the label based on the id
	id=this.attr("id");if(id){// We don't search against the document in case the element
	// is disconnected from the DOM
	ancestor=this.eq(0).parents().last();// Get a full set of top level ancestors
	ancestors=ancestor.add(ancestor.length?ancestor.siblings():this.siblings());// Create a selector for the label based on the id
	selector="label[for='"+$.ui.escapeSelector(id)+"']";labels=labels.add(ancestors.find(selector).addBack(selector));}// Return whatever we have found for labels
	return this.pushStack(labels);};/*!
	 * jQuery UI Scroll Parent 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: scrollParent
	//>>group: Core
	//>>description: Get the closest ancestor element that is scrollable.
	//>>docs: http://api.jqueryui.com/scrollParent/
	var scrollParent=$.fn.scrollParent=function(includeHidden){var position=this.css("position"),excludeStaticParent=position==="absolute",overflowRegex=includeHidden?/(auto|scroll|hidden)/:/(auto|scroll)/,scrollParent=this.parents().filter(function(){var parent=$(this);if(excludeStaticParent&&parent.css("position")==="static"){return false;}return overflowRegex.test(parent.css("overflow")+parent.css("overflow-y")+parent.css("overflow-x"));}).eq(0);return position==="fixed"||!scrollParent.length?$(this[0].ownerDocument||document):scrollParent;};/*!
	 * jQuery UI Tabbable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: :tabbable Selector
	//>>group: Core
	//>>description: Selects elements which can be tabbed to.
	//>>docs: http://api.jqueryui.com/tabbable-selector/
	var tabbable=$.extend($.expr[":"],{tabbable:function tabbable(element){var tabIndex=$.attr(element,"tabindex"),hasTabindex=tabIndex!=null;return(!hasTabindex||tabIndex>=0)&&$.ui.focusable(element,hasTabindex);}});/*!
	 * jQuery UI Unique ID 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: uniqueId
	//>>group: Core
	//>>description: Functions to generate and remove uniqueId's
	//>>docs: http://api.jqueryui.com/uniqueId/
	var uniqueId=$.fn.extend({uniqueId:function(){var uuid=0;return function(){return this.each(function(){if(!this.id){this.id="ui-id-"+ ++uuid;}});};}(),removeUniqueId:function removeUniqueId(){return this.each(function(){if(/^ui-id-\d+$/.test(this.id)){$(this).removeAttr("id");}});}});/*!
	 * jQuery UI Accordion 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Accordion
	//>>group: Widgets
	// jscs:disable maximumLineLength
	//>>description: Displays collapsible content panels for presenting information in a limited amount of space.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/accordion/
	//>>demos: http://jqueryui.com/accordion/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/accordion.css
	//>>css.theme: ../../themes/base/theme.css
	var widgetsAccordion=$.widget("ui.accordion",{version:"1.12.1",options:{active:0,animate:{},classes:{"ui-accordion-header":"ui-corner-top","ui-accordion-header-collapsed":"ui-corner-all","ui-accordion-content":"ui-corner-bottom"},collapsible:false,event:"click",header:"> li > :first-child, > :not(li):even",heightStyle:"auto",icons:{activeHeader:"ui-icon-triangle-1-s",header:"ui-icon-triangle-1-e"},// Callbacks
	activate:null,beforeActivate:null},hideProps:{borderTopWidth:"hide",borderBottomWidth:"hide",paddingTop:"hide",paddingBottom:"hide",height:"hide"},showProps:{borderTopWidth:"show",borderBottomWidth:"show",paddingTop:"show",paddingBottom:"show",height:"show"},_create:function _create(){var options=this.options;this.prevShow=this.prevHide=$();this._addClass("ui-accordion","ui-widget ui-helper-reset");this.element.attr("role","tablist");// Don't allow collapsible: false and active: false / null
	if(!options.collapsible&&(options.active===false||options.active==null)){options.active=0;}this._processPanels();// handle negative values
	if(options.active<0){options.active+=this.headers.length;}this._refresh();},_getCreateEventData:function _getCreateEventData(){return{header:this.active,panel:!this.active.length?$():this.active.next()};},_createIcons:function _createIcons(){var icon,children,icons=this.options.icons;if(icons){icon=$("<span>");this._addClass(icon,"ui-accordion-header-icon","ui-icon "+icons.header);icon.prependTo(this.headers);children=this.active.children(".ui-accordion-header-icon");this._removeClass(children,icons.header)._addClass(children,null,icons.activeHeader)._addClass(this.headers,"ui-accordion-icons");}},_destroyIcons:function _destroyIcons(){this._removeClass(this.headers,"ui-accordion-icons");this.headers.children(".ui-accordion-header-icon").remove();},_destroy:function _destroy(){var contents;// Clean up main element
	this.element.removeAttr("role");// Clean up headers
	this.headers.removeAttr("role aria-expanded aria-selected aria-controls tabIndex").removeUniqueId();this._destroyIcons();// Clean up content panels
	contents=this.headers.next().css("display","").removeAttr("role aria-hidden aria-labelledby").removeUniqueId();if(this.options.heightStyle!=="content"){contents.css("height","");}},_setOption:function _setOption(key,value){if(key==="active"){// _activate() will handle invalid values and update this.options
	this._activate(value);return;}if(key==="event"){if(this.options.event){this._off(this.headers,this.options.event);}this._setupEvents(value);}this._super(key,value);// Setting collapsible: false while collapsed; open first panel
	if(key==="collapsible"&&!value&&this.options.active===false){this._activate(0);}if(key==="icons"){this._destroyIcons();if(value){this._createIcons();}}},_setOptionDisabled:function _setOptionDisabled(value){this._super(value);this.element.attr("aria-disabled",value);// Support: IE8 Only
	// #5332 / #6059 - opacity doesn't cascade to positioned elements in IE
	// so we need to add the disabled class to the headers and panels
	this._toggleClass(null,"ui-state-disabled",!!value);this._toggleClass(this.headers.add(this.headers.next()),null,"ui-state-disabled",!!value);},_keydown:function _keydown(event){if(event.altKey||event.ctrlKey){return;}var keyCode=$.ui.keyCode,length=this.headers.length,currentIndex=this.headers.index(event.target),toFocus=false;switch(event.keyCode){case keyCode.RIGHT:case keyCode.DOWN:toFocus=this.headers[(currentIndex+1)%length];break;case keyCode.LEFT:case keyCode.UP:toFocus=this.headers[(currentIndex-1+length)%length];break;case keyCode.SPACE:case keyCode.ENTER:this._eventHandler(event);break;case keyCode.HOME:toFocus=this.headers[0];break;case keyCode.END:toFocus=this.headers[length-1];break;}if(toFocus){$(event.target).attr("tabIndex",-1);$(toFocus).attr("tabIndex",0);$(toFocus).trigger("focus");event.preventDefault();}},_panelKeyDown:function _panelKeyDown(event){if(event.keyCode===$.ui.keyCode.UP&&event.ctrlKey){$(event.currentTarget).prev().trigger("focus");}},refresh:function refresh(){var options=this.options;this._processPanels();// Was collapsed or no panel
	if(options.active===false&&options.collapsible===true||!this.headers.length){options.active=false;this.active=$();// active false only when collapsible is true
	}else if(options.active===false){this._activate(0);// was active, but active panel is gone
	}else if(this.active.length&&!$.contains(this.element[0],this.active[0])){// all remaining panel are disabled
	if(this.headers.length===this.headers.find(".ui-state-disabled").length){options.active=false;this.active=$();// activate previous panel
	}else{this._activate(Math.max(0,options.active-1));}// was active, active panel still exists
	}else{// make sure active index is correct
	options.active=this.headers.index(this.active);}this._destroyIcons();this._refresh();},_processPanels:function _processPanels(){var prevHeaders=this.headers,prevPanels=this.panels;this.headers=this.element.find(this.options.header);this._addClass(this.headers,"ui-accordion-header ui-accordion-header-collapsed","ui-state-default");this.panels=this.headers.next().filter(":not(.ui-accordion-content-active)").hide();this._addClass(this.panels,"ui-accordion-content","ui-helper-reset ui-widget-content");// Avoid memory leaks (#10056)
	if(prevPanels){this._off(prevHeaders.not(this.headers));this._off(prevPanels.not(this.panels));}},_refresh:function _refresh(){var maxHeight,options=this.options,heightStyle=options.heightStyle,parent=this.element.parent();this.active=this._findActive(options.active);this._addClass(this.active,"ui-accordion-header-active","ui-state-active")._removeClass(this.active,"ui-accordion-header-collapsed");this._addClass(this.active.next(),"ui-accordion-content-active");this.active.next().show();this.headers.attr("role","tab").each(function(){var header=$(this),headerId=header.uniqueId().attr("id"),panel=header.next(),panelId=panel.uniqueId().attr("id");header.attr("aria-controls",panelId);panel.attr("aria-labelledby",headerId);}).next().attr("role","tabpanel");this.headers.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}).next().attr({"aria-hidden":"true"}).hide();// Make sure at least one header is in the tab order
	if(!this.active.length){this.headers.eq(0).attr("tabIndex",0);}else{this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}).next().attr({"aria-hidden":"false"});}this._createIcons();this._setupEvents(options.event);if(heightStyle==="fill"){maxHeight=parent.height();this.element.siblings(":visible").each(function(){var elem=$(this),position=elem.css("position");if(position==="absolute"||position==="fixed"){return;}maxHeight-=elem.outerHeight(true);});this.headers.each(function(){maxHeight-=$(this).outerHeight(true);});this.headers.next().each(function(){$(this).height(Math.max(0,maxHeight-$(this).innerHeight()+$(this).height()));}).css("overflow","auto");}else if(heightStyle==="auto"){maxHeight=0;this.headers.next().each(function(){var isVisible=$(this).is(":visible");if(!isVisible){$(this).show();}maxHeight=Math.max(maxHeight,$(this).css("height","").height());if(!isVisible){$(this).hide();}}).height(maxHeight);}},_activate:function _activate(index){var active=this._findActive(index)[0];// Trying to activate the already active panel
	if(active===this.active[0]){return;}// Trying to collapse, simulate a click on the currently active header
	active=active||this.active[0];this._eventHandler({target:active,currentTarget:active,preventDefault:$.noop});},_findActive:function _findActive(selector){return typeof selector==="number"?this.headers.eq(selector):$();},_setupEvents:function _setupEvents(event){var events={keydown:"_keydown"};if(event){$.each(event.split(" "),function(index,eventName){events[eventName]="_eventHandler";});}this._off(this.headers.add(this.headers.next()));this._on(this.headers,events);this._on(this.headers.next(),{keydown:"_panelKeyDown"});this._hoverable(this.headers);this._focusable(this.headers);},_eventHandler:function _eventHandler(event){var activeChildren,clickedChildren,options=this.options,active=this.active,clicked=$(event.currentTarget),clickedIsActive=clicked[0]===active[0],collapsing=clickedIsActive&&options.collapsible,toShow=collapsing?$():clicked.next(),toHide=active.next(),eventData={oldHeader:active,oldPanel:toHide,newHeader:collapsing?$():clicked,newPanel:toShow};event.preventDefault();if(// click on active header, but not collapsible
	clickedIsActive&&!options.collapsible||// allow canceling activation
	this._trigger("beforeActivate",event,eventData)===false){return;}options.active=collapsing?false:this.headers.index(clicked);// When the call to ._toggle() comes after the class changes
	// it causes a very odd bug in IE 8 (see #6720)
	this.active=clickedIsActive?$():clicked;this._toggle(eventData);// Switch classes
	// corner classes on the previously active header stay after the animation
	this._removeClass(active,"ui-accordion-header-active","ui-state-active");if(options.icons){activeChildren=active.children(".ui-accordion-header-icon");this._removeClass(activeChildren,null,options.icons.activeHeader)._addClass(activeChildren,null,options.icons.header);}if(!clickedIsActive){this._removeClass(clicked,"ui-accordion-header-collapsed")._addClass(clicked,"ui-accordion-header-active","ui-state-active");if(options.icons){clickedChildren=clicked.children(".ui-accordion-header-icon");this._removeClass(clickedChildren,null,options.icons.header)._addClass(clickedChildren,null,options.icons.activeHeader);}this._addClass(clicked.next(),"ui-accordion-content-active");}},_toggle:function _toggle(data){var toShow=data.newPanel,toHide=this.prevShow.length?this.prevShow:data.oldPanel;// Handle activating a panel during the animation for another activation
	this.prevShow.add(this.prevHide).stop(true,true);this.prevShow=toShow;this.prevHide=toHide;if(this.options.animate){this._animate(toShow,toHide,data);}else{toHide.hide();toShow.show();this._toggleComplete(data);}toHide.attr({"aria-hidden":"true"});toHide.prev().attr({"aria-selected":"false","aria-expanded":"false"});// if we're switching panels, remove the old header from the tab order
	// if we're opening from collapsed state, remove the previous header from the tab order
	// if we're collapsing, then keep the collapsing header in the tab order
	if(toShow.length&&toHide.length){toHide.prev().attr({"tabIndex":-1,"aria-expanded":"false"});}else if(toShow.length){this.headers.filter(function(){return parseInt($(this).attr("tabIndex"),10)===0;}).attr("tabIndex",-1);}toShow.attr("aria-hidden","false").prev().attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0});},_animate:function _animate(toShow,toHide,data){var total,easing,duration,that=this,adjust=0,boxSizing=toShow.css("box-sizing"),down=toShow.length&&(!toHide.length||toShow.index()<toHide.index()),animate=this.options.animate||{},options=down&&animate.down||animate,complete=function complete(){that._toggleComplete(data);};if(typeof options==="number"){duration=options;}if(typeof options==="string"){easing=options;}// fall back from options to animation in case of partial down settings
	easing=easing||options.easing||animate.easing;duration=duration||options.duration||animate.duration;if(!toHide.length){return toShow.animate(this.showProps,duration,easing,complete);}if(!toShow.length){return toHide.animate(this.hideProps,duration,easing,complete);}total=toShow.show().outerHeight();toHide.animate(this.hideProps,{duration:duration,easing:easing,step:function step(now,fx){fx.now=Math.round(now);}});toShow.hide().animate(this.showProps,{duration:duration,easing:easing,complete:complete,step:function step(now,fx){fx.now=Math.round(now);if(fx.prop!=="height"){if(boxSizing==="content-box"){adjust+=fx.now;}}else if(that.options.heightStyle!=="content"){fx.now=Math.round(total-toHide.outerHeight()-adjust);adjust=0;}}});},_toggleComplete:function _toggleComplete(data){var toHide=data.oldPanel,prev=toHide.prev();this._removeClass(toHide,"ui-accordion-content-active");this._removeClass(prev,"ui-accordion-header-active")._addClass(prev,"ui-accordion-header-collapsed");// Work around for rendering bug in IE (#5421)
	if(toHide.length){toHide.parent()[0].className=toHide.parent()[0].className;}this._trigger("activate",null,data);}});var safeActiveElement=$.ui.safeActiveElement=function(document){var activeElement;// Support: IE 9 only
	// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
	try{activeElement=document.activeElement;}catch(error){activeElement=document.body;}// Support: IE 9 - 11 only
	// IE may return null instead of an element
	// Interestingly, this only seems to occur when NOT in an iframe
	if(!activeElement){activeElement=document.body;}// Support: IE 11 only
	// IE11 returns a seemingly empty object in some cases when accessing
	// document.activeElement from an <iframe>
	if(!activeElement.nodeName){activeElement=document.body;}return activeElement;};/*!
	 * jQuery UI Menu 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Menu
	//>>group: Widgets
	//>>description: Creates nestable menus.
	//>>docs: http://api.jqueryui.com/menu/
	//>>demos: http://jqueryui.com/menu/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/menu.css
	//>>css.theme: ../../themes/base/theme.css
	var widgetsMenu=$.widget("ui.menu",{version:"1.12.1",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-caret-1-e"},items:"> *",menus:"ul",position:{my:"left top",at:"right top"},role:"menu",// Callbacks
	blur:null,focus:null,select:null},_create:function _create(){this.activeMenu=this.element;// Flag used to prevent firing of the click handler
	// as the event bubbles up through nested menus
	this.mouseHandled=false;this.element.uniqueId().attr({role:this.options.role,tabIndex:0});this._addClass("ui-menu","ui-widget ui-widget-content");this._on({// Prevent focus from sticking to links inside menu after clicking
	// them (focus should always stay on UL during navigation).
	"mousedown .ui-menu-item":function mousedownUiMenuItem(event){event.preventDefault();},"click .ui-menu-item":function clickUiMenuItem(event){var target=$(event.target);var active=$($.ui.safeActiveElement(this.document[0]));if(!this.mouseHandled&&target.not(".ui-state-disabled").length){this.select(event);// Only set the mouseHandled flag if the event will bubble, see #9469.
	if(!event.isPropagationStopped()){this.mouseHandled=true;}// Open submenu on click
	if(target.has(".ui-menu").length){this.expand(event);}else if(!this.element.is(":focus")&&active.closest(".ui-menu").length){// Redirect focus to the menu
	this.element.trigger("focus",[true]);// If the active item is on the top level, let it stay active.
	// Otherwise, blur the active item since it is no longer visible.
	if(this.active&&this.active.parents(".ui-menu").length===1){clearTimeout(this.timer);}}}},"mouseenter .ui-menu-item":function mouseenterUiMenuItem(event){// Ignore mouse events while typeahead is active, see #10458.
	// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
	// is over an item in the menu
	if(this.previousFilter){return;}var actualTarget=$(event.target).closest(".ui-menu-item"),target=$(event.currentTarget);// Ignore bubbled events on parent items, see #11641
	if(actualTarget[0]!==target[0]){return;}// Remove ui-state-active class from siblings of the newly focused menu item
	// to avoid a jump caused by adjacent elements both having a class with a border
	this._removeClass(target.siblings().children(".ui-state-active"),null,"ui-state-active");this.focus(event,target);},mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function focus(event,keepActiveItem){// If there's already an active item, keep it active
	// If not, activate the first item
	var item=this.active||this.element.find(this.options.items).eq(0);if(!keepActiveItem){this.focus(event,item);}},blur:function blur(event){this._delay(function(){var notContained=!$.contains(this.element[0],$.ui.safeActiveElement(this.document[0]));if(notContained){this.collapseAll(event);}});},keydown:"_keydown"});this.refresh();// Clicks outside of a menu collapse any open menus
	this._on(this.document,{click:function click(event){if(this._closeOnDocumentClick(event)){this.collapseAll(event);}// Reset the mouseHandled flag
	this.mouseHandled=false;}});},_destroy:function _destroy(){var items=this.element.find(".ui-menu-item").removeAttr("role aria-disabled"),submenus=items.children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");// Destroy (sub)menus
	this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled "+"tabIndex").removeUniqueId().show();submenus.children().each(function(){var elem=$(this);if(elem.data("ui-menu-submenu-caret")){elem.remove();}});},_keydown:function _keydown(event){var match,prev,character,skip,preventDefault=true;switch(event.keyCode){case $.ui.keyCode.PAGE_UP:this.previousPage(event);break;case $.ui.keyCode.PAGE_DOWN:this.nextPage(event);break;case $.ui.keyCode.HOME:this._move("first","first",event);break;case $.ui.keyCode.END:this._move("last","last",event);break;case $.ui.keyCode.UP:this.previous(event);break;case $.ui.keyCode.DOWN:this.next(event);break;case $.ui.keyCode.LEFT:this.collapse(event);break;case $.ui.keyCode.RIGHT:if(this.active&&!this.active.is(".ui-state-disabled")){this.expand(event);}break;case $.ui.keyCode.ENTER:case $.ui.keyCode.SPACE:this._activate(event);break;case $.ui.keyCode.ESCAPE:this.collapse(event);break;default:preventDefault=false;prev=this.previousFilter||"";skip=false;// Support number pad values
	character=event.keyCode>=96&&event.keyCode<=105?(event.keyCode-96).toString():String.fromCharCode(event.keyCode);clearTimeout(this.filterTimer);if(character===prev){skip=true;}else{character=prev+character;}match=this._filterMenuItems(character);match=skip&&match.index(this.active.next())!==-1?this.active.nextAll(".ui-menu-item"):match;// If no matches on the current filter, reset to the last character pressed
	// to move down the menu to the first item that starts with that character
	if(!match.length){character=String.fromCharCode(event.keyCode);match=this._filterMenuItems(character);}if(match.length){this.focus(event,match);this.previousFilter=character;this.filterTimer=this._delay(function(){delete this.previousFilter;},1000);}else{delete this.previousFilter;}}if(preventDefault){event.preventDefault();}},_activate:function _activate(event){if(this.active&&!this.active.is(".ui-state-disabled")){if(this.active.children("[aria-haspopup='true']").length){this.expand(event);}else{this.select(event);}}},refresh:function refresh(){var menus,items,newSubmenus,newItems,newWrappers,that=this,icon=this.options.icons.submenu,submenus=this.element.find(this.options.menus);this._toggleClass("ui-menu-icons",null,!!this.element.find(".ui-icon").length);// Initialize nested menus
	newSubmenus=submenus.filter(":not(.ui-menu)").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var menu=$(this),item=menu.prev(),submenuCaret=$("<span>").data("ui-menu-submenu-caret",true);that._addClass(submenuCaret,"ui-menu-icon","ui-icon "+icon);item.attr("aria-haspopup","true").prepend(submenuCaret);menu.attr("aria-labelledby",item.attr("id"));});this._addClass(newSubmenus,"ui-menu","ui-widget ui-widget-content ui-front");menus=submenus.add(this.element);items=menus.find(this.options.items);// Initialize menu-items containing spaces and/or dashes only as dividers
	items.not(".ui-menu-item").each(function(){var item=$(this);if(that._isDivider(item)){that._addClass(item,"ui-menu-divider","ui-widget-content");}});// Don't refresh list items that are already adapted
	newItems=items.not(".ui-menu-item, .ui-menu-divider");newWrappers=newItems.children().not(".ui-menu").uniqueId().attr({tabIndex:-1,role:this._itemRole()});this._addClass(newItems,"ui-menu-item")._addClass(newWrappers,"ui-menu-item-wrapper");// Add aria-disabled attribute to any disabled menu item
	items.filter(".ui-state-disabled").attr("aria-disabled","true");// If the active item has been removed, blur the menu
	if(this.active&&!$.contains(this.element[0],this.active[0])){this.blur();}},_itemRole:function _itemRole(){return{menu:"menuitem",listbox:"option"}[this.options.role];},_setOption:function _setOption(key,value){if(key==="icons"){var icons=this.element.find(".ui-menu-icon");this._removeClass(icons,null,this.options.icons.submenu)._addClass(icons,null,value.submenu);}this._super(key,value);},_setOptionDisabled:function _setOptionDisabled(value){this._super(value);this.element.attr("aria-disabled",String(value));this._toggleClass(null,"ui-state-disabled",!!value);},focus:function focus(event,item){var nested,focused,activeParent;this.blur(event,event&&event.type==="focus");this._scrollIntoView(item);this.active=item.first();focused=this.active.children(".ui-menu-item-wrapper");this._addClass(focused,null,"ui-state-active");// Only update aria-activedescendant if there's a role
	// otherwise we assume focus is managed elsewhere
	if(this.options.role){this.element.attr("aria-activedescendant",focused.attr("id"));}// Highlight active parent menu item, if any
	activeParent=this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper");this._addClass(activeParent,null,"ui-state-active");if(event&&event.type==="keydown"){this._close();}else{this.timer=this._delay(function(){this._close();},this.delay);}nested=item.children(".ui-menu");if(nested.length&&event&&/^mouse/.test(event.type)){this._startOpening(nested);}this.activeMenu=item.parent();this._trigger("focus",event,{item:item});},_scrollIntoView:function _scrollIntoView(item){var borderTop,paddingTop,offset,scroll,elementHeight,itemHeight;if(this._hasScroll()){borderTop=parseFloat($.css(this.activeMenu[0],"borderTopWidth"))||0;paddingTop=parseFloat($.css(this.activeMenu[0],"paddingTop"))||0;offset=item.offset().top-this.activeMenu.offset().top-borderTop-paddingTop;scroll=this.activeMenu.scrollTop();elementHeight=this.activeMenu.height();itemHeight=item.outerHeight();if(offset<0){this.activeMenu.scrollTop(scroll+offset);}else if(offset+itemHeight>elementHeight){this.activeMenu.scrollTop(scroll+offset-elementHeight+itemHeight);}}},blur:function blur(event,fromFocus){if(!fromFocus){clearTimeout(this.timer);}if(!this.active){return;}this._removeClass(this.active.children(".ui-menu-item-wrapper"),null,"ui-state-active");this._trigger("blur",event,{item:this.active});this.active=null;},_startOpening:function _startOpening(submenu){clearTimeout(this.timer);// Don't open if already open fixes a Firefox bug that caused a .5 pixel
	// shift in the submenu position when mousing over the caret icon
	if(submenu.attr("aria-hidden")!=="true"){return;}this.timer=this._delay(function(){this._close();this._open(submenu);},this.delay);},_open:function _open(submenu){var position=$.extend({of:this.active},this.options.position);clearTimeout(this.timer);this.element.find(".ui-menu").not(submenu.parents(".ui-menu")).hide().attr("aria-hidden","true");submenu.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(position);},collapseAll:function collapseAll(event,all){clearTimeout(this.timer);this.timer=this._delay(function(){// If we were passed an event, look for the submenu that contains the event
	var currentMenu=all?this.element:$(event&&event.target).closest(this.element.find(".ui-menu"));// If we found no valid submenu ancestor, use the main menu to close all
	// sub menus anyway
	if(!currentMenu.length){currentMenu=this.element;}this._close(currentMenu);this.blur(event);// Work around active item staying active after menu is blurred
	this._removeClass(currentMenu.find(".ui-state-active"),null,"ui-state-active");this.activeMenu=currentMenu;},this.delay);},// With no arguments, closes the currently active menu - if nothing is active
	// it closes all menus.  If passed an argument, it will search for menus BELOW
	_close:function _close(startMenu){if(!startMenu){startMenu=this.active?this.active.parent():this.element;}startMenu.find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false");},_closeOnDocumentClick:function _closeOnDocumentClick(event){return!$(event.target).closest(".ui-menu").length;},_isDivider:function _isDivider(item){// Match hyphen, em dash, en dash
	return!/[^\-\u2014\u2013\s]/.test(item.text());},collapse:function collapse(event){var newItem=this.active&&this.active.parent().closest(".ui-menu-item",this.element);if(newItem&&newItem.length){this._close();this.focus(event,newItem);}},expand:function expand(event){var newItem=this.active&&this.active.children(".ui-menu ").find(this.options.items).first();if(newItem&&newItem.length){this._open(newItem.parent());// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
	this._delay(function(){this.focus(event,newItem);});}},next:function next(event){this._move("next","first",event);},previous:function previous(event){this._move("prev","last",event);},isFirstItem:function isFirstItem(){return this.active&&!this.active.prevAll(".ui-menu-item").length;},isLastItem:function isLastItem(){return this.active&&!this.active.nextAll(".ui-menu-item").length;},_move:function _move(direction,filter,event){var next;if(this.active){if(direction==="first"||direction==="last"){next=this.active[direction==="first"?"prevAll":"nextAll"](".ui-menu-item").eq(-1);}else{next=this.active[direction+"All"](".ui-menu-item").eq(0);}}if(!next||!next.length||!this.active){next=this.activeMenu.find(this.options.items)[filter]();}this.focus(event,next);},nextPage:function nextPage(event){var item,base,height;if(!this.active){this.next(event);return;}if(this.isLastItem()){return;}if(this._hasScroll()){base=this.active.offset().top;height=this.element.height();this.active.nextAll(".ui-menu-item").each(function(){item=$(this);return item.offset().top-base-height<0;});this.focus(event,item);}else{this.focus(event,this.activeMenu.find(this.options.items)[!this.active?"first":"last"]());}},previousPage:function previousPage(event){var item,base,height;if(!this.active){this.next(event);return;}if(this.isFirstItem()){return;}if(this._hasScroll()){base=this.active.offset().top;height=this.element.height();this.active.prevAll(".ui-menu-item").each(function(){item=$(this);return item.offset().top-base+height>0;});this.focus(event,item);}else{this.focus(event,this.activeMenu.find(this.options.items).first());}},_hasScroll:function _hasScroll(){return this.element.outerHeight()<this.element.prop("scrollHeight");},select:function select(event){// TODO: It should never be possible to not have an active item at this
	// point, but the tests don't trigger mouseenter before click.
	this.active=this.active||$(event.target).closest(".ui-menu-item");var ui={item:this.active};if(!this.active.has(".ui-menu").length){this.collapseAll(event,true);}this._trigger("select",event,ui);},_filterMenuItems:function _filterMenuItems(character){var escapedCharacter=character.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&"),regex=new RegExp("^"+escapedCharacter,"i");return this.activeMenu.find(this.options.items)// Only match on items, not dividers or other content (#10571)
	.filter(".ui-menu-item").filter(function(){return regex.test($.trim($(this).children(".ui-menu-item-wrapper").text()));});}});/*!
	 * jQuery UI Autocomplete 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Autocomplete
	//>>group: Widgets
	//>>description: Lists suggested words as the user is typing.
	//>>docs: http://api.jqueryui.com/autocomplete/
	//>>demos: http://jqueryui.com/autocomplete/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/autocomplete.css
	//>>css.theme: ../../themes/base/theme.css
	$.widget("ui.autocomplete",{version:"1.12.1",defaultElement:"<input>",options:{appendTo:null,autoFocus:false,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,// Callbacks
	change:null,close:null,focus:null,open:null,response:null,search:null,select:null},requestIndex:0,pending:0,_create:function _create(){// Some browsers only repeat keydown events, not keypress events,
	// so we use the suppressKeyPress flag to determine if we've already
	// handled the keydown event. #7269
	// Unfortunately the code for & in keypress is the same as the up arrow,
	// so we use the suppressKeyPressRepeat flag to avoid handling keypress
	// events when we know the keydown event was used to modify the
	// search term. #7799
	var suppressKeyPress,suppressKeyPressRepeat,suppressInput,nodeName=this.element[0].nodeName.toLowerCase(),isTextarea=nodeName==="textarea",isInput=nodeName==="input";// Textareas are always multi-line
	// Inputs are always single-line, even if inside a contentEditable element
	// IE also treats inputs as contentEditable
	// All other element types are determined by whether or not they're contentEditable
	this.isMultiLine=isTextarea||!isInput&&this._isContentEditable(this.element);this.valueMethod=this.element[isTextarea||isInput?"val":"text"];this.isNewMenu=true;this._addClass("ui-autocomplete-input");this.element.attr("autocomplete","off");this._on(this.element,{keydown:function keydown(event){if(this.element.prop("readOnly")){suppressKeyPress=true;suppressInput=true;suppressKeyPressRepeat=true;return;}suppressKeyPress=false;suppressInput=false;suppressKeyPressRepeat=false;var keyCode=$.ui.keyCode;switch(event.keyCode){case keyCode.PAGE_UP:suppressKeyPress=true;this._move("previousPage",event);break;case keyCode.PAGE_DOWN:suppressKeyPress=true;this._move("nextPage",event);break;case keyCode.UP:suppressKeyPress=true;this._keyEvent("previous",event);break;case keyCode.DOWN:suppressKeyPress=true;this._keyEvent("next",event);break;case keyCode.ENTER:// when menu is open and has focus
	if(this.menu.active){// #6055 - Opera still allows the keypress to occur
	// which causes forms to submit
	suppressKeyPress=true;event.preventDefault();this.menu.select(event);}break;case keyCode.TAB:if(this.menu.active){this.menu.select(event);}break;case keyCode.ESCAPE:if(this.menu.element.is(":visible")){if(!this.isMultiLine){this._value(this.term);}this.close(event);// Different browsers have different default behavior for escape
	// Single press can mean undo or clear
	// Double press in IE means clear the whole form
	event.preventDefault();}break;default:suppressKeyPressRepeat=true;// search timeout should be triggered before the input value is changed
	this._searchTimeout(event);break;}},keypress:function keypress(event){if(suppressKeyPress){suppressKeyPress=false;if(!this.isMultiLine||this.menu.element.is(":visible")){event.preventDefault();}return;}if(suppressKeyPressRepeat){return;}// Replicate some key handlers to allow them to repeat in Firefox and Opera
	var keyCode=$.ui.keyCode;switch(event.keyCode){case keyCode.PAGE_UP:this._move("previousPage",event);break;case keyCode.PAGE_DOWN:this._move("nextPage",event);break;case keyCode.UP:this._keyEvent("previous",event);break;case keyCode.DOWN:this._keyEvent("next",event);break;}},input:function input(event){if(suppressInput){suppressInput=false;event.preventDefault();return;}this._searchTimeout(event);},focus:function focus(){this.selectedItem=null;this.previous=this._value();},blur:function blur(event){if(this.cancelBlur){delete this.cancelBlur;return;}clearTimeout(this.searching);this.close(event);this._change(event);}});this._initSource();this.menu=$("<ul>").appendTo(this._appendTo()).menu({// disable ARIA support, the live region takes care of that
	role:null}).hide().menu("instance");this._addClass(this.menu.element,"ui-autocomplete","ui-front");this._on(this.menu.element,{mousedown:function mousedown(event){// prevent moving focus out of the text field
	event.preventDefault();// IE doesn't prevent moving focus even with event.preventDefault()
	// so we set a flag to know when we should ignore the blur event
	this.cancelBlur=true;this._delay(function(){delete this.cancelBlur;// Support: IE 8 only
	// Right clicking a menu item or selecting text from the menu items will
	// result in focus moving out of the input. However, we've already received
	// and ignored the blur event because of the cancelBlur flag set above. So
	// we restore focus to ensure that the menu closes properly based on the user's
	// next actions.
	if(this.element[0]!==$.ui.safeActiveElement(this.document[0])){this.element.trigger("focus");}});},menufocus:function menufocus(event,ui){var label,item;// support: Firefox
	// Prevent accidental activation of menu items in Firefox (#7024 #9118)
	if(this.isNewMenu){this.isNewMenu=false;if(event.originalEvent&&/^mouse/.test(event.originalEvent.type)){this.menu.blur();this.document.one("mousemove",function(){$(event.target).trigger(event.originalEvent);});return;}}item=ui.item.data("ui-autocomplete-item");if(false!==this._trigger("focus",event,{item:item})){// use value to match what will end up in the input, if it was a key event
	if(event.originalEvent&&/^key/.test(event.originalEvent.type)){this._value(item.value);}}// Announce the value in the liveRegion
	label=ui.item.attr("aria-label")||item.value;if(label&&$.trim(label).length){this.liveRegion.children().hide();$("<div>").text(label).appendTo(this.liveRegion);}},menuselect:function menuselect(event,ui){var item=ui.item.data("ui-autocomplete-item"),previous=this.previous;// Only trigger when focus was lost (click on menu)
	if(this.element[0]!==$.ui.safeActiveElement(this.document[0])){this.element.trigger("focus");this.previous=previous;// #6109 - IE triggers two focus events and the second
	// is asynchronous, so we need to reset the previous
	// term synchronously and asynchronously :-(
	this._delay(function(){this.previous=previous;this.selectedItem=item;});}if(false!==this._trigger("select",event,{item:item})){this._value(item.value);}// reset the term after the select event
	// this allows custom select handling to work properly
	this.term=this._value();this.close(event);this.selectedItem=item;}});this.liveRegion=$("<div>",{role:"status","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body);this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible");// Turning off autocomplete prevents the browser from remembering the
	// value when navigating through history, so we re-enable autocomplete
	// if the page is unloaded before the widget is destroyed. #7790
	this._on(this.window,{beforeunload:function beforeunload(){this.element.removeAttr("autocomplete");}});},_destroy:function _destroy(){clearTimeout(this.searching);this.element.removeAttr("autocomplete");this.menu.element.remove();this.liveRegion.remove();},_setOption:function _setOption(key,value){this._super(key,value);if(key==="source"){this._initSource();}if(key==="appendTo"){this.menu.element.appendTo(this._appendTo());}if(key==="disabled"&&value&&this.xhr){this.xhr.abort();}},_isEventTargetInWidget:function _isEventTargetInWidget(event){var menuElement=this.menu.element[0];return event.target===this.element[0]||event.target===menuElement||$.contains(menuElement,event.target);},_closeOnClickOutside:function _closeOnClickOutside(event){if(!this._isEventTargetInWidget(event)){this.close();}},_appendTo:function _appendTo(){var element=this.options.appendTo;if(element){element=element.jquery||element.nodeType?$(element):this.document.find(element).eq(0);}if(!element||!element[0]){element=this.element.closest(".ui-front, dialog");}if(!element.length){element=this.document[0].body;}return element;},_initSource:function _initSource(){var array,url,that=this;if($.isArray(this.options.source)){array=this.options.source;this.source=function(request,response){response($.ui.autocomplete.filter(array,request.term));};}else if(typeof this.options.source==="string"){url=this.options.source;this.source=function(request,response){if(that.xhr){that.xhr.abort();}that.xhr=$.ajax({url:url,data:request,dataType:"json",success:function success(data){response(data);},error:function error(){response([]);}});};}else{this.source=this.options.source;}},_searchTimeout:function _searchTimeout(event){clearTimeout(this.searching);this.searching=this._delay(function(){// Search if the value has changed, or if the user retypes the same value (see #7434)
	var equalValues=this.term===this._value(),menuVisible=this.menu.element.is(":visible"),modifierKey=event.altKey||event.ctrlKey||event.metaKey||event.shiftKey;if(!equalValues||equalValues&&!menuVisible&&!modifierKey){this.selectedItem=null;this.search(null,event);}},this.options.delay);},search:function search(value,event){value=value!=null?value:this._value();// Always save the actual value, not the one passed as an argument
	this.term=this._value();if(value.length<this.options.minLength){return this.close(event);}if(this._trigger("search",event)===false){return;}return this._search(value);},_search:function _search(value){this.pending++;this._addClass("ui-autocomplete-loading");this.cancelSearch=false;this.source({term:value},this._response());},_response:function _response(){var index=++this.requestIndex;return $.proxy(function(content){if(index===this.requestIndex){this.__response(content);}this.pending--;if(!this.pending){this._removeClass("ui-autocomplete-loading");}},this);},__response:function __response(content){if(content){content=this._normalize(content);}this._trigger("response",null,{content:content});if(!this.options.disabled&&content&&content.length&&!this.cancelSearch){this._suggest(content);this._trigger("open");}else{// use ._close() instead of .close() so we don't cancel future searches
	this._close();}},close:function close(event){this.cancelSearch=true;this._close(event);},_close:function _close(event){// Remove the handler that closes the menu on outside clicks
	this._off(this.document,"mousedown");if(this.menu.element.is(":visible")){this.menu.element.hide();this.menu.blur();this.isNewMenu=true;this._trigger("close",event);}},_change:function _change(event){if(this.previous!==this._value()){this._trigger("change",event,{item:this.selectedItem});}},_normalize:function _normalize(items){// assume all items have the right format when the first item is complete
	if(items.length&&items[0].label&&items[0].value){return items;}return $.map(items,function(item){if(typeof item==="string"){return{label:item,value:item};}return $.extend({},item,{label:item.label||item.value,value:item.value||item.label});});},_suggest:function _suggest(items){var ul=this.menu.element.empty();this._renderMenu(ul,items);this.isNewMenu=true;this.menu.refresh();// Size and position menu
	ul.show();this._resizeMenu();ul.position($.extend({of:this.element},this.options.position));if(this.options.autoFocus){this.menu.next();}// Listen for interactions outside of the widget (#6642)
	this._on(this.document,{mousedown:"_closeOnClickOutside"});},_resizeMenu:function _resizeMenu(){var ul=this.menu.element;ul.outerWidth(Math.max(// Firefox wraps long text (possibly a rounding bug)
	// so we add 1px to avoid the wrapping (#7513)
	ul.width("").outerWidth()+1,this.element.outerWidth()));},_renderMenu:function _renderMenu(ul,items){var that=this;$.each(items,function(index,item){that._renderItemData(ul,item);});},_renderItemData:function _renderItemData(ul,item){return this._renderItem(ul,item).data("ui-autocomplete-item",item);},_renderItem:function _renderItem(ul,item){return $("<li>").append($("<div>").text(item.label)).appendTo(ul);},_move:function _move(direction,event){if(!this.menu.element.is(":visible")){this.search(null,event);return;}if(this.menu.isFirstItem()&&/^previous/.test(direction)||this.menu.isLastItem()&&/^next/.test(direction)){if(!this.isMultiLine){this._value(this.term);}this.menu.blur();return;}this.menu[direction](event);},widget:function widget(){return this.menu.element;},_value:function _value(){return this.valueMethod.apply(this.element,arguments);},_keyEvent:function _keyEvent(keyEvent,event){if(!this.isMultiLine||this.menu.element.is(":visible")){this._move(keyEvent,event);// Prevents moving cursor to beginning/end of the text field in some browsers
	event.preventDefault();}},// Support: Chrome <=50
	// We should be able to just use this.element.prop( "isContentEditable" )
	// but hidden elements always report false in Chrome.
	// https://code.google.com/p/chromium/issues/detail?id=313082
	_isContentEditable:function _isContentEditable(element){if(!element.length){return false;}var editable=element.prop("contentEditable");if(editable==="inherit"){return this._isContentEditable(element.parent());}return editable==="true";}});$.extend($.ui.autocomplete,{escapeRegex:function escapeRegex(value){return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&");},filter:function filter(array,term){var matcher=new RegExp($.ui.autocomplete.escapeRegex(term),"i");return $.grep(array,function(value){return matcher.test(value.label||value.value||value);});}});// Live region extension, adding a `messages` option
	// NOTE: This is an experimental API. We are still investigating
	// a full solution for string manipulation and internationalization.
	$.widget("ui.autocomplete",$.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function results(amount){return amount+(amount>1?" results are":" result is")+" available, use up and down arrow keys to navigate.";}}},__response:function __response(content){var message;this._superApply(arguments);if(this.options.disabled||this.cancelSearch){return;}if(content&&content.length){message=this.options.messages.results(content.length);}else{message=this.options.messages.noResults;}this.liveRegion.children().hide();$("<div>").text(message).appendTo(this.liveRegion);}});var widgetsAutocomplete=$.ui.autocomplete;/*!
	 * jQuery UI Controlgroup 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Controlgroup
	//>>group: Widgets
	//>>description: Visually groups form control widgets
	//>>docs: http://api.jqueryui.com/controlgroup/
	//>>demos: http://jqueryui.com/controlgroup/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/controlgroup.css
	//>>css.theme: ../../themes/base/theme.css
	var controlgroupCornerRegex=/ui-corner-([a-z]){2,6}/g;var widgetsControlgroup=$.widget("ui.controlgroup",{version:"1.12.1",defaultElement:"<div>",options:{direction:"horizontal",disabled:null,onlyVisible:true,items:{"button":"input[type=button], input[type=submit], input[type=reset], button, a","controlgroupLabel":".ui-controlgroup-label","checkboxradio":"input[type='checkbox'], input[type='radio']","selectmenu":"select","spinner":".ui-spinner-input"}},_create:function _create(){this._enhance();},// To support the enhanced option in jQuery Mobile, we isolate DOM manipulation
	_enhance:function _enhance(){this.element.attr("role","toolbar");this.refresh();},_destroy:function _destroy(){this._callChildMethod("destroy");this.childWidgets.removeData("ui-controlgroup-data");this.element.removeAttr("role");if(this.options.items.controlgroupLabel){this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap();}},_initWidgets:function _initWidgets(){var that=this,childWidgets=[];// First we iterate over each of the items options
	$.each(this.options.items,function(widget,selector){var labels;var options={};// Make sure the widget has a selector set
	if(!selector){return;}if(widget==="controlgroupLabel"){labels=that.element.find(selector);labels.each(function(){var element=$(this);if(element.children(".ui-controlgroup-label-contents").length){return;}element.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>");});that._addClass(labels,null,"ui-widget ui-widget-content ui-state-default");childWidgets=childWidgets.concat(labels.get());return;}// Make sure the widget actually exists
	if(!$.fn[widget]){return;}// We assume everything is in the middle to start because we can't determine
	// first / last elements until all enhancments are done.
	if(that["_"+widget+"Options"]){options=that["_"+widget+"Options"]("middle");}else{options={classes:{}};}// Find instances of this widget inside controlgroup and init them
	that.element.find(selector).each(function(){var element=$(this);var instance=element[widget]("instance");// We need to clone the default options for this type of widget to avoid
	// polluting the variable options which has a wider scope than a single widget.
	var instanceOptions=$.widget.extend({},options);// If the button is the child of a spinner ignore it
	// TODO: Find a more generic solution
	if(widget==="button"&&element.parent(".ui-spinner").length){return;}// Create the widget if it doesn't exist
	if(!instance){instance=element[widget]()[widget]("instance");}if(instance){instanceOptions.classes=that._resolveClassesValues(instanceOptions.classes,instance);}element[widget](instanceOptions);// Store an instance of the controlgroup to be able to reference
	// from the outermost element for changing options and refresh
	var widgetElement=element[widget]("widget");$.data(widgetElement[0],"ui-controlgroup-data",instance?instance:element[widget]("instance"));childWidgets.push(widgetElement[0]);});});this.childWidgets=$($.unique(childWidgets));this._addClass(this.childWidgets,"ui-controlgroup-item");},_callChildMethod:function _callChildMethod(method){this.childWidgets.each(function(){var element=$(this),data=element.data("ui-controlgroup-data");if(data&&data[method]){data[method]();}});},_updateCornerClass:function _updateCornerClass(element,position){var remove="ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all";var add=this._buildSimpleOptions(position,"label").classes.label;this._removeClass(element,null,remove);this._addClass(element,null,add);},_buildSimpleOptions:function _buildSimpleOptions(position,key){var direction=this.options.direction==="vertical";var result={classes:{}};result.classes[key]={"middle":"","first":"ui-corner-"+(direction?"top":"left"),"last":"ui-corner-"+(direction?"bottom":"right"),"only":"ui-corner-all"}[position];return result;},_spinnerOptions:function _spinnerOptions(position){var options=this._buildSimpleOptions(position,"ui-spinner");options.classes["ui-spinner-up"]="";options.classes["ui-spinner-down"]="";return options;},_buttonOptions:function _buttonOptions(position){return this._buildSimpleOptions(position,"ui-button");},_checkboxradioOptions:function _checkboxradioOptions(position){return this._buildSimpleOptions(position,"ui-checkboxradio-label");},_selectmenuOptions:function _selectmenuOptions(position){var direction=this.options.direction==="vertical";return{width:direction?"auto":false,classes:{middle:{"ui-selectmenu-button-open":"","ui-selectmenu-button-closed":""},first:{"ui-selectmenu-button-open":"ui-corner-"+(direction?"top":"tl"),"ui-selectmenu-button-closed":"ui-corner-"+(direction?"top":"left")},last:{"ui-selectmenu-button-open":direction?"":"ui-corner-tr","ui-selectmenu-button-closed":"ui-corner-"+(direction?"bottom":"right")},only:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"}}[position]};},_resolveClassesValues:function _resolveClassesValues(classes,instance){var result={};$.each(classes,function(key){var current=instance.options.classes[key]||"";current=$.trim(current.replace(controlgroupCornerRegex,""));result[key]=(current+" "+classes[key]).replace(/\s+/g," ");});return result;},_setOption:function _setOption(key,value){if(key==="direction"){this._removeClass("ui-controlgroup-"+this.options.direction);}this._super(key,value);if(key==="disabled"){this._callChildMethod(value?"disable":"enable");return;}this.refresh();},refresh:function refresh(){var children,that=this;this._addClass("ui-controlgroup ui-controlgroup-"+this.options.direction);if(this.options.direction==="horizontal"){this._addClass(null,"ui-helper-clearfix");}this._initWidgets();children=this.childWidgets;// We filter here because we need to track all childWidgets not just the visible ones
	if(this.options.onlyVisible){children=children.filter(":visible");}if(children.length){// We do this last because we need to make sure all enhancment is done
	// before determining first and last
	$.each(["first","last"],function(index,value){var instance=children[value]().data("ui-controlgroup-data");if(instance&&that["_"+instance.widgetName+"Options"]){var options=that["_"+instance.widgetName+"Options"](children.length===1?"only":value);options.classes=that._resolveClassesValues(options.classes,instance);instance.element[instance.widgetName](options);}else{that._updateCornerClass(children[value](),value);}});// Finally call the refresh method on each of the child widgets.
	this._callChildMethod("refresh");}}});/*!
	 * jQuery UI Checkboxradio 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Checkboxradio
	//>>group: Widgets
	//>>description: Enhances a form with multiple themeable checkboxes or radio buttons.
	//>>docs: http://api.jqueryui.com/checkboxradio/
	//>>demos: http://jqueryui.com/checkboxradio/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/button.css
	//>>css.structure: ../../themes/base/checkboxradio.css
	//>>css.theme: ../../themes/base/theme.css
	$.widget("ui.checkboxradio",[$.ui.formResetMixin,{version:"1.12.1",options:{disabled:null,label:null,icon:true,classes:{"ui-checkboxradio-label":"ui-corner-all","ui-checkboxradio-icon":"ui-corner-all"}},_getCreateOptions:function _getCreateOptions(){var disabled,labels;var that=this;var options=this._super()||{};// We read the type here, because it makes more sense to throw a element type error first,
	// rather then the error for lack of a label. Often if its the wrong type, it
	// won't have a label (e.g. calling on a div, btn, etc)
	this._readType();labels=this.element.labels();// If there are multiple labels, use the last one
	this.label=$(labels[labels.length-1]);if(!this.label.length){$.error("No label found for checkboxradio widget");}this.originalLabel="";// We need to get the label text but this may also need to make sure it does not contain the
	// input itself.
	this.label.contents().not(this.element[0]).each(function(){// The label contents could be text, html, or a mix. We concat each element to get a
	// string representation of the label, without the input as part of it.
	that.originalLabel+=this.nodeType===3?$(this).text():this.outerHTML;});// Set the label option if we found label text
	if(this.originalLabel){options.label=this.originalLabel;}disabled=this.element[0].disabled;if(disabled!=null){options.disabled=disabled;}return options;},_create:function _create(){var checked=this.element[0].checked;this._bindFormResetHandler();if(this.options.disabled==null){this.options.disabled=this.element[0].disabled;}this._setOption("disabled",this.options.disabled);this._addClass("ui-checkboxradio","ui-helper-hidden-accessible");this._addClass(this.label,"ui-checkboxradio-label","ui-button ui-widget");if(this.type==="radio"){this._addClass(this.label,"ui-checkboxradio-radio-label");}if(this.options.label&&this.options.label!==this.originalLabel){this._updateLabel();}else if(this.originalLabel){this.options.label=this.originalLabel;}this._enhance();if(checked){this._addClass(this.label,"ui-checkboxradio-checked","ui-state-active");if(this.icon){this._addClass(this.icon,null,"ui-state-hover");}}this._on({change:"_toggleClasses",focus:function focus(){this._addClass(this.label,null,"ui-state-focus ui-visual-focus");},blur:function blur(){this._removeClass(this.label,null,"ui-state-focus ui-visual-focus");}});},_readType:function _readType(){var nodeName=this.element[0].nodeName.toLowerCase();this.type=this.element[0].type;if(nodeName!=="input"||!/radio|checkbox/.test(this.type)){$.error("Can't create checkboxradio on element.nodeName="+nodeName+" and element.type="+this.type);}},// Support jQuery Mobile enhanced option
	_enhance:function _enhance(){this._updateIcon(this.element[0].checked);},widget:function widget(){return this.label;},_getRadioGroup:function _getRadioGroup(){var group;var name=this.element[0].name;var nameSelector="input[name='"+$.ui.escapeSelector(name)+"']";if(!name){return $([]);}if(this.form.length){group=$(this.form[0].elements).filter(nameSelector);}else{// Not inside a form, check all inputs that also are not inside a form
	group=$(nameSelector).filter(function(){return $(this).form().length===0;});}return group.not(this.element);},_toggleClasses:function _toggleClasses(){var checked=this.element[0].checked;this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",checked);if(this.options.icon&&this.type==="checkbox"){this._toggleClass(this.icon,null,"ui-icon-check ui-state-checked",checked)._toggleClass(this.icon,null,"ui-icon-blank",!checked);}if(this.type==="radio"){this._getRadioGroup().each(function(){var instance=$(this).checkboxradio("instance");if(instance){instance._removeClass(instance.label,"ui-checkboxradio-checked","ui-state-active");}});}},_destroy:function _destroy(){this._unbindFormResetHandler();if(this.icon){this.icon.remove();this.iconSpace.remove();}},_setOption:function _setOption(key,value){// We don't allow the value to be set to nothing
	if(key==="label"&&!value){return;}this._super(key,value);if(key==="disabled"){this._toggleClass(this.label,null,"ui-state-disabled",value);this.element[0].disabled=value;// Don't refresh when setting disabled
	return;}this.refresh();},_updateIcon:function _updateIcon(checked){var toAdd="ui-icon ui-icon-background ";if(this.options.icon){if(!this.icon){this.icon=$("<span>");this.iconSpace=$("<span> </span>");this._addClass(this.iconSpace,"ui-checkboxradio-icon-space");}if(this.type==="checkbox"){toAdd+=checked?"ui-icon-check ui-state-checked":"ui-icon-blank";this._removeClass(this.icon,null,checked?"ui-icon-blank":"ui-icon-check");}else{toAdd+="ui-icon-blank";}this._addClass(this.icon,"ui-checkboxradio-icon",toAdd);if(!checked){this._removeClass(this.icon,null,"ui-icon-check ui-state-checked");}this.icon.prependTo(this.label).after(this.iconSpace);}else if(this.icon!==undefined){this.icon.remove();this.iconSpace.remove();delete this.icon;}},_updateLabel:function _updateLabel(){// Remove the contents of the label ( minus the icon, icon space, and input )
	var contents=this.label.contents().not(this.element[0]);if(this.icon){contents=contents.not(this.icon[0]);}if(this.iconSpace){contents=contents.not(this.iconSpace[0]);}contents.remove();this.label.append(this.options.label);},refresh:function refresh(){var checked=this.element[0].checked,isDisabled=this.element[0].disabled;this._updateIcon(checked);this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",checked);if(this.options.label!==null){this._updateLabel();}if(isDisabled!==this.options.disabled){this._setOptions({"disabled":isDisabled});}}}]);var widgetsCheckboxradio=$.ui.checkboxradio;/*!
	 * jQuery UI Button 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Button
	//>>group: Widgets
	//>>description: Enhances a form with themeable buttons.
	//>>docs: http://api.jqueryui.com/button/
	//>>demos: http://jqueryui.com/button/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/button.css
	//>>css.theme: ../../themes/base/theme.css
	$.widget("ui.button",{version:"1.12.1",defaultElement:"<button>",options:{classes:{"ui-button":"ui-corner-all"},disabled:null,icon:null,iconPosition:"beginning",label:null,showLabel:true},_getCreateOptions:function _getCreateOptions(){var disabled,// This is to support cases like in jQuery Mobile where the base widget does have
	// an implementation of _getCreateOptions
	options=this._super()||{};this.isInput=this.element.is("input");disabled=this.element[0].disabled;if(disabled!=null){options.disabled=disabled;}this.originalLabel=this.isInput?this.element.val():this.element.html();if(this.originalLabel){options.label=this.originalLabel;}return options;},_create:function _create(){if(!this.option.showLabel&!this.options.icon){this.options.showLabel=true;}// We have to check the option again here even though we did in _getCreateOptions,
	// because null may have been passed on init which would override what was set in
	// _getCreateOptions
	if(this.options.disabled==null){this.options.disabled=this.element[0].disabled||false;}this.hasTitle=!!this.element.attr("title");// Check to see if the label needs to be set or if its already correct
	if(this.options.label&&this.options.label!==this.originalLabel){if(this.isInput){this.element.val(this.options.label);}else{this.element.html(this.options.label);}}this._addClass("ui-button","ui-widget");this._setOption("disabled",this.options.disabled);this._enhance();if(this.element.is("a")){this._on({"keyup":function keyup(event){if(event.keyCode===$.ui.keyCode.SPACE){event.preventDefault();// Support: PhantomJS <= 1.9, IE 8 Only
	// If a native click is available use it so we actually cause navigation
	// otherwise just trigger a click event
	if(this.element[0].click){this.element[0].click();}else{this.element.trigger("click");}}}});}},_enhance:function _enhance(){if(!this.element.is("button")){this.element.attr("role","button");}if(this.options.icon){this._updateIcon("icon",this.options.icon);this._updateTooltip();}},_updateTooltip:function _updateTooltip(){this.title=this.element.attr("title");if(!this.options.showLabel&&!this.title){this.element.attr("title",this.options.label);}},_updateIcon:function _updateIcon(option,value){var icon=option!=="iconPosition",position=icon?this.options.iconPosition:value,displayBlock=position==="top"||position==="bottom";// Create icon
	if(!this.icon){this.icon=$("<span>");this._addClass(this.icon,"ui-button-icon","ui-icon");if(!this.options.showLabel){this._addClass("ui-button-icon-only");}}else if(icon){// If we are updating the icon remove the old icon class
	this._removeClass(this.icon,null,this.options.icon);}// If we are updating the icon add the new icon class
	if(icon){this._addClass(this.icon,null,value);}this._attachIcon(position);// If the icon is on top or bottom we need to add the ui-widget-icon-block class and remove
	// the iconSpace if there is one.
	if(displayBlock){this._addClass(this.icon,null,"ui-widget-icon-block");if(this.iconSpace){this.iconSpace.remove();}}else{// Position is beginning or end so remove the ui-widget-icon-block class and add the
	// space if it does not exist
	if(!this.iconSpace){this.iconSpace=$("<span> </span>");this._addClass(this.iconSpace,"ui-button-icon-space");}this._removeClass(this.icon,null,"ui-wiget-icon-block");this._attachIconSpace(position);}},_destroy:function _destroy(){this.element.removeAttr("role");if(this.icon){this.icon.remove();}if(this.iconSpace){this.iconSpace.remove();}if(!this.hasTitle){this.element.removeAttr("title");}},_attachIconSpace:function _attachIconSpace(iconPosition){this.icon[/^(?:end|bottom)/.test(iconPosition)?"before":"after"](this.iconSpace);},_attachIcon:function _attachIcon(iconPosition){this.element[/^(?:end|bottom)/.test(iconPosition)?"append":"prepend"](this.icon);},_setOptions:function _setOptions(options){var newShowLabel=options.showLabel===undefined?this.options.showLabel:options.showLabel,newIcon=options.icon===undefined?this.options.icon:options.icon;if(!newShowLabel&&!newIcon){options.showLabel=true;}this._super(options);},_setOption:function _setOption(key,value){if(key==="icon"){if(value){this._updateIcon(key,value);}else if(this.icon){this.icon.remove();if(this.iconSpace){this.iconSpace.remove();}}}if(key==="iconPosition"){this._updateIcon(key,value);}// Make sure we can't end up with a button that has neither text nor icon
	if(key==="showLabel"){this._toggleClass("ui-button-icon-only",null,!value);this._updateTooltip();}if(key==="label"){if(this.isInput){this.element.val(value);}else{// If there is an icon, append it, else nothing then append the value
	// this avoids removal of the icon when setting label text
	this.element.html(value);if(this.icon){this._attachIcon(this.options.iconPosition);this._attachIconSpace(this.options.iconPosition);}}}this._super(key,value);if(key==="disabled"){this._toggleClass(null,"ui-state-disabled",value);this.element[0].disabled=value;if(value){this.element.blur();}}},refresh:function refresh(){// Make sure to only check disabled if its an element that supports this otherwise
	// check for the disabled class to determine state
	var isDisabled=this.element.is("input, button")?this.element[0].disabled:this.element.hasClass("ui-button-disabled");if(isDisabled!==this.options.disabled){this._setOptions({disabled:isDisabled});}this._updateTooltip();}});// DEPRECATED
	if($.uiBackCompat!==false){// Text and Icons options
	$.widget("ui.button",$.ui.button,{options:{text:true,icons:{primary:null,secondary:null}},_create:function _create(){if(this.options.showLabel&&!this.options.text){this.options.showLabel=this.options.text;}if(!this.options.showLabel&&this.options.text){this.options.text=this.options.showLabel;}if(!this.options.icon&&(this.options.icons.primary||this.options.icons.secondary)){if(this.options.icons.primary){this.options.icon=this.options.icons.primary;}else{this.options.icon=this.options.icons.secondary;this.options.iconPosition="end";}}else if(this.options.icon){this.options.icons.primary=this.options.icon;}this._super();},_setOption:function _setOption(key,value){if(key==="text"){this._super("showLabel",value);return;}if(key==="showLabel"){this.options.text=value;}if(key==="icon"){this.options.icons.primary=value;}if(key==="icons"){if(value.primary){this._super("icon",value.primary);this._super("iconPosition","beginning");}else if(value.secondary){this._super("icon",value.secondary);this._super("iconPosition","end");}}this._superApply(arguments);}});$.fn.button=function(orig){return function(){if(!this.length||this.length&&this[0].tagName!=="INPUT"||this.length&&this[0].tagName==="INPUT"&&this.attr("type")!=="checkbox"&&this.attr("type")!=="radio"){return orig.apply(this,arguments);}if(!$.ui.checkboxradio){$.error("Checkboxradio widget missing");}if(arguments.length===0){return this.checkboxradio({"icon":false});}return this.checkboxradio.apply(this,arguments);};}($.fn.button);$.fn.buttonset=function(){if(!$.ui.controlgroup){$.error("Controlgroup widget missing");}if(arguments[0]==="option"&&arguments[1]==="items"&&arguments[2]){return this.controlgroup.apply(this,[arguments[0],"items.button",arguments[2]]);}if(arguments[0]==="option"&&arguments[1]==="items"){return this.controlgroup.apply(this,[arguments[0],"items.button"]);}if(_typeof(arguments[0])==="object"&&arguments[0].items){arguments[0].items={button:arguments[0].items};}return this.controlgroup.apply(this,arguments);};}var widgetsButton=$.ui.button;// jscs:disable maximumLineLength
	/* jscs:disable requireCamelCaseOrUpperCaseIdentifiers *//*!
	 * jQuery UI Datepicker 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Datepicker
	//>>group: Widgets
	//>>description: Displays a calendar from an input or inline for selecting dates.
	//>>docs: http://api.jqueryui.com/datepicker/
	//>>demos: http://jqueryui.com/datepicker/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/datepicker.css
	//>>css.theme: ../../themes/base/theme.css
	$.extend($.ui,{datepicker:{version:"1.12.1"}});var datepicker_instActive;function datepicker_getZindex(elem){var position,value;while(elem.length&&elem[0]!==document){// Ignore z-index if position is set to a value where z-index is ignored by the browser
	// This makes behavior of this function consistent across browsers
	// WebKit always returns auto if the element is positioned
	position=elem.css("position");if(position==="absolute"||position==="relative"||position==="fixed"){// IE returns 0 when zIndex is not specified
	// other browsers return a string
	// we ignore the case of nested elements with an explicit value of 0
	// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
	value=parseInt(elem.css("zIndex"),10);if(!isNaN(value)&&value!==0){return value;}}elem=elem.parent();}return 0;}/* Date picker manager.
	   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
	   Settings for (groups of) date pickers are maintained in an instance object,
	   allowing multiple different settings on the same page. */function Datepicker(){this._curInst=null;// The current instance in use
	this._keyEvent=false;// If the last event was a key event
	this._disabledInputs=[];// List of date picker inputs that have been disabled
	this._datepickerShowing=false;// True if the popup picker is showing , false if not
	this._inDialog=false;// True if showing within a "dialog", false if not
	this._mainDivId="ui-datepicker-div";// The ID of the main datepicker division
	this._inlineClass="ui-datepicker-inline";// The name of the inline marker class
	this._appendClass="ui-datepicker-append";// The name of the append marker class
	this._triggerClass="ui-datepicker-trigger";// The name of the trigger marker class
	this._dialogClass="ui-datepicker-dialog";// The name of the dialog marker class
	this._disableClass="ui-datepicker-disabled";// The name of the disabled covering marker class
	this._unselectableClass="ui-datepicker-unselectable";// The name of the unselectable cell marker class
	this._currentClass="ui-datepicker-current-day";// The name of the current day marker class
	this._dayOverClass="ui-datepicker-days-cell-over";// The name of the day hover marker class
	this.regional=[];// Available regional settings, indexed by language code
	this.regional[""]={// Default regional settings
	closeText:"Done",// Display text for close link
	prevText:"Prev",// Display text for previous month link
	nextText:"Next",// Display text for next month link
	currentText:"Today",// Display text for current month link
	monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],// Names of months for drop-down and formatting
	monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],// For formatting
	dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],// For formatting
	dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],// For formatting
	dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],// Column headings for days starting at Sunday
	weekHeader:"Wk",// Column header for week of the year
	dateFormat:"mm/dd/yy",// See format options on parseDate
	firstDay:0,// The first day of the week, Sun = 0, Mon = 1, ...
	isRTL:false,// True if right-to-left language, false if left-to-right
	showMonthAfterYear:false,// True if the year select precedes month, false for month then year
	yearSuffix:""// Additional text to append to the year in the month headers
	};this._defaults={// Global defaults for all the date picker instances
	showOn:"focus",// "focus" for popup on focus,
	// "button" for trigger button, or "both" for either
	showAnim:"fadeIn",// Name of jQuery animation for popup
	showOptions:{},// Options for enhanced animations
	defaultDate:null,// Used when field is blank: actual date,
	// +/-number for offset from today, null for today
	appendText:"",// Display text following the input box, e.g. showing the format
	buttonText:"...",// Text for trigger button
	buttonImage:"",// URL for trigger button image
	buttonImageOnly:false,// True if the image appears alone, false if it appears on a button
	hideIfNoPrevNext:false,// True to hide next/previous month links
	// if not applicable, false to just disable them
	navigationAsDateFormat:false,// True if date formatting applied to prev/today/next links
	gotoCurrent:false,// True if today link goes back to current selection instead
	changeMonth:false,// True if month can be selected directly, false if only prev/next
	changeYear:false,// True if year can be selected directly, false if only prev/next
	yearRange:"c-10:c+10",// Range of years to display in drop-down,
	// either relative to today's year (-nn:+nn), relative to currently displayed year
	// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
	showOtherMonths:false,// True to show dates in other months, false to leave blank
	selectOtherMonths:false,// True to allow selection of dates in other months, false for unselectable
	showWeek:false,// True to show week of the year, false to not show it
	calculateWeek:this.iso8601Week,// How to calculate the week of the year,
	// takes a Date and returns the number of the week for it
	shortYearCutoff:"+10",// Short year values < this are in the current century,
	// > this are in the previous century,
	// string value starting with "+" for current year + value
	minDate:null,// The earliest selectable date, or null for no limit
	maxDate:null,// The latest selectable date, or null for no limit
	duration:"fast",// Duration of display/closure
	beforeShowDay:null,// Function that takes a date and returns an array with
	// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
	// [2] = cell title (optional), e.g. $.datepicker.noWeekends
	beforeShow:null,// Function that takes an input field and
	// returns a set of custom settings for the date picker
	onSelect:null,// Define a callback function when a date is selected
	onChangeMonthYear:null,// Define a callback function when the month or year is changed
	onClose:null,// Define a callback function when the datepicker is closed
	numberOfMonths:1,// Number of months to show at a time
	showCurrentAtPos:0,// The position in multipe months at which to show the current month (starting at 0)
	stepMonths:1,// Number of months to step back/forward
	stepBigMonths:12,// Number of months to step back/forward for the big links
	altField:"",// Selector for an alternate field to store selected dates into
	altFormat:"",// The date format to use for the alternate field
	constrainInput:true,// The input is constrained by the current date format
	showButtonPanel:false,// True to show button panel, false to not show it
	autoSize:false,// True to size the input for the date format, false to leave as is
	disabled:false// The initial disabled state
	};$.extend(this._defaults,this.regional[""]);this.regional.en=$.extend(true,{},this.regional[""]);this.regional["en-US"]=$.extend(true,{},this.regional.en);this.dpDiv=datepicker_bindHover($("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));}$.extend(Datepicker.prototype,{/* Class name added to elements to indicate already configured with a date picker. */markerClassName:"hasDatepicker",//Keep track of the maximum number of rows displayed (see #7043)
	maxRows:4,// TODO rename to "widget" when switching to widget factory
	_widgetDatepicker:function _widgetDatepicker(){return this.dpDiv;},/* Override the default settings for all instances of the date picker.
		 * @param  settings  object - the new settings to use as defaults (anonymous object)
		 * @return the manager object
		 */setDefaults:function setDefaults(settings){datepicker_extendRemove(this._defaults,settings||{});return this;},/* Attach the date picker to a jQuery selection.
		 * @param  target	element - the target input field or division or span
		 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
		 */_attachDatepicker:function _attachDatepicker(target,settings){var nodeName,inline,inst;nodeName=target.nodeName.toLowerCase();inline=nodeName==="div"||nodeName==="span";if(!target.id){this.uuid+=1;target.id="dp"+this.uuid;}inst=this._newInst($(target),inline);inst.settings=$.extend({},settings||{});if(nodeName==="input"){this._connectDatepicker(target,inst);}else if(inline){this._inlineDatepicker(target,inst);}},/* Create a new instance object. */_newInst:function _newInst(target,inline){var id=target[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1");// escape jQuery meta chars
	return{id:id,input:target,// associated target
	selectedDay:0,selectedMonth:0,selectedYear:0,// current selection
	drawMonth:0,drawYear:0,// month being drawn
	inline:inline,// is datepicker inline or not
	dpDiv:!inline?this.dpDiv:// presentation div
	datepicker_bindHover($("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))};},/* Attach the date picker to an input field. */_connectDatepicker:function _connectDatepicker(target,inst){var input=$(target);inst.append=$([]);inst.trigger=$([]);if(input.hasClass(this.markerClassName)){return;}this._attachments(input,inst);input.addClass(this.markerClassName).on("keydown",this._doKeyDown).on("keypress",this._doKeyPress).on("keyup",this._doKeyUp);this._autoSize(inst);$.data(target,"datepicker",inst);//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
	if(inst.settings.disabled){this._disableDatepicker(target);}},/* Make attachments based on settings. */_attachments:function _attachments(input,inst){var showOn,buttonText,buttonImage,appendText=this._get(inst,"appendText"),isRTL=this._get(inst,"isRTL");if(inst.append){inst.append.remove();}if(appendText){inst.append=$("<span class='"+this._appendClass+"'>"+appendText+"</span>");input[isRTL?"before":"after"](inst.append);}input.off("focus",this._showDatepicker);if(inst.trigger){inst.trigger.remove();}showOn=this._get(inst,"showOn");if(showOn==="focus"||showOn==="both"){// pop-up date picker when in the marked field
	input.on("focus",this._showDatepicker);}if(showOn==="button"||showOn==="both"){// pop-up date picker when button clicked
	buttonText=this._get(inst,"buttonText");buttonImage=this._get(inst,"buttonImage");inst.trigger=$(this._get(inst,"buttonImageOnly")?$("<img/>").addClass(this._triggerClass).attr({src:buttonImage,alt:buttonText,title:buttonText}):$("<button type='button'></button>").addClass(this._triggerClass).html(!buttonImage?buttonText:$("<img/>").attr({src:buttonImage,alt:buttonText,title:buttonText})));input[isRTL?"before":"after"](inst.trigger);inst.trigger.on("click",function(){if($.datepicker._datepickerShowing&&$.datepicker._lastInput===input[0]){$.datepicker._hideDatepicker();}else if($.datepicker._datepickerShowing&&$.datepicker._lastInput!==input[0]){$.datepicker._hideDatepicker();$.datepicker._showDatepicker(input[0]);}else{$.datepicker._showDatepicker(input[0]);}return false;});}},/* Apply the maximum length for the date format. */_autoSize:function _autoSize(inst){if(this._get(inst,"autoSize")&&!inst.inline){var findMax,max,maxI,i,date=new Date(2009,12-1,20),// Ensure double digits
	dateFormat=this._get(inst,"dateFormat");if(dateFormat.match(/[DM]/)){findMax=function findMax(names){max=0;maxI=0;for(i=0;i<names.length;i++){if(names[i].length>max){max=names[i].length;maxI=i;}}return maxI;};date.setMonth(findMax(this._get(inst,dateFormat.match(/MM/)?"monthNames":"monthNamesShort")));date.setDate(findMax(this._get(inst,dateFormat.match(/DD/)?"dayNames":"dayNamesShort"))+20-date.getDay());}inst.input.attr("size",this._formatDate(inst,date).length);}},/* Attach an inline date picker to a div. */_inlineDatepicker:function _inlineDatepicker(target,inst){var divSpan=$(target);if(divSpan.hasClass(this.markerClassName)){return;}divSpan.addClass(this.markerClassName).append(inst.dpDiv);$.data(target,"datepicker",inst);this._setDate(inst,this._getDefaultDate(inst),true);this._updateDatepicker(inst);this._updateAlternate(inst);//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
	if(inst.settings.disabled){this._disableDatepicker(target);}// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
	// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
	inst.dpDiv.css("display","block");},/* Pop-up the date picker in a "dialog" box.
		 * @param  input element - ignored
		 * @param  date	string or Date - the initial date to display
		 * @param  onSelect  function - the function to call when a date is selected
		 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
		 * @param  pos int[2] - coordinates for the dialog's position within the screen or
		 *					event - with x/y coordinates or
		 *					leave empty for default (screen centre)
		 * @return the manager object
		 */_dialogDatepicker:function _dialogDatepicker(input,date,onSelect,settings,pos){var id,browserWidth,browserHeight,scrollX,scrollY,inst=this._dialogInst;// internal instance
	if(!inst){this.uuid+=1;id="dp"+this.uuid;this._dialogInput=$("<input type='text' id='"+id+"' style='position: absolute; top: -100px; width: 0px;'/>");this._dialogInput.on("keydown",this._doKeyDown);$("body").append(this._dialogInput);inst=this._dialogInst=this._newInst(this._dialogInput,false);inst.settings={};$.data(this._dialogInput[0],"datepicker",inst);}datepicker_extendRemove(inst.settings,settings||{});date=date&&date.constructor===Date?this._formatDate(inst,date):date;this._dialogInput.val(date);this._pos=pos?pos.length?pos:[pos.pageX,pos.pageY]:null;if(!this._pos){browserWidth=document.documentElement.clientWidth;browserHeight=document.documentElement.clientHeight;scrollX=document.documentElement.scrollLeft||document.body.scrollLeft;scrollY=document.documentElement.scrollTop||document.body.scrollTop;this._pos=// should use actual width/height below
	[browserWidth/2-100+scrollX,browserHeight/2-150+scrollY];}// Move input on screen for focus, but hidden behind dialog
	this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px");inst.settings.onSelect=onSelect;this._inDialog=true;this.dpDiv.addClass(this._dialogClass);this._showDatepicker(this._dialogInput[0]);if($.blockUI){$.blockUI(this.dpDiv);}$.data(this._dialogInput[0],"datepicker",inst);return this;},/* Detach a datepicker from its control.
		 * @param  target	element - the target input field or division or span
		 */_destroyDatepicker:function _destroyDatepicker(target){var nodeName,$target=$(target),inst=$.data(target,"datepicker");if(!$target.hasClass(this.markerClassName)){return;}nodeName=target.nodeName.toLowerCase();$.removeData(target,"datepicker");if(nodeName==="input"){inst.append.remove();inst.trigger.remove();$target.removeClass(this.markerClassName).off("focus",this._showDatepicker).off("keydown",this._doKeyDown).off("keypress",this._doKeyPress).off("keyup",this._doKeyUp);}else if(nodeName==="div"||nodeName==="span"){$target.removeClass(this.markerClassName).empty();}if(datepicker_instActive===inst){datepicker_instActive=null;}},/* Enable the date picker to a jQuery selection.
		 * @param  target	element - the target input field or division or span
		 */_enableDatepicker:function _enableDatepicker(target){var nodeName,inline,$target=$(target),inst=$.data(target,"datepicker");if(!$target.hasClass(this.markerClassName)){return;}nodeName=target.nodeName.toLowerCase();if(nodeName==="input"){target.disabled=false;inst.trigger.filter("button").each(function(){this.disabled=false;}).end().filter("img").css({opacity:"1.0",cursor:""});}else if(nodeName==="div"||nodeName==="span"){inline=$target.children("."+this._inlineClass);inline.children().removeClass("ui-state-disabled");inline.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",false);}this._disabledInputs=$.map(this._disabledInputs,function(value){return value===target?null:value;});// delete entry
	},/* Disable the date picker to a jQuery selection.
		 * @param  target	element - the target input field or division or span
		 */_disableDatepicker:function _disableDatepicker(target){var nodeName,inline,$target=$(target),inst=$.data(target,"datepicker");if(!$target.hasClass(this.markerClassName)){return;}nodeName=target.nodeName.toLowerCase();if(nodeName==="input"){target.disabled=true;inst.trigger.filter("button").each(function(){this.disabled=true;}).end().filter("img").css({opacity:"0.5",cursor:"default"});}else if(nodeName==="div"||nodeName==="span"){inline=$target.children("."+this._inlineClass);inline.children().addClass("ui-state-disabled");inline.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",true);}this._disabledInputs=$.map(this._disabledInputs,function(value){return value===target?null:value;});// delete entry
	this._disabledInputs[this._disabledInputs.length]=target;},/* Is the first field in a jQuery collection disabled as a datepicker?
		 * @param  target	element - the target input field or division or span
		 * @return boolean - true if disabled, false if enabled
		 */_isDisabledDatepicker:function _isDisabledDatepicker(target){if(!target){return false;}for(var i=0;i<this._disabledInputs.length;i++){if(this._disabledInputs[i]===target){return true;}}return false;},/* Retrieve the instance data for the target control.
		 * @param  target  element - the target input field or division or span
		 * @return  object - the associated instance data
		 * @throws  error if a jQuery problem getting data
		 */_getInst:function _getInst(target){try{return $.data(target,"datepicker");}catch(err){throw"Missing instance data for this datepicker";}},/* Update or retrieve the settings for a date picker attached to an input field or division.
		 * @param  target  element - the target input field or division or span
		 * @param  name	object - the new settings to update or
		 *				string - the name of the setting to change or retrieve,
		 *				when retrieving also "all" for all instance settings or
		 *				"defaults" for all global defaults
		 * @param  value   any - the new value for the setting
		 *				(omit if above is an object or to retrieve a value)
		 */_optionDatepicker:function _optionDatepicker(target,name,value){var settings,date,minDate,maxDate,inst=this._getInst(target);if(arguments.length===2&&typeof name==="string"){return name==="defaults"?$.extend({},$.datepicker._defaults):inst?name==="all"?$.extend({},inst.settings):this._get(inst,name):null;}settings=name||{};if(typeof name==="string"){settings={};settings[name]=value;}if(inst){if(this._curInst===inst){this._hideDatepicker();}date=this._getDateDatepicker(target,true);minDate=this._getMinMaxDate(inst,"min");maxDate=this._getMinMaxDate(inst,"max");datepicker_extendRemove(inst.settings,settings);// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
	if(minDate!==null&&settings.dateFormat!==undefined&&settings.minDate===undefined){inst.settings.minDate=this._formatDate(inst,minDate);}if(maxDate!==null&&settings.dateFormat!==undefined&&settings.maxDate===undefined){inst.settings.maxDate=this._formatDate(inst,maxDate);}if("disabled"in settings){if(settings.disabled){this._disableDatepicker(target);}else{this._enableDatepicker(target);}}this._attachments($(target),inst);this._autoSize(inst);this._setDate(inst,date);this._updateAlternate(inst);this._updateDatepicker(inst);}},// Change method deprecated
	_changeDatepicker:function _changeDatepicker(target,name,value){this._optionDatepicker(target,name,value);},/* Redraw the date picker attached to an input field or division.
		 * @param  target  element - the target input field or division or span
		 */_refreshDatepicker:function _refreshDatepicker(target){var inst=this._getInst(target);if(inst){this._updateDatepicker(inst);}},/* Set the dates for a jQuery selection.
		 * @param  target element - the target input field or division or span
		 * @param  date	Date - the new date
		 */_setDateDatepicker:function _setDateDatepicker(target,date){var inst=this._getInst(target);if(inst){this._setDate(inst,date);this._updateDatepicker(inst);this._updateAlternate(inst);}},/* Get the date(s) for the first entry in a jQuery selection.
		 * @param  target element - the target input field or division or span
		 * @param  noDefault boolean - true if no default date is to be used
		 * @return Date - the current date
		 */_getDateDatepicker:function _getDateDatepicker(target,noDefault){var inst=this._getInst(target);if(inst&&!inst.inline){this._setDateFromField(inst,noDefault);}return inst?this._getDate(inst):null;},/* Handle keystrokes. */_doKeyDown:function _doKeyDown(event){var onSelect,dateStr,sel,inst=$.datepicker._getInst(event.target),handled=true,isRTL=inst.dpDiv.is(".ui-datepicker-rtl");inst._keyEvent=true;if($.datepicker._datepickerShowing){switch(event.keyCode){case 9:$.datepicker._hideDatepicker();handled=false;break;// hide on tab out
	case 13:sel=$("td."+$.datepicker._dayOverClass+":not(."+$.datepicker._currentClass+")",inst.dpDiv);if(sel[0]){$.datepicker._selectDay(event.target,inst.selectedMonth,inst.selectedYear,sel[0]);}onSelect=$.datepicker._get(inst,"onSelect");if(onSelect){dateStr=$.datepicker._formatDate(inst);// Trigger custom callback
	onSelect.apply(inst.input?inst.input[0]:null,[dateStr,inst]);}else{$.datepicker._hideDatepicker();}return false;// don't submit the form
	case 27:$.datepicker._hideDatepicker();break;// hide on escape
	case 33:$.datepicker._adjustDate(event.target,event.ctrlKey?-$.datepicker._get(inst,"stepBigMonths"):-$.datepicker._get(inst,"stepMonths"),"M");break;// previous month/year on page up/+ ctrl
	case 34:$.datepicker._adjustDate(event.target,event.ctrlKey?+$.datepicker._get(inst,"stepBigMonths"):+$.datepicker._get(inst,"stepMonths"),"M");break;// next month/year on page down/+ ctrl
	case 35:if(event.ctrlKey||event.metaKey){$.datepicker._clearDate(event.target);}handled=event.ctrlKey||event.metaKey;break;// clear on ctrl or command +end
	case 36:if(event.ctrlKey||event.metaKey){$.datepicker._gotoToday(event.target);}handled=event.ctrlKey||event.metaKey;break;// current on ctrl or command +home
	case 37:if(event.ctrlKey||event.metaKey){$.datepicker._adjustDate(event.target,isRTL?+1:-1,"D");}handled=event.ctrlKey||event.metaKey;// -1 day on ctrl or command +left
	if(event.originalEvent.altKey){$.datepicker._adjustDate(event.target,event.ctrlKey?-$.datepicker._get(inst,"stepBigMonths"):-$.datepicker._get(inst,"stepMonths"),"M");}// next month/year on alt +left on Mac
	break;case 38:if(event.ctrlKey||event.metaKey){$.datepicker._adjustDate(event.target,-7,"D");}handled=event.ctrlKey||event.metaKey;break;// -1 week on ctrl or command +up
	case 39:if(event.ctrlKey||event.metaKey){$.datepicker._adjustDate(event.target,isRTL?-1:+1,"D");}handled=event.ctrlKey||event.metaKey;// +1 day on ctrl or command +right
	if(event.originalEvent.altKey){$.datepicker._adjustDate(event.target,event.ctrlKey?+$.datepicker._get(inst,"stepBigMonths"):+$.datepicker._get(inst,"stepMonths"),"M");}// next month/year on alt +right
	break;case 40:if(event.ctrlKey||event.metaKey){$.datepicker._adjustDate(event.target,+7,"D");}handled=event.ctrlKey||event.metaKey;break;// +1 week on ctrl or command +down
	default:handled=false;}}else if(event.keyCode===36&&event.ctrlKey){// display the date picker on ctrl+home
	$.datepicker._showDatepicker(this);}else{handled=false;}if(handled){event.preventDefault();event.stopPropagation();}},/* Filter entered characters - based on date format. */_doKeyPress:function _doKeyPress(event){var chars,chr,inst=$.datepicker._getInst(event.target);if($.datepicker._get(inst,"constrainInput")){chars=$.datepicker._possibleChars($.datepicker._get(inst,"dateFormat"));chr=String.fromCharCode(event.charCode==null?event.keyCode:event.charCode);return event.ctrlKey||event.metaKey||chr<" "||!chars||chars.indexOf(chr)>-1;}},/* Synchronise manual entry and field/alternate field. */_doKeyUp:function _doKeyUp(event){var date,inst=$.datepicker._getInst(event.target);if(inst.input.val()!==inst.lastVal){try{date=$.datepicker.parseDate($.datepicker._get(inst,"dateFormat"),inst.input?inst.input.val():null,$.datepicker._getFormatConfig(inst));if(date){// only if valid
	$.datepicker._setDateFromField(inst);$.datepicker._updateAlternate(inst);$.datepicker._updateDatepicker(inst);}}catch(err){}}return true;},/* Pop-up the date picker for a given input field.
		 * If false returned from beforeShow event handler do not show.
		 * @param  input  element - the input field attached to the date picker or
		 *					event - if triggered by focus
		 */_showDatepicker:function _showDatepicker(input){input=input.target||input;if(input.nodeName.toLowerCase()!=="input"){// find from button/image trigger
	input=$("input",input.parentNode)[0];}if($.datepicker._isDisabledDatepicker(input)||$.datepicker._lastInput===input){// already here
	return;}var inst,beforeShow,beforeShowSettings,isFixed,offset,showAnim,duration;inst=$.datepicker._getInst(input);if($.datepicker._curInst&&$.datepicker._curInst!==inst){$.datepicker._curInst.dpDiv.stop(true,true);if(inst&&$.datepicker._datepickerShowing){$.datepicker._hideDatepicker($.datepicker._curInst.input[0]);}}beforeShow=$.datepicker._get(inst,"beforeShow");beforeShowSettings=beforeShow?beforeShow.apply(input,[input,inst]):{};if(beforeShowSettings===false){return;}datepicker_extendRemove(inst.settings,beforeShowSettings);inst.lastVal=null;$.datepicker._lastInput=input;$.datepicker._setDateFromField(inst);if($.datepicker._inDialog){// hide cursor
	input.value="";}if(!$.datepicker._pos){// position below input
	$.datepicker._pos=$.datepicker._findPos(input);$.datepicker._pos[1]+=input.offsetHeight;// add the height
	}isFixed=false;$(input).parents().each(function(){isFixed|=$(this).css("position")==="fixed";return!isFixed;});offset={left:$.datepicker._pos[0],top:$.datepicker._pos[1]};$.datepicker._pos=null;//to avoid flashes on Firefox
	inst.dpDiv.empty();// determine sizing offscreen
	inst.dpDiv.css({position:"absolute",display:"block",top:"-1000px"});$.datepicker._updateDatepicker(inst);// fix width for dynamic number of date pickers
	// and adjust position before showing
	offset=$.datepicker._checkOffset(inst,offset,isFixed);inst.dpDiv.css({position:$.datepicker._inDialog&&$.blockUI?"static":isFixed?"fixed":"absolute",display:"none",left:offset.left+"px",top:offset.top+"px"});if(!inst.inline){showAnim=$.datepicker._get(inst,"showAnim");duration=$.datepicker._get(inst,"duration");inst.dpDiv.css("z-index",datepicker_getZindex($(input))+1);$.datepicker._datepickerShowing=true;if($.effects&&$.effects.effect[showAnim]){inst.dpDiv.show(showAnim,$.datepicker._get(inst,"showOptions"),duration);}else{inst.dpDiv[showAnim||"show"](showAnim?duration:null);}if($.datepicker._shouldFocusInput(inst)){inst.input.trigger("focus");}$.datepicker._curInst=inst;}},/* Generate the date picker content. */_updateDatepicker:function _updateDatepicker(inst){this.maxRows=4;//Reset the max number of rows being displayed (see #7043)
	datepicker_instActive=inst;// for delegate hover events
	inst.dpDiv.empty().append(this._generateHTML(inst));this._attachHandlers(inst);var origyearshtml,numMonths=this._getNumberOfMonths(inst),cols=numMonths[1],width=17,activeCell=inst.dpDiv.find("."+this._dayOverClass+" a");if(activeCell.length>0){datepicker_handleMouseover.apply(activeCell.get(0));}inst.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width("");if(cols>1){inst.dpDiv.addClass("ui-datepicker-multi-"+cols).css("width",width*cols+"em");}inst.dpDiv[(numMonths[0]!==1||numMonths[1]!==1?"add":"remove")+"Class"]("ui-datepicker-multi");inst.dpDiv[(this._get(inst,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl");if(inst===$.datepicker._curInst&&$.datepicker._datepickerShowing&&$.datepicker._shouldFocusInput(inst)){inst.input.trigger("focus");}// Deffered render of the years select (to avoid flashes on Firefox)
	if(inst.yearshtml){origyearshtml=inst.yearshtml;setTimeout(function(){//assure that inst.yearshtml didn't change.
	if(origyearshtml===inst.yearshtml&&inst.yearshtml){inst.dpDiv.find("select.ui-datepicker-year:first").replaceWith(inst.yearshtml);}origyearshtml=inst.yearshtml=null;},0);}},// #6694 - don't focus the input if it's already focused
	// this breaks the change event in IE
	// Support: IE and jQuery <1.9
	_shouldFocusInput:function _shouldFocusInput(inst){return inst.input&&inst.input.is(":visible")&&!inst.input.is(":disabled")&&!inst.input.is(":focus");},/* Check positioning to remain on screen. */_checkOffset:function _checkOffset(inst,offset,isFixed){var dpWidth=inst.dpDiv.outerWidth(),dpHeight=inst.dpDiv.outerHeight(),inputWidth=inst.input?inst.input.outerWidth():0,inputHeight=inst.input?inst.input.outerHeight():0,viewWidth=document.documentElement.clientWidth+(isFixed?0:$(document).scrollLeft()),viewHeight=document.documentElement.clientHeight+(isFixed?0:$(document).scrollTop());offset.left-=this._get(inst,"isRTL")?dpWidth-inputWidth:0;offset.left-=isFixed&&offset.left===inst.input.offset().left?$(document).scrollLeft():0;offset.top-=isFixed&&offset.top===inst.input.offset().top+inputHeight?$(document).scrollTop():0;// Now check if datepicker is showing outside window viewport - move to a better place if so.
	offset.left-=Math.min(offset.left,offset.left+dpWidth>viewWidth&&viewWidth>dpWidth?Math.abs(offset.left+dpWidth-viewWidth):0);offset.top-=Math.min(offset.top,offset.top+dpHeight>viewHeight&&viewHeight>dpHeight?Math.abs(dpHeight+inputHeight):0);return offset;},/* Find an object's position on the screen. */_findPos:function _findPos(obj){var position,inst=this._getInst(obj),isRTL=this._get(inst,"isRTL");while(obj&&(obj.type==="hidden"||obj.nodeType!==1||$.expr.filters.hidden(obj))){obj=obj[isRTL?"previousSibling":"nextSibling"];}position=$(obj).offset();return[position.left,position.top];},/* Hide the date picker from view.
		 * @param  input  element - the input field attached to the date picker
		 */_hideDatepicker:function _hideDatepicker(input){var showAnim,duration,postProcess,onClose,inst=this._curInst;if(!inst||input&&inst!==$.data(input,"datepicker")){return;}if(this._datepickerShowing){showAnim=this._get(inst,"showAnim");duration=this._get(inst,"duration");postProcess=function postProcess(){$.datepicker._tidyDialog(inst);};// DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
	if($.effects&&($.effects.effect[showAnim]||$.effects[showAnim])){inst.dpDiv.hide(showAnim,$.datepicker._get(inst,"showOptions"),duration,postProcess);}else{inst.dpDiv[showAnim==="slideDown"?"slideUp":showAnim==="fadeIn"?"fadeOut":"hide"](showAnim?duration:null,postProcess);}if(!showAnim){postProcess();}this._datepickerShowing=false;onClose=this._get(inst,"onClose");if(onClose){onClose.apply(inst.input?inst.input[0]:null,[inst.input?inst.input.val():"",inst]);}this._lastInput=null;if(this._inDialog){this._dialogInput.css({position:"absolute",left:"0",top:"-100px"});if($.blockUI){$.unblockUI();$("body").append(this.dpDiv);}}this._inDialog=false;}},/* Tidy up after a dialog display. */_tidyDialog:function _tidyDialog(inst){inst.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar");},/* Close date picker if clicked elsewhere. */_checkExternalClick:function _checkExternalClick(event){if(!$.datepicker._curInst){return;}var $target=$(event.target),inst=$.datepicker._getInst($target[0]);if($target[0].id!==$.datepicker._mainDivId&&$target.parents("#"+$.datepicker._mainDivId).length===0&&!$target.hasClass($.datepicker.markerClassName)&&!$target.closest("."+$.datepicker._triggerClass).length&&$.datepicker._datepickerShowing&&!($.datepicker._inDialog&&$.blockUI)||$target.hasClass($.datepicker.markerClassName)&&$.datepicker._curInst!==inst){$.datepicker._hideDatepicker();}},/* Adjust one of the date sub-fields. */_adjustDate:function _adjustDate(id,offset,period){var target=$(id),inst=this._getInst(target[0]);if(this._isDisabledDatepicker(target[0])){return;}this._adjustInstDate(inst,offset+(period==="M"?this._get(inst,"showCurrentAtPos"):0),// undo positioning
	period);this._updateDatepicker(inst);},/* Action for current link. */_gotoToday:function _gotoToday(id){var date,target=$(id),inst=this._getInst(target[0]);if(this._get(inst,"gotoCurrent")&&inst.currentDay){inst.selectedDay=inst.currentDay;inst.drawMonth=inst.selectedMonth=inst.currentMonth;inst.drawYear=inst.selectedYear=inst.currentYear;}else{date=new Date();inst.selectedDay=date.getDate();inst.drawMonth=inst.selectedMonth=date.getMonth();inst.drawYear=inst.selectedYear=date.getFullYear();}this._notifyChange(inst);this._adjustDate(target);},/* Action for selecting a new month/year. */_selectMonthYear:function _selectMonthYear(id,select,period){var target=$(id),inst=this._getInst(target[0]);inst["selected"+(period==="M"?"Month":"Year")]=inst["draw"+(period==="M"?"Month":"Year")]=parseInt(select.options[select.selectedIndex].value,10);this._notifyChange(inst);this._adjustDate(target);},/* Action for selecting a day. */_selectDay:function _selectDay(id,month,year,td){var inst,target=$(id);if($(td).hasClass(this._unselectableClass)||this._isDisabledDatepicker(target[0])){return;}inst=this._getInst(target[0]);inst.selectedDay=inst.currentDay=$("a",td).html();inst.selectedMonth=inst.currentMonth=month;inst.selectedYear=inst.currentYear=year;this._selectDate(id,this._formatDate(inst,inst.currentDay,inst.currentMonth,inst.currentYear));},/* Erase the input field and hide the date picker. */_clearDate:function _clearDate(id){var target=$(id);this._selectDate(target,"");},/* Update the input field with the selected date. */_selectDate:function _selectDate(id,dateStr){var onSelect,target=$(id),inst=this._getInst(target[0]);dateStr=dateStr!=null?dateStr:this._formatDate(inst);if(inst.input){inst.input.val(dateStr);}this._updateAlternate(inst);onSelect=this._get(inst,"onSelect");if(onSelect){onSelect.apply(inst.input?inst.input[0]:null,[dateStr,inst]);// trigger custom callback
	}else if(inst.input){inst.input.trigger("change");// fire the change event
	}if(inst.inline){this._updateDatepicker(inst);}else{this._hideDatepicker();this._lastInput=inst.input[0];if(_typeof(inst.input[0])!=="object"){inst.input.trigger("focus");// restore focus
	}this._lastInput=null;}},/* Update any alternate field to synchronise with the main field. */_updateAlternate:function _updateAlternate(inst){var altFormat,date,dateStr,altField=this._get(inst,"altField");if(altField){// update alternate field too
	altFormat=this._get(inst,"altFormat")||this._get(inst,"dateFormat");date=this._getDate(inst);dateStr=this.formatDate(altFormat,date,this._getFormatConfig(inst));$(altField).val(dateStr);}},/* Set as beforeShowDay function to prevent selection of weekends.
		 * @param  date  Date - the date to customise
		 * @return [boolean, string] - is this date selectable?, what is its CSS class?
		 */noWeekends:function noWeekends(date){var day=date.getDay();return[day>0&&day<6,""];},/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
		 * @param  date  Date - the date to get the week for
		 * @return  number - the number of the week within the year that contains this date
		 */iso8601Week:function iso8601Week(date){var time,checkDate=new Date(date.getTime());// Find Thursday of this week starting on Monday
	checkDate.setDate(checkDate.getDate()+4-(checkDate.getDay()||7));time=checkDate.getTime();checkDate.setMonth(0);// Compare with Jan 1
	checkDate.setDate(1);return Math.floor(Math.round((time-checkDate)/86400000)/7)+1;},/* Parse a string value into a date object.
		 * See formatDate below for the possible formats.
		 *
		 * @param  format string - the expected format of the date
		 * @param  value string - the date in the above format
		 * @param  settings Object - attributes include:
		 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
		 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
		 *					dayNames		string[7] - names of the days from Sunday (optional)
		 *					monthNamesShort string[12] - abbreviated names of the months (optional)
		 *					monthNames		string[12] - names of the months (optional)
		 * @return  Date - the extracted date value or null if value is blank
		 */parseDate:function parseDate(format,value,settings){if(format==null||value==null){throw"Invalid arguments";}value=(typeof value==="undefined"?"undefined":_typeof(value))==="object"?value.toString():value+"";if(value===""){return null;}var iFormat,dim,extra,iValue=0,shortYearCutoffTemp=(settings?settings.shortYearCutoff:null)||this._defaults.shortYearCutoff,shortYearCutoff=typeof shortYearCutoffTemp!=="string"?shortYearCutoffTemp:new Date().getFullYear()%100+parseInt(shortYearCutoffTemp,10),dayNamesShort=(settings?settings.dayNamesShort:null)||this._defaults.dayNamesShort,dayNames=(settings?settings.dayNames:null)||this._defaults.dayNames,monthNamesShort=(settings?settings.monthNamesShort:null)||this._defaults.monthNamesShort,monthNames=(settings?settings.monthNames:null)||this._defaults.monthNames,year=-1,month=-1,day=-1,doy=-1,literal=false,date,// Check whether a format character is doubled
	lookAhead=function lookAhead(match){var matches=iFormat+1<format.length&&format.charAt(iFormat+1)===match;if(matches){iFormat++;}return matches;},// Extract a number from the string value
	getNumber=function getNumber(match){var isDoubled=lookAhead(match),size=match==="@"?14:match==="!"?20:match==="y"&&isDoubled?4:match==="o"?3:2,minSize=match==="y"?size:1,digits=new RegExp("^\\d{"+minSize+","+size+"}"),num=value.substring(iValue).match(digits);if(!num){throw"Missing number at position "+iValue;}iValue+=num[0].length;return parseInt(num[0],10);},// Extract a name from the string value and convert to an index
	getName=function getName(match,shortNames,longNames){var index=-1,names=$.map(lookAhead(match)?longNames:shortNames,function(v,k){return[[k,v]];}).sort(function(a,b){return-(a[1].length-b[1].length);});$.each(names,function(i,pair){var name=pair[1];if(value.substr(iValue,name.length).toLowerCase()===name.toLowerCase()){index=pair[0];iValue+=name.length;return false;}});if(index!==-1){return index+1;}else{throw"Unknown name at position "+iValue;}},// Confirm that a literal character matches the string value
	checkLiteral=function checkLiteral(){if(value.charAt(iValue)!==format.charAt(iFormat)){throw"Unexpected literal at position "+iValue;}iValue++;};for(iFormat=0;iFormat<format.length;iFormat++){if(literal){if(format.charAt(iFormat)==="'"&&!lookAhead("'")){literal=false;}else{checkLiteral();}}else{switch(format.charAt(iFormat)){case"d":day=getNumber("d");break;case"D":getName("D",dayNamesShort,dayNames);break;case"o":doy=getNumber("o");break;case"m":month=getNumber("m");break;case"M":month=getName("M",monthNamesShort,monthNames);break;case"y":year=getNumber("y");break;case"@":date=new Date(getNumber("@"));year=date.getFullYear();month=date.getMonth()+1;day=date.getDate();break;case"!":date=new Date((getNumber("!")-this._ticksTo1970)/10000);year=date.getFullYear();month=date.getMonth()+1;day=date.getDate();break;case"'":if(lookAhead("'")){checkLiteral();}else{literal=true;}break;default:checkLiteral();}}}if(iValue<value.length){extra=value.substr(iValue);if(!/^\s+/.test(extra)){throw"Extra/unparsed characters found in date: "+extra;}}if(year===-1){year=new Date().getFullYear();}else if(year<100){year+=new Date().getFullYear()-new Date().getFullYear()%100+(year<=shortYearCutoff?0:-100);}if(doy>-1){month=1;day=doy;do{dim=this._getDaysInMonth(year,month-1);if(day<=dim){break;}month++;day-=dim;}while(true);}date=this._daylightSavingAdjust(new Date(year,month-1,day));if(date.getFullYear()!==year||date.getMonth()+1!==month||date.getDate()!==day){throw"Invalid date";// E.g. 31/02/00
	}return date;},/* Standard date formats. */ATOM:"yy-mm-dd",// RFC 3339 (ISO 8601)
	COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",// RFC 822
	TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",// ISO 8601
	_ticksTo1970:((1970-1)*365+Math.floor(1970/4)-Math.floor(1970/100)+Math.floor(1970/400))*24*60*60*10000000,/* Format a date object into a string value.
		 * The format can be combinations of the following:
		 * d  - day of month (no leading zero)
		 * dd - day of month (two digit)
		 * o  - day of year (no leading zeros)
		 * oo - day of year (three digit)
		 * D  - day name short
		 * DD - day name long
		 * m  - month of year (no leading zero)
		 * mm - month of year (two digit)
		 * M  - month name short
		 * MM - month name long
		 * y  - year (two digit)
		 * yy - year (four digit)
		 * @ - Unix timestamp (ms since 01/01/1970)
		 * ! - Windows ticks (100ns since 01/01/0001)
		 * "..." - literal text
		 * '' - single quote
		 *
		 * @param  format string - the desired format of the date
		 * @param  date Date - the date value to format
		 * @param  settings Object - attributes include:
		 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
		 *					dayNames		string[7] - names of the days from Sunday (optional)
		 *					monthNamesShort string[12] - abbreviated names of the months (optional)
		 *					monthNames		string[12] - names of the months (optional)
		 * @return  string - the date in the above format
		 */formatDate:function formatDate(format,date,settings){if(!date){return"";}var iFormat,dayNamesShort=(settings?settings.dayNamesShort:null)||this._defaults.dayNamesShort,dayNames=(settings?settings.dayNames:null)||this._defaults.dayNames,monthNamesShort=(settings?settings.monthNamesShort:null)||this._defaults.monthNamesShort,monthNames=(settings?settings.monthNames:null)||this._defaults.monthNames,// Check whether a format character is doubled
	lookAhead=function lookAhead(match){var matches=iFormat+1<format.length&&format.charAt(iFormat+1)===match;if(matches){iFormat++;}return matches;},// Format a number, with leading zero if necessary
	formatNumber=function formatNumber(match,value,len){var num=""+value;if(lookAhead(match)){while(num.length<len){num="0"+num;}}return num;},// Format a name, short or long as requested
	formatName=function formatName(match,value,shortNames,longNames){return lookAhead(match)?longNames[value]:shortNames[value];},output="",literal=false;if(date){for(iFormat=0;iFormat<format.length;iFormat++){if(literal){if(format.charAt(iFormat)==="'"&&!lookAhead("'")){literal=false;}else{output+=format.charAt(iFormat);}}else{switch(format.charAt(iFormat)){case"d":output+=formatNumber("d",date.getDate(),2);break;case"D":output+=formatName("D",date.getDay(),dayNamesShort,dayNames);break;case"o":output+=formatNumber("o",Math.round((new Date(date.getFullYear(),date.getMonth(),date.getDate()).getTime()-new Date(date.getFullYear(),0,0).getTime())/86400000),3);break;case"m":output+=formatNumber("m",date.getMonth()+1,2);break;case"M":output+=formatName("M",date.getMonth(),monthNamesShort,monthNames);break;case"y":output+=lookAhead("y")?date.getFullYear():(date.getFullYear()%100<10?"0":"")+date.getFullYear()%100;break;case"@":output+=date.getTime();break;case"!":output+=date.getTime()*10000+this._ticksTo1970;break;case"'":if(lookAhead("'")){output+="'";}else{literal=true;}break;default:output+=format.charAt(iFormat);}}}}return output;},/* Extract all possible characters from the date format. */_possibleChars:function _possibleChars(format){var iFormat,chars="",literal=false,// Check whether a format character is doubled
	lookAhead=function lookAhead(match){var matches=iFormat+1<format.length&&format.charAt(iFormat+1)===match;if(matches){iFormat++;}return matches;};for(iFormat=0;iFormat<format.length;iFormat++){if(literal){if(format.charAt(iFormat)==="'"&&!lookAhead("'")){literal=false;}else{chars+=format.charAt(iFormat);}}else{switch(format.charAt(iFormat)){case"d":case"m":case"y":case"@":chars+="0123456789";break;case"D":case"M":return null;// Accept anything
	case"'":if(lookAhead("'")){chars+="'";}else{literal=true;}break;default:chars+=format.charAt(iFormat);}}}return chars;},/* Get a setting value, defaulting if necessary. */_get:function _get(inst,name){return inst.settings[name]!==undefined?inst.settings[name]:this._defaults[name];},/* Parse existing date and initialise date picker. */_setDateFromField:function _setDateFromField(inst,noDefault){if(inst.input.val()===inst.lastVal){return;}var dateFormat=this._get(inst,"dateFormat"),dates=inst.lastVal=inst.input?inst.input.val():null,defaultDate=this._getDefaultDate(inst),date=defaultDate,settings=this._getFormatConfig(inst);try{date=this.parseDate(dateFormat,dates,settings)||defaultDate;}catch(event){dates=noDefault?"":dates;}inst.selectedDay=date.getDate();inst.drawMonth=inst.selectedMonth=date.getMonth();inst.drawYear=inst.selectedYear=date.getFullYear();inst.currentDay=dates?date.getDate():0;inst.currentMonth=dates?date.getMonth():0;inst.currentYear=dates?date.getFullYear():0;this._adjustInstDate(inst);},/* Retrieve the default date shown on opening. */_getDefaultDate:function _getDefaultDate(inst){return this._restrictMinMax(inst,this._determineDate(inst,this._get(inst,"defaultDate"),new Date()));},/* A date may be specified as an exact value or a relative one. */_determineDate:function _determineDate(inst,date,defaultDate){var offsetNumeric=function offsetNumeric(offset){var date=new Date();date.setDate(date.getDate()+offset);return date;},offsetString=function offsetString(offset){try{return $.datepicker.parseDate($.datepicker._get(inst,"dateFormat"),offset,$.datepicker._getFormatConfig(inst));}catch(e){// Ignore
	}var date=(offset.toLowerCase().match(/^c/)?$.datepicker._getDate(inst):null)||new Date(),year=date.getFullYear(),month=date.getMonth(),day=date.getDate(),pattern=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,matches=pattern.exec(offset);while(matches){switch(matches[2]||"d"){case"d":case"D":day+=parseInt(matches[1],10);break;case"w":case"W":day+=parseInt(matches[1],10)*7;break;case"m":case"M":month+=parseInt(matches[1],10);day=Math.min(day,$.datepicker._getDaysInMonth(year,month));break;case"y":case"Y":year+=parseInt(matches[1],10);day=Math.min(day,$.datepicker._getDaysInMonth(year,month));break;}matches=pattern.exec(offset);}return new Date(year,month,day);},newDate=date==null||date===""?defaultDate:typeof date==="string"?offsetString(date):typeof date==="number"?isNaN(date)?defaultDate:offsetNumeric(date):new Date(date.getTime());newDate=newDate&&newDate.toString()==="Invalid Date"?defaultDate:newDate;if(newDate){newDate.setHours(0);newDate.setMinutes(0);newDate.setSeconds(0);newDate.setMilliseconds(0);}return this._daylightSavingAdjust(newDate);},/* Handle switch to/from daylight saving.
		 * Hours may be non-zero on daylight saving cut-over:
		 * > 12 when midnight changeover, but then cannot generate
		 * midnight datetime, so jump to 1AM, otherwise reset.
		 * @param  date  (Date) the date to check
		 * @return  (Date) the corrected date
		 */_daylightSavingAdjust:function _daylightSavingAdjust(date){if(!date){return null;}date.setHours(date.getHours()>12?date.getHours()+2:0);return date;},/* Set the date(s) directly. */_setDate:function _setDate(inst,date,noChange){var clear=!date,origMonth=inst.selectedMonth,origYear=inst.selectedYear,newDate=this._restrictMinMax(inst,this._determineDate(inst,date,new Date()));inst.selectedDay=inst.currentDay=newDate.getDate();inst.drawMonth=inst.selectedMonth=inst.currentMonth=newDate.getMonth();inst.drawYear=inst.selectedYear=inst.currentYear=newDate.getFullYear();if((origMonth!==inst.selectedMonth||origYear!==inst.selectedYear)&&!noChange){this._notifyChange(inst);}this._adjustInstDate(inst);if(inst.input){inst.input.val(clear?"":this._formatDate(inst));}},/* Retrieve the date(s) directly. */_getDate:function _getDate(inst){var startDate=!inst.currentYear||inst.input&&inst.input.val()===""?null:this._daylightSavingAdjust(new Date(inst.currentYear,inst.currentMonth,inst.currentDay));return startDate;},/* Attach the onxxx handlers.  These are declared statically so
		 * they work with static code transformers like Caja.
		 */_attachHandlers:function _attachHandlers(inst){var stepMonths=this._get(inst,"stepMonths"),id="#"+inst.id.replace(/\\\\/g,"\\");inst.dpDiv.find("[data-handler]").map(function(){var handler={prev:function prev(){$.datepicker._adjustDate(id,-stepMonths,"M");},next:function next(){$.datepicker._adjustDate(id,+stepMonths,"M");},hide:function hide(){$.datepicker._hideDatepicker();},today:function today(){$.datepicker._gotoToday(id);},selectDay:function selectDay(){$.datepicker._selectDay(id,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this);return false;},selectMonth:function selectMonth(){$.datepicker._selectMonthYear(id,this,"M");return false;},selectYear:function selectYear(){$.datepicker._selectMonthYear(id,this,"Y");return false;}};$(this).on(this.getAttribute("data-event"),handler[this.getAttribute("data-handler")]);});},/* Generate the HTML for the current state of the date picker. */_generateHTML:function _generateHTML(inst){var maxDraw,prevText,prev,nextText,next,currentText,gotoDate,controls,buttonPanel,firstDay,showWeek,dayNames,dayNamesMin,monthNames,monthNamesShort,beforeShowDay,showOtherMonths,selectOtherMonths,defaultDate,html,dow,row,group,col,selectedDate,cornerClass,calender,thead,day,daysInMonth,leadDays,curRows,numRows,printDate,dRow,tbody,daySettings,otherMonth,unselectable,tempDate=new Date(),today=this._daylightSavingAdjust(new Date(tempDate.getFullYear(),tempDate.getMonth(),tempDate.getDate())),// clear time
	isRTL=this._get(inst,"isRTL"),showButtonPanel=this._get(inst,"showButtonPanel"),hideIfNoPrevNext=this._get(inst,"hideIfNoPrevNext"),navigationAsDateFormat=this._get(inst,"navigationAsDateFormat"),numMonths=this._getNumberOfMonths(inst),showCurrentAtPos=this._get(inst,"showCurrentAtPos"),stepMonths=this._get(inst,"stepMonths"),isMultiMonth=numMonths[0]!==1||numMonths[1]!==1,currentDate=this._daylightSavingAdjust(!inst.currentDay?new Date(9999,9,9):new Date(inst.currentYear,inst.currentMonth,inst.currentDay)),minDate=this._getMinMaxDate(inst,"min"),maxDate=this._getMinMaxDate(inst,"max"),drawMonth=inst.drawMonth-showCurrentAtPos,drawYear=inst.drawYear;if(drawMonth<0){drawMonth+=12;drawYear--;}if(maxDate){maxDraw=this._daylightSavingAdjust(new Date(maxDate.getFullYear(),maxDate.getMonth()-numMonths[0]*numMonths[1]+1,maxDate.getDate()));maxDraw=minDate&&maxDraw<minDate?minDate:maxDraw;while(this._daylightSavingAdjust(new Date(drawYear,drawMonth,1))>maxDraw){drawMonth--;if(drawMonth<0){drawMonth=11;drawYear--;}}}inst.drawMonth=drawMonth;inst.drawYear=drawYear;prevText=this._get(inst,"prevText");prevText=!navigationAsDateFormat?prevText:this.formatDate(prevText,this._daylightSavingAdjust(new Date(drawYear,drawMonth-stepMonths,1)),this._getFormatConfig(inst));prev=this._canAdjustMonth(inst,-1,drawYear,drawMonth)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'"+" title='"+prevText+"'><span class='ui-icon ui-icon-circle-triangle-"+(isRTL?"e":"w")+"'>"+prevText+"</span></a>":hideIfNoPrevNext?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+prevText+"'><span class='ui-icon ui-icon-circle-triangle-"+(isRTL?"e":"w")+"'>"+prevText+"</span></a>";nextText=this._get(inst,"nextText");nextText=!navigationAsDateFormat?nextText:this.formatDate(nextText,this._daylightSavingAdjust(new Date(drawYear,drawMonth+stepMonths,1)),this._getFormatConfig(inst));next=this._canAdjustMonth(inst,+1,drawYear,drawMonth)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'"+" title='"+nextText+"'><span class='ui-icon ui-icon-circle-triangle-"+(isRTL?"w":"e")+"'>"+nextText+"</span></a>":hideIfNoPrevNext?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+nextText+"'><span class='ui-icon ui-icon-circle-triangle-"+(isRTL?"w":"e")+"'>"+nextText+"</span></a>";currentText=this._get(inst,"currentText");gotoDate=this._get(inst,"gotoCurrent")&&inst.currentDay?currentDate:today;currentText=!navigationAsDateFormat?currentText:this.formatDate(currentText,gotoDate,this._getFormatConfig(inst));controls=!inst.inline?"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(inst,"closeText")+"</button>":"";buttonPanel=showButtonPanel?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(isRTL?controls:"")+(this._isInRange(inst,gotoDate)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'"+">"+currentText+"</button>":"")+(isRTL?"":controls)+"</div>":"";firstDay=parseInt(this._get(inst,"firstDay"),10);firstDay=isNaN(firstDay)?0:firstDay;showWeek=this._get(inst,"showWeek");dayNames=this._get(inst,"dayNames");dayNamesMin=this._get(inst,"dayNamesMin");monthNames=this._get(inst,"monthNames");monthNamesShort=this._get(inst,"monthNamesShort");beforeShowDay=this._get(inst,"beforeShowDay");showOtherMonths=this._get(inst,"showOtherMonths");selectOtherMonths=this._get(inst,"selectOtherMonths");defaultDate=this._getDefaultDate(inst);html="";for(row=0;row<numMonths[0];row++){group="";this.maxRows=4;for(col=0;col<numMonths[1];col++){selectedDate=this._daylightSavingAdjust(new Date(drawYear,drawMonth,inst.selectedDay));cornerClass=" ui-corner-all";calender="";if(isMultiMonth){calender+="<div class='ui-datepicker-group";if(numMonths[1]>1){switch(col){case 0:calender+=" ui-datepicker-group-first";cornerClass=" ui-corner-"+(isRTL?"right":"left");break;case numMonths[1]-1:calender+=" ui-datepicker-group-last";cornerClass=" ui-corner-"+(isRTL?"left":"right");break;default:calender+=" ui-datepicker-group-middle";cornerClass="";break;}}calender+="'>";}calender+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+cornerClass+"'>"+(/all|left/.test(cornerClass)&&row===0?isRTL?next:prev:"")+(/all|right/.test(cornerClass)&&row===0?isRTL?prev:next:"")+this._generateMonthYearHeader(inst,drawMonth,drawYear,minDate,maxDate,row>0||col>0,monthNames,monthNamesShort)+// draw month headers
	"</div><table class='ui-datepicker-calendar'><thead>"+"<tr>";thead=showWeek?"<th class='ui-datepicker-week-col'>"+this._get(inst,"weekHeader")+"</th>":"";for(dow=0;dow<7;dow++){// days of the week
	day=(dow+firstDay)%7;thead+="<th scope='col'"+((dow+firstDay+6)%7>=5?" class='ui-datepicker-week-end'":"")+">"+"<span title='"+dayNames[day]+"'>"+dayNamesMin[day]+"</span></th>";}calender+=thead+"</tr></thead><tbody>";daysInMonth=this._getDaysInMonth(drawYear,drawMonth);if(drawYear===inst.selectedYear&&drawMonth===inst.selectedMonth){inst.selectedDay=Math.min(inst.selectedDay,daysInMonth);}leadDays=(this._getFirstDayOfMonth(drawYear,drawMonth)-firstDay+7)%7;curRows=Math.ceil((leadDays+daysInMonth)/7);// calculate the number of rows to generate
	numRows=isMultiMonth?this.maxRows>curRows?this.maxRows:curRows:curRows;//If multiple months, use the higher number of rows (see #7043)
	this.maxRows=numRows;printDate=this._daylightSavingAdjust(new Date(drawYear,drawMonth,1-leadDays));for(dRow=0;dRow<numRows;dRow++){// create date picker rows
	calender+="<tr>";tbody=!showWeek?"":"<td class='ui-datepicker-week-col'>"+this._get(inst,"calculateWeek")(printDate)+"</td>";for(dow=0;dow<7;dow++){// create date picker days
	daySettings=beforeShowDay?beforeShowDay.apply(inst.input?inst.input[0]:null,[printDate]):[true,""];otherMonth=printDate.getMonth()!==drawMonth;unselectable=otherMonth&&!selectOtherMonths||!daySettings[0]||minDate&&printDate<minDate||maxDate&&printDate>maxDate;tbody+="<td class='"+((dow+firstDay+6)%7>=5?" ui-datepicker-week-end":"")+(// highlight weekends
	otherMonth?" ui-datepicker-other-month":"")+(// highlight days from other months
	printDate.getTime()===selectedDate.getTime()&&drawMonth===inst.selectedMonth&&inst._keyEvent||// user pressed key
	defaultDate.getTime()===printDate.getTime()&&defaultDate.getTime()===selectedDate.getTime()?// or defaultDate is current printedDate and defaultDate is selectedDate
	" "+this._dayOverClass:"")+(// highlight selected day
	unselectable?" "+this._unselectableClass+" ui-state-disabled":"")+(// highlight unselectable days
	otherMonth&&!showOtherMonths?"":" "+daySettings[1]+(// highlight custom dates
	printDate.getTime()===currentDate.getTime()?" "+this._currentClass:"")+(// highlight selected day
	printDate.getTime()===today.getTime()?" ui-datepicker-today":""))+"'"+(// highlight today (if different)
	(!otherMonth||showOtherMonths)&&daySettings[2]?" title='"+daySettings[2].replace(/'/g,"&#39;")+"'":"")+(// cell title
	unselectable?"":" data-handler='selectDay' data-event='click' data-month='"+printDate.getMonth()+"' data-year='"+printDate.getFullYear()+"'")+">"+(// actions
	otherMonth&&!showOtherMonths?"&#xa0;":// display for other months
	unselectable?"<span class='ui-state-default'>"+printDate.getDate()+"</span>":"<a class='ui-state-default"+(printDate.getTime()===today.getTime()?" ui-state-highlight":"")+(printDate.getTime()===currentDate.getTime()?" ui-state-active":"")+(// highlight selected day
	otherMonth?" ui-priority-secondary":"")+// distinguish dates from other months
	"' href='#'>"+printDate.getDate()+"</a>")+"</td>";// display selectable date
	printDate.setDate(printDate.getDate()+1);printDate=this._daylightSavingAdjust(printDate);}calender+=tbody+"</tr>";}drawMonth++;if(drawMonth>11){drawMonth=0;drawYear++;}calender+="</tbody></table>"+(isMultiMonth?"</div>"+(numMonths[0]>0&&col===numMonths[1]-1?"<div class='ui-datepicker-row-break'></div>":""):"");group+=calender;}html+=group;}html+=buttonPanel;inst._keyEvent=false;return html;},/* Generate the month and year header. */_generateMonthYearHeader:function _generateMonthYearHeader(inst,drawMonth,drawYear,minDate,maxDate,secondary,monthNames,monthNamesShort){var inMinYear,inMaxYear,month,years,thisYear,determineYear,year,endYear,changeMonth=this._get(inst,"changeMonth"),changeYear=this._get(inst,"changeYear"),showMonthAfterYear=this._get(inst,"showMonthAfterYear"),html="<div class='ui-datepicker-title'>",monthHtml="";// Month selection
	if(secondary||!changeMonth){monthHtml+="<span class='ui-datepicker-month'>"+monthNames[drawMonth]+"</span>";}else{inMinYear=minDate&&minDate.getFullYear()===drawYear;inMaxYear=maxDate&&maxDate.getFullYear()===drawYear;monthHtml+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";for(month=0;month<12;month++){if((!inMinYear||month>=minDate.getMonth())&&(!inMaxYear||month<=maxDate.getMonth())){monthHtml+="<option value='"+month+"'"+(month===drawMonth?" selected='selected'":"")+">"+monthNamesShort[month]+"</option>";}}monthHtml+="</select>";}if(!showMonthAfterYear){html+=monthHtml+(secondary||!(changeMonth&&changeYear)?"&#xa0;":"");}// Year selection
	if(!inst.yearshtml){inst.yearshtml="";if(secondary||!changeYear){html+="<span class='ui-datepicker-year'>"+drawYear+"</span>";}else{// determine range of years to display
	years=this._get(inst,"yearRange").split(":");thisYear=new Date().getFullYear();determineYear=function determineYear(value){var year=value.match(/c[+\-].*/)?drawYear+parseInt(value.substring(1),10):value.match(/[+\-].*/)?thisYear+parseInt(value,10):parseInt(value,10);return isNaN(year)?thisYear:year;};year=determineYear(years[0]);endYear=Math.max(year,determineYear(years[1]||""));year=minDate?Math.max(year,minDate.getFullYear()):year;endYear=maxDate?Math.min(endYear,maxDate.getFullYear()):endYear;inst.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";for(;year<=endYear;year++){inst.yearshtml+="<option value='"+year+"'"+(year===drawYear?" selected='selected'":"")+">"+year+"</option>";}inst.yearshtml+="</select>";html+=inst.yearshtml;inst.yearshtml=null;}}html+=this._get(inst,"yearSuffix");if(showMonthAfterYear){html+=(secondary||!(changeMonth&&changeYear)?"&#xa0;":"")+monthHtml;}html+="</div>";// Close datepicker_header
	return html;},/* Adjust one of the date sub-fields. */_adjustInstDate:function _adjustInstDate(inst,offset,period){var year=inst.selectedYear+(period==="Y"?offset:0),month=inst.selectedMonth+(period==="M"?offset:0),day=Math.min(inst.selectedDay,this._getDaysInMonth(year,month))+(period==="D"?offset:0),date=this._restrictMinMax(inst,this._daylightSavingAdjust(new Date(year,month,day)));inst.selectedDay=date.getDate();inst.drawMonth=inst.selectedMonth=date.getMonth();inst.drawYear=inst.selectedYear=date.getFullYear();if(period==="M"||period==="Y"){this._notifyChange(inst);}},/* Ensure a date is within any min/max bounds. */_restrictMinMax:function _restrictMinMax(inst,date){var minDate=this._getMinMaxDate(inst,"min"),maxDate=this._getMinMaxDate(inst,"max"),newDate=minDate&&date<minDate?minDate:date;return maxDate&&newDate>maxDate?maxDate:newDate;},/* Notify change of month/year. */_notifyChange:function _notifyChange(inst){var onChange=this._get(inst,"onChangeMonthYear");if(onChange){onChange.apply(inst.input?inst.input[0]:null,[inst.selectedYear,inst.selectedMonth+1,inst]);}},/* Determine the number of months to show. */_getNumberOfMonths:function _getNumberOfMonths(inst){var numMonths=this._get(inst,"numberOfMonths");return numMonths==null?[1,1]:typeof numMonths==="number"?[1,numMonths]:numMonths;},/* Determine the current maximum date - ensure no time components are set. */_getMinMaxDate:function _getMinMaxDate(inst,minMax){return this._determineDate(inst,this._get(inst,minMax+"Date"),null);},/* Find the number of days in a given month. */_getDaysInMonth:function _getDaysInMonth(year,month){return 32-this._daylightSavingAdjust(new Date(year,month,32)).getDate();},/* Find the day of the week of the first of a month. */_getFirstDayOfMonth:function _getFirstDayOfMonth(year,month){return new Date(year,month,1).getDay();},/* Determines if we should allow a "next/prev" month display change. */_canAdjustMonth:function _canAdjustMonth(inst,offset,curYear,curMonth){var numMonths=this._getNumberOfMonths(inst),date=this._daylightSavingAdjust(new Date(curYear,curMonth+(offset<0?offset:numMonths[0]*numMonths[1]),1));if(offset<0){date.setDate(this._getDaysInMonth(date.getFullYear(),date.getMonth()));}return this._isInRange(inst,date);},/* Is the given date in the accepted range? */_isInRange:function _isInRange(inst,date){var yearSplit,currentYear,minDate=this._getMinMaxDate(inst,"min"),maxDate=this._getMinMaxDate(inst,"max"),minYear=null,maxYear=null,years=this._get(inst,"yearRange");if(years){yearSplit=years.split(":");currentYear=new Date().getFullYear();minYear=parseInt(yearSplit[0],10);maxYear=parseInt(yearSplit[1],10);if(yearSplit[0].match(/[+\-].*/)){minYear+=currentYear;}if(yearSplit[1].match(/[+\-].*/)){maxYear+=currentYear;}}return(!minDate||date.getTime()>=minDate.getTime())&&(!maxDate||date.getTime()<=maxDate.getTime())&&(!minYear||date.getFullYear()>=minYear)&&(!maxYear||date.getFullYear()<=maxYear);},/* Provide the configuration settings for formatting/parsing. */_getFormatConfig:function _getFormatConfig(inst){var shortYearCutoff=this._get(inst,"shortYearCutoff");shortYearCutoff=typeof shortYearCutoff!=="string"?shortYearCutoff:new Date().getFullYear()%100+parseInt(shortYearCutoff,10);return{shortYearCutoff:shortYearCutoff,dayNamesShort:this._get(inst,"dayNamesShort"),dayNames:this._get(inst,"dayNames"),monthNamesShort:this._get(inst,"monthNamesShort"),monthNames:this._get(inst,"monthNames")};},/* Format the given date for display. */_formatDate:function _formatDate(inst,day,month,year){if(!day){inst.currentDay=inst.selectedDay;inst.currentMonth=inst.selectedMonth;inst.currentYear=inst.selectedYear;}var date=day?(typeof day==="undefined"?"undefined":_typeof(day))==="object"?day:this._daylightSavingAdjust(new Date(year,month,day)):this._daylightSavingAdjust(new Date(inst.currentYear,inst.currentMonth,inst.currentDay));return this.formatDate(this._get(inst,"dateFormat"),date,this._getFormatConfig(inst));}});/*
	 * Bind hover events for datepicker elements.
	 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
	 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
	 */function datepicker_bindHover(dpDiv){var selector="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return dpDiv.on("mouseout",selector,function(){$(this).removeClass("ui-state-hover");if(this.className.indexOf("ui-datepicker-prev")!==-1){$(this).removeClass("ui-datepicker-prev-hover");}if(this.className.indexOf("ui-datepicker-next")!==-1){$(this).removeClass("ui-datepicker-next-hover");}}).on("mouseover",selector,datepicker_handleMouseover);}function datepicker_handleMouseover(){if(!$.datepicker._isDisabledDatepicker(datepicker_instActive.inline?datepicker_instActive.dpDiv.parent()[0]:datepicker_instActive.input[0])){$(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover");$(this).addClass("ui-state-hover");if(this.className.indexOf("ui-datepicker-prev")!==-1){$(this).addClass("ui-datepicker-prev-hover");}if(this.className.indexOf("ui-datepicker-next")!==-1){$(this).addClass("ui-datepicker-next-hover");}}}/* jQuery extend now ignores nulls! */function datepicker_extendRemove(target,props){$.extend(target,props);for(var name in props){if(props[name]==null){target[name]=props[name];}}return target;}/* Invoke the datepicker functionality.
	   @param  options  string - a command, optionally followed by additional parameters or
						Object - settings for attaching new datepicker functionality
	   @return  jQuery object */$.fn.datepicker=function(options){/* Verify an empty collection wasn't passed - Fixes #6976 */if(!this.length){return this;}/* Initialise the date picker. */if(!$.datepicker.initialized){$(document).on("mousedown",$.datepicker._checkExternalClick);$.datepicker.initialized=true;}/* Append datepicker main container to body if not exist. */if($("#"+$.datepicker._mainDivId).length===0){$("body").append($.datepicker.dpDiv);}var otherArgs=Array.prototype.slice.call(arguments,1);if(typeof options==="string"&&(options==="isDisabled"||options==="getDate"||options==="widget")){return $.datepicker["_"+options+"Datepicker"].apply($.datepicker,[this[0]].concat(otherArgs));}if(options==="option"&&arguments.length===2&&typeof arguments[1]==="string"){return $.datepicker["_"+options+"Datepicker"].apply($.datepicker,[this[0]].concat(otherArgs));}return this.each(function(){typeof options==="string"?$.datepicker["_"+options+"Datepicker"].apply($.datepicker,[this].concat(otherArgs)):$.datepicker._attachDatepicker(this,options);});};$.datepicker=new Datepicker();// singleton instance
	$.datepicker.initialized=false;$.datepicker.uuid=new Date().getTime();$.datepicker.version="1.12.1";var widgetsDatepicker=$.datepicker;// This file is deprecated
	var ie=$.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());/*!
	 * jQuery UI Mouse 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Mouse
	//>>group: Widgets
	//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
	//>>docs: http://api.jqueryui.com/mouse/
	var mouseHandled=false;$(document).on("mouseup",function(){mouseHandled=false;});var widgetsMouse=$.widget("ui.mouse",{version:"1.12.1",options:{cancel:"input, textarea, button, select, option",distance:1,delay:0},_mouseInit:function _mouseInit(){var that=this;this.element.on("mousedown."+this.widgetName,function(event){return that._mouseDown(event);}).on("click."+this.widgetName,function(event){if(true===$.data(event.target,that.widgetName+".preventClickEvent")){$.removeData(event.target,that.widgetName+".preventClickEvent");event.stopImmediatePropagation();return false;}});this.started=false;},// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy:function _mouseDestroy(){this.element.off("."+this.widgetName);if(this._mouseMoveDelegate){this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate);}},_mouseDown:function _mouseDown(event){// don't let more than one widget handle mouseStart
	if(mouseHandled){return;}this._mouseMoved=false;// We may have missed mouseup (out of window)
	this._mouseStarted&&this._mouseUp(event);this._mouseDownEvent=event;var that=this,btnIsLeft=event.which===1,// event.target.nodeName works around a bug in IE 8 with
	// disabled inputs (#7620)
	elIsCancel=typeof this.options.cancel==="string"&&event.target.nodeName?$(event.target).closest(this.options.cancel).length:false;if(!btnIsLeft||elIsCancel||!this._mouseCapture(event)){return true;}this.mouseDelayMet=!this.options.delay;if(!this.mouseDelayMet){this._mouseDelayTimer=setTimeout(function(){that.mouseDelayMet=true;},this.options.delay);}if(this._mouseDistanceMet(event)&&this._mouseDelayMet(event)){this._mouseStarted=this._mouseStart(event)!==false;if(!this._mouseStarted){event.preventDefault();return true;}}// Click event may never have fired (Gecko & Opera)
	if(true===$.data(event.target,this.widgetName+".preventClickEvent")){$.removeData(event.target,this.widgetName+".preventClickEvent");}// These delegates are required to keep context
	this._mouseMoveDelegate=function(event){return that._mouseMove(event);};this._mouseUpDelegate=function(event){return that._mouseUp(event);};this.document.on("mousemove."+this.widgetName,this._mouseMoveDelegate).on("mouseup."+this.widgetName,this._mouseUpDelegate);event.preventDefault();mouseHandled=true;return true;},_mouseMove:function _mouseMove(event){// Only check for mouseups outside the document if you've moved inside the document
	// at least once. This prevents the firing of mouseup in the case of IE<9, which will
	// fire a mousemove event if content is placed under the cursor. See #7778
	// Support: IE <9
	if(this._mouseMoved){// IE mouseup check - mouseup happened when mouse was out of window
	if($.ui.ie&&(!document.documentMode||document.documentMode<9)&&!event.button){return this._mouseUp(event);// Iframe mouseup check - mouseup occurred in another document
	}else if(!event.which){// Support: Safari <=8 - 9
	// Safari sets which to 0 if you press any of the following keys
	// during a drag (#14461)
	if(event.originalEvent.altKey||event.originalEvent.ctrlKey||event.originalEvent.metaKey||event.originalEvent.shiftKey){this.ignoreMissingWhich=true;}else if(!this.ignoreMissingWhich){return this._mouseUp(event);}}}if(event.which||event.button){this._mouseMoved=true;}if(this._mouseStarted){this._mouseDrag(event);return event.preventDefault();}if(this._mouseDistanceMet(event)&&this._mouseDelayMet(event)){this._mouseStarted=this._mouseStart(this._mouseDownEvent,event)!==false;this._mouseStarted?this._mouseDrag(event):this._mouseUp(event);}return!this._mouseStarted;},_mouseUp:function _mouseUp(event){this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate);if(this._mouseStarted){this._mouseStarted=false;if(event.target===this._mouseDownEvent.target){$.data(event.target,this.widgetName+".preventClickEvent",true);}this._mouseStop(event);}if(this._mouseDelayTimer){clearTimeout(this._mouseDelayTimer);delete this._mouseDelayTimer;}this.ignoreMissingWhich=false;mouseHandled=false;event.preventDefault();},_mouseDistanceMet:function _mouseDistanceMet(event){return Math.max(Math.abs(this._mouseDownEvent.pageX-event.pageX),Math.abs(this._mouseDownEvent.pageY-event.pageY))>=this.options.distance;},_mouseDelayMet:function _mouseDelayMet()/* event */{return this.mouseDelayMet;},// These are placeholder methods, to be overriden by extending plugin
	_mouseStart:function _mouseStart()/* event */{},_mouseDrag:function _mouseDrag()/* event */{},_mouseStop:function _mouseStop()/* event */{},_mouseCapture:function _mouseCapture()/* event */{return true;}});// $.ui.plugin is deprecated. Use $.widget() extensions instead.
	var plugin=$.ui.plugin={add:function add(module,option,set){var i,proto=$.ui[module].prototype;for(i in set){proto.plugins[i]=proto.plugins[i]||[];proto.plugins[i].push([option,set[i]]);}},call:function call(instance,name,args,allowDisconnected){var i,set=instance.plugins[name];if(!set){return;}if(!allowDisconnected&&(!instance.element[0].parentNode||instance.element[0].parentNode.nodeType===11)){return;}for(i=0;i<set.length;i++){if(instance.options[set[i][0]]){set[i][1].apply(instance.element,args);}}}};var safeBlur=$.ui.safeBlur=function(element){// Support: IE9 - 10 only
	// If the <body> is blurred, IE will switch windows, see #9420
	if(element&&element.nodeName.toLowerCase()!=="body"){$(element).trigger("blur");}};/*!
	 * jQuery UI Draggable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Draggable
	//>>group: Interactions
	//>>description: Enables dragging functionality for any element.
	//>>docs: http://api.jqueryui.com/draggable/
	//>>demos: http://jqueryui.com/draggable/
	//>>css.structure: ../../themes/base/draggable.css
	$.widget("ui.draggable",$.ui.mouse,{version:"1.12.1",widgetEventPrefix:"drag",options:{addClasses:true,appendTo:"parent",axis:false,connectToSortable:false,containment:false,cursor:"auto",cursorAt:false,grid:false,handle:false,helper:"original",iframeFix:false,opacity:false,refreshPositions:false,revert:false,revertDuration:500,scope:"default",scroll:true,scrollSensitivity:20,scrollSpeed:20,snap:false,snapMode:"both",snapTolerance:20,stack:false,zIndex:false,// Callbacks
	drag:null,start:null,stop:null},_create:function _create(){if(this.options.helper==="original"){this._setPositionRelative();}if(this.options.addClasses){this._addClass("ui-draggable");}this._setHandleClassName();this._mouseInit();},_setOption:function _setOption(key,value){this._super(key,value);if(key==="handle"){this._removeHandleClassName();this._setHandleClassName();}},_destroy:function _destroy(){if((this.helper||this.element).is(".ui-draggable-dragging")){this.destroyOnClear=true;return;}this._removeHandleClassName();this._mouseDestroy();},_mouseCapture:function _mouseCapture(event){var o=this.options;// Among others, prevent a drag on a resizable-handle
	if(this.helper||o.disabled||$(event.target).closest(".ui-resizable-handle").length>0){return false;}//Quit if we're not on a valid handle
	this.handle=this._getHandle(event);if(!this.handle){return false;}this._blurActiveElement(event);this._blockFrames(o.iframeFix===true?"iframe":o.iframeFix);return true;},_blockFrames:function _blockFrames(selector){this.iframeBlocks=this.document.find(selector).map(function(){var iframe=$(this);return $("<div>").css("position","absolute").appendTo(iframe.parent()).outerWidth(iframe.outerWidth()).outerHeight(iframe.outerHeight()).offset(iframe.offset())[0];});},_unblockFrames:function _unblockFrames(){if(this.iframeBlocks){this.iframeBlocks.remove();delete this.iframeBlocks;}},_blurActiveElement:function _blurActiveElement(event){var activeElement=$.ui.safeActiveElement(this.document[0]),target=$(event.target);// Don't blur if the event occurred on an element that is within
	// the currently focused element
	// See #10527, #12472
	if(target.closest(activeElement).length){return;}// Blur any element that currently has focus, see #4261
	$.ui.safeBlur(activeElement);},_mouseStart:function _mouseStart(event){var o=this.options;//Create and append the visible helper
	this.helper=this._createHelper(event);this._addClass(this.helper,"ui-draggable-dragging");//Cache the helper size
	this._cacheHelperProportions();//If ddmanager is used for droppables, set the global draggable
	if($.ui.ddmanager){$.ui.ddmanager.current=this;}/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 *///Cache the margins of the original element
	this._cacheMargins();//Store the helper's css position
	this.cssPosition=this.helper.css("position");this.scrollParent=this.helper.scrollParent(true);this.offsetParent=this.helper.offsetParent();this.hasFixedAncestor=this.helper.parents().filter(function(){return $(this).css("position")==="fixed";}).length>0;//The element's absolute position on the page minus margins
	this.positionAbs=this.element.offset();this._refreshOffsets(event);//Generate the original position
	this.originalPosition=this.position=this._generatePosition(event,false);this.originalPageX=event.pageX;this.originalPageY=event.pageY;//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
	o.cursorAt&&this._adjustOffsetFromHelper(o.cursorAt);//Set a containment if given in the options
	this._setContainment();//Trigger event + callbacks
	if(this._trigger("start",event)===false){this._clear();return false;}//Recache the helper size
	this._cacheHelperProportions();//Prepare the droppable offsets
	if($.ui.ddmanager&&!o.dropBehaviour){$.ui.ddmanager.prepareOffsets(this,event);}// Execute the drag once - this causes the helper not to be visible before getting its
	// correct position
	this._mouseDrag(event,true);// If the ddmanager is used for droppables, inform the manager that dragging has started
	// (see #5003)
	if($.ui.ddmanager){$.ui.ddmanager.dragStart(this,event);}return true;},_refreshOffsets:function _refreshOffsets(event){this.offset={top:this.positionAbs.top-this.margins.top,left:this.positionAbs.left-this.margins.left,scroll:false,parent:this._getParentOffset(),relative:this._getRelativeOffset()};this.offset.click={left:event.pageX-this.offset.left,top:event.pageY-this.offset.top};},_mouseDrag:function _mouseDrag(event,noPropagation){// reset any necessary cached properties (see #5009)
	if(this.hasFixedAncestor){this.offset.parent=this._getParentOffset();}//Compute the helpers position
	this.position=this._generatePosition(event,true);this.positionAbs=this._convertPositionTo("absolute");//Call plugins and callbacks and use the resulting position if something is returned
	if(!noPropagation){var ui=this._uiHash();if(this._trigger("drag",event,ui)===false){this._mouseUp(new $.Event("mouseup",event));return false;}this.position=ui.position;}this.helper[0].style.left=this.position.left+"px";this.helper[0].style.top=this.position.top+"px";if($.ui.ddmanager){$.ui.ddmanager.drag(this,event);}return false;},_mouseStop:function _mouseStop(event){//If we are using droppables, inform the manager about the drop
	var that=this,dropped=false;if($.ui.ddmanager&&!this.options.dropBehaviour){dropped=$.ui.ddmanager.drop(this,event);}//if a drop comes from outside (a sortable)
	if(this.dropped){dropped=this.dropped;this.dropped=false;}if(this.options.revert==="invalid"&&!dropped||this.options.revert==="valid"&&dropped||this.options.revert===true||$.isFunction(this.options.revert)&&this.options.revert.call(this.element,dropped)){$(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){if(that._trigger("stop",event)!==false){that._clear();}});}else{if(this._trigger("stop",event)!==false){this._clear();}}return false;},_mouseUp:function _mouseUp(event){this._unblockFrames();// If the ddmanager is used for droppables, inform the manager that dragging has stopped
	// (see #5003)
	if($.ui.ddmanager){$.ui.ddmanager.dragStop(this,event);}// Only need to focus if the event occurred on the draggable itself, see #10527
	if(this.handleElement.is(event.target)){// The interaction is over; whether or not the click resulted in a drag,
	// focus the element
	this.element.trigger("focus");}return $.ui.mouse.prototype._mouseUp.call(this,event);},cancel:function cancel(){if(this.helper.is(".ui-draggable-dragging")){this._mouseUp(new $.Event("mouseup",{target:this.element[0]}));}else{this._clear();}return this;},_getHandle:function _getHandle(event){return this.options.handle?!!$(event.target).closest(this.element.find(this.options.handle)).length:true;},_setHandleClassName:function _setHandleClassName(){this.handleElement=this.options.handle?this.element.find(this.options.handle):this.element;this._addClass(this.handleElement,"ui-draggable-handle");},_removeHandleClassName:function _removeHandleClassName(){this._removeClass(this.handleElement,"ui-draggable-handle");},_createHelper:function _createHelper(event){var o=this.options,helperIsFunction=$.isFunction(o.helper),helper=helperIsFunction?$(o.helper.apply(this.element[0],[event])):o.helper==="clone"?this.element.clone().removeAttr("id"):this.element;if(!helper.parents("body").length){helper.appendTo(o.appendTo==="parent"?this.element[0].parentNode:o.appendTo);}// Http://bugs.jqueryui.com/ticket/9446
	// a helper function can return the original element
	// which wouldn't have been set to relative in _create
	if(helperIsFunction&&helper[0]===this.element[0]){this._setPositionRelative();}if(helper[0]!==this.element[0]&&!/(fixed|absolute)/.test(helper.css("position"))){helper.css("position","absolute");}return helper;},_setPositionRelative:function _setPositionRelative(){if(!/^(?:r|a|f)/.test(this.element.css("position"))){this.element[0].style.position="relative";}},_adjustOffsetFromHelper:function _adjustOffsetFromHelper(obj){if(typeof obj==="string"){obj=obj.split(" ");}if($.isArray(obj)){obj={left:+obj[0],top:+obj[1]||0};}if("left"in obj){this.offset.click.left=obj.left+this.margins.left;}if("right"in obj){this.offset.click.left=this.helperProportions.width-obj.right+this.margins.left;}if("top"in obj){this.offset.click.top=obj.top+this.margins.top;}if("bottom"in obj){this.offset.click.top=this.helperProportions.height-obj.bottom+this.margins.top;}},_isRootNode:function _isRootNode(element){return /(html|body)/i.test(element.tagName)||element===this.document[0];},_getParentOffset:function _getParentOffset(){//Get the offsetParent and cache its position
	var po=this.offsetParent.offset(),document=this.document[0];// This is a special case where we need to modify a offset calculated on start, since the
	// following happened:
	// 1. The position of the helper is absolute, so it's position is calculated based on the
	// next positioned parent
	// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
	// the document, which means that the scroll is included in the initial calculation of the
	// offset of the parent, and never recalculated upon drag
	if(this.cssPosition==="absolute"&&this.scrollParent[0]!==document&&$.contains(this.scrollParent[0],this.offsetParent[0])){po.left+=this.scrollParent.scrollLeft();po.top+=this.scrollParent.scrollTop();}if(this._isRootNode(this.offsetParent[0])){po={top:0,left:0};}return{top:po.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:po.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)};},_getRelativeOffset:function _getRelativeOffset(){if(this.cssPosition!=="relative"){return{top:0,left:0};}var p=this.element.position(),scrollIsRootNode=this._isRootNode(this.scrollParent[0]);return{top:p.top-(parseInt(this.helper.css("top"),10)||0)+(!scrollIsRootNode?this.scrollParent.scrollTop():0),left:p.left-(parseInt(this.helper.css("left"),10)||0)+(!scrollIsRootNode?this.scrollParent.scrollLeft():0)};},_cacheMargins:function _cacheMargins(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0};},_cacheHelperProportions:function _cacheHelperProportions(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()};},_setContainment:function _setContainment(){var isUserScrollable,c,ce,o=this.options,document=this.document[0];this.relativeContainer=null;if(!o.containment){this.containment=null;return;}if(o.containment==="window"){this.containment=[$(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,$(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,$(window).scrollLeft()+$(window).width()-this.helperProportions.width-this.margins.left,$(window).scrollTop()+($(window).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top];return;}if(o.containment==="document"){this.containment=[0,0,$(document).width()-this.helperProportions.width-this.margins.left,($(document).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top];return;}if(o.containment.constructor===Array){this.containment=o.containment;return;}if(o.containment==="parent"){o.containment=this.helper[0].parentNode;}c=$(o.containment);ce=c[0];if(!ce){return;}isUserScrollable=/(scroll|auto)/.test(c.css("overflow"));this.containment=[(parseInt(c.css("borderLeftWidth"),10)||0)+(parseInt(c.css("paddingLeft"),10)||0),(parseInt(c.css("borderTopWidth"),10)||0)+(parseInt(c.css("paddingTop"),10)||0),(isUserScrollable?Math.max(ce.scrollWidth,ce.offsetWidth):ce.offsetWidth)-(parseInt(c.css("borderRightWidth"),10)||0)-(parseInt(c.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(isUserScrollable?Math.max(ce.scrollHeight,ce.offsetHeight):ce.offsetHeight)-(parseInt(c.css("borderBottomWidth"),10)||0)-(parseInt(c.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom];this.relativeContainer=c;},_convertPositionTo:function _convertPositionTo(d,pos){if(!pos){pos=this.position;}var mod=d==="absolute"?1:-1,scrollIsRootNode=this._isRootNode(this.scrollParent[0]);return{top:// The absolute mouse position
	pos.top+// Only for relative positioned nodes: Relative offset from element to offset parent
	this.offset.relative.top*mod+// The offsetParent's offset without borders (offset + border)
	this.offset.parent.top*mod-(this.cssPosition==="fixed"?-this.offset.scroll.top:scrollIsRootNode?0:this.offset.scroll.top)*mod,left:// The absolute mouse position
	pos.left+// Only for relative positioned nodes: Relative offset from element to offset parent
	this.offset.relative.left*mod+// The offsetParent's offset without borders (offset + border)
	this.offset.parent.left*mod-(this.cssPosition==="fixed"?-this.offset.scroll.left:scrollIsRootNode?0:this.offset.scroll.left)*mod};},_generatePosition:function _generatePosition(event,constrainPosition){var containment,co,top,left,o=this.options,scrollIsRootNode=this._isRootNode(this.scrollParent[0]),pageX=event.pageX,pageY=event.pageY;// Cache the scroll
	if(!scrollIsRootNode||!this.offset.scroll){this.offset.scroll={top:this.scrollParent.scrollTop(),left:this.scrollParent.scrollLeft()};}/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */// If we are not dragging yet, we won't check for options
	if(constrainPosition){if(this.containment){if(this.relativeContainer){co=this.relativeContainer.offset();containment=[this.containment[0]+co.left,this.containment[1]+co.top,this.containment[2]+co.left,this.containment[3]+co.top];}else{containment=this.containment;}if(event.pageX-this.offset.click.left<containment[0]){pageX=containment[0]+this.offset.click.left;}if(event.pageY-this.offset.click.top<containment[1]){pageY=containment[1]+this.offset.click.top;}if(event.pageX-this.offset.click.left>containment[2]){pageX=containment[2]+this.offset.click.left;}if(event.pageY-this.offset.click.top>containment[3]){pageY=containment[3]+this.offset.click.top;}}if(o.grid){//Check for grid elements set to 0 to prevent divide by 0 error causing invalid
	// argument errors in IE (see ticket #6950)
	top=o.grid[1]?this.originalPageY+Math.round((pageY-this.originalPageY)/o.grid[1])*o.grid[1]:this.originalPageY;pageY=containment?top-this.offset.click.top>=containment[1]||top-this.offset.click.top>containment[3]?top:top-this.offset.click.top>=containment[1]?top-o.grid[1]:top+o.grid[1]:top;left=o.grid[0]?this.originalPageX+Math.round((pageX-this.originalPageX)/o.grid[0])*o.grid[0]:this.originalPageX;pageX=containment?left-this.offset.click.left>=containment[0]||left-this.offset.click.left>containment[2]?left:left-this.offset.click.left>=containment[0]?left-o.grid[0]:left+o.grid[0]:left;}if(o.axis==="y"){pageX=this.originalPageX;}if(o.axis==="x"){pageY=this.originalPageY;}}return{top:// The absolute mouse position
	pageY-// Click offset (relative to the element)
	this.offset.click.top-// Only for relative positioned nodes: Relative offset from element to offset parent
	this.offset.relative.top-// The offsetParent's offset without borders (offset + border)
	this.offset.parent.top+(this.cssPosition==="fixed"?-this.offset.scroll.top:scrollIsRootNode?0:this.offset.scroll.top),left:// The absolute mouse position
	pageX-// Click offset (relative to the element)
	this.offset.click.left-// Only for relative positioned nodes: Relative offset from element to offset parent
	this.offset.relative.left-// The offsetParent's offset without borders (offset + border)
	this.offset.parent.left+(this.cssPosition==="fixed"?-this.offset.scroll.left:scrollIsRootNode?0:this.offset.scroll.left)};},_clear:function _clear(){this._removeClass(this.helper,"ui-draggable-dragging");if(this.helper[0]!==this.element[0]&&!this.cancelHelperRemoval){this.helper.remove();}this.helper=null;this.cancelHelperRemoval=false;if(this.destroyOnClear){this.destroy();}},// From now on bulk stuff - mainly helpers
	_trigger:function _trigger(type,event,ui){ui=ui||this._uiHash();$.ui.plugin.call(this,type,[event,ui,this],true);// Absolute position and offset (see #6884 ) have to be recalculated after plugins
	if(/^(drag|start|stop)/.test(type)){this.positionAbs=this._convertPositionTo("absolute");ui.offset=this.positionAbs;}return $.Widget.prototype._trigger.call(this,type,event,ui);},plugins:{},_uiHash:function _uiHash(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs};}});$.ui.plugin.add("draggable","connectToSortable",{start:function start(event,ui,draggable){var uiSortable=$.extend({},ui,{item:draggable.element});draggable.sortables=[];$(draggable.options.connectToSortable).each(function(){var sortable=$(this).sortable("instance");if(sortable&&!sortable.options.disabled){draggable.sortables.push(sortable);// RefreshPositions is called at drag start to refresh the containerCache
	// which is used in drag. This ensures it's initialized and synchronized
	// with any changes that might have happened on the page since initialization.
	sortable.refreshPositions();sortable._trigger("activate",event,uiSortable);}});},stop:function stop(event,ui,draggable){var uiSortable=$.extend({},ui,{item:draggable.element});draggable.cancelHelperRemoval=false;$.each(draggable.sortables,function(){var sortable=this;if(sortable.isOver){sortable.isOver=0;// Allow this sortable to handle removing the helper
	draggable.cancelHelperRemoval=true;sortable.cancelHelperRemoval=false;// Use _storedCSS To restore properties in the sortable,
	// as this also handles revert (#9675) since the draggable
	// may have modified them in unexpected ways (#8809)
	sortable._storedCSS={position:sortable.placeholder.css("position"),top:sortable.placeholder.css("top"),left:sortable.placeholder.css("left")};sortable._mouseStop(event);// Once drag has ended, the sortable should return to using
	// its original helper, not the shared helper from draggable
	sortable.options.helper=sortable.options._helper;}else{// Prevent this Sortable from removing the helper.
	// However, don't set the draggable to remove the helper
	// either as another connected Sortable may yet handle the removal.
	sortable.cancelHelperRemoval=true;sortable._trigger("deactivate",event,uiSortable);}});},drag:function drag(event,ui,draggable){$.each(draggable.sortables,function(){var innermostIntersecting=false,sortable=this;// Copy over variables that sortable's _intersectsWith uses
	sortable.positionAbs=draggable.positionAbs;sortable.helperProportions=draggable.helperProportions;sortable.offset.click=draggable.offset.click;if(sortable._intersectsWith(sortable.containerCache)){innermostIntersecting=true;$.each(draggable.sortables,function(){// Copy over variables that sortable's _intersectsWith uses
	this.positionAbs=draggable.positionAbs;this.helperProportions=draggable.helperProportions;this.offset.click=draggable.offset.click;if(this!==sortable&&this._intersectsWith(this.containerCache)&&$.contains(sortable.element[0],this.element[0])){innermostIntersecting=false;}return innermostIntersecting;});}if(innermostIntersecting){// If it intersects, we use a little isOver variable and set it once,
	// so that the move-in stuff gets fired only once.
	if(!sortable.isOver){sortable.isOver=1;// Store draggable's parent in case we need to reappend to it later.
	draggable._parent=ui.helper.parent();sortable.currentItem=ui.helper.appendTo(sortable.element).data("ui-sortable-item",true);// Store helper option to later restore it
	sortable.options._helper=sortable.options.helper;sortable.options.helper=function(){return ui.helper[0];};// Fire the start events of the sortable with our passed browser event,
	// and our own helper (so it doesn't create a new one)
	event.target=sortable.currentItem[0];sortable._mouseCapture(event,true);sortable._mouseStart(event,true,true);// Because the browser event is way off the new appended portlet,
	// modify necessary variables to reflect the changes
	sortable.offset.click.top=draggable.offset.click.top;sortable.offset.click.left=draggable.offset.click.left;sortable.offset.parent.left-=draggable.offset.parent.left-sortable.offset.parent.left;sortable.offset.parent.top-=draggable.offset.parent.top-sortable.offset.parent.top;draggable._trigger("toSortable",event);// Inform draggable that the helper is in a valid drop zone,
	// used solely in the revert option to handle "valid/invalid".
	draggable.dropped=sortable.element;// Need to refreshPositions of all sortables in the case that
	// adding to one sortable changes the location of the other sortables (#9675)
	$.each(draggable.sortables,function(){this.refreshPositions();});// Hack so receive/update callbacks work (mostly)
	draggable.currentItem=draggable.element;sortable.fromOutside=draggable;}if(sortable.currentItem){sortable._mouseDrag(event);// Copy the sortable's position because the draggable's can potentially reflect
	// a relative position, while sortable is always absolute, which the dragged
	// element has now become. (#8809)
	ui.position=sortable.position;}}else{// If it doesn't intersect with the sortable, and it intersected before,
	// we fake the drag stop of the sortable, but make sure it doesn't remove
	// the helper by using cancelHelperRemoval.
	if(sortable.isOver){sortable.isOver=0;sortable.cancelHelperRemoval=true;// Calling sortable's mouseStop would trigger a revert,
	// so revert must be temporarily false until after mouseStop is called.
	sortable.options._revert=sortable.options.revert;sortable.options.revert=false;sortable._trigger("out",event,sortable._uiHash(sortable));sortable._mouseStop(event,true);// Restore sortable behaviors that were modfied
	// when the draggable entered the sortable area (#9481)
	sortable.options.revert=sortable.options._revert;sortable.options.helper=sortable.options._helper;if(sortable.placeholder){sortable.placeholder.remove();}// Restore and recalculate the draggable's offset considering the sortable
	// may have modified them in unexpected ways. (#8809, #10669)
	ui.helper.appendTo(draggable._parent);draggable._refreshOffsets(event);ui.position=draggable._generatePosition(event,true);draggable._trigger("fromSortable",event);// Inform draggable that the helper is no longer in a valid drop zone
	draggable.dropped=false;// Need to refreshPositions of all sortables just in case removing
	// from one sortable changes the location of other sortables (#9675)
	$.each(draggable.sortables,function(){this.refreshPositions();});}}});}});$.ui.plugin.add("draggable","cursor",{start:function start(event,ui,instance){var t=$("body"),o=instance.options;if(t.css("cursor")){o._cursor=t.css("cursor");}t.css("cursor",o.cursor);},stop:function stop(event,ui,instance){var o=instance.options;if(o._cursor){$("body").css("cursor",o._cursor);}}});$.ui.plugin.add("draggable","opacity",{start:function start(event,ui,instance){var t=$(ui.helper),o=instance.options;if(t.css("opacity")){o._opacity=t.css("opacity");}t.css("opacity",o.opacity);},stop:function stop(event,ui,instance){var o=instance.options;if(o._opacity){$(ui.helper).css("opacity",o._opacity);}}});$.ui.plugin.add("draggable","scroll",{start:function start(event,ui,i){if(!i.scrollParentNotHidden){i.scrollParentNotHidden=i.helper.scrollParent(false);}if(i.scrollParentNotHidden[0]!==i.document[0]&&i.scrollParentNotHidden[0].tagName!=="HTML"){i.overflowOffset=i.scrollParentNotHidden.offset();}},drag:function drag(event,ui,i){var o=i.options,scrolled=false,scrollParent=i.scrollParentNotHidden[0],document=i.document[0];if(scrollParent!==document&&scrollParent.tagName!=="HTML"){if(!o.axis||o.axis!=="x"){if(i.overflowOffset.top+scrollParent.offsetHeight-event.pageY<o.scrollSensitivity){scrollParent.scrollTop=scrolled=scrollParent.scrollTop+o.scrollSpeed;}else if(event.pageY-i.overflowOffset.top<o.scrollSensitivity){scrollParent.scrollTop=scrolled=scrollParent.scrollTop-o.scrollSpeed;}}if(!o.axis||o.axis!=="y"){if(i.overflowOffset.left+scrollParent.offsetWidth-event.pageX<o.scrollSensitivity){scrollParent.scrollLeft=scrolled=scrollParent.scrollLeft+o.scrollSpeed;}else if(event.pageX-i.overflowOffset.left<o.scrollSensitivity){scrollParent.scrollLeft=scrolled=scrollParent.scrollLeft-o.scrollSpeed;}}}else{if(!o.axis||o.axis!=="x"){if(event.pageY-$(document).scrollTop()<o.scrollSensitivity){scrolled=$(document).scrollTop($(document).scrollTop()-o.scrollSpeed);}else if($(window).height()-(event.pageY-$(document).scrollTop())<o.scrollSensitivity){scrolled=$(document).scrollTop($(document).scrollTop()+o.scrollSpeed);}}if(!o.axis||o.axis!=="y"){if(event.pageX-$(document).scrollLeft()<o.scrollSensitivity){scrolled=$(document).scrollLeft($(document).scrollLeft()-o.scrollSpeed);}else if($(window).width()-(event.pageX-$(document).scrollLeft())<o.scrollSensitivity){scrolled=$(document).scrollLeft($(document).scrollLeft()+o.scrollSpeed);}}}if(scrolled!==false&&$.ui.ddmanager&&!o.dropBehaviour){$.ui.ddmanager.prepareOffsets(i,event);}}});$.ui.plugin.add("draggable","snap",{start:function start(event,ui,i){var o=i.options;i.snapElements=[];$(o.snap.constructor!==String?o.snap.items||":data(ui-draggable)":o.snap).each(function(){var $t=$(this),$o=$t.offset();if(this!==i.element[0]){i.snapElements.push({item:this,width:$t.outerWidth(),height:$t.outerHeight(),top:$o.top,left:$o.left});}});},drag:function drag(event,ui,inst){var ts,bs,ls,rs,l,r,t,b,i,first,o=inst.options,d=o.snapTolerance,x1=ui.offset.left,x2=x1+inst.helperProportions.width,y1=ui.offset.top,y2=y1+inst.helperProportions.height;for(i=inst.snapElements.length-1;i>=0;i--){l=inst.snapElements[i].left-inst.margins.left;r=l+inst.snapElements[i].width;t=inst.snapElements[i].top-inst.margins.top;b=t+inst.snapElements[i].height;if(x2<l-d||x1>r+d||y2<t-d||y1>b+d||!$.contains(inst.snapElements[i].item.ownerDocument,inst.snapElements[i].item)){if(inst.snapElements[i].snapping){inst.options.snap.release&&inst.options.snap.release.call(inst.element,event,$.extend(inst._uiHash(),{snapItem:inst.snapElements[i].item}));}inst.snapElements[i].snapping=false;continue;}if(o.snapMode!=="inner"){ts=Math.abs(t-y2)<=d;bs=Math.abs(b-y1)<=d;ls=Math.abs(l-x2)<=d;rs=Math.abs(r-x1)<=d;if(ts){ui.position.top=inst._convertPositionTo("relative",{top:t-inst.helperProportions.height,left:0}).top;}if(bs){ui.position.top=inst._convertPositionTo("relative",{top:b,left:0}).top;}if(ls){ui.position.left=inst._convertPositionTo("relative",{top:0,left:l-inst.helperProportions.width}).left;}if(rs){ui.position.left=inst._convertPositionTo("relative",{top:0,left:r}).left;}}first=ts||bs||ls||rs;if(o.snapMode!=="outer"){ts=Math.abs(t-y1)<=d;bs=Math.abs(b-y2)<=d;ls=Math.abs(l-x1)<=d;rs=Math.abs(r-x2)<=d;if(ts){ui.position.top=inst._convertPositionTo("relative",{top:t,left:0}).top;}if(bs){ui.position.top=inst._convertPositionTo("relative",{top:b-inst.helperProportions.height,left:0}).top;}if(ls){ui.position.left=inst._convertPositionTo("relative",{top:0,left:l}).left;}if(rs){ui.position.left=inst._convertPositionTo("relative",{top:0,left:r-inst.helperProportions.width}).left;}}if(!inst.snapElements[i].snapping&&(ts||bs||ls||rs||first)){inst.options.snap.snap&&inst.options.snap.snap.call(inst.element,event,$.extend(inst._uiHash(),{snapItem:inst.snapElements[i].item}));}inst.snapElements[i].snapping=ts||bs||ls||rs||first;}}});$.ui.plugin.add("draggable","stack",{start:function start(event,ui,instance){var min,o=instance.options,group=$.makeArray($(o.stack)).sort(function(a,b){return(parseInt($(a).css("zIndex"),10)||0)-(parseInt($(b).css("zIndex"),10)||0);});if(!group.length){return;}min=parseInt($(group[0]).css("zIndex"),10)||0;$(group).each(function(i){$(this).css("zIndex",min+i);});this.css("zIndex",min+group.length);}});$.ui.plugin.add("draggable","zIndex",{start:function start(event,ui,instance){var t=$(ui.helper),o=instance.options;if(t.css("zIndex")){o._zIndex=t.css("zIndex");}t.css("zIndex",o.zIndex);},stop:function stop(event,ui,instance){var o=instance.options;if(o._zIndex){$(ui.helper).css("zIndex",o._zIndex);}}});var widgetsDraggable=$.ui.draggable;/*!
	 * jQuery UI Resizable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Resizable
	//>>group: Interactions
	//>>description: Enables resize functionality for any element.
	//>>docs: http://api.jqueryui.com/resizable/
	//>>demos: http://jqueryui.com/resizable/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/resizable.css
	//>>css.theme: ../../themes/base/theme.css
	$.widget("ui.resizable",$.ui.mouse,{version:"1.12.1",widgetEventPrefix:"resize",options:{alsoResize:false,animate:false,animateDuration:"slow",animateEasing:"swing",aspectRatio:false,autoHide:false,classes:{"ui-resizable-se":"ui-icon ui-icon-gripsmall-diagonal-se"},containment:false,ghost:false,grid:false,handles:"e,s,se",helper:false,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,// See #7960
	zIndex:90,// Callbacks
	resize:null,start:null,stop:null},_num:function _num(value){return parseFloat(value)||0;},_isNumber:function _isNumber(value){return!isNaN(parseFloat(value));},_hasScroll:function _hasScroll(el,a){if($(el).css("overflow")==="hidden"){return false;}var scroll=a&&a==="left"?"scrollLeft":"scrollTop",has=false;if(el[scroll]>0){return true;}// TODO: determine which cases actually cause this to happen
	// if the element doesn't have the scroll set, see if it's possible to
	// set the scroll
	el[scroll]=1;has=el[scroll]>0;el[scroll]=0;return has;},_create:function _create(){var margins,o=this.options,that=this;this._addClass("ui-resizable");$.extend(this,{_aspectRatio:!!o.aspectRatio,aspectRatio:o.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:o.helper||o.ghost||o.animate?o.helper||"ui-resizable-helper":null});// Wrap the element if it cannot hold child nodes
	if(this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)){this.element.wrap($("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")}));this.element=this.element.parent().data("ui-resizable",this.element.resizable("instance"));this.elementIsWrapper=true;margins={marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom"),marginLeft:this.originalElement.css("marginLeft")};this.element.css(margins);this.originalElement.css("margin",0);// support: Safari
	// Prevent Safari textarea resize
	this.originalResizeStyle=this.originalElement.css("resize");this.originalElement.css("resize","none");this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"}));// Support: IE9
	// avoid IE jump (hard set the margin)
	this.originalElement.css(margins);this._proportionallyResize();}this._setupHandles();if(o.autoHide){$(this.element).on("mouseenter",function(){if(o.disabled){return;}that._removeClass("ui-resizable-autohide");that._handles.show();}).on("mouseleave",function(){if(o.disabled){return;}if(!that.resizing){that._addClass("ui-resizable-autohide");that._handles.hide();}});}this._mouseInit();},_destroy:function _destroy(){this._mouseDestroy();var wrapper,_destroy=function _destroy(exp){$(exp).removeData("resizable").removeData("ui-resizable").off(".resizable").find(".ui-resizable-handle").remove();};// TODO: Unwrap at same DOM position
	if(this.elementIsWrapper){_destroy(this.element);wrapper=this.element;this.originalElement.css({position:wrapper.css("position"),width:wrapper.outerWidth(),height:wrapper.outerHeight(),top:wrapper.css("top"),left:wrapper.css("left")}).insertAfter(wrapper);wrapper.remove();}this.originalElement.css("resize",this.originalResizeStyle);_destroy(this.originalElement);return this;},_setOption:function _setOption(key,value){this._super(key,value);switch(key){case"handles":this._removeHandles();this._setupHandles();break;default:break;}},_setupHandles:function _setupHandles(){var o=this.options,handle,i,n,hname,axis,that=this;this.handles=o.handles||(!$(".ui-resizable-handle",this.element).length?"e,s,se":{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"});this._handles=$();if(this.handles.constructor===String){if(this.handles==="all"){this.handles="n,e,s,w,se,sw,ne,nw";}n=this.handles.split(",");this.handles={};for(i=0;i<n.length;i++){handle=$.trim(n[i]);hname="ui-resizable-"+handle;axis=$("<div>");this._addClass(axis,"ui-resizable-handle "+hname);axis.css({zIndex:o.zIndex});this.handles[handle]=".ui-resizable-"+handle;this.element.append(axis);}}this._renderAxis=function(target){var i,axis,padPos,padWrapper;target=target||this.element;for(i in this.handles){if(this.handles[i].constructor===String){this.handles[i]=this.element.children(this.handles[i]).first().show();}else if(this.handles[i].jquery||this.handles[i].nodeType){this.handles[i]=$(this.handles[i]);this._on(this.handles[i],{"mousedown":that._mouseDown});}if(this.elementIsWrapper&&this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)){axis=$(this.handles[i],this.element);padWrapper=/sw|ne|nw|se|n|s/.test(i)?axis.outerHeight():axis.outerWidth();padPos=["padding",/ne|nw|n/.test(i)?"Top":/se|sw|s/.test(i)?"Bottom":/^e$/.test(i)?"Right":"Left"].join("");target.css(padPos,padWrapper);this._proportionallyResize();}this._handles=this._handles.add(this.handles[i]);}};// TODO: make renderAxis a prototype function
	this._renderAxis(this.element);this._handles=this._handles.add(this.element.find(".ui-resizable-handle"));this._handles.disableSelection();this._handles.on("mouseover",function(){if(!that.resizing){if(this.className){axis=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i);}that.axis=axis&&axis[1]?axis[1]:"se";}});if(o.autoHide){this._handles.hide();this._addClass("ui-resizable-autohide");}},_removeHandles:function _removeHandles(){this._handles.remove();},_mouseCapture:function _mouseCapture(event){var i,handle,capture=false;for(i in this.handles){handle=$(this.handles[i])[0];if(handle===event.target||$.contains(handle,event.target)){capture=true;}}return!this.options.disabled&&capture;},_mouseStart:function _mouseStart(event){var curleft,curtop,cursor,o=this.options,el=this.element;this.resizing=true;this._renderProxy();curleft=this._num(this.helper.css("left"));curtop=this._num(this.helper.css("top"));if(o.containment){curleft+=$(o.containment).scrollLeft()||0;curtop+=$(o.containment).scrollTop()||0;}this.offset=this.helper.offset();this.position={left:curleft,top:curtop};this.size=this._helper?{width:this.helper.width(),height:this.helper.height()}:{width:el.width(),height:el.height()};this.originalSize=this._helper?{width:el.outerWidth(),height:el.outerHeight()}:{width:el.width(),height:el.height()};this.sizeDiff={width:el.outerWidth()-el.width(),height:el.outerHeight()-el.height()};this.originalPosition={left:curleft,top:curtop};this.originalMousePosition={left:event.pageX,top:event.pageY};this.aspectRatio=typeof o.aspectRatio==="number"?o.aspectRatio:this.originalSize.width/this.originalSize.height||1;cursor=$(".ui-resizable-"+this.axis).css("cursor");$("body").css("cursor",cursor==="auto"?this.axis+"-resize":cursor);this._addClass("ui-resizable-resizing");this._propagate("start",event);return true;},_mouseDrag:function _mouseDrag(event){var data,props,smp=this.originalMousePosition,a=this.axis,dx=event.pageX-smp.left||0,dy=event.pageY-smp.top||0,trigger=this._change[a];this._updatePrevProperties();if(!trigger){return false;}data=trigger.apply(this,[event,dx,dy]);this._updateVirtualBoundaries(event.shiftKey);if(this._aspectRatio||event.shiftKey){data=this._updateRatio(data,event);}data=this._respectSize(data,event);this._updateCache(data);this._propagate("resize",event);props=this._applyChanges();if(!this._helper&&this._proportionallyResizeElements.length){this._proportionallyResize();}if(!$.isEmptyObject(props)){this._updatePrevProperties();this._trigger("resize",event,this.ui());this._applyChanges();}return false;},_mouseStop:function _mouseStop(event){this.resizing=false;var pr,ista,soffseth,soffsetw,s,left,top,o=this.options,that=this;if(this._helper){pr=this._proportionallyResizeElements;ista=pr.length&&/textarea/i.test(pr[0].nodeName);soffseth=ista&&this._hasScroll(pr[0],"left")?0:that.sizeDiff.height;soffsetw=ista?0:that.sizeDiff.width;s={width:that.helper.width()-soffsetw,height:that.helper.height()-soffseth};left=parseFloat(that.element.css("left"))+(that.position.left-that.originalPosition.left)||null;top=parseFloat(that.element.css("top"))+(that.position.top-that.originalPosition.top)||null;if(!o.animate){this.element.css($.extend(s,{top:top,left:left}));}that.helper.height(that.size.height);that.helper.width(that.size.width);if(this._helper&&!o.animate){this._proportionallyResize();}}$("body").css("cursor","auto");this._removeClass("ui-resizable-resizing");this._propagate("stop",event);if(this._helper){this.helper.remove();}return false;},_updatePrevProperties:function _updatePrevProperties(){this.prevPosition={top:this.position.top,left:this.position.left};this.prevSize={width:this.size.width,height:this.size.height};},_applyChanges:function _applyChanges(){var props={};if(this.position.top!==this.prevPosition.top){props.top=this.position.top+"px";}if(this.position.left!==this.prevPosition.left){props.left=this.position.left+"px";}if(this.size.width!==this.prevSize.width){props.width=this.size.width+"px";}if(this.size.height!==this.prevSize.height){props.height=this.size.height+"px";}this.helper.css(props);return props;},_updateVirtualBoundaries:function _updateVirtualBoundaries(forceAspectRatio){var pMinWidth,pMaxWidth,pMinHeight,pMaxHeight,b,o=this.options;b={minWidth:this._isNumber(o.minWidth)?o.minWidth:0,maxWidth:this._isNumber(o.maxWidth)?o.maxWidth:Infinity,minHeight:this._isNumber(o.minHeight)?o.minHeight:0,maxHeight:this._isNumber(o.maxHeight)?o.maxHeight:Infinity};if(this._aspectRatio||forceAspectRatio){pMinWidth=b.minHeight*this.aspectRatio;pMinHeight=b.minWidth/this.aspectRatio;pMaxWidth=b.maxHeight*this.aspectRatio;pMaxHeight=b.maxWidth/this.aspectRatio;if(pMinWidth>b.minWidth){b.minWidth=pMinWidth;}if(pMinHeight>b.minHeight){b.minHeight=pMinHeight;}if(pMaxWidth<b.maxWidth){b.maxWidth=pMaxWidth;}if(pMaxHeight<b.maxHeight){b.maxHeight=pMaxHeight;}}this._vBoundaries=b;},_updateCache:function _updateCache(data){this.offset=this.helper.offset();if(this._isNumber(data.left)){this.position.left=data.left;}if(this._isNumber(data.top)){this.position.top=data.top;}if(this._isNumber(data.height)){this.size.height=data.height;}if(this._isNumber(data.width)){this.size.width=data.width;}},_updateRatio:function _updateRatio(data){var cpos=this.position,csize=this.size,a=this.axis;if(this._isNumber(data.height)){data.width=data.height*this.aspectRatio;}else if(this._isNumber(data.width)){data.height=data.width/this.aspectRatio;}if(a==="sw"){data.left=cpos.left+(csize.width-data.width);data.top=null;}if(a==="nw"){data.top=cpos.top+(csize.height-data.height);data.left=cpos.left+(csize.width-data.width);}return data;},_respectSize:function _respectSize(data){var o=this._vBoundaries,a=this.axis,ismaxw=this._isNumber(data.width)&&o.maxWidth&&o.maxWidth<data.width,ismaxh=this._isNumber(data.height)&&o.maxHeight&&o.maxHeight<data.height,isminw=this._isNumber(data.width)&&o.minWidth&&o.minWidth>data.width,isminh=this._isNumber(data.height)&&o.minHeight&&o.minHeight>data.height,dw=this.originalPosition.left+this.originalSize.width,dh=this.originalPosition.top+this.originalSize.height,cw=/sw|nw|w/.test(a),ch=/nw|ne|n/.test(a);if(isminw){data.width=o.minWidth;}if(isminh){data.height=o.minHeight;}if(ismaxw){data.width=o.maxWidth;}if(ismaxh){data.height=o.maxHeight;}if(isminw&&cw){data.left=dw-o.minWidth;}if(ismaxw&&cw){data.left=dw-o.maxWidth;}if(isminh&&ch){data.top=dh-o.minHeight;}if(ismaxh&&ch){data.top=dh-o.maxHeight;}// Fixing jump error on top/left - bug #2330
	if(!data.width&&!data.height&&!data.left&&data.top){data.top=null;}else if(!data.width&&!data.height&&!data.top&&data.left){data.left=null;}return data;},_getPaddingPlusBorderDimensions:function _getPaddingPlusBorderDimensions(element){var i=0,widths=[],borders=[element.css("borderTopWidth"),element.css("borderRightWidth"),element.css("borderBottomWidth"),element.css("borderLeftWidth")],paddings=[element.css("paddingTop"),element.css("paddingRight"),element.css("paddingBottom"),element.css("paddingLeft")];for(;i<4;i++){widths[i]=parseFloat(borders[i])||0;widths[i]+=parseFloat(paddings[i])||0;}return{height:widths[0]+widths[2],width:widths[1]+widths[3]};},_proportionallyResize:function _proportionallyResize(){if(!this._proportionallyResizeElements.length){return;}var prel,i=0,element=this.helper||this.element;for(;i<this._proportionallyResizeElements.length;i++){prel=this._proportionallyResizeElements[i];// TODO: Seems like a bug to cache this.outerDimensions
	// considering that we are in a loop.
	if(!this.outerDimensions){this.outerDimensions=this._getPaddingPlusBorderDimensions(prel);}prel.css({height:element.height()-this.outerDimensions.height||0,width:element.width()-this.outerDimensions.width||0});}},_renderProxy:function _renderProxy(){var el=this.element,o=this.options;this.elementOffset=el.offset();if(this._helper){this.helper=this.helper||$("<div style='overflow:hidden;'></div>");this._addClass(this.helper,this._helper);this.helper.css({width:this.element.outerWidth(),height:this.element.outerHeight(),position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++o.zIndex//TODO: Don't modify option
	});this.helper.appendTo("body").disableSelection();}else{this.helper=this.element;}},_change:{e:function e(event,dx){return{width:this.originalSize.width+dx};},w:function w(event,dx){var cs=this.originalSize,sp=this.originalPosition;return{left:sp.left+dx,width:cs.width-dx};},n:function n(event,dx,dy){var cs=this.originalSize,sp=this.originalPosition;return{top:sp.top+dy,height:cs.height-dy};},s:function s(event,dx,dy){return{height:this.originalSize.height+dy};},se:function se(event,dx,dy){return $.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[event,dx,dy]));},sw:function sw(event,dx,dy){return $.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[event,dx,dy]));},ne:function ne(event,dx,dy){return $.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[event,dx,dy]));},nw:function nw(event,dx,dy){return $.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[event,dx,dy]));}},_propagate:function _propagate(n,event){$.ui.plugin.call(this,n,[event,this.ui()]);n!=="resize"&&this._trigger(n,event,this.ui());},plugins:{},ui:function ui(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition};}});/*
	 * Resizable Extensions
	 */$.ui.plugin.add("resizable","animate",{stop:function stop(event){var that=$(this).resizable("instance"),o=that.options,pr=that._proportionallyResizeElements,ista=pr.length&&/textarea/i.test(pr[0].nodeName),soffseth=ista&&that._hasScroll(pr[0],"left")?0:that.sizeDiff.height,soffsetw=ista?0:that.sizeDiff.width,style={width:that.size.width-soffsetw,height:that.size.height-soffseth},left=parseFloat(that.element.css("left"))+(that.position.left-that.originalPosition.left)||null,top=parseFloat(that.element.css("top"))+(that.position.top-that.originalPosition.top)||null;that.element.animate($.extend(style,top&&left?{top:top,left:left}:{}),{duration:o.animateDuration,easing:o.animateEasing,step:function step(){var data={width:parseFloat(that.element.css("width")),height:parseFloat(that.element.css("height")),top:parseFloat(that.element.css("top")),left:parseFloat(that.element.css("left"))};if(pr&&pr.length){$(pr[0]).css({width:data.width,height:data.height});}// Propagating resize, and updating values for each animation step
	that._updateCache(data);that._propagate("resize",event);}});}});$.ui.plugin.add("resizable","containment",{start:function start(){var element,p,co,ch,cw,width,height,that=$(this).resizable("instance"),o=that.options,el=that.element,oc=o.containment,ce=oc instanceof $?oc.get(0):/parent/.test(oc)?el.parent().get(0):oc;if(!ce){return;}that.containerElement=$(ce);if(/document/.test(oc)||oc===document){that.containerOffset={left:0,top:0};that.containerPosition={left:0,top:0};that.parentData={element:$(document),left:0,top:0,width:$(document).width(),height:$(document).height()||document.body.parentNode.scrollHeight};}else{element=$(ce);p=[];$(["Top","Right","Left","Bottom"]).each(function(i,name){p[i]=that._num(element.css("padding"+name));});that.containerOffset=element.offset();that.containerPosition=element.position();that.containerSize={height:element.innerHeight()-p[3],width:element.innerWidth()-p[1]};co=that.containerOffset;ch=that.containerSize.height;cw=that.containerSize.width;width=that._hasScroll(ce,"left")?ce.scrollWidth:cw;height=that._hasScroll(ce)?ce.scrollHeight:ch;that.parentData={element:ce,left:co.left,top:co.top,width:width,height:height};}},resize:function resize(event){var woset,hoset,isParent,isOffsetRelative,that=$(this).resizable("instance"),o=that.options,co=that.containerOffset,cp=that.position,pRatio=that._aspectRatio||event.shiftKey,cop={top:0,left:0},ce=that.containerElement,continueResize=true;if(ce[0]!==document&&/static/.test(ce.css("position"))){cop=co;}if(cp.left<(that._helper?co.left:0)){that.size.width=that.size.width+(that._helper?that.position.left-co.left:that.position.left-cop.left);if(pRatio){that.size.height=that.size.width/that.aspectRatio;continueResize=false;}that.position.left=o.helper?co.left:0;}if(cp.top<(that._helper?co.top:0)){that.size.height=that.size.height+(that._helper?that.position.top-co.top:that.position.top);if(pRatio){that.size.width=that.size.height*that.aspectRatio;continueResize=false;}that.position.top=that._helper?co.top:0;}isParent=that.containerElement.get(0)===that.element.parent().get(0);isOffsetRelative=/relative|absolute/.test(that.containerElement.css("position"));if(isParent&&isOffsetRelative){that.offset.left=that.parentData.left+that.position.left;that.offset.top=that.parentData.top+that.position.top;}else{that.offset.left=that.element.offset().left;that.offset.top=that.element.offset().top;}woset=Math.abs(that.sizeDiff.width+(that._helper?that.offset.left-cop.left:that.offset.left-co.left));hoset=Math.abs(that.sizeDiff.height+(that._helper?that.offset.top-cop.top:that.offset.top-co.top));if(woset+that.size.width>=that.parentData.width){that.size.width=that.parentData.width-woset;if(pRatio){that.size.height=that.size.width/that.aspectRatio;continueResize=false;}}if(hoset+that.size.height>=that.parentData.height){that.size.height=that.parentData.height-hoset;if(pRatio){that.size.width=that.size.height*that.aspectRatio;continueResize=false;}}if(!continueResize){that.position.left=that.prevPosition.left;that.position.top=that.prevPosition.top;that.size.width=that.prevSize.width;that.size.height=that.prevSize.height;}},stop:function stop(){var that=$(this).resizable("instance"),o=that.options,co=that.containerOffset,cop=that.containerPosition,ce=that.containerElement,helper=$(that.helper),ho=helper.offset(),w=helper.outerWidth()-that.sizeDiff.width,h=helper.outerHeight()-that.sizeDiff.height;if(that._helper&&!o.animate&&/relative/.test(ce.css("position"))){$(this).css({left:ho.left-cop.left-co.left,width:w,height:h});}if(that._helper&&!o.animate&&/static/.test(ce.css("position"))){$(this).css({left:ho.left-cop.left-co.left,width:w,height:h});}}});$.ui.plugin.add("resizable","alsoResize",{start:function start(){var that=$(this).resizable("instance"),o=that.options;$(o.alsoResize).each(function(){var el=$(this);el.data("ui-resizable-alsoresize",{width:parseFloat(el.width()),height:parseFloat(el.height()),left:parseFloat(el.css("left")),top:parseFloat(el.css("top"))});});},resize:function resize(event,ui){var that=$(this).resizable("instance"),o=that.options,os=that.originalSize,op=that.originalPosition,delta={height:that.size.height-os.height||0,width:that.size.width-os.width||0,top:that.position.top-op.top||0,left:that.position.left-op.left||0};$(o.alsoResize).each(function(){var el=$(this),start=$(this).data("ui-resizable-alsoresize"),style={},css=el.parents(ui.originalElement[0]).length?["width","height"]:["width","height","top","left"];$.each(css,function(i,prop){var sum=(start[prop]||0)+(delta[prop]||0);if(sum&&sum>=0){style[prop]=sum||null;}});el.css(style);});},stop:function stop(){$(this).removeData("ui-resizable-alsoresize");}});$.ui.plugin.add("resizable","ghost",{start:function start(){var that=$(this).resizable("instance"),cs=that.size;that.ghost=that.originalElement.clone();that.ghost.css({opacity:0.25,display:"block",position:"relative",height:cs.height,width:cs.width,margin:0,left:0,top:0});that._addClass(that.ghost,"ui-resizable-ghost");// DEPRECATED
	// TODO: remove after 1.12
	if($.uiBackCompat!==false&&typeof that.options.ghost==="string"){// Ghost option
	that.ghost.addClass(this.options.ghost);}that.ghost.appendTo(that.helper);},resize:function resize(){var that=$(this).resizable("instance");if(that.ghost){that.ghost.css({position:"relative",height:that.size.height,width:that.size.width});}},stop:function stop(){var that=$(this).resizable("instance");if(that.ghost&&that.helper){that.helper.get(0).removeChild(that.ghost.get(0));}}});$.ui.plugin.add("resizable","grid",{resize:function resize(){var outerDimensions,that=$(this).resizable("instance"),o=that.options,cs=that.size,os=that.originalSize,op=that.originalPosition,a=that.axis,grid=typeof o.grid==="number"?[o.grid,o.grid]:o.grid,gridX=grid[0]||1,gridY=grid[1]||1,ox=Math.round((cs.width-os.width)/gridX)*gridX,oy=Math.round((cs.height-os.height)/gridY)*gridY,newWidth=os.width+ox,newHeight=os.height+oy,isMaxWidth=o.maxWidth&&o.maxWidth<newWidth,isMaxHeight=o.maxHeight&&o.maxHeight<newHeight,isMinWidth=o.minWidth&&o.minWidth>newWidth,isMinHeight=o.minHeight&&o.minHeight>newHeight;o.grid=grid;if(isMinWidth){newWidth+=gridX;}if(isMinHeight){newHeight+=gridY;}if(isMaxWidth){newWidth-=gridX;}if(isMaxHeight){newHeight-=gridY;}if(/^(se|s|e)$/.test(a)){that.size.width=newWidth;that.size.height=newHeight;}else if(/^(ne)$/.test(a)){that.size.width=newWidth;that.size.height=newHeight;that.position.top=op.top-oy;}else if(/^(sw)$/.test(a)){that.size.width=newWidth;that.size.height=newHeight;that.position.left=op.left-ox;}else{if(newHeight-gridY<=0||newWidth-gridX<=0){outerDimensions=that._getPaddingPlusBorderDimensions(this);}if(newHeight-gridY>0){that.size.height=newHeight;that.position.top=op.top-oy;}else{newHeight=gridY-outerDimensions.height;that.size.height=newHeight;that.position.top=op.top+os.height-newHeight;}if(newWidth-gridX>0){that.size.width=newWidth;that.position.left=op.left-ox;}else{newWidth=gridX-outerDimensions.width;that.size.width=newWidth;that.position.left=op.left+os.width-newWidth;}}}});var widgetsResizable=$.ui.resizable;/*!
	 * jQuery UI Dialog 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Dialog
	//>>group: Widgets
	//>>description: Displays customizable dialog windows.
	//>>docs: http://api.jqueryui.com/dialog/
	//>>demos: http://jqueryui.com/dialog/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/dialog.css
	//>>css.theme: ../../themes/base/theme.css
	$.widget("ui.dialog",{version:"1.12.1",options:{appendTo:"body",autoOpen:true,buttons:[],classes:{"ui-dialog":"ui-corner-all","ui-dialog-titlebar":"ui-corner-all"},closeOnEscape:true,closeText:"Close",draggable:true,hide:null,height:"auto",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:false,position:{my:"center",at:"center",of:window,collision:"fit",// Ensure the titlebar is always visible
	using:function using(pos){var topOffset=$(this).css(pos).offset().top;if(topOffset<0){$(this).css("top",pos.top-topOffset);}}},resizable:true,show:null,title:null,width:300,// Callbacks
	beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},sizeRelatedOptions:{buttons:true,height:true,maxHeight:true,maxWidth:true,minHeight:true,minWidth:true,width:true},resizableRelatedOptions:{maxHeight:true,maxWidth:true,minHeight:true,minWidth:true},_create:function _create(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height};this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)};this.originalTitle=this.element.attr("title");if(this.options.title==null&&this.originalTitle!=null){this.options.title=this.originalTitle;}// Dialogs can't be disabled
	if(this.options.disabled){this.options.disabled=false;}this._createWrapper();this.element.show().removeAttr("title").appendTo(this.uiDialog);this._addClass("ui-dialog-content","ui-widget-content");this._createTitlebar();this._createButtonPane();if(this.options.draggable&&$.fn.draggable){this._makeDraggable();}if(this.options.resizable&&$.fn.resizable){this._makeResizable();}this._isOpen=false;this._trackFocus();},_init:function _init(){if(this.options.autoOpen){this.open();}},_appendTo:function _appendTo(){var element=this.options.appendTo;if(element&&(element.jquery||element.nodeType)){return $(element);}return this.document.find(element||"body").eq(0);},_destroy:function _destroy(){var next,originalPosition=this.originalPosition;this._untrackInstance();this._destroyOverlay();this.element.removeUniqueId().css(this.originalCss)// Without detaching first, the following becomes really slow
	.detach();this.uiDialog.remove();if(this.originalTitle){this.element.attr("title",this.originalTitle);}next=originalPosition.parent.children().eq(originalPosition.index);// Don't try to place the dialog next to itself (#8613)
	if(next.length&&next[0]!==this.element[0]){next.before(this.element);}else{originalPosition.parent.append(this.element);}},widget:function widget(){return this.uiDialog;},disable:$.noop,enable:$.noop,close:function close(event){var that=this;if(!this._isOpen||this._trigger("beforeClose",event)===false){return;}this._isOpen=false;this._focusedElement=null;this._destroyOverlay();this._untrackInstance();if(!this.opener.filter(":focusable").trigger("focus").length){// Hiding a focused element doesn't trigger blur in WebKit
	// so in case we have nothing to focus on, explicitly blur the active element
	// https://bugs.webkit.org/show_bug.cgi?id=47182
	$.ui.safeBlur($.ui.safeActiveElement(this.document[0]));}this._hide(this.uiDialog,this.options.hide,function(){that._trigger("close",event);});},isOpen:function isOpen(){return this._isOpen;},moveToTop:function moveToTop(){this._moveToTop();},_moveToTop:function _moveToTop(event,silent){var moved=false,zIndices=this.uiDialog.siblings(".ui-front:visible").map(function(){return+$(this).css("z-index");}).get(),zIndexMax=Math.max.apply(null,zIndices);if(zIndexMax>=+this.uiDialog.css("z-index")){this.uiDialog.css("z-index",zIndexMax+1);moved=true;}if(moved&&!silent){this._trigger("focus",event);}return moved;},open:function open(){var that=this;if(this._isOpen){if(this._moveToTop()){this._focusTabbable();}return;}this._isOpen=true;this.opener=$($.ui.safeActiveElement(this.document[0]));this._size();this._position();this._createOverlay();this._moveToTop(null,true);// Ensure the overlay is moved to the top with the dialog, but only when
	// opening. The overlay shouldn't move after the dialog is open so that
	// modeless dialogs opened after the modal dialog stack properly.
	if(this.overlay){this.overlay.css("z-index",this.uiDialog.css("z-index")-1);}this._show(this.uiDialog,this.options.show,function(){that._focusTabbable();that._trigger("focus");});// Track the dialog immediately upon openening in case a focus event
	// somehow occurs outside of the dialog before an element inside the
	// dialog is focused (#10152)
	this._makeFocusTarget();this._trigger("open");},_focusTabbable:function _focusTabbable(){// Set focus to the first match:
	// 1. An element that was focused previously
	// 2. First element inside the dialog matching [autofocus]
	// 3. Tabbable element inside the content element
	// 4. Tabbable element inside the buttonpane
	// 5. The close button
	// 6. The dialog itself
	var hasFocus=this._focusedElement;if(!hasFocus){hasFocus=this.element.find("[autofocus]");}if(!hasFocus.length){hasFocus=this.element.find(":tabbable");}if(!hasFocus.length){hasFocus=this.uiDialogButtonPane.find(":tabbable");}if(!hasFocus.length){hasFocus=this.uiDialogTitlebarClose.filter(":tabbable");}if(!hasFocus.length){hasFocus=this.uiDialog;}hasFocus.eq(0).trigger("focus");},_keepFocus:function _keepFocus(event){function checkFocus(){var activeElement=$.ui.safeActiveElement(this.document[0]),isActive=this.uiDialog[0]===activeElement||$.contains(this.uiDialog[0],activeElement);if(!isActive){this._focusTabbable();}}event.preventDefault();checkFocus.call(this);// support: IE
	// IE <= 8 doesn't prevent moving focus even with event.preventDefault()
	// so we check again later
	this._delay(checkFocus);},_createWrapper:function _createWrapper(){this.uiDialog=$("<div>").hide().attr({// Setting tabIndex makes the div focusable
	tabIndex:-1,role:"dialog"}).appendTo(this._appendTo());this._addClass(this.uiDialog,"ui-dialog","ui-widget ui-widget-content ui-front");this._on(this.uiDialog,{keydown:function keydown(event){if(this.options.closeOnEscape&&!event.isDefaultPrevented()&&event.keyCode&&event.keyCode===$.ui.keyCode.ESCAPE){event.preventDefault();this.close(event);return;}// Prevent tabbing out of dialogs
	if(event.keyCode!==$.ui.keyCode.TAB||event.isDefaultPrevented()){return;}var tabbables=this.uiDialog.find(":tabbable"),first=tabbables.filter(":first"),last=tabbables.filter(":last");if((event.target===last[0]||event.target===this.uiDialog[0])&&!event.shiftKey){this._delay(function(){first.trigger("focus");});event.preventDefault();}else if((event.target===first[0]||event.target===this.uiDialog[0])&&event.shiftKey){this._delay(function(){last.trigger("focus");});event.preventDefault();}},mousedown:function mousedown(event){if(this._moveToTop(event)){this._focusTabbable();}}});// We assume that any existing aria-describedby attribute means
	// that the dialog content is marked up properly
	// otherwise we brute force the content as the description
	if(!this.element.find("[aria-describedby]").length){this.uiDialog.attr({"aria-describedby":this.element.uniqueId().attr("id")});}},_createTitlebar:function _createTitlebar(){var uiDialogTitle;this.uiDialogTitlebar=$("<div>");this._addClass(this.uiDialogTitlebar,"ui-dialog-titlebar","ui-widget-header ui-helper-clearfix");this._on(this.uiDialogTitlebar,{mousedown:function mousedown(event){// Don't prevent click on close button (#8838)
	// Focusing a dialog that is partially scrolled out of view
	// causes the browser to scroll it into view, preventing the click event
	if(!$(event.target).closest(".ui-dialog-titlebar-close")){// Dialog isn't getting focus when dragging (#8063)
	this.uiDialog.trigger("focus");}}});// Support: IE
	// Use type="button" to prevent enter keypresses in textboxes from closing the
	// dialog in IE (#9312)
	this.uiDialogTitlebarClose=$("<button type='button'></button>").button({label:$("<a>").text(this.options.closeText).html(),icon:"ui-icon-closethick",showLabel:false}).appendTo(this.uiDialogTitlebar);this._addClass(this.uiDialogTitlebarClose,"ui-dialog-titlebar-close");this._on(this.uiDialogTitlebarClose,{click:function click(event){event.preventDefault();this.close(event);}});uiDialogTitle=$("<span>").uniqueId().prependTo(this.uiDialogTitlebar);this._addClass(uiDialogTitle,"ui-dialog-title");this._title(uiDialogTitle);this.uiDialogTitlebar.prependTo(this.uiDialog);this.uiDialog.attr({"aria-labelledby":uiDialogTitle.attr("id")});},_title:function _title(title){if(this.options.title){title.text(this.options.title);}else{title.html("&#160;");}},_createButtonPane:function _createButtonPane(){this.uiDialogButtonPane=$("<div>");this._addClass(this.uiDialogButtonPane,"ui-dialog-buttonpane","ui-widget-content ui-helper-clearfix");this.uiButtonSet=$("<div>").appendTo(this.uiDialogButtonPane);this._addClass(this.uiButtonSet,"ui-dialog-buttonset");this._createButtons();},_createButtons:function _createButtons(){var that=this,buttons=this.options.buttons;// If we already have a button pane, remove it
	this.uiDialogButtonPane.remove();this.uiButtonSet.empty();if($.isEmptyObject(buttons)||$.isArray(buttons)&&!buttons.length){this._removeClass(this.uiDialog,"ui-dialog-buttons");return;}$.each(buttons,function(name,props){var click,buttonOptions;props=$.isFunction(props)?{click:props,text:name}:props;// Default to a non-submitting button
	props=$.extend({type:"button"},props);// Change the context for the click callback to be the main element
	click=props.click;buttonOptions={icon:props.icon,iconPosition:props.iconPosition,showLabel:props.showLabel,// Deprecated options
	icons:props.icons,text:props.text};delete props.click;delete props.icon;delete props.iconPosition;delete props.showLabel;// Deprecated options
	delete props.icons;if(typeof props.text==="boolean"){delete props.text;}$("<button></button>",props).button(buttonOptions).appendTo(that.uiButtonSet).on("click",function(){click.apply(that.element[0],arguments);});});this._addClass(this.uiDialog,"ui-dialog-buttons");this.uiDialogButtonPane.appendTo(this.uiDialog);},_makeDraggable:function _makeDraggable(){var that=this,options=this.options;function filteredUi(ui){return{position:ui.position,offset:ui.offset};}this.uiDialog.draggable({cancel:".ui-dialog-content, .ui-dialog-titlebar-close",handle:".ui-dialog-titlebar",containment:"document",start:function start(event,ui){that._addClass($(this),"ui-dialog-dragging");that._blockFrames();that._trigger("dragStart",event,filteredUi(ui));},drag:function drag(event,ui){that._trigger("drag",event,filteredUi(ui));},stop:function stop(event,ui){var left=ui.offset.left-that.document.scrollLeft(),top=ui.offset.top-that.document.scrollTop();options.position={my:"left top",at:"left"+(left>=0?"+":"")+left+" "+"top"+(top>=0?"+":"")+top,of:that.window};that._removeClass($(this),"ui-dialog-dragging");that._unblockFrames();that._trigger("dragStop",event,filteredUi(ui));}});},_makeResizable:function _makeResizable(){var that=this,options=this.options,handles=options.resizable,// .ui-resizable has position: relative defined in the stylesheet
	// but dialogs have to use absolute or fixed positioning
	position=this.uiDialog.css("position"),resizeHandles=typeof handles==="string"?handles:"n,e,s,w,se,sw,ne,nw";function filteredUi(ui){return{originalPosition:ui.originalPosition,originalSize:ui.originalSize,position:ui.position,size:ui.size};}this.uiDialog.resizable({cancel:".ui-dialog-content",containment:"document",alsoResize:this.element,maxWidth:options.maxWidth,maxHeight:options.maxHeight,minWidth:options.minWidth,minHeight:this._minHeight(),handles:resizeHandles,start:function start(event,ui){that._addClass($(this),"ui-dialog-resizing");that._blockFrames();that._trigger("resizeStart",event,filteredUi(ui));},resize:function resize(event,ui){that._trigger("resize",event,filteredUi(ui));},stop:function stop(event,ui){var offset=that.uiDialog.offset(),left=offset.left-that.document.scrollLeft(),top=offset.top-that.document.scrollTop();options.height=that.uiDialog.height();options.width=that.uiDialog.width();options.position={my:"left top",at:"left"+(left>=0?"+":"")+left+" "+"top"+(top>=0?"+":"")+top,of:that.window};that._removeClass($(this),"ui-dialog-resizing");that._unblockFrames();that._trigger("resizeStop",event,filteredUi(ui));}}).css("position",position);},_trackFocus:function _trackFocus(){this._on(this.widget(),{focusin:function focusin(event){this._makeFocusTarget();this._focusedElement=$(event.target);}});},_makeFocusTarget:function _makeFocusTarget(){this._untrackInstance();this._trackingInstances().unshift(this);},_untrackInstance:function _untrackInstance(){var instances=this._trackingInstances(),exists=$.inArray(this,instances);if(exists!==-1){instances.splice(exists,1);}},_trackingInstances:function _trackingInstances(){var instances=this.document.data("ui-dialog-instances");if(!instances){instances=[];this.document.data("ui-dialog-instances",instances);}return instances;},_minHeight:function _minHeight(){var options=this.options;return options.height==="auto"?options.minHeight:Math.min(options.minHeight,options.height);},_position:function _position(){// Need to show the dialog to get the actual offset in the position plugin
	var isVisible=this.uiDialog.is(":visible");if(!isVisible){this.uiDialog.show();}this.uiDialog.position(this.options.position);if(!isVisible){this.uiDialog.hide();}},_setOptions:function _setOptions(options){var that=this,resize=false,resizableOptions={};$.each(options,function(key,value){that._setOption(key,value);if(key in that.sizeRelatedOptions){resize=true;}if(key in that.resizableRelatedOptions){resizableOptions[key]=value;}});if(resize){this._size();this._position();}if(this.uiDialog.is(":data(ui-resizable)")){this.uiDialog.resizable("option",resizableOptions);}},_setOption:function _setOption(key,value){var isDraggable,isResizable,uiDialog=this.uiDialog;if(key==="disabled"){return;}this._super(key,value);if(key==="appendTo"){this.uiDialog.appendTo(this._appendTo());}if(key==="buttons"){this._createButtons();}if(key==="closeText"){this.uiDialogTitlebarClose.button({// Ensure that we always pass a string
	label:$("<a>").text(""+this.options.closeText).html()});}if(key==="draggable"){isDraggable=uiDialog.is(":data(ui-draggable)");if(isDraggable&&!value){uiDialog.draggable("destroy");}if(!isDraggable&&value){this._makeDraggable();}}if(key==="position"){this._position();}if(key==="resizable"){// currently resizable, becoming non-resizable
	isResizable=uiDialog.is(":data(ui-resizable)");if(isResizable&&!value){uiDialog.resizable("destroy");}// Currently resizable, changing handles
	if(isResizable&&typeof value==="string"){uiDialog.resizable("option","handles",value);}// Currently non-resizable, becoming resizable
	if(!isResizable&&value!==false){this._makeResizable();}}if(key==="title"){this._title(this.uiDialogTitlebar.find(".ui-dialog-title"));}},_size:function _size(){// If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
	// divs will both have width and height set, so we need to reset them
	var nonContentHeight,minContentHeight,maxContentHeight,options=this.options;// Reset content sizing
	this.element.show().css({width:"auto",minHeight:0,maxHeight:"none",height:0});if(options.minWidth>options.width){options.width=options.minWidth;}// Reset wrapper sizing
	// determine the height of all the non-content elements
	nonContentHeight=this.uiDialog.css({height:"auto",width:options.width}).outerHeight();minContentHeight=Math.max(0,options.minHeight-nonContentHeight);maxContentHeight=typeof options.maxHeight==="number"?Math.max(0,options.maxHeight-nonContentHeight):"none";if(options.height==="auto"){this.element.css({minHeight:minContentHeight,maxHeight:maxContentHeight,height:"auto"});}else{this.element.height(Math.max(0,options.height-nonContentHeight));}if(this.uiDialog.is(":data(ui-resizable)")){this.uiDialog.resizable("option","minHeight",this._minHeight());}},_blockFrames:function _blockFrames(){this.iframeBlocks=this.document.find("iframe").map(function(){var iframe=$(this);return $("<div>").css({position:"absolute",width:iframe.outerWidth(),height:iframe.outerHeight()}).appendTo(iframe.parent()).offset(iframe.offset())[0];});},_unblockFrames:function _unblockFrames(){if(this.iframeBlocks){this.iframeBlocks.remove();delete this.iframeBlocks;}},_allowInteraction:function _allowInteraction(event){if($(event.target).closest(".ui-dialog").length){return true;}// TODO: Remove hack when datepicker implements
	// the .ui-front logic (#8989)
	return!!$(event.target).closest(".ui-datepicker").length;},_createOverlay:function _createOverlay(){if(!this.options.modal){return;}// We use a delay in case the overlay is created from an
	// event that we're going to be cancelling (#2804)
	var isOpening=true;this._delay(function(){isOpening=false;});if(!this.document.data("ui-dialog-overlays")){// Prevent use of anchors and inputs
	// Using _on() for an event handler shared across many instances is
	// safe because the dialogs stack and must be closed in reverse order
	this._on(this.document,{focusin:function focusin(event){if(isOpening){return;}if(!this._allowInteraction(event)){event.preventDefault();this._trackingInstances()[0]._focusTabbable();}}});}this.overlay=$("<div>").appendTo(this._appendTo());this._addClass(this.overlay,null,"ui-widget-overlay ui-front");this._on(this.overlay,{mousedown:"_keepFocus"});this.document.data("ui-dialog-overlays",(this.document.data("ui-dialog-overlays")||0)+1);},_destroyOverlay:function _destroyOverlay(){if(!this.options.modal){return;}if(this.overlay){var overlays=this.document.data("ui-dialog-overlays")-1;if(!overlays){this._off(this.document,"focusin");this.document.removeData("ui-dialog-overlays");}else{this.document.data("ui-dialog-overlays",overlays);}this.overlay.remove();this.overlay=null;}}});// DEPRECATED
	// TODO: switch return back to widget declaration at top of file when this is removed
	if($.uiBackCompat!==false){// Backcompat for dialogClass option
	$.widget("ui.dialog",$.ui.dialog,{options:{dialogClass:""},_createWrapper:function _createWrapper(){this._super();this.uiDialog.addClass(this.options.dialogClass);},_setOption:function _setOption(key,value){if(key==="dialogClass"){this.uiDialog.removeClass(this.options.dialogClass).addClass(value);}this._superApply(arguments);}});}var widgetsDialog=$.ui.dialog;/*!
	 * jQuery UI Droppable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Droppable
	//>>group: Interactions
	//>>description: Enables drop targets for draggable elements.
	//>>docs: http://api.jqueryui.com/droppable/
	//>>demos: http://jqueryui.com/droppable/
	$.widget("ui.droppable",{version:"1.12.1",widgetEventPrefix:"drop",options:{accept:"*",addClasses:true,greedy:false,scope:"default",tolerance:"intersect",// Callbacks
	activate:null,deactivate:null,drop:null,out:null,over:null},_create:function _create(){var proportions,o=this.options,accept=o.accept;this.isover=false;this.isout=true;this.accept=$.isFunction(accept)?accept:function(d){return d.is(accept);};this.proportions=function()/* valueToWrite */{if(arguments.length){// Store the droppable's proportions
	proportions=arguments[0];}else{// Retrieve or derive the droppable's proportions
	return proportions?proportions:proportions={width:this.element[0].offsetWidth,height:this.element[0].offsetHeight};}};this._addToManager(o.scope);o.addClasses&&this._addClass("ui-droppable");},_addToManager:function _addToManager(scope){// Add the reference and positions to the manager
	$.ui.ddmanager.droppables[scope]=$.ui.ddmanager.droppables[scope]||[];$.ui.ddmanager.droppables[scope].push(this);},_splice:function _splice(drop){var i=0;for(;i<drop.length;i++){if(drop[i]===this){drop.splice(i,1);}}},_destroy:function _destroy(){var drop=$.ui.ddmanager.droppables[this.options.scope];this._splice(drop);},_setOption:function _setOption(key,value){if(key==="accept"){this.accept=$.isFunction(value)?value:function(d){return d.is(value);};}else if(key==="scope"){var drop=$.ui.ddmanager.droppables[this.options.scope];this._splice(drop);this._addToManager(value);}this._super(key,value);},_activate:function _activate(event){var draggable=$.ui.ddmanager.current;this._addActiveClass();if(draggable){this._trigger("activate",event,this.ui(draggable));}},_deactivate:function _deactivate(event){var draggable=$.ui.ddmanager.current;this._removeActiveClass();if(draggable){this._trigger("deactivate",event,this.ui(draggable));}},_over:function _over(event){var draggable=$.ui.ddmanager.current;// Bail if draggable and droppable are same element
	if(!draggable||(draggable.currentItem||draggable.element)[0]===this.element[0]){return;}if(this.accept.call(this.element[0],draggable.currentItem||draggable.element)){this._addHoverClass();this._trigger("over",event,this.ui(draggable));}},_out:function _out(event){var draggable=$.ui.ddmanager.current;// Bail if draggable and droppable are same element
	if(!draggable||(draggable.currentItem||draggable.element)[0]===this.element[0]){return;}if(this.accept.call(this.element[0],draggable.currentItem||draggable.element)){this._removeHoverClass();this._trigger("out",event,this.ui(draggable));}},_drop:function _drop(event,custom){var draggable=custom||$.ui.ddmanager.current,childrenIntersection=false;// Bail if draggable and droppable are same element
	if(!draggable||(draggable.currentItem||draggable.element)[0]===this.element[0]){return false;}this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function(){var inst=$(this).droppable("instance");if(inst.options.greedy&&!inst.options.disabled&&inst.options.scope===draggable.options.scope&&inst.accept.call(inst.element[0],draggable.currentItem||draggable.element)&&intersect(draggable,$.extend(inst,{offset:inst.element.offset()}),inst.options.tolerance,event)){childrenIntersection=true;return false;}});if(childrenIntersection){return false;}if(this.accept.call(this.element[0],draggable.currentItem||draggable.element)){this._removeActiveClass();this._removeHoverClass();this._trigger("drop",event,this.ui(draggable));return this.element;}return false;},ui:function ui(c){return{draggable:c.currentItem||c.element,helper:c.helper,position:c.position,offset:c.positionAbs};},// Extension points just to make backcompat sane and avoid duplicating logic
	// TODO: Remove in 1.13 along with call to it below
	_addHoverClass:function _addHoverClass(){this._addClass("ui-droppable-hover");},_removeHoverClass:function _removeHoverClass(){this._removeClass("ui-droppable-hover");},_addActiveClass:function _addActiveClass(){this._addClass("ui-droppable-active");},_removeActiveClass:function _removeActiveClass(){this._removeClass("ui-droppable-active");}});var intersect=$.ui.intersect=function(){function isOverAxis(x,reference,size){return x>=reference&&x<reference+size;}return function(draggable,droppable,toleranceMode,event){if(!droppable.offset){return false;}var x1=(draggable.positionAbs||draggable.position.absolute).left+draggable.margins.left,y1=(draggable.positionAbs||draggable.position.absolute).top+draggable.margins.top,x2=x1+draggable.helperProportions.width,y2=y1+draggable.helperProportions.height,l=droppable.offset.left,t=droppable.offset.top,r=l+droppable.proportions().width,b=t+droppable.proportions().height;switch(toleranceMode){case"fit":return l<=x1&&x2<=r&&t<=y1&&y2<=b;case"intersect":return l<x1+draggable.helperProportions.width/2&&// Right Half
	x2-draggable.helperProportions.width/2<r&&// Left Half
	t<y1+draggable.helperProportions.height/2&&// Bottom Half
	y2-draggable.helperProportions.height/2<b;// Top Half
	case"pointer":return isOverAxis(event.pageY,t,droppable.proportions().height)&&isOverAxis(event.pageX,l,droppable.proportions().width);case"touch":return(y1>=t&&y1<=b||// Top edge touching
	y2>=t&&y2<=b||// Bottom edge touching
	y1<t&&y2>b// Surrounded vertically
	)&&(x1>=l&&x1<=r||// Left edge touching
	x2>=l&&x2<=r||// Right edge touching
	x1<l&&x2>r// Surrounded horizontally
	);default:return false;}};}();/*
		This manager tracks offsets of draggables and droppables
	*/$.ui.ddmanager={current:null,droppables:{"default":[]},prepareOffsets:function prepareOffsets(t,event){var i,j,m=$.ui.ddmanager.droppables[t.options.scope]||[],type=event?event.type:null,// workaround for #2317
	list=(t.currentItem||t.element).find(":data(ui-droppable)").addBack();droppablesLoop:for(i=0;i<m.length;i++){// No disabled and non-accepted
	if(m[i].options.disabled||t&&!m[i].accept.call(m[i].element[0],t.currentItem||t.element)){continue;}// Filter out elements in the current dragged item
	for(j=0;j<list.length;j++){if(list[j]===m[i].element[0]){m[i].proportions().height=0;continue droppablesLoop;}}m[i].visible=m[i].element.css("display")!=="none";if(!m[i].visible){continue;}// Activate the droppable if used directly from draggables
	if(type==="mousedown"){m[i]._activate.call(m[i],event);}m[i].offset=m[i].element.offset();m[i].proportions({width:m[i].element[0].offsetWidth,height:m[i].element[0].offsetHeight});}},drop:function drop(draggable,event){var dropped=false;// Create a copy of the droppables in case the list changes during the drop (#9116)
	$.each(($.ui.ddmanager.droppables[draggable.options.scope]||[]).slice(),function(){if(!this.options){return;}if(!this.options.disabled&&this.visible&&intersect(draggable,this,this.options.tolerance,event)){dropped=this._drop.call(this,event)||dropped;}if(!this.options.disabled&&this.visible&&this.accept.call(this.element[0],draggable.currentItem||draggable.element)){this.isout=true;this.isover=false;this._deactivate.call(this,event);}});return dropped;},dragStart:function dragStart(draggable,event){// Listen for scrolling so that if the dragging causes scrolling the position of the
	// droppables can be recalculated (see #5003)
	draggable.element.parentsUntil("body").on("scroll.droppable",function(){if(!draggable.options.refreshPositions){$.ui.ddmanager.prepareOffsets(draggable,event);}});},drag:function drag(draggable,event){// If you have a highly dynamic page, you might try this option. It renders positions
	// every time you move the mouse.
	if(draggable.options.refreshPositions){$.ui.ddmanager.prepareOffsets(draggable,event);}// Run through all droppables and check their positions based on specific tolerance options
	$.each($.ui.ddmanager.droppables[draggable.options.scope]||[],function(){if(this.options.disabled||this.greedyChild||!this.visible){return;}var parentInstance,scope,parent,intersects=intersect(draggable,this,this.options.tolerance,event),c=!intersects&&this.isover?"isout":intersects&&!this.isover?"isover":null;if(!c){return;}if(this.options.greedy){// find droppable parents with same scope
	scope=this.options.scope;parent=this.element.parents(":data(ui-droppable)").filter(function(){return $(this).droppable("instance").options.scope===scope;});if(parent.length){parentInstance=$(parent[0]).droppable("instance");parentInstance.greedyChild=c==="isover";}}// We just moved into a greedy child
	if(parentInstance&&c==="isover"){parentInstance.isover=false;parentInstance.isout=true;parentInstance._out.call(parentInstance,event);}this[c]=true;this[c==="isout"?"isover":"isout"]=false;this[c==="isover"?"_over":"_out"].call(this,event);// We just moved out of a greedy child
	if(parentInstance&&c==="isout"){parentInstance.isout=false;parentInstance.isover=true;parentInstance._over.call(parentInstance,event);}});},dragStop:function dragStop(draggable,event){draggable.element.parentsUntil("body").off("scroll.droppable");// Call prepareOffsets one final time since IE does not fire return scroll events when
	// overflow was caused by drag (see #5003)
	if(!draggable.options.refreshPositions){$.ui.ddmanager.prepareOffsets(draggable,event);}}};// DEPRECATED
	// TODO: switch return back to widget declaration at top of file when this is removed
	if($.uiBackCompat!==false){// Backcompat for activeClass and hoverClass options
	$.widget("ui.droppable",$.ui.droppable,{options:{hoverClass:false,activeClass:false},_addActiveClass:function _addActiveClass(){this._super();if(this.options.activeClass){this.element.addClass(this.options.activeClass);}},_removeActiveClass:function _removeActiveClass(){this._super();if(this.options.activeClass){this.element.removeClass(this.options.activeClass);}},_addHoverClass:function _addHoverClass(){this._super();if(this.options.hoverClass){this.element.addClass(this.options.hoverClass);}},_removeHoverClass:function _removeHoverClass(){this._super();if(this.options.hoverClass){this.element.removeClass(this.options.hoverClass);}}});}var widgetsDroppable=$.ui.droppable;/*!
	 * jQuery UI Progressbar 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Progressbar
	//>>group: Widgets
	// jscs:disable maximumLineLength
	//>>description: Displays a status indicator for loading state, standard percentage, and other progress indicators.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/progressbar/
	//>>demos: http://jqueryui.com/progressbar/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/progressbar.css
	//>>css.theme: ../../themes/base/theme.css
	var widgetsProgressbar=$.widget("ui.progressbar",{version:"1.12.1",options:{classes:{"ui-progressbar":"ui-corner-all","ui-progressbar-value":"ui-corner-left","ui-progressbar-complete":"ui-corner-right"},max:100,value:0,change:null,complete:null},min:0,_create:function _create(){// Constrain initial value
	this.oldValue=this.options.value=this._constrainedValue();this.element.attr({// Only set static values; aria-valuenow and aria-valuemax are
	// set inside _refreshValue()
	role:"progressbar","aria-valuemin":this.min});this._addClass("ui-progressbar","ui-widget ui-widget-content");this.valueDiv=$("<div>").appendTo(this.element);this._addClass(this.valueDiv,"ui-progressbar-value","ui-widget-header");this._refreshValue();},_destroy:function _destroy(){this.element.removeAttr("role aria-valuemin aria-valuemax aria-valuenow");this.valueDiv.remove();},value:function value(newValue){if(newValue===undefined){return this.options.value;}this.options.value=this._constrainedValue(newValue);this._refreshValue();},_constrainedValue:function _constrainedValue(newValue){if(newValue===undefined){newValue=this.options.value;}this.indeterminate=newValue===false;// Sanitize value
	if(typeof newValue!=="number"){newValue=0;}return this.indeterminate?false:Math.min(this.options.max,Math.max(this.min,newValue));},_setOptions:function _setOptions(options){// Ensure "value" option is set after other values (like max)
	var value=options.value;delete options.value;this._super(options);this.options.value=this._constrainedValue(value);this._refreshValue();},_setOption:function _setOption(key,value){if(key==="max"){// Don't allow a max less than min
	value=Math.max(this.min,value);}this._super(key,value);},_setOptionDisabled:function _setOptionDisabled(value){this._super(value);this.element.attr("aria-disabled",value);this._toggleClass(null,"ui-state-disabled",!!value);},_percentage:function _percentage(){return this.indeterminate?100:100*(this.options.value-this.min)/(this.options.max-this.min);},_refreshValue:function _refreshValue(){var value=this.options.value,percentage=this._percentage();this.valueDiv.toggle(this.indeterminate||value>this.min).width(percentage.toFixed(0)+"%");this._toggleClass(this.valueDiv,"ui-progressbar-complete",null,value===this.options.max)._toggleClass("ui-progressbar-indeterminate",null,this.indeterminate);if(this.indeterminate){this.element.removeAttr("aria-valuenow");if(!this.overlayDiv){this.overlayDiv=$("<div>").appendTo(this.valueDiv);this._addClass(this.overlayDiv,"ui-progressbar-overlay");}}else{this.element.attr({"aria-valuemax":this.options.max,"aria-valuenow":value});if(this.overlayDiv){this.overlayDiv.remove();this.overlayDiv=null;}}if(this.oldValue!==value){this.oldValue=value;this._trigger("change");}if(value===this.options.max){this._trigger("complete");}}});/*!
	 * jQuery UI Selectable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Selectable
	//>>group: Interactions
	//>>description: Allows groups of elements to be selected with the mouse.
	//>>docs: http://api.jqueryui.com/selectable/
	//>>demos: http://jqueryui.com/selectable/
	//>>css.structure: ../../themes/base/selectable.css
	var widgetsSelectable=$.widget("ui.selectable",$.ui.mouse,{version:"1.12.1",options:{appendTo:"body",autoRefresh:true,distance:0,filter:"*",tolerance:"touch",// Callbacks
	selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function _create(){var that=this;this._addClass("ui-selectable");this.dragged=false;// Cache selectee children based on filter
	this.refresh=function(){that.elementPos=$(that.element[0]).offset();that.selectees=$(that.options.filter,that.element[0]);that._addClass(that.selectees,"ui-selectee");that.selectees.each(function(){var $this=$(this),selecteeOffset=$this.offset(),pos={left:selecteeOffset.left-that.elementPos.left,top:selecteeOffset.top-that.elementPos.top};$.data(this,"selectable-item",{element:this,$element:$this,left:pos.left,top:pos.top,right:pos.left+$this.outerWidth(),bottom:pos.top+$this.outerHeight(),startselected:false,selected:$this.hasClass("ui-selected"),selecting:$this.hasClass("ui-selecting"),unselecting:$this.hasClass("ui-unselecting")});});};this.refresh();this._mouseInit();this.helper=$("<div>");this._addClass(this.helper,"ui-selectable-helper");},_destroy:function _destroy(){this.selectees.removeData("selectable-item");this._mouseDestroy();},_mouseStart:function _mouseStart(event){var that=this,options=this.options;this.opos=[event.pageX,event.pageY];this.elementPos=$(this.element[0]).offset();if(this.options.disabled){return;}this.selectees=$(options.filter,this.element[0]);this._trigger("start",event);$(options.appendTo).append(this.helper);// position helper (lasso)
	this.helper.css({"left":event.pageX,"top":event.pageY,"width":0,"height":0});if(options.autoRefresh){this.refresh();}this.selectees.filter(".ui-selected").each(function(){var selectee=$.data(this,"selectable-item");selectee.startselected=true;if(!event.metaKey&&!event.ctrlKey){that._removeClass(selectee.$element,"ui-selected");selectee.selected=false;that._addClass(selectee.$element,"ui-unselecting");selectee.unselecting=true;// selectable UNSELECTING callback
	that._trigger("unselecting",event,{unselecting:selectee.element});}});$(event.target).parents().addBack().each(function(){var doSelect,selectee=$.data(this,"selectable-item");if(selectee){doSelect=!event.metaKey&&!event.ctrlKey||!selectee.$element.hasClass("ui-selected");that._removeClass(selectee.$element,doSelect?"ui-unselecting":"ui-selected")._addClass(selectee.$element,doSelect?"ui-selecting":"ui-unselecting");selectee.unselecting=!doSelect;selectee.selecting=doSelect;selectee.selected=doSelect;// selectable (UN)SELECTING callback
	if(doSelect){that._trigger("selecting",event,{selecting:selectee.element});}else{that._trigger("unselecting",event,{unselecting:selectee.element});}return false;}});},_mouseDrag:function _mouseDrag(event){this.dragged=true;if(this.options.disabled){return;}var tmp,that=this,options=this.options,x1=this.opos[0],y1=this.opos[1],x2=event.pageX,y2=event.pageY;if(x1>x2){tmp=x2;x2=x1;x1=tmp;}if(y1>y2){tmp=y2;y2=y1;y1=tmp;}this.helper.css({left:x1,top:y1,width:x2-x1,height:y2-y1});this.selectees.each(function(){var selectee=$.data(this,"selectable-item"),hit=false,offset={};//prevent helper from being selected if appendTo: selectable
	if(!selectee||selectee.element===that.element[0]){return;}offset.left=selectee.left+that.elementPos.left;offset.right=selectee.right+that.elementPos.left;offset.top=selectee.top+that.elementPos.top;offset.bottom=selectee.bottom+that.elementPos.top;if(options.tolerance==="touch"){hit=!(offset.left>x2||offset.right<x1||offset.top>y2||offset.bottom<y1);}else if(options.tolerance==="fit"){hit=offset.left>x1&&offset.right<x2&&offset.top>y1&&offset.bottom<y2;}if(hit){// SELECT
	if(selectee.selected){that._removeClass(selectee.$element,"ui-selected");selectee.selected=false;}if(selectee.unselecting){that._removeClass(selectee.$element,"ui-unselecting");selectee.unselecting=false;}if(!selectee.selecting){that._addClass(selectee.$element,"ui-selecting");selectee.selecting=true;// selectable SELECTING callback
	that._trigger("selecting",event,{selecting:selectee.element});}}else{// UNSELECT
	if(selectee.selecting){if((event.metaKey||event.ctrlKey)&&selectee.startselected){that._removeClass(selectee.$element,"ui-selecting");selectee.selecting=false;that._addClass(selectee.$element,"ui-selected");selectee.selected=true;}else{that._removeClass(selectee.$element,"ui-selecting");selectee.selecting=false;if(selectee.startselected){that._addClass(selectee.$element,"ui-unselecting");selectee.unselecting=true;}// selectable UNSELECTING callback
	that._trigger("unselecting",event,{unselecting:selectee.element});}}if(selectee.selected){if(!event.metaKey&&!event.ctrlKey&&!selectee.startselected){that._removeClass(selectee.$element,"ui-selected");selectee.selected=false;that._addClass(selectee.$element,"ui-unselecting");selectee.unselecting=true;// selectable UNSELECTING callback
	that._trigger("unselecting",event,{unselecting:selectee.element});}}}});return false;},_mouseStop:function _mouseStop(event){var that=this;this.dragged=false;$(".ui-unselecting",this.element[0]).each(function(){var selectee=$.data(this,"selectable-item");that._removeClass(selectee.$element,"ui-unselecting");selectee.unselecting=false;selectee.startselected=false;that._trigger("unselected",event,{unselected:selectee.element});});$(".ui-selecting",this.element[0]).each(function(){var selectee=$.data(this,"selectable-item");that._removeClass(selectee.$element,"ui-selecting")._addClass(selectee.$element,"ui-selected");selectee.selecting=false;selectee.selected=true;selectee.startselected=true;that._trigger("selected",event,{selected:selectee.element});});this._trigger("stop",event);this.helper.remove();return false;}});/*!
	 * jQuery UI Selectmenu 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Selectmenu
	//>>group: Widgets
	// jscs:disable maximumLineLength
	//>>description: Duplicates and extends the functionality of a native HTML select element, allowing it to be customizable in behavior and appearance far beyond the limitations of a native select.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/selectmenu/
	//>>demos: http://jqueryui.com/selectmenu/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/selectmenu.css, ../../themes/base/button.css
	//>>css.theme: ../../themes/base/theme.css
	var widgetsSelectmenu=$.widget("ui.selectmenu",[$.ui.formResetMixin,{version:"1.12.1",defaultElement:"<select>",options:{appendTo:null,classes:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"},disabled:null,icons:{button:"ui-icon-triangle-1-s"},position:{my:"left top",at:"left bottom",collision:"none"},width:false,// Callbacks
	change:null,close:null,focus:null,open:null,select:null},_create:function _create(){var selectmenuId=this.element.uniqueId().attr("id");this.ids={element:selectmenuId,button:selectmenuId+"-button",menu:selectmenuId+"-menu"};this._drawButton();this._drawMenu();this._bindFormResetHandler();this._rendered=false;this.menuItems=$();},_drawButton:function _drawButton(){var icon,that=this,item=this._parseOption(this.element.find("option:selected"),this.element[0].selectedIndex);// Associate existing label with the new button
	this.labels=this.element.labels().attr("for",this.ids.button);this._on(this.labels,{click:function click(event){this.button.focus();event.preventDefault();}});// Hide original select element
	this.element.hide();// Create button
	this.button=$("<span>",{tabindex:this.options.disabled?-1:0,id:this.ids.button,role:"combobox","aria-expanded":"false","aria-autocomplete":"list","aria-owns":this.ids.menu,"aria-haspopup":"true",title:this.element.attr("title")}).insertAfter(this.element);this._addClass(this.button,"ui-selectmenu-button ui-selectmenu-button-closed","ui-button ui-widget");icon=$("<span>").appendTo(this.button);this._addClass(icon,"ui-selectmenu-icon","ui-icon "+this.options.icons.button);this.buttonItem=this._renderButtonItem(item).appendTo(this.button);if(this.options.width!==false){this._resizeButton();}this._on(this.button,this._buttonEvents);this.button.one("focusin",function(){// Delay rendering the menu items until the button receives focus.
	// The menu may have already been rendered via a programmatic open.
	if(!that._rendered){that._refreshMenu();}});},_drawMenu:function _drawMenu(){var that=this;// Create menu
	this.menu=$("<ul>",{"aria-hidden":"true","aria-labelledby":this.ids.button,id:this.ids.menu});// Wrap menu
	this.menuWrap=$("<div>").append(this.menu);this._addClass(this.menuWrap,"ui-selectmenu-menu","ui-front");this.menuWrap.appendTo(this._appendTo());// Initialize menu widget
	this.menuInstance=this.menu.menu({classes:{"ui-menu":"ui-corner-bottom"},role:"listbox",select:function select(event,ui){event.preventDefault();// Support: IE8
	// If the item was selected via a click, the text selection
	// will be destroyed in IE
	that._setSelection();that._select(ui.item.data("ui-selectmenu-item"),event);},focus:function focus(event,ui){var item=ui.item.data("ui-selectmenu-item");// Prevent inital focus from firing and check if its a newly focused item
	if(that.focusIndex!=null&&item.index!==that.focusIndex){that._trigger("focus",event,{item:item});if(!that.isOpen){that._select(item,event);}}that.focusIndex=item.index;that.button.attr("aria-activedescendant",that.menuItems.eq(item.index).attr("id"));}}).menu("instance");// Don't close the menu on mouseleave
	this.menuInstance._off(this.menu,"mouseleave");// Cancel the menu's collapseAll on document click
	this.menuInstance._closeOnDocumentClick=function(){return false;};// Selects often contain empty items, but never contain dividers
	this.menuInstance._isDivider=function(){return false;};},refresh:function refresh(){this._refreshMenu();this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(// Fall back to an empty object in case there are no options
	this._getSelectedItem().data("ui-selectmenu-item")||{}));if(this.options.width===null){this._resizeButton();}},_refreshMenu:function _refreshMenu(){var item,options=this.element.find("option");this.menu.empty();this._parseOptions(options);this._renderMenu(this.menu,this.items);this.menuInstance.refresh();this.menuItems=this.menu.find("li").not(".ui-selectmenu-optgroup").find(".ui-menu-item-wrapper");this._rendered=true;if(!options.length){return;}item=this._getSelectedItem();// Update the menu to have the correct item focused
	this.menuInstance.focus(null,item);this._setAria(item.data("ui-selectmenu-item"));// Set disabled state
	this._setOption("disabled",this.element.prop("disabled"));},open:function open(event){if(this.options.disabled){return;}// If this is the first time the menu is being opened, render the items
	if(!this._rendered){this._refreshMenu();}else{// Menu clears focus on close, reset focus to selected item
	this._removeClass(this.menu.find(".ui-state-active"),null,"ui-state-active");this.menuInstance.focus(null,this._getSelectedItem());}// If there are no options, don't open the menu
	if(!this.menuItems.length){return;}this.isOpen=true;this._toggleAttr();this._resizeMenu();this._position();this._on(this.document,this._documentClick);this._trigger("open",event);},_position:function _position(){this.menuWrap.position($.extend({of:this.button},this.options.position));},close:function close(event){if(!this.isOpen){return;}this.isOpen=false;this._toggleAttr();this.range=null;this._off(this.document);this._trigger("close",event);},widget:function widget(){return this.button;},menuWidget:function menuWidget(){return this.menu;},_renderButtonItem:function _renderButtonItem(item){var buttonItem=$("<span>");this._setText(buttonItem,item.label);this._addClass(buttonItem,"ui-selectmenu-text");return buttonItem;},_renderMenu:function _renderMenu(ul,items){var that=this,currentOptgroup="";$.each(items,function(index,item){var li;if(item.optgroup!==currentOptgroup){li=$("<li>",{text:item.optgroup});that._addClass(li,"ui-selectmenu-optgroup","ui-menu-divider"+(item.element.parent("optgroup").prop("disabled")?" ui-state-disabled":""));li.appendTo(ul);currentOptgroup=item.optgroup;}that._renderItemData(ul,item);});},_renderItemData:function _renderItemData(ul,item){return this._renderItem(ul,item).data("ui-selectmenu-item",item);},_renderItem:function _renderItem(ul,item){var li=$("<li>"),wrapper=$("<div>",{title:item.element.attr("title")});if(item.disabled){this._addClass(li,null,"ui-state-disabled");}this._setText(wrapper,item.label);return li.append(wrapper).appendTo(ul);},_setText:function _setText(element,value){if(value){element.text(value);}else{element.html("&#160;");}},_move:function _move(direction,event){var item,next,filter=".ui-menu-item";if(this.isOpen){item=this.menuItems.eq(this.focusIndex).parent("li");}else{item=this.menuItems.eq(this.element[0].selectedIndex).parent("li");filter+=":not(.ui-state-disabled)";}if(direction==="first"||direction==="last"){next=item[direction==="first"?"prevAll":"nextAll"](filter).eq(-1);}else{next=item[direction+"All"](filter).eq(0);}if(next.length){this.menuInstance.focus(event,next);}},_getSelectedItem:function _getSelectedItem(){return this.menuItems.eq(this.element[0].selectedIndex).parent("li");},_toggle:function _toggle(event){this[this.isOpen?"close":"open"](event);},_setSelection:function _setSelection(){var selection;if(!this.range){return;}if(window.getSelection){selection=window.getSelection();selection.removeAllRanges();selection.addRange(this.range);// Support: IE8
	}else{this.range.select();}// Support: IE
	// Setting the text selection kills the button focus in IE, but
	// restoring the focus doesn't kill the selection.
	this.button.focus();},_documentClick:{mousedown:function mousedown(event){if(!this.isOpen){return;}if(!$(event.target).closest(".ui-selectmenu-menu, #"+$.ui.escapeSelector(this.ids.button)).length){this.close(event);}}},_buttonEvents:{// Prevent text selection from being reset when interacting with the selectmenu (#10144)
	mousedown:function mousedown(){var selection;if(window.getSelection){selection=window.getSelection();if(selection.rangeCount){this.range=selection.getRangeAt(0);}// Support: IE8
	}else{this.range=document.selection.createRange();}},click:function click(event){this._setSelection();this._toggle(event);},keydown:function keydown(event){var preventDefault=true;switch(event.keyCode){case $.ui.keyCode.TAB:case $.ui.keyCode.ESCAPE:this.close(event);preventDefault=false;break;case $.ui.keyCode.ENTER:if(this.isOpen){this._selectFocusedItem(event);}break;case $.ui.keyCode.UP:if(event.altKey){this._toggle(event);}else{this._move("prev",event);}break;case $.ui.keyCode.DOWN:if(event.altKey){this._toggle(event);}else{this._move("next",event);}break;case $.ui.keyCode.SPACE:if(this.isOpen){this._selectFocusedItem(event);}else{this._toggle(event);}break;case $.ui.keyCode.LEFT:this._move("prev",event);break;case $.ui.keyCode.RIGHT:this._move("next",event);break;case $.ui.keyCode.HOME:case $.ui.keyCode.PAGE_UP:this._move("first",event);break;case $.ui.keyCode.END:case $.ui.keyCode.PAGE_DOWN:this._move("last",event);break;default:this.menu.trigger(event);preventDefault=false;}if(preventDefault){event.preventDefault();}}},_selectFocusedItem:function _selectFocusedItem(event){var item=this.menuItems.eq(this.focusIndex).parent("li");if(!item.hasClass("ui-state-disabled")){this._select(item.data("ui-selectmenu-item"),event);}},_select:function _select(item,event){var oldIndex=this.element[0].selectedIndex;// Change native select element
	this.element[0].selectedIndex=item.index;this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(item));this._setAria(item);this._trigger("select",event,{item:item});if(item.index!==oldIndex){this._trigger("change",event,{item:item});}this.close(event);},_setAria:function _setAria(item){var id=this.menuItems.eq(item.index).attr("id");this.button.attr({"aria-labelledby":id,"aria-activedescendant":id});this.menu.attr("aria-activedescendant",id);},_setOption:function _setOption(key,value){if(key==="icons"){var icon=this.button.find("span.ui-icon");this._removeClass(icon,null,this.options.icons.button)._addClass(icon,null,value.button);}this._super(key,value);if(key==="appendTo"){this.menuWrap.appendTo(this._appendTo());}if(key==="width"){this._resizeButton();}},_setOptionDisabled:function _setOptionDisabled(value){this._super(value);this.menuInstance.option("disabled",value);this.button.attr("aria-disabled",value);this._toggleClass(this.button,null,"ui-state-disabled",value);this.element.prop("disabled",value);if(value){this.button.attr("tabindex",-1);this.close();}else{this.button.attr("tabindex",0);}},_appendTo:function _appendTo(){var element=this.options.appendTo;if(element){element=element.jquery||element.nodeType?$(element):this.document.find(element).eq(0);}if(!element||!element[0]){element=this.element.closest(".ui-front, dialog");}if(!element.length){element=this.document[0].body;}return element;},_toggleAttr:function _toggleAttr(){this.button.attr("aria-expanded",this.isOpen);// We can't use two _toggleClass() calls here, because we need to make sure
	// we always remove classes first and add them second, otherwise if both classes have the
	// same theme class, it will be removed after we add it.
	this._removeClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"closed":"open"))._addClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"open":"closed"))._toggleClass(this.menuWrap,"ui-selectmenu-open",null,this.isOpen);this.menu.attr("aria-hidden",!this.isOpen);},_resizeButton:function _resizeButton(){var width=this.options.width;// For `width: false`, just remove inline style and stop
	if(width===false){this.button.css("width","");return;}// For `width: null`, match the width of the original element
	if(width===null){width=this.element.show().outerWidth();this.element.hide();}this.button.outerWidth(width);},_resizeMenu:function _resizeMenu(){this.menu.outerWidth(Math.max(this.button.outerWidth(),// Support: IE10
	// IE10 wraps long text (possibly a rounding bug)
	// so we add 1px to avoid the wrapping
	this.menu.width("").outerWidth()+1));},_getCreateOptions:function _getCreateOptions(){var options=this._super();options.disabled=this.element.prop("disabled");return options;},_parseOptions:function _parseOptions(options){var that=this,data=[];options.each(function(index,item){data.push(that._parseOption($(item),index));});this.items=data;},_parseOption:function _parseOption(option,index){var optgroup=option.parent("optgroup");return{element:option,index:index,value:option.val(),label:option.text(),optgroup:optgroup.attr("label")||"",disabled:optgroup.prop("disabled")||option.prop("disabled")};},_destroy:function _destroy(){this._unbindFormResetHandler();this.menuWrap.remove();this.button.remove();this.element.show();this.element.removeUniqueId();this.labels.attr("for",this.ids.element);}}]);/*!
	 * jQuery UI Slider 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Slider
	//>>group: Widgets
	//>>description: Displays a flexible slider with ranges and accessibility via keyboard.
	//>>docs: http://api.jqueryui.com/slider/
	//>>demos: http://jqueryui.com/slider/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/slider.css
	//>>css.theme: ../../themes/base/theme.css
	var widgetsSlider=$.widget("ui.slider",$.ui.mouse,{version:"1.12.1",widgetEventPrefix:"slide",options:{animate:false,classes:{"ui-slider":"ui-corner-all","ui-slider-handle":"ui-corner-all",// Note: ui-widget-header isn't the most fittingly semantic framework class for this
	// element, but worked best visually with a variety of themes
	"ui-slider-range":"ui-corner-all ui-widget-header"},distance:0,max:100,min:0,orientation:"horizontal",range:false,step:1,value:0,values:null,// Callbacks
	change:null,slide:null,start:null,stop:null},// Number of pages in a slider
	// (how many times can you page up/down to go through the whole range)
	numPages:5,_create:function _create(){this._keySliding=false;this._mouseSliding=false;this._animateOff=true;this._handleIndex=null;this._detectOrientation();this._mouseInit();this._calculateNewMax();this._addClass("ui-slider ui-slider-"+this.orientation,"ui-widget ui-widget-content");this._refresh();this._animateOff=false;},_refresh:function _refresh(){this._createRange();this._createHandles();this._setupEvents();this._refreshValue();},_createHandles:function _createHandles(){var i,handleCount,options=this.options,existingHandles=this.element.find(".ui-slider-handle"),handle="<span tabindex='0'></span>",handles=[];handleCount=options.values&&options.values.length||1;if(existingHandles.length>handleCount){existingHandles.slice(handleCount).remove();existingHandles=existingHandles.slice(0,handleCount);}for(i=existingHandles.length;i<handleCount;i++){handles.push(handle);}this.handles=existingHandles.add($(handles.join("")).appendTo(this.element));this._addClass(this.handles,"ui-slider-handle","ui-state-default");this.handle=this.handles.eq(0);this.handles.each(function(i){$(this).data("ui-slider-handle-index",i).attr("tabIndex",0);});},_createRange:function _createRange(){var options=this.options;if(options.range){if(options.range===true){if(!options.values){options.values=[this._valueMin(),this._valueMin()];}else if(options.values.length&&options.values.length!==2){options.values=[options.values[0],options.values[0]];}else if($.isArray(options.values)){options.values=options.values.slice(0);}}if(!this.range||!this.range.length){this.range=$("<div>").appendTo(this.element);this._addClass(this.range,"ui-slider-range");}else{this._removeClass(this.range,"ui-slider-range-min ui-slider-range-max");// Handle range switching from true to min/max
	this.range.css({"left":"","bottom":""});}if(options.range==="min"||options.range==="max"){this._addClass(this.range,"ui-slider-range-"+options.range);}}else{if(this.range){this.range.remove();}this.range=null;}},_setupEvents:function _setupEvents(){this._off(this.handles);this._on(this.handles,this._handleEvents);this._hoverable(this.handles);this._focusable(this.handles);},_destroy:function _destroy(){this.handles.remove();if(this.range){this.range.remove();}this._mouseDestroy();},_mouseCapture:function _mouseCapture(event){var position,normValue,distance,closestHandle,index,allowed,offset,mouseOverHandle,that=this,o=this.options;if(o.disabled){return false;}this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()};this.elementOffset=this.element.offset();position={x:event.pageX,y:event.pageY};normValue=this._normValueFromMouse(position);distance=this._valueMax()-this._valueMin()+1;this.handles.each(function(i){var thisDistance=Math.abs(normValue-that.values(i));if(distance>thisDistance||distance===thisDistance&&(i===that._lastChangedValue||that.values(i)===o.min)){distance=thisDistance;closestHandle=$(this);index=i;}});allowed=this._start(event,index);if(allowed===false){return false;}this._mouseSliding=true;this._handleIndex=index;this._addClass(closestHandle,null,"ui-state-active");closestHandle.trigger("focus");offset=closestHandle.offset();mouseOverHandle=!$(event.target).parents().addBack().is(".ui-slider-handle");this._clickOffset=mouseOverHandle?{left:0,top:0}:{left:event.pageX-offset.left-closestHandle.width()/2,top:event.pageY-offset.top-closestHandle.height()/2-(parseInt(closestHandle.css("borderTopWidth"),10)||0)-(parseInt(closestHandle.css("borderBottomWidth"),10)||0)+(parseInt(closestHandle.css("marginTop"),10)||0)};if(!this.handles.hasClass("ui-state-hover")){this._slide(event,index,normValue);}this._animateOff=true;return true;},_mouseStart:function _mouseStart(){return true;},_mouseDrag:function _mouseDrag(event){var position={x:event.pageX,y:event.pageY},normValue=this._normValueFromMouse(position);this._slide(event,this._handleIndex,normValue);return false;},_mouseStop:function _mouseStop(event){this._removeClass(this.handles,null,"ui-state-active");this._mouseSliding=false;this._stop(event,this._handleIndex);this._change(event,this._handleIndex);this._handleIndex=null;this._clickOffset=null;this._animateOff=false;return false;},_detectOrientation:function _detectOrientation(){this.orientation=this.options.orientation==="vertical"?"vertical":"horizontal";},_normValueFromMouse:function _normValueFromMouse(position){var pixelTotal,pixelMouse,percentMouse,valueTotal,valueMouse;if(this.orientation==="horizontal"){pixelTotal=this.elementSize.width;pixelMouse=position.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0);}else{pixelTotal=this.elementSize.height;pixelMouse=position.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0);}percentMouse=pixelMouse/pixelTotal;if(percentMouse>1){percentMouse=1;}if(percentMouse<0){percentMouse=0;}if(this.orientation==="vertical"){percentMouse=1-percentMouse;}valueTotal=this._valueMax()-this._valueMin();valueMouse=this._valueMin()+percentMouse*valueTotal;return this._trimAlignValue(valueMouse);},_uiHash:function _uiHash(index,value,values){var uiHash={handle:this.handles[index],handleIndex:index,value:value!==undefined?value:this.value()};if(this._hasMultipleValues()){uiHash.value=value!==undefined?value:this.values(index);uiHash.values=values||this.values();}return uiHash;},_hasMultipleValues:function _hasMultipleValues(){return this.options.values&&this.options.values.length;},_start:function _start(event,index){return this._trigger("start",event,this._uiHash(index));},_slide:function _slide(event,index,newVal){var allowed,otherVal,currentValue=this.value(),newValues=this.values();if(this._hasMultipleValues()){otherVal=this.values(index?0:1);currentValue=this.values(index);if(this.options.values.length===2&&this.options.range===true){newVal=index===0?Math.min(otherVal,newVal):Math.max(otherVal,newVal);}newValues[index]=newVal;}if(newVal===currentValue){return;}allowed=this._trigger("slide",event,this._uiHash(index,newVal,newValues));// A slide can be canceled by returning false from the slide callback
	if(allowed===false){return;}if(this._hasMultipleValues()){this.values(index,newVal);}else{this.value(newVal);}},_stop:function _stop(event,index){this._trigger("stop",event,this._uiHash(index));},_change:function _change(event,index){if(!this._keySliding&&!this._mouseSliding){//store the last changed value index for reference when handles overlap
	this._lastChangedValue=index;this._trigger("change",event,this._uiHash(index));}},value:function value(newValue){if(arguments.length){this.options.value=this._trimAlignValue(newValue);this._refreshValue();this._change(null,0);return;}return this._value();},values:function values(index,newValue){var vals,newValues,i;if(arguments.length>1){this.options.values[index]=this._trimAlignValue(newValue);this._refreshValue();this._change(null,index);return;}if(arguments.length){if($.isArray(arguments[0])){vals=this.options.values;newValues=arguments[0];for(i=0;i<vals.length;i+=1){vals[i]=this._trimAlignValue(newValues[i]);this._change(null,i);}this._refreshValue();}else{if(this._hasMultipleValues()){return this._values(index);}else{return this.value();}}}else{return this._values();}},_setOption:function _setOption(key,value){var i,valsLength=0;if(key==="range"&&this.options.range===true){if(value==="min"){this.options.value=this._values(0);this.options.values=null;}else if(value==="max"){this.options.value=this._values(this.options.values.length-1);this.options.values=null;}}if($.isArray(this.options.values)){valsLength=this.options.values.length;}this._super(key,value);switch(key){case"orientation":this._detectOrientation();this._removeClass("ui-slider-horizontal ui-slider-vertical")._addClass("ui-slider-"+this.orientation);this._refreshValue();if(this.options.range){this._refreshRange(value);}// Reset positioning from previous orientation
	this.handles.css(value==="horizontal"?"bottom":"left","");break;case"value":this._animateOff=true;this._refreshValue();this._change(null,0);this._animateOff=false;break;case"values":this._animateOff=true;this._refreshValue();// Start from the last handle to prevent unreachable handles (#9046)
	for(i=valsLength-1;i>=0;i--){this._change(null,i);}this._animateOff=false;break;case"step":case"min":case"max":this._animateOff=true;this._calculateNewMax();this._refreshValue();this._animateOff=false;break;case"range":this._animateOff=true;this._refresh();this._animateOff=false;break;}},_setOptionDisabled:function _setOptionDisabled(value){this._super(value);this._toggleClass(null,"ui-state-disabled",!!value);},//internal value getter
	// _value() returns value trimmed by min and max, aligned by step
	_value:function _value(){var val=this.options.value;val=this._trimAlignValue(val);return val;},//internal values getter
	// _values() returns array of values trimmed by min and max, aligned by step
	// _values( index ) returns single value trimmed by min and max, aligned by step
	_values:function _values(index){var val,vals,i;if(arguments.length){val=this.options.values[index];val=this._trimAlignValue(val);return val;}else if(this._hasMultipleValues()){// .slice() creates a copy of the array
	// this copy gets trimmed by min and max and then returned
	vals=this.options.values.slice();for(i=0;i<vals.length;i+=1){vals[i]=this._trimAlignValue(vals[i]);}return vals;}else{return[];}},// Returns the step-aligned value that val is closest to, between (inclusive) min and max
	_trimAlignValue:function _trimAlignValue(val){if(val<=this._valueMin()){return this._valueMin();}if(val>=this._valueMax()){return this._valueMax();}var step=this.options.step>0?this.options.step:1,valModStep=(val-this._valueMin())%step,alignValue=val-valModStep;if(Math.abs(valModStep)*2>=step){alignValue+=valModStep>0?step:-step;}// Since JavaScript has problems with large floats, round
	// the final value to 5 digits after the decimal point (see #4124)
	return parseFloat(alignValue.toFixed(5));},_calculateNewMax:function _calculateNewMax(){var max=this.options.max,min=this._valueMin(),step=this.options.step,aboveMin=Math.round((max-min)/step)*step;max=aboveMin+min;if(max>this.options.max){//If max is not divisible by step, rounding off may increase its value
	max-=step;}this.max=parseFloat(max.toFixed(this._precision()));},_precision:function _precision(){var precision=this._precisionOf(this.options.step);if(this.options.min!==null){precision=Math.max(precision,this._precisionOf(this.options.min));}return precision;},_precisionOf:function _precisionOf(num){var str=num.toString(),decimal=str.indexOf(".");return decimal===-1?0:str.length-decimal-1;},_valueMin:function _valueMin(){return this.options.min;},_valueMax:function _valueMax(){return this.max;},_refreshRange:function _refreshRange(orientation){if(orientation==="vertical"){this.range.css({"width":"","left":""});}if(orientation==="horizontal"){this.range.css({"height":"","bottom":""});}},_refreshValue:function _refreshValue(){var lastValPercent,valPercent,value,valueMin,valueMax,oRange=this.options.range,o=this.options,that=this,animate=!this._animateOff?o.animate:false,_set={};if(this._hasMultipleValues()){this.handles.each(function(i){valPercent=(that.values(i)-that._valueMin())/(that._valueMax()-that._valueMin())*100;_set[that.orientation==="horizontal"?"left":"bottom"]=valPercent+"%";$(this).stop(1,1)[animate?"animate":"css"](_set,o.animate);if(that.options.range===true){if(that.orientation==="horizontal"){if(i===0){that.range.stop(1,1)[animate?"animate":"css"]({left:valPercent+"%"},o.animate);}if(i===1){that.range[animate?"animate":"css"]({width:valPercent-lastValPercent+"%"},{queue:false,duration:o.animate});}}else{if(i===0){that.range.stop(1,1)[animate?"animate":"css"]({bottom:valPercent+"%"},o.animate);}if(i===1){that.range[animate?"animate":"css"]({height:valPercent-lastValPercent+"%"},{queue:false,duration:o.animate});}}}lastValPercent=valPercent;});}else{value=this.value();valueMin=this._valueMin();valueMax=this._valueMax();valPercent=valueMax!==valueMin?(value-valueMin)/(valueMax-valueMin)*100:0;_set[this.orientation==="horizontal"?"left":"bottom"]=valPercent+"%";this.handle.stop(1,1)[animate?"animate":"css"](_set,o.animate);if(oRange==="min"&&this.orientation==="horizontal"){this.range.stop(1,1)[animate?"animate":"css"]({width:valPercent+"%"},o.animate);}if(oRange==="max"&&this.orientation==="horizontal"){this.range.stop(1,1)[animate?"animate":"css"]({width:100-valPercent+"%"},o.animate);}if(oRange==="min"&&this.orientation==="vertical"){this.range.stop(1,1)[animate?"animate":"css"]({height:valPercent+"%"},o.animate);}if(oRange==="max"&&this.orientation==="vertical"){this.range.stop(1,1)[animate?"animate":"css"]({height:100-valPercent+"%"},o.animate);}}},_handleEvents:{keydown:function keydown(event){var allowed,curVal,newVal,step,index=$(event.target).data("ui-slider-handle-index");switch(event.keyCode){case $.ui.keyCode.HOME:case $.ui.keyCode.END:case $.ui.keyCode.PAGE_UP:case $.ui.keyCode.PAGE_DOWN:case $.ui.keyCode.UP:case $.ui.keyCode.RIGHT:case $.ui.keyCode.DOWN:case $.ui.keyCode.LEFT:event.preventDefault();if(!this._keySliding){this._keySliding=true;this._addClass($(event.target),null,"ui-state-active");allowed=this._start(event,index);if(allowed===false){return;}}break;}step=this.options.step;if(this._hasMultipleValues()){curVal=newVal=this.values(index);}else{curVal=newVal=this.value();}switch(event.keyCode){case $.ui.keyCode.HOME:newVal=this._valueMin();break;case $.ui.keyCode.END:newVal=this._valueMax();break;case $.ui.keyCode.PAGE_UP:newVal=this._trimAlignValue(curVal+(this._valueMax()-this._valueMin())/this.numPages);break;case $.ui.keyCode.PAGE_DOWN:newVal=this._trimAlignValue(curVal-(this._valueMax()-this._valueMin())/this.numPages);break;case $.ui.keyCode.UP:case $.ui.keyCode.RIGHT:if(curVal===this._valueMax()){return;}newVal=this._trimAlignValue(curVal+step);break;case $.ui.keyCode.DOWN:case $.ui.keyCode.LEFT:if(curVal===this._valueMin()){return;}newVal=this._trimAlignValue(curVal-step);break;}this._slide(event,index,newVal);},keyup:function keyup(event){var index=$(event.target).data("ui-slider-handle-index");if(this._keySliding){this._keySliding=false;this._stop(event,index);this._change(event,index);this._removeClass($(event.target),null,"ui-state-active");}}}});/*!
	 * jQuery UI Sortable 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Sortable
	//>>group: Interactions
	//>>description: Enables items in a list to be sorted using the mouse.
	//>>docs: http://api.jqueryui.com/sortable/
	//>>demos: http://jqueryui.com/sortable/
	//>>css.structure: ../../themes/base/sortable.css
	var widgetsSortable=$.widget("ui.sortable",$.ui.mouse,{version:"1.12.1",widgetEventPrefix:"sort",ready:false,options:{appendTo:"parent",axis:false,connectWith:false,containment:false,cursor:"auto",cursorAt:false,dropOnEmpty:true,forcePlaceholderSize:false,forceHelperSize:false,grid:false,handle:false,helper:"original",items:"> *",opacity:false,placeholder:false,revert:false,scroll:true,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1000,// Callbacks
	activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_isOverAxis:function _isOverAxis(x,reference,size){return x>=reference&&x<reference+size;},_isFloating:function _isFloating(item){return /left|right/.test(item.css("float"))||/inline|table-cell/.test(item.css("display"));},_create:function _create(){this.containerCache={};this._addClass("ui-sortable");//Get the items
	this.refresh();//Let's determine the parent's offset
	this.offset=this.element.offset();//Initialize mouse events for interaction
	this._mouseInit();this._setHandleClassName();//We're ready to go
	this.ready=true;},_setOption:function _setOption(key,value){this._super(key,value);if(key==="handle"){this._setHandleClassName();}},_setHandleClassName:function _setHandleClassName(){var that=this;this._removeClass(this.element.find(".ui-sortable-handle"),"ui-sortable-handle");$.each(this.items,function(){that._addClass(this.instance.options.handle?this.item.find(this.instance.options.handle):this.item,"ui-sortable-handle");});},_destroy:function _destroy(){this._mouseDestroy();for(var i=this.items.length-1;i>=0;i--){this.items[i].item.removeData(this.widgetName+"-item");}return this;},_mouseCapture:function _mouseCapture(event,overrideHandle){var currentItem=null,validHandle=false,that=this;if(this.reverting){return false;}if(this.options.disabled||this.options.type==="static"){return false;}//We have to refresh the items data once first
	this._refreshItems(event);//Find out if the clicked node (or one of its parents) is a actual item in this.items
	$(event.target).parents().each(function(){if($.data(this,that.widgetName+"-item")===that){currentItem=$(this);return false;}});if($.data(event.target,that.widgetName+"-item")===that){currentItem=$(event.target);}if(!currentItem){return false;}if(this.options.handle&&!overrideHandle){$(this.options.handle,currentItem).find("*").addBack().each(function(){if(this===event.target){validHandle=true;}});if(!validHandle){return false;}}this.currentItem=currentItem;this._removeCurrentsFromItems();return true;},_mouseStart:function _mouseStart(event,overrideHandle,noActivation){var i,body,o=this.options;this.currentContainer=this;//We only need to call refreshPositions, because the refreshItems call has been moved to
	// mouseCapture
	this.refreshPositions();//Create and append the visible helper
	this.helper=this._createHelper(event);//Cache the helper size
	this._cacheHelperProportions();/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 *///Cache the margins of the original element
	this._cacheMargins();//Get the next scrolling parent
	this.scrollParent=this.helper.scrollParent();//The element's absolute position on the page minus margins
	this.offset=this.currentItem.offset();this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left};$.extend(this.offset,{click:{//Where the click happened, relative to the element
	left:event.pageX-this.offset.left,top:event.pageY-this.offset.top},parent:this._getParentOffset(),// This is a relative to absolute position minus the actual position calculation -
	// only used for relative positioned helper
	relative:this._getRelativeOffset()});// Only after we got the offset, we can change the helper's position to absolute
	// TODO: Still need to figure out a way to make relative sorting possible
	this.helper.css("position","absolute");this.cssPosition=this.helper.css("position");//Generate the original position
	this.originalPosition=this._generatePosition(event);this.originalPageX=event.pageX;this.originalPageY=event.pageY;//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
	o.cursorAt&&this._adjustOffsetFromHelper(o.cursorAt);//Cache the former DOM position
	this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]};// If the helper is not the original, hide the original so it's not playing any role during
	// the drag, won't cause anything bad this way
	if(this.helper[0]!==this.currentItem[0]){this.currentItem.hide();}//Create the placeholder
	this._createPlaceholder();//Set a containment if given in the options
	if(o.containment){this._setContainment();}if(o.cursor&&o.cursor!=="auto"){// cursor option
	body=this.document.find("body");// Support: IE
	this.storedCursor=body.css("cursor");body.css("cursor",o.cursor);this.storedStylesheet=$("<style>*{ cursor: "+o.cursor+" !important; }</style>").appendTo(body);}if(o.opacity){// opacity option
	if(this.helper.css("opacity")){this._storedOpacity=this.helper.css("opacity");}this.helper.css("opacity",o.opacity);}if(o.zIndex){// zIndex option
	if(this.helper.css("zIndex")){this._storedZIndex=this.helper.css("zIndex");}this.helper.css("zIndex",o.zIndex);}//Prepare scrolling
	if(this.scrollParent[0]!==this.document[0]&&this.scrollParent[0].tagName!=="HTML"){this.overflowOffset=this.scrollParent.offset();}//Call callbacks
	this._trigger("start",event,this._uiHash());//Recache the helper size
	if(!this._preserveHelperProportions){this._cacheHelperProportions();}//Post "activate" events to possible containers
	if(!noActivation){for(i=this.containers.length-1;i>=0;i--){this.containers[i]._trigger("activate",event,this._uiHash(this));}}//Prepare possible droppables
	if($.ui.ddmanager){$.ui.ddmanager.current=this;}if($.ui.ddmanager&&!o.dropBehaviour){$.ui.ddmanager.prepareOffsets(this,event);}this.dragging=true;this._addClass(this.helper,"ui-sortable-helper");// Execute the drag once - this causes the helper not to be visiblebefore getting its
	// correct position
	this._mouseDrag(event);return true;},_mouseDrag:function _mouseDrag(event){var i,item,itemElement,intersection,o=this.options,scrolled=false;//Compute the helpers position
	this.position=this._generatePosition(event);this.positionAbs=this._convertPositionTo("absolute");if(!this.lastPositionAbs){this.lastPositionAbs=this.positionAbs;}//Do scrolling
	if(this.options.scroll){if(this.scrollParent[0]!==this.document[0]&&this.scrollParent[0].tagName!=="HTML"){if(this.overflowOffset.top+this.scrollParent[0].offsetHeight-event.pageY<o.scrollSensitivity){this.scrollParent[0].scrollTop=scrolled=this.scrollParent[0].scrollTop+o.scrollSpeed;}else if(event.pageY-this.overflowOffset.top<o.scrollSensitivity){this.scrollParent[0].scrollTop=scrolled=this.scrollParent[0].scrollTop-o.scrollSpeed;}if(this.overflowOffset.left+this.scrollParent[0].offsetWidth-event.pageX<o.scrollSensitivity){this.scrollParent[0].scrollLeft=scrolled=this.scrollParent[0].scrollLeft+o.scrollSpeed;}else if(event.pageX-this.overflowOffset.left<o.scrollSensitivity){this.scrollParent[0].scrollLeft=scrolled=this.scrollParent[0].scrollLeft-o.scrollSpeed;}}else{if(event.pageY-this.document.scrollTop()<o.scrollSensitivity){scrolled=this.document.scrollTop(this.document.scrollTop()-o.scrollSpeed);}else if(this.window.height()-(event.pageY-this.document.scrollTop())<o.scrollSensitivity){scrolled=this.document.scrollTop(this.document.scrollTop()+o.scrollSpeed);}if(event.pageX-this.document.scrollLeft()<o.scrollSensitivity){scrolled=this.document.scrollLeft(this.document.scrollLeft()-o.scrollSpeed);}else if(this.window.width()-(event.pageX-this.document.scrollLeft())<o.scrollSensitivity){scrolled=this.document.scrollLeft(this.document.scrollLeft()+o.scrollSpeed);}}if(scrolled!==false&&$.ui.ddmanager&&!o.dropBehaviour){$.ui.ddmanager.prepareOffsets(this,event);}}//Regenerate the absolute position used for position checks
	this.positionAbs=this._convertPositionTo("absolute");//Set the helper position
	if(!this.options.axis||this.options.axis!=="y"){this.helper[0].style.left=this.position.left+"px";}if(!this.options.axis||this.options.axis!=="x"){this.helper[0].style.top=this.position.top+"px";}//Rearrange
	for(i=this.items.length-1;i>=0;i--){//Cache variables and intersection, continue if no intersection
	item=this.items[i];itemElement=item.item[0];intersection=this._intersectsWithPointer(item);if(!intersection){continue;}// Only put the placeholder inside the current Container, skip all
	// items from other containers. This works because when moving
	// an item from one container to another the
	// currentContainer is switched before the placeholder is moved.
	//
	// Without this, moving items in "sub-sortables" can cause
	// the placeholder to jitter between the outer and inner container.
	if(item.instance!==this.currentContainer){continue;}// Cannot intersect with itself
	// no useless actions that have been done before
	// no action if the item moved is the parent of the item checked
	if(itemElement!==this.currentItem[0]&&this.placeholder[intersection===1?"next":"prev"]()[0]!==itemElement&&!$.contains(this.placeholder[0],itemElement)&&(this.options.type==="semi-dynamic"?!$.contains(this.element[0],itemElement):true)){this.direction=intersection===1?"down":"up";if(this.options.tolerance==="pointer"||this._intersectsWithSides(item)){this._rearrange(event,item);}else{break;}this._trigger("change",event,this._uiHash());break;}}//Post events to containers
	this._contactContainers(event);//Interconnect with droppables
	if($.ui.ddmanager){$.ui.ddmanager.drag(this,event);}//Call callbacks
	this._trigger("sort",event,this._uiHash());this.lastPositionAbs=this.positionAbs;return false;},_mouseStop:function _mouseStop(event,noPropagation){if(!event){return;}//If we are using droppables, inform the manager about the drop
	if($.ui.ddmanager&&!this.options.dropBehaviour){$.ui.ddmanager.drop(this,event);}if(this.options.revert){var that=this,cur=this.placeholder.offset(),axis=this.options.axis,animation={};if(!axis||axis==="x"){animation.left=cur.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollLeft);}if(!axis||axis==="y"){animation.top=cur.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollTop);}this.reverting=true;$(this.helper).animate(animation,parseInt(this.options.revert,10)||500,function(){that._clear(event);});}else{this._clear(event,noPropagation);}return false;},cancel:function cancel(){if(this.dragging){this._mouseUp(new $.Event("mouseup",{target:null}));if(this.options.helper==="original"){this.currentItem.css(this._storedCSS);this._removeClass(this.currentItem,"ui-sortable-helper");}else{this.currentItem.show();}//Post deactivating events to containers
	for(var i=this.containers.length-1;i>=0;i--){this.containers[i]._trigger("deactivate",null,this._uiHash(this));if(this.containers[i].containerCache.over){this.containers[i]._trigger("out",null,this._uiHash(this));this.containers[i].containerCache.over=0;}}}if(this.placeholder){//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
	// it unbinds ALL events from the original node!
	if(this.placeholder[0].parentNode){this.placeholder[0].parentNode.removeChild(this.placeholder[0]);}if(this.options.helper!=="original"&&this.helper&&this.helper[0].parentNode){this.helper.remove();}$.extend(this,{helper:null,dragging:false,reverting:false,_noFinalSort:null});if(this.domPosition.prev){$(this.domPosition.prev).after(this.currentItem);}else{$(this.domPosition.parent).prepend(this.currentItem);}}return this;},serialize:function serialize(o){var items=this._getItemsAsjQuery(o&&o.connected),str=[];o=o||{};$(items).each(function(){var res=($(o.item||this).attr(o.attribute||"id")||"").match(o.expression||/(.+)[\-=_](.+)/);if(res){str.push((o.key||res[1]+"[]")+"="+(o.key&&o.expression?res[1]:res[2]));}});if(!str.length&&o.key){str.push(o.key+"=");}return str.join("&");},toArray:function toArray(o){var items=this._getItemsAsjQuery(o&&o.connected),ret=[];o=o||{};items.each(function(){ret.push($(o.item||this).attr(o.attribute||"id")||"");});return ret;},/* Be careful with the following core functions */_intersectsWith:function _intersectsWith(item){var x1=this.positionAbs.left,x2=x1+this.helperProportions.width,y1=this.positionAbs.top,y2=y1+this.helperProportions.height,l=item.left,r=l+item.width,t=item.top,b=t+item.height,dyClick=this.offset.click.top,dxClick=this.offset.click.left,isOverElementHeight=this.options.axis==="x"||y1+dyClick>t&&y1+dyClick<b,isOverElementWidth=this.options.axis==="y"||x1+dxClick>l&&x1+dxClick<r,isOverElement=isOverElementHeight&&isOverElementWidth;if(this.options.tolerance==="pointer"||this.options.forcePointerForContainers||this.options.tolerance!=="pointer"&&this.helperProportions[this.floating?"width":"height"]>item[this.floating?"width":"height"]){return isOverElement;}else{return l<x1+this.helperProportions.width/2&&// Right Half
	x2-this.helperProportions.width/2<r&&// Left Half
	t<y1+this.helperProportions.height/2&&// Bottom Half
	y2-this.helperProportions.height/2<b;// Top Half
	}},_intersectsWithPointer:function _intersectsWithPointer(item){var verticalDirection,horizontalDirection,isOverElementHeight=this.options.axis==="x"||this._isOverAxis(this.positionAbs.top+this.offset.click.top,item.top,item.height),isOverElementWidth=this.options.axis==="y"||this._isOverAxis(this.positionAbs.left+this.offset.click.left,item.left,item.width),isOverElement=isOverElementHeight&&isOverElementWidth;if(!isOverElement){return false;}verticalDirection=this._getDragVerticalDirection();horizontalDirection=this._getDragHorizontalDirection();return this.floating?horizontalDirection==="right"||verticalDirection==="down"?2:1:verticalDirection&&(verticalDirection==="down"?2:1);},_intersectsWithSides:function _intersectsWithSides(item){var isOverBottomHalf=this._isOverAxis(this.positionAbs.top+this.offset.click.top,item.top+item.height/2,item.height),isOverRightHalf=this._isOverAxis(this.positionAbs.left+this.offset.click.left,item.left+item.width/2,item.width),verticalDirection=this._getDragVerticalDirection(),horizontalDirection=this._getDragHorizontalDirection();if(this.floating&&horizontalDirection){return horizontalDirection==="right"&&isOverRightHalf||horizontalDirection==="left"&&!isOverRightHalf;}else{return verticalDirection&&(verticalDirection==="down"&&isOverBottomHalf||verticalDirection==="up"&&!isOverBottomHalf);}},_getDragVerticalDirection:function _getDragVerticalDirection(){var delta=this.positionAbs.top-this.lastPositionAbs.top;return delta!==0&&(delta>0?"down":"up");},_getDragHorizontalDirection:function _getDragHorizontalDirection(){var delta=this.positionAbs.left-this.lastPositionAbs.left;return delta!==0&&(delta>0?"right":"left");},refresh:function refresh(event){this._refreshItems(event);this._setHandleClassName();this.refreshPositions();return this;},_connectWith:function _connectWith(){var options=this.options;return options.connectWith.constructor===String?[options.connectWith]:options.connectWith;},_getItemsAsjQuery:function _getItemsAsjQuery(connected){var i,j,cur,inst,items=[],queries=[],connectWith=this._connectWith();if(connectWith&&connected){for(i=connectWith.length-1;i>=0;i--){cur=$(connectWith[i],this.document[0]);for(j=cur.length-1;j>=0;j--){inst=$.data(cur[j],this.widgetFullName);if(inst&&inst!==this&&!inst.options.disabled){queries.push([$.isFunction(inst.options.items)?inst.options.items.call(inst.element):$(inst.options.items,inst.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),inst]);}}}}queries.push([$.isFunction(this.options.items)?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):$(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]);function addItems(){items.push(this);}for(i=queries.length-1;i>=0;i--){queries[i][0].each(addItems);}return $(items);},_removeCurrentsFromItems:function _removeCurrentsFromItems(){var list=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=$.grep(this.items,function(item){for(var j=0;j<list.length;j++){if(list[j]===item.item[0]){return false;}}return true;});},_refreshItems:function _refreshItems(event){this.items=[];this.containers=[this];var i,j,cur,inst,targetData,_queries,item,queriesLength,items=this.items,queries=[[$.isFunction(this.options.items)?this.options.items.call(this.element[0],event,{item:this.currentItem}):$(this.options.items,this.element),this]],connectWith=this._connectWith();//Shouldn't be run the first time through due to massive slow-down
	if(connectWith&&this.ready){for(i=connectWith.length-1;i>=0;i--){cur=$(connectWith[i],this.document[0]);for(j=cur.length-1;j>=0;j--){inst=$.data(cur[j],this.widgetFullName);if(inst&&inst!==this&&!inst.options.disabled){queries.push([$.isFunction(inst.options.items)?inst.options.items.call(inst.element[0],event,{item:this.currentItem}):$(inst.options.items,inst.element),inst]);this.containers.push(inst);}}}}for(i=queries.length-1;i>=0;i--){targetData=queries[i][1];_queries=queries[i][0];for(j=0,queriesLength=_queries.length;j<queriesLength;j++){item=$(_queries[j]);// Data for target checking (mouse manager)
	item.data(this.widgetName+"-item",targetData);items.push({item:item,instance:targetData,width:0,height:0,left:0,top:0});}}},refreshPositions:function refreshPositions(fast){// Determine whether items are being displayed horizontally
	this.floating=this.items.length?this.options.axis==="x"||this._isFloating(this.items[0].item):false;//This has to be redone because due to the item being moved out/into the offsetParent,
	// the offsetParent's position will change
	if(this.offsetParent&&this.helper){this.offset.parent=this._getParentOffset();}var i,item,t,p;for(i=this.items.length-1;i>=0;i--){item=this.items[i];//We ignore calculating positions of all connected containers when we're not over them
	if(item.instance!==this.currentContainer&&this.currentContainer&&item.item[0]!==this.currentItem[0]){continue;}t=this.options.toleranceElement?$(this.options.toleranceElement,item.item):item.item;if(!fast){item.width=t.outerWidth();item.height=t.outerHeight();}p=t.offset();item.left=p.left;item.top=p.top;}if(this.options.custom&&this.options.custom.refreshContainers){this.options.custom.refreshContainers.call(this);}else{for(i=this.containers.length-1;i>=0;i--){p=this.containers[i].element.offset();this.containers[i].containerCache.left=p.left;this.containers[i].containerCache.top=p.top;this.containers[i].containerCache.width=this.containers[i].element.outerWidth();this.containers[i].containerCache.height=this.containers[i].element.outerHeight();}}return this;},_createPlaceholder:function _createPlaceholder(that){that=that||this;var className,o=that.options;if(!o.placeholder||o.placeholder.constructor===String){className=o.placeholder;o.placeholder={element:function element(){var nodeName=that.currentItem[0].nodeName.toLowerCase(),element=$("<"+nodeName+">",that.document[0]);that._addClass(element,"ui-sortable-placeholder",className||that.currentItem[0].className)._removeClass(element,"ui-sortable-helper");if(nodeName==="tbody"){that._createTrPlaceholder(that.currentItem.find("tr").eq(0),$("<tr>",that.document[0]).appendTo(element));}else if(nodeName==="tr"){that._createTrPlaceholder(that.currentItem,element);}else if(nodeName==="img"){element.attr("src",that.currentItem.attr("src"));}if(!className){element.css("visibility","hidden");}return element;},update:function update(container,p){// 1. If a className is set as 'placeholder option, we don't force sizes -
	// the class is responsible for that
	// 2. The option 'forcePlaceholderSize can be enabled to force it even if a
	// class name is specified
	if(className&&!o.forcePlaceholderSize){return;}//If the element doesn't have a actual height by itself (without styles coming
	// from a stylesheet), it receives the inline height from the dragged item
	if(!p.height()){p.height(that.currentItem.innerHeight()-parseInt(that.currentItem.css("paddingTop")||0,10)-parseInt(that.currentItem.css("paddingBottom")||0,10));}if(!p.width()){p.width(that.currentItem.innerWidth()-parseInt(that.currentItem.css("paddingLeft")||0,10)-parseInt(that.currentItem.css("paddingRight")||0,10));}}};}//Create the placeholder
	that.placeholder=$(o.placeholder.element.call(that.element,that.currentItem));//Append it after the actual current item
	that.currentItem.after(that.placeholder);//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
	o.placeholder.update(that,that.placeholder);},_createTrPlaceholder:function _createTrPlaceholder(sourceTr,targetTr){var that=this;sourceTr.children().each(function(){$("<td>&#160;</td>",that.document[0]).attr("colspan",$(this).attr("colspan")||1).appendTo(targetTr);});},_contactContainers:function _contactContainers(event){var i,j,dist,itemWithLeastDistance,posProperty,sizeProperty,cur,nearBottom,floating,axis,innermostContainer=null,innermostIndex=null;// Get innermost container that intersects with item
	for(i=this.containers.length-1;i>=0;i--){// Never consider a container that's located within the item itself
	if($.contains(this.currentItem[0],this.containers[i].element[0])){continue;}if(this._intersectsWith(this.containers[i].containerCache)){// If we've already found a container and it's more "inner" than this, then continue
	if(innermostContainer&&$.contains(this.containers[i].element[0],innermostContainer.element[0])){continue;}innermostContainer=this.containers[i];innermostIndex=i;}else{// container doesn't intersect. trigger "out" event if necessary
	if(this.containers[i].containerCache.over){this.containers[i]._trigger("out",event,this._uiHash(this));this.containers[i].containerCache.over=0;}}}// If no intersecting containers found, return
	if(!innermostContainer){return;}// Move the item into the container if it's not there already
	if(this.containers.length===1){if(!this.containers[innermostIndex].containerCache.over){this.containers[innermostIndex]._trigger("over",event,this._uiHash(this));this.containers[innermostIndex].containerCache.over=1;}}else{// When entering a new container, we will find the item with the least distance and
	// append our item near it
	dist=10000;itemWithLeastDistance=null;floating=innermostContainer.floating||this._isFloating(this.currentItem);posProperty=floating?"left":"top";sizeProperty=floating?"width":"height";axis=floating?"pageX":"pageY";for(j=this.items.length-1;j>=0;j--){if(!$.contains(this.containers[innermostIndex].element[0],this.items[j].item[0])){continue;}if(this.items[j].item[0]===this.currentItem[0]){continue;}cur=this.items[j].item.offset()[posProperty];nearBottom=false;if(event[axis]-cur>this.items[j][sizeProperty]/2){nearBottom=true;}if(Math.abs(event[axis]-cur)<dist){dist=Math.abs(event[axis]-cur);itemWithLeastDistance=this.items[j];this.direction=nearBottom?"up":"down";}}//Check if dropOnEmpty is enabled
	if(!itemWithLeastDistance&&!this.options.dropOnEmpty){return;}if(this.currentContainer===this.containers[innermostIndex]){if(!this.currentContainer.containerCache.over){this.containers[innermostIndex]._trigger("over",event,this._uiHash());this.currentContainer.containerCache.over=1;}return;}itemWithLeastDistance?this._rearrange(event,itemWithLeastDistance,null,true):this._rearrange(event,null,this.containers[innermostIndex].element,true);this._trigger("change",event,this._uiHash());this.containers[innermostIndex]._trigger("change",event,this._uiHash(this));this.currentContainer=this.containers[innermostIndex];//Update the placeholder
	this.options.placeholder.update(this.currentContainer,this.placeholder);this.containers[innermostIndex]._trigger("over",event,this._uiHash(this));this.containers[innermostIndex].containerCache.over=1;}},_createHelper:function _createHelper(event){var o=this.options,helper=$.isFunction(o.helper)?$(o.helper.apply(this.element[0],[event,this.currentItem])):o.helper==="clone"?this.currentItem.clone():this.currentItem;//Add the helper to the DOM if that didn't happen already
	if(!helper.parents("body").length){$(o.appendTo!=="parent"?o.appendTo:this.currentItem[0].parentNode)[0].appendChild(helper[0]);}if(helper[0]===this.currentItem[0]){this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")};}if(!helper[0].style.width||o.forceHelperSize){helper.width(this.currentItem.width());}if(!helper[0].style.height||o.forceHelperSize){helper.height(this.currentItem.height());}return helper;},_adjustOffsetFromHelper:function _adjustOffsetFromHelper(obj){if(typeof obj==="string"){obj=obj.split(" ");}if($.isArray(obj)){obj={left:+obj[0],top:+obj[1]||0};}if("left"in obj){this.offset.click.left=obj.left+this.margins.left;}if("right"in obj){this.offset.click.left=this.helperProportions.width-obj.right+this.margins.left;}if("top"in obj){this.offset.click.top=obj.top+this.margins.top;}if("bottom"in obj){this.offset.click.top=this.helperProportions.height-obj.bottom+this.margins.top;}},_getParentOffset:function _getParentOffset(){//Get the offsetParent and cache its position
	this.offsetParent=this.helper.offsetParent();var po=this.offsetParent.offset();// This is a special case where we need to modify a offset calculated on start, since the
	// following happened:
	// 1. The position of the helper is absolute, so it's position is calculated based on the
	// next positioned parent
	// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
	// the document, which means that the scroll is included in the initial calculation of the
	// offset of the parent, and never recalculated upon drag
	if(this.cssPosition==="absolute"&&this.scrollParent[0]!==this.document[0]&&$.contains(this.scrollParent[0],this.offsetParent[0])){po.left+=this.scrollParent.scrollLeft();po.top+=this.scrollParent.scrollTop();}// This needs to be actually done for all browsers, since pageX/pageY includes this
	// information with an ugly IE fix
	if(this.offsetParent[0]===this.document[0].body||this.offsetParent[0].tagName&&this.offsetParent[0].tagName.toLowerCase()==="html"&&$.ui.ie){po={top:0,left:0};}return{top:po.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:po.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)};},_getRelativeOffset:function _getRelativeOffset(){if(this.cssPosition==="relative"){var p=this.currentItem.position();return{top:p.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:p.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()};}else{return{top:0,left:0};}},_cacheMargins:function _cacheMargins(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0};},_cacheHelperProportions:function _cacheHelperProportions(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()};},_setContainment:function _setContainment(){var ce,co,over,o=this.options;if(o.containment==="parent"){o.containment=this.helper[0].parentNode;}if(o.containment==="document"||o.containment==="window"){this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,o.containment==="document"?this.document.width():this.window.width()-this.helperProportions.width-this.margins.left,(o.containment==="document"?this.document.height()||document.body.parentNode.scrollHeight:this.window.height()||this.document[0].body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top];}if(!/^(document|window|parent)$/.test(o.containment)){ce=$(o.containment)[0];co=$(o.containment).offset();over=$(ce).css("overflow")!=="hidden";this.containment=[co.left+(parseInt($(ce).css("borderLeftWidth"),10)||0)+(parseInt($(ce).css("paddingLeft"),10)||0)-this.margins.left,co.top+(parseInt($(ce).css("borderTopWidth"),10)||0)+(parseInt($(ce).css("paddingTop"),10)||0)-this.margins.top,co.left+(over?Math.max(ce.scrollWidth,ce.offsetWidth):ce.offsetWidth)-(parseInt($(ce).css("borderLeftWidth"),10)||0)-(parseInt($(ce).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,co.top+(over?Math.max(ce.scrollHeight,ce.offsetHeight):ce.offsetHeight)-(parseInt($(ce).css("borderTopWidth"),10)||0)-(parseInt($(ce).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top];}},_convertPositionTo:function _convertPositionTo(d,pos){if(!pos){pos=this.position;}var mod=d==="absolute"?1:-1,scroll=this.cssPosition==="absolute"&&!(this.scrollParent[0]!==this.document[0]&&$.contains(this.scrollParent[0],this.offsetParent[0]))?this.offsetParent:this.scrollParent,scrollIsRootNode=/(html|body)/i.test(scroll[0].tagName);return{top:// The absolute mouse position
	pos.top+// Only for relative positioned nodes: Relative offset from element to offset parent
	this.offset.relative.top*mod+// The offsetParent's offset without borders (offset + border)
	this.offset.parent.top*mod-(this.cssPosition==="fixed"?-this.scrollParent.scrollTop():scrollIsRootNode?0:scroll.scrollTop())*mod,left:// The absolute mouse position
	pos.left+// Only for relative positioned nodes: Relative offset from element to offset parent
	this.offset.relative.left*mod+// The offsetParent's offset without borders (offset + border)
	this.offset.parent.left*mod-(this.cssPosition==="fixed"?-this.scrollParent.scrollLeft():scrollIsRootNode?0:scroll.scrollLeft())*mod};},_generatePosition:function _generatePosition(event){var top,left,o=this.options,pageX=event.pageX,pageY=event.pageY,scroll=this.cssPosition==="absolute"&&!(this.scrollParent[0]!==this.document[0]&&$.contains(this.scrollParent[0],this.offsetParent[0]))?this.offsetParent:this.scrollParent,scrollIsRootNode=/(html|body)/i.test(scroll[0].tagName);// This is another very weird special case that only happens for relative elements:
	// 1. If the css position is relative
	// 2. and the scroll parent is the document or similar to the offset parent
	// we have to refresh the relative offset during the scroll so there are no jumps
	if(this.cssPosition==="relative"&&!(this.scrollParent[0]!==this.document[0]&&this.scrollParent[0]!==this.offsetParent[0])){this.offset.relative=this._getRelativeOffset();}/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */if(this.originalPosition){//If we are not dragging yet, we won't check for options
	if(this.containment){if(event.pageX-this.offset.click.left<this.containment[0]){pageX=this.containment[0]+this.offset.click.left;}if(event.pageY-this.offset.click.top<this.containment[1]){pageY=this.containment[1]+this.offset.click.top;}if(event.pageX-this.offset.click.left>this.containment[2]){pageX=this.containment[2]+this.offset.click.left;}if(event.pageY-this.offset.click.top>this.containment[3]){pageY=this.containment[3]+this.offset.click.top;}}if(o.grid){top=this.originalPageY+Math.round((pageY-this.originalPageY)/o.grid[1])*o.grid[1];pageY=this.containment?top-this.offset.click.top>=this.containment[1]&&top-this.offset.click.top<=this.containment[3]?top:top-this.offset.click.top>=this.containment[1]?top-o.grid[1]:top+o.grid[1]:top;left=this.originalPageX+Math.round((pageX-this.originalPageX)/o.grid[0])*o.grid[0];pageX=this.containment?left-this.offset.click.left>=this.containment[0]&&left-this.offset.click.left<=this.containment[2]?left:left-this.offset.click.left>=this.containment[0]?left-o.grid[0]:left+o.grid[0]:left;}}return{top:// The absolute mouse position
	pageY-// Click offset (relative to the element)
	this.offset.click.top-// Only for relative positioned nodes: Relative offset from element to offset parent
	this.offset.relative.top-// The offsetParent's offset without borders (offset + border)
	this.offset.parent.top+(this.cssPosition==="fixed"?-this.scrollParent.scrollTop():scrollIsRootNode?0:scroll.scrollTop()),left:// The absolute mouse position
	pageX-// Click offset (relative to the element)
	this.offset.click.left-// Only for relative positioned nodes: Relative offset from element to offset parent
	this.offset.relative.left-// The offsetParent's offset without borders (offset + border)
	this.offset.parent.left+(this.cssPosition==="fixed"?-this.scrollParent.scrollLeft():scrollIsRootNode?0:scroll.scrollLeft())};},_rearrange:function _rearrange(event,i,a,hardRefresh){a?a[0].appendChild(this.placeholder[0]):i.item[0].parentNode.insertBefore(this.placeholder[0],this.direction==="down"?i.item[0]:i.item[0].nextSibling);//Various things done here to improve the performance:
	// 1. we create a setTimeout, that calls refreshPositions
	// 2. on the instance, we have a counter variable, that get's higher after every append
	// 3. on the local scope, we copy the counter variable, and check in the timeout,
	// if it's still the same
	// 4. this lets only the last addition to the timeout stack through
	this.counter=this.counter?++this.counter:1;var counter=this.counter;this._delay(function(){if(counter===this.counter){//Precompute after each DOM insertion, NOT on mousemove
	this.refreshPositions(!hardRefresh);}});},_clear:function _clear(event,noPropagation){this.reverting=false;// We delay all events that have to be triggered to after the point where the placeholder
	// has been removed and everything else normalized again
	var i,delayedTriggers=[];// We first have to update the dom position of the actual currentItem
	// Note: don't do it if the current item is already removed (by a user), or it gets
	// reappended (see #4088)
	if(!this._noFinalSort&&this.currentItem.parent().length){this.placeholder.before(this.currentItem);}this._noFinalSort=null;if(this.helper[0]===this.currentItem[0]){for(i in this._storedCSS){if(this._storedCSS[i]==="auto"||this._storedCSS[i]==="static"){this._storedCSS[i]="";}}this.currentItem.css(this._storedCSS);this._removeClass(this.currentItem,"ui-sortable-helper");}else{this.currentItem.show();}if(this.fromOutside&&!noPropagation){delayedTriggers.push(function(event){this._trigger("receive",event,this._uiHash(this.fromOutside));});}if((this.fromOutside||this.domPosition.prev!==this.currentItem.prev().not(".ui-sortable-helper")[0]||this.domPosition.parent!==this.currentItem.parent()[0])&&!noPropagation){// Trigger update callback if the DOM position has changed
	delayedTriggers.push(function(event){this._trigger("update",event,this._uiHash());});}// Check if the items Container has Changed and trigger appropriate
	// events.
	if(this!==this.currentContainer){if(!noPropagation){delayedTriggers.push(function(event){this._trigger("remove",event,this._uiHash());});delayedTriggers.push(function(c){return function(event){c._trigger("receive",event,this._uiHash(this));};}.call(this,this.currentContainer));delayedTriggers.push(function(c){return function(event){c._trigger("update",event,this._uiHash(this));};}.call(this,this.currentContainer));}}//Post events to containers
	function delayEvent(type,instance,container){return function(event){container._trigger(type,event,instance._uiHash(instance));};}for(i=this.containers.length-1;i>=0;i--){if(!noPropagation){delayedTriggers.push(delayEvent("deactivate",this,this.containers[i]));}if(this.containers[i].containerCache.over){delayedTriggers.push(delayEvent("out",this,this.containers[i]));this.containers[i].containerCache.over=0;}}//Do what was originally in plugins
	if(this.storedCursor){this.document.find("body").css("cursor",this.storedCursor);this.storedStylesheet.remove();}if(this._storedOpacity){this.helper.css("opacity",this._storedOpacity);}if(this._storedZIndex){this.helper.css("zIndex",this._storedZIndex==="auto"?"":this._storedZIndex);}this.dragging=false;if(!noPropagation){this._trigger("beforeStop",event,this._uiHash());}//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
	// it unbinds ALL events from the original node!
	this.placeholder[0].parentNode.removeChild(this.placeholder[0]);if(!this.cancelHelperRemoval){if(this.helper[0]!==this.currentItem[0]){this.helper.remove();}this.helper=null;}if(!noPropagation){for(i=0;i<delayedTriggers.length;i++){// Trigger all delayed events
	delayedTriggers[i].call(this,event);}this._trigger("stop",event,this._uiHash());}this.fromOutside=false;return!this.cancelHelperRemoval;},_trigger:function _trigger(){if($.Widget.prototype._trigger.apply(this,arguments)===false){this.cancel();}},_uiHash:function _uiHash(_inst){var inst=_inst||this;return{helper:inst.helper,placeholder:inst.placeholder||$([]),position:inst.position,originalPosition:inst.originalPosition,offset:inst.positionAbs,item:inst.currentItem,sender:_inst?_inst.element:null};}});/*!
	 * jQuery UI Spinner 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Spinner
	//>>group: Widgets
	//>>description: Displays buttons to easily input numbers via the keyboard or mouse.
	//>>docs: http://api.jqueryui.com/spinner/
	//>>demos: http://jqueryui.com/spinner/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/spinner.css
	//>>css.theme: ../../themes/base/theme.css
	function spinnerModifer(fn){return function(){var previous=this.element.val();fn.apply(this,arguments);this._refresh();if(previous!==this.element.val()){this._trigger("change");}};}$.widget("ui.spinner",{version:"1.12.1",defaultElement:"<input>",widgetEventPrefix:"spin",options:{classes:{"ui-spinner":"ui-corner-all","ui-spinner-down":"ui-corner-br","ui-spinner-up":"ui-corner-tr"},culture:null,icons:{down:"ui-icon-triangle-1-s",up:"ui-icon-triangle-1-n"},incremental:true,max:null,min:null,numberFormat:null,page:10,step:1,change:null,spin:null,start:null,stop:null},_create:function _create(){// handle string values that need to be parsed
	this._setOption("max",this.options.max);this._setOption("min",this.options.min);this._setOption("step",this.options.step);// Only format if there is a value, prevents the field from being marked
	// as invalid in Firefox, see #9573.
	if(this.value()!==""){// Format the value, but don't constrain.
	this._value(this.element.val(),true);}this._draw();this._on(this._events);this._refresh();// Turning off autocomplete prevents the browser from remembering the
	// value when navigating through history, so we re-enable autocomplete
	// if the page is unloaded before the widget is destroyed. #7790
	this._on(this.window,{beforeunload:function beforeunload(){this.element.removeAttr("autocomplete");}});},_getCreateOptions:function _getCreateOptions(){var options=this._super();var element=this.element;$.each(["min","max","step"],function(i,option){var value=element.attr(option);if(value!=null&&value.length){options[option]=value;}});return options;},_events:{keydown:function keydown(event){if(this._start(event)&&this._keydown(event)){event.preventDefault();}},keyup:"_stop",focus:function focus(){this.previous=this.element.val();},blur:function blur(event){if(this.cancelBlur){delete this.cancelBlur;return;}this._stop();this._refresh();if(this.previous!==this.element.val()){this._trigger("change",event);}},mousewheel:function mousewheel(event,delta){if(!delta){return;}if(!this.spinning&&!this._start(event)){return false;}this._spin((delta>0?1:-1)*this.options.step,event);clearTimeout(this.mousewheelTimer);this.mousewheelTimer=this._delay(function(){if(this.spinning){this._stop(event);}},100);event.preventDefault();},"mousedown .ui-spinner-button":function mousedownUiSpinnerButton(event){var previous;// We never want the buttons to have focus; whenever the user is
	// interacting with the spinner, the focus should be on the input.
	// If the input is focused then this.previous is properly set from
	// when the input first received focus. If the input is not focused
	// then we need to set this.previous based on the value before spinning.
	previous=this.element[0]===$.ui.safeActiveElement(this.document[0])?this.previous:this.element.val();function checkFocus(){var isActive=this.element[0]===$.ui.safeActiveElement(this.document[0]);if(!isActive){this.element.trigger("focus");this.previous=previous;// support: IE
	// IE sets focus asynchronously, so we need to check if focus
	// moved off of the input because the user clicked on the button.
	this._delay(function(){this.previous=previous;});}}// Ensure focus is on (or stays on) the text field
	event.preventDefault();checkFocus.call(this);// Support: IE
	// IE doesn't prevent moving focus even with event.preventDefault()
	// so we set a flag to know when we should ignore the blur event
	// and check (again) if focus moved off of the input.
	this.cancelBlur=true;this._delay(function(){delete this.cancelBlur;checkFocus.call(this);});if(this._start(event)===false){return;}this._repeat(null,$(event.currentTarget).hasClass("ui-spinner-up")?1:-1,event);},"mouseup .ui-spinner-button":"_stop","mouseenter .ui-spinner-button":function mouseenterUiSpinnerButton(event){// button will add ui-state-active if mouse was down while mouseleave and kept down
	if(!$(event.currentTarget).hasClass("ui-state-active")){return;}if(this._start(event)===false){return false;}this._repeat(null,$(event.currentTarget).hasClass("ui-spinner-up")?1:-1,event);},// TODO: do we really want to consider this a stop?
	// shouldn't we just stop the repeater and wait until mouseup before
	// we trigger the stop event?
	"mouseleave .ui-spinner-button":"_stop"},// Support mobile enhanced option and make backcompat more sane
	_enhance:function _enhance(){this.uiSpinner=this.element.attr("autocomplete","off").wrap("<span>").parent()// Add buttons
	.append("<a></a><a></a>");},_draw:function _draw(){this._enhance();this._addClass(this.uiSpinner,"ui-spinner","ui-widget ui-widget-content");this._addClass("ui-spinner-input");this.element.attr("role","spinbutton");// Button bindings
	this.buttons=this.uiSpinner.children("a").attr("tabIndex",-1).attr("aria-hidden",true).button({classes:{"ui-button":""}});// TODO: Right now button does not support classes this is already updated in button PR
	this._removeClass(this.buttons,"ui-corner-all");this._addClass(this.buttons.first(),"ui-spinner-button ui-spinner-up");this._addClass(this.buttons.last(),"ui-spinner-button ui-spinner-down");this.buttons.first().button({"icon":this.options.icons.up,"showLabel":false});this.buttons.last().button({"icon":this.options.icons.down,"showLabel":false});// IE 6 doesn't understand height: 50% for the buttons
	// unless the wrapper has an explicit height
	if(this.buttons.height()>Math.ceil(this.uiSpinner.height()*0.5)&&this.uiSpinner.height()>0){this.uiSpinner.height(this.uiSpinner.height());}},_keydown:function _keydown(event){var options=this.options,keyCode=$.ui.keyCode;switch(event.keyCode){case keyCode.UP:this._repeat(null,1,event);return true;case keyCode.DOWN:this._repeat(null,-1,event);return true;case keyCode.PAGE_UP:this._repeat(null,options.page,event);return true;case keyCode.PAGE_DOWN:this._repeat(null,-options.page,event);return true;}return false;},_start:function _start(event){if(!this.spinning&&this._trigger("start",event)===false){return false;}if(!this.counter){this.counter=1;}this.spinning=true;return true;},_repeat:function _repeat(i,steps,event){i=i||500;clearTimeout(this.timer);this.timer=this._delay(function(){this._repeat(40,steps,event);},i);this._spin(steps*this.options.step,event);},_spin:function _spin(step,event){var value=this.value()||0;if(!this.counter){this.counter=1;}value=this._adjustValue(value+step*this._increment(this.counter));if(!this.spinning||this._trigger("spin",event,{value:value})!==false){this._value(value);this.counter++;}},_increment:function _increment(i){var incremental=this.options.incremental;if(incremental){return $.isFunction(incremental)?incremental(i):Math.floor(i*i*i/50000-i*i/500+17*i/200+1);}return 1;},_precision:function _precision(){var precision=this._precisionOf(this.options.step);if(this.options.min!==null){precision=Math.max(precision,this._precisionOf(this.options.min));}return precision;},_precisionOf:function _precisionOf(num){var str=num.toString(),decimal=str.indexOf(".");return decimal===-1?0:str.length-decimal-1;},_adjustValue:function _adjustValue(value){var base,aboveMin,options=this.options;// Make sure we're at a valid step
	// - find out where we are relative to the base (min or 0)
	base=options.min!==null?options.min:0;aboveMin=value-base;// - round to the nearest step
	aboveMin=Math.round(aboveMin/options.step)*options.step;// - rounding is based on 0, so adjust back to our base
	value=base+aboveMin;// Fix precision from bad JS floating point math
	value=parseFloat(value.toFixed(this._precision()));// Clamp the value
	if(options.max!==null&&value>options.max){return options.max;}if(options.min!==null&&value<options.min){return options.min;}return value;},_stop:function _stop(event){if(!this.spinning){return;}clearTimeout(this.timer);clearTimeout(this.mousewheelTimer);this.counter=0;this.spinning=false;this._trigger("stop",event);},_setOption:function _setOption(key,value){var prevValue,first,last;if(key==="culture"||key==="numberFormat"){prevValue=this._parse(this.element.val());this.options[key]=value;this.element.val(this._format(prevValue));return;}if(key==="max"||key==="min"||key==="step"){if(typeof value==="string"){value=this._parse(value);}}if(key==="icons"){first=this.buttons.first().find(".ui-icon");this._removeClass(first,null,this.options.icons.up);this._addClass(first,null,value.up);last=this.buttons.last().find(".ui-icon");this._removeClass(last,null,this.options.icons.down);this._addClass(last,null,value.down);}this._super(key,value);},_setOptionDisabled:function _setOptionDisabled(value){this._super(value);this._toggleClass(this.uiSpinner,null,"ui-state-disabled",!!value);this.element.prop("disabled",!!value);this.buttons.button(value?"disable":"enable");},_setOptions:spinnerModifer(function(options){this._super(options);}),_parse:function _parse(val){if(typeof val==="string"&&val!==""){val=window.Globalize&&this.options.numberFormat?Globalize.parseFloat(val,10,this.options.culture):+val;}return val===""||isNaN(val)?null:val;},_format:function _format(value){if(value===""){return"";}return window.Globalize&&this.options.numberFormat?Globalize.format(value,this.options.numberFormat,this.options.culture):value;},_refresh:function _refresh(){this.element.attr({"aria-valuemin":this.options.min,"aria-valuemax":this.options.max,// TODO: what should we do with values that can't be parsed?
	"aria-valuenow":this._parse(this.element.val())});},isValid:function isValid(){var value=this.value();// Null is invalid
	if(value===null){return false;}// If value gets adjusted, it's invalid
	return value===this._adjustValue(value);},// Update the value without triggering change
	_value:function _value(value,allowAny){var parsed;if(value!==""){parsed=this._parse(value);if(parsed!==null){if(!allowAny){parsed=this._adjustValue(parsed);}value=this._format(parsed);}}this.element.val(value);this._refresh();},_destroy:function _destroy(){this.element.prop("disabled",false).removeAttr("autocomplete role aria-valuemin aria-valuemax aria-valuenow");this.uiSpinner.replaceWith(this.element);},stepUp:spinnerModifer(function(steps){this._stepUp(steps);}),_stepUp:function _stepUp(steps){if(this._start()){this._spin((steps||1)*this.options.step);this._stop();}},stepDown:spinnerModifer(function(steps){this._stepDown(steps);}),_stepDown:function _stepDown(steps){if(this._start()){this._spin((steps||1)*-this.options.step);this._stop();}},pageUp:spinnerModifer(function(pages){this._stepUp((pages||1)*this.options.page);}),pageDown:spinnerModifer(function(pages){this._stepDown((pages||1)*this.options.page);}),value:function value(newVal){if(!arguments.length){return this._parse(this.element.val());}spinnerModifer(this._value).call(this,newVal);},widget:function widget(){return this.uiSpinner;}});// DEPRECATED
	// TODO: switch return back to widget declaration at top of file when this is removed
	if($.uiBackCompat!==false){// Backcompat for spinner html extension points
	$.widget("ui.spinner",$.ui.spinner,{_enhance:function _enhance(){this.uiSpinner=this.element.attr("autocomplete","off").wrap(this._uiSpinnerHtml()).parent()// Add buttons
	.append(this._buttonHtml());},_uiSpinnerHtml:function _uiSpinnerHtml(){return"<span>";},_buttonHtml:function _buttonHtml(){return"<a></a><a></a>";}});}var widgetsSpinner=$.ui.spinner;/*!
	 * jQuery UI Tabs 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Tabs
	//>>group: Widgets
	//>>description: Transforms a set of container elements into a tab structure.
	//>>docs: http://api.jqueryui.com/tabs/
	//>>demos: http://jqueryui.com/tabs/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/tabs.css
	//>>css.theme: ../../themes/base/theme.css
	$.widget("ui.tabs",{version:"1.12.1",delay:300,options:{active:null,classes:{"ui-tabs":"ui-corner-all","ui-tabs-nav":"ui-corner-all","ui-tabs-panel":"ui-corner-bottom","ui-tabs-tab":"ui-corner-top"},collapsible:false,event:"click",heightStyle:"content",hide:null,show:null,// Callbacks
	activate:null,beforeActivate:null,beforeLoad:null,load:null},_isLocal:function(){var rhash=/#.*$/;return function(anchor){var anchorUrl,locationUrl;anchorUrl=anchor.href.replace(rhash,"");locationUrl=location.href.replace(rhash,"");// Decoding may throw an error if the URL isn't UTF-8 (#9518)
	try{anchorUrl=decodeURIComponent(anchorUrl);}catch(error){}try{locationUrl=decodeURIComponent(locationUrl);}catch(error){}return anchor.hash.length>1&&anchorUrl===locationUrl;};}(),_create:function _create(){var that=this,options=this.options;this.running=false;this._addClass("ui-tabs","ui-widget ui-widget-content");this._toggleClass("ui-tabs-collapsible",null,options.collapsible);this._processTabs();options.active=this._initialActive();// Take disabling tabs via class attribute from HTML
	// into account and update option properly.
	if($.isArray(options.disabled)){options.disabled=$.unique(options.disabled.concat($.map(this.tabs.filter(".ui-state-disabled"),function(li){return that.tabs.index(li);}))).sort();}// Check for length avoids error when initializing empty list
	if(this.options.active!==false&&this.anchors.length){this.active=this._findActive(options.active);}else{this.active=$();}this._refresh();if(this.active.length){this.load(options.active);}},_initialActive:function _initialActive(){var active=this.options.active,collapsible=this.options.collapsible,locationHash=location.hash.substring(1);if(active===null){// check the fragment identifier in the URL
	if(locationHash){this.tabs.each(function(i,tab){if($(tab).attr("aria-controls")===locationHash){active=i;return false;}});}// Check for a tab marked active via a class
	if(active===null){active=this.tabs.index(this.tabs.filter(".ui-tabs-active"));}// No active tab, set to false
	if(active===null||active===-1){active=this.tabs.length?0:false;}}// Handle numbers: negative, out of range
	if(active!==false){active=this.tabs.index(this.tabs.eq(active));if(active===-1){active=collapsible?false:0;}}// Don't allow collapsible: false and active: false
	if(!collapsible&&active===false&&this.anchors.length){active=0;}return active;},_getCreateEventData:function _getCreateEventData(){return{tab:this.active,panel:!this.active.length?$():this._getPanelForTab(this.active)};},_tabKeydown:function _tabKeydown(event){var focusedTab=$($.ui.safeActiveElement(this.document[0])).closest("li"),selectedIndex=this.tabs.index(focusedTab),goingForward=true;if(this._handlePageNav(event)){return;}switch(event.keyCode){case $.ui.keyCode.RIGHT:case $.ui.keyCode.DOWN:selectedIndex++;break;case $.ui.keyCode.UP:case $.ui.keyCode.LEFT:goingForward=false;selectedIndex--;break;case $.ui.keyCode.END:selectedIndex=this.anchors.length-1;break;case $.ui.keyCode.HOME:selectedIndex=0;break;case $.ui.keyCode.SPACE:// Activate only, no collapsing
	event.preventDefault();clearTimeout(this.activating);this._activate(selectedIndex);return;case $.ui.keyCode.ENTER:// Toggle (cancel delayed activation, allow collapsing)
	event.preventDefault();clearTimeout(this.activating);// Determine if we should collapse or activate
	this._activate(selectedIndex===this.options.active?false:selectedIndex);return;default:return;}// Focus the appropriate tab, based on which key was pressed
	event.preventDefault();clearTimeout(this.activating);selectedIndex=this._focusNextTab(selectedIndex,goingForward);// Navigating with control/command key will prevent automatic activation
	if(!event.ctrlKey&&!event.metaKey){// Update aria-selected immediately so that AT think the tab is already selected.
	// Otherwise AT may confuse the user by stating that they need to activate the tab,
	// but the tab will already be activated by the time the announcement finishes.
	focusedTab.attr("aria-selected","false");this.tabs.eq(selectedIndex).attr("aria-selected","true");this.activating=this._delay(function(){this.option("active",selectedIndex);},this.delay);}},_panelKeydown:function _panelKeydown(event){if(this._handlePageNav(event)){return;}// Ctrl+up moves focus to the current tab
	if(event.ctrlKey&&event.keyCode===$.ui.keyCode.UP){event.preventDefault();this.active.trigger("focus");}},// Alt+page up/down moves focus to the previous/next tab (and activates)
	_handlePageNav:function _handlePageNav(event){if(event.altKey&&event.keyCode===$.ui.keyCode.PAGE_UP){this._activate(this._focusNextTab(this.options.active-1,false));return true;}if(event.altKey&&event.keyCode===$.ui.keyCode.PAGE_DOWN){this._activate(this._focusNextTab(this.options.active+1,true));return true;}},_findNextTab:function _findNextTab(index,goingForward){var lastTabIndex=this.tabs.length-1;function constrain(){if(index>lastTabIndex){index=0;}if(index<0){index=lastTabIndex;}return index;}while($.inArray(constrain(),this.options.disabled)!==-1){index=goingForward?index+1:index-1;}return index;},_focusNextTab:function _focusNextTab(index,goingForward){index=this._findNextTab(index,goingForward);this.tabs.eq(index).trigger("focus");return index;},_setOption:function _setOption(key,value){if(key==="active"){// _activate() will handle invalid values and update this.options
	this._activate(value);return;}this._super(key,value);if(key==="collapsible"){this._toggleClass("ui-tabs-collapsible",null,value);// Setting collapsible: false while collapsed; open first panel
	if(!value&&this.options.active===false){this._activate(0);}}if(key==="event"){this._setupEvents(value);}if(key==="heightStyle"){this._setupHeightStyle(value);}},_sanitizeSelector:function _sanitizeSelector(hash){return hash?hash.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g,"\\$&"):"";},refresh:function refresh(){var options=this.options,lis=this.tablist.children(":has(a[href])");// Get disabled tabs from class attribute from HTML
	// this will get converted to a boolean if needed in _refresh()
	options.disabled=$.map(lis.filter(".ui-state-disabled"),function(tab){return lis.index(tab);});this._processTabs();// Was collapsed or no tabs
	if(options.active===false||!this.anchors.length){options.active=false;this.active=$();// was active, but active tab is gone
	}else if(this.active.length&&!$.contains(this.tablist[0],this.active[0])){// all remaining tabs are disabled
	if(this.tabs.length===options.disabled.length){options.active=false;this.active=$();// activate previous tab
	}else{this._activate(this._findNextTab(Math.max(0,options.active-1),false));}// was active, active tab still exists
	}else{// make sure active index is correct
	options.active=this.tabs.index(this.active);}this._refresh();},_refresh:function _refresh(){this._setOptionDisabled(this.options.disabled);this._setupEvents(this.options.event);this._setupHeightStyle(this.options.heightStyle);this.tabs.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1});this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-hidden":"true"});// Make sure one tab is in the tab order
	if(!this.active.length){this.tabs.eq(0).attr("tabIndex",0);}else{this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0});this._addClass(this.active,"ui-tabs-active","ui-state-active");this._getPanelForTab(this.active).show().attr({"aria-hidden":"false"});}},_processTabs:function _processTabs(){var that=this,prevTabs=this.tabs,prevAnchors=this.anchors,prevPanels=this.panels;this.tablist=this._getList().attr("role","tablist");this._addClass(this.tablist,"ui-tabs-nav","ui-helper-reset ui-helper-clearfix ui-widget-header");// Prevent users from focusing disabled tabs via click
	this.tablist.on("mousedown"+this.eventNamespace,"> li",function(event){if($(this).is(".ui-state-disabled")){event.preventDefault();}})// Support: IE <9
	// Preventing the default action in mousedown doesn't prevent IE
	// from focusing the element, so if the anchor gets focused, blur.
	// We don't have to worry about focusing the previously focused
	// element since clicking on a non-focusable element should focus
	// the body anyway.
	.on("focus"+this.eventNamespace,".ui-tabs-anchor",function(){if($(this).closest("li").is(".ui-state-disabled")){this.blur();}});this.tabs=this.tablist.find("> li:has(a[href])").attr({role:"tab",tabIndex:-1});this._addClass(this.tabs,"ui-tabs-tab","ui-state-default");this.anchors=this.tabs.map(function(){return $("a",this)[0];}).attr({role:"presentation",tabIndex:-1});this._addClass(this.anchors,"ui-tabs-anchor");this.panels=$();this.anchors.each(function(i,anchor){var selector,panel,panelId,anchorId=$(anchor).uniqueId().attr("id"),tab=$(anchor).closest("li"),originalAriaControls=tab.attr("aria-controls");// Inline tab
	if(that._isLocal(anchor)){selector=anchor.hash;panelId=selector.substring(1);panel=that.element.find(that._sanitizeSelector(selector));// remote tab
	}else{// If the tab doesn't already have aria-controls,
	// generate an id by using a throw-away element
	panelId=tab.attr("aria-controls")||$({}).uniqueId()[0].id;selector="#"+panelId;panel=that.element.find(selector);if(!panel.length){panel=that._createPanel(panelId);panel.insertAfter(that.panels[i-1]||that.tablist);}panel.attr("aria-live","polite");}if(panel.length){that.panels=that.panels.add(panel);}if(originalAriaControls){tab.data("ui-tabs-aria-controls",originalAriaControls);}tab.attr({"aria-controls":panelId,"aria-labelledby":anchorId});panel.attr("aria-labelledby",anchorId);});this.panels.attr("role","tabpanel");this._addClass(this.panels,"ui-tabs-panel","ui-widget-content");// Avoid memory leaks (#10056)
	if(prevTabs){this._off(prevTabs.not(this.tabs));this._off(prevAnchors.not(this.anchors));this._off(prevPanels.not(this.panels));}},// Allow overriding how to find the list for rare usage scenarios (#7715)
	_getList:function _getList(){return this.tablist||this.element.find("ol, ul").eq(0);},_createPanel:function _createPanel(id){return $("<div>").attr("id",id).data("ui-tabs-destroy",true);},_setOptionDisabled:function _setOptionDisabled(disabled){var currentItem,li,i;if($.isArray(disabled)){if(!disabled.length){disabled=false;}else if(disabled.length===this.anchors.length){disabled=true;}}// Disable tabs
	for(i=0;li=this.tabs[i];i++){currentItem=$(li);if(disabled===true||$.inArray(i,disabled)!==-1){currentItem.attr("aria-disabled","true");this._addClass(currentItem,null,"ui-state-disabled");}else{currentItem.removeAttr("aria-disabled");this._removeClass(currentItem,null,"ui-state-disabled");}}this.options.disabled=disabled;this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,disabled===true);},_setupEvents:function _setupEvents(event){var events={};if(event){$.each(event.split(" "),function(index,eventName){events[eventName]="_eventHandler";});}this._off(this.anchors.add(this.tabs).add(this.panels));// Always prevent the default action, even when disabled
	this._on(true,this.anchors,{click:function click(event){event.preventDefault();}});this._on(this.anchors,events);this._on(this.tabs,{keydown:"_tabKeydown"});this._on(this.panels,{keydown:"_panelKeydown"});this._focusable(this.tabs);this._hoverable(this.tabs);},_setupHeightStyle:function _setupHeightStyle(heightStyle){var maxHeight,parent=this.element.parent();if(heightStyle==="fill"){maxHeight=parent.height();maxHeight-=this.element.outerHeight()-this.element.height();this.element.siblings(":visible").each(function(){var elem=$(this),position=elem.css("position");if(position==="absolute"||position==="fixed"){return;}maxHeight-=elem.outerHeight(true);});this.element.children().not(this.panels).each(function(){maxHeight-=$(this).outerHeight(true);});this.panels.each(function(){$(this).height(Math.max(0,maxHeight-$(this).innerHeight()+$(this).height()));}).css("overflow","auto");}else if(heightStyle==="auto"){maxHeight=0;this.panels.each(function(){maxHeight=Math.max(maxHeight,$(this).height("").height());}).height(maxHeight);}},_eventHandler:function _eventHandler(event){var options=this.options,active=this.active,anchor=$(event.currentTarget),tab=anchor.closest("li"),clickedIsActive=tab[0]===active[0],collapsing=clickedIsActive&&options.collapsible,toShow=collapsing?$():this._getPanelForTab(tab),toHide=!active.length?$():this._getPanelForTab(active),eventData={oldTab:active,oldPanel:toHide,newTab:collapsing?$():tab,newPanel:toShow};event.preventDefault();if(tab.hasClass("ui-state-disabled")||// tab is already loading
	tab.hasClass("ui-tabs-loading")||// can't switch durning an animation
	this.running||// click on active header, but not collapsible
	clickedIsActive&&!options.collapsible||// allow canceling activation
	this._trigger("beforeActivate",event,eventData)===false){return;}options.active=collapsing?false:this.tabs.index(tab);this.active=clickedIsActive?$():tab;if(this.xhr){this.xhr.abort();}if(!toHide.length&&!toShow.length){$.error("jQuery UI Tabs: Mismatching fragment identifier.");}if(toShow.length){this.load(this.tabs.index(tab),event);}this._toggle(event,eventData);},// Handles show/hide for selecting tabs
	_toggle:function _toggle(event,eventData){var that=this,toShow=eventData.newPanel,toHide=eventData.oldPanel;this.running=true;function complete(){that.running=false;that._trigger("activate",event,eventData);}function show(){that._addClass(eventData.newTab.closest("li"),"ui-tabs-active","ui-state-active");if(toShow.length&&that.options.show){that._show(toShow,that.options.show,complete);}else{toShow.show();complete();}}// Start out by hiding, then showing, then completing
	if(toHide.length&&this.options.hide){this._hide(toHide,this.options.hide,function(){that._removeClass(eventData.oldTab.closest("li"),"ui-tabs-active","ui-state-active");show();});}else{this._removeClass(eventData.oldTab.closest("li"),"ui-tabs-active","ui-state-active");toHide.hide();show();}toHide.attr("aria-hidden","true");eventData.oldTab.attr({"aria-selected":"false","aria-expanded":"false"});// If we're switching tabs, remove the old tab from the tab order.
	// If we're opening from collapsed state, remove the previous tab from the tab order.
	// If we're collapsing, then keep the collapsing tab in the tab order.
	if(toShow.length&&toHide.length){eventData.oldTab.attr("tabIndex",-1);}else if(toShow.length){this.tabs.filter(function(){return $(this).attr("tabIndex")===0;}).attr("tabIndex",-1);}toShow.attr("aria-hidden","false");eventData.newTab.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0});},_activate:function _activate(index){var anchor,active=this._findActive(index);// Trying to activate the already active panel
	if(active[0]===this.active[0]){return;}// Trying to collapse, simulate a click on the current active header
	if(!active.length){active=this.active;}anchor=active.find(".ui-tabs-anchor")[0];this._eventHandler({target:anchor,currentTarget:anchor,preventDefault:$.noop});},_findActive:function _findActive(index){return index===false?$():this.tabs.eq(index);},_getIndex:function _getIndex(index){// meta-function to give users option to provide a href string instead of a numerical index.
	if(typeof index==="string"){index=this.anchors.index(this.anchors.filter("[href$='"+$.ui.escapeSelector(index)+"']"));}return index;},_destroy:function _destroy(){if(this.xhr){this.xhr.abort();}this.tablist.removeAttr("role").off(this.eventNamespace);this.anchors.removeAttr("role tabIndex").removeUniqueId();this.tabs.add(this.panels).each(function(){if($.data(this,"ui-tabs-destroy")){$(this).remove();}else{$(this).removeAttr("role tabIndex "+"aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded");}});this.tabs.each(function(){var li=$(this),prev=li.data("ui-tabs-aria-controls");if(prev){li.attr("aria-controls",prev).removeData("ui-tabs-aria-controls");}else{li.removeAttr("aria-controls");}});this.panels.show();if(this.options.heightStyle!=="content"){this.panels.css("height","");}},enable:function enable(index){var disabled=this.options.disabled;if(disabled===false){return;}if(index===undefined){disabled=false;}else{index=this._getIndex(index);if($.isArray(disabled)){disabled=$.map(disabled,function(num){return num!==index?num:null;});}else{disabled=$.map(this.tabs,function(li,num){return num!==index?num:null;});}}this._setOptionDisabled(disabled);},disable:function disable(index){var disabled=this.options.disabled;if(disabled===true){return;}if(index===undefined){disabled=true;}else{index=this._getIndex(index);if($.inArray(index,disabled)!==-1){return;}if($.isArray(disabled)){disabled=$.merge([index],disabled).sort();}else{disabled=[index];}}this._setOptionDisabled(disabled);},load:function load(index,event){index=this._getIndex(index);var that=this,tab=this.tabs.eq(index),anchor=tab.find(".ui-tabs-anchor"),panel=this._getPanelForTab(tab),eventData={tab:tab,panel:panel},complete=function complete(jqXHR,status){if(status==="abort"){that.panels.stop(false,true);}that._removeClass(tab,"ui-tabs-loading");panel.removeAttr("aria-busy");if(jqXHR===that.xhr){delete that.xhr;}};// Not remote
	if(this._isLocal(anchor[0])){return;}this.xhr=$.ajax(this._ajaxSettings(anchor,event,eventData));// Support: jQuery <1.8
	// jQuery <1.8 returns false if the request is canceled in beforeSend,
	// but as of 1.8, $.ajax() always returns a jqXHR object.
	if(this.xhr&&this.xhr.statusText!=="canceled"){this._addClass(tab,"ui-tabs-loading");panel.attr("aria-busy","true");this.xhr.done(function(response,status,jqXHR){// support: jQuery <1.8
	// http://bugs.jquery.com/ticket/11778
	setTimeout(function(){panel.html(response);that._trigger("load",event,eventData);complete(jqXHR,status);},1);}).fail(function(jqXHR,status){// support: jQuery <1.8
	// http://bugs.jquery.com/ticket/11778
	setTimeout(function(){complete(jqXHR,status);},1);});}},_ajaxSettings:function _ajaxSettings(anchor,event,eventData){var that=this;return{// Support: IE <11 only
	// Strip any hash that exists to prevent errors with the Ajax request
	url:anchor.attr("href").replace(/#.*$/,""),beforeSend:function beforeSend(jqXHR,settings){return that._trigger("beforeLoad",event,$.extend({jqXHR:jqXHR,ajaxSettings:settings},eventData));}};},_getPanelForTab:function _getPanelForTab(tab){var id=$(tab).attr("aria-controls");return this.element.find(this._sanitizeSelector("#"+id));}});// DEPRECATED
	// TODO: Switch return back to widget declaration at top of file when this is removed
	if($.uiBackCompat!==false){// Backcompat for ui-tab class (now ui-tabs-tab)
	$.widget("ui.tabs",$.ui.tabs,{_processTabs:function _processTabs(){this._superApply(arguments);this._addClass(this.tabs,"ui-tab");}});}var widgetsTabs=$.ui.tabs;/*!
	 * jQuery UI Tooltip 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *///>>label: Tooltip
	//>>group: Widgets
	//>>description: Shows additional information for any element on hover or focus.
	//>>docs: http://api.jqueryui.com/tooltip/
	//>>demos: http://jqueryui.com/tooltip/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/tooltip.css
	//>>css.theme: ../../themes/base/theme.css
	$.widget("ui.tooltip",{version:"1.12.1",options:{classes:{"ui-tooltip":"ui-corner-all ui-widget-shadow"},content:function content(){// support: IE<9, Opera in jQuery <1.7
	// .text() can't accept undefined, so coerce to a string
	var title=$(this).attr("title")||"";// Escape title, since we're going from an attribute to raw HTML
	return $("<a>").text(title).html();},hide:true,// Disabled elements have inconsistent behavior across browsers (#8661)
	items:"[title]:not([disabled])",position:{my:"left top+15",at:"left bottom",collision:"flipfit flip"},show:true,track:false,// Callbacks
	close:null,open:null},_addDescribedBy:function _addDescribedBy(elem,id){var describedby=(elem.attr("aria-describedby")||"").split(/\s+/);describedby.push(id);elem.data("ui-tooltip-id",id).attr("aria-describedby",$.trim(describedby.join(" ")));},_removeDescribedBy:function _removeDescribedBy(elem){var id=elem.data("ui-tooltip-id"),describedby=(elem.attr("aria-describedby")||"").split(/\s+/),index=$.inArray(id,describedby);if(index!==-1){describedby.splice(index,1);}elem.removeData("ui-tooltip-id");describedby=$.trim(describedby.join(" "));if(describedby){elem.attr("aria-describedby",describedby);}else{elem.removeAttr("aria-describedby");}},_create:function _create(){this._on({mouseover:"open",focusin:"open"});// IDs of generated tooltips, needed for destroy
	this.tooltips={};// IDs of parent tooltips where we removed the title attribute
	this.parents={};// Append the aria-live region so tooltips announce correctly
	this.liveRegion=$("<div>").attr({role:"log","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body);this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible");this.disabledTitles=$([]);},_setOption:function _setOption(key,value){var that=this;this._super(key,value);if(key==="content"){$.each(this.tooltips,function(id,tooltipData){that._updateContent(tooltipData.element);});}},_setOptionDisabled:function _setOptionDisabled(value){this[value?"_disable":"_enable"]();},_disable:function _disable(){var that=this;// Close open tooltips
	$.each(this.tooltips,function(id,tooltipData){var event=$.Event("blur");event.target=event.currentTarget=tooltipData.element[0];that.close(event,true);});// Remove title attributes to prevent native tooltips
	this.disabledTitles=this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function(){var element=$(this);if(element.is("[title]")){return element.data("ui-tooltip-title",element.attr("title")).removeAttr("title");}}));},_enable:function _enable(){// restore title attributes
	this.disabledTitles.each(function(){var element=$(this);if(element.data("ui-tooltip-title")){element.attr("title",element.data("ui-tooltip-title"));}});this.disabledTitles=$([]);},open:function open(event){var that=this,target=$(event?event.target:this.element)// we need closest here due to mouseover bubbling,
	// but always pointing at the same event target
	.closest(this.options.items);// No element to show a tooltip for or the tooltip is already open
	if(!target.length||target.data("ui-tooltip-id")){return;}if(target.attr("title")){target.data("ui-tooltip-title",target.attr("title"));}target.data("ui-tooltip-open",true);// Kill parent tooltips, custom or native, for hover
	if(event&&event.type==="mouseover"){target.parents().each(function(){var parent=$(this),blurEvent;if(parent.data("ui-tooltip-open")){blurEvent=$.Event("blur");blurEvent.target=blurEvent.currentTarget=this;that.close(blurEvent,true);}if(parent.attr("title")){parent.uniqueId();that.parents[this.id]={element:this,title:parent.attr("title")};parent.attr("title","");}});}this._registerCloseHandlers(event,target);this._updateContent(target,event);},_updateContent:function _updateContent(target,event){var content,contentOption=this.options.content,that=this,eventType=event?event.type:null;if(typeof contentOption==="string"||contentOption.nodeType||contentOption.jquery){return this._open(event,target,contentOption);}content=contentOption.call(target[0],function(response){// IE may instantly serve a cached response for ajax requests
	// delay this call to _open so the other call to _open runs first
	that._delay(function(){// Ignore async response if tooltip was closed already
	if(!target.data("ui-tooltip-open")){return;}// JQuery creates a special event for focusin when it doesn't
	// exist natively. To improve performance, the native event
	// object is reused and the type is changed. Therefore, we can't
	// rely on the type being correct after the event finished
	// bubbling, so we set it back to the previous value. (#8740)
	if(event){event.type=eventType;}this._open(event,target,response);});});if(content){this._open(event,target,content);}},_open:function _open(event,target,content){var tooltipData,tooltip,delayedShow,a11yContent,positionOption=$.extend({},this.options.position);if(!content){return;}// Content can be updated multiple times. If the tooltip already
	// exists, then just update the content and bail.
	tooltipData=this._find(target);if(tooltipData){tooltipData.tooltip.find(".ui-tooltip-content").html(content);return;}// If we have a title, clear it to prevent the native tooltip
	// we have to check first to avoid defining a title if none exists
	// (we don't want to cause an element to start matching [title])
	//
	// We use removeAttr only for key events, to allow IE to export the correct
	// accessible attributes. For mouse events, set to empty string to avoid
	// native tooltip showing up (happens only when removing inside mouseover).
	if(target.is("[title]")){if(event&&event.type==="mouseover"){target.attr("title","");}else{target.removeAttr("title");}}tooltipData=this._tooltip(target);tooltip=tooltipData.tooltip;this._addDescribedBy(target,tooltip.attr("id"));tooltip.find(".ui-tooltip-content").html(content);// Support: Voiceover on OS X, JAWS on IE <= 9
	// JAWS announces deletions even when aria-relevant="additions"
	// Voiceover will sometimes re-read the entire log region's contents from the beginning
	this.liveRegion.children().hide();a11yContent=$("<div>").html(tooltip.find(".ui-tooltip-content").html());a11yContent.removeAttr("name").find("[name]").removeAttr("name");a11yContent.removeAttr("id").find("[id]").removeAttr("id");a11yContent.appendTo(this.liveRegion);function position(event){positionOption.of=event;if(tooltip.is(":hidden")){return;}tooltip.position(positionOption);}if(this.options.track&&event&&/^mouse/.test(event.type)){this._on(this.document,{mousemove:position});// trigger once to override element-relative positioning
	position(event);}else{tooltip.position($.extend({of:target},this.options.position));}tooltip.hide();this._show(tooltip,this.options.show);// Handle tracking tooltips that are shown with a delay (#8644). As soon
	// as the tooltip is visible, position the tooltip using the most recent
	// event.
	// Adds the check to add the timers only when both delay and track options are set (#14682)
	if(this.options.track&&this.options.show&&this.options.show.delay){delayedShow=this.delayedShow=setInterval(function(){if(tooltip.is(":visible")){position(positionOption.of);clearInterval(delayedShow);}},$.fx.interval);}this._trigger("open",event,{tooltip:tooltip});},_registerCloseHandlers:function _registerCloseHandlers(event,target){var events={keyup:function keyup(event){if(event.keyCode===$.ui.keyCode.ESCAPE){var fakeEvent=$.Event(event);fakeEvent.currentTarget=target[0];this.close(fakeEvent,true);}}};// Only bind remove handler for delegated targets. Non-delegated
	// tooltips will handle this in destroy.
	if(target[0]!==this.element[0]){events.remove=function(){this._removeTooltip(this._find(target).tooltip);};}if(!event||event.type==="mouseover"){events.mouseleave="close";}if(!event||event.type==="focusin"){events.focusout="close";}this._on(true,target,events);},close:function close(event){var tooltip,that=this,target=$(event?event.currentTarget:this.element),tooltipData=this._find(target);// The tooltip may already be closed
	if(!tooltipData){// We set ui-tooltip-open immediately upon open (in open()), but only set the
	// additional data once there's actually content to show (in _open()). So even if the
	// tooltip doesn't have full data, we always remove ui-tooltip-open in case we're in
	// the period between open() and _open().
	target.removeData("ui-tooltip-open");return;}tooltip=tooltipData.tooltip;// Disabling closes the tooltip, so we need to track when we're closing
	// to avoid an infinite loop in case the tooltip becomes disabled on close
	if(tooltipData.closing){return;}// Clear the interval for delayed tracking tooltips
	clearInterval(this.delayedShow);// Only set title if we had one before (see comment in _open())
	// If the title attribute has changed since open(), don't restore
	if(target.data("ui-tooltip-title")&&!target.attr("title")){target.attr("title",target.data("ui-tooltip-title"));}this._removeDescribedBy(target);tooltipData.hiding=true;tooltip.stop(true);this._hide(tooltip,this.options.hide,function(){that._removeTooltip($(this));});target.removeData("ui-tooltip-open");this._off(target,"mouseleave focusout keyup");// Remove 'remove' binding only on delegated targets
	if(target[0]!==this.element[0]){this._off(target,"remove");}this._off(this.document,"mousemove");if(event&&event.type==="mouseleave"){$.each(this.parents,function(id,parent){$(parent.element).attr("title",parent.title);delete that.parents[id];});}tooltipData.closing=true;this._trigger("close",event,{tooltip:tooltip});if(!tooltipData.hiding){tooltipData.closing=false;}},_tooltip:function _tooltip(element){var tooltip=$("<div>").attr("role","tooltip"),content=$("<div>").appendTo(tooltip),id=tooltip.uniqueId().attr("id");this._addClass(content,"ui-tooltip-content");this._addClass(tooltip,"ui-tooltip","ui-widget ui-widget-content");tooltip.appendTo(this._appendTo(element));return this.tooltips[id]={element:element,tooltip:tooltip};},_find:function _find(target){var id=target.data("ui-tooltip-id");return id?this.tooltips[id]:null;},_removeTooltip:function _removeTooltip(tooltip){tooltip.remove();delete this.tooltips[tooltip.attr("id")];},_appendTo:function _appendTo(target){var element=target.closest(".ui-front, dialog");if(!element.length){element=this.document[0].body;}return element;},_destroy:function _destroy(){var that=this;// Close open tooltips
	$.each(this.tooltips,function(id,tooltipData){// Delegate to close method to handle common cleanup
	var event=$.Event("blur"),element=tooltipData.element;event.target=event.currentTarget=element[0];that.close(event,true);// Remove immediately; destroying an open tooltip doesn't use the
	// hide animation
	$("#"+id).remove();// Restore the title
	if(element.data("ui-tooltip-title")){// If the title attribute has changed since open(), don't restore
	if(!element.attr("title")){element.attr("title",element.data("ui-tooltip-title"));}element.removeData("ui-tooltip-title");}});this.liveRegion.remove();}});// DEPRECATED
	// TODO: Switch return back to widget declaration at top of file when this is removed
	if($.uiBackCompat!==false){// Backcompat for tooltipClass option
	$.widget("ui.tooltip",$.ui.tooltip,{options:{tooltipClass:null},_tooltip:function _tooltip(){var tooltipData=this._superApply(arguments);if(this.options.tooltipClass){tooltipData.tooltip.addClass(this.options.tooltipClass);}return tooltipData;}});}var widgetsTooltip=$.ui.tooltip;});

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _echarts = __webpack_require__(215);
	
	(function () {
	  for (var key in _echarts) {
	    if (_echarts == null || !_echarts.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
	    exports[key] = _echarts[key];
	  }
	})();
	
	var _export = __webpack_require__(339);
	
	(function () {
	  for (var key in _export) {
	    if (_export == null || !_export.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
	    exports[key] = _export[key];
	  }
	})();
	
	__webpack_require__(335);
	
	__webpack_require__(366);
	
	__webpack_require__(395);
	
	__webpack_require__(402);
	
	__webpack_require__(413);
	
	__webpack_require__(417);
	
	__webpack_require__(427);
	
	__webpack_require__(451);
	
	__webpack_require__(460);
	
	__webpack_require__(470);
	
	__webpack_require__(493);
	
	__webpack_require__(497);
	
	__webpack_require__(501);
	
	__webpack_require__(518);
	
	__webpack_require__(524);
	
	__webpack_require__(530);
	
	__webpack_require__(536);
	
	__webpack_require__(540);
	
	__webpack_require__(549);
	
	__webpack_require__(553);
	
	__webpack_require__(556);
	
	__webpack_require__(578);
	
	__webpack_require__(584);
	
	__webpack_require__(590);
	
	__webpack_require__(591);
	
	__webpack_require__(604);
	
	__webpack_require__(557);
	
	__webpack_require__(502);
	
	__webpack_require__(607);
	
	__webpack_require__(611);
	
	__webpack_require__(612);
	
	__webpack_require__(634);
	
	__webpack_require__(564);
	
	__webpack_require__(639);
	
	__webpack_require__(648);
	
	__webpack_require__(649);
	
	__webpack_require__(658);
	
	__webpack_require__(664);
	
	__webpack_require__(667);
	
	__webpack_require__(670);
	
	__webpack_require__(671);
	
	__webpack_require__(679);
	
	__webpack_require__(683);
	
	__webpack_require__(680);
	
	__webpack_require__(687);
	
	__webpack_require__(688);
	
	__webpack_require__(699);
	
	__webpack_require__(702);
	
	__webpack_require__(706);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var zrender = __webpack_require__(217);
	
	var zrUtil = __webpack_require__(220);
	
	var colorTool = __webpack_require__(238);
	
	var env = __webpack_require__(219);
	
	var timsort = __webpack_require__(243);
	
	var Eventful = __webpack_require__(224);
	
	var GlobalModel = __webpack_require__(260);
	
	var ExtensionAPI = __webpack_require__(314);
	
	var CoordinateSystemManager = __webpack_require__(315);
	
	var OptionManager = __webpack_require__(316);
	
	var backwardCompat = __webpack_require__(317);
	
	var dataStack = __webpack_require__(319);
	
	var ComponentModel = __webpack_require__(303);
	
	var SeriesModel = __webpack_require__(320);
	
	var ComponentView = __webpack_require__(324);
	
	var ChartView = __webpack_require__(325);
	
	var graphic = __webpack_require__(268);
	
	var modelUtil = __webpack_require__(261);
	
	var _throttle = __webpack_require__(327);
	
	var throttle = _throttle.throttle;
	
	var seriesColor = __webpack_require__(328);
	
	var aria = __webpack_require__(329);
	
	var loadingDefault = __webpack_require__(331);
	
	var Scheduler = __webpack_require__(332);
	
	var lightTheme = __webpack_require__(333);
	
	var darkTheme = __webpack_require__(334);
	
	__webpack_require__(335);
	
	var mapDataStorage = __webpack_require__(336);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var assert = zrUtil.assert;
	var each = zrUtil.each;
	var isFunction = zrUtil.isFunction;
	var isObject = zrUtil.isObject;
	var parseClassType = ComponentModel.parseClassType;
	var version = '4.9.0';
	var dependencies = {
	  zrender: '4.3.2'
	};
	var TEST_FRAME_REMAIN_TIME = 1;
	var PRIORITY_PROCESSOR_FILTER = 1000;
	var PRIORITY_PROCESSOR_SERIES_FILTER = 800;
	var PRIORITY_PROCESSOR_DATASTACK = 900;
	var PRIORITY_PROCESSOR_STATISTIC = 5000;
	var PRIORITY_VISUAL_LAYOUT = 1000;
	var PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
	var PRIORITY_VISUAL_GLOBAL = 2000;
	var PRIORITY_VISUAL_CHART = 3000;
	var PRIORITY_VISUAL_POST_CHART_LAYOUT = 3500;
	var PRIORITY_VISUAL_COMPONENT = 4000; // FIXME
	// necessary?
	
	var PRIORITY_VISUAL_BRUSH = 5000;
	var PRIORITY = {
	  PROCESSOR: {
	    FILTER: PRIORITY_PROCESSOR_FILTER,
	    SERIES_FILTER: PRIORITY_PROCESSOR_SERIES_FILTER,
	    STATISTIC: PRIORITY_PROCESSOR_STATISTIC
	  },
	  VISUAL: {
	    LAYOUT: PRIORITY_VISUAL_LAYOUT,
	    PROGRESSIVE_LAYOUT: PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
	    GLOBAL: PRIORITY_VISUAL_GLOBAL,
	    CHART: PRIORITY_VISUAL_CHART,
	    POST_CHART_LAYOUT: PRIORITY_VISUAL_POST_CHART_LAYOUT,
	    COMPONENT: PRIORITY_VISUAL_COMPONENT,
	    BRUSH: PRIORITY_VISUAL_BRUSH
	  }
	}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
	// where they must not be invoked nestedly, except the only case: invoke
	// dispatchAction with updateMethod "none" in main process.
	// This flag is used to carry out this rule.
	// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
	
	var IN_MAIN_PROCESS = '__flagInMainProcess';
	var OPTION_UPDATED = '__optionUpdated';
	var ACTION_REG = /^[a-zA-Z0-9_]+$/;
	
	function createRegisterEventWithLowercaseName(method, ignoreDisposed) {
	  return function (eventName, handler, context) {
	    if (!ignoreDisposed && this._disposed) {
	      disposedWarning(this.id);
	      return;
	    } // Event name is all lowercase
	
	
	    eventName = eventName && eventName.toLowerCase();
	    Eventful.prototype[method].call(this, eventName, handler, context);
	  };
	}
	/**
	 * @module echarts~MessageCenter
	 */
	
	
	function MessageCenter() {
	  Eventful.call(this);
	}
	
	MessageCenter.prototype.on = createRegisterEventWithLowercaseName('on', true);
	MessageCenter.prototype.off = createRegisterEventWithLowercaseName('off', true);
	MessageCenter.prototype.one = createRegisterEventWithLowercaseName('one', true);
	zrUtil.mixin(MessageCenter, Eventful);
	/**
	 * @module echarts~ECharts
	 */
	
	function ECharts(dom, theme, opts) {
	  opts = opts || {}; // Get theme by name
	
	  if (typeof theme === 'string') {
	    theme = themeStorage[theme];
	  }
	  /**
	   * @type {string}
	   */
	
	
	  this.id;
	  /**
	   * Group id
	   * @type {string}
	   */
	
	  this.group;
	  /**
	   * @type {HTMLElement}
	   * @private
	   */
	
	  this._dom = dom;
	  var defaultRenderer = 'canvas';
	
	  /**
	   * @type {module:zrender/ZRender}
	   * @private
	   */
	  var zr = this._zr = zrender.init(dom, {
	    renderer: opts.renderer || defaultRenderer,
	    devicePixelRatio: opts.devicePixelRatio,
	    width: opts.width,
	    height: opts.height
	  });
	  /**
	   * Expect 60 fps.
	   * @type {Function}
	   * @private
	   */
	
	  this._throttledZrFlush = throttle(zrUtil.bind(zr.flush, zr), 17);
	  var theme = zrUtil.clone(theme);
	  theme && backwardCompat(theme, true);
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._theme = theme;
	  /**
	   * @type {Array.<module:echarts/view/Chart>}
	   * @private
	   */
	
	  this._chartsViews = [];
	  /**
	   * @type {Object.<string, module:echarts/view/Chart>}
	   * @private
	   */
	
	  this._chartsMap = {};
	  /**
	   * @type {Array.<module:echarts/view/Component>}
	   * @private
	   */
	
	  this._componentsViews = [];
	  /**
	   * @type {Object.<string, module:echarts/view/Component>}
	   * @private
	   */
	
	  this._componentsMap = {};
	  /**
	   * @type {module:echarts/CoordinateSystem}
	   * @private
	   */
	
	  this._coordSysMgr = new CoordinateSystemManager();
	  /**
	   * @type {module:echarts/ExtensionAPI}
	   * @private
	   */
	
	  var api = this._api = createExtensionAPI(this); // Sort on demand
	
	  function prioritySortFunc(a, b) {
	    return a.__prio - b.__prio;
	  }
	
	  timsort(visualFuncs, prioritySortFunc);
	  timsort(dataProcessorFuncs, prioritySortFunc);
	  /**
	   * @type {module:echarts/stream/Scheduler}
	   */
	
	  this._scheduler = new Scheduler(this, api, dataProcessorFuncs, visualFuncs);
	  Eventful.call(this, this._ecEventProcessor = new EventProcessor());
	  /**
	   * @type {module:echarts~MessageCenter}
	   * @private
	   */
	
	  this._messageCenter = new MessageCenter(); // Init mouse events
	
	  this._initEvents(); // In case some people write `window.onresize = chart.resize`
	
	
	  this.resize = zrUtil.bind(this.resize, this); // Can't dispatch action during rendering procedure
	
	  this._pendingActions = [];
	  zr.animation.on('frame', this._onframe, this);
	  bindRenderedEvent(zr, this); // ECharts instance can be used as value.
	
	  zrUtil.setAsPrimitive(this);
	}
	
	var echartsProto = ECharts.prototype;
	
	echartsProto._onframe = function () {
	  if (this._disposed) {
	    return;
	  }
	
	  var scheduler = this._scheduler; // Lazy update
	
	  if (this[OPTION_UPDATED]) {
	    var silent = this[OPTION_UPDATED].silent;
	    this[IN_MAIN_PROCESS] = true;
	    prepare(this);
	    updateMethods.update.call(this);
	    this[IN_MAIN_PROCESS] = false;
	    this[OPTION_UPDATED] = false;
	    flushPendingActions.call(this, silent);
	    triggerUpdatedEvent.call(this, silent);
	  } // Avoid do both lazy update and progress in one frame.
	  else if (scheduler.unfinished) {
	      // Stream progress.
	      var remainTime = TEST_FRAME_REMAIN_TIME;
	      var ecModel = this._model;
	      var api = this._api;
	      scheduler.unfinished = false;
	
	      do {
	        var startTime = +new Date();
	        scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.
	
	        scheduler.performDataProcessorTasks(ecModel);
	        updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
	        // each frame is not a good user experience. So we follow the rule that
	        // the extent of the coordinate system is determin in the first frame (the
	        // frame is executed immedietely after task reset.
	        // this._coordSysMgr.update(ecModel, api);
	        // console.log('--- ec frame visual ---', remainTime);
	
	        scheduler.performVisualTasks(ecModel);
	        renderSeries(this, this._model, api, 'remain');
	        remainTime -= +new Date() - startTime;
	      } while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.
	
	
	      if (!scheduler.unfinished) {
	        this._zr.flush();
	      } // Else, zr flushing be ensue within the same frame,
	      // because zr flushing is after onframe event.
	
	    }
	};
	/**
	 * @return {HTMLElement}
	 */
	
	
	echartsProto.getDom = function () {
	  return this._dom;
	};
	/**
	 * @return {module:zrender~ZRender}
	 */
	
	
	echartsProto.getZr = function () {
	  return this._zr;
	};
	/**
	 * Usage:
	 * chart.setOption(option, notMerge, lazyUpdate);
	 * chart.setOption(option, {
	 *     notMerge: ...,
	 *     lazyUpdate: ...,
	 *     silent: ...
	 * });
	 *
	 * @param {Object} option
	 * @param {Object|boolean} [opts] opts or notMerge.
	 * @param {boolean} [opts.notMerge=false]
	 * @param {boolean} [opts.lazyUpdate=false] Useful when setOption frequently.
	 */
	
	
	echartsProto.setOption = function (option, notMerge, lazyUpdate) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var silent;
	
	  if (isObject(notMerge)) {
	    lazyUpdate = notMerge.lazyUpdate;
	    silent = notMerge.silent;
	    notMerge = notMerge.notMerge;
	  }
	
	  this[IN_MAIN_PROCESS] = true;
	
	  if (!this._model || notMerge) {
	    var optionManager = new OptionManager(this._api);
	    var theme = this._theme;
	    var ecModel = this._model = new GlobalModel();
	    ecModel.scheduler = this._scheduler;
	    ecModel.init(null, null, theme, optionManager);
	  }
	
	  this._model.setOption(option, optionPreprocessorFuncs);
	
	  if (lazyUpdate) {
	    this[OPTION_UPDATED] = {
	      silent: silent
	    };
	    this[IN_MAIN_PROCESS] = false;
	  } else {
	    prepare(this);
	    updateMethods.update.call(this); // Ensure zr refresh sychronously, and then pixel in canvas can be
	    // fetched after `setOption`.
	
	    this._zr.flush();
	
	    this[OPTION_UPDATED] = false;
	    this[IN_MAIN_PROCESS] = false;
	    flushPendingActions.call(this, silent);
	    triggerUpdatedEvent.call(this, silent);
	  }
	};
	/**
	 * @DEPRECATED
	 */
	
	
	echartsProto.setTheme = function () {
	  console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
	};
	/**
	 * @return {module:echarts/model/Global}
	 */
	
	
	echartsProto.getModel = function () {
	  return this._model;
	};
	/**
	 * @return {Object}
	 */
	
	
	echartsProto.getOption = function () {
	  return this._model && this._model.getOption();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getWidth = function () {
	  return this._zr.getWidth();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getHeight = function () {
	  return this._zr.getHeight();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getDevicePixelRatio = function () {
	  return this._zr.painter.dpr || window.devicePixelRatio || 1;
	};
	/**
	 * Get canvas which has all thing rendered
	 * @param {Object} opts
	 * @param {string} [opts.backgroundColor]
	 * @return {string}
	 */
	
	
	echartsProto.getRenderedCanvas = function (opts) {
	  if (!env.canvasSupported) {
	    return;
	  }
	
	  opts = opts || {};
	  opts.pixelRatio = opts.pixelRatio || 1;
	  opts.backgroundColor = opts.backgroundColor || this._model.get('backgroundColor');
	  var zr = this._zr; // var list = zr.storage.getDisplayList();
	  // Stop animations
	  // Never works before in init animation, so remove it.
	  // zrUtil.each(list, function (el) {
	  //     el.stopAnimation(true);
	  // });
	
	  return zr.painter.getRenderedCanvas(opts);
	};
	/**
	 * Get svg data url
	 * @return {string}
	 */
	
	
	echartsProto.getSvgDataURL = function () {
	  if (!env.svgSupported) {
	    return;
	  }
	
	  var zr = this._zr;
	  var list = zr.storage.getDisplayList(); // Stop animations
	
	  zrUtil.each(list, function (el) {
	    el.stopAnimation(true);
	  });
	  return zr.painter.toDataURL();
	};
	/**
	 * @return {string}
	 * @param {Object} opts
	 * @param {string} [opts.type='png']
	 * @param {string} [opts.pixelRatio=1]
	 * @param {string} [opts.backgroundColor]
	 * @param {string} [opts.excludeComponents]
	 */
	
	
	echartsProto.getDataURL = function (opts) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  opts = opts || {};
	  var excludeComponents = opts.excludeComponents;
	  var ecModel = this._model;
	  var excludesComponentViews = [];
	  var self = this;
	  each(excludeComponents, function (componentType) {
	    ecModel.eachComponent({
	      mainType: componentType
	    }, function (component) {
	      var view = self._componentsMap[component.__viewId];
	
	      if (!view.group.ignore) {
	        excludesComponentViews.push(view);
	        view.group.ignore = true;
	      }
	    });
	  });
	  var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
	  each(excludesComponentViews, function (view) {
	    view.group.ignore = false;
	  });
	  return url;
	};
	/**
	 * @return {string}
	 * @param {Object} opts
	 * @param {string} [opts.type='png']
	 * @param {string} [opts.pixelRatio=1]
	 * @param {string} [opts.backgroundColor]
	 */
	
	
	echartsProto.getConnectedDataURL = function (opts) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  if (!env.canvasSupported) {
	    return;
	  }
	
	  var isSvg = opts.type === 'svg';
	  var groupId = this.group;
	  var mathMin = Math.min;
	  var mathMax = Math.max;
	  var MAX_NUMBER = Infinity;
	
	  if (connectedGroups[groupId]) {
	    var left = MAX_NUMBER;
	    var top = MAX_NUMBER;
	    var right = -MAX_NUMBER;
	    var bottom = -MAX_NUMBER;
	    var canvasList = [];
	    var dpr = opts && opts.pixelRatio || 1;
	    zrUtil.each(instances, function (chart, id) {
	      if (chart.group === groupId) {
	        var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas(zrUtil.clone(opts));
	        var boundingRect = chart.getDom().getBoundingClientRect();
	        left = mathMin(boundingRect.left, left);
	        top = mathMin(boundingRect.top, top);
	        right = mathMax(boundingRect.right, right);
	        bottom = mathMax(boundingRect.bottom, bottom);
	        canvasList.push({
	          dom: canvas,
	          left: boundingRect.left,
	          top: boundingRect.top
	        });
	      }
	    });
	    left *= dpr;
	    top *= dpr;
	    right *= dpr;
	    bottom *= dpr;
	    var width = right - left;
	    var height = bottom - top;
	    var targetCanvas = zrUtil.createCanvas();
	    var zr = zrender.init(targetCanvas, {
	      renderer: isSvg ? 'svg' : 'canvas'
	    });
	    zr.resize({
	      width: width,
	      height: height
	    });
	
	    if (isSvg) {
	      var content = '';
	      each(canvasList, function (item) {
	        var x = item.left - left;
	        var y = item.top - top;
	        content += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
	      });
	      zr.painter.getSvgRoot().innerHTML = content;
	
	      if (opts.connectedBackgroundColor) {
	        zr.painter.setBackgroundColor(opts.connectedBackgroundColor);
	      }
	
	      zr.refreshImmediately();
	      return zr.painter.toDataURL();
	    } else {
	      // Background between the charts
	      if (opts.connectedBackgroundColor) {
	        zr.add(new graphic.Rect({
	          shape: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          },
	          style: {
	            fill: opts.connectedBackgroundColor
	          }
	        }));
	      }
	
	      each(canvasList, function (item) {
	        var img = new graphic.Image({
	          style: {
	            x: item.left * dpr - left,
	            y: item.top * dpr - top,
	            image: item.dom
	          }
	        });
	        zr.add(img);
	      });
	      zr.refreshImmediately();
	      return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
	    }
	  } else {
	    return this.getDataURL(opts);
	  }
	};
	/**
	 * Convert from logical coordinate system to pixel coordinate system.
	 * See CoordinateSystem#convertToPixel.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId, geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName,
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {Array|number} result
	 */
	
	
	echartsProto.convertToPixel = zrUtil.curry(doConvertPixel, 'convertToPixel');
	/**
	 * Convert from pixel coordinate system to logical coordinate system.
	 * See CoordinateSystem#convertFromPixel.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId / geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {Array|number} result
	 */
	
	echartsProto.convertFromPixel = zrUtil.curry(doConvertPixel, 'convertFromPixel');
	
	function doConvertPixel(methodName, finder, value) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var ecModel = this._model;
	
	  var coordSysList = this._coordSysMgr.getCoordinateSystems();
	
	  var result;
	  finder = modelUtil.parseFinder(ecModel, finder);
	
	  for (var i = 0; i < coordSysList.length; i++) {
	    var coordSys = coordSysList[i];
	
	    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, finder, value)) != null) {
	      return result;
	    }
	  }
	}
	/**
	 * Is the specified coordinate systems or components contain the given pixel point.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId / geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName,
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {boolean} result
	 */
	
	
	echartsProto.containPixel = function (finder, value) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var ecModel = this._model;
	  var result;
	  finder = modelUtil.parseFinder(ecModel, finder);
	  zrUtil.each(finder, function (models, key) {
	    key.indexOf('Models') >= 0 && zrUtil.each(models, function (model) {
	      var coordSys = model.coordinateSystem;
	
	      if (coordSys && coordSys.containPoint) {
	        result |= !!coordSys.containPoint(value);
	      } else if (key === 'seriesModels') {
	        var view = this._chartsMap[model.__viewId];
	
	        if (view && view.containPoint) {
	          result |= view.containPoint(value, model);
	        } else {}
	      } else {}
	    }, this);
	  }, this);
	  return !!result;
	};
	/**
	 * Get visual from series or data.
	 * @param {string|Object} finder
	 *        If string, e.g., 'series', means {seriesIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            dataIndex / dataIndexInside
	 *        }
	 *        If dataIndex is not specified, series visual will be fetched,
	 *        but not data item visual.
	 *        If all of seriesIndex, seriesId, seriesName are not specified,
	 *        visual will be fetched from first series.
	 * @param {string} visualType 'color', 'symbol', 'symbolSize'
	 */
	
	
	echartsProto.getVisual = function (finder, visualType) {
	  var ecModel = this._model;
	  finder = modelUtil.parseFinder(ecModel, finder, {
	    defaultMainType: 'series'
	  });
	  var seriesModel = finder.seriesModel;
	  var data = seriesModel.getData();
	  var dataIndexInside = finder.hasOwnProperty('dataIndexInside') ? finder.dataIndexInside : finder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(finder.dataIndex) : null;
	  return dataIndexInside != null ? data.getItemVisual(dataIndexInside, visualType) : data.getVisual(visualType);
	};
	/**
	 * Get view of corresponding component model
	 * @param  {module:echarts/model/Component} componentModel
	 * @return {module:echarts/view/Component}
	 */
	
	
	echartsProto.getViewOfComponentModel = function (componentModel) {
	  return this._componentsMap[componentModel.__viewId];
	};
	/**
	 * Get view of corresponding series model
	 * @param  {module:echarts/model/Series} seriesModel
	 * @return {module:echarts/view/Chart}
	 */
	
	
	echartsProto.getViewOfSeriesModel = function (seriesModel) {
	  return this._chartsMap[seriesModel.__viewId];
	};
	
	var updateMethods = {
	  prepareAndUpdate: function (payload) {
	    prepare(this);
	    updateMethods.update.call(this, payload);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  update: function (payload) {
	    // console.profile && console.profile('update');
	    var ecModel = this._model;
	    var api = this._api;
	    var zr = this._zr;
	    var coordSysMgr = this._coordSysMgr;
	    var scheduler = this._scheduler; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    scheduler.restoreData(ecModel, payload);
	    scheduler.performSeriesTasks(ecModel); // TODO
	    // Save total ecModel here for undo/redo (after restoring data and before processing data).
	    // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
	    // Create new coordinate system each update
	    // In LineView may save the old coordinate system and use it to get the orignal point
	
	    coordSysMgr.create(ecModel, api);
	    scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
	    // stream modes after data processing, where the filtered data is used to
	    // deteming whether use progressive rendering.
	
	    updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
	    // can be fetched when coord sys updating (consider the barGrid extent fix). But
	    // the drawback is the full coord info can not be fetched. Fortunately this full
	    // coord is not requied in stream mode updater currently.
	
	    coordSysMgr.update(ecModel, api);
	    clearColorPalette(ecModel);
	    scheduler.performVisualTasks(ecModel, payload);
	    render(this, ecModel, api, payload); // Set background
	
	    var backgroundColor = ecModel.get('backgroundColor') || 'transparent'; // In IE8
	
	    if (!env.canvasSupported) {
	      var colorArr = colorTool.parse(backgroundColor);
	      backgroundColor = colorTool.stringify(colorArr, 'rgb');
	
	      if (colorArr[3] === 0) {
	        backgroundColor = 'transparent';
	      }
	    } else {
	      zr.setBackgroundColor(backgroundColor);
	    }
	
	    performPostUpdateFuncs(ecModel, api); // console.profile && console.profileEnd('update');
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateTransform: function (payload) {
	    var ecModel = this._model;
	    var ecIns = this;
	    var api = this._api; // update before setOption
	
	    if (!ecModel) {
	      return;
	    } // ChartView.markUpdateMethod(payload, 'updateTransform');
	
	
	    var componentDirtyList = [];
	    ecModel.eachComponent(function (componentType, componentModel) {
	      var componentView = ecIns.getViewOfComponentModel(componentModel);
	
	      if (componentView && componentView.__alive) {
	        if (componentView.updateTransform) {
	          var result = componentView.updateTransform(componentModel, ecModel, api, payload);
	          result && result.update && componentDirtyList.push(componentView);
	        } else {
	          componentDirtyList.push(componentView);
	        }
	      }
	    });
	    var seriesDirtyMap = zrUtil.createHashMap();
	    ecModel.eachSeries(function (seriesModel) {
	      var chartView = ecIns._chartsMap[seriesModel.__viewId];
	
	      if (chartView.updateTransform) {
	        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
	        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
	      } else {
	        seriesDirtyMap.set(seriesModel.uid, 1);
	      }
	    });
	    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
	
	    this._scheduler.performVisualTasks(ecModel, payload, {
	      setDirty: true,
	      dirtyMap: seriesDirtyMap
	    }); // Currently, not call render of components. Geo render cost a lot.
	    // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
	
	
	    renderSeries(ecIns, ecModel, api, payload, seriesDirtyMap);
	    performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateView: function (payload) {
	    var ecModel = this._model; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    ChartView.markUpdateMethod(payload, 'updateView');
	    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	
	    this._scheduler.performVisualTasks(ecModel, payload, {
	      setDirty: true
	    });
	
	    render(this, this._model, this._api, payload);
	    performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateVisual: function (payload) {
	    updateMethods.update.call(this, payload); // var ecModel = this._model;
	    // // update before setOption
	    // if (!ecModel) {
	    //     return;
	    // }
	    // ChartView.markUpdateMethod(payload, 'updateVisual');
	    // clearColorPalette(ecModel);
	    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // this._scheduler.performVisualTasks(ecModel, payload, {visualType: 'visual', setDirty: true});
	    // render(this, this._model, this._api, payload);
	    // performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateLayout: function (payload) {
	    updateMethods.update.call(this, payload); // var ecModel = this._model;
	    // // update before setOption
	    // if (!ecModel) {
	    //     return;
	    // }
	    // ChartView.markUpdateMethod(payload, 'updateLayout');
	    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
	    // this._scheduler.performVisualTasks(ecModel, payload, {setDirty: true});
	    // render(this, this._model, this._api, payload);
	    // performPostUpdateFuncs(ecModel, this._api);
	  }
	};
	
	function prepare(ecIns) {
	  var ecModel = ecIns._model;
	  var scheduler = ecIns._scheduler;
	  scheduler.restorePipelines(ecModel);
	  scheduler.prepareStageTasks();
	  prepareView(ecIns, 'component', ecModel, scheduler);
	  prepareView(ecIns, 'chart', ecModel, scheduler);
	  scheduler.plan();
	}
	/**
	 * @private
	 */
	
	
	function updateDirectly(ecIns, method, payload, mainType, subType) {
	  var ecModel = ecIns._model; // broadcast
	
	  if (!mainType) {
	    // FIXME
	    // Chart will not be update directly here, except set dirty.
	    // But there is no such scenario now.
	    each(ecIns._componentsViews.concat(ecIns._chartsViews), callView);
	    return;
	  }
	
	  var query = {};
	  query[mainType + 'Id'] = payload[mainType + 'Id'];
	  query[mainType + 'Index'] = payload[mainType + 'Index'];
	  query[mainType + 'Name'] = payload[mainType + 'Name'];
	  var condition = {
	    mainType: mainType,
	    query: query
	  };
	  subType && (condition.subType = subType); // subType may be '' by parseClassType;
	
	  var excludeSeriesId = payload.excludeSeriesId;
	
	  if (excludeSeriesId != null) {
	    excludeSeriesId = zrUtil.createHashMap(modelUtil.normalizeToArray(excludeSeriesId));
	  } // If dispatchAction before setOption, do nothing.
	
	
	  ecModel && ecModel.eachComponent(condition, function (model) {
	    if (!excludeSeriesId || excludeSeriesId.get(model.id) == null) {
	      callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
	    }
	  }, ecIns);
	
	  function callView(view) {
	    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
	  }
	}
	/**
	 * Resize the chart
	 * @param {Object} opts
	 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
	 * @param {boolean} [opts.silent=false]
	 */
	
	
	echartsProto.resize = function (opts) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this._zr.resize(opts);
	
	  var ecModel = this._model; // Resize loading effect
	
	  this._loadingFX && this._loadingFX.resize();
	
	  if (!ecModel) {
	    return;
	  }
	
	  var optionChanged = ecModel.resetOption('media');
	  var silent = opts && opts.silent;
	  this[IN_MAIN_PROCESS] = true;
	  optionChanged && prepare(this);
	  updateMethods.update.call(this);
	  this[IN_MAIN_PROCESS] = false;
	  flushPendingActions.call(this, silent);
	  triggerUpdatedEvent.call(this, silent);
	};
	
	function updateStreamModes(ecIns, ecModel) {
	  var chartsMap = ecIns._chartsMap;
	  var scheduler = ecIns._scheduler;
	  ecModel.eachSeries(function (seriesModel) {
	    scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
	  });
	}
	/**
	 * Show loading effect
	 * @param  {string} [name='default']
	 * @param  {Object} [cfg]
	 */
	
	
	echartsProto.showLoading = function (name, cfg) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  if (isObject(name)) {
	    cfg = name;
	    name = '';
	  }
	
	  name = name || 'default';
	  this.hideLoading();
	
	  if (!loadingEffects[name]) {
	    return;
	  }
	
	  var el = loadingEffects[name](this._api, cfg);
	  var zr = this._zr;
	  this._loadingFX = el;
	  zr.add(el);
	};
	/**
	 * Hide loading effect
	 */
	
	
	echartsProto.hideLoading = function () {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this._loadingFX && this._zr.remove(this._loadingFX);
	  this._loadingFX = null;
	};
	/**
	 * @param {Object} eventObj
	 * @return {Object}
	 */
	
	
	echartsProto.makeActionFromEvent = function (eventObj) {
	  var payload = zrUtil.extend({}, eventObj);
	  payload.type = eventActionMap[eventObj.type];
	  return payload;
	};
	/**
	 * @pubilc
	 * @param {Object} payload
	 * @param {string} [payload.type] Action type
	 * @param {Object|boolean} [opt] If pass boolean, means opt.silent
	 * @param {boolean} [opt.silent=false] Whether trigger events.
	 * @param {boolean} [opt.flush=undefined]
	 *                  true: Flush immediately, and then pixel in canvas can be fetched
	 *                      immediately. Caution: it might affect performance.
	 *                  false: Not flush.
	 *                  undefined: Auto decide whether perform flush.
	 */
	
	
	echartsProto.dispatchAction = function (payload, opt) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  if (!isObject(opt)) {
	    opt = {
	      silent: !!opt
	    };
	  }
	
	  if (!actions[payload.type]) {
	    return;
	  } // Avoid dispatch action before setOption. Especially in `connect`.
	
	
	  if (!this._model) {
	    return;
	  } // May dispatchAction in rendering procedure
	
	
	  if (this[IN_MAIN_PROCESS]) {
	    this._pendingActions.push(payload);
	
	    return;
	  }
	
	  doDispatchAction.call(this, payload, opt.silent);
	
	  if (opt.flush) {
	    this._zr.flush(true);
	  } else if (opt.flush !== false && env.browser.weChat) {
	    // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
	    // hang when sliding page (on touch event), which cause that zr does not
	    // refresh util user interaction finished, which is not expected.
	    // But `dispatchAction` may be called too frequently when pan on touch
	    // screen, which impacts performance if do not throttle them.
	    this._throttledZrFlush();
	  }
	
	  flushPendingActions.call(this, opt.silent);
	  triggerUpdatedEvent.call(this, opt.silent);
	};
	
	function doDispatchAction(payload, silent) {
	  var payloadType = payload.type;
	  var escapeConnect = payload.escapeConnect;
	  var actionWrap = actions[payloadType];
	  var actionInfo = actionWrap.actionInfo;
	  var cptType = (actionInfo.update || 'update').split(':');
	  var updateMethod = cptType.pop();
	  cptType = cptType[0] != null && parseClassType(cptType[0]);
	  this[IN_MAIN_PROCESS] = true;
	  var payloads = [payload];
	  var batched = false; // Batch action
	
	  if (payload.batch) {
	    batched = true;
	    payloads = zrUtil.map(payload.batch, function (item) {
	      item = zrUtil.defaults(zrUtil.extend({}, item), payload);
	      item.batch = null;
	      return item;
	    });
	  }
	
	  var eventObjBatch = [];
	  var eventObj;
	  var isHighDown = payloadType === 'highlight' || payloadType === 'downplay';
	  each(payloads, function (batchItem) {
	    // Action can specify the event by return it.
	    eventObj = actionWrap.action(batchItem, this._model, this._api); // Emit event outside
	
	    eventObj = eventObj || zrUtil.extend({}, batchItem); // Convert type to eventType
	
	    eventObj.type = actionInfo.event || eventObj.type;
	    eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.
	
	    if (isHighDown) {
	      // method, payload, mainType, subType
	      updateDirectly(this, updateMethod, batchItem, 'series');
	    } else if (cptType) {
	      updateDirectly(this, updateMethod, batchItem, cptType.main, cptType.sub);
	    }
	  }, this);
	
	  if (updateMethod !== 'none' && !isHighDown && !cptType) {
	    // Still dirty
	    if (this[OPTION_UPDATED]) {
	      // FIXME Pass payload ?
	      prepare(this);
	      updateMethods.update.call(this, payload);
	      this[OPTION_UPDATED] = false;
	    } else {
	      updateMethods[updateMethod].call(this, payload);
	    }
	  } // Follow the rule of action batch
	
	
	  if (batched) {
	    eventObj = {
	      type: actionInfo.event || payloadType,
	      escapeConnect: escapeConnect,
	      batch: eventObjBatch
	    };
	  } else {
	    eventObj = eventObjBatch[0];
	  }
	
	  this[IN_MAIN_PROCESS] = false;
	  !silent && this._messageCenter.trigger(eventObj.type, eventObj);
	}
	
	function flushPendingActions(silent) {
	  var pendingActions = this._pendingActions;
	
	  while (pendingActions.length) {
	    var payload = pendingActions.shift();
	    doDispatchAction.call(this, payload, silent);
	  }
	}
	
	function triggerUpdatedEvent(silent) {
	  !silent && this.trigger('updated');
	}
	/**
	 * Event `rendered` is triggered when zr
	 * rendered. It is useful for realtime
	 * snapshot (reflect animation).
	 *
	 * Event `finished` is triggered when:
	 * (1) zrender rendering finished.
	 * (2) initial animation finished.
	 * (3) progressive rendering finished.
	 * (4) no pending action.
	 * (5) no delayed setOption needs to be processed.
	 */
	
	
	function bindRenderedEvent(zr, ecIns) {
	  zr.on('rendered', function () {
	    ecIns.trigger('rendered'); // The `finished` event should not be triggered repeatly,
	    // so it should only be triggered when rendering indeed happend
	    // in zrender. (Consider the case that dipatchAction is keep
	    // triggering when mouse move).
	
	    if ( // Although zr is dirty if initial animation is not finished
	    // and this checking is called on frame, we also check
	    // animation finished for robustness.
	    zr.animation.isFinished() && !ecIns[OPTION_UPDATED] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) {
	      ecIns.trigger('finished');
	    }
	  });
	}
	/**
	 * @param {Object} params
	 * @param {number} params.seriesIndex
	 * @param {Array|TypedArray} params.data
	 */
	
	
	echartsProto.appendData = function (params) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var seriesIndex = params.seriesIndex;
	  var ecModel = this.getModel();
	  var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	  seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
	  // system, util some scenario require that. In the expected usage of
	  // `appendData`, the initial extent of coordinate system should better
	  // be fixed by axis `min`/`max` setting or initial data, otherwise if
	  // the extent changed while `appendData`, the location of the painted
	  // graphic elements have to be changed, which make the usage of
	  // `appendData` meaningless.
	
	  this._scheduler.unfinished = true;
	};
	/**
	 * Register event
	 * @method
	 */
	
	
	echartsProto.on = createRegisterEventWithLowercaseName('on', false);
	echartsProto.off = createRegisterEventWithLowercaseName('off', false);
	echartsProto.one = createRegisterEventWithLowercaseName('one', false);
	/**
	 * Prepare view instances of charts and components
	 * @param  {module:echarts/model/Global} ecModel
	 * @private
	 */
	
	function prepareView(ecIns, type, ecModel, scheduler) {
	  var isComponent = type === 'component';
	  var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
	  var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
	  var zr = ecIns._zr;
	  var api = ecIns._api;
	
	  for (var i = 0; i < viewList.length; i++) {
	    viewList[i].__alive = false;
	  }
	
	  isComponent ? ecModel.eachComponent(function (componentType, model) {
	    componentType !== 'series' && doPrepare(model);
	  }) : ecModel.eachSeries(doPrepare);
	
	  function doPrepare(model) {
	    // Consider: id same and type changed.
	    var viewId = '_ec_' + model.id + '_' + model.type;
	    var view = viewMap[viewId];
	
	    if (!view) {
	      var classType = parseClassType(model.type);
	      var Clazz = isComponent ? ComponentView.getClass(classType.main, classType.sub) : ChartView.getClass(classType.sub);
	      view = new Clazz();
	      view.init(ecModel, api);
	      viewMap[viewId] = view;
	      viewList.push(view);
	      zr.add(view.group);
	    }
	
	    model.__viewId = view.__id = viewId;
	    view.__alive = true;
	    view.__model = model;
	    view.group.__ecComponentInfo = {
	      mainType: model.mainType,
	      index: model.componentIndex
	    };
	    !isComponent && scheduler.prepareView(view, model, ecModel, api);
	  }
	
	  for (var i = 0; i < viewList.length;) {
	    var view = viewList[i];
	
	    if (!view.__alive) {
	      !isComponent && view.renderTask.dispose();
	      zr.remove(view.group);
	      view.dispose(ecModel, api);
	      viewList.splice(i, 1);
	      delete viewMap[view.__id];
	      view.__id = view.group.__ecComponentInfo = null;
	    } else {
	      i++;
	    }
	  }
	} // /**
	//  * Encode visual infomation from data after data processing
	//  *
	//  * @param {module:echarts/model/Global} ecModel
	//  * @param {object} layout
	//  * @param {boolean} [layoutFilter] `true`: only layout,
	//  *                                 `false`: only not layout,
	//  *                                 `null`/`undefined`: all.
	//  * @param {string} taskBaseTag
	//  * @private
	//  */
	// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
	//     each(visualFuncs, function (visual, index) {
	//         var isLayout = visual.isLayout;
	//         if (layoutFilter == null
	//             || (layoutFilter === false && !isLayout)
	//             || (layoutFilter === true && isLayout)
	//         ) {
	//             visual.func(ecModel, api, payload);
	//         }
	//     });
	// }
	
	
	function clearColorPalette(ecModel) {
	  ecModel.clearColorPalette();
	  ecModel.eachSeries(function (seriesModel) {
	    seriesModel.clearColorPalette();
	  });
	}
	
	function render(ecIns, ecModel, api, payload) {
	  renderComponents(ecIns, ecModel, api, payload);
	  each(ecIns._chartsViews, function (chart) {
	    chart.__alive = false;
	  });
	  renderSeries(ecIns, ecModel, api, payload); // Remove groups of unrendered charts
	
	  each(ecIns._chartsViews, function (chart) {
	    if (!chart.__alive) {
	      chart.remove(ecModel, api);
	    }
	  });
	}
	
	function renderComponents(ecIns, ecModel, api, payload, dirtyList) {
	  each(dirtyList || ecIns._componentsViews, function (componentView) {
	    var componentModel = componentView.__model;
	    componentView.render(componentModel, ecModel, api, payload);
	    updateZ(componentModel, componentView);
	  });
	}
	/**
	 * Render each chart and component
	 * @private
	 */
	
	
	function renderSeries(ecIns, ecModel, api, payload, dirtyMap) {
	  // Render all charts
	  var scheduler = ecIns._scheduler;
	  var unfinished;
	  ecModel.eachSeries(function (seriesModel) {
	    var chartView = ecIns._chartsMap[seriesModel.__viewId];
	    chartView.__alive = true;
	    var renderTask = chartView.renderTask;
	    scheduler.updatePayload(renderTask, payload);
	
	    if (dirtyMap && dirtyMap.get(seriesModel.uid)) {
	      renderTask.dirty();
	    }
	
	    unfinished |= renderTask.perform(scheduler.getPerformArgs(renderTask));
	    chartView.group.silent = !!seriesModel.get('silent');
	    updateZ(seriesModel, chartView);
	    updateBlend(seriesModel, chartView);
	  });
	  scheduler.unfinished |= unfinished; // If use hover layer
	
	  updateHoverLayerStatus(ecIns, ecModel); // Add aria
	
	  aria(ecIns._zr.dom, ecModel);
	}
	
	function performPostUpdateFuncs(ecModel, api) {
	  each(postUpdateFuncs, function (func) {
	    func(ecModel, api);
	  });
	}
	
	var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];
	/**
	 * @private
	 */
	
	echartsProto._initEvents = function () {
	  each(MOUSE_EVENT_NAMES, function (eveName) {
	    var handler = function (e) {
	      var ecModel = this.getModel();
	      var el = e.target;
	      var params;
	      var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.
	
	      if (isGlobalOut) {
	        params = {};
	      } else if (el && el.dataIndex != null) {
	        var dataModel = el.dataModel || ecModel.getSeriesByIndex(el.seriesIndex);
	        params = dataModel && dataModel.getDataParams(el.dataIndex, el.dataType, el) || {};
	      } // If element has custom eventData of components
	      else if (el && el.eventData) {
	          params = zrUtil.extend({}, el.eventData);
	        } // Contract: if params prepared in mouse event,
	      // these properties must be specified:
	      // {
	      //    componentType: string (component main type)
	      //    componentIndex: number
	      // }
	      // Otherwise event query can not work.
	
	
	      if (params) {
	        var componentType = params.componentType;
	        var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
	        // markLine/markPoint/markArea, the componentType is
	        // 'markLine'/'markPoint'/'markArea', but we should better
	        // enable them to be queried by seriesIndex, since their
	        // option is set in each series.
	
	        if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
	          componentType = 'series';
	          componentIndex = params.seriesIndex;
	        }
	
	        var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
	        var view = model && this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
	        params.event = e;
	        params.type = eveName;
	        this._ecEventProcessor.eventInfo = {
	          targetEl: el,
	          packedEvent: params,
	          model: model,
	          view: view
	        };
	        this.trigger(eveName, params);
	      }
	    }; // Consider that some component (like tooltip, brush, ...)
	    // register zr event handler, but user event handler might
	    // do anything, such as call `setOption` or `dispatchAction`,
	    // which probably update any of the content and probably
	    // cause problem if it is called previous other inner handlers.
	
	
	    handler.zrEventfulCallAtLast = true;
	
	    this._zr.on(eveName, handler, this);
	  }, this);
	  each(eventActionMap, function (actionType, eventType) {
	    this._messageCenter.on(eventType, function (event) {
	      this.trigger(eventType, event);
	    }, this);
	  }, this);
	};
	/**
	 * @return {boolean}
	 */
	
	
	echartsProto.isDisposed = function () {
	  return this._disposed;
	};
	/**
	 * Clear
	 */
	
	
	echartsProto.clear = function () {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this.setOption({
	    series: []
	  }, true);
	};
	/**
	 * Dispose instance
	 */
	
	
	echartsProto.dispose = function () {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this._disposed = true;
	  modelUtil.setAttribute(this.getDom(), DOM_ATTRIBUTE_KEY, '');
	  var api = this._api;
	  var ecModel = this._model;
	  each(this._componentsViews, function (component) {
	    component.dispose(ecModel, api);
	  });
	  each(this._chartsViews, function (chart) {
	    chart.dispose(ecModel, api);
	  }); // Dispose after all views disposed
	
	  this._zr.dispose();
	
	  delete instances[this.id];
	};
	
	zrUtil.mixin(ECharts, Eventful);
	
	function disposedWarning(id) {}
	
	function updateHoverLayerStatus(ecIns, ecModel) {
	  var zr = ecIns._zr;
	  var storage = zr.storage;
	  var elCount = 0;
	  storage.traverse(function (el) {
	    elCount++;
	  });
	
	  if (elCount > ecModel.get('hoverLayerThreshold') && !env.node) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.preventUsingHoverLayer) {
	        return;
	      }
	
	      var chartView = ecIns._chartsMap[seriesModel.__viewId];
	
	      if (chartView.__alive) {
	        chartView.group.traverse(function (el) {
	          // Don't switch back.
	          el.useHoverLayer = true;
	        });
	      }
	    });
	  }
	}
	/**
	 * Update chart progressive and blend.
	 * @param {module:echarts/model/Series|module:echarts/model/Component} model
	 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
	 */
	
	
	function updateBlend(seriesModel, chartView) {
	  var blendMode = seriesModel.get('blendMode') || null;
	  chartView.group.traverse(function (el) {
	    // FIXME marker and other components
	    if (!el.isGroup) {
	      // Only set if blendMode is changed. In case element is incremental and don't wan't to rerender.
	      if (el.style.blend !== blendMode) {
	        el.setStyle('blend', blendMode);
	      }
	    }
	
	    if (el.eachPendingDisplayable) {
	      el.eachPendingDisplayable(function (displayable) {
	        displayable.setStyle('blend', blendMode);
	      });
	    }
	  });
	}
	/**
	 * @param {module:echarts/model/Series|module:echarts/model/Component} model
	 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
	 */
	
	
	function updateZ(model, view) {
	  var z = model.get('z');
	  var zlevel = model.get('zlevel'); // Set z and zlevel
	
	  view.group.traverse(function (el) {
	    if (el.type !== 'group') {
	      z != null && (el.z = z);
	      zlevel != null && (el.zlevel = zlevel);
	    }
	  });
	}
	
	function createExtensionAPI(ecInstance) {
	  var coordSysMgr = ecInstance._coordSysMgr;
	  return zrUtil.extend(new ExtensionAPI(ecInstance), {
	    // Inject methods
	    getCoordinateSystems: zrUtil.bind(coordSysMgr.getCoordinateSystems, coordSysMgr),
	    getComponentByElement: function (el) {
	      while (el) {
	        var modelInfo = el.__ecComponentInfo;
	
	        if (modelInfo != null) {
	          return ecInstance._model.getComponent(modelInfo.mainType, modelInfo.index);
	        }
	
	        el = el.parent;
	      }
	    }
	  });
	}
	/**
	 * @class
	 * Usage of query:
	 * `chart.on('click', query, handler);`
	 * The `query` can be:
	 * + The component type query string, only `mainType` or `mainType.subType`,
	 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
	 * + The component query object, like:
	 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
	 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
	 * + The data query object, like:
	 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
	 * + The other query object (cmponent customized query), like:
	 *   `{element: 'some'}` (only available in custom series).
	 *
	 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
	 * same as there is no such prop in the `query` object.
	 */
	
	
	function EventProcessor() {
	  // These info required: targetEl, packedEvent, model, view
	  this.eventInfo;
	}
	
	EventProcessor.prototype = {
	  constructor: EventProcessor,
	  normalizeQuery: function (query) {
	    var cptQuery = {};
	    var dataQuery = {};
	    var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.
	
	    if (zrUtil.isString(query)) {
	      var condCptType = parseClassType(query); // `.main` and `.sub` may be ''.
	
	      cptQuery.mainType = condCptType.main || null;
	      cptQuery.subType = condCptType.sub || null;
	    } // `query` is an object, convert to {mainType, index, name, id}.
	    else {
	        // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
	        // can not be used in `compomentModel.filterForExposedEvent`.
	        var suffixes = ['Index', 'Name', 'Id'];
	        var dataKeys = {
	          name: 1,
	          dataIndex: 1,
	          dataType: 1
	        };
	        zrUtil.each(query, function (val, key) {
	          var reserved = false;
	
	          for (var i = 0; i < suffixes.length; i++) {
	            var propSuffix = suffixes[i];
	            var suffixPos = key.lastIndexOf(propSuffix);
	
	            if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
	              var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.
	
	              if (mainType !== 'data') {
	                cptQuery.mainType = mainType;
	                cptQuery[propSuffix.toLowerCase()] = val;
	                reserved = true;
	              }
	            }
	          }
	
	          if (dataKeys.hasOwnProperty(key)) {
	            dataQuery[key] = val;
	            reserved = true;
	          }
	
	          if (!reserved) {
	            otherQuery[key] = val;
	          }
	        });
	      }
	
	    return {
	      cptQuery: cptQuery,
	      dataQuery: dataQuery,
	      otherQuery: otherQuery
	    };
	  },
	  filter: function (eventType, query, args) {
	    // They should be assigned before each trigger call.
	    var eventInfo = this.eventInfo;
	
	    if (!eventInfo) {
	      return true;
	    }
	
	    var targetEl = eventInfo.targetEl;
	    var packedEvent = eventInfo.packedEvent;
	    var model = eventInfo.model;
	    var view = eventInfo.view; // For event like 'globalout'.
	
	    if (!model || !view) {
	      return true;
	    }
	
	    var cptQuery = query.cptQuery;
	    var dataQuery = query.dataQuery;
	    return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
	
	    function check(query, host, prop, propOnHost) {
	      return query[prop] == null || host[propOnHost || prop] === query[prop];
	    }
	  },
	  afterTrigger: function () {
	    // Make sure the eventInfo wont be used in next trigger.
	    this.eventInfo = null;
	  }
	};
	/**
	 * @type {Object} key: actionType.
	 * @inner
	 */
	
	var actions = {};
	/**
	 * Map eventType to actionType
	 * @type {Object}
	 */
	
	var eventActionMap = {};
	/**
	 * Data processor functions of each stage
	 * @type {Array.<Object.<string, Function>>}
	 * @inner
	 */
	
	var dataProcessorFuncs = [];
	/**
	 * @type {Array.<Function>}
	 * @inner
	 */
	
	var optionPreprocessorFuncs = [];
	/**
	 * @type {Array.<Function>}
	 * @inner
	 */
	
	var postUpdateFuncs = [];
	/**
	 * Visual encoding functions of each stage
	 * @type {Array.<Object.<string, Function>>}
	 */
	
	var visualFuncs = [];
	/**
	 * Theme storage
	 * @type {Object.<key, Object>}
	 */
	
	var themeStorage = {};
	/**
	 * Loading effects
	 */
	
	var loadingEffects = {};
	var instances = {};
	var connectedGroups = {};
	var idBase = new Date() - 0;
	var groupIdBase = new Date() - 0;
	var DOM_ATTRIBUTE_KEY = '_echarts_instance_';
	
	function enableConnect(chart) {
	  var STATUS_PENDING = 0;
	  var STATUS_UPDATING = 1;
	  var STATUS_UPDATED = 2;
	  var STATUS_KEY = '__connectUpdateStatus';
	
	  function updateConnectedChartsStatus(charts, status) {
	    for (var i = 0; i < charts.length; i++) {
	      var otherChart = charts[i];
	      otherChart[STATUS_KEY] = status;
	    }
	  }
	
	  each(eventActionMap, function (actionType, eventType) {
	    chart._messageCenter.on(eventType, function (event) {
	      if (connectedGroups[chart.group] && chart[STATUS_KEY] !== STATUS_PENDING) {
	        if (event && event.escapeConnect) {
	          return;
	        }
	
	        var action = chart.makeActionFromEvent(event);
	        var otherCharts = [];
	        each(instances, function (otherChart) {
	          if (otherChart !== chart && otherChart.group === chart.group) {
	            otherCharts.push(otherChart);
	          }
	        });
	        updateConnectedChartsStatus(otherCharts, STATUS_PENDING);
	        each(otherCharts, function (otherChart) {
	          if (otherChart[STATUS_KEY] !== STATUS_UPDATING) {
	            otherChart.dispatchAction(action);
	          }
	        });
	        updateConnectedChartsStatus(otherCharts, STATUS_UPDATED);
	      }
	    });
	  });
	}
	/**
	 * @param {HTMLElement} dom
	 * @param {Object} [theme]
	 * @param {Object} opts
	 * @param {number} [opts.devicePixelRatio] Use window.devicePixelRatio by default
	 * @param {string} [opts.renderer] Can choose 'canvas' or 'svg' to render the chart.
	 * @param {number} [opts.width] Use clientWidth of the input `dom` by default.
	 *                              Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Use clientHeight of the input `dom` by default.
	 *                               Can be 'auto' (the same as null/undefined)
	 */
	
	
	function init(dom, theme, opts) {
	  var existInstance = getInstanceByDom(dom);
	
	  if (existInstance) {
	    return existInstance;
	  }
	
	  var chart = new ECharts(dom, theme, opts);
	  chart.id = 'ec_' + idBase++;
	  instances[chart.id] = chart;
	  modelUtil.setAttribute(dom, DOM_ATTRIBUTE_KEY, chart.id);
	  enableConnect(chart);
	  return chart;
	}
	/**
	 * @return {string|Array.<module:echarts~ECharts>} groupId
	 */
	
	
	function connect(groupId) {
	  // Is array of charts
	  if (zrUtil.isArray(groupId)) {
	    var charts = groupId;
	    groupId = null; // If any chart has group
	
	    each(charts, function (chart) {
	      if (chart.group != null) {
	        groupId = chart.group;
	      }
	    });
	    groupId = groupId || 'g_' + groupIdBase++;
	    each(charts, function (chart) {
	      chart.group = groupId;
	    });
	  }
	
	  connectedGroups[groupId] = true;
	  return groupId;
	}
	/**
	 * @DEPRECATED
	 * @return {string} groupId
	 */
	
	
	function disConnect(groupId) {
	  connectedGroups[groupId] = false;
	}
	/**
	 * @return {string} groupId
	 */
	
	
	var disconnect = disConnect;
	/**
	 * Dispose a chart instance
	 * @param  {module:echarts~ECharts|HTMLDomElement|string} chart
	 */
	
	function dispose(chart) {
	  if (typeof chart === 'string') {
	    chart = instances[chart];
	  } else if (!(chart instanceof ECharts)) {
	    // Try to treat as dom
	    chart = getInstanceByDom(chart);
	  }
	
	  if (chart instanceof ECharts && !chart.isDisposed()) {
	    chart.dispose();
	  }
	}
	/**
	 * @param  {HTMLElement} dom
	 * @return {echarts~ECharts}
	 */
	
	
	function getInstanceByDom(dom) {
	  return instances[modelUtil.getAttribute(dom, DOM_ATTRIBUTE_KEY)];
	}
	/**
	 * @param {string} key
	 * @return {echarts~ECharts}
	 */
	
	
	function getInstanceById(key) {
	  return instances[key];
	}
	/**
	 * Register theme
	 */
	
	
	function registerTheme(name, theme) {
	  themeStorage[name] = theme;
	}
	/**
	 * Register option preprocessor
	 * @param {Function} preprocessorFunc
	 */
	
	
	function registerPreprocessor(preprocessorFunc) {
	  optionPreprocessorFuncs.push(preprocessorFunc);
	}
	/**
	 * @param {number} [priority=1000]
	 * @param {Object|Function} processor
	 */
	
	
	function registerProcessor(priority, processor) {
	  normalizeRegister(dataProcessorFuncs, priority, processor, PRIORITY_PROCESSOR_FILTER);
	}
	/**
	 * Register postUpdater
	 * @param {Function} postUpdateFunc
	 */
	
	
	function registerPostUpdate(postUpdateFunc) {
	  postUpdateFuncs.push(postUpdateFunc);
	}
	/**
	 * Usage:
	 * registerAction('someAction', 'someEvent', function () { ... });
	 * registerAction('someAction', function () { ... });
	 * registerAction(
	 *     {type: 'someAction', event: 'someEvent', update: 'updateView'},
	 *     function () { ... }
	 * );
	 *
	 * @param {(string|Object)} actionInfo
	 * @param {string} actionInfo.type
	 * @param {string} [actionInfo.event]
	 * @param {string} [actionInfo.update]
	 * @param {string} [eventName]
	 * @param {Function} action
	 */
	
	
	function registerAction(actionInfo, eventName, action) {
	  if (typeof eventName === 'function') {
	    action = eventName;
	    eventName = '';
	  }
	
	  var actionType = isObject(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
	    event: eventName
	  }][0]; // Event name is all lowercase
	
	  actionInfo.event = (actionInfo.event || actionType).toLowerCase();
	  eventName = actionInfo.event; // Validate action type and event name.
	
	  assert(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));
	
	  if (!actions[actionType]) {
	    actions[actionType] = {
	      action: action,
	      actionInfo: actionInfo
	    };
	  }
	
	  eventActionMap[eventName] = actionType;
	}
	/**
	 * @param {string} type
	 * @param {*} CoordinateSystem
	 */
	
	
	function registerCoordinateSystem(type, CoordinateSystem) {
	  CoordinateSystemManager.register(type, CoordinateSystem);
	}
	/**
	 * Get dimensions of specified coordinate system.
	 * @param {string} type
	 * @return {Array.<string|Object>}
	 */
	
	
	function getCoordinateSystemDimensions(type) {
	  var coordSysCreator = CoordinateSystemManager.get(type);
	
	  if (coordSysCreator) {
	    return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
	  }
	}
	/**
	 * Layout is a special stage of visual encoding
	 * Most visual encoding like color are common for different chart
	 * But each chart has it's own layout algorithm
	 *
	 * @param {number} [priority=1000]
	 * @param {Function} layoutTask
	 */
	
	
	function registerLayout(priority, layoutTask) {
	  normalizeRegister(visualFuncs, priority, layoutTask, PRIORITY_VISUAL_LAYOUT, 'layout');
	}
	/**
	 * @param {number} [priority=3000]
	 * @param {module:echarts/stream/Task} visualTask
	 */
	
	
	function registerVisual(priority, visualTask) {
	  normalizeRegister(visualFuncs, priority, visualTask, PRIORITY_VISUAL_CHART, 'visual');
	}
	/**
	 * @param {Object|Function} fn: {seriesType, createOnAllSeries, performRawSeries, reset}
	 */
	
	
	function normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
	  if (isFunction(priority) || isObject(priority)) {
	    fn = priority;
	    priority = defaultPriority;
	  }
	
	  var stageHandler = Scheduler.wrapStageHandler(fn, visualType);
	  stageHandler.__prio = priority;
	  stageHandler.__raw = fn;
	  targetList.push(stageHandler);
	  return stageHandler;
	}
	/**
	 * @param {string} name
	 */
	
	
	function registerLoading(name, loadingFx) {
	  loadingEffects[name] = loadingFx;
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendComponentModel(opts
	/*, superClass*/
	) {
	  // var Clazz = ComponentModel;
	  // if (superClass) {
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
	  // }
	  return ComponentModel.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendComponentView(opts
	/*, superClass*/
	) {
	  // var Clazz = ComponentView;
	  // if (superClass) {
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentView.getClass(classType.main, classType.sub, true);
	  // }
	  return ComponentView.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendSeriesModel(opts
	/*, superClass*/
	) {
	  // var Clazz = SeriesModel;
	  // if (superClass) {
	  //     superClass = 'series.' + superClass.replace('series.', '');
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
	  // }
	  return SeriesModel.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendChartView(opts
	/*, superClass*/
	) {
	  // var Clazz = ChartView;
	  // if (superClass) {
	  //     superClass = superClass.replace('series.', '');
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ChartView.getClass(classType.main, true);
	  // }
	  return ChartView.extend(opts);
	}
	/**
	 * ZRender need a canvas context to do measureText.
	 * But in node environment canvas may be created by node-canvas.
	 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
	 *
	 * Be careful of using it in the browser.
	 *
	 * @param {Function} creator
	 * @example
	 *     var Canvas = require('canvas');
	 *     var echarts = require('echarts');
	 *     echarts.setCanvasCreator(function () {
	 *         // Small size is enough.
	 *         return new Canvas(32, 32);
	 *     });
	 */
	
	
	function setCanvasCreator(creator) {
	  zrUtil.$override('createCanvas', creator);
	}
	/**
	 * @param {string} mapName
	 * @param {Array.<Object>|Object|string} geoJson
	 * @param {Object} [specialAreas]
	 *
	 * @example GeoJSON
	 *     $.get('USA.json', function (geoJson) {
	 *         echarts.registerMap('USA', geoJson);
	 *         // Or
	 *         echarts.registerMap('USA', {
	 *             geoJson: geoJson,
	 *             specialAreas: {}
	 *         })
	 *     });
	 *
	 *     $.get('airport.svg', function (svg) {
	 *         echarts.registerMap('airport', {
	 *             svg: svg
	 *         }
	 *     });
	 *
	 *     echarts.registerMap('eu', [
	 *         {svg: eu-topographic.svg},
	 *         {geoJSON: eu.json}
	 *     ])
	 */
	
	
	function registerMap(mapName, geoJson, specialAreas) {
	  mapDataStorage.registerMap(mapName, geoJson, specialAreas);
	}
	/**
	 * @param {string} mapName
	 * @return {Object}
	 */
	
	
	function getMap(mapName) {
	  // For backward compatibility, only return the first one.
	  var records = mapDataStorage.retrieveMap(mapName);
	  return records && records[0] && {
	    geoJson: records[0].geoJSON,
	    specialAreas: records[0].specialAreas
	  };
	}
	
	registerVisual(PRIORITY_VISUAL_GLOBAL, seriesColor);
	registerPreprocessor(backwardCompat);
	registerProcessor(PRIORITY_PROCESSOR_DATASTACK, dataStack);
	registerLoading('default', loadingDefault); // Default actions
	
	registerAction({
	  type: 'highlight',
	  event: 'highlight',
	  update: 'highlight'
	}, zrUtil.noop);
	registerAction({
	  type: 'downplay',
	  event: 'downplay',
	  update: 'downplay'
	}, zrUtil.noop); // Default theme
	
	registerTheme('light', lightTheme);
	registerTheme('dark', darkTheme); // For backward compatibility, where the namespace `dataTool` will
	// be mounted on `echarts` is the extension `dataTool` is imported.
	
	var dataTool = {};
	exports.version = version;
	exports.dependencies = dependencies;
	exports.PRIORITY = PRIORITY;
	exports.init = init;
	exports.connect = connect;
	exports.disConnect = disConnect;
	exports.disconnect = disconnect;
	exports.dispose = dispose;
	exports.getInstanceByDom = getInstanceByDom;
	exports.getInstanceById = getInstanceById;
	exports.registerTheme = registerTheme;
	exports.registerPreprocessor = registerPreprocessor;
	exports.registerProcessor = registerProcessor;
	exports.registerPostUpdate = registerPostUpdate;
	exports.registerAction = registerAction;
	exports.registerCoordinateSystem = registerCoordinateSystem;
	exports.getCoordinateSystemDimensions = getCoordinateSystemDimensions;
	exports.registerLayout = registerLayout;
	exports.registerVisual = registerVisual;
	exports.registerLoading = registerLoading;
	exports.extendComponentModel = extendComponentModel;
	exports.extendComponentView = extendComponentView;
	exports.extendSeriesModel = extendSeriesModel;
	exports.extendChartView = extendChartView;
	exports.setCanvasCreator = setCanvasCreator;
	exports.registerMap = registerMap;
	exports.getMap = getMap;
	exports.dataTool = dataTool;
	var ___ec_export = __webpack_require__(339);
	(function () {
	    for (var key in ___ec_export) {
	        if (___ec_export.hasOwnProperty(key)) {
	            exports[key] = ___ec_export[key];
	        }
	    }
	})();

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (1) The code `if (__DEV__) ...` can be removed by build tool.
	// (2) If intend to use `__DEV__`, this module should be imported. Use a global
	// variable `__DEV__` may cause that miss the declaration (see #6535), or the
	// declaration is behind of the using position (for example in `Model.extent`,
	// And tools like rollup can not analysis the dependency if not import).
	var dev; // In browser
	
	if (typeof window !== 'undefined') {
	  dev = window.__DEV__;
	} // In node
	else if (typeof global !== 'undefined') {
	    dev = global.__DEV__;
	  }
	
	if (typeof dev === 'undefined') {
	  dev = true;
	}
	
	var __DEV__ = dev;
	exports.__DEV__ = __DEV__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var guid = __webpack_require__(218);
	
	var env = __webpack_require__(219);
	
	var zrUtil = __webpack_require__(220);
	
	var Handler = __webpack_require__(221);
	
	var Storage = __webpack_require__(229);
	
	var Painter = __webpack_require__(244);
	
	var Animation = __webpack_require__(258);
	
	var HandlerProxy = __webpack_require__(259);
	
	/*!
	* ZRender, a high performance 2d drawing library.
	*
	* Copyright (c) 2013, Baidu Inc.
	* All rights reserved.
	*
	* LICENSE
	* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
	*/
	var useVML = !env.canvasSupported;
	var painterCtors = {
	  canvas: Painter
	};
	var instances = {}; // ZRender实例map索引
	
	/**
	 * @type {string}
	 */
	
	var version = '4.3.2';
	/**
	 * Initializing a zrender instance
	 * @param {HTMLElement} dom
	 * @param {Object} [opts]
	 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
	 * @param {number} [opts.devicePixelRatio]
	 * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
	 * @return {module:zrender/ZRender}
	 */
	
	function init(dom, opts) {
	  var zr = new ZRender(guid(), dom, opts);
	  instances[zr.id] = zr;
	  return zr;
	}
	/**
	 * Dispose zrender instance
	 * @param {module:zrender/ZRender} zr
	 */
	
	
	function dispose(zr) {
	  if (zr) {
	    zr.dispose();
	  } else {
	    for (var key in instances) {
	      if (instances.hasOwnProperty(key)) {
	        instances[key].dispose();
	      }
	    }
	
	    instances = {};
	  }
	
	  return this;
	}
	/**
	 * Get zrender instance by id
	 * @param {string} id zrender instance id
	 * @return {module:zrender/ZRender}
	 */
	
	
	function getInstance(id) {
	  return instances[id];
	}
	
	function registerPainter(name, Ctor) {
	  painterCtors[name] = Ctor;
	}
	
	function delInstance(id) {
	  delete instances[id];
	}
	/**
	 * @module zrender/ZRender
	 */
	
	/**
	 * @constructor
	 * @alias module:zrender/ZRender
	 * @param {string} id
	 * @param {HTMLElement} dom
	 * @param {Object} opts
	 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
	 * @param {number} [opts.devicePixelRatio]
	 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
	 */
	
	
	var ZRender = function (id, dom, opts) {
	  opts = opts || {};
	  /**
	   * @type {HTMLDomElement}
	   */
	
	  this.dom = dom;
	  /**
	   * @type {string}
	   */
	
	  this.id = id;
	  var self = this;
	  var storage = new Storage();
	  var rendererType = opts.renderer; // TODO WebGL
	
	  if (useVML) {
	    if (!painterCtors.vml) {
	      throw new Error('You need to require \'zrender/vml/vml\' to support IE8');
	    }
	
	    rendererType = 'vml';
	  } else if (!rendererType || !painterCtors[rendererType]) {
	    rendererType = 'canvas';
	  }
	
	  var painter = new painterCtors[rendererType](dom, storage, opts, id);
	  this.storage = storage;
	  this.painter = painter;
	  var handerProxy = !env.node && !env.worker ? new HandlerProxy(painter.getViewportRoot(), painter.root) : null;
	  this.handler = new Handler(storage, painter, handerProxy, painter.root);
	  /**
	   * @type {module:zrender/animation/Animation}
	   */
	
	  this.animation = new Animation({
	    stage: {
	      update: zrUtil.bind(this.flush, this)
	    }
	  });
	  this.animation.start();
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._needsRefresh; // 修改 storage.delFromStorage, 每次删除元素之前删除动画
	  // FIXME 有点ugly
	
	  var oldDelFromStorage = storage.delFromStorage;
	  var oldAddToStorage = storage.addToStorage;
	
	  storage.delFromStorage = function (el) {
	    oldDelFromStorage.call(storage, el);
	    el && el.removeSelfFromZr(self);
	  };
	
	  storage.addToStorage = function (el) {
	    oldAddToStorage.call(storage, el);
	    el.addSelfToZr(self);
	  };
	};
	
	ZRender.prototype = {
	  constructor: ZRender,
	
	  /**
	   * 获取实例唯一标识
	   * @return {string}
	   */
	  getId: function () {
	    return this.id;
	  },
	
	  /**
	   * 添加元素
	   * @param  {module:zrender/Element} el
	   */
	  add: function (el) {
	    this.storage.addRoot(el);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * 删除元素
	   * @param  {module:zrender/Element} el
	   */
	  remove: function (el) {
	    this.storage.delRoot(el);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Change configuration of layer
	   * @param {string} zLevel
	   * @param {Object} config
	   * @param {string} [config.clearColor=0] Clear color
	   * @param {string} [config.motionBlur=false] If enable motion blur
	   * @param {number} [config.lastFrameAlpha=0.7] Motion blur factor. Larger value cause longer trailer
	  */
	  configLayer: function (zLevel, config) {
	    if (this.painter.configLayer) {
	      this.painter.configLayer(zLevel, config);
	    }
	
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Set background color
	   * @param {string} backgroundColor
	   */
	  setBackgroundColor: function (backgroundColor) {
	    if (this.painter.setBackgroundColor) {
	      this.painter.setBackgroundColor(backgroundColor);
	    }
	
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Repaint the canvas immediately
	   */
	  refreshImmediately: function () {
	    // var start = new Date();
	    // Clear needsRefresh ahead to avoid something wrong happens in refresh
	    // Or it will cause zrender refreshes again and again.
	    this._needsRefresh = this._needsRefreshHover = false;
	    this.painter.refresh(); // Avoid trigger zr.refresh in Element#beforeUpdate hook
	
	    this._needsRefresh = this._needsRefreshHover = false; // var end = new Date();
	    // var log = document.getElementById('log');
	    // if (log) {
	    //     log.innerHTML = log.innerHTML + '<br>' + (end - start);
	    // }
	  },
	
	  /**
	   * Mark and repaint the canvas in the next frame of browser
	   */
	  refresh: function () {
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Perform all refresh
	   */
	  flush: function () {
	    var triggerRendered;
	
	    if (this._needsRefresh) {
	      triggerRendered = true;
	      this.refreshImmediately();
	    }
	
	    if (this._needsRefreshHover) {
	      triggerRendered = true;
	      this.refreshHoverImmediately();
	    }
	
	    triggerRendered && this.trigger('rendered');
	  },
	
	  /**
	   * Add element to hover layer
	   * @param  {module:zrender/Element} el
	   * @param {Object} style
	   */
	  addHover: function (el, style) {
	    if (this.painter.addHover) {
	      var elMirror = this.painter.addHover(el, style);
	      this.refreshHover();
	      return elMirror;
	    }
	  },
	
	  /**
	   * Add element from hover layer
	   * @param  {module:zrender/Element} el
	   */
	  removeHover: function (el) {
	    if (this.painter.removeHover) {
	      this.painter.removeHover(el);
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Clear all hover elements in hover layer
	   * @param  {module:zrender/Element} el
	   */
	  clearHover: function () {
	    if (this.painter.clearHover) {
	      this.painter.clearHover();
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Refresh hover in next frame
	   */
	  refreshHover: function () {
	    this._needsRefreshHover = true;
	  },
	
	  /**
	   * Refresh hover immediately
	   */
	  refreshHoverImmediately: function () {
	    this._needsRefreshHover = false;
	    this.painter.refreshHover && this.painter.refreshHover();
	  },
	
	  /**
	   * Resize the canvas.
	   * Should be invoked when container size is changed
	   * @param {Object} [opts]
	   * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
	   * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
	   */
	  resize: function (opts) {
	    opts = opts || {};
	    this.painter.resize(opts.width, opts.height);
	    this.handler.resize();
	  },
	
	  /**
	   * Stop and clear all animation immediately
	   */
	  clearAnimation: function () {
	    this.animation.clear();
	  },
	
	  /**
	   * Get container width
	   */
	  getWidth: function () {
	    return this.painter.getWidth();
	  },
	
	  /**
	   * Get container height
	   */
	  getHeight: function () {
	    return this.painter.getHeight();
	  },
	
	  /**
	   * Export the canvas as Base64 URL
	   * @param {string} type
	   * @param {string} [backgroundColor='#fff']
	   * @return {string} Base64 URL
	   */
	  // toDataURL: function(type, backgroundColor) {
	  //     return this.painter.getRenderedCanvas({
	  //         backgroundColor: backgroundColor
	  //     }).toDataURL(type);
	  // },
	
	  /**
	   * Converting a path to image.
	   * It has much better performance of drawing image rather than drawing a vector path.
	   * @param {module:zrender/graphic/Path} e
	   * @param {number} width
	   * @param {number} height
	   */
	  pathToImage: function (e, dpr) {
	    return this.painter.pathToImage(e, dpr);
	  },
	
	  /**
	   * Set default cursor
	   * @param {string} [cursorStyle='default'] 例如 crosshair
	   */
	  setCursorStyle: function (cursorStyle) {
	    this.handler.setCursorStyle(cursorStyle);
	  },
	
	  /**
	   * Find hovered element
	   * @param {number} x
	   * @param {number} y
	   * @return {Object} {target, topTarget}
	   */
	  findHover: function (x, y) {
	    return this.handler.findHover(x, y);
	  },
	
	  /**
	   * Bind event
	   *
	   * @param {string} eventName Event name
	   * @param {Function} eventHandler Handler function
	   * @param {Object} [context] Context object
	   */
	  on: function (eventName, eventHandler, context) {
	    this.handler.on(eventName, eventHandler, context);
	  },
	
	  /**
	   * Unbind event
	   * @param {string} eventName Event name
	   * @param {Function} [eventHandler] Handler function
	   */
	  off: function (eventName, eventHandler) {
	    this.handler.off(eventName, eventHandler);
	  },
	
	  /**
	   * Trigger event manually
	   *
	   * @param {string} eventName Event name
	   * @param {event=} event Event object
	   */
	  trigger: function (eventName, event) {
	    this.handler.trigger(eventName, event);
	  },
	
	  /**
	   * Clear all objects and the canvas.
	   */
	  clear: function () {
	    this.storage.delRoot();
	    this.painter.clear();
	  },
	
	  /**
	   * Dispose self.
	   */
	  dispose: function () {
	    this.animation.stop();
	    this.clear();
	    this.storage.dispose();
	    this.painter.dispose();
	    this.handler.dispose();
	    this.animation = this.storage = this.painter = this.handler = null;
	    delInstance(this.id);
	  }
	};
	exports.version = version;
	exports.init = init;
	exports.dispose = dispose;
	exports.getInstance = getInstance;
	exports.registerPainter = registerPainter;

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	/**
	 * zrender: 生成唯一id
	 *
	 * @author errorrik (errorrik@gmail.com)
	 */
	var idStart = 0x0907;
	
	function _default() {
	  return idStart++;
	}
	
	module.exports = _default;

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	/**
	 * echarts设备环境识别
	 *
	 * @desc echarts基于Canvas，纯Javascript图表库，提供直观，生动，可交互，可个性化定制的数据统计图表。
	 * @author firede[firede@firede.us]
	 * @desc thanks zepto.
	 */
	
	/* global wx */
	var env = {};
	
	if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
	  // In Weixin Application
	  env = {
	    browser: {},
	    os: {},
	    node: false,
	    wxa: true,
	    // Weixin Application
	    canvasSupported: true,
	    svgSupported: false,
	    touchEventsSupported: true,
	    domSupported: false
	  };
	} else if (typeof document === 'undefined' && typeof self !== 'undefined') {
	  // In worker
	  env = {
	    browser: {},
	    os: {},
	    node: false,
	    worker: true,
	    canvasSupported: true,
	    domSupported: false
	  };
	} else if (typeof navigator === 'undefined') {
	  // In node
	  env = {
	    browser: {},
	    os: {},
	    node: true,
	    worker: false,
	    // Assume canvas is supported
	    canvasSupported: true,
	    svgSupported: true,
	    domSupported: false
	  };
	} else {
	  env = detect(navigator.userAgent);
	}
	
	var _default = env; // Zepto.js
	// (c) 2010-2013 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	
	function detect(ua) {
	  var os = {};
	  var browser = {}; // var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
	  // var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	  // var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  // var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  // var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
	  // var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
	  // var touchpad = webos && ua.match(/TouchPad/);
	  // var kindle = ua.match(/Kindle\/([\d.]+)/);
	  // var silk = ua.match(/Silk\/([\d._]+)/);
	  // var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
	  // var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
	  // var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
	  // var playbook = ua.match(/PlayBook/);
	  // var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
	
	  var firefox = ua.match(/Firefox\/([\d.]+)/); // var safari = webkit && ua.match(/Mobile\//) && !chrome;
	  // var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;
	
	  var ie = ua.match(/MSIE\s([\d.]+)/) // IE 11 Trident/7.0; rv:11.0
	  || ua.match(/Trident\/.+?rv:(([\d.]+))/);
	  var edge = ua.match(/Edge\/([\d.]+)/); // IE 12 and 12+
	
	  var weChat = /micromessenger/i.test(ua); // Todo: clean this up with a better OS/browser seperation:
	  // - discern (more) between multiple browsers on android
	  // - decide if kindle fire in silk mode is android or not
	  // - Firefox on Android doesn't specify the Android version
	  // - possibly devide in os, device and browser hashes
	  // if (browser.webkit = !!webkit) browser.version = webkit[1];
	  // if (android) os.android = true, os.version = android[2];
	  // if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
	  // if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
	  // if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	  // if (webos) os.webos = true, os.version = webos[2];
	  // if (touchpad) os.touchpad = true;
	  // if (blackberry) os.blackberry = true, os.version = blackberry[2];
	  // if (bb10) os.bb10 = true, os.version = bb10[2];
	  // if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
	  // if (playbook) browser.playbook = true;
	  // if (kindle) os.kindle = true, os.version = kindle[1];
	  // if (silk) browser.silk = true, browser.version = silk[1];
	  // if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
	  // if (chrome) browser.chrome = true, browser.version = chrome[1];
	
	  if (firefox) {
	    browser.firefox = true;
	    browser.version = firefox[1];
	  } // if (safari && (ua.match(/Safari/) || !!os.ios)) browser.safari = true;
	  // if (webview) browser.webview = true;
	
	
	  if (ie) {
	    browser.ie = true;
	    browser.version = ie[1];
	  }
	
	  if (edge) {
	    browser.edge = true;
	    browser.version = edge[1];
	  } // It is difficult to detect WeChat in Win Phone precisely, because ua can
	  // not be set on win phone. So we do not consider Win Phone.
	
	
	  if (weChat) {
	    browser.weChat = true;
	  } // os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
	  //     (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
	  // os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos ||
	  //     (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
	  //     (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));
	
	
	  return {
	    browser: browser,
	    os: os,
	    node: false,
	    // 原生canvas支持，改极端点了
	    // canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
	    canvasSupported: !!document.createElement('canvas').getContext,
	    svgSupported: typeof SVGRect !== 'undefined',
	    // works on most browsers
	    // IE10/11 does not support touch event, and MS Edge supports them but not by
	    // default, so we dont check navigator.maxTouchPoints for them here.
	    touchEventsSupported: 'ontouchstart' in window && !browser.ie && !browser.edge,
	    // <http://caniuse.com/#search=pointer%20event>.
	    pointerEventsSupported: // (1) Firefox supports pointer but not by default, only MS browsers are reliable on pointer
	    // events currently. So we dont use that on other browsers unless tested sufficiently.
	    // For example, in iOS 13 Mobile Chromium 78, if the touching behavior starts page
	    // scroll, the `pointermove` event can not be fired any more. That will break some
	    // features like "pan horizontally to move something and pan vertically to page scroll".
	    // The horizontal pan probably be interrupted by the casually triggered page scroll.
	    // (2) Although IE 10 supports pointer event, it use old style and is different from the
	    // standard. So we exclude that. (IE 10 is hardly used on touch device)
	    'onpointerdown' in window && (browser.edge || browser.ie && browser.version >= 11),
	    // passiveSupported: detectPassiveSupport()
	    domSupported: typeof document !== 'undefined'
	  };
	} // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
	// function detectPassiveSupport() {
	//     // Test via a getter in the options object to see if the passive property is accessed
	//     var supportsPassive = false;
	//     try {
	//         var opts = Object.defineProperty({}, 'passive', {
	//             get: function() {
	//                 supportsPassive = true;
	//             }
	//         });
	//         window.addEventListener('testPassive', function() {}, opts);
	//     } catch (e) {
	//     }
	//     return supportsPassive;
	// }
	
	
	module.exports = _default;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	/**
	 * @module zrender/core/util
	 */
	// 用于处理merge时无法遍历Date等对象的问题
	var BUILTIN_OBJECT = {
	  '[object Function]': 1,
	  '[object RegExp]': 1,
	  '[object Date]': 1,
	  '[object Error]': 1,
	  '[object CanvasGradient]': 1,
	  '[object CanvasPattern]': 1,
	  // For node-canvas
	  '[object Image]': 1,
	  '[object Canvas]': 1
	};
	var TYPED_ARRAY = {
	  '[object Int8Array]': 1,
	  '[object Uint8Array]': 1,
	  '[object Uint8ClampedArray]': 1,
	  '[object Int16Array]': 1,
	  '[object Uint16Array]': 1,
	  '[object Int32Array]': 1,
	  '[object Uint32Array]': 1,
	  '[object Float32Array]': 1,
	  '[object Float64Array]': 1
	};
	var objToString = Object.prototype.toString;
	var arrayProto = Array.prototype;
	var nativeForEach = arrayProto.forEach;
	var nativeFilter = arrayProto.filter;
	var nativeSlice = arrayProto.slice;
	var nativeMap = arrayProto.map;
	var nativeReduce = arrayProto.reduce; // Avoid assign to an exported variable, for transforming to cjs.
	
	var methods = {};
	
	function $override(name, fn) {
	  // Clear ctx instance for different environment
	  if (name === 'createCanvas') {
	    _ctx = null;
	  }
	
	  methods[name] = fn;
	}
	/**
	 * Those data types can be cloned:
	 *     Plain object, Array, TypedArray, number, string, null, undefined.
	 * Those data types will be assgined using the orginal data:
	 *     BUILTIN_OBJECT
	 * Instance of user defined class will be cloned to a plain object, without
	 * properties in prototype.
	 * Other data types is not supported (not sure what will happen).
	 *
	 * Caution: do not support clone Date, for performance consideration.
	 * (There might be a large number of date in `series.data`).
	 * So date should not be modified in and out of echarts.
	 *
	 * @param {*} source
	 * @return {*} new
	 */
	
	
	function clone(source) {
	  if (source == null || typeof source !== 'object') {
	    return source;
	  }
	
	  var result = source;
	  var typeStr = objToString.call(source);
	
	  if (typeStr === '[object Array]') {
	    if (!isPrimitive(source)) {
	      result = [];
	
	      for (var i = 0, len = source.length; i < len; i++) {
	        result[i] = clone(source[i]);
	      }
	    }
	  } else if (TYPED_ARRAY[typeStr]) {
	    if (!isPrimitive(source)) {
	      var Ctor = source.constructor;
	
	      if (source.constructor.from) {
	        result = Ctor.from(source);
	      } else {
	        result = new Ctor(source.length);
	
	        for (var i = 0, len = source.length; i < len; i++) {
	          result[i] = clone(source[i]);
	        }
	      }
	    }
	  } else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
	    result = {};
	
	    for (var key in source) {
	      if (source.hasOwnProperty(key)) {
	        result[key] = clone(source[key]);
	      }
	    }
	  }
	
	  return result;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} target
	 * @param {*} source
	 * @param {boolean} [overwrite=false]
	 */
	
	
	function merge(target, source, overwrite) {
	  // We should escapse that source is string
	  // and enter for ... in ...
	  if (!isObject(source) || !isObject(target)) {
	    return overwrite ? clone(source) : target;
	  }
	
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      var targetProp = target[key];
	      var sourceProp = source[key];
	
	      if (isObject(sourceProp) && isObject(targetProp) && !isArray(sourceProp) && !isArray(targetProp) && !isDom(sourceProp) && !isDom(targetProp) && !isBuiltInObject(sourceProp) && !isBuiltInObject(targetProp) && !isPrimitive(sourceProp) && !isPrimitive(targetProp)) {
	        // 如果需要递归覆盖，就递归调用merge
	        merge(targetProp, sourceProp, overwrite);
	      } else if (overwrite || !(key in target)) {
	        // 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
	        // NOTE，在 target[key] 不存在的时候也是直接覆盖
	        target[key] = clone(source[key], true);
	      }
	    }
	  }
	
	  return target;
	}
	/**
	 * @param {Array} targetAndSources The first item is target, and the rests are source.
	 * @param {boolean} [overwrite=false]
	 * @return {*} target
	 */
	
	
	function mergeAll(targetAndSources, overwrite) {
	  var result = targetAndSources[0];
	
	  for (var i = 1, len = targetAndSources.length; i < len; i++) {
	    result = merge(result, targetAndSources[i], overwrite);
	  }
	
	  return result;
	}
	/**
	 * @param {*} target
	 * @param {*} source
	 * @memberOf module:zrender/core/util
	 */
	
	
	function extend(target, source) {
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	/**
	 * @param {*} target
	 * @param {*} source
	 * @param {boolean} [overlay=false]
	 * @memberOf module:zrender/core/util
	 */
	
	
	function defaults(target, source, overlay) {
	  for (var key in source) {
	    if (source.hasOwnProperty(key) && (overlay ? source[key] != null : target[key] == null)) {
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	var createCanvas = function () {
	  return methods.createCanvas();
	};
	
	methods.createCanvas = function () {
	  return document.createElement('canvas');
	}; // FIXME
	
	
	var _ctx;
	
	function getContext() {
	  if (!_ctx) {
	    // Use util.createCanvas instead of createCanvas
	    // because createCanvas may be overwritten in different environment
	    _ctx = createCanvas().getContext('2d');
	  }
	
	  return _ctx;
	}
	/**
	 * 查询数组中元素的index
	 * @memberOf module:zrender/core/util
	 */
	
	
	function indexOf(array, value) {
	  if (array) {
	    if (array.indexOf) {
	      return array.indexOf(value);
	    }
	
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === value) {
	        return i;
	      }
	    }
	  }
	
	  return -1;
	}
	/**
	 * 构造类继承关系
	 *
	 * @memberOf module:zrender/core/util
	 * @param {Function} clazz 源类
	 * @param {Function} baseClazz 基类
	 */
	
	
	function inherits(clazz, baseClazz) {
	  var clazzPrototype = clazz.prototype;
	
	  function F() {}
	
	  F.prototype = baseClazz.prototype;
	  clazz.prototype = new F();
	
	  for (var prop in clazzPrototype) {
	    if (clazzPrototype.hasOwnProperty(prop)) {
	      clazz.prototype[prop] = clazzPrototype[prop];
	    }
	  }
	
	  clazz.prototype.constructor = clazz;
	  clazz.superClass = baseClazz;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Object|Function} target
	 * @param {Object|Function} sorce
	 * @param {boolean} overlay
	 */
	
	
	function mixin(target, source, overlay) {
	  target = 'prototype' in target ? target.prototype : target;
	  source = 'prototype' in source ? source.prototype : source;
	  defaults(target, source, overlay);
	}
	/**
	 * Consider typed array.
	 * @param {Array|TypedArray} data
	 */
	
	
	function isArrayLike(data) {
	  if (!data) {
	    return;
	  }
	
	  if (typeof data === 'string') {
	    return false;
	  }
	
	  return typeof data.length === 'number';
	}
	/**
	 * 数组或对象遍历
	 * @memberOf module:zrender/core/util
	 * @param {Object|Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 */
	
	
	function each(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.forEach && obj.forEach === nativeForEach) {
	    obj.forEach(cb, context);
	  } else if (obj.length === +obj.length) {
	    for (var i = 0, len = obj.length; i < len; i++) {
	      cb.call(context, obj[i], i, obj);
	    }
	  } else {
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        cb.call(context, obj[key], key, obj);
	      }
	    }
	  }
	}
	/**
	 * 数组映射
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function map(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.map && obj.map === nativeMap) {
	    return obj.map(cb, context);
	  } else {
	    var result = [];
	
	    for (var i = 0, len = obj.length; i < len; i++) {
	      result.push(cb.call(context, obj[i], i, obj));
	    }
	
	    return result;
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {Object} [memo]
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function reduce(obj, cb, memo, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.reduce && obj.reduce === nativeReduce) {
	    return obj.reduce(cb, memo, context);
	  } else {
	    for (var i = 0, len = obj.length; i < len; i++) {
	      memo = cb.call(context, memo, obj[i], i, obj);
	    }
	
	    return memo;
	  }
	}
	/**
	 * 数组过滤
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function filter(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.filter && obj.filter === nativeFilter) {
	    return obj.filter(cb, context);
	  } else {
	    var result = [];
	
	    for (var i = 0, len = obj.length; i < len; i++) {
	      if (cb.call(context, obj[i], i, obj)) {
	        result.push(obj[i]);
	      }
	    }
	
	    return result;
	  }
	}
	/**
	 * 数组项查找
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {*}
	 */
	
	
	function find(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  for (var i = 0, len = obj.length; i < len; i++) {
	    if (cb.call(context, obj[i], i, obj)) {
	      return obj[i];
	    }
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Function} func
	 * @param {*} context
	 * @return {Function}
	 */
	
	
	function bind(func, context) {
	  var args = nativeSlice.call(arguments, 2);
	  return function () {
	    return func.apply(context, args.concat(nativeSlice.call(arguments)));
	  };
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Function} func
	 * @return {Function}
	 */
	
	
	function curry(func) {
	  var args = nativeSlice.call(arguments, 1);
	  return function () {
	    return func.apply(this, args.concat(nativeSlice.call(arguments)));
	  };
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isArray(value) {
	  return objToString.call(value) === '[object Array]';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isFunction(value) {
	  return typeof value === 'function';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isString(value) {
	  return objToString.call(value) === '[object String]';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return type === 'function' || !!value && type === 'object';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isBuiltInObject(value) {
	  return !!BUILTIN_OBJECT[objToString.call(value)];
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isTypedArray(value) {
	  return !!TYPED_ARRAY[objToString.call(value)];
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isDom(value) {
	  return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
	}
	/**
	 * Whether is exactly NaN. Notice isNaN('a') returns true.
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function eqNaN(value) {
	  /* eslint-disable-next-line no-self-compare */
	  return value !== value;
	}
	/**
	 * If value1 is not null, then return value1, otherwise judget rest of values.
	 * Low performance.
	 * @memberOf module:zrender/core/util
	 * @return {*} Final value
	 */
	
	
	function retrieve(values) {
	  for (var i = 0, len = arguments.length; i < len; i++) {
	    if (arguments[i] != null) {
	      return arguments[i];
	    }
	  }
	}
	
	function retrieve2(value0, value1) {
	  return value0 != null ? value0 : value1;
	}
	
	function retrieve3(value0, value1, value2) {
	  return value0 != null ? value0 : value1 != null ? value1 : value2;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Array} arr
	 * @param {number} startIndex
	 * @param {number} endIndex
	 * @return {Array}
	 */
	
	
	function slice() {
	  return Function.call.apply(nativeSlice, arguments);
	}
	/**
	 * Normalize css liked array configuration
	 * e.g.
	 *  3 => [3, 3, 3, 3]
	 *  [4, 2] => [4, 2, 4, 2]
	 *  [4, 3, 2] => [4, 3, 2, 3]
	 * @param {number|Array.<number>} val
	 * @return {Array.<number>}
	 */
	
	
	function normalizeCssArray(val) {
	  if (typeof val === 'number') {
	    return [val, val, val, val];
	  }
	
	  var len = val.length;
	
	  if (len === 2) {
	    // vertical | horizontal
	    return [val[0], val[1], val[0], val[1]];
	  } else if (len === 3) {
	    // top | horizontal | bottom
	    return [val[0], val[1], val[2], val[1]];
	  }
	
	  return val;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {boolean} condition
	 * @param {string} message
	 */
	
	
	function assert(condition, message) {
	  if (!condition) {
	    throw new Error(message);
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {string} str string to be trimed
	 * @return {string} trimed string
	 */
	
	
	function trim(str) {
	  if (str == null) {
	    return null;
	  } else if (typeof str.trim === 'function') {
	    return str.trim();
	  } else {
	    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	  }
	}
	
	var primitiveKey = '__ec_primitive__';
	/**
	 * Set an object as primitive to be ignored traversing children in clone or merge
	 */
	
	function setAsPrimitive(obj) {
	  obj[primitiveKey] = true;
	}
	
	function isPrimitive(obj) {
	  return obj[primitiveKey];
	}
	/**
	 * @constructor
	 * @param {Object} obj Only apply `ownProperty`.
	 */
	
	
	function HashMap(obj) {
	  var isArr = isArray(obj); // Key should not be set on this, otherwise
	  // methods get/set/... may be overrided.
	
	  this.data = {};
	  var thisMap = this;
	  obj instanceof HashMap ? obj.each(visit) : obj && each(obj, visit);
	
	  function visit(value, key) {
	    isArr ? thisMap.set(value, key) : thisMap.set(key, value);
	  }
	}
	
	HashMap.prototype = {
	  constructor: HashMap,
	  // Do not provide `has` method to avoid defining what is `has`.
	  // (We usually treat `null` and `undefined` as the same, different
	  // from ES6 Map).
	  get: function (key) {
	    return this.data.hasOwnProperty(key) ? this.data[key] : null;
	  },
	  set: function (key, value) {
	    // Comparing with invocation chaining, `return value` is more commonly
	    // used in this case: `var someVal = map.set('a', genVal());`
	    return this.data[key] = value;
	  },
	  // Although util.each can be performed on this hashMap directly, user
	  // should not use the exposed keys, who are prefixed.
	  each: function (cb, context) {
	    context !== void 0 && (cb = bind(cb, context));
	    /* eslint-disable guard-for-in */
	
	    for (var key in this.data) {
	      this.data.hasOwnProperty(key) && cb(this.data[key], key);
	    }
	    /* eslint-enable guard-for-in */
	
	  },
	  // Do not use this method if performance sensitive.
	  removeKey: function (key) {
	    delete this.data[key];
	  }
	};
	
	function createHashMap(obj) {
	  return new HashMap(obj);
	}
	
	function concatArray(a, b) {
	  var newArray = new a.constructor(a.length + b.length);
	
	  for (var i = 0; i < a.length; i++) {
	    newArray[i] = a[i];
	  }
	
	  var offset = a.length;
	
	  for (i = 0; i < b.length; i++) {
	    newArray[i + offset] = b[i];
	  }
	
	  return newArray;
	}
	
	function noop() {}
	
	exports.$override = $override;
	exports.clone = clone;
	exports.merge = merge;
	exports.mergeAll = mergeAll;
	exports.extend = extend;
	exports.defaults = defaults;
	exports.createCanvas = createCanvas;
	exports.getContext = getContext;
	exports.indexOf = indexOf;
	exports.inherits = inherits;
	exports.mixin = mixin;
	exports.isArrayLike = isArrayLike;
	exports.each = each;
	exports.map = map;
	exports.reduce = reduce;
	exports.filter = filter;
	exports.find = find;
	exports.bind = bind;
	exports.curry = curry;
	exports.isArray = isArray;
	exports.isFunction = isFunction;
	exports.isString = isString;
	exports.isObject = isObject;
	exports.isBuiltInObject = isBuiltInObject;
	exports.isTypedArray = isTypedArray;
	exports.isDom = isDom;
	exports.eqNaN = eqNaN;
	exports.retrieve = retrieve;
	exports.retrieve2 = retrieve2;
	exports.retrieve3 = retrieve3;
	exports.slice = slice;
	exports.normalizeCssArray = normalizeCssArray;
	exports.assert = assert;
	exports.trim = trim;
	exports.setAsPrimitive = setAsPrimitive;
	exports.isPrimitive = isPrimitive;
	exports.createHashMap = createHashMap;
	exports.concatArray = concatArray;
	exports.noop = noop;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(220);
	
	var vec2 = __webpack_require__(222);
	
	var Draggable = __webpack_require__(223);
	
	var Eventful = __webpack_require__(224);
	
	var eventTool = __webpack_require__(225);
	
	var GestureMgr = __webpack_require__(228);
	
	/**
	 * [The interface between `Handler` and `HandlerProxy`]:
	 *
	 * The default `HandlerProxy` only support the common standard web environment
	 * (e.g., standalone browser, headless browser, embed browser in mobild APP, ...).
	 * But `HandlerProxy` can be replaced to support more non-standard environment
	 * (e.g., mini app), or to support more feature that the default `HandlerProxy`
	 * not provided (like echarts-gl did).
	 * So the interface between `Handler` and `HandlerProxy` should be stable. Do not
	 * make break changes util inevitable. The interface include the public methods
	 * of `Handler` and the events listed in `handlerNames` below, by which `HandlerProxy`
	 * drives `Handler`.
	 */
	
	/**
	 * [Drag outside]:
	 *
	 * That is, triggering `mousemove` and `mouseup` event when the pointer is out of the
	 * zrender area when dragging. That is important for the improvement of the user experience
	 * when dragging something near the boundary without being terminated unexpectedly.
	 *
	 * We originally consider to introduce new events like `pagemovemove` and `pagemouseup`
	 * to resolve this issue. But some drawbacks of it is described in
	 * https://github.com/ecomfe/zrender/pull/536#issuecomment-560286899
	 *
	 * Instead, we referenced the specifications:
	 * https://www.w3.org/TR/touch-events/#the-touchmove-event
	 * https://www.w3.org/TR/2014/WD-DOM-Level-3-Events-20140925/#event-type-mousemove
	 * where the the mousemove/touchmove can be continue to fire if the user began a drag
	 * operation and the pointer has left the boundary. (for the mouse event, browsers
	 * only do it on `document` and when the pointer has left the boundary of the browser.)
	 *
	 * So the default `HandlerProxy` supports this feature similarly: if it is in the dragging
	 * state (see `pointerCapture` in `HandlerProxy`), the `mousemove` and `mouseup` continue
	 * to fire until release the pointer. That is implemented by listen to those event on
	 * `document`.
	 * If we implement some other `HandlerProxy` only for touch device, that would be easier.
	 * The touch event support this feature by default.
	 *
	 * Note:
	 * There might be some cases that the mouse event can not be
	 * received on `document`. For example,
	 * (A) `useCapture` is not supported and some user defined event listeners on the ancestor
	 * of zr dom throw Error .
	 * (B) `useCapture` is not supported Some user defined event listeners on the ancestor of
	 * zr dom call `stopPropagation`.
	 * In these cases, the `mousemove` event might be keep triggered event
	 * if the mouse is released. We try to reduce the side-effect in those cases.
	 * That is, do nothing (especially, `findHover`) in those cases. See `isOutsideBoundary`.
	 *
	 * Note:
	 * If `HandlerProxy` listens to `document` with `useCapture`, `HandlerProxy` needs to
	 * make sure `stopPropagation` and `preventDefault` doing nothing if and only if the event
	 * target is not zrender dom. Becuase it is dangerous to enable users to call them in
	 * `document` capture phase to prevent the propagation to any listener of the webpage.
	 * But they are needed to work when the pointer inside the zrender dom.
	 */
	var SILENT = 'silent';
	
	function makeEventPacket(eveType, targetInfo, event) {
	  return {
	    type: eveType,
	    event: event,
	    // target can only be an element that is not silent.
	    target: targetInfo.target,
	    // topTarget can be a silent element.
	    topTarget: targetInfo.topTarget,
	    cancelBubble: false,
	    offsetX: event.zrX,
	    offsetY: event.zrY,
	    gestureEvent: event.gestureEvent,
	    pinchX: event.pinchX,
	    pinchY: event.pinchY,
	    pinchScale: event.pinchScale,
	    wheelDelta: event.zrDelta,
	    zrByTouch: event.zrByTouch,
	    which: event.which,
	    stop: stopEvent
	  };
	}
	
	function stopEvent() {
	  eventTool.stop(this.event);
	}
	
	function EmptyProxy() {}
	
	EmptyProxy.prototype.dispose = function () {};
	
	var handlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
	/**
	 * @alias module:zrender/Handler
	 * @constructor
	 * @extends module:zrender/mixin/Eventful
	 * @param {module:zrender/Storage} storage Storage instance.
	 * @param {module:zrender/Painter} painter Painter instance.
	 * @param {module:zrender/dom/HandlerProxy} proxy HandlerProxy instance.
	 * @param {HTMLElement} painterRoot painter.root (not painter.getViewportRoot()).
	 */
	
	var Handler = function (storage, painter, proxy, painterRoot) {
	  Eventful.call(this);
	  this.storage = storage;
	  this.painter = painter;
	  this.painterRoot = painterRoot;
	  proxy = proxy || new EmptyProxy();
	  /**
	   * Proxy of event. can be Dom, WebGLSurface, etc.
	   */
	
	  this.proxy = null;
	  /**
	   * {target, topTarget, x, y}
	   * @private
	   * @type {Object}
	   */
	
	  this._hovered = {};
	  /**
	   * @private
	   * @type {Date}
	   */
	
	  this._lastTouchMoment;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._lastX;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._lastY;
	  /**
	   * @private
	   * @type {module:zrender/core/GestureMgr}
	   */
	
	  this._gestureMgr;
	  Draggable.call(this);
	  this.setHandlerProxy(proxy);
	};
	
	Handler.prototype = {
	  constructor: Handler,
	  setHandlerProxy: function (proxy) {
	    if (this.proxy) {
	      this.proxy.dispose();
	    }
	
	    if (proxy) {
	      util.each(handlerNames, function (name) {
	        proxy.on && proxy.on(name, this[name], this);
	      }, this); // Attach handler
	
	      proxy.handler = this;
	    }
	
	    this.proxy = proxy;
	  },
	  mousemove: function (event) {
	    var x = event.zrX;
	    var y = event.zrY;
	    var isOutside = isOutsideBoundary(this, x, y);
	    var lastHovered = this._hovered;
	    var lastHoveredTarget = lastHovered.target; // If lastHoveredTarget is removed from zr (detected by '__zr') by some API call
	    // (like 'setOption' or 'dispatchAction') in event handlers, we should find
	    // lastHovered again here. Otherwise 'mouseout' can not be triggered normally.
	    // See #6198.
	
	    if (lastHoveredTarget && !lastHoveredTarget.__zr) {
	      lastHovered = this.findHover(lastHovered.x, lastHovered.y);
	      lastHoveredTarget = lastHovered.target;
	    }
	
	    var hovered = this._hovered = isOutside ? {
	      x: x,
	      y: y
	    } : this.findHover(x, y);
	    var hoveredTarget = hovered.target;
	    var proxy = this.proxy;
	    proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default'); // Mouse out on previous hovered element
	
	    if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
	      this.dispatchToElement(lastHovered, 'mouseout', event);
	    } // Mouse moving on one element
	
	
	    this.dispatchToElement(hovered, 'mousemove', event); // Mouse over on a new element
	
	    if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
	      this.dispatchToElement(hovered, 'mouseover', event);
	    }
	  },
	  mouseout: function (event) {
	    var eventControl = event.zrEventControl;
	    var zrIsToLocalDOM = event.zrIsToLocalDOM;
	
	    if (eventControl !== 'only_globalout') {
	      this.dispatchToElement(this._hovered, 'mouseout', event);
	    }
	
	    if (eventControl !== 'no_globalout') {
	      // FIXME: if the pointer moving from the extra doms to realy "outside",
	      // the `globalout` should have been triggered. But currently not.
	      !zrIsToLocalDOM && this.trigger('globalout', {
	        type: 'globalout',
	        event: event
	      });
	    }
	  },
	
	  /**
	   * Resize
	   */
	  resize: function (event) {
	    this._hovered = {};
	  },
	
	  /**
	   * Dispatch event
	   * @param {string} eventName
	   * @param {event=} eventArgs
	   */
	  dispatch: function (eventName, eventArgs) {
	    var handler = this[eventName];
	    handler && handler.call(this, eventArgs);
	  },
	
	  /**
	   * Dispose
	   */
	  dispose: function () {
	    this.proxy.dispose();
	    this.storage = this.proxy = this.painter = null;
	  },
	
	  /**
	   * 设置默认的cursor style
	   * @param {string} [cursorStyle='default'] 例如 crosshair
	   */
	  setCursorStyle: function (cursorStyle) {
	    var proxy = this.proxy;
	    proxy.setCursor && proxy.setCursor(cursorStyle);
	  },
	
	  /**
	   * 事件分发代理
	   *
	   * @private
	   * @param {Object} targetInfo {target, topTarget} 目标图形元素
	   * @param {string} eventName 事件名称
	   * @param {Object} event 事件对象
	   */
	  dispatchToElement: function (targetInfo, eventName, event) {
	    targetInfo = targetInfo || {};
	    var el = targetInfo.target;
	
	    if (el && el.silent) {
	      return;
	    }
	
	    var eventHandler = 'on' + eventName;
	    var eventPacket = makeEventPacket(eventName, targetInfo, event);
	
	    while (el) {
	      el[eventHandler] && (eventPacket.cancelBubble = el[eventHandler].call(el, eventPacket));
	      el.trigger(eventName, eventPacket);
	      el = el.parent;
	
	      if (eventPacket.cancelBubble) {
	        break;
	      }
	    }
	
	    if (!eventPacket.cancelBubble) {
	      // 冒泡到顶级 zrender 对象
	      this.trigger(eventName, eventPacket); // 分发事件到用户自定义层
	      // 用户有可能在全局 click 事件中 dispose，所以需要判断下 painter 是否存在
	
	      this.painter && this.painter.eachOtherLayer(function (layer) {
	        if (typeof layer[eventHandler] === 'function') {
	          layer[eventHandler].call(layer, eventPacket);
	        }
	
	        if (layer.trigger) {
	          layer.trigger(eventName, eventPacket);
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   * @param {number} x
	   * @param {number} y
	   * @param {module:zrender/graphic/Displayable} exclude
	   * @return {model:zrender/Element}
	   * @method
	   */
	  findHover: function (x, y, exclude) {
	    var list = this.storage.getDisplayList();
	    var out = {
	      x: x,
	      y: y
	    };
	
	    for (var i = list.length - 1; i >= 0; i--) {
	      var hoverCheckResult;
	
	      if (list[i] !== exclude // getDisplayList may include ignored item in VML mode
	      && !list[i].ignore && (hoverCheckResult = isHover(list[i], x, y))) {
	        !out.topTarget && (out.topTarget = list[i]);
	
	        if (hoverCheckResult !== SILENT) {
	          out.target = list[i];
	          break;
	        }
	      }
	    }
	
	    return out;
	  },
	  processGesture: function (event, stage) {
	    if (!this._gestureMgr) {
	      this._gestureMgr = new GestureMgr();
	    }
	
	    var gestureMgr = this._gestureMgr;
	    stage === 'start' && gestureMgr.clear();
	    var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
	    stage === 'end' && gestureMgr.clear(); // Do not do any preventDefault here. Upper application do that if necessary.
	
	    if (gestureInfo) {
	      var type = gestureInfo.type;
	      event.gestureEvent = type;
	      this.dispatchToElement({
	        target: gestureInfo.target
	      }, type, gestureInfo.event);
	    }
	  }
	}; // Common handlers
	
	util.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	  Handler.prototype[name] = function (event) {
	    var x = event.zrX;
	    var y = event.zrY;
	    var isOutside = isOutsideBoundary(this, x, y);
	    var hovered;
	    var hoveredTarget;
	
	    if (name !== 'mouseup' || !isOutside) {
	      // Find hover again to avoid click event is dispatched manually. Or click is triggered without mouseover
	      hovered = this.findHover(x, y);
	      hoveredTarget = hovered.target;
	    }
	
	    if (name === 'mousedown') {
	      this._downEl = hoveredTarget;
	      this._downPoint = [event.zrX, event.zrY]; // In case click triggered before mouseup
	
	      this._upEl = hoveredTarget;
	    } else if (name === 'mouseup') {
	      this._upEl = hoveredTarget;
	    } else if (name === 'click') {
	      if (this._downEl !== this._upEl // Original click event is triggered on the whole canvas element,
	      // including the case that `mousedown` - `mousemove` - `mouseup`,
	      // which should be filtered, otherwise it will bring trouble to
	      // pan and zoom.
	      || !this._downPoint // Arbitrary value
	      || vec2.dist(this._downPoint, [event.zrX, event.zrY]) > 4) {
	        return;
	      }
	
	      this._downPoint = null;
	    }
	
	    this.dispatchToElement(hovered, name, event);
	  };
	});
	
	function isHover(displayable, x, y) {
	  if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
	    var el = displayable;
	    var isSilent;
	
	    while (el) {
	      // If clipped by ancestor.
	      // FIXME: If clipPath has neither stroke nor fill,
	      // el.clipPath.contain(x, y) will always return false.
	      if (el.clipPath && !el.clipPath.contain(x, y)) {
	        return false;
	      }
	
	      if (el.silent) {
	        isSilent = true;
	      }
	
	      el = el.parent;
	    }
	
	    return isSilent ? SILENT : true;
	  }
	
	  return false;
	}
	/**
	 * See [Drag outside].
	 */
	
	
	function isOutsideBoundary(handlerInstance, x, y) {
	  var painter = handlerInstance.painter;
	  return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
	}
	
	util.mixin(Handler, Eventful);
	util.mixin(Handler, Draggable);
	var _default = Handler;
	module.exports = _default;

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	/* global Float32Array */
	var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
	/**
	 * 创建一个向量
	 * @param {number} [x=0]
	 * @param {number} [y=0]
	 * @return {Vector2}
	 */
	
	function create(x, y) {
	  var out = new ArrayCtor(2);
	
	  if (x == null) {
	    x = 0;
	  }
	
	  if (y == null) {
	    y = 0;
	  }
	
	  out[0] = x;
	  out[1] = y;
	  return out;
	}
	/**
	 * 复制向量数据
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @return {Vector2}
	 */
	
	
	function copy(out, v) {
	  out[0] = v[0];
	  out[1] = v[1];
	  return out;
	}
	/**
	 * 克隆一个向量
	 * @param {Vector2} v
	 * @return {Vector2}
	 */
	
	
	function clone(v) {
	  var out = new ArrayCtor(2);
	  out[0] = v[0];
	  out[1] = v[1];
	  return out;
	}
	/**
	 * 设置向量的两个项
	 * @param {Vector2} out
	 * @param {number} a
	 * @param {number} b
	 * @return {Vector2} 结果
	 */
	
	
	function set(out, a, b) {
	  out[0] = a;
	  out[1] = b;
	  return out;
	}
	/**
	 * 向量相加
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function add(out, v1, v2) {
	  out[0] = v1[0] + v2[0];
	  out[1] = v1[1] + v2[1];
	  return out;
	}
	/**
	 * 向量缩放后相加
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @param {number} a
	 */
	
	
	function scaleAndAdd(out, v1, v2, a) {
	  out[0] = v1[0] + v2[0] * a;
	  out[1] = v1[1] + v2[1] * a;
	  return out;
	}
	/**
	 * 向量相减
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function sub(out, v1, v2) {
	  out[0] = v1[0] - v2[0];
	  out[1] = v1[1] - v2[1];
	  return out;
	}
	/**
	 * 向量长度
	 * @param {Vector2} v
	 * @return {number}
	 */
	
	
	function len(v) {
	  return Math.sqrt(lenSquare(v));
	}
	
	var length = len; // jshint ignore:line
	
	/**
	 * 向量长度平方
	 * @param {Vector2} v
	 * @return {number}
	 */
	
	function lenSquare(v) {
	  return v[0] * v[0] + v[1] * v[1];
	}
	
	var lengthSquare = lenSquare;
	/**
	 * 向量乘法
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	function mul(out, v1, v2) {
	  out[0] = v1[0] * v2[0];
	  out[1] = v1[1] * v2[1];
	  return out;
	}
	/**
	 * 向量除法
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function div(out, v1, v2) {
	  out[0] = v1[0] / v2[0];
	  out[1] = v1[1] / v2[1];
	  return out;
	}
	/**
	 * 向量点乘
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	
	function dot(v1, v2) {
	  return v1[0] * v2[0] + v1[1] * v2[1];
	}
	/**
	 * 向量缩放
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @param {number} s
	 */
	
	
	function scale(out, v, s) {
	  out[0] = v[0] * s;
	  out[1] = v[1] * s;
	  return out;
	}
	/**
	 * 向量归一化
	 * @param {Vector2} out
	 * @param {Vector2} v
	 */
	
	
	function normalize(out, v) {
	  var d = len(v);
	
	  if (d === 0) {
	    out[0] = 0;
	    out[1] = 0;
	  } else {
	    out[0] = v[0] / d;
	    out[1] = v[1] / d;
	  }
	
	  return out;
	}
	/**
	 * 计算向量间距离
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	
	function distance(v1, v2) {
	  return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
	}
	
	var dist = distance;
	/**
	 * 向量距离平方
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	function distanceSquare(v1, v2) {
	  return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
	}
	
	var distSquare = distanceSquare;
	/**
	 * 求负向量
	 * @param {Vector2} out
	 * @param {Vector2} v
	 */
	
	function negate(out, v) {
	  out[0] = -v[0];
	  out[1] = -v[1];
	  return out;
	}
	/**
	 * 插值两个点
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @param {number} t
	 */
	
	
	function lerp(out, v1, v2, t) {
	  out[0] = v1[0] + t * (v2[0] - v1[0]);
	  out[1] = v1[1] + t * (v2[1] - v1[1]);
	  return out;
	}
	/**
	 * 矩阵左乘向量
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @param {Vector2} m
	 */
	
	
	function applyTransform(out, v, m) {
	  var x = v[0];
	  var y = v[1];
	  out[0] = m[0] * x + m[2] * y + m[4];
	  out[1] = m[1] * x + m[3] * y + m[5];
	  return out;
	}
	/**
	 * 求两个向量最小值
	 * @param  {Vector2} out
	 * @param  {Vector2} v1
	 * @param  {Vector2} v2
	 */
	
	
	function min(out, v1, v2) {
	  out[0] = Math.min(v1[0], v2[0]);
	  out[1] = Math.min(v1[1], v2[1]);
	  return out;
	}
	/**
	 * 求两个向量最大值
	 * @param  {Vector2} out
	 * @param  {Vector2} v1
	 * @param  {Vector2} v2
	 */
	
	
	function max(out, v1, v2) {
	  out[0] = Math.max(v1[0], v2[0]);
	  out[1] = Math.max(v1[1], v2[1]);
	  return out;
	}
	
	exports.create = create;
	exports.copy = copy;
	exports.clone = clone;
	exports.set = set;
	exports.add = add;
	exports.scaleAndAdd = scaleAndAdd;
	exports.sub = sub;
	exports.len = len;
	exports.length = length;
	exports.lenSquare = lenSquare;
	exports.lengthSquare = lengthSquare;
	exports.mul = mul;
	exports.div = div;
	exports.dot = dot;
	exports.scale = scale;
	exports.normalize = normalize;
	exports.distance = distance;
	exports.dist = dist;
	exports.distanceSquare = distanceSquare;
	exports.distSquare = distSquare;
	exports.negate = negate;
	exports.lerp = lerp;
	exports.applyTransform = applyTransform;
	exports.min = min;
	exports.max = max;

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	// TODO Draggable for group
	// FIXME Draggable on element which has parent rotation or scale
	function Draggable() {
	  this.on('mousedown', this._dragStart, this);
	  this.on('mousemove', this._drag, this);
	  this.on('mouseup', this._dragEnd, this); // `mosuemove` and `mouseup` can be continue to fire when dragging.
	  // See [Drag outside] in `Handler.js`. So we do not need to trigger
	  // `_dragEnd` when globalout. That would brings better user experience.
	  // this.on('globalout', this._dragEnd, this);
	  // this._dropTarget = null;
	  // this._draggingTarget = null;
	  // this._x = 0;
	  // this._y = 0;
	}
	
	Draggable.prototype = {
	  constructor: Draggable,
	  _dragStart: function (e) {
	    var draggingTarget = e.target; // Find if there is draggable in the ancestor
	
	    while (draggingTarget && !draggingTarget.draggable) {
	      draggingTarget = draggingTarget.parent;
	    }
	
	    if (draggingTarget) {
	      this._draggingTarget = draggingTarget;
	      draggingTarget.dragging = true;
	      this._x = e.offsetX;
	      this._y = e.offsetY;
	      this.dispatchToElement(param(draggingTarget, e), 'dragstart', e.event);
	    }
	  },
	  _drag: function (e) {
	    var draggingTarget = this._draggingTarget;
	
	    if (draggingTarget) {
	      var x = e.offsetX;
	      var y = e.offsetY;
	      var dx = x - this._x;
	      var dy = y - this._y;
	      this._x = x;
	      this._y = y;
	      draggingTarget.drift(dx, dy, e);
	      this.dispatchToElement(param(draggingTarget, e), 'drag', e.event);
	      var dropTarget = this.findHover(x, y, draggingTarget).target;
	      var lastDropTarget = this._dropTarget;
	      this._dropTarget = dropTarget;
	
	      if (draggingTarget !== dropTarget) {
	        if (lastDropTarget && dropTarget !== lastDropTarget) {
	          this.dispatchToElement(param(lastDropTarget, e), 'dragleave', e.event);
	        }
	
	        if (dropTarget && dropTarget !== lastDropTarget) {
	          this.dispatchToElement(param(dropTarget, e), 'dragenter', e.event);
	        }
	      }
	    }
	  },
	  _dragEnd: function (e) {
	    var draggingTarget = this._draggingTarget;
	
	    if (draggingTarget) {
	      draggingTarget.dragging = false;
	    }
	
	    this.dispatchToElement(param(draggingTarget, e), 'dragend', e.event);
	
	    if (this._dropTarget) {
	      this.dispatchToElement(param(this._dropTarget, e), 'drop', e.event);
	    }
	
	    this._draggingTarget = null;
	    this._dropTarget = null;
	  }
	};
	
	function param(target, e) {
	  return {
	    target: target,
	    topTarget: e && e.topTarget
	  };
	}
	
	var _default = Draggable;
	module.exports = _default;

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	/**
	 * Event Mixin
	 * @module zrender/mixin/Eventful
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         pissang (https://www.github.com/pissang)
	 */
	var arrySlice = Array.prototype.slice;
	/**
	 * Event dispatcher.
	 *
	 * @alias module:zrender/mixin/Eventful
	 * @constructor
	 * @param {Object} [eventProcessor] The object eventProcessor is the scope when
	 *        `eventProcessor.xxx` called.
	 * @param {Function} [eventProcessor.normalizeQuery]
	 *        param: {string|Object} Raw query.
	 *        return: {string|Object} Normalized query.
	 * @param {Function} [eventProcessor.filter] Event will be dispatched only
	 *        if it returns `true`.
	 *        param: {string} eventType
	 *        param: {string|Object} query
	 *        return: {boolean}
	 * @param {Function} [eventProcessor.afterTrigger] Called after all handlers called.
	 *        param: {string} eventType
	 */
	
	var Eventful = function (eventProcessor) {
	  this._$handlers = {};
	  this._$eventProcessor = eventProcessor;
	};
	
	Eventful.prototype = {
	  constructor: Eventful,
	
	  /**
	   * The handler can only be triggered once, then removed.
	   *
	   * @param {string} event The event name.
	   * @param {string|Object} [query] Condition used on event filter.
	   * @param {Function} handler The event handler.
	   * @param {Object} context
	   */
	  one: function (event, query, handler, context) {
	    return on(this, event, query, handler, context, true);
	  },
	
	  /**
	   * Bind a handler.
	   *
	   * @param {string} event The event name.
	   * @param {string|Object} [query] Condition used on event filter.
	   * @param {Function} handler The event handler.
	   * @param {Object} [context]
	   */
	  on: function (event, query, handler, context) {
	    return on(this, event, query, handler, context, false);
	  },
	
	  /**
	   * Whether any handler has bound.
	   *
	   * @param  {string}  event
	   * @return {boolean}
	   */
	  isSilent: function (event) {
	    var _h = this._$handlers;
	    return !_h[event] || !_h[event].length;
	  },
	
	  /**
	   * Unbind a event.
	   *
	   * @param {string} [event] The event name.
	   *        If no `event` input, "off" all listeners.
	   * @param {Function} [handler] The event handler.
	   *        If no `handler` input, "off" all listeners of the `event`.
	   */
	  off: function (event, handler) {
	    var _h = this._$handlers;
	
	    if (!event) {
	      this._$handlers = {};
	      return this;
	    }
	
	    if (handler) {
	      if (_h[event]) {
	        var newList = [];
	
	        for (var i = 0, l = _h[event].length; i < l; i++) {
	          if (_h[event][i].h !== handler) {
	            newList.push(_h[event][i]);
	          }
	        }
	
	        _h[event] = newList;
	      }
	
	      if (_h[event] && _h[event].length === 0) {
	        delete _h[event];
	      }
	    } else {
	      delete _h[event];
	    }
	
	    return this;
	  },
	
	  /**
	   * Dispatch a event.
	   *
	   * @param {string} type The event name.
	   */
	  trigger: function (type) {
	    var _h = this._$handlers[type];
	    var eventProcessor = this._$eventProcessor;
	
	    if (_h) {
	      var args = arguments;
	      var argLen = args.length;
	
	      if (argLen > 3) {
	        args = arrySlice.call(args, 1);
	      }
	
	      var len = _h.length;
	
	      for (var i = 0; i < len;) {
	        var hItem = _h[i];
	
	        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
	          i++;
	          continue;
	        } // Optimize advise from backbone
	
	
	        switch (argLen) {
	          case 1:
	            hItem.h.call(hItem.ctx);
	            break;
	
	          case 2:
	            hItem.h.call(hItem.ctx, args[1]);
	            break;
	
	          case 3:
	            hItem.h.call(hItem.ctx, args[1], args[2]);
	            break;
	
	          default:
	            // have more than 2 given arguments
	            hItem.h.apply(hItem.ctx, args);
	            break;
	        }
	
	        if (hItem.one) {
	          _h.splice(i, 1);
	
	          len--;
	        } else {
	          i++;
	        }
	      }
	    }
	
	    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
	    return this;
	  },
	
	  /**
	   * Dispatch a event with context, which is specified at the last parameter.
	   *
	   * @param {string} type The event name.
	   */
	  triggerWithContext: function (type) {
	    var _h = this._$handlers[type];
	    var eventProcessor = this._$eventProcessor;
	
	    if (_h) {
	      var args = arguments;
	      var argLen = args.length;
	
	      if (argLen > 4) {
	        args = arrySlice.call(args, 1, args.length - 1);
	      }
	
	      var ctx = args[args.length - 1];
	      var len = _h.length;
	
	      for (var i = 0; i < len;) {
	        var hItem = _h[i];
	
	        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
	          i++;
	          continue;
	        } // Optimize advise from backbone
	
	
	        switch (argLen) {
	          case 1:
	            hItem.h.call(ctx);
	            break;
	
	          case 2:
	            hItem.h.call(ctx, args[1]);
	            break;
	
	          case 3:
	            hItem.h.call(ctx, args[1], args[2]);
	            break;
	
	          default:
	            // have more than 2 given arguments
	            hItem.h.apply(ctx, args);
	            break;
	        }
	
	        if (hItem.one) {
	          _h.splice(i, 1);
	
	          len--;
	        } else {
	          i++;
	        }
	      }
	    }
	
	    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
	    return this;
	  }
	};
	
	function normalizeQuery(host, query) {
	  var eventProcessor = host._$eventProcessor;
	
	  if (query != null && eventProcessor && eventProcessor.normalizeQuery) {
	    query = eventProcessor.normalizeQuery(query);
	  }
	
	  return query;
	}
	
	function on(eventful, event, query, handler, context, isOnce) {
	  var _h = eventful._$handlers;
	
	  if (typeof query === 'function') {
	    context = handler;
	    handler = query;
	    query = null;
	  }
	
	  if (!handler || !event) {
	    return eventful;
	  }
	
	  query = normalizeQuery(eventful, query);
	
	  if (!_h[event]) {
	    _h[event] = [];
	  }
	
	  for (var i = 0; i < _h[event].length; i++) {
	    if (_h[event][i].h === handler) {
	      return eventful;
	    }
	  }
	
	  var wrap = {
	    h: handler,
	    one: isOnce,
	    query: query,
	    ctx: context || eventful,
	    // FIXME
	    // Do not publish this feature util it is proved that it makes sense.
	    callAtLast: handler.zrEventfulCallAtLast
	  };
	  var lastIndex = _h[event].length - 1;
	  var lastWrap = _h[event][lastIndex];
	  lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
	  return eventful;
	} // ----------------------
	// The events in zrender
	// ----------------------
	
	/**
	 * @event module:zrender/mixin/Eventful#onclick
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseover
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseout
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousemove
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousewheel
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousedown
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseup
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondrag
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragstart
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragend
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragenter
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragleave
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragover
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondrop
	 * @type {Function}
	 * @default null
	 */
	
	
	var _default = Eventful;
	module.exports = _default;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var Eventful = __webpack_require__(224);
	
	exports.Dispatcher = Eventful;
	
	var env = __webpack_require__(219);
	
	var _dom = __webpack_require__(226);
	
	var isCanvasEl = _dom.isCanvasEl;
	var transformCoordWithViewport = _dom.transformCoordWithViewport;
	
	/**
	 * Utilities for mouse or touch events.
	 */
	var isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
	var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
	var _calcOut = [];
	/**
	 * Get the `zrX` and `zrY`, which are relative to the top-left of
	 * the input `el`.
	 * CSS transform (2D & 3D) is supported.
	 *
	 * The strategy to fetch the coords:
	 * + If `calculate` is not set as `true`, users of this method should
	 * ensure that `el` is the same or the same size & location as `e.target`.
	 * Otherwise the result coords are probably not expected. Because we
	 * firstly try to get coords from e.offsetX/e.offsetY.
	 * + If `calculate` is set as `true`, the input `el` can be any element
	 * and we force to calculate the coords based on `el`.
	 * + The input `el` should be positionable (not position:static).
	 *
	 * The force `calculate` can be used in case like:
	 * When mousemove event triggered on ec tooltip, `e.target` is not `el`(zr painter.dom).
	 *
	 * @param {HTMLElement} el DOM element.
	 * @param {Event} e Mouse event or touch event.
	 * @param {Object} out Get `out.zrX` and `out.zrY` as the result.
	 * @param {boolean} [calculate=false] Whether to force calculate
	 *        the coordinates but not use ones provided by browser.
	 */
	
	function clientToLocal(el, e, out, calculate) {
	  out = out || {}; // According to the W3C Working Draft, offsetX and offsetY should be relative
	  // to the padding edge of the target element. The only browser using this convention
	  // is IE. Webkit uses the border edge, Opera uses the content edge, and FireFox does
	  // not support the properties.
	  // (see http://www.jacklmoore.com/notes/mouse-position/)
	  // In zr painter.dom, padding edge equals to border edge.
	
	  if (calculate || !env.canvasSupported) {
	    calculateZrXY(el, e, out);
	  } // Caution: In FireFox, layerX/layerY Mouse position relative to the closest positioned
	  // ancestor element, so we should make sure el is positioned (e.g., not position:static).
	  // BTW1, Webkit don't return the same results as FF in non-simple cases (like add
	  // zoom-factor, overflow / opacity layers, transforms ...)
	  // BTW2, (ev.offsetY || ev.pageY - $(ev.target).offset().top) is not correct in preserve-3d.
	  // <https://bugs.jquery.com/ticket/8523#comment:14>
	  // BTW3, In ff, offsetX/offsetY is always 0.
	  else if (env.browser.firefox && e.layerX != null && e.layerX !== e.offsetX) {
	      out.zrX = e.layerX;
	      out.zrY = e.layerY;
	    } // For IE6+, chrome, safari, opera. (When will ff support offsetX?)
	    else if (e.offsetX != null) {
	        out.zrX = e.offsetX;
	        out.zrY = e.offsetY;
	      } // For some other device, e.g., IOS safari.
	      else {
	          calculateZrXY(el, e, out);
	        }
	
	  return out;
	}
	
	function calculateZrXY(el, e, out) {
	  // BlackBerry 5, iOS 3 (original iPhone) don't have getBoundingRect.
	  if (env.domSupported && el.getBoundingClientRect) {
	    var ex = e.clientX;
	    var ey = e.clientY;
	
	    if (isCanvasEl(el)) {
	      // Original approach, which do not support CSS transform.
	      // marker can not be locationed in a canvas container
	      // (getBoundingClientRect is always 0). We do not support
	      // that input a pre-created canvas to zr while using css
	      // transform in iOS.
	      var box = el.getBoundingClientRect();
	      out.zrX = ex - box.left;
	      out.zrY = ey - box.top;
	      return;
	    } else {
	      if (transformCoordWithViewport(_calcOut, el, ex, ey)) {
	        out.zrX = _calcOut[0];
	        out.zrY = _calcOut[1];
	        return;
	      }
	    }
	  }
	
	  out.zrX = out.zrY = 0;
	}
	/**
	 * Find native event compat for legency IE.
	 * Should be called at the begining of a native event listener.
	 *
	 * @param {Event} [e] Mouse event or touch event or pointer event.
	 *        For lagency IE, we use `window.event` is used.
	 * @return {Event} The native event.
	 */
	
	
	function getNativeEvent(e) {
	  return e || window.event;
	}
	/**
	 * Normalize the coordinates of the input event.
	 *
	 * Get the `e.zrX` and `e.zrY`, which are relative to the top-left of
	 * the input `el`.
	 * Get `e.zrDelta` if using mouse wheel.
	 * Get `e.which`, see the comment inside this function.
	 *
	 * Do not calculate repeatly if `zrX` and `zrY` already exist.
	 *
	 * Notice: see comments in `clientToLocal`. check the relationship
	 * between the result coords and the parameters `el` and `calculate`.
	 *
	 * @param {HTMLElement} el DOM element.
	 * @param {Event} [e] See `getNativeEvent`.
	 * @param {boolean} [calculate=false] Whether to force calculate
	 *        the coordinates but not use ones provided by browser.
	 * @return {UIEvent} The normalized native UIEvent.
	 */
	
	
	function normalizeEvent(el, e, calculate) {
	  e = getNativeEvent(e);
	
	  if (e.zrX != null) {
	    return e;
	  }
	
	  var eventType = e.type;
	  var isTouch = eventType && eventType.indexOf('touch') >= 0;
	
	  if (!isTouch) {
	    clientToLocal(el, e, e, calculate);
	    e.zrDelta = e.wheelDelta ? e.wheelDelta / 120 : -(e.detail || 0) / 3;
	  } else {
	    var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
	    touch && clientToLocal(el, touch, e, calculate);
	  } // Add which for click: 1 === left; 2 === middle; 3 === right; otherwise: 0;
	  // See jQuery: https://github.com/jquery/jquery/blob/master/src/event.js
	  // If e.which has been defined, it may be readonly,
	  // see: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which
	
	
	  var button = e.button;
	
	  if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
	    e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
	  } // [Caution]: `e.which` from browser is not always reliable. For example,
	  // when press left button and `mousemove (pointermove)` in Edge, the `e.which`
	  // is 65536 and the `e.button` is -1. But the `mouseup (pointerup)` and
	  // `mousedown (pointerdown)` is the same as Chrome does.
	
	
	  return e;
	}
	/**
	 * @param {HTMLElement} el
	 * @param {string} name
	 * @param {Function} handler
	 * @param {Object|boolean} opt If boolean, means `opt.capture`
	 * @param {boolean} [opt.capture=false]
	 * @param {boolean} [opt.passive=false]
	 */
	
	
	function addEventListener(el, name, handler, opt) {
	  if (isDomLevel2) {
	    // Reproduct the console warning:
	    // [Violation] Added non-passive event listener to a scroll-blocking <some> event.
	    // Consider marking event handler as 'passive' to make the page more responsive.
	    // Just set console log level: verbose in chrome dev tool.
	    // then the warning log will be printed when addEventListener called.
	    // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	    // We have not yet found a neat way to using passive. Because in zrender the dom event
	    // listener delegate all of the upper events of element. Some of those events need
	    // to prevent default. For example, the feature `preventDefaultMouseMove` of echarts.
	    // Before passive can be adopted, these issues should be considered:
	    // (1) Whether and how a zrender user specifies an event listener passive. And by default,
	    // passive or not.
	    // (2) How to tread that some zrender event listener is passive, and some is not. If
	    // we use other way but not preventDefault of mousewheel and touchmove, browser
	    // compatibility should be handled.
	    // var opts = (env.passiveSupported && name === 'mousewheel')
	    //     ? {passive: true}
	    //     // By default, the third param of el.addEventListener is `capture: false`.
	    //     : void 0;
	    // el.addEventListener(name, handler /* , opts */);
	    el.addEventListener(name, handler, opt);
	  } else {
	    // For simplicity, do not implement `setCapture` for IE9-.
	    el.attachEvent('on' + name, handler);
	  }
	}
	/**
	 * Parameter are the same as `addEventListener`.
	 *
	 * Notice that if a listener is registered twice, one with capture and one without,
	 * remove each one separately. Removal of a capturing listener does not affect a
	 * non-capturing version of the same listener, and vice versa.
	 */
	
	
	function removeEventListener(el, name, handler, opt) {
	  if (isDomLevel2) {
	    el.removeEventListener(name, handler, opt);
	  } else {
	    el.detachEvent('on' + name, handler);
	  }
	}
	/**
	 * preventDefault and stopPropagation.
	 * Notice: do not use this method in zrender. It can only be
	 * used by upper applications if necessary.
	 *
	 * @param {Event} e A mouse or touch event.
	 */
	
	
	var stop = isDomLevel2 ? function (e) {
	  e.preventDefault();
	  e.stopPropagation();
	  e.cancelBubble = true;
	} : function (e) {
	  e.returnValue = false;
	  e.cancelBubble = true;
	};
	/**
	 * This method only works for mouseup and mousedown. The functionality is restricted
	 * for fault tolerance, See the `e.which` compatibility above.
	 *
	 * @param {MouseEvent} e
	 * @return {boolean}
	 */
	
	function isMiddleOrRightButtonOnMouseUpDown(e) {
	  return e.which === 2 || e.which === 3;
	}
	/**
	 * To be removed.
	 * @deprecated
	 */
	
	
	function notLeftMouse(e) {
	  // If e.which is undefined, considered as left mouse event.
	  return e.which > 1;
	} // For backward compatibility
	
	
	exports.clientToLocal = clientToLocal;
	exports.getNativeEvent = getNativeEvent;
	exports.normalizeEvent = normalizeEvent;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.stop = stop;
	exports.isMiddleOrRightButtonOnMouseUpDown = isMiddleOrRightButtonOnMouseUpDown;
	exports.notLeftMouse = notLeftMouse;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(219);
	
	var _fourPointsTransform = __webpack_require__(227);
	
	var buildTransformer = _fourPointsTransform.buildTransformer;
	var EVENT_SAVED_PROP = '___zrEVENTSAVED';
	var _calcOut = [];
	/**
	 * Transform "local coord" from `elFrom` to `elTarget`.
	 * "local coord": the coord based on the input `el`. The origin point is at
	 *     the position of "left: 0; top: 0;" in the `el`.
	 *
	 * Support when CSS transform is used.
	 *
	 * Having the `out` (that is, `[outX, outY]`), we can create an DOM element
	 * and set the CSS style as "left: outX; top: outY;" and append it to `elTarge`
	 * to locate the element.
	 *
	 * For example, this code below positions a child of `document.body` on the event
	 * point, no matter whether `body` has `margin`/`paddin`/`transfrom`/... :
	 * ```js
	 * transformLocalCoord(out, container, document.body, event.offsetX, event.offsetY);
	 * if (!eqNaN(out[0])) {
	 *     // Then locate the tip element on the event point.
	 *     var tipEl = document.createElement('div');
	 *     tipEl.style.cssText = 'position: absolute; left:' + out[0] + ';top:' + out[1] + ';';
	 *     document.body.appendChild(tipEl);
	 * }
	 * ```
	 *
	 * Notice: In some env this method is not supported. If called, `out` will be `[NaN, NaN]`.
	 *
	 * @param {Array.<number>} out [inX: number, inY: number] The output..
	 *        If can not transform, `out` will not be modified but return `false`.
	 * @param {HTMLElement} elFrom The `[inX, inY]` is based on elFrom.
	 * @param {HTMLElement} elTarget The `out` is based on elTarget.
	 * @param {number} inX
	 * @param {number} inY
	 * @return {boolean} Whether transform successfully.
	 */
	
	function transformLocalCoord(out, elFrom, elTarget, inX, inY) {
	  return transformCoordWithViewport(_calcOut, elFrom, inX, inY, true) && transformCoordWithViewport(out, elTarget, _calcOut[0], _calcOut[1]);
	}
	/**
	 * Transform between a "viewport coord" and a "local coord".
	 * "viewport coord": the coord based on the left-top corner of the viewport
	 *     of the browser.
	 * "local coord": the coord based on the input `el`. The origin point is at
	 *     the position of "left: 0; top: 0;" in the `el`.
	 *
	 * Support the case when CSS transform is used on el.
	 *
	 * @param {Array.<number>} out [inX: number, inY: number] The output. If `inverse: false`,
	 *        it represents "local coord", otherwise "vireport coord".
	 *        If can not transform, `out` will not be modified but return `false`.
	 * @param {HTMLElement} el The "local coord" is based on the `el`, see comment above.
	 * @param {number} inX If `inverse: false`,
	 *        it represents "vireport coord", otherwise "local coord".
	 * @param {number} inY If `inverse: false`,
	 *        it represents "vireport coord", otherwise "local coord".
	 * @param {boolean} [inverse=false]
	 *        `true`: from "viewport coord" to "local coord".
	 *        `false`: from "local coord" to "viewport coord".
	 * @return {boolean} Whether transform successfully.
	 */
	
	
	function transformCoordWithViewport(out, el, inX, inY, inverse) {
	  if (el.getBoundingClientRect && env.domSupported && !isCanvasEl(el)) {
	    var saved = el[EVENT_SAVED_PROP] || (el[EVENT_SAVED_PROP] = {});
	    var markers = prepareCoordMarkers(el, saved);
	    var transformer = preparePointerTransformer(markers, saved, inverse);
	
	    if (transformer) {
	      transformer(out, inX, inY);
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function prepareCoordMarkers(el, saved) {
	  var markers = saved.markers;
	
	  if (markers) {
	    return markers;
	  }
	
	  markers = saved.markers = [];
	  var propLR = ['left', 'right'];
	  var propTB = ['top', 'bottom'];
	
	  for (var i = 0; i < 4; i++) {
	    var marker = document.createElement('div');
	    var stl = marker.style;
	    var idxLR = i % 2;
	    var idxTB = (i >> 1) % 2;
	    stl.cssText = ['position: absolute', 'visibility: hidden', 'padding: 0', 'margin: 0', 'border-width: 0', 'user-select: none', 'width:0', 'height:0', // 'width: 5px',
	    // 'height: 5px',
	    propLR[idxLR] + ':0', propTB[idxTB] + ':0', propLR[1 - idxLR] + ':auto', propTB[1 - idxTB] + ':auto', ''].join('!important;');
	    el.appendChild(marker);
	    markers.push(marker);
	  }
	
	  return markers;
	}
	
	function preparePointerTransformer(markers, saved, inverse) {
	  var transformerName = inverse ? 'invTrans' : 'trans';
	  var transformer = saved[transformerName];
	  var oldSrcCoords = saved.srcCoords;
	  var oldCoordTheSame = true;
	  var srcCoords = [];
	  var destCoords = [];
	
	  for (var i = 0; i < 4; i++) {
	    var rect = markers[i].getBoundingClientRect();
	    var ii = 2 * i;
	    var x = rect.left;
	    var y = rect.top;
	    srcCoords.push(x, y);
	    oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
	    destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
	  } // Cache to avoid time consuming of `buildTransformer`.
	
	
	  return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? buildTransformer(destCoords, srcCoords) : buildTransformer(srcCoords, destCoords));
	}
	
	function isCanvasEl(el) {
	  return el.nodeName.toUpperCase() === 'CANVAS';
	}
	
	exports.transformLocalCoord = transformLocalCoord;
	exports.transformCoordWithViewport = transformCoordWithViewport;
	exports.isCanvasEl = isCanvasEl;

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	/**
	 * The algoritm is learnt from
	 * https://franklinta.com/2014/09/08/computing-css-matrix3d-transforms/
	 * And we made some optimization for matrix inversion.
	 * Other similar approaches:
	 * "cv::getPerspectiveTransform", "Direct Linear Transformation".
	 */
	var LN2 = Math.log(2);
	
	function determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
	  var cacheKey = rowMask + '-' + colMask;
	  var fullRank = rows.length;
	
	  if (detCache.hasOwnProperty(cacheKey)) {
	    return detCache[cacheKey];
	  }
	
	  if (rank === 1) {
	    // In this case the colMask must be like: `11101111`. We can find the place of `0`.
	    var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / LN2);
	    return rows[rowStart][colStart];
	  }
	
	  var subRowMask = rowMask | 1 << rowStart;
	  var subRowStart = rowStart + 1;
	
	  while (rowMask & 1 << subRowStart) {
	    subRowStart++;
	  }
	
	  var sum = 0;
	
	  for (var j = 0, colLocalIdx = 0; j < fullRank; j++) {
	    var colTag = 1 << j;
	
	    if (!(colTag & colMask)) {
	      sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] // det(subMatrix(0, j))
	      * determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
	      colLocalIdx++;
	    }
	  }
	
	  detCache[cacheKey] = sum;
	  return sum;
	}
	/**
	 * Usage:
	 * ```js
	 * var transformer = buildTransformer(
	 *     [10, 44, 100, 44, 100, 300, 10, 300],
	 *     [50, 54, 130, 14, 140, 330, 14, 220]
	 * );
	 * var out = [];
	 * transformer && transformer([11, 33], out);
	 * ```
	 *
	 * Notice: `buildTransformer` may take more than 10ms in some Android device.
	 *
	 * @param {Array.<number>} src source four points, [x0, y0, x1, y1, x2, y2, x3, y3]
	 * @param {Array.<number>} dest destination four points, [x0, y0, x1, y1, x2, y2, x3, y3]
	 * @return {Function} transformer If fail, return null/undefined.
	 */
	
	
	function buildTransformer(src, dest) {
	  var mA = [[src[0], src[1], 1, 0, 0, 0, -dest[0] * src[0], -dest[0] * src[1]], [0, 0, 0, src[0], src[1], 1, -dest[1] * src[0], -dest[1] * src[1]], [src[2], src[3], 1, 0, 0, 0, -dest[2] * src[2], -dest[2] * src[3]], [0, 0, 0, src[2], src[3], 1, -dest[3] * src[2], -dest[3] * src[3]], [src[4], src[5], 1, 0, 0, 0, -dest[4] * src[4], -dest[4] * src[5]], [0, 0, 0, src[4], src[5], 1, -dest[5] * src[4], -dest[5] * src[5]], [src[6], src[7], 1, 0, 0, 0, -dest[6] * src[6], -dest[6] * src[7]], [0, 0, 0, src[6], src[7], 1, -dest[7] * src[6], -dest[7] * src[7]]];
	  var detCache = {};
	  var det = determinant(mA, 8, 0, 0, 0, detCache);
	
	  if (det === 0) {
	    // can not make transformer when and only when
	    // any three of the markers are collinear.
	    return;
	  } // `invert(mA) * dest`, that is, `adj(mA) / det * dest`.
	
	
	  var vh = [];
	
	  for (var i = 0; i < 8; i++) {
	    for (var j = 0; j < 8; j++) {
	      vh[j] == null && (vh[j] = 0);
	      vh[j] += ((i + j) % 2 ? -1 : 1) * // det(subMatrix(i, j))
	      determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
	    }
	  }
	
	  return function (out, srcPointX, srcPointY) {
	    var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
	    out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
	    out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
	  };
	}
	
	exports.buildTransformer = buildTransformer;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var eventUtil = __webpack_require__(225);
	
	/**
	 * Only implements needed gestures for mobile.
	 */
	var GestureMgr = function () {
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	  this._track = [];
	};
	
	GestureMgr.prototype = {
	  constructor: GestureMgr,
	  recognize: function (event, target, root) {
	    this._doTrack(event, target, root);
	
	    return this._recognize(event);
	  },
	  clear: function () {
	    this._track.length = 0;
	    return this;
	  },
	  _doTrack: function (event, target, root) {
	    var touches = event.touches;
	
	    if (!touches) {
	      return;
	    }
	
	    var trackItem = {
	      points: [],
	      touches: [],
	      target: target,
	      event: event
	    };
	
	    for (var i = 0, len = touches.length; i < len; i++) {
	      var touch = touches[i];
	      var pos = eventUtil.clientToLocal(root, touch, {});
	      trackItem.points.push([pos.zrX, pos.zrY]);
	      trackItem.touches.push(touch);
	    }
	
	    this._track.push(trackItem);
	  },
	  _recognize: function (event) {
	    for (var eventName in recognizers) {
	      if (recognizers.hasOwnProperty(eventName)) {
	        var gestureInfo = recognizers[eventName](this._track, event);
	
	        if (gestureInfo) {
	          return gestureInfo;
	        }
	      }
	    }
	  }
	};
	
	function dist(pointPair) {
	  var dx = pointPair[1][0] - pointPair[0][0];
	  var dy = pointPair[1][1] - pointPair[0][1];
	  return Math.sqrt(dx * dx + dy * dy);
	}
	
	function center(pointPair) {
	  return [(pointPair[0][0] + pointPair[1][0]) / 2, (pointPair[0][1] + pointPair[1][1]) / 2];
	}
	
	var recognizers = {
	  pinch: function (track, event) {
	    var trackLen = track.length;
	
	    if (!trackLen) {
	      return;
	    }
	
	    var pinchEnd = (track[trackLen - 1] || {}).points;
	    var pinchPre = (track[trackLen - 2] || {}).points || pinchEnd;
	
	    if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
	      var pinchScale = dist(pinchEnd) / dist(pinchPre);
	      !isFinite(pinchScale) && (pinchScale = 1);
	      event.pinchScale = pinchScale;
	      var pinchCenter = center(pinchEnd);
	      event.pinchX = pinchCenter[0];
	      event.pinchY = pinchCenter[1];
	      return {
	        type: 'pinch',
	        target: track[0].target,
	        event: event
	      };
	    }
	  } // Only pinch currently.
	
	};
	var _default = GestureMgr;
	module.exports = _default;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(220);
	
	var env = __webpack_require__(219);
	
	var Group = __webpack_require__(230);
	
	var timsort = __webpack_require__(243);
	
	// Use timsort because in most case elements are partially sorted
	// https://jsfiddle.net/pissang/jr4x7mdm/8/
	function shapeCompareFunc(a, b) {
	  if (a.zlevel === b.zlevel) {
	    if (a.z === b.z) {
	      // if (a.z2 === b.z2) {
	      //     // FIXME Slow has renderidx compare
	      //     // http://stackoverflow.com/questions/20883421/sorting-in-javascript-should-every-compare-function-have-a-return-0-statement
	      //     // https://github.com/v8/v8/blob/47cce544a31ed5577ffe2963f67acb4144ee0232/src/js/array.js#L1012
	      //     return a.__renderidx - b.__renderidx;
	      // }
	      return a.z2 - b.z2;
	    }
	
	    return a.z - b.z;
	  }
	
	  return a.zlevel - b.zlevel;
	}
	/**
	 * 内容仓库 (M)
	 * @alias module:zrender/Storage
	 * @constructor
	 */
	
	
	var Storage = function () {
	  // jshint ignore:line
	  this._roots = [];
	  this._displayList = [];
	  this._displayListLen = 0;
	};
	
	Storage.prototype = {
	  constructor: Storage,
	
	  /**
	   * @param  {Function} cb
	   *
	   */
	  traverse: function (cb, context) {
	    for (var i = 0; i < this._roots.length; i++) {
	      this._roots[i].traverse(cb, context);
	    }
	  },
	
	  /**
	   * 返回所有图形的绘制队列
	   * @param {boolean} [update=false] 是否在返回前更新该数组
	   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组, 在 update 为 true 的时候有效
	   *
	   * 详见{@link module:zrender/graphic/Displayable.prototype.updateDisplayList}
	   * @return {Array.<module:zrender/graphic/Displayable>}
	   */
	  getDisplayList: function (update, includeIgnore) {
	    includeIgnore = includeIgnore || false;
	
	    if (update) {
	      this.updateDisplayList(includeIgnore);
	    }
	
	    return this._displayList;
	  },
	
	  /**
	   * 更新图形的绘制队列。
	   * 每次绘制前都会调用，该方法会先深度优先遍历整个树，更新所有Group和Shape的变换并且把所有可见的Shape保存到数组中，
	   * 最后根据绘制的优先级（zlevel > z > 插入顺序）排序得到绘制队列
	   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组
	   */
	  updateDisplayList: function (includeIgnore) {
	    this._displayListLen = 0;
	    var roots = this._roots;
	    var displayList = this._displayList;
	
	    for (var i = 0, len = roots.length; i < len; i++) {
	      this._updateAndAddDisplayable(roots[i], null, includeIgnore);
	    }
	
	    displayList.length = this._displayListLen;
	    env.canvasSupported && timsort(displayList, shapeCompareFunc);
	  },
	  _updateAndAddDisplayable: function (el, clipPaths, includeIgnore) {
	    if (el.ignore && !includeIgnore) {
	      return;
	    }
	
	    el.beforeUpdate();
	
	    if (el.__dirty) {
	      el.update();
	    }
	
	    el.afterUpdate();
	    var userSetClipPath = el.clipPath;
	
	    if (userSetClipPath) {
	      // FIXME 效率影响
	      if (clipPaths) {
	        clipPaths = clipPaths.slice();
	      } else {
	        clipPaths = [];
	      }
	
	      var currentClipPath = userSetClipPath;
	      var parentClipPath = el; // Recursively add clip path
	
	      while (currentClipPath) {
	        // clipPath 的变换是基于使用这个 clipPath 的元素
	        currentClipPath.parent = parentClipPath;
	        currentClipPath.updateTransform();
	        clipPaths.push(currentClipPath);
	        parentClipPath = currentClipPath;
	        currentClipPath = currentClipPath.clipPath;
	      }
	    }
	
	    if (el.isGroup) {
	      var children = el._children;
	
	      for (var i = 0; i < children.length; i++) {
	        var child = children[i]; // Force to mark as dirty if group is dirty
	        // FIXME __dirtyPath ?
	
	        if (el.__dirty) {
	          child.__dirty = true;
	        }
	
	        this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
	      } // Mark group clean here
	
	
	      el.__dirty = false;
	    } else {
	      el.__clipPaths = clipPaths;
	      this._displayList[this._displayListLen++] = el;
	    }
	  },
	
	  /**
	   * 添加图形(Shape)或者组(Group)到根节点
	   * @param {module:zrender/Element} el
	   */
	  addRoot: function (el) {
	    if (el.__storage === this) {
	      return;
	    }
	
	    if (el instanceof Group) {
	      el.addChildrenToStorage(this);
	    }
	
	    this.addToStorage(el);
	
	    this._roots.push(el);
	  },
	
	  /**
	   * 删除指定的图形(Shape)或者组(Group)
	   * @param {string|Array.<string>} [el] 如果为空清空整个Storage
	   */
	  delRoot: function (el) {
	    if (el == null) {
	      // 不指定el清空
	      for (var i = 0; i < this._roots.length; i++) {
	        var root = this._roots[i];
	
	        if (root instanceof Group) {
	          root.delChildrenFromStorage(this);
	        }
	      }
	
	      this._roots = [];
	      this._displayList = [];
	      this._displayListLen = 0;
	      return;
	    }
	
	    if (el instanceof Array) {
	      for (var i = 0, l = el.length; i < l; i++) {
	        this.delRoot(el[i]);
	      }
	
	      return;
	    }
	
	    var idx = util.indexOf(this._roots, el);
	
	    if (idx >= 0) {
	      this.delFromStorage(el);
	
	      this._roots.splice(idx, 1);
	
	      if (el instanceof Group) {
	        el.delChildrenFromStorage(this);
	      }
	    }
	  },
	  addToStorage: function (el) {
	    if (el) {
	      el.__storage = this;
	      el.dirty(false);
	    }
	
	    return this;
	  },
	  delFromStorage: function (el) {
	    if (el) {
	      el.__storage = null;
	    }
	
	    return this;
	  },
	
	  /**
	   * 清空并且释放Storage
	   */
	  dispose: function () {
	    this._renderList = this._roots = null;
	  },
	  displayableSortFunc: shapeCompareFunc
	};
	var _default = Storage;
	module.exports = _default;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(220);
	
	var Element = __webpack_require__(231);
	
	var BoundingRect = __webpack_require__(242);
	
	/**
	 * Group是一个容器，可以插入子节点，Group的变换也会被应用到子节点上
	 * @module zrender/graphic/Group
	 * @example
	 *     var Group = require('zrender/container/Group');
	 *     var Circle = require('zrender/graphic/shape/Circle');
	 *     var g = new Group();
	 *     g.position[0] = 100;
	 *     g.position[1] = 100;
	 *     g.add(new Circle({
	 *         style: {
	 *             x: 100,
	 *             y: 100,
	 *             r: 20,
	 *         }
	 *     }));
	 *     zr.add(g);
	 */
	
	/**
	 * @alias module:zrender/graphic/Group
	 * @constructor
	 * @extends module:zrender/mixin/Transformable
	 * @extends module:zrender/mixin/Eventful
	 */
	var Group = function (opts) {
	  opts = opts || {};
	  Element.call(this, opts);
	
	  for (var key in opts) {
	    if (opts.hasOwnProperty(key)) {
	      this[key] = opts[key];
	    }
	  }
	
	  this._children = [];
	  this.__storage = null;
	  this.__dirty = true;
	};
	
	Group.prototype = {
	  constructor: Group,
	  isGroup: true,
	
	  /**
	   * @type {string}
	   */
	  type: 'group',
	
	  /**
	   * 所有子孙元素是否响应鼠标事件
	   * @name module:/zrender/container/Group#silent
	   * @type {boolean}
	   * @default false
	   */
	  silent: false,
	
	  /**
	   * @return {Array.<module:zrender/Element>}
	   */
	  children: function () {
	    return this._children.slice();
	  },
	
	  /**
	   * 获取指定 index 的儿子节点
	   * @param  {number} idx
	   * @return {module:zrender/Element}
	   */
	  childAt: function (idx) {
	    return this._children[idx];
	  },
	
	  /**
	   * 获取指定名字的儿子节点
	   * @param  {string} name
	   * @return {module:zrender/Element}
	   */
	  childOfName: function (name) {
	    var children = this._children;
	
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].name === name) {
	        return children[i];
	      }
	    }
	  },
	
	  /**
	   * @return {number}
	   */
	  childCount: function () {
	    return this._children.length;
	  },
	
	  /**
	   * 添加子节点到最后
	   * @param {module:zrender/Element} child
	   */
	  add: function (child) {
	    if (child && child !== this && child.parent !== this) {
	      this._children.push(child);
	
	      this._doAdd(child);
	    }
	
	    return this;
	  },
	
	  /**
	   * 添加子节点在 nextSibling 之前
	   * @param {module:zrender/Element} child
	   * @param {module:zrender/Element} nextSibling
	   */
	  addBefore: function (child, nextSibling) {
	    if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
	      var children = this._children;
	      var idx = children.indexOf(nextSibling);
	
	      if (idx >= 0) {
	        children.splice(idx, 0, child);
	
	        this._doAdd(child);
	      }
	    }
	
	    return this;
	  },
	  _doAdd: function (child) {
	    if (child.parent) {
	      child.parent.remove(child);
	    }
	
	    child.parent = this;
	    var storage = this.__storage;
	    var zr = this.__zr;
	
	    if (storage && storage !== child.__storage) {
	      storage.addToStorage(child);
	
	      if (child instanceof Group) {
	        child.addChildrenToStorage(storage);
	      }
	    }
	
	    zr && zr.refresh();
	  },
	
	  /**
	   * 移除子节点
	   * @param {module:zrender/Element} child
	   */
	  remove: function (child) {
	    var zr = this.__zr;
	    var storage = this.__storage;
	    var children = this._children;
	    var idx = zrUtil.indexOf(children, child);
	
	    if (idx < 0) {
	      return this;
	    }
	
	    children.splice(idx, 1);
	    child.parent = null;
	
	    if (storage) {
	      storage.delFromStorage(child);
	
	      if (child instanceof Group) {
	        child.delChildrenFromStorage(storage);
	      }
	    }
	
	    zr && zr.refresh();
	    return this;
	  },
	
	  /**
	   * 移除所有子节点
	   */
	  removeAll: function () {
	    var children = this._children;
	    var storage = this.__storage;
	    var child;
	    var i;
	
	    for (i = 0; i < children.length; i++) {
	      child = children[i];
	
	      if (storage) {
	        storage.delFromStorage(child);
	
	        if (child instanceof Group) {
	          child.delChildrenFromStorage(storage);
	        }
	      }
	
	      child.parent = null;
	    }
	
	    children.length = 0;
	    return this;
	  },
	
	  /**
	   * 遍历所有子节点
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  eachChild: function (cb, context) {
	    var children = this._children;
	
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	      cb.call(context, child, i);
	    }
	
	    return this;
	  },
	
	  /**
	   * 深度优先遍历所有子孙节点
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      cb.call(context, child);
	
	      if (child.type === 'group') {
	        child.traverse(cb, context);
	      }
	    }
	
	    return this;
	  },
	  addChildrenToStorage: function (storage) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      storage.addToStorage(child);
	
	      if (child instanceof Group) {
	        child.addChildrenToStorage(storage);
	      }
	    }
	  },
	  delChildrenFromStorage: function (storage) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      storage.delFromStorage(child);
	
	      if (child instanceof Group) {
	        child.delChildrenFromStorage(storage);
	      }
	    }
	  },
	  dirty: function () {
	    this.__dirty = true;
	    this.__zr && this.__zr.refresh();
	    return this;
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function (includeChildren) {
	    // TODO Caching
	    var rect = null;
	    var tmpRect = new BoundingRect(0, 0, 0, 0);
	    var children = includeChildren || this._children;
	    var tmpMat = [];
	
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	
	      if (child.ignore || child.invisible) {
	        continue;
	      }
	
	      var childRect = child.getBoundingRect();
	      var transform = child.getLocalTransform(tmpMat); // TODO
	      // The boundingRect cacluated by transforming original
	      // rect may be bigger than the actual bundingRect when rotation
	      // is used. (Consider a circle rotated aginst its center, where
	      // the actual boundingRect should be the same as that not be
	      // rotated.) But we can not find better approach to calculate
	      // actual boundingRect yet, considering performance.
	
	      if (transform) {
	        tmpRect.copy(childRect);
	        tmpRect.applyTransform(transform);
	        rect = rect || tmpRect.clone();
	        rect.union(tmpRect);
	      } else {
	        rect = rect || childRect.clone();
	        rect.union(childRect);
	      }
	    }
	
	    return rect || tmpRect;
	  }
	};
	zrUtil.inherits(Group, Element);
	var _default = Group;
	module.exports = _default;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var guid = __webpack_require__(218);
	
	var Eventful = __webpack_require__(224);
	
	var Transformable = __webpack_require__(232);
	
	var Animatable = __webpack_require__(234);
	
	var zrUtil = __webpack_require__(220);
	
	/**
	 * @alias module:zrender/Element
	 * @constructor
	 * @extends {module:zrender/mixin/Animatable}
	 * @extends {module:zrender/mixin/Transformable}
	 * @extends {module:zrender/mixin/Eventful}
	 */
	var Element = function (opts) {
	  // jshint ignore:line
	  Transformable.call(this, opts);
	  Eventful.call(this, opts);
	  Animatable.call(this, opts);
	  /**
	   * 画布元素ID
	   * @type {string}
	   */
	
	  this.id = opts.id || guid();
	};
	
	Element.prototype = {
	  /**
	   * 元素类型
	   * Element type
	   * @type {string}
	   */
	  type: 'element',
	
	  /**
	   * 元素名字
	   * Element name
	   * @type {string}
	   */
	  name: '',
	
	  /**
	   * ZRender 实例对象，会在 element 添加到 zrender 实例中后自动赋值
	   * ZRender instance will be assigned when element is associated with zrender
	   * @name module:/zrender/Element#__zr
	   * @type {module:zrender/ZRender}
	   */
	  __zr: null,
	
	  /**
	   * 图形是否忽略，为true时忽略图形的绘制以及事件触发
	   * If ignore drawing and events of the element object
	   * @name module:/zrender/Element#ignore
	   * @type {boolean}
	   * @default false
	   */
	  ignore: false,
	
	  /**
	   * 用于裁剪的路径(shape)，所有 Group 内的路径在绘制时都会被这个路径裁剪
	   * 该路径会继承被裁减对象的变换
	   * @type {module:zrender/graphic/Path}
	   * @see http://www.w3.org/TR/2dcontext/#clipping-region
	   * @readOnly
	   */
	  clipPath: null,
	
	  /**
	   * 是否是 Group
	   * @type {boolean}
	   */
	  isGroup: false,
	
	  /**
	   * Drift element
	   * @param  {number} dx dx on the global space
	   * @param  {number} dy dy on the global space
	   */
	  drift: function (dx, dy) {
	    switch (this.draggable) {
	      case 'horizontal':
	        dy = 0;
	        break;
	
	      case 'vertical':
	        dx = 0;
	        break;
	    }
	
	    var m = this.transform;
	
	    if (!m) {
	      m = this.transform = [1, 0, 0, 1, 0, 0];
	    }
	
	    m[4] += dx;
	    m[5] += dy;
	    this.decomposeTransform();
	    this.dirty(false);
	  },
	
	  /**
	   * Hook before update
	   */
	  beforeUpdate: function () {},
	
	  /**
	   * Hook after update
	   */
	  afterUpdate: function () {},
	
	  /**
	   * Update each frame
	   */
	  update: function () {
	    this.updateTransform();
	  },
	
	  /**
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {},
	
	  /**
	   * @protected
	   */
	  attrKV: function (key, value) {
	    if (key === 'position' || key === 'scale' || key === 'origin') {
	      // Copy the array
	      if (value) {
	        var target = this[key];
	
	        if (!target) {
	          target = this[key] = [];
	        }
	
	        target[0] = value[0];
	        target[1] = value[1];
	      }
	    } else {
	      this[key] = value;
	    }
	  },
	
	  /**
	   * Hide the element
	   */
	  hide: function () {
	    this.ignore = true;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * Show the element
	   */
	  show: function () {
	    this.ignore = false;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * @param {string|Object} key
	   * @param {*} value
	   */
	  attr: function (key, value) {
	    if (typeof key === 'string') {
	      this.attrKV(key, value);
	    } else if (zrUtil.isObject(key)) {
	      for (var name in key) {
	        if (key.hasOwnProperty(name)) {
	          this.attrKV(name, key[name]);
	        }
	      }
	    }
	
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * @param {module:zrender/graphic/Path} clipPath
	   */
	  setClipPath: function (clipPath) {
	    var zr = this.__zr;
	
	    if (zr) {
	      clipPath.addSelfToZr(zr);
	    } // Remove previous clip path
	
	
	    if (this.clipPath && this.clipPath !== clipPath) {
	      this.removeClipPath();
	    }
	
	    this.clipPath = clipPath;
	    clipPath.__zr = zr;
	    clipPath.__clipTarget = this;
	    this.dirty(false);
	  },
	
	  /**
	   */
	  removeClipPath: function () {
	    var clipPath = this.clipPath;
	
	    if (clipPath) {
	      if (clipPath.__zr) {
	        clipPath.removeSelfFromZr(clipPath.__zr);
	      }
	
	      clipPath.__zr = null;
	      clipPath.__clipTarget = null;
	      this.clipPath = null;
	      this.dirty(false);
	    }
	  },
	
	  /**
	   * Add self from zrender instance.
	   * Not recursively because it will be invoked when element added to storage.
	   * @param {module:zrender/ZRender} zr
	   */
	  addSelfToZr: function (zr) {
	    this.__zr = zr; // 添加动画
	
	    var animators = this.animators;
	
	    if (animators) {
	      for (var i = 0; i < animators.length; i++) {
	        zr.animation.addAnimator(animators[i]);
	      }
	    }
	
	    if (this.clipPath) {
	      this.clipPath.addSelfToZr(zr);
	    }
	  },
	
	  /**
	   * Remove self from zrender instance.
	   * Not recursively because it will be invoked when element added to storage.
	   * @param {module:zrender/ZRender} zr
	   */
	  removeSelfFromZr: function (zr) {
	    this.__zr = null; // 移除动画
	
	    var animators = this.animators;
	
	    if (animators) {
	      for (var i = 0; i < animators.length; i++) {
	        zr.animation.removeAnimator(animators[i]);
	      }
	    }
	
	    if (this.clipPath) {
	      this.clipPath.removeSelfFromZr(zr);
	    }
	  }
	};
	zrUtil.mixin(Element, Animatable);
	zrUtil.mixin(Element, Transformable);
	zrUtil.mixin(Element, Eventful);
	var _default = Element;
	module.exports = _default;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var matrix = __webpack_require__(233);
	
	var vector = __webpack_require__(222);
	
	/**
	 * 提供变换扩展
	 * @module zrender/mixin/Transformable
	 * @author pissang (https://www.github.com/pissang)
	 */
	var mIdentity = matrix.identity;
	var EPSILON = 5e-5;
	
	function isNotAroundZero(val) {
	  return val > EPSILON || val < -EPSILON;
	}
	/**
	 * @alias module:zrender/mixin/Transformable
	 * @constructor
	 */
	
	
	var Transformable = function (opts) {
	  opts = opts || {}; // If there are no given position, rotation, scale
	
	  if (!opts.position) {
	    /**
	     * 平移
	     * @type {Array.<number>}
	     * @default [0, 0]
	     */
	    this.position = [0, 0];
	  }
	
	  if (opts.rotation == null) {
	    /**
	     * 旋转
	     * @type {Array.<number>}
	     * @default 0
	     */
	    this.rotation = 0;
	  }
	
	  if (!opts.scale) {
	    /**
	     * 缩放
	     * @type {Array.<number>}
	     * @default [1, 1]
	     */
	    this.scale = [1, 1];
	  }
	  /**
	   * 旋转和缩放的原点
	   * @type {Array.<number>}
	   * @default null
	   */
	
	
	  this.origin = this.origin || null;
	};
	
	var transformableProto = Transformable.prototype;
	transformableProto.transform = null;
	/**
	 * 判断是否需要有坐标变换
	 * 如果有坐标变换, 则从position, rotation, scale以及父节点的transform计算出自身的transform矩阵
	 */
	
	transformableProto.needLocalTransform = function () {
	  return isNotAroundZero(this.rotation) || isNotAroundZero(this.position[0]) || isNotAroundZero(this.position[1]) || isNotAroundZero(this.scale[0] - 1) || isNotAroundZero(this.scale[1] - 1);
	};
	
	var scaleTmp = [];
	
	transformableProto.updateTransform = function () {
	  var parent = this.parent;
	  var parentHasTransform = parent && parent.transform;
	  var needLocalTransform = this.needLocalTransform();
	  var m = this.transform;
	
	  if (!(needLocalTransform || parentHasTransform)) {
	    m && mIdentity(m);
	    return;
	  }
	
	  m = m || matrix.create();
	
	  if (needLocalTransform) {
	    this.getLocalTransform(m);
	  } else {
	    mIdentity(m);
	  } // 应用父节点变换
	
	
	  if (parentHasTransform) {
	    if (needLocalTransform) {
	      matrix.mul(m, parent.transform, m);
	    } else {
	      matrix.copy(m, parent.transform);
	    }
	  } // 保存这个变换矩阵
	
	
	  this.transform = m;
	  var globalScaleRatio = this.globalScaleRatio;
	
	  if (globalScaleRatio != null && globalScaleRatio !== 1) {
	    this.getGlobalScale(scaleTmp);
	    var relX = scaleTmp[0] < 0 ? -1 : 1;
	    var relY = scaleTmp[1] < 0 ? -1 : 1;
	    var sx = ((scaleTmp[0] - relX) * globalScaleRatio + relX) / scaleTmp[0] || 0;
	    var sy = ((scaleTmp[1] - relY) * globalScaleRatio + relY) / scaleTmp[1] || 0;
	    m[0] *= sx;
	    m[1] *= sx;
	    m[2] *= sy;
	    m[3] *= sy;
	  }
	
	  this.invTransform = this.invTransform || matrix.create();
	  matrix.invert(this.invTransform, m);
	};
	
	transformableProto.getLocalTransform = function (m) {
	  return Transformable.getLocalTransform(this, m);
	};
	/**
	 * 将自己的transform应用到context上
	 * @param {CanvasRenderingContext2D} ctx
	 */
	
	
	transformableProto.setTransform = function (ctx) {
	  var m = this.transform;
	  var dpr = ctx.dpr || 1;
	
	  if (m) {
	    ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
	  } else {
	    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	  }
	};
	
	transformableProto.restoreTransform = function (ctx) {
	  var dpr = ctx.dpr || 1;
	  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	};
	
	var tmpTransform = [];
	var originTransform = matrix.create();
	
	transformableProto.setLocalTransform = function (m) {
	  if (!m) {
	    // TODO return or set identity?
	    return;
	  }
	
	  var sx = m[0] * m[0] + m[1] * m[1];
	  var sy = m[2] * m[2] + m[3] * m[3];
	  var position = this.position;
	  var scale = this.scale;
	
	  if (isNotAroundZero(sx - 1)) {
	    sx = Math.sqrt(sx);
	  }
	
	  if (isNotAroundZero(sy - 1)) {
	    sy = Math.sqrt(sy);
	  }
	
	  if (m[0] < 0) {
	    sx = -sx;
	  }
	
	  if (m[3] < 0) {
	    sy = -sy;
	  }
	
	  position[0] = m[4];
	  position[1] = m[5];
	  scale[0] = sx;
	  scale[1] = sy;
	  this.rotation = Math.atan2(-m[1] / sy, m[0] / sx);
	};
	/**
	 * 分解`transform`矩阵到`position`, `rotation`, `scale`
	 */
	
	
	transformableProto.decomposeTransform = function () {
	  if (!this.transform) {
	    return;
	  }
	
	  var parent = this.parent;
	  var m = this.transform;
	
	  if (parent && parent.transform) {
	    // Get local transform and decompose them to position, scale, rotation
	    matrix.mul(tmpTransform, parent.invTransform, m);
	    m = tmpTransform;
	  }
	
	  var origin = this.origin;
	
	  if (origin && (origin[0] || origin[1])) {
	    originTransform[4] = origin[0];
	    originTransform[5] = origin[1];
	    matrix.mul(tmpTransform, m, originTransform);
	    tmpTransform[4] -= origin[0];
	    tmpTransform[5] -= origin[1];
	    m = tmpTransform;
	  }
	
	  this.setLocalTransform(m);
	};
	/**
	 * Get global scale
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.getGlobalScale = function (out) {
	  var m = this.transform;
	  out = out || [];
	
	  if (!m) {
	    out[0] = 1;
	    out[1] = 1;
	    return out;
	  }
	
	  out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
	  out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
	
	  if (m[0] < 0) {
	    out[0] = -out[0];
	  }
	
	  if (m[3] < 0) {
	    out[1] = -out[1];
	  }
	
	  return out;
	};
	/**
	 * 变换坐标位置到 shape 的局部坐标空间
	 * @method
	 * @param {number} x
	 * @param {number} y
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.transformCoordToLocal = function (x, y) {
	  var v2 = [x, y];
	  var invTransform = this.invTransform;
	
	  if (invTransform) {
	    vector.applyTransform(v2, v2, invTransform);
	  }
	
	  return v2;
	};
	/**
	 * 变换局部坐标位置到全局坐标空间
	 * @method
	 * @param {number} x
	 * @param {number} y
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.transformCoordToGlobal = function (x, y) {
	  var v2 = [x, y];
	  var transform = this.transform;
	
	  if (transform) {
	    vector.applyTransform(v2, v2, transform);
	  }
	
	  return v2;
	};
	/**
	 * @static
	 * @param {Object} target
	 * @param {Array.<number>} target.origin
	 * @param {number} target.rotation
	 * @param {Array.<number>} target.position
	 * @param {Array.<number>} [m]
	 */
	
	
	Transformable.getLocalTransform = function (target, m) {
	  m = m || [];
	  mIdentity(m);
	  var origin = target.origin;
	  var scale = target.scale || [1, 1];
	  var rotation = target.rotation || 0;
	  var position = target.position || [0, 0];
	
	  if (origin) {
	    // Translate to origin
	    m[4] -= origin[0];
	    m[5] -= origin[1];
	  }
	
	  matrix.scale(m, m, scale);
	
	  if (rotation) {
	    matrix.rotate(m, m, rotation);
	  }
	
	  if (origin) {
	    // Translate back from origin
	    m[4] += origin[0];
	    m[5] += origin[1];
	  }
	
	  m[4] += position[0];
	  m[5] += position[1];
	  return m;
	};
	
	var _default = Transformable;
	module.exports = _default;

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	/**
	 * 3x2矩阵操作类
	 * @exports zrender/tool/matrix
	 */
	
	/* global Float32Array */
	var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
	/**
	 * Create a identity matrix.
	 * @return {Float32Array|Array.<number>}
	 */
	
	function create() {
	  var out = new ArrayCtor(6);
	  identity(out);
	  return out;
	}
	/**
	 * 设置矩阵为单位矩阵
	 * @param {Float32Array|Array.<number>} out
	 */
	
	
	function identity(out) {
	  out[0] = 1;
	  out[1] = 0;
	  out[2] = 0;
	  out[3] = 1;
	  out[4] = 0;
	  out[5] = 0;
	  return out;
	}
	/**
	 * 复制矩阵
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} m
	 */
	
	
	function copy(out, m) {
	  out[0] = m[0];
	  out[1] = m[1];
	  out[2] = m[2];
	  out[3] = m[3];
	  out[4] = m[4];
	  out[5] = m[5];
	  return out;
	}
	/**
	 * 矩阵相乘
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} m1
	 * @param {Float32Array|Array.<number>} m2
	 */
	
	
	function mul(out, m1, m2) {
	  // Consider matrix.mul(m, m2, m);
	  // where out is the same as m2.
	  // So use temp variable to escape error.
	  var out0 = m1[0] * m2[0] + m1[2] * m2[1];
	  var out1 = m1[1] * m2[0] + m1[3] * m2[1];
	  var out2 = m1[0] * m2[2] + m1[2] * m2[3];
	  var out3 = m1[1] * m2[2] + m1[3] * m2[3];
	  var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
	  var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
	  out[0] = out0;
	  out[1] = out1;
	  out[2] = out2;
	  out[3] = out3;
	  out[4] = out4;
	  out[5] = out5;
	  return out;
	}
	/**
	 * 平移变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {Float32Array|Array.<number>} v
	 */
	
	
	function translate(out, a, v) {
	  out[0] = a[0];
	  out[1] = a[1];
	  out[2] = a[2];
	  out[3] = a[3];
	  out[4] = a[4] + v[0];
	  out[5] = a[5] + v[1];
	  return out;
	}
	/**
	 * 旋转变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {number} rad
	 */
	
	
	function rotate(out, a, rad) {
	  var aa = a[0];
	  var ac = a[2];
	  var atx = a[4];
	  var ab = a[1];
	  var ad = a[3];
	  var aty = a[5];
	  var st = Math.sin(rad);
	  var ct = Math.cos(rad);
	  out[0] = aa * ct + ab * st;
	  out[1] = -aa * st + ab * ct;
	  out[2] = ac * ct + ad * st;
	  out[3] = -ac * st + ct * ad;
	  out[4] = ct * atx + st * aty;
	  out[5] = ct * aty - st * atx;
	  return out;
	}
	/**
	 * 缩放变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {Float32Array|Array.<number>} v
	 */
	
	
	function scale(out, a, v) {
	  var vx = v[0];
	  var vy = v[1];
	  out[0] = a[0] * vx;
	  out[1] = a[1] * vy;
	  out[2] = a[2] * vx;
	  out[3] = a[3] * vy;
	  out[4] = a[4] * vx;
	  out[5] = a[5] * vy;
	  return out;
	}
	/**
	 * 求逆矩阵
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 */
	
	
	function invert(out, a) {
	  var aa = a[0];
	  var ac = a[2];
	  var atx = a[4];
	  var ab = a[1];
	  var ad = a[3];
	  var aty = a[5];
	  var det = aa * ad - ab * ac;
	
	  if (!det) {
	    return null;
	  }
	
	  det = 1.0 / det;
	  out[0] = ad * det;
	  out[1] = -ab * det;
	  out[2] = -ac * det;
	  out[3] = aa * det;
	  out[4] = (ac * aty - ad * atx) * det;
	  out[5] = (ab * atx - aa * aty) * det;
	  return out;
	}
	/**
	 * Clone a new matrix.
	 * @param {Float32Array|Array.<number>} a
	 */
	
	
	function clone(a) {
	  var b = create();
	  copy(b, a);
	  return b;
	}
	
	exports.create = create;
	exports.identity = identity;
	exports.copy = copy;
	exports.mul = mul;
	exports.translate = translate;
	exports.rotate = rotate;
	exports.scale = scale;
	exports.invert = invert;
	exports.clone = clone;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	var Animator = __webpack_require__(235);
	
	var logError = __webpack_require__(240);
	
	var _util = __webpack_require__(220);
	
	var isString = _util.isString;
	var isFunction = _util.isFunction;
	var isObject = _util.isObject;
	var isArrayLike = _util.isArrayLike;
	var indexOf = _util.indexOf;
	
	/**
	 * @alias module:zrender/mixin/Animatable
	 * @constructor
	 */
	var Animatable = function () {
	  /**
	   * @type {Array.<module:zrender/animation/Animator>}
	   * @readOnly
	   */
	  this.animators = [];
	};
	
	Animatable.prototype = {
	  constructor: Animatable,
	
	  /**
	   * 动画
	   *
	   * @param {string} path The path to fetch value from object, like 'a.b.c'.
	   * @param {boolean} [loop] Whether to loop animation.
	   * @return {module:zrender/animation/Animator}
	   * @example:
	   *     el.animate('style', false)
	   *         .when(1000, {x: 10} )
	   *         .done(function(){ // Animation done })
	   *         .start()
	   */
	  animate: function (path, loop) {
	    var target;
	    var animatingShape = false;
	    var el = this;
	    var zr = this.__zr;
	
	    if (path) {
	      var pathSplitted = path.split('.');
	      var prop = el; // If animating shape
	
	      animatingShape = pathSplitted[0] === 'shape';
	
	      for (var i = 0, l = pathSplitted.length; i < l; i++) {
	        if (!prop) {
	          continue;
	        }
	
	        prop = prop[pathSplitted[i]];
	      }
	
	      if (prop) {
	        target = prop;
	      }
	    } else {
	      target = el;
	    }
	
	    if (!target) {
	      logError('Property "' + path + '" is not existed in element ' + el.id);
	      return;
	    }
	
	    var animators = el.animators;
	    var animator = new Animator(target, loop);
	    animator.during(function (target) {
	      el.dirty(animatingShape);
	    }).done(function () {
	      // FIXME Animator will not be removed if use `Animator#stop` to stop animation
	      animators.splice(indexOf(animators, animator), 1);
	    });
	    animators.push(animator); // If animate after added to the zrender
	
	    if (zr) {
	      zr.animation.addAnimator(animator);
	    }
	
	    return animator;
	  },
	
	  /**
	   * 停止动画
	   * @param {boolean} forwardToLast If move to last frame before stop
	   */
	  stopAnimation: function (forwardToLast) {
	    var animators = this.animators;
	    var len = animators.length;
	
	    for (var i = 0; i < len; i++) {
	      animators[i].stop(forwardToLast);
	    }
	
	    animators.length = 0;
	    return this;
	  },
	
	  /**
	   * Caution: this method will stop previous animation.
	   * So do not use this method to one element twice before
	   * animation starts, unless you know what you are doing.
	   * @param {Object} target
	   * @param {number} [time=500] Time in ms
	   * @param {string} [easing='linear']
	   * @param {number} [delay=0]
	   * @param {Function} [callback]
	   * @param {Function} [forceAnimate] Prevent stop animation and callback
	   *        immediently when target values are the same as current values.
	   *
	   * @example
	   *  // Animate position
	   *  el.animateTo({
	   *      position: [10, 10]
	   *  }, function () { // done })
	   *
	   *  // Animate shape, style and position in 100ms, delayed 100ms, with cubicOut easing
	   *  el.animateTo({
	   *      shape: {
	   *          width: 500
	   *      },
	   *      style: {
	   *          fill: 'red'
	   *      }
	   *      position: [10, 10]
	   *  }, 100, 100, 'cubicOut', function () { // done })
	   */
	  // TODO Return animation key
	  animateTo: function (target, time, delay, easing, callback, forceAnimate) {
	    animateTo(this, target, time, delay, easing, callback, forceAnimate);
	  },
	
	  /**
	   * Animate from the target state to current state.
	   * The params and the return value are the same as `this.animateTo`.
	   */
	  animateFrom: function (target, time, delay, easing, callback, forceAnimate) {
	    animateTo(this, target, time, delay, easing, callback, forceAnimate, true);
	  }
	};
	
	function animateTo(animatable, target, time, delay, easing, callback, forceAnimate, reverse) {
	  // animateTo(target, time, easing, callback);
	  if (isString(delay)) {
	    callback = easing;
	    easing = delay;
	    delay = 0;
	  } // animateTo(target, time, delay, callback);
	  else if (isFunction(easing)) {
	      callback = easing;
	      easing = 'linear';
	      delay = 0;
	    } // animateTo(target, time, callback);
	    else if (isFunction(delay)) {
	        callback = delay;
	        delay = 0;
	      } // animateTo(target, callback)
	      else if (isFunction(time)) {
	          callback = time;
	          time = 500;
	        } // animateTo(target)
	        else if (!time) {
	            time = 500;
	          } // Stop all previous animations
	
	
	  animatable.stopAnimation();
	  animateToShallow(animatable, '', animatable, target, time, delay, reverse); // Animators may be removed immediately after start
	  // if there is nothing to animate
	
	  var animators = animatable.animators.slice();
	  var count = animators.length;
	
	  function done() {
	    count--;
	
	    if (!count) {
	      callback && callback();
	    }
	  } // No animators. This should be checked before animators[i].start(),
	  // because 'done' may be executed immediately if no need to animate.
	
	
	  if (!count) {
	    callback && callback();
	  } // Start after all animators created
	  // Incase any animator is done immediately when all animation properties are not changed
	
	
	  for (var i = 0; i < animators.length; i++) {
	    animators[i].done(done).start(easing, forceAnimate);
	  }
	}
	/**
	 * @param {string} path=''
	 * @param {Object} source=animatable
	 * @param {Object} target
	 * @param {number} [time=500]
	 * @param {number} [delay=0]
	 * @param {boolean} [reverse] If `true`, animate
	 *        from the `target` to current state.
	 *
	 * @example
	 *  // Animate position
	 *  el._animateToShallow({
	 *      position: [10, 10]
	 *  })
	 *
	 *  // Animate shape, style and position in 100ms, delayed 100ms
	 *  el._animateToShallow({
	 *      shape: {
	 *          width: 500
	 *      },
	 *      style: {
	 *          fill: 'red'
	 *      }
	 *      position: [10, 10]
	 *  }, 100, 100)
	 */
	
	
	function animateToShallow(animatable, path, source, target, time, delay, reverse) {
	  var objShallow = {};
	  var propertyCount = 0;
	
	  for (var name in target) {
	    if (!target.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (source[name] != null) {
	      if (isObject(target[name]) && !isArrayLike(target[name])) {
	        animateToShallow(animatable, path ? path + '.' + name : name, source[name], target[name], time, delay, reverse);
	      } else {
	        if (reverse) {
	          objShallow[name] = source[name];
	          setAttrByPath(animatable, path, name, target[name]);
	        } else {
	          objShallow[name] = target[name];
	        }
	
	        propertyCount++;
	      }
	    } else if (target[name] != null && !reverse) {
	      setAttrByPath(animatable, path, name, target[name]);
	    }
	  }
	
	  if (propertyCount > 0) {
	    animatable.animate(path, false).when(time == null ? 500 : time, objShallow).delay(delay || 0);
	  }
	}
	
	function setAttrByPath(el, path, name, value) {
	  // Attr directly if not has property
	  // FIXME, if some property not needed for element ?
	  if (!path) {
	    el.attr(name, value);
	  } else {
	    // Only support set shape or style
	    var props = {};
	    props[path] = {};
	    props[path][name] = value;
	    el.attr(props);
	  }
	}
	
	var _default = Animatable;
	module.exports = _default;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	var Clip = __webpack_require__(236);
	
	var color = __webpack_require__(238);
	
	var _util = __webpack_require__(220);
	
	var isArrayLike = _util.isArrayLike;
	
	/**
	 * @module echarts/animation/Animator
	 */
	var arraySlice = Array.prototype.slice;
	
	function defaultGetter(target, key) {
	  return target[key];
	}
	
	function defaultSetter(target, key, value) {
	  target[key] = value;
	}
	/**
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} percent
	 * @return {number}
	 */
	
	
	function interpolateNumber(p0, p1, percent) {
	  return (p1 - p0) * percent + p0;
	}
	/**
	 * @param  {string} p0
	 * @param  {string} p1
	 * @param  {number} percent
	 * @return {string}
	 */
	
	
	function interpolateString(p0, p1, percent) {
	  return percent > 0.5 ? p1 : p0;
	}
	/**
	 * @param  {Array} p0
	 * @param  {Array} p1
	 * @param  {number} percent
	 * @param  {Array} out
	 * @param  {number} arrDim
	 */
	
	
	function interpolateArray(p0, p1, percent, out, arrDim) {
	  var len = p0.length;
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      out[i] = interpolateNumber(p0[i], p1[i], percent);
	    }
	  } else {
	    var len2 = len && p0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
	      }
	    }
	  }
	} // arr0 is source array, arr1 is target array.
	// Do some preprocess to avoid error happened when interpolating from arr0 to arr1
	
	
	function fillArr(arr0, arr1, arrDim) {
	  var arr0Len = arr0.length;
	  var arr1Len = arr1.length;
	
	  if (arr0Len !== arr1Len) {
	    // FIXME Not work for TypedArray
	    var isPreviousLarger = arr0Len > arr1Len;
	
	    if (isPreviousLarger) {
	      // Cut the previous
	      arr0.length = arr1Len;
	    } else {
	      // Fill the previous
	      for (var i = arr0Len; i < arr1Len; i++) {
	        arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
	      }
	    }
	  } // Handling NaN value
	
	
	  var len2 = arr0[0] && arr0[0].length;
	
	  for (var i = 0; i < arr0.length; i++) {
	    if (arrDim === 1) {
	      if (isNaN(arr0[i])) {
	        arr0[i] = arr1[i];
	      }
	    } else {
	      for (var j = 0; j < len2; j++) {
	        if (isNaN(arr0[i][j])) {
	          arr0[i][j] = arr1[i][j];
	        }
	      }
	    }
	  }
	}
	/**
	 * @param  {Array} arr0
	 * @param  {Array} arr1
	 * @param  {number} arrDim
	 * @return {boolean}
	 */
	
	
	function isArraySame(arr0, arr1, arrDim) {
	  if (arr0 === arr1) {
	    return true;
	  }
	
	  var len = arr0.length;
	
	  if (len !== arr1.length) {
	    return false;
	  }
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      if (arr0[i] !== arr1[i]) {
	        return false;
	      }
	    }
	  } else {
	    var len2 = arr0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        if (arr0[i][j] !== arr1[i][j]) {
	          return false;
	        }
	      }
	    }
	  }
	
	  return true;
	}
	/**
	 * Catmull Rom interpolate array
	 * @param  {Array} p0
	 * @param  {Array} p1
	 * @param  {Array} p2
	 * @param  {Array} p3
	 * @param  {number} t
	 * @param  {number} t2
	 * @param  {number} t3
	 * @param  {Array} out
	 * @param  {number} arrDim
	 */
	
	
	function catmullRomInterpolateArray(p0, p1, p2, p3, t, t2, t3, out, arrDim) {
	  var len = p0.length;
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      out[i] = catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
	    }
	  } else {
	    var len2 = p0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        out[i][j] = catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
	      }
	    }
	  }
	}
	/**
	 * Catmull Rom interpolate number
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @param  {number} t2
	 * @param  {number} t3
	 * @return {number}
	 */
	
	
	function catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
	  var v0 = (p2 - p0) * 0.5;
	  var v1 = (p3 - p1) * 0.5;
	  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
	}
	
	function cloneValue(value) {
	  if (isArrayLike(value)) {
	    var len = value.length;
	
	    if (isArrayLike(value[0])) {
	      var ret = [];
	
	      for (var i = 0; i < len; i++) {
	        ret.push(arraySlice.call(value[i]));
	      }
	
	      return ret;
	    }
	
	    return arraySlice.call(value);
	  }
	
	  return value;
	}
	
	function rgba2String(rgba) {
	  rgba[0] = Math.floor(rgba[0]);
	  rgba[1] = Math.floor(rgba[1]);
	  rgba[2] = Math.floor(rgba[2]);
	  return 'rgba(' + rgba.join(',') + ')';
	}
	
	function getArrayDim(keyframes) {
	  var lastValue = keyframes[keyframes.length - 1].value;
	  return isArrayLike(lastValue && lastValue[0]) ? 2 : 1;
	}
	
	function createTrackClip(animator, easing, oneTrackDone, keyframes, propName, forceAnimate) {
	  var getter = animator._getter;
	  var setter = animator._setter;
	  var useSpline = easing === 'spline';
	  var trackLen = keyframes.length;
	
	  if (!trackLen) {
	    return;
	  } // Guess data type
	
	
	  var firstVal = keyframes[0].value;
	  var isValueArray = isArrayLike(firstVal);
	  var isValueColor = false;
	  var isValueString = false; // For vertices morphing
	
	  var arrDim = isValueArray ? getArrayDim(keyframes) : 0;
	  var trackMaxTime; // Sort keyframe as ascending
	
	  keyframes.sort(function (a, b) {
	    return a.time - b.time;
	  });
	  trackMaxTime = keyframes[trackLen - 1].time; // Percents of each keyframe
	
	  var kfPercents = []; // Value of each keyframe
	
	  var kfValues = [];
	  var prevValue = keyframes[0].value;
	  var isAllValueEqual = true;
	
	  for (var i = 0; i < trackLen; i++) {
	    kfPercents.push(keyframes[i].time / trackMaxTime); // Assume value is a color when it is a string
	
	    var value = keyframes[i].value; // Check if value is equal, deep check if value is array
	
	    if (!(isValueArray && isArraySame(value, prevValue, arrDim) || !isValueArray && value === prevValue)) {
	      isAllValueEqual = false;
	    }
	
	    prevValue = value; // Try converting a string to a color array
	
	    if (typeof value === 'string') {
	      var colorArray = color.parse(value);
	
	      if (colorArray) {
	        value = colorArray;
	        isValueColor = true;
	      } else {
	        isValueString = true;
	      }
	    }
	
	    kfValues.push(value);
	  }
	
	  if (!forceAnimate && isAllValueEqual) {
	    return;
	  }
	
	  var lastValue = kfValues[trackLen - 1]; // Polyfill array and NaN value
	
	  for (var i = 0; i < trackLen - 1; i++) {
	    if (isValueArray) {
	      fillArr(kfValues[i], lastValue, arrDim);
	    } else {
	      if (isNaN(kfValues[i]) && !isNaN(lastValue) && !isValueString && !isValueColor) {
	        kfValues[i] = lastValue;
	      }
	    }
	  }
	
	  isValueArray && fillArr(getter(animator._target, propName), lastValue, arrDim); // Cache the key of last frame to speed up when
	  // animation playback is sequency
	
	  var lastFrame = 0;
	  var lastFramePercent = 0;
	  var start;
	  var w;
	  var p0;
	  var p1;
	  var p2;
	  var p3;
	
	  if (isValueColor) {
	    var rgba = [0, 0, 0, 0];
	  }
	
	  var onframe = function (target, percent) {
	    // Find the range keyframes
	    // kf1-----kf2---------current--------kf3
	    // find kf2 and kf3 and do interpolation
	    var frame; // In the easing function like elasticOut, percent may less than 0
	
	    if (percent < 0) {
	      frame = 0;
	    } else if (percent < lastFramePercent) {
	      // Start from next key
	      // PENDING start from lastFrame ?
	      start = Math.min(lastFrame + 1, trackLen - 1);
	
	      for (frame = start; frame >= 0; frame--) {
	        if (kfPercents[frame] <= percent) {
	          break;
	        }
	      } // PENDING really need to do this ?
	
	
	      frame = Math.min(frame, trackLen - 2);
	    } else {
	      for (frame = lastFrame; frame < trackLen; frame++) {
	        if (kfPercents[frame] > percent) {
	          break;
	        }
	      }
	
	      frame = Math.min(frame - 1, trackLen - 2);
	    }
	
	    lastFrame = frame;
	    lastFramePercent = percent;
	    var range = kfPercents[frame + 1] - kfPercents[frame];
	
	    if (range === 0) {
	      return;
	    } else {
	      w = (percent - kfPercents[frame]) / range;
	    }
	
	    if (useSpline) {
	      p1 = kfValues[frame];
	      p0 = kfValues[frame === 0 ? frame : frame - 1];
	      p2 = kfValues[frame > trackLen - 2 ? trackLen - 1 : frame + 1];
	      p3 = kfValues[frame > trackLen - 3 ? trackLen - 1 : frame + 2];
	
	      if (isValueArray) {
	        catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, getter(target, propName), arrDim);
	      } else {
	        var value;
	
	        if (isValueColor) {
	          value = catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, rgba, 1);
	          value = rgba2String(rgba);
	        } else if (isValueString) {
	          // String is step(0.5)
	          return interpolateString(p1, p2, w);
	        } else {
	          value = catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
	        }
	
	        setter(target, propName, value);
	      }
	    } else {
	      if (isValueArray) {
	        interpolateArray(kfValues[frame], kfValues[frame + 1], w, getter(target, propName), arrDim);
	      } else {
	        var value;
	
	        if (isValueColor) {
	          interpolateArray(kfValues[frame], kfValues[frame + 1], w, rgba, 1);
	          value = rgba2String(rgba);
	        } else if (isValueString) {
	          // String is step(0.5)
	          return interpolateString(kfValues[frame], kfValues[frame + 1], w);
	        } else {
	          value = interpolateNumber(kfValues[frame], kfValues[frame + 1], w);
	        }
	
	        setter(target, propName, value);
	      }
	    }
	  };
	
	  var clip = new Clip({
	    target: animator._target,
	    life: trackMaxTime,
	    loop: animator._loop,
	    delay: animator._delay,
	    onframe: onframe,
	    ondestroy: oneTrackDone
	  });
	
	  if (easing && easing !== 'spline') {
	    clip.easing = easing;
	  }
	
	  return clip;
	}
	/**
	 * @alias module:zrender/animation/Animator
	 * @constructor
	 * @param {Object} target
	 * @param {boolean} loop
	 * @param {Function} getter
	 * @param {Function} setter
	 */
	
	
	var Animator = function (target, loop, getter, setter) {
	  this._tracks = {};
	  this._target = target;
	  this._loop = loop || false;
	  this._getter = getter || defaultGetter;
	  this._setter = setter || defaultSetter;
	  this._clipCount = 0;
	  this._delay = 0;
	  this._doneList = [];
	  this._onframeList = [];
	  this._clipList = [];
	};
	
	Animator.prototype = {
	  /**
	   * Set Animation keyframe
	   * @param  {number} time 关键帧时间，单位是ms
	   * @param  {Object} props 关键帧的属性值，key-value表示
	   * @return {module:zrender/animation/Animator}
	   */
	  when: function (time
	  /* ms */
	  , props) {
	    var tracks = this._tracks;
	
	    for (var propName in props) {
	      if (!props.hasOwnProperty(propName)) {
	        continue;
	      }
	
	      if (!tracks[propName]) {
	        tracks[propName] = []; // Invalid value
	
	        var value = this._getter(this._target, propName);
	
	        if (value == null) {
	          // zrLog('Invalid property ' + propName);
	          continue;
	        } // If time is 0
	        //  Then props is given initialize value
	        // Else
	        //  Initialize value from current prop value
	
	
	        if (time !== 0) {
	          tracks[propName].push({
	            time: 0,
	            value: cloneValue(value)
	          });
	        }
	      }
	
	      tracks[propName].push({
	        time: time,
	        value: props[propName]
	      });
	    }
	
	    return this;
	  },
	
	  /**
	   * 添加动画每一帧的回调函数
	   * @param  {Function} callback
	   * @return {module:zrender/animation/Animator}
	   */
	  during: function (callback) {
	    this._onframeList.push(callback);
	
	    return this;
	  },
	  pause: function () {
	    for (var i = 0; i < this._clipList.length; i++) {
	      this._clipList[i].pause();
	    }
	
	    this._paused = true;
	  },
	  resume: function () {
	    for (var i = 0; i < this._clipList.length; i++) {
	      this._clipList[i].resume();
	    }
	
	    this._paused = false;
	  },
	  isPaused: function () {
	    return !!this._paused;
	  },
	  _doneCallback: function () {
	    // Clear all tracks
	    this._tracks = {}; // Clear all clips
	
	    this._clipList.length = 0;
	    var doneList = this._doneList;
	    var len = doneList.length;
	
	    for (var i = 0; i < len; i++) {
	      doneList[i].call(this);
	    }
	  },
	
	  /**
	   * Start the animation
	   * @param  {string|Function} [easing]
	   *         动画缓动函数，详见{@link module:zrender/animation/easing}
	   * @param  {boolean} forceAnimate
	   * @return {module:zrender/animation/Animator}
	   */
	  start: function (easing, forceAnimate) {
	    var self = this;
	    var clipCount = 0;
	
	    var oneTrackDone = function () {
	      clipCount--;
	
	      if (!clipCount) {
	        self._doneCallback();
	      }
	    };
	
	    var lastClip;
	
	    for (var propName in this._tracks) {
	      if (!this._tracks.hasOwnProperty(propName)) {
	        continue;
	      }
	
	      var clip = createTrackClip(this, easing, oneTrackDone, this._tracks[propName], propName, forceAnimate);
	
	      if (clip) {
	        this._clipList.push(clip);
	
	        clipCount++; // If start after added to animation
	
	        if (this.animation) {
	          this.animation.addClip(clip);
	        }
	
	        lastClip = clip;
	      }
	    } // Add during callback on the last clip
	
	
	    if (lastClip) {
	      var oldOnFrame = lastClip.onframe;
	
	      lastClip.onframe = function (target, percent) {
	        oldOnFrame(target, percent);
	
	        for (var i = 0; i < self._onframeList.length; i++) {
	          self._onframeList[i](target, percent);
	        }
	      };
	    } // This optimization will help the case that in the upper application
	    // the view may be refreshed frequently, where animation will be
	    // called repeatly but nothing changed.
	
	
	    if (!clipCount) {
	      this._doneCallback();
	    }
	
	    return this;
	  },
	
	  /**
	   * Stop animation
	   * @param {boolean} forwardToLast If move to last frame before stop
	   */
	  stop: function (forwardToLast) {
	    var clipList = this._clipList;
	    var animation = this.animation;
	
	    for (var i = 0; i < clipList.length; i++) {
	      var clip = clipList[i];
	
	      if (forwardToLast) {
	        // Move to last frame before stop
	        clip.onframe(this._target, 1);
	      }
	
	      animation && animation.removeClip(clip);
	    }
	
	    clipList.length = 0;
	  },
	
	  /**
	   * Set when animation delay starts
	   * @param  {number} time 单位ms
	   * @return {module:zrender/animation/Animator}
	   */
	  delay: function (time) {
	    this._delay = time;
	    return this;
	  },
	
	  /**
	   * Add callback for animation end
	   * @param  {Function} cb
	   * @return {module:zrender/animation/Animator}
	   */
	  done: function (cb) {
	    if (cb) {
	      this._doneList.push(cb);
	    }
	
	    return this;
	  },
	
	  /**
	   * @return {Array.<module:zrender/animation/Clip>}
	   */
	  getClips: function () {
	    return this._clipList;
	  }
	};
	var _default = Animator;
	module.exports = _default;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var easingFuncs = __webpack_require__(237);
	
	/**
	 * 动画主控制器
	 * @config target 动画对象，可以是数组，如果是数组的话会批量分发onframe等事件
	 * @config life(1000) 动画时长
	 * @config delay(0) 动画延迟时间
	 * @config loop(true)
	 * @config gap(0) 循环的间隔时间
	 * @config onframe
	 * @config easing(optional)
	 * @config ondestroy(optional)
	 * @config onrestart(optional)
	 *
	 * TODO pause
	 */
	function Clip(options) {
	  this._target = options.target; // 生命周期
	
	  this._life = options.life || 1000; // 延时
	
	  this._delay = options.delay || 0; // 开始时间
	  // this._startTime = new Date().getTime() + this._delay;// 单位毫秒
	
	  this._initialized = false; // 是否循环
	
	  this.loop = options.loop == null ? false : options.loop;
	  this.gap = options.gap || 0;
	  this.easing = options.easing || 'Linear';
	  this.onframe = options.onframe;
	  this.ondestroy = options.ondestroy;
	  this.onrestart = options.onrestart;
	  this._pausedTime = 0;
	  this._paused = false;
	}
	
	Clip.prototype = {
	  constructor: Clip,
	  step: function (globalTime, deltaTime) {
	    // Set startTime on first step, or _startTime may has milleseconds different between clips
	    // PENDING
	    if (!this._initialized) {
	      this._startTime = globalTime + this._delay;
	      this._initialized = true;
	    }
	
	    if (this._paused) {
	      this._pausedTime += deltaTime;
	      return;
	    }
	
	    var percent = (globalTime - this._startTime - this._pausedTime) / this._life; // 还没开始
	
	    if (percent < 0) {
	      return;
	    }
	
	    percent = Math.min(percent, 1);
	    var easing = this.easing;
	    var easingFunc = typeof easing === 'string' ? easingFuncs[easing] : easing;
	    var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
	    this.fire('frame', schedule); // 结束
	
	    if (percent === 1) {
	      if (this.loop) {
	        this.restart(globalTime); // 重新开始周期
	        // 抛出而不是直接调用事件直到 stage.update 后再统一调用这些事件
	
	        return 'restart';
	      } // 动画完成将这个控制器标识为待删除
	      // 在Animation.update中进行批量删除
	
	
	      this._needsRemove = true;
	      return 'destroy';
	    }
	
	    return null;
	  },
	  restart: function (globalTime) {
	    var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
	    this._startTime = globalTime - remainder + this.gap;
	    this._pausedTime = 0;
	    this._needsRemove = false;
	  },
	  fire: function (eventType, arg) {
	    eventType = 'on' + eventType;
	
	    if (this[eventType]) {
	      this[eventType](this._target, arg);
	    }
	  },
	  pause: function () {
	    this._paused = true;
	  },
	  resume: function () {
	    this._paused = false;
	  }
	};
	var _default = Clip;
	module.exports = _default;

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	/**
	 * 缓动代码来自 https://github.com/sole/tween.js/blob/master/src/Tween.js
	 * @see http://sole.github.io/tween.js/examples/03_graphs.html
	 * @exports zrender/animation/easing
	 */
	var easing = {
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  linear: function (k) {
	    return k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticIn: function (k) {
	    return k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticOut: function (k) {
	    return k * (2 - k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k;
	    }
	
	    return -0.5 * (--k * (k - 2) - 1);
	  },
	  // 三次方的缓动（t^3）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicIn: function (k) {
	    return k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicOut: function (k) {
	    return --k * k * k + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k;
	    }
	
	    return 0.5 * ((k -= 2) * k * k + 2);
	  },
	  // 四次方的缓动（t^4）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticIn: function (k) {
	    return k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticOut: function (k) {
	    return 1 - --k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k * k;
	    }
	
	    return -0.5 * ((k -= 2) * k * k * k - 2);
	  },
	  // 五次方的缓动（t^5）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticIn: function (k) {
	    return k * k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticOut: function (k) {
	    return --k * k * k * k * k + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k * k * k;
	    }
	
	    return 0.5 * ((k -= 2) * k * k * k * k + 2);
	  },
	  // 正弦曲线的缓动（sin(t)）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalIn: function (k) {
	    return 1 - Math.cos(k * Math.PI / 2);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalOut: function (k) {
	    return Math.sin(k * Math.PI / 2);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalInOut: function (k) {
	    return 0.5 * (1 - Math.cos(Math.PI * k));
	  },
	  // 指数曲线的缓动（2^t）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialIn: function (k) {
	    return k === 0 ? 0 : Math.pow(1024, k - 1);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialOut: function (k) {
	    return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialInOut: function (k) {
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if ((k *= 2) < 1) {
	      return 0.5 * Math.pow(1024, k - 1);
	    }
	
	    return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
	  },
	  // 圆形曲线的缓动（sqrt(1-t^2)）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularIn: function (k) {
	    return 1 - Math.sqrt(1 - k * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularOut: function (k) {
	    return Math.sqrt(1 - --k * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return -0.5 * (Math.sqrt(1 - k * k) - 1);
	    }
	
	    return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
	  },
	  // 创建类似于弹簧在停止前来回振荡的动画
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticIn: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticOut: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticInOut: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    if ((k *= 2) < 1) {
	      return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
	    }
	
	    return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
	  },
	  // 在某一动画开始沿指示的路径进行动画处理前稍稍收回该动画的移动
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backIn: function (k) {
	    var s = 1.70158;
	    return k * k * ((s + 1) * k - s);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backOut: function (k) {
	    var s = 1.70158;
	    return --k * k * ((s + 1) * k + s) + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backInOut: function (k) {
	    var s = 1.70158 * 1.525;
	
	    if ((k *= 2) < 1) {
	      return 0.5 * (k * k * ((s + 1) * k - s));
	    }
	
	    return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
	  },
	  // 创建弹跳效果
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceIn: function (k) {
	    return 1 - easing.bounceOut(1 - k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceOut: function (k) {
	    if (k < 1 / 2.75) {
	      return 7.5625 * k * k;
	    } else if (k < 2 / 2.75) {
	      return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
	    } else if (k < 2.5 / 2.75) {
	      return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
	    } else {
	      return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
	    }
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceInOut: function (k) {
	    if (k < 0.5) {
	      return easing.bounceIn(k * 2) * 0.5;
	    }
	
	    return easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
	  }
	};
	var _default = easing;
	module.exports = _default;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	var LRU = __webpack_require__(239);
	
	var kCSSColorTable = {
	  'transparent': [0, 0, 0, 0],
	  'aliceblue': [240, 248, 255, 1],
	  'antiquewhite': [250, 235, 215, 1],
	  'aqua': [0, 255, 255, 1],
	  'aquamarine': [127, 255, 212, 1],
	  'azure': [240, 255, 255, 1],
	  'beige': [245, 245, 220, 1],
	  'bisque': [255, 228, 196, 1],
	  'black': [0, 0, 0, 1],
	  'blanchedalmond': [255, 235, 205, 1],
	  'blue': [0, 0, 255, 1],
	  'blueviolet': [138, 43, 226, 1],
	  'brown': [165, 42, 42, 1],
	  'burlywood': [222, 184, 135, 1],
	  'cadetblue': [95, 158, 160, 1],
	  'chartreuse': [127, 255, 0, 1],
	  'chocolate': [210, 105, 30, 1],
	  'coral': [255, 127, 80, 1],
	  'cornflowerblue': [100, 149, 237, 1],
	  'cornsilk': [255, 248, 220, 1],
	  'crimson': [220, 20, 60, 1],
	  'cyan': [0, 255, 255, 1],
	  'darkblue': [0, 0, 139, 1],
	  'darkcyan': [0, 139, 139, 1],
	  'darkgoldenrod': [184, 134, 11, 1],
	  'darkgray': [169, 169, 169, 1],
	  'darkgreen': [0, 100, 0, 1],
	  'darkgrey': [169, 169, 169, 1],
	  'darkkhaki': [189, 183, 107, 1],
	  'darkmagenta': [139, 0, 139, 1],
	  'darkolivegreen': [85, 107, 47, 1],
	  'darkorange': [255, 140, 0, 1],
	  'darkorchid': [153, 50, 204, 1],
	  'darkred': [139, 0, 0, 1],
	  'darksalmon': [233, 150, 122, 1],
	  'darkseagreen': [143, 188, 143, 1],
	  'darkslateblue': [72, 61, 139, 1],
	  'darkslategray': [47, 79, 79, 1],
	  'darkslategrey': [47, 79, 79, 1],
	  'darkturquoise': [0, 206, 209, 1],
	  'darkviolet': [148, 0, 211, 1],
	  'deeppink': [255, 20, 147, 1],
	  'deepskyblue': [0, 191, 255, 1],
	  'dimgray': [105, 105, 105, 1],
	  'dimgrey': [105, 105, 105, 1],
	  'dodgerblue': [30, 144, 255, 1],
	  'firebrick': [178, 34, 34, 1],
	  'floralwhite': [255, 250, 240, 1],
	  'forestgreen': [34, 139, 34, 1],
	  'fuchsia': [255, 0, 255, 1],
	  'gainsboro': [220, 220, 220, 1],
	  'ghostwhite': [248, 248, 255, 1],
	  'gold': [255, 215, 0, 1],
	  'goldenrod': [218, 165, 32, 1],
	  'gray': [128, 128, 128, 1],
	  'green': [0, 128, 0, 1],
	  'greenyellow': [173, 255, 47, 1],
	  'grey': [128, 128, 128, 1],
	  'honeydew': [240, 255, 240, 1],
	  'hotpink': [255, 105, 180, 1],
	  'indianred': [205, 92, 92, 1],
	  'indigo': [75, 0, 130, 1],
	  'ivory': [255, 255, 240, 1],
	  'khaki': [240, 230, 140, 1],
	  'lavender': [230, 230, 250, 1],
	  'lavenderblush': [255, 240, 245, 1],
	  'lawngreen': [124, 252, 0, 1],
	  'lemonchiffon': [255, 250, 205, 1],
	  'lightblue': [173, 216, 230, 1],
	  'lightcoral': [240, 128, 128, 1],
	  'lightcyan': [224, 255, 255, 1],
	  'lightgoldenrodyellow': [250, 250, 210, 1],
	  'lightgray': [211, 211, 211, 1],
	  'lightgreen': [144, 238, 144, 1],
	  'lightgrey': [211, 211, 211, 1],
	  'lightpink': [255, 182, 193, 1],
	  'lightsalmon': [255, 160, 122, 1],
	  'lightseagreen': [32, 178, 170, 1],
	  'lightskyblue': [135, 206, 250, 1],
	  'lightslategray': [119, 136, 153, 1],
	  'lightslategrey': [119, 136, 153, 1],
	  'lightsteelblue': [176, 196, 222, 1],
	  'lightyellow': [255, 255, 224, 1],
	  'lime': [0, 255, 0, 1],
	  'limegreen': [50, 205, 50, 1],
	  'linen': [250, 240, 230, 1],
	  'magenta': [255, 0, 255, 1],
	  'maroon': [128, 0, 0, 1],
	  'mediumaquamarine': [102, 205, 170, 1],
	  'mediumblue': [0, 0, 205, 1],
	  'mediumorchid': [186, 85, 211, 1],
	  'mediumpurple': [147, 112, 219, 1],
	  'mediumseagreen': [60, 179, 113, 1],
	  'mediumslateblue': [123, 104, 238, 1],
	  'mediumspringgreen': [0, 250, 154, 1],
	  'mediumturquoise': [72, 209, 204, 1],
	  'mediumvioletred': [199, 21, 133, 1],
	  'midnightblue': [25, 25, 112, 1],
	  'mintcream': [245, 255, 250, 1],
	  'mistyrose': [255, 228, 225, 1],
	  'moccasin': [255, 228, 181, 1],
	  'navajowhite': [255, 222, 173, 1],
	  'navy': [0, 0, 128, 1],
	  'oldlace': [253, 245, 230, 1],
	  'olive': [128, 128, 0, 1],
	  'olivedrab': [107, 142, 35, 1],
	  'orange': [255, 165, 0, 1],
	  'orangered': [255, 69, 0, 1],
	  'orchid': [218, 112, 214, 1],
	  'palegoldenrod': [238, 232, 170, 1],
	  'palegreen': [152, 251, 152, 1],
	  'paleturquoise': [175, 238, 238, 1],
	  'palevioletred': [219, 112, 147, 1],
	  'papayawhip': [255, 239, 213, 1],
	  'peachpuff': [255, 218, 185, 1],
	  'peru': [205, 133, 63, 1],
	  'pink': [255, 192, 203, 1],
	  'plum': [221, 160, 221, 1],
	  'powderblue': [176, 224, 230, 1],
	  'purple': [128, 0, 128, 1],
	  'red': [255, 0, 0, 1],
	  'rosybrown': [188, 143, 143, 1],
	  'royalblue': [65, 105, 225, 1],
	  'saddlebrown': [139, 69, 19, 1],
	  'salmon': [250, 128, 114, 1],
	  'sandybrown': [244, 164, 96, 1],
	  'seagreen': [46, 139, 87, 1],
	  'seashell': [255, 245, 238, 1],
	  'sienna': [160, 82, 45, 1],
	  'silver': [192, 192, 192, 1],
	  'skyblue': [135, 206, 235, 1],
	  'slateblue': [106, 90, 205, 1],
	  'slategray': [112, 128, 144, 1],
	  'slategrey': [112, 128, 144, 1],
	  'snow': [255, 250, 250, 1],
	  'springgreen': [0, 255, 127, 1],
	  'steelblue': [70, 130, 180, 1],
	  'tan': [210, 180, 140, 1],
	  'teal': [0, 128, 128, 1],
	  'thistle': [216, 191, 216, 1],
	  'tomato': [255, 99, 71, 1],
	  'turquoise': [64, 224, 208, 1],
	  'violet': [238, 130, 238, 1],
	  'wheat': [245, 222, 179, 1],
	  'white': [255, 255, 255, 1],
	  'whitesmoke': [245, 245, 245, 1],
	  'yellow': [255, 255, 0, 1],
	  'yellowgreen': [154, 205, 50, 1]
	};
	
	function clampCssByte(i) {
	  // Clamp to integer 0 .. 255.
	  i = Math.round(i); // Seems to be what Chrome does (vs truncation).
	
	  return i < 0 ? 0 : i > 255 ? 255 : i;
	}
	
	function clampCssAngle(i) {
	  // Clamp to integer 0 .. 360.
	  i = Math.round(i); // Seems to be what Chrome does (vs truncation).
	
	  return i < 0 ? 0 : i > 360 ? 360 : i;
	}
	
	function clampCssFloat(f) {
	  // Clamp to float 0.0 .. 1.0.
	  return f < 0 ? 0 : f > 1 ? 1 : f;
	}
	
	function parseCssInt(str) {
	  // int or percentage.
	  if (str.length && str.charAt(str.length - 1) === '%') {
	    return clampCssByte(parseFloat(str) / 100 * 255);
	  }
	
	  return clampCssByte(parseInt(str, 10));
	}
	
	function parseCssFloat(str) {
	  // float or percentage.
	  if (str.length && str.charAt(str.length - 1) === '%') {
	    return clampCssFloat(parseFloat(str) / 100);
	  }
	
	  return clampCssFloat(parseFloat(str));
	}
	
	function cssHueToRgb(m1, m2, h) {
	  if (h < 0) {
	    h += 1;
	  } else if (h > 1) {
	    h -= 1;
	  }
	
	  if (h * 6 < 1) {
	    return m1 + (m2 - m1) * h * 6;
	  }
	
	  if (h * 2 < 1) {
	    return m2;
	  }
	
	  if (h * 3 < 2) {
	    return m1 + (m2 - m1) * (2 / 3 - h) * 6;
	  }
	
	  return m1;
	}
	
	function lerpNumber(a, b, p) {
	  return a + (b - a) * p;
	}
	
	function setRgba(out, r, g, b, a) {
	  out[0] = r;
	  out[1] = g;
	  out[2] = b;
	  out[3] = a;
	  return out;
	}
	
	function copyRgba(out, a) {
	  out[0] = a[0];
	  out[1] = a[1];
	  out[2] = a[2];
	  out[3] = a[3];
	  return out;
	}
	
	var colorCache = new LRU(20);
	var lastRemovedArr = null;
	
	function putToCache(colorStr, rgbaArr) {
	  // Reuse removed array
	  if (lastRemovedArr) {
	    copyRgba(lastRemovedArr, rgbaArr);
	  }
	
	  lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || rgbaArr.slice());
	}
	/**
	 * @param {string} colorStr
	 * @param {Array.<number>} out
	 * @return {Array.<number>}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function parse(colorStr, rgbaArr) {
	  if (!colorStr) {
	    return;
	  }
	
	  rgbaArr = rgbaArr || [];
	  var cached = colorCache.get(colorStr);
	
	  if (cached) {
	    return copyRgba(rgbaArr, cached);
	  } // colorStr may be not string
	
	
	  colorStr = colorStr + ''; // Remove all whitespace, not compliant, but should just be more accepting.
	
	  var str = colorStr.replace(/ /g, '').toLowerCase(); // Color keywords (and transparent) lookup.
	
	  if (str in kCSSColorTable) {
	    copyRgba(rgbaArr, kCSSColorTable[str]);
	    putToCache(colorStr, rgbaArr);
	    return rgbaArr;
	  } // #abc and #abc123 syntax.
	
	
	  if (str.charAt(0) === '#') {
	    if (str.length === 4) {
	      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
	
	      if (!(iv >= 0 && iv <= 0xfff)) {
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return; // Covers NaN.
	      }
	
	      setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, 1);
	      putToCache(colorStr, rgbaArr);
	      return rgbaArr;
	    } else if (str.length === 7) {
	      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
	
	      if (!(iv >= 0 && iv <= 0xffffff)) {
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return; // Covers NaN.
	      }
	
	      setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, 1);
	      putToCache(colorStr, rgbaArr);
	      return rgbaArr;
	    }
	
	    return;
	  }
	
	  var op = str.indexOf('(');
	  var ep = str.indexOf(')');
	
	  if (op !== -1 && ep + 1 === str.length) {
	    var fname = str.substr(0, op);
	    var params = str.substr(op + 1, ep - (op + 1)).split(',');
	    var alpha = 1; // To allow case fallthrough.
	
	    switch (fname) {
	      case 'rgba':
	        if (params.length !== 4) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        alpha = parseCssFloat(params.pop());
	      // jshint ignore:line
	      // Fall through.
	
	      case 'rgb':
	        if (params.length !== 3) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), alpha);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      case 'hsla':
	        if (params.length !== 4) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        params[3] = parseCssFloat(params[3]);
	        hsla2rgba(params, rgbaArr);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      case 'hsl':
	        if (params.length !== 3) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        hsla2rgba(params, rgbaArr);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      default:
	        return;
	    }
	  }
	
	  setRgba(rgbaArr, 0, 0, 0, 1);
	  return;
	}
	/**
	 * @param {Array.<number>} hsla
	 * @param {Array.<number>} rgba
	 * @return {Array.<number>} rgba
	 */
	
	
	function hsla2rgba(hsla, rgba) {
	  var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360; // 0 .. 1
	  // NOTE(deanm): According to the CSS spec s/l should only be
	  // percentages, but we don't bother and let float or percentage.
	
	  var s = parseCssFloat(hsla[1]);
	  var l = parseCssFloat(hsla[2]);
	  var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
	  var m1 = l * 2 - m2;
	  rgba = rgba || [];
	  setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
	
	  if (hsla.length === 4) {
	    rgba[3] = hsla[3];
	  }
	
	  return rgba;
	}
	/**
	 * @param {Array.<number>} rgba
	 * @return {Array.<number>} hsla
	 */
	
	
	function rgba2hsla(rgba) {
	  if (!rgba) {
	    return;
	  } // RGB from 0 to 255
	
	
	  var R = rgba[0] / 255;
	  var G = rgba[1] / 255;
	  var B = rgba[2] / 255;
	  var vMin = Math.min(R, G, B); // Min. value of RGB
	
	  var vMax = Math.max(R, G, B); // Max. value of RGB
	
	  var delta = vMax - vMin; // Delta RGB value
	
	  var L = (vMax + vMin) / 2;
	  var H;
	  var S; // HSL results from 0 to 1
	
	  if (delta === 0) {
	    H = 0;
	    S = 0;
	  } else {
	    if (L < 0.5) {
	      S = delta / (vMax + vMin);
	    } else {
	      S = delta / (2 - vMax - vMin);
	    }
	
	    var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
	    var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
	    var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
	
	    if (R === vMax) {
	      H = deltaB - deltaG;
	    } else if (G === vMax) {
	      H = 1 / 3 + deltaR - deltaB;
	    } else if (B === vMax) {
	      H = 2 / 3 + deltaG - deltaR;
	    }
	
	    if (H < 0) {
	      H += 1;
	    }
	
	    if (H > 1) {
	      H -= 1;
	    }
	  }
	
	  var hsla = [H * 360, S, L];
	
	  if (rgba[3] != null) {
	    hsla.push(rgba[3]);
	  }
	
	  return hsla;
	}
	/**
	 * @param {string} color
	 * @param {number} level
	 * @return {string}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function lift(color, level) {
	  var colorArr = parse(color);
	
	  if (colorArr) {
	    for (var i = 0; i < 3; i++) {
	      if (level < 0) {
	        colorArr[i] = colorArr[i] * (1 - level) | 0;
	      } else {
	        colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
	      }
	
	      if (colorArr[i] > 255) {
	        colorArr[i] = 255;
	      } else if (color[i] < 0) {
	        colorArr[i] = 0;
	      }
	    }
	
	    return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
	  }
	}
	/**
	 * @param {string} color
	 * @return {string}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function toHex(color) {
	  var colorArr = parse(color);
	
	  if (colorArr) {
	    return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
	  }
	}
	/**
	 * Map value to color. Faster than lerp methods because color is represented by rgba array.
	 * @param {number} normalizedValue A float between 0 and 1.
	 * @param {Array.<Array.<number>>} colors List of rgba color array
	 * @param {Array.<number>} [out] Mapped gba color array
	 * @return {Array.<number>} will be null/undefined if input illegal.
	 */
	
	
	function fastLerp(normalizedValue, colors, out) {
	  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	    return;
	  }
	
	  out = out || [];
	  var value = normalizedValue * (colors.length - 1);
	  var leftIndex = Math.floor(value);
	  var rightIndex = Math.ceil(value);
	  var leftColor = colors[leftIndex];
	  var rightColor = colors[rightIndex];
	  var dv = value - leftIndex;
	  out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
	  out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
	  out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
	  out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
	  return out;
	}
	/**
	 * @deprecated
	 */
	
	
	var fastMapToColor = fastLerp;
	/**
	 * @param {number} normalizedValue A float between 0 and 1.
	 * @param {Array.<string>} colors Color list.
	 * @param {boolean=} fullOutput Default false.
	 * @return {(string|Object)} Result color. If fullOutput,
	 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
	 * @memberOf module:zrender/util/color
	 */
	
	function lerp(normalizedValue, colors, fullOutput) {
	  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	    return;
	  }
	
	  var value = normalizedValue * (colors.length - 1);
	  var leftIndex = Math.floor(value);
	  var rightIndex = Math.ceil(value);
	  var leftColor = parse(colors[leftIndex]);
	  var rightColor = parse(colors[rightIndex]);
	  var dv = value - leftIndex;
	  var color = stringify([clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)), clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)), clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)), clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))], 'rgba');
	  return fullOutput ? {
	    color: color,
	    leftIndex: leftIndex,
	    rightIndex: rightIndex,
	    value: value
	  } : color;
	}
	/**
	 * @deprecated
	 */
	
	
	var mapToColor = lerp;
	/**
	 * @param {string} color
	 * @param {number=} h 0 ~ 360, ignore when null.
	 * @param {number=} s 0 ~ 1, ignore when null.
	 * @param {number=} l 0 ~ 1, ignore when null.
	 * @return {string} Color string in rgba format.
	 * @memberOf module:zrender/util/color
	 */
	
	function modifyHSL(color, h, s, l) {
	  color = parse(color);
	
	  if (color) {
	    color = rgba2hsla(color);
	    h != null && (color[0] = clampCssAngle(h));
	    s != null && (color[1] = parseCssFloat(s));
	    l != null && (color[2] = parseCssFloat(l));
	    return stringify(hsla2rgba(color), 'rgba');
	  }
	}
	/**
	 * @param {string} color
	 * @param {number=} alpha 0 ~ 1
	 * @return {string} Color string in rgba format.
	 * @memberOf module:zrender/util/color
	 */
	
	
	function modifyAlpha(color, alpha) {
	  color = parse(color);
	
	  if (color && alpha != null) {
	    color[3] = clampCssFloat(alpha);
	    return stringify(color, 'rgba');
	  }
	}
	/**
	 * @param {Array.<number>} arrColor like [12,33,44,0.4]
	 * @param {string} type 'rgba', 'hsva', ...
	 * @return {string} Result color. (If input illegal, return undefined).
	 */
	
	
	function stringify(arrColor, type) {
	  if (!arrColor || !arrColor.length) {
	    return;
	  }
	
	  var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
	
	  if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
	    colorStr += ',' + arrColor[3];
	  }
	
	  return type + '(' + colorStr + ')';
	}
	
	exports.parse = parse;
	exports.lift = lift;
	exports.toHex = toHex;
	exports.fastLerp = fastLerp;
	exports.fastMapToColor = fastMapToColor;
	exports.lerp = lerp;
	exports.mapToColor = mapToColor;
	exports.modifyHSL = modifyHSL;
	exports.modifyAlpha = modifyAlpha;
	exports.stringify = stringify;

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	// Simple LRU cache use doubly linked list
	// @module zrender/core/LRU
	
	/**
	 * Simple double linked list. Compared with array, it has O(1) remove operation.
	 * @constructor
	 */
	var LinkedList = function () {
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	  this.head = null;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.tail = null;
	  this._len = 0;
	};
	
	var linkedListProto = LinkedList.prototype;
	/**
	 * Insert a new value at the tail
	 * @param  {} val
	 * @return {module:zrender/core/LRU~Entry}
	 */
	
	linkedListProto.insert = function (val) {
	  var entry = new Entry(val);
	  this.insertEntry(entry);
	  return entry;
	};
	/**
	 * Insert an entry at the tail
	 * @param  {module:zrender/core/LRU~Entry} entry
	 */
	
	
	linkedListProto.insertEntry = function (entry) {
	  if (!this.head) {
	    this.head = this.tail = entry;
	  } else {
	    this.tail.next = entry;
	    entry.prev = this.tail;
	    entry.next = null;
	    this.tail = entry;
	  }
	
	  this._len++;
	};
	/**
	 * Remove entry.
	 * @param  {module:zrender/core/LRU~Entry} entry
	 */
	
	
	linkedListProto.remove = function (entry) {
	  var prev = entry.prev;
	  var next = entry.next;
	
	  if (prev) {
	    prev.next = next;
	  } else {
	    // Is head
	    this.head = next;
	  }
	
	  if (next) {
	    next.prev = prev;
	  } else {
	    // Is tail
	    this.tail = prev;
	  }
	
	  entry.next = entry.prev = null;
	  this._len--;
	};
	/**
	 * @return {number}
	 */
	
	
	linkedListProto.len = function () {
	  return this._len;
	};
	/**
	 * Clear list
	 */
	
	
	linkedListProto.clear = function () {
	  this.head = this.tail = null;
	  this._len = 0;
	};
	/**
	 * @constructor
	 * @param {} val
	 */
	
	
	var Entry = function (val) {
	  /**
	   * @type {}
	   */
	  this.value = val;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.next;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.prev;
	};
	/**
	 * LRU Cache
	 * @constructor
	 * @alias module:zrender/core/LRU
	 */
	
	
	var LRU = function (maxSize) {
	  this._list = new LinkedList();
	  this._map = {};
	  this._maxSize = maxSize || 10;
	  this._lastRemovedEntry = null;
	};
	
	var LRUProto = LRU.prototype;
	/**
	 * @param  {string} key
	 * @param  {} value
	 * @return {} Removed value
	 */
	
	LRUProto.put = function (key, value) {
	  var list = this._list;
	  var map = this._map;
	  var removed = null;
	
	  if (map[key] == null) {
	    var len = list.len(); // Reuse last removed entry
	
	    var entry = this._lastRemovedEntry;
	
	    if (len >= this._maxSize && len > 0) {
	      // Remove the least recently used
	      var leastUsedEntry = list.head;
	      list.remove(leastUsedEntry);
	      delete map[leastUsedEntry.key];
	      removed = leastUsedEntry.value;
	      this._lastRemovedEntry = leastUsedEntry;
	    }
	
	    if (entry) {
	      entry.value = value;
	    } else {
	      entry = new Entry(value);
	    }
	
	    entry.key = key;
	    list.insertEntry(entry);
	    map[key] = entry;
	  }
	
	  return removed;
	};
	/**
	 * @param  {string} key
	 * @return {}
	 */
	
	
	LRUProto.get = function (key) {
	  var entry = this._map[key];
	  var list = this._list;
	
	  if (entry != null) {
	    // Put the latest used entry in the tail
	    if (entry !== list.tail) {
	      list.remove(entry);
	      list.insertEntry(entry);
	    }
	
	    return entry.value;
	  }
	};
	/**
	 * Clear the cache
	 */
	
	
	LRUProto.clear = function () {
	  this._list.clear();
	
	  this._map = {};
	};
	
	var _default = LRU;
	module.exports = _default;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(241);
	
	var debugMode = _config.debugMode;
	
	var logError = function () {};
	
	if (debugMode === 1) {
	  logError = console.error;
	}
	
	var _default = logError;
	module.exports = _default;

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	var dpr = 1; // If in browser environment
	
	if (typeof window !== 'undefined') {
	  dpr = Math.max(window.devicePixelRatio || 1, 1);
	}
	/**
	 * config默认配置项
	 * @exports zrender/config
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 */
	
	/**
	 * Debug log mode:
	 * 0: Do nothing, for release.
	 * 1: console.error, for debug.
	 */
	
	
	var debugMode = 0; // retina 屏幕优化
	
	var devicePixelRatio = dpr;
	exports.debugMode = debugMode;
	exports.devicePixelRatio = devicePixelRatio;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(222);
	
	var matrix = __webpack_require__(233);
	
	/**
	 * @module echarts/core/BoundingRect
	 */
	var v2ApplyTransform = vec2.applyTransform;
	var mathMin = Math.min;
	var mathMax = Math.max;
	/**
	 * @alias module:echarts/core/BoundingRect
	 */
	
	function BoundingRect(x, y, width, height) {
	  if (width < 0) {
	    x = x + width;
	    width = -width;
	  }
	
	  if (height < 0) {
	    y = y + height;
	    height = -height;
	  }
	  /**
	   * @type {number}
	   */
	
	
	  this.x = x;
	  /**
	   * @type {number}
	   */
	
	  this.y = y;
	  /**
	   * @type {number}
	   */
	
	  this.width = width;
	  /**
	   * @type {number}
	   */
	
	  this.height = height;
	}
	
	BoundingRect.prototype = {
	  constructor: BoundingRect,
	
	  /**
	   * @param {module:echarts/core/BoundingRect} other
	   */
	  union: function (other) {
	    var x = mathMin(other.x, this.x);
	    var y = mathMin(other.y, this.y);
	    this.width = mathMax(other.x + other.width, this.x + this.width) - x;
	    this.height = mathMax(other.y + other.height, this.y + this.height) - y;
	    this.x = x;
	    this.y = y;
	  },
	
	  /**
	   * @param {Array.<number>} m
	   * @methods
	   */
	  applyTransform: function () {
	    var lt = [];
	    var rb = [];
	    var lb = [];
	    var rt = [];
	    return function (m) {
	      // In case usage like this
	      // el.getBoundingRect().applyTransform(el.transform)
	      // And element has no transform
	      if (!m) {
	        return;
	      }
	
	      lt[0] = lb[0] = this.x;
	      lt[1] = rt[1] = this.y;
	      rb[0] = rt[0] = this.x + this.width;
	      rb[1] = lb[1] = this.y + this.height;
	      v2ApplyTransform(lt, lt, m);
	      v2ApplyTransform(rb, rb, m);
	      v2ApplyTransform(lb, lb, m);
	      v2ApplyTransform(rt, rt, m);
	      this.x = mathMin(lt[0], rb[0], lb[0], rt[0]);
	      this.y = mathMin(lt[1], rb[1], lb[1], rt[1]);
	      var maxX = mathMax(lt[0], rb[0], lb[0], rt[0]);
	      var maxY = mathMax(lt[1], rb[1], lb[1], rt[1]);
	      this.width = maxX - this.x;
	      this.height = maxY - this.y;
	    };
	  }(),
	
	  /**
	   * Calculate matrix of transforming from self to target rect
	   * @param  {module:zrender/core/BoundingRect} b
	   * @return {Array.<number>}
	   */
	  calculateTransform: function (b) {
	    var a = this;
	    var sx = b.width / a.width;
	    var sy = b.height / a.height;
	    var m = matrix.create(); // 矩阵右乘
	
	    matrix.translate(m, m, [-a.x, -a.y]);
	    matrix.scale(m, m, [sx, sy]);
	    matrix.translate(m, m, [b.x, b.y]);
	    return m;
	  },
	
	  /**
	   * @param {(module:echarts/core/BoundingRect|Object)} b
	   * @return {boolean}
	   */
	  intersect: function (b) {
	    if (!b) {
	      return false;
	    }
	
	    if (!(b instanceof BoundingRect)) {
	      // Normalize negative width/height.
	      b = BoundingRect.create(b);
	    }
	
	    var a = this;
	    var ax0 = a.x;
	    var ax1 = a.x + a.width;
	    var ay0 = a.y;
	    var ay1 = a.y + a.height;
	    var bx0 = b.x;
	    var bx1 = b.x + b.width;
	    var by0 = b.y;
	    var by1 = b.y + b.height;
	    return !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
	  },
	  contain: function (x, y) {
	    var rect = this;
	    return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
	  },
	
	  /**
	   * @return {module:echarts/core/BoundingRect}
	   */
	  clone: function () {
	    return new BoundingRect(this.x, this.y, this.width, this.height);
	  },
	
	  /**
	   * Copy from another rect
	   */
	  copy: function (other) {
	    this.x = other.x;
	    this.y = other.y;
	    this.width = other.width;
	    this.height = other.height;
	  },
	  plain: function () {
	    return {
	      x: this.x,
	      y: this.y,
	      width: this.width,
	      height: this.height
	    };
	  }
	};
	/**
	 * @param {Object|module:zrender/core/BoundingRect} rect
	 * @param {number} rect.x
	 * @param {number} rect.y
	 * @param {number} rect.width
	 * @param {number} rect.height
	 * @return {module:zrender/core/BoundingRect}
	 */
	
	BoundingRect.create = function (rect) {
	  return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
	};
	
	var _default = BoundingRect;
	module.exports = _default;

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	// https://github.com/mziccard/node-timsort
	var DEFAULT_MIN_MERGE = 32;
	var DEFAULT_MIN_GALLOPING = 7;
	var DEFAULT_TMP_STORAGE_LENGTH = 256;
	
	function minRunLength(n) {
	  var r = 0;
	
	  while (n >= DEFAULT_MIN_MERGE) {
	    r |= n & 1;
	    n >>= 1;
	  }
	
	  return n + r;
	}
	
	function makeAscendingRun(array, lo, hi, compare) {
	  var runHi = lo + 1;
	
	  if (runHi === hi) {
	    return 1;
	  }
	
	  if (compare(array[runHi++], array[lo]) < 0) {
	    while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
	      runHi++;
	    }
	
	    reverseRun(array, lo, runHi);
	  } else {
	    while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
	      runHi++;
	    }
	  }
	
	  return runHi - lo;
	}
	
	function reverseRun(array, lo, hi) {
	  hi--;
	
	  while (lo < hi) {
	    var t = array[lo];
	    array[lo++] = array[hi];
	    array[hi--] = t;
	  }
	}
	
	function binaryInsertionSort(array, lo, hi, start, compare) {
	  if (start === lo) {
	    start++;
	  }
	
	  for (; start < hi; start++) {
	    var pivot = array[start];
	    var left = lo;
	    var right = start;
	    var mid;
	
	    while (left < right) {
	      mid = left + right >>> 1;
	
	      if (compare(pivot, array[mid]) < 0) {
	        right = mid;
	      } else {
	        left = mid + 1;
	      }
	    }
	
	    var n = start - left;
	
	    switch (n) {
	      case 3:
	        array[left + 3] = array[left + 2];
	
	      case 2:
	        array[left + 2] = array[left + 1];
	
	      case 1:
	        array[left + 1] = array[left];
	        break;
	
	      default:
	        while (n > 0) {
	          array[left + n] = array[left + n - 1];
	          n--;
	        }
	
	    }
	
	    array[left] = pivot;
	  }
	}
	
	function gallopLeft(value, array, start, length, hint, compare) {
	  var lastOffset = 0;
	  var maxOffset = 0;
	  var offset = 1;
	
	  if (compare(value, array[start + hint]) > 0) {
	    maxOffset = length - hint;
	
	    while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    lastOffset += hint;
	    offset += hint;
	  } else {
	    maxOffset = hint + 1;
	
	    while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    var tmp = lastOffset;
	    lastOffset = hint - offset;
	    offset = hint - tmp;
	  }
	
	  lastOffset++;
	
	  while (lastOffset < offset) {
	    var m = lastOffset + (offset - lastOffset >>> 1);
	
	    if (compare(value, array[start + m]) > 0) {
	      lastOffset = m + 1;
	    } else {
	      offset = m;
	    }
	  }
	
	  return offset;
	}
	
	function gallopRight(value, array, start, length, hint, compare) {
	  var lastOffset = 0;
	  var maxOffset = 0;
	  var offset = 1;
	
	  if (compare(value, array[start + hint]) < 0) {
	    maxOffset = hint + 1;
	
	    while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    var tmp = lastOffset;
	    lastOffset = hint - offset;
	    offset = hint - tmp;
	  } else {
	    maxOffset = length - hint;
	
	    while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    lastOffset += hint;
	    offset += hint;
	  }
	
	  lastOffset++;
	
	  while (lastOffset < offset) {
	    var m = lastOffset + (offset - lastOffset >>> 1);
	
	    if (compare(value, array[start + m]) < 0) {
	      offset = m;
	    } else {
	      lastOffset = m + 1;
	    }
	  }
	
	  return offset;
	}
	
	function TimSort(array, compare) {
	  var minGallop = DEFAULT_MIN_GALLOPING;
	  var length = 0;
	  var tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
	  var stackLength = 0;
	  var runStart;
	  var runLength;
	  var stackSize = 0;
	  length = array.length;
	
	  if (length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
	    tmpStorageLength = length >>> 1;
	  }
	
	  var tmp = [];
	  stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
	  runStart = [];
	  runLength = [];
	
	  function pushRun(_runStart, _runLength) {
	    runStart[stackSize] = _runStart;
	    runLength[stackSize] = _runLength;
	    stackSize += 1;
	  }
	
	  function mergeRuns() {
	    while (stackSize > 1) {
	      var n = stackSize - 2;
	
	      if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
	        if (runLength[n - 1] < runLength[n + 1]) {
	          n--;
	        }
	      } else if (runLength[n] > runLength[n + 1]) {
	        break;
	      }
	
	      mergeAt(n);
	    }
	  }
	
	  function forceMergeRuns() {
	    while (stackSize > 1) {
	      var n = stackSize - 2;
	
	      if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
	        n--;
	      }
	
	      mergeAt(n);
	    }
	  }
	
	  function mergeAt(i) {
	    var start1 = runStart[i];
	    var length1 = runLength[i];
	    var start2 = runStart[i + 1];
	    var length2 = runLength[i + 1];
	    runLength[i] = length1 + length2;
	
	    if (i === stackSize - 3) {
	      runStart[i + 1] = runStart[i + 2];
	      runLength[i + 1] = runLength[i + 2];
	    }
	
	    stackSize--;
	    var k = gallopRight(array[start2], array, start1, length1, 0, compare);
	    start1 += k;
	    length1 -= k;
	
	    if (length1 === 0) {
	      return;
	    }
	
	    length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
	
	    if (length2 === 0) {
	      return;
	    }
	
	    if (length1 <= length2) {
	      mergeLow(start1, length1, start2, length2);
	    } else {
	      mergeHigh(start1, length1, start2, length2);
	    }
	  }
	
	  function mergeLow(start1, length1, start2, length2) {
	    var i = 0;
	
	    for (i = 0; i < length1; i++) {
	      tmp[i] = array[start1 + i];
	    }
	
	    var cursor1 = 0;
	    var cursor2 = start2;
	    var dest = start1;
	    array[dest++] = array[cursor2++];
	
	    if (--length2 === 0) {
	      for (i = 0; i < length1; i++) {
	        array[dest + i] = tmp[cursor1 + i];
	      }
	
	      return;
	    }
	
	    if (length1 === 1) {
	      for (i = 0; i < length2; i++) {
	        array[dest + i] = array[cursor2 + i];
	      }
	
	      array[dest + length2] = tmp[cursor1];
	      return;
	    }
	
	    var _minGallop = minGallop;
	    var count1;
	    var count2;
	    var exit;
	
	    while (1) {
	      count1 = 0;
	      count2 = 0;
	      exit = false;
	
	      do {
	        if (compare(array[cursor2], tmp[cursor1]) < 0) {
	          array[dest++] = array[cursor2++];
	          count2++;
	          count1 = 0;
	
	          if (--length2 === 0) {
	            exit = true;
	            break;
	          }
	        } else {
	          array[dest++] = tmp[cursor1++];
	          count1++;
	          count2 = 0;
	
	          if (--length1 === 1) {
	            exit = true;
	            break;
	          }
	        }
	      } while ((count1 | count2) < _minGallop);
	
	      if (exit) {
	        break;
	      }
	
	      do {
	        count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
	
	        if (count1 !== 0) {
	          for (i = 0; i < count1; i++) {
	            array[dest + i] = tmp[cursor1 + i];
	          }
	
	          dest += count1;
	          cursor1 += count1;
	          length1 -= count1;
	
	          if (length1 <= 1) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest++] = array[cursor2++];
	
	        if (--length2 === 0) {
	          exit = true;
	          break;
	        }
	
	        count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
	
	        if (count2 !== 0) {
	          for (i = 0; i < count2; i++) {
	            array[dest + i] = array[cursor2 + i];
	          }
	
	          dest += count2;
	          cursor2 += count2;
	          length2 -= count2;
	
	          if (length2 === 0) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest++] = tmp[cursor1++];
	
	        if (--length1 === 1) {
	          exit = true;
	          break;
	        }
	
	        _minGallop--;
	      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	
	      if (exit) {
	        break;
	      }
	
	      if (_minGallop < 0) {
	        _minGallop = 0;
	      }
	
	      _minGallop += 2;
	    }
	
	    minGallop = _minGallop;
	    minGallop < 1 && (minGallop = 1);
	
	    if (length1 === 1) {
	      for (i = 0; i < length2; i++) {
	        array[dest + i] = array[cursor2 + i];
	      }
	
	      array[dest + length2] = tmp[cursor1];
	    } else if (length1 === 0) {
	      throw new Error(); // throw new Error('mergeLow preconditions were not respected');
	    } else {
	      for (i = 0; i < length1; i++) {
	        array[dest + i] = tmp[cursor1 + i];
	      }
	    }
	  }
	
	  function mergeHigh(start1, length1, start2, length2) {
	    var i = 0;
	
	    for (i = 0; i < length2; i++) {
	      tmp[i] = array[start2 + i];
	    }
	
	    var cursor1 = start1 + length1 - 1;
	    var cursor2 = length2 - 1;
	    var dest = start2 + length2 - 1;
	    var customCursor = 0;
	    var customDest = 0;
	    array[dest--] = array[cursor1--];
	
	    if (--length1 === 0) {
	      customCursor = dest - (length2 - 1);
	
	      for (i = 0; i < length2; i++) {
	        array[customCursor + i] = tmp[i];
	      }
	
	      return;
	    }
	
	    if (length2 === 1) {
	      dest -= length1;
	      cursor1 -= length1;
	      customDest = dest + 1;
	      customCursor = cursor1 + 1;
	
	      for (i = length1 - 1; i >= 0; i--) {
	        array[customDest + i] = array[customCursor + i];
	      }
	
	      array[dest] = tmp[cursor2];
	      return;
	    }
	
	    var _minGallop = minGallop;
	
	    while (true) {
	      var count1 = 0;
	      var count2 = 0;
	      var exit = false;
	
	      do {
	        if (compare(tmp[cursor2], array[cursor1]) < 0) {
	          array[dest--] = array[cursor1--];
	          count1++;
	          count2 = 0;
	
	          if (--length1 === 0) {
	            exit = true;
	            break;
	          }
	        } else {
	          array[dest--] = tmp[cursor2--];
	          count2++;
	          count1 = 0;
	
	          if (--length2 === 1) {
	            exit = true;
	            break;
	          }
	        }
	      } while ((count1 | count2) < _minGallop);
	
	      if (exit) {
	        break;
	      }
	
	      do {
	        count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
	
	        if (count1 !== 0) {
	          dest -= count1;
	          cursor1 -= count1;
	          length1 -= count1;
	          customDest = dest + 1;
	          customCursor = cursor1 + 1;
	
	          for (i = count1 - 1; i >= 0; i--) {
	            array[customDest + i] = array[customCursor + i];
	          }
	
	          if (length1 === 0) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest--] = tmp[cursor2--];
	
	        if (--length2 === 1) {
	          exit = true;
	          break;
	        }
	
	        count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
	
	        if (count2 !== 0) {
	          dest -= count2;
	          cursor2 -= count2;
	          length2 -= count2;
	          customDest = dest + 1;
	          customCursor = cursor2 + 1;
	
	          for (i = 0; i < count2; i++) {
	            array[customDest + i] = tmp[customCursor + i];
	          }
	
	          if (length2 <= 1) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest--] = array[cursor1--];
	
	        if (--length1 === 0) {
	          exit = true;
	          break;
	        }
	
	        _minGallop--;
	      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	
	      if (exit) {
	        break;
	      }
	
	      if (_minGallop < 0) {
	        _minGallop = 0;
	      }
	
	      _minGallop += 2;
	    }
	
	    minGallop = _minGallop;
	
	    if (minGallop < 1) {
	      minGallop = 1;
	    }
	
	    if (length2 === 1) {
	      dest -= length1;
	      cursor1 -= length1;
	      customDest = dest + 1;
	      customCursor = cursor1 + 1;
	
	      for (i = length1 - 1; i >= 0; i--) {
	        array[customDest + i] = array[customCursor + i];
	      }
	
	      array[dest] = tmp[cursor2];
	    } else if (length2 === 0) {
	      throw new Error(); // throw new Error('mergeHigh preconditions were not respected');
	    } else {
	      customCursor = dest - (length2 - 1);
	
	      for (i = 0; i < length2; i++) {
	        array[customCursor + i] = tmp[i];
	      }
	    }
	  }
	
	  this.mergeRuns = mergeRuns;
	  this.forceMergeRuns = forceMergeRuns;
	  this.pushRun = pushRun;
	}
	
	function sort(array, compare, lo, hi) {
	  if (!lo) {
	    lo = 0;
	  }
	
	  if (!hi) {
	    hi = array.length;
	  }
	
	  var remaining = hi - lo;
	
	  if (remaining < 2) {
	    return;
	  }
	
	  var runLength = 0;
	
	  if (remaining < DEFAULT_MIN_MERGE) {
	    runLength = makeAscendingRun(array, lo, hi, compare);
	    binaryInsertionSort(array, lo, hi, lo + runLength, compare);
	    return;
	  }
	
	  var ts = new TimSort(array, compare);
	  var minRun = minRunLength(remaining);
	
	  do {
	    runLength = makeAscendingRun(array, lo, hi, compare);
	
	    if (runLength < minRun) {
	      var force = remaining;
	
	      if (force > minRun) {
	        force = minRun;
	      }
	
	      binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
	      runLength = force;
	    }
	
	    ts.pushRun(lo, runLength);
	    ts.mergeRuns();
	    remaining -= runLength;
	    lo += runLength;
	  } while (remaining !== 0);
	
	  ts.forceMergeRuns();
	}
	
	module.exports = sort;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(241);
	
	var devicePixelRatio = _config.devicePixelRatio;
	
	var util = __webpack_require__(220);
	
	var logError = __webpack_require__(240);
	
	var BoundingRect = __webpack_require__(242);
	
	var timsort = __webpack_require__(243);
	
	var Layer = __webpack_require__(245);
	
	var requestAnimationFrame = __webpack_require__(250);
	
	var Image = __webpack_require__(251);
	
	var env = __webpack_require__(219);
	
	var HOVER_LAYER_ZLEVEL = 1e5;
	var CANVAS_ZLEVEL = 314159;
	var EL_AFTER_INCREMENTAL_INC = 0.01;
	var INCREMENTAL_INC = 0.001;
	
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	
	function isLayerValid(layer) {
	  if (!layer) {
	    return false;
	  }
	
	  if (layer.__builtin__) {
	    return true;
	  }
	
	  if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') {
	    return false;
	  }
	
	  return true;
	}
	
	var tmpRect = new BoundingRect(0, 0, 0, 0);
	var viewRect = new BoundingRect(0, 0, 0, 0);
	
	function isDisplayableCulled(el, width, height) {
	  tmpRect.copy(el.getBoundingRect());
	
	  if (el.transform) {
	    tmpRect.applyTransform(el.transform);
	  }
	
	  viewRect.width = width;
	  viewRect.height = height;
	  return !tmpRect.intersect(viewRect);
	}
	
	function isClipPathChanged(clipPaths, prevClipPaths) {
	  // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.
	  if (clipPaths === prevClipPaths) {
	    return false;
	  }
	
	  if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) {
	    return true;
	  }
	
	  for (var i = 0; i < clipPaths.length; i++) {
	    if (clipPaths[i] !== prevClipPaths[i]) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function doClip(clipPaths, ctx) {
	  for (var i = 0; i < clipPaths.length; i++) {
	    var clipPath = clipPaths[i];
	    clipPath.setTransform(ctx);
	    ctx.beginPath();
	    clipPath.buildPath(ctx, clipPath.shape);
	    ctx.clip(); // Transform back
	
	    clipPath.restoreTransform(ctx);
	  }
	}
	
	function createRoot(width, height) {
	  var domRoot = document.createElement('div'); // domRoot.onselectstart = returnFalse; // Avoid page selected
	
	  domRoot.style.cssText = ['position:relative', // IOS13 safari probably has a compositing bug (z order of the canvas and the consequent
	  // dom does not act as expected) when some of the parent dom has
	  // `-webkit-overflow-scrolling: touch;` and the webpage is longer than one screen and
	  // the canvas is not at the top part of the page.
	  // Check `https://bugs.webkit.org/show_bug.cgi?id=203681` for more details. We remove
	  // this `overflow:hidden` to avoid the bug.
	  // 'overflow:hidden',
	  'width:' + width + 'px', 'height:' + height + 'px', 'padding:0', 'margin:0', 'border-width:0'].join(';') + ';';
	  return domRoot;
	}
	/**
	 * @alias module:zrender/Painter
	 * @constructor
	 * @param {HTMLElement} root 绘图容器
	 * @param {module:zrender/Storage} storage
	 * @param {Object} opts
	 */
	
	
	var Painter = function (root, storage, opts) {
	  this.type = 'canvas'; // In node environment using node-canvas
	
	  var singleCanvas = !root.nodeName // In node ?
	  || root.nodeName.toUpperCase() === 'CANVAS';
	  this._opts = opts = util.extend({}, opts || {});
	  /**
	   * @type {number}
	   */
	
	  this.dpr = opts.devicePixelRatio || devicePixelRatio;
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._singleCanvas = singleCanvas;
	  /**
	   * 绘图容器
	   * @type {HTMLElement}
	   */
	
	  this.root = root;
	  var rootStyle = root.style;
	
	  if (rootStyle) {
	    rootStyle['-webkit-tap-highlight-color'] = 'transparent';
	    rootStyle['-webkit-user-select'] = rootStyle['user-select'] = rootStyle['-webkit-touch-callout'] = 'none';
	    root.innerHTML = '';
	  }
	  /**
	   * @type {module:zrender/Storage}
	   */
	
	
	  this.storage = storage;
	  /**
	   * @type {Array.<number>}
	   * @private
	   */
	
	  var zlevelList = this._zlevelList = [];
	  /**
	   * @type {Object.<string, module:zrender/Layer>}
	   * @private
	   */
	
	  var layers = this._layers = {};
	  /**
	   * @type {Object.<string, Object>}
	   * @private
	   */
	
	  this._layerConfig = {};
	  /**
	   * zrender will do compositing when root is a canvas and have multiple zlevels.
	   */
	
	  this._needsManuallyCompositing = false;
	
	  if (!singleCanvas) {
	    this._width = this._getSize(0);
	    this._height = this._getSize(1);
	    var domRoot = this._domRoot = createRoot(this._width, this._height);
	    root.appendChild(domRoot);
	  } else {
	    var width = root.width;
	    var height = root.height;
	
	    if (opts.width != null) {
	      width = opts.width;
	    }
	
	    if (opts.height != null) {
	      height = opts.height;
	    }
	
	    this.dpr = opts.devicePixelRatio || 1; // Use canvas width and height directly
	
	    root.width = width * this.dpr;
	    root.height = height * this.dpr;
	    this._width = width;
	    this._height = height; // Create layer if only one given canvas
	    // Device can be specified to create a high dpi image.
	
	    var mainLayer = new Layer(root, this, this.dpr);
	    mainLayer.__builtin__ = true;
	    mainLayer.initContext(); // FIXME Use canvas width and height
	    // mainLayer.resize(width, height);
	
	    layers[CANVAS_ZLEVEL] = mainLayer;
	    mainLayer.zlevel = CANVAS_ZLEVEL; // Not use common zlevel.
	
	    zlevelList.push(CANVAS_ZLEVEL);
	    this._domRoot = root;
	  }
	  /**
	   * @type {module:zrender/Layer}
	   * @private
	   */
	
	
	  this._hoverlayer = null;
	  this._hoverElements = [];
	};
	
	Painter.prototype = {
	  constructor: Painter,
	  getType: function () {
	    return 'canvas';
	  },
	
	  /**
	   * If painter use a single canvas
	   * @return {boolean}
	   */
	  isSingleCanvas: function () {
	    return this._singleCanvas;
	  },
	
	  /**
	   * @return {HTMLDivElement}
	   */
	  getViewportRoot: function () {
	    return this._domRoot;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	
	  /**
	   * 刷新
	   * @param {boolean} [paintAll=false] 强制绘制所有displayable
	   */
	  refresh: function (paintAll) {
	    var list = this.storage.getDisplayList(true);
	    var zlevelList = this._zlevelList;
	    this._redrawId = Math.random();
	
	    this._paintList(list, paintAll, this._redrawId); // Paint custum layers
	
	
	    for (var i = 0; i < zlevelList.length; i++) {
	      var z = zlevelList[i];
	      var layer = this._layers[z];
	
	      if (!layer.__builtin__ && layer.refresh) {
	        var clearColor = i === 0 ? this._backgroundColor : null;
	        layer.refresh(clearColor);
	      }
	    }
	
	    this.refreshHover();
	    return this;
	  },
	  addHover: function (el, hoverStyle) {
	    if (el.__hoverMir) {
	      return;
	    }
	
	    var elMirror = new el.constructor({
	      style: el.style,
	      shape: el.shape,
	      z: el.z,
	      z2: el.z2,
	      silent: el.silent
	    });
	    elMirror.__from = el;
	    el.__hoverMir = elMirror;
	    hoverStyle && elMirror.setStyle(hoverStyle);
	
	    this._hoverElements.push(elMirror);
	
	    return elMirror;
	  },
	  removeHover: function (el) {
	    var elMirror = el.__hoverMir;
	    var hoverElements = this._hoverElements;
	    var idx = util.indexOf(hoverElements, elMirror);
	
	    if (idx >= 0) {
	      hoverElements.splice(idx, 1);
	    }
	
	    el.__hoverMir = null;
	  },
	  clearHover: function (el) {
	    var hoverElements = this._hoverElements;
	
	    for (var i = 0; i < hoverElements.length; i++) {
	      var from = hoverElements[i].__from;
	
	      if (from) {
	        from.__hoverMir = null;
	      }
	    }
	
	    hoverElements.length = 0;
	  },
	  refreshHover: function () {
	    var hoverElements = this._hoverElements;
	    var len = hoverElements.length;
	    var hoverLayer = this._hoverlayer;
	    hoverLayer && hoverLayer.clear();
	
	    if (!len) {
	      return;
	    }
	
	    timsort(hoverElements, this.storage.displayableSortFunc); // Use a extream large zlevel
	    // FIXME?
	
	    if (!hoverLayer) {
	      hoverLayer = this._hoverlayer = this.getLayer(HOVER_LAYER_ZLEVEL);
	    }
	
	    var scope = {};
	    hoverLayer.ctx.save();
	
	    for (var i = 0; i < len;) {
	      var el = hoverElements[i];
	      var originalEl = el.__from; // Original el is removed
	      // PENDING
	
	      if (!(originalEl && originalEl.__zr)) {
	        hoverElements.splice(i, 1);
	        originalEl.__hoverMir = null;
	        len--;
	        continue;
	      }
	
	      i++; // Use transform
	      // FIXME style and shape ?
	
	      if (!originalEl.invisible) {
	        el.transform = originalEl.transform;
	        el.invTransform = originalEl.invTransform;
	        el.__clipPaths = originalEl.__clipPaths; // el.
	
	        this._doPaintEl(el, hoverLayer, true, scope);
	      }
	    }
	
	    hoverLayer.ctx.restore();
	  },
	  getHoverLayer: function () {
	    return this.getLayer(HOVER_LAYER_ZLEVEL);
	  },
	  _paintList: function (list, paintAll, redrawId) {
	    if (this._redrawId !== redrawId) {
	      return;
	    }
	
	    paintAll = paintAll || false;
	
	    this._updateLayerStatus(list);
	
	    var finished = this._doPaintList(list, paintAll);
	
	    if (this._needsManuallyCompositing) {
	      this._compositeManually();
	    }
	
	    if (!finished) {
	      var self = this;
	      requestAnimationFrame(function () {
	        self._paintList(list, paintAll, redrawId);
	      });
	    }
	  },
	  _compositeManually: function () {
	    var ctx = this.getLayer(CANVAS_ZLEVEL).ctx;
	    var width = this._domRoot.width;
	    var height = this._domRoot.height;
	    ctx.clearRect(0, 0, width, height); // PENDING, If only builtin layer?
	
	    this.eachBuiltinLayer(function (layer) {
	      if (layer.virtual) {
	        ctx.drawImage(layer.dom, 0, 0, width, height);
	      }
	    });
	  },
	  _doPaintList: function (list, paintAll) {
	    var layerList = [];
	
	    for (var zi = 0; zi < this._zlevelList.length; zi++) {
	      var zlevel = this._zlevelList[zi];
	      var layer = this._layers[zlevel];
	
	      if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) {
	        layerList.push(layer);
	      }
	    }
	
	    var finished = true;
	
	    for (var k = 0; k < layerList.length; k++) {
	      var layer = layerList[k];
	      var ctx = layer.ctx;
	      var scope = {};
	      ctx.save();
	      var start = paintAll ? layer.__startIndex : layer.__drawIndex;
	      var useTimer = !paintAll && layer.incremental && Date.now;
	      var startTime = useTimer && Date.now();
	      var clearColor = layer.zlevel === this._zlevelList[0] ? this._backgroundColor : null; // All elements in this layer are cleared.
	
	      if (layer.__startIndex === layer.__endIndex) {
	        layer.clear(false, clearColor);
	      } else if (start === layer.__startIndex) {
	        var firstEl = list[start];
	
	        if (!firstEl.incremental || !firstEl.notClear || paintAll) {
	          layer.clear(false, clearColor);
	        }
	      }
	
	      if (start === -1) {
	        console.error('For some unknown reason. drawIndex is -1');
	        start = layer.__startIndex;
	      }
	
	      for (var i = start; i < layer.__endIndex; i++) {
	        var el = list[i];
	
	        this._doPaintEl(el, layer, paintAll, scope);
	
	        el.__dirty = el.__dirtyText = false;
	
	        if (useTimer) {
	          // Date.now can be executed in 13,025,305 ops/second.
	          var dTime = Date.now() - startTime; // Give 15 millisecond to draw.
	          // The rest elements will be drawn in the next frame.
	
	          if (dTime > 15) {
	            break;
	          }
	        }
	      }
	
	      layer.__drawIndex = i;
	
	      if (layer.__drawIndex < layer.__endIndex) {
	        finished = false;
	      }
	
	      if (scope.prevElClipPaths) {
	        // Needs restore the state. If last drawn element is in the clipping area.
	        ctx.restore();
	      }
	
	      ctx.restore();
	    }
	
	    if (env.wxa) {
	      // Flush for weixin application
	      util.each(this._layers, function (layer) {
	        if (layer && layer.ctx && layer.ctx.draw) {
	          layer.ctx.draw();
	        }
	      });
	    }
	
	    return finished;
	  },
	  _doPaintEl: function (el, currentLayer, forcePaint, scope) {
	    var ctx = currentLayer.ctx;
	    var m = el.transform;
	
	    if ((currentLayer.__dirty || forcePaint) && // Ignore invisible element
	    !el.invisible // Ignore transparent element
	    && el.style.opacity !== 0 // Ignore scale 0 element, in some environment like node-canvas
	    // Draw a scale 0 element can cause all following draw wrong
	    // And setTransform with scale 0 will cause set back transform failed.
	    && !(m && !m[0] && !m[3]) // Ignore culled element
	    && !(el.culling && isDisplayableCulled(el, this._width, this._height))) {
	      var clipPaths = el.__clipPaths;
	      var prevElClipPaths = scope.prevElClipPaths; // Optimize when clipping on group with several elements
	
	      if (!prevElClipPaths || isClipPathChanged(clipPaths, prevElClipPaths)) {
	        // If has previous clipping state, restore from it
	        if (prevElClipPaths) {
	          ctx.restore();
	          scope.prevElClipPaths = null; // Reset prevEl since context has been restored
	
	          scope.prevEl = null;
	        } // New clipping state
	
	
	        if (clipPaths) {
	          ctx.save();
	          doClip(clipPaths, ctx);
	          scope.prevElClipPaths = clipPaths;
	        }
	      }
	
	      el.beforeBrush && el.beforeBrush(ctx);
	      el.brush(ctx, scope.prevEl || null);
	      scope.prevEl = el;
	      el.afterBrush && el.afterBrush(ctx);
	    }
	  },
	
	  /**
	   * 获取 zlevel 所在层，如果不存在则会创建一个新的层
	   * @param {number} zlevel
	   * @param {boolean} virtual Virtual layer will not be inserted into dom.
	   * @return {module:zrender/Layer}
	   */
	  getLayer: function (zlevel, virtual) {
	    if (this._singleCanvas && !this._needsManuallyCompositing) {
	      zlevel = CANVAS_ZLEVEL;
	    }
	
	    var layer = this._layers[zlevel];
	
	    if (!layer) {
	      // Create a new layer
	      layer = new Layer('zr_' + zlevel, this, this.dpr);
	      layer.zlevel = zlevel;
	      layer.__builtin__ = true;
	
	      if (this._layerConfig[zlevel]) {
	        util.merge(layer, this._layerConfig[zlevel], true);
	      } // TODO Remove EL_AFTER_INCREMENTAL_INC magic number
	      else if (this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC]) {
	          util.merge(layer, this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC], true);
	        }
	
	      if (virtual) {
	        layer.virtual = virtual;
	      }
	
	      this.insertLayer(zlevel, layer); // Context is created after dom inserted to document
	      // Or excanvas will get 0px clientWidth and clientHeight
	
	      layer.initContext();
	    }
	
	    return layer;
	  },
	  insertLayer: function (zlevel, layer) {
	    var layersMap = this._layers;
	    var zlevelList = this._zlevelList;
	    var len = zlevelList.length;
	    var prevLayer = null;
	    var i = -1;
	    var domRoot = this._domRoot;
	
	    if (layersMap[zlevel]) {
	      logError('ZLevel ' + zlevel + ' has been used already');
	      return;
	    } // Check if is a valid layer
	
	
	    if (!isLayerValid(layer)) {
	      logError('Layer of zlevel ' + zlevel + ' is not valid');
	      return;
	    }
	
	    if (len > 0 && zlevel > zlevelList[0]) {
	      for (i = 0; i < len - 1; i++) {
	        if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) {
	          break;
	        }
	      }
	
	      prevLayer = layersMap[zlevelList[i]];
	    }
	
	    zlevelList.splice(i + 1, 0, zlevel);
	    layersMap[zlevel] = layer; // Vitual layer will not directly show on the screen.
	    // (It can be a WebGL layer and assigned to a ZImage element)
	    // But it still under management of zrender.
	
	    if (!layer.virtual) {
	      if (prevLayer) {
	        var prevDom = prevLayer.dom;
	
	        if (prevDom.nextSibling) {
	          domRoot.insertBefore(layer.dom, prevDom.nextSibling);
	        } else {
	          domRoot.appendChild(layer.dom);
	        }
	      } else {
	        if (domRoot.firstChild) {
	          domRoot.insertBefore(layer.dom, domRoot.firstChild);
	        } else {
	          domRoot.appendChild(layer.dom);
	        }
	      }
	    }
	  },
	  // Iterate each layer
	  eachLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      cb.call(context, this._layers[z], z);
	    }
	  },
	  // Iterate each buildin layer
	  eachBuiltinLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var layer;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      layer = this._layers[z];
	
	      if (layer.__builtin__) {
	        cb.call(context, layer, z);
	      }
	    }
	  },
	  // Iterate each other layer except buildin layer
	  eachOtherLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var layer;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      layer = this._layers[z];
	
	      if (!layer.__builtin__) {
	        cb.call(context, layer, z);
	      }
	    }
	  },
	
	  /**
	   * 获取所有已创建的层
	   * @param {Array.<module:zrender/Layer>} [prevLayer]
	   */
	  getLayers: function () {
	    return this._layers;
	  },
	  _updateLayerStatus: function (list) {
	    this.eachBuiltinLayer(function (layer, z) {
	      layer.__dirty = layer.__used = false;
	    });
	
	    function updatePrevLayer(idx) {
	      if (prevLayer) {
	        if (prevLayer.__endIndex !== idx) {
	          prevLayer.__dirty = true;
	        }
	
	        prevLayer.__endIndex = idx;
	      }
	    }
	
	    if (this._singleCanvas) {
	      for (var i = 1; i < list.length; i++) {
	        var el = list[i];
	
	        if (el.zlevel !== list[i - 1].zlevel || el.incremental) {
	          this._needsManuallyCompositing = true;
	          break;
	        }
	      }
	    }
	
	    var prevLayer = null;
	    var incrementalLayerCount = 0;
	    var prevZlevel;
	
	    for (var i = 0; i < list.length; i++) {
	      var el = list[i];
	      var zlevel = el.zlevel;
	      var layer;
	
	      if (prevZlevel !== zlevel) {
	        prevZlevel = zlevel;
	        incrementalLayerCount = 0;
	      } // TODO Not use magic number on zlevel.
	      // Each layer with increment element can be separated to 3 layers.
	      //          (Other Element drawn after incremental element)
	      // -----------------zlevel + EL_AFTER_INCREMENTAL_INC--------------------
	      //                      (Incremental element)
	      // ----------------------zlevel + INCREMENTAL_INC------------------------
	      //              (Element drawn before incremental element)
	      // --------------------------------zlevel--------------------------------
	
	
	      if (el.incremental) {
	        layer = this.getLayer(zlevel + INCREMENTAL_INC, this._needsManuallyCompositing);
	        layer.incremental = true;
	        incrementalLayerCount = 1;
	      } else {
	        layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
	      }
	
	      if (!layer.__builtin__) {
	        logError('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
	      }
	
	      if (layer !== prevLayer) {
	        layer.__used = true;
	
	        if (layer.__startIndex !== i) {
	          layer.__dirty = true;
	        }
	
	        layer.__startIndex = i;
	
	        if (!layer.incremental) {
	          layer.__drawIndex = i;
	        } else {
	          // Mark layer draw index needs to update.
	          layer.__drawIndex = -1;
	        }
	
	        updatePrevLayer(i);
	        prevLayer = layer;
	      }
	
	      if (el.__dirty) {
	        layer.__dirty = true;
	
	        if (layer.incremental && layer.__drawIndex < 0) {
	          // Start draw from the first dirty element.
	          layer.__drawIndex = i;
	        }
	      }
	    }
	
	    updatePrevLayer(i);
	    this.eachBuiltinLayer(function (layer, z) {
	      // Used in last frame but not in this frame. Needs clear
	      if (!layer.__used && layer.getElementCount() > 0) {
	        layer.__dirty = true;
	        layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
	      } // For incremental layer. In case start index changed and no elements are dirty.
	
	
	      if (layer.__dirty && layer.__drawIndex < 0) {
	        layer.__drawIndex = layer.__startIndex;
	      }
	    });
	  },
	
	  /**
	   * 清除hover层外所有内容
	   */
	  clear: function () {
	    this.eachBuiltinLayer(this._clearLayer);
	    return this;
	  },
	  _clearLayer: function (layer) {
	    layer.clear();
	  },
	  setBackgroundColor: function (backgroundColor) {
	    this._backgroundColor = backgroundColor;
	  },
	
	  /**
	   * 修改指定zlevel的绘制参数
	   *
	   * @param {string} zlevel
	   * @param {Object} config 配置对象
	   * @param {string} [config.clearColor=0] 每次清空画布的颜色
	   * @param {string} [config.motionBlur=false] 是否开启动态模糊
	   * @param {number} [config.lastFrameAlpha=0.7]
	   *                 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
	   */
	  configLayer: function (zlevel, config) {
	    if (config) {
	      var layerConfig = this._layerConfig;
	
	      if (!layerConfig[zlevel]) {
	        layerConfig[zlevel] = config;
	      } else {
	        util.merge(layerConfig[zlevel], config, true);
	      }
	
	      for (var i = 0; i < this._zlevelList.length; i++) {
	        var _zlevel = this._zlevelList[i]; // TODO Remove EL_AFTER_INCREMENTAL_INC magic number
	
	        if (_zlevel === zlevel || _zlevel === zlevel + EL_AFTER_INCREMENTAL_INC) {
	          var layer = this._layers[_zlevel];
	          util.merge(layer, layerConfig[zlevel], true);
	        }
	      }
	    }
	  },
	
	  /**
	   * 删除指定层
	   * @param {number} zlevel 层所在的zlevel
	   */
	  delLayer: function (zlevel) {
	    var layers = this._layers;
	    var zlevelList = this._zlevelList;
	    var layer = layers[zlevel];
	
	    if (!layer) {
	      return;
	    }
	
	    layer.dom.parentNode.removeChild(layer.dom);
	    delete layers[zlevel];
	    zlevelList.splice(util.indexOf(zlevelList, zlevel), 1);
	  },
	
	  /**
	   * 区域大小变化后重绘
	   */
	  resize: function (width, height) {
	    if (!this._domRoot.style) {
	      // Maybe in node or worker
	      if (width == null || height == null) {
	        return;
	      }
	
	      this._width = width;
	      this._height = height;
	      this.getLayer(CANVAS_ZLEVEL).resize(width, height);
	    } else {
	      var domRoot = this._domRoot; // FIXME Why ?
	
	      domRoot.style.display = 'none'; // Save input w/h
	
	      var opts = this._opts;
	      width != null && (opts.width = width);
	      height != null && (opts.height = height);
	      width = this._getSize(0);
	      height = this._getSize(1);
	      domRoot.style.display = ''; // 优化没有实际改变的resize
	
	      if (this._width !== width || height !== this._height) {
	        domRoot.style.width = width + 'px';
	        domRoot.style.height = height + 'px';
	
	        for (var id in this._layers) {
	          if (this._layers.hasOwnProperty(id)) {
	            this._layers[id].resize(width, height);
	          }
	        }
	
	        util.each(this._progressiveLayers, function (layer) {
	          layer.resize(width, height);
	        });
	        this.refresh(true);
	      }
	
	      this._width = width;
	      this._height = height;
	    }
	
	    return this;
	  },
	
	  /**
	   * 清除单独的一个层
	   * @param {number} zlevel
	   */
	  clearLayer: function (zlevel) {
	    var layer = this._layers[zlevel];
	
	    if (layer) {
	      layer.clear();
	    }
	  },
	
	  /**
	   * 释放
	   */
	  dispose: function () {
	    this.root.innerHTML = '';
	    this.root = this.storage = this._domRoot = this._layers = null;
	  },
	
	  /**
	   * Get canvas which has all thing rendered
	   * @param {Object} opts
	   * @param {string} [opts.backgroundColor]
	   * @param {number} [opts.pixelRatio]
	   */
	  getRenderedCanvas: function (opts) {
	    opts = opts || {};
	
	    if (this._singleCanvas && !this._compositeManually) {
	      return this._layers[CANVAS_ZLEVEL].dom;
	    }
	
	    var imageLayer = new Layer('image', this, opts.pixelRatio || this.dpr);
	    imageLayer.initContext();
	    imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
	
	    if (opts.pixelRatio <= this.dpr) {
	      this.refresh();
	      var width = imageLayer.dom.width;
	      var height = imageLayer.dom.height;
	      var ctx = imageLayer.ctx;
	      this.eachLayer(function (layer) {
	        if (layer.__builtin__) {
	          ctx.drawImage(layer.dom, 0, 0, width, height);
	        } else if (layer.renderToCanvas) {
	          imageLayer.ctx.save();
	          layer.renderToCanvas(imageLayer.ctx);
	          imageLayer.ctx.restore();
	        }
	      });
	    } else {
	      // PENDING, echarts-gl and incremental rendering.
	      var scope = {};
	      var displayList = this.storage.getDisplayList(true);
	
	      for (var i = 0; i < displayList.length; i++) {
	        var el = displayList[i];
	
	        this._doPaintEl(el, imageLayer, true, scope);
	      }
	    }
	
	    return imageLayer.dom;
	  },
	
	  /**
	   * 获取绘图区域宽度
	   */
	  getWidth: function () {
	    return this._width;
	  },
	
	  /**
	   * 获取绘图区域高度
	   */
	  getHeight: function () {
	    return this._height;
	  },
	  _getSize: function (whIdx) {
	    var opts = this._opts;
	    var wh = ['width', 'height'][whIdx];
	    var cwh = ['clientWidth', 'clientHeight'][whIdx];
	    var plt = ['paddingLeft', 'paddingTop'][whIdx];
	    var prb = ['paddingRight', 'paddingBottom'][whIdx];
	
	    if (opts[wh] != null && opts[wh] !== 'auto') {
	      return parseFloat(opts[wh]);
	    }
	
	    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
	
	    var stl = document.defaultView.getComputedStyle(root);
	    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
	  },
	  pathToImage: function (path, dpr) {
	    dpr = dpr || this.dpr;
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	    var rect = path.getBoundingRect();
	    var style = path.style;
	    var shadowBlurSize = style.shadowBlur * dpr;
	    var shadowOffsetX = style.shadowOffsetX * dpr;
	    var shadowOffsetY = style.shadowOffsetY * dpr;
	    var lineWidth = style.hasStroke() ? style.lineWidth : 0;
	    var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
	    var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
	    var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
	    var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
	    var width = rect.width + leftMargin + rightMargin;
	    var height = rect.height + topMargin + bottomMargin;
	    canvas.width = width * dpr;
	    canvas.height = height * dpr;
	    ctx.scale(dpr, dpr);
	    ctx.clearRect(0, 0, width, height);
	    ctx.dpr = dpr;
	    var pathTransform = {
	      position: path.position,
	      rotation: path.rotation,
	      scale: path.scale
	    };
	    path.position = [leftMargin - rect.x, topMargin - rect.y];
	    path.rotation = 0;
	    path.scale = [1, 1];
	    path.updateTransform();
	
	    if (path) {
	      path.brush(ctx);
	    }
	
	    var ImageShape = Image;
	    var imgShape = new ImageShape({
	      style: {
	        x: 0,
	        y: 0,
	        image: canvas
	      }
	    });
	
	    if (pathTransform.position != null) {
	      imgShape.position = path.position = pathTransform.position;
	    }
	
	    if (pathTransform.rotation != null) {
	      imgShape.rotation = path.rotation = pathTransform.rotation;
	    }
	
	    if (pathTransform.scale != null) {
	      imgShape.scale = path.scale = pathTransform.scale;
	    }
	
	    return imgShape;
	  }
	};
	var _default = Painter;
	module.exports = _default;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(220);
	
	var _config = __webpack_require__(241);
	
	var devicePixelRatio = _config.devicePixelRatio;
	
	var Style = __webpack_require__(246);
	
	var Pattern = __webpack_require__(249);
	
	/**
	 * @module zrender/Layer
	 * @author pissang(https://www.github.com/pissang)
	 */
	function returnFalse() {
	  return false;
	}
	/**
	 * 创建dom
	 *
	 * @inner
	 * @param {string} id dom id 待用
	 * @param {Painter} painter painter instance
	 * @param {number} number
	 */
	
	
	function createDom(id, painter, dpr) {
	  var newDom = util.createCanvas();
	  var width = painter.getWidth();
	  var height = painter.getHeight();
	  var newDomStyle = newDom.style;
	
	  if (newDomStyle) {
	    // In node or some other non-browser environment
	    newDomStyle.position = 'absolute';
	    newDomStyle.left = 0;
	    newDomStyle.top = 0;
	    newDomStyle.width = width + 'px';
	    newDomStyle.height = height + 'px';
	    newDom.setAttribute('data-zr-dom-id', id);
	  }
	
	  newDom.width = width * dpr;
	  newDom.height = height * dpr;
	  return newDom;
	}
	/**
	 * @alias module:zrender/Layer
	 * @constructor
	 * @extends module:zrender/mixin/Transformable
	 * @param {string} id
	 * @param {module:zrender/Painter} painter
	 * @param {number} [dpr]
	 */
	
	
	var Layer = function (id, painter, dpr) {
	  var dom;
	  dpr = dpr || devicePixelRatio;
	
	  if (typeof id === 'string') {
	    dom = createDom(id, painter, dpr);
	  } // Not using isDom because in node it will return false
	  else if (util.isObject(id)) {
	      dom = id;
	      id = dom.id;
	    }
	
	  this.id = id;
	  this.dom = dom;
	  var domStyle = dom.style;
	
	  if (domStyle) {
	    // Not in node
	    dom.onselectstart = returnFalse; // 避免页面选中的尴尬
	
	    domStyle['-webkit-user-select'] = 'none';
	    domStyle['user-select'] = 'none';
	    domStyle['-webkit-touch-callout'] = 'none';
	    domStyle['-webkit-tap-highlight-color'] = 'rgba(0,0,0,0)';
	    domStyle['padding'] = 0; // eslint-disable-line dot-notation
	
	    domStyle['margin'] = 0; // eslint-disable-line dot-notation
	
	    domStyle['border-width'] = 0;
	  }
	
	  this.domBack = null;
	  this.ctxBack = null;
	  this.painter = painter;
	  this.config = null; // Configs
	
	  /**
	   * 每次清空画布的颜色
	   * @type {string}
	   * @default 0
	   */
	
	  this.clearColor = 0;
	  /**
	   * 是否开启动态模糊
	   * @type {boolean}
	   * @default false
	   */
	
	  this.motionBlur = false;
	  /**
	   * 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
	   * @type {number}
	   * @default 0.7
	   */
	
	  this.lastFrameAlpha = 0.7;
	  /**
	   * Layer dpr
	   * @type {number}
	   */
	
	  this.dpr = dpr;
	};
	
	Layer.prototype = {
	  constructor: Layer,
	  __dirty: true,
	  __used: false,
	  __drawIndex: 0,
	  __startIndex: 0,
	  __endIndex: 0,
	  incremental: false,
	  getElementCount: function () {
	    return this.__endIndex - this.__startIndex;
	  },
	  initContext: function () {
	    this.ctx = this.dom.getContext('2d');
	    this.ctx.dpr = this.dpr;
	  },
	  createBackBuffer: function () {
	    var dpr = this.dpr;
	    this.domBack = createDom('back-' + this.id, this.painter, dpr);
	    this.ctxBack = this.domBack.getContext('2d');
	
	    if (dpr !== 1) {
	      this.ctxBack.scale(dpr, dpr);
	    }
	  },
	
	  /**
	   * @param  {number} width
	   * @param  {number} height
	   */
	  resize: function (width, height) {
	    var dpr = this.dpr;
	    var dom = this.dom;
	    var domStyle = dom.style;
	    var domBack = this.domBack;
	
	    if (domStyle) {
	      domStyle.width = width + 'px';
	      domStyle.height = height + 'px';
	    }
	
	    dom.width = width * dpr;
	    dom.height = height * dpr;
	
	    if (domBack) {
	      domBack.width = width * dpr;
	      domBack.height = height * dpr;
	
	      if (dpr !== 1) {
	        this.ctxBack.scale(dpr, dpr);
	      }
	    }
	  },
	
	  /**
	   * 清空该层画布
	   * @param {boolean} [clearAll]=false Clear all with out motion blur
	   * @param {Color} [clearColor]
	   */
	  clear: function (clearAll, clearColor) {
	    var dom = this.dom;
	    var ctx = this.ctx;
	    var width = dom.width;
	    var height = dom.height;
	    var clearColor = clearColor || this.clearColor;
	    var haveMotionBLur = this.motionBlur && !clearAll;
	    var lastFrameAlpha = this.lastFrameAlpha;
	    var dpr = this.dpr;
	
	    if (haveMotionBLur) {
	      if (!this.domBack) {
	        this.createBackBuffer();
	      }
	
	      this.ctxBack.globalCompositeOperation = 'copy';
	      this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
	    }
	
	    ctx.clearRect(0, 0, width, height);
	
	    if (clearColor && clearColor !== 'transparent') {
	      var clearColorGradientOrPattern; // Gradient
	
	      if (clearColor.colorStops) {
	        // Cache canvas gradient
	        clearColorGradientOrPattern = clearColor.__canvasGradient || Style.getGradient(ctx, clearColor, {
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        });
	        clearColor.__canvasGradient = clearColorGradientOrPattern;
	      } // Pattern
	      else if (clearColor.image) {
	          clearColorGradientOrPattern = Pattern.prototype.getCanvasPattern.call(clearColor, ctx);
	        }
	
	      ctx.save();
	      ctx.fillStyle = clearColorGradientOrPattern || clearColor;
	      ctx.fillRect(0, 0, width, height);
	      ctx.restore();
	    }
	
	    if (haveMotionBLur) {
	      var domBack = this.domBack;
	      ctx.save();
	      ctx.globalAlpha = lastFrameAlpha;
	      ctx.drawImage(domBack, 0, 0, width, height);
	      ctx.restore();
	    }
	  }
	};
	var _default = Layer;
	module.exports = _default;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var fixShadow = __webpack_require__(247);
	
	var _constant = __webpack_require__(248);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	var STYLE_COMMON_PROPS = [['shadowBlur', 0], ['shadowOffsetX', 0], ['shadowOffsetY', 0], ['shadowColor', '#000'], ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]]; // var SHADOW_PROPS = STYLE_COMMON_PROPS.slice(0, 4);
	// var LINE_PROPS = STYLE_COMMON_PROPS.slice(4);
	
	var Style = function (opts) {
	  this.extendFrom(opts, false);
	};
	
	function createLinearGradient(ctx, obj, rect) {
	  var x = obj.x == null ? 0 : obj.x;
	  var x2 = obj.x2 == null ? 1 : obj.x2;
	  var y = obj.y == null ? 0 : obj.y;
	  var y2 = obj.y2 == null ? 0 : obj.y2;
	
	  if (!obj.global) {
	    x = x * rect.width + rect.x;
	    x2 = x2 * rect.width + rect.x;
	    y = y * rect.height + rect.y;
	    y2 = y2 * rect.height + rect.y;
	  } // Fix NaN when rect is Infinity
	
	
	  x = isNaN(x) ? 0 : x;
	  x2 = isNaN(x2) ? 1 : x2;
	  y = isNaN(y) ? 0 : y;
	  y2 = isNaN(y2) ? 0 : y2;
	  var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
	  return canvasGradient;
	}
	
	function createRadialGradient(ctx, obj, rect) {
	  var width = rect.width;
	  var height = rect.height;
	  var min = Math.min(width, height);
	  var x = obj.x == null ? 0.5 : obj.x;
	  var y = obj.y == null ? 0.5 : obj.y;
	  var r = obj.r == null ? 0.5 : obj.r;
	
	  if (!obj.global) {
	    x = x * width + rect.x;
	    y = y * height + rect.y;
	    r = r * min;
	  }
	
	  var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
	  return canvasGradient;
	}
	
	Style.prototype = {
	  constructor: Style,
	
	  /**
	   * @type {string}
	   */
	  fill: '#000',
	
	  /**
	   * @type {string}
	   */
	  stroke: null,
	
	  /**
	   * @type {number}
	   */
	  opacity: 1,
	
	  /**
	   * @type {number}
	   */
	  fillOpacity: null,
	
	  /**
	   * @type {number}
	   */
	  strokeOpacity: null,
	
	  /**
	   * `true` is not supported.
	   * `false`/`null`/`undefined` are the same.
	   * `false` is used to remove lineDash in some
	   * case that `null`/`undefined` can not be set.
	   * (e.g., emphasis.lineStyle in echarts)
	   * @type {Array.<number>|boolean}
	   */
	  lineDash: null,
	
	  /**
	   * @type {number}
	   */
	  lineDashOffset: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowOffsetY: 0,
	
	  /**
	   * @type {number}
	   */
	  lineWidth: 1,
	
	  /**
	   * If stroke ignore scale
	   * @type {Boolean}
	   */
	  strokeNoScale: false,
	  // Bounding rect text configuration
	  // Not affected by element transform
	
	  /**
	   * @type {string}
	   */
	  text: null,
	
	  /**
	   * If `fontSize` or `fontFamily` exists, `font` will be reset by
	   * `fontSize`, `fontStyle`, `fontWeight`, `fontFamily`.
	   * So do not visit it directly in upper application (like echarts),
	   * but use `contain/text#makeFont` instead.
	   * @type {string}
	   */
	  font: null,
	
	  /**
	   * The same as font. Use font please.
	   * @deprecated
	   * @type {string}
	   */
	  textFont: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontStyle: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontWeight: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * Should be 12 but not '12px'.
	   * @type {number}
	   */
	  fontSize: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontFamily: null,
	
	  /**
	   * Reserved for special functinality, like 'hr'.
	   * @type {string}
	   */
	  textTag: null,
	
	  /**
	   * @type {string}
	   */
	  textFill: '#000',
	
	  /**
	   * @type {string}
	   */
	  textStroke: null,
	
	  /**
	   * @type {number}
	   */
	  textWidth: null,
	
	  /**
	   * Only for textBackground.
	   * @type {number}
	   */
	  textHeight: null,
	
	  /**
	   * textStroke may be set as some color as a default
	   * value in upper applicaion, where the default value
	   * of textStrokeWidth should be 0 to make sure that
	   * user can choose to do not use text stroke.
	   * @type {number}
	   */
	  textStrokeWidth: 0,
	
	  /**
	   * @type {number}
	   */
	  textLineHeight: null,
	
	  /**
	   * 'inside', 'left', 'right', 'top', 'bottom'
	   * [x, y]
	   * Based on x, y of rect.
	   * @type {string|Array.<number>}
	   * @default 'inside'
	   */
	  textPosition: 'inside',
	
	  /**
	   * If not specified, use the boundingRect of a `displayable`.
	   * @type {Object}
	   */
	  textRect: null,
	
	  /**
	   * [x, y]
	   * @type {Array.<number>}
	   */
	  textOffset: null,
	
	  /**
	   * @type {string}
	   */
	  textAlign: null,
	
	  /**
	   * @type {string}
	   */
	  textVerticalAlign: null,
	
	  /**
	   * @type {number}
	   */
	  textDistance: 5,
	
	  /**
	   * @type {string}
	   */
	  textShadowColor: 'transparent',
	
	  /**
	   * @type {number}
	   */
	  textShadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  textShadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  textShadowOffsetY: 0,
	
	  /**
	   * @type {string}
	   */
	  textBoxShadowColor: 'transparent',
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowOffsetY: 0,
	
	  /**
	   * Whether transform text.
	   * Only available in Path and Image element,
	   * where the text is called as `RectText`.
	   * @type {boolean}
	   */
	  transformText: false,
	
	  /**
	   * Text rotate around position of Path or Image.
	   * The origin of the rotation can be specified by `textOrigin`.
	   * Only available in Path and Image element,
	   * where the text is called as `RectText`.
	   */
	  textRotation: 0,
	
	  /**
	   * Text origin of text rotation.
	   * Useful in the case like label rotation of circular symbol.
	   * Only available in Path and Image element, where the text is called
	   * as `RectText` and the element is called as "host element".
	   * The value can be:
	   * + If specified as a coordinate like `[10, 40]`, it is the `[x, y]`
	   * base on the left-top corner of the rect of its host element.
	   * + If specified as a string `center`, it is the center of the rect of
	   * its host element.
	   * + By default, this origin is the `textPosition`.
	   * @type {string|Array.<number>}
	   */
	  textOrigin: null,
	
	  /**
	   * @type {string}
	   */
	  textBackgroundColor: null,
	
	  /**
	   * @type {string}
	   */
	  textBorderColor: null,
	
	  /**
	   * @type {number}
	   */
	  textBorderWidth: 0,
	
	  /**
	   * @type {number}
	   */
	  textBorderRadius: 0,
	
	  /**
	   * Can be `2` or `[2, 4]` or `[2, 3, 4, 5]`
	   * @type {number|Array.<number>}
	   */
	  textPadding: null,
	
	  /**
	   * Text styles for rich text.
	   * @type {Object}
	   */
	  rich: null,
	
	  /**
	   * {outerWidth, outerHeight, ellipsis, placeholder}
	   * @type {Object}
	   */
	  truncate: null,
	
	  /**
	   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	   * @type {string}
	   */
	  blend: null,
	
	  /**
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  bind: function (ctx, el, prevEl) {
	    var style = this;
	    var prevStyle = prevEl && prevEl.style; // If no prevStyle, it means first draw.
	    // Only apply cache if the last time cachced by this function.
	
	    var notCheckCache = !prevStyle || ctx.__attrCachedBy !== ContextCachedBy.STYLE_BIND;
	    ctx.__attrCachedBy = ContextCachedBy.STYLE_BIND;
	
	    for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
	      var prop = STYLE_COMMON_PROPS[i];
	      var styleName = prop[0];
	
	      if (notCheckCache || style[styleName] !== prevStyle[styleName]) {
	        // FIXME Invalid property value will cause style leak from previous element.
	        ctx[styleName] = fixShadow(ctx, styleName, style[styleName] || prop[1]);
	      }
	    }
	
	    if (notCheckCache || style.fill !== prevStyle.fill) {
	      ctx.fillStyle = style.fill;
	    }
	
	    if (notCheckCache || style.stroke !== prevStyle.stroke) {
	      ctx.strokeStyle = style.stroke;
	    }
	
	    if (notCheckCache || style.opacity !== prevStyle.opacity) {
	      ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
	    }
	
	    if (notCheckCache || style.blend !== prevStyle.blend) {
	      ctx.globalCompositeOperation = style.blend || 'source-over';
	    }
	
	    if (this.hasStroke()) {
	      var lineWidth = style.lineWidth;
	      ctx.lineWidth = lineWidth / (this.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
	    }
	  },
	  hasFill: function () {
	    var fill = this.fill;
	    return fill != null && fill !== 'none';
	  },
	  hasStroke: function () {
	    var stroke = this.stroke;
	    return stroke != null && stroke !== 'none' && this.lineWidth > 0;
	  },
	
	  /**
	   * Extend from other style
	   * @param {zrender/graphic/Style} otherStyle
	   * @param {boolean} overwrite true: overwrirte any way.
	   *                            false: overwrite only when !target.hasOwnProperty
	   *                            others: overwrite when property is not null/undefined.
	   */
	  extendFrom: function (otherStyle, overwrite) {
	    if (otherStyle) {
	      for (var name in otherStyle) {
	        if (otherStyle.hasOwnProperty(name) && (overwrite === true || (overwrite === false ? !this.hasOwnProperty(name) : otherStyle[name] != null))) {
	          this[name] = otherStyle[name];
	        }
	      }
	    }
	  },
	
	  /**
	   * Batch setting style with a given object
	   * @param {Object|string} obj
	   * @param {*} [obj]
	   */
	  set: function (obj, value) {
	    if (typeof obj === 'string') {
	      this[obj] = value;
	    } else {
	      this.extendFrom(obj, true);
	    }
	  },
	
	  /**
	   * Clone
	   * @return {zrender/graphic/Style} [description]
	   */
	  clone: function () {
	    var newStyle = new this.constructor();
	    newStyle.extendFrom(this, true);
	    return newStyle;
	  },
	  getGradient: function (ctx, obj, rect) {
	    var method = obj.type === 'radial' ? createRadialGradient : createLinearGradient;
	    var canvasGradient = method(ctx, obj, rect);
	    var colorStops = obj.colorStops;
	
	    for (var i = 0; i < colorStops.length; i++) {
	      canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
	    }
	
	    return canvasGradient;
	  }
	};
	var styleProto = Style.prototype;
	
	for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
	  var prop = STYLE_COMMON_PROPS[i];
	
	  if (!(prop[0] in styleProto)) {
	    styleProto[prop[0]] = prop[1];
	  }
	} // Provide for others
	
	
	Style.getGradient = styleProto.getGradient;
	var _default = Style;
	module.exports = _default;

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	var SHADOW_PROPS = {
	  'shadowBlur': 1,
	  'shadowOffsetX': 1,
	  'shadowOffsetY': 1,
	  'textShadowBlur': 1,
	  'textShadowOffsetX': 1,
	  'textShadowOffsetY': 1,
	  'textBoxShadowBlur': 1,
	  'textBoxShadowOffsetX': 1,
	  'textBoxShadowOffsetY': 1
	};
	
	function _default(ctx, propName, value) {
	  if (SHADOW_PROPS.hasOwnProperty(propName)) {
	    return value *= ctx.dpr;
	  }
	
	  return value;
	}
	
	module.exports = _default;

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	var ContextCachedBy = {
	  NONE: 0,
	  STYLE_BIND: 1,
	  PLAIN_TEXT: 2
	}; // Avoid confused with 0/false.
	
	var WILL_BE_RESTORED = 9;
	exports.ContextCachedBy = ContextCachedBy;
	exports.WILL_BE_RESTORED = WILL_BE_RESTORED;

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	var Pattern = function (image, repeat) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {image: ...}`, where this constructor will not be called.
	  this.image = image;
	  this.repeat = repeat; // Can be cloned
	
	  this.type = 'pattern';
	};
	
	Pattern.prototype.getCanvasPattern = function (ctx) {
	  return ctx.createPattern(this.image, this.repeat || 'repeat');
	};
	
	var _default = Pattern;
	module.exports = _default;

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	var _default = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || // https://github.com/ecomfe/zrender/issues/189#issuecomment-224919809
	window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function (func) {
	  setTimeout(func, 16);
	};
	
	module.exports = _default;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(252);
	
	var BoundingRect = __webpack_require__(242);
	
	var zrUtil = __webpack_require__(220);
	
	var imageHelper = __webpack_require__(256);
	
	/**
	 * @alias zrender/graphic/Image
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	function ZImage(opts) {
	  Displayable.call(this, opts);
	}
	
	ZImage.prototype = {
	  constructor: ZImage,
	  type: 'image',
	  brush: function (ctx, prevEl) {
	    var style = this.style;
	    var src = style.image; // Must bind each time
	
	    style.bind(ctx, this, prevEl);
	    var image = this._image = imageHelper.createOrUpdateImage(src, this._image, this, this.onload);
	
	    if (!image || !imageHelper.isImageReady(image)) {
	      return;
	    } // 图片已经加载完成
	    // if (image.nodeName.toUpperCase() == 'IMG') {
	    //     if (!image.complete) {
	    //         return;
	    //     }
	    // }
	    // Else is canvas
	
	
	    var x = style.x || 0;
	    var y = style.y || 0;
	    var width = style.width;
	    var height = style.height;
	    var aspect = image.width / image.height;
	
	    if (width == null && height != null) {
	      // Keep image/height ratio
	      width = height * aspect;
	    } else if (height == null && width != null) {
	      height = width / aspect;
	    } else if (width == null && height == null) {
	      width = image.width;
	      height = image.height;
	    } // 设置transform
	
	
	    this.setTransform(ctx);
	
	    if (style.sWidth && style.sHeight) {
	      var sx = style.sx || 0;
	      var sy = style.sy || 0;
	      ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
	    } else if (style.sx && style.sy) {
	      var sx = style.sx;
	      var sy = style.sy;
	      var sWidth = width - sx;
	      var sHeight = height - sy;
	      ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
	    } else {
	      ctx.drawImage(image, x, y, width, height);
	    } // Draw rect text
	
	
	    if (style.text != null) {
	      // Only restore transform when needs draw text.
	      this.restoreTransform(ctx);
	      this.drawRectText(ctx, this.getBoundingRect());
	    }
	  },
	  getBoundingRect: function () {
	    var style = this.style;
	
	    if (!this._rect) {
	      this._rect = new BoundingRect(style.x || 0, style.y || 0, style.width || 0, style.height || 0);
	    }
	
	    return this._rect;
	  }
	};
	zrUtil.inherits(ZImage, Displayable);
	var _default = ZImage;
	module.exports = _default;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(220);
	
	var Style = __webpack_require__(246);
	
	var Element = __webpack_require__(231);
	
	var RectText = __webpack_require__(253);
	
	/**
	 * Base class of all displayable graphic objects
	 * @module zrender/graphic/Displayable
	 */
	
	/**
	 * @alias module:zrender/graphic/Displayable
	 * @extends module:zrender/Element
	 * @extends module:zrender/graphic/mixin/RectText
	 */
	function Displayable(opts) {
	  opts = opts || {};
	  Element.call(this, opts); // Extend properties
	
	  for (var name in opts) {
	    if (opts.hasOwnProperty(name) && name !== 'style') {
	      this[name] = opts[name];
	    }
	  }
	  /**
	   * @type {module:zrender/graphic/Style}
	   */
	
	
	  this.style = new Style(opts.style, this);
	  this._rect = null; // Shapes for cascade clipping.
	  // Can only be `null`/`undefined` or an non-empty array, MUST NOT be an empty array.
	  // because it is easy to only using null to check whether clipPaths changed.
	
	  this.__clipPaths = null; // FIXME Stateful must be mixined after style is setted
	  // Stateful.call(this, opts);
	}
	
	Displayable.prototype = {
	  constructor: Displayable,
	  type: 'displayable',
	
	  /**
	   * Dirty flag. From which painter will determine if this displayable object needs brush.
	   * @name module:zrender/graphic/Displayable#__dirty
	   * @type {boolean}
	   */
	  __dirty: true,
	
	  /**
	   * Whether the displayable object is visible. when it is true, the displayable object
	   * is not drawn, but the mouse event can still trigger the object.
	   * @name module:/zrender/graphic/Displayable#invisible
	   * @type {boolean}
	   * @default false
	   */
	  invisible: false,
	
	  /**
	   * @name module:/zrender/graphic/Displayable#z
	   * @type {number}
	   * @default 0
	   */
	  z: 0,
	
	  /**
	   * @name module:/zrender/graphic/Displayable#z
	   * @type {number}
	   * @default 0
	   */
	  z2: 0,
	
	  /**
	   * The z level determines the displayable object can be drawn in which layer canvas.
	   * @name module:/zrender/graphic/Displayable#zlevel
	   * @type {number}
	   * @default 0
	   */
	  zlevel: 0,
	
	  /**
	   * Whether it can be dragged.
	   * @name module:/zrender/graphic/Displayable#draggable
	   * @type {boolean}
	   * @default false
	   */
	  draggable: false,
	
	  /**
	   * Whether is it dragging.
	   * @name module:/zrender/graphic/Displayable#draggable
	   * @type {boolean}
	   * @default false
	   */
	  dragging: false,
	
	  /**
	   * Whether to respond to mouse events.
	   * @name module:/zrender/graphic/Displayable#silent
	   * @type {boolean}
	   * @default false
	   */
	  silent: false,
	
	  /**
	   * If enable culling
	   * @type {boolean}
	   * @default false
	   */
	  culling: false,
	
	  /**
	   * Mouse cursor when hovered
	   * @name module:/zrender/graphic/Displayable#cursor
	   * @type {string}
	   */
	  cursor: 'pointer',
	
	  /**
	   * If hover area is bounding rect
	   * @name module:/zrender/graphic/Displayable#rectHover
	   * @type {string}
	   */
	  rectHover: false,
	
	  /**
	   * Render the element progressively when the value >= 0,
	   * usefull for large data.
	   * @type {boolean}
	   */
	  progressive: false,
	
	  /**
	   * @type {boolean}
	   */
	  incremental: false,
	
	  /**
	   * Scale ratio for global scale.
	   * @type {boolean}
	   */
	  globalScaleRatio: 1,
	  beforeBrush: function (ctx) {},
	  afterBrush: function (ctx) {},
	
	  /**
	   * Graphic drawing method.
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  // Interface
	  brush: function (ctx, prevEl) {},
	
	  /**
	   * Get the minimum bounding box.
	   * @return {module:zrender/core/BoundingRect}
	   */
	  // Interface
	  getBoundingRect: function () {},
	
	  /**
	   * If displayable element contain coord x, y
	   * @param  {number} x
	   * @param  {number} y
	   * @return {boolean}
	   */
	  contain: function (x, y) {
	    return this.rectContain(x, y);
	  },
	
	  /**
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {
	    cb.call(context, this);
	  },
	
	  /**
	   * If bounding rect of element contain coord x, y
	   * @param  {number} x
	   * @param  {number} y
	   * @return {boolean}
	   */
	  rectContain: function (x, y) {
	    var coord = this.transformCoordToLocal(x, y);
	    var rect = this.getBoundingRect();
	    return rect.contain(coord[0], coord[1]);
	  },
	
	  /**
	   * Mark displayable element dirty and refresh next frame
	   */
	  dirty: function () {
	    this.__dirty = this.__dirtyText = true;
	    this._rect = null;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * If displayable object binded any event
	   * @return {boolean}
	   */
	  // TODO, events bound by bind
	  // isSilent: function () {
	  //     return !(
	  //         this.hoverable || this.draggable
	  //         || this.onmousemove || this.onmouseover || this.onmouseout
	  //         || this.onmousedown || this.onmouseup || this.onclick
	  //         || this.ondragenter || this.ondragover || this.ondragleave
	  //         || this.ondrop
	  //     );
	  // },
	
	  /**
	   * Alias for animate('style')
	   * @param {boolean} loop
	   */
	  animateStyle: function (loop) {
	    return this.animate('style', loop);
	  },
	  attrKV: function (key, value) {
	    if (key !== 'style') {
	      Element.prototype.attrKV.call(this, key, value);
	    } else {
	      this.style.set(value);
	    }
	  },
	
	  /**
	   * @param {Object|string} key
	   * @param {*} value
	   */
	  setStyle: function (key, value) {
	    this.style.set(key, value);
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * Use given style object
	   * @param  {Object} obj
	   */
	  useStyle: function (obj) {
	    this.style = new Style(obj, this);
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * The string value of `textPosition` needs to be calculated to a real postion.
	   * For example, `'inside'` is calculated to `[rect.width/2, rect.height/2]`
	   * by default. See `contain/text.js#calculateTextPosition` for more details.
	   * But some coutom shapes like "pin", "flag" have center that is not exactly
	   * `[width/2, height/2]`. So we provide this hook to customize the calculation
	   * for those shapes. It will be called if the `style.textPosition` is a string.
	   * @param {Obejct} [out] Prepared out object. If not provided, this method should
	   *        be responsible for creating one.
	   * @param {module:zrender/graphic/Style} style
	   * @param {Object} rect {x, y, width, height}
	   * @return {Obejct} out The same as the input out.
	   *         {
	   *             x: number. mandatory.
	   *             y: number. mandatory.
	   *             textAlign: string. optional. use style.textAlign by default.
	   *             textVerticalAlign: string. optional. use style.textVerticalAlign by default.
	   *         }
	   */
	  calculateTextPosition: null
	};
	zrUtil.inherits(Displayable, Element);
	zrUtil.mixin(Displayable, RectText); // zrUtil.mixin(Displayable, Stateful);
	
	var _default = Displayable;
	module.exports = _default;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var textHelper = __webpack_require__(254);
	
	var BoundingRect = __webpack_require__(242);
	
	var _constant = __webpack_require__(248);
	
	var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;
	
	/**
	 * Mixin for drawing text in a element bounding rect
	 * @module zrender/mixin/RectText
	 */
	var tmpRect = new BoundingRect();
	
	var RectText = function () {};
	
	RectText.prototype = {
	  constructor: RectText,
	
	  /**
	   * Draw text in a rect with specified position.
	   * @param  {CanvasRenderingContext2D} ctx
	   * @param  {Object} rect Displayable rect
	   */
	  drawRectText: function (ctx, rect) {
	    var style = this.style;
	    rect = style.textRect || rect; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	    var text = style.text; // Convert to string
	
	    text != null && (text += '');
	
	    if (!textHelper.needDrawText(text, style)) {
	      return;
	    } // FIXME
	    // Do not provide prevEl to `textHelper.renderText` for ctx prop cache,
	    // but use `ctx.save()` and `ctx.restore()`. Because the cache for rect
	    // text propably break the cache for its host elements.
	
	
	    ctx.save(); // Transform rect to view space
	
	    var transform = this.transform;
	
	    if (!style.transformText) {
	      if (transform) {
	        tmpRect.copy(rect);
	        tmpRect.applyTransform(transform);
	        rect = tmpRect;
	      }
	    } else {
	      this.setTransform(ctx);
	    } // transformText and textRotation can not be used at the same time.
	
	
	    textHelper.renderText(this, ctx, text, style, rect, WILL_BE_RESTORED);
	    ctx.restore();
	  }
	};
	var _default = RectText;
	module.exports = _default;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(220);
	
	var retrieve2 = _util.retrieve2;
	var retrieve3 = _util.retrieve3;
	var each = _util.each;
	var normalizeCssArray = _util.normalizeCssArray;
	var isString = _util.isString;
	var isObject = _util.isObject;
	
	var textContain = __webpack_require__(255);
	
	var roundRectHelper = __webpack_require__(257);
	
	var imageHelper = __webpack_require__(256);
	
	var fixShadow = __webpack_require__(247);
	
	var _constant = __webpack_require__(248);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;
	var DEFAULT_FONT = textContain.DEFAULT_FONT; // TODO: Have not support 'start', 'end' yet.
	
	var VALID_TEXT_ALIGN = {
	  left: 1,
	  right: 1,
	  center: 1
	};
	var VALID_TEXT_VERTICAL_ALIGN = {
	  top: 1,
	  bottom: 1,
	  middle: 1
	}; // Different from `STYLE_COMMON_PROPS` of `graphic/Style`,
	// the default value of shadowColor is `'transparent'`.
	
	var SHADOW_STYLE_COMMON_PROPS = [['textShadowBlur', 'shadowBlur', 0], ['textShadowOffsetX', 'shadowOffsetX', 0], ['textShadowOffsetY', 'shadowOffsetY', 0], ['textShadowColor', 'shadowColor', 'transparent']];
	var _tmpTextPositionResult = {};
	var _tmpBoxPositionResult = {};
	/**
	 * @param {module:zrender/graphic/Style} style
	 * @return {module:zrender/graphic/Style} The input style.
	 */
	
	function normalizeTextStyle(style) {
	  normalizeStyle(style);
	  each(style.rich, normalizeStyle);
	  return style;
	}
	
	function normalizeStyle(style) {
	  if (style) {
	    style.font = textContain.makeFont(style);
	    var textAlign = style.textAlign;
	    textAlign === 'middle' && (textAlign = 'center');
	    style.textAlign = textAlign == null || VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left'; // Compatible with textBaseline.
	
	    var textVerticalAlign = style.textVerticalAlign || style.textBaseline;
	    textVerticalAlign === 'center' && (textVerticalAlign = 'middle');
	    style.textVerticalAlign = textVerticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[textVerticalAlign] ? textVerticalAlign : 'top';
	    var textPadding = style.textPadding;
	
	    if (textPadding) {
	      style.textPadding = normalizeCssArray(style.textPadding);
	    }
	  }
	}
	/**
	 * @param {CanvasRenderingContext2D} ctx
	 * @param {string} text
	 * @param {module:zrender/graphic/Style} style
	 * @param {Object|boolean} [rect] {x, y, width, height}
	 *                  If set false, rect text is not used.
	 * @param {Element|module:zrender/graphic/helper/constant.WILL_BE_RESTORED} [prevEl] For ctx prop cache.
	 */
	
	
	function renderText(hostEl, ctx, text, style, rect, prevEl) {
	  style.rich ? renderRichText(hostEl, ctx, text, style, rect, prevEl) : renderPlainText(hostEl, ctx, text, style, rect, prevEl);
	} // Avoid setting to ctx according to prevEl if possible for
	// performance in scenarios of large amount text.
	
	
	function renderPlainText(hostEl, ctx, text, style, rect, prevEl) {
	  'use strict';
	
	  var needDrawBg = needDrawBackground(style);
	  var prevStyle;
	  var checkCache = false;
	  var cachedByMe = ctx.__attrCachedBy === ContextCachedBy.PLAIN_TEXT; // Only take and check cache for `Text` el, but not RectText.
	
	  if (prevEl !== WILL_BE_RESTORED) {
	    if (prevEl) {
	      prevStyle = prevEl.style;
	      checkCache = !needDrawBg && cachedByMe && prevStyle;
	    } // Prevent from using cache in `Style::bind`, because of the case:
	    // ctx property is modified by other properties than `Style::bind`
	    // used, and Style::bind is called next.
	
	
	    ctx.__attrCachedBy = needDrawBg ? ContextCachedBy.NONE : ContextCachedBy.PLAIN_TEXT;
	  } // Since this will be restored, prevent from using these props to check cache in the next
	  // entering of this method. But do not need to clear other cache like `Style::bind`.
	  else if (cachedByMe) {
	      ctx.__attrCachedBy = ContextCachedBy.NONE;
	    }
	
	  var styleFont = style.font || DEFAULT_FONT; // PENDING
	  // Only `Text` el set `font` and keep it (`RectText` will restore). So theoretically
	  // we can make font cache on ctx, which can cache for text el that are discontinuous.
	  // But layer save/restore needed to be considered.
	  // if (styleFont !== ctx.__fontCache) {
	  //     ctx.font = styleFont;
	  //     if (prevEl !== WILL_BE_RESTORED) {
	  //         ctx.__fontCache = styleFont;
	  //     }
	  // }
	
	  if (!checkCache || styleFont !== (prevStyle.font || DEFAULT_FONT)) {
	    ctx.font = styleFont;
	  } // Use the final font from context-2d, because the final
	  // font might not be the style.font when it is illegal.
	  // But get `ctx.font` might be time consuming.
	
	
	  var computedFont = hostEl.__computedFont;
	
	  if (hostEl.__styleFont !== styleFont) {
	    hostEl.__styleFont = styleFont;
	    computedFont = hostEl.__computedFont = ctx.font;
	  }
	
	  var textPadding = style.textPadding;
	  var textLineHeight = style.textLineHeight;
	  var contentBlock = hostEl.__textCotentBlock;
	
	  if (!contentBlock || hostEl.__dirtyText) {
	    contentBlock = hostEl.__textCotentBlock = textContain.parsePlainText(text, computedFont, textPadding, textLineHeight, style.truncate);
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var textLines = contentBlock.lines;
	  var lineHeight = contentBlock.lineHeight;
	  var boxPos = getBoxPosition(_tmpBoxPositionResult, hostEl, style, rect);
	  var baseX = boxPos.baseX;
	  var baseY = boxPos.baseY;
	  var textAlign = boxPos.textAlign || 'left';
	  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
	
	  applyTextRotation(ctx, style, rect, baseX, baseY);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var textX = baseX;
	  var textY = boxY;
	
	  if (needDrawBg || textPadding) {
	    // Consider performance, do not call getTextWidth util necessary.
	    var textWidth = textContain.getWidth(text, computedFont);
	    var outerWidth = textWidth;
	    textPadding && (outerWidth += textPadding[1] + textPadding[3]);
	    var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
	    needDrawBg && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
	
	    if (textPadding) {
	      textX = getTextXForPadding(baseX, textAlign, textPadding);
	      textY += textPadding[0];
	    }
	  } // Always set textAlign and textBase line, because it is difficute to calculate
	  // textAlign from prevEl, and we dont sure whether textAlign will be reset if
	  // font set happened.
	
	
	  ctx.textAlign = textAlign; // Force baseline to be "middle". Otherwise, if using "top", the
	  // text will offset downward a little bit in font "Microsoft YaHei".
	
	  ctx.textBaseline = 'middle'; // Set text opacity
	
	  ctx.globalAlpha = style.opacity || 1; // Always set shadowBlur and shadowOffset to avoid leak from displayable.
	
	  for (var i = 0; i < SHADOW_STYLE_COMMON_PROPS.length; i++) {
	    var propItem = SHADOW_STYLE_COMMON_PROPS[i];
	    var styleProp = propItem[0];
	    var ctxProp = propItem[1];
	    var val = style[styleProp];
	
	    if (!checkCache || val !== prevStyle[styleProp]) {
	      ctx[ctxProp] = fixShadow(ctx, ctxProp, val || propItem[2]);
	    }
	  } // `textBaseline` is set as 'middle'.
	
	
	  textY += lineHeight / 2;
	  var textStrokeWidth = style.textStrokeWidth;
	  var textStrokeWidthPrev = checkCache ? prevStyle.textStrokeWidth : null;
	  var strokeWidthChanged = !checkCache || textStrokeWidth !== textStrokeWidthPrev;
	  var strokeChanged = !checkCache || strokeWidthChanged || style.textStroke !== prevStyle.textStroke;
	  var textStroke = getStroke(style.textStroke, textStrokeWidth);
	  var textFill = getFill(style.textFill);
	
	  if (textStroke) {
	    if (strokeWidthChanged) {
	      ctx.lineWidth = textStrokeWidth;
	    }
	
	    if (strokeChanged) {
	      ctx.strokeStyle = textStroke;
	    }
	  }
	
	  if (textFill) {
	    if (!checkCache || style.textFill !== prevStyle.textFill) {
	      ctx.fillStyle = textFill;
	    }
	  } // Optimize simply, in most cases only one line exists.
	
	
	  if (textLines.length === 1) {
	    // Fill after stroke so the outline will not cover the main part.
	    textStroke && ctx.strokeText(textLines[0], textX, textY);
	    textFill && ctx.fillText(textLines[0], textX, textY);
	  } else {
	    for (var i = 0; i < textLines.length; i++) {
	      // Fill after stroke so the outline will not cover the main part.
	      textStroke && ctx.strokeText(textLines[i], textX, textY);
	      textFill && ctx.fillText(textLines[i], textX, textY);
	      textY += lineHeight;
	    }
	  }
	}
	
	function renderRichText(hostEl, ctx, text, style, rect, prevEl) {
	  // Do not do cache for rich text because of the complexity.
	  // But `RectText` this will be restored, do not need to clear other cache like `Style::bind`.
	  if (prevEl !== WILL_BE_RESTORED) {
	    ctx.__attrCachedBy = ContextCachedBy.NONE;
	  }
	
	  var contentBlock = hostEl.__textCotentBlock;
	
	  if (!contentBlock || hostEl.__dirtyText) {
	    contentBlock = hostEl.__textCotentBlock = textContain.parseRichText(text, style);
	  }
	
	  drawRichText(hostEl, ctx, contentBlock, style, rect);
	}
	
	function drawRichText(hostEl, ctx, contentBlock, style, rect) {
	  var contentWidth = contentBlock.width;
	  var outerWidth = contentBlock.outerWidth;
	  var outerHeight = contentBlock.outerHeight;
	  var textPadding = style.textPadding;
	  var boxPos = getBoxPosition(_tmpBoxPositionResult, hostEl, style, rect);
	  var baseX = boxPos.baseX;
	  var baseY = boxPos.baseY;
	  var textAlign = boxPos.textAlign;
	  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
	
	  applyTextRotation(ctx, style, rect, baseX, baseY);
	  var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var xLeft = boxX;
	  var lineTop = boxY;
	
	  if (textPadding) {
	    xLeft += textPadding[3];
	    lineTop += textPadding[0];
	  }
	
	  var xRight = xLeft + contentWidth;
	  needDrawBackground(style) && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
	
	  for (var i = 0; i < contentBlock.lines.length; i++) {
	    var line = contentBlock.lines[i];
	    var tokens = line.tokens;
	    var tokenCount = tokens.length;
	    var lineHeight = line.lineHeight;
	    var usedWidth = line.width;
	    var leftIndex = 0;
	    var lineXLeft = xLeft;
	    var lineXRight = xRight;
	    var rightIndex = tokenCount - 1;
	    var token;
	
	    while (leftIndex < tokenCount && (token = tokens[leftIndex], !token.textAlign || token.textAlign === 'left')) {
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft, 'left');
	      usedWidth -= token.width;
	      lineXLeft += token.width;
	      leftIndex++;
	    }
	
	    while (rightIndex >= 0 && (token = tokens[rightIndex], token.textAlign === 'right')) {
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXRight, 'right');
	      usedWidth -= token.width;
	      lineXRight -= token.width;
	      rightIndex--;
	    } // The other tokens are placed as textAlign 'center' if there is enough space.
	
	
	    lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - usedWidth) / 2;
	
	    while (leftIndex <= rightIndex) {
	      token = tokens[leftIndex]; // Consider width specified by user, use 'center' rather than 'left'.
	
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center');
	      lineXLeft += token.width;
	      leftIndex++;
	    }
	
	    lineTop += lineHeight;
	  }
	}
	
	function applyTextRotation(ctx, style, rect, x, y) {
	  // textRotation only apply in RectText.
	  if (rect && style.textRotation) {
	    var origin = style.textOrigin;
	
	    if (origin === 'center') {
	      x = rect.width / 2 + rect.x;
	      y = rect.height / 2 + rect.y;
	    } else if (origin) {
	      x = origin[0] + rect.x;
	      y = origin[1] + rect.y;
	    }
	
	    ctx.translate(x, y); // Positive: anticlockwise
	
	    ctx.rotate(-style.textRotation);
	    ctx.translate(-x, -y);
	  }
	}
	
	function placeToken(hostEl, ctx, token, style, lineHeight, lineTop, x, textAlign) {
	  var tokenStyle = style.rich[token.styleName] || {};
	  tokenStyle.text = token.text; // 'ctx.textBaseline' is always set as 'middle', for sake of
	  // the bias of "Microsoft YaHei".
	
	  var textVerticalAlign = token.textVerticalAlign;
	  var y = lineTop + lineHeight / 2;
	
	  if (textVerticalAlign === 'top') {
	    y = lineTop + token.height / 2;
	  } else if (textVerticalAlign === 'bottom') {
	    y = lineTop + lineHeight - token.height / 2;
	  }
	
	  !token.isLineHolder && needDrawBackground(tokenStyle) && drawBackground(hostEl, ctx, tokenStyle, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
	  var textPadding = token.textPadding;
	
	  if (textPadding) {
	    x = getTextXForPadding(x, textAlign, textPadding);
	    y -= token.height / 2 - textPadding[2] - token.textHeight / 2;
	  }
	
	  setCtx(ctx, 'shadowBlur', retrieve3(tokenStyle.textShadowBlur, style.textShadowBlur, 0));
	  setCtx(ctx, 'shadowColor', tokenStyle.textShadowColor || style.textShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', retrieve3(tokenStyle.textShadowOffsetX, style.textShadowOffsetX, 0));
	  setCtx(ctx, 'shadowOffsetY', retrieve3(tokenStyle.textShadowOffsetY, style.textShadowOffsetY, 0));
	  setCtx(ctx, 'textAlign', textAlign); // Force baseline to be "middle". Otherwise, if using "top", the
	  // text will offset downward a little bit in font "Microsoft YaHei".
	
	  setCtx(ctx, 'textBaseline', 'middle');
	  setCtx(ctx, 'font', token.font || DEFAULT_FONT);
	  var textStroke = getStroke(tokenStyle.textStroke || style.textStroke, textStrokeWidth);
	  var textFill = getFill(tokenStyle.textFill || style.textFill);
	  var textStrokeWidth = retrieve2(tokenStyle.textStrokeWidth, style.textStrokeWidth); // Fill after stroke so the outline will not cover the main part.
	
	  if (textStroke) {
	    setCtx(ctx, 'lineWidth', textStrokeWidth);
	    setCtx(ctx, 'strokeStyle', textStroke);
	    ctx.strokeText(token.text, x, y);
	  }
	
	  if (textFill) {
	    setCtx(ctx, 'fillStyle', textFill);
	    ctx.fillText(token.text, x, y);
	  }
	}
	
	function needDrawBackground(style) {
	  return !!(style.textBackgroundColor || style.textBorderWidth && style.textBorderColor);
	} // style: {textBackgroundColor, textBorderWidth, textBorderColor, textBorderRadius, text}
	// shape: {x, y, width, height}
	
	
	function drawBackground(hostEl, ctx, style, x, y, width, height) {
	  var textBackgroundColor = style.textBackgroundColor;
	  var textBorderWidth = style.textBorderWidth;
	  var textBorderColor = style.textBorderColor;
	  var isPlainBg = isString(textBackgroundColor);
	  setCtx(ctx, 'shadowBlur', style.textBoxShadowBlur || 0);
	  setCtx(ctx, 'shadowColor', style.textBoxShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', style.textBoxShadowOffsetX || 0);
	  setCtx(ctx, 'shadowOffsetY', style.textBoxShadowOffsetY || 0);
	
	  if (isPlainBg || textBorderWidth && textBorderColor) {
	    ctx.beginPath();
	    var textBorderRadius = style.textBorderRadius;
	
	    if (!textBorderRadius) {
	      ctx.rect(x, y, width, height);
	    } else {
	      roundRectHelper.buildPath(ctx, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        r: textBorderRadius
	      });
	    }
	
	    ctx.closePath();
	  }
	
	  if (isPlainBg) {
	    setCtx(ctx, 'fillStyle', textBackgroundColor);
	
	    if (style.fillOpacity != null) {
	      var originalGlobalAlpha = ctx.globalAlpha;
	      ctx.globalAlpha = style.fillOpacity * style.opacity;
	      ctx.fill();
	      ctx.globalAlpha = originalGlobalAlpha;
	    } else {
	      ctx.fill();
	    }
	  } else if (isObject(textBackgroundColor)) {
	    var image = textBackgroundColor.image;
	    image = imageHelper.createOrUpdateImage(image, null, hostEl, onBgImageLoaded, textBackgroundColor);
	
	    if (image && imageHelper.isImageReady(image)) {
	      ctx.drawImage(image, x, y, width, height);
	    }
	  }
	
	  if (textBorderWidth && textBorderColor) {
	    setCtx(ctx, 'lineWidth', textBorderWidth);
	    setCtx(ctx, 'strokeStyle', textBorderColor);
	
	    if (style.strokeOpacity != null) {
	      var originalGlobalAlpha = ctx.globalAlpha;
	      ctx.globalAlpha = style.strokeOpacity * style.opacity;
	      ctx.stroke();
	      ctx.globalAlpha = originalGlobalAlpha;
	    } else {
	      ctx.stroke();
	    }
	  }
	}
	
	function onBgImageLoaded(image, textBackgroundColor) {
	  // Replace image, so that `contain/text.js#parseRichText`
	  // will get correct result in next tick.
	  textBackgroundColor.image = image;
	}
	
	function getBoxPosition(out, hostEl, style, rect) {
	  var baseX = style.x || 0;
	  var baseY = style.y || 0;
	  var textAlign = style.textAlign;
	  var textVerticalAlign = style.textVerticalAlign; // Text position represented by coord
	
	  if (rect) {
	    var textPosition = style.textPosition;
	
	    if (textPosition instanceof Array) {
	      // Percent
	      baseX = rect.x + parsePercent(textPosition[0], rect.width);
	      baseY = rect.y + parsePercent(textPosition[1], rect.height);
	    } else {
	      var res = hostEl && hostEl.calculateTextPosition ? hostEl.calculateTextPosition(_tmpTextPositionResult, style, rect) : textContain.calculateTextPosition(_tmpTextPositionResult, style, rect);
	      baseX = res.x;
	      baseY = res.y; // Default align and baseline when has textPosition
	
	      textAlign = textAlign || res.textAlign;
	      textVerticalAlign = textVerticalAlign || res.textVerticalAlign;
	    } // textOffset is only support in RectText, otherwise
	    // we have to adjust boundingRect for textOffset.
	
	
	    var textOffset = style.textOffset;
	
	    if (textOffset) {
	      baseX += textOffset[0];
	      baseY += textOffset[1];
	    }
	  }
	
	  out = out || {};
	  out.baseX = baseX;
	  out.baseY = baseY;
	  out.textAlign = textAlign;
	  out.textVerticalAlign = textVerticalAlign;
	  return out;
	}
	
	function setCtx(ctx, prop, value) {
	  ctx[prop] = fixShadow(ctx, prop, value);
	  return ctx[prop];
	}
	/**
	 * @param {string} [stroke] If specified, do not check style.textStroke.
	 * @param {string} [lineWidth] If specified, do not check style.textStroke.
	 * @param {number} style
	 */
	
	
	function getStroke(stroke, lineWidth) {
	  return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null // TODO pattern and gradient?
	  : stroke.image || stroke.colorStops ? '#000' : stroke;
	}
	
	function getFill(fill) {
	  return fill == null || fill === 'none' ? null // TODO pattern and gradient?
	  : fill.image || fill.colorStops ? '#000' : fill;
	}
	
	function parsePercent(value, maxValue) {
	  if (typeof value === 'string') {
	    if (value.lastIndexOf('%') >= 0) {
	      return parseFloat(value) / 100 * maxValue;
	    }
	
	    return parseFloat(value);
	  }
	
	  return value;
	}
	
	function getTextXForPadding(x, textAlign, textPadding) {
	  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
	}
	/**
	 * @param {string} text
	 * @param {module:zrender/Style} style
	 * @return {boolean}
	 */
	
	
	function needDrawText(text, style) {
	  return text != null && (text || style.textBackgroundColor || style.textBorderWidth && style.textBorderColor || style.textPadding);
	}
	
	exports.normalizeTextStyle = normalizeTextStyle;
	exports.renderText = renderText;
	exports.getBoxPosition = getBoxPosition;
	exports.getStroke = getStroke;
	exports.getFill = getFill;
	exports.parsePercent = parsePercent;
	exports.needDrawText = needDrawText;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var BoundingRect = __webpack_require__(242);
	
	var imageHelper = __webpack_require__(256);
	
	var _util = __webpack_require__(220);
	
	var getContext = _util.getContext;
	var extend = _util.extend;
	var retrieve2 = _util.retrieve2;
	var retrieve3 = _util.retrieve3;
	var trim = _util.trim;
	var textWidthCache = {};
	var textWidthCacheCounter = 0;
	var TEXT_CACHE_MAX = 5000;
	var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
	var DEFAULT_FONT = '12px sans-serif'; // Avoid assign to an exported variable, for transforming to cjs.
	
	var methods = {};
	
	function $override(name, fn) {
	  methods[name] = fn;
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @return {number} width
	 */
	
	
	function getWidth(text, font) {
	  font = font || DEFAULT_FONT;
	  var key = text + ':' + font;
	
	  if (textWidthCache[key]) {
	    return textWidthCache[key];
	  }
	
	  var textLines = (text + '').split('\n');
	  var width = 0;
	
	  for (var i = 0, l = textLines.length; i < l; i++) {
	    // textContain.measureText may be overrided in SVG or VML
	    width = Math.max(measureText(textLines[i], font).width, width);
	  }
	
	  if (textWidthCacheCounter > TEXT_CACHE_MAX) {
	    textWidthCacheCounter = 0;
	    textWidthCache = {};
	  }
	
	  textWidthCacheCounter++;
	  textWidthCache[key] = width;
	  return width;
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @param {string} [textAlign='left']
	 * @param {string} [textVerticalAlign='top']
	 * @param {Array.<number>} [textPadding]
	 * @param {Object} [rich]
	 * @param {Object} [truncate]
	 * @return {Object} {x, y, width, height, lineHeight}
	 */
	
	
	function getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
	  return rich ? getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) : getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate);
	}
	
	function getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate) {
	  var contentBlock = parsePlainText(text, font, textPadding, textLineHeight, truncate);
	  var outerWidth = getWidth(text, font);
	
	  if (textPadding) {
	    outerWidth += textPadding[1] + textPadding[3];
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var x = adjustTextX(0, outerWidth, textAlign);
	  var y = adjustTextY(0, outerHeight, textVerticalAlign);
	  var rect = new BoundingRect(x, y, outerWidth, outerHeight);
	  rect.lineHeight = contentBlock.lineHeight;
	  return rect;
	}
	
	function getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
	  var contentBlock = parseRichText(text, {
	    rich: rich,
	    truncate: truncate,
	    font: font,
	    textAlign: textAlign,
	    textPadding: textPadding,
	    textLineHeight: textLineHeight
	  });
	  var outerWidth = contentBlock.outerWidth;
	  var outerHeight = contentBlock.outerHeight;
	  var x = adjustTextX(0, outerWidth, textAlign);
	  var y = adjustTextY(0, outerHeight, textVerticalAlign);
	  return new BoundingRect(x, y, outerWidth, outerHeight);
	}
	/**
	 * @public
	 * @param {number} x
	 * @param {number} width
	 * @param {string} [textAlign='left']
	 * @return {number} Adjusted x.
	 */
	
	
	function adjustTextX(x, width, textAlign) {
	  // FIXME Right to left language
	  if (textAlign === 'right') {
	    x -= width;
	  } else if (textAlign === 'center') {
	    x -= width / 2;
	  }
	
	  return x;
	}
	/**
	 * @public
	 * @param {number} y
	 * @param {number} height
	 * @param {string} [textVerticalAlign='top']
	 * @return {number} Adjusted y.
	 */
	
	
	function adjustTextY(y, height, textVerticalAlign) {
	  if (textVerticalAlign === 'middle') {
	    y -= height / 2;
	  } else if (textVerticalAlign === 'bottom') {
	    y -= height;
	  }
	
	  return y;
	}
	/**
	 * Follow same interface to `Displayable.prototype.calculateTextPosition`.
	 * @public
	 * @param {Obejct} [out] Prepared out object. If not input, auto created in the method.
	 * @param {module:zrender/graphic/Style} style where `textPosition` and `textDistance` are visited.
	 * @param {Object} rect {x, y, width, height} Rect of the host elment, according to which the text positioned.
	 * @return {Object} The input `out`. Set: {x, y, textAlign, textVerticalAlign}
	 */
	
	
	function calculateTextPosition(out, style, rect) {
	  var textPosition = style.textPosition;
	  var distance = style.textDistance;
	  var x = rect.x;
	  var y = rect.y;
	  distance = distance || 0;
	  var height = rect.height;
	  var width = rect.width;
	  var halfHeight = height / 2;
	  var textAlign = 'left';
	  var textVerticalAlign = 'top';
	
	  switch (textPosition) {
	    case 'left':
	      x -= distance;
	      y += halfHeight;
	      textAlign = 'right';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'right':
	      x += distance + width;
	      y += halfHeight;
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'top':
	      x += width / 2;
	      y -= distance;
	      textAlign = 'center';
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'bottom':
	      x += width / 2;
	      y += height + distance;
	      textAlign = 'center';
	      break;
	
	    case 'inside':
	      x += width / 2;
	      y += halfHeight;
	      textAlign = 'center';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideLeft':
	      x += distance;
	      y += halfHeight;
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideRight':
	      x += width - distance;
	      y += halfHeight;
	      textAlign = 'right';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideTop':
	      x += width / 2;
	      y += distance;
	      textAlign = 'center';
	      break;
	
	    case 'insideBottom':
	      x += width / 2;
	      y += height - distance;
	      textAlign = 'center';
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'insideTopLeft':
	      x += distance;
	      y += distance;
	      break;
	
	    case 'insideTopRight':
	      x += width - distance;
	      y += distance;
	      textAlign = 'right';
	      break;
	
	    case 'insideBottomLeft':
	      x += distance;
	      y += height - distance;
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'insideBottomRight':
	      x += width - distance;
	      y += height - distance;
	      textAlign = 'right';
	      textVerticalAlign = 'bottom';
	      break;
	  }
	
	  out = out || {};
	  out.x = x;
	  out.y = y;
	  out.textAlign = textAlign;
	  out.textVerticalAlign = textVerticalAlign;
	  return out;
	}
	/**
	 * To be removed. But still do not remove in case that some one has imported it.
	 * @deprecated
	 * @public
	 * @param {stirng} textPosition
	 * @param {Object} rect {x, y, width, height}
	 * @param {number} distance
	 * @return {Object} {x, y, textAlign, textVerticalAlign}
	 */
	
	
	function adjustTextPositionOnRect(textPosition, rect, distance) {
	  var dummyStyle = {
	    textPosition: textPosition,
	    textDistance: distance
	  };
	  return calculateTextPosition({}, dummyStyle, rect);
	}
	/**
	 * Show ellipsis if overflow.
	 *
	 * @public
	 * @param  {string} text
	 * @param  {string} containerWidth
	 * @param  {string} font
	 * @param  {number} [ellipsis='...']
	 * @param  {Object} [options]
	 * @param  {number} [options.maxIterations=3]
	 * @param  {number} [options.minChar=0] If truncate result are less
	 *                  then minChar, ellipsis will not show, which is
	 *                  better for user hint in some cases.
	 * @param  {number} [options.placeholder=''] When all truncated, use the placeholder.
	 * @return {string}
	 */
	
	
	function truncateText(text, containerWidth, font, ellipsis, options) {
	  if (!containerWidth) {
	    return '';
	  }
	
	  var textLines = (text + '').split('\n');
	  options = prepareTruncateOptions(containerWidth, font, ellipsis, options); // FIXME
	  // It is not appropriate that every line has '...' when truncate multiple lines.
	
	  for (var i = 0, len = textLines.length; i < len; i++) {
	    textLines[i] = truncateSingleLine(textLines[i], options);
	  }
	
	  return textLines.join('\n');
	}
	
	function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
	  options = extend({}, options);
	  options.font = font;
	  var ellipsis = retrieve2(ellipsis, '...');
	  options.maxIterations = retrieve2(options.maxIterations, 2);
	  var minChar = options.minChar = retrieve2(options.minChar, 0); // FIXME
	  // Other languages?
	
	  options.cnCharWidth = getWidth('国', font); // FIXME
	  // Consider proportional font?
	
	  var ascCharWidth = options.ascCharWidth = getWidth('a', font);
	  options.placeholder = retrieve2(options.placeholder, ''); // Example 1: minChar: 3, text: 'asdfzxcv', truncate result: 'asdf', but not: 'a...'.
	  // Example 2: minChar: 3, text: '维度', truncate result: '维', but not: '...'.
	
	  var contentWidth = containerWidth = Math.max(0, containerWidth - 1); // Reserve some gap.
	
	  for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
	    contentWidth -= ascCharWidth;
	  }
	
	  var ellipsisWidth = getWidth(ellipsis, font);
	
	  if (ellipsisWidth > contentWidth) {
	    ellipsis = '';
	    ellipsisWidth = 0;
	  }
	
	  contentWidth = containerWidth - ellipsisWidth;
	  options.ellipsis = ellipsis;
	  options.ellipsisWidth = ellipsisWidth;
	  options.contentWidth = contentWidth;
	  options.containerWidth = containerWidth;
	  return options;
	}
	
	function truncateSingleLine(textLine, options) {
	  var containerWidth = options.containerWidth;
	  var font = options.font;
	  var contentWidth = options.contentWidth;
	
	  if (!containerWidth) {
	    return '';
	  }
	
	  var lineWidth = getWidth(textLine, font);
	
	  if (lineWidth <= containerWidth) {
	    return textLine;
	  }
	
	  for (var j = 0;; j++) {
	    if (lineWidth <= contentWidth || j >= options.maxIterations) {
	      textLine += options.ellipsis;
	      break;
	    }
	
	    var subLength = j === 0 ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
	    textLine = textLine.substr(0, subLength);
	    lineWidth = getWidth(textLine, font);
	  }
	
	  if (textLine === '') {
	    textLine = options.placeholder;
	  }
	
	  return textLine;
	}
	
	function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
	  var width = 0;
	  var i = 0;
	
	  for (var len = text.length; i < len && width < contentWidth; i++) {
	    var charCode = text.charCodeAt(i);
	    width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
	  }
	
	  return i;
	}
	/**
	 * @public
	 * @param {string} font
	 * @return {number} line height
	 */
	
	
	function getLineHeight(font) {
	  // FIXME A rough approach.
	  return getWidth('国', font);
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @return {Object} width
	 */
	
	
	function measureText(text, font) {
	  return methods.measureText(text, font);
	} // Avoid assign to an exported variable, for transforming to cjs.
	
	
	methods.measureText = function (text, font) {
	  var ctx = getContext();
	  ctx.font = font || DEFAULT_FONT;
	  return ctx.measureText(text);
	};
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @param {Object} [truncate]
	 * @return {Object} block: {lineHeight, lines, height, outerHeight, canCacheByTextString}
	 *  Notice: for performance, do not calculate outerWidth util needed.
	 *  `canCacheByTextString` means the result `lines` is only determined by the input `text`.
	 *  Thus we can simply comparing the `input` text to determin whether the result changed,
	 *  without travel the result `lines`.
	 */
	
	
	function parsePlainText(text, font, padding, textLineHeight, truncate) {
	  text != null && (text += '');
	  var lineHeight = retrieve2(textLineHeight, getLineHeight(font));
	  var lines = text ? text.split('\n') : [];
	  var height = lines.length * lineHeight;
	  var outerHeight = height;
	  var canCacheByTextString = true;
	
	  if (padding) {
	    outerHeight += padding[0] + padding[2];
	  }
	
	  if (text && truncate) {
	    canCacheByTextString = false;
	    var truncOuterHeight = truncate.outerHeight;
	    var truncOuterWidth = truncate.outerWidth;
	
	    if (truncOuterHeight != null && outerHeight > truncOuterHeight) {
	      text = '';
	      lines = [];
	    } else if (truncOuterWidth != null) {
	      var options = prepareTruncateOptions(truncOuterWidth - (padding ? padding[1] + padding[3] : 0), font, truncate.ellipsis, {
	        minChar: truncate.minChar,
	        placeholder: truncate.placeholder
	      }); // FIXME
	      // It is not appropriate that every line has '...' when truncate multiple lines.
	
	      for (var i = 0, len = lines.length; i < len; i++) {
	        lines[i] = truncateSingleLine(lines[i], options);
	      }
	    }
	  }
	
	  return {
	    lines: lines,
	    height: height,
	    outerHeight: outerHeight,
	    lineHeight: lineHeight,
	    canCacheByTextString: canCacheByTextString
	  };
	}
	/**
	 * For example: 'some text {a|some text}other text{b|some text}xxx{c|}xxx'
	 * Also consider 'bbbb{a|xxx\nzzz}xxxx\naaaa'.
	 *
	 * @public
	 * @param {string} text
	 * @param {Object} style
	 * @return {Object} block
	 * {
	 *      width,
	 *      height,
	 *      lines: [{
	 *          lineHeight,
	 *          width,
	 *          tokens: [[{
	 *              styleName,
	 *              text,
	 *              width,      // include textPadding
	 *              height,     // include textPadding
	 *              textWidth, // pure text width
	 *              textHeight, // pure text height
	 *              lineHeihgt,
	 *              font,
	 *              textAlign,
	 *              textVerticalAlign
	 *          }], [...], ...]
	 *      }, ...]
	 * }
	 * If styleName is undefined, it is plain text.
	 */
	
	
	function parseRichText(text, style) {
	  var contentBlock = {
	    lines: [],
	    width: 0,
	    height: 0
	  };
	  text != null && (text += '');
	
	  if (!text) {
	    return contentBlock;
	  }
	
	  var lastIndex = STYLE_REG.lastIndex = 0;
	  var result;
	
	  while ((result = STYLE_REG.exec(text)) != null) {
	    var matchedIndex = result.index;
	
	    if (matchedIndex > lastIndex) {
	      pushTokens(contentBlock, text.substring(lastIndex, matchedIndex));
	    }
	
	    pushTokens(contentBlock, result[2], result[1]);
	    lastIndex = STYLE_REG.lastIndex;
	  }
	
	  if (lastIndex < text.length) {
	    pushTokens(contentBlock, text.substring(lastIndex, text.length));
	  }
	
	  var lines = contentBlock.lines;
	  var contentHeight = 0;
	  var contentWidth = 0; // For `textWidth: 100%`
	
	  var pendingList = [];
	  var stlPadding = style.textPadding;
	  var truncate = style.truncate;
	  var truncateWidth = truncate && truncate.outerWidth;
	  var truncateHeight = truncate && truncate.outerHeight;
	
	  if (stlPadding) {
	    truncateWidth != null && (truncateWidth -= stlPadding[1] + stlPadding[3]);
	    truncateHeight != null && (truncateHeight -= stlPadding[0] + stlPadding[2]);
	  } // Calculate layout info of tokens.
	
	
	  for (var i = 0; i < lines.length; i++) {
	    var line = lines[i];
	    var lineHeight = 0;
	    var lineWidth = 0;
	
	    for (var j = 0; j < line.tokens.length; j++) {
	      var token = line.tokens[j];
	      var tokenStyle = token.styleName && style.rich[token.styleName] || {}; // textPadding should not inherit from style.
	
	      var textPadding = token.textPadding = tokenStyle.textPadding; // textFont has been asigned to font by `normalizeStyle`.
	
	      var font = token.font = tokenStyle.font || style.font; // textHeight can be used when textVerticalAlign is specified in token.
	
	      var tokenHeight = token.textHeight = retrieve2( // textHeight should not be inherited, consider it can be specified
	      // as box height of the block.
	      tokenStyle.textHeight, getLineHeight(font));
	      textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
	      token.height = tokenHeight;
	      token.lineHeight = retrieve3(tokenStyle.textLineHeight, style.textLineHeight, tokenHeight);
	      token.textAlign = tokenStyle && tokenStyle.textAlign || style.textAlign;
	      token.textVerticalAlign = tokenStyle && tokenStyle.textVerticalAlign || 'middle';
	
	      if (truncateHeight != null && contentHeight + token.lineHeight > truncateHeight) {
	        return {
	          lines: [],
	          width: 0,
	          height: 0
	        };
	      }
	
	      token.textWidth = getWidth(token.text, font);
	      var tokenWidth = tokenStyle.textWidth;
	      var tokenWidthNotSpecified = tokenWidth == null || tokenWidth === 'auto'; // Percent width, can be `100%`, can be used in drawing separate
	      // line when box width is needed to be auto.
	
	      if (typeof tokenWidth === 'string' && tokenWidth.charAt(tokenWidth.length - 1) === '%') {
	        token.percentWidth = tokenWidth;
	        pendingList.push(token);
	        tokenWidth = 0; // Do not truncate in this case, because there is no user case
	        // and it is too complicated.
	      } else {
	        if (tokenWidthNotSpecified) {
	          tokenWidth = token.textWidth; // FIXME: If image is not loaded and textWidth is not specified, calling
	          // `getBoundingRect()` will not get correct result.
	
	          var textBackgroundColor = tokenStyle.textBackgroundColor;
	          var bgImg = textBackgroundColor && textBackgroundColor.image; // Use cases:
	          // (1) If image is not loaded, it will be loaded at render phase and call
	          // `dirty()` and `textBackgroundColor.image` will be replaced with the loaded
	          // image, and then the right size will be calculated here at the next tick.
	          // See `graphic/helper/text.js`.
	          // (2) If image loaded, and `textBackgroundColor.image` is image src string,
	          // use `imageHelper.findExistImage` to find cached image.
	          // `imageHelper.findExistImage` will always be called here before
	          // `imageHelper.createOrUpdateImage` in `graphic/helper/text.js#renderRichText`
	          // which ensures that image will not be rendered before correct size calcualted.
	
	          if (bgImg) {
	            bgImg = imageHelper.findExistImage(bgImg);
	
	            if (imageHelper.isImageReady(bgImg)) {
	              tokenWidth = Math.max(tokenWidth, bgImg.width * tokenHeight / bgImg.height);
	            }
	          }
	        }
	
	        var paddingW = textPadding ? textPadding[1] + textPadding[3] : 0;
	        tokenWidth += paddingW;
	        var remianTruncWidth = truncateWidth != null ? truncateWidth - lineWidth : null;
	
	        if (remianTruncWidth != null && remianTruncWidth < tokenWidth) {
	          if (!tokenWidthNotSpecified || remianTruncWidth < paddingW) {
	            token.text = '';
	            token.textWidth = tokenWidth = 0;
	          } else {
	            token.text = truncateText(token.text, remianTruncWidth - paddingW, font, truncate.ellipsis, {
	              minChar: truncate.minChar
	            });
	            token.textWidth = getWidth(token.text, font);
	            tokenWidth = token.textWidth + paddingW;
	          }
	        }
	      }
	
	      lineWidth += token.width = tokenWidth;
	      tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
	    }
	
	    line.width = lineWidth;
	    line.lineHeight = lineHeight;
	    contentHeight += lineHeight;
	    contentWidth = Math.max(contentWidth, lineWidth);
	  }
	
	  contentBlock.outerWidth = contentBlock.width = retrieve2(style.textWidth, contentWidth);
	  contentBlock.outerHeight = contentBlock.height = retrieve2(style.textHeight, contentHeight);
	
	  if (stlPadding) {
	    contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
	    contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
	  }
	
	  for (var i = 0; i < pendingList.length; i++) {
	    var token = pendingList[i];
	    var percentWidth = token.percentWidth; // Should not base on outerWidth, because token can not be placed out of padding.
	
	    token.width = parseInt(percentWidth, 10) / 100 * contentWidth;
	  }
	
	  return contentBlock;
	}
	
	function pushTokens(block, str, styleName) {
	  var isEmptyStr = str === '';
	  var strs = str.split('\n');
	  var lines = block.lines;
	
	  for (var i = 0; i < strs.length; i++) {
	    var text = strs[i];
	    var token = {
	      styleName: styleName,
	      text: text,
	      isLineHolder: !text && !isEmptyStr
	    }; // The first token should be appended to the last line.
	
	    if (!i) {
	      var tokens = (lines[lines.length - 1] || (lines[0] = {
	        tokens: []
	      })).tokens; // Consider cases:
	      // (1) ''.split('\n') => ['', '\n', ''], the '' at the first item
	      // (which is a placeholder) should be replaced by new token.
	      // (2) A image backage, where token likes {a|}.
	      // (3) A redundant '' will affect textAlign in line.
	      // (4) tokens with the same tplName should not be merged, because
	      // they should be displayed in different box (with border and padding).
	
	      var tokensLen = tokens.length;
	      tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : // Consider text is '', only insert when it is the "lineHolder" or
	      // "emptyStr". Otherwise a redundant '' will affect textAlign in line.
	      (text || !tokensLen || isEmptyStr) && tokens.push(token);
	    } // Other tokens always start a new line.
	    else {
	        // If there is '', insert it as a placeholder.
	        lines.push({
	          tokens: [token]
	        });
	      }
	  }
	}
	
	function makeFont(style) {
	  // FIXME in node-canvas fontWeight is before fontStyle
	  // Use `fontSize` `fontFamily` to check whether font properties are defined.
	  var font = (style.fontSize || style.fontFamily) && [style.fontStyle, style.fontWeight, (style.fontSize || 12) + 'px', // If font properties are defined, `fontFamily` should not be ignored.
	  style.fontFamily || 'sans-serif'].join(' ');
	  return font && trim(font) || style.textFont || style.font;
	}
	
	exports.DEFAULT_FONT = DEFAULT_FONT;
	exports.$override = $override;
	exports.getWidth = getWidth;
	exports.getBoundingRect = getBoundingRect;
	exports.adjustTextX = adjustTextX;
	exports.adjustTextY = adjustTextY;
	exports.calculateTextPosition = calculateTextPosition;
	exports.adjustTextPositionOnRect = adjustTextPositionOnRect;
	exports.truncateText = truncateText;
	exports.getLineHeight = getLineHeight;
	exports.measureText = measureText;
	exports.parsePlainText = parsePlainText;
	exports.parseRichText = parseRichText;
	exports.makeFont = makeFont;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var LRU = __webpack_require__(239);
	
	var globalImageCache = new LRU(50);
	/**
	 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
	 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
	 */
	
	function findExistImage(newImageOrSrc) {
	  if (typeof newImageOrSrc === 'string') {
	    var cachedImgObj = globalImageCache.get(newImageOrSrc);
	    return cachedImgObj && cachedImgObj.image;
	  } else {
	    return newImageOrSrc;
	  }
	}
	/**
	 * Caution: User should cache loaded images, but not just count on LRU.
	 * Consider if required images more than LRU size, will dead loop occur?
	 *
	 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
	 * @param {HTMLImageElement|HTMLCanvasElement|Canvas} image Existent image.
	 * @param {module:zrender/Element} [hostEl] For calling `dirty`.
	 * @param {Function} [cb] params: (image, cbPayload)
	 * @param {Object} [cbPayload] Payload on cb calling.
	 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
	 */
	
	
	function createOrUpdateImage(newImageOrSrc, image, hostEl, cb, cbPayload) {
	  if (!newImageOrSrc) {
	    return image;
	  } else if (typeof newImageOrSrc === 'string') {
	    // Image should not be loaded repeatly.
	    if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) {
	      return image;
	    } // Only when there is no existent image or existent image src
	    // is different, this method is responsible for load.
	
	
	    var cachedImgObj = globalImageCache.get(newImageOrSrc);
	    var pendingWrap = {
	      hostEl: hostEl,
	      cb: cb,
	      cbPayload: cbPayload
	    };
	
	    if (cachedImgObj) {
	      image = cachedImgObj.image;
	      !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
	    } else {
	      image = new Image();
	      image.onload = image.onerror = imageOnLoad;
	      globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
	        image: image,
	        pending: [pendingWrap]
	      });
	      image.src = image.__zrImageSrc = newImageOrSrc;
	    }
	
	    return image;
	  } // newImageOrSrc is an HTMLImageElement or HTMLCanvasElement or Canvas
	  else {
	      return newImageOrSrc;
	    }
	}
	
	function imageOnLoad() {
	  var cachedImgObj = this.__cachedImgObj;
	  this.onload = this.onerror = this.__cachedImgObj = null;
	
	  for (var i = 0; i < cachedImgObj.pending.length; i++) {
	    var pendingWrap = cachedImgObj.pending[i];
	    var cb = pendingWrap.cb;
	    cb && cb(this, pendingWrap.cbPayload);
	    pendingWrap.hostEl.dirty();
	  }
	
	  cachedImgObj.pending.length = 0;
	}
	
	function isImageReady(image) {
	  return image && image.width && image.height;
	}
	
	exports.findExistImage = findExistImage;
	exports.createOrUpdateImage = createOrUpdateImage;
	exports.isImageReady = isImageReady;

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	/**
	 * @param {Object} ctx
	 * @param {Object} shape
	 * @param {number} shape.x
	 * @param {number} shape.y
	 * @param {number} shape.width
	 * @param {number} shape.height
	 * @param {number} shape.r
	 */
	function buildPath(ctx, shape) {
	  var x = shape.x;
	  var y = shape.y;
	  var width = shape.width;
	  var height = shape.height;
	  var r = shape.r;
	  var r1;
	  var r2;
	  var r3;
	  var r4; // Convert width and height to positive for better borderRadius
	
	  if (width < 0) {
	    x = x + width;
	    width = -width;
	  }
	
	  if (height < 0) {
	    y = y + height;
	    height = -height;
	  }
	
	  if (typeof r === 'number') {
	    r1 = r2 = r3 = r4 = r;
	  } else if (r instanceof Array) {
	    if (r.length === 1) {
	      r1 = r2 = r3 = r4 = r[0];
	    } else if (r.length === 2) {
	      r1 = r3 = r[0];
	      r2 = r4 = r[1];
	    } else if (r.length === 3) {
	      r1 = r[0];
	      r2 = r4 = r[1];
	      r3 = r[2];
	    } else {
	      r1 = r[0];
	      r2 = r[1];
	      r3 = r[2];
	      r4 = r[3];
	    }
	  } else {
	    r1 = r2 = r3 = r4 = 0;
	  }
	
	  var total;
	
	  if (r1 + r2 > width) {
	    total = r1 + r2;
	    r1 *= width / total;
	    r2 *= width / total;
	  }
	
	  if (r3 + r4 > width) {
	    total = r3 + r4;
	    r3 *= width / total;
	    r4 *= width / total;
	  }
	
	  if (r2 + r3 > height) {
	    total = r2 + r3;
	    r2 *= height / total;
	    r3 *= height / total;
	  }
	
	  if (r1 + r4 > height) {
	    total = r1 + r4;
	    r1 *= height / total;
	    r4 *= height / total;
	  }
	
	  ctx.moveTo(x + r1, y);
	  ctx.lineTo(x + width - r2, y);
	  r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
	  ctx.lineTo(x + width, y + height - r3);
	  r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
	  ctx.lineTo(x + r4, y + height);
	  r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
	  ctx.lineTo(x, y + r1);
	  r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
	}
	
	exports.buildPath = buildPath;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(220);
	
	var _event = __webpack_require__(225);
	
	var Dispatcher = _event.Dispatcher;
	
	var requestAnimationFrame = __webpack_require__(250);
	
	var Animator = __webpack_require__(235);
	
	/**
	 * Animation main class, dispatch and manage all animation controllers
	 *
	 * @module zrender/animation/Animation
	 * @author pissang(https://github.com/pissang)
	 */
	// TODO Additive animation
	// http://iosoteric.com/additive-animations-animatewithduration-in-ios-8/
	// https://developer.apple.com/videos/wwdc2014/#236
	
	/**
	 * @typedef {Object} IZRenderStage
	 * @property {Function} update
	 */
	
	/**
	 * @alias module:zrender/animation/Animation
	 * @constructor
	 * @param {Object} [options]
	 * @param {Function} [options.onframe]
	 * @param {IZRenderStage} [options.stage]
	 * @example
	 *     var animation = new Animation();
	 *     var obj = {
	 *         x: 100,
	 *         y: 100
	 *     };
	 *     animation.animate(node.position)
	 *         .when(1000, {
	 *             x: 500,
	 *             y: 500
	 *         })
	 *         .when(2000, {
	 *             x: 100,
	 *             y: 100
	 *         })
	 *         .start('spline');
	 */
	var Animation = function (options) {
	  options = options || {};
	  this.stage = options.stage || {};
	
	  this.onframe = options.onframe || function () {}; // private properties
	
	
	  this._clips = [];
	  this._running = false;
	  this._time;
	  this._pausedTime;
	  this._pauseStart;
	  this._paused = false;
	  Dispatcher.call(this);
	};
	
	Animation.prototype = {
	  constructor: Animation,
	
	  /**
	   * Add clip
	   * @param {module:zrender/animation/Clip} clip
	   */
	  addClip: function (clip) {
	    this._clips.push(clip);
	  },
	
	  /**
	   * Add animator
	   * @param {module:zrender/animation/Animator} animator
	   */
	  addAnimator: function (animator) {
	    animator.animation = this;
	    var clips = animator.getClips();
	
	    for (var i = 0; i < clips.length; i++) {
	      this.addClip(clips[i]);
	    }
	  },
	
	  /**
	   * Delete animation clip
	   * @param {module:zrender/animation/Clip} clip
	   */
	  removeClip: function (clip) {
	    var idx = util.indexOf(this._clips, clip);
	
	    if (idx >= 0) {
	      this._clips.splice(idx, 1);
	    }
	  },
	
	  /**
	   * Delete animation clip
	   * @param {module:zrender/animation/Animator} animator
	   */
	  removeAnimator: function (animator) {
	    var clips = animator.getClips();
	
	    for (var i = 0; i < clips.length; i++) {
	      this.removeClip(clips[i]);
	    }
	
	    animator.animation = null;
	  },
	  _update: function () {
	    var time = new Date().getTime() - this._pausedTime;
	
	    var delta = time - this._time;
	    var clips = this._clips;
	    var len = clips.length;
	    var deferredEvents = [];
	    var deferredClips = [];
	
	    for (var i = 0; i < len; i++) {
	      var clip = clips[i];
	      var e = clip.step(time, delta); // Throw out the events need to be called after
	      // stage.update, like destroy
	
	      if (e) {
	        deferredEvents.push(e);
	        deferredClips.push(clip);
	      }
	    } // Remove the finished clip
	
	
	    for (var i = 0; i < len;) {
	      if (clips[i]._needsRemove) {
	        clips[i] = clips[len - 1];
	        clips.pop();
	        len--;
	      } else {
	        i++;
	      }
	    }
	
	    len = deferredEvents.length;
	
	    for (var i = 0; i < len; i++) {
	      deferredClips[i].fire(deferredEvents[i]);
	    }
	
	    this._time = time;
	    this.onframe(delta); // 'frame' should be triggered before stage, because upper application
	    // depends on the sequence (e.g., echarts-stream and finish
	    // event judge)
	
	    this.trigger('frame', delta);
	
	    if (this.stage.update) {
	      this.stage.update();
	    }
	  },
	  _startLoop: function () {
	    var self = this;
	    this._running = true;
	
	    function step() {
	      if (self._running) {
	        requestAnimationFrame(step);
	        !self._paused && self._update();
	      }
	    }
	
	    requestAnimationFrame(step);
	  },
	
	  /**
	   * Start animation.
	   */
	  start: function () {
	    this._time = new Date().getTime();
	    this._pausedTime = 0;
	
	    this._startLoop();
	  },
	
	  /**
	   * Stop animation.
	   */
	  stop: function () {
	    this._running = false;
	  },
	
	  /**
	   * Pause animation.
	   */
	  pause: function () {
	    if (!this._paused) {
	      this._pauseStart = new Date().getTime();
	      this._paused = true;
	    }
	  },
	
	  /**
	   * Resume animation.
	   */
	  resume: function () {
	    if (this._paused) {
	      this._pausedTime += new Date().getTime() - this._pauseStart;
	      this._paused = false;
	    }
	  },
	
	  /**
	   * Clear animation.
	   */
	  clear: function () {
	    this._clips = [];
	  },
	
	  /**
	   * Whether animation finished.
	   */
	  isFinished: function () {
	    return !this._clips.length;
	  },
	
	  /**
	   * Creat animator for a target, whose props can be animated.
	   *
	   * @param  {Object} target
	   * @param  {Object} options
	   * @param  {boolean} [options.loop=false] Whether loop animation.
	   * @param  {Function} [options.getter=null] Get value from target.
	   * @param  {Function} [options.setter=null] Set value to target.
	   * @return {module:zrender/animation/Animation~Animator}
	   */
	  // TODO Gap
	  animate: function (target, options) {
	    options = options || {};
	    var animator = new Animator(target, options.loop, options.getter, options.setter);
	    this.addAnimator(animator);
	    return animator;
	  }
	};
	util.mixin(Animation, Dispatcher);
	var _default = Animation;
	module.exports = _default;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var _event = __webpack_require__(225);
	
	var addEventListener = _event.addEventListener;
	var removeEventListener = _event.removeEventListener;
	var normalizeEvent = _event.normalizeEvent;
	var getNativeEvent = _event.getNativeEvent;
	
	var zrUtil = __webpack_require__(220);
	
	var Eventful = __webpack_require__(224);
	
	var env = __webpack_require__(219);
	
	/* global document */
	var TOUCH_CLICK_DELAY = 300;
	var globalEventSupported = env.domSupported;
	
	var localNativeListenerNames = function () {
	  var mouseHandlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
	  var touchHandlerNames = ['touchstart', 'touchend', 'touchmove'];
	  var pointerEventNameMap = {
	    pointerdown: 1,
	    pointerup: 1,
	    pointermove: 1,
	    pointerout: 1
	  };
	  var pointerHandlerNames = zrUtil.map(mouseHandlerNames, function (name) {
	    var nm = name.replace('mouse', 'pointer');
	    return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
	  });
	  return {
	    mouse: mouseHandlerNames,
	    touch: touchHandlerNames,
	    pointer: pointerHandlerNames
	  };
	}();
	
	var globalNativeListenerNames = {
	  mouse: ['mousemove', 'mouseup'],
	  pointer: ['pointermove', 'pointerup']
	};
	
	function eventNameFix(name) {
	  return name === 'mousewheel' && env.browser.firefox ? 'DOMMouseScroll' : name;
	}
	
	function isPointerFromTouch(event) {
	  var pointerType = event.pointerType;
	  return pointerType === 'pen' || pointerType === 'touch';
	} // function useMSGuesture(handlerProxy, event) {
	//     return isPointerFromTouch(event) && !!handlerProxy._msGesture;
	// }
	// function onMSGestureChange(proxy, event) {
	//     if (event.translationX || event.translationY) {
	//         // mousemove is carried by MSGesture to reduce the sensitivity.
	//         proxy.handler.dispatchToElement(event.target, 'mousemove', event);
	//     }
	//     if (event.scale !== 1) {
	//         event.pinchX = event.offsetX;
	//         event.pinchY = event.offsetY;
	//         event.pinchScale = event.scale;
	//         proxy.handler.dispatchToElement(event.target, 'pinch', event);
	//     }
	// }
	
	/**
	 * Prevent mouse event from being dispatched after Touch Events action
	 * @see <https://github.com/deltakosh/handjs/blob/master/src/hand.base.js>
	 * 1. Mobile browsers dispatch mouse events 300ms after touchend.
	 * 2. Chrome for Android dispatch mousedown for long-touch about 650ms
	 * Result: Blocking Mouse Events for 700ms.
	 *
	 * @param {DOMHandlerScope} scope
	 */
	
	
	function setTouchTimer(scope) {
	  scope.touching = true;
	
	  if (scope.touchTimer != null) {
	    clearTimeout(scope.touchTimer);
	    scope.touchTimer = null;
	  }
	
	  scope.touchTimer = setTimeout(function () {
	    scope.touching = false;
	    scope.touchTimer = null;
	  }, 700);
	} // Mark touch, which is useful in distinguish touch and
	// mouse event in upper applicatoin.
	
	
	function markTouch(event) {
	  event && (event.zrByTouch = true);
	} // function markTriggeredFromLocal(event) {
	//     event && (event.__zrIsFromLocal = true);
	// }
	// function isTriggeredFromLocal(instance, event) {
	//     return !!(event && event.__zrIsFromLocal);
	// }
	
	
	function normalizeGlobalEvent(instance, event) {
	  // offsetX, offsetY still need to be calculated. They are necessary in the event
	  // handlers of the upper applications. Set `true` to force calculate them.
	  return normalizeEvent(instance.dom, new FakeGlobalEvent(instance, event), true);
	}
	/**
	 * Detect whether the given el is in `painterRoot`.
	 */
	
	
	function isLocalEl(instance, el) {
	  var elTmp = el;
	  var isLocal = false;
	
	  while (elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot)) {
	    elTmp = elTmp.parentNode;
	  }
	
	  return isLocal;
	}
	/**
	 * Make a fake event but not change the original event,
	 * becuase the global event probably be used by other
	 * listeners not belonging to zrender.
	 * @class
	 */
	
	
	function FakeGlobalEvent(instance, event) {
	  this.type = event.type;
	  this.target = this.currentTarget = instance.dom;
	  this.pointerType = event.pointerType; // Necessray for the force calculation of zrX, zrY
	
	  this.clientX = event.clientX;
	  this.clientY = event.clientY; // Because we do not mount global listeners to touch events,
	  // we do not copy `targetTouches` and `changedTouches` here.
	}
	
	var fakeGlobalEventProto = FakeGlobalEvent.prototype; // we make the default methods on the event do nothing,
	// otherwise it is dangerous. See more details in
	// [Drag outside] in `Handler.js`.
	
	fakeGlobalEventProto.stopPropagation = fakeGlobalEventProto.stopImmediatePropagation = fakeGlobalEventProto.preventDefault = zrUtil.noop;
	/**
	 * Local DOM Handlers
	 * @this {HandlerProxy}
	 */
	
	var localDOMHandlers = {
	  mousedown: function (event) {
	    event = normalizeEvent(this.dom, event);
	    this._mayPointerCapture = [event.zrX, event.zrY];
	    this.trigger('mousedown', event);
	  },
	  mousemove: function (event) {
	    event = normalizeEvent(this.dom, event);
	    var downPoint = this._mayPointerCapture;
	
	    if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) {
	      togglePointerCapture(this, true);
	    }
	
	    this.trigger('mousemove', event);
	  },
	  mouseup: function (event) {
	    event = normalizeEvent(this.dom, event);
	    togglePointerCapture(this, false);
	    this.trigger('mouseup', event);
	  },
	  mouseout: function (event) {
	    event = normalizeEvent(this.dom, event); // Similarly to the browser did on `document` and touch event,
	    // `globalout` will be delayed to final pointer cature release.
	
	    if (this._pointerCapturing) {
	      event.zrEventControl = 'no_globalout';
	    } // There might be some doms created by upper layer application
	    // at the same level of painter.getViewportRoot() (e.g., tooltip
	    // dom created by echarts), where 'globalout' event should not
	    // be triggered when mouse enters these doms. (But 'mouseout'
	    // should be triggered at the original hovered element as usual).
	
	
	    var element = event.toElement || event.relatedTarget;
	    event.zrIsToLocalDOM = isLocalEl(this, element);
	    this.trigger('mouseout', event);
	  },
	  touchstart: function (event) {
	    // Default mouse behaviour should not be disabled here.
	    // For example, page may needs to be slided.
	    event = normalizeEvent(this.dom, event);
	    markTouch(event);
	    this._lastTouchMoment = new Date();
	    this.handler.processGesture(event, 'start'); // For consistent event listener for both touch device and mouse device,
	    // we simulate "mouseover-->mousedown" in touch device. So we trigger
	    // `mousemove` here (to trigger `mouseover` inside), and then trigger
	    // `mousedown`.
	
	    localDOMHandlers.mousemove.call(this, event);
	    localDOMHandlers.mousedown.call(this, event);
	  },
	  touchmove: function (event) {
	    event = normalizeEvent(this.dom, event);
	    markTouch(event);
	    this.handler.processGesture(event, 'change'); // Mouse move should always be triggered no matter whether
	    // there is gestrue event, because mouse move and pinch may
	    // be used at the same time.
	
	    localDOMHandlers.mousemove.call(this, event);
	  },
	  touchend: function (event) {
	    event = normalizeEvent(this.dom, event);
	    markTouch(event);
	    this.handler.processGesture(event, 'end');
	    localDOMHandlers.mouseup.call(this, event); // Do not trigger `mouseout` here, in spite of `mousemove`(`mouseover`) is
	    // triggered in `touchstart`. This seems to be illogical, but by this mechanism,
	    // we can conveniently implement "hover style" in both PC and touch device just
	    // by listening to `mouseover` to add "hover style" and listening to `mouseout`
	    // to remove "hover style" on an element, without any additional code for
	    // compatibility. (`mouseout` will not be triggered in `touchend`, so "hover
	    // style" will remain for user view)
	    // click event should always be triggered no matter whether
	    // there is gestrue event. System click can not be prevented.
	
	    if (+new Date() - this._lastTouchMoment < TOUCH_CLICK_DELAY) {
	      localDOMHandlers.click.call(this, event);
	    }
	  },
	  pointerdown: function (event) {
	    localDOMHandlers.mousedown.call(this, event); // if (useMSGuesture(this, event)) {
	    //     this._msGesture.addPointer(event.pointerId);
	    // }
	  },
	  pointermove: function (event) {
	    // FIXME
	    // pointermove is so sensitive that it always triggered when
	    // tap(click) on touch screen, which affect some judgement in
	    // upper application. So, we dont support mousemove on MS touch
	    // device yet.
	    if (!isPointerFromTouch(event)) {
	      localDOMHandlers.mousemove.call(this, event);
	    }
	  },
	  pointerup: function (event) {
	    localDOMHandlers.mouseup.call(this, event);
	  },
	  pointerout: function (event) {
	    // pointerout will be triggered when tap on touch screen
	    // (IE11+/Edge on MS Surface) after click event triggered,
	    // which is inconsistent with the mousout behavior we defined
	    // in touchend. So we unify them.
	    // (check localDOMHandlers.touchend for detailed explanation)
	    if (!isPointerFromTouch(event)) {
	      localDOMHandlers.mouseout.call(this, event);
	    }
	  }
	};
	/**
	 * Othere DOM UI Event handlers for zr dom.
	 * @this {HandlerProxy}
	 */
	
	zrUtil.each(['click', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	  localDOMHandlers[name] = function (event) {
	    event = normalizeEvent(this.dom, event);
	    this.trigger(name, event);
	  };
	});
	/**
	 * DOM UI Event handlers for global page.
	 *
	 * [Caution]:
	 * those handlers should both support in capture phase and bubble phase!
	 *
	 * @this {HandlerProxy}
	 */
	
	var globalDOMHandlers = {
	  pointermove: function (event) {
	    // FIXME
	    // pointermove is so sensitive that it always triggered when
	    // tap(click) on touch screen, which affect some judgement in
	    // upper application. So, we dont support mousemove on MS touch
	    // device yet.
	    if (!isPointerFromTouch(event)) {
	      globalDOMHandlers.mousemove.call(this, event);
	    }
	  },
	  pointerup: function (event) {
	    globalDOMHandlers.mouseup.call(this, event);
	  },
	  mousemove: function (event) {
	    this.trigger('mousemove', event);
	  },
	  mouseup: function (event) {
	    var pointerCaptureReleasing = this._pointerCapturing;
	    togglePointerCapture(this, false);
	    this.trigger('mouseup', event);
	
	    if (pointerCaptureReleasing) {
	      event.zrEventControl = 'only_globalout';
	      this.trigger('mouseout', event);
	    }
	  }
	};
	/**
	 * @param {HandlerProxy} instance
	 * @param {DOMHandlerScope} scope
	 */
	
	function mountLocalDOMEventListeners(instance, scope) {
	  var domHandlers = scope.domHandlers;
	
	  if (env.pointerEventsSupported) {
	    // Only IE11+/Edge
	    // 1. On devices that both enable touch and mouse (e.g., MS Surface and lenovo X240),
	    // IE11+/Edge do not trigger touch event, but trigger pointer event and mouse event
	    // at the same time.
	    // 2. On MS Surface, it probablely only trigger mousedown but no mouseup when tap on
	    // screen, which do not occurs in pointer event.
	    // So we use pointer event to both detect touch gesture and mouse behavior.
	    zrUtil.each(localNativeListenerNames.pointer, function (nativeEventName) {
	      mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	        // markTriggeredFromLocal(event);
	        domHandlers[nativeEventName].call(instance, event);
	      });
	    }); // FIXME
	    // Note: MS Gesture require CSS touch-action set. But touch-action is not reliable,
	    // which does not prevent defuault behavior occasionally (which may cause view port
	    // zoomed in but use can not zoom it back). And event.preventDefault() does not work.
	    // So we have to not to use MSGesture and not to support touchmove and pinch on MS
	    // touch screen. And we only support click behavior on MS touch screen now.
	    // MS Gesture Event is only supported on IE11+/Edge and on Windows 8+.
	    // We dont support touch on IE on win7.
	    // See <https://msdn.microsoft.com/en-us/library/dn433243(v=vs.85).aspx>
	    // if (typeof MSGesture === 'function') {
	    //     (this._msGesture = new MSGesture()).target = dom; // jshint ignore:line
	    //     dom.addEventListener('MSGestureChange', onMSGestureChange);
	    // }
	  } else {
	    if (env.touchEventsSupported) {
	      zrUtil.each(localNativeListenerNames.touch, function (nativeEventName) {
	        mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	          // markTriggeredFromLocal(event);
	          domHandlers[nativeEventName].call(instance, event);
	          setTouchTimer(scope);
	        });
	      }); // Handler of 'mouseout' event is needed in touch mode, which will be mounted below.
	      // addEventListener(root, 'mouseout', this._mouseoutHandler);
	    } // 1. Considering some devices that both enable touch and mouse event (like on MS Surface
	    // and lenovo X240, @see #2350), we make mouse event be always listened, otherwise
	    // mouse event can not be handle in those devices.
	    // 2. On MS Surface, Chrome will trigger both touch event and mouse event. How to prevent
	    // mouseevent after touch event triggered, see `setTouchTimer`.
	
	
	    zrUtil.each(localNativeListenerNames.mouse, function (nativeEventName) {
	      mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	        event = getNativeEvent(event);
	
	        if (!scope.touching) {
	          // markTriggeredFromLocal(event);
	          domHandlers[nativeEventName].call(instance, event);
	        }
	      });
	    });
	  }
	}
	/**
	 * @param {HandlerProxy} instance
	 * @param {DOMHandlerScope} scope
	 */
	
	
	function mountGlobalDOMEventListeners(instance, scope) {
	  // Only IE11+/Edge. See the comment in `mountLocalDOMEventListeners`.
	  if (env.pointerEventsSupported) {
	    zrUtil.each(globalNativeListenerNames.pointer, mount);
	  } // Touch event has implemented "drag outside" so we do not mount global listener for touch event.
	  // (see https://www.w3.org/TR/touch-events/#the-touchmove-event)
	  // We do not consider "both-support-touch-and-mouse device" for this feature (see the comment of
	  // `mountLocalDOMEventListeners`) to avoid bugs util some requirements come.
	  else if (!env.touchEventsSupported) {
	      zrUtil.each(globalNativeListenerNames.mouse, mount);
	    }
	
	  function mount(nativeEventName) {
	    function nativeEventListener(event) {
	      event = getNativeEvent(event); // See the reason in [Drag outside] in `Handler.js`
	      // This checking supports both `useCapture` or not.
	      // PENDING: if there is performance issue in some devices,
	      // we probably can not use `useCapture` and change a easier
	      // to judes whether local (mark).
	
	      if (!isLocalEl(instance, event.target)) {
	        event = normalizeGlobalEvent(instance, event);
	        scope.domHandlers[nativeEventName].call(instance, event);
	      }
	    }
	
	    mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
	      capture: true
	    } // See [Drag Outside] in `Handler.js`
	    );
	  }
	}
	
	function mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
	  scope.mounted[nativeEventName] = listener;
	  scope.listenerOpts[nativeEventName] = opt;
	  addEventListener(scope.domTarget, eventNameFix(nativeEventName), listener, opt);
	}
	
	function unmountDOMEventListeners(scope) {
	  var mounted = scope.mounted;
	
	  for (var nativeEventName in mounted) {
	    if (mounted.hasOwnProperty(nativeEventName)) {
	      removeEventListener(scope.domTarget, eventNameFix(nativeEventName), mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
	    }
	  }
	
	  scope.mounted = {};
	}
	/**
	 * See [Drag Outside] in `Handler.js`.
	 * @implement
	 * @param {boolean} isPointerCapturing Should never be `null`/`undefined`.
	 *        `true`: start to capture pointer if it is not capturing.
	 *        `false`: end the capture if it is capturing.
	 */
	
	
	function togglePointerCapture(instance, isPointerCapturing) {
	  instance._mayPointerCapture = null;
	
	  if (globalEventSupported && instance._pointerCapturing ^ isPointerCapturing) {
	    instance._pointerCapturing = isPointerCapturing;
	    var globalHandlerScope = instance._globalHandlerScope;
	    isPointerCapturing ? mountGlobalDOMEventListeners(instance, globalHandlerScope) : unmountDOMEventListeners(globalHandlerScope);
	  }
	}
	/**
	 * @inner
	 * @class
	 */
	
	
	function DOMHandlerScope(domTarget, domHandlers) {
	  this.domTarget = domTarget;
	  this.domHandlers = domHandlers; // Key: eventName, value: mounted handler funcitons.
	  // Used for unmount.
	
	  this.mounted = {};
	  this.listenerOpts = {};
	  this.touchTimer = null;
	  this.touching = false;
	}
	/**
	 * @public
	 * @class
	 */
	
	
	function HandlerDomProxy(dom, painterRoot) {
	  Eventful.call(this);
	  this.dom = dom;
	  this.painterRoot = painterRoot;
	  this._localHandlerScope = new DOMHandlerScope(dom, localDOMHandlers);
	
	  if (globalEventSupported) {
	    this._globalHandlerScope = new DOMHandlerScope(document, globalDOMHandlers);
	  }
	  /**
	   * @type {boolean}
	   */
	
	
	  this._pointerCapturing = false;
	  /**
	   * @type {Array.<number>} [x, y] or null.
	   */
	
	  this._mayPointerCapture = null;
	  mountLocalDOMEventListeners(this, this._localHandlerScope);
	}
	
	var handlerDomProxyProto = HandlerDomProxy.prototype;
	
	handlerDomProxyProto.dispose = function () {
	  unmountDOMEventListeners(this._localHandlerScope);
	
	  if (globalEventSupported) {
	    unmountDOMEventListeners(this._globalHandlerScope);
	  }
	};
	
	handlerDomProxyProto.setCursor = function (cursorStyle) {
	  this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
	};
	
	zrUtil.mixin(HandlerDomProxy, Eventful);
	var _default = HandlerDomProxy;
	module.exports = _default;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	var filter = _util.filter;
	var map = _util.map;
	var isArray = _util.isArray;
	var indexOf = _util.indexOf;
	var isObject = _util.isObject;
	var isString = _util.isString;
	var createHashMap = _util.createHashMap;
	var assert = _util.assert;
	var clone = _util.clone;
	var merge = _util.merge;
	var extend = _util.extend;
	var mixin = _util.mixin;
	
	var modelUtil = __webpack_require__(261);
	
	var Model = __webpack_require__(262);
	
	var ComponentModel = __webpack_require__(303);
	
	var globalDefault = __webpack_require__(309);
	
	var colorPaletteMixin = __webpack_require__(310);
	
	var _sourceHelper = __webpack_require__(311);
	
	var resetSourceDefaulter = _sourceHelper.resetSourceDefaulter;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * ECharts global model
	 *
	 * @module {echarts/model/Global}
	 */
	
	/**
	 * Caution: If the mechanism should be changed some day, these cases
	 * should be considered:
	 *
	 * (1) In `merge option` mode, if using the same option to call `setOption`
	 * many times, the result should be the same (try our best to ensure that).
	 * (2) In `merge option` mode, if a component has no id/name specified, it
	 * will be merged by index, and the result sequence of the components is
	 * consistent to the original sequence.
	 * (3) `reset` feature (in toolbox). Find detailed info in comments about
	 * `mergeOption` in module:echarts/model/OptionManager.
	 */
	var OPTION_INNER_KEY = '\0_ec_inner';
	/**
	 * @alias module:echarts/model/Global
	 *
	 * @param {Object} option
	 * @param {module:echarts/model/Model} parentModel
	 * @param {Object} theme
	 */
	
	var GlobalModel = Model.extend({
	  init: function (option, parentModel, theme, optionManager) {
	    theme = theme || {};
	    this.option = null; // Mark as not initialized.
	
	    /**
	     * @type {module:echarts/model/Model}
	     * @private
	     */
	
	    this._theme = new Model(theme);
	    /**
	     * @type {module:echarts/model/OptionManager}
	     */
	
	    this._optionManager = optionManager;
	  },
	  setOption: function (option, optionPreprocessorFuncs) {
	    assert(!(OPTION_INNER_KEY in option), 'please use chart.getOption()');
	
	    this._optionManager.setOption(option, optionPreprocessorFuncs);
	
	    this.resetOption(null);
	  },
	
	  /**
	   * @param {string} type null/undefined: reset all.
	   *                      'recreate': force recreate all.
	   *                      'timeline': only reset timeline option
	   *                      'media': only reset media query option
	   * @return {boolean} Whether option changed.
	   */
	  resetOption: function (type) {
	    var optionChanged = false;
	    var optionManager = this._optionManager;
	
	    if (!type || type === 'recreate') {
	      var baseOption = optionManager.mountOption(type === 'recreate');
	
	      if (!this.option || type === 'recreate') {
	        initBase.call(this, baseOption);
	      } else {
	        this.restoreData();
	        this.mergeOption(baseOption);
	      }
	
	      optionChanged = true;
	    }
	
	    if (type === 'timeline' || type === 'media') {
	      this.restoreData();
	    }
	
	    if (!type || type === 'recreate' || type === 'timeline') {
	      var timelineOption = optionManager.getTimelineOption(this);
	      timelineOption && (this.mergeOption(timelineOption), optionChanged = true);
	    }
	
	    if (!type || type === 'recreate' || type === 'media') {
	      var mediaOptions = optionManager.getMediaOption(this, this._api);
	
	      if (mediaOptions.length) {
	        each(mediaOptions, function (mediaOption) {
	          this.mergeOption(mediaOption, optionChanged = true);
	        }, this);
	      }
	    }
	
	    return optionChanged;
	  },
	
	  /**
	   * @protected
	   */
	  mergeOption: function (newOption) {
	    var option = this.option;
	    var componentsMap = this._componentsMap;
	    var newCptTypes = [];
	    resetSourceDefaulter(this); // If no component class, merge directly.
	    // For example: color, animaiton options, etc.
	
	    each(newOption, function (componentOption, mainType) {
	      if (componentOption == null) {
	        return;
	      }
	
	      if (!ComponentModel.hasClass(mainType)) {
	        // globalSettingTask.dirty();
	        option[mainType] = option[mainType] == null ? clone(componentOption) : merge(option[mainType], componentOption, true);
	      } else if (mainType) {
	        newCptTypes.push(mainType);
	      }
	    });
	    ComponentModel.topologicalTravel(newCptTypes, ComponentModel.getAllClassMainTypes(), visitComponent, this);
	
	    function visitComponent(mainType, dependencies) {
	      var newCptOptionList = modelUtil.normalizeToArray(newOption[mainType]);
	      var mapResult = modelUtil.mappingToExists(componentsMap.get(mainType), newCptOptionList);
	      modelUtil.makeIdAndName(mapResult); // Set mainType and complete subType.
	
	      each(mapResult, function (item, index) {
	        var opt = item.option;
	
	        if (isObject(opt)) {
	          item.keyInfo.mainType = mainType;
	          item.keyInfo.subType = determineSubType(mainType, opt, item.exist);
	        }
	      });
	      var dependentModels = getComponentsByTypes(componentsMap, dependencies);
	      option[mainType] = [];
	      componentsMap.set(mainType, []);
	      each(mapResult, function (resultItem, index) {
	        var componentModel = resultItem.exist;
	        var newCptOption = resultItem.option;
	        assert(isObject(newCptOption) || componentModel, 'Empty component definition'); // Consider where is no new option and should be merged using {},
	        // see removeEdgeAndAdd in topologicalTravel and
	        // ComponentModel.getAllClassMainTypes.
	
	        if (!newCptOption) {
	          componentModel.mergeOption({}, this);
	          componentModel.optionUpdated({}, false);
	        } else {
	          var ComponentModelClass = ComponentModel.getClass(mainType, resultItem.keyInfo.subType, true);
	
	          if (componentModel && componentModel.constructor === ComponentModelClass) {
	            componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();
	
	            componentModel.mergeOption(newCptOption, this);
	            componentModel.optionUpdated(newCptOption, false);
	          } else {
	            // PENDING Global as parent ?
	            var extraOpt = extend({
	              dependentModels: dependentModels,
	              componentIndex: index
	            }, resultItem.keyInfo);
	            componentModel = new ComponentModelClass(newCptOption, this, this, extraOpt);
	            extend(componentModel, extraOpt);
	            componentModel.init(newCptOption, this, this, extraOpt); // Call optionUpdated after init.
	            // newCptOption has been used as componentModel.option
	            // and may be merged with theme and default, so pass null
	            // to avoid confusion.
	
	            componentModel.optionUpdated(null, true);
	          }
	        }
	
	        componentsMap.get(mainType)[index] = componentModel;
	        option[mainType][index] = componentModel.option;
	      }, this); // Backup series for filtering.
	
	      if (mainType === 'series') {
	        createSeriesIndices(this, componentsMap.get('series'));
	      }
	    }
	
	    this._seriesIndicesMap = createHashMap(this._seriesIndices = this._seriesIndices || []);
	  },
	
	  /**
	   * Get option for output (cloned option and inner info removed)
	   * @public
	   * @return {Object}
	   */
	  getOption: function () {
	    var option = clone(this.option);
	    each(option, function (opts, mainType) {
	      if (ComponentModel.hasClass(mainType)) {
	        var opts = modelUtil.normalizeToArray(opts);
	
	        for (var i = opts.length - 1; i >= 0; i--) {
	          // Remove options with inner id.
	          if (modelUtil.isIdInner(opts[i])) {
	            opts.splice(i, 1);
	          }
	        }
	
	        option[mainType] = opts;
	      }
	    });
	    delete option[OPTION_INNER_KEY];
	    return option;
	  },
	
	  /**
	   * @return {module:echarts/model/Model}
	   */
	  getTheme: function () {
	    return this._theme;
	  },
	
	  /**
	   * @param {string} mainType
	   * @param {number} [idx=0]
	   * @return {module:echarts/model/Component}
	   */
	  getComponent: function (mainType, idx) {
	    var list = this._componentsMap.get(mainType);
	
	    if (list) {
	      return list[idx || 0];
	    }
	  },
	
	  /**
	   * If none of index and id and name used, return all components with mainType.
	   * @param {Object} condition
	   * @param {string} condition.mainType
	   * @param {string} [condition.subType] If ignore, only query by mainType
	   * @param {number|Array.<number>} [condition.index] Either input index or id or name.
	   * @param {string|Array.<string>} [condition.id] Either input index or id or name.
	   * @param {string|Array.<string>} [condition.name] Either input index or id or name.
	   * @return {Array.<module:echarts/model/Component>}
	   */
	  queryComponents: function (condition) {
	    var mainType = condition.mainType;
	
	    if (!mainType) {
	      return [];
	    }
	
	    var index = condition.index;
	    var id = condition.id;
	    var name = condition.name;
	
	    var cpts = this._componentsMap.get(mainType);
	
	    if (!cpts || !cpts.length) {
	      return [];
	    }
	
	    var result;
	
	    if (index != null) {
	      if (!isArray(index)) {
	        index = [index];
	      }
	
	      result = filter(map(index, function (idx) {
	        return cpts[idx];
	      }), function (val) {
	        return !!val;
	      });
	    } else if (id != null) {
	      var isIdArray = isArray(id);
	      result = filter(cpts, function (cpt) {
	        return isIdArray && indexOf(id, cpt.id) >= 0 || !isIdArray && cpt.id === id;
	      });
	    } else if (name != null) {
	      var isNameArray = isArray(name);
	      result = filter(cpts, function (cpt) {
	        return isNameArray && indexOf(name, cpt.name) >= 0 || !isNameArray && cpt.name === name;
	      });
	    } else {
	      // Return all components with mainType
	      result = cpts.slice();
	    }
	
	    return filterBySubType(result, condition);
	  },
	
	  /**
	   * The interface is different from queryComponents,
	   * which is convenient for inner usage.
	   *
	   * @usage
	   * var result = findComponents(
	   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
	   * );
	   * var result = findComponents(
	   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
	   * );
	   * var result = findComponents(
	   *     {mainType: 'series',
	   *     filter: function (model, index) {...}}
	   * );
	   * // result like [component0, componnet1, ...]
	   *
	   * @param {Object} condition
	   * @param {string} condition.mainType Mandatory.
	   * @param {string} [condition.subType] Optional.
	   * @param {Object} [condition.query] like {xxxIndex, xxxId, xxxName},
	   *        where xxx is mainType.
	   *        If query attribute is null/undefined or has no index/id/name,
	   *        do not filtering by query conditions, which is convenient for
	   *        no-payload situations or when target of action is global.
	   * @param {Function} [condition.filter] parameter: component, return boolean.
	   * @return {Array.<module:echarts/model/Component>}
	   */
	  findComponents: function (condition) {
	    var query = condition.query;
	    var mainType = condition.mainType;
	    var queryCond = getQueryCond(query);
	    var result = queryCond ? this.queryComponents(queryCond) : this._componentsMap.get(mainType);
	    return doFilter(filterBySubType(result, condition));
	
	    function getQueryCond(q) {
	      var indexAttr = mainType + 'Index';
	      var idAttr = mainType + 'Id';
	      var nameAttr = mainType + 'Name';
	      return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
	        mainType: mainType,
	        // subType will be filtered finally.
	        index: q[indexAttr],
	        id: q[idAttr],
	        name: q[nameAttr]
	      } : null;
	    }
	
	    function doFilter(res) {
	      return condition.filter ? filter(res, condition.filter) : res;
	    }
	  },
	
	  /**
	   * @usage
	   * eachComponent('legend', function (legendModel, index) {
	   *     ...
	   * });
	   * eachComponent(function (componentType, model, index) {
	   *     // componentType does not include subType
	   *     // (componentType is 'xxx' but not 'xxx.aa')
	   * });
	   * eachComponent(
	   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}},
	   *     function (model, index) {...}
	   * );
	   * eachComponent(
	   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}},
	   *     function (model, index) {...}
	   * );
	   *
	   * @param {string|Object=} mainType When mainType is object, the definition
	   *                                  is the same as the method 'findComponents'.
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachComponent: function (mainType, cb, context) {
	    var componentsMap = this._componentsMap;
	
	    if (typeof mainType === 'function') {
	      context = cb;
	      cb = mainType;
	      componentsMap.each(function (components, componentType) {
	        each(components, function (component, index) {
	          cb.call(context, componentType, component, index);
	        });
	      });
	    } else if (isString(mainType)) {
	      each(componentsMap.get(mainType), cb, context);
	    } else if (isObject(mainType)) {
	      var queryResult = this.findComponents(mainType);
	      each(queryResult, cb, context);
	    }
	  },
	
	  /**
	   * @param {string} name
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeriesByName: function (name) {
	    var series = this._componentsMap.get('series');
	
	    return filter(series, function (oneSeries) {
	      return oneSeries.name === name;
	    });
	  },
	
	  /**
	   * @param {number} seriesIndex
	   * @return {module:echarts/model/Series}
	   */
	  getSeriesByIndex: function (seriesIndex) {
	    return this._componentsMap.get('series')[seriesIndex];
	  },
	
	  /**
	   * Get series list before filtered by type.
	   * FIXME: rename to getRawSeriesByType?
	   *
	   * @param {string} subType
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeriesByType: function (subType) {
	    var series = this._componentsMap.get('series');
	
	    return filter(series, function (oneSeries) {
	      return oneSeries.subType === subType;
	    });
	  },
	
	  /**
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeries: function () {
	    return this._componentsMap.get('series').slice();
	  },
	
	  /**
	   * @return {number}
	   */
	  getSeriesCount: function () {
	    return this._componentsMap.get('series').length;
	  },
	
	  /**
	   * After filtering, series may be different
	   * frome raw series.
	   *
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachSeries: function (cb, context) {
	    assertSeriesInitialized(this);
	    each(this._seriesIndices, function (rawSeriesIndex) {
	      var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	      cb.call(context, series, rawSeriesIndex);
	    }, this);
	  },
	
	  /**
	   * Iterate raw series before filtered.
	   *
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachRawSeries: function (cb, context) {
	    each(this._componentsMap.get('series'), cb, context);
	  },
	
	  /**
	   * After filtering, series may be different.
	   * frome raw series.
	   *
	   * @param {string} subType.
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachSeriesByType: function (subType, cb, context) {
	    assertSeriesInitialized(this);
	    each(this._seriesIndices, function (rawSeriesIndex) {
	      var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	      if (series.subType === subType) {
	        cb.call(context, series, rawSeriesIndex);
	      }
	    }, this);
	  },
	
	  /**
	   * Iterate raw series before filtered of given type.
	   *
	   * @parma {string} subType
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachRawSeriesByType: function (subType, cb, context) {
	    return each(this.getSeriesByType(subType), cb, context);
	  },
	
	  /**
	   * @param {module:echarts/model/Series} seriesModel
	   */
	  isSeriesFiltered: function (seriesModel) {
	    assertSeriesInitialized(this);
	    return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getCurrentSeriesIndices: function () {
	    return (this._seriesIndices || []).slice();
	  },
	
	  /**
	   * @param {Function} cb
	   * @param {*} context
	   */
	  filterSeries: function (cb, context) {
	    assertSeriesInitialized(this);
	    var filteredSeries = filter(this._componentsMap.get('series'), cb, context);
	    createSeriesIndices(this, filteredSeries);
	  },
	  restoreData: function (payload) {
	    var componentsMap = this._componentsMap;
	    createSeriesIndices(this, componentsMap.get('series'));
	    var componentTypes = [];
	    componentsMap.each(function (components, componentType) {
	      componentTypes.push(componentType);
	    });
	    ComponentModel.topologicalTravel(componentTypes, ComponentModel.getAllClassMainTypes(), function (componentType, dependencies) {
	      each(componentsMap.get(componentType), function (component) {
	        (componentType !== 'series' || !isNotTargetSeries(component, payload)) && component.restoreData();
	      });
	    });
	  }
	});
	
	function isNotTargetSeries(seriesModel, payload) {
	  if (payload) {
	    var index = payload.seiresIndex;
	    var id = payload.seriesId;
	    var name = payload.seriesName;
	    return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name != null && seriesModel.name !== name;
	  }
	}
	/**
	 * @inner
	 */
	
	
	function mergeTheme(option, theme) {
	  // PENDING
	  // NOT use `colorLayer` in theme if option has `color`
	  var notMergeColorLayer = option.color && !option.colorLayer;
	  each(theme, function (themeItem, name) {
	    if (name === 'colorLayer' && notMergeColorLayer) {
	      return;
	    } // 如果有 component model 则把具体的 merge 逻辑交给该 model 处理
	
	
	    if (!ComponentModel.hasClass(name)) {
	      if (typeof themeItem === 'object') {
	        option[name] = !option[name] ? clone(themeItem) : merge(option[name], themeItem, false);
	      } else {
	        if (option[name] == null) {
	          option[name] = themeItem;
	        }
	      }
	    }
	  });
	}
	
	function initBase(baseOption) {
	  baseOption = baseOption; // Using OPTION_INNER_KEY to mark that this option can not be used outside,
	  // i.e. `chart.setOption(chart.getModel().option);` is forbiden.
	
	  this.option = {};
	  this.option[OPTION_INNER_KEY] = 1;
	  /**
	   * Init with series: [], in case of calling findSeries method
	   * before series initialized.
	   * @type {Object.<string, Array.<module:echarts/model/Model>>}
	   * @private
	   */
	
	  this._componentsMap = createHashMap({
	    series: []
	  });
	  /**
	   * Mapping between filtered series list and raw series list.
	   * key: filtered series indices, value: raw series indices.
	   * @type {Array.<nubmer>}
	   * @private
	   */
	
	  this._seriesIndices;
	  this._seriesIndicesMap;
	  mergeTheme(baseOption, this._theme.option); // TODO Needs clone when merging to the unexisted property
	
	  merge(baseOption, globalDefault, false);
	  this.mergeOption(baseOption);
	}
	/**
	 * @inner
	 * @param {Array.<string>|string} types model types
	 * @return {Object} key: {string} type, value: {Array.<Object>} models
	 */
	
	
	function getComponentsByTypes(componentsMap, types) {
	  if (!isArray(types)) {
	    types = types ? [types] : [];
	  }
	
	  var ret = {};
	  each(types, function (type) {
	    ret[type] = (componentsMap.get(type) || []).slice();
	  });
	  return ret;
	}
	/**
	 * @inner
	 */
	
	
	function determineSubType(mainType, newCptOption, existComponent) {
	  var subType = newCptOption.type ? newCptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
	  : ComponentModel.determineSubType(mainType, newCptOption); // tooltip, markline, markpoint may always has no subType
	
	  return subType;
	}
	/**
	 * @inner
	 */
	
	
	function createSeriesIndices(ecModel, seriesModels) {
	  ecModel._seriesIndicesMap = createHashMap(ecModel._seriesIndices = map(seriesModels, function (series) {
	    return series.componentIndex;
	  }) || []);
	}
	/**
	 * @inner
	 */
	
	
	function filterBySubType(components, condition) {
	  // Using hasOwnProperty for restrict. Consider
	  // subType is undefined in user payload.
	  return condition.hasOwnProperty('subType') ? filter(components, function (cpt) {
	    return cpt.subType === condition.subType;
	  }) : components;
	}
	/**
	 * @inner
	 */
	
	
	function assertSeriesInitialized(ecModel) {}
	
	mixin(GlobalModel, colorPaletteMixin);
	var _default = GlobalModel;
	module.exports = _default;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var env = __webpack_require__(219);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var isArray = zrUtil.isArray;
	/**
	 * Make the name displayable. But we should
	 * make sure it is not duplicated with user
	 * specified name, so use '\0';
	 */
	
	var DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
	/**
	 * If value is not array, then translate it to array.
	 * @param  {*} value
	 * @return {Array} [value] or value
	 */
	
	function normalizeToArray(value) {
	  return value instanceof Array ? value : value == null ? [] : [value];
	}
	/**
	 * Sync default option between normal and emphasis like `position` and `show`
	 * In case some one will write code like
	 *     label: {
	 *          show: false,
	 *          position: 'outside',
	 *          fontSize: 18
	 *     },
	 *     emphasis: {
	 *          label: { show: true }
	 *     }
	 * @param {Object} opt
	 * @param {string} key
	 * @param {Array.<string>} subOpts
	 */
	
	
	function defaultEmphasis(opt, key, subOpts) {
	  // Caution: performance sensitive.
	  if (opt) {
	    opt[key] = opt[key] || {};
	    opt.emphasis = opt.emphasis || {};
	    opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal
	
	    for (var i = 0, len = subOpts.length; i < len; i++) {
	      var subOptName = subOpts[i];
	
	      if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) {
	        opt.emphasis[key][subOptName] = opt[key][subOptName];
	      }
	    }
	  }
	}
	
	var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
	//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
	//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
	//     // FIXME: deprecated, check and remove it.
	//     'textStyle'
	// ]);
	
	/**
	 * The method do not ensure performance.
	 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	 * This helper method retieves value from data.
	 * @param {string|number|Date|Array|Object} dataItem
	 * @return {number|string|Date|Array.<number|string|Date>}
	 */
	
	function getDataItemValue(dataItem) {
	  return isObject(dataItem) && !isArray(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
	}
	/**
	 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	 * This helper method determine if dataItem has extra option besides value
	 * @param {string|number|Date|Array|Object} dataItem
	 */
	
	
	function isDataItemOption(dataItem) {
	  return isObject(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
	  // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
	}
	/**
	 * Mapping to exists for merge.
	 *
	 * @public
	 * @param {Array.<Object>|Array.<module:echarts/model/Component>} exists
	 * @param {Object|Array.<Object>} newCptOptions
	 * @return {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
	 *                          index of which is the same as exists.
	 */
	
	
	function mappingToExists(exists, newCptOptions) {
	  // Mapping by the order by original option (but not order of
	  // new option) in merge mode. Because we should ensure
	  // some specified index (like xAxisIndex) is consistent with
	  // original option, which is easy to understand, espatially in
	  // media query. And in most case, merge option is used to
	  // update partial option but not be expected to change order.
	  newCptOptions = (newCptOptions || []).slice();
	  var result = zrUtil.map(exists || [], function (obj, index) {
	    return {
	      exist: obj
	    };
	  }); // Mapping by id or name if specified.
	
	  each(newCptOptions, function (cptOption, index) {
	    if (!isObject(cptOption)) {
	      return;
	    } // id has highest priority.
	
	
	    for (var i = 0; i < result.length; i++) {
	      if (!result[i].option // Consider name: two map to one.
	      && cptOption.id != null && result[i].exist.id === cptOption.id + '') {
	        result[i].option = cptOption;
	        newCptOptions[index] = null;
	        return;
	      }
	    }
	
	    for (var i = 0; i < result.length; i++) {
	      var exist = result[i].exist;
	
	      if (!result[i].option // Consider name: two map to one.
	      // Can not match when both ids exist but different.
	      && (exist.id == null || cptOption.id == null) && cptOption.name != null && !isIdInner(cptOption) && !isIdInner(exist) && exist.name === cptOption.name + '') {
	        result[i].option = cptOption;
	        newCptOptions[index] = null;
	        return;
	      }
	    }
	  }); // Otherwise mapping by index.
	
	  each(newCptOptions, function (cptOption, index) {
	    if (!isObject(cptOption)) {
	      return;
	    }
	
	    var i = 0;
	
	    for (; i < result.length; i++) {
	      var exist = result[i].exist;
	
	      if (!result[i].option // Existing model that already has id should be able to
	      // mapped to (because after mapping performed model may
	      // be assigned with a id, whish should not affect next
	      // mapping), except those has inner id.
	      && !isIdInner(exist) // Caution:
	      // Do not overwrite id. But name can be overwritten,
	      // because axis use name as 'show label text'.
	      // 'exist' always has id and name and we dont
	      // need to check it.
	      && cptOption.id == null) {
	        result[i].option = cptOption;
	        break;
	      }
	    }
	
	    if (i >= result.length) {
	      result.push({
	        option: cptOption
	      });
	    }
	  });
	  return result;
	}
	/**
	 * Make id and name for mapping result (result of mappingToExists)
	 * into `keyInfo` field.
	 *
	 * @public
	 * @param {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
	 *                          which order is the same as exists.
	 * @return {Array.<Object>} The input.
	 */
	
	
	function makeIdAndName(mapResult) {
	  // We use this id to hash component models and view instances
	  // in echarts. id can be specified by user, or auto generated.
	  // The id generation rule ensures new view instance are able
	  // to mapped to old instance when setOption are called in
	  // no-merge mode. So we generate model id by name and plus
	  // type in view id.
	  // name can be duplicated among components, which is convenient
	  // to specify multi components (like series) by one name.
	  // Ensure that each id is distinct.
	  var idMap = zrUtil.createHashMap();
	  each(mapResult, function (item, index) {
	    var existCpt = item.exist;
	    existCpt && idMap.set(existCpt.id, item);
	  });
	  each(mapResult, function (item, index) {
	    var opt = item.option;
	    zrUtil.assert(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
	    opt && opt.id != null && idMap.set(opt.id, item);
	    !item.keyInfo && (item.keyInfo = {});
	  }); // Make name and id.
	
	  each(mapResult, function (item, index) {
	    var existCpt = item.exist;
	    var opt = item.option;
	    var keyInfo = item.keyInfo;
	
	    if (!isObject(opt)) {
	      return;
	    } // name can be overwitten. Consider case: axis.name = '20km'.
	    // But id generated by name will not be changed, which affect
	    // only in that case: setOption with 'not merge mode' and view
	    // instance will be recreated, which can be accepted.
	
	
	    keyInfo.name = opt.name != null ? opt.name + '' : existCpt ? existCpt.name // Avoid diffferent series has the same name,
	    // because name may be used like in color pallet.
	    : DUMMY_COMPONENT_NAME_PREFIX + index;
	
	    if (existCpt) {
	      keyInfo.id = existCpt.id;
	    } else if (opt.id != null) {
	      keyInfo.id = opt.id + '';
	    } else {
	      // Consider this situatoin:
	      //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
	      //  optionB [{..}, {name: 'a'}, {name: 'a'}]
	      // Series with the same name between optionA and optionB
	      // should be mapped.
	      var idNum = 0;
	
	      do {
	        keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
	      } while (idMap.get(keyInfo.id));
	    }
	
	    idMap.set(keyInfo.id, item);
	  });
	}
	
	function isNameSpecified(componentModel) {
	  var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.
	
	  return !!(name && name.indexOf(DUMMY_COMPONENT_NAME_PREFIX));
	}
	/**
	 * @public
	 * @param {Object} cptOption
	 * @return {boolean}
	 */
	
	
	function isIdInner(cptOption) {
	  return isObject(cptOption) && cptOption.id && (cptOption.id + '').indexOf('\0_ec_\0') === 0;
	}
	/**
	 * A helper for removing duplicate items between batchA and batchB,
	 * and in themselves, and categorize by series.
	 *
	 * @param {Array.<Object>} batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	 * @param {Array.<Object>} batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	 * @return {Array.<Array.<Object>, Array.<Object>>} result: [resultBatchA, resultBatchB]
	 */
	
	
	function compressBatches(batchA, batchB) {
	  var mapA = {};
	  var mapB = {};
	  makeMap(batchA || [], mapA);
	  makeMap(batchB || [], mapB, mapA);
	  return [mapToArray(mapA), mapToArray(mapB)];
	
	  function makeMap(sourceBatch, map, otherMap) {
	    for (var i = 0, len = sourceBatch.length; i < len; i++) {
	      var seriesId = sourceBatch[i].seriesId;
	      var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
	      var otherDataIndices = otherMap && otherMap[seriesId];
	
	      for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
	        var dataIndex = dataIndices[j];
	
	        if (otherDataIndices && otherDataIndices[dataIndex]) {
	          otherDataIndices[dataIndex] = null;
	        } else {
	          (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
	        }
	      }
	    }
	  }
	
	  function mapToArray(map, isData) {
	    var result = [];
	
	    for (var i in map) {
	      if (map.hasOwnProperty(i) && map[i] != null) {
	        if (isData) {
	          result.push(+i);
	        } else {
	          var dataIndices = mapToArray(map[i], true);
	          dataIndices.length && result.push({
	            seriesId: i,
	            dataIndex: dataIndices
	          });
	        }
	      }
	    }
	
	    return result;
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
	 *                         each of which can be Array or primary type.
	 * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
	 */
	
	
	function queryDataIndex(data, payload) {
	  if (payload.dataIndexInside != null) {
	    return payload.dataIndexInside;
	  } else if (payload.dataIndex != null) {
	    return zrUtil.isArray(payload.dataIndex) ? zrUtil.map(payload.dataIndex, function (value) {
	      return data.indexOfRawIndex(value);
	    }) : data.indexOfRawIndex(payload.dataIndex);
	  } else if (payload.name != null) {
	    return zrUtil.isArray(payload.name) ? zrUtil.map(payload.name, function (value) {
	      return data.indexOfName(value);
	    }) : data.indexOfName(payload.name);
	  }
	}
	/**
	 * Enable property storage to any host object.
	 * Notice: Serialization is not supported.
	 *
	 * For example:
	 * var inner = zrUitl.makeInner();
	 *
	 * function some1(hostObj) {
	 *      inner(hostObj).someProperty = 1212;
	 *      ...
	 * }
	 * function some2() {
	 *      var fields = inner(this);
	 *      fields.someProperty1 = 1212;
	 *      fields.someProperty2 = 'xx';
	 *      ...
	 * }
	 *
	 * @return {Function}
	 */
	
	
	function makeInner() {
	  // Consider different scope by es module import.
	  var key = '__\0ec_inner_' + innerUniqueIndex++ + '_' + Math.random().toFixed(5);
	  return function (hostObj) {
	    return hostObj[key] || (hostObj[key] = {});
	  };
	}
	
	var innerUniqueIndex = 0;
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex, seriesId, seriesName,
	 *            geoIndex, geoId, geoName,
	 *            bmapIndex, bmapId, bmapName,
	 *            xAxisIndex, xAxisId, xAxisName,
	 *            yAxisIndex, yAxisId, yAxisName,
	 *            gridIndex, gridId, gridName,
	 *            ... (can be extended)
	 *        }
	 *        Each properties can be number|string|Array.<number>|Array.<string>
	 *        For example, a finder could be
	 *        {
	 *            seriesIndex: 3,
	 *            geoId: ['aa', 'cc'],
	 *            gridName: ['xx', 'rr']
	 *        }
	 *        xxxIndex can be set as 'all' (means all xxx) or 'none' (means not specify)
	 *        If nothing or null/undefined specified, return nothing.
	 * @param {Object} [opt]
	 * @param {string} [opt.defaultMainType]
	 * @param {Array.<string>} [opt.includeMainTypes]
	 * @return {Object} result like:
	 *        {
	 *            seriesModels: [seriesModel1, seriesModel2],
	 *            seriesModel: seriesModel1, // The first model
	 *            geoModels: [geoModel1, geoModel2],
	 *            geoModel: geoModel1, // The first model
	 *            ...
	 *        }
	 */
	
	function parseFinder(ecModel, finder, opt) {
	  if (zrUtil.isString(finder)) {
	    var obj = {};
	    obj[finder + 'Index'] = 0;
	    finder = obj;
	  }
	
	  var defaultMainType = opt && opt.defaultMainType;
	
	  if (defaultMainType && !has(finder, defaultMainType + 'Index') && !has(finder, defaultMainType + 'Id') && !has(finder, defaultMainType + 'Name')) {
	    finder[defaultMainType + 'Index'] = 0;
	  }
	
	  var result = {};
	  each(finder, function (value, key) {
	    var value = finder[key]; // Exclude 'dataIndex' and other illgal keys.
	
	    if (key === 'dataIndex' || key === 'dataIndexInside') {
	      result[key] = value;
	      return;
	    }
	
	    var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
	    var mainType = parsedKey[1];
	    var queryType = (parsedKey[2] || '').toLowerCase();
	
	    if (!mainType || !queryType || value == null || queryType === 'index' && value === 'none' || opt && opt.includeMainTypes && zrUtil.indexOf(opt.includeMainTypes, mainType) < 0) {
	      return;
	    }
	
	    var queryParam = {
	      mainType: mainType
	    };
	
	    if (queryType !== 'index' || value !== 'all') {
	      queryParam[queryType] = value;
	    }
	
	    var models = ecModel.queryComponents(queryParam);
	    result[mainType + 'Models'] = models;
	    result[mainType + 'Model'] = models[0];
	  });
	  return result;
	}
	
	function has(obj, prop) {
	  return obj && obj.hasOwnProperty(prop);
	}
	
	function setAttribute(dom, key, value) {
	  dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
	}
	
	function getAttribute(dom, key) {
	  return dom.getAttribute ? dom.getAttribute(key) : dom[key];
	}
	
	function getTooltipRenderMode(renderModeOption) {
	  if (renderModeOption === 'auto') {
	    // Using html when `document` exists, use richText otherwise
	    return env.domSupported ? 'html' : 'richText';
	  } else {
	    return renderModeOption || 'html';
	  }
	}
	/**
	 * Group a list by key.
	 *
	 * @param {Array} array
	 * @param {Function} getKey
	 *        param {*} Array item
	 *        return {string} key
	 * @return {Object} Result
	 *        {Array}: keys,
	 *        {module:zrender/core/util/HashMap} buckets: {key -> Array}
	 */
	
	
	function groupData(array, getKey) {
	  var buckets = zrUtil.createHashMap();
	  var keys = [];
	  zrUtil.each(array, function (item) {
	    var key = getKey(item);
	    (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
	  });
	  return {
	    keys: keys,
	    buckets: buckets
	  };
	}
	
	exports.normalizeToArray = normalizeToArray;
	exports.defaultEmphasis = defaultEmphasis;
	exports.TEXT_STYLE_OPTIONS = TEXT_STYLE_OPTIONS;
	exports.getDataItemValue = getDataItemValue;
	exports.isDataItemOption = isDataItemOption;
	exports.mappingToExists = mappingToExists;
	exports.makeIdAndName = makeIdAndName;
	exports.isNameSpecified = isNameSpecified;
	exports.isIdInner = isIdInner;
	exports.compressBatches = compressBatches;
	exports.queryDataIndex = queryDataIndex;
	exports.makeInner = makeInner;
	exports.parseFinder = parseFinder;
	exports.setAttribute = setAttribute;
	exports.getAttribute = getAttribute;
	exports.getTooltipRenderMode = getTooltipRenderMode;
	exports.groupData = groupData;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var env = __webpack_require__(219);
	
	var _model = __webpack_require__(261);
	
	var makeInner = _model.makeInner;
	
	var _clazz = __webpack_require__(263);
	
	var enableClassExtend = _clazz.enableClassExtend;
	var enableClassCheck = _clazz.enableClassCheck;
	
	var lineStyleMixin = __webpack_require__(264);
	
	var areaStyleMixin = __webpack_require__(266);
	
	var textStyleMixin = __webpack_require__(267);
	
	var itemStyleMixin = __webpack_require__(302);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/model/Model
	 */
	var mixin = zrUtil.mixin;
	var inner = makeInner();
	/**
	 * @alias module:echarts/model/Model
	 * @constructor
	 * @param {Object} [option]
	 * @param {module:echarts/model/Model} [parentModel]
	 * @param {module:echarts/model/Global} [ecModel]
	 */
	
	function Model(option, parentModel, ecModel) {
	  /**
	   * @type {module:echarts/model/Model}
	   * @readOnly
	   */
	  this.parentModel = parentModel;
	  /**
	   * @type {module:echarts/model/Global}
	   * @readOnly
	   */
	
	  this.ecModel = ecModel;
	  /**
	   * @type {Object}
	   * @protected
	   */
	
	  this.option = option; // Simple optimization
	  // if (this.init) {
	  //     if (arguments.length <= 4) {
	  //         this.init(option, parentModel, ecModel, extraOpt);
	  //     }
	  //     else {
	  //         this.init.apply(this, arguments);
	  //     }
	  // }
	}
	
	Model.prototype = {
	  constructor: Model,
	
	  /**
	   * Model 的初始化函数
	   * @param {Object} option
	   */
	  init: null,
	
	  /**
	   * 从新的 Option merge
	   */
	  mergeOption: function (option) {
	    zrUtil.merge(this.option, option, true);
	  },
	
	  /**
	   * @param {string|Array.<string>} path
	   * @param {boolean} [ignoreParent=false]
	   * @return {*}
	   */
	  get: function (path, ignoreParent) {
	    if (path == null) {
	      return this.option;
	    }
	
	    return doGet(this.option, this.parsePath(path), !ignoreParent && getParent(this, path));
	  },
	
	  /**
	   * @param {string} key
	   * @param {boolean} [ignoreParent=false]
	   * @return {*}
	   */
	  getShallow: function (key, ignoreParent) {
	    var option = this.option;
	    var val = option == null ? option : option[key];
	    var parentModel = !ignoreParent && getParent(this, key);
	
	    if (val == null && parentModel) {
	      val = parentModel.getShallow(key);
	    }
	
	    return val;
	  },
	
	  /**
	   * @param {string|Array.<string>} [path]
	   * @param {module:echarts/model/Model} [parentModel]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path, parentModel) {
	    var obj = path == null ? this.option : doGet(this.option, path = this.parsePath(path));
	    var thisParentModel;
	    parentModel = parentModel || (thisParentModel = getParent(this, path)) && thisParentModel.getModel(path);
	    return new Model(obj, parentModel, this.ecModel);
	  },
	
	  /**
	   * If model has option
	   */
	  isEmpty: function () {
	    return this.option == null;
	  },
	  restoreData: function () {},
	  // Pending
	  clone: function () {
	    var Ctor = this.constructor;
	    return new Ctor(zrUtil.clone(this.option));
	  },
	  setReadOnly: function (properties) {// clazzUtil.setReadOnly(this, properties);
	  },
	  // If path is null/undefined, return null/undefined.
	  parsePath: function (path) {
	    if (typeof path === 'string') {
	      path = path.split('.');
	    }
	
	    return path;
	  },
	
	  /**
	   * @param {Function} getParentMethod
	   *        param {Array.<string>|string} path
	   *        return {module:echarts/model/Model}
	   */
	  customizeGetParent: function (getParentMethod) {
	    inner(this).getParent = getParentMethod;
	  },
	  isAnimationEnabled: function () {
	    if (!env.node) {
	      if (this.option.animation != null) {
	        return !!this.option.animation;
	      } else if (this.parentModel) {
	        return this.parentModel.isAnimationEnabled();
	      }
	    }
	  }
	};
	
	function doGet(obj, pathArr, parentModel) {
	  for (var i = 0; i < pathArr.length; i++) {
	    // Ignore empty
	    if (!pathArr[i]) {
	      continue;
	    } // obj could be number/string/... (like 0)
	
	
	    obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
	
	    if (obj == null) {
	      break;
	    }
	  }
	
	  if (obj == null && parentModel) {
	    obj = parentModel.get(pathArr);
	  }
	
	  return obj;
	} // `path` can be null/undefined
	
	
	function getParent(model, path) {
	  var getParentMethod = inner(model).getParent;
	  return getParentMethod ? getParentMethod.call(model, path) : model.parentModel;
	} // Enable Model.extend.
	
	
	enableClassExtend(Model);
	enableClassCheck(Model);
	mixin(Model, lineStyleMixin);
	mixin(Model, areaStyleMixin);
	mixin(Model, textStyleMixin);
	mixin(Model, itemStyleMixin);
	var _default = Model;
	module.exports = _default;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TYPE_DELIMITER = '.';
	var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
	/**
	 * Notice, parseClassType('') should returns {main: '', sub: ''}
	 * @public
	 */
	
	function parseClassType(componentType) {
	  var ret = {
	    main: '',
	    sub: ''
	  };
	
	  if (componentType) {
	    componentType = componentType.split(TYPE_DELIMITER);
	    ret.main = componentType[0] || '';
	    ret.sub = componentType[1] || '';
	  }
	
	  return ret;
	}
	/**
	 * @public
	 */
	
	
	function checkClassType(componentType) {
	  zrUtil.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
	}
	/**
	 * @public
	 */
	
	
	function enableClassExtend(RootClass, mandatoryMethods) {
	  RootClass.$constructor = RootClass;
	
	  RootClass.extend = function (proto) {
	    var superClass = this;
	
	    var ExtendedClass = function () {
	      if (!proto.$constructor) {
	        superClass.apply(this, arguments);
	      } else {
	        proto.$constructor.apply(this, arguments);
	      }
	    };
	
	    zrUtil.extend(ExtendedClass.prototype, proto);
	    ExtendedClass.extend = this.extend;
	    ExtendedClass.superCall = superCall;
	    ExtendedClass.superApply = superApply;
	    zrUtil.inherits(ExtendedClass, this);
	    ExtendedClass.superClass = superClass;
	    return ExtendedClass;
	  };
	}
	
	var classBase = 0;
	/**
	 * Can not use instanceof, consider different scope by
	 * cross domain or es module import in ec extensions.
	 * Mount a method "isInstance()" to Clz.
	 */
	
	function enableClassCheck(Clz) {
	  var classAttr = ['__\0is_clz', classBase++, Math.random().toFixed(3)].join('_');
	  Clz.prototype[classAttr] = true;
	
	  Clz.isInstance = function (obj) {
	    return !!(obj && obj[classAttr]);
	  };
	} // superCall should have class info, which can not be fetch from 'this'.
	// Consider this case:
	// class A has method f,
	// class B inherits class A, overrides method f, f call superApply('f'),
	// class C inherits class B, do not overrides method f,
	// then when method of class C is called, dead loop occured.
	
	
	function superCall(context, methodName) {
	  var args = zrUtil.slice(arguments, 2);
	  return this.superClass.prototype[methodName].apply(context, args);
	}
	
	function superApply(context, methodName, args) {
	  return this.superClass.prototype[methodName].apply(context, args);
	}
	/**
	 * @param {Object} entity
	 * @param {Object} options
	 * @param {boolean} [options.registerWhenExtend]
	 * @public
	 */
	
	
	function enableClassManagement(entity, options) {
	  options = options || {};
	  /**
	   * Component model classes
	   * key: componentType,
	   * value:
	   *     componentClass, when componentType is 'xxx'
	   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
	   * @type {Object}
	   */
	
	  var storage = {};
	
	  entity.registerClass = function (Clazz, componentType) {
	    if (componentType) {
	      checkClassType(componentType);
	      componentType = parseClassType(componentType);
	
	      if (!componentType.sub) {
	        storage[componentType.main] = Clazz;
	      } else if (componentType.sub !== IS_CONTAINER) {
	        var container = makeContainer(componentType);
	        container[componentType.sub] = Clazz;
	      }
	    }
	
	    return Clazz;
	  };
	
	  entity.getClass = function (componentMainType, subType, throwWhenNotFound) {
	    var Clazz = storage[componentMainType];
	
	    if (Clazz && Clazz[IS_CONTAINER]) {
	      Clazz = subType ? Clazz[subType] : null;
	    }
	
	    if (throwWhenNotFound && !Clazz) {
	      throw new Error(!subType ? componentMainType + '.' + 'type should be specified.' : 'Component ' + componentMainType + '.' + (subType || '') + ' not exists. Load it first.');
	    }
	
	    return Clazz;
	  };
	
	  entity.getClassesByMainType = function (componentType) {
	    componentType = parseClassType(componentType);
	    var result = [];
	    var obj = storage[componentType.main];
	
	    if (obj && obj[IS_CONTAINER]) {
	      zrUtil.each(obj, function (o, type) {
	        type !== IS_CONTAINER && result.push(o);
	      });
	    } else {
	      result.push(obj);
	    }
	
	    return result;
	  };
	
	  entity.hasClass = function (componentType) {
	    // Just consider componentType.main.
	    componentType = parseClassType(componentType);
	    return !!storage[componentType.main];
	  };
	  /**
	   * @return {Array.<string>} Like ['aa', 'bb'], but can not be ['aa.xx']
	   */
	
	
	  entity.getAllClassMainTypes = function () {
	    var types = [];
	    zrUtil.each(storage, function (obj, type) {
	      types.push(type);
	    });
	    return types;
	  };
	  /**
	   * If a main type is container and has sub types
	   * @param  {string}  mainType
	   * @return {boolean}
	   */
	
	
	  entity.hasSubTypes = function (componentType) {
	    componentType = parseClassType(componentType);
	    var obj = storage[componentType.main];
	    return obj && obj[IS_CONTAINER];
	  };
	
	  entity.parseClassType = parseClassType;
	
	  function makeContainer(componentType) {
	    var container = storage[componentType.main];
	
	    if (!container || !container[IS_CONTAINER]) {
	      container = storage[componentType.main] = {};
	      container[IS_CONTAINER] = true;
	    }
	
	    return container;
	  }
	
	  if (options.registerWhenExtend) {
	    var originalExtend = entity.extend;
	
	    if (originalExtend) {
	      entity.extend = function (proto) {
	        var ExtendedClass = originalExtend.call(this, proto);
	        return entity.registerClass(ExtendedClass, proto.type);
	      };
	    }
	  }
	
	  return entity;
	}
	/**
	 * @param {string|Array.<string>} properties
	 */
	
	
	function setReadOnly(obj, properties) {// FIXME It seems broken in IE8 simulation of IE11
	  // if (!zrUtil.isArray(properties)) {
	  //     properties = properties != null ? [properties] : [];
	  // }
	  // zrUtil.each(properties, function (prop) {
	  //     var value = obj[prop];
	  //     Object.defineProperty
	  //         && Object.defineProperty(obj, prop, {
	  //             value: value, writable: false
	  //         });
	  //     zrUtil.isArray(obj[prop])
	  //         && Object.freeze
	  //         && Object.freeze(obj[prop]);
	  // });
	}
	
	exports.parseClassType = parseClassType;
	exports.enableClassExtend = enableClassExtend;
	exports.enableClassCheck = enableClassCheck;
	exports.enableClassManagement = enableClassManagement;
	exports.setReadOnly = setReadOnly;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(265);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getLineStyle = makeStyleMapper([['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	var _default = {
	  getLineStyle: function (excludes) {
	    var style = getLineStyle(this, excludes); // Always set lineDash whether dashed, otherwise we can not
	    // erase the previous style when assigning to el.style.
	
	    style.lineDash = this.getLineDash(style.lineWidth);
	    return style;
	  },
	  getLineDash: function (lineWidth) {
	    if (lineWidth == null) {
	      lineWidth = 1;
	    }
	
	    var lineType = this.get('type');
	    var dotSize = Math.max(lineWidth, 2);
	    var dashSize = lineWidth * 4;
	    return lineType === 'solid' || lineType == null ? // Use `false` but not `null` for the solid line here, because `null` might be
	    // ignored when assigning to `el.style`. e.g., when setting `lineStyle.type` as
	    // `'dashed'` and `emphasis.lineStyle.type` as `'solid'` in graph series, the
	    // `lineDash` gotten form the latter one is not able to erase that from the former
	    // one if using `null` here according to the emhpsis strategy in `util/graphic.js`.
	    false : lineType === 'dashed' ? [dashSize, dashSize] : [dotSize, dotSize];
	  }
	};
	module.exports = _default;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Parse shadow style
	// TODO Only shallow path support
	function _default(properties) {
	  // Normalize
	  for (var i = 0; i < properties.length; i++) {
	    if (!properties[i][1]) {
	      properties[i][1] = properties[i][0];
	    }
	  }
	
	  return function (model, excludes, includes) {
	    var style = {};
	
	    for (var i = 0; i < properties.length; i++) {
	      var propName = properties[i][1];
	
	      if (excludes && zrUtil.indexOf(excludes, propName) >= 0 || includes && zrUtil.indexOf(includes, propName) < 0) {
	        continue;
	      }
	
	      var val = model.getShallow(propName);
	
	      if (val != null) {
	        style[properties[i][0]] = val;
	      }
	    }
	
	    return style;
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(265);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getAreaStyle = makeStyleMapper([['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor']]);
	var _default = {
	  getAreaStyle: function (excludes, includes) {
	    return getAreaStyle(this, excludes, includes);
	  }
	};
	module.exports = _default;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var textContain = __webpack_require__(255);
	
	var graphicUtil = __webpack_require__(268);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PATH_COLOR = ['textStyle', 'color'];
	var _default = {
	  /**
	   * Get color property or get color from option.textStyle.color
	   * @param {boolean} [isEmphasis]
	   * @return {string}
	   */
	  getTextColor: function (isEmphasis) {
	    var ecModel = this.ecModel;
	    return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
	  },
	
	  /**
	   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
	   * @return {string}
	   */
	  getFont: function () {
	    return graphicUtil.getFont({
	      fontStyle: this.getShallow('fontStyle'),
	      fontWeight: this.getShallow('fontWeight'),
	      fontSize: this.getShallow('fontSize'),
	      fontFamily: this.getShallow('fontFamily')
	    }, this.ecModel);
	  },
	  getTextRect: function (text) {
	    return textContain.getBoundingRect(text, this.getFont(), this.getShallow('align'), this.getShallow('verticalAlign') || this.getShallow('baseline'), this.getShallow('padding'), this.getShallow('lineHeight'), this.getShallow('rich'), this.getShallow('truncateText'));
	  }
	};
	module.exports = _default;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var pathTool = __webpack_require__(269);
	
	var colorTool = __webpack_require__(238);
	
	var matrix = __webpack_require__(233);
	
	var vector = __webpack_require__(222);
	
	var Path = __webpack_require__(270);
	
	var Transformable = __webpack_require__(232);
	
	var ZImage = __webpack_require__(251);
	
	exports.Image = ZImage;
	
	var Group = __webpack_require__(230);
	
	exports.Group = Group;
	
	var Text = __webpack_require__(282);
	
	exports.Text = Text;
	
	var Circle = __webpack_require__(283);
	
	exports.Circle = Circle;
	
	var Sector = __webpack_require__(284);
	
	exports.Sector = Sector;
	
	var Ring = __webpack_require__(286);
	
	exports.Ring = Ring;
	
	var Polygon = __webpack_require__(287);
	
	exports.Polygon = Polygon;
	
	var Polyline = __webpack_require__(291);
	
	exports.Polyline = Polyline;
	
	var Rect = __webpack_require__(292);
	
	exports.Rect = Rect;
	
	var Line = __webpack_require__(294);
	
	exports.Line = Line;
	
	var BezierCurve = __webpack_require__(295);
	
	exports.BezierCurve = BezierCurve;
	
	var Arc = __webpack_require__(296);
	
	exports.Arc = Arc;
	
	var CompoundPath = __webpack_require__(297);
	
	exports.CompoundPath = CompoundPath;
	
	var LinearGradient = __webpack_require__(298);
	
	exports.LinearGradient = LinearGradient;
	
	var RadialGradient = __webpack_require__(300);
	
	exports.RadialGradient = RadialGradient;
	
	var BoundingRect = __webpack_require__(242);
	
	exports.BoundingRect = BoundingRect;
	
	var IncrementalDisplayable = __webpack_require__(301);
	
	exports.IncrementalDisplayable = IncrementalDisplayable;
	
	var subPixelOptimizeUtil = __webpack_require__(293);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var mathMax = Math.max;
	var mathMin = Math.min;
	var EMPTY_OBJ = {};
	var Z2_EMPHASIS_LIFT = 1; // key: label model property nane, value: style property name.
	
	var CACHED_LABEL_STYLE_PROPERTIES = {
	  color: 'textFill',
	  textBorderColor: 'textStroke',
	  textBorderWidth: 'textStrokeWidth'
	};
	var EMPHASIS = 'emphasis';
	var NORMAL = 'normal'; // Reserve 0 as default.
	
	var _highlightNextDigit = 1;
	var _highlightKeyMap = {};
	var _customShapeMap = {};
	/**
	 * Extend shape with parameters
	 */
	
	function extendShape(opts) {
	  return Path.extend(opts);
	}
	/**
	 * Extend path
	 */
	
	
	function extendPath(pathData, opts) {
	  return pathTool.extendFromString(pathData, opts);
	}
	/**
	 * Register a user defined shape.
	 * The shape class can be fetched by `getShapeClass`
	 * This method will overwrite the registered shapes, including
	 * the registered built-in shapes, if using the same `name`.
	 * The shape can be used in `custom series` and
	 * `graphic component` by declaring `{type: name}`.
	 *
	 * @param {string} name
	 * @param {Object} ShapeClass Can be generated by `extendShape`.
	 */
	
	
	function registerShape(name, ShapeClass) {
	  _customShapeMap[name] = ShapeClass;
	}
	/**
	 * Find shape class registered by `registerShape`. Usually used in
	 * fetching user defined shape.
	 *
	 * [Caution]:
	 * (1) This method **MUST NOT be used inside echarts !!!**, unless it is prepared
	 * to use user registered shapes.
	 * Because the built-in shape (see `getBuiltInShape`) will be registered by
	 * `registerShape` by default. That enables users to get both built-in
	 * shapes as well as the shapes belonging to themsleves. But users can overwrite
	 * the built-in shapes by using names like 'circle', 'rect' via calling
	 * `registerShape`. So the echarts inner featrues should not fetch shapes from here
	 * in case that it is overwritten by users, except that some features, like
	 * `custom series`, `graphic component`, do it deliberately.
	 *
	 * (2) In the features like `custom series`, `graphic component`, the user input
	 * `{tpye: 'xxx'}` does not only specify shapes but also specify other graphic
	 * elements like `'group'`, `'text'`, `'image'` or event `'path'`. Those names
	 * are reserved names, that is, if some user register a shape named `'image'`,
	 * the shape will not be used. If we intending to add some more reserved names
	 * in feature, that might bring break changes (disable some existing user shape
	 * names). But that case probably rearly happen. So we dont make more mechanism
	 * to resolve this issue here.
	 *
	 * @param {string} name
	 * @return {Object} The shape class. If not found, return nothing.
	 */
	
	
	function getShapeClass(name) {
	  if (_customShapeMap.hasOwnProperty(name)) {
	    return _customShapeMap[name];
	  }
	}
	/**
	 * Create a path element from path data string
	 * @param {string} pathData
	 * @param {Object} opts
	 * @param {module:zrender/core/BoundingRect} rect
	 * @param {string} [layout=cover] 'center' or 'cover'
	 */
	
	
	function makePath(pathData, opts, rect, layout) {
	  var path = pathTool.createFromString(pathData, opts);
	
	  if (rect) {
	    if (layout === 'center') {
	      rect = centerGraphic(rect, path.getBoundingRect());
	    }
	
	    resizePath(path, rect);
	  }
	
	  return path;
	}
	/**
	 * Create a image element from image url
	 * @param {string} imageUrl image url
	 * @param {Object} opts options
	 * @param {module:zrender/core/BoundingRect} rect constrain rect
	 * @param {string} [layout=cover] 'center' or 'cover'
	 */
	
	
	function makeImage(imageUrl, rect, layout) {
	  var path = new ZImage({
	    style: {
	      image: imageUrl,
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    onload: function (img) {
	      if (layout === 'center') {
	        var boundingRect = {
	          width: img.width,
	          height: img.height
	        };
	        path.setStyle(centerGraphic(rect, boundingRect));
	      }
	    }
	  });
	  return path;
	}
	/**
	 * Get position of centered element in bounding box.
	 *
	 * @param  {Object} rect         element local bounding box
	 * @param  {Object} boundingRect constraint bounding box
	 * @return {Object} element position containing x, y, width, and height
	 */
	
	
	function centerGraphic(rect, boundingRect) {
	  // Set rect to center, keep width / height ratio.
	  var aspect = boundingRect.width / boundingRect.height;
	  var width = rect.height * aspect;
	  var height;
	
	  if (width <= rect.width) {
	    height = rect.height;
	  } else {
	    width = rect.width;
	    height = width / aspect;
	  }
	
	  var cx = rect.x + rect.width / 2;
	  var cy = rect.y + rect.height / 2;
	  return {
	    x: cx - width / 2,
	    y: cy - height / 2,
	    width: width,
	    height: height
	  };
	}
	
	var mergePath = pathTool.mergePath;
	/**
	 * Resize a path to fit the rect
	 * @param {module:zrender/graphic/Path} path
	 * @param {Object} rect
	 */
	
	function resizePath(path, rect) {
	  if (!path.applyTransform) {
	    return;
	  }
	
	  var pathRect = path.getBoundingRect();
	  var m = pathRect.calculateTransform(rect);
	  path.applyTransform(m);
	}
	/**
	 * Sub pixel optimize line for canvas
	 *
	 * @param {Object} param
	 * @param {Object} [param.shape]
	 * @param {number} [param.shape.x1]
	 * @param {number} [param.shape.y1]
	 * @param {number} [param.shape.x2]
	 * @param {number} [param.shape.y2]
	 * @param {Object} [param.style]
	 * @param {number} [param.style.lineWidth]
	 * @return {Object} Modified param
	 */
	
	
	function subPixelOptimizeLine(param) {
	  subPixelOptimizeUtil.subPixelOptimizeLine(param.shape, param.shape, param.style);
	  return param;
	}
	/**
	 * Sub pixel optimize rect for canvas
	 *
	 * @param {Object} param
	 * @param {Object} [param.shape]
	 * @param {number} [param.shape.x]
	 * @param {number} [param.shape.y]
	 * @param {number} [param.shape.width]
	 * @param {number} [param.shape.height]
	 * @param {Object} [param.style]
	 * @param {number} [param.style.lineWidth]
	 * @return {Object} Modified param
	 */
	
	
	function subPixelOptimizeRect(param) {
	  subPixelOptimizeUtil.subPixelOptimizeRect(param.shape, param.shape, param.style);
	  return param;
	}
	/**
	 * Sub pixel optimize for canvas
	 *
	 * @param {number} position Coordinate, such as x, y
	 * @param {number} lineWidth Should be nonnegative integer.
	 * @param {boolean=} positiveOrNegative Default false (negative).
	 * @return {number} Optimized position.
	 */
	
	
	var subPixelOptimize = subPixelOptimizeUtil.subPixelOptimize;
	
	function hasFillOrStroke(fillOrStroke) {
	  return fillOrStroke != null && fillOrStroke !== 'none';
	} // Most lifted color are duplicated.
	
	
	var liftedColorMap = zrUtil.createHashMap();
	var liftedColorCount = 0;
	
	function liftColor(color) {
	  if (typeof color !== 'string') {
	    return color;
	  }
	
	  var liftedColor = liftedColorMap.get(color);
	
	  if (!liftedColor) {
	    liftedColor = colorTool.lift(color, -0.1);
	
	    if (liftedColorCount < 10000) {
	      liftedColorMap.set(color, liftedColor);
	      liftedColorCount++;
	    }
	  }
	
	  return liftedColor;
	}
	
	function cacheElementStl(el) {
	  if (!el.__hoverStlDirty) {
	    return;
	  }
	
	  el.__hoverStlDirty = false;
	  var hoverStyle = el.__hoverStl;
	
	  if (!hoverStyle) {
	    el.__cachedNormalStl = el.__cachedNormalZ2 = null;
	    return;
	  }
	
	  var normalStyle = el.__cachedNormalStl = {};
	  el.__cachedNormalZ2 = el.z2;
	  var elStyle = el.style;
	
	  for (var name in hoverStyle) {
	    // See comment in `singleEnterEmphasis`.
	    if (hoverStyle[name] != null) {
	      normalStyle[name] = elStyle[name];
	    }
	  } // Always cache fill and stroke to normalStyle for lifting color.
	
	
	  normalStyle.fill = elStyle.fill;
	  normalStyle.stroke = elStyle.stroke;
	}
	
	function singleEnterEmphasis(el) {
	  var hoverStl = el.__hoverStl;
	
	  if (!hoverStl || el.__highlighted) {
	    return;
	  }
	
	  var zr = el.__zr;
	  var useHoverLayer = el.useHoverLayer && zr && zr.painter.type === 'canvas';
	  el.__highlighted = useHoverLayer ? 'layer' : 'plain';
	
	  if (el.isGroup || !zr && el.useHoverLayer) {
	    return;
	  }
	
	  var elTarget = el;
	  var targetStyle = el.style;
	
	  if (useHoverLayer) {
	    elTarget = zr.addHover(el);
	    targetStyle = elTarget.style;
	  }
	
	  rollbackDefaultTextStyle(targetStyle);
	
	  if (!useHoverLayer) {
	    cacheElementStl(elTarget);
	  } // styles can be:
	  // {
	  //    label: {
	  //        show: false,
	  //        position: 'outside',
	  //        fontSize: 18
	  //    },
	  //    emphasis: {
	  //        label: {
	  //            show: true
	  //        }
	  //    }
	  // },
	  // where properties of `emphasis` may not appear in `normal`. We previously use
	  // module:echarts/util/model#defaultEmphasis to merge `normal` to `emphasis`.
	  // But consider rich text and setOption in merge mode, it is impossible to cover
	  // all properties in merge. So we use merge mode when setting style here.
	  // But we choose the merge strategy that only properties that is not `null/undefined`.
	  // Because when making a textStyle (espacially rich text), it is not easy to distinguish
	  // `hasOwnProperty` and `null/undefined` in code, so we trade them as the same for simplicity.
	  // But this strategy brings a trouble that `null/undefined` can not be used to remove
	  // style any more in `emphasis`. Users can both set properties directly on normal and
	  // emphasis to avoid this issue, or we might support `'none'` for this case if required.
	
	
	  targetStyle.extendFrom(hoverStl);
	  setDefaultHoverFillStroke(targetStyle, hoverStl, 'fill');
	  setDefaultHoverFillStroke(targetStyle, hoverStl, 'stroke');
	  applyDefaultTextStyle(targetStyle);
	
	  if (!useHoverLayer) {
	    el.dirty(false);
	    el.z2 += Z2_EMPHASIS_LIFT;
	  }
	}
	
	function setDefaultHoverFillStroke(targetStyle, hoverStyle, prop) {
	  if (!hasFillOrStroke(hoverStyle[prop]) && hasFillOrStroke(targetStyle[prop])) {
	    targetStyle[prop] = liftColor(targetStyle[prop]);
	  }
	}
	
	function singleEnterNormal(el) {
	  var highlighted = el.__highlighted;
	
	  if (!highlighted) {
	    return;
	  }
	
	  el.__highlighted = false;
	
	  if (el.isGroup) {
	    return;
	  }
	
	  if (highlighted === 'layer') {
	    el.__zr && el.__zr.removeHover(el);
	  } else {
	    var style = el.style;
	    var normalStl = el.__cachedNormalStl;
	
	    if (normalStl) {
	      rollbackDefaultTextStyle(style);
	      el.setStyle(normalStl);
	      applyDefaultTextStyle(style);
	    } // `__cachedNormalZ2` will not be reset if calling `setElementHoverStyle`
	    // when `el` is on emphasis state. So here by comparing with 1, we try
	    // hard to make the bug case rare.
	
	
	    var normalZ2 = el.__cachedNormalZ2;
	
	    if (normalZ2 != null && el.z2 - normalZ2 === Z2_EMPHASIS_LIFT) {
	      el.z2 = normalZ2;
	    }
	  }
	}
	
	function traverseUpdate(el, updater, commonParam) {
	  // If root is group, also enter updater for `highDownOnUpdate`.
	  var fromState = NORMAL;
	  var toState = NORMAL;
	  var trigger; // See the rule of `highDownOnUpdate` on `graphic.setAsHighDownDispatcher`.
	
	  el.__highlighted && (fromState = EMPHASIS, trigger = true);
	  updater(el, commonParam);
	  el.__highlighted && (toState = EMPHASIS, trigger = true);
	  el.isGroup && el.traverse(function (child) {
	    !child.isGroup && updater(child, commonParam);
	  });
	  trigger && el.__highDownOnUpdate && el.__highDownOnUpdate(fromState, toState);
	}
	/**
	 * Set hover style (namely "emphasis style") of element, based on the current
	 * style of the given `el`.
	 * This method should be called after all of the normal styles have been adopted
	 * to the `el`. See the reason on `setHoverStyle`.
	 *
	 * @param {module:zrender/Element} el Should not be `zrender/container/Group`.
	 * @param {Object} [el.hoverStyle] Can be set on el or its descendants,
	 *        e.g., `el.hoverStyle = ...; graphic.setHoverStyle(el); `.
	 *        Often used when item group has a label element and it's hoverStyle is different.
	 * @param {Object|boolean} [hoverStl] The specified hover style.
	 *        If set as `false`, disable the hover style.
	 *        Similarly, The `el.hoverStyle` can alse be set
	 *        as `false` to disable the hover style.
	 *        Otherwise, use the default hover style if not provided.
	 */
	
	
	function setElementHoverStyle(el, hoverStl) {
	  // For performance consideration, it might be better to make the "hover style" only the
	  // difference properties from the "normal style", but not a entire copy of all styles.
	  hoverStl = el.__hoverStl = hoverStl !== false && (el.hoverStyle || hoverStl || {});
	  el.__hoverStlDirty = true; // FIXME
	  // It is not completely right to save "normal"/"emphasis" flag on elements.
	  // It probably should be saved on `data` of series. Consider the cases:
	  // (1) A highlighted elements are moved out of the view port and re-enter
	  // again by dataZoom.
	  // (2) call `setOption` and replace elements totally when they are highlighted.
	
	  if (el.__highlighted) {
	    // Consider the case:
	    // The styles of a highlighted `el` is being updated. The new "emphasis style"
	    // should be adapted to the `el`. Notice here new "normal styles" should have
	    // been set outside and the cached "normal style" is out of date.
	    el.__cachedNormalStl = null; // Do not clear `__cachedNormalZ2` here, because setting `z2` is not a constraint
	    // of this method. In most cases, `z2` is not set and hover style should be able
	    // to rollback. Of course, that would bring bug, but only in a rare case, see
	    // `doSingleLeaveHover` for details.
	
	    singleEnterNormal(el);
	    singleEnterEmphasis(el);
	  }
	}
	
	function onElementMouseOver(e) {
	  !shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
	  && !this.__highByOuter && traverseUpdate(this, singleEnterEmphasis);
	}
	
	function onElementMouseOut(e) {
	  !shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
	  && !this.__highByOuter && traverseUpdate(this, singleEnterNormal);
	}
	
	function onElementEmphasisEvent(highlightDigit) {
	  this.__highByOuter |= 1 << (highlightDigit || 0);
	  traverseUpdate(this, singleEnterEmphasis);
	}
	
	function onElementNormalEvent(highlightDigit) {
	  !(this.__highByOuter &= ~(1 << (highlightDigit || 0))) && traverseUpdate(this, singleEnterNormal);
	}
	
	function shouldSilent(el, e) {
	  return el.__highDownSilentOnTouch && e.zrByTouch;
	}
	/**
	 * Set hover style (namely "emphasis style") of element,
	 * based on the current style of the given `el`.
	 *
	 * (1)
	 * **CONSTRAINTS** for this method:
	 * <A> This method MUST be called after all of the normal styles having been adopted
	 * to the `el`.
	 * <B> The input `hoverStyle` (that is, "emphasis style") MUST be the subset of the
	 * "normal style" having been set to the el.
	 * <C> `color` MUST be one of the "normal styles" (because color might be lifted as
	 * a default hover style).
	 *
	 * The reason: this method treat the current style of the `el` as the "normal style"
	 * and cache them when enter/update the "emphasis style". Consider the case: the `el`
	 * is in "emphasis" state and `setOption`/`dispatchAction` trigger the style updating
	 * logic, where the el should shift from the original emphasis style to the new
	 * "emphasis style" and should be able to "downplay" back to the new "normal style".
	 *
	 * Indeed, it is error-prone to make a interface has so many constraints, but I have
	 * not found a better solution yet to fit the backward compatibility, performance and
	 * the current programming style.
	 *
	 * (2)
	 * Call the method for a "root" element once. Do not call it for each descendants.
	 * If the descendants elemenets of a group has itself hover style different from the
	 * root group, we can simply mount the style on `el.hoverStyle` for them, but should
	 * not call this method for them.
	 *
	 * (3) These input parameters can be set directly on `el`:
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} [el.hoverStyle] See `graphic.setElementHoverStyle`.
	 * @param {boolean} [el.highDownSilentOnTouch=false] See `graphic.setAsHighDownDispatcher`.
	 * @param {Function} [el.highDownOnUpdate] See `graphic.setAsHighDownDispatcher`.
	 * @param {Object|boolean} [hoverStyle] See `graphic.setElementHoverStyle`.
	 */
	
	
	function setHoverStyle(el, hoverStyle) {
	  setAsHighDownDispatcher(el, true);
	  traverseUpdate(el, setElementHoverStyle, hoverStyle);
	}
	/**
	 * @param {module:zrender/Element} el
	 * @param {Function} [el.highDownOnUpdate] Called when state updated.
	 *        Since `setHoverStyle` has the constraint that it must be called after
	 *        all of the normal style updated, `highDownOnUpdate` is not needed to
	 *        trigger if both `fromState` and `toState` is 'normal', and needed to
	 *        trigger if both `fromState` and `toState` is 'emphasis', which enables
	 *        to sync outside style settings to "emphasis" state.
	 *        @this {string} This dispatcher `el`.
	 *        @param {string} fromState Can be "normal" or "emphasis".
	 *               `fromState` might equal to `toState`,
	 *               for example, when this method is called when `el` is
	 *               on "emphasis" state.
	 *        @param {string} toState Can be "normal" or "emphasis".
	 *
	 *        FIXME
	 *        CAUTION: Do not expose `highDownOnUpdate` outside echarts.
	 *        Because it is not a complete solution. The update
	 *        listener should not have been mount in element,
	 *        and the normal/emphasis state should not have
	 *        mantained on elements.
	 *
	 * @param {boolean} [el.highDownSilentOnTouch=false]
	 *        In touch device, mouseover event will be trigger on touchstart event
	 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
	 *        conveniently use hoverStyle when tap on touch screen without additional
	 *        code for compatibility.
	 *        But if the chart/component has select feature, which usually also use
	 *        hoverStyle, there might be conflict between 'select-highlight' and
	 *        'hover-highlight' especially when roam is enabled (see geo for example).
	 *        In this case, `highDownSilentOnTouch` should be used to disable
	 *        hover-highlight on touch device.
	 * @param {boolean} [asDispatcher=true] If `false`, do not set as "highDownDispatcher".
	 */
	
	
	function setAsHighDownDispatcher(el, asDispatcher) {
	  var disable = asDispatcher === false; // Make `highDownSilentOnTouch` and `highDownOnUpdate` only work after
	  // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
	
	  el.__highDownSilentOnTouch = el.highDownSilentOnTouch;
	  el.__highDownOnUpdate = el.highDownOnUpdate; // Simple optimize, since this method might be
	  // called for each elements of a group in some cases.
	
	  if (!disable || el.__highDownDispatcher) {
	    var method = disable ? 'off' : 'on'; // Duplicated function will be auto-ignored, see Eventful.js.
	
	    el[method]('mouseover', onElementMouseOver)[method]('mouseout', onElementMouseOut); // Emphasis, normal can be triggered manually by API or other components like hover link.
	
	    el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent); // Also keep previous record.
	
	    el.__highByOuter = el.__highByOuter || 0;
	    el.__highDownDispatcher = !disable;
	  }
	}
	/**
	 * @param {module:zrender/src/Element} el
	 * @return {boolean}
	 */
	
	
	function isHighDownDispatcher(el) {
	  return !!(el && el.__highDownDispatcher);
	}
	/**
	 * Support hightlight/downplay record on each elements.
	 * For the case: hover highlight/downplay (legend, visualMap, ...) and
	 * user triggerred hightlight/downplay should not conflict.
	 * Only all of the highlightDigit cleared, return to normal.
	 * @param {string} highlightKey
	 * @return {number} highlightDigit
	 */
	
	
	function getHighlightDigit(highlightKey) {
	  var highlightDigit = _highlightKeyMap[highlightKey];
	
	  if (highlightDigit == null && _highlightNextDigit <= 32) {
	    highlightDigit = _highlightKeyMap[highlightKey] = _highlightNextDigit++;
	  }
	
	  return highlightDigit;
	}
	/**
	 * See more info in `setTextStyleCommon`.
	 * @param {Object|module:zrender/graphic/Style} normalStyle
	 * @param {Object} emphasisStyle
	 * @param {module:echarts/model/Model} normalModel
	 * @param {module:echarts/model/Model} emphasisModel
	 * @param {Object} opt Check `opt` of `setTextStyleCommon` to find other props.
	 * @param {string|Function} [opt.defaultText]
	 * @param {module:echarts/model/Model} [opt.labelFetcher] Fetch text by
	 *      `opt.labelFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {number} [opt.labelDataIndex] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {number} [opt.labelDimIndex] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {string} [opt.labelProp] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {Object} [normalSpecified]
	 * @param {Object} [emphasisSpecified]
	 */
	
	
	function setLabelStyle(normalStyle, emphasisStyle, normalModel, emphasisModel, opt, normalSpecified, emphasisSpecified) {
	  opt = opt || EMPTY_OBJ;
	  var labelFetcher = opt.labelFetcher;
	  var labelDataIndex = opt.labelDataIndex;
	  var labelDimIndex = opt.labelDimIndex;
	  var labelProp = opt.labelProp; // This scenario, `label.normal.show = true; label.emphasis.show = false`,
	  // is not supported util someone requests.
	
	  var showNormal = normalModel.getShallow('show');
	  var showEmphasis = emphasisModel.getShallow('show'); // Consider performance, only fetch label when necessary.
	  // If `normal.show` is `false` and `emphasis.show` is `true` and `emphasis.formatter` is not set,
	  // label should be displayed, where text is fetched by `normal.formatter` or `opt.defaultText`.
	
	  var baseText;
	
	  if (showNormal || showEmphasis) {
	    if (labelFetcher) {
	      baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, labelProp);
	    }
	
	    if (baseText == null) {
	      baseText = zrUtil.isFunction(opt.defaultText) ? opt.defaultText(labelDataIndex, opt) : opt.defaultText;
	    }
	  }
	
	  var normalStyleText = showNormal ? baseText : null;
	  var emphasisStyleText = showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'emphasis', null, labelDimIndex, labelProp) : null, baseText) : null; // Optimize: If style.text is null, text will not be drawn.
	
	  if (normalStyleText != null || emphasisStyleText != null) {
	    // Always set `textStyle` even if `normalStyle.text` is null, because default
	    // values have to be set on `normalStyle`.
	    // If we set default values on `emphasisStyle`, consider case:
	    // Firstly, `setOption(... label: {normal: {text: null}, emphasis: {show: true}} ...);`
	    // Secondly, `setOption(... label: {noraml: {show: true, text: 'abc', color: 'red'} ...);`
	    // Then the 'red' will not work on emphasis.
	    setTextStyle(normalStyle, normalModel, normalSpecified, opt);
	    setTextStyle(emphasisStyle, emphasisModel, emphasisSpecified, opt, true);
	  }
	
	  normalStyle.text = normalStyleText;
	  emphasisStyle.text = emphasisStyleText;
	}
	/**
	 * Modify label style manually.
	 * Only works after `setLabelStyle` and `setElementHoverStyle` called.
	 *
	 * @param {module:zrender/src/Element} el
	 * @param {Object} [normalStyleProps] optional
	 * @param {Object} [emphasisStyleProps] optional
	 */
	
	
	function modifyLabelStyle(el, normalStyleProps, emphasisStyleProps) {
	  var elStyle = el.style;
	
	  if (normalStyleProps) {
	    rollbackDefaultTextStyle(elStyle);
	    el.setStyle(normalStyleProps);
	    applyDefaultTextStyle(elStyle);
	  }
	
	  elStyle = el.__hoverStl;
	
	  if (emphasisStyleProps && elStyle) {
	    rollbackDefaultTextStyle(elStyle);
	    zrUtil.extend(elStyle, emphasisStyleProps);
	    applyDefaultTextStyle(elStyle);
	  }
	}
	/**
	 * Set basic textStyle properties.
	 * See more info in `setTextStyleCommon`.
	 * @param {Object|module:zrender/graphic/Style} textStyle
	 * @param {module:echarts/model/Model} model
	 * @param {Object} [specifiedTextStyle] Can be overrided by settings in model.
	 * @param {Object} [opt] See `opt` of `setTextStyleCommon`.
	 * @param {boolean} [isEmphasis]
	 */
	
	
	function setTextStyle(textStyle, textStyleModel, specifiedTextStyle, opt, isEmphasis) {
	  setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis);
	  specifiedTextStyle && zrUtil.extend(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	
	  return textStyle;
	}
	/**
	 * Set text option in the style.
	 * See more info in `setTextStyleCommon`.
	 * @deprecated
	 * @param {Object} textStyle
	 * @param {module:echarts/model/Model} labelModel
	 * @param {string|boolean} defaultColor Default text color.
	 *        If set as false, it will be processed as a emphasis style.
	 */
	
	
	function setText(textStyle, labelModel, defaultColor) {
	  var opt = {
	    isRectText: true
	  };
	  var isEmphasis;
	
	  if (defaultColor === false) {
	    isEmphasis = true;
	  } else {
	    // Support setting color as 'auto' to get visual color.
	    opt.autoColor = defaultColor;
	  }
	
	  setTextStyleCommon(textStyle, labelModel, opt, isEmphasis); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	}
	/**
	 * The uniform entry of set text style, that is, retrieve style definitions
	 * from `model` and set to `textStyle` object.
	 *
	 * Never in merge mode, but in overwrite mode, that is, all of the text style
	 * properties will be set. (Consider the states of normal and emphasis and
	 * default value can be adopted, merge would make the logic too complicated
	 * to manage.)
	 *
	 * The `textStyle` object can either be a plain object or an instance of
	 * `zrender/src/graphic/Style`, and either be the style of normal or emphasis.
	 * After this mothod called, the `textStyle` object can then be used in
	 * `el.setStyle(textStyle)` or `el.hoverStyle = textStyle`.
	 *
	 * Default value will be adopted and `insideRollbackOpt` will be created.
	 * See `applyDefaultTextStyle` `rollbackDefaultTextStyle` for more details.
	 *
	 * opt: {
	 *      disableBox: boolean, Whether diable drawing box of block (outer most).
	 *      isRectText: boolean,
	 *      autoColor: string, specify a color when color is 'auto',
	 *              for textFill, textStroke, textBackgroundColor, and textBorderColor.
	 *              If autoColor specified, it is used as default textFill.
	 *      useInsideStyle:
	 *              `true`: Use inside style (textFill, textStroke, textStrokeWidth)
	 *                  if `textFill` is not specified.
	 *              `false`: Do not use inside style.
	 *              `null/undefined`: use inside style if `isRectText` is true and
	 *                  `textFill` is not specified and textPosition contains `'inside'`.
	 *      forceRich: boolean
	 * }
	 */
	
	
	function setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis) {
	  // Consider there will be abnormal when merge hover style to normal style if given default value.
	  opt = opt || EMPTY_OBJ;
	
	  if (opt.isRectText) {
	    var textPosition;
	
	    if (opt.getTextPosition) {
	      textPosition = opt.getTextPosition(textStyleModel, isEmphasis);
	    } else {
	      textPosition = textStyleModel.getShallow('position') || (isEmphasis ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
	      // in bar series, and magric type should be considered.
	
	      textPosition === 'outside' && (textPosition = 'top');
	    }
	
	    textStyle.textPosition = textPosition;
	    textStyle.textOffset = textStyleModel.getShallow('offset');
	    var labelRotate = textStyleModel.getShallow('rotate');
	    labelRotate != null && (labelRotate *= Math.PI / 180);
	    textStyle.textRotation = labelRotate;
	    textStyle.textDistance = zrUtil.retrieve2(textStyleModel.getShallow('distance'), isEmphasis ? null : 5);
	  }
	
	  var ecModel = textStyleModel.ecModel;
	  var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
	  // {
	  //     data: [{
	  //         value: 12,
	  //         label: {
	  //             rich: {
	  //                 // no 'a' here but using parent 'a'.
	  //             }
	  //         }
	  //     }],
	  //     rich: {
	  //         a: { ... }
	  //     }
	  // }
	
	  var richItemNames = getRichItemNames(textStyleModel);
	  var richResult;
	
	  if (richItemNames) {
	    richResult = {};
	
	    for (var name in richItemNames) {
	      if (richItemNames.hasOwnProperty(name)) {
	        // Cascade is supported in rich.
	        var richTextStyle = textStyleModel.getModel(['rich', name]); // In rich, never `disableBox`.
	        // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
	        // the default color `'blue'` will not be adopted if no color declared in `rich`.
	        // That might confuses users. So probably we should put `textStyleModel` as the
	        // root ancestor of the `richTextStyle`. But that would be a break change.
	
	        setTokenTextStyle(richResult[name] = {}, richTextStyle, globalTextStyle, opt, isEmphasis);
	      }
	    }
	  }
	
	  textStyle.rich = richResult;
	  setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, true);
	
	  if (opt.forceRich && !opt.textStyle) {
	    opt.textStyle = {};
	  }
	
	  return textStyle;
	} // Consider case:
	// {
	//     data: [{
	//         value: 12,
	//         label: {
	//             rich: {
	//                 // no 'a' here but using parent 'a'.
	//             }
	//         }
	//     }],
	//     rich: {
	//         a: { ... }
	//     }
	// }
	
	
	function getRichItemNames(textStyleModel) {
	  // Use object to remove duplicated names.
	  var richItemNameMap;
	
	  while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
	    var rich = (textStyleModel.option || EMPTY_OBJ).rich;
	
	    if (rich) {
	      richItemNameMap = richItemNameMap || {};
	
	      for (var name in rich) {
	        if (rich.hasOwnProperty(name)) {
	          richItemNameMap[name] = 1;
	        }
	      }
	    }
	
	    textStyleModel = textStyleModel.parentModel;
	  }
	
	  return richItemNameMap;
	}
	
	function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, isBlock) {
	  // In merge mode, default value should not be given.
	  globalTextStyle = !isEmphasis && globalTextStyle || EMPTY_OBJ;
	  textStyle.textFill = getAutoColor(textStyleModel.getShallow('color'), opt) || globalTextStyle.color;
	  textStyle.textStroke = getAutoColor(textStyleModel.getShallow('textBorderColor'), opt) || globalTextStyle.textBorderColor;
	  textStyle.textStrokeWidth = zrUtil.retrieve2(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
	
	  if (!isEmphasis) {
	    if (isBlock) {
	      textStyle.insideRollbackOpt = opt;
	      applyDefaultTextStyle(textStyle);
	    } // Set default finally.
	
	
	    if (textStyle.textFill == null) {
	      textStyle.textFill = opt.autoColor;
	    }
	  } // Do not use `getFont` here, because merge should be supported, where
	  // part of these properties may be changed in emphasis style, and the
	  // others should remain their original value got from normal style.
	
	
	  textStyle.fontStyle = textStyleModel.getShallow('fontStyle') || globalTextStyle.fontStyle;
	  textStyle.fontWeight = textStyleModel.getShallow('fontWeight') || globalTextStyle.fontWeight;
	  textStyle.fontSize = textStyleModel.getShallow('fontSize') || globalTextStyle.fontSize;
	  textStyle.fontFamily = textStyleModel.getShallow('fontFamily') || globalTextStyle.fontFamily;
	  textStyle.textAlign = textStyleModel.getShallow('align');
	  textStyle.textVerticalAlign = textStyleModel.getShallow('verticalAlign') || textStyleModel.getShallow('baseline');
	  textStyle.textLineHeight = textStyleModel.getShallow('lineHeight');
	  textStyle.textWidth = textStyleModel.getShallow('width');
	  textStyle.textHeight = textStyleModel.getShallow('height');
	  textStyle.textTag = textStyleModel.getShallow('tag');
	
	  if (!isBlock || !opt.disableBox) {
	    textStyle.textBackgroundColor = getAutoColor(textStyleModel.getShallow('backgroundColor'), opt);
	    textStyle.textPadding = textStyleModel.getShallow('padding');
	    textStyle.textBorderColor = getAutoColor(textStyleModel.getShallow('borderColor'), opt);
	    textStyle.textBorderWidth = textStyleModel.getShallow('borderWidth');
	    textStyle.textBorderRadius = textStyleModel.getShallow('borderRadius');
	    textStyle.textBoxShadowColor = textStyleModel.getShallow('shadowColor');
	    textStyle.textBoxShadowBlur = textStyleModel.getShallow('shadowBlur');
	    textStyle.textBoxShadowOffsetX = textStyleModel.getShallow('shadowOffsetX');
	    textStyle.textBoxShadowOffsetY = textStyleModel.getShallow('shadowOffsetY');
	  }
	
	  textStyle.textShadowColor = textStyleModel.getShallow('textShadowColor') || globalTextStyle.textShadowColor;
	  textStyle.textShadowBlur = textStyleModel.getShallow('textShadowBlur') || globalTextStyle.textShadowBlur;
	  textStyle.textShadowOffsetX = textStyleModel.getShallow('textShadowOffsetX') || globalTextStyle.textShadowOffsetX;
	  textStyle.textShadowOffsetY = textStyleModel.getShallow('textShadowOffsetY') || globalTextStyle.textShadowOffsetY;
	}
	
	function getAutoColor(color, opt) {
	  return color !== 'auto' ? color : opt && opt.autoColor ? opt.autoColor : null;
	}
	/**
	 * Give some default value to the input `textStyle` object, based on the current settings
	 * in this `textStyle` object.
	 *
	 * The Scenario:
	 * when text position is `inside` and `textFill` is not specified, we show
	 * text border by default for better view. But it should be considered that text position
	 * might be changed when hovering or being emphasis, where the `insideRollback` is used to
	 * restore the style.
	 *
	 * Usage (& NOTICE):
	 * When a style object (eithor plain object or instance of `zrender/src/graphic/Style`) is
	 * about to be modified on its text related properties, `rollbackDefaultTextStyle` should
	 * be called before the modification and `applyDefaultTextStyle` should be called after that.
	 * (For the case that all of the text related properties is reset, like `setTextStyleCommon`
	 * does, `rollbackDefaultTextStyle` is not needed to be called).
	 */
	
	
	function applyDefaultTextStyle(textStyle) {
	  var textPosition = textStyle.textPosition;
	  var opt = textStyle.insideRollbackOpt;
	  var insideRollback;
	
	  if (opt && textStyle.textFill == null) {
	    var autoColor = opt.autoColor;
	    var isRectText = opt.isRectText;
	    var useInsideStyle = opt.useInsideStyle;
	    var useInsideStyleCache = useInsideStyle !== false && (useInsideStyle === true || isRectText && textPosition // textPosition can be [10, 30]
	    && typeof textPosition === 'string' && textPosition.indexOf('inside') >= 0);
	    var useAutoColorCache = !useInsideStyleCache && autoColor != null; // All of the props declared in `CACHED_LABEL_STYLE_PROPERTIES` are to be cached.
	
	    if (useInsideStyleCache || useAutoColorCache) {
	      insideRollback = {
	        textFill: textStyle.textFill,
	        textStroke: textStyle.textStroke,
	        textStrokeWidth: textStyle.textStrokeWidth
	      };
	    }
	
	    if (useInsideStyleCache) {
	      textStyle.textFill = '#fff'; // Consider text with #fff overflow its container.
	
	      if (textStyle.textStroke == null) {
	        textStyle.textStroke = autoColor;
	        textStyle.textStrokeWidth == null && (textStyle.textStrokeWidth = 2);
	      }
	    }
	
	    if (useAutoColorCache) {
	      textStyle.textFill = autoColor;
	    }
	  } // Always set `insideRollback`, so that the previous one can be cleared.
	
	
	  textStyle.insideRollback = insideRollback;
	}
	/**
	 * Consider the case: in a scatter,
	 * label: {
	 *     normal: {position: 'inside'},
	 *     emphasis: {position: 'top'}
	 * }
	 * In the normal state, the `textFill` will be set as '#fff' for pretty view (see
	 * `applyDefaultTextStyle`), but when switching to emphasis state, the `textFill`
	 * should be retured to 'autoColor', but not keep '#fff'.
	 */
	
	
	function rollbackDefaultTextStyle(style) {
	  var insideRollback = style.insideRollback;
	
	  if (insideRollback) {
	    // Reset all of the props in `CACHED_LABEL_STYLE_PROPERTIES`.
	    style.textFill = insideRollback.textFill;
	    style.textStroke = insideRollback.textStroke;
	    style.textStrokeWidth = insideRollback.textStrokeWidth;
	    style.insideRollback = null;
	  }
	}
	
	function getFont(opt, ecModel) {
	  var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
	  return zrUtil.trim([// FIXME in node-canvas fontWeight is before fontStyle
	  opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' '));
	}
	
	function animateOrSetProps(isUpdate, el, props, animatableModel, dataIndex, cb) {
	  if (typeof dataIndex === 'function') {
	    cb = dataIndex;
	    dataIndex = null;
	  } // Do not check 'animation' property directly here. Consider this case:
	  // animation model is an `itemModel`, whose does not have `isAnimationEnabled`
	  // but its parent model (`seriesModel`) does.
	
	
	  var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
	
	  if (animationEnabled) {
	    var postfix = isUpdate ? 'Update' : '';
	    var duration = animatableModel.getShallow('animationDuration' + postfix);
	    var animationEasing = animatableModel.getShallow('animationEasing' + postfix);
	    var animationDelay = animatableModel.getShallow('animationDelay' + postfix);
	
	    if (typeof animationDelay === 'function') {
	      animationDelay = animationDelay(dataIndex, animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
	    }
	
	    if (typeof duration === 'function') {
	      duration = duration(dataIndex);
	    }
	
	    duration > 0 ? el.animateTo(props, duration, animationDelay || 0, animationEasing, cb, !!cb) : (el.stopAnimation(), el.attr(props), cb && cb());
	  } else {
	    el.stopAnimation();
	    el.attr(props);
	    cb && cb();
	  }
	}
	/**
	 * Update graphic element properties with or without animation according to the
	 * configuration in series.
	 *
	 * Caution: this method will stop previous animation.
	 * So do not use this method to one element twice before
	 * animation starts, unless you know what you are doing.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} props
	 * @param {module:echarts/model/Model} [animatableModel]
	 * @param {number} [dataIndex]
	 * @param {Function} [cb]
	 * @example
	 *     graphic.updateProps(el, {
	 *         position: [100, 100]
	 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
	 *     // Or
	 *     graphic.updateProps(el, {
	 *         position: [100, 100]
	 *     }, seriesModel, function () { console.log('Animation done!'); });
	 */
	
	
	function updateProps(el, props, animatableModel, dataIndex, cb) {
	  animateOrSetProps(true, el, props, animatableModel, dataIndex, cb);
	}
	/**
	 * Init graphic element properties with or without animation according to the
	 * configuration in series.
	 *
	 * Caution: this method will stop previous animation.
	 * So do not use this method to one element twice before
	 * animation starts, unless you know what you are doing.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} props
	 * @param {module:echarts/model/Model} [animatableModel]
	 * @param {number} [dataIndex]
	 * @param {Function} cb
	 */
	
	
	function initProps(el, props, animatableModel, dataIndex, cb) {
	  animateOrSetProps(false, el, props, animatableModel, dataIndex, cb);
	}
	/**
	 * Get transform matrix of target (param target),
	 * in coordinate of its ancestor (param ancestor)
	 *
	 * @param {module:zrender/mixin/Transformable} target
	 * @param {module:zrender/mixin/Transformable} [ancestor]
	 */
	
	
	function getTransform(target, ancestor) {
	  var mat = matrix.identity([]);
	
	  while (target && target !== ancestor) {
	    matrix.mul(mat, target.getLocalTransform(), mat);
	    target = target.parent;
	  }
	
	  return mat;
	}
	/**
	 * Apply transform to an vertex.
	 * @param {Array.<number>} target [x, y]
	 * @param {Array.<number>|TypedArray.<number>|Object} transform Can be:
	 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
	 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
	 * @param {boolean=} invert Whether use invert matrix.
	 * @return {Array.<number>} [x, y]
	 */
	
	
	function applyTransform(target, transform, invert) {
	  if (transform && !zrUtil.isArrayLike(transform)) {
	    transform = Transformable.getLocalTransform(transform);
	  }
	
	  if (invert) {
	    transform = matrix.invert([], transform);
	  }
	
	  return vector.applyTransform([], target, transform);
	}
	/**
	 * @param {string} direction 'left' 'right' 'top' 'bottom'
	 * @param {Array.<number>} transform Transform matrix: like [1, 0, 0, 1, 0, 0]
	 * @param {boolean=} invert Whether use invert matrix.
	 * @return {string} Transformed direction. 'left' 'right' 'top' 'bottom'
	 */
	
	
	function transformDirection(direction, transform, invert) {
	  // Pick a base, ensure that transform result will not be (0, 0).
	  var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
	  var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
	  var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
	  vertex = applyTransform(vertex, transform, invert);
	  return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
	}
	/**
	 * Apply group transition animation from g1 to g2.
	 * If no animatableModel, no animation.
	 */
	
	
	function groupTransition(g1, g2, animatableModel, cb) {
	  if (!g1 || !g2) {
	    return;
	  }
	
	  function getElMap(g) {
	    var elMap = {};
	    g.traverse(function (el) {
	      if (!el.isGroup && el.anid) {
	        elMap[el.anid] = el;
	      }
	    });
	    return elMap;
	  }
	
	  function getAnimatableProps(el) {
	    var obj = {
	      position: vector.clone(el.position),
	      rotation: el.rotation
	    };
	
	    if (el.shape) {
	      obj.shape = zrUtil.extend({}, el.shape);
	    }
	
	    return obj;
	  }
	
	  var elMap1 = getElMap(g1);
	  g2.traverse(function (el) {
	    if (!el.isGroup && el.anid) {
	      var oldEl = elMap1[el.anid];
	
	      if (oldEl) {
	        var newProp = getAnimatableProps(el);
	        el.attr(getAnimatableProps(oldEl));
	        updateProps(el, newProp, animatableModel, el.dataIndex);
	      } // else {
	      //     if (el.previousProps) {
	      //         graphic.updateProps
	      //     }
	      // }
	
	    }
	  });
	}
	/**
	 * @param {Array.<Array.<number>>} points Like: [[23, 44], [53, 66], ...]
	 * @param {Object} rect {x, y, width, height}
	 * @return {Array.<Array.<number>>} A new clipped points.
	 */
	
	
	function clipPointsByRect(points, rect) {
	  // FIXME: this way migth be incorrect when grpahic clipped by a corner.
	  // and when element have border.
	  return zrUtil.map(points, function (point) {
	    var x = point[0];
	    x = mathMax(x, rect.x);
	    x = mathMin(x, rect.x + rect.width);
	    var y = point[1];
	    y = mathMax(y, rect.y);
	    y = mathMin(y, rect.y + rect.height);
	    return [x, y];
	  });
	}
	/**
	 * @param {Object} targetRect {x, y, width, height}
	 * @param {Object} rect {x, y, width, height}
	 * @return {Object} A new clipped rect. If rect size are negative, return undefined.
	 */
	
	
	function clipRectByRect(targetRect, rect) {
	  var x = mathMax(targetRect.x, rect.x);
	  var x2 = mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
	  var y = mathMax(targetRect.y, rect.y);
	  var y2 = mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
	  // should be painted. So return undefined.
	
	  if (x2 >= x && y2 >= y) {
	    return {
	      x: x,
	      y: y,
	      width: x2 - x,
	      height: y2 - y
	    };
	  }
	}
	/**
	 * @param {string} iconStr Support 'image://' or 'path://' or direct svg path.
	 * @param {Object} [opt] Properties of `module:zrender/Element`, except `style`.
	 * @param {Object} [rect] {x, y, width, height}
	 * @return {module:zrender/Element} Icon path or image element.
	 */
	
	
	function createIcon(iconStr, opt, rect) {
	  opt = zrUtil.extend({
	    rectHover: true
	  }, opt);
	  var style = opt.style = {
	    strokeNoScale: true
	  };
	  rect = rect || {
	    x: -1,
	    y: -1,
	    width: 2,
	    height: 2
	  };
	
	  if (iconStr) {
	    return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), zrUtil.defaults(style, rect), new ZImage(opt)) : makePath(iconStr.replace('path://', ''), opt, rect, 'center');
	  }
	}
	/**
	 * Return `true` if the given line (line `a`) and the given polygon
	 * are intersect.
	 * Note that we do not count colinear as intersect here because no
	 * requirement for that. We could do that if required in future.
	 *
	 * @param {number} a1x
	 * @param {number} a1y
	 * @param {number} a2x
	 * @param {number} a2y
	 * @param {Array.<Array.<number>>} points Points of the polygon.
	 * @return {boolean}
	 */
	
	
	function linePolygonIntersect(a1x, a1y, a2x, a2y, points) {
	  for (var i = 0, p2 = points[points.length - 1]; i < points.length; i++) {
	    var p = points[i];
	
	    if (lineLineIntersect(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) {
	      return true;
	    }
	
	    p2 = p;
	  }
	}
	/**
	 * Return `true` if the given two lines (line `a` and line `b`)
	 * are intersect.
	 * Note that we do not count colinear as intersect here because no
	 * requirement for that. We could do that if required in future.
	 *
	 * @param {number} a1x
	 * @param {number} a1y
	 * @param {number} a2x
	 * @param {number} a2y
	 * @param {number} b1x
	 * @param {number} b1y
	 * @param {number} b2x
	 * @param {number} b2y
	 * @return {boolean}
	 */
	
	
	function lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
	  // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
	  var mx = a2x - a1x;
	  var my = a2y - a1y;
	  var nx = b2x - b1x;
	  var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
	  //     exising `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
	
	  var nmCrossProduct = crossProduct2d(nx, ny, mx, my);
	
	  if (nearZero(nmCrossProduct)) {
	    return false;
	  } // `vec_m` and `vec_n` are intersect iff
	  //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
	  //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
	  //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
	
	
	  var b1a1x = a1x - b1x;
	  var b1a1y = a1y - b1y;
	  var q = crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
	
	  if (q < 0 || q > 1) {
	    return false;
	  }
	
	  var p = crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
	
	  if (p < 0 || p > 1) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Cross product of 2-dimension vector.
	 */
	
	
	function crossProduct2d(x1, y1, x2, y2) {
	  return x1 * y2 - x2 * y1;
	}
	
	function nearZero(val) {
	  return val <= 1e-6 && val >= -1e-6;
	} // Register built-in shapes. These shapes might be overwirtten
	// by users, although we do not recommend that.
	
	
	registerShape('circle', Circle);
	registerShape('sector', Sector);
	registerShape('ring', Ring);
	registerShape('polygon', Polygon);
	registerShape('polyline', Polyline);
	registerShape('rect', Rect);
	registerShape('line', Line);
	registerShape('bezierCurve', BezierCurve);
	registerShape('arc', Arc);
	exports.Z2_EMPHASIS_LIFT = Z2_EMPHASIS_LIFT;
	exports.CACHED_LABEL_STYLE_PROPERTIES = CACHED_LABEL_STYLE_PROPERTIES;
	exports.extendShape = extendShape;
	exports.extendPath = extendPath;
	exports.registerShape = registerShape;
	exports.getShapeClass = getShapeClass;
	exports.makePath = makePath;
	exports.makeImage = makeImage;
	exports.mergePath = mergePath;
	exports.resizePath = resizePath;
	exports.subPixelOptimizeLine = subPixelOptimizeLine;
	exports.subPixelOptimizeRect = subPixelOptimizeRect;
	exports.subPixelOptimize = subPixelOptimize;
	exports.setElementHoverStyle = setElementHoverStyle;
	exports.setHoverStyle = setHoverStyle;
	exports.setAsHighDownDispatcher = setAsHighDownDispatcher;
	exports.isHighDownDispatcher = isHighDownDispatcher;
	exports.getHighlightDigit = getHighlightDigit;
	exports.setLabelStyle = setLabelStyle;
	exports.modifyLabelStyle = modifyLabelStyle;
	exports.setTextStyle = setTextStyle;
	exports.setText = setText;
	exports.getFont = getFont;
	exports.updateProps = updateProps;
	exports.initProps = initProps;
	exports.getTransform = getTransform;
	exports.applyTransform = applyTransform;
	exports.transformDirection = transformDirection;
	exports.groupTransition = groupTransition;
	exports.clipPointsByRect = clipPointsByRect;
	exports.clipRectByRect = clipRectByRect;
	exports.createIcon = createIcon;
	exports.linePolygonIntersect = linePolygonIntersect;
	exports.lineLineIntersect = lineLineIntersect;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(270);
	
	var PathProxy = __webpack_require__(271);
	
	var transformPath = __webpack_require__(281);
	
	// command chars
	// var cc = [
	//     'm', 'M', 'l', 'L', 'v', 'V', 'h', 'H', 'z', 'Z',
	//     'c', 'C', 'q', 'Q', 't', 'T', 's', 'S', 'a', 'A'
	// ];
	var mathSqrt = Math.sqrt;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI = Math.PI;
	
	var vMag = function (v) {
	  return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
	};
	
	var vRatio = function (u, v) {
	  return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
	};
	
	var vAngle = function (u, v) {
	  return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
	};
	
	function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
	  var psi = psiDeg * (PI / 180.0);
	  var xp = mathCos(psi) * (x1 - x2) / 2.0 + mathSin(psi) * (y1 - y2) / 2.0;
	  var yp = -1 * mathSin(psi) * (x1 - x2) / 2.0 + mathCos(psi) * (y1 - y2) / 2.0;
	  var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
	
	  if (lambda > 1) {
	    rx *= mathSqrt(lambda);
	    ry *= mathSqrt(lambda);
	  }
	
	  var f = (fa === fs ? -1 : 1) * mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
	  var cxp = f * rx * yp / ry;
	  var cyp = f * -ry * xp / rx;
	  var cx = (x1 + x2) / 2.0 + mathCos(psi) * cxp - mathSin(psi) * cyp;
	  var cy = (y1 + y2) / 2.0 + mathSin(psi) * cxp + mathCos(psi) * cyp;
	  var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
	  var u = [(xp - cxp) / rx, (yp - cyp) / ry];
	  var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
	  var dTheta = vAngle(u, v);
	
	  if (vRatio(u, v) <= -1) {
	    dTheta = PI;
	  }
	
	  if (vRatio(u, v) >= 1) {
	    dTheta = 0;
	  }
	
	  if (fs === 0 && dTheta > 0) {
	    dTheta = dTheta - 2 * PI;
	  }
	
	  if (fs === 1 && dTheta < 0) {
	    dTheta = dTheta + 2 * PI;
	  }
	
	  path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
	}
	
	var commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig; // Consider case:
	// (1) delimiter can be comma or space, where continuous commas
	// or spaces should be seen as one comma.
	// (2) value can be like:
	// '2e-4', 'l.5.9' (ignore 0), 'M-10-10', 'l-2.43e-1,34.9983',
	// 'l-.5E1,54', '121-23-44-11' (no delimiter)
	
	var numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g; // var valueSplitReg = /[\s,]+/;
	
	function createPathProxyFromString(data) {
	  if (!data) {
	    return new PathProxy();
	  } // var data = data.replace(/-/g, ' -')
	  //     .replace(/  /g, ' ')
	  //     .replace(/ /g, ',')
	  //     .replace(/,,/g, ',');
	  // var n;
	  // create pipes so that we can split the data
	  // for (n = 0; n < cc.length; n++) {
	  //     cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
	  // }
	  // data = data.replace(/-/g, ',-');
	  // create array
	  // var arr = cs.split('|');
	  // init context point
	
	
	  var cpx = 0;
	  var cpy = 0;
	  var subpathX = cpx;
	  var subpathY = cpy;
	  var prevCmd;
	  var path = new PathProxy();
	  var CMD = PathProxy.CMD; // commandReg.lastIndex = 0;
	  // var cmdResult;
	  // while ((cmdResult = commandReg.exec(data)) != null) {
	  //     var cmdStr = cmdResult[1];
	  //     var cmdContent = cmdResult[2];
	
	  var cmdList = data.match(commandReg);
	
	  for (var l = 0; l < cmdList.length; l++) {
	    var cmdText = cmdList[l];
	    var cmdStr = cmdText.charAt(0);
	    var cmd; // String#split is faster a little bit than String#replace or RegExp#exec.
	    // var p = cmdContent.split(valueSplitReg);
	    // var pLen = 0;
	    // for (var i = 0; i < p.length; i++) {
	    //     // '' and other invalid str => NaN
	    //     var val = parseFloat(p[i]);
	    //     !isNaN(val) && (p[pLen++] = val);
	    // }
	
	    var p = cmdText.match(numberReg) || [];
	    var pLen = p.length;
	
	    for (var i = 0; i < pLen; i++) {
	      p[i] = parseFloat(p[i]);
	    }
	
	    var off = 0;
	
	    while (off < pLen) {
	      var ctlPtx;
	      var ctlPty;
	      var rx;
	      var ry;
	      var psi;
	      var fa;
	      var fs;
	      var x1 = cpx;
	      var y1 = cpy; // convert l, H, h, V, and v to L
	
	      switch (cmdStr) {
	        case 'l':
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'L':
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'm':
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.M;
	          path.addData(cmd, cpx, cpy);
	          subpathX = cpx;
	          subpathY = cpy;
	          cmdStr = 'l';
	          break;
	
	        case 'M':
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.M;
	          path.addData(cmd, cpx, cpy);
	          subpathX = cpx;
	          subpathY = cpy;
	          cmdStr = 'L';
	          break;
	
	        case 'h':
	          cpx += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'H':
	          cpx = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'v':
	          cpy += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'V':
	          cpy = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'C':
	          cmd = CMD.C;
	          path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
	          cpx = p[off - 2];
	          cpy = p[off - 1];
	          break;
	
	        case 'c':
	          cmd = CMD.C;
	          path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
	          cpx += p[off - 2];
	          cpy += p[off - 1];
	          break;
	
	        case 'S':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.C) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cmd = CMD.C;
	          x1 = p[off++];
	          y1 = p[off++];
	          cpx = p[off++];
	          cpy = p[off++];
	          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	          break;
	
	        case 's':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.C) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cmd = CMD.C;
	          x1 = cpx + p[off++];
	          y1 = cpy + p[off++];
	          cpx += p[off++];
	          cpy += p[off++];
	          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	          break;
	
	        case 'Q':
	          x1 = p[off++];
	          y1 = p[off++];
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, x1, y1, cpx, cpy);
	          break;
	
	        case 'q':
	          x1 = p[off++] + cpx;
	          y1 = p[off++] + cpy;
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, x1, y1, cpx, cpy);
	          break;
	
	        case 'T':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.Q) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	          break;
	
	        case 't':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.Q) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	          break;
	
	        case 'A':
	          rx = p[off++];
	          ry = p[off++];
	          psi = p[off++];
	          fa = p[off++];
	          fs = p[off++];
	          x1 = cpx, y1 = cpy;
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.A;
	          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	          break;
	
	        case 'a':
	          rx = p[off++];
	          ry = p[off++];
	          psi = p[off++];
	          fa = p[off++];
	          fs = p[off++];
	          x1 = cpx, y1 = cpy;
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.A;
	          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	          break;
	      }
	    }
	
	    if (cmdStr === 'z' || cmdStr === 'Z') {
	      cmd = CMD.Z;
	      path.addData(cmd); // z may be in the middle of the path.
	
	      cpx = subpathX;
	      cpy = subpathY;
	    }
	
	    prevCmd = cmd;
	  }
	
	  path.toStatic();
	  return path;
	} // TODO Optimize double memory cost problem
	
	
	function createPathOptions(str, opts) {
	  var pathProxy = createPathProxyFromString(str);
	  opts = opts || {};
	
	  opts.buildPath = function (path) {
	    if (path.setData) {
	      path.setData(pathProxy.data); // Svg and vml renderer don't have context
	
	      var ctx = path.getContext();
	
	      if (ctx) {
	        path.rebuildPath(ctx);
	      }
	    } else {
	      var ctx = path;
	      pathProxy.rebuildPath(ctx);
	    }
	  };
	
	  opts.applyTransform = function (m) {
	    transformPath(pathProxy, m);
	    this.dirty(true);
	  };
	
	  return opts;
	}
	/**
	 * Create a Path object from path string data
	 * http://www.w3.org/TR/SVG/paths.html#PathData
	 * @param  {Object} opts Other options
	 */
	
	
	function createFromString(str, opts) {
	  return new Path(createPathOptions(str, opts));
	}
	/**
	 * Create a Path class from path string data
	 * @param  {string} str
	 * @param  {Object} opts Other options
	 */
	
	
	function extendFromString(str, opts) {
	  return Path.extend(createPathOptions(str, opts));
	}
	/**
	 * Merge multiple paths
	 */
	// TODO Apply transform
	// TODO stroke dash
	// TODO Optimize double memory cost problem
	
	
	function mergePath(pathEls, opts) {
	  var pathList = [];
	  var len = pathEls.length;
	
	  for (var i = 0; i < len; i++) {
	    var pathEl = pathEls[i];
	
	    if (!pathEl.path) {
	      pathEl.createPathProxy();
	    }
	
	    if (pathEl.__dirtyPath) {
	      pathEl.buildPath(pathEl.path, pathEl.shape, true);
	    }
	
	    pathList.push(pathEl.path);
	  }
	
	  var pathBundle = new Path(opts); // Need path proxy.
	
	  pathBundle.createPathProxy();
	
	  pathBundle.buildPath = function (path) {
	    path.appendPath(pathList); // Svg and vml renderer don't have context
	
	    var ctx = path.getContext();
	
	    if (ctx) {
	      path.rebuildPath(ctx);
	    }
	  };
	
	  return pathBundle;
	}
	
	exports.createFromString = createFromString;
	exports.extendFromString = extendFromString;
	exports.mergePath = mergePath;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(252);
	
	var zrUtil = __webpack_require__(220);
	
	var PathProxy = __webpack_require__(271);
	
	var pathContain = __webpack_require__(274);
	
	var Pattern = __webpack_require__(249);
	
	var getCanvasPattern = Pattern.prototype.getCanvasPattern;
	var abs = Math.abs;
	var pathProxyForDraw = new PathProxy(true);
	/**
	 * @alias module:zrender/graphic/Path
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	
	function Path(opts) {
	  Displayable.call(this, opts);
	  /**
	   * @type {module:zrender/core/PathProxy}
	   * @readOnly
	   */
	
	  this.path = null;
	}
	
	Path.prototype = {
	  constructor: Path,
	  type: 'path',
	  __dirtyPath: true,
	  strokeContainThreshold: 5,
	  // This item default to be false. But in map series in echarts,
	  // in order to improve performance, it should be set to true,
	  // so the shorty segment won't draw.
	  segmentIgnoreThreshold: 0,
	
	  /**
	   * See `module:zrender/src/graphic/helper/subPixelOptimize`.
	   * @type {boolean}
	   */
	  subPixelOptimize: false,
	  brush: function (ctx, prevEl) {
	    var style = this.style;
	    var path = this.path || pathProxyForDraw;
	    var hasStroke = style.hasStroke();
	    var hasFill = style.hasFill();
	    var fill = style.fill;
	    var stroke = style.stroke;
	    var hasFillGradient = hasFill && !!fill.colorStops;
	    var hasStrokeGradient = hasStroke && !!stroke.colorStops;
	    var hasFillPattern = hasFill && !!fill.image;
	    var hasStrokePattern = hasStroke && !!stroke.image;
	    style.bind(ctx, this, prevEl);
	    this.setTransform(ctx);
	
	    if (this.__dirty) {
	      var rect; // Update gradient because bounding rect may changed
	
	      if (hasFillGradient) {
	        rect = rect || this.getBoundingRect();
	        this._fillGradient = style.getGradient(ctx, fill, rect);
	      }
	
	      if (hasStrokeGradient) {
	        rect = rect || this.getBoundingRect();
	        this._strokeGradient = style.getGradient(ctx, stroke, rect);
	      }
	    } // Use the gradient or pattern
	
	
	    if (hasFillGradient) {
	      // PENDING If may have affect the state
	      ctx.fillStyle = this._fillGradient;
	    } else if (hasFillPattern) {
	      ctx.fillStyle = getCanvasPattern.call(fill, ctx);
	    }
	
	    if (hasStrokeGradient) {
	      ctx.strokeStyle = this._strokeGradient;
	    } else if (hasStrokePattern) {
	      ctx.strokeStyle = getCanvasPattern.call(stroke, ctx);
	    }
	
	    var lineDash = style.lineDash;
	    var lineDashOffset = style.lineDashOffset;
	    var ctxLineDash = !!ctx.setLineDash; // Update path sx, sy
	
	    var scale = this.getGlobalScale();
	    path.setScale(scale[0], scale[1], this.segmentIgnoreThreshold); // Proxy context
	    // Rebuild path in following 2 cases
	    // 1. Path is dirty
	    // 2. Path needs javascript implemented lineDash stroking.
	    //    In this case, lineDash information will not be saved in PathProxy
	
	    if (this.__dirtyPath || lineDash && !ctxLineDash && hasStroke) {
	      path.beginPath(ctx); // Setting line dash before build path
	
	      if (lineDash && !ctxLineDash) {
	        path.setLineDash(lineDash);
	        path.setLineDashOffset(lineDashOffset);
	      }
	
	      this.buildPath(path, this.shape, false); // Clear path dirty flag
	
	      if (this.path) {
	        this.__dirtyPath = false;
	      }
	    } else {
	      // Replay path building
	      ctx.beginPath();
	      this.path.rebuildPath(ctx);
	    }
	
	    if (hasFill) {
	      if (style.fillOpacity != null) {
	        var originalGlobalAlpha = ctx.globalAlpha;
	        ctx.globalAlpha = style.fillOpacity * style.opacity;
	        path.fill(ctx);
	        ctx.globalAlpha = originalGlobalAlpha;
	      } else {
	        path.fill(ctx);
	      }
	    }
	
	    if (lineDash && ctxLineDash) {
	      ctx.setLineDash(lineDash);
	      ctx.lineDashOffset = lineDashOffset;
	    }
	
	    if (hasStroke) {
	      if (style.strokeOpacity != null) {
	        var originalGlobalAlpha = ctx.globalAlpha;
	        ctx.globalAlpha = style.strokeOpacity * style.opacity;
	        path.stroke(ctx);
	        ctx.globalAlpha = originalGlobalAlpha;
	      } else {
	        path.stroke(ctx);
	      }
	    }
	
	    if (lineDash && ctxLineDash) {
	      // PENDING
	      // Remove lineDash
	      ctx.setLineDash([]);
	    } // Draw rect text
	
	
	    if (style.text != null) {
	      // Only restore transform when needs draw text.
	      this.restoreTransform(ctx);
	      this.drawRectText(ctx, this.getBoundingRect());
	    }
	  },
	  // When bundling path, some shape may decide if use moveTo to begin a new subpath or closePath
	  // Like in circle
	  buildPath: function (ctx, shapeCfg, inBundle) {},
	  createPathProxy: function () {
	    this.path = new PathProxy();
	  },
	  getBoundingRect: function () {
	    var rect = this._rect;
	    var style = this.style;
	    var needsUpdateRect = !rect;
	
	    if (needsUpdateRect) {
	      var path = this.path;
	
	      if (!path) {
	        // Create path on demand.
	        path = this.path = new PathProxy();
	      }
	
	      if (this.__dirtyPath) {
	        path.beginPath();
	        this.buildPath(path, this.shape, false);
	      }
	
	      rect = path.getBoundingRect();
	    }
	
	    this._rect = rect;
	
	    if (style.hasStroke()) {
	      // Needs update rect with stroke lineWidth when
	      // 1. Element changes scale or lineWidth
	      // 2. Shape is changed
	      var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
	
	      if (this.__dirty || needsUpdateRect) {
	        rectWithStroke.copy(rect); // FIXME Must after updateTransform
	
	        var w = style.lineWidth; // PENDING, Min line width is needed when line is horizontal or vertical
	
	        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Only add extra hover lineWidth when there are no fill
	
	        if (!style.hasFill()) {
	          w = Math.max(w, this.strokeContainThreshold || 4);
	        } // Consider line width
	        // Line scale can't be 0;
	
	
	        if (lineScale > 1e-10) {
	          rectWithStroke.width += w / lineScale;
	          rectWithStroke.height += w / lineScale;
	          rectWithStroke.x -= w / lineScale / 2;
	          rectWithStroke.y -= w / lineScale / 2;
	        }
	      } // Return rect with stroke
	
	
	      return rectWithStroke;
	    }
	
	    return rect;
	  },
	  contain: function (x, y) {
	    var localPos = this.transformCoordToLocal(x, y);
	    var rect = this.getBoundingRect();
	    var style = this.style;
	    x = localPos[0];
	    y = localPos[1];
	
	    if (rect.contain(x, y)) {
	      var pathData = this.path.data;
	
	      if (style.hasStroke()) {
	        var lineWidth = style.lineWidth;
	        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Line scale can't be 0;
	
	        if (lineScale > 1e-10) {
	          // Only add extra hover lineWidth when there are no fill
	          if (!style.hasFill()) {
	            lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
	          }
	
	          if (pathContain.containStroke(pathData, lineWidth / lineScale, x, y)) {
	            return true;
	          }
	        }
	      }
	
	      if (style.hasFill()) {
	        return pathContain.contain(pathData, x, y);
	      }
	    }
	
	    return false;
	  },
	
	  /**
	   * @param  {boolean} dirtyPath
	   */
	  dirty: function (dirtyPath) {
	    if (dirtyPath == null) {
	      dirtyPath = true;
	    } // Only mark dirty, not mark clean
	
	
	    if (dirtyPath) {
	      this.__dirtyPath = dirtyPath;
	      this._rect = null;
	    }
	
	    this.__dirty = this.__dirtyText = true;
	    this.__zr && this.__zr.refresh(); // Used as a clipping path
	
	    if (this.__clipTarget) {
	      this.__clipTarget.dirty();
	    }
	  },
	
	  /**
	   * Alias for animate('shape')
	   * @param {boolean} loop
	   */
	  animateShape: function (loop) {
	    return this.animate('shape', loop);
	  },
	  // Overwrite attrKV
	  attrKV: function (key, value) {
	    // FIXME
	    if (key === 'shape') {
	      this.setShape(value);
	      this.__dirtyPath = true;
	      this._rect = null;
	    } else {
	      Displayable.prototype.attrKV.call(this, key, value);
	    }
	  },
	
	  /**
	   * @param {Object|string} key
	   * @param {*} value
	   */
	  setShape: function (key, value) {
	    var shape = this.shape; // Path from string may not have shape
	
	    if (shape) {
	      if (zrUtil.isObject(key)) {
	        for (var name in key) {
	          if (key.hasOwnProperty(name)) {
	            shape[name] = key[name];
	          }
	        }
	      } else {
	        shape[key] = value;
	      }
	
	      this.dirty(true);
	    }
	
	    return this;
	  },
	  getLineScale: function () {
	    var m = this.transform; // Get the line scale.
	    // Determinant of `m` means how much the area is enlarged by the
	    // transformation. So its square root can be used as a scale factor
	    // for width.
	
	    return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10 ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1])) : 1;
	  }
	};
	/**
	 * 扩展一个 Path element, 比如星形，圆等。
	 * Extend a path element
	 * @param {Object} props
	 * @param {string} props.type Path type
	 * @param {Function} props.init Initialize
	 * @param {Function} props.buildPath Overwrite buildPath method
	 * @param {Object} [props.style] Extended default style config
	 * @param {Object} [props.shape] Extended default shape config
	 */
	
	Path.extend = function (defaults) {
	  var Sub = function (opts) {
	    Path.call(this, opts);
	
	    if (defaults.style) {
	      // Extend default style
	      this.style.extendFrom(defaults.style, false);
	    } // Extend default shape
	
	
	    var defaultShape = defaults.shape;
	
	    if (defaultShape) {
	      this.shape = this.shape || {};
	      var thisShape = this.shape;
	
	      for (var name in defaultShape) {
	        if (!thisShape.hasOwnProperty(name) && defaultShape.hasOwnProperty(name)) {
	          thisShape[name] = defaultShape[name];
	        }
	      }
	    }
	
	    defaults.init && defaults.init.call(this, opts);
	  };
	
	  zrUtil.inherits(Sub, Path); // FIXME 不能 extend position, rotation 等引用对象
	
	  for (var name in defaults) {
	    // Extending prototype values and methods
	    if (name !== 'style' && name !== 'shape') {
	      Sub.prototype[name] = defaults[name];
	    }
	  }
	
	  return Sub;
	};
	
	zrUtil.inherits(Path, Displayable);
	var _default = Path;
	module.exports = _default;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var curve = __webpack_require__(272);
	
	var vec2 = __webpack_require__(222);
	
	var bbox = __webpack_require__(273);
	
	var BoundingRect = __webpack_require__(242);
	
	var _config = __webpack_require__(241);
	
	var dpr = _config.devicePixelRatio;
	
	/**
	 * Path 代理，可以在`buildPath`中用于替代`ctx`, 会保存每个path操作的命令到pathCommands属性中
	 * 可以用于 isInsidePath 判断以及获取boundingRect
	 *
	 * @module zrender/core/PathProxy
	 * @author Yi Shen (http://www.github.com/pissang)
	 */
	// TODO getTotalLength, getPointAtLength
	
	/* global Float32Array */
	var CMD = {
	  M: 1,
	  L: 2,
	  C: 3,
	  Q: 4,
	  A: 5,
	  Z: 6,
	  // Rect
	  R: 7
	}; // var CMD_MEM_SIZE = {
	//     M: 3,
	//     L: 3,
	//     C: 7,
	//     Q: 5,
	//     A: 9,
	//     R: 5,
	//     Z: 1
	// };
	
	var min = [];
	var max = [];
	var min2 = [];
	var max2 = [];
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathCos = Math.cos;
	var mathSin = Math.sin;
	var mathSqrt = Math.sqrt;
	var mathAbs = Math.abs;
	var hasTypedArray = typeof Float32Array !== 'undefined';
	/**
	 * @alias module:zrender/core/PathProxy
	 * @constructor
	 */
	
	var PathProxy = function (notSaveData) {
	  this._saveData = !(notSaveData || false);
	
	  if (this._saveData) {
	    /**
	     * Path data. Stored as flat array
	     * @type {Array.<Object>}
	     */
	    this.data = [];
	  }
	
	  this._ctx = null;
	};
	/**
	 * 快速计算Path包围盒（并不是最小包围盒）
	 * @return {Object}
	 */
	
	
	PathProxy.prototype = {
	  constructor: PathProxy,
	  _xi: 0,
	  _yi: 0,
	  _x0: 0,
	  _y0: 0,
	  // Unit x, Unit y. Provide for avoiding drawing that too short line segment
	  _ux: 0,
	  _uy: 0,
	  _len: 0,
	  _lineDash: null,
	  _dashOffset: 0,
	  _dashIdx: 0,
	  _dashSum: 0,
	
	  /**
	   * @readOnly
	   */
	  setScale: function (sx, sy, segmentIgnoreThreshold) {
	    // Compat. Previously there is no segmentIgnoreThreshold.
	    segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
	    this._ux = mathAbs(segmentIgnoreThreshold / dpr / sx) || 0;
	    this._uy = mathAbs(segmentIgnoreThreshold / dpr / sy) || 0;
	  },
	  getContext: function () {
	    return this._ctx;
	  },
	
	  /**
	   * @param  {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  beginPath: function (ctx) {
	    this._ctx = ctx;
	    ctx && ctx.beginPath();
	    ctx && (this.dpr = ctx.dpr); // Reset
	
	    if (this._saveData) {
	      this._len = 0;
	    }
	
	    if (this._lineDash) {
	      this._lineDash = null;
	      this._dashOffset = 0;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param  {number} x
	   * @param  {number} y
	   * @return {module:zrender/core/PathProxy}
	   */
	  moveTo: function (x, y) {
	    this.addData(CMD.M, x, y);
	    this._ctx && this._ctx.moveTo(x, y); // x0, y0, xi, yi 是记录在 _dashedXXXXTo 方法中使用
	    // xi, yi 记录当前点, x0, y0 在 closePath 的时候回到起始点。
	    // 有可能在 beginPath 之后直接调用 lineTo，这时候 x0, y0 需要
	    // 在 lineTo 方法中记录，这里先不考虑这种情况，dashed line 也只在 IE10- 中不支持
	
	    this._x0 = x;
	    this._y0 = y;
	    this._xi = x;
	    this._yi = y;
	    return this;
	  },
	
	  /**
	   * @param  {number} x
	   * @param  {number} y
	   * @return {module:zrender/core/PathProxy}
	   */
	  lineTo: function (x, y) {
	    var exceedUnit = mathAbs(x - this._xi) > this._ux || mathAbs(y - this._yi) > this._uy // Force draw the first segment
	    || this._len < 5;
	    this.addData(CMD.L, x, y);
	
	    if (this._ctx && exceedUnit) {
	      this._needsDash() ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
	    }
	
	    if (exceedUnit) {
	      this._xi = x;
	      this._yi = y;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param  {number} x1
	   * @param  {number} y1
	   * @param  {number} x2
	   * @param  {number} y2
	   * @param  {number} x3
	   * @param  {number} y3
	   * @return {module:zrender/core/PathProxy}
	   */
	  bezierCurveTo: function (x1, y1, x2, y2, x3, y3) {
	    this.addData(CMD.C, x1, y1, x2, y2, x3, y3);
	
	    if (this._ctx) {
	      this._needsDash() ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
	    }
	
	    this._xi = x3;
	    this._yi = y3;
	    return this;
	  },
	
	  /**
	   * @param  {number} x1
	   * @param  {number} y1
	   * @param  {number} x2
	   * @param  {number} y2
	   * @return {module:zrender/core/PathProxy}
	   */
	  quadraticCurveTo: function (x1, y1, x2, y2) {
	    this.addData(CMD.Q, x1, y1, x2, y2);
	
	    if (this._ctx) {
	      this._needsDash() ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
	    }
	
	    this._xi = x2;
	    this._yi = y2;
	    return this;
	  },
	
	  /**
	   * @param  {number} cx
	   * @param  {number} cy
	   * @param  {number} r
	   * @param  {number} startAngle
	   * @param  {number} endAngle
	   * @param  {boolean} anticlockwise
	   * @return {module:zrender/core/PathProxy}
	   */
	  arc: function (cx, cy, r, startAngle, endAngle, anticlockwise) {
	    this.addData(CMD.A, cx, cy, r, r, startAngle, endAngle - startAngle, 0, anticlockwise ? 0 : 1);
	    this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
	    this._xi = mathCos(endAngle) * r + cx;
	    this._yi = mathSin(endAngle) * r + cy;
	    return this;
	  },
	  // TODO
	  arcTo: function (x1, y1, x2, y2, radius) {
	    if (this._ctx) {
	      this._ctx.arcTo(x1, y1, x2, y2, radius);
	    }
	
	    return this;
	  },
	  // TODO
	  rect: function (x, y, w, h) {
	    this._ctx && this._ctx.rect(x, y, w, h);
	    this.addData(CMD.R, x, y, w, h);
	    return this;
	  },
	
	  /**
	   * @return {module:zrender/core/PathProxy}
	   */
	  closePath: function () {
	    this.addData(CMD.Z);
	    var ctx = this._ctx;
	    var x0 = this._x0;
	    var y0 = this._y0;
	
	    if (ctx) {
	      this._needsDash() && this._dashedLineTo(x0, y0);
	      ctx.closePath();
	    }
	
	    this._xi = x0;
	    this._yi = y0;
	    return this;
	  },
	
	  /**
	   * Context 从外部传入，因为有可能是 rebuildPath 完之后再 fill。
	   * stroke 同样
	   * @param {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  fill: function (ctx) {
	    ctx && ctx.fill();
	    this.toStatic();
	  },
	
	  /**
	   * @param {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  stroke: function (ctx) {
	    ctx && ctx.stroke();
	    this.toStatic();
	  },
	
	  /**
	   * 必须在其它绘制命令前调用
	   * Must be invoked before all other path drawing methods
	   * @return {module:zrender/core/PathProxy}
	   */
	  setLineDash: function (lineDash) {
	    if (lineDash instanceof Array) {
	      this._lineDash = lineDash;
	      this._dashIdx = 0;
	      var lineDashSum = 0;
	
	      for (var i = 0; i < lineDash.length; i++) {
	        lineDashSum += lineDash[i];
	      }
	
	      this._dashSum = lineDashSum;
	    }
	
	    return this;
	  },
	
	  /**
	   * 必须在其它绘制命令前调用
	   * Must be invoked before all other path drawing methods
	   * @return {module:zrender/core/PathProxy}
	   */
	  setLineDashOffset: function (offset) {
	    this._dashOffset = offset;
	    return this;
	  },
	
	  /**
	   *
	   * @return {boolean}
	   */
	  len: function () {
	    return this._len;
	  },
	
	  /**
	   * 直接设置 Path 数据
	   */
	  setData: function (data) {
	    var len = data.length;
	
	    if (!(this.data && this.data.length === len) && hasTypedArray) {
	      this.data = new Float32Array(len);
	    }
	
	    for (var i = 0; i < len; i++) {
	      this.data[i] = data[i];
	    }
	
	    this._len = len;
	  },
	
	  /**
	   * 添加子路径
	   * @param {module:zrender/core/PathProxy|Array.<module:zrender/core/PathProxy>} path
	   */
	  appendPath: function (path) {
	    if (!(path instanceof Array)) {
	      path = [path];
	    }
	
	    var len = path.length;
	    var appendSize = 0;
	    var offset = this._len;
	
	    for (var i = 0; i < len; i++) {
	      appendSize += path[i].len();
	    }
	
	    if (hasTypedArray && this.data instanceof Float32Array) {
	      this.data = new Float32Array(offset + appendSize);
	    }
	
	    for (var i = 0; i < len; i++) {
	      var appendPathData = path[i].data;
	
	      for (var k = 0; k < appendPathData.length; k++) {
	        this.data[offset++] = appendPathData[k];
	      }
	    }
	
	    this._len = offset;
	  },
	
	  /**
	   * 填充 Path 数据。
	   * 尽量复用而不申明新的数组。大部分图形重绘的指令数据长度都是不变的。
	   */
	  addData: function (cmd) {
	    if (!this._saveData) {
	      return;
	    }
	
	    var data = this.data;
	
	    if (this._len + arguments.length > data.length) {
	      // 因为之前的数组已经转换成静态的 Float32Array
	      // 所以不够用时需要扩展一个新的动态数组
	      this._expandData();
	
	      data = this.data;
	    }
	
	    for (var i = 0; i < arguments.length; i++) {
	      data[this._len++] = arguments[i];
	    }
	
	    this._prevCmd = cmd;
	  },
	  _expandData: function () {
	    // Only if data is Float32Array
	    if (!(this.data instanceof Array)) {
	      var newData = [];
	
	      for (var i = 0; i < this._len; i++) {
	        newData[i] = this.data[i];
	      }
	
	      this.data = newData;
	    }
	  },
	
	  /**
	   * If needs js implemented dashed line
	   * @return {boolean}
	   * @private
	   */
	  _needsDash: function () {
	    return this._lineDash;
	  },
	  _dashedLineTo: function (x1, y1) {
	    var dashSum = this._dashSum;
	    var offset = this._dashOffset;
	    var lineDash = this._lineDash;
	    var ctx = this._ctx;
	    var x0 = this._xi;
	    var y0 = this._yi;
	    var dx = x1 - x0;
	    var dy = y1 - y0;
	    var dist = mathSqrt(dx * dx + dy * dy);
	    var x = x0;
	    var y = y0;
	    var dash;
	    var nDash = lineDash.length;
	    var idx;
	    dx /= dist;
	    dy /= dist;
	
	    if (offset < 0) {
	      // Convert to positive offset
	      offset = dashSum + offset;
	    }
	
	    offset %= dashSum;
	    x -= offset * dx;
	    y -= offset * dy;
	
	    while (dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)) {
	      idx = this._dashIdx;
	      dash = lineDash[idx];
	      x += dx * dash;
	      y += dy * dash;
	      this._dashIdx = (idx + 1) % nDash; // Skip positive offset
	
	      if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) {
	        continue;
	      }
	
	      ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? mathMin(x, x1) : mathMax(x, x1), dy >= 0 ? mathMin(y, y1) : mathMax(y, y1));
	    } // Offset for next lineTo
	
	
	    dx = x - x1;
	    dy = y - y1;
	    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
	  },
	  // Not accurate dashed line to
	  _dashedBezierTo: function (x1, y1, x2, y2, x3, y3) {
	    var dashSum = this._dashSum;
	    var offset = this._dashOffset;
	    var lineDash = this._lineDash;
	    var ctx = this._ctx;
	    var x0 = this._xi;
	    var y0 = this._yi;
	    var t;
	    var dx;
	    var dy;
	    var cubicAt = curve.cubicAt;
	    var bezierLen = 0;
	    var idx = this._dashIdx;
	    var nDash = lineDash.length;
	    var x;
	    var y;
	    var tmpLen = 0;
	
	    if (offset < 0) {
	      // Convert to positive offset
	      offset = dashSum + offset;
	    }
	
	    offset %= dashSum; // Bezier approx length
	
	    for (t = 0; t < 1; t += 0.1) {
	      dx = cubicAt(x0, x1, x2, x3, t + 0.1) - cubicAt(x0, x1, x2, x3, t);
	      dy = cubicAt(y0, y1, y2, y3, t + 0.1) - cubicAt(y0, y1, y2, y3, t);
	      bezierLen += mathSqrt(dx * dx + dy * dy);
	    } // Find idx after add offset
	
	
	    for (; idx < nDash; idx++) {
	      tmpLen += lineDash[idx];
	
	      if (tmpLen > offset) {
	        break;
	      }
	    }
	
	    t = (tmpLen - offset) / bezierLen;
	
	    while (t <= 1) {
	      x = cubicAt(x0, x1, x2, x3, t);
	      y = cubicAt(y0, y1, y2, y3, t); // Use line to approximate dashed bezier
	      // Bad result if dash is long
	
	      idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
	      t += lineDash[idx] / bezierLen;
	      idx = (idx + 1) % nDash;
	    } // Finish the last segment and calculate the new offset
	
	
	    idx % 2 !== 0 && ctx.lineTo(x3, y3);
	    dx = x3 - x;
	    dy = y3 - y;
	    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
	  },
	  _dashedQuadraticTo: function (x1, y1, x2, y2) {
	    // Convert quadratic to cubic using degree elevation
	    var x3 = x2;
	    var y3 = y2;
	    x2 = (x2 + 2 * x1) / 3;
	    y2 = (y2 + 2 * y1) / 3;
	    x1 = (this._xi + 2 * x1) / 3;
	    y1 = (this._yi + 2 * y1) / 3;
	
	    this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
	  },
	
	  /**
	   * 转成静态的 Float32Array 减少堆内存占用
	   * Convert dynamic array to static Float32Array
	   */
	  toStatic: function () {
	    var data = this.data;
	
	    if (data instanceof Array) {
	      data.length = this._len;
	
	      if (hasTypedArray) {
	        this.data = new Float32Array(data);
	      }
	    }
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function () {
	    min[0] = min[1] = min2[0] = min2[1] = Number.MAX_VALUE;
	    max[0] = max[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
	    var data = this.data;
	    var xi = 0;
	    var yi = 0;
	    var x0 = 0;
	    var y0 = 0;
	
	    for (var i = 0; i < data.length;) {
	      var cmd = data[i++];
	
	      if (i === 1) {
	        // 如果第一个命令是 L, C, Q
	        // 则 previous point 同绘制命令的第一个 point
	        //
	        // 第一个命令为 Arc 的情况下会在后面特殊处理
	        xi = data[i];
	        yi = data[i + 1];
	        x0 = xi;
	        y0 = yi;
	      }
	
	      switch (cmd) {
	        case CMD.M:
	          // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	          // 在 closePath 的时候使用
	          x0 = data[i++];
	          y0 = data[i++];
	          xi = x0;
	          yi = y0;
	          min2[0] = x0;
	          min2[1] = y0;
	          max2[0] = x0;
	          max2[1] = y0;
	          break;
	
	        case CMD.L:
	          bbox.fromLine(xi, yi, data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.C:
	          bbox.fromCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.Q:
	          bbox.fromQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.A:
	          // TODO Arc 判断的开销比较大
	          var cx = data[i++];
	          var cy = data[i++];
	          var rx = data[i++];
	          var ry = data[i++];
	          var startAngle = data[i++];
	          var endAngle = data[i++] + startAngle; // TODO Arc 旋转
	
	          i += 1;
	          var anticlockwise = 1 - data[i++];
	
	          if (i === 1) {
	            // 直接使用 arc 命令
	            // 第一个命令起点还未定义
	            x0 = mathCos(startAngle) * rx + cx;
	            y0 = mathSin(startAngle) * ry + cy;
	          }
	
	          bbox.fromArc(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
	          xi = mathCos(endAngle) * rx + cx;
	          yi = mathSin(endAngle) * ry + cy;
	          break;
	
	        case CMD.R:
	          x0 = xi = data[i++];
	          y0 = yi = data[i++];
	          var width = data[i++];
	          var height = data[i++]; // Use fromLine
	
	          bbox.fromLine(x0, y0, x0 + width, y0 + height, min2, max2);
	          break;
	
	        case CMD.Z:
	          xi = x0;
	          yi = y0;
	          break;
	      } // Union
	
	
	      vec2.min(min, min, min2);
	      vec2.max(max, max, max2);
	    } // No data
	
	
	    if (i === 0) {
	      min[0] = min[1] = max[0] = max[1] = 0;
	    }
	
	    return new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	  },
	
	  /**
	   * Rebuild path from current data
	   * Rebuild path will not consider javascript implemented line dash.
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  rebuildPath: function (ctx) {
	    var d = this.data;
	    var x0;
	    var y0;
	    var xi;
	    var yi;
	    var x;
	    var y;
	    var ux = this._ux;
	    var uy = this._uy;
	    var len = this._len;
	
	    for (var i = 0; i < len;) {
	      var cmd = d[i++];
	
	      if (i === 1) {
	        // 如果第一个命令是 L, C, Q
	        // 则 previous point 同绘制命令的第一个 point
	        //
	        // 第一个命令为 Arc 的情况下会在后面特殊处理
	        xi = d[i];
	        yi = d[i + 1];
	        x0 = xi;
	        y0 = yi;
	      }
	
	      switch (cmd) {
	        case CMD.M:
	          x0 = xi = d[i++];
	          y0 = yi = d[i++];
	          ctx.moveTo(xi, yi);
	          break;
	
	        case CMD.L:
	          x = d[i++];
	          y = d[i++]; // Not draw too small seg between
	
	          if (mathAbs(x - xi) > ux || mathAbs(y - yi) > uy || i === len - 1) {
	            ctx.lineTo(x, y);
	            xi = x;
	            yi = y;
	          }
	
	          break;
	
	        case CMD.C:
	          ctx.bezierCurveTo(d[i++], d[i++], d[i++], d[i++], d[i++], d[i++]);
	          xi = d[i - 2];
	          yi = d[i - 1];
	          break;
	
	        case CMD.Q:
	          ctx.quadraticCurveTo(d[i++], d[i++], d[i++], d[i++]);
	          xi = d[i - 2];
	          yi = d[i - 1];
	          break;
	
	        case CMD.A:
	          var cx = d[i++];
	          var cy = d[i++];
	          var rx = d[i++];
	          var ry = d[i++];
	          var theta = d[i++];
	          var dTheta = d[i++];
	          var psi = d[i++];
	          var fs = d[i++];
	          var r = rx > ry ? rx : ry;
	          var scaleX = rx > ry ? 1 : rx / ry;
	          var scaleY = rx > ry ? ry / rx : 1;
	          var isEllipse = Math.abs(rx - ry) > 1e-3;
	          var endAngle = theta + dTheta;
	
	          if (isEllipse) {
	            ctx.translate(cx, cy);
	            ctx.rotate(psi);
	            ctx.scale(scaleX, scaleY);
	            ctx.arc(0, 0, r, theta, endAngle, 1 - fs);
	            ctx.scale(1 / scaleX, 1 / scaleY);
	            ctx.rotate(-psi);
	            ctx.translate(-cx, -cy);
	          } else {
	            ctx.arc(cx, cy, r, theta, endAngle, 1 - fs);
	          }
	
	          if (i === 1) {
	            // 直接使用 arc 命令
	            // 第一个命令起点还未定义
	            x0 = mathCos(theta) * rx + cx;
	            y0 = mathSin(theta) * ry + cy;
	          }
	
	          xi = mathCos(endAngle) * rx + cx;
	          yi = mathSin(endAngle) * ry + cy;
	          break;
	
	        case CMD.R:
	          x0 = xi = d[i];
	          y0 = yi = d[i + 1];
	          ctx.rect(d[i++], d[i++], d[i++], d[i++]);
	          break;
	
	        case CMD.Z:
	          ctx.closePath();
	          xi = x0;
	          yi = y0;
	      }
	    }
	  }
	};
	PathProxy.CMD = CMD;
	var _default = PathProxy;
	module.exports = _default;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(222);
	
	var v2Create = _vector.create;
	var v2DistSquare = _vector.distSquare;
	
	/**
	 * 曲线辅助模块
	 * @module zrender/core/curve
	 * @author pissang(https://www.github.com/pissang)
	 */
	var mathPow = Math.pow;
	var mathSqrt = Math.sqrt;
	var EPSILON = 1e-8;
	var EPSILON_NUMERIC = 1e-4;
	var THREE_SQRT = mathSqrt(3);
	var ONE_THIRD = 1 / 3; // 临时变量
	
	var _v0 = v2Create();
	
	var _v1 = v2Create();
	
	var _v2 = v2Create();
	
	function isAroundZero(val) {
	  return val > -EPSILON && val < EPSILON;
	}
	
	function isNotAroundZero(val) {
	  return val > EPSILON || val < -EPSILON;
	}
	/**
	 * 计算三次贝塞尔值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function cubicAt(p0, p1, p2, p3, t) {
	  var onet = 1 - t;
	  return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
	}
	/**
	 * 计算三次贝塞尔导数值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function cubicDerivativeAt(p0, p1, p2, p3, t) {
	  var onet = 1 - t;
	  return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
	}
	/**
	 * 计算三次贝塞尔方程根，使用盛金公式
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} val
	 * @param  {Array.<number>} roots
	 * @return {number} 有效根数目
	 */
	
	
	function cubicRootAt(p0, p1, p2, p3, val, roots) {
	  // Evaluate roots of cubic functions
	  var a = p3 + 3 * (p1 - p2) - p0;
	  var b = 3 * (p2 - p1 * 2 + p0);
	  var c = 3 * (p1 - p0);
	  var d = p0 - val;
	  var A = b * b - 3 * a * c;
	  var B = b * c - 9 * a * d;
	  var C = c * c - 3 * b * d;
	  var n = 0;
	
	  if (isAroundZero(A) && isAroundZero(B)) {
	    if (isAroundZero(b)) {
	      roots[0] = 0;
	    } else {
	      var t1 = -c / b; //t1, t2, t3, b is not zero
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    }
	  } else {
	    var disc = B * B - 4 * A * C;
	
	    if (isAroundZero(disc)) {
	      var K = B / A;
	      var t1 = -b / a + K; // t1, a is not zero
	
	      var t2 = -K / 2; // t2, t3
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var Y1 = A * b + 1.5 * a * (-B + discSqrt);
	      var Y2 = A * b + 1.5 * a * (-B - discSqrt);
	
	      if (Y1 < 0) {
	        Y1 = -mathPow(-Y1, ONE_THIRD);
	      } else {
	        Y1 = mathPow(Y1, ONE_THIRD);
	      }
	
	      if (Y2 < 0) {
	        Y2 = -mathPow(-Y2, ONE_THIRD);
	      } else {
	        Y2 = mathPow(Y2, ONE_THIRD);
	      }
	
	      var t1 = (-b - (Y1 + Y2)) / (3 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    } else {
	      var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
	      var theta = Math.acos(T) / 3;
	      var ASqrt = mathSqrt(A);
	      var tmp = Math.cos(theta);
	      var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
	      var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
	      var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	
	      if (t3 >= 0 && t3 <= 1) {
	        roots[n++] = t3;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 计算三次贝塞尔方程极限值的位置
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {Array.<number>} extrema
	 * @return {number} 有效数目
	 */
	
	
	function cubicExtrema(p0, p1, p2, p3, extrema) {
	  var b = 6 * p2 - 12 * p1 + 6 * p0;
	  var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
	  var c = 3 * p1 - 3 * p0;
	  var n = 0;
	
	  if (isAroundZero(a)) {
	    if (isNotAroundZero(b)) {
	      var t1 = -c / b;
	
	      if (t1 >= 0 && t1 <= 1) {
	        extrema[n++] = t1;
	      }
	    }
	  } else {
	    var disc = b * b - 4 * a * c;
	
	    if (isAroundZero(disc)) {
	      extrema[0] = -b / (2 * a);
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var t1 = (-b + discSqrt) / (2 * a);
	      var t2 = (-b - discSqrt) / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        extrema[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        extrema[n++] = t2;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 细分三次贝塞尔曲线
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @param  {Array.<number>} out
	 */
	
	
	function cubicSubdivide(p0, p1, p2, p3, t, out) {
	  var p01 = (p1 - p0) * t + p0;
	  var p12 = (p2 - p1) * t + p1;
	  var p23 = (p3 - p2) * t + p2;
	  var p012 = (p12 - p01) * t + p01;
	  var p123 = (p23 - p12) * t + p12;
	  var p0123 = (p123 - p012) * t + p012; // Seg0
	
	  out[0] = p0;
	  out[1] = p01;
	  out[2] = p012;
	  out[3] = p0123; // Seg1
	
	  out[4] = p0123;
	  out[5] = p123;
	  out[6] = p23;
	  out[7] = p3;
	}
	/**
	 * 投射点到三次贝塞尔曲线上，返回投射距离。
	 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x3
	 * @param {number} y3
	 * @param {number} x
	 * @param {number} y
	 * @param {Array.<number>} [out] 投射点
	 * @return {number}
	 */
	
	
	function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
	  // http://pomax.github.io/bezierinfo/#projections
	  var t;
	  var interval = 0.005;
	  var d = Infinity;
	  var prev;
	  var next;
	  var d1;
	  var d2;
	  _v0[0] = x;
	  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
	  // PENDING
	
	  for (var _t = 0; _t < 1; _t += 0.05) {
	    _v1[0] = cubicAt(x0, x1, x2, x3, _t);
	    _v1[1] = cubicAt(y0, y1, y2, y3, _t);
	    d1 = v2DistSquare(_v0, _v1);
	
	    if (d1 < d) {
	      t = _t;
	      d = d1;
	    }
	  }
	
	  d = Infinity; // At most 32 iteration
	
	  for (var i = 0; i < 32; i++) {
	    if (interval < EPSILON_NUMERIC) {
	      break;
	    }
	
	    prev = t - interval;
	    next = t + interval; // t - interval
	
	    _v1[0] = cubicAt(x0, x1, x2, x3, prev);
	    _v1[1] = cubicAt(y0, y1, y2, y3, prev);
	    d1 = v2DistSquare(_v1, _v0);
	
	    if (prev >= 0 && d1 < d) {
	      t = prev;
	      d = d1;
	    } else {
	      // t + interval
	      _v2[0] = cubicAt(x0, x1, x2, x3, next);
	      _v2[1] = cubicAt(y0, y1, y2, y3, next);
	      d2 = v2DistSquare(_v2, _v0);
	
	      if (next <= 1 && d2 < d) {
	        t = next;
	        d = d2;
	      } else {
	        interval *= 0.5;
	      }
	    }
	  } // t
	
	
	  if (out) {
	    out[0] = cubicAt(x0, x1, x2, x3, t);
	    out[1] = cubicAt(y0, y1, y2, y3, t);
	  } // console.log(interval, i);
	
	
	  return mathSqrt(d);
	}
	/**
	 * 计算二次方贝塞尔值
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function quadraticAt(p0, p1, p2, t) {
	  var onet = 1 - t;
	  return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
	}
	/**
	 * 计算二次方贝塞尔导数值
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function quadraticDerivativeAt(p0, p1, p2, t) {
	  return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
	}
	/**
	 * 计算二次方贝塞尔方程根
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @param  {Array.<number>} roots
	 * @return {number} 有效根数目
	 */
	
	
	function quadraticRootAt(p0, p1, p2, val, roots) {
	  var a = p0 - 2 * p1 + p2;
	  var b = 2 * (p1 - p0);
	  var c = p0 - val;
	  var n = 0;
	
	  if (isAroundZero(a)) {
	    if (isNotAroundZero(b)) {
	      var t1 = -c / b;
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    }
	  } else {
	    var disc = b * b - 4 * a * c;
	
	    if (isAroundZero(disc)) {
	      var t1 = -b / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var t1 = (-b + discSqrt) / (2 * a);
	      var t2 = (-b - discSqrt) / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 计算二次贝塞尔方程极限值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @return {number}
	 */
	
	
	function quadraticExtremum(p0, p1, p2) {
	  var divider = p0 + p2 - 2 * p1;
	
	  if (divider === 0) {
	    // p1 is center of p0 and p2
	    return 0.5;
	  } else {
	    return (p0 - p1) / divider;
	  }
	}
	/**
	 * 细分二次贝塞尔曲线
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @param  {Array.<number>} out
	 */
	
	
	function quadraticSubdivide(p0, p1, p2, t, out) {
	  var p01 = (p1 - p0) * t + p0;
	  var p12 = (p2 - p1) * t + p1;
	  var p012 = (p12 - p01) * t + p01; // Seg0
	
	  out[0] = p0;
	  out[1] = p01;
	  out[2] = p012; // Seg1
	
	  out[3] = p012;
	  out[4] = p12;
	  out[5] = p2;
	}
	/**
	 * 投射点到二次贝塞尔曲线上，返回投射距离。
	 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x
	 * @param {number} y
	 * @param {Array.<number>} out 投射点
	 * @return {number}
	 */
	
	
	function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
	  // http://pomax.github.io/bezierinfo/#projections
	  var t;
	  var interval = 0.005;
	  var d = Infinity;
	  _v0[0] = x;
	  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
	  // PENDING
	
	  for (var _t = 0; _t < 1; _t += 0.05) {
	    _v1[0] = quadraticAt(x0, x1, x2, _t);
	    _v1[1] = quadraticAt(y0, y1, y2, _t);
	    var d1 = v2DistSquare(_v0, _v1);
	
	    if (d1 < d) {
	      t = _t;
	      d = d1;
	    }
	  }
	
	  d = Infinity; // At most 32 iteration
	
	  for (var i = 0; i < 32; i++) {
	    if (interval < EPSILON_NUMERIC) {
	      break;
	    }
	
	    var prev = t - interval;
	    var next = t + interval; // t - interval
	
	    _v1[0] = quadraticAt(x0, x1, x2, prev);
	    _v1[1] = quadraticAt(y0, y1, y2, prev);
	    var d1 = v2DistSquare(_v1, _v0);
	
	    if (prev >= 0 && d1 < d) {
	      t = prev;
	      d = d1;
	    } else {
	      // t + interval
	      _v2[0] = quadraticAt(x0, x1, x2, next);
	      _v2[1] = quadraticAt(y0, y1, y2, next);
	      var d2 = v2DistSquare(_v2, _v0);
	
	      if (next <= 1 && d2 < d) {
	        t = next;
	        d = d2;
	      } else {
	        interval *= 0.5;
	      }
	    }
	  } // t
	
	
	  if (out) {
	    out[0] = quadraticAt(x0, x1, x2, t);
	    out[1] = quadraticAt(y0, y1, y2, t);
	  } // console.log(interval, i);
	
	
	  return mathSqrt(d);
	}
	
	exports.cubicAt = cubicAt;
	exports.cubicDerivativeAt = cubicDerivativeAt;
	exports.cubicRootAt = cubicRootAt;
	exports.cubicExtrema = cubicExtrema;
	exports.cubicSubdivide = cubicSubdivide;
	exports.cubicProjectPoint = cubicProjectPoint;
	exports.quadraticAt = quadraticAt;
	exports.quadraticDerivativeAt = quadraticDerivativeAt;
	exports.quadraticRootAt = quadraticRootAt;
	exports.quadraticExtremum = quadraticExtremum;
	exports.quadraticSubdivide = quadraticSubdivide;
	exports.quadraticProjectPoint = quadraticProjectPoint;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(222);
	
	var curve = __webpack_require__(272);
	
	/**
	 * @author Yi Shen(https://github.com/pissang)
	 */
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI2 = Math.PI * 2;
	var start = vec2.create();
	var end = vec2.create();
	var extremity = vec2.create();
	/**
	 * 从顶点数组中计算出最小包围盒，写入`min`和`max`中
	 * @module zrender/core/bbox
	 * @param {Array<Object>} points 顶点数组
	 * @param {number} min
	 * @param {number} max
	 */
	
	function fromPoints(points, min, max) {
	  if (points.length === 0) {
	    return;
	  }
	
	  var p = points[0];
	  var left = p[0];
	  var right = p[0];
	  var top = p[1];
	  var bottom = p[1];
	  var i;
	
	  for (i = 1; i < points.length; i++) {
	    p = points[i];
	    left = mathMin(left, p[0]);
	    right = mathMax(right, p[0]);
	    top = mathMin(top, p[1]);
	    bottom = mathMax(bottom, p[1]);
	  }
	
	  min[0] = left;
	  min[1] = top;
	  max[0] = right;
	  max[1] = bottom;
	}
	/**
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromLine(x0, y0, x1, y1, min, max) {
	  min[0] = mathMin(x0, x1);
	  min[1] = mathMin(y0, y1);
	  max[0] = mathMax(x0, x1);
	  max[1] = mathMax(y0, y1);
	}
	
	var xDim = [];
	var yDim = [];
	/**
	 * 从三阶贝塞尔曲线(p0, p1, p2, p3)中计算出最小包围盒，写入`min`和`max`中
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x3
	 * @param {number} y3
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
	  var cubicExtrema = curve.cubicExtrema;
	  var cubicAt = curve.cubicAt;
	  var i;
	  var n = cubicExtrema(x0, x1, x2, x3, xDim);
	  min[0] = Infinity;
	  min[1] = Infinity;
	  max[0] = -Infinity;
	  max[1] = -Infinity;
	
	  for (i = 0; i < n; i++) {
	    var x = cubicAt(x0, x1, x2, x3, xDim[i]);
	    min[0] = mathMin(x, min[0]);
	    max[0] = mathMax(x, max[0]);
	  }
	
	  n = cubicExtrema(y0, y1, y2, y3, yDim);
	
	  for (i = 0; i < n; i++) {
	    var y = cubicAt(y0, y1, y2, y3, yDim[i]);
	    min[1] = mathMin(y, min[1]);
	    max[1] = mathMax(y, max[1]);
	  }
	
	  min[0] = mathMin(x0, min[0]);
	  max[0] = mathMax(x0, max[0]);
	  min[0] = mathMin(x3, min[0]);
	  max[0] = mathMax(x3, max[0]);
	  min[1] = mathMin(y0, min[1]);
	  max[1] = mathMax(y0, max[1]);
	  min[1] = mathMin(y3, min[1]);
	  max[1] = mathMax(y3, max[1]);
	}
	/**
	 * 从二阶贝塞尔曲线(p0, p1, p2)中计算出最小包围盒，写入`min`和`max`中
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
	  var quadraticExtremum = curve.quadraticExtremum;
	  var quadraticAt = curve.quadraticAt; // Find extremities, where derivative in x dim or y dim is zero
	
	  var tx = mathMax(mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
	  var ty = mathMax(mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
	  var x = quadraticAt(x0, x1, x2, tx);
	  var y = quadraticAt(y0, y1, y2, ty);
	  min[0] = mathMin(x0, x2, x);
	  min[1] = mathMin(y0, y2, y);
	  max[0] = mathMax(x0, x2, x);
	  max[1] = mathMax(y0, y2, y);
	}
	/**
	 * 从圆弧中计算出最小包围盒，写入`min`和`max`中
	 * @method
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x
	 * @param {number} y
	 * @param {number} rx
	 * @param {number} ry
	 * @param {number} startAngle
	 * @param {number} endAngle
	 * @param {number} anticlockwise
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
	  var vec2Min = vec2.min;
	  var vec2Max = vec2.max;
	  var diff = Math.abs(startAngle - endAngle);
	
	  if (diff % PI2 < 1e-4 && diff > 1e-4) {
	    // Is a circle
	    min[0] = x - rx;
	    min[1] = y - ry;
	    max[0] = x + rx;
	    max[1] = y + ry;
	    return;
	  }
	
	  start[0] = mathCos(startAngle) * rx + x;
	  start[1] = mathSin(startAngle) * ry + y;
	  end[0] = mathCos(endAngle) * rx + x;
	  end[1] = mathSin(endAngle) * ry + y;
	  vec2Min(min, start, end);
	  vec2Max(max, start, end); // Thresh to [0, Math.PI * 2]
	
	  startAngle = startAngle % PI2;
	
	  if (startAngle < 0) {
	    startAngle = startAngle + PI2;
	  }
	
	  endAngle = endAngle % PI2;
	
	  if (endAngle < 0) {
	    endAngle = endAngle + PI2;
	  }
	
	  if (startAngle > endAngle && !anticlockwise) {
	    endAngle += PI2;
	  } else if (startAngle < endAngle && anticlockwise) {
	    startAngle += PI2;
	  }
	
	  if (anticlockwise) {
	    var tmp = endAngle;
	    endAngle = startAngle;
	    startAngle = tmp;
	  } // var number = 0;
	  // var step = (anticlockwise ? -Math.PI : Math.PI) / 2;
	
	
	  for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
	    if (angle > startAngle) {
	      extremity[0] = mathCos(angle) * rx + x;
	      extremity[1] = mathSin(angle) * ry + y;
	      vec2Min(min, extremity, min);
	      vec2Max(max, extremity, max);
	    }
	  }
	}
	
	exports.fromPoints = fromPoints;
	exports.fromLine = fromLine;
	exports.fromCubic = fromCubic;
	exports.fromQuadratic = fromQuadratic;
	exports.fromArc = fromArc;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var PathProxy = __webpack_require__(271);
	
	var line = __webpack_require__(275);
	
	var cubic = __webpack_require__(276);
	
	var quadratic = __webpack_require__(277);
	
	var arc = __webpack_require__(278);
	
	var _util = __webpack_require__(279);
	
	var normalizeRadian = _util.normalizeRadian;
	
	var curve = __webpack_require__(272);
	
	var windingLine = __webpack_require__(280);
	
	var CMD = PathProxy.CMD;
	var PI2 = Math.PI * 2;
	var EPSILON = 1e-4;
	
	function isAroundEqual(a, b) {
	  return Math.abs(a - b) < EPSILON;
	} // 临时数组
	
	
	var roots = [-1, -1, -1];
	var extrema = [-1, -1];
	
	function swapExtrema() {
	  var tmp = extrema[0];
	  extrema[0] = extrema[1];
	  extrema[1] = tmp;
	}
	
	function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
	  // Quick reject
	  if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) {
	    return 0;
	  }
	
	  var nRoots = curve.cubicRootAt(y0, y1, y2, y3, y, roots);
	
	  if (nRoots === 0) {
	    return 0;
	  } else {
	    var w = 0;
	    var nExtrema = -1;
	    var y0_;
	    var y1_;
	
	    for (var i = 0; i < nRoots; i++) {
	      var t = roots[i]; // Avoid winding error when intersection point is the connect point of two line of polygon
	
	      var unit = t === 0 || t === 1 ? 0.5 : 1;
	      var x_ = curve.cubicAt(x0, x1, x2, x3, t);
	
	      if (x_ < x) {
	        // Quick reject
	        continue;
	      }
	
	      if (nExtrema < 0) {
	        nExtrema = curve.cubicExtrema(y0, y1, y2, y3, extrema);
	
	        if (extrema[1] < extrema[0] && nExtrema > 1) {
	          swapExtrema();
	        }
	
	        y0_ = curve.cubicAt(y0, y1, y2, y3, extrema[0]);
	
	        if (nExtrema > 1) {
	          y1_ = curve.cubicAt(y0, y1, y2, y3, extrema[1]);
	        }
	      }
	
	      if (nExtrema === 2) {
	        // 分成三段单调函数
	        if (t < extrema[0]) {
	          w += y0_ < y0 ? unit : -unit;
	        } else if (t < extrema[1]) {
	          w += y1_ < y0_ ? unit : -unit;
	        } else {
	          w += y3 < y1_ ? unit : -unit;
	        }
	      } else {
	        // 分成两段单调函数
	        if (t < extrema[0]) {
	          w += y0_ < y0 ? unit : -unit;
	        } else {
	          w += y3 < y0_ ? unit : -unit;
	        }
	      }
	    }
	
	    return w;
	  }
	}
	
	function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
	  // Quick reject
	  if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) {
	    return 0;
	  }
	
	  var nRoots = curve.quadraticRootAt(y0, y1, y2, y, roots);
	
	  if (nRoots === 0) {
	    return 0;
	  } else {
	    var t = curve.quadraticExtremum(y0, y1, y2);
	
	    if (t >= 0 && t <= 1) {
	      var w = 0;
	      var y_ = curve.quadraticAt(y0, y1, y2, t);
	
	      for (var i = 0; i < nRoots; i++) {
	        // Remove one endpoint.
	        var unit = roots[i] === 0 || roots[i] === 1 ? 0.5 : 1;
	        var x_ = curve.quadraticAt(x0, x1, x2, roots[i]);
	
	        if (x_ < x) {
	          // Quick reject
	          continue;
	        }
	
	        if (roots[i] < t) {
	          w += y_ < y0 ? unit : -unit;
	        } else {
	          w += y2 < y_ ? unit : -unit;
	        }
	      }
	
	      return w;
	    } else {
	      // Remove one endpoint.
	      var unit = roots[0] === 0 || roots[0] === 1 ? 0.5 : 1;
	      var x_ = curve.quadraticAt(x0, x1, x2, roots[0]);
	
	      if (x_ < x) {
	        // Quick reject
	        return 0;
	      }
	
	      return y2 < y0 ? unit : -unit;
	    }
	  }
	} // TODO
	// Arc 旋转
	
	
	function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
	  y -= cy;
	
	  if (y > r || y < -r) {
	    return 0;
	  }
	
	  var tmp = Math.sqrt(r * r - y * y);
	  roots[0] = -tmp;
	  roots[1] = tmp;
	  var diff = Math.abs(startAngle - endAngle);
	
	  if (diff < 1e-4) {
	    return 0;
	  }
	
	  if (diff % PI2 < 1e-4) {
	    // Is a circle
	    startAngle = 0;
	    endAngle = PI2;
	    var dir = anticlockwise ? 1 : -1;
	
	    if (x >= roots[0] + cx && x <= roots[1] + cx) {
	      return dir;
	    } else {
	      return 0;
	    }
	  }
	
	  if (anticlockwise) {
	    var tmp = startAngle;
	    startAngle = normalizeRadian(endAngle);
	    endAngle = normalizeRadian(tmp);
	  } else {
	    startAngle = normalizeRadian(startAngle);
	    endAngle = normalizeRadian(endAngle);
	  }
	
	  if (startAngle > endAngle) {
	    endAngle += PI2;
	  }
	
	  var w = 0;
	
	  for (var i = 0; i < 2; i++) {
	    var x_ = roots[i];
	
	    if (x_ + cx > x) {
	      var angle = Math.atan2(y, x_);
	      var dir = anticlockwise ? 1 : -1;
	
	      if (angle < 0) {
	        angle = PI2 + angle;
	      }
	
	      if (angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle) {
	        if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
	          dir = -dir;
	        }
	
	        w += dir;
	      }
	    }
	  }
	
	  return w;
	}
	
	function containPath(data, lineWidth, isStroke, x, y) {
	  var w = 0;
	  var xi = 0;
	  var yi = 0;
	  var x0 = 0;
	  var y0 = 0;
	
	  for (var i = 0; i < data.length;) {
	    var cmd = data[i++]; // Begin a new subpath
	
	    if (cmd === CMD.M && i > 1) {
	      // Close previous subpath
	      if (!isStroke) {
	        w += windingLine(xi, yi, x0, y0, x, y);
	      } // 如果被任何一个 subpath 包含
	      // if (w !== 0) {
	      //     return true;
	      // }
	
	    }
	
	    if (i === 1) {
	      // 如果第一个命令是 L, C, Q
	      // 则 previous point 同绘制命令的第一个 point
	      //
	      // 第一个命令为 Arc 的情况下会在后面特殊处理
	      xi = data[i];
	      yi = data[i + 1];
	      x0 = xi;
	      y0 = yi;
	    }
	
	    switch (cmd) {
	      case CMD.M:
	        // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	        // 在 closePath 的时候使用
	        x0 = data[i++];
	        y0 = data[i++];
	        xi = x0;
	        yi = y0;
	        break;
	
	      case CMD.L:
	        if (isStroke) {
	          if (line.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // NOTE 在第一个命令为 L, C, Q 的时候会计算出 NaN
	          w += windingLine(xi, yi, data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.C:
	        if (isStroke) {
	          if (cubic.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.Q:
	        if (isStroke) {
	          if (quadratic.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.A:
	        // TODO Arc 判断的开销比较大
	        var cx = data[i++];
	        var cy = data[i++];
	        var rx = data[i++];
	        var ry = data[i++];
	        var theta = data[i++];
	        var dTheta = data[i++]; // TODO Arc 旋转
	
	        i += 1;
	        var anticlockwise = 1 - data[i++];
	        var x1 = Math.cos(theta) * rx + cx;
	        var y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令
	
	        if (i > 1) {
	          w += windingLine(xi, yi, x1, y1, x, y);
	        } else {
	          // 第一个命令起点还未定义
	          x0 = x1;
	          y0 = y1;
	        } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
	
	
	        var _x = (x - cx) * ry / rx + cx;
	
	        if (isStroke) {
	          if (arc.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
	            return true;
	          }
	        } else {
	          w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
	        }
	
	        xi = Math.cos(theta + dTheta) * rx + cx;
	        yi = Math.sin(theta + dTheta) * ry + cy;
	        break;
	
	      case CMD.R:
	        x0 = xi = data[i++];
	        y0 = yi = data[i++];
	        var width = data[i++];
	        var height = data[i++];
	        var x1 = x0 + width;
	        var y1 = y0 + height;
	
	        if (isStroke) {
	          if (line.containStroke(x0, y0, x1, y0, lineWidth, x, y) || line.containStroke(x1, y0, x1, y1, lineWidth, x, y) || line.containStroke(x1, y1, x0, y1, lineWidth, x, y) || line.containStroke(x0, y1, x0, y0, lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // FIXME Clockwise ?
	          w += windingLine(x1, y0, x1, y1, x, y);
	          w += windingLine(x0, y1, x0, y0, x, y);
	        }
	
	        break;
	
	      case CMD.Z:
	        if (isStroke) {
	          if (line.containStroke(xi, yi, x0, y0, lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // Close a subpath
	          w += windingLine(xi, yi, x0, y0, x, y); // 如果被任何一个 subpath 包含
	          // FIXME subpaths may overlap
	          // if (w !== 0) {
	          //     return true;
	          // }
	        }
	
	        xi = x0;
	        yi = y0;
	        break;
	    }
	  }
	
	  if (!isStroke && !isAroundEqual(yi, y0)) {
	    w += windingLine(xi, yi, x0, y0, x, y) || 0;
	  }
	
	  return w !== 0;
	}
	
	function contain(pathData, x, y) {
	  return containPath(pathData, 0, false, x, y);
	}
	
	function containStroke(pathData, lineWidth, x, y) {
	  return containPath(pathData, lineWidth, true, x, y);
	}
	
	exports.contain = contain;
	exports.containStroke = containStroke;

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	/**
	 * 线段包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth;
	  var _a = 0;
	  var _b = x0; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) {
	    return false;
	  }
	
	  if (x0 !== x1) {
	    _a = (y0 - y1) / (x0 - x1);
	    _b = (x0 * y1 - x1 * y0) / (x0 - x1);
	  } else {
	    return Math.abs(x - x0) <= _l / 2;
	  }
	
	  var tmp = _a * x - y + _b;
	
	  var _s = tmp * tmp / (_a * _a + 1);
	
	  return _s <= _l / 2 * _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var curve = __webpack_require__(272);
	
	/**
	 * 三次贝塞尔曲线描边包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  x2
	 * @param  {number}  y2
	 * @param  {number}  x3
	 * @param  {number}  y3
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) {
	    return false;
	  }
	
	  var d = curve.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
	  return d <= _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var _curve = __webpack_require__(272);
	
	var quadraticProjectPoint = _curve.quadraticProjectPoint;
	
	/**
	 * 二次贝塞尔曲线描边包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  x2
	 * @param  {number}  y2
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) {
	    return false;
	  }
	
	  var d = quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
	  return d <= _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(279);
	
	var normalizeRadian = _util.normalizeRadian;
	var PI2 = Math.PI * 2;
	/**
	 * 圆弧描边包含判断
	 * @param  {number}  cx
	 * @param  {number}  cy
	 * @param  {number}  r
	 * @param  {number}  startAngle
	 * @param  {number}  endAngle
	 * @param  {boolean}  anticlockwise
	 * @param  {number} lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {Boolean}
	 */
	
	function containStroke(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth;
	  x -= cx;
	  y -= cy;
	  var d = Math.sqrt(x * x + y * y);
	
	  if (d - _l > r || d + _l < r) {
	    return false;
	  }
	
	  if (Math.abs(startAngle - endAngle) % PI2 < 1e-4) {
	    // Is a circle
	    return true;
	  }
	
	  if (anticlockwise) {
	    var tmp = startAngle;
	    startAngle = normalizeRadian(endAngle);
	    endAngle = normalizeRadian(tmp);
	  } else {
	    startAngle = normalizeRadian(startAngle);
	    endAngle = normalizeRadian(endAngle);
	  }
	
	  if (startAngle > endAngle) {
	    endAngle += PI2;
	  }
	
	  var angle = Math.atan2(y, x);
	
	  if (angle < 0) {
	    angle += PI2;
	  }
	
	  return angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle;
	}
	
	exports.containStroke = containStroke;

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	var PI2 = Math.PI * 2;
	
	function normalizeRadian(angle) {
	  angle %= PI2;
	
	  if (angle < 0) {
	    angle += PI2;
	  }
	
	  return angle;
	}
	
	exports.normalizeRadian = normalizeRadian;

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	function windingLine(x0, y0, x1, y1, x, y) {
	  if (y > y0 && y > y1 || y < y0 && y < y1) {
	    return 0;
	  } // Ignore horizontal line
	
	
	  if (y1 === y0) {
	    return 0;
	  }
	
	  var dir = y1 < y0 ? 1 : -1;
	  var t = (y - y0) / (y1 - y0); // Avoid winding error when intersection point is the connect point of two line of polygon
	
	  if (t === 1 || t === 0) {
	    dir = y1 < y0 ? 0.5 : -0.5;
	  }
	
	  var x_ = t * (x1 - x0) + x0; // If (x, y) on the line, considered as "contain".
	
	  return x_ === x ? Infinity : x_ > x ? dir : 0;
	}
	
	module.exports = windingLine;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var PathProxy = __webpack_require__(271);
	
	var _vector = __webpack_require__(222);
	
	var v2ApplyTransform = _vector.applyTransform;
	var CMD = PathProxy.CMD;
	var points = [[], [], []];
	var mathSqrt = Math.sqrt;
	var mathAtan2 = Math.atan2;
	
	function _default(path, m) {
	  var data = path.data;
	  var cmd;
	  var nPoint;
	  var i;
	  var j;
	  var k;
	  var p;
	  var M = CMD.M;
	  var C = CMD.C;
	  var L = CMD.L;
	  var R = CMD.R;
	  var A = CMD.A;
	  var Q = CMD.Q;
	
	  for (i = 0, j = 0; i < data.length;) {
	    cmd = data[i++];
	    j = i;
	    nPoint = 0;
	
	    switch (cmd) {
	      case M:
	        nPoint = 1;
	        break;
	
	      case L:
	        nPoint = 1;
	        break;
	
	      case C:
	        nPoint = 3;
	        break;
	
	      case Q:
	        nPoint = 2;
	        break;
	
	      case A:
	        var x = m[4];
	        var y = m[5];
	        var sx = mathSqrt(m[0] * m[0] + m[1] * m[1]);
	        var sy = mathSqrt(m[2] * m[2] + m[3] * m[3]);
	        var angle = mathAtan2(-m[1] / sy, m[0] / sx); // cx
	
	        data[i] *= sx;
	        data[i++] += x; // cy
	
	        data[i] *= sy;
	        data[i++] += y; // Scale rx and ry
	        // FIXME Assume psi is 0 here
	
	        data[i++] *= sx;
	        data[i++] *= sy; // Start angle
	
	        data[i++] += angle; // end angle
	
	        data[i++] += angle; // FIXME psi
	
	        i += 2;
	        j = i;
	        break;
	
	      case R:
	        // x0, y0
	        p[0] = data[i++];
	        p[1] = data[i++];
	        v2ApplyTransform(p, p, m);
	        data[j++] = p[0];
	        data[j++] = p[1]; // x1, y1
	
	        p[0] += data[i++];
	        p[1] += data[i++];
	        v2ApplyTransform(p, p, m);
	        data[j++] = p[0];
	        data[j++] = p[1];
	    }
	
	    for (k = 0; k < nPoint; k++) {
	      var p = points[k];
	      p[0] = data[i++];
	      p[1] = data[i++];
	      v2ApplyTransform(p, p, m); // Write back
	
	      data[j++] = p[0];
	      data[j++] = p[1];
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(252);
	
	var zrUtil = __webpack_require__(220);
	
	var textContain = __webpack_require__(255);
	
	var textHelper = __webpack_require__(254);
	
	var _constant = __webpack_require__(248);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	
	/**
	 * @alias zrender/graphic/Text
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	var Text = function (opts) {
	  // jshint ignore:line
	  Displayable.call(this, opts);
	};
	
	Text.prototype = {
	  constructor: Text,
	  type: 'text',
	  brush: function (ctx, prevEl) {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true); // Use props with prefix 'text'.
	
	    style.fill = style.stroke = style.shadowBlur = style.shadowColor = style.shadowOffsetX = style.shadowOffsetY = null;
	    var text = style.text; // Convert to string
	
	    text != null && (text += ''); // Do not apply style.bind in Text node. Because the real bind job
	    // is in textHelper.renderText, and performance of text render should
	    // be considered.
	    // style.bind(ctx, this, prevEl);
	
	    if (!textHelper.needDrawText(text, style)) {
	      // The current el.style is not applied
	      // and should not be used as cache.
	      ctx.__attrCachedBy = ContextCachedBy.NONE;
	      return;
	    }
	
	    this.setTransform(ctx);
	    textHelper.renderText(this, ctx, text, style, null, prevEl);
	    this.restoreTransform(ctx);
	  },
	  getBoundingRect: function () {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	
	    if (!this._rect) {
	      var text = style.text;
	      text != null ? text += '' : text = '';
	      var rect = textContain.getBoundingRect(style.text + '', style.font, style.textAlign, style.textVerticalAlign, style.textPadding, style.textLineHeight, style.rich);
	      rect.x += style.x || 0;
	      rect.y += style.y || 0;
	
	      if (textHelper.getStroke(style.textStroke, style.textStrokeWidth)) {
	        var w = style.textStrokeWidth;
	        rect.x -= w / 2;
	        rect.y -= w / 2;
	        rect.width += w;
	        rect.height += w;
	      }
	
	      this._rect = rect;
	    }
	
	    return this._rect;
	  }
	};
	zrUtil.inherits(Text, Displayable);
	var _default = Text;
	module.exports = _default;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(270);
	
	/**
	 * 圆形
	 * @module zrender/shape/Circle
	 */
	var _default = Path.extend({
	  type: 'circle',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0
	  },
	  buildPath: function (ctx, shape, inBundle) {
	    // Better stroking in ShapeBundle
	    // Always do it may have performence issue ( fill may be 2x more cost)
	    if (inBundle) {
	      ctx.moveTo(shape.cx + shape.r, shape.cy);
	    } // else {
	    //     if (ctx.allocate && !ctx.data.length) {
	    //         ctx.allocate(ctx.CMD_MEM_SIZE.A);
	    //     }
	    // }
	    // Better stroking in ShapeBundle
	    // ctx.moveTo(shape.cx + shape.r, shape.cy);
	
	
	    ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2, true);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(270);
	
	var fixClipWithShadow = __webpack_require__(285);
	
	/**
	 * 扇形
	 * @module zrender/graphic/shape/Sector
	 */
	var _default = Path.extend({
	  type: 'sector',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r0: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r0 = Math.max(shape.r0 || 0, 0);
	    var r = Math.max(shape.r, 0);
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitX = Math.cos(startAngle);
	    var unitY = Math.sin(startAngle);
	    ctx.moveTo(unitX * r0 + x, unitY * r0 + y);
	    ctx.lineTo(unitX * r + x, unitY * r + y);
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	    ctx.lineTo(Math.cos(endAngle) * r0 + x, Math.sin(endAngle) * r0 + y);
	
	    if (r0 !== 0) {
	      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
	    }
	
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(219);
	
	// Fix weird bug in some version of IE11 (like 11.0.9600.178**),
	// where exception "unexpected call to method or property access"
	// might be thrown when calling ctx.fill or ctx.stroke after a path
	// whose area size is zero is drawn and ctx.clip() is called and
	// shadowBlur is set. See #4572, #3112, #5777.
	// (e.g.,
	//  ctx.moveTo(10, 10);
	//  ctx.lineTo(20, 10);
	//  ctx.closePath();
	//  ctx.clip();
	//  ctx.shadowBlur = 10;
	//  ...
	//  ctx.fill();
	// )
	var shadowTemp = [['shadowBlur', 0], ['shadowColor', '#000'], ['shadowOffsetX', 0], ['shadowOffsetY', 0]];
	
	function _default(orignalBrush) {
	  // version string can be: '11.0'
	  return env.browser.ie && env.browser.version >= 11 ? function () {
	    var clipPaths = this.__clipPaths;
	    var style = this.style;
	    var modified;
	
	    if (clipPaths) {
	      for (var i = 0; i < clipPaths.length; i++) {
	        var clipPath = clipPaths[i];
	        var shape = clipPath && clipPath.shape;
	        var type = clipPath && clipPath.type;
	
	        if (shape && (type === 'sector' && shape.startAngle === shape.endAngle || type === 'rect' && (!shape.width || !shape.height))) {
	          for (var j = 0; j < shadowTemp.length; j++) {
	            // It is save to put shadowTemp static, because shadowTemp
	            // will be all modified each item brush called.
	            shadowTemp[j][2] = style[shadowTemp[j][0]];
	            style[shadowTemp[j][0]] = shadowTemp[j][1];
	          }
	
	          modified = true;
	          break;
	        }
	      }
	    }
	
	    orignalBrush.apply(this, arguments);
	
	    if (modified) {
	      for (var j = 0; j < shadowTemp.length; j++) {
	        style[shadowTemp[j][0]] = shadowTemp[j][2];
	      }
	    }
	  } : orignalBrush;
	}
	
	module.exports = _default;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(270);
	
	/**
	 * 圆环
	 * @module zrender/graphic/shape/Ring
	 */
	var _default = Path.extend({
	  type: 'ring',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0,
	    r0: 0
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var PI2 = Math.PI * 2;
	    ctx.moveTo(x + shape.r, y);
	    ctx.arc(x, y, shape.r, 0, PI2, false);
	    ctx.moveTo(x + shape.r0, y);
	    ctx.arc(x, y, shape.r0, 0, PI2, true);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(270);
	
	var polyHelper = __webpack_require__(288);
	
	/**
	 * 多边形
	 * @module zrender/shape/Polygon
	 */
	var _default = Path.extend({
	  type: 'polygon',
	  shape: {
	    points: null,
	    smooth: false,
	    smoothConstraint: null
	  },
	  buildPath: function (ctx, shape) {
	    polyHelper.buildPath(ctx, shape, true);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var smoothSpline = __webpack_require__(289);
	
	var smoothBezier = __webpack_require__(290);
	
	function buildPath(ctx, shape, closePath) {
	  var points = shape.points;
	  var smooth = shape.smooth;
	
	  if (points && points.length >= 2) {
	    if (smooth && smooth !== 'spline') {
	      var controlPoints = smoothBezier(points, smooth, closePath, shape.smoothConstraint);
	      ctx.moveTo(points[0][0], points[0][1]);
	      var len = points.length;
	
	      for (var i = 0; i < (closePath ? len : len - 1); i++) {
	        var cp1 = controlPoints[i * 2];
	        var cp2 = controlPoints[i * 2 + 1];
	        var p = points[(i + 1) % len];
	        ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
	      }
	    } else {
	      if (smooth === 'spline') {
	        points = smoothSpline(points, closePath);
	      }
	
	      ctx.moveTo(points[0][0], points[0][1]);
	
	      for (var i = 1, l = points.length; i < l; i++) {
	        ctx.lineTo(points[i][0], points[i][1]);
	      }
	    }
	
	    closePath && ctx.closePath();
	  }
	}
	
	exports.buildPath = buildPath;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(222);
	
	var v2Distance = _vector.distance;
	
	/**
	 * Catmull-Rom spline 插值折线
	 * @module zrender/shape/util/smoothSpline
	 * @author pissang (https://www.github.com/pissang)
	 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 */
	
	/**
	 * @inner
	 */
	function interpolate(p0, p1, p2, p3, t, t2, t3) {
	  var v0 = (p2 - p0) * 0.5;
	  var v1 = (p3 - p1) * 0.5;
	  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
	}
	/**
	 * @alias module:zrender/shape/util/smoothSpline
	 * @param {Array} points 线段顶点数组
	 * @param {boolean} isLoop
	 * @return {Array}
	 */
	
	
	function _default(points, isLoop) {
	  var len = points.length;
	  var ret = [];
	  var distance = 0;
	
	  for (var i = 1; i < len; i++) {
	    distance += v2Distance(points[i - 1], points[i]);
	  }
	
	  var segs = distance / 2;
	  segs = segs < len ? len : segs;
	
	  for (var i = 0; i < segs; i++) {
	    var pos = i / (segs - 1) * (isLoop ? len : len - 1);
	    var idx = Math.floor(pos);
	    var w = pos - idx;
	    var p0;
	    var p1 = points[idx % len];
	    var p2;
	    var p3;
	
	    if (!isLoop) {
	      p0 = points[idx === 0 ? idx : idx - 1];
	      p2 = points[idx > len - 2 ? len - 1 : idx + 1];
	      p3 = points[idx > len - 3 ? len - 1 : idx + 2];
	    } else {
	      p0 = points[(idx - 1 + len) % len];
	      p2 = points[(idx + 1) % len];
	      p3 = points[(idx + 2) % len];
	    }
	
	    var w2 = w * w;
	    var w3 = w * w2;
	    ret.push([interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3), interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)]);
	  }
	
	  return ret;
	}
	
	module.exports = _default;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(222);
	
	var v2Min = _vector.min;
	var v2Max = _vector.max;
	var v2Scale = _vector.scale;
	var v2Distance = _vector.distance;
	var v2Add = _vector.add;
	var v2Clone = _vector.clone;
	var v2Sub = _vector.sub;
	
	/**
	 * 贝塞尔平滑曲线
	 * @module zrender/shape/util/smoothBezier
	 * @author pissang (https://www.github.com/pissang)
	 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 */
	
	/**
	 * 贝塞尔平滑曲线
	 * @alias module:zrender/shape/util/smoothBezier
	 * @param {Array} points 线段顶点数组
	 * @param {number} smooth 平滑等级, 0-1
	 * @param {boolean} isLoop
	 * @param {Array} constraint 将计算出来的控制点约束在一个包围盒内
	 *                           比如 [[0, 0], [100, 100]], 这个包围盒会与
	 *                           整个折线的包围盒做一个并集用来约束控制点。
	 * @param {Array} 计算出来的控制点数组
	 */
	function _default(points, smooth, isLoop, constraint) {
	  var cps = [];
	  var v = [];
	  var v1 = [];
	  var v2 = [];
	  var prevPoint;
	  var nextPoint;
	  var min;
	  var max;
	
	  if (constraint) {
	    min = [Infinity, Infinity];
	    max = [-Infinity, -Infinity];
	
	    for (var i = 0, len = points.length; i < len; i++) {
	      v2Min(min, min, points[i]);
	      v2Max(max, max, points[i]);
	    } // 与指定的包围盒做并集
	
	
	    v2Min(min, min, constraint[0]);
	    v2Max(max, max, constraint[1]);
	  }
	
	  for (var i = 0, len = points.length; i < len; i++) {
	    var point = points[i];
	
	    if (isLoop) {
	      prevPoint = points[i ? i - 1 : len - 1];
	      nextPoint = points[(i + 1) % len];
	    } else {
	      if (i === 0 || i === len - 1) {
	        cps.push(v2Clone(points[i]));
	        continue;
	      } else {
	        prevPoint = points[i - 1];
	        nextPoint = points[i + 1];
	      }
	    }
	
	    v2Sub(v, nextPoint, prevPoint); // use degree to scale the handle length
	
	    v2Scale(v, v, smooth);
	    var d0 = v2Distance(point, prevPoint);
	    var d1 = v2Distance(point, nextPoint);
	    var sum = d0 + d1;
	
	    if (sum !== 0) {
	      d0 /= sum;
	      d1 /= sum;
	    }
	
	    v2Scale(v1, v, -d0);
	    v2Scale(v2, v, d1);
	    var cp0 = v2Add([], point, v1);
	    var cp1 = v2Add([], point, v2);
	
	    if (constraint) {
	      v2Max(cp0, cp0, min);
	      v2Min(cp0, cp0, max);
	      v2Max(cp1, cp1, min);
	      v2Min(cp1, cp1, max);
	    }
	
	    cps.push(cp0);
	    cps.push(cp1);
	  }
	
	  if (isLoop) {
	    cps.push(cps.shift());
	  }
	
	  return cps;
	}
	
	module.exports = _default;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(270);
	
	var polyHelper = __webpack_require__(288);
	
	/**
	 * @module zrender/graphic/shape/Polyline
	 */
	var _default = Path.extend({
	  type: 'polyline',
	  shape: {
	    points: null,
	    smooth: false,
	    smoothConstraint: null
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    polyHelper.buildPath(ctx, shape, false);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(270);
	
	var roundRectHelper = __webpack_require__(257);
	
	var _subPixelOptimize = __webpack_require__(293);
	
	var subPixelOptimizeRect = _subPixelOptimize.subPixelOptimizeRect;
	
	/**
	 * 矩形
	 * @module zrender/graphic/shape/Rect
	 */
	// Avoid create repeatly.
	var subPixelOptimizeOutputShape = {};
	
	var _default = Path.extend({
	  type: 'rect',
	  shape: {
	    // 左上、右上、右下、左下角的半径依次为r1、r2、r3、r4
	    // r缩写为1         相当于 [1, 1, 1, 1]
	    // r缩写为[1]       相当于 [1, 1, 1, 1]
	    // r缩写为[1, 2]    相当于 [1, 2, 1, 2]
	    // r缩写为[1, 2, 3] 相当于 [1, 2, 3, 2]
	    r: 0,
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (ctx, shape) {
	    var x;
	    var y;
	    var width;
	    var height;
	
	    if (this.subPixelOptimize) {
	      subPixelOptimizeRect(subPixelOptimizeOutputShape, shape, this.style);
	      x = subPixelOptimizeOutputShape.x;
	      y = subPixelOptimizeOutputShape.y;
	      width = subPixelOptimizeOutputShape.width;
	      height = subPixelOptimizeOutputShape.height;
	      subPixelOptimizeOutputShape.r = shape.r;
	      shape = subPixelOptimizeOutputShape;
	    } else {
	      x = shape.x;
	      y = shape.y;
	      width = shape.width;
	      height = shape.height;
	    }
	
	    if (!shape.r) {
	      ctx.rect(x, y, width, height);
	    } else {
	      roundRectHelper.buildPath(ctx, shape);
	    }
	
	    ctx.closePath();
	    return;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	/**
	 * Sub-pixel optimize for canvas rendering, prevent from blur
	 * when rendering a thin vertical/horizontal line.
	 */
	var round = Math.round;
	/**
	 * Sub pixel optimize line for canvas
	 *
	 * @param {Object} outputShape The modification will be performed on `outputShape`.
	 *                 `outputShape` and `inputShape` can be the same object.
	 *                 `outputShape` object can be used repeatly, because all of
	 *                 the `x1`, `x2`, `y1`, `y2` will be assigned in this method.
	 * @param {Object} [inputShape]
	 * @param {number} [inputShape.x1]
	 * @param {number} [inputShape.y1]
	 * @param {number} [inputShape.x2]
	 * @param {number} [inputShape.y2]
	 * @param {Object} [style]
	 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
	 */
	
	function subPixelOptimizeLine(outputShape, inputShape, style) {
	  if (!inputShape) {
	    return;
	  }
	
	  var x1 = inputShape.x1;
	  var x2 = inputShape.x2;
	  var y1 = inputShape.y1;
	  var y2 = inputShape.y2;
	  outputShape.x1 = x1;
	  outputShape.x2 = x2;
	  outputShape.y1 = y1;
	  outputShape.y2 = y2;
	  var lineWidth = style && style.lineWidth;
	
	  if (!lineWidth) {
	    return;
	  }
	
	  if (round(x1 * 2) === round(x2 * 2)) {
	    outputShape.x1 = outputShape.x2 = subPixelOptimize(x1, lineWidth, true);
	  }
	
	  if (round(y1 * 2) === round(y2 * 2)) {
	    outputShape.y1 = outputShape.y2 = subPixelOptimize(y1, lineWidth, true);
	  }
	}
	/**
	 * Sub pixel optimize rect for canvas
	 *
	 * @param {Object} outputShape The modification will be performed on `outputShape`.
	 *                 `outputShape` and `inputShape` can be the same object.
	 *                 `outputShape` object can be used repeatly, because all of
	 *                 the `x`, `y`, `width`, `height` will be assigned in this method.
	 * @param {Object} [inputShape]
	 * @param {number} [inputShape.x]
	 * @param {number} [inputShape.y]
	 * @param {number} [inputShape.width]
	 * @param {number} [inputShape.height]
	 * @param {Object} [style]
	 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
	 */
	
	
	function subPixelOptimizeRect(outputShape, inputShape, style) {
	  if (!inputShape) {
	    return;
	  }
	
	  var originX = inputShape.x;
	  var originY = inputShape.y;
	  var originWidth = inputShape.width;
	  var originHeight = inputShape.height;
	  outputShape.x = originX;
	  outputShape.y = originY;
	  outputShape.width = originWidth;
	  outputShape.height = originHeight;
	  var lineWidth = style && style.lineWidth;
	
	  if (!lineWidth) {
	    return;
	  }
	
	  outputShape.x = subPixelOptimize(originX, lineWidth, true);
	  outputShape.y = subPixelOptimize(originY, lineWidth, true);
	  outputShape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
	  outputShape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
	}
	/**
	 * Sub pixel optimize for canvas
	 *
	 * @param {number} position Coordinate, such as x, y
	 * @param {number} lineWidth If `null`/`undefined`/`0`, do not optimize.
	 * @param {boolean=} positiveOrNegative Default false (negative).
	 * @return {number} Optimized position.
	 */
	
	
	function subPixelOptimize(position, lineWidth, positiveOrNegative) {
	  if (!lineWidth) {
	    return position;
	  } // Assure that (position + lineWidth / 2) is near integer edge,
	  // otherwise line will be fuzzy in canvas.
	
	
	  var doubledPosition = round(position * 2);
	  return (doubledPosition + round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
	}
	
	exports.subPixelOptimizeLine = subPixelOptimizeLine;
	exports.subPixelOptimizeRect = subPixelOptimizeRect;
	exports.subPixelOptimize = subPixelOptimize;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(270);
	
	var _subPixelOptimize = __webpack_require__(293);
	
	var subPixelOptimizeLine = _subPixelOptimize.subPixelOptimizeLine;
	
	/**
	 * 直线
	 * @module zrender/graphic/shape/Line
	 */
	// Avoid create repeatly.
	var subPixelOptimizeOutputShape = {};
	
	var _default = Path.extend({
	  type: 'line',
	  shape: {
	    // Start point
	    x1: 0,
	    y1: 0,
	    // End point
	    x2: 0,
	    y2: 0,
	    percent: 1
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x1;
	    var y1;
	    var x2;
	    var y2;
	
	    if (this.subPixelOptimize) {
	      subPixelOptimizeLine(subPixelOptimizeOutputShape, shape, this.style);
	      x1 = subPixelOptimizeOutputShape.x1;
	      y1 = subPixelOptimizeOutputShape.y1;
	      x2 = subPixelOptimizeOutputShape.x2;
	      y2 = subPixelOptimizeOutputShape.y2;
	    } else {
	      x1 = shape.x1;
	      y1 = shape.y1;
	      x2 = shape.x2;
	      y2 = shape.y2;
	    }
	
	    var percent = shape.percent;
	
	    if (percent === 0) {
	      return;
	    }
	
	    ctx.moveTo(x1, y1);
	
	    if (percent < 1) {
	      x2 = x1 * (1 - percent) + x2 * percent;
	      y2 = y1 * (1 - percent) + y2 * percent;
	    }
	
	    ctx.lineTo(x2, y2);
	  },
	
	  /**
	   * Get point at percent
	   * @param  {number} percent
	   * @return {Array.<number>}
	   */
	  pointAt: function (p) {
	    var shape = this.shape;
	    return [shape.x1 * (1 - p) + shape.x2 * p, shape.y1 * (1 - p) + shape.y2 * p];
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(270);
	
	var vec2 = __webpack_require__(222);
	
	var _curve = __webpack_require__(272);
	
	var quadraticSubdivide = _curve.quadraticSubdivide;
	var cubicSubdivide = _curve.cubicSubdivide;
	var quadraticAt = _curve.quadraticAt;
	var cubicAt = _curve.cubicAt;
	var quadraticDerivativeAt = _curve.quadraticDerivativeAt;
	var cubicDerivativeAt = _curve.cubicDerivativeAt;
	
	/**
	 * 贝塞尔曲线
	 * @module zrender/shape/BezierCurve
	 */
	var out = [];
	
	function someVectorAt(shape, t, isTangent) {
	  var cpx2 = shape.cpx2;
	  var cpy2 = shape.cpy2;
	
	  if (cpx2 === null || cpy2 === null) {
	    return [(isTangent ? cubicDerivativeAt : cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t), (isTangent ? cubicDerivativeAt : cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)];
	  } else {
	    return [(isTangent ? quadraticDerivativeAt : quadraticAt)(shape.x1, shape.cpx1, shape.x2, t), (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)];
	  }
	}
	
	var _default = Path.extend({
	  type: 'bezier-curve',
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    cpx1: 0,
	    cpy1: 0,
	    // cpx2: 0,
	    // cpy2: 0
	    // Curve show percent, for animating
	    percent: 1
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x1 = shape.x1;
	    var y1 = shape.y1;
	    var x2 = shape.x2;
	    var y2 = shape.y2;
	    var cpx1 = shape.cpx1;
	    var cpy1 = shape.cpy1;
	    var cpx2 = shape.cpx2;
	    var cpy2 = shape.cpy2;
	    var percent = shape.percent;
	
	    if (percent === 0) {
	      return;
	    }
	
	    ctx.moveTo(x1, y1);
	
	    if (cpx2 == null || cpy2 == null) {
	      if (percent < 1) {
	        quadraticSubdivide(x1, cpx1, x2, percent, out);
	        cpx1 = out[1];
	        x2 = out[2];
	        quadraticSubdivide(y1, cpy1, y2, percent, out);
	        cpy1 = out[1];
	        y2 = out[2];
	      }
	
	      ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
	    } else {
	      if (percent < 1) {
	        cubicSubdivide(x1, cpx1, cpx2, x2, percent, out);
	        cpx1 = out[1];
	        cpx2 = out[2];
	        x2 = out[3];
	        cubicSubdivide(y1, cpy1, cpy2, y2, percent, out);
	        cpy1 = out[1];
	        cpy2 = out[2];
	        y2 = out[3];
	      }
	
	      ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
	    }
	  },
	
	  /**
	   * Get point at percent
	   * @param  {number} t
	   * @return {Array.<number>}
	   */
	  pointAt: function (t) {
	    return someVectorAt(this.shape, t, false);
	  },
	
	  /**
	   * Get tangent at percent
	   * @param  {number} t
	   * @return {Array.<number>}
	   */
	  tangentAt: function (t) {
	    var p = someVectorAt(this.shape, t, true);
	    return vec2.normalize(p, p);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(270);
	
	/**
	 * 圆弧
	 * @module zrender/graphic/shape/Arc
	 */
	var _default = Path.extend({
	  type: 'arc',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r = Math.max(shape.r, 0);
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitX = Math.cos(startAngle);
	    var unitY = Math.sin(startAngle);
	    ctx.moveTo(unitX * r + x, unitY * r + y);
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(270);
	
	// CompoundPath to improve performance
	var _default = Path.extend({
	  type: 'compound',
	  shape: {
	    paths: null
	  },
	  _updatePathDirty: function () {
	    var dirtyPath = this.__dirtyPath;
	    var paths = this.shape.paths;
	
	    for (var i = 0; i < paths.length; i++) {
	      // Mark as dirty if any subpath is dirty
	      dirtyPath = dirtyPath || paths[i].__dirtyPath;
	    }
	
	    this.__dirtyPath = dirtyPath;
	    this.__dirty = this.__dirty || dirtyPath;
	  },
	  beforeBrush: function () {
	    this._updatePathDirty();
	
	    var paths = this.shape.paths || [];
	    var scale = this.getGlobalScale(); // Update path scale
	
	    for (var i = 0; i < paths.length; i++) {
	      if (!paths[i].path) {
	        paths[i].createPathProxy();
	      }
	
	      paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
	    }
	  },
	  buildPath: function (ctx, shape) {
	    var paths = shape.paths || [];
	
	    for (var i = 0; i < paths.length; i++) {
	      paths[i].buildPath(ctx, paths[i].shape, true);
	    }
	  },
	  afterBrush: function () {
	    var paths = this.shape.paths || [];
	
	    for (var i = 0; i < paths.length; i++) {
	      paths[i].__dirtyPath = false;
	    }
	  },
	  getBoundingRect: function () {
	    this._updatePathDirty();
	
	    return Path.prototype.getBoundingRect.call(this);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(220);
	
	var Gradient = __webpack_require__(299);
	
	/**
	 * x, y, x2, y2 are all percent from 0 to 1
	 * @param {number} [x=0]
	 * @param {number} [y=0]
	 * @param {number} [x2=1]
	 * @param {number} [y2=0]
	 * @param {Array.<Object>} colorStops
	 * @param {boolean} [globalCoord=false]
	 */
	var LinearGradient = function (x, y, x2, y2, colorStops, globalCoord) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {type: 'linear', colorStops: ...}`, where
	  // this constructor will not be called.
	  this.x = x == null ? 0 : x;
	  this.y = y == null ? 0 : y;
	  this.x2 = x2 == null ? 1 : x2;
	  this.y2 = y2 == null ? 0 : y2; // Can be cloned
	
	  this.type = 'linear'; // If use global coord
	
	  this.global = globalCoord || false;
	  Gradient.call(this, colorStops);
	};
	
	LinearGradient.prototype = {
	  constructor: LinearGradient
	};
	zrUtil.inherits(LinearGradient, Gradient);
	var _default = LinearGradient;
	module.exports = _default;

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	/**
	 * @param {Array.<Object>} colorStops
	 */
	var Gradient = function (colorStops) {
	  this.colorStops = colorStops || [];
	};
	
	Gradient.prototype = {
	  constructor: Gradient,
	  addColorStop: function (offset, color) {
	    this.colorStops.push({
	      offset: offset,
	      color: color
	    });
	  }
	};
	var _default = Gradient;
	module.exports = _default;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(220);
	
	var Gradient = __webpack_require__(299);
	
	/**
	 * x, y, r are all percent from 0 to 1
	 * @param {number} [x=0.5]
	 * @param {number} [y=0.5]
	 * @param {number} [r=0.5]
	 * @param {Array.<Object>} [colorStops]
	 * @param {boolean} [globalCoord=false]
	 */
	var RadialGradient = function (x, y, r, colorStops, globalCoord) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {type: 'radial', colorStops: ...}`, where
	  // this constructor will not be called.
	  this.x = x == null ? 0.5 : x;
	  this.y = y == null ? 0.5 : y;
	  this.r = r == null ? 0.5 : r; // Can be cloned
	
	  this.type = 'radial'; // If use global coord
	
	  this.global = globalCoord || false;
	  Gradient.call(this, colorStops);
	};
	
	RadialGradient.prototype = {
	  constructor: RadialGradient
	};
	zrUtil.inherits(RadialGradient, Gradient);
	var _default = RadialGradient;
	module.exports = _default;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(220);
	
	var inherits = _util.inherits;
	
	var Displayble = __webpack_require__(252);
	
	var BoundingRect = __webpack_require__(242);
	
	/**
	 * Displayable for incremental rendering. It will be rendered in a separate layer
	 * IncrementalDisplay have two main methods. `clearDisplayables` and `addDisplayables`
	 * addDisplayables will render the added displayables incremetally.
	 *
	 * It use a not clearFlag to tell the painter don't clear the layer if it's the first element.
	 */
	// TODO Style override ?
	function IncrementalDisplayble(opts) {
	  Displayble.call(this, opts);
	  this._displayables = [];
	  this._temporaryDisplayables = [];
	  this._cursor = 0;
	  this.notClear = true;
	}
	
	IncrementalDisplayble.prototype.incremental = true;
	
	IncrementalDisplayble.prototype.clearDisplaybles = function () {
	  this._displayables = [];
	  this._temporaryDisplayables = [];
	  this._cursor = 0;
	  this.dirty();
	  this.notClear = false;
	};
	
	IncrementalDisplayble.prototype.addDisplayable = function (displayable, notPersistent) {
	  if (notPersistent) {
	    this._temporaryDisplayables.push(displayable);
	  } else {
	    this._displayables.push(displayable);
	  }
	
	  this.dirty();
	};
	
	IncrementalDisplayble.prototype.addDisplayables = function (displayables, notPersistent) {
	  notPersistent = notPersistent || false;
	
	  for (var i = 0; i < displayables.length; i++) {
	    this.addDisplayable(displayables[i], notPersistent);
	  }
	};
	
	IncrementalDisplayble.prototype.eachPendingDisplayable = function (cb) {
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    cb && cb(this._displayables[i]);
	  }
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    cb && cb(this._temporaryDisplayables[i]);
	  }
	};
	
	IncrementalDisplayble.prototype.update = function () {
	  this.updateTransform();
	
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    var displayable = this._displayables[i]; // PENDING
	
	    displayable.parent = this;
	    displayable.update();
	    displayable.parent = null;
	  }
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    var displayable = this._temporaryDisplayables[i]; // PENDING
	
	    displayable.parent = this;
	    displayable.update();
	    displayable.parent = null;
	  }
	};
	
	IncrementalDisplayble.prototype.brush = function (ctx, prevEl) {
	  // Render persistant displayables.
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    var displayable = this._displayables[i];
	    displayable.beforeBrush && displayable.beforeBrush(ctx);
	    displayable.brush(ctx, i === this._cursor ? null : this._displayables[i - 1]);
	    displayable.afterBrush && displayable.afterBrush(ctx);
	  }
	
	  this._cursor = i; // Render temporary displayables.
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    var displayable = this._temporaryDisplayables[i];
	    displayable.beforeBrush && displayable.beforeBrush(ctx);
	    displayable.brush(ctx, i === 0 ? null : this._temporaryDisplayables[i - 1]);
	    displayable.afterBrush && displayable.afterBrush(ctx);
	  }
	
	  this._temporaryDisplayables = [];
	  this.notClear = true;
	};
	
	var m = [];
	
	IncrementalDisplayble.prototype.getBoundingRect = function () {
	  if (!this._rect) {
	    var rect = new BoundingRect(Infinity, Infinity, -Infinity, -Infinity);
	
	    for (var i = 0; i < this._displayables.length; i++) {
	      var displayable = this._displayables[i];
	      var childRect = displayable.getBoundingRect().clone();
	
	      if (displayable.needLocalTransform()) {
	        childRect.applyTransform(displayable.getLocalTransform(m));
	      }
	
	      rect.union(childRect);
	    }
	
	    this._rect = rect;
	  }
	
	  return this._rect;
	};
	
	IncrementalDisplayble.prototype.contain = function (x, y) {
	  var localPos = this.transformCoordToLocal(x, y);
	  var rect = this.getBoundingRect();
	
	  if (rect.contain(localPos[0], localPos[1])) {
	    for (var i = 0; i < this._displayables.length; i++) {
	      var displayable = this._displayables[i];
	
	      if (displayable.contain(x, y)) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	};
	
	inherits(IncrementalDisplayble, Displayble);
	var _default = IncrementalDisplayble;
	module.exports = _default;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(265);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['textPosition'], ['textAlign']]);
	var _default = {
	  getItemStyle: function (excludes, includes) {
	    var style = getItemStyle(this, excludes, includes);
	    var lineDash = this.getBorderLineDash();
	    lineDash && (style.lineDash = lineDash);
	    return style;
	  },
	  getBorderLineDash: function () {
	    var lineType = this.get('borderType');
	    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [5, 5] : [1, 1];
	  }
	};
	module.exports = _default;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Model = __webpack_require__(262);
	
	var componentUtil = __webpack_require__(304);
	
	var _clazz = __webpack_require__(263);
	
	var enableClassManagement = _clazz.enableClassManagement;
	var parseClassType = _clazz.parseClassType;
	
	var _model = __webpack_require__(261);
	
	var makeInner = _model.makeInner;
	
	var layout = __webpack_require__(305);
	
	var boxLayoutMixin = __webpack_require__(308);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Component model
	 *
	 * @module echarts/model/Component
	 */
	var inner = makeInner();
	/**
	 * @alias module:echarts/model/Component
	 * @constructor
	 * @param {Object} option
	 * @param {module:echarts/model/Model} parentModel
	 * @param {module:echarts/model/Model} ecModel
	 */
	
	var ComponentModel = Model.extend({
	  type: 'component',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  id: '',
	
	  /**
	   * Because simplified concept is probably better, series.name (or component.name)
	   * has been having too many resposibilities:
	   * (1) Generating id (which requires name in option should not be modified).
	   * (2) As an index to mapping series when merging option or calling API (a name
	   * can refer to more then one components, which is convinient is some case).
	   * (3) Display.
	   * @readOnly
	   */
	  name: '',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  mainType: '',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  subType: '',
	
	  /**
	   * @readOnly
	   * @type {number}
	   */
	  componentIndex: 0,
	
	  /**
	   * @type {Object}
	   * @protected
	   */
	  defaultOption: null,
	
	  /**
	   * @type {module:echarts/model/Global}
	   * @readOnly
	   */
	  ecModel: null,
	
	  /**
	   * key: componentType
	   * value:  Component model list, can not be null.
	   * @type {Object.<string, Array.<module:echarts/model/Model>>}
	   * @readOnly
	   */
	  dependentModels: [],
	
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  uid: null,
	
	  /**
	   * Support merge layout params.
	   * Only support 'box' now (left/right/top/bottom/width/height).
	   * @type {string|Object} Object can be {ignoreSize: true}
	   * @readOnly
	   */
	  layoutMode: null,
	  $constructor: function (option, parentModel, ecModel, extraOpt) {
	    Model.call(this, option, parentModel, ecModel, extraOpt);
	    this.uid = componentUtil.getUID('ec_cpt_model');
	  },
	  init: function (option, parentModel, ecModel, extraOpt) {
	    this.mergeDefaultAndTheme(option, ecModel);
	  },
	  mergeDefaultAndTheme: function (option, ecModel) {
	    var layoutMode = this.layoutMode;
	    var inputPositionParams = layoutMode ? layout.getLayoutParams(option) : {};
	    var themeModel = ecModel.getTheme();
	    zrUtil.merge(option, themeModel.get(this.mainType));
	    zrUtil.merge(option, this.getDefaultOption());
	
	    if (layoutMode) {
	      layout.mergeLayoutParam(option, inputPositionParams, layoutMode);
	    }
	  },
	  mergeOption: function (option, extraOpt) {
	    zrUtil.merge(this.option, option, true);
	    var layoutMode = this.layoutMode;
	
	    if (layoutMode) {
	      layout.mergeLayoutParam(this.option, option, layoutMode);
	    }
	  },
	  // Hooker after init or mergeOption
	  optionUpdated: function (newCptOption, isInit) {},
	  getDefaultOption: function () {
	    var fields = inner(this);
	
	    if (!fields.defaultOption) {
	      var optList = [];
	      var Class = this.constructor;
	
	      while (Class) {
	        var opt = Class.prototype.defaultOption;
	        opt && optList.push(opt);
	        Class = Class.superClass;
	      }
	
	      var defaultOption = {};
	
	      for (var i = optList.length - 1; i >= 0; i--) {
	        defaultOption = zrUtil.merge(defaultOption, optList[i], true);
	      }
	
	      fields.defaultOption = defaultOption;
	    }
	
	    return fields.defaultOption;
	  },
	  getReferringComponents: function (mainType) {
	    return this.ecModel.queryComponents({
	      mainType: mainType,
	      index: this.get(mainType + 'Index', true),
	      id: this.get(mainType + 'Id', true)
	    });
	  }
	}); // Reset ComponentModel.extend, add preConstruct.
	// clazzUtil.enableClassExtend(
	//     ComponentModel,
	//     function (option, parentModel, ecModel, extraOpt) {
	//         // Set dependentModels, componentIndex, name, id, mainType, subType.
	//         zrUtil.extend(this, extraOpt);
	//         this.uid = componentUtil.getUID('componentModel');
	//         // this.setReadOnly([
	//         //     'type', 'id', 'uid', 'name', 'mainType', 'subType',
	//         //     'dependentModels', 'componentIndex'
	//         // ]);
	//     }
	// );
	// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	enableClassManagement(ComponentModel, {
	  registerWhenExtend: true
	});
	componentUtil.enableSubTypeDefaulter(ComponentModel); // Add capability of ComponentModel.topologicalTravel.
	
	componentUtil.enableTopologicalTravel(ComponentModel, getDependencies);
	
	function getDependencies(componentType) {
	  var deps = [];
	  zrUtil.each(ComponentModel.getClassesByMainType(componentType), function (Clazz) {
	    deps = deps.concat(Clazz.prototype.dependencies || []);
	  }); // Ensure main type.
	
	  deps = zrUtil.map(deps, function (type) {
	    return parseClassType(type).main;
	  }); // Hack dataset for convenience.
	
	  if (componentType !== 'dataset' && zrUtil.indexOf(deps, 'dataset') <= 0) {
	    deps.unshift('dataset');
	  }
	
	  return deps;
	}
	
	zrUtil.mixin(ComponentModel, boxLayoutMixin);
	var _default = ComponentModel;
	module.exports = _default;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var _clazz = __webpack_require__(263);
	
	var parseClassType = _clazz.parseClassType;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var base = 0;
	/**
	 * @public
	 * @param {string} type
	 * @return {string}
	 */
	
	function getUID(type) {
	  // Considering the case of crossing js context,
	  // use Math.random to make id as unique as possible.
	  return [type || '', base++, Math.random().toFixed(5)].join('_');
	}
	/**
	 * @inner
	 */
	
	
	function enableSubTypeDefaulter(entity) {
	  var subTypeDefaulters = {};
	
	  entity.registerSubTypeDefaulter = function (componentType, defaulter) {
	    componentType = parseClassType(componentType);
	    subTypeDefaulters[componentType.main] = defaulter;
	  };
	
	  entity.determineSubType = function (componentType, option) {
	    var type = option.type;
	
	    if (!type) {
	      var componentTypeMain = parseClassType(componentType).main;
	
	      if (entity.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
	        type = subTypeDefaulters[componentTypeMain](option);
	      }
	    }
	
	    return type;
	  };
	
	  return entity;
	}
	/**
	 * Topological travel on Activity Network (Activity On Vertices).
	 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
	 *
	 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
	 *
	 * If there is circle dependencey, Error will be thrown.
	 *
	 */
	
	
	function enableTopologicalTravel(entity, dependencyGetter) {
	  /**
	   * @public
	   * @param {Array.<string>} targetNameList Target Component type list.
	   *                                           Can be ['aa', 'bb', 'aa.xx']
	   * @param {Array.<string>} fullNameList By which we can build dependency graph.
	   * @param {Function} callback Params: componentType, dependencies.
	   * @param {Object} context Scope of callback.
	   */
	  entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
	    if (!targetNameList.length) {
	      return;
	    }
	
	    var result = makeDepndencyGraph(fullNameList);
	    var graph = result.graph;
	    var stack = result.noEntryList;
	    var targetNameSet = {};
	    zrUtil.each(targetNameList, function (name) {
	      targetNameSet[name] = true;
	    });
	
	    while (stack.length) {
	      var currComponentType = stack.pop();
	      var currVertex = graph[currComponentType];
	      var isInTargetNameSet = !!targetNameSet[currComponentType];
	
	      if (isInTargetNameSet) {
	        callback.call(context, currComponentType, currVertex.originalDeps.slice());
	        delete targetNameSet[currComponentType];
	      }
	
	      zrUtil.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
	    }
	
	    zrUtil.each(targetNameSet, function () {
	      throw new Error('Circle dependency may exists');
	    });
	
	    function removeEdge(succComponentType) {
	      graph[succComponentType].entryCount--;
	
	      if (graph[succComponentType].entryCount === 0) {
	        stack.push(succComponentType);
	      }
	    } // Consider this case: legend depends on series, and we call
	    // chart.setOption({series: [...]}), where only series is in option.
	    // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
	    // not be called, but only sereis.mergeOption is called. Thus legend
	    // have no chance to update its local record about series (like which
	    // name of series is available in legend).
	
	
	    function removeEdgeAndAdd(succComponentType) {
	      targetNameSet[succComponentType] = true;
	      removeEdge(succComponentType);
	    }
	  };
	  /**
	   * DepndencyGraph: {Object}
	   * key: conponentType,
	   * value: {
	   *     successor: [conponentTypes...],
	   *     originalDeps: [conponentTypes...],
	   *     entryCount: {number}
	   * }
	   */
	
	
	  function makeDepndencyGraph(fullNameList) {
	    var graph = {};
	    var noEntryList = [];
	    zrUtil.each(fullNameList, function (name) {
	      var thisItem = createDependencyGraphItem(graph, name);
	      var originalDeps = thisItem.originalDeps = dependencyGetter(name);
	      var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
	      thisItem.entryCount = availableDeps.length;
	
	      if (thisItem.entryCount === 0) {
	        noEntryList.push(name);
	      }
	
	      zrUtil.each(availableDeps, function (dependentName) {
	        if (zrUtil.indexOf(thisItem.predecessor, dependentName) < 0) {
	          thisItem.predecessor.push(dependentName);
	        }
	
	        var thatItem = createDependencyGraphItem(graph, dependentName);
	
	        if (zrUtil.indexOf(thatItem.successor, dependentName) < 0) {
	          thatItem.successor.push(name);
	        }
	      });
	    });
	    return {
	      graph: graph,
	      noEntryList: noEntryList
	    };
	  }
	
	  function createDependencyGraphItem(graph, name) {
	    if (!graph[name]) {
	      graph[name] = {
	        predecessor: [],
	        successor: []
	      };
	    }
	
	    return graph[name];
	  }
	
	  function getAvailableDependencies(originalDeps, fullNameList) {
	    var availableDeps = [];
	    zrUtil.each(originalDeps, function (dep) {
	      zrUtil.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
	    });
	    return availableDeps;
	  }
	}
	
	exports.getUID = getUID;
	exports.enableSubTypeDefaulter = enableSubTypeDefaulter;
	exports.enableTopologicalTravel = enableTopologicalTravel;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var BoundingRect = __webpack_require__(242);
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	
	var formatUtil = __webpack_require__(307);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Layout helpers for each component positioning
	var each = zrUtil.each;
	/**
	 * @public
	 */
	
	var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
	/**
	 * @public
	 */
	
	var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];
	
	function boxLayout(orient, group, gap, maxWidth, maxHeight) {
	  var x = 0;
	  var y = 0;
	
	  if (maxWidth == null) {
	    maxWidth = Infinity;
	  }
	
	  if (maxHeight == null) {
	    maxHeight = Infinity;
	  }
	
	  var currentLineMaxSize = 0;
	  group.eachChild(function (child, idx) {
	    var position = child.position;
	    var rect = child.getBoundingRect();
	    var nextChild = group.childAt(idx + 1);
	    var nextChildRect = nextChild && nextChild.getBoundingRect();
	    var nextX;
	    var nextY;
	
	    if (orient === 'horizontal') {
	      var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
	      nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
	      // FIXME compare before adding gap?
	
	      if (nextX > maxWidth || child.newline) {
	        x = 0;
	        nextX = moveX;
	        y += currentLineMaxSize + gap;
	        currentLineMaxSize = rect.height;
	      } else {
	        // FIXME: consider rect.y is not `0`?
	        currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
	      }
	    } else {
	      var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
	      nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group
	
	      if (nextY > maxHeight || child.newline) {
	        x += currentLineMaxSize + gap;
	        y = 0;
	        nextY = moveY;
	        currentLineMaxSize = rect.width;
	      } else {
	        currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
	      }
	    }
	
	    if (child.newline) {
	      return;
	    }
	
	    position[0] = x;
	    position[1] = y;
	    orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
	  });
	}
	/**
	 * VBox or HBox layouting
	 * @param {string} orient
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	
	var box = boxLayout;
	/**
	 * VBox layouting
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	var vbox = zrUtil.curry(boxLayout, 'vertical');
	/**
	 * HBox layouting
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	var hbox = zrUtil.curry(boxLayout, 'horizontal');
	/**
	 * If x or x2 is not specified or 'center' 'left' 'right',
	 * the width would be as long as possible.
	 * If y or y2 is not specified or 'middle' 'top' 'bottom',
	 * the height would be as long as possible.
	 *
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.x]
	 * @param {number|string} [positionInfo.y]
	 * @param {number|string} [positionInfo.x2]
	 * @param {number|string} [positionInfo.y2]
	 * @param {Object} containerRect {width, height}
	 * @param {string|number} margin
	 * @return {Object} {width, height}
	 */
	
	function getAvailableSize(positionInfo, containerRect, margin) {
	  var containerWidth = containerRect.width;
	  var containerHeight = containerRect.height;
	  var x = parsePercent(positionInfo.x, containerWidth);
	  var y = parsePercent(positionInfo.y, containerHeight);
	  var x2 = parsePercent(positionInfo.x2, containerWidth);
	  var y2 = parsePercent(positionInfo.y2, containerHeight);
	  (isNaN(x) || isNaN(parseFloat(positionInfo.x))) && (x = 0);
	  (isNaN(x2) || isNaN(parseFloat(positionInfo.x2))) && (x2 = containerWidth);
	  (isNaN(y) || isNaN(parseFloat(positionInfo.y))) && (y = 0);
	  (isNaN(y2) || isNaN(parseFloat(positionInfo.y2))) && (y2 = containerHeight);
	  margin = formatUtil.normalizeCssArray(margin || 0);
	  return {
	    width: Math.max(x2 - x - margin[1] - margin[3], 0),
	    height: Math.max(y2 - y - margin[0] - margin[2], 0)
	  };
	}
	/**
	 * Parse position info.
	 *
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.left]
	 * @param {number|string} [positionInfo.top]
	 * @param {number|string} [positionInfo.right]
	 * @param {number|string} [positionInfo.bottom]
	 * @param {number|string} [positionInfo.width]
	 * @param {number|string} [positionInfo.height]
	 * @param {number|string} [positionInfo.aspect] Aspect is width / height
	 * @param {Object} containerRect
	 * @param {string|number} [margin]
	 *
	 * @return {module:zrender/core/BoundingRect}
	 */
	
	
	function getLayoutRect(positionInfo, containerRect, margin) {
	  margin = formatUtil.normalizeCssArray(margin || 0);
	  var containerWidth = containerRect.width;
	  var containerHeight = containerRect.height;
	  var left = parsePercent(positionInfo.left, containerWidth);
	  var top = parsePercent(positionInfo.top, containerHeight);
	  var right = parsePercent(positionInfo.right, containerWidth);
	  var bottom = parsePercent(positionInfo.bottom, containerHeight);
	  var width = parsePercent(positionInfo.width, containerWidth);
	  var height = parsePercent(positionInfo.height, containerHeight);
	  var verticalMargin = margin[2] + margin[0];
	  var horizontalMargin = margin[1] + margin[3];
	  var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right
	
	  if (isNaN(width)) {
	    width = containerWidth - right - horizontalMargin - left;
	  }
	
	  if (isNaN(height)) {
	    height = containerHeight - bottom - verticalMargin - top;
	  }
	
	  if (aspect != null) {
	    // If width and height are not given
	    // 1. Graph should not exceeds the container
	    // 2. Aspect must be keeped
	    // 3. Graph should take the space as more as possible
	    // FIXME
	    // Margin is not considered, because there is no case that both
	    // using margin and aspect so far.
	    if (isNaN(width) && isNaN(height)) {
	      if (aspect > containerWidth / containerHeight) {
	        width = containerWidth * 0.8;
	      } else {
	        height = containerHeight * 0.8;
	      }
	    } // Calculate width or height with given aspect
	
	
	    if (isNaN(width)) {
	      width = aspect * height;
	    }
	
	    if (isNaN(height)) {
	      height = width / aspect;
	    }
	  } // If left is not specified, calculate left from right and width
	
	
	  if (isNaN(left)) {
	    left = containerWidth - right - width - horizontalMargin;
	  }
	
	  if (isNaN(top)) {
	    top = containerHeight - bottom - height - verticalMargin;
	  } // Align left and top
	
	
	  switch (positionInfo.left || positionInfo.right) {
	    case 'center':
	      left = containerWidth / 2 - width / 2 - margin[3];
	      break;
	
	    case 'right':
	      left = containerWidth - width - horizontalMargin;
	      break;
	  }
	
	  switch (positionInfo.top || positionInfo.bottom) {
	    case 'middle':
	    case 'center':
	      top = containerHeight / 2 - height / 2 - margin[0];
	      break;
	
	    case 'bottom':
	      top = containerHeight - height - verticalMargin;
	      break;
	  } // If something is wrong and left, top, width, height are calculated as NaN
	
	
	  left = left || 0;
	  top = top || 0;
	
	  if (isNaN(width)) {
	    // Width may be NaN if only one value is given except width
	    width = containerWidth - horizontalMargin - left - (right || 0);
	  }
	
	  if (isNaN(height)) {
	    // Height may be NaN if only one value is given except height
	    height = containerHeight - verticalMargin - top - (bottom || 0);
	  }
	
	  var rect = new BoundingRect(left + margin[3], top + margin[0], width, height);
	  rect.margin = margin;
	  return rect;
	}
	/**
	 * Position a zr element in viewport
	 *  Group position is specified by either
	 *  {left, top}, {right, bottom}
	 *  If all properties exists, right and bottom will be igonred.
	 *
	 * Logic:
	 *     1. Scale (against origin point in parent coord)
	 *     2. Rotate (against origin point in parent coord)
	 *     3. Traslate (with el.position by this method)
	 * So this method only fixes the last step 'Traslate', which does not affect
	 * scaling and rotating.
	 *
	 * If be called repeatly with the same input el, the same result will be gotten.
	 *
	 * @param {module:zrender/Element} el Should have `getBoundingRect` method.
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.left]
	 * @param {number|string} [positionInfo.top]
	 * @param {number|string} [positionInfo.right]
	 * @param {number|string} [positionInfo.bottom]
	 * @param {number|string} [positionInfo.width] Only for opt.boundingModel: 'raw'
	 * @param {number|string} [positionInfo.height] Only for opt.boundingModel: 'raw'
	 * @param {Object} containerRect
	 * @param {string|number} margin
	 * @param {Object} [opt]
	 * @param {Array.<number>} [opt.hv=[1,1]] Only horizontal or only vertical.
	 * @param {Array.<number>} [opt.boundingMode='all']
	 *        Specify how to calculate boundingRect when locating.
	 *        'all': Position the boundingRect that is transformed and uioned
	 *               both itself and its descendants.
	 *               This mode simplies confine the elements in the bounding
	 *               of their container (e.g., using 'right: 0').
	 *        'raw': Position the boundingRect that is not transformed and only itself.
	 *               This mode is useful when you want a element can overflow its
	 *               container. (Consider a rotated circle needs to be located in a corner.)
	 *               In this mode positionInfo.width/height can only be number.
	 */
	
	
	function positionElement(el, positionInfo, containerRect, margin, opt) {
	  var h = !opt || !opt.hv || opt.hv[0];
	  var v = !opt || !opt.hv || opt.hv[1];
	  var boundingMode = opt && opt.boundingMode || 'all';
	
	  if (!h && !v) {
	    return;
	  }
	
	  var rect;
	
	  if (boundingMode === 'raw') {
	    rect = el.type === 'group' ? new BoundingRect(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
	  } else {
	    rect = el.getBoundingRect();
	
	    if (el.needLocalTransform()) {
	      var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
	      // which should not be modified.
	
	      rect = rect.clone();
	      rect.applyTransform(transform);
	    }
	  } // The real width and height can not be specified but calculated by the given el.
	
	
	  positionInfo = getLayoutRect(zrUtil.defaults({
	    width: rect.width,
	    height: rect.height
	  }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
	  // (see zrender/core/Transformable#getLocalTransform),
	  // we can just only modify el.position to get final result.
	
	  var elPos = el.position;
	  var dx = h ? positionInfo.x - rect.x : 0;
	  var dy = v ? positionInfo.y - rect.y : 0;
	  el.attr('position', boundingMode === 'raw' ? [dx, dy] : [elPos[0] + dx, elPos[1] + dy]);
	}
	/**
	 * @param {Object} option Contains some of the properties in HV_NAMES.
	 * @param {number} hvIdx 0: horizontal; 1: vertical.
	 */
	
	
	function sizeCalculable(option, hvIdx) {
	  return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
	}
	/**
	 * Consider Case:
	 * When defulat option has {left: 0, width: 100}, and we set {right: 0}
	 * through setOption or media query, using normal zrUtil.merge will cause
	 * {right: 0} does not take effect.
	 *
	 * @example
	 * ComponentModel.extend({
	 *     init: function () {
	 *         ...
	 *         var inputPositionParams = layout.getLayoutParams(option);
	 *         this.mergeOption(inputPositionParams);
	 *     },
	 *     mergeOption: function (newOption) {
	 *         newOption && zrUtil.merge(thisOption, newOption, true);
	 *         layout.mergeLayoutParam(thisOption, newOption);
	 *     }
	 * });
	 *
	 * @param {Object} targetOption
	 * @param {Object} newOption
	 * @param {Object|string} [opt]
	 * @param {boolean|Array.<boolean>} [opt.ignoreSize=false] Used for the components
	 *  that width (or height) should not be calculated by left and right (or top and bottom).
	 */
	
	
	function mergeLayoutParam(targetOption, newOption, opt) {
	  !zrUtil.isObject(opt) && (opt = {});
	  var ignoreSize = opt.ignoreSize;
	  !zrUtil.isArray(ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
	  var hResult = merge(HV_NAMES[0], 0);
	  var vResult = merge(HV_NAMES[1], 1);
	  copy(HV_NAMES[0], targetOption, hResult);
	  copy(HV_NAMES[1], targetOption, vResult);
	
	  function merge(names, hvIdx) {
	    var newParams = {};
	    var newValueCount = 0;
	    var merged = {};
	    var mergedValueCount = 0;
	    var enoughParamNumber = 2;
	    each(names, function (name) {
	      merged[name] = targetOption[name];
	    });
	    each(names, function (name) {
	      // Consider case: newOption.width is null, which is
	      // set by user for removing width setting.
	      hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
	      hasValue(newParams, name) && newValueCount++;
	      hasValue(merged, name) && mergedValueCount++;
	    });
	
	    if (ignoreSize[hvIdx]) {
	      // Only one of left/right is premitted to exist.
	      if (hasValue(newOption, names[1])) {
	        merged[names[2]] = null;
	      } else if (hasValue(newOption, names[2])) {
	        merged[names[1]] = null;
	      }
	
	      return merged;
	    } // Case: newOption: {width: ..., right: ...},
	    // or targetOption: {right: ...} and newOption: {width: ...},
	    // There is no conflict when merged only has params count
	    // little than enoughParamNumber.
	
	
	    if (mergedValueCount === enoughParamNumber || !newValueCount) {
	      return merged;
	    } // Case: newOption: {width: ..., right: ...},
	    // Than we can make sure user only want those two, and ignore
	    // all origin params in targetOption.
	    else if (newValueCount >= enoughParamNumber) {
	        return newParams;
	      } else {
	        // Chose another param from targetOption by priority.
	        for (var i = 0; i < names.length; i++) {
	          var name = names[i];
	
	          if (!hasProp(newParams, name) && hasProp(targetOption, name)) {
	            newParams[name] = targetOption[name];
	            break;
	          }
	        }
	
	        return newParams;
	      }
	  }
	
	  function hasProp(obj, name) {
	    return obj.hasOwnProperty(name);
	  }
	
	  function hasValue(obj, name) {
	    return obj[name] != null && obj[name] !== 'auto';
	  }
	
	  function copy(names, target, source) {
	    each(names, function (name) {
	      target[name] = source[name];
	    });
	  }
	}
	/**
	 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	 * @param {Object} source
	 * @return {Object} Result contains those props.
	 */
	
	
	function getLayoutParams(source) {
	  return copyLayoutParams({}, source);
	}
	/**
	 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	 * @param {Object} source
	 * @return {Object} Result contains those props.
	 */
	
	
	function copyLayoutParams(target, source) {
	  source && target && each(LOCATION_PARAMS, function (name) {
	    source.hasOwnProperty(name) && (target[name] = source[name]);
	  });
	  return target;
	}
	
	exports.LOCATION_PARAMS = LOCATION_PARAMS;
	exports.HV_NAMES = HV_NAMES;
	exports.box = box;
	exports.vbox = vbox;
	exports.hbox = hbox;
	exports.getAvailableSize = getAvailableSize;
	exports.getLayoutRect = getLayoutRect;
	exports.positionElement = positionElement;
	exports.sizeCalculable = sizeCalculable;
	exports.mergeLayoutParam = mergeLayoutParam;
	exports.getLayoutParams = getLayoutParams;
	exports.copyLayoutParams = copyLayoutParams;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The method "quantile" was copied from "d3.js".
	* (See more details in the comment of the method below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var RADIAN_EPSILON = 1e-4;
	
	function _trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	}
	/**
	 * Linear mapping a value from domain to range
	 * @memberOf module:echarts/util/number
	 * @param  {(number|Array.<number>)} val
	 * @param  {Array.<number>} domain Domain extent domain[0] can be bigger than domain[1]
	 * @param  {Array.<number>} range  Range extent range[0] can be bigger than range[1]
	 * @param  {boolean} clamp
	 * @return {(number|Array.<number>}
	 */
	
	
	function linearMap(val, domain, range, clamp) {
	  var subDomain = domain[1] - domain[0];
	  var subRange = range[1] - range[0];
	
	  if (subDomain === 0) {
	    return subRange === 0 ? range[0] : (range[0] + range[1]) / 2;
	  } // Avoid accuracy problem in edge, such as
	  // 146.39 - 62.83 === 83.55999999999999.
	  // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
	  // It is a little verbose for efficiency considering this method
	  // is a hotspot.
	
	
	  if (clamp) {
	    if (subDomain > 0) {
	      if (val <= domain[0]) {
	        return range[0];
	      } else if (val >= domain[1]) {
	        return range[1];
	      }
	    } else {
	      if (val >= domain[0]) {
	        return range[0];
	      } else if (val <= domain[1]) {
	        return range[1];
	      }
	    }
	  } else {
	    if (val === domain[0]) {
	      return range[0];
	    }
	
	    if (val === domain[1]) {
	      return range[1];
	    }
	  }
	
	  return (val - domain[0]) / subDomain * subRange + range[0];
	}
	/**
	 * Convert a percent string to absolute number.
	 * Returns NaN if percent is not a valid string or number
	 * @memberOf module:echarts/util/number
	 * @param {string|number} percent
	 * @param {number} all
	 * @return {number}
	 */
	
	
	function parsePercent(percent, all) {
	  switch (percent) {
	    case 'center':
	    case 'middle':
	      percent = '50%';
	      break;
	
	    case 'left':
	    case 'top':
	      percent = '0%';
	      break;
	
	    case 'right':
	    case 'bottom':
	      percent = '100%';
	      break;
	  }
	
	  if (typeof percent === 'string') {
	    if (_trim(percent).match(/%$/)) {
	      return parseFloat(percent) / 100 * all;
	    }
	
	    return parseFloat(percent);
	  }
	
	  return percent == null ? NaN : +percent;
	}
	/**
	 * (1) Fix rounding error of float numbers.
	 * (2) Support return string to avoid scientific notation like '3.5e-7'.
	 *
	 * @param {number} x
	 * @param {number} [precision]
	 * @param {boolean} [returnStr]
	 * @return {number|string}
	 */
	
	
	function round(x, precision, returnStr) {
	  if (precision == null) {
	    precision = 10;
	  } // Avoid range error
	
	
	  precision = Math.min(Math.max(0, precision), 20);
	  x = (+x).toFixed(precision);
	  return returnStr ? x : +x;
	}
	/**
	 * asc sort arr.
	 * The input arr will be modified.
	 *
	 * @param {Array} arr
	 * @return {Array} The input arr.
	 */
	
	
	function asc(arr) {
	  arr.sort(function (a, b) {
	    return a - b;
	  });
	  return arr;
	}
	/**
	 * Get precision
	 * @param {number} val
	 */
	
	
	function getPrecision(val) {
	  val = +val;
	
	  if (isNaN(val)) {
	    return 0;
	  } // It is much faster than methods converting number to string as follows
	  //      var tmp = val.toString();
	  //      return tmp.length - 1 - tmp.indexOf('.');
	  // especially when precision is low
	
	
	  var e = 1;
	  var count = 0;
	
	  while (Math.round(val * e) / e !== val) {
	    e *= 10;
	    count++;
	  }
	
	  return count;
	}
	/**
	 * @param {string|number} val
	 * @return {number}
	 */
	
	
	function getPrecisionSafe(val) {
	  var str = val.toString(); // Consider scientific notation: '3.4e-12' '3.4e+12'
	
	  var eIndex = str.indexOf('e');
	
	  if (eIndex > 0) {
	    var precision = +str.slice(eIndex + 1);
	    return precision < 0 ? -precision : 0;
	  } else {
	    var dotIndex = str.indexOf('.');
	    return dotIndex < 0 ? 0 : str.length - 1 - dotIndex;
	  }
	}
	/**
	 * Minimal dicernible data precisioin according to a single pixel.
	 *
	 * @param {Array.<number>} dataExtent
	 * @param {Array.<number>} pixelExtent
	 * @return {number} precision
	 */
	
	
	function getPixelPrecision(dataExtent, pixelExtent) {
	  var log = Math.log;
	  var LN10 = Math.LN10;
	  var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
	  var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.
	
	  var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
	  return !isFinite(precision) ? 20 : precision;
	}
	/**
	 * Get a data of given precision, assuring the sum of percentages
	 * in valueList is 1.
	 * The largest remainer method is used.
	 * https://en.wikipedia.org/wiki/Largest_remainder_method
	 *
	 * @param {Array.<number>} valueList a list of all data
	 * @param {number} idx index of the data to be processed in valueList
	 * @param {number} precision integer number showing digits of precision
	 * @return {number} percent ranging from 0 to 100
	 */
	
	
	function getPercentWithPrecision(valueList, idx, precision) {
	  if (!valueList[idx]) {
	    return 0;
	  }
	
	  var sum = zrUtil.reduce(valueList, function (acc, val) {
	    return acc + (isNaN(val) ? 0 : val);
	  }, 0);
	
	  if (sum === 0) {
	    return 0;
	  }
	
	  var digits = Math.pow(10, precision);
	  var votesPerQuota = zrUtil.map(valueList, function (val) {
	    return (isNaN(val) ? 0 : val) / sum * digits * 100;
	  });
	  var targetSeats = digits * 100;
	  var seats = zrUtil.map(votesPerQuota, function (votes) {
	    // Assign automatic seats.
	    return Math.floor(votes);
	  });
	  var currentSum = zrUtil.reduce(seats, function (acc, val) {
	    return acc + val;
	  }, 0);
	  var remainder = zrUtil.map(votesPerQuota, function (votes, idx) {
	    return votes - seats[idx];
	  }); // Has remainding votes.
	
	  while (currentSum < targetSeats) {
	    // Find next largest remainder.
	    var max = Number.NEGATIVE_INFINITY;
	    var maxId = null;
	
	    for (var i = 0, len = remainder.length; i < len; ++i) {
	      if (remainder[i] > max) {
	        max = remainder[i];
	        maxId = i;
	      }
	    } // Add a vote to max remainder.
	
	
	    ++seats[maxId];
	    remainder[maxId] = 0;
	    ++currentSum;
	  }
	
	  return seats[idx] / digits;
	} // Number.MAX_SAFE_INTEGER, ie do not support.
	
	
	var MAX_SAFE_INTEGER = 9007199254740991;
	/**
	 * To 0 - 2 * PI, considering negative radian.
	 * @param {number} radian
	 * @return {number}
	 */
	
	function remRadian(radian) {
	  var pi2 = Math.PI * 2;
	  return (radian % pi2 + pi2) % pi2;
	}
	/**
	 * @param {type} radian
	 * @return {boolean}
	 */
	
	
	function isRadianAroundZero(val) {
	  return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
	}
	/* eslint-disable */
	
	
	var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
	
	/* eslint-enable */
	
	/**
	 * @param {string|Date|number} value These values can be accepted:
	 *   + An instance of Date, represent a time in its own time zone.
	 *   + Or string in a subset of ISO 8601, only including:
	 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
	 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
	 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
	 *     all of which will be treated as local time if time zone is not specified
	 *     (see <https://momentjs.com/>).
	 *   + Or other string format, including (all of which will be treated as loacal time):
	 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
	 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
	 *   + a timestamp, which represent a time in UTC.
	 * @return {Date} date
	 */
	
	function parseDate(value) {
	  if (value instanceof Date) {
	    return value;
	  } else if (typeof value === 'string') {
	    // Different browsers parse date in different way, so we parse it manually.
	    // Some other issues:
	    // new Date('1970-01-01') is UTC,
	    // new Date('1970/01/01') and new Date('1970-1-01') is local.
	    // See issue #3623
	    var match = TIME_REG.exec(value);
	
	    if (!match) {
	      // return Invalid Date.
	      return new Date(NaN);
	    } // Use local time when no timezone offset specifed.
	
	
	    if (!match[8]) {
	      // match[n] can only be string or undefined.
	      // But take care of '12' + 1 => '121'.
	      return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, +match[7] || 0);
	    } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
	    // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
	    // For example, system timezone is set as "Time Zone: America/Toronto",
	    // then these code will get different result:
	    // `new Date(1478411999999).getTimezoneOffset();  // get 240`
	    // `new Date(1478412000000).getTimezoneOffset();  // get 300`
	    // So we should not use `new Date`, but use `Date.UTC`.
	    else {
	        var hour = +match[4] || 0;
	
	        if (match[8].toUpperCase() !== 'Z') {
	          hour -= match[8].slice(0, 3);
	        }
	
	        return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, +match[7] || 0));
	      }
	  } else if (value == null) {
	    return new Date(NaN);
	  }
	
	  return new Date(Math.round(value));
	}
	/**
	 * Quantity of a number. e.g. 0.1, 1, 10, 100
	 *
	 * @param  {number} val
	 * @return {number}
	 */
	
	
	function quantity(val) {
	  return Math.pow(10, quantityExponent(val));
	}
	/**
	 * Exponent of the quantity of a number
	 * e.g., 1234 equals to 1.234*10^3, so quantityExponent(1234) is 3
	 *
	 * @param  {number} val non-negative value
	 * @return {number}
	 */
	
	
	function quantityExponent(val) {
	  if (val === 0) {
	    return 0;
	  }
	
	  var exp = Math.floor(Math.log(val) / Math.LN10);
	  /**
	   * exp is expected to be the rounded-down result of the base-10 log of val.
	   * But due to the precision loss with Math.log(val), we need to restore it
	   * using 10^exp to make sure we can get val back from exp. #11249
	   */
	
	  if (val / Math.pow(10, exp) >= 10) {
	    exp++;
	  }
	
	  return exp;
	}
	/**
	 * find a “nice” number approximately equal to x. Round the number if round = true,
	 * take ceiling if round = false. The primary observation is that the “nicest”
	 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
	 *
	 * See "Nice Numbers for Graph Labels" of Graphic Gems.
	 *
	 * @param  {number} val Non-negative value.
	 * @param  {boolean} round
	 * @return {number}
	 */
	
	
	function nice(val, round) {
	  var exponent = quantityExponent(val);
	  var exp10 = Math.pow(10, exponent);
	  var f = val / exp10; // 1 <= f < 10
	
	  var nf;
	
	  if (round) {
	    if (f < 1.5) {
	      nf = 1;
	    } else if (f < 2.5) {
	      nf = 2;
	    } else if (f < 4) {
	      nf = 3;
	    } else if (f < 7) {
	      nf = 5;
	    } else {
	      nf = 10;
	    }
	  } else {
	    if (f < 1) {
	      nf = 1;
	    } else if (f < 2) {
	      nf = 2;
	    } else if (f < 3) {
	      nf = 3;
	    } else if (f < 5) {
	      nf = 5;
	    } else {
	      nf = 10;
	    }
	  }
	
	  val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
	  // 20 is the uppper bound of toFixed.
	
	  return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
	}
	/**
	 * This code was copied from "d3.js"
	 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/arrays/quantile.js>.
	 * See the license statement at the head of this file.
	 * @param {Array.<number>} ascArr
	 */
	
	
	function quantile(ascArr, p) {
	  var H = (ascArr.length - 1) * p + 1;
	  var h = Math.floor(H);
	  var v = +ascArr[h - 1];
	  var e = H - h;
	  return e ? v + e * (ascArr[h] - v) : v;
	}
	/**
	 * Order intervals asc, and split them when overlap.
	 * expect(numberUtil.reformIntervals([
	 *     {interval: [18, 62], close: [1, 1]},
	 *     {interval: [-Infinity, -70], close: [0, 0]},
	 *     {interval: [-70, -26], close: [1, 1]},
	 *     {interval: [-26, 18], close: [1, 1]},
	 *     {interval: [62, 150], close: [1, 1]},
	 *     {interval: [106, 150], close: [1, 1]},
	 *     {interval: [150, Infinity], close: [0, 0]}
	 * ])).toEqual([
	 *     {interval: [-Infinity, -70], close: [0, 0]},
	 *     {interval: [-70, -26], close: [1, 1]},
	 *     {interval: [-26, 18], close: [0, 1]},
	 *     {interval: [18, 62], close: [0, 1]},
	 *     {interval: [62, 150], close: [0, 1]},
	 *     {interval: [150, Infinity], close: [0, 0]}
	 * ]);
	 * @param {Array.<Object>} list, where `close` mean open or close
	 *        of the interval, and Infinity can be used.
	 * @return {Array.<Object>} The origin list, which has been reformed.
	 */
	
	
	function reformIntervals(list) {
	  list.sort(function (a, b) {
	    return littleThan(a, b, 0) ? -1 : 1;
	  });
	  var curr = -Infinity;
	  var currClose = 1;
	
	  for (var i = 0; i < list.length;) {
	    var interval = list[i].interval;
	    var close = list[i].close;
	
	    for (var lg = 0; lg < 2; lg++) {
	      if (interval[lg] <= curr) {
	        interval[lg] = curr;
	        close[lg] = !lg ? 1 - currClose : 1;
	      }
	
	      curr = interval[lg];
	      currClose = close[lg];
	    }
	
	    if (interval[0] === interval[1] && close[0] * close[1] !== 1) {
	      list.splice(i, 1);
	    } else {
	      i++;
	    }
	  }
	
	  return list;
	
	  function littleThan(a, b, lg) {
	    return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
	  }
	}
	/**
	 * parseFloat NaNs numeric-cast false positives (null|true|false|"")
	 * ...but misinterprets leading-number strings, particularly hex literals ("0x...")
	 * subtraction forces infinities to NaN
	 *
	 * @param {*} v
	 * @return {boolean}
	 */
	
	
	function isNumeric(v) {
	  return v - parseFloat(v) >= 0;
	}
	
	exports.linearMap = linearMap;
	exports.parsePercent = parsePercent;
	exports.round = round;
	exports.asc = asc;
	exports.getPrecision = getPrecision;
	exports.getPrecisionSafe = getPrecisionSafe;
	exports.getPixelPrecision = getPixelPrecision;
	exports.getPercentWithPrecision = getPercentWithPrecision;
	exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
	exports.remRadian = remRadian;
	exports.isRadianAroundZero = isRadianAroundZero;
	exports.parseDate = parseDate;
	exports.quantity = quantity;
	exports.quantityExponent = quantityExponent;
	exports.nice = nice;
	exports.quantile = quantile;
	exports.reformIntervals = reformIntervals;
	exports.isNumeric = isNumeric;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var textContain = __webpack_require__(255);
	
	var numberUtil = __webpack_require__(306);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import Text from 'zrender/src/graphic/Text';
	
	/**
	 * add commas after every three numbers
	 * @param {string|number} x
	 * @return {string}
	 */
	function addCommas(x) {
	  if (isNaN(x)) {
	    return '-';
	  }
	
	  x = (x + '').split('.');
	  return x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (x.length > 1 ? '.' + x[1] : '');
	}
	/**
	 * @param {string} str
	 * @param {boolean} [upperCaseFirst=false]
	 * @return {string} str
	 */
	
	
	function toCamelCase(str, upperCaseFirst) {
	  str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
	    return group1.toUpperCase();
	  });
	
	  if (upperCaseFirst && str) {
	    str = str.charAt(0).toUpperCase() + str.slice(1);
	  }
	
	  return str;
	}
	
	var normalizeCssArray = zrUtil.normalizeCssArray;
	var replaceReg = /([&<>"'])/g;
	var replaceMap = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  '\'': '&#39;'
	};
	
	function encodeHTML(source) {
	  return source == null ? '' : (source + '').replace(replaceReg, function (str, c) {
	    return replaceMap[c];
	  });
	}
	
	var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
	
	var wrapVar = function (varName, seriesIdx) {
	  return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
	};
	/**
	 * Template formatter
	 * @param {string} tpl
	 * @param {Array.<Object>|Object} paramsList
	 * @param {boolean} [encode=false]
	 * @return {string}
	 */
	
	
	function formatTpl(tpl, paramsList, encode) {
	  if (!zrUtil.isArray(paramsList)) {
	    paramsList = [paramsList];
	  }
	
	  var seriesLen = paramsList.length;
	
	  if (!seriesLen) {
	    return '';
	  }
	
	  var $vars = paramsList[0].$vars || [];
	
	  for (var i = 0; i < $vars.length; i++) {
	    var alias = TPL_VAR_ALIAS[i];
	    tpl = tpl.replace(wrapVar(alias), wrapVar(alias, 0));
	  }
	
	  for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
	    for (var k = 0; k < $vars.length; k++) {
	      var val = paramsList[seriesIdx][$vars[k]];
	      tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
	    }
	  }
	
	  return tpl;
	}
	/**
	 * simple Template formatter
	 *
	 * @param {string} tpl
	 * @param {Object} param
	 * @param {boolean} [encode=false]
	 * @return {string}
	 */
	
	
	function formatTplSimple(tpl, param, encode) {
	  zrUtil.each(param, function (value, key) {
	    tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
	  });
	  return tpl;
	}
	/**
	 * @param {Object|string} [opt] If string, means color.
	 * @param {string} [opt.color]
	 * @param {string} [opt.extraCssText]
	 * @param {string} [opt.type='item'] 'item' or 'subItem'
	 * @param {string} [opt.renderMode='html'] render mode of tooltip, 'html' or 'richText'
	 * @param {string} [opt.markerId='X'] id name for marker. If only one marker is in a rich text, this can be omitted.
	 * @return {string}
	 */
	
	
	function getTooltipMarker(opt, extraCssText) {
	  opt = zrUtil.isString(opt) ? {
	    color: opt,
	    extraCssText: extraCssText
	  } : opt || {};
	  var color = opt.color;
	  var type = opt.type;
	  var extraCssText = opt.extraCssText;
	  var renderMode = opt.renderMode || 'html';
	  var markerId = opt.markerId || 'X';
	
	  if (!color) {
	    return '';
	  }
	
	  if (renderMode === 'html') {
	    return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;' + 'border-radius:4px;width:4px;height:4px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:5px;' + 'border-radius:10px;width:10px;height:10px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>';
	  } else {
	    // Space for rich element marker
	    return {
	      renderMode: renderMode,
	      content: '{marker' + markerId + '|}  ',
	      style: {
	        color: color
	      }
	    };
	  }
	}
	
	function pad(str, len) {
	  str += '';
	  return '0000'.substr(0, len - str.length) + str;
	}
	/**
	 * ISO Date format
	 * @param {string} tpl
	 * @param {number} value
	 * @param {boolean} [isUTC=false] Default in local time.
	 *           see `module:echarts/scale/Time`
	 *           and `module:echarts/util/number#parseDate`.
	 * @inner
	 */
	
	
	function formatTime(tpl, value, isUTC) {
	  if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
	    tpl = 'MM-dd\nyyyy';
	  }
	
	  var date = numberUtil.parseDate(value);
	  var utc = isUTC ? 'UTC' : '';
	  var y = date['get' + utc + 'FullYear']();
	  var M = date['get' + utc + 'Month']() + 1;
	  var d = date['get' + utc + 'Date']();
	  var h = date['get' + utc + 'Hours']();
	  var m = date['get' + utc + 'Minutes']();
	  var s = date['get' + utc + 'Seconds']();
	  var S = date['get' + utc + 'Milliseconds']();
	  tpl = tpl.replace('MM', pad(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100).replace('dd', pad(d, 2)).replace('d', d).replace('hh', pad(h, 2)).replace('h', h).replace('mm', pad(m, 2)).replace('m', m).replace('ss', pad(s, 2)).replace('s', s).replace('SSS', pad(S, 3));
	  return tpl;
	}
	/**
	 * Capital first
	 * @param {string} str
	 * @return {string}
	 */
	
	
	function capitalFirst(str) {
	  return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
	}
	
	var truncateText = textContain.truncateText;
	/**
	 * @public
	 * @param {Object} opt
	 * @param {string} opt.text
	 * @param {string} opt.font
	 * @param {string} [opt.textAlign='left']
	 * @param {string} [opt.textVerticalAlign='top']
	 * @param {Array.<number>} [opt.textPadding]
	 * @param {number} [opt.textLineHeight]
	 * @param {Object} [opt.rich]
	 * @param {Object} [opt.truncate]
	 * @return {Object} {x, y, width, height, lineHeight}
	 */
	
	function getTextBoundingRect(opt) {
	  return textContain.getBoundingRect(opt.text, opt.font, opt.textAlign, opt.textVerticalAlign, opt.textPadding, opt.textLineHeight, opt.rich, opt.truncate);
	}
	/**
	 * @deprecated
	 * the `textLineHeight` was added later.
	 * For backward compatiblility, put it as the last parameter.
	 * But deprecated this interface. Please use `getTextBoundingRect` instead.
	 */
	
	
	function getTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate, textLineHeight) {
	  return textContain.getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate);
	}
	/**
	 * open new tab
	 * @param {string} link url
	 * @param {string} target blank or self
	 */
	
	
	function windowOpen(link, target) {
	  if (target === '_blank' || target === 'blank') {
	    var blank = window.open();
	    blank.opener = null;
	    blank.location = link;
	  } else {
	    window.open(link, target);
	  }
	}
	
	exports.addCommas = addCommas;
	exports.toCamelCase = toCamelCase;
	exports.normalizeCssArray = normalizeCssArray;
	exports.encodeHTML = encodeHTML;
	exports.formatTpl = formatTpl;
	exports.formatTplSimple = formatTplSimple;
	exports.getTooltipMarker = getTooltipMarker;
	exports.formatTime = formatTime;
	exports.capitalFirst = capitalFirst;
	exports.truncateText = truncateText;
	exports.getTextBoundingRect = getTextBoundingRect;
	exports.getTextRect = getTextRect;
	exports.windowOpen = windowOpen;

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = {
	  getBoxLayoutParams: function () {
	    return {
	      left: this.get('left'),
	      top: this.get('top'),
	      right: this.get('right'),
	      bottom: this.get('bottom'),
	      width: this.get('width'),
	      height: this.get('height')
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var platform = ''; // Navigator not exists in node
	
	if (typeof navigator !== 'undefined') {
	  platform = navigator.platform || '';
	}
	
	var _default = {
	  // backgroundColor: 'rgba(0,0,0,0)',
	  // https://dribbble.com/shots/1065960-Infographic-Pie-chart-visualization
	  // color: ['#5793f3', '#d14a61', '#fd9c35', '#675bba', '#fec42c', '#dd4444', '#d4df5a', '#cd4870'],
	  // Light colors:
	  // color: ['#bcd3bb', '#e88f70', '#edc1a5', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a'],
	  // color: ['#cc5664', '#9bd6ec', '#ea946e', '#8acaaa', '#f1ec64', '#ee8686', '#a48dc1', '#5da6bc', '#b9dcae'],
	  // Dark colors:
	  color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
	  gradientColor: ['#f6efa6', '#d88273', '#bf444c'],
	  // If xAxis and yAxis declared, grid is created by default.
	  // grid: {},
	  textStyle: {
	    // color: '#000',
	    // decoration: 'none',
	    // PENDING
	    fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
	    // fontFamily: 'Arial, Verdana, sans-serif',
	    fontSize: 12,
	    fontStyle: 'normal',
	    fontWeight: 'normal'
	  },
	  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
	  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	  // Default is source-over
	  blendMode: null,
	  animation: 'auto',
	  animationDuration: 1000,
	  animationDurationUpdate: 300,
	  animationEasing: 'exponentialOut',
	  animationEasingUpdate: 'cubicOut',
	  animationThreshold: 2000,
	  // Configuration for progressive/incremental rendering
	  progressiveThreshold: 3000,
	  progressive: 400,
	  // Threshold of if use single hover layer to optimize.
	  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
	  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
	  // which is unexpected.
	  // see example <echarts/test/heatmap-large.html>.
	  hoverLayerThreshold: 3000,
	  // See: module:echarts/scale/Time
	  useUTC: false
	};
	module.exports = _default;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _model = __webpack_require__(261);
	
	var makeInner = _model.makeInner;
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	
	function getNearestColorPalette(colors, requestColorNum) {
	  var paletteNum = colors.length; // TODO colors must be in order
	
	  for (var i = 0; i < paletteNum; i++) {
	    if (colors[i].length > requestColorNum) {
	      return colors[i];
	    }
	  }
	
	  return colors[paletteNum - 1];
	}
	
	var _default = {
	  clearColorPalette: function () {
	    inner(this).colorIdx = 0;
	    inner(this).colorNameMap = {};
	  },
	
	  /**
	   * @param {string} name MUST NOT be null/undefined. Otherwise call this function
	   *                 twise with the same parameters will get different result.
	   * @param {Object} [scope=this]
	   * @param {Object} [requestColorNum]
	   * @return {string} color string.
	   */
	  getColorFromPalette: function (name, scope, requestColorNum) {
	    scope = scope || this;
	    var scopeFields = inner(scope);
	    var colorIdx = scopeFields.colorIdx || 0;
	    var colorNameMap = scopeFields.colorNameMap = scopeFields.colorNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.
	
	    if (colorNameMap.hasOwnProperty(name)) {
	      return colorNameMap[name];
	    }
	
	    var defaultColorPalette = normalizeToArray(this.get('color', true));
	    var layeredColorPalette = this.get('colorLayer', true);
	    var colorPalette = requestColorNum == null || !layeredColorPalette ? defaultColorPalette : getNearestColorPalette(layeredColorPalette, requestColorNum); // In case can't find in layered color palette.
	
	    colorPalette = colorPalette || defaultColorPalette;
	
	    if (!colorPalette || !colorPalette.length) {
	      return;
	    }
	
	    var color = colorPalette[colorIdx];
	
	    if (name) {
	      colorNameMap[name] = color;
	    }
	
	    scopeFields.colorIdx = (colorIdx + 1) % colorPalette.length;
	    return color;
	  }
	};
	module.exports = _default;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var _model = __webpack_require__(261);
	
	var makeInner = _model.makeInner;
	var getDataItemValue = _model.getDataItemValue;
	
	var _util = __webpack_require__(220);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	var map = _util.map;
	var isArray = _util.isArray;
	var isString = _util.isString;
	var isObject = _util.isObject;
	var isTypedArray = _util.isTypedArray;
	var isArrayLike = _util.isArrayLike;
	var extend = _util.extend;
	var assert = _util.assert;
	
	var Source = __webpack_require__(312);
	
	var _sourceType = __webpack_require__(313);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
	var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;
	var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;
	var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SERIES_LAYOUT_BY_ROW = _sourceType.SERIES_LAYOUT_BY_ROW;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// The result of `guessOrdinal`.
	var BE_ORDINAL = {
	  Must: 1,
	  // Encounter string but not '-' and not number-like.
	  Might: 2,
	  // Encounter string but number-like.
	  Not: 3 // Other cases
	
	};
	var inner = makeInner();
	/**
	 * @see {module:echarts/data/Source}
	 * @param {module:echarts/component/dataset/DatasetModel} datasetModel
	 * @return {string} sourceFormat
	 */
	
	function detectSourceFormat(datasetModel) {
	  var data = datasetModel.option.source;
	  var sourceFormat = SOURCE_FORMAT_UNKNOWN;
	
	  if (isTypedArray(data)) {
	    sourceFormat = SOURCE_FORMAT_TYPED_ARRAY;
	  } else if (isArray(data)) {
	    // FIXME Whether tolerate null in top level array?
	    if (data.length === 0) {
	      sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
	    }
	
	    for (var i = 0, len = data.length; i < len; i++) {
	      var item = data[i];
	
	      if (item == null) {
	        continue;
	      } else if (isArray(item)) {
	        sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
	        break;
	      } else if (isObject(item)) {
	        sourceFormat = SOURCE_FORMAT_OBJECT_ROWS;
	        break;
	      }
	    }
	  } else if (isObject(data)) {
	    for (var key in data) {
	      if (data.hasOwnProperty(key) && isArrayLike(data[key])) {
	        sourceFormat = SOURCE_FORMAT_KEYED_COLUMNS;
	        break;
	      }
	    }
	  } else if (data != null) {
	    throw new Error('Invalid data');
	  }
	
	  inner(datasetModel).sourceFormat = sourceFormat;
	}
	/**
	 * [Scenarios]:
	 * (1) Provide source data directly:
	 *     series: {
	 *         encode: {...},
	 *         dimensions: [...]
	 *         seriesLayoutBy: 'row',
	 *         data: [[...]]
	 *     }
	 * (2) Refer to datasetModel.
	 *     series: [{
	 *         encode: {...}
	 *         // Ignore datasetIndex means `datasetIndex: 0`
	 *         // and the dimensions defination in dataset is used
	 *     }, {
	 *         encode: {...},
	 *         seriesLayoutBy: 'column',
	 *         datasetIndex: 1
	 *     }]
	 *
	 * Get data from series itself or datset.
	 * @return {module:echarts/data/Source} source
	 */
	
	
	function getSource(seriesModel) {
	  return inner(seriesModel).source;
	}
	/**
	 * MUST be called before mergeOption of all series.
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function resetSourceDefaulter(ecModel) {
	  // `datasetMap` is used to make default encode.
	  inner(ecModel).datasetMap = createHashMap();
	}
	/**
	 * [Caution]:
	 * MUST be called after series option merged and
	 * before "series.getInitailData()" called.
	 *
	 * [The rule of making default encode]:
	 * Category axis (if exists) alway map to the first dimension.
	 * Each other axis occupies a subsequent dimension.
	 *
	 * [Why make default encode]:
	 * Simplify the typing of encode in option, avoiding the case like that:
	 * series: [{encode: {x: 0, y: 1}}, {encode: {x: 0, y: 2}}, {encode: {x: 0, y: 3}}],
	 * where the "y" have to be manually typed as "1, 2, 3, ...".
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 */
	
	
	function prepareSource(seriesModel) {
	  var seriesOption = seriesModel.option;
	  var data = seriesOption.data;
	  var sourceFormat = isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL;
	  var fromDataset = false;
	  var seriesLayoutBy = seriesOption.seriesLayoutBy;
	  var sourceHeader = seriesOption.sourceHeader;
	  var dimensionsDefine = seriesOption.dimensions;
	  var datasetModel = getDatasetModel(seriesModel);
	
	  if (datasetModel) {
	    var datasetOption = datasetModel.option;
	    data = datasetOption.source;
	    sourceFormat = inner(datasetModel).sourceFormat;
	    fromDataset = true; // These settings from series has higher priority.
	
	    seriesLayoutBy = seriesLayoutBy || datasetOption.seriesLayoutBy;
	    sourceHeader == null && (sourceHeader = datasetOption.sourceHeader);
	    dimensionsDefine = dimensionsDefine || datasetOption.dimensions;
	  }
	
	  var completeResult = completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine);
	  inner(seriesModel).source = new Source({
	    data: data,
	    fromDataset: fromDataset,
	    seriesLayoutBy: seriesLayoutBy,
	    sourceFormat: sourceFormat,
	    dimensionsDefine: completeResult.dimensionsDefine,
	    startIndex: completeResult.startIndex,
	    dimensionsDetectCount: completeResult.dimensionsDetectCount,
	    // Note: dataset option does not have `encode`.
	    encodeDefine: seriesOption.encode
	  });
	} // return {startIndex, dimensionsDefine, dimensionsCount}
	
	
	function completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine) {
	  if (!data) {
	    return {
	      dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine)
	    };
	  }
	
	  var dimensionsDetectCount;
	  var startIndex;
	
	  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	    // Rule: Most of the first line are string: it is header.
	    // Caution: consider a line with 5 string and 1 number,
	    // it still can not be sure it is a head, because the
	    // 5 string may be 5 values of category columns.
	    if (sourceHeader === 'auto' || sourceHeader == null) {
	      arrayRowsTravelFirst(function (val) {
	        // '-' is regarded as null/undefined.
	        if (val != null && val !== '-') {
	          if (isString(val)) {
	            startIndex == null && (startIndex = 1);
	          } else {
	            startIndex = 0;
	          }
	        } // 10 is an experience number, avoid long loop.
	
	      }, seriesLayoutBy, data, 10);
	    } else {
	      startIndex = sourceHeader ? 1 : 0;
	    }
	
	    if (!dimensionsDefine && startIndex === 1) {
	      dimensionsDefine = [];
	      arrayRowsTravelFirst(function (val, index) {
	        dimensionsDefine[index] = val != null ? val : '';
	      }, seriesLayoutBy, data);
	    }
	
	    dimensionsDetectCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === SERIES_LAYOUT_BY_ROW ? data.length : data[0] ? data[0].length : null;
	  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	    if (!dimensionsDefine) {
	      dimensionsDefine = objectRowsCollectDimensions(data);
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    if (!dimensionsDefine) {
	      dimensionsDefine = [];
	      each(data, function (colArr, key) {
	        dimensionsDefine.push(key);
	      });
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    var value0 = getDataItemValue(data[0]);
	    dimensionsDetectCount = isArray(value0) && value0.length || 1;
	  } else if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {}
	
	  return {
	    startIndex: startIndex,
	    dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine),
	    dimensionsDetectCount: dimensionsDetectCount
	  };
	} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
	// which is reasonable. But dimension name is duplicated.
	// Returns undefined or an array contains only object without null/undefiend or string.
	
	
	function normalizeDimensionsDefine(dimensionsDefine) {
	  if (!dimensionsDefine) {
	    // The meaning of null/undefined is different from empty array.
	    return;
	  }
	
	  var nameMap = createHashMap();
	  return map(dimensionsDefine, function (item, index) {
	    item = extend({}, isObject(item) ? item : {
	      name: item
	    }); // User can set null in dimensions.
	    // We dont auto specify name, othewise a given name may
	    // cause it be refered unexpectedly.
	
	    if (item.name == null) {
	      return item;
	    } // Also consider number form like 2012.
	
	
	    item.name += ''; // User may also specify displayName.
	    // displayName will always exists except user not
	    // specified or dim name is not specified or detected.
	    // (A auto generated dim name will not be used as
	    // displayName).
	
	    if (item.displayName == null) {
	      item.displayName = item.name;
	    }
	
	    var exist = nameMap.get(item.name);
	
	    if (!exist) {
	      nameMap.set(item.name, {
	        count: 1
	      });
	    } else {
	      item.name += '-' + exist.count++;
	    }
	
	    return item;
	  });
	}
	
	function arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
	  maxLoop == null && (maxLoop = Infinity);
	
	  if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      cb(data[i] ? data[i][0] : null, i);
	    }
	  } else {
	    var value0 = data[0] || [];
	
	    for (var i = 0; i < value0.length && i < maxLoop; i++) {
	      cb(value0[i], i);
	    }
	  }
	}
	
	function objectRowsCollectDimensions(data) {
	  var firstIndex = 0;
	  var obj;
	
	  while (firstIndex < data.length && !(obj = data[firstIndex++])) {} // jshint ignore: line
	
	
	  if (obj) {
	    var dimensions = [];
	    each(obj, function (value, key) {
	      dimensions.push(key);
	    });
	    return dimensions;
	  }
	}
	/**
	 * [The strategy of the arrengment of data dimensions for dataset]:
	 * "value way": all axes are non-category axes. So series one by one take
	 *     several (the number is coordSysDims.length) dimensions from dataset.
	 *     The result of data arrengment of data dimensions like:
	 *     | ser0_x | ser0_y | ser1_x | ser1_y | ser2_x | ser2_y |
	 * "category way": at least one axis is category axis. So the the first data
	 *     dimension is always mapped to the first category axis and shared by
	 *     all of the series. The other data dimensions are taken by series like
	 *     "value way" does.
	 *     The result of data arrengment of data dimensions like:
	 *     | ser_shared_x | ser0_y | ser1_y | ser2_y |
	 *
	 * @param {Array.<Object|string>} coordDimensions [{name: <string>, type: <string>, dimsDef: <Array>}, ...]
	 * @param {module:model/Series} seriesModel
	 * @param {module:data/Source} source
	 * @return {Object} encode Never be `null/undefined`.
	 */
	
	
	function makeSeriesEncodeForAxisCoordSys(coordDimensions, seriesModel, source) {
	  var encode = {};
	  var datasetModel = getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
	
	  if (!datasetModel || !coordDimensions) {
	    return encode;
	  }
	
	  var encodeItemName = [];
	  var encodeSeriesName = [];
	  var ecModel = seriesModel.ecModel;
	  var datasetMap = inner(ecModel).datasetMap;
	  var key = datasetModel.uid + '_' + source.seriesLayoutBy;
	  var baseCategoryDimIndex;
	  var categoryWayValueDimStart;
	  coordDimensions = coordDimensions.slice();
	  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
	    !isObject(coordDimInfo) && (coordDimensions[coordDimIdx] = {
	      name: coordDimInfo
	    });
	
	    if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
	      baseCategoryDimIndex = coordDimIdx;
	      categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimensions[coordDimIdx]);
	    }
	
	    encode[coordDimInfo.name] = [];
	  });
	  var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
	    categoryWayDim: categoryWayValueDimStart,
	    valueWayDim: 0
	  }); // TODO
	  // Auto detect first time axis and do arrangement.
	
	  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
	    var coordDimName = coordDimInfo.name;
	    var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.
	
	    if (baseCategoryDimIndex == null) {
	      var start = datasetRecord.valueWayDim;
	      pushDim(encode[coordDimName], start, count);
	      pushDim(encodeSeriesName, start, count);
	      datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
	      // especially when encode x y specified.
	      // consider: when mutiple series share one dimension
	      // category axis, series name should better use
	      // the other dimsion name. On the other hand, use
	      // both dimensions name.
	    } // In category way, the first category axis.
	    else if (baseCategoryDimIndex === coordDimIdx) {
	        pushDim(encode[coordDimName], 0, count);
	        pushDim(encodeItemName, 0, count);
	      } // In category way, the other axis.
	      else {
	          var start = datasetRecord.categoryWayDim;
	          pushDim(encode[coordDimName], start, count);
	          pushDim(encodeSeriesName, start, count);
	          datasetRecord.categoryWayDim += count;
	        }
	  });
	
	  function pushDim(dimIdxArr, idxFrom, idxCount) {
	    for (var i = 0; i < idxCount; i++) {
	      dimIdxArr.push(idxFrom + i);
	    }
	  }
	
	  function getDataDimCountOnCoordDim(coordDimInfo) {
	    var dimsDef = coordDimInfo.dimsDef;
	    return dimsDef ? dimsDef.length : 1;
	  }
	
	  encodeItemName.length && (encode.itemName = encodeItemName);
	  encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
	  return encode;
	}
	/**
	 * Work for data like [{name: ..., value: ...}, ...].
	 *
	 * @param {module:model/Series} seriesModel
	 * @param {module:data/Source} source
	 * @return {Object} encode Never be `null/undefined`.
	 */
	
	
	function makeSeriesEncodeForNameBased(seriesModel, source, dimCount) {
	  var encode = {};
	  var datasetModel = getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
	
	  if (!datasetModel) {
	    return encode;
	  }
	
	  var sourceFormat = source.sourceFormat;
	  var dimensionsDefine = source.dimensionsDefine;
	  var potentialNameDimIndex;
	
	  if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS || sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    each(dimensionsDefine, function (dim, idx) {
	      if ((isObject(dim) ? dim.name : dim) === 'name') {
	        potentialNameDimIndex = idx;
	      }
	    });
	  } // idxResult: {v, n}.
	
	
	  var idxResult = function () {
	    var idxRes0 = {};
	    var idxRes1 = {};
	    var guessRecords = []; // 5 is an experience value.
	
	    for (var i = 0, len = Math.min(5, dimCount); i < len; i++) {
	      var guessResult = doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
	      guessRecords.push(guessResult);
	      var isPureNumber = guessResult === BE_ORDINAL.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
	      // and then find a name dim with the priority:
	      // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
	
	      if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) {
	        idxRes0.v = i;
	      }
	
	      if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === BE_ORDINAL.Not) {
	        idxRes0.n = i;
	      }
	
	      if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== BE_ORDINAL.Not) {
	        return idxRes0;
	      } // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
	      // find the first BE_ORDINAL.Might as the value dim,
	      // and then find a name dim with the priority:
	      // "other dim" > "the value dim itself".
	      // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
	      // treated as number.
	
	
	      if (!isPureNumber) {
	        if (guessResult === BE_ORDINAL.Might && idxRes1.v == null && i !== potentialNameDimIndex) {
	          idxRes1.v = i;
	        }
	
	        if (idxRes1.n == null || idxRes1.n === idxRes1.v) {
	          idxRes1.n = i;
	        }
	      }
	    }
	
	    function fulfilled(idxResult) {
	      return idxResult.v != null && idxResult.n != null;
	    }
	
	    return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
	  }();
	
	  if (idxResult) {
	    encode.value = idxResult.v; // `potentialNameDimIndex` has highest priority.
	
	    var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label use itemName in charts.
	    // So we dont set encodeLabel here.
	
	    encode.itemName = [nameDimIndex];
	    encode.seriesName = [nameDimIndex];
	  }
	
	  return encode;
	}
	/**
	 * If return null/undefined, indicate that should not use datasetModel.
	 */
	
	
	function getDatasetModel(seriesModel) {
	  var option = seriesModel.option; // Caution: consider the scenario:
	  // A dataset is declared and a series is not expected to use the dataset,
	  // and at the beginning `setOption({series: { noData })` (just prepare other
	  // option but no data), then `setOption({series: {data: [...]}); In this case,
	  // the user should set an empty array to avoid that dataset is used by default.
	
	  var thisData = option.data;
	
	  if (!thisData) {
	    return seriesModel.ecModel.getComponent('dataset', option.datasetIndex || 0);
	  }
	}
	/**
	 * The rule should not be complex, otherwise user might not
	 * be able to known where the data is wrong.
	 * The code is ugly, but how to make it neat?
	 *
	 * @param {module:echars/data/Source} source
	 * @param {number} dimIndex
	 * @return {BE_ORDINAL} guess result.
	 */
	
	
	function guessOrdinal(source, dimIndex) {
	  return doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
	} // dimIndex may be overflow source data.
	// return {BE_ORDINAL}
	
	
	function doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
	  var result; // Experience value.
	
	  var maxLoop = 5;
	
	  if (isTypedArray(data)) {
	    return BE_ORDINAL.Not;
	  } // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
	  // always exists in source.
	
	
	  var dimName;
	  var dimType;
	
	  if (dimensionsDefine) {
	    var dimDefItem = dimensionsDefine[dimIndex];
	
	    if (isObject(dimDefItem)) {
	      dimName = dimDefItem.name;
	      dimType = dimDefItem.type;
	    } else if (isString(dimDefItem)) {
	      dimName = dimDefItem;
	    }
	  }
	
	  if (dimType != null) {
	    return dimType === 'ordinal' ? BE_ORDINAL.Must : BE_ORDINAL.Not;
	  }
	
	  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	    if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
	      var sample = data[dimIndex];
	
	      for (var i = 0; i < (sample || []).length && i < maxLoop; i++) {
	        if ((result = detectValue(sample[startIndex + i])) != null) {
	          return result;
	        }
	      }
	    } else {
	      for (var i = 0; i < data.length && i < maxLoop; i++) {
	        var row = data[startIndex + i];
	
	        if (row && (result = detectValue(row[dimIndex])) != null) {
	          return result;
	        }
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	    if (!dimName) {
	      return BE_ORDINAL.Not;
	    }
	
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      var item = data[i];
	
	      if (item && (result = detectValue(item[dimName])) != null) {
	        return result;
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    if (!dimName) {
	      return BE_ORDINAL.Not;
	    }
	
	    var sample = data[dimName];
	
	    if (!sample || isTypedArray(sample)) {
	      return BE_ORDINAL.Not;
	    }
	
	    for (var i = 0; i < sample.length && i < maxLoop; i++) {
	      if ((result = detectValue(sample[i])) != null) {
	        return result;
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      var item = data[i];
	      var val = getDataItemValue(item);
	
	      if (!isArray(val)) {
	        return BE_ORDINAL.Not;
	      }
	
	      if ((result = detectValue(val[dimIndex])) != null) {
	        return result;
	      }
	    }
	  }
	
	  function detectValue(val) {
	    var beStr = isString(val); // Consider usage convenience, '1', '2' will be treated as "number".
	    // `isFinit('')` get `true`.
	
	    if (val != null && isFinite(val) && val !== '') {
	      return beStr ? BE_ORDINAL.Might : BE_ORDINAL.Not;
	    } else if (beStr && val !== '-') {
	      return BE_ORDINAL.Must;
	    }
	  }
	
	  return BE_ORDINAL.Not;
	}
	
	exports.BE_ORDINAL = BE_ORDINAL;
	exports.detectSourceFormat = detectSourceFormat;
	exports.getSource = getSource;
	exports.resetSourceDefaulter = resetSourceDefaulter;
	exports.prepareSource = prepareSource;
	exports.makeSeriesEncodeForAxisCoordSys = makeSeriesEncodeForAxisCoordSys;
	exports.makeSeriesEncodeForNameBased = makeSeriesEncodeForNameBased;
	exports.guessOrdinal = guessOrdinal;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var createHashMap = _util.createHashMap;
	var isTypedArray = _util.isTypedArray;
	
	var _clazz = __webpack_require__(263);
	
	var enableClassCheck = _clazz.enableClassCheck;
	
	var _sourceType = __webpack_require__(313);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;
	var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [sourceFormat]
	 *
	 * + "original":
	 * This format is only used in series.data, where
	 * itemStyle can be specified in data item.
	 *
	 * + "arrayRows":
	 * [
	 *     ['product', 'score', 'amount'],
	 *     ['Matcha Latte', 89.3, 95.8],
	 *     ['Milk Tea', 92.1, 89.4],
	 *     ['Cheese Cocoa', 94.4, 91.2],
	 *     ['Walnut Brownie', 85.4, 76.9]
	 * ]
	 *
	 * + "objectRows":
	 * [
	 *     {product: 'Matcha Latte', score: 89.3, amount: 95.8},
	 *     {product: 'Milk Tea', score: 92.1, amount: 89.4},
	 *     {product: 'Cheese Cocoa', score: 94.4, amount: 91.2},
	 *     {product: 'Walnut Brownie', score: 85.4, amount: 76.9}
	 * ]
	 *
	 * + "keyedColumns":
	 * {
	 *     'product': ['Matcha Latte', 'Milk Tea', 'Cheese Cocoa', 'Walnut Brownie'],
	 *     'count': [823, 235, 1042, 988],
	 *     'score': [95.8, 81.4, 91.2, 76.9]
	 * }
	 *
	 * + "typedArray"
	 *
	 * + "unknown"
	 */
	
	/**
	 * @constructor
	 * @param {Object} fields
	 * @param {string} fields.sourceFormat
	 * @param {Array|Object} fields.fromDataset
	 * @param {Array|Object} [fields.data]
	 * @param {string} [seriesLayoutBy='column']
	 * @param {Array.<Object|string>} [dimensionsDefine]
	 * @param {Objet|HashMap} [encodeDefine]
	 * @param {number} [startIndex=0]
	 * @param {number} [dimensionsDetectCount]
	 */
	function Source(fields) {
	  /**
	   * @type {boolean}
	   */
	  this.fromDataset = fields.fromDataset;
	  /**
	   * Not null/undefined.
	   * @type {Array|Object}
	   */
	
	  this.data = fields.data || (fields.sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS ? {} : []);
	  /**
	   * See also "detectSourceFormat".
	   * Not null/undefined.
	   * @type {string}
	   */
	
	  this.sourceFormat = fields.sourceFormat || SOURCE_FORMAT_UNKNOWN;
	  /**
	   * 'row' or 'column'
	   * Not null/undefined.
	   * @type {string} seriesLayoutBy
	   */
	
	  this.seriesLayoutBy = fields.seriesLayoutBy || SERIES_LAYOUT_BY_COLUMN;
	  /**
	   * dimensions definition in option.
	   * can be null/undefined.
	   * @type {Array.<Object|string>}
	   */
	
	  this.dimensionsDefine = fields.dimensionsDefine;
	  /**
	   * encode definition in option.
	   * can be null/undefined.
	   * @type {Objet|HashMap}
	   */
	
	  this.encodeDefine = fields.encodeDefine && createHashMap(fields.encodeDefine);
	  /**
	   * Not null/undefined, uint.
	   * @type {number}
	   */
	
	  this.startIndex = fields.startIndex || 0;
	  /**
	   * Can be null/undefined (when unknown), uint.
	   * @type {number}
	   */
	
	  this.dimensionsDetectCount = fields.dimensionsDetectCount;
	}
	/**
	 * Wrap original series data for some compatibility cases.
	 */
	
	
	Source.seriesDataToSource = function (data) {
	  return new Source({
	    data: data,
	    sourceFormat: isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL,
	    fromDataset: false
	  });
	};
	
	enableClassCheck(Source);
	var _default = Source;
	module.exports = _default;

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Avoid typo.
	var SOURCE_FORMAT_ORIGINAL = 'original';
	var SOURCE_FORMAT_ARRAY_ROWS = 'arrayRows';
	var SOURCE_FORMAT_OBJECT_ROWS = 'objectRows';
	var SOURCE_FORMAT_KEYED_COLUMNS = 'keyedColumns';
	var SOURCE_FORMAT_UNKNOWN = 'unknown'; // ??? CHANGE A NAME
	
	var SOURCE_FORMAT_TYPED_ARRAY = 'typedArray';
	var SERIES_LAYOUT_BY_COLUMN = 'column';
	var SERIES_LAYOUT_BY_ROW = 'row';
	exports.SOURCE_FORMAT_ORIGINAL = SOURCE_FORMAT_ORIGINAL;
	exports.SOURCE_FORMAT_ARRAY_ROWS = SOURCE_FORMAT_ARRAY_ROWS;
	exports.SOURCE_FORMAT_OBJECT_ROWS = SOURCE_FORMAT_OBJECT_ROWS;
	exports.SOURCE_FORMAT_KEYED_COLUMNS = SOURCE_FORMAT_KEYED_COLUMNS;
	exports.SOURCE_FORMAT_UNKNOWN = SOURCE_FORMAT_UNKNOWN;
	exports.SOURCE_FORMAT_TYPED_ARRAY = SOURCE_FORMAT_TYPED_ARRAY;
	exports.SERIES_LAYOUT_BY_COLUMN = SERIES_LAYOUT_BY_COLUMN;
	exports.SERIES_LAYOUT_BY_ROW = SERIES_LAYOUT_BY_ROW;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var echartsAPIList = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', 'getModel', 'getOption', 'getViewOfComponentModel', 'getViewOfSeriesModel']; // And `getCoordinateSystems` and `getComponentByElement` will be injected in echarts.js
	
	function ExtensionAPI(chartInstance) {
	  zrUtil.each(echartsAPIList, function (name) {
	    this[name] = zrUtil.bind(chartInstance[name], chartInstance);
	  }, this);
	}
	
	var _default = ExtensionAPI;
	module.exports = _default;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var coordinateSystemCreators = {};
	
	function CoordinateSystemManager() {
	  this._coordinateSystems = [];
	}
	
	CoordinateSystemManager.prototype = {
	  constructor: CoordinateSystemManager,
	  create: function (ecModel, api) {
	    var coordinateSystems = [];
	    zrUtil.each(coordinateSystemCreators, function (creater, type) {
	      var list = creater.create(ecModel, api);
	      coordinateSystems = coordinateSystems.concat(list || []);
	    });
	    this._coordinateSystems = coordinateSystems;
	  },
	  update: function (ecModel, api) {
	    zrUtil.each(this._coordinateSystems, function (coordSys) {
	      coordSys.update && coordSys.update(ecModel, api);
	    });
	  },
	  getCoordinateSystems: function () {
	    return this._coordinateSystems.slice();
	  }
	};
	
	CoordinateSystemManager.register = function (type, coordinateSystemCreator) {
	  coordinateSystemCreators[type] = coordinateSystemCreator;
	};
	
	CoordinateSystemManager.get = function (type) {
	  return coordinateSystemCreators[type];
	};
	
	var _default = CoordinateSystemManager;
	module.exports = _default;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var modelUtil = __webpack_require__(261);
	
	var ComponentModel = __webpack_require__(303);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * ECharts option manager
	 *
	 * @module {echarts/model/OptionManager}
	 */
	var each = zrUtil.each;
	var clone = zrUtil.clone;
	var map = zrUtil.map;
	var merge = zrUtil.merge;
	var QUERY_REG = /^(min|max)?(.+)$/;
	/**
	 * TERM EXPLANATIONS:
	 *
	 * [option]:
	 *
	 *     An object that contains definitions of components. For example:
	 *     var option = {
	 *         title: {...},
	 *         legend: {...},
	 *         visualMap: {...},
	 *         series: [
	 *             {data: [...]},
	 *             {data: [...]},
	 *             ...
	 *         ]
	 *     };
	 *
	 * [rawOption]:
	 *
	 *     An object input to echarts.setOption. 'rawOption' may be an
	 *     'option', or may be an object contains multi-options. For example:
	 *     var option = {
	 *         baseOption: {
	 *             title: {...},
	 *             legend: {...},
	 *             series: [
	 *                 {data: [...]},
	 *                 {data: [...]},
	 *                 ...
	 *             ]
	 *         },
	 *         timeline: {...},
	 *         options: [
	 *             {title: {...}, series: {data: [...]}},
	 *             {title: {...}, series: {data: [...]}},
	 *             ...
	 *         ],
	 *         media: [
	 *             {
	 *                 query: {maxWidth: 320},
	 *                 option: {series: {x: 20}, visualMap: {show: false}}
	 *             },
	 *             {
	 *                 query: {minWidth: 320, maxWidth: 720},
	 *                 option: {series: {x: 500}, visualMap: {show: true}}
	 *             },
	 *             {
	 *                 option: {series: {x: 1200}, visualMap: {show: true}}
	 *             }
	 *         ]
	 *     };
	 *
	 * @alias module:echarts/model/OptionManager
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	function OptionManager(api) {
	  /**
	   * @private
	   * @type {module:echarts/ExtensionAPI}
	   */
	  this._api = api;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._timelineOptions = [];
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	
	  this._mediaList = [];
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._mediaDefault;
	  /**
	   * -1, means default.
	   * empty means no media.
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._currentMediaIndices = [];
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._optionBackup;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._newBaseOption;
	} // timeline.notMerge is not supported in ec3. Firstly there is rearly
	// case that notMerge is needed. Secondly supporting 'notMerge' requires
	// rawOption cloned and backuped when timeline changed, which does no
	// good to performance. What's more, that both timeline and setOption
	// method supply 'notMerge' brings complex and some problems.
	// Consider this case:
	// (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
	// (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
	
	
	OptionManager.prototype = {
	  constructor: OptionManager,
	
	  /**
	   * @public
	   * @param {Object} rawOption Raw option.
	   * @param {module:echarts/model/Global} ecModel
	   * @param {Array.<Function>} optionPreprocessorFuncs
	   * @return {Object} Init option
	   */
	  setOption: function (rawOption, optionPreprocessorFuncs) {
	    if (rawOption) {
	      // That set dat primitive is dangerous if user reuse the data when setOption again.
	      zrUtil.each(modelUtil.normalizeToArray(rawOption.series), function (series) {
	        series && series.data && zrUtil.isTypedArray(series.data) && zrUtil.setAsPrimitive(series.data);
	      });
	    } // Caution: some series modify option data, if do not clone,
	    // it should ensure that the repeat modify correctly
	    // (create a new object when modify itself).
	
	
	    rawOption = clone(rawOption); // FIXME
	    // 如果 timeline options 或者 media 中设置了某个属性，而baseOption中没有设置，则进行警告。
	
	    var oldOptionBackup = this._optionBackup;
	    var newParsedOption = parseRawOption.call(this, rawOption, optionPreprocessorFuncs, !oldOptionBackup);
	    this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);
	
	    if (oldOptionBackup) {
	      // Only baseOption can be merged.
	      mergeOption(oldOptionBackup.baseOption, newParsedOption.baseOption); // For simplicity, timeline options and media options do not support merge,
	      // that is, if you `setOption` twice and both has timeline options, the latter
	      // timeline opitons will not be merged to the formers, but just substitude them.
	
	      if (newParsedOption.timelineOptions.length) {
	        oldOptionBackup.timelineOptions = newParsedOption.timelineOptions;
	      }
	
	      if (newParsedOption.mediaList.length) {
	        oldOptionBackup.mediaList = newParsedOption.mediaList;
	      }
	
	      if (newParsedOption.mediaDefault) {
	        oldOptionBackup.mediaDefault = newParsedOption.mediaDefault;
	      }
	    } else {
	      this._optionBackup = newParsedOption;
	    }
	  },
	
	  /**
	   * @param {boolean} isRecreate
	   * @return {Object}
	   */
	  mountOption: function (isRecreate) {
	    var optionBackup = this._optionBackup; // TODO
	    // 如果没有reset功能则不clone。
	
	    this._timelineOptions = map(optionBackup.timelineOptions, clone);
	    this._mediaList = map(optionBackup.mediaList, clone);
	    this._mediaDefault = clone(optionBackup.mediaDefault);
	    this._currentMediaIndices = [];
	    return clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
	    // called, and is merged into every new option by inner method `mergeOption`
	    // each time `setOption` called, can be only used in `isRecreate`, because
	    // its reliability is under suspicion. In other cases option merge is
	    // performed by `model.mergeOption`.
	    ? optionBackup.baseOption : this._newBaseOption);
	  },
	
	  /**
	   * @param {module:echarts/model/Global} ecModel
	   * @return {Object}
	   */
	  getTimelineOption: function (ecModel) {
	    var option;
	    var timelineOptions = this._timelineOptions;
	
	    if (timelineOptions.length) {
	      // getTimelineOption can only be called after ecModel inited,
	      // so we can get currentIndex from timelineModel.
	      var timelineModel = ecModel.getComponent('timeline');
	
	      if (timelineModel) {
	        option = clone(timelineOptions[timelineModel.getCurrentIndex()], true);
	      }
	    }
	
	    return option;
	  },
	
	  /**
	   * @param {module:echarts/model/Global} ecModel
	   * @return {Array.<Object>}
	   */
	  getMediaOption: function (ecModel) {
	    var ecWidth = this._api.getWidth();
	
	    var ecHeight = this._api.getHeight();
	
	    var mediaList = this._mediaList;
	    var mediaDefault = this._mediaDefault;
	    var indices = [];
	    var result = []; // No media defined.
	
	    if (!mediaList.length && !mediaDefault) {
	      return result;
	    } // Multi media may be applied, the latter defined media has higher priority.
	
	
	    for (var i = 0, len = mediaList.length; i < len; i++) {
	      if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
	        indices.push(i);
	      }
	    } // FIXME
	    // 是否mediaDefault应该强制用户设置，否则可能修改不能回归。
	
	
	    if (!indices.length && mediaDefault) {
	      indices = [-1];
	    }
	
	    if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
	      result = map(indices, function (index) {
	        return clone(index === -1 ? mediaDefault.option : mediaList[index].option);
	      });
	    } // Otherwise return nothing.
	
	
	    this._currentMediaIndices = indices;
	    return result;
	  }
	};
	
	function parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
	  var timelineOptions = [];
	  var mediaList = [];
	  var mediaDefault;
	  var baseOption; // Compatible with ec2.
	
	  var timelineOpt = rawOption.timeline;
	
	  if (rawOption.baseOption) {
	    baseOption = rawOption.baseOption;
	  } // For timeline
	
	
	  if (timelineOpt || rawOption.options) {
	    baseOption = baseOption || {};
	    timelineOptions = (rawOption.options || []).slice();
	  } // For media query
	
	
	  if (rawOption.media) {
	    baseOption = baseOption || {};
	    var media = rawOption.media;
	    each(media, function (singleMedia) {
	      if (singleMedia && singleMedia.option) {
	        if (singleMedia.query) {
	          mediaList.push(singleMedia);
	        } else if (!mediaDefault) {
	          // Use the first media default.
	          mediaDefault = singleMedia;
	        }
	      }
	    });
	  } // For normal option
	
	
	  if (!baseOption) {
	    baseOption = rawOption;
	  } // Set timelineOpt to baseOption in ec3,
	  // which is convenient for merge option.
	
	
	  if (!baseOption.timeline) {
	    baseOption.timeline = timelineOpt;
	  } // Preprocess.
	
	
	  each([baseOption].concat(timelineOptions).concat(zrUtil.map(mediaList, function (media) {
	    return media.option;
	  })), function (option) {
	    each(optionPreprocessorFuncs, function (preProcess) {
	      preProcess(option, isNew);
	    });
	  });
	  return {
	    baseOption: baseOption,
	    timelineOptions: timelineOptions,
	    mediaDefault: mediaDefault,
	    mediaList: mediaList
	  };
	}
	/**
	 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
	 * Support: width, height, aspectRatio
	 * Can use max or min as prefix.
	 */
	
	
	function applyMediaQuery(query, ecWidth, ecHeight) {
	  var realMap = {
	    width: ecWidth,
	    height: ecHeight,
	    aspectratio: ecWidth / ecHeight // lowser case for convenientce.
	
	  };
	  var applicatable = true;
	  zrUtil.each(query, function (value, attr) {
	    var matched = attr.match(QUERY_REG);
	
	    if (!matched || !matched[1] || !matched[2]) {
	      return;
	    }
	
	    var operator = matched[1];
	    var realAttr = matched[2].toLowerCase();
	
	    if (!compare(realMap[realAttr], value, operator)) {
	      applicatable = false;
	    }
	  });
	  return applicatable;
	}
	
	function compare(real, expect, operator) {
	  if (operator === 'min') {
	    return real >= expect;
	  } else if (operator === 'max') {
	    return real <= expect;
	  } else {
	    // Equals
	    return real === expect;
	  }
	}
	
	function indicesEquals(indices1, indices2) {
	  // indices is always order by asc and has only finite number.
	  return indices1.join(',') === indices2.join(',');
	}
	/**
	 * Consider case:
	 * `chart.setOption(opt1);`
	 * Then user do some interaction like dataZoom, dataView changing.
	 * `chart.setOption(opt2);`
	 * Then user press 'reset button' in toolbox.
	 *
	 * After doing that all of the interaction effects should be reset, the
	 * chart should be the same as the result of invoke
	 * `chart.setOption(opt1); chart.setOption(opt2);`.
	 *
	 * Although it is not able ensure that
	 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
	 * `chart.setOption(merge(opt1, opt2));` exactly,
	 * this might be the only simple way to implement that feature.
	 *
	 * MEMO: We've considered some other approaches:
	 * 1. Each model handle its self restoration but not uniform treatment.
	 *     (Too complex in logic and error-prone)
	 * 2. Use a shadow ecModel. (Performace expensive)
	 */
	
	
	function mergeOption(oldOption, newOption) {
	  newOption = newOption || {};
	  each(newOption, function (newCptOpt, mainType) {
	    if (newCptOpt == null) {
	      return;
	    }
	
	    var oldCptOpt = oldOption[mainType];
	
	    if (!ComponentModel.hasClass(mainType)) {
	      oldOption[mainType] = merge(oldCptOpt, newCptOpt, true);
	    } else {
	      newCptOpt = modelUtil.normalizeToArray(newCptOpt);
	      oldCptOpt = modelUtil.normalizeToArray(oldCptOpt);
	      var mapResult = modelUtil.mappingToExists(oldCptOpt, newCptOpt);
	      oldOption[mainType] = map(mapResult, function (item) {
	        return item.option && item.exist ? merge(item.exist, item.option, true) : item.exist || item.option;
	      });
	    }
	  });
	}
	
	var _default = OptionManager;
	module.exports = _default;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	var isArray = _util.isArray;
	var isObject = _util.isObject;
	
	var compatStyle = __webpack_require__(318);
	
	var _model = __webpack_require__(261);
	
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Compatitable with 2.0
	function get(opt, path) {
	  path = path.split(',');
	  var obj = opt;
	
	  for (var i = 0; i < path.length; i++) {
	    obj = obj && obj[path[i]];
	
	    if (obj == null) {
	      break;
	    }
	  }
	
	  return obj;
	}
	
	function set(opt, path, val, overwrite) {
	  path = path.split(',');
	  var obj = opt;
	  var key;
	
	  for (var i = 0; i < path.length - 1; i++) {
	    key = path[i];
	
	    if (obj[key] == null) {
	      obj[key] = {};
	    }
	
	    obj = obj[key];
	  }
	
	  if (overwrite || obj[path[i]] == null) {
	    obj[path[i]] = val;
	  }
	}
	
	function compatLayoutProperties(option) {
	  each(LAYOUT_PROPERTIES, function (prop) {
	    if (prop[0] in option && !(prop[1] in option)) {
	      option[prop[1]] = option[prop[0]];
	    }
	  });
	}
	
	var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
	var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];
	
	function _default(option, isTheme) {
	  compatStyle(option, isTheme); // Make sure series array for model initialization.
	
	  option.series = normalizeToArray(option.series);
	  each(option.series, function (seriesOpt) {
	    if (!isObject(seriesOpt)) {
	      return;
	    }
	
	    var seriesType = seriesOpt.type;
	
	    if (seriesType === 'line') {
	      if (seriesOpt.clipOverflow != null) {
	        seriesOpt.clip = seriesOpt.clipOverflow;
	      }
	    } else if (seriesType === 'pie' || seriesType === 'gauge') {
	      if (seriesOpt.clockWise != null) {
	        seriesOpt.clockwise = seriesOpt.clockWise;
	      }
	    } else if (seriesType === 'gauge') {
	      var pointerColor = get(seriesOpt, 'pointer.color');
	      pointerColor != null && set(seriesOpt, 'itemStyle.color', pointerColor);
	    }
	
	    compatLayoutProperties(seriesOpt);
	  }); // dataRange has changed to visualMap
	
	  if (option.dataRange) {
	    option.visualMap = option.dataRange;
	  }
	
	  each(COMPATITABLE_COMPONENTS, function (componentName) {
	    var options = option[componentName];
	
	    if (options) {
	      if (!isArray(options)) {
	        options = [options];
	      }
	
	      each(options, function (option) {
	        compatLayoutProperties(option);
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var modelUtil = __webpack_require__(261);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];
	
	function compatEC2ItemStyle(opt) {
	  var itemStyleOpt = opt && opt.itemStyle;
	
	  if (!itemStyleOpt) {
	    return;
	  }
	
	  for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
	    var styleName = POSSIBLE_STYLES[i];
	    var normalItemStyleOpt = itemStyleOpt.normal;
	    var emphasisItemStyleOpt = itemStyleOpt.emphasis;
	
	    if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
	      opt[styleName] = opt[styleName] || {};
	
	      if (!opt[styleName].normal) {
	        opt[styleName].normal = normalItemStyleOpt[styleName];
	      } else {
	        zrUtil.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
	      }
	
	      normalItemStyleOpt[styleName] = null;
	    }
	
	    if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
	      opt[styleName] = opt[styleName] || {};
	
	      if (!opt[styleName].emphasis) {
	        opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
	      } else {
	        zrUtil.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
	      }
	
	      emphasisItemStyleOpt[styleName] = null;
	    }
	  }
	}
	
	function convertNormalEmphasis(opt, optType, useExtend) {
	  if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
	    var normalOpt = opt[optType].normal;
	    var emphasisOpt = opt[optType].emphasis;
	
	    if (normalOpt) {
	      // Timeline controlStyle has other properties besides normal and emphasis
	      if (useExtend) {
	        opt[optType].normal = opt[optType].emphasis = null;
	        zrUtil.defaults(opt[optType], normalOpt);
	      } else {
	        opt[optType] = normalOpt;
	      }
	    }
	
	    if (emphasisOpt) {
	      opt.emphasis = opt.emphasis || {};
	      opt.emphasis[optType] = emphasisOpt;
	    }
	  }
	}
	
	function removeEC3NormalStatus(opt) {
	  convertNormalEmphasis(opt, 'itemStyle');
	  convertNormalEmphasis(opt, 'lineStyle');
	  convertNormalEmphasis(opt, 'areaStyle');
	  convertNormalEmphasis(opt, 'label');
	  convertNormalEmphasis(opt, 'labelLine'); // treemap
	
	  convertNormalEmphasis(opt, 'upperLabel'); // graph
	
	  convertNormalEmphasis(opt, 'edgeLabel');
	}
	
	function compatTextStyle(opt, propName) {
	  // Check whether is not object (string\null\undefined ...)
	  var labelOptSingle = isObject(opt) && opt[propName];
	  var textStyle = isObject(labelOptSingle) && labelOptSingle.textStyle;
	
	  if (textStyle) {
	    for (var i = 0, len = modelUtil.TEXT_STYLE_OPTIONS.length; i < len; i++) {
	      var propName = modelUtil.TEXT_STYLE_OPTIONS[i];
	
	      if (textStyle.hasOwnProperty(propName)) {
	        labelOptSingle[propName] = textStyle[propName];
	      }
	    }
	  }
	}
	
	function compatEC3CommonStyles(opt) {
	  if (opt) {
	    removeEC3NormalStatus(opt);
	    compatTextStyle(opt, 'label');
	    opt.emphasis && compatTextStyle(opt.emphasis, 'label');
	  }
	}
	
	function processSeries(seriesOpt) {
	  if (!isObject(seriesOpt)) {
	    return;
	  }
	
	  compatEC2ItemStyle(seriesOpt);
	  removeEC3NormalStatus(seriesOpt);
	  compatTextStyle(seriesOpt, 'label'); // treemap
	
	  compatTextStyle(seriesOpt, 'upperLabel'); // graph
	
	  compatTextStyle(seriesOpt, 'edgeLabel');
	
	  if (seriesOpt.emphasis) {
	    compatTextStyle(seriesOpt.emphasis, 'label'); // treemap
	
	    compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph
	
	    compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
	  }
	
	  var markPoint = seriesOpt.markPoint;
	
	  if (markPoint) {
	    compatEC2ItemStyle(markPoint);
	    compatEC3CommonStyles(markPoint);
	  }
	
	  var markLine = seriesOpt.markLine;
	
	  if (markLine) {
	    compatEC2ItemStyle(markLine);
	    compatEC3CommonStyles(markLine);
	  }
	
	  var markArea = seriesOpt.markArea;
	
	  if (markArea) {
	    compatEC3CommonStyles(markArea);
	  }
	
	  var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
	  // then the backward compat based on option type will not be performed.
	
	  if (seriesOpt.type === 'graph') {
	    data = data || seriesOpt.nodes;
	    var edgeData = seriesOpt.links || seriesOpt.edges;
	
	    if (edgeData && !zrUtil.isTypedArray(edgeData)) {
	      for (var i = 0; i < edgeData.length; i++) {
	        compatEC3CommonStyles(edgeData[i]);
	      }
	    }
	
	    zrUtil.each(seriesOpt.categories, function (opt) {
	      removeEC3NormalStatus(opt);
	    });
	  }
	
	  if (data && !zrUtil.isTypedArray(data)) {
	    for (var i = 0; i < data.length; i++) {
	      compatEC3CommonStyles(data[i]);
	    }
	  } // mark point data
	
	
	  var markPoint = seriesOpt.markPoint;
	
	  if (markPoint && markPoint.data) {
	    var mpData = markPoint.data;
	
	    for (var i = 0; i < mpData.length; i++) {
	      compatEC3CommonStyles(mpData[i]);
	    }
	  } // mark line data
	
	
	  var markLine = seriesOpt.markLine;
	
	  if (markLine && markLine.data) {
	    var mlData = markLine.data;
	
	    for (var i = 0; i < mlData.length; i++) {
	      if (zrUtil.isArray(mlData[i])) {
	        compatEC3CommonStyles(mlData[i][0]);
	        compatEC3CommonStyles(mlData[i][1]);
	      } else {
	        compatEC3CommonStyles(mlData[i]);
	      }
	    }
	  } // Series
	
	
	  if (seriesOpt.type === 'gauge') {
	    compatTextStyle(seriesOpt, 'axisLabel');
	    compatTextStyle(seriesOpt, 'title');
	    compatTextStyle(seriesOpt, 'detail');
	  } else if (seriesOpt.type === 'treemap') {
	    convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
	    zrUtil.each(seriesOpt.levels, function (opt) {
	      removeEC3NormalStatus(opt);
	    });
	  } else if (seriesOpt.type === 'tree') {
	    removeEC3NormalStatus(seriesOpt.leaves);
	  } // sunburst starts from ec4, so it does not need to compat levels.
	
	}
	
	function toArr(o) {
	  return zrUtil.isArray(o) ? o : o ? [o] : [];
	}
	
	function toObj(o) {
	  return (zrUtil.isArray(o) ? o[0] : o) || {};
	}
	
	function _default(option, isTheme) {
	  each(toArr(option.series), function (seriesOpt) {
	    isObject(seriesOpt) && processSeries(seriesOpt);
	  });
	  var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
	  isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
	  each(axes, function (axisName) {
	    each(toArr(option[axisName]), function (axisOpt) {
	      if (axisOpt) {
	        compatTextStyle(axisOpt, 'axisLabel');
	        compatTextStyle(axisOpt.axisPointer, 'label');
	      }
	    });
	  });
	  each(toArr(option.parallel), function (parallelOpt) {
	    var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
	    compatTextStyle(parallelAxisDefault, 'axisLabel');
	    compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
	  });
	  each(toArr(option.calendar), function (calendarOpt) {
	    convertNormalEmphasis(calendarOpt, 'itemStyle');
	    compatTextStyle(calendarOpt, 'dayLabel');
	    compatTextStyle(calendarOpt, 'monthLabel');
	    compatTextStyle(calendarOpt, 'yearLabel');
	  }); // radar.name.textStyle
	
	  each(toArr(option.radar), function (radarOpt) {
	    compatTextStyle(radarOpt, 'name');
	  });
	  each(toArr(option.geo), function (geoOpt) {
	    if (isObject(geoOpt)) {
	      compatEC3CommonStyles(geoOpt);
	      each(toArr(geoOpt.regions), function (regionObj) {
	        compatEC3CommonStyles(regionObj);
	      });
	    }
	  });
	  each(toArr(option.timeline), function (timelineOpt) {
	    compatEC3CommonStyles(timelineOpt);
	    convertNormalEmphasis(timelineOpt, 'label');
	    convertNormalEmphasis(timelineOpt, 'itemStyle');
	    convertNormalEmphasis(timelineOpt, 'controlStyle', true);
	    var data = timelineOpt.data;
	    zrUtil.isArray(data) && zrUtil.each(data, function (item) {
	      if (zrUtil.isObject(item)) {
	        convertNormalEmphasis(item, 'label');
	        convertNormalEmphasis(item, 'itemStyle');
	      }
	    });
	  });
	  each(toArr(option.toolbox), function (toolboxOpt) {
	    convertNormalEmphasis(toolboxOpt, 'iconStyle');
	    each(toolboxOpt.feature, function (featureOpt) {
	      convertNormalEmphasis(featureOpt, 'iconStyle');
	    });
	  });
	  compatTextStyle(toObj(option.axisPointer), 'label');
	  compatTextStyle(toObj(option.tooltip).axisPointer, 'label');
	}
	
	module.exports = _default;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (1) [Caution]: the logic is correct based on the premises:
	//     data processing stage is blocked in stream.
	//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
	// (2) Only register once when import repeatly.
	//     Should be executed after series filtered and before stack calculation.
	function _default(ecModel) {
	  var stackInfoMap = createHashMap();
	  ecModel.eachSeries(function (seriesModel) {
	    var stack = seriesModel.get('stack'); // Compatibal: when `stack` is set as '', do not stack.
	
	    if (stack) {
	      var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
	      var data = seriesModel.getData();
	      var stackInfo = {
	        // Used for calculate axis extent automatically.
	        stackResultDimension: data.getCalculationInfo('stackResultDimension'),
	        stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
	        stackedDimension: data.getCalculationInfo('stackedDimension'),
	        stackedByDimension: data.getCalculationInfo('stackedByDimension'),
	        isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
	        data: data,
	        seriesModel: seriesModel
	      }; // If stacked on axis that do not support data stack.
	
	      if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) {
	        return;
	      }
	
	      stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
	      stackInfoList.push(stackInfo);
	    }
	  });
	  stackInfoMap.each(calculateStack);
	}
	
	function calculateStack(stackInfoList) {
	  each(stackInfoList, function (targetStackInfo, idxInStack) {
	    var resultVal = [];
	    var resultNaN = [NaN, NaN];
	    var dims = [targetStackInfo.stackResultDimension, targetStackInfo.stackedOverDimension];
	    var targetData = targetStackInfo.data;
	    var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
	    // depending on legend selection.
	
	    var newData = targetData.map(dims, function (v0, v1, dataIndex) {
	      var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
	      // should also be NaN, to draw a appropriate belt area.
	
	      if (isNaN(sum)) {
	        return resultNaN;
	      }
	
	      var byValue;
	      var stackedDataRawIndex;
	
	      if (isStackedByIndex) {
	        stackedDataRawIndex = targetData.getRawIndex(dataIndex);
	      } else {
	        byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
	      } // If stackOver is NaN, chart view will render point on value start.
	
	
	      var stackedOver = NaN;
	
	      for (var j = idxInStack - 1; j >= 0; j--) {
	        var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.
	
	        if (!isStackedByIndex) {
	          stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
	        }
	
	        if (stackedDataRawIndex >= 0) {
	          var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data
	
	          if (sum >= 0 && val > 0 || // Positive stack
	          sum <= 0 && val < 0 // Negative stack
	          ) {
	              sum += val;
	              stackedOver = val;
	              break;
	            }
	        }
	      }
	
	      resultVal[0] = sum;
	      resultVal[1] = stackedOver;
	      return resultVal;
	    });
	    targetData.hostModel.setData(newData); // Update for consequent calculation
	
	    targetStackInfo.data = newData;
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(220);
	
	var env = __webpack_require__(219);
	
	var _format = __webpack_require__(307);
	
	var formatTime = _format.formatTime;
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	var getTooltipMarker = _format.getTooltipMarker;
	
	var modelUtil = __webpack_require__(261);
	
	var ComponentModel = __webpack_require__(303);
	
	var colorPaletteMixin = __webpack_require__(310);
	
	var dataFormatMixin = __webpack_require__(321);
	
	var _layout = __webpack_require__(305);
	
	var getLayoutParams = _layout.getLayoutParams;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	var _task = __webpack_require__(323);
	
	var createTask = _task.createTask;
	
	var _sourceHelper = __webpack_require__(311);
	
	var prepareSource = _sourceHelper.prepareSource;
	var getSource = _sourceHelper.getSource;
	
	var _dataProvider = __webpack_require__(322);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = modelUtil.makeInner();
	var SeriesModel = ComponentModel.extend({
	  type: 'series.__base__',
	
	  /**
	   * @readOnly
	   */
	  seriesIndex: 0,
	  // coodinateSystem will be injected in the echarts/CoordinateSystem
	  coordinateSystem: null,
	
	  /**
	   * @type {Object}
	   * @protected
	   */
	  defaultOption: null,
	
	  /**
	   * legend visual provider to the legend component
	   * @type {Object}
	   */
	  // PENDING
	  legendVisualProvider: null,
	
	  /**
	   * Access path of color for visual
	   */
	  visualColorAccessPath: 'itemStyle.color',
	
	  /**
	   * Access path of borderColor for visual
	   */
	  visualBorderColorAccessPath: 'itemStyle.borderColor',
	
	  /**
	   * Support merge layout params.
	   * Only support 'box' now (left/right/top/bottom/width/height).
	   * @type {string|Object} Object can be {ignoreSize: true}
	   * @readOnly
	   */
	  layoutMode: null,
	  init: function (option, parentModel, ecModel, extraOpt) {
	    /**
	     * @type {number}
	     * @readOnly
	     */
	    this.seriesIndex = this.componentIndex;
	    this.dataTask = createTask({
	      count: dataTaskCount,
	      reset: dataTaskReset
	    });
	    this.dataTask.context = {
	      model: this
	    };
	    this.mergeDefaultAndTheme(option, ecModel);
	    prepareSource(this);
	    var data = this.getInitialData(option, ecModel);
	    wrapData(data, this);
	    this.dataTask.context.data = data;
	
	    /**
	     * @type {module:echarts/data/List|module:echarts/data/Tree|module:echarts/data/Graph}
	     * @private
	     */
	    inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
	    // dataBeforeProcessed by cloneShallow), cloneShallow will
	    // cause data.graph.data !== data when using
	    // module:echarts/data/Graph or module:echarts/data/Tree.
	    // See module:echarts/data/helper/linkList
	    // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
	    // init or merge stage, because the data can be restored. So we do not `restoreData`
	    // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
	    // Call `seriesModel.getRawData()` instead.
	    // this.restoreData();
	
	    autoSeriesName(this);
	  },
	
	  /**
	   * Util for merge default and theme to option
	   * @param  {Object} option
	   * @param  {module:echarts/model/Global} ecModel
	   */
	  mergeDefaultAndTheme: function (option, ecModel) {
	    var layoutMode = this.layoutMode;
	    var inputPositionParams = layoutMode ? getLayoutParams(option) : {}; // Backward compat: using subType on theme.
	    // But if name duplicate between series subType
	    // (for example: parallel) add component mainType,
	    // add suffix 'Series'.
	
	    var themeSubType = this.subType;
	
	    if (ComponentModel.hasClass(themeSubType)) {
	      themeSubType += 'Series';
	    }
	
	    zrUtil.merge(option, ecModel.getTheme().get(this.subType));
	    zrUtil.merge(option, this.getDefaultOption()); // Default label emphasis `show`
	
	    modelUtil.defaultEmphasis(option, 'label', ['show']);
	    this.fillDataTextStyle(option.data);
	
	    if (layoutMode) {
	      mergeLayoutParam(option, inputPositionParams, layoutMode);
	    }
	  },
	  mergeOption: function (newSeriesOption, ecModel) {
	    // this.settingTask.dirty();
	    newSeriesOption = zrUtil.merge(this.option, newSeriesOption, true);
	    this.fillDataTextStyle(newSeriesOption.data);
	    var layoutMode = this.layoutMode;
	
	    if (layoutMode) {
	      mergeLayoutParam(this.option, newSeriesOption, layoutMode);
	    }
	
	    prepareSource(this);
	    var data = this.getInitialData(newSeriesOption, ecModel);
	    wrapData(data, this);
	    this.dataTask.dirty();
	    this.dataTask.context.data = data;
	    inner(this).dataBeforeProcessed = data;
	    autoSeriesName(this);
	  },
	  fillDataTextStyle: function (data) {
	    // Default data label emphasis `show`
	    // FIXME Tree structure data ?
	    // FIXME Performance ?
	    if (data && !zrUtil.isTypedArray(data)) {
	      var props = ['show'];
	
	      for (var i = 0; i < data.length; i++) {
	        if (data[i] && data[i].label) {
	          modelUtil.defaultEmphasis(data[i], 'label', props);
	        }
	      }
	    }
	  },
	
	  /**
	   * Init a data structure from data related option in series
	   * Must be overwritten
	   */
	  getInitialData: function () {},
	
	  /**
	   * Append data to list
	   * @param {Object} params
	   * @param {Array|TypedArray} params.data
	   */
	  appendData: function (params) {
	    // FIXME ???
	    // (1) If data from dataset, forbidden append.
	    // (2) support append data of dataset.
	    var data = this.getRawData();
	    data.appendData(params.data);
	  },
	
	  /**
	   * Consider some method like `filter`, `map` need make new data,
	   * We should make sure that `seriesModel.getData()` get correct
	   * data in the stream procedure. So we fetch data from upstream
	   * each time `task.perform` called.
	   * @param {string} [dataType]
	   * @return {module:echarts/data/List}
	   */
	  getData: function (dataType) {
	    var task = getCurrentTask(this);
	
	    if (task) {
	      var data = task.context.data;
	      return dataType == null ? data : data.getLinkedData(dataType);
	    } else {
	      // When series is not alive (that may happen when click toolbox
	      // restore or setOption with not merge mode), series data may
	      // be still need to judge animation or something when graphic
	      // elements want to know whether fade out.
	      return inner(this).data;
	    }
	  },
	
	  /**
	   * @param {module:echarts/data/List} data
	   */
	  setData: function (data) {
	    var task = getCurrentTask(this);
	
	    if (task) {
	      var context = task.context; // Consider case: filter, data sample.
	
	      if (context.data !== data && task.modifyOutputEnd) {
	        task.setOutputEnd(data.count());
	      }
	
	      context.outputData = data; // Caution: setData should update context.data,
	      // Because getData may be called multiply in a
	      // single stage and expect to get the data just
	      // set. (For example, AxisProxy, x y both call
	      // getData and setDate sequentially).
	      // So the context.data should be fetched from
	      // upstream each time when a stage starts to be
	      // performed.
	
	      if (task !== this.dataTask) {
	        context.data = data;
	      }
	    }
	
	    inner(this).data = data;
	  },
	
	  /**
	   * @see {module:echarts/data/helper/sourceHelper#getSource}
	   * @return {module:echarts/data/Source} source
	   */
	  getSource: function () {
	    return getSource(this);
	  },
	
	  /**
	   * Get data before processed
	   * @return {module:echarts/data/List}
	   */
	  getRawData: function () {
	    return inner(this).dataBeforeProcessed;
	  },
	
	  /**
	   * Get base axis if has coordinate system and has axis.
	   * By default use coordSys.getBaseAxis();
	   * Can be overrided for some chart.
	   * @return {type} description
	   */
	  getBaseAxis: function () {
	    var coordSys = this.coordinateSystem;
	    return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
	  },
	  // FIXME
	
	  /**
	   * Default tooltip formatter
	   *
	   * @param {number} dataIndex
	   * @param {boolean} [multipleSeries=false]
	   * @param {number} [dataType]
	   * @param {string} [renderMode='html'] valid values: 'html' and 'richText'.
	   *                                     'html' is used for rendering tooltip in extra DOM form, and the result
	   *                                     string is used as DOM HTML content.
	   *                                     'richText' is used for rendering tooltip in rich text form, for those where
	   *                                     DOM operation is not supported.
	   * @return {Object} formatted tooltip with `html` and `markers`
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var series = this;
	    renderMode = renderMode || 'html';
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    var isRichText = renderMode === 'richText';
	    var markers = {};
	    var markerId = 0;
	
	    function formatArrayValue(value) {
	      // ??? TODO refactor these logic.
	      // check: category-no-encode-has-axis-data in dataset.html
	      var vertially = zrUtil.reduce(value, function (vertially, val, idx) {
	        var dimItem = data.getDimensionInfo(idx);
	        return vertially |= dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
	      }, 0);
	      var result = [];
	      tooltipDims.length ? zrUtil.each(tooltipDims, function (dim) {
	        setEachItem(retrieveRawValue(data, dataIndex, dim), dim);
	      }) // By default, all dims is used on tooltip.
	      : zrUtil.each(value, setEachItem);
	
	      function setEachItem(val, dim) {
	        var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.
	
	        if (!dimInfo || dimInfo.otherDims.tooltip === false) {
	          return;
	        }
	
	        var dimType = dimInfo.type;
	        var markName = 'sub' + series.seriesIndex + 'at' + markerId;
	        var dimHead = getTooltipMarker({
	          color: color,
	          type: 'subItem',
	          renderMode: renderMode,
	          markerId: markName
	        });
	        var dimHeadStr = typeof dimHead === 'string' ? dimHead : dimHead.content;
	        var valStr = (vertially ? dimHeadStr + encodeHTML(dimInfo.displayName || '-') + ': ' : '') + // FIXME should not format time for raw data?
	        encodeHTML(dimType === 'ordinal' ? val + '' : dimType === 'time' ? multipleSeries ? '' : formatTime('yyyy/MM/dd hh:mm:ss', val) : addCommas(val));
	        valStr && result.push(valStr);
	
	        if (isRichText) {
	          markers[markName] = color;
	          ++markerId;
	        }
	      }
	
	      var newLine = vertially ? isRichText ? '\n' : '<br/>' : '';
	      var content = newLine + result.join(newLine || ', ');
	      return {
	        renderMode: renderMode,
	        content: content,
	        style: markers
	      };
	    }
	
	    function formatSingleValue(val) {
	      // return encodeHTML(addCommas(val));
	      return {
	        renderMode: renderMode,
	        content: encodeHTML(addCommas(val)),
	        style: markers
	      };
	    }
	
	    var data = this.getData();
	    var tooltipDims = data.mapDimension('defaultedTooltip', true);
	    var tooltipDimLen = tooltipDims.length;
	    var value = this.getRawValue(dataIndex);
	    var isValueArr = zrUtil.isArray(value);
	    var color = data.getItemVisual(dataIndex, 'color');
	
	    if (zrUtil.isObject(color) && color.colorStops) {
	      color = (color.colorStops[0] || {}).color;
	    }
	
	    color = color || 'transparent'; // Complicated rule for pretty tooltip.
	
	    var formattedValue = tooltipDimLen > 1 || isValueArr && !tooltipDimLen ? formatArrayValue(value) : tooltipDimLen ? formatSingleValue(retrieveRawValue(data, dataIndex, tooltipDims[0])) : formatSingleValue(isValueArr ? value[0] : value);
	    var content = formattedValue.content;
	    var markName = series.seriesIndex + 'at' + markerId;
	    var colorEl = getTooltipMarker({
	      color: color,
	      type: 'item',
	      renderMode: renderMode,
	      markerId: markName
	    });
	    markers[markName] = color;
	    ++markerId;
	    var name = data.getName(dataIndex);
	    var seriesName = this.name;
	
	    if (!modelUtil.isNameSpecified(this)) {
	      seriesName = '';
	    }
	
	    seriesName = seriesName ? encodeHTML(seriesName) + (!multipleSeries ? newLine : ': ') : '';
	    var colorStr = typeof colorEl === 'string' ? colorEl : colorEl.content;
	    var html = !multipleSeries ? seriesName + colorStr + (name ? encodeHTML(name) + ': ' + content : content) : colorStr + seriesName + content;
	    return {
	      html: html,
	      markers: markers
	    };
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isAnimationEnabled: function () {
	    if (env.node) {
	      return false;
	    }
	
	    var animationEnabled = this.getShallow('animation');
	
	    if (animationEnabled) {
	      if (this.getData().count() > this.getShallow('animationThreshold')) {
	        animationEnabled = false;
	      }
	    }
	
	    return animationEnabled;
	  },
	  restoreData: function () {
	    this.dataTask.dirty();
	  },
	  getColorFromPalette: function (name, scope, requestColorNum) {
	    var ecModel = this.ecModel; // PENDING
	
	    var color = colorPaletteMixin.getColorFromPalette.call(this, name, scope, requestColorNum);
	
	    if (!color) {
	      color = ecModel.getColorFromPalette(name, scope, requestColorNum);
	    }
	
	    return color;
	  },
	
	  /**
	   * Use `data.mapDimension(coordDim, true)` instead.
	   * @deprecated
	   */
	  coordDimToDataDim: function (coordDim) {
	    return this.getRawData().mapDimension(coordDim, true);
	  },
	
	  /**
	   * Get progressive rendering count each step
	   * @return {number}
	   */
	  getProgressive: function () {
	    return this.get('progressive');
	  },
	
	  /**
	   * Get progressive rendering count each step
	   * @return {number}
	   */
	  getProgressiveThreshold: function () {
	    return this.get('progressiveThreshold');
	  },
	
	  /**
	   * Get data indices for show tooltip content. See tooltip.
	   * @abstract
	   * @param {Array.<string>|string} dim
	   * @param {Array.<number>} value
	   * @param {module:echarts/coord/single/SingleAxis} baseAxis
	   * @return {Object} {dataIndices, nestestValue}.
	   */
	  getAxisTooltipData: null,
	
	  /**
	   * See tooltip.
	   * @abstract
	   * @param {number} dataIndex
	   * @return {Array.<number>} Point of tooltip. null/undefined can be returned.
	   */
	  getTooltipPosition: null,
	
	  /**
	   * @see {module:echarts/stream/Scheduler}
	   */
	  pipeTask: null,
	
	  /**
	   * Convinient for override in extended class.
	   * @protected
	   * @type {Function}
	   */
	  preventIncremental: null,
	
	  /**
	   * @public
	   * @readOnly
	   * @type {Object}
	   */
	  pipelineContext: null
	});
	zrUtil.mixin(SeriesModel, dataFormatMixin);
	zrUtil.mixin(SeriesModel, colorPaletteMixin);
	/**
	 * MUST be called after `prepareSource` called
	 * Here we need to make auto series, especially for auto legend. But we
	 * do not modify series.name in option to avoid side effects.
	 */
	
	function autoSeriesName(seriesModel) {
	  // User specified name has higher priority, otherwise it may cause
	  // series can not be queried unexpectedly.
	  var name = seriesModel.name;
	
	  if (!modelUtil.isNameSpecified(seriesModel)) {
	    seriesModel.name = getSeriesAutoName(seriesModel) || name;
	  }
	}
	
	function getSeriesAutoName(seriesModel) {
	  var data = seriesModel.getRawData();
	  var dataDims = data.mapDimension('seriesName', true);
	  var nameArr = [];
	  zrUtil.each(dataDims, function (dataDim) {
	    var dimInfo = data.getDimensionInfo(dataDim);
	    dimInfo.displayName && nameArr.push(dimInfo.displayName);
	  });
	  return nameArr.join(' ');
	}
	
	function dataTaskCount(context) {
	  return context.model.getRawData().count();
	}
	
	function dataTaskReset(context) {
	  var seriesModel = context.model;
	  seriesModel.setData(seriesModel.getRawData().cloneShallow());
	  return dataTaskProgress;
	}
	
	function dataTaskProgress(param, context) {
	  // Avoid repead cloneShallow when data just created in reset.
	  if (context.outputData && param.end > context.outputData.count()) {
	    context.model.getRawData().cloneShallow(context.outputData);
	  }
	} // TODO refactor
	
	
	function wrapData(data, seriesModel) {
	  zrUtil.each(data.CHANGABLE_METHODS, function (methodName) {
	    data.wrapMethod(methodName, zrUtil.curry(onDataSelfChange, seriesModel));
	  });
	}
	
	function onDataSelfChange(seriesModel) {
	  var task = getCurrentTask(seriesModel);
	
	  if (task) {
	    // Consider case: filter, selectRange
	    task.setOutputEnd(this.count());
	  }
	}
	
	function getCurrentTask(seriesModel) {
	  var scheduler = (seriesModel.ecModel || {}).scheduler;
	  var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
	
	  if (pipeline) {
	    // When pipline finished, the currrentTask keep the last
	    // task (renderTask).
	    var task = pipeline.currentTask;
	
	    if (task) {
	      var agentStubMap = task.agentStubMap;
	
	      if (agentStubMap) {
	        task = agentStubMap.get(seriesModel.uid);
	      }
	    }
	
	    return task;
	  }
	}
	
	var _default = SeriesModel;
	module.exports = _default;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataProvider = __webpack_require__(322);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	var _format = __webpack_require__(307);
	
	var getTooltipMarker = _format.getTooltipMarker;
	var formatTpl = _format.formatTpl;
	
	var _model = __webpack_require__(261);
	
	var getTooltipRenderMode = _model.getTooltipRenderMode;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DIMENSION_LABEL_REG = /\{@(.+?)\}/g; // PENDING A little ugly
	
	var _default = {
	  /**
	   * Get params for formatter
	   * @param {number} dataIndex
	   * @param {string} [dataType]
	   * @return {Object}
	   */
	  getDataParams: function (dataIndex, dataType) {
	    var data = this.getData(dataType);
	    var rawValue = this.getRawValue(dataIndex, dataType);
	    var rawDataIndex = data.getRawIndex(dataIndex);
	    var name = data.getName(dataIndex);
	    var itemOpt = data.getRawDataItem(dataIndex);
	    var color = data.getItemVisual(dataIndex, 'color');
	    var borderColor = data.getItemVisual(dataIndex, 'borderColor');
	    var tooltipModel = this.ecModel.getComponent('tooltip');
	    var renderModeOption = tooltipModel && tooltipModel.get('renderMode');
	    var renderMode = getTooltipRenderMode(renderModeOption);
	    var mainType = this.mainType;
	    var isSeries = mainType === 'series';
	    var userOutput = data.userOutput;
	    return {
	      componentType: mainType,
	      componentSubType: this.subType,
	      componentIndex: this.componentIndex,
	      seriesType: isSeries ? this.subType : null,
	      seriesIndex: this.seriesIndex,
	      seriesId: isSeries ? this.id : null,
	      seriesName: isSeries ? this.name : null,
	      name: name,
	      dataIndex: rawDataIndex,
	      data: itemOpt,
	      dataType: dataType,
	      value: rawValue,
	      color: color,
	      borderColor: borderColor,
	      dimensionNames: userOutput ? userOutput.dimensionNames : null,
	      encode: userOutput ? userOutput.encode : null,
	      marker: getTooltipMarker({
	        color: color,
	        renderMode: renderMode
	      }),
	      // Param name list for mapping `a`, `b`, `c`, `d`, `e`
	      $vars: ['seriesName', 'name', 'value']
	    };
	  },
	
	  /**
	   * Format label
	   * @param {number} dataIndex
	   * @param {string} [status='normal'] 'normal' or 'emphasis'
	   * @param {string} [dataType]
	   * @param {number} [dimIndex] Only used in some chart that
	   *        use formatter in different dimensions, like radar.
	   * @param {string} [labelProp='label']
	   * @return {string} If not formatter, return null/undefined
	   */
	  getFormattedLabel: function (dataIndex, status, dataType, dimIndex, labelProp) {
	    status = status || 'normal';
	    var data = this.getData(dataType);
	    var itemModel = data.getItemModel(dataIndex);
	    var params = this.getDataParams(dataIndex, dataType);
	
	    if (dimIndex != null && params.value instanceof Array) {
	      params.value = params.value[dimIndex];
	    }
	
	    var formatter = itemModel.get(status === 'normal' ? [labelProp || 'label', 'formatter'] : [status, labelProp || 'label', 'formatter']);
	
	    if (typeof formatter === 'function') {
	      params.status = status;
	      params.dimensionIndex = dimIndex;
	      return formatter(params);
	    } else if (typeof formatter === 'string') {
	      var str = formatTpl(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
	      // Do not support '}' in dim name util have to.
	
	      return str.replace(DIMENSION_LABEL_REG, function (origin, dim) {
	        var len = dim.length;
	
	        if (dim.charAt(0) === '[' && dim.charAt(len - 1) === ']') {
	          dim = +dim.slice(1, len - 1); // Also: '[]' => 0
	        }
	
	        return retrieveRawValue(data, dataIndex, dim);
	      });
	    }
	  },
	
	  /**
	   * Get raw value in option
	   * @param {number} idx
	   * @param {string} [dataType]
	   * @return {Array|number|string}
	   */
	  getRawValue: function (idx, dataType) {
	    return retrieveRawValue(this.getData(dataType), idx);
	  },
	
	  /**
	   * Should be implemented.
	   * @param {number} dataIndex
	   * @param {boolean} [multipleSeries=false]
	   * @param {number} [dataType]
	   * @return {string} tooltip string
	   */
	  formatTooltip: function () {// Empty function
	  }
	};
	module.exports = _default;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(220);
	
	var isTypedArray = _util.isTypedArray;
	var extend = _util.extend;
	var assert = _util.assert;
	var each = _util.each;
	var isObject = _util.isObject;
	
	var _model = __webpack_require__(261);
	
	var getDataItemValue = _model.getDataItemValue;
	var isDataItemOption = _model.isDataItemOption;
	
	var _number = __webpack_require__(306);
	
	var parseDate = _number.parseDate;
	
	var Source = __webpack_require__(312);
	
	var _sourceType = __webpack_require__(313);
	
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO
	// ??? refactor? check the outer usage of data provider.
	// merge with defaultDimValueGetter?
	
	/**
	 * If normal array used, mutable chunk size is supported.
	 * If typed array used, chunk size must be fixed.
	 */
	function DefaultDataProvider(source, dimSize) {
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  this._source = source;
	  var data = this._data = source.data;
	  var sourceFormat = source.sourceFormat; // Typed array. TODO IE10+?
	
	  if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
	    this._offset = 0;
	    this._dimSize = dimSize;
	    this._data = data;
	  }
	
	  var methods = providerMethods[sourceFormat === SOURCE_FORMAT_ARRAY_ROWS ? sourceFormat + '_' + source.seriesLayoutBy : sourceFormat];
	  extend(this, methods);
	}
	
	var providerProto = DefaultDataProvider.prototype; // If data is pure without style configuration
	
	providerProto.pure = false; // If data is persistent and will not be released after use.
	
	providerProto.persistent = true; // ???! FIXME legacy data provider do not has method getSource
	
	providerProto.getSource = function () {
	  return this._source;
	};
	
	var providerMethods = {
	  'arrayRows_column': {
	    pure: true,
	    count: function () {
	      return Math.max(0, this._data.length - this._source.startIndex);
	    },
	    getItem: function (idx) {
	      return this._data[idx + this._source.startIndex];
	    },
	    appendData: appendDataSimply
	  },
	  'arrayRows_row': {
	    pure: true,
	    count: function () {
	      var row = this._data[0];
	      return row ? Math.max(0, row.length - this._source.startIndex) : 0;
	    },
	    getItem: function (idx) {
	      idx += this._source.startIndex;
	      var item = [];
	      var data = this._data;
	
	      for (var i = 0; i < data.length; i++) {
	        var row = data[i];
	        item.push(row ? row[idx] : null);
	      }
	
	      return item;
	    },
	    appendData: function () {
	      throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
	    }
	  },
	  'objectRows': {
	    pure: true,
	    count: countSimply,
	    getItem: getItemSimply,
	    appendData: appendDataSimply
	  },
	  'keyedColumns': {
	    pure: true,
	    count: function () {
	      var dimName = this._source.dimensionsDefine[0].name;
	      var col = this._data[dimName];
	      return col ? col.length : 0;
	    },
	    getItem: function (idx) {
	      var item = [];
	      var dims = this._source.dimensionsDefine;
	
	      for (var i = 0; i < dims.length; i++) {
	        var col = this._data[dims[i].name];
	        item.push(col ? col[idx] : null);
	      }
	
	      return item;
	    },
	    appendData: function (newData) {
	      var data = this._data;
	      each(newData, function (newCol, key) {
	        var oldCol = data[key] || (data[key] = []);
	
	        for (var i = 0; i < (newCol || []).length; i++) {
	          oldCol.push(newCol[i]);
	        }
	      });
	    }
	  },
	  'original': {
	    count: countSimply,
	    getItem: getItemSimply,
	    appendData: appendDataSimply
	  },
	  'typedArray': {
	    persistent: false,
	    pure: true,
	    count: function () {
	      return this._data ? this._data.length / this._dimSize : 0;
	    },
	    getItem: function (idx, out) {
	      idx = idx - this._offset;
	      out = out || [];
	      var offset = this._dimSize * idx;
	
	      for (var i = 0; i < this._dimSize; i++) {
	        out[i] = this._data[offset + i];
	      }
	
	      return out;
	    },
	    appendData: function (newData) {
	      this._data = newData;
	    },
	    // Clean self if data is already used.
	    clean: function () {
	      // PENDING
	      this._offset += this.count();
	      this._data = null;
	    }
	  }
	};
	
	function countSimply() {
	  return this._data.length;
	}
	
	function getItemSimply(idx) {
	  return this._data[idx];
	}
	
	function appendDataSimply(newData) {
	  for (var i = 0; i < newData.length; i++) {
	    this._data.push(newData[i]);
	  }
	}
	
	var rawValueGetters = {
	  arrayRows: getRawValueSimply,
	  objectRows: function (dataItem, dataIndex, dimIndex, dimName) {
	    return dimIndex != null ? dataItem[dimName] : dataItem;
	  },
	  keyedColumns: getRawValueSimply,
	  original: function (dataItem, dataIndex, dimIndex, dimName) {
	    // FIXME
	    // In some case (markpoint in geo (geo-map.html)), dataItem
	    // is {coord: [...]}
	    var value = getDataItemValue(dataItem);
	    return dimIndex == null || !(value instanceof Array) ? value : value[dimIndex];
	  },
	  typedArray: getRawValueSimply
	};
	
	function getRawValueSimply(dataItem, dataIndex, dimIndex, dimName) {
	  return dimIndex != null ? dataItem[dimIndex] : dataItem;
	}
	
	var defaultDimValueGetters = {
	  arrayRows: getDimValueSimply,
	  objectRows: function (dataItem, dimName, dataIndex, dimIndex) {
	    return converDataValue(dataItem[dimName], this._dimensionInfos[dimName]);
	  },
	  keyedColumns: getDimValueSimply,
	  original: function (dataItem, dimName, dataIndex, dimIndex) {
	    // Performance sensitive, do not use modelUtil.getDataItemValue.
	    // If dataItem is an plain object with no value field, the var `value`
	    // will be assigned with the object, but it will be tread correctly
	    // in the `convertDataValue`.
	    var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value); // If any dataItem is like { value: 10 }
	
	    if (!this._rawData.pure && isDataItemOption(dataItem)) {
	      this.hasItemOption = true;
	    }
	
	    return converDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
	    : value, this._dimensionInfos[dimName]);
	  },
	  typedArray: function (dataItem, dimName, dataIndex, dimIndex) {
	    return dataItem[dimIndex];
	  }
	};
	
	function getDimValueSimply(dataItem, dimName, dataIndex, dimIndex) {
	  return converDataValue(dataItem[dimIndex], this._dimensionInfos[dimName]);
	}
	/**
	 * This helper method convert value in data.
	 * @param {string|number|Date} value
	 * @param {Object|string} [dimInfo] If string (like 'x'), dimType defaults 'number'.
	 *        If "dimInfo.ordinalParseAndSave", ordinal value can be parsed.
	 */
	
	
	function converDataValue(value, dimInfo) {
	  // Performance sensitive.
	  var dimType = dimInfo && dimInfo.type;
	
	  if (dimType === 'ordinal') {
	    // If given value is a category string
	    var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
	    return ordinalMeta ? ordinalMeta.parseAndCollect(value) : value;
	  }
	
	  if (dimType === 'time' // spead up when using timestamp
	  && typeof value !== 'number' && value != null && value !== '-') {
	    value = +parseDate(value);
	  } // dimType defaults 'number'.
	  // If dimType is not ordinal and value is null or undefined or NaN or '-',
	  // parse to NaN.
	
	
	  return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
	  // If object, also parse to NaN
	  : +value;
	} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
	// Consider persistent.
	// Caution: why use raw value to display on label or tooltip?
	// A reason is to avoid format. For example time value we do not know
	// how to format is expected. More over, if stack is used, calculated
	// value may be 0.91000000001, which have brings trouble to display.
	// TODO: consider how to treat null/undefined/NaN when display?
	
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @param {string|number} [dim] dimName or dimIndex
	 * @return {Array.<number>|string|number} can be null/undefined.
	 */
	
	
	function retrieveRawValue(data, dataIndex, dim) {
	  if (!data) {
	    return;
	  } // Consider data may be not persistent.
	
	
	  var dataItem = data.getRawDataItem(dataIndex);
	
	  if (dataItem == null) {
	    return;
	  }
	
	  var sourceFormat = data.getProvider().getSource().sourceFormat;
	  var dimName;
	  var dimIndex;
	  var dimInfo = data.getDimensionInfo(dim);
	
	  if (dimInfo) {
	    dimName = dimInfo.name;
	    dimIndex = dimInfo.index;
	  }
	
	  return rawValueGetters[sourceFormat](dataItem, dataIndex, dimIndex, dimName);
	}
	/**
	 * Compatible with some cases (in pie, map) like:
	 * data: [{name: 'xx', value: 5, selected: true}, ...]
	 * where only sourceFormat is 'original' and 'objectRows' supported.
	 *
	 * ??? TODO
	 * Supported detail options in data item when using 'arrayRows'.
	 *
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @param {string} attr like 'selected'
	 */
	
	
	function retrieveRawAttr(data, dataIndex, attr) {
	  if (!data) {
	    return;
	  }
	
	  var sourceFormat = data.getProvider().getSource().sourceFormat;
	
	  if (sourceFormat !== SOURCE_FORMAT_ORIGINAL && sourceFormat !== SOURCE_FORMAT_OBJECT_ROWS) {
	    return;
	  }
	
	  var dataItem = data.getRawDataItem(dataIndex);
	
	  if (sourceFormat === SOURCE_FORMAT_ORIGINAL && !isObject(dataItem)) {
	    dataItem = null;
	  }
	
	  if (dataItem) {
	    return dataItem[attr];
	  }
	}
	
	exports.DefaultDataProvider = DefaultDataProvider;
	exports.defaultDimValueGetters = defaultDimValueGetters;
	exports.retrieveRawValue = retrieveRawValue;
	exports.retrieveRawAttr = retrieveRawAttr;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var assert = _util.assert;
	var isArray = _util.isArray;
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} define
	 * @return See the return of `createTask`.
	 */
	function createTask(define) {
	  return new Task(define);
	}
	/**
	 * @constructor
	 * @param {Object} define
	 * @param {Function} define.reset Custom reset
	 * @param {Function} [define.plan] Returns 'reset' indicate reset immediately.
	 * @param {Function} [define.count] count is used to determin data task.
	 * @param {Function} [define.onDirty] count is used to determin data task.
	 */
	
	
	function Task(define) {
	  define = define || {};
	  this._reset = define.reset;
	  this._plan = define.plan;
	  this._count = define.count;
	  this._onDirty = define.onDirty;
	  this._dirty = true; // Context must be specified implicitly, to
	  // avoid miss update context when model changed.
	
	  this.context;
	}
	
	var taskProto = Task.prototype;
	/**
	 * @param {Object} performArgs
	 * @param {number} [performArgs.step] Specified step.
	 * @param {number} [performArgs.skip] Skip customer perform call.
	 * @param {number} [performArgs.modBy] Sampling window size.
	 * @param {number} [performArgs.modDataCount] Sampling count.
	 */
	
	taskProto.perform = function (performArgs) {
	  var upTask = this._upstream;
	  var skip = performArgs && performArgs.skip; // TODO some refactor.
	  // Pull data. Must pull data each time, because context.data
	  // may be updated by Series.setData.
	
	  if (this._dirty && upTask) {
	    var context = this.context;
	    context.data = context.outputData = upTask.context.outputData;
	  }
	
	  if (this.__pipeline) {
	    this.__pipeline.currentTask = this;
	  }
	
	  var planResult;
	
	  if (this._plan && !skip) {
	    planResult = this._plan(this.context);
	  } // Support sharding by mod, which changes the render sequence and makes the rendered graphic
	  // elements uniformed distributed when progress, especially when moving or zooming.
	
	
	  var lastModBy = normalizeModBy(this._modBy);
	  var lastModDataCount = this._modDataCount || 0;
	  var modBy = normalizeModBy(performArgs && performArgs.modBy);
	  var modDataCount = performArgs && performArgs.modDataCount || 0;
	
	  if (lastModBy !== modBy || lastModDataCount !== modDataCount) {
	    planResult = 'reset';
	  }
	
	  function normalizeModBy(val) {
	    !(val >= 1) && (val = 1); // jshint ignore:line
	
	    return val;
	  }
	
	  var forceFirstProgress;
	
	  if (this._dirty || planResult === 'reset') {
	    this._dirty = false;
	    forceFirstProgress = reset(this, skip);
	  }
	
	  this._modBy = modBy;
	  this._modDataCount = modDataCount;
	  var step = performArgs && performArgs.step;
	
	  if (upTask) {
	    this._dueEnd = upTask._outputDueEnd;
	  } // DataTask or overallTask
	  else {
	      this._dueEnd = this._count ? this._count(this.context) : Infinity;
	    } // Note: Stubs, that its host overall task let it has progress, has progress.
	  // If no progress, pass index from upstream to downstream each time plan called.
	
	
	  if (this._progress) {
	    var start = this._dueIndex;
	    var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
	
	    if (!skip && (forceFirstProgress || start < end)) {
	      var progress = this._progress;
	
	      if (isArray(progress)) {
	        for (var i = 0; i < progress.length; i++) {
	          doProgress(this, progress[i], start, end, modBy, modDataCount);
	        }
	      } else {
	        doProgress(this, progress, start, end, modBy, modDataCount);
	      }
	    }
	
	    this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
	    // input data is the same, so use `dueIndex` as `outputDueEnd`.
	
	    var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
	    this._outputDueEnd = outputDueEnd;
	  } else {
	    // (1) Some overall task has no progress.
	    // (2) Stubs, that its host overall task do not let it has progress, has no progress.
	    // This should always be performed so it can be passed to downstream.
	    this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
	  }
	
	  return this.unfinished();
	};
	
	var iterator = function () {
	  var end;
	  var current;
	  var modBy;
	  var modDataCount;
	  var winCount;
	  var it = {
	    reset: function (s, e, sStep, sCount) {
	      current = s;
	      end = e;
	      modBy = sStep;
	      modDataCount = sCount;
	      winCount = Math.ceil(modDataCount / modBy);
	      it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
	    }
	  };
	  return it;
	
	  function sequentialNext() {
	    return current < end ? current++ : null;
	  }
	
	  function modNext() {
	    var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
	    var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
	    // Use normal linear rendering mode.
	    : current;
	    current++;
	    return result;
	  }
	}();
	
	taskProto.dirty = function () {
	  this._dirty = true;
	  this._onDirty && this._onDirty(this.context);
	};
	
	function doProgress(taskIns, progress, start, end, modBy, modDataCount) {
	  iterator.reset(start, end, modBy, modDataCount);
	  taskIns._callingProgress = progress;
	
	  taskIns._callingProgress({
	    start: start,
	    end: end,
	    count: end - start,
	    next: iterator.next
	  }, taskIns.context);
	}
	
	function reset(taskIns, skip) {
	  taskIns._dueIndex = taskIns._outputDueEnd = taskIns._dueEnd = 0;
	  taskIns._settedOutputEnd = null;
	  var progress;
	  var forceFirstProgress;
	
	  if (!skip && taskIns._reset) {
	    progress = taskIns._reset(taskIns.context);
	
	    if (progress && progress.progress) {
	      forceFirstProgress = progress.forceFirstProgress;
	      progress = progress.progress;
	    } // To simplify no progress checking, array must has item.
	
	
	    if (isArray(progress) && !progress.length) {
	      progress = null;
	    }
	  }
	
	  taskIns._progress = progress;
	  taskIns._modBy = taskIns._modDataCount = null;
	  var downstream = taskIns._downstream;
	  downstream && downstream.dirty();
	  return forceFirstProgress;
	}
	/**
	 * @return {boolean}
	 */
	
	
	taskProto.unfinished = function () {
	  return this._progress && this._dueIndex < this._dueEnd;
	};
	/**
	 * @param {Object} downTask The downstream task.
	 * @return {Object} The downstream task.
	 */
	
	
	taskProto.pipe = function (downTask) {
	  // If already downstream, do not dirty downTask.
	  if (this._downstream !== downTask || this._dirty) {
	    this._downstream = downTask;
	    downTask._upstream = this;
	    downTask.dirty();
	  }
	};
	
	taskProto.dispose = function () {
	  if (this._disposed) {
	    return;
	  }
	
	  this._upstream && (this._upstream._downstream = null);
	  this._downstream && (this._downstream._upstream = null);
	  this._dirty = false;
	  this._disposed = true;
	};
	
	taskProto.getUpstream = function () {
	  return this._upstream;
	};
	
	taskProto.getDownstream = function () {
	  return this._downstream;
	};
	
	taskProto.setOutputEnd = function (end) {
	  // This only happend in dataTask, dataZoom, map, currently.
	  // where dataZoom do not set end each time, but only set
	  // when reset. So we should record the setted end, in case
	  // that the stub of dataZoom perform again and earse the
	  // setted end by upstream.
	  this._outputDueEnd = this._settedOutputEnd = end;
	}; ///////////////////////////////////////////////////////////
	// For stream debug (Should be commented out after used!)
	// Usage: printTask(this, 'begin');
	// Usage: printTask(this, null, {someExtraProp});
	// function printTask(task, prefix, extra) {
	//     window.ecTaskUID == null && (window.ecTaskUID = 0);
	//     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
	//     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
	//     var props = [];
	//     if (task.__pipeline) {
	//         var val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
	//         props.push({text: 'idx', value: val});
	//     } else {
	//         var stubCount = 0;
	//         task.agentStubMap.each(() => stubCount++);
	//         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
	//     }
	//     props.push({text: 'uid', value: task.uidDebug});
	//     if (task.__pipeline) {
	//         props.push({text: 'pid', value: task.__pipeline.id});
	//         task.agent && props.push(
	//             {text: 'stubFor', value: task.agent.uidDebug}
	//         );
	//     }
	//     props.push(
	//         {text: 'dirty', value: task._dirty},
	//         {text: 'dueIndex', value: task._dueIndex},
	//         {text: 'dueEnd', value: task._dueEnd},
	//         {text: 'outputDueEnd', value: task._outputDueEnd}
	//     );
	//     if (extra) {
	//         Object.keys(extra).forEach(key => {
	//             props.push({text: key, value: extra[key]});
	//         });
	//     }
	//     var args = ['color: blue'];
	//     var msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
	//         args.push('color: black', 'color: red'),
	//         `${item.text}: %c${item.value}`
	//     )).join('%c, ');
	//     console.log.apply(console, [msg].concat(args));
	//     // console.log(this);
	// }
	
	
	exports.createTask = createTask;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Group = __webpack_require__(230);
	
	var componentUtil = __webpack_require__(304);
	
	var clazzUtil = __webpack_require__(263);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var Component = function () {
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	  this.group = new Group();
	  /**
	   * @type {string}
	   * @readOnly
	   */
	
	  this.uid = componentUtil.getUID('viewComponent');
	};
	
	Component.prototype = {
	  constructor: Component,
	  init: function (ecModel, api) {},
	  render: function (componentModel, ecModel, api, payload) {},
	  dispose: function () {},
	
	  /**
	   * @param {string} eventType
	   * @param {Object} query
	   * @param {module:zrender/Element} targetEl
	   * @param {Object} packedEvent
	   * @return {boolen} Pass only when return `true`.
	   */
	  filterForExposedEvent: null
	};
	var componentProto = Component.prototype;
	
	componentProto.updateView = componentProto.updateLayout = componentProto.updateVisual = function (seriesModel, ecModel, api, payload) {// Do nothing;
	}; // Enable Component.extend.
	
	
	clazzUtil.enableClassExtend(Component); // Enable capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(Component, {
	  registerWhenExtend: true
	});
	var _default = Component;
	module.exports = _default;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	
	var Group = __webpack_require__(230);
	
	var componentUtil = __webpack_require__(304);
	
	var clazzUtil = __webpack_require__(263);
	
	var modelUtil = __webpack_require__(261);
	
	var graphicUtil = __webpack_require__(268);
	
	var _task = __webpack_require__(323);
	
	var createTask = _task.createTask;
	
	var createRenderPlanner = __webpack_require__(326);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = modelUtil.makeInner();
	var renderPlanner = createRenderPlanner();
	
	function Chart() {
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	  this.group = new Group();
	  /**
	   * @type {string}
	   * @readOnly
	   */
	
	  this.uid = componentUtil.getUID('viewChart');
	  this.renderTask = createTask({
	    plan: renderTaskPlan,
	    reset: renderTaskReset
	  });
	  this.renderTask.context = {
	    view: this
	  };
	}
	
	Chart.prototype = {
	  type: 'chart',
	
	  /**
	   * Init the chart.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  init: function (ecModel, api) {},
	
	  /**
	   * Render the chart.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  render: function (seriesModel, ecModel, api, payload) {},
	
	  /**
	   * Highlight series or specified data item.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  highlight: function (seriesModel, ecModel, api, payload) {
	    toggleHighlight(seriesModel.getData(), payload, 'emphasis');
	  },
	
	  /**
	   * Downplay series or specified data item.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  downplay: function (seriesModel, ecModel, api, payload) {
	    toggleHighlight(seriesModel.getData(), payload, 'normal');
	  },
	
	  /**
	   * Remove self.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  remove: function (ecModel, api) {
	    this.group.removeAll();
	  },
	
	  /**
	   * Dispose self.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  dispose: function () {},
	
	  /**
	   * Rendering preparation in progressive mode.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  incrementalPrepareRender: null,
	
	  /**
	   * Render in progressive mode.
	   * @param  {Object} params See taskParams in `stream/task.js`
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  incrementalRender: null,
	
	  /**
	   * Update transform directly.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   * @return {Object} {update: true}
	   */
	  updateTransform: null,
	
	  /**
	   * The view contains the given point.
	   * @interface
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  // containPoint: function () {}
	
	  /**
	   * @param {string} eventType
	   * @param {Object} query
	   * @param {module:zrender/Element} targetEl
	   * @param {Object} packedEvent
	   * @return {boolen} Pass only when return `true`.
	   */
	  filterForExposedEvent: null
	};
	var chartProto = Chart.prototype;
	
	chartProto.updateView = chartProto.updateLayout = chartProto.updateVisual = function (seriesModel, ecModel, api, payload) {
	  this.render(seriesModel, ecModel, api, payload);
	};
	/**
	 * Set state of single element
	 * @param {module:zrender/Element} el
	 * @param {string} state 'normal'|'emphasis'
	 * @param {number} highlightDigit
	 */
	
	
	function elSetState(el, state, highlightDigit) {
	  if (el) {
	    el.trigger(state, highlightDigit);
	
	    if (el.isGroup // Simple optimize.
	    && !graphicUtil.isHighDownDispatcher(el)) {
	      for (var i = 0, len = el.childCount(); i < len; i++) {
	        elSetState(el.childAt(i), state, highlightDigit);
	      }
	    }
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Object} payload
	 * @param {string} state 'normal'|'emphasis'
	 */
	
	
	function toggleHighlight(data, payload, state) {
	  var dataIndex = modelUtil.queryDataIndex(data, payload);
	  var highlightDigit = payload && payload.highlightKey != null ? graphicUtil.getHighlightDigit(payload.highlightKey) : null;
	
	  if (dataIndex != null) {
	    each(modelUtil.normalizeToArray(dataIndex), function (dataIdx) {
	      elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
	    });
	  } else {
	    data.eachItemGraphicEl(function (el) {
	      elSetState(el, state, highlightDigit);
	    });
	  }
	} // Enable Chart.extend.
	
	
	clazzUtil.enableClassExtend(Chart, ['dispose']); // Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(Chart, {
	  registerWhenExtend: true
	});
	
	Chart.markUpdateMethod = function (payload, methodName) {
	  inner(payload).updateMethod = methodName;
	};
	
	function renderTaskPlan(context) {
	  return renderPlanner(context.model);
	}
	
	function renderTaskReset(context) {
	  var seriesModel = context.model;
	  var ecModel = context.ecModel;
	  var api = context.api;
	  var payload = context.payload; // ???! remove updateView updateVisual
	
	  var progressiveRender = seriesModel.pipelineContext.progressiveRender;
	  var view = context.view;
	  var updateMethod = payload && inner(payload).updateMethod;
	  var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
	  // is less than progressive threshold.
	  : 'render';
	
	  if (methodName !== 'render') {
	    view[methodName](seriesModel, ecModel, api, payload);
	  }
	
	  return progressMethodMap[methodName];
	}
	
	var progressMethodMap = {
	  incrementalPrepareRender: {
	    progress: function (params, context) {
	      context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
	    }
	  },
	  render: {
	    // Put view.render in `progress` to support appendData. But in this case
	    // view.render should not be called in reset, otherwise it will be called
	    // twise. Use `forceFirstProgress` to make sure that view.render is called
	    // in any cases.
	    forceFirstProgress: true,
	    progress: function (params, context) {
	      context.view.render(context.model, context.ecModel, context.api, context.payload);
	    }
	  }
	};
	var _default = Chart;
	module.exports = _default;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _model = __webpack_require__(261);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @return {string} If large mode changed, return string 'reset';
	 */
	function _default() {
	  var inner = makeInner();
	  return function (seriesModel) {
	    var fields = inner(seriesModel);
	    var pipelineContext = seriesModel.pipelineContext;
	    var originalLarge = fields.large;
	    var originalProgressive = fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
	    // exists. See #11611 . Probably we need to modify this structure, see the comment
	    // on `performRawSeries` in `Schedular.js`.
	
	    var large = fields.large = pipelineContext && pipelineContext.large;
	    var progressive = fields.progressiveRender = pipelineContext && pipelineContext.progressiveRender;
	    return !!(originalLarge ^ large || originalProgressive ^ progressive) && 'reset';
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ORIGIN_METHOD = '\0__throttleOriginMethod';
	var RATE = '\0__throttleRate';
	var THROTTLE_TYPE = '\0__throttleType';
	/**
	 * @public
	 * @param {(Function)} fn
	 * @param {number} [delay=0] Unit: ms.
	 * @param {boolean} [debounce=false]
	 *        true: If call interval less than `delay`, only the last call works.
	 *        false: If call interval less than `delay, call works on fixed rate.
	 * @return {(Function)} throttled fn.
	 */
	
	function throttle(fn, delay, debounce) {
	  var currCall;
	  var lastCall = 0;
	  var lastExec = 0;
	  var timer = null;
	  var diff;
	  var scope;
	  var args;
	  var debounceNextCall;
	  delay = delay || 0;
	
	  function exec() {
	    lastExec = new Date().getTime();
	    timer = null;
	    fn.apply(scope, args || []);
	  }
	
	  var cb = function () {
	    currCall = new Date().getTime();
	    scope = this;
	    args = arguments;
	    var thisDelay = debounceNextCall || delay;
	    var thisDebounce = debounceNextCall || debounce;
	    debounceNextCall = null;
	    diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
	    clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
	    // than a new call of `cb`, that is, preserving the command order. Consider
	    // calculating "scale rate" when roaming as an example. When a call of `cb`
	    // happens, either the `exec` is called dierectly, or the call is delayed.
	    // But the delayed call should never be later than next call of `cb`. Under
	    // this assurance, we can simply update view state each time `dispatchAction`
	    // triggered by user roaming, but not need to add extra code to avoid the
	    // state being "rolled-back".
	
	    if (thisDebounce) {
	      timer = setTimeout(exec, thisDelay);
	    } else {
	      if (diff >= 0) {
	        exec();
	      } else {
	        timer = setTimeout(exec, -diff);
	      }
	    }
	
	    lastCall = currCall;
	  };
	  /**
	   * Clear throttle.
	   * @public
	   */
	
	
	  cb.clear = function () {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  };
	  /**
	   * Enable debounce once.
	   */
	
	
	  cb.debounceNextCall = function (debounceDelay) {
	    debounceNextCall = debounceDelay;
	  };
	
	  return cb;
	}
	/**
	 * Create throttle method or update throttle rate.
	 *
	 * @example
	 * ComponentView.prototype.render = function () {
	 *     ...
	 *     throttle.createOrUpdate(
	 *         this,
	 *         '_dispatchAction',
	 *         this.model.get('throttle'),
	 *         'fixRate'
	 *     );
	 * };
	 * ComponentView.prototype.remove = function () {
	 *     throttle.clear(this, '_dispatchAction');
	 * };
	 * ComponentView.prototype.dispose = function () {
	 *     throttle.clear(this, '_dispatchAction');
	 * };
	 *
	 * @public
	 * @param {Object} obj
	 * @param {string} fnAttr
	 * @param {number} [rate]
	 * @param {string} [throttleType='fixRate'] 'fixRate' or 'debounce'
	 * @return {Function} throttled function.
	 */
	
	
	function createOrUpdate(obj, fnAttr, rate, throttleType) {
	  var fn = obj[fnAttr];
	
	  if (!fn) {
	    return;
	  }
	
	  var originFn = fn[ORIGIN_METHOD] || fn;
	  var lastThrottleType = fn[THROTTLE_TYPE];
	  var lastRate = fn[RATE];
	
	  if (lastRate !== rate || lastThrottleType !== throttleType) {
	    if (rate == null || !throttleType) {
	      return obj[fnAttr] = originFn;
	    }
	
	    fn = obj[fnAttr] = throttle(originFn, rate, throttleType === 'debounce');
	    fn[ORIGIN_METHOD] = originFn;
	    fn[THROTTLE_TYPE] = throttleType;
	    fn[RATE] = rate;
	  }
	
	  return fn;
	}
	/**
	 * Clear throttle. Example see throttle.createOrUpdate.
	 *
	 * @public
	 * @param {Object} obj
	 * @param {string} fnAttr
	 */
	
	
	function clear(obj, fnAttr) {
	  var fn = obj[fnAttr];
	
	  if (fn && fn[ORIGIN_METHOD]) {
	    obj[fnAttr] = fn[ORIGIN_METHOD];
	  }
	}
	
	exports.throttle = throttle;
	exports.createOrUpdate = createOrUpdate;
	exports.clear = clear;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Gradient = __webpack_require__(299);
	
	var _util = __webpack_require__(220);
	
	var isFunction = _util.isFunction;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = {
	  createOnAllSeries: true,
	  performRawSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var colorAccessPath = (seriesModel.visualColorAccessPath || 'itemStyle.color').split('.'); // Set in itemStyle
	
	    var color = seriesModel.get(colorAccessPath);
	    var colorCallback = isFunction(color) && !(color instanceof Gradient) ? color : null; // Default color
	
	    if (!color || colorCallback) {
	      color = seriesModel.getColorFromPalette( // TODO series count changed.
	      seriesModel.name, null, ecModel.getSeriesCount());
	    }
	
	    data.setVisual('color', color);
	    var borderColorAccessPath = (seriesModel.visualBorderColorAccessPath || 'itemStyle.borderColor').split('.');
	    var borderColor = seriesModel.get(borderColorAccessPath);
	    data.setVisual('borderColor', borderColor); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      if (colorCallback) {
	        data.each(function (idx) {
	          data.setItemVisual(idx, 'color', colorCallback(seriesModel.getDataParams(idx)));
	        });
	      } // itemStyle in each data item
	
	
	      var dataEach = function (data, idx) {
	        var itemModel = data.getItemModel(idx);
	        var color = itemModel.get(colorAccessPath, true);
	        var borderColor = itemModel.get(borderColorAccessPath, true);
	
	        if (color != null) {
	          data.setItemVisual(idx, 'color', color);
	        }
	
	        if (borderColor != null) {
	          data.setItemVisual(idx, 'borderColor', borderColor);
	        }
	      };
	
	      return {
	        dataEach: data.hasItemOption ? dataEach : null
	      };
	    }
	  }
	};
	module.exports = _default;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var lang = __webpack_require__(330);
	
	var _dataProvider = __webpack_require__(322);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(dom, ecModel) {
	  var ariaModel = ecModel.getModel('aria');
	
	  if (!ariaModel.get('show')) {
	    return;
	  } else if (ariaModel.get('description')) {
	    dom.setAttribute('aria-label', ariaModel.get('description'));
	    return;
	  }
	
	  var seriesCnt = 0;
	  ecModel.eachSeries(function (seriesModel, idx) {
	    ++seriesCnt;
	  }, this);
	  var maxDataCnt = ariaModel.get('data.maxCount') || 10;
	  var maxSeriesCnt = ariaModel.get('series.maxCount') || 10;
	  var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
	  var ariaLabel;
	
	  if (seriesCnt < 1) {
	    // No series, no aria label
	    return;
	  } else {
	    var title = getTitle();
	
	    if (title) {
	      ariaLabel = replace(getConfig('general.withTitle'), {
	        title: title
	      });
	    } else {
	      ariaLabel = getConfig('general.withoutTitle');
	    }
	
	    var seriesLabels = [];
	    var prefix = seriesCnt > 1 ? 'series.multiple.prefix' : 'series.single.prefix';
	    ariaLabel += replace(getConfig(prefix), {
	      seriesCount: seriesCnt
	    });
	    ecModel.eachSeries(function (seriesModel, idx) {
	      if (idx < displaySeriesCnt) {
	        var seriesLabel;
	        var seriesName = seriesModel.get('name');
	        var seriesTpl = 'series.' + (seriesCnt > 1 ? 'multiple' : 'single') + '.';
	        seriesLabel = getConfig(seriesName ? seriesTpl + 'withName' : seriesTpl + 'withoutName');
	        seriesLabel = replace(seriesLabel, {
	          seriesId: seriesModel.seriesIndex,
	          seriesName: seriesModel.get('name'),
	          seriesType: getSeriesTypeName(seriesModel.subType)
	        });
	        var data = seriesModel.getData();
	        window.data = data;
	
	        if (data.count() > maxDataCnt) {
	          // Show part of data
	          seriesLabel += replace(getConfig('data.partialData'), {
	            displayCnt: maxDataCnt
	          });
	        } else {
	          seriesLabel += getConfig('data.allData');
	        }
	
	        var dataLabels = [];
	
	        for (var i = 0; i < data.count(); i++) {
	          if (i < maxDataCnt) {
	            var name = data.getName(i);
	            var value = retrieveRawValue(data, i);
	            dataLabels.push(replace(name ? getConfig('data.withName') : getConfig('data.withoutName'), {
	              name: name,
	              value: value
	            }));
	          }
	        }
	
	        seriesLabel += dataLabels.join(getConfig('data.separator.middle')) + getConfig('data.separator.end');
	        seriesLabels.push(seriesLabel);
	      }
	    });
	    ariaLabel += seriesLabels.join(getConfig('series.multiple.separator.middle')) + getConfig('series.multiple.separator.end');
	    dom.setAttribute('aria-label', ariaLabel);
	  }
	
	  function replace(str, keyValues) {
	    if (typeof str !== 'string') {
	      return str;
	    }
	
	    var result = str;
	    zrUtil.each(keyValues, function (value, key) {
	      result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
	    });
	    return result;
	  }
	
	  function getConfig(path) {
	    var userConfig = ariaModel.get(path);
	
	    if (userConfig == null) {
	      var pathArr = path.split('.');
	      var result = lang.aria;
	
	      for (var i = 0; i < pathArr.length; ++i) {
	        result = result[pathArr[i]];
	      }
	
	      return result;
	    } else {
	      return userConfig;
	    }
	  }
	
	  function getTitle() {
	    var title = ecModel.getModel('title').option;
	
	    if (title && title.length) {
	      title = title[0];
	    }
	
	    return title && title.text;
	  }
	
	  function getSeriesTypeName(type) {
	    return lang.series.typeNames[type] || '自定义图';
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Language: (Simplified) Chinese.
	 */
	var _default = {
	  legend: {
	    selector: {
	      all: '全选',
	      inverse: '反选'
	    }
	  },
	  toolbox: {
	    brush: {
	      title: {
	        rect: '矩形选择',
	        polygon: '圈选',
	        lineX: '横向选择',
	        lineY: '纵向选择',
	        keep: '保持选择',
	        clear: '清除选择'
	      }
	    },
	    dataView: {
	      title: '数据视图',
	      lang: ['数据视图', '关闭', '刷新']
	    },
	    dataZoom: {
	      title: {
	        zoom: '区域缩放',
	        back: '区域缩放还原'
	      }
	    },
	    magicType: {
	      title: {
	        line: '切换为折线图',
	        bar: '切换为柱状图',
	        stack: '切换为堆叠',
	        tiled: '切换为平铺'
	      }
	    },
	    restore: {
	      title: '还原'
	    },
	    saveAsImage: {
	      title: '保存为图片',
	      lang: ['右键另存为图片']
	    }
	  },
	  series: {
	    typeNames: {
	      pie: '饼图',
	      bar: '柱状图',
	      line: '折线图',
	      scatter: '散点图',
	      effectScatter: '涟漪散点图',
	      radar: '雷达图',
	      tree: '树图',
	      treemap: '矩形树图',
	      boxplot: '箱型图',
	      candlestick: 'K线图',
	      k: 'K线图',
	      heatmap: '热力图',
	      map: '地图',
	      parallel: '平行坐标图',
	      lines: '线图',
	      graph: '关系图',
	      sankey: '桑基图',
	      funnel: '漏斗图',
	      gauge: '仪表盘图',
	      pictorialBar: '象形柱图',
	      themeRiver: '主题河流图',
	      sunburst: '旭日图'
	    }
	  },
	  aria: {
	    general: {
	      withTitle: '这是一个关于“{title}”的图表。',
	      withoutTitle: '这是一个图表，'
	    },
	    series: {
	      single: {
	        prefix: '',
	        withName: '图表类型是{seriesType}，表示{seriesName}。',
	        withoutName: '图表类型是{seriesType}。'
	      },
	      multiple: {
	        prefix: '它由{seriesCount}个图表系列组成。',
	        withName: '第{seriesId}个系列是一个表示{seriesName}的{seriesType}，',
	        withoutName: '第{seriesId}个系列是一个{seriesType}，',
	        separator: {
	          middle: '；',
	          end: '。'
	        }
	      }
	    },
	    data: {
	      allData: '其数据是——',
	      partialData: '其中，前{displayCnt}项是——',
	      withName: '{name}的数据是{value}',
	      withoutName: '{value}',
	      separator: {
	        middle: '，',
	        end: ''
	      }
	    }
	  }
	};
	module.exports = _default;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var textContain = __webpack_require__(255);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	/**
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Object} [opts]
	 * @param {string} [opts.text]
	 * @param {string} [opts.color]
	 * @param {string} [opts.textColor]
	 * @return {module:zrender/Element}
	 */
	
	function _default(api, opts) {
	  opts = opts || {};
	  zrUtil.defaults(opts, {
	    text: 'loading',
	    textColor: '#000',
	    fontSize: '12px',
	    maskColor: 'rgba(255, 255, 255, 0.8)',
	    showSpinner: true,
	    color: '#c23531',
	    spinnerRadius: 10,
	    lineWidth: 5,
	    zlevel: 0
	  });
	  var group = new graphic.Group();
	  var mask = new graphic.Rect({
	    style: {
	      fill: opts.maskColor
	    },
	    zlevel: opts.zlevel,
	    z: 10000
	  });
	  group.add(mask);
	  var font = opts.fontSize + ' sans-serif';
	  var labelRect = new graphic.Rect({
	    style: {
	      fill: 'none',
	      text: opts.text,
	      font: font,
	      textPosition: 'right',
	      textDistance: 10,
	      textFill: opts.textColor
	    },
	    zlevel: opts.zlevel,
	    z: 10001
	  });
	  group.add(labelRect);
	
	  if (opts.showSpinner) {
	    var arc = new graphic.Arc({
	      shape: {
	        startAngle: -PI / 2,
	        endAngle: -PI / 2 + 0.1,
	        r: opts.spinnerRadius
	      },
	      style: {
	        stroke: opts.color,
	        lineCap: 'round',
	        lineWidth: opts.lineWidth
	      },
	      zlevel: opts.zlevel,
	      z: 10001
	    });
	    arc.animateShape(true).when(1000, {
	      endAngle: PI * 3 / 2
	    }).start('circularInOut');
	    arc.animateShape(true).when(1000, {
	      startAngle: PI * 3 / 2
	    }).delay(300).start('circularInOut');
	    group.add(arc);
	  } // Inject resize
	
	
	  group.resize = function () {
	    var textWidth = textContain.getWidth(opts.text, font);
	    var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
	    // textDistance needs to be calculated when both animation and text exist
	
	    var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 // only show the text
	    - (opts.showSpinner ? 0 : textWidth / 2);
	    var cy = api.getHeight() / 2;
	    opts.showSpinner && arc.setShape({
	      cx: cx,
	      cy: cy
	    });
	    labelRect.setShape({
	      x: cx - r,
	      y: cy - r,
	      width: r * 2,
	      height: r * 2
	    });
	    mask.setShape({
	      x: 0,
	      y: 0,
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	  };
	
	  group.resize();
	  return group;
	}
	
	module.exports = _default;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	var map = _util.map;
	var isFunction = _util.isFunction;
	var createHashMap = _util.createHashMap;
	var noop = _util.noop;
	
	var _task = __webpack_require__(323);
	
	var createTask = _task.createTask;
	
	var _component = __webpack_require__(304);
	
	var getUID = _component.getUID;
	
	var GlobalModel = __webpack_require__(260);
	
	var ExtensionAPI = __webpack_require__(314);
	
	var _model = __webpack_require__(261);
	
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/stream/Scheduler
	 */
	
	/**
	 * @constructor
	 */
	function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
	  this.ecInstance = ecInstance;
	  this.api = api;
	  this.unfinished; // Fix current processors in case that in some rear cases that
	  // processors might be registered after echarts instance created.
	  // Register processors incrementally for a echarts instance is
	  // not supported by this stream architecture.
	
	  var dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
	  var visualHandlers = this._visualHandlers = visualHandlers.slice();
	  this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
	  /**
	   * @private
	   * @type {
	   *     [handlerUID: string]: {
	   *         seriesTaskMap?: {
	   *             [seriesUID: string]: Task
	   *         },
	   *         overallTask?: Task
	   *     }
	   * }
	   */
	
	  this._stageTaskMap = createHashMap();
	}
	
	var proto = Scheduler.prototype;
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} payload
	 */
	
	proto.restoreData = function (ecModel, payload) {
	  // TODO: Only restore needed series and components, but not all components.
	  // Currently `restoreData` of all of the series and component will be called.
	  // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
	  // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
	  // and some components like coordinate system, axes, dataZoom, visualMap only
	  // need their target series refresh.
	  // (1) If we are implementing this feature some day, we should consider these cases:
	  // if a data processor depends on a component (e.g., dataZoomProcessor depends
	  // on the settings of `dataZoom`), it should be re-performed if the component
	  // is modified by `setOption`.
	  // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
	  // it should be re-performed when the result array of `getTargetSeries` changed.
	  // We use `dependencies` to cover these issues.
	  // (3) How to update target series when coordinate system related components modified.
	  // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
	  // and this case all of the tasks will be set as dirty.
	  ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
	  // depends on all of the series.
	  // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
	  // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
	  // that the overall task is set as dirty and to be performed, otherwise it probably cause
	  // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
	  // probably cause state chaos (consider `dataZoomProcessor`).
	
	  this._stageTaskMap.each(function (taskRecord) {
	    var overallTask = taskRecord.overallTask;
	    overallTask && overallTask.dirty();
	  });
	}; // If seriesModel provided, incremental threshold is check by series data.
	
	
	proto.getPerformArgs = function (task, isBlock) {
	  // For overall task
	  if (!task.__pipeline) {
	    return;
	  }
	
	  var pipeline = this._pipelineMap.get(task.__pipeline.id);
	
	  var pCtx = pipeline.context;
	  var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
	  var step = incremental ? pipeline.step : null;
	  var modDataCount = pCtx && pCtx.modDataCount;
	  var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
	  return {
	    step: step,
	    modBy: modBy,
	    modDataCount: modDataCount
	  };
	};
	
	proto.getPipeline = function (pipelineId) {
	  return this._pipelineMap.get(pipelineId);
	};
	/**
	 * Current, progressive rendering starts from visual and layout.
	 * Always detect render mode in the same stage, avoiding that incorrect
	 * detection caused by data filtering.
	 * Caution:
	 * `updateStreamModes` use `seriesModel.getData()`.
	 */
	
	
	proto.updateStreamModes = function (seriesModel, view) {
	  var pipeline = this._pipelineMap.get(seriesModel.uid);
	
	  var data = seriesModel.getData();
	  var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
	  // animation frame. Note that some types of series do not provide
	  // `view.incrementalPrepareRender` but support `chart.appendData`. We
	  // use the term `incremental` but not `progressive` to describe the
	  // case that `chart.appendData`.
	
	  var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
	  var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
	  // see `test/candlestick-large3.html`
	
	  var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
	  seriesModel.pipelineContext = pipeline.context = {
	    progressiveRender: progressiveRender,
	    modDataCount: modDataCount,
	    large: large
	  };
	};
	
	proto.restorePipelines = function (ecModel) {
	  var scheduler = this;
	  var pipelineMap = scheduler._pipelineMap = createHashMap();
	  ecModel.eachSeries(function (seriesModel) {
	    var progressive = seriesModel.getProgressive();
	    var pipelineId = seriesModel.uid;
	    pipelineMap.set(pipelineId, {
	      id: pipelineId,
	      head: null,
	      tail: null,
	      threshold: seriesModel.getProgressiveThreshold(),
	      progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
	      blockIndex: -1,
	      step: Math.round(progressive || 700),
	      count: 0
	    });
	    pipe(scheduler, seriesModel, seriesModel.dataTask);
	  });
	};
	
	proto.prepareStageTasks = function () {
	  var stageTaskMap = this._stageTaskMap;
	  var ecModel = this.ecInstance.getModel();
	  var api = this.api;
	  each(this._allHandlers, function (handler) {
	    var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, []);
	    handler.reset && createSeriesStageTask(this, handler, record, ecModel, api);
	    handler.overallReset && createOverallStageTask(this, handler, record, ecModel, api);
	  }, this);
	};
	
	proto.prepareView = function (view, model, ecModel, api) {
	  var renderTask = view.renderTask;
	  var context = renderTask.context;
	  context.model = model;
	  context.ecModel = ecModel;
	  context.api = api;
	  renderTask.__block = !view.incrementalPrepareRender;
	  pipe(this, model, renderTask);
	};
	
	proto.performDataProcessorTasks = function (ecModel, payload) {
	  // If we do not use `block` here, it should be considered when to update modes.
	  performStageTasks(this, this._dataProcessorHandlers, ecModel, payload, {
	    block: true
	  });
	}; // opt
	// opt.visualType: 'visual' or 'layout'
	// opt.setDirty
	
	
	proto.performVisualTasks = function (ecModel, payload, opt) {
	  performStageTasks(this, this._visualHandlers, ecModel, payload, opt);
	};
	
	function performStageTasks(scheduler, stageHandlers, ecModel, payload, opt) {
	  opt = opt || {};
	  var unfinished;
	  each(stageHandlers, function (stageHandler, idx) {
	    if (opt.visualType && opt.visualType !== stageHandler.visualType) {
	      return;
	    }
	
	    var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
	
	    var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
	    var overallTask = stageHandlerRecord.overallTask;
	
	    if (overallTask) {
	      var overallNeedDirty;
	      var agentStubMap = overallTask.agentStubMap;
	      agentStubMap.each(function (stub) {
	        if (needSetDirty(opt, stub)) {
	          stub.dirty();
	          overallNeedDirty = true;
	        }
	      });
	      overallNeedDirty && overallTask.dirty();
	      updatePayload(overallTask, payload);
	      var performArgs = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
	      // then execute the overall task. And stub will call seriesModel.setData,
	      // which ensures that in the overallTask seriesModel.getData() will not
	      // return incorrect data.
	
	      agentStubMap.each(function (stub) {
	        stub.perform(performArgs);
	      });
	      unfinished |= overallTask.perform(performArgs);
	    } else if (seriesTaskMap) {
	      seriesTaskMap.each(function (task, pipelineId) {
	        if (needSetDirty(opt, task)) {
	          task.dirty();
	        }
	
	        var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
	        // if intending to decalare `performRawSeries` in handlers, only
	        // stream-independent (specifically, data item independent) operations can be
	        // performed. Because is a series is filtered, most of the tasks will not
	        // be performed. A stream-dependent operation probably cause wrong biz logic.
	        // Perhaps we should not provide a separate callback for this case instead
	        // of providing the config `performRawSeries`. The stream-dependent operaions
	        // and stream-independent operations should better not be mixed.
	
	        performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
	        updatePayload(task, payload);
	        unfinished |= task.perform(performArgs);
	      });
	    }
	  });
	
	  function needSetDirty(opt, task) {
	    return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
	  }
	
	  scheduler.unfinished |= unfinished;
	}
	
	proto.performSeriesTasks = function (ecModel) {
	  var unfinished;
	  ecModel.eachSeries(function (seriesModel) {
	    // Progress to the end for dataInit and dataRestore.
	    unfinished |= seriesModel.dataTask.perform();
	  });
	  this.unfinished |= unfinished;
	};
	
	proto.plan = function () {
	  // Travel pipelines, check block.
	  this._pipelineMap.each(function (pipeline) {
	    var task = pipeline.tail;
	
	    do {
	      if (task.__block) {
	        pipeline.blockIndex = task.__idxInPipeline;
	        break;
	      }
	
	      task = task.getUpstream();
	    } while (task);
	  });
	};
	
	var updatePayload = proto.updatePayload = function (task, payload) {
	  payload !== 'remain' && (task.context.payload = payload);
	};
	
	function createSeriesStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
	  var seriesTaskMap = stageHandlerRecord.seriesTaskMap || (stageHandlerRecord.seriesTaskMap = createHashMap());
	  var seriesType = stageHandler.seriesType;
	  var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
	  // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
	  // it works but it may cause other irrelevant charts blocked.
	
	  if (stageHandler.createOnAllSeries) {
	    ecModel.eachRawSeries(create);
	  } else if (seriesType) {
	    ecModel.eachRawSeriesByType(seriesType, create);
	  } else if (getTargetSeries) {
	    getTargetSeries(ecModel, api).each(create);
	  }
	
	  function create(seriesModel) {
	    var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
	    // Reuse original task instance.
	
	    var task = seriesTaskMap.get(pipelineId) || seriesTaskMap.set(pipelineId, createTask({
	      plan: seriesTaskPlan,
	      reset: seriesTaskReset,
	      count: seriesTaskCount
	    }));
	    task.context = {
	      model: seriesModel,
	      ecModel: ecModel,
	      api: api,
	      useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
	      plan: stageHandler.plan,
	      reset: stageHandler.reset,
	      scheduler: scheduler
	    };
	    pipe(scheduler, seriesModel, task);
	  } // Clear unused series tasks.
	
	
	  var pipelineMap = scheduler._pipelineMap;
	  seriesTaskMap.each(function (task, pipelineId) {
	    if (!pipelineMap.get(pipelineId)) {
	      task.dispose();
	      seriesTaskMap.removeKey(pipelineId);
	    }
	  });
	}
	
	function createOverallStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
	  var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
	  || createTask({
	    reset: overallTaskReset
	  });
	  overallTask.context = {
	    ecModel: ecModel,
	    api: api,
	    overallReset: stageHandler.overallReset,
	    scheduler: scheduler
	  }; // Reuse orignal stubs.
	
	  var agentStubMap = overallTask.agentStubMap = overallTask.agentStubMap || createHashMap();
	  var seriesType = stageHandler.seriesType;
	  var getTargetSeries = stageHandler.getTargetSeries;
	  var overallProgress = true;
	  var modifyOutputEnd = stageHandler.modifyOutputEnd; // An overall task with seriesType detected or has `getTargetSeries`, we add
	  // stub in each pipelines, it will set the overall task dirty when the pipeline
	  // progress. Moreover, to avoid call the overall task each frame (too frequent),
	  // we set the pipeline block.
	
	  if (seriesType) {
	    ecModel.eachRawSeriesByType(seriesType, createStub);
	  } else if (getTargetSeries) {
	    getTargetSeries(ecModel, api).each(createStub);
	  } // Otherwise, (usually it is legancy case), the overall task will only be
	  // executed when upstream dirty. Otherwise the progressive rendering of all
	  // pipelines will be disabled unexpectedly. But it still needs stubs to receive
	  // dirty info from upsteam.
	  else {
	      overallProgress = false;
	      each(ecModel.getSeries(), createStub);
	    }
	
	  function createStub(seriesModel) {
	    var pipelineId = seriesModel.uid;
	    var stub = agentStubMap.get(pipelineId);
	
	    if (!stub) {
	      stub = agentStubMap.set(pipelineId, createTask({
	        reset: stubReset,
	        onDirty: stubOnDirty
	      })); // When the result of `getTargetSeries` changed, the overallTask
	      // should be set as dirty and re-performed.
	
	      overallTask.dirty();
	    }
	
	    stub.context = {
	      model: seriesModel,
	      overallProgress: overallProgress,
	      modifyOutputEnd: modifyOutputEnd
	    };
	    stub.agent = overallTask;
	    stub.__block = overallProgress;
	    pipe(scheduler, seriesModel, stub);
	  } // Clear unused stubs.
	
	
	  var pipelineMap = scheduler._pipelineMap;
	  agentStubMap.each(function (stub, pipelineId) {
	    if (!pipelineMap.get(pipelineId)) {
	      stub.dispose(); // When the result of `getTargetSeries` changed, the overallTask
	      // should be set as dirty and re-performed.
	
	      overallTask.dirty();
	      agentStubMap.removeKey(pipelineId);
	    }
	  });
	}
	
	function overallTaskReset(context) {
	  context.overallReset(context.ecModel, context.api, context.payload);
	}
	
	function stubReset(context, upstreamContext) {
	  return context.overallProgress && stubProgress;
	}
	
	function stubProgress() {
	  this.agent.dirty();
	  this.getDownstream().dirty();
	}
	
	function stubOnDirty() {
	  this.agent && this.agent.dirty();
	}
	
	function seriesTaskPlan(context) {
	  return context.plan && context.plan(context.model, context.ecModel, context.api, context.payload);
	}
	
	function seriesTaskReset(context) {
	  if (context.useClearVisual) {
	    context.data.clearAllVisual();
	  }
	
	  var resetDefines = context.resetDefines = normalizeToArray(context.reset(context.model, context.ecModel, context.api, context.payload));
	  return resetDefines.length > 1 ? map(resetDefines, function (v, idx) {
	    return makeSeriesTaskProgress(idx);
	  }) : singleSeriesTaskProgress;
	}
	
	var singleSeriesTaskProgress = makeSeriesTaskProgress(0);
	
	function makeSeriesTaskProgress(resetDefineIdx) {
	  return function (params, context) {
	    var data = context.data;
	    var resetDefine = context.resetDefines[resetDefineIdx];
	
	    if (resetDefine && resetDefine.dataEach) {
	      for (var i = params.start; i < params.end; i++) {
	        resetDefine.dataEach(data, i);
	      }
	    } else if (resetDefine && resetDefine.progress) {
	      resetDefine.progress(params, data);
	    }
	  };
	}
	
	function seriesTaskCount(context) {
	  return context.data.count();
	}
	
	function pipe(scheduler, seriesModel, task) {
	  var pipelineId = seriesModel.uid;
	
	  var pipeline = scheduler._pipelineMap.get(pipelineId);
	
	  !pipeline.head && (pipeline.head = task);
	  pipeline.tail && pipeline.tail.pipe(task);
	  pipeline.tail = task;
	  task.__idxInPipeline = pipeline.count++;
	  task.__pipeline = pipeline;
	}
	
	Scheduler.wrapStageHandler = function (stageHandler, visualType) {
	  if (isFunction(stageHandler)) {
	    stageHandler = {
	      overallReset: stageHandler,
	      seriesType: detectSeriseType(stageHandler)
	    };
	  }
	
	  stageHandler.uid = getUID('stageHandler');
	  visualType && (stageHandler.visualType = visualType);
	  return stageHandler;
	};
	/**
	 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
	 * To ensure that they can work normally, they should work in block mode, that is,
	 * they should not be started util the previous tasks finished. So they cause the
	 * progressive rendering disabled. We try to detect the series type, to narrow down
	 * the block range to only the series type they concern, but not all series.
	 */
	
	
	function detectSeriseType(legacyFunc) {
	  seriesType = null;
	
	  try {
	    // Assume there is no async when calling `eachSeriesByType`.
	    legacyFunc(ecModelMock, apiMock);
	  } catch (e) {}
	
	  return seriesType;
	}
	
	var ecModelMock = {};
	var apiMock = {};
	var seriesType;
	mockMethods(ecModelMock, GlobalModel);
	mockMethods(apiMock, ExtensionAPI);
	
	ecModelMock.eachSeriesByType = ecModelMock.eachRawSeriesByType = function (type) {
	  seriesType = type;
	};
	
	ecModelMock.eachComponent = function (cond) {
	  if (cond.mainType === 'series' && cond.subType) {
	    seriesType = cond.subType;
	  }
	};
	
	function mockMethods(target, Clz) {
	  /* eslint-disable */
	  for (var name in Clz.prototype) {
	    // Do not use hasOwnProperty
	    target[name] = noop;
	  }
	  /* eslint-enable */
	
	}
	
	var _default = Scheduler;
	module.exports = _default;

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var colorAll = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];
	var _default = {
	  color: colorAll,
	  colorLayer: [['#37A2DA', '#ffd85c', '#fd7b5f'], ['#37A2DA', '#67E0E3', '#FFDB5C', '#ff9f7f', '#E062AE', '#9d96f5'], ['#37A2DA', '#32C5E9', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#e7bcf3', '#8378EA', '#96BFFF'], colorAll]
	};
	module.exports = _default;

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var contrastColor = '#eee';
	
	var axisCommon = function () {
	  return {
	    axisLine: {
	      lineStyle: {
	        color: contrastColor
	      }
	    },
	    axisTick: {
	      lineStyle: {
	        color: contrastColor
	      }
	    },
	    axisLabel: {
	      textStyle: {
	        color: contrastColor
	      }
	    },
	    splitLine: {
	      lineStyle: {
	        type: 'dashed',
	        color: '#aaa'
	      }
	    },
	    splitArea: {
	      areaStyle: {
	        color: contrastColor
	      }
	    }
	  };
	};
	
	var colorPalette = ['#dd6b66', '#759aa0', '#e69d87', '#8dc1a9', '#ea7e53', '#eedd78', '#73a373', '#73b9bc', '#7289ab', '#91ca8c', '#f49f42'];
	var theme = {
	  color: colorPalette,
	  backgroundColor: '#333',
	  tooltip: {
	    axisPointer: {
	      lineStyle: {
	        color: contrastColor
	      },
	      crossStyle: {
	        color: contrastColor
	      },
	      label: {
	        color: '#000'
	      }
	    }
	  },
	  legend: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  textStyle: {
	    color: contrastColor
	  },
	  title: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  toolbox: {
	    iconStyle: {
	      normal: {
	        borderColor: contrastColor
	      }
	    }
	  },
	  dataZoom: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  visualMap: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  timeline: {
	    lineStyle: {
	      color: contrastColor
	    },
	    itemStyle: {
	      normal: {
	        color: colorPalette[1]
	      }
	    },
	    label: {
	      normal: {
	        textStyle: {
	          color: contrastColor
	        }
	      }
	    },
	    controlStyle: {
	      normal: {
	        color: contrastColor,
	        borderColor: contrastColor
	      }
	    }
	  },
	  timeAxis: axisCommon(),
	  logAxis: axisCommon(),
	  valueAxis: axisCommon(),
	  categoryAxis: axisCommon(),
	  line: {
	    symbol: 'circle'
	  },
	  graph: {
	    color: colorPalette
	  },
	  gauge: {
	    title: {
	      textStyle: {
	        color: contrastColor
	      }
	    }
	  },
	  candlestick: {
	    itemStyle: {
	      normal: {
	        color: '#FD1050',
	        color0: '#0CF49B',
	        borderColor: '#FD1050',
	        borderColor0: '#0CF49B'
	      }
	    }
	  }
	};
	theme.categoryAxis.splitLine.show = false;
	var _default = theme;
	module.exports = _default;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentModel = __webpack_require__(303);
	
	var ComponentView = __webpack_require__(324);
	
	var _sourceHelper = __webpack_require__(311);
	
	var detectSourceFormat = _sourceHelper.detectSourceFormat;
	
	var _sourceType = __webpack_require__(313);
	
	var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * This module is imported by echarts directly.
	 *
	 * Notice:
	 * Always keep this file exists for backward compatibility.
	 * Because before 4.1.0, dataset is an optional component,
	 * some users may import this module manually.
	 */
	ComponentModel.extend({
	  type: 'dataset',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    // 'row', 'column'
	    seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN,
	    // null/'auto': auto detect header, see "module:echarts/data/helper/sourceHelper"
	    sourceHeader: null,
	    dimensions: null,
	    source: null
	  },
	  optionUpdated: function () {
	    detectSourceFormat(this);
	  }
	});
	ComponentView.extend({
	  type: 'dataset'
	});

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(220);
	
	var createHashMap = _util.createHashMap;
	var isString = _util.isString;
	var isArray = _util.isArray;
	var each = _util.each;
	var assert = _util.assert;
	
	var _parseSVG = __webpack_require__(337);
	
	var parseXML = _parseSVG.parseXML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var storage = createHashMap(); // For minimize the code size of common echarts package,
	// do not put too much logic in this module.
	
	var _default = {
	  // The format of record: see `echarts.registerMap`.
	  // Compatible with previous `echarts.registerMap`.
	  registerMap: function (mapName, rawGeoJson, rawSpecialAreas) {
	    var records;
	
	    if (isArray(rawGeoJson)) {
	      records = rawGeoJson;
	    } else if (rawGeoJson.svg) {
	      records = [{
	        type: 'svg',
	        source: rawGeoJson.svg,
	        specialAreas: rawGeoJson.specialAreas
	      }];
	    } else {
	      // Backward compatibility.
	      if (rawGeoJson.geoJson && !rawGeoJson.features) {
	        rawSpecialAreas = rawGeoJson.specialAreas;
	        rawGeoJson = rawGeoJson.geoJson;
	      }
	
	      records = [{
	        type: 'geoJSON',
	        source: rawGeoJson,
	        specialAreas: rawSpecialAreas
	      }];
	    }
	
	    each(records, function (record) {
	      var type = record.type;
	      type === 'geoJson' && (type = record.type = 'geoJSON');
	      var parse = parsers[type];
	      parse(record);
	    });
	    return storage.set(mapName, records);
	  },
	  retrieveMap: function (mapName) {
	    return storage.get(mapName);
	  }
	};
	var parsers = {
	  geoJSON: function (record) {
	    var source = record.source;
	    record.geoJSON = !isString(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
	  },
	  // Only perform parse to XML object here, which might be time
	  // consiming for large SVG.
	  // Although convert XML to zrender element is also time consiming,
	  // if we do it here, the clone of zrender elements has to be
	  // required. So we do it once for each geo instance, util real
	  // performance issues call for optimizing it.
	  svg: function (record) {
	    record.svgXML = parseXML(record.source);
	  }
	};
	module.exports = _default;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	var Group = __webpack_require__(230);
	
	var ZImage = __webpack_require__(251);
	
	var Text = __webpack_require__(282);
	
	var Circle = __webpack_require__(283);
	
	var Rect = __webpack_require__(292);
	
	var Ellipse = __webpack_require__(338);
	
	var Line = __webpack_require__(294);
	
	var Path = __webpack_require__(270);
	
	var Polygon = __webpack_require__(287);
	
	var Polyline = __webpack_require__(291);
	
	var LinearGradient = __webpack_require__(298);
	
	var Style = __webpack_require__(246);
	
	var matrix = __webpack_require__(233);
	
	var _path = __webpack_require__(269);
	
	var createFromString = _path.createFromString;
	
	var _util = __webpack_require__(220);
	
	var isString = _util.isString;
	var extend = _util.extend;
	var defaults = _util.defaults;
	var trim = _util.trim;
	var each = _util.each;
	// import RadialGradient from '../graphic/RadialGradient';
	// import Pattern from '../graphic/Pattern';
	// import * as vector from '../core/vector';
	// Most of the values can be separated by comma and/or white space.
	var DILIMITER_REG = /[\s,]+/;
	/**
	 * For big svg string, this method might be time consuming.
	 *
	 * @param {string} svg xml string
	 * @return {Object} xml root.
	 */
	
	function parseXML(svg) {
	  if (isString(svg)) {
	    var parser = new DOMParser();
	    svg = parser.parseFromString(svg, 'text/xml');
	  } // Document node. If using $.get, doc node may be input.
	
	
	  if (svg.nodeType === 9) {
	    svg = svg.firstChild;
	  } // nodeName of <!DOCTYPE svg> is also 'svg'.
	
	
	  while (svg.nodeName.toLowerCase() !== 'svg' || svg.nodeType !== 1) {
	    svg = svg.nextSibling;
	  }
	
	  return svg;
	}
	
	function SVGParser() {
	  this._defs = {};
	  this._root = null;
	  this._isDefine = false;
	  this._isText = false;
	}
	
	SVGParser.prototype.parse = function (xml, opt) {
	  opt = opt || {};
	  var svg = parseXML(xml);
	
	  if (!svg) {
	    throw new Error('Illegal svg');
	  }
	
	  var root = new Group();
	  this._root = root; // parse view port
	
	  var viewBox = svg.getAttribute('viewBox') || ''; // If width/height not specified, means "100%" of `opt.width/height`.
	  // TODO: Other percent value not supported yet.
	
	  var width = parseFloat(svg.getAttribute('width') || opt.width);
	  var height = parseFloat(svg.getAttribute('height') || opt.height); // If width/height not specified, set as null for output.
	
	  isNaN(width) && (width = null);
	  isNaN(height) && (height = null); // Apply inline style on svg element.
	
	  parseAttributes(svg, root, null, true);
	  var child = svg.firstChild;
	
	  while (child) {
	    this._parseNode(child, root);
	
	    child = child.nextSibling;
	  }
	
	  var viewBoxRect;
	  var viewBoxTransform;
	
	  if (viewBox) {
	    var viewBoxArr = trim(viewBox).split(DILIMITER_REG); // Some invalid case like viewBox: 'none'.
	
	    if (viewBoxArr.length >= 4) {
	      viewBoxRect = {
	        x: parseFloat(viewBoxArr[0] || 0),
	        y: parseFloat(viewBoxArr[1] || 0),
	        width: parseFloat(viewBoxArr[2]),
	        height: parseFloat(viewBoxArr[3])
	      };
	    }
	  }
	
	  if (viewBoxRect && width != null && height != null) {
	    viewBoxTransform = makeViewBoxTransform(viewBoxRect, width, height);
	
	    if (!opt.ignoreViewBox) {
	      // If set transform on the output group, it probably bring trouble when
	      // some users only intend to show the clipped content inside the viewBox,
	      // but not intend to transform the output group. So we keep the output
	      // group no transform. If the user intend to use the viewBox as a
	      // camera, just set `opt.ignoreViewBox` as `true` and set transfrom
	      // manually according to the viewBox info in the output of this method.
	      var elRoot = root;
	      root = new Group();
	      root.add(elRoot);
	      elRoot.scale = viewBoxTransform.scale.slice();
	      elRoot.position = viewBoxTransform.position.slice();
	    }
	  } // Some shapes might be overflow the viewport, which should be
	  // clipped despite whether the viewBox is used, as the SVG does.
	
	
	  if (!opt.ignoreRootClip && width != null && height != null) {
	    root.setClipPath(new Rect({
	      shape: {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      }
	    }));
	  } // Set width/height on group just for output the viewport size.
	
	
	  return {
	    root: root,
	    width: width,
	    height: height,
	    viewBoxRect: viewBoxRect,
	    viewBoxTransform: viewBoxTransform
	  };
	};
	
	SVGParser.prototype._parseNode = function (xmlNode, parentGroup) {
	  var nodeName = xmlNode.nodeName.toLowerCase(); // TODO
	  // support <style>...</style> in svg, where nodeName is 'style',
	  // CSS classes is defined globally wherever the style tags are declared.
	
	  if (nodeName === 'defs') {
	    // define flag
	    this._isDefine = true;
	  } else if (nodeName === 'text') {
	    this._isText = true;
	  }
	
	  var el;
	
	  if (this._isDefine) {
	    var parser = defineParsers[nodeName];
	
	    if (parser) {
	      var def = parser.call(this, xmlNode);
	      var id = xmlNode.getAttribute('id');
	
	      if (id) {
	        this._defs[id] = def;
	      }
	    }
	  } else {
	    var parser = nodeParsers[nodeName];
	
	    if (parser) {
	      el = parser.call(this, xmlNode, parentGroup);
	      parentGroup.add(el);
	    }
	  }
	
	  var child = xmlNode.firstChild;
	
	  while (child) {
	    if (child.nodeType === 1) {
	      this._parseNode(child, el);
	    } // Is text
	
	
	    if (child.nodeType === 3 && this._isText) {
	      this._parseText(child, el);
	    }
	
	    child = child.nextSibling;
	  } // Quit define
	
	
	  if (nodeName === 'defs') {
	    this._isDefine = false;
	  } else if (nodeName === 'text') {
	    this._isText = false;
	  }
	};
	
	SVGParser.prototype._parseText = function (xmlNode, parentGroup) {
	  if (xmlNode.nodeType === 1) {
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    this._textX += parseFloat(dx);
	    this._textY += parseFloat(dy);
	  }
	
	  var text = new Text({
	    style: {
	      text: xmlNode.textContent,
	      transformText: true
	    },
	    position: [this._textX || 0, this._textY || 0]
	  });
	  inheritStyle(parentGroup, text);
	  parseAttributes(xmlNode, text, this._defs);
	  var fontSize = text.style.fontSize;
	
	  if (fontSize && fontSize < 9) {
	    // PENDING
	    text.style.fontSize = 9;
	    text.scale = text.scale || [1, 1];
	    text.scale[0] *= fontSize / 9;
	    text.scale[1] *= fontSize / 9;
	  }
	
	  var rect = text.getBoundingRect();
	  this._textX += rect.width;
	  parentGroup.add(text);
	  return text;
	};
	
	var nodeParsers = {
	  'g': function (xmlNode, parentGroup) {
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    return g;
	  },
	  'rect': function (xmlNode, parentGroup) {
	    var rect = new Rect();
	    inheritStyle(parentGroup, rect);
	    parseAttributes(xmlNode, rect, this._defs);
	    rect.setShape({
	      x: parseFloat(xmlNode.getAttribute('x') || 0),
	      y: parseFloat(xmlNode.getAttribute('y') || 0),
	      width: parseFloat(xmlNode.getAttribute('width') || 0),
	      height: parseFloat(xmlNode.getAttribute('height') || 0)
	    }); // console.log(xmlNode.getAttribute('transform'));
	    // console.log(rect.transform);
	
	    return rect;
	  },
	  'circle': function (xmlNode, parentGroup) {
	    var circle = new Circle();
	    inheritStyle(parentGroup, circle);
	    parseAttributes(xmlNode, circle, this._defs);
	    circle.setShape({
	      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
	      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
	      r: parseFloat(xmlNode.getAttribute('r') || 0)
	    });
	    return circle;
	  },
	  'line': function (xmlNode, parentGroup) {
	    var line = new Line();
	    inheritStyle(parentGroup, line);
	    parseAttributes(xmlNode, line, this._defs);
	    line.setShape({
	      x1: parseFloat(xmlNode.getAttribute('x1') || 0),
	      y1: parseFloat(xmlNode.getAttribute('y1') || 0),
	      x2: parseFloat(xmlNode.getAttribute('x2') || 0),
	      y2: parseFloat(xmlNode.getAttribute('y2') || 0)
	    });
	    return line;
	  },
	  'ellipse': function (xmlNode, parentGroup) {
	    var ellipse = new Ellipse();
	    inheritStyle(parentGroup, ellipse);
	    parseAttributes(xmlNode, ellipse, this._defs);
	    ellipse.setShape({
	      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
	      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
	      rx: parseFloat(xmlNode.getAttribute('rx') || 0),
	      ry: parseFloat(xmlNode.getAttribute('ry') || 0)
	    });
	    return ellipse;
	  },
	  'polygon': function (xmlNode, parentGroup) {
	    var points = xmlNode.getAttribute('points');
	
	    if (points) {
	      points = parsePoints(points);
	    }
	
	    var polygon = new Polygon({
	      shape: {
	        points: points || []
	      }
	    });
	    inheritStyle(parentGroup, polygon);
	    parseAttributes(xmlNode, polygon, this._defs);
	    return polygon;
	  },
	  'polyline': function (xmlNode, parentGroup) {
	    var path = new Path();
	    inheritStyle(parentGroup, path);
	    parseAttributes(xmlNode, path, this._defs);
	    var points = xmlNode.getAttribute('points');
	
	    if (points) {
	      points = parsePoints(points);
	    }
	
	    var polyline = new Polyline({
	      shape: {
	        points: points || []
	      }
	    });
	    return polyline;
	  },
	  'image': function (xmlNode, parentGroup) {
	    var img = new ZImage();
	    inheritStyle(parentGroup, img);
	    parseAttributes(xmlNode, img, this._defs);
	    img.setStyle({
	      image: xmlNode.getAttribute('xlink:href'),
	      x: xmlNode.getAttribute('x'),
	      y: xmlNode.getAttribute('y'),
	      width: xmlNode.getAttribute('width'),
	      height: xmlNode.getAttribute('height')
	    });
	    return img;
	  },
	  'text': function (xmlNode, parentGroup) {
	    var x = xmlNode.getAttribute('x') || 0;
	    var y = xmlNode.getAttribute('y') || 0;
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    this._textX = parseFloat(x) + parseFloat(dx);
	    this._textY = parseFloat(y) + parseFloat(dy);
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    return g;
	  },
	  'tspan': function (xmlNode, parentGroup) {
	    var x = xmlNode.getAttribute('x');
	    var y = xmlNode.getAttribute('y');
	
	    if (x != null) {
	      // new offset x
	      this._textX = parseFloat(x);
	    }
	
	    if (y != null) {
	      // new offset y
	      this._textY = parseFloat(y);
	    }
	
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    this._textX += dx;
	    this._textY += dy;
	    return g;
	  },
	  'path': function (xmlNode, parentGroup) {
	    // TODO svg fill rule
	    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/fill-rule
	    // path.style.globalCompositeOperation = 'xor';
	    var d = xmlNode.getAttribute('d') || ''; // Performance sensitive.
	
	    var path = createFromString(d);
	    inheritStyle(parentGroup, path);
	    parseAttributes(xmlNode, path, this._defs);
	    return path;
	  }
	};
	var defineParsers = {
	  'lineargradient': function (xmlNode) {
	    var x1 = parseInt(xmlNode.getAttribute('x1') || 0, 10);
	    var y1 = parseInt(xmlNode.getAttribute('y1') || 0, 10);
	    var x2 = parseInt(xmlNode.getAttribute('x2') || 10, 10);
	    var y2 = parseInt(xmlNode.getAttribute('y2') || 0, 10);
	    var gradient = new LinearGradient(x1, y1, x2, y2);
	
	    _parseGradientColorStops(xmlNode, gradient);
	
	    return gradient;
	  },
	  'radialgradient': function (xmlNode) {}
	};
	
	function _parseGradientColorStops(xmlNode, gradient) {
	  var stop = xmlNode.firstChild;
	
	  while (stop) {
	    if (stop.nodeType === 1) {
	      var offset = stop.getAttribute('offset');
	
	      if (offset.indexOf('%') > 0) {
	        // percentage
	        offset = parseInt(offset, 10) / 100;
	      } else if (offset) {
	        // number from 0 to 1
	        offset = parseFloat(offset);
	      } else {
	        offset = 0;
	      }
	
	      var stopColor = stop.getAttribute('stop-color') || '#000000';
	      gradient.addColorStop(offset, stopColor);
	    }
	
	    stop = stop.nextSibling;
	  }
	}
	
	function inheritStyle(parent, child) {
	  if (parent && parent.__inheritedStyle) {
	    if (!child.__inheritedStyle) {
	      child.__inheritedStyle = {};
	    }
	
	    defaults(child.__inheritedStyle, parent.__inheritedStyle);
	  }
	}
	
	function parsePoints(pointsString) {
	  var list = trim(pointsString).split(DILIMITER_REG);
	  var points = [];
	
	  for (var i = 0; i < list.length; i += 2) {
	    var x = parseFloat(list[i]);
	    var y = parseFloat(list[i + 1]);
	    points.push([x, y]);
	  }
	
	  return points;
	}
	
	var attributesMap = {
	  'fill': 'fill',
	  'stroke': 'stroke',
	  'stroke-width': 'lineWidth',
	  'opacity': 'opacity',
	  'fill-opacity': 'fillOpacity',
	  'stroke-opacity': 'strokeOpacity',
	  'stroke-dasharray': 'lineDash',
	  'stroke-dashoffset': 'lineDashOffset',
	  'stroke-linecap': 'lineCap',
	  'stroke-linejoin': 'lineJoin',
	  'stroke-miterlimit': 'miterLimit',
	  'font-family': 'fontFamily',
	  'font-size': 'fontSize',
	  'font-style': 'fontStyle',
	  'font-weight': 'fontWeight',
	  'text-align': 'textAlign',
	  'alignment-baseline': 'textBaseline'
	};
	
	function parseAttributes(xmlNode, el, defs, onlyInlineStyle) {
	  var zrStyle = el.__inheritedStyle || {};
	  var isTextEl = el.type === 'text'; // TODO Shadow
	
	  if (xmlNode.nodeType === 1) {
	    parseTransformAttribute(xmlNode, el);
	    extend(zrStyle, parseStyleAttribute(xmlNode));
	
	    if (!onlyInlineStyle) {
	      for (var svgAttrName in attributesMap) {
	        if (attributesMap.hasOwnProperty(svgAttrName)) {
	          var attrValue = xmlNode.getAttribute(svgAttrName);
	
	          if (attrValue != null) {
	            zrStyle[attributesMap[svgAttrName]] = attrValue;
	          }
	        }
	      }
	    }
	  }
	
	  var elFillProp = isTextEl ? 'textFill' : 'fill';
	  var elStrokeProp = isTextEl ? 'textStroke' : 'stroke';
	  el.style = el.style || new Style();
	  var elStyle = el.style;
	  zrStyle.fill != null && elStyle.set(elFillProp, getPaint(zrStyle.fill, defs));
	  zrStyle.stroke != null && elStyle.set(elStrokeProp, getPaint(zrStyle.stroke, defs));
	  each(['lineWidth', 'opacity', 'fillOpacity', 'strokeOpacity', 'miterLimit', 'fontSize'], function (propName) {
	    var elPropName = propName === 'lineWidth' && isTextEl ? 'textStrokeWidth' : propName;
	    zrStyle[propName] != null && elStyle.set(elPropName, parseFloat(zrStyle[propName]));
	  });
	
	  if (!zrStyle.textBaseline || zrStyle.textBaseline === 'auto') {
	    zrStyle.textBaseline = 'alphabetic';
	  }
	
	  if (zrStyle.textBaseline === 'alphabetic') {
	    zrStyle.textBaseline = 'bottom';
	  }
	
	  if (zrStyle.textAlign === 'start') {
	    zrStyle.textAlign = 'left';
	  }
	
	  if (zrStyle.textAlign === 'end') {
	    zrStyle.textAlign = 'right';
	  }
	
	  each(['lineDashOffset', 'lineCap', 'lineJoin', 'fontWeight', 'fontFamily', 'fontStyle', 'textAlign', 'textBaseline'], function (propName) {
	    zrStyle[propName] != null && elStyle.set(propName, zrStyle[propName]);
	  });
	
	  if (zrStyle.lineDash) {
	    el.style.lineDash = trim(zrStyle.lineDash).split(DILIMITER_REG);
	  }
	
	  if (elStyle[elStrokeProp] && elStyle[elStrokeProp] !== 'none') {
	    // enable stroke
	    el[elStrokeProp] = true;
	  }
	
	  el.__inheritedStyle = zrStyle;
	}
	
	var urlRegex = /url\(\s*#(.*?)\)/;
	
	function getPaint(str, defs) {
	  // if (str === 'none') {
	  //     return;
	  // }
	  var urlMatch = defs && str && str.match(urlRegex);
	
	  if (urlMatch) {
	    var url = trim(urlMatch[1]);
	    var def = defs[url];
	    return def;
	  }
	
	  return str;
	}
	
	var transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.e,]*)\)/g;
	
	function parseTransformAttribute(xmlNode, node) {
	  var transform = xmlNode.getAttribute('transform');
	
	  if (transform) {
	    transform = transform.replace(/,/g, ' ');
	    var m = null;
	    var transformOps = [];
	    transform.replace(transformRegex, function (str, type, value) {
	      transformOps.push(type, value);
	    });
	
	    for (var i = transformOps.length - 1; i > 0; i -= 2) {
	      var value = transformOps[i];
	      var type = transformOps[i - 1];
	      m = m || matrix.create();
	
	      switch (type) {
	        case 'translate':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.translate(m, m, [parseFloat(value[0]), parseFloat(value[1] || 0)]);
	          break;
	
	        case 'scale':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.scale(m, m, [parseFloat(value[0]), parseFloat(value[1] || value[0])]);
	          break;
	
	        case 'rotate':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.rotate(m, m, parseFloat(value[0]));
	          break;
	
	        case 'skew':
	          value = trim(value).split(DILIMITER_REG);
	          console.warn('Skew transform is not supported yet');
	          break;
	
	        case 'matrix':
	          var value = trim(value).split(DILIMITER_REG);
	          m[0] = parseFloat(value[0]);
	          m[1] = parseFloat(value[1]);
	          m[2] = parseFloat(value[2]);
	          m[3] = parseFloat(value[3]);
	          m[4] = parseFloat(value[4]);
	          m[5] = parseFloat(value[5]);
	          break;
	      }
	    }
	
	    node.setLocalTransform(m);
	  }
	} // Value may contain space.
	
	
	var styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
	
	function parseStyleAttribute(xmlNode) {
	  var style = xmlNode.getAttribute('style');
	  var result = {};
	
	  if (!style) {
	    return result;
	  }
	
	  var styleList = {};
	  styleRegex.lastIndex = 0;
	  var styleRegResult;
	
	  while ((styleRegResult = styleRegex.exec(style)) != null) {
	    styleList[styleRegResult[1]] = styleRegResult[2];
	  }
	
	  for (var svgAttrName in attributesMap) {
	    if (attributesMap.hasOwnProperty(svgAttrName) && styleList[svgAttrName] != null) {
	      result[attributesMap[svgAttrName]] = styleList[svgAttrName];
	    }
	  }
	
	  return result;
	}
	/**
	 * @param {Array.<number>} viewBoxRect
	 * @param {number} width
	 * @param {number} height
	 * @return {Object} {scale, position}
	 */
	
	
	function makeViewBoxTransform(viewBoxRect, width, height) {
	  var scaleX = width / viewBoxRect.width;
	  var scaleY = height / viewBoxRect.height;
	  var scale = Math.min(scaleX, scaleY); // preserveAspectRatio 'xMidYMid'
	
	  var viewBoxScale = [scale, scale];
	  var viewBoxPosition = [-(viewBoxRect.x + viewBoxRect.width / 2) * scale + width / 2, -(viewBoxRect.y + viewBoxRect.height / 2) * scale + height / 2];
	  return {
	    scale: viewBoxScale,
	    position: viewBoxPosition
	  };
	}
	/**
	 * @param {string|XMLElement} xml
	 * @param {Object} [opt]
	 * @param {number} [opt.width] Default width if svg width not specified or is a percent value.
	 * @param {number} [opt.height] Default height if svg height not specified or is a percent value.
	 * @param {boolean} [opt.ignoreViewBox]
	 * @param {boolean} [opt.ignoreRootClip]
	 * @return {Object} result:
	 * {
	 *     root: Group, The root of the the result tree of zrender shapes,
	 *     width: number, the viewport width of the SVG,
	 *     height: number, the viewport height of the SVG,
	 *     viewBoxRect: {x, y, width, height}, the declared viewBox rect of the SVG, if exists,
	 *     viewBoxTransform: the {scale, position} calculated by viewBox and viewport, is exists.
	 * }
	 */
	
	
	function parseSVG(xml, opt) {
	  var parser = new SVGParser();
	  return parser.parse(xml, opt);
	}
	
	exports.parseXML = parseXML;
	exports.makeViewBoxTransform = makeViewBoxTransform;
	exports.parseSVG = parseSVG;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(270);
	
	/**
	 * 椭圆形状
	 * @module zrender/graphic/shape/Ellipse
	 */
	var _default = Path.extend({
	  type: 'ellipse',
	  shape: {
	    cx: 0,
	    cy: 0,
	    rx: 0,
	    ry: 0
	  },
	  buildPath: function (ctx, shape) {
	    var k = 0.5522848;
	    var x = shape.cx;
	    var y = shape.cy;
	    var a = shape.rx;
	    var b = shape.ry;
	    var ox = a * k; // 水平控制点偏移量
	
	    var oy = b * k; // 垂直控制点偏移量
	    // 从椭圆的左端点开始顺时针绘制四条三次贝塞尔曲线
	
	    ctx.moveTo(x - a, y);
	    ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
	    ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
	    ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
	    ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrender = __webpack_require__(217);
	
	exports.zrender = zrender;
	
	var matrix = __webpack_require__(233);
	
	exports.matrix = matrix;
	
	var vector = __webpack_require__(222);
	
	exports.vector = vector;
	
	var zrUtil = __webpack_require__(220);
	
	var colorTool = __webpack_require__(238);
	
	exports.color = colorTool;
	
	var graphicUtil = __webpack_require__(268);
	
	var numberUtil = __webpack_require__(306);
	
	exports.number = numberUtil;
	
	var formatUtil = __webpack_require__(307);
	
	exports.format = formatUtil;
	
	var _throttle = __webpack_require__(327);
	
	var throttle = _throttle.throttle;
	exports.throttle = _throttle.throttle;
	
	var ecHelper = __webpack_require__(340);
	
	exports.helper = ecHelper;
	
	var parseGeoJSON = __webpack_require__(361);
	
	exports.parseGeoJSON = parseGeoJSON;
	
	var _List = __webpack_require__(342);
	
	exports.List = _List;
	
	var _Model = __webpack_require__(262);
	
	exports.Model = _Model;
	
	var _Axis = __webpack_require__(364);
	
	exports.Axis = _Axis;
	
	var _env = __webpack_require__(219);
	
	exports.env = _env;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Do not mount those modules on 'src/echarts' for better tree shaking.
	 */
	var parseGeoJson = parseGeoJSON;
	var ecUtil = {};
	zrUtil.each(['map', 'each', 'filter', 'indexOf', 'inherits', 'reduce', 'filter', 'bind', 'curry', 'isArray', 'isString', 'isObject', 'isFunction', 'extend', 'defaults', 'clone', 'merge'], function (name) {
	  ecUtil[name] = zrUtil[name];
	});
	var graphic = {};
	zrUtil.each(['extendShape', 'extendPath', 'makePath', 'makeImage', 'mergePath', 'resizePath', 'createIcon', 'setHoverStyle', 'setLabelStyle', 'setTextStyle', 'setText', 'getFont', 'updateProps', 'initProps', 'getTransform', 'clipPointsByRect', 'clipRectByRect', 'registerShape', 'getShapeClass', 'Group', 'Image', 'Text', 'Circle', 'Sector', 'Ring', 'Polygon', 'Polyline', 'Rect', 'Line', 'BezierCurve', 'Arc', 'IncrementalDisplayable', 'CompoundPath', 'LinearGradient', 'RadialGradient', 'BoundingRect'], function (name) {
	  graphic[name] = graphicUtil[name];
	});
	exports.parseGeoJson = parseGeoJson;
	exports.util = ecUtil;
	exports.graphic = graphic;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var createListFromArray = __webpack_require__(341);
	
	var axisHelper = __webpack_require__(350);
	
	var axisModelCommonMixin = __webpack_require__(359);
	
	var Model = __webpack_require__(262);
	
	var _layout = __webpack_require__(305);
	
	var getLayoutRect = _layout.getLayoutRect;
	exports.getLayoutRect = _layout.getLayoutRect;
	
	var _dataStackHelper = __webpack_require__(349);
	
	var enableDataStack = _dataStackHelper.enableDataStack;
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	var _completeDimensions = __webpack_require__(347);
	
	exports.completeDimensions = _completeDimensions;
	
	var _createDimensions = __webpack_require__(346);
	
	exports.createDimensions = _createDimensions;
	
	var _symbol = __webpack_require__(360);
	
	exports.createSymbol = _symbol.createSymbol;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import createGraphFromNodeEdge from './chart/helper/createGraphFromNodeEdge';
	
	/**
	 * Create a muti dimension List structure from seriesModel.
	 * @param  {module:echarts/model/Model} seriesModel
	 * @return {module:echarts/data/List} list
	 */
	function createList(seriesModel) {
	  return createListFromArray(seriesModel.getSource(), seriesModel);
	} // export function createGraph(seriesModel) {
	//     var nodes = seriesModel.get('data');
	//     var links = seriesModel.get('links');
	//     return createGraphFromNodeEdge(nodes, links, seriesModel);
	// }
	
	
	var dataStack = {
	  isDimensionStacked: isDimensionStacked,
	  enableDataStack: enableDataStack,
	  getStackedDimension: getStackedDimension
	};
	/**
	 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
	 * @param {string} symbolDesc
	 * @param {number} x
	 * @param {number} y
	 * @param {number} w
	 * @param {number} h
	 * @param {string} color
	 */
	
	/**
	 * Create scale
	 * @param {Array.<number>} dataExtent
	 * @param {Object|module:echarts/Model} option
	 */
	function createScale(dataExtent, option) {
	  var axisModel = option;
	
	  if (!Model.isInstance(option)) {
	    axisModel = new Model(option);
	    zrUtil.mixin(axisModel, axisModelCommonMixin);
	  }
	
	  var scale = axisHelper.createScaleByModel(axisModel);
	  scale.setExtent(dataExtent[0], dataExtent[1]);
	  axisHelper.niceScaleExtent(scale, axisModel);
	  return scale;
	}
	/**
	 * Mixin common methods to axis model,
	 *
	 * Inlcude methods
	 * `getFormattedLabels() => Array.<string>`
	 * `getCategories() => Array.<string>`
	 * `getMin(origin: boolean) => number`
	 * `getMax(origin: boolean) => number`
	 * `getNeedCrossZero() => boolean`
	 * `setRange(start: number, end: number)`
	 * `resetRange()`
	 */
	
	
	function mixinAxisModelCommonMethods(Model) {
	  zrUtil.mixin(Model, axisModelCommonMixin);
	}
	
	exports.createList = createList;
	exports.dataStack = dataStack;
	exports.createScale = createScale;
	exports.mixinAxisModelCommonMethods = mixinAxisModelCommonMethods;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var List = __webpack_require__(342);
	
	var createDimensions = __webpack_require__(346);
	
	var _sourceType = __webpack_require__(313);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	
	var _dimensionHelper = __webpack_require__(344);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var _model = __webpack_require__(261);
	
	var getDataItemValue = _model.getDataItemValue;
	
	var CoordinateSystem = __webpack_require__(315);
	
	var _referHelper = __webpack_require__(348);
	
	var getCoordSysInfoBySeries = _referHelper.getCoordSysInfoBySeries;
	
	var Source = __webpack_require__(312);
	
	var _dataStackHelper = __webpack_require__(349);
	
	var enableDataStack = _dataStackHelper.enableDataStack;
	
	var _sourceHelper = __webpack_require__(311);
	
	var makeSeriesEncodeForAxisCoordSys = _sourceHelper.makeSeriesEncodeForAxisCoordSys;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/data/Source|Array} source Or raw data.
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Object} [opt]
	 * @param {string} [opt.generateCoord]
	 * @param {boolean} [opt.useEncodeDefaulter]
	 */
	function createListFromArray(source, seriesModel, opt) {
	  opt = opt || {};
	
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  var coordSysName = seriesModel.get('coordinateSystem');
	  var registeredCoordSys = CoordinateSystem.get(coordSysName);
	  var coordSysInfo = getCoordSysInfoBySeries(seriesModel);
	  var coordSysDimDefs;
	
	  if (coordSysInfo) {
	    coordSysDimDefs = zrUtil.map(coordSysInfo.coordSysDims, function (dim) {
	      var dimInfo = {
	        name: dim
	      };
	      var axisModel = coordSysInfo.axisMap.get(dim);
	
	      if (axisModel) {
	        var axisType = axisModel.get('type');
	        dimInfo.type = getDimensionTypeByAxis(axisType); // dimInfo.stackable = isStackable(axisType);
	      }
	
	      return dimInfo;
	    });
	  }
	
	  if (!coordSysDimDefs) {
	    // Get dimensions from registered coordinate system
	    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
	  }
	
	  var dimInfoList = createDimensions(source, {
	    coordDimensions: coordSysDimDefs,
	    generateCoord: opt.generateCoord,
	    encodeDefaulter: opt.useEncodeDefaulter ? zrUtil.curry(makeSeriesEncodeForAxisCoordSys, coordSysDimDefs, seriesModel) : null
	  });
	  var firstCategoryDimIndex;
	  var hasNameEncode;
	  coordSysInfo && zrUtil.each(dimInfoList, function (dimInfo, dimIndex) {
	    var coordDim = dimInfo.coordDim;
	    var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
	
	    if (categoryAxisModel) {
	      if (firstCategoryDimIndex == null) {
	        firstCategoryDimIndex = dimIndex;
	      }
	
	      dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
	    }
	
	    if (dimInfo.otherDims.itemName != null) {
	      hasNameEncode = true;
	    }
	  });
	
	  if (!hasNameEncode && firstCategoryDimIndex != null) {
	    dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
	  }
	
	  var stackCalculationInfo = enableDataStack(seriesModel, dimInfoList);
	  var list = new List(dimInfoList, seriesModel);
	  list.setCalculationInfo(stackCalculationInfo);
	  var dimValueGetter = firstCategoryDimIndex != null && isNeedCompleteOrdinalData(source) ? function (itemOpt, dimName, dataIndex, dimIndex) {
	    // Use dataIndex as ordinal value in categoryAxis
	    return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
	  } : null;
	  list.hasItemOption = false;
	  list.initData(source, null, dimValueGetter);
	  return list;
	}
	
	function isNeedCompleteOrdinalData(source) {
	  if (source.sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    var sampleItem = firstDataNotNull(source.data || []);
	    return sampleItem != null && !zrUtil.isArray(getDataItemValue(sampleItem));
	  }
	}
	
	function firstDataNotNull(data) {
	  var i = 0;
	
	  while (i < data.length && data[i] == null) {
	    i++;
	  }
	
	  return data[i];
	}
	
	var _default = createListFromArray;
	module.exports = _default;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(220);
	
	var Model = __webpack_require__(262);
	
	var DataDiffer = __webpack_require__(343);
	
	var Source = __webpack_require__(312);
	
	var _dataProvider = __webpack_require__(322);
	
	var defaultDimValueGetters = _dataProvider.defaultDimValueGetters;
	var DefaultDataProvider = _dataProvider.DefaultDataProvider;
	
	var _dimensionHelper = __webpack_require__(344);
	
	var summarizeDimensions = _dimensionHelper.summarizeDimensions;
	
	var DataDimensionInfo = __webpack_require__(345);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float64Array, Int32Array, Uint32Array, Uint16Array */
	
	/**
	 * List for data storage
	 * @module echarts/data/List
	 */
	var isObject = zrUtil.isObject;
	var UNDEFINED = 'undefined';
	var INDEX_NOT_FOUND = -1; // Use prefix to avoid index to be the same as otherIdList[idx],
	// which will cause weird udpate animation.
	
	var ID_PREFIX = 'e\0\0';
	var dataCtors = {
	  'float': typeof Float64Array === UNDEFINED ? Array : Float64Array,
	  'int': typeof Int32Array === UNDEFINED ? Array : Int32Array,
	  // Ordinal data type can be string or int
	  'ordinal': Array,
	  'number': Array,
	  'time': Array
	}; // Caution: MUST not use `new CtorUint32Array(arr, 0, len)`, because the Ctor of array is
	// different from the Ctor of typed array.
	
	var CtorUint32Array = typeof Uint32Array === UNDEFINED ? Array : Uint32Array;
	var CtorInt32Array = typeof Int32Array === UNDEFINED ? Array : Int32Array;
	var CtorUint16Array = typeof Uint16Array === UNDEFINED ? Array : Uint16Array;
	
	function getIndicesCtor(list) {
	  // The possible max value in this._indicies is always this._rawCount despite of filtering.
	  return list._rawCount > 65535 ? CtorUint32Array : CtorUint16Array;
	}
	
	function cloneChunk(originalChunk) {
	  var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.
	
	  return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
	}
	
	var TRANSFERABLE_PROPERTIES = ['hasItemOption', '_nameList', '_idList', '_invertedIndicesMap', '_rawData', '_chunkSize', '_chunkCount', '_dimValueGetter', '_count', '_rawCount', '_nameDimIdx', '_idDimIdx'];
	var CLONE_PROPERTIES = ['_extent', '_approximateExtent', '_rawExtent'];
	
	function transferProperties(target, source) {
	  zrUtil.each(TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function (propName) {
	    if (source.hasOwnProperty(propName)) {
	      target[propName] = source[propName];
	    }
	  });
	  target.__wrappedMethods = source.__wrappedMethods;
	  zrUtil.each(CLONE_PROPERTIES, function (propName) {
	    target[propName] = zrUtil.clone(source[propName]);
	  });
	  target._calculationInfo = zrUtil.extend(source._calculationInfo);
	}
	/**
	 * @constructor
	 * @alias module:echarts/data/List
	 *
	 * @param {Array.<string|Object|module:data/DataDimensionInfo>} dimensions
	 *      For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
	 *      Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
	 * @param {module:echarts/model/Model} hostModel
	 */
	
	
	var List = function (dimensions, hostModel) {
	  dimensions = dimensions || ['x', 'y'];
	  var dimensionInfos = {};
	  var dimensionNames = [];
	  var invertedIndicesMap = {};
	
	  for (var i = 0; i < dimensions.length; i++) {
	    // Use the original dimensions[i], where other flag props may exists.
	    var dimensionInfo = dimensions[i];
	
	    if (zrUtil.isString(dimensionInfo)) {
	      dimensionInfo = new DataDimensionInfo({
	        name: dimensionInfo
	      });
	    } else if (!(dimensionInfo instanceof DataDimensionInfo)) {
	      dimensionInfo = new DataDimensionInfo(dimensionInfo);
	    }
	
	    var dimensionName = dimensionInfo.name;
	    dimensionInfo.type = dimensionInfo.type || 'float';
	
	    if (!dimensionInfo.coordDim) {
	      dimensionInfo.coordDim = dimensionName;
	      dimensionInfo.coordDimIndex = 0;
	    }
	
	    dimensionInfo.otherDims = dimensionInfo.otherDims || {};
	    dimensionNames.push(dimensionName);
	    dimensionInfos[dimensionName] = dimensionInfo;
	    dimensionInfo.index = i;
	
	    if (dimensionInfo.createInvertedIndices) {
	      invertedIndicesMap[dimensionName] = [];
	    }
	  }
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	
	
	  this.dimensions = dimensionNames;
	  /**
	   * Infomation of each data dimension, like data type.
	   * @type {Object}
	   */
	
	  this._dimensionInfos = dimensionInfos;
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.hostModel = hostModel;
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.dataType;
	  /**
	   * Indices stores the indices of data subset after filtered.
	   * This data subset will be used in chart.
	   * @type {Array.<number>}
	   * @readOnly
	   */
	
	  this._indices = null;
	  this._count = 0;
	  this._rawCount = 0;
	  /**
	   * Data storage
	   * @type {Object.<key, Array.<TypedArray|Array>>}
	   * @private
	   */
	
	  this._storage = {};
	  /**
	   * @type {Array.<string>}
	   */
	
	  this._nameList = [];
	  /**
	   * @type {Array.<string>}
	   */
	
	  this._idList = [];
	  /**
	   * Models of data option is stored sparse for optimizing memory cost
	   * @type {Array.<module:echarts/model/Model>}
	   * @private
	   */
	
	  this._optionModels = [];
	  /**
	   * Global visual properties after visual coding
	   * @type {Object}
	   * @private
	   */
	
	  this._visual = {};
	  /**
	   * Globel layout properties.
	   * @type {Object}
	   * @private
	   */
	
	  this._layout = {};
	  /**
	   * Item visual properties after visual coding
	   * @type {Array.<Object>}
	   * @private
	   */
	
	  this._itemVisuals = [];
	  /**
	   * Key: visual type, Value: boolean
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.hasItemVisual = {};
	  /**
	   * Item layout properties after layout
	   * @type {Array.<Object>}
	   * @private
	   */
	
	  this._itemLayouts = [];
	  /**
	   * Graphic elemnents
	   * @type {Array.<module:zrender/Element>}
	   * @private
	   */
	
	  this._graphicEls = [];
	  /**
	   * Max size of each chunk.
	   * @type {number}
	   * @private
	   */
	
	  this._chunkSize = 1e5;
	  /**
	   * @type {number}
	   * @private
	   */
	
	  this._chunkCount = 0;
	  /**
	   * @type {Array.<Array|Object>}
	   * @private
	   */
	
	  this._rawData;
	  /**
	   * Raw extent will not be cloned, but only transfered.
	   * It will not be calculated util needed.
	   * key: dim,
	   * value: {end: number, extent: Array.<number>}
	   * @type {Object}
	   * @private
	   */
	
	  this._rawExtent = {};
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._extent = {};
	  /**
	   * key: dim
	   * value: extent
	   * @type {Object}
	   * @private
	   */
	
	  this._approximateExtent = {};
	  /**
	   * Cache summary info for fast visit. See "dimensionHelper".
	   * @type {Object}
	   * @private
	   */
	
	  this._dimensionsSummary = summarizeDimensions(this);
	  /**
	   * @type {Object.<Array|TypedArray>}
	   * @private
	   */
	
	  this._invertedIndicesMap = invertedIndicesMap;
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._calculationInfo = {};
	  /**
	   * User output info of this data.
	   * DO NOT use it in other places!
	   *
	   * When preparing user params for user callbacks, we have
	   * to clone these inner data structures to prevent users
	   * from modifying them to effect built-in logic. And for
	   * performance consideration we make this `userOutput` to
	   * avoid clone them too many times.
	   *
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.userOutput = this._dimensionsSummary.userOutput;
	};
	
	var listProto = List.prototype;
	listProto.type = 'list';
	/**
	 * If each data item has it's own option
	 * @type {boolean}
	 */
	
	listProto.hasItemOption = true;
	/**
	 * The meanings of the input parameter `dim`:
	 *
	 * + If dim is a number (e.g., `1`), it means the index of the dimension.
	 *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
	 * + If dim is a number-like string (e.g., `"1"`):
	 *     + If there is the same concrete dim name defined in `this.dimensions`, it means that concrete name.
	 *     + If not, it will be converted to a number, which means the index of the dimension.
	 *        (why? because of the backward compatbility. We have been tolerating number-like string in
	 *        dimension setting, although now it seems that it is not a good idea.)
	 *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
	 *     if no dimension name is defined as `"1"`.
	 * + If dim is a not-number-like string, it means the concrete dim name.
	 *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
	 *   or customized in `dimensions` property of option like `"age"`.
	 *
	 * Get dimension name
	 * @param {string|number} dim See above.
	 * @return {string} Concrete dim name.
	 */
	
	listProto.getDimension = function (dim) {
	  if (typeof dim === 'number' // If being a number-like string but not being defined a dimension name.
	  || !isNaN(dim) && !this._dimensionInfos.hasOwnProperty(dim)) {
	    dim = this.dimensions[dim];
	  }
	
	  return dim;
	};
	/**
	 * Get type and calculation info of particular dimension
	 * @param {string|number} dim
	 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
	 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
	 */
	
	
	listProto.getDimensionInfo = function (dim) {
	  // Do not clone, because there may be categories in dimInfo.
	  return this._dimensionInfos[this.getDimension(dim)];
	};
	/**
	 * @return {Array.<string>} concrete dimension name list on coord.
	 */
	
	
	listProto.getDimensionsOnCoord = function () {
	  return this._dimensionsSummary.dataDimsOnCoord.slice();
	};
	/**
	 * @param {string} coordDim
	 * @param {number} [idx] A coordDim may map to more than one data dim.
	 *        If idx is `true`, return a array of all mapped dims.
	 *        If idx is not specified, return the first dim not extra.
	 * @return {string|Array.<string>} concrete data dim.
	 *        If idx is number, and not found, return null/undefined.
	 *        If idx is `true`, and not found, return empty array (always return array).
	 */
	
	
	listProto.mapDimension = function (coordDim, idx) {
	  var dimensionsSummary = this._dimensionsSummary;
	
	  if (idx == null) {
	    return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
	  }
	
	  var dims = dimensionsSummary.encode[coordDim];
	  return idx === true // always return array if idx is `true`
	  ? (dims || []).slice() : dims && dims[idx];
	};
	/**
	 * Initialize from data
	 * @param {Array.<Object|number|Array>} data source or data or data provider.
	 * @param {Array.<string>} [nameLIst] The name of a datum is used on data diff and
	 *        default label/tooltip.
	 *        A name can be specified in encode.itemName,
	 *        or dataItem.name (only for series option data),
	 *        or provided in nameList from outside.
	 * @param {Function} [dimValueGetter] (dataItem, dimName, dataIndex, dimIndex) => number
	 */
	
	
	listProto.initData = function (data, nameList, dimValueGetter) {
	  var notProvider = Source.isInstance(data) || zrUtil.isArrayLike(data);
	
	  if (notProvider) {
	    data = new DefaultDataProvider(data, this.dimensions.length);
	  }
	
	  this._rawData = data; // Clear
	
	  this._storage = {};
	  this._indices = null;
	  this._nameList = nameList || [];
	  this._idList = [];
	  this._nameRepeatCount = {};
	
	  if (!dimValueGetter) {
	    this.hasItemOption = false;
	  }
	  /**
	   * @readOnly
	   */
	
	
	  this.defaultDimValueGetter = defaultDimValueGetters[this._rawData.getSource().sourceFormat]; // Default dim value getter
	
	  this._dimValueGetter = dimValueGetter = dimValueGetter || this.defaultDimValueGetter;
	  this._dimValueGetterArrayRows = defaultDimValueGetters.arrayRows; // Reset raw extent.
	
	  this._rawExtent = {};
	
	  this._initDataFromProvider(0, data.count()); // If data has no item option.
	
	
	  if (data.pure) {
	    this.hasItemOption = false;
	  }
	};
	
	listProto.getProvider = function () {
	  return this._rawData;
	};
	/**
	 * Caution: Can be only called on raw data (before `this._indices` created).
	 */
	
	
	listProto.appendData = function (data) {
	  var rawData = this._rawData;
	  var start = this.count();
	  rawData.appendData(data);
	  var end = rawData.count();
	
	  if (!rawData.persistent) {
	    end += start;
	  }
	
	  this._initDataFromProvider(start, end);
	};
	/**
	 * Caution: Can be only called on raw data (before `this._indices` created).
	 * This method does not modify `rawData` (`dataProvider`), but only
	 * add values to storage.
	 *
	 * The final count will be increased by `Math.max(values.length, names.length)`.
	 *
	 * @param {Array.<Array.<*>>} values That is the SourceType: 'arrayRows', like
	 *        [
	 *            [12, 33, 44],
	 *            [NaN, 43, 1],
	 *            ['-', 'asdf', 0]
	 *        ]
	 *        Each item is exaclty cooresponding to a dimension.
	 * @param {Array.<string>} [names]
	 */
	
	
	listProto.appendValues = function (values, names) {
	  var chunkSize = this._chunkSize;
	  var storage = this._storage;
	  var dimensions = this.dimensions;
	  var dimLen = dimensions.length;
	  var rawExtent = this._rawExtent;
	  var start = this.count();
	  var end = start + Math.max(values.length, names ? names.length : 0);
	  var originalChunkCount = this._chunkCount;
	
	  for (var i = 0; i < dimLen; i++) {
	    var dim = dimensions[i];
	
	    if (!rawExtent[dim]) {
	      rawExtent[dim] = getInitialExtent();
	    }
	
	    if (!storage[dim]) {
	      storage[dim] = [];
	    }
	
	    prepareChunks(storage, this._dimensionInfos[dim], chunkSize, originalChunkCount, end);
	    this._chunkCount = storage[dim].length;
	  }
	
	  var emptyDataItem = new Array(dimLen);
	
	  for (var idx = start; idx < end; idx++) {
	    var sourceIdx = idx - start;
	    var chunkIndex = Math.floor(idx / chunkSize);
	    var chunkOffset = idx % chunkSize; // Store the data by dimensions
	
	    for (var k = 0; k < dimLen; k++) {
	      var dim = dimensions[k];
	
	      var val = this._dimValueGetterArrayRows(values[sourceIdx] || emptyDataItem, dim, sourceIdx, k);
	
	      storage[dim][chunkIndex][chunkOffset] = val;
	      var dimRawExtent = rawExtent[dim];
	      val < dimRawExtent[0] && (dimRawExtent[0] = val);
	      val > dimRawExtent[1] && (dimRawExtent[1] = val);
	    }
	
	    if (names) {
	      this._nameList[idx] = names[sourceIdx];
	    }
	  }
	
	  this._rawCount = this._count = end; // Reset data extent
	
	  this._extent = {};
	  prepareInvertedIndex(this);
	};
	
	listProto._initDataFromProvider = function (start, end) {
	  // Optimize.
	  if (start >= end) {
	    return;
	  }
	
	  var chunkSize = this._chunkSize;
	  var rawData = this._rawData;
	  var storage = this._storage;
	  var dimensions = this.dimensions;
	  var dimLen = dimensions.length;
	  var dimensionInfoMap = this._dimensionInfos;
	  var nameList = this._nameList;
	  var idList = this._idList;
	  var rawExtent = this._rawExtent;
	  var nameRepeatCount = this._nameRepeatCount = {};
	  var nameDimIdx;
	  var originalChunkCount = this._chunkCount;
	
	  for (var i = 0; i < dimLen; i++) {
	    var dim = dimensions[i];
	
	    if (!rawExtent[dim]) {
	      rawExtent[dim] = getInitialExtent();
	    }
	
	    var dimInfo = dimensionInfoMap[dim];
	
	    if (dimInfo.otherDims.itemName === 0) {
	      nameDimIdx = this._nameDimIdx = i;
	    }
	
	    if (dimInfo.otherDims.itemId === 0) {
	      this._idDimIdx = i;
	    }
	
	    if (!storage[dim]) {
	      storage[dim] = [];
	    }
	
	    prepareChunks(storage, dimInfo, chunkSize, originalChunkCount, end);
	    this._chunkCount = storage[dim].length;
	  }
	
	  var dataItem = new Array(dimLen);
	
	  for (var idx = start; idx < end; idx++) {
	    // NOTICE: Try not to write things into dataItem
	    dataItem = rawData.getItem(idx, dataItem); // Each data item is value
	    // [1, 2]
	    // 2
	    // Bar chart, line chart which uses category axis
	    // only gives the 'y' value. 'x' value is the indices of category
	    // Use a tempValue to normalize the value to be a (x, y) value
	
	    var chunkIndex = Math.floor(idx / chunkSize);
	    var chunkOffset = idx % chunkSize; // Store the data by dimensions
	
	    for (var k = 0; k < dimLen; k++) {
	      var dim = dimensions[k];
	      var dimStorage = storage[dim][chunkIndex]; // PENDING NULL is empty or zero
	
	      var val = this._dimValueGetter(dataItem, dim, idx, k);
	
	      dimStorage[chunkOffset] = val;
	      var dimRawExtent = rawExtent[dim];
	      val < dimRawExtent[0] && (dimRawExtent[0] = val);
	      val > dimRawExtent[1] && (dimRawExtent[1] = val);
	    } // ??? FIXME not check by pure but sourceFormat?
	    // TODO refactor these logic.
	
	
	    if (!rawData.pure) {
	      var name = nameList[idx];
	
	      if (dataItem && name == null) {
	        // If dataItem is {name: ...}, it has highest priority.
	        // That is appropriate for many common cases.
	        if (dataItem.name != null) {
	          // There is no other place to persistent dataItem.name,
	          // so save it to nameList.
	          nameList[idx] = name = dataItem.name;
	        } else if (nameDimIdx != null) {
	          var nameDim = dimensions[nameDimIdx];
	          var nameDimChunk = storage[nameDim][chunkIndex];
	
	          if (nameDimChunk) {
	            name = nameDimChunk[chunkOffset];
	            var ordinalMeta = dimensionInfoMap[nameDim].ordinalMeta;
	
	            if (ordinalMeta && ordinalMeta.categories.length) {
	              name = ordinalMeta.categories[name];
	            }
	          }
	        }
	      } // Try using the id in option
	      // id or name is used on dynamical data, mapping old and new items.
	
	
	      var id = dataItem == null ? null : dataItem.id;
	
	      if (id == null && name != null) {
	        // Use name as id and add counter to avoid same name
	        nameRepeatCount[name] = nameRepeatCount[name] || 0;
	        id = name;
	
	        if (nameRepeatCount[name] > 0) {
	          id += '__ec__' + nameRepeatCount[name];
	        }
	
	        nameRepeatCount[name]++;
	      }
	
	      id != null && (idList[idx] = id);
	    }
	  }
	
	  if (!rawData.persistent && rawData.clean) {
	    // Clean unused data if data source is typed array.
	    rawData.clean();
	  }
	
	  this._rawCount = this._count = end; // Reset data extent
	
	  this._extent = {};
	  prepareInvertedIndex(this);
	};
	
	function prepareChunks(storage, dimInfo, chunkSize, chunkCount, end) {
	  var DataCtor = dataCtors[dimInfo.type];
	  var lastChunkIndex = chunkCount - 1;
	  var dim = dimInfo.name;
	  var resizeChunkArray = storage[dim][lastChunkIndex];
	
	  if (resizeChunkArray && resizeChunkArray.length < chunkSize) {
	    var newStore = new DataCtor(Math.min(end - lastChunkIndex * chunkSize, chunkSize)); // The cost of the copy is probably inconsiderable
	    // within the initial chunkSize.
	
	    for (var j = 0; j < resizeChunkArray.length; j++) {
	      newStore[j] = resizeChunkArray[j];
	    }
	
	    storage[dim][lastChunkIndex] = newStore;
	  } // Create new chunks.
	
	
	  for (var k = chunkCount * chunkSize; k < end; k += chunkSize) {
	    storage[dim].push(new DataCtor(Math.min(end - k, chunkSize)));
	  }
	}
	
	function prepareInvertedIndex(list) {
	  var invertedIndicesMap = list._invertedIndicesMap;
	  zrUtil.each(invertedIndicesMap, function (invertedIndices, dim) {
	    var dimInfo = list._dimensionInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.
	
	    var ordinalMeta = dimInfo.ordinalMeta;
	
	    if (ordinalMeta) {
	      invertedIndices = invertedIndicesMap[dim] = new CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
	      // mapping to 0, we should set it as INDEX_NOT_FOUND.
	
	      for (var i = 0; i < invertedIndices.length; i++) {
	        invertedIndices[i] = INDEX_NOT_FOUND;
	      }
	
	      for (var i = 0; i < list._count; i++) {
	        // Only support the case that all values are distinct.
	        invertedIndices[list.get(dim, i)] = i;
	      }
	    }
	  });
	}
	
	function getRawValueFromStore(list, dimIndex, rawIndex) {
	  var val;
	
	  if (dimIndex != null) {
	    var chunkSize = list._chunkSize;
	    var chunkIndex = Math.floor(rawIndex / chunkSize);
	    var chunkOffset = rawIndex % chunkSize;
	    var dim = list.dimensions[dimIndex];
	    var chunk = list._storage[dim][chunkIndex];
	
	    if (chunk) {
	      val = chunk[chunkOffset];
	      var ordinalMeta = list._dimensionInfos[dim].ordinalMeta;
	
	      if (ordinalMeta && ordinalMeta.categories.length) {
	        val = ordinalMeta.categories[val];
	      }
	    }
	  }
	
	  return val;
	}
	/**
	 * @return {number}
	 */
	
	
	listProto.count = function () {
	  return this._count;
	};
	
	listProto.getIndices = function () {
	  var newIndices;
	  var indices = this._indices;
	
	  if (indices) {
	    var Ctor = indices.constructor;
	    var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
	
	    if (Ctor === Array) {
	      newIndices = new Ctor(thisCount);
	
	      for (var i = 0; i < thisCount; i++) {
	        newIndices[i] = indices[i];
	      }
	    } else {
	      newIndices = new Ctor(indices.buffer, 0, thisCount);
	    }
	  } else {
	    var Ctor = getIndicesCtor(this);
	    var newIndices = new Ctor(this.count());
	
	    for (var i = 0; i < newIndices.length; i++) {
	      newIndices[i] = i;
	    }
	  }
	
	  return newIndices;
	};
	/**
	 * Get value. Return NaN if idx is out of range.
	 * @param {string} dim Dim must be concrete name.
	 * @param {number} idx
	 * @param {boolean} stack
	 * @return {number}
	 */
	
	
	listProto.get = function (dim, idx
	/*, stack */
	) {
	  if (!(idx >= 0 && idx < this._count)) {
	    return NaN;
	  }
	
	  var storage = this._storage;
	
	  if (!storage[dim]) {
	    // TODO Warn ?
	    return NaN;
	  }
	
	  idx = this.getRawIndex(idx);
	  var chunkIndex = Math.floor(idx / this._chunkSize);
	  var chunkOffset = idx % this._chunkSize;
	  var chunkStore = storage[dim][chunkIndex];
	  var value = chunkStore[chunkOffset]; // FIXME ordinal data type is not stackable
	  // if (stack) {
	  //     var dimensionInfo = this._dimensionInfos[dim];
	  //     if (dimensionInfo && dimensionInfo.stackable) {
	  //         var stackedOn = this.stackedOn;
	  //         while (stackedOn) {
	  //             // Get no stacked data of stacked on
	  //             var stackedValue = stackedOn.get(dim, idx);
	  //             // Considering positive stack, negative stack and empty data
	  //             if ((value >= 0 && stackedValue > 0)  // Positive stack
	  //                 || (value <= 0 && stackedValue < 0) // Negative stack
	  //             ) {
	  //                 value += stackedValue;
	  //             }
	  //             stackedOn = stackedOn.stackedOn;
	  //         }
	  //     }
	  // }
	
	  return value;
	};
	/**
	 * @param {string} dim concrete dim
	 * @param {number} rawIndex
	 * @return {number|string}
	 */
	
	
	listProto.getByRawIndex = function (dim, rawIdx) {
	  if (!(rawIdx >= 0 && rawIdx < this._rawCount)) {
	    return NaN;
	  }
	
	  var dimStore = this._storage[dim];
	
	  if (!dimStore) {
	    // TODO Warn ?
	    return NaN;
	  }
	
	  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
	  var chunkOffset = rawIdx % this._chunkSize;
	  var chunkStore = dimStore[chunkIndex];
	  return chunkStore[chunkOffset];
	};
	/**
	 * FIXME Use `get` on chrome maybe slow(in filterSelf and selectRange).
	 * Hack a much simpler _getFast
	 * @private
	 */
	
	
	listProto._getFast = function (dim, rawIdx) {
	  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
	  var chunkOffset = rawIdx % this._chunkSize;
	  var chunkStore = this._storage[dim][chunkIndex];
	  return chunkStore[chunkOffset];
	};
	/**
	 * Get value for multi dimensions.
	 * @param {Array.<string>} [dimensions] If ignored, using all dimensions.
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getValues = function (dimensions, idx
	/*, stack */
	) {
	  var values = [];
	
	  if (!zrUtil.isArray(dimensions)) {
	    // stack = idx;
	    idx = dimensions;
	    dimensions = this.dimensions;
	  }
	
	  for (var i = 0, len = dimensions.length; i < len; i++) {
	    values.push(this.get(dimensions[i], idx
	    /*, stack */
	    ));
	  }
	
	  return values;
	};
	/**
	 * If value is NaN. Inlcuding '-'
	 * Only check the coord dimensions.
	 * @param {string} dim
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.hasValue = function (idx) {
	  var dataDimsOnCoord = this._dimensionsSummary.dataDimsOnCoord;
	
	  for (var i = 0, len = dataDimsOnCoord.length; i < len; i++) {
	    // Ordinal type originally can be string or number.
	    // But when an ordinal type is used on coord, it can
	    // not be string but only number. So we can also use isNaN.
	    if (isNaN(this.get(dataDimsOnCoord[i], idx))) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Get extent of data in one dimension
	 * @param {string} dim
	 * @param {boolean} stack
	 */
	
	
	listProto.getDataExtent = function (dim
	/*, stack */
	) {
	  // Make sure use concrete dim as cache name.
	  dim = this.getDimension(dim);
	  var dimData = this._storage[dim];
	  var initialExtent = getInitialExtent(); // stack = !!((stack || false) && this.getCalculationInfo(dim));
	
	  if (!dimData) {
	    return initialExtent;
	  } // Make more strict checkings to ensure hitting cache.
	
	
	  var currEnd = this.count(); // var cacheName = [dim, !!stack].join('_');
	  // var cacheName = dim;
	  // Consider the most cases when using data zoom, `getDataExtent`
	  // happened before filtering. We cache raw extent, which is not
	  // necessary to be cleared and recalculated when restore data.
	
	  var useRaw = !this._indices; // && !stack;
	
	  var dimExtent;
	
	  if (useRaw) {
	    return this._rawExtent[dim].slice();
	  }
	
	  dimExtent = this._extent[dim];
	
	  if (dimExtent) {
	    return dimExtent.slice();
	  }
	
	  dimExtent = initialExtent;
	  var min = dimExtent[0];
	  var max = dimExtent[1];
	
	  for (var i = 0; i < currEnd; i++) {
	    // var value = stack ? this.get(dim, i, true) : this._getFast(dim, this.getRawIndex(i));
	    var value = this._getFast(dim, this.getRawIndex(i));
	
	    value < min && (min = value);
	    value > max && (max = value);
	  }
	
	  dimExtent = [min, max];
	  this._extent[dim] = dimExtent;
	  return dimExtent;
	};
	/**
	 * Optimize for the scenario that data is filtered by a given extent.
	 * Consider that if data amount is more than hundreds of thousand,
	 * extent calculation will cost more than 10ms and the cache will
	 * be erased because of the filtering.
	 */
	
	
	listProto.getApproximateExtent = function (dim
	/*, stack */
	) {
	  dim = this.getDimension(dim);
	  return this._approximateExtent[dim] || this.getDataExtent(dim
	  /*, stack */
	  );
	};
	
	listProto.setApproximateExtent = function (extent, dim
	/*, stack */
	) {
	  dim = this.getDimension(dim);
	  this._approximateExtent[dim] = extent.slice();
	};
	/**
	 * @param {string} key
	 * @return {*}
	 */
	
	
	listProto.getCalculationInfo = function (key) {
	  return this._calculationInfo[key];
	};
	/**
	 * @param {string|Object} key or k-v object
	 * @param {*} [value]
	 */
	
	
	listProto.setCalculationInfo = function (key, value) {
	  isObject(key) ? zrUtil.extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
	};
	/**
	 * Get sum of data in one dimension
	 * @param {string} dim
	 */
	
	
	listProto.getSum = function (dim
	/*, stack */
	) {
	  var dimData = this._storage[dim];
	  var sum = 0;
	
	  if (dimData) {
	    for (var i = 0, len = this.count(); i < len; i++) {
	      var value = this.get(dim, i
	      /*, stack */
	      );
	
	      if (!isNaN(value)) {
	        sum += value;
	      }
	    }
	  }
	
	  return sum;
	};
	/**
	 * Get median of data in one dimension
	 * @param {string} dim
	 */
	
	
	listProto.getMedian = function (dim
	/*, stack */
	) {
	  var dimDataArray = []; // map all data of one dimension
	
	  this.each(dim, function (val, idx) {
	    if (!isNaN(val)) {
	      dimDataArray.push(val);
	    }
	  }); // TODO
	  // Use quick select?
	  // immutability & sort
	
	  var sortedDimDataArray = [].concat(dimDataArray).sort(function (a, b) {
	    return a - b;
	  });
	  var len = this.count(); // calculate median
	
	  return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
	}; // /**
	//  * Retreive the index with given value
	//  * @param {string} dim Concrete dimension.
	//  * @param {number} value
	//  * @return {number}
	//  */
	// Currently incorrect: should return dataIndex but not rawIndex.
	// Do not fix it until this method is to be used somewhere.
	// FIXME Precision of float value
	// listProto.indexOf = function (dim, value) {
	//     var storage = this._storage;
	//     var dimData = storage[dim];
	//     var chunkSize = this._chunkSize;
	//     if (dimData) {
	//         for (var i = 0, len = this.count(); i < len; i++) {
	//             var chunkIndex = Math.floor(i / chunkSize);
	//             var chunkOffset = i % chunkSize;
	//             if (dimData[chunkIndex][chunkOffset] === value) {
	//                 return i;
	//             }
	//         }
	//     }
	//     return -1;
	// };
	
	/**
	 * Only support the dimension which inverted index created.
	 * Do not support other cases until required.
	 * @param {string} concrete dim
	 * @param {number|string} value
	 * @return {number} rawIndex
	 */
	
	
	listProto.rawIndexOf = function (dim, value) {
	  var invertedIndices = dim && this._invertedIndicesMap[dim];
	  var rawIndex = invertedIndices[value];
	
	  if (rawIndex == null || isNaN(rawIndex)) {
	    return INDEX_NOT_FOUND;
	  }
	
	  return rawIndex;
	};
	/**
	 * Retreive the index with given name
	 * @param {number} idx
	 * @param {number} name
	 * @return {number}
	 */
	
	
	listProto.indexOfName = function (name) {
	  for (var i = 0, len = this.count(); i < len; i++) {
	    if (this.getName(i) === name) {
	      return i;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index with given raw data index
	 * @param {number} idx
	 * @param {number} name
	 * @return {number}
	 */
	
	
	listProto.indexOfRawIndex = function (rawIndex) {
	  if (rawIndex >= this._rawCount || rawIndex < 0) {
	    return -1;
	  }
	
	  if (!this._indices) {
	    return rawIndex;
	  } // Indices are ascending
	
	
	  var indices = this._indices; // If rawIndex === dataIndex
	
	  var rawDataIndex = indices[rawIndex];
	
	  if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) {
	    return rawIndex;
	  }
	
	  var left = 0;
	  var right = this._count - 1;
	
	  while (left <= right) {
	    var mid = (left + right) / 2 | 0;
	
	    if (indices[mid] < rawIndex) {
	      left = mid + 1;
	    } else if (indices[mid] > rawIndex) {
	      right = mid - 1;
	    } else {
	      return mid;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index of nearest value
	 * @param {string} dim
	 * @param {number} value
	 * @param {number} [maxDistance=Infinity]
	 * @return {Array.<number>} If and only if multiple indices has
	 *        the same value, they are put to the result.
	 */
	
	
	listProto.indicesOfNearest = function (dim, value, maxDistance) {
	  var storage = this._storage;
	  var dimData = storage[dim];
	  var nearestIndices = [];
	
	  if (!dimData) {
	    return nearestIndices;
	  }
	
	  if (maxDistance == null) {
	    maxDistance = Infinity;
	  }
	
	  var minDist = Infinity;
	  var minDiff = -1;
	  var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/List.js`.
	
	  for (var i = 0, len = this.count(); i < len; i++) {
	    var diff = value - this.get(dim, i);
	    var dist = Math.abs(diff);
	
	    if (dist <= maxDistance) {
	      // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
	      // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
	      // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
	      // So we chose the one that `diff >= 0` in this csae.
	      // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
	      // should be push to `nearestIndices`.
	      if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
	        minDist = dist;
	        minDiff = diff;
	        nearestIndicesLen = 0;
	      }
	
	      if (diff === minDiff) {
	        nearestIndices[nearestIndicesLen++] = i;
	      }
	    }
	  }
	
	  nearestIndices.length = nearestIndicesLen;
	  return nearestIndices;
	};
	/**
	 * Get raw data index
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getRawIndex = getRawIndexWithoutIndices;
	
	function getRawIndexWithoutIndices(idx) {
	  return idx;
	}
	
	function getRawIndexWithIndices(idx) {
	  if (idx < this._count && idx >= 0) {
	    return this._indices[idx];
	  }
	
	  return -1;
	}
	/**
	 * Get raw data item
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getRawDataItem = function (idx) {
	  if (!this._rawData.persistent) {
	    var val = [];
	
	    for (var i = 0; i < this.dimensions.length; i++) {
	      var dim = this.dimensions[i];
	      val.push(this.get(dim, idx));
	    }
	
	    return val;
	  } else {
	    return this._rawData.getItem(this.getRawIndex(idx));
	  }
	};
	/**
	 * @param {number} idx
	 * @param {boolean} [notDefaultIdx=false]
	 * @return {string}
	 */
	
	
	listProto.getName = function (idx) {
	  var rawIndex = this.getRawIndex(idx);
	  return this._nameList[rawIndex] || getRawValueFromStore(this, this._nameDimIdx, rawIndex) || '';
	};
	/**
	 * @param {number} idx
	 * @param {boolean} [notDefaultIdx=false]
	 * @return {string}
	 */
	
	
	listProto.getId = function (idx) {
	  return getId(this, this.getRawIndex(idx));
	};
	
	function getId(list, rawIndex) {
	  var id = list._idList[rawIndex];
	
	  if (id == null) {
	    id = getRawValueFromStore(list, list._idDimIdx, rawIndex);
	  }
	
	  if (id == null) {
	    // FIXME Check the usage in graph, should not use prefix.
	    id = ID_PREFIX + rawIndex;
	  }
	
	  return id;
	}
	
	function normalizeDimensions(dimensions) {
	  if (!zrUtil.isArray(dimensions)) {
	    dimensions = [dimensions];
	  }
	
	  return dimensions;
	}
	
	function validateDimensions(list, dims) {
	  for (var i = 0; i < dims.length; i++) {
	    // stroage may be empty when no data, so use
	    // dimensionInfos to check.
	    if (!list._dimensionInfos[dims[i]]) {
	      console.error('Unkown dimension ' + dims[i]);
	    }
	  }
	}
	/**
	 * Data iteration
	 * @param {string|Array.<string>}
	 * @param {Function} cb
	 * @param {*} [context=this]
	 *
	 * @example
	 *  list.each('x', function (x, idx) {});
	 *  list.each(['x', 'y'], function (x, y, idx) {});
	 *  list.each(function (idx) {})
	 */
	
	
	listProto.each = function (dims, cb, context, contextCompat) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  if (typeof dims === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dims;
	    dims = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  dims = zrUtil.map(normalizeDimensions(dims), this.getDimension, this);
	  var dimSize = dims.length;
	
	  for (var i = 0; i < this.count(); i++) {
	    // Simple optimization
	    switch (dimSize) {
	      case 0:
	        cb.call(context, i);
	        break;
	
	      case 1:
	        cb.call(context, this.get(dims[0], i), i);
	        break;
	
	      case 2:
	        cb.call(context, this.get(dims[0], i), this.get(dims[1], i), i);
	        break;
	
	      default:
	        var k = 0;
	        var value = [];
	
	        for (; k < dimSize; k++) {
	          value[k] = this.get(dims[k], i);
	        } // Index
	
	
	        value[k] = i;
	        cb.apply(context, value);
	    }
	  }
	};
	/**
	 * Data filter
	 * @param {string|Array.<string>}
	 * @param {Function} cb
	 * @param {*} [context=this]
	 */
	
	
	listProto.filterSelf = function (dimensions, cb, context, contextCompat) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  if (typeof dimensions === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dimensions;
	    dimensions = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
	  var count = this.count();
	  var Ctor = getIndicesCtor(this);
	  var newIndices = new Ctor(count);
	  var value = [];
	  var dimSize = dimensions.length;
	  var offset = 0;
	  var dim0 = dimensions[0];
	
	  for (var i = 0; i < count; i++) {
	    var keep;
	    var rawIdx = this.getRawIndex(i); // Simple optimization
	
	    if (dimSize === 0) {
	      keep = cb.call(context, i);
	    } else if (dimSize === 1) {
	      var val = this._getFast(dim0, rawIdx);
	
	      keep = cb.call(context, val, i);
	    } else {
	      for (var k = 0; k < dimSize; k++) {
	        value[k] = this._getFast(dim0, rawIdx);
	      }
	
	      value[k] = i;
	      keep = cb.apply(context, value);
	    }
	
	    if (keep) {
	      newIndices[offset++] = rawIdx;
	    }
	  } // Set indices after filtered.
	
	
	  if (offset < count) {
	    this._indices = newIndices;
	  }
	
	  this._count = offset; // Reset data extent
	
	  this._extent = {};
	  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return this;
	};
	/**
	 * Select data in range. (For optimization of filter)
	 * (Manually inline code, support 5 million data filtering in data zoom.)
	 */
	
	
	listProto.selectRange = function (range) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  var dimensions = [];
	
	  for (var dim in range) {
	    if (range.hasOwnProperty(dim)) {
	      dimensions.push(dim);
	    }
	  }
	
	  var dimSize = dimensions.length;
	
	  if (!dimSize) {
	    return;
	  }
	
	  var originalCount = this.count();
	  var Ctor = getIndicesCtor(this);
	  var newIndices = new Ctor(originalCount);
	  var offset = 0;
	  var dim0 = dimensions[0];
	  var min = range[dim0][0];
	  var max = range[dim0][1];
	  var quickFinished = false;
	
	  if (!this._indices) {
	    // Extreme optimization for common case. About 2x faster in chrome.
	    var idx = 0;
	
	    if (dimSize === 1) {
	      var dimStorage = this._storage[dimensions[0]];
	
	      for (var k = 0; k < this._chunkCount; k++) {
	        var chunkStorage = dimStorage[k];
	        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);
	
	        for (var i = 0; i < len; i++) {
	          var val = chunkStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
	          // value indicates the line should be broken. But for the case like
	          // scatter plot, a data item with empty value will not be rendered,
	          // but the axis extent may be effected if some other dim of the data
	          // item has value. Fortunately it is not a significant negative effect.
	
	          if (val >= min && val <= max || isNaN(val)) {
	            newIndices[offset++] = idx;
	          }
	
	          idx++;
	        }
	      }
	
	      quickFinished = true;
	    } else if (dimSize === 2) {
	      var dimStorage = this._storage[dim0];
	      var dimStorage2 = this._storage[dimensions[1]];
	      var min2 = range[dimensions[1]][0];
	      var max2 = range[dimensions[1]][1];
	
	      for (var k = 0; k < this._chunkCount; k++) {
	        var chunkStorage = dimStorage[k];
	        var chunkStorage2 = dimStorage2[k];
	        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);
	
	        for (var i = 0; i < len; i++) {
	          var val = chunkStorage[i];
	          var val2 = chunkStorage2[i]; // Do not filter NaN, see comment above.
	
	          if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) {
	            newIndices[offset++] = idx;
	          }
	
	          idx++;
	        }
	      }
	
	      quickFinished = true;
	    }
	  }
	
	  if (!quickFinished) {
	    if (dimSize === 1) {
	      for (var i = 0; i < originalCount; i++) {
	        var rawIndex = this.getRawIndex(i);
	
	        var val = this._getFast(dim0, rawIndex); // Do not filter NaN, see comment above.
	
	
	        if (val >= min && val <= max || isNaN(val)) {
	          newIndices[offset++] = rawIndex;
	        }
	      }
	    } else {
	      for (var i = 0; i < originalCount; i++) {
	        var keep = true;
	        var rawIndex = this.getRawIndex(i);
	
	        for (var k = 0; k < dimSize; k++) {
	          var dimk = dimensions[k];
	
	          var val = this._getFast(dim, rawIndex); // Do not filter NaN, see comment above.
	
	
	          if (val < range[dimk][0] || val > range[dimk][1]) {
	            keep = false;
	          }
	        }
	
	        if (keep) {
	          newIndices[offset++] = this.getRawIndex(i);
	        }
	      }
	    }
	  } // Set indices after filtered.
	
	
	  if (offset < originalCount) {
	    this._indices = newIndices;
	  }
	
	  this._count = offset; // Reset data extent
	
	  this._extent = {};
	  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return this;
	};
	/**
	 * Data mapping to a plain array
	 * @param {string|Array.<string>} [dimensions]
	 * @param {Function} cb
	 * @param {*} [context=this]
	 * @return {Array}
	 */
	
	
	listProto.mapArray = function (dimensions, cb, context, contextCompat) {
	  'use strict';
	
	  if (typeof dimensions === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dimensions;
	    dimensions = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  var result = [];
	  this.each(dimensions, function () {
	    result.push(cb && cb.apply(this, arguments));
	  }, context);
	  return result;
	}; // Data in excludeDimensions is copied, otherwise transfered.
	
	
	function cloneListForMapAndSample(original, excludeDimensions) {
	  var allDimensions = original.dimensions;
	  var list = new List(zrUtil.map(allDimensions, original.getDimensionInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked
	
	  transferProperties(list, original);
	  var storage = list._storage = {};
	  var originalStorage = original._storage; // Init storage
	
	  for (var i = 0; i < allDimensions.length; i++) {
	    var dim = allDimensions[i];
	
	    if (originalStorage[dim]) {
	      // Notice that we do not reset invertedIndicesMap here, becuase
	      // there is no scenario of mapping or sampling ordinal dimension.
	      if (zrUtil.indexOf(excludeDimensions, dim) >= 0) {
	        storage[dim] = cloneDimStore(originalStorage[dim]);
	        list._rawExtent[dim] = getInitialExtent();
	        list._extent[dim] = null;
	      } else {
	        // Direct reference for other dimensions
	        storage[dim] = originalStorage[dim];
	      }
	    }
	  }
	
	  return list;
	}
	
	function cloneDimStore(originalDimStore) {
	  var newDimStore = new Array(originalDimStore.length);
	
	  for (var j = 0; j < originalDimStore.length; j++) {
	    newDimStore[j] = cloneChunk(originalDimStore[j]);
	  }
	
	  return newDimStore;
	}
	
	function getInitialExtent() {
	  return [Infinity, -Infinity];
	}
	/**
	 * Data mapping to a new List with given dimensions
	 * @param {string|Array.<string>} dimensions
	 * @param {Function} cb
	 * @param {*} [context=this]
	 * @return {Array}
	 */
	
	
	listProto.map = function (dimensions, cb, context, contextCompat) {
	  'use strict'; // contextCompat just for compat echarts3
	
	  context = context || contextCompat || this;
	  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
	  var list = cloneListForMapAndSample(this, dimensions); // Following properties are all immutable.
	  // So we can reference to the same value
	
	  list._indices = this._indices;
	  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  var storage = list._storage;
	  var tmpRetValue = [];
	  var chunkSize = this._chunkSize;
	  var dimSize = dimensions.length;
	  var dataCount = this.count();
	  var values = [];
	  var rawExtent = list._rawExtent;
	
	  for (var dataIndex = 0; dataIndex < dataCount; dataIndex++) {
	    for (var dimIndex = 0; dimIndex < dimSize; dimIndex++) {
	      values[dimIndex] = this.get(dimensions[dimIndex], dataIndex
	      /*, stack */
	      );
	    }
	
	    values[dimSize] = dataIndex;
	    var retValue = cb && cb.apply(context, values);
	
	    if (retValue != null) {
	      // a number or string (in oridinal dimension)?
	      if (typeof retValue !== 'object') {
	        tmpRetValue[0] = retValue;
	        retValue = tmpRetValue;
	      }
	
	      var rawIndex = this.getRawIndex(dataIndex);
	      var chunkIndex = Math.floor(rawIndex / chunkSize);
	      var chunkOffset = rawIndex % chunkSize;
	
	      for (var i = 0; i < retValue.length; i++) {
	        var dim = dimensions[i];
	        var val = retValue[i];
	        var rawExtentOnDim = rawExtent[dim];
	        var dimStore = storage[dim];
	
	        if (dimStore) {
	          dimStore[chunkIndex][chunkOffset] = val;
	        }
	
	        if (val < rawExtentOnDim[0]) {
	          rawExtentOnDim[0] = val;
	        }
	
	        if (val > rawExtentOnDim[1]) {
	          rawExtentOnDim[1] = val;
	        }
	      }
	    }
	  }
	
	  return list;
	};
	/**
	 * Large data down sampling on given dimension
	 * @param {string} dimension
	 * @param {number} rate
	 * @param {Function} sampleValue
	 * @param {Function} sampleIndex Sample index for name and id
	 */
	
	
	listProto.downSample = function (dimension, rate, sampleValue, sampleIndex) {
	  var list = cloneListForMapAndSample(this, [dimension]);
	  var targetStorage = list._storage;
	  var frameValues = [];
	  var frameSize = Math.floor(1 / rate);
	  var dimStore = targetStorage[dimension];
	  var len = this.count();
	  var chunkSize = this._chunkSize;
	  var rawExtentOnDim = list._rawExtent[dimension];
	  var newIndices = new (getIndicesCtor(this))(len);
	  var offset = 0;
	
	  for (var i = 0; i < len; i += frameSize) {
	    // Last frame
	    if (frameSize > len - i) {
	      frameSize = len - i;
	      frameValues.length = frameSize;
	    }
	
	    for (var k = 0; k < frameSize; k++) {
	      var dataIdx = this.getRawIndex(i + k);
	      var originalChunkIndex = Math.floor(dataIdx / chunkSize);
	      var originalChunkOffset = dataIdx % chunkSize;
	      frameValues[k] = dimStore[originalChunkIndex][originalChunkOffset];
	    }
	
	    var value = sampleValue(frameValues);
	    var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
	    var sampleChunkIndex = Math.floor(sampleFrameIdx / chunkSize);
	    var sampleChunkOffset = sampleFrameIdx % chunkSize; // Only write value on the filtered data
	
	    dimStore[sampleChunkIndex][sampleChunkOffset] = value;
	
	    if (value < rawExtentOnDim[0]) {
	      rawExtentOnDim[0] = value;
	    }
	
	    if (value > rawExtentOnDim[1]) {
	      rawExtentOnDim[1] = value;
	    }
	
	    newIndices[offset++] = sampleFrameIdx;
	  }
	
	  list._count = offset;
	  list._indices = newIndices;
	  list.getRawIndex = getRawIndexWithIndices;
	  return list;
	};
	/**
	 * Get model of one data item.
	 *
	 * @param {number} idx
	 */
	// FIXME Model proxy ?
	
	
	listProto.getItemModel = function (idx) {
	  var hostModel = this.hostModel;
	  return new Model(this.getRawDataItem(idx), hostModel, hostModel && hostModel.ecModel);
	};
	/**
	 * Create a data differ
	 * @param {module:echarts/data/List} otherList
	 * @return {module:echarts/data/DataDiffer}
	 */
	
	
	listProto.diff = function (otherList) {
	  var thisList = this;
	  return new DataDiffer(otherList ? otherList.getIndices() : [], this.getIndices(), function (idx) {
	    return getId(otherList, idx);
	  }, function (idx) {
	    return getId(thisList, idx);
	  });
	};
	/**
	 * Get visual property.
	 * @param {string} key
	 */
	
	
	listProto.getVisual = function (key) {
	  var visual = this._visual;
	  return visual && visual[key];
	};
	/**
	 * Set visual property
	 * @param {string|Object} key
	 * @param {*} [value]
	 *
	 * @example
	 *  setVisual('color', color);
	 *  setVisual({
	 *      'color': color
	 *  });
	 */
	
	
	listProto.setVisual = function (key, val) {
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        this.setVisual(name, key[name]);
	      }
	    }
	
	    return;
	  }
	
	  this._visual = this._visual || {};
	  this._visual[key] = val;
	};
	/**
	 * Set layout property.
	 * @param {string|Object} key
	 * @param {*} [val]
	 */
	
	
	listProto.setLayout = function (key, val) {
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        this.setLayout(name, key[name]);
	      }
	    }
	
	    return;
	  }
	
	  this._layout[key] = val;
	};
	/**
	 * Get layout property.
	 * @param  {string} key.
	 * @return {*}
	 */
	
	
	listProto.getLayout = function (key) {
	  return this._layout[key];
	};
	/**
	 * Get layout of single data item
	 * @param {number} idx
	 */
	
	
	listProto.getItemLayout = function (idx) {
	  return this._itemLayouts[idx];
	};
	/**
	 * Set layout of single data item
	 * @param {number} idx
	 * @param {Object} layout
	 * @param {boolean=} [merge=false]
	 */
	
	
	listProto.setItemLayout = function (idx, layout, merge) {
	  this._itemLayouts[idx] = merge ? zrUtil.extend(this._itemLayouts[idx] || {}, layout) : layout;
	};
	/**
	 * Clear all layout of single data item
	 */
	
	
	listProto.clearItemLayouts = function () {
	  this._itemLayouts.length = 0;
	};
	/**
	 * Get visual property of single data item
	 * @param {number} idx
	 * @param {string} key
	 * @param {boolean} [ignoreParent=false]
	 */
	
	
	listProto.getItemVisual = function (idx, key, ignoreParent) {
	  var itemVisual = this._itemVisuals[idx];
	  var val = itemVisual && itemVisual[key];
	
	  if (val == null && !ignoreParent) {
	    // Use global visual property
	    return this.getVisual(key);
	  }
	
	  return val;
	};
	/**
	 * Set visual property of single data item
	 *
	 * @param {number} idx
	 * @param {string|Object} key
	 * @param {*} [value]
	 *
	 * @example
	 *  setItemVisual(0, 'color', color);
	 *  setItemVisual(0, {
	 *      'color': color
	 *  });
	 */
	
	
	listProto.setItemVisual = function (idx, key, value) {
	  var itemVisual = this._itemVisuals[idx] || {};
	  var hasItemVisual = this.hasItemVisual;
	  this._itemVisuals[idx] = itemVisual;
	
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        itemVisual[name] = key[name];
	        hasItemVisual[name] = true;
	      }
	    }
	
	    return;
	  }
	
	  itemVisual[key] = value;
	  hasItemVisual[key] = true;
	};
	/**
	 * Clear itemVisuals and list visual.
	 */
	
	
	listProto.clearAllVisual = function () {
	  this._visual = {};
	  this._itemVisuals = [];
	  this.hasItemVisual = {};
	};
	
	var setItemDataAndSeriesIndex = function (child) {
	  child.seriesIndex = this.seriesIndex;
	  child.dataIndex = this.dataIndex;
	  child.dataType = this.dataType;
	};
	/**
	 * Set graphic element relative to data. It can be set as null
	 * @param {number} idx
	 * @param {module:zrender/Element} [el]
	 */
	
	
	listProto.setItemGraphicEl = function (idx, el) {
	  var hostModel = this.hostModel;
	
	  if (el) {
	    // Add data index and series index for indexing the data by element
	    // Useful in tooltip
	    el.dataIndex = idx;
	    el.dataType = this.dataType;
	    el.seriesIndex = hostModel && hostModel.seriesIndex;
	
	    if (el.type === 'group') {
	      el.traverse(setItemDataAndSeriesIndex, el);
	    }
	  }
	
	  this._graphicEls[idx] = el;
	};
	/**
	 * @param {number} idx
	 * @return {module:zrender/Element}
	 */
	
	
	listProto.getItemGraphicEl = function (idx) {
	  return this._graphicEls[idx];
	};
	/**
	 * @param {Function} cb
	 * @param {*} context
	 */
	
	
	listProto.eachItemGraphicEl = function (cb, context) {
	  zrUtil.each(this._graphicEls, function (el, idx) {
	    if (el) {
	      cb && cb.call(context, el, idx);
	    }
	  });
	};
	/**
	 * Shallow clone a new list except visual and layout properties, and graph elements.
	 * New list only change the indices.
	 */
	
	
	listProto.cloneShallow = function (list) {
	  if (!list) {
	    var dimensionInfoList = zrUtil.map(this.dimensions, this.getDimensionInfo, this);
	    list = new List(dimensionInfoList, this.hostModel);
	  } // FIXME
	
	
	  list._storage = this._storage;
	  transferProperties(list, this); // Clone will not change the data extent and indices
	
	  if (this._indices) {
	    var Ctor = this._indices.constructor;
	    list._indices = new Ctor(this._indices);
	  } else {
	    list._indices = null;
	  }
	
	  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return list;
	};
	/**
	 * Wrap some method to add more feature
	 * @param {string} methodName
	 * @param {Function} injectFunction
	 */
	
	
	listProto.wrapMethod = function (methodName, injectFunction) {
	  var originalMethod = this[methodName];
	
	  if (typeof originalMethod !== 'function') {
	    return;
	  }
	
	  this.__wrappedMethods = this.__wrappedMethods || [];
	
	  this.__wrappedMethods.push(methodName);
	
	  this[methodName] = function () {
	    var res = originalMethod.apply(this, arguments);
	    return injectFunction.apply(this, [res].concat(zrUtil.slice(arguments)));
	  };
	}; // Methods that create a new list based on this list should be listed here.
	// Notice that those method should `RETURN` the new list.
	
	
	listProto.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'map']; // Methods that change indices of this list should be listed here.
	
	listProto.CHANGABLE_METHODS = ['filterSelf', 'selectRange'];
	var _default = List;
	module.exports = _default;

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function defaultKeyGetter(item) {
	  return item;
	}
	/**
	 * @param {Array} oldArr
	 * @param {Array} newArr
	 * @param {Function} oldKeyGetter
	 * @param {Function} newKeyGetter
	 * @param {Object} [context] Can be visited by this.context in callback.
	 */
	
	
	function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context) {
	  this._old = oldArr;
	  this._new = newArr;
	  this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
	  this._newKeyGetter = newKeyGetter || defaultKeyGetter;
	  this.context = context;
	}
	
	DataDiffer.prototype = {
	  constructor: DataDiffer,
	
	  /**
	   * Callback function when add a data
	   */
	  add: function (func) {
	    this._add = func;
	    return this;
	  },
	
	  /**
	   * Callback function when update a data
	   */
	  update: function (func) {
	    this._update = func;
	    return this;
	  },
	
	  /**
	   * Callback function when remove a data
	   */
	  remove: function (func) {
	    this._remove = func;
	    return this;
	  },
	  execute: function () {
	    var oldArr = this._old;
	    var newArr = this._new;
	    var oldDataIndexMap = {};
	    var newDataIndexMap = {};
	    var oldDataKeyArr = [];
	    var newDataKeyArr = [];
	    var i;
	    initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter', this);
	    initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter', this);
	
	    for (i = 0; i < oldArr.length; i++) {
	      var key = oldDataKeyArr[i];
	      var idx = newDataIndexMap[key]; // idx can never be empty array here. see 'set null' logic below.
	
	      if (idx != null) {
	        // Consider there is duplicate key (for example, use dataItem.name as key).
	        // We should make sure every item in newArr and oldArr can be visited.
	        var len = idx.length;
	
	        if (len) {
	          len === 1 && (newDataIndexMap[key] = null);
	          idx = idx.shift();
	        } else {
	          newDataIndexMap[key] = null;
	        }
	
	        this._update && this._update(idx, i);
	      } else {
	        this._remove && this._remove(i);
	      }
	    }
	
	    for (var i = 0; i < newDataKeyArr.length; i++) {
	      var key = newDataKeyArr[i];
	
	      if (newDataIndexMap.hasOwnProperty(key)) {
	        var idx = newDataIndexMap[key];
	
	        if (idx == null) {
	          continue;
	        } // idx can never be empty array here. see 'set null' logic above.
	
	
	        if (!idx.length) {
	          this._add && this._add(idx);
	        } else {
	          for (var j = 0, len = idx.length; j < len; j++) {
	            this._add && this._add(idx[j]);
	          }
	        }
	      }
	    }
	  }
	};
	
	function initIndexMap(arr, map, keyArr, keyGetterName, dataDiffer) {
	  for (var i = 0; i < arr.length; i++) {
	    // Add prefix to avoid conflict with Object.prototype.
	    var key = '_ec_' + dataDiffer[keyGetterName](arr[i], i);
	    var existence = map[key];
	
	    if (existence == null) {
	      keyArr.push(key);
	      map[key] = i;
	    } else {
	      if (!existence.length) {
	        map[key] = existence = [existence];
	      }
	
	      existence.push(i);
	    }
	  }
	}
	
	var _default = DataDiffer;
	module.exports = _default;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	var assert = _util.assert;
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var OTHER_DIMENSIONS = createHashMap(['tooltip', 'label', 'itemName', 'itemId', 'seriesName']);
	
	function summarizeDimensions(data) {
	  var summary = {};
	  var encode = summary.encode = {};
	  var notExtraCoordDimMap = createHashMap();
	  var defaultedLabel = [];
	  var defaultedTooltip = []; // See the comment of `List.js#userOutput`.
	
	  var userOutput = summary.userOutput = {
	    dimensionNames: data.dimensions.slice(),
	    encode: {}
	  };
	  each(data.dimensions, function (dimName) {
	    var dimItem = data.getDimensionInfo(dimName);
	    var coordDim = dimItem.coordDim;
	
	    if (coordDim) {
	      var coordDimIndex = dimItem.coordDimIndex;
	      getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
	
	      if (!dimItem.isExtraCoord) {
	        notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
	        // because when dataset is used, it is hard to guess which dimension
	        // can be value dimension. If both show x, y on label is not look good,
	        // and conventionally y axis is focused more.
	
	        if (mayLabelDimType(dimItem.type)) {
	          defaultedLabel[0] = dimName;
	        } // User output encode do not contain generated coords.
	        // And it only has index. User can use index to retrieve value from the raw item array.
	
	
	        getOrCreateEncodeArr(userOutput.encode, coordDim)[coordDimIndex] = dimItem.index;
	      }
	
	      if (dimItem.defaultTooltip) {
	        defaultedTooltip.push(dimName);
	      }
	    }
	
	    OTHER_DIMENSIONS.each(function (v, otherDim) {
	      var encodeArr = getOrCreateEncodeArr(encode, otherDim);
	      var dimIndex = dimItem.otherDims[otherDim];
	
	      if (dimIndex != null && dimIndex !== false) {
	        encodeArr[dimIndex] = dimItem.name;
	      }
	    });
	  });
	  var dataDimsOnCoord = [];
	  var encodeFirstDimNotExtra = {};
	  notExtraCoordDimMap.each(function (v, coordDim) {
	    var dimArr = encode[coordDim]; // ??? FIXME extra coord should not be set in dataDimsOnCoord.
	    // But should fix the case that radar axes: simplify the logic
	    // of `completeDimension`, remove `extraPrefix`.
	
	    encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
	    // dim canot on more than one coordDim.
	
	    dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
	  });
	  summary.dataDimsOnCoord = dataDimsOnCoord;
	  summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
	  var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
	  // in this way. Use label.formatter instead. May be remove this approach someday.
	
	  if (encodeLabel && encodeLabel.length) {
	    defaultedLabel = encodeLabel.slice();
	  }
	
	  var encodeTooltip = encode.tooltip;
	
	  if (encodeTooltip && encodeTooltip.length) {
	    defaultedTooltip = encodeTooltip.slice();
	  } else if (!defaultedTooltip.length) {
	    defaultedTooltip = defaultedLabel.slice();
	  }
	
	  encode.defaultedLabel = defaultedLabel;
	  encode.defaultedTooltip = defaultedTooltip;
	  return summary;
	}
	
	function getOrCreateEncodeArr(encode, dim) {
	  if (!encode.hasOwnProperty(dim)) {
	    encode[dim] = [];
	  }
	
	  return encode[dim];
	}
	
	function getDimensionTypeByAxis(axisType) {
	  return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
	}
	
	function mayLabelDimType(dimType) {
	  // In most cases, ordinal and time do not suitable for label.
	  // Ordinal info can be displayed on axis. Time is too long.
	  return !(dimType === 'ordinal' || dimType === 'time');
	} // function findTheLastDimMayLabel(data) {
	//     // Get last value dim
	//     var dimensions = data.dimensions.slice();
	//     var valueType;
	//     var valueDim;
	//     while (dimensions.length && (
	//         valueDim = dimensions.pop(),
	//         valueType = data.getDimensionInfo(valueDim).type,
	//         valueType === 'ordinal' || valueType === 'time'
	//     )) {} // jshint ignore:line
	//     return valueDim;
	// }
	
	
	exports.OTHER_DIMENSIONS = OTHER_DIMENSIONS;
	exports.summarizeDimensions = summarizeDimensions;
	exports.getDimensionTypeByAxis = getDimensionTypeByAxis;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @class
	 * @param {Object|DataDimensionInfo} [opt] All of the fields will be shallow copied.
	 */
	function DataDimensionInfo(opt) {
	  if (opt != null) {
	    zrUtil.extend(this, opt);
	  }
	  /**
	   * Dimension name.
	   * Mandatory.
	   * @type {string}
	   */
	  // this.name;
	
	  /**
	   * The origin name in dimsDef, see source helper.
	   * If displayName given, the tooltip will displayed vertically.
	   * Optional.
	   * @type {string}
	   */
	  // this.displayName;
	
	  /**
	   * Which coordSys dimension this dimension mapped to.
	   * A `coordDim` can be a "coordSysDim" that the coordSys required
	   * (for example, an item in `coordSysDims` of `model/referHelper#CoordSysInfo`),
	   * or an generated "extra coord name" if does not mapped to any "coordSysDim"
	   * (That is determined by whether `isExtraCoord` is `true`).
	   * Mandatory.
	   * @type {string}
	   */
	  // this.coordDim;
	
	  /**
	   * The index of this dimension in `series.encode[coordDim]`.
	   * Mandatory.
	   * @type {number}
	   */
	  // this.coordDimIndex;
	
	  /**
	   * Dimension type. The enumerable values are the key of
	   * `dataCtors` of `data/List`.
	   * Optional.
	   * @type {string}
	   */
	  // this.type;
	
	  /**
	   * This index of this dimension info in `data/List#_dimensionInfos`.
	   * Mandatory after added to `data/List`.
	   * @type {number}
	   */
	  // this.index;
	
	  /**
	   * The format of `otherDims` is:
	   * ```js
	   * {
	   *     tooltip: number optional,
	   *     label: number optional,
	   *     itemName: number optional,
	   *     seriesName: number optional,
	   * }
	   * ```
	   *
	   * A `series.encode` can specified these fields:
	   * ```js
	   * encode: {
	   *     // "3, 1, 5" is the index of data dimension.
	   *     tooltip: [3, 1, 5],
	   *     label: [0, 3],
	   *     ...
	   * }
	   * ```
	   * `otherDims` is the parse result of the `series.encode` above, like:
	   * ```js
	   * // Suppose the index of this data dimension is `3`.
	   * this.otherDims = {
	   *     // `3` is at the index `0` of the `encode.tooltip`
	   *     tooltip: 0,
	   *     // `3` is at the index `1` of the `encode.tooltip`
	   *     label: 1
	   * };
	   * ```
	   *
	   * This prop should never be `null`/`undefined` after initialized.
	   * @type {Object}
	   */
	
	
	  this.otherDims = {};
	  /**
	   * Be `true` if this dimension is not mapped to any "coordSysDim" that the
	   * "coordSys" required.
	   * Mandatory.
	   * @type {boolean}
	   */
	  // this.isExtraCoord;
	
	  /**
	   * @type {module:data/OrdinalMeta}
	   */
	  // this.ordinalMeta;
	
	  /**
	   * Whether to create inverted indices.
	   * @type {boolean}
	   */
	  // this.createInvertedIndices;
	}
	
	;
	var _default = DataDimensionInfo;
	module.exports = _default;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var completeDimensions = __webpack_require__(347);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Substitute `completeDimensions`.
	 * `completeDimensions` is to be deprecated.
	 */
	
	/**
	 * @param {module:echarts/data/Source|module:echarts/data/List} source or data.
	 * @param {Object|Array} [opt]
	 * @param {Array.<string|Object>} [opt.coordDimensions=[]]
	 * @param {number} [opt.dimensionsCount]
	 * @param {string} [opt.generateCoord]
	 * @param {string} [opt.generateCoordCount]
	 * @param {Array.<string|Object>} [opt.dimensionsDefine=source.dimensionsDefine] Overwrite source define.
	 * @param {Object|HashMap} [opt.encodeDefine=source.encodeDefine] Overwrite source define.
	 * @param {Function} [opt.encodeDefaulter] Make default encode if user not specified.
	 * @return {Array.<Object>} dimensionsInfo
	 */
	function _default(source, opt) {
	  opt = opt || {};
	  return completeDimensions(opt.coordDimensions || [], source, {
	    dimsDef: opt.dimensionsDefine || source.dimensionsDefine,
	    encodeDef: opt.encodeDefine || source.encodeDefine,
	    dimCount: opt.dimensionsCount,
	    encodeDefaulter: opt.encodeDefaulter,
	    generateCoord: opt.generateCoord,
	    generateCoordCount: opt.generateCoordCount
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	var isString = _util.isString;
	var defaults = _util.defaults;
	var extend = _util.extend;
	var isObject = _util.isObject;
	var clone = _util.clone;
	
	var _model = __webpack_require__(261);
	
	var normalizeToArray = _model.normalizeToArray;
	
	var _sourceHelper = __webpack_require__(311);
	
	var guessOrdinal = _sourceHelper.guessOrdinal;
	var BE_ORDINAL = _sourceHelper.BE_ORDINAL;
	
	var Source = __webpack_require__(312);
	
	var _dimensionHelper = __webpack_require__(344);
	
	var OTHER_DIMENSIONS = _dimensionHelper.OTHER_DIMENSIONS;
	
	var DataDimensionInfo = __webpack_require__(345);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @deprecated
	 * Use `echarts/data/helper/createDimensions` instead.
	 */
	
	/**
	 * @see {module:echarts/test/ut/spec/data/completeDimensions}
	 *
	 * This method builds the relationship between:
	 * + "what the coord sys or series requires (see `sysDims`)",
	 * + "what the user defines (in `encode` and `dimensions`, see `opt.dimsDef` and `opt.encodeDef`)"
	 * + "what the data source provids (see `source`)".
	 *
	 * Some guess strategy will be adapted if user does not define something.
	 * If no 'value' dimension specified, the first no-named dimension will be
	 * named as 'value'.
	 *
	 * @param {Array.<string>} sysDims Necessary dimensions, like ['x', 'y'], which
	 *      provides not only dim template, but also default order.
	 *      properties: 'name', 'type', 'displayName'.
	 *      `name` of each item provides default coord name.
	 *      [{dimsDef: [string|Object, ...]}, ...] dimsDef of sysDim item provides default dim name, and
	 *                                    provide dims count that the sysDim required.
	 *      [{ordinalMeta}] can be specified.
	 * @param {module:echarts/data/Source|Array|Object} source or data (for compatibal with pervious)
	 * @param {Object} [opt]
	 * @param {Array.<Object|string>} [opt.dimsDef] option.series.dimensions User defined dimensions
	 *      For example: ['asdf', {name, type}, ...].
	 * @param {Object|HashMap} [opt.encodeDef] option.series.encode {x: 2, y: [3, 1], tooltip: [1, 2], label: 3}
	 * @param {Function} [opt.encodeDefaulter] Called if no `opt.encodeDef` exists.
	 *      If not specified, auto find the next available data dim.
	 *      param source {module:data/Source}
	 *      param dimCount {number}
	 *      return {Object} encode Never be `null/undefined`.
	 * @param {string} [opt.generateCoord] Generate coord dim with the given name.
	 *      If not specified, extra dim names will be:
	 *      'value', 'value0', 'value1', ...
	 * @param {number} [opt.generateCoordCount] By default, the generated dim name is `generateCoord`.
	 *      If `generateCoordCount` specified, the generated dim names will be:
	 *      `generateCoord` + 0, `generateCoord` + 1, ...
	 *      can be Infinity, indicate that use all of the remain columns.
	 * @param {number} [opt.dimCount] If not specified, guess by the first data item.
	 * @return {Array.<module:data/DataDimensionInfo>}
	 */
	function completeDimensions(sysDims, source, opt) {
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  opt = opt || {};
	  sysDims = (sysDims || []).slice();
	  var dimsDef = (opt.dimsDef || []).slice();
	  var dataDimNameMap = createHashMap();
	  var coordDimNameMap = createHashMap(); // var valueCandidate;
	
	  var result = [];
	  var dimCount = getDimCount(source, sysDims, dimsDef, opt.dimCount); // Apply user defined dims (`name` and `type`) and init result.
	
	  for (var i = 0; i < dimCount; i++) {
	    var dimDefItem = dimsDef[i] = extend({}, isObject(dimsDef[i]) ? dimsDef[i] : {
	      name: dimsDef[i]
	    });
	    var userDimName = dimDefItem.name;
	    var resultItem = result[i] = new DataDimensionInfo(); // Name will be applied later for avoiding duplication.
	
	    if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
	      // Only if `series.dimensions` is defined in option
	      // displayName, will be set, and dimension will be diplayed vertically in
	      // tooltip by default.
	      resultItem.name = resultItem.displayName = userDimName;
	      dataDimNameMap.set(userDimName, i);
	    }
	
	    dimDefItem.type != null && (resultItem.type = dimDefItem.type);
	    dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
	  }
	
	  var encodeDef = opt.encodeDef;
	
	  if (!encodeDef && opt.encodeDefaulter) {
	    encodeDef = opt.encodeDefaulter(source, dimCount);
	  }
	
	  encodeDef = createHashMap(encodeDef); // Set `coordDim` and `coordDimIndex` by `encodeDef` and normalize `encodeDef`.
	
	  encodeDef.each(function (dataDims, coordDim) {
	    dataDims = normalizeToArray(dataDims).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
	    // `{encode: {x: -1, y: 1}}`. Should not filter anything in
	    // this case.
	
	    if (dataDims.length === 1 && !isString(dataDims[0]) && dataDims[0] < 0) {
	      encodeDef.set(coordDim, false);
	      return;
	    }
	
	    var validDataDims = encodeDef.set(coordDim, []);
	    each(dataDims, function (resultDimIdx, idx) {
	      // The input resultDimIdx can be dim name or index.
	      isString(resultDimIdx) && (resultDimIdx = dataDimNameMap.get(resultDimIdx));
	
	      if (resultDimIdx != null && resultDimIdx < dimCount) {
	        validDataDims[idx] = resultDimIdx;
	        applyDim(result[resultDimIdx], coordDim, idx);
	      }
	    });
	  }); // Apply templetes and default order from `sysDims`.
	
	  var availDimIdx = 0;
	  each(sysDims, function (sysDimItem, sysDimIndex) {
	    var coordDim;
	    var sysDimItem;
	    var sysDimItemDimsDef;
	    var sysDimItemOtherDims;
	
	    if (isString(sysDimItem)) {
	      coordDim = sysDimItem;
	      sysDimItem = {};
	    } else {
	      coordDim = sysDimItem.name;
	      var ordinalMeta = sysDimItem.ordinalMeta;
	      sysDimItem.ordinalMeta = null;
	      sysDimItem = clone(sysDimItem);
	      sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.
	
	      sysDimItemDimsDef = sysDimItem.dimsDef;
	      sysDimItemOtherDims = sysDimItem.otherDims;
	      sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
	    }
	
	    var dataDims = encodeDef.get(coordDim); // negative resultDimIdx means no need to mapping.
	
	    if (dataDims === false) {
	      return;
	    }
	
	    var dataDims = normalizeToArray(dataDims); // dimensions provides default dim sequences.
	
	    if (!dataDims.length) {
	      for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
	        while (availDimIdx < result.length && result[availDimIdx].coordDim != null) {
	          availDimIdx++;
	        }
	
	        availDimIdx < result.length && dataDims.push(availDimIdx++);
	      }
	    } // Apply templates.
	
	
	    each(dataDims, function (resultDimIdx, coordDimIndex) {
	      var resultItem = result[resultDimIdx];
	      applyDim(defaults(resultItem, sysDimItem), coordDim, coordDimIndex);
	
	      if (resultItem.name == null && sysDimItemDimsDef) {
	        var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
	        !isObject(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
	          name: sysDimItemDimsDefItem
	        });
	        resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
	        resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
	      } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
	
	
	      sysDimItemOtherDims && defaults(resultItem.otherDims, sysDimItemOtherDims);
	    });
	  });
	
	  function applyDim(resultItem, coordDim, coordDimIndex) {
	    if (OTHER_DIMENSIONS.get(coordDim) != null) {
	      resultItem.otherDims[coordDim] = coordDimIndex;
	    } else {
	      resultItem.coordDim = coordDim;
	      resultItem.coordDimIndex = coordDimIndex;
	      coordDimNameMap.set(coordDim, true);
	    }
	  } // Make sure the first extra dim is 'value'.
	
	
	  var generateCoord = opt.generateCoord;
	  var generateCoordCount = opt.generateCoordCount;
	  var fromZero = generateCoordCount != null;
	  generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
	  var extra = generateCoord || 'value'; // Set dim `name` and other `coordDim` and other props.
	
	  for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
	    var resultItem = result[resultDimIdx] = result[resultDimIdx] || new DataDimensionInfo();
	    var coordDim = resultItem.coordDim;
	
	    if (coordDim == null) {
	      resultItem.coordDim = genName(extra, coordDimNameMap, fromZero);
	      resultItem.coordDimIndex = 0;
	
	      if (!generateCoord || generateCoordCount <= 0) {
	        resultItem.isExtraCoord = true;
	      }
	
	      generateCoordCount--;
	    }
	
	    resultItem.name == null && (resultItem.name = genName(resultItem.coordDim, dataDimNameMap));
	
	    if (resultItem.type == null && (guessOrdinal(source, resultDimIdx, resultItem.name) === BE_ORDINAL.Must // Consider the case:
	    // {
	    //    dataset: {source: [
	    //        ['2001', 123],
	    //        ['2002', 456],
	    //        ...
	    //        ['The others', 987],
	    //    ]},
	    //    series: {type: 'pie'}
	    // }
	    // The first colum should better be treated as a "ordinal" although it
	    // might not able to be detected as an "ordinal" by `guessOrdinal`.
	    || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) {
	      resultItem.type = 'ordinal';
	    }
	  }
	
	  return result;
	} // ??? TODO
	// Originally detect dimCount by data[0]. Should we
	// optimize it to only by sysDims and dimensions and encode.
	// So only necessary dims will be initialized.
	// But
	// (1) custom series should be considered. where other dims
	// may be visited.
	// (2) sometimes user need to calcualte bubble size or use visualMap
	// on other dimensions besides coordSys needed.
	// So, dims that is not used by system, should be shared in storage?
	
	
	function getDimCount(source, sysDims, dimsDef, optDimCount) {
	  // Note that the result dimCount should not small than columns count
	  // of data, otherwise `dataDimNameMap` checking will be incorrect.
	  var dimCount = Math.max(source.dimensionsDetectCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
	  each(sysDims, function (sysDimItem) {
	    var sysDimItemDimsDef = sysDimItem.dimsDef;
	    sysDimItemDimsDef && (dimCount = Math.max(dimCount, sysDimItemDimsDef.length));
	  });
	  return dimCount;
	}
	
	function genName(name, map, fromZero) {
	  if (fromZero || map.get(name) != null) {
	    var i = 0;
	
	    while (map.get(name + i) != null) {
	      i++;
	    }
	
	    name += i;
	  }
	
	  map.set(name, true);
	  return name;
	}
	
	var _default = completeDimensions;
	module.exports = _default;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(220);
	
	var createHashMap = _util.createHashMap;
	var retrieve = _util.retrieve;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Helper for model references.
	 * There are many manners to refer axis/coordSys.
	 */
	// TODO
	// merge relevant logic to this file?
	// check: "modelHelper" of tooltip and "BrushTargetManager".
	
	/**
	 * @class
	 * For example:
	 * {
	 *     coordSysName: 'cartesian2d',
	 *     coordSysDims: ['x', 'y', ...],
	 *     axisMap: HashMap({
	 *         x: xAxisModel,
	 *         y: yAxisModel
	 *     }),
	 *     categoryAxisMap: HashMap({
	 *         x: xAxisModel,
	 *         y: undefined
	 *     }),
	 *     // The index of the first category axis in `coordSysDims`.
	 *     // `null/undefined` means no category axis exists.
	 *     firstCategoryDimIndex: 1,
	 *     // To replace user specified encode.
	 * }
	 */
	function CoordSysInfo(coordSysName) {
	  /**
	   * @type {string}
	   */
	  this.coordSysName = coordSysName;
	  /**
	   * @type {Array.<string>}
	   */
	
	  this.coordSysDims = [];
	  /**
	   * @type {module:zrender/core/util#HashMap}
	   */
	
	  this.axisMap = createHashMap();
	  /**
	   * @type {module:zrender/core/util#HashMap}
	   */
	
	  this.categoryAxisMap = createHashMap();
	  /**
	   * @type {number}
	   */
	
	  this.firstCategoryDimIndex = null;
	}
	/**
	 * @return {module:model/referHelper#CoordSysInfo}
	 */
	
	
	function getCoordSysInfoBySeries(seriesModel) {
	  var coordSysName = seriesModel.get('coordinateSystem');
	  var result = new CoordSysInfo(coordSysName);
	  var fetch = fetchers[coordSysName];
	
	  if (fetch) {
	    fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
	    return result;
	  }
	}
	
	var fetchers = {
	  cartesian2d: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var xAxisModel = seriesModel.getReferringComponents('xAxis')[0];
	    var yAxisModel = seriesModel.getReferringComponents('yAxis')[0];
	    result.coordSysDims = ['x', 'y'];
	    axisMap.set('x', xAxisModel);
	    axisMap.set('y', yAxisModel);
	
	    if (isCategory(xAxisModel)) {
	      categoryAxisMap.set('x', xAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	
	    if (isCategory(yAxisModel)) {
	      categoryAxisMap.set('y', yAxisModel);
	      result.firstCategoryDimIndex == null & (result.firstCategoryDimIndex = 1);
	    }
	  },
	  singleAxis: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var singleAxisModel = seriesModel.getReferringComponents('singleAxis')[0];
	    result.coordSysDims = ['single'];
	    axisMap.set('single', singleAxisModel);
	
	    if (isCategory(singleAxisModel)) {
	      categoryAxisMap.set('single', singleAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	  },
	  polar: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var polarModel = seriesModel.getReferringComponents('polar')[0];
	    var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	    var angleAxisModel = polarModel.findAxisModel('angleAxis');
	    result.coordSysDims = ['radius', 'angle'];
	    axisMap.set('radius', radiusAxisModel);
	    axisMap.set('angle', angleAxisModel);
	
	    if (isCategory(radiusAxisModel)) {
	      categoryAxisMap.set('radius', radiusAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	
	    if (isCategory(angleAxisModel)) {
	      categoryAxisMap.set('angle', angleAxisModel);
	      result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
	    }
	  },
	  geo: function (seriesModel, result, axisMap, categoryAxisMap) {
	    result.coordSysDims = ['lng', 'lat'];
	  },
	  parallel: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var ecModel = seriesModel.ecModel;
	    var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
	    var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
	    each(parallelModel.parallelAxisIndex, function (axisIndex, index) {
	      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	      var axisDim = coordSysDims[index];
	      axisMap.set(axisDim, axisModel);
	
	      if (isCategory(axisModel) && result.firstCategoryDimIndex == null) {
	        categoryAxisMap.set(axisDim, axisModel);
	        result.firstCategoryDimIndex = index;
	      }
	    });
	  }
	};
	
	function isCategory(axisModel) {
	  return axisModel.get('type') === 'category';
	}
	
	exports.getCoordSysInfoBySeries = getCoordSysInfoBySeries;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	var isString = _util.isString;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Note that it is too complicated to support 3d stack by value
	 * (have to create two-dimension inverted index), so in 3d case
	 * we just support that stacked by index.
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Array.<string|Object>} dimensionInfoList The same as the input of <module:echarts/data/List>.
	 *        The input dimensionInfoList will be modified.
	 * @param {Object} [opt]
	 * @param {boolean} [opt.stackedCoordDimension=''] Specify a coord dimension if needed.
	 * @param {boolean} [opt.byIndex=false]
	 * @return {Object} calculationInfo
	 * {
	 *     stackedDimension: string
	 *     stackedByDimension: string
	 *     isStackedByIndex: boolean
	 *     stackedOverDimension: string
	 *     stackResultDimension: string
	 * }
	 */
	function enableDataStack(seriesModel, dimensionInfoList, opt) {
	  opt = opt || {};
	  var byIndex = opt.byIndex;
	  var stackedCoordDimension = opt.stackedCoordDimension; // Compatibal: when `stack` is set as '', do not stack.
	
	  var mayStack = !!(seriesModel && seriesModel.get('stack'));
	  var stackedByDimInfo;
	  var stackedDimInfo;
	  var stackResultDimension;
	  var stackedOverDimension;
	  each(dimensionInfoList, function (dimensionInfo, index) {
	    if (isString(dimensionInfo)) {
	      dimensionInfoList[index] = dimensionInfo = {
	        name: dimensionInfo
	      };
	    }
	
	    if (mayStack && !dimensionInfo.isExtraCoord) {
	      // Find the first ordinal dimension as the stackedByDimInfo.
	      if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) {
	        stackedByDimInfo = dimensionInfo;
	      } // Find the first stackable dimension as the stackedDimInfo.
	
	
	      if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) {
	        stackedDimInfo = dimensionInfo;
	      }
	    }
	  });
	
	  if (stackedDimInfo && !byIndex && !stackedByDimInfo) {
	    // Compatible with previous design, value axis (time axis) only stack by index.
	    // It may make sense if the user provides elaborately constructed data.
	    byIndex = true;
	  } // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
	  // That put stack logic in List is for using conveniently in echarts extensions, but it
	  // might not be a good way.
	
	
	  if (stackedDimInfo) {
	    // Use a weird name that not duplicated with other names.
	    stackResultDimension = '__\0ecstackresult';
	    stackedOverDimension = '__\0ecstackedover'; // Create inverted index to fast query index by value.
	
	    if (stackedByDimInfo) {
	      stackedByDimInfo.createInvertedIndices = true;
	    }
	
	    var stackedDimCoordDim = stackedDimInfo.coordDim;
	    var stackedDimType = stackedDimInfo.type;
	    var stackedDimCoordIndex = 0;
	    each(dimensionInfoList, function (dimensionInfo) {
	      if (dimensionInfo.coordDim === stackedDimCoordDim) {
	        stackedDimCoordIndex++;
	      }
	    });
	    dimensionInfoList.push({
	      name: stackResultDimension,
	      coordDim: stackedDimCoordDim,
	      coordDimIndex: stackedDimCoordIndex,
	      type: stackedDimType,
	      isExtraCoord: true,
	      isCalculationCoord: true
	    });
	    stackedDimCoordIndex++;
	    dimensionInfoList.push({
	      name: stackedOverDimension,
	      // This dimension contains stack base (generally, 0), so do not set it as
	      // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
	      coordDim: stackedOverDimension,
	      coordDimIndex: stackedDimCoordIndex,
	      type: stackedDimType,
	      isExtraCoord: true,
	      isCalculationCoord: true
	    });
	  }
	
	  return {
	    stackedDimension: stackedDimInfo && stackedDimInfo.name,
	    stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
	    isStackedByIndex: byIndex,
	    stackedOverDimension: stackedOverDimension,
	    stackResultDimension: stackResultDimension
	  };
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {string} stackedDim
	 */
	
	
	function isDimensionStacked(data, stackedDim
	/*, stackedByDim*/
	) {
	  // Each single series only maps to one pair of axis. So we do not need to
	  // check stackByDim, whatever stacked by a dimension or stacked by index.
	  return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension'); // && (
	  //     stackedByDim != null
	  //         ? stackedByDim === data.getCalculationInfo('stackedByDimension')
	  //         : data.getCalculationInfo('isStackedByIndex')
	  // );
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {string} targetDim
	 * @param {string} [stackedByDim] If not input this parameter, check whether
	 *                                stacked by index.
	 * @return {string} dimension
	 */
	
	
	function getStackedDimension(data, targetDim) {
	  return isDimensionStacked(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
	}
	
	exports.enableDataStack = enableDataStack;
	exports.isDimensionStacked = isDimensionStacked;
	exports.getStackedDimension = getStackedDimension;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(220);
	
	var OrdinalScale = __webpack_require__(351);
	
	var IntervalScale = __webpack_require__(354);
	
	var Scale = __webpack_require__(352);
	
	var numberUtil = __webpack_require__(306);
	
	var _barGrid = __webpack_require__(356);
	
	var prepareLayoutBarSeries = _barGrid.prepareLayoutBarSeries;
	var makeColumnLayout = _barGrid.makeColumnLayout;
	var retrieveColumnLayout = _barGrid.retrieveColumnLayout;
	
	var BoundingRect = __webpack_require__(242);
	
	__webpack_require__(357);
	
	__webpack_require__(358);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Get axis scale extent before niced.
	 * Item of returned array can only be number (including Infinity and NaN).
	 */
	function getScaleExtent(scale, model) {
	  var scaleType = scale.type;
	  var min = model.getMin();
	  var max = model.getMax();
	  var originalExtent = scale.getExtent();
	  var axisDataLen;
	  var boundaryGap;
	  var span;
	
	  if (scaleType === 'ordinal') {
	    axisDataLen = model.getCategories().length;
	  } else {
	    boundaryGap = model.get('boundaryGap');
	
	    if (!zrUtil.isArray(boundaryGap)) {
	      boundaryGap = [boundaryGap || 0, boundaryGap || 0];
	    }
	
	    if (typeof boundaryGap[0] === 'boolean') {
	      boundaryGap = [0, 0];
	    }
	
	    boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], 1);
	    boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], 1);
	    span = originalExtent[1] - originalExtent[0] || Math.abs(originalExtent[0]);
	  } // Notice: When min/max is not set (that is, when there are null/undefined,
	  // which is the most common case), these cases should be ensured:
	  // (1) For 'ordinal', show all axis.data.
	  // (2) For others:
	  //      + `boundaryGap` is applied (if min/max set, boundaryGap is
	  //      disabled).
	  //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
	  //      be the result that originalExtent enlarged by boundaryGap.
	  // (3) If no data, it should be ensured that `scale.setBlank` is set.
	  // FIXME
	  // (1) When min/max is 'dataMin' or 'dataMax', should boundaryGap be able to used?
	  // (2) When `needCrossZero` and all data is positive/negative, should it be ensured
	  // that the results processed by boundaryGap are positive/negative?
	
	
	  if (min === 'dataMin') {
	    min = originalExtent[0];
	  } else if (typeof min === 'function') {
	    min = min({
	      min: originalExtent[0],
	      max: originalExtent[1]
	    });
	  }
	
	  if (max === 'dataMax') {
	    max = originalExtent[1];
	  } else if (typeof max === 'function') {
	    max = max({
	      min: originalExtent[0],
	      max: originalExtent[1]
	    });
	  }
	
	  var fixMin = min != null;
	  var fixMax = max != null;
	
	  if (min == null) {
	    min = scaleType === 'ordinal' ? axisDataLen ? 0 : NaN : originalExtent[0] - boundaryGap[0] * span;
	  }
	
	  if (max == null) {
	    max = scaleType === 'ordinal' ? axisDataLen ? axisDataLen - 1 : NaN : originalExtent[1] + boundaryGap[1] * span;
	  }
	
	  (min == null || !isFinite(min)) && (min = NaN);
	  (max == null || !isFinite(max)) && (max = NaN);
	  scale.setBlank(zrUtil.eqNaN(min) || zrUtil.eqNaN(max) || scaleType === 'ordinal' && !scale.getOrdinalMeta().categories.length); // Evaluate if axis needs cross zero
	
	  if (model.getNeedCrossZero()) {
	    // Axis is over zero and min is not set
	    if (min > 0 && max > 0 && !fixMin) {
	      min = 0;
	    } // Axis is under zero and max is not set
	
	
	    if (min < 0 && max < 0 && !fixMax) {
	      max = 0;
	    }
	  } // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
	  // is base axis
	  // FIXME
	  // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
	  // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
	  //     Should not depend on series type `bar`?
	  // (3) Fix that might overlap when using dataZoom.
	  // (4) Consider other chart types using `barGrid`?
	  // See #6728, #4862, `test/bar-overflow-time-plot.html`
	
	
	  var ecModel = model.ecModel;
	
	  if (ecModel && scaleType === 'time'
	  /*|| scaleType === 'interval' */
	  ) {
	    var barSeriesModels = prepareLayoutBarSeries('bar', ecModel);
	    var isBaseAxisAndHasBarSeries;
	    zrUtil.each(barSeriesModels, function (seriesModel) {
	      isBaseAxisAndHasBarSeries |= seriesModel.getBaseAxis() === model.axis;
	    });
	
	    if (isBaseAxisAndHasBarSeries) {
	      // Calculate placement of bars on axis
	      var barWidthAndOffset = makeColumnLayout(barSeriesModels); // Adjust axis min and max to account for overflow
	
	      var adjustedScale = adjustScaleForOverflow(min, max, model, barWidthAndOffset);
	      min = adjustedScale.min;
	      max = adjustedScale.max;
	    }
	  }
	
	  return {
	    extent: [min, max],
	    // "fix" means "fixed", the value should not be
	    // changed in the subsequent steps.
	    fixMin: fixMin,
	    fixMax: fixMax
	  };
	}
	
	function adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
	  // Get Axis Length
	  var axisExtent = model.axis.getExtent();
	  var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow
	
	  var barsOnCurrentAxis = retrieveColumnLayout(barWidthAndOffset, model.axis);
	
	  if (barsOnCurrentAxis === undefined) {
	    return {
	      min: min,
	      max: max
	    };
	  }
	
	  var minOverflow = Infinity;
	  zrUtil.each(barsOnCurrentAxis, function (item) {
	    minOverflow = Math.min(item.offset, minOverflow);
	  });
	  var maxOverflow = -Infinity;
	  zrUtil.each(barsOnCurrentAxis, function (item) {
	    maxOverflow = Math.max(item.offset + item.width, maxOverflow);
	  });
	  minOverflow = Math.abs(minOverflow);
	  maxOverflow = Math.abs(maxOverflow);
	  var totalOverFlow = minOverflow + maxOverflow; // Calulate required buffer based on old range and overflow
	
	  var oldRange = max - min;
	  var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
	  var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
	  max += overflowBuffer * (maxOverflow / totalOverFlow);
	  min -= overflowBuffer * (minOverflow / totalOverFlow);
	  return {
	    min: min,
	    max: max
	  };
	}
	
	function niceScaleExtent(scale, model) {
	  var extentInfo = getScaleExtent(scale, model);
	  var extent = extentInfo.extent;
	  var splitNumber = model.get('splitNumber');
	
	  if (scale.type === 'log') {
	    scale.base = model.get('logBase');
	  }
	
	  var scaleType = scale.type;
	  scale.setExtent(extent[0], extent[1]);
	  scale.niceExtent({
	    splitNumber: splitNumber,
	    fixMin: extentInfo.fixMin,
	    fixMax: extentInfo.fixMax,
	    minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
	    maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
	  }); // If some one specified the min, max. And the default calculated interval
	  // is not good enough. He can specify the interval. It is often appeared
	  // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
	  // to be 60.
	  // FIXME
	
	  var interval = model.get('interval');
	
	  if (interval != null) {
	    scale.setInterval && scale.setInterval(interval);
	  }
	}
	/**
	 * @param {module:echarts/model/Model} model
	 * @param {string} [axisType] Default retrieve from model.type
	 * @return {module:echarts/scale/*}
	 */
	
	
	function createScaleByModel(model, axisType) {
	  axisType = axisType || model.get('type');
	
	  if (axisType) {
	    switch (axisType) {
	      // Buildin scale
	      case 'category':
	        return new OrdinalScale(model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(), [Infinity, -Infinity]);
	
	      case 'value':
	        return new IntervalScale();
	      // Extended scale, like time and log
	
	      default:
	        return (Scale.getClass(axisType) || IntervalScale).create(model);
	    }
	  }
	}
	/**
	 * Check if the axis corss 0
	 */
	
	
	function ifAxisCrossZero(axis) {
	  var dataExtent = axis.scale.getExtent();
	  var min = dataExtent[0];
	  var max = dataExtent[1];
	  return !(min > 0 && max > 0 || min < 0 && max < 0);
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @return {Function} Label formatter function.
	 *         param: {number} tickValue,
	 *         param: {number} idx, the index in all ticks.
	 *                         If category axis, this param is not requied.
	 *         return: {string} label string.
	 */
	
	
	function makeLabelFormatter(axis) {
	  var labelFormatter = axis.getLabelModel().get('formatter');
	  var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
	
	  if (typeof labelFormatter === 'string') {
	    labelFormatter = function (tpl) {
	      return function (val) {
	        // For category axis, get raw value; for numeric axis,
	        // get foramtted label like '1,333,444'.
	        val = axis.scale.getLabel(val);
	        return tpl.replace('{value}', val != null ? val : '');
	      };
	    }(labelFormatter); // Consider empty array
	
	
	    return labelFormatter;
	  } else if (typeof labelFormatter === 'function') {
	    return function (tickValue, idx) {
	      // The original intention of `idx` is "the index of the tick in all ticks".
	      // But the previous implementation of category axis do not consider the
	      // `axisLabel.interval`, which cause that, for example, the `interval` is
	      // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
	      // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
	      // the definition here for back compatibility.
	      if (categoryTickStart != null) {
	        idx = tickValue - categoryTickStart;
	      }
	
	      return labelFormatter(getAxisRawValue(axis, tickValue), idx);
	    };
	  } else {
	    return function (tick) {
	      return axis.scale.getLabel(tick);
	    };
	  }
	}
	
	function getAxisRawValue(axis, value) {
	  // In category axis with data zoom, tick is not the original
	  // index of axis.data. So tick should not be exposed to user
	  // in category axis.
	  return axis.type === 'category' ? axis.scale.getLabel(value) : value;
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @return {module:zrender/core/BoundingRect} Be null/undefined if no labels.
	 */
	
	
	function estimateLabelUnionRect(axis) {
	  var axisModel = axis.model;
	  var scale = axis.scale;
	
	  if (!axisModel.get('axisLabel.show') || scale.isBlank()) {
	    return;
	  }
	
	  var isCategory = axis.type === 'category';
	  var realNumberScaleTicks;
	  var tickCount;
	  var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.
	
	  if (isCategory) {
	    tickCount = scale.count();
	  } else {
	    realNumberScaleTicks = scale.getTicks();
	    tickCount = realNumberScaleTicks.length;
	  }
	
	  var axisLabelModel = axis.getLabelModel();
	  var labelFormatter = makeLabelFormatter(axis);
	  var rect;
	  var step = 1; // Simple optimization for large amount of labels
	
	  if (tickCount > 40) {
	    step = Math.ceil(tickCount / 40);
	  }
	
	  for (var i = 0; i < tickCount; i += step) {
	    var tickValue = realNumberScaleTicks ? realNumberScaleTicks[i] : categoryScaleExtent[0] + i;
	    var label = labelFormatter(tickValue);
	    var unrotatedSingleRect = axisLabelModel.getTextRect(label);
	    var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
	    rect ? rect.union(singleRect) : rect = singleRect;
	  }
	
	  return rect;
	}
	
	function rotateTextRect(textRect, rotate) {
	  var rotateRadians = rotate * Math.PI / 180;
	  var boundingBox = textRect.plain();
	  var beforeWidth = boundingBox.width;
	  var beforeHeight = boundingBox.height;
	  var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
	  var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
	  var rotatedRect = new BoundingRect(boundingBox.x, boundingBox.y, afterWidth, afterHeight);
	  return rotatedRect;
	}
	/**
	 * @param {module:echarts/src/model/Model} model axisLabelModel or axisTickModel
	 * @return {number|String} Can be null|'auto'|number|function
	 */
	
	
	function getOptionCategoryInterval(model) {
	  var interval = model.get('interval');
	  return interval == null ? 'auto' : interval;
	}
	/**
	 * Set `categoryInterval` as 0 implicitly indicates that
	 * show all labels reguardless of overlap.
	 * @param {Object} axis axisModel.axis
	 * @return {boolean}
	 */
	
	
	function shouldShowAllLabels(axis) {
	  return axis.type === 'category' && getOptionCategoryInterval(axis.getLabelModel()) === 0;
	}
	
	exports.getScaleExtent = getScaleExtent;
	exports.niceScaleExtent = niceScaleExtent;
	exports.createScaleByModel = createScaleByModel;
	exports.ifAxisCrossZero = ifAxisCrossZero;
	exports.makeLabelFormatter = makeLabelFormatter;
	exports.getAxisRawValue = getAxisRawValue;
	exports.estimateLabelUnionRect = estimateLabelUnionRect;
	exports.getOptionCategoryInterval = getOptionCategoryInterval;
	exports.shouldShowAllLabels = shouldShowAllLabels;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Scale = __webpack_require__(352);
	
	var OrdinalMeta = __webpack_require__(353);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Linear continuous scale
	 * @module echarts/coord/scale/Ordinal
	 *
	 * http://en.wikipedia.org/wiki/Level_of_measurement
	 */
	// FIXME only one data
	var scaleProto = Scale.prototype;
	var OrdinalScale = Scale.extend({
	  type: 'ordinal',
	
	  /**
	   * @param {module:echarts/data/OrdianlMeta|Array.<string>} ordinalMeta
	   */
	  init: function (ordinalMeta, extent) {
	    // Caution: Should not use instanceof, consider ec-extensions using
	    // import approach to get OrdinalMeta class.
	    if (!ordinalMeta || zrUtil.isArray(ordinalMeta)) {
	      ordinalMeta = new OrdinalMeta({
	        categories: ordinalMeta
	      });
	    }
	
	    this._ordinalMeta = ordinalMeta;
	    this._extent = extent || [0, ordinalMeta.categories.length - 1];
	  },
	  parse: function (val) {
	    return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) // val might be float.
	    : Math.round(val);
	  },
	  contain: function (rank) {
	    rank = this.parse(rank);
	    return scaleProto.contain.call(this, rank) && this._ordinalMeta.categories[rank] != null;
	  },
	
	  /**
	   * Normalize given rank or name to linear [0, 1]
	   * @param {number|string} [val]
	   * @return {number}
	   */
	  normalize: function (val) {
	    return scaleProto.normalize.call(this, this.parse(val));
	  },
	  scale: function (val) {
	    return Math.round(scaleProto.scale.call(this, val));
	  },
	
	  /**
	   * @return {Array}
	   */
	  getTicks: function () {
	    var ticks = [];
	    var extent = this._extent;
	    var rank = extent[0];
	
	    while (rank <= extent[1]) {
	      ticks.push(rank);
	      rank++;
	    }
	
	    return ticks;
	  },
	
	  /**
	   * Get item on rank n
	   * @param {number} n
	   * @return {string}
	   */
	  getLabel: function (n) {
	    if (!this.isBlank()) {
	      // Note that if no data, ordinalMeta.categories is an empty array.
	      return this._ordinalMeta.categories[n];
	    }
	  },
	
	  /**
	   * @return {number}
	   */
	  count: function () {
	    return this._extent[1] - this._extent[0] + 1;
	  },
	
	  /**
	   * @override
	   */
	  unionExtentFromData: function (data, dim) {
	    this.unionExtent(data.getApproximateExtent(dim));
	  },
	  getOrdinalMeta: function () {
	    return this._ordinalMeta;
	  },
	  niceTicks: zrUtil.noop,
	  niceExtent: zrUtil.noop
	});
	/**
	 * @return {module:echarts/scale/Time}
	 */
	
	OrdinalScale.create = function () {
	  return new OrdinalScale();
	};
	
	var _default = OrdinalScale;
	module.exports = _default;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var clazzUtil = __webpack_require__(263);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * // Scale class management
	 * @module echarts/scale/Scale
	 */
	
	/**
	 * @param {Object} [setting]
	 */
	function Scale(setting) {
	  this._setting = setting || {};
	  /**
	   * Extent
	   * @type {Array.<number>}
	   * @protected
	   */
	
	  this._extent = [Infinity, -Infinity];
	  /**
	   * Step is calculated in adjustExtent
	   * @type {Array.<number>}
	   * @protected
	   */
	
	  this._interval = 0;
	  this.init && this.init.apply(this, arguments);
	}
	/**
	 * Parse input val to valid inner number.
	 * @param {*} val
	 * @return {number}
	 */
	
	
	Scale.prototype.parse = function (val) {
	  // Notice: This would be a trap here, If the implementation
	  // of this method depends on extent, and this method is used
	  // before extent set (like in dataZoom), it would be wrong.
	  // Nevertheless, parse does not depend on extent generally.
	  return val;
	};
	
	Scale.prototype.getSetting = function (name) {
	  return this._setting[name];
	};
	
	Scale.prototype.contain = function (val) {
	  var extent = this._extent;
	  return val >= extent[0] && val <= extent[1];
	};
	/**
	 * Normalize value to linear [0, 1], return 0.5 if extent span is 0
	 * @param {number} val
	 * @return {number}
	 */
	
	
	Scale.prototype.normalize = function (val) {
	  var extent = this._extent;
	
	  if (extent[1] === extent[0]) {
	    return 0.5;
	  }
	
	  return (val - extent[0]) / (extent[1] - extent[0]);
	};
	/**
	 * Scale normalized value
	 * @param {number} val
	 * @return {number}
	 */
	
	
	Scale.prototype.scale = function (val) {
	  var extent = this._extent;
	  return val * (extent[1] - extent[0]) + extent[0];
	};
	/**
	 * Set extent from data
	 * @param {Array.<number>} other
	 */
	
	
	Scale.prototype.unionExtent = function (other) {
	  var extent = this._extent;
	  other[0] < extent[0] && (extent[0] = other[0]);
	  other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
	  // this.setExtent(extent[0], extent[1]);
	};
	/**
	 * Set extent from data
	 * @param {module:echarts/data/List} data
	 * @param {string} dim
	 */
	
	
	Scale.prototype.unionExtentFromData = function (data, dim) {
	  this.unionExtent(data.getApproximateExtent(dim));
	};
	/**
	 * Get extent
	 * @return {Array.<number>}
	 */
	
	
	Scale.prototype.getExtent = function () {
	  return this._extent.slice();
	};
	/**
	 * Set extent
	 * @param {number} start
	 * @param {number} end
	 */
	
	
	Scale.prototype.setExtent = function (start, end) {
	  var thisExtent = this._extent;
	
	  if (!isNaN(start)) {
	    thisExtent[0] = start;
	  }
	
	  if (!isNaN(end)) {
	    thisExtent[1] = end;
	  }
	};
	/**
	 * When axis extent depends on data and no data exists,
	 * axis ticks should not be drawn, which is named 'blank'.
	 */
	
	
	Scale.prototype.isBlank = function () {
	  return this._isBlank;
	},
	/**
	 * When axis extent depends on data and no data exists,
	 * axis ticks should not be drawn, which is named 'blank'.
	 */
	Scale.prototype.setBlank = function (isBlank) {
	  this._isBlank = isBlank;
	};
	/**
	 * @abstract
	 * @param {*} tick
	 * @return {string} label of the tick.
	 */
	
	Scale.prototype.getLabel = null;
	clazzUtil.enableClassExtend(Scale);
	clazzUtil.enableClassManagement(Scale, {
	  registerWhenExtend: true
	});
	var _default = Scale;
	module.exports = _default;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var createHashMap = _util.createHashMap;
	var isObject = _util.isObject;
	var map = _util.map;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor
	 * @param {Object} [opt]
	 * @param {Object} [opt.categories=[]]
	 * @param {Object} [opt.needCollect=false]
	 * @param {Object} [opt.deduplication=false]
	 */
	function OrdinalMeta(opt) {
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  this.categories = opt.categories || [];
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._needCollect = opt.needCollect;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._deduplication = opt.deduplication;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._map;
	}
	/**
	 * @param {module:echarts/model/Model} axisModel
	 * @return {module:echarts/data/OrdinalMeta}
	 */
	
	
	OrdinalMeta.createByAxisModel = function (axisModel) {
	  var option = axisModel.option;
	  var data = option.data;
	  var categories = data && map(data, getName);
	  return new OrdinalMeta({
	    categories: categories,
	    needCollect: !categories,
	    // deduplication is default in axis.
	    deduplication: option.dedplication !== false
	  });
	};
	
	var proto = OrdinalMeta.prototype;
	/**
	 * @param {string} category
	 * @return {number} ordinal
	 */
	
	proto.getOrdinal = function (category) {
	  return getOrCreateMap(this).get(category);
	};
	/**
	 * @param {*} category
	 * @return {number} The ordinal. If not found, return NaN.
	 */
	
	
	proto.parseAndCollect = function (category) {
	  var index;
	  var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
	  // This feature is only supported when !needCollect, because we should
	  // consider a common case: a value is 2017, which is a number but is
	  // expected to be tread as a category. This case usually happen in dataset,
	  // where it happent to be no need of the index feature.
	
	  if (typeof category !== 'string' && !needCollect) {
	    return category;
	  } // Optimize for the scenario:
	  // category is ['2012-01-01', '2012-01-02', ...], where the input
	  // data has been ensured not duplicate and is large data.
	  // Notice, if a dataset dimension provide categroies, usually echarts
	  // should remove duplication except user tell echarts dont do that
	  // (set axis.deduplication = false), because echarts do not know whether
	  // the values in the category dimension has duplication (consider the
	  // parallel-aqi example)
	
	
	  if (needCollect && !this._deduplication) {
	    index = this.categories.length;
	    this.categories[index] = category;
	    return index;
	  }
	
	  var map = getOrCreateMap(this);
	  index = map.get(category);
	
	  if (index == null) {
	    if (needCollect) {
	      index = this.categories.length;
	      this.categories[index] = category;
	      map.set(category, index);
	    } else {
	      index = NaN;
	    }
	  }
	
	  return index;
	}; // Consider big data, do not create map until needed.
	
	
	function getOrCreateMap(ordinalMeta) {
	  return ordinalMeta._map || (ordinalMeta._map = createHashMap(ordinalMeta.categories));
	}
	
	function getName(obj) {
	  if (isObject(obj) && obj.value != null) {
	    return obj.value;
	  } else {
	    return obj + '';
	  }
	}
	
	var _default = OrdinalMeta;
	module.exports = _default;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var numberUtil = __webpack_require__(306);
	
	var formatUtil = __webpack_require__(307);
	
	var Scale = __webpack_require__(352);
	
	var helper = __webpack_require__(355);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Interval scale
	 * @module echarts/scale/Interval
	 */
	var roundNumber = numberUtil.round;
	/**
	 * @alias module:echarts/coord/scale/Interval
	 * @constructor
	 */
	
	var IntervalScale = Scale.extend({
	  type: 'interval',
	  _interval: 0,
	  _intervalPrecision: 2,
	  setExtent: function (start, end) {
	    var thisExtent = this._extent; //start,end may be a Number like '25',so...
	
	    if (!isNaN(start)) {
	      thisExtent[0] = parseFloat(start);
	    }
	
	    if (!isNaN(end)) {
	      thisExtent[1] = parseFloat(end);
	    }
	  },
	  unionExtent: function (other) {
	    var extent = this._extent;
	    other[0] < extent[0] && (extent[0] = other[0]);
	    other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes
	
	    IntervalScale.prototype.setExtent.call(this, extent[0], extent[1]);
	  },
	
	  /**
	   * Get interval
	   */
	  getInterval: function () {
	    return this._interval;
	  },
	
	  /**
	   * Set interval
	   */
	  setInterval: function (interval) {
	    this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
	    // We assume user wan't to set both interval, min, max to get a better result
	
	    this._niceExtent = this._extent.slice();
	    this._intervalPrecision = helper.getIntervalPrecision(interval);
	  },
	
	  /**
	   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
	   * @return {Array.<number>}
	   */
	  getTicks: function (expandToNicedExtent) {
	    var interval = this._interval;
	    var extent = this._extent;
	    var niceTickExtent = this._niceExtent;
	    var intervalPrecision = this._intervalPrecision;
	    var ticks = []; // If interval is 0, return [];
	
	    if (!interval) {
	      return ticks;
	    } // Consider this case: using dataZoom toolbox, zoom and zoom.
	
	
	    var safeLimit = 10000;
	
	    if (extent[0] < niceTickExtent[0]) {
	      if (expandToNicedExtent) {
	        ticks.push(roundNumber(niceTickExtent[0] - interval, intervalPrecision));
	      } else {
	        ticks.push(extent[0]);
	      }
	    }
	
	    var tick = niceTickExtent[0];
	
	    while (tick <= niceTickExtent[1]) {
	      ticks.push(tick); // Avoid rounding error
	
	      tick = roundNumber(tick + interval, intervalPrecision);
	
	      if (tick === ticks[ticks.length - 1]) {
	        // Consider out of safe float point, e.g.,
	        // -3711126.9907707 + 2e-10 === -3711126.9907707
	        break;
	      }
	
	      if (ticks.length > safeLimit) {
	        return [];
	      }
	    } // Consider this case: the last item of ticks is smaller
	    // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
	
	
	    var lastNiceTick = ticks.length ? ticks[ticks.length - 1] : niceTickExtent[1];
	
	    if (extent[1] > lastNiceTick) {
	      if (expandToNicedExtent) {
	        ticks.push(roundNumber(lastNiceTick + interval, intervalPrecision));
	      } else {
	        ticks.push(extent[1]);
	      }
	    }
	
	    return ticks;
	  },
	
	  /**
	   * @param {number} [splitNumber=5]
	   * @return {Array.<Array.<number>>}
	   */
	  getMinorTicks: function (splitNumber) {
	    var ticks = this.getTicks(true);
	    var minorTicks = [];
	    var extent = this.getExtent();
	
	    for (var i = 1; i < ticks.length; i++) {
	      var nextTick = ticks[i];
	      var prevTick = ticks[i - 1];
	      var count = 0;
	      var minorTicksGroup = [];
	      var interval = nextTick - prevTick;
	      var minorInterval = interval / splitNumber;
	
	      while (count < splitNumber - 1) {
	        var minorTick = numberUtil.round(prevTick + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.
	
	        if (minorTick > extent[0] && minorTick < extent[1]) {
	          minorTicksGroup.push(minorTick);
	        }
	
	        count++;
	      }
	
	      minorTicks.push(minorTicksGroup);
	    }
	
	    return minorTicks;
	  },
	
	  /**
	   * @param {number} data
	   * @param {Object} [opt]
	   * @param {number|string} [opt.precision] If 'auto', use nice presision.
	   * @param {boolean} [opt.pad] returns 1.50 but not 1.5 if precision is 2.
	   * @return {string}
	   */
	  getLabel: function (data, opt) {
	    if (data == null) {
	      return '';
	    }
	
	    var precision = opt && opt.precision;
	
	    if (precision == null) {
	      precision = numberUtil.getPrecisionSafe(data) || 0;
	    } else if (precision === 'auto') {
	      // Should be more precise then tick.
	      precision = this._intervalPrecision;
	    } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
	    // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
	
	
	    data = roundNumber(data, precision, true);
	    return formatUtil.addCommas(data);
	  },
	
	  /**
	   * Update interval and extent of intervals for nice ticks
	   *
	   * @param {number} [splitNumber = 5] Desired number of ticks
	   * @param {number} [minInterval]
	   * @param {number} [maxInterval]
	   */
	  niceTicks: function (splitNumber, minInterval, maxInterval) {
	    splitNumber = splitNumber || 5;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	
	    if (!isFinite(span)) {
	      return;
	    } // User may set axis min 0 and data are all negative
	    // FIXME If it needs to reverse ?
	
	
	    if (span < 0) {
	      span = -span;
	      extent.reverse();
	    }
	
	    var result = helper.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
	    this._intervalPrecision = result.intervalPrecision;
	    this._interval = result.interval;
	    this._niceExtent = result.niceTickExtent;
	  },
	
	  /**
	   * Nice extent.
	   * @param {Object} opt
	   * @param {number} [opt.splitNumber = 5] Given approx tick number
	   * @param {boolean} [opt.fixMin=false]
	   * @param {boolean} [opt.fixMax=false]
	   * @param {boolean} [opt.minInterval]
	   * @param {boolean} [opt.maxInterval]
	   */
	  niceExtent: function (opt) {
	    var extent = this._extent; // If extent start and end are same, expand them
	
	    if (extent[0] === extent[1]) {
	      if (extent[0] !== 0) {
	        // Expand extent
	        var expandSize = extent[0]; // In the fowllowing case
	        //      Axis has been fixed max 100
	        //      Plus data are all 100 and axis extent are [100, 100].
	        // Extend to the both side will cause expanded max is larger than fixed max.
	        // So only expand to the smaller side.
	
	        if (!opt.fixMax) {
	          extent[1] += expandSize / 2;
	          extent[0] -= expandSize / 2;
	        } else {
	          extent[0] -= expandSize / 2;
	        }
	      } else {
	        extent[1] = 1;
	      }
	    }
	
	    var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]
	
	    if (!isFinite(span)) {
	      extent[0] = 0;
	      extent[1] = 1;
	    }
	
	    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
	
	    var interval = this._interval;
	
	    if (!opt.fixMin) {
	      extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
	    }
	
	    if (!opt.fixMax) {
	      extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
	    }
	  }
	});
	/**
	 * @return {module:echarts/scale/Time}
	 */
	
	IntervalScale.create = function () {
	  return new IntervalScale();
	};
	
	var _default = IntervalScale;
	module.exports = _default;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var numberUtil = __webpack_require__(306);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * For testable.
	 */
	var roundNumber = numberUtil.round;
	/**
	 * @param {Array.<number>} extent Both extent[0] and extent[1] should be valid number.
	 *                                Should be extent[0] < extent[1].
	 * @param {number} splitNumber splitNumber should be >= 1.
	 * @param {number} [minInterval]
	 * @param {number} [maxInterval]
	 * @return {Object} {interval, intervalPrecision, niceTickExtent}
	 */
	
	function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
	  var result = {};
	  var span = extent[1] - extent[0];
	  var interval = result.interval = numberUtil.nice(span / splitNumber, true);
	
	  if (minInterval != null && interval < minInterval) {
	    interval = result.interval = minInterval;
	  }
	
	  if (maxInterval != null && interval > maxInterval) {
	    interval = result.interval = maxInterval;
	  } // Tow more digital for tick.
	
	
	  var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent
	
	  var niceTickExtent = result.niceTickExtent = [roundNumber(Math.ceil(extent[0] / interval) * interval, precision), roundNumber(Math.floor(extent[1] / interval) * interval, precision)];
	  fixExtent(niceTickExtent, extent);
	  return result;
	}
	/**
	 * @param {number} interval
	 * @return {number} interval precision
	 */
	
	
	function getIntervalPrecision(interval) {
	  // Tow more digital for tick.
	  return numberUtil.getPrecisionSafe(interval) + 2;
	}
	
	function clamp(niceTickExtent, idx, extent) {
	  niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
	} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
	
	
	function fixExtent(niceTickExtent, extent) {
	  !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
	  !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
	  clamp(niceTickExtent, 0, extent);
	  clamp(niceTickExtent, 1, extent);
	
	  if (niceTickExtent[0] > niceTickExtent[1]) {
	    niceTickExtent[0] = niceTickExtent[1];
	  }
	}
	
	exports.intervalScaleNiceTicks = intervalScaleNiceTicks;
	exports.getIntervalPrecision = getIntervalPrecision;
	exports.fixExtent = fixExtent;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	
	var _dataStackHelper = __webpack_require__(349);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	var createRenderPlanner = __webpack_require__(326);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var STACK_PREFIX = '__ec_stack_';
	var LARGE_BAR_MIN_WIDTH = 0.5;
	var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
	
	function getSeriesStackId(seriesModel) {
	  return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
	}
	
	function getAxisKey(axis) {
	  return axis.dim + axis.index;
	}
	/**
	 * @param {Object} opt
	 * @param {module:echarts/coord/Axis} opt.axis Only support category axis currently.
	 * @param {number} opt.count Positive interger.
	 * @param {number} [opt.barWidth]
	 * @param {number} [opt.barMaxWidth]
	 * @param {number} [opt.barMinWidth]
	 * @param {number} [opt.barGap]
	 * @param {number} [opt.barCategoryGap]
	 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
	 */
	
	
	function getLayoutOnAxis(opt) {
	  var params = [];
	  var baseAxis = opt.axis;
	  var axisKey = 'axis0';
	
	  if (baseAxis.type !== 'category') {
	    return;
	  }
	
	  var bandWidth = baseAxis.getBandWidth();
	
	  for (var i = 0; i < opt.count || 0; i++) {
	    params.push(zrUtil.defaults({
	      bandWidth: bandWidth,
	      axisKey: axisKey,
	      stackId: STACK_PREFIX + i
	    }, opt));
	  }
	
	  var widthAndOffsets = doCalBarWidthAndOffset(params);
	  var result = [];
	
	  for (var i = 0; i < opt.count; i++) {
	    var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
	    item.offsetCenter = item.offset + item.width / 2;
	    result.push(item);
	  }
	
	  return result;
	}
	
	function prepareLayoutBarSeries(seriesType, ecModel) {
	  var seriesModels = [];
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    // Check series coordinate, do layout for cartesian2d only
	    if (isOnCartesian(seriesModel) && !isInLargeMode(seriesModel)) {
	      seriesModels.push(seriesModel);
	    }
	  });
	  return seriesModels;
	}
	/**
	 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
	 * values.
	 * This works for time axes, value axes, and log axes.
	 * For a single time axis, return value is in the form like
	 * {'x_0': [1000000]}.
	 * The value of 1000000 is in milliseconds.
	 */
	
	
	function getValueAxesMinGaps(barSeries) {
	  /**
	   * Map from axis.index to values.
	   * For a single time axis, axisValues is in the form like
	   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
	   * Items in axisValues[x], e.g. 1495555200000, are time values of all
	   * series.
	   */
	  var axisValues = {};
	  zrUtil.each(barSeries, function (seriesModel) {
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	
	    if (baseAxis.type !== 'time' && baseAxis.type !== 'value') {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var key = baseAxis.dim + '_' + baseAxis.index;
	    var dim = data.mapDimension(baseAxis.dim);
	
	    for (var i = 0, cnt = data.count(); i < cnt; ++i) {
	      var value = data.get(dim, i);
	
	      if (!axisValues[key]) {
	        // No previous data for the axis
	        axisValues[key] = [value];
	      } else {
	        // No value in previous series
	        axisValues[key].push(value);
	      } // Ignore duplicated time values in the same axis
	
	    }
	  });
	  var axisMinGaps = [];
	
	  for (var key in axisValues) {
	    if (axisValues.hasOwnProperty(key)) {
	      var valuesInAxis = axisValues[key];
	
	      if (valuesInAxis) {
	        // Sort axis values into ascending order to calculate gaps
	        valuesInAxis.sort(function (a, b) {
	          return a - b;
	        });
	        var min = null;
	
	        for (var j = 1; j < valuesInAxis.length; ++j) {
	          var delta = valuesInAxis[j] - valuesInAxis[j - 1];
	
	          if (delta > 0) {
	            // Ignore 0 delta because they are of the same axis value
	            min = min === null ? delta : Math.min(min, delta);
	          }
	        } // Set to null if only have one data
	
	
	        axisMinGaps[key] = min;
	      }
	    }
	  }
	
	  return axisMinGaps;
	}
	
	function makeColumnLayout(barSeries) {
	  var axisMinGaps = getValueAxesMinGaps(barSeries);
	  var seriesInfoList = [];
	  zrUtil.each(barSeries, function (seriesModel) {
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var axisExtent = baseAxis.getExtent();
	    var bandWidth;
	
	    if (baseAxis.type === 'category') {
	      bandWidth = baseAxis.getBandWidth();
	    } else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
	      var key = baseAxis.dim + '_' + baseAxis.index;
	      var minGap = axisMinGaps[key];
	      var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
	      var scale = baseAxis.scale.getExtent();
	      var scaleSpan = Math.abs(scale[1] - scale[0]);
	      bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
	    } else {
	      var data = seriesModel.getData();
	      bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	    }
	
	    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
	    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
	    var barMinWidth = parsePercent( // barMinWidth by default is 1 in cartesian. Because in value axis,
	    // the auto-calculated bar width might be less than 1.
	    seriesModel.get('barMinWidth') || 1, bandWidth);
	    var barGap = seriesModel.get('barGap');
	    var barCategoryGap = seriesModel.get('barCategoryGap');
	    seriesInfoList.push({
	      bandWidth: bandWidth,
	      barWidth: barWidth,
	      barMaxWidth: barMaxWidth,
	      barMinWidth: barMinWidth,
	      barGap: barGap,
	      barCategoryGap: barCategoryGap,
	      axisKey: getAxisKey(baseAxis),
	      stackId: getSeriesStackId(seriesModel)
	    });
	  });
	  return doCalBarWidthAndOffset(seriesInfoList);
	}
	
	function doCalBarWidthAndOffset(seriesInfoList) {
	  // Columns info on each category axis. Key is cartesian name
	  var columnsMap = {};
	  zrUtil.each(seriesInfoList, function (seriesInfo, idx) {
	    var axisKey = seriesInfo.axisKey;
	    var bandWidth = seriesInfo.bandWidth;
	    var columnsOnAxis = columnsMap[axisKey] || {
	      bandWidth: bandWidth,
	      remainedWidth: bandWidth,
	      autoWidthCount: 0,
	      categoryGap: '20%',
	      gap: '30%',
	      stacks: {}
	    };
	    var stacks = columnsOnAxis.stacks;
	    columnsMap[axisKey] = columnsOnAxis;
	    var stackId = seriesInfo.stackId;
	
	    if (!stacks[stackId]) {
	      columnsOnAxis.autoWidthCount++;
	    }
	
	    stacks[stackId] = stacks[stackId] || {
	      width: 0,
	      maxWidth: 0
	    }; // Caution: In a single coordinate system, these barGrid attributes
	    // will be shared by series. Consider that they have default values,
	    // only the attributes set on the last series will work.
	    // Do not change this fact unless there will be a break change.
	
	    var barWidth = seriesInfo.barWidth;
	
	    if (barWidth && !stacks[stackId].width) {
	      // See #6312, do not restrict width.
	      stacks[stackId].width = barWidth;
	      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	      columnsOnAxis.remainedWidth -= barWidth;
	    }
	
	    var barMaxWidth = seriesInfo.barMaxWidth;
	    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	    var barMinWidth = seriesInfo.barMinWidth;
	    barMinWidth && (stacks[stackId].minWidth = barMinWidth);
	    var barGap = seriesInfo.barGap;
	    barGap != null && (columnsOnAxis.gap = barGap);
	    var barCategoryGap = seriesInfo.barCategoryGap;
	    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	  });
	  var result = {};
	  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
	    result[coordSysName] = {};
	    var stacks = columnsOnAxis.stacks;
	    var bandWidth = columnsOnAxis.bandWidth;
	    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
	    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
	    var remainedWidth = columnsOnAxis.remainedWidth;
	    var autoWidthCount = columnsOnAxis.autoWidthCount;
	    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	    zrUtil.each(stacks, function (column) {
	      var maxWidth = column.maxWidth;
	      var minWidth = column.minWidth;
	
	      if (!column.width) {
	        var finalWidth = autoWidth;
	
	        if (maxWidth && maxWidth < finalWidth) {
	          finalWidth = Math.min(maxWidth, remainedWidth);
	        } // `minWidth` has higher priority. `minWidth` decide that wheter the
	        // bar is able to be visible. So `minWidth` should not be restricted
	        // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
	        // the extreme cases for `value` axis, bars are allowed to overlap
	        // with each other if `minWidth` specified.
	
	
	        if (minWidth && minWidth > finalWidth) {
	          finalWidth = minWidth;
	        }
	
	        if (finalWidth !== autoWidth) {
	          column.width = finalWidth;
	          remainedWidth -= finalWidth + barGapPercent * finalWidth;
	          autoWidthCount--;
	        }
	      } else {
	        // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
	        // CSS does. Becuase barWidth can be a percent value, where
	        // `barMaxWidth` can be used to restrict the final width.
	        var finalWidth = column.width;
	
	        if (maxWidth) {
	          finalWidth = Math.min(finalWidth, maxWidth);
	        } // `minWidth` has higher priority, as described above
	
	
	        if (minWidth) {
	          finalWidth = Math.max(finalWidth, minWidth);
	        }
	
	        column.width = finalWidth;
	        remainedWidth -= finalWidth + barGapPercent * finalWidth;
	        autoWidthCount--;
	      }
	    }); // Recalculate width again
	
	    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0);
	    var widthSum = 0;
	    var lastColumn;
	    zrUtil.each(stacks, function (column, idx) {
	      if (!column.width) {
	        column.width = autoWidth;
	      }
	
	      lastColumn = column;
	      widthSum += column.width * (1 + barGapPercent);
	    });
	
	    if (lastColumn) {
	      widthSum -= lastColumn.width * barGapPercent;
	    }
	
	    var offset = -widthSum / 2;
	    zrUtil.each(stacks, function (column, stackId) {
	      result[coordSysName][stackId] = result[coordSysName][stackId] || {
	        bandWidth: bandWidth,
	        offset: offset,
	        width: column.width
	      };
	      offset += column.width * (1 + barGapPercent);
	    });
	  });
	  return result;
	}
	/**
	 * @param {Object} barWidthAndOffset The result of makeColumnLayout
	 * @param {module:echarts/coord/Axis} axis
	 * @param {module:echarts/model/Series} [seriesModel] If not provided, return all.
	 * @return {Object} {stackId: {offset, width}} or {offset, width} if seriesModel provided.
	 */
	
	
	function retrieveColumnLayout(barWidthAndOffset, axis, seriesModel) {
	  if (barWidthAndOffset && axis) {
	    var result = barWidthAndOffset[getAxisKey(axis)];
	
	    if (result != null && seriesModel != null) {
	      result = result[getSeriesStackId(seriesModel)];
	    }
	
	    return result;
	  }
	}
	/**
	 * @param {string} seriesType
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function layout(seriesType, ecModel) {
	  var seriesModels = prepareLayoutBarSeries(seriesType, ecModel);
	  var barWidthAndOffset = makeColumnLayout(seriesModels);
	  var lastStackCoords = {};
	  var lastStackCoordsOrigin = {};
	  zrUtil.each(seriesModels, function (seriesModel) {
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var stackId = getSeriesStackId(seriesModel);
	    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
	    var columnOffset = columnLayoutInfo.offset;
	    var columnWidth = columnLayoutInfo.width;
	    var valueAxis = cartesian.getOtherAxis(baseAxis);
	    var barMinHeight = seriesModel.get('barMinHeight') || 0;
	    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	    lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243
	
	    data.setLayout({
	      bandWidth: columnLayoutInfo.bandWidth,
	      offset: columnOffset,
	      size: columnWidth
	    });
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var stacked = isDimensionStacked(data, valueDim
	    /*, baseDim*/
	    );
	    var isValueAxisH = valueAxis.isHorizontal();
	    var valueAxisStart = getValueAxisStart(baseAxis, valueAxis, stacked);
	
	    for (var idx = 0, len = data.count(); idx < len; idx++) {
	      var value = data.get(valueDim, idx);
	      var baseValue = data.get(baseDim, idx);
	      var sign = value >= 0 ? 'p' : 'n';
	      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
	      // stackResultDimension directly.
	
	      if (stacked) {
	        // Only ordinal axis can be stacked.
	        if (!lastStackCoords[stackId][baseValue]) {
	          lastStackCoords[stackId][baseValue] = {
	            p: valueAxisStart,
	            // Positive stack
	            n: valueAxisStart // Negative stack
	
	          };
	        } // Should also consider #4243
	
	
	        baseCoord = lastStackCoords[stackId][baseValue][sign];
	      }
	
	      var x;
	      var y;
	      var width;
	      var height;
	
	      if (isValueAxisH) {
	        var coord = cartesian.dataToPoint([value, baseValue]);
	        x = baseCoord;
	        y = coord[1] + columnOffset;
	        width = coord[0] - valueAxisStart;
	        height = columnWidth;
	
	        if (Math.abs(width) < barMinHeight) {
	          width = (width < 0 ? -1 : 1) * barMinHeight;
	        } // Ignore stack from NaN value
	
	
	        if (!isNaN(width)) {
	          stacked && (lastStackCoords[stackId][baseValue][sign] += width);
	        }
	      } else {
	        var coord = cartesian.dataToPoint([baseValue, value]);
	        x = coord[0] + columnOffset;
	        y = baseCoord;
	        width = columnWidth;
	        height = coord[1] - valueAxisStart;
	
	        if (Math.abs(height) < barMinHeight) {
	          // Include zero to has a positive bar
	          height = (height <= 0 ? -1 : 1) * barMinHeight;
	        } // Ignore stack from NaN value
	
	
	        if (!isNaN(height)) {
	          stacked && (lastStackCoords[stackId][baseValue][sign] += height);
	        }
	      }
	
	      data.setItemLayout(idx, {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, this);
	} // TODO: Do not support stack in large mode yet.
	
	
	var largeLayout = {
	  seriesType: 'bar',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    if (!isOnCartesian(seriesModel) || !isInLargeMode(seriesModel)) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var coordLayout = cartesian.grid.getRect();
	    var baseAxis = cartesian.getBaseAxis();
	    var valueAxis = cartesian.getOtherAxis(baseAxis);
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var valueAxisHorizontal = valueAxis.isHorizontal();
	    var valueDimIdx = valueAxisHorizontal ? 0 : 1;
	    var barWidth = retrieveColumnLayout(makeColumnLayout([seriesModel]), baseAxis, seriesModel).width;
	
	    if (!(barWidth > LARGE_BAR_MIN_WIDTH)) {
	      // jshint ignore:line
	      barWidth = LARGE_BAR_MIN_WIDTH;
	    }
	
	    return {
	      progress: progress
	    };
	
	    function progress(params, data) {
	      var count = params.count;
	      var largePoints = new LargeArr(count * 2);
	      var largeBackgroundPoints = new LargeArr(count * 2);
	      var largeDataIndices = new LargeArr(count);
	      var dataIndex;
	      var coord = [];
	      var valuePair = [];
	      var pointsOffset = 0;
	      var idxOffset = 0;
	
	      while ((dataIndex = params.next()) != null) {
	        valuePair[valueDimIdx] = data.get(valueDim, dataIndex);
	        valuePair[1 - valueDimIdx] = data.get(baseDim, dataIndex);
	        coord = cartesian.dataToPoint(valuePair, null, coord); // Data index might not be in order, depends on `progressiveChunkMode`.
	
	        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
	        largePoints[pointsOffset++] = coord[0];
	        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
	        largePoints[pointsOffset++] = coord[1];
	        largeDataIndices[idxOffset++] = dataIndex;
	      }
	
	      data.setLayout({
	        largePoints: largePoints,
	        largeDataIndices: largeDataIndices,
	        largeBackgroundPoints: largeBackgroundPoints,
	        barWidth: barWidth,
	        valueAxisStart: getValueAxisStart(baseAxis, valueAxis, false),
	        backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
	        valueAxisHorizontal: valueAxisHorizontal
	      });
	    }
	  }
	};
	
	function isOnCartesian(seriesModel) {
	  return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
	}
	
	function isInLargeMode(seriesModel) {
	  return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
	} // See cases in `test/bar-start.html` and `#7412`, `#8747`.
	
	
	function getValueAxisStart(baseAxis, valueAxis, stacked) {
	  return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
	}
	
	exports.getLayoutOnAxis = getLayoutOnAxis;
	exports.prepareLayoutBarSeries = prepareLayoutBarSeries;
	exports.makeColumnLayout = makeColumnLayout;
	exports.retrieveColumnLayout = retrieveColumnLayout;
	exports.layout = layout;
	exports.largeLayout = largeLayout;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var numberUtil = __webpack_require__(306);
	
	var formatUtil = __webpack_require__(307);
	
	var scaleHelper = __webpack_require__(355);
	
	var IntervalScale = __webpack_require__(354);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The "scaleLevels" was originally copied from "d3.js" with some
	* modifications made for this project.
	* (See more details in the comment on the definition of "scaleLevels" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	// [About UTC and local time zone]:
	// In most cases, `number.parseDate` will treat input data string as local time
	// (except time zone is specified in time string). And `format.formateTime` returns
	// local time by default. option.useUTC is false by default. This design have
	// concidered these common case:
	// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
	// in local time by default.
	// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
	// as its original time, without any time difference.
	var intervalScaleProto = IntervalScale.prototype;
	var mathCeil = Math.ceil;
	var mathFloor = Math.floor;
	var ONE_SECOND = 1000;
	var ONE_MINUTE = ONE_SECOND * 60;
	var ONE_HOUR = ONE_MINUTE * 60;
	var ONE_DAY = ONE_HOUR * 24; // FIXME 公用？
	
	var bisect = function (a, x, lo, hi) {
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	
	    if (a[mid][1] < x) {
	      lo = mid + 1;
	    } else {
	      hi = mid;
	    }
	  }
	
	  return lo;
	};
	/**
	 * @alias module:echarts/coord/scale/Time
	 * @constructor
	 */
	
	
	var TimeScale = IntervalScale.extend({
	  type: 'time',
	
	  /**
	   * @override
	   */
	  getLabel: function (val) {
	    var stepLvl = this._stepLvl;
	    var date = new Date(val);
	    return formatUtil.formatTime(stepLvl[0], date, this.getSetting('useUTC'));
	  },
	
	  /**
	   * @override
	   */
	  niceExtent: function (opt) {
	    var extent = this._extent; // If extent start and end are same, expand them
	
	    if (extent[0] === extent[1]) {
	      // Expand extent
	      extent[0] -= ONE_DAY;
	      extent[1] += ONE_DAY;
	    } // If there are no data and extent are [Infinity, -Infinity]
	
	
	    if (extent[1] === -Infinity && extent[0] === Infinity) {
	      var d = new Date();
	      extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
	      extent[0] = extent[1] - ONE_DAY;
	    }
	
	    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
	
	    var interval = this._interval;
	
	    if (!opt.fixMin) {
	      extent[0] = numberUtil.round(mathFloor(extent[0] / interval) * interval);
	    }
	
	    if (!opt.fixMax) {
	      extent[1] = numberUtil.round(mathCeil(extent[1] / interval) * interval);
	    }
	  },
	
	  /**
	   * @override
	   */
	  niceTicks: function (approxTickNum, minInterval, maxInterval) {
	    approxTickNum = approxTickNum || 10;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	    var approxInterval = span / approxTickNum;
	
	    if (minInterval != null && approxInterval < minInterval) {
	      approxInterval = minInterval;
	    }
	
	    if (maxInterval != null && approxInterval > maxInterval) {
	      approxInterval = maxInterval;
	    }
	
	    var scaleLevelsLen = scaleLevels.length;
	    var idx = bisect(scaleLevels, approxInterval, 0, scaleLevelsLen);
	    var level = scaleLevels[Math.min(idx, scaleLevelsLen - 1)];
	    var interval = level[1]; // Same with interval scale if span is much larger than 1 year
	
	    if (level[0] === 'year') {
	      var yearSpan = span / interval; // From "Nice Numbers for Graph Labels" of Graphic Gems
	      // var niceYearSpan = numberUtil.nice(yearSpan, false);
	
	      var yearStep = numberUtil.nice(yearSpan / approxTickNum, true);
	      interval *= yearStep;
	    }
	
	    var timezoneOffset = this.getSetting('useUTC') ? 0 : new Date(+extent[0] || +extent[1]).getTimezoneOffset() * 60 * 1000;
	    var niceExtent = [Math.round(mathCeil((extent[0] - timezoneOffset) / interval) * interval + timezoneOffset), Math.round(mathFloor((extent[1] - timezoneOffset) / interval) * interval + timezoneOffset)];
	    scaleHelper.fixExtent(niceExtent, extent);
	    this._stepLvl = level; // Interval will be used in getTicks
	
	    this._interval = interval;
	    this._niceExtent = niceExtent;
	  },
	  parse: function (val) {
	    // val might be float.
	    return +numberUtil.parseDate(val);
	  }
	});
	zrUtil.each(['contain', 'normalize'], function (methodName) {
	  TimeScale.prototype[methodName] = function (val) {
	    return intervalScaleProto[methodName].call(this, this.parse(val));
	  };
	});
	/**
	 * This implementation was originally copied from "d3.js"
	 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 */
	
	var scaleLevels = [// Format              interval
	['hh:mm:ss', ONE_SECOND], // 1s
	['hh:mm:ss', ONE_SECOND * 5], // 5s
	['hh:mm:ss', ONE_SECOND * 10], // 10s
	['hh:mm:ss', ONE_SECOND * 15], // 15s
	['hh:mm:ss', ONE_SECOND * 30], // 30s
	['hh:mm\nMM-dd', ONE_MINUTE], // 1m
	['hh:mm\nMM-dd', ONE_MINUTE * 5], // 5m
	['hh:mm\nMM-dd', ONE_MINUTE * 10], // 10m
	['hh:mm\nMM-dd', ONE_MINUTE * 15], // 15m
	['hh:mm\nMM-dd', ONE_MINUTE * 30], // 30m
	['hh:mm\nMM-dd', ONE_HOUR], // 1h
	['hh:mm\nMM-dd', ONE_HOUR * 2], // 2h
	['hh:mm\nMM-dd', ONE_HOUR * 6], // 6h
	['hh:mm\nMM-dd', ONE_HOUR * 12], // 12h
	['MM-dd\nyyyy', ONE_DAY], // 1d
	['MM-dd\nyyyy', ONE_DAY * 2], // 2d
	['MM-dd\nyyyy', ONE_DAY * 3], // 3d
	['MM-dd\nyyyy', ONE_DAY * 4], // 4d
	['MM-dd\nyyyy', ONE_DAY * 5], // 5d
	['MM-dd\nyyyy', ONE_DAY * 6], // 6d
	['week', ONE_DAY * 7], // 7d
	['MM-dd\nyyyy', ONE_DAY * 10], // 10d
	['week', ONE_DAY * 14], // 2w
	['week', ONE_DAY * 21], // 3w
	['month', ONE_DAY * 31], // 1M
	['week', ONE_DAY * 42], // 6w
	['month', ONE_DAY * 62], // 2M
	['week', ONE_DAY * 70], // 10w
	['quarter', ONE_DAY * 95], // 3M
	['month', ONE_DAY * 31 * 4], // 4M
	['month', ONE_DAY * 31 * 5], // 5M
	['half-year', ONE_DAY * 380 / 2], // 6M
	['month', ONE_DAY * 31 * 8], // 8M
	['month', ONE_DAY * 31 * 10], // 10M
	['year', ONE_DAY * 380] // 1Y
	];
	/**
	 * @param {module:echarts/model/Model}
	 * @return {module:echarts/scale/Time}
	 */
	
	TimeScale.create = function (model) {
	  return new TimeScale({
	    useUTC: model.ecModel.get('useUTC')
	  });
	};
	
	var _default = TimeScale;
	module.exports = _default;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Scale = __webpack_require__(352);
	
	var numberUtil = __webpack_require__(306);
	
	var IntervalScale = __webpack_require__(354);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Log scale
	 * @module echarts/scale/Log
	 */
	// Use some method of IntervalScale
	var scaleProto = Scale.prototype;
	var intervalScaleProto = IntervalScale.prototype;
	var getPrecisionSafe = numberUtil.getPrecisionSafe;
	var roundingErrorFix = numberUtil.round;
	var mathFloor = Math.floor;
	var mathCeil = Math.ceil;
	var mathPow = Math.pow;
	var mathLog = Math.log;
	var LogScale = Scale.extend({
	  type: 'log',
	  base: 10,
	  $constructor: function () {
	    Scale.apply(this, arguments);
	    this._originalScale = new IntervalScale();
	  },
	
	  /**
	   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
	   * @return {Array.<number>}
	   */
	  getTicks: function (expandToNicedExtent) {
	    var originalScale = this._originalScale;
	    var extent = this._extent;
	    var originalExtent = originalScale.getExtent();
	    return zrUtil.map(intervalScaleProto.getTicks.call(this, expandToNicedExtent), function (val) {
	      var powVal = numberUtil.round(mathPow(this.base, val)); // Fix #4158
	
	      powVal = val === extent[0] && originalScale.__fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
	      powVal = val === extent[1] && originalScale.__fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
	      return powVal;
	    }, this);
	  },
	
	  /**
	   * @param {number} splitNumber
	   * @return {Array.<Array.<number>>}
	   */
	  getMinorTicks: intervalScaleProto.getMinorTicks,
	
	  /**
	   * @param {number} val
	   * @return {string}
	   */
	  getLabel: intervalScaleProto.getLabel,
	
	  /**
	   * @param  {number} val
	   * @return {number}
	   */
	  scale: function (val) {
	    val = scaleProto.scale.call(this, val);
	    return mathPow(this.base, val);
	  },
	
	  /**
	   * @param {number} start
	   * @param {number} end
	   */
	  setExtent: function (start, end) {
	    var base = this.base;
	    start = mathLog(start) / mathLog(base);
	    end = mathLog(end) / mathLog(base);
	    intervalScaleProto.setExtent.call(this, start, end);
	  },
	
	  /**
	   * @return {number} end
	   */
	  getExtent: function () {
	    var base = this.base;
	    var extent = scaleProto.getExtent.call(this);
	    extent[0] = mathPow(base, extent[0]);
	    extent[1] = mathPow(base, extent[1]); // Fix #4158
	
	    var originalScale = this._originalScale;
	    var originalExtent = originalScale.getExtent();
	    originalScale.__fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
	    originalScale.__fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
	    return extent;
	  },
	
	  /**
	   * @param  {Array.<number>} extent
	   */
	  unionExtent: function (extent) {
	    this._originalScale.unionExtent(extent);
	
	    var base = this.base;
	    extent[0] = mathLog(extent[0]) / mathLog(base);
	    extent[1] = mathLog(extent[1]) / mathLog(base);
	    scaleProto.unionExtent.call(this, extent);
	  },
	
	  /**
	   * @override
	   */
	  unionExtentFromData: function (data, dim) {
	    // TODO
	    // filter value that <= 0
	    this.unionExtent(data.getApproximateExtent(dim));
	  },
	
	  /**
	   * Update interval and extent of intervals for nice ticks
	   * @param  {number} [approxTickNum = 10] Given approx tick number
	   */
	  niceTicks: function (approxTickNum) {
	    approxTickNum = approxTickNum || 10;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	
	    if (span === Infinity || span <= 0) {
	      return;
	    }
	
	    var interval = numberUtil.quantity(span);
	    var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.
	
	    if (err <= 0.5) {
	      interval *= 10;
	    } // Interval should be integer
	
	
	    while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
	      interval *= 10;
	    }
	
	    var niceExtent = [numberUtil.round(mathCeil(extent[0] / interval) * interval), numberUtil.round(mathFloor(extent[1] / interval) * interval)];
	    this._interval = interval;
	    this._niceExtent = niceExtent;
	  },
	
	  /**
	   * Nice extent.
	   * @override
	   */
	  niceExtent: function (opt) {
	    intervalScaleProto.niceExtent.call(this, opt);
	    var originalScale = this._originalScale;
	    originalScale.__fixMin = opt.fixMin;
	    originalScale.__fixMax = opt.fixMax;
	  }
	});
	zrUtil.each(['contain', 'normalize'], function (methodName) {
	  LogScale.prototype[methodName] = function (val) {
	    val = mathLog(val) / mathLog(this.base);
	    return scaleProto[methodName].call(this, val);
	  };
	});
	
	LogScale.create = function () {
	  return new LogScale();
	};
	
	function fixRoundingError(val, originalVal) {
	  return roundingErrorFix(val, getPrecisionSafe(originalVal));
	}
	
	var _default = LogScale;
	module.exports = _default;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import * as axisHelper from './axisHelper';
	var _default = {
	  /**
	   * @param {boolean} origin
	   * @return {number|string} min value or 'dataMin' or null/undefined (means auto) or NaN
	   */
	  getMin: function (origin) {
	    var option = this.option;
	    var min = !origin && option.rangeStart != null ? option.rangeStart : option.min;
	
	    if (this.axis && min != null && min !== 'dataMin' && typeof min !== 'function' && !zrUtil.eqNaN(min)) {
	      min = this.axis.scale.parse(min);
	    }
	
	    return min;
	  },
	
	  /**
	   * @param {boolean} origin
	   * @return {number|string} max value or 'dataMax' or null/undefined (means auto) or NaN
	   */
	  getMax: function (origin) {
	    var option = this.option;
	    var max = !origin && option.rangeEnd != null ? option.rangeEnd : option.max;
	
	    if (this.axis && max != null && max !== 'dataMax' && typeof max !== 'function' && !zrUtil.eqNaN(max)) {
	      max = this.axis.scale.parse(max);
	    }
	
	    return max;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  getNeedCrossZero: function () {
	    var option = this.option;
	    return option.rangeStart != null || option.rangeEnd != null ? false : !option.scale;
	  },
	
	  /**
	   * Should be implemented by each axis model if necessary.
	   * @return {module:echarts/model/Component} coordinate system model
	   */
	  getCoordSysModel: zrUtil.noop,
	
	  /**
	   * @param {number} rangeStart Can only be finite number or null/undefined or NaN.
	   * @param {number} rangeEnd Can only be finite number or null/undefined or NaN.
	   */
	  setRange: function (rangeStart, rangeEnd) {
	    this.option.rangeStart = rangeStart;
	    this.option.rangeEnd = rangeEnd;
	  },
	
	  /**
	   * Reset range
	   */
	  resetRange: function () {
	    // rangeStart and rangeEnd is readonly.
	    this.option.rangeStart = this.option.rangeEnd = null;
	  }
	};
	module.exports = _default;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var BoundingRect = __webpack_require__(242);
	
	var _text = __webpack_require__(255);
	
	var calculateTextPosition = _text.calculateTextPosition;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Symbol factory
	
	/**
	 * Triangle shape
	 * @inner
	 */
	var Triangle = graphic.extendShape({
	  type: 'triangle',
	  shape: {
	    cx: 0,
	    cy: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var cx = shape.cx;
	    var cy = shape.cy;
	    var width = shape.width / 2;
	    var height = shape.height / 2;
	    path.moveTo(cx, cy - height);
	    path.lineTo(cx + width, cy + height);
	    path.lineTo(cx - width, cy + height);
	    path.closePath();
	  }
	});
	/**
	 * Diamond shape
	 * @inner
	 */
	
	var Diamond = graphic.extendShape({
	  type: 'diamond',
	  shape: {
	    cx: 0,
	    cy: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var cx = shape.cx;
	    var cy = shape.cy;
	    var width = shape.width / 2;
	    var height = shape.height / 2;
	    path.moveTo(cx, cy - height);
	    path.lineTo(cx + width, cy);
	    path.lineTo(cx, cy + height);
	    path.lineTo(cx - width, cy);
	    path.closePath();
	  }
	});
	/**
	 * Pin shape
	 * @inner
	 */
	
	var Pin = graphic.extendShape({
	  type: 'pin',
	  shape: {
	    // x, y on the cusp
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var x = shape.x;
	    var y = shape.y;
	    var w = shape.width / 5 * 3; // Height must be larger than width
	
	    var h = Math.max(w, shape.height);
	    var r = w / 2; // Dist on y with tangent point and circle center
	
	    var dy = r * r / (h - r);
	    var cy = y - h + r + dy;
	    var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center
	
	    var dx = Math.cos(angle) * r;
	    var tanX = Math.sin(angle);
	    var tanY = Math.cos(angle);
	    var cpLen = r * 0.6;
	    var cpLen2 = r * 0.7;
	    path.moveTo(x - dx, cy + dy);
	    path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
	    path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
	    path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
	    path.closePath();
	  }
	});
	/**
	 * Arrow shape
	 * @inner
	 */
	
	var Arrow = graphic.extendShape({
	  type: 'arrow',
	  shape: {
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (ctx, shape) {
	    var height = shape.height;
	    var width = shape.width;
	    var x = shape.x;
	    var y = shape.y;
	    var dx = width / 3 * 2;
	    ctx.moveTo(x, y);
	    ctx.lineTo(x + dx, y + height);
	    ctx.lineTo(x, y + height / 4 * 3);
	    ctx.lineTo(x - dx, y + height);
	    ctx.lineTo(x, y);
	    ctx.closePath();
	  }
	});
	/**
	 * Map of path contructors
	 * @type {Object.<string, module:zrender/graphic/Path>}
	 */
	
	var symbolCtors = {
	  line: graphic.Line,
	  rect: graphic.Rect,
	  roundRect: graphic.Rect,
	  square: graphic.Rect,
	  circle: graphic.Circle,
	  diamond: Diamond,
	  pin: Pin,
	  arrow: Arrow,
	  triangle: Triangle
	};
	var symbolShapeMakers = {
	  line: function (x, y, w, h, shape) {
	    // FIXME
	    shape.x1 = x;
	    shape.y1 = y + h / 2;
	    shape.x2 = x + w;
	    shape.y2 = y + h / 2;
	  },
	  rect: function (x, y, w, h, shape) {
	    shape.x = x;
	    shape.y = y;
	    shape.width = w;
	    shape.height = h;
	  },
	  roundRect: function (x, y, w, h, shape) {
	    shape.x = x;
	    shape.y = y;
	    shape.width = w;
	    shape.height = h;
	    shape.r = Math.min(w, h) / 4;
	  },
	  square: function (x, y, w, h, shape) {
	    var size = Math.min(w, h);
	    shape.x = x;
	    shape.y = y;
	    shape.width = size;
	    shape.height = size;
	  },
	  circle: function (x, y, w, h, shape) {
	    // Put circle in the center of square
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.r = Math.min(w, h) / 2;
	  },
	  diamond: function (x, y, w, h, shape) {
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  pin: function (x, y, w, h, shape) {
	    shape.x = x + w / 2;
	    shape.y = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  arrow: function (x, y, w, h, shape) {
	    shape.x = x + w / 2;
	    shape.y = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  triangle: function (x, y, w, h, shape) {
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  }
	};
	var symbolBuildProxies = {};
	zrUtil.each(symbolCtors, function (Ctor, name) {
	  symbolBuildProxies[name] = new Ctor();
	});
	var SymbolClz = graphic.extendShape({
	  type: 'symbol',
	  shape: {
	    symbolType: '',
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  calculateTextPosition: function (out, style, rect) {
	    var res = calculateTextPosition(out, style, rect);
	    var shape = this.shape;
	
	    if (shape && shape.symbolType === 'pin' && style.textPosition === 'inside') {
	      res.y = rect.y + rect.height * 0.4;
	    }
	
	    return res;
	  },
	  buildPath: function (ctx, shape, inBundle) {
	    var symbolType = shape.symbolType;
	
	    if (symbolType !== 'none') {
	      var proxySymbol = symbolBuildProxies[symbolType];
	
	      if (!proxySymbol) {
	        // Default rect
	        symbolType = 'rect';
	        proxySymbol = symbolBuildProxies[symbolType];
	      }
	
	      symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
	      proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
	    }
	  }
	}); // Provide setColor helper method to avoid determine if set the fill or stroke outside
	
	function symbolPathSetColor(color, innerColor) {
	  if (this.type !== 'image') {
	    var symbolStyle = this.style;
	    var symbolShape = this.shape;
	
	    if (symbolShape && symbolShape.symbolType === 'line') {
	      symbolStyle.stroke = color;
	    } else if (this.__isEmptyBrush) {
	      symbolStyle.stroke = color;
	      symbolStyle.fill = innerColor || '#fff';
	    } else {
	      // FIXME 判断图形默认是填充还是描边，使用 onlyStroke ?
	      symbolStyle.fill && (symbolStyle.fill = color);
	      symbolStyle.stroke && (symbolStyle.stroke = color);
	    }
	
	    this.dirty(false);
	  }
	}
	/**
	 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
	 * @param {string} symbolType
	 * @param {number} x
	 * @param {number} y
	 * @param {number} w
	 * @param {number} h
	 * @param {string} color
	 * @param {boolean} [keepAspect=false] whether to keep the ratio of w/h,
	 *                            for path and image only.
	 */
	
	
	function createSymbol(symbolType, x, y, w, h, color, keepAspect) {
	  // TODO Support image object, DynamicImage.
	  var isEmpty = symbolType.indexOf('empty') === 0;
	
	  if (isEmpty) {
	    symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
	  }
	
	  var symbolPath;
	
	  if (symbolType.indexOf('image://') === 0) {
	    symbolPath = graphic.makeImage(symbolType.slice(8), new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	  } else if (symbolType.indexOf('path://') === 0) {
	    symbolPath = graphic.makePath(symbolType.slice(7), {}, new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	  } else {
	    symbolPath = new SymbolClz({
	      shape: {
	        symbolType: symbolType,
	        x: x,
	        y: y,
	        width: w,
	        height: h
	      }
	    });
	  }
	
	  symbolPath.__isEmptyBrush = isEmpty;
	  symbolPath.setColor = symbolPathSetColor;
	  symbolPath.setColor(color);
	  return symbolPath;
	}
	
	exports.createSymbol = createSymbol;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Region = __webpack_require__(362);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parse and decode geo json
	 * @module echarts/coord/geo/parseGeoJson
	 */
	function decode(json) {
	  if (!json.UTF8Encoding) {
	    return json;
	  }
	
	  var encodeScale = json.UTF8Scale;
	
	  if (encodeScale == null) {
	    encodeScale = 1024;
	  }
	
	  var features = json.features;
	
	  for (var f = 0; f < features.length; f++) {
	    var feature = features[f];
	    var geometry = feature.geometry;
	    var coordinates = geometry.coordinates;
	    var encodeOffsets = geometry.encodeOffsets;
	
	    for (var c = 0; c < coordinates.length; c++) {
	      var coordinate = coordinates[c];
	
	      if (geometry.type === 'Polygon') {
	        coordinates[c] = decodePolygon(coordinate, encodeOffsets[c], encodeScale);
	      } else if (geometry.type === 'MultiPolygon') {
	        for (var c2 = 0; c2 < coordinate.length; c2++) {
	          var polygon = coordinate[c2];
	          coordinate[c2] = decodePolygon(polygon, encodeOffsets[c][c2], encodeScale);
	        }
	      }
	    }
	  } // Has been decoded
	
	
	  json.UTF8Encoding = false;
	  return json;
	}
	
	function decodePolygon(coordinate, encodeOffsets, encodeScale) {
	  var result = [];
	  var prevX = encodeOffsets[0];
	  var prevY = encodeOffsets[1];
	
	  for (var i = 0; i < coordinate.length; i += 2) {
	    var x = coordinate.charCodeAt(i) - 64;
	    var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding
	
	    x = x >> 1 ^ -(x & 1);
	    y = y >> 1 ^ -(y & 1); // Delta deocding
	
	    x += prevX;
	    y += prevY;
	    prevX = x;
	    prevY = y; // Dequantize
	
	    result.push([x / encodeScale, y / encodeScale]);
	  }
	
	  return result;
	}
	/**
	 * @alias module:echarts/coord/geo/parseGeoJson
	 * @param {Object} geoJson
	 * @param {string} nameProperty
	 * @return {module:zrender/container/Group}
	 */
	
	
	function _default(geoJson, nameProperty) {
	  decode(geoJson);
	  return zrUtil.map(zrUtil.filter(geoJson.features, function (featureObj) {
	    // Output of mapshaper may have geometry null
	    return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
	  }), function (featureObj) {
	    var properties = featureObj.properties;
	    var geo = featureObj.geometry;
	    var coordinates = geo.coordinates;
	    var geometries = [];
	
	    if (geo.type === 'Polygon') {
	      geometries.push({
	        type: 'polygon',
	        // According to the GeoJSON specification.
	        // First must be exterior, and the rest are all interior(holes).
	        exterior: coordinates[0],
	        interiors: coordinates.slice(1)
	      });
	    }
	
	    if (geo.type === 'MultiPolygon') {
	      zrUtil.each(coordinates, function (item) {
	        if (item[0]) {
	          geometries.push({
	            type: 'polygon',
	            exterior: item[0],
	            interiors: item.slice(1)
	          });
	        }
	      });
	    }
	
	    var region = new Region(properties[nameProperty || 'name'], geometries, properties.cp);
	    region.properties = properties;
	    return region;
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BoundingRect = __webpack_require__(242);
	
	var bbox = __webpack_require__(273);
	
	var vec2 = __webpack_require__(222);
	
	var polygonContain = __webpack_require__(363);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/coord/geo/Region
	 */
	
	/**
	 * @param {string|Region} name
	 * @param {Array} geometries
	 * @param {Array.<number>} cp
	 */
	function Region(name, geometries, cp) {
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  this.name = name;
	  /**
	   * @type {Array.<Array>}
	   * @readOnly
	   */
	
	  this.geometries = geometries;
	
	  if (!cp) {
	    var rect = this.getBoundingRect();
	    cp = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  } else {
	    cp = [cp[0], cp[1]];
	  }
	  /**
	   * @type {Array.<number>}
	   */
	
	
	  this.center = cp;
	}
	
	Region.prototype = {
	  constructor: Region,
	  properties: null,
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function () {
	    var rect = this._rect;
	
	    if (rect) {
	      return rect;
	    }
	
	    var MAX_NUMBER = Number.MAX_VALUE;
	    var min = [MAX_NUMBER, MAX_NUMBER];
	    var max = [-MAX_NUMBER, -MAX_NUMBER];
	    var min2 = [];
	    var max2 = [];
	    var geometries = this.geometries;
	
	    for (var i = 0; i < geometries.length; i++) {
	      // Only support polygon
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      } // Doesn't consider hole
	
	
	      var exterior = geometries[i].exterior;
	      bbox.fromPoints(exterior, min2, max2);
	      vec2.min(min, min, min2);
	      vec2.max(max, max, max2);
	    } // No data
	
	
	    if (i === 0) {
	      min[0] = min[1] = max[0] = max[1] = 0;
	    }
	
	    return this._rect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	  },
	
	  /**
	   * @param {<Array.<number>} coord
	   * @return {boolean}
	   */
	  contain: function (coord) {
	    var rect = this.getBoundingRect();
	    var geometries = this.geometries;
	
	    if (!rect.contain(coord[0], coord[1])) {
	      return false;
	    }
	
	    loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
	      // Only support polygon.
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      }
	
	      var exterior = geometries[i].exterior;
	      var interiors = geometries[i].interiors;
	
	      if (polygonContain.contain(exterior, coord[0], coord[1])) {
	        // Not in the region if point is in the hole.
	        for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
	          if (polygonContain.contain(interiors[k])) {
	            continue loopGeo;
	          }
	        }
	
	        return true;
	      }
	    }
	
	    return false;
	  },
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var aspect = rect.width / rect.height;
	
	    if (!width) {
	      width = aspect * height;
	    } else if (!height) {
	      height = width / aspect;
	    }
	
	    var target = new BoundingRect(x, y, width, height);
	    var transform = rect.calculateTransform(target);
	    var geometries = this.geometries;
	
	    for (var i = 0; i < geometries.length; i++) {
	      // Only support polygon.
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      }
	
	      var exterior = geometries[i].exterior;
	      var interiors = geometries[i].interiors;
	
	      for (var p = 0; p < exterior.length; p++) {
	        vec2.applyTransform(exterior[p], exterior[p], transform);
	      }
	
	      for (var h = 0; h < (interiors ? interiors.length : 0); h++) {
	        for (var p = 0; p < interiors[h].length; p++) {
	          vec2.applyTransform(interiors[h][p], interiors[h][p], transform);
	        }
	      }
	    }
	
	    rect = this._rect;
	    rect.copy(target); // Update center
	
	    this.center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  },
	  cloneShallow: function (name) {
	    name == null && (name = this.name);
	    var newRegion = new Region(name, this.geometries, this.center);
	    newRegion._rect = this._rect;
	    newRegion.transformTo = null; // Simply avoid to be called.
	
	    return newRegion;
	  }
	};
	var _default = Region;
	module.exports = _default;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var windingLine = __webpack_require__(280);
	
	var EPSILON = 1e-8;
	
	function isAroundEqual(a, b) {
	  return Math.abs(a - b) < EPSILON;
	}
	
	function contain(points, x, y) {
	  var w = 0;
	  var p = points[0];
	
	  if (!p) {
	    return false;
	  }
	
	  for (var i = 1; i < points.length; i++) {
	    var p2 = points[i];
	    w += windingLine(p[0], p[1], p2[0], p2[1], x, y);
	    p = p2;
	  } // Close polygon
	
	
	  var p0 = points[0];
	
	  if (!isAroundEqual(p[0], p0[0]) || !isAroundEqual(p[1], p0[1])) {
	    w += windingLine(p[0], p[1], p0[0], p0[1], x, y);
	  }
	
	  return w !== 0;
	}
	
	exports.contain = contain;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	var map = _util.map;
	
	var _number = __webpack_require__(306);
	
	var linearMap = _number.linearMap;
	var getPixelPrecision = _number.getPixelPrecision;
	var round = _number.round;
	
	var _axisTickLabelBuilder = __webpack_require__(365);
	
	var createAxisTicks = _axisTickLabelBuilder.createAxisTicks;
	var createAxisLabels = _axisTickLabelBuilder.createAxisLabels;
	var calculateCategoryInterval = _axisTickLabelBuilder.calculateCategoryInterval;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NORMALIZED_EXTENT = [0, 1];
	/**
	 * Base class of Axis.
	 * @constructor
	 */
	
	var Axis = function (dim, scale, extent) {
	  /**
	   * Axis dimension. Such as 'x', 'y', 'z', 'angle', 'radius'.
	   * @type {string}
	   */
	  this.dim = dim;
	  /**
	   * Axis scale
	   * @type {module:echarts/coord/scale/*}
	   */
	
	  this.scale = scale;
	  /**
	   * @type {Array.<number>}
	   * @private
	   */
	
	  this._extent = extent || [0, 0];
	  /**
	   * @type {boolean}
	   */
	
	  this.inverse = false;
	  /**
	   * Usually true when axis has a ordinal scale
	   * @type {boolean}
	   */
	
	  this.onBand = false;
	};
	
	Axis.prototype = {
	  constructor: Axis,
	
	  /**
	   * If axis extent contain given coord
	   * @param {number} coord
	   * @return {boolean}
	   */
	  contain: function (coord) {
	    var extent = this._extent;
	    var min = Math.min(extent[0], extent[1]);
	    var max = Math.max(extent[0], extent[1]);
	    return coord >= min && coord <= max;
	  },
	
	  /**
	   * If axis extent contain given data
	   * @param {number} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this.scale.contain(data);
	  },
	
	  /**
	   * Get coord extent.
	   * @return {Array.<number>}
	   */
	  getExtent: function () {
	    return this._extent.slice();
	  },
	
	  /**
	   * Get precision used for formatting
	   * @param {Array.<number>} [dataExtent]
	   * @return {number}
	   */
	  getPixelPrecision: function (dataExtent) {
	    return getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
	  },
	
	  /**
	   * Set coord extent
	   * @param {number} start
	   * @param {number} end
	   */
	  setExtent: function (start, end) {
	    var extent = this._extent;
	    extent[0] = start;
	    extent[1] = end;
	  },
	
	  /**
	   * Convert data to coord. Data is the rank if it has an ordinal scale
	   * @param {number} data
	   * @param  {boolean} clamp
	   * @return {number}
	   */
	  dataToCoord: function (data, clamp) {
	    var extent = this._extent;
	    var scale = this.scale;
	    data = scale.normalize(data);
	
	    if (this.onBand && scale.type === 'ordinal') {
	      extent = extent.slice();
	      fixExtentWithBands(extent, scale.count());
	    }
	
	    return linearMap(data, NORMALIZED_EXTENT, extent, clamp);
	  },
	
	  /**
	   * Convert coord to data. Data is the rank if it has an ordinal scale
	   * @param {number} coord
	   * @param  {boolean} clamp
	   * @return {number}
	   */
	  coordToData: function (coord, clamp) {
	    var extent = this._extent;
	    var scale = this.scale;
	
	    if (this.onBand && scale.type === 'ordinal') {
	      extent = extent.slice();
	      fixExtentWithBands(extent, scale.count());
	    }
	
	    var t = linearMap(coord, extent, NORMALIZED_EXTENT, clamp);
	    return this.scale.scale(t);
	  },
	
	  /**
	   * Convert pixel point to data in axis
	   * @param {Array.<number>} point
	   * @param  {boolean} clamp
	   * @return {number} data
	   */
	  pointToData: function (point, clamp) {// Should be implemented in derived class if necessary.
	  },
	
	  /**
	   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
	   * `axis.getTicksCoords` considers `onBand`, which is used by
	   * `boundaryGap:true` of category axis and splitLine and splitArea.
	   * @param {Object} [opt]
	   * @param {Model} [opt.tickModel=axis.model.getModel('axisTick')]
	   * @param {boolean} [opt.clamp] If `true`, the first and the last
	   *        tick must be at the axis end points. Otherwise, clip ticks
	   *        that outside the axis extent.
	   * @return {Array.<Object>} [{
	   *     coord: ...,
	   *     tickValue: ...
	   * }, ...]
	   */
	  getTicksCoords: function (opt) {
	    opt = opt || {};
	    var tickModel = opt.tickModel || this.getTickModel();
	    var result = createAxisTicks(this, tickModel);
	    var ticks = result.ticks;
	    var ticksCoords = map(ticks, function (tickValue) {
	      return {
	        coord: this.dataToCoord(tickValue),
	        tickValue: tickValue
	      };
	    }, this);
	    var alignWithLabel = tickModel.get('alignWithLabel');
	    fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
	    return ticksCoords;
	  },
	
	  /**
	   * @return {Array.<Array.<Object>>} [{ coord: ..., tickValue: ...}]
	   */
	  getMinorTicksCoords: function () {
	    if (this.scale.type === 'ordinal') {
	      // Category axis doesn't support minor ticks
	      return [];
	    }
	
	    var minorTickModel = this.model.getModel('minorTick');
	    var splitNumber = minorTickModel.get('splitNumber'); // Protection.
	
	    if (!(splitNumber > 0 && splitNumber < 100)) {
	      splitNumber = 5;
	    }
	
	    var minorTicks = this.scale.getMinorTicks(splitNumber);
	    var minorTicksCoords = map(minorTicks, function (minorTicksGroup) {
	      return map(minorTicksGroup, function (minorTick) {
	        return {
	          coord: this.dataToCoord(minorTick),
	          tickValue: minorTick
	        };
	      }, this);
	    }, this);
	    return minorTicksCoords;
	  },
	
	  /**
	   * @return {Array.<Object>} [{
	   *     formattedLabel: string,
	   *     rawLabel: axis.scale.getLabel(tickValue)
	   *     tickValue: number
	   * }, ...]
	   */
	  getViewLabels: function () {
	    return createAxisLabels(this).labels;
	  },
	
	  /**
	   * @return {module:echarts/coord/model/Model}
	   */
	  getLabelModel: function () {
	    return this.model.getModel('axisLabel');
	  },
	
	  /**
	   * Notice here we only get the default tick model. For splitLine
	   * or splitArea, we should pass the splitLineModel or splitAreaModel
	   * manually when calling `getTicksCoords`.
	   * In GL, this method may be overrided to:
	   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
	   * @return {module:echarts/coord/model/Model}
	   */
	  getTickModel: function () {
	    return this.model.getModel('axisTick');
	  },
	
	  /**
	   * Get width of band
	   * @return {number}
	   */
	  getBandWidth: function () {
	    var axisExtent = this._extent;
	    var dataExtent = this.scale.getExtent();
	    var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.
	
	    len === 0 && (len = 1);
	    var size = Math.abs(axisExtent[1] - axisExtent[0]);
	    return Math.abs(size) / len;
	  },
	
	  /**
	   * @abstract
	   * @return {boolean} Is horizontal
	   */
	  isHorizontal: null,
	
	  /**
	   * @abstract
	   * @return {number} Get axis rotate, by degree.
	   */
	  getRotate: null,
	
	  /**
	   * Only be called in category axis.
	   * Can be overrided, consider other axes like in 3D.
	   * @return {number} Auto interval for cateogry axis tick and label
	   */
	  calculateCategoryInterval: function () {
	    return calculateCategoryInterval(this);
	  }
	};
	
	function fixExtentWithBands(extent, nTick) {
	  var size = extent[1] - extent[0];
	  var len = nTick;
	  var margin = size / len / 2;
	  extent[0] += margin;
	  extent[1] -= margin;
	} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
	// |---1---|---2---|---3---|---4---|.
	// So the displayed ticks and splitLine/splitArea should between
	// each data item, otherwise cause misleading (e.g., split tow bars
	// of a single data item when there are two bar series).
	// Also consider if tickCategoryInterval > 0 and onBand, ticks and
	// splitLine/spliteArea should layout appropriately corresponding
	// to displayed labels. (So we should not use `getBandWidth` in this
	// case).
	
	
	function fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
	  var ticksLen = ticksCoords.length;
	
	  if (!axis.onBand || alignWithLabel || !ticksLen) {
	    return;
	  }
	
	  var axisExtent = axis.getExtent();
	  var last;
	  var diffSize;
	
	  if (ticksLen === 1) {
	    ticksCoords[0].coord = axisExtent[0];
	    last = ticksCoords[1] = {
	      coord: axisExtent[0]
	    };
	  } else {
	    var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
	    var shift = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
	    each(ticksCoords, function (ticksItem) {
	      ticksItem.coord -= shift / 2;
	    });
	    var dataExtent = axis.scale.getExtent();
	    diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
	    last = {
	      coord: ticksCoords[ticksLen - 1].coord + shift * diffSize
	    };
	    ticksCoords.push(last);
	  }
	
	  var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.
	
	  if (littleThan(ticksCoords[0].coord, axisExtent[0])) {
	    clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
	  }
	
	  if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) {
	    ticksCoords.unshift({
	      coord: axisExtent[0]
	    });
	  }
	
	  if (littleThan(axisExtent[1], last.coord)) {
	    clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
	  }
	
	  if (clamp && littleThan(last.coord, axisExtent[1])) {
	    ticksCoords.push({
	      coord: axisExtent[1]
	    });
	  }
	
	  function littleThan(a, b) {
	    // Avoid rounding error cause calculated tick coord different with extent.
	    // It may cause an extra unecessary tick added.
	    a = round(a);
	    b = round(b);
	    return inverse ? a > b : a < b;
	  }
	}
	
	var _default = Axis;
	module.exports = _default;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var textContain = __webpack_require__(255);
	
	var _model = __webpack_require__(261);
	
	var makeInner = _model.makeInner;
	
	var _axisHelper = __webpack_require__(350);
	
	var makeLabelFormatter = _axisHelper.makeLabelFormatter;
	var getOptionCategoryInterval = _axisHelper.getOptionCategoryInterval;
	var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	/**
	 * @param {module:echats/coord/Axis} axis
	 * @return {Object} {
	 *     labels: [{
	 *         formattedLabel: string,
	 *         rawLabel: string,
	 *         tickValue: number
	 *     }, ...],
	 *     labelCategoryInterval: number
	 * }
	 */
	
	function createAxisLabels(axis) {
	  // Only ordinal scale support tick interval
	  return axis.type === 'category' ? makeCategoryLabels(axis) : makeRealNumberLabels(axis);
	}
	/**
	 * @param {module:echats/coord/Axis} axis
	 * @param {module:echarts/model/Model} tickModel For example, can be axisTick, splitLine, splitArea.
	 * @return {Object} {
	 *     ticks: Array.<number>
	 *     tickCategoryInterval: number
	 * }
	 */
	
	
	function createAxisTicks(axis, tickModel) {
	  // Only ordinal scale support tick interval
	  return axis.type === 'category' ? makeCategoryTicks(axis, tickModel) : {
	    ticks: axis.scale.getTicks()
	  };
	}
	
	function makeCategoryLabels(axis) {
	  var labelModel = axis.getLabelModel();
	  var result = makeCategoryLabelsActually(axis, labelModel);
	  return !labelModel.get('show') || axis.scale.isBlank() ? {
	    labels: [],
	    labelCategoryInterval: result.labelCategoryInterval
	  } : result;
	}
	
	function makeCategoryLabelsActually(axis, labelModel) {
	  var labelsCache = getListCache(axis, 'labels');
	  var optionLabelInterval = getOptionCategoryInterval(labelModel);
	  var result = listCacheGet(labelsCache, optionLabelInterval);
	
	  if (result) {
	    return result;
	  }
	
	  var labels;
	  var numericLabelInterval;
	
	  if (zrUtil.isFunction(optionLabelInterval)) {
	    labels = makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
	  } else {
	    numericLabelInterval = optionLabelInterval === 'auto' ? makeAutoCategoryInterval(axis) : optionLabelInterval;
	    labels = makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
	  } // Cache to avoid calling interval function repeatly.
	
	
	  return listCacheSet(labelsCache, optionLabelInterval, {
	    labels: labels,
	    labelCategoryInterval: numericLabelInterval
	  });
	}
	
	function makeCategoryTicks(axis, tickModel) {
	  var ticksCache = getListCache(axis, 'ticks');
	  var optionTickInterval = getOptionCategoryInterval(tickModel);
	  var result = listCacheGet(ticksCache, optionTickInterval);
	
	  if (result) {
	    return result;
	  }
	
	  var ticks;
	  var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
	  // we should not return all ticks.
	
	  if (!tickModel.get('show') || axis.scale.isBlank()) {
	    ticks = [];
	  }
	
	  if (zrUtil.isFunction(optionTickInterval)) {
	    ticks = makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
	  } // Always use label interval by default despite label show. Consider this
	  // scenario, Use multiple grid with the xAxis sync, and only one xAxis shows
	  // labels. `splitLine` and `axisTick` should be consistent in this case.
	  else if (optionTickInterval === 'auto') {
	      var labelsResult = makeCategoryLabelsActually(axis, axis.getLabelModel());
	      tickCategoryInterval = labelsResult.labelCategoryInterval;
	      ticks = zrUtil.map(labelsResult.labels, function (labelItem) {
	        return labelItem.tickValue;
	      });
	    } else {
	      tickCategoryInterval = optionTickInterval;
	      ticks = makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
	    } // Cache to avoid calling interval function repeatly.
	
	
	  return listCacheSet(ticksCache, optionTickInterval, {
	    ticks: ticks,
	    tickCategoryInterval: tickCategoryInterval
	  });
	}
	
	function makeRealNumberLabels(axis) {
	  var ticks = axis.scale.getTicks();
	  var labelFormatter = makeLabelFormatter(axis);
	  return {
	    labels: zrUtil.map(ticks, function (tickValue, idx) {
	      return {
	        formattedLabel: labelFormatter(tickValue, idx),
	        rawLabel: axis.scale.getLabel(tickValue),
	        tickValue: tickValue
	      };
	    })
	  };
	} // Large category data calculation is performence sensitive, and ticks and label
	// probably be fetched by multiple times. So we cache the result.
	// axis is created each time during a ec process, so we do not need to clear cache.
	
	
	function getListCache(axis, prop) {
	  // Because key can be funciton, and cache size always be small, we use array cache.
	  return inner(axis)[prop] || (inner(axis)[prop] = []);
	}
	
	function listCacheGet(cache, key) {
	  for (var i = 0; i < cache.length; i++) {
	    if (cache[i].key === key) {
	      return cache[i].value;
	    }
	  }
	}
	
	function listCacheSet(cache, key, value) {
	  cache.push({
	    key: key,
	    value: value
	  });
	  return value;
	}
	
	function makeAutoCategoryInterval(axis) {
	  var result = inner(axis).autoInterval;
	  return result != null ? result : inner(axis).autoInterval = axis.calculateCategoryInterval();
	}
	/**
	 * Calculate interval for category axis ticks and labels.
	 * To get precise result, at least one of `getRotate` and `isHorizontal`
	 * should be implemented in axis.
	 */
	
	
	function calculateCategoryInterval(axis) {
	  var params = fetchAutoCategoryIntervalCalculationParams(axis);
	  var labelFormatter = makeLabelFormatter(axis);
	  var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
	  var ordinalScale = axis.scale;
	  var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
	  // avoid generating a long array by `getTicks`
	  // in large category data case.
	
	  var tickCount = ordinalScale.count();
	
	  if (ordinalExtent[1] - ordinalExtent[0] < 1) {
	    return 0;
	  }
	
	  var step = 1; // Simple optimization. Empirical value: tick count should less than 40.
	
	  if (tickCount > 40) {
	    step = Math.max(1, Math.floor(tickCount / 40));
	  }
	
	  var tickValue = ordinalExtent[0];
	  var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
	  var unitW = Math.abs(unitSpan * Math.cos(rotation));
	  var unitH = Math.abs(unitSpan * Math.sin(rotation));
	  var maxW = 0;
	  var maxH = 0; // Caution: Performance sensitive for large category data.
	  // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
	
	  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
	    var width = 0;
	    var height = 0; // Not precise, do not consider align and vertical align
	    // and each distance from axis line yet.
	
	    var rect = textContain.getBoundingRect(labelFormatter(tickValue), params.font, 'center', 'top'); // Magic number
	
	    width = rect.width * 1.3;
	    height = rect.height * 1.3; // Min size, void long loop.
	
	    maxW = Math.max(maxW, width, 7);
	    maxH = Math.max(maxH, height, 7);
	  }
	
	  var dw = maxW / unitW;
	  var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
	
	  isNaN(dw) && (dw = Infinity);
	  isNaN(dh) && (dh = Infinity);
	  var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
	  var cache = inner(axis.model);
	  var axisExtent = axis.getExtent();
	  var lastAutoInterval = cache.lastAutoInterval;
	  var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
	  // otherwise the calculated interval might jitter when the zoom
	  // window size is close to the interval-changing size.
	  // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
	  // The jitter will cause that sometimes the displayed labels are
	  // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
	
	  if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
	  // point is not the same when zooming in or zooming out.
	  && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
	  // be used. Otherwise some hiden labels might not be shown again.
	  && cache.axisExtend0 === axisExtent[0] && cache.axisExtend1 === axisExtent[1]) {
	    interval = lastAutoInterval;
	  } // Only update cache if cache not used, otherwise the
	  // changing of interval is too insensitive.
	  else {
	      cache.lastTickCount = tickCount;
	      cache.lastAutoInterval = interval;
	      cache.axisExtend0 = axisExtent[0];
	      cache.axisExtend1 = axisExtent[1];
	    }
	
	  return interval;
	}
	
	function fetchAutoCategoryIntervalCalculationParams(axis) {
	  var labelModel = axis.getLabelModel();
	  return {
	    axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
	    labelRotate: labelModel.get('rotate') || 0,
	    font: labelModel.getFont()
	  };
	}
	
	function makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
	  var labelFormatter = makeLabelFormatter(axis);
	  var ordinalScale = axis.scale;
	  var ordinalExtent = ordinalScale.getExtent();
	  var labelModel = axis.getLabelModel();
	  var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
	
	  var step = Math.max((categoryInterval || 0) + 1, 1);
	  var startTick = ordinalExtent[0];
	  var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
	  // while zooming and moving while interval > 0. Otherwise the selection
	  // of displayable ticks and symbols probably keep changing.
	  // 3 is empirical value.
	
	  if (startTick !== 0 && step > 1 && tickCount / step > 2) {
	    startTick = Math.round(Math.ceil(startTick / step) * step);
	  } // (1) Only add min max label here but leave overlap checking
	  // to render stage, which also ensure the returned list
	  // suitable for splitLine and splitArea rendering.
	  // (2) Scales except category always contain min max label so
	  // do not need to perform this process.
	
	
	  var showAllLabel = shouldShowAllLabels(axis);
	  var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
	  var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
	
	  if (includeMinLabel && startTick !== ordinalExtent[0]) {
	    addItem(ordinalExtent[0]);
	  } // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
	
	
	  var tickValue = startTick;
	
	  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
	    addItem(tickValue);
	  }
	
	  if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) {
	    addItem(ordinalExtent[1]);
	  }
	
	  function addItem(tVal) {
	    result.push(onlyTick ? tVal : {
	      formattedLabel: labelFormatter(tVal),
	      rawLabel: ordinalScale.getLabel(tVal),
	      tickValue: tVal
	    });
	  }
	
	  return result;
	} // When interval is function, the result `false` means ignore the tick.
	// It is time consuming for large category data.
	
	
	function makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
	  var ordinalScale = axis.scale;
	  var labelFormatter = makeLabelFormatter(axis);
	  var result = [];
	  zrUtil.each(ordinalScale.getTicks(), function (tickValue) {
	    var rawLabel = ordinalScale.getLabel(tickValue);
	
	    if (categoryInterval(tickValue, rawLabel)) {
	      result.push(onlyTick ? tickValue : {
	        formattedLabel: labelFormatter(tickValue),
	        rawLabel: rawLabel,
	        tickValue: tickValue
	      });
	    }
	  });
	  return result;
	}
	
	exports.createAxisLabels = createAxisLabels;
	exports.createAxisTicks = createAxisTicks;
	exports.calculateCategoryInterval = calculateCategoryInterval;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(367);
	
	__webpack_require__(368);
	
	var visualSymbol = __webpack_require__(376);
	
	var layoutPoints = __webpack_require__(377);
	
	var dataSample = __webpack_require__(378);
	
	__webpack_require__(379);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerVisual(visualSymbol('line', 'circle', 'line'));
	echarts.registerLayout(layoutPoints('line')); // Down sample after filter
	
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, dataSample('line'));

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var createListFromArray = __webpack_require__(341);
	
	var SeriesModel = __webpack_require__(320);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.line',
	  dependencies: ['grid', 'polar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // stack: null
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // polarIndex: 0,
	    // If clip the overflow value
	    clip: true,
	    // cursor: null,
	    label: {
	      position: 'top'
	    },
	    // itemStyle: {
	    // },
	    lineStyle: {
	      width: 2,
	      type: 'solid'
	    },
	    // areaStyle: {
	    // origin of areaStyle. Valid values:
	    // `'auto'/null/undefined`: from axisLine to data
	    // `'start'`: from min to data
	    // `'end'`: from data to max
	    // origin: 'auto'
	    // },
	    // false, 'start', 'end', 'middle'
	    step: false,
	    // Disabled if step is true
	    smooth: false,
	    smoothMonotone: null,
	    symbol: 'emptyCircle',
	    symbolSize: 4,
	    symbolRotate: null,
	    showSymbol: true,
	    // `false`: follow the label interval strategy.
	    // `true`: show all symbols.
	    // `'auto'`: If possible, show all symbols, otherwise
	    //           follow the label interval strategy.
	    showAllSymbol: 'auto',
	    // Whether to connect break point.
	    connectNulls: false,
	    // Sampling for large data. Can be: 'average', 'max', 'min', 'sum'.
	    sampling: 'none',
	    animationEasing: 'linear',
	    // Disable progressive
	    progressive: 0,
	    hoverLayerThreshold: Infinity
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(220);
	
	var _bbox = __webpack_require__(273);
	
	var fromPoints = _bbox.fromPoints;
	
	var SymbolDraw = __webpack_require__(369);
	
	var SymbolClz = __webpack_require__(370);
	
	var lineAnimationDiff = __webpack_require__(372);
	
	var graphic = __webpack_require__(268);
	
	var modelUtil = __webpack_require__(261);
	
	var _poly = __webpack_require__(374);
	
	var Polyline = _poly.Polyline;
	var Polygon = _poly.Polygon;
	
	var ChartView = __webpack_require__(325);
	
	var _helper = __webpack_require__(373);
	
	var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
	var getStackedOnPoint = _helper.getStackedOnPoint;
	
	var _createClipPathFromCoordSys = __webpack_require__(375);
	
	var createGridClipPath = _createClipPathFromCoordSys.createGridClipPath;
	var createPolarClipPath = _createClipPathFromCoordSys.createPolarClipPath;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME step not support polar
	function isPointsSame(points1, points2) {
	  if (points1.length !== points2.length) {
	    return;
	  }
	
	  for (var i = 0; i < points1.length; i++) {
	    var p1 = points1[i];
	    var p2 = points2[i];
	
	    if (p1[0] !== p2[0] || p1[1] !== p2[1]) {
	      return;
	    }
	  }
	
	  return true;
	}
	
	function getBoundingDiff(points1, points2) {
	  var min1 = [];
	  var max1 = [];
	  var min2 = [];
	  var max2 = [];
	  fromPoints(points1, min1, max1);
	  fromPoints(points2, min2, max2); // Get a max value from each corner of two boundings.
	
	  return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
	}
	
	function getSmooth(smooth) {
	  return typeof smooth === 'number' ? smooth : smooth ? 0.5 : 0;
	}
	/**
	 * @param {module:echarts/coord/cartesian/Cartesian2D|module:echarts/coord/polar/Polar} coordSys
	 * @param {module:echarts/data/List} data
	 * @param {Object} dataCoordInfo
	 * @param {Array.<Array.<number>>} points
	 */
	
	
	function getStackedOnPoints(coordSys, data, dataCoordInfo) {
	  if (!dataCoordInfo.valueDim) {
	    return [];
	  }
	
	  var points = [];
	
	  for (var idx = 0, len = data.count(); idx < len; idx++) {
	    points.push(getStackedOnPoint(dataCoordInfo, coordSys, data, idx));
	  }
	
	  return points;
	}
	
	function turnPointsIntoStep(points, coordSys, stepTurnAt) {
	  var baseAxis = coordSys.getBaseAxis();
	  var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
	  var stepPoints = [];
	
	  for (var i = 0; i < points.length - 1; i++) {
	    var nextPt = points[i + 1];
	    var pt = points[i];
	    stepPoints.push(pt);
	    var stepPt = [];
	
	    switch (stepTurnAt) {
	      case 'end':
	        stepPt[baseIndex] = nextPt[baseIndex];
	        stepPt[1 - baseIndex] = pt[1 - baseIndex]; // default is start
	
	        stepPoints.push(stepPt);
	        break;
	
	      case 'middle':
	        // default is start
	        var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
	        var stepPt2 = [];
	        stepPt[baseIndex] = stepPt2[baseIndex] = middle;
	        stepPt[1 - baseIndex] = pt[1 - baseIndex];
	        stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
	        stepPoints.push(stepPt);
	        stepPoints.push(stepPt2);
	        break;
	
	      default:
	        stepPt[baseIndex] = pt[baseIndex];
	        stepPt[1 - baseIndex] = nextPt[1 - baseIndex]; // default is start
	
	        stepPoints.push(stepPt);
	    }
	  } // Last points
	
	
	  points[i] && stepPoints.push(points[i]);
	  return stepPoints;
	}
	
	function getVisualGradient(data, coordSys) {
	  var visualMetaList = data.getVisual('visualMeta');
	
	  if (!visualMetaList || !visualMetaList.length || !data.count()) {
	    // When data.count() is 0, gradient range can not be calculated.
	    return;
	  }
	
	  if (coordSys.type !== 'cartesian2d') {
	    return;
	  }
	
	  var coordDim;
	  var visualMeta;
	
	  for (var i = visualMetaList.length - 1; i >= 0; i--) {
	    var dimIndex = visualMetaList[i].dimension;
	    var dimName = data.dimensions[dimIndex];
	    var dimInfo = data.getDimensionInfo(dimName);
	    coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y
	
	    if (coordDim === 'x' || coordDim === 'y') {
	      visualMeta = visualMetaList[i];
	      break;
	    }
	  }
	
	  if (!visualMeta) {
	    return;
	  } // If the area to be rendered is bigger than area defined by LinearGradient,
	  // the canvas spec prescribes that the color of the first stop and the last
	  // stop should be used. But if two stops are added at offset 0, in effect
	  // browsers use the color of the second stop to render area outside
	  // LinearGradient. So we can only infinitesimally extend area defined in
	  // LinearGradient to render `outerColors`.
	
	
	  var axis = coordSys.getAxis(coordDim); // dataToCoor mapping may not be linear, but must be monotonic.
	
	  var colorStops = zrUtil.map(visualMeta.stops, function (stop) {
	    return {
	      coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
	      color: stop.color
	    };
	  });
	  var stopLen = colorStops.length;
	  var outerColors = visualMeta.outerColors.slice();
	
	  if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
	    colorStops.reverse();
	    outerColors.reverse();
	  }
	
	  var tinyExtent = 10; // Arbitrary value: 10px
	
	  var minCoord = colorStops[0].coord - tinyExtent;
	  var maxCoord = colorStops[stopLen - 1].coord + tinyExtent;
	  var coordSpan = maxCoord - minCoord;
	
	  if (coordSpan < 1e-3) {
	    return 'transparent';
	  }
	
	  zrUtil.each(colorStops, function (stop) {
	    stop.offset = (stop.coord - minCoord) / coordSpan;
	  });
	  colorStops.push({
	    offset: stopLen ? colorStops[stopLen - 1].offset : 0.5,
	    color: outerColors[1] || 'transparent'
	  });
	  colorStops.unshift({
	    // notice colorStops.length have been changed.
	    offset: stopLen ? colorStops[0].offset : 0.5,
	    color: outerColors[0] || 'transparent'
	  }); // zrUtil.each(colorStops, function (colorStop) {
	  //     // Make sure each offset has rounded px to avoid not sharp edge
	  //     colorStop.offset = (Math.round(colorStop.offset * (end - start) + start) - start) / (end - start);
	  // });
	
	  var gradient = new graphic.LinearGradient(0, 0, 0, 0, colorStops, true);
	  gradient[coordDim] = minCoord;
	  gradient[coordDim + '2'] = maxCoord;
	  return gradient;
	}
	
	function getIsIgnoreFunc(seriesModel, data, coordSys) {
	  var showAllSymbol = seriesModel.get('showAllSymbol');
	  var isAuto = showAllSymbol === 'auto';
	
	  if (showAllSymbol && !isAuto) {
	    return;
	  }
	
	  var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	  if (!categoryAxis) {
	    return;
	  } // Note that category label interval strategy might bring some weird effect
	  // in some scenario: users may wonder why some of the symbols are not
	  // displayed. So we show all symbols as possible as we can.
	
	
	  if (isAuto // Simplify the logic, do not determine label overlap here.
	  && canShowAllSymbolForCategory(categoryAxis, data)) {
	    return;
	  } // Otherwise follow the label interval strategy on category axis.
	
	
	  var categoryDataDim = data.mapDimension(categoryAxis.dim);
	  var labelMap = {};
	  zrUtil.each(categoryAxis.getViewLabels(), function (labelItem) {
	    labelMap[labelItem.tickValue] = 1;
	  });
	  return function (dataIndex) {
	    return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
	  };
	}
	
	function canShowAllSymbolForCategory(categoryAxis, data) {
	  // In mose cases, line is monotonous on category axis, and the label size
	  // is close with each other. So we check the symbol size and some of the
	  // label size alone with the category axis to estimate whether all symbol
	  // can be shown without overlap.
	  var axisExtent = categoryAxis.getExtent();
	  var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
	  isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
	  // Sampling some points, max 5.
	
	  var dataLen = data.count();
	  var step = Math.max(1, Math.round(dataLen / 5));
	
	  for (var dataIndex = 0; dataIndex < dataLen; dataIndex += step) {
	    if (SymbolClz.getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
	    )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
	    * 1.5 > availSize) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function createLineClipPath(coordSys, hasAnimation, seriesModel) {
	  if (coordSys.type === 'cartesian2d') {
	    var isHorizontal = coordSys.getBaseAxis().isHorizontal();
	    var clipPath = createGridClipPath(coordSys, hasAnimation, seriesModel); // Expand clip shape to avoid clipping when line value exceeds axis
	
	    if (!seriesModel.get('clip', true)) {
	      var rectShape = clipPath.shape;
	      var expandSize = Math.max(rectShape.width, rectShape.height);
	
	      if (isHorizontal) {
	        rectShape.y -= expandSize;
	        rectShape.height += expandSize * 2;
	      } else {
	        rectShape.x -= expandSize;
	        rectShape.width += expandSize * 2;
	      }
	    }
	
	    return clipPath;
	  } else {
	    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
	  }
	}
	
	var _default = ChartView.extend({
	  type: 'line',
	  init: function () {
	    var lineGroup = new graphic.Group();
	    var symbolDraw = new SymbolDraw();
	    this.group.add(symbolDraw.group);
	    this._symbolDraw = symbolDraw;
	    this._lineGroup = lineGroup;
	  },
	  render: function (seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var group = this.group;
	    var data = seriesModel.getData();
	    var lineStyleModel = seriesModel.getModel('lineStyle');
	    var areaStyleModel = seriesModel.getModel('areaStyle');
	    var points = data.mapArray(data.getItemLayout);
	    var isCoordSysPolar = coordSys.type === 'polar';
	    var prevCoordSys = this._coordSys;
	    var symbolDraw = this._symbolDraw;
	    var polyline = this._polyline;
	    var polygon = this._polygon;
	    var lineGroup = this._lineGroup;
	    var hasAnimation = seriesModel.get('animation');
	    var isAreaChart = !areaStyleModel.isEmpty();
	    var valueOrigin = areaStyleModel.get('origin');
	    var dataCoordInfo = prepareDataCoordInfo(coordSys, data, valueOrigin);
	    var stackedOnPoints = getStackedOnPoints(coordSys, data, dataCoordInfo);
	    var showSymbol = seriesModel.get('showSymbol');
	    var isIgnoreFunc = showSymbol && !isCoordSysPolar && getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols
	
	    var oldData = this._data;
	    oldData && oldData.eachItemGraphicEl(function (el, idx) {
	      if (el.__temp) {
	        group.remove(el);
	        oldData.setItemGraphicEl(idx, null);
	      }
	    }); // Remove previous created symbols if showSymbol changed to false
	
	    if (!showSymbol) {
	      symbolDraw.remove();
	    }
	
	    group.add(lineGroup); // FIXME step not support polar
	
	    var step = !isCoordSysPolar && seriesModel.get('step');
	    var clipShapeForSymbol;
	
	    if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
	      clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
	      // See #7913 and `test/dataZoom-clip.html`.
	
	      if (clipShapeForSymbol.width != null) {
	        clipShapeForSymbol.x -= 0.1;
	        clipShapeForSymbol.y -= 0.1;
	        clipShapeForSymbol.width += 0.2;
	        clipShapeForSymbol.height += 0.2;
	      } else if (clipShapeForSymbol.r0) {
	        clipShapeForSymbol.r0 -= 0.5;
	        clipShapeForSymbol.r1 += 0.5;
	      }
	    }
	
	    this._clipShapeForSymbol = clipShapeForSymbol; // Initialization animation or coordinate system changed
	
	    if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
	      showSymbol && symbolDraw.updateData(data, {
	        isIgnore: isIgnoreFunc,
	        clipShape: clipShapeForSymbol
	      });
	
	      if (step) {
	        // TODO If stacked series is not step
	        points = turnPointsIntoStep(points, coordSys, step);
	        stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
	      }
	
	      polyline = this._newPolyline(points, coordSys, hasAnimation);
	
	      if (isAreaChart) {
	        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
	      }
	
	      lineGroup.setClipPath(createLineClipPath(coordSys, true, seriesModel));
	    } else {
	      if (isAreaChart && !polygon) {
	        // If areaStyle is added
	        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
	      } else if (polygon && !isAreaChart) {
	        // If areaStyle is removed
	        lineGroup.remove(polygon);
	        polygon = this._polygon = null;
	      } // Update clipPath
	
	
	      lineGroup.setClipPath(createLineClipPath(coordSys, false, seriesModel)); // Always update, or it is wrong in the case turning on legend
	      // because points are not changed
	
	      showSymbol && symbolDraw.updateData(data, {
	        isIgnore: isIgnoreFunc,
	        clipShape: clipShapeForSymbol
	      }); // Stop symbol animation and sync with line points
	      // FIXME performance?
	
	      data.eachItemGraphicEl(function (el) {
	        el.stopAnimation(true);
	      }); // In the case data zoom triggerred refreshing frequently
	      // Data may not change if line has a category axis. So it should animate nothing
	
	      if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
	        if (hasAnimation) {
	          this._updateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
	        } else {
	          // Not do it in update with animation
	          if (step) {
	            // TODO If stacked series is not step
	            points = turnPointsIntoStep(points, coordSys, step);
	            stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
	          }
	
	          polyline.setShape({
	            points: points
	          });
	          polygon && polygon.setShape({
	            points: points,
	            stackedOnPoints: stackedOnPoints
	          });
	        }
	      }
	    }
	
	    var visualColor = getVisualGradient(data, coordSys) || data.getVisual('color');
	    polyline.useStyle(zrUtil.defaults( // Use color in lineStyle first
	    lineStyleModel.getLineStyle(), {
	      fill: 'none',
	      stroke: visualColor,
	      lineJoin: 'bevel'
	    }));
	    var smooth = seriesModel.get('smooth');
	    smooth = getSmooth(seriesModel.get('smooth'));
	    polyline.setShape({
	      smooth: smooth,
	      smoothMonotone: seriesModel.get('smoothMonotone'),
	      connectNulls: seriesModel.get('connectNulls')
	    });
	
	    if (polygon) {
	      var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
	      var stackedOnSmooth = 0;
	      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
	        fill: visualColor,
	        opacity: 0.7,
	        lineJoin: 'bevel'
	      }));
	
	      if (stackedOnSeries) {
	        stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
	      }
	
	      polygon.setShape({
	        smooth: smooth,
	        stackedOnSmooth: stackedOnSmooth,
	        smoothMonotone: seriesModel.get('smoothMonotone'),
	        connectNulls: seriesModel.get('connectNulls')
	      });
	    }
	
	    this._data = data; // Save the coordinate system for transition animation when data changed
	
	    this._coordSys = coordSys;
	    this._stackedOnPoints = stackedOnPoints;
	    this._points = points;
	    this._step = step;
	    this._valueOrigin = valueOrigin;
	  },
	  dispose: function () {},
	  highlight: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	    if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
	      var symbol = data.getItemGraphicEl(dataIndex);
	
	      if (!symbol) {
	        // Create a temporary symbol if it is not exists
	        var pt = data.getItemLayout(dataIndex);
	
	        if (!pt) {
	          // Null data
	          return;
	        } // fix #11360: should't draw symbol outside clipShapeForSymbol
	
	
	        if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(pt[0], pt[1])) {
	          return;
	        }
	
	        symbol = new SymbolClz(data, dataIndex);
	        symbol.position = pt;
	        symbol.setZ(seriesModel.get('zlevel'), seriesModel.get('z'));
	        symbol.ignore = isNaN(pt[0]) || isNaN(pt[1]);
	        symbol.__temp = true;
	        data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation
	
	        symbol.stopSymbolAnimation(true);
	        this.group.add(symbol);
	      }
	
	      symbol.highlight();
	    } else {
	      // Highlight whole series
	      ChartView.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
	    }
	  },
	  downplay: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	    if (dataIndex != null && dataIndex >= 0) {
	      var symbol = data.getItemGraphicEl(dataIndex);
	
	      if (symbol) {
	        if (symbol.__temp) {
	          data.setItemGraphicEl(dataIndex, null);
	          this.group.remove(symbol);
	        } else {
	          symbol.downplay();
	        }
	      }
	    } else {
	      // FIXME
	      // can not downplay completely.
	      // Downplay whole series
	      ChartView.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
	    }
	  },
	
	  /**
	   * @param {module:zrender/container/Group} group
	   * @param {Array.<Array.<number>>} points
	   * @private
	   */
	  _newPolyline: function (points) {
	    var polyline = this._polyline; // Remove previous created polyline
	
	    if (polyline) {
	      this._lineGroup.remove(polyline);
	    }
	
	    polyline = new Polyline({
	      shape: {
	        points: points
	      },
	      silent: true,
	      z2: 10
	    });
	
	    this._lineGroup.add(polyline);
	
	    this._polyline = polyline;
	    return polyline;
	  },
	
	  /**
	   * @param {module:zrender/container/Group} group
	   * @param {Array.<Array.<number>>} stackedOnPoints
	   * @param {Array.<Array.<number>>} points
	   * @private
	   */
	  _newPolygon: function (points, stackedOnPoints) {
	    var polygon = this._polygon; // Remove previous created polygon
	
	    if (polygon) {
	      this._lineGroup.remove(polygon);
	    }
	
	    polygon = new Polygon({
	      shape: {
	        points: points,
	        stackedOnPoints: stackedOnPoints
	      },
	      silent: true
	    });
	
	    this._lineGroup.add(polygon);
	
	    this._polygon = polygon;
	    return polygon;
	  },
	
	  /**
	   * @private
	   */
	  // FIXME Two value axis
	  _updateAnimation: function (data, stackedOnPoints, coordSys, api, step, valueOrigin) {
	    var polyline = this._polyline;
	    var polygon = this._polygon;
	    var seriesModel = data.hostModel;
	    var diff = lineAnimationDiff(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
	    var current = diff.current;
	    var stackedOnCurrent = diff.stackedOnCurrent;
	    var next = diff.next;
	    var stackedOnNext = diff.stackedOnNext;
	
	    if (step) {
	      // TODO If stacked series is not step
	      current = turnPointsIntoStep(diff.current, coordSys, step);
	      stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
	      next = turnPointsIntoStep(diff.next, coordSys, step);
	      stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
	    } // Don't apply animation if diff is large.
	    // For better result and avoid memory explosion problems like
	    // https://github.com/apache/incubator-echarts/issues/12229
	
	
	    if (getBoundingDiff(current, next) > 3000 || polygon && getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
	      polyline.setShape({
	        points: next
	      });
	
	      if (polygon) {
	        polygon.setShape({
	          points: next,
	          stackedOnPoints: stackedOnNext
	        });
	      }
	
	      return;
	    } // `diff.current` is subset of `current` (which should be ensured by
	    // turnPointsIntoStep), so points in `__points` can be updated when
	    // points in `current` are update during animation.
	
	
	    polyline.shape.__points = diff.current;
	    polyline.shape.points = current;
	    graphic.updateProps(polyline, {
	      shape: {
	        points: next
	      }
	    }, seriesModel);
	
	    if (polygon) {
	      polygon.setShape({
	        points: current,
	        stackedOnPoints: stackedOnCurrent
	      });
	      graphic.updateProps(polygon, {
	        shape: {
	          points: next,
	          stackedOnPoints: stackedOnNext
	        }
	      }, seriesModel);
	    }
	
	    var updatedDataInfo = [];
	    var diffStatus = diff.status;
	
	    for (var i = 0; i < diffStatus.length; i++) {
	      var cmd = diffStatus[i].cmd;
	
	      if (cmd === '=') {
	        var el = data.getItemGraphicEl(diffStatus[i].idx1);
	
	        if (el) {
	          updatedDataInfo.push({
	            el: el,
	            ptIdx: i // Index of points
	
	          });
	        }
	      }
	    }
	
	    if (polyline.animators && polyline.animators.length) {
	      polyline.animators[0].during(function () {
	        for (var i = 0; i < updatedDataInfo.length; i++) {
	          var el = updatedDataInfo[i].el;
	          el.attr('position', polyline.shape.__points[updatedDataInfo[i].ptIdx]);
	        }
	      });
	    }
	  },
	  remove: function (ecModel) {
	    var group = this.group;
	    var oldData = this._data;
	
	    this._lineGroup.removeAll();
	
	    this._symbolDraw.remove(true); // Remove temporary created elements when highlighting
	
	
	    oldData && oldData.eachItemGraphicEl(function (el, idx) {
	      if (el.__temp) {
	        group.remove(el);
	        oldData.setItemGraphicEl(idx, null);
	      }
	    });
	    this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._data = null;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var SymbolClz = __webpack_require__(370);
	
	var _util = __webpack_require__(220);
	
	var isObject = _util.isObject;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/SymbolDraw
	 */
	
	/**
	 * @constructor
	 * @alias module:echarts/chart/helper/SymbolDraw
	 * @param {module:zrender/graphic/Group} [symbolCtor]
	 */
	function SymbolDraw(symbolCtor) {
	  this.group = new graphic.Group();
	  this._symbolCtor = symbolCtor || SymbolClz;
	}
	
	var symbolDrawProto = SymbolDraw.prototype;
	
	function symbolNeedsDraw(data, point, idx, opt) {
	  return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) // We do not set clipShape on group, because it will cut part of
	  // the symbol element shape. We use the same clip shape here as
	  // the line clip.
	  && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
	}
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} [opt] Or isIgnore
	 * @param {Function} [opt.isIgnore]
	 * @param {Object} [opt.clipShape]
	 */
	
	
	symbolDrawProto.updateData = function (data, opt) {
	  opt = normalizeUpdateOpt(opt);
	  var group = this.group;
	  var seriesModel = data.hostModel;
	  var oldData = this._data;
	  var SymbolCtor = this._symbolCtor;
	  var seriesScope = makeSeriesScope(data); // There is no oldLineData only when first rendering or switching from
	  // stream mode to normal mode, where previous elements should be removed.
	
	  if (!oldData) {
	    group.removeAll();
	  }
	
	  data.diff(oldData).add(function (newIdx) {
	    var point = data.getItemLayout(newIdx);
	
	    if (symbolNeedsDraw(data, point, newIdx, opt)) {
	      var symbolEl = new SymbolCtor(data, newIdx, seriesScope);
	      symbolEl.attr('position', point);
	      data.setItemGraphicEl(newIdx, symbolEl);
	      group.add(symbolEl);
	    }
	  }).update(function (newIdx, oldIdx) {
	    var symbolEl = oldData.getItemGraphicEl(oldIdx);
	    var point = data.getItemLayout(newIdx);
	
	    if (!symbolNeedsDraw(data, point, newIdx, opt)) {
	      group.remove(symbolEl);
	      return;
	    }
	
	    if (!symbolEl) {
	      symbolEl = new SymbolCtor(data, newIdx);
	      symbolEl.attr('position', point);
	    } else {
	      symbolEl.updateData(data, newIdx, seriesScope);
	      graphic.updateProps(symbolEl, {
	        position: point
	      }, seriesModel);
	    } // Add back
	
	
	    group.add(symbolEl);
	    data.setItemGraphicEl(newIdx, symbolEl);
	  }).remove(function (oldIdx) {
	    var el = oldData.getItemGraphicEl(oldIdx);
	    el && el.fadeOut(function () {
	      group.remove(el);
	    });
	  }).execute();
	  this._data = data;
	};
	
	symbolDrawProto.isPersistent = function () {
	  return true;
	};
	
	symbolDrawProto.updateLayout = function () {
	  var data = this._data;
	
	  if (data) {
	    // Not use animation
	    data.eachItemGraphicEl(function (el, idx) {
	      var point = data.getItemLayout(idx);
	      el.attr('position', point);
	    });
	  }
	};
	
	symbolDrawProto.incrementalPrepareUpdate = function (data) {
	  this._seriesScope = makeSeriesScope(data);
	  this._data = null;
	  this.group.removeAll();
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} [opt] Or isIgnore
	 * @param {Function} [opt.isIgnore]
	 * @param {Object} [opt.clipShape]
	 */
	
	
	symbolDrawProto.incrementalUpdate = function (taskParams, data, opt) {
	  opt = normalizeUpdateOpt(opt);
	
	  function updateIncrementalAndHover(el) {
	    if (!el.isGroup) {
	      el.incremental = el.useHoverLayer = true;
	    }
	  }
	
	  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
	    var point = data.getItemLayout(idx);
	
	    if (symbolNeedsDraw(data, point, idx, opt)) {
	      var el = new this._symbolCtor(data, idx, this._seriesScope);
	      el.traverse(updateIncrementalAndHover);
	      el.attr('position', point);
	      this.group.add(el);
	      data.setItemGraphicEl(idx, el);
	    }
	  }
	};
	
	function normalizeUpdateOpt(opt) {
	  if (opt != null && !isObject(opt)) {
	    opt = {
	      isIgnore: opt
	    };
	  }
	
	  return opt || {};
	}
	
	symbolDrawProto.remove = function (enableAnimation) {
	  var group = this.group;
	  var data = this._data; // Incremental model do not have this._data.
	
	  if (data && enableAnimation) {
	    data.eachItemGraphicEl(function (el) {
	      el.fadeOut(function () {
	        group.remove(el);
	      });
	    });
	  } else {
	    group.removeAll();
	  }
	};
	
	function makeSeriesScope(data) {
	  var seriesModel = data.hostModel;
	  return {
	    itemStyle: seriesModel.getModel('itemStyle').getItemStyle(['color']),
	    hoverItemStyle: seriesModel.getModel('emphasis.itemStyle').getItemStyle(),
	    symbolRotate: seriesModel.get('symbolRotate'),
	    symbolOffset: seriesModel.get('symbolOffset'),
	    hoverAnimation: seriesModel.get('hoverAnimation'),
	    labelModel: seriesModel.getModel('label'),
	    hoverLabelModel: seriesModel.getModel('emphasis.label'),
	    cursorStyle: seriesModel.get('cursor')
	  };
	}
	
	var _default = SymbolDraw;
	module.exports = _default;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var _symbol = __webpack_require__(360);
	
	var createSymbol = _symbol.createSymbol;
	
	var graphic = __webpack_require__(268);
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	
	var _labelHelper = __webpack_require__(371);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Symbol
	 */
	
	/**
	 * @constructor
	 * @alias {module:echarts/chart/helper/Symbol}
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @extends {module:zrender/graphic/Group}
	 */
	function SymbolClz(data, idx, seriesScope) {
	  graphic.Group.call(this);
	  this.updateData(data, idx, seriesScope);
	}
	
	var symbolProto = SymbolClz.prototype;
	/**
	 * @public
	 * @static
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @return {Array.<number>} [width, height]
	 */
	
	var getSymbolSize = SymbolClz.getSymbolSize = function (data, idx) {
	  var symbolSize = data.getItemVisual(idx, 'symbolSize');
	  return symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
	};
	
	function getScale(symbolSize) {
	  return [symbolSize[0] / 2, symbolSize[1] / 2];
	}
	
	function driftSymbol(dx, dy) {
	  this.parent.drift(dx, dy);
	}
	
	symbolProto._createSymbol = function (symbolType, data, idx, symbolSize, keepAspect) {
	  // Remove paths created before
	  this.removeAll();
	  var color = data.getItemVisual(idx, 'color'); // var symbolPath = createSymbol(
	  //     symbolType, -0.5, -0.5, 1, 1, color
	  // );
	  // If width/height are set too small (e.g., set to 1) on ios10
	  // and macOS Sierra, a circle stroke become a rect, no matter what
	  // the scale is set. So we set width/height as 2. See #4150.
	
	  var symbolPath = createSymbol(symbolType, -1, -1, 2, 2, color, keepAspect);
	  symbolPath.attr({
	    z2: 100,
	    culling: true,
	    scale: getScale(symbolSize)
	  }); // Rewrite drift method
	
	  symbolPath.drift = driftSymbol;
	  this._symbolType = symbolType;
	  this.add(symbolPath);
	};
	/**
	 * Stop animation
	 * @param {boolean} toLastFrame
	 */
	
	
	symbolProto.stopSymbolAnimation = function (toLastFrame) {
	  this.childAt(0).stopAnimation(toLastFrame);
	};
	/**
	 * FIXME:
	 * Caution: This method breaks the encapsulation of this module,
	 * but it indeed brings convenience. So do not use the method
	 * unless you detailedly know all the implements of `Symbol`,
	 * especially animation.
	 *
	 * Get symbol path element.
	 */
	
	
	symbolProto.getSymbolPath = function () {
	  return this.childAt(0);
	};
	/**
	 * Get scale(aka, current symbol size).
	 * Including the change caused by animation
	 */
	
	
	symbolProto.getScale = function () {
	  return this.childAt(0).scale;
	};
	/**
	 * Highlight symbol
	 */
	
	
	symbolProto.highlight = function () {
	  this.childAt(0).trigger('emphasis');
	};
	/**
	 * Downplay symbol
	 */
	
	
	symbolProto.downplay = function () {
	  this.childAt(0).trigger('normal');
	};
	/**
	 * @param {number} zlevel
	 * @param {number} z
	 */
	
	
	symbolProto.setZ = function (zlevel, z) {
	  var symbolPath = this.childAt(0);
	  symbolPath.zlevel = zlevel;
	  symbolPath.z = z;
	};
	
	symbolProto.setDraggable = function (draggable) {
	  var symbolPath = this.childAt(0);
	  symbolPath.draggable = draggable;
	  symbolPath.cursor = draggable ? 'move' : symbolPath.cursor;
	};
	/**
	 * Update symbol properties
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Object} [seriesScope]
	 * @param {Object} [seriesScope.itemStyle]
	 * @param {Object} [seriesScope.hoverItemStyle]
	 * @param {Object} [seriesScope.symbolRotate]
	 * @param {Object} [seriesScope.symbolOffset]
	 * @param {module:echarts/model/Model} [seriesScope.labelModel]
	 * @param {module:echarts/model/Model} [seriesScope.hoverLabelModel]
	 * @param {boolean} [seriesScope.hoverAnimation]
	 * @param {Object} [seriesScope.cursorStyle]
	 * @param {module:echarts/model/Model} [seriesScope.itemModel]
	 * @param {string} [seriesScope.symbolInnerColor]
	 * @param {Object} [seriesScope.fadeIn=false]
	 */
	
	
	symbolProto.updateData = function (data, idx, seriesScope) {
	  this.silent = false;
	  var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	  var seriesModel = data.hostModel;
	  var symbolSize = getSymbolSize(data, idx);
	  var isInit = symbolType !== this._symbolType;
	
	  if (isInit) {
	    var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
	
	    this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
	  } else {
	    var symbolPath = this.childAt(0);
	    symbolPath.silent = false;
	    graphic.updateProps(symbolPath, {
	      scale: getScale(symbolSize)
	    }, seriesModel, idx);
	  }
	
	  this._updateCommon(data, idx, symbolSize, seriesScope);
	
	  if (isInit) {
	    var symbolPath = this.childAt(0);
	    var fadeIn = seriesScope && seriesScope.fadeIn;
	    var target = {
	      scale: symbolPath.scale.slice()
	    };
	    fadeIn && (target.style = {
	      opacity: symbolPath.style.opacity
	    });
	    symbolPath.scale = [0, 0];
	    fadeIn && (symbolPath.style.opacity = 0);
	    graphic.initProps(symbolPath, target, seriesModel, idx);
	  }
	
	  this._seriesModel = seriesModel;
	}; // Update common properties
	
	
	var normalStyleAccessPath = ['itemStyle'];
	var emphasisStyleAccessPath = ['emphasis', 'itemStyle'];
	var normalLabelAccessPath = ['label'];
	var emphasisLabelAccessPath = ['emphasis', 'label'];
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Array.<number>} symbolSize
	 * @param {Object} [seriesScope]
	 */
	
	symbolProto._updateCommon = function (data, idx, symbolSize, seriesScope) {
	  var symbolPath = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var color = data.getItemVisual(idx, 'color'); // Reset style
	
	  if (symbolPath.type !== 'image') {
	    symbolPath.useStyle({
	      strokeNoScale: true
	    });
	  } else {
	    symbolPath.setStyle({
	      opacity: 1,
	      shadowBlur: null,
	      shadowOffsetX: null,
	      shadowOffsetY: null,
	      shadowColor: null
	    });
	  }
	
	  var itemStyle = seriesScope && seriesScope.itemStyle;
	  var hoverItemStyle = seriesScope && seriesScope.hoverItemStyle;
	  var symbolOffset = seriesScope && seriesScope.symbolOffset;
	  var labelModel = seriesScope && seriesScope.labelModel;
	  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel;
	  var hoverAnimation = seriesScope && seriesScope.hoverAnimation;
	  var cursorStyle = seriesScope && seriesScope.cursorStyle;
	
	  if (!seriesScope || data.hasItemOption) {
	    var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx); // Color must be excluded.
	    // Because symbol provide setColor individually to set fill and stroke
	
	    itemStyle = itemModel.getModel(normalStyleAccessPath).getItemStyle(['color']);
	    hoverItemStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
	    symbolOffset = itemModel.getShallow('symbolOffset');
	    labelModel = itemModel.getModel(normalLabelAccessPath);
	    hoverLabelModel = itemModel.getModel(emphasisLabelAccessPath);
	    hoverAnimation = itemModel.getShallow('hoverAnimation');
	    cursorStyle = itemModel.getShallow('cursor');
	  } else {
	    hoverItemStyle = zrUtil.extend({}, hoverItemStyle);
	  }
	
	  var elStyle = symbolPath.style;
	  var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
	  symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
	
	  if (symbolOffset) {
	    symbolPath.attr('position', [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])]);
	  }
	
	  cursorStyle && symbolPath.attr('cursor', cursorStyle); // PENDING setColor before setStyle!!!
	
	  symbolPath.setColor(color, seriesScope && seriesScope.symbolInnerColor);
	  symbolPath.setStyle(itemStyle);
	  var opacity = data.getItemVisual(idx, 'opacity');
	
	  if (opacity != null) {
	    elStyle.opacity = opacity;
	  }
	
	  var liftZ = data.getItemVisual(idx, 'liftZ');
	  var z2Origin = symbolPath.__z2Origin;
	
	  if (liftZ != null) {
	    if (z2Origin == null) {
	      symbolPath.__z2Origin = symbolPath.z2;
	      symbolPath.z2 += liftZ;
	    }
	  } else if (z2Origin != null) {
	    symbolPath.z2 = z2Origin;
	    symbolPath.__z2Origin = null;
	  }
	
	  var useNameLabel = seriesScope && seriesScope.useNameLabel;
	  graphic.setLabelStyle(elStyle, hoverItemStyle, labelModel, hoverLabelModel, {
	    labelFetcher: seriesModel,
	    labelDataIndex: idx,
	    defaultText: getLabelDefaultText,
	    isRectText: true,
	    autoColor: color
	  }); // Do not execute util needed.
	
	  function getLabelDefaultText(idx, opt) {
	    return useNameLabel ? data.getName(idx) : getDefaultLabel(data, idx);
	  }
	
	  symbolPath.__symbolOriginalScale = getScale(symbolSize);
	  symbolPath.hoverStyle = hoverItemStyle;
	  symbolPath.highDownOnUpdate = hoverAnimation && seriesModel.isAnimationEnabled() ? highDownOnUpdate : null;
	  graphic.setHoverStyle(symbolPath);
	};
	
	function highDownOnUpdate(fromState, toState) {
	  // Do not support this hover animation util some scenario required.
	  // Animation can only be supported in hover layer when using `el.incremetal`.
	  if (this.incremental || this.useHoverLayer) {
	    return;
	  }
	
	  if (toState === 'emphasis') {
	    var scale = this.__symbolOriginalScale;
	    var ratio = scale[1] / scale[0];
	    var emphasisOpt = {
	      scale: [Math.max(scale[0] * 1.1, scale[0] + 3), Math.max(scale[1] * 1.1, scale[1] + 3 * ratio)]
	    }; // FIXME
	    // modify it after support stop specified animation.
	    // toState === fromState
	    //     ? (this.stopAnimation(), this.attr(emphasisOpt))
	
	    this.animateTo(emphasisOpt, 400, 'elasticOut');
	  } else if (toState === 'normal') {
	    this.animateTo({
	      scale: this.__symbolOriginalScale
	    }, 400, 'elasticOut');
	  }
	}
	/**
	 * @param {Function} cb
	 * @param {Object} [opt]
	 * @param {Object} [opt.keepLabel=true]
	 */
	
	
	symbolProto.fadeOut = function (cb, opt) {
	  var symbolPath = this.childAt(0); // Avoid mistaken hover when fading out
	
	  this.silent = symbolPath.silent = true; // Not show text when animating
	
	  !(opt && opt.keepLabel) && (symbolPath.style.text = null);
	  graphic.updateProps(symbolPath, {
	    style: {
	      opacity: 0
	    },
	    scale: [0, 0]
	  }, this._seriesModel, this.dataIndex, cb);
	};
	
	zrUtil.inherits(SymbolClz, graphic.Group);
	var _default = SymbolClz;
	module.exports = _default;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataProvider = __webpack_require__(322);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @return {string} label string. Not null/undefined
	 */
	function getDefaultLabel(data, dataIndex) {
	  var labelDims = data.mapDimension('defaultedLabel', true);
	  var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)
	
	  if (len === 1) {
	    return retrieveRawValue(data, dataIndex, labelDims[0]);
	  } else if (len) {
	    var vals = [];
	
	    for (var i = 0; i < labelDims.length; i++) {
	      var val = retrieveRawValue(data, dataIndex, labelDims[i]);
	      vals.push(val);
	    }
	
	    return vals.join(' ');
	  }
	}
	
	exports.getDefaultLabel = getDefaultLabel;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _helper = __webpack_require__(373);
	
	var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
	var getStackedOnPoint = _helper.getStackedOnPoint;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// var arrayDiff = require('zrender/src/core/arrayDiff');
	// 'zrender/src/core/arrayDiff' has been used before, but it did
	// not do well in performance when roam with fixed dataZoom window.
	// function convertToIntId(newIdList, oldIdList) {
	//     // Generate int id instead of string id.
	//     // Compare string maybe slow in score function of arrDiff
	//     // Assume id in idList are all unique
	//     var idIndicesMap = {};
	//     var idx = 0;
	//     for (var i = 0; i < newIdList.length; i++) {
	//         idIndicesMap[newIdList[i]] = idx;
	//         newIdList[i] = idx++;
	//     }
	//     for (var i = 0; i < oldIdList.length; i++) {
	//         var oldId = oldIdList[i];
	//         // Same with newIdList
	//         if (idIndicesMap[oldId]) {
	//             oldIdList[i] = idIndicesMap[oldId];
	//         }
	//         else {
	//             oldIdList[i] = idx++;
	//         }
	//     }
	// }
	function diffData(oldData, newData) {
	  var diffResult = [];
	  newData.diff(oldData).add(function (idx) {
	    diffResult.push({
	      cmd: '+',
	      idx: idx
	    });
	  }).update(function (newIdx, oldIdx) {
	    diffResult.push({
	      cmd: '=',
	      idx: oldIdx,
	      idx1: newIdx
	    });
	  }).remove(function (idx) {
	    diffResult.push({
	      cmd: '-',
	      idx: idx
	    });
	  }).execute();
	  return diffResult;
	}
	
	function _default(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
	  var diff = diffData(oldData, newData); // var newIdList = newData.mapArray(newData.getId);
	  // var oldIdList = oldData.mapArray(oldData.getId);
	  // convertToIntId(newIdList, oldIdList);
	  // // FIXME One data ?
	  // diff = arrayDiff(oldIdList, newIdList);
	
	  var currPoints = [];
	  var nextPoints = []; // Points for stacking base line
	
	  var currStackedPoints = [];
	  var nextStackedPoints = [];
	  var status = [];
	  var sortedIndices = [];
	  var rawIndices = [];
	  var newDataOldCoordInfo = prepareDataCoordInfo(oldCoordSys, newData, oldValueOrigin);
	  var oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
	
	  for (var i = 0; i < diff.length; i++) {
	    var diffItem = diff[i];
	    var pointAdded = true; // FIXME, animation is not so perfect when dataZoom window moves fast
	    // Which is in case remvoing or add more than one data in the tail or head
	
	    switch (diffItem.cmd) {
	      case '=':
	        var currentPt = oldData.getItemLayout(diffItem.idx);
	        var nextPt = newData.getItemLayout(diffItem.idx1); // If previous data is NaN, use next point directly
	
	        if (isNaN(currentPt[0]) || isNaN(currentPt[1])) {
	          currentPt = nextPt.slice();
	        }
	
	        currPoints.push(currentPt);
	        nextPoints.push(nextPt);
	        currStackedPoints.push(oldStackedOnPoints[diffItem.idx]);
	        nextStackedPoints.push(newStackedOnPoints[diffItem.idx1]);
	        rawIndices.push(newData.getRawIndex(diffItem.idx1));
	        break;
	
	      case '+':
	        var idx = diffItem.idx;
	        currPoints.push(oldCoordSys.dataToPoint([newData.get(newDataOldCoordInfo.dataDimsForPoint[0], idx), newData.get(newDataOldCoordInfo.dataDimsForPoint[1], idx)]));
	        nextPoints.push(newData.getItemLayout(idx).slice());
	        currStackedPoints.push(getStackedOnPoint(newDataOldCoordInfo, oldCoordSys, newData, idx));
	        nextStackedPoints.push(newStackedOnPoints[idx]);
	        rawIndices.push(newData.getRawIndex(idx));
	        break;
	
	      case '-':
	        var idx = diffItem.idx;
	        var rawIndex = oldData.getRawIndex(idx); // Data is replaced. In the case of dynamic data queue
	        // FIXME FIXME FIXME
	
	        if (rawIndex !== idx) {
	          currPoints.push(oldData.getItemLayout(idx));
	          nextPoints.push(newCoordSys.dataToPoint([oldData.get(oldDataNewCoordInfo.dataDimsForPoint[0], idx), oldData.get(oldDataNewCoordInfo.dataDimsForPoint[1], idx)]));
	          currStackedPoints.push(oldStackedOnPoints[idx]);
	          nextStackedPoints.push(getStackedOnPoint(oldDataNewCoordInfo, newCoordSys, oldData, idx));
	          rawIndices.push(rawIndex);
	        } else {
	          pointAdded = false;
	        }
	
	    } // Original indices
	
	
	    if (pointAdded) {
	      status.push(diffItem);
	      sortedIndices.push(sortedIndices.length);
	    }
	  } // Diff result may be crossed if all items are changed
	  // Sort by data index
	
	
	  sortedIndices.sort(function (a, b) {
	    return rawIndices[a] - rawIndices[b];
	  });
	  var sortedCurrPoints = [];
	  var sortedNextPoints = [];
	  var sortedCurrStackedPoints = [];
	  var sortedNextStackedPoints = [];
	  var sortedStatus = [];
	
	  for (var i = 0; i < sortedIndices.length; i++) {
	    var idx = sortedIndices[i];
	    sortedCurrPoints[i] = currPoints[idx];
	    sortedNextPoints[i] = nextPoints[idx];
	    sortedCurrStackedPoints[i] = currStackedPoints[idx];
	    sortedNextStackedPoints[i] = nextStackedPoints[idx];
	    sortedStatus[i] = status[idx];
	  }
	
	  return {
	    current: sortedCurrPoints,
	    next: sortedNextPoints,
	    stackedOnCurrent: sortedCurrStackedPoints,
	    stackedOnNext: sortedNextStackedPoints,
	    status: sortedStatus
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataStackHelper = __webpack_require__(349);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	var _util = __webpack_require__(220);
	
	var map = _util.map;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} coordSys
	 * @param {module:echarts/data/List} data
	 * @param {string} valueOrigin lineSeries.option.areaStyle.origin
	 */
	function prepareDataCoordInfo(coordSys, data, valueOrigin) {
	  var baseAxis = coordSys.getBaseAxis();
	  var valueAxis = coordSys.getOtherAxis(baseAxis);
	  var valueStart = getValueStart(valueAxis, valueOrigin);
	  var baseAxisDim = baseAxis.dim;
	  var valueAxisDim = valueAxis.dim;
	  var valueDim = data.mapDimension(valueAxisDim);
	  var baseDim = data.mapDimension(baseAxisDim);
	  var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
	  var dims = map(coordSys.dimensions, function (coordDim) {
	    return data.mapDimension(coordDim);
	  });
	  var stacked;
	  var stackResultDim = data.getCalculationInfo('stackResultDimension');
	
	  if (stacked |= isDimensionStacked(data, dims[0]
	  /*, dims[1]*/
	  )) {
	    // jshint ignore:line
	    dims[0] = stackResultDim;
	  }
	
	  if (stacked |= isDimensionStacked(data, dims[1]
	  /*, dims[0]*/
	  )) {
	    // jshint ignore:line
	    dims[1] = stackResultDim;
	  }
	
	  return {
	    dataDimsForPoint: dims,
	    valueStart: valueStart,
	    valueAxisDim: valueAxisDim,
	    baseAxisDim: baseAxisDim,
	    stacked: !!stacked,
	    valueDim: valueDim,
	    baseDim: baseDim,
	    baseDataOffset: baseDataOffset,
	    stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
	  };
	}
	
	function getValueStart(valueAxis, valueOrigin) {
	  var valueStart = 0;
	  var extent = valueAxis.scale.getExtent();
	
	  if (valueOrigin === 'start') {
	    valueStart = extent[0];
	  } else if (valueOrigin === 'end') {
	    valueStart = extent[1];
	  } // auto
	  else {
	      // Both positive
	      if (extent[0] > 0) {
	        valueStart = extent[0];
	      } // Both negative
	      else if (extent[1] < 0) {
	          valueStart = extent[1];
	        } // If is one positive, and one negative, onZero shall be true
	
	    }
	
	  return valueStart;
	}
	
	function getStackedOnPoint(dataCoordInfo, coordSys, data, idx) {
	  var value = NaN;
	
	  if (dataCoordInfo.stacked) {
	    value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
	  }
	
	  if (isNaN(value)) {
	    value = dataCoordInfo.valueStart;
	  }
	
	  var baseDataOffset = dataCoordInfo.baseDataOffset;
	  var stackedData = [];
	  stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
	  stackedData[1 - baseDataOffset] = value;
	  return coordSys.dataToPoint(stackedData);
	}
	
	exports.prepareDataCoordInfo = prepareDataCoordInfo;
	exports.getStackedOnPoint = getStackedOnPoint;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Path = __webpack_require__(270);
	
	var vec2 = __webpack_require__(222);
	
	var fixClipWithShadow = __webpack_require__(285);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Poly path support NaN point
	var vec2Min = vec2.min;
	var vec2Max = vec2.max;
	var scaleAndAdd = vec2.scaleAndAdd;
	var v2Copy = vec2.copy; // Temporary variable
	
	var v = [];
	var cp0 = [];
	var cp1 = [];
	
	function isPointNull(p) {
	  return isNaN(p[0]) || isNaN(p[1]);
	}
	
	function drawSegment(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  // if (smoothMonotone == null) {
	  //     if (isMono(points, 'x')) {
	  //         return drawMono(ctx, points, start, segLen, allLen,
	  //             dir, smoothMin, smoothMax, smooth, 'x', connectNulls);
	  //     }
	  //     else if (isMono(points, 'y')) {
	  //         return drawMono(ctx, points, start, segLen, allLen,
	  //             dir, smoothMin, smoothMax, smooth, 'y', connectNulls);
	  //     }
	  //     else {
	  //         return drawNonMono.apply(this, arguments);
	  //     }
	  // }
	  // else if (smoothMonotone !== 'none' && isMono(points, smoothMonotone)) {
	  //     return drawMono.apply(this, arguments);
	  // }
	  // else {
	  //     return drawNonMono.apply(this, arguments);
	  // }
	  if (smoothMonotone === 'none' || !smoothMonotone) {
	    return drawNonMono.apply(this, arguments);
	  } else {
	    return drawMono.apply(this, arguments);
	  }
	}
	/**
	 * Check if points is in monotone.
	 *
	 * @param {number[][]} points         Array of points which is in [x, y] form
	 * @param {string}     smoothMonotone 'x', 'y', or 'none', stating for which
	 *                                    dimension that is checking.
	 *                                    If is 'none', `drawNonMono` should be
	 *                                    called.
	 *                                    If is undefined, either being monotone
	 *                                    in 'x' or 'y' will call `drawMono`.
	 */
	// function isMono(points, smoothMonotone) {
	//     if (points.length <= 1) {
	//         return true;
	//     }
	//     var dim = smoothMonotone === 'x' ? 0 : 1;
	//     var last = points[0][dim];
	//     var lastDiff = 0;
	//     for (var i = 1; i < points.length; ++i) {
	//         var diff = points[i][dim] - last;
	//         if (!isNaN(diff) && !isNaN(lastDiff)
	//             && diff !== 0 && lastDiff !== 0
	//             && ((diff >= 0) !== (lastDiff >= 0))
	//         ) {
	//             return false;
	//         }
	//         if (!isNaN(diff) && diff !== 0) {
	//             lastDiff = diff;
	//             last = points[i][dim];
	//         }
	//     }
	//     return true;
	// }
	
	/**
	 * Draw smoothed line in monotone, in which only vertical or horizontal bezier
	 * control points will be used. This should be used when points are monotone
	 * either in x or y dimension.
	 */
	
	
	function drawMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  var prevIdx = 0;
	  var idx = start;
	
	  for (var k = 0; k < segLen; k++) {
	    var p = points[idx];
	
	    if (idx >= allLen || idx < 0) {
	      break;
	    }
	
	    if (isPointNull(p)) {
	      if (connectNulls) {
	        idx += dir;
	        continue;
	      }
	
	      break;
	    }
	
	    if (idx === start) {
	      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
	    } else {
	      if (smooth > 0) {
	        var prevP = points[prevIdx];
	        var dim = smoothMonotone === 'y' ? 1 : 0; // Length of control point to p, either in x or y, but not both
	
	        var ctrlLen = (p[dim] - prevP[dim]) * smooth;
	        v2Copy(cp0, prevP);
	        cp0[dim] = prevP[dim] + ctrlLen;
	        v2Copy(cp1, p);
	        cp1[dim] = p[dim] - ctrlLen;
	        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]);
	      } else {
	        ctx.lineTo(p[0], p[1]);
	      }
	    }
	
	    prevIdx = idx;
	    idx += dir;
	  }
	
	  return k;
	}
	/**
	 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
	 * situations. This should be used when points are non-monotone neither in x or
	 * y dimension.
	 */
	
	
	function drawNonMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  var prevIdx = 0;
	  var idx = start;
	
	  for (var k = 0; k < segLen; k++) {
	    var p = points[idx];
	
	    if (idx >= allLen || idx < 0) {
	      break;
	    }
	
	    if (isPointNull(p)) {
	      if (connectNulls) {
	        idx += dir;
	        continue;
	      }
	
	      break;
	    }
	
	    if (idx === start) {
	      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
	      v2Copy(cp0, p);
	    } else {
	      if (smooth > 0) {
	        var nextIdx = idx + dir;
	        var nextP = points[nextIdx];
	
	        if (connectNulls) {
	          // Find next point not null
	          while (nextP && isPointNull(points[nextIdx])) {
	            nextIdx += dir;
	            nextP = points[nextIdx];
	          }
	        }
	
	        var ratioNextSeg = 0.5;
	        var prevP = points[prevIdx];
	        var nextP = points[nextIdx]; // Last point
	
	        if (!nextP || isPointNull(nextP)) {
	          v2Copy(cp1, p);
	        } else {
	          // If next data is null in not connect case
	          if (isPointNull(nextP) && !connectNulls) {
	            nextP = p;
	          }
	
	          vec2.sub(v, nextP, prevP);
	          var lenPrevSeg;
	          var lenNextSeg;
	
	          if (smoothMonotone === 'x' || smoothMonotone === 'y') {
	            var dim = smoothMonotone === 'x' ? 0 : 1;
	            lenPrevSeg = Math.abs(p[dim] - prevP[dim]);
	            lenNextSeg = Math.abs(p[dim] - nextP[dim]);
	          } else {
	            lenPrevSeg = vec2.dist(p, prevP);
	            lenNextSeg = vec2.dist(p, nextP);
	          } // Use ratio of seg length
	
	
	          ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
	          scaleAndAdd(cp1, p, v, -smooth * (1 - ratioNextSeg));
	        } // Smooth constraint
	
	
	        vec2Min(cp0, cp0, smoothMax);
	        vec2Max(cp0, cp0, smoothMin);
	        vec2Min(cp1, cp1, smoothMax);
	        vec2Max(cp1, cp1, smoothMin);
	        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]); // cp0 of next segment
	
	        scaleAndAdd(cp0, p, v, smooth * ratioNextSeg);
	      } else {
	        ctx.lineTo(p[0], p[1]);
	      }
	    }
	
	    prevIdx = idx;
	    idx += dir;
	  }
	
	  return k;
	}
	
	function getBoundingBox(points, smoothConstraint) {
	  var ptMin = [Infinity, Infinity];
	  var ptMax = [-Infinity, -Infinity];
	
	  if (smoothConstraint) {
	    for (var i = 0; i < points.length; i++) {
	      var pt = points[i];
	
	      if (pt[0] < ptMin[0]) {
	        ptMin[0] = pt[0];
	      }
	
	      if (pt[1] < ptMin[1]) {
	        ptMin[1] = pt[1];
	      }
	
	      if (pt[0] > ptMax[0]) {
	        ptMax[0] = pt[0];
	      }
	
	      if (pt[1] > ptMax[1]) {
	        ptMax[1] = pt[1];
	      }
	    }
	  }
	
	  return {
	    min: smoothConstraint ? ptMin : ptMax,
	    max: smoothConstraint ? ptMax : ptMin
	  };
	}
	
	var Polyline = Path.extend({
	  type: 'ec-polyline',
	  shape: {
	    points: [],
	    smooth: 0,
	    smoothConstraint: true,
	    smoothMonotone: null,
	    connectNulls: false
	  },
	  style: {
	    fill: null,
	    stroke: '#000'
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var points = shape.points;
	    var i = 0;
	    var len = points.length;
	    var result = getBoundingBox(points, shape.smoothConstraint);
	
	    if (shape.connectNulls) {
	      // Must remove first and last null values avoid draw error in polygon
	      for (; len > 0; len--) {
	        if (!isPointNull(points[len - 1])) {
	          break;
	        }
	      }
	
	      for (; i < len; i++) {
	        if (!isPointNull(points[i])) {
	          break;
	        }
	      }
	    }
	
	    while (i < len) {
	      i += drawSegment(ctx, points, i, len, len, 1, result.min, result.max, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
	    }
	  }
	});
	var Polygon = Path.extend({
	  type: 'ec-polygon',
	  shape: {
	    points: [],
	    // Offset between stacked base points and points
	    stackedOnPoints: [],
	    smooth: 0,
	    stackedOnSmooth: 0,
	    smoothConstraint: true,
	    smoothMonotone: null,
	    connectNulls: false
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var points = shape.points;
	    var stackedOnPoints = shape.stackedOnPoints;
	    var i = 0;
	    var len = points.length;
	    var smoothMonotone = shape.smoothMonotone;
	    var bbox = getBoundingBox(points, shape.smoothConstraint);
	    var stackedOnBBox = getBoundingBox(stackedOnPoints, shape.smoothConstraint);
	
	    if (shape.connectNulls) {
	      // Must remove first and last null values avoid draw error in polygon
	      for (; len > 0; len--) {
	        if (!isPointNull(points[len - 1])) {
	          break;
	        }
	      }
	
	      for (; i < len; i++) {
	        if (!isPointNull(points[i])) {
	          break;
	        }
	      }
	    }
	
	    while (i < len) {
	      var k = drawSegment(ctx, points, i, len, len, 1, bbox.min, bbox.max, shape.smooth, smoothMonotone, shape.connectNulls);
	      drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, stackedOnBBox.min, stackedOnBBox.max, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
	      i += k + 1;
	      ctx.closePath();
	    }
	  }
	});
	exports.Polyline = Polyline;
	exports.Polygon = Polygon;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var _number = __webpack_require__(306);
	
	var round = _number.round;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function createGridClipPath(cartesian, hasAnimation, seriesModel) {
	  var rect = cartesian.getArea();
	  var isHorizontal = cartesian.getBaseAxis().isHorizontal();
	  var x = rect.x;
	  var y = rect.y;
	  var width = rect.width;
	  var height = rect.height;
	  var lineWidth = seriesModel.get('lineStyle.width') || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner
	
	  x -= lineWidth / 2;
	  y -= lineWidth / 2;
	  width += lineWidth;
	  height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369
	
	  x = Math.floor(x);
	  width = Math.round(width);
	  var clipPath = new graphic.Rect({
	    shape: {
	      x: x,
	      y: y,
	      width: width,
	      height: height
	    }
	  });
	
	  if (hasAnimation) {
	    clipPath.shape[isHorizontal ? 'width' : 'height'] = 0;
	    graphic.initProps(clipPath, {
	      shape: {
	        width: width,
	        height: height
	      }
	    }, seriesModel);
	  }
	
	  return clipPath;
	}
	
	function createPolarClipPath(polar, hasAnimation, seriesModel) {
	  var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
	
	  var clipPath = new graphic.Sector({
	    shape: {
	      cx: round(polar.cx, 1),
	      cy: round(polar.cy, 1),
	      r0: round(sectorArea.r0, 1),
	      r: round(sectorArea.r, 1),
	      startAngle: sectorArea.startAngle,
	      endAngle: sectorArea.endAngle,
	      clockwise: sectorArea.clockwise
	    }
	  });
	
	  if (hasAnimation) {
	    clipPath.shape.endAngle = sectorArea.startAngle;
	    graphic.initProps(clipPath, {
	      shape: {
	        endAngle: sectorArea.endAngle
	      }
	    }, seriesModel);
	  }
	
	  return clipPath;
	}
	
	function createClipPath(coordSys, hasAnimation, seriesModel) {
	  if (!coordSys) {
	    return null;
	  } else if (coordSys.type === 'polar') {
	    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
	  } else if (coordSys.type === 'cartesian2d') {
	    return createGridClipPath(coordSys, hasAnimation, seriesModel);
	  }
	
	  return null;
	}
	
	exports.createGridClipPath = createGridClipPath;
	exports.createPolarClipPath = createPolarClipPath;
	exports.createClipPath = createClipPath;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var isFunction = _util.isFunction;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType, defaultSymbolType, legendSymbol) {
	  // Encoding visual for all series include which is filtered for legend drawing
	  return {
	    seriesType: seriesType,
	    // For legend.
	    performRawSeries: true,
	    reset: function (seriesModel, ecModel, api) {
	      var data = seriesModel.getData();
	      var symbolType = seriesModel.get('symbol');
	      var symbolSize = seriesModel.get('symbolSize');
	      var keepAspect = seriesModel.get('symbolKeepAspect');
	      var symbolRotate = seriesModel.get('symbolRotate');
	      var hasSymbolTypeCallback = isFunction(symbolType);
	      var hasSymbolSizeCallback = isFunction(symbolSize);
	      var hasSymbolRotateCallback = isFunction(symbolRotate);
	      var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback;
	      var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : defaultSymbolType;
	      var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
	      var seriesSymbolRotate = !hasSymbolRotateCallback ? seriesSymbolRotate : null;
	      data.setVisual({
	        legendSymbol: legendSymbol || seriesSymbol,
	        // If seting callback functions on `symbol` or `symbolSize`, for simplicity and avoiding
	        // to bring trouble, we do not pick a reuslt from one of its calling on data item here,
	        // but just use the default value. Callback on `symbol` or `symbolSize` is convenient in
	        // some cases but generally it is not recommanded.
	        symbol: seriesSymbol,
	        symbolSize: seriesSymbolSize,
	        symbolKeepAspect: keepAspect,
	        symbolRotate: symbolRotate
	      }); // Only visible series has each data be visual encoded
	
	      if (ecModel.isSeriesFiltered(seriesModel)) {
	        return;
	      }
	
	      function dataEach(data, idx) {
	        if (hasCallback) {
	          var rawValue = seriesModel.getRawValue(idx);
	          var params = seriesModel.getDataParams(idx);
	          hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
	          hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
	          hasSymbolRotateCallback && data.setItemVisual(idx, 'symbolRotate', symbolRotate(rawValue, params));
	        }
	
	        if (data.hasItemOption) {
	          var itemModel = data.getItemModel(idx);
	          var itemSymbolType = itemModel.getShallow('symbol', true);
	          var itemSymbolSize = itemModel.getShallow('symbolSize', true);
	          var itemSymbolRotate = itemModel.getShallow('symbolRotate', true);
	          var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true); // If has item symbol
	
	          if (itemSymbolType != null) {
	            data.setItemVisual(idx, 'symbol', itemSymbolType);
	          }
	
	          if (itemSymbolSize != null) {
	            // PENDING Transform symbolSize ?
	            data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
	          }
	
	          if (itemSymbolRotate != null) {
	            data.setItemVisual(idx, 'symbolRotate', itemSymbolRotate);
	          }
	
	          if (itemSymbolKeepAspect != null) {
	            data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
	          }
	        }
	      }
	
	      return {
	        dataEach: data.hasItemOption || hasCallback ? dataEach : null
	      };
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var map = _util.map;
	
	var createRenderPlanner = __webpack_require__(326);
	
	var _dataStackHelper = __webpack_require__(349);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    plan: createRenderPlanner(),
	    reset: function (seriesModel) {
	      var data = seriesModel.getData();
	      var coordSys = seriesModel.coordinateSystem;
	      var pipelineContext = seriesModel.pipelineContext;
	      var isLargeRender = pipelineContext.large;
	
	      if (!coordSys) {
	        return;
	      }
	
	      var dims = map(coordSys.dimensions, function (dim) {
	        return data.mapDimension(dim);
	      }).slice(0, 2);
	      var dimLen = dims.length;
	      var stackResultDim = data.getCalculationInfo('stackResultDimension');
	
	      if (isDimensionStacked(data, dims[0]
	      /*, dims[1]*/
	      )) {
	        dims[0] = stackResultDim;
	      }
	
	      if (isDimensionStacked(data, dims[1]
	      /*, dims[0]*/
	      )) {
	        dims[1] = stackResultDim;
	      }
	
	      function progress(params, data) {
	        var segCount = params.end - params.start;
	        var points = isLargeRender && new Float32Array(segCount * dimLen);
	
	        for (var i = params.start, offset = 0, tmpIn = [], tmpOut = []; i < params.end; i++) {
	          var point;
	
	          if (dimLen === 1) {
	            var x = data.get(dims[0], i);
	            point = !isNaN(x) && coordSys.dataToPoint(x, null, tmpOut);
	          } else {
	            var x = tmpIn[0] = data.get(dims[0], i);
	            var y = tmpIn[1] = data.get(dims[1], i); // Also {Array.<number>}, not undefined to avoid if...else... statement
	
	            point = !isNaN(x) && !isNaN(y) && coordSys.dataToPoint(tmpIn, null, tmpOut);
	          }
	
	          if (isLargeRender) {
	            points[offset++] = point ? point[0] : NaN;
	            points[offset++] = point ? point[1] : NaN;
	          } else {
	            data.setItemLayout(i, point && point.slice() || [NaN, NaN]);
	          }
	        }
	
	        isLargeRender && data.setLayout('symbolPoints', points);
	      }
	
	      return dimLen && {
	        progress: progress
	      };
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var samplers = {
	  average: function (frame) {
	    var sum = 0;
	    var count = 0;
	
	    for (var i = 0; i < frame.length; i++) {
	      if (!isNaN(frame[i])) {
	        sum += frame[i];
	        count++;
	      }
	    } // Return NaN if count is 0
	
	
	    return count === 0 ? NaN : sum / count;
	  },
	  sum: function (frame) {
	    var sum = 0;
	
	    for (var i = 0; i < frame.length; i++) {
	      // Ignore NaN
	      sum += frame[i] || 0;
	    }
	
	    return sum;
	  },
	  max: function (frame) {
	    var max = -Infinity;
	
	    for (var i = 0; i < frame.length; i++) {
	      frame[i] > max && (max = frame[i]);
	    } // NaN will cause illegal axis extent.
	
	
	    return isFinite(max) ? max : NaN;
	  },
	  min: function (frame) {
	    var min = Infinity;
	
	    for (var i = 0; i < frame.length; i++) {
	      frame[i] < min && (min = frame[i]);
	    } // NaN will cause illegal axis extent.
	
	
	    return isFinite(min) ? min : NaN;
	  },
	  // TODO
	  // Median
	  nearest: function (frame) {
	    return frame[0];
	  }
	};
	
	var indexSampler = function (frame, value) {
	  return Math.round(frame.length / 2);
	};
	
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    modifyOutputEnd: true,
	    reset: function (seriesModel, ecModel, api) {
	      var data = seriesModel.getData();
	      var sampling = seriesModel.get('sampling');
	      var coordSys = seriesModel.coordinateSystem; // Only cartesian2d support down sampling
	
	      if (coordSys.type === 'cartesian2d' && sampling) {
	        var baseAxis = coordSys.getBaseAxis();
	        var valueAxis = coordSys.getOtherAxis(baseAxis);
	        var extent = baseAxis.getExtent(); // Coordinste system has been resized
	
	        var size = Math.abs(extent[1] - extent[0]);
	        var rate = Math.round(data.count() / size);
	
	        if (rate > 1) {
	          var sampler;
	
	          if (typeof sampling === 'string') {
	            sampler = samplers[sampling];
	          } else if (typeof sampling === 'function') {
	            sampler = sampling;
	          }
	
	          if (sampler) {
	            // Only support sample the first dim mapped from value axis.
	            seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, indexSampler));
	          }
	        }
	      }
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	__webpack_require__(380);
	
	__webpack_require__(388);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Grid view
	echarts.extendComponentView({
	  type: 'grid',
	  render: function (gridModel, ecModel) {
	    this.group.removeAll();
	
	    if (gridModel.get('show')) {
	      this.group.add(new graphic.Rect({
	        shape: gridModel.coordinateSystem.getRect(),
	        style: zrUtil.defaults({
	          fill: gridModel.get('backgroundColor')
	        }, gridModel.getItemStyle()),
	        silent: true,
	        z2: -1
	      }));
	    }
	  }
	});
	echarts.registerPreprocessor(function (option) {
	  // Only create grid when need
	  if (option.xAxis && option.yAxis && !option.grid) {
	    option.grid = {};
	  }
	});

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(220);
	
	var isObject = _util.isObject;
	var each = _util.each;
	var map = _util.map;
	var indexOf = _util.indexOf;
	var retrieve = _util.retrieve;
	
	var _layout = __webpack_require__(305);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _axisHelper = __webpack_require__(350);
	
	var createScaleByModel = _axisHelper.createScaleByModel;
	var ifAxisCrossZero = _axisHelper.ifAxisCrossZero;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	var estimateLabelUnionRect = _axisHelper.estimateLabelUnionRect;
	
	var Cartesian2D = __webpack_require__(381);
	
	var Axis2D = __webpack_require__(383);
	
	var CoordinateSystem = __webpack_require__(315);
	
	var _dataStackHelper = __webpack_require__(349);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	__webpack_require__(384);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Grid is a region which contains at most 4 cartesian systems
	 *
	 * TODO Default cartesian
	 */
	// Depends on GridModel, AxisModel, which performs preprocess.
	
	/**
	 * Check if the axis is used in the specified grid
	 * @inner
	 */
	function isAxisUsedInTheGrid(axisModel, gridModel, ecModel) {
	  return axisModel.getCoordSysModel() === gridModel;
	}
	
	function Grid(gridModel, ecModel, api) {
	  /**
	   * @type {Object.<string, module:echarts/coord/cartesian/Cartesian2D>}
	   * @private
	   */
	  this._coordsMap = {};
	  /**
	   * @type {Array.<module:echarts/coord/cartesian/Cartesian>}
	   * @private
	   */
	
	  this._coordsList = [];
	  /**
	   * @type {Object.<string, Array.<module:echarts/coord/cartesian/Axis2D>>}
	   * @private
	   */
	
	  this._axesMap = {};
	  /**
	   * @type {Array.<module:echarts/coord/cartesian/Axis2D>}
	   * @private
	   */
	
	  this._axesList = [];
	
	  this._initCartesian(gridModel, ecModel, api);
	
	  this.model = gridModel;
	}
	
	var gridProto = Grid.prototype;
	gridProto.type = 'grid';
	gridProto.axisPointerEnabled = true;
	
	gridProto.getRect = function () {
	  return this._rect;
	};
	
	gridProto.update = function (ecModel, api) {
	  var axesMap = this._axesMap;
	
	  this._updateScale(ecModel, this.model);
	
	  each(axesMap.x, function (xAxis) {
	    niceScaleExtent(xAxis.scale, xAxis.model);
	  });
	  each(axesMap.y, function (yAxis) {
	    niceScaleExtent(yAxis.scale, yAxis.model);
	  }); // Key: axisDim_axisIndex, value: boolean, whether onZero target.
	
	  var onZeroRecords = {};
	  each(axesMap.x, function (xAxis) {
	    fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
	  });
	  each(axesMap.y, function (yAxis) {
	    fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
	  }); // Resize again if containLabel is enabled
	  // FIXME It may cause getting wrong grid size in data processing stage
	
	  this.resize(this.model, api);
	};
	
	function fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
	  axis.getAxesOnZeroOf = function () {
	    // TODO: onZero of multiple axes.
	    return otherAxisOnZeroOf ? [otherAxisOnZeroOf] : [];
	  }; // onZero can not be enabled in these two situations:
	  // 1. When any other axis is a category axis.
	  // 2. When no axis is cross 0 point.
	
	
	  var otherAxes = axesMap[otherAxisDim];
	  var otherAxisOnZeroOf;
	  var axisModel = axis.model;
	  var onZero = axisModel.get('axisLine.onZero');
	  var onZeroAxisIndex = axisModel.get('axisLine.onZeroAxisIndex');
	
	  if (!onZero) {
	    return;
	  } // If target axis is specified.
	
	
	  if (onZeroAxisIndex != null) {
	    if (canOnZeroToAxis(otherAxes[onZeroAxisIndex])) {
	      otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
	    }
	  } else {
	    // Find the first available other axis.
	    for (var idx in otherAxes) {
	      if (otherAxes.hasOwnProperty(idx) && canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
	      // if both onZero, the two Y axes overlap.
	      && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
	        otherAxisOnZeroOf = otherAxes[idx];
	        break;
	      }
	    }
	  }
	
	  if (otherAxisOnZeroOf) {
	    onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
	  }
	
	  function getOnZeroRecordKey(axis) {
	    return axis.dim + '_' + axis.index;
	  }
	}
	
	function canOnZeroToAxis(axis) {
	  return axis && axis.type !== 'category' && axis.type !== 'time' && ifAxisCrossZero(axis);
	}
	/**
	 * Resize the grid
	 * @param {module:echarts/coord/cartesian/GridModel} gridModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	gridProto.resize = function (gridModel, api, ignoreContainLabel) {
	  var gridRect = getLayoutRect(gridModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	  this._rect = gridRect;
	  var axesList = this._axesList;
	  adjustAxes(); // Minus label size
	
	  if (!ignoreContainLabel && gridModel.get('containLabel')) {
	    each(axesList, function (axis) {
	      if (!axis.model.get('axisLabel.inside')) {
	        var labelUnionRect = estimateLabelUnionRect(axis);
	
	        if (labelUnionRect) {
	          var dim = axis.isHorizontal() ? 'height' : 'width';
	          var margin = axis.model.get('axisLabel.margin');
	          gridRect[dim] -= labelUnionRect[dim] + margin;
	
	          if (axis.position === 'top') {
	            gridRect.y += labelUnionRect.height + margin;
	          } else if (axis.position === 'left') {
	            gridRect.x += labelUnionRect.width + margin;
	          }
	        }
	      }
	    });
	    adjustAxes();
	  }
	
	  function adjustAxes() {
	    each(axesList, function (axis) {
	      var isHorizontal = axis.isHorizontal();
	      var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
	      var idx = axis.inverse ? 1 : 0;
	      axis.setExtent(extent[idx], extent[1 - idx]);
	      updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
	    });
	  }
	};
	/**
	 * @param {string} axisType
	 * @param {number} [axisIndex]
	 */
	
	
	gridProto.getAxis = function (axisType, axisIndex) {
	  var axesMapOnDim = this._axesMap[axisType];
	
	  if (axesMapOnDim != null) {
	    if (axisIndex == null) {
	      // Find first axis
	      for (var name in axesMapOnDim) {
	        if (axesMapOnDim.hasOwnProperty(name)) {
	          return axesMapOnDim[name];
	        }
	      }
	    }
	
	    return axesMapOnDim[axisIndex];
	  }
	};
	/**
	 * @return {Array.<module:echarts/coord/Axis>}
	 */
	
	
	gridProto.getAxes = function () {
	  return this._axesList.slice();
	};
	/**
	 * Usage:
	 *      grid.getCartesian(xAxisIndex, yAxisIndex);
	 *      grid.getCartesian(xAxisIndex);
	 *      grid.getCartesian(null, yAxisIndex);
	 *      grid.getCartesian({xAxisIndex: ..., yAxisIndex: ...});
	 *
	 * @param {number|Object} [xAxisIndex]
	 * @param {number} [yAxisIndex]
	 */
	
	
	gridProto.getCartesian = function (xAxisIndex, yAxisIndex) {
	  if (xAxisIndex != null && yAxisIndex != null) {
	    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	    return this._coordsMap[key];
	  }
	
	  if (isObject(xAxisIndex)) {
	    yAxisIndex = xAxisIndex.yAxisIndex;
	    xAxisIndex = xAxisIndex.xAxisIndex;
	  } // When only xAxisIndex or yAxisIndex given, find its first cartesian.
	
	
	  for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
	    if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
	      return coordList[i];
	    }
	  }
	};
	
	gridProto.getCartesians = function () {
	  return this._coordsList.slice();
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.convertToPixel = function (ecModel, finder, value) {
	  var target = this._findConvertTarget(ecModel, finder);
	
	  return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.convertFromPixel = function (ecModel, finder, value) {
	  var target = this._findConvertTarget(ecModel, finder);
	
	  return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
	};
	/**
	 * @inner
	 */
	
	
	gridProto._findConvertTarget = function (ecModel, finder) {
	  var seriesModel = finder.seriesModel;
	  var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis')[0];
	  var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis')[0];
	  var gridModel = finder.gridModel;
	  var coordsList = this._coordsList;
	  var cartesian;
	  var axis;
	
	  if (seriesModel) {
	    cartesian = seriesModel.coordinateSystem;
	    indexOf(coordsList, cartesian) < 0 && (cartesian = null);
	  } else if (xAxisModel && yAxisModel) {
	    cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	  } else if (xAxisModel) {
	    axis = this.getAxis('x', xAxisModel.componentIndex);
	  } else if (yAxisModel) {
	    axis = this.getAxis('y', yAxisModel.componentIndex);
	  } // Lowest priority.
	  else if (gridModel) {
	      var grid = gridModel.coordinateSystem;
	
	      if (grid === this) {
	        cartesian = this._coordsList[0];
	      }
	    }
	
	  return {
	    cartesian: cartesian,
	    axis: axis
	  };
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.containPoint = function (point) {
	  var coord = this._coordsList[0];
	
	  if (coord) {
	    return coord.containPoint(point);
	  }
	};
	/**
	 * Initialize cartesian coordinate systems
	 * @private
	 */
	
	
	gridProto._initCartesian = function (gridModel, ecModel, api) {
	  var axisPositionUsed = {
	    left: false,
	    right: false,
	    top: false,
	    bottom: false
	  };
	  var axesMap = {
	    x: {},
	    y: {}
	  };
	  var axesCount = {
	    x: 0,
	    y: 0
	  }; /// Create axis
	
	  ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
	  ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
	
	  if (!axesCount.x || !axesCount.y) {
	    // Roll back when there no either x or y axis
	    this._axesMap = {};
	    this._axesList = [];
	    return;
	  }
	
	  this._axesMap = axesMap; /// Create cartesian2d
	
	  each(axesMap.x, function (xAxis, xAxisIndex) {
	    each(axesMap.y, function (yAxis, yAxisIndex) {
	      var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	      var cartesian = new Cartesian2D(key);
	      cartesian.grid = this;
	      cartesian.model = gridModel;
	      this._coordsMap[key] = cartesian;
	
	      this._coordsList.push(cartesian);
	
	      cartesian.addAxis(xAxis);
	      cartesian.addAxis(yAxis);
	    }, this);
	  }, this);
	
	  function createAxisCreator(axisType) {
	    return function (axisModel, idx) {
	      if (!isAxisUsedInTheGrid(axisModel, gridModel, ecModel)) {
	        return;
	      }
	
	      var axisPosition = axisModel.get('position');
	
	      if (axisType === 'x') {
	        // Fix position
	        if (axisPosition !== 'top' && axisPosition !== 'bottom') {
	          // Default bottom of X
	          axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
	        }
	      } else {
	        // Fix position
	        if (axisPosition !== 'left' && axisPosition !== 'right') {
	          // Default left of Y
	          axisPosition = axisPositionUsed.left ? 'right' : 'left';
	        }
	      }
	
	      axisPositionUsed[axisPosition] = true;
	      var axis = new Axis2D(axisType, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisPosition);
	      var isCategory = axis.type === 'category';
	      axis.onBand = isCategory && axisModel.get('boundaryGap');
	      axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel
	
	      axisModel.axis = axis; // Inject axisModel into axis
	
	      axis.model = axisModel; // Inject grid info axis
	
	      axis.grid = this; // Index of axis, can be used as key
	
	      axis.index = idx;
	
	      this._axesList.push(axis);
	
	      axesMap[axisType][idx] = axis;
	      axesCount[axisType]++;
	    };
	  }
	};
	/**
	 * Update cartesian properties from series
	 * @param  {module:echarts/model/Option} option
	 * @private
	 */
	
	
	gridProto._updateScale = function (ecModel, gridModel) {
	  // Reset scale
	  each(this._axesList, function (axis) {
	    axis.scale.setExtent(Infinity, -Infinity);
	  });
	  ecModel.eachSeries(function (seriesModel) {
	    if (isCartesian2D(seriesModel)) {
	      var axesModels = findAxesModels(seriesModel, ecModel);
	      var xAxisModel = axesModels[0];
	      var yAxisModel = axesModels[1];
	
	      if (!isAxisUsedInTheGrid(xAxisModel, gridModel, ecModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel, ecModel)) {
	        return;
	      }
	
	      var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	      var data = seriesModel.getData();
	      var xAxis = cartesian.getAxis('x');
	      var yAxis = cartesian.getAxis('y');
	
	      if (data.type === 'list') {
	        unionExtent(data, xAxis, seriesModel);
	        unionExtent(data, yAxis, seriesModel);
	      }
	    }
	  }, this);
	
	  function unionExtent(data, axis, seriesModel) {
	    each(data.mapDimension(axis.dim, true), function (dim) {
	      axis.scale.unionExtentFromData( // For example, the extent of the orginal dimension
	      // is [0.1, 0.5], the extent of the `stackResultDimension`
	      // is [7, 9], the final extent should not include [0.1, 0.5].
	      data, getStackedDimension(data, dim));
	    });
	  }
	};
	/**
	 * @param {string} [dim] 'x' or 'y' or 'auto' or null/undefined
	 * @return {Object} {baseAxes: [], otherAxes: []}
	 */
	
	
	gridProto.getTooltipAxes = function (dim) {
	  var baseAxes = [];
	  var otherAxes = [];
	  each(this.getCartesians(), function (cartesian) {
	    var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
	    var otherAxis = cartesian.getOtherAxis(baseAxis);
	    indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
	    indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
	  });
	  return {
	    baseAxes: baseAxes,
	    otherAxes: otherAxes
	  };
	};
	/**
	 * @inner
	 */
	
	
	function updateAxisTransform(axis, coordBase) {
	  var axisExtent = axis.getExtent();
	  var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform
	
	  axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
	    return coord + coordBase;
	  } : function (coord) {
	    return axisExtentSum - coord + coordBase;
	  };
	  axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
	    return coord - coordBase;
	  } : function (coord) {
	    return axisExtentSum - coord + coordBase;
	  };
	}
	
	var axesTypes = ['xAxis', 'yAxis'];
	/**
	 * @inner
	 */
	
	function findAxesModels(seriesModel, ecModel) {
	  return map(axesTypes, function (axisType) {
	    var axisModel = seriesModel.getReferringComponents(axisType)[0];
	    return axisModel;
	  });
	}
	/**
	 * @inner
	 */
	
	
	function isCartesian2D(seriesModel) {
	  return seriesModel.get('coordinateSystem') === 'cartesian2d';
	}
	
	Grid.create = function (ecModel, api) {
	  var grids = [];
	  ecModel.eachComponent('grid', function (gridModel, idx) {
	    var grid = new Grid(gridModel, ecModel, api);
	    grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
	    // should be performed in create stage.
	
	    grid.resize(gridModel, api, true);
	    gridModel.coordinateSystem = grid;
	    grids.push(grid);
	  }); // Inject the coordinateSystems into seriesModel
	
	  ecModel.eachSeries(function (seriesModel) {
	    if (!isCartesian2D(seriesModel)) {
	      return;
	    }
	
	    var axesModels = findAxesModels(seriesModel, ecModel);
	    var xAxisModel = axesModels[0];
	    var yAxisModel = axesModels[1];
	    var gridModel = xAxisModel.getCoordSysModel();
	    var grid = gridModel.coordinateSystem;
	    seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	  });
	  return grids;
	}; // For deciding which dimensions to use when creating list data
	
	
	Grid.dimensions = Grid.prototype.dimensions = Cartesian2D.prototype.dimensions;
	CoordinateSystem.register('cartesian2d', Grid);
	var _default = Grid;
	module.exports = _default;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var BoundingRect = __webpack_require__(242);
	
	var Cartesian = __webpack_require__(382);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function Cartesian2D(name) {
	  Cartesian.call(this, name);
	}
	
	Cartesian2D.prototype = {
	  constructor: Cartesian2D,
	  type: 'cartesian2d',
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['x', 'y'],
	
	  /**
	   * Base axis will be used on stacking.
	   *
	   * @return {module:echarts/coord/cartesian/Axis2D}
	   */
	  getBaseAxis: function () {
	    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
	  },
	
	  /**
	   * If contain point
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var axisX = this.getAxis('x');
	    var axisY = this.getAxis('y');
	    return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
	  },
	
	  /**
	   * If contain data
	   * @param {Array.<number>} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
	  },
	
	  /**
	   * @param {Array.<number>} data
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, reserved, out) {
	    var xAxis = this.getAxis('x');
	    var yAxis = this.getAxis('y');
	    out = out || [];
	    out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(data[0]));
	    out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(data[1]));
	    return out;
	  },
	
	  /**
	   * @param {Array.<number>} data
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  clampData: function (data, out) {
	    var xScale = this.getAxis('x').scale;
	    var yScale = this.getAxis('y').scale;
	    var xAxisExtent = xScale.getExtent();
	    var yAxisExtent = yScale.getExtent();
	    var x = xScale.parse(data[0]);
	    var y = yScale.parse(data[1]);
	    out = out || [];
	    out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
	    out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
	    return out;
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  pointToData: function (point, out) {
	    var xAxis = this.getAxis('x');
	    var yAxis = this.getAxis('y');
	    out = out || [];
	    out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]));
	    out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]));
	    return out;
	  },
	
	  /**
	   * Get other axis
	   * @param {module:echarts/coord/cartesian/Axis2D} axis
	   */
	  getOtherAxis: function (axis) {
	    return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
	  },
	
	  /**
	   * Get rect area of cartesian.
	   * Area will have a contain function to determine if a point is in the coordinate system.
	   * @return {BoundingRect}
	   */
	  getArea: function () {
	    var xExtent = this.getAxis('x').getGlobalExtent();
	    var yExtent = this.getAxis('y').getGlobalExtent();
	    var x = Math.min(xExtent[0], xExtent[1]);
	    var y = Math.min(yExtent[0], yExtent[1]);
	    var width = Math.max(xExtent[0], xExtent[1]) - x;
	    var height = Math.max(yExtent[0], yExtent[1]) - y;
	    var rect = new BoundingRect(x, y, width, height);
	    return rect;
	  }
	};
	zrUtil.inherits(Cartesian2D, Cartesian);
	var _default = Cartesian2D;
	module.exports = _default;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Cartesian coordinate system
	 * @module  echarts/coord/Cartesian
	 *
	 */
	function dimAxisMapper(dim) {
	  return this._axes[dim];
	}
	/**
	 * @alias module:echarts/coord/Cartesian
	 * @constructor
	 */
	
	
	var Cartesian = function (name) {
	  this._axes = {};
	  this._dimList = [];
	  /**
	   * @type {string}
	   */
	
	  this.name = name || '';
	};
	
	Cartesian.prototype = {
	  constructor: Cartesian,
	  type: 'cartesian',
	
	  /**
	   * Get axis
	   * @param  {number|string} dim
	   * @return {module:echarts/coord/Cartesian~Axis}
	   */
	  getAxis: function (dim) {
	    return this._axes[dim];
	  },
	
	  /**
	   * Get axes list
	   * @return {Array.<module:echarts/coord/Cartesian~Axis>}
	   */
	  getAxes: function () {
	    return zrUtil.map(this._dimList, dimAxisMapper, this);
	  },
	
	  /**
	   * Get axes list by given scale type
	   */
	  getAxesByScale: function (scaleType) {
	    scaleType = scaleType.toLowerCase();
	    return zrUtil.filter(this.getAxes(), function (axis) {
	      return axis.scale.type === scaleType;
	    });
	  },
	
	  /**
	   * Add axis
	   * @param {module:echarts/coord/Cartesian.Axis}
	   */
	  addAxis: function (axis) {
	    var dim = axis.dim;
	    this._axes[dim] = axis;
	
	    this._dimList.push(dim);
	  },
	
	  /**
	   * Convert data to coord in nd space
	   * @param {Array.<number>|Object.<string, number>} val
	   * @return {Array.<number>|Object.<string, number>}
	   */
	  dataToCoord: function (val) {
	    return this._dataCoordConvert(val, 'dataToCoord');
	  },
	
	  /**
	   * Convert coord in nd space to data
	   * @param  {Array.<number>|Object.<string, number>} val
	   * @return {Array.<number>|Object.<string, number>}
	   */
	  coordToData: function (val) {
	    return this._dataCoordConvert(val, 'coordToData');
	  },
	  _dataCoordConvert: function (input, method) {
	    var dimList = this._dimList;
	    var output = input instanceof Array ? [] : {};
	
	    for (var i = 0; i < dimList.length; i++) {
	      var dim = dimList[i];
	      var axis = this._axes[dim];
	      output[dim] = axis[method](input[dim]);
	    }
	
	    return output;
	  }
	};
	var _default = Cartesian;
	module.exports = _default;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Axis = __webpack_require__(364);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Extend axis 2d
	 * @constructor module:echarts/coord/cartesian/Axis2D
	 * @extends {module:echarts/coord/cartesian/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var Axis2D = function (dim, scale, coordExtent, axisType, position) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis position
	   *  - 'top'
	   *  - 'bottom'
	   *  - 'left'
	   *  - 'right'
	   */
	
	  this.position = position || 'bottom';
	};
	
	Axis2D.prototype = {
	  constructor: Axis2D,
	
	  /**
	   * Index of axis, can be used as key
	   */
	  index: 0,
	
	  /**
	   * Implemented in <module:echarts/coord/cartesian/Grid>.
	   * @return {Array.<module:echarts/coord/cartesian/Axis2D>}
	   *         If not on zero of other axis, return null/undefined.
	   *         If no axes, return an empty array.
	   */
	  getAxesOnZeroOf: null,
	
	  /**
	   * Axis model
	   * @param {module:echarts/coord/cartesian/AxisModel}
	   */
	  model: null,
	  isHorizontal: function () {
	    var position = this.position;
	    return position === 'top' || position === 'bottom';
	  },
	
	  /**
	   * Each item cooresponds to this.getExtent(), which
	   * means globalExtent[0] may greater than globalExtent[1],
	   * unless `asc` is input.
	   *
	   * @param {boolean} [asc]
	   * @return {Array.<number>}
	   */
	  getGlobalExtent: function (asc) {
	    var ret = this.getExtent();
	    ret[0] = this.toGlobalCoord(ret[0]);
	    ret[1] = this.toGlobalCoord(ret[1]);
	    asc && ret[0] > ret[1] && ret.reverse();
	    return ret;
	  },
	  getOtherAxis: function () {
	    this.grid.getOtherAxis();
	  },
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
	  },
	
	  /**
	   * Transform global coord to local coord,
	   * i.e. var localCoord = axis.toLocalCoord(80);
	   * designate by module:echarts/coord/cartesian/Grid.
	   * @type {Function}
	   */
	  toLocalCoord: null,
	
	  /**
	   * Transform global coord to local coord,
	   * i.e. var globalCoord = axis.toLocalCoord(40);
	   * designate by module:echarts/coord/cartesian/Grid.
	   * @type {Function}
	   */
	  toGlobalCoord: null
	};
	zrUtil.inherits(Axis2D, Axis);
	var _default = Axis2D;
	module.exports = _default;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(385);
	
	var ComponentModel = __webpack_require__(303);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Grid 是在有直角坐标系的时候必须要存在的
	// 所以这里也要被 Cartesian2D 依赖
	var _default = ComponentModel.extend({
	  type: 'grid',
	  dependencies: ['xAxis', 'yAxis'],
	  layoutMode: 'box',
	
	  /**
	   * @type {module:echarts/coord/cartesian/Grid}
	   */
	  coordinateSystem: null,
	  defaultOption: {
	    show: false,
	    zlevel: 0,
	    z: 0,
	    left: '10%',
	    top: 60,
	    right: '10%',
	    bottom: 60,
	    // If grid size contain label
	    containLabel: false,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    backgroundColor: 'rgba(0,0,0,0)',
	    borderWidth: 1,
	    borderColor: '#ccc'
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var ComponentModel = __webpack_require__(303);
	
	var axisModelCreator = __webpack_require__(386);
	
	var axisModelCommonMixin = __webpack_require__(359);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'cartesian2dAxis',
	
	  /**
	   * @type {module:echarts/coord/cartesian/Axis2D}
	   */
	  axis: null,
	
	  /**
	   * @override
	   */
	  init: function () {
	    AxisModel.superApply(this, 'init', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function () {
	    AxisModel.superApply(this, 'mergeOption', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   */
	  restoreData: function () {
	    AxisModel.superApply(this, 'restoreData', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   * @return {module:echarts/model/Component}
	   */
	  getCoordSysModel: function () {
	    return this.ecModel.queryComponents({
	      mainType: 'grid',
	      index: this.option.gridIndex,
	      id: this.option.gridId
	    })[0];
	  }
	});
	
	function getAxisType(axisDim, option) {
	  // Default axis with data is category axis
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	var extraOption = {
	  // gridIndex: 0,
	  // gridId: '',
	  // Offset is for multiple axis on the same position
	  offset: 0
	};
	axisModelCreator('x', AxisModel, getAxisType, extraOption);
	axisModelCreator('y', AxisModel, getAxisType, extraOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var axisDefault = __webpack_require__(387);
	
	var ComponentModel = __webpack_require__(303);
	
	var _layout = __webpack_require__(305);
	
	var getLayoutParams = _layout.getLayoutParams;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	var OrdinalMeta = __webpack_require__(353);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME axisType is fixed ?
	var AXIS_TYPES = ['value', 'category', 'time', 'log'];
	/**
	 * Generate sub axis model class
	 * @param {string} axisName 'x' 'y' 'radius' 'angle' 'parallel'
	 * @param {module:echarts/model/Component} BaseAxisModelClass
	 * @param {Function} axisTypeDefaulter
	 * @param {Object} [extraDefaultOption]
	 */
	
	function _default(axisName, BaseAxisModelClass, axisTypeDefaulter, extraDefaultOption) {
	  zrUtil.each(AXIS_TYPES, function (axisType) {
	    BaseAxisModelClass.extend({
	      /**
	       * @readOnly
	       */
	      type: axisName + 'Axis.' + axisType,
	      mergeDefaultAndTheme: function (option, ecModel) {
	        var layoutMode = this.layoutMode;
	        var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
	        var themeModel = ecModel.getTheme();
	        zrUtil.merge(option, themeModel.get(axisType + 'Axis'));
	        zrUtil.merge(option, this.getDefaultOption());
	        option.type = axisTypeDefaulter(axisName, option);
	
	        if (layoutMode) {
	          mergeLayoutParam(option, inputPositionParams, layoutMode);
	        }
	      },
	
	      /**
	       * @override
	       */
	      optionUpdated: function () {
	        var thisOption = this.option;
	
	        if (thisOption.type === 'category') {
	          this.__ordinalMeta = OrdinalMeta.createByAxisModel(this);
	        }
	      },
	
	      /**
	       * Should not be called before all of 'getInitailData' finished.
	       * Because categories are collected during initializing data.
	       */
	      getCategories: function (rawData) {
	        var option = this.option; // FIXME
	        // warning if called before all of 'getInitailData' finished.
	
	        if (option.type === 'category') {
	          if (rawData) {
	            return option.data;
	          }
	
	          return this.__ordinalMeta.categories;
	        }
	      },
	      getOrdinalMeta: function () {
	        return this.__ordinalMeta;
	      },
	      defaultOption: zrUtil.mergeAll([{}, axisDefault[axisType + 'Axis'], extraDefaultOption], true)
	    });
	  });
	  ComponentModel.registerSubTypeDefaulter(axisName + 'Axis', zrUtil.curry(axisTypeDefaulter, axisName));
	}
	
	module.exports = _default;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var defaultOption = {
	  show: true,
	  zlevel: 0,
	  z: 0,
	  // Inverse the axis.
	  inverse: false,
	  // Axis name displayed.
	  name: '',
	  // 'start' | 'middle' | 'end'
	  nameLocation: 'end',
	  // By degree. By default auto rotate by nameLocation.
	  nameRotate: null,
	  nameTruncate: {
	    maxWidth: null,
	    ellipsis: '...',
	    placeholder: '.'
	  },
	  // Use global text style by default.
	  nameTextStyle: {},
	  // The gap between axisName and axisLine.
	  nameGap: 15,
	  // Default `false` to support tooltip.
	  silent: false,
	  // Default `false` to avoid legacy user event listener fail.
	  triggerEvent: false,
	  tooltip: {
	    show: false
	  },
	  axisPointer: {},
	  axisLine: {
	    show: true,
	    onZero: true,
	    onZeroAxisIndex: null,
	    lineStyle: {
	      color: '#333',
	      width: 1,
	      type: 'solid'
	    },
	    // The arrow at both ends the the axis.
	    symbol: ['none', 'none'],
	    symbolSize: [10, 15]
	  },
	  axisTick: {
	    show: true,
	    // Whether axisTick is inside the grid or outside the grid.
	    inside: false,
	    // The length of axisTick.
	    length: 5,
	    lineStyle: {
	      width: 1
	    }
	  },
	  axisLabel: {
	    show: true,
	    // Whether axisLabel is inside the grid or outside the grid.
	    inside: false,
	    rotate: 0,
	    // true | false | null/undefined (auto)
	    showMinLabel: null,
	    // true | false | null/undefined (auto)
	    showMaxLabel: null,
	    margin: 8,
	    // formatter: null,
	    fontSize: 12
	  },
	  splitLine: {
	    show: true,
	    lineStyle: {
	      color: ['#ccc'],
	      width: 1,
	      type: 'solid'
	    }
	  },
	  splitArea: {
	    show: false,
	    areaStyle: {
	      color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
	    }
	  }
	};
	var axisDefault = {};
	axisDefault.categoryAxis = zrUtil.merge({
	  // The gap at both ends of the axis. For categoryAxis, boolean.
	  boundaryGap: true,
	  // Set false to faster category collection.
	  // Only usefull in the case like: category is
	  // ['2012-01-01', '2012-01-02', ...], where the input
	  // data has been ensured not duplicate and is large data.
	  // null means "auto":
	  // if axis.data provided, do not deduplication,
	  // else do deduplication.
	  deduplication: null,
	  // splitArea: {
	  // show: false
	  // },
	  splitLine: {
	    show: false
	  },
	  axisTick: {
	    // If tick is align with label when boundaryGap is true
	    alignWithLabel: false,
	    interval: 'auto'
	  },
	  axisLabel: {
	    interval: 'auto'
	  }
	}, defaultOption);
	axisDefault.valueAxis = zrUtil.merge({
	  // The gap at both ends of the axis. For value axis, [GAP, GAP], where
	  // `GAP` can be an absolute pixel number (like `35`), or percent (like `'30%'`)
	  boundaryGap: [0, 0],
	  // TODO
	  // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
	  // Min value of the axis. can be:
	  // + a number
	  // + 'dataMin': use the min value in data.
	  // + null/undefined: auto decide min value (consider pretty look and boundaryGap).
	  // min: null,
	  // Max value of the axis. can be:
	  // + a number
	  // + 'dataMax': use the max value in data.
	  // + null/undefined: auto decide max value (consider pretty look and boundaryGap).
	  // max: null,
	  // Readonly prop, specifies start value of the range when using data zoom.
	  // rangeStart: null
	  // Readonly prop, specifies end value of the range when using data zoom.
	  // rangeEnd: null
	  // Optional value can be:
	  // + `false`: always include value 0.
	  // + `true`: the extent do not consider value 0.
	  // scale: false,
	  // AxisTick and axisLabel and splitLine are caculated based on splitNumber.
	  splitNumber: 5,
	  // Interval specifies the span of the ticks is mandatorily.
	  // interval: null
	  // Specify min interval when auto calculate tick interval.
	  // minInterval: null
	  // Specify max interval when auto calculate tick interval.
	  // maxInterval: null
	  minorTick: {
	    // Minor tick, not available for cateogry axis.
	    show: false,
	    // Split number of minor ticks. The value should be in range of (0, 100)
	    splitNumber: 5,
	    // Lenght of minor tick
	    length: 3,
	    // Same inside with axisTick
	    // Line style
	    lineStyle: {// Default to be same with axisTick
	    }
	  },
	  minorSplitLine: {
	    show: false,
	    lineStyle: {
	      color: '#eee',
	      width: 1
	    }
	  }
	}, defaultOption);
	axisDefault.timeAxis = zrUtil.defaults({
	  scale: true,
	  min: 'dataMin',
	  max: 'dataMax'
	}, axisDefault.valueAxis);
	axisDefault.logAxis = zrUtil.defaults({
	  scale: true,
	  logBase: 10
	}, axisDefault.valueAxis);
	var _default = axisDefault;
	module.exports = _default;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(385);
	
	__webpack_require__(389);

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var AxisBuilder = __webpack_require__(390);
	
	var AxisView = __webpack_require__(391);
	
	var cartesianAxisHelper = __webpack_require__(393);
	
	var _axisSplitHelper = __webpack_require__(394);
	
	var rectCoordAxisBuildSplitArea = _axisSplitHelper.rectCoordAxisBuildSplitArea;
	var rectCoordAxisHandleRemove = _axisSplitHelper.rectCoordAxisHandleRemove;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitArea', 'splitLine', 'minorSplitLine'];
	var CartesianAxisView = AxisView.extend({
	  type: 'cartesianAxis',
	  axisPointerClass: 'CartesianAxisPointer',
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    this.group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    this.group.add(this._axisGroup);
	
	    if (!axisModel.get('show')) {
	      return;
	    }
	
	    var gridModel = axisModel.getCoordSysModel();
	    var layout = cartesianAxisHelper.layout(gridModel, axisModel);
	    var axisBuilder = new AxisBuilder(axisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	
	    this._axisGroup.add(axisBuilder.getGroup());
	
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (axisModel.get(name + '.show')) {
	        this['_' + name](axisModel, gridModel);
	      }
	    }, this);
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	    CartesianAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
	  },
	  remove: function () {
	    rectCoordAxisHandleRemove(this);
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _splitLine: function (axisModel, gridModel) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitLineModel = axisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    lineColors = zrUtil.isArray(lineColors) ? lineColors : [lineColors];
	    var gridRect = gridModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var lineCount = 0;
	    var ticksCoords = axis.getTicksCoords({
	      tickModel: splitLineModel
	    });
	    var p1 = [];
	    var p2 = [];
	    var lineStyle = lineStyleModel.getLineStyle();
	
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	
	      if (isHorizontal) {
	        p1[0] = tickCoord;
	        p1[1] = gridRect.y;
	        p2[0] = tickCoord;
	        p2[1] = gridRect.y + gridRect.height;
	      } else {
	        p1[0] = gridRect.x;
	        p1[1] = tickCoord;
	        p2[0] = gridRect.x + gridRect.width;
	        p2[1] = tickCoord;
	      }
	
	      var colorIndex = lineCount++ % lineColors.length;
	      var tickValue = ticksCoords[i].tickValue;
	
	      this._axisGroup.add(new graphic.Line({
	        anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
	        subPixelOptimize: true,
	        shape: {
	          x1: p1[0],
	          y1: p1[1],
	          x2: p2[0],
	          y2: p2[1]
	        },
	        style: zrUtil.defaults({
	          stroke: lineColors[colorIndex]
	        }, lineStyle),
	        silent: true
	      }));
	    }
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _minorSplitLine: function (axisModel, gridModel) {
	    var axis = axisModel.axis;
	    var minorSplitLineModel = axisModel.getModel('minorSplitLine');
	    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	    var gridRect = gridModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var minorTicksCoords = axis.getMinorTicksCoords();
	
	    if (!minorTicksCoords.length) {
	      return;
	    }
	
	    var p1 = [];
	    var p2 = [];
	    var lineStyle = lineStyleModel.getLineStyle();
	
	    for (var i = 0; i < minorTicksCoords.length; i++) {
	      for (var k = 0; k < minorTicksCoords[i].length; k++) {
	        var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
	
	        if (isHorizontal) {
	          p1[0] = tickCoord;
	          p1[1] = gridRect.y;
	          p2[0] = tickCoord;
	          p2[1] = gridRect.y + gridRect.height;
	        } else {
	          p1[0] = gridRect.x;
	          p1[1] = tickCoord;
	          p2[0] = gridRect.x + gridRect.width;
	          p2[1] = tickCoord;
	        }
	
	        this._axisGroup.add(new graphic.Line({
	          anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
	          subPixelOptimize: true,
	          shape: {
	            x1: p1[0],
	            y1: p1[1],
	            x2: p2[0],
	            y2: p2[1]
	          },
	          style: lineStyle,
	          silent: true
	        }));
	      }
	    }
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _splitArea: function (axisModel, gridModel) {
	    rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, gridModel);
	  }
	});
	CartesianAxisView.extend({
	  type: 'xAxis'
	});
	CartesianAxisView.extend({
	  type: 'yAxis'
	});

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var retrieve = _util.retrieve;
	var defaults = _util.defaults;
	var extend = _util.extend;
	var each = _util.each;
	
	var formatUtil = __webpack_require__(307);
	
	var graphic = __webpack_require__(268);
	
	var Model = __webpack_require__(262);
	
	var _number = __webpack_require__(306);
	
	var isRadianAroundZero = _number.isRadianAroundZero;
	var remRadian = _number.remRadian;
	
	var _symbol = __webpack_require__(360);
	
	var createSymbol = _symbol.createSymbol;
	
	var matrixUtil = __webpack_require__(233);
	
	var _vector = __webpack_require__(222);
	
	var v2ApplyTransform = _vector.applyTransform;
	
	var _axisHelper = __webpack_require__(350);
	
	var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	/**
	 * A final axis is translated and rotated from a "standard axis".
	 * So opt.position and opt.rotation is required.
	 *
	 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
	 * for example: (0, 0) ------------> (0, 50)
	 *
	 * nameDirection or tickDirection or labelDirection is 1 means tick
	 * or label is below the standard axis, whereas is -1 means above
	 * the standard axis. labelOffset means offset between label and axis,
	 * which is useful when 'onZero', where axisLabel is in the grid and
	 * label in outside grid.
	 *
	 * Tips: like always,
	 * positive rotation represents anticlockwise, and negative rotation
	 * represents clockwise.
	 * The direction of position coordinate is the same as the direction
	 * of screen coordinate.
	 *
	 * Do not need to consider axis 'inverse', which is auto processed by
	 * axis extent.
	 *
	 * @param {module:zrender/container/Group} group
	 * @param {Object} axisModel
	 * @param {Object} opt Standard axis parameters.
	 * @param {Array.<number>} opt.position [x, y]
	 * @param {number} opt.rotation by radian
	 * @param {number} [opt.nameDirection=1] 1 or -1 Used when nameLocation is 'middle' or 'center'.
	 * @param {number} [opt.tickDirection=1] 1 or -1
	 * @param {number} [opt.labelDirection=1] 1 or -1
	 * @param {number} [opt.labelOffset=0] Usefull when onZero.
	 * @param {string} [opt.axisLabelShow] default get from axisModel.
	 * @param {string} [opt.axisName] default get from axisModel.
	 * @param {number} [opt.axisNameAvailableWidth]
	 * @param {number} [opt.labelRotate] by degree, default get from axisModel.
	 * @param {number} [opt.strokeContainThreshold] Default label interval when label
	 * @param {number} [opt.nameTruncateMaxWidth]
	 */
	
	var AxisBuilder = function (axisModel, opt) {
	  /**
	   * @readOnly
	   */
	  this.opt = opt;
	  /**
	   * @readOnly
	   */
	
	  this.axisModel = axisModel; // Default value
	
	  defaults(opt, {
	    labelOffset: 0,
	    nameDirection: 1,
	    tickDirection: 1,
	    labelDirection: 1,
	    silent: true
	  });
	  /**
	   * @readOnly
	   */
	
	  this.group = new graphic.Group(); // FIXME Not use a seperate text group?
	
	  var dumbGroup = new graphic.Group({
	    position: opt.position.slice(),
	    rotation: opt.rotation
	  }); // this.group.add(dumbGroup);
	  // this._dumbGroup = dumbGroup;
	
	  dumbGroup.updateTransform();
	  this._transform = dumbGroup.transform;
	  this._dumbGroup = dumbGroup;
	};
	
	AxisBuilder.prototype = {
	  constructor: AxisBuilder,
	  hasBuilder: function (name) {
	    return !!builders[name];
	  },
	  add: function (name) {
	    builders[name].call(this);
	  },
	  getGroup: function () {
	    return this.group;
	  }
	};
	var builders = {
	  /**
	   * @private
	   */
	  axisLine: function () {
	    var opt = this.opt;
	    var axisModel = this.axisModel;
	
	    if (!axisModel.get('axisLine.show')) {
	      return;
	    }
	
	    var extent = this.axisModel.axis.getExtent();
	    var matrix = this._transform;
	    var pt1 = [extent[0], 0];
	    var pt2 = [extent[1], 0];
	
	    if (matrix) {
	      v2ApplyTransform(pt1, pt1, matrix);
	      v2ApplyTransform(pt2, pt2, matrix);
	    }
	
	    var lineStyle = extend({
	      lineCap: 'round'
	    }, axisModel.getModel('axisLine.lineStyle').getLineStyle());
	    this.group.add(new graphic.Line({
	      // Id for animation
	      anid: 'line',
	      subPixelOptimize: true,
	      shape: {
	        x1: pt1[0],
	        y1: pt1[1],
	        x2: pt2[0],
	        y2: pt2[1]
	      },
	      style: lineStyle,
	      strokeContainThreshold: opt.strokeContainThreshold || 5,
	      silent: true,
	      z2: 1
	    }));
	    var arrows = axisModel.get('axisLine.symbol');
	    var arrowSize = axisModel.get('axisLine.symbolSize');
	    var arrowOffset = axisModel.get('axisLine.symbolOffset') || 0;
	
	    if (typeof arrowOffset === 'number') {
	      arrowOffset = [arrowOffset, arrowOffset];
	    }
	
	    if (arrows != null) {
	      if (typeof arrows === 'string') {
	        // Use the same arrow for start and end point
	        arrows = [arrows, arrows];
	      }
	
	      if (typeof arrowSize === 'string' || typeof arrowSize === 'number') {
	        // Use the same size for width and height
	        arrowSize = [arrowSize, arrowSize];
	      }
	
	      var symbolWidth = arrowSize[0];
	      var symbolHeight = arrowSize[1];
	      each([{
	        rotate: opt.rotation + Math.PI / 2,
	        offset: arrowOffset[0],
	        r: 0
	      }, {
	        rotate: opt.rotation - Math.PI / 2,
	        offset: arrowOffset[1],
	        r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
	      }], function (point, index) {
	        if (arrows[index] !== 'none' && arrows[index] != null) {
	          var symbol = createSymbol(arrows[index], -symbolWidth / 2, -symbolHeight / 2, symbolWidth, symbolHeight, lineStyle.stroke, true); // Calculate arrow position with offset
	
	          var r = point.r + point.offset;
	          var pos = [pt1[0] + r * Math.cos(opt.rotation), pt1[1] - r * Math.sin(opt.rotation)];
	          symbol.attr({
	            rotation: point.rotate,
	            position: pos,
	            silent: true,
	            z2: 11
	          });
	          this.group.add(symbol);
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @private
	   */
	  axisTickLabel: function () {
	    var axisModel = this.axisModel;
	    var opt = this.opt;
	    var ticksEls = buildAxisMajorTicks(this, axisModel, opt);
	    var labelEls = buildAxisLabel(this, axisModel, opt);
	    fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
	    buildAxisMinorTicks(this, axisModel, opt);
	  },
	
	  /**
	   * @private
	   */
	  axisName: function () {
	    var opt = this.opt;
	    var axisModel = this.axisModel;
	    var name = retrieve(opt.axisName, axisModel.get('name'));
	
	    if (!name) {
	      return;
	    }
	
	    var nameLocation = axisModel.get('nameLocation');
	    var nameDirection = opt.nameDirection;
	    var textStyleModel = axisModel.getModel('nameTextStyle');
	    var gap = axisModel.get('nameGap') || 0;
	    var extent = this.axisModel.axis.getExtent();
	    var gapSignal = extent[0] > extent[1] ? -1 : 1;
	    var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // 'middle'
	    // Reuse labelOffset.
	    isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
	    var labelLayout;
	    var nameRotation = axisModel.get('nameRotate');
	
	    if (nameRotation != null) {
	      nameRotation = nameRotation * PI / 180; // To radian.
	    }
	
	    var axisNameAvailableWidth;
	
	    if (isNameLocationCenter(nameLocation)) {
	      labelLayout = innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
	      nameDirection);
	    } else {
	      labelLayout = endTextLayout(opt, nameLocation, nameRotation || 0, extent);
	      axisNameAvailableWidth = opt.axisNameAvailableWidth;
	
	      if (axisNameAvailableWidth != null) {
	        axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
	        !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
	      }
	    }
	
	    var textFont = textStyleModel.getFont();
	    var truncateOpt = axisModel.get('nameTruncate', true) || {};
	    var ellipsis = truncateOpt.ellipsis;
	    var maxWidth = retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth); // FIXME
	    // truncate rich text? (consider performance)
	
	    var truncatedText = ellipsis != null && maxWidth != null ? formatUtil.truncateText(name, maxWidth, textFont, ellipsis, {
	      minChar: 2,
	      placeholder: truncateOpt.placeholder
	    }) : name;
	    var tooltipOpt = axisModel.get('tooltip', true);
	    var mainType = axisModel.mainType;
	    var formatterParams = {
	      componentType: mainType,
	      name: name,
	      $vars: ['name']
	    };
	    formatterParams[mainType + 'Index'] = axisModel.componentIndex;
	    var textEl = new graphic.Text({
	      // Id for animation
	      anid: 'name',
	      __fullText: name,
	      __truncatedText: truncatedText,
	      position: pos,
	      rotation: labelLayout.rotation,
	      silent: isLabelSilent(axisModel),
	      z2: 1,
	      tooltip: tooltipOpt && tooltipOpt.show ? extend({
	        content: name,
	        formatter: function () {
	          return name;
	        },
	        formatterParams: formatterParams
	      }, tooltipOpt) : null
	    });
	    graphic.setTextStyle(textEl.style, textStyleModel, {
	      text: truncatedText,
	      textFont: textFont,
	      textFill: textStyleModel.getTextColor() || axisModel.get('axisLine.lineStyle.color'),
	      textAlign: textStyleModel.get('align') || labelLayout.textAlign,
	      textVerticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
	    });
	
	    if (axisModel.get('triggerEvent')) {
	      textEl.eventData = makeAxisEventDataBase(axisModel);
	      textEl.eventData.targetType = 'axisName';
	      textEl.eventData.name = name;
	    } // FIXME
	
	
	    this._dumbGroup.add(textEl);
	
	    textEl.updateTransform();
	    this.group.add(textEl);
	    textEl.decomposeTransform();
	  }
	};
	
	var makeAxisEventDataBase = AxisBuilder.makeAxisEventDataBase = function (axisModel) {
	  var eventData = {
	    componentType: axisModel.mainType,
	    componentIndex: axisModel.componentIndex
	  };
	  eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
	  return eventData;
	};
	/**
	 * @public
	 * @static
	 * @param {Object} opt
	 * @param {number} axisRotation in radian
	 * @param {number} textRotation in radian
	 * @param {number} direction
	 * @return {Object} {
	 *  rotation, // according to axis
	 *  textAlign,
	 *  textVerticalAlign
	 * }
	 */
	
	
	var innerTextLayout = AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
	  var rotationDiff = remRadian(textRotation - axisRotation);
	  var textAlign;
	  var textVerticalAlign;
	
	  if (isRadianAroundZero(rotationDiff)) {
	    // Label is parallel with axis line.
	    textVerticalAlign = direction > 0 ? 'top' : 'bottom';
	    textAlign = 'center';
	  } else if (isRadianAroundZero(rotationDiff - PI)) {
	    // Label is inverse parallel with axis line.
	    textVerticalAlign = direction > 0 ? 'bottom' : 'top';
	    textAlign = 'center';
	  } else {
	    textVerticalAlign = 'middle';
	
	    if (rotationDiff > 0 && rotationDiff < PI) {
	      textAlign = direction > 0 ? 'right' : 'left';
	    } else {
	      textAlign = direction > 0 ? 'left' : 'right';
	    }
	  }
	
	  return {
	    rotation: rotationDiff,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	};
	
	function endTextLayout(opt, textPosition, textRotate, extent) {
	  var rotationDiff = remRadian(textRotate - opt.rotation);
	  var textAlign;
	  var textVerticalAlign;
	  var inverse = extent[0] > extent[1];
	  var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
	
	  if (isRadianAroundZero(rotationDiff - PI / 2)) {
	    textVerticalAlign = onLeft ? 'bottom' : 'top';
	    textAlign = 'center';
	  } else if (isRadianAroundZero(rotationDiff - PI * 1.5)) {
	    textVerticalAlign = onLeft ? 'top' : 'bottom';
	    textAlign = 'center';
	  } else {
	    textVerticalAlign = 'middle';
	
	    if (rotationDiff < PI * 1.5 && rotationDiff > PI / 2) {
	      textAlign = onLeft ? 'left' : 'right';
	    } else {
	      textAlign = onLeft ? 'right' : 'left';
	    }
	  }
	
	  return {
	    rotation: rotationDiff,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	}
	
	var isLabelSilent = AxisBuilder.isLabelSilent = function (axisModel) {
	  var tooltipOpt = axisModel.get('tooltip');
	  return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
	  || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
	};
	
	function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
	  if (shouldShowAllLabels(axisModel.axis)) {
	    return;
	  } // If min or max are user set, we need to check
	  // If the tick on min(max) are overlap on their neighbour tick
	  // If they are overlapped, we need to hide the min(max) tick label
	
	
	  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
	  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel'); // FIXME
	  // Have not consider onBand yet, where tick els is more than label els.
	
	  labelEls = labelEls || [];
	  tickEls = tickEls || [];
	  var firstLabel = labelEls[0];
	  var nextLabel = labelEls[1];
	  var lastLabel = labelEls[labelEls.length - 1];
	  var prevLabel = labelEls[labelEls.length - 2];
	  var firstTick = tickEls[0];
	  var nextTick = tickEls[1];
	  var lastTick = tickEls[tickEls.length - 1];
	  var prevTick = tickEls[tickEls.length - 2];
	
	  if (showMinLabel === false) {
	    ignoreEl(firstLabel);
	    ignoreEl(firstTick);
	  } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
	    if (showMinLabel) {
	      ignoreEl(nextLabel);
	      ignoreEl(nextTick);
	    } else {
	      ignoreEl(firstLabel);
	      ignoreEl(firstTick);
	    }
	  }
	
	  if (showMaxLabel === false) {
	    ignoreEl(lastLabel);
	    ignoreEl(lastTick);
	  } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
	    if (showMaxLabel) {
	      ignoreEl(prevLabel);
	      ignoreEl(prevTick);
	    } else {
	      ignoreEl(lastLabel);
	      ignoreEl(lastTick);
	    }
	  }
	}
	
	function ignoreEl(el) {
	  el && (el.ignore = true);
	}
	
	function isTwoLabelOverlapped(current, next, labelLayout) {
	  // current and next has the same rotation.
	  var firstRect = current && current.getBoundingRect().clone();
	  var nextRect = next && next.getBoundingRect().clone();
	
	  if (!firstRect || !nextRect) {
	    return;
	  } // When checking intersect of two rotated labels, we use mRotationBack
	  // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
	
	
	  var mRotationBack = matrixUtil.identity([]);
	  matrixUtil.rotate(mRotationBack, mRotationBack, -current.rotation);
	  firstRect.applyTransform(matrixUtil.mul([], mRotationBack, current.getLocalTransform()));
	  nextRect.applyTransform(matrixUtil.mul([], mRotationBack, next.getLocalTransform()));
	  return firstRect.intersect(nextRect);
	}
	
	function isNameLocationCenter(nameLocation) {
	  return nameLocation === 'middle' || nameLocation === 'center';
	}
	
	function createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, aniid) {
	  var tickEls = [];
	  var pt1 = [];
	  var pt2 = [];
	
	  for (var i = 0; i < ticksCoords.length; i++) {
	    var tickCoord = ticksCoords[i].coord;
	    pt1[0] = tickCoord;
	    pt1[1] = 0;
	    pt2[0] = tickCoord;
	    pt2[1] = tickEndCoord;
	
	    if (tickTransform) {
	      v2ApplyTransform(pt1, pt1, tickTransform);
	      v2ApplyTransform(pt2, pt2, tickTransform);
	    } // Tick line, Not use group transform to have better line draw
	
	
	    var tickEl = new graphic.Line({
	      // Id for animation
	      anid: aniid + '_' + ticksCoords[i].tickValue,
	      subPixelOptimize: true,
	      shape: {
	        x1: pt1[0],
	        y1: pt1[1],
	        x2: pt2[0],
	        y2: pt2[1]
	      },
	      style: tickLineStyle,
	      z2: 2,
	      silent: true
	    });
	    tickEls.push(tickEl);
	  }
	
	  return tickEls;
	}
	
	function buildAxisMajorTicks(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var tickModel = axisModel.getModel('axisTick');
	
	  if (!tickModel.get('show') || axis.scale.isBlank()) {
	    return;
	  }
	
	  var lineStyleModel = tickModel.getModel('lineStyle');
	  var tickEndCoord = opt.tickDirection * tickModel.get('length');
	  var ticksCoords = axis.getTicksCoords();
	  var ticksEls = createTicks(ticksCoords, axisBuilder._transform, tickEndCoord, defaults(lineStyleModel.getLineStyle(), {
	    stroke: axisModel.get('axisLine.lineStyle.color')
	  }), 'ticks');
	
	  for (var i = 0; i < ticksEls.length; i++) {
	    axisBuilder.group.add(ticksEls[i]);
	  }
	
	  return ticksEls;
	}
	
	function buildAxisMinorTicks(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var minorTickModel = axisModel.getModel('minorTick');
	
	  if (!minorTickModel.get('show') || axis.scale.isBlank()) {
	    return;
	  }
	
	  var minorTicksCoords = axis.getMinorTicksCoords();
	
	  if (!minorTicksCoords.length) {
	    return;
	  }
	
	  var lineStyleModel = minorTickModel.getModel('lineStyle');
	  var tickEndCoord = opt.tickDirection * minorTickModel.get('length');
	  var minorTickLineStyle = defaults(lineStyleModel.getLineStyle(), defaults(axisModel.getModel('axisTick').getLineStyle(), {
	    stroke: axisModel.get('axisLine.lineStyle.color')
	  }));
	
	  for (var i = 0; i < minorTicksCoords.length; i++) {
	    var minorTicksEls = createTicks(minorTicksCoords[i], axisBuilder._transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
	
	    for (var k = 0; k < minorTicksEls.length; k++) {
	      axisBuilder.group.add(minorTicksEls[k]);
	    }
	  }
	}
	
	function buildAxisLabel(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var show = retrieve(opt.axisLabelShow, axisModel.get('axisLabel.show'));
	
	  if (!show || axis.scale.isBlank()) {
	    return;
	  }
	
	  var labelModel = axisModel.getModel('axisLabel');
	  var labelMargin = labelModel.get('margin');
	  var labels = axis.getViewLabels(); // Special label rotate.
	
	  var labelRotation = (retrieve(opt.labelRotate, labelModel.get('rotate')) || 0) * PI / 180;
	  var labelLayout = innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
	  var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
	  var labelEls = [];
	  var silent = isLabelSilent(axisModel);
	  var triggerEvent = axisModel.get('triggerEvent');
	  each(labels, function (labelItem, index) {
	    var tickValue = labelItem.tickValue;
	    var formattedLabel = labelItem.formattedLabel;
	    var rawLabel = labelItem.rawLabel;
	    var itemLabelModel = labelModel;
	
	    if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
	      itemLabelModel = new Model(rawCategoryData[tickValue].textStyle, labelModel, axisModel.ecModel);
	    }
	
	    var textColor = itemLabelModel.getTextColor() || axisModel.get('axisLine.lineStyle.color');
	    var tickCoord = axis.dataToCoord(tickValue);
	    var pos = [tickCoord, opt.labelOffset + opt.labelDirection * labelMargin];
	    var textEl = new graphic.Text({
	      // Id for animation
	      anid: 'label_' + tickValue,
	      position: pos,
	      rotation: labelLayout.rotation,
	      silent: silent,
	      z2: 10
	    });
	    graphic.setTextStyle(textEl.style, itemLabelModel, {
	      text: formattedLabel,
	      textAlign: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
	      textVerticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
	      textFill: typeof textColor === 'function' ? textColor( // (1) In category axis with data zoom, tick is not the original
	      // index of axis.data. So tick should not be exposed to user
	      // in category axis.
	      // (2) Compatible with previous version, which always use formatted label as
	      // input. But in interval scale the formatted label is like '223,445', which
	      // maked user repalce ','. So we modify it to return original val but remain
	      // it as 'string' to avoid error in replacing.
	      axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
	    }); // Pack data for mouse event
	
	    if (triggerEvent) {
	      textEl.eventData = makeAxisEventDataBase(axisModel);
	      textEl.eventData.targetType = 'axisLabel';
	      textEl.eventData.value = rawLabel;
	    } // FIXME
	
	
	    axisBuilder._dumbGroup.add(textEl);
	
	    textEl.updateTransform();
	    labelEls.push(textEl);
	    axisBuilder.group.add(textEl);
	    textEl.decomposeTransform();
	  });
	  return labelEls;
	}
	
	var _default = AxisBuilder;
	module.exports = _default;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(215);
	
	var axisPointerModelHelper = __webpack_require__(392);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Base class of AxisView.
	 */
	var AxisView = echarts.extendComponentView({
	  type: 'axis',
	
	  /**
	   * @private
	   */
	  _axisPointer: null,
	
	  /**
	   * @protected
	   * @type {string}
	   */
	  axisPointerClass: null,
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    // FIXME
	    // This process should proformed after coordinate systems updated
	    // (axis scale updated), and should be performed each time update.
	    // So put it here temporarily, although it is not appropriate to
	    // put a model-writing procedure in `view`.
	    this.axisPointerClass && axisPointerModelHelper.fixValue(axisModel);
	    AxisView.superApply(this, 'render', arguments);
	    updateAxisPointer(this, axisModel, ecModel, api, payload, true);
	  },
	
	  /**
	   * Action handler.
	   * @public
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/model/Global} ecModel
	   * @param {module:echarts/ExtensionAPI} api
	   * @param {Object} payload
	   */
	  updateAxisPointer: function (axisModel, ecModel, api, payload, force) {
	    updateAxisPointer(this, axisModel, ecModel, api, payload, false);
	  },
	
	  /**
	   * @override
	   */
	  remove: function (ecModel, api) {
	    var axisPointer = this._axisPointer;
	    axisPointer && axisPointer.remove(api);
	    AxisView.superApply(this, 'remove', arguments);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function (ecModel, api) {
	    disposeAxisPointer(this, api);
	    AxisView.superApply(this, 'dispose', arguments);
	  }
	});
	
	function updateAxisPointer(axisView, axisModel, ecModel, api, payload, forceRender) {
	  var Clazz = AxisView.getAxisPointerClass(axisView.axisPointerClass);
	
	  if (!Clazz) {
	    return;
	  }
	
	  var axisPointerModel = axisPointerModelHelper.getAxisPointerModel(axisModel);
	  axisPointerModel ? (axisView._axisPointer || (axisView._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : disposeAxisPointer(axisView, api);
	}
	
	function disposeAxisPointer(axisView, ecModel, api) {
	  var axisPointer = axisView._axisPointer;
	  axisPointer && axisPointer.dispose(ecModel, api);
	  axisView._axisPointer = null;
	}
	
	var axisPointerClazz = [];
	
	AxisView.registerAxisPointerClass = function (type, clazz) {
	  axisPointerClazz[type] = clazz;
	};
	
	AxisView.getAxisPointerClass = function (type) {
	  return type && axisPointerClazz[type];
	};
	
	var _default = AxisView;
	module.exports = _default;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Model = __webpack_require__(262);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var curry = zrUtil.curry; // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	// allAxesInfo should be updated when setOption performed.
	
	function collect(ecModel, api) {
	  var result = {
	    /**
	     * key: makeKey(axis.model)
	     * value: {
	     *      axis,
	     *      coordSys,
	     *      axisPointerModel,
	     *      triggerTooltip,
	     *      involveSeries,
	     *      snap,
	     *      seriesModels,
	     *      seriesDataCount
	     * }
	     */
	    axesInfo: {},
	    seriesInvolved: false,
	
	    /**
	     * key: makeKey(coordSys.model)
	     * value: Object: key makeKey(axis.model), value: axisInfo
	     */
	    coordSysAxesInfo: {},
	    coordSysMap: {}
	  };
	  collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.
	
	  result.seriesInvolved && collectSeriesInfo(result, ecModel);
	  return result;
	}
	
	function collectAxesInfo(result, ecModel, api) {
	  var globalTooltipModel = ecModel.getComponent('tooltip');
	  var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.
	
	  var linksOption = globalAxisPointerModel.get('link', true) || [];
	  var linkGroups = []; // Collect axes info.
	
	  each(api.getCoordinateSystems(), function (coordSys) {
	    // Some coordinate system do not support axes, like geo.
	    if (!coordSys.axisPointerEnabled) {
	      return;
	    }
	
	    var coordSysKey = makeKey(coordSys.model);
	    var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
	    result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
	    // for user. So we enable seting tooltip on coordSys model.
	
	    var coordSysModel = coordSys.model;
	    var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
	    each(coordSys.getAxes(), curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
	    // Notice this case: coordSys is `grid` but not `cartesian2D` here.
	
	    if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
	    // show but axisPointer will show as normal.
	    && baseTooltipModel.get('show')) {
	      // Compatible with previous logic. But series.tooltip.trigger: 'axis'
	      // or series.data[n].tooltip.trigger: 'axis' are not support any more.
	      var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
	      var cross = baseTooltipModel.get('axisPointer.type') === 'cross';
	      var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get('axisPointer.axis'));
	
	      if (triggerAxis || cross) {
	        each(tooltipAxes.baseAxes, curry(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
	      }
	
	      if (cross) {
	        each(tooltipAxes.otherAxes, curry(saveTooltipAxisInfo, 'cross', false));
	      }
	    } // fromTooltip: true | false | 'cross'
	    // triggerTooltip: true | false | null
	
	
	    function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
	      var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
	      var axisPointerShow = axisPointerModel.get('show');
	
	      if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
	        return;
	      }
	
	      if (triggerTooltip == null) {
	        triggerTooltip = axisPointerModel.get('triggerTooltip');
	      }
	
	      axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
	      var snap = axisPointerModel.get('snap');
	      var key = makeKey(axis.model);
	      var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).
	
	      var axisInfo = result.axesInfo[key] = {
	        key: key,
	        axis: axis,
	        coordSys: coordSys,
	        axisPointerModel: axisPointerModel,
	        triggerTooltip: triggerTooltip,
	        involveSeries: involveSeries,
	        snap: snap,
	        useHandle: isHandleTrigger(axisPointerModel),
	        seriesModels: []
	      };
	      axesInfoInCoordSys[key] = axisInfo;
	      result.seriesInvolved |= involveSeries;
	      var groupIndex = getLinkGroupIndex(linksOption, axis);
	
	      if (groupIndex != null) {
	        var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
	          axesInfo: {}
	        });
	        linkGroup.axesInfo[key] = axisInfo;
	        linkGroup.mapper = linksOption[groupIndex].mapper;
	        axisInfo.linkGroup = linkGroup;
	      }
	    }
	  });
	}
	
	function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
	  var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
	  var volatileOption = {};
	  each(['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'], function (field) {
	    volatileOption[field] = zrUtil.clone(tooltipAxisPointerModel.get(field));
	  }); // category axis do not auto snap, otherwise some tick that do not
	  // has value can not be hovered. value/time/log axis default snap if
	  // triggered from tooltip and trigger tooltip.
	
	  volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
	  // Only these properties can be overrided from tooltip to axisPointer.
	
	  if (tooltipAxisPointerModel.get('type') === 'cross') {
	    volatileOption.type = 'line';
	  }
	
	  var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.
	
	  labelOption.show == null && (labelOption.show = false);
	
	  if (fromTooltip === 'cross') {
	    // When 'cross', both axes show labels.
	    var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get('label.show');
	    labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
	    // (cross style is dashed by default)
	
	    if (!triggerTooltip) {
	      var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
	      crossStyle && zrUtil.defaults(labelOption, crossStyle.textStyle);
	    }
	  }
	
	  return axis.model.getModel('axisPointer', new Model(volatileOption, globalAxisPointerModel, ecModel));
	}
	
	function collectSeriesInfo(result, ecModel) {
	  // Prepare data for axis trigger
	  ecModel.eachSeries(function (seriesModel) {
	    // Notice this case: this coordSys is `cartesian2D` but not `grid`.
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesTooltipTrigger = seriesModel.get('tooltip.trigger', true);
	    var seriesTooltipShow = seriesModel.get('tooltip.show', true);
	
	    if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get('axisPointer.show', true) === false) {
	      return;
	    }
	
	    each(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
	      var axis = axisInfo.axis;
	
	      if (coordSys.getAxis(axis.dim) === axis) {
	        axisInfo.seriesModels.push(seriesModel);
	        axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
	        axisInfo.seriesDataCount += seriesModel.getData().count();
	      }
	    });
	  }, this);
	}
	/**
	 * For example:
	 * {
	 *     axisPointer: {
	 *         links: [{
	 *             xAxisIndex: [2, 4],
	 *             yAxisIndex: 'all'
	 *         }, {
	 *             xAxisId: ['a5', 'a7'],
	 *             xAxisName: 'xxx'
	 *         }]
	 *     }
	 * }
	 */
	
	
	function getLinkGroupIndex(linksOption, axis) {
	  var axisModel = axis.model;
	  var dim = axis.dim;
	
	  for (var i = 0; i < linksOption.length; i++) {
	    var linkOption = linksOption[i] || {};
	
	    if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
	      return i;
	    }
	  }
	}
	
	function checkPropInLink(linkPropValue, axisPropValue) {
	  return linkPropValue === 'all' || zrUtil.isArray(linkPropValue) && zrUtil.indexOf(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
	}
	
	function fixValue(axisModel) {
	  var axisInfo = getAxisInfo(axisModel);
	
	  if (!axisInfo) {
	    return;
	  }
	
	  var axisPointerModel = axisInfo.axisPointerModel;
	  var scale = axisInfo.axis.scale;
	  var option = axisPointerModel.option;
	  var status = axisPointerModel.get('status');
	  var value = axisPointerModel.get('value'); // Parse init value for category and time axis.
	
	  if (value != null) {
	    value = scale.parse(value);
	  }
	
	  var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
	  // and status should be initialized.
	
	  if (status == null) {
	    option.status = useHandle ? 'show' : 'hide';
	  }
	
	  var extent = scale.getExtent().slice();
	  extent[0] > extent[1] && extent.reverse();
	
	  if ( // Pick a value on axis when initializing.
	  value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
	  // where we should re-pick a value to keep `handle` displaying normally.
	  || value > extent[1]) {
	    // Make handle displayed on the end of the axis when init, which looks better.
	    value = extent[1];
	  }
	
	  if (value < extent[0]) {
	    value = extent[0];
	  }
	
	  option.value = value;
	
	  if (useHandle) {
	    option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
	  }
	}
	
	function getAxisInfo(axisModel) {
	  var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
	  return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
	}
	
	function getAxisPointerModel(axisModel) {
	  var axisInfo = getAxisInfo(axisModel);
	  return axisInfo && axisInfo.axisPointerModel;
	}
	
	function isHandleTrigger(axisPointerModel) {
	  return !!axisPointerModel.get('handle.show');
	}
	/**
	 * @param {module:echarts/model/Model} model
	 * @return {string} unique key
	 */
	
	
	function makeKey(model) {
	  return model.type + '||' + model.id;
	}
	
	exports.collect = collect;
	exports.fixValue = fixValue;
	exports.getAxisInfo = getAxisInfo;
	exports.getAxisPointerModel = getAxisPointerModel;
	exports.makeKey = makeKey;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Can only be called after coordinate system creation stage.
	 * (Can be called before coordinate system update stage).
	 *
	 * @param {Object} opt {labelInside}
	 * @return {Object} {
	 *  position, rotation, labelDirection, labelOffset,
	 *  tickDirection, labelRotate, z2
	 * }
	 */
	function layout(gridModel, axisModel, opt) {
	  opt = opt || {};
	  var grid = gridModel.coordinateSystem;
	  var axis = axisModel.axis;
	  var layout = {};
	  var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
	  var rawAxisPosition = axis.position;
	  var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
	  var axisDim = axis.dim;
	  var rect = grid.getRect();
	  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	  var idx = {
	    left: 0,
	    right: 1,
	    top: 0,
	    bottom: 1,
	    onZero: 2
	  };
	  var axisOffset = axisModel.get('offset') || 0;
	  var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];
	
	  if (otherAxisOnZeroOf) {
	    var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
	    posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
	  } // Axis position
	
	
	  layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation
	
	  layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim
	
	  var dirMap = {
	    top: -1,
	    bottom: 1,
	    left: -1,
	    right: 1
	  };
	  layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
	  layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
	
	  if (axisModel.get('axisTick.inside')) {
	    layout.tickDirection = -layout.tickDirection;
	  }
	
	  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
	    layout.labelDirection = -layout.labelDirection;
	  } // Special label rotation
	
	
	  var labelRotate = axisModel.get('axisLabel.rotate');
	  layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea
	
	  layout.z2 = 1;
	  return layout;
	}
	
	exports.layout = layout;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, gridModel) {
	  var axis = axisModel.axis;
	
	  if (axis.scale.isBlank()) {
	    return;
	  }
	
	  var splitAreaModel = axisModel.getModel('splitArea');
	  var areaStyleModel = splitAreaModel.getModel('areaStyle');
	  var areaColors = areaStyleModel.get('color');
	  var gridRect = gridModel.coordinateSystem.getRect();
	  var ticksCoords = axis.getTicksCoords({
	    tickModel: splitAreaModel,
	    clamp: true
	  });
	
	  if (!ticksCoords.length) {
	    return;
	  } // For Making appropriate splitArea animation, the color and anid
	  // should be corresponding to previous one if possible.
	
	
	  var areaColorsLen = areaColors.length;
	  var lastSplitAreaColors = axisView.__splitAreaColors;
	  var newSplitAreaColors = zrUtil.createHashMap();
	  var colorIndex = 0;
	
	  if (lastSplitAreaColors) {
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
	
	      if (cIndex != null) {
	        colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
	        break;
	      }
	    }
	  }
	
	  var prev = axis.toGlobalCoord(ticksCoords[0].coord);
	  var areaStyle = areaStyleModel.getAreaStyle();
	  areaColors = zrUtil.isArray(areaColors) ? areaColors : [areaColors];
	
	  for (var i = 1; i < ticksCoords.length; i++) {
	    var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	    var x;
	    var y;
	    var width;
	    var height;
	
	    if (axis.isHorizontal()) {
	      x = prev;
	      y = gridRect.y;
	      width = tickCoord - x;
	      height = gridRect.height;
	      prev = x + width;
	    } else {
	      x = gridRect.x;
	      y = prev;
	      width = gridRect.width;
	      height = tickCoord - y;
	      prev = y + height;
	    }
	
	    var tickValue = ticksCoords[i - 1].tickValue;
	    tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
	    axisGroup.add(new graphic.Rect({
	      anid: tickValue != null ? 'area_' + tickValue : null,
	      shape: {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      },
	      style: zrUtil.defaults({
	        fill: areaColors[colorIndex]
	      }, areaStyle),
	      silent: true
	    }));
	    colorIndex = (colorIndex + 1) % areaColorsLen;
	  }
	
	  axisView.__splitAreaColors = newSplitAreaColors;
	}
	
	function rectCoordAxisHandleRemove(axisView) {
	  axisView.__splitAreaColors = null;
	}
	
	exports.rectCoordAxisBuildSplitArea = rectCoordAxisBuildSplitArea;
	exports.rectCoordAxisHandleRemove = rectCoordAxisHandleRemove;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var _barGrid = __webpack_require__(356);
	
	var layout = _barGrid.layout;
	var largeLayout = _barGrid.largeLayout;
	
	__webpack_require__(380);
	
	__webpack_require__(396);
	
	__webpack_require__(398);
	
	__webpack_require__(379);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerLayout(echarts.PRIORITY.VISUAL.LAYOUT, zrUtil.curry(layout, 'bar')); // Use higher prority to avoid to be blocked by other overall layout, which do not
	// only exist in this module, but probably also exist in other modules, like `barPolar`.
	
	echarts.registerLayout(echarts.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, largeLayout);
	echarts.registerVisual({
	  seriesType: 'bar',
	  reset: function (seriesModel) {
	    // Visual coding for legend
	    seriesModel.getData().setVisual('legendSymbol', 'roundRect');
	  }
	});

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseBarSeries = __webpack_require__(397);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = BaseBarSeries.extend({
	  type: 'series.bar',
	  dependencies: ['grid', 'polar'],
	  brushSelector: 'rect',
	
	  /**
	   * @override
	   */
	  getProgressive: function () {
	    // Do not support progressive in normal mode.
	    return this.get('large') ? this.get('progressive') : false;
	  },
	
	  /**
	   * @override
	   */
	  getProgressiveThreshold: function () {
	    // Do not support progressive in normal mode.
	    var progressiveThreshold = this.get('progressiveThreshold');
	    var largeThreshold = this.get('largeThreshold');
	
	    if (largeThreshold > progressiveThreshold) {
	      progressiveThreshold = largeThreshold;
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    // If clipped
	    // Only available on cartesian2d
	    clip: true,
	    // If use caps on two sides of bars
	    // Only available on tangential polar bar
	    roundCap: false,
	    showBackground: false,
	    backgroundStyle: {
	      color: 'rgba(180, 180, 180, 0.2)',
	      borderColor: null,
	      borderWidth: 0,
	      borderType: 'solid',
	      borderRadius: 0,
	      shadowBlur: 0,
	      shadowColor: null,
	      shadowOffsetX: 0,
	      shadowOffsetY: 0,
	      opacity: 1
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(320);
	
	var createListFromArray = __webpack_require__(341);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.__base_bar__',
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  getMarkerPosition: function (value) {
	    var coordSys = this.coordinateSystem;
	
	    if (coordSys) {
	      // PENDING if clamp ?
	      var pt = coordSys.dataToPoint(coordSys.clampData(value));
	      var data = this.getData();
	      var offset = data.getLayout('offset');
	      var size = data.getLayout('size');
	      var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
	      pt[offsetIndex] += offset + size / 2;
	      return pt;
	    }
	
	    return [NaN, NaN];
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    // stack: null
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // 最小高度改为0
	    barMinHeight: 0,
	    // 最小角度为0，仅对极坐标系下的柱状图有效
	    barMinAngle: 0,
	    // cursor: null,
	    large: false,
	    largeThreshold: 400,
	    progressive: 3e3,
	    progressiveChunkMode: 'mod',
	    // barMaxWidth: null,
	    // In cartesian, the default value is 1. Otherwise null.
	    // barMinWidth: null,
	    // 默认自适应
	    // barWidth: null,
	    // 柱间距离，默认为柱形宽度的30%，可设固定值
	    // barGap: '30%',
	    // 类目间柱形距离，默认为类目间距的20%，可设固定值
	    // barCategoryGap: '20%',
	    // label: {
	    //      show: false
	    // },
	    itemStyle: {},
	    emphasis: {}
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var _helper = __webpack_require__(399);
	
	var setLabel = _helper.setLabel;
	
	var Model = __webpack_require__(262);
	
	var barItemStyle = __webpack_require__(400);
	
	var Path = __webpack_require__(270);
	
	var Group = __webpack_require__(230);
	
	var _throttle = __webpack_require__(327);
	
	var throttle = _throttle.throttle;
	
	var _createClipPathFromCoordSys = __webpack_require__(375);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	var Sausage = __webpack_require__(401);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'barBorderWidth'];
	var _eventPos = [0, 0]; // FIXME
	// Just for compatible with ec2.
	
	zrUtil.extend(Model.prototype, barItemStyle);
	
	function getClipArea(coord, data) {
	  var coordSysClipArea = coord.getArea && coord.getArea();
	
	  if (coord.type === 'cartesian2d') {
	    var baseAxis = coord.getBaseAxis(); // When boundaryGap is false or using time axis. bar may exceed the grid.
	    // We should not clip this part.
	    // See test/bar2.html
	
	    if (baseAxis.type !== 'category' || !baseAxis.onBand) {
	      var expandWidth = data.getLayout('bandWidth');
	
	      if (baseAxis.isHorizontal()) {
	        coordSysClipArea.x -= expandWidth;
	        coordSysClipArea.width += expandWidth * 2;
	      } else {
	        coordSysClipArea.y -= expandWidth;
	        coordSysClipArea.height += expandWidth * 2;
	      }
	    }
	  }
	
	  return coordSysClipArea;
	}
	
	var _default = echarts.extendChartView({
	  type: 'bar',
	  render: function (seriesModel, ecModel, api) {
	    this._updateDrawMode(seriesModel);
	
	    var coordinateSystemType = seriesModel.get('coordinateSystem');
	
	    if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
	      this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api);
	    } else {}
	
	    return this.group;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    this._updateDrawMode(seriesModel);
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    // Do not support progressive in normal mode.
	    this._incrementalRenderLarge(params, seriesModel);
	  },
	  _updateDrawMode: function (seriesModel) {
	    var isLargeDraw = seriesModel.pipelineContext.large;
	
	    if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
	      this._isLargeDraw = isLargeDraw;
	
	      this._clear();
	    }
	  },
	  _renderNormal: function (seriesModel, ecModel, api) {
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var coord = seriesModel.coordinateSystem;
	    var baseAxis = coord.getBaseAxis();
	    var isHorizontalOrRadial;
	
	    if (coord.type === 'cartesian2d') {
	      isHorizontalOrRadial = baseAxis.isHorizontal();
	    } else if (coord.type === 'polar') {
	      isHorizontalOrRadial = baseAxis.dim === 'angle';
	    }
	
	    var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
	    var needsClip = seriesModel.get('clip', true);
	    var coordSysClipArea = getClipArea(coord, data); // If there is clipPath created in large mode. Remove it.
	
	    group.removeClipPath(); // We don't use clipPath in normal mode because we needs a perfect animation
	    // And don't want the label are clipped.
	
	    var roundCap = seriesModel.get('roundCap', true);
	    var drawBackground = seriesModel.get('showBackground', true);
	    var backgroundModel = seriesModel.getModel('backgroundStyle');
	    var barBorderRadius = backgroundModel.get('barBorderRadius') || 0;
	    var bgEls = [];
	    var oldBgEls = this._backgroundEls || [];
	
	    var createBackground = function (dataIndex) {
	      var bgLayout = getLayout[coord.type](data, dataIndex);
	      var bgEl = createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
	      bgEl.useStyle(backgroundModel.getBarItemStyle()); // Only cartesian2d support borderRadius.
	
	      if (coord.type === 'cartesian2d') {
	        bgEl.setShape('r', barBorderRadius);
	      }
	
	      bgEls[dataIndex] = bgEl;
	      return bgEl;
	    };
	
	    data.diff(oldData).add(function (dataIndex) {
	      var itemModel = data.getItemModel(dataIndex);
	      var layout = getLayout[coord.type](data, dataIndex, itemModel);
	
	      if (drawBackground) {
	        createBackground(dataIndex);
	      } // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
	
	
	      if (!data.hasValue(dataIndex)) {
	        return;
	      }
	
	      if (needsClip) {
	        // Clip will modify the layout params.
	        // And return a boolean to determine if the shape are fully clipped.
	        var isClipped = clip[coord.type](coordSysClipArea, layout);
	
	        if (isClipped) {
	          group.remove(el);
	          return;
	        }
	      }
	
	      var el = elementCreator[coord.type](dataIndex, layout, isHorizontalOrRadial, animationModel, false, roundCap);
	      data.setItemGraphicEl(dataIndex, el);
	      group.add(el);
	      updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	    }).update(function (newIndex, oldIndex) {
	      var itemModel = data.getItemModel(newIndex);
	      var layout = getLayout[coord.type](data, newIndex, itemModel);
	
	      if (drawBackground) {
	        var bgEl;
	
	        if (oldBgEls.length === 0) {
	          bgEl = createBackground(oldIndex);
	        } else {
	          bgEl = oldBgEls[oldIndex];
	          bgEl.useStyle(backgroundModel.getBarItemStyle()); // Only cartesian2d support borderRadius.
	
	          if (coord.type === 'cartesian2d') {
	            bgEl.setShape('r', barBorderRadius);
	          }
	
	          bgEls[newIndex] = bgEl;
	        }
	
	        var bgLayout = getLayout[coord.type](data, newIndex);
	        var shape = createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
	        graphic.updateProps(bgEl, {
	          shape: shape
	        }, animationModel, newIndex);
	      }
	
	      var el = oldData.getItemGraphicEl(oldIndex);
	
	      if (!data.hasValue(newIndex)) {
	        group.remove(el);
	        return;
	      }
	
	      if (needsClip) {
	        var isClipped = clip[coord.type](coordSysClipArea, layout);
	
	        if (isClipped) {
	          group.remove(el);
	          return;
	        }
	      }
	
	      if (el) {
	        graphic.updateProps(el, {
	          shape: layout
	        }, animationModel, newIndex);
	      } else {
	        el = elementCreator[coord.type](newIndex, layout, isHorizontalOrRadial, animationModel, true, roundCap);
	      }
	
	      data.setItemGraphicEl(newIndex, el); // Add back
	
	      group.add(el);
	      updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	    }).remove(function (dataIndex) {
	      var el = oldData.getItemGraphicEl(dataIndex);
	
	      if (coord.type === 'cartesian2d') {
	        el && removeRect(dataIndex, animationModel, el);
	      } else {
	        el && removeSector(dataIndex, animationModel, el);
	      }
	    }).execute();
	    var bgGroup = this._backgroundGroup || (this._backgroundGroup = new Group());
	    bgGroup.removeAll();
	
	    for (var i = 0; i < bgEls.length; ++i) {
	      bgGroup.add(bgEls[i]);
	    }
	
	    group.add(bgGroup);
	    this._backgroundEls = bgEls;
	    this._data = data;
	  },
	  _renderLarge: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    createLarge(seriesModel, this.group); // Use clipPath in large mode.
	
	    var clipPath = seriesModel.get('clip', true) ? createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;
	
	    if (clipPath) {
	      this.group.setClipPath(clipPath);
	    } else {
	      this.group.removeClipPath();
	    }
	  },
	  _incrementalRenderLarge: function (params, seriesModel) {
	    this._removeBackground();
	
	    createLarge(seriesModel, this.group, true);
	  },
	  dispose: zrUtil.noop,
	  remove: function (ecModel) {
	    this._clear(ecModel);
	  },
	  _clear: function (ecModel) {
	    var group = this.group;
	    var data = this._data;
	
	    if (ecModel && ecModel.get('animation') && data && !this._isLargeDraw) {
	      this._removeBackground();
	
	      this._backgroundEls = [];
	      data.eachItemGraphicEl(function (el) {
	        if (el.type === 'sector') {
	          removeSector(el.dataIndex, ecModel, el);
	        } else {
	          removeRect(el.dataIndex, ecModel, el);
	        }
	      });
	    } else {
	      group.removeAll();
	    }
	
	    this._data = null;
	  },
	  _removeBackground: function () {
	    this.group.remove(this._backgroundGroup);
	    this._backgroundGroup = null;
	  }
	});
	
	var mathMax = Math.max;
	var mathMin = Math.min;
	var clip = {
	  cartesian2d: function (coordSysBoundingRect, layout) {
	    var signWidth = layout.width < 0 ? -1 : 1;
	    var signHeight = layout.height < 0 ? -1 : 1; // Needs positive width and height
	
	    if (signWidth < 0) {
	      layout.x += layout.width;
	      layout.width = -layout.width;
	    }
	
	    if (signHeight < 0) {
	      layout.y += layout.height;
	      layout.height = -layout.height;
	    }
	
	    var x = mathMax(layout.x, coordSysBoundingRect.x);
	    var x2 = mathMin(layout.x + layout.width, coordSysBoundingRect.x + coordSysBoundingRect.width);
	    var y = mathMax(layout.y, coordSysBoundingRect.y);
	    var y2 = mathMin(layout.y + layout.height, coordSysBoundingRect.y + coordSysBoundingRect.height);
	    layout.x = x;
	    layout.y = y;
	    layout.width = x2 - x;
	    layout.height = y2 - y;
	    var clipped = layout.width < 0 || layout.height < 0; // Reverse back
	
	    if (signWidth < 0) {
	      layout.x += layout.width;
	      layout.width = -layout.width;
	    }
	
	    if (signHeight < 0) {
	      layout.y += layout.height;
	      layout.height = -layout.height;
	    }
	
	    return clipped;
	  },
	  polar: function (coordSysClipArea, layout) {
	    var signR = layout.r0 <= layout.r ? 1 : -1; // Make sure r is larger than r0
	
	    if (signR < 0) {
	      var r = layout.r;
	      layout.r = layout.r0;
	      layout.r0 = r;
	    }
	
	    var r = mathMin(layout.r, coordSysClipArea.r);
	    var r0 = mathMax(layout.r0, coordSysClipArea.r0);
	    layout.r = r;
	    layout.r0 = r0;
	    var clipped = r - r0 < 0; // Reverse back
	
	    if (signR < 0) {
	      var r = layout.r;
	      layout.r = layout.r0;
	      layout.r0 = r;
	    }
	
	    return clipped;
	  }
	};
	var elementCreator = {
	  cartesian2d: function (dataIndex, layout, isHorizontal, animationModel, isUpdate) {
	    var rect = new graphic.Rect({
	      shape: zrUtil.extend({}, layout),
	      z2: 1
	    });
	    rect.name = 'item'; // Animation
	
	    if (animationModel) {
	      var rectShape = rect.shape;
	      var animateProperty = isHorizontal ? 'height' : 'width';
	      var animateTarget = {};
	      rectShape[animateProperty] = 0;
	      animateTarget[animateProperty] = layout[animateProperty];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](rect, {
	        shape: animateTarget
	      }, animationModel, dataIndex);
	    }
	
	    return rect;
	  },
	  polar: function (dataIndex, layout, isRadial, animationModel, isUpdate, roundCap) {
	    // Keep the same logic with bar in catesion: use end value to control
	    // direction. Notice that if clockwise is true (by default), the sector
	    // will always draw clockwisely, no matter whether endAngle is greater
	    // or less than startAngle.
	    var clockwise = layout.startAngle < layout.endAngle;
	    var ShapeClass = !isRadial && roundCap ? Sausage : graphic.Sector;
	    var sector = new ShapeClass({
	      shape: zrUtil.defaults({
	        clockwise: clockwise
	      }, layout),
	      z2: 1
	    });
	    sector.name = 'item'; // Animation
	
	    if (animationModel) {
	      var sectorShape = sector.shape;
	      var animateProperty = isRadial ? 'r' : 'endAngle';
	      var animateTarget = {};
	      sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
	      animateTarget[animateProperty] = layout[animateProperty];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](sector, {
	        shape: animateTarget
	      }, animationModel, dataIndex);
	    }
	
	    return sector;
	  }
	};
	
	function removeRect(dataIndex, animationModel, el) {
	  // Not show text when animating
	  el.style.text = null;
	  graphic.updateProps(el, {
	    shape: {
	      width: 0
	    }
	  }, animationModel, dataIndex, function () {
	    el.parent && el.parent.remove(el);
	  });
	}
	
	function removeSector(dataIndex, animationModel, el) {
	  // Not show text when animating
	  el.style.text = null;
	  graphic.updateProps(el, {
	    shape: {
	      r: el.shape.r0
	    }
	  }, animationModel, dataIndex, function () {
	    el.parent && el.parent.remove(el);
	  });
	}
	
	var getLayout = {
	  // itemModel is only used to get borderWidth, which is not needed
	  // when calculating bar background layout.
	  cartesian2d: function (data, dataIndex, itemModel) {
	    var layout = data.getItemLayout(dataIndex);
	    var fixedLineWidth = itemModel ? getLineWidth(itemModel, layout) : 0; // fix layout with lineWidth
	
	    var signX = layout.width > 0 ? 1 : -1;
	    var signY = layout.height > 0 ? 1 : -1;
	    return {
	      x: layout.x + signX * fixedLineWidth / 2,
	      y: layout.y + signY * fixedLineWidth / 2,
	      width: layout.width - signX * fixedLineWidth,
	      height: layout.height - signY * fixedLineWidth
	    };
	  },
	  polar: function (data, dataIndex, itemModel) {
	    var layout = data.getItemLayout(dataIndex);
	    return {
	      cx: layout.cx,
	      cy: layout.cy,
	      r0: layout.r0,
	      r: layout.r,
	      startAngle: layout.startAngle,
	      endAngle: layout.endAngle
	    };
	  }
	};
	
	function isZeroOnPolar(layout) {
	  return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
	}
	
	function updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontal, isPolar) {
	  var color = data.getItemVisual(dataIndex, 'color');
	  var opacity = data.getItemVisual(dataIndex, 'opacity');
	  var stroke = data.getVisual('borderColor');
	  var itemStyleModel = itemModel.getModel('itemStyle');
	  var hoverStyle = itemModel.getModel('emphasis.itemStyle').getBarItemStyle();
	
	  if (!isPolar) {
	    el.setShape('r', itemStyleModel.get('barBorderRadius') || 0);
	  }
	
	  el.useStyle(zrUtil.defaults({
	    stroke: isZeroOnPolar(layout) ? 'none' : stroke,
	    fill: isZeroOnPolar(layout) ? 'none' : color,
	    opacity: opacity
	  }, itemStyleModel.getBarItemStyle()));
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && el.attr('cursor', cursorStyle);
	  var labelPositionOutside = isHorizontal ? layout.height > 0 ? 'bottom' : 'top' : layout.width > 0 ? 'left' : 'right';
	
	  if (!isPolar) {
	    setLabel(el.style, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside);
	  }
	
	  if (isZeroOnPolar(layout)) {
	    hoverStyle.fill = hoverStyle.stroke = 'none';
	  }
	
	  graphic.setHoverStyle(el, hoverStyle);
	} // In case width or height are too small.
	
	
	function getLineWidth(itemModel, rawLayout) {
	  var lineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0; // width or height may be NaN for empty data
	
	  var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
	  var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
	  return Math.min(lineWidth, width, height);
	}
	
	var LargePath = Path.extend({
	  type: 'largeBar',
	  shape: {
	    points: []
	  },
	  buildPath: function (ctx, shape) {
	    // Drawing lines is more efficient than drawing
	    // a whole line or drawing rects.
	    var points = shape.points;
	    var startPoint = this.__startPoint;
	    var baseDimIdx = this.__baseDimIdx;
	
	    for (var i = 0; i < points.length; i += 2) {
	      startPoint[baseDimIdx] = points[i + baseDimIdx];
	      ctx.moveTo(startPoint[0], startPoint[1]);
	      ctx.lineTo(points[i], points[i + 1]);
	    }
	  }
	});
	
	function createLarge(seriesModel, group, incremental) {
	  // TODO support polar
	  var data = seriesModel.getData();
	  var startPoint = [];
	  var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
	  startPoint[1 - baseDimIdx] = data.getLayout('valueAxisStart');
	  var largeDataIndices = data.getLayout('largeDataIndices');
	  var barWidth = data.getLayout('barWidth');
	  var backgroundModel = seriesModel.getModel('backgroundStyle');
	  var drawBackground = seriesModel.get('showBackground', true);
	
	  if (drawBackground) {
	    var points = data.getLayout('largeBackgroundPoints');
	    var backgroundStartPoint = [];
	    backgroundStartPoint[1 - baseDimIdx] = data.getLayout('backgroundStart');
	    var bgEl = new LargePath({
	      shape: {
	        points: points
	      },
	      incremental: !!incremental,
	      __startPoint: backgroundStartPoint,
	      __baseDimIdx: baseDimIdx,
	      __largeDataIndices: largeDataIndices,
	      __barWidth: barWidth,
	      silent: true,
	      z2: 0
	    });
	    setLargeBackgroundStyle(bgEl, backgroundModel, data);
	    group.add(bgEl);
	  }
	
	  var el = new LargePath({
	    shape: {
	      points: data.getLayout('largePoints')
	    },
	    incremental: !!incremental,
	    __startPoint: startPoint,
	    __baseDimIdx: baseDimIdx,
	    __largeDataIndices: largeDataIndices,
	    __barWidth: barWidth
	  });
	  group.add(el);
	  setLargeStyle(el, seriesModel, data); // Enable tooltip and user mouse/touch event handlers.
	
	  el.seriesIndex = seriesModel.seriesIndex;
	
	  if (!seriesModel.get('silent')) {
	    el.on('mousedown', largePathUpdateDataIndex);
	    el.on('mousemove', largePathUpdateDataIndex);
	  }
	} // Use throttle to avoid frequently traverse to find dataIndex.
	
	
	var largePathUpdateDataIndex = throttle(function (event) {
	  var largePath = this;
	  var dataIndex = largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
	  largePath.dataIndex = dataIndex >= 0 ? dataIndex : null;
	}, 30, false);
	
	function largePathFindDataIndex(largePath, x, y) {
	  var baseDimIdx = largePath.__baseDimIdx;
	  var valueDimIdx = 1 - baseDimIdx;
	  var points = largePath.shape.points;
	  var largeDataIndices = largePath.__largeDataIndices;
	  var barWidthHalf = Math.abs(largePath.__barWidth / 2);
	  var startValueVal = largePath.__startPoint[valueDimIdx];
	  _eventPos[0] = x;
	  _eventPos[1] = y;
	  var pointerBaseVal = _eventPos[baseDimIdx];
	  var pointerValueVal = _eventPos[1 - baseDimIdx];
	  var baseLowerBound = pointerBaseVal - barWidthHalf;
	  var baseUpperBound = pointerBaseVal + barWidthHalf;
	
	  for (var i = 0, len = points.length / 2; i < len; i++) {
	    var ii = i * 2;
	    var barBaseVal = points[ii + baseDimIdx];
	    var barValueVal = points[ii + valueDimIdx];
	
	    if (barBaseVal >= baseLowerBound && barBaseVal <= baseUpperBound && (startValueVal <= barValueVal ? pointerValueVal >= startValueVal && pointerValueVal <= barValueVal : pointerValueVal >= barValueVal && pointerValueVal <= startValueVal)) {
	      return largeDataIndices[i];
	    }
	  }
	
	  return -1;
	}
	
	function setLargeStyle(el, seriesModel, data) {
	  var borderColor = data.getVisual('borderColor') || data.getVisual('color');
	  var itemStyle = seriesModel.getModel('itemStyle').getItemStyle(['color', 'borderColor']);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor;
	  el.style.lineWidth = data.getLayout('barWidth');
	}
	
	function setLargeBackgroundStyle(el, backgroundModel, data) {
	  var borderColor = backgroundModel.get('borderColor') || backgroundModel.get('color');
	  var itemStyle = backgroundModel.getItemStyle(['color', 'borderColor']);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor;
	  el.style.lineWidth = data.getLayout('barWidth');
	}
	
	function createBackgroundShape(isHorizontalOrRadial, layout, coord) {
	  var coordLayout;
	  var isPolar = coord.type === 'polar';
	
	  if (isPolar) {
	    coordLayout = coord.getArea();
	  } else {
	    coordLayout = coord.grid.getRect();
	  }
	
	  if (isPolar) {
	    return {
	      cx: coordLayout.cx,
	      cy: coordLayout.cy,
	      r0: isHorizontalOrRadial ? coordLayout.r0 : layout.r0,
	      r: isHorizontalOrRadial ? coordLayout.r : layout.r,
	      startAngle: isHorizontalOrRadial ? layout.startAngle : 0,
	      endAngle: isHorizontalOrRadial ? layout.endAngle : Math.PI * 2
	    };
	  } else {
	    return {
	      x: isHorizontalOrRadial ? layout.x : coordLayout.x,
	      y: isHorizontalOrRadial ? coordLayout.y : layout.y,
	      width: isHorizontalOrRadial ? layout.width : coordLayout.width,
	      height: isHorizontalOrRadial ? coordLayout.height : layout.height
	    };
	  }
	}
	
	function createBackgroundEl(coord, isHorizontalOrRadial, layout) {
	  var ElementClz = coord.type === 'polar' ? graphic.Sector : graphic.Rect;
	  return new ElementClz({
	    shape: createBackgroundShape(isHorizontalOrRadial, layout, coord),
	    silent: true,
	    z2: 0
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var _labelHelper = __webpack_require__(371);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function setLabel(normalStyle, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside) {
	  var labelModel = itemModel.getModel('label');
	  var hoverLabelModel = itemModel.getModel('emphasis.label');
	  graphic.setLabelStyle(normalStyle, hoverStyle, labelModel, hoverLabelModel, {
	    labelFetcher: seriesModel,
	    labelDataIndex: dataIndex,
	    defaultText: getDefaultLabel(seriesModel.getData(), dataIndex),
	    isRectText: true,
	    autoColor: color
	  });
	  fixPosition(normalStyle);
	  fixPosition(hoverStyle);
	}
	
	function fixPosition(style, labelPositionOutside) {
	  if (style.textPosition === 'outside') {
	    style.textPosition = labelPositionOutside;
	  }
	}
	
	exports.setLabel = setLabel;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(265);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getBarItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], // Compatitable with 2
	['stroke', 'barBorderColor'], ['lineWidth', 'barBorderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	var _default = {
	  getBarItemStyle: function (excludes) {
	    var style = getBarItemStyle(this, excludes);
	
	    if (this.getBorderLineDash) {
	      var lineDash = this.getBorderLineDash();
	      lineDash && (style.lineDash = lineDash);
	    }
	
	    return style;
	  }
	};
	module.exports = _default;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _graphic = __webpack_require__(268);
	
	var extendShape = _graphic.extendShape;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Sausage: similar to sector, but have half circle on both sides
	 * @public
	 */
	var _default = extendShape({
	  type: 'sausage',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r0: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r0 = Math.max(shape.r0 || 0, 0);
	    var r = Math.max(shape.r, 0);
	    var dr = (r - r0) * 0.5;
	    var rCenter = r0 + dr;
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitStartX = Math.cos(startAngle);
	    var unitStartY = Math.sin(startAngle);
	    var unitEndX = Math.cos(endAngle);
	    var unitEndY = Math.sin(endAngle);
	    var lessThanCircle = clockwise ? endAngle - startAngle < Math.PI * 2 : startAngle - endAngle < Math.PI * 2;
	
	    if (lessThanCircle) {
	      ctx.moveTo(unitStartX * r0 + x, unitStartY * r0 + y);
	      ctx.arc(unitStartX * rCenter + x, unitStartY * rCenter + y, dr, -Math.PI + startAngle, startAngle, !clockwise);
	    }
	
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	    ctx.moveTo(unitEndX * r + x, unitEndY * r + y);
	    ctx.arc(unitEndX * rCenter + x, unitEndY * rCenter + y, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
	
	    if (r0 !== 0) {
	      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
	      ctx.moveTo(unitStartX * r0 + x, unitEndY * r0 + y);
	    }
	
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	__webpack_require__(403);
	
	__webpack_require__(407);
	
	var createDataSelectAction = __webpack_require__(408);
	
	var dataColor = __webpack_require__(409);
	
	var pieLayout = __webpack_require__(410);
	
	var dataFilter = __webpack_require__(412);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	createDataSelectAction('pie', [{
	  type: 'pieToggleSelect',
	  event: 'pieselectchanged',
	  method: 'toggleSelected'
	}, {
	  type: 'pieSelect',
	  event: 'pieselected',
	  method: 'select'
	}, {
	  type: 'pieUnSelect',
	  event: 'pieunselected',
	  method: 'unSelect'
	}]);
	echarts.registerVisual(dataColor('pie'));
	echarts.registerLayout(zrUtil.curry(pieLayout, 'pie'));
	echarts.registerProcessor(dataFilter('pie'));

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var createListSimply = __webpack_require__(404);
	
	var zrUtil = __webpack_require__(220);
	
	var modelUtil = __webpack_require__(261);
	
	var _number = __webpack_require__(306);
	
	var getPercentWithPrecision = _number.getPercentWithPrecision;
	
	var dataSelectableMixin = __webpack_require__(405);
	
	var _dataProvider = __webpack_require__(322);
	
	var retrieveRawAttr = _dataProvider.retrieveRawAttr;
	
	var _sourceHelper = __webpack_require__(311);
	
	var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;
	
	var LegendVisualProvider = __webpack_require__(406);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PieSeries = echarts.extendSeriesModel({
	  type: 'series.pie',
	  // Overwrite
	  init: function (option) {
	    PieSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
	    this.updateSelectedMap(this._createSelectableList());
	
	    this._defaultLabelLine(option);
	  },
	  // Overwrite
	  mergeOption: function (newOption) {
	    PieSeries.superCall(this, 'mergeOption', newOption);
	    this.updateSelectedMap(this._createSelectableList());
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      coordDimensions: ['value'],
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
	    });
	  },
	  _createSelectableList: function () {
	    var data = this.getRawData();
	    var valueDim = data.mapDimension('value');
	    var targetList = [];
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      targetList.push({
	        name: data.getName(i),
	        value: data.get(valueDim, i),
	        selected: retrieveRawAttr(data, i, 'selected')
	      });
	    }
	
	    return targetList;
	  },
	  // Overwrite
	  getDataParams: function (dataIndex) {
	    var data = this.getData();
	    var params = PieSeries.superCall(this, 'getDataParams', dataIndex); // FIXME toFixed?
	
	    var valueList = [];
	    data.each(data.mapDimension('value'), function (value) {
	      valueList.push(value);
	    });
	    params.percent = getPercentWithPrecision(valueList, dataIndex, data.hostModel.get('percentPrecision'));
	    params.$vars.push('percent');
	    return params;
	  },
	  _defaultLabelLine: function (option) {
	    // Extend labelLine emphasis
	    modelUtil.defaultEmphasis(option, 'labelLine', ['show']);
	    var labelLineNormalOpt = option.labelLine;
	    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
	
	    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
	    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    radius: [0, '75%'],
	    // 默认顺时针
	    clockwise: true,
	    startAngle: 90,
	    // 最小角度改为0
	    minAngle: 0,
	    // If the angle of a sector less than `minShowLabelAngle`,
	    // the label will not be displayed.
	    minShowLabelAngle: 0,
	    // 选中时扇区偏移量
	    selectedOffset: 10,
	    // 高亮扇区偏移量
	    hoverOffset: 10,
	    // If use strategy to avoid label overlapping
	    avoidLabelOverlap: true,
	    // 选择模式，默认关闭，可选single，multiple
	    // selectedMode: false,
	    // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
	    // roseType: null,
	    percentPrecision: 2,
	    // If still show when all data zero.
	    stillShowZeroSum: true,
	    // cursor: null,
	    left: 0,
	    top: 0,
	    right: 0,
	    bottom: 0,
	    width: null,
	    height: null,
	    label: {
	      // If rotate around circle
	      rotate: false,
	      show: true,
	      // 'outer', 'inside', 'center'
	      position: 'outer',
	      // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
	      alignTo: 'none',
	      // Closest distance between label and chart edge.
	      // Works only position is 'outer' and alignTo is 'edge'.
	      margin: '25%',
	      // Works only position is 'outer' and alignTo is not 'edge'.
	      bleedMargin: 10,
	      // Distance between text and label line.
	      distanceToLabelLine: 5 // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	      // 默认使用全局文本样式，详见TEXTSTYLE
	      // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数
	
	    },
	    // Enabled when label.normal.position is 'outer'
	    labelLine: {
	      show: true,
	      // 引导线两段中的第一段长度
	      length: 15,
	      // 引导线两段中的第二段长度
	      length2: 15,
	      smooth: false,
	      lineStyle: {
	        // color: 各异,
	        width: 1,
	        type: 'solid'
	      }
	    },
	    itemStyle: {
	      borderWidth: 1
	    },
	    // Animation type. Valid values: expansion, scale
	    animationType: 'expansion',
	    // Animation type when update. Valid values: transition, expansion
	    animationTypeUpdate: 'transition',
	    animationEasing: 'cubicOut'
	  }
	});
	zrUtil.mixin(PieSeries, dataSelectableMixin);
	var _default = PieSeries;
	module.exports = _default;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createDimensions = __webpack_require__(346);
	
	var List = __webpack_require__(342);
	
	var _util = __webpack_require__(220);
	
	var extend = _util.extend;
	var isArray = _util.isArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [Usage]:
	 * (1)
	 * createListSimply(seriesModel, ['value']);
	 * (2)
	 * createListSimply(seriesModel, {
	 *     coordDimensions: ['value'],
	 *     dimensionsCount: 5
	 * });
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Object|Array.<string|Object>} opt opt or coordDimensions
	 *        The options in opt, see `echarts/data/helper/createDimensions`
	 * @param {Array.<string>} [nameList]
	 * @return {module:echarts/data/List}
	 */
	function _default(seriesModel, opt, nameList) {
	  opt = isArray(opt) && {
	    coordDimensions: opt
	  } || extend({}, opt);
	  var source = seriesModel.getSource();
	  var dimensionsInfo = createDimensions(source, opt);
	  var list = new List(dimensionsInfo, seriesModel);
	  list.initData(source, nameList);
	  return list;
	}
	
	module.exports = _default;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Data selectable mixin for chart series.
	 * To eanble data select, option of series must have `selectedMode`.
	 * And each data item will use `selected` to toggle itself selected status
	 */
	var _default = {
	  /**
	   * @param {Array.<Object>} targetList [{name, value, selected}, ...]
	   *        If targetList is an array, it should like [{name: ..., value: ...}, ...].
	   *        If targetList is a "List", it must have coordDim: 'value' dimension and name.
	   */
	  updateSelectedMap: function (targetList) {
	    this._targetList = zrUtil.isArray(targetList) ? targetList.slice() : [];
	    this._selectTargetMap = zrUtil.reduce(targetList || [], function (targetMap, target) {
	      targetMap.set(target.name, target);
	      return targetMap;
	    }, zrUtil.createHashMap());
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  // PENGING If selectedMode is null ?
	  select: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	    var selectedMode = this.get('selectedMode');
	
	    if (selectedMode === 'single') {
	      this._selectTargetMap.each(function (target) {
	        target.selected = false;
	      });
	    }
	
	    target && (target.selected = true);
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  unSelect: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name); // var selectedMode = this.get('selectedMode');
	    // selectedMode !== 'single' && target && (target.selected = false);
	
	    target && (target.selected = false);
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  toggleSelected: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	
	    if (target != null) {
	      this[target.selected ? 'unSelect' : 'select'](name, id);
	      return target.selected;
	    }
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  isSelected: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	    return target && target.selected;
	  }
	};
	module.exports = _default;

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * LegendVisualProvider is an bridge that pick encoded color from data and
	 * provide to the legend component.
	 * @param {Function} getDataWithEncodedVisual Function to get data after filtered. It stores all the encoding info
	 * @param {Function} getRawData Function to get raw data before filtered.
	 */
	function LegendVisualProvider(getDataWithEncodedVisual, getRawData) {
	  this.getAllNames = function () {
	    var rawData = getRawData(); // We find the name from the raw data. In case it's filtered by the legend component.
	    // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
	
	    return rawData.mapArray(rawData.getName);
	  };
	
	  this.containName = function (name) {
	    var rawData = getRawData();
	    return rawData.indexOfName(name) >= 0;
	  };
	
	  this.indexOfName = function (name) {
	    // Only get data when necessary.
	    // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
	    // Invoking Series#getData immediately will throw an error.
	    var dataWithEncodedVisual = getDataWithEncodedVisual();
	    return dataWithEncodedVisual.indexOfName(name);
	  };
	
	  this.getItemVisual = function (dataIndex, key) {
	    // Get encoded visual properties from final filtered data.
	    var dataWithEncodedVisual = getDataWithEncodedVisual();
	    return dataWithEncodedVisual.getItemVisual(dataIndex, key);
	  };
	}
	
	var _default = LegendVisualProvider;
	module.exports = _default;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var ChartView = __webpack_require__(325);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {boolean} hasAnimation
	 * @inner
	 */
	function updateDataSelected(uid, seriesModel, hasAnimation, api) {
	  var data = seriesModel.getData();
	  var dataIndex = this.dataIndex;
	  var name = data.getName(dataIndex);
	  var selectedOffset = seriesModel.get('selectedOffset');
	  api.dispatchAction({
	    type: 'pieToggleSelect',
	    from: uid,
	    name: name,
	    seriesId: seriesModel.id
	  });
	  data.each(function (idx) {
	    toggleItemSelected(data.getItemGraphicEl(idx), data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), selectedOffset, hasAnimation);
	  });
	}
	/**
	 * @param {module:zrender/graphic/Sector} el
	 * @param {Object} layout
	 * @param {boolean} isSelected
	 * @param {number} selectedOffset
	 * @param {boolean} hasAnimation
	 * @inner
	 */
	
	
	function toggleItemSelected(el, layout, isSelected, selectedOffset, hasAnimation) {
	  var midAngle = (layout.startAngle + layout.endAngle) / 2;
	  var dx = Math.cos(midAngle);
	  var dy = Math.sin(midAngle);
	  var offset = isSelected ? selectedOffset : 0;
	  var position = [dx * offset, dy * offset];
	  hasAnimation // animateTo will stop revious animation like update transition
	  ? el.animate().when(200, {
	    position: position
	  }).start('bounceOut') : el.attr('position', position);
	}
	/**
	 * Piece of pie including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function PiePiece(data, idx) {
	  graphic.Group.call(this);
	  var sector = new graphic.Sector({
	    z2: 2
	  });
	  var polyline = new graphic.Polyline();
	  var text = new graphic.Text();
	  this.add(sector);
	  this.add(polyline);
	  this.add(text);
	  this.updateData(data, idx, true);
	}
	
	var piePieceProto = PiePiece.prototype;
	
	piePieceProto.updateData = function (data, idx, firstCreate) {
	  var sector = this.childAt(0);
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var sectorShape = zrUtil.extend({}, layout);
	  sectorShape.label = null;
	  var animationTypeUpdate = seriesModel.getShallow('animationTypeUpdate');
	
	  if (firstCreate) {
	    sector.setShape(sectorShape);
	    var animationType = seriesModel.getShallow('animationType');
	
	    if (animationType === 'scale') {
	      sector.shape.r = layout.r0;
	      graphic.initProps(sector, {
	        shape: {
	          r: layout.r
	        }
	      }, seriesModel, idx);
	    } // Expansion
	    else {
	        sector.shape.endAngle = layout.startAngle;
	        graphic.updateProps(sector, {
	          shape: {
	            endAngle: layout.endAngle
	          }
	        }, seriesModel, idx);
	      }
	  } else {
	    if (animationTypeUpdate === 'expansion') {
	      // Sectors are set to be target shape and an overlaying clipPath is used for animation
	      sector.setShape(sectorShape);
	    } else {
	      // Transition animation from the old shape
	      graphic.updateProps(sector, {
	        shape: sectorShape
	      }, seriesModel, idx);
	    }
	  } // Update common style
	
	
	  var visualColor = data.getItemVisual(idx, 'color');
	  sector.useStyle(zrUtil.defaults({
	    lineJoin: 'bevel',
	    fill: visualColor
	  }, itemModel.getModel('itemStyle').getItemStyle()));
	  sector.hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && sector.attr('cursor', cursorStyle); // Toggle selected
	
	  toggleItemSelected(this, data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), seriesModel.get('selectedOffset'), seriesModel.get('animation')); // Label and text animation should be applied only for transition type animation when update
	
	  var withAnimation = !firstCreate && animationTypeUpdate === 'transition';
	
	  this._updateLabel(data, idx, withAnimation);
	
	  this.highDownOnUpdate = !seriesModel.get('silent') ? function (fromState, toState) {
	    var hasAnimation = seriesModel.isAnimationEnabled() && itemModel.get('hoverAnimation');
	
	    if (toState === 'emphasis') {
	      labelLine.ignore = labelLine.hoverIgnore;
	      labelText.ignore = labelText.hoverIgnore; // Sector may has animation of updating data. Force to move to the last frame
	      // Or it may stopped on the wrong shape
	
	      if (hasAnimation) {
	        sector.stopAnimation(true);
	        sector.animateTo({
	          shape: {
	            r: layout.r + seriesModel.get('hoverOffset')
	          }
	        }, 300, 'elasticOut');
	      }
	    } else {
	      labelLine.ignore = labelLine.normalIgnore;
	      labelText.ignore = labelText.normalIgnore;
	
	      if (hasAnimation) {
	        sector.stopAnimation(true);
	        sector.animateTo({
	          shape: {
	            r: layout.r
	          }
	        }, 300, 'elasticOut');
	      }
	    }
	  } : null;
	  graphic.setHoverStyle(this);
	};
	
	piePieceProto._updateLabel = function (data, idx, withAnimation) {
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var labelLayout = layout.label;
	  var visualColor = data.getItemVisual(idx, 'color');
	
	  if (!labelLayout || isNaN(labelLayout.x) || isNaN(labelLayout.y)) {
	    labelText.ignore = labelText.normalIgnore = labelText.hoverIgnore = labelLine.ignore = labelLine.normalIgnore = labelLine.hoverIgnore = true;
	    return;
	  }
	
	  var targetLineShape = {
	    points: labelLayout.linePoints || [[labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y]]
	  };
	  var targetTextStyle = {
	    x: labelLayout.x,
	    y: labelLayout.y
	  };
	
	  if (withAnimation) {
	    graphic.updateProps(labelLine, {
	      shape: targetLineShape
	    }, seriesModel, idx);
	    graphic.updateProps(labelText, {
	      style: targetTextStyle
	    }, seriesModel, idx);
	  } else {
	    labelLine.attr({
	      shape: targetLineShape
	    });
	    labelText.attr({
	      style: targetTextStyle
	    });
	  }
	
	  labelText.attr({
	    rotation: labelLayout.rotation,
	    origin: [labelLayout.x, labelLayout.y],
	    z2: 10
	  });
	  var labelModel = itemModel.getModel('label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelLineModel = itemModel.getModel('labelLine');
	  var labelLineHoverModel = itemModel.getModel('emphasis.labelLine');
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
	    labelFetcher: data.hostModel,
	    labelDataIndex: idx,
	    defaultText: labelLayout.text,
	    autoColor: visualColor,
	    useInsideStyle: !!labelLayout.inside
	  }, {
	    textAlign: labelLayout.textAlign,
	    textVerticalAlign: labelLayout.verticalAlign,
	    opacity: data.getItemVisual(idx, 'opacity')
	  });
	  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
	  labelText.hoverIgnore = !labelHoverModel.get('show');
	  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
	  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color
	
	  labelLine.setStyle({
	    stroke: visualColor,
	    opacity: data.getItemVisual(idx, 'opacity')
	  });
	  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
	  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
	  var smooth = labelLineModel.get('smooth');
	
	  if (smooth && smooth === true) {
	    smooth = 0.4;
	  }
	
	  labelLine.setShape({
	    smooth: smooth
	  });
	};
	
	zrUtil.inherits(PiePiece, graphic.Group); // Pie view
	
	var PieView = ChartView.extend({
	  type: 'pie',
	  init: function () {
	    var sectorGroup = new graphic.Group();
	    this._sectorGroup = sectorGroup;
	  },
	  render: function (seriesModel, ecModel, api, payload) {
	    if (payload && payload.from === this.uid) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    var hasAnimation = ecModel.get('animation');
	    var isFirstRender = !oldData;
	    var animationType = seriesModel.get('animationType');
	    var animationTypeUpdate = seriesModel.get('animationTypeUpdate');
	    var onSectorClick = zrUtil.curry(updateDataSelected, this.uid, seriesModel, hasAnimation, api);
	    var selectedMode = seriesModel.get('selectedMode');
	    data.diff(oldData).add(function (idx) {
	      var piePiece = new PiePiece(data, idx); // Default expansion animation
	
	      if (isFirstRender && animationType !== 'scale') {
	        piePiece.eachChild(function (child) {
	          child.stopAnimation(true);
	        });
	      }
	
	      selectedMode && piePiece.on('click', onSectorClick);
	      data.setItemGraphicEl(idx, piePiece);
	      group.add(piePiece);
	    }).update(function (newIdx, oldIdx) {
	      var piePiece = oldData.getItemGraphicEl(oldIdx);
	
	      if (!isFirstRender && animationTypeUpdate !== 'transition') {
	        piePiece.eachChild(function (child) {
	          child.stopAnimation(true);
	        });
	      }
	
	      piePiece.updateData(data, newIdx);
	      piePiece.off('click');
	      selectedMode && piePiece.on('click', onSectorClick);
	      group.add(piePiece);
	      data.setItemGraphicEl(newIdx, piePiece);
	    }).remove(function (idx) {
	      var piePiece = oldData.getItemGraphicEl(idx);
	      group.remove(piePiece);
	    }).execute();
	
	    if (hasAnimation && data.count() > 0 && (isFirstRender ? animationType !== 'scale' : animationTypeUpdate !== 'transition')) {
	      var shape = data.getItemLayout(0);
	
	      for (var s = 1; isNaN(shape.startAngle) && s < data.count(); ++s) {
	        shape = data.getItemLayout(s);
	      }
	
	      var r = Math.max(api.getWidth(), api.getHeight()) / 2;
	      var removeClipPath = zrUtil.bind(group.removeClipPath, group);
	      group.setClipPath(this._createClipPath(shape.cx, shape.cy, r, shape.startAngle, shape.clockwise, removeClipPath, seriesModel, isFirstRender));
	    } else {
	      // clipPath is used in first-time animation, so remove it when otherwise. See: #8994
	      group.removeClipPath();
	    }
	
	    this._data = data;
	  },
	  dispose: function () {},
	  _createClipPath: function (cx, cy, r, startAngle, clockwise, cb, seriesModel, isFirstRender) {
	    var clipPath = new graphic.Sector({
	      shape: {
	        cx: cx,
	        cy: cy,
	        r0: 0,
	        r: r,
	        startAngle: startAngle,
	        endAngle: startAngle,
	        clockwise: clockwise
	      }
	    });
	    var initOrUpdate = isFirstRender ? graphic.initProps : graphic.updateProps;
	    initOrUpdate(clipPath, {
	      shape: {
	        endAngle: startAngle + (clockwise ? 1 : -1) * Math.PI * 2
	      }
	    }, seriesModel, cb);
	    return clipPath;
	  },
	
	  /**
	   * @implement
	   */
	  containPoint: function (point, seriesModel) {
	    var data = seriesModel.getData();
	    var itemLayout = data.getItemLayout(0);
	
	    if (itemLayout) {
	      var dx = point[0] - itemLayout.cx;
	      var dy = point[1] - itemLayout.cy;
	      var radius = Math.sqrt(dx * dx + dy * dy);
	      return radius <= itemLayout.r && radius >= itemLayout.r0;
	    }
	  }
	});
	var _default = PieView;
	module.exports = _default;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType, actionInfos) {
	  zrUtil.each(actionInfos, function (actionInfo) {
	    actionInfo.update = 'updateView';
	    /**
	     * @payload
	     * @property {string} seriesName
	     * @property {string} name
	     */
	
	    echarts.registerAction(actionInfo, function (payload, ecModel) {
	      var selected = {};
	      ecModel.eachComponent({
	        mainType: 'series',
	        subType: seriesType,
	        query: payload
	      }, function (seriesModel) {
	        if (seriesModel[actionInfo.method]) {
	          seriesModel[actionInfo.method](payload.name, payload.dataIndex);
	        }
	
	        var data = seriesModel.getData(); // Create selected map
	
	        data.each(function (idx) {
	          var name = data.getName(idx);
	          selected[name] = seriesModel.isSelected(name) || false;
	        });
	      });
	      return {
	        name: payload.name,
	        selected: selected,
	        seriesId: payload.seriesId
	      };
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var createHashMap = _util.createHashMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Pick color from palette for each data item.
	// Applicable for charts that require applying color palette
	// in data level (like pie, funnel, chord).
	function _default(seriesType) {
	  return {
	    getTargetSeries: function (ecModel) {
	      // Pie and funnel may use diferrent scope
	      var paletteScope = {};
	      var seiresModelMap = createHashMap();
	      ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	        seriesModel.__paletteScope = paletteScope;
	        seiresModelMap.set(seriesModel.uid, seriesModel);
	      });
	      return seiresModelMap;
	    },
	    reset: function (seriesModel, ecModel) {
	      var dataAll = seriesModel.getRawData();
	      var idxMap = {};
	      var data = seriesModel.getData();
	      data.each(function (idx) {
	        var rawIdx = data.getRawIndex(idx);
	        idxMap[rawIdx] = idx;
	      });
	      dataAll.each(function (rawIdx) {
	        var filteredIdx = idxMap[rawIdx]; // If series.itemStyle.normal.color is a function. itemVisual may be encoded
	
	        var singleDataColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'color', true);
	        var singleDataBorderColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'borderColor', true);
	        var itemModel;
	
	        if (!singleDataColor || !singleDataBorderColor) {
	          // FIXME Performance
	          itemModel = dataAll.getItemModel(rawIdx);
	        }
	
	        if (!singleDataColor) {
	          var color = itemModel.get('itemStyle.color') || seriesModel.getColorFromPalette(dataAll.getName(rawIdx) || rawIdx + '', seriesModel.__paletteScope, dataAll.count()); // Data is not filtered
	
	          if (filteredIdx != null) {
	            data.setItemVisual(filteredIdx, 'color', color);
	          }
	        }
	
	        if (!singleDataBorderColor) {
	          var borderColor = itemModel.get('itemStyle.borderColor'); // Data is not filtered
	
	          if (filteredIdx != null) {
	            data.setItemVisual(filteredIdx, 'borderColor', borderColor);
	          }
	        }
	      });
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	var linearMap = _number.linearMap;
	
	var layout = __webpack_require__(305);
	
	var labelLayout = __webpack_require__(411);
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI2 = Math.PI * 2;
	var RADIAN = Math.PI / 180;
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function _default(seriesType, ecModel, api, payload) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var viewRect = getViewRect(seriesModel, api);
	    var center = seriesModel.get('center');
	    var radius = seriesModel.get('radius');
	
	    if (!zrUtil.isArray(radius)) {
	      radius = [0, radius];
	    }
	
	    if (!zrUtil.isArray(center)) {
	      center = [center, center];
	    }
	
	    var width = parsePercent(viewRect.width, api.getWidth());
	    var height = parsePercent(viewRect.height, api.getHeight());
	    var size = Math.min(width, height);
	    var cx = parsePercent(center[0], width) + viewRect.x;
	    var cy = parsePercent(center[1], height) + viewRect.y;
	    var r0 = parsePercent(radius[0], size / 2);
	    var r = parsePercent(radius[1], size / 2);
	    var startAngle = -seriesModel.get('startAngle') * RADIAN;
	    var minAngle = seriesModel.get('minAngle') * RADIAN;
	    var validDataCount = 0;
	    data.each(valueDim, function (value) {
	      !isNaN(value) && validDataCount++;
	    });
	    var sum = data.getSum(valueDim); // Sum may be 0
	
	    var unitRadian = Math.PI / (sum || validDataCount) * 2;
	    var clockwise = seriesModel.get('clockwise');
	    var roseType = seriesModel.get('roseType');
	    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]
	
	    var extent = data.getDataExtent(valueDim);
	    extent[0] = 0; // In the case some sector angle is smaller than minAngle
	
	    var restAngle = PI2;
	    var valueSumLargerThanMinAngle = 0;
	    var currentAngle = startAngle;
	    var dir = clockwise ? 1 : -1;
	    data.each(valueDim, function (value, idx) {
	      var angle;
	
	      if (isNaN(value)) {
	        data.setItemLayout(idx, {
	          angle: NaN,
	          startAngle: NaN,
	          endAngle: NaN,
	          clockwise: clockwise,
	          cx: cx,
	          cy: cy,
	          r0: r0,
	          r: roseType ? NaN : r,
	          viewRect: viewRect
	        });
	        return;
	      } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
	
	
	      if (roseType !== 'area') {
	        angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	      } else {
	        angle = PI2 / validDataCount;
	      }
	
	      if (angle < minAngle) {
	        angle = minAngle;
	        restAngle -= minAngle;
	      } else {
	        valueSumLargerThanMinAngle += value;
	      }
	
	      var endAngle = currentAngle + dir * angle;
	      data.setItemLayout(idx, {
	        angle: angle,
	        startAngle: currentAngle,
	        endAngle: endAngle,
	        clockwise: clockwise,
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: roseType ? linearMap(value, extent, [r0, r]) : r,
	        viewRect: viewRect
	      });
	      currentAngle = endAngle;
	    }); // Some sector is constrained by minAngle
	    // Rest sectors needs recalculate angle
	
	    if (restAngle < PI2 && validDataCount) {
	      // Average the angle if rest angle is not enough after all angles is
	      // Constrained by minAngle
	      if (restAngle <= 1e-3) {
	        var angle = PI2 / validDataCount;
	        data.each(valueDim, function (value, idx) {
	          if (!isNaN(value)) {
	            var layout = data.getItemLayout(idx);
	            layout.angle = angle;
	            layout.startAngle = startAngle + dir * idx * angle;
	            layout.endAngle = startAngle + dir * (idx + 1) * angle;
	          }
	        });
	      } else {
	        unitRadian = restAngle / valueSumLargerThanMinAngle;
	        currentAngle = startAngle;
	        data.each(valueDim, function (value, idx) {
	          if (!isNaN(value)) {
	            var layout = data.getItemLayout(idx);
	            var angle = layout.angle === minAngle ? minAngle : value * unitRadian;
	            layout.startAngle = currentAngle;
	            layout.endAngle = currentAngle + dir * angle;
	            currentAngle += dir * angle;
	          }
	        });
	      }
	    }
	
	    labelLayout(seriesModel, r, viewRect.width, viewRect.height, viewRect.x, viewRect.y);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var textContain = __webpack_require__(255);
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME emphasis label position is not same with normal label position
	var RADIAN = Math.PI / 180;
	
	function adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
	  list.sort(function (a, b) {
	    return a.y - b.y;
	  });
	
	  function shiftDown(start, end, delta, dir) {
	    for (var j = start; j < end; j++) {
	      if (list[j].y + delta > viewTop + viewHeight) {
	        break;
	      }
	
	      list[j].y += delta;
	
	      if (j > start && j + 1 < end && list[j + 1].y > list[j].y + list[j].height) {
	        shiftUp(j, delta / 2);
	        return;
	      }
	    }
	
	    shiftUp(end - 1, delta / 2);
	  }
	
	  function shiftUp(end, delta) {
	    for (var j = end; j >= 0; j--) {
	      if (list[j].y - delta < viewTop) {
	        break;
	      }
	
	      list[j].y -= delta;
	
	      if (j > 0 && list[j].y > list[j - 1].y + list[j - 1].height) {
	        break;
	      }
	    }
	  }
	
	  function changeX(list, isDownList, cx, cy, r, dir) {
	    var lastDeltaX = dir > 0 ? isDownList // right-side
	    ? Number.MAX_VALUE // down
	    : 0 // up
	    : isDownList // left-side
	    ? Number.MAX_VALUE // down
	    : 0; // up
	
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (list[i].labelAlignTo !== 'none') {
	        continue;
	      }
	
	      var deltaY = Math.abs(list[i].y - cy);
	      var length = list[i].len;
	      var length2 = list[i].len2;
	      var deltaX = deltaY < r + length ? Math.sqrt((r + length + length2) * (r + length + length2) - deltaY * deltaY) : Math.abs(list[i].x - cx);
	
	      if (isDownList && deltaX >= lastDeltaX) {
	        // right-down, left-down
	        deltaX = lastDeltaX - 10;
	      }
	
	      if (!isDownList && deltaX <= lastDeltaX) {
	        // right-up, left-up
	        deltaX = lastDeltaX + 10;
	      }
	
	      list[i].x = cx + deltaX * dir;
	      lastDeltaX = deltaX;
	    }
	  }
	
	  var lastY = 0;
	  var delta;
	  var len = list.length;
	  var upList = [];
	  var downList = [];
	
	  for (var i = 0; i < len; i++) {
	    if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
	      var dx = list[i].x - farthestX;
	      list[i].linePoints[1][0] += dx;
	      list[i].x = farthestX;
	    }
	
	    delta = list[i].y - lastY;
	
	    if (delta < 0) {
	      shiftDown(i, len, -delta, dir);
	    }
	
	    lastY = list[i].y + list[i].height;
	  }
	
	  if (viewHeight - lastY < 0) {
	    shiftUp(len - 1, lastY - viewHeight);
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (list[i].y >= cy) {
	      downList.push(list[i]);
	    } else {
	      upList.push(list[i]);
	    }
	  }
	
	  changeX(upList, false, cx, cy, r, dir);
	  changeX(downList, true, cx, cy, r, dir);
	}
	
	function avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
	  var leftList = [];
	  var rightList = [];
	  var leftmostX = Number.MAX_VALUE;
	  var rightmostX = -Number.MAX_VALUE;
	
	  for (var i = 0; i < labelLayoutList.length; i++) {
	    if (isPositionCenter(labelLayoutList[i])) {
	      continue;
	    }
	
	    if (labelLayoutList[i].x < cx) {
	      leftmostX = Math.min(leftmostX, labelLayoutList[i].x);
	      leftList.push(labelLayoutList[i]);
	    } else {
	      rightmostX = Math.max(rightmostX, labelLayoutList[i].x);
	      rightList.push(labelLayoutList[i]);
	    }
	  }
	
	  adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
	  adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
	
	  for (var i = 0; i < labelLayoutList.length; i++) {
	    var layout = labelLayoutList[i];
	
	    if (isPositionCenter(layout)) {
	      continue;
	    }
	
	    var linePoints = layout.linePoints;
	
	    if (linePoints) {
	      var isAlignToEdge = layout.labelAlignTo === 'edge';
	      var realTextWidth = layout.textRect.width;
	      var targetTextWidth;
	
	      if (isAlignToEdge) {
	        if (layout.x < cx) {
	          targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.labelMargin;
	        } else {
	          targetTextWidth = viewLeft + viewWidth - layout.labelMargin - linePoints[2][0] - layout.labelDistance;
	        }
	      } else {
	        if (layout.x < cx) {
	          targetTextWidth = layout.x - viewLeft - layout.bleedMargin;
	        } else {
	          targetTextWidth = viewLeft + viewWidth - layout.x - layout.bleedMargin;
	        }
	      }
	
	      if (targetTextWidth < layout.textRect.width) {
	        layout.text = textContain.truncateText(layout.text, targetTextWidth, layout.font);
	
	        if (layout.labelAlignTo === 'edge') {
	          realTextWidth = textContain.getWidth(layout.text, layout.font);
	        }
	      }
	
	      var dist = linePoints[1][0] - linePoints[2][0];
	
	      if (isAlignToEdge) {
	        if (layout.x < cx) {
	          linePoints[2][0] = viewLeft + layout.labelMargin + realTextWidth + layout.labelDistance;
	        } else {
	          linePoints[2][0] = viewLeft + viewWidth - layout.labelMargin - realTextWidth - layout.labelDistance;
	        }
	      } else {
	        if (layout.x < cx) {
	          linePoints[2][0] = layout.x + layout.labelDistance;
	        } else {
	          linePoints[2][0] = layout.x - layout.labelDistance;
	        }
	
	        linePoints[1][0] = linePoints[2][0] + dist;
	      }
	
	      linePoints[1][1] = linePoints[2][1] = layout.y;
	    }
	  }
	}
	
	function isPositionCenter(layout) {
	  // Not change x for center label
	  return layout.position === 'center';
	}
	
	function _default(seriesModel, r, viewWidth, viewHeight, viewLeft, viewTop) {
	  var data = seriesModel.getData();
	  var labelLayoutList = [];
	  var cx;
	  var cy;
	  var hasLabelRotate = false;
	  var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * RADIAN;
	  data.each(function (idx) {
	    var layout = data.getItemLayout(idx);
	    var itemModel = data.getItemModel(idx);
	    var labelModel = itemModel.getModel('label'); // Use position in normal or emphasis
	
	    var labelPosition = labelModel.get('position') || itemModel.get('emphasis.label.position');
	    var labelDistance = labelModel.get('distanceToLabelLine');
	    var labelAlignTo = labelModel.get('alignTo');
	    var labelMargin = parsePercent(labelModel.get('margin'), viewWidth);
	    var bleedMargin = labelModel.get('bleedMargin');
	    var font = labelModel.getFont();
	    var labelLineModel = itemModel.getModel('labelLine');
	    var labelLineLen = labelLineModel.get('length');
	    labelLineLen = parsePercent(labelLineLen, viewWidth);
	    var labelLineLen2 = labelLineModel.get('length2');
	    labelLineLen2 = parsePercent(labelLineLen2, viewWidth);
	
	    if (layout.angle < minShowLabelRadian) {
	      return;
	    }
	
	    var midAngle = (layout.startAngle + layout.endAngle) / 2;
	    var dx = Math.cos(midAngle);
	    var dy = Math.sin(midAngle);
	    var textX;
	    var textY;
	    var linePoints;
	    var textAlign;
	    cx = layout.cx;
	    cy = layout.cy;
	    var text = seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx);
	    var textRect = textContain.getBoundingRect(text, font, textAlign, 'top');
	    var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
	
	    if (labelPosition === 'center') {
	      textX = layout.cx;
	      textY = layout.cy;
	      textAlign = 'center';
	    } else {
	      var x1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dx : layout.r * dx) + cx;
	      var y1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dy : layout.r * dy) + cy;
	      textX = x1 + dx * 3;
	      textY = y1 + dy * 3;
	
	      if (!isLabelInside) {
	        // For roseType
	        var x2 = x1 + dx * (labelLineLen + r - layout.r);
	        var y2 = y1 + dy * (labelLineLen + r - layout.r);
	        var x3 = x2 + (dx < 0 ? -1 : 1) * labelLineLen2;
	        var y3 = y2;
	
	        if (labelAlignTo === 'edge') {
	          // Adjust textX because text align of edge is opposite
	          textX = dx < 0 ? viewLeft + labelMargin : viewLeft + viewWidth - labelMargin;
	        } else {
	          textX = x3 + (dx < 0 ? -labelDistance : labelDistance);
	        }
	
	        textY = y3;
	        linePoints = [[x1, y1], [x2, y2], [x3, y3]];
	      }
	
	      textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? dx > 0 ? 'right' : 'left' : dx > 0 ? 'left' : 'right';
	    }
	
	    var labelRotate;
	    var rotate = labelModel.get('rotate');
	
	    if (typeof rotate === 'number') {
	      labelRotate = rotate * (Math.PI / 180);
	    } else {
	      labelRotate = rotate ? dx < 0 ? -midAngle + Math.PI : -midAngle : 0;
	    }
	
	    hasLabelRotate = !!labelRotate;
	    layout.label = {
	      x: textX,
	      y: textY,
	      position: labelPosition,
	      height: textRect.height,
	      len: labelLineLen,
	      len2: labelLineLen2,
	      linePoints: linePoints,
	      textAlign: textAlign,
	      verticalAlign: 'middle',
	      rotation: labelRotate,
	      inside: isLabelInside,
	      labelDistance: labelDistance,
	      labelAlignTo: labelAlignTo,
	      labelMargin: labelMargin,
	      bleedMargin: bleedMargin,
	      textRect: textRect,
	      text: text,
	      font: font
	    }; // Not layout the inside label
	
	    if (!isLabelInside) {
	      labelLayoutList.push(layout.label);
	    }
	  });
	
	  if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) {
	    avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    reset: function (seriesModel, ecModel) {
	      var legendModels = ecModel.findComponents({
	        mainType: 'legend'
	      });
	
	      if (!legendModels || !legendModels.length) {
	        return;
	      }
	
	      var data = seriesModel.getData();
	      data.filterSelf(function (idx) {
	        var name = data.getName(idx); // If in any legend component the status is not selected.
	
	        for (var i = 0; i < legendModels.length; i++) {
	          if (!legendModels[i].isSelected(name)) {
	            return false;
	          }
	        }
	
	        return true;
	      });
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(414);
	
	__webpack_require__(415);
	
	var visualSymbol = __webpack_require__(376);
	
	var layoutPoints = __webpack_require__(377);
	
	__webpack_require__(379);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import * as zrUtil from 'zrender/src/core/util';
	// In case developer forget to include grid component
	echarts.registerVisual(visualSymbol('scatter', 'circle'));
	echarts.registerLayout(layoutPoints('scatter')); // echarts.registerProcessor(function (ecModel, api) {
	//     ecModel.eachSeriesByType('scatter', function (seriesModel) {
	//         var data = seriesModel.getData();
	//         var coordSys = seriesModel.coordinateSystem;
	//         if (coordSys.type !== 'geo') {
	//             return;
	//         }
	//         var startPt = coordSys.pointToData([0, 0]);
	//         var endPt = coordSys.pointToData([api.getWidth(), api.getHeight()]);
	//         var dims = zrUtil.map(coordSys.dimensions, function (dim) {
	//             return data.mapDimension(dim);
	//         });
	//         var range = {};
	//         range[dims[0]] = [Math.min(startPt[0], endPt[0]), Math.max(startPt[0], endPt[0])];
	//         range[dims[1]] = [Math.min(startPt[1], endPt[1]), Math.max(startPt[1], endPt[1])];
	//         data.selectRange(range);
	//     });
	// });

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListFromArray = __webpack_require__(341);
	
	var SeriesModel = __webpack_require__(320);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.scatter',
	  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  brushSelector: 'point',
	  getProgressive: function () {
	    var progressive = this.option.progressive;
	
	    if (progressive == null) {
	      // PENDING
	      return this.option.large ? 5e3 : this.get('progressive');
	    }
	
	    return progressive;
	  },
	  getProgressiveThreshold: function () {
	    var progressiveThreshold = this.option.progressiveThreshold;
	
	    if (progressiveThreshold == null) {
	      // PENDING
	      return this.option.large ? 1e4 : this.get('progressiveThreshold');
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // symbol: null,        // 图形类型
	    symbolSize: 10,
	    // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	    // symbolRotate: null,  // 图形旋转控制
	    large: false,
	    // Available when large is true
	    largeThreshold: 2000,
	    // cursor: null,
	    // label: {
	    // show: false
	    // distance: 5,
	    // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	    // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
	    //           'inside'|'left'|'right'|'top'|'bottom'
	    // 默认使用全局文本样式，详见TEXTSTYLE
	    // },
	    itemStyle: {
	      opacity: 0.8 // color: 各异
	
	    },
	    // If clip the overflow graphics
	    // Works on cartesian / polar series
	    clip: true // progressive: null
	
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var SymbolDraw = __webpack_require__(369);
	
	var LargeSymbolDraw = __webpack_require__(416);
	
	var pointsLayout = __webpack_require__(377);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.extendChartView({
	  type: 'scatter',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var symbolDraw = this._updateSymbolDraw(data, seriesModel);
	
	    symbolDraw.updateData(data, {
	      // TODO
	      // If this parameter should be a shape or a bounding volume
	      // shape will be more general.
	      // But bounding volume like bounding rect will be much faster in the contain calculation
	      clipShape: this._getClipShape(seriesModel)
	    });
	    this._finished = true;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var symbolDraw = this._updateSymbolDraw(data, seriesModel);
	
	    symbolDraw.incrementalPrepareUpdate(data);
	    this._finished = false;
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
	      clipShape: this._getClipShape(seriesModel)
	    });
	
	    this._finished = taskParams.end === seriesModel.getData().count();
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData(); // Must mark group dirty and make sure the incremental layer will be cleared
	    // PENDING
	
	    this.group.dirty();
	
	    if (!this._finished || data.count() > 1e4 || !this._symbolDraw.isPersistent()) {
	      return {
	        update: true
	      };
	    } else {
	      var res = pointsLayout().reset(seriesModel);
	
	      if (res.progress) {
	        res.progress({
	          start: 0,
	          end: data.count()
	        }, data);
	      }
	
	      this._symbolDraw.updateLayout(data);
	    }
	  },
	  _getClipShape: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
	    return seriesModel.get('clip', true) ? clipArea : null;
	  },
	  _updateSymbolDraw: function (data, seriesModel) {
	    var symbolDraw = this._symbolDraw;
	    var pipelineContext = seriesModel.pipelineContext;
	    var isLargeDraw = pipelineContext.large;
	
	    if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
	      symbolDraw && symbolDraw.remove();
	      symbolDraw = this._symbolDraw = isLargeDraw ? new LargeSymbolDraw() : new SymbolDraw();
	      this._isLargeDraw = isLargeDraw;
	      this.group.removeAll();
	    }
	
	    this.group.add(symbolDraw.group);
	    return symbolDraw;
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove(true);
	    this._symbolDraw = null;
	  },
	  dispose: function () {}
	});

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var _symbol = __webpack_require__(360);
	
	var createSymbol = _symbol.createSymbol;
	
	var IncrementalDisplayable = __webpack_require__(301);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	// TODO Batch by color
	var BOOST_SIZE_THRESHOLD = 4;
	var LargeSymbolPath = graphic.extendShape({
	  shape: {
	    points: null
	  },
	  symbolProxy: null,
	  softClipShape: null,
	  buildPath: function (path, shape) {
	    var points = shape.points;
	    var size = shape.size;
	    var symbolProxy = this.symbolProxy;
	    var symbolProxyShape = symbolProxy.shape;
	    var ctx = path.getContext ? path.getContext() : path;
	    var canBoost = ctx && size[0] < BOOST_SIZE_THRESHOLD; // Do draw in afterBrush.
	
	    if (canBoost) {
	      return;
	    }
	
	    for (var i = 0; i < points.length;) {
	      var x = points[i++];
	      var y = points[i++];
	
	      if (isNaN(x) || isNaN(y)) {
	        continue;
	      }
	
	      if (this.softClipShape && !this.softClipShape.contain(x, y)) {
	        continue;
	      }
	
	      symbolProxyShape.x = x - size[0] / 2;
	      symbolProxyShape.y = y - size[1] / 2;
	      symbolProxyShape.width = size[0];
	      symbolProxyShape.height = size[1];
	      symbolProxy.buildPath(path, symbolProxyShape, true);
	    }
	  },
	  afterBrush: function (ctx) {
	    var shape = this.shape;
	    var points = shape.points;
	    var size = shape.size;
	    var canBoost = size[0] < BOOST_SIZE_THRESHOLD;
	
	    if (!canBoost) {
	      return;
	    }
	
	    this.setTransform(ctx); // PENDING If style or other canvas status changed?
	
	    for (var i = 0; i < points.length;) {
	      var x = points[i++];
	      var y = points[i++];
	
	      if (isNaN(x) || isNaN(y)) {
	        continue;
	      }
	
	      if (this.softClipShape && !this.softClipShape.contain(x, y)) {
	        continue;
	      } // fillRect is faster than building a rect path and draw.
	      // And it support light globalCompositeOperation.
	
	
	      ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
	    }
	
	    this.restoreTransform(ctx);
	  },
	  findDataIndex: function (x, y) {
	    // TODO ???
	    // Consider transform
	    var shape = this.shape;
	    var points = shape.points;
	    var size = shape.size;
	    var w = Math.max(size[0], 4);
	    var h = Math.max(size[1], 4); // Not consider transform
	    // Treat each element as a rect
	    // top down traverse
	
	    for (var idx = points.length / 2 - 1; idx >= 0; idx--) {
	      var i = idx * 2;
	      var x0 = points[i] - w / 2;
	      var y0 = points[i + 1] - h / 2;
	
	      if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) {
	        return idx;
	      }
	    }
	
	    return -1;
	  }
	});
	
	function LargeSymbolDraw() {
	  this.group = new graphic.Group();
	}
	
	var largeSymbolProto = LargeSymbolDraw.prototype;
	
	largeSymbolProto.isPersistent = function () {
	  return !this._incremental;
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} opt
	 * @param {Object} [opt.clipShape]
	 */
	
	
	largeSymbolProto.updateData = function (data, opt) {
	  this.group.removeAll();
	  var symbolEl = new LargeSymbolPath({
	    rectHover: true,
	    cursor: 'default'
	  });
	  symbolEl.setShape({
	    points: data.getLayout('symbolPoints')
	  });
	
	  this._setCommon(symbolEl, data, false, opt);
	
	  this.group.add(symbolEl);
	  this._incremental = null;
	};
	
	largeSymbolProto.updateLayout = function (data) {
	  if (this._incremental) {
	    return;
	  }
	
	  var points = data.getLayout('symbolPoints');
	  this.group.eachChild(function (child) {
	    if (child.startIndex != null) {
	      var len = (child.endIndex - child.startIndex) * 2;
	      var byteOffset = child.startIndex * 4 * 2;
	      points = new Float32Array(points.buffer, byteOffset, len);
	    }
	
	    child.setShape('points', points);
	  });
	};
	
	largeSymbolProto.incrementalPrepareUpdate = function (data) {
	  this.group.removeAll();
	
	  this._clearIncremental(); // Only use incremental displayables when data amount is larger than 2 million.
	  // PENDING Incremental data?
	
	
	  if (data.count() > 2e6) {
	    if (!this._incremental) {
	      this._incremental = new IncrementalDisplayable({
	        silent: true
	      });
	    }
	
	    this.group.add(this._incremental);
	  } else {
	    this._incremental = null;
	  }
	};
	
	largeSymbolProto.incrementalUpdate = function (taskParams, data, opt) {
	  var symbolEl;
	
	  if (this._incremental) {
	    symbolEl = new LargeSymbolPath();
	
	    this._incremental.addDisplayable(symbolEl, true);
	  } else {
	    symbolEl = new LargeSymbolPath({
	      rectHover: true,
	      cursor: 'default',
	      startIndex: taskParams.start,
	      endIndex: taskParams.end
	    });
	    symbolEl.incremental = true;
	    this.group.add(symbolEl);
	  }
	
	  symbolEl.setShape({
	    points: data.getLayout('symbolPoints')
	  });
	
	  this._setCommon(symbolEl, data, !!this._incremental, opt);
	};
	
	largeSymbolProto._setCommon = function (symbolEl, data, isIncremental, opt) {
	  var hostModel = data.hostModel;
	  opt = opt || {}; // TODO
	  // if (data.hasItemVisual.symbolSize) {
	  //     // TODO typed array?
	  //     symbolEl.setShape('sizes', data.mapArray(
	  //         function (idx) {
	  //             var size = data.getItemVisual(idx, 'symbolSize');
	  //             return (size instanceof Array) ? size : [size, size];
	  //         }
	  //     ));
	  // }
	  // else {
	
	  var size = data.getVisual('symbolSize');
	  symbolEl.setShape('size', size instanceof Array ? size : [size, size]); // }
	
	  symbolEl.softClipShape = opt.clipShape || null; // Create symbolProxy to build path for each data
	
	  symbolEl.symbolProxy = createSymbol(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method
	
	  symbolEl.setColor = symbolEl.symbolProxy.setColor;
	  var extrudeShadow = symbolEl.shape.size[0] < BOOST_SIZE_THRESHOLD;
	  symbolEl.useStyle( // Draw shadow when doing fillRect is extremely slow.
	  hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? ['color', 'shadowBlur', 'shadowColor'] : ['color']));
	  var visualColor = data.getVisual('color');
	
	  if (visualColor) {
	    symbolEl.setColor(visualColor);
	  }
	
	  if (!isIncremental) {
	    // Enable tooltip
	    // PENDING May have performance issue when path is extremely large
	    symbolEl.seriesIndex = hostModel.seriesIndex;
	    symbolEl.on('mousemove', function (e) {
	      symbolEl.dataIndex = null;
	      var dataIndex = symbolEl.findDataIndex(e.offsetX, e.offsetY);
	
	      if (dataIndex >= 0) {
	        // Provide dataIndex for tooltip
	        symbolEl.dataIndex = dataIndex + (symbolEl.startIndex || 0);
	      }
	    });
	  }
	};
	
	largeSymbolProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	largeSymbolProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	var _default = LargeSymbolDraw;
	module.exports = _default;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(418);
	
	__webpack_require__(423);
	
	__webpack_require__(424);
	
	var dataColor = __webpack_require__(409);
	
	var visualSymbol = __webpack_require__(376);
	
	var radarLayout = __webpack_require__(425);
	
	var dataFilter = __webpack_require__(412);
	
	var backwardCompat = __webpack_require__(426);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Must use radar component
	echarts.registerVisual(dataColor('radar'));
	echarts.registerVisual(visualSymbol('radar', 'circle'));
	echarts.registerLayout(radarLayout);
	echarts.registerProcessor(dataFilter('radar'));
	echarts.registerPreprocessor(backwardCompat);

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(419);
	
	__webpack_require__(421);
	
	__webpack_require__(422);

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var IndicatorAxis = __webpack_require__(420);
	
	var IntervalScale = __webpack_require__(354);
	
	var numberUtil = __webpack_require__(306);
	
	var _axisHelper = __webpack_require__(350);
	
	var getScaleExtent = _axisHelper.getScaleExtent;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	
	var CoordinateSystem = __webpack_require__(315);
	
	var LogScale = __webpack_require__(358);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO clockwise
	function Radar(radarModel, ecModel, api) {
	  this._model = radarModel;
	  /**
	   * Radar dimensions
	   * @type {Array.<string>}
	   */
	
	  this.dimensions = [];
	  this._indicatorAxes = zrUtil.map(radarModel.getIndicatorModels(), function (indicatorModel, idx) {
	    var dim = 'indicator_' + idx;
	    var indicatorAxis = new IndicatorAxis(dim, indicatorModel.get('axisType') === 'log' ? new LogScale() : new IntervalScale());
	    indicatorAxis.name = indicatorModel.get('name'); // Inject model and axis
	
	    indicatorAxis.model = indicatorModel;
	    indicatorModel.axis = indicatorAxis;
	    this.dimensions.push(dim);
	    return indicatorAxis;
	  }, this);
	  this.resize(radarModel, api);
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.cx;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.cy;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.r;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.r0;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.startAngle;
	}
	
	Radar.prototype.getIndicatorAxes = function () {
	  return this._indicatorAxes;
	};
	
	Radar.prototype.dataToPoint = function (value, indicatorIndex) {
	  var indicatorAxis = this._indicatorAxes[indicatorIndex];
	  return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
	};
	
	Radar.prototype.coordToPoint = function (coord, indicatorIndex) {
	  var indicatorAxis = this._indicatorAxes[indicatorIndex];
	  var angle = indicatorAxis.angle;
	  var x = this.cx + coord * Math.cos(angle);
	  var y = this.cy - coord * Math.sin(angle);
	  return [x, y];
	};
	
	Radar.prototype.pointToData = function (pt) {
	  var dx = pt[0] - this.cx;
	  var dy = pt[1] - this.cy;
	  var radius = Math.sqrt(dx * dx + dy * dy);
	  dx /= radius;
	  dy /= radius;
	  var radian = Math.atan2(-dy, dx); // Find the closest angle
	  // FIXME index can calculated directly
	
	  var minRadianDiff = Infinity;
	  var closestAxis;
	  var closestAxisIdx = -1;
	
	  for (var i = 0; i < this._indicatorAxes.length; i++) {
	    var indicatorAxis = this._indicatorAxes[i];
	    var diff = Math.abs(radian - indicatorAxis.angle);
	
	    if (diff < minRadianDiff) {
	      closestAxis = indicatorAxis;
	      closestAxisIdx = i;
	      minRadianDiff = diff;
	    }
	  }
	
	  return [closestAxisIdx, +(closestAxis && closestAxis.coordToData(radius))];
	};
	
	Radar.prototype.resize = function (radarModel, api) {
	  var center = radarModel.get('center');
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  var viewSize = Math.min(viewWidth, viewHeight) / 2;
	  this.cx = numberUtil.parsePercent(center[0], viewWidth);
	  this.cy = numberUtil.parsePercent(center[1], viewHeight);
	  this.startAngle = radarModel.get('startAngle') * Math.PI / 180; // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
	
	  var radius = radarModel.get('radius');
	
	  if (typeof radius === 'string' || typeof radius === 'number') {
	    radius = [0, radius];
	  }
	
	  this.r0 = numberUtil.parsePercent(radius[0], viewSize);
	  this.r = numberUtil.parsePercent(radius[1], viewSize);
	  zrUtil.each(this._indicatorAxes, function (indicatorAxis, idx) {
	    indicatorAxis.setExtent(this.r0, this.r);
	    var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length; // Normalize to [-PI, PI]
	
	    angle = Math.atan2(Math.sin(angle), Math.cos(angle));
	    indicatorAxis.angle = angle;
	  }, this);
	};
	
	Radar.prototype.update = function (ecModel, api) {
	  var indicatorAxes = this._indicatorAxes;
	  var radarModel = this._model;
	  zrUtil.each(indicatorAxes, function (indicatorAxis) {
	    indicatorAxis.scale.setExtent(Infinity, -Infinity);
	  });
	  ecModel.eachSeriesByType('radar', function (radarSeries, idx) {
	    if (radarSeries.get('coordinateSystem') !== 'radar' || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) {
	      return;
	    }
	
	    var data = radarSeries.getData();
	    zrUtil.each(indicatorAxes, function (indicatorAxis) {
	      indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
	    });
	  }, this);
	  var splitNumber = radarModel.get('splitNumber');
	
	  function increaseInterval(interval) {
	    var exp10 = Math.pow(10, Math.floor(Math.log(interval) / Math.LN10)); // Increase interval
	
	    var f = interval / exp10;
	
	    if (f === 2) {
	      f = 5;
	    } else {
	      // f is 2 or 5
	      f *= 2;
	    }
	
	    return f * exp10;
	  } // Force all the axis fixing the maxSplitNumber.
	
	
	  zrUtil.each(indicatorAxes, function (indicatorAxis, idx) {
	    var rawExtent = getScaleExtent(indicatorAxis.scale, indicatorAxis.model).extent;
	    niceScaleExtent(indicatorAxis.scale, indicatorAxis.model);
	    var axisModel = indicatorAxis.model;
	    var scale = indicatorAxis.scale;
	    var fixedMin = axisModel.getMin();
	    var fixedMax = axisModel.getMax();
	    var interval = scale.getInterval();
	
	    if (fixedMin != null && fixedMax != null) {
	      // User set min, max, divide to get new interval
	      scale.setExtent(+fixedMin, +fixedMax);
	      scale.setInterval((fixedMax - fixedMin) / splitNumber);
	    } else if (fixedMin != null) {
	      var max; // User set min, expand extent on the other side
	
	      do {
	        max = fixedMin + interval * splitNumber;
	        scale.setExtent(+fixedMin, max); // Interval must been set after extent
	        // FIXME
	
	        scale.setInterval(interval);
	        interval = increaseInterval(interval);
	      } while (max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1]));
	    } else if (fixedMax != null) {
	      var min; // User set min, expand extent on the other side
	
	      do {
	        min = fixedMax - interval * splitNumber;
	        scale.setExtent(min, +fixedMax);
	        scale.setInterval(interval);
	        interval = increaseInterval(interval);
	      } while (min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0]));
	    } else {
	      var nicedSplitNumber = scale.getTicks().length - 1;
	
	      if (nicedSplitNumber > splitNumber) {
	        interval = increaseInterval(interval);
	      } // TODO
	
	
	      var max = Math.ceil(rawExtent[1] / interval) * interval;
	      var min = numberUtil.round(max - interval * splitNumber);
	      scale.setExtent(min, max);
	      scale.setInterval(interval);
	    }
	  });
	};
	/**
	 * Radar dimensions is based on the data
	 * @type {Array}
	 */
	
	
	Radar.dimensions = [];
	
	Radar.create = function (ecModel, api) {
	  var radarList = [];
	  ecModel.eachComponent('radar', function (radarModel) {
	    var radar = new Radar(radarModel, ecModel, api);
	    radarList.push(radar);
	    radarModel.coordinateSystem = radar;
	  });
	  ecModel.eachSeriesByType('radar', function (radarSeries) {
	    if (radarSeries.get('coordinateSystem') === 'radar') {
	      // Inject coordinate system
	      radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
	    }
	  });
	  return radarList;
	};
	
	CoordinateSystem.register('radar', Radar);
	var _default = Radar;
	module.exports = _default;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Axis = __webpack_require__(364);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function IndicatorAxis(dim, scale, radiusExtent) {
	  Axis.call(this, dim, scale, radiusExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'value';
	  this.angle = 0;
	  /**
	   * Indicator name
	   * @type {string}
	   */
	
	  this.name = '';
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.model;
	}
	
	zrUtil.inherits(IndicatorAxis, Axis);
	var _default = IndicatorAxis;
	module.exports = _default;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var axisDefault = __webpack_require__(387);
	
	var Model = __webpack_require__(262);
	
	var axisModelCommonMixin = __webpack_require__(359);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var valueAxisDefault = axisDefault.valueAxis;
	
	function defaultsShow(opt, show) {
	  return zrUtil.defaults({
	    show: show
	  }, opt);
	}
	
	var RadarModel = echarts.extendComponentModel({
	  type: 'radar',
	  optionUpdated: function () {
	    var boundaryGap = this.get('boundaryGap');
	    var splitNumber = this.get('splitNumber');
	    var scale = this.get('scale');
	    var axisLine = this.get('axisLine');
	    var axisTick = this.get('axisTick');
	    var axisType = this.get('axisType');
	    var axisLabel = this.get('axisLabel');
	    var nameTextStyle = this.get('name');
	    var showName = this.get('name.show');
	    var nameFormatter = this.get('name.formatter');
	    var nameGap = this.get('nameGap');
	    var triggerEvent = this.get('triggerEvent');
	    var indicatorModels = zrUtil.map(this.get('indicator') || [], function (indicatorOpt) {
	      // PENDING
	      if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) {
	        indicatorOpt.min = 0;
	      } else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) {
	        indicatorOpt.max = 0;
	      }
	
	      var iNameTextStyle = nameTextStyle;
	
	      if (indicatorOpt.color != null) {
	        iNameTextStyle = zrUtil.defaults({
	          color: indicatorOpt.color
	        }, nameTextStyle);
	      } // Use same configuration
	
	
	      indicatorOpt = zrUtil.merge(zrUtil.clone(indicatorOpt), {
	        boundaryGap: boundaryGap,
	        splitNumber: splitNumber,
	        scale: scale,
	        axisLine: axisLine,
	        axisTick: axisTick,
	        axisType: axisType,
	        axisLabel: axisLabel,
	        // Compatible with 2 and use text
	        name: indicatorOpt.text,
	        nameLocation: 'end',
	        nameGap: nameGap,
	        // min: 0,
	        nameTextStyle: iNameTextStyle,
	        triggerEvent: triggerEvent
	      }, false);
	
	      if (!showName) {
	        indicatorOpt.name = '';
	      }
	
	      if (typeof nameFormatter === 'string') {
	        var indName = indicatorOpt.name;
	        indicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
	      } else if (typeof nameFormatter === 'function') {
	        indicatorOpt.name = nameFormatter(indicatorOpt.name, indicatorOpt);
	      }
	
	      var model = zrUtil.extend(new Model(indicatorOpt, null, this.ecModel), axisModelCommonMixin); // For triggerEvent.
	
	      model.mainType = 'radar';
	      model.componentIndex = this.componentIndex;
	      return model;
	    }, this);
	
	    this.getIndicatorModels = function () {
	      return indicatorModels;
	    };
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    center: ['50%', '50%'],
	    radius: '75%',
	    startAngle: 90,
	    name: {
	      show: true // formatter: null
	      // textStyle: {}
	
	    },
	    boundaryGap: [0, 0],
	    splitNumber: 5,
	    nameGap: 15,
	    scale: false,
	    // Polygon or circle
	    shape: 'polygon',
	    axisLine: zrUtil.merge({
	      lineStyle: {
	        color: '#bbb'
	      }
	    }, valueAxisDefault.axisLine),
	    axisLabel: defaultsShow(valueAxisDefault.axisLabel, false),
	    axisTick: defaultsShow(valueAxisDefault.axisTick, false),
	    axisType: 'interval',
	    splitLine: defaultsShow(valueAxisDefault.splitLine, true),
	    splitArea: defaultsShow(valueAxisDefault.splitArea, true),
	    // {text, min, max}
	    indicator: []
	  }
	});
	var _default = RadarModel;
	module.exports = _default;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var AxisBuilder = __webpack_require__(390);
	
	var graphic = __webpack_require__(268);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	
	var _default = echarts.extendComponentView({
	  type: 'radar',
	  render: function (radarModel, ecModel, api) {
	    var group = this.group;
	    group.removeAll();
	
	    this._buildAxes(radarModel);
	
	    this._buildSplitLineAndArea(radarModel);
	  },
	  _buildAxes: function (radarModel) {
	    var radar = radarModel.coordinateSystem;
	    var indicatorAxes = radar.getIndicatorAxes();
	    var axisBuilders = zrUtil.map(indicatorAxes, function (indicatorAxis) {
	      var axisBuilder = new AxisBuilder(indicatorAxis.model, {
	        position: [radar.cx, radar.cy],
	        rotation: indicatorAxis.angle,
	        labelDirection: -1,
	        tickDirection: -1,
	        nameDirection: 1
	      });
	      return axisBuilder;
	    });
	    zrUtil.each(axisBuilders, function (axisBuilder) {
	      zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	      this.group.add(axisBuilder.getGroup());
	    }, this);
	  },
	  _buildSplitLineAndArea: function (radarModel) {
	    var radar = radarModel.coordinateSystem;
	    var indicatorAxes = radar.getIndicatorAxes();
	
	    if (!indicatorAxes.length) {
	      return;
	    }
	
	    var shape = radarModel.get('shape');
	    var splitLineModel = radarModel.getModel('splitLine');
	    var splitAreaModel = radarModel.getModel('splitArea');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var showSplitLine = splitLineModel.get('show');
	    var showSplitArea = splitAreaModel.get('show');
	    var splitLineColors = lineStyleModel.get('color');
	    var splitAreaColors = areaStyleModel.get('color');
	    splitLineColors = zrUtil.isArray(splitLineColors) ? splitLineColors : [splitLineColors];
	    splitAreaColors = zrUtil.isArray(splitAreaColors) ? splitAreaColors : [splitAreaColors];
	    var splitLines = [];
	    var splitAreas = [];
	
	    function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
	      var colorIndex = idx % areaOrLineColorList.length;
	      areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
	      return colorIndex;
	    }
	
	    if (shape === 'circle') {
	      var ticksRadius = indicatorAxes[0].getTicksCoords();
	      var cx = radar.cx;
	      var cy = radar.cy;
	
	      for (var i = 0; i < ticksRadius.length; i++) {
	        if (showSplitLine) {
	          var colorIndex = getColorIndex(splitLines, splitLineColors, i);
	          splitLines[colorIndex].push(new graphic.Circle({
	            shape: {
	              cx: cx,
	              cy: cy,
	              r: ticksRadius[i].coord
	            }
	          }));
	        }
	
	        if (showSplitArea && i < ticksRadius.length - 1) {
	          var colorIndex = getColorIndex(splitAreas, splitAreaColors, i);
	          splitAreas[colorIndex].push(new graphic.Ring({
	            shape: {
	              cx: cx,
	              cy: cy,
	              r0: ticksRadius[i].coord,
	              r: ticksRadius[i + 1].coord
	            }
	          }));
	        }
	      }
	    } // Polyyon
	    else {
	        var realSplitNumber;
	        var axesTicksPoints = zrUtil.map(indicatorAxes, function (indicatorAxis, idx) {
	          var ticksCoords = indicatorAxis.getTicksCoords();
	          realSplitNumber = realSplitNumber == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber);
	          return zrUtil.map(ticksCoords, function (tickCoord) {
	            return radar.coordToPoint(tickCoord.coord, idx);
	          });
	        });
	        var prevPoints = [];
	
	        for (var i = 0; i <= realSplitNumber; i++) {
	          var points = [];
	
	          for (var j = 0; j < indicatorAxes.length; j++) {
	            points.push(axesTicksPoints[j][i]);
	          } // Close
	
	
	          if (points[0]) {
	            points.push(points[0].slice());
	          } else {}
	
	          if (showSplitLine) {
	            var colorIndex = getColorIndex(splitLines, splitLineColors, i);
	            splitLines[colorIndex].push(new graphic.Polyline({
	              shape: {
	                points: points
	              }
	            }));
	          }
	
	          if (showSplitArea && prevPoints) {
	            var colorIndex = getColorIndex(splitAreas, splitAreaColors, i - 1);
	            splitAreas[colorIndex].push(new graphic.Polygon({
	              shape: {
	                points: points.concat(prevPoints)
	              }
	            }));
	          }
	
	          prevPoints = points.slice().reverse();
	        }
	      }
	
	    var lineStyle = lineStyleModel.getLineStyle();
	    var areaStyle = areaStyleModel.getAreaStyle(); // Add splitArea before splitLine
	
	    zrUtil.each(splitAreas, function (splitAreas, idx) {
	      this.group.add(graphic.mergePath(splitAreas, {
	        style: zrUtil.defaults({
	          stroke: 'none',
	          fill: splitAreaColors[idx % splitAreaColors.length]
	        }, areaStyle),
	        silent: true
	      }));
	    }, this);
	    zrUtil.each(splitLines, function (splitLines, idx) {
	      this.group.add(graphic.mergePath(splitLines, {
	        style: zrUtil.defaults({
	          fill: 'none',
	          stroke: splitLineColors[idx % splitLineColors.length]
	        }, lineStyle),
	        silent: true
	      }));
	    }, this);
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(320);
	
	var createListSimply = __webpack_require__(404);
	
	var zrUtil = __webpack_require__(220);
	
	var _format = __webpack_require__(307);
	
	var encodeHTML = _format.encodeHTML;
	
	var LegendVisualProvider = __webpack_require__(406);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var RadarSeries = SeriesModel.extend({
	  type: 'series.radar',
	  dependencies: ['radar'],
	  // Overwrite
	  init: function (option) {
	    RadarSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      generateCoord: 'indicator_',
	      generateCoordCount: Infinity
	    });
	  },
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var data = this.getData();
	    var coordSys = this.coordinateSystem;
	    var indicatorAxes = coordSys.getIndicatorAxes();
	    var name = this.getData().getName(dataIndex);
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    return encodeHTML(name === '' ? this.name : name) + newLine + zrUtil.map(indicatorAxes, function (axis, idx) {
	      var val = data.get(data.mapDimension(axis.dim), dataIndex);
	      return encodeHTML(axis.name + ' : ' + val);
	    }).join(newLine);
	  },
	
	  /**
	   * @implement
	   */
	  getTooltipPosition: function (dataIndex) {
	    if (dataIndex != null) {
	      var data = this.getData();
	      var coordSys = this.coordinateSystem;
	      var values = data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
	        return data.mapDimension(dim);
	      }), dataIndex, true);
	
	      for (var i = 0, len = values.length; i < len; i++) {
	        if (!isNaN(values[i])) {
	          var indicatorAxes = coordSys.getIndicatorAxes();
	          return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
	        }
	      }
	    }
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'radar',
	    legendHoverLink: true,
	    radarIndex: 0,
	    lineStyle: {
	      width: 2,
	      type: 'solid'
	    },
	    label: {
	      position: 'top'
	    },
	    // areaStyle: {
	    // },
	    // itemStyle: {}
	    symbol: 'emptyCircle',
	    symbolSize: 4 // symbolRotate: null
	
	  }
	});
	var _default = RadarSeries;
	module.exports = _default;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var graphic = __webpack_require__(268);
	
	var zrUtil = __webpack_require__(220);
	
	var symbolUtil = __webpack_require__(360);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalizeSymbolSize(symbolSize) {
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [+symbolSize, +symbolSize];
	  }
	
	  return symbolSize;
	}
	
	var _default = echarts.extendChartView({
	  type: 'radar',
	  render: function (seriesModel, ecModel, api) {
	    var polar = seriesModel.coordinateSystem;
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	
	    function createSymbol(data, idx) {
	      var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	      var color = data.getItemVisual(idx, 'color');
	
	      if (symbolType === 'none') {
	        return;
	      }
	
	      var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	      var symbolPath = symbolUtil.createSymbol(symbolType, -1, -1, 2, 2, color);
	      var symbolRotate = data.getItemVisual(idx, 'symbolRotate') || 0;
	      symbolPath.attr({
	        style: {
	          strokeNoScale: true
	        },
	        z2: 100,
	        scale: [symbolSize[0] / 2, symbolSize[1] / 2],
	        rotation: symbolRotate * Math.PI / 180 || 0
	      });
	      return symbolPath;
	    }
	
	    function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
	      // Simply rerender all
	      symbolGroup.removeAll();
	
	      for (var i = 0; i < newPoints.length - 1; i++) {
	        var symbolPath = createSymbol(data, idx);
	
	        if (symbolPath) {
	          symbolPath.__dimIdx = i;
	
	          if (oldPoints[i]) {
	            symbolPath.attr('position', oldPoints[i]);
	            graphic[isInit ? 'initProps' : 'updateProps'](symbolPath, {
	              position: newPoints[i]
	            }, seriesModel, idx);
	          } else {
	            symbolPath.attr('position', newPoints[i]);
	          }
	
	          symbolGroup.add(symbolPath);
	        }
	      }
	    }
	
	    function getInitialPoints(points) {
	      return zrUtil.map(points, function (pt) {
	        return [polar.cx, polar.cy];
	      });
	    }
	
	    data.diff(oldData).add(function (idx) {
	      var points = data.getItemLayout(idx);
	
	      if (!points) {
	        return;
	      }
	
	      var polygon = new graphic.Polygon();
	      var polyline = new graphic.Polyline();
	      var target = {
	        shape: {
	          points: points
	        }
	      };
	      polygon.shape.points = getInitialPoints(points);
	      polyline.shape.points = getInitialPoints(points);
	      graphic.initProps(polygon, target, seriesModel, idx);
	      graphic.initProps(polyline, target, seriesModel, idx);
	      var itemGroup = new graphic.Group();
	      var symbolGroup = new graphic.Group();
	      itemGroup.add(polyline);
	      itemGroup.add(polygon);
	      itemGroup.add(symbolGroup);
	      updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
	      data.setItemGraphicEl(idx, itemGroup);
	    }).update(function (newIdx, oldIdx) {
	      var itemGroup = oldData.getItemGraphicEl(oldIdx);
	      var polyline = itemGroup.childAt(0);
	      var polygon = itemGroup.childAt(1);
	      var symbolGroup = itemGroup.childAt(2);
	      var target = {
	        shape: {
	          points: data.getItemLayout(newIdx)
	        }
	      };
	
	      if (!target.shape.points) {
	        return;
	      }
	
	      updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
	      graphic.updateProps(polyline, target, seriesModel);
	      graphic.updateProps(polygon, target, seriesModel);
	      data.setItemGraphicEl(newIdx, itemGroup);
	    }).remove(function (idx) {
	      group.remove(oldData.getItemGraphicEl(idx));
	    }).execute();
	    data.eachItemGraphicEl(function (itemGroup, idx) {
	      var itemModel = data.getItemModel(idx);
	      var polyline = itemGroup.childAt(0);
	      var polygon = itemGroup.childAt(1);
	      var symbolGroup = itemGroup.childAt(2);
	      var color = data.getItemVisual(idx, 'color');
	      group.add(itemGroup);
	      polyline.useStyle(zrUtil.defaults(itemModel.getModel('lineStyle').getLineStyle(), {
	        fill: 'none',
	        stroke: color
	      }));
	      polyline.hoverStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	      var areaStyleModel = itemModel.getModel('areaStyle');
	      var hoverAreaStyleModel = itemModel.getModel('emphasis.areaStyle');
	      var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
	      var hoverPolygonIgnore = hoverAreaStyleModel.isEmpty() && hoverAreaStyleModel.parentModel.isEmpty();
	      hoverPolygonIgnore = hoverPolygonIgnore && polygonIgnore;
	      polygon.ignore = polygonIgnore;
	      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
	        fill: color,
	        opacity: 0.7
	      }));
	      polygon.hoverStyle = hoverAreaStyleModel.getAreaStyle();
	      var itemStyle = itemModel.getModel('itemStyle').getItemStyle(['color']);
	      var itemHoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      symbolGroup.eachChild(function (symbolPath) {
	        symbolPath.setStyle(itemStyle);
	        symbolPath.hoverStyle = zrUtil.clone(itemHoverStyle);
	        var defaultText = data.get(data.dimensions[symbolPath.__dimIdx], idx);
	        (defaultText == null || isNaN(defaultText)) && (defaultText = '');
	        graphic.setLabelStyle(symbolPath.style, symbolPath.hoverStyle, labelModel, labelHoverModel, {
	          labelFetcher: data.hostModel,
	          labelDataIndex: idx,
	          labelDimIndex: symbolPath.__dimIdx,
	          defaultText: defaultText,
	          autoColor: color,
	          isRectText: true
	        });
	      });
	
	      itemGroup.highDownOnUpdate = function (fromState, toState) {
	        polygon.attr('ignore', toState === 'emphasis' ? hoverPolygonIgnore : polygonIgnore);
	      };
	
	      graphic.setHoverStyle(itemGroup);
	    });
	    this._data = data;
	  },
	  remove: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('radar', function (seriesModel) {
	    var data = seriesModel.getData();
	    var points = [];
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (!coordSys) {
	      return;
	    }
	
	    var axes = coordSys.getIndicatorAxes();
	    zrUtil.each(axes, function (axis, axisIndex) {
	      data.each(data.mapDimension(axes[axisIndex].dim), function (val, dataIndex) {
	        points[dataIndex] = points[dataIndex] || [];
	        var point = coordSys.dataToPoint(val, axisIndex);
	        points[dataIndex][axisIndex] = isValidPoint(point) ? point : getValueMissingPoint(coordSys);
	      });
	    }); // Close polygon
	
	    data.each(function (idx) {
	      // TODO
	      // Is it appropriate to connect to the next data when some data is missing?
	      // Or, should trade it like `connectNull` in line chart?
	      var firstPoint = zrUtil.find(points[idx], function (point) {
	        return isValidPoint(point);
	      }) || getValueMissingPoint(coordSys); // Copy the first actual point to the end of the array
	
	      points[idx].push(firstPoint.slice());
	      data.setItemLayout(idx, points[idx]);
	    });
	  });
	}
	
	function isValidPoint(point) {
	  return !isNaN(point[0]) && !isNaN(point[1]);
	}
	
	function getValueMissingPoint(coordSys) {
	  // It is error-prone to input [NaN, NaN] into polygon, polygon.
	  // (probably cause problem when refreshing or animating)
	  return [coordSys.cx, coordSys.cy];
	}
	
	module.exports = _default;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Backward compat for radar chart in 2
	function _default(option) {
	  var polarOptArr = option.polar;
	
	  if (polarOptArr) {
	    if (!zrUtil.isArray(polarOptArr)) {
	      polarOptArr = [polarOptArr];
	    }
	
	    var polarNotRadar = [];
	    zrUtil.each(polarOptArr, function (polarOpt, idx) {
	      if (polarOpt.indicator) {
	        if (polarOpt.type && !polarOpt.shape) {
	          polarOpt.shape = polarOpt.type;
	        }
	
	        option.radar = option.radar || [];
	
	        if (!zrUtil.isArray(option.radar)) {
	          option.radar = [option.radar];
	        }
	
	        option.radar.push(polarOpt);
	      } else {
	        polarNotRadar.push(polarOpt);
	      }
	    });
	    option.polar = polarNotRadar;
	  }
	
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) {
	      seriesOpt.radarIndex = seriesOpt.polarIndex;
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(428);
	
	__webpack_require__(436);
	
	__webpack_require__(442);
	
	__webpack_require__(444);
	
	var mapSymbolLayout = __webpack_require__(447);
	
	var mapVisual = __webpack_require__(448);
	
	var mapDataStatistic = __webpack_require__(449);
	
	var backwardCompat = __webpack_require__(450);
	
	var createDataSelectAction = __webpack_require__(408);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(mapSymbolLayout);
	echarts.registerVisual(mapVisual);
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, mapDataStatistic);
	echarts.registerPreprocessor(backwardCompat);
	createDataSelectAction('map', [{
	  type: 'mapToggleSelect',
	  event: 'mapselectchanged',
	  method: 'toggleSelected'
	}, {
	  type: 'mapSelect',
	  event: 'mapselected',
	  method: 'select'
	}, {
	  type: 'mapUnSelect',
	  event: 'mapunselected',
	  method: 'unSelect'
	}]);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var createListSimply = __webpack_require__(404);
	
	var SeriesModel = __webpack_require__(320);
	
	var _format = __webpack_require__(307);
	
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	
	var dataSelectableMixin = __webpack_require__(405);
	
	var _dataProvider = __webpack_require__(322);
	
	var retrieveRawAttr = _dataProvider.retrieveRawAttr;
	
	var geoSourceManager = __webpack_require__(429);
	
	var _sourceHelper = __webpack_require__(311);
	
	var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var MapSeries = SeriesModel.extend({
	  type: 'series.map',
	  dependencies: ['geo'],
	  layoutMode: 'box',
	
	  /**
	   * Only first map series of same mapType will drawMap
	   * @type {boolean}
	   */
	  needsDrawMap: false,
	
	  /**
	   * Group of all map series with same mapType
	   * @type {boolean}
	   */
	  seriesGroup: [],
	  getInitialData: function (option) {
	    var data = createListSimply(this, {
	      coordDimensions: ['value'],
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
	    });
	    var valueDim = data.mapDimension('value');
	    var dataNameMap = zrUtil.createHashMap();
	    var selectTargetList = [];
	    var toAppendNames = [];
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      var name = data.getName(i);
	      dataNameMap.set(name, true);
	      selectTargetList.push({
	        name: name,
	        value: data.get(valueDim, i),
	        selected: retrieveRawAttr(data, i, 'selected')
	      });
	    }
	
	    var geoSource = geoSourceManager.load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
	    zrUtil.each(geoSource.regions, function (region) {
	      var name = region.name;
	
	      if (!dataNameMap.get(name)) {
	        selectTargetList.push({
	          name: name
	        });
	        toAppendNames.push(name);
	      }
	    });
	    this.updateSelectedMap(selectTargetList); // Complete data with missing regions. The consequent processes (like visual
	    // map and render) can not be performed without a "full data". For example,
	    // find `dataIndex` by name.
	
	    data.appendValues([], toAppendNames);
	    return data;
	  },
	
	  /**
	   * If no host geo model, return null, which means using a
	   * inner exclusive geo model.
	   */
	  getHostGeoModel: function () {
	    var geoIndex = this.option.geoIndex;
	    return geoIndex != null ? this.dependentModels.geo[geoIndex] : null;
	  },
	  getMapType: function () {
	    return (this.getHostGeoModel() || this).option.map;
	  },
	  // _fillOption: function (option, mapName) {
	  // Shallow clone
	  // option = zrUtil.extend({}, option);
	  // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
	  // return option;
	  // },
	  getRawValue: function (dataIndex) {
	    // Use value stored in data instead because it is calculated from multiple series
	    // FIXME Provide all value of multiple series ?
	    var data = this.getData();
	    return data.get(data.mapDimension('value'), dataIndex);
	  },
	
	  /**
	   * Get model of region
	   * @param  {string} name
	   * @return {module:echarts/model/Model}
	   */
	  getRegionModel: function (regionName) {
	    var data = this.getData();
	    return data.getItemModel(data.indexOfName(regionName));
	  },
	
	  /**
	   * Map tooltip formatter
	   *
	   * @param {number} dataIndex
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    // FIXME orignalData and data is a bit confusing
	    var data = this.getData();
	    var formattedValue = addCommas(this.getRawValue(dataIndex));
	    var name = data.getName(dataIndex);
	    var seriesGroup = this.seriesGroup;
	    var seriesNames = [];
	
	    for (var i = 0; i < seriesGroup.length; i++) {
	      var otherIndex = seriesGroup[i].originalData.indexOfName(name);
	      var valueDim = data.mapDimension('value');
	
	      if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) {
	        seriesNames.push(encodeHTML(seriesGroup[i].name));
	      }
	    }
	
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    return seriesNames.join(', ') + newLine + encodeHTML(name + ' : ' + formattedValue);
	  },
	
	  /**
	   * @implement
	   */
	  getTooltipPosition: function (dataIndex) {
	    if (dataIndex != null) {
	      var name = this.getData().getName(dataIndex);
	      var geo = this.coordinateSystem;
	      var region = geo.getRegion(name);
	      return region && geo.dataToPoint(region.center);
	    }
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 2,
	    coordinateSystem: 'geo',
	    // map should be explicitly specified since ec3.
	    map: '',
	    // If `geoIndex` is not specified, a exclusive geo will be
	    // created. Otherwise use the specified geo component, and
	    // `map` and `mapType` are ignored.
	    // geoIndex: 0,
	    // 'center' | 'left' | 'right' | 'x%' | {number}
	    left: 'center',
	    // 'center' | 'top' | 'bottom' | 'x%' | {number}
	    top: 'center',
	    // right
	    // bottom
	    // width:
	    // height
	    // Aspect is width / height. Inited to be geoJson bbox aspect
	    // This parameter is used for scale this aspect
	    aspectScale: 0.75,
	    ///// Layout with center and size
	    // If you wan't to put map in a fixed size box with right aspect ratio
	    // This two properties may more conveninet
	    // layoutCenter: [50%, 50%]
	    // layoutSize: 100
	    // 数值合并方式，默认加和，可选为：
	    // 'sum' | 'average' | 'max' | 'min'
	    // mapValueCalculation: 'sum',
	    // 地图数值计算结果小数精度
	    // mapValuePrecision: 0,
	    // 显示图例颜色标识（系列标识的小圆点），图例开启时有效
	    showLegendSymbol: true,
	    // 选择模式，默认关闭，可选single，multiple
	    // selectedMode: false,
	    dataRangeHoverLink: true,
	    // 是否开启缩放及漫游模式
	    // roam: false,
	    // Define left-top, right-bottom coords to control view
	    // For example, [ [180, 90], [-180, -90] ],
	    // higher priority than center and zoom
	    boundingCoords: null,
	    // Default on center of map
	    center: null,
	    zoom: 1,
	    scaleLimit: null,
	    label: {
	      show: false,
	      color: '#000'
	    },
	    // scaleLimit: null,
	    itemStyle: {
	      borderWidth: 0.5,
	      borderColor: '#444',
	      areaColor: '#eee'
	    },
	    emphasis: {
	      label: {
	        show: true,
	        color: 'rgb(100,0,0)'
	      },
	      itemStyle: {
	        areaColor: 'rgba(255,215,0,0.8)'
	      }
	    },
	    nameProperty: 'name'
	  }
	});
	zrUtil.mixin(MapSeries, dataSelectableMixin);
	var _default = MapSeries;
	module.exports = _default;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	
	var mapDataStorage = __webpack_require__(336);
	
	var geoJSONLoader = __webpack_require__(430);
	
	var geoSVGLoader = __webpack_require__(435);
	
	var BoundingRect = __webpack_require__(242);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var loaders = {
	  geoJSON: geoJSONLoader,
	  svg: geoSVGLoader
	};
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} nameMap
	   * @param {string} nameProperty
	   * @return {Object} source {regions, regionsMap, nameCoordMap, boundingRect}
	   */
	  load: function (mapName, nameMap, nameProperty) {
	    var regions = [];
	    var regionsMap = createHashMap();
	    var nameCoordMap = createHashMap();
	    var boundingRect;
	    var mapRecords = retrieveMap(mapName);
	    each(mapRecords, function (record) {
	      var singleSource = loaders[record.type].load(mapName, record, nameProperty);
	      each(singleSource.regions, function (region) {
	        var regionName = region.name; // Try use the alias in geoNameMap
	
	        if (nameMap && nameMap.hasOwnProperty(regionName)) {
	          region = region.cloneShallow(regionName = nameMap[regionName]);
	        }
	
	        regions.push(region);
	        regionsMap.set(regionName, region);
	        nameCoordMap.set(regionName, region.center);
	      });
	      var rect = singleSource.boundingRect;
	
	      if (rect) {
	        boundingRect ? boundingRect.union(rect) : boundingRect = rect.clone();
	      }
	    });
	    return {
	      regions: regions,
	      regionsMap: regionsMap,
	      nameCoordMap: nameCoordMap,
	      // FIXME Always return new ?
	      boundingRect: boundingRect || new BoundingRect(0, 0, 0, 0)
	    };
	  },
	
	  /**
	   * @param {string} mapName
	   * @param {string} hostKey For cache.
	   * @return {Array.<module:zrender/Element>} Roots.
	   */
	  makeGraphic: makeInvoker('makeGraphic'),
	
	  /**
	   * @param {string} mapName
	   * @param {string} hostKey For cache.
	   */
	  removeGraphic: makeInvoker('removeGraphic')
	};
	
	function makeInvoker(methodName) {
	  return function (mapName, hostKey) {
	    var mapRecords = retrieveMap(mapName);
	    var results = [];
	    each(mapRecords, function (record) {
	      var method = loaders[record.type][methodName];
	      method && results.push(method(mapName, record, hostKey));
	    });
	    return results;
	  };
	}
	
	function mapNotExistsError(mapName) {}
	
	function retrieveMap(mapName) {
	  var mapRecords = mapDataStorage.retrieveMap(mapName) || [];
	  return mapRecords;
	}
	
	module.exports = _default;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	
	var parseGeoJson = __webpack_require__(361);
	
	var _model = __webpack_require__(261);
	
	var makeInner = _model.makeInner;
	
	var fixNanhai = __webpack_require__(431);
	
	var fixTextCoord = __webpack_require__(432);
	
	var fixGeoCoord = __webpack_require__(433);
	
	var fixDiaoyuIsland = __webpack_require__(434);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Built-in GEO fixer.
	var inner = makeInner();
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} mapRecord {specialAreas, geoJSON}
	   * @param {string} nameProperty
	   * @return {Object} {regions, boundingRect}
	   */
	  load: function (mapName, mapRecord, nameProperty) {
	    var parsed = inner(mapRecord).parsed;
	
	    if (parsed) {
	      return parsed;
	    }
	
	    var specialAreas = mapRecord.specialAreas || {};
	    var geoJSON = mapRecord.geoJSON;
	    var regions; // https://jsperf.com/try-catch-performance-overhead
	
	    try {
	      regions = geoJSON ? parseGeoJson(geoJSON, nameProperty) : [];
	    } catch (e) {
	      throw new Error('Invalid geoJson format\n' + e.message);
	    }
	
	    fixNanhai(mapName, regions);
	    each(regions, function (region) {
	      var regionName = region.name;
	      fixTextCoord(mapName, region);
	      fixGeoCoord(mapName, region);
	      fixDiaoyuIsland(mapName, region); // Some area like Alaska in USA map needs to be tansformed
	      // to look better
	
	      var specialArea = specialAreas[regionName];
	
	      if (specialArea) {
	        region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
	      }
	    });
	    return inner(mapRecord).parsed = {
	      regions: regions,
	      boundingRect: getBoundingRect(regions)
	    };
	  }
	};
	
	function getBoundingRect(regions) {
	  var rect;
	
	  for (var i = 0; i < regions.length; i++) {
	    var regionRect = regions[i].getBoundingRect();
	    rect = rect || regionRect.clone();
	    rect.union(regionRect);
	  }
	
	  return rect;
	}
	
	module.exports = _default;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Region = __webpack_require__(362);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Fix for 南海诸岛
	var geoCoord = [126, 25];
	var points = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, 0.7], [52, 0.7], [56, 7.7], [59, 0.7], [64, 0.7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]];
	
	for (var i = 0; i < points.length; i++) {
	  for (var k = 0; k < points[i].length; k++) {
	    points[i][k][0] /= 10.5;
	    points[i][k][1] /= -10.5 / 0.75;
	    points[i][k][0] += geoCoord[0];
	    points[i][k][1] += geoCoord[1];
	  }
	}
	
	function _default(mapType, regions) {
	  if (mapType === 'china') {
	    regions.push(new Region('南海诸岛', zrUtil.map(points, function (exterior) {
	      return {
	        type: 'polygon',
	        exterior: exterior
	      };
	    }), geoCoord));
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var coordsOffsetMap = {
	  '南海诸岛': [32, 80],
	  // 全国
	  '广东': [0, -10],
	  '香港': [10, 5],
	  '澳门': [-10, 10],
	  //'北京': [-10, 0],
	  '天津': [5, 5]
	};
	
	function _default(mapType, region) {
	  if (mapType === 'china') {
	    var coordFix = coordsOffsetMap[region.name];
	
	    if (coordFix) {
	      var cp = region.center;
	      cp[0] += coordFix[0] / 10.5;
	      cp[1] += -coordFix[1] / (10.5 / 0.75);
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var geoCoordMap = {
	  'Russia': [100, 60],
	  'United States': [-99, 38],
	  'United States of America': [-99, 38]
	};
	
	function _default(mapType, region) {
	  if (mapType === 'world') {
	    var geoCoord = geoCoordMap[region.name];
	
	    if (geoCoord) {
	      var cp = region.center;
	      cp[0] = geoCoord[0];
	      cp[1] = geoCoord[1];
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Fix for 钓鱼岛
	// var Region = require('../Region');
	// var zrUtil = require('zrender/src/core/util');
	// var geoCoord = [126, 25];
	var points = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];
	
	function _default(mapType, region) {
	  if (mapType === 'china' && region.name === '台湾') {
	    region.geometries.push({
	      type: 'polygon',
	      exterior: points[0]
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _parseSVG = __webpack_require__(337);
	
	var parseSVG = _parseSVG.parseSVG;
	var makeViewBoxTransform = _parseSVG.makeViewBoxTransform;
	
	var Group = __webpack_require__(230);
	
	var Rect = __webpack_require__(292);
	
	var _util = __webpack_require__(220);
	
	var assert = _util.assert;
	var createHashMap = _util.createHashMap;
	
	var BoundingRect = __webpack_require__(242);
	
	var _model = __webpack_require__(261);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} mapRecord {specialAreas, geoJSON}
	   * @return {Object} {root, boundingRect}
	   */
	  load: function (mapName, mapRecord) {
	    var originRoot = inner(mapRecord).originRoot;
	
	    if (originRoot) {
	      return {
	        root: originRoot,
	        boundingRect: inner(mapRecord).boundingRect
	      };
	    }
	
	    var graphic = buildGraphic(mapRecord);
	    inner(mapRecord).originRoot = graphic.root;
	    inner(mapRecord).boundingRect = graphic.boundingRect;
	    return graphic;
	  },
	  makeGraphic: function (mapName, mapRecord, hostKey) {
	    // For performance consideration (in large SVG), graphic only maked
	    // when necessary and reuse them according to hostKey.
	    var field = inner(mapRecord);
	    var rootMap = field.rootMap || (field.rootMap = createHashMap());
	    var root = rootMap.get(hostKey);
	
	    if (root) {
	      return root;
	    }
	
	    var originRoot = field.originRoot;
	    var boundingRect = field.boundingRect; // For performance, if originRoot is not used by a view,
	    // assign it to a view, but not reproduce graphic elements.
	
	    if (!field.originRootHostKey) {
	      field.originRootHostKey = hostKey;
	      root = originRoot;
	    } else {
	      root = buildGraphic(mapRecord, boundingRect).root;
	    }
	
	    return rootMap.set(hostKey, root);
	  },
	  removeGraphic: function (mapName, mapRecord, hostKey) {
	    var field = inner(mapRecord);
	    var rootMap = field.rootMap;
	    rootMap && rootMap.removeKey(hostKey);
	
	    if (hostKey === field.originRootHostKey) {
	      field.originRootHostKey = null;
	    }
	  }
	};
	
	function buildGraphic(mapRecord, boundingRect) {
	  var svgXML = mapRecord.svgXML;
	  var result;
	  var root;
	
	  try {
	    result = svgXML && parseSVG(svgXML, {
	      ignoreViewBox: true,
	      ignoreRootClip: true
	    }) || {};
	    root = result.root;
	    assert(root != null);
	  } catch (e) {
	    throw new Error('Invalid svg format\n' + e.message);
	  }
	
	  var svgWidth = result.width;
	  var svgHeight = result.height;
	  var viewBoxRect = result.viewBoxRect;
	
	  if (!boundingRect) {
	    boundingRect = svgWidth == null || svgHeight == null ? // If svg width / height not specified, calculate
	    // bounding rect as the width / height
	    root.getBoundingRect() : new BoundingRect(0, 0, 0, 0);
	
	    if (svgWidth != null) {
	      boundingRect.width = svgWidth;
	    }
	
	    if (svgHeight != null) {
	      boundingRect.height = svgHeight;
	    }
	  }
	
	  if (viewBoxRect) {
	    var viewBoxTransform = makeViewBoxTransform(viewBoxRect, boundingRect.width, boundingRect.height);
	    var elRoot = root;
	    root = new Group();
	    root.add(elRoot);
	    elRoot.scale = viewBoxTransform.scale;
	    elRoot.position = viewBoxTransform.position;
	  }
	
	  root.setClipPath(new Rect({
	    shape: boundingRect.plain()
	  }));
	  return {
	    root: root,
	    boundingRect: boundingRect
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var MapDraw = __webpack_require__(437);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var HIGH_DOWN_PROP = '__seriesMapHighDown';
	var RECORD_VERSION_PROP = '__seriesMapCallKey';
	
	var _default = echarts.extendChartView({
	  type: 'map',
	  render: function (mapModel, ecModel, api, payload) {
	    // Not render if it is an toggleSelect action from self
	    if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) {
	      return;
	    }
	
	    var group = this.group;
	    group.removeAll();
	
	    if (mapModel.getHostGeoModel()) {
	      return;
	    } // Not update map if it is an roam action from self
	
	
	    if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
	      if (mapModel.needsDrawMap) {
	        var mapDraw = this._mapDraw || new MapDraw(api, true);
	        group.add(mapDraw.group);
	        mapDraw.draw(mapModel, ecModel, api, this, payload);
	        this._mapDraw = mapDraw;
	      } else {
	        // Remove drawed map
	        this._mapDraw && this._mapDraw.remove();
	        this._mapDraw = null;
	      }
	    } else {
	      var mapDraw = this._mapDraw;
	      mapDraw && group.add(mapDraw.group);
	    }
	
	    mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
	  },
	  remove: function () {
	    this._mapDraw && this._mapDraw.remove();
	    this._mapDraw = null;
	    this.group.removeAll();
	  },
	  dispose: function () {
	    this._mapDraw && this._mapDraw.remove();
	    this._mapDraw = null;
	  },
	  _renderSymbols: function (mapModel, ecModel, api) {
	    var originalData = mapModel.originalData;
	    var group = this.group;
	    originalData.each(originalData.mapDimension('value'), function (value, originalDataIndex) {
	      if (isNaN(value)) {
	        return;
	      }
	
	      var layout = originalData.getItemLayout(originalDataIndex);
	
	      if (!layout || !layout.point) {
	        // Not exists in map
	        return;
	      }
	
	      var point = layout.point;
	      var offset = layout.offset;
	      var circle = new graphic.Circle({
	        style: {
	          // Because the special of map draw.
	          // Which needs statistic of multiple series and draw on one map.
	          // And each series also need a symbol with legend color
	          //
	          // Layout and visual are put one the different data
	          fill: mapModel.getData().getVisual('color')
	        },
	        shape: {
	          cx: point[0] + offset * 9,
	          cy: point[1],
	          r: 3
	        },
	        silent: true,
	        // Do not overlap the first series, on which labels are displayed.
	        z2: 8 + (!offset ? graphic.Z2_EMPHASIS_LIFT + 1 : 0)
	      }); // Only the series that has the first value on the same region is in charge of rendering the label.
	      // But consider the case:
	      // series: [
	      //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
	      //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
	      // ]
	      // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
	      // For backward compatibility, we follow the rule that render label `A` by the
	      // settings on series `X` but render label `C` by the settings on series `Y`.
	
	      if (!offset) {
	        var fullData = mapModel.mainSeries.getData();
	        var name = originalData.getName(originalDataIndex);
	        var fullIndex = fullData.indexOfName(name);
	        var itemModel = originalData.getItemModel(originalDataIndex);
	        var labelModel = itemModel.getModel('label');
	        var hoverLabelModel = itemModel.getModel('emphasis.label');
	        var regionGroup = fullData.getItemGraphicEl(fullIndex); // `getFormattedLabel` needs to use `getData` inside. Here
	        // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
	        // FIXME
	        // If this is not the `mainSeries`, the item model (like label formatter)
	        // set on original data item will never get. But it has been working
	        // like that from the begining, and this scenario is rarely encountered.
	        // So it won't be fixed until have to.
	
	        var normalText = zrUtil.retrieve2(mapModel.getFormattedLabel(fullIndex, 'normal'), name);
	        var emphasisText = zrUtil.retrieve2(mapModel.getFormattedLabel(fullIndex, 'emphasis'), normalText);
	        var highDownRecord = regionGroup[HIGH_DOWN_PROP];
	        var recordVersion = Math.random(); // Prevent from register listeners duplicatedly when roaming.
	
	        if (!highDownRecord) {
	          highDownRecord = regionGroup[HIGH_DOWN_PROP] = {};
	          var onEmphasis = zrUtil.curry(onRegionHighDown, true);
	          var onNormal = zrUtil.curry(onRegionHighDown, false);
	          regionGroup.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
	        } // Prevent removed regions effect current grapics.
	
	
	        regionGroup[RECORD_VERSION_PROP] = recordVersion;
	        zrUtil.extend(highDownRecord, {
	          recordVersion: recordVersion,
	          circle: circle,
	          labelModel: labelModel,
	          hoverLabelModel: hoverLabelModel,
	          emphasisText: emphasisText,
	          normalText: normalText
	        }); // FIXME
	        // Consider set option when emphasis.
	
	        enterRegionHighDown(highDownRecord, false);
	      }
	
	      group.add(circle);
	    });
	  }
	});
	
	function onRegionHighDown(toHighOrDown) {
	  var highDownRecord = this[HIGH_DOWN_PROP];
	
	  if (highDownRecord && highDownRecord.recordVersion === this[RECORD_VERSION_PROP]) {
	    enterRegionHighDown(highDownRecord, toHighOrDown);
	  }
	}
	
	function enterRegionHighDown(highDownRecord, toHighOrDown) {
	  var circle = highDownRecord.circle;
	  var labelModel = highDownRecord.labelModel;
	  var hoverLabelModel = highDownRecord.hoverLabelModel;
	  var emphasisText = highDownRecord.emphasisText;
	  var normalText = highDownRecord.normalText;
	
	  if (toHighOrDown) {
	    circle.style.extendFrom(graphic.setTextStyle({}, hoverLabelModel, {
	      text: hoverLabelModel.get('show') ? emphasisText : null
	    }, {
	      isRectText: true,
	      useInsideStyle: false
	    }, true)); // Make label upper than others if overlaps.
	
	    circle.__mapOriginalZ2 = circle.z2;
	    circle.z2 += graphic.Z2_EMPHASIS_LIFT;
	  } else {
	    graphic.setTextStyle(circle.style, labelModel, {
	      text: labelModel.get('show') ? normalText : null,
	      textPosition: labelModel.getShallow('position') || 'bottom'
	    }, {
	      isRectText: true,
	      useInsideStyle: false
	    }); // Trigger normalize style like padding.
	
	    circle.dirty(false);
	
	    if (circle.__mapOriginalZ2 != null) {
	      circle.z2 = circle.__mapOriginalZ2;
	      circle.__mapOriginalZ2 = null;
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var RoamController = __webpack_require__(438);
	
	var roamHelper = __webpack_require__(440);
	
	var _cursorHelper = __webpack_require__(441);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphic = __webpack_require__(268);
	
	var geoSourceManager = __webpack_require__(429);
	
	var _component = __webpack_require__(304);
	
	var getUID = _component.getUID;
	
	var Transformable = __webpack_require__(232);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getFixedItemStyle(model) {
	  var itemStyle = model.getItemStyle();
	  var areaColor = model.get('areaColor'); // If user want the color not to be changed when hover,
	  // they should both set areaColor and color to be null.
	
	  if (areaColor != null) {
	    itemStyle.fill = areaColor;
	  }
	
	  return itemStyle;
	}
	
	function updateMapSelectHandler(mapDraw, mapOrGeoModel, regionsGroup, api, fromView) {
	  regionsGroup.off('click');
	  regionsGroup.off('mousedown');
	
	  if (mapOrGeoModel.get('selectedMode')) {
	    regionsGroup.on('mousedown', function () {
	      mapDraw._mouseDownFlag = true;
	    });
	    regionsGroup.on('click', function (e) {
	      if (!mapDraw._mouseDownFlag) {
	        return;
	      }
	
	      mapDraw._mouseDownFlag = false;
	      var el = e.target;
	
	      while (!el.__regions) {
	        el = el.parent;
	      }
	
	      if (!el) {
	        return;
	      }
	
	      var action = {
	        type: (mapOrGeoModel.mainType === 'geo' ? 'geo' : 'map') + 'ToggleSelect',
	        batch: zrUtil.map(el.__regions, function (region) {
	          return {
	            name: region.name,
	            from: fromView.uid
	          };
	        })
	      };
	      action[mapOrGeoModel.mainType + 'Id'] = mapOrGeoModel.id;
	      api.dispatchAction(action);
	      updateMapSelected(mapOrGeoModel, regionsGroup);
	    });
	  }
	}
	
	function updateMapSelected(mapOrGeoModel, regionsGroup) {
	  // FIXME
	  regionsGroup.eachChild(function (otherRegionEl) {
	    zrUtil.each(otherRegionEl.__regions, function (region) {
	      otherRegionEl.trigger(mapOrGeoModel.isSelected(region.name) ? 'emphasis' : 'normal');
	    });
	  });
	}
	/**
	 * @alias module:echarts/component/helper/MapDraw
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {boolean} updateGroup
	 */
	
	
	function MapDraw(api, updateGroup) {
	  var group = new graphic.Group();
	  /**
	   * @type {string}
	   * @private
	   */
	
	  this.uid = getUID('ec_map_draw');
	  /**
	   * @type {module:echarts/component/helper/RoamController}
	   * @private
	   */
	
	  this._controller = new RoamController(api.getZr());
	  /**
	   * @type {Object} {target, zoom, zoomLimit}
	   * @private
	   */
	
	  this._controllerHost = {
	    target: updateGroup ? group : null
	  };
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	
	  this.group = group;
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._updateGroup = updateGroup;
	  /**
	   * This flag is used to make sure that only one among
	   * `pan`, `zoom`, `click` can occurs, otherwise 'selected'
	   * action may be triggered when `pan`, which is unexpected.
	   * @type {booelan}
	   */
	
	  this._mouseDownFlag;
	  /**
	   * @type {string}
	   */
	
	  this._mapName;
	  /**
	   * @type {boolean}
	   */
	
	  this._initialized;
	  /**
	   * @type {module:zrender/container/Group}
	   */
	
	  group.add(this._regionsGroup = new graphic.Group());
	  /**
	   * @type {module:zrender/container/Group}
	   */
	
	  group.add(this._backgroundGroup = new graphic.Group());
	}
	
	MapDraw.prototype = {
	  constructor: MapDraw,
	  draw: function (mapOrGeoModel, ecModel, api, fromView, payload) {
	    var isGeo = mapOrGeoModel.mainType === 'geo'; // Map series has data. GEO model that controlled by map series
	    // will be assigned with map data. Other GEO model has no data.
	
	    var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
	    isGeo && ecModel.eachComponent({
	      mainType: 'series',
	      subType: 'map'
	    }, function (mapSeries) {
	      if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) {
	        data = mapSeries.getData();
	      }
	    });
	    var geo = mapOrGeoModel.coordinateSystem;
	
	    this._updateBackground(geo);
	
	    var regionsGroup = this._regionsGroup;
	    var group = this.group;
	    var transformInfo = geo.getTransformInfo(); // No animation when first draw or in action
	
	    var isFirstDraw = !regionsGroup.childAt(0) || payload;
	    var targetScale;
	
	    if (isFirstDraw) {
	      group.transform = transformInfo.roamTransform;
	      group.decomposeTransform();
	      group.dirty();
	    } else {
	      var target = new Transformable();
	      target.transform = transformInfo.roamTransform;
	      target.decomposeTransform();
	      var props = {
	        scale: target.scale,
	        position: target.position
	      };
	      targetScale = target.scale;
	      graphic.updateProps(group, props, mapOrGeoModel);
	    }
	
	    var scale = transformInfo.rawScale;
	    var position = transformInfo.rawPosition;
	    regionsGroup.removeAll();
	    var itemStyleAccessPath = ['itemStyle'];
	    var hoverItemStyleAccessPath = ['emphasis', 'itemStyle'];
	    var labelAccessPath = ['label'];
	    var hoverLabelAccessPath = ['emphasis', 'label'];
	    var nameMap = zrUtil.createHashMap();
	    zrUtil.each(geo.regions, function (region) {
	      // Consider in GeoJson properties.name may be duplicated, for example,
	      // there is multiple region named "United Kindom" or "France" (so many
	      // colonies). And it is not appropriate to merge them in geo, which
	      // will make them share the same label and bring trouble in label
	      // location calculation.
	      var regionGroup = nameMap.get(region.name) || nameMap.set(region.name, new graphic.Group());
	      var compoundPath = new graphic.CompoundPath({
	        segmentIgnoreThreshold: 1,
	        shape: {
	          paths: []
	        }
	      });
	      regionGroup.add(compoundPath);
	      var regionModel = mapOrGeoModel.getRegionModel(region.name) || mapOrGeoModel;
	      var itemStyleModel = regionModel.getModel(itemStyleAccessPath);
	      var hoverItemStyleModel = regionModel.getModel(hoverItemStyleAccessPath);
	      var itemStyle = getFixedItemStyle(itemStyleModel);
	      var hoverItemStyle = getFixedItemStyle(hoverItemStyleModel);
	      var labelModel = regionModel.getModel(labelAccessPath);
	      var hoverLabelModel = regionModel.getModel(hoverLabelAccessPath);
	      var dataIdx; // Use the itemStyle in data if has data
	
	      if (data) {
	        dataIdx = data.indexOfName(region.name); // Only visual color of each item will be used. It can be encoded by dataRange
	        // But visual color of series is used in symbol drawing
	        //
	        // Visual color for each series is for the symbol draw
	
	        var visualColor = data.getItemVisual(dataIdx, 'color', true);
	
	        if (visualColor) {
	          itemStyle.fill = visualColor;
	        }
	      }
	
	      var transformPoint = function (point) {
	        return [point[0] * scale[0] + position[0], point[1] * scale[1] + position[1]];
	      };
	
	      zrUtil.each(region.geometries, function (geometry) {
	        if (geometry.type !== 'polygon') {
	          return;
	        }
	
	        var points = [];
	
	        for (var i = 0; i < geometry.exterior.length; ++i) {
	          points.push(transformPoint(geometry.exterior[i]));
	        }
	
	        compoundPath.shape.paths.push(new graphic.Polygon({
	          segmentIgnoreThreshold: 1,
	          shape: {
	            points: points
	          }
	        }));
	
	        for (var i = 0; i < (geometry.interiors ? geometry.interiors.length : 0); ++i) {
	          var interior = geometry.interiors[i];
	          var points = [];
	
	          for (var j = 0; j < interior.length; ++j) {
	            points.push(transformPoint(interior[j]));
	          }
	
	          compoundPath.shape.paths.push(new graphic.Polygon({
	            segmentIgnoreThreshold: 1,
	            shape: {
	              points: points
	            }
	          }));
	        }
	      });
	      compoundPath.setStyle(itemStyle);
	      compoundPath.style.strokeNoScale = true;
	      compoundPath.culling = true; // Label
	
	      var showLabel = labelModel.get('show');
	      var hoverShowLabel = hoverLabelModel.get('show');
	      var isDataNaN = data && isNaN(data.get(data.mapDimension('value'), dataIdx));
	      var itemLayout = data && data.getItemLayout(dataIdx); // In the following cases label will be drawn
	      // 1. In map series and data value is NaN
	      // 2. In geo component
	      // 4. Region has no series legendSymbol, which will be add a showLabel flag in mapSymbolLayout
	
	      if (isGeo || isDataNaN && (showLabel || hoverShowLabel) || itemLayout && itemLayout.showLabel) {
	        var query = !isGeo ? dataIdx : region.name;
	        var labelFetcher; // Consider dataIdx not found.
	
	        if (!data || dataIdx >= 0) {
	          labelFetcher = mapOrGeoModel;
	        }
	
	        var textEl = new graphic.Text({
	          position: transformPoint(region.center.slice()),
	          // FIXME
	          // label rotation is not support yet in geo or regions of series-map
	          // that has no data. The rotation will be effected by this `scale`.
	          // So needed to change to RectText?
	          scale: [1 / group.scale[0], 1 / group.scale[1]],
	          z2: 10,
	          silent: true
	        });
	        graphic.setLabelStyle(textEl.style, textEl.hoverStyle = {}, labelModel, hoverLabelModel, {
	          labelFetcher: labelFetcher,
	          labelDataIndex: query,
	          defaultText: region.name,
	          useInsideStyle: false
	        }, {
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        });
	
	        if (!isFirstDraw) {
	          // Text animation
	          var textScale = [1 / targetScale[0], 1 / targetScale[1]];
	          graphic.updateProps(textEl, {
	            scale: textScale
	          }, mapOrGeoModel);
	        }
	
	        regionGroup.add(textEl);
	      } // setItemGraphicEl, setHoverStyle after all polygons and labels
	      // are added to the rigionGroup
	
	
	      if (data) {
	        data.setItemGraphicEl(dataIdx, regionGroup);
	      } else {
	        var regionModel = mapOrGeoModel.getRegionModel(region.name); // Package custom mouse event for geo component
	
	        compoundPath.eventData = {
	          componentType: 'geo',
	          componentIndex: mapOrGeoModel.componentIndex,
	          geoIndex: mapOrGeoModel.componentIndex,
	          name: region.name,
	          region: regionModel && regionModel.option || {}
	        };
	      }
	
	      var groupRegions = regionGroup.__regions || (regionGroup.__regions = []);
	      groupRegions.push(region);
	      regionGroup.highDownSilentOnTouch = !!mapOrGeoModel.get('selectedMode');
	      graphic.setHoverStyle(regionGroup, hoverItemStyle);
	      regionsGroup.add(regionGroup);
	    });
	
	    this._updateController(mapOrGeoModel, ecModel, api);
	
	    updateMapSelectHandler(this, mapOrGeoModel, regionsGroup, api, fromView);
	    updateMapSelected(mapOrGeoModel, regionsGroup);
	  },
	  remove: function () {
	    this._regionsGroup.removeAll();
	
	    this._backgroundGroup.removeAll();
	
	    this._controller.dispose();
	
	    this._mapName && geoSourceManager.removeGraphic(this._mapName, this.uid);
	    this._mapName = null;
	    this._controllerHost = {};
	  },
	  _updateBackground: function (geo) {
	    var mapName = geo.map;
	
	    if (this._mapName !== mapName) {
	      zrUtil.each(geoSourceManager.makeGraphic(mapName, this.uid), function (root) {
	        this._backgroundGroup.add(root);
	      }, this);
	    }
	
	    this._mapName = mapName;
	  },
	  _updateController: function (mapOrGeoModel, ecModel, api) {
	    var geo = mapOrGeoModel.coordinateSystem;
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
	    controllerHost.zoom = geo.getZoom(); // roamType is will be set default true if it is null
	
	    controller.enable(mapOrGeoModel.get('roam') || false);
	    var mainType = mapOrGeoModel.mainType;
	
	    function makeActionBase() {
	      var action = {
	        type: 'geoRoam',
	        componentType: mainType
	      };
	      action[mainType + 'Id'] = mapOrGeoModel.id;
	      return action;
	    }
	
	    controller.off('pan').on('pan', function (e) {
	      this._mouseDownFlag = false;
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction(zrUtil.extend(makeActionBase(), {
	        dx: e.dx,
	        dy: e.dy
	      }));
	    }, this);
	    controller.off('zoom').on('zoom', function (e) {
	      this._mouseDownFlag = false;
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction(zrUtil.extend(makeActionBase(), {
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      }));
	
	      if (this._updateGroup) {
	        var scale = this.group.scale;
	
	        this._regionsGroup.traverse(function (el) {
	          if (el.type === 'text') {
	            el.attr('scale', [1 / scale[0], 1 / scale[1]]);
	          }
	        });
	      }
	    }, this);
	    controller.setPointerChecker(function (e, x, y) {
	      return geo.getViewRectAfterRoam().contain(x, y) && !onIrrelevantElement(e, api, mapOrGeoModel);
	    });
	  }
	};
	var _default = MapDraw;
	module.exports = _default;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Eventful = __webpack_require__(224);
	
	var eventTool = __webpack_require__(225);
	
	var interactionMutex = __webpack_require__(439);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @alias module:echarts/component/helper/RoamController
	 * @constructor
	 * @mixin {module:zrender/mixin/Eventful}
	 *
	 * @param {module:zrender/zrender~ZRender} zr
	 */
	function RoamController(zr) {
	  /**
	   * @type {Function}
	   */
	  this.pointerChecker;
	  /**
	   * @type {module:zrender}
	   */
	
	  this._zr = zr;
	  /**
	   * @type {Object}
	   */
	
	  this._opt = {}; // Avoid two roamController bind the same handler
	
	  var bind = zrUtil.bind;
	  var mousedownHandler = bind(mousedown, this);
	  var mousemoveHandler = bind(mousemove, this);
	  var mouseupHandler = bind(mouseup, this);
	  var mousewheelHandler = bind(mousewheel, this);
	  var pinchHandler = bind(pinch, this);
	  Eventful.call(this);
	  /**
	   * @param {Function} pointerChecker
	   *                   input: x, y
	   *                   output: boolean
	   */
	
	  this.setPointerChecker = function (pointerChecker) {
	    this.pointerChecker = pointerChecker;
	  };
	  /**
	   * Notice: only enable needed types. For example, if 'zoom'
	   * is not needed, 'zoom' should not be enabled, otherwise
	   * default mousewheel behaviour (scroll page) will be disabled.
	   *
	   * @param  {boolean|string} [controlType=true] Specify the control type,
	   *                          which can be null/undefined or true/false
	   *                          or 'pan/move' or 'zoom'/'scale'
	   * @param {Object} [opt]
	   * @param {Object} [opt.zoomOnMouseWheel=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.moveOnMouseMove=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.moveOnMouseWheel=false] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.preventDefaultMouseMove=true] When pan.
	   */
	
	
	  this.enable = function (controlType, opt) {
	    // Disable previous first
	    this.disable();
	    this._opt = zrUtil.defaults(zrUtil.clone(opt) || {}, {
	      zoomOnMouseWheel: true,
	      moveOnMouseMove: true,
	      // By default, wheel do not trigger move.
	      moveOnMouseWheel: false,
	      preventDefaultMouseMove: true
	    });
	
	    if (controlType == null) {
	      controlType = true;
	    }
	
	    if (controlType === true || controlType === 'move' || controlType === 'pan') {
	      zr.on('mousedown', mousedownHandler);
	      zr.on('mousemove', mousemoveHandler);
	      zr.on('mouseup', mouseupHandler);
	    }
	
	    if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
	      zr.on('mousewheel', mousewheelHandler);
	      zr.on('pinch', pinchHandler);
	    }
	  };
	
	  this.disable = function () {
	    zr.off('mousedown', mousedownHandler);
	    zr.off('mousemove', mousemoveHandler);
	    zr.off('mouseup', mouseupHandler);
	    zr.off('mousewheel', mousewheelHandler);
	    zr.off('pinch', pinchHandler);
	  };
	
	  this.dispose = this.disable;
	
	  this.isDragging = function () {
	    return this._dragging;
	  };
	
	  this.isPinching = function () {
	    return this._pinching;
	  };
	}
	
	zrUtil.mixin(RoamController, Eventful);
	
	function mousedown(e) {
	  if (eventTool.isMiddleOrRightButtonOnMouseUpDown(e) || e.target && e.target.draggable) {
	    return;
	  }
	
	  var x = e.offsetX;
	  var y = e.offsetY; // Only check on mosedown, but not mousemove.
	  // Mouse can be out of target when mouse moving.
	
	  if (this.pointerChecker && this.pointerChecker(e, x, y)) {
	    this._x = x;
	    this._y = y;
	    this._dragging = true;
	  }
	}
	
	function mousemove(e) {
	  if (!this._dragging || !isAvailableBehavior('moveOnMouseMove', e, this._opt) || e.gestureEvent === 'pinch' || interactionMutex.isTaken(this._zr, 'globalPan')) {
	    return;
	  }
	
	  var x = e.offsetX;
	  var y = e.offsetY;
	  var oldX = this._x;
	  var oldY = this._y;
	  var dx = x - oldX;
	  var dy = y - oldY;
	  this._x = x;
	  this._y = y;
	  this._opt.preventDefaultMouseMove && eventTool.stop(e.event);
	  trigger(this, 'pan', 'moveOnMouseMove', e, {
	    dx: dx,
	    dy: dy,
	    oldX: oldX,
	    oldY: oldY,
	    newX: x,
	    newY: y
	  });
	}
	
	function mouseup(e) {
	  if (!eventTool.isMiddleOrRightButtonOnMouseUpDown(e)) {
	    this._dragging = false;
	  }
	}
	
	function mousewheel(e) {
	  var shouldZoom = isAvailableBehavior('zoomOnMouseWheel', e, this._opt);
	  var shouldMove = isAvailableBehavior('moveOnMouseWheel', e, this._opt);
	  var wheelDelta = e.wheelDelta;
	  var absWheelDeltaDelta = Math.abs(wheelDelta);
	  var originX = e.offsetX;
	  var originY = e.offsetY; // wheelDelta maybe -0 in chrome mac.
	
	  if (wheelDelta === 0 || !shouldZoom && !shouldMove) {
	    return;
	  } // If both `shouldZoom` and `shouldMove` is true, trigger
	  // their event both, and the final behavior is determined
	  // by event listener themselves.
	
	
	  if (shouldZoom) {
	    // Convenience:
	    // Mac and VM Windows on Mac: scroll up: zoom out.
	    // Windows: scroll up: zoom in.
	    // FIXME: Should do more test in different environment.
	    // wheelDelta is too complicated in difference nvironment
	    // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
	    // although it has been normallized by zrender.
	    // wheelDelta of mouse wheel is bigger than touch pad.
	    var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
	    var scale = wheelDelta > 0 ? factor : 1 / factor;
	    checkPointerAndTrigger(this, 'zoom', 'zoomOnMouseWheel', e, {
	      scale: scale,
	      originX: originX,
	      originY: originY
	    });
	  }
	
	  if (shouldMove) {
	    // FIXME: Should do more test in different environment.
	    var absDelta = Math.abs(wheelDelta); // wheelDelta of mouse wheel is bigger than touch pad.
	
	    var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
	    checkPointerAndTrigger(this, 'scrollMove', 'moveOnMouseWheel', e, {
	      scrollDelta: scrollDelta,
	      originX: originX,
	      originY: originY
	    });
	  }
	}
	
	function pinch(e) {
	  if (interactionMutex.isTaken(this._zr, 'globalPan')) {
	    return;
	  }
	
	  var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
	  checkPointerAndTrigger(this, 'zoom', null, e, {
	    scale: scale,
	    originX: e.pinchX,
	    originY: e.pinchY
	  });
	}
	
	function checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
	  if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
	    // When mouse is out of roamController rect,
	    // default befavoius should not be be disabled, otherwise
	    // page sliding is disabled, contrary to expectation.
	    eventTool.stop(e.event);
	    trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
	  }
	}
	
	function trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
	  // Also provide behavior checker for event listener, for some case that
	  // multiple components share one listener.
	  contollerEvent.isAvailableBehavior = zrUtil.bind(isAvailableBehavior, null, behaviorToCheck, e);
	  controller.trigger(eventName, contollerEvent);
	} // settings: {
	//     zoomOnMouseWheel
	//     moveOnMouseMove
	//     moveOnMouseWheel
	// }
	// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	
	
	function isAvailableBehavior(behaviorToCheck, e, settings) {
	  var setting = settings[behaviorToCheck];
	  return !behaviorToCheck || setting && (!zrUtil.isString(setting) || e.event[setting + 'Key']);
	}
	
	var _default = RoamController;
	module.exports = _default;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ATTR = '\0_ec_interaction_mutex';
	
	function take(zr, resourceKey, userKey) {
	  var store = getStore(zr);
	  store[resourceKey] = userKey;
	}
	
	function release(zr, resourceKey, userKey) {
	  var store = getStore(zr);
	  var uKey = store[resourceKey];
	
	  if (uKey === userKey) {
	    store[resourceKey] = null;
	  }
	}
	
	function isTaken(zr, resourceKey) {
	  return !!getStore(zr)[resourceKey];
	}
	
	function getStore(zr) {
	  return zr[ATTR] || (zr[ATTR] = {});
	}
	/**
	 * payload: {
	 *     type: 'takeGlobalCursor',
	 *     key: 'dataZoomSelect', or 'brush', or ...,
	 *         If no userKey, release global cursor.
	 * }
	 */
	
	
	echarts.registerAction({
	  type: 'takeGlobalCursor',
	  event: 'globalCursorTaken',
	  update: 'update'
	}, function () {});
	exports.take = take;
	exports.release = release;
	exports.isTaken = isTaken;

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * For geo and graph.
	 *
	 * @param {Object} controllerHost
	 * @param {module:zrender/Element} controllerHost.target
	 */
	function updateViewOnPan(controllerHost, dx, dy) {
	  var target = controllerHost.target;
	  var pos = target.position;
	  pos[0] += dx;
	  pos[1] += dy;
	  target.dirty();
	}
	/**
	 * For geo and graph.
	 *
	 * @param {Object} controllerHost
	 * @param {module:zrender/Element} controllerHost.target
	 * @param {number} controllerHost.zoom
	 * @param {number} controllerHost.zoomLimit like: {min: 1, max: 2}
	 */
	
	
	function updateViewOnZoom(controllerHost, zoomDelta, zoomX, zoomY) {
	  var target = controllerHost.target;
	  var zoomLimit = controllerHost.zoomLimit;
	  var pos = target.position;
	  var scale = target.scale;
	  var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
	  newZoom *= zoomDelta;
	
	  if (zoomLimit) {
	    var zoomMin = zoomLimit.min || 0;
	    var zoomMax = zoomLimit.max || Infinity;
	    newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
	  }
	
	  var zoomScale = newZoom / controllerHost.zoom;
	  controllerHost.zoom = newZoom; // Keep the mouse center when scaling
	
	  pos[0] -= (zoomX - pos[0]) * (zoomScale - 1);
	  pos[1] -= (zoomY - pos[1]) * (zoomScale - 1);
	  scale[0] *= zoomScale;
	  scale[1] *= zoomScale;
	  target.dirty();
	}
	
	exports.updateViewOnPan = updateViewOnPan;
	exports.updateViewOnZoom = updateViewOnZoom;

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var IRRELEVANT_EXCLUDES = {
	  'axisPointer': 1,
	  'tooltip': 1,
	  'brush': 1
	};
	/**
	 * Avoid that: mouse click on a elements that is over geo or graph,
	 * but roam is triggered.
	 */
	
	function onIrrelevantElement(e, api, targetCoordSysModel) {
	  var model = api.getComponentByElement(e.topTarget); // If model is axisModel, it works only if it is injected with coordinateSystem.
	
	  var coordSys = model && model.coordinateSystem;
	  return model && model !== targetCoordSysModel && !IRRELEVANT_EXCLUDES[model.mainType] && coordSys && coordSys.model !== targetCoordSysModel;
	}
	
	exports.onIrrelevantElement = onIrrelevantElement;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var _roamHelper = __webpack_require__(443);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {string} [componentType=series]
	 * @property {number} [dx]
	 * @property {number} [dy]
	 * @property {number} [zoom]
	 * @property {number} [originX]
	 * @property {number} [originY]
	 */
	echarts.registerAction({
	  type: 'geoRoam',
	  event: 'geoRoam',
	  update: 'updateTransform'
	}, function (payload, ecModel) {
	  var componentType = payload.componentType || 'series';
	  ecModel.eachComponent({
	    mainType: componentType,
	    query: payload
	  }, function (componentModel) {
	    var geo = componentModel.coordinateSystem;
	
	    if (geo.type !== 'geo') {
	      return;
	    }
	
	    var res = updateCenterAndZoom(geo, payload, componentModel.get('scaleLimit'));
	    componentModel.setCenter && componentModel.setCenter(res.center);
	    componentModel.setZoom && componentModel.setZoom(res.zoom); // All map series with same `map` use the same geo coordinate system
	    // So the center and zoom must be in sync. Include the series not selected by legend
	
	    if (componentType === 'series') {
	      zrUtil.each(componentModel.seriesGroup, function (seriesModel) {
	        seriesModel.setCenter(res.center);
	        seriesModel.setZoom(res.zoom);
	      });
	    }
	  });
	});

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/coord/View} view
	 * @param {Object} payload
	 * @param {Object} [zoomLimit]
	 */
	function updateCenterAndZoom(view, payload, zoomLimit) {
	  var previousZoom = view.getZoom();
	  var center = view.getCenter();
	  var zoom = payload.zoom;
	  var point = view.dataToPoint(center);
	
	  if (payload.dx != null && payload.dy != null) {
	    point[0] -= payload.dx;
	    point[1] -= payload.dy;
	    var center = view.pointToData(point);
	    view.setCenter(center);
	  }
	
	  if (zoom != null) {
	    if (zoomLimit) {
	      var zoomMin = zoomLimit.min || 0;
	      var zoomMax = zoomLimit.max || Infinity;
	      zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
	    } // Zoom on given point(originX, originY)
	
	
	    view.scale[0] *= zoom;
	    view.scale[1] *= zoom;
	    var position = view.position;
	    var fixX = (payload.originX - position[0]) * (zoom - 1);
	    var fixY = (payload.originY - position[1]) * (zoom - 1);
	    position[0] -= fixX;
	    position[1] -= fixY;
	    view.updateTransform(); // Get the new center
	
	    var center = view.pointToData(point);
	    view.setCenter(center);
	    view.setZoom(zoom * previousZoom);
	  }
	
	  return {
	    center: view.getCenter(),
	    zoom: view.getZoom()
	  };
	}
	
	exports.updateCenterAndZoom = updateCenterAndZoom;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var Geo = __webpack_require__(445);
	
	var layout = __webpack_require__(305);
	
	var numberUtil = __webpack_require__(306);
	
	var geoSourceManager = __webpack_require__(429);
	
	var mapDataStorage = __webpack_require__(336);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Resize method bound to the geo
	 * @param {module:echarts/coord/geo/GeoModel|module:echarts/chart/map/MapModel} geoModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function resizeGeo(geoModel, api) {
	  var boundingCoords = geoModel.get('boundingCoords');
	
	  if (boundingCoords != null) {
	    var leftTop = boundingCoords[0];
	    var rightBottom = boundingCoords[1];
	
	    if (isNaN(leftTop[0]) || isNaN(leftTop[1]) || isNaN(rightBottom[0]) || isNaN(rightBottom[1])) {} else {
	      this.setBoundingRect(leftTop[0], leftTop[1], rightBottom[0] - leftTop[0], rightBottom[1] - leftTop[1]);
	    }
	  }
	
	  var rect = this.getBoundingRect();
	  var boxLayoutOption;
	  var center = geoModel.get('layoutCenter');
	  var size = geoModel.get('layoutSize');
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  var aspect = rect.width / rect.height * this.aspectScale;
	  var useCenterAndSize = false;
	
	  if (center && size) {
	    center = [numberUtil.parsePercent(center[0], viewWidth), numberUtil.parsePercent(center[1], viewHeight)];
	    size = numberUtil.parsePercent(size, Math.min(viewWidth, viewHeight));
	
	    if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) {
	      useCenterAndSize = true;
	    } else {}
	  }
	
	  var viewRect;
	
	  if (useCenterAndSize) {
	    var viewRect = {};
	
	    if (aspect > 1) {
	      // Width is same with size
	      viewRect.width = size;
	      viewRect.height = size / aspect;
	    } else {
	      viewRect.height = size;
	      viewRect.width = size * aspect;
	    }
	
	    viewRect.y = center[1] - viewRect.height / 2;
	    viewRect.x = center[0] - viewRect.width / 2;
	  } else {
	    // Use left/top/width/height
	    boxLayoutOption = geoModel.getBoxLayoutParams(); // 0.75 rate
	
	    boxLayoutOption.aspect = aspect;
	    viewRect = layout.getLayoutRect(boxLayoutOption, {
	      width: viewWidth,
	      height: viewHeight
	    });
	  }
	
	  this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
	  this.setCenter(geoModel.get('center'));
	  this.setZoom(geoModel.get('zoom'));
	}
	/**
	 * @param {module:echarts/coord/Geo} geo
	 * @param {module:echarts/model/Model} model
	 * @inner
	 */
	
	
	function setGeoCoords(geo, model) {
	  zrUtil.each(model.get('geoCoord'), function (geoCoord, name) {
	    geo.addGeoCoord(name, geoCoord);
	  });
	}
	
	var geoCreator = {
	  // For deciding which dimensions to use when creating list data
	  dimensions: Geo.prototype.dimensions,
	  create: function (ecModel, api) {
	    var geoList = []; // FIXME Create each time may be slow
	
	    ecModel.eachComponent('geo', function (geoModel, idx) {
	      var name = geoModel.get('map');
	      var aspectScale = geoModel.get('aspectScale');
	      var invertLongitute = true;
	      var mapRecords = mapDataStorage.retrieveMap(name);
	
	      if (mapRecords && mapRecords[0] && mapRecords[0].type === 'svg') {
	        aspectScale == null && (aspectScale = 1);
	        invertLongitute = false;
	      } else {
	        aspectScale == null && (aspectScale = 0.75);
	      }
	
	      var geo = new Geo(name + idx, name, geoModel.get('nameMap'), invertLongitute);
	      geo.aspectScale = aspectScale;
	      geo.zoomLimit = geoModel.get('scaleLimit');
	      geoList.push(geo);
	      setGeoCoords(geo, geoModel);
	      geoModel.coordinateSystem = geo;
	      geo.model = geoModel; // Inject resize method
	
	      geo.resize = resizeGeo;
	      geo.resize(geoModel, api);
	    });
	    ecModel.eachSeries(function (seriesModel) {
	      var coordSys = seriesModel.get('coordinateSystem');
	
	      if (coordSys === 'geo') {
	        var geoIndex = seriesModel.get('geoIndex') || 0;
	        seriesModel.coordinateSystem = geoList[geoIndex];
	      }
	    }); // If has map series
	
	    var mapModelGroupBySeries = {};
	    ecModel.eachSeriesByType('map', function (seriesModel) {
	      if (!seriesModel.getHostGeoModel()) {
	        var mapType = seriesModel.getMapType();
	        mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
	        mapModelGroupBySeries[mapType].push(seriesModel);
	      }
	    });
	    zrUtil.each(mapModelGroupBySeries, function (mapSeries, mapType) {
	      var nameMapList = zrUtil.map(mapSeries, function (singleMapSeries) {
	        return singleMapSeries.get('nameMap');
	      });
	      var geo = new Geo(mapType, mapType, zrUtil.mergeAll(nameMapList));
	      geo.zoomLimit = zrUtil.retrieve.apply(null, zrUtil.map(mapSeries, function (singleMapSeries) {
	        return singleMapSeries.get('scaleLimit');
	      }));
	      geoList.push(geo); // Inject resize method
	
	      geo.resize = resizeGeo;
	      geo.aspectScale = mapSeries[0].get('aspectScale');
	      geo.resize(mapSeries[0], api);
	      zrUtil.each(mapSeries, function (singleMapSeries) {
	        singleMapSeries.coordinateSystem = geo;
	        setGeoCoords(geo, singleMapSeries);
	      });
	    });
	    return geoList;
	  },
	
	  /**
	   * Fill given regions array
	   * @param  {Array.<Object>} originRegionArr
	   * @param  {string} mapName
	   * @param  {Object} [nameMap]
	   * @return {Array}
	   */
	  getFilledRegions: function (originRegionArr, mapName, nameMap) {
	    // Not use the original
	    var regionsArr = (originRegionArr || []).slice();
	    var dataNameMap = zrUtil.createHashMap();
	
	    for (var i = 0; i < regionsArr.length; i++) {
	      dataNameMap.set(regionsArr[i].name, regionsArr[i]);
	    }
	
	    var source = geoSourceManager.load(mapName, nameMap);
	    zrUtil.each(source.regions, function (region) {
	      var name = region.name;
	      !dataNameMap.get(name) && regionsArr.push({
	        name: name
	      });
	    });
	    return regionsArr;
	  }
	};
	echarts.registerCoordinateSystem('geo', geoCreator);
	var _default = geoCreator;
	module.exports = _default;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var BoundingRect = __webpack_require__(242);
	
	var View = __webpack_require__(446);
	
	var geoSourceManager = __webpack_require__(429);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [Geo description]
	 * For backward compatibility, the orginal interface:
	 * `name, map, geoJson, specialAreas, nameMap` is kept.
	 *
	 * @param {string|Object} name
	 * @param {string} map Map type
	 *        Specify the positioned areas by left, top, width, height
	 * @param {Object.<string, string>} [nameMap]
	 *        Specify name alias
	 * @param {boolean} [invertLongitute=true]
	 */
	function Geo(name, map, nameMap, invertLongitute) {
	  View.call(this, name);
	  /**
	   * Map type
	   * @type {string}
	   */
	
	  this.map = map;
	  var source = geoSourceManager.load(map, nameMap);
	  this._nameCoordMap = source.nameCoordMap;
	  this._regionsMap = source.regionsMap;
	  this._invertLongitute = invertLongitute == null ? true : invertLongitute;
	  /**
	   * @readOnly
	   */
	
	  this.regions = source.regions;
	  /**
	   * @type {module:zrender/src/core/BoundingRect}
	   */
	
	  this._rect = source.boundingRect;
	}
	
	Geo.prototype = {
	  constructor: Geo,
	  type: 'geo',
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['lng', 'lat'],
	
	  /**
	   * If contain given lng,lat coord
	   * @param {Array.<number>}
	   * @readOnly
	   */
	  containCoord: function (coord) {
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      if (regions[i].contain(coord)) {
	        return true;
	      }
	    }
	
	    return false;
	  },
	
	  /**
	   * @override
	   */
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var invertLongitute = this._invertLongitute;
	    rect = rect.clone();
	
	    if (invertLongitute) {
	      // Longitute is inverted
	      rect.y = -rect.y - rect.height;
	    }
	
	    var rawTransformable = this._rawTransformable;
	    rawTransformable.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	    rawTransformable.decomposeTransform();
	
	    if (invertLongitute) {
	      var scale = rawTransformable.scale;
	      scale[1] = -scale[1];
	    }
	
	    rawTransformable.updateTransform();
	
	    this._updateTransform();
	  },
	
	  /**
	   * @param {string} name
	   * @return {module:echarts/coord/geo/Region}
	   */
	  getRegion: function (name) {
	    return this._regionsMap.get(name);
	  },
	  getRegionByCoord: function (coord) {
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      if (regions[i].contain(coord)) {
	        return regions[i];
	      }
	    }
	  },
	
	  /**
	   * Add geoCoord for indexing by name
	   * @param {string} name
	   * @param {Array.<number>} geoCoord
	   */
	  addGeoCoord: function (name, geoCoord) {
	    this._nameCoordMap.set(name, geoCoord);
	  },
	
	  /**
	   * Get geoCoord by name
	   * @param {string} name
	   * @return {Array.<number>}
	   */
	  getGeoCoord: function (name) {
	    return this._nameCoordMap.get(name);
	  },
	
	  /**
	   * @override
	   */
	  getBoundingRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @param {string|Array.<number>} data
	   * @param {boolean} noRoam
	   * @param {Array.<number>} [out]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, noRoam, out) {
	    if (typeof data === 'string') {
	      // Map area name to geoCoord
	      data = this.getGeoCoord(data);
	    }
	
	    if (data) {
	      return View.prototype.dataToPoint.call(this, data, noRoam, out);
	    }
	  },
	
	  /**
	   * @override
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @override
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData')
	};
	zrUtil.mixin(Geo, View);
	
	function doConvert(methodName, ecModel, finder, value) {
	  var geoModel = finder.geoModel;
	  var seriesModel = finder.seriesModel;
	  var coordSys = geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map.
	  || (seriesModel.getReferringComponents('geo')[0] || {}).coordinateSystem : null;
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	var _default = Geo;
	module.exports = _default;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var vector = __webpack_require__(222);
	
	var matrix = __webpack_require__(233);
	
	var BoundingRect = __webpack_require__(242);
	
	var Transformable = __webpack_require__(232);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Simple view coordinate system
	 * Mapping given x, y to transformd view x, y
	 */
	var v2ApplyTransform = vector.applyTransform; // Dummy transform node
	
	function TransformDummy() {
	  Transformable.call(this);
	}
	
	zrUtil.mixin(TransformDummy, Transformable);
	
	function View(name) {
	  /**
	   * @type {string}
	   */
	  this.name = name;
	  /**
	   * @type {Object}
	   */
	
	  this.zoomLimit;
	  Transformable.call(this);
	  this._roamTransformable = new TransformDummy();
	  this._rawTransformable = new TransformDummy();
	  this._center;
	  this._zoom;
	}
	
	View.prototype = {
	  constructor: View,
	  type: 'view',
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['x', 'y'],
	
	  /**
	   * Set bounding rect
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  // PENDING to getRect
	  setBoundingRect: function (x, y, width, height) {
	    this._rect = new BoundingRect(x, y, width, height);
	    return this._rect;
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  // PENDING to getRect
	  getBoundingRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  setViewRect: function (x, y, width, height) {
	    this.transformTo(x, y, width, height);
	    this._viewRect = new BoundingRect(x, y, width, height);
	  },
	
	  /**
	   * Transformed to particular position and size
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var rawTransform = this._rawTransformable;
	    rawTransform.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	    rawTransform.decomposeTransform();
	
	    this._updateTransform();
	  },
	
	  /**
	   * Set center of view
	   * @param {Array.<number>} [centerCoord]
	   */
	  setCenter: function (centerCoord) {
	    if (!centerCoord) {
	      return;
	    }
	
	    this._center = centerCoord;
	
	    this._updateCenterAndZoom();
	  },
	
	  /**
	   * @param {number} zoom
	   */
	  setZoom: function (zoom) {
	    zoom = zoom || 1;
	    var zoomLimit = this.zoomLimit;
	
	    if (zoomLimit) {
	      if (zoomLimit.max != null) {
	        zoom = Math.min(zoomLimit.max, zoom);
	      }
	
	      if (zoomLimit.min != null) {
	        zoom = Math.max(zoomLimit.min, zoom);
	      }
	    }
	
	    this._zoom = zoom;
	
	    this._updateCenterAndZoom();
	  },
	
	  /**
	   * Get default center without roam
	   */
	  getDefaultCenter: function () {
	    // Rect before any transform
	    var rawRect = this.getBoundingRect();
	    var cx = rawRect.x + rawRect.width / 2;
	    var cy = rawRect.y + rawRect.height / 2;
	    return [cx, cy];
	  },
	  getCenter: function () {
	    return this._center || this.getDefaultCenter();
	  },
	  getZoom: function () {
	    return this._zoom || 1;
	  },
	
	  /**
	   * @return {Array.<number}
	   */
	  getRoamTransform: function () {
	    return this._roamTransformable.getLocalTransform();
	  },
	
	  /**
	   * Remove roam
	   */
	  _updateCenterAndZoom: function () {
	    // Must update after view transform updated
	    var rawTransformMatrix = this._rawTransformable.getLocalTransform();
	
	    var roamTransform = this._roamTransformable;
	    var defaultCenter = this.getDefaultCenter();
	    var center = this.getCenter();
	    var zoom = this.getZoom();
	    center = vector.applyTransform([], center, rawTransformMatrix);
	    defaultCenter = vector.applyTransform([], defaultCenter, rawTransformMatrix);
	    roamTransform.origin = center;
	    roamTransform.position = [defaultCenter[0] - center[0], defaultCenter[1] - center[1]];
	    roamTransform.scale = [zoom, zoom];
	
	    this._updateTransform();
	  },
	
	  /**
	   * Update transform from roam and mapLocation
	   * @private
	   */
	  _updateTransform: function () {
	    var roamTransformable = this._roamTransformable;
	    var rawTransformable = this._rawTransformable;
	    rawTransformable.parent = roamTransformable;
	    roamTransformable.updateTransform();
	    rawTransformable.updateTransform();
	    matrix.copy(this.transform || (this.transform = []), rawTransformable.transform || matrix.create());
	    this._rawTransform = rawTransformable.getLocalTransform();
	    this.invTransform = this.invTransform || [];
	    matrix.invert(this.invTransform, this.transform);
	    this.decomposeTransform();
	  },
	  getTransformInfo: function () {
	    var roamTransform = this._roamTransformable.transform;
	    var rawTransformable = this._rawTransformable;
	    return {
	      roamTransform: roamTransform ? zrUtil.slice(roamTransform) : matrix.create(),
	      rawScale: zrUtil.slice(rawTransformable.scale),
	      rawPosition: zrUtil.slice(rawTransformable.position)
	    };
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getViewRect: function () {
	    return this._viewRect;
	  },
	
	  /**
	   * Get view rect after roam transform
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getViewRectAfterRoam: function () {
	    var rect = this.getBoundingRect().clone();
	    rect.applyTransform(this.transform);
	    return rect;
	  },
	
	  /**
	   * Convert a single (lon, lat) data item to (x, y) point.
	   * @param {Array.<number>} data
	   * @param {boolean} noRoam
	   * @param {Array.<number>} [out]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, noRoam, out) {
	    var transform = noRoam ? this._rawTransform : this.transform;
	    out = out || [];
	    return transform ? v2ApplyTransform(out, data, transform) : vector.copy(out, data);
	  },
	
	  /**
	   * Convert a (x, y) point to (lon, lat) data
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToData: function (point) {
	    var invTransform = this.invTransform;
	    return invTransform ? v2ApplyTransform([], point, invTransform) : [point[0], point[1]];
	  },
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  containPoint: function (point) {
	    return this.getViewRectAfterRoam().contain(point[0], point[1]);
	  }
	  /**
	   * @return {number}
	   */
	  // getScalarScale: function () {
	  //     // Use determinant square root of transform to mutiply scalar
	  //     var m = this.transform;
	  //     var det = Math.sqrt(Math.abs(m[0] * m[3] - m[2] * m[1]));
	  //     return det;
	  // }
	
	};
	zrUtil.mixin(View, Transformable);
	
	function doConvert(methodName, ecModel, finder, value) {
	  var seriesModel = finder.seriesModel;
	  var coordSys = seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
	
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	var _default = View;
	module.exports = _default;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var processedMapType = {};
	  ecModel.eachSeriesByType('map', function (mapSeries) {
	    var mapType = mapSeries.getMapType();
	
	    if (mapSeries.getHostGeoModel() || processedMapType[mapType]) {
	      return;
	    }
	
	    var mapSymbolOffsets = {};
	    zrUtil.each(mapSeries.seriesGroup, function (subMapSeries) {
	      var geo = subMapSeries.coordinateSystem;
	      var data = subMapSeries.originalData;
	
	      if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) {
	        data.each(data.mapDimension('value'), function (value, idx) {
	          var name = data.getName(idx);
	          var region = geo.getRegion(name); // If input series.data is [11, 22, '-'/null/undefined, 44],
	          // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
	          // not be drawn. So here must validate if value is NaN.
	
	          if (!region || isNaN(value)) {
	            return;
	          }
	
	          var offset = mapSymbolOffsets[name] || 0;
	          var point = geo.dataToPoint(region.center);
	          mapSymbolOffsets[name] = offset + 1;
	          data.setItemLayout(idx, {
	            point: point,
	            offset: offset
	          });
	        });
	      }
	    }); // Show label of those region not has legendSymbol(which is offset 0)
	
	    var data = mapSeries.getData();
	    data.each(function (idx) {
	      var name = data.getName(idx);
	      var layout = data.getItemLayout(idx) || {};
	      layout.showLabel = !mapSymbolOffsets[name];
	      data.setItemLayout(idx, layout);
	    });
	    processedMapType[mapType] = true;
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('map', function (seriesModel) {
	    var colorList = seriesModel.get('color');
	    var itemStyleModel = seriesModel.getModel('itemStyle');
	    var areaColor = itemStyleModel.get('areaColor');
	    var color = itemStyleModel.get('color') || colorList[seriesModel.seriesIndex % colorList.length];
	    seriesModel.getData().setVisual({
	      'areaColor': areaColor,
	      'color': color
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME 公用？
	
	/**
	 * @param {Array.<module:echarts/data/List>} datas
	 * @param {string} statisticType 'average' 'sum'
	 * @inner
	 */
	function dataStatistics(datas, statisticType) {
	  var dataNameMap = {};
	  zrUtil.each(datas, function (data) {
	    data.each(data.mapDimension('value'), function (value, idx) {
	      // Add prefix to avoid conflict with Object.prototype.
	      var mapKey = 'ec-' + data.getName(idx);
	      dataNameMap[mapKey] = dataNameMap[mapKey] || [];
	
	      if (!isNaN(value)) {
	        dataNameMap[mapKey].push(value);
	      }
	    });
	  });
	  return datas[0].map(datas[0].mapDimension('value'), function (value, idx) {
	    var mapKey = 'ec-' + datas[0].getName(idx);
	    var sum = 0;
	    var min = Infinity;
	    var max = -Infinity;
	    var len = dataNameMap[mapKey].length;
	
	    for (var i = 0; i < len; i++) {
	      min = Math.min(min, dataNameMap[mapKey][i]);
	      max = Math.max(max, dataNameMap[mapKey][i]);
	      sum += dataNameMap[mapKey][i];
	    }
	
	    var result;
	
	    if (statisticType === 'min') {
	      result = min;
	    } else if (statisticType === 'max') {
	      result = max;
	    } else if (statisticType === 'average') {
	      result = sum / len;
	    } else {
	      result = sum;
	    }
	
	    return len === 0 ? NaN : result;
	  });
	}
	
	function _default(ecModel) {
	  var seriesGroups = {};
	  ecModel.eachSeriesByType('map', function (seriesModel) {
	    var hostGeoModel = seriesModel.getHostGeoModel();
	    var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
	    (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
	  });
	  zrUtil.each(seriesGroups, function (seriesList, key) {
	    var data = dataStatistics(zrUtil.map(seriesList, function (seriesModel) {
	      return seriesModel.getData();
	    }), seriesList[0].get('mapValueCalculation'));
	
	    for (var i = 0; i < seriesList.length; i++) {
	      seriesList[i].originalData = seriesList[i].getData();
	    } // FIXME Put where?
	
	
	    for (var i = 0; i < seriesList.length; i++) {
	      seriesList[i].seriesGroup = seriesList;
	      seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
	      seriesList[i].setData(data.cloneShallow());
	      seriesList[i].mainSeries = seriesList[0];
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  // Save geoCoord
	  var mapSeries = [];
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'map') {
	      mapSeries.push(seriesOpt);
	      seriesOpt.map = seriesOpt.map || seriesOpt.mapType; // Put x, y, width, height, x2, y2 in the top level
	
	      zrUtil.defaults(seriesOpt, seriesOpt.mapLocation);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(452);
	
	__webpack_require__(455);
	
	__webpack_require__(457);
	
	var visualSymbol = __webpack_require__(376);
	
	var treeLayout = __webpack_require__(458);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(visualSymbol('tree', 'circle'));
	echarts.registerLayout(treeLayout);

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(320);
	
	var Tree = __webpack_require__(453);
	
	var _format = __webpack_require__(307);
	
	var encodeHTML = _format.encodeHTML;
	
	var Model = __webpack_require__(262);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.tree',
	  layoutInfo: null,
	  // can support the position parameters 'left', 'top','right','bottom', 'width',
	  // 'height' in the setOption() with 'merge' mode normal.
	  layoutMode: 'box',
	
	  /**
	   * Init a tree data structure from data in option series
	   * @param  {Object} option  the object used to config echarts view
	   * @return {module:echarts/data/List} storage initial data
	   */
	  getInitialData: function (option) {
	    //create an virtual root
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    var leaves = option.leaves || {};
	    var leavesModel = new Model(leaves, this, this.ecModel);
	    var tree = Tree.createTree(root, this, beforeLink);
	
	    function beforeLink(nodeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        var node = tree.getNodeByDataIndex(idx);
	
	        if (!node.children.length || !node.isExpand) {
	          model.parentModel = leavesModel;
	        }
	
	        return model;
	      });
	    }
	
	    var treeDepth = 0;
	    tree.eachNode('preorder', function (node) {
	      if (node.depth > treeDepth) {
	        treeDepth = node.depth;
	      }
	    });
	    var expandAndCollapse = option.expandAndCollapse;
	    var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
	    tree.root.eachNode('preorder', function (node) {
	      var item = node.hostTree.data.getRawDataItem(node.dataIndex); // Add item.collapsed != null, because users can collapse node original in the series.data.
	
	      node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
	    });
	    return tree.data;
	  },
	
	  /**
	   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
	   * @returns {string} orient
	   */
	  getOrient: function () {
	    var orient = this.get('orient');
	
	    if (orient === 'horizontal') {
	      orient = 'LR';
	    } else if (orient === 'vertical') {
	      orient = 'TB';
	    }
	
	    return orient;
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex
	   */
	  formatTooltip: function (dataIndex) {
	    var tree = this.getData().tree;
	    var realRoot = tree.root.children[0];
	    var node = tree.getNodeByDataIndex(dataIndex);
	    var value = node.getValue();
	    var name = node.name;
	
	    while (node && node !== realRoot) {
	      name = node.parentNode.name + '.' + name;
	      node = node.parentNode;
	    }
	
	    return encodeHTML(name + (isNaN(value) || value == null ? '' : ' : ' + value));
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    // the position of the whole view
	    left: '12%',
	    top: '12%',
	    right: '12%',
	    bottom: '12%',
	    // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
	    layout: 'orthogonal',
	    // value can be 'polyline'
	    edgeShape: 'curve',
	    edgeForkPosition: '50%',
	    // true | false | 'move' | 'scale', see module:component/helper/RoamController.
	    roam: false,
	    // Symbol size scale ratio in roam
	    nodeScaleRatio: 0.4,
	    // Default on center of graph
	    center: null,
	    zoom: 1,
	    // The orient of orthoginal layout, can be setted to 'LR', 'TB', 'RL', 'BT'.
	    // and the backward compatibility configuration 'horizontal = LR', 'vertical = TB'.
	    orient: 'LR',
	    symbol: 'emptyCircle',
	    symbolSize: 7,
	    expandAndCollapse: true,
	    initialTreeDepth: 2,
	    lineStyle: {
	      color: '#ccc',
	      width: 1.5,
	      curveness: 0.5
	    },
	    itemStyle: {
	      color: 'lightsteelblue',
	      borderColor: '#c23531',
	      borderWidth: 1.5
	    },
	    label: {
	      show: true,
	      color: '#555'
	    },
	    leaves: {
	      label: {
	        show: true
	      }
	    },
	    animationEasing: 'linear',
	    animationDuration: 700,
	    animationDurationUpdate: 1000
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var linkList = __webpack_require__(454);
	
	var List = __webpack_require__(342);
	
	var createDimensions = __webpack_require__(346);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Tree data structure
	 *
	 * @module echarts/data/Tree
	 */
	
	/**
	 * @constructor module:echarts/data/Tree~TreeNode
	 * @param {string} name
	 * @param {module:echarts/data/Tree} hostTree
	 */
	var TreeNode = function (name, hostTree) {
	  /**
	   * @type {string}
	   */
	  this.name = name || '';
	  /**
	   * Depth of node
	   *
	   * @type {number}
	   * @readOnly
	   */
	
	  this.depth = 0;
	  /**
	   * Height of the subtree rooted at this node.
	   * @type {number}
	   * @readOnly
	   */
	
	  this.height = 0;
	  /**
	   * @type {module:echarts/data/Tree~TreeNode}
	   * @readOnly
	   */
	
	  this.parentNode = null;
	  /**
	   * Reference to list item.
	   * Do not persistent dataIndex outside,
	   * besause it may be changed by list.
	   * If dataIndex -1,
	   * this node is logical deleted (filtered) in list.
	   *
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.dataIndex = -1;
	  /**
	   * @type {Array.<module:echarts/data/Tree~TreeNode>}
	   * @readOnly
	   */
	
	  this.children = [];
	  /**
	   * @type {Array.<module:echarts/data/Tree~TreeNode>}
	   * @pubilc
	   */
	
	  this.viewChildren = [];
	  /**
	   * @type {moduel:echarts/data/Tree}
	   * @readOnly
	   */
	
	  this.hostTree = hostTree;
	};
	
	TreeNode.prototype = {
	  constructor: TreeNode,
	
	  /**
	   * The node is removed.
	   * @return {boolean} is removed.
	   */
	  isRemoved: function () {
	    return this.dataIndex < 0;
	  },
	
	  /**
	   * Travel this subtree (include this node).
	   * Usage:
	   *    node.eachNode(function () { ... }); // preorder
	   *    node.eachNode('preorder', function () { ... }); // preorder
	   *    node.eachNode('postorder', function () { ... }); // postorder
	   *    node.eachNode(
	   *        {order: 'postorder', attr: 'viewChildren'},
	   *        function () { ... }
	   *    ); // postorder
	   *
	   * @param {(Object|string)} options If string, means order.
	   * @param {string=} options.order 'preorder' or 'postorder'
	   * @param {string=} options.attr 'children' or 'viewChildren'
	   * @param {Function} cb If in preorder and return false,
	   *                      its subtree will not be visited.
	   * @param {Object} [context]
	   */
	  eachNode: function (options, cb, context) {
	    if (typeof options === 'function') {
	      context = cb;
	      cb = options;
	      options = null;
	    }
	
	    options = options || {};
	
	    if (zrUtil.isString(options)) {
	      options = {
	        order: options
	      };
	    }
	
	    var order = options.order || 'preorder';
	    var children = this[options.attr || 'children'];
	    var suppressVisitSub;
	    order === 'preorder' && (suppressVisitSub = cb.call(context, this));
	
	    for (var i = 0; !suppressVisitSub && i < children.length; i++) {
	      children[i].eachNode(options, cb, context);
	    }
	
	    order === 'postorder' && cb.call(context, this);
	  },
	
	  /**
	   * Update depth and height of this subtree.
	   *
	   * @param  {number} depth
	   */
	  updateDepthAndHeight: function (depth) {
	    var height = 0;
	    this.depth = depth;
	
	    for (var i = 0; i < this.children.length; i++) {
	      var child = this.children[i];
	      child.updateDepthAndHeight(depth + 1);
	
	      if (child.height > height) {
	        height = child.height;
	      }
	    }
	
	    this.height = height + 1;
	  },
	
	  /**
	   * @param  {string} id
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeById: function (id) {
	    if (this.getId() === id) {
	      return this;
	    }
	
	    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	      var res = children[i].getNodeById(id);
	
	      if (res) {
	        return res;
	      }
	    }
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~TreeNode} node
	   * @return {boolean}
	   */
	  contains: function (node) {
	    if (node === this) {
	      return true;
	    }
	
	    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	      var res = children[i].contains(node);
	
	      if (res) {
	        return res;
	      }
	    }
	  },
	
	  /**
	   * @param {boolean} includeSelf Default false.
	   * @return {Array.<module:echarts/data/Tree~TreeNode>} order: [root, child, grandchild, ...]
	   */
	  getAncestors: function (includeSelf) {
	    var ancestors = [];
	    var node = includeSelf ? this : this.parentNode;
	
	    while (node) {
	      ancestors.push(node);
	      node = node.parentNode;
	    }
	
	    ancestors.reverse();
	    return ancestors;
	  },
	
	  /**
	   * @param {string|Array=} [dimension='value'] Default 'value'. can be 0, 1, 2, 3
	   * @return {number} Value.
	   */
	  getValue: function (dimension) {
	    var data = this.hostTree.data;
	    return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
	  },
	
	  /**
	   * @param {Object} layout
	   * @param {boolean=} [merge=false]
	   */
	  setLayout: function (layout, merge) {
	    this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
	  },
	
	  /**
	   * @return {Object} layout
	   */
	  getLayout: function () {
	    return this.hostTree.data.getItemLayout(this.dataIndex);
	  },
	
	  /**
	   * @param {string} [path]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path) {
	    if (this.dataIndex < 0) {
	      return;
	    }
	
	    var hostTree = this.hostTree;
	    var itemModel = hostTree.data.getItemModel(this.dataIndex);
	    return itemModel.getModel(path);
	  },
	
	  /**
	   * @example
	   *  setItemVisual('color', color);
	   *  setItemVisual({
	   *      'color': color
	   *  });
	   */
	  setVisual: function (key, value) {
	    this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
	  },
	
	  /**
	   * Get item visual
	   */
	  getVisual: function (key, ignoreParent) {
	    return this.hostTree.data.getItemVisual(this.dataIndex, key, ignoreParent);
	  },
	
	  /**
	   * @public
	   * @return {number}
	   */
	  getRawIndex: function () {
	    return this.hostTree.data.getRawIndex(this.dataIndex);
	  },
	
	  /**
	   * @public
	   * @return {string}
	   */
	  getId: function () {
	    return this.hostTree.data.getId(this.dataIndex);
	  },
	
	  /**
	   * if this is an ancestor of another node
	   *
	   * @public
	   * @param {TreeNode} node another node
	   * @return {boolean} if is ancestor
	   */
	  isAncestorOf: function (node) {
	    var parent = node.parentNode;
	
	    while (parent) {
	      if (parent === this) {
	        return true;
	      }
	
	      parent = parent.parentNode;
	    }
	
	    return false;
	  },
	
	  /**
	   * if this is an descendant of another node
	   *
	   * @public
	   * @param {TreeNode} node another node
	   * @return {boolean} if is descendant
	   */
	  isDescendantOf: function (node) {
	    return node !== this && node.isAncestorOf(this);
	  }
	};
	/**
	 * @constructor
	 * @alias module:echarts/data/Tree
	 * @param {module:echarts/model/Model} hostModel
	 */
	
	function Tree(hostModel) {
	  /**
	   * @type {module:echarts/data/Tree~TreeNode}
	   * @readOnly
	   */
	  this.root;
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.data;
	  /**
	   * Index of each item is the same as the raw index of coresponding list item.
	   * @private
	   * @type {Array.<module:echarts/data/Tree~TreeNode}
	   */
	
	  this._nodes = [];
	  /**
	   * @private
	   * @readOnly
	   * @type {module:echarts/model/Model}
	   */
	
	  this.hostModel = hostModel;
	}
	
	Tree.prototype = {
	  constructor: Tree,
	  type: 'tree',
	
	  /**
	   * Travel this subtree (include this node).
	   * Usage:
	   *    node.eachNode(function () { ... }); // preorder
	   *    node.eachNode('preorder', function () { ... }); // preorder
	   *    node.eachNode('postorder', function () { ... }); // postorder
	   *    node.eachNode(
	   *        {order: 'postorder', attr: 'viewChildren'},
	   *        function () { ... }
	   *    ); // postorder
	   *
	   * @param {(Object|string)} options If string, means order.
	   * @param {string=} options.order 'preorder' or 'postorder'
	   * @param {string=} options.attr 'children' or 'viewChildren'
	   * @param {Function} cb
	   * @param {Object}   [context]
	   */
	  eachNode: function (options, cb, context) {
	    this.root.eachNode(options, cb, context);
	  },
	
	  /**
	   * @param {number} dataIndex
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeByDataIndex: function (dataIndex) {
	    var rawIndex = this.data.getRawIndex(dataIndex);
	    return this._nodes[rawIndex];
	  },
	
	  /**
	   * @param {string} name
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeByName: function (name) {
	    return this.root.getNodeByName(name);
	  },
	
	  /**
	   * Update item available by list,
	   * when list has been performed options like 'filterSelf' or 'map'.
	   */
	  update: function () {
	    var data = this.data;
	    var nodes = this._nodes;
	
	    for (var i = 0, len = nodes.length; i < len; i++) {
	      nodes[i].dataIndex = -1;
	    }
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      nodes[data.getRawIndex(i)].dataIndex = i;
	    }
	  },
	
	  /**
	   * Clear all layouts
	   */
	  clearLayouts: function () {
	    this.data.clearItemLayouts();
	  }
	};
	/**
	 * data node format:
	 * {
	 *     name: ...
	 *     value: ...
	 *     children: [
	 *         {
	 *             name: ...
	 *             value: ...
	 *             children: ...
	 *         },
	 *         ...
	 *     ]
	 * }
	 *
	 * @static
	 * @param {Object} dataRoot Root node.
	 * @param {module:echarts/model/Model} hostModel
	 * @return module:echarts/data/Tree
	 */
	
	Tree.createTree = function (dataRoot, hostModel, beforeLink) {
	  var tree = new Tree(hostModel);
	  var listData = [];
	  var dimMax = 1;
	  buildHierarchy(dataRoot);
	
	  function buildHierarchy(dataNode, parentNode) {
	    var value = dataNode.value;
	    dimMax = Math.max(dimMax, zrUtil.isArray(value) ? value.length : 1);
	    listData.push(dataNode);
	    var node = new TreeNode(dataNode.name, tree);
	    parentNode ? addChild(node, parentNode) : tree.root = node;
	
	    tree._nodes.push(node);
	
	    var children = dataNode.children;
	
	    if (children) {
	      for (var i = 0; i < children.length; i++) {
	        buildHierarchy(children[i], node);
	      }
	    }
	  }
	
	  tree.root.updateDepthAndHeight(0);
	  var dimensionsInfo = createDimensions(listData, {
	    coordDimensions: ['value'],
	    dimensionsCount: dimMax
	  });
	  var list = new List(dimensionsInfo, hostModel);
	  list.initData(listData);
	  beforeLink && beforeLink(list);
	  linkList({
	    mainData: list,
	    struct: tree,
	    structAttr: 'tree'
	  });
	  tree.update();
	  return tree;
	};
	/**
	 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
	 * so this function is not ready and not necessary to be public.
	 *
	 * @param {(module:echarts/data/Tree~TreeNode|Object)} child
	 */
	
	
	function addChild(child, node) {
	  var children = node.children;
	
	  if (child.parentNode === node) {
	    return;
	  }
	
	  children.push(child);
	  child.parentNode = node;
	}
	
	var _default = Tree;
	module.exports = _default;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Link lists and struct (graph or tree)
	 */
	var each = zrUtil.each;
	var DATAS = '\0__link_datas';
	var MAIN_DATA = '\0__link_mainData'; // Caution:
	// In most case, either list or its shallow clones (see list.cloneShallow)
	// is active in echarts process. So considering heap memory consumption,
	// we do not clone tree or graph, but share them among list and its shallow clones.
	// But in some rare case, we have to keep old list (like do animation in chart). So
	// please take care that both the old list and the new list share the same tree/graph.
	
	/**
	 * @param {Object} opt
	 * @param {module:echarts/data/List} opt.mainData
	 * @param {Object} [opt.struct] For example, instance of Graph or Tree.
	 * @param {string} [opt.structAttr] designation: list[structAttr] = struct;
	 * @param {Object} [opt.datas] {dataType: data},
	 *                 like: {node: nodeList, edge: edgeList}.
	 *                 Should contain mainData.
	 * @param {Object} [opt.datasAttr] {dataType: attr},
	 *                 designation: struct[datasAttr[dataType]] = list;
	 */
	
	function linkList(opt) {
	  var mainData = opt.mainData;
	  var datas = opt.datas;
	
	  if (!datas) {
	    datas = {
	      main: mainData
	    };
	    opt.datasAttr = {
	      main: 'data'
	    };
	  }
	
	  opt.datas = opt.mainData = null;
	  linkAll(mainData, datas, opt); // Porxy data original methods.
	
	  each(datas, function (data) {
	    each(mainData.TRANSFERABLE_METHODS, function (methodName) {
	      data.wrapMethod(methodName, zrUtil.curry(transferInjection, opt));
	    });
	  }); // Beyond transfer, additional features should be added to `cloneShallow`.
	
	  mainData.wrapMethod('cloneShallow', zrUtil.curry(cloneShallowInjection, opt)); // Only mainData trigger change, because struct.update may trigger
	  // another changable methods, which may bring about dead lock.
	
	  each(mainData.CHANGABLE_METHODS, function (methodName) {
	    mainData.wrapMethod(methodName, zrUtil.curry(changeInjection, opt));
	  }); // Make sure datas contains mainData.
	
	  zrUtil.assert(datas[mainData.dataType] === mainData);
	}
	
	function transferInjection(opt, res) {
	  if (isMainData(this)) {
	    // Transfer datas to new main data.
	    var datas = zrUtil.extend({}, this[DATAS]);
	    datas[this.dataType] = res;
	    linkAll(res, datas, opt);
	  } else {
	    // Modify the reference in main data to point newData.
	    linkSingle(res, this.dataType, this[MAIN_DATA], opt);
	  }
	
	  return res;
	}
	
	function changeInjection(opt, res) {
	  opt.struct && opt.struct.update(this);
	  return res;
	}
	
	function cloneShallowInjection(opt, res) {
	  // cloneShallow, which brings about some fragilities, may be inappropriate
	  // to be exposed as an API. So for implementation simplicity we can make
	  // the restriction that cloneShallow of not-mainData should not be invoked
	  // outside, but only be invoked here.
	  each(res[DATAS], function (data, dataType) {
	    data !== res && linkSingle(data.cloneShallow(), dataType, res, opt);
	  });
	  return res;
	}
	/**
	 * Supplement method to List.
	 *
	 * @public
	 * @param {string} [dataType] If not specified, return mainData.
	 * @return {module:echarts/data/List}
	 */
	
	
	function getLinkedData(dataType) {
	  var mainData = this[MAIN_DATA];
	  return dataType == null || mainData == null ? mainData : mainData[DATAS][dataType];
	}
	
	function isMainData(data) {
	  return data[MAIN_DATA] === data;
	}
	
	function linkAll(mainData, datas, opt) {
	  mainData[DATAS] = {};
	  each(datas, function (data, dataType) {
	    linkSingle(data, dataType, mainData, opt);
	  });
	}
	
	function linkSingle(data, dataType, mainData, opt) {
	  mainData[DATAS][dataType] = data;
	  data[MAIN_DATA] = mainData;
	  data.dataType = dataType;
	
	  if (opt.struct) {
	    data[opt.structAttr] = opt.struct;
	    opt.struct[opt.datasAttr[dataType]] = data;
	  } // Supplement method.
	
	
	  data.getLinkedData = getLinkedData;
	}
	
	var _default = linkList;
	module.exports = _default;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var SymbolClz = __webpack_require__(370);
	
	var _layoutHelper = __webpack_require__(456);
	
	var radialCoordinate = _layoutHelper.radialCoordinate;
	
	var echarts = __webpack_require__(215);
	
	var bbox = __webpack_require__(273);
	
	var View = __webpack_require__(446);
	
	var roamHelper = __webpack_require__(440);
	
	var RoamController = __webpack_require__(438);
	
	var _cursorHelper = __webpack_require__(441);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TreeShape = graphic.extendShape({
	  shape: {
	    parentPoint: [],
	    childPoints: [],
	    orient: '',
	    forkPosition: ''
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var childPoints = shape.childPoints;
	    var childLen = childPoints.length;
	    var parentPoint = shape.parentPoint;
	    var firstChildPos = childPoints[0];
	    var lastChildPos = childPoints[childLen - 1];
	
	    if (childLen === 1) {
	      ctx.moveTo(parentPoint[0], parentPoint[1]);
	      ctx.lineTo(firstChildPos[0], firstChildPos[1]);
	      return;
	    }
	
	    var orient = shape.orient;
	    var forkDim = orient === 'TB' || orient === 'BT' ? 0 : 1;
	    var otherDim = 1 - forkDim;
	    var forkPosition = parsePercent(shape.forkPosition, 1);
	    var tmpPoint = [];
	    tmpPoint[forkDim] = parentPoint[forkDim];
	    tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
	    ctx.moveTo(parentPoint[0], parentPoint[1]);
	    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    ctx.moveTo(firstChildPos[0], firstChildPos[1]);
	    tmpPoint[forkDim] = firstChildPos[forkDim];
	    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    tmpPoint[forkDim] = lastChildPos[forkDim];
	    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    ctx.lineTo(lastChildPos[0], lastChildPos[1]);
	
	    for (var i = 1; i < childLen - 1; i++) {
	      var point = childPoints[i];
	      ctx.moveTo(point[0], point[1]);
	      tmpPoint[forkDim] = point[forkDim];
	      ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    }
	  }
	});
	
	var _default = echarts.extendChartView({
	  type: 'tree',
	
	  /**
	   * Init the chart
	   * @override
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {module:echarts/data/Tree}
	     */
	    this._oldTree;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this._mainGroup = new graphic.Group();
	    /**
	     * @private
	     * @type {module:echarts/componet/helper/RoamController}
	     */
	
	    this._controller = new RoamController(api.getZr());
	    this._controllerHost = {
	      target: this.group
	    };
	    this.group.add(this._mainGroup);
	  },
	  render: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var layoutInfo = seriesModel.layoutInfo;
	    var group = this._mainGroup;
	    var layout = seriesModel.get('layout');
	
	    if (layout === 'radial') {
	      group.attr('position', [layoutInfo.x + layoutInfo.width / 2, layoutInfo.y + layoutInfo.height / 2]);
	    } else {
	      group.attr('position', [layoutInfo.x, layoutInfo.y]);
	    }
	
	    this._updateViewCoordSys(seriesModel, layoutInfo, layout);
	
	    this._updateController(seriesModel, ecModel, api);
	
	    var oldData = this._data;
	    var seriesScope = {
	      expandAndCollapse: seriesModel.get('expandAndCollapse'),
	      layout: layout,
	      edgeShape: seriesModel.get('edgeShape'),
	      edgeForkPosition: seriesModel.get('edgeForkPosition'),
	      orient: seriesModel.getOrient(),
	      curvature: seriesModel.get('lineStyle.curveness'),
	      symbolRotate: seriesModel.get('symbolRotate'),
	      symbolOffset: seriesModel.get('symbolOffset'),
	      hoverAnimation: seriesModel.get('hoverAnimation'),
	      useNameLabel: true,
	      fadeIn: true
	    };
	    data.diff(oldData).add(function (newIdx) {
	      if (symbolNeedsDraw(data, newIdx)) {
	        // Create node and edge
	        updateNode(data, newIdx, null, group, seriesModel, seriesScope);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx);
	
	      if (!symbolNeedsDraw(data, newIdx)) {
	        symbolEl && removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
	        return;
	      } // Update node and edge
	
	
	      updateNode(data, newIdx, symbolEl, group, seriesModel, seriesScope);
	    }).remove(function (oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx); // When remove a collapsed node of subtree, since the collapsed
	      // node haven't been initialized with a symbol element,
	      // you can't found it's symbol element through index.
	      // so if we want to remove the symbol element we should insure
	      // that the symbol element is not null.
	
	      if (symbolEl) {
	        removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
	      }
	    }).execute();
	    this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');
	
	    this._updateNodeAndLinkScale(seriesModel);
	
	    if (seriesScope.expandAndCollapse === true) {
	      data.eachItemGraphicEl(function (el, dataIndex) {
	        el.off('click').on('click', function () {
	          api.dispatchAction({
	            type: 'treeExpandAndCollapse',
	            seriesId: seriesModel.id,
	            dataIndex: dataIndex
	          });
	        });
	      });
	    }
	
	    this._data = data;
	  },
	  _updateViewCoordSys: function (seriesModel) {
	    var data = seriesModel.getData();
	    var points = [];
	    data.each(function (idx) {
	      var layout = data.getItemLayout(idx);
	
	      if (layout && !isNaN(layout.x) && !isNaN(layout.y)) {
	        points.push([+layout.x, +layout.y]);
	      }
	    });
	    var min = [];
	    var max = [];
	    bbox.fromPoints(points, min, max); // If don't Store min max when collapse the root node after roam,
	    // the root node will disappear.
	
	    var oldMin = this._min;
	    var oldMax = this._max; // If width or height is 0
	
	    if (max[0] - min[0] === 0) {
	      min[0] = oldMin ? oldMin[0] : min[0] - 1;
	      max[0] = oldMax ? oldMax[0] : max[0] + 1;
	    }
	
	    if (max[1] - min[1] === 0) {
	      min[1] = oldMin ? oldMin[1] : min[1] - 1;
	      max[1] = oldMax ? oldMax[1] : max[1] + 1;
	    }
	
	    var viewCoordSys = seriesModel.coordinateSystem = new View();
	    viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	    viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	    viewCoordSys.setCenter(seriesModel.get('center'));
	    viewCoordSys.setZoom(seriesModel.get('zoom')); // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group
	
	    this.group.attr({
	      position: viewCoordSys.position,
	      scale: viewCoordSys.scale
	    });
	    this._viewCoordSys = viewCoordSys;
	    this._min = min;
	    this._max = max;
	  },
	  _updateController: function (seriesModel, ecModel, api) {
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    var group = this.group;
	    controller.setPointerChecker(function (e, x, y) {
	      var rect = group.getBoundingRect();
	      rect.applyTransform(group.transform);
	      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	    });
	    controller.enable(seriesModel.get('roam'));
	    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	    controller.off('pan').off('zoom').on('pan', function (e) {
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'treeRoam',
	        dx: e.dx,
	        dy: e.dy
	      });
	    }, this).on('zoom', function (e) {
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'treeRoam',
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      });
	
	      this._updateNodeAndLinkScale(seriesModel);
	    }, this);
	  },
	  _updateNodeAndLinkScale: function (seriesModel) {
	    var data = seriesModel.getData();
	
	    var nodeScale = this._getNodeGlobalScale(seriesModel);
	
	    var invScale = [nodeScale, nodeScale];
	    data.eachItemGraphicEl(function (el, idx) {
	      el.attr('scale', invScale);
	    });
	  },
	  _getNodeGlobalScale: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type !== 'view') {
	      return 1;
	    }
	
	    var nodeScaleRatio = this._nodeScaleRatio;
	    var groupScale = coordSys.scale;
	    var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
	
	    var roamZoom = coordSys.getZoom();
	    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	    return nodeScale / groupZoom;
	  },
	  dispose: function () {
	    this._controller && this._controller.dispose();
	    this._controllerHost = {};
	  },
	  remove: function () {
	    this._mainGroup.removeAll();
	
	    this._data = null;
	  }
	});
	
	function symbolNeedsDraw(data, dataIndex) {
	  var layout = data.getItemLayout(dataIndex);
	  return layout && !isNaN(layout.x) && !isNaN(layout.y) && data.getItemVisual(dataIndex, 'symbol') !== 'none';
	}
	
	function getTreeNodeStyle(node, itemModel, seriesScope) {
	  seriesScope.itemModel = itemModel;
	  seriesScope.itemStyle = itemModel.getModel('itemStyle').getItemStyle();
	  seriesScope.hoverItemStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  seriesScope.lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	  seriesScope.labelModel = itemModel.getModel('label');
	  seriesScope.hoverLabelModel = itemModel.getModel('emphasis.label');
	
	  if (node.isExpand === false && node.children.length !== 0) {
	    seriesScope.symbolInnerColor = seriesScope.itemStyle.fill;
	  } else {
	    seriesScope.symbolInnerColor = '#fff';
	  }
	
	  return seriesScope;
	}
	
	function updateNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
	  var isInit = !symbolEl;
	  var node = data.tree.getNodeByDataIndex(dataIndex);
	  var itemModel = node.getModel();
	  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
	  var virtualRoot = data.tree.root;
	  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
	  var sourceLayout = source.getLayout();
	  var sourceOldLayout = sourceSymbolEl ? {
	    x: sourceSymbolEl.position[0],
	    y: sourceSymbolEl.position[1],
	    rawX: sourceSymbolEl.__radialOldRawX,
	    rawY: sourceSymbolEl.__radialOldRawY
	  } : sourceLayout;
	  var targetLayout = node.getLayout();
	
	  if (isInit) {
	    symbolEl = new SymbolClz(data, dataIndex, seriesScope);
	    symbolEl.attr('position', [sourceOldLayout.x, sourceOldLayout.y]);
	  } else {
	    symbolEl.updateData(data, dataIndex, seriesScope);
	  }
	
	  symbolEl.__radialOldRawX = symbolEl.__radialRawX;
	  symbolEl.__radialOldRawY = symbolEl.__radialRawY;
	  symbolEl.__radialRawX = targetLayout.rawX;
	  symbolEl.__radialRawY = targetLayout.rawY;
	  group.add(symbolEl);
	  data.setItemGraphicEl(dataIndex, symbolEl);
	  graphic.updateProps(symbolEl, {
	    position: [targetLayout.x, targetLayout.y]
	  }, seriesModel);
	  var symbolPath = symbolEl.getSymbolPath();
	
	  if (seriesScope.layout === 'radial') {
	    var realRoot = virtualRoot.children[0];
	    var rootLayout = realRoot.getLayout();
	    var length = realRoot.children.length;
	    var rad;
	    var isLeft;
	
	    if (targetLayout.x === rootLayout.x && node.isExpand === true) {
	      var center = {};
	      center.x = (realRoot.children[0].getLayout().x + realRoot.children[length - 1].getLayout().x) / 2;
	      center.y = (realRoot.children[0].getLayout().y + realRoot.children[length - 1].getLayout().y) / 2;
	      rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
	
	      if (rad < 0) {
	        rad = Math.PI * 2 + rad;
	      }
	
	      isLeft = center.x < rootLayout.x;
	
	      if (isLeft) {
	        rad = rad - Math.PI;
	      }
	    } else {
	      rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
	
	      if (rad < 0) {
	        rad = Math.PI * 2 + rad;
	      }
	
	      if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
	        isLeft = targetLayout.x < rootLayout.x;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	      } else {
	        isLeft = targetLayout.x > rootLayout.x;
	
	        if (!isLeft) {
	          rad = rad - Math.PI;
	        }
	      }
	    }
	
	    var textPosition = isLeft ? 'left' : 'right';
	    var rotate = seriesScope.labelModel.get('rotate');
	    var labelRotateRadian = rotate * (Math.PI / 180);
	    symbolPath.setStyle({
	      textPosition: seriesScope.labelModel.get('position') || textPosition,
	      textRotation: rotate == null ? -rad : labelRotateRadian,
	      textOrigin: 'center',
	      verticalAlign: 'middle'
	    });
	  }
	
	  drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group, seriesScope);
	}
	
	function drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group, seriesScope) {
	  var edgeShape = seriesScope.edgeShape;
	  var edge = symbolEl.__edge;
	
	  if (edgeShape === 'curve') {
	    if (node.parentNode && node.parentNode !== virtualRoot) {
	      if (!edge) {
	        edge = symbolEl.__edge = new graphic.BezierCurve({
	          shape: getEdgeShape(seriesScope, sourceOldLayout, sourceOldLayout),
	          style: zrUtil.defaults({
	            opacity: 0,
	            strokeNoScale: true
	          }, seriesScope.lineStyle)
	        });
	      }
	
	      graphic.updateProps(edge, {
	        shape: getEdgeShape(seriesScope, sourceLayout, targetLayout),
	        style: zrUtil.defaults({
	          opacity: 1
	        }, seriesScope.lineStyle)
	      }, seriesModel);
	    }
	  } else if (edgeShape === 'polyline') {
	    if (seriesScope.layout === 'orthogonal') {
	      if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
	        var children = node.children;
	        var childPoints = [];
	
	        for (var i = 0; i < children.length; i++) {
	          var childLayout = children[i].getLayout();
	          childPoints.push([childLayout.x, childLayout.y]);
	        }
	
	        if (!edge) {
	          edge = symbolEl.__edge = new TreeShape({
	            shape: {
	              parentPoint: [targetLayout.x, targetLayout.y],
	              childPoints: [[targetLayout.x, targetLayout.y]],
	              orient: seriesScope.orient,
	              forkPosition: seriesScope.edgeForkPosition
	            },
	            style: zrUtil.defaults({
	              opacity: 0,
	              strokeNoScale: true
	            }, seriesScope.lineStyle)
	          });
	        }
	
	        graphic.updateProps(edge, {
	          shape: {
	            parentPoint: [targetLayout.x, targetLayout.y],
	            childPoints: childPoints
	          },
	          style: zrUtil.defaults({
	            opacity: 1
	          }, seriesScope.lineStyle)
	        }, seriesModel);
	      }
	    } else {}
	  }
	
	  group.add(edge);
	}
	
	function removeNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
	  var node = data.tree.getNodeByDataIndex(dataIndex);
	  var virtualRoot = data.tree.root;
	  var itemModel = node.getModel();
	  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
	  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	  var edgeShape = seriesScope.edgeShape;
	  var sourceLayout;
	
	  while (sourceLayout = source.getLayout(), sourceLayout == null) {
	    source = source.parentNode === virtualRoot ? source : source.parentNode || source;
	  }
	
	  graphic.updateProps(symbolEl, {
	    position: [sourceLayout.x + 1, sourceLayout.y + 1]
	  }, seriesModel, function () {
	    group.remove(symbolEl);
	    data.setItemGraphicEl(dataIndex, null);
	  });
	  symbolEl.fadeOut(null, {
	    keepLabel: true
	  });
	  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
	  var sourceEdge = sourceSymbolEl.__edge; // 1. when expand the sub tree, delete the children node should delete the edge of
	  // the source at the same time. because the polyline edge shape is only owned by the source.
	  // 2.when the node is the only children of the source, delete the node should delete the edge of
	  // the source at the same time. the same reason as above.
	
	  var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
	  var edgeShape = seriesScope.edgeShape;
	
	  if (edge) {
	    if (edgeShape === 'curve') {
	      graphic.updateProps(edge, {
	        shape: getEdgeShape(seriesScope, sourceLayout, sourceLayout),
	        style: {
	          opacity: 0
	        }
	      }, seriesModel, function () {
	        group.remove(edge);
	      });
	    } else if (edgeShape === 'polyline' && seriesScope.layout === 'orthogonal') {
	      graphic.updateProps(edge, {
	        shape: {
	          parentPoint: [sourceLayout.x, sourceLayout.y],
	          childPoints: [[sourceLayout.x, sourceLayout.y]]
	        },
	        style: {
	          opacity: 0
	        }
	      }, seriesModel, function () {
	        group.remove(edge);
	      });
	    }
	  }
	}
	
	function getEdgeShape(seriesScope, sourceLayout, targetLayout) {
	  var cpx1;
	  var cpy1;
	  var cpx2;
	  var cpy2;
	  var orient = seriesScope.orient;
	  var x1;
	  var x2;
	  var y1;
	  var y2;
	
	  if (seriesScope.layout === 'radial') {
	    x1 = sourceLayout.rawX;
	    y1 = sourceLayout.rawY;
	    x2 = targetLayout.rawX;
	    y2 = targetLayout.rawY;
	    var radialCoor1 = radialCoordinate(x1, y1);
	    var radialCoor2 = radialCoordinate(x1, y1 + (y2 - y1) * seriesScope.curvature);
	    var radialCoor3 = radialCoordinate(x2, y2 + (y1 - y2) * seriesScope.curvature);
	    var radialCoor4 = radialCoordinate(x2, y2);
	    return {
	      x1: radialCoor1.x,
	      y1: radialCoor1.y,
	      x2: radialCoor4.x,
	      y2: radialCoor4.y,
	      cpx1: radialCoor2.x,
	      cpy1: radialCoor2.y,
	      cpx2: radialCoor3.x,
	      cpy2: radialCoor3.y
	    };
	  } else {
	    x1 = sourceLayout.x;
	    y1 = sourceLayout.y;
	    x2 = targetLayout.x;
	    y2 = targetLayout.y;
	
	    if (orient === 'LR' || orient === 'RL') {
	      cpx1 = x1 + (x2 - x1) * seriesScope.curvature;
	      cpy1 = y1;
	      cpx2 = x2 + (x1 - x2) * seriesScope.curvature;
	      cpy2 = y2;
	    }
	
	    if (orient === 'TB' || orient === 'BT') {
	      cpx1 = x1;
	      cpy1 = y1 + (y2 - y1) * seriesScope.curvature;
	      cpx2 = x2;
	      cpy2 = y2 + (y1 - y2) * seriesScope.curvature;
	    }
	  }
	
	  return {
	    x1: x1,
	    y1: y1,
	    x2: x2,
	    y2: y2,
	    cpx1: cpx1,
	    cpy1: cpy1,
	    cpx2: cpx2,
	    cpy2: cpy2
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var layout = __webpack_require__(305);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The tree layoutHelper implementation was originally copied from
	* "d3.js"(https://github.com/d3/d3-hierarchy) with
	* some modifications made for this project.
	* (see more details in the comment of the specific method below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the licence of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	
	/**
	 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
	 *       the tree.
	 */
	
	/**
	 * Initialize all computational message for following algorithm.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} root   The virtual root of the tree.
	 */
	function init(root) {
	  root.hierNode = {
	    defaultAncestor: null,
	    ancestor: root,
	    prelim: 0,
	    modifier: 0,
	    change: 0,
	    shift: 0,
	    i: 0,
	    thread: null
	  };
	  var nodes = [root];
	  var node;
	  var children;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    children = node.children;
	
	    if (node.isExpand && children.length) {
	      var n = children.length;
	
	      for (var i = n - 1; i >= 0; i--) {
	        var child = children[i];
	        child.hierNode = {
	          defaultAncestor: null,
	          ancestor: child,
	          prelim: 0,
	          modifier: 0,
	          change: 0,
	          shift: 0,
	          i: i,
	          thread: null
	        };
	        nodes.push(child);
	      }
	    }
	  }
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Computes a preliminary x coordinate for node. Before that, this function is
	 * applied recursively to the children of node, as well as the function
	 * apportion(). After spacing out the children by calling executeShifts(), the
	 * node is placed to the midpoint of its outermost children.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @param {Function} separation
	 */
	
	
	function firstWalk(node, separation) {
	  var children = node.isExpand ? node.children : [];
	  var siblings = node.parentNode.children;
	  var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
	
	  if (children.length) {
	    executeShifts(node);
	    var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
	
	    if (subtreeW) {
	      node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	      node.hierNode.modifier = node.hierNode.prelim - midPoint;
	    } else {
	      node.hierNode.prelim = midPoint;
	    }
	  } else if (subtreeW) {
	    node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	  }
	
	  node.parentNode.hierNode.defaultAncestor = apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Computes all real x-coordinates by summing up the modifiers recursively.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 */
	
	
	function secondWalk(node) {
	  var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
	  node.setLayout({
	    x: nodeX
	  }, true);
	  node.hierNode.modifier += node.parentNode.hierNode.modifier;
	}
	
	function separation(cb) {
	  return arguments.length ? cb : defaultSeparation;
	}
	/**
	 * Transform the common coordinate to radial coordinate.
	 *
	 * @param  {number} x
	 * @param  {number} y
	 * @return {Object}
	 */
	
	
	function radialCoordinate(x, y) {
	  var radialCoor = {};
	  x -= Math.PI / 2;
	  radialCoor.x = y * Math.cos(x);
	  radialCoor.y = y * Math.sin(x);
	  return radialCoor;
	}
	/**
	 * Get the layout position of the whole view.
	 *
	 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
	 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
	 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
	 */
	
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	/**
	 * All other shifts, applied to the smaller subtrees between w- and w+, are
	 * performed by this function.
	 *
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 */
	
	
	function executeShifts(node) {
	  var children = node.children;
	  var n = children.length;
	  var shift = 0;
	  var change = 0;
	
	  while (--n >= 0) {
	    var child = children[n];
	    child.hierNode.prelim += shift;
	    child.hierNode.modifier += shift;
	    change += child.hierNode.change;
	    shift += child.hierNode.shift + change;
	  }
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * The core of the algorithm. Here, a new subtree is combined with the
	 * previous subtrees. Threads are used to traverse the inside and outside
	 * contours of the left and right subtree up to the highest common level.
	 * Whenever two nodes of the inside contours conflict, we compute the left
	 * one of the greatest uncommon ancestors using the function nextAncestor()
	 * and call moveSubtree() to shift the subtree and prepare the shifts of
	 * smaller subtrees. Finally, we add a new thread (if necessary).
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} subtreeV
	 * @param  {module:echarts/data/Tree~TreeNode} subtreeW
	 * @param  {module:echarts/data/Tree~TreeNode} ancestor
	 * @param  {Function} separation
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function apportion(subtreeV, subtreeW, ancestor, separation) {
	  if (subtreeW) {
	    var nodeOutRight = subtreeV;
	    var nodeInRight = subtreeV;
	    var nodeOutLeft = nodeInRight.parentNode.children[0];
	    var nodeInLeft = subtreeW;
	    var sumOutRight = nodeOutRight.hierNode.modifier;
	    var sumInRight = nodeInRight.hierNode.modifier;
	    var sumOutLeft = nodeOutLeft.hierNode.modifier;
	    var sumInLeft = nodeInLeft.hierNode.modifier;
	
	    while (nodeInLeft = nextRight(nodeInLeft), nodeInRight = nextLeft(nodeInRight), nodeInLeft && nodeInRight) {
	      nodeOutRight = nextRight(nodeOutRight);
	      nodeOutLeft = nextLeft(nodeOutLeft);
	      nodeOutRight.hierNode.ancestor = subtreeV;
	      var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
	
	      if (shift > 0) {
	        moveSubtree(nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
	        sumInRight += shift;
	        sumOutRight += shift;
	      }
	
	      sumInLeft += nodeInLeft.hierNode.modifier;
	      sumInRight += nodeInRight.hierNode.modifier;
	      sumOutRight += nodeOutRight.hierNode.modifier;
	      sumOutLeft += nodeOutLeft.hierNode.modifier;
	    }
	
	    if (nodeInLeft && !nextRight(nodeOutRight)) {
	      nodeOutRight.hierNode.thread = nodeInLeft;
	      nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
	    }
	
	    if (nodeInRight && !nextLeft(nodeOutLeft)) {
	      nodeOutLeft.hierNode.thread = nodeInRight;
	      nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
	      ancestor = subtreeV;
	    }
	  }
	
	  return ancestor;
	}
	/**
	 * This function is used to traverse the right contour of a subtree.
	 * It returns the rightmost child of node or the thread of node. The function
	 * returns null if and only if node is on the highest depth of its subtree.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextRight(node) {
	  var children = node.children;
	  return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
	}
	/**
	 * This function is used to traverse the left contour of a subtree (or a subforest).
	 * It returns the leftmost child of node or the thread of node. The function
	 * returns null if and only if node is on the highest depth of its subtree.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextLeft(node) {
	  var children = node.children;
	  return children.length && node.isExpand ? children[0] : node.hierNode.thread;
	}
	/**
	 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
	 * Otherwise, returns the specified ancestor.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} nodeInLeft
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @param  {module:echarts/data/Tree~TreeNode} ancestor
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextAncestor(nodeInLeft, node, ancestor) {
	  return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Shifts the current subtree rooted at wr.
	 * This is done by increasing prelim(w+) and modifier(w+) by shift.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} wl
	 * @param  {module:echarts/data/Tree~TreeNode} wr
	 * @param  {number} shift [description]
	 */
	
	
	function moveSubtree(wl, wr, shift) {
	  var change = shift / (wr.hierNode.i - wl.hierNode.i);
	  wr.hierNode.change -= change;
	  wr.hierNode.shift += shift;
	  wr.hierNode.modifier += shift;
	  wr.hierNode.prelim += shift;
	  wl.hierNode.change += change;
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 */
	
	
	function defaultSeparation(node1, node2) {
	  return node1.parentNode === node2.parentNode ? 1 : 2;
	}
	
	exports.init = init;
	exports.firstWalk = firstWalk;
	exports.secondWalk = secondWalk;
	exports.separation = separation;
	exports.radialCoordinate = radialCoordinate;
	exports.getViewRect = getViewRect;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var _roamHelper = __webpack_require__(443);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'treeExpandAndCollapse',
	  event: 'treeExpandAndCollapse',
	  update: 'update'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'tree',
	    query: payload
	  }, function (seriesModel) {
	    var dataIndex = payload.dataIndex;
	    var tree = seriesModel.getData().tree;
	    var node = tree.getNodeByDataIndex(dataIndex);
	    node.isExpand = !node.isExpand;
	  });
	});
	echarts.registerAction({
	  type: 'treeRoam',
	  event: 'treeRoam',
	  // Here we set 'none' instead of 'update', because roam action
	  // just need to update the transform matrix without having to recalculate
	  // the layout. So don't need to go through the whole update process, such
	  // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
	  update: 'none'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'tree',
	    query: payload
	  }, function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var res = updateCenterAndZoom(coordSys, payload);
	    seriesModel.setCenter && seriesModel.setCenter(res.center);
	    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	  });
	});

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _traversalHelper = __webpack_require__(459);
	
	var eachAfter = _traversalHelper.eachAfter;
	var eachBefore = _traversalHelper.eachBefore;
	
	var _layoutHelper = __webpack_require__(456);
	
	var init = _layoutHelper.init;
	var firstWalk = _layoutHelper.firstWalk;
	var secondWalk = _layoutHelper.secondWalk;
	var sep = _layoutHelper.separation;
	var radialCoordinate = _layoutHelper.radialCoordinate;
	var getViewRect = _layoutHelper.getViewRect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('tree', function (seriesModel) {
	    commonLayout(seriesModel, api);
	  });
	}
	
	function commonLayout(seriesModel, api) {
	  var layoutInfo = getViewRect(seriesModel, api);
	  seriesModel.layoutInfo = layoutInfo;
	  var layout = seriesModel.get('layout');
	  var width = 0;
	  var height = 0;
	  var separation = null;
	
	  if (layout === 'radial') {
	    width = 2 * Math.PI;
	    height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
	    separation = sep(function (node1, node2) {
	      return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
	    });
	  } else {
	    width = layoutInfo.width;
	    height = layoutInfo.height;
	    separation = sep();
	  }
	
	  var virtualRoot = seriesModel.getData().tree.root;
	  var realRoot = virtualRoot.children[0];
	
	  if (realRoot) {
	    init(virtualRoot);
	    eachAfter(realRoot, firstWalk, separation);
	    virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
	    eachBefore(realRoot, secondWalk);
	    var left = realRoot;
	    var right = realRoot;
	    var bottom = realRoot;
	    eachBefore(realRoot, function (node) {
	      var x = node.getLayout().x;
	
	      if (x < left.getLayout().x) {
	        left = node;
	      }
	
	      if (x > right.getLayout().x) {
	        right = node;
	      }
	
	      if (node.depth > bottom.depth) {
	        bottom = node;
	      }
	    });
	    var delta = left === right ? 1 : separation(left, right) / 2;
	    var tx = delta - left.getLayout().x;
	    var kx = 0;
	    var ky = 0;
	    var coorX = 0;
	    var coorY = 0;
	
	    if (layout === 'radial') {
	      kx = width / (right.getLayout().x + delta + tx); // here we use (node.depth - 1), bucause the real root's depth is 1
	
	      ky = height / (bottom.depth - 1 || 1);
	      eachBefore(realRoot, function (node) {
	        coorX = (node.getLayout().x + tx) * kx;
	        coorY = (node.depth - 1) * ky;
	        var finalCoor = radialCoordinate(coorX, coorY);
	        node.setLayout({
	          x: finalCoor.x,
	          y: finalCoor.y,
	          rawX: coorX,
	          rawY: coorY
	        }, true);
	      });
	    } else {
	      var orient = seriesModel.getOrient();
	
	      if (orient === 'RL' || orient === 'LR') {
	        ky = height / (right.getLayout().x + delta + tx);
	        kx = width / (bottom.depth - 1 || 1);
	        eachBefore(realRoot, function (node) {
	          coorY = (node.getLayout().x + tx) * ky;
	          coorX = orient === 'LR' ? (node.depth - 1) * kx : width - (node.depth - 1) * kx;
	          node.setLayout({
	            x: coorX,
	            y: coorY
	          }, true);
	        });
	      } else if (orient === 'TB' || orient === 'BT') {
	        kx = width / (right.getLayout().x + delta + tx);
	        ky = height / (bottom.depth - 1 || 1);
	        eachBefore(realRoot, function (node) {
	          coorX = (node.getLayout().x + tx) * kx;
	          coorY = orient === 'TB' ? (node.depth - 1) * ky : height - (node.depth - 1) * ky;
	          node.setLayout({
	            x: coorX,
	            y: coorY
	          }, true);
	        });
	      }
	    }
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Traverse the tree from bottom to top and do something
	 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
	 * @param  {Function} callback
	 */
	function eachAfter(root, callback, separation) {
	  var nodes = [root];
	  var next = [];
	  var node;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    next.push(node);
	
	    if (node.isExpand) {
	      var children = node.children;
	
	      if (children.length) {
	        for (var i = 0; i < children.length; i++) {
	          nodes.push(children[i]);
	        }
	      }
	    }
	  }
	
	  while (node = next.pop()) {
	    // jshint ignore:line
	    callback(node, separation);
	  }
	}
	/**
	 * Traverse the tree from top to bottom and do something
	 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
	 * @param  {Function} callback
	 */
	
	
	function eachBefore(root, callback) {
	  var nodes = [root];
	  var node;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    callback(node);
	
	    if (node.isExpand) {
	      var children = node.children;
	
	      if (children.length) {
	        for (var i = children.length - 1; i >= 0; i--) {
	          nodes.push(children[i]);
	        }
	      }
	    }
	  }
	}
	
	exports.eachAfter = eachAfter;
	exports.eachBefore = eachBefore;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(461);
	
	__webpack_require__(463);
	
	__webpack_require__(466);
	
	var treemapVisual = __webpack_require__(467);
	
	var treemapLayout = __webpack_require__(469);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(treemapVisual);
	echarts.registerLayout(treemapLayout);

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var SeriesModel = __webpack_require__(320);
	
	var Tree = __webpack_require__(453);
	
	var Model = __webpack_require__(262);
	
	var _format = __webpack_require__(307);
	
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	
	var _treeHelper = __webpack_require__(462);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.treemap',
	  layoutMode: 'box',
	  dependencies: ['grid', 'polar'],
	  preventUsingHoverLayer: true,
	
	  /**
	   * @type {module:echarts/data/Tree~Node}
	   */
	  _viewRoot: null,
	  defaultOption: {
	    // Disable progressive rendering
	    progressive: 0,
	    // center: ['50%', '50%'],          // not supported in ec3.
	    // size: ['80%', '80%'],            // deprecated, compatible with ec2.
	    left: 'center',
	    top: 'middle',
	    right: null,
	    bottom: null,
	    width: '80%',
	    height: '80%',
	    sort: true,
	    // Can be null or false or true
	    // (order by desc default, asc not supported yet (strange effect))
	    clipWindow: 'origin',
	    // Size of clipped window when zooming. 'origin' or 'fullscreen'
	    squareRatio: 0.5 * (1 + Math.sqrt(5)),
	    // golden ratio
	    leafDepth: null,
	    // Nodes on depth from root are regarded as leaves.
	    // Count from zero (zero represents only view root).
	    drillDownIcon: '▶',
	    // Use html character temporarily because it is complicated
	    // to align specialized icon. ▷▶❒❐▼✚
	    zoomToNodeRatio: 0.32 * 0.32,
	    // Be effective when using zoomToNode. Specify the proportion of the
	    // target node area in the view area.
	    roam: true,
	    // true, false, 'scale' or 'zoom', 'move'.
	    nodeClick: 'zoomToNode',
	    // Leaf node click behaviour: 'zoomToNode', 'link', false.
	    // If leafDepth is set and clicking a node which has children but
	    // be on left depth, the behaviour would be changing root. Otherwise
	    // use behavious defined above.
	    animation: true,
	    animationDurationUpdate: 900,
	    animationEasing: 'quinticInOut',
	    breadcrumb: {
	      show: true,
	      height: 22,
	      left: 'center',
	      top: 'bottom',
	      // right
	      // bottom
	      emptyItemWidth: 25,
	      // Width of empty node.
	      itemStyle: {
	        color: 'rgba(0,0,0,0.7)',
	        //'#5793f3',
	        borderColor: 'rgba(255,255,255,0.7)',
	        borderWidth: 1,
	        shadowColor: 'rgba(150,150,150,1)',
	        shadowBlur: 3,
	        shadowOffsetX: 0,
	        shadowOffsetY: 0,
	        textStyle: {
	          color: '#fff'
	        }
	      },
	      emphasis: {
	        textStyle: {}
	      }
	    },
	    label: {
	      show: true,
	      // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
	      distance: 0,
	      padding: 5,
	      position: 'inside',
	      // Can be [5, '5%'] or position stirng like 'insideTopLeft', ...
	      // formatter: null,
	      color: '#fff',
	      ellipsis: true // align
	      // verticalAlign
	
	    },
	    upperLabel: {
	      // Label when node is parent.
	      show: false,
	      position: [0, '50%'],
	      height: 20,
	      // formatter: null,
	      color: '#fff',
	      ellipsis: true,
	      // align: null,
	      verticalAlign: 'middle'
	    },
	    itemStyle: {
	      color: null,
	      // Can be 'none' if not necessary.
	      colorAlpha: null,
	      // Can be 'none' if not necessary.
	      colorSaturation: null,
	      // Can be 'none' if not necessary.
	      borderWidth: 0,
	      gapWidth: 0,
	      borderColor: '#fff',
	      borderColorSaturation: null // If specified, borderColor will be ineffective, and the
	      // border color is evaluated by color of current node and
	      // borderColorSaturation.
	
	    },
	    emphasis: {
	      upperLabel: {
	        show: true,
	        position: [0, '50%'],
	        color: '#fff',
	        ellipsis: true,
	        verticalAlign: 'middle'
	      }
	    },
	    visualDimension: 0,
	    // Can be 0, 1, 2, 3.
	    visualMin: null,
	    visualMax: null,
	    color: [],
	    // + treemapSeries.color should not be modified. Please only modified
	    // level[n].color (if necessary).
	    // + Specify color list of each level. level[0].color would be global
	    // color list if not specified. (see method `setDefault`).
	    // + But set as a empty array to forbid fetch color from global palette
	    // when using nodeModel.get('color'), otherwise nodes on deep level
	    // will always has color palette set and are not able to inherit color
	    // from parent node.
	    // + TreemapSeries.color can not be set as 'none', otherwise effect
	    // legend color fetching (see seriesColor.js).
	    colorAlpha: null,
	    // Array. Specify color alpha range of each level, like [0.2, 0.8]
	    colorSaturation: null,
	    // Array. Specify color saturation of each level, like [0.2, 0.5]
	    colorMappingBy: 'index',
	    // 'value' or 'index' or 'id'.
	    visibleMin: 10,
	    // If area less than this threshold (unit: pixel^2), node will not
	    // be rendered. Only works when sort is 'asc' or 'desc'.
	    childrenVisibleMin: null,
	    // If area of a node less than this threshold (unit: pixel^2),
	    // grandchildren will not show.
	    // Why grandchildren? If not grandchildren but children,
	    // some siblings show children and some not,
	    // the appearance may be mess and not consistent,
	    levels: [] // Each item: {
	    //     visibleMin, itemStyle, visualDimension, label
	    // }
	    // data: {
	    //      value: [],
	    //      children: [],
	    //      link: 'http://xxx.xxx.xxx',
	    //      target: 'blank' or 'self'
	    // }
	
	  },
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    // Create a virtual root.
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    completeTreeValue(root);
	    var levels = option.levels || []; // Used in "visual priority" in `treemapVisual.js`.
	    // This way is a little tricky, must satisfy the precondition:
	    //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
	    //   2. The `Model.prototype.getModel()` will not use any clone-like way.
	
	    var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
	    var designatedVisualModel = new Model({
	      itemStyle: designatedVisualItemStyle
	    }, this, ecModel);
	    levels = option.levels = setDefault(levels, ecModel);
	    var levelModels = zrUtil.map(levels || [], function (levelDefine) {
	      return new Model(levelDefine, designatedVisualModel, ecModel);
	    }, this); // Make sure always a new tree is created when setOption,
	    // in TreemapView, we check whether oldTree === newTree
	    // to choose mappings approach among old shapes and new shapes.
	
	    var tree = Tree.createTree(root, this, beforeLink);
	
	    function beforeLink(nodeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        var node = tree.getNodeByDataIndex(idx);
	        var levelModel = levelModels[node.depth]; // If no levelModel, we also need `designatedVisualModel`.
	
	        model.parentModel = levelModel || designatedVisualModel;
	        return model;
	      });
	    }
	
	    return tree.data;
	  },
	  optionUpdated: function () {
	    this.resetViewRoot();
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex
	   * @param {boolean} [mutipleSeries=false]
	   */
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? addCommas(value[0]) : addCommas(value);
	    var name = data.getName(dataIndex);
	    return encodeHTML(name + ': ' + formattedValue);
	  },
	
	  /**
	   * Add tree path to tooltip param
	   *
	   * @override
	   * @param {number} dataIndex
	   * @return {Object}
	   */
	  getDataParams: function (dataIndex) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	    params.treePathInfo = wrapTreePathInfo(node, this);
	    return params;
	  },
	
	  /**
	   * @public
	   * @param {Object} layoutInfo {
	   *                                x: containerGroup x
	   *                                y: containerGroup y
	   *                                width: containerGroup width
	   *                                height: containerGroup height
	   *                            }
	   */
	  setLayoutInfo: function (layoutInfo) {
	    /**
	     * @readOnly
	     * @type {Object}
	     */
	    this.layoutInfo = this.layoutInfo || {};
	    zrUtil.extend(this.layoutInfo, layoutInfo);
	  },
	
	  /**
	   * @param  {string} id
	   * @return {number} index
	   */
	  mapIdToIndex: function (id) {
	    // A feature is implemented:
	    // index is monotone increasing with the sequence of
	    // input id at the first time.
	    // This feature can make sure that each data item and its
	    // mapped color have the same index between data list and
	    // color list at the beginning, which is useful for user
	    // to adjust data-color mapping.
	
	    /**
	     * @private
	     * @type {Object}
	     */
	    var idIndexMap = this._idIndexMap;
	
	    if (!idIndexMap) {
	      idIndexMap = this._idIndexMap = zrUtil.createHashMap();
	      /**
	       * @private
	       * @type {number}
	       */
	
	      this._idIndexMapCount = 0;
	    }
	
	    var index = idIndexMap.get(id);
	
	    if (index == null) {
	      idIndexMap.set(id, index = this._idIndexMapCount++);
	    }
	
	    return index;
	  },
	  getViewRoot: function () {
	    return this._viewRoot;
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~Node} [viewRoot]
	   */
	  resetViewRoot: function (viewRoot) {
	    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	    var root = this.getRawData().tree.root;
	
	    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	      this._viewRoot = root;
	    }
	  }
	});
	/**
	 * @param {Object} dataNode
	 */
	
	
	function completeTreeValue(dataNode) {
	  // Postorder travel tree.
	  // If value of none-leaf node is not set,
	  // calculate it by suming up the value of all children.
	  var sum = 0;
	  zrUtil.each(dataNode.children, function (child) {
	    completeTreeValue(child);
	    var childValue = child.value;
	    zrUtil.isArray(childValue) && (childValue = childValue[0]);
	    sum += childValue;
	  });
	  var thisValue = dataNode.value;
	
	  if (zrUtil.isArray(thisValue)) {
	    thisValue = thisValue[0];
	  }
	
	  if (thisValue == null || isNaN(thisValue)) {
	    thisValue = sum;
	  } // Value should not less than 0.
	
	
	  if (thisValue < 0) {
	    thisValue = 0;
	  }
	
	  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	}
	/**
	 * set default to level configuration
	 */
	
	
	function setDefault(levels, ecModel) {
	  var globalColorList = ecModel.get('color');
	
	  if (!globalColorList) {
	    return;
	  }
	
	  levels = levels || [];
	  var hasColorDefine;
	  zrUtil.each(levels, function (levelDefine) {
	    var model = new Model(levelDefine);
	    var modelColor = model.get('color');
	
	    if (model.get('itemStyle.color') || modelColor && modelColor !== 'none') {
	      hasColorDefine = true;
	    }
	  });
	
	  if (!hasColorDefine) {
	    var level0 = levels[0] || (levels[0] = {});
	    level0.color = globalColorList.slice();
	  }
	
	  return levels;
	}
	
	module.exports = _default;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function retrieveTargetInfo(payload, validPayloadTypes, seriesModel) {
	  if (payload && zrUtil.indexOf(validPayloadTypes, payload.type) >= 0) {
	    var root = seriesModel.getData().tree.root;
	    var targetNode = payload.targetNode;
	
	    if (typeof targetNode === 'string') {
	      targetNode = root.getNodeById(targetNode);
	    }
	
	    if (targetNode && root.contains(targetNode)) {
	      return {
	        node: targetNode
	      };
	    }
	
	    var targetNodeId = payload.targetNodeId;
	
	    if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) {
	      return {
	        node: targetNode
	      };
	    }
	  }
	} // Not includes the given node at the last item.
	
	
	function getPathToRoot(node) {
	  var path = [];
	
	  while (node) {
	    node = node.parentNode;
	    node && path.push(node);
	  }
	
	  return path.reverse();
	}
	
	function aboveViewRoot(viewRoot, node) {
	  var viewPath = getPathToRoot(viewRoot);
	  return zrUtil.indexOf(viewPath, node) >= 0;
	} // From root to the input node (the input node will be included).
	
	
	function wrapTreePathInfo(node, seriesModel) {
	  var treePathInfo = [];
	
	  while (node) {
	    var nodeDataIndex = node.dataIndex;
	    treePathInfo.push({
	      name: node.name,
	      dataIndex: nodeDataIndex,
	      value: seriesModel.getRawValue(nodeDataIndex)
	    });
	    node = node.parentNode;
	  }
	
	  treePathInfo.reverse();
	  return treePathInfo;
	}
	
	exports.retrieveTargetInfo = retrieveTargetInfo;
	exports.getPathToRoot = getPathToRoot;
	exports.aboveViewRoot = aboveViewRoot;
	exports.wrapTreePathInfo = wrapTreePathInfo;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var DataDiffer = __webpack_require__(343);
	
	var helper = __webpack_require__(462);
	
	var Breadcrumb = __webpack_require__(464);
	
	var RoamController = __webpack_require__(438);
	
	var BoundingRect = __webpack_require__(242);
	
	var matrix = __webpack_require__(233);
	
	var animationUtil = __webpack_require__(465);
	
	var makeStyleMapper = __webpack_require__(265);
	
	var _format = __webpack_require__(307);
	
	var windowOpen = _format.windowOpen;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var Group = graphic.Group;
	var Rect = graphic.Rect;
	var each = zrUtil.each;
	var DRAG_THRESHOLD = 3;
	var PATH_LABEL_NOAMAL = ['label'];
	var PATH_LABEL_EMPHASIS = ['emphasis', 'label'];
	var PATH_UPPERLABEL_NORMAL = ['upperLabel'];
	var PATH_UPPERLABEL_EMPHASIS = ['emphasis', 'upperLabel'];
	var Z_BASE = 10; // Should bigger than every z.
	
	var Z_BG = 1;
	var Z_CONTENT = 2;
	var getItemStyleEmphasis = makeStyleMapper([['fill', 'color'], // `borderColor` and `borderWidth` has been occupied,
	// so use `stroke` to indicate the stroke of the rect.
	['stroke', 'strokeColor'], ['lineWidth', 'strokeWidth'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	
	var getItemStyleNormal = function (model) {
	  // Normal style props should include emphasis style props.
	  var itemStyle = getItemStyleEmphasis(model); // Clear styles set by emphasis.
	
	  itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
	  return itemStyle;
	};
	
	var _default = echarts.extendChartView({
	  type: 'treemap',
	
	  /**
	   * @override
	   */
	  init: function (o, api) {
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	    this._containerGroup;
	    /**
	     * @private
	     * @type {Object.<string, Array.<module:zrender/container/Group>>}
	     */
	
	    this._storage = createStorage();
	    /**
	     * @private
	     * @type {module:echarts/data/Tree}
	     */
	
	    this._oldTree;
	    /**
	     * @private
	     * @type {module:echarts/chart/treemap/Breadcrumb}
	     */
	
	    this._breadcrumb;
	    /**
	     * @private
	     * @type {module:echarts/component/helper/RoamController}
	     */
	
	    this._controller;
	    /**
	     * 'ready', 'animating'
	     * @private
	     */
	
	    this._state = 'ready';
	  },
	
	  /**
	   * @override
	   */
	  render: function (seriesModel, ecModel, api, payload) {
	    var models = ecModel.findComponents({
	      mainType: 'series',
	      subType: 'treemap',
	      query: payload
	    });
	
	    if (zrUtil.indexOf(models, seriesModel) < 0) {
	      return;
	    }
	
	    this.seriesModel = seriesModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, seriesModel);
	    var payloadType = payload && payload.type;
	    var layoutInfo = seriesModel.layoutInfo;
	    var isInit = !this._oldTree;
	    var thisStorage = this._storage; // Mark new root when action is treemapRootToNode.
	
	    var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
	      rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
	      direction: payload.direction
	    } : null;
	
	    var containerGroup = this._giveContainerGroup(layoutInfo);
	
	    var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
	
	    !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
	
	    this._resetController(api);
	
	    this._renderBreadcrumb(seriesModel, api, targetInfo);
	  },
	
	  /**
	   * @private
	   */
	  _giveContainerGroup: function (layoutInfo) {
	    var containerGroup = this._containerGroup;
	
	    if (!containerGroup) {
	      // FIXME
	      // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
	      containerGroup = this._containerGroup = new Group();
	
	      this._initEvents(containerGroup);
	
	      this.group.add(containerGroup);
	    }
	
	    containerGroup.attr('position', [layoutInfo.x, layoutInfo.y]);
	    return containerGroup;
	  },
	
	  /**
	   * @private
	   */
	  _doRender: function (containerGroup, seriesModel, reRoot) {
	    var thisTree = seriesModel.getData().tree;
	    var oldTree = this._oldTree; // Clear last shape records.
	
	    var lastsForAnimation = createStorage();
	    var thisStorage = createStorage();
	    var oldStorage = this._storage;
	    var willInvisibleEls = [];
	    var doRenderNode = zrUtil.curry(renderNode, seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls); // Notice: when thisTree and oldTree are the same tree (see list.cloneShallow),
	    // the oldTree is actually losted, so we can not find all of the old graphic
	    // elements from tree. So we use this stragegy: make element storage, move
	    // from old storage to new storage, clear old storage.
	
	    dualTravel(thisTree.root ? [thisTree.root] : [], oldTree && oldTree.root ? [oldTree.root] : [], containerGroup, thisTree === oldTree || !oldTree, 0); // Process all removing.
	
	    var willDeleteEls = clearStorage(oldStorage);
	    this._oldTree = thisTree;
	    this._storage = thisStorage;
	    return {
	      lastsForAnimation: lastsForAnimation,
	      willDeleteEls: willDeleteEls,
	      renderFinally: renderFinally
	    };
	
	    function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
	      // When 'render' is triggered by action,
	      // 'this' and 'old' may be the same tree,
	      // we use rawIndex in that case.
	      if (sameTree) {
	        oldViewChildren = thisViewChildren;
	        each(thisViewChildren, function (child, index) {
	          !child.isRemoved() && processNode(index, index);
	        });
	      } // Diff hierarchically (diff only in each subtree, but not whole).
	      // because, consistency of view is important.
	      else {
	          new DataDiffer(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
	        }
	
	      function getKey(node) {
	        // Identify by name or raw index.
	        return node.getId();
	      }
	
	      function processNode(newIndex, oldIndex) {
	        var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
	        var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
	        var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
	        group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
	      }
	    }
	
	    function clearStorage(storage) {
	      var willDeleteEls = createStorage();
	      storage && each(storage, function (store, storageName) {
	        var delEls = willDeleteEls[storageName];
	        each(store, function (el) {
	          el && (delEls.push(el), el.__tmWillDelete = 1);
	        });
	      });
	      return willDeleteEls;
	    }
	
	    function renderFinally() {
	      each(willDeleteEls, function (els) {
	        each(els, function (el) {
	          el.parent && el.parent.remove(el);
	        });
	      });
	      each(willInvisibleEls, function (el) {
	        el.invisible = true; // Setting invisible is for optimizing, so no need to set dirty,
	        // just mark as invisible.
	
	        el.dirty();
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _doAnimation: function (containerGroup, renderResult, seriesModel, reRoot) {
	    if (!seriesModel.get('animation')) {
	      return;
	    }
	
	    var duration = seriesModel.get('animationDurationUpdate');
	    var easing = seriesModel.get('animationEasing');
	    var animationWrap = animationUtil.createWrap(); // Make delete animations.
	
	    each(renderResult.willDeleteEls, function (store, storageName) {
	      each(store, function (el, rawIndex) {
	        if (el.invisible) {
	          return;
	        }
	
	        var parent = el.parent; // Always has parent, and parent is nodeGroup.
	
	        var target;
	
	        if (reRoot && reRoot.direction === 'drillDown') {
	          target = parent === reRoot.rootNodeGroup // This is the content element of view root.
	          // Only `content` will enter this branch, because
	          // `background` and `nodeGroup` will not be deleted.
	          ? {
	            shape: {
	              x: 0,
	              y: 0,
	              width: parent.__tmNodeWidth,
	              height: parent.__tmNodeHeight
	            },
	            style: {
	              opacity: 0
	            } // Others.
	
	          } : {
	            style: {
	              opacity: 0
	            }
	          };
	        } else {
	          var targetX = 0;
	          var targetY = 0;
	
	          if (!parent.__tmWillDelete) {
	            // Let node animate to right-bottom corner, cooperating with fadeout,
	            // which is appropriate for user understanding.
	            // Divided by 2 for reRoot rolling up effect.
	            targetX = parent.__tmNodeWidth / 2;
	            targetY = parent.__tmNodeHeight / 2;
	          }
	
	          target = storageName === 'nodeGroup' ? {
	            position: [targetX, targetY],
	            style: {
	              opacity: 0
	            }
	          } : {
	            shape: {
	              x: targetX,
	              y: targetY,
	              width: 0,
	              height: 0
	            },
	            style: {
	              opacity: 0
	            }
	          };
	        }
	
	        target && animationWrap.add(el, target, duration, easing);
	      });
	    }); // Make other animations
	
	    each(this._storage, function (store, storageName) {
	      each(store, function (el, rawIndex) {
	        var last = renderResult.lastsForAnimation[storageName][rawIndex];
	        var target = {};
	
	        if (!last) {
	          return;
	        }
	
	        if (storageName === 'nodeGroup') {
	          if (last.old) {
	            target.position = el.position.slice();
	            el.attr('position', last.old);
	          }
	        } else {
	          if (last.old) {
	            target.shape = zrUtil.extend({}, el.shape);
	            el.setShape(last.old);
	          }
	
	          if (last.fadein) {
	            el.setStyle('opacity', 0);
	            target.style = {
	              opacity: 1
	            };
	          } // When animation is stopped for succedent animation starting,
	          // el.style.opacity might not be 1
	          else if (el.style.opacity !== 1) {
	              target.style = {
	                opacity: 1
	              };
	            }
	        }
	
	        animationWrap.add(el, target, duration, easing);
	      });
	    }, this);
	    this._state = 'animating';
	    animationWrap.done(bind(function () {
	      this._state = 'ready';
	      renderResult.renderFinally();
	    }, this)).start();
	  },
	
	  /**
	   * @private
	   */
	  _resetController: function (api) {
	    var controller = this._controller; // Init controller.
	
	    if (!controller) {
	      controller = this._controller = new RoamController(api.getZr());
	      controller.enable(this.seriesModel.get('roam'));
	      controller.on('pan', bind(this._onPan, this));
	      controller.on('zoom', bind(this._onZoom, this));
	    }
	
	    var rect = new BoundingRect(0, 0, api.getWidth(), api.getHeight());
	    controller.setPointerChecker(function (e, x, y) {
	      return rect.contain(x, y);
	    });
	  },
	
	  /**
	   * @private
	   */
	  _clearController: function () {
	    var controller = this._controller;
	
	    if (controller) {
	      controller.dispose();
	      controller = null;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _onPan: function (e) {
	    if (this._state !== 'animating' && (Math.abs(e.dx) > DRAG_THRESHOLD || Math.abs(e.dy) > DRAG_THRESHOLD)) {
	      // These param must not be cached.
	      var root = this.seriesModel.getData().tree.root;
	
	      if (!root) {
	        return;
	      }
	
	      var rootLayout = root.getLayout();
	
	      if (!rootLayout) {
	        return;
	      }
	
	      this.api.dispatchAction({
	        type: 'treemapMove',
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        rootRect: {
	          x: rootLayout.x + e.dx,
	          y: rootLayout.y + e.dy,
	          width: rootLayout.width,
	          height: rootLayout.height
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _onZoom: function (e) {
	    var mouseX = e.originX;
	    var mouseY = e.originY;
	
	    if (this._state !== 'animating') {
	      // These param must not be cached.
	      var root = this.seriesModel.getData().tree.root;
	
	      if (!root) {
	        return;
	      }
	
	      var rootLayout = root.getLayout();
	
	      if (!rootLayout) {
	        return;
	      }
	
	      var rect = new BoundingRect(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
	      var layoutInfo = this.seriesModel.layoutInfo; // Transform mouse coord from global to containerGroup.
	
	      mouseX -= layoutInfo.x;
	      mouseY -= layoutInfo.y; // Scale root bounding rect.
	
	      var m = matrix.create();
	      matrix.translate(m, m, [-mouseX, -mouseY]);
	      matrix.scale(m, m, [e.scale, e.scale]);
	      matrix.translate(m, m, [mouseX, mouseY]);
	      rect.applyTransform(m);
	      this.api.dispatchAction({
	        type: 'treemapRender',
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        rootRect: {
	          x: rect.x,
	          y: rect.y,
	          width: rect.width,
	          height: rect.height
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _initEvents: function (containerGroup) {
	    containerGroup.on('click', function (e) {
	      if (this._state !== 'ready') {
	        return;
	      }
	
	      var nodeClick = this.seriesModel.get('nodeClick', true);
	
	      if (!nodeClick) {
	        return;
	      }
	
	      var targetInfo = this.findTarget(e.offsetX, e.offsetY);
	
	      if (!targetInfo) {
	        return;
	      }
	
	      var node = targetInfo.node;
	
	      if (node.getLayout().isLeafRoot) {
	        this._rootToNode(targetInfo);
	      } else {
	        if (nodeClick === 'zoomToNode') {
	          this._zoomToNode(targetInfo);
	        } else if (nodeClick === 'link') {
	          var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
	          var link = itemModel.get('link', true);
	          var linkTarget = itemModel.get('target', true) || 'blank';
	          link && windowOpen(link, linkTarget);
	        }
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderBreadcrumb: function (seriesModel, api, targetInfo) {
	    if (!targetInfo) {
	      targetInfo = seriesModel.get('leafDepth', true) != null ? {
	        node: seriesModel.getViewRoot() // FIXME
	        // better way?
	        // Find breadcrumb tail on center of containerGroup.
	
	      } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
	
	      if (!targetInfo) {
	        targetInfo = {
	          node: seriesModel.getData().tree.root
	        };
	      }
	    }
	
	    (this._breadcrumb || (this._breadcrumb = new Breadcrumb(this.group))).render(seriesModel, api, targetInfo.node, bind(onSelect, this));
	
	    function onSelect(node) {
	      if (this._state !== 'animating') {
	        helper.aboveViewRoot(seriesModel.getViewRoot(), node) ? this._rootToNode({
	          node: node
	        }) : this._zoomToNode({
	          node: node
	        });
	      }
	    }
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearController();
	
	    this._containerGroup && this._containerGroup.removeAll();
	    this._storage = createStorage();
	    this._state = 'ready';
	    this._breadcrumb && this._breadcrumb.remove();
	  },
	  dispose: function () {
	    this._clearController();
	  },
	
	  /**
	   * @private
	   */
	  _zoomToNode: function (targetInfo) {
	    this.api.dispatchAction({
	      type: 'treemapZoomToNode',
	      from: this.uid,
	      seriesId: this.seriesModel.id,
	      targetNode: targetInfo.node
	    });
	  },
	
	  /**
	   * @private
	   */
	  _rootToNode: function (targetInfo) {
	    this.api.dispatchAction({
	      type: 'treemapRootToNode',
	      from: this.uid,
	      seriesId: this.seriesModel.id,
	      targetNode: targetInfo.node
	    });
	  },
	
	  /**
	   * @public
	   * @param {number} x Global coord x.
	   * @param {number} y Global coord y.
	   * @return {Object} info If not found, return undefined;
	   * @return {number} info.node Target node.
	   * @return {number} info.offsetX x refer to target node.
	   * @return {number} info.offsetY y refer to target node.
	   */
	  findTarget: function (x, y) {
	    var targetInfo;
	    var viewRoot = this.seriesModel.getViewRoot();
	    viewRoot.eachNode({
	      attr: 'viewChildren',
	      order: 'preorder'
	    }, function (node) {
	      var bgEl = this._storage.background[node.getRawIndex()]; // If invisible, there might be no element.
	
	
	      if (bgEl) {
	        var point = bgEl.transformCoordToLocal(x, y);
	        var shape = bgEl.shape; // For performance consideration, dont use 'getBoundingRect'.
	
	        if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) {
	          targetInfo = {
	            node: node,
	            offsetX: point[0],
	            offsetY: point[1]
	          };
	        } else {
	          return false; // Suppress visit subtree.
	        }
	      }
	    }, this);
	    return targetInfo;
	  }
	});
	/**
	 * @inner
	 */
	
	
	function createStorage() {
	  return {
	    nodeGroup: [],
	    background: [],
	    content: []
	  };
	}
	/**
	 * @inner
	 * @return Return undefined means do not travel further.
	 */
	
	
	function renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
	  // Whether under viewRoot.
	  if (!thisNode) {
	    // Deleting nodes will be performed finally. This method just find
	    // element from old storage, or create new element, set them to new
	    // storage, and set styles.
	    return;
	  } // -------------------------------------------------------------------
	  // Start of closure variables available in "Procedures in renderNode".
	
	
	  var thisLayout = thisNode.getLayout();
	  var data = seriesModel.getData(); // Only for enabling highlight/downplay. Clear firstly.
	  // Because some node will not be rendered.
	
	  data.setItemGraphicEl(thisNode.dataIndex, null);
	
	  if (!thisLayout || !thisLayout.isInView) {
	    return;
	  }
	
	  var thisWidth = thisLayout.width;
	  var thisHeight = thisLayout.height;
	  var borderWidth = thisLayout.borderWidth;
	  var thisInvisible = thisLayout.invisible;
	  var thisRawIndex = thisNode.getRawIndex();
	  var oldRawIndex = oldNode && oldNode.getRawIndex();
	  var thisViewChildren = thisNode.viewChildren;
	  var upperHeight = thisLayout.upperHeight;
	  var isParent = thisViewChildren && thisViewChildren.length;
	  var itemStyleNormalModel = thisNode.getModel('itemStyle');
	  var itemStyleEmphasisModel = thisNode.getModel('emphasis.itemStyle'); // End of closure ariables available in "Procedures in renderNode".
	  // -----------------------------------------------------------------
	  // Node group
	
	  var group = giveGraphic('nodeGroup', Group);
	
	  if (!group) {
	    return;
	  }
	
	  parentGroup.add(group); // x,y are not set when el is above view root.
	
	  group.attr('position', [thisLayout.x || 0, thisLayout.y || 0]);
	  group.__tmNodeWidth = thisWidth;
	  group.__tmNodeHeight = thisHeight;
	
	  if (thisLayout.isAboveViewRoot) {
	    return group;
	  }
	
	  var nodeModel = thisNode.getModel(); // Background
	
	  var bg = giveGraphic('background', Rect, depth, Z_BG);
	  bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight); // No children, render content.
	
	  if (isParent) {
	    // Because of the implementation about "traverse" in graphic hover style, we
	    // can not set hover listener on the "group" of non-leaf node. Otherwise the
	    // hover event from the descendents will be listenered.
	    if (graphic.isHighDownDispatcher(group)) {
	      graphic.setAsHighDownDispatcher(group, false);
	    }
	
	    if (bg) {
	      graphic.setAsHighDownDispatcher(bg, true); // Only for enabling highlight/downplay.
	
	      data.setItemGraphicEl(thisNode.dataIndex, bg);
	    }
	  } else {
	    var content = giveGraphic('content', Rect, depth, Z_CONTENT);
	    content && renderContent(group, content);
	
	    if (bg && graphic.isHighDownDispatcher(bg)) {
	      graphic.setAsHighDownDispatcher(bg, false);
	    }
	
	    graphic.setAsHighDownDispatcher(group, true); // Only for enabling highlight/downplay.
	
	    data.setItemGraphicEl(thisNode.dataIndex, group);
	  }
	
	  return group; // ----------------------------
	  // | Procedures in renderNode |
	  // ----------------------------
	
	  function renderBackground(group, bg, useUpperLabel) {
	    // For tooltip.
	    bg.dataIndex = thisNode.dataIndex;
	    bg.seriesIndex = seriesModel.seriesIndex;
	    bg.setShape({
	      x: 0,
	      y: 0,
	      width: thisWidth,
	      height: thisHeight
	    });
	
	    if (thisInvisible) {
	      // If invisible, do not set visual, otherwise the element will
	      // change immediately before animation. We think it is OK to
	      // remain its origin color when moving out of the view window.
	      processInvisible(bg);
	    } else {
	      bg.invisible = false;
	      var visualBorderColor = thisNode.getVisual('borderColor', true);
	      var emphasisBorderColor = itemStyleEmphasisModel.get('borderColor');
	      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	      normalStyle.fill = visualBorderColor;
	      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
	      emphasisStyle.fill = emphasisBorderColor;
	
	      if (useUpperLabel) {
	        var upperLabelWidth = thisWidth - 2 * borderWidth;
	        prepareText(normalStyle, emphasisStyle, visualBorderColor, upperLabelWidth, upperHeight, {
	          x: borderWidth,
	          y: 0,
	          width: upperLabelWidth,
	          height: upperHeight
	        });
	      } // For old bg.
	      else {
	          normalStyle.text = emphasisStyle.text = null;
	        }
	
	      bg.setStyle(normalStyle);
	      graphic.setElementHoverStyle(bg, emphasisStyle);
	    }
	
	    group.add(bg);
	  }
	
	  function renderContent(group, content) {
	    // For tooltip.
	    content.dataIndex = thisNode.dataIndex;
	    content.seriesIndex = seriesModel.seriesIndex;
	    var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
	    var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
	    content.culling = true;
	    content.setShape({
	      x: borderWidth,
	      y: borderWidth,
	      width: contentWidth,
	      height: contentHeight
	    });
	
	    if (thisInvisible) {
	      // If invisible, do not set visual, otherwise the element will
	      // change immediately before animation. We think it is OK to
	      // remain its origin color when moving out of the view window.
	      processInvisible(content);
	    } else {
	      content.invisible = false;
	      var visualColor = thisNode.getVisual('color', true);
	      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	      normalStyle.fill = visualColor;
	      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
	      prepareText(normalStyle, emphasisStyle, visualColor, contentWidth, contentHeight);
	      content.setStyle(normalStyle);
	      graphic.setElementHoverStyle(content, emphasisStyle);
	    }
	
	    group.add(content);
	  }
	
	  function processInvisible(element) {
	    // Delay invisible setting utill animation finished,
	    // avoid element vanish suddenly before animation.
	    !element.invisible && willInvisibleEls.push(element);
	  }
	
	  function prepareText(normalStyle, emphasisStyle, visualColor, width, height, upperLabelRect) {
	    var defaultText = nodeModel.get('name');
	    var normalLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL);
	    var emphasisLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_EMPHASIS : PATH_LABEL_EMPHASIS);
	    var isShow = normalLabelModel.getShallow('show');
	    graphic.setLabelStyle(normalStyle, emphasisStyle, normalLabelModel, emphasisLabelModel, {
	      defaultText: isShow ? defaultText : null,
	      autoColor: visualColor,
	      isRectText: true,
	      labelFetcher: seriesModel,
	      labelDataIndex: thisNode.dataIndex,
	      labelProp: upperLabelRect ? 'upperLabel' : 'label'
	    });
	    addDrillDownIcon(normalStyle, upperLabelRect, thisLayout);
	    addDrillDownIcon(emphasisStyle, upperLabelRect, thisLayout);
	    upperLabelRect && (normalStyle.textRect = zrUtil.clone(upperLabelRect));
	    normalStyle.truncate = isShow && normalLabelModel.get('ellipsis') ? {
	      outerWidth: width,
	      outerHeight: height,
	      minChar: 2
	    } : null;
	  }
	
	  function addDrillDownIcon(style, upperLabelRect, thisLayout) {
	    var text = style.text;
	
	    if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
	      var iconChar = seriesModel.get('drillDownIcon', true);
	      style.text = iconChar ? iconChar + ' ' + text : text;
	    }
	  }
	
	  function giveGraphic(storageName, Ctor, depth, z) {
	    var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
	    var lasts = lastsForAnimation[storageName];
	
	    if (element) {
	      // Remove from oldStorage
	      oldStorage[storageName][oldRawIndex] = null;
	      prepareAnimationWhenHasOld(lasts, element, storageName);
	    } // If invisible and no old element, do not create new element (for optimizing).
	    else if (!thisInvisible) {
	        element = new Ctor({
	          z: calculateZ(depth, z)
	        });
	        element.__tmDepth = depth;
	        element.__tmStorageName = storageName;
	        prepareAnimationWhenNoOld(lasts, element, storageName);
	      } // Set to thisStorage
	
	
	    return thisStorage[storageName][thisRawIndex] = element;
	  }
	
	  function prepareAnimationWhenHasOld(lasts, element, storageName) {
	    var lastCfg = lasts[thisRawIndex] = {};
	    lastCfg.old = storageName === 'nodeGroup' ? element.position.slice() : zrUtil.extend({}, element.shape);
	  } // If a element is new, we need to find the animation start point carefully,
	  // otherwise it will looks strange when 'zoomToNode'.
	
	
	  function prepareAnimationWhenNoOld(lasts, element, storageName) {
	    var lastCfg = lasts[thisRawIndex] = {};
	    var parentNode = thisNode.parentNode;
	
	    if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
	      var parentOldX = 0;
	      var parentOldY = 0; // New nodes appear from right-bottom corner in 'zoomToNode' animation.
	      // For convenience, get old bounding rect from background.
	
	      var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
	
	      if (!reRoot && parentOldBg && parentOldBg.old) {
	        parentOldX = parentOldBg.old.width;
	        parentOldY = parentOldBg.old.height;
	      } // When no parent old shape found, its parent is new too,
	      // so we can just use {x:0, y:0}.
	
	
	      lastCfg.old = storageName === 'nodeGroup' ? [0, parentOldY] : {
	        x: parentOldX,
	        y: parentOldY,
	        width: 0,
	        height: 0
	      };
	    } // Fade in, user can be aware that these nodes are new.
	
	
	    lastCfg.fadein = storageName !== 'nodeGroup';
	  }
	} // We can not set all backgroud with the same z, Because the behaviour of
	// drill down and roll up differ background creation sequence from tree
	// hierarchy sequence, which cause that lowser background element overlap
	// upper ones. So we calculate z based on depth.
	// Moreover, we try to shrink down z interval to [0, 1] to avoid that
	// treemap with large z overlaps other components.
	
	
	function calculateZ(depth, zInLevel) {
	  var zb = depth * Z_BASE + zInLevel;
	  return (zb - 1) / zb;
	}
	
	module.exports = _default;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var layout = __webpack_require__(305);
	
	var zrUtil = __webpack_require__(220);
	
	var _treeHelper = __webpack_require__(462);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TEXT_PADDING = 8;
	var ITEM_GAP = 8;
	var ARRAY_LENGTH = 5;
	
	function Breadcrumb(containerGroup) {
	  /**
	   * @private
	   * @type {module:zrender/container/Group}
	   */
	  this.group = new graphic.Group();
	  containerGroup.add(this.group);
	}
	
	Breadcrumb.prototype = {
	  constructor: Breadcrumb,
	  render: function (seriesModel, api, targetNode, onSelect) {
	    var model = seriesModel.getModel('breadcrumb');
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	
	    if (!model.get('show') || !targetNode) {
	      return;
	    }
	
	    var normalStyleModel = model.getModel('itemStyle'); // var emphasisStyleModel = model.getModel('emphasis.itemStyle');
	
	    var textStyleModel = normalStyleModel.getModel('textStyle');
	    var layoutParam = {
	      pos: {
	        left: model.get('left'),
	        right: model.get('right'),
	        top: model.get('top'),
	        bottom: model.get('bottom')
	      },
	      box: {
	        width: api.getWidth(),
	        height: api.getHeight()
	      },
	      emptyItemWidth: model.get('emptyItemWidth'),
	      totalWidth: 0,
	      renderList: []
	    };
	
	    this._prepare(targetNode, layoutParam, textStyleModel);
	
	    this._renderContent(seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect);
	
	    layout.positionElement(thisGroup, layoutParam.pos, layoutParam.box);
	  },
	
	  /**
	   * Prepare render list and total width
	   * @private
	   */
	  _prepare: function (targetNode, layoutParam, textStyleModel) {
	    for (var node = targetNode; node; node = node.parentNode) {
	      var text = node.getModel().get('name');
	      var textRect = textStyleModel.getTextRect(text);
	      var itemWidth = Math.max(textRect.width + TEXT_PADDING * 2, layoutParam.emptyItemWidth);
	      layoutParam.totalWidth += itemWidth + ITEM_GAP;
	      layoutParam.renderList.push({
	        node: node,
	        text: text,
	        width: itemWidth
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderContent: function (seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect) {
	    // Start rendering.
	    var lastX = 0;
	    var emptyItemWidth = layoutParam.emptyItemWidth;
	    var height = seriesModel.get('breadcrumb.height');
	    var availableSize = layout.getAvailableSize(layoutParam.pos, layoutParam.box);
	    var totalWidth = layoutParam.totalWidth;
	    var renderList = layoutParam.renderList;
	
	    for (var i = renderList.length - 1; i >= 0; i--) {
	      var item = renderList[i];
	      var itemNode = item.node;
	      var itemWidth = item.width;
	      var text = item.text; // Hdie text and shorten width if necessary.
	
	      if (totalWidth > availableSize.width) {
	        totalWidth -= itemWidth - emptyItemWidth;
	        itemWidth = emptyItemWidth;
	        text = null;
	      }
	
	      var el = new graphic.Polygon({
	        shape: {
	          points: makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
	        },
	        style: zrUtil.defaults(normalStyleModel.getItemStyle(), {
	          lineJoin: 'bevel',
	          text: text,
	          textFill: textStyleModel.getTextColor(),
	          textFont: textStyleModel.getFont()
	        }),
	        z: 10,
	        onclick: zrUtil.curry(onSelect, itemNode)
	      });
	      this.group.add(el);
	      packEventData(el, seriesModel, itemNode);
	      lastX += itemWidth + ITEM_GAP;
	    }
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this.group.removeAll();
	  }
	};
	
	function makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
	  var points = [[head ? x : x - ARRAY_LENGTH, y], [x + itemWidth, y], [x + itemWidth, y + itemHeight], [head ? x : x - ARRAY_LENGTH, y + itemHeight]];
	  !tail && points.splice(2, 0, [x + itemWidth + ARRAY_LENGTH, y + itemHeight / 2]);
	  !head && points.push([x, y + itemHeight / 2]);
	  return points;
	} // Package custom mouse event.
	
	
	function packEventData(el, seriesModel, itemNode) {
	  el.eventData = {
	    componentType: 'series',
	    componentSubType: 'treemap',
	    componentIndex: seriesModel.componentIndex,
	    seriesIndex: seriesModel.componentIndex,
	    seriesName: seriesModel.name,
	    seriesType: 'treemap',
	    selfType: 'breadcrumb',
	    // Distinguish with click event on treemap node.
	    nodeData: {
	      dataIndex: itemNode && itemNode.dataIndex,
	      name: itemNode && itemNode.name
	    },
	    treePathInfo: itemNode && wrapTreePathInfo(itemNode, seriesModel)
	  };
	}
	
	var _default = Breadcrumb;
	module.exports = _default;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {number} [time=500] Time in ms
	 * @param {string} [easing='linear']
	 * @param {number} [delay=0]
	 * @param {Function} [callback]
	 *
	 * @example
	 *  // Animate position
	 *  animation
	 *      .createWrap()
	 *      .add(el1, {position: [10, 10]})
	 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
	 *      .done(function () { // done })
	 *      .start('cubicOut');
	 */
	function createWrap() {
	  var storage = [];
	  var elExistsMap = {};
	  var doneCallback;
	  return {
	    /**
	     * Caution: a el can only be added once, otherwise 'done'
	     * might not be called. This method checks this (by el.id),
	     * suppresses adding and returns false when existing el found.
	     *
	     * @param {modele:zrender/Element} el
	     * @param {Object} target
	     * @param {number} [time=500]
	     * @param {number} [delay=0]
	     * @param {string} [easing='linear']
	     * @return {boolean} Whether adding succeeded.
	     *
	     * @example
	     *     add(el, target, time, delay, easing);
	     *     add(el, target, time, easing);
	     *     add(el, target, time);
	     *     add(el, target);
	     */
	    add: function (el, target, time, delay, easing) {
	      if (zrUtil.isString(delay)) {
	        easing = delay;
	        delay = 0;
	      }
	
	      if (elExistsMap[el.id]) {
	        return false;
	      }
	
	      elExistsMap[el.id] = 1;
	      storage.push({
	        el: el,
	        target: target,
	        time: time,
	        delay: delay,
	        easing: easing
	      });
	      return true;
	    },
	
	    /**
	     * Only execute when animation finished. Will not execute when any
	     * of 'stop' or 'stopAnimation' called.
	     *
	     * @param {Function} callback
	     */
	    done: function (callback) {
	      doneCallback = callback;
	      return this;
	    },
	
	    /**
	     * Will stop exist animation firstly.
	     */
	    start: function () {
	      var count = storage.length;
	
	      for (var i = 0, len = storage.length; i < len; i++) {
	        var item = storage[i];
	        item.el.animateTo(item.target, item.time, item.delay, item.easing, done);
	      }
	
	      return this;
	
	      function done() {
	        count--;
	
	        if (!count) {
	          storage.length = 0;
	          elExistsMap = {};
	          doneCallback && doneCallback();
	        }
	      }
	    }
	  };
	}
	
	exports.createWrap = createWrap;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var helper = __webpack_require__(462);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Treemap action
	 */
	var noop = function () {};
	
	var actionTypes = ['treemapZoomToNode', 'treemapRender', 'treemapMove'];
	
	for (var i = 0; i < actionTypes.length; i++) {
	  echarts.registerAction({
	    type: actionTypes[i],
	    update: 'updateView'
	  }, noop);
	}
	
	echarts.registerAction({
	  type: 'treemapRootToNode',
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'treemap',
	    query: payload
	  }, handleRootToNode);
	
	  function handleRootToNode(model, index) {
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, model);
	
	    if (targetInfo) {
	      var originViewRoot = model.getViewRoot();
	
	      if (originViewRoot) {
	        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	      }
	
	      model.resetViewRoot(targetInfo.node);
	    }
	  }
	});

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var VisualMapping = __webpack_require__(468);
	
	var zrColor = __webpack_require__(238);
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var isArray = zrUtil.isArray;
	var ITEM_STYLE_NORMAL = 'itemStyle';
	var _default = {
	  seriesType: 'treemap',
	  reset: function (seriesModel, ecModel, api, payload) {
	    var tree = seriesModel.getData().tree;
	    var root = tree.root;
	
	    if (root.isRemoved()) {
	      return;
	    }
	
	    travelTree(root, // Visual should calculate from tree root but not view root.
	    {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
	  }
	};
	
	function travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
	  var nodeModel = node.getModel();
	  var nodeLayout = node.getLayout(); // Optimize
	
	  if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) {
	    return;
	  }
	
	  var nodeItemStyleModel = node.getModel(ITEM_STYLE_NORMAL);
	  var visuals = buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel); // calculate border color
	
	  var borderColor = nodeItemStyleModel.get('borderColor');
	  var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
	  var thisNodeColor;
	
	  if (borderColorSaturation != null) {
	    // For performance, do not always execute 'calculateColor'.
	    thisNodeColor = calculateColor(visuals, node);
	    borderColor = calculateBorderColor(borderColorSaturation, thisNodeColor);
	  }
	
	  node.setVisual('borderColor', borderColor);
	  var viewChildren = node.viewChildren;
	
	  if (!viewChildren || !viewChildren.length) {
	    thisNodeColor = calculateColor(visuals, node); // Apply visual to this node.
	
	    node.setVisual('color', thisNodeColor);
	  } else {
	    var mapping = buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren); // Designate visual to children.
	
	    zrUtil.each(viewChildren, function (child, index) {
	      // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
	      if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
	        var childVisual = mapVisual(nodeModel, visuals, child, index, mapping, seriesModel);
	        travelTree(child, childVisual, viewRootAncestors, seriesModel);
	      }
	    });
	  }
	}
	
	function buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
	  var visuals = zrUtil.extend({}, designatedVisual);
	  var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
	  zrUtil.each(['color', 'colorAlpha', 'colorSaturation'], function (visualName) {
	    // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
	    designatedVisualItemStyle[visualName] = designatedVisual[visualName];
	    var val = nodeItemStyleModel.get(visualName);
	    designatedVisualItemStyle[visualName] = null;
	    val != null && (visuals[visualName] = val);
	  });
	  return visuals;
	}
	
	function calculateColor(visuals) {
	  var color = getValueVisualDefine(visuals, 'color');
	
	  if (color) {
	    var colorAlpha = getValueVisualDefine(visuals, 'colorAlpha');
	    var colorSaturation = getValueVisualDefine(visuals, 'colorSaturation');
	
	    if (colorSaturation) {
	      color = zrColor.modifyHSL(color, null, null, colorSaturation);
	    }
	
	    if (colorAlpha) {
	      color = zrColor.modifyAlpha(color, colorAlpha);
	    }
	
	    return color;
	  }
	}
	
	function calculateBorderColor(borderColorSaturation, thisNodeColor) {
	  return thisNodeColor != null ? zrColor.modifyHSL(thisNodeColor, null, null, borderColorSaturation) : null;
	}
	
	function getValueVisualDefine(visuals, name) {
	  var value = visuals[name];
	
	  if (value != null && value !== 'none') {
	    return value;
	  }
	}
	
	function buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
	  if (!viewChildren || !viewChildren.length) {
	    return;
	  }
	
	  var rangeVisual = getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && (getRangeVisual(nodeModel, 'colorAlpha') || getRangeVisual(nodeModel, 'colorSaturation'));
	
	  if (!rangeVisual) {
	    return;
	  }
	
	  var visualMin = nodeModel.get('visualMin');
	  var visualMax = nodeModel.get('visualMax');
	  var dataExtent = nodeLayout.dataExtent.slice();
	  visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
	  visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
	  var colorMappingBy = nodeModel.get('colorMappingBy');
	  var opt = {
	    type: rangeVisual.name,
	    dataExtent: dataExtent,
	    visual: rangeVisual.range
	  };
	
	  if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
	    opt.mappingMethod = 'category';
	    opt.loop = true; // categories is ordinal, so do not set opt.categories.
	  } else {
	    opt.mappingMethod = 'linear';
	  }
	
	  var mapping = new VisualMapping(opt);
	  mapping.__drColorMappingBy = colorMappingBy;
	  return mapping;
	} // Notice: If we dont have the attribute 'colorRange', but only use
	// attribute 'color' to represent both concepts of 'colorRange' and 'color',
	// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
	// this problem will be encountered:
	// If a level-1 node dont have children, and its siblings has children,
	// and colorRange is set on level-1, then the node can not be colored.
	// So we separate 'colorRange' and 'color' to different attributes.
	
	
	function getRangeVisual(nodeModel, name) {
	  // 'colorRange', 'colorARange', 'colorSRange'.
	  // If not exsits on this node, fetch from levels and series.
	  var range = nodeModel.get(name);
	  return isArray(range) && range.length ? {
	    name: name,
	    range: range
	  } : null;
	}
	
	function mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
	  var childVisuals = zrUtil.extend({}, visuals);
	
	  if (mapping) {
	    var mappingType = mapping.type;
	    var colorMappingBy = mappingType === 'color' && mapping.__drColorMappingBy;
	    var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
	    childVisuals[mappingType] = mapping.mapValueToVisual(value);
	  }
	
	  return childVisuals;
	}
	
	module.exports = _default;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var zrColor = __webpack_require__(238);
	
	var _number = __webpack_require__(306);
	
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var CATEGORY_DEFAULT_VISUAL_INDEX = -1;
	/**
	 * @param {Object} option
	 * @param {string} [option.type] See visualHandlers.
	 * @param {string} [option.mappingMethod] 'linear' or 'piecewise' or 'category' or 'fixed'
	 * @param {Array.<number>=} [option.dataExtent] [minExtent, maxExtent],
	 *                                              required when mappingMethod is 'linear'
	 * @param {Array.<Object>=} [option.pieceList] [
	 *                                             {value: someValue},
	 *                                             {interval: [min1, max1], visual: {...}},
	 *                                             {interval: [min2, max2]}
	 *                                             ],
	 *                                            required when mappingMethod is 'piecewise'.
	 *                                            Visual for only each piece can be specified.
	 * @param {Array.<string|Object>=} [option.categories] ['cate1', 'cate2']
	 *                                            required when mappingMethod is 'category'.
	 *                                            If no option.categories, categories is set
	 *                                            as [0, 1, 2, ...].
	 * @param {boolean} [option.loop=false] Whether loop mapping when mappingMethod is 'category'.
	 * @param {(Array|Object|*)} [option.visual]  Visual data.
	 *                                            when mappingMethod is 'category',
	 *                                            visual data can be array or object
	 *                                            (like: {cate1: '#222', none: '#fff'})
	 *                                            or primary types (which represents
	 *                                            default category visual), otherwise visual
	 *                                            can be array or primary (which will be
	 *                                            normalized to array).
	 *
	 */
	
	var VisualMapping = function (option) {
	  var mappingMethod = option.mappingMethod;
	  var visualType = option.type;
	  /**
	   * @readOnly
	   * @type {Object}
	   */
	
	  var thisOption = this.option = zrUtil.clone(option);
	  /**
	   * @readOnly
	   * @type {string}
	   */
	
	  this.type = visualType;
	  /**
	   * @readOnly
	   * @type {string}
	   */
	
	  this.mappingMethod = mappingMethod;
	  /**
	   * @private
	   * @type {Function}
	   */
	
	  this._normalizeData = normalizers[mappingMethod];
	  var visualHandler = visualHandlers[visualType];
	  /**
	   * @public
	   * @type {Function}
	   */
	
	  this.applyVisual = visualHandler.applyVisual;
	  /**
	   * @public
	   * @type {Function}
	   */
	
	  this.getColorMapper = visualHandler.getColorMapper;
	  /**
	   * @private
	   * @type {Function}
	   */
	
	  this._doMap = visualHandler._doMap[mappingMethod];
	
	  if (mappingMethod === 'piecewise') {
	    normalizeVisualRange(thisOption);
	    preprocessForPiecewise(thisOption);
	  } else if (mappingMethod === 'category') {
	    thisOption.categories ? preprocessForSpecifiedCategory(thisOption) // categories is ordinal when thisOption.categories not specified,
	    // which need no more preprocess except normalize visual.
	    : normalizeVisualRange(thisOption, true);
	  } else {
	    // mappingMethod === 'linear' or 'fixed'
	    zrUtil.assert(mappingMethod !== 'linear' || thisOption.dataExtent);
	    normalizeVisualRange(thisOption);
	  }
	};
	
	VisualMapping.prototype = {
	  constructor: VisualMapping,
	  mapValueToVisual: function (value) {
	    var normalized = this._normalizeData(value);
	
	    return this._doMap(normalized, value);
	  },
	  getNormalizer: function () {
	    return zrUtil.bind(this._normalizeData, this);
	  }
	};
	var visualHandlers = VisualMapping.visualHandlers = {
	  color: {
	    applyVisual: makeApplyVisual('color'),
	
	    /**
	     * Create a mapper function
	     * @return {Function}
	     */
	    getColorMapper: function () {
	      var thisOption = this.option;
	      return zrUtil.bind(thisOption.mappingMethod === 'category' ? function (value, isNormalized) {
	        !isNormalized && (value = this._normalizeData(value));
	        return doMapCategory.call(this, value);
	      } : function (value, isNormalized, out) {
	        // If output rgb array
	        // which will be much faster and useful in pixel manipulation
	        var returnRGBArray = !!out;
	        !isNormalized && (value = this._normalizeData(value));
	        out = zrColor.fastLerp(value, thisOption.parsedVisual, out);
	        return returnRGBArray ? out : zrColor.stringify(out, 'rgba');
	      }, this);
	    },
	    _doMap: {
	      linear: function (normalized) {
	        return zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
	      },
	      category: doMapCategory,
	      piecewise: function (normalized, value) {
	        var result = getSpecifiedVisual.call(this, value);
	
	        if (result == null) {
	          result = zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
	        }
	
	        return result;
	      },
	      fixed: doMapFixed
	    }
	  },
	  colorHue: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, value);
	  }),
	  colorSaturation: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, null, value);
	  }),
	  colorLightness: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, null, null, value);
	  }),
	  colorAlpha: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyAlpha(color, value);
	  }),
	  opacity: {
	    applyVisual: makeApplyVisual('opacity'),
	    _doMap: makeDoMap([0, 1])
	  },
	  liftZ: {
	    applyVisual: makeApplyVisual('liftZ'),
	    _doMap: {
	      linear: doMapFixed,
	      category: doMapFixed,
	      piecewise: doMapFixed,
	      fixed: doMapFixed
	    }
	  },
	  symbol: {
	    applyVisual: function (value, getter, setter) {
	      var symbolCfg = this.mapValueToVisual(value);
	
	      if (zrUtil.isString(symbolCfg)) {
	        setter('symbol', symbolCfg);
	      } else if (isObject(symbolCfg)) {
	        for (var name in symbolCfg) {
	          if (symbolCfg.hasOwnProperty(name)) {
	            setter(name, symbolCfg[name]);
	          }
	        }
	      }
	    },
	    _doMap: {
	      linear: doMapToArray,
	      category: doMapCategory,
	      piecewise: function (normalized, value) {
	        var result = getSpecifiedVisual.call(this, value);
	
	        if (result == null) {
	          result = doMapToArray.call(this, normalized);
	        }
	
	        return result;
	      },
	      fixed: doMapFixed
	    }
	  },
	  symbolSize: {
	    applyVisual: makeApplyVisual('symbolSize'),
	    _doMap: makeDoMap([0, 1])
	  }
	};
	
	function preprocessForPiecewise(thisOption) {
	  var pieceList = thisOption.pieceList;
	  thisOption.hasSpecialVisual = false;
	  zrUtil.each(pieceList, function (piece, index) {
	    piece.originIndex = index; // piece.visual is "result visual value" but not
	    // a visual range, so it does not need to be normalized.
	
	    if (piece.visual != null) {
	      thisOption.hasSpecialVisual = true;
	    }
	  });
	}
	
	function preprocessForSpecifiedCategory(thisOption) {
	  // Hash categories.
	  var categories = thisOption.categories;
	  var visual = thisOption.visual;
	  var categoryMap = thisOption.categoryMap = {};
	  each(categories, function (cate, index) {
	    categoryMap[cate] = index;
	  }); // Process visual map input.
	
	  if (!zrUtil.isArray(visual)) {
	    var visualArr = [];
	
	    if (zrUtil.isObject(visual)) {
	      each(visual, function (v, cate) {
	        var index = categoryMap[cate];
	        visualArr[index != null ? index : CATEGORY_DEFAULT_VISUAL_INDEX] = v;
	      });
	    } else {
	      // Is primary type, represents default visual.
	      visualArr[CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
	    }
	
	    visual = setVisualToOption(thisOption, visualArr);
	  } // Remove categories that has no visual,
	  // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
	
	
	  for (var i = categories.length - 1; i >= 0; i--) {
	    if (visual[i] == null) {
	      delete categoryMap[categories[i]];
	      categories.pop();
	    }
	  }
	}
	
	function normalizeVisualRange(thisOption, isCategory) {
	  var visual = thisOption.visual;
	  var visualArr = [];
	
	  if (zrUtil.isObject(visual)) {
	    each(visual, function (v) {
	      visualArr.push(v);
	    });
	  } else if (visual != null) {
	    visualArr.push(visual);
	  }
	
	  var doNotNeedPair = {
	    color: 1,
	    symbol: 1
	  };
	
	  if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) {
	    // Do not care visualArr.length === 0, which is illegal.
	    visualArr[1] = visualArr[0];
	  }
	
	  setVisualToOption(thisOption, visualArr);
	}
	
	function makePartialColorVisualHandler(applyValue) {
	  return {
	    applyVisual: function (value, getter, setter) {
	      value = this.mapValueToVisual(value); // Must not be array value
	
	      setter('color', applyValue(getter('color'), value));
	    },
	    _doMap: makeDoMap([0, 1])
	  };
	}
	
	function doMapToArray(normalized) {
	  var visual = this.option.visual;
	  return visual[Math.round(linearMap(normalized, [0, 1], [0, visual.length - 1], true))] || {};
	}
	
	function makeApplyVisual(visualType) {
	  return function (value, getter, setter) {
	    setter(visualType, this.mapValueToVisual(value));
	  };
	}
	
	function doMapCategory(normalized) {
	  var visual = this.option.visual;
	  return visual[this.option.loop && normalized !== CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
	}
	
	function doMapFixed() {
	  return this.option.visual[0];
	}
	
	function makeDoMap(sourceExtent) {
	  return {
	    linear: function (normalized) {
	      return linearMap(normalized, sourceExtent, this.option.visual, true);
	    },
	    category: doMapCategory,
	    piecewise: function (normalized, value) {
	      var result = getSpecifiedVisual.call(this, value);
	
	      if (result == null) {
	        result = linearMap(normalized, sourceExtent, this.option.visual, true);
	      }
	
	      return result;
	    },
	    fixed: doMapFixed
	  };
	}
	
	function getSpecifiedVisual(value) {
	  var thisOption = this.option;
	  var pieceList = thisOption.pieceList;
	
	  if (thisOption.hasSpecialVisual) {
	    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList);
	    var piece = pieceList[pieceIndex];
	
	    if (piece && piece.visual) {
	      return piece.visual[this.type];
	    }
	  }
	}
	
	function setVisualToOption(thisOption, visualArr) {
	  thisOption.visual = visualArr;
	
	  if (thisOption.type === 'color') {
	    thisOption.parsedVisual = zrUtil.map(visualArr, function (item) {
	      return zrColor.parse(item);
	    });
	  }
	
	  return visualArr;
	}
	/**
	 * Normalizers by mapping methods.
	 */
	
	
	var normalizers = {
	  linear: function (value) {
	    return linearMap(value, this.option.dataExtent, [0, 1], true);
	  },
	  piecewise: function (value) {
	    var pieceList = this.option.pieceList;
	    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList, true);
	
	    if (pieceIndex != null) {
	      return linearMap(pieceIndex, [0, pieceList.length - 1], [0, 1], true);
	    }
	  },
	  category: function (value) {
	    var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal
	
	    return index == null ? CATEGORY_DEFAULT_VISUAL_INDEX : index;
	  },
	  fixed: zrUtil.noop
	};
	/**
	 * List available visual types.
	 *
	 * @public
	 * @return {Array.<string>}
	 */
	
	VisualMapping.listVisualTypes = function () {
	  var visualTypes = [];
	  zrUtil.each(visualHandlers, function (handler, key) {
	    visualTypes.push(key);
	  });
	  return visualTypes;
	};
	/**
	 * @public
	 */
	
	
	VisualMapping.addVisualHandler = function (name, handler) {
	  visualHandlers[name] = handler;
	};
	/**
	 * @public
	 */
	
	
	VisualMapping.isValidType = function (visualType) {
	  return visualHandlers.hasOwnProperty(visualType);
	};
	/**
	 * Convinent method.
	 * Visual can be Object or Array or primary type.
	 *
	 * @public
	 */
	
	
	VisualMapping.eachVisual = function (visual, callback, context) {
	  if (zrUtil.isObject(visual)) {
	    zrUtil.each(visual, callback, context);
	  } else {
	    callback.call(context, visual);
	  }
	};
	
	VisualMapping.mapVisual = function (visual, callback, context) {
	  var isPrimary;
	  var newVisual = zrUtil.isArray(visual) ? [] : zrUtil.isObject(visual) ? {} : (isPrimary = true, null);
	  VisualMapping.eachVisual(visual, function (v, key) {
	    var newVal = callback.call(context, v, key);
	    isPrimary ? newVisual = newVal : newVisual[key] = newVal;
	  });
	  return newVisual;
	};
	/**
	 * @public
	 * @param {Object} obj
	 * @return {Object} new object containers visual values.
	 *                 If no visuals, return null.
	 */
	
	
	VisualMapping.retrieveVisuals = function (obj) {
	  var ret = {};
	  var hasVisual;
	  obj && each(visualHandlers, function (h, visualType) {
	    if (obj.hasOwnProperty(visualType)) {
	      ret[visualType] = obj[visualType];
	      hasVisual = true;
	    }
	  });
	  return hasVisual ? ret : null;
	};
	/**
	 * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
	 *
	 * @public
	 * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
	 *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
	 * @return {Array.<string>} Sorted visual types.
	 */
	
	
	VisualMapping.prepareVisualTypes = function (visualTypes) {
	  if (isObject(visualTypes)) {
	    var types = [];
	    each(visualTypes, function (item, type) {
	      types.push(type);
	    });
	    visualTypes = types;
	  } else if (zrUtil.isArray(visualTypes)) {
	    visualTypes = visualTypes.slice();
	  } else {
	    return [];
	  }
	
	  visualTypes.sort(function (type1, type2) {
	    // color should be front of colorSaturation, colorAlpha, ...
	    // symbol and symbolSize do not matter.
	    return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
	  });
	  return visualTypes;
	};
	/**
	 * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
	 * Other visuals are only depends on themself.
	 *
	 * @public
	 * @param {string} visualType1
	 * @param {string} visualType2
	 * @return {boolean}
	 */
	
	
	VisualMapping.dependsOn = function (visualType1, visualType2) {
	  return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
	};
	/**
	 * @param {number} value
	 * @param {Array.<Object>} pieceList [{value: ..., interval: [min, max]}, ...]
	 *                         Always from small to big.
	 * @param {boolean} [findClosestWhenOutside=false]
	 * @return {number} index
	 */
	
	
	VisualMapping.findPieceIndex = function (value, pieceList, findClosestWhenOutside) {
	  var possibleI;
	  var abs = Infinity; // value has the higher priority.
	
	  for (var i = 0, len = pieceList.length; i < len; i++) {
	    var pieceValue = pieceList[i].value;
	
	    if (pieceValue != null) {
	      if (pieceValue === value // FIXME
	      // It is supposed to compare value according to value type of dimension,
	      // but currently value type can exactly be string or number.
	      // Compromise for numeric-like string (like '12'), especially
	      // in the case that visualMap.categories is ['22', '33'].
	      || typeof pieceValue === 'string' && pieceValue === value + '') {
	        return i;
	      }
	
	      findClosestWhenOutside && updatePossible(pieceValue, i);
	    }
	  }
	
	  for (var i = 0, len = pieceList.length; i < len; i++) {
	    var piece = pieceList[i];
	    var interval = piece.interval;
	    var close = piece.close;
	
	    if (interval) {
	      if (interval[0] === -Infinity) {
	        if (littleThan(close[1], value, interval[1])) {
	          return i;
	        }
	      } else if (interval[1] === Infinity) {
	        if (littleThan(close[0], interval[0], value)) {
	          return i;
	        }
	      } else if (littleThan(close[0], interval[0], value) && littleThan(close[1], value, interval[1])) {
	        return i;
	      }
	
	      findClosestWhenOutside && updatePossible(interval[0], i);
	      findClosestWhenOutside && updatePossible(interval[1], i);
	    }
	  }
	
	  if (findClosestWhenOutside) {
	    return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
	  }
	
	  function updatePossible(val, index) {
	    var newAbs = Math.abs(val - value);
	
	    if (newAbs < abs) {
	      abs = newAbs;
	      possibleI = index;
	    }
	  }
	};
	
	function littleThan(close, a, b) {
	  return close ? a <= b : a < b;
	}
	
	var _default = VisualMapping;
	module.exports = _default;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var BoundingRect = __webpack_require__(242);
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	var MAX_SAFE_INTEGER = _number.MAX_SAFE_INTEGER;
	
	var layout = __webpack_require__(305);
	
	var helper = __webpack_require__(462);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The treemap layout implementation was originally copied from
	* "d3.js" with some modifications made for this project.
	* (See more details in the comment of the method "squarify" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var mathMax = Math.max;
	var mathMin = Math.min;
	var retrieveValue = zrUtil.retrieve;
	var each = zrUtil.each;
	var PATH_BORDER_WIDTH = ['itemStyle', 'borderWidth'];
	var PATH_GAP_WIDTH = ['itemStyle', 'gapWidth'];
	var PATH_UPPER_LABEL_SHOW = ['upperLabel', 'show'];
	var PATH_UPPER_LABEL_HEIGHT = ['upperLabel', 'height'];
	/**
	 * @public
	 */
	
	var _default = {
	  seriesType: 'treemap',
	  reset: function (seriesModel, ecModel, api, payload) {
	    // Layout result in each node:
	    // {x, y, width, height, area, borderWidth}
	    var ecWidth = api.getWidth();
	    var ecHeight = api.getHeight();
	    var seriesOption = seriesModel.option;
	    var layoutInfo = layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	    var size = seriesOption.size || []; // Compatible with ec2.
	
	    var containerWidth = parsePercent(retrieveValue(layoutInfo.width, size[0]), ecWidth);
	    var containerHeight = parsePercent(retrieveValue(layoutInfo.height, size[1]), ecHeight); // Fetch payload info.
	
	    var payloadType = payload && payload.type;
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, seriesModel);
	    var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
	    var viewRoot = seriesModel.getViewRoot();
	    var viewAbovePath = helper.getPathToRoot(viewRoot);
	
	    if (payloadType !== 'treemapMove') {
	      var rootSize = payloadType === 'treemapZoomToNode' ? estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [rootRect.width, rootRect.height] : [containerWidth, containerHeight];
	      var sort = seriesOption.sort;
	
	      if (sort && sort !== 'asc' && sort !== 'desc') {
	        sort = 'desc';
	      }
	
	      var options = {
	        squareRatio: seriesOption.squareRatio,
	        sort: sort,
	        leafDepth: seriesOption.leafDepth
	      }; // layout should be cleared because using updateView but not update.
	
	      viewRoot.hostTree.clearLayouts(); // TODO
	      // optimize: if out of view clip, do not layout.
	      // But take care that if do not render node out of view clip,
	      // how to calculate start po
	
	      var viewRootLayout = {
	        x: 0,
	        y: 0,
	        width: rootSize[0],
	        height: rootSize[1],
	        area: rootSize[0] * rootSize[1]
	      };
	      viewRoot.setLayout(viewRootLayout);
	      squarify(viewRoot, options, false, 0); // Supplement layout.
	
	      var viewRootLayout = viewRoot.getLayout();
	      each(viewAbovePath, function (node, index) {
	        var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
	        node.setLayout(zrUtil.extend({
	          dataExtent: [childValue, childValue],
	          borderWidth: 0,
	          upperHeight: 0
	        }, viewRootLayout));
	      });
	    }
	
	    var treeRoot = seriesModel.getData().tree.root;
	    treeRoot.setLayout(calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
	    seriesModel.setLayoutInfo(layoutInfo); // FIXME
	    // 现在没有clip功能，暂时取ec高宽。
	
	    prunning(treeRoot, // Transform to base element coordinate system.
	    new BoundingRect(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
	  }
	};
	/**
	 * Layout treemap with squarify algorithm.
	 * The original presentation of this algorithm
	 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
	 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
	 * The implementation of this algorithm was originally copied from "d3.js"
	 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * @protected
	 * @param {module:echarts/data/Tree~TreeNode} node
	 * @param {Object} options
	 * @param {string} options.sort 'asc' or 'desc'
	 * @param {number} options.squareRatio
	 * @param {boolean} hideChildren
	 * @param {number} depth
	 */
	
	function squarify(node, options, hideChildren, depth) {
	  var width;
	  var height;
	
	  if (node.isRemoved()) {
	    return;
	  }
	
	  var thisLayout = node.getLayout();
	  width = thisLayout.width;
	  height = thisLayout.height; // Considering border and gap
	
	  var nodeModel = node.getModel();
	  var borderWidth = nodeModel.get(PATH_BORDER_WIDTH);
	  var halfGapWidth = nodeModel.get(PATH_GAP_WIDTH) / 2;
	  var upperLabelHeight = getUpperLabelHeight(nodeModel);
	  var upperHeight = Math.max(borderWidth, upperLabelHeight);
	  var layoutOffset = borderWidth - halfGapWidth;
	  var layoutOffsetUpper = upperHeight - halfGapWidth;
	  var nodeModel = node.getModel();
	  node.setLayout({
	    borderWidth: borderWidth,
	    upperHeight: upperHeight,
	    upperLabelHeight: upperLabelHeight
	  }, true);
	  width = mathMax(width - 2 * layoutOffset, 0);
	  height = mathMax(height - layoutOffset - layoutOffsetUpper, 0);
	  var totalArea = width * height;
	  var viewChildren = initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
	
	  if (!viewChildren.length) {
	    return;
	  }
	
	  var rect = {
	    x: layoutOffset,
	    y: layoutOffsetUpper,
	    width: width,
	    height: height
	  };
	  var rowFixedLength = mathMin(width, height);
	  var best = Infinity; // the best row score so far
	
	  var row = [];
	  row.area = 0;
	
	  for (var i = 0, len = viewChildren.length; i < len;) {
	    var child = viewChildren[i];
	    row.push(child);
	    row.area += child.getLayout().area;
	    var score = worst(row, rowFixedLength, options.squareRatio); // continue with this orientation
	
	    if (score <= best) {
	      i++;
	      best = score;
	    } // abort, and try a different orientation
	    else {
	        row.area -= row.pop().getLayout().area;
	        position(row, rowFixedLength, rect, halfGapWidth, false);
	        rowFixedLength = mathMin(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	  }
	
	  if (row.length) {
	    position(row, rowFixedLength, rect, halfGapWidth, true);
	  }
	
	  if (!hideChildren) {
	    var childrenVisibleMin = nodeModel.get('childrenVisibleMin');
	
	    if (childrenVisibleMin != null && totalArea < childrenVisibleMin) {
	      hideChildren = true;
	    }
	  }
	
	  for (var i = 0, len = viewChildren.length; i < len; i++) {
	    squarify(viewChildren[i], options, hideChildren, depth + 1);
	  }
	}
	/**
	 * Set area to each child, and calculate data extent for visual coding.
	 */
	
	
	function initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
	  var viewChildren = node.children || [];
	  var orderBy = options.sort;
	  orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
	  var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth; // leafDepth has higher priority.
	
	  if (hideChildren && !overLeafDepth) {
	    return node.viewChildren = [];
	  } // Sort children, order by desc.
	
	
	  viewChildren = zrUtil.filter(viewChildren, function (child) {
	    return !child.isRemoved();
	  });
	  sort(viewChildren, orderBy);
	  var info = statistic(nodeModel, viewChildren, orderBy);
	
	  if (info.sum === 0) {
	    return node.viewChildren = [];
	  }
	
	  info.sum = filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
	
	  if (info.sum === 0) {
	    return node.viewChildren = [];
	  } // Set area to each child.
	
	
	  for (var i = 0, len = viewChildren.length; i < len; i++) {
	    var area = viewChildren[i].getValue() / info.sum * totalArea; // Do not use setLayout({...}, true), because it is needed to clear last layout.
	
	    viewChildren[i].setLayout({
	      area: area
	    });
	  }
	
	  if (overLeafDepth) {
	    viewChildren.length && node.setLayout({
	      isLeafRoot: true
	    }, true);
	    viewChildren.length = 0;
	  }
	
	  node.viewChildren = viewChildren;
	  node.setLayout({
	    dataExtent: info.dataExtent
	  }, true);
	  return viewChildren;
	}
	/**
	 * Consider 'visibleMin'. Modify viewChildren and get new sum.
	 */
	
	
	function filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
	  // visibleMin is not supported yet when no option.sort.
	  if (!orderBy) {
	    return sum;
	  }
	
	  var visibleMin = nodeModel.get('visibleMin');
	  var len = orderedChildren.length;
	  var deletePoint = len; // Always travel from little value to big value.
	
	  for (var i = len - 1; i >= 0; i--) {
	    var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();
	
	    if (value / sum * totalArea < visibleMin) {
	      deletePoint = i;
	      sum -= value;
	    }
	  }
	
	  orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
	  return sum;
	}
	/**
	 * Sort
	 */
	
	
	function sort(viewChildren, orderBy) {
	  if (orderBy) {
	    viewChildren.sort(function (a, b) {
	      var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
	      return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
	    });
	  }
	
	  return viewChildren;
	}
	/**
	 * Statistic
	 */
	
	
	function statistic(nodeModel, children, orderBy) {
	  // Calculate sum.
	  var sum = 0;
	
	  for (var i = 0, len = children.length; i < len; i++) {
	    sum += children[i].getValue();
	  } // Statistic data extent for latter visual coding.
	  // Notice: data extent should be calculate based on raw children
	  // but not filtered view children, otherwise visual mapping will not
	  // be stable when zoom (where children is filtered by visibleMin).
	
	
	  var dimension = nodeModel.get('visualDimension');
	  var dataExtent; // The same as area dimension.
	
	  if (!children || !children.length) {
	    dataExtent = [NaN, NaN];
	  } else if (dimension === 'value' && orderBy) {
	    dataExtent = [children[children.length - 1].getValue(), children[0].getValue()];
	    orderBy === 'asc' && dataExtent.reverse();
	  } // Other dimension.
	  else {
	      var dataExtent = [Infinity, -Infinity];
	      each(children, function (child) {
	        var value = child.getValue(dimension);
	        value < dataExtent[0] && (dataExtent[0] = value);
	        value > dataExtent[1] && (dataExtent[1] = value);
	      });
	    }
	
	  return {
	    sum: sum,
	    dataExtent: dataExtent
	  };
	}
	/**
	 * Computes the score for the specified row,
	 * as the worst aspect ratio.
	 */
	
	
	function worst(row, rowFixedLength, ratio) {
	  var areaMax = 0;
	  var areaMin = Infinity;
	
	  for (var i = 0, area, len = row.length; i < len; i++) {
	    area = row[i].getLayout().area;
	
	    if (area) {
	      area < areaMin && (areaMin = area);
	      area > areaMax && (areaMax = area);
	    }
	  }
	
	  var squareArea = row.area * row.area;
	  var f = rowFixedLength * rowFixedLength * ratio;
	  return squareArea ? mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
	}
	/**
	 * Positions the specified row of nodes. Modifies `rect`.
	 */
	
	
	function position(row, rowFixedLength, rect, halfGapWidth, flush) {
	  // When rowFixedLength === rect.width,
	  // it is horizontal subdivision,
	  // rowFixedLength is the width of the subdivision,
	  // rowOtherLength is the height of the subdivision,
	  // and nodes will be positioned from left to right.
	  // wh[idx0WhenH] means: when horizontal,
	  //      wh[idx0WhenH] => wh[0] => 'width'.
	  //      xy[idx1WhenH] => xy[1] => 'y'.
	  var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
	  var idx1WhenH = 1 - idx0WhenH;
	  var xy = ['x', 'y'];
	  var wh = ['width', 'height'];
	  var last = rect[xy[idx0WhenH]];
	  var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
	
	  if (flush || rowOtherLength > rect[wh[idx1WhenH]]) {
	    rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
	  }
	
	  for (var i = 0, rowLen = row.length; i < rowLen; i++) {
	    var node = row[i];
	    var nodeLayout = {};
	    var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
	    var wh1 = nodeLayout[wh[idx1WhenH]] = mathMax(rowOtherLength - 2 * halfGapWidth, 0); // We use Math.max/min to avoid negative width/height when considering gap width.
	
	    var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
	    var modWH = i === rowLen - 1 || remain < step ? remain : step;
	    var wh0 = nodeLayout[wh[idx0WhenH]] = mathMax(modWH - 2 * halfGapWidth, 0);
	    nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + mathMin(halfGapWidth, wh1 / 2);
	    nodeLayout[xy[idx0WhenH]] = last + mathMin(halfGapWidth, wh0 / 2);
	    last += modWH;
	    node.setLayout(nodeLayout, true);
	  }
	
	  rect[xy[idx1WhenH]] += rowOtherLength;
	  rect[wh[idx1WhenH]] -= rowOtherLength;
	} // Return [containerWidth, containerHeight] as default.
	
	
	function estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
	  // If targetInfo.node exists, we zoom to the node,
	  // so estimate whold width and heigth by target node.
	  var currNode = (targetInfo || {}).node;
	  var defaultSize = [containerWidth, containerHeight];
	
	  if (!currNode || currNode === viewRoot) {
	    return defaultSize;
	  }
	
	  var parent;
	  var viewArea = containerWidth * containerHeight;
	  var area = viewArea * seriesModel.option.zoomToNodeRatio;
	
	  while (parent = currNode.parentNode) {
	    // jshint ignore:line
	    var sum = 0;
	    var siblings = parent.children;
	
	    for (var i = 0, len = siblings.length; i < len; i++) {
	      sum += siblings[i].getValue();
	    }
	
	    var currNodeValue = currNode.getValue();
	
	    if (currNodeValue === 0) {
	      return defaultSize;
	    }
	
	    area *= sum / currNodeValue; // Considering border, suppose aspect ratio is 1.
	
	    var parentModel = parent.getModel();
	    var borderWidth = parentModel.get(PATH_BORDER_WIDTH);
	    var upperHeight = Math.max(borderWidth, getUpperLabelHeight(parentModel, borderWidth));
	    area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
	    area > MAX_SAFE_INTEGER && (area = MAX_SAFE_INTEGER);
	    currNode = parent;
	  }
	
	  area < viewArea && (area = viewArea);
	  var scale = Math.pow(area / viewArea, 0.5);
	  return [containerWidth * scale, containerHeight * scale];
	} // Root postion base on coord of containerGroup
	
	
	function calculateRootPosition(layoutInfo, rootRect, targetInfo) {
	  if (rootRect) {
	    return {
	      x: rootRect.x,
	      y: rootRect.y
	    };
	  }
	
	  var defaultPosition = {
	    x: 0,
	    y: 0
	  };
	
	  if (!targetInfo) {
	    return defaultPosition;
	  } // If targetInfo is fetched by 'retrieveTargetInfo',
	  // old tree and new tree are the same tree,
	  // so the node still exists and we can visit it.
	
	
	  var targetNode = targetInfo.node;
	  var layout = targetNode.getLayout();
	
	  if (!layout) {
	    return defaultPosition;
	  } // Transform coord from local to container.
	
	
	  var targetCenter = [layout.width / 2, layout.height / 2];
	  var node = targetNode;
	
	  while (node) {
	    var nodeLayout = node.getLayout();
	    targetCenter[0] += nodeLayout.x;
	    targetCenter[1] += nodeLayout.y;
	    node = node.parentNode;
	  }
	
	  return {
	    x: layoutInfo.width / 2 - targetCenter[0],
	    y: layoutInfo.height / 2 - targetCenter[1]
	  };
	} // Mark nodes visible for prunning when visual coding and rendering.
	// Prunning depends on layout and root position, so we have to do it after layout.
	
	
	function prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
	  var nodeLayout = node.getLayout();
	  var nodeInViewAbovePath = viewAbovePath[depth];
	  var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
	
	  if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) {
	    return;
	  }
	
	  node.setLayout({
	    // isInView means: viewRoot sub tree + viewAbovePath
	    isInView: true,
	    // invisible only means: outside view clip so that the node can not
	    // see but still layout for animation preparation but not render.
	    invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
	    isAboveViewRoot: isAboveViewRoot
	  }, true); // Transform to child coordinate.
	
	  var childClipRect = new BoundingRect(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
	  each(node.viewChildren || [], function (child) {
	    prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
	  });
	}
	
	function getUpperLabelHeight(model) {
	  return model.get(PATH_UPPER_LABEL_SHOW) ? model.get(PATH_UPPER_LABEL_HEIGHT) : 0;
	}
	
	module.exports = _default;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(471);
	
	__webpack_require__(475);
	
	__webpack_require__(481);
	
	var categoryFilter = __webpack_require__(483);
	
	var visualSymbol = __webpack_require__(376);
	
	var categoryVisual = __webpack_require__(484);
	
	var edgeVisual = __webpack_require__(485);
	
	var simpleLayout = __webpack_require__(486);
	
	var circularLayout = __webpack_require__(488);
	
	var forceLayout = __webpack_require__(490);
	
	var createView = __webpack_require__(492);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerProcessor(categoryFilter);
	echarts.registerVisual(visualSymbol('graph', 'circle', null));
	echarts.registerVisual(categoryVisual);
	echarts.registerVisual(edgeVisual);
	echarts.registerLayout(simpleLayout);
	echarts.registerLayout(echarts.PRIORITY.VISUAL.POST_CHART_LAYOUT, circularLayout);
	echarts.registerLayout(forceLayout); // Graph view coordinate system
	
	echarts.registerCoordinateSystem('graphView', {
	  create: createView
	});

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var List = __webpack_require__(342);
	
	var zrUtil = __webpack_require__(220);
	
	var _model = __webpack_require__(261);
	
	var defaultEmphasis = _model.defaultEmphasis;
	
	var Model = __webpack_require__(262);
	
	var _format = __webpack_require__(307);
	
	var encodeHTML = _format.encodeHTML;
	
	var createGraphFromNodeEdge = __webpack_require__(472);
	
	var LegendVisualProvider = __webpack_require__(406);
	
	var _multipleGraphEdgeHelper = __webpack_require__(474);
	
	var initCurvenessList = _multipleGraphEdgeHelper.initCurvenessList;
	var createEdgeMapForCurveness = _multipleGraphEdgeHelper.createEdgeMapForCurveness;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GraphSeries = echarts.extendSeriesModel({
	  type: 'series.graph',
	  init: function (option) {
	    GraphSeries.superApply(this, 'init', arguments);
	    var self = this;
	
	    function getCategoriesData() {
	      return self._categoriesData;
	    } // Provide data for legend select
	
	
	    this.legendVisualProvider = new LegendVisualProvider(getCategoriesData, getCategoriesData);
	    this.fillDataTextStyle(option.edges || option.links);
	
	    this._updateCategoriesData();
	  },
	  mergeOption: function (option) {
	    GraphSeries.superApply(this, 'mergeOption', arguments);
	    this.fillDataTextStyle(option.edges || option.links);
	
	    this._updateCategoriesData();
	  },
	  mergeDefaultAndTheme: function (option) {
	    GraphSeries.superApply(this, 'mergeDefaultAndTheme', arguments);
	    defaultEmphasis(option, ['edgeLabel'], ['show']);
	  },
	  getInitialData: function (option, ecModel) {
	    var edges = option.edges || option.links || [];
	    var nodes = option.data || option.nodes || [];
	    var self = this;
	
	    if (nodes && edges) {
	      // auto curveness
	      initCurvenessList(this);
	      var graph = createGraphFromNodeEdge(nodes, edges, this, true, beforeLink);
	      zrUtil.each(graph.edges, function (edge) {
	        createEdgeMapForCurveness(edge.node1, edge.node2, this, edge.dataIndex);
	      }, this);
	      return graph.data;
	    }
	
	    function beforeLink(nodeData, edgeData) {
	      // Overwrite nodeData.getItemModel to
	      nodeData.wrapMethod('getItemModel', function (model) {
	        var categoriesModels = self._categoriesModels;
	        var categoryIdx = model.getShallow('category');
	        var categoryModel = categoriesModels[categoryIdx];
	
	        if (categoryModel) {
	          categoryModel.parentModel = model.parentModel;
	          model.parentModel = categoryModel;
	        }
	
	        return model;
	      });
	      var edgeLabelModel = self.getModel('edgeLabel'); // For option `edgeLabel` can be found by label.xxx.xxx on item mode.
	
	      var fakeSeriesModel = new Model({
	        label: edgeLabelModel.option
	      }, edgeLabelModel.parentModel, ecModel);
	      var emphasisEdgeLabelModel = self.getModel('emphasis.edgeLabel');
	      var emphasisFakeSeriesModel = new Model({
	        emphasis: {
	          label: emphasisEdgeLabelModel.option
	        }
	      }, emphasisEdgeLabelModel.parentModel, ecModel);
	      edgeData.wrapMethod('getItemModel', function (model) {
	        model.customizeGetParent(edgeGetParent);
	        return model;
	      });
	
	      function edgeGetParent(path) {
	        path = this.parsePath(path);
	        return path && path[0] === 'label' ? fakeSeriesModel : path && path[0] === 'emphasis' && path[1] === 'label' ? emphasisFakeSeriesModel : this.parentModel;
	      }
	    }
	  },
	
	  /**
	   * @return {module:echarts/data/Graph}
	   */
	  getGraph: function () {
	    return this.getData().graph;
	  },
	
	  /**
	   * @return {module:echarts/data/List}
	   */
	  getEdgeData: function () {
	    return this.getGraph().edgeData;
	  },
	
	  /**
	   * @return {module:echarts/data/List}
	   */
	  getCategoriesData: function () {
	    return this._categoriesData;
	  },
	
	  /**
	   * @override
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    if (dataType === 'edge') {
	      var nodeData = this.getData();
	      var params = this.getDataParams(dataIndex, dataType);
	      var edge = nodeData.graph.getEdgeByIndex(dataIndex);
	      var sourceName = nodeData.getName(edge.node1.dataIndex);
	      var targetName = nodeData.getName(edge.node2.dataIndex);
	      var html = [];
	      sourceName != null && html.push(sourceName);
	      targetName != null && html.push(targetName);
	      html = encodeHTML(html.join(' > '));
	
	      if (params.value) {
	        html += ' : ' + encodeHTML(params.value);
	      }
	
	      return html;
	    } else {
	      // dataType === 'node' or empty
	      return GraphSeries.superApply(this, 'formatTooltip', arguments);
	    }
	  },
	  _updateCategoriesData: function () {
	    var categories = zrUtil.map(this.option.categories || [], function (category) {
	      // Data must has value
	      return category.value != null ? category : zrUtil.extend({
	        value: 0
	      }, category);
	    });
	    var categoriesData = new List(['value'], this);
	    categoriesData.initData(categories);
	    this._categoriesData = categoriesData;
	    this._categoriesModels = categoriesData.mapArray(function (idx) {
	      return categoriesData.getItemModel(idx, true);
	    });
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	  isAnimationEnabled: function () {
	    return GraphSeries.superCall(this, 'isAnimationEnabled') // Not enable animation when do force layout
	    && !(this.get('layout') === 'force' && this.get('force.layoutAnimation'));
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    // Default option for all coordinate systems
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // polarIndex: 0,
	    // geoIndex: 0,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    layout: null,
	    focusNodeAdjacency: false,
	    // Configuration of circular layout
	    circular: {
	      rotateLabel: false
	    },
	    // Configuration of force directed layout
	    force: {
	      initLayout: null,
	      // Node repulsion. Can be an array to represent range.
	      repulsion: [0, 50],
	      gravity: 0.1,
	      // Initial friction
	      friction: 0.6,
	      // Edge length. Can be an array to represent range.
	      edgeLength: 30,
	      layoutAnimation: true
	    },
	    left: 'center',
	    top: 'center',
	    // right: null,
	    // bottom: null,
	    // width: '80%',
	    // height: '80%',
	    symbol: 'circle',
	    symbolSize: 10,
	    edgeSymbol: ['none', 'none'],
	    edgeSymbolSize: 10,
	    edgeLabel: {
	      position: 'middle',
	      distance: 5
	    },
	    draggable: false,
	    roam: false,
	    // Default on center of graph
	    center: null,
	    zoom: 1,
	    // Symbol size scale ratio in roam
	    nodeScaleRatio: 0.6,
	    // cursor: null,
	    // categories: [],
	    // data: []
	    // Or
	    // nodes: []
	    //
	    // links: []
	    // Or
	    // edges: []
	    label: {
	      show: false,
	      formatter: '{b}'
	    },
	    itemStyle: {},
	    lineStyle: {
	      color: '#aaa',
	      width: 1,
	      opacity: 0.5
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = GraphSeries;
	module.exports = _default;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var List = __webpack_require__(342);
	
	var Graph = __webpack_require__(473);
	
	var linkList = __webpack_require__(454);
	
	var createDimensions = __webpack_require__(346);
	
	var CoordinateSystem = __webpack_require__(315);
	
	var createListFromArray = __webpack_require__(341);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(nodes, edges, seriesModel, directed, beforeLink) {
	  // ??? TODO
	  // support dataset?
	  var graph = new Graph(directed);
	
	  for (var i = 0; i < nodes.length; i++) {
	    graph.addNode(zrUtil.retrieve( // Id, name, dataIndex
	    nodes[i].id, nodes[i].name, i), i);
	  }
	
	  var linkNameList = [];
	  var validEdges = [];
	  var linkCount = 0;
	
	  for (var i = 0; i < edges.length; i++) {
	    var link = edges[i];
	    var source = link.source;
	    var target = link.target; // addEdge may fail when source or target not exists
	
	    if (graph.addEdge(source, target, linkCount)) {
	      validEdges.push(link);
	      linkNameList.push(zrUtil.retrieve(link.id, source + ' > ' + target));
	      linkCount++;
	    }
	  }
	
	  var coordSys = seriesModel.get('coordinateSystem');
	  var nodeData;
	
	  if (coordSys === 'cartesian2d' || coordSys === 'polar') {
	    nodeData = createListFromArray(nodes, seriesModel);
	  } else {
	    var coordSysCtor = CoordinateSystem.get(coordSys);
	    var coordDimensions = coordSysCtor && coordSysCtor.type !== 'view' ? coordSysCtor.dimensions || [] : []; // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
	    // `value` dimension, but graph need `value` dimension. It's better to
	    // uniform this behavior.
	
	    if (zrUtil.indexOf(coordDimensions, 'value') < 0) {
	      coordDimensions.concat(['value']);
	    }
	
	    var dimensionNames = createDimensions(nodes, {
	      coordDimensions: coordDimensions
	    });
	    nodeData = new List(dimensionNames, seriesModel);
	    nodeData.initData(nodes);
	  }
	
	  var edgeData = new List(['value'], seriesModel);
	  edgeData.initData(validEdges, linkNameList);
	  beforeLink && beforeLink(nodeData, edgeData);
	  linkList({
	    mainData: nodeData,
	    struct: graph,
	    structAttr: 'graph',
	    datas: {
	      node: nodeData,
	      edge: edgeData
	    },
	    datasAttr: {
	      node: 'data',
	      edge: 'edgeData'
	    }
	  }); // Update dataIndex of nodes and edges because invalid edge may be removed
	
	  graph.update();
	  return graph;
	}
	
	module.exports = _default;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(220);
	
	var _clazz = __webpack_require__(263);
	
	var enableClassCheck = _clazz.enableClassCheck;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// id may be function name of Object, add a prefix to avoid this problem.
	function generateNodeKey(id) {
	  return '_EC_' + id;
	}
	/**
	 * @alias module:echarts/data/Graph
	 * @constructor
	 * @param {boolean} directed
	 */
	
	
	var Graph = function (directed) {
	  /**
	   * 是否是有向图
	   * @type {boolean}
	   * @private
	   */
	  this._directed = directed || false;
	  /**
	   * @type {Array.<module:echarts/data/Graph.Node>}
	   * @readOnly
	   */
	
	  this.nodes = [];
	  /**
	   * @type {Array.<module:echarts/data/Graph.Edge>}
	   * @readOnly
	   */
	
	  this.edges = [];
	  /**
	   * @type {Object.<string, module:echarts/data/Graph.Node>}
	   * @private
	   */
	
	  this._nodesMap = {};
	  /**
	   * @type {Object.<string, module:echarts/data/Graph.Edge>}
	   * @private
	   */
	
	  this._edgesMap = {};
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.data;
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.edgeData;
	};
	
	var graphProto = Graph.prototype;
	/**
	 * @type {string}
	 */
	
	graphProto.type = 'graph';
	/**
	 * If is directed graph
	 * @return {boolean}
	 */
	
	graphProto.isDirected = function () {
	  return this._directed;
	};
	/**
	 * Add a new node
	 * @param {string} id
	 * @param {number} [dataIndex]
	 */
	
	
	graphProto.addNode = function (id, dataIndex) {
	  id = id == null ? '' + dataIndex : '' + id;
	  var nodesMap = this._nodesMap;
	
	  if (nodesMap[generateNodeKey(id)]) {
	    return;
	  }
	
	  var node = new Node(id, dataIndex);
	  node.hostGraph = this;
	  this.nodes.push(node);
	  nodesMap[generateNodeKey(id)] = node;
	  return node;
	};
	/**
	 * Get node by data index
	 * @param  {number} dataIndex
	 * @return {module:echarts/data/Graph~Node}
	 */
	
	
	graphProto.getNodeByIndex = function (dataIndex) {
	  var rawIdx = this.data.getRawIndex(dataIndex);
	  return this.nodes[rawIdx];
	};
	/**
	 * Get node by id
	 * @param  {string} id
	 * @return {module:echarts/data/Graph.Node}
	 */
	
	
	graphProto.getNodeById = function (id) {
	  return this._nodesMap[generateNodeKey(id)];
	};
	/**
	 * Add a new edge
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {number} [dataIndex=-1]
	 * @return {module:echarts/data/Graph.Edge}
	 */
	
	
	graphProto.addEdge = function (n1, n2, dataIndex) {
	  var nodesMap = this._nodesMap;
	  var edgesMap = this._edgesMap; // PNEDING
	
	  if (typeof n1 === 'number') {
	    n1 = this.nodes[n1];
	  }
	
	  if (typeof n2 === 'number') {
	    n2 = this.nodes[n2];
	  }
	
	  if (!Node.isInstance(n1)) {
	    n1 = nodesMap[generateNodeKey(n1)];
	  }
	
	  if (!Node.isInstance(n2)) {
	    n2 = nodesMap[generateNodeKey(n2)];
	  }
	
	  if (!n1 || !n2) {
	    return;
	  }
	
	  var key = n1.id + '-' + n2.id;
	  var edge = new Edge(n1, n2, dataIndex);
	  edge.hostGraph = this;
	
	  if (this._directed) {
	    n1.outEdges.push(edge);
	    n2.inEdges.push(edge);
	  }
	
	  n1.edges.push(edge);
	
	  if (n1 !== n2) {
	    n2.edges.push(edge);
	  }
	
	  this.edges.push(edge);
	  edgesMap[key] = edge;
	  return edge;
	};
	/**
	 * Get edge by data index
	 * @param  {number} dataIndex
	 * @return {module:echarts/data/Graph~Node}
	 */
	
	
	graphProto.getEdgeByIndex = function (dataIndex) {
	  var rawIdx = this.edgeData.getRawIndex(dataIndex);
	  return this.edges[rawIdx];
	};
	/**
	 * Get edge by two linked nodes
	 * @param  {module:echarts/data/Graph.Node|string} n1
	 * @param  {module:echarts/data/Graph.Node|string} n2
	 * @return {module:echarts/data/Graph.Edge}
	 */
	
	
	graphProto.getEdge = function (n1, n2) {
	  if (Node.isInstance(n1)) {
	    n1 = n1.id;
	  }
	
	  if (Node.isInstance(n2)) {
	    n2 = n2.id;
	  }
	
	  var edgesMap = this._edgesMap;
	
	  if (this._directed) {
	    return edgesMap[n1 + '-' + n2];
	  } else {
	    return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
	  }
	};
	/**
	 * Iterate all nodes
	 * @param  {Function} cb
	 * @param  {*} [context]
	 */
	
	
	graphProto.eachNode = function (cb, context) {
	  var nodes = this.nodes;
	  var len = nodes.length;
	
	  for (var i = 0; i < len; i++) {
	    if (nodes[i].dataIndex >= 0) {
	      cb.call(context, nodes[i], i);
	    }
	  }
	};
	/**
	 * Iterate all edges
	 * @param  {Function} cb
	 * @param  {*} [context]
	 */
	
	
	graphProto.eachEdge = function (cb, context) {
	  var edges = this.edges;
	  var len = edges.length;
	
	  for (var i = 0; i < len; i++) {
	    if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) {
	      cb.call(context, edges[i], i);
	    }
	  }
	};
	/**
	 * Breadth first traverse
	 * @param {Function} cb
	 * @param {module:echarts/data/Graph.Node} startNode
	 * @param {string} [direction='none'] 'none'|'in'|'out'
	 * @param {*} [context]
	 */
	
	
	graphProto.breadthFirstTraverse = function (cb, startNode, direction, context) {
	  if (!Node.isInstance(startNode)) {
	    startNode = this._nodesMap[generateNodeKey(startNode)];
	  }
	
	  if (!startNode) {
	    return;
	  }
	
	  var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';
	
	  for (var i = 0; i < this.nodes.length; i++) {
	    this.nodes[i].__visited = false;
	  }
	
	  if (cb.call(context, startNode, null)) {
	    return;
	  }
	
	  var queue = [startNode];
	
	  while (queue.length) {
	    var currentNode = queue.shift();
	    var edges = currentNode[edgeType];
	
	    for (var i = 0; i < edges.length; i++) {
	      var e = edges[i];
	      var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
	
	      if (!otherNode.__visited) {
	        if (cb.call(context, otherNode, currentNode)) {
	          // Stop traversing
	          return;
	        }
	
	        queue.push(otherNode);
	        otherNode.__visited = true;
	      }
	    }
	  }
	}; // TODO
	// graphProto.depthFirstTraverse = function (
	//     cb, startNode, direction, context
	// ) {
	// };
	// Filter update
	
	
	graphProto.update = function () {
	  var data = this.data;
	  var edgeData = this.edgeData;
	  var nodes = this.nodes;
	  var edges = this.edges;
	
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    nodes[i].dataIndex = -1;
	  }
	
	  for (var i = 0, len = data.count(); i < len; i++) {
	    nodes[data.getRawIndex(i)].dataIndex = i;
	  }
	
	  edgeData.filterSelf(function (idx) {
	    var edge = edges[edgeData.getRawIndex(idx)];
	    return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
	  }); // Update edge
	
	  for (var i = 0, len = edges.length; i < len; i++) {
	    edges[i].dataIndex = -1;
	  }
	
	  for (var i = 0, len = edgeData.count(); i < len; i++) {
	    edges[edgeData.getRawIndex(i)].dataIndex = i;
	  }
	};
	/**
	 * @return {module:echarts/data/Graph}
	 */
	
	
	graphProto.clone = function () {
	  var graph = new Graph(this._directed);
	  var nodes = this.nodes;
	  var edges = this.edges;
	
	  for (var i = 0; i < nodes.length; i++) {
	    graph.addNode(nodes[i].id, nodes[i].dataIndex);
	  }
	
	  for (var i = 0; i < edges.length; i++) {
	    var e = edges[i];
	    graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
	  }
	
	  return graph;
	};
	/**
	 * @alias module:echarts/data/Graph.Node
	 */
	
	
	function Node(id, dataIndex) {
	  /**
	  * @type {string}
	  */
	  this.id = id == null ? '' : id;
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.inEdges = [];
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.outEdges = [];
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.edges = [];
	  /**
	   * @type {module:echarts/data/Graph}
	   */
	
	  this.hostGraph;
	  /**
	   * @type {number}
	   */
	
	  this.dataIndex = dataIndex == null ? -1 : dataIndex;
	}
	
	Node.prototype = {
	  constructor: Node,
	
	  /**
	   * @return {number}
	   */
	  degree: function () {
	    return this.edges.length;
	  },
	
	  /**
	   * @return {number}
	   */
	  inDegree: function () {
	    return this.inEdges.length;
	  },
	
	  /**
	  * @return {number}
	  */
	  outDegree: function () {
	    return this.outEdges.length;
	  },
	
	  /**
	   * @param {string} [path]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path) {
	    if (this.dataIndex < 0) {
	      return;
	    }
	
	    var graph = this.hostGraph;
	    var itemModel = graph.data.getItemModel(this.dataIndex);
	    return itemModel.getModel(path);
	  }
	};
	/**
	 * 图边
	 * @alias module:echarts/data/Graph.Edge
	 * @param {module:echarts/data/Graph.Node} n1
	 * @param {module:echarts/data/Graph.Node} n2
	 * @param {number} [dataIndex=-1]
	 */
	
	function Edge(n1, n2, dataIndex) {
	  /**
	   * 节点1，如果是有向图则为源节点
	   * @type {module:echarts/data/Graph.Node}
	   */
	  this.node1 = n1;
	  /**
	   * 节点2，如果是有向图则为目标节点
	   * @type {module:echarts/data/Graph.Node}
	   */
	
	  this.node2 = n2;
	  this.dataIndex = dataIndex == null ? -1 : dataIndex;
	}
	/**
	 * @param {string} [path]
	 * @return {module:echarts/model/Model}
	 */
	
	
	Edge.prototype.getModel = function (path) {
	  if (this.dataIndex < 0) {
	    return;
	  }
	
	  var graph = this.hostGraph;
	  var itemModel = graph.edgeData.getItemModel(this.dataIndex);
	  return itemModel.getModel(path);
	};
	
	var createGraphDataProxyMixin = function (hostName, dataName) {
	  return {
	    /**
	     * @param {string=} [dimension='value'] Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
	     * @return {number}
	     */
	    getValue: function (dimension) {
	      var data = this[hostName][dataName];
	      return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
	    },
	
	    /**
	     * @param {Object|string} key
	     * @param {*} [value]
	     */
	    setVisual: function (key, value) {
	      this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
	    },
	
	    /**
	     * @param {string} key
	     * @return {boolean}
	     */
	    getVisual: function (key, ignoreParent) {
	      return this[hostName][dataName].getItemVisual(this.dataIndex, key, ignoreParent);
	    },
	
	    /**
	     * @param {Object} layout
	     * @return {boolean} [merge=false]
	     */
	    setLayout: function (layout, merge) {
	      this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
	    },
	
	    /**
	     * @return {Object}
	     */
	    getLayout: function () {
	      return this[hostName][dataName].getItemLayout(this.dataIndex);
	    },
	
	    /**
	     * @return {module:zrender/Element}
	     */
	    getGraphicEl: function () {
	      return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
	    },
	
	    /**
	     * @return {number}
	     */
	    getRawIndex: function () {
	      return this[hostName][dataName].getRawIndex(this.dataIndex);
	    }
	  };
	};
	
	zrUtil.mixin(Node, createGraphDataProxyMixin('hostGraph', 'data'));
	zrUtil.mixin(Edge, createGraphDataProxyMixin('hostGraph', 'edgeData'));
	Graph.Node = Node;
	Graph.Edge = Edge;
	enableClassCheck(Node);
	enableClassCheck(Edge);
	var _default = Graph;
	module.exports = _default;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var KEY_DELIMITER = '-->';
	/**
	 * params handler
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @returns {*}
	 */
	
	var getAutoCurvenessParams = function (seriesModel) {
	  return seriesModel.get('autoCurveness') || null;
	};
	/**
	 * Generate a list of edge curvatures, 20 is the default
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @param {number} appendLength
	 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
	 */
	
	
	var createCurveness = function (seriesModel, appendLength) {
	  var autoCurvenessParmas = getAutoCurvenessParams(seriesModel);
	  var length = 20;
	  var curvenessList = []; // handler the function set
	
	  if (typeof autoCurvenessParmas === 'number') {
	    length = autoCurvenessParmas;
	  } else if (zrUtil.isArray(autoCurvenessParmas)) {
	    seriesModel.__curvenessList = autoCurvenessParmas;
	    return;
	  } // append length
	
	
	  if (appendLength > length) {
	    length = appendLength;
	  } // make sure the length is even
	
	
	  var len = length % 2 ? length + 2 : length + 3;
	  curvenessList = [];
	
	  for (var i = 0; i < len; i++) {
	    curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
	  }
	
	  seriesModel.__curvenessList = curvenessList;
	};
	/**
	 * Create different cache key data in the positive and negative directions, in order to set the curvature later
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @returns {string} key
	 */
	
	
	var getKeyOfEdges = function (n1, n2, seriesModel) {
	  var source = [n1.id, n1.dataIndex].join('.');
	  var target = [n2.id, n2.dataIndex].join('.');
	  return [seriesModel.uid, source, target].join(KEY_DELIMITER);
	};
	/**
	 * get opposite key
	 * @param {string} key
	 * @returns {string}
	 */
	
	
	var getOppositeKey = function (key) {
	  var keys = key.split(KEY_DELIMITER);
	  return [keys[0], keys[2], keys[1]].join(KEY_DELIMITER);
	};
	/**
	 * get edgeMap with key
	 * @param edge
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 */
	
	
	var getEdgeFromMap = function (edge, seriesModel) {
	  var key = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
	  return seriesModel.__edgeMap[key];
	};
	/**
	 * calculate all cases total length
	 * @param edge
	 * @param seriesModel
	 * @returns {number}
	 */
	
	
	var getTotalLengthBetweenNodes = function (edge, seriesModel) {
	  var len = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
	  var lenV = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
	  return len + lenV;
	};
	/**
	 *
	 * @param key
	 */
	
	
	var getEdgeMapLengthWithKey = function (key, seriesModel) {
	  var edgeMap = seriesModel.__edgeMap;
	  return edgeMap[key] ? edgeMap[key].length : 0;
	};
	/**
	 * Count the number of edges between the same two points, used to obtain the curvature table and the parity of the edge
	 * @see /graph/GraphSeries.js@getInitialData
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 */
	
	
	function initCurvenessList(seriesModel) {
	  if (!getAutoCurvenessParams(seriesModel)) {
	    return;
	  }
	
	  seriesModel.__curvenessList = [];
	  seriesModel.__edgeMap = {}; // calc the array of curveness List
	
	  createCurveness(seriesModel);
	}
	/**
	 * set edgeMap with key
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @param {number} index
	 */
	
	
	function createEdgeMapForCurveness(n1, n2, seriesModel, index) {
	  if (!getAutoCurvenessParams(seriesModel)) {
	    return;
	  }
	
	  var key = getKeyOfEdges(n1, n2, seriesModel);
	  var edgeMap = seriesModel.__edgeMap;
	  var oppositeEdges = edgeMap[getOppositeKey(key)]; // set direction
	
	  if (edgeMap[key] && !oppositeEdges) {
	    edgeMap[key].isForward = true;
	  } else if (oppositeEdges && edgeMap[key]) {
	    oppositeEdges.isForward = true;
	    edgeMap[key].isForward = false;
	  }
	
	  edgeMap[key] = edgeMap[key] || [];
	  edgeMap[key].push(index);
	}
	/**
	 * get curvature for edge
	 * @param edge
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @param index
	 */
	
	
	function getCurvenessForEdge(edge, seriesModel, index, needReverse) {
	  var autoCurvenessParams = getAutoCurvenessParams(seriesModel);
	  var isArrayParam = zrUtil.isArray(autoCurvenessParams);
	
	  if (!autoCurvenessParams) {
	    return null;
	  }
	
	  var edgeArray = getEdgeFromMap(edge, seriesModel);
	
	  if (!edgeArray) {
	    return null;
	  }
	
	  var edgeIndex = -1;
	
	  for (var i = 0; i < edgeArray.length; i++) {
	    if (edgeArray[i] === index) {
	      edgeIndex = i;
	      break;
	    }
	  } // if totalLen is Longer createCurveness
	
	
	  var totalLen = getTotalLengthBetweenNodes(edge, seriesModel);
	  createCurveness(seriesModel, totalLen);
	  edge.lineStyle = edge.lineStyle || {}; // if is opposite edge, must set curvenss to opposite number
	
	  var curKey = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
	  var curvenessList = seriesModel.__curvenessList; // if pass array no need parity
	
	  var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;
	
	  if (!edgeArray.isForward) {
	    // the opposite edge show outside
	    var oppositeKey = getOppositeKey(curKey);
	    var len = getEdgeMapLengthWithKey(oppositeKey, seriesModel);
	    var resValue = curvenessList[edgeIndex + len + parityCorrection]; // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite
	
	    if (needReverse) {
	      // set as array may make the parity handle with the len of opposite
	      if (isArrayParam) {
	        if (autoCurvenessParams && autoCurvenessParams[0] === 0) {
	          return (len + parityCorrection) % 2 ? resValue : -resValue;
	        } else {
	          return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
	        }
	      } else {
	        return (len + parityCorrection) % 2 ? resValue : -resValue;
	      }
	    } else {
	      return curvenessList[edgeIndex + len + parityCorrection];
	    }
	  } else {
	    return curvenessList[parityCorrection + edgeIndex];
	  }
	}
	
	exports.initCurvenessList = initCurvenessList;
	exports.createEdgeMapForCurveness = createEdgeMapForCurveness;
	exports.getCurvenessForEdge = getCurvenessForEdge;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var SymbolDraw = __webpack_require__(369);
	
	var LineDraw = __webpack_require__(476);
	
	var RoamController = __webpack_require__(438);
	
	var roamHelper = __webpack_require__(440);
	
	var _cursorHelper = __webpack_require__(441);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphic = __webpack_require__(268);
	
	var adjustEdge = __webpack_require__(479);
	
	var _graphHelper = __webpack_require__(480);
	
	var getNodeGlobalScale = _graphHelper.getNodeGlobalScale;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var FOCUS_ADJACENCY = '__focusNodeAdjacency';
	var UNFOCUS_ADJACENCY = '__unfocusNodeAdjacency';
	var nodeOpacityPath = ['itemStyle', 'opacity'];
	var lineOpacityPath = ['lineStyle', 'opacity'];
	
	function getItemOpacity(item, opacityPath) {
	  var opacity = item.getVisual('opacity');
	  return opacity != null ? opacity : item.getModel().get(opacityPath);
	}
	
	function fadeOutItem(item, opacityPath, opacityRatio) {
	  var el = item.getGraphicEl();
	  var opacity = getItemOpacity(item, opacityPath);
	
	  if (opacityRatio != null) {
	    opacity == null && (opacity = 1);
	    opacity *= opacityRatio;
	  }
	
	  el.downplay && el.downplay();
	  el.traverse(function (child) {
	    if (!child.isGroup) {
	      var opct = child.lineLabelOriginalOpacity;
	
	      if (opct == null || opacityRatio != null) {
	        opct = opacity;
	      }
	
	      child.setStyle('opacity', opct);
	    }
	  });
	}
	
	function fadeInItem(item, opacityPath) {
	  var opacity = getItemOpacity(item, opacityPath);
	  var el = item.getGraphicEl(); // Should go back to normal opacity first, consider hoverLayer,
	  // where current state is copied to elMirror, and support
	  // emphasis opacity here.
	
	  el.traverse(function (child) {
	    !child.isGroup && child.setStyle('opacity', opacity);
	  });
	  el.highlight && el.highlight();
	}
	
	var _default = echarts.extendChartView({
	  type: 'graph',
	  init: function (ecModel, api) {
	    var symbolDraw = new SymbolDraw();
	    var lineDraw = new LineDraw();
	    var group = this.group;
	    this._controller = new RoamController(api.getZr());
	    this._controllerHost = {
	      target: group
	    };
	    group.add(symbolDraw.group);
	    group.add(lineDraw.group);
	    this._symbolDraw = symbolDraw;
	    this._lineDraw = lineDraw;
	    this._firstRender = true;
	  },
	  render: function (seriesModel, ecModel, api) {
	    var graphView = this;
	    var coordSys = seriesModel.coordinateSystem;
	    this._model = seriesModel;
	    var symbolDraw = this._symbolDraw;
	    var lineDraw = this._lineDraw;
	    var group = this.group;
	
	    if (coordSys.type === 'view') {
	      var groupNewProp = {
	        position: coordSys.position,
	        scale: coordSys.scale
	      };
	
	      if (this._firstRender) {
	        group.attr(groupNewProp);
	      } else {
	        graphic.updateProps(group, groupNewProp, seriesModel);
	      }
	    } // Fix edge contact point with node
	
	
	    adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	    var data = seriesModel.getData();
	    symbolDraw.updateData(data);
	    var edgeData = seriesModel.getEdgeData();
	    lineDraw.updateData(edgeData);
	
	    this._updateNodeAndLinkScale();
	
	    this._updateController(seriesModel, ecModel, api);
	
	    clearTimeout(this._layoutTimeout);
	    var forceLayout = seriesModel.forceLayout;
	    var layoutAnimation = seriesModel.get('force.layoutAnimation');
	
	    if (forceLayout) {
	      this._startForceLayoutIteration(forceLayout, layoutAnimation);
	    }
	
	    data.eachItemGraphicEl(function (el, idx) {
	      var itemModel = data.getItemModel(idx); // Update draggable
	
	      el.off('drag').off('dragend');
	      var draggable = itemModel.get('draggable');
	
	      if (draggable) {
	        el.on('drag', function () {
	          if (forceLayout) {
	            forceLayout.warmUp();
	            !this._layouting && this._startForceLayoutIteration(forceLayout, layoutAnimation);
	            forceLayout.setFixed(idx); // Write position back to layout
	
	            data.setItemLayout(idx, el.position);
	          }
	        }, this).on('dragend', function () {
	          if (forceLayout) {
	            forceLayout.setUnfixed(idx);
	          }
	        }, this);
	      }
	
	      el.setDraggable(draggable && forceLayout);
	      el[FOCUS_ADJACENCY] && el.off('mouseover', el[FOCUS_ADJACENCY]);
	      el[UNFOCUS_ADJACENCY] && el.off('mouseout', el[UNFOCUS_ADJACENCY]);
	
	      if (itemModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el[FOCUS_ADJACENCY] = function () {
	          graphView._clearTimer();
	
	          api.dispatchAction({
	            type: 'focusNodeAdjacency',
	            seriesId: seriesModel.id,
	            dataIndex: el.dataIndex
	          });
	        });
	        el.on('mouseout', el[UNFOCUS_ADJACENCY] = function () {
	          graphView._dispatchUnfocus(api);
	        });
	      }
	    }, this);
	    data.graph.eachEdge(function (edge) {
	      var el = edge.getGraphicEl();
	      el[FOCUS_ADJACENCY] && el.off('mouseover', el[FOCUS_ADJACENCY]);
	      el[UNFOCUS_ADJACENCY] && el.off('mouseout', el[UNFOCUS_ADJACENCY]);
	
	      if (edge.getModel().get('focusNodeAdjacency')) {
	        el.on('mouseover', el[FOCUS_ADJACENCY] = function () {
	          graphView._clearTimer();
	
	          api.dispatchAction({
	            type: 'focusNodeAdjacency',
	            seriesId: seriesModel.id,
	            edgeDataIndex: edge.dataIndex
	          });
	        });
	        el.on('mouseout', el[UNFOCUS_ADJACENCY] = function () {
	          graphView._dispatchUnfocus(api);
	        });
	      }
	    });
	    var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get('circular.rotateLabel');
	    var cx = data.getLayout('cx');
	    var cy = data.getLayout('cy');
	    data.eachItemGraphicEl(function (el, idx) {
	      var itemModel = data.getItemModel(idx);
	      var labelRotate = itemModel.get('label.rotate') || 0;
	      var symbolPath = el.getSymbolPath();
	
	      if (circularRotateLabel) {
	        var pos = data.getItemLayout(idx);
	        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
	
	        if (rad < 0) {
	          rad = Math.PI * 2 + rad;
	        }
	
	        var isLeft = pos[0] < cx;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	
	        var textPosition = isLeft ? 'left' : 'right';
	        graphic.modifyLabelStyle(symbolPath, {
	          textRotation: -rad,
	          textPosition: textPosition,
	          textOrigin: 'center'
	        }, {
	          textPosition: textPosition
	        });
	      } else {
	        graphic.modifyLabelStyle(symbolPath, {
	          textRotation: labelRotate *= Math.PI / 180
	        });
	      }
	    });
	    this._firstRender = false;
	  },
	  dispose: function () {
	    this._controller && this._controller.dispose();
	    this._controllerHost = {};
	
	    this._clearTimer();
	  },
	  _dispatchUnfocus: function (api, opt) {
	    var self = this;
	
	    this._clearTimer();
	
	    this._unfocusDelayTimer = setTimeout(function () {
	      self._unfocusDelayTimer = null;
	      api.dispatchAction({
	        type: 'unfocusNodeAdjacency',
	        seriesId: self._model.id
	      });
	    }, 500);
	  },
	  _clearTimer: function () {
	    if (this._unfocusDelayTimer) {
	      clearTimeout(this._unfocusDelayTimer);
	      this._unfocusDelayTimer = null;
	    }
	  },
	  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var graph = data.graph;
	    var dataIndex = payload.dataIndex;
	    var edgeDataIndex = payload.edgeDataIndex;
	    var node = graph.getNodeByIndex(dataIndex);
	    var edge = graph.getEdgeByIndex(edgeDataIndex);
	
	    if (!node && !edge) {
	      return;
	    }
	
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath, 0.1);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath, 0.1);
	    });
	
	    if (node) {
	      fadeInItem(node, nodeOpacityPath);
	      zrUtil.each(node.edges, function (adjacentEdge) {
	        if (adjacentEdge.dataIndex < 0) {
	          return;
	        }
	
	        fadeInItem(adjacentEdge, lineOpacityPath);
	        fadeInItem(adjacentEdge.node1, nodeOpacityPath);
	        fadeInItem(adjacentEdge.node2, nodeOpacityPath);
	      });
	    }
	
	    if (edge) {
	      fadeInItem(edge, lineOpacityPath);
	      fadeInItem(edge.node1, nodeOpacityPath);
	      fadeInItem(edge.node2, nodeOpacityPath);
	    }
	  },
	  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var graph = seriesModel.getData().graph;
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath);
	    });
	  },
	  _startForceLayoutIteration: function (forceLayout, layoutAnimation) {
	    var self = this;
	
	    (function step() {
	      forceLayout.step(function (stopped) {
	        self.updateLayout(self._model);
	        (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
	      });
	    })();
	  },
	  _updateController: function (seriesModel, ecModel, api) {
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    var group = this.group;
	    controller.setPointerChecker(function (e, x, y) {
	      var rect = group.getBoundingRect();
	      rect.applyTransform(group.transform);
	      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	    });
	
	    if (seriesModel.coordinateSystem.type !== 'view') {
	      controller.disable();
	      return;
	    }
	
	    controller.enable(seriesModel.get('roam'));
	    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	    controller.off('pan').off('zoom').on('pan', function (e) {
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'graphRoam',
	        dx: e.dx,
	        dy: e.dy
	      });
	    }).on('zoom', function (e) {
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'graphRoam',
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      });
	
	      this._updateNodeAndLinkScale();
	
	      adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	
	      this._lineDraw.updateLayout();
	    }, this);
	  },
	  _updateNodeAndLinkScale: function () {
	    var seriesModel = this._model;
	    var data = seriesModel.getData();
	    var nodeScale = getNodeGlobalScale(seriesModel);
	    var invScale = [nodeScale, nodeScale];
	    data.eachItemGraphicEl(function (el, idx) {
	      el.attr('scale', invScale);
	    });
	  },
	  updateLayout: function (seriesModel) {
	    adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	
	    this._symbolDraw.updateLayout();
	
	    this._lineDraw.updateLayout();
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove();
	    this._lineDraw && this._lineDraw.remove();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var LineGroup = __webpack_require__(477);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/LineDraw
	 */
	// import IncrementalDisplayable from 'zrender/src/graphic/IncrementalDisplayable';
	
	/**
	 * @alias module:echarts/component/marker/LineDraw
	 * @constructor
	 */
	function LineDraw(ctor) {
	  this._ctor = ctor || LineGroup;
	  this.group = new graphic.Group();
	}
	
	var lineDrawProto = LineDraw.prototype;
	
	lineDrawProto.isPersistent = function () {
	  return true;
	};
	/**
	 * @param {module:echarts/data/List} lineData
	 */
	
	
	lineDrawProto.updateData = function (lineData) {
	  var lineDraw = this;
	  var group = lineDraw.group;
	  var oldLineData = lineDraw._lineData;
	  lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
	  // stream mode to normal mode, where previous elements should be removed.
	
	  if (!oldLineData) {
	    group.removeAll();
	  }
	
	  var seriesScope = makeSeriesScope(lineData);
	  lineData.diff(oldLineData).add(function (idx) {
	    doAdd(lineDraw, lineData, idx, seriesScope);
	  }).update(function (newIdx, oldIdx) {
	    doUpdate(lineDraw, oldLineData, lineData, oldIdx, newIdx, seriesScope);
	  }).remove(function (idx) {
	    group.remove(oldLineData.getItemGraphicEl(idx));
	  }).execute();
	};
	
	function doAdd(lineDraw, lineData, idx, seriesScope) {
	  var itemLayout = lineData.getItemLayout(idx);
	
	  if (!lineNeedsDraw(itemLayout)) {
	    return;
	  }
	
	  var el = new lineDraw._ctor(lineData, idx, seriesScope);
	  lineData.setItemGraphicEl(idx, el);
	  lineDraw.group.add(el);
	}
	
	function doUpdate(lineDraw, oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
	  var itemEl = oldLineData.getItemGraphicEl(oldIdx);
	
	  if (!lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
	    lineDraw.group.remove(itemEl);
	    return;
	  }
	
	  if (!itemEl) {
	    itemEl = new lineDraw._ctor(newLineData, newIdx, seriesScope);
	  } else {
	    itemEl.updateData(newLineData, newIdx, seriesScope);
	  }
	
	  newLineData.setItemGraphicEl(newIdx, itemEl);
	  lineDraw.group.add(itemEl);
	}
	
	lineDrawProto.updateLayout = function () {
	  var lineData = this._lineData; // Do not support update layout in incremental mode.
	
	  if (!lineData) {
	    return;
	  }
	
	  lineData.eachItemGraphicEl(function (el, idx) {
	    el.updateLayout(lineData, idx);
	  }, this);
	};
	
	lineDrawProto.incrementalPrepareUpdate = function (lineData) {
	  this._seriesScope = makeSeriesScope(lineData);
	  this._lineData = null;
	  this.group.removeAll();
	};
	
	function isEffectObject(el) {
	  return el.animators && el.animators.length > 0;
	}
	
	lineDrawProto.incrementalUpdate = function (taskParams, lineData) {
	  function updateIncrementalAndHover(el) {
	    if (!el.isGroup && !isEffectObject(el)) {
	      el.incremental = el.useHoverLayer = true;
	    }
	  }
	
	  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
	    var itemLayout = lineData.getItemLayout(idx);
	
	    if (lineNeedsDraw(itemLayout)) {
	      var el = new this._ctor(lineData, idx, this._seriesScope);
	      el.traverse(updateIncrementalAndHover);
	      this.group.add(el);
	      lineData.setItemGraphicEl(idx, el);
	    }
	  }
	};
	
	function makeSeriesScope(lineData) {
	  var hostModel = lineData.hostModel;
	  return {
	    lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
	    hoverLineStyle: hostModel.getModel('emphasis.lineStyle').getLineStyle(),
	    labelModel: hostModel.getModel('label'),
	    hoverLabelModel: hostModel.getModel('emphasis.label')
	  };
	}
	
	lineDrawProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	lineDrawProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	function isPointNaN(pt) {
	  return isNaN(pt[0]) || isNaN(pt[1]);
	}
	
	function lineNeedsDraw(pts) {
	  return !isPointNaN(pts[0]) && !isPointNaN(pts[1]);
	}
	
	var _default = LineDraw;
	module.exports = _default;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var vector = __webpack_require__(222);
	
	var symbolUtil = __webpack_require__(360);
	
	var LinePath = __webpack_require__(478);
	
	var graphic = __webpack_require__(268);
	
	var _number = __webpack_require__(306);
	
	var round = _number.round;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Line
	 */
	var SYMBOL_CATEGORIES = ['fromSymbol', 'toSymbol'];
	
	function makeSymbolTypeKey(symbolCategory) {
	  return '_' + symbolCategory + 'Type';
	}
	/**
	 * @inner
	 */
	
	
	function createSymbol(name, lineData, idx) {
	  var symbolType = lineData.getItemVisual(idx, name);
	
	  if (!symbolType || symbolType === 'none') {
	    return;
	  }
	
	  var color = lineData.getItemVisual(idx, 'color');
	  var symbolSize = lineData.getItemVisual(idx, name + 'Size');
	  var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
	
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [symbolSize, symbolSize];
	  }
	
	  var symbolPath = symbolUtil.createSymbol(symbolType, -symbolSize[0] / 2, -symbolSize[1] / 2, symbolSize[0], symbolSize[1], color); // rotate by default if symbolRotate is not specified or NaN
	
	  symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
	  symbolPath.name = name;
	  return symbolPath;
	}
	
	function createLine(points) {
	  var line = new LinePath({
	    name: 'line',
	    subPixelOptimize: true
	  });
	  setLinePoints(line.shape, points);
	  return line;
	}
	
	function setLinePoints(targetShape, points) {
	  targetShape.x1 = points[0][0];
	  targetShape.y1 = points[0][1];
	  targetShape.x2 = points[1][0];
	  targetShape.y2 = points[1][1];
	  targetShape.percent = 1;
	  var cp1 = points[2];
	
	  if (cp1) {
	    targetShape.cpx1 = cp1[0];
	    targetShape.cpy1 = cp1[1];
	  } else {
	    targetShape.cpx1 = NaN;
	    targetShape.cpy1 = NaN;
	  }
	}
	
	function updateSymbolAndLabelBeforeLineUpdate() {
	  var lineGroup = this;
	  var symbolFrom = lineGroup.childOfName('fromSymbol');
	  var symbolTo = lineGroup.childOfName('toSymbol');
	  var label = lineGroup.childOfName('label'); // Quick reject
	
	  if (!symbolFrom && !symbolTo && label.ignore) {
	    return;
	  }
	
	  var invScale = 1;
	  var parentNode = this.parent;
	
	  while (parentNode) {
	    if (parentNode.scale) {
	      invScale /= parentNode.scale[0];
	    }
	
	    parentNode = parentNode.parent;
	  }
	
	  var line = lineGroup.childOfName('line'); // If line not changed
	  // FIXME Parent scale changed
	
	  if (!this.__dirty && !line.__dirty) {
	    return;
	  }
	
	  var percent = line.shape.percent;
	  var fromPos = line.pointAt(0);
	  var toPos = line.pointAt(percent);
	  var d = vector.sub([], toPos, fromPos);
	  vector.normalize(d, d);
	
	  if (symbolFrom) {
	    symbolFrom.attr('position', fromPos); // Fix #12388
	    // when symbol is set to be 'arrow' in markLine,
	    // symbolRotate value will be ignored, and compulsively use tangent angle.
	    // rotate by default if symbol rotation is not specified
	
	    var specifiedRotation = symbolFrom.__specifiedRotation;
	
	    if (specifiedRotation == null) {
	      var tangent = line.tangentAt(0);
	      symbolFrom.attr('rotation', Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	    } else {
	      symbolFrom.attr('rotation', specifiedRotation);
	    }
	
	    symbolFrom.attr('scale', [invScale * percent, invScale * percent]);
	  }
	
	  if (symbolTo) {
	    symbolTo.attr('position', toPos); // Fix #12388
	    // when symbol is set to be 'arrow' in markLine,
	    // symbolRotate value will be ignored, and compulsively use tangent angle.
	    // rotate by default if symbol rotation is not specified
	
	    var specifiedRotation = symbolTo.__specifiedRotation;
	
	    if (specifiedRotation == null) {
	      var tangent = line.tangentAt(1);
	      symbolTo.attr('rotation', -Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	    } else {
	      symbolTo.attr('rotation', specifiedRotation);
	    }
	
	    symbolTo.attr('scale', [invScale * percent, invScale * percent]);
	  }
	
	  if (!label.ignore) {
	    label.attr('position', toPos);
	    var textPosition;
	    var textAlign;
	    var textVerticalAlign;
	    var textOrigin;
	    var distance = label.__labelDistance;
	    var distanceX = distance[0] * invScale;
	    var distanceY = distance[1] * invScale;
	    var halfPercent = percent / 2;
	    var tangent = line.tangentAt(halfPercent);
	    var n = [tangent[1], -tangent[0]];
	    var cp = line.pointAt(halfPercent);
	
	    if (n[1] > 0) {
	      n[0] = -n[0];
	      n[1] = -n[1];
	    }
	
	    var dir = tangent[0] < 0 ? -1 : 1;
	
	    if (label.__position !== 'start' && label.__position !== 'end') {
	      var rotation = -Math.atan2(tangent[1], tangent[0]);
	
	      if (toPos[0] < fromPos[0]) {
	        rotation = Math.PI + rotation;
	      }
	
	      label.attr('rotation', rotation);
	    }
	
	    var dy;
	
	    switch (label.__position) {
	      case 'insideStartTop':
	      case 'insideMiddleTop':
	      case 'insideEndTop':
	      case 'middle':
	        dy = -distanceY;
	        textVerticalAlign = 'bottom';
	        break;
	
	      case 'insideStartBottom':
	      case 'insideMiddleBottom':
	      case 'insideEndBottom':
	        dy = distanceY;
	        textVerticalAlign = 'top';
	        break;
	
	      default:
	        dy = 0;
	        textVerticalAlign = 'middle';
	    }
	
	    switch (label.__position) {
	      case 'end':
	        textPosition = [d[0] * distanceX + toPos[0], d[1] * distanceY + toPos[1]];
	        textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
	        textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
	        break;
	
	      case 'start':
	        textPosition = [-d[0] * distanceX + fromPos[0], -d[1] * distanceY + fromPos[1]];
	        textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
	        textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
	        break;
	
	      case 'insideStartTop':
	      case 'insideStart':
	      case 'insideStartBottom':
	        textPosition = [distanceX * dir + fromPos[0], fromPos[1] + dy];
	        textAlign = tangent[0] < 0 ? 'right' : 'left';
	        textOrigin = [-distanceX * dir, -dy];
	        break;
	
	      case 'insideMiddleTop':
	      case 'insideMiddle':
	      case 'insideMiddleBottom':
	      case 'middle':
	        textPosition = [cp[0], cp[1] + dy];
	        textAlign = 'center';
	        textOrigin = [0, -dy];
	        break;
	
	      case 'insideEndTop':
	      case 'insideEnd':
	      case 'insideEndBottom':
	        textPosition = [-distanceX * dir + toPos[0], toPos[1] + dy];
	        textAlign = tangent[0] >= 0 ? 'right' : 'left';
	        textOrigin = [distanceX * dir, -dy];
	        break;
	    }
	
	    label.attr({
	      style: {
	        // Use the user specified text align and baseline first
	        textVerticalAlign: label.__verticalAlign || textVerticalAlign,
	        textAlign: label.__textAlign || textAlign
	      },
	      position: textPosition,
	      scale: [invScale, invScale],
	      origin: textOrigin
	    });
	  }
	}
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Line}
	 */
	
	
	function Line(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	
	  this._createLine(lineData, idx, seriesScope);
	}
	
	var lineProto = Line.prototype; // Update symbol position and rotation
	
	lineProto.beforeUpdate = updateSymbolAndLabelBeforeLineUpdate;
	
	lineProto._createLine = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var linePoints = lineData.getItemLayout(idx);
	  var line = createLine(linePoints);
	  line.shape.percent = 0;
	  graphic.initProps(line, {
	    shape: {
	      percent: 1
	    }
	  }, seriesModel, idx);
	  this.add(line);
	  var label = new graphic.Text({
	    name: 'label',
	    // FIXME
	    // Temporary solution for `focusNodeAdjacency`.
	    // line label do not use the opacity of lineStyle.
	    lineLabelOriginalOpacity: 1
	  });
	  this.add(label);
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbol = createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
	    // it will be updated after line#update.
	    // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
	
	    this.add(symbol);
	    this[makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
	  }, this);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	lineProto.updateData = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childOfName('line');
	  var linePoints = lineData.getItemLayout(idx);
	  var target = {
	    shape: {}
	  };
	  setLinePoints(target.shape, linePoints);
	  graphic.updateProps(line, target, seriesModel, idx);
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbolType = lineData.getItemVisual(idx, symbolCategory);
	    var key = makeSymbolTypeKey(symbolCategory); // Symbol changed
	
	    if (this[key] !== symbolType) {
	      this.remove(this.childOfName(symbolCategory));
	      var symbol = createSymbol(symbolCategory, lineData, idx);
	      this.add(symbol);
	    }
	
	    this[key] = symbolType;
	  }, this);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	lineProto._updateCommonStl = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childOfName('line');
	  var lineStyle = seriesScope && seriesScope.lineStyle;
	  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
	  var labelModel = seriesScope && seriesScope.labelModel;
	  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel; // Optimization for large dataset
	
	  if (!seriesScope || lineData.hasItemOption) {
	    var itemModel = lineData.getItemModel(idx);
	    lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	    hoverLineStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	    labelModel = itemModel.getModel('label');
	    hoverLabelModel = itemModel.getModel('emphasis.label');
	  }
	
	  var visualColor = lineData.getItemVisual(idx, 'color');
	  var visualOpacity = zrUtil.retrieve3(lineData.getItemVisual(idx, 'opacity'), lineStyle.opacity, 1);
	  line.useStyle(zrUtil.defaults({
	    strokeNoScale: true,
	    fill: 'none',
	    stroke: visualColor,
	    opacity: visualOpacity
	  }, lineStyle));
	  line.hoverStyle = hoverLineStyle; // Update symbol
	
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbol = this.childOfName(symbolCategory);
	
	    if (symbol) {
	      symbol.setColor(visualColor);
	      symbol.setStyle({
	        opacity: visualOpacity
	      });
	    }
	  }, this);
	  var showLabel = labelModel.getShallow('show');
	  var hoverShowLabel = hoverLabelModel.getShallow('show');
	  var label = this.childOfName('label');
	  var defaultLabelColor;
	  var baseText; // FIXME: the logic below probably should be merged to `graphic.setLabelStyle`.
	
	  if (showLabel || hoverShowLabel) {
	    defaultLabelColor = visualColor || '#000';
	    baseText = seriesModel.getFormattedLabel(idx, 'normal', lineData.dataType);
	
	    if (baseText == null) {
	      var rawVal = seriesModel.getRawValue(idx);
	      baseText = rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? round(rawVal) : rawVal;
	    }
	  }
	
	  var normalText = showLabel ? baseText : null;
	  var emphasisText = hoverShowLabel ? zrUtil.retrieve2(seriesModel.getFormattedLabel(idx, 'emphasis', lineData.dataType), baseText) : null;
	  var labelStyle = label.style; // Always set `textStyle` even if `normalStyle.text` is null, because default
	  // values have to be set on `normalStyle`.
	
	  if (normalText != null || emphasisText != null) {
	    graphic.setTextStyle(label.style, labelModel, {
	      text: normalText
	    }, {
	      autoColor: defaultLabelColor
	    });
	    label.__textAlign = labelStyle.textAlign;
	    label.__verticalAlign = labelStyle.textVerticalAlign; // 'start', 'middle', 'end'
	
	    label.__position = labelModel.get('position') || 'middle';
	    var distance = labelModel.get('distance');
	
	    if (!zrUtil.isArray(distance)) {
	      distance = [distance, distance];
	    }
	
	    label.__labelDistance = distance;
	  }
	
	  if (emphasisText != null) {
	    // Only these properties supported in this emphasis style here.
	    label.hoverStyle = {
	      text: emphasisText,
	      textFill: hoverLabelModel.getTextColor(true),
	      // For merging hover style to normal style, do not use
	      // `hoverLabelModel.getFont()` here.
	      fontStyle: hoverLabelModel.getShallow('fontStyle'),
	      fontWeight: hoverLabelModel.getShallow('fontWeight'),
	      fontSize: hoverLabelModel.getShallow('fontSize'),
	      fontFamily: hoverLabelModel.getShallow('fontFamily')
	    };
	  } else {
	    label.hoverStyle = {
	      text: null
	    };
	  }
	
	  label.ignore = !showLabel && !hoverShowLabel;
	  graphic.setHoverStyle(this);
	};
	
	lineProto.highlight = function () {
	  this.trigger('emphasis');
	};
	
	lineProto.downplay = function () {
	  this.trigger('normal');
	};
	
	lineProto.updateLayout = function (lineData, idx) {
	  this.setLinePoints(lineData.getItemLayout(idx));
	};
	
	lineProto.setLinePoints = function (points) {
	  var linePath = this.childOfName('line');
	  setLinePoints(linePath.shape, points);
	  linePath.dirty();
	};
	
	zrUtil.inherits(Line, graphic.Group);
	var _default = Line;
	module.exports = _default;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var vec2 = __webpack_require__(222);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Line path for bezier and straight line draw
	 */
	var straightLineProto = graphic.Line.prototype;
	var bezierCurveProto = graphic.BezierCurve.prototype;
	
	function isLine(shape) {
	  return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
	}
	
	var _default = graphic.extendShape({
	  type: 'ec-line',
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    percent: 1,
	    cpx1: null,
	    cpy1: null
	  },
	  buildPath: function (ctx, shape) {
	    this[isLine(shape) ? '_buildPathLine' : '_buildPathCurve'](ctx, shape);
	  },
	  _buildPathLine: straightLineProto.buildPath,
	  _buildPathCurve: bezierCurveProto.buildPath,
	  pointAt: function (t) {
	    return this[isLine(this.shape) ? '_pointAtLine' : '_pointAtCurve'](t);
	  },
	  _pointAtLine: straightLineProto.pointAt,
	  _pointAtCurve: bezierCurveProto.pointAt,
	  tangentAt: function (t) {
	    var shape = this.shape;
	    var p = isLine(shape) ? [shape.x2 - shape.x1, shape.y2 - shape.y1] : this._tangentAtCurve(t);
	    return vec2.normalize(p, p);
	  },
	  _tangentAtCurve: bezierCurveProto.tangentAt
	});
	
	module.exports = _default;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var curveTool = __webpack_require__(272);
	
	var vec2 = __webpack_require__(222);
	
	var _graphHelper = __webpack_require__(480);
	
	var getSymbolSize = _graphHelper.getSymbolSize;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var v1 = [];
	var v2 = [];
	var v3 = [];
	var quadraticAt = curveTool.quadraticAt;
	var v2DistSquare = vec2.distSquare;
	var mathAbs = Math.abs;
	
	function intersectCurveCircle(curvePoints, center, radius) {
	  var p0 = curvePoints[0];
	  var p1 = curvePoints[1];
	  var p2 = curvePoints[2];
	  var d = Infinity;
	  var t;
	  var radiusSquare = radius * radius;
	  var interval = 0.1;
	
	  for (var _t = 0.1; _t <= 0.9; _t += 0.1) {
	    v1[0] = quadraticAt(p0[0], p1[0], p2[0], _t);
	    v1[1] = quadraticAt(p0[1], p1[1], p2[1], _t);
	    var diff = mathAbs(v2DistSquare(v1, center) - radiusSquare);
	
	    if (diff < d) {
	      d = diff;
	      t = _t;
	    }
	  } // Assume the segment is monotone，Find root through Bisection method
	  // At most 32 iteration
	
	
	  for (var i = 0; i < 32; i++) {
	    // var prev = t - interval;
	    var next = t + interval; // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
	    // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
	
	    v2[0] = quadraticAt(p0[0], p1[0], p2[0], t);
	    v2[1] = quadraticAt(p0[1], p1[1], p2[1], t);
	    v3[0] = quadraticAt(p0[0], p1[0], p2[0], next);
	    v3[1] = quadraticAt(p0[1], p1[1], p2[1], next);
	    var diff = v2DistSquare(v2, center) - radiusSquare;
	
	    if (mathAbs(diff) < 1e-2) {
	      break;
	    } // var prevDiff = v2DistSquare(v1, center) - radiusSquare;
	
	
	    var nextDiff = v2DistSquare(v3, center) - radiusSquare;
	    interval /= 2;
	
	    if (diff < 0) {
	      if (nextDiff >= 0) {
	        t = t + interval;
	      } else {
	        t = t - interval;
	      }
	    } else {
	      if (nextDiff >= 0) {
	        t = t - interval;
	      } else {
	        t = t + interval;
	      }
	    }
	  }
	
	  return t;
	} // Adjust edge to avoid
	
	
	function _default(graph, scale) {
	  var tmp0 = [];
	  var quadraticSubdivide = curveTool.quadraticSubdivide;
	  var pts = [[], [], []];
	  var pts2 = [[], []];
	  var v = [];
	  scale /= 2;
	  graph.eachEdge(function (edge, idx) {
	    var linePoints = edge.getLayout();
	    var fromSymbol = edge.getVisual('fromSymbol');
	    var toSymbol = edge.getVisual('toSymbol');
	
	    if (!linePoints.__original) {
	      linePoints.__original = [vec2.clone(linePoints[0]), vec2.clone(linePoints[1])];
	
	      if (linePoints[2]) {
	        linePoints.__original.push(vec2.clone(linePoints[2]));
	      }
	    }
	
	    var originalPoints = linePoints.__original; // Quadratic curve
	
	    if (linePoints[2] != null) {
	      vec2.copy(pts[0], originalPoints[0]);
	      vec2.copy(pts[1], originalPoints[2]);
	      vec2.copy(pts[2], originalPoints[1]);
	
	      if (fromSymbol && fromSymbol !== 'none') {
	        var symbolSize = getSymbolSize(edge.node1);
	        var t = intersectCurveCircle(pts, originalPoints[0], symbolSize * scale); // Subdivide and get the second
	
	        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	        pts[0][0] = tmp0[3];
	        pts[1][0] = tmp0[4];
	        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	        pts[0][1] = tmp0[3];
	        pts[1][1] = tmp0[4];
	      }
	
	      if (toSymbol && toSymbol !== 'none') {
	        var symbolSize = getSymbolSize(edge.node2);
	        var t = intersectCurveCircle(pts, originalPoints[1], symbolSize * scale); // Subdivide and get the first
	
	        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	        pts[1][0] = tmp0[1];
	        pts[2][0] = tmp0[2];
	        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	        pts[1][1] = tmp0[1];
	        pts[2][1] = tmp0[2];
	      } // Copy back to layout
	
	
	      vec2.copy(linePoints[0], pts[0]);
	      vec2.copy(linePoints[1], pts[2]);
	      vec2.copy(linePoints[2], pts[1]);
	    } // Line
	    else {
	        vec2.copy(pts2[0], originalPoints[0]);
	        vec2.copy(pts2[1], originalPoints[1]);
	        vec2.sub(v, pts2[1], pts2[0]);
	        vec2.normalize(v, v);
	
	        if (fromSymbol && fromSymbol !== 'none') {
	          var symbolSize = getSymbolSize(edge.node1);
	          vec2.scaleAndAdd(pts2[0], pts2[0], v, symbolSize * scale);
	        }
	
	        if (toSymbol && toSymbol !== 'none') {
	          var symbolSize = getSymbolSize(edge.node2);
	          vec2.scaleAndAdd(pts2[1], pts2[1], v, -symbolSize * scale);
	        }
	
	        vec2.copy(linePoints[0], pts2[0]);
	        vec2.copy(linePoints[1], pts2[1]);
	      }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getNodeGlobalScale(seriesModel) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys.type !== 'view') {
	    return 1;
	  }
	
	  var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
	  var groupScale = coordSys.scale;
	  var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
	
	  var roamZoom = coordSys.getZoom();
	  var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	  return nodeScale / groupZoom;
	}
	
	function getSymbolSize(node) {
	  var symbolSize = node.getVisual('symbolSize');
	
	  if (symbolSize instanceof Array) {
	    symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
	  }
	
	  return +symbolSize;
	}
	
	exports.getNodeGlobalScale = getNodeGlobalScale;
	exports.getSymbolSize = getSymbolSize;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var _roamHelper = __webpack_require__(443);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	__webpack_require__(482);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var actionInfo = {
	  type: 'graphRoam',
	  event: 'graphRoam',
	  update: 'none'
	};
	/**
	 * @payload
	 * @property {string} name Series name
	 * @property {number} [dx]
	 * @property {number} [dy]
	 * @property {number} [zoom]
	 * @property {number} [originX]
	 * @property {number} [originY]
	 */
	
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    query: payload
	  }, function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var res = updateCenterAndZoom(coordSys, payload);
	    seriesModel.setCenter && seriesModel.setCenter(res.center);
	    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	  });
	});

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {number} [seriesIndex]
	 * @property {string} [seriesId]
	 * @property {string} [seriesName]
	 * @property {number} [dataIndex]
	 */
	echarts.registerAction({
	  type: 'focusNodeAdjacency',
	  event: 'focusNodeAdjacency',
	  update: 'series:focusNodeAdjacency'
	}, function () {});
	/**
	 * @payload
	 * @property {number} [seriesIndex]
	 * @property {string} [seriesId]
	 * @property {string} [seriesName]
	 */
	
	echarts.registerAction({
	  type: 'unfocusNodeAdjacency',
	  event: 'unfocusNodeAdjacency',
	  update: 'series:unfocusNodeAdjacency'
	}, function () {});

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (!legendModels || !legendModels.length) {
	    return;
	  }
	
	  ecModel.eachSeriesByType('graph', function (graphSeries) {
	    var categoriesData = graphSeries.getCategoriesData();
	    var graph = graphSeries.getGraph();
	    var data = graph.data;
	    var categoryNames = categoriesData.mapArray(categoriesData.getName);
	    data.filterSelf(function (idx) {
	      var model = data.getItemModel(idx);
	      var category = model.getShallow('category');
	
	      if (category != null) {
	        if (typeof category === 'number') {
	          category = categoryNames[category];
	        } // If in any legend component the status is not selected.
	
	
	        for (var i = 0; i < legendModels.length; i++) {
	          if (!legendModels[i].isSelected(category)) {
	            return false;
	          }
	        }
	      }
	
	      return true;
	    });
	  }, this);
	}
	
	module.exports = _default;

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var paletteScope = {};
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var categoriesData = seriesModel.getCategoriesData();
	    var data = seriesModel.getData();
	    var categoryNameIdxMap = {};
	    categoriesData.each(function (idx) {
	      var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.
	
	      categoryNameIdxMap['ec-' + name] = idx;
	      var itemModel = categoriesData.getItemModel(idx);
	      var color = itemModel.get('itemStyle.color') || seriesModel.getColorFromPalette(name, paletteScope);
	      categoriesData.setItemVisual(idx, 'color', color);
	      var itemStyleList = ['opacity', 'symbol', 'symbolSize', 'symbolKeepAspect'];
	
	      for (var i = 0; i < itemStyleList.length; i++) {
	        var itemStyle = itemModel.getShallow(itemStyleList[i], true);
	
	        if (itemStyle != null) {
	          categoriesData.setItemVisual(idx, itemStyleList[i], itemStyle);
	        }
	      }
	    }); // Assign category color to visual
	
	    if (categoriesData.count()) {
	      data.each(function (idx) {
	        var model = data.getItemModel(idx);
	        var category = model.getShallow('category');
	
	        if (category != null) {
	          if (typeof category === 'string') {
	            category = categoryNameIdxMap['ec-' + category];
	          }
	
	          var itemStyleList = ['color', 'opacity', 'symbol', 'symbolSize', 'symbolKeepAspect'];
	
	          for (var i = 0; i < itemStyleList.length; i++) {
	            if (data.getItemVisual(idx, itemStyleList[i], true) == null) {
	              data.setItemVisual(idx, itemStyleList[i], categoriesData.getItemVisual(category, itemStyleList[i]));
	            }
	          }
	        }
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalize(a) {
	  if (!(a instanceof Array)) {
	    a = [a, a];
	  }
	
	  return a;
	}
	
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var graph = seriesModel.getGraph();
	    var edgeData = seriesModel.getEdgeData();
	    var symbolType = normalize(seriesModel.get('edgeSymbol'));
	    var symbolSize = normalize(seriesModel.get('edgeSymbolSize'));
	    var colorQuery = 'lineStyle.color'.split('.');
	    var opacityQuery = 'lineStyle.opacity'.split('.');
	    edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
	    edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
	    edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	    edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	    edgeData.setVisual('color', seriesModel.get(colorQuery));
	    edgeData.setVisual('opacity', seriesModel.get(opacityQuery));
	    edgeData.each(function (idx) {
	      var itemModel = edgeData.getItemModel(idx);
	      var edge = graph.getEdgeByIndex(idx);
	      var symbolType = normalize(itemModel.getShallow('symbol', true));
	      var symbolSize = normalize(itemModel.getShallow('symbolSize', true)); // Edge visual must after node visual
	
	      var color = itemModel.get(colorQuery);
	      var opacity = itemModel.get(opacityQuery);
	
	      switch (color) {
	        case 'source':
	          color = edge.node1.getVisual('color');
	          break;
	
	        case 'target':
	          color = edge.node2.getVisual('color');
	          break;
	      }
	
	      symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
	      symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
	      symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
	      symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
	      edge.setVisual('color', color);
	      edge.setVisual('opacity', opacity);
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	
	var _simpleLayoutHelper = __webpack_require__(487);
	
	var simpleLayout = _simpleLayoutHelper.simpleLayout;
	var simpleLayoutEdge = _simpleLayoutHelper.simpleLayoutEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var layout = seriesModel.get('layout');
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.type !== 'view') {
	      var data = seriesModel.getData();
	      var dimensions = [];
	      each(coordSys.dimensions, function (coordDim) {
	        dimensions = dimensions.concat(data.mapDimension(coordDim, true));
	      });
	
	      for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
	        var value = [];
	        var hasValue = false;
	
	        for (var i = 0; i < dimensions.length; i++) {
	          var val = data.get(dimensions[i], dataIndex);
	
	          if (!isNaN(val)) {
	            hasValue = true;
	          }
	
	          value.push(val);
	        }
	
	        if (hasValue) {
	          data.setItemLayout(dataIndex, coordSys.dataToPoint(value));
	        } else {
	          // Also {Array.<number>}, not undefined to avoid if...else... statement
	          data.setItemLayout(dataIndex, [NaN, NaN]);
	        }
	      }
	
	      simpleLayoutEdge(data.graph, seriesModel);
	    } else if (!layout || layout === 'none') {
	      simpleLayout(seriesModel);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(222);
	
	var zrUtil = __webpack_require__(220);
	
	var _multipleGraphEdgeHelper = __webpack_require__(474);
	
	var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function simpleLayout(seriesModel) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys && coordSys.type !== 'view') {
	    return;
	  }
	
	  var graph = seriesModel.getGraph();
	  graph.eachNode(function (node) {
	    var model = node.getModel();
	    node.setLayout([+model.get('x'), +model.get('y')]);
	  });
	  simpleLayoutEdge(graph, seriesModel);
	}
	
	function simpleLayoutEdge(graph, seriesModel) {
	  graph.eachEdge(function (edge, index) {
	    var curveness = zrUtil.retrieve3(edge.getModel().get('lineStyle.curveness'), -getCurvenessForEdge(edge, seriesModel, index, true), 0);
	    var p1 = vec2.clone(edge.node1.getLayout());
	    var p2 = vec2.clone(edge.node2.getLayout());
	    var points = [p1, p2];
	
	    if (+curveness) {
	      points.push([(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness]);
	    }
	
	    edge.setLayout(points);
	  });
	}
	
	exports.simpleLayout = simpleLayout;
	exports.simpleLayoutEdge = simpleLayoutEdge;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _circularLayoutHelper = __webpack_require__(489);
	
	var circularLayout = _circularLayoutHelper.circularLayout;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    if (seriesModel.get('layout') === 'circular') {
	      circularLayout(seriesModel, 'symbolSize');
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(222);
	
	var _graphHelper = __webpack_require__(480);
	
	var getSymbolSize = _graphHelper.getSymbolSize;
	var getNodeGlobalScale = _graphHelper.getNodeGlobalScale;
	
	var zrUtil = __webpack_require__(220);
	
	var _multipleGraphEdgeHelper = __webpack_require__(474);
	
	var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	var _symbolRadiansHalf = [];
	/**
	 * `basedOn` can be:
	 * 'value':
	 *     This layout is not accurate and have same bad case. For example,
	 *     if the min value is very smaller than the max value, the nodes
	 *     with the min value probably overlap even though there is enough
	 *     space to layout them. So we only use this approach in the as the
	 *     init layout of the force layout.
	 *     FIXME
	 *     Probably we do not need this method any more but use
	 *     `basedOn: 'symbolSize'` in force layout if
	 *     delay its init operations to GraphView.
	 * 'symbolSize':
	 *     This approach work only if all of the symbol size calculated.
	 *     That is, the progressive rendering is not applied to graph.
	 *     FIXME
	 *     If progressive rendering is applied to graph some day,
	 *     probably we have to use `basedOn: 'value'`.
	 *
	 * @param {module:echarts/src/model/Series} seriesModel
	 * @param {string} basedOn 'value' or 'symbolSize'
	 */
	
	function circularLayout(seriesModel, basedOn) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys && coordSys.type !== 'view') {
	    return;
	  }
	
	  var rect = coordSys.getBoundingRect();
	  var nodeData = seriesModel.getData();
	  var graph = nodeData.graph;
	  var cx = rect.width / 2 + rect.x;
	  var cy = rect.height / 2 + rect.y;
	  var r = Math.min(rect.width, rect.height) / 2;
	  var count = nodeData.count();
	  nodeData.setLayout({
	    cx: cx,
	    cy: cy
	  });
	
	  if (!count) {
	    return;
	  }
	
	  _layoutNodesBasedOn[basedOn](seriesModel, coordSys, graph, nodeData, r, cx, cy, count);
	
	  graph.eachEdge(function (edge, index) {
	    var curveness = zrUtil.retrieve3(edge.getModel().get('lineStyle.curveness'), getCurvenessForEdge(edge, seriesModel, index), 0);
	    var p1 = vec2.clone(edge.node1.getLayout());
	    var p2 = vec2.clone(edge.node2.getLayout());
	    var cp1;
	    var x12 = (p1[0] + p2[0]) / 2;
	    var y12 = (p1[1] + p2[1]) / 2;
	
	    if (+curveness) {
	      curveness *= 3;
	      cp1 = [cx * curveness + x12 * (1 - curveness), cy * curveness + y12 * (1 - curveness)];
	    }
	
	    edge.setLayout([p1, p2, cp1]);
	  });
	}
	
	var _layoutNodesBasedOn = {
	  value: function (seriesModel, coordSys, graph, nodeData, r, cx, cy, count) {
	    var angle = 0;
	    var sum = nodeData.getSum('value');
	    var unitAngle = Math.PI * 2 / (sum || count);
	    graph.eachNode(function (node) {
	      var value = node.getValue('value');
	      var radianHalf = unitAngle * (sum ? value : 1) / 2;
	      angle += radianHalf;
	      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
	      angle += radianHalf;
	    });
	  },
	  symbolSize: function (seriesModel, coordSys, graph, nodeData, r, cx, cy, count) {
	    var sumRadian = 0;
	    _symbolRadiansHalf.length = count;
	    var nodeScale = getNodeGlobalScale(seriesModel);
	    graph.eachNode(function (node) {
	      var symbolSize = getSymbolSize(node); // Normally this case will not happen, but we still add
	      // some the defensive code (2px is an arbitrary value).
	
	      isNaN(symbolSize) && (symbolSize = 2);
	      symbolSize < 0 && (symbolSize = 0);
	      symbolSize *= nodeScale;
	      var symbolRadianHalf = Math.asin(symbolSize / 2 / r); // when `symbolSize / 2` is bigger than `r`.
	
	      isNaN(symbolRadianHalf) && (symbolRadianHalf = PI / 2);
	      _symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
	      sumRadian += symbolRadianHalf * 2;
	    });
	    var halfRemainRadian = (2 * PI - sumRadian) / count / 2;
	    var angle = 0;
	    graph.eachNode(function (node) {
	      var radianHalf = halfRemainRadian + _symbolRadiansHalf[node.dataIndex];
	      angle += radianHalf;
	      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
	      angle += radianHalf;
	    });
	  }
	};
	exports.circularLayout = circularLayout;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _forceHelper = __webpack_require__(491);
	
	var forceLayout = _forceHelper.forceLayout;
	
	var _simpleLayoutHelper = __webpack_require__(487);
	
	var simpleLayout = _simpleLayoutHelper.simpleLayout;
	
	var _circularLayoutHelper = __webpack_require__(489);
	
	var circularLayout = _circularLayoutHelper.circularLayout;
	
	var _number = __webpack_require__(306);
	
	var linearMap = _number.linearMap;
	
	var vec2 = __webpack_require__(222);
	
	var zrUtil = __webpack_require__(220);
	
	var _multipleGraphEdgeHelper = __webpack_require__(474);
	
	var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (graphSeries) {
	    var coordSys = graphSeries.coordinateSystem;
	
	    if (coordSys && coordSys.type !== 'view') {
	      return;
	    }
	
	    if (graphSeries.get('layout') === 'force') {
	      var preservedPoints = graphSeries.preservedPoints || {};
	      var graph = graphSeries.getGraph();
	      var nodeData = graph.data;
	      var edgeData = graph.edgeData;
	      var forceModel = graphSeries.getModel('force');
	      var initLayout = forceModel.get('initLayout');
	
	      if (graphSeries.preservedPoints) {
	        nodeData.each(function (idx) {
	          var id = nodeData.getId(idx);
	          nodeData.setItemLayout(idx, preservedPoints[id] || [NaN, NaN]);
	        });
	      } else if (!initLayout || initLayout === 'none') {
	        simpleLayout(graphSeries);
	      } else if (initLayout === 'circular') {
	        circularLayout(graphSeries, 'value');
	      }
	
	      var nodeDataExtent = nodeData.getDataExtent('value');
	      var edgeDataExtent = edgeData.getDataExtent('value'); // var edgeDataExtent = edgeData.getDataExtent('value');
	
	      var repulsion = forceModel.get('repulsion');
	      var edgeLength = forceModel.get('edgeLength');
	
	      if (!zrUtil.isArray(repulsion)) {
	        repulsion = [repulsion, repulsion];
	      }
	
	      if (!zrUtil.isArray(edgeLength)) {
	        edgeLength = [edgeLength, edgeLength];
	      } // Larger value has smaller length
	
	
	      edgeLength = [edgeLength[1], edgeLength[0]];
	      var nodes = nodeData.mapArray('value', function (value, idx) {
	        var point = nodeData.getItemLayout(idx);
	        var rep = linearMap(value, nodeDataExtent, repulsion);
	
	        if (isNaN(rep)) {
	          rep = (repulsion[0] + repulsion[1]) / 2;
	        }
	
	        return {
	          w: rep,
	          rep: rep,
	          fixed: nodeData.getItemModel(idx).get('fixed'),
	          p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
	        };
	      });
	      var edges = edgeData.mapArray('value', function (value, idx) {
	        var edge = graph.getEdgeByIndex(idx);
	        var d = linearMap(value, edgeDataExtent, edgeLength);
	
	        if (isNaN(d)) {
	          d = (edgeLength[0] + edgeLength[1]) / 2;
	        }
	
	        var edgeModel = edge.getModel();
	        var curveness = zrUtil.retrieve3(edgeModel.get('lineStyle.curveness'), -getCurvenessForEdge(edge, graphSeries, idx, true), 0);
	        return {
	          n1: nodes[edge.node1.dataIndex],
	          n2: nodes[edge.node2.dataIndex],
	          d: d,
	          curveness: curveness,
	          ignoreForceLayout: edgeModel.get('ignoreForceLayout')
	        };
	      });
	      var coordSys = graphSeries.coordinateSystem;
	      var rect = coordSys.getBoundingRect();
	      var forceInstance = forceLayout(nodes, edges, {
	        rect: rect,
	        gravity: forceModel.get('gravity'),
	        friction: forceModel.get('friction')
	      });
	      var oldStep = forceInstance.step;
	
	      forceInstance.step = function (cb) {
	        for (var i = 0, l = nodes.length; i < l; i++) {
	          if (nodes[i].fixed) {
	            // Write back to layout instance
	            vec2.copy(nodes[i].p, graph.getNodeByIndex(i).getLayout());
	          }
	        }
	
	        oldStep(function (nodes, edges, stopped) {
	          for (var i = 0, l = nodes.length; i < l; i++) {
	            if (!nodes[i].fixed) {
	              graph.getNodeByIndex(i).setLayout(nodes[i].p);
	            }
	
	            preservedPoints[nodeData.getId(i)] = nodes[i].p;
	          }
	
	          for (var i = 0, l = edges.length; i < l; i++) {
	            var e = edges[i];
	            var edge = graph.getEdgeByIndex(i);
	            var p1 = e.n1.p;
	            var p2 = e.n2.p;
	            var points = edge.getLayout();
	            points = points ? points.slice() : [];
	            points[0] = points[0] || [];
	            points[1] = points[1] || [];
	            vec2.copy(points[0], p1);
	            vec2.copy(points[1], p2);
	
	            if (+e.curveness) {
	              points[2] = [(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness];
	            }
	
	            edge.setLayout(points);
	          } // Update layout
	
	
	          cb && cb(stopped);
	        });
	      };
	
	      graphSeries.forceLayout = forceInstance;
	      graphSeries.preservedPoints = preservedPoints; // Step to get the layout
	
	      forceInstance.step();
	    } else {
	      // Remove prev injected forceLayout instance
	      graphSeries.forceLayout = null;
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(222);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* Some formulas were originally copied from "d3.js" with some
	* modifications made for this project.
	* (See more details in the comment of the method "step" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var scaleAndAdd = vec2.scaleAndAdd; // function adjacentNode(n, e) {
	//     return e.n1 === n ? e.n2 : e.n1;
	// }
	
	function forceLayout(nodes, edges, opts) {
	  var rect = opts.rect;
	  var width = rect.width;
	  var height = rect.height;
	  var center = [rect.x + width / 2, rect.y + height / 2]; // var scale = opts.scale || 1;
	
	  var gravity = opts.gravity == null ? 0.1 : opts.gravity; // for (var i = 0; i < edges.length; i++) {
	  //     var e = edges[i];
	  //     var n1 = e.n1;
	  //     var n2 = e.n2;
	  //     n1.edges = n1.edges || [];
	  //     n2.edges = n2.edges || [];
	  //     n1.edges.push(e);
	  //     n2.edges.push(e);
	  // }
	  // Init position
	
	  for (var i = 0; i < nodes.length; i++) {
	    var n = nodes[i];
	
	    if (!n.p) {
	      n.p = vec2.create(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
	    }
	
	    n.pp = vec2.clone(n.p);
	    n.edges = null;
	  } // Formula in 'Graph Drawing by Force-directed Placement'
	  // var k = scale * Math.sqrt(width * height / nodes.length);
	  // var k2 = k * k;
	
	
	  var initialFriction = opts.friction == null ? 0.6 : opts.friction;
	  var friction = initialFriction;
	  return {
	    warmUp: function () {
	      friction = initialFriction * 0.8;
	    },
	    setFixed: function (idx) {
	      nodes[idx].fixed = true;
	    },
	    setUnfixed: function (idx) {
	      nodes[idx].fixed = false;
	    },
	
	    /**
	     * Some formulas were originally copied from "d3.js"
	     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
	     * with some modifications made for this project.
	     * See the license statement at the head of this file.
	     */
	    step: function (cb) {
	      var v12 = [];
	      var nLen = nodes.length;
	
	      for (var i = 0; i < edges.length; i++) {
	        var e = edges[i];
	
	        if (e.ignoreForceLayout) {
	          continue;
	        }
	
	        var n1 = e.n1;
	        var n2 = e.n2;
	        vec2.sub(v12, n2.p, n1.p);
	        var d = vec2.len(v12) - e.d;
	        var w = n2.w / (n1.w + n2.w);
	
	        if (isNaN(w)) {
	          w = 0;
	        }
	
	        vec2.normalize(v12, v12);
	        !n1.fixed && scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
	        !n2.fixed && scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
	      } // Gravity
	
	
	      for (var i = 0; i < nLen; i++) {
	        var n = nodes[i];
	
	        if (!n.fixed) {
	          vec2.sub(v12, center, n.p); // var d = vec2.len(v12);
	          // vec2.scale(v12, v12, 1 / d);
	          // var gravityFactor = gravity;
	
	          scaleAndAdd(n.p, n.p, v12, gravity * friction);
	        }
	      } // Repulsive
	      // PENDING
	
	
	      for (var i = 0; i < nLen; i++) {
	        var n1 = nodes[i];
	
	        for (var j = i + 1; j < nLen; j++) {
	          var n2 = nodes[j];
	          vec2.sub(v12, n2.p, n1.p);
	          var d = vec2.len(v12);
	
	          if (d === 0) {
	            // Random repulse
	            vec2.set(v12, Math.random() - 0.5, Math.random() - 0.5);
	            d = 1;
	          }
	
	          var repFact = (n1.rep + n2.rep) / d / d;
	          !n1.fixed && scaleAndAdd(n1.pp, n1.pp, v12, repFact);
	          !n2.fixed && scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
	        }
	      }
	
	      var v = [];
	
	      for (var i = 0; i < nLen; i++) {
	        var n = nodes[i];
	
	        if (!n.fixed) {
	          vec2.sub(v, n.p, n.pp);
	          scaleAndAdd(n.p, n.p, v, friction);
	          vec2.copy(n.pp, n.p);
	        }
	      }
	
	      friction = friction * 0.992;
	      cb && cb(nodes, edges, friction < 0.01);
	    }
	  };
	}
	
	exports.forceLayout = forceLayout;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var View = __webpack_require__(446);
	
	var _layout = __webpack_require__(305);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var bbox = __webpack_require__(273);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME Where to create the simple view coordinate system
	function getViewRect(seriesModel, api, aspect) {
	  var option = seriesModel.getBoxLayoutParams();
	  option.aspect = aspect;
	  return getLayoutRect(option, {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function _default(ecModel, api) {
	  var viewList = [];
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var coordSysType = seriesModel.get('coordinateSystem');
	
	    if (!coordSysType || coordSysType === 'view') {
	      var data = seriesModel.getData();
	      var positions = data.mapArray(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        return [+itemModel.get('x'), +itemModel.get('y')];
	      });
	      var min = [];
	      var max = [];
	      bbox.fromPoints(positions, min, max); // If width or height is 0
	
	      if (max[0] - min[0] === 0) {
	        max[0] += 1;
	        min[0] -= 1;
	      }
	
	      if (max[1] - min[1] === 0) {
	        max[1] += 1;
	        min[1] -= 1;
	      }
	
	      var aspect = (max[0] - min[0]) / (max[1] - min[1]); // FIXME If get view rect after data processed?
	
	      var viewRect = getViewRect(seriesModel, api, aspect); // Position may be NaN, use view rect instead
	
	      if (isNaN(aspect)) {
	        min = [viewRect.x, viewRect.y];
	        max = [viewRect.x + viewRect.width, viewRect.y + viewRect.height];
	      }
	
	      var bbWidth = max[0] - min[0];
	      var bbHeight = max[1] - min[1];
	      var viewWidth = viewRect.width;
	      var viewHeight = viewRect.height;
	      var viewCoordSys = seriesModel.coordinateSystem = new View();
	      viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	      viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
	      viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight); // Update roam info
	
	      viewCoordSys.setCenter(seriesModel.get('center'));
	      viewCoordSys.setZoom(seriesModel.get('zoom'));
	      viewList.push(viewCoordSys);
	    }
	  });
	  return viewList;
	}
	
	module.exports = _default;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(494);
	
	__webpack_require__(495);

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListSimply = __webpack_require__(404);
	
	var SeriesModel = __webpack_require__(320);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GaugeSeries = SeriesModel.extend({
	  type: 'series.gauge',
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, ['value']);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    legendHoverLink: true,
	    radius: '75%',
	    startAngle: 225,
	    endAngle: -45,
	    clockwise: true,
	    // 最小值
	    min: 0,
	    // 最大值
	    max: 100,
	    // 分割段数，默认为10
	    splitNumber: 10,
	    // 坐标轴线
	    axisLine: {
	      // 默认显示，属性show控制显示与否
	      show: true,
	      lineStyle: {
	        // 属性lineStyle控制线条样式
	        color: [[0.2, '#91c7ae'], [0.8, '#63869e'], [1, '#c23531']],
	        width: 30
	      }
	    },
	    // 分隔线
	    splitLine: {
	      // 默认显示，属性show控制显示与否
	      show: true,
	      // 属性length控制线长
	      length: 30,
	      // 属性lineStyle（详见lineStyle）控制线条样式
	      lineStyle: {
	        color: '#eee',
	        width: 2,
	        type: 'solid'
	      }
	    },
	    // 坐标轴小标记
	    axisTick: {
	      // 属性show控制显示与否，默认不显示
	      show: true,
	      // 每份split细分多少段
	      splitNumber: 5,
	      // 属性length控制线长
	      length: 8,
	      // 属性lineStyle控制线条样式
	      lineStyle: {
	        color: '#eee',
	        width: 1,
	        type: 'solid'
	      }
	    },
	    axisLabel: {
	      show: true,
	      distance: 5,
	      // formatter: null,
	      color: 'auto'
	    },
	    pointer: {
	      show: true,
	      length: '80%',
	      width: 8
	    },
	    itemStyle: {
	      color: 'auto'
	    },
	    title: {
	      show: true,
	      // x, y，单位px
	      offsetCenter: [0, '-40%'],
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: '#333',
	      fontSize: 15
	    },
	    detail: {
	      show: true,
	      backgroundColor: 'rgba(0,0,0,0)',
	      borderWidth: 0,
	      borderColor: '#ccc',
	      width: 100,
	      height: null,
	      // self-adaption
	      padding: [5, 10],
	      // x, y，单位px
	      offsetCenter: [0, '40%'],
	      // formatter: null,
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: 'auto',
	      fontSize: 30
	    }
	  }
	});
	var _default = GaugeSeries;
	module.exports = _default;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var PointerPath = __webpack_require__(496);
	
	var graphic = __webpack_require__(268);
	
	var ChartView = __webpack_require__(325);
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	var round = _number.round;
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function parsePosition(seriesModel, api) {
	  var center = seriesModel.get('center');
	  var width = api.getWidth();
	  var height = api.getHeight();
	  var size = Math.min(width, height);
	  var cx = parsePercent(center[0], api.getWidth());
	  var cy = parsePercent(center[1], api.getHeight());
	  var r = parsePercent(seriesModel.get('radius'), size / 2);
	  return {
	    cx: cx,
	    cy: cy,
	    r: r
	  };
	}
	
	function formatLabel(label, labelFormatter) {
	  if (labelFormatter) {
	    if (typeof labelFormatter === 'string') {
	      label = labelFormatter.replace('{value}', label != null ? label : '');
	    } else if (typeof labelFormatter === 'function') {
	      label = labelFormatter(label);
	    }
	  }
	
	  return label;
	}
	
	var PI2 = Math.PI * 2;
	var GaugeView = ChartView.extend({
	  type: 'gauge',
	  render: function (seriesModel, ecModel, api) {
	    this.group.removeAll();
	    var colorList = seriesModel.get('axisLine.lineStyle.color');
	    var posInfo = parsePosition(seriesModel, api);
	
	    this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
	  },
	  dispose: function () {},
	  _renderMain: function (seriesModel, ecModel, api, colorList, posInfo) {
	    var group = this.group;
	    var axisLineModel = seriesModel.getModel('axisLine');
	    var lineStyleModel = axisLineModel.getModel('lineStyle');
	    var clockwise = seriesModel.get('clockwise');
	    var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
	    var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
	    var angleRangeSpan = (endAngle - startAngle) % PI2;
	    var prevEndAngle = startAngle;
	    var axisLineWidth = lineStyleModel.get('width');
	    var showAxis = axisLineModel.get('show');
	
	    for (var i = 0; showAxis && i < colorList.length; i++) {
	      // Clamp
	      var percent = Math.min(Math.max(colorList[i][0], 0), 1);
	      var endAngle = startAngle + angleRangeSpan * percent;
	      var sector = new graphic.Sector({
	        shape: {
	          startAngle: prevEndAngle,
	          endAngle: endAngle,
	          cx: posInfo.cx,
	          cy: posInfo.cy,
	          clockwise: clockwise,
	          r0: posInfo.r - axisLineWidth,
	          r: posInfo.r
	        },
	        silent: true
	      });
	      sector.setStyle({
	        fill: colorList[i][1]
	      });
	      sector.setStyle(lineStyleModel.getLineStyle( // Because we use sector to simulate arc
	      // so the properties for stroking are useless
	      ['color', 'borderWidth', 'borderColor']));
	      group.add(sector);
	      prevEndAngle = endAngle;
	    }
	
	    var getColor = function (percent) {
	      // Less than 0
	      if (percent <= 0) {
	        return colorList[0][1];
	      }
	
	      for (var i = 0; i < colorList.length; i++) {
	        if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) {
	          return colorList[i][1];
	        }
	      } // More than 1
	
	
	      return colorList[i - 1][1];
	    };
	
	    if (!clockwise) {
	      var tmp = startAngle;
	      startAngle = endAngle;
	      endAngle = tmp;
	    }
	
	    this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
	
	    this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
	
	    this._renderTitle(seriesModel, ecModel, api, getColor, posInfo);
	
	    this._renderDetail(seriesModel, ecModel, api, getColor, posInfo);
	  },
	  _renderTicks: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
	    var group = this.group;
	    var cx = posInfo.cx;
	    var cy = posInfo.cy;
	    var r = posInfo.r;
	    var minVal = +seriesModel.get('min');
	    var maxVal = +seriesModel.get('max');
	    var splitLineModel = seriesModel.getModel('splitLine');
	    var tickModel = seriesModel.getModel('axisTick');
	    var labelModel = seriesModel.getModel('axisLabel');
	    var splitNumber = seriesModel.get('splitNumber');
	    var subSplitNumber = tickModel.get('splitNumber');
	    var splitLineLen = parsePercent(splitLineModel.get('length'), r);
	    var tickLen = parsePercent(tickModel.get('length'), r);
	    var angle = startAngle;
	    var step = (endAngle - startAngle) / splitNumber;
	    var subStep = step / subSplitNumber;
	    var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
	    var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();
	
	    for (var i = 0; i <= splitNumber; i++) {
	      var unitX = Math.cos(angle);
	      var unitY = Math.sin(angle); // Split line
	
	      if (splitLineModel.get('show')) {
	        var splitLine = new graphic.Line({
	          shape: {
	            x1: unitX * r + cx,
	            y1: unitY * r + cy,
	            x2: unitX * (r - splitLineLen) + cx,
	            y2: unitY * (r - splitLineLen) + cy
	          },
	          style: splitLineStyle,
	          silent: true
	        });
	
	        if (splitLineStyle.stroke === 'auto') {
	          splitLine.setStyle({
	            stroke: getColor(i / splitNumber)
	          });
	        }
	
	        group.add(splitLine);
	      } // Label
	
	
	      if (labelModel.get('show')) {
	        var label = formatLabel(round(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
	        var distance = labelModel.get('distance');
	        var autoColor = getColor(i / splitNumber);
	        group.add(new graphic.Text({
	          style: graphic.setTextStyle({}, labelModel, {
	            text: label,
	            x: unitX * (r - splitLineLen - distance) + cx,
	            y: unitY * (r - splitLineLen - distance) + cy,
	            textVerticalAlign: unitY < -0.4 ? 'top' : unitY > 0.4 ? 'bottom' : 'middle',
	            textAlign: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
	          }, {
	            autoColor: autoColor
	          }),
	          silent: true
	        }));
	      } // Axis tick
	
	
	      if (tickModel.get('show') && i !== splitNumber) {
	        for (var j = 0; j <= subSplitNumber; j++) {
	          var unitX = Math.cos(angle);
	          var unitY = Math.sin(angle);
	          var tickLine = new graphic.Line({
	            shape: {
	              x1: unitX * r + cx,
	              y1: unitY * r + cy,
	              x2: unitX * (r - tickLen) + cx,
	              y2: unitY * (r - tickLen) + cy
	            },
	            silent: true,
	            style: tickLineStyle
	          });
	
	          if (tickLineStyle.stroke === 'auto') {
	            tickLine.setStyle({
	              stroke: getColor((i + j / subSplitNumber) / splitNumber)
	            });
	          }
	
	          group.add(tickLine);
	          angle += subStep;
	        }
	
	        angle -= subStep;
	      } else {
	        angle += step;
	      }
	    }
	  },
	  _renderPointer: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
	    var group = this.group;
	    var oldData = this._data;
	
	    if (!seriesModel.get('pointer.show')) {
	      // Remove old element
	      oldData && oldData.eachItemGraphicEl(function (el) {
	        group.remove(el);
	      });
	      return;
	    }
	
	    var valueExtent = [+seriesModel.get('min'), +seriesModel.get('max')];
	    var angleExtent = [startAngle, endAngle];
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    data.diff(oldData).add(function (idx) {
	      var pointer = new PointerPath({
	        shape: {
	          angle: startAngle
	        }
	      });
	      graphic.initProps(pointer, {
	        shape: {
	          angle: linearMap(data.get(valueDim, idx), valueExtent, angleExtent, true)
	        }
	      }, seriesModel);
	      group.add(pointer);
	      data.setItemGraphicEl(idx, pointer);
	    }).update(function (newIdx, oldIdx) {
	      var pointer = oldData.getItemGraphicEl(oldIdx);
	      graphic.updateProps(pointer, {
	        shape: {
	          angle: linearMap(data.get(valueDim, newIdx), valueExtent, angleExtent, true)
	        }
	      }, seriesModel);
	      group.add(pointer);
	      data.setItemGraphicEl(newIdx, pointer);
	    }).remove(function (idx) {
	      var pointer = oldData.getItemGraphicEl(idx);
	      group.remove(pointer);
	    }).execute();
	    data.eachItemGraphicEl(function (pointer, idx) {
	      var itemModel = data.getItemModel(idx);
	      var pointerModel = itemModel.getModel('pointer');
	      pointer.setShape({
	        x: posInfo.cx,
	        y: posInfo.cy,
	        width: parsePercent(pointerModel.get('width'), posInfo.r),
	        r: parsePercent(pointerModel.get('length'), posInfo.r)
	      });
	      pointer.useStyle(itemModel.getModel('itemStyle').getItemStyle());
	
	      if (pointer.style.fill === 'auto') {
	        pointer.setStyle('fill', getColor(linearMap(data.get(valueDim, idx), valueExtent, [0, 1], true)));
	      }
	
	      graphic.setHoverStyle(pointer, itemModel.getModel('emphasis.itemStyle').getItemStyle());
	    });
	    this._data = data;
	  },
	  _renderTitle: function (seriesModel, ecModel, api, getColor, posInfo) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var titleModel = seriesModel.getModel('title');
	
	    if (titleModel.get('show')) {
	      var offsetCenter = titleModel.get('offsetCenter');
	      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
	      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
	      var minVal = +seriesModel.get('min');
	      var maxVal = +seriesModel.get('max');
	      var value = seriesModel.getData().get(valueDim, 0);
	      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	      this.group.add(new graphic.Text({
	        silent: true,
	        style: graphic.setTextStyle({}, titleModel, {
	          x: x,
	          y: y,
	          // FIXME First data name ?
	          text: data.getName(0),
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        }, {
	          autoColor: autoColor,
	          forceRich: true
	        })
	      }));
	    }
	  },
	  _renderDetail: function (seriesModel, ecModel, api, getColor, posInfo) {
	    var detailModel = seriesModel.getModel('detail');
	    var minVal = +seriesModel.get('min');
	    var maxVal = +seriesModel.get('max');
	
	    if (detailModel.get('show')) {
	      var offsetCenter = detailModel.get('offsetCenter');
	      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
	      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
	      var width = parsePercent(detailModel.get('width'), posInfo.r);
	      var height = parsePercent(detailModel.get('height'), posInfo.r);
	      var data = seriesModel.getData();
	      var value = data.get(data.mapDimension('value'), 0);
	      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	      this.group.add(new graphic.Text({
	        silent: true,
	        style: graphic.setTextStyle({}, detailModel, {
	          x: x,
	          y: y,
	          text: formatLabel( // FIXME First data name ?
	          value, detailModel.get('formatter')),
	          textWidth: isNaN(width) ? null : width,
	          textHeight: isNaN(height) ? null : height,
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        }, {
	          autoColor: autoColor,
	          forceRich: true
	        })
	      }));
	    }
	  }
	});
	var _default = GaugeView;
	module.exports = _default;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Path = __webpack_require__(270);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = Path.extend({
	  type: 'echartsGaugePointer',
	  shape: {
	    angle: 0,
	    width: 10,
	    r: 10,
	    x: 0,
	    y: 0
	  },
	  buildPath: function (ctx, shape) {
	    var mathCos = Math.cos;
	    var mathSin = Math.sin;
	    var r = shape.r;
	    var width = shape.width;
	    var angle = shape.angle;
	    var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
	    var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
	    angle = shape.angle - Math.PI / 2;
	    ctx.moveTo(x, y);
	    ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
	    ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
	    ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
	    ctx.lineTo(x, y);
	    return;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(498);
	
	__webpack_require__(499);
	
	var dataColor = __webpack_require__(409);
	
	var funnelLayout = __webpack_require__(500);
	
	var dataFilter = __webpack_require__(412);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(dataColor('funnel'));
	echarts.registerLayout(funnelLayout);
	echarts.registerProcessor(dataFilter('funnel'));

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var createListSimply = __webpack_require__(404);
	
	var _model = __webpack_require__(261);
	
	var defaultEmphasis = _model.defaultEmphasis;
	
	var _sourceHelper = __webpack_require__(311);
	
	var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;
	
	var LegendVisualProvider = __webpack_require__(406);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var FunnelSeries = echarts.extendSeriesModel({
	  type: 'series.funnel',
	  init: function (option) {
	    FunnelSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this)); // Extend labelLine emphasis
	
	    this._defaultLabelLine(option);
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      coordDimensions: ['value'],
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
	    });
	  },
	  _defaultLabelLine: function (option) {
	    // Extend labelLine emphasis
	    defaultEmphasis(option, 'labelLine', ['show']);
	    var labelLineNormalOpt = option.labelLine;
	    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
	
	    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
	    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
	  },
	  // Overwrite
	  getDataParams: function (dataIndex) {
	    var data = this.getData();
	    var params = FunnelSeries.superCall(this, 'getDataParams', dataIndex);
	    var valueDim = data.mapDimension('value');
	    var sum = data.getSum(valueDim); // Percent is 0 if sum is 0
	
	    params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
	    params.$vars.push('percent');
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    legendHoverLink: true,
	    left: 80,
	    top: 60,
	    right: 80,
	    bottom: 60,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    // 默认取数据最小最大值
	    // min: 0,
	    // max: 100,
	    minSize: '0%',
	    maxSize: '100%',
	    sort: 'descending',
	    // 'ascending', 'descending'
	    orient: 'vertical',
	    gap: 0,
	    funnelAlign: 'center',
	    label: {
	      show: true,
	      position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	    },
	    labelLine: {
	      show: true,
	      length: 20,
	      lineStyle: {
	        // color: 各异,
	        width: 1,
	        type: 'solid'
	      }
	    },
	    itemStyle: {
	      // color: 各异,
	      borderColor: '#fff',
	      borderWidth: 1
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = FunnelSeries;
	module.exports = _default;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var zrUtil = __webpack_require__(220);
	
	var ChartView = __webpack_require__(325);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Piece of pie including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	function FunnelPiece(data, idx) {
	  graphic.Group.call(this);
	  var polygon = new graphic.Polygon();
	  var labelLine = new graphic.Polyline();
	  var text = new graphic.Text();
	  this.add(polygon);
	  this.add(labelLine);
	  this.add(text);
	
	  this.highDownOnUpdate = function (fromState, toState) {
	    if (toState === 'emphasis') {
	      labelLine.ignore = labelLine.hoverIgnore;
	      text.ignore = text.hoverIgnore;
	    } else {
	      labelLine.ignore = labelLine.normalIgnore;
	      text.ignore = text.normalIgnore;
	    }
	  };
	
	  this.updateData(data, idx, true);
	}
	
	var funnelPieceProto = FunnelPiece.prototype;
	var opacityAccessPath = ['itemStyle', 'opacity'];
	
	funnelPieceProto.updateData = function (data, idx, firstCreate) {
	  var polygon = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var opacity = data.getItemModel(idx).get(opacityAccessPath);
	  opacity = opacity == null ? 1 : opacity; // Reset style
	
	  polygon.useStyle({});
	
	  if (firstCreate) {
	    polygon.setShape({
	      points: layout.points
	    });
	    polygon.setStyle({
	      opacity: 0
	    });
	    graphic.initProps(polygon, {
	      style: {
	        opacity: opacity
	      }
	    }, seriesModel, idx);
	  } else {
	    graphic.updateProps(polygon, {
	      style: {
	        opacity: opacity
	      },
	      shape: {
	        points: layout.points
	      }
	    }, seriesModel, idx);
	  } // Update common style
	
	
	  var itemStyleModel = itemModel.getModel('itemStyle');
	  var visualColor = data.getItemVisual(idx, 'color');
	  polygon.setStyle(zrUtil.defaults({
	    lineJoin: 'round',
	    fill: visualColor
	  }, itemStyleModel.getItemStyle(['opacity'])));
	  polygon.hoverStyle = itemStyleModel.getModel('emphasis').getItemStyle();
	
	  this._updateLabel(data, idx);
	
	  graphic.setHoverStyle(this);
	};
	
	funnelPieceProto._updateLabel = function (data, idx) {
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var labelLayout = layout.label;
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.updateProps(labelLine, {
	    shape: {
	      points: labelLayout.linePoints || labelLayout.linePoints
	    }
	  }, seriesModel, idx);
	  graphic.updateProps(labelText, {
	    style: {
	      x: labelLayout.x,
	      y: labelLayout.y
	    }
	  }, seriesModel, idx);
	  labelText.attr({
	    rotation: labelLayout.rotation,
	    origin: [labelLayout.x, labelLayout.y],
	    z2: 10
	  });
	  var labelModel = itemModel.getModel('label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelLineModel = itemModel.getModel('labelLine');
	  var labelLineHoverModel = itemModel.getModel('emphasis.labelLine');
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
	    labelFetcher: data.hostModel,
	    labelDataIndex: idx,
	    defaultText: data.getName(idx),
	    autoColor: visualColor,
	    useInsideStyle: !!labelLayout.inside
	  }, {
	    textAlign: labelLayout.textAlign,
	    textVerticalAlign: labelLayout.verticalAlign
	  });
	  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
	  labelText.hoverIgnore = !labelHoverModel.get('show');
	  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
	  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color
	
	  labelLine.setStyle({
	    stroke: visualColor
	  });
	  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
	  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
	};
	
	zrUtil.inherits(FunnelPiece, graphic.Group);
	var FunnelView = ChartView.extend({
	  type: 'funnel',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    data.diff(oldData).add(function (idx) {
	      var funnelPiece = new FunnelPiece(data, idx);
	      data.setItemGraphicEl(idx, funnelPiece);
	      group.add(funnelPiece);
	    }).update(function (newIdx, oldIdx) {
	      var piePiece = oldData.getItemGraphicEl(oldIdx);
	      piePiece.updateData(data, newIdx);
	      group.add(piePiece);
	      data.setItemGraphicEl(newIdx, piePiece);
	    }).remove(function (idx) {
	      var piePiece = oldData.getItemGraphicEl(idx);
	      group.remove(piePiece);
	    }).execute();
	    this._data = data;
	  },
	  remove: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: function () {}
	});
	var _default = FunnelView;
	module.exports = _default;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var layout = __webpack_require__(305);
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function getSortedIndices(data, sort) {
	  var valueDim = data.mapDimension('value');
	  var valueArr = data.mapArray(valueDim, function (val) {
	    return val;
	  });
	  var indices = [];
	  var isAscending = sort === 'ascending';
	
	  for (var i = 0, len = data.count(); i < len; i++) {
	    indices[i] = i;
	  } // Add custom sortable function & none sortable opetion by "options.sort"
	
	
	  if (typeof sort === 'function') {
	    indices.sort(sort);
	  } else if (sort !== 'none') {
	    indices.sort(function (a, b) {
	      return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
	    });
	  }
	
	  return indices;
	}
	
	function labelLayout(data) {
	  data.each(function (idx) {
	    var itemModel = data.getItemModel(idx);
	    var labelModel = itemModel.getModel('label');
	    var labelPosition = labelModel.get('position');
	    var orient = itemModel.get('orient');
	    var labelLineModel = itemModel.getModel('labelLine');
	    var layout = data.getItemLayout(idx);
	    var points = layout.points;
	    var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center' || labelPosition === 'insideLeft' || labelPosition === 'insideRight';
	    var textAlign;
	    var textX;
	    var textY;
	    var linePoints;
	
	    if (isLabelInside) {
	      if (labelPosition === 'insideLeft') {
	        textX = (points[0][0] + points[3][0]) / 2 + 5;
	        textY = (points[0][1] + points[3][1]) / 2;
	        textAlign = 'left';
	      } else if (labelPosition === 'insideRight') {
	        textX = (points[1][0] + points[2][0]) / 2 - 5;
	        textY = (points[1][1] + points[2][1]) / 2;
	        textAlign = 'right';
	      } else {
	        textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
	        textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
	        textAlign = 'center';
	      }
	
	      linePoints = [[textX, textY], [textX, textY]];
	    } else {
	      var x1;
	      var y1;
	      var x2;
	      var y2;
	      var labelLineLen = labelLineModel.get('length');
	
	      if (labelPosition === 'left') {
	        // Left side
	        x1 = (points[3][0] + points[0][0]) / 2;
	        y1 = (points[3][1] + points[0][1]) / 2;
	        x2 = x1 - labelLineLen;
	        textX = x2 - 5;
	        textAlign = 'right';
	      } else if (labelPosition === 'right') {
	        // Right side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	        x2 = x1 + labelLineLen;
	        textX = x2 + 5;
	        textAlign = 'left';
	      } else if (labelPosition === 'top') {
	        // Top side
	        x1 = (points[3][0] + points[0][0]) / 2;
	        y1 = (points[3][1] + points[0][1]) / 2;
	        y2 = y1 - labelLineLen;
	        textY = y2 - 5;
	        textAlign = 'center';
	      } else if (labelPosition === 'bottom') {
	        // Bottom side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	        y2 = y1 + labelLineLen;
	        textY = y2 + 5;
	        textAlign = 'center';
	      } else if (labelPosition === 'rightTop') {
	        // RightTop side
	        x1 = orient === 'horizontal' ? points[3][0] : points[1][0];
	        y1 = orient === 'horizontal' ? points[3][1] : points[1][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 - labelLineLen;
	          textY = y2 - 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 + labelLineLen;
	          textX = x2 + 5;
	          textAlign = 'top';
	        }
	      } else if (labelPosition === 'rightBottom') {
	        // RightBottom side
	        x1 = points[2][0];
	        y1 = points[2][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 + labelLineLen;
	          textY = y2 + 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 + labelLineLen;
	          textX = x2 + 5;
	          textAlign = 'bottom';
	        }
	      } else if (labelPosition === 'leftTop') {
	        // LeftTop side
	        x1 = points[0][0];
	        y1 = orient === 'horizontal' ? points[0][1] : points[1][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 - labelLineLen;
	          textY = y2 - 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 - labelLineLen;
	          textX = x2 - 5;
	          textAlign = 'right';
	        }
	      } else if (labelPosition === 'leftBottom') {
	        // LeftBottom side
	        x1 = orient === 'horizontal' ? points[1][0] : points[3][0];
	        y1 = orient === 'horizontal' ? points[1][1] : points[2][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 + labelLineLen;
	          textY = y2 + 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 - labelLineLen;
	          textX = x2 - 5;
	          textAlign = 'right';
	        }
	      } else {
	        // Right side or Bottom side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	
	        if (orient === 'horizontal') {
	          y2 = y1 + labelLineLen;
	          textY = y2 + 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 + labelLineLen;
	          textX = x2 + 5;
	          textAlign = 'left';
	        }
	      }
	
	      if (orient === 'horizontal') {
	        x2 = x1;
	        textX = x2;
	      } else {
	        y2 = y1;
	        textY = y2;
	      }
	
	      linePoints = [[x1, y1], [x2, y2]];
	    }
	
	    layout.label = {
	      linePoints: linePoints,
	      x: textX,
	      y: textY,
	      verticalAlign: 'middle',
	      textAlign: textAlign,
	      inside: isLabelInside
	    };
	  });
	}
	
	function _default(ecModel, api, payload) {
	  ecModel.eachSeriesByType('funnel', function (seriesModel) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var sort = seriesModel.get('sort');
	    var viewRect = getViewRect(seriesModel, api);
	    var indices = getSortedIndices(data, sort);
	    var orient = seriesModel.get('orient');
	    var viewWidth = viewRect.width;
	    var viewHeight = viewRect.height;
	    var x = viewRect.x;
	    var y = viewRect.y;
	    var sizeExtent = orient === 'horizontal' ? [parsePercent(seriesModel.get('minSize'), viewHeight), parsePercent(seriesModel.get('maxSize'), viewHeight)] : [parsePercent(seriesModel.get('minSize'), viewWidth), parsePercent(seriesModel.get('maxSize'), viewWidth)];
	    var dataExtent = data.getDataExtent(valueDim);
	    var min = seriesModel.get('min');
	    var max = seriesModel.get('max');
	
	    if (min == null) {
	      min = Math.min(dataExtent[0], 0);
	    }
	
	    if (max == null) {
	      max = dataExtent[1];
	    }
	
	    var funnelAlign = seriesModel.get('funnelAlign');
	    var gap = seriesModel.get('gap');
	    var viewSize = orient === 'horizontal' ? viewWidth : viewHeight;
	    var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();
	
	    var getLinePoints = function (idx, offset) {
	      // End point index is data.count() and we assign it 0
	      if (orient === 'horizontal') {
	        var val = data.get(valueDim, idx) || 0;
	        var itemHeight = linearMap(val, [min, max], sizeExtent, true);
	        var y0;
	
	        switch (funnelAlign) {
	          case 'top':
	            y0 = y;
	            break;
	
	          case 'center':
	            y0 = y + (viewHeight - itemHeight) / 2;
	            break;
	
	          case 'bottom':
	            y0 = y + (viewHeight - itemHeight);
	            break;
	        }
	
	        return [[offset, y0], [offset, y0 + itemHeight]];
	      }
	
	      var val = data.get(valueDim, idx) || 0;
	      var itemWidth = linearMap(val, [min, max], sizeExtent, true);
	      var x0;
	
	      switch (funnelAlign) {
	        case 'left':
	          x0 = x;
	          break;
	
	        case 'center':
	          x0 = x + (viewWidth - itemWidth) / 2;
	          break;
	
	        case 'right':
	          x0 = x + viewWidth - itemWidth;
	          break;
	      }
	
	      return [[x0, offset], [x0 + itemWidth, offset]];
	    };
	
	    if (sort === 'ascending') {
	      // From bottom to top
	      itemSize = -itemSize;
	      gap = -gap;
	
	      if (orient === 'horizontal') {
	        x += viewWidth;
	      } else {
	        y += viewHeight;
	      }
	
	      indices = indices.reverse();
	    }
	
	    for (var i = 0; i < indices.length; i++) {
	      var idx = indices[i];
	      var nextIdx = indices[i + 1];
	      var itemModel = data.getItemModel(idx);
	
	      if (orient === 'horizontal') {
	        var width = itemModel.get('itemStyle.width');
	
	        if (width == null) {
	          width = itemSize;
	        } else {
	          width = parsePercent(width, viewWidth);
	
	          if (sort === 'ascending') {
	            width = -width;
	          }
	        }
	
	        var start = getLinePoints(idx, x);
	        var end = getLinePoints(nextIdx, x + width);
	        x += width + gap;
	        data.setItemLayout(idx, {
	          points: start.concat(end.slice().reverse())
	        });
	      } else {
	        var height = itemModel.get('itemStyle.height');
	
	        if (height == null) {
	          height = itemSize;
	        } else {
	          height = parsePercent(height, viewHeight);
	
	          if (sort === 'ascending') {
	            height = -height;
	          }
	        }
	
	        var start = orient === 'horizontal' ? getLinePoints(idx, x) : getLinePoints(idx, y);
	        var end = orient === 'horizontal' ? getLinePoints(nextIdx, x + width) : getLinePoints(nextIdx, y + height);
	        y += height + gap;
	        data.setItemLayout(idx, {
	          points: start.concat(end.slice().reverse())
	        });
	      }
	    }
	
	    labelLayout(data);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(502);
	
	__webpack_require__(515);
	
	__webpack_require__(516);
	
	var parallelVisual = __webpack_require__(517);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(parallelVisual);

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var throttleUtil = __webpack_require__(327);
	
	var parallelPreprocessor = __webpack_require__(503);
	
	__webpack_require__(504);
	
	__webpack_require__(508);
	
	__webpack_require__(510);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CLICK_THRESHOLD = 5; // > 4
	// Parallel view
	
	echarts.extendComponentView({
	  type: 'parallel',
	  render: function (parallelModel, ecModel, api) {
	    this._model = parallelModel;
	    this._api = api;
	
	    if (!this._handlers) {
	      this._handlers = {};
	      zrUtil.each(handlers, function (handler, eventName) {
	        api.getZr().on(eventName, this._handlers[eventName] = zrUtil.bind(handler, this));
	      }, this);
	    }
	
	    throttleUtil.createOrUpdate(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
	  },
	  dispose: function (ecModel, api) {
	    zrUtil.each(this._handlers, function (handler, eventName) {
	      api.getZr().off(eventName, handler);
	    });
	    this._handlers = null;
	  },
	
	  /**
	   * @param {Object} [opt] If null, cancle the last action triggering for debounce.
	   */
	  _throttledDispatchExpand: function (opt) {
	    this._dispatchExpand(opt);
	  },
	  _dispatchExpand: function (opt) {
	    opt && this._api.dispatchAction(zrUtil.extend({
	      type: 'parallelAxisExpand'
	    }, opt));
	  }
	});
	var handlers = {
	  mousedown: function (e) {
	    if (checkTrigger(this, 'click')) {
	      this._mouseDownPoint = [e.offsetX, e.offsetY];
	    }
	  },
	  mouseup: function (e) {
	    var mouseDownPoint = this._mouseDownPoint;
	
	    if (checkTrigger(this, 'click') && mouseDownPoint) {
	      var point = [e.offsetX, e.offsetY];
	      var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
	
	      if (dist > CLICK_THRESHOLD) {
	        return;
	      }
	
	      var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	
	      result.behavior !== 'none' && this._dispatchExpand({
	        axisExpandWindow: result.axisExpandWindow
	      });
	    }
	
	    this._mouseDownPoint = null;
	  },
	  mousemove: function (e) {
	    // Should do nothing when brushing.
	    if (this._mouseDownPoint || !checkTrigger(this, 'mousemove')) {
	      return;
	    }
	
	    var model = this._model;
	    var result = model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	    var behavior = result.behavior;
	    behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));
	
	    this._throttledDispatchExpand(behavior === 'none' ? null // Cancle the last trigger, in case that mouse slide out of the area quickly.
	    : {
	      axisExpandWindow: result.axisExpandWindow,
	      // Jumping uses animation, and sliding suppresses animation.
	      animation: behavior === 'jump' ? null : false
	    });
	  }
	};
	
	function checkTrigger(view, triggerOn) {
	  var model = view._model;
	  return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
	}
	
	echarts.registerPreprocessor(parallelPreprocessor);

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var modelUtil = __webpack_require__(261);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  createParallelIfNeeded(option);
	  mergeAxisOptionFromParallel(option);
	}
	/**
	 * Create a parallel coordinate if not exists.
	 * @inner
	 */
	
	
	function createParallelIfNeeded(option) {
	  if (option.parallel) {
	    return;
	  }
	
	  var hasParallelSeries = false;
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'parallel') {
	      hasParallelSeries = true;
	    }
	  });
	
	  if (hasParallelSeries) {
	    option.parallel = [{}];
	  }
	}
	/**
	 * Merge aixs definition from parallel option (if exists) to axis option.
	 * @inner
	 */
	
	
	function mergeAxisOptionFromParallel(option) {
	  var axes = modelUtil.normalizeToArray(option.parallelAxis);
	  zrUtil.each(axes, function (axisOption) {
	    if (!zrUtil.isObject(axisOption)) {
	      return;
	    }
	
	    var parallelIndex = axisOption.parallelIndex || 0;
	    var parallelOption = modelUtil.normalizeToArray(option.parallel)[parallelIndex];
	
	    if (parallelOption && parallelOption.parallelAxisDefault) {
	      zrUtil.merge(axisOption, parallelOption.parallelAxisDefault, false);
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Parallel = __webpack_require__(505);
	
	var CoordinateSystem = __webpack_require__(315);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parallel coordinate system creater.
	 */
	function create(ecModel, api) {
	  var coordSysList = [];
	  ecModel.eachComponent('parallel', function (parallelModel, idx) {
	    var coordSys = new Parallel(parallelModel, ecModel, api);
	    coordSys.name = 'parallel_' + idx;
	    coordSys.resize(parallelModel, api);
	    parallelModel.coordinateSystem = coordSys;
	    coordSys.model = parallelModel;
	    coordSysList.push(coordSys);
	  }); // Inject the coordinateSystems into seriesModel
	
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.get('coordinateSystem') === 'parallel') {
	      var parallelModel = ecModel.queryComponents({
	        mainType: 'parallel',
	        index: seriesModel.get('parallelIndex'),
	        id: seriesModel.get('parallelId')
	      })[0];
	      seriesModel.coordinateSystem = parallelModel.coordinateSystem;
	    }
	  });
	  return coordSysList;
	}
	
	CoordinateSystem.register('parallel', {
	  create: create
	});

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var matrix = __webpack_require__(233);
	
	var layoutUtil = __webpack_require__(305);
	
	var axisHelper = __webpack_require__(350);
	
	var ParallelAxis = __webpack_require__(506);
	
	var graphic = __webpack_require__(268);
	
	var numberUtil = __webpack_require__(306);
	
	var sliderMove = __webpack_require__(507);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parallel Coordinates
	 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
	 */
	var each = zrUtil.each;
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathFloor = Math.floor;
	var mathCeil = Math.ceil;
	var round = numberUtil.round;
	var PI = Math.PI;
	
	function Parallel(parallelModel, ecModel, api) {
	  /**
	   * key: dimension
	   * @type {Object.<string, module:echarts/coord/parallel/Axis>}
	   * @private
	   */
	  this._axesMap = zrUtil.createHashMap();
	  /**
	   * key: dimension
	   * value: {position: [], rotation, }
	   * @type {Object.<string, Object>}
	   * @private
	   */
	
	  this._axesLayout = {};
	  /**
	   * Always follow axis order.
	   * @type {Array.<string>}
	   * @readOnly
	   */
	
	  this.dimensions = parallelModel.dimensions;
	  /**
	   * @type {module:zrender/core/BoundingRect}
	   */
	
	  this._rect;
	  /**
	   * @type {module:echarts/coord/parallel/ParallelModel}
	   */
	
	  this._model = parallelModel;
	
	  this._init(parallelModel, ecModel, api);
	}
	
	Parallel.prototype = {
	  type: 'parallel',
	  constructor: Parallel,
	
	  /**
	   * Initialize cartesian coordinate systems
	   * @private
	   */
	  _init: function (parallelModel, ecModel, api) {
	    var dimensions = parallelModel.dimensions;
	    var parallelAxisIndex = parallelModel.parallelAxisIndex;
	    each(dimensions, function (dim, idx) {
	      var axisIndex = parallelAxisIndex[idx];
	      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	
	      var axis = this._axesMap.set(dim, new ParallelAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisIndex));
	
	      var isCategory = axis.type === 'category';
	      axis.onBand = isCategory && axisModel.get('boundaryGap');
	      axis.inverse = axisModel.get('inverse'); // Injection
	
	      axisModel.axis = axis;
	      axis.model = axisModel;
	      axis.coordinateSystem = axisModel.coordinateSystem = this;
	    }, this);
	  },
	
	  /**
	   * Update axis scale after data processed
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  update: function (ecModel, api) {
	    this._updateAxesFromSeries(this._model, ecModel);
	  },
	
	  /**
	   * @override
	   */
	  containPoint: function (point) {
	    var layoutInfo = this._makeLayoutInfo();
	
	    var axisBase = layoutInfo.axisBase;
	    var layoutBase = layoutInfo.layoutBase;
	    var pixelDimIndex = layoutInfo.pixelDimIndex;
	    var pAxis = point[1 - pixelDimIndex];
	    var pLayout = point[pixelDimIndex];
	    return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
	  },
	  getModel: function () {
	    return this._model;
	  },
	
	  /**
	   * Update properties from series
	   * @private
	   */
	  _updateAxesFromSeries: function (parallelModel, ecModel) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (!parallelModel.contains(seriesModel, ecModel)) {
	        return;
	      }
	
	      var data = seriesModel.getData();
	      each(this.dimensions, function (dim) {
	        var axis = this._axesMap.get(dim);
	
	        axis.scale.unionExtentFromData(data, data.mapDimension(dim));
	        axisHelper.niceScaleExtent(axis.scale, axis.model);
	      }, this);
	    }, this);
	  },
	
	  /**
	   * Resize the parallel coordinate system.
	   * @param {module:echarts/coord/parallel/ParallelModel} parallelModel
	   * @param {module:echarts/ExtensionAPI} api
	   */
	  resize: function (parallelModel, api) {
	    this._rect = layoutUtil.getLayoutRect(parallelModel.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	
	    this._layoutAxes();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @private
	   */
	  _makeLayoutInfo: function () {
	    var parallelModel = this._model;
	    var rect = this._rect;
	    var xy = ['x', 'y'];
	    var wh = ['width', 'height'];
	    var layout = parallelModel.get('layout');
	    var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
	    var layoutLength = rect[wh[pixelDimIndex]];
	    var layoutExtent = [0, layoutLength];
	    var axisCount = this.dimensions.length;
	    var axisExpandWidth = restrict(parallelModel.get('axisExpandWidth'), layoutExtent);
	    var axisExpandCount = restrict(parallelModel.get('axisExpandCount') || 0, [0, axisCount]);
	    var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0; // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
	    // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
	    // where collapsed axes should be overlapped.
	
	    var axisExpandWindow = parallelModel.get('axisExpandWindow');
	    var winSize;
	
	    if (!axisExpandWindow) {
	      winSize = restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
	      var axisExpandCenter = parallelModel.get('axisExpandCenter') || mathFloor(axisCount / 2);
	      axisExpandWindow = [axisExpandWidth * axisExpandCenter - winSize / 2];
	      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	    } else {
	      winSize = restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
	      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	    }
	
	    var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount); // Avoid axisCollapseWidth is too small.
	
	    axisCollapseWidth < 3 && (axisCollapseWidth = 0); // Find the first and last indices > ewin[0] and < ewin[1].
	
	    var winInnerIndices = [mathFloor(round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1, mathCeil(round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1]; // Pos in ec coordinates.
	
	    var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
	    return {
	      layout: layout,
	      pixelDimIndex: pixelDimIndex,
	      layoutBase: rect[xy[pixelDimIndex]],
	      layoutLength: layoutLength,
	      axisBase: rect[xy[1 - pixelDimIndex]],
	      axisLength: rect[wh[1 - pixelDimIndex]],
	      axisExpandable: axisExpandable,
	      axisExpandWidth: axisExpandWidth,
	      axisCollapseWidth: axisCollapseWidth,
	      axisExpandWindow: axisExpandWindow,
	      axisCount: axisCount,
	      winInnerIndices: winInnerIndices,
	      axisExpandWindow0Pos: axisExpandWindow0Pos
	    };
	  },
	
	  /**
	   * @private
	   */
	  _layoutAxes: function () {
	    var rect = this._rect;
	    var axes = this._axesMap;
	    var dimensions = this.dimensions;
	
	    var layoutInfo = this._makeLayoutInfo();
	
	    var layout = layoutInfo.layout;
	    axes.each(function (axis) {
	      var axisExtent = [0, layoutInfo.axisLength];
	      var idx = axis.inverse ? 1 : 0;
	      axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
	    });
	    each(dimensions, function (dim, idx) {
	      var posInfo = (layoutInfo.axisExpandable ? layoutAxisWithExpand : layoutAxisWithoutExpand)(idx, layoutInfo);
	      var positionTable = {
	        horizontal: {
	          x: posInfo.position,
	          y: layoutInfo.axisLength
	        },
	        vertical: {
	          x: 0,
	          y: posInfo.position
	        }
	      };
	      var rotationTable = {
	        horizontal: PI / 2,
	        vertical: 0
	      };
	      var position = [positionTable[layout].x + rect.x, positionTable[layout].y + rect.y];
	      var rotation = rotationTable[layout];
	      var transform = matrix.create();
	      matrix.rotate(transform, transform, rotation);
	      matrix.translate(transform, transform, position); // TODO
	      // tick等排布信息。
	      // TODO
	      // 根据axis order 更新 dimensions顺序。
	
	      this._axesLayout[dim] = {
	        position: position,
	        rotation: rotation,
	        transform: transform,
	        axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
	        axisLabelShow: posInfo.axisLabelShow,
	        nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
	        tickDirection: 1,
	        labelDirection: 1
	      };
	    }, this);
	  },
	
	  /**
	   * Get axis by dim.
	   * @param {string} dim
	   * @return {module:echarts/coord/parallel/ParallelAxis} [description]
	   */
	  getAxis: function (dim) {
	    return this._axesMap.get(dim);
	  },
	
	  /**
	   * Convert a dim value of a single item of series data to Point.
	   * @param {*} value
	   * @param {string} dim
	   * @return {Array}
	   */
	  dataToPoint: function (value, dim) {
	    return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
	  },
	
	  /**
	   * Travel data for one time, get activeState of each data item.
	   * @param {module:echarts/data/List} data
	   * @param {Functio} cb param: {string} activeState 'active' or 'inactive' or 'normal'
	   *                            {number} dataIndex
	   * @param {number} [start=0] the start dataIndex that travel from.
	   * @param {number} [end=data.count()] the next dataIndex of the last dataIndex will be travel.
	   */
	  eachActiveState: function (data, callback, start, end) {
	    start == null && (start = 0);
	    end == null && (end = data.count());
	    var axesMap = this._axesMap;
	    var dimensions = this.dimensions;
	    var dataDimensions = [];
	    var axisModels = [];
	    zrUtil.each(dimensions, function (axisDim) {
	      dataDimensions.push(data.mapDimension(axisDim));
	      axisModels.push(axesMap.get(axisDim).model);
	    });
	    var hasActiveSet = this.hasAxisBrushed();
	
	    for (var dataIndex = start; dataIndex < end; dataIndex++) {
	      var activeState;
	
	      if (!hasActiveSet) {
	        activeState = 'normal';
	      } else {
	        activeState = 'active';
	        var values = data.getValues(dataDimensions, dataIndex);
	
	        for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	          var state = axisModels[j].getActiveState(values[j]);
	
	          if (state === 'inactive') {
	            activeState = 'inactive';
	            break;
	          }
	        }
	      }
	
	      callback(activeState, dataIndex);
	    }
	  },
	
	  /**
	   * Whether has any activeSet.
	   * @return {boolean}
	   */
	  hasAxisBrushed: function () {
	    var dimensions = this.dimensions;
	    var axesMap = this._axesMap;
	    var hasActiveSet = false;
	
	    for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	      if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') {
	        hasActiveSet = true;
	      }
	    }
	
	    return hasActiveSet;
	  },
	
	  /**
	   * Convert coords of each axis to Point.
	   *  Return point. For example: [10, 20]
	   * @param {Array.<number>} coords
	   * @param {string} dim
	   * @return {Array.<number>}
	   */
	  axisCoordToPoint: function (coord, dim) {
	    var axisLayout = this._axesLayout[dim];
	    return graphic.applyTransform([coord, 0], axisLayout.transform);
	  },
	
	  /**
	   * Get axis layout.
	   */
	  getAxisLayout: function (dim) {
	    return zrUtil.clone(this._axesLayout[dim]);
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
	   */
	  getSlidedAxisExpandWindow: function (point) {
	    var layoutInfo = this._makeLayoutInfo();
	
	    var pixelDimIndex = layoutInfo.pixelDimIndex;
	    var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
	    var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	    var extent = [0, layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)]; // Out of the area of coordinate system.
	
	    if (!this.containPoint(point)) {
	      return {
	        behavior: 'none',
	        axisExpandWindow: axisExpandWindow
	      };
	    } // Conver the point from global to expand coordinates.
	
	
	    var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos; // For dragging operation convenience, the window should not be
	    // slided when mouse is the center area of the window.
	
	    var delta;
	    var behavior = 'slide';
	    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	
	    var triggerArea = this._model.get('axisExpandSlideTriggerArea'); // But consider touch device, jump is necessary.
	
	
	    var useJump = triggerArea[0] != null;
	
	    if (axisCollapseWidth) {
	      if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
	        behavior = 'jump';
	        delta = pointCoord - winSize * triggerArea[2];
	      } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
	        behavior = 'jump';
	        delta = pointCoord - winSize * (1 - triggerArea[2]);
	      } else {
	        (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
	      }
	
	      delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
	      delta ? sliderMove(delta, axisExpandWindow, extent, 'all') // Avoid nonsense triger on mousemove.
	      : behavior = 'none';
	    } // When screen is too narrow, make it visible and slidable, although it is hard to interact.
	    else {
	        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	        var pos = extent[1] * pointCoord / winSize;
	        axisExpandWindow = [mathMax(0, pos - winSize / 2)];
	        axisExpandWindow[1] = mathMin(extent[1], axisExpandWindow[0] + winSize);
	        axisExpandWindow[0] = axisExpandWindow[1] - winSize;
	      }
	
	    return {
	      axisExpandWindow: axisExpandWindow,
	      behavior: behavior
	    };
	  }
	};
	
	function restrict(len, extent) {
	  return mathMin(mathMax(len, extent[0]), extent[1]);
	}
	
	function layoutAxisWithoutExpand(axisIndex, layoutInfo) {
	  var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
	  return {
	    position: step * axisIndex,
	    axisNameAvailableWidth: step,
	    axisLabelShow: true
	  };
	}
	
	function layoutAxisWithExpand(axisIndex, layoutInfo) {
	  var layoutLength = layoutInfo.layoutLength;
	  var axisExpandWidth = layoutInfo.axisExpandWidth;
	  var axisCount = layoutInfo.axisCount;
	  var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	  var winInnerIndices = layoutInfo.winInnerIndices;
	  var position;
	  var axisNameAvailableWidth = axisCollapseWidth;
	  var axisLabelShow = false;
	  var nameTruncateMaxWidth;
	
	  if (axisIndex < winInnerIndices[0]) {
	    position = axisIndex * axisCollapseWidth;
	    nameTruncateMaxWidth = axisCollapseWidth;
	  } else if (axisIndex <= winInnerIndices[1]) {
	    position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
	    axisNameAvailableWidth = axisExpandWidth;
	    axisLabelShow = true;
	  } else {
	    position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
	    nameTruncateMaxWidth = axisCollapseWidth;
	  }
	
	  return {
	    position: position,
	    axisNameAvailableWidth: axisNameAvailableWidth,
	    axisLabelShow: axisLabelShow,
	    nameTruncateMaxWidth: nameTruncateMaxWidth
	  };
	}
	
	var _default = Parallel;
	module.exports = _default;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Axis = __webpack_require__(364);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor module:echarts/coord/parallel/ParallelAxis
	 * @extends {module:echarts/coord/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 */
	var ParallelAxis = function (dim, scale, coordExtent, axisType, axisIndex) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.axisIndex = axisIndex;
	};
	
	ParallelAxis.prototype = {
	  constructor: ParallelAxis,
	
	  /**
	   * Axis model
	   * @param {module:echarts/coord/parallel/AxisModel}
	   */
	  model: null,
	
	  /**
	   * @override
	   */
	  isHorizontal: function () {
	    return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
	  }
	};
	zrUtil.inherits(ParallelAxis, Axis);
	var _default = ParallelAxis;
	module.exports = _default;

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Calculate slider move result.
	 * Usage:
	 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
	 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
	 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
	 *
	 * @param {number} delta Move length.
	 * @param {Array.<number>} handleEnds handleEnds[0] can be bigger then handleEnds[1].
	 *              handleEnds will be modified in this method.
	 * @param {Array.<number>} extent handleEnds is restricted by extent.
	 *              extent[0] should less or equals than extent[1].
	 * @param {number|string} handleIndex Can be 'all', means that both move the two handleEnds.
	 * @param {number} [minSpan] The range of dataZoom can not be smaller than that.
	 *              If not set, handle0 and cross handle1. If set as a non-negative
	 *              number (including `0`), handles will push each other when reaching
	 *              the minSpan.
	 * @param {number} [maxSpan] The range of dataZoom can not be larger than that.
	 * @return {Array.<number>} The input handleEnds.
	 */
	function _default(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
	  delta = delta || 0;
	  var extentSpan = extent[1] - extent[0]; // Notice maxSpan and minSpan can be null/undefined.
	
	  if (minSpan != null) {
	    minSpan = restrict(minSpan, [0, extentSpan]);
	  }
	
	  if (maxSpan != null) {
	    maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
	  }
	
	  if (handleIndex === 'all') {
	    var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
	    handleSpan = restrict(handleSpan, [0, extentSpan]);
	    minSpan = maxSpan = restrict(handleSpan, [minSpan, maxSpan]);
	    handleIndex = 0;
	  }
	
	  handleEnds[0] = restrict(handleEnds[0], extent);
	  handleEnds[1] = restrict(handleEnds[1], extent);
	  var originalDistSign = getSpanSign(handleEnds, handleIndex);
	  handleEnds[handleIndex] += delta; // Restrict in extent.
	
	  var extentMinSpan = minSpan || 0;
	  var realExtent = extent.slice();
	  originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
	  handleEnds[handleIndex] = restrict(handleEnds[handleIndex], realExtent); // Expand span.
	
	  var currDistSign = getSpanSign(handleEnds, handleIndex);
	
	  if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) {
	    // If minSpan exists, 'cross' is forbidden.
	    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
	  } // Shrink span.
	
	
	  var currDistSign = getSpanSign(handleEnds, handleIndex);
	
	  if (maxSpan != null && currDistSign.span > maxSpan) {
	    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
	  }
	
	  return handleEnds;
	}
	
	function getSpanSign(handleEnds, handleIndex) {
	  var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex]; // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
	  // is at left of handleEnds[1] for non-cross case.
	
	  return {
	    span: Math.abs(dist),
	    sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
	  };
	}
	
	function restrict(value, extend) {
	  return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
	}
	
	module.exports = _default;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Component = __webpack_require__(303);
	
	__webpack_require__(509);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = Component.extend({
	  type: 'parallel',
	  dependencies: ['parallelAxis'],
	
	  /**
	   * @type {module:echarts/coord/parallel/Parallel}
	   */
	  coordinateSystem: null,
	
	  /**
	   * Each item like: 'dim0', 'dim1', 'dim2', ...
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * Coresponding to dimensions.
	   * @type {Array.<number>}
	   * @readOnly
	   */
	  parallelAxisIndex: null,
	  layoutMode: 'box',
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    left: 80,
	    top: 60,
	    right: 80,
	    bottom: 60,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    layout: 'horizontal',
	    // 'horizontal' or 'vertical'
	    // FIXME
	    // naming?
	    axisExpandable: false,
	    axisExpandCenter: null,
	    axisExpandCount: 0,
	    axisExpandWidth: 50,
	    // FIXME '10%' ?
	    axisExpandRate: 17,
	    axisExpandDebounce: 50,
	    // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
	    // Do not doc to user until necessary.
	    axisExpandSlideTriggerArea: [-0.15, 0.05, 0.4],
	    axisExpandTriggerOn: 'click',
	    // 'mousemove' or 'click'
	    parallelAxisDefault: null
	  },
	
	  /**
	   * @override
	   */
	  init: function () {
	    Component.prototype.init.apply(this, arguments);
	    this.mergeOption({});
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (newOption) {
	    var thisOption = this.option;
	    newOption && zrUtil.merge(thisOption, newOption, true);
	
	    this._initDimensions();
	  },
	
	  /**
	   * Whether series or axis is in this coordinate system.
	   * @param {module:echarts/model/Series|module:echarts/coord/parallel/AxisModel} model
	   * @param {module:echarts/model/Global} ecModel
	   */
	  contains: function (model, ecModel) {
	    var parallelIndex = model.get('parallelIndex');
	    return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
	  },
	  setAxisExpand: function (opt) {
	    zrUtil.each(['axisExpandable', 'axisExpandCenter', 'axisExpandCount', 'axisExpandWidth', 'axisExpandWindow'], function (name) {
	      if (opt.hasOwnProperty(name)) {
	        this.option[name] = opt[name];
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _initDimensions: function () {
	    var dimensions = this.dimensions = [];
	    var parallelAxisIndex = this.parallelAxisIndex = [];
	    var axisModels = zrUtil.filter(this.dependentModels.parallelAxis, function (axisModel) {
	      // Can not use this.contains here, because
	      // initialization has not been completed yet.
	      return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
	    }, this);
	    zrUtil.each(axisModels, function (axisModel) {
	      dimensions.push('dim' + axisModel.get('dim'));
	      parallelAxisIndex.push(axisModel.componentIndex);
	    });
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var ComponentModel = __webpack_require__(303);
	
	var makeStyleMapper = __webpack_require__(265);
	
	var axisModelCreator = __webpack_require__(386);
	
	var numberUtil = __webpack_require__(306);
	
	var axisModelCommonMixin = __webpack_require__(359);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'baseParallelAxis',
	
	  /**
	   * @type {module:echarts/coord/parallel/Axis}
	   */
	  axis: null,
	
	  /**
	   * @type {Array.<Array.<number>}
	   * @readOnly
	   */
	  activeIntervals: [],
	
	  /**
	   * @return {Object}
	   */
	  getAreaSelectStyle: function () {
	    return makeStyleMapper([['fill', 'color'], ['lineWidth', 'borderWidth'], ['stroke', 'borderColor'], ['width', 'width'], ['opacity', 'opacity']])(this.getModel('areaSelectStyle'));
	  },
	
	  /**
	   * The code of this feature is put on AxisModel but not ParallelAxis,
	   * because axisModel can be alive after echarts updating but instance of
	   * ParallelAxis having been disposed. this._activeInterval should be kept
	   * when action dispatched (i.e. legend click).
	   *
	   * @param {Array.<Array<number>>} intervals interval.length === 0
	   *                                          means set all active.
	   * @public
	   */
	  setActiveIntervals: function (intervals) {
	    var activeIntervals = this.activeIntervals = zrUtil.clone(intervals); // Normalize
	
	    if (activeIntervals) {
	      for (var i = activeIntervals.length - 1; i >= 0; i--) {
	        numberUtil.asc(activeIntervals[i]);
	      }
	    }
	  },
	
	  /**
	   * @param {number|string} [value] When attempting to detect 'no activeIntervals set',
	   *                         value can not be input.
	   * @return {string} 'normal': no activeIntervals set,
	   *                  'active',
	   *                  'inactive'.
	   * @public
	   */
	  getActiveState: function (value) {
	    var activeIntervals = this.activeIntervals;
	
	    if (!activeIntervals.length) {
	      return 'normal';
	    }
	
	    if (value == null || isNaN(value)) {
	      return 'inactive';
	    } // Simple optimization
	
	
	    if (activeIntervals.length === 1) {
	      var interval = activeIntervals[0];
	
	      if (interval[0] <= value && value <= interval[1]) {
	        return 'active';
	      }
	    } else {
	      for (var i = 0, len = activeIntervals.length; i < len; i++) {
	        if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) {
	          return 'active';
	        }
	      }
	    }
	
	    return 'inactive';
	  }
	});
	var defaultOption = {
	  type: 'value',
	
	  /**
	   * @type {Array.<number>}
	   */
	  dim: null,
	  // 0, 1, 2, ...
	  // parallelIndex: null,
	  areaSelectStyle: {
	    width: 20,
	    borderWidth: 1,
	    borderColor: 'rgba(160,197,232)',
	    color: 'rgba(160,197,232)',
	    opacity: 0.3
	  },
	  realtime: true,
	  // Whether realtime update view when select.
	  z: 10
	};
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	
	function getAxisType(axisName, option) {
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	axisModelCreator('parallel', AxisModel, getAxisType, defaultOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(504);
	
	__webpack_require__(511);
	
	__webpack_require__(512);

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {string} parallelAxisId
	 * @property {Array.<Array.<number>>} intervals
	 */
	var actionInfo = {
	  type: 'axisAreaSelect',
	  event: 'axisAreaSelected' // update: 'updateVisual'
	
	};
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'parallelAxis',
	    query: payload
	  }, function (parallelAxisModel) {
	    parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
	  });
	});
	/**
	 * @payload
	 */
	
	echarts.registerAction('parallelAxisExpand', function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'parallel',
	    query: payload
	  }, function (parallelModel) {
	    parallelModel.setAxisExpand(payload);
	  });
	});

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var AxisBuilder = __webpack_require__(390);
	
	var BrushController = __webpack_require__(513);
	
	var brushHelper = __webpack_require__(514);
	
	var graphic = __webpack_require__(268);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var elementList = ['axisLine', 'axisTickLabel', 'axisName'];
	var AxisView = echarts.extendComponentView({
	  type: 'parallelAxis',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    AxisView.superApply(this, 'init', arguments);
	    /**
	     * @type {module:echarts/component/helper/BrushController}
	     */
	
	    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this));
	  },
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    if (fromAxisAreaSelect(axisModel, ecModel, payload)) {
	      return;
	    }
	
	    this.axisModel = axisModel;
	    this.api = api;
	    this.group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    this.group.add(this._axisGroup);
	
	    if (!axisModel.get('show')) {
	      return;
	    }
	
	    var coordSysModel = getCoordSysModel(axisModel, ecModel);
	    var coordSys = coordSysModel.coordinateSystem;
	    var areaSelectStyle = axisModel.getAreaSelectStyle();
	    var areaWidth = areaSelectStyle.width;
	    var dim = axisModel.axis.dim;
	    var axisLayout = coordSys.getAxisLayout(dim);
	    var builderOpt = zrUtil.extend({
	      strokeContainThreshold: areaWidth
	    }, axisLayout);
	    var axisBuilder = new AxisBuilder(axisModel, builderOpt);
	    zrUtil.each(elementList, axisBuilder.add, axisBuilder);
	
	    this._axisGroup.add(axisBuilder.getGroup());
	
	    this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
	
	    var animationModel = payload && payload.animation === false ? null : axisModel;
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, animationModel);
	  },
	  // /**
	  //  * @override
	  //  */
	  // updateVisual: function (axisModel, ecModel, api, payload) {
	  //     this._brushController && this._brushController
	  //         .updateCovers(getCoverInfoList(axisModel));
	  // },
	  _refreshBrushController: function (builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
	    // After filtering, axis may change, select area needs to be update.
	    var extent = axisModel.axis.getExtent();
	    var extentLen = extent[1] - extent[0];
	    var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
	    // width/height might be negative, which will be
	    // normalized in BoundingRect.
	
	    var rect = graphic.BoundingRect.create({
	      x: extent[0],
	      y: -areaWidth / 2,
	      width: extentLen,
	      height: areaWidth
	    });
	    rect.x -= extra;
	    rect.width += 2 * extra;
	
	    this._brushController.mount({
	      enableGlobalPan: true,
	      rotation: builderOpt.rotation,
	      position: builderOpt.position
	    }).setPanels([{
	      panelId: 'pl',
	      clipPath: brushHelper.makeRectPanelClipPath(rect),
	      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, coordSysModel),
	      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect, 0)
	    }]).enableBrush({
	      brushType: 'lineX',
	      brushStyle: areaSelectStyle,
	      removeOnClick: true
	    }).updateCovers(getCoverInfoList(axisModel));
	  },
	  _onBrush: function (coverInfoList, opt) {
	    // Do not cache these object, because the mey be changed.
	    var axisModel = this.axisModel;
	    var axis = axisModel.axis;
	    var intervals = zrUtil.map(coverInfoList, function (coverInfo) {
	      return [axis.coordToData(coverInfo.range[0], true), axis.coordToData(coverInfo.range[1], true)];
	    }); // If realtime is true, action is not dispatched on drag end, because
	    // the drag end emits the same params with the last drag move event,
	    // and may have some delay when using touch pad.
	
	    if (!axisModel.option.realtime === opt.isEnd || opt.removeOnClick) {
	      // jshint ignore:line
	      this.api.dispatchAction({
	        type: 'axisAreaSelect',
	        parallelAxisId: axisModel.id,
	        intervals: intervals
	      });
	    }
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._brushController.dispose();
	  }
	});
	
	function fromAxisAreaSelect(axisModel, ecModel, payload) {
	  return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
	    mainType: 'parallelAxis',
	    query: payload
	  })[0] === axisModel;
	}
	
	function getCoverInfoList(axisModel) {
	  var axis = axisModel.axis;
	  return zrUtil.map(axisModel.activeIntervals, function (interval) {
	    return {
	      brushType: 'lineX',
	      panelId: 'pl',
	      range: [axis.dataToCoord(interval[0], true), axis.dataToCoord(interval[1], true)]
	    };
	  });
	}
	
	function getCoordSysModel(axisModel, ecModel) {
	  return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
	}
	
	var _default = AxisView;
	module.exports = _default;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(220);
	
	var Eventful = __webpack_require__(224);
	
	var graphic = __webpack_require__(268);
	
	var interactionMutex = __webpack_require__(439);
	
	var DataDiffer = __webpack_require__(343);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var curry = zrUtil.curry;
	var each = zrUtil.each;
	var map = zrUtil.map;
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathPow = Math.pow;
	var COVER_Z = 10000;
	var UNSELECT_THRESHOLD = 6;
	var MIN_RESIZE_LINE_WIDTH = 6;
	var MUTEX_RESOURCE_KEY = 'globalPan';
	var DIRECTION_MAP = {
	  w: [0, 0],
	  e: [0, 1],
	  n: [1, 0],
	  s: [1, 1]
	};
	var CURSOR_MAP = {
	  w: 'ew',
	  e: 'ew',
	  n: 'ns',
	  s: 'ns',
	  ne: 'nesw',
	  sw: 'nesw',
	  nw: 'nwse',
	  se: 'nwse'
	};
	var DEFAULT_BRUSH_OPT = {
	  brushStyle: {
	    lineWidth: 2,
	    stroke: 'rgba(0,0,0,0.3)',
	    fill: 'rgba(0,0,0,0.1)'
	  },
	  transformable: true,
	  brushMode: 'single',
	  removeOnClick: false
	};
	var baseUID = 0;
	/**
	 * @alias module:echarts/component/helper/BrushController
	 * @constructor
	 * @mixin {module:zrender/mixin/Eventful}
	 * @event module:echarts/component/helper/BrushController#brush
	 *        params:
	 *            areas: Array.<Array>, coord relates to container group,
	 *                                    If no container specified, to global.
	 *            opt {
	 *                isEnd: boolean,
	 *                removeOnClick: boolean
	 *            }
	 *
	 * @param {module:zrender/zrender~ZRender} zr
	 */
	
	function BrushController(zr) {
	  Eventful.call(this);
	  /**
	   * @type {module:zrender/zrender~ZRender}
	   * @private
	   */
	
	  this._zr = zr;
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	
	  this.group = new graphic.Group();
	  /**
	   * Only for drawing (after enabledBrush).
	   *     'line', 'rect', 'polygon' or false
	   *     If passing false/null/undefined, disable brush.
	   *     If passing 'auto', determined by panel.defaultBrushType
	   * @private
	   * @type {string}
	   */
	
	  this._brushType;
	  /**
	   * Only for drawing (after enabledBrush).
	   *
	   * @private
	   * @type {Object}
	   */
	
	  this._brushOption;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._panels;
	  /**
	   * @private
	   * @type {Array.<nubmer>}
	   */
	
	  this._track = [];
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._dragging;
	  /**
	   * @private
	   * @type {Array}
	   */
	
	  this._covers = [];
	  /**
	   * @private
	   * @type {moudule:zrender/container/Group}
	   */
	
	  this._creatingCover;
	  /**
	   * `true` means global panel
	   * @private
	   * @type {module:zrender/container/Group|boolean}
	   */
	
	  this._creatingPanel;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._enableGlobalPan;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  /**
	   * @private
	   * @type {string}
	   */
	  this._uid = 'brushController_' + baseUID++;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._handlers = {};
	  each(pointerHandlers, function (handler, eventName) {
	    this._handlers[eventName] = zrUtil.bind(handler, this);
	  }, this);
	}
	
	BrushController.prototype = {
	  constructor: BrushController,
	
	  /**
	   * If set to null/undefined/false, select disabled.
	   * @param {Object} brushOption
	   * @param {string|boolean} brushOption.brushType 'line', 'rect', 'polygon' or false
	   *                          If passing false/null/undefined, disable brush.
	   *                          If passing 'auto', determined by panel.defaultBrushType.
	   *                              ('auto' can not be used in global panel)
	   * @param {number} [brushOption.brushMode='single'] 'single' or 'multiple'
	   * @param {boolean} [brushOption.transformable=true]
	   * @param {boolean} [brushOption.removeOnClick=false]
	   * @param {Object} [brushOption.brushStyle]
	   * @param {number} [brushOption.brushStyle.width]
	   * @param {number} [brushOption.brushStyle.lineWidth]
	   * @param {string} [brushOption.brushStyle.stroke]
	   * @param {string} [brushOption.brushStyle.fill]
	   * @param {number} [brushOption.z]
	   */
	  enableBrush: function (brushOption) {
	    this._brushType && doDisableBrush(this);
	    brushOption.brushType && doEnableBrush(this, brushOption);
	    return this;
	  },
	
	  /**
	   * @param {Array.<Object>} panelOpts If not pass, it is global brush.
	   *        Each items: {
	   *            panelId, // mandatory.
	   *            clipPath, // mandatory. function.
	   *            isTargetByCursor, // mandatory. function.
	   *            defaultBrushType, // optional, only used when brushType is 'auto'.
	   *            getLinearBrushOtherExtent, // optional. function.
	   *        }
	   */
	  setPanels: function (panelOpts) {
	    if (panelOpts && panelOpts.length) {
	      var panels = this._panels = {};
	      zrUtil.each(panelOpts, function (panelOpts) {
	        panels[panelOpts.panelId] = zrUtil.clone(panelOpts);
	      });
	    } else {
	      this._panels = null;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param {Object} [opt]
	   * @return {boolean} [opt.enableGlobalPan=false]
	   */
	  mount: function (opt) {
	    opt = opt || {};
	    this._enableGlobalPan = opt.enableGlobalPan;
	    var thisGroup = this.group;
	
	    this._zr.add(thisGroup);
	
	    thisGroup.attr({
	      position: opt.position || [0, 0],
	      rotation: opt.rotation || 0,
	      scale: opt.scale || [1, 1]
	    });
	    this._transform = thisGroup.getLocalTransform();
	    return this;
	  },
	  eachCover: function (cb, context) {
	    each(this._covers, cb, context);
	  },
	
	  /**
	   * Update covers.
	   * @param {Array.<Object>} brushOptionList Like:
	   *        [
	   *            {id: 'xx', brushType: 'line', range: [23, 44], brushStyle, transformable},
	   *            {id: 'yy', brushType: 'rect', range: [[23, 44], [23, 54]]},
	   *            ...
	   *        ]
	   *        `brushType` is required in each cover info. (can not be 'auto')
	   *        `id` is not mandatory.
	   *        `brushStyle`, `transformable` is not mandatory, use DEFAULT_BRUSH_OPT by default.
	   *        If brushOptionList is null/undefined, all covers removed.
	   */
	  updateCovers: function (brushOptionList) {
	    brushOptionList = zrUtil.map(brushOptionList, function (brushOption) {
	      return zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
	    });
	    var tmpIdPrefix = '\0-brush-index-';
	    var oldCovers = this._covers;
	    var newCovers = this._covers = [];
	    var controller = this;
	    var creatingCover = this._creatingCover;
	    new DataDiffer(oldCovers, brushOptionList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
	    return this;
	
	    function getKey(brushOption, index) {
	      return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
	    }
	
	    function oldGetKey(cover, index) {
	      return getKey(cover.__brushOption, index);
	    }
	
	    function addOrUpdate(newIndex, oldIndex) {
	      var newBrushOption = brushOptionList[newIndex]; // Consider setOption in event listener of brushSelect,
	      // where updating cover when creating should be forbiden.
	
	      if (oldIndex != null && oldCovers[oldIndex] === creatingCover) {
	        newCovers[newIndex] = oldCovers[oldIndex];
	      } else {
	        var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushOption, oldCovers[oldIndex]) : endCreating(controller, createCover(controller, newBrushOption));
	        updateCoverAfterCreation(controller, cover);
	      }
	    }
	
	    function remove(oldIndex) {
	      if (oldCovers[oldIndex] !== creatingCover) {
	        controller.group.remove(oldCovers[oldIndex]);
	      }
	    }
	  },
	  unmount: function () {
	    this.enableBrush(false); // container may 'removeAll' outside.
	
	    clearCovers(this);
	
	    this._zr.remove(this.group);
	
	    return this;
	  },
	  dispose: function () {
	    this.unmount();
	    this.off();
	  }
	};
	zrUtil.mixin(BrushController, Eventful);
	
	function doEnableBrush(controller, brushOption) {
	  var zr = controller._zr; // Consider roam, which takes globalPan too.
	
	  if (!controller._enableGlobalPan) {
	    interactionMutex.take(zr, MUTEX_RESOURCE_KEY, controller._uid);
	  }
	
	  mountHandlers(zr, controller._handlers);
	  controller._brushType = brushOption.brushType;
	  controller._brushOption = zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
	}
	
	function doDisableBrush(controller) {
	  var zr = controller._zr;
	  interactionMutex.release(zr, MUTEX_RESOURCE_KEY, controller._uid);
	  unmountHandlers(zr, controller._handlers);
	  controller._brushType = controller._brushOption = null;
	}
	
	function mountHandlers(zr, handlers) {
	  each(handlers, function (handler, eventName) {
	    zr.on(eventName, handler);
	  });
	}
	
	function unmountHandlers(zr, handlers) {
	  each(handlers, function (handler, eventName) {
	    zr.off(eventName, handler);
	  });
	}
	
	function createCover(controller, brushOption) {
	  var cover = coverRenderers[brushOption.brushType].createCover(controller, brushOption);
	  cover.__brushOption = brushOption;
	  updateZ(cover, brushOption);
	  controller.group.add(cover);
	  return cover;
	}
	
	function endCreating(controller, creatingCover) {
	  var coverRenderer = getCoverRenderer(creatingCover);
	
	  if (coverRenderer.endCreating) {
	    coverRenderer.endCreating(controller, creatingCover);
	    updateZ(creatingCover, creatingCover.__brushOption);
	  }
	
	  return creatingCover;
	}
	
	function updateCoverShape(controller, cover) {
	  var brushOption = cover.__brushOption;
	  getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
	}
	
	function updateZ(cover, brushOption) {
	  var z = brushOption.z;
	  z == null && (z = COVER_Z);
	  cover.traverse(function (el) {
	    el.z = z;
	    el.z2 = z; // Consider in given container.
	  });
	}
	
	function updateCoverAfterCreation(controller, cover) {
	  getCoverRenderer(cover).updateCommon(controller, cover);
	  updateCoverShape(controller, cover);
	}
	
	function getCoverRenderer(cover) {
	  return coverRenderers[cover.__brushOption.brushType];
	} // return target panel or `true` (means global panel)
	
	
	function getPanelByPoint(controller, e, localCursorPoint) {
	  var panels = controller._panels;
	
	  if (!panels) {
	    return true; // Global panel
	  }
	
	  var panel;
	  var transform = controller._transform;
	  each(panels, function (pn) {
	    pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
	  });
	  return panel;
	} // Return a panel or true
	
	
	function getPanelByCover(controller, cover) {
	  var panels = controller._panels;
	
	  if (!panels) {
	    return true; // Global panel
	  }
	
	  var panelId = cover.__brushOption.panelId; // User may give cover without coord sys info,
	  // which is then treated as global panel.
	
	  return panelId != null ? panels[panelId] : true;
	}
	
	function clearCovers(controller) {
	  var covers = controller._covers;
	  var originalLength = covers.length;
	  each(covers, function (cover) {
	    controller.group.remove(cover);
	  }, controller);
	  covers.length = 0;
	  return !!originalLength;
	}
	
	function trigger(controller, opt) {
	  var areas = map(controller._covers, function (cover) {
	    var brushOption = cover.__brushOption;
	    var range = zrUtil.clone(brushOption.range);
	    return {
	      brushType: brushOption.brushType,
	      panelId: brushOption.panelId,
	      range: range
	    };
	  });
	  controller.trigger('brush', areas, {
	    isEnd: !!opt.isEnd,
	    removeOnClick: !!opt.removeOnClick
	  });
	}
	
	function shouldShowCover(controller) {
	  var track = controller._track;
	
	  if (!track.length) {
	    return false;
	  }
	
	  var p2 = track[track.length - 1];
	  var p1 = track[0];
	  var dx = p2[0] - p1[0];
	  var dy = p2[1] - p1[1];
	  var dist = mathPow(dx * dx + dy * dy, 0.5);
	  return dist > UNSELECT_THRESHOLD;
	}
	
	function getTrackEnds(track) {
	  var tail = track.length - 1;
	  tail < 0 && (tail = 0);
	  return [track[0], track[tail]];
	}
	
	function createBaseRectCover(doDrift, controller, brushOption, edgeNames) {
	  var cover = new graphic.Group();
	  cover.add(new graphic.Rect({
	    name: 'main',
	    style: makeStyle(brushOption),
	    silent: true,
	    draggable: true,
	    cursor: 'move',
	    drift: curry(doDrift, controller, cover, 'nswe'),
	    ondragend: curry(trigger, controller, {
	      isEnd: true
	    })
	  }));
	  each(edgeNames, function (name) {
	    cover.add(new graphic.Rect({
	      name: name,
	      style: {
	        opacity: 0
	      },
	      draggable: true,
	      silent: true,
	      invisible: true,
	      drift: curry(doDrift, controller, cover, name),
	      ondragend: curry(trigger, controller, {
	        isEnd: true
	      })
	    }));
	  });
	  return cover;
	}
	
	function updateBaseRect(controller, cover, localRange, brushOption) {
	  var lineWidth = brushOption.brushStyle.lineWidth || 0;
	  var handleSize = mathMax(lineWidth, MIN_RESIZE_LINE_WIDTH);
	  var x = localRange[0][0];
	  var y = localRange[1][0];
	  var xa = x - lineWidth / 2;
	  var ya = y - lineWidth / 2;
	  var x2 = localRange[0][1];
	  var y2 = localRange[1][1];
	  var x2a = x2 - handleSize + lineWidth / 2;
	  var y2a = y2 - handleSize + lineWidth / 2;
	  var width = x2 - x;
	  var height = y2 - y;
	  var widtha = width + lineWidth;
	  var heighta = height + lineWidth;
	  updateRectShape(controller, cover, 'main', x, y, width, height);
	
	  if (brushOption.transformable) {
	    updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
	    updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
	    updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
	    updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
	    updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
	    updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
	    updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
	    updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
	  }
	}
	
	function updateCommon(controller, cover) {
	  var brushOption = cover.__brushOption;
	  var transformable = brushOption.transformable;
	  var mainEl = cover.childAt(0);
	  mainEl.useStyle(makeStyle(brushOption));
	  mainEl.attr({
	    silent: !transformable,
	    cursor: transformable ? 'move' : 'default'
	  });
	  each(['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw'], function (name) {
	    var el = cover.childOfName(name);
	    var globalDir = getGlobalDirection(controller, name);
	    el && el.attr({
	      silent: !transformable,
	      invisible: !transformable,
	      cursor: transformable ? CURSOR_MAP[globalDir] + '-resize' : null
	    });
	  });
	}
	
	function updateRectShape(controller, cover, name, x, y, w, h) {
	  var el = cover.childOfName(name);
	  el && el.setShape(pointsToRect(clipByPanel(controller, cover, [[x, y], [x + w, y + h]])));
	}
	
	function makeStyle(brushOption) {
	  return zrUtil.defaults({
	    strokeNoScale: true
	  }, brushOption.brushStyle);
	}
	
	function formatRectRange(x, y, x2, y2) {
	  var min = [mathMin(x, x2), mathMin(y, y2)];
	  var max = [mathMax(x, x2), mathMax(y, y2)];
	  return [[min[0], max[0]], // x range
	  [min[1], max[1]] // y range
	  ];
	}
	
	function getTransform(controller) {
	  return graphic.getTransform(controller.group);
	}
	
	function getGlobalDirection(controller, localDirection) {
	  if (localDirection.length > 1) {
	    localDirection = localDirection.split('');
	    var globalDir = [getGlobalDirection(controller, localDirection[0]), getGlobalDirection(controller, localDirection[1])];
	    (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
	    return globalDir.join('');
	  } else {
	    var map = {
	      w: 'left',
	      e: 'right',
	      n: 'top',
	      s: 'bottom'
	    };
	    var inverseMap = {
	      left: 'w',
	      right: 'e',
	      top: 'n',
	      bottom: 's'
	    };
	    var globalDir = graphic.transformDirection(map[localDirection], getTransform(controller));
	    return inverseMap[globalDir];
	  }
	}
	
	function driftRect(toRectRange, fromRectRange, controller, cover, name, dx, dy, e) {
	  var brushOption = cover.__brushOption;
	  var rectRange = toRectRange(brushOption.range);
	  var localDelta = toLocalDelta(controller, dx, dy);
	  each(name.split(''), function (namePart) {
	    var ind = DIRECTION_MAP[namePart];
	    rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
	  });
	  brushOption.range = fromRectRange(formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
	  updateCoverAfterCreation(controller, cover);
	  trigger(controller, {
	    isEnd: false
	  });
	}
	
	function driftPolygon(controller, cover, dx, dy, e) {
	  var range = cover.__brushOption.range;
	  var localDelta = toLocalDelta(controller, dx, dy);
	  each(range, function (point) {
	    point[0] += localDelta[0];
	    point[1] += localDelta[1];
	  });
	  updateCoverAfterCreation(controller, cover);
	  trigger(controller, {
	    isEnd: false
	  });
	}
	
	function toLocalDelta(controller, dx, dy) {
	  var thisGroup = controller.group;
	  var localD = thisGroup.transformCoordToLocal(dx, dy);
	  var localZero = thisGroup.transformCoordToLocal(0, 0);
	  return [localD[0] - localZero[0], localD[1] - localZero[1]];
	}
	
	function clipByPanel(controller, cover, data) {
	  var panel = getPanelByCover(controller, cover);
	  return panel && panel !== true ? panel.clipPath(data, controller._transform) : zrUtil.clone(data);
	}
	
	function pointsToRect(points) {
	  var xmin = mathMin(points[0][0], points[1][0]);
	  var ymin = mathMin(points[0][1], points[1][1]);
	  var xmax = mathMax(points[0][0], points[1][0]);
	  var ymax = mathMax(points[0][1], points[1][1]);
	  return {
	    x: xmin,
	    y: ymin,
	    width: xmax - xmin,
	    height: ymax - ymin
	  };
	}
	
	function resetCursor(controller, e, localCursorPoint) {
	  if ( // Check active
	  !controller._brushType // resetCursor should be always called when mouse is in zr area,
	  // but not called when mouse is out of zr area to avoid bad influence
	  // if `mousemove`, `mouseup` are triggered from `document` event.
	  || isOutsideZrArea(controller, e)) {
	    return;
	  }
	
	  var zr = controller._zr;
	  var covers = controller._covers;
	  var currPanel = getPanelByPoint(controller, e, localCursorPoint); // Check whether in covers.
	
	  if (!controller._dragging) {
	    for (var i = 0; i < covers.length; i++) {
	      var brushOption = covers[i].__brushOption;
	
	      if (currPanel && (currPanel === true || brushOption.panelId === currPanel.panelId) && coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) {
	        // Use cursor style set on cover.
	        return;
	      }
	    }
	  }
	
	  currPanel && zr.setCursorStyle('crosshair');
	}
	
	function preventDefault(e) {
	  var rawE = e.event;
	  rawE.preventDefault && rawE.preventDefault();
	}
	
	function mainShapeContain(cover, x, y) {
	  return cover.childOfName('main').contain(x, y);
	}
	
	function updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
	  var creatingCover = controller._creatingCover;
	  var panel = controller._creatingPanel;
	  var thisBrushOption = controller._brushOption;
	  var eventParams;
	
	  controller._track.push(localCursorPoint.slice());
	
	  if (shouldShowCover(controller) || creatingCover) {
	    if (panel && !creatingCover) {
	      thisBrushOption.brushMode === 'single' && clearCovers(controller);
	      var brushOption = zrUtil.clone(thisBrushOption);
	      brushOption.brushType = determineBrushType(brushOption.brushType, panel);
	      brushOption.panelId = panel === true ? null : panel.panelId;
	      creatingCover = controller._creatingCover = createCover(controller, brushOption);
	
	      controller._covers.push(creatingCover);
	    }
	
	    if (creatingCover) {
	      var coverRenderer = coverRenderers[determineBrushType(controller._brushType, panel)];
	      var coverBrushOption = creatingCover.__brushOption;
	      coverBrushOption.range = coverRenderer.getCreatingRange(clipByPanel(controller, creatingCover, controller._track));
	
	      if (isEnd) {
	        endCreating(controller, creatingCover);
	        coverRenderer.updateCommon(controller, creatingCover);
	      }
	
	      updateCoverShape(controller, creatingCover);
	      eventParams = {
	        isEnd: isEnd
	      };
	    }
	  } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) {
	    // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
	    // But a single click do not clear covers, because user may have casual
	    // clicks (for example, click on other component and do not expect covers
	    // disappear).
	    // Only some cover removed, trigger action, but not every click trigger action.
	    if (getPanelByPoint(controller, e, localCursorPoint) && clearCovers(controller)) {
	      eventParams = {
	        isEnd: isEnd,
	        removeOnClick: true
	      };
	    }
	  }
	
	  return eventParams;
	}
	
	function determineBrushType(brushType, panel) {
	  if (brushType === 'auto') {
	    return panel.defaultBrushType;
	  }
	
	  return brushType;
	}
	
	var pointerHandlers = {
	  mousedown: function (e) {
	    if (this._dragging) {
	      // In case some browser do not support globalOut,
	      // and release mose out side the browser.
	      handleDragEnd(this, e);
	    } else if (!e.target || !e.target.draggable) {
	      preventDefault(e);
	      var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
	      this._creatingCover = null;
	      var panel = this._creatingPanel = getPanelByPoint(this, e, localCursorPoint);
	
	      if (panel) {
	        this._dragging = true;
	        this._track = [localCursorPoint.slice()];
	      }
	    }
	  },
	  mousemove: function (e) {
	    var x = e.offsetX;
	    var y = e.offsetY;
	    var localCursorPoint = this.group.transformCoordToLocal(x, y);
	    resetCursor(this, e, localCursorPoint);
	
	    if (this._dragging) {
	      preventDefault(e);
	      var eventParams = updateCoverByMouse(this, e, localCursorPoint, false);
	      eventParams && trigger(this, eventParams);
	    }
	  },
	  mouseup: function (e) {
	    handleDragEnd(this, e);
	  }
	};
	
	function handleDragEnd(controller, e) {
	  if (controller._dragging) {
	    preventDefault(e);
	    var x = e.offsetX;
	    var y = e.offsetY;
	    var localCursorPoint = controller.group.transformCoordToLocal(x, y);
	    var eventParams = updateCoverByMouse(controller, e, localCursorPoint, true);
	    controller._dragging = false;
	    controller._track = [];
	    controller._creatingCover = null; // trigger event shoule be at final, after procedure will be nested.
	
	    eventParams && trigger(controller, eventParams);
	  }
	}
	
	function isOutsideZrArea(controller, x, y) {
	  var zr = controller._zr;
	  return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
	}
	/**
	 * key: brushType
	 * @type {Object}
	 */
	
	
	var coverRenderers = {
	  lineX: getLineRenderer(0),
	  lineY: getLineRenderer(1),
	  rect: {
	    createCover: function (controller, brushOption) {
	      return createBaseRectCover(curry(driftRect, function (range) {
	        return range;
	      }, function (range) {
	        return range;
	      }), controller, brushOption, ['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw']);
	    },
	    getCreatingRange: function (localTrack) {
	      var ends = getTrackEnds(localTrack);
	      return formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      updateBaseRect(controller, cover, localRange, brushOption);
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  },
	  polygon: {
	    createCover: function (controller, brushOption) {
	      var cover = new graphic.Group(); // Do not use graphic.Polygon because graphic.Polyline do not close the
	      // border of the shape when drawing, which is a better experience for user.
	
	      cover.add(new graphic.Polyline({
	        name: 'main',
	        style: makeStyle(brushOption),
	        silent: true
	      }));
	      return cover;
	    },
	    getCreatingRange: function (localTrack) {
	      return localTrack;
	    },
	    endCreating: function (controller, cover) {
	      cover.remove(cover.childAt(0)); // Use graphic.Polygon close the shape.
	
	      cover.add(new graphic.Polygon({
	        name: 'main',
	        draggable: true,
	        drift: curry(driftPolygon, controller, cover),
	        ondragend: curry(trigger, controller, {
	          isEnd: true
	        })
	      }));
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      cover.childAt(0).setShape({
	        points: clipByPanel(controller, cover, localRange)
	      });
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  }
	};
	
	function getLineRenderer(xyIndex) {
	  return {
	    createCover: function (controller, brushOption) {
	      return createBaseRectCover(curry(driftRect, function (range) {
	        var rectRange = [range, [0, 100]];
	        xyIndex && rectRange.reverse();
	        return rectRange;
	      }, function (rectRange) {
	        return rectRange[xyIndex];
	      }), controller, brushOption, [['w', 'e'], ['n', 's']][xyIndex]);
	    },
	    getCreatingRange: function (localTrack) {
	      var ends = getTrackEnds(localTrack);
	      var min = mathMin(ends[0][xyIndex], ends[1][xyIndex]);
	      var max = mathMax(ends[0][xyIndex], ends[1][xyIndex]);
	      return [min, max];
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      var otherExtent; // If brushWidth not specified, fit the panel.
	
	      var panel = getPanelByCover(controller, cover);
	
	      if (panel !== true && panel.getLinearBrushOtherExtent) {
	        otherExtent = panel.getLinearBrushOtherExtent(xyIndex, controller._transform);
	      } else {
	        var zr = controller._zr;
	        otherExtent = [0, [zr.getWidth(), zr.getHeight()][1 - xyIndex]];
	      }
	
	      var rectRange = [localRange, otherExtent];
	      xyIndex && rectRange.reverse();
	      updateBaseRect(controller, cover, rectRange, brushOption);
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  };
	}
	
	var _default = BrushController;
	module.exports = _default;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BoundingRect = __webpack_require__(242);
	
	var _cursorHelper = __webpack_require__(441);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphicUtil = __webpack_require__(268);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function makeRectPanelClipPath(rect) {
	  rect = normalizeRect(rect);
	  return function (localPoints, transform) {
	    return graphicUtil.clipPointsByRect(localPoints, rect);
	  };
	}
	
	function makeLinearBrushOtherExtent(rect, specifiedXYIndex) {
	  rect = normalizeRect(rect);
	  return function (xyIndex) {
	    var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
	    var brushWidth = idx ? rect.width : rect.height;
	    var base = idx ? rect.x : rect.y;
	    return [base, base + (brushWidth || 0)];
	  };
	}
	
	function makeRectIsTargetByCursor(rect, api, targetModel) {
	  rect = normalizeRect(rect);
	  return function (e, localCursorPoint, transform) {
	    return rect.contain(localCursorPoint[0], localCursorPoint[1]) && !onIrrelevantElement(e, api, targetModel);
	  };
	} // Consider width/height is negative.
	
	
	function normalizeRect(rect) {
	  return BoundingRect.create(rect);
	}
	
	exports.makeRectPanelClipPath = makeRectPanelClipPath;
	exports.makeLinearBrushOtherExtent = makeLinearBrushOtherExtent;
	exports.makeRectIsTargetByCursor = makeRectIsTargetByCursor;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	
	var SeriesModel = __webpack_require__(320);
	
	var createListFromArray = __webpack_require__(341);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.parallel',
	  dependencies: ['parallel'],
	  visualColorAccessPath: 'lineStyle.color',
	  getInitialData: function (option, ecModel) {
	    var source = this.getSource();
	    setEncodeAndDimensions(source, this);
	    return createListFromArray(source, this);
	  },
	
	  /**
	   * User can get data raw indices on 'axisAreaSelected' event received.
	   *
	   * @public
	   * @param {string} activeState 'active' or 'inactive' or 'normal'
	   * @return {Array.<number>} Raw indices
	   */
	  getRawIndicesByActiveState: function (activeState) {
	    var coordSys = this.coordinateSystem;
	    var data = this.getData();
	    var indices = [];
	    coordSys.eachActiveState(data, function (theActiveState, dataIndex) {
	      if (activeState === theActiveState) {
	        indices.push(data.getRawIndex(dataIndex));
	      }
	    });
	    return indices;
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'parallel',
	    parallelIndex: 0,
	    label: {
	      show: false
	    },
	    inactiveOpacity: 0.05,
	    activeOpacity: 1,
	    lineStyle: {
	      width: 1,
	      opacity: 0.45,
	      type: 'solid'
	    },
	    emphasis: {
	      label: {
	        show: false
	      }
	    },
	    progressive: 500,
	    smooth: false,
	    // true | false | number
	    animationEasing: 'linear'
	  }
	});
	
	function setEncodeAndDimensions(source, seriesModel) {
	  // The mapping of parallelAxis dimension to data dimension can
	  // be specified in parallelAxis.option.dim. For example, if
	  // parallelAxis.option.dim is 'dim3', it mapping to the third
	  // dimension of data. But `data.encode` has higher priority.
	  // Moreover, parallelModel.dimension should not be regarded as data
	  // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
	  if (source.encodeDefine) {
	    return;
	  }
	
	  var parallelModel = seriesModel.ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
	
	  if (!parallelModel) {
	    return;
	  }
	
	  var encodeDefine = source.encodeDefine = createHashMap();
	  each(parallelModel.dimensions, function (axisDim) {
	    var dataDimIndex = convertDimNameToNumber(axisDim);
	    encodeDefine.set(axisDim, dataDimIndex);
	  });
	}
	
	function convertDimNameToNumber(dimName) {
	  return +dimName.replace('dim', '');
	}
	
	module.exports = _default;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var ChartView = __webpack_require__(325);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_SMOOTH = 0.3;
	var ParallelView = ChartView.extend({
	  type: 'parallel',
	  init: function () {
	    /**
	     * @type {module:zrender/container/Group}
	     * @private
	     */
	    this._dataGroup = new graphic.Group();
	    this.group.add(this._dataGroup);
	    /**
	     * @type {module:echarts/data/List}
	     */
	
	    this._data;
	    /**
	     * @type {boolean}
	     */
	
	    this._initialized;
	  },
	
	  /**
	   * @override
	   */
	  render: function (seriesModel, ecModel, api, payload) {
	    var dataGroup = this._dataGroup;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var coordSys = seriesModel.coordinateSystem;
	    var dimensions = coordSys.dimensions;
	    var seriesScope = makeSeriesScope(seriesModel);
	    data.diff(oldData).add(add).update(update).remove(remove).execute();
	
	    function add(newDataIndex) {
	      var line = addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
	      updateElCommon(line, data, newDataIndex, seriesScope);
	    }
	
	    function update(newDataIndex, oldDataIndex) {
	      var line = oldData.getItemGraphicEl(oldDataIndex);
	      var points = createLinePoints(data, newDataIndex, dimensions, coordSys);
	      data.setItemGraphicEl(newDataIndex, line);
	      var animationModel = payload && payload.animation === false ? null : seriesModel;
	      graphic.updateProps(line, {
	        shape: {
	          points: points
	        }
	      }, animationModel, newDataIndex);
	      updateElCommon(line, data, newDataIndex, seriesScope);
	    }
	
	    function remove(oldDataIndex) {
	      var line = oldData.getItemGraphicEl(oldDataIndex);
	      dataGroup.remove(line);
	    } // First create
	
	
	    if (!this._initialized) {
	      this._initialized = true;
	      var clipPath = createGridClipShape(coordSys, seriesModel, function () {
	        // Callback will be invoked immediately if there is no animation
	        setTimeout(function () {
	          dataGroup.removeClipPath();
	        });
	      });
	      dataGroup.setClipPath(clipPath);
	    }
	
	    this._data = data;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._initialized = true;
	    this._data = null;
	
	    this._dataGroup.removeAll();
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var coordSys = seriesModel.coordinateSystem;
	    var dimensions = coordSys.dimensions;
	    var seriesScope = makeSeriesScope(seriesModel);
	
	    for (var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++) {
	      var line = addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
	      line.incremental = true;
	      updateElCommon(line, data, dataIndex, seriesScope);
	    }
	  },
	  dispose: function () {},
	  // _renderForProgressive: function (seriesModel) {
	  //     var dataGroup = this._dataGroup;
	  //     var data = seriesModel.getData();
	  //     var oldData = this._data;
	  //     var coordSys = seriesModel.coordinateSystem;
	  //     var dimensions = coordSys.dimensions;
	  //     var option = seriesModel.option;
	  //     var progressive = option.progressive;
	  //     var smooth = option.smooth ? SMOOTH : null;
	  //     // In progressive animation is disabled, so use simple data diff,
	  //     // which effects performance less.
	  //     // (Typically performance for data with length 7000+ like:
	  //     // simpleDiff: 60ms, addEl: 184ms,
	  //     // in RMBP 2.4GHz intel i7, OSX 10.9 chrome 50.0.2661.102 (64-bit))
	  //     if (simpleDiff(oldData, data, dimensions)) {
	  //         dataGroup.removeAll();
	  //         data.each(function (dataIndex) {
	  //             addEl(data, dataGroup, dataIndex, dimensions, coordSys);
	  //         });
	  //     }
	  //     updateElCommon(data, progressive, smooth);
	  //     // Consider switch between progressive and not.
	  //     data.__plProgressive = true;
	  //     this._data = data;
	  // },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._dataGroup && this._dataGroup.removeAll();
	    this._data = null;
	  }
	});
	
	function createGridClipShape(coordSys, seriesModel, cb) {
	  var parallelModel = coordSys.model;
	  var rect = coordSys.getRect();
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    }
	  });
	  var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
	  rectEl.setShape(dim, 0);
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width,
	      height: rect.height
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	function createLinePoints(data, dataIndex, dimensions, coordSys) {
	  var points = [];
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimName = dimensions[i];
	    var value = data.get(data.mapDimension(dimName), dataIndex);
	
	    if (!isEmptyValue(value, coordSys.getAxis(dimName).type)) {
	      points.push(coordSys.dataToPoint(value, dimName));
	    }
	  }
	
	  return points;
	}
	
	function addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
	  var points = createLinePoints(data, dataIndex, dimensions, coordSys);
	  var line = new graphic.Polyline({
	    shape: {
	      points: points
	    },
	    silent: true,
	    z2: 10
	  });
	  dataGroup.add(line);
	  data.setItemGraphicEl(dataIndex, line);
	  return line;
	}
	
	function makeSeriesScope(seriesModel) {
	  var smooth = seriesModel.get('smooth', true);
	  smooth === true && (smooth = DEFAULT_SMOOTH);
	  return {
	    lineStyle: seriesModel.getModel('lineStyle').getLineStyle(),
	    smooth: smooth != null ? smooth : DEFAULT_SMOOTH
	  };
	}
	
	function updateElCommon(el, data, dataIndex, seriesScope) {
	  var lineStyle = seriesScope.lineStyle;
	
	  if (data.hasItemOption) {
	    var lineStyleModel = data.getItemModel(dataIndex).getModel('lineStyle');
	    lineStyle = lineStyleModel.getLineStyle();
	  }
	
	  el.useStyle(lineStyle);
	  var elStyle = el.style;
	  elStyle.fill = null; // lineStyle.color have been set to itemVisual in module:echarts/visual/seriesColor.
	
	  elStyle.stroke = data.getItemVisual(dataIndex, 'color'); // lineStyle.opacity have been set to itemVisual in parallelVisual.
	
	  elStyle.opacity = data.getItemVisual(dataIndex, 'opacity');
	  seriesScope.smooth && (el.shape.smooth = seriesScope.smooth);
	} // function simpleDiff(oldData, newData, dimensions) {
	//     var oldLen;
	//     if (!oldData
	//         || !oldData.__plProgressive
	//         || (oldLen = oldData.count()) !== newData.count()
	//     ) {
	//         return true;
	//     }
	//     var dimLen = dimensions.length;
	//     for (var i = 0; i < oldLen; i++) {
	//         for (var j = 0; j < dimLen; j++) {
	//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
	//                 return true;
	//             }
	//         }
	//     }
	//     return false;
	// }
	// FIXME
	// 公用方法?
	
	
	function isEmptyValue(val, axisType) {
	  return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
	}
	
	var _default = ParallelView;
	module.exports = _default;

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var opacityAccessPath = ['lineStyle', 'normal', 'opacity'];
	var _default = {
	  seriesType: 'parallel',
	  reset: function (seriesModel, ecModel, api) {
	    var itemStyleModel = seriesModel.getModel('itemStyle');
	    var lineStyleModel = seriesModel.getModel('lineStyle');
	    var globalColors = ecModel.get('color');
	    var color = lineStyleModel.get('color') || itemStyleModel.get('color') || globalColors[seriesModel.seriesIndex % globalColors.length];
	    var inactiveOpacity = seriesModel.get('inactiveOpacity');
	    var activeOpacity = seriesModel.get('activeOpacity');
	    var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
	    var coordSys = seriesModel.coordinateSystem;
	    var data = seriesModel.getData();
	    var opacityMap = {
	      normal: lineStyle.opacity,
	      active: activeOpacity,
	      inactive: inactiveOpacity
	    };
	    data.setVisual('color', color);
	
	    function progress(params, data) {
	      coordSys.eachActiveState(data, function (activeState, dataIndex) {
	        var opacity = opacityMap[activeState];
	
	        if (activeState === 'normal' && data.hasItemOption) {
	          var itemOpacity = data.getItemModel(dataIndex).get(opacityAccessPath, true);
	          itemOpacity != null && (opacity = itemOpacity);
	        }
	
	        data.setItemVisual(dataIndex, 'opacity', opacity);
	      }, params.start, params.end);
	    }
	
	    return {
	      progress: progress
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(519);
	
	__webpack_require__(520);
	
	__webpack_require__(521);
	
	var sankeyLayout = __webpack_require__(522);
	
	var sankeyVisual = __webpack_require__(523);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(sankeyLayout);
	echarts.registerVisual(sankeyVisual);

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(320);
	
	var createGraphFromNodeEdge = __webpack_require__(472);
	
	var _format = __webpack_require__(307);
	
	var encodeHTML = _format.encodeHTML;
	
	var Model = __webpack_require__(262);
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SankeySeries = SeriesModel.extend({
	  type: 'series.sankey',
	  layoutInfo: null,
	  levelModels: null,
	
	  /**
	   * Init a graph data structure from data in option series
	   *
	   * @param  {Object} option  the object used to config echarts view
	   * @return {module:echarts/data/List} storage initial data
	   */
	  getInitialData: function (option, ecModel) {
	    var links = option.edges || option.links;
	    var nodes = option.data || option.nodes;
	    var levels = option.levels;
	    var levelModels = this.levelModels = {};
	
	    for (var i = 0; i < levels.length; i++) {
	      if (levels[i].depth != null && levels[i].depth >= 0) {
	        levelModels[levels[i].depth] = new Model(levels[i], this, ecModel);
	      } else {}
	    }
	
	    if (nodes && links) {
	      var graph = createGraphFromNodeEdge(nodes, links, this, true, beforeLink);
	      return graph.data;
	    }
	
	    function beforeLink(nodeData, edgeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        model.customizeGetParent(function (path) {
	          var parentModel = this.parentModel;
	          var nodeDepth = parentModel.getData().getItemLayout(idx).depth;
	          var levelModel = parentModel.levelModels[nodeDepth];
	          return levelModel || this.parentModel;
	        });
	        return model;
	      });
	      edgeData.wrapMethod('getItemModel', function (model, idx) {
	        model.customizeGetParent(function (path) {
	          var parentModel = this.parentModel;
	          var edge = parentModel.getGraph().getEdgeByIndex(idx);
	          var depth = edge.node1.getLayout().depth;
	          var levelModel = parentModel.levelModels[depth];
	          return levelModel || this.parentModel;
	        });
	        return model;
	      });
	    }
	  },
	  setNodePosition: function (dataIndex, localPosition) {
	    var dataItem = this.option.data[dataIndex];
	    dataItem.localX = localPosition[0];
	    dataItem.localY = localPosition[1];
	  },
	
	  /**
	   * Return the graphic data structure
	   *
	   * @return {module:echarts/data/Graph} graphic data structure
	   */
	  getGraph: function () {
	    return this.getData().graph;
	  },
	
	  /**
	   * Get edge data of graphic data structure
	   *
	   * @return {module:echarts/data/List} data structure of list
	   */
	  getEdgeData: function () {
	    return this.getGraph().edgeData;
	  },
	
	  /**
	   * @override
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    // dataType === 'node' or empty do not show tooltip by default
	    if (dataType === 'edge') {
	      var params = this.getDataParams(dataIndex, dataType);
	      var rawDataOpt = params.data;
	      var html = rawDataOpt.source + ' -- ' + rawDataOpt.target;
	
	      if (params.value) {
	        html += ' : ' + params.value;
	      }
	
	      return encodeHTML(html);
	    } else if (dataType === 'node') {
	      var node = this.getGraph().getNodeByIndex(dataIndex);
	      var value = node.getLayout().value;
	      var name = this.getDataParams(dataIndex, dataType).data.name;
	
	      if (value) {
	        var html = name + ' : ' + value;
	      }
	
	      return encodeHTML(html);
	    }
	
	    return SankeySeries.superCall(this, 'formatTooltip', dataIndex, multipleSeries);
	  },
	  optionUpdated: function () {
	    var option = this.option;
	
	    if (option.focusNodeAdjacency === true) {
	      option.focusNodeAdjacency = 'allEdges';
	    }
	  },
	  // Override Series.getDataParams()
	  getDataParams: function (dataIndex, dataType) {
	    var params = SankeySeries.superCall(this, 'getDataParams', dataIndex, dataType);
	
	    if (params.value == null && dataType === 'node') {
	      var node = this.getGraph().getNodeByIndex(dataIndex);
	      var nodeValue = node.getLayout().value;
	      params.value = nodeValue;
	    }
	
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    layout: null,
	    // The position of the whole view
	    left: '5%',
	    top: '5%',
	    right: '20%',
	    bottom: '5%',
	    // Value can be 'vertical'
	    orient: 'horizontal',
	    // The dx of the node
	    nodeWidth: 20,
	    // The vertical distance between two nodes
	    nodeGap: 8,
	    // Control if the node can move or not
	    draggable: true,
	    // Value can be 'inEdges', 'outEdges', 'allEdges', true (the same as 'allEdges').
	    focusNodeAdjacency: false,
	    // The number of iterations to change the position of the node
	    layoutIterations: 32,
	    label: {
	      show: true,
	      position: 'right',
	      color: '#000',
	      fontSize: 12
	    },
	    levels: [],
	    // Value can be 'left' or 'right'
	    nodeAlign: 'justify',
	    itemStyle: {
	      borderWidth: 1,
	      borderColor: '#333'
	    },
	    lineStyle: {
	      color: '#314656',
	      opacity: 0.2,
	      curveness: 0.5
	    },
	    emphasis: {
	      label: {
	        show: true
	      },
	      lineStyle: {
	        opacity: 0.5
	      }
	    },
	    animationEasing: 'linear',
	    animationDuration: 1000
	  }
	});
	var _default = SankeySeries;
	module.exports = _default;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var nodeOpacityPath = ['itemStyle', 'opacity'];
	var hoverNodeOpacityPath = ['emphasis', 'itemStyle', 'opacity'];
	var lineOpacityPath = ['lineStyle', 'opacity'];
	var hoverLineOpacityPath = ['emphasis', 'lineStyle', 'opacity'];
	
	function getItemOpacity(item, opacityPath) {
	  return item.getVisual('opacity') || item.getModel().get(opacityPath);
	}
	
	function fadeOutItem(item, opacityPath, opacityRatio) {
	  var el = item.getGraphicEl();
	  var opacity = getItemOpacity(item, opacityPath);
	
	  if (opacityRatio != null) {
	    opacity == null && (opacity = 1);
	    opacity *= opacityRatio;
	  }
	
	  el.downplay && el.downplay();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  });
	}
	
	function fadeInItem(item, opacityPath) {
	  var opacity = getItemOpacity(item, opacityPath);
	  var el = item.getGraphicEl();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  }); // Support emphasis here.
	
	  el.highlight && el.highlight();
	}
	
	var SankeyShape = graphic.extendShape({
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    cpx1: 0,
	    cpy1: 0,
	    cpx2: 0,
	    cpy2: 0,
	    extent: 0,
	    orient: ''
	  },
	  buildPath: function (ctx, shape) {
	    var extent = shape.extent;
	    ctx.moveTo(shape.x1, shape.y1);
	    ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
	
	    if (shape.orient === 'vertical') {
	      ctx.lineTo(shape.x2 + extent, shape.y2);
	      ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
	    } else {
	      ctx.lineTo(shape.x2, shape.y2 + extent);
	      ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
	    }
	
	    ctx.closePath();
	  },
	  highlight: function () {
	    this.trigger('emphasis');
	  },
	  downplay: function () {
	    this.trigger('normal');
	  }
	});
	
	var _default = echarts.extendChartView({
	  type: 'sankey',
	
	  /**
	   * @private
	   * @type {module:echarts/chart/sankey/SankeySeries}
	   */
	  _model: null,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _focusAdjacencyDisabled: false,
	  render: function (seriesModel, ecModel, api) {
	    var sankeyView = this;
	    var graph = seriesModel.getGraph();
	    var group = this.group;
	    var layoutInfo = seriesModel.layoutInfo; // view width
	
	    var width = layoutInfo.width; // view height
	
	    var height = layoutInfo.height;
	    var nodeData = seriesModel.getData();
	    var edgeData = seriesModel.getData('edge');
	    var orient = seriesModel.get('orient');
	    this._model = seriesModel;
	    group.removeAll();
	    group.attr('position', [layoutInfo.x, layoutInfo.y]); // generate a bezire Curve for each edge
	
	    graph.eachEdge(function (edge) {
	      var curve = new SankeyShape();
	      curve.dataIndex = edge.dataIndex;
	      curve.seriesIndex = seriesModel.seriesIndex;
	      curve.dataType = 'edge';
	      var lineStyleModel = edge.getModel('lineStyle');
	      var curvature = lineStyleModel.get('curveness');
	      var n1Layout = edge.node1.getLayout();
	      var node1Model = edge.node1.getModel();
	      var dragX1 = node1Model.get('localX');
	      var dragY1 = node1Model.get('localY');
	      var n2Layout = edge.node2.getLayout();
	      var node2Model = edge.node2.getModel();
	      var dragX2 = node2Model.get('localX');
	      var dragY2 = node2Model.get('localY');
	      var edgeLayout = edge.getLayout();
	      var x1;
	      var y1;
	      var x2;
	      var y2;
	      var cpx1;
	      var cpy1;
	      var cpx2;
	      var cpy2;
	      curve.shape.extent = Math.max(1, edgeLayout.dy);
	      curve.shape.orient = orient;
	
	      if (orient === 'vertical') {
	        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
	        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
	        x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
	        y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
	        cpx1 = x1;
	        cpy1 = y1 * (1 - curvature) + y2 * curvature;
	        cpx2 = x2;
	        cpy2 = y1 * curvature + y2 * (1 - curvature);
	      } else {
	        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
	        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
	        x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
	        y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
	        cpx1 = x1 * (1 - curvature) + x2 * curvature;
	        cpy1 = y1;
	        cpx2 = x1 * curvature + x2 * (1 - curvature);
	        cpy2 = y2;
	      }
	
	      curve.setShape({
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2,
	        cpx1: cpx1,
	        cpy1: cpy1,
	        cpx2: cpx2,
	        cpy2: cpy2
	      });
	      curve.setStyle(lineStyleModel.getItemStyle()); // Special color, use source node color or target node color
	
	      switch (curve.style.fill) {
	        case 'source':
	          curve.style.fill = edge.node1.getVisual('color');
	          break;
	
	        case 'target':
	          curve.style.fill = edge.node2.getVisual('color');
	          break;
	      }
	
	      graphic.setHoverStyle(curve, edge.getModel('emphasis.lineStyle').getItemStyle());
	      group.add(curve);
	      edgeData.setItemGraphicEl(edge.dataIndex, curve);
	    }); // Generate a rect for each node
	
	    graph.eachNode(function (node) {
	      var layout = node.getLayout();
	      var itemModel = node.getModel();
	      var dragX = itemModel.get('localX');
	      var dragY = itemModel.get('localY');
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      var rect = new graphic.Rect({
	        shape: {
	          x: dragX != null ? dragX * width : layout.x,
	          y: dragY != null ? dragY * height : layout.y,
	          width: layout.dx,
	          height: layout.dy
	        },
	        style: itemModel.getModel('itemStyle').getItemStyle()
	      });
	      var hoverStyle = node.getModel('emphasis.itemStyle').getItemStyle();
	      graphic.setLabelStyle(rect.style, hoverStyle, labelModel, labelHoverModel, {
	        labelFetcher: seriesModel,
	        labelDataIndex: node.dataIndex,
	        defaultText: node.id,
	        isRectText: true
	      });
	      rect.setStyle('fill', node.getVisual('color'));
	      graphic.setHoverStyle(rect, hoverStyle);
	      group.add(rect);
	      nodeData.setItemGraphicEl(node.dataIndex, rect);
	      rect.dataType = 'node';
	    });
	    nodeData.eachItemGraphicEl(function (el, dataIndex) {
	      var itemModel = nodeData.getItemModel(dataIndex);
	
	      if (itemModel.get('draggable')) {
	        el.drift = function (dx, dy) {
	          sankeyView._focusAdjacencyDisabled = true;
	          this.shape.x += dx;
	          this.shape.y += dy;
	          this.dirty();
	          api.dispatchAction({
	            type: 'dragNode',
	            seriesId: seriesModel.id,
	            dataIndex: nodeData.getRawIndex(dataIndex),
	            localX: this.shape.x / width,
	            localY: this.shape.y / height
	          });
	        };
	
	        el.ondragend = function () {
	          sankeyView._focusAdjacencyDisabled = false;
	        };
	
	        el.draggable = true;
	        el.cursor = 'move';
	      }
	
	      el.highlight = function () {
	        this.trigger('emphasis');
	      };
	
	      el.downplay = function () {
	        this.trigger('normal');
	      };
	
	      el.focusNodeAdjHandler && el.off('mouseover', el.focusNodeAdjHandler);
	      el.unfocusNodeAdjHandler && el.off('mouseout', el.unfocusNodeAdjHandler);
	
	      if (itemModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el.focusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._clearTimer();
	
	            api.dispatchAction({
	              type: 'focusNodeAdjacency',
	              seriesId: seriesModel.id,
	              dataIndex: el.dataIndex
	            });
	          }
	        });
	        el.on('mouseout', el.unfocusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._dispatchUnfocus(api);
	          }
	        });
	      }
	    });
	    edgeData.eachItemGraphicEl(function (el, dataIndex) {
	      var edgeModel = edgeData.getItemModel(dataIndex);
	      el.focusNodeAdjHandler && el.off('mouseover', el.focusNodeAdjHandler);
	      el.unfocusNodeAdjHandler && el.off('mouseout', el.unfocusNodeAdjHandler);
	
	      if (edgeModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el.focusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._clearTimer();
	
	            api.dispatchAction({
	              type: 'focusNodeAdjacency',
	              seriesId: seriesModel.id,
	              edgeDataIndex: el.dataIndex
	            });
	          }
	        });
	        el.on('mouseout', el.unfocusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._dispatchUnfocus(api);
	          }
	        });
	      }
	    });
	
	    if (!this._data && seriesModel.get('animation')) {
	      group.setClipPath(createGridClipShape(group.getBoundingRect(), seriesModel, function () {
	        group.removeClipPath();
	      }));
	    }
	
	    this._data = seriesModel.getData();
	  },
	  dispose: function () {
	    this._clearTimer();
	  },
	  _dispatchUnfocus: function (api) {
	    var self = this;
	
	    this._clearTimer();
	
	    this._unfocusDelayTimer = setTimeout(function () {
	      self._unfocusDelayTimer = null;
	      api.dispatchAction({
	        type: 'unfocusNodeAdjacency',
	        seriesId: self._model.id
	      });
	    }, 500);
	  },
	  _clearTimer: function () {
	    if (this._unfocusDelayTimer) {
	      clearTimeout(this._unfocusDelayTimer);
	      this._unfocusDelayTimer = null;
	    }
	  },
	  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var graph = data.graph;
	    var dataIndex = payload.dataIndex;
	    var itemModel = data.getItemModel(dataIndex);
	    var edgeDataIndex = payload.edgeDataIndex;
	
	    if (dataIndex == null && edgeDataIndex == null) {
	      return;
	    }
	
	    var node = graph.getNodeByIndex(dataIndex);
	    var edge = graph.getEdgeByIndex(edgeDataIndex);
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath, 0.1);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath, 0.1);
	    });
	
	    if (node) {
	      fadeInItem(node, hoverNodeOpacityPath);
	      var focusNodeAdj = itemModel.get('focusNodeAdjacency');
	
	      if (focusNodeAdj === 'outEdges') {
	        zrUtil.each(node.outEdges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, hoverLineOpacityPath);
	          fadeInItem(edge.node2, hoverNodeOpacityPath);
	        });
	      } else if (focusNodeAdj === 'inEdges') {
	        zrUtil.each(node.inEdges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, hoverLineOpacityPath);
	          fadeInItem(edge.node1, hoverNodeOpacityPath);
	        });
	      } else if (focusNodeAdj === 'allEdges') {
	        zrUtil.each(node.edges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, hoverLineOpacityPath);
	          edge.node1 !== node && fadeInItem(edge.node1, hoverNodeOpacityPath);
	          edge.node2 !== node && fadeInItem(edge.node2, hoverNodeOpacityPath);
	        });
	      }
	    }
	
	    if (edge) {
	      fadeInItem(edge, hoverLineOpacityPath);
	      fadeInItem(edge.node1, hoverNodeOpacityPath);
	      fadeInItem(edge.node2, hoverNodeOpacityPath);
	    }
	  },
	  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var graph = seriesModel.getGraph();
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath);
	    });
	  }
	}); // Add animation to the view
	
	
	function createGridClipShape(rect, seriesModel, cb) {
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x - 10,
	      y: rect.y - 10,
	      width: 0,
	      height: rect.height + 20
	    }
	  });
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width + 20
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	module.exports = _default;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(482);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'dragNode',
	  event: 'dragnode',
	  // here can only use 'update' now, other value is not support in echarts.
	  update: 'update'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sankey',
	    query: payload
	  }, function (seriesModel) {
	    seriesModel.setNodePosition(payload.dataIndex, [payload.localX, payload.localY]);
	  });
	});

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var layout = __webpack_require__(305);
	
	var zrUtil = __webpack_require__(220);
	
	var _model = __webpack_require__(261);
	
	var groupData = _model.groupData;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api, payload) {
	  ecModel.eachSeriesByType('sankey', function (seriesModel) {
	    var nodeWidth = seriesModel.get('nodeWidth');
	    var nodeGap = seriesModel.get('nodeGap');
	    var layoutInfo = getViewRect(seriesModel, api);
	    seriesModel.layoutInfo = layoutInfo;
	    var width = layoutInfo.width;
	    var height = layoutInfo.height;
	    var graph = seriesModel.getGraph();
	    var nodes = graph.nodes;
	    var edges = graph.edges;
	    computeNodeValues(nodes);
	    var filteredNodes = zrUtil.filter(nodes, function (node) {
	      return node.getLayout().value === 0;
	    });
	    var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
	    var orient = seriesModel.get('orient');
	    var nodeAlign = seriesModel.get('nodeAlign');
	    layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
	  });
	}
	/**
	 * Get the layout position of the whole view
	 *
	 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
	 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
	 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
	 */
	
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
	  computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
	  computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
	  computeEdgeDepths(nodes, orient);
	}
	/**
	 * Compute the value of each node by summing the associated edge's value
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 */
	
	
	function computeNodeValues(nodes) {
	  zrUtil.each(nodes, function (node) {
	    var value1 = sum(node.outEdges, getEdgeValue);
	    var value2 = sum(node.inEdges, getEdgeValue);
	    var nodeRawValue = node.getValue() || 0;
	    var value = Math.max(value1, value2, nodeRawValue);
	    node.setLayout({
	      value: value
	    }, true);
	  });
	}
	/**
	 * Compute the x-position for each node.
	 *
	 * Here we use Kahn algorithm to detect cycle when we traverse
	 * the node to computer the initial x position.
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param  {number} nodeWidth  the dx of the node
	 * @param  {number} width  the whole width of the area to draw the view
	 */
	
	
	function computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
	  // Used to mark whether the edge is deleted. if it is deleted,
	  // the value is 0, otherwise it is 1.
	  var remainEdges = []; // Storage each node's indegree.
	
	  var indegreeArr = []; //Used to storage the node with indegree is equal to 0.
	
	  var zeroIndegrees = [];
	  var nextTargetNode = [];
	  var x = 0;
	  var kx = 0;
	
	  for (var i = 0; i < edges.length; i++) {
	    remainEdges[i] = 1;
	  }
	
	  for (i = 0; i < nodes.length; i++) {
	    indegreeArr[i] = nodes[i].inEdges.length;
	
	    if (indegreeArr[i] === 0) {
	      zeroIndegrees.push(nodes[i]);
	    }
	  }
	
	  var maxNodeDepth = -1; // Traversing nodes using topological sorting to calculate the
	  // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
	  // position of the nodes.
	
	  while (zeroIndegrees.length) {
	    for (var idx = 0; idx < zeroIndegrees.length; idx++) {
	      var node = zeroIndegrees[idx];
	      var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
	      var isItemDepth = item.depth != null && item.depth >= 0;
	
	      if (isItemDepth && item.depth > maxNodeDepth) {
	        maxNodeDepth = item.depth;
	      }
	
	      node.setLayout({
	        depth: isItemDepth ? item.depth : x
	      }, true);
	      orient === 'vertical' ? node.setLayout({
	        dy: nodeWidth
	      }, true) : node.setLayout({
	        dx: nodeWidth
	      }, true);
	
	      for (var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++) {
	        var edge = node.outEdges[edgeIdx];
	        var indexEdge = edges.indexOf(edge);
	        remainEdges[indexEdge] = 0;
	        var targetNode = edge.node2;
	        var nodeIndex = nodes.indexOf(targetNode);
	
	        if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) {
	          nextTargetNode.push(targetNode);
	        }
	      }
	    }
	
	    ++x;
	    zeroIndegrees = nextTargetNode;
	    nextTargetNode = [];
	  }
	
	  for (i = 0; i < remainEdges.length; i++) {
	    if (remainEdges[i] === 1) {
	      throw new Error('Sankey is a DAG, the original data has cycle!');
	    }
	  }
	
	  var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;
	
	  if (nodeAlign && nodeAlign !== 'left') {
	    adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
	  }
	
	  var kx = orient === 'vertical' ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
	  scaleNodeBreadths(nodes, kx, orient);
	}
	
	function isNodeDepth(node) {
	  var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
	  return item.depth != null && item.depth >= 0;
	}
	
	function adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
	  if (nodeAlign === 'right') {
	    var nextSourceNode = [];
	    var remainNodes = nodes;
	    var nodeHeight = 0;
	
	    while (remainNodes.length) {
	      for (var i = 0; i < remainNodes.length; i++) {
	        var node = remainNodes[i];
	        node.setLayout({
	          skNodeHeight: nodeHeight
	        }, true);
	
	        for (var j = 0; j < node.inEdges.length; j++) {
	          var edge = node.inEdges[j];
	
	          if (nextSourceNode.indexOf(edge.node1) < 0) {
	            nextSourceNode.push(edge.node1);
	          }
	        }
	      }
	
	      remainNodes = nextSourceNode;
	      nextSourceNode = [];
	      ++nodeHeight;
	    }
	
	    zrUtil.each(nodes, function (node) {
	      if (!isNodeDepth(node)) {
	        node.setLayout({
	          depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
	        }, true);
	      }
	    });
	  } else if (nodeAlign === 'justify') {
	    moveSinksRight(nodes, maxDepth);
	  }
	}
	/**
	 * All the node without outEgdes are assigned maximum x-position and
	 *     be aligned in the last column.
	 *
	 * @param {module:echarts/data/Graph~Node} nodes.  node of sankey view.
	 * @param {number} maxDepth.  use to assign to node without outEdges as x-position.
	 */
	
	
	function moveSinksRight(nodes, maxDepth) {
	  zrUtil.each(nodes, function (node) {
	    if (!isNodeDepth(node) && !node.outEdges.length) {
	      node.setLayout({
	        depth: maxDepth
	      }, true);
	    }
	  });
	}
	/**
	 * Scale node x-position to the width
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {number} kx   multiple used to scale nodes
	 */
	
	
	function scaleNodeBreadths(nodes, kx, orient) {
	  zrUtil.each(nodes, function (node) {
	    var nodeDepth = node.getLayout().depth * kx;
	    orient === 'vertical' ? node.setLayout({
	      y: nodeDepth
	    }, true) : node.setLayout({
	      x: nodeDepth
	    }, true);
	  });
	}
	/**
	 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
	 * @param {number} height  the whole height of the area to draw the view
	 * @param {number} nodeGap  the vertical distance between two nodes
	 *     in the same column.
	 * @param {number} iterations  the number of iterations for the algorithm
	 */
	
	
	function computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
	  var nodesByBreadth = prepareNodesByBreadth(nodes, orient);
	  initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
	  resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	
	  for (var alpha = 1; iterations > 0; iterations--) {
	    // 0.99 is a experience parameter, ensure that each iterations of
	    // changes as small as possible.
	    alpha *= 0.99;
	    relaxRightToLeft(nodesByBreadth, alpha, orient);
	    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	    relaxLeftToRight(nodesByBreadth, alpha, orient);
	    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	  }
	}
	
	function prepareNodesByBreadth(nodes, orient) {
	  var nodesByBreadth = [];
	  var keyAttr = orient === 'vertical' ? 'y' : 'x';
	  var groupResult = groupData(nodes, function (node) {
	    return node.getLayout()[keyAttr];
	  });
	  groupResult.keys.sort(function (a, b) {
	    return a - b;
	  });
	  zrUtil.each(groupResult.keys, function (key) {
	    nodesByBreadth.push(groupResult.buckets.get(key));
	  });
	  return nodesByBreadth;
	}
	/**
	 * Compute the original y-position for each node
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the nodes x-position.
	 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
	 * @param {number} height  the whole height of the area to draw the view
	 * @param {number} nodeGap  the vertical distance between two nodes
	 */
	
	
	function initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
	  var minKy = Infinity;
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    var n = nodes.length;
	    var sum = 0;
	    zrUtil.each(nodes, function (node) {
	      sum += node.getLayout().value;
	    });
	    var ky = orient === 'vertical' ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;
	
	    if (ky < minKy) {
	      minKy = ky;
	    }
	  });
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    zrUtil.each(nodes, function (node, i) {
	      var nodeDy = node.getLayout().value * minKy;
	
	      if (orient === 'vertical') {
	        node.setLayout({
	          x: i
	        }, true);
	        node.setLayout({
	          dx: nodeDy
	        }, true);
	      } else {
	        node.setLayout({
	          y: i
	        }, true);
	        node.setLayout({
	          dy: nodeDy
	        }, true);
	      }
	    });
	  });
	  zrUtil.each(edges, function (edge) {
	    var edgeDy = +edge.getValue() * minKy;
	    edge.setLayout({
	      dy: edgeDy
	    }, true);
	  });
	}
	/**
	 * Resolve the collision of initialized depth (y-position)
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the nodes x-position.
	 * @param {number} nodeGap  the vertical distance between two nodes
	 * @param {number} height  the whole height of the area to draw the view
	 */
	
	
	function resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
	  var keyAttr = orient === 'vertical' ? 'x' : 'y';
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    nodes.sort(function (a, b) {
	      return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
	    });
	    var nodeX;
	    var node;
	    var dy;
	    var y0 = 0;
	    var n = nodes.length;
	    var nodeDyAttr = orient === 'vertical' ? 'dx' : 'dy';
	
	    for (var i = 0; i < n; i++) {
	      node = nodes[i];
	      dy = y0 - node.getLayout()[keyAttr];
	
	      if (dy > 0) {
	        nodeX = node.getLayout()[keyAttr] + dy;
	        orient === 'vertical' ? node.setLayout({
	          x: nodeX
	        }, true) : node.setLayout({
	          y: nodeX
	        }, true);
	      }
	
	      y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
	    }
	
	    var viewWidth = orient === 'vertical' ? width : height; // If the bottommost node goes outside the bounds, push it back up
	
	    dy = y0 - nodeGap - viewWidth;
	
	    if (dy > 0) {
	      nodeX = node.getLayout()[keyAttr] - dy;
	      orient === 'vertical' ? node.setLayout({
	        x: nodeX
	      }, true) : node.setLayout({
	        y: nodeX
	      }, true);
	      y0 = nodeX;
	
	      for (i = n - 2; i >= 0; --i) {
	        node = nodes[i];
	        dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;
	
	        if (dy > 0) {
	          nodeX = node.getLayout()[keyAttr] - dy;
	          orient === 'vertical' ? node.setLayout({
	            x: nodeX
	          }, true) : node.setLayout({
	            y: nodeX
	          }, true);
	        }
	
	        y0 = node.getLayout()[keyAttr];
	      }
	    }
	  });
	}
	/**
	 * Change the y-position of the nodes, except most the right side nodes
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the node x-position.
	 * @param {number} alpha  parameter used to adjust the nodes y-position
	 */
	
	
	function relaxRightToLeft(nodesByBreadth, alpha, orient) {
	  zrUtil.each(nodesByBreadth.slice().reverse(), function (nodes) {
	    zrUtil.each(nodes, function (node) {
	      if (node.outEdges.length) {
	        var y = sum(node.outEdges, weightedTarget, orient) / sum(node.outEdges, getEdgeValue, orient);
	
	        if (isNaN(y)) {
	          var len = node.outEdges.length;
	          y = len ? sum(node.outEdges, centerTarget, orient) / len : 0;
	        }
	
	        if (orient === 'vertical') {
	          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            x: nodeX
	          }, true);
	        } else {
	          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            y: nodeY
	          }, true);
	        }
	      }
	    });
	  });
	}
	
	function weightedTarget(edge, orient) {
	  return center(edge.node2, orient) * edge.getValue();
	}
	
	function centerTarget(edge, orient) {
	  return center(edge.node2, orient);
	}
	
	function weightedSource(edge, orient) {
	  return center(edge.node1, orient) * edge.getValue();
	}
	
	function centerSource(edge, orient) {
	  return center(edge.node1, orient);
	}
	
	function center(node, orient) {
	  return orient === 'vertical' ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
	}
	
	function getEdgeValue(edge) {
	  return edge.getValue();
	}
	
	function sum(array, cb, orient) {
	  var sum = 0;
	  var len = array.length;
	  var i = -1;
	
	  while (++i < len) {
	    var value = +cb.call(array, array[i], orient);
	
	    if (!isNaN(value)) {
	      sum += value;
	    }
	  }
	
	  return sum;
	}
	/**
	 * Change the y-position of the nodes, except most the left side nodes
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the node x-position.
	 * @param {number} alpha  parameter used to adjust the nodes y-position
	 */
	
	
	function relaxLeftToRight(nodesByBreadth, alpha, orient) {
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    zrUtil.each(nodes, function (node) {
	      if (node.inEdges.length) {
	        var y = sum(node.inEdges, weightedSource, orient) / sum(node.inEdges, getEdgeValue, orient);
	
	        if (isNaN(y)) {
	          var len = node.inEdges.length;
	          y = len ? sum(node.inEdges, centerSource, orient) / len : 0;
	        }
	
	        if (orient === 'vertical') {
	          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            x: nodeX
	          }, true);
	        } else {
	          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            y: nodeY
	          }, true);
	        }
	      }
	    });
	  });
	}
	/**
	 * Compute the depth(y-position) of each edge
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 */
	
	
	function computeEdgeDepths(nodes, orient) {
	  var keyAttr = orient === 'vertical' ? 'x' : 'y';
	  zrUtil.each(nodes, function (node) {
	    node.outEdges.sort(function (a, b) {
	      return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
	    });
	    node.inEdges.sort(function (a, b) {
	      return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
	    });
	  });
	  zrUtil.each(nodes, function (node) {
	    var sy = 0;
	    var ty = 0;
	    zrUtil.each(node.outEdges, function (edge) {
	      edge.setLayout({
	        sy: sy
	      }, true);
	      sy += edge.getLayout().dy;
	    });
	    zrUtil.each(node.inEdges, function (edge) {
	      edge.setLayout({
	        ty: ty
	      }, true);
	      ty += edge.getLayout().dy;
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var VisualMapping = __webpack_require__(468);
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, payload) {
	  ecModel.eachSeriesByType('sankey', function (seriesModel) {
	    var graph = seriesModel.getGraph();
	    var nodes = graph.nodes;
	
	    if (nodes.length) {
	      var minValue = Infinity;
	      var maxValue = -Infinity;
	      zrUtil.each(nodes, function (node) {
	        var nodeValue = node.getLayout().value;
	
	        if (nodeValue < minValue) {
	          minValue = nodeValue;
	        }
	
	        if (nodeValue > maxValue) {
	          maxValue = nodeValue;
	        }
	      });
	      zrUtil.each(nodes, function (node) {
	        var mapping = new VisualMapping({
	          type: 'color',
	          mappingMethod: 'linear',
	          dataExtent: [minValue, maxValue],
	          visual: seriesModel.get('color')
	        });
	        var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
	        var customColor = node.getModel().get('itemStyle.color');
	        customColor != null ? node.setVisual('color', customColor) : node.setVisual('color', mapValueToColor);
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(525);
	
	__webpack_require__(527);
	
	var boxplotVisual = __webpack_require__(528);
	
	var boxplotLayout = __webpack_require__(529);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(boxplotVisual);
	echarts.registerLayout(boxplotLayout);

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var SeriesModel = __webpack_require__(320);
	
	var _whiskerBoxCommon = __webpack_require__(526);
	
	var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BoxplotSeries = SeriesModel.extend({
	  type: 'series.boxplot',
	  dependencies: ['xAxis', 'yAxis', 'grid'],
	  // TODO
	  // box width represents group size, so dimension should have 'size'.
	
	  /**
	   * @see <https://en.wikipedia.org/wiki/Box_plot>
	   * The meanings of 'min' and 'max' depend on user,
	   * and echarts do not need to know it.
	   * @readOnly
	   */
	  defaultValueDimensions: [{
	    name: 'min',
	    defaultTooltip: true
	  }, {
	    name: 'Q1',
	    defaultTooltip: true
	  }, {
	    name: 'median',
	    defaultTooltip: true
	  }, {
	    name: 'Q3',
	    defaultTooltip: true
	  }, {
	    name: 'max',
	    defaultTooltip: true
	  }],
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * @override
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    layout: null,
	    // 'horizontal' or 'vertical'
	    boxWidth: [7, 50],
	    // [min, max] can be percent of band width.
	    itemStyle: {
	      color: '#fff',
	      borderWidth: 1
	    },
	    emphasis: {
	      itemStyle: {
	        borderWidth: 2,
	        shadowBlur: 5,
	        shadowOffsetX: 2,
	        shadowOffsetY: 2,
	        shadowColor: 'rgba(0,0,0,0.4)'
	      }
	    },
	    animationEasing: 'elasticOut',
	    animationDuration: 800
	  }
	});
	zrUtil.mixin(BoxplotSeries, seriesModelMixin, true);
	var _default = BoxplotSeries;
	module.exports = _default;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListSimply = __webpack_require__(404);
	
	var zrUtil = __webpack_require__(220);
	
	var _dimensionHelper = __webpack_require__(344);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var _sourceHelper = __webpack_require__(311);
	
	var makeSeriesEncodeForAxisCoordSys = _sourceHelper.makeSeriesEncodeForAxisCoordSys;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var seriesModelMixin = {
	  /**
	   * @private
	   * @type {string}
	   */
	  _baseAxisDim: null,
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    // When both types of xAxis and yAxis are 'value', layout is
	    // needed to be specified by user. Otherwise, layout can be
	    // judged by which axis is category.
	    var ordinalMeta;
	    var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
	    var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
	    var xAxisType = xAxisModel.get('type');
	    var yAxisType = yAxisModel.get('type');
	    var addOrdinal; // FIXME
	    // Consider time axis.
	
	    if (xAxisType === 'category') {
	      option.layout = 'horizontal';
	      ordinalMeta = xAxisModel.getOrdinalMeta();
	      addOrdinal = true;
	    } else if (yAxisType === 'category') {
	      option.layout = 'vertical';
	      ordinalMeta = yAxisModel.getOrdinalMeta();
	      addOrdinal = true;
	    } else {
	      option.layout = option.layout || 'horizontal';
	    }
	
	    var coordDims = ['x', 'y'];
	    var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
	    var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
	    var otherAxisDim = coordDims[1 - baseAxisDimIndex];
	    var axisModels = [xAxisModel, yAxisModel];
	    var baseAxisType = axisModels[baseAxisDimIndex].get('type');
	    var otherAxisType = axisModels[1 - baseAxisDimIndex].get('type');
	    var data = option.data; // ??? FIXME make a stage to perform data transfrom.
	    // MUST create a new data, consider setOption({}) again.
	
	    if (data && addOrdinal) {
	      var newOptionData = [];
	      zrUtil.each(data, function (item, index) {
	        var newItem;
	
	        if (item.value && zrUtil.isArray(item.value)) {
	          newItem = item.value.slice();
	          item.value.unshift(index);
	        } else if (zrUtil.isArray(item)) {
	          newItem = item.slice();
	          item.unshift(index);
	        } else {
	          newItem = item;
	        }
	
	        newOptionData.push(newItem);
	      });
	      option.data = newOptionData;
	    }
	
	    var defaultValueDimensions = this.defaultValueDimensions;
	    var coordDimensions = [{
	      name: baseAxisDim,
	      type: getDimensionTypeByAxis(baseAxisType),
	      ordinalMeta: ordinalMeta,
	      otherDims: {
	        tooltip: false,
	        itemName: 0
	      },
	      dimsDef: ['base']
	    }, {
	      name: otherAxisDim,
	      type: getDimensionTypeByAxis(otherAxisType),
	      dimsDef: defaultValueDimensions.slice()
	    }];
	    return createListSimply(this, {
	      coordDimensions: coordDimensions,
	      dimensionsCount: defaultValueDimensions.length + 1,
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForAxisCoordSys, coordDimensions, this)
	    });
	  },
	
	  /**
	   * If horizontal, base axis is x, otherwise y.
	   * @override
	   */
	  getBaseAxis: function () {
	    var dim = this._baseAxisDim;
	    return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
	  }
	};
	exports.seriesModelMixin = seriesModelMixin;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var ChartView = __webpack_require__(325);
	
	var graphic = __webpack_require__(268);
	
	var Path = __webpack_require__(270);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Update common properties
	var NORMAL_ITEM_STYLE_PATH = ['itemStyle'];
	var EMPHASIS_ITEM_STYLE_PATH = ['emphasis', 'itemStyle'];
	var BoxplotView = ChartView.extend({
	  type: 'boxplot',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var group = this.group;
	    var oldData = this._data; // There is no old data only when first rendering or switching from
	    // stream mode to normal mode, where previous elements should be removed.
	
	    if (!this._data) {
	      group.removeAll();
	    }
	
	    var constDim = seriesModel.get('layout') === 'horizontal' ? 1 : 0;
	    data.diff(oldData).add(function (newIdx) {
	      if (data.hasValue(newIdx)) {
	        var itemLayout = data.getItemLayout(newIdx);
	        var symbolEl = createNormalBox(itemLayout, data, newIdx, constDim, true);
	        data.setItemGraphicEl(newIdx, symbolEl);
	        group.add(symbolEl);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	      if (!data.hasValue(newIdx)) {
	        group.remove(symbolEl);
	        return;
	      }
	
	      var itemLayout = data.getItemLayout(newIdx);
	
	      if (!symbolEl) {
	        symbolEl = createNormalBox(itemLayout, data, newIdx, constDim);
	      } else {
	        updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
	      }
	
	      group.add(symbolEl);
	      data.setItemGraphicEl(newIdx, symbolEl);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute();
	    this._data = data;
	  },
	  remove: function (ecModel) {
	    var group = this.group;
	    var data = this._data;
	    this._data = null;
	    data && data.eachItemGraphicEl(function (el) {
	      el && group.remove(el);
	    });
	  },
	  dispose: zrUtil.noop
	});
	var BoxPath = Path.extend({
	  type: 'boxplotBoxPath',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    var ends = shape.points;
	    var i = 0;
	    ctx.moveTo(ends[i][0], ends[i][1]);
	    i++;
	
	    for (; i < 4; i++) {
	      ctx.lineTo(ends[i][0], ends[i][1]);
	    }
	
	    ctx.closePath();
	
	    for (; i < ends.length; i++) {
	      ctx.moveTo(ends[i][0], ends[i][1]);
	      i++;
	      ctx.lineTo(ends[i][0], ends[i][1]);
	    }
	  }
	});
	
	function createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
	  var ends = itemLayout.ends;
	  var el = new BoxPath({
	    shape: {
	      points: isInit ? transInit(ends, constDim, itemLayout) : ends
	    }
	  });
	  updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
	  return el;
	}
	
	function updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
	  var seriesModel = data.hostModel;
	  var updateMethod = graphic[isInit ? 'initProps' : 'updateProps'];
	  updateMethod(el, {
	    shape: {
	      points: itemLayout.ends
	    }
	  }, seriesModel, dataIndex);
	  var itemModel = data.getItemModel(dataIndex);
	  var normalItemStyleModel = itemModel.getModel(NORMAL_ITEM_STYLE_PATH);
	  var borderColor = data.getItemVisual(dataIndex, 'color'); // Exclude borderColor.
	
	  var itemStyle = normalItemStyleModel.getItemStyle(['borderColor']);
	  itemStyle.stroke = borderColor;
	  itemStyle.strokeNoScale = true;
	  el.useStyle(itemStyle);
	  el.z2 = 100;
	  var hoverStyle = itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
	  graphic.setHoverStyle(el, hoverStyle);
	}
	
	function transInit(points, dim, itemLayout) {
	  return zrUtil.map(points, function (point) {
	    point = point.slice();
	    point[dim] = itemLayout.initBaseline;
	    return point;
	  });
	}
	
	var _default = BoxplotView;
	module.exports = _default;

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var borderColorQuery = ['itemStyle', 'borderColor'];
	
	function _default(ecModel, api) {
	  var globalColors = ecModel.get('color');
	  ecModel.eachRawSeriesByType('boxplot', function (seriesModel) {
	    var defaulColor = globalColors[seriesModel.seriesIndex % globalColors.length];
	    var data = seriesModel.getData();
	    data.setVisual({
	      legendSymbol: 'roundRect',
	      // Use name 'color' but not 'borderColor' for legend usage and
	      // visual coding from other component like dataRange.
	      color: seriesModel.get(borderColorQuery) || defaulColor
	    }); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      data.each(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        data.setItemVisual(idx, {
	          color: itemModel.get(borderColorQuery, true)
	        });
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	
	function _default(ecModel) {
	  var groupResult = groupSeriesByAxis(ecModel);
	  each(groupResult, function (groupItem) {
	    var seriesModels = groupItem.seriesModels;
	
	    if (!seriesModels.length) {
	      return;
	    }
	
	    calculateBase(groupItem);
	    each(seriesModels, function (seriesModel, idx) {
	      layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
	    });
	  });
	}
	/**
	 * Group series by axis.
	 */
	
	
	function groupSeriesByAxis(ecModel) {
	  var result = [];
	  var axisList = [];
	  ecModel.eachSeriesByType('boxplot', function (seriesModel) {
	    var baseAxis = seriesModel.getBaseAxis();
	    var idx = zrUtil.indexOf(axisList, baseAxis);
	
	    if (idx < 0) {
	      idx = axisList.length;
	      axisList[idx] = baseAxis;
	      result[idx] = {
	        axis: baseAxis,
	        seriesModels: []
	      };
	    }
	
	    result[idx].seriesModels.push(seriesModel);
	  });
	  return result;
	}
	/**
	 * Calculate offset and box width for each series.
	 */
	
	
	function calculateBase(groupItem) {
	  var extent;
	  var baseAxis = groupItem.axis;
	  var seriesModels = groupItem.seriesModels;
	  var seriesCount = seriesModels.length;
	  var boxWidthList = groupItem.boxWidthList = [];
	  var boxOffsetList = groupItem.boxOffsetList = [];
	  var boundList = [];
	  var bandWidth;
	
	  if (baseAxis.type === 'category') {
	    bandWidth = baseAxis.getBandWidth();
	  } else {
	    var maxDataCount = 0;
	    each(seriesModels, function (seriesModel) {
	      maxDataCount = Math.max(maxDataCount, seriesModel.getData().count());
	    });
	    extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / maxDataCount;
	  }
	
	  each(seriesModels, function (seriesModel) {
	    var boxWidthBound = seriesModel.get('boxWidth');
	
	    if (!zrUtil.isArray(boxWidthBound)) {
	      boxWidthBound = [boxWidthBound, boxWidthBound];
	    }
	
	    boundList.push([parsePercent(boxWidthBound[0], bandWidth) || 0, parsePercent(boxWidthBound[1], bandWidth) || 0]);
	  });
	  var availableWidth = bandWidth * 0.8 - 2;
	  var boxGap = availableWidth / seriesCount * 0.3;
	  var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
	  var base = boxWidth / 2 - availableWidth / 2;
	  each(seriesModels, function (seriesModel, idx) {
	    boxOffsetList.push(base);
	    base += boxGap + boxWidth;
	    boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
	  });
	}
	/**
	 * Calculate points location for each series.
	 */
	
	
	function layoutSingleSeries(seriesModel, offset, boxWidth) {
	  var coordSys = seriesModel.coordinateSystem;
	  var data = seriesModel.getData();
	  var halfWidth = boxWidth / 2;
	  var cDimIdx = seriesModel.get('layout') === 'horizontal' ? 0 : 1;
	  var vDimIdx = 1 - cDimIdx;
	  var coordDims = ['x', 'y'];
	  var cDim = data.mapDimension(coordDims[cDimIdx]);
	  var vDims = data.mapDimension(coordDims[vDimIdx], true);
	
	  if (cDim == null || vDims.length < 5) {
	    return;
	  }
	
	  for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
	    var axisDimVal = data.get(cDim, dataIndex);
	    var median = getPoint(axisDimVal, vDims[2], dataIndex);
	    var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
	    var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
	    var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
	    var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
	    var ends = [];
	    addBodyEnd(ends, end2, 0);
	    addBodyEnd(ends, end4, 1);
	    ends.push(end1, end2, end5, end4);
	    layEndLine(ends, end1);
	    layEndLine(ends, end5);
	    layEndLine(ends, median);
	    data.setItemLayout(dataIndex, {
	      initBaseline: median[vDimIdx],
	      ends: ends
	    });
	  }
	
	  function getPoint(axisDimVal, dimIdx, dataIndex) {
	    var val = data.get(dimIdx, dataIndex);
	    var p = [];
	    p[cDimIdx] = axisDimVal;
	    p[vDimIdx] = val;
	    var point;
	
	    if (isNaN(axisDimVal) || isNaN(val)) {
	      point = [NaN, NaN];
	    } else {
	      point = coordSys.dataToPoint(p);
	      point[cDimIdx] += offset;
	    }
	
	    return point;
	  }
	
	  function addBodyEnd(ends, point, start) {
	    var point1 = point.slice();
	    var point2 = point.slice();
	    point1[cDimIdx] += halfWidth;
	    point2[cDimIdx] -= halfWidth;
	    start ? ends.push(point1, point2) : ends.push(point2, point1);
	  }
	
	  function layEndLine(ends, endCenter) {
	    var from = endCenter.slice();
	    var to = endCenter.slice();
	    from[cDimIdx] -= halfWidth;
	    to[cDimIdx] += halfWidth;
	    ends.push(from, to);
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(531);
	
	__webpack_require__(532);
	
	var preprocessor = __webpack_require__(533);
	
	var candlestickVisual = __webpack_require__(534);
	
	var candlestickLayout = __webpack_require__(535);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(preprocessor);
	echarts.registerVisual(candlestickVisual);
	echarts.registerLayout(candlestickLayout);

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var SeriesModel = __webpack_require__(320);
	
	var _whiskerBoxCommon = __webpack_require__(526);
	
	var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CandlestickSeries = SeriesModel.extend({
	  type: 'series.candlestick',
	  dependencies: ['xAxis', 'yAxis', 'grid'],
	
	  /**
	   * @readOnly
	   */
	  defaultValueDimensions: [{
	    name: 'open',
	    defaultTooltip: true
	  }, {
	    name: 'close',
	    defaultTooltip: true
	  }, {
	    name: 'lowest',
	    defaultTooltip: true
	  }, {
	    name: 'highest',
	    defaultTooltip: true
	  }],
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * @override
	   */
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    layout: null,
	    // 'horizontal' or 'vertical'
	    clip: true,
	    itemStyle: {
	      color: '#c23531',
	      // 阳线 positive
	      color0: '#314656',
	      // 阴线 negative     '#c23531', '#314656'
	      borderWidth: 1,
	      // FIXME
	      // ec2中使用的是lineStyle.color 和 lineStyle.color0
	      borderColor: '#c23531',
	      borderColor0: '#314656'
	    },
	    emphasis: {
	      itemStyle: {
	        borderWidth: 2
	      }
	    },
	    barMaxWidth: null,
	    barMinWidth: null,
	    barWidth: null,
	    large: true,
	    largeThreshold: 600,
	    progressive: 3e3,
	    progressiveThreshold: 1e4,
	    progressiveChunkMode: 'mod',
	    animationUpdate: false,
	    animationEasing: 'linear',
	    animationDuration: 300
	  },
	
	  /**
	   * Get dimension for shadow in dataZoom
	   * @return {string} dimension name
	   */
	  getShadowDim: function () {
	    return 'open';
	  },
	  brushSelector: function (dataIndex, data, selectors) {
	    var itemLayout = data.getItemLayout(dataIndex);
	    return itemLayout && selectors.rect(itemLayout.brushRect);
	  }
	});
	zrUtil.mixin(CandlestickSeries, seriesModelMixin, true);
	var _default = CandlestickSeries;
	module.exports = _default;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var ChartView = __webpack_require__(325);
	
	var graphic = __webpack_require__(268);
	
	var Path = __webpack_require__(270);
	
	var _createClipPathFromCoordSys = __webpack_require__(375);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NORMAL_ITEM_STYLE_PATH = ['itemStyle'];
	var EMPHASIS_ITEM_STYLE_PATH = ['emphasis', 'itemStyle'];
	var SKIP_PROPS = ['color', 'color0', 'borderColor', 'borderColor0'];
	var CandlestickView = ChartView.extend({
	  type: 'candlestick',
	  render: function (seriesModel, ecModel, api) {
	    // If there is clipPath created in large mode. Remove it.
	    this.group.removeClipPath();
	
	    this._updateDrawMode(seriesModel);
	
	    this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    this._updateDrawMode(seriesModel);
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
	  },
	  _updateDrawMode: function (seriesModel) {
	    var isLargeDraw = seriesModel.pipelineContext.large;
	
	    if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
	      this._isLargeDraw = isLargeDraw;
	
	      this._clear();
	    }
	  },
	  _renderNormal: function (seriesModel) {
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    var isSimpleBox = data.getLayout('isSimpleBox');
	    var needsClip = seriesModel.get('clip', true);
	    var coord = seriesModel.coordinateSystem;
	    var clipArea = coord.getArea && coord.getArea(); // There is no old data only when first rendering or switching from
	    // stream mode to normal mode, where previous elements should be removed.
	
	    if (!this._data) {
	      group.removeAll();
	    }
	
	    data.diff(oldData).add(function (newIdx) {
	      if (data.hasValue(newIdx)) {
	        var el;
	        var itemLayout = data.getItemLayout(newIdx);
	
	        if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
	          return;
	        }
	
	        el = createNormalBox(itemLayout, newIdx, true);
	        graphic.initProps(el, {
	          shape: {
	            points: itemLayout.ends
	          }
	        }, seriesModel, newIdx);
	        setBoxCommon(el, data, newIdx, isSimpleBox);
	        group.add(el);
	        data.setItemGraphicEl(newIdx, el);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	      if (!data.hasValue(newIdx)) {
	        group.remove(el);
	        return;
	      }
	
	      var itemLayout = data.getItemLayout(newIdx);
	
	      if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
	        group.remove(el);
	        return;
	      }
	
	      if (!el) {
	        el = createNormalBox(itemLayout, newIdx);
	      } else {
	        graphic.updateProps(el, {
	          shape: {
	            points: itemLayout.ends
	          }
	        }, seriesModel, newIdx);
	      }
	
	      setBoxCommon(el, data, newIdx, isSimpleBox);
	      group.add(el);
	      data.setItemGraphicEl(newIdx, el);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute();
	    this._data = data;
	  },
	  _renderLarge: function (seriesModel) {
	    this._clear();
	
	    createLarge(seriesModel, this.group);
	    var clipPath = seriesModel.get('clip', true) ? createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;
	
	    if (clipPath) {
	      this.group.setClipPath(clipPath);
	    } else {
	      this.group.removeClipPath();
	    }
	  },
	  _incrementalRenderNormal: function (params, seriesModel) {
	    var data = seriesModel.getData();
	    var isSimpleBox = data.getLayout('isSimpleBox');
	    var dataIndex;
	
	    while ((dataIndex = params.next()) != null) {
	      var el;
	      var itemLayout = data.getItemLayout(dataIndex);
	      el = createNormalBox(itemLayout, dataIndex);
	      setBoxCommon(el, data, dataIndex, isSimpleBox);
	      el.incremental = true;
	      this.group.add(el);
	    }
	  },
	  _incrementalRenderLarge: function (params, seriesModel) {
	    createLarge(seriesModel, this.group, true);
	  },
	  remove: function (ecModel) {
	    this._clear();
	  },
	  _clear: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: zrUtil.noop
	});
	var NormalBoxPath = Path.extend({
	  type: 'normalCandlestickBox',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    var ends = shape.points;
	
	    if (this.__simpleBox) {
	      ctx.moveTo(ends[4][0], ends[4][1]);
	      ctx.lineTo(ends[6][0], ends[6][1]);
	    } else {
	      ctx.moveTo(ends[0][0], ends[0][1]);
	      ctx.lineTo(ends[1][0], ends[1][1]);
	      ctx.lineTo(ends[2][0], ends[2][1]);
	      ctx.lineTo(ends[3][0], ends[3][1]);
	      ctx.closePath();
	      ctx.moveTo(ends[4][0], ends[4][1]);
	      ctx.lineTo(ends[5][0], ends[5][1]);
	      ctx.moveTo(ends[6][0], ends[6][1]);
	      ctx.lineTo(ends[7][0], ends[7][1]);
	    }
	  }
	});
	
	function createNormalBox(itemLayout, dataIndex, isInit) {
	  var ends = itemLayout.ends;
	  return new NormalBoxPath({
	    shape: {
	      points: isInit ? transInit(ends, itemLayout) : ends
	    },
	    z2: 100
	  });
	}
	
	function isNormalBoxClipped(clipArea, itemLayout) {
	  var clipped = true;
	
	  for (var i = 0; i < itemLayout.ends.length; i++) {
	    // If any point are in the region.
	    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
	      clipped = false;
	      break;
	    }
	  }
	
	  return clipped;
	}
	
	function setBoxCommon(el, data, dataIndex, isSimpleBox) {
	  var itemModel = data.getItemModel(dataIndex);
	  var normalItemStyleModel = itemModel.getModel(NORMAL_ITEM_STYLE_PATH);
	  var color = data.getItemVisual(dataIndex, 'color');
	  var borderColor = data.getItemVisual(dataIndex, 'borderColor') || color; // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var itemStyle = normalItemStyleModel.getItemStyle(SKIP_PROPS);
	  el.useStyle(itemStyle);
	  el.style.strokeNoScale = true;
	  el.style.fill = color;
	  el.style.stroke = borderColor;
	  el.__simpleBox = isSimpleBox;
	  var hoverStyle = itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
	  graphic.setHoverStyle(el, hoverStyle);
	}
	
	function transInit(points, itemLayout) {
	  return zrUtil.map(points, function (point) {
	    point = point.slice();
	    point[1] = itemLayout.initBaseline;
	    return point;
	  });
	}
	
	var LargeBoxPath = Path.extend({
	  type: 'largeCandlestickBox',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    // Drawing lines is more efficient than drawing
	    // a whole line or drawing rects.
	    var points = shape.points;
	
	    for (var i = 0; i < points.length;) {
	      if (this.__sign === points[i++]) {
	        var x = points[i++];
	        ctx.moveTo(x, points[i++]);
	        ctx.lineTo(x, points[i++]);
	      } else {
	        i += 3;
	      }
	    }
	  }
	});
	
	function createLarge(seriesModel, group, incremental) {
	  var data = seriesModel.getData();
	  var largePoints = data.getLayout('largePoints');
	  var elP = new LargeBoxPath({
	    shape: {
	      points: largePoints
	    },
	    __sign: 1
	  });
	  group.add(elP);
	  var elN = new LargeBoxPath({
	    shape: {
	      points: largePoints
	    },
	    __sign: -1
	  });
	  group.add(elN);
	  setLargeStyle(1, elP, seriesModel, data);
	  setLargeStyle(-1, elN, seriesModel, data);
	
	  if (incremental) {
	    elP.incremental = true;
	    elN.incremental = true;
	  }
	}
	
	function setLargeStyle(sign, el, seriesModel, data) {
	  var suffix = sign > 0 ? 'P' : 'N';
	  var borderColor = data.getVisual('borderColor' + suffix) || data.getVisual('color' + suffix); // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var itemStyle = seriesModel.getModel(NORMAL_ITEM_STYLE_PATH).getItemStyle(SKIP_PROPS);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor; // No different
	  // el.style.lineWidth = .5;
	}
	
	var _default = CandlestickView;
	module.exports = _default;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  if (!option || !zrUtil.isArray(option.series)) {
	    return;
	  } // Translate 'k' to 'candlestick'.
	
	
	  zrUtil.each(option.series, function (seriesItem) {
	    if (zrUtil.isObject(seriesItem) && seriesItem.type === 'k') {
	      seriesItem.type = 'candlestick';
	    }
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createRenderPlanner = __webpack_require__(326);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var positiveBorderColorQuery = ['itemStyle', 'borderColor'];
	var negativeBorderColorQuery = ['itemStyle', 'borderColor0'];
	var positiveColorQuery = ['itemStyle', 'color'];
	var negativeColorQuery = ['itemStyle', 'color0'];
	var _default = {
	  seriesType: 'candlestick',
	  plan: createRenderPlanner(),
	  // For legend.
	  performRawSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    data.setVisual({
	      legendSymbol: 'roundRect',
	      colorP: getColor(1, seriesModel),
	      colorN: getColor(-1, seriesModel),
	      borderColorP: getBorderColor(1, seriesModel),
	      borderColorN: getBorderColor(-1, seriesModel)
	    }); // Only visible series has each data be visual encoded
	
	    if (ecModel.isSeriesFiltered(seriesModel)) {
	      return;
	    }
	
	    var isLargeRender = seriesModel.pipelineContext.large;
	    return !isLargeRender && {
	      progress: progress
	    };
	
	    function progress(params, data) {
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var itemModel = data.getItemModel(dataIndex);
	        var sign = data.getItemLayout(dataIndex).sign;
	        data.setItemVisual(dataIndex, {
	          color: getColor(sign, itemModel),
	          borderColor: getBorderColor(sign, itemModel)
	        });
	      }
	    }
	
	    function getColor(sign, model) {
	      return model.get(sign > 0 ? positiveColorQuery : negativeColorQuery);
	    }
	
	    function getBorderColor(sign, model) {
	      return model.get(sign > 0 ? positiveBorderColorQuery : negativeBorderColorQuery);
	    }
	  }
	};
	module.exports = _default;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _graphic = __webpack_require__(268);
	
	var subPixelOptimize = _graphic.subPixelOptimize;
	
	var createRenderPlanner = __webpack_require__(326);
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	
	var _util = __webpack_require__(220);
	
	var retrieve2 = _util.retrieve2;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
	var _default = {
	  seriesType: 'candlestick',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var data = seriesModel.getData();
	    var candleWidth = calculateCandleWidth(seriesModel, data);
	    var cDimIdx = 0;
	    var vDimIdx = 1;
	    var coordDims = ['x', 'y'];
	    var cDim = data.mapDimension(coordDims[cDimIdx]);
	    var vDims = data.mapDimension(coordDims[vDimIdx], true);
	    var openDim = vDims[0];
	    var closeDim = vDims[1];
	    var lowestDim = vDims[2];
	    var highestDim = vDims[3];
	    data.setLayout({
	      candleWidth: candleWidth,
	      // The value is experimented visually.
	      isSimpleBox: candleWidth <= 1.3
	    });
	
	    if (cDim == null || vDims.length < 4) {
	      return;
	    }
	
	    return {
	      progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
	    };
	
	    function normalProgress(params, data) {
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var axisDimVal = data.get(cDim, dataIndex);
	        var openVal = data.get(openDim, dataIndex);
	        var closeVal = data.get(closeDim, dataIndex);
	        var lowestVal = data.get(lowestDim, dataIndex);
	        var highestVal = data.get(highestDim, dataIndex);
	        var ocLow = Math.min(openVal, closeVal);
	        var ocHigh = Math.max(openVal, closeVal);
	        var ocLowPoint = getPoint(ocLow, axisDimVal);
	        var ocHighPoint = getPoint(ocHigh, axisDimVal);
	        var lowestPoint = getPoint(lowestVal, axisDimVal);
	        var highestPoint = getPoint(highestVal, axisDimVal);
	        var ends = [];
	        addBodyEnd(ends, ocHighPoint, 0);
	        addBodyEnd(ends, ocLowPoint, 1);
	        ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
	        data.setItemLayout(dataIndex, {
	          sign: getSign(data, dataIndex, openVal, closeVal, closeDim),
	          initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
	          // open point.
	          ends: ends,
	          brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
	        });
	      }
	
	      function getPoint(val, axisDimVal) {
	        var p = [];
	        p[cDimIdx] = axisDimVal;
	        p[vDimIdx] = val;
	        return isNaN(axisDimVal) || isNaN(val) ? [NaN, NaN] : coordSys.dataToPoint(p);
	      }
	
	      function addBodyEnd(ends, point, start) {
	        var point1 = point.slice();
	        var point2 = point.slice();
	        point1[cDimIdx] = subPixelOptimize(point1[cDimIdx] + candleWidth / 2, 1, false);
	        point2[cDimIdx] = subPixelOptimize(point2[cDimIdx] - candleWidth / 2, 1, true);
	        start ? ends.push(point1, point2) : ends.push(point2, point1);
	      }
	
	      function makeBrushRect(lowestVal, highestVal, axisDimVal) {
	        var pmin = getPoint(lowestVal, axisDimVal);
	        var pmax = getPoint(highestVal, axisDimVal);
	        pmin[cDimIdx] -= candleWidth / 2;
	        pmax[cDimIdx] -= candleWidth / 2;
	        return {
	          x: pmin[0],
	          y: pmin[1],
	          width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
	          height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
	        };
	      }
	
	      function subPixelOptimizePoint(point) {
	        point[cDimIdx] = subPixelOptimize(point[cDimIdx], 1);
	        return point;
	      }
	    }
	
	    function largeProgress(params, data) {
	      // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
	      var points = new LargeArr(params.count * 4);
	      var offset = 0;
	      var point;
	      var tmpIn = [];
	      var tmpOut = [];
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var axisDimVal = data.get(cDim, dataIndex);
	        var openVal = data.get(openDim, dataIndex);
	        var closeVal = data.get(closeDim, dataIndex);
	        var lowestVal = data.get(lowestDim, dataIndex);
	        var highestVal = data.get(highestDim, dataIndex);
	
	        if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
	          points[offset++] = NaN;
	          offset += 3;
	          continue;
	        }
	
	        points[offset++] = getSign(data, dataIndex, openVal, closeVal, closeDim);
	        tmpIn[cDimIdx] = axisDimVal;
	        tmpIn[vDimIdx] = lowestVal;
	        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	        points[offset++] = point ? point[0] : NaN;
	        points[offset++] = point ? point[1] : NaN;
	        tmpIn[vDimIdx] = highestVal;
	        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	        points[offset++] = point ? point[1] : NaN;
	      }
	
	      data.setLayout('largePoints', points);
	    }
	  }
	};
	
	function getSign(data, dataIndex, openVal, closeVal, closeDim) {
	  var sign;
	
	  if (openVal > closeVal) {
	    sign = -1;
	  } else if (openVal < closeVal) {
	    sign = 1;
	  } else {
	    sign = dataIndex > 0 // If close === open, compare with close of last record
	    ? data.get(closeDim, dataIndex - 1) <= closeVal ? 1 : -1 : // No record of previous, set to be positive
	    1;
	  }
	
	  return sign;
	}
	
	function calculateCandleWidth(seriesModel, data) {
	  var baseAxis = seriesModel.getBaseAxis();
	  var extent;
	  var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
	  var barMaxWidth = parsePercent(retrieve2(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
	  var barMinWidth = parsePercent(retrieve2(seriesModel.get('barMinWidth'), 1), bandWidth);
	  var barWidth = seriesModel.get('barWidth');
	  return barWidth != null ? parsePercent(barWidth, bandWidth) // Put max outer to ensure bar visible in spite of overlap.
	  : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
	}
	
	module.exports = _default;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(537);
	
	__webpack_require__(538);
	
	var visualSymbol = __webpack_require__(376);
	
	var layoutPoints = __webpack_require__(377);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(visualSymbol('effectScatter', 'circle'));
	echarts.registerLayout(layoutPoints('effectScatter'));

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListFromArray = __webpack_require__(341);
	
	var SeriesModel = __webpack_require__(320);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.effectScatter',
	  dependencies: ['grid', 'polar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  brushSelector: 'point',
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    effectType: 'ripple',
	    progressive: 0,
	    // When to show the effect, option: 'render'|'emphasis'
	    showEffectOn: 'render',
	    // Ripple effect config
	    rippleEffect: {
	      period: 4,
	      // Scale of ripple
	      scale: 2.5,
	      // Brush type can be fill or stroke
	      brushType: 'fill'
	    },
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // symbol: null,        // 图形类型
	    symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	    // symbolRotate: null,  // 图形旋转控制
	    // large: false,
	    // Available when large is true
	    // largeThreshold: 2000,
	    // itemStyle: {
	    //     opacity: 1
	    // }
	
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var SymbolDraw = __webpack_require__(369);
	
	var EffectSymbol = __webpack_require__(539);
	
	var matrix = __webpack_require__(233);
	
	var pointsLayout = __webpack_require__(377);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'effectScatter',
	  init: function () {
	    this._symbolDraw = new SymbolDraw(EffectSymbol);
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var effectSymbolDraw = this._symbolDraw;
	    effectSymbolDraw.updateData(data);
	    this.group.add(effectSymbolDraw.group);
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    this.group.dirty();
	    var res = pointsLayout().reset(seriesModel);
	
	    if (res.progress) {
	      res.progress({
	        start: 0,
	        end: data.count()
	      }, data);
	    }
	
	    this._symbolDraw.updateLayout(data);
	  },
	  _updateGroupTransform: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.getRoamTransform) {
	      this.group.transform = matrix.clone(coordSys.getRoamTransform());
	      this.group.decomposeTransform();
	    }
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove(api);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var _symbol = __webpack_require__(360);
	
	var createSymbol = _symbol.createSymbol;
	
	var _graphic = __webpack_require__(268);
	
	var Group = _graphic.Group;
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	
	var SymbolClz = __webpack_require__(370);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Symbol with ripple effect
	 * @module echarts/chart/helper/EffectSymbol
	 */
	var EFFECT_RIPPLE_NUMBER = 3;
	
	function normalizeSymbolSize(symbolSize) {
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [+symbolSize, +symbolSize];
	  }
	
	  return symbolSize;
	}
	
	function updateRipplePath(rippleGroup, effectCfg) {
	  var color = effectCfg.rippleEffectColor || effectCfg.color;
	  rippleGroup.eachChild(function (ripplePath) {
	    ripplePath.attr({
	      z: effectCfg.z,
	      zlevel: effectCfg.zlevel,
	      style: {
	        stroke: effectCfg.brushType === 'stroke' ? color : null,
	        fill: effectCfg.brushType === 'fill' ? color : null
	      }
	    });
	  });
	}
	/**
	 * @constructor
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function EffectSymbol(data, idx) {
	  Group.call(this);
	  var symbol = new SymbolClz(data, idx);
	  var rippleGroup = new Group();
	  this.add(symbol);
	  this.add(rippleGroup);
	
	  rippleGroup.beforeUpdate = function () {
	    this.attr(symbol.getScale());
	  };
	
	  this.updateData(data, idx);
	}
	
	var effectSymbolProto = EffectSymbol.prototype;
	
	effectSymbolProto.stopEffectAnimation = function () {
	  this.childAt(1).removeAll();
	};
	
	effectSymbolProto.startEffectAnimation = function (effectCfg) {
	  var symbolType = effectCfg.symbolType;
	  var color = effectCfg.color;
	  var rippleGroup = this.childAt(1);
	
	  for (var i = 0; i < EFFECT_RIPPLE_NUMBER; i++) {
	    // If width/height are set too small (e.g., set to 1) on ios10
	    // and macOS Sierra, a circle stroke become a rect, no matter what
	    // the scale is set. So we set width/height as 2. See #4136.
	    var ripplePath = createSymbol(symbolType, -1, -1, 2, 2, color);
	    ripplePath.attr({
	      style: {
	        strokeNoScale: true
	      },
	      z2: 99,
	      silent: true,
	      scale: [0.5, 0.5]
	    });
	    var delay = -i / EFFECT_RIPPLE_NUMBER * effectCfg.period + effectCfg.effectOffset; // TODO Configurable effectCfg.period
	
	    ripplePath.animate('', true).when(effectCfg.period, {
	      scale: [effectCfg.rippleScale / 2, effectCfg.rippleScale / 2]
	    }).delay(delay).start();
	    ripplePath.animateStyle(true).when(effectCfg.period, {
	      opacity: 0
	    }).delay(delay).start();
	    rippleGroup.add(ripplePath);
	  }
	
	  updateRipplePath(rippleGroup, effectCfg);
	};
	/**
	 * Update effect symbol
	 */
	
	
	effectSymbolProto.updateEffectAnimation = function (effectCfg) {
	  var oldEffectCfg = this._effectCfg;
	  var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed
	
	  var DIFFICULT_PROPS = ['symbolType', 'period', 'rippleScale'];
	
	  for (var i = 0; i < DIFFICULT_PROPS.length; i++) {
	    var propName = DIFFICULT_PROPS[i];
	
	    if (oldEffectCfg[propName] !== effectCfg[propName]) {
	      this.stopEffectAnimation();
	      this.startEffectAnimation(effectCfg);
	      return;
	    }
	  }
	
	  updateRipplePath(rippleGroup, effectCfg);
	};
	/**
	 * Highlight symbol
	 */
	
	
	effectSymbolProto.highlight = function () {
	  this.trigger('emphasis');
	};
	/**
	 * Downplay symbol
	 */
	
	
	effectSymbolProto.downplay = function () {
	  this.trigger('normal');
	};
	/**
	 * Update symbol properties
	 * @param  {module:echarts/data/List} data
	 * @param  {number} idx
	 */
	
	
	effectSymbolProto.updateData = function (data, idx) {
	  var seriesModel = data.hostModel;
	  this.childAt(0).updateData(data, idx);
	  var rippleGroup = this.childAt(1);
	  var itemModel = data.getItemModel(idx);
	  var symbolType = data.getItemVisual(idx, 'symbol');
	  var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	  var color = data.getItemVisual(idx, 'color');
	  rippleGroup.attr('scale', symbolSize);
	  rippleGroup.traverse(function (ripplePath) {
	    ripplePath.attr({
	      fill: color
	    });
	  });
	  var symbolOffset = itemModel.getShallow('symbolOffset');
	
	  if (symbolOffset) {
	    var pos = rippleGroup.position;
	    pos[0] = parsePercent(symbolOffset[0], symbolSize[0]);
	    pos[1] = parsePercent(symbolOffset[1], symbolSize[1]);
	  }
	
	  var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
	  rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  var effectCfg = {};
	  effectCfg.showEffectOn = seriesModel.get('showEffectOn');
	  effectCfg.rippleScale = itemModel.get('rippleEffect.scale');
	  effectCfg.brushType = itemModel.get('rippleEffect.brushType');
	  effectCfg.period = itemModel.get('rippleEffect.period') * 1000;
	  effectCfg.effectOffset = idx / data.count();
	  effectCfg.z = itemModel.getShallow('z') || 0;
	  effectCfg.zlevel = itemModel.getShallow('zlevel') || 0;
	  effectCfg.symbolType = symbolType;
	  effectCfg.color = color;
	  effectCfg.rippleEffectColor = itemModel.get('rippleEffect.color');
	  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
	
	  if (effectCfg.showEffectOn === 'render') {
	    this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
	    this._effectCfg = effectCfg;
	  } else {
	    // Not keep old effect config
	    this._effectCfg = null;
	    this.stopEffectAnimation();
	    var symbol = this.childAt(0);
	
	    var onEmphasis = function () {
	      symbol.highlight();
	
	      if (effectCfg.showEffectOn !== 'render') {
	        this.startEffectAnimation(effectCfg);
	      }
	    };
	
	    var onNormal = function () {
	      symbol.downplay();
	
	      if (effectCfg.showEffectOn !== 'render') {
	        this.stopEffectAnimation();
	      }
	    };
	
	    this.on('mouseover', onEmphasis, this).on('mouseout', onNormal, this).on('emphasis', onEmphasis, this).on('normal', onNormal, this);
	  }
	
	  this._effectCfg = effectCfg;
	};
	
	effectSymbolProto.fadeOut = function (cb) {
	  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  cb && cb();
	};
	
	zrUtil.inherits(EffectSymbol, Group);
	var _default = EffectSymbol;
	module.exports = _default;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(541);
	
	__webpack_require__(542);
	
	var linesLayout = __webpack_require__(547);
	
	var linesVisual = __webpack_require__(548);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(linesLayout);
	echarts.registerVisual(linesVisual);

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var SeriesModel = __webpack_require__(320);
	
	var List = __webpack_require__(342);
	
	var _util = __webpack_require__(220);
	
	var concatArray = _util.concatArray;
	var mergeAll = _util.mergeAll;
	var map = _util.map;
	
	var _format = __webpack_require__(307);
	
	var encodeHTML = _format.encodeHTML;
	
	var CoordinateSystem = __webpack_require__(315);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint32Array, Float64Array, Float32Array */
	var Uint32Arr = typeof Uint32Array === 'undefined' ? Array : Uint32Array;
	var Float64Arr = typeof Float64Array === 'undefined' ? Array : Float64Array;
	
	function compatEc2(seriesOpt) {
	  var data = seriesOpt.data;
	
	  if (data && data[0] && data[0][0] && data[0][0].coord) {
	    seriesOpt.data = map(data, function (itemOpt) {
	      var coords = [itemOpt[0].coord, itemOpt[1].coord];
	      var target = {
	        coords: coords
	      };
	
	      if (itemOpt[0].name) {
	        target.fromName = itemOpt[0].name;
	      }
	
	      if (itemOpt[1].name) {
	        target.toName = itemOpt[1].name;
	      }
	
	      return mergeAll([target, itemOpt[0], itemOpt[1]]);
	    });
	  }
	}
	
	var LinesSeries = SeriesModel.extend({
	  type: 'series.lines',
	  dependencies: ['grid', 'polar'],
	  visualColorAccessPath: 'lineStyle.color',
	  init: function (option) {
	    // The input data may be null/undefined.
	    option.data = option.data || []; // Not using preprocessor because mergeOption may not have series.type
	
	    compatEc2(option);
	
	    var result = this._processFlatCoordsArray(option.data);
	
	    this._flatCoords = result.flatCoords;
	    this._flatCoordsOffset = result.flatCoordsOffset;
	
	    if (result.flatCoords) {
	      option.data = new Float32Array(result.count);
	    }
	
	    LinesSeries.superApply(this, 'init', arguments);
	  },
	  mergeOption: function (option) {
	    compatEc2(option);
	
	    if (option.data) {
	      // Only update when have option data to merge.
	      var result = this._processFlatCoordsArray(option.data);
	
	      this._flatCoords = result.flatCoords;
	      this._flatCoordsOffset = result.flatCoordsOffset;
	
	      if (result.flatCoords) {
	        option.data = new Float32Array(result.count);
	      }
	    }
	
	    LinesSeries.superApply(this, 'mergeOption', arguments);
	  },
	  appendData: function (params) {
	    var result = this._processFlatCoordsArray(params.data);
	
	    if (result.flatCoords) {
	      if (!this._flatCoords) {
	        this._flatCoords = result.flatCoords;
	        this._flatCoordsOffset = result.flatCoordsOffset;
	      } else {
	        this._flatCoords = concatArray(this._flatCoords, result.flatCoords);
	        this._flatCoordsOffset = concatArray(this._flatCoordsOffset, result.flatCoordsOffset);
	      }
	
	      params.data = new Float32Array(result.count);
	    }
	
	    this.getRawData().appendData(params.data);
	  },
	  _getCoordsFromItemModel: function (idx) {
	    var itemModel = this.getData().getItemModel(idx);
	    var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow('coords');
	    return coords;
	  },
	  getLineCoordsCount: function (idx) {
	    if (this._flatCoordsOffset) {
	      return this._flatCoordsOffset[idx * 2 + 1];
	    } else {
	      return this._getCoordsFromItemModel(idx).length;
	    }
	  },
	  getLineCoords: function (idx, out) {
	    if (this._flatCoordsOffset) {
	      var offset = this._flatCoordsOffset[idx * 2];
	      var len = this._flatCoordsOffset[idx * 2 + 1];
	
	      for (var i = 0; i < len; i++) {
	        out[i] = out[i] || [];
	        out[i][0] = this._flatCoords[offset + i * 2];
	        out[i][1] = this._flatCoords[offset + i * 2 + 1];
	      }
	
	      return len;
	    } else {
	      var coords = this._getCoordsFromItemModel(idx);
	
	      for (var i = 0; i < coords.length; i++) {
	        out[i] = out[i] || [];
	        out[i][0] = coords[i][0];
	        out[i][1] = coords[i][1];
	      }
	
	      return coords.length;
	    }
	  },
	  _processFlatCoordsArray: function (data) {
	    var startOffset = 0;
	
	    if (this._flatCoords) {
	      startOffset = this._flatCoords.length;
	    } // Stored as a typed array. In format
	    // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
	
	
	    if (typeof data[0] === 'number') {
	      var len = data.length; // Store offset and len of each segment
	
	      var coordsOffsetAndLenStorage = new Uint32Arr(len);
	      var coordsStorage = new Float64Arr(len);
	      var coordsCursor = 0;
	      var offsetCursor = 0;
	      var dataCount = 0;
	
	      for (var i = 0; i < len;) {
	        dataCount++;
	        var count = data[i++]; // Offset
	
	        coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset; // Len
	
	        coordsOffsetAndLenStorage[offsetCursor++] = count;
	
	        for (var k = 0; k < count; k++) {
	          var x = data[i++];
	          var y = data[i++];
	          coordsStorage[coordsCursor++] = x;
	          coordsStorage[coordsCursor++] = y;
	
	          if (i > len) {}
	        }
	      }
	
	      return {
	        flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
	        flatCoords: coordsStorage,
	        count: dataCount
	      };
	    }
	
	    return {
	      flatCoordsOffset: null,
	      flatCoords: null,
	      count: data.length
	    };
	  },
	  getInitialData: function (option, ecModel) {
	    var lineData = new List(['value'], this);
	    lineData.hasItemOption = false;
	    lineData.initData(option.data, [], function (dataItem, dimName, dataIndex, dimIndex) {
	      // dataItem is simply coords
	      if (dataItem instanceof Array) {
	        return NaN;
	      } else {
	        lineData.hasItemOption = true;
	        var value = dataItem.value;
	
	        if (value != null) {
	          return value instanceof Array ? value[dimIndex] : value;
	        }
	      }
	    });
	    return lineData;
	  },
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var itemModel = data.getItemModel(dataIndex);
	    var name = itemModel.get('name');
	
	    if (name) {
	      return name;
	    }
	
	    var fromName = itemModel.get('fromName');
	    var toName = itemModel.get('toName');
	    var html = [];
	    fromName != null && html.push(fromName);
	    toName != null && html.push(toName);
	    return encodeHTML(html.join(' > '));
	  },
	  preventIncremental: function () {
	    return !!this.get('effect.show');
	  },
	  getProgressive: function () {
	    var progressive = this.option.progressive;
	
	    if (progressive == null) {
	      return this.option.large ? 1e4 : this.get('progressive');
	    }
	
	    return progressive;
	  },
	  getProgressiveThreshold: function () {
	    var progressiveThreshold = this.option.progressiveThreshold;
	
	    if (progressiveThreshold == null) {
	      return this.option.large ? 2e4 : this.get('progressiveThreshold');
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    coordinateSystem: 'geo',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // Cartesian coordinate system
	    xAxisIndex: 0,
	    yAxisIndex: 0,
	    symbol: ['none', 'none'],
	    symbolSize: [10, 10],
	    // Geo coordinate system
	    geoIndex: 0,
	    effect: {
	      show: false,
	      period: 4,
	      // Animation delay. support callback
	      // delay: 0,
	      // If move with constant speed px/sec
	      // period will be ignored if this property is > 0,
	      constantSpeed: 0,
	      symbol: 'circle',
	      symbolSize: 3,
	      loop: true,
	      // Length of trail, 0 - 1
	      trailLength: 0.2 // Same with lineStyle.color
	      // color
	
	    },
	    large: false,
	    // Available when large is true
	    largeThreshold: 2000,
	    // If lines are polyline
	    // polyline not support curveness, label, animation
	    polyline: false,
	    // If clip the overflow.
	    // Available when coordinateSystem is cartesian or polar.
	    clip: true,
	    label: {
	      show: false,
	      position: 'end' // distance: 5,
	      // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	    },
	    lineStyle: {
	      opacity: 0.5
	    }
	  }
	});
	var _default = LinesSeries;
	module.exports = _default;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(215);
	
	var LineDraw = __webpack_require__(476);
	
	var EffectLine = __webpack_require__(543);
	
	var Line = __webpack_require__(477);
	
	var Polyline = __webpack_require__(544);
	
	var EffectPolyline = __webpack_require__(545);
	
	var LargeLineDraw = __webpack_require__(546);
	
	var linesLayout = __webpack_require__(547);
	
	var _createClipPathFromCoordSys = __webpack_require__(375);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'lines',
	  init: function () {},
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var lineDraw = this._updateLineDraw(data, seriesModel);
	
	    var zlevel = seriesModel.get('zlevel');
	    var trailLength = seriesModel.get('effect.trailLength');
	    var zr = api.getZr(); // Avoid the drag cause ghost shadow
	    // FIXME Better way ?
	    // SVG doesn't support
	
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg) {
	      zr.painter.getLayer(zlevel).clear(true);
	    } // Config layer with motion blur
	
	
	    if (this._lastZlevel != null && !isSvg) {
	      zr.configLayer(this._lastZlevel, {
	        motionBlur: false
	      });
	    }
	
	    if (this._showEffect(seriesModel) && trailLength) {
	      if (!isSvg) {
	        zr.configLayer(zlevel, {
	          motionBlur: true,
	          lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
	        });
	      }
	    }
	
	    lineDraw.updateData(data);
	    var clipPath = seriesModel.get('clip', true) && createClipPath(seriesModel.coordinateSystem, false, seriesModel);
	
	    if (clipPath) {
	      this.group.setClipPath(clipPath);
	    } else {
	      this.group.removeClipPath();
	    }
	
	    this._lastZlevel = zlevel;
	    this._finished = true;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var lineDraw = this._updateLineDraw(data, seriesModel);
	
	    lineDraw.incrementalPrepareUpdate(data);
	
	    this._clearLayer(api);
	
	    this._finished = false;
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
	
	    this._finished = taskParams.end === seriesModel.getData().count();
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var pipelineContext = seriesModel.pipelineContext;
	
	    if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) {
	      // TODO Don't have to do update in large mode. Only do it when there are millions of data.
	      return {
	        update: true
	      };
	    } else {
	      // TODO Use same logic with ScatterView.
	      // Manually update layout
	      var res = linesLayout.reset(seriesModel);
	
	      if (res.progress) {
	        res.progress({
	          start: 0,
	          end: data.count()
	        }, data);
	      }
	
	      this._lineDraw.updateLayout();
	
	      this._clearLayer(api);
	    }
	  },
	  _updateLineDraw: function (data, seriesModel) {
	    var lineDraw = this._lineDraw;
	
	    var hasEffect = this._showEffect(seriesModel);
	
	    var isPolyline = !!seriesModel.get('polyline');
	    var pipelineContext = seriesModel.pipelineContext;
	    var isLargeDraw = pipelineContext.large;
	
	    if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
	      if (lineDraw) {
	        lineDraw.remove();
	      }
	
	      lineDraw = this._lineDraw = isLargeDraw ? new LargeLineDraw() : new LineDraw(isPolyline ? hasEffect ? EffectPolyline : Polyline : hasEffect ? EffectLine : Line);
	      this._hasEffet = hasEffect;
	      this._isPolyline = isPolyline;
	      this._isLargeDraw = isLargeDraw;
	      this.group.removeAll();
	    }
	
	    this.group.add(lineDraw.group);
	    return lineDraw;
	  },
	  _showEffect: function (seriesModel) {
	    return !!seriesModel.get('effect.show');
	  },
	  _clearLayer: function (api) {
	    // Not use motion when dragging or zooming
	    var zr = api.getZr();
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg && this._lastZlevel != null) {
	      zr.painter.getLayer(this._lastZlevel).clear(true);
	    }
	  },
	  remove: function (ecModel, api) {
	    this._lineDraw && this._lineDraw.remove();
	    this._lineDraw = null; // Clear motion when lineDraw is removed
	
	    this._clearLayer(api);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var Line = __webpack_require__(477);
	
	var zrUtil = __webpack_require__(220);
	
	var _symbol = __webpack_require__(360);
	
	var createSymbol = _symbol.createSymbol;
	
	var vec2 = __webpack_require__(222);
	
	var curveUtil = __webpack_require__(272);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Provide effect for line
	 * @module echarts/chart/helper/EffectLine
	 */
	
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Line}
	 */
	function EffectLine(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	  this.add(this.createLine(lineData, idx, seriesScope));
	
	  this._updateEffectSymbol(lineData, idx);
	}
	
	var effectLineProto = EffectLine.prototype;
	
	effectLineProto.createLine = function (lineData, idx, seriesScope) {
	  return new Line(lineData, idx, seriesScope);
	};
	
	effectLineProto._updateEffectSymbol = function (lineData, idx) {
	  var itemModel = lineData.getItemModel(idx);
	  var effectModel = itemModel.getModel('effect');
	  var size = effectModel.get('symbolSize');
	  var symbolType = effectModel.get('symbol');
	
	  if (!zrUtil.isArray(size)) {
	    size = [size, size];
	  }
	
	  var color = effectModel.get('color') || lineData.getItemVisual(idx, 'color');
	  var symbol = this.childAt(1);
	
	  if (this._symbolType !== symbolType) {
	    // Remove previous
	    this.remove(symbol);
	    symbol = createSymbol(symbolType, -0.5, -0.5, 1, 1, color);
	    symbol.z2 = 100;
	    symbol.culling = true;
	    this.add(symbol);
	  } // Symbol may be removed if loop is false
	
	
	  if (!symbol) {
	    return;
	  } // Shadow color is same with color in default
	
	
	  symbol.setStyle('shadowColor', color);
	  symbol.setStyle(effectModel.getItemStyle(['color']));
	  symbol.attr('scale', size);
	  symbol.setColor(color);
	  symbol.attr('scale', size);
	  this._symbolType = symbolType;
	  this._symbolScale = size;
	
	  this._updateEffectAnimation(lineData, effectModel, idx);
	};
	
	effectLineProto._updateEffectAnimation = function (lineData, effectModel, idx) {
	  var symbol = this.childAt(1);
	
	  if (!symbol) {
	    return;
	  }
	
	  var self = this;
	  var points = lineData.getItemLayout(idx);
	  var period = effectModel.get('period') * 1000;
	  var loop = effectModel.get('loop');
	  var constantSpeed = effectModel.get('constantSpeed');
	  var delayExpr = zrUtil.retrieve(effectModel.get('delay'), function (idx) {
	    return idx / lineData.count() * period / 3;
	  });
	  var isDelayFunc = typeof delayExpr === 'function'; // Ignore when updating
	
	  symbol.ignore = true;
	  this.updateAnimationPoints(symbol, points);
	
	  if (constantSpeed > 0) {
	    period = this.getLineLength(symbol) / constantSpeed * 1000;
	  }
	
	  if (period !== this._period || loop !== this._loop) {
	    symbol.stopAnimation();
	    var delay = delayExpr;
	
	    if (isDelayFunc) {
	      delay = delayExpr(idx);
	    }
	
	    if (symbol.__t > 0) {
	      delay = -period * symbol.__t;
	    }
	
	    symbol.__t = 0;
	    var animator = symbol.animate('', loop).when(period, {
	      __t: 1
	    }).delay(delay).during(function () {
	      self.updateSymbolPosition(symbol);
	    });
	
	    if (!loop) {
	      animator.done(function () {
	        self.remove(symbol);
	      });
	    }
	
	    animator.start();
	  }
	
	  this._period = period;
	  this._loop = loop;
	};
	
	effectLineProto.getLineLength = function (symbol) {
	  // Not so accurate
	  return vec2.dist(symbol.__p1, symbol.__cp1) + vec2.dist(symbol.__cp1, symbol.__p2);
	};
	
	effectLineProto.updateAnimationPoints = function (symbol, points) {
	  symbol.__p1 = points[0];
	  symbol.__p2 = points[1];
	  symbol.__cp1 = points[2] || [(points[0][0] + points[1][0]) / 2, (points[0][1] + points[1][1]) / 2];
	};
	
	effectLineProto.updateData = function (lineData, idx, seriesScope) {
	  this.childAt(0).updateData(lineData, idx, seriesScope);
	
	  this._updateEffectSymbol(lineData, idx);
	};
	
	effectLineProto.updateSymbolPosition = function (symbol) {
	  var p1 = symbol.__p1;
	  var p2 = symbol.__p2;
	  var cp1 = symbol.__cp1;
	  var t = symbol.__t;
	  var pos = symbol.position;
	  var lastPos = [pos[0], pos[1]];
	  var quadraticAt = curveUtil.quadraticAt;
	  var quadraticDerivativeAt = curveUtil.quadraticDerivativeAt;
	  pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
	  pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t); // Tangent
	
	  var tx = quadraticDerivativeAt(p1[0], cp1[0], p2[0], t);
	  var ty = quadraticDerivativeAt(p1[1], cp1[1], p2[1], t);
	  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2; // enable continuity trail for 'line', 'rect', 'roundRect' symbolType
	
	  if (this._symbolType === 'line' || this._symbolType === 'rect' || this._symbolType === 'roundRect') {
	    if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
	      var scaleY = vec2.dist(lastPos, pos) * 1.05;
	      symbol.attr('scale', [symbol.scale[0], scaleY]); // make sure the last segment render within endPoint
	
	      if (t === 1) {
	        pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
	        pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
	      }
	    } else if (symbol.__lastT === 1) {
	      // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
	      var scaleY = 2 * vec2.dist(p1, pos);
	      symbol.attr('scale', [symbol.scale[0], scaleY]);
	    } else {
	      symbol.attr('scale', this._symbolScale);
	    }
	  }
	
	  symbol.__lastT = symbol.__t;
	  symbol.ignore = false;
	};
	
	effectLineProto.updateLayout = function (lineData, idx) {
	  this.childAt(0).updateLayout(lineData, idx);
	  var effectModel = lineData.getItemModel(idx).getModel('effect');
	
	  this._updateEffectAnimation(lineData, effectModel, idx);
	};
	
	zrUtil.inherits(EffectLine, graphic.Group);
	var _default = EffectLine;
	module.exports = _default;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Line
	 */
	
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Polyline}
	 */
	function Polyline(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	
	  this._createPolyline(lineData, idx, seriesScope);
	}
	
	var polylineProto = Polyline.prototype;
	
	polylineProto._createPolyline = function (lineData, idx, seriesScope) {
	  // var seriesModel = lineData.hostModel;
	  var points = lineData.getItemLayout(idx);
	  var line = new graphic.Polyline({
	    shape: {
	      points: points
	    }
	  });
	  this.add(line);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	polylineProto.updateData = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childAt(0);
	  var target = {
	    shape: {
	      points: lineData.getItemLayout(idx)
	    }
	  };
	  graphic.updateProps(line, target, seriesModel, idx);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	polylineProto._updateCommonStl = function (lineData, idx, seriesScope) {
	  var line = this.childAt(0);
	  var itemModel = lineData.getItemModel(idx);
	  var visualColor = lineData.getItemVisual(idx, 'color');
	  var lineStyle = seriesScope && seriesScope.lineStyle;
	  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
	
	  if (!seriesScope || lineData.hasItemOption) {
	    lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	    hoverLineStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	  }
	
	  line.useStyle(zrUtil.defaults({
	    strokeNoScale: true,
	    fill: 'none',
	    stroke: visualColor
	  }, lineStyle));
	  line.hoverStyle = hoverLineStyle;
	  graphic.setHoverStyle(this);
	};
	
	polylineProto.updateLayout = function (lineData, idx) {
	  var polyline = this.childAt(0);
	  polyline.setShape('points', lineData.getItemLayout(idx));
	};
	
	zrUtil.inherits(Polyline, graphic.Group);
	var _default = Polyline;
	module.exports = _default;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Polyline = __webpack_require__(544);
	
	var zrUtil = __webpack_require__(220);
	
	var EffectLine = __webpack_require__(543);
	
	var vec2 = __webpack_require__(222);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Provide effect for line
	 * @module echarts/chart/helper/EffectLine
	 */
	
	/**
	 * @constructor
	 * @extends {module:echarts/chart/helper/EffectLine}
	 * @alias {module:echarts/chart/helper/Polyline}
	 */
	function EffectPolyline(lineData, idx, seriesScope) {
	  EffectLine.call(this, lineData, idx, seriesScope);
	  this._lastFrame = 0;
	  this._lastFramePercent = 0;
	}
	
	var effectPolylineProto = EffectPolyline.prototype; // Overwrite
	
	effectPolylineProto.createLine = function (lineData, idx, seriesScope) {
	  return new Polyline(lineData, idx, seriesScope);
	}; // Overwrite
	
	
	effectPolylineProto.updateAnimationPoints = function (symbol, points) {
	  this._points = points;
	  var accLenArr = [0];
	  var len = 0;
	
	  for (var i = 1; i < points.length; i++) {
	    var p1 = points[i - 1];
	    var p2 = points[i];
	    len += vec2.dist(p1, p2);
	    accLenArr.push(len);
	  }
	
	  if (len === 0) {
	    return;
	  }
	
	  for (var i = 0; i < accLenArr.length; i++) {
	    accLenArr[i] /= len;
	  }
	
	  this._offsets = accLenArr;
	  this._length = len;
	}; // Overwrite
	
	
	effectPolylineProto.getLineLength = function (symbol) {
	  return this._length;
	}; // Overwrite
	
	
	effectPolylineProto.updateSymbolPosition = function (symbol) {
	  var t = symbol.__t;
	  var points = this._points;
	  var offsets = this._offsets;
	  var len = points.length;
	
	  if (!offsets) {
	    // Has length 0
	    return;
	  }
	
	  var lastFrame = this._lastFrame;
	  var frame;
	
	  if (t < this._lastFramePercent) {
	    // Start from the next frame
	    // PENDING start from lastFrame ?
	    var start = Math.min(lastFrame + 1, len - 1);
	
	    for (frame = start; frame >= 0; frame--) {
	      if (offsets[frame] <= t) {
	        break;
	      }
	    } // PENDING really need to do this ?
	
	
	    frame = Math.min(frame, len - 2);
	  } else {
	    for (var frame = lastFrame; frame < len; frame++) {
	      if (offsets[frame] > t) {
	        break;
	      }
	    }
	
	    frame = Math.min(frame - 1, len - 2);
	  }
	
	  vec2.lerp(symbol.position, points[frame], points[frame + 1], (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]));
	  var tx = points[frame + 1][0] - points[frame][0];
	  var ty = points[frame + 1][1] - points[frame][1];
	  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
	  this._lastFrame = frame;
	  this._lastFramePercent = t;
	  symbol.ignore = false;
	};
	
	zrUtil.inherits(EffectPolyline, EffectLine);
	var _default = EffectPolyline;
	module.exports = _default;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(268);
	
	var IncrementalDisplayable = __webpack_require__(301);
	
	var lineContain = __webpack_require__(275);
	
	var quadraticContain = __webpack_require__(277);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Batch by color
	var LargeLineShape = graphic.extendShape({
	  shape: {
	    polyline: false,
	    curveness: 0,
	    segs: []
	  },
	  buildPath: function (path, shape) {
	    var segs = shape.segs;
	    var curveness = shape.curveness;
	
	    if (shape.polyline) {
	      for (var i = 0; i < segs.length;) {
	        var count = segs[i++];
	
	        if (count > 0) {
	          path.moveTo(segs[i++], segs[i++]);
	
	          for (var k = 1; k < count; k++) {
	            path.lineTo(segs[i++], segs[i++]);
	          }
	        }
	      }
	    } else {
	      for (var i = 0; i < segs.length;) {
	        var x0 = segs[i++];
	        var y0 = segs[i++];
	        var x1 = segs[i++];
	        var y1 = segs[i++];
	        path.moveTo(x0, y0);
	
	        if (curveness > 0) {
	          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
	          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
	          path.quadraticCurveTo(x2, y2, x1, y1);
	        } else {
	          path.lineTo(x1, y1);
	        }
	      }
	    }
	  },
	  findDataIndex: function (x, y) {
	    var shape = this.shape;
	    var segs = shape.segs;
	    var curveness = shape.curveness;
	
	    if (shape.polyline) {
	      var dataIndex = 0;
	
	      for (var i = 0; i < segs.length;) {
	        var count = segs[i++];
	
	        if (count > 0) {
	          var x0 = segs[i++];
	          var y0 = segs[i++];
	
	          for (var k = 1; k < count; k++) {
	            var x1 = segs[i++];
	            var y1 = segs[i++];
	
	            if (lineContain.containStroke(x0, y0, x1, y1)) {
	              return dataIndex;
	            }
	          }
	        }
	
	        dataIndex++;
	      }
	    } else {
	      var dataIndex = 0;
	
	      for (var i = 0; i < segs.length;) {
	        var x0 = segs[i++];
	        var y0 = segs[i++];
	        var x1 = segs[i++];
	        var y1 = segs[i++];
	
	        if (curveness > 0) {
	          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
	          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
	
	          if (quadraticContain.containStroke(x0, y0, x2, y2, x1, y1)) {
	            return dataIndex;
	          }
	        } else {
	          if (lineContain.containStroke(x0, y0, x1, y1)) {
	            return dataIndex;
	          }
	        }
	
	        dataIndex++;
	      }
	    }
	
	    return -1;
	  }
	});
	
	function LargeLineDraw() {
	  this.group = new graphic.Group();
	}
	
	var largeLineProto = LargeLineDraw.prototype;
	
	largeLineProto.isPersistent = function () {
	  return !this._incremental;
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 */
	
	
	largeLineProto.updateData = function (data) {
	  this.group.removeAll();
	  var lineEl = new LargeLineShape({
	    rectHover: true,
	    cursor: 'default'
	  });
	  lineEl.setShape({
	    segs: data.getLayout('linesPoints')
	  });
	
	  this._setCommon(lineEl, data); // Add back
	
	
	  this.group.add(lineEl);
	  this._incremental = null;
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.incrementalPrepareUpdate = function (data) {
	  this.group.removeAll();
	
	  this._clearIncremental();
	
	  if (data.count() > 5e5) {
	    if (!this._incremental) {
	      this._incremental = new IncrementalDisplayable({
	        silent: true
	      });
	    }
	
	    this.group.add(this._incremental);
	  } else {
	    this._incremental = null;
	  }
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.incrementalUpdate = function (taskParams, data) {
	  var lineEl = new LargeLineShape();
	  lineEl.setShape({
	    segs: data.getLayout('linesPoints')
	  });
	
	  this._setCommon(lineEl, data, !!this._incremental);
	
	  if (!this._incremental) {
	    lineEl.rectHover = true;
	    lineEl.cursor = 'default';
	    lineEl.__startIndex = taskParams.start;
	    this.group.add(lineEl);
	  } else {
	    this._incremental.addDisplayable(lineEl, true);
	  }
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	largeLineProto._setCommon = function (lineEl, data, isIncremental) {
	  var hostModel = data.hostModel;
	  lineEl.setShape({
	    polyline: hostModel.get('polyline'),
	    curveness: hostModel.get('lineStyle.curveness')
	  });
	  lineEl.useStyle(hostModel.getModel('lineStyle').getLineStyle());
	  lineEl.style.strokeNoScale = true;
	  var visualColor = data.getVisual('color');
	
	  if (visualColor) {
	    lineEl.setStyle('stroke', visualColor);
	  }
	
	  lineEl.setStyle('fill');
	
	  if (!isIncremental) {
	    // Enable tooltip
	    // PENDING May have performance issue when path is extremely large
	    lineEl.seriesIndex = hostModel.seriesIndex;
	    lineEl.on('mousemove', function (e) {
	      lineEl.dataIndex = null;
	      var dataIndex = lineEl.findDataIndex(e.offsetX, e.offsetY);
	
	      if (dataIndex > 0) {
	        // Provide dataIndex for tooltip
	        lineEl.dataIndex = dataIndex + lineEl.__startIndex;
	      }
	    });
	  }
	};
	
	largeLineProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	var _default = LargeLineDraw;
	module.exports = _default;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createRenderPlanner = __webpack_require__(326);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var _default = {
	  seriesType: 'lines',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var isPolyline = seriesModel.get('polyline');
	    var isLarge = seriesModel.pipelineContext.large;
	
	    function progress(params, lineData) {
	      var lineCoords = [];
	
	      if (isLarge) {
	        var points;
	        var segCount = params.end - params.start;
	
	        if (isPolyline) {
	          var totalCoordsCount = 0;
	
	          for (var i = params.start; i < params.end; i++) {
	            totalCoordsCount += seriesModel.getLineCoordsCount(i);
	          }
	
	          points = new Float32Array(segCount + totalCoordsCount * 2);
	        } else {
	          points = new Float32Array(segCount * 4);
	        }
	
	        var offset = 0;
	        var pt = [];
	
	        for (var i = params.start; i < params.end; i++) {
	          var len = seriesModel.getLineCoords(i, lineCoords);
	
	          if (isPolyline) {
	            points[offset++] = len;
	          }
	
	          for (var k = 0; k < len; k++) {
	            pt = coordSys.dataToPoint(lineCoords[k], false, pt);
	            points[offset++] = pt[0];
	            points[offset++] = pt[1];
	          }
	        }
	
	        lineData.setLayout('linesPoints', points);
	      } else {
	        for (var i = params.start; i < params.end; i++) {
	          var itemModel = lineData.getItemModel(i);
	          var len = seriesModel.getLineCoords(i, lineCoords);
	          var pts = [];
	
	          if (isPolyline) {
	            for (var j = 0; j < len; j++) {
	              pts.push(coordSys.dataToPoint(lineCoords[j]));
	            }
	          } else {
	            pts[0] = coordSys.dataToPoint(lineCoords[0]);
	            pts[1] = coordSys.dataToPoint(lineCoords[1]);
	            var curveness = itemModel.get('lineStyle.curveness');
	
	            if (+curveness) {
	              pts[2] = [(pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness, (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness];
	            }
	          }
	
	          lineData.setItemLayout(i, pts);
	        }
	      }
	    }
	
	    return {
	      progress: progress
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalize(a) {
	  if (!(a instanceof Array)) {
	    a = [a, a];
	  }
	
	  return a;
	}
	
	var opacityQuery = 'lineStyle.opacity'.split('.');
	var _default = {
	  seriesType: 'lines',
	  reset: function (seriesModel, ecModel, api) {
	    var symbolType = normalize(seriesModel.get('symbol'));
	    var symbolSize = normalize(seriesModel.get('symbolSize'));
	    var data = seriesModel.getData();
	    data.setVisual('fromSymbol', symbolType && symbolType[0]);
	    data.setVisual('toSymbol', symbolType && symbolType[1]);
	    data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	    data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	    data.setVisual('opacity', seriesModel.get(opacityQuery));
	
	    function dataEach(data, idx) {
	      var itemModel = data.getItemModel(idx);
	      var symbolType = normalize(itemModel.getShallow('symbol', true));
	      var symbolSize = normalize(itemModel.getShallow('symbolSize', true));
	      var opacity = itemModel.get(opacityQuery);
	      symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
	      symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
	      symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
	      symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
	      data.setItemVisual(idx, 'opacity', opacity);
	    }
	
	    return {
	      dataEach: data.hasItemOption ? dataEach : null
	    };
	  }
	};
	module.exports = _default;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(550);
	
	__webpack_require__(551);

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(320);
	
	var createListFromArray = __webpack_require__(341);
	
	var CoordinateSystem = __webpack_require__(315);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.heatmap',
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      generateCoord: 'value'
	    });
	  },
	  preventIncremental: function () {
	    var coordSysCreator = CoordinateSystem.get(this.get('coordinateSystem'));
	
	    if (coordSysCreator && coordSysCreator.dimensions) {
	      return coordSysCreator.dimensions[0] === 'lng' && coordSysCreator.dimensions[1] === 'lat';
	    }
	  },
	  defaultOption: {
	    // Cartesian2D or geo
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Geo coordinate system
	    geoIndex: 0,
	    blurSize: 30,
	    pointSize: 20,
	    maxOpacity: 1,
	    minOpacity: 0
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(215);
	
	var graphic = __webpack_require__(268);
	
	var HeatmapLayer = __webpack_require__(552);
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getIsInPiecewiseRange(dataExtent, pieceList, selected) {
	  var dataSpan = dataExtent[1] - dataExtent[0];
	  pieceList = zrUtil.map(pieceList, function (piece) {
	    return {
	      interval: [(piece.interval[0] - dataExtent[0]) / dataSpan, (piece.interval[1] - dataExtent[0]) / dataSpan]
	    };
	  });
	  var len = pieceList.length;
	  var lastIndex = 0;
	  return function (val) {
	    // Try to find in the location of the last found
	    for (var i = lastIndex; i < len; i++) {
	      var interval = pieceList[i].interval;
	
	      if (interval[0] <= val && val <= interval[1]) {
	        lastIndex = i;
	        break;
	      }
	    }
	
	    if (i === len) {
	      // Not found, back interation
	      for (var i = lastIndex - 1; i >= 0; i--) {
	        var interval = pieceList[i].interval;
	
	        if (interval[0] <= val && val <= interval[1]) {
	          lastIndex = i;
	          break;
	        }
	      }
	    }
	
	    return i >= 0 && i < len && selected[i];
	  };
	}
	
	function getIsInContinuousRange(dataExtent, range) {
	  var dataSpan = dataExtent[1] - dataExtent[0];
	  range = [(range[0] - dataExtent[0]) / dataSpan, (range[1] - dataExtent[0]) / dataSpan];
	  return function (val) {
	    return val >= range[0] && val <= range[1];
	  };
	}
	
	function isGeoCoordSys(coordSys) {
	  var dimensions = coordSys.dimensions; // Not use coorSys.type === 'geo' because coordSys maybe extended
	
	  return dimensions[0] === 'lng' && dimensions[1] === 'lat';
	}
	
	var _default = echarts.extendChartView({
	  type: 'heatmap',
	  render: function (seriesModel, ecModel, api) {
	    var visualMapOfThisSeries;
	    ecModel.eachComponent('visualMap', function (visualMap) {
	      visualMap.eachTargetSeries(function (targetSeries) {
	        if (targetSeries === seriesModel) {
	          visualMapOfThisSeries = visualMap;
	        }
	      });
	    });
	    this.group.removeAll();
	    this._incrementalDisplayable = null;
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') {
	      this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
	    } else if (isGeoCoordSys(coordSys)) {
	      this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
	    }
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this.group.removeAll();
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys) {
	      this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
	    }
	  },
	  _renderOnCartesianAndCalendar: function (seriesModel, api, start, end, incremental) {
	    var coordSys = seriesModel.coordinateSystem;
	    var width;
	    var height;
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      width = xAxis.getBandWidth();
	      height = yAxis.getBandWidth();
	    }
	
	    var group = this.group;
	    var data = seriesModel.getData();
	    var itemStyleQuery = 'itemStyle';
	    var hoverItemStyleQuery = 'emphasis.itemStyle';
	    var labelQuery = 'label';
	    var hoverLabelQuery = 'emphasis.label';
	    var style = seriesModel.getModel(itemStyleQuery).getItemStyle(['color']);
	    var hoverStl = seriesModel.getModel(hoverItemStyleQuery).getItemStyle();
	    var labelModel = seriesModel.getModel(labelQuery);
	    var hoverLabelModel = seriesModel.getModel(hoverLabelQuery);
	    var coordSysType = coordSys.type;
	    var dataDims = coordSysType === 'cartesian2d' ? [data.mapDimension('x'), data.mapDimension('y'), data.mapDimension('value')] : [data.mapDimension('time'), data.mapDimension('value')];
	
	    for (var idx = start; idx < end; idx++) {
	      var rect;
	
	      if (coordSysType === 'cartesian2d') {
	        // Ignore empty data
	        if (isNaN(data.get(dataDims[2], idx))) {
	          continue;
	        }
	
	        var point = coordSys.dataToPoint([data.get(dataDims[0], idx), data.get(dataDims[1], idx)]);
	        rect = new graphic.Rect({
	          shape: {
	            x: Math.floor(Math.round(point[0]) - width / 2),
	            y: Math.floor(Math.round(point[1]) - height / 2),
	            width: Math.ceil(width),
	            height: Math.ceil(height)
	          },
	          style: {
	            fill: data.getItemVisual(idx, 'color'),
	            opacity: data.getItemVisual(idx, 'opacity')
	          }
	        });
	      } else {
	        // Ignore empty data
	        if (isNaN(data.get(dataDims[1], idx))) {
	          continue;
	        }
	
	        rect = new graphic.Rect({
	          z2: 1,
	          shape: coordSys.dataToRect([data.get(dataDims[0], idx)]).contentShape,
	          style: {
	            fill: data.getItemVisual(idx, 'color'),
	            opacity: data.getItemVisual(idx, 'opacity')
	          }
	        });
	      }
	
	      var itemModel = data.getItemModel(idx); // Optimization for large datset
	
	      if (data.hasItemOption) {
	        style = itemModel.getModel(itemStyleQuery).getItemStyle(['color']);
	        hoverStl = itemModel.getModel(hoverItemStyleQuery).getItemStyle();
	        labelModel = itemModel.getModel(labelQuery);
	        hoverLabelModel = itemModel.getModel(hoverLabelQuery);
	      }
	
	      var rawValue = seriesModel.getRawValue(idx);
	      var defaultText = '-';
	
	      if (rawValue && rawValue[2] != null) {
	        defaultText = rawValue[2];
	      }
	
	      graphic.setLabelStyle(style, hoverStl, labelModel, hoverLabelModel, {
	        labelFetcher: seriesModel,
	        labelDataIndex: idx,
	        defaultText: defaultText,
	        isRectText: true
	      });
	      rect.setStyle(style);
	      graphic.setHoverStyle(rect, data.hasItemOption ? hoverStl : zrUtil.extend({}, hoverStl));
	      rect.incremental = incremental; // PENDING
	
	      if (incremental) {
	        // Rect must use hover layer if it's incremental.
	        rect.useHoverLayer = true;
	      }
	
	      group.add(rect);
	      data.setItemGraphicEl(idx, rect);
	    }
	  },
	  _renderOnGeo: function (geo, seriesModel, visualMapModel, api) {
	    var inRangeVisuals = visualMapModel.targetVisuals.inRange;
	    var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange; // if (!visualMapping) {
	    //     throw new Error('Data range must have color visuals');
	    // }
	
	    var data = seriesModel.getData();
	    var hmLayer = this._hmLayer || this._hmLayer || new HeatmapLayer();
	    hmLayer.blurSize = seriesModel.get('blurSize');
	    hmLayer.pointSize = seriesModel.get('pointSize');
	    hmLayer.minOpacity = seriesModel.get('minOpacity');
	    hmLayer.maxOpacity = seriesModel.get('maxOpacity');
	    var rect = geo.getViewRect().clone();
	    var roamTransform = geo.getRoamTransform();
	    rect.applyTransform(roamTransform); // Clamp on viewport
	
	    var x = Math.max(rect.x, 0);
	    var y = Math.max(rect.y, 0);
	    var x2 = Math.min(rect.width + rect.x, api.getWidth());
	    var y2 = Math.min(rect.height + rect.y, api.getHeight());
	    var width = x2 - x;
	    var height = y2 - y;
	    var dims = [data.mapDimension('lng'), data.mapDimension('lat'), data.mapDimension('value')];
	    var points = data.mapArray(dims, function (lng, lat, value) {
	      var pt = geo.dataToPoint([lng, lat]);
	      pt[0] -= x;
	      pt[1] -= y;
	      pt.push(value);
	      return pt;
	    });
	    var dataExtent = visualMapModel.getExtent();
	    var isInRange = visualMapModel.type === 'visualMap.continuous' ? getIsInContinuousRange(dataExtent, visualMapModel.option.range) : getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
	    hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
	      inRange: inRangeVisuals.color.getColorMapper(),
	      outOfRange: outOfRangeVisuals.color.getColorMapper()
	    }, isInRange);
	    var img = new graphic.Image({
	      style: {
	        width: width,
	        height: height,
	        x: x,
	        y: y,
	        image: hmLayer.canvas
	      },
	      silent: true
	    });
	    this.group.add(img);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint8ClampedArray */
	var GRADIENT_LEVELS = 256;
	/**
	 * Heatmap Chart
	 *
	 * @class
	 */
	
	function Heatmap() {
	  var canvas = zrUtil.createCanvas();
	  this.canvas = canvas;
	  this.blurSize = 30;
	  this.pointSize = 20;
	  this.maxOpacity = 1;
	  this.minOpacity = 0;
	  this._gradientPixels = {};
	}
	
	Heatmap.prototype = {
	  /**
	   * Renders Heatmap and returns the rendered canvas
	   * @param {Array} data array of data, each has x, y, value
	   * @param {number} width canvas width
	   * @param {number} height canvas height
	   */
	  update: function (data, width, height, normalize, colorFunc, isInRange) {
	    var brush = this._getBrush();
	
	    var gradientInRange = this._getGradient(data, colorFunc, 'inRange');
	
	    var gradientOutOfRange = this._getGradient(data, colorFunc, 'outOfRange');
	
	    var r = this.pointSize + this.blurSize;
	    var canvas = this.canvas;
	    var ctx = canvas.getContext('2d');
	    var len = data.length;
	    canvas.width = width;
	    canvas.height = height;
	
	    for (var i = 0; i < len; ++i) {
	      var p = data[i];
	      var x = p[0];
	      var y = p[1];
	      var value = p[2]; // calculate alpha using value
	
	      var alpha = normalize(value); // draw with the circle brush with alpha
	
	      ctx.globalAlpha = alpha;
	      ctx.drawImage(brush, x - r, y - r);
	    }
	
	    if (!canvas.width || !canvas.height) {
	      // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
	      // 'CanvasRenderingContext2D': The source height is 0."
	      return canvas;
	    } // colorize the canvas using alpha value and set with gradient
	
	
	    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	    var pixels = imageData.data;
	    var offset = 0;
	    var pixelLen = pixels.length;
	    var minOpacity = this.minOpacity;
	    var maxOpacity = this.maxOpacity;
	    var diffOpacity = maxOpacity - minOpacity;
	
	    while (offset < pixelLen) {
	      var alpha = pixels[offset + 3] / 256;
	      var gradientOffset = Math.floor(alpha * (GRADIENT_LEVELS - 1)) * 4; // Simple optimize to ignore the empty data
	
	      if (alpha > 0) {
	        var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange; // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
	
	        alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
	        pixels[offset++] = gradient[gradientOffset];
	        pixels[offset++] = gradient[gradientOffset + 1];
	        pixels[offset++] = gradient[gradientOffset + 2];
	        pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
	      } else {
	        offset += 4;
	      }
	    }
	
	    ctx.putImageData(imageData, 0, 0);
	    return canvas;
	  },
	
	  /**
	   * get canvas of a black circle brush used for canvas to draw later
	   * @private
	   * @returns {Object} circle brush canvas
	   */
	  _getBrush: function () {
	    var brushCanvas = this._brushCanvas || (this._brushCanvas = zrUtil.createCanvas()); // set brush size
	
	    var r = this.pointSize + this.blurSize;
	    var d = r * 2;
	    brushCanvas.width = d;
	    brushCanvas.height = d;
	    var ctx = brushCanvas.getContext('2d');
	    ctx.clearRect(0, 0, d, d); // in order to render shadow without the distinct circle,
	    // draw the distinct circle in an invisible place,
	    // and use shadowOffset to draw shadow in the center of the canvas
	
	    ctx.shadowOffsetX = d;
	    ctx.shadowBlur = this.blurSize; // draw the shadow in black, and use alpha and shadow blur to generate
	    // color in color map
	
	    ctx.shadowColor = '#000'; // draw circle in the left to the canvas
	
	    ctx.beginPath();
	    ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
	    ctx.closePath();
	    ctx.fill();
	    return brushCanvas;
	  },
	
	  /**
	   * get gradient color map
	   * @private
	   */
	  _getGradient: function (data, colorFunc, state) {
	    var gradientPixels = this._gradientPixels;
	    var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(256 * 4));
	    var color = [0, 0, 0, 0];
	    var off = 0;
	
	    for (var i = 0; i < 256; i++) {
	      colorFunc[state](i / 255, true, color);
	      pixelsSingleState[off++] = color[0];
	      pixelsSingleState[off++] = color[1];
	      pixelsSingleState[off++] = color[2];
	      pixelsSingleState[off++] = color[3];
	    }
	
	    return pixelsSingleState;
	  }
	};
	var _default = Heatmap;
	module.exports = _default;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	__webpack_require__(380);
	
	__webpack_require__(554);
	
	__webpack_require__(555);
	
	var _barGrid = __webpack_require__(356);
	
	var layout = _barGrid.layout;
	
	var visualSymbol = __webpack_require__(376);
	
	__webpack_require__(379);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerLayout(zrUtil.curry(layout, 'pictorialBar'));
	echarts.registerVisual(visualSymbol('pictorialBar', 'roundRect'));

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseBarSeries = __webpack_require__(397);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PictorialBarSeries = BaseBarSeries.extend({
	  type: 'series.pictorialBar',
	  dependencies: ['grid'],
	  defaultOption: {
	    symbol: 'circle',
	    // Customized bar shape
	    symbolSize: null,
	    // Can be ['100%', '100%'], null means auto.
	    symbolRotate: null,
	    symbolPosition: null,
	    // 'start' or 'end' or 'center', null means auto.
	    symbolOffset: null,
	    symbolMargin: null,
	    // start margin and end margin. Can be a number or a percent string.
	    // Auto margin by default.
	    symbolRepeat: false,
	    // false/null/undefined, means no repeat.
	    // Can be true, means auto calculate repeat times and cut by data.
	    // Can be a number, specifies repeat times, and do not cut by data.
	    // Can be 'fixed', means auto calculate repeat times but do not cut by data.
	    symbolRepeatDirection: 'end',
	    // 'end' means from 'start' to 'end'.
	    symbolClip: false,
	    symbolBoundingData: null,
	    // Can be 60 or -40 or [-40, 60]
	    symbolPatternSize: 400,
	    // 400 * 400 px
	    barGap: '-100%',
	    // In most case, overlap is needed.
	    // z can be set in data item, which is z2 actually.
	    // Disable progressive
	    progressive: 0,
	    hoverAnimation: false // Open only when needed.
	
	  },
	  getInitialData: function (option) {
	    // Disable stack.
	    option.stack = null;
	    return PictorialBarSeries.superApply(this, 'getInitialData', arguments);
	  }
	});
	var _default = PictorialBarSeries;
	module.exports = _default;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var _symbol = __webpack_require__(360);
	
	var createSymbol = _symbol.createSymbol;
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	var isNumeric = _number.isNumeric;
	
	var _helper = __webpack_require__(399);
	
	var setLabel = _helper.setLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'borderWidth']; // index: +isHorizontal
	
	var LAYOUT_ATTRS = [{
	  xy: 'x',
	  wh: 'width',
	  index: 0,
	  posDesc: ['left', 'right']
	}, {
	  xy: 'y',
	  wh: 'height',
	  index: 1,
	  posDesc: ['top', 'bottom']
	}];
	var pathForLineWidth = new graphic.Circle();
	var BarView = echarts.extendChartView({
	  type: 'pictorialBar',
	  render: function (seriesModel, ecModel, api) {
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var isHorizontal = !!baseAxis.isHorizontal();
	    var coordSysRect = cartesian.grid.getRect();
	    var opt = {
	      ecSize: {
	        width: api.getWidth(),
	        height: api.getHeight()
	      },
	      seriesModel: seriesModel,
	      coordSys: cartesian,
	      coordSysExtent: [[coordSysRect.x, coordSysRect.x + coordSysRect.width], [coordSysRect.y, coordSysRect.y + coordSysRect.height]],
	      isHorizontal: isHorizontal,
	      valueDim: LAYOUT_ATTRS[+isHorizontal],
	      categoryDim: LAYOUT_ATTRS[1 - isHorizontal]
	    };
	    data.diff(oldData).add(function (dataIndex) {
	      if (!data.hasValue(dataIndex)) {
	        return;
	      }
	
	      var itemModel = getItemModel(data, dataIndex);
	      var symbolMeta = getSymbolMeta(data, dataIndex, itemModel, opt);
	      var bar = createBar(data, opt, symbolMeta);
	      data.setItemGraphicEl(dataIndex, bar);
	      group.add(bar);
	      updateCommon(bar, opt, symbolMeta);
	    }).update(function (newIndex, oldIndex) {
	      var bar = oldData.getItemGraphicEl(oldIndex);
	
	      if (!data.hasValue(newIndex)) {
	        group.remove(bar);
	        return;
	      }
	
	      var itemModel = getItemModel(data, newIndex);
	      var symbolMeta = getSymbolMeta(data, newIndex, itemModel, opt);
	      var pictorialShapeStr = getShapeStr(data, symbolMeta);
	
	      if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
	        group.remove(bar);
	        data.setItemGraphicEl(newIndex, null);
	        bar = null;
	      }
	
	      if (bar) {
	        updateBar(bar, opt, symbolMeta);
	      } else {
	        bar = createBar(data, opt, symbolMeta, true);
	      }
	
	      data.setItemGraphicEl(newIndex, bar);
	      bar.__pictorialSymbolMeta = symbolMeta; // Add back
	
	      group.add(bar);
	      updateCommon(bar, opt, symbolMeta);
	    }).remove(function (dataIndex) {
	      var bar = oldData.getItemGraphicEl(dataIndex);
	      bar && removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
	    }).execute();
	    this._data = data;
	    return this.group;
	  },
	  dispose: zrUtil.noop,
	  remove: function (ecModel, api) {
	    var group = this.group;
	    var data = this._data;
	
	    if (ecModel.get('animation')) {
	      if (data) {
	        data.eachItemGraphicEl(function (bar) {
	          removeBar(data, bar.dataIndex, ecModel, bar);
	        });
	      }
	    } else {
	      group.removeAll();
	    }
	  }
	}); // Set or calculate default value about symbol, and calculate layout info.
	
	function getSymbolMeta(data, dataIndex, itemModel, opt) {
	  var layout = data.getItemLayout(dataIndex);
	  var symbolRepeat = itemModel.get('symbolRepeat');
	  var symbolClip = itemModel.get('symbolClip');
	  var symbolPosition = itemModel.get('symbolPosition') || 'start';
	  var symbolRotate = itemModel.get('symbolRotate');
	  var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
	  var isAnimationEnabled = itemModel.isAnimationEnabled();
	  var symbolMeta = {
	    dataIndex: dataIndex,
	    layout: layout,
	    itemModel: itemModel,
	    symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
	    color: data.getItemVisual(dataIndex, 'color'),
	    symbolClip: symbolClip,
	    symbolRepeat: symbolRepeat,
	    symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
	    symbolPatternSize: symbolPatternSize,
	    rotation: rotation,
	    animationModel: isAnimationEnabled ? itemModel : null,
	    hoverAnimation: isAnimationEnabled && itemModel.get('hoverAnimation'),
	    z2: itemModel.getShallow('z', true) || 0
	  };
	  prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
	  prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
	  prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
	  var symbolSize = symbolMeta.symbolSize;
	  var symbolOffset = itemModel.get('symbolOffset');
	
	  if (zrUtil.isArray(symbolOffset)) {
	    symbolOffset = [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])];
	  }
	
	  prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
	  return symbolMeta;
	} // bar length can be negative.
	
	
	function prepareBarLength(itemModel, symbolRepeat, layout, opt, output) {
	  var valueDim = opt.valueDim;
	  var symbolBoundingData = itemModel.get('symbolBoundingData');
	  var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
	  var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
	  var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
	  var boundingLength;
	
	  if (zrUtil.isArray(symbolBoundingData)) {
	    var symbolBoundingExtent = [convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx, convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx];
	    symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
	    boundingLength = symbolBoundingExtent[pxSignIdx];
	  } else if (symbolBoundingData != null) {
	    boundingLength = convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
	  } else if (symbolRepeat) {
	    boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
	  } else {
	    boundingLength = layout[valueDim.wh];
	  }
	
	  output.boundingLength = boundingLength;
	
	  if (symbolRepeat) {
	    output.repeatCutLength = layout[valueDim.wh];
	  }
	
	  output.pxSign = boundingLength > 0 ? 1 : boundingLength < 0 ? -1 : 0;
	}
	
	function convertToCoordOnAxis(axis, value) {
	  return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
	} // Support ['100%', '100%']
	
	
	function prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, output) {
	  var valueDim = opt.valueDim;
	  var categoryDim = opt.categoryDim;
	  var categorySize = Math.abs(layout[categoryDim.wh]);
	  var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');
	
	  if (zrUtil.isArray(symbolSize)) {
	    symbolSize = symbolSize.slice();
	  } else {
	    if (symbolSize == null) {
	      symbolSize = '100%';
	    }
	
	    symbolSize = [symbolSize, symbolSize];
	  } // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
	  // to complicated to calculate real percent value if considering scaled lineWidth.
	  // So the actual size will bigger than layout size if lineWidth is bigger than zero,
	  // which can be tolerated in pictorial chart.
	
	
	  symbolSize[categoryDim.index] = parsePercent(symbolSize[categoryDim.index], categorySize);
	  symbolSize[valueDim.index] = parsePercent(symbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
	  output.symbolSize = symbolSize; // If x or y is less than zero, show reversed shape.
	
	  var symbolScale = output.symbolScale = [symbolSize[0] / symbolPatternSize, symbolSize[1] / symbolPatternSize]; // Follow convention, 'right' and 'top' is the normal scale.
	
	  symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
	}
	
	function prepareLineWidth(itemModel, symbolScale, rotation, opt, output) {
	  // In symbols are drawn with scale, so do not need to care about the case that width
	  // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
	  // be calculated.
	  var valueLineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;
	
	  if (valueLineWidth) {
	    pathForLineWidth.attr({
	      scale: symbolScale.slice(),
	      rotation: rotation
	    });
	    pathForLineWidth.updateTransform();
	    valueLineWidth /= pathForLineWidth.getLineScale();
	    valueLineWidth *= symbolScale[opt.valueDim.index];
	  }
	
	  output.valueLineWidth = valueLineWidth;
	}
	
	function prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, output) {
	  var categoryDim = opt.categoryDim;
	  var valueDim = opt.valueDim;
	  var pxSign = output.pxSign;
	  var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
	  var pathLen = unitLength; // Note: rotation will not effect the layout of symbols, because user may
	  // want symbols to rotate on its center, which should not be translated
	  // when rotating.
	
	  if (symbolRepeat) {
	    var absBoundingLength = Math.abs(boundingLength);
	    var symbolMargin = zrUtil.retrieve(itemModel.get('symbolMargin'), '15%') + '';
	    var hasEndGap = false;
	
	    if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
	      hasEndGap = true;
	      symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
	    }
	
	    symbolMargin = parsePercent(symbolMargin, symbolSize[valueDim.index]);
	    var uLenWithMargin = Math.max(unitLength + symbolMargin * 2, 0); // When symbol margin is less than 0, margin at both ends will be subtracted
	    // to ensure that all of the symbols will not be overflow the given area.
	
	    var endFix = hasEndGap ? 0 : symbolMargin * 2; // Both final repeatTimes and final symbolMargin area calculated based on
	    // boundingLength.
	
	    var repeatSpecified = isNumeric(symbolRepeat);
	    var repeatTimes = repeatSpecified ? symbolRepeat : toIntTimes((absBoundingLength + endFix) / uLenWithMargin); // Adjust calculate margin, to ensure each symbol is displayed
	    // entirely in the given layout area.
	
	    var mDiff = absBoundingLength - repeatTimes * unitLength;
	    symbolMargin = mDiff / 2 / (hasEndGap ? repeatTimes : repeatTimes - 1);
	    uLenWithMargin = unitLength + symbolMargin * 2;
	    endFix = hasEndGap ? 0 : symbolMargin * 2; // Update repeatTimes when not all symbol will be shown.
	
	    if (!repeatSpecified && symbolRepeat !== 'fixed') {
	      repeatTimes = repeatCutLength ? toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
	    }
	
	    pathLen = repeatTimes * uLenWithMargin - endFix;
	    output.repeatTimes = repeatTimes;
	    output.symbolMargin = symbolMargin;
	  }
	
	  var sizeFix = pxSign * (pathLen / 2);
	  var pathPosition = output.pathPosition = [];
	  pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
	  pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'
	
	  if (symbolOffset) {
	    pathPosition[0] += symbolOffset[0];
	    pathPosition[1] += symbolOffset[1];
	  }
	
	  var bundlePosition = output.bundlePosition = [];
	  bundlePosition[categoryDim.index] = layout[categoryDim.xy];
	  bundlePosition[valueDim.index] = layout[valueDim.xy];
	  var barRectShape = output.barRectShape = zrUtil.extend({}, layout);
	  barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
	  barRectShape[categoryDim.wh] = layout[categoryDim.wh];
	  var clipShape = output.clipShape = {}; // Consider that symbol may be overflow layout rect.
	
	  clipShape[categoryDim.xy] = -layout[categoryDim.xy];
	  clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
	  clipShape[valueDim.xy] = 0;
	  clipShape[valueDim.wh] = layout[valueDim.wh];
	}
	
	function createPath(symbolMeta) {
	  var symbolPatternSize = symbolMeta.symbolPatternSize;
	  var path = createSymbol( // Consider texture img, make a big size.
	  symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize, symbolMeta.color);
	  path.attr({
	    culling: true
	  });
	  path.type !== 'image' && path.setStyle({
	    strokeNoScale: true
	  });
	  return path;
	}
	
	function createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
	  var bundle = bar.__pictorialBundle;
	  var symbolSize = symbolMeta.symbolSize;
	  var valueLineWidth = symbolMeta.valueLineWidth;
	  var pathPosition = symbolMeta.pathPosition;
	  var valueDim = opt.valueDim;
	  var repeatTimes = symbolMeta.repeatTimes || 0;
	  var index = 0;
	  var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
	  eachPath(bar, function (path) {
	    path.__pictorialAnimationIndex = index;
	    path.__pictorialRepeatTimes = repeatTimes;
	
	    if (index < repeatTimes) {
	      updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
	    } else {
	      updateAttr(path, null, {
	        scale: [0, 0]
	      }, symbolMeta, isUpdate, function () {
	        bundle.remove(path);
	      });
	    }
	
	    updateHoverAnimation(path, symbolMeta);
	    index++;
	  });
	
	  for (; index < repeatTimes; index++) {
	    var path = createPath(symbolMeta);
	    path.__pictorialAnimationIndex = index;
	    path.__pictorialRepeatTimes = repeatTimes;
	    bundle.add(path);
	    var target = makeTarget(index);
	    updateAttr(path, {
	      position: target.position,
	      scale: [0, 0]
	    }, {
	      scale: target.scale,
	      rotation: target.rotation
	    }, symbolMeta, isUpdate); // FIXME
	    // If all emphasis/normal through action.
	
	    path.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
	    updateHoverAnimation(path, symbolMeta);
	  }
	
	  function makeTarget(index) {
	    var position = pathPosition.slice(); // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
	    // Otherwise: i = index;
	
	    var pxSign = symbolMeta.pxSign;
	    var i = index;
	
	    if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) {
	      i = repeatTimes - 1 - index;
	    }
	
	    position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
	    return {
	      position: position,
	      scale: symbolMeta.symbolScale.slice(),
	      rotation: symbolMeta.rotation
	    };
	  }
	
	  function onMouseOver() {
	    eachPath(bar, function (path) {
	      path.trigger('emphasis');
	    });
	  }
	
	  function onMouseOut() {
	    eachPath(bar, function (path) {
	      path.trigger('normal');
	    });
	  }
	}
	
	function createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
	  var bundle = bar.__pictorialBundle;
	  var mainPath = bar.__pictorialMainPath;
	
	  if (!mainPath) {
	    mainPath = bar.__pictorialMainPath = createPath(symbolMeta);
	    bundle.add(mainPath);
	    updateAttr(mainPath, {
	      position: symbolMeta.pathPosition.slice(),
	      scale: [0, 0],
	      rotation: symbolMeta.rotation
	    }, {
	      scale: symbolMeta.symbolScale.slice()
	    }, symbolMeta, isUpdate);
	    mainPath.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
	  } else {
	    updateAttr(mainPath, null, {
	      position: symbolMeta.pathPosition.slice(),
	      scale: symbolMeta.symbolScale.slice(),
	      rotation: symbolMeta.rotation
	    }, symbolMeta, isUpdate);
	  }
	
	  updateHoverAnimation(mainPath, symbolMeta);
	
	  function onMouseOver() {
	    this.trigger('emphasis');
	  }
	
	  function onMouseOut() {
	    this.trigger('normal');
	  }
	} // bar rect is used for label.
	
	
	function createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
	  var rectShape = zrUtil.extend({}, symbolMeta.barRectShape);
	  var barRect = bar.__pictorialBarRect;
	
	  if (!barRect) {
	    barRect = bar.__pictorialBarRect = new graphic.Rect({
	      z2: 2,
	      shape: rectShape,
	      silent: true,
	      style: {
	        stroke: 'transparent',
	        fill: 'transparent',
	        lineWidth: 0
	      }
	    });
	    bar.add(barRect);
	  } else {
	    updateAttr(barRect, null, {
	      shape: rectShape
	    }, symbolMeta, isUpdate);
	  }
	}
	
	function createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
	  // If not clip, symbol will be remove and rebuilt.
	  if (symbolMeta.symbolClip) {
	    var clipPath = bar.__pictorialClipPath;
	    var clipShape = zrUtil.extend({}, symbolMeta.clipShape);
	    var valueDim = opt.valueDim;
	    var animationModel = symbolMeta.animationModel;
	    var dataIndex = symbolMeta.dataIndex;
	
	    if (clipPath) {
	      graphic.updateProps(clipPath, {
	        shape: clipShape
	      }, animationModel, dataIndex);
	    } else {
	      clipShape[valueDim.wh] = 0;
	      clipPath = new graphic.Rect({
	        shape: clipShape
	      });
	
	      bar.__pictorialBundle.setClipPath(clipPath);
	
	      bar.__pictorialClipPath = clipPath;
	      var target = {};
	      target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
	        shape: target
	      }, animationModel, dataIndex);
	    }
	  }
	}
	
	function getItemModel(data, dataIndex) {
	  var itemModel = data.getItemModel(dataIndex);
	  itemModel.getAnimationDelayParams = getAnimationDelayParams;
	  itemModel.isAnimationEnabled = isAnimationEnabled;
	  return itemModel;
	}
	
	function getAnimationDelayParams(path) {
	  // The order is the same as the z-order, see `symbolRepeatDiretion`.
	  return {
	    index: path.__pictorialAnimationIndex,
	    count: path.__pictorialRepeatTimes
	  };
	}
	
	function isAnimationEnabled() {
	  // `animation` prop can be set on itemModel in pictorial bar chart.
	  return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
	}
	
	function updateHoverAnimation(path, symbolMeta) {
	  path.off('emphasis').off('normal');
	  var scale = symbolMeta.symbolScale.slice();
	  symbolMeta.hoverAnimation && path.on('emphasis', function () {
	    this.animateTo({
	      scale: [scale[0] * 1.1, scale[1] * 1.1]
	    }, 400, 'elasticOut');
	  }).on('normal', function () {
	    this.animateTo({
	      scale: scale.slice()
	    }, 400, 'elasticOut');
	  });
	}
	
	function createBar(data, opt, symbolMeta, isUpdate) {
	  // bar is the main element for each data.
	  var bar = new graphic.Group(); // bundle is used for location and clip.
	
	  var bundle = new graphic.Group();
	  bar.add(bundle);
	  bar.__pictorialBundle = bundle;
	  bundle.attr('position', symbolMeta.bundlePosition.slice());
	
	  if (symbolMeta.symbolRepeat) {
	    createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
	  } else {
	    createOrUpdateSingleSymbol(bar, opt, symbolMeta);
	  }
	
	  createOrUpdateBarRect(bar, symbolMeta, isUpdate);
	  createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
	  bar.__pictorialShapeStr = getShapeStr(data, symbolMeta);
	  bar.__pictorialSymbolMeta = symbolMeta;
	  return bar;
	}
	
	function updateBar(bar, opt, symbolMeta) {
	  var animationModel = symbolMeta.animationModel;
	  var dataIndex = symbolMeta.dataIndex;
	  var bundle = bar.__pictorialBundle;
	  graphic.updateProps(bundle, {
	    position: symbolMeta.bundlePosition.slice()
	  }, animationModel, dataIndex);
	
	  if (symbolMeta.symbolRepeat) {
	    createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
	  } else {
	    createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
	  }
	
	  createOrUpdateBarRect(bar, symbolMeta, true);
	  createOrUpdateClip(bar, opt, symbolMeta, true);
	}
	
	function removeBar(data, dataIndex, animationModel, bar) {
	  // Not show text when animating
	  var labelRect = bar.__pictorialBarRect;
	  labelRect && (labelRect.style.text = null);
	  var pathes = [];
	  eachPath(bar, function (path) {
	    pathes.push(path);
	  });
	  bar.__pictorialMainPath && pathes.push(bar.__pictorialMainPath); // I do not find proper remove animation for clip yet.
	
	  bar.__pictorialClipPath && (animationModel = null);
	  zrUtil.each(pathes, function (path) {
	    graphic.updateProps(path, {
	      scale: [0, 0]
	    }, animationModel, dataIndex, function () {
	      bar.parent && bar.parent.remove(bar);
	    });
	  });
	  data.setItemGraphicEl(dataIndex, null);
	}
	
	function getShapeStr(data, symbolMeta) {
	  return [data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none', !!symbolMeta.symbolRepeat, !!symbolMeta.symbolClip].join(':');
	}
	
	function eachPath(bar, cb, context) {
	  // Do not use Group#eachChild, because it do not support remove.
	  zrUtil.each(bar.__pictorialBundle.children(), function (el) {
	    el !== bar.__pictorialBarRect && cb.call(context, el);
	  });
	}
	
	function updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
	  immediateAttrs && el.attr(immediateAttrs); // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
	
	  if (symbolMeta.symbolClip && !isUpdate) {
	    animationAttrs && el.attr(animationAttrs);
	  } else {
	    animationAttrs && graphic[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
	  }
	}
	
	function updateCommon(bar, opt, symbolMeta) {
	  var color = symbolMeta.color;
	  var dataIndex = symbolMeta.dataIndex;
	  var itemModel = symbolMeta.itemModel; // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var normalStyle = itemModel.getModel('itemStyle').getItemStyle(['color']);
	  var hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  var cursorStyle = itemModel.getShallow('cursor');
	  eachPath(bar, function (path) {
	    // PENDING setColor should be before setStyle!!!
	    path.setColor(color);
	    path.setStyle(zrUtil.defaults({
	      fill: color,
	      opacity: symbolMeta.opacity
	    }, normalStyle));
	    graphic.setHoverStyle(path, hoverStyle);
	    cursorStyle && (path.cursor = cursorStyle);
	    path.z2 = symbolMeta.z2;
	  });
	  var barRectHoverStyle = {};
	  var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
	  var barRect = bar.__pictorialBarRect;
	  setLabel(barRect.style, barRectHoverStyle, itemModel, color, opt.seriesModel, dataIndex, barPositionOutside);
	  graphic.setHoverStyle(barRect, barRectHoverStyle);
	}
	
	function toIntTimes(times) {
	  var roundedTimes = Math.round(times); // Escapse accurate error
	
	  return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
	}
	
	var _default = BarView;
	module.exports = _default;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(557);
	
	__webpack_require__(574);
	
	__webpack_require__(575);
	
	var themeRiverLayout = __webpack_require__(576);
	
	var themeRiverVisual = __webpack_require__(577);
	
	var dataFilter = __webpack_require__(412);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(themeRiverLayout);
	echarts.registerVisual(themeRiverVisual);
	echarts.registerProcessor(dataFilter('themeRiver'));

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(558);
	
	__webpack_require__(561);
	
	__webpack_require__(563);
	
	__webpack_require__(564);
	
	__webpack_require__(573);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.extendComponentView({
	  type: 'single'
	});

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Single = __webpack_require__(559);
	
	var CoordinateSystem = __webpack_require__(315);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Single coordinate system creator.
	 */
	
	/**
	 * Create single coordinate system and inject it into seriesModel.
	 *
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 * @return {Array.<module:echarts/coord/single/Single>}
	 */
	function create(ecModel, api) {
	  var singles = [];
	  ecModel.eachComponent('singleAxis', function (axisModel, idx) {
	    var single = new Single(axisModel, ecModel, api);
	    single.name = 'single_' + idx;
	    single.resize(axisModel, api);
	    axisModel.coordinateSystem = single;
	    singles.push(single);
	  });
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.get('coordinateSystem') === 'singleAxis') {
	      var singleAxisModel = ecModel.queryComponents({
	        mainType: 'singleAxis',
	        index: seriesModel.get('singleAxisIndex'),
	        id: seriesModel.get('singleAxisId')
	      })[0];
	      seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
	    }
	  });
	  return singles;
	}
	
	CoordinateSystem.register('single', {
	  create: create,
	  dimensions: Single.prototype.dimensions
	});

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SingleAxis = __webpack_require__(560);
	
	var axisHelper = __webpack_require__(350);
	
	var _layout = __webpack_require__(305);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Single coordinates system.
	 */
	
	/**
	 * Create a single coordinates system.
	 *
	 * @param {module:echarts/coord/single/AxisModel} axisModel
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function Single(axisModel, ecModel, api) {
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  this.dimension = 'single';
	  /**
	   * Add it just for draw tooltip.
	   *
	   * @type {Array.<string>}
	   * @readOnly
	   */
	
	  this.dimensions = ['single'];
	  /**
	   * @private
	   * @type {module:echarts/coord/single/SingleAxis}.
	   */
	
	  this._axis = null;
	  /**
	   * @private
	   * @type {module:zrender/core/BoundingRect}
	   */
	
	  this._rect;
	
	  this._init(axisModel, ecModel, api);
	  /**
	   * @type {module:echarts/coord/single/AxisModel}
	   */
	
	
	  this.model = axisModel;
	}
	
	Single.prototype = {
	  type: 'singleAxis',
	  axisPointerEnabled: true,
	  constructor: Single,
	
	  /**
	   * Initialize single coordinate system.
	   *
	   * @param  {module:echarts/coord/single/AxisModel} axisModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @private
	   */
	  _init: function (axisModel, ecModel, api) {
	    var dim = this.dimension;
	    var axis = new SingleAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisModel.get('position'));
	    var isCategory = axis.type === 'category';
	    axis.onBand = isCategory && axisModel.get('boundaryGap');
	    axis.inverse = axisModel.get('inverse');
	    axis.orient = axisModel.get('orient');
	    axisModel.axis = axis;
	    axis.model = axisModel;
	    axis.coordinateSystem = this;
	    this._axis = axis;
	  },
	
	  /**
	   * Update axis scale after data processed
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  update: function (ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.coordinateSystem === this) {
	        var data = seriesModel.getData();
	        each(data.mapDimension(this.dimension, true), function (dim) {
	          this._axis.scale.unionExtentFromData(data, dim);
	        }, this);
	        axisHelper.niceScaleExtent(this._axis.scale, this._axis.model);
	      }
	    }, this);
	  },
	
	  /**
	   * Resize the single coordinate system.
	   *
	   * @param  {module:echarts/coord/single/AxisModel} axisModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  resize: function (axisModel, api) {
	    this._rect = getLayoutRect({
	      left: axisModel.get('left'),
	      top: axisModel.get('top'),
	      right: axisModel.get('right'),
	      bottom: axisModel.get('bottom'),
	      width: axisModel.get('width'),
	      height: axisModel.get('height')
	    }, {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	
	    this._adjustAxis();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @private
	   */
	  _adjustAxis: function () {
	    var rect = this._rect;
	    var axis = this._axis;
	    var isHorizontal = axis.isHorizontal();
	    var extent = isHorizontal ? [0, rect.width] : [0, rect.height];
	    var idx = axis.reverse ? 1 : 0;
	    axis.setExtent(extent[idx], extent[1 - idx]);
	
	    this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
	  },
	
	  /**
	   * @param  {module:echarts/coord/single/SingleAxis} axis
	   * @param  {number} coordBase
	   */
	  _updateAxisTransform: function (axis, coordBase) {
	    var axisExtent = axis.getExtent();
	    var extentSum = axisExtent[0] + axisExtent[1];
	    var isHorizontal = axis.isHorizontal();
	    axis.toGlobalCoord = isHorizontal ? function (coord) {
	      return coord + coordBase;
	    } : function (coord) {
	      return extentSum - coord + coordBase;
	    };
	    axis.toLocalCoord = isHorizontal ? function (coord) {
	      return coord - coordBase;
	    } : function (coord) {
	      return extentSum - coord + coordBase;
	    };
	  },
	
	  /**
	   * Get axis.
	   *
	   * @return {module:echarts/coord/single/SingleAxis}
	   */
	  getAxis: function () {
	    return this._axis;
	  },
	
	  /**
	   * Get axis, add it just for draw tooltip.
	   *
	   * @return {[type]} [description]
	   */
	  getBaseAxis: function () {
	    return this._axis;
	  },
	
	  /**
	   * @return {Array.<module:echarts/coord/Axis>}
	   */
	  getAxes: function () {
	    return [this._axis];
	  },
	
	  /**
	   * @return {Object} {baseAxes: [], otherAxes: []}
	   */
	  getTooltipAxes: function () {
	    return {
	      baseAxes: [this.getAxis()]
	    };
	  },
	
	  /**
	   * If contain point.
	   *
	   * @param  {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var rect = this.getRect();
	    var axis = this.getAxis();
	    var orient = axis.orient;
	
	    if (orient === 'horizontal') {
	      return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
	    } else {
	      return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
	    }
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToData: function (point) {
	    var axis = this.getAxis();
	    return [axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))];
	  },
	
	  /**
	   * Convert the series data to concrete point.
	   *
	   * @param  {number|Array.<number>} val
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (val) {
	    var axis = this.getAxis();
	    var rect = this.getRect();
	    var pt = [];
	    var idx = axis.orient === 'horizontal' ? 0 : 1;
	
	    if (val instanceof Array) {
	      val = val[0];
	    }
	
	    pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
	    pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
	    return pt;
	  }
	};
	var _default = Single;
	module.exports = _default;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Axis = __webpack_require__(364);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor  module:echarts/coord/single/SingleAxis
	 * @extends {module:echarts/coord/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var SingleAxis = function (dim, scale, coordExtent, axisType, position) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   * - 'category'
	   * - 'value'
	   * - 'time'
	   * - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis position
	   *  - 'top'
	   *  - 'bottom'
	   *  - 'left'
	   *  - 'right'
	   *  @type {string}
	   */
	
	  this.position = position || 'bottom';
	  /**
	   * Axis orient
	   *  - 'horizontal'
	   *  - 'vertical'
	   * @type {[type]}
	   */
	
	  this.orient = null;
	};
	
	SingleAxis.prototype = {
	  constructor: SingleAxis,
	
	  /**
	   * Axis model
	   * @type {module:echarts/coord/single/AxisModel}
	   */
	  model: null,
	
	  /**
	   * Judge the orient of the axis.
	   * @return {boolean}
	   */
	  isHorizontal: function () {
	    var position = this.position;
	    return position === 'top' || position === 'bottom';
	  },
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.coordinateSystem.pointToData(point, clamp)[0];
	  },
	
	  /**
	   * Convert the local coord(processed by dataToCoord())
	   * to global coord(concrete pixel coord).
	   * designated by module:echarts/coord/single/Single.
	   * @type {Function}
	   */
	  toGlobalCoord: null,
	
	  /**
	   * Convert the global coord to local coord.
	   * designated by module:echarts/coord/single/Single.
	   * @type {Function}
	   */
	  toLocalCoord: null
	};
	zrUtil.inherits(SingleAxis, Axis);
	var _default = SingleAxis;
	module.exports = _default;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var AxisBuilder = __webpack_require__(390);
	
	var graphic = __webpack_require__(268);
	
	var singleAxisHelper = __webpack_require__(562);
	
	var AxisView = __webpack_require__(391);
	
	var _axisSplitHelper = __webpack_require__(394);
	
	var rectCoordAxisBuildSplitArea = _axisSplitHelper.rectCoordAxisBuildSplitArea;
	var rectCoordAxisHandleRemove = _axisSplitHelper.rectCoordAxisHandleRemove;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitArea', 'splitLine'];
	var SingleAxisView = AxisView.extend({
	  type: 'singleAxis',
	  axisPointerClass: 'SingleAxisPointer',
	  render: function (axisModel, ecModel, api, payload) {
	    var group = this.group;
	    group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    var layout = singleAxisHelper.layout(axisModel);
	    var axisBuilder = new AxisBuilder(axisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	    group.add(this._axisGroup);
	    group.add(axisBuilder.getGroup());
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (axisModel.get(name + '.show')) {
	        this['_' + name](axisModel);
	      }
	    }, this);
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	    SingleAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
	  },
	  remove: function () {
	    rectCoordAxisHandleRemove(this);
	  },
	  _splitLine: function (axisModel) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitLineModel = axisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineWidth = lineStyleModel.get('width');
	    var lineColors = lineStyleModel.get('color');
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var gridRect = axisModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var splitLines = [];
	    var lineCount = 0;
	    var ticksCoords = axis.getTicksCoords({
	      tickModel: splitLineModel
	    });
	    var p1 = [];
	    var p2 = [];
	
	    for (var i = 0; i < ticksCoords.length; ++i) {
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	
	      if (isHorizontal) {
	        p1[0] = tickCoord;
	        p1[1] = gridRect.y;
	        p2[0] = tickCoord;
	        p2[1] = gridRect.y + gridRect.height;
	      } else {
	        p1[0] = gridRect.x;
	        p1[1] = tickCoord;
	        p2[0] = gridRect.x + gridRect.width;
	        p2[1] = tickCoord;
	      }
	
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Line({
	        subPixelOptimize: true,
	        shape: {
	          x1: p1[0],
	          y1: p1[1],
	          x2: p2[0],
	          y2: p2[1]
	        },
	        style: {
	          lineWidth: lineWidth
	        },
	        silent: true
	      }));
	    }
	
	    for (var i = 0; i < splitLines.length; ++i) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: {
	          stroke: lineColors[i % lineColors.length],
	          lineDash: lineStyleModel.getLineDash(lineWidth),
	          lineWidth: lineWidth
	        },
	        silent: true
	      }));
	    }
	  },
	  _splitArea: function (axisModel) {
	    rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, axisModel);
	  }
	});
	var _default = SingleAxisView;
	module.exports = _default;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} opt {labelInside}
	 * @return {Object} {
	 *  position, rotation, labelDirection, labelOffset,
	 *  tickDirection, labelRotate, z2
	 * }
	 */
	function layout(axisModel, opt) {
	  opt = opt || {};
	  var single = axisModel.coordinateSystem;
	  var axis = axisModel.axis;
	  var layout = {};
	  var axisPosition = axis.position;
	  var orient = axis.orient;
	  var rect = single.getRect();
	  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	  var positionMap = {
	    horizontal: {
	      top: rectBound[2],
	      bottom: rectBound[3]
	    },
	    vertical: {
	      left: rectBound[0],
	      right: rectBound[1]
	    }
	  };
	  layout.position = [orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0], orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]];
	  var r = {
	    horizontal: 0,
	    vertical: 1
	  };
	  layout.rotation = Math.PI / 2 * r[orient];
	  var directionMap = {
	    top: -1,
	    bottom: 1,
	    right: 1,
	    left: -1
	  };
	  layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
	
	  if (axisModel.get('axisTick.inside')) {
	    layout.tickDirection = -layout.tickDirection;
	  }
	
	  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
	    layout.labelDirection = -layout.labelDirection;
	  }
	
	  var labelRotation = opt.rotate;
	  labelRotation == null && (labelRotation = axisModel.get('axisLabel.rotate'));
	  layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
	  layout.z2 = 1;
	  return layout;
	}
	
	exports.layout = layout;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var ComponentModel = __webpack_require__(303);
	
	var axisModelCreator = __webpack_require__(386);
	
	var axisModelCommonMixin = __webpack_require__(359);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'singleAxis',
	  layoutMode: 'box',
	
	  /**
	   * @type {module:echarts/coord/single/SingleAxis}
	   */
	  axis: null,
	
	  /**
	   * @type {module:echarts/coord/single/Single}
	   */
	  coordinateSystem: null,
	
	  /**
	   * @override
	   */
	  getCoordSysModel: function () {
	    return this;
	  }
	});
	var defaultOption = {
	  left: '5%',
	  top: '5%',
	  right: '5%',
	  bottom: '5%',
	  type: 'value',
	  position: 'bottom',
	  orient: 'horizontal',
	  axisLine: {
	    show: true,
	    lineStyle: {
	      width: 1,
	      type: 'solid'
	    }
	  },
	  // Single coordinate system and single axis is the,
	  // which is used as the parent tooltip model.
	  // same model, so we set default tooltip show as true.
	  tooltip: {
	    show: true
	  },
	  axisTick: {
	    show: true,
	    length: 6,
	    lineStyle: {
	      width: 1
	    }
	  },
	  axisLabel: {
	    show: true,
	    interval: 'auto'
	  },
	  splitLine: {
	    show: true,
	    lineStyle: {
	      type: 'dashed',
	      opacity: 0.2
	    }
	  }
	};
	
	function getAxisType(axisName, option) {
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	axisModelCreator('single', AxisModel, getAxisType, defaultOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var axisPointerModelHelper = __webpack_require__(392);
	
	var axisTrigger = __webpack_require__(565);
	
	__webpack_require__(567);
	
	__webpack_require__(568);
	
	__webpack_require__(570);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// CartesianAxisPointer is not supposed to be required here. But consider
	// echarts.simple.js and online build tooltip, which only require gridSimple,
	// CartesianAxisPointer should be able to required somewhere.
	echarts.registerPreprocessor(function (option) {
	  // Always has a global axisPointerModel for default setting.
	  if (option) {
	    (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
	    var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
	    // is not set, remain null/undefined, otherwise it will
	    // override existent link setting.
	
	    if (link && !zrUtil.isArray(link)) {
	      option.axisPointer.link = [link];
	    }
	  }
	}); // This process should proformed after coordinate systems created
	// and series data processed. So put it on statistic processing stage.
	
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
	  // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	  // allAxesInfo should be updated when setOption performed.
	  ecModel.getComponent('axisPointer').coordSysAxesInfo = axisPointerModelHelper.collect(ecModel, api);
	}); // Broadcast to all views.
	
	echarts.registerAction({
	  type: 'updateAxisPointer',
	  event: 'updateAxisPointer',
	  update: ':updateAxisPointer'
	}, axisTrigger);

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var _model = __webpack_require__(261);
	
	var makeInner = _model.makeInner;
	
	var modelHelper = __webpack_require__(392);
	
	var findPointFromSeries = __webpack_require__(566);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var curry = zrUtil.curry;
	var inner = makeInner();
	/**
	 * Basic logic: check all axis, if they do not demand show/highlight,
	 * then hide/downplay them.
	 *
	 * @param {Object} coordSysAxesInfo
	 * @param {Object} payload
	 * @param {string} [payload.currTrigger] 'click' | 'mousemove' | 'leave'
	 * @param {Array.<number>} [payload.x] x and y, which are mandatory, specify a point to
	 *              trigger axisPointer and tooltip.
	 * @param {Array.<number>} [payload.y] x and y, which are mandatory, specify a point to
	 *              trigger axisPointer and tooltip.
	 * @param {Object} [payload.seriesIndex] finder, optional, restrict target axes.
	 * @param {Object} [payload.dataIndex] finder, restrict target axes.
	 * @param {Object} [payload.axesInfo] finder, restrict target axes.
	 *        [{
	 *          axisDim: 'x'|'y'|'angle'|...,
	 *          axisIndex: ...,
	 *          value: ...
	 *        }, ...]
	 * @param {Function} [payload.dispatchAction]
	 * @param {Object} [payload.tooltipOption]
	 * @param {Object|Array.<number>|Function} [payload.position] Tooltip position,
	 *        which can be specified in dispatchAction
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 * @return {Object} content of event obj for echarts.connect.
	 */
	
	function _default(payload, ecModel, api) {
	  var currTrigger = payload.currTrigger;
	  var point = [payload.x, payload.y];
	  var finder = payload;
	  var dispatchAction = payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
	  var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
	  // See #6121. But we are not able to reproduce it yet.
	
	  if (!coordSysAxesInfo) {
	    return;
	  }
	
	  if (illegalPoint(point)) {
	    // Used in the default behavior of `connection`: use the sample seriesIndex
	    // and dataIndex. And also used in the tooltipView trigger.
	    point = findPointFromSeries({
	      seriesIndex: finder.seriesIndex,
	      // Do not use dataIndexInside from other ec instance.
	      // FIXME: auto detect it?
	      dataIndex: finder.dataIndex
	    }, ecModel).point;
	  }
	
	  var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
	  // Notice: In this case, it is difficult to get the `point` (which is necessary to show
	  // tooltip, so if point is not given, we just use the point found by sample seriesIndex
	  // and dataIndex.
	
	  var inputAxesInfo = finder.axesInfo;
	  var axesInfo = coordSysAxesInfo.axesInfo;
	  var shouldHide = currTrigger === 'leave' || illegalPoint(point);
	  var outputFinder = {};
	  var showValueMap = {};
	  var dataByCoordSys = {
	    list: [],
	    map: {}
	  };
	  var updaters = {
	    showPointer: curry(showPointer, showValueMap),
	    showTooltip: curry(showTooltip, dataByCoordSys)
	  }; // Process for triggered axes.
	
	  each(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
	    // If a point given, it must be contained by the coordinate system.
	    var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
	    each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
	      var axis = axisInfo.axis;
	      var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.
	
	      if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
	        var val = inputAxisInfo && inputAxisInfo.value;
	
	        if (val == null && !isIllegalPoint) {
	          val = axis.pointToData(point);
	        }
	
	        val != null && processOnAxis(axisInfo, val, updaters, false, outputFinder);
	      }
	    });
	  }); // Process for linked axes.
	
	  var linkTriggers = {};
	  each(axesInfo, function (tarAxisInfo, tarKey) {
	    var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.
	
	    if (linkGroup && !showValueMap[tarKey]) {
	      each(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
	        var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.
	
	        if (srcAxisInfo !== tarAxisInfo && srcValItem) {
	          var val = srcValItem.value;
	          linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
	          linkTriggers[tarAxisInfo.key] = val;
	        }
	      });
	    }
	  });
	  each(linkTriggers, function (val, tarKey) {
	    processOnAxis(axesInfo[tarKey], val, updaters, true, outputFinder);
	  });
	  updateModelActually(showValueMap, axesInfo, outputFinder);
	  dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
	  dispatchHighDownActually(axesInfo, dispatchAction, api);
	  return outputFinder;
	}
	
	function processOnAxis(axisInfo, newValue, updaters, dontSnap, outputFinder) {
	  var axis = axisInfo.axis;
	
	  if (axis.scale.isBlank() || !axis.containData(newValue)) {
	    return;
	  }
	
	  if (!axisInfo.involveSeries) {
	    updaters.showPointer(axisInfo, newValue);
	    return;
	  } // Heavy calculation. So put it after axis.containData checking.
	
	
	  var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
	  var payloadBatch = payloadInfo.payloadBatch;
	  var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
	  // By default use the first involved series data as a sample to connect.
	
	  if (payloadBatch[0] && outputFinder.seriesIndex == null) {
	    zrUtil.extend(outputFinder, payloadBatch[0]);
	  } // If no linkSource input, this process is for collecting link
	  // target, where snap should not be accepted.
	
	
	  if (!dontSnap && axisInfo.snap) {
	    if (axis.containData(snapToValue) && snapToValue != null) {
	      newValue = snapToValue;
	    }
	  }
	
	  updaters.showPointer(axisInfo, newValue, payloadBatch, outputFinder); // Tooltip should always be snapToValue, otherwise there will be
	  // incorrect "axis value ~ series value" mapping displayed in tooltip.
	
	  updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
	}
	
	function buildPayloadsBySeries(value, axisInfo) {
	  var axis = axisInfo.axis;
	  var dim = axis.dim;
	  var snapToValue = value;
	  var payloadBatch = [];
	  var minDist = Number.MAX_VALUE;
	  var minDiff = -1;
	  each(axisInfo.seriesModels, function (series, idx) {
	    var dataDim = series.getData().mapDimension(dim, true);
	    var seriesNestestValue;
	    var dataIndices;
	
	    if (series.getAxisTooltipData) {
	      var result = series.getAxisTooltipData(dataDim, value, axis);
	      dataIndices = result.dataIndices;
	      seriesNestestValue = result.nestestValue;
	    } else {
	      dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
	      // when data length is not same.
	      // false,
	      axis.type === 'category' ? 0.5 : null);
	
	      if (!dataIndices.length) {
	        return;
	      }
	
	      seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
	    }
	
	    if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
	      return;
	    }
	
	    var diff = value - seriesNestestValue;
	    var dist = Math.abs(diff); // Consider category case
	
	    if (dist <= minDist) {
	      if (dist < minDist || diff >= 0 && minDiff < 0) {
	        minDist = dist;
	        minDiff = diff;
	        snapToValue = seriesNestestValue;
	        payloadBatch.length = 0;
	      }
	
	      each(dataIndices, function (dataIndex) {
	        payloadBatch.push({
	          seriesIndex: series.seriesIndex,
	          dataIndexInside: dataIndex,
	          dataIndex: series.getData().getRawIndex(dataIndex)
	        });
	      });
	    }
	  });
	  return {
	    payloadBatch: payloadBatch,
	    snapToValue: snapToValue
	  };
	}
	
	function showPointer(showValueMap, axisInfo, value, payloadBatch) {
	  showValueMap[axisInfo.key] = {
	    value: value,
	    payloadBatch: payloadBatch
	  };
	}
	
	function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
	  var payloadBatch = payloadInfo.payloadBatch;
	  var axis = axisInfo.axis;
	  var axisModel = axis.model;
	  var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
	  // whose length will be used to judge whether dispatch action.
	
	  if (!axisInfo.triggerTooltip || !payloadBatch.length) {
	    return;
	  }
	
	  var coordSysModel = axisInfo.coordSys.model;
	  var coordSysKey = modelHelper.makeKey(coordSysModel);
	  var coordSysItem = dataByCoordSys.map[coordSysKey];
	
	  if (!coordSysItem) {
	    coordSysItem = dataByCoordSys.map[coordSysKey] = {
	      coordSysId: coordSysModel.id,
	      coordSysIndex: coordSysModel.componentIndex,
	      coordSysType: coordSysModel.type,
	      coordSysMainType: coordSysModel.mainType,
	      dataByAxis: []
	    };
	    dataByCoordSys.list.push(coordSysItem);
	  }
	
	  coordSysItem.dataByAxis.push({
	    axisDim: axis.dim,
	    axisIndex: axisModel.componentIndex,
	    axisType: axisModel.type,
	    axisId: axisModel.id,
	    value: value,
	    // Caustion: viewHelper.getValueLabel is actually on "view stage", which
	    // depends that all models have been updated. So it should not be performed
	    // here. Considering axisPointerModel used here is volatile, which is hard
	    // to be retrieve in TooltipView, we prepare parameters here.
	    valueLabelOpt: {
	      precision: axisPointerModel.get('label.precision'),
	      formatter: axisPointerModel.get('label.formatter')
	    },
	    seriesDataIndices: payloadBatch.slice()
	  });
	}
	
	function updateModelActually(showValueMap, axesInfo, outputFinder) {
	  var outputAxesInfo = outputFinder.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.
	
	  each(axesInfo, function (axisInfo, key) {
	    var option = axisInfo.axisPointerModel.option;
	    var valItem = showValueMap[key];
	
	    if (valItem) {
	      !axisInfo.useHandle && (option.status = 'show');
	      option.value = valItem.value; // For label formatter param and highlight.
	
	      option.seriesDataIndices = (valItem.payloadBatch || []).slice();
	    } // When always show (e.g., handle used), remain
	    // original value and status.
	    else {
	        // If hide, value still need to be set, consider
	        // click legend to toggle axis blank.
	        !axisInfo.useHandle && (option.status = 'hide');
	      } // If status is 'hide', should be no info in payload.
	
	
	    option.status === 'show' && outputAxesInfo.push({
	      axisDim: axisInfo.axis.dim,
	      axisIndex: axisInfo.axis.model.componentIndex,
	      value: option.value
	    });
	  });
	}
	
	function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
	  // Basic logic: If no showTip required, hideTip will be dispatched.
	  if (illegalPoint(point) || !dataByCoordSys.list.length) {
	    dispatchAction({
	      type: 'hideTip'
	    });
	    return;
	  } // In most case only one axis (or event one series is used). It is
	  // convinient to fetch payload.seriesIndex and payload.dataIndex
	  // dirtectly. So put the first seriesIndex and dataIndex of the first
	  // axis on the payload.
	
	
	  var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
	  dispatchAction({
	    type: 'showTip',
	    escapeConnect: true,
	    x: point[0],
	    y: point[1],
	    tooltipOption: payload.tooltipOption,
	    position: payload.position,
	    dataIndexInside: sampleItem.dataIndexInside,
	    dataIndex: sampleItem.dataIndex,
	    seriesIndex: sampleItem.seriesIndex,
	    dataByCoordSys: dataByCoordSys.list
	  });
	}
	
	function dispatchHighDownActually(axesInfo, dispatchAction, api) {
	  // FIXME
	  // highlight status modification shoule be a stage of main process?
	  // (Consider confilct (e.g., legend and axisPointer) and setOption)
	  var zr = api.getZr();
	  var highDownKey = 'axisPointerLastHighlights';
	  var lastHighlights = inner(zr)[highDownKey] || {};
	  var newHighlights = inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
	  // Build hash map and remove duplicate incidentally.
	
	  each(axesInfo, function (axisInfo, key) {
	    var option = axisInfo.axisPointerModel.option;
	    option.status === 'show' && each(option.seriesDataIndices, function (batchItem) {
	      var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
	      newHighlights[key] = batchItem;
	    });
	  }); // Diff.
	
	  var toHighlight = [];
	  var toDownplay = [];
	  zrUtil.each(lastHighlights, function (batchItem, key) {
	    !newHighlights[key] && toDownplay.push(batchItem);
	  });
	  zrUtil.each(newHighlights, function (batchItem, key) {
	    !lastHighlights[key] && toHighlight.push(batchItem);
	  });
	  toDownplay.length && api.dispatchAction({
	    type: 'downplay',
	    escapeConnect: true,
	    batch: toDownplay
	  });
	  toHighlight.length && api.dispatchAction({
	    type: 'highlight',
	    escapeConnect: true,
	    batch: toHighlight
	  });
	}
	
	function findInputAxisInfo(inputAxesInfo, axisInfo) {
	  for (var i = 0; i < (inputAxesInfo || []).length; i++) {
	    var inputAxisInfo = inputAxesInfo[i];
	
	    if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
	      return inputAxisInfo;
	    }
	  }
	}
	
	function makeMapperParam(axisInfo) {
	  var axisModel = axisInfo.axis.model;
	  var item = {};
	  var dim = item.axisDim = axisInfo.axis.dim;
	  item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
	  item.axisName = item[dim + 'AxisName'] = axisModel.name;
	  item.axisId = item[dim + 'AxisId'] = axisModel.id;
	  return item;
	}
	
	function illegalPoint(point) {
	  return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
	}
	
	module.exports = _default;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var modelUtil = __webpack_require__(261);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} finder contains {seriesIndex, dataIndex, dataIndexInside}
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object} {point: [x, y], el: ...} point Will not be null.
	 */
	function _default(finder, ecModel) {
	  var point = [];
	  var seriesIndex = finder.seriesIndex;
	  var seriesModel;
	
	  if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
	    return {
	      point: []
	    };
	  }
	
	  var data = seriesModel.getData();
	  var dataIndex = modelUtil.queryDataIndex(data, finder);
	
	  if (dataIndex == null || dataIndex < 0 || zrUtil.isArray(dataIndex)) {
	    return {
	      point: []
	    };
	  }
	
	  var el = data.getItemGraphicEl(dataIndex);
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (seriesModel.getTooltipPosition) {
	    point = seriesModel.getTooltipPosition(dataIndex) || [];
	  } else if (coordSys && coordSys.dataToPoint) {
	    point = coordSys.dataToPoint(data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
	      return data.mapDimension(dim);
	    }), dataIndex, true)) || [];
	  } else if (el) {
	    // Use graphic bounding rect
	    var rect = el.getBoundingRect().clone();
	    rect.applyTransform(el.transform);
	    point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  }
	
	  return {
	    point: point,
	    el: el
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisPointerModel = echarts.extendComponentModel({
	  type: 'axisPointer',
	  coordSysAxesInfo: null,
	  defaultOption: {
	    // 'auto' means that show when triggered by tooltip or handle.
	    show: 'auto',
	    // 'click' | 'mousemove' | 'none'
	    triggerOn: null,
	    // set default in AxisPonterView.js
	    zlevel: 0,
	    z: 50,
	    type: 'line',
	    // 'line' 'shadow' 'cross' 'none'.
	    // axispointer triggered by tootip determine snap automatically,
	    // see `modelHelper`.
	    snap: false,
	    triggerTooltip: true,
	    value: null,
	    status: null,
	    // Init value depends on whether handle is used.
	    // [group0, group1, ...]
	    // Each group can be: {
	    //      mapper: function () {},
	    //      singleTooltip: 'multiple',  // 'multiple' or 'single'
	    //      xAxisId: ...,
	    //      yAxisName: ...,
	    //      angleAxisIndex: ...
	    // }
	    // mapper: can be ignored.
	    //      input: {axisInfo, value}
	    //      output: {axisInfo, value}
	    link: [],
	    // Do not set 'auto' here, otherwise global animation: false
	    // will not effect at this axispointer.
	    animation: null,
	    animationDurationUpdate: 200,
	    lineStyle: {
	      color: '#aaa',
	      width: 1,
	      type: 'solid'
	    },
	    shadowStyle: {
	      color: 'rgba(150,150,150,0.3)'
	    },
	    label: {
	      show: true,
	      formatter: null,
	      // string | Function
	      precision: 'auto',
	      // Or a number like 0, 1, 2 ...
	      margin: 3,
	      color: '#fff',
	      padding: [5, 7, 5, 7],
	      backgroundColor: 'auto',
	      // default: axis line color
	      borderColor: null,
	      borderWidth: 0,
	      shadowBlur: 3,
	      shadowColor: '#aaa' // Considering applicability, common style should
	      // better not have shadowOffset.
	      // shadowOffsetX: 0,
	      // shadowOffsetY: 2
	
	    },
	    handle: {
	      show: false,
	
	      /* eslint-disable */
	      icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
	      // jshint ignore:line
	
	      /* eslint-enable */
	      size: 45,
	      // handle margin is from symbol center to axis, which is stable when circular move.
	      margin: 50,
	      // color: '#1b8bbd'
	      // color: '#2f4554'
	      color: '#333',
	      shadowBlur: 3,
	      shadowColor: '#aaa',
	      shadowOffsetX: 0,
	      shadowOffsetY: 2,
	      // For mobile performance
	      throttle: 40
	    }
	  }
	});
	var _default = AxisPointerModel;
	module.exports = _default;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var globalListener = __webpack_require__(569);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisPointerView = echarts.extendComponentView({
	  type: 'axisPointer',
	  render: function (globalAxisPointerModel, ecModel, api) {
	    var globalTooltipModel = ecModel.getComponent('tooltip');
	    var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
	    // AxisPointerView to be independent to Tooltip.
	
	    globalListener.register('axisPointer', api, function (currTrigger, e, dispatchAction) {
	      // If 'none', it is not controlled by mouse totally.
	      if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
	        dispatchAction({
	          type: 'updateAxisPointer',
	          currTrigger: currTrigger,
	          x: e && e.offsetX,
	          y: e && e.offsetY
	        });
	      }
	    });
	  },
	
	  /**
	   * @override
	   */
	  remove: function (ecModel, api) {
	    globalListener.unregister(api.getZr(), 'axisPointer');
	    AxisPointerView.superApply(this._model, 'remove', arguments);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function (ecModel, api) {
	    globalListener.unregister('axisPointer', api);
	    AxisPointerView.superApply(this._model, 'dispose', arguments);
	  }
	});
	var _default = AxisPointerView;
	module.exports = _default;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var env = __webpack_require__(219);
	
	var _model = __webpack_require__(261);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var each = zrUtil.each;
	/**
	 * @param {string} key
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Function} handler
	 *      param: {string} currTrigger
	 *      param: {Array.<number>} point
	 */
	
	function register(key, api, handler) {
	  if (env.node) {
	    return;
	  }
	
	  var zr = api.getZr();
	  inner(zr).records || (inner(zr).records = {});
	  initGlobalListeners(zr, api);
	  var record = inner(zr).records[key] || (inner(zr).records[key] = {});
	  record.handler = handler;
	}
	
	function initGlobalListeners(zr, api) {
	  if (inner(zr).initialized) {
	    return;
	  }
	
	  inner(zr).initialized = true;
	  useHandler('click', zrUtil.curry(doEnter, 'click'));
	  useHandler('mousemove', zrUtil.curry(doEnter, 'mousemove')); // useHandler('mouseout', onLeave);
	
	  useHandler('globalout', onLeave);
	
	  function useHandler(eventType, cb) {
	    zr.on(eventType, function (e) {
	      var dis = makeDispatchAction(api);
	      each(inner(zr).records, function (record) {
	        record && cb(record, e, dis.dispatchAction);
	      });
	      dispatchTooltipFinally(dis.pendings, api);
	    });
	  }
	}
	
	function dispatchTooltipFinally(pendings, api) {
	  var showLen = pendings.showTip.length;
	  var hideLen = pendings.hideTip.length;
	  var actuallyPayload;
	
	  if (showLen) {
	    actuallyPayload = pendings.showTip[showLen - 1];
	  } else if (hideLen) {
	    actuallyPayload = pendings.hideTip[hideLen - 1];
	  }
	
	  if (actuallyPayload) {
	    actuallyPayload.dispatchAction = null;
	    api.dispatchAction(actuallyPayload);
	  }
	}
	
	function onLeave(record, e, dispatchAction) {
	  record.handler('leave', null, dispatchAction);
	}
	
	function doEnter(currTrigger, record, e, dispatchAction) {
	  record.handler(currTrigger, e, dispatchAction);
	}
	
	function makeDispatchAction(api) {
	  var pendings = {
	    showTip: [],
	    hideTip: []
	  }; // FIXME
	  // better approach?
	  // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
	  // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
	  // So we have to add "final stage" to merge those dispatched actions.
	
	  var dispatchAction = function (payload) {
	    var pendingList = pendings[payload.type];
	
	    if (pendingList) {
	      pendingList.push(payload);
	    } else {
	      payload.dispatchAction = dispatchAction;
	      api.dispatchAction(payload);
	    }
	  };
	
	  return {
	    dispatchAction: dispatchAction,
	    pendings: pendings
	  };
	}
	/**
	 * @param {string} key
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function unregister(key, api) {
	  if (env.node) {
	    return;
	  }
	
	  var zr = api.getZr();
	  var record = (inner(zr).records || {})[key];
	
	  if (record) {
	    inner(zr).records[key] = null;
	  }
	}
	
	exports.register = register;
	exports.unregister = unregister;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseAxisPointer = __webpack_require__(571);
	
	var viewHelper = __webpack_require__(572);
	
	var cartesianAxisHelper = __webpack_require__(393);
	
	var AxisView = __webpack_require__(391);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CartesianAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	    var grid = axis.grid;
	    var axisPointerType = axisPointerModel.get('type');
	    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	    var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var layoutInfo = cartesianAxisHelper.layout(grid.model, axisModel);
	    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	  },
	
	  /**
	   * @override
	   */
	  getHandleTransform: function (value, axisModel, axisPointerModel) {
	    var layoutInfo = cartesianAxisHelper.layout(axisModel.axis.grid.model, axisModel, {
	      labelInside: false
	    });
	    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
	    return {
	      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
	      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	    };
	  },
	
	  /**
	   * @override
	   */
	  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
	    var axis = axisModel.axis;
	    var grid = axis.grid;
	    var axisExtent = axis.getGlobalExtent(true);
	    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	    var dimIndex = axis.dim === 'x' ? 0 : 1;
	    var currPosition = transform.position;
	    currPosition[dimIndex] += delta[dimIndex];
	    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	    var cursorPoint = [cursorOtherValue, cursorOtherValue];
	    cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.
	
	    var tooltipOptions = [{
	      verticalAlign: 'middle'
	    }, {
	      align: 'center'
	    }];
	    return {
	      position: currPosition,
	      rotation: transform.rotation,
	      cursorPoint: cursorPoint,
	      tooltipOption: tooltipOptions[dimIndex]
	    };
	  }
	});
	
	function getCartesian(grid, axis) {
	  var opt = {};
	  opt[axis.dim + 'AxisIndex'] = axis.index;
	  return grid.getCartesian(opt);
	}
	
	var pointerShapeBuilder = {
	  line: function (axis, pixelValue, otherExtent) {
	    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
	    return {
	      type: 'Line',
	      subPixelOptimize: true,
	      shape: targetShape
	    };
	  },
	  shadow: function (axis, pixelValue, otherExtent) {
	    var bandWidth = Math.max(1, axis.getBandWidth());
	    var span = otherExtent[1] - otherExtent[0];
	    return {
	      type: 'Rect',
	      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
	    };
	  }
	};
	
	function getAxisDimIndex(axis) {
	  return axis.dim === 'x' ? 0 : 1;
	}
	
	AxisView.registerAxisPointerClass('CartesianAxisPointer', CartesianAxisPointer);
	var _default = CartesianAxisPointer;
	module.exports = _default;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var clazzUtil = __webpack_require__(263);
	
	var graphic = __webpack_require__(268);
	
	var axisPointerModelHelper = __webpack_require__(392);
	
	var eventTool = __webpack_require__(225);
	
	var throttleUtil = __webpack_require__(327);
	
	var _model = __webpack_require__(261);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var clone = zrUtil.clone;
	var bind = zrUtil.bind;
	/**
	 * Base axis pointer class in 2D.
	 * Implemenents {module:echarts/component/axis/IAxisPointer}.
	 */
	
	function BaseAxisPointer() {}
	
	BaseAxisPointer.prototype = {
	  /**
	   * @private
	   */
	  _group: null,
	
	  /**
	   * @private
	   */
	  _lastGraphicKey: null,
	
	  /**
	   * @private
	   */
	  _handle: null,
	
	  /**
	   * @private
	   */
	  _dragging: false,
	
	  /**
	   * @private
	   */
	  _lastValue: null,
	
	  /**
	   * @private
	   */
	  _lastStatus: null,
	
	  /**
	   * @private
	   */
	  _payloadInfo: null,
	
	  /**
	   * In px, arbitrary value. Do not set too small,
	   * no animation is ok for most cases.
	   * @protected
	   */
	  animationThreshold: 15,
	
	  /**
	   * @implement
	   */
	  render: function (axisModel, axisPointerModel, api, forceRender) {
	    var value = axisPointerModel.get('value');
	    var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
	    // be replaced when user calling setOption in not merge mode.
	
	    this._axisModel = axisModel;
	    this._axisPointerModel = axisPointerModel;
	    this._api = api; // Optimize: `render` will be called repeatly during mouse move.
	    // So it is power consuming if performing `render` each time,
	    // especially on mobile device.
	
	    if (!forceRender && this._lastValue === value && this._lastStatus === status) {
	      return;
	    }
	
	    this._lastValue = value;
	    this._lastStatus = status;
	    var group = this._group;
	    var handle = this._handle;
	
	    if (!status || status === 'hide') {
	      // Do not clear here, for animation better.
	      group && group.hide();
	      handle && handle.hide();
	      return;
	    }
	
	    group && group.show();
	    handle && handle.show(); // Otherwise status is 'show'
	
	    var elOption = {};
	    this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.
	
	    var graphicKey = elOption.graphicKey;
	
	    if (graphicKey !== this._lastGraphicKey) {
	      this.clear(api);
	    }
	
	    this._lastGraphicKey = graphicKey;
	    var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
	
	    if (!group) {
	      group = this._group = new graphic.Group();
	      this.createPointerEl(group, elOption, axisModel, axisPointerModel);
	      this.createLabelEl(group, elOption, axisModel, axisPointerModel);
	      api.getZr().add(group);
	    } else {
	      var doUpdateProps = zrUtil.curry(updateProps, axisPointerModel, moveAnimation);
	      this.updatePointerEl(group, elOption, doUpdateProps, axisPointerModel);
	      this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
	    }
	
	    updateMandatoryProps(group, axisPointerModel, true);
	
	    this._renderHandle(value);
	  },
	
	  /**
	   * @implement
	   */
	  remove: function (api) {
	    this.clear(api);
	  },
	
	  /**
	   * @implement
	   */
	  dispose: function (api) {
	    this.clear(api);
	  },
	
	  /**
	   * @protected
	   */
	  determineAnimation: function (axisModel, axisPointerModel) {
	    var animation = axisPointerModel.get('animation');
	    var axis = axisModel.axis;
	    var isCategoryAxis = axis.type === 'category';
	    var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.
	
	    if (!useSnap && !isCategoryAxis) {
	      return false;
	    }
	
	    if (animation === 'auto' || animation == null) {
	      var animationThreshold = this.animationThreshold;
	
	      if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
	        return true;
	      } // It is important to auto animation when snap used. Consider if there is
	      // a dataZoom, animation will be disabled when too many points exist, while
	      // it will be enabled for better visual effect when little points exist.
	
	
	      if (useSnap) {
	        var seriesDataCount = axisPointerModelHelper.getAxisInfo(axisModel).seriesDataCount;
	        var axisExtent = axis.getExtent(); // Approximate band width
	
	        return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
	      }
	
	      return false;
	    }
	
	    return animation === true;
	  },
	
	  /**
	   * add {pointer, label, graphicKey} to elOption
	   * @protected
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {// Shoule be implemenented by sub-class.
	  },
	
	  /**
	   * @protected
	   */
	  createPointerEl: function (group, elOption, axisModel, axisPointerModel) {
	    var pointerOption = elOption.pointer;
	
	    if (pointerOption) {
	      var pointerEl = inner(group).pointerEl = new graphic[pointerOption.type](clone(elOption.pointer));
	      group.add(pointerEl);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  createLabelEl: function (group, elOption, axisModel, axisPointerModel) {
	    if (elOption.label) {
	      var labelEl = inner(group).labelEl = new graphic.Rect(clone(elOption.label));
	      group.add(labelEl);
	      updateLabelShowHide(labelEl, axisPointerModel);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  updatePointerEl: function (group, elOption, updateProps) {
	    var pointerEl = inner(group).pointerEl;
	
	    if (pointerEl && elOption.pointer) {
	      pointerEl.setStyle(elOption.pointer.style);
	      updateProps(pointerEl, {
	        shape: elOption.pointer.shape
	      });
	    }
	  },
	
	  /**
	   * @protected
	   */
	  updateLabelEl: function (group, elOption, updateProps, axisPointerModel) {
	    var labelEl = inner(group).labelEl;
	
	    if (labelEl) {
	      labelEl.setStyle(elOption.label.style);
	      updateProps(labelEl, {
	        // Consider text length change in vertical axis, animation should
	        // be used on shape, otherwise the effect will be weird.
	        shape: elOption.label.shape,
	        position: elOption.label.position
	      });
	      updateLabelShowHide(labelEl, axisPointerModel);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderHandle: function (value) {
	    if (this._dragging || !this.updateHandleTransform) {
	      return;
	    }
	
	    var axisPointerModel = this._axisPointerModel;
	
	    var zr = this._api.getZr();
	
	    var handle = this._handle;
	    var handleModel = axisPointerModel.getModel('handle');
	    var status = axisPointerModel.get('status');
	
	    if (!handleModel.get('show') || !status || status === 'hide') {
	      handle && zr.remove(handle);
	      this._handle = null;
	      return;
	    }
	
	    var isInit;
	
	    if (!this._handle) {
	      isInit = true;
	      handle = this._handle = graphic.createIcon(handleModel.get('icon'), {
	        cursor: 'move',
	        draggable: true,
	        onmousemove: function (e) {
	          // Fot mobile devicem, prevent screen slider on the button.
	          eventTool.stop(e.event);
	        },
	        onmousedown: bind(this._onHandleDragMove, this, 0, 0),
	        drift: bind(this._onHandleDragMove, this),
	        ondragend: bind(this._onHandleDragEnd, this)
	      });
	      zr.add(handle);
	    }
	
	    updateMandatoryProps(handle, axisPointerModel, false); // update style
	
	    var includeStyles = ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
	    handle.setStyle(handleModel.getItemStyle(null, includeStyles)); // update position
	
	    var handleSize = handleModel.get('size');
	
	    if (!zrUtil.isArray(handleSize)) {
	      handleSize = [handleSize, handleSize];
	    }
	
	    handle.attr('scale', [handleSize[0] / 2, handleSize[1] / 2]);
	    throttleUtil.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
	
	    this._moveHandleToValue(value, isInit);
	  },
	
	  /**
	   * @private
	   */
	  _moveHandleToValue: function (value, isInit) {
	    updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
	  },
	
	  /**
	   * @private
	   */
	  _onHandleDragMove: function (dx, dy) {
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    this._dragging = true; // Persistent for throttle.
	
	    var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
	    this._payloadInfo = trans;
	    handle.stopAnimation();
	    handle.attr(getHandleTransProps(trans));
	    inner(handle).lastProp = null;
	
	    this._doDispatchAxisPointer();
	  },
	
	  /**
	   * Throttled method.
	   * @private
	   */
	  _doDispatchAxisPointer: function () {
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    var payloadInfo = this._payloadInfo;
	    var axisModel = this._axisModel;
	
	    this._api.dispatchAction({
	      type: 'updateAxisPointer',
	      x: payloadInfo.cursorPoint[0],
	      y: payloadInfo.cursorPoint[1],
	      tooltipOption: payloadInfo.tooltipOption,
	      axesInfo: [{
	        axisDim: axisModel.axis.dim,
	        axisIndex: axisModel.componentIndex
	      }]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _onHandleDragEnd: function (moveAnimation) {
	    this._dragging = false;
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
	    // axisPointer. So move handle to align the exact value position when
	    // drag ended.
	
	
	    this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
	    // button, and will be hidden after finger left handle button.
	
	
	    this._api.dispatchAction({
	      type: 'hideTip'
	    });
	  },
	
	  /**
	   * Should be implemenented by sub-class if support `handle`.
	   * @protected
	   * @param {number} value
	   * @param {module:echarts/model/Model} axisModel
	   * @param {module:echarts/model/Model} axisPointerModel
	   * @return {Object} {position: [x, y], rotation: 0}
	   */
	  getHandleTransform: null,
	
	  /**
	   * * Should be implemenented by sub-class if support `handle`.
	   * @protected
	   * @param {Object} transform {position, rotation}
	   * @param {Array.<number>} delta [dx, dy]
	   * @param {module:echarts/model/Model} axisModel
	   * @param {module:echarts/model/Model} axisPointerModel
	   * @return {Object} {position: [x, y], rotation: 0, cursorPoint: [x, y]}
	   */
	  updateHandleTransform: null,
	
	  /**
	   * @private
	   */
	  clear: function (api) {
	    this._lastValue = null;
	    this._lastStatus = null;
	    var zr = api.getZr();
	    var group = this._group;
	    var handle = this._handle;
	
	    if (zr && group) {
	      this._lastGraphicKey = null;
	      group && zr.remove(group);
	      handle && zr.remove(handle);
	      this._group = null;
	      this._handle = null;
	      this._payloadInfo = null;
	    }
	  },
	
	  /**
	   * @protected
	   */
	  doClear: function () {// Implemented by sub-class if necessary.
	  },
	
	  /**
	   * @protected
	   * @param {Array.<number>} xy
	   * @param {Array.<number>} wh
	   * @param {number} [xDimIndex=0] or 1
	   */
	  buildLabel: function (xy, wh, xDimIndex) {
	    xDimIndex = xDimIndex || 0;
	    return {
	      x: xy[xDimIndex],
	      y: xy[1 - xDimIndex],
	      width: wh[xDimIndex],
	      height: wh[1 - xDimIndex]
	    };
	  }
	};
	BaseAxisPointer.prototype.constructor = BaseAxisPointer;
	
	function updateProps(animationModel, moveAnimation, el, props) {
	  // Animation optimize.
	  if (!propsEqual(inner(el).lastProp, props)) {
	    inner(el).lastProp = props;
	    moveAnimation ? graphic.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
	  }
	}
	
	function propsEqual(lastProps, newProps) {
	  if (zrUtil.isObject(lastProps) && zrUtil.isObject(newProps)) {
	    var equals = true;
	    zrUtil.each(newProps, function (item, key) {
	      equals = equals && propsEqual(lastProps[key], item);
	    });
	    return !!equals;
	  } else {
	    return lastProps === newProps;
	  }
	}
	
	function updateLabelShowHide(labelEl, axisPointerModel) {
	  labelEl[axisPointerModel.get('label.show') ? 'show' : 'hide']();
	}
	
	function getHandleTransProps(trans) {
	  return {
	    position: trans.position.slice(),
	    rotation: trans.rotation || 0
	  };
	}
	
	function updateMandatoryProps(group, axisPointerModel, silent) {
	  var z = axisPointerModel.get('z');
	  var zlevel = axisPointerModel.get('zlevel');
	  group && group.traverse(function (el) {
	    if (el.type !== 'group') {
	      z != null && (el.z = z);
	      zlevel != null && (el.zlevel = zlevel);
	      el.silent = silent;
	    }
	  });
	}
	
	clazzUtil.enableClassExtend(BaseAxisPointer);
	var _default = BaseAxisPointer;
	module.exports = _default;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var textContain = __webpack_require__(255);
	
	var formatUtil = __webpack_require__(307);
	
	var matrix = __webpack_require__(233);
	
	var axisHelper = __webpack_require__(350);
	
	var AxisBuilder = __webpack_require__(390);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/model/Model} axisPointerModel
	 */
	function buildElStyle(axisPointerModel) {
	  var axisPointerType = axisPointerModel.get('type');
	  var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
	  var style;
	
	  if (axisPointerType === 'line') {
	    style = styleModel.getLineStyle();
	    style.fill = null;
	  } else if (axisPointerType === 'shadow') {
	    style = styleModel.getAreaStyle();
	    style.stroke = null;
	  }
	
	  return style;
	}
	/**
	 * @param {Function} labelPos {align, verticalAlign, position}
	 */
	
	
	function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
	  var value = axisPointerModel.get('value');
	  var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
	    precision: axisPointerModel.get('label.precision'),
	    formatter: axisPointerModel.get('label.formatter')
	  });
	  var labelModel = axisPointerModel.getModel('label');
	  var paddings = formatUtil.normalizeCssArray(labelModel.get('padding') || 0);
	  var font = labelModel.getFont();
	  var textRect = textContain.getBoundingRect(text, font);
	  var position = labelPos.position;
	  var width = textRect.width + paddings[1] + paddings[3];
	  var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.
	
	  var align = labelPos.align;
	  align === 'right' && (position[0] -= width);
	  align === 'center' && (position[0] -= width / 2);
	  var verticalAlign = labelPos.verticalAlign;
	  verticalAlign === 'bottom' && (position[1] -= height);
	  verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container
	
	  confineInContainer(position, width, height, api);
	  var bgColor = labelModel.get('backgroundColor');
	
	  if (!bgColor || bgColor === 'auto') {
	    bgColor = axisModel.get('axisLine.lineStyle.color');
	  }
	
	  elOption.label = {
	    shape: {
	      x: 0,
	      y: 0,
	      width: width,
	      height: height,
	      r: labelModel.get('borderRadius')
	    },
	    position: position.slice(),
	    // TODO: rich
	    style: {
	      text: text,
	      textFont: font,
	      textFill: labelModel.getTextColor(),
	      textPosition: 'inside',
	      textPadding: paddings,
	      fill: bgColor,
	      stroke: labelModel.get('borderColor') || 'transparent',
	      lineWidth: labelModel.get('borderWidth') || 0,
	      shadowBlur: labelModel.get('shadowBlur'),
	      shadowColor: labelModel.get('shadowColor'),
	      shadowOffsetX: labelModel.get('shadowOffsetX'),
	      shadowOffsetY: labelModel.get('shadowOffsetY')
	    },
	    // Lable should be over axisPointer.
	    z2: 10
	  };
	} // Do not overflow ec container
	
	
	function confineInContainer(position, width, height, api) {
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  position[0] = Math.min(position[0] + width, viewWidth) - width;
	  position[1] = Math.min(position[1] + height, viewHeight) - height;
	  position[0] = Math.max(position[0], 0);
	  position[1] = Math.max(position[1], 0);
	}
	/**
	 * @param {number} value
	 * @param {module:echarts/coord/Axis} axis
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} opt
	 * @param {Array.<Object>} seriesDataIndices
	 * @param {number|string} opt.precision 'auto' or a number
	 * @param {string|Function} opt.formatter label formatter
	 */
	
	
	function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
	  value = axis.scale.parse(value);
	  var text = axis.scale.getLabel( // If `precision` is set, width can be fixed (like '12.00500'), which
	  // helps to debounce when when moving label.
	  value, {
	    precision: opt.precision
	  });
	  var formatter = opt.formatter;
	
	  if (formatter) {
	    var params = {
	      value: axisHelper.getAxisRawValue(axis, value),
	      axisDimension: axis.dim,
	      axisIndex: axis.index,
	      seriesData: []
	    };
	    zrUtil.each(seriesDataIndices, function (idxItem) {
	      var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	      var dataIndex = idxItem.dataIndexInside;
	      var dataParams = series && series.getDataParams(dataIndex);
	      dataParams && params.seriesData.push(dataParams);
	    });
	
	    if (zrUtil.isString(formatter)) {
	      text = formatter.replace('{value}', text);
	    } else if (zrUtil.isFunction(formatter)) {
	      text = formatter(params);
	    }
	  }
	
	  return text;
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @param {number} value
	 * @param {Object} layoutInfo {
	 *  rotation, position, labelOffset, labelDirection, labelMargin
	 * }
	 */
	
	
	function getTransformedPosition(axis, value, layoutInfo) {
	  var transform = matrix.create();
	  matrix.rotate(transform, transform, layoutInfo.rotation);
	  matrix.translate(transform, transform, layoutInfo.position);
	  return graphic.applyTransform([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
	}
	
	function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
	  var textLayout = AxisBuilder.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
	  layoutInfo.labelMargin = axisPointerModel.get('label.margin');
	  buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
	    position: getTransformedPosition(axisModel.axis, value, layoutInfo),
	    align: textLayout.textAlign,
	    verticalAlign: textLayout.textVerticalAlign
	  });
	}
	/**
	 * @param {Array.<number>} p1
	 * @param {Array.<number>} p2
	 * @param {number} [xDimIndex=0] or 1
	 */
	
	
	function makeLineShape(p1, p2, xDimIndex) {
	  xDimIndex = xDimIndex || 0;
	  return {
	    x1: p1[xDimIndex],
	    y1: p1[1 - xDimIndex],
	    x2: p2[xDimIndex],
	    y2: p2[1 - xDimIndex]
	  };
	}
	/**
	 * @param {Array.<number>} xy
	 * @param {Array.<number>} wh
	 * @param {number} [xDimIndex=0] or 1
	 */
	
	
	function makeRectShape(xy, wh, xDimIndex) {
	  xDimIndex = xDimIndex || 0;
	  return {
	    x: xy[xDimIndex],
	    y: xy[1 - xDimIndex],
	    width: wh[xDimIndex],
	    height: wh[1 - xDimIndex]
	  };
	}
	
	function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
	  return {
	    cx: cx,
	    cy: cy,
	    r0: r0,
	    r: r,
	    startAngle: startAngle,
	    endAngle: endAngle,
	    clockwise: true
	  };
	}
	
	exports.buildElStyle = buildElStyle;
	exports.buildLabelElOption = buildLabelElOption;
	exports.getValueLabel = getValueLabel;
	exports.getTransformedPosition = getTransformedPosition;
	exports.buildCartesianSingleLabelElOption = buildCartesianSingleLabelElOption;
	exports.makeLineShape = makeLineShape;
	exports.makeRectShape = makeRectShape;
	exports.makeSectorShape = makeSectorShape;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseAxisPointer = __webpack_require__(571);
	
	var viewHelper = __webpack_require__(572);
	
	var singleAxisHelper = __webpack_require__(562);
	
	var AxisView = __webpack_require__(391);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var XY = ['x', 'y'];
	var WH = ['width', 'height'];
	var SingleAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	    var coordSys = axis.coordinateSystem;
	    var otherExtent = getGlobalExtent(coordSys, 1 - getPointDimIndex(axis));
	    var pixelValue = coordSys.dataToPoint(value)[0];
	    var axisPointerType = axisPointerModel.get('type');
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var layoutInfo = singleAxisHelper.layout(axisModel);
	    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	  },
	
	  /**
	   * @override
	   */
	  getHandleTransform: function (value, axisModel, axisPointerModel) {
	    var layoutInfo = singleAxisHelper.layout(axisModel, {
	      labelInside: false
	    });
	    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
	    return {
	      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
	      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	    };
	  },
	
	  /**
	   * @override
	   */
	  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
	    var axis = axisModel.axis;
	    var coordSys = axis.coordinateSystem;
	    var dimIndex = getPointDimIndex(axis);
	    var axisExtent = getGlobalExtent(coordSys, dimIndex);
	    var currPosition = transform.position;
	    currPosition[dimIndex] += delta[dimIndex];
	    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	    var otherExtent = getGlobalExtent(coordSys, 1 - dimIndex);
	    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	    var cursorPoint = [cursorOtherValue, cursorOtherValue];
	    cursorPoint[dimIndex] = currPosition[dimIndex];
	    return {
	      position: currPosition,
	      rotation: transform.rotation,
	      cursorPoint: cursorPoint,
	      tooltipOption: {
	        verticalAlign: 'middle'
	      }
	    };
	  }
	});
	var pointerShapeBuilder = {
	  line: function (axis, pixelValue, otherExtent) {
	    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getPointDimIndex(axis));
	    return {
	      type: 'Line',
	      subPixelOptimize: true,
	      shape: targetShape
	    };
	  },
	  shadow: function (axis, pixelValue, otherExtent) {
	    var bandWidth = axis.getBandWidth();
	    var span = otherExtent[1] - otherExtent[0];
	    return {
	      type: 'Rect',
	      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getPointDimIndex(axis))
	    };
	  }
	};
	
	function getPointDimIndex(axis) {
	  return axis.isHorizontal() ? 0 : 1;
	}
	
	function getGlobalExtent(coordSys, dimIndex) {
	  var rect = coordSys.getRect();
	  return [rect[XY[dimIndex]], rect[XY[dimIndex]] + rect[WH[dimIndex]]];
	}
	
	AxisView.registerAxisPointerClass('SingleAxisPointer', SingleAxisPointer);
	var _default = SingleAxisPointer;
	module.exports = _default;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(320);
	
	var createDimensions = __webpack_require__(346);
	
	var _dimensionHelper = __webpack_require__(344);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var List = __webpack_require__(342);
	
	var zrUtil = __webpack_require__(220);
	
	var _model = __webpack_require__(261);
	
	var groupData = _model.groupData;
	
	var _format = __webpack_require__(307);
	
	var encodeHTML = _format.encodeHTML;
	
	var LegendVisualProvider = __webpack_require__(406);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DATA_NAME_INDEX = 2;
	var ThemeRiverSeries = SeriesModel.extend({
	  type: 'series.themeRiver',
	  dependencies: ['singleAxis'],
	
	  /**
	   * @readOnly
	   * @type {module:zrender/core/util#HashMap}
	   */
	  nameMap: null,
	
	  /**
	   * @override
	   */
	  init: function (option) {
	    // eslint-disable-next-line
	    ThemeRiverSeries.superApply(this, 'init', arguments); // Put this function here is for the sake of consistency of code style.
	    // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
	  },
	
	  /**
	   * If there is no value of a certain point in the time for some event,set it value to 0.
	   *
	   * @param {Array} data  initial data in the option
	   * @return {Array}
	   */
	  fixData: function (data) {
	    var rawDataLength = data.length;
	    /**
	     * Make sure every layer data get the same keys.
	     * The value index tells which layer has visited.
	     * {
	     *  2014/01/01: -1
	     * }
	     */
	
	    var timeValueKeys = {}; // grouped data by name
	
	    var groupResult = groupData(data, function (item) {
	      if (!timeValueKeys.hasOwnProperty(item[0])) {
	        timeValueKeys[item[0]] = -1;
	      }
	
	      return item[2];
	    });
	    var layData = [];
	    groupResult.buckets.each(function (items, key) {
	      layData.push({
	        name: key,
	        dataList: items
	      });
	    });
	    var layerNum = layData.length;
	
	    for (var k = 0; k < layerNum; ++k) {
	      var name = layData[k].name;
	
	      for (var j = 0; j < layData[k].dataList.length; ++j) {
	        var timeValue = layData[k].dataList[j][0];
	        timeValueKeys[timeValue] = k;
	      }
	
	      for (var timeValue in timeValueKeys) {
	        if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
	          timeValueKeys[timeValue] = k;
	          data[rawDataLength] = [];
	          data[rawDataLength][0] = timeValue;
	          data[rawDataLength][1] = 0;
	          data[rawDataLength][2] = name;
	          rawDataLength++;
	        }
	      }
	    }
	
	    return data;
	  },
	
	  /**
	   * @override
	   * @param  {Object} option  the initial option that user gived
	   * @param  {module:echarts/model/Model} ecModel  the model object for themeRiver option
	   * @return {module:echarts/data/List}
	   */
	  getInitialData: function (option, ecModel) {
	    var singleAxisModel = ecModel.queryComponents({
	      mainType: 'singleAxis',
	      index: this.get('singleAxisIndex'),
	      id: this.get('singleAxisId')
	    })[0];
	    var axisType = singleAxisModel.get('type'); // filter the data item with the value of label is undefined
	
	    var filterData = zrUtil.filter(option.data, function (dataItem) {
	      return dataItem[2] !== undefined;
	    }); // ??? TODO design a stage to transfer data for themeRiver and lines?
	
	    var data = this.fixData(filterData || []);
	    var nameList = [];
	    var nameMap = this.nameMap = zrUtil.createHashMap();
	    var count = 0;
	
	    for (var i = 0; i < data.length; ++i) {
	      nameList.push(data[i][DATA_NAME_INDEX]);
	
	      if (!nameMap.get(data[i][DATA_NAME_INDEX])) {
	        nameMap.set(data[i][DATA_NAME_INDEX], count);
	        count++;
	      }
	    }
	
	    var dimensionsInfo = createDimensions(data, {
	      coordDimensions: ['single'],
	      dimensionsDefine: [{
	        name: 'time',
	        type: getDimensionTypeByAxis(axisType)
	      }, {
	        name: 'value',
	        type: 'float'
	      }, {
	        name: 'name',
	        type: 'ordinal'
	      }],
	      encodeDefine: {
	        single: 0,
	        value: 1,
	        itemName: 2
	      }
	    });
	    var list = new List(dimensionsInfo, this);
	    list.initData(data);
	    return list;
	  },
	
	  /**
	   * The raw data is divided into multiple layers and each layer
	   *     has same name.
	   *
	   * @return {Array.<Array.<number>>}
	   */
	  getLayerSeries: function () {
	    var data = this.getData();
	    var lenCount = data.count();
	    var indexArr = [];
	
	    for (var i = 0; i < lenCount; ++i) {
	      indexArr[i] = i;
	    }
	
	    var timeDim = data.mapDimension('single'); // data group by name
	
	    var groupResult = groupData(indexArr, function (index) {
	      return data.get('name', index);
	    });
	    var layerSeries = [];
	    groupResult.buckets.each(function (items, key) {
	      items.sort(function (index1, index2) {
	        return data.get(timeDim, index1) - data.get(timeDim, index2);
	      });
	      layerSeries.push({
	        name: key,
	        indices: items
	      });
	    });
	    return layerSeries;
	  },
	
	  /**
	   * Get data indices for show tooltip content
	    * @param {Array.<string>|string} dim  single coordinate dimension
	   * @param {number} value axis value
	   * @param {module:echarts/coord/single/SingleAxis} baseAxis  single Axis used
	   *     the themeRiver.
	   * @return {Object} {dataIndices, nestestValue}
	   */
	  getAxisTooltipData: function (dim, value, baseAxis) {
	    if (!zrUtil.isArray(dim)) {
	      dim = dim ? [dim] : [];
	    }
	
	    var data = this.getData();
	    var layerSeries = this.getLayerSeries();
	    var indices = [];
	    var layerNum = layerSeries.length;
	    var nestestValue;
	
	    for (var i = 0; i < layerNum; ++i) {
	      var minDist = Number.MAX_VALUE;
	      var nearestIdx = -1;
	      var pointNum = layerSeries[i].indices.length;
	
	      for (var j = 0; j < pointNum; ++j) {
	        var theValue = data.get(dim[0], layerSeries[i].indices[j]);
	        var dist = Math.abs(theValue - value);
	
	        if (dist <= minDist) {
	          nestestValue = theValue;
	          minDist = dist;
	          nearestIdx = layerSeries[i].indices[j];
	        }
	      }
	
	      indices.push(nearestIdx);
	    }
	
	    return {
	      dataIndices: indices,
	      nestestValue: nestestValue
	    };
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex  index of data
	   */
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var htmlName = data.getName(dataIndex);
	    var htmlValue = data.get(data.mapDimension('value'), dataIndex);
	
	    if (isNaN(htmlValue) || htmlValue == null) {
	      htmlValue = '-';
	    }
	
	    return encodeHTML(htmlName + ' : ' + htmlValue);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'singleAxis',
	    // gap in axis's orthogonal orientation
	    boundaryGap: ['10%', '10%'],
	    // legendHoverLink: true,
	    singleAxisIndex: 0,
	    animationEasing: 'linear',
	    label: {
	      margin: 4,
	      show: true,
	      position: 'left',
	      color: '#000',
	      fontSize: 11
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = ThemeRiverSeries;
	module.exports = _default;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var _poly = __webpack_require__(374);
	
	var Polygon = _poly.Polygon;
	
	var graphic = __webpack_require__(268);
	
	var _util = __webpack_require__(220);
	
	var bind = _util.bind;
	var extend = _util.extend;
	
	var DataDiffer = __webpack_require__(343);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'themeRiver',
	  init: function () {
	    this._layers = [];
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var group = this.group;
	    var layerSeries = seriesModel.getLayerSeries();
	    var layoutInfo = data.getLayout('layoutInfo');
	    var rect = layoutInfo.rect;
	    var boundaryGap = layoutInfo.boundaryGap;
	    group.attr('position', [0, rect.y + boundaryGap[0]]);
	
	    function keyGetter(item) {
	      return item.name;
	    }
	
	    var dataDiffer = new DataDiffer(this._layersSeries || [], layerSeries, keyGetter, keyGetter);
	    var newLayersGroups = {};
	    dataDiffer.add(bind(process, this, 'add')).update(bind(process, this, 'update')).remove(bind(process, this, 'remove')).execute();
	
	    function process(status, idx, oldIdx) {
	      var oldLayersGroups = this._layers;
	
	      if (status === 'remove') {
	        group.remove(oldLayersGroups[idx]);
	        return;
	      }
	
	      var points0 = [];
	      var points1 = [];
	      var color;
	      var indices = layerSeries[idx].indices;
	
	      for (var j = 0; j < indices.length; j++) {
	        var layout = data.getItemLayout(indices[j]);
	        var x = layout.x;
	        var y0 = layout.y0;
	        var y = layout.y;
	        points0.push([x, y0]);
	        points1.push([x, y0 + y]);
	        color = data.getItemVisual(indices[j], 'color');
	      }
	
	      var polygon;
	      var text;
	      var textLayout = data.getItemLayout(indices[0]);
	      var itemModel = data.getItemModel(indices[j - 1]);
	      var labelModel = itemModel.getModel('label');
	      var margin = labelModel.get('margin');
	
	      if (status === 'add') {
	        var layerGroup = newLayersGroups[idx] = new graphic.Group();
	        polygon = new Polygon({
	          shape: {
	            points: points0,
	            stackedOnPoints: points1,
	            smooth: 0.4,
	            stackedOnSmooth: 0.4,
	            smoothConstraint: false
	          },
	          z2: 0
	        });
	        text = new graphic.Text({
	          style: {
	            x: textLayout.x - margin,
	            y: textLayout.y0 + textLayout.y / 2
	          }
	        });
	        layerGroup.add(polygon);
	        layerGroup.add(text);
	        group.add(layerGroup);
	        polygon.setClipPath(createGridClipShape(polygon.getBoundingRect(), seriesModel, function () {
	          polygon.removeClipPath();
	        }));
	      } else {
	        var layerGroup = oldLayersGroups[oldIdx];
	        polygon = layerGroup.childAt(0);
	        text = layerGroup.childAt(1);
	        group.add(layerGroup);
	        newLayersGroups[idx] = layerGroup;
	        graphic.updateProps(polygon, {
	          shape: {
	            points: points0,
	            stackedOnPoints: points1
	          }
	        }, seriesModel);
	        graphic.updateProps(text, {
	          style: {
	            x: textLayout.x - margin,
	            y: textLayout.y0 + textLayout.y / 2
	          }
	        }, seriesModel);
	      }
	
	      var hoverItemStyleModel = itemModel.getModel('emphasis.itemStyle');
	      var itemStyleModel = itemModel.getModel('itemStyle');
	      graphic.setTextStyle(text.style, labelModel, {
	        text: labelModel.get('show') ? seriesModel.getFormattedLabel(indices[j - 1], 'normal') || data.getName(indices[j - 1]) : null,
	        textVerticalAlign: 'middle'
	      });
	      polygon.setStyle(extend({
	        fill: color
	      }, itemStyleModel.getItemStyle(['color'])));
	      graphic.setHoverStyle(polygon, hoverItemStyleModel.getItemStyle());
	    }
	
	    this._layersSeries = layerSeries;
	    this._layers = newLayersGroups;
	  },
	  dispose: function () {}
	}); // add animation to the view
	
	
	function createGridClipShape(rect, seriesModel, cb) {
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x - 10,
	      y: rect.y - 10,
	      width: 0,
	      height: rect.height + 20
	    }
	  });
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width + 20,
	      height: rect.height + 20
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	module.exports = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var numberUtil = __webpack_require__(306);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	    var data = seriesModel.getData();
	    var single = seriesModel.coordinateSystem;
	    var layoutInfo = {}; // use the axis boundingRect for view
	
	    var rect = single.getRect();
	    layoutInfo.rect = rect;
	    var boundaryGap = seriesModel.get('boundaryGap');
	    var axis = single.getAxis();
	    layoutInfo.boundaryGap = boundaryGap;
	
	    if (axis.orient === 'horizontal') {
	      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.height);
	      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.height);
	      var height = rect.height - boundaryGap[0] - boundaryGap[1];
	      themeRiverLayout(data, seriesModel, height);
	    } else {
	      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.width);
	      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.width);
	      var width = rect.width - boundaryGap[0] - boundaryGap[1];
	      themeRiverLayout(data, seriesModel, width);
	    }
	
	    data.setLayout('layoutInfo', layoutInfo);
	  });
	}
	/**
	 * The layout information about themeriver
	 *
	 * @param {module:echarts/data/List} data  data in the series
	 * @param {module:echarts/model/Series} seriesModel  the model object of themeRiver series
	 * @param {number} height  value used to compute every series height
	 */
	
	
	function themeRiverLayout(data, seriesModel, height) {
	  if (!data.count()) {
	    return;
	  }
	
	  var coordSys = seriesModel.coordinateSystem; // the data in each layer are organized into a series.
	
	  var layerSeries = seriesModel.getLayerSeries(); // the points in each layer.
	
	  var timeDim = data.mapDimension('single');
	  var valueDim = data.mapDimension('value');
	  var layerPoints = zrUtil.map(layerSeries, function (singleLayer) {
	    return zrUtil.map(singleLayer.indices, function (idx) {
	      var pt = coordSys.dataToPoint(data.get(timeDim, idx));
	      pt[1] = data.get(valueDim, idx);
	      return pt;
	    });
	  });
	  var base = computeBaseline(layerPoints);
	  var baseLine = base.y0;
	  var ky = height / base.max; // set layout information for each item.
	
	  var n = layerSeries.length;
	  var m = layerSeries[0].indices.length;
	  var baseY0;
	
	  for (var j = 0; j < m; ++j) {
	    baseY0 = baseLine[j] * ky;
	    data.setItemLayout(layerSeries[0].indices[j], {
	      layerIndex: 0,
	      x: layerPoints[0][j][0],
	      y0: baseY0,
	      y: layerPoints[0][j][1] * ky
	    });
	
	    for (var i = 1; i < n; ++i) {
	      baseY0 += layerPoints[i - 1][j][1] * ky;
	      data.setItemLayout(layerSeries[i].indices[j], {
	        layerIndex: i,
	        x: layerPoints[i][j][0],
	        y0: baseY0,
	        y: layerPoints[i][j][1] * ky
	      });
	    }
	  }
	}
	/**
	 * Compute the baseLine of the rawdata
	 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
	 *
	 * @param  {Array.<Array>} data  the points in each layer
	 * @return {Object}
	 */
	
	
	function computeBaseline(data) {
	  var layerNum = data.length;
	  var pointNum = data[0].length;
	  var sums = [];
	  var y0 = [];
	  var max = 0;
	  var temp;
	  var base = {};
	
	  for (var i = 0; i < pointNum; ++i) {
	    for (var j = 0, temp = 0; j < layerNum; ++j) {
	      temp += data[j][i][1];
	    }
	
	    if (temp > max) {
	      max = temp;
	    }
	
	    sums.push(temp);
	  }
	
	  for (var k = 0; k < pointNum; ++k) {
	    y0[k] = (max - sums[k]) / 2;
	  }
	
	  max = 0;
	
	  for (var l = 0; l < pointNum; ++l) {
	    var sum = sums[l] + y0[l];
	
	    if (sum > max) {
	      max = sum;
	    }
	  }
	
	  base.y0 = y0;
	  base.max = max;
	  return base;
	}
	
	module.exports = _default;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(220);
	
	var createHashMap = _util.createHashMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	    var data = seriesModel.getData();
	    var rawData = seriesModel.getRawData();
	    var colorList = seriesModel.get('color');
	    var idxMap = createHashMap();
	    data.each(function (idx) {
	      idxMap.set(data.getRawIndex(idx), idx);
	    });
	    rawData.each(function (rawIndex) {
	      var name = rawData.getName(rawIndex);
	      var color = colorList[(seriesModel.nameMap.get(name) - 1) % colorList.length];
	      rawData.setItemVisual(rawIndex, 'color', color);
	      var idx = idxMap.get(rawIndex);
	
	      if (idx != null) {
	        data.setItemVisual(idx, 'color', color);
	      }
	    });
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	__webpack_require__(579);
	
	__webpack_require__(580);
	
	__webpack_require__(582);
	
	var dataColor = __webpack_require__(409);
	
	var sunburstLayout = __webpack_require__(583);
	
	var dataFilter = __webpack_require__(412);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(zrUtil.curry(dataColor, 'sunburst'));
	echarts.registerLayout(zrUtil.curry(sunburstLayout, 'sunburst'));
	echarts.registerProcessor(zrUtil.curry(dataFilter, 'sunburst'));

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var SeriesModel = __webpack_require__(320);
	
	var Tree = __webpack_require__(453);
	
	var Model = __webpack_require__(262);
	
	var _treeHelper = __webpack_require__(462);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.sunburst',
	
	  /**
	   * @type {module:echarts/data/Tree~Node}
	   */
	  _viewRoot: null,
	  getInitialData: function (option, ecModel) {
	    // Create a virtual root.
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    completeTreeValue(root);
	    var levelModels = zrUtil.map(option.levels || [], function (levelDefine) {
	      return new Model(levelDefine, this, ecModel);
	    }, this); // Make sure always a new tree is created when setOption,
	    // in TreemapView, we check whether oldTree === newTree
	    // to choose mappings approach among old shapes and new shapes.
	
	    var tree = Tree.createTree(root, this, beforeLink);
	
	    function beforeLink(nodeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        var node = tree.getNodeByDataIndex(idx);
	        var levelModel = levelModels[node.depth];
	        levelModel && (model.parentModel = levelModel);
	        return model;
	      });
	    }
	
	    return tree.data;
	  },
	  optionUpdated: function () {
	    this.resetViewRoot();
	  },
	
	  /*
	   * @override
	   */
	  getDataParams: function (dataIndex) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	    params.treePathInfo = wrapTreePathInfo(node, this);
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    radius: [0, '75%'],
	    // 默认顺时针
	    clockwise: true,
	    startAngle: 90,
	    // 最小角度改为0
	    minAngle: 0,
	    percentPrecision: 2,
	    // If still show when all data zero.
	    stillShowZeroSum: true,
	    // Policy of highlighting pieces when hover on one
	    // Valid values: 'none' (for not downplay others), 'descendant',
	    // 'ancestor', 'self'
	    highlightPolicy: 'descendant',
	    // 'rootToNode', 'link', or false
	    nodeClick: 'rootToNode',
	    renderLabelForZeroData: false,
	    label: {
	      // could be: 'radial', 'tangential', or 'none'
	      rotate: 'radial',
	      show: true,
	      opacity: 1,
	      // 'left' is for inner side of inside, and 'right' is for outter
	      // side for inside
	      align: 'center',
	      position: 'inside',
	      distance: 5,
	      silent: true
	    },
	    itemStyle: {
	      borderWidth: 1,
	      borderColor: 'white',
	      borderType: 'solid',
	      shadowBlur: 0,
	      shadowColor: 'rgba(0, 0, 0, 0.2)',
	      shadowOffsetX: 0,
	      shadowOffsetY: 0,
	      opacity: 1
	    },
	    highlight: {
	      itemStyle: {
	        opacity: 1
	      }
	    },
	    downplay: {
	      itemStyle: {
	        opacity: 0.5
	      },
	      label: {
	        opacity: 0.6
	      }
	    },
	    // Animation type canbe expansion, scale
	    animationType: 'expansion',
	    animationDuration: 1000,
	    animationDurationUpdate: 500,
	    animationEasing: 'cubicOut',
	    data: [],
	    levels: [],
	
	    /**
	     * Sort order.
	     *
	     * Valid values: 'desc', 'asc', null, or callback function.
	     * 'desc' and 'asc' for descend and ascendant order;
	     * null for not sorting;
	     * example of callback function:
	     * function(nodeA, nodeB) {
	     *     return nodeA.getValue() - nodeB.getValue();
	     * }
	     */
	    sort: 'desc'
	  },
	  getViewRoot: function () {
	    return this._viewRoot;
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~Node} [viewRoot]
	   */
	  resetViewRoot: function (viewRoot) {
	    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	    var root = this.getRawData().tree.root;
	
	    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	      this._viewRoot = root;
	    }
	  }
	});
	/**
	 * @param {Object} dataNode
	 */
	
	
	function completeTreeValue(dataNode) {
	  // Postorder travel tree.
	  // If value of none-leaf node is not set,
	  // calculate it by suming up the value of all children.
	  var sum = 0;
	  zrUtil.each(dataNode.children, function (child) {
	    completeTreeValue(child);
	    var childValue = child.value;
	    zrUtil.isArray(childValue) && (childValue = childValue[0]);
	    sum += childValue;
	  });
	  var thisValue = dataNode.value;
	
	  if (zrUtil.isArray(thisValue)) {
	    thisValue = thisValue[0];
	  }
	
	  if (thisValue == null || isNaN(thisValue)) {
	    thisValue = sum;
	  } // Value should not less than 0.
	
	
	  if (thisValue < 0) {
	    thisValue = 0;
	  }
	
	  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	}
	
	module.exports = _default;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var ChartView = __webpack_require__(325);
	
	var SunburstPiece = __webpack_require__(581);
	
	var DataDiffer = __webpack_require__(343);
	
	var _format = __webpack_require__(307);
	
	var windowOpen = _format.windowOpen;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
	var SunburstView = ChartView.extend({
	  type: 'sunburst',
	  init: function () {},
	  render: function (seriesModel, ecModel, api, payload) {
	    var that = this;
	    this.seriesModel = seriesModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    var data = seriesModel.getData();
	    var virtualRoot = data.tree.root;
	    var newRoot = seriesModel.getViewRoot();
	    var group = this.group;
	    var renderLabelForZeroData = seriesModel.get('renderLabelForZeroData');
	    var newChildren = [];
	    newRoot.eachNode(function (node) {
	      newChildren.push(node);
	    });
	    var oldChildren = this._oldChildren || [];
	    dualTravel(newChildren, oldChildren);
	    renderRollUp(virtualRoot, newRoot);
	
	    if (payload && payload.highlight && payload.highlight.piece) {
	      var highlightPolicy = seriesModel.getShallow('highlightPolicy');
	      payload.highlight.piece.onEmphasis(highlightPolicy);
	    } else if (payload && payload.unhighlight) {
	      var piece = this.virtualPiece;
	
	      if (!piece && virtualRoot.children.length) {
	        piece = virtualRoot.children[0].piece;
	      }
	
	      if (piece) {
	        piece.onNormal();
	      }
	    }
	
	    this._initEvents();
	
	    this._oldChildren = newChildren;
	
	    function dualTravel(newChildren, oldChildren) {
	      if (newChildren.length === 0 && oldChildren.length === 0) {
	        return;
	      }
	
	      new DataDiffer(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
	
	      function getKey(node) {
	        return node.getId();
	      }
	
	      function processNode(newId, oldId) {
	        var newNode = newId == null ? null : newChildren[newId];
	        var oldNode = oldId == null ? null : oldChildren[oldId];
	        doRenderNode(newNode, oldNode);
	      }
	    }
	
	    function doRenderNode(newNode, oldNode) {
	      if (!renderLabelForZeroData && newNode && !newNode.getValue()) {
	        // Not render data with value 0
	        newNode = null;
	      }
	
	      if (newNode !== virtualRoot && oldNode !== virtualRoot) {
	        if (oldNode && oldNode.piece) {
	          if (newNode) {
	            // Update
	            oldNode.piece.updateData(false, newNode, 'normal', seriesModel, ecModel); // For tooltip
	
	            data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
	          } else {
	            // Remove
	            removeNode(oldNode);
	          }
	        } else if (newNode) {
	          // Add
	          var piece = new SunburstPiece(newNode, seriesModel, ecModel);
	          group.add(piece); // For tooltip
	
	          data.setItemGraphicEl(newNode.dataIndex, piece);
	        }
	      }
	    }
	
	    function removeNode(node) {
	      if (!node) {
	        return;
	      }
	
	      if (node.piece) {
	        group.remove(node.piece);
	        node.piece = null;
	      }
	    }
	
	    function renderRollUp(virtualRoot, viewRoot) {
	      if (viewRoot.depth > 0) {
	        // Render
	        if (that.virtualPiece) {
	          // Update
	          that.virtualPiece.updateData(false, virtualRoot, 'normal', seriesModel, ecModel);
	        } else {
	          // Add
	          that.virtualPiece = new SunburstPiece(virtualRoot, seriesModel, ecModel);
	          group.add(that.virtualPiece);
	        }
	
	        if (viewRoot.piece._onclickEvent) {
	          viewRoot.piece.off('click', viewRoot.piece._onclickEvent);
	        }
	
	        var event = function (e) {
	          that._rootToNode(viewRoot.parentNode);
	        };
	
	        viewRoot.piece._onclickEvent = event;
	        that.virtualPiece.on('click', event);
	      } else if (that.virtualPiece) {
	        // Remove
	        group.remove(that.virtualPiece);
	        that.virtualPiece = null;
	      }
	    }
	  },
	  dispose: function () {},
	
	  /**
	   * @private
	   */
	  _initEvents: function () {
	    var that = this;
	
	    var event = function (e) {
	      var targetFound = false;
	      var viewRoot = that.seriesModel.getViewRoot();
	      viewRoot.eachNode(function (node) {
	        if (!targetFound && node.piece && node.piece.childAt(0) === e.target) {
	          var nodeClick = node.getModel().get('nodeClick');
	
	          if (nodeClick === 'rootToNode') {
	            that._rootToNode(node);
	          } else if (nodeClick === 'link') {
	            var itemModel = node.getModel();
	            var link = itemModel.get('link');
	
	            if (link) {
	              var linkTarget = itemModel.get('target', true) || '_blank';
	              windowOpen(link, linkTarget);
	            }
	          }
	
	          targetFound = true;
	        }
	      });
	    };
	
	    if (this.group._onclickEvent) {
	      this.group.off('click', this.group._onclickEvent);
	    }
	
	    this.group.on('click', event);
	    this.group._onclickEvent = event;
	  },
	
	  /**
	   * @private
	   */
	  _rootToNode: function (node) {
	    if (node !== this.seriesModel.getViewRoot()) {
	      this.api.dispatchAction({
	        type: ROOT_TO_NODE_ACTION,
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        targetNode: node
	      });
	    }
	  },
	
	  /**
	   * @implement
	   */
	  containPoint: function (point, seriesModel) {
	    var treeRoot = seriesModel.getData();
	    var itemLayout = treeRoot.getItemLayout(0);
	
	    if (itemLayout) {
	      var dx = point[0] - itemLayout.cx;
	      var dy = point[1] - itemLayout.cy;
	      var radius = Math.sqrt(dx * dx + dy * dy);
	      return radius <= itemLayout.r && radius >= itemLayout.r0;
	    }
	  }
	});
	var _default = SunburstView;
	module.exports = _default;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NodeHighlightPolicy = {
	  NONE: 'none',
	  // not downplay others
	  DESCENDANT: 'descendant',
	  ANCESTOR: 'ancestor',
	  SELF: 'self'
	};
	var DEFAULT_SECTOR_Z = 2;
	var DEFAULT_TEXT_Z = 4;
	/**
	 * Sunburstce of Sunburst including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	
	function SunburstPiece(node, seriesModel, ecModel) {
	  graphic.Group.call(this);
	  var sector = new graphic.Sector({
	    z2: DEFAULT_SECTOR_Z
	  });
	  sector.seriesIndex = seriesModel.seriesIndex;
	  var text = new graphic.Text({
	    z2: DEFAULT_TEXT_Z,
	    silent: node.getModel('label').get('silent')
	  });
	  this.add(sector);
	  this.add(text);
	  this.updateData(true, node, 'normal', seriesModel, ecModel); // Hover to change label and labelLine
	
	  function onEmphasis() {
	    text.ignore = text.hoverIgnore;
	  }
	
	  function onNormal() {
	    text.ignore = text.normalIgnore;
	  }
	
	  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
	}
	
	var SunburstPieceProto = SunburstPiece.prototype;
	
	SunburstPieceProto.updateData = function (firstCreate, node, state, seriesModel, ecModel) {
	  this.node = node;
	  node.piece = this;
	  seriesModel = seriesModel || this._seriesModel;
	  ecModel = ecModel || this._ecModel;
	  var sector = this.childAt(0);
	  sector.dataIndex = node.dataIndex;
	  var itemModel = node.getModel();
	  var layout = node.getLayout(); // if (!layout) {
	  //     console.log(node.getLayout());
	  // }
	
	  var sectorShape = zrUtil.extend({}, layout);
	  sectorShape.label = null;
	  var visualColor = getNodeColor(node, seriesModel, ecModel);
	  fillDefaultColor(node, seriesModel, visualColor);
	  var normalStyle = itemModel.getModel('itemStyle').getItemStyle();
	  var style;
	
	  if (state === 'normal') {
	    style = normalStyle;
	  } else {
	    var stateStyle = itemModel.getModel(state + '.itemStyle').getItemStyle();
	    style = zrUtil.merge(stateStyle, normalStyle);
	  }
	
	  style = zrUtil.defaults({
	    lineJoin: 'bevel',
	    fill: style.fill || visualColor
	  }, style);
	
	  if (firstCreate) {
	    sector.setShape(sectorShape);
	    sector.shape.r = layout.r0;
	    graphic.updateProps(sector, {
	      shape: {
	        r: layout.r
	      }
	    }, seriesModel, node.dataIndex);
	    sector.useStyle(style);
	  } else if (typeof style.fill === 'object' && style.fill.type || typeof sector.style.fill === 'object' && sector.style.fill.type) {
	    // Disable animation for gradient since no interpolation method
	    // is supported for gradient
	    graphic.updateProps(sector, {
	      shape: sectorShape
	    }, seriesModel);
	    sector.useStyle(style);
	  } else {
	    graphic.updateProps(sector, {
	      shape: sectorShape,
	      style: style
	    }, seriesModel);
	  }
	
	  this._updateLabel(seriesModel, visualColor, state);
	
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && sector.attr('cursor', cursorStyle);
	
	  if (firstCreate) {
	    var highlightPolicy = seriesModel.getShallow('highlightPolicy');
	
	    this._initEvents(sector, node, seriesModel, highlightPolicy);
	  }
	
	  this._seriesModel = seriesModel || this._seriesModel;
	  this._ecModel = ecModel || this._ecModel;
	  graphic.setHoverStyle(this);
	};
	
	SunburstPieceProto.onEmphasis = function (highlightPolicy) {
	  var that = this;
	  this.node.hostTree.root.eachNode(function (n) {
	    if (n.piece) {
	      if (that.node === n) {
	        n.piece.updateData(false, n, 'emphasis');
	      } else if (isNodeHighlighted(n, that.node, highlightPolicy)) {
	        n.piece.childAt(0).trigger('highlight');
	      } else if (highlightPolicy !== NodeHighlightPolicy.NONE) {
	        n.piece.childAt(0).trigger('downplay');
	      }
	    }
	  });
	};
	
	SunburstPieceProto.onNormal = function () {
	  this.node.hostTree.root.eachNode(function (n) {
	    if (n.piece) {
	      n.piece.updateData(false, n, 'normal');
	    }
	  });
	};
	
	SunburstPieceProto.onHighlight = function () {
	  this.updateData(false, this.node, 'highlight');
	};
	
	SunburstPieceProto.onDownplay = function () {
	  this.updateData(false, this.node, 'downplay');
	};
	
	SunburstPieceProto._updateLabel = function (seriesModel, visualColor, state) {
	  var itemModel = this.node.getModel();
	  var normalModel = itemModel.getModel('label');
	  var labelModel = state === 'normal' || state === 'emphasis' ? normalModel : itemModel.getModel(state + '.label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelFormatter = labelModel.get('formatter'); // Use normal formatter if no state formatter is defined
	
	  var labelState = labelFormatter ? state : 'normal';
	  var text = zrUtil.retrieve(seriesModel.getFormattedLabel(this.node.dataIndex, labelState, null, null, 'label'), this.node.name);
	
	  if (getLabelAttr('show') === false) {
	    text = '';
	  }
	
	  var layout = this.node.getLayout();
	  var labelMinAngle = labelModel.get('minAngle');
	
	  if (labelMinAngle == null) {
	    labelMinAngle = normalModel.get('minAngle');
	  }
	
	  labelMinAngle = labelMinAngle / 180 * Math.PI;
	  var angle = layout.endAngle - layout.startAngle;
	
	  if (labelMinAngle != null && Math.abs(angle) < labelMinAngle) {
	    // Not displaying text when angle is too small
	    text = '';
	  }
	
	  var label = this.childAt(1);
	  graphic.setLabelStyle(label.style, label.hoverStyle || {}, normalModel, labelHoverModel, {
	    defaultText: labelModel.getShallow('show') ? text : null,
	    autoColor: visualColor,
	    useInsideStyle: true
	  });
	  var midAngle = (layout.startAngle + layout.endAngle) / 2;
	  var dx = Math.cos(midAngle);
	  var dy = Math.sin(midAngle);
	  var r;
	  var labelPosition = getLabelAttr('position');
	  var labelPadding = getLabelAttr('distance') || 0;
	  var textAlign = getLabelAttr('align');
	
	  if (labelPosition === 'outside') {
	    r = layout.r + labelPadding;
	    textAlign = midAngle > Math.PI / 2 ? 'right' : 'left';
	  } else {
	    if (!textAlign || textAlign === 'center') {
	      r = (layout.r + layout.r0) / 2;
	      textAlign = 'center';
	    } else if (textAlign === 'left') {
	      r = layout.r0 + labelPadding;
	
	      if (midAngle > Math.PI / 2) {
	        textAlign = 'right';
	      }
	    } else if (textAlign === 'right') {
	      r = layout.r - labelPadding;
	
	      if (midAngle > Math.PI / 2) {
	        textAlign = 'left';
	      }
	    }
	  }
	
	  label.attr('style', {
	    text: text,
	    textAlign: textAlign,
	    textVerticalAlign: getLabelAttr('verticalAlign') || 'middle',
	    opacity: getLabelAttr('opacity')
	  });
	  var textX = r * dx + layout.cx;
	  var textY = r * dy + layout.cy;
	  label.attr('position', [textX, textY]);
	  var rotateType = getLabelAttr('rotate');
	  var rotate = 0;
	
	  if (rotateType === 'radial') {
	    rotate = -midAngle;
	
	    if (rotate < -Math.PI / 2) {
	      rotate += Math.PI;
	    }
	  } else if (rotateType === 'tangential') {
	    rotate = Math.PI / 2 - midAngle;
	
	    if (rotate > Math.PI / 2) {
	      rotate -= Math.PI;
	    } else if (rotate < -Math.PI / 2) {
	      rotate += Math.PI;
	    }
	  } else if (typeof rotateType === 'number') {
	    rotate = rotateType * Math.PI / 180;
	  }
	
	  label.attr('rotation', rotate);
	
	  function getLabelAttr(name) {
	    var stateAttr = labelModel.get(name);
	
	    if (stateAttr == null) {
	      return normalModel.get(name);
	    } else {
	      return stateAttr;
	    }
	  }
	};
	
	SunburstPieceProto._initEvents = function (sector, node, seriesModel, highlightPolicy) {
	  sector.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  var that = this;
	
	  var onEmphasis = function () {
	    that.onEmphasis(highlightPolicy);
	  };
	
	  var onNormal = function () {
	    that.onNormal();
	  };
	
	  var onDownplay = function () {
	    that.onDownplay();
	  };
	
	  var onHighlight = function () {
	    that.onHighlight();
	  };
	
	  if (seriesModel.isAnimationEnabled()) {
	    sector.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal).on('downplay', onDownplay).on('highlight', onHighlight);
	  }
	};
	
	zrUtil.inherits(SunburstPiece, graphic.Group);
	var _default = SunburstPiece;
	/**
	 * Get node color
	 *
	 * @param {TreeNode} node the node to get color
	 * @param {module:echarts/model/Series} seriesModel series
	 * @param {module:echarts/model/Global} ecModel echarts defaults
	 */
	
	function getNodeColor(node, seriesModel, ecModel) {
	  // Color from visualMap
	  var visualColor = node.getVisual('color');
	  var visualMetaList = node.getVisual('visualMeta');
	
	  if (!visualMetaList || visualMetaList.length === 0) {
	    // Use first-generation color if has no visualMap
	    visualColor = null;
	  } // Self color or level color
	
	
	  var color = node.getModel('itemStyle').get('color');
	
	  if (color) {
	    return color;
	  } else if (visualColor) {
	    // Color mapping
	    return visualColor;
	  } else if (node.depth === 0) {
	    // Virtual root node
	    return ecModel.option.color[0];
	  } else {
	    // First-generation color
	    var length = ecModel.option.color.length;
	    color = ecModel.option.color[getRootId(node) % length];
	  }
	
	  return color;
	}
	/**
	 * Get index of root in sorted order
	 *
	 * @param {TreeNode} node current node
	 * @return {number} index in root
	 */
	
	
	function getRootId(node) {
	  var ancestor = node;
	
	  while (ancestor.depth > 1) {
	    ancestor = ancestor.parentNode;
	  }
	
	  var virtualRoot = node.getAncestors()[0];
	  return zrUtil.indexOf(virtualRoot.children, ancestor);
	}
	
	function isNodeHighlighted(node, activeNode, policy) {
	  if (policy === NodeHighlightPolicy.NONE) {
	    return false;
	  } else if (policy === NodeHighlightPolicy.SELF) {
	    return node === activeNode;
	  } else if (policy === NodeHighlightPolicy.ANCESTOR) {
	    return node === activeNode || node.isAncestorOf(activeNode);
	  } else {
	    return node === activeNode || node.isDescendantOf(activeNode);
	  }
	} // Fix tooltip callback function params.color incorrect when pick a default color
	
	
	function fillDefaultColor(node, seriesModel, color) {
	  var data = seriesModel.getData();
	  data.setItemVisual(node.dataIndex, 'color', color);
	}
	
	module.exports = _default;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var helper = __webpack_require__(462);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Sunburst action
	 */
	var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
	echarts.registerAction({
	  type: ROOT_TO_NODE_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleRootToNode);
	
	  function handleRootToNode(model, index) {
	    var targetInfo = helper.retrieveTargetInfo(payload, [ROOT_TO_NODE_ACTION], model);
	
	    if (targetInfo) {
	      var originViewRoot = model.getViewRoot();
	
	      if (originViewRoot) {
	        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	      }
	
	      model.resetViewRoot(targetInfo.node);
	    }
	  }
	});
	var HIGHLIGHT_ACTION = 'sunburstHighlight';
	echarts.registerAction({
	  type: HIGHLIGHT_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleHighlight);
	
	  function handleHighlight(model, index) {
	    var targetInfo = helper.retrieveTargetInfo(payload, [HIGHLIGHT_ACTION], model);
	
	    if (targetInfo) {
	      payload.highlight = targetInfo.node;
	    }
	  }
	});
	var UNHIGHLIGHT_ACTION = 'sunburstUnhighlight';
	echarts.registerAction({
	  type: UNHIGHLIGHT_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleUnhighlight);
	
	  function handleUnhighlight(model, index) {
	    payload.unhighlight = true;
	  }
	});

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// var PI2 = Math.PI * 2;
	var RADIAN = Math.PI / 180;
	
	function _default(seriesType, ecModel, api, payload) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var center = seriesModel.get('center');
	    var radius = seriesModel.get('radius');
	
	    if (!zrUtil.isArray(radius)) {
	      radius = [0, radius];
	    }
	
	    if (!zrUtil.isArray(center)) {
	      center = [center, center];
	    }
	
	    var width = api.getWidth();
	    var height = api.getHeight();
	    var size = Math.min(width, height);
	    var cx = parsePercent(center[0], width);
	    var cy = parsePercent(center[1], height);
	    var r0 = parsePercent(radius[0], size / 2);
	    var r = parsePercent(radius[1], size / 2);
	    var startAngle = -seriesModel.get('startAngle') * RADIAN;
	    var minAngle = seriesModel.get('minAngle') * RADIAN;
	    var virtualRoot = seriesModel.getData().tree.root;
	    var treeRoot = seriesModel.getViewRoot();
	    var rootDepth = treeRoot.depth;
	    var sort = seriesModel.get('sort');
	
	    if (sort != null) {
	      initChildren(treeRoot, sort);
	    }
	
	    var validDataCount = 0;
	    zrUtil.each(treeRoot.children, function (child) {
	      !isNaN(child.getValue()) && validDataCount++;
	    });
	    var sum = treeRoot.getValue(); // Sum may be 0
	
	    var unitRadian = Math.PI / (sum || validDataCount) * 2;
	    var renderRollupNode = treeRoot.depth > 0;
	    var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
	    var rPerLevel = (r - r0) / (levels || 1);
	    var clockwise = seriesModel.get('clockwise');
	    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // In the case some sector angle is smaller than minAngle
	    // var restAngle = PI2;
	    // var valueSumLargerThanMinAngle = 0;
	
	    var dir = clockwise ? 1 : -1;
	    /**
	     * Render a tree
	     * @return increased angle
	     */
	
	    var renderNode = function (node, startAngle) {
	      if (!node) {
	        return;
	      }
	
	      var endAngle = startAngle; // Render self
	
	      if (node !== virtualRoot) {
	        // Tree node is virtual, so it doesn't need to be drawn
	        var value = node.getValue();
	        var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	
	        if (angle < minAngle) {
	          angle = minAngle; // restAngle -= minAngle;
	        } // else {
	        //     valueSumLargerThanMinAngle += value;
	        // }
	
	
	        endAngle = startAngle + dir * angle;
	        var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
	        var rStart = r0 + rPerLevel * depth;
	        var rEnd = r0 + rPerLevel * (depth + 1);
	        var itemModel = node.getModel();
	
	        if (itemModel.get('r0') != null) {
	          rStart = parsePercent(itemModel.get('r0'), size / 2);
	        }
	
	        if (itemModel.get('r') != null) {
	          rEnd = parsePercent(itemModel.get('r'), size / 2);
	        }
	
	        node.setLayout({
	          angle: angle,
	          startAngle: startAngle,
	          endAngle: endAngle,
	          clockwise: clockwise,
	          cx: cx,
	          cy: cy,
	          r0: rStart,
	          r: rEnd
	        });
	      } // Render children
	
	
	      if (node.children && node.children.length) {
	        // currentAngle = startAngle;
	        var siblingAngle = 0;
	        zrUtil.each(node.children, function (node) {
	          siblingAngle += renderNode(node, startAngle + siblingAngle);
	        });
	      }
	
	      return endAngle - startAngle;
	    }; // Virtual root node for roll up
	
	
	    if (renderRollupNode) {
	      var rStart = r0;
	      var rEnd = r0 + rPerLevel;
	      var angle = Math.PI * 2;
	      virtualRoot.setLayout({
	        angle: angle,
	        startAngle: startAngle,
	        endAngle: startAngle + angle,
	        clockwise: clockwise,
	        cx: cx,
	        cy: cy,
	        r0: rStart,
	        r: rEnd
	      });
	    }
	
	    renderNode(treeRoot, startAngle);
	  });
	}
	/**
	 * Init node children by order and update visual
	 *
	 * @param {TreeNode} node  root node
	 * @param {boolean}  isAsc if is in ascendant order
	 */
	
	
	function initChildren(node, isAsc) {
	  var children = node.children || [];
	  node.children = sort(children, isAsc); // Init children recursively
	
	  if (children.length) {
	    zrUtil.each(node.children, function (child) {
	      initChildren(child, isAsc);
	    });
	  }
	}
	/**
	 * Sort children nodes
	 *
	 * @param {TreeNode[]}               children children of node to be sorted
	 * @param {string | function | null} sort sort method
	 *                                   See SunburstSeries.js for details.
	 */
	
	
	function sort(children, sortOrder) {
	  if (typeof sortOrder === 'function') {
	    return children.sort(sortOrder);
	  } else {
	    var isAsc = sortOrder === 'asc';
	    return children.sort(function (a, b) {
	      var diff = (a.getValue() - b.getValue()) * (isAsc ? 1 : -1);
	      return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc ? -1 : 1) : diff;
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(220);
	
	var graphicUtil = __webpack_require__(268);
	
	var _labelHelper = __webpack_require__(371);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	var createListFromArray = __webpack_require__(341);
	
	var _barGrid = __webpack_require__(356);
	
	var getLayoutOnAxis = _barGrid.getLayoutOnAxis;
	
	var DataDiffer = __webpack_require__(343);
	
	var SeriesModel = __webpack_require__(320);
	
	var Model = __webpack_require__(262);
	
	var ChartView = __webpack_require__(325);
	
	var _createClipPathFromCoordSys = __webpack_require__(375);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	var prepareCartesian2d = __webpack_require__(585);
	
	var prepareGeo = __webpack_require__(586);
	
	var prepareSingleAxis = __webpack_require__(587);
	
	var preparePolar = __webpack_require__(588);
	
	var prepareCalendar = __webpack_require__(589);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CACHED_LABEL_STYLE_PROPERTIES = graphicUtil.CACHED_LABEL_STYLE_PROPERTIES;
	var ITEM_STYLE_NORMAL_PATH = ['itemStyle'];
	var ITEM_STYLE_EMPHASIS_PATH = ['emphasis', 'itemStyle'];
	var LABEL_NORMAL = ['label'];
	var LABEL_EMPHASIS = ['emphasis', 'label']; // Use prefix to avoid index to be the same as el.name,
	// which will cause weird udpate animation.
	
	var GROUP_DIFF_PREFIX = 'e\0\0';
	/**
	 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
	 * of each coordinate systems are not required by each coordinate systems directly, but
	 * required by the module `custom`.
	 *
	 * prepareInfoForCustomSeries {Function}: optional
	 *     @return {Object} {coordSys: {...}, api: {
	 *         coord: function (data, clamp) {}, // return point in global.
	 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
	 *     }}
	 */
	
	var prepareCustoms = {
	  cartesian2d: prepareCartesian2d,
	  geo: prepareGeo,
	  singleAxis: prepareSingleAxis,
	  polar: preparePolar,
	  calendar: prepareCalendar
	}; // ------
	// Model
	// ------
	
	SeriesModel.extend({
	  type: 'series.custom',
	  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    // Can be set as 'none'
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    useTransform: true,
	    // Custom series will not clip by default.
	    // Some case will use custom series to draw label
	    // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
	    // Only works on polar and cartesian2d coordinate system.
	    clip: false // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // label: {}
	    // itemStyle: {}
	
	  },
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this);
	  },
	
	  /**
	   * @override
	   */
	  getDataParams: function (dataIndex, dataType, el) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    el && (params.info = el.info);
	    return params;
	  }
	}); // -----
	// View
	// -----
	
	ChartView.extend({
	  type: 'custom',
	
	  /**
	   * @private
	   * @type {module:echarts/data/List}
	   */
	  _data: null,
	
	  /**
	   * @override
	   */
	  render: function (customSeries, ecModel, api, payload) {
	    var oldData = this._data;
	    var data = customSeries.getData();
	    var group = this.group;
	    var renderItem = makeRenderItem(customSeries, data, ecModel, api); // By default, merge mode is applied. In most cases, custom series is
	    // used in the scenario that data amount is not large but graphic elements
	    // is complicated, where merge mode is probably necessary for optimization.
	    // For example, reuse graphic elements and only update the transform when
	    // roam or data zoom according to `actionType`.
	
	    data.diff(oldData).add(function (newIdx) {
	      createOrUpdate(null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
	    }).update(function (newIdx, oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      createOrUpdate(el, newIdx, renderItem(newIdx, payload), customSeries, group, data);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute(); // Do clipping
	
	    var clipPath = customSeries.get('clip', true) ? createClipPath(customSeries.coordinateSystem, false, customSeries) : null;
	
	    if (clipPath) {
	      group.setClipPath(clipPath);
	    } else {
	      group.removeClipPath();
	    }
	
	    this._data = data;
	  },
	  incrementalPrepareRender: function (customSeries, ecModel, api) {
	    this.group.removeAll();
	    this._data = null;
	  },
	  incrementalRender: function (params, customSeries, ecModel, api, payload) {
	    var data = customSeries.getData();
	    var renderItem = makeRenderItem(customSeries, data, ecModel, api);
	
	    function setIncrementalAndHoverLayer(el) {
	      if (!el.isGroup) {
	        el.incremental = true;
	        el.useHoverLayer = true;
	      }
	    }
	
	    for (var idx = params.start; idx < params.end; idx++) {
	      var el = createOrUpdate(null, idx, renderItem(idx, payload), customSeries, this.group, data);
	      el.traverse(setIncrementalAndHoverLayer);
	    }
	  },
	
	  /**
	   * @override
	   */
	  dispose: zrUtil.noop,
	
	  /**
	   * @override
	   */
	  filterForExposedEvent: function (eventType, query, targetEl, packedEvent) {
	    var elementName = query.element;
	
	    if (elementName == null || targetEl.name === elementName) {
	      return true;
	    } // Enable to give a name on a group made by `renderItem`, and listen
	    // events that triggerd by its descendents.
	
	
	    while ((targetEl = targetEl.parent) && targetEl !== this.group) {
	      if (targetEl.name === elementName) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	});
	
	function createEl(elOption) {
	  var graphicType = elOption.type;
	  var el; // Those graphic elements are not shapes. They should not be
	  // overwritten by users, so do them first.
	
	  if (graphicType === 'path') {
	    var shape = elOption.shape; // Using pathRect brings convenience to users sacle svg path.
	
	    var pathRect = shape.width != null && shape.height != null ? {
	      x: shape.x || 0,
	      y: shape.y || 0,
	      width: shape.width,
	      height: shape.height
	    } : null;
	    var pathData = getPathData(shape); // Path is also used for icon, so layout 'center' by default.
	
	    el = graphicUtil.makePath(pathData, null, pathRect, shape.layout || 'center');
	    el.__customPathData = pathData;
	  } else if (graphicType === 'image') {
	    el = new graphicUtil.Image({});
	    el.__customImagePath = elOption.style.image;
	  } else if (graphicType === 'text') {
	    el = new graphicUtil.Text({});
	    el.__customText = elOption.style.text;
	  } else if (graphicType === 'group') {
	    el = new graphicUtil.Group();
	  } else if (graphicType === 'compoundPath') {
	    throw new Error('"compoundPath" is not supported yet.');
	  } else {
	    var Clz = graphicUtil.getShapeClass(graphicType);
	    el = new Clz();
	  }
	
	  el.__customGraphicType = graphicType;
	  el.name = elOption.name;
	  return el;
	}
	
	function updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot) {
	  var transitionProps = {};
	  var elOptionStyle = elOption.style || {};
	  elOption.shape && (transitionProps.shape = zrUtil.clone(elOption.shape));
	  elOption.position && (transitionProps.position = elOption.position.slice());
	  elOption.scale && (transitionProps.scale = elOption.scale.slice());
	  elOption.origin && (transitionProps.origin = elOption.origin.slice());
	  elOption.rotation && (transitionProps.rotation = elOption.rotation);
	
	  if (el.type === 'image' && elOption.style) {
	    var targetStyle = transitionProps.style = {};
	    zrUtil.each(['x', 'y', 'width', 'height'], function (prop) {
	      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
	    });
	  }
	
	  if (el.type === 'text' && elOption.style) {
	    var targetStyle = transitionProps.style = {};
	    zrUtil.each(['x', 'y'], function (prop) {
	      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
	    }); // Compatible with previous: both support
	    // textFill and fill, textStroke and stroke in 'text' element.
	
	    !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
	    !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
	  }
	
	  if (el.type !== 'group') {
	    el.useStyle(elOptionStyle); // Init animation.
	
	    if (isInit) {
	      el.style.opacity = 0;
	      var targetOpacity = elOptionStyle.opacity;
	      targetOpacity == null && (targetOpacity = 1);
	      graphicUtil.initProps(el, {
	        style: {
	          opacity: targetOpacity
	        }
	      }, animatableModel, dataIndex);
	    }
	  }
	
	  if (isInit) {
	    el.attr(transitionProps);
	  } else {
	    graphicUtil.updateProps(el, transitionProps, animatableModel, dataIndex);
	  } // Merge by default.
	  // z2 must not be null/undefined, otherwise sort error may occur.
	
	
	  elOption.hasOwnProperty('z2') && el.attr('z2', elOption.z2 || 0);
	  elOption.hasOwnProperty('silent') && el.attr('silent', elOption.silent);
	  elOption.hasOwnProperty('invisible') && el.attr('invisible', elOption.invisible);
	  elOption.hasOwnProperty('ignore') && el.attr('ignore', elOption.ignore); // `elOption.info` enables user to mount some info on
	  // elements and use them in event handlers.
	  // Update them only when user specified, otherwise, remain.
	
	  elOption.hasOwnProperty('info') && el.attr('info', elOption.info); // If `elOption.styleEmphasis` is `false`, remove hover style. The
	  // logic is ensured by `graphicUtil.setElementHoverStyle`.
	
	  var styleEmphasis = elOption.styleEmphasis; // hoverStyle should always be set here, because if the hover style
	  // may already be changed, where the inner cache should be reset.
	
	  graphicUtil.setElementHoverStyle(el, styleEmphasis);
	
	  if (isRoot) {
	    graphicUtil.setAsHighDownDispatcher(el, styleEmphasis !== false);
	  }
	}
	
	function prepareStyleTransition(prop, targetStyle, elOptionStyle, oldElStyle, isInit) {
	  if (elOptionStyle[prop] != null && !isInit) {
	    targetStyle[prop] = elOptionStyle[prop];
	    elOptionStyle[prop] = oldElStyle[prop];
	  }
	}
	
	function makeRenderItem(customSeries, data, ecModel, api) {
	  var renderItem = customSeries.get('renderItem');
	  var coordSys = customSeries.coordinateSystem;
	  var prepareResult = {};
	
	  if (coordSys) {
	    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms() : prepareCustoms[coordSys.type](coordSys);
	  }
	
	  var userAPI = zrUtil.defaults({
	    getWidth: api.getWidth,
	    getHeight: api.getHeight,
	    getZr: api.getZr,
	    getDevicePixelRatio: api.getDevicePixelRatio,
	    value: value,
	    style: style,
	    styleEmphasis: styleEmphasis,
	    visual: visual,
	    barLayout: barLayout,
	    currentSeriesIndices: currentSeriesIndices,
	    font: font
	  }, prepareResult.api || {});
	  var userParams = {
	    // The life cycle of context: current round of rendering.
	    // The global life cycle is probably not necessary, because
	    // user can store global status by themselves.
	    context: {},
	    seriesId: customSeries.id,
	    seriesName: customSeries.name,
	    seriesIndex: customSeries.seriesIndex,
	    coordSys: prepareResult.coordSys,
	    dataInsideLength: data.count(),
	    encode: wrapEncodeDef(customSeries.getData())
	  }; // Do not support call `api` asynchronously without dataIndexInside input.
	
	  var currDataIndexInside;
	  var currDirty = true;
	  var currItemModel;
	  var currLabelNormalModel;
	  var currLabelEmphasisModel;
	  var currVisualColor;
	  return function (dataIndexInside, payload) {
	    currDataIndexInside = dataIndexInside;
	    currDirty = true;
	    return renderItem && renderItem(zrUtil.defaults({
	      dataIndexInside: dataIndexInside,
	      dataIndex: data.getRawIndex(dataIndexInside),
	      // Can be used for optimization when zoom or roam.
	      actionType: payload ? payload.type : null
	    }, userParams), userAPI);
	  }; // Do not update cache until api called.
	
	  function updateCache(dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	
	    if (currDirty) {
	      currItemModel = data.getItemModel(dataIndexInside);
	      currLabelNormalModel = currItemModel.getModel(LABEL_NORMAL);
	      currLabelEmphasisModel = currItemModel.getModel(LABEL_EMPHASIS);
	      currVisualColor = data.getItemVisual(dataIndexInside, 'color');
	      currDirty = false;
	    }
	  }
	  /**
	   * @public
	   * @param {number|string} dim
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   * @return {number|string} value
	   */
	
	
	  function value(dim, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    return data.get(data.getDimension(dim || 0), dataIndexInside);
	  }
	  /**
	   * By default, `visual` is applied to style (to support visualMap).
	   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
	   * it can be implemented as:
	   * `api.style({stroke: api.visual('color'), fill: null})`;
	   * @public
	   * @param {Object} [extra]
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function style(extra, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    updateCache(dataIndexInside);
	    var itemStyle = currItemModel.getModel(ITEM_STYLE_NORMAL_PATH).getItemStyle();
	    currVisualColor != null && (itemStyle.fill = currVisualColor);
	    var opacity = data.getItemVisual(dataIndexInside, 'opacity');
	    opacity != null && (itemStyle.opacity = opacity);
	    var labelModel = extra ? applyExtraBefore(extra, currLabelNormalModel) : currLabelNormalModel;
	    graphicUtil.setTextStyle(itemStyle, labelModel, null, {
	      autoColor: currVisualColor,
	      isRectText: true
	    });
	    itemStyle.text = labelModel.getShallow('show') ? zrUtil.retrieve2(customSeries.getFormattedLabel(dataIndexInside, 'normal'), getDefaultLabel(data, dataIndexInside)) : null;
	    extra && applyExtraAfter(itemStyle, extra);
	    return itemStyle;
	  }
	  /**
	   * @public
	   * @param {Object} [extra]
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function styleEmphasis(extra, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    updateCache(dataIndexInside);
	    var itemStyle = currItemModel.getModel(ITEM_STYLE_EMPHASIS_PATH).getItemStyle();
	    var labelModel = extra ? applyExtraBefore(extra, currLabelEmphasisModel) : currLabelEmphasisModel;
	    graphicUtil.setTextStyle(itemStyle, labelModel, null, {
	      isRectText: true
	    }, true);
	    itemStyle.text = labelModel.getShallow('show') ? zrUtil.retrieve3(customSeries.getFormattedLabel(dataIndexInside, 'emphasis'), customSeries.getFormattedLabel(dataIndexInside, 'normal'), getDefaultLabel(data, dataIndexInside)) : null;
	    extra && applyExtraAfter(itemStyle, extra);
	    return itemStyle;
	  }
	  /**
	   * @public
	   * @param {string} visualType
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function visual(visualType, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    return data.getItemVisual(dataIndexInside, visualType);
	  }
	  /**
	   * @public
	   * @param {number} opt.count Positive interger.
	   * @param {number} [opt.barWidth]
	   * @param {number} [opt.barMaxWidth]
	   * @param {number} [opt.barMinWidth]
	   * @param {number} [opt.barGap]
	   * @param {number} [opt.barCategoryGap]
	   * @return {Object} {width, offset, offsetCenter} is not support, return undefined.
	   */
	
	
	  function barLayout(opt) {
	    if (coordSys.getBaseAxis) {
	      var baseAxis = coordSys.getBaseAxis();
	      return getLayoutOnAxis(zrUtil.defaults({
	        axis: baseAxis
	      }, opt), api);
	    }
	  }
	  /**
	   * @public
	   * @return {Array.<number>}
	   */
	
	
	  function currentSeriesIndices() {
	    return ecModel.getCurrentSeriesIndices();
	  }
	  /**
	   * @public
	   * @param {Object} opt
	   * @param {string} [opt.fontStyle]
	   * @param {number} [opt.fontWeight]
	   * @param {number} [opt.fontSize]
	   * @param {string} [opt.fontFamily]
	   * @return {string} font string
	   */
	
	
	  function font(opt) {
	    return graphicUtil.getFont(opt, ecModel);
	  }
	}
	
	function wrapEncodeDef(data) {
	  var encodeDef = {};
	  zrUtil.each(data.dimensions, function (dimName, dataDimIndex) {
	    var dimInfo = data.getDimensionInfo(dimName);
	
	    if (!dimInfo.isExtraCoord) {
	      var coordDim = dimInfo.coordDim;
	      var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
	      dataDims[dimInfo.coordDimIndex] = dataDimIndex;
	    }
	  });
	  return encodeDef;
	}
	
	function createOrUpdate(el, dataIndex, elOption, animatableModel, group, data) {
	  el = doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, true);
	  el && data.setItemGraphicEl(dataIndex, el);
	  return el;
	}
	
	function doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, isRoot) {
	  // [Rule]
	  // By default, follow merge mode.
	  //     (It probably brings benifit for performance in some cases of large data, where
	  //     user program can be optimized to that only updated props needed to be re-calculated,
	  //     or according to `actionType` some calculation can be skipped.)
	  // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
	  //     (It seems that violate the "merge" principle, but most of users probably intuitively
	  //     regard "return;" as "show nothing element whatever", so make a exception to meet the
	  //     most cases.)
	  var simplyRemove = !elOption; // `null`/`undefined`/`false`
	
	  elOption = elOption || {};
	  var elOptionType = elOption.type;
	  var elOptionShape = elOption.shape;
	  var elOptionStyle = elOption.style;
	
	  if (el && (simplyRemove // || elOption.$merge === false
	  // If `elOptionType` is `null`, follow the merge principle.
	  || elOptionType != null && elOptionType !== el.__customGraphicType || elOptionType === 'path' && hasOwnPathData(elOptionShape) && getPathData(elOptionShape) !== el.__customPathData || elOptionType === 'image' && hasOwn(elOptionStyle, 'image') && elOptionStyle.image !== el.__customImagePath // FIXME test and remove this restriction?
	  || elOptionType === 'text' && hasOwn(elOptionShape, 'text') && elOptionStyle.text !== el.__customText)) {
	    group.remove(el);
	    el = null;
	  } // `elOption.type` is undefined when `renderItem` returns nothing.
	
	
	  if (simplyRemove) {
	    return;
	  }
	
	  var isInit = !el;
	  !el && (el = createEl(elOption));
	  updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot);
	
	  if (elOptionType === 'group') {
	    mergeChildren(el, dataIndex, elOption, animatableModel, data);
	  } // Always add whatever already added to ensure sequence.
	
	
	  group.add(el);
	  return el;
	} // Usage:
	// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates that
	//     the existing children will not be removed, and enables the feature that
	//     update some of the props of some of the children simply by construct
	//     the returned children of `renderItem` like:
	//     `var children = group.children = []; children[3] = {opacity: 0.5};`
	// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
	//     by child.name. But that might be lower performance.
	// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
	//     replaced totally.
	// (4) If `!elOption.children`, following the "merge" principle, nothing will happen.
	//
	// For implementation simpleness, do not provide a direct way to remove sinlge
	// child (otherwise the total indicies of the children array have to be modified).
	// User can remove a single child by set its `ignore` as `true` or replace
	// it by another element, where its `$merge` can be set as `true` if necessary.
	
	
	function mergeChildren(el, dataIndex, elOption, animatableModel, data) {
	  var newChildren = elOption.children;
	  var newLen = newChildren ? newChildren.length : 0;
	  var mergeChildren = elOption.$mergeChildren; // `diffChildrenByName` has been deprecated.
	
	  var byName = mergeChildren === 'byName' || elOption.diffChildrenByName;
	  var notMerge = mergeChildren === false; // For better performance on roam update, only enter if necessary.
	
	  if (!newLen && !byName && !notMerge) {
	    return;
	  }
	
	  if (byName) {
	    diffGroupChildren({
	      oldChildren: el.children() || [],
	      newChildren: newChildren || [],
	      dataIndex: dataIndex,
	      animatableModel: animatableModel,
	      group: el,
	      data: data
	    });
	    return;
	  }
	
	  notMerge && el.removeAll(); // Mapping children of a group simply by index, which
	  // might be better performance.
	
	  var index = 0;
	
	  for (; index < newLen; index++) {
	    newChildren[index] && doCreateOrUpdate(el.childAt(index), dataIndex, newChildren[index], animatableModel, el, data);
	  }
	}
	
	function diffGroupChildren(context) {
	  new DataDiffer(context.oldChildren, context.newChildren, getKey, getKey, context).add(processAddUpdate).update(processAddUpdate).remove(processRemove).execute();
	}
	
	function getKey(item, idx) {
	  var name = item && item.name;
	  return name != null ? name : GROUP_DIFF_PREFIX + idx;
	}
	
	function processAddUpdate(newIndex, oldIndex) {
	  var context = this.context;
	  var childOption = newIndex != null ? context.newChildren[newIndex] : null;
	  var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
	  doCreateOrUpdate(child, context.dataIndex, childOption, context.animatableModel, context.group, context.data);
	} // `graphic#applyDefaultTextStyle` will cache
	// textFill, textStroke, textStrokeWidth.
	// We have to do this trick.
	
	
	function applyExtraBefore(extra, model) {
	  var dummyModel = new Model({}, model);
	  zrUtil.each(CACHED_LABEL_STYLE_PROPERTIES, function (stylePropName, modelPropName) {
	    if (extra.hasOwnProperty(stylePropName)) {
	      dummyModel.option[modelPropName] = extra[stylePropName];
	    }
	  });
	  return dummyModel;
	}
	
	function applyExtraAfter(itemStyle, extra) {
	  for (var key in extra) {
	    if (extra.hasOwnProperty(key) || !CACHED_LABEL_STYLE_PROPERTIES.hasOwnProperty(key)) {
	      itemStyle[key] = extra[key];
	    }
	  }
	}
	
	function processRemove(oldIndex) {
	  var context = this.context;
	  var child = context.oldChildren[oldIndex];
	  child && context.group.remove(child);
	}
	
	function getPathData(shape) {
	  // "d" follows the SVG convention.
	  return shape && (shape.pathData || shape.d);
	}
	
	function hasOwnPathData(shape) {
	  return shape && (shape.hasOwnProperty('pathData') || shape.hasOwnProperty('d'));
	}
	
	function hasOwn(host, prop) {
	  return host && host.hasOwnProperty(prop);
	}

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  dataItem = dataItem || [0, 0];
	  return zrUtil.map(['x', 'y'], function (dim, dimIdx) {
	    var axis = this.getAxis(dim);
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	  }, this);
	}
	
	function _default(coordSys) {
	  var rect = coordSys.grid.getRect();
	  return {
	    coordSys: {
	      // The name exposed to user is always 'cartesian2d' but not 'grid'.
	      type: 'cartesian2d',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: function (data) {
	        // do not provide "out" param
	        return coordSys.dataToPoint(data);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  dataItem = dataItem || [0, 0];
	  return zrUtil.map([0, 1], function (dimIdx) {
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    var p1 = [];
	    var p2 = [];
	    p1[dimIdx] = val - halfSize;
	    p2[dimIdx] = val + halfSize;
	    p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
	    return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
	  }, this);
	}
	
	function _default(coordSys) {
	  var rect = coordSys.getBoundingRect();
	  return {
	    coordSys: {
	      type: 'geo',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height,
	      zoom: coordSys.getZoom()
	    },
	    api: {
	      coord: function (data) {
	        // do not provide "out" and noRoam param,
	        // Compatible with this usage:
	        // echarts.util.map(item.points, api.coord)
	        return coordSys.dataToPoint(data);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  var axis = this.getAxis();
	  var val = dataItem instanceof Array ? dataItem[0] : dataItem;
	  var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
	  return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	}
	
	function _default(coordSys) {
	  var rect = coordSys.getRect();
	  return {
	    coordSys: {
	      type: 'singleAxis',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: function (val) {
	        // do not provide "out" param
	        return coordSys.dataToPoint(val);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  return zrUtil.map(['Radius', 'Angle'], function (dim, dimIdx) {
	    var axis = this['get' + dim + 'Axis']();
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    var method = 'dataTo' + dim;
	    var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis[method](val - halfSize) - axis[method](val + halfSize));
	
	    if (dim === 'Angle') {
	      result = result * Math.PI / 180;
	    }
	
	    return result;
	  }, this);
	}
	
	function _default(coordSys) {
	  var radiusAxis = coordSys.getRadiusAxis();
	  var angleAxis = coordSys.getAngleAxis();
	  var radius = radiusAxis.getExtent();
	  radius[0] > radius[1] && radius.reverse();
	  return {
	    coordSys: {
	      type: 'polar',
	      cx: coordSys.cx,
	      cy: coordSys.cy,
	      r: radius[1],
	      r0: radius[0]
	    },
	    api: {
	      coord: zrUtil.bind(function (data) {
	        var radius = radiusAxis.dataToRadius(data[0]);
	        var angle = angleAxis.dataToAngle(data[1]);
	        var coord = coordSys.coordToPoint([radius, angle]);
	        coord.push(radius, angle * Math.PI / 180);
	        return coord;
	      }),
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 589 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(coordSys) {
	  var rect = coordSys.getRect();
	  var rangeInfo = coordSys.getRangeInfo();
	  return {
	    coordSys: {
	      type: 'calendar',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height,
	      cellWidth: coordSys.getCellWidth(),
	      cellHeight: coordSys.getCellHeight(),
	      rangeInfo: {
	        start: rangeInfo.start,
	        end: rangeInfo.end,
	        weeks: rangeInfo.weeks,
	        dayCount: rangeInfo.allDay
	      }
	    },
	    api: {
	      coord: function (data, clamp) {
	        return coordSys.dataToPoint(data, clamp);
	      }
	    }
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(379);
	
	__webpack_require__(570);
	
	__webpack_require__(564);

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var barPolar = __webpack_require__(592);
	
	__webpack_require__(593);
	
	__webpack_require__(599);
	
	__webpack_require__(601);
	
	__webpack_require__(564);
	
	__webpack_require__(603);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// For reducing size of echarts.min, barLayoutPolar is required by polar.
	echarts.registerLayout(zrUtil.curry(barPolar, 'bar')); // Polar view
	
	echarts.extendComponentView({
	  type: 'polar'
	});

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	
	var _dataStackHelper = __webpack_require__(349);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getSeriesStackId(seriesModel) {
	  return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
	}
	
	function getAxisKey(polar, axis) {
	  return axis.dim + polar.model.componentIndex;
	}
	/**
	 * @param {string} seriesType
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function barLayoutPolar(seriesType, ecModel, api) {
	  var lastStackCoords = {};
	  var barWidthAndOffset = calRadialBar(zrUtil.filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
	    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
	  }));
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    // Check series coordinate, do layout for polar only
	    if (seriesModel.coordinateSystem.type !== 'polar') {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var polar = seriesModel.coordinateSystem;
	    var baseAxis = polar.getBaseAxis();
	    var axisKey = getAxisKey(polar, baseAxis);
	    var stackId = getSeriesStackId(seriesModel);
	    var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
	    var columnOffset = columnLayoutInfo.offset;
	    var columnWidth = columnLayoutInfo.width;
	    var valueAxis = polar.getOtherAxis(baseAxis);
	    var cx = seriesModel.coordinateSystem.cx;
	    var cy = seriesModel.coordinateSystem.cy;
	    var barMinHeight = seriesModel.get('barMinHeight') || 0;
	    var barMinAngle = seriesModel.get('barMinAngle') || 0;
	    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var stacked = isDimensionStacked(data, valueDim
	    /*, baseDim*/
	    );
	    var clampLayout = baseAxis.dim !== 'radius' || !seriesModel.get('roundCap', true);
	    var valueAxisStart = valueAxis.dim === 'radius' ? valueAxis.dataToRadius(0) : valueAxis.dataToAngle(0);
	
	    for (var idx = 0, len = data.count(); idx < len; idx++) {
	      var value = data.get(valueDim, idx);
	      var baseValue = data.get(baseDim, idx);
	      var sign = value >= 0 ? 'p' : 'n';
	      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
	      // stackResultDimension directly.
	      // Only ordinal axis can be stacked.
	
	      if (stacked) {
	        if (!lastStackCoords[stackId][baseValue]) {
	          lastStackCoords[stackId][baseValue] = {
	            p: valueAxisStart,
	            // Positive stack
	            n: valueAxisStart // Negative stack
	
	          };
	        } // Should also consider #4243
	
	
	        baseCoord = lastStackCoords[stackId][baseValue][sign];
	      }
	
	      var r0;
	      var r;
	      var startAngle;
	      var endAngle; // radial sector
	
	      if (valueAxis.dim === 'radius') {
	        var radiusSpan = valueAxis.dataToRadius(value) - valueAxisStart;
	        var angle = baseAxis.dataToAngle(baseValue);
	
	        if (Math.abs(radiusSpan) < barMinHeight) {
	          radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
	        }
	
	        r0 = baseCoord;
	        r = baseCoord + radiusSpan;
	        startAngle = angle - columnOffset;
	        endAngle = startAngle - columnWidth;
	        stacked && (lastStackCoords[stackId][baseValue][sign] = r);
	      } // tangential sector
	      else {
	          var angleSpan = valueAxis.dataToAngle(value, clampLayout) - valueAxisStart;
	          var radius = baseAxis.dataToRadius(baseValue);
	
	          if (Math.abs(angleSpan) < barMinAngle) {
	            angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
	          }
	
	          r0 = radius + columnOffset;
	          r = r0 + columnWidth;
	          startAngle = baseCoord;
	          endAngle = baseCoord + angleSpan; // if the previous stack is at the end of the ring,
	          // add a round to differentiate it from origin
	          // var extent = angleAxis.getExtent();
	          // var stackCoord = angle;
	          // if (stackCoord === extent[0] && value > 0) {
	          //     stackCoord = extent[1];
	          // }
	          // else if (stackCoord === extent[1] && value < 0) {
	          //     stackCoord = extent[0];
	          // }
	
	          stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
	        }
	
	      data.setItemLayout(idx, {
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: r,
	        // Consider that positive angle is anti-clockwise,
	        // while positive radian of sector is clockwise
	        startAngle: -startAngle * Math.PI / 180,
	        endAngle: -endAngle * Math.PI / 180
	      });
	    }
	  }, this);
	}
	/**
	 * Calculate bar width and offset for radial bar charts
	 */
	
	
	function calRadialBar(barSeries, api) {
	  // Columns info on each category axis. Key is polar name
	  var columnsMap = {};
	  zrUtil.each(barSeries, function (seriesModel, idx) {
	    var data = seriesModel.getData();
	    var polar = seriesModel.coordinateSystem;
	    var baseAxis = polar.getBaseAxis();
	    var axisKey = getAxisKey(polar, baseAxis);
	    var axisExtent = baseAxis.getExtent();
	    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	    var columnsOnAxis = columnsMap[axisKey] || {
	      bandWidth: bandWidth,
	      remainedWidth: bandWidth,
	      autoWidthCount: 0,
	      categoryGap: '20%',
	      gap: '30%',
	      stacks: {}
	    };
	    var stacks = columnsOnAxis.stacks;
	    columnsMap[axisKey] = columnsOnAxis;
	    var stackId = getSeriesStackId(seriesModel);
	
	    if (!stacks[stackId]) {
	      columnsOnAxis.autoWidthCount++;
	    }
	
	    stacks[stackId] = stacks[stackId] || {
	      width: 0,
	      maxWidth: 0
	    };
	    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
	    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
	    var barGap = seriesModel.get('barGap');
	    var barCategoryGap = seriesModel.get('barCategoryGap');
	
	    if (barWidth && !stacks[stackId].width) {
	      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	      stacks[stackId].width = barWidth;
	      columnsOnAxis.remainedWidth -= barWidth;
	    }
	
	    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	    barGap != null && (columnsOnAxis.gap = barGap);
	    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	  });
	  var result = {};
	  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
	    result[coordSysName] = {};
	    var stacks = columnsOnAxis.stacks;
	    var bandWidth = columnsOnAxis.bandWidth;
	    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
	    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
	    var remainedWidth = columnsOnAxis.remainedWidth;
	    var autoWidthCount = columnsOnAxis.autoWidthCount;
	    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	    zrUtil.each(stacks, function (column, stack) {
	      var maxWidth = column.maxWidth;
	
	      if (maxWidth && maxWidth < autoWidth) {
	        maxWidth = Math.min(maxWidth, remainedWidth);
	
	        if (column.width) {
	          maxWidth = Math.min(maxWidth, column.width);
	        }
	
	        remainedWidth -= maxWidth;
	        column.width = maxWidth;
	        autoWidthCount--;
	      }
	    }); // Recalculate width again
	
	    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0);
	    var widthSum = 0;
	    var lastColumn;
	    zrUtil.each(stacks, function (column, idx) {
	      if (!column.width) {
	        column.width = autoWidth;
	      }
	
	      lastColumn = column;
	      widthSum += column.width * (1 + barGapPercent);
	    });
	
	    if (lastColumn) {
	      widthSum -= lastColumn.width * barGapPercent;
	    }
	
	    var offset = -widthSum / 2;
	    zrUtil.each(stacks, function (column, stackId) {
	      result[coordSysName][stackId] = result[coordSysName][stackId] || {
	        offset: offset,
	        width: column.width
	      };
	      offset += column.width * (1 + barGapPercent);
	    });
	  });
	  return result;
	}
	
	var _default = barLayoutPolar;
	module.exports = _default;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(220);
	
	var Polar = __webpack_require__(594);
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	
	var _axisHelper = __webpack_require__(350);
	
	var createScaleByModel = _axisHelper.createScaleByModel;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	
	var CoordinateSystem = __webpack_require__(315);
	
	var _dataStackHelper = __webpack_require__(349);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	__webpack_require__(597);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Axis scale
	
	/**
	 * Resize method bound to the polar
	 * @param {module:echarts/coord/polar/PolarModel} polarModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function resizePolar(polar, polarModel, api) {
	  var center = polarModel.get('center');
	  var width = api.getWidth();
	  var height = api.getHeight();
	  polar.cx = parsePercent(center[0], width);
	  polar.cy = parsePercent(center[1], height);
	  var radiusAxis = polar.getRadiusAxis();
	  var size = Math.min(width, height) / 2;
	  var radius = polarModel.get('radius');
	
	  if (radius == null) {
	    radius = [0, '100%'];
	  } else if (!zrUtil.isArray(radius)) {
	    // r0 = 0
	    radius = [0, radius];
	  }
	
	  radius = [parsePercent(radius[0], size), parsePercent(radius[1], size)];
	  radiusAxis.inverse ? radiusAxis.setExtent(radius[1], radius[0]) : radiusAxis.setExtent(radius[0], radius[1]);
	}
	/**
	 * Update polar
	 */
	
	
	function updatePolarScale(ecModel, api) {
	  var polar = this;
	  var angleAxis = polar.getAngleAxis();
	  var radiusAxis = polar.getRadiusAxis(); // Reset scale
	
	  angleAxis.scale.setExtent(Infinity, -Infinity);
	  radiusAxis.scale.setExtent(Infinity, -Infinity);
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.coordinateSystem === polar) {
	      var data = seriesModel.getData();
	      zrUtil.each(data.mapDimension('radius', true), function (dim) {
	        radiusAxis.scale.unionExtentFromData(data, getStackedDimension(data, dim));
	      });
	      zrUtil.each(data.mapDimension('angle', true), function (dim) {
	        angleAxis.scale.unionExtentFromData(data, getStackedDimension(data, dim));
	      });
	    }
	  });
	  niceScaleExtent(angleAxis.scale, angleAxis.model);
	  niceScaleExtent(radiusAxis.scale, radiusAxis.model); // Fix extent of category angle axis
	
	  if (angleAxis.type === 'category' && !angleAxis.onBand) {
	    var extent = angleAxis.getExtent();
	    var diff = 360 / angleAxis.scale.count();
	    angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
	    angleAxis.setExtent(extent[0], extent[1]);
	  }
	}
	/**
	 * Set common axis properties
	 * @param {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	 * @param {module:echarts/coord/polar/AxisModel}
	 * @inner
	 */
	
	
	function setAxis(axis, axisModel) {
	  axis.type = axisModel.get('type');
	  axis.scale = createScaleByModel(axisModel);
	  axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
	  axis.inverse = axisModel.get('inverse');
	
	  if (axisModel.mainType === 'angleAxis') {
	    axis.inverse ^= axisModel.get('clockwise');
	    var startAngle = axisModel.get('startAngle');
	    axis.setExtent(startAngle, startAngle + (axis.inverse ? -360 : 360));
	  } // Inject axis instance
	
	
	  axisModel.axis = axis;
	  axis.model = axisModel;
	}
	
	var polarCreator = {
	  dimensions: Polar.prototype.dimensions,
	  create: function (ecModel, api) {
	    var polarList = [];
	    ecModel.eachComponent('polar', function (polarModel, idx) {
	      var polar = new Polar(idx); // Inject resize and update method
	
	      polar.update = updatePolarScale;
	      var radiusAxis = polar.getRadiusAxis();
	      var angleAxis = polar.getAngleAxis();
	      var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	      var angleAxisModel = polarModel.findAxisModel('angleAxis');
	      setAxis(radiusAxis, radiusAxisModel);
	      setAxis(angleAxis, angleAxisModel);
	      resizePolar(polar, polarModel, api);
	      polarList.push(polar);
	      polarModel.coordinateSystem = polar;
	      polar.model = polarModel;
	    }); // Inject coordinateSystem to series
	
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.get('coordinateSystem') === 'polar') {
	        var polarModel = ecModel.queryComponents({
	          mainType: 'polar',
	          index: seriesModel.get('polarIndex'),
	          id: seriesModel.get('polarId')
	        })[0];
	        seriesModel.coordinateSystem = polarModel.coordinateSystem;
	      }
	    });
	    return polarList;
	  }
	};
	CoordinateSystem.register('polar', polarCreator);

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var RadiusAxis = __webpack_require__(595);
	
	var AngleAxis = __webpack_require__(596);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/coord/polar/Polar
	 */
	
	/**
	 * @alias {module:echarts/coord/polar/Polar}
	 * @constructor
	 * @param {string} name
	 */
	var Polar = function (name) {
	  /**
	   * @type {string}
	   */
	  this.name = name || '';
	  /**
	   * x of polar center
	   * @type {number}
	   */
	
	  this.cx = 0;
	  /**
	   * y of polar center
	   * @type {number}
	   */
	
	  this.cy = 0;
	  /**
	   * @type {module:echarts/coord/polar/RadiusAxis}
	   * @private
	   */
	
	  this._radiusAxis = new RadiusAxis();
	  /**
	   * @type {module:echarts/coord/polar/AngleAxis}
	   * @private
	   */
	
	  this._angleAxis = new AngleAxis();
	  this._radiusAxis.polar = this._angleAxis.polar = this;
	};
	
	Polar.prototype = {
	  type: 'polar',
	  axisPointerEnabled: true,
	  constructor: Polar,
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['radius', 'angle'],
	
	  /**
	   * @type {module:echarts/coord/PolarModel}
	   */
	  model: null,
	
	  /**
	   * If contain coord
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var coord = this.pointToCoord(point);
	    return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
	  },
	
	  /**
	   * If contain data
	   * @param {Array.<number>} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
	  },
	
	  /**
	   * @param {string} dim
	   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  getAxis: function (dim) {
	    return this['_' + dim + 'Axis'];
	  },
	
	  /**
	   * @return {Array.<module:echarts/coord/Axis>}
	   */
	  getAxes: function () {
	    return [this._radiusAxis, this._angleAxis];
	  },
	
	  /**
	   * Get axes by type of scale
	   * @param {string} scaleType
	   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  getAxesByScale: function (scaleType) {
	    var axes = [];
	    var angleAxis = this._angleAxis;
	    var radiusAxis = this._radiusAxis;
	    angleAxis.scale.type === scaleType && axes.push(angleAxis);
	    radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
	    return axes;
	  },
	
	  /**
	   * @return {module:echarts/coord/polar/AngleAxis}
	   */
	  getAngleAxis: function () {
	    return this._angleAxis;
	  },
	
	  /**
	   * @return {module:echarts/coord/polar/RadiusAxis}
	   */
	  getRadiusAxis: function () {
	    return this._radiusAxis;
	  },
	
	  /**
	   * @param {module:echarts/coord/polar/Axis}
	   * @return {module:echarts/coord/polar/Axis}
	   */
	  getOtherAxis: function (axis) {
	    var angleAxis = this._angleAxis;
	    return axis === angleAxis ? this._radiusAxis : angleAxis;
	  },
	
	  /**
	   * Base axis will be used on stacking.
	   *
	   * @return {module:echarts/coord/polar/Axis}
	   */
	  getBaseAxis: function () {
	    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
	  },
	
	  /**
	   * @param {string} [dim] 'radius' or 'angle' or 'auto' or null/undefined
	   * @return {Object} {baseAxes: [], otherAxes: []}
	   */
	  getTooltipAxes: function (dim) {
	    var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
	    return {
	      baseAxes: [baseAxis],
	      otherAxes: [this.getOtherAxis(baseAxis)]
	    };
	  },
	
	  /**
	   * Convert a single data item to (x, y) point.
	   * Parameter data is an array which the first element is radius and the second is angle
	   * @param {Array.<number>} data
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, clamp) {
	    return this.coordToPoint([this._radiusAxis.dataToRadius(data[0], clamp), this._angleAxis.dataToAngle(data[1], clamp)]);
	  },
	
	  /**
	   * Convert a (x, y) point to data
	   * @param {Array.<number>} point
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  pointToData: function (point, clamp) {
	    var coord = this.pointToCoord(point);
	    return [this._radiusAxis.radiusToData(coord[0], clamp), this._angleAxis.angleToData(coord[1], clamp)];
	  },
	
	  /**
	   * Convert a (x, y) point to (radius, angle) coord
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToCoord: function (point) {
	    var dx = point[0] - this.cx;
	    var dy = point[1] - this.cy;
	    var angleAxis = this.getAngleAxis();
	    var extent = angleAxis.getExtent();
	    var minAngle = Math.min(extent[0], extent[1]);
	    var maxAngle = Math.max(extent[0], extent[1]); // Fix fixed extent in polarCreator
	    // FIXME
	
	    angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
	    var radius = Math.sqrt(dx * dx + dy * dy);
	    dx /= radius;
	    dy /= radius;
	    var radian = Math.atan2(-dy, dx) / Math.PI * 180; // move to angleExtent
	
	    var dir = radian < minAngle ? 1 : -1;
	
	    while (radian < minAngle || radian > maxAngle) {
	      radian += dir * 360;
	    }
	
	    return [radius, radian];
	  },
	
	  /**
	   * Convert a (radius, angle) coord to (x, y) point
	   * @param {Array.<number>} coord
	   * @return {Array.<number>}
	   */
	  coordToPoint: function (coord) {
	    var radius = coord[0];
	    var radian = coord[1] / 180 * Math.PI;
	    var x = Math.cos(radian) * radius + this.cx; // Inverse the y
	
	    var y = -Math.sin(radian) * radius + this.cy;
	    return [x, y];
	  },
	
	  /**
	   * Get ring area of cartesian.
	   * Area will have a contain function to determine if a point is in the coordinate system.
	   * @return {Ring}
	   */
	  getArea: function () {
	    var angleAxis = this.getAngleAxis();
	    var radiusAxis = this.getRadiusAxis();
	    var radiusExtent = radiusAxis.getExtent().slice();
	    radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
	    var angleExtent = angleAxis.getExtent();
	    var RADIAN = Math.PI / 180;
	    return {
	      cx: this.cx,
	      cy: this.cy,
	      r0: radiusExtent[0],
	      r: radiusExtent[1],
	      startAngle: -angleExtent[0] * RADIAN,
	      endAngle: -angleExtent[1] * RADIAN,
	      clockwise: angleAxis.inverse,
	      contain: function (x, y) {
	        // It's a ring shape.
	        // Start angle and end angle don't matter
	        var dx = x - this.cx;
	        var dy = y - this.cy;
	        var d2 = dx * dx + dy * dy;
	        var r = this.r;
	        var r0 = this.r0;
	        return d2 <= r * r && d2 >= r0 * r0;
	      }
	    };
	  }
	};
	var _default = Polar;
	module.exports = _default;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Axis = __webpack_require__(364);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function RadiusAxis(scale, radiusExtent) {
	  Axis.call(this, 'radius', scale, radiusExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'category';
	}
	
	RadiusAxis.prototype = {
	  constructor: RadiusAxis,
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	  },
	  dataToRadius: Axis.prototype.dataToCoord,
	  radiusToData: Axis.prototype.coordToData
	};
	zrUtil.inherits(RadiusAxis, Axis);
	var _default = RadiusAxis;
	module.exports = _default;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var textContain = __webpack_require__(255);
	
	var Axis = __webpack_require__(364);
	
	var _model = __webpack_require__(261);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	
	function AngleAxis(scale, angleExtent) {
	  angleExtent = angleExtent || [0, 360];
	  Axis.call(this, 'angle', scale, angleExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'category';
	}
	
	AngleAxis.prototype = {
	  constructor: AngleAxis,
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	  },
	  dataToAngle: Axis.prototype.dataToCoord,
	  angleToData: Axis.prototype.coordToData,
	
	  /**
	   * Only be called in category axis.
	   * Angle axis uses text height to decide interval
	   *
	   * @override
	   * @return {number} Auto interval for cateogry axis tick and label
	   */
	  calculateCategoryInterval: function () {
	    var axis = this;
	    var labelModel = axis.getLabelModel();
	    var ordinalScale = axis.scale;
	    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
	    // avoid generating a long array by `getTicks`
	    // in large category data case.
	
	    var tickCount = ordinalScale.count();
	
	    if (ordinalExtent[1] - ordinalExtent[0] < 1) {
	      return 0;
	    }
	
	    var tickValue = ordinalExtent[0];
	    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
	    var unitH = Math.abs(unitSpan); // Not precise, just use height as text width
	    // and each distance from axis line yet.
	
	    var rect = textContain.getBoundingRect(tickValue, labelModel.getFont(), 'center', 'top');
	    var maxH = Math.max(rect.height, 7);
	    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
	
	    isNaN(dh) && (dh = Infinity);
	    var interval = Math.max(0, Math.floor(dh));
	    var cache = inner(axis.model);
	    var lastAutoInterval = cache.lastAutoInterval;
	    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
	    // otherwise the calculated interval might jitter when the zoom
	    // window size is close to the interval-changing size.
	
	    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
	    // point is not the same when zooming in or zooming out.
	    && lastAutoInterval > interval) {
	      interval = lastAutoInterval;
	    } // Only update cache if cache not used, otherwise the
	    // changing of interval is too insensitive.
	    else {
	        cache.lastTickCount = tickCount;
	        cache.lastAutoInterval = interval;
	      }
	
	    return interval;
	  }
	};
	zrUtil.inherits(AngleAxis, Axis);
	var _default = AngleAxis;
	module.exports = _default;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(598);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentModel({
	  type: 'polar',
	  dependencies: ['polarAxis', 'angleAxis'],
	
	  /**
	   * @type {module:echarts/coord/polar/Polar}
	   */
	  coordinateSystem: null,
	
	  /**
	   * @param {string} axisType
	   * @return {module:echarts/coord/polar/AxisModel}
	   */
	  findAxisModel: function (axisType) {
	    var foundAxisModel;
	    var ecModel = this.ecModel;
	    ecModel.eachComponent(axisType, function (axisModel) {
	      if (axisModel.getCoordSysModel() === this) {
	        foundAxisModel = axisModel;
	      }
	    }, this);
	    return foundAxisModel;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    center: ['50%', '50%'],
	    radius: '80%'
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var ComponentModel = __webpack_require__(303);
	
	var axisModelCreator = __webpack_require__(386);
	
	var axisModelCommonMixin = __webpack_require__(359);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PolarAxisModel = ComponentModel.extend({
	  type: 'polarAxis',
	
	  /**
	   * @type {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  axis: null,
	
	  /**
	   * @override
	   */
	  getCoordSysModel: function () {
	    return this.ecModel.queryComponents({
	      mainType: 'polar',
	      index: this.option.polarIndex,
	      id: this.option.polarId
	    })[0];
	  }
	});
	zrUtil.merge(PolarAxisModel.prototype, axisModelCommonMixin);
	var polarAxisDefaultExtendedOption = {
	  angle: {
	    // polarIndex: 0,
	    // polarId: '',
	    startAngle: 90,
	    clockwise: true,
	    splitNumber: 12,
	    axisLabel: {
	      rotate: false
	    }
	  },
	  radius: {
	    // polarIndex: 0,
	    // polarId: '',
	    splitNumber: 5
	  }
	};
	
	function getAxisType(axisDim, option) {
	  // Default axis with data is category axis
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	axisModelCreator('angle', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.angle);
	axisModelCreator('radius', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.radius);

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(593);
	
	__webpack_require__(600);

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var Model = __webpack_require__(262);
	
	var AxisView = __webpack_require__(391);
	
	var AxisBuilder = __webpack_require__(390);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var elementList = ['axisLine', 'axisLabel', 'axisTick', 'minorTick', 'splitLine', 'minorSplitLine', 'splitArea'];
	
	function getAxisLineShape(polar, rExtent, angle) {
	  rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
	  var start = polar.coordToPoint([rExtent[0], angle]);
	  var end = polar.coordToPoint([rExtent[1], angle]);
	  return {
	    x1: start[0],
	    y1: start[1],
	    x2: end[0],
	    y2: end[1]
	  };
	}
	
	function getRadiusIdx(polar) {
	  var radiusAxis = polar.getRadiusAxis();
	  return radiusAxis.inverse ? 0 : 1;
	} // Remove the last tick which will overlap the first tick
	
	
	function fixAngleOverlap(list) {
	  var firstItem = list[0];
	  var lastItem = list[list.length - 1];
	
	  if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) {
	    list.pop();
	  }
	}
	
	var _default = AxisView.extend({
	  type: 'angleAxis',
	  axisPointerClass: 'PolarAxisPointer',
	  render: function (angleAxisModel, ecModel) {
	    this.group.removeAll();
	
	    if (!angleAxisModel.get('show')) {
	      return;
	    }
	
	    var angleAxis = angleAxisModel.axis;
	    var polar = angleAxis.polar;
	    var radiusExtent = polar.getRadiusAxis().getExtent();
	    var ticksAngles = angleAxis.getTicksCoords();
	    var minorTickAngles = angleAxis.getMinorTicksCoords();
	    var labels = zrUtil.map(angleAxis.getViewLabels(), function (labelItem) {
	      var labelItem = zrUtil.clone(labelItem);
	      labelItem.coord = angleAxis.dataToCoord(labelItem.tickValue);
	      return labelItem;
	    });
	    fixAngleOverlap(labels);
	    fixAngleOverlap(ticksAngles);
	    zrUtil.each(elementList, function (name) {
	      if (angleAxisModel.get(name + '.show') && (!angleAxis.scale.isBlank() || name === 'axisLine')) {
	        this['_' + name](angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _axisLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    var lineStyleModel = angleAxisModel.getModel('axisLine.lineStyle'); // extent id of the axis radius (r0 and r)
	
	    var rId = getRadiusIdx(polar);
	    var r0Id = rId ? 0 : 1;
	    var shape;
	
	    if (radiusExtent[r0Id] === 0) {
	      shape = new graphic.Circle({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: radiusExtent[rId]
	        },
	        style: lineStyleModel.getLineStyle(),
	        z2: 1,
	        silent: true
	      });
	    } else {
	      shape = new graphic.Ring({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: radiusExtent[rId],
	          r0: radiusExtent[r0Id]
	        },
	        style: lineStyleModel.getLineStyle(),
	        z2: 1,
	        silent: true
	      });
	    }
	
	    shape.style.fill = null;
	    this.group.add(shape);
	  },
	
	  /**
	   * @private
	   */
	  _axisTick: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    var tickModel = angleAxisModel.getModel('axisTick');
	    var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
	    var radius = radiusExtent[getRadiusIdx(polar)];
	    var lines = zrUtil.map(ticksAngles, function (tickAngleItem) {
	      return new graphic.Line({
	        shape: getAxisLineShape(polar, [radius, radius + tickLen], tickAngleItem.coord)
	      });
	    });
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults(tickModel.getModel('lineStyle').getLineStyle(), {
	        stroke: angleAxisModel.get('axisLine.lineStyle.color')
	      })
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _minorTick: function (angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
	    if (!minorTickAngles.length) {
	      return;
	    }
	
	    var tickModel = angleAxisModel.getModel('axisTick');
	    var minorTickModel = angleAxisModel.getModel('minorTick');
	    var tickLen = (tickModel.get('inside') ? -1 : 1) * minorTickModel.get('length');
	    var radius = radiusExtent[getRadiusIdx(polar)];
	    var lines = [];
	
	    for (var i = 0; i < minorTickAngles.length; i++) {
	      for (var k = 0; k < minorTickAngles[i].length; k++) {
	        lines.push(new graphic.Line({
	          shape: getAxisLineShape(polar, [radius, radius + tickLen], minorTickAngles[i][k].coord)
	        }));
	      }
	    }
	
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults(minorTickModel.getModel('lineStyle').getLineStyle(), zrUtil.defaults(tickModel.getLineStyle(), {
	        stroke: angleAxisModel.get('axisLine.lineStyle.color')
	      }))
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _axisLabel: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
	    var rawCategoryData = angleAxisModel.getCategories(true);
	    var commonLabelModel = angleAxisModel.getModel('axisLabel');
	    var labelMargin = commonLabelModel.get('margin');
	    var triggerEvent = angleAxisModel.get('triggerEvent'); // Use length of ticksAngles because it may remove the last tick to avoid overlapping
	
	    zrUtil.each(labels, function (labelItem, idx) {
	      var labelModel = commonLabelModel;
	      var tickValue = labelItem.tickValue;
	      var r = radiusExtent[getRadiusIdx(polar)];
	      var p = polar.coordToPoint([r + labelMargin, labelItem.coord]);
	      var cx = polar.cx;
	      var cy = polar.cy;
	      var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
	      var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';
	
	      if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
	        labelModel = new Model(rawCategoryData[tickValue].textStyle, commonLabelModel, commonLabelModel.ecModel);
	      }
	
	      var textEl = new graphic.Text({
	        silent: AxisBuilder.isLabelSilent(angleAxisModel)
	      });
	      this.group.add(textEl);
	      graphic.setTextStyle(textEl.style, labelModel, {
	        x: p[0],
	        y: p[1],
	        textFill: labelModel.getTextColor() || angleAxisModel.get('axisLine.lineStyle.color'),
	        text: labelItem.formattedLabel,
	        textAlign: labelTextAlign,
	        textVerticalAlign: labelTextVerticalAlign
	      }); // Pack data for mouse event
	
	      if (triggerEvent) {
	        textEl.eventData = AxisBuilder.makeAxisEventDataBase(angleAxisModel);
	        textEl.eventData.targetType = 'axisLabel';
	        textEl.eventData.value = labelItem.rawLabel;
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _splitLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    var splitLineModel = angleAxisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineCount = 0;
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var splitLines = [];
	
	    for (var i = 0; i < ticksAngles.length; i++) {
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Line({
	        shape: getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
	      }));
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitLines.length; i++) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: zrUtil.defaults({
	          stroke: lineColors[i % lineColors.length]
	        }, lineStyleModel.getLineStyle()),
	        silent: true,
	        z: angleAxisModel.get('z')
	      }));
	    }
	  },
	
	  /**
	   * @private
	   */
	  _minorSplitLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    if (!minorTickAngles.length) {
	      return;
	    }
	
	    var minorSplitLineModel = angleAxisModel.getModel('minorSplitLine');
	    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	    var lines = [];
	
	    for (var i = 0; i < minorTickAngles.length; i++) {
	      for (var k = 0; k < minorTickAngles[i].length; k++) {
	        lines.push(new graphic.Line({
	          shape: getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
	        }));
	      }
	    }
	
	    this.group.add(graphic.mergePath(lines, {
	      style: lineStyleModel.getLineStyle(),
	      silent: true,
	      z: angleAxisModel.get('z')
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _splitArea: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    if (!ticksAngles.length) {
	      return;
	    }
	
	    var splitAreaModel = angleAxisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var lineCount = 0;
	    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	    var splitAreas = [];
	    var RADIAN = Math.PI / 180;
	    var prevAngle = -ticksAngles[0].coord * RADIAN;
	    var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
	    var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
	    var clockwise = angleAxisModel.get('clockwise');
	
	    for (var i = 1; i < ticksAngles.length; i++) {
	      var colorIndex = lineCount++ % areaColors.length;
	      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	      splitAreas[colorIndex].push(new graphic.Sector({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r0: r0,
	          r: r1,
	          startAngle: prevAngle,
	          endAngle: -ticksAngles[i].coord * RADIAN,
	          clockwise: clockwise
	        },
	        silent: true
	      }));
	      prevAngle = -ticksAngles[i].coord * RADIAN;
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitAreas.length; i++) {
	      this.group.add(graphic.mergePath(splitAreas[i], {
	        style: zrUtil.defaults({
	          fill: areaColors[i % areaColors.length]
	        }, areaStyleModel.getAreaStyle()),
	        silent: true
	      }));
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(593);
	
	__webpack_require__(602);

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var AxisBuilder = __webpack_require__(390);
	
	var AxisView = __webpack_require__(391);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitLine', 'splitArea', 'minorSplitLine'];
	
	var _default = AxisView.extend({
	  type: 'radiusAxis',
	  axisPointerClass: 'PolarAxisPointer',
	  render: function (radiusAxisModel, ecModel) {
	    this.group.removeAll();
	
	    if (!radiusAxisModel.get('show')) {
	      return;
	    }
	
	    var radiusAxis = radiusAxisModel.axis;
	    var polar = radiusAxis.polar;
	    var angleAxis = polar.getAngleAxis();
	    var ticksCoords = radiusAxis.getTicksCoords();
	    var minorTicksCoords = radiusAxis.getMinorTicksCoords();
	    var axisAngle = angleAxis.getExtent()[0];
	    var radiusExtent = radiusAxis.getExtent();
	    var layout = layoutAxis(polar, radiusAxisModel, axisAngle);
	    var axisBuilder = new AxisBuilder(radiusAxisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	    this.group.add(axisBuilder.getGroup());
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (radiusAxisModel.get(name + '.show') && !radiusAxis.scale.isBlank()) {
	        this['_' + name](radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _splitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	    var splitLineModel = radiusAxisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineCount = 0;
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var splitLines = [];
	
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Circle({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: ticksCoords[i].coord
	        }
	      }));
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitLines.length; i++) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: zrUtil.defaults({
	          stroke: lineColors[i % lineColors.length],
	          fill: null
	        }, lineStyleModel.getLineStyle()),
	        silent: true
	      }));
	    }
	  },
	
	  /**
	   * @private
	   */
	  _minorSplitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
	    if (!minorTicksCoords.length) {
	      return;
	    }
	
	    var minorSplitLineModel = radiusAxisModel.getModel('minorSplitLine');
	    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	    var lines = [];
	
	    for (var i = 0; i < minorTicksCoords.length; i++) {
	      for (var k = 0; k < minorTicksCoords[i].length; k++) {
	        lines.push(new graphic.Circle({
	          shape: {
	            cx: polar.cx,
	            cy: polar.cy,
	            r: minorTicksCoords[i][k].coord
	          }
	        }));
	      }
	    }
	
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults({
	        fill: null
	      }, lineStyleModel.getLineStyle()),
	      silent: true
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _splitArea: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	    if (!ticksCoords.length) {
	      return;
	    }
	
	    var splitAreaModel = radiusAxisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var lineCount = 0;
	    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	    var splitAreas = [];
	    var prevRadius = ticksCoords[0].coord;
	
	    for (var i = 1; i < ticksCoords.length; i++) {
	      var colorIndex = lineCount++ % areaColors.length;
	      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	      splitAreas[colorIndex].push(new graphic.Sector({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r0: prevRadius,
	          r: ticksCoords[i].coord,
	          startAngle: 0,
	          endAngle: Math.PI * 2
	        },
	        silent: true
	      }));
	      prevRadius = ticksCoords[i].coord;
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitAreas.length; i++) {
	      this.group.add(graphic.mergePath(splitAreas[i], {
	        style: zrUtil.defaults({
	          fill: areaColors[i % areaColors.length]
	        }, areaStyleModel.getAreaStyle()),
	        silent: true
	      }));
	    }
	  }
	});
	/**
	 * @inner
	 */
	
	
	function layoutAxis(polar, radiusAxisModel, axisAngle) {
	  return {
	    position: [polar.cx, polar.cy],
	    rotation: axisAngle / 180 * Math.PI,
	    labelDirection: -1,
	    tickDirection: -1,
	    nameDirection: 1,
	    labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
	    // Over splitLine and splitArea
	    z2: 1
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var formatUtil = __webpack_require__(307);
	
	var BaseAxisPointer = __webpack_require__(571);
	
	var graphic = __webpack_require__(268);
	
	var viewHelper = __webpack_require__(572);
	
	var matrix = __webpack_require__(233);
	
	var AxisBuilder = __webpack_require__(390);
	
	var AxisView = __webpack_require__(391);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PolarAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	
	    if (axis.dim === 'angle') {
	      this.animationThreshold = Math.PI / 18;
	    }
	
	    var polar = axis.polar;
	    var otherAxis = polar.getOtherAxis(axis);
	    var otherExtent = otherAxis.getExtent();
	    var coordValue;
	    coordValue = axis['dataTo' + formatUtil.capitalFirst(axis.dim)](value);
	    var axisPointerType = axisPointerModel.get('type');
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent, elStyle);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var labelMargin = axisPointerModel.get('label.margin');
	    var labelPos = getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
	    viewHelper.buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos);
	  } // Do not support handle, utill any user requires it.
	
	});
	
	function getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
	  var axis = axisModel.axis;
	  var coord = axis.dataToCoord(value);
	  var axisAngle = polar.getAngleAxis().getExtent()[0];
	  axisAngle = axisAngle / 180 * Math.PI;
	  var radiusExtent = polar.getRadiusAxis().getExtent();
	  var position;
	  var align;
	  var verticalAlign;
	
	  if (axis.dim === 'radius') {
	    var transform = matrix.create();
	    matrix.rotate(transform, transform, axisAngle);
	    matrix.translate(transform, transform, [polar.cx, polar.cy]);
	    position = graphic.applyTransform([coord, -labelMargin], transform);
	    var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0;
	    var labelLayout = AxisBuilder.innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
	    align = labelLayout.textAlign;
	    verticalAlign = labelLayout.textVerticalAlign;
	  } else {
	    // angle axis
	    var r = radiusExtent[1];
	    position = polar.coordToPoint([r + labelMargin, coord]);
	    var cx = polar.cx;
	    var cy = polar.cy;
	    align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
	    verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
	  }
	
	  return {
	    position: position,
	    align: align,
	    verticalAlign: verticalAlign
	  };
	}
	
	var pointerShapeBuilder = {
	  line: function (axis, polar, coordValue, otherExtent, elStyle) {
	    return axis.dim === 'angle' ? {
	      type: 'Line',
	      shape: viewHelper.makeLineShape(polar.coordToPoint([otherExtent[0], coordValue]), polar.coordToPoint([otherExtent[1], coordValue]))
	    } : {
	      type: 'Circle',
	      shape: {
	        cx: polar.cx,
	        cy: polar.cy,
	        r: coordValue
	      }
	    };
	  },
	  shadow: function (axis, polar, coordValue, otherExtent, elStyle) {
	    var bandWidth = Math.max(1, axis.getBandWidth());
	    var radian = Math.PI / 180;
	    return axis.dim === 'angle' ? {
	      type: 'Sector',
	      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
	      (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
	    } : {
	      type: 'Sector',
	      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
	    };
	  }
	};
	AxisView.registerAxisPointerClass('PolarAxisPointer', PolarAxisPointer);
	var _default = PolarAxisPointer;
	module.exports = _default;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	__webpack_require__(605);
	
	__webpack_require__(444);
	
	__webpack_require__(606);
	
	__webpack_require__(442);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function makeAction(method, actionInfo) {
	  actionInfo.update = 'updateView';
	  echarts.registerAction(actionInfo, function (payload, ecModel) {
	    var selected = {};
	    ecModel.eachComponent({
	      mainType: 'geo',
	      query: payload
	    }, function (geoModel) {
	      geoModel[method](payload.name);
	      var geo = geoModel.coordinateSystem;
	      zrUtil.each(geo.regions, function (region) {
	        selected[region.name] = geoModel.isSelected(region.name) || false;
	      });
	    });
	    return {
	      selected: selected,
	      name: payload.name
	    };
	  });
	}
	
	makeAction('toggleSelected', {
	  type: 'geoToggleSelect',
	  event: 'geoselectchanged'
	});
	makeAction('select', {
	  type: 'geoSelect',
	  event: 'geoselected'
	});
	makeAction('unSelect', {
	  type: 'geoUnSelect',
	  event: 'geounselected'
	});

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var modelUtil = __webpack_require__(261);
	
	var ComponentModel = __webpack_require__(303);
	
	var Model = __webpack_require__(262);
	
	var selectableMixin = __webpack_require__(405);
	
	var geoCreator = __webpack_require__(444);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GeoModel = ComponentModel.extend({
	  type: 'geo',
	
	  /**
	   * @type {module:echarts/coord/geo/Geo}
	   */
	  coordinateSystem: null,
	  layoutMode: 'box',
	  init: function (option) {
	    ComponentModel.prototype.init.apply(this, arguments); // Default label emphasis `show`
	
	    modelUtil.defaultEmphasis(option, 'label', ['show']);
	  },
	  optionUpdated: function () {
	    var option = this.option;
	    var self = this;
	    option.regions = geoCreator.getFilledRegions(option.regions, option.map, option.nameMap);
	    this._optionModelMap = zrUtil.reduce(option.regions || [], function (optionModelMap, regionOpt) {
	      if (regionOpt.name) {
	        optionModelMap.set(regionOpt.name, new Model(regionOpt, self));
	      }
	
	      return optionModelMap;
	    }, zrUtil.createHashMap());
	    this.updateSelectedMap(option.regions);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    show: true,
	    left: 'center',
	    top: 'center',
	    // width:,
	    // height:,
	    // right
	    // bottom
	    // Aspect is width / height. Inited to be geoJson bbox aspect
	    // This parameter is used for scale this aspect
	    // If svg used, aspectScale is 1 by default.
	    // aspectScale: 0.75,
	    aspectScale: null,
	    ///// Layout with center and size
	    // If you wan't to put map in a fixed size box with right aspect ratio
	    // This two properties may more conveninet
	    // layoutCenter: [50%, 50%]
	    // layoutSize: 100
	    silent: false,
	    // Map type
	    map: '',
	    // Define left-top, right-bottom coords to control view
	    // For example, [ [180, 90], [-180, -90] ]
	    boundingCoords: null,
	    // Default on center of map
	    center: null,
	    zoom: 1,
	    scaleLimit: null,
	    // selectedMode: false
	    label: {
	      show: false,
	      color: '#000'
	    },
	    itemStyle: {
	      // color: 各异,
	      borderWidth: 0.5,
	      borderColor: '#444',
	      color: '#eee'
	    },
	    emphasis: {
	      label: {
	        show: true,
	        color: 'rgb(100,0,0)'
	      },
	      itemStyle: {
	        color: 'rgba(255,215,0,0.8)'
	      }
	    },
	    regions: []
	  },
	
	  /**
	   * Get model of region
	   * @param  {string} name
	   * @return {module:echarts/model/Model}
	   */
	  getRegionModel: function (name) {
	    return this._optionModelMap.get(name) || new Model(null, this, this.ecModel);
	  },
	
	  /**
	   * Format label
	   * @param {string} name Region name
	   * @param {string} [status='normal'] 'normal' or 'emphasis'
	   * @return {string}
	   */
	  getFormattedLabel: function (name, status) {
	    status = status || 'normal';
	    var regionModel = this.getRegionModel(name);
	    var formatter = regionModel.get((status === 'normal' ? '' : status + '.') + 'label.formatter');
	    var params = {
	      name: name
	    };
	
	    if (typeof formatter === 'function') {
	      params.status = status;
	      return formatter(params);
	    } else if (typeof formatter === 'string') {
	      return formatter.replace('{a}', name != null ? name : '');
	    }
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  }
	});
	zrUtil.mixin(GeoModel, selectableMixin);
	var _default = GeoModel;
	module.exports = _default;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MapDraw = __webpack_require__(437);
	
	var echarts = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'geo',
	  init: function (ecModel, api) {
	    var mapDraw = new MapDraw(api, true);
	    this._mapDraw = mapDraw;
	    this.group.add(mapDraw.group);
	  },
	  render: function (geoModel, ecModel, api, payload) {
	    // Not render if it is an toggleSelect action from self
	    if (payload && payload.type === 'geoToggleSelect' && payload.from === this.uid) {
	      return;
	    }
	
	    var mapDraw = this._mapDraw;
	
	    if (geoModel.get('show')) {
	      mapDraw.draw(geoModel, ecModel, api, this, payload);
	    } else {
	      this._mapDraw.group.removeAll();
	    }
	
	    this.group.silent = geoModel.get('silent');
	  },
	  dispose: function () {
	    this._mapDraw && this._mapDraw.remove();
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(608);
	
	__webpack_require__(609);
	
	__webpack_require__(610);

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var layout = __webpack_require__(305);
	
	var numberUtil = __webpack_require__(306);
	
	var CoordinateSystem = __webpack_require__(315);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (24*60*60*1000)
	var PROXIMATE_ONE_DAY = 86400000;
	/**
	 * Calendar
	 *
	 * @constructor
	 *
	 * @param {Object} calendarModel calendarModel
	 * @param {Object} ecModel       ecModel
	 * @param {Object} api           api
	 */
	
	function Calendar(calendarModel, ecModel, api) {
	  this._model = calendarModel;
	}
	
	Calendar.prototype = {
	  constructor: Calendar,
	  type: 'calendar',
	  dimensions: ['time', 'value'],
	  // Required in createListFromData
	  getDimensionsInfo: function () {
	    return [{
	      name: 'time',
	      type: 'time'
	    }, 'value'];
	  },
	  getRangeInfo: function () {
	    return this._rangeInfo;
	  },
	  getModel: function () {
	    return this._model;
	  },
	  getRect: function () {
	    return this._rect;
	  },
	  getCellWidth: function () {
	    return this._sw;
	  },
	  getCellHeight: function () {
	    return this._sh;
	  },
	  getOrient: function () {
	    return this._orient;
	  },
	
	  /**
	   * getFirstDayOfWeek
	   *
	   * @example
	   *     0 : start at Sunday
	   *     1 : start at Monday
	   *
	   * @return {number}
	   */
	  getFirstDayOfWeek: function () {
	    return this._firstDayOfWeek;
	  },
	
	  /**
	   * get date info
	   *
	   * @param  {string|number} date date
	   * @return {Object}
	   * {
	   *      y: string, local full year, eg., '1940',
	   *      m: string, local month, from '01' ot '12',
	   *      d: string, local date, from '01' to '31' (if exists),
	   *      day: It is not date.getDay(). It is the location of the cell in a week, from 0 to 6,
	   *      time: timestamp,
	   *      formatedDate: string, yyyy-MM-dd,
	   *      date: original date object.
	   * }
	   */
	  getDateInfo: function (date) {
	    date = numberUtil.parseDate(date);
	    var y = date.getFullYear();
	    var m = date.getMonth() + 1;
	    m = m < 10 ? '0' + m : m;
	    var d = date.getDate();
	    d = d < 10 ? '0' + d : d;
	    var day = date.getDay();
	    day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
	    return {
	      y: y,
	      m: m,
	      d: d,
	      day: day,
	      time: date.getTime(),
	      formatedDate: y + '-' + m + '-' + d,
	      date: date
	    };
	  },
	  getNextNDay: function (date, n) {
	    n = n || 0;
	
	    if (n === 0) {
	      return this.getDateInfo(date);
	    }
	
	    date = new Date(this.getDateInfo(date).time);
	    date.setDate(date.getDate() + n);
	    return this.getDateInfo(date);
	  },
	  update: function (ecModel, api) {
	    this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
	    this._orient = this._model.get('orient');
	    this._lineWidth = this._model.getModel('itemStyle').getItemStyle().lineWidth || 0;
	    this._rangeInfo = this._getRangeInfo(this._initRangeOption());
	    var weeks = this._rangeInfo.weeks || 1;
	    var whNames = ['width', 'height'];
	
	    var cellSize = this._model.get('cellSize').slice();
	
	    var layoutParams = this._model.getBoxLayoutParams();
	
	    var cellNumbers = this._orient === 'horizontal' ? [weeks, 7] : [7, weeks];
	    zrUtil.each([0, 1], function (idx) {
	      if (cellSizeSpecified(cellSize, idx)) {
	        layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
	      }
	    });
	    var whGlobal = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    };
	    var calendarRect = this._rect = layout.getLayoutRect(layoutParams, whGlobal);
	    zrUtil.each([0, 1], function (idx) {
	      if (!cellSizeSpecified(cellSize, idx)) {
	        cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
	      }
	    });
	
	    function cellSizeSpecified(cellSize, idx) {
	      return cellSize[idx] != null && cellSize[idx] !== 'auto';
	    }
	
	    this._sw = cellSize[0];
	    this._sh = cellSize[1];
	  },
	
	  /**
	   * Convert a time data(time, value) item to (x, y) point.
	   *
	   * @override
	   * @param  {Array|number} data data
	   * @param  {boolean} [clamp=true] out of range
	   * @return {Array} point
	   */
	  dataToPoint: function (data, clamp) {
	    zrUtil.isArray(data) && (data = data[0]);
	    clamp == null && (clamp = true);
	    var dayInfo = this.getDateInfo(data);
	    var range = this._rangeInfo;
	    var date = dayInfo.formatedDate; // if not in range return [NaN, NaN]
	
	    if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + PROXIMATE_ONE_DAY)) {
	      return [NaN, NaN];
	    }
	
	    var week = dayInfo.day;
	
	    var nthWeek = this._getRangeInfo([range.start.time, date]).nthWeek;
	
	    if (this._orient === 'vertical') {
	      return [this._rect.x + week * this._sw + this._sw / 2, this._rect.y + nthWeek * this._sh + this._sh / 2];
	    }
	
	    return [this._rect.x + nthWeek * this._sw + this._sw / 2, this._rect.y + week * this._sh + this._sh / 2];
	  },
	
	  /**
	   * Convert a (x, y) point to time data
	   *
	   * @override
	   * @param  {string} point point
	   * @return {string}       data
	   */
	  pointToData: function (point) {
	    var date = this.pointToDate(point);
	    return date && date.time;
	  },
	
	  /**
	   * Convert a time date item to (x, y) four point.
	   *
	   * @param  {Array} data  date[0] is date
	   * @param  {boolean} [clamp=true]  out of range
	   * @return {Object}       point
	   */
	  dataToRect: function (data, clamp) {
	    var point = this.dataToPoint(data, clamp);
	    return {
	      contentShape: {
	        x: point[0] - (this._sw - this._lineWidth) / 2,
	        y: point[1] - (this._sh - this._lineWidth) / 2,
	        width: this._sw - this._lineWidth,
	        height: this._sh - this._lineWidth
	      },
	      center: point,
	      tl: [point[0] - this._sw / 2, point[1] - this._sh / 2],
	      tr: [point[0] + this._sw / 2, point[1] - this._sh / 2],
	      br: [point[0] + this._sw / 2, point[1] + this._sh / 2],
	      bl: [point[0] - this._sw / 2, point[1] + this._sh / 2]
	    };
	  },
	
	  /**
	   * Convert a (x, y) point to time date
	   *
	   * @param  {Array} point point
	   * @return {Object}       date
	   */
	  pointToDate: function (point) {
	    var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
	    var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
	    var range = this._rangeInfo.range;
	
	    if (this._orient === 'vertical') {
	      return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
	    }
	
	    return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
	  },
	
	  /**
	   * @inheritDoc
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @inheritDoc
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),
	
	  /**
	   * initRange
	   *
	   * @private
	   * @return {Array} [start, end]
	   */
	  _initRangeOption: function () {
	    var range = this._model.get('range');
	
	    var rg = range;
	
	    if (zrUtil.isArray(rg) && rg.length === 1) {
	      rg = rg[0];
	    }
	
	    if (/^\d{4}$/.test(rg)) {
	      range = [rg + '-01-01', rg + '-12-31'];
	    }
	
	    if (/^\d{4}[\/|-]\d{1,2}$/.test(rg)) {
	      var start = this.getDateInfo(rg);
	      var firstDay = start.date;
	      firstDay.setMonth(firstDay.getMonth() + 1);
	      var end = this.getNextNDay(firstDay, -1);
	      range = [start.formatedDate, end.formatedDate];
	    }
	
	    if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rg)) {
	      range = [rg, rg];
	    }
	
	    var tmp = this._getRangeInfo(range);
	
	    if (tmp.start.time > tmp.end.time) {
	      range.reverse();
	    }
	
	    return range;
	  },
	
	  /**
	   * range info
	   *
	   * @private
	   * @param  {Array} range range ['2017-01-01', '2017-07-08']
	   *  If range[0] > range[1], they will not be reversed.
	   * @return {Object}       obj
	   */
	  _getRangeInfo: function (range) {
	    range = [this.getDateInfo(range[0]), this.getDateInfo(range[1])];
	    var reversed;
	
	    if (range[0].time > range[1].time) {
	      reversed = true;
	      range.reverse();
	    }
	
	    var allDay = Math.floor(range[1].time / PROXIMATE_ONE_DAY) - Math.floor(range[0].time / PROXIMATE_ONE_DAY) + 1; // Consider case1 (#11677 #10430):
	    // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
	    // Consider case2:
	    // Firstly set system timezone as "Time Zone: America/Toronto",
	    // ```
	    // var first = new Date(1478412000000 - 3600 * 1000 * 2.5);
	    // var second = new Date(1478412000000);
	    // var allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
	    // ```
	    // will get wrong result because of DST. So we should fix it.
	
	    var date = new Date(range[0].time);
	    var startDateNum = date.getDate();
	    var endDateNum = range[1].date.getDate();
	    date.setDate(startDateNum + allDay - 1); // The bias can not over a month, so just compare date.
	
	    var dateNum = date.getDate();
	
	    if (dateNum !== endDateNum) {
	      var sign = date.getTime() - range[1].time > 0 ? 1 : -1;
	
	      while ((dateNum = date.getDate()) !== endDateNum && (date.getTime() - range[1].time) * sign > 0) {
	        allDay -= sign;
	        date.setDate(dateNum - sign);
	      }
	    }
	
	    var weeks = Math.floor((allDay + range[0].day + 6) / 7);
	    var nthWeek = reversed ? -weeks + 1 : weeks - 1;
	    reversed && range.reverse();
	    return {
	      range: [range[0].formatedDate, range[1].formatedDate],
	      start: range[0],
	      end: range[1],
	      allDay: allDay,
	      weeks: weeks,
	      // From 0.
	      nthWeek: nthWeek,
	      fweek: range[0].day,
	      lweek: range[1].day
	    };
	  },
	
	  /**
	   * get date by nthWeeks and week day in range
	   *
	   * @private
	   * @param  {number} nthWeek the week
	   * @param  {number} day   the week day
	   * @param  {Array} range [d1, d2]
	   * @return {Object}
	   */
	  _getDateByWeeksAndDay: function (nthWeek, day, range) {
	    var rangeInfo = this._getRangeInfo(range);
	
	    if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) {
	      return false;
	    }
	
	    var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
	    var date = new Date(rangeInfo.start.time);
	    date.setDate(rangeInfo.start.d + nthDay);
	    return this.getDateInfo(date);
	  }
	};
	Calendar.dimensions = Calendar.prototype.dimensions;
	Calendar.getDimensionsInfo = Calendar.prototype.getDimensionsInfo;
	
	Calendar.create = function (ecModel, api) {
	  var calendarList = [];
	  ecModel.eachComponent('calendar', function (calendarModel) {
	    var calendar = new Calendar(calendarModel, ecModel, api);
	    calendarList.push(calendar);
	    calendarModel.coordinateSystem = calendar;
	  });
	  ecModel.eachSeries(function (calendarSeries) {
	    if (calendarSeries.get('coordinateSystem') === 'calendar') {
	      // Inject coordinate system
	      calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
	    }
	  });
	  return calendarList;
	};
	
	function doConvert(methodName, ecModel, finder, value) {
	  var calendarModel = finder.calendarModel;
	  var seriesModel = finder.seriesModel;
	  var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	CoordinateSystem.register('calendar', Calendar);
	var _default = Calendar;
	module.exports = _default;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var ComponentModel = __webpack_require__(303);
	
	var _layout = __webpack_require__(305);
	
	var getLayoutParams = _layout.getLayoutParams;
	var sizeCalculable = _layout.sizeCalculable;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CalendarModel = ComponentModel.extend({
	  type: 'calendar',
	
	  /**
	   * @type {module:echarts/coord/calendar/Calendar}
	   */
	  coordinateSystem: null,
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    left: 80,
	    top: 60,
	    cellSize: 20,
	    // horizontal vertical
	    orient: 'horizontal',
	    // month separate line style
	    splitLine: {
	      show: true,
	      lineStyle: {
	        color: '#000',
	        width: 1,
	        type: 'solid'
	      }
	    },
	    // rect style  temporarily unused emphasis
	    itemStyle: {
	      color: '#fff',
	      borderWidth: 1,
	      borderColor: '#ccc'
	    },
	    // week text style
	    dayLabel: {
	      show: true,
	      // a week first day
	      firstDay: 0,
	      // start end
	      position: 'start',
	      margin: '50%',
	      // 50% of cellSize
	      nameMap: 'en',
	      color: '#000'
	    },
	    // month text style
	    monthLabel: {
	      show: true,
	      // start end
	      position: 'start',
	      margin: 5,
	      // center or left
	      align: 'center',
	      // cn en []
	      nameMap: 'en',
	      formatter: null,
	      color: '#000'
	    },
	    // year text style
	    yearLabel: {
	      show: true,
	      // top bottom left right
	      position: null,
	      margin: 30,
	      formatter: null,
	      color: '#ccc',
	      fontFamily: 'sans-serif',
	      fontWeight: 'bolder',
	      fontSize: 20
	    }
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    var inputPositionParams = getLayoutParams(option);
	    CalendarModel.superApply(this, 'init', arguments);
	    mergeAndNormalizeLayoutParams(option, inputPositionParams);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option, extraOpt) {
	    CalendarModel.superApply(this, 'mergeOption', arguments);
	    mergeAndNormalizeLayoutParams(this.option, option);
	  }
	});
	
	function mergeAndNormalizeLayoutParams(target, raw) {
	  // Normalize cellSize
	  var cellSize = target.cellSize;
	
	  if (!zrUtil.isArray(cellSize)) {
	    cellSize = target.cellSize = [cellSize, cellSize];
	  } else if (cellSize.length === 1) {
	    cellSize[1] = cellSize[0];
	  }
	
	  var ignoreSize = zrUtil.map([0, 1], function (hvIdx) {
	    // If user have set `width` or both `left` and `right`, cellSize
	    // will be automatically set to 'auto', otherwise the default
	    // setting of cellSize will make `width` setting not work.
	    if (sizeCalculable(raw, hvIdx)) {
	      cellSize[hvIdx] = 'auto';
	    }
	
	    return cellSize[hvIdx] != null && cellSize[hvIdx] !== 'auto';
	  });
	  mergeLayoutParam(target, raw, {
	    type: 'box',
	    ignoreSize: ignoreSize
	  });
	}
	
	var _default = CalendarModel;
	module.exports = _default;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var formatUtil = __webpack_require__(307);
	
	var numberUtil = __webpack_require__(306);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var MONTH_TEXT = {
	  EN: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  CN: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
	};
	var WEEK_TEXT = {
	  EN: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  CN: ['日', '一', '二', '三', '四', '五', '六']
	};
	
	var _default = echarts.extendComponentView({
	  type: 'calendar',
	
	  /**
	   * top/left line points
	   *  @private
	   */
	  _tlpoints: null,
	
	  /**
	   * bottom/right line points
	   *  @private
	   */
	  _blpoints: null,
	
	  /**
	   * first day of month
	   *  @private
	   */
	  _firstDayOfMonth: null,
	
	  /**
	   * first day point of month
	   *  @private
	   */
	  _firstDayPoints: null,
	  render: function (calendarModel, ecModel, api) {
	    var group = this.group;
	    group.removeAll();
	    var coordSys = calendarModel.coordinateSystem; // range info
	
	    var rangeData = coordSys.getRangeInfo();
	    var orient = coordSys.getOrient();
	
	    this._renderDayRect(calendarModel, rangeData, group); // _renderLines must be called prior to following function
	
	
	    this._renderLines(calendarModel, rangeData, orient, group);
	
	    this._renderYearText(calendarModel, rangeData, orient, group);
	
	    this._renderMonthText(calendarModel, orient, group);
	
	    this._renderWeekText(calendarModel, rangeData, orient, group);
	  },
	  // render day rect
	  _renderDayRect: function (calendarModel, rangeData, group) {
	    var coordSys = calendarModel.coordinateSystem;
	    var itemRectStyleModel = calendarModel.getModel('itemStyle').getItemStyle();
	    var sw = coordSys.getCellWidth();
	    var sh = coordSys.getCellHeight();
	
	    for (var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time) {
	      var point = coordSys.dataToRect([i], false).tl; // every rect
	
	      var rect = new graphic.Rect({
	        shape: {
	          x: point[0],
	          y: point[1],
	          width: sw,
	          height: sh
	        },
	        cursor: 'default',
	        style: itemRectStyleModel
	      });
	      group.add(rect);
	    }
	  },
	  // render separate line
	  _renderLines: function (calendarModel, rangeData, orient, group) {
	    var self = this;
	    var coordSys = calendarModel.coordinateSystem;
	    var lineStyleModel = calendarModel.getModel('splitLine.lineStyle').getLineStyle();
	    var show = calendarModel.get('splitLine.show');
	    var lineWidth = lineStyleModel.lineWidth;
	    this._tlpoints = [];
	    this._blpoints = [];
	    this._firstDayOfMonth = [];
	    this._firstDayPoints = [];
	    var firstDay = rangeData.start;
	
	    for (var i = 0; firstDay.time <= rangeData.end.time; i++) {
	      addPoints(firstDay.formatedDate);
	
	      if (i === 0) {
	        firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
	      }
	
	      var date = firstDay.date;
	      date.setMonth(date.getMonth() + 1);
	      firstDay = coordSys.getDateInfo(date);
	    }
	
	    addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
	
	    function addPoints(date) {
	      self._firstDayOfMonth.push(coordSys.getDateInfo(date));
	
	      self._firstDayPoints.push(coordSys.dataToRect([date], false).tl);
	
	      var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
	
	      self._tlpoints.push(points[0]);
	
	      self._blpoints.push(points[points.length - 1]);
	
	      show && self._drawSplitline(points, lineStyleModel, group);
	    } // render top/left line
	
	
	    show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group); // render bottom/right line
	
	    show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
	  },
	  // get points at both ends
	  _getEdgesPoints: function (points, lineWidth, orient) {
	    var rs = [points[0].slice(), points[points.length - 1].slice()];
	    var idx = orient === 'horizontal' ? 0 : 1; // both ends of the line are extend half lineWidth
	
	    rs[0][idx] = rs[0][idx] - lineWidth / 2;
	    rs[1][idx] = rs[1][idx] + lineWidth / 2;
	    return rs;
	  },
	  // render split line
	  _drawSplitline: function (points, lineStyleModel, group) {
	    var poyline = new graphic.Polyline({
	      z2: 20,
	      shape: {
	        points: points
	      },
	      style: lineStyleModel
	    });
	    group.add(poyline);
	  },
	  // render month line of one week points
	  _getLinePointsOfOneWeek: function (calendarModel, date, orient) {
	    var coordSys = calendarModel.coordinateSystem;
	    date = coordSys.getDateInfo(date);
	    var points = [];
	
	    for (var i = 0; i < 7; i++) {
	      var tmpD = coordSys.getNextNDay(date.time, i);
	      var point = coordSys.dataToRect([tmpD.time], false);
	      points[2 * tmpD.day] = point.tl;
	      points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
	    }
	
	    return points;
	  },
	  _formatterLabel: function (formatter, params) {
	    if (typeof formatter === 'string' && formatter) {
	      return formatUtil.formatTplSimple(formatter, params);
	    }
	
	    if (typeof formatter === 'function') {
	      return formatter(params);
	    }
	
	    return params.nameMap;
	  },
	  _yearTextPositionControl: function (textEl, point, orient, position, margin) {
	    point = point.slice();
	    var aligns = ['center', 'bottom'];
	
	    if (position === 'bottom') {
	      point[1] += margin;
	      aligns = ['center', 'top'];
	    } else if (position === 'left') {
	      point[0] -= margin;
	    } else if (position === 'right') {
	      point[0] += margin;
	      aligns = ['center', 'top'];
	    } else {
	      // top
	      point[1] -= margin;
	    }
	
	    var rotate = 0;
	
	    if (position === 'left' || position === 'right') {
	      rotate = Math.PI / 2;
	    }
	
	    return {
	      rotation: rotate,
	      position: point,
	      style: {
	        textAlign: aligns[0],
	        textVerticalAlign: aligns[1]
	      }
	    };
	  },
	  // render year
	  _renderYearText: function (calendarModel, rangeData, orient, group) {
	    var yearLabel = calendarModel.getModel('yearLabel');
	
	    if (!yearLabel.get('show')) {
	      return;
	    }
	
	    var margin = yearLabel.get('margin');
	    var pos = yearLabel.get('position');
	
	    if (!pos) {
	      pos = orient !== 'horizontal' ? 'top' : 'left';
	    }
	
	    var points = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]];
	    var xc = (points[0][0] + points[1][0]) / 2;
	    var yc = (points[0][1] + points[1][1]) / 2;
	    var idx = orient === 'horizontal' ? 0 : 1;
	    var posPoints = {
	      top: [xc, points[idx][1]],
	      bottom: [xc, points[1 - idx][1]],
	      left: [points[1 - idx][0], yc],
	      right: [points[idx][0], yc]
	    };
	    var name = rangeData.start.y;
	
	    if (+rangeData.end.y > +rangeData.start.y) {
	      name = name + '-' + rangeData.end.y;
	    }
	
	    var formatter = yearLabel.get('formatter');
	    var params = {
	      start: rangeData.start.y,
	      end: rangeData.end.y,
	      nameMap: name
	    };
	
	    var content = this._formatterLabel(formatter, params);
	
	    var yearText = new graphic.Text({
	      z2: 30
	    });
	    graphic.setTextStyle(yearText.style, yearLabel, {
	      text: content
	    }), yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
	    group.add(yearText);
	  },
	  _monthTextPositionControl: function (point, isCenter, orient, position, margin) {
	    var align = 'left';
	    var vAlign = 'top';
	    var x = point[0];
	    var y = point[1];
	
	    if (orient === 'horizontal') {
	      y = y + margin;
	
	      if (isCenter) {
	        align = 'center';
	      }
	
	      if (position === 'start') {
	        vAlign = 'bottom';
	      }
	    } else {
	      x = x + margin;
	
	      if (isCenter) {
	        vAlign = 'middle';
	      }
	
	      if (position === 'start') {
	        align = 'right';
	      }
	    }
	
	    return {
	      x: x,
	      y: y,
	      textAlign: align,
	      textVerticalAlign: vAlign
	    };
	  },
	  // render month and year text
	  _renderMonthText: function (calendarModel, orient, group) {
	    var monthLabel = calendarModel.getModel('monthLabel');
	
	    if (!monthLabel.get('show')) {
	      return;
	    }
	
	    var nameMap = monthLabel.get('nameMap');
	    var margin = monthLabel.get('margin');
	    var pos = monthLabel.get('position');
	    var align = monthLabel.get('align');
	    var termPoints = [this._tlpoints, this._blpoints];
	
	    if (zrUtil.isString(nameMap)) {
	      nameMap = MONTH_TEXT[nameMap.toUpperCase()] || [];
	    }
	
	    var idx = pos === 'start' ? 0 : 1;
	    var axis = orient === 'horizontal' ? 0 : 1;
	    margin = pos === 'start' ? -margin : margin;
	    var isCenter = align === 'center';
	
	    for (var i = 0; i < termPoints[idx].length - 1; i++) {
	      var tmp = termPoints[idx][i].slice();
	      var firstDay = this._firstDayOfMonth[i];
	
	      if (isCenter) {
	        var firstDayPoints = this._firstDayPoints[i];
	        tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
	      }
	
	      var formatter = monthLabel.get('formatter');
	      var name = nameMap[+firstDay.m - 1];
	      var params = {
	        yyyy: firstDay.y,
	        yy: (firstDay.y + '').slice(2),
	        MM: firstDay.m,
	        M: +firstDay.m,
	        nameMap: name
	      };
	
	      var content = this._formatterLabel(formatter, params);
	
	      var monthText = new graphic.Text({
	        z2: 30
	      });
	      zrUtil.extend(graphic.setTextStyle(monthText.style, monthLabel, {
	        text: content
	      }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin));
	      group.add(monthText);
	    }
	  },
	  _weekTextPositionControl: function (point, orient, position, margin, cellSize) {
	    var align = 'center';
	    var vAlign = 'middle';
	    var x = point[0];
	    var y = point[1];
	    var isStart = position === 'start';
	
	    if (orient === 'horizontal') {
	      x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
	      align = isStart ? 'right' : 'left';
	    } else {
	      y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
	      vAlign = isStart ? 'bottom' : 'top';
	    }
	
	    return {
	      x: x,
	      y: y,
	      textAlign: align,
	      textVerticalAlign: vAlign
	    };
	  },
	  // render weeks
	  _renderWeekText: function (calendarModel, rangeData, orient, group) {
	    var dayLabel = calendarModel.getModel('dayLabel');
	
	    if (!dayLabel.get('show')) {
	      return;
	    }
	
	    var coordSys = calendarModel.coordinateSystem;
	    var pos = dayLabel.get('position');
	    var nameMap = dayLabel.get('nameMap');
	    var margin = dayLabel.get('margin');
	    var firstDayOfWeek = coordSys.getFirstDayOfWeek();
	
	    if (zrUtil.isString(nameMap)) {
	      nameMap = WEEK_TEXT[nameMap.toUpperCase()] || [];
	    }
	
	    var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
	    var cellSize = [coordSys.getCellWidth(), coordSys.getCellHeight()];
	    margin = numberUtil.parsePercent(margin, cellSize[orient === 'horizontal' ? 0 : 1]);
	
	    if (pos === 'start') {
	      start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
	      margin = -margin;
	    }
	
	    for (var i = 0; i < 7; i++) {
	      var tmpD = coordSys.getNextNDay(start, i);
	      var point = coordSys.dataToRect([tmpD.time], false).center;
	      var day = i;
	      day = Math.abs((i + firstDayOfWeek) % 7);
	      var weekText = new graphic.Text({
	        z2: 30
	      });
	      zrUtil.extend(graphic.setTextStyle(weekText.style, dayLabel, {
	        text: nameMap[day]
	      }), this._weekTextPositionControl(point, orient, pos, margin, cellSize));
	      group.add(weekText);
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var modelUtil = __webpack_require__(261);
	
	var graphicUtil = __webpack_require__(268);
	
	var layoutUtil = __webpack_require__(305);
	
	var _number = __webpack_require__(306);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _nonShapeGraphicElements = {
	  // Reserved but not supported in graphic component.
	  path: null,
	  compoundPath: null,
	  // Supported in graphic component.
	  group: graphicUtil.Group,
	  image: graphicUtil.Image,
	  text: graphicUtil.Text
	}; // -------------
	// Preprocessor
	// -------------
	
	echarts.registerPreprocessor(function (option) {
	  var graphicOption = option.graphic; // Convert
	  // {graphic: [{left: 10, type: 'circle'}, ...]}
	  // or
	  // {graphic: {left: 10, type: 'circle'}}
	  // to
	  // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
	
	  if (zrUtil.isArray(graphicOption)) {
	    if (!graphicOption[0] || !graphicOption[0].elements) {
	      option.graphic = [{
	        elements: graphicOption
	      }];
	    } else {
	      // Only one graphic instance can be instantiated. (We dont
	      // want that too many views are created in echarts._viewMap)
	      option.graphic = [option.graphic[0]];
	    }
	  } else if (graphicOption && !graphicOption.elements) {
	    option.graphic = [{
	      elements: [graphicOption]
	    }];
	  }
	}); // ------
	// Model
	// ------
	
	var GraphicModel = echarts.extendComponentModel({
	  type: 'graphic',
	  defaultOption: {
	    // Extra properties for each elements:
	    //
	    // left/right/top/bottom: (like 12, '22%', 'center', default undefined)
	    //      If left/rigth is set, shape.x/shape.cx/position will not be used.
	    //      If top/bottom is set, shape.y/shape.cy/position will not be used.
	    //      This mechanism is useful when you want to position a group/element
	    //      against the right side or the center of this container.
	    //
	    // width/height: (can only be pixel value, default 0)
	    //      Only be used to specify contianer(group) size, if needed. And
	    //      can not be percentage value (like '33%'). See the reason in the
	    //      layout algorithm below.
	    //
	    // bounding: (enum: 'all' (default) | 'raw')
	    //      Specify how to calculate boundingRect when locating.
	    //      'all': Get uioned and transformed boundingRect
	    //          from both itself and its descendants.
	    //          This mode simplies confining a group of elements in the bounding
	    //          of their ancester container (e.g., using 'right: 0').
	    //      'raw': Only use the boundingRect of itself and before transformed.
	    //          This mode is similar to css behavior, which is useful when you
	    //          want an element to be able to overflow its container. (Consider
	    //          a rotated circle needs to be located in a corner.)
	    // info: custom info. enables user to mount some info on elements and use them
	    //      in event handlers. Update them only when user specified, otherwise, remain.
	    // Note: elements is always behind its ancestors in this elements array.
	    elements: [],
	    parentId: null
	  },
	
	  /**
	   * Save el options for the sake of the performance (only update modified graphics).
	   * The order is the same as those in option. (ancesters -> descendants)
	   *
	   * @private
	   * @type {Array.<Object>}
	   */
	  _elOptionsToUpdate: null,
	
	  /**
	   * @override
	   */
	  mergeOption: function (option) {
	    // Prevent default merge to elements
	    var elements = this.option.elements;
	    this.option.elements = null;
	    GraphicModel.superApply(this, 'mergeOption', arguments);
	    this.option.elements = elements;
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option;
	    var newList = (isInit ? thisOption : newOption).elements;
	    var existList = thisOption.elements = isInit ? [] : thisOption.elements;
	    var flattenedList = [];
	
	    this._flatten(newList, flattenedList);
	
	    var mappingResult = modelUtil.mappingToExists(existList, flattenedList);
	    modelUtil.makeIdAndName(mappingResult); // Clear elOptionsToUpdate
	
	    var elOptionsToUpdate = this._elOptionsToUpdate = [];
	    zrUtil.each(mappingResult, function (resultItem, index) {
	      var newElOption = resultItem.option;
	
	      if (!newElOption) {
	        return;
	      }
	
	      elOptionsToUpdate.push(newElOption);
	      setKeyInfoToNewElOption(resultItem, newElOption);
	      mergeNewElOptionToExist(existList, index, newElOption);
	      setLayoutInfoToExist(existList[index], newElOption);
	    }, this); // Clean
	
	    for (var i = existList.length - 1; i >= 0; i--) {
	      if (existList[i] == null) {
	        existList.splice(i, 1);
	      } else {
	        // $action should be volatile, otherwise option gotten from
	        // `getOption` will contain unexpected $action.
	        delete existList[i].$action;
	      }
	    }
	  },
	
	  /**
	   * Convert
	   * [{
	   *  type: 'group',
	   *  id: 'xx',
	   *  children: [{type: 'circle'}, {type: 'polygon'}]
	   * }]
	   * to
	   * [
	   *  {type: 'group', id: 'xx'},
	   *  {type: 'circle', parentId: 'xx'},
	   *  {type: 'polygon', parentId: 'xx'}
	   * ]
	   *
	   * @private
	   * @param {Array.<Object>} optionList option list
	   * @param {Array.<Object>} result result of flatten
	   * @param {Object} parentOption parent option
	   */
	  _flatten: function (optionList, result, parentOption) {
	    zrUtil.each(optionList, function (option) {
	      if (!option) {
	        return;
	      }
	
	      if (parentOption) {
	        option.parentOption = parentOption;
	      }
	
	      result.push(option);
	      var children = option.children;
	
	      if (option.type === 'group' && children) {
	        this._flatten(children, result, option);
	      } // Deleting for JSON output, and for not affecting group creation.
	
	
	      delete option.children;
	    }, this);
	  },
	  // FIXME
	  // Pass to view using payload? setOption has a payload?
	  useElOptionsToUpdate: function () {
	    var els = this._elOptionsToUpdate; // Clear to avoid render duplicately when zooming.
	
	    this._elOptionsToUpdate = null;
	    return els;
	  }
	}); // -----
	// View
	// -----
	
	echarts.extendComponentView({
	  type: 'graphic',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {module:zrender/core/util.HashMap}
	     */
	    this._elMap = zrUtil.createHashMap();
	    /**
	     * @private
	     * @type {module:echarts/graphic/GraphicModel}
	     */
	
	    this._lastGraphicModel;
	  },
	
	  /**
	   * @override
	   */
	  render: function (graphicModel, ecModel, api) {
	    // Having leveraged between use cases and algorithm complexity, a very
	    // simple layout mechanism is used:
	    // The size(width/height) can be determined by itself or its parent (not
	    // implemented yet), but can not by its children. (Top-down travel)
	    // The location(x/y) can be determined by the bounding rect of itself
	    // (can including its descendants or not) and the size of its parent.
	    // (Bottom-up travel)
	    // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
	    // view will be reused.
	    if (graphicModel !== this._lastGraphicModel) {
	      this._clear();
	    }
	
	    this._lastGraphicModel = graphicModel;
	
	    this._updateElements(graphicModel);
	
	    this._relocate(graphicModel, api);
	  },
	
	  /**
	   * Update graphic elements.
	   *
	   * @private
	   * @param {Object} graphicModel graphic model
	   */
	  _updateElements: function (graphicModel) {
	    var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
	
	    if (!elOptionsToUpdate) {
	      return;
	    }
	
	    var elMap = this._elMap;
	    var rootGroup = this.group; // Top-down tranverse to assign graphic settings to each elements.
	
	    zrUtil.each(elOptionsToUpdate, function (elOption) {
	      var $action = elOption.$action;
	      var id = elOption.id;
	      var existEl = elMap.get(id);
	      var parentId = elOption.parentId;
	      var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
	      var elOptionStyle = elOption.style;
	
	      if (elOption.type === 'text' && elOptionStyle) {
	        // In top/bottom mode, textVerticalAlign should not be used, which cause
	        // inaccurately locating.
	        if (elOption.hv && elOption.hv[1]) {
	          elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = null;
	        } // Compatible with previous setting: both support fill and textFill,
	        // stroke and textStroke.
	
	
	        !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
	        !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
	      } // Remove unnecessary props to avoid potential problems.
	
	
	      var elOptionCleaned = getCleanedElOption(elOption); // For simple, do not support parent change, otherwise reorder is needed.
	
	      if (!$action || $action === 'merge') {
	        existEl ? existEl.attr(elOptionCleaned) : createEl(id, targetElParent, elOptionCleaned, elMap);
	      } else if ($action === 'replace') {
	        removeEl(existEl, elMap);
	        createEl(id, targetElParent, elOptionCleaned, elMap);
	      } else if ($action === 'remove') {
	        removeEl(existEl, elMap);
	      }
	
	      var el = elMap.get(id);
	
	      if (el) {
	        el.__ecGraphicWidthOption = elOption.width;
	        el.__ecGraphicHeightOption = elOption.height;
	        setEventData(el, graphicModel, elOption);
	      }
	    });
	  },
	
	  /**
	   * Locate graphic elements.
	   *
	   * @private
	   * @param {Object} graphicModel graphic model
	   * @param {module:echarts/ExtensionAPI} api extension API
	   */
	  _relocate: function (graphicModel, api) {
	    var elOptions = graphicModel.option.elements;
	    var rootGroup = this.group;
	    var elMap = this._elMap;
	    var apiWidth = api.getWidth();
	    var apiHeight = api.getHeight(); // Top-down to calculate percentage width/height of group
	
	    for (var i = 0; i < elOptions.length; i++) {
	      var elOption = elOptions[i];
	      var el = elMap.get(elOption.id);
	
	      if (!el || !el.isGroup) {
	        continue;
	      }
	
	      var parentEl = el.parent;
	      var isParentRoot = parentEl === rootGroup; // Like 'position:absolut' in css, default 0.
	
	      el.__ecGraphicWidth = parsePercent(el.__ecGraphicWidthOption, isParentRoot ? apiWidth : parentEl.__ecGraphicWidth) || 0;
	      el.__ecGraphicHeight = parsePercent(el.__ecGraphicHeightOption, isParentRoot ? apiHeight : parentEl.__ecGraphicHeight) || 0;
	    } // Bottom-up tranvese all elements (consider ec resize) to locate elements.
	
	
	    for (var i = elOptions.length - 1; i >= 0; i--) {
	      var elOption = elOptions[i];
	      var el = elMap.get(elOption.id);
	
	      if (!el) {
	        continue;
	      }
	
	      var parentEl = el.parent;
	      var containerInfo = parentEl === rootGroup ? {
	        width: apiWidth,
	        height: apiHeight
	      } : {
	        width: parentEl.__ecGraphicWidth,
	        height: parentEl.__ecGraphicHeight
	      }; // PENDING
	      // Currently, when `bounding: 'all'`, the union bounding rect of the group
	      // does not include the rect of [0, 0, group.width, group.height], which
	      // is probably weird for users. Should we make a break change for it?
	
	      layoutUtil.positionElement(el, elOption, containerInfo, null, {
	        hv: elOption.hv,
	        boundingMode: elOption.bounding
	      });
	    }
	  },
	
	  /**
	   * Clear all elements.
	   *
	   * @private
	   */
	  _clear: function () {
	    var elMap = this._elMap;
	    elMap.each(function (el) {
	      removeEl(el, elMap);
	    });
	    this._elMap = zrUtil.createHashMap();
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clear();
	  }
	});
	
	function createEl(id, targetElParent, elOption, elMap) {
	  var graphicType = elOption.type;
	  var Clz = _nonShapeGraphicElements.hasOwnProperty(graphicType) // Those graphic elements are not shapes. They should not be
	  // overwritten by users, so do them first.
	  ? _nonShapeGraphicElements[graphicType] : graphicUtil.getShapeClass(graphicType);
	  var el = new Clz(elOption);
	  targetElParent.add(el);
	  elMap.set(id, el);
	  el.__ecGraphicId = id;
	}
	
	function removeEl(existEl, elMap) {
	  var existElParent = existEl && existEl.parent;
	
	  if (existElParent) {
	    existEl.type === 'group' && existEl.traverse(function (el) {
	      removeEl(el, elMap);
	    });
	    elMap.removeKey(existEl.__ecGraphicId);
	    existElParent.remove(existEl);
	  }
	} // Remove unnecessary props to avoid potential problems.
	
	
	function getCleanedElOption(elOption) {
	  elOption = zrUtil.extend({}, elOption);
	  zrUtil.each(['id', 'parentId', '$action', 'hv', 'bounding'].concat(layoutUtil.LOCATION_PARAMS), function (name) {
	    delete elOption[name];
	  });
	  return elOption;
	}
	
	function isSetLoc(obj, props) {
	  var isSet;
	  zrUtil.each(props, function (prop) {
	    obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
	  });
	  return isSet;
	}
	
	function setKeyInfoToNewElOption(resultItem, newElOption) {
	  var existElOption = resultItem.exist; // Set id and type after id assigned.
	
	  newElOption.id = resultItem.keyInfo.id;
	  !newElOption.type && existElOption && (newElOption.type = existElOption.type); // Set parent id if not specified
	
	  if (newElOption.parentId == null) {
	    var newElParentOption = newElOption.parentOption;
	
	    if (newElParentOption) {
	      newElOption.parentId = newElParentOption.id;
	    } else if (existElOption) {
	      newElOption.parentId = existElOption.parentId;
	    }
	  } // Clear
	
	
	  newElOption.parentOption = null;
	}
	
	function mergeNewElOptionToExist(existList, index, newElOption) {
	  // Update existing options, for `getOption` feature.
	  var newElOptCopy = zrUtil.extend({}, newElOption);
	  var existElOption = existList[index];
	  var $action = newElOption.$action || 'merge';
	
	  if ($action === 'merge') {
	    if (existElOption) {
	      // We can ensure that newElOptCopy and existElOption are not
	      // the same object, so `merge` will not change newElOptCopy.
	      zrUtil.merge(existElOption, newElOptCopy, true); // Rigid body, use ignoreSize.
	
	      layoutUtil.mergeLayoutParam(existElOption, newElOptCopy, {
	        ignoreSize: true
	      }); // Will be used in render.
	
	      layoutUtil.copyLayoutParams(newElOption, existElOption);
	    } else {
	      existList[index] = newElOptCopy;
	    }
	  } else if ($action === 'replace') {
	    existList[index] = newElOptCopy;
	  } else if ($action === 'remove') {
	    // null will be cleaned later.
	    existElOption && (existList[index] = null);
	  }
	}
	
	function setLayoutInfoToExist(existItem, newElOption) {
	  if (!existItem) {
	    return;
	  }
	
	  existItem.hv = newElOption.hv = [// Rigid body, dont care `width`.
	  isSetLoc(newElOption, ['left', 'right']), // Rigid body, dont care `height`.
	  isSetLoc(newElOption, ['top', 'bottom'])]; // Give default group size. Otherwise layout error may occur.
	
	  if (existItem.type === 'group') {
	    existItem.width == null && (existItem.width = newElOption.width = 0);
	    existItem.height == null && (existItem.height = newElOption.height = 0);
	  }
	}
	
	function setEventData(el, graphicModel, elOption) {
	  var eventData = el.eventData; // Simple optimize for large amount of elements that no need event.
	
	  if (!el.silent && !el.ignore && !eventData) {
	    eventData = el.eventData = {
	      componentType: 'graphic',
	      componentIndex: graphicModel.componentIndex,
	      name: el.name
	    };
	  } // `elOption.info` enables user to mount some info on
	  // elements and use them in event handlers.
	
	
	  if (eventData) {
	    eventData.info = el.info;
	  }
	}

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(613);
	
	__webpack_require__(615);
	
	__webpack_require__(617);
	
	__webpack_require__(618);
	
	__webpack_require__(619);
	
	__webpack_require__(620);
	
	__webpack_require__(633);

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var featureManager = __webpack_require__(614);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ToolboxModel = echarts.extendComponentModel({
	  type: 'toolbox',
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	  optionUpdated: function () {
	    ToolboxModel.superApply(this, 'optionUpdated', arguments);
	    zrUtil.each(this.option.feature, function (featureOpt, featureName) {
	      var Feature = featureManager.get(featureName);
	      Feature && zrUtil.merge(featureOpt, Feature.defaultOption);
	    });
	  },
	  defaultOption: {
	    show: true,
	    z: 6,
	    zlevel: 0,
	    orient: 'horizontal',
	    left: 'right',
	    top: 'top',
	    // right
	    // bottom
	    backgroundColor: 'transparent',
	    borderColor: '#ccc',
	    borderRadius: 0,
	    borderWidth: 0,
	    padding: 5,
	    itemSize: 15,
	    itemGap: 8,
	    showTitle: true,
	    iconStyle: {
	      borderColor: '#666',
	      color: 'none'
	    },
	    emphasis: {
	      iconStyle: {
	        borderColor: '#3E98C5'
	      }
	    },
	    // textStyle: {},
	    // feature
	    tooltip: {
	      show: false
	    }
	  }
	});
	var _default = ToolboxModel;
	module.exports = _default;

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var features = {};
	
	function register(name, ctor) {
	  features[name] = ctor;
	}
	
	function get(name) {
	  return features[name];
	}
	
	exports.register = register;
	exports.get = get;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var textContain = __webpack_require__(255);
	
	var featureManager = __webpack_require__(614);
	
	var graphic = __webpack_require__(268);
	
	var Model = __webpack_require__(262);
	
	var DataDiffer = __webpack_require__(343);
	
	var listComponentHelper = __webpack_require__(616);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'toolbox',
	  render: function (toolboxModel, ecModel, api, payload) {
	    var group = this.group;
	    group.removeAll();
	
	    if (!toolboxModel.get('show')) {
	      return;
	    }
	
	    var itemSize = +toolboxModel.get('itemSize');
	    var featureOpts = toolboxModel.get('feature') || {};
	    var features = this._features || (this._features = {});
	    var featureNames = [];
	    zrUtil.each(featureOpts, function (opt, name) {
	      featureNames.push(name);
	    });
	    new DataDiffer(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove(zrUtil.curry(processFeature, null)).execute(); // Keep for diff.
	
	    this._featureNames = featureNames;
	
	    function processFeature(newIndex, oldIndex) {
	      var featureName = featureNames[newIndex];
	      var oldName = featureNames[oldIndex];
	      var featureOpt = featureOpts[featureName];
	      var featureModel = new Model(featureOpt, toolboxModel, toolboxModel.ecModel);
	      var feature; // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?
	
	      if (payload && payload.newTitle != null && payload.featureName === featureName) {
	        featureOpt.title = payload.newTitle;
	      }
	
	      if (featureName && !oldName) {
	        // Create
	        if (isUserFeatureName(featureName)) {
	          feature = {
	            model: featureModel,
	            onclick: featureModel.option.onclick,
	            featureName: featureName
	          };
	        } else {
	          var Feature = featureManager.get(featureName);
	
	          if (!Feature) {
	            return;
	          }
	
	          feature = new Feature(featureModel, ecModel, api);
	        }
	
	        features[featureName] = feature;
	      } else {
	        feature = features[oldName]; // If feature does not exsit.
	
	        if (!feature) {
	          return;
	        }
	
	        feature.model = featureModel;
	        feature.ecModel = ecModel;
	        feature.api = api;
	      }
	
	      if (!featureName && oldName) {
	        feature.dispose && feature.dispose(ecModel, api);
	        return;
	      }
	
	      if (!featureModel.get('show') || feature.unusable) {
	        feature.remove && feature.remove(ecModel, api);
	        return;
	      }
	
	      createIconPaths(featureModel, feature, featureName);
	
	      featureModel.setIconStatus = function (iconName, status) {
	        var option = this.option;
	        var iconPaths = this.iconPaths;
	        option.iconStatus = option.iconStatus || {};
	        option.iconStatus[iconName] = status; // FIXME
	
	        iconPaths[iconName] && iconPaths[iconName].trigger(status);
	      };
	
	      if (feature.render) {
	        feature.render(featureModel, ecModel, api, payload);
	      }
	    }
	
	    function createIconPaths(featureModel, feature, featureName) {
	      var iconStyleModel = featureModel.getModel('iconStyle');
	      var iconStyleEmphasisModel = featureModel.getModel('emphasis.iconStyle'); // If one feature has mutiple icon. they are orginaized as
	      // {
	      //     icon: {
	      //         foo: '',
	      //         bar: ''
	      //     },
	      //     title: {
	      //         foo: '',
	      //         bar: ''
	      //     }
	      // }
	
	      var icons = feature.getIcons ? feature.getIcons() : featureModel.get('icon');
	      var titles = featureModel.get('title') || {};
	
	      if (typeof icons === 'string') {
	        var icon = icons;
	        var title = titles;
	        icons = {};
	        titles = {};
	        icons[featureName] = icon;
	        titles[featureName] = title;
	      }
	
	      var iconPaths = featureModel.iconPaths = {};
	      zrUtil.each(icons, function (iconStr, iconName) {
	        var path = graphic.createIcon(iconStr, {}, {
	          x: -itemSize / 2,
	          y: -itemSize / 2,
	          width: itemSize,
	          height: itemSize
	        });
	        path.setStyle(iconStyleModel.getItemStyle());
	        path.hoverStyle = iconStyleEmphasisModel.getItemStyle(); // Text position calculation
	
	        path.setStyle({
	          text: titles[iconName],
	          textAlign: iconStyleEmphasisModel.get('textAlign'),
	          textBorderRadius: iconStyleEmphasisModel.get('textBorderRadius'),
	          textPadding: iconStyleEmphasisModel.get('textPadding'),
	          textFill: null
	        });
	        var tooltipModel = toolboxModel.getModel('tooltip');
	
	        if (tooltipModel && tooltipModel.get('show')) {
	          path.attr('tooltip', zrUtil.extend({
	            content: titles[iconName],
	            formatter: tooltipModel.get('formatter', true) || function () {
	              return titles[iconName];
	            },
	            formatterParams: {
	              componentType: 'toolbox',
	              name: iconName,
	              title: titles[iconName],
	              $vars: ['name', 'title']
	            },
	            position: tooltipModel.get('position', true) || 'bottom'
	          }, tooltipModel.option));
	        }
	
	        graphic.setHoverStyle(path);
	
	        if (toolboxModel.get('showTitle')) {
	          path.__title = titles[iconName];
	          path.on('mouseover', function () {
	            // Should not reuse above hoverStyle, which might be modified.
	            var hoverStyle = iconStyleEmphasisModel.getItemStyle();
	            var defaultTextPosition = toolboxModel.get('orient') === 'vertical' ? toolboxModel.get('right') == null ? 'right' : 'left' : toolboxModel.get('bottom') == null ? 'bottom' : 'top';
	            path.setStyle({
	              textFill: iconStyleEmphasisModel.get('textFill') || hoverStyle.fill || hoverStyle.stroke || '#000',
	              textBackgroundColor: iconStyleEmphasisModel.get('textBackgroundColor'),
	              textPosition: iconStyleEmphasisModel.get('textPosition') || defaultTextPosition
	            });
	          }).on('mouseout', function () {
	            path.setStyle({
	              textFill: null,
	              textBackgroundColor: null
	            });
	          });
	        }
	
	        path.trigger(featureModel.get('iconStatus.' + iconName) || 'normal');
	        group.add(path);
	        path.on('click', zrUtil.bind(feature.onclick, feature, ecModel, api, iconName));
	        iconPaths[iconName] = path;
	      });
	    }
	
	    listComponentHelper.layout(group, toolboxModel, api); // Render background after group is layout
	    // FIXME
	
	    group.add(listComponentHelper.makeBackground(group.getBoundingRect(), toolboxModel)); // Adjust icon title positions to avoid them out of screen
	
	    group.eachChild(function (icon) {
	      var titleText = icon.__title;
	      var hoverStyle = icon.hoverStyle; // May be background element
	
	      if (hoverStyle && titleText) {
	        var rect = textContain.getBoundingRect(titleText, textContain.makeFont(hoverStyle));
	        var offsetX = icon.position[0] + group.position[0];
	        var offsetY = icon.position[1] + group.position[1] + itemSize;
	        var needPutOnTop = false;
	
	        if (offsetY + rect.height > api.getHeight()) {
	          hoverStyle.textPosition = 'top';
	          needPutOnTop = true;
	        }
	
	        var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 8;
	
	        if (offsetX + rect.width / 2 > api.getWidth()) {
	          hoverStyle.textPosition = ['100%', topOffset];
	          hoverStyle.textAlign = 'right';
	        } else if (offsetX - rect.width / 2 < 0) {
	          hoverStyle.textPosition = [0, topOffset];
	          hoverStyle.textAlign = 'left';
	        }
	      }
	    });
	  },
	  updateView: function (toolboxModel, ecModel, api, payload) {
	    zrUtil.each(this._features, function (feature) {
	      feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
	    });
	  },
	  // updateLayout: function (toolboxModel, ecModel, api, payload) {
	  //     zrUtil.each(this._features, function (feature) {
	  //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
	  //     });
	  // },
	  remove: function (ecModel, api) {
	    zrUtil.each(this._features, function (feature) {
	      feature.remove && feature.remove(ecModel, api);
	    });
	    this.group.removeAll();
	  },
	  dispose: function (ecModel, api) {
	    zrUtil.each(this._features, function (feature) {
	      feature.dispose && feature.dispose(ecModel, api);
	    });
	  }
	});
	
	function isUserFeatureName(featureName) {
	  return featureName.indexOf('my') === 0;
	}
	
	module.exports = _default;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _layout = __webpack_require__(305);
	
	var getLayoutRect = _layout.getLayoutRect;
	var layoutBox = _layout.box;
	var positionElement = _layout.positionElement;
	
	var formatUtil = __webpack_require__(307);
	
	var graphic = __webpack_require__(268);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Layout list like component.
	 * It will box layout each items in group of component and then position the whole group in the viewport
	 * @param {module:zrender/group/Group} group
	 * @param {module:echarts/model/Component} componentModel
	 * @param {module:echarts/ExtensionAPI}
	 */
	function layout(group, componentModel, api) {
	  var boxLayoutParams = componentModel.getBoxLayoutParams();
	  var padding = componentModel.get('padding');
	  var viewportSize = {
	    width: api.getWidth(),
	    height: api.getHeight()
	  };
	  var rect = getLayoutRect(boxLayoutParams, viewportSize, padding);
	  layoutBox(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
	  positionElement(group, boxLayoutParams, viewportSize, padding);
	}
	
	function makeBackground(rect, componentModel) {
	  var padding = formatUtil.normalizeCssArray(componentModel.get('padding'));
	  var style = componentModel.getItemStyle(['color', 'opacity']);
	  style.fill = componentModel.get('backgroundColor');
	  var rect = new graphic.Rect({
	    shape: {
	      x: rect.x - padding[3],
	      y: rect.y - padding[0],
	      width: rect.width + padding[1] + padding[3],
	      height: rect.height + padding[0] + padding[2],
	      r: componentModel.get('borderRadius')
	    },
	    style: style,
	    silent: true,
	    z2: -1
	  }); // FIXME
	  // `subPixelOptimizeRect` may bring some gap between edge of viewpart
	  // and background rect when setting like `left: 0`, `top: 0`.
	  // graphic.subPixelOptimizeRect(rect);
	
	  return rect;
	}
	
	exports.layout = layout;
	exports.makeBackground = makeBackground;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var env = __webpack_require__(219);
	
	var lang = __webpack_require__(330);
	
	var featureManager = __webpack_require__(614);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint8Array */
	var saveAsImageLang = lang.toolbox.saveAsImage;
	
	function SaveAsImage(model) {
	  this.model = model;
	}
	
	SaveAsImage.defaultOption = {
	  show: true,
	  icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
	  title: saveAsImageLang.title,
	  type: 'png',
	  // Default use option.backgroundColor
	  // backgroundColor: '#fff',
	  connectedBackgroundColor: '#fff',
	  name: '',
	  excludeComponents: ['toolbox'],
	  pixelRatio: 1,
	  lang: saveAsImageLang.lang.slice()
	};
	SaveAsImage.prototype.unusable = !env.canvasSupported;
	var proto = SaveAsImage.prototype;
	
	proto.onclick = function (ecModel, api) {
	  var model = this.model;
	  var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
	  var isSvg = api.getZr().painter.getType() === 'svg';
	  var type = isSvg ? 'svg' : model.get('type', true) || 'png';
	  var url = api.getConnectedDataURL({
	    type: type,
	    backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
	    connectedBackgroundColor: model.get('connectedBackgroundColor'),
	    excludeComponents: model.get('excludeComponents'),
	    pixelRatio: model.get('pixelRatio')
	  }); // Chrome and Firefox
	
	  if (typeof MouseEvent === 'function' && !env.browser.ie && !env.browser.edge) {
	    var $a = document.createElement('a');
	    $a.download = title + '.' + type;
	    $a.target = '_blank';
	    $a.href = url;
	    var evt = new MouseEvent('click', {
	      // some micro front-end framework， window maybe is a Proxy
	      view: document.defaultView,
	      bubbles: true,
	      cancelable: false
	    });
	    $a.dispatchEvent(evt);
	  } // IE
	  else {
	      if (window.navigator.msSaveOrOpenBlob) {
	        var bstr = atob(url.split(',')[1]);
	        var n = bstr.length;
	        var u8arr = new Uint8Array(n);
	
	        while (n--) {
	          u8arr[n] = bstr.charCodeAt(n);
	        }
	
	        var blob = new Blob([u8arr]);
	        window.navigator.msSaveOrOpenBlob(blob, title + '.' + type);
	      } else {
	        var lang = model.get('lang');
	        var html = '' + '<body style="margin:0;">' + '<img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
	        var tab = window.open();
	        tab.document.write(html);
	      }
	    }
	};
	
	featureManager.register('saveAsImage', SaveAsImage);
	var _default = SaveAsImage;
	module.exports = _default;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var lang = __webpack_require__(330);
	
	var featureManager = __webpack_require__(614);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var magicTypeLang = lang.toolbox.magicType;
	var INNER_STACK_KEYWORD = '__ec_magicType_stack__';
	
	function MagicType(model) {
	  this.model = model;
	}
	
	MagicType.defaultOption = {
	  show: true,
	  type: [],
	  // Icon group
	  icon: {
	    /* eslint-disable */
	    line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
	    bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
	    stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z' // jshint ignore:line
	
	    /* eslint-enable */
	
	  },
	  // `line`, `bar`, `stack`, `tiled`
	  title: zrUtil.clone(magicTypeLang.title),
	  option: {},
	  seriesIndex: {}
	};
	var proto = MagicType.prototype;
	
	proto.getIcons = function () {
	  var model = this.model;
	  var availableIcons = model.get('icon');
	  var icons = {};
	  zrUtil.each(model.get('type'), function (type) {
	    if (availableIcons[type]) {
	      icons[type] = availableIcons[type];
	    }
	  });
	  return icons;
	};
	
	var seriesOptGenreator = {
	  'line': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'bar') {
	      return zrUtil.merge({
	        id: seriesId,
	        type: 'line',
	        // Preserve data related option
	        data: seriesModel.get('data'),
	        stack: seriesModel.get('stack'),
	        markPoint: seriesModel.get('markPoint'),
	        markLine: seriesModel.get('markLine')
	      }, model.get('option.line') || {}, true);
	    }
	  },
	  'bar': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'line') {
	      return zrUtil.merge({
	        id: seriesId,
	        type: 'bar',
	        // Preserve data related option
	        data: seriesModel.get('data'),
	        stack: seriesModel.get('stack'),
	        markPoint: seriesModel.get('markPoint'),
	        markLine: seriesModel.get('markLine')
	      }, model.get('option.bar') || {}, true);
	    }
	  },
	  'stack': function (seriesType, seriesId, seriesModel, model) {
	    var isStack = seriesModel.get('stack') === INNER_STACK_KEYWORD;
	
	    if (seriesType === 'line' || seriesType === 'bar') {
	      model.setIconStatus('stack', isStack ? 'normal' : 'emphasis');
	      return zrUtil.merge({
	        id: seriesId,
	        stack: isStack ? '' : INNER_STACK_KEYWORD
	      }, model.get('option.stack') || {}, true);
	    }
	  }
	};
	var radioTypes = [['line', 'bar'], ['stack']];
	
	proto.onclick = function (ecModel, api, type) {
	  var model = this.model;
	  var seriesIndex = model.get('seriesIndex.' + type); // Not supported magicType
	
	  if (!seriesOptGenreator[type]) {
	    return;
	  }
	
	  var newOption = {
	    series: []
	  };
	
	  var generateNewSeriesTypes = function (seriesModel) {
	    var seriesType = seriesModel.subType;
	    var seriesId = seriesModel.id;
	    var newSeriesOpt = seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
	
	    if (newSeriesOpt) {
	      // PENDING If merge original option?
	      zrUtil.defaults(newSeriesOpt, seriesModel.option);
	      newOption.series.push(newSeriesOpt);
	    } // Modify boundaryGap
	
	
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
	      var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	      if (categoryAxis) {
	        var axisDim = categoryAxis.dim;
	        var axisType = axisDim + 'Axis';
	        var axisModel = ecModel.queryComponents({
	          mainType: axisType,
	          index: seriesModel.get(name + 'Index'),
	          id: seriesModel.get(name + 'Id')
	        })[0];
	        var axisIndex = axisModel.componentIndex;
	        newOption[axisType] = newOption[axisType] || [];
	
	        for (var i = 0; i <= axisIndex; i++) {
	          newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
	        }
	
	        newOption[axisType][axisIndex].boundaryGap = type === 'bar';
	      }
	    }
	  };
	
	  zrUtil.each(radioTypes, function (radio) {
	    if (zrUtil.indexOf(radio, type) >= 0) {
	      zrUtil.each(radio, function (item) {
	        model.setIconStatus(item, 'normal');
	      });
	    }
	  });
	  model.setIconStatus(type, 'emphasis');
	  ecModel.eachComponent({
	    mainType: 'series',
	    query: seriesIndex == null ? null : {
	      seriesIndex: seriesIndex
	    }
	  }, generateNewSeriesTypes);
	  var newTitle; // Change title of stack
	
	  if (type === 'stack') {
	    var isStack = newOption.series && newOption.series[0] && newOption.series[0].stack === INNER_STACK_KEYWORD;
	    newTitle = isStack ? zrUtil.merge({
	      stack: magicTypeLang.title.tiled
	    }, magicTypeLang.title) : zrUtil.clone(magicTypeLang.title);
	  }
	
	  api.dispatchAction({
	    type: 'changeMagicType',
	    currentType: type,
	    newOption: newOption,
	    newTitle: newTitle,
	    featureName: 'magicType'
	  });
	};
	
	echarts.registerAction({
	  type: 'changeMagicType',
	  event: 'magicTypeChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  ecModel.mergeOption(payload.newOption);
	});
	featureManager.register('magicType', MagicType);
	var _default = MagicType;
	module.exports = _default;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var eventTool = __webpack_require__(225);
	
	var lang = __webpack_require__(330);
	
	var featureManager = __webpack_require__(614);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var dataViewLang = lang.toolbox.dataView;
	var BLOCK_SPLITER = new Array(60).join('-');
	var ITEM_SPLITER = '\t';
	/**
	 * Group series into two types
	 *  1. on category axis, like line, bar
	 *  2. others, like scatter, pie
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object}
	 * @inner
	 */
	
	function groupSeries(ecModel) {
	  var seriesGroupByCategoryAxis = {};
	  var otherSeries = [];
	  var meta = [];
	  ecModel.eachRawSeries(function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
	      var baseAxis = coordSys.getBaseAxis();
	
	      if (baseAxis.type === 'category') {
	        var key = baseAxis.dim + '_' + baseAxis.index;
	
	        if (!seriesGroupByCategoryAxis[key]) {
	          seriesGroupByCategoryAxis[key] = {
	            categoryAxis: baseAxis,
	            valueAxis: coordSys.getOtherAxis(baseAxis),
	            series: []
	          };
	          meta.push({
	            axisDim: baseAxis.dim,
	            axisIndex: baseAxis.index
	          });
	        }
	
	        seriesGroupByCategoryAxis[key].series.push(seriesModel);
	      } else {
	        otherSeries.push(seriesModel);
	      }
	    } else {
	      otherSeries.push(seriesModel);
	    }
	  });
	  return {
	    seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
	    other: otherSeries,
	    meta: meta
	  };
	}
	/**
	 * Assemble content of series on cateogory axis
	 * @param {Array.<module:echarts/model/Series>} series
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleSeriesWithCategoryAxis(series) {
	  var tables = [];
	  zrUtil.each(series, function (group, key) {
	    var categoryAxis = group.categoryAxis;
	    var valueAxis = group.valueAxis;
	    var valueAxisDim = valueAxis.dim;
	    var headers = [' '].concat(zrUtil.map(group.series, function (series) {
	      return series.name;
	    }));
	    var columns = [categoryAxis.model.getCategories()];
	    zrUtil.each(group.series, function (series) {
	      var rawData = series.getRawData();
	      columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function (val) {
	        return val;
	      }));
	    }); // Assemble table content
	
	    var lines = [headers.join(ITEM_SPLITER)];
	
	    for (var i = 0; i < columns[0].length; i++) {
	      var items = [];
	
	      for (var j = 0; j < columns.length; j++) {
	        items.push(columns[j][i]);
	      }
	
	      lines.push(items.join(ITEM_SPLITER));
	    }
	
	    tables.push(lines.join('\n'));
	  });
	  return tables.join('\n\n' + BLOCK_SPLITER + '\n\n');
	}
	/**
	 * Assemble content of other series
	 * @param {Array.<module:echarts/model/Series>} series
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleOtherSeries(series) {
	  return zrUtil.map(series, function (series) {
	    var data = series.getRawData();
	    var lines = [series.name];
	    var vals = [];
	    data.each(data.dimensions, function () {
	      var argLen = arguments.length;
	      var dataIndex = arguments[argLen - 1];
	      var name = data.getName(dataIndex);
	
	      for (var i = 0; i < argLen - 1; i++) {
	        vals[i] = arguments[i];
	      }
	
	      lines.push((name ? name + ITEM_SPLITER : '') + vals.join(ITEM_SPLITER));
	    });
	    return lines.join('\n');
	  }).join('\n\n' + BLOCK_SPLITER + '\n\n');
	}
	/**
	 * @param {module:echarts/model/Global}
	 * @return {Object}
	 * @inner
	 */
	
	
	function getContentFromModel(ecModel) {
	  var result = groupSeries(ecModel);
	  return {
	    value: zrUtil.filter([assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis), assembleOtherSeries(result.other)], function (str) {
	      return str.replace(/[\n\t\s]/g, '');
	    }).join('\n\n' + BLOCK_SPLITER + '\n\n'),
	    meta: result.meta
	  };
	}
	
	function trim(str) {
	  return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	}
	/**
	 * If a block is tsv format
	 */
	
	
	function isTSVFormat(block) {
	  // Simple method to find out if a block is tsv format
	  var firstLine = block.slice(0, block.indexOf('\n'));
	
	  if (firstLine.indexOf(ITEM_SPLITER) >= 0) {
	    return true;
	  }
	}
	
	var itemSplitRegex = new RegExp('[' + ITEM_SPLITER + ']+', 'g');
	/**
	 * @param {string} tsv
	 * @return {Object}
	 */
	
	function parseTSVContents(tsv) {
	  var tsvLines = tsv.split(/\n+/g);
	  var headers = trim(tsvLines.shift()).split(itemSplitRegex);
	  var categories = [];
	  var series = zrUtil.map(headers, function (header) {
	    return {
	      name: header,
	      data: []
	    };
	  });
	
	  for (var i = 0; i < tsvLines.length; i++) {
	    var items = trim(tsvLines[i]).split(itemSplitRegex);
	    categories.push(items.shift());
	
	    for (var j = 0; j < items.length; j++) {
	      series[j] && (series[j].data[i] = items[j]);
	    }
	  }
	
	  return {
	    series: series,
	    categories: categories
	  };
	}
	/**
	 * @param {string} str
	 * @return {Array.<Object>}
	 * @inner
	 */
	
	
	function parseListContents(str) {
	  var lines = str.split(/\n+/g);
	  var seriesName = trim(lines.shift());
	  var data = [];
	
	  for (var i = 0; i < lines.length; i++) {
	    // if line is empty, ignore it.
	    // there is a case that a user forgot to delete `\n`.
	    var line = trim(lines[i]);
	
	    if (!line) {
	      continue;
	    }
	
	    var items = line.split(itemSplitRegex);
	    var name = '';
	    var value;
	    var hasName = false;
	
	    if (isNaN(items[0])) {
	      // First item is name
	      hasName = true;
	      name = items[0];
	      items = items.slice(1);
	      data[i] = {
	        name: name,
	        value: []
	      };
	      value = data[i].value;
	    } else {
	      value = data[i] = [];
	    }
	
	    for (var j = 0; j < items.length; j++) {
	      value.push(+items[j]);
	    }
	
	    if (value.length === 1) {
	      hasName ? data[i].value = value[0] : data[i] = value[0];
	    }
	  }
	
	  return {
	    name: seriesName,
	    data: data
	  };
	}
	/**
	 * @param {string} str
	 * @param {Array.<Object>} blockMetaList
	 * @return {Object}
	 * @inner
	 */
	
	
	function parseContents(str, blockMetaList) {
	  var blocks = str.split(new RegExp('\n*' + BLOCK_SPLITER + '\n*', 'g'));
	  var newOption = {
	    series: []
	  };
	  zrUtil.each(blocks, function (block, idx) {
	    if (isTSVFormat(block)) {
	      var result = parseTSVContents(block);
	      var blockMeta = blockMetaList[idx];
	      var axisKey = blockMeta.axisDim + 'Axis';
	
	      if (blockMeta) {
	        newOption[axisKey] = newOption[axisKey] || [];
	        newOption[axisKey][blockMeta.axisIndex] = {
	          data: result.categories
	        };
	        newOption.series = newOption.series.concat(result.series);
	      }
	    } else {
	      var result = parseListContents(block);
	      newOption.series.push(result);
	    }
	  });
	  return newOption;
	}
	/**
	 * @alias {module:echarts/component/toolbox/feature/DataView}
	 * @constructor
	 * @param {module:echarts/model/Model} model
	 */
	
	
	function DataView(model) {
	  this._dom = null;
	  this.model = model;
	}
	
	DataView.defaultOption = {
	  show: true,
	  readOnly: false,
	  optionToContent: null,
	  contentToOption: null,
	  icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
	  title: zrUtil.clone(dataViewLang.title),
	  lang: zrUtil.clone(dataViewLang.lang),
	  backgroundColor: '#fff',
	  textColor: '#000',
	  textareaColor: '#fff',
	  textareaBorderColor: '#333',
	  buttonColor: '#c23531',
	  buttonTextColor: '#fff'
	};
	
	DataView.prototype.onclick = function (ecModel, api) {
	  var container = api.getDom();
	  var model = this.model;
	
	  if (this._dom) {
	    container.removeChild(this._dom);
	  }
	
	  var root = document.createElement('div');
	  root.style.cssText = 'position:absolute;left:5px;top:5px;bottom:5px;right:5px;';
	  root.style.backgroundColor = model.get('backgroundColor') || '#fff'; // Create elements
	
	  var header = document.createElement('h4');
	  var lang = model.get('lang') || [];
	  header.innerHTML = lang[0] || model.get('title');
	  header.style.cssText = 'margin: 10px 20px;';
	  header.style.color = model.get('textColor');
	  var viewMain = document.createElement('div');
	  var textarea = document.createElement('textarea');
	  viewMain.style.cssText = 'display:block;width:100%;overflow:auto;';
	  var optionToContent = model.get('optionToContent');
	  var contentToOption = model.get('contentToOption');
	  var result = getContentFromModel(ecModel);
	
	  if (typeof optionToContent === 'function') {
	    var htmlOrDom = optionToContent(api.getOption());
	
	    if (typeof htmlOrDom === 'string') {
	      viewMain.innerHTML = htmlOrDom;
	    } else if (zrUtil.isDom(htmlOrDom)) {
	      viewMain.appendChild(htmlOrDom);
	    }
	  } else {
	    // Use default textarea
	    viewMain.appendChild(textarea);
	    textarea.readOnly = model.get('readOnly');
	    textarea.style.cssText = 'width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;';
	    textarea.style.color = model.get('textColor');
	    textarea.style.borderColor = model.get('textareaBorderColor');
	    textarea.style.backgroundColor = model.get('textareaColor');
	    textarea.value = result.value;
	  }
	
	  var blockMetaList = result.meta;
	  var buttonContainer = document.createElement('div');
	  buttonContainer.style.cssText = 'position:absolute;bottom:0;left:0;right:0;';
	  var buttonStyle = 'float:right;margin-right:20px;border:none;' + 'cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
	  var closeButton = document.createElement('div');
	  var refreshButton = document.createElement('div');
	  buttonStyle += ';background-color:' + model.get('buttonColor');
	  buttonStyle += ';color:' + model.get('buttonTextColor');
	  var self = this;
	
	  function close() {
	    container.removeChild(root);
	    self._dom = null;
	  }
	
	  eventTool.addEventListener(closeButton, 'click', close);
	  eventTool.addEventListener(refreshButton, 'click', function () {
	    var newOption;
	
	    try {
	      if (typeof contentToOption === 'function') {
	        newOption = contentToOption(viewMain, api.getOption());
	      } else {
	        newOption = parseContents(textarea.value, blockMetaList);
	      }
	    } catch (e) {
	      close();
	      throw new Error('Data view format error ' + e);
	    }
	
	    if (newOption) {
	      api.dispatchAction({
	        type: 'changeDataView',
	        newOption: newOption
	      });
	    }
	
	    close();
	  });
	  closeButton.innerHTML = lang[1];
	  refreshButton.innerHTML = lang[2];
	  refreshButton.style.cssText = buttonStyle;
	  closeButton.style.cssText = buttonStyle;
	  !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
	  buttonContainer.appendChild(closeButton);
	  root.appendChild(header);
	  root.appendChild(viewMain);
	  root.appendChild(buttonContainer);
	  viewMain.style.height = container.clientHeight - 80 + 'px';
	  container.appendChild(root);
	  this._dom = root;
	};
	
	DataView.prototype.remove = function (ecModel, api) {
	  this._dom && api.getDom().removeChild(this._dom);
	};
	
	DataView.prototype.dispose = function (ecModel, api) {
	  this.remove(ecModel, api);
	};
	/**
	 * @inner
	 */
	
	
	function tryMergeDataOption(newData, originalData) {
	  return zrUtil.map(newData, function (newVal, idx) {
	    var original = originalData && originalData[idx];
	
	    if (zrUtil.isObject(original) && !zrUtil.isArray(original)) {
	      var newValIsObject = zrUtil.isObject(newVal) && !zrUtil.isArray(newVal);
	
	      if (!newValIsObject) {
	        newVal = {
	          value: newVal
	        };
	      } // original data has name but new data has no name
	
	
	      var shouldDeleteName = original.name != null && newVal.name == null; // Original data has option
	
	      newVal = zrUtil.defaults(newVal, original);
	      shouldDeleteName && delete newVal.name;
	      return newVal;
	    } else {
	      return newVal;
	    }
	  });
	}
	
	featureManager.register('dataView', DataView);
	echarts.registerAction({
	  type: 'changeDataView',
	  event: 'dataViewChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  var newSeriesOptList = [];
	  zrUtil.each(payload.newOption.series, function (seriesOpt) {
	    var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
	
	    if (!seriesModel) {
	      // New created series
	      // Geuss the series type
	      newSeriesOptList.push(zrUtil.extend({
	        // Default is scatter
	        type: 'scatter'
	      }, seriesOpt));
	    } else {
	      var originalData = seriesModel.get('data');
	      newSeriesOptList.push({
	        name: seriesOpt.name,
	        data: tryMergeDataOption(seriesOpt.data, originalData)
	      });
	    }
	  });
	  ecModel.mergeOption(zrUtil.defaults({
	    series: newSeriesOptList
	  }, payload.newOption));
	});
	var _default = DataView;
	module.exports = _default;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var BrushController = __webpack_require__(513);
	
	var BrushTargetManager = __webpack_require__(621);
	
	var history = __webpack_require__(622);
	
	var sliderMove = __webpack_require__(507);
	
	var lang = __webpack_require__(330);
	
	var featureManager = __webpack_require__(614);
	
	__webpack_require__(623);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Use dataZoomSelect
	var dataZoomLang = lang.toolbox.dataZoom;
	var each = zrUtil.each; // Spectial component id start with \0ec\0, see echarts/model/Global.js~hasInnerId
	
	var DATA_ZOOM_ID_BASE = '\0_ec_\0toolbox-dataZoom_';
	
	function DataZoom(model, ecModel, api) {
	  /**
	   * @private
	   * @type {module:echarts/component/helper/BrushController}
	   */
	  (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._isZoomActive;
	}
	
	DataZoom.defaultOption = {
	  show: true,
	  filterMode: 'filter',
	  // Icon group
	  icon: {
	    zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
	    back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
	  },
	  // `zoom`, `back`
	  title: zrUtil.clone(dataZoomLang.title),
	  brushStyle: {
	    borderWidth: 0,
	    color: 'rgba(0,0,0,0.2)'
	  }
	};
	var proto = DataZoom.prototype;
	
	proto.render = function (featureModel, ecModel, api, payload) {
	  this.model = featureModel;
	  this.ecModel = ecModel;
	  this.api = api;
	  updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
	  updateBackBtnStatus(featureModel, ecModel);
	};
	
	proto.onclick = function (ecModel, api, type) {
	  handlers[type].call(this);
	};
	
	proto.remove = function (ecModel, api) {
	  this._brushController.unmount();
	};
	
	proto.dispose = function (ecModel, api) {
	  this._brushController.dispose();
	};
	/**
	 * @private
	 */
	
	
	var handlers = {
	  zoom: function () {
	    var nextActive = !this._isZoomActive;
	    this.api.dispatchAction({
	      type: 'takeGlobalCursor',
	      key: 'dataZoomSelect',
	      dataZoomSelectActive: nextActive
	    });
	  },
	  back: function () {
	    this._dispatchZoomAction(history.pop(this.ecModel));
	  }
	};
	/**
	 * @private
	 */
	
	proto._onBrush = function (areas, opt) {
	  if (!opt.isEnd || !areas.length) {
	    return;
	  }
	
	  var snapshot = {};
	  var ecModel = this.ecModel;
	
	  this._brushController.updateCovers([]); // remove cover
	
	
	  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(this.model.option), ecModel, {
	    include: ['grid']
	  });
	  brushTargetManager.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	    if (coordSys.type !== 'cartesian2d') {
	      return;
	    }
	
	    var brushType = area.brushType;
	
	    if (brushType === 'rect') {
	      setBatch('x', coordSys, coordRange[0]);
	      setBatch('y', coordSys, coordRange[1]);
	    } else {
	      setBatch({
	        lineX: 'x',
	        lineY: 'y'
	      }[brushType], coordSys, coordRange);
	    }
	  });
	  history.push(ecModel, snapshot);
	
	  this._dispatchZoomAction(snapshot);
	
	  function setBatch(dimName, coordSys, minMax) {
	    var axis = coordSys.getAxis(dimName);
	    var axisModel = axis.model;
	    var dataZoomModel = findDataZoom(dimName, axisModel, ecModel); // Restrict range.
	
	    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
	
	    if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) {
	      minMax = sliderMove(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
	    }
	
	    dataZoomModel && (snapshot[dataZoomModel.id] = {
	      dataZoomId: dataZoomModel.id,
	      startValue: minMax[0],
	      endValue: minMax[1]
	    });
	  }
	
	  function findDataZoom(dimName, axisModel, ecModel) {
	    var found;
	    ecModel.eachComponent({
	      mainType: 'dataZoom',
	      subType: 'select'
	    }, function (dzModel) {
	      var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
	      has && (found = dzModel);
	    });
	    return found;
	  }
	};
	/**
	 * @private
	 */
	
	
	proto._dispatchZoomAction = function (snapshot) {
	  var batch = []; // Convert from hash map to array.
	
	  each(snapshot, function (batchItem, dataZoomId) {
	    batch.push(zrUtil.clone(batchItem));
	  });
	  batch.length && this.api.dispatchAction({
	    type: 'dataZoom',
	    from: this.uid,
	    batch: batch
	  });
	};
	
	function retrieveAxisSetting(option) {
	  var setting = {}; // Compatible with previous setting: null => all axis, false => no axis.
	
	  zrUtil.each(['xAxisIndex', 'yAxisIndex'], function (name) {
	    setting[name] = option[name];
	    setting[name] == null && (setting[name] = 'all');
	    (setting[name] === false || setting[name] === 'none') && (setting[name] = []);
	  });
	  return setting;
	}
	
	function updateBackBtnStatus(featureModel, ecModel) {
	  featureModel.setIconStatus('back', history.count(ecModel) > 1 ? 'emphasis' : 'normal');
	}
	
	function updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
	  var zoomActive = view._isZoomActive;
	
	  if (payload && payload.type === 'takeGlobalCursor') {
	    zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
	  }
	
	  view._isZoomActive = zoomActive;
	  featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
	  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(featureModel.option), ecModel, {
	    include: ['grid']
	  });
	
	  view._brushController.setPanels(brushTargetManager.makePanelOpts(api, function (targetInfo) {
	    return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
	  })).enableBrush(zoomActive ? {
	    brushType: 'auto',
	    brushStyle: featureModel.getModel('brushStyle').getItemStyle()
	  } : false);
	}
	
	featureManager.register('dataZoom', DataZoom); // Create special dataZoom option for select
	// FIXME consider the case of merge option, where axes options are not exists.
	
	echarts.registerPreprocessor(function (option) {
	  if (!option) {
	    return;
	  }
	
	  var dataZoomOpts = option.dataZoom || (option.dataZoom = []);
	
	  if (!zrUtil.isArray(dataZoomOpts)) {
	    option.dataZoom = dataZoomOpts = [dataZoomOpts];
	  }
	
	  var toolboxOpt = option.toolbox;
	
	  if (toolboxOpt) {
	    // Assume there is only one toolbox
	    if (zrUtil.isArray(toolboxOpt)) {
	      toolboxOpt = toolboxOpt[0];
	    }
	
	    if (toolboxOpt && toolboxOpt.feature) {
	      var dataZoomOpt = toolboxOpt.feature.dataZoom; // FIXME: If add dataZoom when setOption in merge mode,
	      // no axis info to be added. See `test/dataZoom-extreme.html`
	
	      addForAxis('xAxis', dataZoomOpt);
	      addForAxis('yAxis', dataZoomOpt);
	    }
	  }
	
	  function addForAxis(axisName, dataZoomOpt) {
	    if (!dataZoomOpt) {
	      return;
	    } // Try not to modify model, because it is not merged yet.
	
	
	    var axisIndicesName = axisName + 'Index';
	    var givenAxisIndices = dataZoomOpt[axisIndicesName];
	
	    if (givenAxisIndices != null && givenAxisIndices !== 'all' && !zrUtil.isArray(givenAxisIndices)) {
	      givenAxisIndices = givenAxisIndices === false || givenAxisIndices === 'none' ? [] : [givenAxisIndices];
	    }
	
	    forEachComponent(axisName, function (axisOpt, axisIndex) {
	      if (givenAxisIndices != null && givenAxisIndices !== 'all' && zrUtil.indexOf(givenAxisIndices, axisIndex) === -1) {
	        return;
	      }
	
	      var newOpt = {
	        type: 'select',
	        $fromToolbox: true,
	        // Default to be filter
	        filterMode: dataZoomOpt.filterMode || 'filter',
	        // Id for merge mapping.
	        id: DATA_ZOOM_ID_BASE + axisName + axisIndex
	      }; // FIXME
	      // Only support one axis now.
	
	      newOpt[axisIndicesName] = axisIndex;
	      dataZoomOpts.push(newOpt);
	    });
	  }
	
	  function forEachComponent(mainType, cb) {
	    var opts = option[mainType];
	
	    if (!zrUtil.isArray(opts)) {
	      opts = opts ? [opts] : [];
	    }
	
	    each(opts, cb);
	  }
	});
	var _default = DataZoom;
	module.exports = _default;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var modelUtil = __webpack_require__(261);
	
	var brushHelper = __webpack_require__(514);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var indexOf = zrUtil.indexOf;
	var curry = zrUtil.curry;
	var COORD_CONVERTS = ['dataToPoint', 'pointToData']; // FIXME
	// how to genarialize to more coordinate systems.
	
	var INCLUDE_FINDER_MAIN_TYPES = ['grid', 'xAxis', 'yAxis', 'geo', 'graph', 'polar', 'radiusAxis', 'angleAxis', 'bmap'];
	/**
	 * [option in constructor]:
	 * {
	 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
	 * }
	 *
	 *
	 * [targetInfo]:
	 *
	 * There can be multiple axes in a single targetInfo. Consider the case
	 * of `grid` component, a targetInfo represents a grid which contains one or more
	 * cartesian and one or more axes. And consider the case of parallel system,
	 * which has multiple axes in a coordinate system.
	 * Can be {
	 *     panelId: ...,
	 *     coordSys: <a representitive cartesian in grid (first cartesian by default)>,
	 *     coordSyses: all cartesians.
	 *     gridModel: <grid component>
	 *     xAxes: correspond to coordSyses on index
	 *     yAxes: correspond to coordSyses on index
	 * }
	 * or {
	 *     panelId: ...,
	 *     coordSys: <geo coord sys>
	 *     coordSyses: [<geo coord sys>]
	 *     geoModel: <geo component>
	 * }
	 *
	 *
	 * [panelOpt]:
	 *
	 * Make from targetInfo. Input to BrushController.
	 * {
	 *     panelId: ...,
	 *     rect: ...
	 * }
	 *
	 *
	 * [area]:
	 *
	 * Generated by BrushController or user input.
	 * {
	 *     panelId: Used to locate coordInfo directly. If user inpput, no panelId.
	 *     brushType: determine how to convert to/from coord('rect' or 'polygon' or 'lineX/Y').
	 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
	 *     range: pixel range.
	 *     coordRange: representitive coord range (the first one of coordRanges).
	 *     coordRanges: <Array> coord ranges, used in multiple cartesian in one grid.
	 * }
	 */
	
	/**
	 * @param {Object} option contains Index/Id/Name of xAxis/yAxis/geo/grid
	 *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} [opt]
	 * @param {Array.<string>} [opt.include] include coordinate system types.
	 */
	
	function BrushTargetManager(option, ecModel, opt) {
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	  var targetInfoList = this._targetInfoList = [];
	  var info = {};
	  var foundCpts = parseFinder(ecModel, option);
	  each(targetInfoBuilders, function (builder, type) {
	    if (!opt || !opt.include || indexOf(opt.include, type) >= 0) {
	      builder(foundCpts, targetInfoList, info);
	    }
	  });
	}
	
	var proto = BrushTargetManager.prototype;
	
	proto.setOutputRanges = function (areas, ecModel) {
	  this.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	    (area.coordRanges || (area.coordRanges = [])).push(coordRange); // area.coordRange is the first of area.coordRanges
	
	    if (!area.coordRange) {
	      area.coordRange = coordRange; // In 'category' axis, coord to pixel is not reversible, so we can not
	      // rebuild range by coordRange accrately, which may bring trouble when
	      // brushing only one item. So we use __rangeOffset to rebuilding range
	      // by coordRange. And this it only used in brush component so it is no
	      // need to be adapted to coordRanges.
	
	      var result = coordConvert[area.brushType](0, coordSys, coordRange);
	      area.__rangeOffset = {
	        offset: diffProcessor[area.brushType](result.values, area.range, [1, 1]),
	        xyMinMax: result.xyMinMax
	      };
	    }
	  });
	};
	
	proto.matchOutputRanges = function (areas, ecModel, cb) {
	  each(areas, function (area) {
	    var targetInfo = this.findTargetInfo(area, ecModel);
	
	    if (targetInfo && targetInfo !== true) {
	      zrUtil.each(targetInfo.coordSyses, function (coordSys) {
	        var result = coordConvert[area.brushType](1, coordSys, area.range);
	        cb(area, result.values, coordSys, ecModel);
	      });
	    }
	  }, this);
	};
	
	proto.setInputRanges = function (areas, ecModel) {
	  each(areas, function (area) {
	    var targetInfo = this.findTargetInfo(area, ecModel);
	    area.range = area.range || []; // convert coordRange to global range and set panelId.
	
	    if (targetInfo && targetInfo !== true) {
	      area.panelId = targetInfo.panelId; // (1) area.range shoule always be calculate from coordRange but does
	      // not keep its original value, for the sake of the dataZoom scenario,
	      // where area.coordRange remains unchanged but area.range may be changed.
	      // (2) Only support converting one coordRange to pixel range in brush
	      // component. So do not consider `coordRanges`.
	      // (3) About __rangeOffset, see comment above.
	
	      var result = coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
	      var rangeOffset = area.__rangeOffset;
	      area.range = rangeOffset ? diffProcessor[area.brushType](result.values, rangeOffset.offset, getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
	    }
	  }, this);
	};
	
	proto.makePanelOpts = function (api, getDefaultBrushType) {
	  return zrUtil.map(this._targetInfoList, function (targetInfo) {
	    var rect = targetInfo.getPanelRect();
	    return {
	      panelId: targetInfo.panelId,
	      defaultBrushType: getDefaultBrushType && getDefaultBrushType(targetInfo),
	      clipPath: brushHelper.makeRectPanelClipPath(rect),
	      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, targetInfo.coordSysModel),
	      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect)
	    };
	  });
	};
	
	proto.controlSeries = function (area, seriesModel, ecModel) {
	  // Check whether area is bound in coord, and series do not belong to that coord.
	  // If do not do this check, some brush (like lineX) will controll all axes.
	  var targetInfo = this.findTargetInfo(area, ecModel);
	  return targetInfo === true || targetInfo && indexOf(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
	};
	/**
	 * If return Object, a coord found.
	 * If reutrn true, global found.
	 * Otherwise nothing found.
	 *
	 * @param {Object} area
	 * @param {Array} targetInfoList
	 * @return {Object|boolean}
	 */
	
	
	proto.findTargetInfo = function (area, ecModel) {
	  var targetInfoList = this._targetInfoList;
	  var foundCpts = parseFinder(ecModel, area);
	
	  for (var i = 0; i < targetInfoList.length; i++) {
	    var targetInfo = targetInfoList[i];
	    var areaPanelId = area.panelId;
	
	    if (areaPanelId) {
	      if (targetInfo.panelId === areaPanelId) {
	        return targetInfo;
	      }
	    } else {
	      for (var i = 0; i < targetInfoMatchers.length; i++) {
	        if (targetInfoMatchers[i](foundCpts, targetInfo)) {
	          return targetInfo;
	        }
	      }
	    }
	  }
	
	  return true;
	};
	
	function formatMinMax(minMax) {
	  minMax[0] > minMax[1] && minMax.reverse();
	  return minMax;
	}
	
	function parseFinder(ecModel, option) {
	  return modelUtil.parseFinder(ecModel, option, {
	    includeMainTypes: INCLUDE_FINDER_MAIN_TYPES
	  });
	}
	
	var targetInfoBuilders = {
	  grid: function (foundCpts, targetInfoList) {
	    var xAxisModels = foundCpts.xAxisModels;
	    var yAxisModels = foundCpts.yAxisModels;
	    var gridModels = foundCpts.gridModels; // Remove duplicated.
	
	    var gridModelMap = zrUtil.createHashMap();
	    var xAxesHas = {};
	    var yAxesHas = {};
	
	    if (!xAxisModels && !yAxisModels && !gridModels) {
	      return;
	    }
	
	    each(xAxisModels, function (axisModel) {
	      var gridModel = axisModel.axis.grid.model;
	      gridModelMap.set(gridModel.id, gridModel);
	      xAxesHas[gridModel.id] = true;
	    });
	    each(yAxisModels, function (axisModel) {
	      var gridModel = axisModel.axis.grid.model;
	      gridModelMap.set(gridModel.id, gridModel);
	      yAxesHas[gridModel.id] = true;
	    });
	    each(gridModels, function (gridModel) {
	      gridModelMap.set(gridModel.id, gridModel);
	      xAxesHas[gridModel.id] = true;
	      yAxesHas[gridModel.id] = true;
	    });
	    gridModelMap.each(function (gridModel) {
	      var grid = gridModel.coordinateSystem;
	      var cartesians = [];
	      each(grid.getCartesians(), function (cartesian, index) {
	        if (indexOf(xAxisModels, cartesian.getAxis('x').model) >= 0 || indexOf(yAxisModels, cartesian.getAxis('y').model) >= 0) {
	          cartesians.push(cartesian);
	        }
	      });
	      targetInfoList.push({
	        panelId: 'grid--' + gridModel.id,
	        gridModel: gridModel,
	        coordSysModel: gridModel,
	        // Use the first one as the representitive coordSys.
	        coordSys: cartesians[0],
	        coordSyses: cartesians,
	        getPanelRect: panelRectBuilder.grid,
	        xAxisDeclared: xAxesHas[gridModel.id],
	        yAxisDeclared: yAxesHas[gridModel.id]
	      });
	    });
	  },
	  geo: function (foundCpts, targetInfoList) {
	    each(foundCpts.geoModels, function (geoModel) {
	      var coordSys = geoModel.coordinateSystem;
	      targetInfoList.push({
	        panelId: 'geo--' + geoModel.id,
	        geoModel: geoModel,
	        coordSysModel: geoModel,
	        coordSys: coordSys,
	        coordSyses: [coordSys],
	        getPanelRect: panelRectBuilder.geo
	      });
	    });
	  }
	};
	var targetInfoMatchers = [// grid
	function (foundCpts, targetInfo) {
	  var xAxisModel = foundCpts.xAxisModel;
	  var yAxisModel = foundCpts.yAxisModel;
	  var gridModel = foundCpts.gridModel;
	  !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
	  !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
	  return gridModel && gridModel === targetInfo.gridModel;
	}, // geo
	function (foundCpts, targetInfo) {
	  var geoModel = foundCpts.geoModel;
	  return geoModel && geoModel === targetInfo.geoModel;
	}];
	var panelRectBuilder = {
	  grid: function () {
	    // grid is not Transformable.
	    return this.coordSys.grid.getRect().clone();
	  },
	  geo: function () {
	    var coordSys = this.coordSys;
	    var rect = coordSys.getBoundingRect().clone(); // geo roam and zoom transform
	
	    rect.applyTransform(graphic.getTransform(coordSys));
	    return rect;
	  }
	};
	var coordConvert = {
	  lineX: curry(axisConvert, 0),
	  lineY: curry(axisConvert, 1),
	  rect: function (to, coordSys, rangeOrCoordRange) {
	    var xminymin = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]]);
	    var xmaxymax = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]]);
	    var values = [formatMinMax([xminymin[0], xmaxymax[0]]), formatMinMax([xminymin[1], xmaxymax[1]])];
	    return {
	      values: values,
	      xyMinMax: values
	    };
	  },
	  polygon: function (to, coordSys, rangeOrCoordRange) {
	    var xyMinMax = [[Infinity, -Infinity], [Infinity, -Infinity]];
	    var values = zrUtil.map(rangeOrCoordRange, function (item) {
	      var p = coordSys[COORD_CONVERTS[to]](item);
	      xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
	      xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
	      xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
	      xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
	      return p;
	    });
	    return {
	      values: values,
	      xyMinMax: xyMinMax
	    };
	  }
	};
	
	function axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
	  var axis = coordSys.getAxis(['x', 'y'][axisNameIndex]);
	  var values = formatMinMax(zrUtil.map([0, 1], function (i) {
	    return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i])) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
	  }));
	  var xyMinMax = [];
	  xyMinMax[axisNameIndex] = values;
	  xyMinMax[1 - axisNameIndex] = [NaN, NaN];
	  return {
	    values: values,
	    xyMinMax: xyMinMax
	  };
	}
	
	var diffProcessor = {
	  lineX: curry(axisDiffProcessor, 0),
	  lineY: curry(axisDiffProcessor, 1),
	  rect: function (values, refer, scales) {
	    return [[values[0][0] - scales[0] * refer[0][0], values[0][1] - scales[0] * refer[0][1]], [values[1][0] - scales[1] * refer[1][0], values[1][1] - scales[1] * refer[1][1]]];
	  },
	  polygon: function (values, refer, scales) {
	    return zrUtil.map(values, function (item, idx) {
	      return [item[0] - scales[0] * refer[idx][0], item[1] - scales[1] * refer[idx][1]];
	    });
	  }
	};
	
	function axisDiffProcessor(axisNameIndex, values, refer, scales) {
	  return [values[0] - scales[axisNameIndex] * refer[0], values[1] - scales[axisNameIndex] * refer[1]];
	} // We have to process scale caused by dataZoom manually,
	// although it might be not accurate.
	
	
	function getScales(xyMinMaxCurr, xyMinMaxOrigin) {
	  var sizeCurr = getSize(xyMinMaxCurr);
	  var sizeOrigin = getSize(xyMinMaxOrigin);
	  var scales = [sizeCurr[0] / sizeOrigin[0], sizeCurr[1] / sizeOrigin[1]];
	  isNaN(scales[0]) && (scales[0] = 1);
	  isNaN(scales[1]) && (scales[1] = 1);
	  return scales;
	}
	
	function getSize(xyMinMax) {
	  return xyMinMax ? [xyMinMax[0][1] - xyMinMax[0][0], xyMinMax[1][1] - xyMinMax[1][0]] : [NaN, NaN];
	}
	
	var _default = BrushTargetManager;
	module.exports = _default;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var ATTR = '\0_ec_hist_store';
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} newSnapshot {dataZoomId, batch: [payloadInfo, ...]}
	 */
	
	function push(ecModel, newSnapshot) {
	  var store = giveStore(ecModel); // If previous dataZoom can not be found,
	  // complete an range with current range.
	
	  each(newSnapshot, function (batchItem, dataZoomId) {
	    var i = store.length - 1;
	
	    for (; i >= 0; i--) {
	      var snapshot = store[i];
	
	      if (snapshot[dataZoomId]) {
	        break;
	      }
	    }
	
	    if (i < 0) {
	      // No origin range set, create one by current range.
	      var dataZoomModel = ecModel.queryComponents({
	        mainType: 'dataZoom',
	        subType: 'select',
	        id: dataZoomId
	      })[0];
	
	      if (dataZoomModel) {
	        var percentRange = dataZoomModel.getPercentRange();
	        store[0][dataZoomId] = {
	          dataZoomId: dataZoomId,
	          start: percentRange[0],
	          end: percentRange[1]
	        };
	      }
	    }
	  });
	  store.push(newSnapshot);
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object} snapshot
	 */
	
	
	function pop(ecModel) {
	  var store = giveStore(ecModel);
	  var head = store[store.length - 1];
	  store.length > 1 && store.pop(); // Find top for all dataZoom.
	
	  var snapshot = {};
	  each(head, function (batchItem, dataZoomId) {
	    for (var i = store.length - 1; i >= 0; i--) {
	      var batchItem = store[i][dataZoomId];
	
	      if (batchItem) {
	        snapshot[dataZoomId] = batchItem;
	        break;
	      }
	    }
	  });
	  return snapshot;
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function clear(ecModel) {
	  ecModel[ATTR] = null;
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @return {number} records. always >= 1.
	 */
	
	
	function count(ecModel) {
	  return giveStore(ecModel).length;
	}
	/**
	 * [{key: dataZoomId, value: {dataZoomId, range}}, ...]
	 * History length of each dataZoom may be different.
	 * this._history[0] is used to store origin range.
	 * @type {Array.<Object>}
	 */
	
	
	function giveStore(ecModel) {
	  var store = ecModel[ATTR];
	
	  if (!store) {
	    store = ecModel[ATTR] = [{}];
	  }
	
	  return store;
	}
	
	exports.push = push;
	exports.pop = pop;
	exports.clear = clear;
	exports.count = count;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(624);
	
	__webpack_require__(625);
	
	__webpack_require__(628);
	
	__webpack_require__(629);
	
	__webpack_require__(630);
	
	__webpack_require__(631);
	
	__webpack_require__(632);

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(303);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('dataZoom', function () {
	  // Default 'slider' when no type specified.
	  return 'slider';
	});

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var env = __webpack_require__(219);
	
	var modelUtil = __webpack_require__(261);
	
	var helper = __webpack_require__(626);
	
	var AxisProxy = __webpack_require__(627);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var eachAxisDim = helper.eachAxisDim;
	var DataZoomModel = echarts.extendComponentModel({
	  type: 'dataZoom',
	  dependencies: ['xAxis', 'yAxis', 'zAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'series'],
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    zlevel: 0,
	    z: 4,
	    // Higher than normal component (z: 2).
	    orient: null,
	    // Default auto by axisIndex. Possible value: 'horizontal', 'vertical'.
	    xAxisIndex: null,
	    // Default the first horizontal category axis.
	    yAxisIndex: null,
	    // Default the first vertical category axis.
	    filterMode: 'filter',
	    // Possible values: 'filter' or 'empty' or 'weakFilter'.
	    // 'filter': data items which are out of window will be removed. This option is
	    //          applicable when filtering outliers. For each data item, it will be
	    //          filtered if one of the relevant dimensions is out of the window.
	    // 'weakFilter': data items which are out of window will be removed. This option
	    //          is applicable when filtering outliers. For each data item, it will be
	    //          filtered only if all  of the relevant dimensions are out of the same
	    //          side of the window.
	    // 'empty': data items which are out of window will be set to empty.
	    //          This option is applicable when user should not neglect
	    //          that there are some data items out of window.
	    // 'none': Do not filter.
	    // Taking line chart as an example, line will be broken in
	    // the filtered points when filterModel is set to 'empty', but
	    // be connected when set to 'filter'.
	    throttle: null,
	    // Dispatch action by the fixed rate, avoid frequency.
	    // default 100. Do not throttle when use null/undefined.
	    // If animation === true and animationDurationUpdate > 0,
	    // default value is 100, otherwise 20.
	    start: 0,
	    // Start percent. 0 ~ 100
	    end: 100,
	    // End percent. 0 ~ 100
	    startValue: null,
	    // Start value. If startValue specified, start is ignored.
	    endValue: null,
	    // End value. If endValue specified, end is ignored.
	    minSpan: null,
	    // 0 ~ 100
	    maxSpan: null,
	    // 0 ~ 100
	    minValueSpan: null,
	    // The range of dataZoom can not be smaller than that.
	    maxValueSpan: null,
	    // The range of dataZoom can not be larger than that.
	    rangeMode: null // Array, can be 'value' or 'percent'.
	
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * key like x_0, y_1
	     * @private
	     * @type {Object}
	     */
	    this._dataIntervalByAxis = {};
	    /**
	     * @private
	     */
	
	    this._dataInfo = {};
	    /**
	     * key like x_0, y_1
	     * @private
	     */
	
	    this._axisProxies = {};
	    /**
	     * @readOnly
	     */
	
	    this.textStyleModel;
	    /**
	     * @private
	     */
	
	    this._autoThrottle = true;
	    /**
	     * It is `[rangeModeForMin, rangeModeForMax]`.
	     * The optional values for `rangeMode`:
	     * + `'value'` mode: the axis extent will always be determined by
	     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
	     *     how data like and how `axis.min` and `axis.max` are.
	     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
	     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
	     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
	     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
	     *
	     * For example, when users are using dynamic data (update data periodically via `setOption`),
	     * if in `'value`' mode, the window will be kept in a fixed value range despite how
	     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
	     * the appended data (suppose `axis.min` and `axis.max` are not specified).
	     *
	     * @private
	     */
	
	    this._rangePropMode = ['percent', 'percent'];
	    var inputRawOption = retrieveRawOption(option);
	    /**
	     * Suppose a "main process" start at the point that model prepared (that is,
	     * model initialized or merged or method called in `action`).
	     * We should keep the `main process` idempotent, that is, given a set of values
	     * on `option`, we get the same result.
	     *
	     * But sometimes, values on `option` will be updated for providing users
	     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
	     * should not be the base/input of the `main process`.
	     *
	     * So in that case we should save and keep the input of the `main process`
	     * separately, called `settledOption`.
	     *
	     * For example, consider the case:
	     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
	     *     where the original input `option.startValue`, `option.endValue` are earsed by
	     *     calculated value.
	     * (Step)2) click the legend to hide and show a series,
	     *     where the new range is calculated by the earsed `startValue` and `endValue`,
	     *     which brings incorrect result.
	     *
	     * @readOnly
	     */
	
	    this.settledOption = inputRawOption;
	    this.mergeDefaultAndTheme(option, ecModel);
	    this.doInit(inputRawOption);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (newOption) {
	    var inputRawOption = retrieveRawOption(newOption); //FIX #2591
	
	    zrUtil.merge(this.option, newOption, true);
	    zrUtil.merge(this.settledOption, inputRawOption, true);
	    this.doInit(inputRawOption);
	  },
	
	  /**
	   * @protected
	   */
	  doInit: function (inputRawOption) {
	    var thisOption = this.option; // Disable realtime view update if canvas is not supported.
	
	    if (!env.canvasSupported) {
	      thisOption.realtime = false;
	    }
	
	    this._setDefaultThrottle(inputRawOption);
	
	    updateRangeUse(this, inputRawOption);
	    var settledOption = this.settledOption;
	    each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	      // start/end has higher priority over startValue/endValue if they
	      // both set, but we should make chart.setOption({endValue: 1000})
	      // effective, rather than chart.setOption({endValue: 1000, end: null}).
	      if (this._rangePropMode[index] === 'value') {
	        thisOption[names[0]] = settledOption[names[0]] = null;
	      } // Otherwise do nothing and use the merge result.
	
	    }, this);
	    this.textStyleModel = this.getModel('textStyle');
	
	    this._resetTarget();
	
	    this._giveAxisProxies();
	  },
	
	  /**
	   * @private
	   */
	  _giveAxisProxies: function () {
	    var axisProxies = this._axisProxies;
	    this.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel, ecModel) {
	      var axisModel = this.dependentModels[dimNames.axis][axisIndex]; // If exists, share axisProxy with other dataZoomModels.
	
	      var axisProxy = axisModel.__dzAxisProxy || ( // Use the first dataZoomModel as the main model of axisProxy.
	      axisModel.__dzAxisProxy = new AxisProxy(dimNames.name, axisIndex, this, ecModel)); // FIXME
	      // dispose __dzAxisProxy
	
	      axisProxies[dimNames.name + '_' + axisIndex] = axisProxy;
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _resetTarget: function () {
	    var thisOption = this.option;
	
	    var autoMode = this._judgeAutoMode();
	
	    eachAxisDim(function (dimNames) {
	      var axisIndexName = dimNames.axisIndex;
	      thisOption[axisIndexName] = modelUtil.normalizeToArray(thisOption[axisIndexName]);
	    }, this);
	
	    if (autoMode === 'axisIndex') {
	      this._autoSetAxisIndex();
	    } else if (autoMode === 'orient') {
	      this._autoSetOrient();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _judgeAutoMode: function () {
	    // Auto set only works for setOption at the first time.
	    // The following is user's reponsibility. So using merged
	    // option is OK.
	    var thisOption = this.option;
	    var hasIndexSpecified = false;
	    eachAxisDim(function (dimNames) {
	      // When user set axisIndex as a empty array, we think that user specify axisIndex
	      // but do not want use auto mode. Because empty array may be encountered when
	      // some error occured.
	      if (thisOption[dimNames.axisIndex] != null) {
	        hasIndexSpecified = true;
	      }
	    }, this);
	    var orient = thisOption.orient;
	
	    if (orient == null && hasIndexSpecified) {
	      return 'orient';
	    } else if (!hasIndexSpecified) {
	      if (orient == null) {
	        thisOption.orient = 'horizontal';
	      }
	
	      return 'axisIndex';
	    }
	  },
	
	  /**
	   * @private
	   */
	  _autoSetAxisIndex: function () {
	    var autoAxisIndex = true;
	    var orient = this.get('orient', true);
	    var thisOption = this.option;
	    var dependentModels = this.dependentModels;
	
	    if (autoAxisIndex) {
	      // Find axis that parallel to dataZoom as default.
	      var dimName = orient === 'vertical' ? 'y' : 'x';
	
	      if (dependentModels[dimName + 'Axis'].length) {
	        thisOption[dimName + 'AxisIndex'] = [0];
	        autoAxisIndex = false;
	      } else {
	        each(dependentModels.singleAxis, function (singleAxisModel) {
	          if (autoAxisIndex && singleAxisModel.get('orient', true) === orient) {
	            thisOption.singleAxisIndex = [singleAxisModel.componentIndex];
	            autoAxisIndex = false;
	          }
	        });
	      }
	    }
	
	    if (autoAxisIndex) {
	      // Find the first category axis as default. (consider polar)
	      eachAxisDim(function (dimNames) {
	        if (!autoAxisIndex) {
	          return;
	        }
	
	        var axisIndices = [];
	        var axisModels = this.dependentModels[dimNames.axis];
	
	        if (axisModels.length && !axisIndices.length) {
	          for (var i = 0, len = axisModels.length; i < len; i++) {
	            if (axisModels[i].get('type') === 'category') {
	              axisIndices.push(i);
	            }
	          }
	        }
	
	        thisOption[dimNames.axisIndex] = axisIndices;
	
	        if (axisIndices.length) {
	          autoAxisIndex = false;
	        }
	      }, this);
	    }
	
	    if (autoAxisIndex) {
	      // FIXME
	      // 这里是兼容ec2的写法（没指定xAxisIndex和yAxisIndex时把scatter和双数值轴折柱纳入dataZoom控制），
	      // 但是实际是否需要Grid.js#getScaleByOption来判断（考虑time，log等axis type）？
	      // If both dataZoom.xAxisIndex and dataZoom.yAxisIndex is not specified,
	      // dataZoom component auto adopts series that reference to
	      // both xAxis and yAxis which type is 'value'.
	      this.ecModel.eachSeries(function (seriesModel) {
	        if (this._isSeriesHasAllAxesTypeOf(seriesModel, 'value')) {
	          eachAxisDim(function (dimNames) {
	            var axisIndices = thisOption[dimNames.axisIndex];
	            var axisIndex = seriesModel.get(dimNames.axisIndex);
	            var axisId = seriesModel.get(dimNames.axisId);
	            var axisModel = seriesModel.ecModel.queryComponents({
	              mainType: dimNames.axis,
	              index: axisIndex,
	              id: axisId
	            })[0];
	            axisIndex = axisModel.componentIndex;
	
	            if (zrUtil.indexOf(axisIndices, axisIndex) < 0) {
	              axisIndices.push(axisIndex);
	            }
	          });
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _autoSetOrient: function () {
	    var dim; // Find the first axis
	
	    this.eachTargetAxis(function (dimNames) {
	      !dim && (dim = dimNames.name);
	    }, this);
	    this.option.orient = dim === 'y' ? 'vertical' : 'horizontal';
	  },
	
	  /**
	   * @private
	   */
	  _isSeriesHasAllAxesTypeOf: function (seriesModel, axisType) {
	    // FIXME
	    // 需要series的xAxisIndex和yAxisIndex都首先自动设置上。
	    // 例如series.type === scatter时。
	    var is = true;
	    eachAxisDim(function (dimNames) {
	      var seriesAxisIndex = seriesModel.get(dimNames.axisIndex);
	      var axisModel = this.dependentModels[dimNames.axis][seriesAxisIndex];
	
	      if (!axisModel || axisModel.get('type') !== axisType) {
	        is = false;
	      }
	    }, this);
	    return is;
	  },
	
	  /**
	   * @private
	   */
	  _setDefaultThrottle: function (inputRawOption) {
	    // When first time user set throttle, auto throttle ends.
	    if (inputRawOption.hasOwnProperty('throttle')) {
	      this._autoThrottle = false;
	    }
	
	    if (this._autoThrottle) {
	      var globalOption = this.ecModel.option;
	      this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
	    }
	  },
	
	  /**
	   * @public
	   */
	  getFirstTargetAxisModel: function () {
	    var firstAxisModel;
	    eachAxisDim(function (dimNames) {
	      if (firstAxisModel == null) {
	        var indices = this.get(dimNames.axisIndex);
	
	        if (indices.length) {
	          firstAxisModel = this.dependentModels[dimNames.axis][indices[0]];
	        }
	      }
	    }, this);
	    return firstAxisModel;
	  },
	
	  /**
	   * @public
	   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
	   */
	  eachTargetAxis: function (callback, context) {
	    var ecModel = this.ecModel;
	    eachAxisDim(function (dimNames) {
	      each(this.get(dimNames.axisIndex), function (axisIndex) {
	        callback.call(context, dimNames, axisIndex, this, ecModel);
	      }, this);
	    }, this);
	  },
	
	  /**
	   * @param {string} dimName
	   * @param {number} axisIndex
	   * @return {module:echarts/component/dataZoom/AxisProxy} If not found, return null/undefined.
	   */
	  getAxisProxy: function (dimName, axisIndex) {
	    return this._axisProxies[dimName + '_' + axisIndex];
	  },
	
	  /**
	   * @param {string} dimName
	   * @param {number} axisIndex
	   * @return {module:echarts/model/Model} If not found, return null/undefined.
	   */
	  getAxisModel: function (dimName, axisIndex) {
	    var axisProxy = this.getAxisProxy(dimName, axisIndex);
	    return axisProxy && axisProxy.getAxisModel();
	  },
	
	  /**
	   * If not specified, set to undefined.
	   *
	   * @public
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  setRawRange: function (opt) {
	    var thisOption = this.option;
	    var settledOption = this.settledOption;
	    each([['start', 'startValue'], ['end', 'endValue']], function (names) {
	      // Consider the pair <start, startValue>:
	      // If one has value and the other one is `null/undefined`, we both set them
	      // to `settledOption`. This strategy enables the feature to clear the original
	      // value in `settledOption` to `null/undefined`.
	      // But if both of them are `null/undefined`, we do not set them to `settledOption`
	      // and keep `settledOption` with the original value. This strategy enables users to
	      // only set <end or endValue> but not set <start or startValue> when calling
	      // `dispatchAction`.
	      // The pair <end, endValue> is treated in the same way.
	      if (opt[names[0]] != null || opt[names[1]] != null) {
	        thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
	        thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
	      }
	    }, this);
	    updateRangeUse(this, opt);
	  },
	
	  /**
	   * @public
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  setCalculatedRange: function (opt) {
	    var option = this.option;
	    each(['start', 'startValue', 'end', 'endValue'], function (name) {
	      option[name] = opt[name];
	    });
	  },
	
	  /**
	   * @public
	   * @return {Array.<number>} [startPercent, endPercent]
	   */
	  getPercentRange: function () {
	    var axisProxy = this.findRepresentativeAxisProxy();
	
	    if (axisProxy) {
	      return axisProxy.getDataPercentWindow();
	    }
	  },
	
	  /**
	   * @public
	   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
	   *
	   * @param {string} [axisDimName]
	   * @param {number} [axisIndex]
	   * @return {Array.<number>} [startValue, endValue] value can only be '-' or finite number.
	   */
	  getValueRange: function (axisDimName, axisIndex) {
	    if (axisDimName == null && axisIndex == null) {
	      var axisProxy = this.findRepresentativeAxisProxy();
	
	      if (axisProxy) {
	        return axisProxy.getDataValueWindow();
	      }
	    } else {
	      return this.getAxisProxy(axisDimName, axisIndex).getDataValueWindow();
	    }
	  },
	
	  /**
	   * @public
	   * @param {module:echarts/model/Model} [axisModel] If axisModel given, find axisProxy
	   *      corresponding to the axisModel
	   * @return {module:echarts/component/dataZoom/AxisProxy}
	   */
	  findRepresentativeAxisProxy: function (axisModel) {
	    if (axisModel) {
	      return axisModel.__dzAxisProxy;
	    } // Find the first hosted axisProxy
	
	
	    var axisProxies = this._axisProxies;
	
	    for (var key in axisProxies) {
	      if (axisProxies.hasOwnProperty(key) && axisProxies[key].hostedBy(this)) {
	        return axisProxies[key];
	      }
	    } // If no hosted axis find not hosted axisProxy.
	    // Consider this case: dataZoomModel1 and dataZoomModel2 control the same axis,
	    // and the option.start or option.end settings are different. The percentRange
	    // should follow axisProxy.
	    // (We encounter this problem in toolbox data zoom.)
	
	
	    for (var key in axisProxies) {
	      if (axisProxies.hasOwnProperty(key) && !axisProxies[key].hostedBy(this)) {
	        return axisProxies[key];
	      }
	    }
	  },
	
	  /**
	   * @return {Array.<string>}
	   */
	  getRangePropMode: function () {
	    return this._rangePropMode.slice();
	  }
	});
	/**
	 * Retrieve the those raw params from option, which will be cached separately.
	 * becasue they will be overwritten by normalized/calculated values in the main
	 * process.
	 */
	
	function retrieveRawOption(option) {
	  var ret = {};
	  each(['start', 'end', 'startValue', 'endValue', 'throttle'], function (name) {
	    option.hasOwnProperty(name) && (ret[name] = option[name]);
	  });
	  return ret;
	}
	
	function updateRangeUse(dataZoomModel, inputRawOption) {
	  var rangePropMode = dataZoomModel._rangePropMode;
	  var rangeModeInOption = dataZoomModel.get('rangeMode');
	  each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	    var percentSpecified = inputRawOption[names[0]] != null;
	    var valueSpecified = inputRawOption[names[1]] != null;
	
	    if (percentSpecified && !valueSpecified) {
	      rangePropMode[index] = 'percent';
	    } else if (!percentSpecified && valueSpecified) {
	      rangePropMode[index] = 'value';
	    } else if (rangeModeInOption) {
	      rangePropMode[index] = rangeModeInOption[index];
	    } else if (percentSpecified) {
	      // percentSpecified && valueSpecified
	      rangePropMode[index] = 'percent';
	    } // else remain its original setting.
	
	  });
	}
	
	var _default = DataZoomModel;
	module.exports = _default;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var formatUtil = __webpack_require__(307);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AXIS_DIMS = ['x', 'y', 'z', 'radius', 'angle', 'single']; // Supported coords.
	
	var COORDS = ['cartesian2d', 'polar', 'singleAxis'];
	/**
	 * @param {string} coordType
	 * @return {boolean}
	 */
	
	function isCoordSupported(coordType) {
	  return zrUtil.indexOf(COORDS, coordType) >= 0;
	}
	/**
	 * Create "each" method to iterate names.
	 *
	 * @pubilc
	 * @param  {Array.<string>} names
	 * @param  {Array.<string>=} attrs
	 * @return {Function}
	 */
	
	
	function createNameEach(names, attrs) {
	  names = names.slice();
	  var capitalNames = zrUtil.map(names, formatUtil.capitalFirst);
	  attrs = (attrs || []).slice();
	  var capitalAttrs = zrUtil.map(attrs, formatUtil.capitalFirst);
	  return function (callback, context) {
	    zrUtil.each(names, function (name, index) {
	      var nameObj = {
	        name: name,
	        capital: capitalNames[index]
	      };
	
	      for (var j = 0; j < attrs.length; j++) {
	        nameObj[attrs[j]] = name + capitalAttrs[j];
	      }
	
	      callback.call(context, nameObj);
	    });
	  };
	}
	/**
	 * Iterate each dimension name.
	 *
	 * @public
	 * @param {Function} callback The parameter is like:
	 *                            {
	 *                                name: 'angle',
	 *                                capital: 'Angle',
	 *                                axis: 'angleAxis',
	 *                                axisIndex: 'angleAixs',
	 *                                index: 'angleIndex'
	 *                            }
	 * @param {Object} context
	 */
	
	
	var eachAxisDim = createNameEach(AXIS_DIMS, ['axisIndex', 'axis', 'index', 'id']);
	/**
	 * If tow dataZoomModels has the same axis controlled, we say that they are 'linked'.
	 * dataZoomModels and 'links' make up one or more graphics.
	 * This function finds the graphic where the source dataZoomModel is in.
	 *
	 * @public
	 * @param {Function} forEachNode Node iterator.
	 * @param {Function} forEachEdgeType edgeType iterator
	 * @param {Function} edgeIdGetter Giving node and edgeType, return an array of edge id.
	 * @return {Function} Input: sourceNode, Output: Like {nodes: [], dims: {}}
	 */
	
	function createLinkedNodesFinder(forEachNode, forEachEdgeType, edgeIdGetter) {
	  return function (sourceNode) {
	    var result = {
	      nodes: [],
	      records: {} // key: edgeType.name, value: Object (key: edge id, value: boolean).
	
	    };
	    forEachEdgeType(function (edgeType) {
	      result.records[edgeType.name] = {};
	    });
	
	    if (!sourceNode) {
	      return result;
	    }
	
	    absorb(sourceNode, result);
	    var existsLink;
	
	    do {
	      existsLink = false;
	      forEachNode(processSingleNode);
	    } while (existsLink);
	
	    function processSingleNode(node) {
	      if (!isNodeAbsorded(node, result) && isLinked(node, result)) {
	        absorb(node, result);
	        existsLink = true;
	      }
	    }
	
	    return result;
	  };
	
	  function isNodeAbsorded(node, result) {
	    return zrUtil.indexOf(result.nodes, node) >= 0;
	  }
	
	  function isLinked(node, result) {
	    var hasLink = false;
	    forEachEdgeType(function (edgeType) {
	      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
	        result.records[edgeType.name][edgeId] && (hasLink = true);
	      });
	    });
	    return hasLink;
	  }
	
	  function absorb(node, result) {
	    result.nodes.push(node);
	    forEachEdgeType(function (edgeType) {
	      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
	        result.records[edgeType.name][edgeId] = true;
	      });
	    });
	  }
	}
	
	exports.isCoordSupported = isCoordSupported;
	exports.createNameEach = createNameEach;
	exports.eachAxisDim = eachAxisDim;
	exports.createLinkedNodesFinder = createLinkedNodesFinder;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var numberUtil = __webpack_require__(306);
	
	var helper = __webpack_require__(626);
	
	var sliderMove = __webpack_require__(507);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var asc = numberUtil.asc;
	/**
	 * Operate single axis.
	 * One axis can only operated by one axis operator.
	 * Different dataZoomModels may be defined to operate the same axis.
	 * (i.e. 'inside' data zoom and 'slider' data zoom components)
	 * So dataZoomModels share one axisProxy in that case.
	 *
	 * @class
	 */
	
	var AxisProxy = function (dimName, axisIndex, dataZoomModel, ecModel) {
	  /**
	   * @private
	   * @type {string}
	   */
	  this._dimName = dimName;
	  /**
	   * @private
	   */
	
	  this._axisIndex = axisIndex;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._valueWindow;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._percentWindow;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._dataExtent;
	  /**
	   * {minSpan, maxSpan, minValueSpan, maxValueSpan}
	   * @private
	   * @type {Object}
	   */
	
	  this._minMaxSpan;
	  /**
	   * @readOnly
	   * @type {module: echarts/model/Global}
	   */
	
	  this.ecModel = ecModel;
	  /**
	   * @private
	   * @type {module: echarts/component/dataZoom/DataZoomModel}
	   */
	
	  this._dataZoomModel = dataZoomModel; // /**
	  //  * @readOnly
	  //  * @private
	  //  */
	  // this.hasSeriesStacked;
	};
	
	AxisProxy.prototype = {
	  constructor: AxisProxy,
	
	  /**
	   * Whether the axisProxy is hosted by dataZoomModel.
	   *
	   * @public
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   * @return {boolean}
	   */
	  hostedBy: function (dataZoomModel) {
	    return this._dataZoomModel === dataZoomModel;
	  },
	
	  /**
	   * @return {Array.<number>} Value can only be NaN or finite value.
	   */
	  getDataValueWindow: function () {
	    return this._valueWindow.slice();
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getDataPercentWindow: function () {
	    return this._percentWindow.slice();
	  },
	
	  /**
	   * @public
	   * @param {number} axisIndex
	   * @return {Array} seriesModels
	   */
	  getTargetSeriesModels: function () {
	    var seriesModels = [];
	    var ecModel = this.ecModel;
	    ecModel.eachSeries(function (seriesModel) {
	      if (helper.isCoordSupported(seriesModel.get('coordinateSystem'))) {
	        var dimName = this._dimName;
	        var axisModel = ecModel.queryComponents({
	          mainType: dimName + 'Axis',
	          index: seriesModel.get(dimName + 'AxisIndex'),
	          id: seriesModel.get(dimName + 'AxisId')
	        })[0];
	
	        if (this._axisIndex === (axisModel && axisModel.componentIndex)) {
	          seriesModels.push(seriesModel);
	        }
	      }
	    }, this);
	    return seriesModels;
	  },
	  getAxisModel: function () {
	    return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
	  },
	  getOtherAxisModel: function () {
	    var axisDim = this._dimName;
	    var ecModel = this.ecModel;
	    var axisModel = this.getAxisModel();
	    var isCartesian = axisDim === 'x' || axisDim === 'y';
	    var otherAxisDim;
	    var coordSysIndexName;
	
	    if (isCartesian) {
	      coordSysIndexName = 'gridIndex';
	      otherAxisDim = axisDim === 'x' ? 'y' : 'x';
	    } else {
	      coordSysIndexName = 'polarIndex';
	      otherAxisDim = axisDim === 'angle' ? 'radius' : 'angle';
	    }
	
	    var foundOtherAxisModel;
	    ecModel.eachComponent(otherAxisDim + 'Axis', function (otherAxisModel) {
	      if ((otherAxisModel.get(coordSysIndexName) || 0) === (axisModel.get(coordSysIndexName) || 0)) {
	        foundOtherAxisModel = otherAxisModel;
	      }
	    });
	    return foundOtherAxisModel;
	  },
	  getMinMaxSpan: function () {
	    return zrUtil.clone(this._minMaxSpan);
	  },
	
	  /**
	   * Only calculate by given range and this._dataExtent, do not change anything.
	   *
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  calculateDataWindow: function (opt) {
	    var dataExtent = this._dataExtent;
	    var axisModel = this.getAxisModel();
	    var scale = axisModel.axis.scale;
	
	    var rangePropMode = this._dataZoomModel.getRangePropMode();
	
	    var percentExtent = [0, 100];
	    var percentWindow = [];
	    var valueWindow = [];
	    var hasPropModeValue;
	    each(['start', 'end'], function (prop, idx) {
	      var boundPercent = opt[prop];
	      var boundValue = opt[prop + 'Value']; // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
	      // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
	      // but not min/max of axis, which will be calculated by data window then).
	      // The former one is suitable for cases that a dataZoom component controls multiple
	      // axes with different unit or extent, and the latter one is suitable for accurate
	      // zoom by pixel (e.g., in dataZoomSelect).
	      // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
	      // only when setOption or dispatchAction, otherwise it remains its original value.
	      // (Why not only record `percentProp` and always map to `valueProp`? Because
	      // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
	      // `valueProp`. consider two axes constrolled by one dataZoom. They have different
	      // data extent. All of values that are overflow the `dataExtent` will be calculated
	      // to percent '100%').
	
	      if (rangePropMode[idx] === 'percent') {
	        boundPercent == null && (boundPercent = percentExtent[idx]); // Use scale.parse to math round for category or time axis.
	
	        boundValue = scale.parse(numberUtil.linearMap(boundPercent, percentExtent, dataExtent));
	      } else {
	        hasPropModeValue = true;
	        boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue); // Calculating `percent` from `value` may be not accurate, because
	        // This calculation can not be inversed, because all of values that
	        // are overflow the `dataExtent` will be calculated to percent '100%'
	
	        boundPercent = numberUtil.linearMap(boundValue, dataExtent, percentExtent);
	      } // valueWindow[idx] = round(boundValue);
	      // percentWindow[idx] = round(boundPercent);
	
	
	      valueWindow[idx] = boundValue;
	      percentWindow[idx] = boundPercent;
	    });
	    asc(valueWindow);
	    asc(percentWindow); // The windows from user calling of `dispatchAction` might be out of the extent,
	    // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we dont restrict window
	    // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
	    // where API is able to initialize/modify the window size even though `zoomLock`
	    // specified.
	
	    var spans = this._minMaxSpan;
	    hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);
	
	    function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
	      var suffix = toValue ? 'Span' : 'ValueSpan';
	      sliderMove(0, fromWindow, fromExtent, 'all', spans['min' + suffix], spans['max' + suffix]);
	
	      for (var i = 0; i < 2; i++) {
	        toWindow[i] = numberUtil.linearMap(fromWindow[i], fromExtent, toExtent, true);
	        toValue && (toWindow[i] = scale.parse(toWindow[i]));
	      }
	    }
	
	    return {
	      valueWindow: valueWindow,
	      percentWindow: percentWindow
	    };
	  },
	
	  /**
	   * Notice: reset should not be called before series.restoreData() called,
	   * so it is recommanded to be called in "process stage" but not "model init
	   * stage".
	   *
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  reset: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    var targetSeries = this.getTargetSeriesModels(); // Culculate data window and data extent, and record them.
	
	    this._dataExtent = calculateDataExtent(this, this._dimName, targetSeries); // this.hasSeriesStacked = false;
	    // each(targetSeries, function (series) {
	    // var data = series.getData();
	    // var dataDim = data.mapDimension(this._dimName);
	    // var stackedDimension = data.getCalculationInfo('stackedDimension');
	    // if (stackedDimension && stackedDimension === dataDim) {
	    // this.hasSeriesStacked = true;
	    // }
	    // }, this);
	    // `calculateDataWindow` uses min/maxSpan.
	
	    setMinMaxSpan(this);
	    var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
	    this._valueWindow = dataWindow.valueWindow;
	    this._percentWindow = dataWindow.percentWindow; // Update axis setting then.
	
	    setAxisModel(this);
	  },
	
	  /**
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  restore: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    this._valueWindow = this._percentWindow = null;
	    setAxisModel(this, true);
	  },
	
	  /**
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  filterData: function (dataZoomModel, api) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    var axisDim = this._dimName;
	    var seriesModels = this.getTargetSeriesModels();
	    var filterMode = dataZoomModel.get('filterMode');
	    var valueWindow = this._valueWindow;
	
	    if (filterMode === 'none') {
	      return;
	    } // FIXME
	    // Toolbox may has dataZoom injected. And if there are stacked bar chart
	    // with NaN data, NaN will be filtered and stack will be wrong.
	    // So we need to force the mode to be set empty.
	    // In fect, it is not a big deal that do not support filterMode-'filter'
	    // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
	    // selection" some day, which might need "adapt to data extent on the
	    // otherAxis", which is disabled by filterMode-'empty'.
	    // But currently, stack has been fixed to based on value but not index,
	    // so this is not an issue any more.
	    // var otherAxisModel = this.getOtherAxisModel();
	    // if (dataZoomModel.get('$fromToolbox')
	    //     && otherAxisModel
	    //     && otherAxisModel.hasSeriesStacked
	    // ) {
	    //     filterMode = 'empty';
	    // }
	    // TODO
	    // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
	
	
	    each(seriesModels, function (seriesModel) {
	      var seriesData = seriesModel.getData();
	      var dataDims = seriesData.mapDimension(axisDim, true);
	
	      if (!dataDims.length) {
	        return;
	      }
	
	      if (filterMode === 'weakFilter') {
	        seriesData.filterSelf(function (dataIndex) {
	          var leftOut;
	          var rightOut;
	          var hasValue;
	
	          for (var i = 0; i < dataDims.length; i++) {
	            var value = seriesData.get(dataDims[i], dataIndex);
	            var thisHasValue = !isNaN(value);
	            var thisLeftOut = value < valueWindow[0];
	            var thisRightOut = value > valueWindow[1];
	
	            if (thisHasValue && !thisLeftOut && !thisRightOut) {
	              return true;
	            }
	
	            thisHasValue && (hasValue = true);
	            thisLeftOut && (leftOut = true);
	            thisRightOut && (rightOut = true);
	          } // If both left out and right out, do not filter.
	
	
	          return hasValue && leftOut && rightOut;
	        });
	      } else {
	        each(dataDims, function (dim) {
	          if (filterMode === 'empty') {
	            seriesModel.setData(seriesData = seriesData.map(dim, function (value) {
	              return !isInWindow(value) ? NaN : value;
	            }));
	          } else {
	            var range = {};
	            range[dim] = valueWindow; // console.time('select');
	
	            seriesData.selectRange(range); // console.timeEnd('select');
	          }
	        });
	      }
	
	      each(dataDims, function (dim) {
	        seriesData.setApproximateExtent(valueWindow, dim);
	      });
	    });
	
	    function isInWindow(value) {
	      return value >= valueWindow[0] && value <= valueWindow[1];
	    }
	  }
	};
	
	function calculateDataExtent(axisProxy, axisDim, seriesModels) {
	  var dataExtent = [Infinity, -Infinity];
	  each(seriesModels, function (seriesModel) {
	    var seriesData = seriesModel.getData();
	
	    if (seriesData) {
	      each(seriesData.mapDimension(axisDim, true), function (dim) {
	        var seriesExtent = seriesData.getApproximateExtent(dim);
	        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
	        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
	      });
	    }
	  });
	
	  if (dataExtent[1] < dataExtent[0]) {
	    dataExtent = [NaN, NaN];
	  } // It is important to get "consistent" extent when more then one axes is
	  // controlled by a `dataZoom`, otherwise those axes will not be synchronized
	  // when zooming. But it is difficult to know what is "consistent", considering
	  // axes have different type or even different meanings (For example, two
	  // time axes are used to compare data of the same date in different years).
	  // So basically dataZoom just obtains extent by series.data (in category axis
	  // extent can be obtained from axis.data).
	  // Nevertheless, user can set min/max/scale on axes to make extent of axes
	  // consistent.
	
	
	  fixExtentByAxis(axisProxy, dataExtent);
	  return dataExtent;
	}
	
	function fixExtentByAxis(axisProxy, dataExtent) {
	  var axisModel = axisProxy.getAxisModel();
	  var min = axisModel.getMin(true); // For category axis, if min/max/scale are not set, extent is determined
	  // by axis.data by default.
	
	  var isCategoryAxis = axisModel.get('type') === 'category';
	  var axisDataLen = isCategoryAxis && axisModel.getCategories().length;
	
	  if (min != null && min !== 'dataMin' && typeof min !== 'function') {
	    dataExtent[0] = min;
	  } else if (isCategoryAxis) {
	    dataExtent[0] = axisDataLen > 0 ? 0 : NaN;
	  }
	
	  var max = axisModel.getMax(true);
	
	  if (max != null && max !== 'dataMax' && typeof max !== 'function') {
	    dataExtent[1] = max;
	  } else if (isCategoryAxis) {
	    dataExtent[1] = axisDataLen > 0 ? axisDataLen - 1 : NaN;
	  }
	
	  if (!axisModel.get('scale', true)) {
	    dataExtent[0] > 0 && (dataExtent[0] = 0);
	    dataExtent[1] < 0 && (dataExtent[1] = 0);
	  } // For value axis, if min/max/scale are not set, we just use the extent obtained
	  // by series data, which may be a little different from the extent calculated by
	  // `axisHelper.getScaleExtent`. But the different just affects the experience a
	  // little when zooming. So it will not be fixed until some users require it strongly.
	
	
	  return dataExtent;
	}
	
	function setAxisModel(axisProxy, isRestore) {
	  var axisModel = axisProxy.getAxisModel();
	  var percentWindow = axisProxy._percentWindow;
	  var valueWindow = axisProxy._valueWindow;
	
	  if (!percentWindow) {
	    return;
	  } // [0, 500]: arbitrary value, guess axis extent.
	
	
	  var precision = numberUtil.getPixelPrecision(valueWindow, [0, 500]);
	  precision = Math.min(precision, 20); // isRestore or isFull
	
	  var useOrigin = isRestore || percentWindow[0] === 0 && percentWindow[1] === 100;
	  axisModel.setRange(useOrigin ? null : +valueWindow[0].toFixed(precision), useOrigin ? null : +valueWindow[1].toFixed(precision));
	}
	
	function setMinMaxSpan(axisProxy) {
	  var minMaxSpan = axisProxy._minMaxSpan = {};
	  var dataZoomModel = axisProxy._dataZoomModel;
	  var dataExtent = axisProxy._dataExtent;
	  each(['min', 'max'], function (minMax) {
	    var percentSpan = dataZoomModel.get(minMax + 'Span');
	    var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
	    valueSpan != null && (valueSpan = axisProxy.getAxisModel().axis.scale.parse(valueSpan)); // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
	
	    if (valueSpan != null) {
	      percentSpan = numberUtil.linearMap(dataExtent[0] + valueSpan, dataExtent, [0, 100], true);
	    } else if (percentSpan != null) {
	      valueSpan = numberUtil.linearMap(percentSpan, [0, 100], dataExtent, true) - dataExtent[0];
	    }
	
	    minMaxSpan[minMax + 'Span'] = percentSpan;
	    minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
	  });
	}
	
	var _default = AxisProxy;
	module.exports = _default;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentView = __webpack_require__(324);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = ComponentView.extend({
	  type: 'dataZoom',
	  render: function (dataZoomModel, ecModel, api, payload) {
	    this.dataZoomModel = dataZoomModel;
	    this.ecModel = ecModel;
	    this.api = api;
	  },
	
	  /**
	   * Find the first target coordinate system.
	   *
	   * @protected
	   * @return {Object} {
	   *                   grid: [
	   *                       {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
	   *                       {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
	   *                       ...
	   *                   ],  // cartesians must not be null/undefined.
	   *                   polar: [
	   *                       {model: coord0, axisModels: [axis4], coordIndex: 0},
	   *                       ...
	   *                   ],  // polars must not be null/undefined.
	   *                   singleAxis: [
	   *                       {model: coord0, axisModels: [], coordIndex: 0}
	   *                   ]
	   */
	  getTargetCoordInfo: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var ecModel = this.ecModel;
	    var coordSysLists = {};
	    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
	      var axisModel = ecModel.getComponent(dimNames.axis, axisIndex);
	
	      if (axisModel) {
	        var coordModel = axisModel.getCoordSysModel();
	        coordModel && save(coordModel, axisModel, coordSysLists[coordModel.mainType] || (coordSysLists[coordModel.mainType] = []), coordModel.componentIndex);
	      }
	    }, this);
	
	    function save(coordModel, axisModel, store, coordIndex) {
	      var item;
	
	      for (var i = 0; i < store.length; i++) {
	        if (store[i].model === coordModel) {
	          item = store[i];
	          break;
	        }
	      }
	
	      if (!item) {
	        store.push(item = {
	          model: coordModel,
	          axisModels: [],
	          coordIndex: coordIndex
	        });
	      }
	
	      item.axisModels.push(axisModel);
	    }
	
	    return coordSysLists;
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(625);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomModel.extend({
	  type: 'dataZoom.select'
	});
	
	module.exports = _default;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomView = __webpack_require__(628);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomView.extend({
	  type: 'dataZoom.select'
	});
	
	module.exports = _default;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var _util = __webpack_require__(220);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerProcessor({
	  // `dataZoomProcessor` will only be performed in needed series. Consider if
	  // there is a line series and a pie series, it is better not to update the
	  // line series if only pie series is needed to be updated.
	  getTargetSeries: function (ecModel) {
	    var seriesModelMap = createHashMap();
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        var axisProxy = dataZoomModel.getAxisProxy(dimNames.name, axisIndex);
	        each(axisProxy.getTargetSeriesModels(), function (seriesModel) {
	          seriesModelMap.set(seriesModel.uid, seriesModel);
	        });
	      });
	    });
	    return seriesModelMap;
	  },
	  modifyOutputEnd: true,
	  // Consider appendData, where filter should be performed. Because data process is
	  // in block mode currently, it is not need to worry about that the overallProgress
	  // execute every frame.
	  overallReset: function (ecModel, api) {
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      // We calculate window and reset axis here but not in model
	      // init stage and not after action dispatch handler, because
	      // reset should be called after seriesData.restoreData.
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        dataZoomModel.getAxisProxy(dimNames.name, axisIndex).reset(dataZoomModel, api);
	      }); // Caution: data zoom filtering is order sensitive when using
	      // percent range and no min/max/scale set on axis.
	      // For example, we have dataZoom definition:
	      // [
	      //      {xAxisIndex: 0, start: 30, end: 70},
	      //      {yAxisIndex: 0, start: 20, end: 80}
	      // ]
	      // In this case, [20, 80] of y-dataZoom should be based on data
	      // that have filtered by x-dataZoom using range of [30, 70],
	      // but should not be based on full raw data. Thus sliding
	      // x-dataZoom will change both ranges of xAxis and yAxis,
	      // while sliding y-dataZoom will only change the range of yAxis.
	      // So we should filter x-axis after reset x-axis immediately,
	      // and then reset y-axis and filter y-axis.
	
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        dataZoomModel.getAxisProxy(dimNames.name, axisIndex).filterData(dataZoomModel, api);
	      });
	    });
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      // Fullfill all of the range props so that user
	      // is able to get them from chart.getOption().
	      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	      var percentRange = axisProxy.getDataPercentWindow();
	      var valueRange = axisProxy.getDataValueWindow();
	      dataZoomModel.setCalculatedRange({
	        start: percentRange[0],
	        end: percentRange[1],
	        startValue: valueRange[0],
	        endValue: valueRange[1]
	      });
	    });
	  }
	});

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var helper = __webpack_require__(626);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction('dataZoom', function (payload, ecModel) {
	  var linkedNodesFinder = helper.createLinkedNodesFinder(zrUtil.bind(ecModel.eachComponent, ecModel, 'dataZoom'), helper.eachAxisDim, function (model, dimNames) {
	    return model.get(dimNames.axisIndex);
	  });
	  var effectedModels = [];
	  ecModel.eachComponent({
	    mainType: 'dataZoom',
	    query: payload
	  }, function (model, index) {
	    effectedModels.push.apply(effectedModels, linkedNodesFinder(model).nodes);
	  });
	  zrUtil.each(effectedModels, function (dataZoomModel, index) {
	    dataZoomModel.setRawRange({
	      start: payload.start,
	      end: payload.end,
	      startValue: payload.startValue,
	      endValue: payload.endValue
	    });
	  });
	});

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var history = __webpack_require__(622);
	
	var lang = __webpack_require__(330);
	
	var featureManager = __webpack_require__(614);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var restoreLang = lang.toolbox.restore;
	
	function Restore(model) {
	  this.model = model;
	}
	
	Restore.defaultOption = {
	  show: true,
	
	  /* eslint-disable */
	  icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
	
	  /* eslint-enable */
	  title: restoreLang.title
	};
	var proto = Restore.prototype;
	
	proto.onclick = function (ecModel, api, type) {
	  history.clear(ecModel);
	  api.dispatchAction({
	    type: 'restore',
	    from: this.uid
	  });
	};
	
	featureManager.register('restore', Restore);
	echarts.registerAction({
	  type: 'restore',
	  event: 'restore',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  ecModel.resetOption('recreate');
	});
	var _default = Restore;
	module.exports = _default;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(564);
	
	__webpack_require__(635);
	
	__webpack_require__(636);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME Better way to pack data in graphic element
	
	/**
	 * @action
	 * @property {string} type
	 * @property {number} seriesIndex
	 * @property {number} dataIndex
	 * @property {number} [x]
	 * @property {number} [y]
	 */
	echarts.registerAction({
	  type: 'showTip',
	  event: 'showTip',
	  update: 'tooltip:manuallyShowTip'
	}, // noop
	function () {});
	echarts.registerAction({
	  type: 'hideTip',
	  event: 'hideTip',
	  update: 'tooltip:manuallyHideTip'
	}, // noop
	function () {});

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentModel({
	  type: 'tooltip',
	  dependencies: ['axisPointer'],
	  defaultOption: {
	    zlevel: 0,
	    z: 60,
	    show: true,
	    // tooltip主体内容
	    showContent: true,
	    // 'trigger' only works on coordinate system.
	    // 'item' | 'axis' | 'none'
	    trigger: 'item',
	    // 'click' | 'mousemove' | 'none'
	    triggerOn: 'mousemove|click',
	    alwaysShowContent: false,
	    displayMode: 'single',
	    // 'single' | 'multipleByCoordSys'
	    renderMode: 'auto',
	    // 'auto' | 'html' | 'richText'
	    // 'auto': use html by default, and use non-html if `document` is not defined
	    // 'html': use html for tooltip
	    // 'richText': use canvas, svg, and etc. for tooltip
	    // 位置 {Array} | {Function}
	    // position: null
	    // Consider triggered from axisPointer handle, verticalAlign should be 'middle'
	    // align: null,
	    // verticalAlign: null,
	    // 是否约束 content 在 viewRect 中。默认 false 是为了兼容以前版本。
	    confine: false,
	    // 内容格式器：{string}（Template） ¦ {Function}
	    // formatter: null
	    showDelay: 0,
	    // 隐藏延迟，单位ms
	    hideDelay: 100,
	    // 动画变换时间，单位s
	    transitionDuration: 0.4,
	    enterable: false,
	    // 提示背景颜色，默认为透明度为0.7的黑色
	    backgroundColor: 'rgba(50,50,50,0.7)',
	    // 提示边框颜色
	    borderColor: '#333',
	    // 提示边框圆角，单位px，默认为4
	    borderRadius: 4,
	    // 提示边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 提示内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // Extra css text
	    extraCssText: '',
	    // 坐标轴指示器，坐标轴触发有效
	    axisPointer: {
	      // 默认为直线
	      // 可选为：'line' | 'shadow' | 'cross'
	      type: 'line',
	      // type 为 line 的时候有效，指定 tooltip line 所在的轴，可选
	      // 可选 'x' | 'y' | 'angle' | 'radius' | 'auto'
	      // 默认 'auto'，会选择类型为 category 的轴，对于双数值轴，笛卡尔坐标系会默认选择 x 轴
	      // 极坐标系会默认选择 angle 轴
	      axis: 'auto',
	      animation: 'auto',
	      animationDurationUpdate: 200,
	      animationEasingUpdate: 'exponentialOut',
	      crossStyle: {
	        color: '#999',
	        width: 1,
	        type: 'dashed',
	        // TODO formatter
	        textStyle: {} // lineStyle and shadowStyle should not be specified here,
	        // otherwise it will always override those styles on option.axisPointer.
	
	      }
	    },
	    textStyle: {
	      color: '#fff',
	      fontSize: 14
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var env = __webpack_require__(219);
	
	var TooltipContent = __webpack_require__(637);
	
	var TooltipRichContent = __webpack_require__(638);
	
	var formatUtil = __webpack_require__(307);
	
	var numberUtil = __webpack_require__(306);
	
	var graphic = __webpack_require__(268);
	
	var findPointFromSeries = __webpack_require__(566);
	
	var layoutUtil = __webpack_require__(305);
	
	var Model = __webpack_require__(262);
	
	var globalListener = __webpack_require__(569);
	
	var axisHelper = __webpack_require__(350);
	
	var axisPointerViewHelper = __webpack_require__(572);
	
	var _model = __webpack_require__(261);
	
	var getTooltipRenderMode = _model.getTooltipRenderMode;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var each = zrUtil.each;
	var parsePercent = numberUtil.parsePercent;
	var proxyRect = new graphic.Rect({
	  shape: {
	    x: -1,
	    y: -1,
	    width: 2,
	    height: 2
	  }
	});
	
	var _default = echarts.extendComponentView({
	  type: 'tooltip',
	  init: function (ecModel, api) {
	    if (env.node) {
	      return;
	    }
	
	    var tooltipModel = ecModel.getComponent('tooltip');
	    var renderMode = tooltipModel.get('renderMode');
	    this._renderMode = getTooltipRenderMode(renderMode);
	    var tooltipContent;
	
	    if (this._renderMode === 'html') {
	      tooltipContent = new TooltipContent(api.getDom(), api, {
	        appendToBody: tooltipModel.get('appendToBody', true)
	      });
	      this._newLine = '<br/>';
	    } else {
	      tooltipContent = new TooltipRichContent(api);
	      this._newLine = '\n';
	    }
	
	    this._tooltipContent = tooltipContent;
	  },
	  render: function (tooltipModel, ecModel, api) {
	    if (env.node) {
	      return;
	    } // Reset
	
	
	    this.group.removeAll();
	    /**
	     * @private
	     * @type {module:echarts/component/tooltip/TooltipModel}
	     */
	
	    this._tooltipModel = tooltipModel;
	    /**
	     * @private
	     * @type {module:echarts/model/Global}
	     */
	
	    this._ecModel = ecModel;
	    /**
	     * @private
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this._api = api;
	    /**
	     * Should be cleaned when render.
	     * @private
	     * @type {Array.<Array.<Object>>}
	     */
	
	    this._lastDataByCoordSys = null;
	    /**
	     * @private
	     * @type {boolean}
	     */
	
	    this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    var tooltipContent = this._tooltipContent;
	    tooltipContent.update(tooltipModel);
	    tooltipContent.setEnterable(tooltipModel.get('enterable'));
	
	    this._initGlobalListener();
	
	    this._keepShow();
	  },
	  _initGlobalListener: function () {
	    var tooltipModel = this._tooltipModel;
	    var triggerOn = tooltipModel.get('triggerOn');
	    globalListener.register('itemTooltip', this._api, bind(function (currTrigger, e, dispatchAction) {
	      // If 'none', it is not controlled by mouse totally.
	      if (triggerOn !== 'none') {
	        if (triggerOn.indexOf(currTrigger) >= 0) {
	          this._tryShow(e, dispatchAction);
	        } else if (currTrigger === 'leave') {
	          this._hide(dispatchAction);
	        }
	      }
	    }, this));
	  },
	  _keepShow: function () {
	    var tooltipModel = this._tooltipModel;
	    var ecModel = this._ecModel;
	    var api = this._api; // Try to keep the tooltip show when refreshing
	
	    if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
	    // self.manuallyShowTip({x, y}) might cause tooltip hide,
	    // which is not expected.
	    && tooltipModel.get('triggerOn') !== 'none') {
	      var self = this;
	      clearTimeout(this._refreshUpdateTimeout);
	      this._refreshUpdateTimeout = setTimeout(function () {
	        // Show tip next tick after other charts are rendered
	        // In case highlight action has wrong result
	        // FIXME
	        !api.isDisposed() && self.manuallyShowTip(tooltipModel, ecModel, api, {
	          x: self._lastX,
	          y: self._lastY
	        });
	      });
	    }
	  },
	
	  /**
	   * Show tip manually by
	   * dispatchAction({
	   *     type: 'showTip',
	   *     x: 10,
	   *     y: 10
	   * });
	   * Or
	   * dispatchAction({
	   *      type: 'showTip',
	   *      seriesIndex: 0,
	   *      dataIndex or dataIndexInside or name
	   * });
	   *
	   *  TODO Batch
	   */
	  manuallyShowTip: function (tooltipModel, ecModel, api, payload) {
	    if (payload.from === this.uid || env.node) {
	      return;
	    }
	
	    var dispatchAction = makeDispatchAction(payload, api); // Reset ticket
	
	    this._ticket = ''; // When triggered from axisPointer.
	
	    var dataByCoordSys = payload.dataByCoordSys;
	
	    if (payload.tooltip && payload.x != null && payload.y != null) {
	      var el = proxyRect;
	      el.position = [payload.x, payload.y];
	      el.update();
	      el.tooltip = payload.tooltip; // Manually show tooltip while view is not using zrender elements.
	
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        target: el
	      }, dispatchAction);
	    } else if (dataByCoordSys) {
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        position: payload.position,
	        dataByCoordSys: payload.dataByCoordSys,
	        tooltipOption: payload.tooltipOption
	      }, dispatchAction);
	    } else if (payload.seriesIndex != null) {
	      if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
	        return;
	      }
	
	      var pointInfo = findPointFromSeries(payload, ecModel);
	      var cx = pointInfo.point[0];
	      var cy = pointInfo.point[1];
	
	      if (cx != null && cy != null) {
	        this._tryShow({
	          offsetX: cx,
	          offsetY: cy,
	          position: payload.position,
	          target: pointInfo.el
	        }, dispatchAction);
	      }
	    } else if (payload.x != null && payload.y != null) {
	      // FIXME
	      // should wrap dispatchAction like `axisPointer/globalListener` ?
	      api.dispatchAction({
	        type: 'updateAxisPointer',
	        x: payload.x,
	        y: payload.y
	      });
	
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        position: payload.position,
	        target: api.getZr().findHover(payload.x, payload.y).target
	      }, dispatchAction);
	    }
	  },
	  manuallyHideTip: function (tooltipModel, ecModel, api, payload) {
	    var tooltipContent = this._tooltipContent;
	
	    if (!this._alwaysShowContent && this._tooltipModel) {
	      tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
	    }
	
	    this._lastX = this._lastY = null;
	
	    if (payload.from !== this.uid) {
	      this._hide(makeDispatchAction(payload, api));
	    }
	  },
	  // Be compatible with previous design, that is, when tooltip.type is 'axis' and
	  // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
	  // and tooltip.
	  _manuallyAxisShowTip: function (tooltipModel, ecModel, api, payload) {
	    var seriesIndex = payload.seriesIndex;
	    var dataIndex = payload.dataIndex;
	    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
	
	    if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
	      return;
	    }
	
	    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	
	    if (!seriesModel) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model, tooltipModel]);
	
	    if (tooltipModel.get('trigger') !== 'axis') {
	      return;
	    }
	
	    api.dispatchAction({
	      type: 'updateAxisPointer',
	      seriesIndex: seriesIndex,
	      dataIndex: dataIndex,
	      position: payload.position
	    });
	    return true;
	  },
	  _tryShow: function (e, dispatchAction) {
	    var el = e.target;
	    var tooltipModel = this._tooltipModel;
	
	    if (!tooltipModel) {
	      return;
	    } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
	
	
	    this._lastX = e.offsetX;
	    this._lastY = e.offsetY;
	    var dataByCoordSys = e.dataByCoordSys;
	
	    if (dataByCoordSys && dataByCoordSys.length) {
	      this._showAxisTooltip(dataByCoordSys, e);
	    } // Always show item tooltip if mouse is on the element with dataIndex
	    else if (el && el.dataIndex != null) {
	        this._lastDataByCoordSys = null;
	
	        this._showSeriesItemTooltip(e, el, dispatchAction);
	      } // Tooltip provided directly. Like legend.
	      else if (el && el.tooltip) {
	          this._lastDataByCoordSys = null;
	
	          this._showComponentItemTooltip(e, el, dispatchAction);
	        } else {
	          this._lastDataByCoordSys = null;
	
	          this._hide(dispatchAction);
	        }
	  },
	  _showOrMove: function (tooltipModel, cb) {
	    // showDelay is used in this case: tooltip.enterable is set
	    // as true. User intent to move mouse into tooltip and click
	    // something. `showDelay` makes it easier to enter the content
	    // but tooltip do not move immediately.
	    var delay = tooltipModel.get('showDelay');
	    cb = zrUtil.bind(cb, this);
	    clearTimeout(this._showTimout);
	    delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
	  },
	  _showAxisTooltip: function (dataByCoordSys, e) {
	    var ecModel = this._ecModel;
	    var globalTooltipModel = this._tooltipModel;
	    var point = [e.offsetX, e.offsetY];
	    var singleDefaultHTML = [];
	    var singleParamsList = [];
	    var singleTooltipModel = buildTooltipModel([e.tooltipOption, globalTooltipModel]);
	    var renderMode = this._renderMode;
	    var newLine = this._newLine;
	    var markers = {};
	    each(dataByCoordSys, function (itemCoordSys) {
	      // var coordParamList = [];
	      // var coordDefaultHTML = [];
	      // var coordTooltipModel = buildTooltipModel([
	      //     e.tooltipOption,
	      //     itemCoordSys.tooltipOption,
	      //     ecModel.getComponent(itemCoordSys.coordSysMainType, itemCoordSys.coordSysIndex),
	      //     globalTooltipModel
	      // ]);
	      // var displayMode = coordTooltipModel.get('displayMode');
	      // var paramsList = displayMode === 'single' ? singleParamsList : [];
	      each(itemCoordSys.dataByAxis, function (item) {
	        var axisModel = ecModel.getComponent(item.axisDim + 'Axis', item.axisIndex);
	        var axisValue = item.value;
	        var seriesDefaultHTML = [];
	
	        if (!axisModel || axisValue == null) {
	          return;
	        }
	
	        var valueLabel = axisPointerViewHelper.getValueLabel(axisValue, axisModel.axis, ecModel, item.seriesDataIndices, item.valueLabelOpt);
	        zrUtil.each(item.seriesDataIndices, function (idxItem) {
	          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	          var dataIndex = idxItem.dataIndexInside;
	          var dataParams = series && series.getDataParams(dataIndex);
	          dataParams.axisDim = item.axisDim;
	          dataParams.axisIndex = item.axisIndex;
	          dataParams.axisType = item.axisType;
	          dataParams.axisId = item.axisId;
	          dataParams.axisValue = axisHelper.getAxisRawValue(axisModel.axis, axisValue);
	          dataParams.axisValueLabel = valueLabel;
	
	          if (dataParams) {
	            singleParamsList.push(dataParams);
	            var seriesTooltip = series.formatTooltip(dataIndex, true, null, renderMode);
	            var html;
	
	            if (zrUtil.isObject(seriesTooltip)) {
	              html = seriesTooltip.html;
	              var newMarkers = seriesTooltip.markers;
	              zrUtil.merge(markers, newMarkers);
	            } else {
	              html = seriesTooltip;
	            }
	
	            seriesDefaultHTML.push(html);
	          }
	        }); // Default tooltip content
	        // FIXME
	        // (1) should be the first data which has name?
	        // (2) themeRiver, firstDataIndex is array, and first line is unnecessary.
	
	        var firstLine = valueLabel;
	
	        if (renderMode !== 'html') {
	          singleDefaultHTML.push(seriesDefaultHTML.join(newLine));
	        } else {
	          singleDefaultHTML.push((firstLine ? formatUtil.encodeHTML(firstLine) + newLine : '') + seriesDefaultHTML.join(newLine));
	        }
	      });
	    }, this); // In most case, the second axis is shown upper than the first one.
	
	    singleDefaultHTML.reverse();
	    singleDefaultHTML = singleDefaultHTML.join(this._newLine + this._newLine);
	    var positionExpr = e.position;
	
	    this._showOrMove(singleTooltipModel, function () {
	      if (this._updateContentNotChangedOnAxis(dataByCoordSys)) {
	        this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, singleParamsList);
	      } else {
	        this._showTooltipContent(singleTooltipModel, singleDefaultHTML, singleParamsList, Math.random(), point[0], point[1], positionExpr, undefined, markers);
	      }
	    }); // Do not trigger events here, because this branch only be entered
	    // from dispatchAction.
	
	  },
	  _showSeriesItemTooltip: function (e, el, dispatchAction) {
	    var ecModel = this._ecModel; // Use dataModel in element if possible
	    // Used when mouseover on a element like markPoint or edge
	    // In which case, the data is not main data in series.
	
	    var seriesIndex = el.seriesIndex;
	    var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.
	
	    var dataModel = el.dataModel || seriesModel;
	    var dataIndex = el.dataIndex;
	    var dataType = el.dataType;
	    var data = dataModel.getData(dataType);
	    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model, this._tooltipModel]);
	    var tooltipTrigger = tooltipModel.get('trigger');
	
	    if (tooltipTrigger != null && tooltipTrigger !== 'item') {
	      return;
	    }
	
	    var params = dataModel.getDataParams(dataIndex, dataType);
	    var seriesTooltip = dataModel.formatTooltip(dataIndex, false, dataType, this._renderMode);
	    var defaultHtml;
	    var markers;
	
	    if (zrUtil.isObject(seriesTooltip)) {
	      defaultHtml = seriesTooltip.html;
	      markers = seriesTooltip.markers;
	    } else {
	      defaultHtml = seriesTooltip;
	      markers = null;
	    }
	
	    var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
	
	    this._showOrMove(tooltipModel, function () {
	      this._showTooltipContent(tooltipModel, defaultHtml, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markers);
	    }); // FIXME
	    // duplicated showtip if manuallyShowTip is called from dispatchAction.
	
	
	    dispatchAction({
	      type: 'showTip',
	      dataIndexInside: dataIndex,
	      dataIndex: data.getRawIndex(dataIndex),
	      seriesIndex: seriesIndex,
	      from: this.uid
	    });
	  },
	  _showComponentItemTooltip: function (e, el, dispatchAction) {
	    var tooltipOpt = el.tooltip;
	
	    if (typeof tooltipOpt === 'string') {
	      var content = tooltipOpt;
	      tooltipOpt = {
	        content: content,
	        // Fixed formatter
	        formatter: content
	      };
	    }
	
	    var subTooltipModel = new Model(tooltipOpt, this._tooltipModel, this._ecModel);
	    var defaultHtml = subTooltipModel.get('content');
	    var asyncTicket = Math.random(); // Do not check whether `trigger` is 'none' here, because `trigger`
	    // only works on coordinate system. In fact, we have not found case
	    // that requires setting `trigger` nothing on component yet.
	
	    this._showOrMove(subTooltipModel, function () {
	      this._showTooltipContent(subTooltipModel, defaultHtml, subTooltipModel.get('formatterParams') || {}, asyncTicket, e.offsetX, e.offsetY, e.position, el);
	    }); // If not dispatch showTip, tip may be hide triggered by axis.
	
	
	    dispatchAction({
	      type: 'showTip',
	      from: this.uid
	    });
	  },
	  _showTooltipContent: function (tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markers) {
	    // Reset ticket
	    this._ticket = '';
	
	    if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
	      return;
	    }
	
	    var tooltipContent = this._tooltipContent;
	    var formatter = tooltipModel.get('formatter');
	    positionExpr = positionExpr || tooltipModel.get('position');
	    var html = defaultHtml;
	
	    if (formatter && typeof formatter === 'string') {
	      html = formatUtil.formatTpl(formatter, params, true);
	    } else if (typeof formatter === 'function') {
	      var callback = bind(function (cbTicket, html) {
	        if (cbTicket === this._ticket) {
	          tooltipContent.setContent(html, markers, tooltipModel);
	
	          this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	        }
	      }, this);
	      this._ticket = asyncTicket;
	      html = formatter(params, asyncTicket, callback);
	    }
	
	    tooltipContent.setContent(html, markers, tooltipModel);
	    tooltipContent.show(tooltipModel);
	
	    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	  },
	
	  /**
	   * @param  {string|Function|Array.<number>|Object} positionExpr
	   * @param  {number} x Mouse x
	   * @param  {number} y Mouse y
	   * @param  {boolean} confine Whether confine tooltip content in view rect.
	   * @param  {Object|<Array.<Object>} params
	   * @param  {module:zrender/Element} el target element
	   * @param  {module:echarts/ExtensionAPI} api
	   * @return {Array.<number>}
	   */
	  _updatePosition: function (tooltipModel, positionExpr, x, y, content, params, el) {
	    var viewWidth = this._api.getWidth();
	
	    var viewHeight = this._api.getHeight();
	
	    positionExpr = positionExpr || tooltipModel.get('position');
	    var contentSize = content.getSize();
	    var align = tooltipModel.get('align');
	    var vAlign = tooltipModel.get('verticalAlign');
	    var rect = el && el.getBoundingRect().clone();
	    el && rect.applyTransform(el.transform);
	
	    if (typeof positionExpr === 'function') {
	      // Callback of position can be an array or a string specify the position
	      positionExpr = positionExpr([x, y], params, content.el, rect, {
	        viewSize: [viewWidth, viewHeight],
	        contentSize: contentSize.slice()
	      });
	    }
	
	    if (zrUtil.isArray(positionExpr)) {
	      x = parsePercent(positionExpr[0], viewWidth);
	      y = parsePercent(positionExpr[1], viewHeight);
	    } else if (zrUtil.isObject(positionExpr)) {
	      positionExpr.width = contentSize[0];
	      positionExpr.height = contentSize[1];
	      var layoutRect = layoutUtil.getLayoutRect(positionExpr, {
	        width: viewWidth,
	        height: viewHeight
	      });
	      x = layoutRect.x;
	      y = layoutRect.y;
	      align = null; // When positionExpr is left/top/right/bottom,
	      // align and verticalAlign will not work.
	
	      vAlign = null;
	    } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
	    else if (typeof positionExpr === 'string' && el) {
	        var pos = calcTooltipPosition(positionExpr, rect, contentSize);
	        x = pos[0];
	        y = pos[1];
	      } else {
	        var pos = refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
	        x = pos[0];
	        y = pos[1];
	      }
	
	    align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
	    vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
	
	    if (tooltipModel.get('confine')) {
	      var pos = confineTooltipPosition(x, y, content, viewWidth, viewHeight);
	      x = pos[0];
	      y = pos[1];
	    }
	
	    content.moveTo(x, y);
	  },
	  // FIXME
	  // Should we remove this but leave this to user?
	  _updateContentNotChangedOnAxis: function (dataByCoordSys) {
	    var lastCoordSys = this._lastDataByCoordSys;
	    var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
	    contentNotChanged && each(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
	      var lastDataByAxis = lastItemCoordSys.dataByAxis || {};
	      var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
	      var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
	      contentNotChanged &= lastDataByAxis.length === thisDataByAxis.length;
	      contentNotChanged && each(lastDataByAxis, function (lastItem, indexAxis) {
	        var thisItem = thisDataByAxis[indexAxis] || {};
	        var lastIndices = lastItem.seriesDataIndices || [];
	        var newIndices = thisItem.seriesDataIndices || [];
	        contentNotChanged &= lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
	        contentNotChanged && each(lastIndices, function (lastIdxItem, j) {
	          var newIdxItem = newIndices[j];
	          contentNotChanged &= lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
	        });
	      });
	    });
	    this._lastDataByCoordSys = dataByCoordSys;
	    return !!contentNotChanged;
	  },
	  _hide: function (dispatchAction) {
	    // Do not directly hideLater here, because this behavior may be prevented
	    // in dispatchAction when showTip is dispatched.
	    // FIXME
	    // duplicated hideTip if manuallyHideTip is called from dispatchAction.
	    this._lastDataByCoordSys = null;
	    dispatchAction({
	      type: 'hideTip',
	      from: this.uid
	    });
	  },
	  dispose: function (ecModel, api) {
	    if (env.node) {
	      return;
	    }
	
	    this._tooltipContent.dispose();
	
	    globalListener.unregister('itemTooltip', api);
	  }
	});
	/**
	 * @param {Array.<Object|module:echarts/model/Model>} modelCascade
	 * From top to bottom. (the last one should be globalTooltipModel);
	 */
	
	
	function buildTooltipModel(modelCascade) {
	  var resultModel = modelCascade.pop();
	
	  while (modelCascade.length) {
	    var tooltipOpt = modelCascade.pop();
	
	    if (tooltipOpt) {
	      if (Model.isInstance(tooltipOpt)) {
	        tooltipOpt = tooltipOpt.get('tooltip', true);
	      } // In each data item tooltip can be simply write:
	      // {
	      //  value: 10,
	      //  tooltip: 'Something you need to know'
	      // }
	
	
	      if (typeof tooltipOpt === 'string') {
	        tooltipOpt = {
	          formatter: tooltipOpt
	        };
	      }
	
	      resultModel = new Model(tooltipOpt, resultModel, resultModel.ecModel);
	    }
	  }
	
	  return resultModel;
	}
	
	function makeDispatchAction(payload, api) {
	  return payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
	}
	
	function refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
	  var size = content.getOuterSize();
	  var width = size.width;
	  var height = size.height;
	
	  if (gapH != null) {
	    if (x + width + gapH > viewWidth) {
	      x -= width + gapH;
	    } else {
	      x += gapH;
	    }
	  }
	
	  if (gapV != null) {
	    if (y + height + gapV > viewHeight) {
	      y -= height + gapV;
	    } else {
	      y += gapV;
	    }
	  }
	
	  return [x, y];
	}
	
	function confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
	  var size = content.getOuterSize();
	  var width = size.width;
	  var height = size.height;
	  x = Math.min(x + width, viewWidth) - width;
	  y = Math.min(y + height, viewHeight) - height;
	  x = Math.max(x, 0);
	  y = Math.max(y, 0);
	  return [x, y];
	}
	
	function calcTooltipPosition(position, rect, contentSize) {
	  var domWidth = contentSize[0];
	  var domHeight = contentSize[1];
	  var gap = 5;
	  var x = 0;
	  var y = 0;
	  var rectWidth = rect.width;
	  var rectHeight = rect.height;
	
	  switch (position) {
	    case 'inside':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	      break;
	
	    case 'top':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y - domHeight - gap;
	      break;
	
	    case 'bottom':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y + rectHeight + gap;
	      break;
	
	    case 'left':
	      x = rect.x - domWidth - gap;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	      break;
	
	    case 'right':
	      x = rect.x + rectWidth + gap;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	  }
	
	  return [x, y];
	}
	
	function isCenterAlign(align) {
	  return align === 'center' || align === 'middle';
	}
	
	module.exports = _default;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var zrColor = __webpack_require__(238);
	
	var eventUtil = __webpack_require__(225);
	
	var domUtil = __webpack_require__(226);
	
	var env = __webpack_require__(219);
	
	var formatUtil = __webpack_require__(307);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var toCamelCase = formatUtil.toCamelCase;
	var vendors = ['', '-webkit-', '-moz-', '-o-'];
	var gCssText = 'position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;';
	/**
	 * @param {number} duration
	 * @return {string}
	 * @inner
	 */
	
	function assembleTransition(duration) {
	  var transitionCurve = 'cubic-bezier(0.23, 1, 0.32, 1)';
	  var transitionText = 'left ' + duration + 's ' + transitionCurve + ',' + 'top ' + duration + 's ' + transitionCurve;
	  return zrUtil.map(vendors, function (vendorPrefix) {
	    return vendorPrefix + 'transition:' + transitionText;
	  }).join(';');
	}
	/**
	 * @param {Object} textStyle
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleFont(textStyleModel) {
	  var cssText = [];
	  var fontSize = textStyleModel.get('fontSize');
	  var color = textStyleModel.getTextColor();
	  color && cssText.push('color:' + color);
	  cssText.push('font:' + textStyleModel.getFont());
	  var lineHeight = textStyleModel.get('lineHeight');
	
	  if (lineHeight == null) {
	    lineHeight = Math.round(fontSize * 3 / 2);
	  }
	
	  fontSize && cssText.push('line-height:' + lineHeight + 'px');
	  var shadowColor = textStyleModel.get('textShadowColor');
	  var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
	  var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
	  var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
	  shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
	  each(['decoration', 'align'], function (name) {
	    var val = textStyleModel.get(name);
	    val && cssText.push('text-' + name + ':' + val);
	  });
	  return cssText.join(';');
	}
	/**
	 * @param {Object} tooltipModel
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleCssText(tooltipModel) {
	  var cssText = [];
	  var transitionDuration = tooltipModel.get('transitionDuration');
	  var backgroundColor = tooltipModel.get('backgroundColor');
	  var textStyleModel = tooltipModel.getModel('textStyle');
	  var padding = tooltipModel.get('padding'); // Animation transition. Do not animate when transitionDuration is 0.
	
	  transitionDuration && cssText.push(assembleTransition(transitionDuration));
	
	  if (backgroundColor) {
	    if (env.canvasSupported) {
	      cssText.push('background-Color:' + backgroundColor);
	    } else {
	      // for ie
	      cssText.push('background-Color:#' + zrColor.toHex(backgroundColor));
	      cssText.push('filter:alpha(opacity=70)');
	    }
	  } // Border style
	
	
	  each(['width', 'color', 'radius'], function (name) {
	    var borderName = 'border-' + name;
	    var camelCase = toCamelCase(borderName);
	    var val = tooltipModel.get(camelCase);
	    val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
	  }); // Text style
	
	  cssText.push(assembleFont(textStyleModel)); // Padding
	
	  if (padding != null) {
	    cssText.push('padding:' + formatUtil.normalizeCssArray(padding).join('px ') + 'px');
	  }
	
	  return cssText.join(';') + ';';
	} // If not able to make, do not modify the input `out`.
	
	
	function makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
	  var zrPainter = zr && zr.painter;
	
	  if (appendToBody) {
	    var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
	
	    if (zrViewportRoot) {
	      // Some APPs might use scale on body, so we support CSS transform here.
	      domUtil.transformLocalCoord(out, zrViewportRoot, document.body, zrX, zrY);
	    }
	  } else {
	    out[0] = zrX;
	    out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
	    // the sibling of canvas root. So padding of ec container
	    // should be considered here.
	
	    var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
	
	    if (viewportRootOffset) {
	      out[0] += viewportRootOffset.offsetLeft;
	      out[1] += viewportRootOffset.offsetTop;
	    }
	  }
	
	  out[2] = out[0] / zr.getWidth(); // The ratio of left to width
	
	  out[3] = out[1] / zr.getHeight(); // The ratio of top to height
	}
	/**
	 * @alias module:echarts/component/tooltip/TooltipContent
	 * @param {HTMLElement} container
	 * @param {ExtensionAPI} api
	 * @param {Object} [opt]
	 * @param {boolean} [opt.appendToBody]
	 *        `false`: the DOM element will be inside the container. Default value.
	 *        `true`: the DOM element will be appended to HTML body, which avoid
	 *                some overflow clip but intrude outside of the container.
	 * @constructor
	 */
	
	
	function TooltipContent(container, api, opt) {
	  if (env.wxa) {
	    return null;
	  }
	
	  var el = document.createElement('div');
	  el.domBelongToZr = true;
	  this.el = el;
	  var zr = this._zr = api.getZr();
	  var appendToBody = this._appendToBody = opt && opt.appendToBody;
	  this._styleCoord = [0, 0, 0, 0]; // [left, top, left/width, top/height]
	
	  makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);
	
	  if (appendToBody) {
	    document.body.appendChild(el);
	  } else {
	    container.appendChild(el);
	  }
	
	  this._container = container;
	  this._show = false;
	  /**
	   * @private
	   */
	
	  this._hideTimeout; // FIXME
	  // Is it needed to trigger zr event manually if
	  // the browser do not support `pointer-events: none`.
	
	  var self = this;
	
	  el.onmouseenter = function () {
	    // clear the timeout in hideLater and keep showing tooltip
	    if (self._enterable) {
	      clearTimeout(self._hideTimeout);
	      self._show = true;
	    }
	
	    self._inContent = true;
	  };
	
	  el.onmousemove = function (e) {
	    e = e || window.event;
	
	    if (!self._enterable) {
	      // `pointer-events: none` is set to tooltip content div
	      // if `enterable` is set as `false`, and `el.onmousemove`
	      // can not be triggered. But in browser that do not
	      // support `pointer-events`, we need to do this:
	      // Try trigger zrender event to avoid mouse
	      // in and out shape too frequently
	      var handler = zr.handler;
	      var zrViewportRoot = zr.painter.getViewportRoot();
	      eventUtil.normalizeEvent(zrViewportRoot, e, true);
	      handler.dispatch('mousemove', e);
	    }
	  };
	
	  el.onmouseleave = function () {
	    if (self._enterable) {
	      if (self._show) {
	        self.hideLater(self._hideDelay);
	      }
	    }
	
	    self._inContent = false;
	  };
	}
	
	TooltipContent.prototype = {
	  constructor: TooltipContent,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _enterable: true,
	
	  /**
	   * Update when tooltip is rendered
	   */
	  update: function (tooltipModel) {
	    // FIXME
	    // Move this logic to ec main?
	    var container = this._container;
	    var stl = container.currentStyle || document.defaultView.getComputedStyle(container);
	    var domStyle = container.style;
	
	    if (domStyle.position !== 'absolute' && stl.position !== 'absolute') {
	      domStyle.position = 'relative';
	    }
	
	    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    alwaysShowContent && this._moveTooltipIfResized(); // Hide the tooltip
	    // PENDING
	    // this.hide();
	  },
	
	  /**
	   * when `alwaysShowContent` is true,
	   * we should move the tooltip after chart resized
	   */
	  _moveTooltipIfResized: function () {
	    var ratioX = this._styleCoord[2]; // The ratio of left to width
	
	    var ratioY = this._styleCoord[3]; // The ratio of top to height
	
	    var realX = ratioX * this._zr.getWidth();
	
	    var realY = ratioY * this._zr.getHeight();
	
	    this.moveTo(realX, realY);
	  },
	  show: function (tooltipModel) {
	    clearTimeout(this._hideTimeout);
	    var el = this.el;
	    var styleCoord = this._styleCoord;
	    el.style.cssText = gCssText + assembleCssText(tooltipModel) // Because of the reason described in:
	    // http://stackoverflow.com/questions/21125587/css3-transition-not-working-in-chrome-anymore
	    // we should set initial value to `left` and `top`.
	    + ';left:' + styleCoord[0] + 'px;top:' + styleCoord[1] + 'px;' + (tooltipModel.get('extraCssText') || '');
	    el.style.display = el.innerHTML ? 'block' : 'none'; // If mouse occasionally move over the tooltip, a mouseout event will be
	    // triggered by canvas, and cause some unexpectable result like dragging
	    // stop, "unfocusAdjacency". Here `pointer-events: none` is used to solve
	    // it. Although it is not supported by IE8~IE10, fortunately it is a rare
	    // scenario.
	
	    el.style.pointerEvents = this._enterable ? 'auto' : 'none';
	    this._show = true;
	  },
	  setContent: function (content) {
	    this.el.innerHTML = content == null ? '' : content;
	  },
	  setEnterable: function (enterable) {
	    this._enterable = enterable;
	  },
	  getSize: function () {
	    var el = this.el;
	    return [el.clientWidth, el.clientHeight];
	  },
	  moveTo: function (zrX, zrY) {
	    var styleCoord = this._styleCoord;
	    makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
	    var style = this.el.style;
	    style.left = styleCoord[0] + 'px';
	    style.top = styleCoord[1] + 'px';
	  },
	  hide: function () {
	    this.el.style.display = 'none';
	    this._show = false;
	  },
	  hideLater: function (time) {
	    if (this._show && !(this._inContent && this._enterable)) {
	      if (time) {
	        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
	
	        this._show = false;
	        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
	      } else {
	        this.hide();
	      }
	    }
	  },
	  isShow: function () {
	    return this._show;
	  },
	  dispose: function () {
	    this.el.parentNode.removeChild(this.el);
	  },
	  getOuterSize: function () {
	    var width = this.el.clientWidth;
	    var height = this.el.clientHeight; // Consider browser compatibility.
	    // IE8 does not support getComputedStyle.
	
	    if (document.defaultView && document.defaultView.getComputedStyle) {
	      var stl = document.defaultView.getComputedStyle(this.el);
	
	      if (stl) {
	        width += parseInt(stl.borderLeftWidth, 10) + parseInt(stl.borderRightWidth, 10);
	        height += parseInt(stl.borderTopWidth, 10) + parseInt(stl.borderBottomWidth, 10);
	      }
	    }
	
	    return {
	      width: width,
	      height: height
	    };
	  }
	};
	var _default = TooltipContent;
	module.exports = _default;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Text = __webpack_require__(282);
	
	var graphicUtil = __webpack_require__(268);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import Group from 'zrender/src/container/Group';
	function makeStyleCoord(out, zr, zrX, zrY) {
	  out[0] = zrX;
	  out[1] = zrY;
	  out[2] = out[0] / zr.getWidth(); // The ratio of left to width
	
	  out[3] = out[1] / zr.getHeight(); // The ratio of top to height
	}
	/**
	 * @alias module:echarts/component/tooltip/TooltipRichContent
	 * @constructor
	 */
	
	
	function TooltipRichContent(api) {
	  var zr = this._zr = api.getZr();
	  this._styleCoord = [0, 0, 0, 0]; // [left, top, left/width, top/height]
	
	  makeStyleCoord(this._styleCoord, zr, api.getWidth() / 2, api.getHeight() / 2);
	  this._show = false;
	  /**
	   * @private
	   */
	
	  this._hideTimeout;
	}
	
	TooltipRichContent.prototype = {
	  constructor: TooltipRichContent,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _enterable: true,
	
	  /**
	   * Update when tooltip is rendered
	   */
	  update: function (tooltipModel) {
	    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    alwaysShowContent && this._moveTooltipIfResized();
	  },
	
	  /**
	   * when `alwaysShowContent` is true,
	   * we should move the tooltip after chart resized
	   */
	  _moveTooltipIfResized: function () {
	    var ratioX = this._styleCoord[2]; // The ratio of left to width
	
	    var ratioY = this._styleCoord[3]; // The ratio of top to height
	
	    var realX = ratioX * this._zr.getWidth();
	
	    var realY = ratioY * this._zr.getHeight();
	
	    this.moveTo(realX, realY);
	  },
	  show: function (tooltipModel) {
	    if (this._hideTimeout) {
	      clearTimeout(this._hideTimeout);
	    }
	
	    this.el.attr('show', true);
	    this._show = true;
	  },
	
	  /**
	   * Set tooltip content
	   *
	   * @param {string} content rich text string of content
	   * @param {Object} markerRich rich text style
	   * @param {Object} tooltipModel tooltip model
	   */
	  setContent: function (content, markerRich, tooltipModel) {
	    if (this.el) {
	      this._zr.remove(this.el);
	    }
	
	    var markers = {};
	    var text = content;
	    var prefix = '{marker';
	    var suffix = '|}';
	    var startId = text.indexOf(prefix);
	
	    while (startId >= 0) {
	      var endId = text.indexOf(suffix);
	      var name = text.substr(startId + prefix.length, endId - startId - prefix.length);
	
	      if (name.indexOf('sub') > -1) {
	        markers['marker' + name] = {
	          textWidth: 4,
	          textHeight: 4,
	          textBorderRadius: 2,
	          textBackgroundColor: markerRich[name],
	          // TODO: textOffset is not implemented for rich text
	          textOffset: [3, 0]
	        };
	      } else {
	        markers['marker' + name] = {
	          textWidth: 10,
	          textHeight: 10,
	          textBorderRadius: 5,
	          textBackgroundColor: markerRich[name]
	        };
	      }
	
	      text = text.substr(endId + 1);
	      startId = text.indexOf('{marker');
	    }
	
	    var textStyleModel = tooltipModel.getModel('textStyle');
	    var fontSize = textStyleModel.get('fontSize');
	    var lineHeight = tooltipModel.get('textLineHeight');
	
	    if (lineHeight == null) {
	      lineHeight = Math.round(fontSize * 3 / 2);
	    }
	
	    this.el = new Text({
	      style: graphicUtil.setTextStyle({}, textStyleModel, {
	        rich: markers,
	        text: content,
	        textBackgroundColor: tooltipModel.get('backgroundColor'),
	        textBorderRadius: tooltipModel.get('borderRadius'),
	        textFill: tooltipModel.get('textStyle.color'),
	        textPadding: tooltipModel.get('padding'),
	        textLineHeight: lineHeight
	      }),
	      z: tooltipModel.get('z')
	    });
	
	    this._zr.add(this.el);
	
	    var self = this;
	    this.el.on('mouseover', function () {
	      // clear the timeout in hideLater and keep showing tooltip
	      if (self._enterable) {
	        clearTimeout(self._hideTimeout);
	        self._show = true;
	      }
	
	      self._inContent = true;
	    });
	    this.el.on('mouseout', function () {
	      if (self._enterable) {
	        if (self._show) {
	          self.hideLater(self._hideDelay);
	        }
	      }
	
	      self._inContent = false;
	    });
	  },
	  setEnterable: function (enterable) {
	    this._enterable = enterable;
	  },
	  getSize: function () {
	    var bounding = this.el.getBoundingRect();
	    return [bounding.width, bounding.height];
	  },
	  moveTo: function (x, y) {
	    if (this.el) {
	      var styleCoord = this._styleCoord;
	      makeStyleCoord(styleCoord, this._zr, x, y);
	      this.el.attr('position', [styleCoord[0], styleCoord[1]]);
	    }
	  },
	  hide: function () {
	    if (this.el) {
	      this.el.hide();
	    }
	
	    this._show = false;
	  },
	  hideLater: function (time) {
	    if (this._show && !(this._inContent && this._enterable)) {
	      if (time) {
	        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
	
	        this._show = false;
	        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
	      } else {
	        this.hide();
	      }
	    }
	  },
	  isShow: function () {
	    return this._show;
	  },
	  dispose: function () {
	    clearTimeout(this._hideTimeout);
	
	    if (this.el) {
	      this._zr.remove(this.el);
	    }
	  },
	  getOuterSize: function () {
	    var size = this.getSize();
	    return {
	      width: size[0],
	      height: size[1]
	    };
	  }
	};
	var _default = TooltipRichContent;
	module.exports = _default;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var preprocessor = __webpack_require__(640);
	
	__webpack_require__(641);
	
	__webpack_require__(644);
	
	__webpack_require__(645);
	
	__webpack_require__(646);
	
	__webpack_require__(647);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Brush component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_TOOLBOX_BTNS = ['rect', 'polygon', 'keep', 'clear'];
	
	function _default(option, isNew) {
	  var brushComponents = option && option.brush;
	
	  if (!zrUtil.isArray(brushComponents)) {
	    brushComponents = brushComponents ? [brushComponents] : [];
	  }
	
	  if (!brushComponents.length) {
	    return;
	  }
	
	  var brushComponentSpecifiedBtns = [];
	  zrUtil.each(brushComponents, function (brushOpt) {
	    var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];
	
	    if (tbs instanceof Array) {
	      brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
	    }
	  });
	  var toolbox = option && option.toolbox;
	
	  if (zrUtil.isArray(toolbox)) {
	    toolbox = toolbox[0];
	  }
	
	  if (!toolbox) {
	    toolbox = {
	      feature: {}
	    };
	    option.toolbox = [toolbox];
	  }
	
	  var toolboxFeature = toolbox.feature || (toolbox.feature = {});
	  var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
	  var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
	  brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
	  removeDuplicate(brushTypes);
	
	  if (isNew && !brushTypes.length) {
	    brushTypes.push.apply(brushTypes, DEFAULT_TOOLBOX_BTNS);
	  }
	}
	
	function removeDuplicate(arr) {
	  var map = {};
	  zrUtil.each(arr, function (val) {
	    map[val] = 1;
	  });
	  arr.length = 0;
	  zrUtil.each(map, function (flag, val) {
	    arr.push(val);
	  });
	}
	
	module.exports = _default;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var BoundingRect = __webpack_require__(242);
	
	var visualSolution = __webpack_require__(642);
	
	var selector = __webpack_require__(643);
	
	var throttleUtil = __webpack_require__(327);
	
	var BrushTargetManager = __webpack_require__(621);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var STATE_LIST = ['inBrush', 'outOfBrush'];
	var DISPATCH_METHOD = '__ecBrushSelect';
	var DISPATCH_FLAG = '__ecInBrushSelectEvent';
	var PRIORITY_BRUSH = echarts.PRIORITY.VISUAL.BRUSH;
	/**
	 * Layout for visual, the priority higher than other layout, and before brush visual.
	 */
	
	echarts.registerLayout(PRIORITY_BRUSH, function (ecModel, api, payload) {
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
	      brushType: false
	    });
	  });
	  layoutCovers(ecModel);
	});
	
	function layoutCovers(ecModel) {
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    var brushTargetManager = brushModel.brushTargetManager = new BrushTargetManager(brushModel.option, ecModel);
	    brushTargetManager.setInputRanges(brushModel.areas, ecModel);
	  });
	}
	/**
	 * Register the visual encoding if this modules required.
	 */
	
	
	echarts.registerVisual(PRIORITY_BRUSH, function (ecModel, api, payload) {
	  var brushSelected = [];
	  var throttleType;
	  var throttleDelay;
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel, brushIndex) {
	    var thisBrushSelected = {
	      brushId: brushModel.id,
	      brushIndex: brushIndex,
	      brushName: brushModel.name,
	      areas: zrUtil.clone(brushModel.areas),
	      selected: []
	    }; // Every brush component exists in event params, convenient
	    // for user to find by index.
	
	    brushSelected.push(thisBrushSelected);
	    var brushOption = brushModel.option;
	    var brushLink = brushOption.brushLink;
	    var linkedSeriesMap = [];
	    var selectedDataIndexForLink = [];
	    var rangeInfoBySeries = [];
	    var hasBrushExists = 0;
	
	    if (!brushIndex) {
	      // Only the first throttle setting works.
	      throttleType = brushOption.throttleType;
	      throttleDelay = brushOption.throttleDelay;
	    } // Add boundingRect and selectors to range.
	
	
	    var areas = zrUtil.map(brushModel.areas, function (area) {
	      return bindSelector(zrUtil.defaults({
	        boundingRect: boundingRectBuilders[area.brushType](area)
	      }, area));
	    });
	    var visualMappings = visualSolution.createVisualMappings(brushModel.option, STATE_LIST, function (mappingOption) {
	      mappingOption.mappingMethod = 'fixed';
	    });
	    zrUtil.isArray(brushLink) && zrUtil.each(brushLink, function (seriesIndex) {
	      linkedSeriesMap[seriesIndex] = 1;
	    });
	
	    function linkOthers(seriesIndex) {
	      return brushLink === 'all' || linkedSeriesMap[seriesIndex];
	    } // If no supported brush or no brush on the series,
	    // all visuals should be in original state.
	
	
	    function brushed(rangeInfoList) {
	      return !!rangeInfoList.length;
	    }
	    /**
	     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
	     *
	     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
	     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
	     *                └!hasBrushExist┘                                              └nothing.
	     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
	     *                └!hasBrushExist┘                                              └nothing.
	     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
	     *   !brushed┘                                                                  └nothing.
	     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
	     */
	    // Step A
	
	
	    ecModel.eachSeries(function (seriesModel, seriesIndex) {
	      var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
	      seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex, rangeInfoList) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
	    });
	
	    function stepAParallel(seriesModel, seriesIndex) {
	      var coordSys = seriesModel.coordinateSystem;
	      hasBrushExists |= coordSys.hasAxisBrushed();
	      linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function (activeState, dataIndex) {
	        activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
	      });
	    }
	
	    function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
	      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
	
	      if (!selectorsByBrushType || brushModelNotControll(brushModel, seriesIndex)) {
	        return;
	      }
	
	      zrUtil.each(areas, function (area) {
	        selectorsByBrushType[area.brushType] && brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel) && rangeInfoList.push(area);
	        hasBrushExists |= brushed(rangeInfoList);
	      });
	
	      if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
	        var data = seriesModel.getData();
	        data.each(function (dataIndex) {
	          if (checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex)) {
	            selectedDataIndexForLink[dataIndex] = 1;
	          }
	        });
	      }
	    } // Step B
	
	
	    ecModel.eachSeries(function (seriesModel, seriesIndex) {
	      var seriesBrushSelected = {
	        seriesId: seriesModel.id,
	        seriesIndex: seriesIndex,
	        seriesName: seriesModel.name,
	        dataIndex: []
	      }; // Every series exists in event params, convenient
	      // for user to find series by seriesIndex.
	
	      thisBrushSelected.selected.push(seriesBrushSelected);
	      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
	      var rangeInfoList = rangeInfoBySeries[seriesIndex];
	      var data = seriesModel.getData();
	      var getValueState = linkOthers(seriesIndex) ? function (dataIndex) {
	        return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	      } : function (dataIndex) {
	        return checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	      }; // If no supported brush or no brush, all visuals are in original state.
	
	      (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && visualSolution.applyVisual(STATE_LIST, visualMappings, data, getValueState);
	    });
	  });
	  dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
	});
	
	function dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
	  // This event will not be triggered when `setOpion`, otherwise dead lock may
	  // triggered when do `setOption` in event listener, which we do not find
	  // satisfactory way to solve yet. Some considered resolutions:
	  // (a) Diff with prevoius selected data ant only trigger event when changed.
	  // But store previous data and diff precisely (i.e., not only by dataIndex, but
	  // also detect value changes in selected data) might bring complexity or fragility.
	  // (b) Use spectial param like `silent` to suppress event triggering.
	  // But such kind of volatile param may be weird in `setOption`.
	  if (!payload) {
	    return;
	  }
	
	  var zr = api.getZr();
	
	  if (zr[DISPATCH_FLAG]) {
	    return;
	  }
	
	  if (!zr[DISPATCH_METHOD]) {
	    zr[DISPATCH_METHOD] = doDispatch;
	  }
	
	  var fn = throttleUtil.createOrUpdate(zr, DISPATCH_METHOD, throttleDelay, throttleType);
	  fn(api, brushSelected);
	}
	
	function doDispatch(api, brushSelected) {
	  if (!api.isDisposed()) {
	    var zr = api.getZr();
	    zr[DISPATCH_FLAG] = true;
	    api.dispatchAction({
	      type: 'brushSelect',
	      batch: brushSelected
	    });
	    zr[DISPATCH_FLAG] = false;
	  }
	}
	
	function checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) {
	  for (var i = 0, len = rangeInfoList.length; i < len; i++) {
	    var area = rangeInfoList[i];
	
	    if (selectorsByBrushType[area.brushType](dataIndex, data, area.selectors, area)) {
	      return true;
	    }
	  }
	}
	
	function getSelectorsByBrushType(seriesModel) {
	  var brushSelector = seriesModel.brushSelector;
	
	  if (zrUtil.isString(brushSelector)) {
	    var sels = [];
	    zrUtil.each(selector, function (selectorsByElementType, brushType) {
	      sels[brushType] = function (dataIndex, data, selectors, area) {
	        var itemLayout = data.getItemLayout(dataIndex);
	        return selectorsByElementType[brushSelector](itemLayout, selectors, area);
	      };
	    });
	    return sels;
	  } else if (zrUtil.isFunction(brushSelector)) {
	    var bSelector = {};
	    zrUtil.each(selector, function (sel, brushType) {
	      bSelector[brushType] = brushSelector;
	    });
	    return bSelector;
	  }
	
	  return brushSelector;
	}
	
	function brushModelNotControll(brushModel, seriesIndex) {
	  var seriesIndices = brushModel.option.seriesIndex;
	  return seriesIndices != null && seriesIndices !== 'all' && (zrUtil.isArray(seriesIndices) ? zrUtil.indexOf(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
	}
	
	function bindSelector(area) {
	  var selectors = area.selectors = {};
	  zrUtil.each(selector[area.brushType], function (selFn, elType) {
	    // Do not use function binding or curry for performance.
	    selectors[elType] = function (itemLayout) {
	      return selFn(itemLayout, selectors, area);
	    };
	  });
	  return area;
	}
	
	var boundingRectBuilders = {
	  lineX: zrUtil.noop,
	  lineY: zrUtil.noop,
	  rect: function (area) {
	    return getBoundingRectFromMinMax(area.range);
	  },
	  polygon: function (area) {
	    var minMax;
	    var range = area.range;
	
	    for (var i = 0, len = range.length; i < len; i++) {
	      minMax = minMax || [[Infinity, -Infinity], [Infinity, -Infinity]];
	      var rg = range[i];
	      rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
	      rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
	      rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
	      rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
	    }
	
	    return minMax && getBoundingRectFromMinMax(minMax);
	  }
	};
	
	function getBoundingRectFromMinMax(minMax) {
	  return new BoundingRect(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
	}
	
	exports.layoutCovers = layoutCovers;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var VisualMapping = __webpack_require__(468);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Visual solution, for consistent option specification.
	 */
	var each = zrUtil.each;
	
	function hasKeys(obj) {
	  if (obj) {
	    for (var name in obj) {
	      if (obj.hasOwnProperty(name)) {
	        return true;
	      }
	    }
	  }
	}
	/**
	 * @param {Object} option
	 * @param {Array.<string>} stateList
	 * @param {Function} [supplementVisualOption]
	 * @return {Object} visualMappings <state, <visualType, module:echarts/visual/VisualMapping>>
	 */
	
	
	function createVisualMappings(option, stateList, supplementVisualOption) {
	  var visualMappings = {};
	  each(stateList, function (state) {
	    var mappings = visualMappings[state] = createMappings();
	    each(option[state], function (visualData, visualType) {
	      if (!VisualMapping.isValidType(visualType)) {
	        return;
	      }
	
	      var mappingOption = {
	        type: visualType,
	        visual: visualData
	      };
	      supplementVisualOption && supplementVisualOption(mappingOption, state);
	      mappings[visualType] = new VisualMapping(mappingOption); // Prepare a alpha for opacity, for some case that opacity
	      // is not supported, such as rendering using gradient color.
	
	      if (visualType === 'opacity') {
	        mappingOption = zrUtil.clone(mappingOption);
	        mappingOption.type = 'colorAlpha';
	        mappings.__hidden.__alphaForOpacity = new VisualMapping(mappingOption);
	      }
	    });
	  });
	  return visualMappings;
	
	  function createMappings() {
	    var Creater = function () {}; // Make sure hidden fields will not be visited by
	    // object iteration (with hasOwnProperty checking).
	
	
	    Creater.prototype.__hidden = Creater.prototype;
	    var obj = new Creater();
	    return obj;
	  }
	}
	/**
	 * @param {Object} thisOption
	 * @param {Object} newOption
	 * @param {Array.<string>} keys
	 */
	
	
	function replaceVisualOption(thisOption, newOption, keys) {
	  // Visual attributes merge is not supported, otherwise it
	  // brings overcomplicated merge logic. See #2853. So if
	  // newOption has anyone of these keys, all of these keys
	  // will be reset. Otherwise, all keys remain.
	  var has;
	  zrUtil.each(keys, function (key) {
	    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	      has = true;
	    }
	  });
	  has && zrUtil.each(keys, function (key) {
	    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	      thisOption[key] = zrUtil.clone(newOption[key]);
	    } else {
	      delete thisOption[key];
	    }
	  });
	}
	/**
	 * @param {Array.<string>} stateList
	 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
	 * @param {module:echarts/data/List} list
	 * @param {Function} getValueState param: valueOrIndex, return: state.
	 * @param {object} [scope] Scope for getValueState
	 * @param {string} [dimension] Concrete dimension, if used.
	 */
	// ???! handle brush?
	
	
	function applyVisual(stateList, visualMappings, data, getValueState, scope, dimension) {
	  var visualTypesMap = {};
	  zrUtil.each(stateList, function (state) {
	    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	    visualTypesMap[state] = visualTypes;
	  });
	  var dataIndex;
	
	  function getVisual(key) {
	    return data.getItemVisual(dataIndex, key);
	  }
	
	  function setVisual(key, value) {
	    data.setItemVisual(dataIndex, key, value);
	  }
	
	  if (dimension == null) {
	    data.each(eachItem);
	  } else {
	    data.each([dimension], eachItem);
	  }
	
	  function eachItem(valueOrIndex, index) {
	    dataIndex = dimension == null ? valueOrIndex : index;
	    var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	
	    if (rawDataItem && rawDataItem.visualMap === false) {
	      return;
	    }
	
	    var valueState = getValueState.call(scope, valueOrIndex);
	    var mappings = visualMappings[valueState];
	    var visualTypes = visualTypesMap[valueState];
	
	    for (var i = 0, len = visualTypes.length; i < len; i++) {
	      var type = visualTypes[i];
	      mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
	    }
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Array.<string>} stateList
	 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
	 * @param {Function} getValueState param: valueOrIndex, return: state.
	 * @param {number} [dim] dimension or dimension index.
	 */
	
	
	function incrementalApplyVisual(stateList, visualMappings, getValueState, dim) {
	  var visualTypesMap = {};
	  zrUtil.each(stateList, function (state) {
	    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	    visualTypesMap[state] = visualTypes;
	  });
	
	  function progress(params, data) {
	    if (dim != null) {
	      dim = data.getDimension(dim);
	    }
	
	    function getVisual(key) {
	      return data.getItemVisual(dataIndex, key);
	    }
	
	    function setVisual(key, value) {
	      data.setItemVisual(dataIndex, key, value);
	    }
	
	    var dataIndex;
	
	    while ((dataIndex = params.next()) != null) {
	      var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	
	      if (rawDataItem && rawDataItem.visualMap === false) {
	        continue;
	      }
	
	      var value = dim != null ? data.get(dim, dataIndex, true) : dataIndex;
	      var valueState = getValueState(value);
	      var mappings = visualMappings[valueState];
	      var visualTypes = visualTypesMap[valueState];
	
	      for (var i = 0, len = visualTypes.length; i < len; i++) {
	        var type = visualTypes[i];
	        mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
	      }
	    }
	  }
	
	  return {
	    progress: progress
	  };
	}
	
	exports.createVisualMappings = createVisualMappings;
	exports.replaceVisualOption = replaceVisualOption;
	exports.applyVisual = applyVisual;
	exports.incrementalApplyVisual = incrementalApplyVisual;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var polygonContain = __webpack_require__(363);
	
	var BoundingRect = __webpack_require__(242);
	
	var _graphic = __webpack_require__(268);
	
	var linePolygonIntersect = _graphic.linePolygonIntersect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Key of the first level is brushType: `line`, `rect`, `polygon`.
	// Key of the second level is chart element type: `point`, `rect`.
	// See moudule:echarts/component/helper/BrushController
	// function param:
	//      {Object} itemLayout fetch from data.getItemLayout(dataIndex)
	//      {Object} selectors {point: selector, rect: selector, ...}
	//      {Object} area {range: [[], [], ..], boudingRect}
	// function return:
	//      {boolean} Whether in the given brush.
	var selector = {
	  lineX: getLineSelectors(0),
	  lineY: getLineSelectors(1),
	  rect: {
	    point: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
	    },
	    rect: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.intersect(itemLayout);
	    }
	  },
	  polygon: {
	    point: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && polygonContain.contain(area.range, itemLayout[0], itemLayout[1]);
	    },
	    rect: function (itemLayout, selectors, area) {
	      var points = area.range;
	
	      if (!itemLayout || points.length <= 1) {
	        return false;
	      }
	
	      var x = itemLayout.x;
	      var y = itemLayout.y;
	      var width = itemLayout.width;
	      var height = itemLayout.height;
	      var p = points[0];
	
	      if (polygonContain.contain(points, x, y) || polygonContain.contain(points, x + width, y) || polygonContain.contain(points, x, y + height) || polygonContain.contain(points, x + width, y + height) || BoundingRect.create(itemLayout).contain(p[0], p[1]) || linePolygonIntersect(x, y, x + width, y, points) || linePolygonIntersect(x, y, x, y + height, points) || linePolygonIntersect(x + width, y, x + width, y + height, points) || linePolygonIntersect(x, y + height, x + width, y + height, points)) {
	        return true;
	      }
	    }
	  }
	};
	
	function getLineSelectors(xyIndex) {
	  var xy = ['x', 'y'];
	  var wh = ['width', 'height'];
	  return {
	    point: function (itemLayout, selectors, area) {
	      if (itemLayout) {
	        var range = area.range;
	        var p = itemLayout[xyIndex];
	        return inLineRange(p, range);
	      }
	    },
	    rect: function (itemLayout, selectors, area) {
	      if (itemLayout) {
	        var range = area.range;
	        var layoutRange = [itemLayout[xy[xyIndex]], itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]];
	        layoutRange[1] < layoutRange[0] && layoutRange.reverse();
	        return inLineRange(layoutRange[0], range) || inLineRange(layoutRange[1], range) || inLineRange(range[0], layoutRange) || inLineRange(range[1], layoutRange);
	      }
	    }
	  };
	}
	
	function inLineRange(p, range) {
	  return range[0] <= p && p <= range[1];
	}
	
	var _default = selector;
	module.exports = _default;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var visualSolution = __webpack_require__(642);
	
	var Model = __webpack_require__(262);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_OUT_OF_BRUSH_COLOR = ['#ddd'];
	var BrushModel = echarts.extendComponentModel({
	  type: 'brush',
	  dependencies: ['geo', 'grid', 'xAxis', 'yAxis', 'parallel', 'series'],
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    // inBrush: null,
	    // outOfBrush: null,
	    toolbox: null,
	    // Default value see preprocessor.
	    brushLink: null,
	    // Series indices array, broadcast using dataIndex.
	    // or 'all', which means all series. 'none' or null means no series.
	    seriesIndex: 'all',
	    // seriesIndex array, specify series controlled by this brush component.
	    geoIndex: null,
	    //
	    xAxisIndex: null,
	    yAxisIndex: null,
	    brushType: 'rect',
	    // Default brushType, see BrushController.
	    brushMode: 'single',
	    // Default brushMode, 'single' or 'multiple'
	    transformable: true,
	    // Default transformable.
	    brushStyle: {
	      // Default brushStyle
	      borderWidth: 1,
	      color: 'rgba(120,140,180,0.3)',
	      borderColor: 'rgba(120,140,180,0.8)'
	    },
	    throttleType: 'fixRate',
	    // Throttle in brushSelected event. 'fixRate' or 'debounce'.
	    // If null, no throttle. Valid only in the first brush component
	    throttleDelay: 0,
	    // Unit: ms, 0 means every event will be triggered.
	    // FIXME
	    // 试验效果
	    removeOnClick: true,
	    z: 10000
	  },
	
	  /**
	   * @readOnly
	   * @type {Array.<Object>}
	   */
	  areas: [],
	
	  /**
	   * Current activated brush type.
	   * If null, brush is inactived.
	   * see module:echarts/component/helper/BrushController
	   * @readOnly
	   * @type {string}
	   */
	  brushType: null,
	
	  /**
	   * Current brush opt.
	   * see module:echarts/component/helper/BrushController
	   * @readOnly
	   * @type {Object}
	   */
	  brushOption: {},
	
	  /**
	   * @readOnly
	   * @type {Array.<Object>}
	   */
	  coordInfoList: [],
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option;
	    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, ['inBrush', 'outOfBrush']);
	    var inBrush = thisOption.inBrush = thisOption.inBrush || {}; // Always give default visual, consider setOption at the second time.
	
	    thisOption.outOfBrush = thisOption.outOfBrush || {
	      color: DEFAULT_OUT_OF_BRUSH_COLOR
	    };
	
	    if (!inBrush.hasOwnProperty('liftZ')) {
	      // Bigger than the highlight z lift, otherwise it will
	      // be effected by the highlight z when brush.
	      inBrush.liftZ = 5;
	    }
	  },
	
	  /**
	   * If ranges is null/undefined, range state remain.
	   *
	   * @param {Array.<Object>} [ranges]
	   */
	  setAreas: function (areas) {
	    // If ranges is null/undefined, range state remain.
	    // This helps user to dispatchAction({type: 'brush'}) with no areas
	    // set but just want to get the current brush select info from a `brush` event.
	    if (!areas) {
	      return;
	    }
	
	    this.areas = zrUtil.map(areas, function (area) {
	      return generateBrushOption(this.option, area);
	    }, this);
	  },
	
	  /**
	   * see module:echarts/component/helper/BrushController
	   * @param {Object} brushOption
	   */
	  setBrushOption: function (brushOption) {
	    this.brushOption = generateBrushOption(this.option, brushOption);
	    this.brushType = this.brushOption.brushType;
	  }
	});
	
	function generateBrushOption(option, brushOption) {
	  return zrUtil.merge({
	    brushType: option.brushType,
	    brushMode: option.brushMode,
	    transformable: option.transformable,
	    brushStyle: new Model(option.brushStyle).getItemStyle(),
	    removeOnClick: option.removeOnClick,
	    z: option.z
	  }, brushOption, true);
	}
	
	var _default = BrushModel;
	module.exports = _default;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var BrushController = __webpack_require__(513);
	
	var _visualEncoding = __webpack_require__(641);
	
	var layoutCovers = _visualEncoding.layoutCovers;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'brush',
	  init: function (ecModel, api) {
	    /**
	     * @readOnly
	     * @type {module:echarts/model/Global}
	     */
	    this.ecModel = ecModel;
	    /**
	     * @readOnly
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this.api = api;
	    /**
	     * @readOnly
	     * @type {module:echarts/component/brush/BrushModel}
	     */
	
	    this.model;
	    /**
	     * @private
	     * @type {module:echarts/component/helper/BrushController}
	     */
	
	    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
	  },
	
	  /**
	   * @override
	   */
	  render: function (brushModel) {
	    this.model = brushModel;
	    return updateController.apply(this, arguments);
	  },
	
	  /**
	   * @override
	   */
	  updateTransform: function (brushModel, ecModel) {
	    // PENDING: `updateTransform` is a little tricky, whose layout need
	    // to be calculate mandatorily and other stages will not be performed.
	    // Take care the correctness of the logic. See #11754 .
	    layoutCovers(ecModel);
	    return updateController.apply(this, arguments);
	  },
	
	  /**
	   * @override
	   */
	  updateView: updateController,
	  // /**
	  //  * @override
	  //  */
	  // updateLayout: updateController,
	  // /**
	  //  * @override
	  //  */
	  // updateVisual: updateController,
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._brushController.dispose();
	  },
	
	  /**
	   * @private
	   */
	  _onBrush: function (areas, opt) {
	    var modelId = this.model.id;
	    this.model.brushTargetManager.setOutputRanges(areas, this.ecModel); // Action is not dispatched on drag end, because the drag end
	    // emits the same params with the last drag move event, and
	    // may have some delay when using touch pad, which makes
	    // animation not smooth (when using debounce).
	
	    (!opt.isEnd || opt.removeOnClick) && this.api.dispatchAction({
	      type: 'brush',
	      brushId: modelId,
	      areas: zrUtil.clone(areas),
	      $from: modelId
	    });
	    opt.isEnd && this.api.dispatchAction({
	      type: 'brushEnd',
	      brushId: modelId,
	      areas: zrUtil.clone(areas),
	      $from: modelId
	    });
	  }
	});
	
	function updateController(brushModel, ecModel, api, payload) {
	  // Do not update controller when drawing.
	  (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
	}
	
	module.exports = _default;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * payload: {
	 *      brushIndex: number, or,
	 *      brushId: string, or,
	 *      brushName: string,
	 *      globalRanges: Array
	 * }
	 */
	echarts.registerAction({
	  type: 'brush',
	  event: 'brush'
	  /*, update: 'updateView' */
	
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'brush',
	    query: payload
	  }, function (brushModel) {
	    brushModel.setAreas(payload.areas);
	  });
	});
	/**
	 * payload: {
	 *      brushComponents: [
	 *          {
	 *              brushId,
	 *              brushIndex,
	 *              brushName,
	 *              series: [
	 *                  {
	 *                      seriesId,
	 *                      seriesIndex,
	 *                      seriesName,
	 *                      rawIndices: [21, 34, ...]
	 *                  },
	 *                  ...
	 *              ]
	 *          },
	 *          ...
	 *      ]
	 * }
	 */
	
	echarts.registerAction({
	  type: 'brushSelect',
	  event: 'brushSelected',
	  update: 'none'
	}, function () {});
	echarts.registerAction({
	  type: 'brushEnd',
	  event: 'brushEnd',
	  update: 'none'
	}, function () {});

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var featureManager = __webpack_require__(614);
	
	var lang = __webpack_require__(330);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var brushLang = lang.toolbox.brush;
	
	function Brush(model, ecModel, api) {
	  this.model = model;
	  this.ecModel = ecModel;
	  this.api = api;
	  /**
	   * @private
	   * @type {string}
	   */
	
	  this._brushType;
	  /**
	   * @private
	   * @type {string}
	   */
	
	  this._brushMode;
	}
	
	Brush.defaultOption = {
	  show: true,
	  type: ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'],
	  icon: {
	    /* eslint-disable */
	    rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
	    // jshint ignore:line
	    polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
	    // jshint ignore:line
	    lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
	    // jshint ignore:line
	    lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
	    // jshint ignore:line
	    keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
	    // jshint ignore:line
	    clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line
	
	    /* eslint-enable */
	
	  },
	  // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
	  title: zrUtil.clone(brushLang.title)
	};
	var proto = Brush.prototype; // proto.updateLayout = function (featureModel, ecModel, api) {
	
	/* eslint-disable */
	
	proto.render =
	/* eslint-enable */
	proto.updateView = function (featureModel, ecModel, api) {
	  var brushType;
	  var brushMode;
	  var isBrushed;
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    brushType = brushModel.brushType;
	    brushMode = brushModel.brushOption.brushMode || 'single';
	    isBrushed |= brushModel.areas.length;
	  });
	  this._brushType = brushType;
	  this._brushMode = brushMode;
	  zrUtil.each(featureModel.get('type', true), function (type) {
	    featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
	  });
	};
	
	proto.getIcons = function () {
	  var model = this.model;
	  var availableIcons = model.get('icon', true);
	  var icons = {};
	  zrUtil.each(model.get('type', true), function (type) {
	    if (availableIcons[type]) {
	      icons[type] = availableIcons[type];
	    }
	  });
	  return icons;
	};
	
	proto.onclick = function (ecModel, api, type) {
	  var brushType = this._brushType;
	  var brushMode = this._brushMode;
	
	  if (type === 'clear') {
	    // Trigger parallel action firstly
	    api.dispatchAction({
	      type: 'axisAreaSelect',
	      intervals: []
	    });
	    api.dispatchAction({
	      type: 'brush',
	      command: 'clear',
	      // Clear all areas of all brush components.
	      areas: []
	    });
	  } else {
	    api.dispatchAction({
	      type: 'takeGlobalCursor',
	      key: 'brush',
	      brushOption: {
	        brushType: type === 'keep' ? brushType : brushType === type ? false : type,
	        brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
	      }
	    });
	  }
	};
	
	featureManager.register('brush', Brush);
	var _default = Brush;
	module.exports = _default;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var echarts = __webpack_require__(215);
	
	var graphic = __webpack_require__(268);
	
	var _layout = __webpack_require__(305);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _format = __webpack_require__(307);
	
	var windowOpen = _format.windowOpen;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Model
	echarts.extendComponentModel({
	  type: 'title',
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 6,
	    show: true,
	    text: '',
	    // 超链接跳转
	    // link: null,
	    // 仅支持self | blank
	    target: 'blank',
	    subtext: '',
	    // 超链接跳转
	    // sublink: null,
	    // 仅支持self | blank
	    subtarget: 'blank',
	    // 'center' ¦ 'left' ¦ 'right'
	    // ¦ {number}（x坐标，单位px）
	    left: 0,
	    // 'top' ¦ 'bottom' ¦ 'center'
	    // ¦ {number}（y坐标，单位px）
	    top: 0,
	    // 水平对齐
	    // 'auto' | 'left' | 'right' | 'center'
	    // 默认根据 left 的位置判断是左对齐还是右对齐
	    // textAlign: null
	    //
	    // 垂直对齐
	    // 'auto' | 'top' | 'bottom' | 'middle'
	    // 默认根据 top 位置判断是上对齐还是下对齐
	    // textVerticalAlign: null
	    // textBaseline: null // The same as textVerticalAlign.
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 标题边框颜色
	    borderColor: '#ccc',
	    // 标题边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 标题内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // 主副标题纵向间隔，单位px，默认为10，
	    itemGap: 10,
	    textStyle: {
	      fontSize: 18,
	      fontWeight: 'bolder',
	      color: '#333'
	    },
	    subtextStyle: {
	      color: '#aaa'
	    }
	  }
	}); // View
	
	echarts.extendComponentView({
	  type: 'title',
	  render: function (titleModel, ecModel, api) {
	    this.group.removeAll();
	
	    if (!titleModel.get('show')) {
	      return;
	    }
	
	    var group = this.group;
	    var textStyleModel = titleModel.getModel('textStyle');
	    var subtextStyleModel = titleModel.getModel('subtextStyle');
	    var textAlign = titleModel.get('textAlign');
	    var textVerticalAlign = zrUtil.retrieve2(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
	    var textEl = new graphic.Text({
	      style: graphic.setTextStyle({}, textStyleModel, {
	        text: titleModel.get('text'),
	        textFill: textStyleModel.getTextColor()
	      }, {
	        disableBox: true
	      }),
	      z2: 10
	    });
	    var textRect = textEl.getBoundingRect();
	    var subText = titleModel.get('subtext');
	    var subTextEl = new graphic.Text({
	      style: graphic.setTextStyle({}, subtextStyleModel, {
	        text: subText,
	        textFill: subtextStyleModel.getTextColor(),
	        y: textRect.height + titleModel.get('itemGap'),
	        textVerticalAlign: 'top'
	      }, {
	        disableBox: true
	      }),
	      z2: 10
	    });
	    var link = titleModel.get('link');
	    var sublink = titleModel.get('sublink');
	    var triggerEvent = titleModel.get('triggerEvent', true);
	    textEl.silent = !link && !triggerEvent;
	    subTextEl.silent = !sublink && !triggerEvent;
	
	    if (link) {
	      textEl.on('click', function () {
	        windowOpen(link, '_' + titleModel.get('target'));
	      });
	    }
	
	    if (sublink) {
	      subTextEl.on('click', function () {
	        windowOpen(sublink, '_' + titleModel.get('subtarget'));
	      });
	    }
	
	    textEl.eventData = subTextEl.eventData = triggerEvent ? {
	      componentType: 'title',
	      componentIndex: titleModel.componentIndex
	    } : null;
	    group.add(textEl);
	    subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.
	
	    var groupRect = group.getBoundingRect();
	    var layoutOption = titleModel.getBoxLayoutParams();
	    layoutOption.width = groupRect.width;
	    layoutOption.height = groupRect.height;
	    var layoutRect = getLayoutRect(layoutOption, {
	      width: api.getWidth(),
	      height: api.getHeight()
	    }, titleModel.get('padding')); // Adjust text align based on position
	
	    if (!textAlign) {
	      // Align left if title is on the left. center and right is same
	      textAlign = titleModel.get('left') || titleModel.get('right');
	
	      if (textAlign === 'middle') {
	        textAlign = 'center';
	      } // Adjust layout by text align
	
	
	      if (textAlign === 'right') {
	        layoutRect.x += layoutRect.width;
	      } else if (textAlign === 'center') {
	        layoutRect.x += layoutRect.width / 2;
	      }
	    }
	
	    if (!textVerticalAlign) {
	      textVerticalAlign = titleModel.get('top') || titleModel.get('bottom');
	
	      if (textVerticalAlign === 'center') {
	        textVerticalAlign = 'middle';
	      }
	
	      if (textVerticalAlign === 'bottom') {
	        layoutRect.y += layoutRect.height;
	      } else if (textVerticalAlign === 'middle') {
	        layoutRect.y += layoutRect.height / 2;
	      }
	
	      textVerticalAlign = textVerticalAlign || 'top';
	    }
	
	    group.attr('position', [layoutRect.x, layoutRect.y]);
	    var alignStyle = {
	      textAlign: textAlign,
	      textVerticalAlign: textVerticalAlign
	    };
	    textEl.setStyle(alignStyle);
	    subTextEl.setStyle(alignStyle); // Render background
	    // Get groupRect again because textAlign has been changed
	
	    groupRect = group.getBoundingRect();
	    var padding = layoutRect.margin;
	    var style = titleModel.getItemStyle(['color', 'opacity']);
	    style.fill = titleModel.get('backgroundColor');
	    var rect = new graphic.Rect({
	      shape: {
	        x: groupRect.x - padding[3],
	        y: groupRect.y - padding[0],
	        width: groupRect.width + padding[1] + padding[3],
	        height: groupRect.height + padding[0] + padding[2],
	        r: titleModel.get('borderRadius')
	      },
	      style: style,
	      subPixelOptimize: true,
	      silent: true
	    });
	    group.add(rect);
	  }
	});

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var preprocessor = __webpack_require__(650);
	
	__webpack_require__(651);
	
	__webpack_require__(652);
	
	__webpack_require__(653);
	
	__webpack_require__(655);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  var timelineOpt = option && option.timeline;
	
	  if (!zrUtil.isArray(timelineOpt)) {
	    timelineOpt = timelineOpt ? [timelineOpt] : [];
	  }
	
	  zrUtil.each(timelineOpt, function (opt) {
	    if (!opt) {
	      return;
	    }
	
	    compatibleEC2(opt);
	  });
	}
	
	function compatibleEC2(opt) {
	  var type = opt.type;
	  var ec2Types = {
	    'number': 'value',
	    'time': 'time'
	  }; // Compatible with ec2
	
	  if (ec2Types[type]) {
	    opt.axisType = ec2Types[type];
	    delete opt.type;
	  }
	
	  transferItem(opt);
	
	  if (has(opt, 'controlPosition')) {
	    var controlStyle = opt.controlStyle || (opt.controlStyle = {});
	
	    if (!has(controlStyle, 'position')) {
	      controlStyle.position = opt.controlPosition;
	    }
	
	    if (controlStyle.position === 'none' && !has(controlStyle, 'show')) {
	      controlStyle.show = false;
	      delete controlStyle.position;
	    }
	
	    delete opt.controlPosition;
	  }
	
	  zrUtil.each(opt.data || [], function (dataItem) {
	    if (zrUtil.isObject(dataItem) && !zrUtil.isArray(dataItem)) {
	      if (!has(dataItem, 'value') && has(dataItem, 'name')) {
	        // In ec2, using name as value.
	        dataItem.value = dataItem.name;
	      }
	
	      transferItem(dataItem);
	    }
	  });
	}
	
	function transferItem(opt) {
	  var itemStyle = opt.itemStyle || (opt.itemStyle = {});
	  var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {}); // Transfer label out
	
	  var label = opt.label || opt.label || {};
	  var labelNormal = label.normal || (label.normal = {});
	  var excludeLabelAttr = {
	    normal: 1,
	    emphasis: 1
	  };
	  zrUtil.each(label, function (value, name) {
	    if (!excludeLabelAttr[name] && !has(labelNormal, name)) {
	      labelNormal[name] = value;
	    }
	  });
	
	  if (itemStyleEmphasis.label && !has(label, 'emphasis')) {
	    label.emphasis = itemStyleEmphasis.label;
	    delete itemStyleEmphasis.label;
	  }
	}
	
	function has(obj, attr) {
	  return obj.hasOwnProperty(attr);
	}
	
	module.exports = _default;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(303);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('timeline', function () {
	  // Only slider now.
	  return 'slider';
	});

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'timelineChange',
	  event: 'timelineChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  var timelineModel = ecModel.getComponent('timeline');
	
	  if (timelineModel && payload.currentIndex != null) {
	    timelineModel.setCurrentIndex(payload.currentIndex);
	
	    if (!timelineModel.get('loop', true) && timelineModel.isIndexMax()) {
	      timelineModel.setPlayState(false);
	    }
	  } // Set normalized currentIndex to payload.
	
	
	  ecModel.resetOption('timeline');
	  return zrUtil.defaults({
	    currentIndex: timelineModel.option.currentIndex
	  }, payload);
	});
	echarts.registerAction({
	  type: 'timelinePlayChange',
	  event: 'timelinePlayChanged',
	  update: 'update'
	}, function (payload, ecModel) {
	  var timelineModel = ecModel.getComponent('timeline');
	
	  if (timelineModel && payload.playState != null) {
	    timelineModel.setPlayState(payload.playState);
	  }
	});

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var TimelineModel = __webpack_require__(654);
	
	var dataFormatMixin = __webpack_require__(321);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SliderTimelineModel = TimelineModel.extend({
	  type: 'timeline.slider',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 时间轴背景颜色
	    borderColor: '#ccc',
	    // 时间轴边框颜色
	    borderWidth: 0,
	    // 时间轴边框线宽，单位px，默认为0（无边框）
	    orient: 'horizontal',
	    // 'vertical'
	    inverse: false,
	    tooltip: {
	      // boolean or Object
	      trigger: 'item' // data item may also have tootip attr.
	
	    },
	    symbol: 'emptyCircle',
	    symbolSize: 10,
	    lineStyle: {
	      show: true,
	      width: 2,
	      color: '#304654'
	    },
	    label: {
	      // 文本标签
	      position: 'auto',
	      // auto left right top bottom
	      // When using number, label position is not
	      // restricted by viewRect.
	      // positive: right/bottom, negative: left/top
	      show: true,
	      interval: 'auto',
	      rotate: 0,
	      // formatter: null,
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: '#304654'
	    },
	    itemStyle: {
	      color: '#304654',
	      borderWidth: 1
	    },
	    checkpointStyle: {
	      symbol: 'circle',
	      symbolSize: 13,
	      color: '#c23531',
	      borderWidth: 5,
	      borderColor: 'rgba(194,53,49, 0.5)',
	      animation: true,
	      animationDuration: 300,
	      animationEasing: 'quinticInOut'
	    },
	    controlStyle: {
	      show: true,
	      showPlayBtn: true,
	      showPrevBtn: true,
	      showNextBtn: true,
	      itemSize: 22,
	      itemGap: 12,
	      position: 'left',
	      // 'left' 'right' 'top' 'bottom'
	      playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
	      // jshint ignore:line
	      stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
	      // jshint ignore:line
	      nextIcon: 'path://M18.6,50.8l22.5-22.5c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7L18.7,4.4c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.4,0.3-0.8,0.8-0.8c0.2,0,0.5,0.1,0.6,0.3l23.5,23.5l0,0c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7l-0.1,0.1L19.7,52 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.8-0.3-0.8-0.8C18.4,51.2,18.5,51,18.6,50.8z',
	      // jshint ignore:line
	      prevIcon: 'path://M43,52.8L20.4,30.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7L42.9,6.4c0.1-0.1,0.2-0.3,0.2-0.5 c0-0.4-0.3-0.8-0.8-0.8c-0.2,0-0.5,0.1-0.6,0.3L18.3,28.8l0,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7l0.1,0.1L41.9,54 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.8-0.3,0.8-0.8C43.2,53.2,43.1,53,43,52.8z',
	      // jshint ignore:line
	      color: '#304654',
	      borderColor: '#304654',
	      borderWidth: 1
	    },
	    emphasis: {
	      label: {
	        show: true,
	        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	        color: '#c23531'
	      },
	      itemStyle: {
	        color: '#c23531'
	      },
	      controlStyle: {
	        color: '#c23531',
	        borderColor: '#c23531',
	        borderWidth: 2
	      }
	    },
	    data: []
	  }
	});
	zrUtil.mixin(SliderTimelineModel, dataFormatMixin);
	var _default = SliderTimelineModel;
	module.exports = _default;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var ComponentModel = __webpack_require__(303);
	
	var List = __webpack_require__(342);
	
	var modelUtil = __webpack_require__(261);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TimelineModel = ComponentModel.extend({
	  type: 'timeline',
	  layoutMode: 'box',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 4,
	    // 二级层叠
	    show: true,
	    axisType: 'time',
	    // 模式是时间类型，支持 value, category
	    realtime: true,
	    left: '20%',
	    top: null,
	    right: '20%',
	    bottom: 0,
	    width: null,
	    height: 40,
	    padding: 5,
	    controlPosition: 'left',
	    // 'left' 'right' 'top' 'bottom' 'none'
	    autoPlay: false,
	    rewind: false,
	    // 反向播放
	    loop: true,
	    playInterval: 2000,
	    // 播放时间间隔，单位ms
	    currentIndex: 0,
	    itemStyle: {},
	    label: {
	      color: '#000'
	    },
	    data: []
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * @private
	     * @type {module:echarts/data/List}
	     */
	    this._data;
	    /**
	     * @private
	     * @type {Array.<string>}
	     */
	
	    this._names;
	    this.mergeDefaultAndTheme(option, ecModel);
	
	    this._initData();
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option) {
	    TimelineModel.superApply(this, 'mergeOption', arguments);
	
	    this._initData();
	  },
	
	  /**
	   * @param {number} [currentIndex]
	   */
	  setCurrentIndex: function (currentIndex) {
	    if (currentIndex == null) {
	      currentIndex = this.option.currentIndex;
	    }
	
	    var count = this._data.count();
	
	    if (this.option.loop) {
	      currentIndex = (currentIndex % count + count) % count;
	    } else {
	      currentIndex >= count && (currentIndex = count - 1);
	      currentIndex < 0 && (currentIndex = 0);
	    }
	
	    this.option.currentIndex = currentIndex;
	  },
	
	  /**
	   * @return {number} currentIndex
	   */
	  getCurrentIndex: function () {
	    return this.option.currentIndex;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isIndexMax: function () {
	    return this.getCurrentIndex() >= this._data.count() - 1;
	  },
	
	  /**
	   * @param {boolean} state true: play, false: stop
	   */
	  setPlayState: function (state) {
	    this.option.autoPlay = !!state;
	  },
	
	  /**
	   * @return {boolean} true: play, false: stop
	   */
	  getPlayState: function () {
	    return !!this.option.autoPlay;
	  },
	
	  /**
	   * @private
	   */
	  _initData: function () {
	    var thisOption = this.option;
	    var dataArr = thisOption.data || [];
	    var axisType = thisOption.axisType;
	    var names = this._names = [];
	
	    if (axisType === 'category') {
	      var idxArr = [];
	      zrUtil.each(dataArr, function (item, index) {
	        var value = modelUtil.getDataItemValue(item);
	        var newItem;
	
	        if (zrUtil.isObject(item)) {
	          newItem = zrUtil.clone(item);
	          newItem.value = index;
	        } else {
	          newItem = index;
	        }
	
	        idxArr.push(newItem);
	
	        if (!zrUtil.isString(value) && (value == null || isNaN(value))) {
	          value = '';
	        }
	
	        names.push(value + '');
	      });
	      dataArr = idxArr;
	    }
	
	    var dimType = {
	      category: 'ordinal',
	      time: 'time'
	    }[axisType] || 'number';
	    var data = this._data = new List([{
	      name: 'value',
	      type: dimType
	    }], this);
	    data.initData(dataArr, names);
	  },
	  getData: function () {
	    return this._data;
	  },
	
	  /**
	   * @public
	   * @return {Array.<string>} categoreis
	   */
	  getCategories: function () {
	    if (this.get('axisType') === 'category') {
	      return this._names.slice();
	    }
	  }
	});
	var _default = TimelineModel;
	module.exports = _default;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var BoundingRect = __webpack_require__(242);
	
	var matrix = __webpack_require__(233);
	
	var graphic = __webpack_require__(268);
	
	var layout = __webpack_require__(305);
	
	var TimelineView = __webpack_require__(656);
	
	var TimelineAxis = __webpack_require__(657);
	
	var _symbol = __webpack_require__(360);
	
	var createSymbol = _symbol.createSymbol;
	
	var axisHelper = __webpack_require__(350);
	
	var numberUtil = __webpack_require__(306);
	
	var _format = __webpack_require__(307);
	
	var encodeHTML = _format.encodeHTML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var each = zrUtil.each;
	var PI = Math.PI;
	
	var _default = TimelineView.extend({
	  type: 'timeline.slider',
	  init: function (ecModel, api) {
	    this.api = api;
	    /**
	     * @private
	     * @type {module:echarts/component/timeline/TimelineAxis}
	     */
	
	    this._axis;
	    /**
	     * @private
	     * @type {module:zrender/core/BoundingRect}
	     */
	
	    this._viewRect;
	    /**
	     * @type {number}
	     */
	
	    this._timer;
	    /**
	     * @type {module:zrender/Element}
	     */
	
	    this._currentPointer;
	    /**
	     * @type {module:zrender/container/Group}
	     */
	
	    this._mainGroup;
	    /**
	     * @type {module:zrender/container/Group}
	     */
	
	    this._labelGroup;
	  },
	
	  /**
	   * @override
	   */
	  render: function (timelineModel, ecModel, api, payload) {
	    this.model = timelineModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    this.group.removeAll();
	
	    if (timelineModel.get('show', true)) {
	      var layoutInfo = this._layout(timelineModel, api);
	
	      var mainGroup = this._createGroup('mainGroup');
	
	      var labelGroup = this._createGroup('labelGroup');
	      /**
	       * @private
	       * @type {module:echarts/component/timeline/TimelineAxis}
	       */
	
	
	      var axis = this._axis = this._createAxis(layoutInfo, timelineModel);
	
	      timelineModel.formatTooltip = function (dataIndex) {
	        return encodeHTML(axis.scale.getLabel(dataIndex));
	      };
	
	      each(['AxisLine', 'AxisTick', 'Control', 'CurrentPointer'], function (name) {
	        this['_render' + name](layoutInfo, mainGroup, axis, timelineModel);
	      }, this);
	
	      this._renderAxisLabel(layoutInfo, labelGroup, axis, timelineModel);
	
	      this._position(layoutInfo, timelineModel);
	    }
	
	    this._doPlayStop();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearTimer();
	
	    this.group.removeAll();
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clearTimer();
	  },
	  _layout: function (timelineModel, api) {
	    var labelPosOpt = timelineModel.get('label.position');
	    var orient = timelineModel.get('orient');
	    var viewRect = getViewRect(timelineModel, api); // Auto label offset.
	
	    if (labelPosOpt == null || labelPosOpt === 'auto') {
	      labelPosOpt = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
	    } else if (isNaN(labelPosOpt)) {
	      labelPosOpt = {
	        horizontal: {
	          top: '-',
	          bottom: '+'
	        },
	        vertical: {
	          left: '-',
	          right: '+'
	        }
	      }[orient][labelPosOpt];
	    }
	
	    var labelAlignMap = {
	      horizontal: 'center',
	      vertical: labelPosOpt >= 0 || labelPosOpt === '+' ? 'left' : 'right'
	    };
	    var labelBaselineMap = {
	      horizontal: labelPosOpt >= 0 || labelPosOpt === '+' ? 'top' : 'bottom',
	      vertical: 'middle'
	    };
	    var rotationMap = {
	      horizontal: 0,
	      vertical: PI / 2
	    }; // Position
	
	    var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
	    var controlModel = timelineModel.getModel('controlStyle');
	    var showControl = controlModel.get('show', true);
	    var controlSize = showControl ? controlModel.get('itemSize') : 0;
	    var controlGap = showControl ? controlModel.get('itemGap') : 0;
	    var sizePlusGap = controlSize + controlGap; // Special label rotate.
	
	    var labelRotation = timelineModel.get('label.rotate') || 0;
	    labelRotation = labelRotation * PI / 180; // To radian.
	
	    var playPosition;
	    var prevBtnPosition;
	    var nextBtnPosition;
	    var axisExtent;
	    var controlPosition = controlModel.get('position', true);
	    var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
	    var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
	    var showNextBtn = showControl && controlModel.get('showNextBtn', true);
	    var xLeft = 0;
	    var xRight = mainLength; // position[0] means left, position[1] means middle.
	
	    if (controlPosition === 'left' || controlPosition === 'bottom') {
	      showPlayBtn && (playPosition = [0, 0], xLeft += sizePlusGap);
	      showPrevBtn && (prevBtnPosition = [xLeft, 0], xLeft += sizePlusGap);
	      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	    } else {
	      // 'top' 'right'
	      showPlayBtn && (playPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	      showPrevBtn && (prevBtnPosition = [0, 0], xLeft += sizePlusGap);
	      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	    }
	
	    axisExtent = [xLeft, xRight];
	
	    if (timelineModel.get('inverse')) {
	      axisExtent.reverse();
	    }
	
	    return {
	      viewRect: viewRect,
	      mainLength: mainLength,
	      orient: orient,
	      rotation: rotationMap[orient],
	      labelRotation: labelRotation,
	      labelPosOpt: labelPosOpt,
	      labelAlign: timelineModel.get('label.align') || labelAlignMap[orient],
	      labelBaseline: timelineModel.get('label.verticalAlign') || timelineModel.get('label.baseline') || labelBaselineMap[orient],
	      // Based on mainGroup.
	      playPosition: playPosition,
	      prevBtnPosition: prevBtnPosition,
	      nextBtnPosition: nextBtnPosition,
	      axisExtent: axisExtent,
	      controlSize: controlSize,
	      controlGap: controlGap
	    };
	  },
	  _position: function (layoutInfo, timelineModel) {
	    // Position is be called finally, because bounding rect is needed for
	    // adapt content to fill viewRect (auto adapt offset).
	    // Timeline may be not all in the viewRect when 'offset' is specified
	    // as a number, because it is more appropriate that label aligns at
	    // 'offset' but not the other edge defined by viewRect.
	    var mainGroup = this._mainGroup;
	    var labelGroup = this._labelGroup;
	    var viewRect = layoutInfo.viewRect;
	
	    if (layoutInfo.orient === 'vertical') {
	      // transform to horizontal, inverse rotate by left-top point.
	      var m = matrix.create();
	      var rotateOriginX = viewRect.x;
	      var rotateOriginY = viewRect.y + viewRect.height;
	      matrix.translate(m, m, [-rotateOriginX, -rotateOriginY]);
	      matrix.rotate(m, m, -PI / 2);
	      matrix.translate(m, m, [rotateOriginX, rotateOriginY]);
	      viewRect = viewRect.clone();
	      viewRect.applyTransform(m);
	    }
	
	    var viewBound = getBound(viewRect);
	    var mainBound = getBound(mainGroup.getBoundingRect());
	    var labelBound = getBound(labelGroup.getBoundingRect());
	    var mainPosition = mainGroup.position;
	    var labelsPosition = labelGroup.position;
	    labelsPosition[0] = mainPosition[0] = viewBound[0][0];
	    var labelPosOpt = layoutInfo.labelPosOpt;
	
	    if (isNaN(labelPosOpt)) {
	      // '+' or '-'
	      var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
	      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	      toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
	    } else {
	      var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
	      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	      labelsPosition[1] = mainPosition[1] + labelPosOpt;
	    }
	
	    mainGroup.attr('position', mainPosition);
	    labelGroup.attr('position', labelsPosition);
	    mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
	    setOrigin(mainGroup);
	    setOrigin(labelGroup);
	
	    function setOrigin(targetGroup) {
	      var pos = targetGroup.position;
	      targetGroup.origin = [viewBound[0][0] - pos[0], viewBound[1][0] - pos[1]];
	    }
	
	    function getBound(rect) {
	      // [[xmin, xmax], [ymin, ymax]]
	      return [[rect.x, rect.x + rect.width], [rect.y, rect.y + rect.height]];
	    }
	
	    function toBound(fromPos, from, to, dimIdx, boundIdx) {
	      fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
	    }
	  },
	  _createAxis: function (layoutInfo, timelineModel) {
	    var data = timelineModel.getData();
	    var axisType = timelineModel.get('axisType');
	    var scale = axisHelper.createScaleByModel(timelineModel, axisType); // Customize scale. The `tickValue` is `dataIndex`.
	
	    scale.getTicks = function () {
	      return data.mapArray(['value'], function (value) {
	        return value;
	      });
	    };
	
	    var dataExtent = data.getDataExtent('value');
	    scale.setExtent(dataExtent[0], dataExtent[1]);
	    scale.niceTicks();
	    var axis = new TimelineAxis('value', scale, layoutInfo.axisExtent, axisType);
	    axis.model = timelineModel;
	    return axis;
	  },
	  _createGroup: function (name) {
	    var newGroup = this['_' + name] = new graphic.Group();
	    this.group.add(newGroup);
	    return newGroup;
	  },
	  _renderAxisLine: function (layoutInfo, group, axis, timelineModel) {
	    var axisExtent = axis.getExtent();
	
	    if (!timelineModel.get('lineStyle.show')) {
	      return;
	    }
	
	    group.add(new graphic.Line({
	      shape: {
	        x1: axisExtent[0],
	        y1: 0,
	        x2: axisExtent[1],
	        y2: 0
	      },
	      style: zrUtil.extend({
	        lineCap: 'round'
	      }, timelineModel.getModel('lineStyle').getLineStyle()),
	      silent: true,
	      z2: 1
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _renderAxisTick: function (layoutInfo, group, axis, timelineModel) {
	    var data = timelineModel.getData(); // Show all ticks, despite ignoring strategy.
	
	    var ticks = axis.scale.getTicks(); // The value is dataIndex, see the costomized scale.
	
	    each(ticks, function (value) {
	      var tickCoord = axis.dataToCoord(value);
	      var itemModel = data.getItemModel(value);
	      var itemStyleModel = itemModel.getModel('itemStyle');
	      var hoverStyleModel = itemModel.getModel('emphasis.itemStyle');
	      var symbolOpt = {
	        position: [tickCoord, 0],
	        onclick: bind(this._changeTimeline, this, value)
	      };
	      var el = giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
	      graphic.setHoverStyle(el, hoverStyleModel.getItemStyle());
	
	      if (itemModel.get('tooltip')) {
	        el.dataIndex = value;
	        el.dataModel = timelineModel;
	      } else {
	        el.dataIndex = el.dataModel = null;
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderAxisLabel: function (layoutInfo, group, axis, timelineModel) {
	    var labelModel = axis.getLabelModel();
	
	    if (!labelModel.get('show')) {
	      return;
	    }
	
	    var data = timelineModel.getData();
	    var labels = axis.getViewLabels();
	    each(labels, function (labelItem) {
	      // The tickValue is dataIndex, see the costomized scale.
	      var dataIndex = labelItem.tickValue;
	      var itemModel = data.getItemModel(dataIndex);
	      var normalLabelModel = itemModel.getModel('label');
	      var hoverLabelModel = itemModel.getModel('emphasis.label');
	      var tickCoord = axis.dataToCoord(labelItem.tickValue);
	      var textEl = new graphic.Text({
	        position: [tickCoord, 0],
	        rotation: layoutInfo.labelRotation - layoutInfo.rotation,
	        onclick: bind(this._changeTimeline, this, dataIndex),
	        silent: false
	      });
	      graphic.setTextStyle(textEl.style, normalLabelModel, {
	        text: labelItem.formattedLabel,
	        textAlign: layoutInfo.labelAlign,
	        textVerticalAlign: layoutInfo.labelBaseline
	      });
	      group.add(textEl);
	      graphic.setHoverStyle(textEl, graphic.setTextStyle({}, hoverLabelModel));
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderControl: function (layoutInfo, group, axis, timelineModel) {
	    var controlSize = layoutInfo.controlSize;
	    var rotation = layoutInfo.rotation;
	    var itemStyle = timelineModel.getModel('controlStyle').getItemStyle();
	    var hoverStyle = timelineModel.getModel('emphasis.controlStyle').getItemStyle();
	    var rect = [0, -controlSize / 2, controlSize, controlSize];
	    var playState = timelineModel.getPlayState();
	    var inverse = timelineModel.get('inverse', true);
	    makeBtn(layoutInfo.nextBtnPosition, 'controlStyle.nextIcon', bind(this._changeTimeline, this, inverse ? '-' : '+'));
	    makeBtn(layoutInfo.prevBtnPosition, 'controlStyle.prevIcon', bind(this._changeTimeline, this, inverse ? '+' : '-'));
	    makeBtn(layoutInfo.playPosition, 'controlStyle.' + (playState ? 'stopIcon' : 'playIcon'), bind(this._handlePlayClick, this, !playState), true);
	
	    function makeBtn(position, iconPath, onclick, willRotate) {
	      if (!position) {
	        return;
	      }
	
	      var opt = {
	        position: position,
	        origin: [controlSize / 2, 0],
	        rotation: willRotate ? -rotation : 0,
	        rectHover: true,
	        style: itemStyle,
	        onclick: onclick
	      };
	      var btn = makeIcon(timelineModel, iconPath, rect, opt);
	      group.add(btn);
	      graphic.setHoverStyle(btn, hoverStyle);
	    }
	  },
	  _renderCurrentPointer: function (layoutInfo, group, axis, timelineModel) {
	    var data = timelineModel.getData();
	    var currentIndex = timelineModel.getCurrentIndex();
	    var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
	    var me = this;
	    var callback = {
	      onCreate: function (pointer) {
	        pointer.draggable = true;
	        pointer.drift = bind(me._handlePointerDrag, me);
	        pointer.ondragend = bind(me._handlePointerDragend, me);
	        pointerMoveTo(pointer, currentIndex, axis, timelineModel, true);
	      },
	      onUpdate: function (pointer) {
	        pointerMoveTo(pointer, currentIndex, axis, timelineModel);
	      }
	    }; // Reuse when exists, for animation and drag.
	
	    this._currentPointer = giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
	  },
	  _handlePlayClick: function (nextState) {
	    this._clearTimer();
	
	    this.api.dispatchAction({
	      type: 'timelinePlayChange',
	      playState: nextState,
	      from: this.uid
	    });
	  },
	  _handlePointerDrag: function (dx, dy, e) {
	    this._clearTimer();
	
	    this._pointerChangeTimeline([e.offsetX, e.offsetY]);
	  },
	  _handlePointerDragend: function (e) {
	    this._pointerChangeTimeline([e.offsetX, e.offsetY], true);
	  },
	  _pointerChangeTimeline: function (mousePos, trigger) {
	    var toCoord = this._toAxisCoord(mousePos)[0];
	
	    var axis = this._axis;
	    var axisExtent = numberUtil.asc(axis.getExtent().slice());
	    toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
	    toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
	    this._currentPointer.position[0] = toCoord;
	
	    this._currentPointer.dirty();
	
	    var targetDataIndex = this._findNearestTick(toCoord);
	
	    var timelineModel = this.model;
	
	    if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) {
	      this._changeTimeline(targetDataIndex);
	    }
	  },
	  _doPlayStop: function () {
	    this._clearTimer();
	
	    if (this.model.getPlayState()) {
	      this._timer = setTimeout(bind(handleFrame, this), this.model.get('playInterval'));
	    }
	
	    function handleFrame() {
	      // Do not cache
	      var timelineModel = this.model;
	
	      this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
	    }
	  },
	  _toAxisCoord: function (vertex) {
	    var trans = this._mainGroup.getLocalTransform();
	
	    return graphic.applyTransform(vertex, trans, true);
	  },
	  _findNearestTick: function (axisCoord) {
	    var data = this.model.getData();
	    var dist = Infinity;
	    var targetDataIndex;
	    var axis = this._axis;
	    data.each(['value'], function (value, dataIndex) {
	      var coord = axis.dataToCoord(value);
	      var d = Math.abs(coord - axisCoord);
	
	      if (d < dist) {
	        dist = d;
	        targetDataIndex = dataIndex;
	      }
	    });
	    return targetDataIndex;
	  },
	  _clearTimer: function () {
	    if (this._timer) {
	      clearTimeout(this._timer);
	      this._timer = null;
	    }
	  },
	  _changeTimeline: function (nextIndex) {
	    var currentIndex = this.model.getCurrentIndex();
	
	    if (nextIndex === '+') {
	      nextIndex = currentIndex + 1;
	    } else if (nextIndex === '-') {
	      nextIndex = currentIndex - 1;
	    }
	
	    this.api.dispatchAction({
	      type: 'timelineChange',
	      currentIndex: nextIndex,
	      from: this.uid
	    });
	  }
	});
	
	function getViewRect(model, api) {
	  return layout.getLayoutRect(model.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  }, model.get('padding'));
	}
	
	function makeIcon(timelineModel, objPath, rect, opts) {
	  var style = opts.style;
	  var icon = graphic.createIcon(timelineModel.get(objPath), opts || {}, new BoundingRect(rect[0], rect[1], rect[2], rect[3])); // TODO createIcon won't use style in opt.
	
	  if (style) {
	    icon.setStyle(style);
	  }
	
	  return icon;
	}
	/**
	 * Create symbol or update symbol
	 * opt: basic position and event handlers
	 */
	
	
	function giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
	  var color = itemStyleModel.get('color');
	
	  if (!symbol) {
	    var symbolType = hostModel.get('symbol');
	    symbol = createSymbol(symbolType, -1, -1, 2, 2, color);
	    symbol.setStyle('strokeNoScale', true);
	    group.add(symbol);
	    callback && callback.onCreate(symbol);
	  } else {
	    symbol.setColor(color);
	    group.add(symbol); // Group may be new, also need to add.
	
	    callback && callback.onUpdate(symbol);
	  } // Style
	
	
	  var itemStyle = itemStyleModel.getItemStyle(['color', 'symbol', 'symbolSize']);
	  symbol.setStyle(itemStyle); // Transform and events.
	
	  opt = zrUtil.merge({
	    rectHover: true,
	    z2: 100
	  }, opt, true);
	  var symbolSize = hostModel.get('symbolSize');
	  symbolSize = symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
	  symbolSize[0] /= 2;
	  symbolSize[1] /= 2;
	  opt.scale = symbolSize;
	  var symbolOffset = hostModel.get('symbolOffset');
	
	  if (symbolOffset) {
	    var pos = opt.position = opt.position || [0, 0];
	    pos[0] += numberUtil.parsePercent(symbolOffset[0], symbolSize[0]);
	    pos[1] += numberUtil.parsePercent(symbolOffset[1], symbolSize[1]);
	  }
	
	  var symbolRotate = hostModel.get('symbolRotate');
	  opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  symbol.attr(opt); // FIXME
	  // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
	  // getBoundingRect will return wrong result.
	  // (This is supposed to be resolved in zrender, but it is a little difficult to
	  // leverage performance and auto updateTransform)
	  // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
	
	  symbol.updateTransform();
	  return symbol;
	}
	
	function pointerMoveTo(pointer, dataIndex, axis, timelineModel, noAnimation) {
	  if (pointer.dragging) {
	    return;
	  }
	
	  var pointerModel = timelineModel.getModel('checkpointStyle');
	  var toCoord = axis.dataToCoord(timelineModel.getData().get(['value'], dataIndex));
	
	  if (noAnimation || !pointerModel.get('animation', true)) {
	    pointer.attr({
	      position: [toCoord, 0]
	    });
	  } else {
	    pointer.stopAnimation(true);
	    pointer.animateTo({
	      position: [toCoord, 0]
	    }, pointerModel.get('animationDuration', true), pointerModel.get('animationEasing', true));
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentView = __webpack_require__(324);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = ComponentView.extend({
	  type: 'timeline'
	});
	
	module.exports = _default;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var Axis = __webpack_require__(364);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Extend axis 2d
	 * @constructor module:echarts/coord/cartesian/Axis2D
	 * @extends {module:echarts/coord/cartesian/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var TimelineAxis = function (dim, scale, coordExtent, axisType) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis model
	   * @param {module:echarts/component/TimelineModel}
	   */
	
	  this.model = null;
	};
	
	TimelineAxis.prototype = {
	  constructor: TimelineAxis,
	
	  /**
	   * @override
	   */
	  getLabelModel: function () {
	    return this.model.getModel('label');
	  },
	
	  /**
	   * @override
	   */
	  isHorizontal: function () {
	    return this.model.get('orient') === 'horizontal';
	  }
	};
	zrUtil.inherits(TimelineAxis, Axis);
	var _default = TimelineAxis;
	module.exports = _default;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(659);
	
	__webpack_require__(661);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// HINT Markpoint can't be used too much
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markPoint component is enabled
	  opt.markPoint = opt.markPoint || {};
	});

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(660);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markPoint',
	  defaultOption: {
	    zlevel: 0,
	    z: 5,
	    symbol: 'pin',
	    symbolSize: 50,
	    //symbolRotate: 0,
	    //symbolOffset: [0, 0]
	    tooltip: {
	      trigger: 'item'
	    },
	    label: {
	      show: true,
	      position: 'inside'
	    },
	    itemStyle: {
	      borderWidth: 2
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var env = __webpack_require__(219);
	
	var modelUtil = __webpack_require__(261);
	
	var formatUtil = __webpack_require__(307);
	
	var dataFormatMixin = __webpack_require__(321);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var addCommas = formatUtil.addCommas;
	var encodeHTML = formatUtil.encodeHTML;
	
	function fillLabel(opt) {
	  modelUtil.defaultEmphasis(opt, 'label', ['show']);
	}
	
	var MarkerModel = echarts.extendComponentModel({
	  type: 'marker',
	  dependencies: ['series', 'grid', 'polar', 'geo'],
	
	  /**
	   * @overrite
	   */
	  init: function (option, parentModel, ecModel) {
	    this.mergeDefaultAndTheme(option, ecModel);
	
	    this._mergeOption(option, ecModel, false, true);
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isAnimationEnabled: function () {
	    if (env.node) {
	      return false;
	    }
	
	    var hostSeries = this.__hostSeries;
	    return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
	  },
	
	  /**
	   * @overrite
	   */
	  mergeOption: function (newOpt, ecModel) {
	    this._mergeOption(newOpt, ecModel, false, false);
	  },
	  _mergeOption: function (newOpt, ecModel, createdBySelf, isInit) {
	    var MarkerModel = this.constructor;
	    var modelPropName = this.mainType + 'Model';
	
	    if (!createdBySelf) {
	      ecModel.eachSeries(function (seriesModel) {
	        var markerOpt = seriesModel.get(this.mainType, true);
	        var markerModel = seriesModel[modelPropName];
	
	        if (!markerOpt || !markerOpt.data) {
	          seriesModel[modelPropName] = null;
	          return;
	        }
	
	        if (!markerModel) {
	          if (isInit) {
	            // Default label emphasis `position` and `show`
	            fillLabel(markerOpt);
	          }
	
	          zrUtil.each(markerOpt.data, function (item) {
	            // FIXME Overwrite fillLabel method ?
	            if (item instanceof Array) {
	              fillLabel(item[0]);
	              fillLabel(item[1]);
	            } else {
	              fillLabel(item);
	            }
	          });
	          markerModel = new MarkerModel(markerOpt, this, ecModel);
	          zrUtil.extend(markerModel, {
	            mainType: this.mainType,
	            // Use the same series index and name
	            seriesIndex: seriesModel.seriesIndex,
	            name: seriesModel.name,
	            createdBySelf: true
	          });
	          markerModel.__hostSeries = seriesModel;
	        } else {
	          markerModel._mergeOption(markerOpt, ecModel, true);
	        }
	
	        seriesModel[modelPropName] = markerModel;
	      }, this);
	    }
	  },
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var data = this.getData();
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? zrUtil.map(value, addCommas).join(', ') : addCommas(value);
	    var name = data.getName(dataIndex);
	    var html = encodeHTML(this.name);
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	
	    if (value != null || name) {
	      html += newLine;
	    }
	
	    if (name) {
	      html += encodeHTML(name);
	
	      if (value != null) {
	        html += ' : ';
	      }
	    }
	
	    if (value != null) {
	      html += encodeHTML(formattedValue);
	    }
	
	    return html;
	  },
	  getData: function () {
	    return this._data;
	  },
	  setData: function (data) {
	    this._data = data;
	  }
	});
	zrUtil.mixin(MarkerModel, dataFormatMixin);
	var _default = MarkerModel;
	module.exports = _default;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var SymbolDraw = __webpack_require__(369);
	
	var numberUtil = __webpack_require__(306);
	
	var List = __webpack_require__(342);
	
	var markerHelper = __webpack_require__(662);
	
	var MarkerView = __webpack_require__(663);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function updateMarkerLayout(mpData, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  mpData.each(function (idx) {
	    var itemModel = mpData.getItemModel(idx);
	    var point;
	    var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
	    var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());
	
	    if (!isNaN(xPx) && !isNaN(yPx)) {
	      point = [xPx, yPx];
	    } // Chart like bar may have there own marker positioning logic
	    else if (seriesModel.getMarkerPosition) {
	        // Use the getMarkerPoisition
	        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
	      } else if (coordSys) {
	        var x = mpData.get(coordSys.dimensions[0], idx);
	        var y = mpData.get(coordSys.dimensions[1], idx);
	        point = coordSys.dataToPoint([x, y]);
	      } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	
	    mpData.setItemLayout(idx, point);
	  });
	}
	
	var _default = MarkerView.extend({
	  type: 'markPoint',
	  // updateLayout: function (markPointModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var mpModel = seriesModel.markPointModel;
	  //         if (mpModel) {
	  //             updateMarkerLayout(mpModel.getData(), seriesModel, api);
	  //             this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markPointModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var mpModel = seriesModel.markPointModel;
	
	      if (mpModel) {
	        updateMarkerLayout(mpModel.getData(), seriesModel, api);
	        this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, mpModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var symbolDrawMap = this.markerGroupMap;
	    var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new SymbolDraw());
	    var mpData = createList(coordSys, seriesModel, mpModel); // FIXME
	
	    mpModel.setData(mpData);
	    updateMarkerLayout(mpModel.getData(), seriesModel, api);
	    mpData.each(function (idx) {
	      var itemModel = mpData.getItemModel(idx);
	      var symbol = itemModel.getShallow('symbol');
	      var symbolSize = itemModel.getShallow('symbolSize');
	      var symbolRotate = itemModel.getShallow('symbolRotate');
	      var isFnSymbol = zrUtil.isFunction(symbol);
	      var isFnSymbolSize = zrUtil.isFunction(symbolSize);
	      var isFnSymbolRotate = zrUtil.isFunction(symbolRotate);
	
	      if (isFnSymbol || isFnSymbolSize || isFnSymbolRotate) {
	        var rawIdx = mpModel.getRawValue(idx);
	        var dataParams = mpModel.getDataParams(idx);
	
	        if (isFnSymbol) {
	          symbol = symbol(rawIdx, dataParams);
	        }
	
	        if (isFnSymbolSize) {
	          // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
	          symbolSize = symbolSize(rawIdx, dataParams);
	        }
	
	        if (isFnSymbolRotate) {
	          symbolRotate = symbolRotate(rawIdx, dataParams);
	        }
	      }
	
	      mpData.setItemVisual(idx, {
	        symbol: symbol,
	        symbolSize: symbolSize,
	        symbolRotate: symbolRotate,
	        color: itemModel.get('itemStyle.color') || seriesData.getVisual('color')
	      });
	    }); // TODO Text are wrong
	
	    symbolDraw.updateData(mpData);
	    this.group.add(symbolDraw.group); // Set host model for tooltip
	    // FIXME
	
	    mpData.eachItemGraphicEl(function (el) {
	      el.traverse(function (child) {
	        child.dataModel = mpModel;
	      });
	    });
	    symbolDraw.__keep = true;
	    symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} [coordSys]
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	
	function createList(coordSys, seriesModel, mpModel) {
	  var coordDimsInfos;
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	  }
	
	  var mpData = new List(coordDimsInfos, mpModel);
	  var dataOpt = zrUtil.map(mpModel.get('data'), zrUtil.curry(markerHelper.dataTransform, seriesModel));
	
	  if (coordSys) {
	    dataOpt = zrUtil.filter(dataOpt, zrUtil.curry(markerHelper.dataFilter, coordSys));
	  }
	
	  mpData.initData(dataOpt, null, coordSys ? markerHelper.dimValueGetter : function (item) {
	    return item.value;
	  });
	  return mpData;
	}
	
	module.exports = _default;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var numberUtil = __webpack_require__(306);
	
	var _dataStackHelper = __webpack_require__(349);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var indexOf = zrUtil.indexOf;
	
	function hasXOrY(item) {
	  return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
	}
	
	function hasXAndY(item) {
	  return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
	} // Make it simple, do not visit all stacked value to count precision.
	// function getPrecision(data, valueAxisDim, dataIndex) {
	//     var precision = -1;
	//     var stackedDim = data.mapDimension(valueAxisDim);
	//     do {
	//         precision = Math.max(
	//             numberUtil.getPrecision(data.get(stackedDim, dataIndex)),
	//             precision
	//         );
	//         var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
	//         if (stackedOnSeries) {
	//             var byValue = data.get(data.getCalculationInfo('stackedByDimension'), dataIndex);
	//             data = stackedOnSeries.getData();
	//             dataIndex = data.indexOf(data.getCalculationInfo('stackedByDimension'), byValue);
	//             stackedDim = data.getCalculationInfo('stackedDimension');
	//         }
	//         else {
	//             data = null;
	//         }
	//     } while (data);
	//     return precision;
	// }
	
	
	function markerTypeCalculatorWithExtent(mlType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
	  var coordArr = [];
	  var stacked = isDimensionStacked(data, targetDataDim
	  /*, otherDataDim*/
	  );
	  var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
	  var value = numCalculate(data, calcDataDim, mlType);
	  var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
	  coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
	  coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
	  var coordArrValue = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.
	
	  var precision = numberUtil.getPrecision(data.get(targetDataDim, dataIndex));
	  precision = Math.min(precision, 20);
	
	  if (precision >= 0) {
	    coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
	  }
	
	  return [coordArr, coordArrValue];
	}
	
	var curry = zrUtil.curry; // TODO Specified percent
	
	var markerTypeCalculator = {
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  min: curry(markerTypeCalculatorWithExtent, 'min'),
	
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  max: curry(markerTypeCalculatorWithExtent, 'max'),
	
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  average: curry(markerTypeCalculatorWithExtent, 'average')
	};
	/**
	 * Transform markPoint data item to format used in List by do the following
	 * 1. Calculate statistic like `max`, `min`, `average`
	 * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
	 * @param  {module:echarts/model/Series} seriesModel
	 * @param  {module:echarts/coord/*} [coordSys]
	 * @param  {Object} item
	 * @return {Object}
	 */
	
	function dataTransform(seriesModel, item) {
	  var data = seriesModel.getData();
	  var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
	  // 2. If `coord` is not a data array. Which uses `xAxis`,
	  // `yAxis` to specify the coord on each dimension
	  // parseFloat first because item.x and item.y can be percent string like '20%'
	
	  if (item && !hasXAndY(item) && !zrUtil.isArray(item.coord) && coordSys) {
	    var dims = coordSys.dimensions;
	    var axisInfo = getAxisInfo(item, data, coordSys, seriesModel); // Clone the option
	    // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
	
	    item = zrUtil.clone(item);
	
	    if (item.type && markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
	      var otherCoordIndex = indexOf(dims, axisInfo.baseAxis.dim);
	      var targetCoordIndex = indexOf(dims, axisInfo.valueAxis.dim);
	      var coordInfo = markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
	      item.coord = coordInfo[0]; // Force to use the value of calculated value.
	      // let item use the value without stack.
	
	      item.value = coordInfo[1];
	    } else {
	      // FIXME Only has one of xAxis and yAxis.
	      var coord = [item.xAxis != null ? item.xAxis : item.radiusAxis, item.yAxis != null ? item.yAxis : item.angleAxis]; // Each coord support max, min, average
	
	      for (var i = 0; i < 2; i++) {
	        if (markerTypeCalculator[coord[i]]) {
	          coord[i] = numCalculate(data, data.mapDimension(dims[i]), coord[i]);
	        }
	      }
	
	      item.coord = coord;
	    }
	  }
	
	  return item;
	}
	
	function getAxisInfo(item, data, coordSys, seriesModel) {
	  var ret = {};
	
	  if (item.valueIndex != null || item.valueDim != null) {
	    ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
	    ret.valueAxis = coordSys.getAxis(dataDimToCoordDim(seriesModel, ret.valueDataDim));
	    ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
	    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
	  } else {
	    ret.baseAxis = seriesModel.getBaseAxis();
	    ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
	    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
	    ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
	  }
	
	  return ret;
	}
	
	function dataDimToCoordDim(seriesModel, dataDim) {
	  var data = seriesModel.getData();
	  var dimensions = data.dimensions;
	  dataDim = data.getDimension(dataDim);
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimItem = data.getDimensionInfo(dimensions[i]);
	
	    if (dimItem.name === dataDim) {
	      return dimItem.coordDim;
	    }
	  }
	}
	/**
	 * Filter data which is out of coordinateSystem range
	 * [dataFilter description]
	 * @param  {module:echarts/coord/*} [coordSys]
	 * @param  {Object} item
	 * @return {boolean}
	 */
	
	
	function dataFilter(coordSys, item) {
	  // Alwalys return true if there is no coordSys
	  return coordSys && coordSys.containData && item.coord && !hasXOrY(item) ? coordSys.containData(item.coord) : true;
	}
	
	function dimValueGetter(item, dimName, dataIndex, dimIndex) {
	  // x, y, radius, angle
	  if (dimIndex < 2) {
	    return item.coord && item.coord[dimIndex];
	  }
	
	  return item.value;
	}
	
	function numCalculate(data, valueDataDim, type) {
	  if (type === 'average') {
	    var sum = 0;
	    var count = 0;
	    data.each(valueDataDim, function (val, idx) {
	      if (!isNaN(val)) {
	        sum += val;
	        count++;
	      }
	    });
	    return sum / count;
	  } else if (type === 'median') {
	    return data.getMedian(valueDataDim);
	  } else {
	    // max & min
	    return data.getDataExtent(valueDataDim, true)[type === 'max' ? 1 : 0];
	  }
	}
	
	exports.dataTransform = dataTransform;
	exports.getAxisInfo = getAxisInfo;
	exports.dataFilter = dataFilter;
	exports.dimValueGetter = dimValueGetter;
	exports.numCalculate = numCalculate;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'marker',
	  init: function () {
	    /**
	     * Markline grouped by series
	     * @private
	     * @type {module:zrender/core/util.HashMap}
	     */
	    this.markerGroupMap = zrUtil.createHashMap();
	  },
	  render: function (markerModel, ecModel, api) {
	    var markerGroupMap = this.markerGroupMap;
	    markerGroupMap.each(function (item) {
	      item.__keep = false;
	    });
	    var markerModelKey = this.type + 'Model';
	    ecModel.eachSeries(function (seriesModel) {
	      var markerModel = seriesModel[markerModelKey];
	      markerModel && this.renderSeries(seriesModel, markerModel, ecModel, api);
	    }, this);
	    markerGroupMap.each(function (item) {
	      !item.__keep && this.group.remove(item.group);
	    }, this);
	  },
	  renderSeries: function () {}
	});
	
	module.exports = _default;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(665);
	
	__webpack_require__(666);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markLine component is enabled
	  opt.markLine = opt.markLine || {};
	});

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(660);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markLine',
	  defaultOption: {
	    zlevel: 0,
	    z: 5,
	    symbol: ['circle', 'arrow'],
	    symbolSize: [8, 16],
	    //symbolRotate: 0,
	    precision: 2,
	    tooltip: {
	      trigger: 'item'
	    },
	    label: {
	      show: true,
	      position: 'end',
	      distance: 5
	    },
	    lineStyle: {
	      type: 'dashed'
	    },
	    emphasis: {
	      label: {
	        show: true
	      },
	      lineStyle: {
	        width: 3
	      }
	    },
	    animationEasing: 'linear'
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var List = __webpack_require__(342);
	
	var numberUtil = __webpack_require__(306);
	
	var markerHelper = __webpack_require__(662);
	
	var LineDraw = __webpack_require__(476);
	
	var MarkerView = __webpack_require__(663);
	
	var _dataStackHelper = __webpack_require__(349);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var markLineTransform = function (seriesModel, coordSys, mlModel, item) {
	  var data = seriesModel.getData(); // Special type markLine like 'min', 'max', 'average', 'median'
	
	  var mlType = item.type;
	
	  if (!zrUtil.isArray(item) && (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' // In case
	  // data: [{
	  //   yAxis: 10
	  // }]
	  || item.xAxis != null || item.yAxis != null)) {
	    var valueAxis;
	    var value;
	
	    if (item.yAxis != null || item.xAxis != null) {
	      valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
	      value = zrUtil.retrieve(item.yAxis, item.xAxis);
	    } else {
	      var axisInfo = markerHelper.getAxisInfo(item, data, coordSys, seriesModel);
	      valueAxis = axisInfo.valueAxis;
	      var valueDataDim = getStackedDimension(data, axisInfo.valueDataDim);
	      value = markerHelper.numCalculate(data, valueDataDim, mlType);
	    }
	
	    var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
	    var baseIndex = 1 - valueIndex;
	    var mlFrom = zrUtil.clone(item);
	    var mlTo = {};
	    mlFrom.type = null;
	    mlFrom.coord = [];
	    mlTo.coord = [];
	    mlFrom.coord[baseIndex] = -Infinity;
	    mlTo.coord[baseIndex] = Infinity;
	    var precision = mlModel.get('precision');
	
	    if (precision >= 0 && typeof value === 'number') {
	      value = +value.toFixed(Math.min(precision, 20));
	    }
	
	    mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
	    item = [mlFrom, mlTo, {
	      // Extra option for tooltip and label
	      type: mlType,
	      valueIndex: item.valueIndex,
	      // Force to use the value of calculated value.
	      value: value
	    }];
	  }
	
	  item = [markerHelper.dataTransform(seriesModel, item[0]), markerHelper.dataTransform(seriesModel, item[1]), zrUtil.extend({}, item[2])]; // Avoid line data type is extended by from(to) data type
	
	  item[2].type = item[2].type || ''; // Merge from option and to option into line option
	
	  zrUtil.merge(item[2], item[0]);
	  zrUtil.merge(item[2], item[1]);
	  return item;
	};
	
	function isInifinity(val) {
	  return !isNaN(val) && !isFinite(val);
	} // If a markLine has one dim
	
	
	function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	  var otherDimIndex = 1 - dimIndex;
	  var dimName = coordSys.dimensions[dimIndex];
	  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
	}
	
	function markLineFilter(coordSys, item) {
	  if (coordSys.type === 'cartesian2d') {
	    var fromCoord = item[0].coord;
	    var toCoord = item[1].coord; // In case
	    // {
	    //  markLine: {
	    //    data: [{ yAxis: 2 }]
	    //  }
	    // }
	
	    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	      return true;
	    }
	  }
	
	  return markerHelper.dataFilter(coordSys, item[0]) && markerHelper.dataFilter(coordSys, item[1]);
	}
	
	function updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  var itemModel = data.getItemModel(idx);
	  var point;
	  var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
	  var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());
	
	  if (!isNaN(xPx) && !isNaN(yPx)) {
	    point = [xPx, yPx];
	  } else {
	    // Chart like bar may have there own marker positioning logic
	    if (seriesModel.getMarkerPosition) {
	      // Use the getMarkerPoisition
	      point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
	    } else {
	      var dims = coordSys.dimensions;
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	      point = coordSys.dataToPoint([x, y]);
	    } // Expand line to the edge of grid if value on one axis is Inifnity
	    // In case
	    //  markLine: {
	    //    data: [{
	    //      yAxis: 2
	    //      // or
	    //      type: 'average'
	    //    }]
	    //  }
	
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var dims = coordSys.dimensions;
	
	      if (isInifinity(data.get(dims[0], idx))) {
	        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
	      } else if (isInifinity(data.get(dims[1], idx))) {
	        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
	      }
	    } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	  }
	
	  data.setItemLayout(idx, point);
	}
	
	var _default = MarkerView.extend({
	  type: 'markLine',
	  // updateLayout: function (markLineModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var mlModel = seriesModel.markLineModel;
	  //         if (mlModel) {
	  //             var mlData = mlModel.getData();
	  //             var fromData = mlModel.__from;
	  //             var toData = mlModel.__to;
	  //             // Update visual and layout of from symbol and to symbol
	  //             fromData.each(function (idx) {
	  //                 updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
	  //                 updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
	  //             });
	  //             // Update layout of line
	  //             mlData.each(function (idx) {
	  //                 mlData.setItemLayout(idx, [
	  //                     fromData.getItemLayout(idx),
	  //                     toData.getItemLayout(idx)
	  //                 ]);
	  //             });
	  //             this.markerGroupMap.get(seriesModel.id).updateLayout();
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markLineModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var mlModel = seriesModel.markLineModel;
	
	      if (mlModel) {
	        var mlData = mlModel.getData();
	        var fromData = mlModel.__from;
	        var toData = mlModel.__to; // Update visual and layout of from symbol and to symbol
	
	        fromData.each(function (idx) {
	          updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
	          updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
	        }); // Update layout of line
	
	        mlData.each(function (idx) {
	          mlData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	        });
	        this.markerGroupMap.get(seriesModel.id).updateLayout();
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, mlModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var lineDrawMap = this.markerGroupMap;
	    var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new LineDraw());
	    this.group.add(lineDraw.group);
	    var mlData = createList(coordSys, seriesModel, mlModel);
	    var fromData = mlData.from;
	    var toData = mlData.to;
	    var lineData = mlData.line;
	    mlModel.__from = fromData;
	    mlModel.__to = toData; // Line data for tooltip and formatter
	
	    mlModel.setData(lineData);
	    var symbolType = mlModel.get('symbol');
	    var symbolSize = mlModel.get('symbolSize');
	
	    if (!zrUtil.isArray(symbolType)) {
	      symbolType = [symbolType, symbolType];
	    }
	
	    if (typeof symbolSize === 'number') {
	      symbolSize = [symbolSize, symbolSize];
	    } // Update visual and layout of from symbol and to symbol
	
	
	    mlData.from.each(function (idx) {
	      updateDataVisualAndLayout(fromData, idx, true);
	      updateDataVisualAndLayout(toData, idx, false);
	    }); // Update visual and layout of line
	
	    lineData.each(function (idx) {
	      var lineColor = lineData.getItemModel(idx).get('lineStyle.color');
	      lineData.setItemVisual(idx, {
	        color: lineColor || fromData.getItemVisual(idx, 'color')
	      });
	      lineData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	      lineData.setItemVisual(idx, {
	        'fromSymbolRotate': fromData.getItemVisual(idx, 'symbolRotate'),
	        'fromSymbolSize': fromData.getItemVisual(idx, 'symbolSize'),
	        'fromSymbol': fromData.getItemVisual(idx, 'symbol'),
	        'toSymbolRotate': toData.getItemVisual(idx, 'symbolRotate'),
	        'toSymbolSize': toData.getItemVisual(idx, 'symbolSize'),
	        'toSymbol': toData.getItemVisual(idx, 'symbol')
	      });
	    });
	    lineDraw.updateData(lineData); // Set host model for tooltip
	    // FIXME
	
	    mlData.line.eachItemGraphicEl(function (el, idx) {
	      el.traverse(function (child) {
	        child.dataModel = mlModel;
	      });
	    });
	
	    function updateDataVisualAndLayout(data, idx, isFrom) {
	      var itemModel = data.getItemModel(idx);
	      updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
	      data.setItemVisual(idx, {
	        symbolRotate: itemModel.get('symbolRotate'),
	        symbolSize: itemModel.get('symbolSize') || symbolSize[isFrom ? 0 : 1],
	        symbol: itemModel.get('symbol', true) || symbolType[isFrom ? 0 : 1],
	        color: itemModel.get('itemStyle.color') || seriesData.getVisual('color')
	      });
	    }
	
	    lineDraw.__keep = true;
	    lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} coordSys
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	
	function createList(coordSys, seriesModel, mlModel) {
	  var coordDimsInfos;
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	  }
	
	  var fromData = new List(coordDimsInfos, mlModel);
	  var toData = new List(coordDimsInfos, mlModel); // No dimensions
	
	  var lineData = new List([], mlModel);
	  var optData = zrUtil.map(mlModel.get('data'), zrUtil.curry(markLineTransform, seriesModel, coordSys, mlModel));
	
	  if (coordSys) {
	    optData = zrUtil.filter(optData, zrUtil.curry(markLineFilter, coordSys));
	  }
	
	  var dimValueGetter = coordSys ? markerHelper.dimValueGetter : function (item) {
	    return item.value;
	  };
	  fromData.initData(zrUtil.map(optData, function (item) {
	    return item[0];
	  }), null, dimValueGetter);
	  toData.initData(zrUtil.map(optData, function (item) {
	    return item[1];
	  }), null, dimValueGetter);
	  lineData.initData(zrUtil.map(optData, function (item) {
	    return item[2];
	  }));
	  lineData.hasItemOption = true;
	  return {
	    from: fromData,
	    to: toData,
	    line: lineData
	  };
	}
	
	module.exports = _default;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(668);
	
	__webpack_require__(669);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markArea component is enabled
	  opt.markArea = opt.markArea || {};
	});

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(660);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markArea',
	  defaultOption: {
	    zlevel: 0,
	    // PENDING
	    z: 1,
	    tooltip: {
	      trigger: 'item'
	    },
	    // markArea should fixed on the coordinate system
	    animation: false,
	    label: {
	      show: true,
	      position: 'top'
	    },
	    itemStyle: {
	      // color and borderColor default to use color from series
	      // color: 'auto'
	      // borderColor: 'auto'
	      borderWidth: 0
	    },
	    emphasis: {
	      label: {
	        show: true,
	        position: 'top'
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var colorUtil = __webpack_require__(238);
	
	var List = __webpack_require__(342);
	
	var numberUtil = __webpack_require__(306);
	
	var graphic = __webpack_require__(268);
	
	var markerHelper = __webpack_require__(662);
	
	var MarkerView = __webpack_require__(663);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Better on polar
	var markAreaTransform = function (seriesModel, coordSys, maModel, item) {
	  var lt = markerHelper.dataTransform(seriesModel, item[0]);
	  var rb = markerHelper.dataTransform(seriesModel, item[1]);
	  var retrieve = zrUtil.retrieve; // FIXME make sure lt is less than rb
	
	  var ltCoord = lt.coord;
	  var rbCoord = rb.coord;
	  ltCoord[0] = retrieve(ltCoord[0], -Infinity);
	  ltCoord[1] = retrieve(ltCoord[1], -Infinity);
	  rbCoord[0] = retrieve(rbCoord[0], Infinity);
	  rbCoord[1] = retrieve(rbCoord[1], Infinity); // Merge option into one
	
	  var result = zrUtil.mergeAll([{}, lt, rb]);
	  result.coord = [lt.coord, rb.coord];
	  result.x0 = lt.x;
	  result.y0 = lt.y;
	  result.x1 = rb.x;
	  result.y1 = rb.y;
	  return result;
	};
	
	function isInifinity(val) {
	  return !isNaN(val) && !isFinite(val);
	} // If a markArea has one dim
	
	
	function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	  var otherDimIndex = 1 - dimIndex;
	  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]);
	}
	
	function markAreaFilter(coordSys, item) {
	  var fromCoord = item.coord[0];
	  var toCoord = item.coord[1];
	
	  if (coordSys.type === 'cartesian2d') {
	    // In case
	    // {
	    //  markArea: {
	    //    data: [{ yAxis: 2 }]
	    //  }
	    // }
	    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	      return true;
	    }
	  }
	
	  return markerHelper.dataFilter(coordSys, {
	    coord: fromCoord,
	    x: item.x0,
	    y: item.y0
	  }) || markerHelper.dataFilter(coordSys, {
	    coord: toCoord,
	    x: item.x1,
	    y: item.y1
	  });
	} // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
	
	
	function getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  var itemModel = data.getItemModel(idx);
	  var point;
	  var xPx = numberUtil.parsePercent(itemModel.get(dims[0]), api.getWidth());
	  var yPx = numberUtil.parsePercent(itemModel.get(dims[1]), api.getHeight());
	
	  if (!isNaN(xPx) && !isNaN(yPx)) {
	    point = [xPx, yPx];
	  } else {
	    // Chart like bar may have there own marker positioning logic
	    if (seriesModel.getMarkerPosition) {
	      // Use the getMarkerPoisition
	      point = seriesModel.getMarkerPosition(data.getValues(dims, idx));
	    } else {
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	      var pt = [x, y];
	      coordSys.clampData && coordSys.clampData(pt, pt);
	      point = coordSys.dataToPoint(pt, true);
	    }
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	
	      if (isInifinity(x)) {
	        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
	      } else if (isInifinity(y)) {
	        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
	      }
	    } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	  }
	
	  return point;
	}
	
	var dimPermutations = [['x0', 'y0'], ['x1', 'y0'], ['x1', 'y1'], ['x0', 'y1']];
	MarkerView.extend({
	  type: 'markArea',
	  // updateLayout: function (markAreaModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var maModel = seriesModel.markAreaModel;
	  //         if (maModel) {
	  //             var areaData = maModel.getData();
	  //             areaData.each(function (idx) {
	  //                 var points = zrUtil.map(dimPermutations, function (dim) {
	  //                     return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	  //                 });
	  //                 // Layout
	  //                 areaData.setItemLayout(idx, points);
	  //                 var el = areaData.getItemGraphicEl(idx);
	  //                 el.setShape('points', points);
	  //             });
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markAreaModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var maModel = seriesModel.markAreaModel;
	
	      if (maModel) {
	        var areaData = maModel.getData();
	        areaData.each(function (idx) {
	          var points = zrUtil.map(dimPermutations, function (dim) {
	            return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	          }); // Layout
	
	          areaData.setItemLayout(idx, points);
	          var el = areaData.getItemGraphicEl(idx);
	          el.setShape('points', points);
	        });
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, maModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var areaGroupMap = this.markerGroupMap;
	    var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
	      group: new graphic.Group()
	    });
	    this.group.add(polygonGroup.group);
	    polygonGroup.__keep = true;
	    var areaData = createList(coordSys, seriesModel, maModel); // Line data for tooltip and formatter
	
	    maModel.setData(areaData); // Update visual and layout of line
	
	    areaData.each(function (idx) {
	      // Layout
	      var points = zrUtil.map(dimPermutations, function (dim) {
	        return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	      }); // If none of the area is inside coordSys, allClipped is set to be true
	      // in layout so that label will not be displayed. See #12591
	
	      var allClipped = true;
	      zrUtil.each(dimPermutations, function (dim) {
	        if (!allClipped) {
	          return;
	        }
	
	        var xValue = areaData.get(dim[0], idx);
	        var yValue = areaData.get(dim[1], idx); // If is infinity, the axis should be considered not clipped
	
	        if ((isInifinity(xValue) || coordSys.getAxis('x').containData(xValue)) && (isInifinity(yValue) || coordSys.getAxis('y').containData(yValue))) {
	          allClipped = false;
	        }
	      });
	      areaData.setItemLayout(idx, {
	        points: points,
	        allClipped: allClipped
	      }); // Visual
	
	      areaData.setItemVisual(idx, {
	        color: seriesData.getVisual('color')
	      });
	    });
	    areaData.diff(polygonGroup.__data).add(function (idx) {
	      var layout = areaData.getItemLayout(idx);
	
	      if (!layout.allClipped) {
	        var polygon = new graphic.Polygon({
	          shape: {
	            points: layout.points
	          }
	        });
	        areaData.setItemGraphicEl(idx, polygon);
	        polygonGroup.group.add(polygon);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var polygon = polygonGroup.__data.getItemGraphicEl(oldIdx);
	
	      var layout = areaData.getItemLayout(newIdx);
	
	      if (!layout.allClipped) {
	        if (polygon) {
	          graphic.updateProps(polygon, {
	            shape: {
	              points: layout.points
	            }
	          }, maModel, newIdx);
	        } else {
	          polygon = new graphic.Polygon({
	            shape: {
	              points: layout.points
	            }
	          });
	        }
	
	        areaData.setItemGraphicEl(newIdx, polygon);
	        polygonGroup.group.add(polygon);
	      } else if (polygon) {
	        polygonGroup.group.remove(polygon);
	      }
	    }).remove(function (idx) {
	      var polygon = polygonGroup.__data.getItemGraphicEl(idx);
	
	      polygonGroup.group.remove(polygon);
	    }).execute();
	    areaData.eachItemGraphicEl(function (polygon, idx) {
	      var itemModel = areaData.getItemModel(idx);
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      var color = areaData.getItemVisual(idx, 'color');
	      polygon.useStyle(zrUtil.defaults(itemModel.getModel('itemStyle').getItemStyle(), {
	        fill: colorUtil.modifyAlpha(color, 0.4),
	        stroke: color
	      }));
	      polygon.hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	      graphic.setLabelStyle(polygon.style, polygon.hoverStyle, labelModel, labelHoverModel, {
	        labelFetcher: maModel,
	        labelDataIndex: idx,
	        defaultText: areaData.getName(idx) || '',
	        isRectText: true,
	        autoColor: color
	      });
	      graphic.setHoverStyle(polygon, {});
	      polygon.dataModel = maModel;
	    });
	    polygonGroup.__data = areaData;
	    polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} coordSys
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	function createList(coordSys, seriesModel, maModel) {
	  var coordDimsInfos;
	  var areaData;
	  var dims = ['x0', 'y0', 'x1', 'y1'];
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var data = seriesModel.getData();
	      var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	    areaData = new List(zrUtil.map(dims, function (dim, idx) {
	      return {
	        name: dim,
	        type: coordDimsInfos[idx % 2].type
	      };
	    }), maModel);
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	    areaData = new List(coordDimsInfos, maModel);
	  }
	
	  var optData = zrUtil.map(maModel.get('data'), zrUtil.curry(markAreaTransform, seriesModel, coordSys, maModel));
	
	  if (coordSys) {
	    optData = zrUtil.filter(optData, zrUtil.curry(markAreaFilter, coordSys));
	  }
	
	  var dimValueGetter = coordSys ? function (item, dimName, dataIndex, dimIndex) {
	    return item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
	  } : function (item) {
	    return item.value;
	  };
	  areaData.initData(optData, null, dimValueGetter);
	  areaData.hasItemOption = true;
	  return areaData;
	}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(671);
	
	__webpack_require__(676);
	
	__webpack_require__(677);
	
	__webpack_require__(678);

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	__webpack_require__(672);
	
	__webpack_require__(673);
	
	__webpack_require__(674);
	
	var legendFilter = __webpack_require__(675);
	
	var Component = __webpack_require__(303);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Do not contain scrollable legend, for sake of file size.
	// Series Filter
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.SERIES_FILTER, legendFilter);
	Component.registerSubTypeDefaulter('legend', function () {
	  // Default 'plain' when no type specified.
	  return 'plain';
	});

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var Model = __webpack_require__(262);
	
	var _model = __webpack_require__(261);
	
	var isNameSpecified = _model.isNameSpecified;
	
	var lang = __webpack_require__(330);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var langSelector = lang.legend.selector;
	var defaultSelectorOption = {
	  all: {
	    type: 'all',
	    title: zrUtil.clone(langSelector.all)
	  },
	  inverse: {
	    type: 'inverse',
	    title: zrUtil.clone(langSelector.inverse)
	  }
	};
	var LegendModel = echarts.extendComponentModel({
	  type: 'legend.plain',
	  dependencies: ['series'],
	  layoutMode: {
	    type: 'box',
	    // legend.width/height are maxWidth/maxHeight actually,
	    // whereas realy width/height is calculated by its content.
	    // (Setting {left: 10, right: 10} does not make sense).
	    // So consider the case:
	    // `setOption({legend: {left: 10});`
	    // then `setOption({legend: {right: 10});`
	    // The previous `left` should be cleared by setting `ignoreSize`.
	    ignoreSize: true
	  },
	  init: function (option, parentModel, ecModel) {
	    this.mergeDefaultAndTheme(option, ecModel);
	    option.selected = option.selected || {};
	
	    this._updateSelector(option);
	  },
	  mergeOption: function (option) {
	    LegendModel.superCall(this, 'mergeOption', option);
	
	    this._updateSelector(option);
	  },
	  _updateSelector: function (option) {
	    var selector = option.selector;
	
	    if (selector === true) {
	      selector = option.selector = ['all', 'inverse'];
	    }
	
	    if (zrUtil.isArray(selector)) {
	      zrUtil.each(selector, function (item, index) {
	        zrUtil.isString(item) && (item = {
	          type: item
	        });
	        selector[index] = zrUtil.merge(item, defaultSelectorOption[item.type]);
	      });
	    }
	  },
	  optionUpdated: function () {
	    this._updateData(this.ecModel);
	
	    var legendData = this._data; // If selectedMode is single, try to select one
	
	    if (legendData[0] && this.get('selectedMode') === 'single') {
	      var hasSelected = false; // If has any selected in option.selected
	
	      for (var i = 0; i < legendData.length; i++) {
	        var name = legendData[i].get('name');
	
	        if (this.isSelected(name)) {
	          // Force to unselect others
	          this.select(name);
	          hasSelected = true;
	          break;
	        }
	      } // Try select the first if selectedMode is single
	
	
	      !hasSelected && this.select(legendData[0].get('name'));
	    }
	  },
	  _updateData: function (ecModel) {
	    var potentialData = [];
	    var availableNames = [];
	    ecModel.eachRawSeries(function (seriesModel) {
	      var seriesName = seriesModel.name;
	      availableNames.push(seriesName);
	      var isPotential;
	
	      if (seriesModel.legendVisualProvider) {
	        var provider = seriesModel.legendVisualProvider;
	        var names = provider.getAllNames();
	
	        if (!ecModel.isSeriesFiltered(seriesModel)) {
	          availableNames = availableNames.concat(names);
	        }
	
	        if (names.length) {
	          potentialData = potentialData.concat(names);
	        } else {
	          isPotential = true;
	        }
	      } else {
	        isPotential = true;
	      }
	
	      if (isPotential && isNameSpecified(seriesModel)) {
	        potentialData.push(seriesModel.name);
	      }
	    });
	    /**
	     * @type {Array.<string>}
	     * @private
	     */
	
	    this._availableNames = availableNames; // If legend.data not specified in option, use availableNames as data,
	    // which is convinient for user preparing option.
	
	    var rawData = this.get('data') || potentialData;
	    var legendData = zrUtil.map(rawData, function (dataItem) {
	      // Can be string or number
	      if (typeof dataItem === 'string' || typeof dataItem === 'number') {
	        dataItem = {
	          name: dataItem
	        };
	      }
	
	      return new Model(dataItem, this, this.ecModel);
	    }, this);
	    /**
	     * @type {Array.<module:echarts/model/Model>}
	     * @private
	     */
	
	    this._data = legendData;
	  },
	
	  /**
	   * @return {Array.<module:echarts/model/Model>}
	   */
	  getData: function () {
	    return this._data;
	  },
	
	  /**
	   * @param {string} name
	   */
	  select: function (name) {
	    var selected = this.option.selected;
	    var selectedMode = this.get('selectedMode');
	
	    if (selectedMode === 'single') {
	      var data = this._data;
	      zrUtil.each(data, function (dataItem) {
	        selected[dataItem.get('name')] = false;
	      });
	    }
	
	    selected[name] = true;
	  },
	
	  /**
	   * @param {string} name
	   */
	  unSelect: function (name) {
	    if (this.get('selectedMode') !== 'single') {
	      this.option.selected[name] = false;
	    }
	  },
	
	  /**
	   * @param {string} name
	   */
	  toggleSelected: function (name) {
	    var selected = this.option.selected; // Default is true
	
	    if (!selected.hasOwnProperty(name)) {
	      selected[name] = true;
	    }
	
	    this[selected[name] ? 'unSelect' : 'select'](name);
	  },
	  allSelect: function () {
	    var data = this._data;
	    var selected = this.option.selected;
	    zrUtil.each(data, function (dataItem) {
	      selected[dataItem.get('name', true)] = true;
	    });
	  },
	  inverseSelect: function () {
	    var data = this._data;
	    var selected = this.option.selected;
	    zrUtil.each(data, function (dataItem) {
	      var name = dataItem.get('name', true); // Initially, default value is true
	
	      if (!selected.hasOwnProperty(name)) {
	        selected[name] = true;
	      }
	
	      selected[name] = !selected[name];
	    });
	  },
	
	  /**
	   * @param {string} name
	   */
	  isSelected: function (name) {
	    var selected = this.option.selected;
	    return !(selected.hasOwnProperty(name) && !selected[name]) && zrUtil.indexOf(this._availableNames, name) >= 0;
	  },
	  getOrient: function () {
	    return this.get('orient') === 'vertical' ? {
	      index: 1,
	      name: 'vertical'
	    } : {
	      index: 0,
	      name: 'horizontal'
	    };
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 4,
	    show: true,
	    // 布局方式，默认为水平布局，可选为：
	    // 'horizontal' | 'vertical'
	    orient: 'horizontal',
	    left: 'center',
	    // right: 'center',
	    top: 0,
	    // bottom: null,
	    // 水平对齐
	    // 'auto' | 'left' | 'right'
	    // 默认为 'auto', 根据 x 的位置判断是左对齐还是右对齐
	    align: 'auto',
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 图例边框颜色
	    borderColor: '#ccc',
	    borderRadius: 0,
	    // 图例边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 图例内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // 各个item之间的间隔，单位px，默认为10，
	    // 横向布局时为水平间隔，纵向布局时为纵向间隔
	    itemGap: 10,
	    // the width of legend symbol
	    itemWidth: 25,
	    // the height of legend symbol
	    itemHeight: 14,
	    // the color of unselected legend symbol
	    inactiveColor: '#ccc',
	    // the borderColor of unselected legend symbol
	    inactiveBorderColor: '#ccc',
	    itemStyle: {
	      // the default borderWidth of legend symbol
	      borderWidth: 0
	    },
	    textStyle: {
	      // 图例文字颜色
	      color: '#333'
	    },
	    // formatter: '',
	    // 选择模式，默认开启图例开关
	    selectedMode: true,
	    // 配置默认选中状态，可配合LEGEND.SELECTED事件做动态数据载入
	    // selected: null,
	    // 图例内容（详见legend.data，数组中每一项代表一个item
	    // data: [],
	    // Usage:
	    // selector: [{type: 'all or inverse', title: xxx}]
	    // or
	    // selector: true
	    // or
	    // selector: ['all', 'inverse']
	    selector: false,
	    selectorLabel: {
	      show: true,
	      borderRadius: 10,
	      padding: [3, 5, 3, 5],
	      fontSize: 12,
	      fontFamily: ' sans-serif',
	      color: '#666',
	      borderWidth: 1,
	      borderColor: '#666'
	    },
	    emphasis: {
	      selectorLabel: {
	        show: true,
	        color: '#eee',
	        backgroundColor: '#666'
	      }
	    },
	    // Value can be 'start' or 'end'
	    selectorPosition: 'auto',
	    selectorItemGap: 7,
	    selectorButtonGap: 10,
	    // Tooltip 相关配置
	    tooltip: {
	      show: false
	    }
	  }
	});
	var _default = LegendModel;
	module.exports = _default;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function legendSelectActionHandler(methodName, payload, ecModel) {
	  var selectedMap = {};
	  var isToggleSelect = methodName === 'toggleSelected';
	  var isSelected; // Update all legend components
	
	  ecModel.eachComponent('legend', function (legendModel) {
	    if (isToggleSelect && isSelected != null) {
	      // Force other legend has same selected status
	      // Or the first is toggled to true and other are toggled to false
	      // In the case one legend has some item unSelected in option. And if other legend
	      // doesn't has the item, they will assume it is selected.
	      legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
	    } else if (methodName === 'allSelect' || methodName === 'inverseSelect') {
	      legendModel[methodName]();
	    } else {
	      legendModel[methodName](payload.name);
	      isSelected = legendModel.isSelected(payload.name);
	    }
	
	    var legendData = legendModel.getData();
	    zrUtil.each(legendData, function (model) {
	      var name = model.get('name'); // Wrap element
	
	      if (name === '\n' || name === '') {
	        return;
	      }
	
	      var isItemSelected = legendModel.isSelected(name);
	
	      if (selectedMap.hasOwnProperty(name)) {
	        // Unselected if any legend is unselected
	        selectedMap[name] = selectedMap[name] && isItemSelected;
	      } else {
	        selectedMap[name] = isItemSelected;
	      }
	    });
	  }); // Return the event explicitly
	
	  return methodName === 'allSelect' || methodName === 'inverseSelect' ? {
	    selected: selectedMap
	  } : {
	    name: payload.name,
	    selected: selectedMap
	  };
	}
	/**
	 * @event legendToggleSelect
	 * @type {Object}
	 * @property {string} type 'legendToggleSelect'
	 * @property {string} [from]
	 * @property {string} name Series name or data item name
	 */
	
	
	echarts.registerAction('legendToggleSelect', 'legendselectchanged', zrUtil.curry(legendSelectActionHandler, 'toggleSelected'));
	echarts.registerAction('legendAllSelect', 'legendselectall', zrUtil.curry(legendSelectActionHandler, 'allSelect'));
	echarts.registerAction('legendInverseSelect', 'legendinverseselect', zrUtil.curry(legendSelectActionHandler, 'inverseSelect'));
	/**
	 * @event legendSelect
	 * @type {Object}
	 * @property {string} type 'legendSelect'
	 * @property {string} name Series name or data item name
	 */
	
	echarts.registerAction('legendSelect', 'legendselected', zrUtil.curry(legendSelectActionHandler, 'select'));
	/**
	 * @event legendUnSelect
	 * @type {Object}
	 * @property {string} type 'legendUnSelect'
	 * @property {string} name Series name or data item name
	 */
	
	echarts.registerAction('legendUnSelect', 'legendunselected', zrUtil.curry(legendSelectActionHandler, 'unSelect'));

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var _symbol = __webpack_require__(360);
	
	var createSymbol = _symbol.createSymbol;
	
	var graphic = __webpack_require__(268);
	
	var _listComponent = __webpack_require__(616);
	
	var makeBackground = _listComponent.makeBackground;
	
	var layoutUtil = __webpack_require__(305);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var curry = zrUtil.curry;
	var each = zrUtil.each;
	var Group = graphic.Group;
	
	var _default = echarts.extendComponentView({
	  type: 'legend.plain',
	  newlineDisabled: false,
	
	  /**
	   * @override
	   */
	  init: function () {
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	    this.group.add(this._contentGroup = new Group());
	    /**
	     * @private
	     * @type {module:zrender/Element}
	     */
	
	    this._backgroundEl;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this.group.add(this._selectorGroup = new Group());
	    /**
	     * If first rendering, `contentGroup.position` is [0, 0], which
	     * does not make sense and may cause unexepcted animation if adopted.
	     * @private
	     * @type {boolean}
	     */
	
	    this._isFirstRender = true;
	  },
	
	  /**
	   * @protected
	   */
	  getContentGroup: function () {
	    return this._contentGroup;
	  },
	
	  /**
	   * @protected
	   */
	  getSelectorGroup: function () {
	    return this._selectorGroup;
	  },
	
	  /**
	   * @override
	   */
	  render: function (legendModel, ecModel, api) {
	    var isFirstRender = this._isFirstRender;
	    this._isFirstRender = false;
	    this.resetInner();
	
	    if (!legendModel.get('show', true)) {
	      return;
	    }
	
	    var itemAlign = legendModel.get('align');
	    var orient = legendModel.get('orient');
	
	    if (!itemAlign || itemAlign === 'auto') {
	      itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
	    }
	
	    var selector = legendModel.get('selector', true);
	    var selectorPosition = legendModel.get('selectorPosition', true);
	
	    if (selector && (!selectorPosition || selectorPosition === 'auto')) {
	      selectorPosition = orient === 'horizontal' ? 'end' : 'start';
	    }
	
	    this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition); // Perform layout.
	
	    var positionInfo = legendModel.getBoxLayoutParams();
	    var viewportSize = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    };
	    var padding = legendModel.get('padding');
	    var maxSize = layoutUtil.getLayoutRect(positionInfo, viewportSize, padding);
	    var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition); // Place mainGroup, based on the calculated `mainRect`.
	
	    var layoutRect = layoutUtil.getLayoutRect(zrUtil.defaults({
	      width: mainRect.width,
	      height: mainRect.height
	    }, positionInfo), viewportSize, padding);
	    this.group.attr('position', [layoutRect.x - mainRect.x, layoutRect.y - mainRect.y]); // Render background after group is layout.
	
	    this.group.add(this._backgroundEl = makeBackground(mainRect, legendModel));
	  },
	
	  /**
	   * @protected
	   */
	  resetInner: function () {
	    this.getContentGroup().removeAll();
	    this._backgroundEl && this.group.remove(this._backgroundEl);
	    this.getSelectorGroup().removeAll();
	  },
	
	  /**
	   * @protected
	   */
	  renderInner: function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
	    var contentGroup = this.getContentGroup();
	    var legendDrawnMap = zrUtil.createHashMap();
	    var selectMode = legendModel.get('selectedMode');
	    var excludeSeriesId = [];
	    ecModel.eachRawSeries(function (seriesModel) {
	      !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
	    });
	    each(legendModel.getData(), function (itemModel, dataIndex) {
	      var name = itemModel.get('name'); // Use empty string or \n as a newline string
	
	      if (!this.newlineDisabled && (name === '' || name === '\n')) {
	        contentGroup.add(new Group({
	          newline: true
	        }));
	        return;
	      } // Representitive series.
	
	
	      var seriesModel = ecModel.getSeriesByName(name)[0];
	
	      if (legendDrawnMap.get(name)) {
	        // Have been drawed
	        return;
	      } // Legend to control series.
	
	
	      if (seriesModel) {
	        var data = seriesModel.getData();
	        var color = data.getVisual('color');
	        var borderColor = data.getVisual('borderColor'); // If color is a callback function
	
	        if (typeof color === 'function') {
	          // Use the first data
	          color = color(seriesModel.getDataParams(0));
	        } // If borderColor is a callback function
	
	
	        if (typeof borderColor === 'function') {
	          // Use the first data
	          borderColor = borderColor(seriesModel.getDataParams(0));
	        } // Using rect symbol defaultly
	
	
	        var legendSymbolType = data.getVisual('legendSymbol') || 'roundRect';
	        var symbolType = data.getVisual('symbol');
	
	        var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode);
	
	        itemGroup.on('click', curry(dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', curry(dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
	        legendDrawnMap.set(name, true);
	      } else {
	        // Legend to control data. In pie and funnel.
	        ecModel.eachRawSeries(function (seriesModel) {
	          // In case multiple series has same data name
	          if (legendDrawnMap.get(name)) {
	            return;
	          }
	
	          if (seriesModel.legendVisualProvider) {
	            var provider = seriesModel.legendVisualProvider;
	
	            if (!provider.containName(name)) {
	              return;
	            }
	
	            var idx = provider.indexOfName(name);
	            var color = provider.getItemVisual(idx, 'color');
	            var borderColor = provider.getItemVisual(idx, 'borderColor');
	            var legendSymbolType = 'roundRect';
	
	            var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, null, itemAlign, color, borderColor, selectMode); // FIXME: consider different series has items with the same name.
	
	
	            itemGroup.on('click', curry(dispatchSelectAction, null, name, api, excludeSeriesId)) // Should not specify the series name, consider legend controls
	            // more than one pie series.
	            .on('mouseover', curry(dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, null, name, api, excludeSeriesId));
	            legendDrawnMap.set(name, true);
	          }
	        }, this);
	      }
	    }, this);
	
	    if (selector) {
	      this._createSelector(selector, legendModel, api, orient, selectorPosition);
	    }
	  },
	  _createSelector: function (selector, legendModel, api, orient, selectorPosition) {
	    var selectorGroup = this.getSelectorGroup();
	    each(selector, function (selectorItem) {
	      createSelectorButton(selectorItem);
	    });
	
	    function createSelectorButton(selectorItem) {
	      var type = selectorItem.type;
	      var labelText = new graphic.Text({
	        style: {
	          x: 0,
	          y: 0,
	          align: 'center',
	          verticalAlign: 'middle'
	        },
	        onclick: function () {
	          api.dispatchAction({
	            type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect'
	          });
	        }
	      });
	      selectorGroup.add(labelText);
	      var labelModel = legendModel.getModel('selectorLabel');
	      var emphasisLabelModel = legendModel.getModel('emphasis.selectorLabel');
	      graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, emphasisLabelModel, {
	        defaultText: selectorItem.title,
	        isRectText: false
	      });
	      graphic.setHoverStyle(labelText);
	    }
	  },
	  _createItem: function (name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode) {
	    var itemWidth = legendModel.get('itemWidth');
	    var itemHeight = legendModel.get('itemHeight');
	    var inactiveColor = legendModel.get('inactiveColor');
	    var inactiveBorderColor = legendModel.get('inactiveBorderColor');
	    var symbolKeepAspect = legendModel.get('symbolKeepAspect');
	    var legendModelItemStyle = legendModel.getModel('itemStyle');
	    var isSelected = legendModel.isSelected(name);
	    var itemGroup = new Group();
	    var textStyleModel = itemModel.getModel('textStyle');
	    var itemIcon = itemModel.get('icon');
	    var tooltipModel = itemModel.getModel('tooltip');
	    var legendGlobalTooltipModel = tooltipModel.parentModel; // Use user given icon first
	
	    legendSymbolType = itemIcon || legendSymbolType;
	    var legendSymbol = createSymbol(legendSymbolType, 0, 0, itemWidth, itemHeight, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
	    symbolKeepAspect == null ? true : symbolKeepAspect);
	    itemGroup.add(setSymbolStyle(legendSymbol, legendSymbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected)); // Compose symbols
	    // PENDING
	
	    if (!itemIcon && symbolType // At least show one symbol, can't be all none
	    && (symbolType !== legendSymbolType || symbolType === 'none')) {
	      var size = itemHeight * 0.8;
	
	      if (symbolType === 'none') {
	        symbolType = 'circle';
	      }
	
	      var legendSymbolCenter = createSymbol(symbolType, (itemWidth - size) / 2, (itemHeight - size) / 2, size, size, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
	      symbolKeepAspect == null ? true : symbolKeepAspect); // Put symbol in the center
	
	      itemGroup.add(setSymbolStyle(legendSymbolCenter, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected));
	    }
	
	    var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
	    var textAlign = itemAlign;
	    var formatter = legendModel.get('formatter');
	    var content = name;
	
	    if (typeof formatter === 'string' && formatter) {
	      content = formatter.replace('{name}', name != null ? name : '');
	    } else if (typeof formatter === 'function') {
	      content = formatter(name);
	    }
	
	    itemGroup.add(new graphic.Text({
	      style: graphic.setTextStyle({}, textStyleModel, {
	        text: content,
	        x: textX,
	        y: itemHeight / 2,
	        textFill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
	        textAlign: textAlign,
	        textVerticalAlign: 'middle'
	      })
	    })); // Add a invisible rect to increase the area of mouse hover
	
	    var hitRect = new graphic.Rect({
	      shape: itemGroup.getBoundingRect(),
	      invisible: true,
	      tooltip: tooltipModel.get('show') ? zrUtil.extend({
	        content: name,
	        // Defaul formatter
	        formatter: legendGlobalTooltipModel.get('formatter', true) || function () {
	          return name;
	        },
	        formatterParams: {
	          componentType: 'legend',
	          legendIndex: legendModel.componentIndex,
	          name: name,
	          $vars: ['name']
	        }
	      }, tooltipModel.option) : null
	    });
	    itemGroup.add(hitRect);
	    itemGroup.eachChild(function (child) {
	      child.silent = true;
	    });
	    hitRect.silent = !selectMode;
	    this.getContentGroup().add(itemGroup);
	    graphic.setHoverStyle(itemGroup);
	    itemGroup.__legendDataIndex = dataIndex;
	    return itemGroup;
	  },
	
	  /**
	   * @protected
	   */
	  layoutInner: function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
	    var contentGroup = this.getContentGroup();
	    var selectorGroup = this.getSelectorGroup(); // Place items in contentGroup.
	
	    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
	    var contentRect = contentGroup.getBoundingRect();
	    var contentPos = [-contentRect.x, -contentRect.y];
	
	    if (selector) {
	      // Place buttons in selectorGroup
	      layoutUtil.box( // Buttons in selectorGroup always layout horizontally
	      'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
	      var selectorRect = selectorGroup.getBoundingRect();
	      var selectorPos = [-selectorRect.x, -selectorRect.y];
	      var selectorButtonGap = legendModel.get('selectorButtonGap', true);
	      var orientIdx = legendModel.getOrient().index;
	      var wh = orientIdx === 0 ? 'width' : 'height';
	      var hw = orientIdx === 0 ? 'height' : 'width';
	      var yx = orientIdx === 0 ? 'y' : 'x';
	
	      if (selectorPosition === 'end') {
	        selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
	      } else {
	        contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
	      } //Always align selector to content as 'middle'
	
	
	      selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
	      selectorGroup.attr('position', selectorPos);
	      contentGroup.attr('position', contentPos);
	      var mainRect = {
	        x: 0,
	        y: 0
	      };
	      mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
	      mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
	      mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
	      return mainRect;
	    } else {
	      contentGroup.attr('position', contentPos);
	      return this.group.getBoundingRect();
	    }
	  },
	
	  /**
	   * @protected
	   */
	  remove: function () {
	    this.getContentGroup().removeAll();
	    this._isFirstRender = true;
	  }
	});
	
	function setSymbolStyle(symbol, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected) {
	  var itemStyle;
	
	  if (symbolType !== 'line' && symbolType.indexOf('empty') < 0) {
	    itemStyle = legendModelItemStyle.getItemStyle();
	    symbol.style.stroke = borderColor;
	
	    if (!isSelected) {
	      itemStyle.stroke = inactiveBorderColor;
	    }
	  } else {
	    itemStyle = legendModelItemStyle.getItemStyle(['borderWidth', 'borderColor']);
	  }
	
	  return symbol.setStyle(itemStyle);
	}
	
	function dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
	  // downplay before unselect
	  dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
	  api.dispatchAction({
	    type: 'legendToggleSelect',
	    name: seriesName != null ? seriesName : dataName
	  }); // highlight after select
	
	  dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
	}
	
	function dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
	  // If element hover will move to a hoverLayer.
	  var el = api.getZr().storage.getDisplayList()[0];
	
	  if (!(el && el.useHoverLayer)) {
	    api.dispatchAction({
	      type: 'highlight',
	      seriesName: seriesName,
	      name: dataName,
	      excludeSeriesId: excludeSeriesId
	    });
	  }
	}
	
	function dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
	  // If element hover will move to a hoverLayer.
	  var el = api.getZr().storage.getDisplayList()[0];
	
	  if (!(el && el.useHoverLayer)) {
	    api.dispatchAction({
	      type: 'downplay',
	      seriesName: seriesName,
	      name: dataName,
	      excludeSeriesId: excludeSeriesId
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (legendModels && legendModels.length) {
	    ecModel.filterSeries(function (series) {
	      // If in any legend component the status is not selected.
	      // Because in legend series is assumed selected when it is not in the legend data.
	      for (var i = 0; i < legendModels.length; i++) {
	        if (!legendModels[i].isSelected(series.name)) {
	          return false;
	        }
	      }
	
	      return true;
	    });
	  }
	}
	
	module.exports = _default;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var LegendModel = __webpack_require__(672);
	
	var _layout = __webpack_require__(305);
	
	var mergeLayoutParam = _layout.mergeLayoutParam;
	var getLayoutParams = _layout.getLayoutParams;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ScrollableLegendModel = LegendModel.extend({
	  type: 'legend.scroll',
	
	  /**
	   * @param {number} scrollDataIndex
	   */
	  setScrollDataIndex: function (scrollDataIndex) {
	    this.option.scrollDataIndex = scrollDataIndex;
	  },
	  defaultOption: {
	    scrollDataIndex: 0,
	    pageButtonItemGap: 5,
	    pageButtonGap: null,
	    pageButtonPosition: 'end',
	    // 'start' or 'end'
	    pageFormatter: '{current}/{total}',
	    // If null/undefined, do not show page.
	    pageIcons: {
	      horizontal: ['M0,0L12,-10L12,10z', 'M0,0L-12,-10L-12,10z'],
	      vertical: ['M0,0L20,0L10,-20z', 'M0,0L20,0L10,20z']
	    },
	    pageIconColor: '#2f4554',
	    pageIconInactiveColor: '#aaa',
	    pageIconSize: 15,
	    // Can be [10, 3], which represents [width, height]
	    pageTextStyle: {
	      color: '#333'
	    },
	    animationDurationUpdate: 800
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    var inputPositionParams = getLayoutParams(option);
	    ScrollableLegendModel.superCall(this, 'init', option, parentModel, ecModel, extraOpt);
	    mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option, extraOpt) {
	    ScrollableLegendModel.superCall(this, 'mergeOption', option, extraOpt);
	    mergeAndNormalizeLayoutParams(this, this.option, option);
	  }
	}); // Do not `ignoreSize` to enable setting {left: 10, right: 10}.
	
	function mergeAndNormalizeLayoutParams(legendModel, target, raw) {
	  var orient = legendModel.getOrient();
	  var ignoreSize = [1, 1];
	  ignoreSize[orient.index] = 0;
	  mergeLayoutParam(target, raw, {
	    type: 'box',
	    ignoreSize: ignoreSize
	  });
	}
	
	var _default = ScrollableLegendModel;
	module.exports = _default;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var layoutUtil = __webpack_require__(305);
	
	var LegendView = __webpack_require__(674);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Separate legend and scrollable legend to reduce package size.
	 */
	var Group = graphic.Group;
	var WH = ['width', 'height'];
	var XY = ['x', 'y'];
	var ScrollableLegendView = LegendView.extend({
	  type: 'legend.scroll',
	  newlineDisabled: true,
	  init: function () {
	    ScrollableLegendView.superCall(this, 'init');
	    /**
	     * @private
	     * @type {number} For `scroll`.
	     */
	
	    this._currentIndex = 0;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this.group.add(this._containerGroup = new Group());
	
	    this._containerGroup.add(this.getContentGroup());
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	
	    this.group.add(this._controllerGroup = new Group());
	    /**
	     *
	     * @private
	     */
	
	    this._showController;
	  },
	
	  /**
	   * @override
	   */
	  resetInner: function () {
	    ScrollableLegendView.superCall(this, 'resetInner');
	
	    this._controllerGroup.removeAll();
	
	    this._containerGroup.removeClipPath();
	
	    this._containerGroup.__rectSize = null;
	  },
	
	  /**
	   * @override
	   */
	  renderInner: function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
	    var me = this; // Render content items.
	
	    ScrollableLegendView.superCall(this, 'renderInner', itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
	    var controllerGroup = this._controllerGroup; // FIXME: support be 'auto' adapt to size number text length,
	    // e.g., '3/12345' should not overlap with the control arrow button.
	
	    var pageIconSize = legendModel.get('pageIconSize', true);
	
	    if (!zrUtil.isArray(pageIconSize)) {
	      pageIconSize = [pageIconSize, pageIconSize];
	    }
	
	    createPageButton('pagePrev', 0);
	    var pageTextStyleModel = legendModel.getModel('pageTextStyle');
	    controllerGroup.add(new graphic.Text({
	      name: 'pageText',
	      style: {
	        textFill: pageTextStyleModel.getTextColor(),
	        font: pageTextStyleModel.getFont(),
	        textVerticalAlign: 'middle',
	        textAlign: 'center'
	      },
	      silent: true
	    }));
	    createPageButton('pageNext', 1);
	
	    function createPageButton(name, iconIdx) {
	      var pageDataIndexName = name + 'DataIndex';
	      var icon = graphic.createIcon(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
	        // Buttons will be created in each render, so we do not need
	        // to worry about avoiding using legendModel kept in scope.
	        onclick: zrUtil.bind(me._pageGo, me, pageDataIndexName, legendModel, api)
	      }, {
	        x: -pageIconSize[0] / 2,
	        y: -pageIconSize[1] / 2,
	        width: pageIconSize[0],
	        height: pageIconSize[1]
	      });
	      icon.name = name;
	      controllerGroup.add(icon);
	    }
	  },
	
	  /**
	   * @override
	   */
	  layoutInner: function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
	    var selectorGroup = this.getSelectorGroup();
	    var orientIdx = legendModel.getOrient().index;
	    var wh = WH[orientIdx];
	    var xy = XY[orientIdx];
	    var hw = WH[1 - orientIdx];
	    var yx = XY[1 - orientIdx];
	    selector && layoutUtil.box( // Buttons in selectorGroup always layout horizontally
	    'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
	    var selectorButtonGap = legendModel.get('selectorButtonGap', true);
	    var selectorRect = selectorGroup.getBoundingRect();
	    var selectorPos = [-selectorRect.x, -selectorRect.y];
	    var processMaxSize = zrUtil.clone(maxSize);
	    selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
	
	    var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx);
	
	    if (selector) {
	      if (selectorPosition === 'end') {
	        selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
	      } else {
	        var offset = selectorRect[wh] + selectorButtonGap;
	        selectorPos[orientIdx] -= offset;
	        mainRect[xy] -= offset;
	      }
	
	      mainRect[wh] += selectorRect[wh] + selectorButtonGap;
	      selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
	      mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
	      mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
	      selectorGroup.attr('position', selectorPos);
	    }
	
	    return mainRect;
	  },
	  _layoutContentAndController: function (legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx) {
	    var contentGroup = this.getContentGroup();
	    var containerGroup = this._containerGroup;
	    var controllerGroup = this._controllerGroup; // Place items in contentGroup.
	
	    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
	    layoutUtil.box( // Buttons in controller are layout always horizontally.
	    'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
	    var contentRect = contentGroup.getBoundingRect();
	    var controllerRect = controllerGroup.getBoundingRect();
	    var showController = this._showController = contentRect[wh] > maxSize[wh];
	    var contentPos = [-contentRect.x, -contentRect.y]; // Remain contentPos when scroll animation perfroming.
	    // If first rendering, `contentGroup.position` is [0, 0], which
	    // does not make sense and may cause unexepcted animation if adopted.
	
	    if (!isFirstRender) {
	      contentPos[orientIdx] = contentGroup.position[orientIdx];
	    } // Layout container group based on 0.
	
	
	    var containerPos = [0, 0];
	    var controllerPos = [-controllerRect.x, -controllerRect.y];
	    var pageButtonGap = zrUtil.retrieve2(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true)); // Place containerGroup and controllerGroup and contentGroup.
	
	    if (showController) {
	      var pageButtonPosition = legendModel.get('pageButtonPosition', true); // controller is on the right / bottom.
	
	      if (pageButtonPosition === 'end') {
	        controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
	      } // controller is on the left / top.
	      else {
	          containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
	        }
	    } // Always align controller to content as 'middle'.
	
	
	    controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
	    contentGroup.attr('position', contentPos);
	    containerGroup.attr('position', containerPos);
	    controllerGroup.attr('position', controllerPos); // Calculate `mainRect` and set `clipPath`.
	    // mainRect should not be calculated by `this.group.getBoundingRect()`
	    // for sake of the overflow.
	
	    var mainRect = {
	      x: 0,
	      y: 0
	    }; // Consider content may be overflow (should be clipped).
	
	    mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
	    mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]); // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
	
	    mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
	    containerGroup.__rectSize = maxSize[wh];
	
	    if (showController) {
	      var clipShape = {
	        x: 0,
	        y: 0
	      };
	      clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
	      clipShape[hw] = mainRect[hw];
	      containerGroup.setClipPath(new graphic.Rect({
	        shape: clipShape
	      })); // Consider content may be larger than container, container rect
	      // can not be obtained from `containerGroup.getBoundingRect()`.
	
	      containerGroup.__rectSize = clipShape[wh];
	    } else {
	      // Do not remove or ignore controller. Keep them set as placeholders.
	      controllerGroup.eachChild(function (child) {
	        child.attr({
	          invisible: true,
	          silent: true
	        });
	      });
	    } // Content translate animation.
	
	
	    var pageInfo = this._getPageInfo(legendModel);
	
	    pageInfo.pageIndex != null && graphic.updateProps(contentGroup, {
	      position: pageInfo.contentPosition
	    }, // When switch from "show controller" to "not show controller", view should be
	    // updated immediately without animation, otherwise causes weird effect.
	    showController ? legendModel : false);
	
	    this._updatePageInfoView(legendModel, pageInfo);
	
	    return mainRect;
	  },
	  _pageGo: function (to, legendModel, api) {
	    var scrollDataIndex = this._getPageInfo(legendModel)[to];
	
	    scrollDataIndex != null && api.dispatchAction({
	      type: 'legendScroll',
	      scrollDataIndex: scrollDataIndex,
	      legendId: legendModel.id
	    });
	  },
	  _updatePageInfoView: function (legendModel, pageInfo) {
	    var controllerGroup = this._controllerGroup;
	    zrUtil.each(['pagePrev', 'pageNext'], function (name) {
	      var canJump = pageInfo[name + 'DataIndex'] != null;
	      var icon = controllerGroup.childOfName(name);
	
	      if (icon) {
	        icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
	        icon.cursor = canJump ? 'pointer' : 'default';
	      }
	    });
	    var pageText = controllerGroup.childOfName('pageText');
	    var pageFormatter = legendModel.get('pageFormatter');
	    var pageIndex = pageInfo.pageIndex;
	    var current = pageIndex != null ? pageIndex + 1 : 0;
	    var total = pageInfo.pageCount;
	    pageText && pageFormatter && pageText.setStyle('text', zrUtil.isString(pageFormatter) ? pageFormatter.replace('{current}', current).replace('{total}', total) : pageFormatter({
	      current: current,
	      total: total
	    }));
	  },
	
	  /**
	   * @param {module:echarts/model/Model} legendModel
	   * @return {Object} {
	   *  contentPosition: Array.<number>, null when data item not found.
	   *  pageIndex: number, null when data item not found.
	   *  pageCount: number, always be a number, can be 0.
	   *  pagePrevDataIndex: number, null when no previous page.
	   *  pageNextDataIndex: number, null when no next page.
	   * }
	   */
	  _getPageInfo: function (legendModel) {
	    var scrollDataIndex = legendModel.get('scrollDataIndex', true);
	    var contentGroup = this.getContentGroup();
	    var containerRectSize = this._containerGroup.__rectSize;
	    var orientIdx = legendModel.getOrient().index;
	    var wh = WH[orientIdx];
	    var xy = XY[orientIdx];
	
	    var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
	
	    var children = contentGroup.children();
	    var targetItem = children[targetItemIndex];
	    var itemCount = children.length;
	    var pCount = !itemCount ? 0 : 1;
	    var result = {
	      contentPosition: contentGroup.position.slice(),
	      pageCount: pCount,
	      pageIndex: pCount - 1,
	      pagePrevDataIndex: null,
	      pageNextDataIndex: null
	    };
	
	    if (!targetItem) {
	      return result;
	    }
	
	    var targetItemInfo = getItemInfo(targetItem);
	    result.contentPosition[orientIdx] = -targetItemInfo.s; // Strategy:
	    // (1) Always align based on the left/top most item.
	    // (2) It is user-friendly that the last item shown in the
	    // current window is shown at the begining of next window.
	    // Otherwise if half of the last item is cut by the window,
	    // it will have no chance to display entirely.
	    // (3) Consider that item size probably be different, we
	    // have calculate pageIndex by size rather than item index,
	    // and we can not get page index directly by division.
	    // (4) The window is to narrow to contain more than
	    // one item, we should make sure that the page can be fliped.
	
	    for (var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i) {
	      currItemInfo = getItemInfo(children[i]);
	
	      if ( // Half of the last item is out of the window.
	      !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || // If the current item does not intersect with the window, the new page
	      // can be started at the current item or the last item.
	      currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
	        if (winEndItemInfo.i > winStartItemInfo.i) {
	          winStartItemInfo = winEndItemInfo;
	        } else {
	          // e.g., when page size is smaller than item size.
	          winStartItemInfo = currItemInfo;
	        }
	
	        if (winStartItemInfo) {
	          if (result.pageNextDataIndex == null) {
	            result.pageNextDataIndex = winStartItemInfo.i;
	          }
	
	          ++result.pageCount;
	        }
	      }
	
	      winEndItemInfo = currItemInfo;
	    }
	
	    for (var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i) {
	      currItemInfo = getItemInfo(children[i]);
	
	      if ( // If the the end item does not intersect with the window started
	      // from the current item, a page can be settled.
	      (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && // e.g., when page size is smaller than item size.
	      winStartItemInfo.i < winEndItemInfo.i) {
	        winEndItemInfo = winStartItemInfo;
	
	        if (result.pagePrevDataIndex == null) {
	          result.pagePrevDataIndex = winStartItemInfo.i;
	        }
	
	        ++result.pageCount;
	        ++result.pageIndex;
	      }
	
	      winStartItemInfo = currItemInfo;
	    }
	
	    return result;
	
	    function getItemInfo(el) {
	      if (el) {
	        var itemRect = el.getBoundingRect();
	        var start = itemRect[xy] + el.position[orientIdx];
	        return {
	          s: start,
	          e: start + itemRect[wh],
	          i: el.__legendDataIndex
	        };
	      }
	    }
	
	    function intersect(itemInfo, winStart) {
	      return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
	    }
	  },
	  _findTargetItemIndex: function (targetDataIndex) {
	    if (!this._showController) {
	      return 0;
	    }
	
	    var index;
	    var contentGroup = this.getContentGroup();
	    var defaultIndex;
	    contentGroup.eachChild(function (child, idx) {
	      var legendDataIdx = child.__legendDataIndex; // FIXME
	      // If the given targetDataIndex (from model) is illegal,
	      // we use defaultIndex. But the index on the legend model and
	      // action payload is still illegal. That case will not be
	      // changed until some scenario requires.
	
	      if (defaultIndex == null && legendDataIdx != null) {
	        defaultIndex = idx;
	      }
	
	      if (legendDataIdx === targetDataIndex) {
	        index = idx;
	      }
	    });
	    return index != null ? index : defaultIndex;
	  }
	});
	var _default = ScrollableLegendView;
	module.exports = _default;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @event legendScroll
	 * @type {Object}
	 * @property {string} type 'legendScroll'
	 * @property {string} scrollDataIndex
	 */
	echarts.registerAction('legendScroll', 'legendscroll', function (payload, ecModel) {
	  var scrollDataIndex = payload.scrollDataIndex;
	  scrollDataIndex != null && ecModel.eachComponent({
	    mainType: 'legend',
	    subType: 'scroll',
	    query: payload
	  }, function (legendModel) {
	    legendModel.setScrollDataIndex(scrollDataIndex);
	  });
	});

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(680);
	
	__webpack_require__(683);

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(624);
	
	__webpack_require__(625);
	
	__webpack_require__(628);
	
	__webpack_require__(681);
	
	__webpack_require__(682);
	
	__webpack_require__(631);
	
	__webpack_require__(632);

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(625);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SliderZoomModel = DataZoomModel.extend({
	  type: 'dataZoom.slider',
	  layoutMode: 'box',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    show: true,
	    // ph => placeholder. Using placehoder here because
	    // deault value can only be drived in view stage.
	    right: 'ph',
	    // Default align to grid rect.
	    top: 'ph',
	    // Default align to grid rect.
	    width: 'ph',
	    // Default align to grid rect.
	    height: 'ph',
	    // Default align to grid rect.
	    left: null,
	    // Default align to grid rect.
	    bottom: null,
	    // Default align to grid rect.
	    backgroundColor: 'rgba(47,69,84,0)',
	    // Background of slider zoom component.
	    // dataBackgroundColor: '#ddd',         // Background coor of data shadow and border of box,
	    // highest priority, remain for compatibility of
	    // previous version, but not recommended any more.
	    dataBackground: {
	      lineStyle: {
	        color: '#2f4554',
	        width: 0.5,
	        opacity: 0.3
	      },
	      areaStyle: {
	        color: 'rgba(47,69,84,0.3)',
	        opacity: 0.3
	      }
	    },
	    borderColor: '#ddd',
	    // border color of the box. For compatibility,
	    // if dataBackgroundColor is set, borderColor
	    // is ignored.
	    fillerColor: 'rgba(167,183,204,0.4)',
	    // Color of selected area.
	    // handleColor: 'rgba(89,170,216,0.95)',     // Color of handle.
	    // handleIcon: 'path://M4.9,17.8c0-1.4,4.5-10.5,5.5-12.4c0-0.1,0.6-1.1,0.9-1.1c0.4,0,0.9,1,0.9,1.1c1.1,2.2,5.4,11,5.4,12.4v17.8c0,1.5-0.6,2.1-1.3,2.1H6.1c-0.7,0-1.3-0.6-1.3-2.1V17.8z',
	
	    /* eslint-disable */
	    handleIcon: 'M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z',
	
	    /* eslint-enable */
	    // Percent of the slider height
	    handleSize: '100%',
	    handleStyle: {
	      color: '#a7b7cc'
	    },
	    labelPrecision: null,
	    labelFormatter: null,
	    showDetail: true,
	    showDataShadow: 'auto',
	    // Default auto decision.
	    realtime: true,
	    zoomLock: false,
	    // Whether disable zoom.
	    textStyle: {
	      color: '#333'
	    }
	  }
	});
	var _default = SliderZoomModel;
	module.exports = _default;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var eventTool = __webpack_require__(225);
	
	var graphic = __webpack_require__(268);
	
	var throttle = __webpack_require__(327);
	
	var DataZoomView = __webpack_require__(628);
	
	var numberUtil = __webpack_require__(306);
	
	var layout = __webpack_require__(305);
	
	var sliderMove = __webpack_require__(507);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var Rect = graphic.Rect;
	var linearMap = numberUtil.linearMap;
	var asc = numberUtil.asc;
	var bind = zrUtil.bind;
	var each = zrUtil.each; // Constants
	
	var DEFAULT_LOCATION_EDGE_GAP = 7;
	var DEFAULT_FRAME_BORDER_WIDTH = 1;
	var DEFAULT_FILLER_SIZE = 30;
	var HORIZONTAL = 'horizontal';
	var VERTICAL = 'vertical';
	var LABEL_GAP = 5;
	var SHOW_DATA_SHADOW_SERIES_TYPE = ['line', 'bar', 'candlestick', 'scatter'];
	var SliderZoomView = DataZoomView.extend({
	  type: 'dataZoom.slider',
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {Object}
	     */
	    this._displayables = {};
	    /**
	     * @private
	     * @type {string}
	     */
	
	    this._orient;
	    /**
	     * [0, 100]
	     * @private
	     */
	
	    this._range;
	    /**
	     * [coord of the first handle, coord of the second handle]
	     * @private
	     */
	
	    this._handleEnds;
	    /**
	     * [length, thick]
	     * @private
	     * @type {Array.<number>}
	     */
	
	    this._size;
	    /**
	     * @private
	     * @type {number}
	     */
	
	    this._handleWidth;
	    /**
	     * @private
	     * @type {number}
	     */
	
	    this._handleHeight;
	    /**
	     * @private
	     */
	
	    this._location;
	    /**
	     * @private
	     */
	
	    this._dragging;
	    /**
	     * @private
	     */
	
	    this._dataShadowInfo;
	    this.api = api;
	  },
	
	  /**
	   * @override
	   */
	  render: function (dataZoomModel, ecModel, api, payload) {
	    SliderZoomView.superApply(this, 'render', arguments);
	    throttle.createOrUpdate(this, '_dispatchZoomAction', this.dataZoomModel.get('throttle'), 'fixRate');
	    this._orient = dataZoomModel.get('orient');
	
	    if (this.dataZoomModel.get('show') === false) {
	      this.group.removeAll();
	      return;
	    } // Notice: this._resetInterval() should not be executed when payload.type
	    // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
	    // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
	
	
	    if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) {
	      this._buildView();
	    }
	
	    this._updateView();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    SliderZoomView.superApply(this, 'remove', arguments);
	    throttle.clear(this, '_dispatchZoomAction');
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    SliderZoomView.superApply(this, 'dispose', arguments);
	    throttle.clear(this, '_dispatchZoomAction');
	  },
	  _buildView: function () {
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	
	    this._resetLocation();
	
	    this._resetInterval();
	
	    var barGroup = this._displayables.barGroup = new graphic.Group();
	
	    this._renderBackground();
	
	    this._renderHandle();
	
	    this._renderDataShadow();
	
	    thisGroup.add(barGroup);
	
	    this._positionGroup();
	  },
	
	  /**
	   * @private
	   */
	  _resetLocation: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var api = this.api; // If some of x/y/width/height are not specified,
	    // auto-adapt according to target grid.
	
	    var coordRect = this._findCoordRect();
	
	    var ecSize = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    }; // Default align by coordinate system rect.
	
	    var positionInfo = this._orient === HORIZONTAL ? {
	      // Why using 'right', because right should be used in vertical,
	      // and it is better to be consistent for dealing with position param merge.
	      right: ecSize.width - coordRect.x - coordRect.width,
	      top: ecSize.height - DEFAULT_FILLER_SIZE - DEFAULT_LOCATION_EDGE_GAP,
	      width: coordRect.width,
	      height: DEFAULT_FILLER_SIZE
	    } : {
	      // vertical
	      right: DEFAULT_LOCATION_EDGE_GAP,
	      top: coordRect.y,
	      width: DEFAULT_FILLER_SIZE,
	      height: coordRect.height
	    }; // Do not write back to option and replace value 'ph', because
	    // the 'ph' value should be recalculated when resize.
	
	    var layoutParams = layout.getLayoutParams(dataZoomModel.option); // Replace the placeholder value.
	
	    zrUtil.each(['right', 'top', 'width', 'height'], function (name) {
	      if (layoutParams[name] === 'ph') {
	        layoutParams[name] = positionInfo[name];
	      }
	    });
	    var layoutRect = layout.getLayoutRect(layoutParams, ecSize, dataZoomModel.padding);
	    this._location = {
	      x: layoutRect.x,
	      y: layoutRect.y
	    };
	    this._size = [layoutRect.width, layoutRect.height];
	    this._orient === VERTICAL && this._size.reverse();
	  },
	
	  /**
	   * @private
	   */
	  _positionGroup: function () {
	    var thisGroup = this.group;
	    var location = this._location;
	    var orient = this._orient; // Just use the first axis to determine mapping.
	
	    var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
	    var inverse = targetAxisModel && targetAxisModel.get('inverse');
	    var barGroup = this._displayables.barGroup;
	    var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse; // Transform barGroup.
	
	    barGroup.attr(orient === HORIZONTAL && !inverse ? {
	      scale: otherAxisInverse ? [1, 1] : [1, -1]
	    } : orient === HORIZONTAL && inverse ? {
	      scale: otherAxisInverse ? [-1, 1] : [-1, -1]
	    } : orient === VERTICAL && !inverse ? {
	      scale: otherAxisInverse ? [1, -1] : [1, 1],
	      rotation: Math.PI / 2 // Dont use Math.PI, considering shadow direction.
	
	    } : {
	      scale: otherAxisInverse ? [-1, -1] : [-1, 1],
	      rotation: Math.PI / 2
	    }); // Position barGroup
	
	    var rect = thisGroup.getBoundingRect([barGroup]);
	    thisGroup.attr('position', [location.x - rect.x, location.y - rect.y]);
	  },
	
	  /**
	   * @private
	   */
	  _getViewExtent: function () {
	    return [0, this._size[0]];
	  },
	  _renderBackground: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var size = this._size;
	    var barGroup = this._displayables.barGroup;
	    barGroup.add(new Rect({
	      silent: true,
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        fill: dataZoomModel.get('backgroundColor')
	      },
	      z2: -40
	    })); // Click panel, over shadow, below handles.
	
	    barGroup.add(new Rect({
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        fill: 'transparent'
	      },
	      z2: 0,
	      onclick: zrUtil.bind(this._onClickPanelClick, this)
	    }));
	  },
	  _renderDataShadow: function () {
	    var info = this._dataShadowInfo = this._prepareDataShadowInfo();
	
	    if (!info) {
	      return;
	    }
	
	    var size = this._size;
	    var seriesModel = info.series;
	    var data = seriesModel.getRawData();
	    var otherDim = seriesModel.getShadowDim ? seriesModel.getShadowDim() // @see candlestick
	    : info.otherDim;
	
	    if (otherDim == null) {
	      return;
	    }
	
	    var otherDataExtent = data.getDataExtent(otherDim); // Nice extent.
	
	    var otherOffset = (otherDataExtent[1] - otherDataExtent[0]) * 0.3;
	    otherDataExtent = [otherDataExtent[0] - otherOffset, otherDataExtent[1] + otherOffset];
	    var otherShadowExtent = [0, size[1]];
	    var thisShadowExtent = [0, size[0]];
	    var areaPoints = [[size[0], 0], [0, 0]];
	    var linePoints = [];
	    var step = thisShadowExtent[1] / (data.count() - 1);
	    var thisCoord = 0; // Optimize for large data shadow
	
	    var stride = Math.round(data.count() / size[0]);
	    var lastIsEmpty;
	    data.each([otherDim], function (value, index) {
	      if (stride > 0 && index % stride) {
	        thisCoord += step;
	        return;
	      } // FIXME
	      // Should consider axis.min/axis.max when drawing dataShadow.
	      // FIXME
	      // 应该使用统一的空判断？还是在list里进行空判断？
	
	
	      var isEmpty = value == null || isNaN(value) || value === ''; // See #4235.
	
	      var otherCoord = isEmpty ? 0 : linearMap(value, otherDataExtent, otherShadowExtent, true); // Attempt to draw data shadow precisely when there are empty value.
	
	      if (isEmpty && !lastIsEmpty && index) {
	        areaPoints.push([areaPoints[areaPoints.length - 1][0], 0]);
	        linePoints.push([linePoints[linePoints.length - 1][0], 0]);
	      } else if (!isEmpty && lastIsEmpty) {
	        areaPoints.push([thisCoord, 0]);
	        linePoints.push([thisCoord, 0]);
	      }
	
	      areaPoints.push([thisCoord, otherCoord]);
	      linePoints.push([thisCoord, otherCoord]);
	      thisCoord += step;
	      lastIsEmpty = isEmpty;
	    });
	    var dataZoomModel = this.dataZoomModel; // var dataBackgroundModel = dataZoomModel.getModel('dataBackground');
	
	    this._displayables.barGroup.add(new graphic.Polygon({
	      shape: {
	        points: areaPoints
	      },
	      style: zrUtil.defaults({
	        fill: dataZoomModel.get('dataBackgroundColor')
	      }, dataZoomModel.getModel('dataBackground.areaStyle').getAreaStyle()),
	      silent: true,
	      z2: -20
	    }));
	
	    this._displayables.barGroup.add(new graphic.Polyline({
	      shape: {
	        points: linePoints
	      },
	      style: dataZoomModel.getModel('dataBackground.lineStyle').getLineStyle(),
	      silent: true,
	      z2: -19
	    }));
	  },
	  _prepareDataShadowInfo: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var showDataShadow = dataZoomModel.get('showDataShadow');
	
	    if (showDataShadow === false) {
	      return;
	    } // Find a representative series.
	
	
	    var result;
	    var ecModel = this.ecModel;
	    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
	      var seriesModels = dataZoomModel.getAxisProxy(dimNames.name, axisIndex).getTargetSeriesModels();
	      zrUtil.each(seriesModels, function (seriesModel) {
	        if (result) {
	          return;
	        }
	
	        if (showDataShadow !== true && zrUtil.indexOf(SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) {
	          return;
	        }
	
	        var thisAxis = ecModel.getComponent(dimNames.axis, axisIndex).axis;
	        var otherDim = getOtherDim(dimNames.name);
	        var otherAxisInverse;
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (otherDim != null && coordSys.getOtherAxis) {
	          otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
	        }
	
	        otherDim = seriesModel.getData().mapDimension(otherDim);
	        result = {
	          thisAxis: thisAxis,
	          series: seriesModel,
	          thisDim: dimNames.name,
	          otherDim: otherDim,
	          otherAxisInverse: otherAxisInverse
	        };
	      }, this);
	    }, this);
	    return result;
	  },
	  _renderHandle: function () {
	    var displaybles = this._displayables;
	    var handles = displaybles.handles = [];
	    var handleLabels = displaybles.handleLabels = [];
	    var barGroup = this._displayables.barGroup;
	    var size = this._size;
	    var dataZoomModel = this.dataZoomModel;
	    barGroup.add(displaybles.filler = new Rect({
	      draggable: true,
	      cursor: getCursor(this._orient),
	      drift: bind(this._onDragMove, this, 'all'),
	      ondragstart: bind(this._showDataInfo, this, true),
	      ondragend: bind(this._onDragEnd, this),
	      onmouseover: bind(this._showDataInfo, this, true),
	      onmouseout: bind(this._showDataInfo, this, false),
	      style: {
	        fill: dataZoomModel.get('fillerColor'),
	        textPosition: 'inside'
	      }
	    })); // Frame border.
	
	    barGroup.add(new Rect({
	      silent: true,
	      subPixelOptimize: true,
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
	        lineWidth: DEFAULT_FRAME_BORDER_WIDTH,
	        fill: 'rgba(0,0,0,0)'
	      }
	    }));
	    each([0, 1], function (handleIndex) {
	      var path = graphic.createIcon(dataZoomModel.get('handleIcon'), {
	        cursor: getCursor(this._orient),
	        draggable: true,
	        drift: bind(this._onDragMove, this, handleIndex),
	        ondragend: bind(this._onDragEnd, this),
	        onmouseover: bind(this._showDataInfo, this, true),
	        onmouseout: bind(this._showDataInfo, this, false)
	      }, {
	        x: -1,
	        y: 0,
	        width: 2,
	        height: 2
	      });
	      var bRect = path.getBoundingRect();
	      this._handleHeight = numberUtil.parsePercent(dataZoomModel.get('handleSize'), this._size[1]);
	      this._handleWidth = bRect.width / bRect.height * this._handleHeight;
	      path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
	      var handleColor = dataZoomModel.get('handleColor'); // Compatitable with previous version
	
	      if (handleColor != null) {
	        path.style.fill = handleColor;
	      }
	
	      barGroup.add(handles[handleIndex] = path);
	      var textStyleModel = dataZoomModel.textStyleModel;
	      this.group.add(handleLabels[handleIndex] = new graphic.Text({
	        silent: true,
	        invisible: true,
	        style: {
	          x: 0,
	          y: 0,
	          text: '',
	          textVerticalAlign: 'middle',
	          textAlign: 'center',
	          textFill: textStyleModel.getTextColor(),
	          textFont: textStyleModel.getFont()
	        },
	        z2: 10
	      }));
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _resetInterval: function () {
	    var range = this._range = this.dataZoomModel.getPercentRange();
	
	    var viewExtent = this._getViewExtent();
	
	    this._handleEnds = [linearMap(range[0], [0, 100], viewExtent, true), linearMap(range[1], [0, 100], viewExtent, true)];
	  },
	
	  /**
	   * @private
	   * @param {(number|string)} handleIndex 0 or 1 or 'all'
	   * @param {number} delta
	   * @return {boolean} changed
	   */
	  _updateInterval: function (handleIndex, delta) {
	    var dataZoomModel = this.dataZoomModel;
	    var handleEnds = this._handleEnds;
	
	    var viewExtend = this._getViewExtent();
	
	    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	    var percentExtent = [0, 100];
	    sliderMove(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? linearMap(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? linearMap(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
	    var lastRange = this._range;
	    var range = this._range = asc([linearMap(handleEnds[0], viewExtend, percentExtent, true), linearMap(handleEnds[1], viewExtend, percentExtent, true)]);
	    return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
	  },
	
	  /**
	   * @private
	   */
	  _updateView: function (nonRealtime) {
	    var displaybles = this._displayables;
	    var handleEnds = this._handleEnds;
	    var handleInterval = asc(handleEnds.slice());
	    var size = this._size;
	    each([0, 1], function (handleIndex) {
	      // Handles
	      var handle = displaybles.handles[handleIndex];
	      var handleHeight = this._handleHeight;
	      handle.attr({
	        scale: [handleHeight / 2, handleHeight / 2],
	        position: [handleEnds[handleIndex], size[1] / 2 - handleHeight / 2]
	      });
	    }, this); // Filler
	
	    displaybles.filler.setShape({
	      x: handleInterval[0],
	      y: 0,
	      width: handleInterval[1] - handleInterval[0],
	      height: size[1]
	    });
	
	    this._updateDataInfo(nonRealtime);
	  },
	
	  /**
	   * @private
	   */
	  _updateDataInfo: function (nonRealtime) {
	    var dataZoomModel = this.dataZoomModel;
	    var displaybles = this._displayables;
	    var handleLabels = displaybles.handleLabels;
	    var orient = this._orient;
	    var labelTexts = ['', '']; // FIXME
	    // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
	
	    if (dataZoomModel.get('showDetail')) {
	      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	
	      if (axisProxy) {
	        var axis = axisProxy.getAxisModel().axis;
	        var range = this._range;
	        var dataInterval = nonRealtime // See #4434, data and axis are not processed and reset yet in non-realtime mode.
	        ? axisProxy.calculateDataWindow({
	          start: range[0],
	          end: range[1]
	        }).valueWindow : axisProxy.getDataValueWindow();
	        labelTexts = [this._formatLabel(dataInterval[0], axis), this._formatLabel(dataInterval[1], axis)];
	      }
	    }
	
	    var orderedHandleEnds = asc(this._handleEnds.slice());
	    setLabel.call(this, 0);
	    setLabel.call(this, 1);
	
	    function setLabel(handleIndex) {
	      // Label
	      // Text should not transform by barGroup.
	      // Ignore handlers transform
	      var barTransform = graphic.getTransform(displaybles.handles[handleIndex].parent, this.group);
	      var direction = graphic.transformDirection(handleIndex === 0 ? 'right' : 'left', barTransform);
	      var offset = this._handleWidth / 2 + LABEL_GAP;
	      var textPoint = graphic.applyTransform([orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset), this._size[1] / 2], barTransform);
	      handleLabels[handleIndex].setStyle({
	        x: textPoint[0],
	        y: textPoint[1],
	        textVerticalAlign: orient === HORIZONTAL ? 'middle' : direction,
	        textAlign: orient === HORIZONTAL ? direction : 'center',
	        text: labelTexts[handleIndex]
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _formatLabel: function (value, axis) {
	    var dataZoomModel = this.dataZoomModel;
	    var labelFormatter = dataZoomModel.get('labelFormatter');
	    var labelPrecision = dataZoomModel.get('labelPrecision');
	
	    if (labelPrecision == null || labelPrecision === 'auto') {
	      labelPrecision = axis.getPixelPrecision();
	    }
	
	    var valueStr = value == null || isNaN(value) ? '' // FIXME Glue code
	    : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel(Math.round(value)) // param of toFixed should less then 20.
	    : value.toFixed(Math.min(labelPrecision, 20));
	    return zrUtil.isFunction(labelFormatter) ? labelFormatter(value, valueStr) : zrUtil.isString(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
	  },
	
	  /**
	   * @private
	   * @param {boolean} showOrHide true: show, false: hide
	   */
	  _showDataInfo: function (showOrHide) {
	    // Always show when drgging.
	    showOrHide = this._dragging || showOrHide;
	    var handleLabels = this._displayables.handleLabels;
	    handleLabels[0].attr('invisible', !showOrHide);
	    handleLabels[1].attr('invisible', !showOrHide);
	  },
	  _onDragMove: function (handleIndex, dx, dy, event) {
	    this._dragging = true; // For mobile device, prevent screen slider on the button.
	
	    eventTool.stop(event.event); // Transform dx, dy to bar coordination.
	
	    var barTransform = this._displayables.barGroup.getLocalTransform();
	
	    var vertex = graphic.applyTransform([dx, dy], barTransform, true);
	
	    var changed = this._updateInterval(handleIndex, vertex[0]);
	
	    var realtime = this.dataZoomModel.get('realtime');
	
	    this._updateView(!realtime); // Avoid dispatch dataZoom repeatly but range not changed,
	    // which cause bad visual effect when progressive enabled.
	
	
	    changed && realtime && this._dispatchZoomAction();
	  },
	  _onDragEnd: function () {
	    this._dragging = false;
	
	    this._showDataInfo(false); // While in realtime mode and stream mode, dispatch action when
	    // drag end will cause the whole view rerender, which is unnecessary.
	
	
	    var realtime = this.dataZoomModel.get('realtime');
	    !realtime && this._dispatchZoomAction();
	  },
	  _onClickPanelClick: function (e) {
	    var size = this._size;
	
	    var localPoint = this._displayables.barGroup.transformCoordToLocal(e.offsetX, e.offsetY);
	
	    if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) {
	      return;
	    }
	
	    var handleEnds = this._handleEnds;
	    var center = (handleEnds[0] + handleEnds[1]) / 2;
	
	    var changed = this._updateInterval('all', localPoint[0] - center);
	
	    this._updateView();
	
	    changed && this._dispatchZoomAction();
	  },
	
	  /**
	   * This action will be throttled.
	   * @private
	   */
	  _dispatchZoomAction: function () {
	    var range = this._range;
	    this.api.dispatchAction({
	      type: 'dataZoom',
	      from: this.uid,
	      dataZoomId: this.dataZoomModel.id,
	      start: range[0],
	      end: range[1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _findCoordRect: function () {
	    // Find the grid coresponding to the first axis referred by dataZoom.
	    var rect;
	    each(this.getTargetCoordInfo(), function (coordInfoList) {
	      if (!rect && coordInfoList.length) {
	        var coordSys = coordInfoList[0].model.coordinateSystem;
	        rect = coordSys.getRect && coordSys.getRect();
	      }
	    });
	
	    if (!rect) {
	      var width = this.api.getWidth();
	      var height = this.api.getHeight();
	      rect = {
	        x: width * 0.2,
	        y: height * 0.2,
	        width: width * 0.6,
	        height: height * 0.6
	      };
	    }
	
	    return rect;
	  }
	});
	
	function getOtherDim(thisDim) {
	  // FIXME
	  // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
	  var map = {
	    x: 'y',
	    y: 'x',
	    radius: 'angle',
	    angle: 'radius'
	  };
	  return map[thisDim];
	}
	
	function getCursor(orient) {
	  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	}
	
	var _default = SliderZoomView;
	module.exports = _default;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(624);
	
	__webpack_require__(625);
	
	__webpack_require__(628);
	
	__webpack_require__(684);
	
	__webpack_require__(685);
	
	__webpack_require__(631);
	
	__webpack_require__(632);

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(625);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomModel.extend({
	  type: 'dataZoom.inside',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    disabled: false,
	    // Whether disable this inside zoom.
	    zoomLock: false,
	    // Whether disable zoom but only pan.
	    zoomOnMouseWheel: true,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    moveOnMouseMove: true,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    moveOnMouseWheel: false,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    preventDefaultMouseMove: true
	  }
	});
	
	module.exports = _default;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var DataZoomView = __webpack_require__(628);
	
	var sliderMove = __webpack_require__(507);
	
	var roams = __webpack_require__(686);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var InsideZoomView = DataZoomView.extend({
	  type: 'dataZoom.inside',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    /**
	     * 'throttle' is used in this.dispatchAction, so we save range
	     * to avoid missing some 'pan' info.
	     * @private
	     * @type {Array.<number>}
	     */
	    this._range;
	  },
	
	  /**
	   * @override
	   */
	  render: function (dataZoomModel, ecModel, api, payload) {
	    InsideZoomView.superApply(this, 'render', arguments); // Hence the `throttle` util ensures to preserve command order,
	    // here simply updating range all the time will not cause missing
	    // any of the the roam change.
	
	    this._range = dataZoomModel.getPercentRange(); // Reset controllers.
	
	    zrUtil.each(this.getTargetCoordInfo(), function (coordInfoList, coordSysName) {
	      var allCoordIds = zrUtil.map(coordInfoList, function (coordInfo) {
	        return roams.generateCoordId(coordInfo.model);
	      });
	      zrUtil.each(coordInfoList, function (coordInfo) {
	        var coordModel = coordInfo.model;
	        var getRange = {};
	        zrUtil.each(['pan', 'zoom', 'scrollMove'], function (eventName) {
	          getRange[eventName] = bind(roamHandlers[eventName], this, coordInfo, coordSysName);
	        }, this);
	        roams.register(api, {
	          coordId: roams.generateCoordId(coordModel),
	          allCoordIds: allCoordIds,
	          containsPoint: function (e, x, y) {
	            return coordModel.coordinateSystem.containPoint([x, y]);
	          },
	          dataZoomId: dataZoomModel.id,
	          dataZoomModel: dataZoomModel,
	          getRange: getRange
	        });
	      }, this);
	    }, this);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    roams.unregister(this.api, this.dataZoomModel.id);
	    InsideZoomView.superApply(this, 'dispose', arguments);
	    this._range = null;
	  }
	});
	var roamHandlers = {
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  zoom: function (coordInfo, coordSysName, controller, e) {
	    var lastRange = this._range;
	    var range = lastRange.slice(); // Calculate transform by the first axis.
	
	    var axisModel = coordInfo.axisModels[0];
	
	    if (!axisModel) {
	      return;
	    }
	
	    var directionInfo = getDirectionInfo[coordSysName](null, [e.originX, e.originY], axisModel, controller, coordInfo);
	    var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
	    var scale = Math.max(1 / e.scale, 0);
	    range[0] = (range[0] - percentPoint) * scale + percentPoint;
	    range[1] = (range[1] - percentPoint) * scale + percentPoint; // Restrict range.
	
	    var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	    sliderMove(0, range, [0, 100], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
	    this._range = range;
	
	    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
	      return range;
	    }
	  },
	
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  pan: makeMover(function (range, axisModel, coordInfo, coordSysName, controller, e) {
	    var directionInfo = getDirectionInfo[coordSysName]([e.oldX, e.oldY], [e.newX, e.newY], axisModel, controller, coordInfo);
	    return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
	  }),
	
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  scrollMove: makeMover(function (range, axisModel, coordInfo, coordSysName, controller, e) {
	    var directionInfo = getDirectionInfo[coordSysName]([0, 0], [e.scrollDelta, e.scrollDelta], axisModel, controller, coordInfo);
	    return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
	  })
	};
	
	function makeMover(getPercentDelta) {
	  return function (coordInfo, coordSysName, controller, e) {
	    var lastRange = this._range;
	    var range = lastRange.slice(); // Calculate transform by the first axis.
	
	    var axisModel = coordInfo.axisModels[0];
	
	    if (!axisModel) {
	      return;
	    }
	
	    var percentDelta = getPercentDelta(range, axisModel, coordInfo, coordSysName, controller, e);
	    sliderMove(percentDelta, range, [0, 100], 'all');
	    this._range = range;
	
	    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
	      return range;
	    }
	  };
	}
	
	var getDirectionInfo = {
	  grid: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var ret = {};
	    var rect = coordInfo.model.coordinateSystem.getRect();
	    oldPoint = oldPoint || [0, 0];
	
	    if (axis.dim === 'x') {
	      ret.pixel = newPoint[0] - oldPoint[0];
	      ret.pixelLength = rect.width;
	      ret.pixelStart = rect.x;
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // axis.dim === 'y'
	      ret.pixel = newPoint[1] - oldPoint[1];
	      ret.pixelLength = rect.height;
	      ret.pixelStart = rect.y;
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  },
	  polar: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var ret = {};
	    var polar = coordInfo.model.coordinateSystem;
	    var radiusExtent = polar.getRadiusAxis().getExtent();
	    var angleExtent = polar.getAngleAxis().getExtent();
	    oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [0, 0];
	    newPoint = polar.pointToCoord(newPoint);
	
	    if (axisModel.mainType === 'radiusAxis') {
	      ret.pixel = newPoint[0] - oldPoint[0]; // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
	      // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
	
	      ret.pixelLength = radiusExtent[1] - radiusExtent[0];
	      ret.pixelStart = radiusExtent[0];
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // 'angleAxis'
	      ret.pixel = newPoint[1] - oldPoint[1]; // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
	      // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
	
	      ret.pixelLength = angleExtent[1] - angleExtent[0];
	      ret.pixelStart = angleExtent[0];
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  },
	  singleAxis: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var rect = coordInfo.model.coordinateSystem.getRect();
	    var ret = {};
	    oldPoint = oldPoint || [0, 0];
	
	    if (axis.orient === 'horizontal') {
	      ret.pixel = newPoint[0] - oldPoint[0];
	      ret.pixelLength = rect.width;
	      ret.pixelStart = rect.x;
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // 'vertical'
	      ret.pixel = newPoint[1] - oldPoint[1];
	      ret.pixelLength = rect.height;
	      ret.pixelStart = rect.y;
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  }
	};
	var _default = InsideZoomView;
	module.exports = _default;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var RoamController = __webpack_require__(438);
	
	var throttleUtil = __webpack_require__(327);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Only create one roam controller for each coordinate system.
	// one roam controller might be refered by two inside data zoom
	// components (for example, one for x and one for y). When user
	// pan or zoom, only dispatch one action for those data zoom
	// components.
	var ATTR = '\0_ec_dataZoom_roams';
	/**
	 * @public
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Object} dataZoomInfo
	 * @param {string} dataZoomInfo.coordId
	 * @param {Function} dataZoomInfo.containsPoint
	 * @param {Array.<string>} dataZoomInfo.allCoordIds
	 * @param {string} dataZoomInfo.dataZoomId
	 * @param {Object} dataZoomInfo.getRange
	 * @param {Function} dataZoomInfo.getRange.pan
	 * @param {Function} dataZoomInfo.getRange.zoom
	 * @param {Function} dataZoomInfo.getRange.scrollMove
	 * @param {boolean} dataZoomInfo.dataZoomModel
	 */
	
	function register(api, dataZoomInfo) {
	  var store = giveStore(api);
	  var theDataZoomId = dataZoomInfo.dataZoomId;
	  var theCoordId = dataZoomInfo.coordId; // Do clean when a dataZoom changes its target coordnate system.
	  // Avoid memory leak, dispose all not-used-registered.
	
	  zrUtil.each(store, function (record, coordId) {
	    var dataZoomInfos = record.dataZoomInfos;
	
	    if (dataZoomInfos[theDataZoomId] && zrUtil.indexOf(dataZoomInfo.allCoordIds, theCoordId) < 0) {
	      delete dataZoomInfos[theDataZoomId];
	      record.count--;
	    }
	  });
	  cleanStore(store);
	  var record = store[theCoordId]; // Create if needed.
	
	  if (!record) {
	    record = store[theCoordId] = {
	      coordId: theCoordId,
	      dataZoomInfos: {},
	      count: 0
	    };
	    record.controller = createController(api, record);
	    record.dispatchAction = zrUtil.curry(dispatchAction, api);
	  } // Update reference of dataZoom.
	
	
	  !record.dataZoomInfos[theDataZoomId] && record.count++;
	  record.dataZoomInfos[theDataZoomId] = dataZoomInfo;
	  var controllerParams = mergeControllerParams(record.dataZoomInfos);
	  record.controller.enable(controllerParams.controlType, controllerParams.opt); // Consider resize, area should be always updated.
	
	  record.controller.setPointerChecker(dataZoomInfo.containsPoint); // Update throttle.
	
	  throttleUtil.createOrUpdate(record, 'dispatchAction', dataZoomInfo.dataZoomModel.get('throttle', true), 'fixRate');
	}
	/**
	 * @public
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {string} dataZoomId
	 */
	
	
	function unregister(api, dataZoomId) {
	  var store = giveStore(api);
	  zrUtil.each(store, function (record) {
	    record.controller.dispose();
	    var dataZoomInfos = record.dataZoomInfos;
	
	    if (dataZoomInfos[dataZoomId]) {
	      delete dataZoomInfos[dataZoomId];
	      record.count--;
	    }
	  });
	  cleanStore(store);
	}
	/**
	 * @public
	 */
	
	
	function generateCoordId(coordModel) {
	  return coordModel.type + '\0_' + coordModel.id;
	}
	/**
	 * Key: coordId, value: {dataZoomInfos: [], count, controller}
	 * @type {Array.<Object>}
	 */
	
	
	function giveStore(api) {
	  // Mount store on zrender instance, so that we do not
	  // need to worry about dispose.
	  var zr = api.getZr();
	  return zr[ATTR] || (zr[ATTR] = {});
	}
	
	function createController(api, newRecord) {
	  var controller = new RoamController(api.getZr());
	  zrUtil.each(['pan', 'zoom', 'scrollMove'], function (eventName) {
	    controller.on(eventName, function (event) {
	      var batch = [];
	      zrUtil.each(newRecord.dataZoomInfos, function (info) {
	        // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
	        // moveOnMouseWheel, ...) enabled.
	        if (!event.isAvailableBehavior(info.dataZoomModel.option)) {
	          return;
	        }
	
	        var method = (info.getRange || {})[eventName];
	        var range = method && method(newRecord.controller, event);
	        !info.dataZoomModel.get('disabled', true) && range && batch.push({
	          dataZoomId: info.dataZoomId,
	          start: range[0],
	          end: range[1]
	        });
	      });
	      batch.length && newRecord.dispatchAction(batch);
	    });
	  });
	  return controller;
	}
	
	function cleanStore(store) {
	  zrUtil.each(store, function (record, coordId) {
	    if (!record.count) {
	      record.controller.dispose();
	      delete store[coordId];
	    }
	  });
	}
	/**
	 * This action will be throttled.
	 */
	
	
	function dispatchAction(api, batch) {
	  api.dispatchAction({
	    type: 'dataZoom',
	    batch: batch
	  });
	}
	/**
	 * Merge roamController settings when multiple dataZooms share one roamController.
	 */
	
	
	function mergeControllerParams(dataZoomInfos) {
	  var controlType; // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
	  // as string, it is probably revert to reserved word by compress tool. See #7411.
	
	  var prefix = 'type_';
	  var typePriority = {
	    'type_true': 2,
	    'type_move': 1,
	    'type_false': 0,
	    'type_undefined': -1
	  };
	  var preventDefaultMouseMove = true;
	  zrUtil.each(dataZoomInfos, function (dataZoomInfo) {
	    var dataZoomModel = dataZoomInfo.dataZoomModel;
	    var oneType = dataZoomModel.get('disabled', true) ? false : dataZoomModel.get('zoomLock', true) ? 'move' : true;
	
	    if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) {
	      controlType = oneType;
	    } // Prevent default move event by default. If one false, do not prevent. Otherwise
	    // users may be confused why it does not work when multiple insideZooms exist.
	
	
	    preventDefaultMouseMove &= dataZoomModel.get('preventDefaultMouseMove', true);
	  });
	  return {
	    controlType: controlType,
	    opt: {
	      // RoamController will enable all of these functionalities,
	      // and the final behavior is determined by its event listener
	      // provided by each inside zoom.
	      zoomOnMouseWheel: true,
	      moveOnMouseMove: true,
	      moveOnMouseWheel: true,
	      preventDefaultMouseMove: !!preventDefaultMouseMove
	    }
	  };
	}
	
	exports.register = register;
	exports.unregister = unregister;
	exports.generateCoordId = generateCoordId;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(688);
	
	__webpack_require__(699);

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var preprocessor = __webpack_require__(689);
	
	__webpack_require__(690);
	
	__webpack_require__(691);
	
	__webpack_require__(692);
	
	__webpack_require__(695);
	
	__webpack_require__(698);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	
	function _default(option) {
	  var visualMap = option && option.visualMap;
	
	  if (!zrUtil.isArray(visualMap)) {
	    visualMap = visualMap ? [visualMap] : [];
	  }
	
	  each(visualMap, function (opt) {
	    if (!opt) {
	      return;
	    } // rename splitList to pieces
	
	
	    if (has(opt, 'splitList') && !has(opt, 'pieces')) {
	      opt.pieces = opt.splitList;
	      delete opt.splitList;
	    }
	
	    var pieces = opt.pieces;
	
	    if (pieces && zrUtil.isArray(pieces)) {
	      each(pieces, function (piece) {
	        if (zrUtil.isObject(piece)) {
	          if (has(piece, 'start') && !has(piece, 'min')) {
	            piece.min = piece.start;
	          }
	
	          if (has(piece, 'end') && !has(piece, 'max')) {
	            piece.max = piece.end;
	          }
	        }
	      });
	    }
	  });
	}
	
	function has(obj, name) {
	  return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
	}
	
	module.exports = _default;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(303);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('visualMap', function (option) {
	  // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
	  return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
	});

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var visualSolution = __webpack_require__(642);
	
	var VisualMapping = __webpack_require__(468);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var VISUAL_PRIORITY = echarts.PRIORITY.VISUAL.COMPONENT;
	echarts.registerVisual(VISUAL_PRIORITY, {
	  createOnAllSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var resetDefines = [];
	    ecModel.eachComponent('visualMap', function (visualMapModel) {
	      var pipelineContext = seriesModel.pipelineContext;
	
	      if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) {
	        return;
	      }
	
	      resetDefines.push(visualSolution.incrementalApplyVisual(visualMapModel.stateList, visualMapModel.targetVisuals, zrUtil.bind(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimension(seriesModel.getData())));
	    });
	    return resetDefines;
	  }
	}); // Only support color.
	
	echarts.registerVisual(VISUAL_PRIORITY, {
	  createOnAllSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var visualMetaList = [];
	    ecModel.eachComponent('visualMap', function (visualMapModel) {
	      if (visualMapModel.isTargetSeries(seriesModel)) {
	        var visualMeta = visualMapModel.getVisualMeta(zrUtil.bind(getColorVisual, null, seriesModel, visualMapModel)) || {
	          stops: [],
	          outerColors: []
	        };
	        var concreteDim = visualMapModel.getDataDimension(data);
	        var dimInfo = data.getDimensionInfo(concreteDim);
	
	        if (dimInfo != null) {
	          // visualMeta.dimension should be dimension index, but not concrete dimension.
	          visualMeta.dimension = dimInfo.index;
	          visualMetaList.push(visualMeta);
	        }
	      }
	    }); // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
	
	    seriesModel.getData().setVisual('visualMeta', visualMetaList);
	  }
	}); // FIXME
	// performance and export for heatmap?
	// value can be Infinity or -Infinity
	
	function getColorVisual(seriesModel, visualMapModel, value, valueState) {
	  var mappings = visualMapModel.targetVisuals[valueState];
	  var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	  var resultVisual = {
	    color: seriesModel.getData().getVisual('color') // default color.
	
	  };
	
	  for (var i = 0, len = visualTypes.length; i < len; i++) {
	    var type = visualTypes[i];
	    var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
	    mapping && mapping.applyVisual(value, getVisual, setVisual);
	  }
	
	  return resultVisual.color;
	
	  function getVisual(key) {
	    return resultVisual[key];
	  }
	
	  function setVisual(key, value) {
	    resultVisual[key] = value;
	  }
	}

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var VisualMapModel = __webpack_require__(693);
	
	var numberUtil = __webpack_require__(306);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Constant
	var DEFAULT_BAR_BOUND = [20, 140];
	var ContinuousModel = VisualMapModel.extend({
	  type: 'visualMap.continuous',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    align: 'auto',
	    // 'auto', 'left', 'right', 'top', 'bottom'
	    calculable: false,
	    // This prop effect default component type determine,
	    // See echarts/component/visualMap/typeDefaulter.
	    range: null,
	    // selected range. In default case `range` is [min, max]
	    // and can auto change along with modification of min max,
	    // util use specifid a range.
	    realtime: true,
	    // Whether realtime update.
	    itemHeight: null,
	    // The length of the range control edge.
	    itemWidth: null,
	    // The length of the other side.
	    hoverLink: true,
	    // Enable hover highlight.
	    hoverLinkDataSize: null,
	    // The size of hovered data.
	    hoverLinkOnHandle: null // Whether trigger hoverLink when hover handle.
	    // If not specified, follow the value of `realtime`.
	
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    ContinuousModel.superApply(this, 'optionUpdated', arguments);
	    this.resetExtent();
	    this.resetVisual(function (mappingOption) {
	      mappingOption.mappingMethod = 'linear';
	      mappingOption.dataExtent = this.getExtent();
	    });
	
	    this._resetRange();
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  resetItemSize: function () {
	    ContinuousModel.superApply(this, 'resetItemSize', arguments);
	    var itemSize = this.itemSize;
	    this._orient === 'horizontal' && itemSize.reverse();
	    (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = DEFAULT_BAR_BOUND[0]);
	    (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = DEFAULT_BAR_BOUND[1]);
	  },
	
	  /**
	   * @private
	   */
	  _resetRange: function () {
	    var dataExtent = this.getExtent();
	    var range = this.option.range;
	
	    if (!range || range.auto) {
	      // `range` should always be array (so we dont use other
	      // value like 'auto') for user-friend. (consider getOption).
	      dataExtent.auto = 1;
	      this.option.range = dataExtent;
	    } else if (zrUtil.isArray(range)) {
	      if (range[0] > range[1]) {
	        range.reverse();
	      }
	
	      range[0] = Math.max(range[0], dataExtent[0]);
	      range[1] = Math.min(range[1], dataExtent[1]);
	    }
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  completeVisualOption: function () {
	    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
	    zrUtil.each(this.stateList, function (state) {
	      var symbolSize = this.option.controller[state].symbolSize;
	
	      if (symbolSize && symbolSize[0] !== symbolSize[1]) {
	        symbolSize[0] = 0; // For good looking.
	      }
	    }, this);
	  },
	
	  /**
	   * @override
	   */
	  setSelected: function (selected) {
	    this.option.range = selected.slice();
	
	    this._resetRange();
	  },
	
	  /**
	   * @public
	   */
	  getSelected: function () {
	    var dataExtent = this.getExtent();
	    var dataInterval = numberUtil.asc((this.get('range') || []).slice()); // Clamp
	
	    dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
	    dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
	    dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
	    dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
	    return dataInterval;
	  },
	
	  /**
	   * @override
	   */
	  getValueState: function (value) {
	    var range = this.option.range;
	    var dataExtent = this.getExtent(); // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
	    // range[1] is processed likewise.
	
	    return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
	  },
	
	  /**
	   * @params {Array.<number>} range target value: range[0] <= value && value <= range[1]
	   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
	   */
	  findTargetDataIndices: function (range) {
	    var result = [];
	    this.eachTargetSeries(function (seriesModel) {
	      var dataIndices = [];
	      var data = seriesModel.getData();
	      data.each(this.getDataDimension(data), function (value, dataIndex) {
	        range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
	      }, this);
	      result.push({
	        seriesId: seriesModel.id,
	        dataIndex: dataIndices
	      });
	    }, this);
	    return result;
	  },
	
	  /**
	   * @implement
	   */
	  getVisualMeta: function (getColorVisual) {
	    var oVals = getColorStopValues(this, 'outOfRange', this.getExtent());
	    var iVals = getColorStopValues(this, 'inRange', this.option.range.slice());
	    var stops = [];
	
	    function setStop(value, valueState) {
	      stops.push({
	        value: value,
	        color: getColorVisual(value, valueState)
	      });
	    } // Format to: outOfRange -- inRange -- outOfRange.
	
	
	    var iIdx = 0;
	    var oIdx = 0;
	    var iLen = iVals.length;
	    var oLen = oVals.length;
	
	    for (; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++) {
	      // If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
	      if (oVals[oIdx] < iVals[iIdx]) {
	        setStop(oVals[oIdx], 'outOfRange');
	      }
	    }
	
	    for (var first = 1; iIdx < iLen; iIdx++, first = 0) {
	      // If range is full, value beyond min, max will be clamped.
	      // make a singularity
	      first && stops.length && setStop(iVals[iIdx], 'outOfRange');
	      setStop(iVals[iIdx], 'inRange');
	    }
	
	    for (var first = 1; oIdx < oLen; oIdx++) {
	      if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
	        // make a singularity
	        if (first) {
	          stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
	          first = 0;
	        }
	
	        setStop(oVals[oIdx], 'outOfRange');
	      }
	    }
	
	    var stopsLen = stops.length;
	    return {
	      stops: stops,
	      outerColors: [stopsLen ? stops[0].color : 'transparent', stopsLen ? stops[stopsLen - 1].color : 'transparent']
	    };
	  }
	});
	
	function getColorStopValues(visualMapModel, valueState, dataExtent) {
	  if (dataExtent[0] === dataExtent[1]) {
	    return dataExtent.slice();
	  } // When using colorHue mapping, it is not linear color any more.
	  // Moreover, canvas gradient seems not to be accurate linear.
	  // FIXME
	  // Should be arbitrary value 100? or based on pixel size?
	
	
	  var count = 200;
	  var step = (dataExtent[1] - dataExtent[0]) / count;
	  var value = dataExtent[0];
	  var stopValues = [];
	
	  for (var i = 0; i <= count && value < dataExtent[1]; i++) {
	    stopValues.push(value);
	    value += step;
	  }
	
	  stopValues.push(dataExtent[1]);
	  return stopValues;
	}
	
	var _default = ContinuousModel;
	module.exports = _default;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var env = __webpack_require__(219);
	
	var visualDefault = __webpack_require__(694);
	
	var VisualMapping = __webpack_require__(468);
	
	var visualSolution = __webpack_require__(642);
	
	var modelUtil = __webpack_require__(261);
	
	var numberUtil = __webpack_require__(306);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var mapVisual = VisualMapping.mapVisual;
	var eachVisual = VisualMapping.eachVisual;
	var isArray = zrUtil.isArray;
	var each = zrUtil.each;
	var asc = numberUtil.asc;
	var linearMap = numberUtil.linearMap;
	var noop = zrUtil.noop;
	var VisualMapModel = echarts.extendComponentModel({
	  type: 'visualMap',
	  dependencies: ['series'],
	
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  stateList: ['inRange', 'outOfRange'],
	
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  replacableOptionKeys: ['inRange', 'outOfRange', 'target', 'controller', 'color'],
	
	  /**
	   * [lowerBound, upperBound]
	   *
	   * @readOnly
	   * @type {Array.<number>}
	   */
	  dataBound: [-Infinity, Infinity],
	
	  /**
	   * @readOnly
	   * @type {string|Object}
	   */
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    show: true,
	    zlevel: 0,
	    z: 4,
	    seriesIndex: 'all',
	    // 'all' or null/undefined: all series.
	    // A number or an array of number: the specified series.
	    // set min: 0, max: 200, only for campatible with ec2.
	    // In fact min max should not have default value.
	    min: 0,
	    // min value, must specified if pieces is not specified.
	    max: 200,
	    // max value, must specified if pieces is not specified.
	    dimension: null,
	    inRange: null,
	    // 'color', 'colorHue', 'colorSaturation', 'colorLightness', 'colorAlpha',
	    // 'symbol', 'symbolSize'
	    outOfRange: null,
	    // 'color', 'colorHue', 'colorSaturation',
	    // 'colorLightness', 'colorAlpha',
	    // 'symbol', 'symbolSize'
	    left: 0,
	    // 'center' ¦ 'left' ¦ 'right' ¦ {number} (px)
	    right: null,
	    // The same as left.
	    top: null,
	    // 'top' ¦ 'bottom' ¦ 'center' ¦ {number} (px)
	    bottom: 0,
	    // The same as top.
	    itemWidth: null,
	    itemHeight: null,
	    inverse: false,
	    orient: 'vertical',
	    // 'horizontal' ¦ 'vertical'
	    backgroundColor: 'rgba(0,0,0,0)',
	    borderColor: '#ccc',
	    // 值域边框颜色
	    contentColor: '#5793f3',
	    inactiveColor: '#aaa',
	    borderWidth: 0,
	    // 值域边框线宽，单位px，默认为0（无边框）
	    padding: 5,
	    // 值域内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    textGap: 10,
	    //
	    precision: 0,
	    // 小数精度，默认为0，无小数点
	    color: null,
	    //颜色（deprecated，兼容ec2，顺序同pieces，不同于inRange/outOfRange）
	    formatter: null,
	    text: null,
	    // 文本，如['高', '低']，兼容ec2，text[0]对应高值，text[1]对应低值
	    textStyle: {
	      color: '#333' // 值域文字颜色
	
	    }
	  },
	
	  /**
	   * @protected
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * @private
	     * @type {Array.<number>}
	     */
	    this._dataExtent;
	    /**
	     * @readOnly
	     */
	
	    this.targetVisuals = {};
	    /**
	     * @readOnly
	     */
	
	    this.controllerVisuals = {};
	    /**
	     * @readOnly
	     */
	
	    this.textStyleModel;
	    /**
	     * [width, height]
	     * @readOnly
	     * @type {Array.<number>}
	     */
	
	    this.itemSize;
	    this.mergeDefaultAndTheme(option, ecModel);
	  },
	
	  /**
	   * @protected
	   */
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option; // FIXME
	    // necessary?
	    // Disable realtime view update if canvas is not supported.
	
	    if (!env.canvasSupported) {
	      thisOption.realtime = false;
	    }
	
	    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, this.replacableOptionKeys);
	    this.textStyleModel = this.getModel('textStyle');
	    this.resetItemSize();
	    this.completeVisualOption();
	  },
	
	  /**
	   * @protected
	   */
	  resetVisual: function (supplementVisualOption) {
	    var stateList = this.stateList;
	    supplementVisualOption = zrUtil.bind(supplementVisualOption, this);
	    this.controllerVisuals = visualSolution.createVisualMappings(this.option.controller, stateList, supplementVisualOption);
	    this.targetVisuals = visualSolution.createVisualMappings(this.option.target, stateList, supplementVisualOption);
	  },
	
	  /**
	   * @protected
	   * @return {Array.<number>} An array of series indices.
	   */
	  getTargetSeriesIndices: function () {
	    var optionSeriesIndex = this.option.seriesIndex;
	    var seriesIndices = [];
	
	    if (optionSeriesIndex == null || optionSeriesIndex === 'all') {
	      this.ecModel.eachSeries(function (seriesModel, index) {
	        seriesIndices.push(index);
	      });
	    } else {
	      seriesIndices = modelUtil.normalizeToArray(optionSeriesIndex);
	    }
	
	    return seriesIndices;
	  },
	
	  /**
	   * @public
	   */
	  eachTargetSeries: function (callback, context) {
	    zrUtil.each(this.getTargetSeriesIndices(), function (seriesIndex) {
	      callback.call(context, this.ecModel.getSeriesByIndex(seriesIndex));
	    }, this);
	  },
	
	  /**
	   * @pubilc
	   */
	  isTargetSeries: function (seriesModel) {
	    var is = false;
	    this.eachTargetSeries(function (model) {
	      model === seriesModel && (is = true);
	    });
	    return is;
	  },
	
	  /**
	   * @example
	   * this.formatValueText(someVal); // format single numeric value to text.
	   * this.formatValueText(someVal, true); // format single category value to text.
	   * this.formatValueText([min, max]); // format numeric min-max to text.
	   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
	   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
	   *
	   * @param {number|Array.<number>} value Real value, or this.dataBound[0 or 1].
	   * @param {boolean} [isCategory=false] Only available when value is number.
	   * @param {Array.<string>} edgeSymbols Open-close symbol when value is interval.
	   * @return {string}
	   * @protected
	   */
	  formatValueText: function (value, isCategory, edgeSymbols) {
	    var option = this.option;
	    var precision = option.precision;
	    var dataBound = this.dataBound;
	    var formatter = option.formatter;
	    var isMinMax;
	    var textValue;
	    edgeSymbols = edgeSymbols || ['<', '>'];
	
	    if (zrUtil.isArray(value)) {
	      value = value.slice();
	      isMinMax = true;
	    }
	
	    textValue = isCategory ? value : isMinMax ? [toFixed(value[0]), toFixed(value[1])] : toFixed(value);
	
	    if (zrUtil.isString(formatter)) {
	      return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
	    } else if (zrUtil.isFunction(formatter)) {
	      return isMinMax ? formatter(value[0], value[1]) : formatter(value);
	    }
	
	    if (isMinMax) {
	      if (value[0] === dataBound[0]) {
	        return edgeSymbols[0] + ' ' + textValue[1];
	      } else if (value[1] === dataBound[1]) {
	        return edgeSymbols[1] + ' ' + textValue[0];
	      } else {
	        return textValue[0] + ' - ' + textValue[1];
	      }
	    } else {
	      // Format single value (includes category case).
	      return textValue;
	    }
	
	    function toFixed(val) {
	      return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
	    }
	  },
	
	  /**
	   * @protected
	   */
	  resetExtent: function () {
	    var thisOption = this.option; // Can not calculate data extent by data here.
	    // Because series and data may be modified in processing stage.
	    // So we do not support the feature "auto min/max".
	
	    var extent = asc([thisOption.min, thisOption.max]);
	    this._dataExtent = extent;
	  },
	
	  /**
	   * @public
	   * @param {module:echarts/data/List} list
	   * @return {string} Concrete dimention. If return null/undefined,
	   *                  no dimension used.
	   */
	  getDataDimension: function (list) {
	    var optDim = this.option.dimension;
	    var listDimensions = list.dimensions;
	
	    if (optDim == null && !listDimensions.length) {
	      return;
	    }
	
	    if (optDim != null) {
	      return list.getDimension(optDim);
	    }
	
	    var dimNames = list.dimensions;
	
	    for (var i = dimNames.length - 1; i >= 0; i--) {
	      var dimName = dimNames[i];
	      var dimInfo = list.getDimensionInfo(dimName);
	
	      if (!dimInfo.isCalculationCoord) {
	        return dimName;
	      }
	    }
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  getExtent: function () {
	    return this._dataExtent.slice();
	  },
	
	  /**
	   * @protected
	   */
	  completeVisualOption: function () {
	    var ecModel = this.ecModel;
	    var thisOption = this.option;
	    var base = {
	      inRange: thisOption.inRange,
	      outOfRange: thisOption.outOfRange
	    };
	    var target = thisOption.target || (thisOption.target = {});
	    var controller = thisOption.controller || (thisOption.controller = {});
	    zrUtil.merge(target, base); // Do not override
	
	    zrUtil.merge(controller, base); // Do not override
	
	    var isCategory = this.isCategory();
	    completeSingle.call(this, target);
	    completeSingle.call(this, controller);
	    completeInactive.call(this, target, 'inRange', 'outOfRange'); // completeInactive.call(this, target, 'outOfRange', 'inRange');
	
	    completeController.call(this, controller);
	
	    function completeSingle(base) {
	      // Compatible with ec2 dataRange.color.
	      // The mapping order of dataRange.color is: [high value, ..., low value]
	      // whereas inRange.color and outOfRange.color is [low value, ..., high value]
	      // Notice: ec2 has no inverse.
	      if (isArray(thisOption.color) // If there has been inRange: {symbol: ...}, adding color is a mistake.
	      // So adding color only when no inRange defined.
	      && !base.inRange) {
	        base.inRange = {
	          color: thisOption.color.slice().reverse()
	        };
	      } // Compatible with previous logic, always give a defautl color, otherwise
	      // simple config with no inRange and outOfRange will not work.
	      // Originally we use visualMap.color as the default color, but setOption at
	      // the second time the default color will be erased. So we change to use
	      // constant DEFAULT_COLOR.
	      // If user do not want the default color, set inRange: {color: null}.
	
	
	      base.inRange = base.inRange || {
	        color: ecModel.get('gradientColor')
	      }; // If using shortcut like: {inRange: 'symbol'}, complete default value.
	
	      each(this.stateList, function (state) {
	        var visualType = base[state];
	
	        if (zrUtil.isString(visualType)) {
	          var defa = visualDefault.get(visualType, 'active', isCategory);
	
	          if (defa) {
	            base[state] = {};
	            base[state][visualType] = defa;
	          } else {
	            // Mark as not specified.
	            delete base[state];
	          }
	        }
	      }, this);
	    }
	
	    function completeInactive(base, stateExist, stateAbsent) {
	      var optExist = base[stateExist];
	      var optAbsent = base[stateAbsent];
	
	      if (optExist && !optAbsent) {
	        optAbsent = base[stateAbsent] = {};
	        each(optExist, function (visualData, visualType) {
	          if (!VisualMapping.isValidType(visualType)) {
	            return;
	          }
	
	          var defa = visualDefault.get(visualType, 'inactive', isCategory);
	
	          if (defa != null) {
	            optAbsent[visualType] = defa; // Compatibable with ec2:
	            // Only inactive color to rgba(0,0,0,0) can not
	            // make label transparent, so use opacity also.
	
	            if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) {
	              optAbsent.opacity = [0, 0];
	            }
	          }
	        });
	      }
	    }
	
	    function completeController(controller) {
	      var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
	      var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
	      var inactiveColor = this.get('inactiveColor');
	      each(this.stateList, function (state) {
	        var itemSize = this.itemSize;
	        var visuals = controller[state]; // Set inactive color for controller if no other color
	        // attr (like colorAlpha) specified.
	
	        if (!visuals) {
	          visuals = controller[state] = {
	            color: isCategory ? inactiveColor : [inactiveColor]
	          };
	        } // Consistent symbol and symbolSize if not specified.
	
	
	        if (visuals.symbol == null) {
	          visuals.symbol = symbolExists && zrUtil.clone(symbolExists) || (isCategory ? 'roundRect' : ['roundRect']);
	        }
	
	        if (visuals.symbolSize == null) {
	          visuals.symbolSize = symbolSizeExists && zrUtil.clone(symbolSizeExists) || (isCategory ? itemSize[0] : [itemSize[0], itemSize[0]]);
	        } // Filter square and none.
	
	
	        visuals.symbol = mapVisual(visuals.symbol, function (symbol) {
	          return symbol === 'none' || symbol === 'square' ? 'roundRect' : symbol;
	        }); // Normalize symbolSize
	
	        var symbolSize = visuals.symbolSize;
	
	        if (symbolSize != null) {
	          var max = -Infinity; // symbolSize can be object when categories defined.
	
	          eachVisual(symbolSize, function (value) {
	            value > max && (max = value);
	          });
	          visuals.symbolSize = mapVisual(symbolSize, function (value) {
	            return linearMap(value, [0, max], [0, itemSize[0]], true);
	          });
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  resetItemSize: function () {
	    this.itemSize = [parseFloat(this.get('itemWidth')), parseFloat(this.get('itemHeight'))];
	  },
	
	  /**
	   * @public
	   */
	  isCategory: function () {
	    return !!this.option.categories;
	  },
	
	  /**
	   * @public
	   * @abstract
	   */
	  setSelected: noop,
	
	  /**
	   * @public
	   * @abstract
	   * @param {*|module:echarts/data/List} valueOrData
	   * @param {number} dataIndex
	   * @return {string} state See this.stateList
	   */
	  getValueState: noop,
	
	  /**
	   * FIXME
	   * Do not publish to thirt-part-dev temporarily
	   * util the interface is stable. (Should it return
	   * a function but not visual meta?)
	   *
	   * @pubilc
	   * @abstract
	   * @param {Function} getColorVisual
	   *        params: value, valueState
	   *        return: color
	   * @return {Object} visualMeta
	   *        should includes {stops, outerColors}
	   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
	   */
	  getVisualMeta: noop
	});
	var _default = VisualMapModel;
	module.exports = _default;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Visual mapping.
	 */
	var visualDefault = {
	  /**
	   * @public
	   */
	  get: function (visualType, key, isCategory) {
	    var value = zrUtil.clone((defaultOption[visualType] || {})[key]);
	    return isCategory ? zrUtil.isArray(value) ? value[value.length - 1] : value : value;
	  }
	};
	var defaultOption = {
	  color: {
	    active: ['#006edd', '#e0ffff'],
	    inactive: ['rgba(0,0,0,0)']
	  },
	  colorHue: {
	    active: [0, 360],
	    inactive: [0, 0]
	  },
	  colorSaturation: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  colorLightness: {
	    active: [0.9, 0.5],
	    inactive: [0, 0]
	  },
	  colorAlpha: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  opacity: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  symbol: {
	    active: ['circle', 'roundRect', 'diamond'],
	    inactive: ['none']
	  },
	  symbolSize: {
	    active: [10, 50],
	    inactive: [0, 0]
	  }
	};
	var _default = visualDefault;
	module.exports = _default;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var LinearGradient = __webpack_require__(298);
	
	var eventTool = __webpack_require__(225);
	
	var VisualMapView = __webpack_require__(696);
	
	var graphic = __webpack_require__(268);
	
	var numberUtil = __webpack_require__(306);
	
	var sliderMove = __webpack_require__(507);
	
	var helper = __webpack_require__(697);
	
	var modelUtil = __webpack_require__(261);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var linearMap = numberUtil.linearMap;
	var each = zrUtil.each;
	var mathMin = Math.min;
	var mathMax = Math.max; // Arbitrary value
	
	var HOVER_LINK_SIZE = 12;
	var HOVER_LINK_OUT = 6; // Notice:
	// Any "interval" should be by the order of [low, high].
	// "handle0" (handleIndex === 0) maps to
	// low data value: this._dataInterval[0] and has low coord.
	// "handle1" (handleIndex === 1) maps to
	// high data value: this._dataInterval[1] and has high coord.
	// The logic of transform is implemented in this._createBarGroup.
	
	var ContinuousView = VisualMapView.extend({
	  type: 'visualMap.continuous',
	
	  /**
	   * @override
	   */
	  init: function () {
	    ContinuousView.superApply(this, 'init', arguments);
	    /**
	     * @private
	     */
	
	    this._shapes = {};
	    /**
	     * @private
	     */
	
	    this._dataInterval = [];
	    /**
	     * @private
	     */
	
	    this._handleEnds = [];
	    /**
	     * @private
	     */
	
	    this._orient;
	    /**
	     * @private
	     */
	
	    this._useHandle;
	    /**
	     * @private
	     */
	
	    this._hoverLinkDataIndices = [];
	    /**
	     * @private
	     */
	
	    this._dragging;
	    /**
	     * @private
	     */
	
	    this._hovering;
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  doRender: function (visualMapModel, ecModel, api, payload) {
	    if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) {
	      this._buildView();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _buildView: function () {
	    this.group.removeAll();
	    var visualMapModel = this.visualMapModel;
	    var thisGroup = this.group;
	    this._orient = visualMapModel.get('orient');
	    this._useHandle = visualMapModel.get('calculable');
	
	    this._resetInterval();
	
	    this._renderBar(thisGroup);
	
	    var dataRangeText = visualMapModel.get('text');
	
	    this._renderEndsText(thisGroup, dataRangeText, 0);
	
	    this._renderEndsText(thisGroup, dataRangeText, 1); // Do this for background size calculation.
	
	
	    this._updateView(true); // After updating view, inner shapes is built completely,
	    // and then background can be rendered.
	
	
	    this.renderBackground(thisGroup); // Real update view
	
	    this._updateView();
	
	    this._enableHoverLinkToSeries();
	
	    this._enableHoverLinkFromSeries();
	
	    this.positionGroup(thisGroup);
	  },
	
	  /**
	   * @private
	   */
	  _renderEndsText: function (group, dataRangeText, endsIndex) {
	    if (!dataRangeText) {
	      return;
	    } // Compatible with ec2, text[0] map to high value, text[1] map low value.
	
	
	    var text = dataRangeText[1 - endsIndex];
	    text = text != null ? text + '' : '';
	    var visualMapModel = this.visualMapModel;
	    var textGap = visualMapModel.get('textGap');
	    var itemSize = visualMapModel.itemSize;
	    var barGroup = this._shapes.barGroup;
	
	    var position = this._applyTransform([itemSize[0] / 2, endsIndex === 0 ? -textGap : itemSize[1] + textGap], barGroup);
	
	    var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);
	
	    var orient = this._orient;
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    this.group.add(new graphic.Text({
	      style: {
	        x: position[0],
	        y: position[1],
	        textVerticalAlign: orient === 'horizontal' ? 'middle' : align,
	        textAlign: orient === 'horizontal' ? align : 'center',
	        text: text,
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _renderBar: function (targetGroup) {
	    var visualMapModel = this.visualMapModel;
	    var shapes = this._shapes;
	    var itemSize = visualMapModel.itemSize;
	    var orient = this._orient;
	    var useHandle = this._useHandle;
	    var itemAlign = helper.getItemAlign(visualMapModel, this.api, itemSize);
	
	    var barGroup = shapes.barGroup = this._createBarGroup(itemAlign); // Bar
	
	
	    barGroup.add(shapes.outOfRange = createPolygon());
	    barGroup.add(shapes.inRange = createPolygon(null, useHandle ? getCursor(this._orient) : null, zrUtil.bind(this._dragHandle, this, 'all', false), zrUtil.bind(this._dragHandle, this, 'all', true)));
	    var textRect = visualMapModel.textStyleModel.getTextRect('国');
	    var textSize = mathMax(textRect.width, textRect.height); // Handle
	
	    if (useHandle) {
	      shapes.handleThumbs = [];
	      shapes.handleLabels = [];
	      shapes.handleLabelPoints = [];
	
	      this._createHandle(barGroup, 0, itemSize, textSize, orient, itemAlign);
	
	      this._createHandle(barGroup, 1, itemSize, textSize, orient, itemAlign);
	    }
	
	    this._createIndicator(barGroup, itemSize, textSize, orient);
	
	    targetGroup.add(barGroup);
	  },
	
	  /**
	   * @private
	   */
	  _createHandle: function (barGroup, handleIndex, itemSize, textSize, orient) {
	    var onDrift = zrUtil.bind(this._dragHandle, this, handleIndex, false);
	    var onDragEnd = zrUtil.bind(this._dragHandle, this, handleIndex, true);
	    var handleThumb = createPolygon(createHandlePoints(handleIndex, textSize), getCursor(this._orient), onDrift, onDragEnd);
	    handleThumb.position[0] = itemSize[0];
	    barGroup.add(handleThumb); // Text is always horizontal layout but should not be effected by
	    // transform (orient/inverse). So label is built separately but not
	    // use zrender/graphic/helper/RectText, and is located based on view
	    // group (according to handleLabelPoint) but not barGroup.
	
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    var handleLabel = new graphic.Text({
	      draggable: true,
	      drift: onDrift,
	      onmousemove: function (e) {
	        // Fot mobile devicem, prevent screen slider on the button.
	        eventTool.stop(e.event);
	      },
	      ondragend: onDragEnd,
	      style: {
	        x: 0,
	        y: 0,
	        text: '',
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    });
	    this.group.add(handleLabel);
	    var handleLabelPoint = [orient === 'horizontal' ? textSize / 2 : textSize * 1.5, orient === 'horizontal' ? handleIndex === 0 ? -(textSize * 1.5) : textSize * 1.5 : handleIndex === 0 ? -textSize / 2 : textSize / 2];
	    var shapes = this._shapes;
	    shapes.handleThumbs[handleIndex] = handleThumb;
	    shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
	    shapes.handleLabels[handleIndex] = handleLabel;
	  },
	
	  /**
	   * @private
	   */
	  _createIndicator: function (barGroup, itemSize, textSize, orient) {
	    var indicator = createPolygon([[0, 0]], 'move');
	    indicator.position[0] = itemSize[0];
	    indicator.attr({
	      invisible: true,
	      silent: true
	    });
	    barGroup.add(indicator);
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    var indicatorLabel = new graphic.Text({
	      silent: true,
	      invisible: true,
	      style: {
	        x: 0,
	        y: 0,
	        text: '',
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    });
	    this.group.add(indicatorLabel);
	    var indicatorLabelPoint = [orient === 'horizontal' ? textSize / 2 : HOVER_LINK_OUT + 3, 0];
	    var shapes = this._shapes;
	    shapes.indicator = indicator;
	    shapes.indicatorLabel = indicatorLabel;
	    shapes.indicatorLabelPoint = indicatorLabelPoint;
	  },
	
	  /**
	   * @private
	   */
	  _dragHandle: function (handleIndex, isEnd, dx, dy) {
	    if (!this._useHandle) {
	      return;
	    }
	
	    this._dragging = !isEnd;
	
	    if (!isEnd) {
	      // Transform dx, dy to bar coordination.
	      var vertex = this._applyTransform([dx, dy], this._shapes.barGroup, true);
	
	      this._updateInterval(handleIndex, vertex[1]); // Considering realtime, update view should be executed
	      // before dispatch action.
	
	
	      this._updateView();
	    } // dragEnd do not dispatch action when realtime.
	
	
	    if (isEnd === !this.visualMapModel.get('realtime')) {
	      // jshint ignore:line
	      this.api.dispatchAction({
	        type: 'selectDataRange',
	        from: this.uid,
	        visualMapId: this.visualMapModel.id,
	        selected: this._dataInterval.slice()
	      });
	    }
	
	    if (isEnd) {
	      !this._hovering && this._clearHoverLinkToSeries();
	    } else if (useHoverLinkOnHandle(this.visualMapModel)) {
	      this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _resetInterval: function () {
	    var visualMapModel = this.visualMapModel;
	    var dataInterval = this._dataInterval = visualMapModel.getSelected();
	    var dataExtent = visualMapModel.getExtent();
	    var sizeExtent = [0, visualMapModel.itemSize[1]];
	    this._handleEnds = [linearMap(dataInterval[0], dataExtent, sizeExtent, true), linearMap(dataInterval[1], dataExtent, sizeExtent, true)];
	  },
	
	  /**
	   * @private
	   * @param {(number|string)} handleIndex 0 or 1 or 'all'
	   * @param {number} dx
	   * @param {number} dy
	   */
	  _updateInterval: function (handleIndex, delta) {
	    delta = delta || 0;
	    var visualMapModel = this.visualMapModel;
	    var handleEnds = this._handleEnds;
	    var sizeExtent = [0, visualMapModel.itemSize[1]];
	    sliderMove(delta, handleEnds, sizeExtent, handleIndex, // cross is forbiden
	    0);
	    var dataExtent = visualMapModel.getExtent(); // Update data interval.
	
	    this._dataInterval = [linearMap(handleEnds[0], sizeExtent, dataExtent, true), linearMap(handleEnds[1], sizeExtent, dataExtent, true)];
	  },
	
	  /**
	   * @private
	   */
	  _updateView: function (forSketch) {
	    var visualMapModel = this.visualMapModel;
	    var dataExtent = visualMapModel.getExtent();
	    var shapes = this._shapes;
	    var outOfRangeHandleEnds = [0, visualMapModel.itemSize[1]];
	    var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
	
	    var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');
	
	    var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');
	
	    shapes.inRange.setStyle({
	      fill: visualInRange.barColor,
	      opacity: visualInRange.opacity
	    }).setShape('points', visualInRange.barPoints);
	    shapes.outOfRange.setStyle({
	      fill: visualOutOfRange.barColor,
	      opacity: visualOutOfRange.opacity
	    }).setShape('points', visualOutOfRange.barPoints);
	
	    this._updateHandle(inRangeHandleEnds, visualInRange);
	  },
	
	  /**
	   * @private
	   */
	  _createBarVisual: function (dataInterval, dataExtent, handleEnds, forceState) {
	    var opts = {
	      forceState: forceState,
	      convertOpacityToAlpha: true
	    };
	
	    var colorStops = this._makeColorGradient(dataInterval, opts);
	
	    var symbolSizes = [this.getControllerVisual(dataInterval[0], 'symbolSize', opts), this.getControllerVisual(dataInterval[1], 'symbolSize', opts)];
	
	    var barPoints = this._createBarPoints(handleEnds, symbolSizes);
	
	    return {
	      barColor: new LinearGradient(0, 0, 0, 1, colorStops),
	      barPoints: barPoints,
	      handlesColor: [colorStops[0].color, colorStops[colorStops.length - 1].color]
	    };
	  },
	
	  /**
	   * @private
	   */
	  _makeColorGradient: function (dataInterval, opts) {
	    // Considering colorHue, which is not linear, so we have to sample
	    // to calculate gradient color stops, but not only caculate head
	    // and tail.
	    var sampleNumber = 100; // Arbitrary value.
	
	    var colorStops = [];
	    var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
	    colorStops.push({
	      color: this.getControllerVisual(dataInterval[0], 'color', opts),
	      offset: 0
	    });
	
	    for (var i = 1; i < sampleNumber; i++) {
	      var currValue = dataInterval[0] + step * i;
	
	      if (currValue > dataInterval[1]) {
	        break;
	      }
	
	      colorStops.push({
	        color: this.getControllerVisual(currValue, 'color', opts),
	        offset: i / sampleNumber
	      });
	    }
	
	    colorStops.push({
	      color: this.getControllerVisual(dataInterval[1], 'color', opts),
	      offset: 1
	    });
	    return colorStops;
	  },
	
	  /**
	   * @private
	   */
	  _createBarPoints: function (handleEnds, symbolSizes) {
	    var itemSize = this.visualMapModel.itemSize;
	    return [[itemSize[0] - symbolSizes[0], handleEnds[0]], [itemSize[0], handleEnds[0]], [itemSize[0], handleEnds[1]], [itemSize[0] - symbolSizes[1], handleEnds[1]]];
	  },
	
	  /**
	   * @private
	   */
	  _createBarGroup: function (itemAlign) {
	    var orient = this._orient;
	    var inverse = this.visualMapModel.get('inverse');
	    return new graphic.Group(orient === 'horizontal' && !inverse ? {
	      scale: itemAlign === 'bottom' ? [1, 1] : [-1, 1],
	      rotation: Math.PI / 2
	    } : orient === 'horizontal' && inverse ? {
	      scale: itemAlign === 'bottom' ? [-1, 1] : [1, 1],
	      rotation: -Math.PI / 2
	    } : orient === 'vertical' && !inverse ? {
	      scale: itemAlign === 'left' ? [1, -1] : [-1, -1]
	    } : {
	      scale: itemAlign === 'left' ? [1, 1] : [-1, 1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _updateHandle: function (handleEnds, visualInRange) {
	    if (!this._useHandle) {
	      return;
	    }
	
	    var shapes = this._shapes;
	    var visualMapModel = this.visualMapModel;
	    var handleThumbs = shapes.handleThumbs;
	    var handleLabels = shapes.handleLabels;
	    each([0, 1], function (handleIndex) {
	      var handleThumb = handleThumbs[handleIndex];
	      handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
	      handleThumb.position[1] = handleEnds[handleIndex]; // Update handle label position.
	
	      var textPoint = graphic.applyTransform(shapes.handleLabelPoints[handleIndex], graphic.getTransform(handleThumb, this.group));
	      handleLabels[handleIndex].setStyle({
	        x: textPoint[0],
	        y: textPoint[1],
	        text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
	        textVerticalAlign: 'middle',
	        textAlign: this._applyTransform(this._orient === 'horizontal' ? handleIndex === 0 ? 'bottom' : 'top' : 'left', shapes.barGroup)
	      });
	    }, this);
	  },
	
	  /**
	   * @private
	   * @param {number} cursorValue
	   * @param {number} textValue
	   * @param {string} [rangeSymbol]
	   * @param {number} [halfHoverLinkSize]
	   */
	  _showIndicator: function (cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
	    var visualMapModel = this.visualMapModel;
	    var dataExtent = visualMapModel.getExtent();
	    var itemSize = visualMapModel.itemSize;
	    var sizeExtent = [0, itemSize[1]];
	    var pos = linearMap(cursorValue, dataExtent, sizeExtent, true);
	    var shapes = this._shapes;
	    var indicator = shapes.indicator;
	
	    if (!indicator) {
	      return;
	    }
	
	    indicator.position[1] = pos;
	    indicator.attr('invisible', false);
	    indicator.setShape('points', createIndicatorPoints(!!rangeSymbol, halfHoverLinkSize, pos, itemSize[1]));
	    var opts = {
	      convertOpacityToAlpha: true
	    };
	    var color = this.getControllerVisual(cursorValue, 'color', opts);
	    indicator.setStyle('fill', color); // Update handle label position.
	
	    var textPoint = graphic.applyTransform(shapes.indicatorLabelPoint, graphic.getTransform(indicator, this.group));
	    var indicatorLabel = shapes.indicatorLabel;
	    indicatorLabel.attr('invisible', false);
	
	    var align = this._applyTransform('left', shapes.barGroup);
	
	    var orient = this._orient;
	    indicatorLabel.setStyle({
	      text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
	      textVerticalAlign: orient === 'horizontal' ? align : 'middle',
	      textAlign: orient === 'horizontal' ? 'center' : align,
	      x: textPoint[0],
	      y: textPoint[1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLinkToSeries: function () {
	    var self = this;
	
	    this._shapes.barGroup.on('mousemove', function (e) {
	      self._hovering = true;
	
	      if (!self._dragging) {
	        var itemSize = self.visualMapModel.itemSize;
	
	        var pos = self._applyTransform([e.offsetX, e.offsetY], self._shapes.barGroup, true, true); // For hover link show when hover handle, which might be
	        // below or upper than sizeExtent.
	
	
	        pos[1] = mathMin(mathMax(0, pos[1]), itemSize[1]);
	
	        self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
	      }
	    }).on('mouseout', function () {
	      // When mouse is out of handle, hoverLink still need
	      // to be displayed when realtime is set as false.
	      self._hovering = false;
	      !self._dragging && self._clearHoverLinkToSeries();
	    });
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLinkFromSeries: function () {
	    var zr = this.api.getZr();
	
	    if (this.visualMapModel.option.hoverLink) {
	      zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
	      zr.on('mouseout', this._hideIndicator, this);
	    } else {
	      this._clearHoverLinkFromSeries();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _doHoverLinkToSeries: function (cursorPos, hoverOnBar) {
	    var visualMapModel = this.visualMapModel;
	    var itemSize = visualMapModel.itemSize;
	
	    if (!visualMapModel.option.hoverLink) {
	      return;
	    }
	
	    var sizeExtent = [0, itemSize[1]];
	    var dataExtent = visualMapModel.getExtent(); // For hover link show when hover handle, which might be below or upper than sizeExtent.
	
	    cursorPos = mathMin(mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
	    var halfHoverLinkSize = getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
	    var hoverRange = [cursorPos - halfHoverLinkSize, cursorPos + halfHoverLinkSize];
	    var cursorValue = linearMap(cursorPos, sizeExtent, dataExtent, true);
	    var valueRange = [linearMap(hoverRange[0], sizeExtent, dataExtent, true), linearMap(hoverRange[1], sizeExtent, dataExtent, true)]; // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
	    // where china and india has very large population.
	
	    hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
	    hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity); // Do not show indicator when mouse is over handle,
	    // otherwise labels overlap, especially when dragging.
	
	    if (hoverOnBar) {
	      if (valueRange[0] === -Infinity) {
	        this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
	      } else if (valueRange[1] === Infinity) {
	        this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
	      } else {
	        this._showIndicator(cursorValue, cursorValue, '≈ ', halfHoverLinkSize);
	      }
	    } // When realtime is set as false, handles, which are in barGroup,
	    // also trigger hoverLink, which help user to realize where they
	    // focus on when dragging. (see test/heatmap-large.html)
	    // When realtime is set as true, highlight will not show when hover
	    // handle, because the label on handle, which displays a exact value
	    // but not range, might mislead users.
	
	
	    var oldBatch = this._hoverLinkDataIndices;
	    var newBatch = [];
	
	    if (hoverOnBar || useHoverLinkOnHandle(visualMapModel)) {
	      newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
	    }
	
	    var resultBatches = modelUtil.compressBatches(oldBatch, newBatch);
	
	    this._dispatchHighDown('downplay', helper.makeHighDownBatch(resultBatches[0], visualMapModel));
	
	    this._dispatchHighDown('highlight', helper.makeHighDownBatch(resultBatches[1], visualMapModel));
	  },
	
	  /**
	   * @private
	   */
	  _hoverLinkFromSeriesMouseOver: function (e) {
	    var el = e.target;
	    var visualMapModel = this.visualMapModel;
	
	    if (!el || el.dataIndex == null) {
	      return;
	    }
	
	    var dataModel = this.ecModel.getSeriesByIndex(el.seriesIndex);
	
	    if (!visualMapModel.isTargetSeries(dataModel)) {
	      return;
	    }
	
	    var data = dataModel.getData(el.dataType);
	    var value = data.get(visualMapModel.getDataDimension(data), el.dataIndex, true);
	
	    if (!isNaN(value)) {
	      this._showIndicator(value, value);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _hideIndicator: function () {
	    var shapes = this._shapes;
	    shapes.indicator && shapes.indicator.attr('invisible', true);
	    shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
	  },
	
	  /**
	   * @private
	   */
	  _clearHoverLinkToSeries: function () {
	    this._hideIndicator();
	
	    var indices = this._hoverLinkDataIndices;
	
	    this._dispatchHighDown('downplay', helper.makeHighDownBatch(indices, this.visualMapModel));
	
	    indices.length = 0;
	  },
	
	  /**
	   * @private
	   */
	  _clearHoverLinkFromSeries: function () {
	    this._hideIndicator();
	
	    var zr = this.api.getZr();
	    zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
	    zr.off('mouseout', this._hideIndicator);
	  },
	
	  /**
	   * @private
	   */
	  _applyTransform: function (vertex, element, inverse, global) {
	    var transform = graphic.getTransform(element, global ? null : this.group);
	    return graphic[zrUtil.isArray(vertex) ? 'applyTransform' : 'transformDirection'](vertex, transform, inverse);
	  },
	
	  /**
	   * @private
	   */
	  _dispatchHighDown: function (type, batch) {
	    batch && batch.length && this.api.dispatchAction({
	      type: type,
	      batch: batch
	    });
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clearHoverLinkFromSeries();
	
	    this._clearHoverLinkToSeries();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearHoverLinkFromSeries();
	
	    this._clearHoverLinkToSeries();
	  }
	});
	
	function createPolygon(points, cursor, onDrift, onDragEnd) {
	  return new graphic.Polygon({
	    shape: {
	      points: points
	    },
	    draggable: !!onDrift,
	    cursor: cursor,
	    drift: onDrift,
	    onmousemove: function (e) {
	      // Fot mobile devicem, prevent screen slider on the button.
	      eventTool.stop(e.event);
	    },
	    ondragend: onDragEnd
	  });
	}
	
	function createHandlePoints(handleIndex, textSize) {
	  return handleIndex === 0 ? [[0, 0], [textSize, 0], [textSize, -textSize]] : [[0, 0], [textSize, 0], [textSize, textSize]];
	}
	
	function createIndicatorPoints(isRange, halfHoverLinkSize, pos, extentMax) {
	  return isRange ? [// indicate range
	  [0, -mathMin(halfHoverLinkSize, mathMax(pos, 0))], [HOVER_LINK_OUT, 0], [0, mathMin(halfHoverLinkSize, mathMax(extentMax - pos, 0))]] : [// indicate single value
	  [0, 0], [5, -5], [5, 5]];
	}
	
	function getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
	  var halfHoverLinkSize = HOVER_LINK_SIZE / 2;
	  var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');
	
	  if (hoverLinkDataSize) {
	    halfHoverLinkSize = linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
	  }
	
	  return halfHoverLinkSize;
	}
	
	function useHoverLinkOnHandle(visualMapModel) {
	  var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
	  return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
	}
	
	function getCursor(orient) {
	  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	}
	
	var _default = ContinuousView;
	module.exports = _default;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var zrUtil = __webpack_require__(220);
	
	var graphic = __webpack_require__(268);
	
	var formatUtil = __webpack_require__(307);
	
	var layout = __webpack_require__(305);
	
	var VisualMapping = __webpack_require__(468);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'visualMap',
	
	  /**
	   * @readOnly
	   * @type {Object}
	   */
	  autoPositionValues: {
	    left: 1,
	    right: 1,
	    top: 1,
	    bottom: 1
	  },
	  init: function (ecModel, api) {
	    /**
	     * @readOnly
	     * @type {module:echarts/model/Global}
	     */
	    this.ecModel = ecModel;
	    /**
	     * @readOnly
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this.api = api;
	    /**
	     * @readOnly
	     * @type {module:echarts/component/visualMap/visualMapModel}
	     */
	
	    this.visualMapModel;
	  },
	
	  /**
	   * @protected
	   */
	  render: function (visualMapModel, ecModel, api, payload) {
	    this.visualMapModel = visualMapModel;
	
	    if (visualMapModel.get('show') === false) {
	      this.group.removeAll();
	      return;
	    }
	
	    this.doRender.apply(this, arguments);
	  },
	
	  /**
	   * @protected
	   */
	  renderBackground: function (group) {
	    var visualMapModel = this.visualMapModel;
	    var padding = formatUtil.normalizeCssArray(visualMapModel.get('padding') || 0);
	    var rect = group.getBoundingRect();
	    group.add(new graphic.Rect({
	      z2: -1,
	      // Lay background rect on the lowest layer.
	      silent: true,
	      shape: {
	        x: rect.x - padding[3],
	        y: rect.y - padding[0],
	        width: rect.width + padding[3] + padding[1],
	        height: rect.height + padding[0] + padding[2]
	      },
	      style: {
	        fill: visualMapModel.get('backgroundColor'),
	        stroke: visualMapModel.get('borderColor'),
	        lineWidth: visualMapModel.get('borderWidth')
	      }
	    }));
	  },
	
	  /**
	   * @protected
	   * @param {number} targetValue can be Infinity or -Infinity
	   * @param {string=} visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
	   * @param {Object} [opts]
	   * @param {string=} [opts.forceState] Specify state, instead of using getValueState method.
	   * @param {string=} [opts.convertOpacityToAlpha=false] For color gradient in controller widget.
	   * @return {*} Visual value.
	   */
	  getControllerVisual: function (targetValue, visualCluster, opts) {
	    opts = opts || {};
	    var forceState = opts.forceState;
	    var visualMapModel = this.visualMapModel;
	    var visualObj = {}; // Default values.
	
	    if (visualCluster === 'symbol') {
	      visualObj.symbol = visualMapModel.get('itemSymbol');
	    }
	
	    if (visualCluster === 'color') {
	      var defaultColor = visualMapModel.get('contentColor');
	      visualObj.color = defaultColor;
	    }
	
	    function getter(key) {
	      return visualObj[key];
	    }
	
	    function setter(key, value) {
	      visualObj[key] = value;
	    }
	
	    var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
	    var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	    zrUtil.each(visualTypes, function (type) {
	      var visualMapping = mappings[type];
	
	      if (opts.convertOpacityToAlpha && type === 'opacity') {
	        type = 'colorAlpha';
	        visualMapping = mappings.__alphaForOpacity;
	      }
	
	      if (VisualMapping.dependsOn(type, visualCluster)) {
	        visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
	      }
	    });
	    return visualObj[visualCluster];
	  },
	
	  /**
	   * @protected
	   */
	  positionGroup: function (group) {
	    var model = this.visualMapModel;
	    var api = this.api;
	    layout.positionElement(group, model.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	  },
	
	  /**
	   * @protected
	   * @abstract
	   */
	  doRender: zrUtil.noop
	});
	
	module.exports = _default;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var _layout = __webpack_require__(305);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/component/visualMap/VisualMapModel} visualMapModel\
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Array.<number>} itemSize always [short, long]
	 * @return {string} 'left' or 'right' or 'top' or 'bottom'
	 */
	function getItemAlign(visualMapModel, api, itemSize) {
	  var modelOption = visualMapModel.option;
	  var itemAlign = modelOption.align;
	
	  if (itemAlign != null && itemAlign !== 'auto') {
	    return itemAlign;
	  } // Auto decision align.
	
	
	  var ecSize = {
	    width: api.getWidth(),
	    height: api.getHeight()
	  };
	  var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
	  var paramsSet = [['left', 'right', 'width'], ['top', 'bottom', 'height']];
	  var reals = paramsSet[realIndex];
	  var fakeValue = [0, null, 10];
	  var layoutInput = {};
	
	  for (var i = 0; i < 3; i++) {
	    layoutInput[paramsSet[1 - realIndex][i]] = fakeValue[i];
	    layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
	  }
	
	  var rParam = [['x', 'width', 3], ['y', 'height', 0]][realIndex];
	  var rect = getLayoutRect(layoutInput, ecSize, modelOption.padding);
	  return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
	}
	/**
	 * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
	 * dataIndexInside means filtered index.
	 */
	
	
	function makeHighDownBatch(batch, visualMapModel) {
	  zrUtil.each(batch || [], function (batchItem) {
	    if (batchItem.dataIndex != null) {
	      batchItem.dataIndexInside = batchItem.dataIndex;
	      batchItem.dataIndex = null;
	    }
	
	    batchItem.highlightKey = 'visualMap' + (visualMapModel ? visualMapModel.componentIndex : '');
	  });
	  return batch;
	}
	
	exports.getItemAlign = getItemAlign;
	exports.makeHighDownBatch = makeHighDownBatch;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var actionInfo = {
	  type: 'selectDataRange',
	  event: 'dataRangeSelected',
	  // FIXME use updateView appears wrong
	  update: 'update'
	};
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'visualMap',
	    query: payload
	  }, function (model) {
	    model.setSelected(payload.selected);
	  });
	});

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(215);
	
	var preprocessor = __webpack_require__(689);
	
	__webpack_require__(690);
	
	__webpack_require__(691);
	
	__webpack_require__(700);
	
	__webpack_require__(701);
	
	__webpack_require__(698);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(216);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(220);
	
	var VisualMapModel = __webpack_require__(693);
	
	var VisualMapping = __webpack_require__(468);
	
	var visualDefault = __webpack_require__(694);
	
	var _number = __webpack_require__(306);
	
	var reformIntervals = _number.reformIntervals;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PiecewiseModel = VisualMapModel.extend({
	  type: 'visualMap.piecewise',
	
	  /**
	   * Order Rule:
	   *
	   * option.categories / option.pieces / option.text / option.selected:
	   *     If !option.inverse,
	   *     Order when vertical: ['top', ..., 'bottom'].
	   *     Order when horizontal: ['left', ..., 'right'].
	   *     If option.inverse, the meaning of
	   *     the order should be reversed.
	   *
	   * this._pieceList:
	   *     The order is always [low, ..., high].
	   *
	   * Mapping from location to low-high:
	   *     If !option.inverse
	   *     When vertical, top is high.
	   *     When horizontal, right is high.
	   *     If option.inverse, reverse.
	   */
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    selected: null,
	    // Object. If not specified, means selected.
	    // When pieces and splitNumber: {'0': true, '5': true}
	    // When categories: {'cate1': false, 'cate3': true}
	    // When selected === false, means all unselected.
	    minOpen: false,
	    // Whether include values that smaller than `min`.
	    maxOpen: false,
	    // Whether include values that bigger than `max`.
	    align: 'auto',
	    // 'auto', 'left', 'right'
	    itemWidth: 20,
	    // When put the controller vertically, it is the length of
	    // horizontal side of each item. Otherwise, vertical side.
	    itemHeight: 14,
	    // When put the controller vertically, it is the length of
	    // vertical side of each item. Otherwise, horizontal side.
	    itemSymbol: 'roundRect',
	    pieceList: null,
	    // Each item is Object, with some of those attrs:
	    // {min, max, lt, gt, lte, gte, value,
	    // color, colorSaturation, colorAlpha, opacity,
	    // symbol, symbolSize}, which customize the range or visual
	    // coding of the certain piece. Besides, see "Order Rule".
	    categories: null,
	    // category names, like: ['some1', 'some2', 'some3'].
	    // Attr min/max are ignored when categories set. See "Order Rule"
	    splitNumber: 5,
	    // If set to 5, auto split five pieces equally.
	    // If set to 0 and component type not set, component type will be
	    // determined as "continuous". (It is less reasonable but for ec2
	    // compatibility, see echarts/component/visualMap/typeDefaulter)
	    selectedMode: 'multiple',
	    // Can be 'multiple' or 'single'.
	    itemGap: 10,
	    // The gap between two items, in px.
	    hoverLink: true,
	    // Enable hover highlight.
	    showLabel: null // By default, when text is used, label will hide (the logic
	    // is remained for compatibility reason)
	
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    PiecewiseModel.superApply(this, 'optionUpdated', arguments);
	    /**
	     * The order is always [low, ..., high].
	     * [{text: string, interval: Array.<number>}, ...]
	     * @private
	     * @type {Array.<Object>}
	     */
	
	    this._pieceList = [];
	    this.resetExtent();
	    /**
	     * 'pieces', 'categories', 'splitNumber'
	     * @type {string}
	     */
	
	    var mode = this._mode = this._determineMode();
	
	    resetMethods[this._mode].call(this);
	
	    this._resetSelected(newOption, isInit);
	
	    var categories = this.option.categories;
	    this.resetVisual(function (mappingOption, state) {
	      if (mode === 'categories') {
	        mappingOption.mappingMethod = 'category';
	        mappingOption.categories = zrUtil.clone(categories);
	      } else {
	        mappingOption.dataExtent = this.getExtent();
	        mappingOption.mappingMethod = 'piecewise';
	        mappingOption.pieceList = zrUtil.map(this._pieceList, function (piece) {
	          var piece = zrUtil.clone(piece);
	
	          if (state !== 'inRange') {
	            // FIXME
	            // outOfRange do not support special visual in pieces.
	            piece.visual = null;
	          }
	
	          return piece;
	        });
	      }
	    });
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  completeVisualOption: function () {
	    // Consider this case:
	    // visualMap: {
	    //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
	    // }
	    // where no inRange/outOfRange set but only pieces. So we should make
	    // default inRange/outOfRange for this case, otherwise visuals that only
	    // appear in `pieces` will not be taken into account in visual encoding.
	    var option = this.option;
	    var visualTypesInPieces = {};
	    var visualTypes = VisualMapping.listVisualTypes();
	    var isCategory = this.isCategory();
	    zrUtil.each(option.pieces, function (piece) {
	      zrUtil.each(visualTypes, function (visualType) {
	        if (piece.hasOwnProperty(visualType)) {
	          visualTypesInPieces[visualType] = 1;
	        }
	      });
	    });
	    zrUtil.each(visualTypesInPieces, function (v, visualType) {
	      var exists = 0;
	      zrUtil.each(this.stateList, function (state) {
	        exists |= has(option, state, visualType) || has(option.target, state, visualType);
	      }, this);
	      !exists && zrUtil.each(this.stateList, function (state) {
	        (option[state] || (option[state] = {}))[visualType] = visualDefault.get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
	      });
	    }, this);
	
	    function has(obj, state, visualType) {
	      return obj && obj[state] && (zrUtil.isObject(obj[state]) ? obj[state].hasOwnProperty(visualType) : obj[state] === visualType // e.g., inRange: 'symbol'
	      );
	    }
	
	    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
	  },
	  _resetSelected: function (newOption, isInit) {
	    var thisOption = this.option;
	    var pieceList = this._pieceList; // Selected do not merge but all override.
	
	    var selected = (isInit ? thisOption : newOption).selected || {};
	    thisOption.selected = selected; // Consider 'not specified' means true.
	
	    zrUtil.each(pieceList, function (piece, index) {
	      var key = this.getSelectedMapKey(piece);
	
	      if (!selected.hasOwnProperty(key)) {
	        selected[key] = true;
	      }
	    }, this);
	
	    if (thisOption.selectedMode === 'single') {
	      // Ensure there is only one selected.
	      var hasSel = false;
	      zrUtil.each(pieceList, function (piece, index) {
	        var key = this.getSelectedMapKey(piece);
	
	        if (selected[key]) {
	          hasSel ? selected[key] = false : hasSel = true;
	        }
	      }, this);
	    } // thisOption.selectedMode === 'multiple', default: all selected.
	
	  },
	
	  /**
	   * @public
	   */
	  getSelectedMapKey: function (piece) {
	    return this._mode === 'categories' ? piece.value + '' : piece.index + '';
	  },
	
	  /**
	   * @public
	   */
	  getPieceList: function () {
	    return this._pieceList;
	  },
	
	  /**
	   * @private
	   * @return {string}
	   */
	  _determineMode: function () {
	    var option = this.option;
	    return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  setSelected: function (selected) {
	    this.option.selected = zrUtil.clone(selected);
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  getValueState: function (value) {
	    var index = VisualMapping.findPieceIndex(value, this._pieceList);
	    return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
	  },
	
	  /**
	   * @public
	   * @params {number} pieceIndex piece index in visualMapModel.getPieceList()
	   * @return {Array.<Object>} [{seriesId, dataIndex: <Array.<number>>}, ...]
	   */
	  findTargetDataIndices: function (pieceIndex) {
	    var result = [];
	    this.eachTargetSeries(function (seriesModel) {
	      var dataIndices = [];
	      var data = seriesModel.getData();
	      data.each(this.getDataDimension(data), function (value, dataIndex) {
	        // Should always base on model pieceList, because it is order sensitive.
	        var pIdx = VisualMapping.findPieceIndex(value, this._pieceList);
	        pIdx === pieceIndex && dataIndices.push(dataIndex);
	      }, this);
	      result.push({
	        seriesId: seriesModel.id,
	        dataIndex: dataIndices
	      });
	    }, this);
	    return result;
	  },
	
	  /**
	   * @private
	   * @param {Object} piece piece.value or piece.interval is required.
	   * @return {number} Can be Infinity or -Infinity
	   */
	  getRepresentValue: function (piece) {
	    var representValue;
	
	    if (this.isCategory()) {
	      representValue = piece.value;
	    } else {
	      if (piece.value != null) {
	        representValue = piece.value;
	      } else {
	        var pieceInterval = piece.interval || [];
	        representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
	      }
	    }
	
	    return representValue;
	  },
	  getVisualMeta: function (getColorVisual) {
	    // Do not support category. (category axis is ordinal, numerical)
	    if (this.isCategory()) {
	      return;
	    }
	
	    var stops = [];
	    var outerColors = [];
	    var visualMapModel = this;
	
	    function setStop(interval, valueState) {
	      var representValue = visualMapModel.getRepresentValue({
	        interval: interval
	      });
	
	      if (!valueState) {
	        valueState = visualMapModel.getValueState(representValue);
	      }
	
	      var color = getColorVisual(representValue, valueState);
	
	      if (interval[0] === -Infinity) {
	        outerColors[0] = color;
	      } else if (interval[1] === Infinity) {
	        outerColors[1] = color;
	      } else {
	        stops.push({
	          value: interval[0],
	          color: color
	        }, {
	          value: interval[1],
	          color: color
	        });
	      }
	    } // Suplement
	
	
	    var pieceList = this._pieceList.slice();
	
	    if (!pieceList.length) {
	      pieceList.push({
	        interval: [-Infinity, Infinity]
	      });
	    } else {
	      var edge = pieceList[0].interval[0];
	      edge !== -Infinity && pieceList.unshift({
	        interval: [-Infinity, edge]
	      });
	      edge = pieceList[pieceList.length - 1].interval[1];
	      edge !== Infinity && pieceList.push({
	        interval: [edge, Infinity]
	      });
	    }
	
	    var curr = -Infinity;
	    zrUtil.each(pieceList, function (piece) {
	      var interval = piece.interval;
	
	      if (interval) {
	        // Fulfill gap.
	        interval[0] > curr && setStop([curr, interval[0]], 'outOfRange');
	        setStop(interval.slice());
	        curr = interval[1];
	      }
	    }, this);
	    return {
	      stops: stops,
	      outerColors: outerColors
	    };
	  }
	});
	/**
	 * Key is this._mode
	 * @type {Object}
	 * @this {module:echarts/component/viusalMap/PiecewiseMode}
	 */
	
	var resetMethods = {
	  splitNumber: function () {
	    var thisOption = this.option;
	    var pieceList = this._pieceList;
	    var precision = Math.min(thisOption.precision, 20);
	    var dataExtent = this.getExtent();
	    var splitNumber = thisOption.splitNumber;
	    splitNumber = Math.max(parseInt(splitNumber, 10), 1);
	    thisOption.splitNumber = splitNumber;
	    var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber; // Precision auto-adaption
	
	    while (+splitStep.toFixed(precision) !== splitStep && precision < 5) {
	      precision++;
	    }
	
	    thisOption.precision = precision;
	    splitStep = +splitStep.toFixed(precision);
	
	    if (thisOption.minOpen) {
	      pieceList.push({
	        interval: [-Infinity, dataExtent[0]],
	        close: [0, 0]
	      });
	    }
	
	    for (var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++) {
	      var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
	      pieceList.push({
	        interval: [curr, max],
	        close: [1, 1]
	      });
	    }
	
	    if (thisOption.maxOpen) {
	      pieceList.push({
	        interval: [dataExtent[1], Infinity],
	        close: [0, 0]
	      });
	    }
	
	    reformIntervals(pieceList);
	    zrUtil.each(pieceList, function (piece, index) {
	      piece.index = index;
	      piece.text = this.formatValueText(piece.interval);
	    }, this);
	  },
	  categories: function () {
	    var thisOption = this.option;
	    zrUtil.each(thisOption.categories, function (cate) {
	      // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
	      // 是否改一致。
	      this._pieceList.push({
	        text: this.formatValueText(cate, true),
	        value: cate
	      });
	    }, this); // See "Order Rule".
	
	    normalizeReverse(thisOption, this._pieceList);
	  },
	  pieces: function () {
	    var thisOption = this.option;
	    var pieceList = this._pieceList;
	    zrUtil.each(thisOption.pieces, function (pieceListItem, index) {
	      if (!zrUtil.isObject(pieceListItem)) {
	        pieceListItem = {
	          value: pieceListItem
	        };
	      }
	
	      var item = {
	        text: '',
	        index: index
	      };
	
	      if (pieceListItem.label != null) {
	        item.text = pieceListItem.label;
	      }
	
	      if (pieceListItem.hasOwnProperty('value')) {
	        var value = item.value = pieceListItem.value;
	        item.interval = [value, value];
	        item.close = [1, 1];
	      } else {
	        // `min` `max` is legacy option.
	        // `lt` `gt` `lte` `gte` is recommanded.
	        var interval = item.interval = [];
	        var close = item.close = [0, 0];
	        var closeList = [1, 0, 1];
	        var infinityList = [-Infinity, Infinity];
	        var useMinMax = [];
	
	        for (var lg = 0; lg < 2; lg++) {
	          var names = [['gte', 'gt', 'min'], ['lte', 'lt', 'max']][lg];
	
	          for (var i = 0; i < 3 && interval[lg] == null; i++) {
	            interval[lg] = pieceListItem[names[i]];
	            close[lg] = closeList[i];
	            useMinMax[lg] = i === 2;
	          }
	
	          interval[lg] == null && (interval[lg] = infinityList[lg]);
	        }
	
	        useMinMax[0] && interval[1] === Infinity && (close[0] = 0);
	        useMinMax[1] && interval[0] === -Infinity && (close[1] = 0);
	
	        if (interval[0] === interval[1] && close[0] && close[1]) {
	          // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
	          // we use value to lift the priority when min === max
	          item.value = interval[0];
	        }
	      }
	
	      item.visual = VisualMapping.retrieveVisuals(pieceListItem);
	      pieceList.push(item);
	    }, this); // See "Order Rule".
	
	    normalizeReverse(thisOption, pieceList); // Only pieces
	
	    reformIntervals(pieceList);
	    zrUtil.each(pieceList, function (piece) {
	      var close = piece.close;
	      var edgeSymbols = [['<', '≤'][close[1]], ['>', '≥'][close[0]]];
	      piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
	    }, this);
	  }
	};
	
	function normalizeReverse(thisOption, pieceList) {
	  var inverse = thisOption.inverse;
	
	  if (thisOption.orient === 'vertical' ? !inverse : inverse) {
	    pieceList.reverse();
	  }
	}
	
	var _default = PiecewiseModel;
	module.exports = _default;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(220);
	
	var VisualMapView = __webpack_require__(696);
	
	var graphic = __webpack_require__(268);
	
	var _symbol = __webpack_require__(360);
	
	var createSymbol = _symbol.createSymbol;
	
	var layout = __webpack_require__(305);
	
	var helper = __webpack_require__(697);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PiecewiseVisualMapView = VisualMapView.extend({
	  type: 'visualMap.piecewise',
	
	  /**
	   * @protected
	   * @override
	   */
	  doRender: function () {
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	    var visualMapModel = this.visualMapModel;
	    var textGap = visualMapModel.get('textGap');
	    var textStyleModel = visualMapModel.textStyleModel;
	    var textFont = textStyleModel.getFont();
	    var textFill = textStyleModel.getTextColor();
	
	    var itemAlign = this._getItemAlign();
	
	    var itemSize = visualMapModel.itemSize;
	
	    var viewData = this._getViewData();
	
	    var endsText = viewData.endsText;
	    var showLabel = zrUtil.retrieve(visualMapModel.get('showLabel', true), !endsText);
	    endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
	    zrUtil.each(viewData.viewPieceList, renderItem, this);
	    endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
	    layout.box(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
	    this.renderBackground(thisGroup);
	    this.positionGroup(thisGroup);
	
	    function renderItem(item) {
	      var piece = item.piece;
	      var itemGroup = new graphic.Group();
	      itemGroup.onclick = zrUtil.bind(this._onItemClick, this, piece);
	
	      this._enableHoverLink(itemGroup, item.indexInModelPieceList);
	
	      var representValue = visualMapModel.getRepresentValue(piece);
	
	      this._createItemSymbol(itemGroup, representValue, [0, 0, itemSize[0], itemSize[1]]);
	
	      if (showLabel) {
	        var visualState = this.visualMapModel.getValueState(representValue);
	        itemGroup.add(new graphic.Text({
	          style: {
	            x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
	            y: itemSize[1] / 2,
	            text: piece.text,
	            textVerticalAlign: 'middle',
	            textAlign: itemAlign,
	            textFont: textFont,
	            textFill: textFill,
	            opacity: visualState === 'outOfRange' ? 0.5 : 1
	          }
	        }));
	      }
	
	      thisGroup.add(itemGroup);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLink: function (itemGroup, pieceIndex) {
	    itemGroup.on('mouseover', zrUtil.bind(onHoverLink, this, 'highlight')).on('mouseout', zrUtil.bind(onHoverLink, this, 'downplay'));
	
	    function onHoverLink(method) {
	      var visualMapModel = this.visualMapModel;
	      visualMapModel.option.hoverLink && this.api.dispatchAction({
	        type: method,
	        batch: helper.makeHighDownBatch(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _getItemAlign: function () {
	    var visualMapModel = this.visualMapModel;
	    var modelOption = visualMapModel.option;
	
	    if (modelOption.orient === 'vertical') {
	      return helper.getItemAlign(visualMapModel, this.api, visualMapModel.itemSize);
	    } else {
	      // horizontal, most case left unless specifying right.
	      var align = modelOption.align;
	
	      if (!align || align === 'auto') {
	        align = 'left';
	      }
	
	      return align;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderEndsText: function (group, text, itemSize, showLabel, itemAlign) {
	    if (!text) {
	      return;
	    }
	
	    var itemGroup = new graphic.Group();
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    itemGroup.add(new graphic.Text({
	      style: {
	        x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
	        y: itemSize[1] / 2,
	        textVerticalAlign: 'middle',
	        textAlign: showLabel ? itemAlign : 'center',
	        text: text,
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    }));
	    group.add(itemGroup);
	  },
	
	  /**
	   * @private
	   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
	   */
	  _getViewData: function () {
	    var visualMapModel = this.visualMapModel;
	    var viewPieceList = zrUtil.map(visualMapModel.getPieceList(), function (piece, index) {
	      return {
	        piece: piece,
	        indexInModelPieceList: index
	      };
	    });
	    var endsText = visualMapModel.get('text'); // Consider orient and inverse.
	
	    var orient = visualMapModel.get('orient');
	    var inverse = visualMapModel.get('inverse'); // Order of model pieceList is always [low, ..., high]
	
	    if (orient === 'horizontal' ? inverse : !inverse) {
	      viewPieceList.reverse();
	    } // Origin order of endsText is [high, low]
	    else if (endsText) {
	        endsText = endsText.slice().reverse();
	      }
	
	    return {
	      viewPieceList: viewPieceList,
	      endsText: endsText
	    };
	  },
	
	  /**
	   * @private
	   */
	  _createItemSymbol: function (group, representValue, shapeParam) {
	    group.add(createSymbol(this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], this.getControllerVisual(representValue, 'color')));
	  },
	
	  /**
	   * @private
	   */
	  _onItemClick: function (piece) {
	    var visualMapModel = this.visualMapModel;
	    var option = visualMapModel.option;
	    var selected = zrUtil.clone(option.selected);
	    var newKey = visualMapModel.getSelectedMapKey(piece);
	
	    if (option.selectedMode === 'single') {
	      selected[newKey] = true;
	      zrUtil.each(selected, function (o, key) {
	        selected[key] = key === newKey;
	      });
	    } else {
	      selected[newKey] = !selected[newKey];
	    }
	
	    this.api.dispatchAction({
	      type: 'selectDataRange',
	      from: this.uid,
	      visualMapId: this.visualMapModel.id,
	      selected: selected
	    });
	  }
	});
	var _default = PiecewiseVisualMapView;
	module.exports = _default;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(703);
	
	var _zrender = __webpack_require__(217);
	
	var registerPainter = _zrender.registerPainter;
	
	var Painter = __webpack_require__(705);
	
	registerPainter('vml', Painter);

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(219);
	
	var _vector = __webpack_require__(222);
	
	var applyTransform = _vector.applyTransform;
	
	var BoundingRect = __webpack_require__(242);
	
	var colorTool = __webpack_require__(238);
	
	var textContain = __webpack_require__(255);
	
	var textHelper = __webpack_require__(254);
	
	var RectText = __webpack_require__(253);
	
	var Displayable = __webpack_require__(252);
	
	var ZImage = __webpack_require__(251);
	
	var Text = __webpack_require__(282);
	
	var Path = __webpack_require__(270);
	
	var PathProxy = __webpack_require__(271);
	
	var Gradient = __webpack_require__(299);
	
	var vmlCore = __webpack_require__(704);
	
	// http://www.w3.org/TR/NOTE-VML
	// TODO Use proxy like svg instead of overwrite brush methods
	var CMD = PathProxy.CMD;
	var round = Math.round;
	var sqrt = Math.sqrt;
	var abs = Math.abs;
	var cos = Math.cos;
	var sin = Math.sin;
	var mathMax = Math.max;
	
	if (!env.canvasSupported) {
	  var comma = ',';
	  var imageTransformPrefix = 'progid:DXImageTransform.Microsoft';
	  var Z = 21600;
	  var Z2 = Z / 2;
	  var ZLEVEL_BASE = 100000;
	  var Z_BASE = 1000;
	
	  var initRootElStyle = function (el) {
	    el.style.cssText = 'position:absolute;left:0;top:0;width:1px;height:1px;';
	    el.coordsize = Z + ',' + Z;
	    el.coordorigin = '0,0';
	  };
	
	  var encodeHtmlAttribute = function (s) {
	    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
	  };
	
	  var rgb2Str = function (r, g, b) {
	    return 'rgb(' + [r, g, b].join(',') + ')';
	  };
	
	  var append = function (parent, child) {
	    if (child && parent && child.parentNode !== parent) {
	      parent.appendChild(child);
	    }
	  };
	
	  var remove = function (parent, child) {
	    if (child && parent && child.parentNode === parent) {
	      parent.removeChild(child);
	    }
	  };
	
	  var getZIndex = function (zlevel, z, z2) {
	    // z 的取值范围为 [0, 1000]
	    return (parseFloat(zlevel) || 0) * ZLEVEL_BASE + (parseFloat(z) || 0) * Z_BASE + z2;
	  };
	
	  var parsePercent = textHelper.parsePercent;
	  /***************************************************
	   * PATH
	   **************************************************/
	
	  var setColorAndOpacity = function (el, color, opacity) {
	    var colorArr = colorTool.parse(color);
	    opacity = +opacity;
	
	    if (isNaN(opacity)) {
	      opacity = 1;
	    }
	
	    if (colorArr) {
	      el.color = rgb2Str(colorArr[0], colorArr[1], colorArr[2]);
	      el.opacity = opacity * colorArr[3];
	    }
	  };
	
	  var getColorAndAlpha = function (color) {
	    var colorArr = colorTool.parse(color);
	    return [rgb2Str(colorArr[0], colorArr[1], colorArr[2]), colorArr[3]];
	  };
	
	  var updateFillNode = function (el, style, zrEl) {
	    // TODO pattern
	    var fill = style.fill;
	
	    if (fill != null) {
	      // Modified from excanvas
	      if (fill instanceof Gradient) {
	        var gradientType;
	        var angle = 0;
	        var focus = [0, 0]; // additional offset
	
	        var shift = 0; // scale factor for offset
	
	        var expansion = 1;
	        var rect = zrEl.getBoundingRect();
	        var rectWidth = rect.width;
	        var rectHeight = rect.height;
	
	        if (fill.type === 'linear') {
	          gradientType = 'gradient';
	          var transform = zrEl.transform;
	          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
	          var p1 = [fill.x2 * rectWidth, fill.y2 * rectHeight];
	
	          if (transform) {
	            applyTransform(p0, p0, transform);
	            applyTransform(p1, p1, transform);
	          }
	
	          var dx = p1[0] - p0[0];
	          var dy = p1[1] - p0[1];
	          angle = Math.atan2(dx, dy) * 180 / Math.PI; // The angle should be a non-negative number.
	
	          if (angle < 0) {
	            angle += 360;
	          } // Very small angles produce an unexpected result because they are
	          // converted to a scientific notation string.
	
	
	          if (angle < 1e-6) {
	            angle = 0;
	          }
	        } else {
	          gradientType = 'gradientradial';
	          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
	          var transform = zrEl.transform;
	          var scale = zrEl.scale;
	          var width = rectWidth;
	          var height = rectHeight;
	          focus = [// Percent in bounding rect
	          (p0[0] - rect.x) / width, (p0[1] - rect.y) / height];
	
	          if (transform) {
	            applyTransform(p0, p0, transform);
	          }
	
	          width /= scale[0] * Z;
	          height /= scale[1] * Z;
	          var dimension = mathMax(width, height);
	          shift = 2 * 0 / dimension;
	          expansion = 2 * fill.r / dimension - shift;
	        } // We need to sort the color stops in ascending order by offset,
	        // otherwise IE won't interpret it correctly.
	
	
	        var stops = fill.colorStops.slice();
	        stops.sort(function (cs1, cs2) {
	          return cs1.offset - cs2.offset;
	        });
	        var length = stops.length; // Color and alpha list of first and last stop
	
	        var colorAndAlphaList = [];
	        var colors = [];
	
	        for (var i = 0; i < length; i++) {
	          var stop = stops[i];
	          var colorAndAlpha = getColorAndAlpha(stop.color);
	          colors.push(stop.offset * expansion + shift + ' ' + colorAndAlpha[0]);
	
	          if (i === 0 || i === length - 1) {
	            colorAndAlphaList.push(colorAndAlpha);
	          }
	        }
	
	        if (length >= 2) {
	          var color1 = colorAndAlphaList[0][0];
	          var color2 = colorAndAlphaList[1][0];
	          var opacity1 = colorAndAlphaList[0][1] * style.opacity;
	          var opacity2 = colorAndAlphaList[1][1] * style.opacity;
	          el.type = gradientType;
	          el.method = 'none';
	          el.focus = '100%';
	          el.angle = angle;
	          el.color = color1;
	          el.color2 = color2;
	          el.colors = colors.join(','); // When colors attribute is used, the meanings of opacity and o:opacity2
	          // are reversed.
	
	          el.opacity = opacity2; // FIXME g_o_:opacity ?
	
	          el.opacity2 = opacity1;
	        }
	
	        if (gradientType === 'radial') {
	          el.focusposition = focus.join(',');
	        }
	      } else {
	        // FIXME Change from Gradient fill to color fill
	        setColorAndOpacity(el, fill, style.opacity);
	      }
	    }
	  };
	
	  var updateStrokeNode = function (el, style) {
	    // if (style.lineJoin != null) {
	    //     el.joinstyle = style.lineJoin;
	    // }
	    // if (style.miterLimit != null) {
	    //     el.miterlimit = style.miterLimit * Z;
	    // }
	    // if (style.lineCap != null) {
	    //     el.endcap = style.lineCap;
	    // }
	    if (style.lineDash) {
	      el.dashstyle = style.lineDash.join(' ');
	    }
	
	    if (style.stroke != null && !(style.stroke instanceof Gradient)) {
	      setColorAndOpacity(el, style.stroke, style.opacity);
	    }
	  };
	
	  var updateFillAndStroke = function (vmlEl, type, style, zrEl) {
	    var isFill = type === 'fill';
	    var el = vmlEl.getElementsByTagName(type)[0]; // Stroke must have lineWidth
	
	    if (style[type] != null && style[type] !== 'none' && (isFill || !isFill && style.lineWidth)) {
	      vmlEl[isFill ? 'filled' : 'stroked'] = 'true'; // FIXME Remove before updating, or set `colors` will throw error
	
	      if (style[type] instanceof Gradient) {
	        remove(vmlEl, el);
	      }
	
	      if (!el) {
	        el = vmlCore.createNode(type);
	      }
	
	      isFill ? updateFillNode(el, style, zrEl) : updateStrokeNode(el, style);
	      append(vmlEl, el);
	    } else {
	      vmlEl[isFill ? 'filled' : 'stroked'] = 'false';
	      remove(vmlEl, el);
	    }
	  };
	
	  var points = [[], [], []];
	
	  var pathDataToString = function (path, m) {
	    var M = CMD.M;
	    var C = CMD.C;
	    var L = CMD.L;
	    var A = CMD.A;
	    var Q = CMD.Q;
	    var str = [];
	    var nPoint;
	    var cmdStr;
	    var cmd;
	    var i;
	    var xi;
	    var yi;
	    var data = path.data;
	    var dataLength = path.len();
	
	    for (i = 0; i < dataLength;) {
	      cmd = data[i++];
	      cmdStr = '';
	      nPoint = 0;
	
	      switch (cmd) {
	        case M:
	          cmdStr = ' m ';
	          nPoint = 1;
	          xi = data[i++];
	          yi = data[i++];
	          points[0][0] = xi;
	          points[0][1] = yi;
	          break;
	
	        case L:
	          cmdStr = ' l ';
	          nPoint = 1;
	          xi = data[i++];
	          yi = data[i++];
	          points[0][0] = xi;
	          points[0][1] = yi;
	          break;
	
	        case Q:
	        case C:
	          cmdStr = ' c ';
	          nPoint = 3;
	          var x1 = data[i++];
	          var y1 = data[i++];
	          var x2 = data[i++];
	          var y2 = data[i++];
	          var x3;
	          var y3;
	
	          if (cmd === Q) {
	            // Convert quadratic to cubic using degree elevation
	            x3 = x2;
	            y3 = y2;
	            x2 = (x2 + 2 * x1) / 3;
	            y2 = (y2 + 2 * y1) / 3;
	            x1 = (xi + 2 * x1) / 3;
	            y1 = (yi + 2 * y1) / 3;
	          } else {
	            x3 = data[i++];
	            y3 = data[i++];
	          }
	
	          points[0][0] = x1;
	          points[0][1] = y1;
	          points[1][0] = x2;
	          points[1][1] = y2;
	          points[2][0] = x3;
	          points[2][1] = y3;
	          xi = x3;
	          yi = y3;
	          break;
	
	        case A:
	          var x = 0;
	          var y = 0;
	          var sx = 1;
	          var sy = 1;
	          var angle = 0;
	
	          if (m) {
	            // Extract SRT from matrix
	            x = m[4];
	            y = m[5];
	            sx = sqrt(m[0] * m[0] + m[1] * m[1]);
	            sy = sqrt(m[2] * m[2] + m[3] * m[3]);
	            angle = Math.atan2(-m[1] / sy, m[0] / sx);
	          }
	
	          var cx = data[i++];
	          var cy = data[i++];
	          var rx = data[i++];
	          var ry = data[i++];
	          var startAngle = data[i++] + angle;
	          var endAngle = data[i++] + startAngle + angle; // FIXME
	          // var psi = data[i++];
	
	          i++;
	          var clockwise = data[i++];
	          var x0 = cx + cos(startAngle) * rx;
	          var y0 = cy + sin(startAngle) * ry;
	          var x1 = cx + cos(endAngle) * rx;
	          var y1 = cy + sin(endAngle) * ry;
	          var type = clockwise ? ' wa ' : ' at ';
	
	          if (Math.abs(x0 - x1) < 1e-4) {
	            // IE won't render arches drawn counter clockwise if x0 == x1.
	            if (Math.abs(endAngle - startAngle) > 1e-2) {
	              // Offset x0 by 1/80 of a pixel. Use something
	              // that can be represented in binary
	              if (clockwise) {
	                x0 += 270 / Z;
	              }
	            } else {
	              // Avoid case draw full circle
	              if (Math.abs(y0 - cy) < 1e-4) {
	                if (clockwise && x0 < cx || !clockwise && x0 > cx) {
	                  y1 -= 270 / Z;
	                } else {
	                  y1 += 270 / Z;
	                }
	              } else if (clockwise && y0 < cy || !clockwise && y0 > cy) {
	                x1 += 270 / Z;
	              } else {
	                x1 -= 270 / Z;
	              }
	            }
	          }
	
	          str.push(type, round(((cx - rx) * sx + x) * Z - Z2), comma, round(((cy - ry) * sy + y) * Z - Z2), comma, round(((cx + rx) * sx + x) * Z - Z2), comma, round(((cy + ry) * sy + y) * Z - Z2), comma, round((x0 * sx + x) * Z - Z2), comma, round((y0 * sy + y) * Z - Z2), comma, round((x1 * sx + x) * Z - Z2), comma, round((y1 * sy + y) * Z - Z2));
	          xi = x1;
	          yi = y1;
	          break;
	
	        case CMD.R:
	          var p0 = points[0];
	          var p1 = points[1]; // x0, y0
	
	          p0[0] = data[i++];
	          p0[1] = data[i++]; // x1, y1
	
	          p1[0] = p0[0] + data[i++];
	          p1[1] = p0[1] + data[i++];
	
	          if (m) {
	            applyTransform(p0, p0, m);
	            applyTransform(p1, p1, m);
	          }
	
	          p0[0] = round(p0[0] * Z - Z2);
	          p1[0] = round(p1[0] * Z - Z2);
	          p0[1] = round(p0[1] * Z - Z2);
	          p1[1] = round(p1[1] * Z - Z2);
	          str.push( // x0, y0
	          ' m ', p0[0], comma, p0[1], // x1, y0
	          ' l ', p1[0], comma, p0[1], // x1, y1
	          ' l ', p1[0], comma, p1[1], // x0, y1
	          ' l ', p0[0], comma, p1[1]);
	          break;
	
	        case CMD.Z:
	          // FIXME Update xi, yi
	          str.push(' x ');
	      }
	
	      if (nPoint > 0) {
	        str.push(cmdStr);
	
	        for (var k = 0; k < nPoint; k++) {
	          var p = points[k];
	          m && applyTransform(p, p, m); // 不 round 会非常慢
	
	          str.push(round(p[0] * Z - Z2), comma, round(p[1] * Z - Z2), k < nPoint - 1 ? comma : '');
	        }
	      }
	    }
	
	    return str.join('');
	  }; // Rewrite the original path method
	
	
	  Path.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	    var vmlEl = this._vmlEl;
	
	    if (!vmlEl) {
	      vmlEl = vmlCore.createNode('shape');
	      initRootElStyle(vmlEl);
	      this._vmlEl = vmlEl;
	    }
	
	    updateFillAndStroke(vmlEl, 'fill', style, this);
	    updateFillAndStroke(vmlEl, 'stroke', style, this);
	    var m = this.transform;
	    var needTransform = m != null;
	    var strokeEl = vmlEl.getElementsByTagName('stroke')[0];
	
	    if (strokeEl) {
	      var lineWidth = style.lineWidth; // Get the line scale.
	      // Determinant of this.m_ means how much the area is enlarged by the
	      // transformation. So its square root can be used as a scale factor
	      // for width.
	
	      if (needTransform && !style.strokeNoScale) {
	        var det = m[0] * m[3] - m[1] * m[2];
	        lineWidth *= sqrt(abs(det));
	      }
	
	      strokeEl.weight = lineWidth + 'px';
	    }
	
	    var path = this.path || (this.path = new PathProxy());
	
	    if (this.__dirtyPath) {
	      path.beginPath();
	      path.subPixelOptimize = false;
	      this.buildPath(path, this.shape);
	      path.toStatic();
	      this.__dirtyPath = false;
	    }
	
	    vmlEl.path = pathDataToString(path, this.transform);
	    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root
	
	    append(vmlRoot, vmlEl); // Text
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, this.getBoundingRect());
	    } else {
	      this.removeRectText(vmlRoot);
	    }
	  };
	
	  Path.prototype.onRemove = function (vmlRoot) {
	    remove(vmlRoot, this._vmlEl);
	    this.removeRectText(vmlRoot);
	  };
	
	  Path.prototype.onAdd = function (vmlRoot) {
	    append(vmlRoot, this._vmlEl);
	    this.appendRectText(vmlRoot);
	  };
	  /***************************************************
	   * IMAGE
	   **************************************************/
	
	
	  var isImage = function (img) {
	    // FIXME img instanceof Image 如果 img 是一个字符串的时候，IE8 下会报错
	    return typeof img === 'object' && img.tagName && img.tagName.toUpperCase() === 'IMG'; // return img instanceof Image;
	  }; // Rewrite the original path method
	
	
	  ZImage.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	    var image = style.image; // Image original width, height
	
	    var ow;
	    var oh;
	
	    if (isImage(image)) {
	      var src = image.src;
	
	      if (src === this._imageSrc) {
	        ow = this._imageWidth;
	        oh = this._imageHeight;
	      } else {
	        var imageRuntimeStyle = image.runtimeStyle;
	        var oldRuntimeWidth = imageRuntimeStyle.width;
	        var oldRuntimeHeight = imageRuntimeStyle.height;
	        imageRuntimeStyle.width = 'auto';
	        imageRuntimeStyle.height = 'auto'; // get the original size
	
	        ow = image.width;
	        oh = image.height; // and remove overides
	
	        imageRuntimeStyle.width = oldRuntimeWidth;
	        imageRuntimeStyle.height = oldRuntimeHeight; // Caching image original width, height and src
	
	        this._imageSrc = src;
	        this._imageWidth = ow;
	        this._imageHeight = oh;
	      }
	
	      image = src;
	    } else {
	      if (image === this._imageSrc) {
	        ow = this._imageWidth;
	        oh = this._imageHeight;
	      }
	    }
	
	    if (!image) {
	      return;
	    }
	
	    var x = style.x || 0;
	    var y = style.y || 0;
	    var dw = style.width;
	    var dh = style.height;
	    var sw = style.sWidth;
	    var sh = style.sHeight;
	    var sx = style.sx || 0;
	    var sy = style.sy || 0;
	    var hasCrop = sw && sh;
	    var vmlEl = this._vmlEl;
	
	    if (!vmlEl) {
	      // FIXME 使用 group 在 left, top 都不是 0 的时候就无法显示了。
	      // vmlEl = vmlCore.createNode('group');
	      vmlEl = vmlCore.doc.createElement('div');
	      initRootElStyle(vmlEl);
	      this._vmlEl = vmlEl;
	    }
	
	    var vmlElStyle = vmlEl.style;
	    var hasRotation = false;
	    var m;
	    var scaleX = 1;
	    var scaleY = 1;
	
	    if (this.transform) {
	      m = this.transform;
	      scaleX = sqrt(m[0] * m[0] + m[1] * m[1]);
	      scaleY = sqrt(m[2] * m[2] + m[3] * m[3]);
	      hasRotation = m[1] || m[2];
	    }
	
	    if (hasRotation) {
	      // If filters are necessary (rotation exists), create them
	      // filters are bog-slow, so only create them if abbsolutely necessary
	      // The following check doesn't account for skews (which don't exist
	      // in the canvas spec (yet) anyway.
	      // From excanvas
	      var p0 = [x, y];
	      var p1 = [x + dw, y];
	      var p2 = [x, y + dh];
	      var p3 = [x + dw, y + dh];
	      applyTransform(p0, p0, m);
	      applyTransform(p1, p1, m);
	      applyTransform(p2, p2, m);
	      applyTransform(p3, p3, m);
	      var maxX = mathMax(p0[0], p1[0], p2[0], p3[0]);
	      var maxY = mathMax(p0[1], p1[1], p2[1], p3[1]);
	      var transformFilter = [];
	      transformFilter.push('M11=', m[0] / scaleX, comma, 'M12=', m[2] / scaleY, comma, 'M21=', m[1] / scaleX, comma, 'M22=', m[3] / scaleY, comma, 'Dx=', round(x * scaleX + m[4]), comma, 'Dy=', round(y * scaleY + m[5]));
	      vmlElStyle.padding = '0 ' + round(maxX) + 'px ' + round(maxY) + 'px 0'; // FIXME DXImageTransform 在 IE11 的兼容模式下不起作用
	
	      vmlElStyle.filter = imageTransformPrefix + '.Matrix(' + transformFilter.join('') + ', SizingMethod=clip)';
	    } else {
	      if (m) {
	        x = x * scaleX + m[4];
	        y = y * scaleY + m[5];
	      }
	
	      vmlElStyle.filter = '';
	      vmlElStyle.left = round(x) + 'px';
	      vmlElStyle.top = round(y) + 'px';
	    }
	
	    var imageEl = this._imageEl;
	    var cropEl = this._cropEl;
	
	    if (!imageEl) {
	      imageEl = vmlCore.doc.createElement('div');
	      this._imageEl = imageEl;
	    }
	
	    var imageELStyle = imageEl.style;
	
	    if (hasCrop) {
	      // Needs know image original width and height
	      if (!(ow && oh)) {
	        var tmpImage = new Image();
	        var self = this;
	
	        tmpImage.onload = function () {
	          tmpImage.onload = null;
	          ow = tmpImage.width;
	          oh = tmpImage.height; // Adjust image width and height to fit the ratio destinationSize / sourceSize
	
	          imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
	          imageELStyle.height = round(scaleY * oh * dh / sh) + 'px'; // Caching image original width, height and src
	
	          self._imageWidth = ow;
	          self._imageHeight = oh;
	          self._imageSrc = image;
	        };
	
	        tmpImage.src = image;
	      } else {
	        imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
	        imageELStyle.height = round(scaleY * oh * dh / sh) + 'px';
	      }
	
	      if (!cropEl) {
	        cropEl = vmlCore.doc.createElement('div');
	        cropEl.style.overflow = 'hidden';
	        this._cropEl = cropEl;
	      }
	
	      var cropElStyle = cropEl.style;
	      cropElStyle.width = round((dw + sx * dw / sw) * scaleX);
	      cropElStyle.height = round((dh + sy * dh / sh) * scaleY);
	      cropElStyle.filter = imageTransformPrefix + '.Matrix(Dx=' + -sx * dw / sw * scaleX + ',Dy=' + -sy * dh / sh * scaleY + ')';
	
	      if (!cropEl.parentNode) {
	        vmlEl.appendChild(cropEl);
	      }
	
	      if (imageEl.parentNode !== cropEl) {
	        cropEl.appendChild(imageEl);
	      }
	    } else {
	      imageELStyle.width = round(scaleX * dw) + 'px';
	      imageELStyle.height = round(scaleY * dh) + 'px';
	      vmlEl.appendChild(imageEl);
	
	      if (cropEl && cropEl.parentNode) {
	        vmlEl.removeChild(cropEl);
	        this._cropEl = null;
	      }
	    }
	
	    var filterStr = '';
	    var alpha = style.opacity;
	
	    if (alpha < 1) {
	      filterStr += '.Alpha(opacity=' + round(alpha * 100) + ') ';
	    }
	
	    filterStr += imageTransformPrefix + '.AlphaImageLoader(src=' + image + ', SizingMethod=scale)';
	    imageELStyle.filter = filterStr;
	    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root
	
	    append(vmlRoot, vmlEl); // Text
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, this.getBoundingRect());
	    }
	  };
	
	  ZImage.prototype.onRemove = function (vmlRoot) {
	    remove(vmlRoot, this._vmlEl);
	    this._vmlEl = null;
	    this._cropEl = null;
	    this._imageEl = null;
	    this.removeRectText(vmlRoot);
	  };
	
	  ZImage.prototype.onAdd = function (vmlRoot) {
	    append(vmlRoot, this._vmlEl);
	    this.appendRectText(vmlRoot);
	  };
	  /***************************************************
	   * TEXT
	   **************************************************/
	
	
	  var DEFAULT_STYLE_NORMAL = 'normal';
	  var fontStyleCache = {};
	  var fontStyleCacheCount = 0;
	  var MAX_FONT_CACHE_SIZE = 100;
	  var fontEl = document.createElement('div');
	
	  var getFontStyle = function (fontString) {
	    var fontStyle = fontStyleCache[fontString];
	
	    if (!fontStyle) {
	      // Clear cache
	      if (fontStyleCacheCount > MAX_FONT_CACHE_SIZE) {
	        fontStyleCacheCount = 0;
	        fontStyleCache = {};
	      }
	
	      var style = fontEl.style;
	      var fontFamily;
	
	      try {
	        style.font = fontString;
	        fontFamily = style.fontFamily.split(',')[0];
	      } catch (e) {}
	
	      fontStyle = {
	        style: style.fontStyle || DEFAULT_STYLE_NORMAL,
	        variant: style.fontVariant || DEFAULT_STYLE_NORMAL,
	        weight: style.fontWeight || DEFAULT_STYLE_NORMAL,
	        size: parseFloat(style.fontSize || 12) | 0,
	        family: fontFamily || 'Microsoft YaHei'
	      };
	      fontStyleCache[fontString] = fontStyle;
	      fontStyleCacheCount++;
	    }
	
	    return fontStyle;
	  };
	
	  var textMeasureEl; // Overwrite measure text method
	
	  textContain.$override('measureText', function (text, textFont) {
	    var doc = vmlCore.doc;
	
	    if (!textMeasureEl) {
	      textMeasureEl = doc.createElement('div');
	      textMeasureEl.style.cssText = 'position:absolute;top:-20000px;left:0;' + 'padding:0;margin:0;border:none;white-space:pre;';
	      vmlCore.doc.body.appendChild(textMeasureEl);
	    }
	
	    try {
	      textMeasureEl.style.font = textFont;
	    } catch (ex) {// Ignore failures to set to invalid font.
	    }
	
	    textMeasureEl.innerHTML = ''; // Don't use innerHTML or innerText because they allow markup/whitespace.
	
	    textMeasureEl.appendChild(doc.createTextNode(text));
	    return {
	      width: textMeasureEl.offsetWidth
	    };
	  });
	  var tmpRect = new BoundingRect();
	
	  var drawRectText = function (vmlRoot, rect, textRect, fromTextEl) {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	    var text = style.text; // Convert to string
	
	    text != null && (text += '');
	
	    if (!text) {
	      return;
	    } // Convert rich text to plain text. Rich text is not supported in
	    // IE8-, but tags in rich text template will be removed.
	
	
	    if (style.rich) {
	      var contentBlock = textContain.parseRichText(text, style);
	      text = [];
	
	      for (var i = 0; i < contentBlock.lines.length; i++) {
	        var tokens = contentBlock.lines[i].tokens;
	        var textLine = [];
	
	        for (var j = 0; j < tokens.length; j++) {
	          textLine.push(tokens[j].text);
	        }
	
	        text.push(textLine.join(''));
	      }
	
	      text = text.join('\n');
	    }
	
	    var x;
	    var y;
	    var align = style.textAlign;
	    var verticalAlign = style.textVerticalAlign;
	    var fontStyle = getFontStyle(style.font); // FIXME encodeHtmlAttribute ?
	
	    var font = fontStyle.style + ' ' + fontStyle.variant + ' ' + fontStyle.weight + ' ' + fontStyle.size + 'px "' + fontStyle.family + '"';
	    textRect = textRect || textContain.getBoundingRect(text, font, align, verticalAlign, style.textPadding, style.textLineHeight); // Transform rect to view space
	
	    var m = this.transform; // Ignore transform for text in other element
	
	    if (m && !fromTextEl) {
	      tmpRect.copy(rect);
	      tmpRect.applyTransform(m);
	      rect = tmpRect;
	    }
	
	    if (!fromTextEl) {
	      var textPosition = style.textPosition; // Text position represented by coord
	
	      if (textPosition instanceof Array) {
	        x = rect.x + parsePercent(textPosition[0], rect.width);
	        y = rect.y + parsePercent(textPosition[1], rect.height);
	        align = align || 'left';
	      } else {
	        var res = this.calculateTextPosition ? this.calculateTextPosition({}, style, rect) : textContain.calculateTextPosition({}, style, rect);
	        x = res.x;
	        y = res.y; // Default align and baseline when has textPosition
	
	        align = align || res.textAlign;
	        verticalAlign = verticalAlign || res.textVerticalAlign;
	      }
	    } else {
	      x = rect.x;
	      y = rect.y;
	    }
	
	    x = textContain.adjustTextX(x, textRect.width, align);
	    y = textContain.adjustTextY(y, textRect.height, verticalAlign); // Force baseline 'middle'
	
	    y += textRect.height / 2; // var fontSize = fontStyle.size;
	    // 1.75 is an arbitrary number, as there is no info about the text baseline
	    // switch (baseline) {
	    // case 'hanging':
	    // case 'top':
	    //     y += fontSize / 1.75;
	    //     break;
	    //     case 'middle':
	    //         break;
	    //     default:
	    //     // case null:
	    //     // case 'alphabetic':
	    //     // case 'ideographic':
	    //     // case 'bottom':
	    //         y -= fontSize / 2.25;
	    //         break;
	    // }
	    // switch (align) {
	    //     case 'left':
	    //         break;
	    //     case 'center':
	    //         x -= textRect.width / 2;
	    //         break;
	    //     case 'right':
	    //         x -= textRect.width;
	    //         break;
	    // case 'end':
	    // align = elementStyle.direction == 'ltr' ? 'right' : 'left';
	    // break;
	    // case 'start':
	    // align = elementStyle.direction == 'rtl' ? 'right' : 'left';
	    // break;
	    // default:
	    //     align = 'left';
	    // }
	
	    var createNode = vmlCore.createNode;
	    var textVmlEl = this._textVmlEl;
	    var pathEl;
	    var textPathEl;
	    var skewEl;
	
	    if (!textVmlEl) {
	      textVmlEl = createNode('line');
	      pathEl = createNode('path');
	      textPathEl = createNode('textpath');
	      skewEl = createNode('skew'); // FIXME Why here is not cammel case
	      // Align 'center' seems wrong
	
	      textPathEl.style['v-text-align'] = 'left';
	      initRootElStyle(textVmlEl);
	      pathEl.textpathok = true;
	      textPathEl.on = true;
	      textVmlEl.from = '0 0';
	      textVmlEl.to = '1000 0.05';
	      append(textVmlEl, skewEl);
	      append(textVmlEl, pathEl);
	      append(textVmlEl, textPathEl);
	      this._textVmlEl = textVmlEl;
	    } else {
	      // 这里是在前面 appendChild 保证顺序的前提下
	      skewEl = textVmlEl.firstChild;
	      pathEl = skewEl.nextSibling;
	      textPathEl = pathEl.nextSibling;
	    }
	
	    var coords = [x, y];
	    var textVmlElStyle = textVmlEl.style; // Ignore transform for text in other element
	
	    if (m && fromTextEl) {
	      applyTransform(coords, coords, m);
	      skewEl.on = true;
	      skewEl.matrix = m[0].toFixed(3) + comma + m[2].toFixed(3) + comma + m[1].toFixed(3) + comma + m[3].toFixed(3) + ',0,0'; // Text position
	
	      skewEl.offset = (round(coords[0]) || 0) + ',' + (round(coords[1]) || 0); // Left top point as origin
	
	      skewEl.origin = '0 0';
	      textVmlElStyle.left = '0px';
	      textVmlElStyle.top = '0px';
	    } else {
	      skewEl.on = false;
	      textVmlElStyle.left = round(x) + 'px';
	      textVmlElStyle.top = round(y) + 'px';
	    }
	
	    textPathEl.string = encodeHtmlAttribute(text); // TODO
	
	    try {
	      textPathEl.style.font = font;
	    } // Error font format
	    catch (e) {}
	
	    updateFillAndStroke(textVmlEl, 'fill', {
	      fill: style.textFill,
	      opacity: style.opacity
	    }, this);
	    updateFillAndStroke(textVmlEl, 'stroke', {
	      stroke: style.textStroke,
	      opacity: style.opacity,
	      lineDash: style.lineDash || null // style.lineDash can be `false`.
	
	    }, this);
	    textVmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Attached to root
	
	    append(vmlRoot, textVmlEl);
	  };
	
	  var removeRectText = function (vmlRoot) {
	    remove(vmlRoot, this._textVmlEl);
	    this._textVmlEl = null;
	  };
	
	  var appendRectText = function (vmlRoot) {
	    append(vmlRoot, this._textVmlEl);
	  };
	
	  var list = [RectText, Displayable, ZImage, Path, Text]; // In case Displayable has been mixed in RectText
	
	  for (var i = 0; i < list.length; i++) {
	    var proto = list[i].prototype;
	    proto.drawRectText = drawRectText;
	    proto.removeRectText = removeRectText;
	    proto.appendRectText = appendRectText;
	  }
	
	  Text.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, {
	        x: style.x || 0,
	        y: style.y || 0,
	        width: 0,
	        height: 0
	      }, this.getBoundingRect(), true);
	    } else {
	      this.removeRectText(vmlRoot);
	    }
	  };
	
	  Text.prototype.onRemove = function (vmlRoot) {
	    this.removeRectText(vmlRoot);
	  };
	
	  Text.prototype.onAdd = function (vmlRoot) {
	    this.appendRectText(vmlRoot);
	  };
	}

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	var env = __webpack_require__(219);
	
	var urn = 'urn:schemas-microsoft-com:vml';
	var win = typeof window === 'undefined' ? null : window;
	var vmlInited = false;
	var doc = win && win.document;
	
	function createNode(tagName) {
	  return doCreateNode(tagName);
	} // Avoid assign to an exported variable, for transforming to cjs.
	
	
	var doCreateNode;
	
	if (doc && !env.canvasSupported) {
	  try {
	    !doc.namespaces.zrvml && doc.namespaces.add('zrvml', urn);
	
	    doCreateNode = function (tagName) {
	      return doc.createElement('<zrvml:' + tagName + ' class="zrvml">');
	    };
	  } catch (e) {
	    doCreateNode = function (tagName) {
	      return doc.createElement('<' + tagName + ' xmlns="' + urn + '" class="zrvml">');
	    };
	  }
	} // From raphael
	
	
	function initVML() {
	  if (vmlInited || !doc) {
	    return;
	  }
	
	  vmlInited = true;
	  var styleSheets = doc.styleSheets;
	
	  if (styleSheets.length < 31) {
	    doc.createStyleSheet().addRule('.zrvml', 'behavior:url(#default#VML)');
	  } else {
	    // http://msdn.microsoft.com/en-us/library/ms531194%28VS.85%29.aspx
	    styleSheets[0].addRule('.zrvml', 'behavior:url(#default#VML)');
	  }
	}
	
	exports.doc = doc;
	exports.createNode = createNode;
	exports.initVML = initVML;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	var logError = __webpack_require__(240);
	
	var vmlCore = __webpack_require__(704);
	
	var _util = __webpack_require__(220);
	
	var each = _util.each;
	
	/**
	 * VML Painter.
	 *
	 * @module zrender/vml/Painter
	 */
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	/**
	 * @alias module:zrender/vml/Painter
	 */
	
	
	function VMLPainter(root, storage) {
	  vmlCore.initVML();
	  this.root = root;
	  this.storage = storage;
	  var vmlViewport = document.createElement('div');
	  var vmlRoot = document.createElement('div');
	  vmlViewport.style.cssText = 'display:inline-block;overflow:hidden;position:relative;width:300px;height:150px;';
	  vmlRoot.style.cssText = 'position:absolute;left:0;top:0;';
	  root.appendChild(vmlViewport);
	  this._vmlRoot = vmlRoot;
	  this._vmlViewport = vmlViewport;
	  this.resize(); // Modify storage
	
	  var oldDelFromStorage = storage.delFromStorage;
	  var oldAddToStorage = storage.addToStorage;
	
	  storage.delFromStorage = function (el) {
	    oldDelFromStorage.call(storage, el);
	
	    if (el) {
	      el.onRemove && el.onRemove(vmlRoot);
	    }
	  };
	
	  storage.addToStorage = function (el) {
	    // Displayable already has a vml node
	    el.onAdd && el.onAdd(vmlRoot);
	    oldAddToStorage.call(storage, el);
	  };
	
	  this._firstPaint = true;
	}
	
	VMLPainter.prototype = {
	  constructor: VMLPainter,
	  getType: function () {
	    return 'vml';
	  },
	
	  /**
	   * @return {HTMLDivElement}
	   */
	  getViewportRoot: function () {
	    return this._vmlViewport;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	
	  /**
	   * 刷新
	   */
	  refresh: function () {
	    var list = this.storage.getDisplayList(true, true);
	
	    this._paintList(list);
	  },
	  _paintList: function (list) {
	    var vmlRoot = this._vmlRoot;
	
	    for (var i = 0; i < list.length; i++) {
	      var el = list[i];
	
	      if (el.invisible || el.ignore) {
	        if (!el.__alreadyNotVisible) {
	          el.onRemove(vmlRoot);
	        } // Set as already invisible
	
	
	        el.__alreadyNotVisible = true;
	      } else {
	        if (el.__alreadyNotVisible) {
	          el.onAdd(vmlRoot);
	        }
	
	        el.__alreadyNotVisible = false;
	
	        if (el.__dirty) {
	          el.beforeBrush && el.beforeBrush();
	          (el.brushVML || el.brush).call(el, vmlRoot);
	          el.afterBrush && el.afterBrush();
	        }
	      }
	
	      el.__dirty = false;
	    }
	
	    if (this._firstPaint) {
	      // Detached from document at first time
	      // to avoid page refreshing too many times
	      // FIXME 如果每次都先 removeChild 可能会导致一些填充和描边的效果改变
	      this._vmlViewport.appendChild(vmlRoot);
	
	      this._firstPaint = false;
	    }
	  },
	  resize: function (width, height) {
	    var width = width == null ? this._getWidth() : width;
	    var height = height == null ? this._getHeight() : height;
	
	    if (this._width !== width || this._height !== height) {
	      this._width = width;
	      this._height = height;
	      var vmlViewportStyle = this._vmlViewport.style;
	      vmlViewportStyle.width = width + 'px';
	      vmlViewportStyle.height = height + 'px';
	    }
	  },
	  dispose: function () {
	    this.root.innerHTML = '';
	    this._vmlRoot = this._vmlViewport = this.storage = null;
	  },
	  getWidth: function () {
	    return this._width;
	  },
	  getHeight: function () {
	    return this._height;
	  },
	  clear: function () {
	    if (this._vmlViewport) {
	      this.root.removeChild(this._vmlViewport);
	    }
	  },
	  _getWidth: function () {
	    var root = this.root;
	    var stl = root.currentStyle;
	    return (root.clientWidth || parseInt10(stl.width)) - parseInt10(stl.paddingLeft) - parseInt10(stl.paddingRight) | 0;
	  },
	  _getHeight: function () {
	    var root = this.root;
	    var stl = root.currentStyle;
	    return (root.clientHeight || parseInt10(stl.height)) - parseInt10(stl.paddingTop) - parseInt10(stl.paddingBottom) | 0;
	  }
	}; // Not supported methods
	
	function createMethodNotSupport(method) {
	  return function () {
	    logError('In IE8.0 VML mode painter not support method "' + method + '"');
	  };
	} // Unsupported methods
	
	
	each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'toDataURL', 'pathToImage'], function (name) {
	  VMLPainter.prototype[name] = createMethodNotSupport(name);
	});
	var _default = VMLPainter;
	module.exports = _default;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(707);
	
	var _zrender = __webpack_require__(217);
	
	var registerPainter = _zrender.registerPainter;
	
	var Painter = __webpack_require__(709);
	
	registerPainter('svg', Painter);

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(708);
	
	var createElement = _core.createElement;
	
	var PathProxy = __webpack_require__(271);
	
	var BoundingRect = __webpack_require__(242);
	
	var matrix = __webpack_require__(233);
	
	var textContain = __webpack_require__(255);
	
	var textHelper = __webpack_require__(254);
	
	var Text = __webpack_require__(282);
	
	// TODO
	// 1. shadow
	// 2. Image: sx, sy, sw, sh
	var CMD = PathProxy.CMD;
	var arrayJoin = Array.prototype.join;
	var NONE = 'none';
	var mathRound = Math.round;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI = Math.PI;
	var PI2 = Math.PI * 2;
	var degree = 180 / PI;
	var EPSILON = 1e-4;
	
	function round4(val) {
	  return mathRound(val * 1e4) / 1e4;
	}
	
	function isAroundZero(val) {
	  return val < EPSILON && val > -EPSILON;
	}
	
	function pathHasFill(style, isText) {
	  var fill = isText ? style.textFill : style.fill;
	  return fill != null && fill !== NONE;
	}
	
	function pathHasStroke(style, isText) {
	  var stroke = isText ? style.textStroke : style.stroke;
	  return stroke != null && stroke !== NONE;
	}
	
	function setTransform(svgEl, m) {
	  if (m) {
	    attr(svgEl, 'transform', 'matrix(' + arrayJoin.call(m, ',') + ')');
	  }
	}
	
	function attr(el, key, val) {
	  if (!val || val.type !== 'linear' && val.type !== 'radial') {
	    // Don't set attribute for gradient, since it need new dom nodes
	    el.setAttribute(key, val);
	  }
	}
	
	function attrXLink(el, key, val) {
	  el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
	}
	
	function bindStyle(svgEl, style, isText, el) {
	  if (pathHasFill(style, isText)) {
	    var fill = isText ? style.textFill : style.fill;
	    fill = fill === 'transparent' ? NONE : fill;
	    attr(svgEl, 'fill', fill);
	    attr(svgEl, 'fill-opacity', style.fillOpacity != null ? style.fillOpacity * style.opacity : style.opacity);
	  } else {
	    attr(svgEl, 'fill', NONE);
	  }
	
	  if (pathHasStroke(style, isText)) {
	    var stroke = isText ? style.textStroke : style.stroke;
	    stroke = stroke === 'transparent' ? NONE : stroke;
	    attr(svgEl, 'stroke', stroke);
	    var strokeWidth = isText ? style.textStrokeWidth : style.lineWidth;
	    var strokeScale = !isText && style.strokeNoScale ? el.getLineScale() : 1;
	    attr(svgEl, 'stroke-width', strokeWidth / strokeScale); // stroke then fill for text; fill then stroke for others
	
	    attr(svgEl, 'paint-order', isText ? 'stroke' : 'fill');
	    attr(svgEl, 'stroke-opacity', style.strokeOpacity != null ? style.strokeOpacity : style.opacity);
	    var lineDash = style.lineDash;
	
	    if (lineDash) {
	      attr(svgEl, 'stroke-dasharray', style.lineDash.join(','));
	      attr(svgEl, 'stroke-dashoffset', mathRound(style.lineDashOffset || 0));
	    } else {
	      attr(svgEl, 'stroke-dasharray', '');
	    } // PENDING
	
	
	    style.lineCap && attr(svgEl, 'stroke-linecap', style.lineCap);
	    style.lineJoin && attr(svgEl, 'stroke-linejoin', style.lineJoin);
	    style.miterLimit && attr(svgEl, 'stroke-miterlimit', style.miterLimit);
	  } else {
	    attr(svgEl, 'stroke', NONE);
	  }
	}
	/***************************************************
	 * PATH
	 **************************************************/
	
	
	function pathDataToString(path) {
	  var str = [];
	  var data = path.data;
	  var dataLength = path.len();
	
	  for (var i = 0; i < dataLength;) {
	    var cmd = data[i++];
	    var cmdStr = '';
	    var nData = 0;
	
	    switch (cmd) {
	      case CMD.M:
	        cmdStr = 'M';
	        nData = 2;
	        break;
	
	      case CMD.L:
	        cmdStr = 'L';
	        nData = 2;
	        break;
	
	      case CMD.Q:
	        cmdStr = 'Q';
	        nData = 4;
	        break;
	
	      case CMD.C:
	        cmdStr = 'C';
	        nData = 6;
	        break;
	
	      case CMD.A:
	        var cx = data[i++];
	        var cy = data[i++];
	        var rx = data[i++];
	        var ry = data[i++];
	        var theta = data[i++];
	        var dTheta = data[i++];
	        var psi = data[i++];
	        var clockwise = data[i++];
	        var dThetaPositive = Math.abs(dTheta);
	        var isCircle = isAroundZero(dThetaPositive - PI2) || (clockwise ? dTheta >= PI2 : -dTheta >= PI2); // Mapping to 0~2PI
	
	        var unifiedTheta = dTheta > 0 ? dTheta % PI2 : dTheta % PI2 + PI2;
	        var large = false;
	
	        if (isCircle) {
	          large = true;
	        } else if (isAroundZero(dThetaPositive)) {
	          large = false;
	        } else {
	          large = unifiedTheta >= PI === !!clockwise;
	        }
	
	        var x0 = round4(cx + rx * mathCos(theta));
	        var y0 = round4(cy + ry * mathSin(theta)); // It will not draw if start point and end point are exactly the same
	        // We need to shift the end point with a small value
	        // FIXME A better way to draw circle ?
	
	        if (isCircle) {
	          if (clockwise) {
	            dTheta = PI2 - 1e-4;
	          } else {
	            dTheta = -PI2 + 1e-4;
	          }
	
	          large = true;
	
	          if (i === 9) {
	            // Move to (x0, y0) only when CMD.A comes at the
	            // first position of a shape.
	            // For instance, when drawing a ring, CMD.A comes
	            // after CMD.M, so it's unnecessary to move to
	            // (x0, y0).
	            str.push('M', x0, y0);
	          }
	        }
	
	        var x = round4(cx + rx * mathCos(theta + dTheta));
	        var y = round4(cy + ry * mathSin(theta + dTheta)); // FIXME Ellipse
	
	        str.push('A', round4(rx), round4(ry), mathRound(psi * degree), +large, +clockwise, x, y);
	        break;
	
	      case CMD.Z:
	        cmdStr = 'Z';
	        break;
	
	      case CMD.R:
	        var x = round4(data[i++]);
	        var y = round4(data[i++]);
	        var w = round4(data[i++]);
	        var h = round4(data[i++]);
	        str.push('M', x, y, 'L', x + w, y, 'L', x + w, y + h, 'L', x, y + h, 'L', x, y);
	        break;
	    }
	
	    cmdStr && str.push(cmdStr);
	
	    for (var j = 0; j < nData; j++) {
	      // PENDING With scale
	      str.push(round4(data[i++]));
	    }
	  }
	
	  return str.join(' ');
	}
	
	var svgPath = {};
	
	svgPath.brush = function (el) {
	  var style = el.style;
	  var svgEl = el.__svgEl;
	
	  if (!svgEl) {
	    svgEl = createElement('path');
	    el.__svgEl = svgEl;
	  }
	
	  if (!el.path) {
	    el.createPathProxy();
	  }
	
	  var path = el.path;
	
	  if (el.__dirtyPath) {
	    path.beginPath();
	    path.subPixelOptimize = false;
	    el.buildPath(path, el.shape);
	    el.__dirtyPath = false;
	    var pathStr = pathDataToString(path);
	
	    if (pathStr.indexOf('NaN') < 0) {
	      // Ignore illegal path, which may happen such in out-of-range
	      // data in Calendar series.
	      attr(svgEl, 'd', pathStr);
	    }
	  }
	
	  bindStyle(svgEl, style, false, el);
	  setTransform(svgEl, el.transform);
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, el.getBoundingRect());
	  } else {
	    removeOldTextNode(el);
	  }
	};
	/***************************************************
	 * IMAGE
	 **************************************************/
	
	
	var svgImage = {};
	
	svgImage.brush = function (el) {
	  var style = el.style;
	  var image = style.image;
	
	  if (image instanceof HTMLImageElement) {
	    var src = image.src;
	    image = src;
	  }
	
	  if (!image) {
	    return;
	  }
	
	  var x = style.x || 0;
	  var y = style.y || 0;
	  var dw = style.width;
	  var dh = style.height;
	  var svgEl = el.__svgEl;
	
	  if (!svgEl) {
	    svgEl = createElement('image');
	    el.__svgEl = svgEl;
	  }
	
	  if (image !== el.__imageSrc) {
	    attrXLink(svgEl, 'href', image); // Caching image src
	
	    el.__imageSrc = image;
	  }
	
	  attr(svgEl, 'width', dw);
	  attr(svgEl, 'height', dh);
	  attr(svgEl, 'x', x);
	  attr(svgEl, 'y', y);
	  setTransform(svgEl, el.transform);
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, el.getBoundingRect());
	  } else {
	    removeOldTextNode(el);
	  }
	};
	/***************************************************
	 * TEXT
	 **************************************************/
	
	
	var svgText = {};
	
	var _tmpTextHostRect = new BoundingRect();
	
	var _tmpTextBoxPos = {};
	var _tmpTextTransform = [];
	var TEXT_ALIGN_TO_ANCHRO = {
	  left: 'start',
	  right: 'end',
	  center: 'middle',
	  middle: 'middle'
	};
	/**
	 * @param {module:zrender/Element} el
	 * @param {Object|boolean} [hostRect] {x, y, width, height}
	 *        If set false, rect text is not used.
	 */
	
	var svgTextDrawRectText = function (el, hostRect) {
	  var style = el.style;
	  var elTransform = el.transform;
	  var needTransformTextByHostEl = el instanceof Text || style.transformText;
	  el.__dirty && textHelper.normalizeTextStyle(style, true);
	  var text = style.text; // Convert to string
	
	  text != null && (text += '');
	
	  if (!textHelper.needDrawText(text, style)) {
	    return;
	  } // render empty text for svg if no text but need draw text.
	
	
	  text == null && (text = ''); // Follow the setting in the canvas renderer, if not transform the
	  // text, transform the hostRect, by which the text is located.
	
	  if (!needTransformTextByHostEl && elTransform) {
	    _tmpTextHostRect.copy(hostRect);
	
	    _tmpTextHostRect.applyTransform(elTransform);
	
	    hostRect = _tmpTextHostRect;
	  }
	
	  var textSvgEl = el.__textSvgEl;
	
	  if (!textSvgEl) {
	    textSvgEl = createElement('text');
	    el.__textSvgEl = textSvgEl;
	  } // style.font has been normalized by `normalizeTextStyle`.
	
	
	  var textSvgElStyle = textSvgEl.style;
	  var font = style.font || textContain.DEFAULT_FONT;
	  var computedFont = textSvgEl.__computedFont;
	
	  if (font !== textSvgEl.__styleFont) {
	    textSvgElStyle.font = textSvgEl.__styleFont = font; // The computedFont might not be the orginal font if it is illegal font.
	
	    computedFont = textSvgEl.__computedFont = textSvgElStyle.font;
	  }
	
	  var textPadding = style.textPadding;
	  var textLineHeight = style.textLineHeight;
	  var contentBlock = el.__textCotentBlock;
	
	  if (!contentBlock || el.__dirtyText) {
	    contentBlock = el.__textCotentBlock = textContain.parsePlainText(text, computedFont, textPadding, textLineHeight, style.truncate);
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var lineHeight = contentBlock.lineHeight;
	  textHelper.getBoxPosition(_tmpTextBoxPos, el, style, hostRect);
	  var baseX = _tmpTextBoxPos.baseX;
	  var baseY = _tmpTextBoxPos.baseY;
	  var textAlign = _tmpTextBoxPos.textAlign || 'left';
	  var textVerticalAlign = _tmpTextBoxPos.textVerticalAlign;
	  setTextTransform(textSvgEl, needTransformTextByHostEl, elTransform, style, hostRect, baseX, baseY);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var textX = baseX;
	  var textY = boxY; // TODO needDrawBg
	
	  if (textPadding) {
	    textX = getTextXForPadding(baseX, textAlign, textPadding);
	    textY += textPadding[0];
	  } // `textBaseline` is set as 'middle'.
	
	
	  textY += lineHeight / 2;
	  bindStyle(textSvgEl, style, true, el); // FIXME
	  // Add a <style> to reset all of the text font as inherit?
	  // otherwise the outer <style> may set the unexpected style.
	  // Font may affect position of each tspan elements
	
	  var canCacheByTextString = contentBlock.canCacheByTextString;
	  var tspanList = el.__tspanList || (el.__tspanList = []);
	  var tspanOriginLen = tspanList.length; // Optimize for most cases, just compare text string to determine change.
	
	  if (canCacheByTextString && el.__canCacheByTextString && el.__text === text) {
	    if (el.__dirtyText && tspanOriginLen) {
	      for (var idx = 0; idx < tspanOriginLen; ++idx) {
	        updateTextLocation(tspanList[idx], textAlign, textX, textY + idx * lineHeight);
	      }
	    }
	  } else {
	    el.__text = text;
	    el.__canCacheByTextString = canCacheByTextString;
	    var textLines = contentBlock.lines;
	    var nTextLines = textLines.length;
	    var idx = 0;
	
	    for (; idx < nTextLines; idx++) {
	      // Using cached tspan elements
	      var tspan = tspanList[idx];
	      var singleLineText = textLines[idx];
	
	      if (!tspan) {
	        tspan = tspanList[idx] = createElement('tspan');
	        textSvgEl.appendChild(tspan);
	        tspan.appendChild(document.createTextNode(singleLineText));
	      } else if (tspan.__zrText !== singleLineText) {
	        tspan.innerHTML = '';
	        tspan.appendChild(document.createTextNode(singleLineText));
	      }
	
	      updateTextLocation(tspan, textAlign, textX, textY + idx * lineHeight);
	    } // Remove unused tspan elements
	
	
	    if (tspanOriginLen > nTextLines) {
	      for (; idx < tspanOriginLen; idx++) {
	        textSvgEl.removeChild(tspanList[idx]);
	      }
	
	      tspanList.length = nTextLines;
	    }
	  }
	};
	
	function setTextTransform(textSvgEl, needTransformTextByHostEl, elTransform, style, hostRect, baseX, baseY) {
	  matrix.identity(_tmpTextTransform);
	
	  if (needTransformTextByHostEl && elTransform) {
	    matrix.copy(_tmpTextTransform, elTransform);
	  } // textRotation only apply in RectText.
	
	
	  var textRotation = style.textRotation;
	
	  if (hostRect && textRotation) {
	    var origin = style.textOrigin;
	
	    if (origin === 'center') {
	      baseX = hostRect.width / 2 + hostRect.x;
	      baseY = hostRect.height / 2 + hostRect.y;
	    } else if (origin) {
	      baseX = origin[0] + hostRect.x;
	      baseY = origin[1] + hostRect.y;
	    }
	
	    _tmpTextTransform[4] -= baseX;
	    _tmpTextTransform[5] -= baseY; // Positive: anticlockwise
	
	    matrix.rotate(_tmpTextTransform, _tmpTextTransform, textRotation);
	    _tmpTextTransform[4] += baseX;
	    _tmpTextTransform[5] += baseY;
	  } // See the definition in `Style.js#textOrigin`, the default
	  // origin is from the result of `getBoxPosition`.
	
	
	  setTransform(textSvgEl, _tmpTextTransform);
	} // FIXME merge the same code with `helper/text.js#getTextXForPadding`;
	
	
	function getTextXForPadding(x, textAlign, textPadding) {
	  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
	}
	
	function updateTextLocation(tspan, textAlign, x, y) {
	  // Consider different font display differently in vertial align, we always
	  // set vertialAlign as 'middle', and use 'y' to locate text vertically.
	  attr(tspan, 'dominant-baseline', 'middle');
	  attr(tspan, 'text-anchor', TEXT_ALIGN_TO_ANCHRO[textAlign]);
	  attr(tspan, 'x', x);
	  attr(tspan, 'y', y);
	}
	
	function removeOldTextNode(el) {
	  if (el && el.__textSvgEl) {
	    // textSvgEl may has no parentNode if el has been removed temporary.
	    if (el.__textSvgEl.parentNode) {
	      el.__textSvgEl.parentNode.removeChild(el.__textSvgEl);
	    }
	
	    el.__textSvgEl = null;
	    el.__tspanList = [];
	    el.__text = null;
	  }
	}
	
	svgText.drawRectText = svgTextDrawRectText;
	
	svgText.brush = function (el) {
	  var style = el.style;
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, false);
	  } else {
	    removeOldTextNode(el);
	  }
	};
	
	exports.path = svgPath;
	exports.image = svgImage;
	exports.text = svgText;

/***/ }),
/* 708 */
/***/ (function(module, exports) {

	var svgURI = 'http://www.w3.org/2000/svg';
	
	function createElement(name) {
	  return document.createElementNS(svgURI, name);
	}
	
	exports.createElement = createElement;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(708);
	
	var createElement = _core.createElement;
	
	var util = __webpack_require__(220);
	
	var logError = __webpack_require__(240);
	
	var Path = __webpack_require__(270);
	
	var ZImage = __webpack_require__(251);
	
	var ZText = __webpack_require__(282);
	
	var arrayDiff = __webpack_require__(710);
	
	var GradientManager = __webpack_require__(711);
	
	var ClippathManager = __webpack_require__(713);
	
	var ShadowManager = __webpack_require__(714);
	
	var _graphic = __webpack_require__(707);
	
	var svgPath = _graphic.path;
	var svgImage = _graphic.image;
	var svgText = _graphic.text;
	
	/**
	 * SVG Painter
	 * @module zrender/svg/Painter
	 */
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	
	function getSvgProxy(el) {
	  if (el instanceof Path) {
	    return svgPath;
	  } else if (el instanceof ZImage) {
	    return svgImage;
	  } else if (el instanceof ZText) {
	    return svgText;
	  } else {
	    return svgPath;
	  }
	}
	
	function checkParentAvailable(parent, child) {
	  return child && parent && child.parentNode !== parent;
	}
	
	function insertAfter(parent, child, prevSibling) {
	  if (checkParentAvailable(parent, child) && prevSibling) {
	    var nextSibling = prevSibling.nextSibling;
	    nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
	  }
	}
	
	function prepend(parent, child) {
	  if (checkParentAvailable(parent, child)) {
	    var firstChild = parent.firstChild;
	    firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
	  }
	} // function append(parent, child) {
	//     if (checkParentAvailable(parent, child)) {
	//         parent.appendChild(child);
	//     }
	// }
	
	
	function remove(parent, child) {
	  if (child && parent && child.parentNode === parent) {
	    parent.removeChild(child);
	  }
	}
	
	function getTextSvgElement(displayable) {
	  return displayable.__textSvgEl;
	}
	
	function getSvgElement(displayable) {
	  return displayable.__svgEl;
	}
	/**
	 * @alias module:zrender/svg/Painter
	 * @constructor
	 * @param {HTMLElement} root 绘图容器
	 * @param {module:zrender/Storage} storage
	 * @param {Object} opts
	 */
	
	
	var SVGPainter = function (root, storage, opts, zrId) {
	  this.root = root;
	  this.storage = storage;
	  this._opts = opts = util.extend({}, opts || {});
	  var svgDom = createElement('svg');
	  svgDom.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	  svgDom.setAttribute('version', '1.1');
	  svgDom.setAttribute('baseProfile', 'full');
	  svgDom.style.cssText = 'user-select:none;position:absolute;left:0;top:0;';
	  var bgRoot = createElement('g');
	  svgDom.appendChild(bgRoot);
	  var svgRoot = createElement('g');
	  svgDom.appendChild(svgRoot);
	  this.gradientManager = new GradientManager(zrId, svgRoot);
	  this.clipPathManager = new ClippathManager(zrId, svgRoot);
	  this.shadowManager = new ShadowManager(zrId, svgRoot);
	  var viewport = document.createElement('div');
	  viewport.style.cssText = 'overflow:hidden;position:relative';
	  this._svgDom = svgDom;
	  this._svgRoot = svgRoot;
	  this._backgroundRoot = bgRoot;
	  this._viewport = viewport;
	  root.appendChild(viewport);
	  viewport.appendChild(svgDom);
	  this.resize(opts.width, opts.height);
	  this._visibleList = [];
	};
	
	SVGPainter.prototype = {
	  constructor: SVGPainter,
	  getType: function () {
	    return 'svg';
	  },
	  getViewportRoot: function () {
	    return this._viewport;
	  },
	  getSvgDom: function () {
	    return this._svgDom;
	  },
	  getSvgRoot: function () {
	    return this._svgRoot;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	  refresh: function () {
	    var list = this.storage.getDisplayList(true);
	
	    this._paintList(list);
	  },
	  setBackgroundColor: function (backgroundColor) {
	    // TODO gradient
	    // Insert a bg rect instead of setting background to viewport.
	    // Otherwise, the exported SVG don't have background.
	    if (this._backgroundRoot && this._backgroundNode) {
	      this._backgroundRoot.removeChild(this._backgroundNode);
	    }
	
	    var bgNode = createElement('rect');
	    bgNode.setAttribute('width', this.getWidth());
	    bgNode.setAttribute('height', this.getHeight());
	    bgNode.setAttribute('x', 0);
	    bgNode.setAttribute('y', 0);
	    bgNode.setAttribute('id', 0);
	    bgNode.style.fill = backgroundColor;
	
	    this._backgroundRoot.appendChild(bgNode);
	
	    this._backgroundNode = bgNode;
	  },
	  _paintList: function (list) {
	    this.gradientManager.markAllUnused();
	    this.clipPathManager.markAllUnused();
	    this.shadowManager.markAllUnused();
	    var svgRoot = this._svgRoot;
	    var visibleList = this._visibleList;
	    var listLen = list.length;
	    var newVisibleList = [];
	    var i;
	
	    for (i = 0; i < listLen; i++) {
	      var displayable = list[i];
	      var svgProxy = getSvgProxy(displayable);
	      var svgElement = getSvgElement(displayable) || getTextSvgElement(displayable);
	
	      if (!displayable.invisible) {
	        if (displayable.__dirty) {
	          svgProxy && svgProxy.brush(displayable); // Update clipPath
	
	          this.clipPathManager.update(displayable); // Update gradient and shadow
	
	          if (displayable.style) {
	            this.gradientManager.update(displayable.style.fill);
	            this.gradientManager.update(displayable.style.stroke);
	            this.shadowManager.update(svgElement, displayable);
	          }
	
	          displayable.__dirty = false;
	        }
	
	        newVisibleList.push(displayable);
	      }
	    }
	
	    var diff = arrayDiff(visibleList, newVisibleList);
	    var prevSvgElement; // First do remove, in case element moved to the head and do remove
	    // after add
	
	    for (i = 0; i < diff.length; i++) {
	      var item = diff[i];
	
	      if (item.removed) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = visibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          remove(svgRoot, svgElement);
	          remove(svgRoot, textSvgElement);
	        }
	      }
	    }
	
	    for (i = 0; i < diff.length; i++) {
	      var item = diff[i];
	
	      if (item.added) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = newVisibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          prevSvgElement ? insertAfter(svgRoot, svgElement, prevSvgElement) : prepend(svgRoot, svgElement);
	
	          if (svgElement) {
	            insertAfter(svgRoot, textSvgElement, svgElement);
	          } else if (prevSvgElement) {
	            insertAfter(svgRoot, textSvgElement, prevSvgElement);
	          } else {
	            prepend(svgRoot, textSvgElement);
	          } // Insert text
	
	
	          insertAfter(svgRoot, textSvgElement, svgElement);
	          prevSvgElement = textSvgElement || svgElement || prevSvgElement; // zrender.Text only create textSvgElement.
	
	          this.gradientManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.shadowManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.clipPathManager.markUsed(displayable);
	        }
	      } else if (!item.removed) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = newVisibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          this.gradientManager.markUsed(displayable);
	          this.gradientManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.shadowManager.markUsed(displayable);
	          this.shadowManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.clipPathManager.markUsed(displayable);
	
	          if (textSvgElement) {
	            // Insert text.
	            insertAfter(svgRoot, textSvgElement, svgElement);
	          }
	
	          prevSvgElement = svgElement || textSvgElement || prevSvgElement;
	        }
	      }
	    }
	
	    this.gradientManager.removeUnused();
	    this.clipPathManager.removeUnused();
	    this.shadowManager.removeUnused();
	    this._visibleList = newVisibleList;
	  },
	  _getDefs: function (isForceCreating) {
	    var svgRoot = this._svgDom;
	    var defs = svgRoot.getElementsByTagName('defs');
	
	    if (defs.length === 0) {
	      // Not exist
	      if (isForceCreating) {
	        var defs = svgRoot.insertBefore(createElement('defs'), // Create new tag
	        svgRoot.firstChild // Insert in the front of svg
	        );
	
	        if (!defs.contains) {
	          // IE doesn't support contains method
	          defs.contains = function (el) {
	            var children = defs.children;
	
	            if (!children) {
	              return false;
	            }
	
	            for (var i = children.length - 1; i >= 0; --i) {
	              if (children[i] === el) {
	                return true;
	              }
	            }
	
	            return false;
	          };
	        }
	
	        return defs;
	      } else {
	        return null;
	      }
	    } else {
	      return defs[0];
	    }
	  },
	  resize: function (width, height) {
	    var viewport = this._viewport; // FIXME Why ?
	
	    viewport.style.display = 'none'; // Save input w/h
	
	    var opts = this._opts;
	    width != null && (opts.width = width);
	    height != null && (opts.height = height);
	    width = this._getSize(0);
	    height = this._getSize(1);
	    viewport.style.display = '';
	
	    if (this._width !== width || this._height !== height) {
	      this._width = width;
	      this._height = height;
	      var viewportStyle = viewport.style;
	      viewportStyle.width = width + 'px';
	      viewportStyle.height = height + 'px';
	      var svgRoot = this._svgDom; // Set width by 'svgRoot.width = width' is invalid
	
	      svgRoot.setAttribute('width', width);
	      svgRoot.setAttribute('height', height);
	    }
	
	    if (this._backgroundNode) {
	      this._backgroundNode.setAttribute('width', width);
	
	      this._backgroundNode.setAttribute('height', height);
	    }
	  },
	
	  /**
	   * 获取绘图区域宽度
	   */
	  getWidth: function () {
	    return this._width;
	  },
	
	  /**
	   * 获取绘图区域高度
	   */
	  getHeight: function () {
	    return this._height;
	  },
	  _getSize: function (whIdx) {
	    var opts = this._opts;
	    var wh = ['width', 'height'][whIdx];
	    var cwh = ['clientWidth', 'clientHeight'][whIdx];
	    var plt = ['paddingLeft', 'paddingTop'][whIdx];
	    var prb = ['paddingRight', 'paddingBottom'][whIdx];
	
	    if (opts[wh] != null && opts[wh] !== 'auto') {
	      return parseFloat(opts[wh]);
	    }
	
	    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
	
	    var stl = document.defaultView.getComputedStyle(root);
	    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
	  },
	  dispose: function () {
	    this.root.innerHTML = '';
	    this._svgRoot = this._backgroundRoot = this._svgDom = this._backgroundNode = this._viewport = this.storage = null;
	  },
	  clear: function () {
	    if (this._viewport) {
	      this.root.removeChild(this._viewport);
	    }
	  },
	  toDataURL: function () {
	    this.refresh();
	    var html = encodeURIComponent(this._svgDom.outerHTML.replace(/></g, '>\n\r<'));
	    return 'data:image/svg+xml;charset=UTF-8,' + html;
	  }
	}; // Not supported methods
	
	function createMethodNotSupport(method) {
	  return function () {
	    logError('In SVG mode painter not support method "' + method + '"');
	  };
	} // Unsuppoted methods
	
	
	util.each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'pathToImage'], function (name) {
	  SVGPainter.prototype[name] = createMethodNotSupport(name);
	});
	var _default = SVGPainter;
	module.exports = _default;

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	// Myers' Diff Algorithm
	// Modified from https://github.com/kpdecker/jsdiff/blob/master/src/diff/base.js
	function Diff() {}
	
	Diff.prototype = {
	  diff: function (oldArr, newArr, equals) {
	    if (!equals) {
	      equals = function (a, b) {
	        return a === b;
	      };
	    }
	
	    this.equals = equals;
	    var self = this;
	    oldArr = oldArr.slice();
	    newArr = newArr.slice(); // Allow subclasses to massage the input prior to running
	
	    var newLen = newArr.length;
	    var oldLen = oldArr.length;
	    var editLength = 1;
	    var maxEditLength = newLen + oldLen;
	    var bestPath = [{
	      newPos: -1,
	      components: []
	    }]; // Seed editLength = 0, i.e. the content starts with the same values
	
	    var oldPos = this.extractCommon(bestPath[0], newArr, oldArr, 0);
	
	    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	      var indices = [];
	
	      for (var i = 0; i < newArr.length; i++) {
	        indices.push(i);
	      } // Identity per the equality and tokenizer
	
	
	      return [{
	        indices: indices,
	        count: newArr.length
	      }];
	    } // Main worker method. checks all permutations of a given edit length for acceptance.
	
	
	    function execEditLength() {
	      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
	        var basePath;
	        var addPath = bestPath[diagonalPath - 1];
	        var removePath = bestPath[diagonalPath + 1];
	        var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
	
	        if (addPath) {
	          // No one else is going to attempt to use this value, clear it
	          bestPath[diagonalPath - 1] = undefined;
	        }
	
	        var canAdd = addPath && addPath.newPos + 1 < newLen;
	        var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;
	
	        if (!canAdd && !canRemove) {
	          // If this path is a terminal then prune
	          bestPath[diagonalPath] = undefined;
	          continue;
	        } // Select the diagonal that we want to branch from. We select the prior
	        // path whose position in the new string is the farthest from the origin
	        // and does not pass the bounds of the diff graph
	
	
	        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
	          basePath = clonePath(removePath);
	          self.pushComponent(basePath.components, undefined, true);
	        } else {
	          basePath = addPath; // No need to clone, we've pulled it from the list
	
	          basePath.newPos++;
	          self.pushComponent(basePath.components, true, undefined);
	        }
	
	        oldPos = self.extractCommon(basePath, newArr, oldArr, diagonalPath); // If we have hit the end of both strings, then we are done
	
	        if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	          return buildValues(self, basePath.components, newArr, oldArr);
	        } else {
	          // Otherwise track this path as a potential candidate and continue.
	          bestPath[diagonalPath] = basePath;
	        }
	      }
	
	      editLength++;
	    }
	
	    while (editLength <= maxEditLength) {
	      var ret = execEditLength();
	
	      if (ret) {
	        return ret;
	      }
	    }
	  },
	  pushComponent: function (components, added, removed) {
	    var last = components[components.length - 1];
	
	    if (last && last.added === added && last.removed === removed) {
	      // We need to clone here as the component clone operation is just
	      // as shallow array clone
	      components[components.length - 1] = {
	        count: last.count + 1,
	        added: added,
	        removed: removed
	      };
	    } else {
	      components.push({
	        count: 1,
	        added: added,
	        removed: removed
	      });
	    }
	  },
	  extractCommon: function (basePath, newArr, oldArr, diagonalPath) {
	    var newLen = newArr.length;
	    var oldLen = oldArr.length;
	    var newPos = basePath.newPos;
	    var oldPos = newPos - diagonalPath;
	    var commonCount = 0;
	
	    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newArr[newPos + 1], oldArr[oldPos + 1])) {
	      newPos++;
	      oldPos++;
	      commonCount++;
	    }
	
	    if (commonCount) {
	      basePath.components.push({
	        count: commonCount
	      });
	    }
	
	    basePath.newPos = newPos;
	    return oldPos;
	  },
	  tokenize: function (value) {
	    return value.slice();
	  },
	  join: function (value) {
	    return value.slice();
	  }
	};
	
	function buildValues(diff, components, newArr, oldArr) {
	  var componentPos = 0;
	  var componentLen = components.length;
	  var newPos = 0;
	  var oldPos = 0;
	
	  for (; componentPos < componentLen; componentPos++) {
	    var component = components[componentPos];
	
	    if (!component.removed) {
	      var indices = [];
	
	      for (var i = newPos; i < newPos + component.count; i++) {
	        indices.push(i);
	      }
	
	      component.indices = indices;
	      newPos += component.count; // Common case
	
	      if (!component.added) {
	        oldPos += component.count;
	      }
	    } else {
	      var indices = [];
	
	      for (var i = oldPos; i < oldPos + component.count; i++) {
	        indices.push(i);
	      }
	
	      component.indices = indices;
	      oldPos += component.count;
	    }
	  }
	
	  return components;
	}
	
	function clonePath(path) {
	  return {
	    newPos: path.newPos,
	    components: path.components.slice(0)
	  };
	}
	
	var arrayDiff = new Diff();
	
	function _default(oldArr, newArr, callback) {
	  return arrayDiff.diff(oldArr, newArr, callback);
	}
	
	module.exports = _default;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(712);
	
	var zrUtil = __webpack_require__(220);
	
	var logError = __webpack_require__(240);
	
	var colorTool = __webpack_require__(238);
	
	/**
	 * @file Manages SVG gradient elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG gradient elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function GradientManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, ['linearGradient', 'radialGradient'], '__gradient_in_use__');
	}
	
	zrUtil.inherits(GradientManager, Definable);
	/**
	 * Create new gradient DOM for fill or stroke if not exist,
	 * but will not update gradient if exists.
	 *
	 * @param {SvgElement}  svgElement   SVG element to paint
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	GradientManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
	  if (displayable && displayable.style) {
	    var that = this;
	    zrUtil.each(['fill', 'stroke'], function (fillOrStroke) {
	      if (displayable.style[fillOrStroke] && (displayable.style[fillOrStroke].type === 'linear' || displayable.style[fillOrStroke].type === 'radial')) {
	        var gradient = displayable.style[fillOrStroke];
	        var defs = that.getDefs(true); // Create dom in <defs> if not exists
	
	        var dom;
	
	        if (gradient._dom) {
	          // Gradient exists
	          dom = gradient._dom;
	
	          if (!defs.contains(gradient._dom)) {
	            // _dom is no longer in defs, recreate
	            that.addDom(dom);
	          }
	        } else {
	          // New dom
	          dom = that.add(gradient);
	        }
	
	        that.markUsed(displayable);
	        var id = dom.getAttribute('id');
	        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
	      }
	    });
	  }
	};
	/**
	 * Add a new gradient tag in <defs>
	 *
	 * @param   {Gradient} gradient zr gradient instance
	 * @return {SVGLinearGradientElement | SVGRadialGradientElement}
	 *                            created DOM
	 */
	
	
	GradientManager.prototype.add = function (gradient) {
	  var dom;
	
	  if (gradient.type === 'linear') {
	    dom = this.createElement('linearGradient');
	  } else if (gradient.type === 'radial') {
	    dom = this.createElement('radialGradient');
	  } else {
	    logError('Illegal gradient type.');
	    return null;
	  } // Set dom id with gradient id, since each gradient instance
	  // will have no more than one dom element.
	  // id may exists before for those dirty elements, in which case
	  // id should remain the same, and other attributes should be
	  // updated.
	
	
	  gradient.id = gradient.id || this.nextId++;
	  dom.setAttribute('id', 'zr' + this._zrId + '-gradient-' + gradient.id);
	  this.updateDom(gradient, dom);
	  this.addDom(dom);
	  return dom;
	};
	/**
	 * Update gradient.
	 *
	 * @param {Gradient} gradient zr gradient instance
	 */
	
	
	GradientManager.prototype.update = function (gradient) {
	  var that = this;
	  Definable.prototype.update.call(this, gradient, function () {
	    var type = gradient.type;
	    var tagName = gradient._dom.tagName;
	
	    if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') {
	      // Gradient type is not changed, update gradient
	      that.updateDom(gradient, gradient._dom);
	    } else {
	      // Remove and re-create if type is changed
	      that.removeDom(gradient);
	      that.add(gradient);
	    }
	  });
	};
	/**
	 * Update gradient dom
	 *
	 * @param {Gradient} gradient zr gradient instance
	 * @param {SVGLinearGradientElement | SVGRadialGradientElement} dom
	 *                            DOM to update
	 */
	
	
	GradientManager.prototype.updateDom = function (gradient, dom) {
	  if (gradient.type === 'linear') {
	    dom.setAttribute('x1', gradient.x);
	    dom.setAttribute('y1', gradient.y);
	    dom.setAttribute('x2', gradient.x2);
	    dom.setAttribute('y2', gradient.y2);
	  } else if (gradient.type === 'radial') {
	    dom.setAttribute('cx', gradient.x);
	    dom.setAttribute('cy', gradient.y);
	    dom.setAttribute('r', gradient.r);
	  } else {
	    logError('Illegal gradient type.');
	    return;
	  }
	
	  if (gradient.global) {
	    // x1, x2, y1, y2 in range of 0 to canvas width or height
	    dom.setAttribute('gradientUnits', 'userSpaceOnUse');
	  } else {
	    // x1, x2, y1, y2 in range of 0 to 1
	    dom.setAttribute('gradientUnits', 'objectBoundingBox');
	  } // Remove color stops if exists
	
	
	  dom.innerHTML = ''; // Add color stops
	
	  var colors = gradient.colorStops;
	
	  for (var i = 0, len = colors.length; i < len; ++i) {
	    var stop = this.createElement('stop');
	    stop.setAttribute('offset', colors[i].offset * 100 + '%');
	    var color = colors[i].color;
	
	    if (color.indexOf('rgba') > -1) {
	      // Fix Safari bug that stop-color not recognizing alpha #9014
	      var opacity = colorTool.parse(color)[3];
	      var hex = colorTool.toHex(color); // stop-color cannot be color, since:
	      // The opacity value used for the gradient calculation is the
	      // *product* of the value of stop-opacity and the opacity of the
	      // value of stop-color.
	      // See https://www.w3.org/TR/SVG2/pservers.html#StopOpacityProperty
	
	      stop.setAttribute('stop-color', '#' + hex);
	      stop.setAttribute('stop-opacity', opacity);
	    } else {
	      stop.setAttribute('stop-color', colors[i].color);
	    }
	
	    dom.appendChild(stop);
	  } // Store dom element in gradient, to avoid creating multiple
	  // dom instances for the same gradient element
	
	
	  gradient._dom = dom;
	};
	/**
	 * Mark a single gradient to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	GradientManager.prototype.markUsed = function (displayable) {
	  if (displayable.style) {
	    var gradient = displayable.style.fill;
	
	    if (gradient && gradient._dom) {
	      Definable.prototype.markUsed.call(this, gradient._dom);
	    }
	
	    gradient = displayable.style.stroke;
	
	    if (gradient && gradient._dom) {
	      Definable.prototype.markUsed.call(this, gradient._dom);
	    }
	  }
	};
	
	var _default = GradientManager;
	module.exports = _default;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(708);
	
	var createElement = _core.createElement;
	
	var zrUtil = __webpack_require__(220);
	
	var Path = __webpack_require__(270);
	
	var ZImage = __webpack_require__(251);
	
	var ZText = __webpack_require__(282);
	
	var _graphic = __webpack_require__(707);
	
	var svgPath = _graphic.path;
	var svgImage = _graphic.image;
	var svgText = _graphic.text;
	
	/**
	 * @file Manages elements that can be defined in <defs> in SVG,
	 *       e.g., gradients, clip path, etc.
	 * @author Zhang Wenli
	 */
	var MARK_UNUSED = '0';
	var MARK_USED = '1';
	/**
	 * Manages elements that can be defined in <defs> in SVG,
	 * e.g., gradients, clip path, etc.
	 *
	 * @class
	 * @param {number}          zrId      zrender instance id
	 * @param {SVGElement}      svgRoot   root of SVG document
	 * @param {string|string[]} tagNames  possible tag names
	 * @param {string}          markLabel label name to make if the element
	 *                                    is used
	 */
	
	function Definable(zrId, svgRoot, tagNames, markLabel, domName) {
	  this._zrId = zrId;
	  this._svgRoot = svgRoot;
	  this._tagNames = typeof tagNames === 'string' ? [tagNames] : tagNames;
	  this._markLabel = markLabel;
	  this._domName = domName || '_dom';
	  this.nextId = 0;
	}
	
	Definable.prototype.createElement = createElement;
	/**
	 * Get the <defs> tag for svgRoot; optionally creates one if not exists.
	 *
	 * @param {boolean} isForceCreating if need to create when not exists
	 * @return {SVGDefsElement} SVG <defs> element, null if it doesn't
	 * exist and isForceCreating is false
	 */
	
	Definable.prototype.getDefs = function (isForceCreating) {
	  var svgRoot = this._svgRoot;
	
	  var defs = this._svgRoot.getElementsByTagName('defs');
	
	  if (defs.length === 0) {
	    // Not exist
	    if (isForceCreating) {
	      defs = svgRoot.insertBefore(this.createElement('defs'), // Create new tag
	      svgRoot.firstChild // Insert in the front of svg
	      );
	
	      if (!defs.contains) {
	        // IE doesn't support contains method
	        defs.contains = function (el) {
	          var children = defs.children;
	
	          if (!children) {
	            return false;
	          }
	
	          for (var i = children.length - 1; i >= 0; --i) {
	            if (children[i] === el) {
	              return true;
	            }
	          }
	
	          return false;
	        };
	      }
	
	      return defs;
	    } else {
	      return null;
	    }
	  } else {
	    return defs[0];
	  }
	};
	/**
	 * Update DOM element if necessary.
	 *
	 * @param {Object|string} element style element. e.g., for gradient,
	 *                                it may be '#ccc' or {type: 'linear', ...}
	 * @param {Function|undefined} onUpdate update callback
	 */
	
	
	Definable.prototype.update = function (element, onUpdate) {
	  if (!element) {
	    return;
	  }
	
	  var defs = this.getDefs(false);
	
	  if (element[this._domName] && defs.contains(element[this._domName])) {
	    // Update DOM
	    if (typeof onUpdate === 'function') {
	      onUpdate(element);
	    }
	  } else {
	    // No previous dom, create new
	    var dom = this.add(element);
	
	    if (dom) {
	      element[this._domName] = dom;
	    }
	  }
	};
	/**
	 * Add gradient dom to defs
	 *
	 * @param {SVGElement} dom DOM to be added to <defs>
	 */
	
	
	Definable.prototype.addDom = function (dom) {
	  var defs = this.getDefs(true);
	  defs.appendChild(dom);
	};
	/**
	 * Remove DOM of a given element.
	 *
	 * @param {SVGElement} element element to remove dom
	 */
	
	
	Definable.prototype.removeDom = function (element) {
	  var defs = this.getDefs(false);
	
	  if (defs && element[this._domName]) {
	    defs.removeChild(element[this._domName]);
	    element[this._domName] = null;
	  }
	};
	/**
	 * Get DOMs of this element.
	 *
	 * @return {HTMLDomElement} doms of this defineable elements in <defs>
	 */
	
	
	Definable.prototype.getDoms = function () {
	  var defs = this.getDefs(false);
	
	  if (!defs) {
	    // No dom when defs is not defined
	    return [];
	  }
	
	  var doms = [];
	  zrUtil.each(this._tagNames, function (tagName) {
	    var tags = defs.getElementsByTagName(tagName); // Note that tags is HTMLCollection, which is array-like
	    // rather than real array.
	    // So `doms.concat(tags)` add tags as one object.
	
	    doms = doms.concat([].slice.call(tags));
	  });
	  return doms;
	};
	/**
	 * Mark DOMs to be unused before painting, and clear unused ones at the end
	 * of the painting.
	 */
	
	
	Definable.prototype.markAllUnused = function () {
	  var doms = this.getDoms();
	  var that = this;
	  zrUtil.each(doms, function (dom) {
	    dom[that._markLabel] = MARK_UNUSED;
	  });
	};
	/**
	 * Mark a single DOM to be used.
	 *
	 * @param {SVGElement} dom DOM to mark
	 */
	
	
	Definable.prototype.markUsed = function (dom) {
	  if (dom) {
	    dom[this._markLabel] = MARK_USED;
	  }
	};
	/**
	 * Remove unused DOMs defined in <defs>
	 */
	
	
	Definable.prototype.removeUnused = function () {
	  var defs = this.getDefs(false);
	
	  if (!defs) {
	    // Nothing to remove
	    return;
	  }
	
	  var doms = this.getDoms();
	  var that = this;
	  zrUtil.each(doms, function (dom) {
	    if (dom[that._markLabel] !== MARK_USED) {
	      // Remove gradient
	      defs.removeChild(dom);
	    }
	  });
	};
	/**
	 * Get SVG proxy.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {Path|Image|Text} svg proxy of given element
	 */
	
	
	Definable.prototype.getSvgProxy = function (displayable) {
	  if (displayable instanceof Path) {
	    return svgPath;
	  } else if (displayable instanceof ZImage) {
	    return svgImage;
	  } else if (displayable instanceof ZText) {
	    return svgText;
	  } else {
	    return svgPath;
	  }
	};
	/**
	 * Get text SVG element.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {SVGElement} SVG element of text
	 */
	
	
	Definable.prototype.getTextSvgElement = function (displayable) {
	  return displayable.__textSvgEl;
	};
	/**
	 * Get SVG element.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {SVGElement} SVG element
	 */
	
	
	Definable.prototype.getSvgElement = function (displayable) {
	  return displayable.__svgEl;
	};
	
	var _default = Definable;
	module.exports = _default;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(712);
	
	var zrUtil = __webpack_require__(220);
	
	var matrix = __webpack_require__(233);
	
	/**
	 * @file Manages SVG clipPath elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG clipPath elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function ClippathManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, 'clipPath', '__clippath_in_use__');
	}
	
	zrUtil.inherits(ClippathManager, Definable);
	/**
	 * Update clipPath.
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	ClippathManager.prototype.update = function (displayable) {
	  var svgEl = this.getSvgElement(displayable);
	
	  if (svgEl) {
	    this.updateDom(svgEl, displayable.__clipPaths, false);
	  }
	
	  var textEl = this.getTextSvgElement(displayable);
	
	  if (textEl) {
	    // Make another clipPath for text, since it's transform
	    // matrix is not the same with svgElement
	    this.updateDom(textEl, displayable.__clipPaths, true);
	  }
	
	  this.markUsed(displayable);
	};
	/**
	 * Create an SVGElement of displayable and create a <clipPath> of its
	 * clipPath
	 *
	 * @param {Displayable} parentEl  parent element
	 * @param {ClipPath[]}  clipPaths clipPaths of parent element
	 * @param {boolean}     isText    if parent element is Text
	 */
	
	
	ClippathManager.prototype.updateDom = function (parentEl, clipPaths, isText) {
	  if (clipPaths && clipPaths.length > 0) {
	    // Has clipPath, create <clipPath> with the first clipPath
	    var defs = this.getDefs(true);
	    var clipPath = clipPaths[0];
	    var clipPathEl;
	    var id;
	    var dom = isText ? '_textDom' : '_dom';
	
	    if (clipPath[dom]) {
	      // Use a dom that is already in <defs>
	      id = clipPath[dom].getAttribute('id');
	      clipPathEl = clipPath[dom]; // Use a dom that is already in <defs>
	
	      if (!defs.contains(clipPathEl)) {
	        // This happens when set old clipPath that has
	        // been previously removed
	        defs.appendChild(clipPathEl);
	      }
	    } else {
	      // New <clipPath>
	      id = 'zr' + this._zrId + '-clip-' + this.nextId;
	      ++this.nextId;
	      clipPathEl = this.createElement('clipPath');
	      clipPathEl.setAttribute('id', id);
	      defs.appendChild(clipPathEl);
	      clipPath[dom] = clipPathEl;
	    } // Build path and add to <clipPath>
	
	
	    var svgProxy = this.getSvgProxy(clipPath);
	
	    if (clipPath.transform && clipPath.parent.invTransform && !isText) {
	      /**
	       * If a clipPath has a parent with transform, the transform
	       * of parent should not be considered when setting transform
	       * of clipPath. So we need to transform back from parent's
	       * transform, which is done by multiplying parent's inverse
	       * transform.
	       */
	      // Store old transform
	      var transform = Array.prototype.slice.call(clipPath.transform); // Transform back from parent, and brush path
	
	      matrix.mul(clipPath.transform, clipPath.parent.invTransform, clipPath.transform);
	      svgProxy.brush(clipPath); // Set back transform of clipPath
	
	      clipPath.transform = transform;
	    } else {
	      svgProxy.brush(clipPath);
	    }
	
	    var pathEl = this.getSvgElement(clipPath);
	    clipPathEl.innerHTML = '';
	    /**
	     * Use `cloneNode()` here to appendChild to multiple parents,
	     * which may happend when Text and other shapes are using the same
	     * clipPath. Since Text will create an extra clipPath DOM due to
	     * different transform rules.
	     */
	
	    clipPathEl.appendChild(pathEl.cloneNode());
	    parentEl.setAttribute('clip-path', 'url(#' + id + ')');
	
	    if (clipPaths.length > 1) {
	      // Make the other clipPaths recursively
	      this.updateDom(clipPathEl, clipPaths.slice(1), isText);
	    }
	  } else {
	    // No clipPath
	    if (parentEl) {
	      parentEl.setAttribute('clip-path', 'none');
	    }
	  }
	};
	/**
	 * Mark a single clipPath to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	ClippathManager.prototype.markUsed = function (displayable) {
	  var that = this; // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.
	
	  if (displayable.__clipPaths) {
	    zrUtil.each(displayable.__clipPaths, function (clipPath) {
	      if (clipPath._dom) {
	        Definable.prototype.markUsed.call(that, clipPath._dom);
	      }
	
	      if (clipPath._textDom) {
	        Definable.prototype.markUsed.call(that, clipPath._textDom);
	      }
	    });
	  }
	};
	
	var _default = ClippathManager;
	module.exports = _default;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(712);
	
	var zrUtil = __webpack_require__(220);
	
	/**
	 * @file Manages SVG shadow elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG shadow elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function ShadowManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, ['filter'], '__filter_in_use__', '_shadowDom');
	}
	
	zrUtil.inherits(ShadowManager, Definable);
	/**
	 * Create new shadow DOM for fill or stroke if not exist,
	 * but will not update shadow if exists.
	 *
	 * @param {SvgElement}  svgElement   SVG element to paint
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	ShadowManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
	  if (displayable && hasShadow(displayable.style)) {
	    // Create dom in <defs> if not exists
	    var dom;
	
	    if (displayable._shadowDom) {
	      // Gradient exists
	      dom = displayable._shadowDom;
	      var defs = this.getDefs(true);
	
	      if (!defs.contains(displayable._shadowDom)) {
	        // _shadowDom is no longer in defs, recreate
	        this.addDom(dom);
	      }
	    } else {
	      // New dom
	      dom = this.add(displayable);
	    }
	
	    this.markUsed(displayable);
	    var id = dom.getAttribute('id');
	    svgElement.style.filter = 'url(#' + id + ')';
	  }
	};
	/**
	 * Add a new shadow tag in <defs>
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 * @return {SVGFilterElement} created DOM
	 */
	
	
	ShadowManager.prototype.add = function (displayable) {
	  var dom = this.createElement('filter'); // Set dom id with shadow id, since each shadow instance
	  // will have no more than one dom element.
	  // id may exists before for those dirty elements, in which case
	  // id should remain the same, and other attributes should be
	  // updated.
	
	  displayable._shadowDomId = displayable._shadowDomId || this.nextId++;
	  dom.setAttribute('id', 'zr' + this._zrId + '-shadow-' + displayable._shadowDomId);
	  this.updateDom(displayable, dom);
	  this.addDom(dom);
	  return dom;
	};
	/**
	 * Update shadow.
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	
	ShadowManager.prototype.update = function (svgElement, displayable) {
	  var style = displayable.style;
	
	  if (hasShadow(style)) {
	    var that = this;
	    Definable.prototype.update.call(this, displayable, function () {
	      that.updateDom(displayable, displayable._shadowDom);
	    });
	  } else {
	    // Remove shadow
	    this.remove(svgElement, displayable);
	  }
	};
	/**
	 * Remove DOM and clear parent filter
	 */
	
	
	ShadowManager.prototype.remove = function (svgElement, displayable) {
	  if (displayable._shadowDomId != null) {
	    this.removeDom(svgElement);
	    svgElement.style.filter = '';
	  }
	};
	/**
	 * Update shadow dom
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 * @param {SVGFilterElement} dom DOM to update
	 */
	
	
	ShadowManager.prototype.updateDom = function (displayable, dom) {
	  var domChild = dom.getElementsByTagName('feDropShadow');
	
	  if (domChild.length === 0) {
	    domChild = this.createElement('feDropShadow');
	  } else {
	    domChild = domChild[0];
	  }
	
	  var style = displayable.style;
	  var scaleX = displayable.scale ? displayable.scale[0] || 1 : 1;
	  var scaleY = displayable.scale ? displayable.scale[1] || 1 : 1; // TODO: textBoxShadowBlur is not supported yet
	
	  var offsetX;
	  var offsetY;
	  var blur;
	  var color;
	
	  if (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY) {
	    offsetX = style.shadowOffsetX || 0;
	    offsetY = style.shadowOffsetY || 0;
	    blur = style.shadowBlur;
	    color = style.shadowColor;
	  } else if (style.textShadowBlur) {
	    offsetX = style.textShadowOffsetX || 0;
	    offsetY = style.textShadowOffsetY || 0;
	    blur = style.textShadowBlur;
	    color = style.textShadowColor;
	  } else {
	    // Remove shadow
	    this.removeDom(dom, style);
	    return;
	  }
	
	  domChild.setAttribute('dx', offsetX / scaleX);
	  domChild.setAttribute('dy', offsetY / scaleY);
	  domChild.setAttribute('flood-color', color); // Divide by two here so that it looks the same as in canvas
	  // See: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-shadowblur
	
	  var stdDx = blur / 2 / scaleX;
	  var stdDy = blur / 2 / scaleY;
	  var stdDeviation = stdDx + ' ' + stdDy;
	  domChild.setAttribute('stdDeviation', stdDeviation); // Fix filter clipping problem
	
	  dom.setAttribute('x', '-100%');
	  dom.setAttribute('y', '-100%');
	  dom.setAttribute('width', Math.ceil(blur / 2 * 200) + '%');
	  dom.setAttribute('height', Math.ceil(blur / 2 * 200) + '%');
	  dom.appendChild(domChild); // Store dom element in shadow, to avoid creating multiple
	  // dom instances for the same shadow element
	
	  displayable._shadowDom = dom;
	};
	/**
	 * Mark a single shadow to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	ShadowManager.prototype.markUsed = function (displayable) {
	  if (displayable._shadowDom) {
	    Definable.prototype.markUsed.call(this, displayable._shadowDom);
	  }
	};
	
	function hasShadow(style) {
	  // TODO: textBoxShadowBlur is not supported yet
	  return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY || style.textShadowBlur || style.textShadowOffsetX || style.textShadowOffsetY);
	}
	
	var _default = ShadowManager;
	module.exports = _default;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fileLoadFrame = undefined;
	
	var _loading = __webpack_require__(210);
	
	var _pageUrl = __webpack_require__(206);
	
	var _cookies = __webpack_require__(207);
	
	//페이지 url 호출
	function fileLoadSet(callUrl) {
		var scriptHtml = "<script id='pageScript' type='text/javascript' charset='utf-8' src='/js/bundle/" + callUrl + ".js'></script>";
		var cssHtml = "<link id='pageCss' rel='stylesheet' type='text/css' href='/css/" + callUrl + ".css'>";
		$('#pageScript, #pageCss').remove();
		$('body').append(scriptHtml);
		$('head').append(cssHtml);
	}
	//쿠키 호출
	//데이터 로딩
	var fileLoadFrame = exports.fileLoadFrame = {
		init: function init(param) {
			var userCheck = _cookies.cookies.getCookies('user_id');
			$('body').attr('id', 'page');
			if (param != _pageUrl.dataUrlArray[0].url && userCheck != null) {
				// for (var i = 0; i <= dataUrlArray.length -1; i++) {
				// 	if(param == dataUrlArray[i].url) {
				// 		//fileLoadSet(dataUrlArray[i].callurl);
				// 		break;
				// 	}else if(param == '/' || param == '/index' || param == '') {
				// 		//데이터 생성 페이지 인덱스 화면으로 활용
				// 		//fileLoadSet(dataUrlArray[2].callurl);
				// 		break;
				// 	}else if(i == dataUrlArray.length-1) {
				// 		break;
				// 	}
				// }
			} else {
				//로그인 화면
				//fileLoadSet(dataUrlArray[0].callurl);
				$('body').attr('id', 'login');
			}
			setTimeout(function () {
				$('#container').show();
			}, 200);
		}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _pageUrl = __webpack_require__(206);
	
	var _loadData = __webpack_require__(717);
	
	var _favoriteFunc = __webpack_require__(719);
	
	var _biddingFunc = __webpack_require__(859);
	
	var _createFunc = __webpack_require__(861);
	
	var _settingFunc = __webpack_require__(862);
	
	var _loginFunc = __webpack_require__(863);
	
	__webpack_require__(860);

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.alwaysFunc = undefined;
	
	var _ajaxForm = __webpack_require__(209);
	
	var _dataUrl = __webpack_require__(718);
	
	var _cookies = __webpack_require__(207);
	
	//데이터 API 목록
	var asideDataId = {};
	//쿠키 호출
	//AJAX 프레임
	
	var asideSubList = {};
	var asideKeyData = {};
	var advSettingData = {};
	var userKey = 'user_id';
	//히든값
	var groupId = '#advId';
	var groupNm = '#advNm';
	var groupKey = '#advKey';
	var groupSubId = "#adgKey";
	var asideClass = '.aside-category';
	
	var alwaysFunc = exports.alwaysFunc = {
		init: function init() {
			if (_cookies.cookies.getCookies(userKey) != null) {
				this.asideMenuData(_cookies.cookies.getCookies(userKey));
				this.headerUserNameData();
			}
		},
		//좌측 매뉴
		asideMenuData: function asideMenuData(obj) {
			var obj = '?user_id=' + obj + '&status=Active&client_type=premium';
			var dataApi = _dataUrl.dataUrl.alwaysAPI('GET', 'leftMenu', obj);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, alwaysFunc.asideMenuCallBack);
		},
		//좌측 서브 매뉴(즐겨찾기)
		asideMenuSubData: function asideMenuSubData(obj, callType) {
			var dataApi = _dataUrl.dataUrl.alwaysAPI('GET', callType, obj);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, alwaysFunc.asideMenuSubCallBack);
		},
		//좌측 매뉴 수정(즐겨찾기)
		asideMenuModifyData: function asideMenuModifyData(data) {
			var modifyData = {
				"group": {
					"id": data[0],
					"name": data[1]
				}
			};
			var dataApi = _dataUrl.dataUrl.alwaysAPI('PUT', 'menuModify');
			_ajaxForm.ajaxFrame.ajaxDataCall('PUT', dataApi, 'json', true, alwaysFunc.asideMenuModifyCallBack, modifyData);
		},
		//좌측 매뉴 삭제(즐겨찾기)
		asideMenuDeleteData: function asideMenuDeleteData(data) {
			var deleteData = {
				"group": { "id": data }
			};
			var dataApi = _dataUrl.dataUrl.alwaysAPI('DELETE', 'menuDelete');
			_ajaxForm.ajaxFrame.ajaxDataCall('DELETE', dataApi, 'json', true, alwaysFunc.asideMenuDeleteCallBack, deleteData);
		},
		//좌측 매뉴 추가(즐겨찾기)
		asideMenuAddData: function asideMenuAddData(data) {
			var addData = {
				"group": {
					"name": data[0],
					"status": "Active",
					"advs_id": data[1]
				}
			};
			var dataApi = _dataUrl.dataUrl.alwaysAPI('POST', 'menuAdd');
			_ajaxForm.ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, alwaysFunc.asideMenuAddCallBack, addData);
		},
		//상단 알림창
		headerNewsData: function headerNewsData(obj) {
			var param = '?adv_id=' + obj;
			var dataApi = _dataUrl.dataUrl.alwaysAPI('GET', 'news', param);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, alwaysFunc.headerNewsCallBack);
		},
		//상단 알림 삭제
		headerNewsDeleteData: function headerNewsDeleteData(obj) {
			var param = '?rept_job_history_ids=' + obj;
			var dataApi = _dataUrl.dataUrl.alwaysAPI('PUT', 'news', param);
			_ajaxForm.ajaxFrame.ajaxDataCall('PUT', dataApi, 'json', true, alwaysFunc.headerNewsDeleteCallBack);
		},
		//로그인 회원 이름
		headerUserNameData: function headerUserNameData() {
			var userName = decodeURIComponent(decodeURIComponent(_cookies.cookies.getCookies('user_nm')));
			$('#user-name').text(userName);
		},
		//즐겨찾기 사이드 서브 리스트 저장
		favoriteSubListSave: function favoriteSubListSave() {
			return asideSubList;
		},
		//광고주설정 목록
		advSettingPop: function advSettingPop() {
			var obj = '?user_id=' + _cookies.cookies.getCookies(userKey) + '&status=Active';
			var dataApi = _dataUrl.dataUrl.alwaysAPI('GET', 'leftMenu', obj);
			AjaxLoading.pageLoading('time');
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, alwaysFunc.advSettingPopCallBack);
		},
		//광고주설정 저장 기능
		advSettingSaveData: function advSettingSaveData(thisEl) {
			var thisEl = $(thisEl);
			var preId = '';
			var normalId = '';
			var preStr = 0;
			var normalStr = 0;
			thisEl.find("li input").each(function () {
				var thisCheck = $(this).prop('checked');
				if (thisCheck == true) {
					if (0 == preStr) {
						preId += $(this).parent().data('key');
					} else {
						preId += ',' + $(this).parent().data('key');
					}
					preStr++;
				} else {
					if (0 == normalStr) {
						normalId += $(this).parent().data('key');
					} else {
						normalId += ',' + $(this).parent().data('key');
					}
					normalStr++;
				}
			});
			var obj = '?premium_ids=' + preId + '&normal_ids=' + normalId;
			var dataApi = _dataUrl.dataUrl.alwaysAPI('PUT', 'settingUpdate', obj);
			_ajaxForm.ajaxFrame.ajaxDataCall('PUT', dataApi, 'json', true, alwaysFunc.advSettingSaveCallBack);
		},
		//광고주 설정 검색기능
		advSettingSearchData: function advSettingSearchData(thisEl) {
			var thisEl = $(thisEl);
			var value = thisEl.val().toUpperCase();
			var advKeyText = Object.keys(advSettingData);
			var uiBox = $('#setting-box-inner');
			if (value == '') {
				uiBox.find('li').show();
			} else {
				for (var i = 0; i < advKeyText.length; i++) {
					var keyStr = advKeyText[i].toUpperCase();
					if (String(keyStr).indexOf(value) > -1) {
						uiBox.find('.setting-box-' + advSettingData[advKeyText[i]].id).show();
					} else {
						uiBox.find('.setting-box-' + advSettingData[advKeyText[i]].id).hide();
					}
				}
			}
		},
	
		//CallBack Functions
		//좌측 매뉴
		asideMenuCallBack: function asideMenuCallBack(data) {
			var path = document.location.hash;
			path = path.replace('#', '');
			var dataFilter = data.data;
			var dataKey = Object.keys(dataFilter);
			var asideMenu = '';
			var subPage = true;
			if (0 < dataKey.length) {
				if (path == '/sub/favorite') {
					for (var i = 0; i < dataKey.length; i++) {
						asideMenu += "<li class='cate" + dataFilter[dataKey[i]].id + " deps" + i + " favorite'>";
						asideMenu += "<a href='javascript:void(0);' data-id='" + dataFilter[dataKey[i]].id + "' data-name='" + dataFilter[dataKey[i]].name + "' data-key='" + dataFilter[dataKey[i]].na_customer_ser + "' class='favorite'><span class='menu-name'>" + dataFilter[dataKey[i]].name + "</span><strong class='allCount'></strong></a>";
						asideMenu += "<button type='button' class='group-add-btn hide' data-id='" + dataFilter[dataKey[i]].id + "'>+</button>";
						asideMenu += "<div class='menu-sub-category active'>";
						asideMenu += "<ul class='menu-sub-inner'>";
						asideMenu += "</ul>";
						asideMenu += "</div>";
						asideMenu += "</li>";
						asideMenu += "<li class='create-group-tool hide'>";
						asideMenu += "<div class='active-btn-area'>";
						asideMenu += "<input type='text' data-id='" + dataFilter[dataKey[i]].id + "'  value='' class='active-input-area'>";
						asideMenu += "<button type='button' class='menu-btn-save' data-id='" + dataFilter[dataKey[i]].id + "'>저장</button>";
						asideMenu += "<button type='button' class='menu-btn-cancer'>취소</button>";
						asideMenu += "</div>";
						asideMenu += "</li>";
					}
				} else {
					for (var i = 0; i < dataKey.length; i++) {
						asideMenu += "<li class='cate" + dataFilter[dataKey[i]].id + " deps" + i + "'>";
						asideMenu += "<a href='javascript:void(0);' data-id='" + dataFilter[dataKey[i]].id + "' data-name='" + dataFilter[dataKey[i]].name + "' data-key='" + dataFilter[dataKey[i]].na_customer_ser + "'><span class='menu-name'>" + dataFilter[dataKey[i]].name + "</span></a>";
						asideMenu += "</li>";
					}
				}
			} else {
				asideMenu += "<li class='no-cate'>";
				asideMenu += "<a href='javascript:void(0);' data-id='no-data'>등록된 광고주가 없습니다.</a>";
				asideMenu += "</li>";
			}
			$(asideClass).html(asideMenu);
			alwaysFunc.asideEventCallBack();
		},
		//좌측 서브 매뉴 (즐겨찾기)
		asideMenuSubCallBack: function asideMenuSubCallBack(data) {
			asideSubList = data.data;
			var dataFilter = asideSubList.groups;
			var subListKey = Object.keys(dataFilter);
			var subListValues = subListKey.map(function (i) {
				return dataFilter[i];
			});
			var hasSubCate = $(asideClass + " .cate" + asideDataId['onId']).find('.menu-sub-category').hasClass('active');
			var asideSubMenu = '';
			if (0 < subListKey.length) {
				for (var i = 0; i < subListKey.length; i++) {
					asideSubMenu += "<li class='sub-li " + subListValues[i].id + "'><a href='javascript:void(0);' data-id='" + subListValues[i].id + "'>-<span class='group-name'>" + subListValues[i].name + "</span><strong class='subCount'>(" + subListValues[i].count + ")</strong></a>";
					asideSubMenu += "<div class='hover-btn-area hide'>";
					asideSubMenu += "<button type='button' class='menu-btn-modify' data-id='" + subListValues[i].id + "'>수정</button>";
					asideSubMenu += "<button type='button' class='menu-btn-delete' data-id='" + subListValues[i].id + "'>삭제</button>";
					asideSubMenu += "</div>";
					asideSubMenu += "<div class='active-btn-area hide'>";
					asideSubMenu += "<input type='text' data-id='" + subListValues[i].id + "' value='" + subListValues[i].name + "' class='active-input-area'>";
					asideSubMenu += "<button type='button' data-id='" + subListValues[i].id + "' class='menu-btn-save'>저장</button>";
					asideSubMenu += "<button type='button' class='menu-btn-cancer'>취소</button>";
					asideSubMenu += "</div>";
					asideSubMenu += "</li>";
				}
				$(asideClass + " .cate" + asideDataId['onId']).find('.menu-sub-inner').html(asideSubMenu);
				setTimeout(function () {
					$(asideClass + " .cate" + asideDataId['onId'] + ' .menu-sub-category').stop().slideDown(100);
				}, 100);
			}
			//서브매뉴 콜백 액션
			if (asideSubList.allCount != '' || asideSubList.allCount != null || asideSubList.allCount != 'undefined') {
				$(asideClass + " .cate" + asideDataId['onId']).find('a .allCount').text("(" + asideSubList.allCount + ")");
			}
			alwaysFunc.asideSubEvent();
		},
		//상단 알림창
		headerNewsCallBack: function headerNewsCallBack(data) {
			var dataFilter = data;
			var dataKey = Object.keys(dataFilter);
			var dataValues = dataKey.map(function (key) {
				return dataFilter[key];
			});
			var newsHtml = '';
			var maxLength = 5;
			var newsLength = 0;
			var newsId = '#my-news-data';
			if (0 < dataKey.length) {
				for (var i = 0; i < dataKey.length; i++) {
					if (i < maxLength) {
						newsHtml += "<li class='" + dataKey[i] + "'><div><span>" + dataFilter[dataKey[i]] + "</span><a class='news-delete' data-key='' onclick='btnActions.newsDeleteBtn(this);' data-number='" + dataKey[i] + "'>X</a></div></li>";
					}
				}
				$('.new-icon').addClass('active');
			} else {
				newsHtml += "<li><p>새로 생성된 데이터가 없습니다.</p></li>";
				$('.new-icon').removeClass('active');
			}
			$(newsId).html(newsHtml);
			$(newsId).find('li').each(function (length) {
				newsLength = length;
			});
		},
		//상단 알림 삭제
		headerNewsDeleteCallBack: function headerNewsDeleteCallBack() {
			var createCheck = location.hash;
			var newsLength = null;
			$('#my-news-data').find('li').each(function (length) {
				newsLength = length;
			});
			if (newsLength == null) {
				$('.new-icon').removeClass('active');
			} else {
				$('.new-icon').addClass('active');
			}
		},
		//좌측 매뉴 이벤트
		asideEventCallBack: function asideEventCallBack() {
			var path = document.location.hash;
			path = path.replace('#', '');
			asideDataId['subOnId'] = null;
			if (asideDataId['onId'] == null) {
				//매뉴 광고주 아이디/광고주명/네이버키 저장
				asideDataId['onId'] = $(asideClass + ' li').eq(0).find('a').data('id');
				asideDataId['onNm'] = $(asideClass + ' li').eq(0).find('a').data('name');
				asideDataId['onKey'] = $(asideClass + ' li').eq(0).find('a').data('key');
				$(groupId).val(asideDataId['onId']);
				$(groupNm).val(asideDataId['onNm']);
				$(groupKey).val(asideDataId['onKey']);
				//초기 매뉴 첫번째 엑티브 효과
				$(asideClass + ' li').eq(0).find('a').addClass('active');
			} else {
				$(asideClass + ' li.cate' + asideDataId['onId']).find('a').addClass('active');
			}
	
			asideDataId['prevId'] = asideDataId['onId'];
	
			//매뉴 클릭 이벤트
			$(asideClass + ' > li > a').click(function (e) {
				asideDataId['subOnId'] = null;
				//광고주 그룹 아이디 저장
				asideDataId['onId'] = $(this).data('id');
				asideDataId['onNm'] = $(this).data('name');
				asideDataId['onKey'] = $(this).data('key');
				$(groupId).val(asideDataId['onId']);
				$(groupNm).val(asideDataId['onNm']);
				$(groupKey).val(asideDataId['onKey']);
	
				var subCheck = $(this).next().hasClass('active');
				$('.create-group-tool').hide();
	
				//좌측매뉴 별 매뉴 데이터 불러오기
				if (asideDataId['onId'] != asideDataId['prevId']) {
					if (path == '/sub/favorite') {
						$(asideClass).find('a .allCount').text("");
						$('.menu-sub-category').stop().slideUp(100);
						setTimeout(function () {
							$('.menu-sub-inner').find('li').remove();
							alwaysFunc.asideMenuSubData(asideDataId['onId'], 'subMenu');
						}, 100);
					} else if (path == '/sub/create' || path == '/index') {
						createFunc.createListCall(asideDataId['onId']);
					} else if (path == '/sub/bidding') {
						biddingFunc.initReptJobHistoryDatesByAdvId(asideDataId['onId']);
					} else if (path == '/sub/setting') {
						settingFunc.callSettingByAdvId(asideDataId['onId']);
					}
					alwaysFunc.headerNewsData(asideDataId['onId']);
					$(asideClass + '> li a').removeClass('active');
					$(this).addClass('active');
					asideDataId['prevId'] = asideDataId['onId'];
					asideDataId['subPrevId'] = "Na";
				} else {
					if (path == '/sub/favorite') {
						$('.menu-sub-category').stop().slideUp(100);
						setTimeout(function () {
							$('.menu-sub-inner').find('li').remove();
						}, 100);
						$(asideClass).find('a .allCount').text("");
						asideDataId['prevId'] = 'Na';
						$(this).removeClass('active');
					}
				}
				//끝
			});
			//좌측 매뉴 생성/삭제/수정 (즐겨찾기)
			$(asideClass + ' > li').mouseenter(function () {
				var $this = $(this);
				$this.find('.group-add-btn').show();
			});
			$(asideClass + ' > li').mouseleave(function () {
				$('.group-add-btn').hide();
			});
			//추가
			$('.group-add-btn').click(function () {
				var $this = $(this);
				var dataId = $this.data('id');
				$this.parent('li').next().show();
				$this.parent('li').next().find('input').attr('data-id', dataId).focus();
			});
			//저장
			$('.create-group-tool').find('.menu-btn-save').click(function () {
				if (confirm('등록하시겠습니까?') == true) {
					var $this = $(this);
					var saveText = $this.parent().find('input').val();
					var saveGroupId = $this.data('id');
					var addSave = [saveText, saveGroupId];
					//데이터 넣는곳 필요
					if (saveText == '') {
						alert('입력 값이 없습니다.');
					} else {
						alwaysFunc.asideMenuAddData(addSave);
					}
				} else {
					return;
				}
			});
			$('.create-group-tool').find('.active-input-area').keydown(function (e) {
				if (e.which == 13) {
					if (confirm('등록하시겠습니까?') == true) {
						var $this = $(this);
						var saveText = $this.parent().find('input').val();
						var saveGroupId = $this.data('id');
						var addSave = [saveText, saveGroupId];
						//데이터 넣는곳 필요
						if (saveText == '') {
							alert('입력 값이 없습니다.');
						} else {
							alwaysFunc.asideMenuAddData(addSave);
						}
					} else {
						return;
					}
				}
			});
			//취소
			$('.create-group-tool').find('.menu-btn-cancer').click(function () {
				$(this).parents('.create-group-tool').hide();
			});
	
			//좌측매뉴 불러오기
			if (asideDataId['onId'] == 'no-data' || asideDataId['onId'] == '') {
				$('#bidding-area, #create-area, #favorite-area, #setting-area').hide();
				$('.no-data-wrap').show();
			} else {
				$('#bidding-area, #create-area, #favorite-area, #setting-area').show();
				$('.no-data-wrap').hide();
				if (path == '/sub/favorite') {
					alwaysFunc.asideMenuSubData(asideDataId['onId'], 'subMenu');
				} else if ((path == '/sub/create' || path == '/index') && asideDataId['onId'] != 'no-data') {
					createFunc.createListCall(asideDataId['onId']);
				} else if (path == '/sub/bidding' && asideDataId['onId'] != 'no-data') {
					biddingFunc.initReptJobHistoryDatesByAdvId(asideDataId['onId']);
				} else if (path == '/sub/setting' && asideDataId['onId'] != 'no-data') {
					settingFunc.callSettingByAdvId(asideDataId['onId']);
				}
				alwaysFunc.headerNewsData(asideDataId['onId']);
			}
		},
		//좌측 서브 매뉴 이벤트(즐겨찾기)
		asideSubEvent: function asideSubEvent() {
			var subEl = '.menu-sub-inner li.sub-li';
			if (asideDataId['subOnId'] == null) {
				asideDataId['subOnId'] = $(subEl).eq(0).find('a').data('id');
				$(groupSubId).val(asideDataId['subOnId']);
				$(subEl).eq(0).find('a').addClass('active');
				favoriteFunc.favoriteSubListData(asideDataId['subOnId']);
			}
			//즐겨찾기 매뉴 서브 데이터
			$(subEl).find('a').click(function () {
				asideDataId['subOnId'] = $(this).data('id');
				var thisHas = $(this).hasClass('active');
				if (asideDataId['subOnId'] != asideDataId['subPrevId']) {
					$(groupSubId).val(asideDataId['subOnId']);
					favoriteFunc.favoriteSubListData(asideDataId['subOnId']);
					$('.menu-sub-inner li a').removeClass('active');
					$(this).addClass('active');
					asideDataId['subPrevId'] = asideDataId['subOnId'];
				}
			});
			//좌측 서브 매뉴 생성/삭제/수정 (즐겨찾기)
			$(subEl).mouseover(function () {
				var $this = $(this);
				$(subEl).find('.hover-btn-area').hide();
				$this.find('.hover-btn-area').show();
			});
			$(subEl).mouseleave(function () {
				$(subEl).find('.hover-btn-area').hide();
			});
			//수정
			$(subEl).find('.menu-btn-modify').click(function () {
				var $this = $(this);
				var thisId = $this.parent().prev().data('id');
				$(subEl).find('.active-btn-area').hide();
				$this.parent('.hover-btn-area').next('.active-btn-area').show().find('input').focus();
			});
			//취소
			$(subEl).find('.menu-btn-cancer').click(function () {
				$(subEl).find('.active-btn-area').hide();
			});
			//ESC 버튼 취소
			$(document).keyup(function (e) {
				if (e.keyCode == 27) {
					$(subEl).find('.active-btn-area').hide();
					$('.create-group-tool').hide();
				}
			});
			//저장
			$(subEl).find('.menu-btn-save').bind('click', function (e) {
				if (confirm('저장하시겠습니까?') == true) {
					var $this = $(this);
					var saveText = $this.parent().find('.active-input-area').val();
					var saveId = $this.data('id');
					var modifySave = [saveId, saveText];
					if (saveText == '') {
						alert('입력 값이 없습니다.');
					} else {
						alwaysFunc.asideMenuModifyData(modifySave);
						$this.parent().parent('li').find('.group-name').text(saveText);
						$this.parent().hide();
					}
				} else {
					return;
				}
			});
			$(subEl).find('.active-input-area').bind('keydown', function (e) {
				if (e.which == 13) {
					if (confirm('저장하시겠습니까?') == true) {
						var $this = $(this);
						var saveText = $this.parent().find('.active-input-area').val();
						var saveId = $this.data('id');
						var modifySave = [saveId, saveText];
						if (saveText == '') {
							alert('입력 값이 없습니다.');
						} else {
							alwaysFunc.asideMenuModifyData(modifySave);
							$this.parent().parent('li').find('.group-name').text(saveText);
							$this.parent().hide();
						}
					} else {
						return;
					}
				}
			});
			//삭제
			$(subEl).find('.menu-btn-delete').click(function () {
				var $this = $(this);
				var deleteId = $this.data('id');
				if (confirm('삭제하시겠습니까?') == true) {
					$this.parent().parent('li').remove();
					alwaysFunc.asideMenuDeleteData(deleteId);
				}
			});
		},
		advSettingPopCallBack: function advSettingPopCallBack(data) {
			var dataFilter = data.data;
			var dataKey = Object.keys(dataFilter);
			var temp_obj = {};
			var html = "";
			if (0 < dataKey.length) {
				dataKey.map(function (key) {
					temp_obj[dataFilter[key].name] = dataFilter[key];
				});
				advSettingData = temp_obj;
				var newDataKey = Object.keys(temp_obj);
				newDataKey.sort();
				for (var i = 0; i < newDataKey.length; i++) {
					html += "<li class='setting-box-" + temp_obj[newDataKey[i]].id + "' data-key='" + temp_obj[newDataKey[i]].id + "'>";
					if (temp_obj[newDataKey[i]].client_type == 'premium') {
						html += "<input id='set-box-" + i + "' type='checkbox' checked value=''>";
					} else {
						html += "<input id='set-box-" + i + "' type='checkbox' value=''>";
					}
					html += "<label for='set-box-" + i + "'>" + temp_obj[newDataKey[i]].name + "</label>";
					html += "</li>";
				}
			} else {
				html += "<li class='no-data-message'>";
				html += "<div class='no-data'>";
				html += "* 광고주 목록이 없습니다. 원더박스에서 확인 후 이용해주세요.";
				html += "</div>";
				html += "</li>";
			}
			$('#setting-box-inner').html(html);
			$('.fixed-pop').fadeIn(200);
			$('#timeLoading').remove();
		},
		//좌측 광고주 추가 (즐겨찾기)
		asideMenuAddCallBack: function asideMenuAddCallBack() {
			alwaysFunc.asideMenuData(_cookies.cookies.getCookies(userKey));
		},
		advSettingSaveCallBack: function advSettingSaveCallBack(data) {
			delete asideDataId['onId'];
			alwaysFunc.asideMenuData(_cookies.cookies.getCookies(userKey));
			layerPopup.close();
		},
		//좌측 매뉴 수정(즐겨찾기)
		asideMenuModifyCallBack: function asideMenuModifyCallBack() {},
		asideMenuDeleteCallBack: function asideMenuDeleteCallBack() {}
	};
	
	window.alwaysFunc = alwaysFunc;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	//베이스 URL
	var domainCheck = location.hostname;
	var tmpbaseUrl = "";
	var chartUrl = "";
	if (domainCheck != 'bid.emforce.co.kr') {
		tmpbaseUrl = 'http://beta.ad-api.emforce.co.kr';
		chartUrl = 'http://beta.stats.emforce.co.kr';
	} else {
		tmpbaseUrl = 'http://ad-api.emforce.co.kr';
		chartUrl = 'http://stats.emforce.co.kr';
	} //http://218.232.122.57:8090/api
	var baseUrl = tmpbaseUrl;
	var dataUrl = exports.dataUrl = {
		alwaysAPI: function alwaysAPI(type, call, values) {
			var param = null;
			if (type == 'POST') {
				if (call == 'menuAdd') {
					param = baseUrl + '/bid_favorites/';
				} else if (call == 'login') {
					param = baseUrl + '/user_login/login/' + values;
				}
			} else if (type == 'GET') {
				if (call == 'news') {
					param = baseUrl + '/rept_job_history/execute_list/' + values;
				} else if (call == 'leftMenu') {
					param = baseUrl + '/adv/list/' + values;
				} else if (call == 'subMenu') {
					param = baseUrl + '/bid_favorites/count/?adv_id=' + values;
				}
			} else if (type == 'PUT') {
				if (call == 'news') {
					param = baseUrl + '/rept_job_history/read_dt/' + values;
				} else if (call == 'menuModify') {
					param = baseUrl + '/bid_favorites/';
				} else if (call == 'settingUpdate') {
					param = baseUrl + '/adv/upgrade/' + values;
				}
			} else if (type == 'DELETE') {
				if (call == 'menuDelete') {
					param = baseUrl + '/bid_favorites/';
				}
			}
			return param;
		},
		createAPI: function createAPI(type, call, values) {
			var param = null;
			if (type == 'POST') {
				if (call == 'add') {
					//데이터 기간 설정 생성
					param = baseUrl + '/rept_execute/';
				} else if (call == 'save') {
					//매일 예약 저장
					param = baseUrl + '/rept_execute/';
				}
			} else if (type == 'GET') {
				if (call == 'history') {
					//작업 목록 가져오기
					param = baseUrl + '/rept_job_history/' + values;
				} else if (call == 'status') {
					param = baseUrl + '/rept_job_history/status/?rept_job_history_id=' + values;
				} else if (call == 'saveCheck') {
					param = baseUrl + '/rept_execute/' + values;
				}
			} else if (type == 'PUT') {
				if (call == 'history') {
					//작업 목록 수정하기
					param = baseUrl + '/rept_job_history/?rept_job_history_ids=' + values;
				}
			} else if (type == 'DELETE') {
				if (call == 'daily') {
					param = baseUrl + '/rept_execute/?rept_execute_ids=' + values;
				} else if (call == 'history') {
					//작업 목록 수정하기
					param = baseUrl + '/rept_job_history/deleted_dt/?rept_job_history_ids=' + values;
				}
			}
			return param;
		},
		biddingAPI: function biddingAPI(type, call, values) {
			var param = null;
			if (type == 'POST') {
				if (call == 'bidUpdate') {
					param = baseUrl + '/integrate_rept/update_bid' + values;
				}
			} else if (type == 'GET') {
				if (call == 'historyDate') {
					param = baseUrl + '/rept_job_history/?adv_id=' + values;
				} else if (call == 'dateMatch') {
					param = baseUrl + "/integrate_rept/" + values;
				} else if (call == 'searchKeyword') {
					//키워드 검색 : 포함/정확/시작
					param = baseUrl + "/integrate_rept/" + values;
				} else if (call == 'addSelectField') {
					//고급 검색 - 유형 선택
					param = baseUrl + "/rept_fields/" + values;
				} else if (call == 'search') {
					//일반(고급) 검색
					param = baseUrl + "/integrate_rept/" + values;
				} else if (call == 'excel') {
					param = baseUrl + "/rept_excel/" + values;
				} else if (call == 'activeKeywordList') {
					param = baseUrl + "/bid_favorites/list/?bid_status=Active&adv_id=" + values;
				} else if (call == 'NaverApiAmt') {
					param = baseUrl + "/naapi/view_bid/" + values;
				} else if (call == 'NaverApiCampaign') {
					param = baseUrl + "/naapi/campaign_list/?na_customer=" + values;
				}
			} else if (type == 'PUT') {} else if (type == 'DELETE') {}
			return param;
		},
		favoriteAPI: function favoriteAPI(type, call, values) {
			var param = null;
			if (type == 'POST') {
				//키워드 추가 : 즐겨찾기 운영키워드 등록
				if (call == 'update_bid') {
					param = baseUrl + "/integrate_rept/update_bid/";
				} else if (call == 'keywordPush') {
					param = baseUrl + "/bid_favorites/";
				} else if (call == 'updateStatus') {
					param = baseUrl + "/integrate_rept/update_status/";
				} else if (call == 'naSync') {
					param = baseUrl + '/bid_favorites/na_sync/' + values;
				}
			} else if (type == 'GET') {
				if (call == 'search') {
					//즐겨찾기 키워드 검색 - 포함/일치/시작
					param = baseUrl + "/bid_favorites/list/" + values;
				} else if (call == 'masterSearch') {
					// 키워드 추가 : 즐겨찾기 운영키워드 검색 - 포함/정확/시작
					param = baseUrl + "/bid_favorites/operated_kwd_list/" + values;
				} else if (call == 'keywordAddList-1') {
					param = baseUrl + "/naapi/campaign_list/" + values;
				} else if (call == 'keywordAddList-2') {
					param = baseUrl + "/naapi/group_list/" + values;
				} else if (call == 'keywordAddList-3') {
					param = baseUrl + "/naapi/kwd_sync/" + values;
				} else if (call == 'list') {
					//즐겨찾기 키워드 리스트
					param = baseUrl + "/bid_favorites/list/?adv_id=" + values;
				} else if (call == 'subList') {
					//즐겨찾기 키워드 서브 리스트
					param = baseUrl + "/bid_favorites/list/?bid_favorite_id=" + values;
				} else if (call == 'groupKey') {
					param = baseUrl + "/bid_favorites/inserted_kwd_list/" + values;
				} else if (call == 'keyStatus') {
					param = baseUrl + "/naapi/kwd_info/" + values;
				} else if (call == 'sort') {
					param = baseUrl + "/bid_favorites/list/" + values;
				} else if (call == 'history') {
					param = baseUrl + "/bid_file_history/read/" + values;
				} else if (call == 'schedule') {
					param = baseUrl + "/bid_favorites/bid_schedule/" + values;
				} else if (call == 'rate') {
					param = baseUrl + "/bid_favorites/bid_variations/" + values;
				} else if (call == 'chart') {
					param = chartUrl + "/stats/" + values;
				} else if (call == 'chartExcel') {
					param = chartUrl + "/stats/excel/" + values;
				}
			} else if (type == 'PUT') {
				//순위/입찰가 작업 - 목표순위 변경 / 현재 입찰가 변경/ 입찰유형 변경/ 최대 입찰가 변경/ 목표순위,최대입찰가 일괄 변경 /
				if (call == 'update') {
					param = baseUrl + "/bid_favorites/";
				} else if (call == 'schedule') {
					param = baseUrl + "/bid_favorites/bid_schedule/";
				} else if (call == 'rate') {
					param = baseUrl + "/bid_favorites/bid_variations/";
				}
			} else if (type == 'DELETE') {
				if (call == 'update') {
					param = baseUrl + "/bid_favorites/";
				}
			}
			return param;
		},
		settingAPI: function settingAPI(type, call, values) {
			var param = null;
			if (type == 'POST') {
				if (call == 'save') {
					param = baseUrl + "/rept_match_type/";
				} else if (call == "filter") {
					param = baseUrl + "/rept_config/?adv_id=" + values + "&month_rept_config=0&week_rept_config=0&neo_duple_fields=이,것은,테스&neo_duple_sec=0";
				}
			} else if (type == 'GET') {
				if (call == 'client') {
					param = baseUrl + "/rept_match_type?adv_id=" + values + "&status=True";
				} else if (call == 'naver') {
					param = baseUrl + "/rept_match_type/match/?adv_id=" + values + "&status=True";
				} else if (call == 'neo') {
					param = baseUrl + "/rept_match_type/match/?adv_id=" + values + "&status=True";
				} else if (call == 'filter') {
					param = baseUrl + "/rept_config/?adv_id=" + values;
				}
			} else if (type == 'PUT') {} else if (type == 'DELETE') {}
			return param;
		}
	};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.favoriteFunc = undefined;
	
	var _ajaxForm = __webpack_require__(209);
	
	var _loading = __webpack_require__(210);
	
	var _dataUrl = __webpack_require__(718);
	
	__webpack_require__(720);
	
	__webpack_require__(858);
	
	//데이터 저장용
	
	//import datePicker
	
	//로딩 액션
	var faListData = {}; //즐겨찾기 전체 리스트
	
	//UI라이브러리
	
	//데이터 API 목록
	//AJAX 프레임
	var keywordData = {}; // 키워드 데이터
	var addKeywordData = {}; //추가 키워드 리스트
	var groupKeyword = {}; //그룹 키워드advSubId
	var pushKeywordData = {}; //키워드 추가 데이터
	var newKeywordData = {}; //신규 키워드
	var moveKeywordData = {}; // 이동 키워드
	var modifyKeywordData = {}; // 일괄변경 키워드 데이터
	var bidSetSaveKeywordData = {}; //입찰가 일괄설정
	var bidCpaSaveKeywordData = {}; //CPA 일괄설정
	var bidOppSaveKeywordData = {};
	var statusKwd = {}; // 상태 키워드
	var statusData = {}; // 상태 데이터
	var tableFilterData = {}; // 테이블 제어 데이터
	var filterCheckSave = {}; //제어 체크 데이터
	var bidChangeList = {}; //입찰가 일괄변경 리스트
	var bidSetList = {}; //일괄설정 리스트
	var naverSaveAPIData = {};
	var bidScheAllData = {}; //전체 예약 설정 데이터
	
	var AMT_MAX_VALUE = 100000;
	var OPTION_MAX_BID_AMT = AMT_MAX_VALUE;
	
	//히든값 엘리먼트
	var groupId = '#advId';
	var groupNm = '#advNm';
	var groupKey = '#advKey';
	var groupSubId = "#adgKey";
	
	//히든값 빈 변수
	var advNm;
	var advKey;
	var advId;
	
	//NULL 값
	var searchData = null;
	var advSubId = null;
	var historyKey = null;
	var clickedSingleKwdId = null;
	var bidSetChange = null;
	var thisKey = null;
	var bidScheAllClickKwd = null;
	
	//서브 체크
	var subCheck = false;
	var chartDataCheck = false;
	
	var favoriteFunc = exports.favoriteFunc = {
		init: function init() {},
	
		//Data or PopUpFunction (Start)
		//즐겨찾기 리스트
		//즐겨찾기 서브 리스트
		favoriteSubListData: function favoriteSubListData(dataId, type) {
			advId = $(groupId).val();
			advNm = $(groupNm).val();
			advKey = $(groupKey).val();
			$('.check-btn').prop('disabled', true);
			advSubId = $(groupSubId).val();
			searchData = null;
			subCheck = true;
			if (dataId !== undefined) {
				var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'subList', dataId);
				if (type != 'sync') {
					_loading.AjaxLoading.pageLoading();
				}
				$('.main_search_wrap, .bidding_function_wrap').show();
				$('#all_check').prop('checked', false);
				_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteListCallBack);
			} else {
				$('.main_search_wrap, .bidding_function_wrap').hide();
				$('.none_date p').text('즐겨찾기 그룹이 없습니다.');
				$('.favorite_table_wrap').hide();
				$('.favorite_none_wrap').show();
			}
		},
	
		favoriteResultDivOnScroll: function favoriteResultDivOnScroll() {
			var $list1 = $('.table_01');
			var leftOffset = $('.table_scroll_xy').scrollLeft();
			$list1.css('left', leftOffset);
		},
	
		//즐겨찾기 검색
		favoriteSearchData: function favoriteSearchData(data) {
			var favoriteId = null;
			searchData = data;
			$('.menu-sub-category .menu-sub-inner li').each(function () {
				var $this = $(this);
				var subActiveCheck = $this.find('a').hasClass('active');
				if (subActiveCheck == true) {
					favoriteId = $this.find('a').attr('data-id');
				}
			});
			if (favoriteId != null) {
				subCheck = true;
				var param = "?bid_favorite_id=" + favoriteId + "&" + searchData;
				var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'search', param);
				_loading.AjaxLoading.pageLoading();
				_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteListCallBack);
			}
		},
	
		//즐겨찾기 등록 키워드
		favoriteGroupKeywordData: function favoriteGroupKeywordData(data) {
			var param = "?adv_id=" + advId;
			var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'groupKey', param);
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteGroupKeywordCallBack);
		},
	
		//즐겨찾기 키워드 팝업
		favoriteKeywordPopUp: function favoriteKeywordPopUp(obj, data) {
			favoriteFunc.favoriteKeywordPopCallBack();
		},
	
		//즐겨찾기 운영키워드 검색
		favoriteKeywordSearchData: function favoriteKeywordSearchData(data) {
			var param = "?adv_id=" + advId + "&" + data;
			var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'masterSearch', param);
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteKeywordCallBack);
		},
	
		//즐겨찾기 신규 키워드 리스트
		favoriteAddKeywordListData: function favoriteAddKeywordListData(data) {
			if (data != '') {
				var param = '?na_customer=' + data;
				var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'keywordAddList-1', param);
				_loading.AjaxLoading.pageLoading();
				_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteAddKeywordListCallBack);
			}
		},
	
		//즐겨찾기 신규 키워드 리스트2
		favoriteAddKeywordListData2: function favoriteAddKeywordListData2(dataEl) {
			var thisId = $(dataEl).attr('data-id');
			var param = '?na_customer=' + advKey + '&na_campaign_ser=' + thisId;
			var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'keywordAddList-2', param);
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteAddKeywordList2CallBack);
		},
	
		//즐겨찾기 신규 키워드 리스트3
		favoriteAddKeywordListData3: function favoriteAddKeywordListData3(dataEl) {
			var thisId = $(dataEl).attr('data-id');
			var param = '?na_customer=' + advKey + '&na_adgroup_ser=' + thisId;
			var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'keywordAddList-3', param);
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteAddKeywordList3CallBack);
		},
	
		//즐겨찾기 키워드 등록
		favoriteAddKeywordPushData: function favoriteAddKeywordPushData(type) {
			if (type == 'add') {
				var pushSubId = advSubId;
				var pushKey = Object.keys(pushKeywordData);
				var pushValue = pushKey.map(function (key) {
					return pushKeywordData[key];
				});
			} else if (type == 'move') {
				var pushSubId = $('#move-group-select').val();
				if (pushSubId != '') {
					var pushKey = Object.keys(moveKeywordData);
					var pushValue = pushKey.map(function (key) {
						return moveKeywordData[key];
					});
					alert('키워드가 이동되었습니다.');
				} else {
					alert('이동할 그룹을 선택해주세요.');
					return;
				}
			}
			if (pushSubId != undefined) {
				var request = { "group": {
						"id": Number(pushSubId),
						"advs_id": Number(advId)
					},
					"keywords": pushValue
				};
			} else {
				var request = { "group": {
						"advs_id": Number(advId)
					},
					"keywords": pushValue
				};
			}
			if (0 < pushValue.length) {
				var dataApi = _dataUrl.dataUrl.favoriteAPI('POST', 'keywordPush');
				_ajaxForm.ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, favoriteFunc.favoriteKeywordPushCallBack, request);
			} else {
				alert('키워드 선택 후 이용해주세요.');
			}
		},
	
		//오름차순/내림차순 (현재순위, 목표순위, 현재입찰가, 최대입찰가)
		favoriteSortChangeData: function favoriteSortChangeData(sort, type, thisEl) {
			var searchKey = '';
			var $this = $(thisEl);
			if (advSubId != null) {
				searchKey = 'bid_favorite_id=' + advSubId;
				if (searchData != null) {
					searchKey += '&' + searchData;
				}
			} else {
				searchKey = 'adv_id=' + advId;
			}
			if (sort == 'BASIC') {
				var param = '?' + searchKey;
			} else {
				var param = '?' + searchKey + '&sort=' + sort + '&sort_field=' + type;
			}
			//action
			$this.parents('ul').find('button').removeClass('on');
			$this.addClass('on');
			_loading.AjaxLoading.pageLoading();
			var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'sort', param);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteListCallBack);
		},
	
		//순위/입찰가 작업 - 목표순위 변경 / 현재 입찰가 변경/ 입찰유형 변경/ 최대 입찰가 변경/ 목표순위,최대입찰가 일괄 변경 /경쟁사순위변경
		favoriteBidChangeData: function favoriteBidChangeData(thisEl, allType, condition) {
			var $this = $(thisEl);
			var type = $this.attr('data-type');
			var keyId = $this.parents('tr').attr('data-id');
			var keywords = faListData[keyId];
			var listArray = [];
			var changeKey = [];
			var updateData;
			var ajaxType = 'PUT';
			var updateType = '';
			var multi = false;
			var subEl = '.favorite_inner_table_wrap tbody tr, #bid_amt_preview_table tbody tr';
			var $bidListTr = $('#bid-list-body-2 tr');
			if (type == 'bidRank') {
				if (confirm("변경 하시겠습니까?") == true) {
					//순위변경
					ajaxType = 'PUT';
					updateType = 'type3';
					var key = $this.attr('data-name');
					var value = $this.val();
					$this.addClass('effect');
					setTimeout(function () {
						$this.removeClass('effect');
					}, 500);
					changeKey.push(key);
					keywords['before_goal_rank'] = keywords[key];
					keywords[key] = value;
					$this.attr('data-rank', value);
					listArray.push(keywords);
				} else {
					var orign = $this.attr('data-rank');
					$this.val(orign);
					return;
				}
			} else if (allType == 'bidSet' || allType == 'bidCpa' || allType == 'bidOpp') {
				var comment = allType == 'bidSet' ? '목표순위, 최대 입찰가를 일괄설정 하시겠습니까?' : allType == 'bidCpa' ? '목표CPA, 최대 입찰가를 일괄설정 하시겠습니까?' : '타겟 목표순위, 최대 입찰가를 일괄설정 하시겠습니까?';
				var success = false;
				var setMax = Number($('#max-bid-input').val());
				var setMin = Number($('#min-bid-input').val());
	
				//최대,최소입찰가 필터
				if ('' === setMax || '' === setMin) {
					alert('최대입찰가,최소입찰가를 입력해 주세요.');
					success = false;
					return;
				} else if (0 < setMax && 0 < setMin) {
					if (setMin < setMax) {
						if ((0 == setMax || 70 <= setMax) && (0 == setMin || 70 <= setMin)) {
							success = true;
						} else {
							alert('최소입찰가,최대입찰가는 70원 미만으로 설정할 수 없습니다.');
							success = false;
							return;
						}
					} else {
						alert('최대입찰가는 최소입찰가보다 작거나 동일하게 설정할 수 없습니다.');
						success = false;
						return;
					}
				} else {
					if ((0 == setMax || 70 <= setMax) && (0 == setMin || 70 <= setMin)) {
						success = true;
					} else {
						alert('최대입찰가,최소입찰가는 70원 미만으로 설정할 수 없습니다.');
						success = false;
						return;
					}
				}
	
				if (success == true) {
					if (confirm(comment) == true) {
						ajaxType = 'PUT';
						updateType = 'type3';
						var setKey = '';
						var eRemoveEl = '';
						var messageCount = 0;
	
						if (allType == 'bidSet') {
							var afterKeys = ['goal_rank', 'max_bid_amt', 'min_bid_amt', 'bid_status'];
							var beforeKeys = ['before_goal_rank', 'before_max_bid_amt', 'before_min_bid_amt', 'before_bid_status'];
							var eAddEl = ['.bid-rank-option option', '.max_bid_price', '.min_bid_price'];
							eRemoveEl = '.bid-rank-option option, .max_bid_price, .min_bid_price';
						} else if (allType == 'bidCpa') {
							var afterKeys = ['goal_cpa_amt', 'max_bid_amt', 'min_bid_amt', 'bid_status'];
							var beforeKeys = ['before_goal_cpa_amt', 'before_max_bid_amt', 'before_min_bid_amt', 'before_bid_status'];
							var eAddEl = ['.goal_cpa_price', '.max_bid_price', '.min_bid_price'];
							eRemoveEl = '.goal_cpa_price, .max_bid_price, .min_bid_price';
						} else if (allType == 'bidOpp') {
							var afterKeys = ['opp_gap', 'opp_goal_rank', 'max_bid_amt', 'min_bid_amt', 'opp_site', 'bid_status'];
							var beforeKeys = ['before_opp_gap', 'before_opp_goal_rank', 'before_max_bid_amt', 'before_min_bid_amt', 'before_opp_site', 'before_bid_status'];
							var eAddEl = ['.opp-gap', '.opp_goal_rank', '.max_bid_price', '.min_bid_price'];
							eRemoveEl = '.opp-gap, .opp_goal_rank, .max_bid_price, .min_bid_price';
						}
						setKey = afterKeys;
	
						if (0 < setKey.length) {
							for (var i = 0; i < setKey.length; i++) {
								changeKey.push(setKey[i]);
							}
						}
						$this.find('tr').each(function () {
							var $this = $(this);
							var key = $this.attr('data-id');
							var $this2 = $('#bid-list-body-2').find('.' + key);
							var bidStatusCheck = $this2.find('.bidStatus-td > p').attr('data-status');
							var check = $this.find("input[type='checkbox']").prop('checked');
							//&& bidStatusCheck != 'Inactive'
							if (check == true) {
								keywords = faListData[key];
								//목표순위, 최대 입찰가 일괄설정
								if (allType == 'bidSet') {
									var targetCheck = keywords.target;
	
									for (var i = 0; i < afterKeys.length; i++) {
										if (i <= 2) {
											keywords[beforeKeys[i]] = keywords[afterKeys[i]];
											if (targetCheck == 'mobile' && Number(bidSetSaveKeywordData[key]['goal_rank']) > 15 && messageCount === 0) {
												messageCount++;
												alert('설정 목표순위가 15이상 입니다. 모바일 키워드는 적용이 제외됩니다.');
												keywords[afterKeys[i]] = keywords[afterKeys[i]];
											} else {
												keywords[afterKeys[i]] = Number(bidSetSaveKeywordData[key][afterKeys[i]]);
											}
											$this2.find(eAddEl[i]).addClass('effect');
											if (i == 0) {
												$this2.find(eAddEl[i]).eq(Number(bidSetSaveKeywordData[key][afterKeys[i]] - 1)).prop('selected', true);
											} else {
												$this2.find(eAddEl[i]).text(bidSetSaveKeywordData[key][afterKeys[i]]);
											}
										} else {
											keywords[beforeKeys[i]] = keywords[afterKeys[i]];
											if (targetCheck == 'mobile' && Number(bidSetSaveKeywordData[key]['goal_rank']) > 15 && messageCount === 0) {
												messageCount++;
												alert('설정 목표순위가 15이상 입니다. 모바일 키워드는 적용이 제외됩니다.');
												keywords[afterKeys[i]] = keywords[afterKeys[i]];
											} else {
												keywords[afterKeys[i]] = 'Active';
											}
										}
									}
									//목표CPA 일괄설정
								} else if (allType == 'bidCpa') {
	
									for (var i = 0; i < afterKeys.length; i++) {
										if (i <= 2) {
											if (i == 0) {
												keywords[afterKeys[i]] = keywords[afterKeys[i]] == null ? 0 : keywords[afterKeys[i]];
											}
											keywords[beforeKeys[i]] = keywords[afterKeys[i]];
											keywords[afterKeys[i]] = bidCpaSaveKeywordData[key][afterKeys[i]];
											$this2.find(eAddEl[i]).addClass('effect');
											$this2.find(eAddEl[i]).text(bidCpaSaveKeywordData[key][afterKeys[i]]);
										} else {
											keywords[beforeKeys[i]] = keywords[afterKeys[i]];
											keywords[afterKeys[i]] = 'CpaActive';
										}
									}
	
									//경쟁사 일괄설정
								} else if (allType == 'bidOpp') {
	
									for (var i = 0; i < afterKeys.length; i++) {
										if (i <= 1) {
											//경쟁사 현재순위
											keywords[beforeKeys[i]] = keywords[afterKeys[i]] == null ? 0 : keywords[afterKeys[i]];
											keywords[afterKeys[i]] = Number(bidOppSaveKeywordData[key][afterKeys[i]]);
										} else if (i <= 3) {
											//최대입찰가
											keywords[beforeKeys[i]] = keywords[afterKeys[i]];
											keywords[afterKeys[i]] = bidOppSaveKeywordData[key][afterKeys[i]];
											$this2.find(eAddEl[i]).addClass('effect');
											$this2.find(eAddEl[i]).text(bidOppSaveKeywordData[key][afterKeys[i]]);
										} else if (i == 4) {
											//경쟁사 사이트
											keywords[beforeKeys[i]] = keywords.opp_site == null ? '' : keywords[afterKeys[i]];
											keywords[afterKeys[i]] = bidOppSaveKeywordData[key][afterKeys[i]];
										} else {
											//입찰상태
											keywords[beforeKeys[i]] = keywords[afterKeys[i]];
											keywords[afterKeys[i]] = 'OppActive';
										}
									}
								}
								listArray.push(keywords);
							}
						});
	
						_loading.AjaxLoading.pageLoading('time');
						setTimeout(function () {
							favoriteFunc.favoriteSubListData(advSubId, 'sync');
						}, 1000);
						setTimeout(function () {
							$this.find('tr').find(eRemoveEl).removeClass('effect');
						}, 1500);
					} else {
						return;
					}
				}
			} else if (allType == 'mutiCurBid') {
				//다중  입찰가 일괄설정
				if (confirm('선택한 키워드의 입찰가를 변경하시겠습니까?') == true) {
					ajaxType = 'POST';
					updateType = 'type1';
					var $radio = $('.amt-choices:checked');
					var $parentLi = $radio.closest('li');
					var checkVal = Number($parentLi.find('.change-value').val());
					var changeValueType = $parentLi.find('.change-value-type').val();
					var selectVal = $radio.closest('li').find('.select-value').val();
					var $table = $('#bid_amt_preview_table');
					var optionCheck = $('#option').prop('checked');
					var key = ['cur_bid_amt', 'bid_status'];
					for (var i = 0; i < key.length; i++) {
						changeKey.push(key[i]);
					}
	
					var setFunctions = function setFunctions(check) {
						$table.find('tbody tr').each(function () {
							var dataKey = $(this).attr('data-key');
							var values = checkVal;
	
							if (check == 'perI' || check == 'perD') {
								if (changeValueType == '원') {
									if (check == 'perI') {
										var values = bidChangeList[dataKey].cur_bid_amt + checkVal;
									} else {
										var values = bidChangeList[dataKey].cur_bid_amt - checkVal;
									}
								} else {
									var values = bidChangeList[dataKey].cur_bid_amt * (1 + checkVal / 100);
								}
							}
	
							if (optionCheck == true) {
								maxAmt = $('#option-max-bid-amt').val();
								if (maxAmt < values) {
									values = maxAmt;
								}
							}
	
							var price = favoriteFunc.bidAmtRound(Number(values));
							bidChangeList[dataKey]['before_bid_status'] = bidChangeList[dataKey].bid_status;
							bidChangeList[dataKey]['before_bid_amt'] = bidChangeList[dataKey].cur_bid_amt;
							bidChangeList[dataKey]['bid_status'] = 'Inactive';
							bidChangeList[dataKey]['cur_bid_amt'] = price;
	
							$(this).find('.bid_price').text(numberWithCommas(price));
							actions(dataKey, price);
							listArray.push(bidChangeList[dataKey]);
						});
					};
	
					var actions = function actions(key, price) {
						var $list = $('#bid-list-body-2 .' + key);
						$list.find('.cur_bid_price').text(numberWithCommas(price));
						$list.find('.bid-status-btn').removeClass('on');
						$list.find('.bid-status-Inactive').addClass('on');
						$list.find('.bid-cur-option').prop('disabled', false);
						$list.find('.bid-rank-option, .bid-max-option, .bid-min-option').prop('disabled', true);
					};
	
					switch ($radio.val()) {
						case 'SAME':
							setFunctions();
							break;
						case 'INCREASE':
							setFunctions('perI');
							break;
						case 'DECREASE':
							setFunctions('perD');
							break;
						case 'MID_AMT':
						case 'AVG_AMT':
							var params = '?na_customer=' + advKey;
							params += '&view_bid_type=' + selectVal;
							params += '&na_kwd_sers=' + favoriteFunc.makeCheckedBiddingListKeywordKeyCommaStr(bidChangeList);
							var dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'NaverApiAmt', params);
							_loading.AjaxLoading.pageLoading();
							_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', false, favoriteFunc.setCurBidAmtByNaverSaveAPI);
							$table.find('tbody tr').each(function () {
								var dataKey = $(this).attr('data-key');
								var values = naverSaveAPIData[dataKey].bid;
	
								if (optionCheck == true) {
									var maxAmt = $('#option-max-bid-amt').val();
									if (maxAmt < values) {
										values = maxAmt;
									}
								}
								var price = favoriteFunc.bidAmtRound(Number(values));
	
								bidChangeList[dataKey]['before_bid_amt'] = bidChangeList[dataKey].cur_bid_amt;
								bidChangeList[dataKey]['cur_bid_amt'] = price;
	
								$(this).find('.bid_price').text(numberWithCommas(price));
								$('#bid-list-body-2 .' + dataKey).find('.cur_bid_price').text(numberWithCommas(price));
								listArray.push(bidChangeList[dataKey]);
							});
							break;
					}
					_loading.AjaxLoading.pageLoading('time');
					setTimeout(function () {
						favoriteFunc.favoriteSubListData(advSubId, 'sync');
						$bidListTr.find('.cur_bid_price').addClass('effect');
						setTimeout(function () {
							$bidListTr.find('.cur_bid_price').removeClass('effect');
						}, 500);
					}, 1000);
				} else {
					return;
				}
			} else if (type == 'resvStatus') {
				var bidOnCheck = $this.parents('tr').find('.bid-status-active').hasClass('on');
				var cpaOnCheck = $this.parents('tr').find('.cpa-status-active').hasClass('on');
				var oppOnCheck = $this.parents('tr').find('.opp-status-active').hasClass('on');
				var value = $this.attr('data-status');
				if (bidOnCheck == true || cpaOnCheck == true || oppOnCheck == true || value == 'Inactive') {
					//예약 변경 : on/off
					if ($this.hasClass('on') !== true) {
						if (confirm("변경 하시겠습니까?") == true) {
							ajaxType = 'PUT';
							updateType = 'type3';
							var key = $this.attr('data-name');
							changeKey.push(key);
							keywords['before_revs_status'] = keywords[key];
							keywords[key] = value;
	
							listArray.push(keywords);
							//버튼 이벤트
							$('.' + keyId).find('.resv-status-btn').removeClass('on');
							$this.addClass('on');
						} else {
							return;
						}
					} else {
						return;
					}
				} else {
					alert('먼저 자동입찰을 선택해주세요.');
					return;
				}
			} else if (type == 'bidStatus') {
				//입찰유형 변경 : 자동 /수동
				if ($this.hasClass('on') !== true) {
					var $keyEl = $('.' + keyId);
					var value = $this.attr('data-status');
					var comment = value == 'Inactive' ? '입찰상태를 OFF로 변경하시면 예약 상태도 OFF로 변경됩니다. 변경하시겠습니까?' : "변경 하시겠습니까?";
					if (confirm(comment) == true) {
						ajaxType = 'PUT';
						updateType = 'type3';
						var key = $this.attr('data-name');
						changeKey.push(key);
						keywords['before_bid_status'] = keywords[key];
						keywords[key] = value;
	
						listArray.push(keywords);
						var statusText = value == 'Inactive' ? '수동' : value == 'Active' ? '목표순위' : value == 'CpaActive' ? '목표CPA' : '경쟁사 타겟';
	
						if (value == 'Inactive') {
							keywords['before_resv_status'] = keywords['resv_status'];
							keywords['resv_status'] = 'Inactive';
							changeKey.push('resv_status');
							$('.' + keyId).find('.resv-status-active').removeClass('on');
						}
	
						//버튼 이벤트
						$this.parents('tr').find('.bidStatus-td > p').attr('data-status', value).text(statusText);
						$keyEl.find('.bid-status-btns').removeClass('on');
						$keyEl.find('.bid-status-Inactives').addClass('on');
						if (value != 'Inactive') {
							$this.addClass('on');
							$this.next().removeClass('on');
						}
						if (value == 'Inactive') {
							$keyEl.find('.bid-cur-option').prop('disabled', false);
							$keyEl.find('.bid-rank-option, .bid-max-option, .bid-min-option, .bid-cpa-option, .target_btn').prop('disabled', true);
						} else if (value == 'Active') {
							$keyEl.find('.bid-cur-option, .bid-cpa-option, .target_btn').prop('disabled', true);
							$keyEl.find('.bid-rank-option, .bid-max-option, .bid-min-option').prop('disabled', false);
						} else if (value == 'CpaActive') {
							$keyEl.find('.bid-cur-option, .bid-rank-option, .target_btn').prop('disabled', true);
							$keyEl.find('.bid-cpa-option, .bid-max-option, .bid-min-option').prop('disabled', false);
						} else if (value == 'OppActive') {
							$keyEl.find('.bid-cur-option, .bid-rank-option, .bid-cpa-option').prop('disabled', true);
							$keyEl.find('.target_btn, .bid-max-option, .bid-min-option').prop('disabled', false);
						}
					} else {
						return;
					}
				} else {
					return;
				}
			} else if (allType == 'AllBidStatus') {
				//전체 상태 값 변경
				if (confirm("변경 하시겠습니까?") == true) {
					ajaxType = 'PUT';
					updateType = 'type3';
					$this.find('tr').each(function (i) {
						var $this = $(this);
						var check = $this.find("input[type='checkbox']").prop('checked');
						if (check == true) {
							var onCheck = $(this).find('.bidStatus-btn-area .bid-status-' + condition).hasClass('on');
							if (onCheck != true) {
								var value = $(this).find('.bidStatus-td > p').attr('data-status');
								var key = $this.attr('data-id');
								var name = $this.attr('data-name');
								multi = true;
	
								keywords = faListData[key];
								$this.find('.bidStatus-btn-area button').removeClass('on');
								if (condition == 'Active') {
									$this.find('.bid-status-Active').addClass('on');
									keywords['bid_status'] = 'Active';
								} else {
									$this.find('.bid-status-Inactive').addClass('on');
									keywords['bid_status'] = 'Inactive';
								}
								keywords['before_bid_status'] = value;
	
								listArray.push(keywords);
							}
						}
					});
					changeKey.push('bid_status');
				} else {
					return;
				}
				if (multi == false) {
					alert('변경 할 수 있는 키워드가 없습니다.');
				}
			} else if (type == 'curBid') {
				//입찰가를 변경
				if (confirm('입찰가를 반영하시겠습니까?') == true) {
					ajaxType = 'POST';
					updateType = 'type1';
					var key = $this.parent().find('input').attr('name');
					var value = favoriteFunc.bidAmtRound($this.parent().find('input').val());
					if (70 <= value) {
						changeKey.push(key);
						keywords['before_bid_amt'] = keywords[key];
						keywords[key] = value;
						if (bidChangeList[keyId] != undefined) {
							bidChangeList[keyId]['cur_bid_amt'] = value;
						}
	
						listArray.push(keywords);
	
						$(subEl).find('.bid_icon').show();
						$(subEl).find('.bid_price').show();
						$(subEl).find('.active-btn-area').hide();
						//입찰가 변경 저장
						$this.parents('.bid_wrap').find('.bid_price').text(numberWithCommas(value));
						$this.parents('.bid_wrap').find('.bid_price').addClass('effect');
						setTimeout(function () {
							$this.parents('.bid_wrap').find('.bid_price').removeClass('effect');
						}, 500);
					} else {
						alert('입찰가는 70원 미만으로 설정할 수 없습니다.');
						return;
					}
				} else {
					return;
				}
			} else if (type == 'bidMax') {
				//최대 입찰가 설정
				if (confirm("변경 하시겠습니까?") == true) {
					ajaxType = 'PUT';
					updateType = 'type3';
					var key = $this.parent().find('input').attr('name');
					var value = Number($this.parent().find('input').val());
					var bidMin = keywords['min_bid_amt'];
	
					var bidMaxFunc = function bidMaxFunc(amt) {
	
						changeKey.push(key);
						keywords['before_max_bid_amt'] = keywords[key];
						keywords[key] = value;
	
						listArray.push(keywords);
	
						$(subEl).find('.bid_icon').show();
						$(subEl).find('.bid_price').show();
						$(subEl).find('.active-btn-area').hide();
						$this.parents('.bid_wrap').find('.bid_price').text(numberWithCommas(value));
						$this.parents('.bid_wrap').find('.bid_price').addClass('effect');
						setTimeout(function () {
							$this.parents('.bid_wrap').find('.bid_price').removeClass('effect');
						}, 500);
					};
	
					if (0 < bidMin) {
						if (value > bidMin) {
							if (0 == value || 70 <= value) {
								bidMaxFunc();
							} else {
								alert('최대입찰가는 70원 미만으로 설정할 수 없습니다.');
								return;
							}
						} else {
							alert('최대입찰가는 최소입찰가보다 작거나 동일하게 설정할 수 없습니다.');
							return;
						}
					} else {
						if (0 == value || 70 <= value) {
							bidMaxFunc();
						} else {
							alert('최대입찰가는 70원 미만으로 설정할 수 없습니다.');
							return;
						}
					}
				} else {
					return;
				}
			} else if (type == 'bidMin') {
				//최소 입찰가 설정
				if (confirm("변경 하시겠습니까?") == true) {
					ajaxType = 'PUT';
					updateType = 'type3';
					var key = $this.parent().find('input').attr('name');
					var value = $this.parent().find('input').val();
					var bidMax = keywords['max_bid_amt'];
	
					var bidMinFunc = function bidMinFunc(amt) {
	
						changeKey.push(key);
						keywords['before_min_bid_amt'] = keywords[key];
						keywords[key] = value;
	
						listArray.push(keywords);
	
						$(subEl).find('.bid_icon').show();
						$(subEl).find('.bid_price').show();
						$(subEl).find('.active-btn-area').hide();
						$this.parents('.bid_wrap').find('.bid_price').text(numberWithCommas(value));
						$this.parents('.bid_wrap').find('.bid_price').addClass('effect');
						setTimeout(function () {
							$this.parents('.bid_wrap').find('.bid_price').removeClass('effect');
						}, 500);
					};
	
					if (0 < bidMax) {
						if (value < bidMax) {
							if (0 == value || 70 <= value) {
								bidMinFunc();
							} else {
								alert('최소입찰가는 70원 미만으로 설정할 수 없습니다.');
								return;
							}
						} else {
							alert('최소입찰가는 최대입찰가를 초과하거나 동일하게 설정할 수 없습니다.');
							return;
						}
					} else {
						if (0 == value || 70 <= value) {
							bidMinFunc();
						} else {
							alert('최소입찰가는 70원 미만으로 설정할 수 없습니다.');
							return;
						}
					}
				} else {
					return;
				}
			} else if (type == 'goalCpa') {
				//최소 입찰가 설정
				if (confirm("변경 하시겠습니까?") == true) {
					ajaxType = 'PUT';
					updateType = 'type3';
					var key = $this.parent().find('input').attr('name');
					var value = favoriteFunc.bidAmtRound($this.parent().find('input').val());
	
					changeKey.push(key);
					keywords['before_goal_cpa_amt'] = keywords[key];
					keywords[key] = value;
	
					listArray.push(keywords);
	
					$(subEl).find('.bid_icon').show();
					$(subEl).find('.bid_price').show();
					$(subEl).find('.active-btn-area').hide();
					$this.parents('.bid_wrap').find('.bid_price').text(numberWithCommas(value));
					$this.parents('.bid_wrap').find('.bid_price').addClass('effect');
					setTimeout(function () {
						$this.parents('.bid_wrap').find('.bid_price').removeClass('effect');
					}, 500);
				} else {
					return;
				}
			} else if (allType == 'bidDelete') {
				//즐겨찾기 삭제
				if (confirm('선택된 키워드를 삭제하시겠습니까?') == true) {
					ajaxType = 'DELETE';
					updateType = 'type3';
					$this.find('tr').each(function () {
						var $this = $(this);
						var key = $this.attr('data-id');
						var $this2 = $('#bid-list-body-2').find('.' + key);
						var check = $this.find("input[type='checkbox']").prop('checked');
						if (check == true) {
							keywords = faListData[key];
							$(this).remove();
							$this2.remove();
	
							listArray.push(keywords);
						}
					});
				} else {
					return;
				}
			} else if (type == 'status') {
				//ON/OFF 상태값변경
				ajaxType = 'POST';
				updateType = 'type2';
				var check = $this.hasClass('on');
				if (check != true) {
					if (confirm("변경 하시겠습니까?") == true) {
						var thisId = $this.attr('data-status');
						var key = $this.attr('data-name');
						var value;
						multi = true;
						$this.parent('.status-btn-area').find('button').each(function () {
							var check = $(this).hasClass('on');
							if (check == true) {
								value = $(this).attr('data-status');
							}
						});
						$this.parent('.status-btn-area').find('button').removeClass('on');
						$this.addClass('on');
						keywords['before_status'] = value;
						keywords[key] = thisId;
						listArray.push(keywords);
					} else {
						return;
					}
				} else {
					return;
				}
			} else if (allType == 'status') {
				//전체 상태 값 변경
				if (confirm("변경 하시겠습니까?") == true) {
					ajaxType = 'POST';
					updateType = 'type2';
					$this.find('tr').each(function (i) {
						var $this = $(this);
						var check = $this.find("input[type='checkbox']").prop('checked');
						if (check == true) {
							var onCheck = $(this).find('.status-btn-area .status-' + condition).hasClass('on');
							if (onCheck != true) {
								var value = $(this).find('.status-btn-area .on').attr('data-status');
								var key = $this.attr('data-id');
								var name = $this.attr('data-name');
								multi = true;
	
								keywords = faListData[key];
								$this.find('.status-btn-area button').removeClass('on');
								if (condition == 'on') {
									$this.find('.status-on').addClass('on');
									keywords['status'] = 'ELIGIBLE';
								} else {
									$this.find('.status-off').addClass('on');
									keywords['status'] = 'PAUSED';
								}
								keywords['before_status'] = value;
	
								listArray.push(keywords);
							}
						}
					});
				} else {
					return;
				}
				if (multi == false) {
					alert('변경 할 키워드를 선택해주세요.');
				}
			} else if (type == 'opp') {
				if (confirm("저장하시겠습니까?") == true) {
					var keyId = $this.attr('data-id');
					var keywords = faListData[keyId];
					//순위변경
					ajaxType = 'PUT';
					updateType = 'type3';
					var $urlEl = $('#target-url');
					var $gapEl = $('#target-gap');
					var $rankEl = $('#target-rank');
					var urlKey = $urlEl.attr('name');
					var gapKey = $gapEl.attr('name');
					var rankKey = $rankEl.attr('name');
					var setKey = [urlKey, gapKey, rankKey];
					var urlVal = $urlEl.val();
					var gapVal = $gapEl.val();
					var rankVal = $rankEl.val();
					if (urlVal == '' || rankVal == '') {
						alert('경쟁사 표시 URL을 입력하세요.');
						$urlEl.focus();
						return;
					} else {
						if (0 < setKey.length) {
							for (var i = 0; i < setKey.length; i++) {
								changeKey.push(setKey[i]);
							}
						}
						keywords['before_opp_site'] = keywords[urlKey] == null ? '' : keywords[urlKey];
						keywords[urlKey] = urlVal;
						keywords['before_opp_gap'] = keywords[gapKey] == null ? 0 : keywords[gapKey];
						keywords[gapKey] = Number(gapVal);
						keywords['before_opp_goal_rank'] = keywords[rankKey] == null ? 0 : keywords[rankKey];
						keywords[rankKey] = Number(rankVal);
						listArray.push(keywords);
					}
				} else {
					return;
				}
			} else if (type == 'schedule' || type == 'scheduleAll') {
				if (confirm("저장하시겠습니까?") == true) {
					ajaxType = 'PUT';
					updateType = 'type4';
					var $addList = $('#add-key-list');
					var ajaxGate = true;
					var kwdKeys = [];
					if (type == 'schedule') {
						var kwdKey = $this.attr('data-key');
						var kwdObj = {
							"kwd_id": kwdKey
						};
						kwdKeys.push(kwdObj);
					} else {
						var messageCount = 0;
						$addList.find('li').each(function () {
							var $this = $(this);
							var kwdKey = $this.attr('data-kwd');
							var kwdObj = {
								"kwd_id": kwdKey
							};
							//모바일 및 목표순위 체크
							var deviceCheck = faListData[kwdKey].target;
							var clickDataType = bidScheAllData[bidScheAllClickKwd].bid_schedule_types;
							var pushGate = true;
							var clickDataKey = Object.keys(clickDataType);
							for (var i = 0; i < clickDataKey.length; i++) {
								var goalRank = clickDataType[clickDataKey[i]].goal_rank;
								if (deviceCheck == 'mobile' && goalRank > 15) {
									if (messageCount === 0) {
										alert('설정 목표순위가 15이상 입니다. 모바일 키워드는 적용이 제외됩니다.');
									}
									messageCount++;
									pushGate = false;
								}
							}
	
							if (pushGate == true) {
								kwdKeys.push(kwdObj);
							}
							if (kwdKeys.length == 0) {
								ajaxGate = false;
							}
						});
					}
	
					if (ajaxGate === false) {
						alert('변경 가능한 키워드가 없습니다.');
						return false;
					}
	
					var schKwd = kwdKeys;
					var $gridBox = $('.grid-box');
					var $gridCell = $('.box-grid');
					var $schList = $('.add-sch-list');
					var schedulData = '';
					var colorBox = {};
	
					$gridBox.find('.box-line').each(function () {
						var $this = $(this);
						$this.find('.box-grid').each(function () {
							var $this = $(this);
							var colorData = $this.attr('data-color');
							if (colorData == '' || colorData == null) {
								colorData = 0;
							}
							schedulData += ',' + String(colorData);
						});
					});
	
					schedulData = schedulData.replace(',', '');
					if (type == 'schedule') {
						$schList.find('.add-type-btn').each(function () {
							var $this = $(this);
							var dataNm = $this.attr('data-nm');
							var dataType = $this.attr('data-type');
							var dataRank = Number($this.attr('data-rank'));
							var dataMax = $this.attr('data-max');
							var dataMin = $this.attr('data-min');
							var dataCpa = $this.attr('data-cpa');
							var dataColor = $this.attr('data-color');
							if (dataType == 'Active') {
								colorBox[dataColor] = {
									"nm": dataNm,
									"bid_status": dataType,
									"goal_rank": dataRank,
									"max_bid_amt": dataMax,
									"min_bid_amt": dataMin,
									"goal_cpa": 0
								};
							} else {
								colorBox[dataColor] = {
									"nm": dataNm,
									"bid_status": dataType,
									"goal_rank": 0,
									"max_bid_amt": dataMax,
									"min_bid_amt": dataMin,
									"goal_cpa": dataCpa
								};
							}
						});
					} else {
						colorBox = bidScheAllData[bidScheAllClickKwd].bid_schedule_types;
					}
					_loading.AjaxLoading.pageLoading('time');
					setTimeout(function () {
						favoriteFunc.favoriteSubListData(advSubId, 'sync');
					}, 1000);
				} else {
					return;
				}
			} else if (type == 'rate' || type == 'rateCpa' || type == 'rateAll') {
				if (confirm("저장하시겠습니까?") == true) {
					ajaxType = 'PUT';
					updateType = 'type5';
					var $addList = $('#add-key-list');
					var kwdKeys = [];
					if (type.indexOf('All') === -1) {
						var kwdKey = $this.attr('data-key');
						var target = faListData[kwdKey].target;
						var kwdObj = {
							"kwd_id": kwdKey,
							"target": target
						};
						kwdKeys.push(kwdObj);
						var bidType = type.indexOf('Cpa') === -1 ? 'rank' : 'cpa';
					} else {
						$addList.find('li').each(function () {
							var $this = $(this);
							var kwdKey = $this.attr('data-kwd');
							var target = faListData[kwdKey].target;
							var kwdObj = {
								"kwd_id": kwdKey,
								"target": target
							};
							kwdKeys.push(kwdObj);
						});
	
						var bidType = $('.rate-tab-box').find('.active').attr('data-name');
					}
	
					var rateKwd = kwdKeys;
					var rateType = $('#rate-type select').val();
					var tables = bidType === 'rank' ? '#goal-rate' : '#cpa-rate';
					var eachs = function eachs(el) {
						var returnData = {};
						$(el).each(function (i) {
							if (0 < i) {
								var thisVal = Number($(this).find('input').val());
								var value = thisVal === '' ? 0 : thisVal;
								returnData[i] = value;
							}
						});
						return JSON.stringify(returnData);
					};
					//증액
					var incData = eachs(tables + ' tbody .inc td');
					//감액
					var decData = eachs(tables + ' tbody .dec td');
	
					_loading.AjaxLoading.pageLoading('time');
					setTimeout(function () {
						favoriteFunc.favoriteSubListData(advSubId, 'sync');
					}, 1000);
				} else {
					return;
				}
			}
	
			if (updateType == 'type1') {
				var request = {
					"adv_id": Number(advId),
					"update_fields": changeKey,
					"keywords": listArray
				};
				var dataApi = _dataUrl.dataUrl.favoriteAPI(ajaxType, 'update_bid');
				_ajaxForm.ajaxFrame.ajaxDataCall(ajaxType, dataApi, 'json', true, favoriteFunc.favoriteChangeCallBack, request);
			} else if (updateType == 'type2') {
				if (multi == true) {
					var request = {
						"adv_id": Number(advId),
						"update_fields": changeKey,
						"keywords": listArray
					};
					var dataApi = _dataUrl.dataUrl.favoriteAPI(ajaxType, 'updateStatus');
					_ajaxForm.ajaxFrame.ajaxDataCall(ajaxType, dataApi, 'json', true, favoriteFunc.favoriteChangeCallBack, request);
					multi = false;
				} else {
					var request = {
						"adv_id": Number(advId),
						"update_fields": changeKey,
						"keywords": listArray
					};
				}
			} else if (updateType == 'type3') {
				var request = {
					"adv_id": Number(advId),
					"update_fields": changeKey,
					"keywords": listArray
				};
			} else if (updateType == 'type4') {
				var request = {
					"update_schedule": {
						"bid_schedule_types": colorBox,
						"bid_schedule": schedulData
					},
					"bid_schedules": schKwd
				};
				var dataApi = _dataUrl.dataUrl.favoriteAPI(ajaxType, 'schedule');
				_ajaxForm.ajaxFrame.ajaxDataCall(ajaxType, dataApi, 'json', true, favoriteFunc.favoriteChangeCallBack, request);
			} else if (updateType == 'type5') {
				var request = {
					"update_bid_variation": {
						"increse_json": incData,
						"decrese_json": decData,
						"type": rateType,
						"bid_type": bidType
					},
					"bid_variations": rateKwd
				};
	
				var dataApi = _dataUrl.dataUrl.favoriteAPI(ajaxType, 'rate');
				_ajaxForm.ajaxFrame.ajaxDataCall(ajaxType, dataApi, 'json', true, favoriteFunc.favoriteChangeCallBack, request);
			}
			if (updateType == 'type3') {
				var dataApi = _dataUrl.dataUrl.favoriteAPI(ajaxType, 'update');
				_ajaxForm.ajaxFrame.ajaxDataCall(ajaxType, dataApi, 'json', true, favoriteFunc.favoriteChangeCallBack, request);
			}
		},
	
		//리스트 상태 키워드 값 데이터
		favoriteListStatusData: function favoriteListStatusData(data) {
			var statusKey = Object.keys(statusKwd);
			var statusValue = statusKey.map(function (key) {
				return statusKwd[key];
			});
			var param = "?na_customer=" + advKey + "&na_kwd_sers=";
			if (0 < statusKey.length) {
				for (var i = 0; i < statusKey.length; i++) {
					if (1 > i) {
						param += statusValue[i];
					} else {
						param += ',' + statusValue[i];
					}
				}
				var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'keyStatus', param);
				_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', false, favoriteFunc.favoriteStatusCallBack);
			}
		},
	
		//전체 리스트 상태 데이터
		favoriteStatusChangeData: function favoriteStatusChangeData(thisEl) {
			var $this = $(thisEl);
			var thisId = $this.attr('data-id');
			$this.parent('.on_off_btn').find('button').removeClass('on');
			$this.addClass('on');
		},
	
		//키워드 이동 팝업
		favoriteKeywordMovePop: function favoriteKeywordMovePop() {
			var $this = $('#bid-list-body-1');
			var keywordList = [];
			moveKeywordData = {};
			$this.find('tr').each(function () {
				var $this = $(this);
				var check = $this.find("input[type='checkbox']").prop('checked');
				if (check == true) {
					var key = $this.attr('data-id');
					var checklist = faListData[key];
					keywordList.push(checklist);
				}
			});
			if (0 < keywordList.length) {
				var subListData = alwaysFunc.favoriteSubListSave();
				favoriteFunc.favoriteKeywordMoveGroupCallBack(subListData, keywordList);
			} else {
				alert('키워드를 선택해 주세요.');
				return false;
			}
		},
	
		//즐겨찾기 테이블 제어 필터
		favoriteFilterData: function favoriteFilterData(key) {
			var listKey = [];
			$('#bid-list-body-1').find('tr').each(function () {
				if ($(this).hasClass('hide') != true) {
					listKey.push($(this).attr('data-id'));
				}
			});
			var data = {};
			var forKey = ['status', 'target', 'campaign_nm', 'adgroup_nm', 'bid_status', 'bid_status', 'bid_status', 'bid_status', 'resv_status'];
			var keyArray = ['status', 'target', 'campaign_nm', 'adgroup_nm', 'bid_status', 'bid_status_a', 'bid_status_b', 'bid_status_c', 'resv_status'];
			var dataPushs = function dataPushs(keyI) {
				for (var i2 = 0; i2 < listKey.length; i2++) {
					if (keyFilter != faListData[listKey[i2]][forKey[keyI]]) {
						data[faListData[listKey[i2]][forKey[keyI]]] = [];
					}
					keyFilter = faListData[listKey[i2]][forKey[keyI]];
				}
				for (var i3 = 0; i3 < listKey.length; i3++) {
					data[faListData[listKey[i3]][forKey[keyI]]].push(listKey[i3]);
				}
			};
			for (var i = 0; i < keyArray.length; i++) {
				var keyFilter = null;
				if (key == 'status') {
					var dataCheck = Object.keys(statusData);
					if (0 < dataCheck.length) {
						dataPushs(i);
					}
				} else if (key == keyArray[i]) {
					dataPushs(i);
				}
			}
			var dataKeyChange = function dataKeyChange(deleteKey, activeKey) {
				for (var i = 0; i < deleteKey.length; i++) {
					if (data[deleteKey[i]] != undefined) {
						for (var idx = 0; idx < data[deleteKey[i]].length; idx++) {
							if (data[activeKey] == undefined) {
								data[activeKey] = new Array();
							}
							data[activeKey].push(data[deleteKey[i]][idx]);
						}
						delete data[deleteKey[i]];
					}
				}
			};
	
			var customKeys = ['bid_status', 'bid_status_a', 'bid_status_b', 'bid_status_c'];
			for (var str = 0; str < customKeys.length; str++) {
				var deleteKey = str <= 1 ? ['CpaActive', 'OppActive'] : str == 2 ? ['Active', 'OppActive'] : ['Active', 'CpaActive'];
				var activeKey = str == 0 ? 'Active' : 'Inactive';
				if (key == customKeys[str]) {
					dataKeyChange(deleteKey, activeKey);
				}
			}
	
			tableFilterData['data'] = data;
			tableFilterData['key'] = key;
			favoriteFunc.favoriteFilterCallBack(data, key);
		},
	
		//즐겨찾기 리스트 새로고침
		favoriteListReData: function favoriteListReData() {
			var searchKey = '';
			if (advSubId != null) {
				searchKey = 'bid_favorite_id=' + advSubId;
				// if(searchData != null) {
				// 	searchKey += '&' + searchData;
				// }
			} else {
				searchKey = 'adv_id=' + advId;
			}
			var param = '?' + searchKey;
			_loading.AjaxLoading.pageLoading();
			var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'sort', param);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteListCallBack);
		},
	
		//즐겨찾기 입찰가 변경 팝업
		favoriteBidAllChangePopUp: function favoriteBidAllChangePopUp() {
			bidChangeList = {};
			var keywordList = [];
			if (historyKey != null) {
				var keywords = faListData[historyKey];
				keywordList.push(keywords);
				var subListData = alwaysFunc.favoriteSubListSave();
				favoriteFunc.favoriteBidAllChangePopUpCallBack(subListData, keywordList);
				historyKey = null;
			} else {
				var $this = $('#bid-list-body-1');
				var $list2 = $('#bid-list-body-2');
				$this.find('tr').each(function () {
					var $this = $(this);
					var key = $this.attr('data-id');
					var $this2 = $list2.find('.' + key);
					var bidStatusCheck = $this.find('.bidStatus-td > p').attr('data-status');
					var check = $this.find("input[type='checkbox']").prop('checked');
					//&& bidStatusCheck == 'Inactive'
					if (check == true) {
						var checklist = faListData[key];
						keywordList.push(checklist);
					}
				});
				var subListData = alwaysFunc.favoriteSubListSave();
				favoriteFunc.favoriteBidAllChangePopUpCallBack(subListData, keywordList);
			}
		},
	
		//즐겨찾기 입찰가 변경
		favoriteBidUpdateData: function favoriteBidUpdateData() {
			if (confirm('선택한 키워드의 입찰가를 변경하시겠습니까?') == false) {
				return;
			}
			var request = {
				adv_id: advId,
				keywords: new Array()
			};
			var dataApi = _dataUrl.dataUrl.favoriteAPI('POST', 'update_bid');
			_ajaxForm.ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, biddingFunc.afterSaveCurrentAmt, sendData);
		},
	
		//즐겨찾기 동기화
		favoriteNaSyncData: function favoriteNaSyncData() {
			if (advSubId != null) {
				if (confirm('작업시간이 다소 소요됩니다. 동기화 하시겠습니까?') == true) {
					var param = '?adv_id=' + advId + '&favorite_id=' + advSubId;
					var dataApi = _dataUrl.dataUrl.favoriteAPI('POST', 'naSync', param);
					_loading.AjaxLoading.pageLoading('time');
					_ajaxForm.ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, favoriteFunc.favoriteNaSyncCallBack);
				} else {
					return;
				}
			}
		},
	
		//즐겨찾기 일괄 설정 데이터
		favoriteBidSetData: function favoriteBidSetData(type, setType) {
			var keywordList = [];
			var subListData = alwaysFunc.favoriteSubListSave();
			var $this = $('#bid-list-body-1');
			var $list2 = $('#bid-list-body-2');
			var reviewOnEl = '#max-bid-input, #goal-cpa, #target-rank, #target-url';
			var comment = setType == 'bidSet' ? '설정 할 목표순위,최대입찰가를 입력해주세요.' : setType == 'bidCpa' ? '설정 할 목표CPA,최대입찰가를 입력해주세요.' : '설정 할 경쟁사URL,경쟁사대비목표순위,최대입찰가를 입력해주세요.';
			if (setType == 'bidSet') {
				//값
				var goalVal = $('#goal-rank-sel').val();
				var maxAmt = $('#max-bid-input').val();
				var minAmt = favoriteFunc.bidAmtRound($('#min-bid-input').val());
				var keyData = [goalVal, maxAmt, minAmt];
			} else if (setType == 'bidCpa') {
				//값
				var goalCpa = favoriteFunc.bidAmtRound($('#goal-cpa').val());
				var maxAmt = $('#max-bid-input').val();
				var minAmt = favoriteFunc.bidAmtRound($('#min-bid-input').val());
				var keyData = [goalCpa, maxAmt, minAmt];
			} else {
				//값
				var targetUrl = $('#target-url').val();
				var targetGap = Number($('#target-gap').val());
				var targetRank = Number($('#target-rank').val());
				var maxAmt = $('#max-bid-input').val();
				var minAmt = favoriteFunc.bidAmtRound($('#min-bid-input').val());
				var minAmt = favoriteFunc.bidAmtRound($('#min-bid-input').val());
				var keyData = [targetGap, maxAmt, minAmt, targetUrl, targetRank];
			}
	
			if (keyData[0] != '' || keyData[1] != '') {
				if (historyKey != null) {
					var keywords = faListData[historyKey];
					keywordList.push(keywords);
					if (type == 'view') {
						favoriteFunc.favoriteBidSetViewCallBack(subListData, keywordList, keyData, setType);
					} else {
						favoriteFunc.favoriteBidSetSaveCallBack(subListData, keywordList, keyData, setType);
					}
					historyKey = null;
				} else {
					$this.find('tr').each(function () {
						var $this = $(this);
						var key = $this.attr('data-id');
						var $this2 = $list2.find('.' + key);
						var bidStatusCheck = $this2.find('.bidStatus-td > p').attr('data-status');
						var check = $this.find("input[type='checkbox']").prop('checked');
						//&& bidStatusCheck != 'Inactive'
						if (check == true) {
							var checklist = faListData[key];
							keywordList.push(checklist);
						}
					});
					if (type == 'view') {
						favoriteFunc.favoriteBidSetViewCallBack(subListData, keywordList, keyData, setType);
					} else {
						favoriteFunc.favoriteBidSetSaveCallBack(subListData, keywordList, keyData, setType);
					}
					$(reviewOnEl).change(function () {
						var thisVal = $(this).val();
						if (thisVal != '') {
							$('.preview_btn button').prop('disabled', false);
						} else {
							$('.preview_btn button').prop('disabled', true);
						}
					});
				}
			} else {
				alert(comment);
			}
		},
	
		//즐겨찾기 이력 팝업
		favoriteHistoryPop: function favoriteHistoryPop(thisKey) {
			historyKey = thisKey;
			var param = '?na_account_ser=' + advKey + '&kwd_id=' + thisKey;
			var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'history', param);
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteHistoryPopCallBack);
			setTimeout(function () {
				$("#fa-date-picker").dateRangeCustomPicker({ single: false, autoClose: false });
			}, 500);
		},
	
		//즐겨찾기 이력 검색
		favoriteHistorySearch: function favoriteHistorySearch() {
			var $search = $('#create-date');
			var dateVal = $search.val();
			if (dateVal != '') {
				var dateReplace = dateVal.replace(/-/gi, "");
				var dateSplit = dateReplace.split('~');
				var param = '?na_account_ser=' + advKey + '&kwd_id=' + historyKey;
				if (dateSplit[0] == dateSplit[1]) {
					param += '&to_date=' + dateSplit[0];
				} else {
					param += '&to_date=' + dateSplit[0] + '&from_date=' + dateSplit[1];
				}
				var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'history', param);
				_loading.AjaxLoading.pageLoading();
				_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteHistoryPopCallBack);
			}
		},
		//즐겨찾기 차트 데이터(검색기능 동일)
		favoriteChartData: function favoriteChartData(dataType, thisEl, clickType) {
			if (clickType == 'search') {
				var $this = $(thisEl);
				var $date = $('#create-date');
				var type = $this.attr('data-type');
				var kwdId = $this.attr('data-key');
				var date = $date.val();
				if (date != '') {
					var dateSplit = date.split('~');
					var firstDate = dateSplit[0];
					var endDate = dateSplit[1];
				}
			} else {
				var type = dataType[0];
				var kwdId = dataType[1];
				var d = new Date();
				var yy = d.getFullYear();
				var mm = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
				var dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
				var firstDate = yy + '-' + mm + '-' + dd;
				var chartTypeActive = function chartTypeActive(type) {
					$('.chart-type-btn button').removeClass('on').attr('data-key', kwdId);
					$('.chart-type-btn .' + type).addClass('on');
					$('#create-date').attr('placeholder', firstDate + '~' + firstDate);
				};
				var chartSearchTypes = function chartSearchTypes() {
					var $searchBtn = $('#chart-search-btn, #chart-excel-btn');
					$searchBtn.attr('data-type', type).attr('data-key', kwdId);
				};
				chartSearchTypes();
				chartTypeActive(type);
				setTimeout(function () {
					$("#fa-date-picker.chart-date").dateRangeCustomPicker({ single: false, autoClose: false });
				}, 500);
			}
	
			var dataApiFilter = function dataApiFilter(type) {
				var param = type + '/?kwd_id=' + kwdId;
				if (firstDate == endDate || endDate == undefined) {
					param += '&start_date=' + firstDate;
				} else {
					param += '&start_date=' + firstDate + '&end_date=' + endDate;
				}
				var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'chart', param);
				return dataApi;
			};
			var charts = type == 'chart1' ? 'rank' : type == 'chart2' ? 'bid' : 'cpa';
			$('#chart-excel-btn').attr('data-type', charts);
			var dataApi = dataApiFilter(charts);
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteChartCallBack, '', type);
		},
		//차트 엑셀 다운로드
		favoriteChartExcelData: function favoriteChartExcelData(thisEl) {
			if (chartDataCheck == true) {
				if (confirm('통계 데이터를 다운로드 하시겠습니까?') == true) {
					var $this = $(thisEl);
					var kwdId = $this.attr('data-key');
					var type = $this.attr('data-type');
					var $date = $('#create-date');
					var date = $date.val();
					var param = '?kwd_id=' + kwdId + '&type=' + type;
					if (date != '') {
						var dateSplit = date.split('~');
						var firstDate = dateSplit[0];
						var endDate = dateSplit[1];
					} else {
						var d = new Date();
						var yy = d.getFullYear();
						var mm = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
						var dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
						var firstDate = yy + '-' + mm + '-' + dd;
					}
					var dataApiFilter = function dataApiFilter() {
						if (firstDate == endDate || endDate == undefined) {
							param += '&start_date=' + firstDate;
						} else {
							param += '&start_date=' + firstDate + '&end_date=' + endDate;
						}
						var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'chartExcel', param);
						return dataApi;
					};
					var dataApi = dataApiFilter();
					window.open(dataApi, 'zero_frame');
				}
			} else {
				alert('다운받을 통계데이터가 없습니다.');
			}
		},
		//예약 데이터
		favoriteScheDuleData: function favoriteScheDuleData(type) {
			if (type == 'multi') {
				var favoriteId = $(groupSubId).val();
				var param = '?bid_favorites_id=' + favoriteId;
				var callBack = favoriteFunc.favoriteBidSetPopCallBack5;
			} else {
				$('#bid-set-save').attr('data-key', type);
				var kwdArray = [type];
				var param = '?kwd_id=' + type;
				var callBack = favoriteFunc.favoriteBookingCallBack;
			}
			var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'schedule', param);
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, callBack, '', kwdArray);
		},
	
		//증감율 데이터(순위)
		favoriteRateData: function favoriteRateData(type) {
			var bidSaveBtn = $('#bid-set-save');
			var rateType = $('#rate-type select').val();
			if (type == 'change') {
				var kwd = bidSaveBtn.attr('data-key');
				var param = '?kwd_id=' + kwd + '&type=' + rateType + '&bid_type=rank';
				if (rateType !== 'pct') {
					$('.default-btn').hide();
				} else {
					$('.default-btn').show();
				}
			} else if (type == 'default') {
				var kwd = bidSaveBtn.attr('data-key');
				var curBidAmt = faListData[kwd].cur_bid_amt;
				var param = '?kwd_id=default&bid_type=rank&type=pct&cur_bid_amt=' + curBidAmt;
			} else {
				var param = '?kwd_id=' + type + '&bid_type=rank';
				$('#rate-type select').attr('data-key', type);
				bidSaveBtn.attr('data-key', type);
			}
			var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'rate', param);
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteRateCallBack, '', type);
		},
		//증감율 데이터(CPA)
		favoriteRateCpaData: function favoriteRateCpaData(type) {
			var bidSaveBtn = $('#bid-set-save');
			var rateType = $('#rate-type select').val();
			if (type == 'change') {
				var kwd = bidSaveBtn.attr('data-key');
				var param = '?kwd_id=' + kwd + '&type=' + rateType + '&bid_type=cpa';
				if (rateType !== 'pct') {
					$('.default-btn').hide();
				} else {
					$('.default-btn').show();
				}
			} else if (type == 'default') {
				var kwd = bidSaveBtn.attr('data-key');
				var curBidAmt = faListData[kwd].cur_bid_amt;
				var param = '?kwd_id=default&bid_type=cpa&type=pct&cur_bid_amt=' + curBidAmt;
			} else {
				var param = '?kwd_id=' + type + '&bid_type=cpa';
				$('#rate-type select').attr('data-key', type);
				bidSaveBtn.attr('data-key', type);
			}
	
			var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'rate', param);
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteRateCallBack, '', type);
		},
	
		//Data or PopUpFunction (End)
	
	
		//CallBack Functions
		favoriteListCallBack: function favoriteListCallBack(data) {
			faListData = data.data;
			var listKeys = Object.keys(faListData);
			var listValues = listKeys.map(function (key) {
				return faListData[key];
			});
			var listHtml1 = '';
			var listHtml2 = '';
			var $count = $('#favorite-area .left_hit .allCount');
			var $list = $('.favorite_table_wrap');
			var $noList = $('.favorite_none_wrap');
			var $search = $('.main_search_wrap');
			var $listBodyPos = $('.position_table tbody');
			var $listBodyFull = $('.favorite_full_table tbody');
	
			//앞자리 0 추가
			var timeSupport = function timeSupport(time) {
				var supTime = time;
				var returnTime = supTime < 10 ? '0' + supTime : supTime;
				return returnTime;
			};
	
			//타임 계산 로직(연도,월,날짜,시간)
			var times = function times(time) {
				var date = new Date(time);
				var yy = date.getFullYear();
				var mm = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
				var dd = timeSupport(date.getDate());
				var hh = timeSupport(date.getHours());
				var mi = timeSupport(date.getMinutes());
				var ss = timeSupport(date.getSeconds());
				var returnDate = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mi + ':' + ss;
	
				return returnDate;
			};
	
			var changeNumber = function changeNumber(data) {
				return data == null ? 0 : data;
			};
	
			//상태값 초기화
			statusKwd = {};
			if (0 < listKeys.length) {
				for (var i = 0; i < listKeys.length; i++) {
	
					var curBtnId = '"#cur-save-btn-' + i + '"';
					var maxBtnId = '"#max-save-btn-' + i + '"';
					var minBtnId = '"#min-save-btn-' + i + '"';
					var goalBtnId = '"#goal-save-btn-' + i + '"';
	
					var msgActive = function msgActive(off) {
						return listValues[i].msg_cd == off ? 'point' : '';
					};
					var activeClass = listValues[i].bid_status != 'Inactive' && listValues[i].cur_bid_amt >= listValues[i].max_bid_amt ? 'point' : listValues[i].cur_bid_amt <= listValues[i].min_bid_amt ? 'point2' : '';
					var activeComment = listValues[i].bid_status != 'Inactive' && listValues[i].cur_bid_amt >= listValues[i].max_bid_amt ? '자동입찰의 최대입찰가에 도달하였습니다.' : listValues[i].cur_bid_amt <= listValues[i].min_bid_amt ? '자동입찰의 최소입찰가에 도달하였습니다.' : '';
					var target = listValues[i].target == null ? '동기화요청' : listValues[i].target == 'all' ? '전체' : listValues[i].target;
					var goalMaxRank = target == 'mobile' ? 15 : 25;
	
					//null일경우 0으로 반환 (추가시 changeKey에 키값 추가)
					var changeKey = ['cur_cpa_amt', 'rec_clk_rnk', 'cur_opp_rank', 'opp_gap', 'goal_cpa_amt', 'min_bid_amt', 'rank', 'rank_range', 'cur_opp_rank'];
					for (var idx = 0; idx < changeKey.length; idx++) {
						listValues[i][changeKey[idx]] = changeNumber(listValues[i][changeKey[idx]]);
					}
	
					statusKwd[listValues[i].kwd_id] = listValues[i].kwd_id;
	
					///////////
					//고정 테이블 //
					///////////
					listHtml1 += "<tr class='" + listValues[i].kwd_id + "' data-id='" + listValues[i].kwd_id + "'>";
					listHtml1 += "<td><input type='checkbox' class='list-check' id='campaign" + i + "' onclick='favoriteFunc.favoriteBtnOnOffEvent();'><label for='campaign" + i + "'></label></td>";
					listHtml1 += "<td>";
					listHtml1 += "<div class='on_off_btn status-btn-area status-ui-btn" + i + "'>";
					listHtml1 += "<button type='button' data-name='status' data-status='ELIGIBLE' data-type='status' class='status-on' onclick='favoriteFunc.favoriteBidChangeData(this);'>ON</button>";
					listHtml1 += "<button type='button' data-name='status' data-status='PAUSED' data-type='status' class='status-off on' onclick='favoriteFunc.favoriteBidChangeData(this);'>OFF</button>";
					listHtml1 += "</div>";
					listHtml1 += "</td>";
					listHtml1 += "<td>" + target + "</td>";
					listHtml1 += "<td align='left'>" + listValues[i].campaign_nm + "</td>";
					listHtml1 += "<td align='left'><span class='group-td " + msgActive('group_off') + "' data-comment='광고그룹 OFF'>" + listValues[i].adgroup_nm + "</span></td>";
					listHtml1 += "<td class='keyword_contents'>";
					if (target == 'mobile') {
						listHtml1 += "<a href='https://m.search.naver.com/search.naver?query=" + listValues[i].kwd_nm + "' target='_blank'></a>";
					} else {
						listHtml1 += "<a href='https://search.naver.com/search.naver?&query=" + listValues[i].kwd_nm + "' target='_blank'></a>";
					}
					listHtml1 += "<div class='update-time'>";
					listHtml1 += "<span class='date-text'><div class='kwd-td" + msgActive('kwd_off') + "' data-comment='키워드 OFF'>" + listValues[i].kwd_nm + "</div></span>";
					listHtml1 += "<span class='time-icon'><img src='/image/common/keyword_watch.png' alt='시계아이콘'></span>";
					listHtml1 += "<p class='time-text'>" + times(listValues[i].updated_at);+"</p>";
					listHtml1 += "</div>";
					listHtml1 += "</td>";
					listHtml1 += "</tr>";
	
					///////////////
					//이동 스크롤 테이블 //
					///////////////
					listHtml2 += "<tr class='" + listValues[i].kwd_id + "' data-id='" + listValues[i].kwd_id + "'>";
					//현재순위
					listHtml2 += "<td>" + listValues[i].rank + "/" + listValues[i].rank_range + "</td>";
	
					//현재 입찰가
					listHtml2 += "<td>";
					listHtml2 += "<div class='bid_wrap'>";
					listHtml2 += "<div class='bid_icon'>";
					if (listValues[i].bid_status == 'Inactive') {
						listHtml2 += "<button type='button' class='bid_01 bid-cur-option bidPop_btn' data-name='bidFavorite' data-key='" + listValues[i].kwd_id + "' onclick='layerPopup.open(this, this.id);'></button>";
						listHtml2 += "<button type='button' class='bid_02 list-btn-modify bid-cur-option'></button>";
					} else {
						listHtml2 += "<button type='button' class='bid_01 bid-cur-option' disabled></button>";
						listHtml2 += "<button type='button' class='bid_02 list-btn-modify bid-cur-option' disabled></button>";
					}
					listHtml2 += "</div>";
					listHtml2 += "<div class='bid_price cur_bid_price " + activeClass + "' data-comment='" + activeComment + "'>" + numberWithCommas(listValues[i].cur_bid_amt) + "</div>";
					listHtml2 += "<div class='active-btn-area hide'>";
					listHtml2 += "<form onsubmit='favoriteFunc.favoriteBidChangeData(" + curBtnId + "); return false;'>";
					listHtml2 += "<button id='cur-save-btn-" + i + "' type='button' data-type='curBid' onclick='favoriteFunc.favoriteBidChangeData(this);' class='list-btn-save'>저장</button>";
					listHtml2 += "<button type='button' class='list-btn-cancer'>취소</button>";
					listHtml2 += "<input type='number' name='cur_bid_amt' value='" + listValues[i].cur_bid_amt + "' class='bid-cur-input active-input-area'>";
					listHtml2 += "</form>";
					listHtml2 += "</div>";
					listHtml2 += "</div>";
					listHtml2 += "</td>";
	
					//입찰유형
					listHtml2 += "<td class='bidStatus-td'>";
					if (listValues[i].bid_status == 'Inactive') {
						listHtml2 += "<p data-status='Inactive'>수동</p>";
					} else if (listValues[i].bid_status == 'CpaActive') {
						listHtml2 += "<p data-status='" + listValues[i].bid_status + "'>목표CPA</p>";
					} else if (listValues[i].bid_status == 'OppActive') {
						listHtml2 += "<p data-status='" + listValues[i].bid_status + "'>경쟁사 타겟</p>";
					} else {
						listHtml2 += "<p data-status='" + listValues[i].bid_status + "'>목표순위</p>";
					}
					listHtml2 += "</td>";
	
					//최대 입찰가
					listHtml2 += "<td>";
					listHtml2 += "<div class='bid_wrap'>";
					listHtml2 += "<div class='bid_icon'>";
					if (listValues[i].bid_status == 'Inactive') {
						listHtml2 += "<button type='button' class='bid_02 list-btn-modify bid-max-option' disabled></button>";
					} else {
						listHtml2 += "<button type='button' class='bid_02 list-btn-modify bid-max-option'></button>";
					}
					listHtml2 += "</div>";
					listHtml2 += "<div class='bid_price max_bid_price'>" + numberWithCommas(listValues[i].max_bid_amt) + "</div>";
					listHtml2 += "<div class='active-btn-area hide'>";
					listHtml2 += "<form onsubmit='favoriteFunc.favoriteBidChangeData(" + maxBtnId + "); return false;'>";
					listHtml2 += "<button id='max-save-btn-" + i + "' type='button' data-type='bidMax' onclick='favoriteFunc.favoriteBidChangeData(this);' class='list-btn-save'>저장</button>";
					listHtml2 += "<button type='button' class='list-btn-cancer'>취소</button>";
					listHtml2 += "<input type='number' name='max_bid_amt' value='" + listValues[i].max_bid_amt + "' class='bid-max-input active-input-area'>";
					listHtml2 += "</form>";
					listHtml2 += "</div>";
					listHtml2 += "</div>";
					listHtml2 += "</td>";
	
					//최소 입찰가 설정
					listHtml2 += "<td>";
					listHtml2 += "<div class='bid_wrap'>";
					listHtml2 += "<div class='bid_icon'>";
					if (listValues[i].bid_status == 'Inactive') {
						listHtml2 += "<button type='button' class='bid_02 list-btn-modify bid-min-option' disabled></button>";
					} else {
						listHtml2 += "<button type='button' class='bid_02 list-btn-modify bid-min-option'></button>";
					}
					listHtml2 += "</div>";
					listHtml2 += "<div class='bid_price min_bid_price'>" + numberWithCommas(listValues[i].min_bid_amt) + "</div>";
					listHtml2 += "<div class='active-btn-area hide'>";
					listHtml2 += "<form onsubmit='favoriteFunc.favoriteBidChangeData(" + minBtnId + "); return false;'>";
					listHtml2 += "<button id='min-save-btn-" + i + "' type='button' data-type='bidMin' onclick='favoriteFunc.favoriteBidChangeData(this);' class='list-btn-save'>저장</button>";
					listHtml2 += "<button type='button' class='list-btn-cancer'>취소</button>";
					listHtml2 += "<input type='number' name='min_bid_amt' value='" + listValues[i].min_bid_amt + "' class='bid-min-input active-input-area'>";
					listHtml2 += "</form>";
					listHtml2 += "</div>";
					listHtml2 += "</div>";
					listHtml2 += "</td>";
	
					//목표순위 자동입찰
					listHtml2 += "<td class='add-td-1'>";
					listHtml2 += "<div class='on_off_btn status-btn-area status-ui-btn" + i + "'>";
					if (listValues[i].bid_status == 'Active') {
						listHtml2 += "<button id='check2-bidStatus' data-type='bidStatus' data-name='bid_status' data-status='Active' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on bid-status-btn bid-status-active bid-status-btns'>ON</button>";
						listHtml2 += "<button id='check-bidStatus' data-type='bidStatus' class='bid-status-btn bid-status-Inactive bid-status-btns bid-status-Inactives' data-name='bid_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>OFF</button>";
					} else {
						listHtml2 += "<button id='check2-bidStatus' data-type='bidStatus' class='bid-status-btn bid-status-active bid-status-btns' data-name='bid_status' data-status='Active' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>ON</button>";
						listHtml2 += "<button id='check-bidStatus' data-type='bidStatus' data-name='bid_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on bid-status-btn bid-status-Inactive bid-status-btns bid-status-Inactives'>OFF</button>";
					}
					listHtml2 += "</div>";
					listHtml2 += "</td>";
	
					//입찰 성공률
					// listHtml2 += 	"<td class='add-td-1'>" + listValues[i].bid_success_rate + "%</td>";
	
					listHtml2 += "<td class='add-td-1'>";
					if (listValues[i].bid_status != 'Active') {
						listHtml2 += "<select class='bid-rank-option' data-name='goal_rank' data-rank='" + listValues[i].goal_rank + "' data-type='bidRank' disabled onchange='favoriteFunc.favoriteBidChangeData(this);'>";
					} else {
						listHtml2 += "<select class='bid-rank-option' data-name='goal_rank' data-rank='" + listValues[i].goal_rank + "' data-type='bidRank' onchange='favoriteFunc.favoriteBidChangeData(this);'>";
					}
					for (var idx = 1; idx <= goalMaxRank; idx++) {
						if (listValues[i].goal_rank == idx) {
							listHtml2 += "<option value='" + idx + "' selected>" + idx + "</option>";
						} else {
							listHtml2 += "<option value='" + idx + "'>" + idx + "</option>";
						}
					}
					listHtml2 += "</select>";
					if (listValues[i].rank_var_status == 'saved') {
						listHtml2 += "<button type='button' class='rate_btn' data-key='" + listValues[i].kwd_id + "' data-name='rate' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/book_btn_on.png' alt='증감률아이콘'></button>";
					} else {
						listHtml2 += "<button type='button' class='rate_btn' data-key='" + listValues[i].kwd_id + "' data-name='rate' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/book_btn.png' alt='증감률아이콘'></button>";
					}
					// if((listValues[i].bid_status != 'CpaActive' && listValues[i].bid_status != 'Inactive') && (listValues[i].rank_range < listValues[i].goal_rank)) {
					// 	listHtml2 += 	"<div class='comment-box'>";
					// 	listHtml2 += 		"<span class='rank-ms-icon'><img src='/image/common/alert_icon.png' alt='크롤링 실패'></span>";
					// 	listHtml2 += 		"<div class='comment-inner hide'>";
					// 	listHtml2 += 			"<p class='comment-text'>더보기 영역 입찰불가. 자동입찰중지됨.</p>";
					// 	listHtml2 += 		"</div>";
					// 	listHtml2 += 	"</div>";
					// }
					listHtml2 += "</td>";
	
					//목표 CPA 자동입찰
					listHtml2 += "<td class='add-td-2'>";
					listHtml2 += "<div class='on_off_btn status-btn-area status-ui-btn" + i + "'>";
					if (listValues[i].bid_status == 'CpaActive') {
						listHtml2 += "<button id='check2-bidStatus' data-type='bidStatus' data-name='bid_status' data-status='CpaActive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on cpa-status-btn cpa-status-active bid-status-btns'>ON</button>";
						listHtml2 += "<button id='check-bidStatus' data-type='bidStatus' class='cpa-status-btn cpa-status-Inactive bid-status-btns bid-status-Inactives' data-name='bid_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>OFF</button>";
					} else {
						listHtml2 += "<button id='check2-bidStatus' data-type='bidStatus' class='cpa-status-btn cpa-status-active bid-status-btns' data-name='bid_status' data-status='CpaActive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>ON</button>";
						listHtml2 += "<button id='check-bidStatus' data-type='bidStatus' data-name='bid_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on cpa-status-btn cpa-status-Inactive bid-status-btns bid-status-Inactives'>OFF</button>";
					}
					listHtml2 += "</div>";
					listHtml2 += "</td>";
	
					listHtml2 += "<td class='add-td-2'>";
					listHtml2 += "<span>" + numberWithCommas(listValues[i].cur_cpa_amt) + "</span>";
					if (listValues[i].msg_cd == 'cpa_shortage') {
						listHtml2 += "<span class='alert-icon comment-alert' data-comment='CPA산출데이터 불충분.<br/> 일 평균 클릭, 전환 10회 미만으로<br/> CPA입찰 시 불안정할 수 있음'><img src='/image/common/alert_icon.png' alt='느낌표'></span>";
					}
					listHtml2 += "</td>";
					listHtml2 += "<td class='add-td-2 keyword_contents keywords_hover'>";
					listHtml2 += "<div class='update-time time-2'>";
					listHtml2 += "<span class='clk-text'>" + listValues[i].rec_clk_rnk + "</span>";
					listHtml2 += "<p class='time-text'>" + times(listValues[i].rec_clk_at) + "</p>";
					listHtml2 += "</div>";
					listHtml2 += "</td>";
					listHtml2 += "<td class='add-td-2'>";
					listHtml2 += "<div class='bid_wrap'>";
					listHtml2 += "<div class='bid_icon'>";
					if (listValues[i].bid_status != 'CpaActive') {
						listHtml2 += "<button type='button' class='bid_02 list-btn-modify bid-cpa-option' disabled></button>";
					} else {
						listHtml2 += "<button type='button' class='bid_02 list-btn-modify bid-cpa-option'></button>";
					}
					listHtml2 += "</div>";
					listHtml2 += "<div class='bid_price goal_cpa_price'>" + numberWithCommas(listValues[i].goal_cpa_amt) + "</div>";
					listHtml2 += "<div class='active-btn-area hide'>";
					listHtml2 += "<form onsubmit='favoriteFunc.favoriteBidChangeData(" + goalBtnId + "); return false;'>";
					listHtml2 += "<button id='goal-save-btn-" + i + "' type='button' data-type='goalCpa' onclick='favoriteFunc.favoriteBidChangeData(this);' class='list-btn-save'>저장</button>";
					listHtml2 += "<button type='button' class='list-btn-cancer'>취소</button>";
					listHtml2 += "<input type='number' name='goal_cpa_amt' value='" + listValues[i].goal_cpa_amt + "' class='bid-max-input active-input-area'>";
					listHtml2 += "</form>";
					listHtml2 += "</div>";
					if (listValues[i].cpa_var_status == 'saved') {
						listHtml2 += "<button type='button' class='rate_btn' data-key='" + listValues[i].kwd_id + "' data-name='rateCpa' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/book_btn_on.png' alt='증감률아이콘'></button>";
					} else {
						listHtml2 += "<button type='button' class='rate_btn' data-key='" + listValues[i].kwd_id + "' data-name='rateCpa' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/book_btn.png' alt='증감률아이콘'></button>";
					}
					listHtml2 += "</div>";
					listHtml2 += "</td>";
	
					//경쟁사 타겟 자동입찰
					listHtml2 += "<td class='add-td-3'>";
					listHtml2 += "<div class='on_off_btn status-btn-area status-ui-btn" + i + "'>";
					if (listValues[i].bid_status == 'OppActive') {
						listHtml2 += "<button id='check2-bidStatus' data-type='bidStatus' data-name='bid_status' data-status='OppActive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on opp-status-btn opp-status-active bid-status-btns'>ON</button>";
						listHtml2 += "<button id='check-bidStatus' data-type='bidStatus' class='opp-status-btn opp-status-Inactive bid-status-btns bid-status-Inactives' data-name='bid_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>OFF</button>";
					} else {
						listHtml2 += "<button id='check2-bidStatus' data-type='bidStatus' class='opp-status-btn opp-status-active bid-status-btns' data-name='bid_status' data-status='OppActive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>ON</button>";
						listHtml2 += "<button id='check-bidStatus' data-type='bidStatus' data-name='bid_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on opp-status-btn opp-status-Inactive bid-status-btns bid-status-Inactives'>OFF</button>";
					}
					listHtml2 += "</div>";
					listHtml2 += "</td>";
					listHtml2 += "<td class='add-td-3'>";
					if (listValues[i].opp_site === null) {
						listHtml2 += "<span class='opp-rank'>미등록</span>";
					} else {
						if (listValues[i].cur_opp_rank === 16) {
							listHtml2 += "<span class='opp-rank'><img src='/image/common/alert_icon.png' alt='크롤링 실패'></span>";
						} else {
							listHtml2 += "<span class='opp-rank'>" + listValues[i].cur_opp_rank + "</span>/<span class='opp-gap'>" + listValues[i].rank_range + "</span>";
						}
					}
					listHtml2 += "</td>";
					listHtml2 += "<td class='add-td-3'>";
					if (listValues[i].bid_status == 'OppActive') {
						listHtml2 += "<button type='button' class='his_btn target_btn' data-key='" + listValues[i].kwd_id + "' data-name='target' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/target_icon.png' alt='타겟아이콘'></button>";
					} else {
						listHtml2 += "<button type='button' class='his_btn target_btn' data-key='" + listValues[i].kwd_id + "' data-name='target' data-id='favorite-area' onclick='layerPopup.open(this);' disabled><img src='/image/common/target_icon.png' alt='타겟아이콘'></button>";
					}
					listHtml2 += "</td>";
	
					//예약
					listHtml2 += "<td class='add-td-4'>";
					listHtml2 += "<div class='on_off_btn status-btn-area status-ui-btn" + i + "'>";
					if (listValues[i].resv_status == 'Active') {
						listHtml2 += "<button id='check2-resvStatus' data-type='resvStatus' data-name='resv_status' data-status='Active' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on resv-status-btn resv-status-active'>ON</button>";
						listHtml2 += "<button id='check-resvStatus' data-type='resvStatus' class='resv-status-btn resv-status-Inactive bid-status-Inactives' data-name='resv_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>OFF</button>";
					} else {
						listHtml2 += "<button id='check2-resvStatus' data-type='resvStatus' class='resv-status-btn resv-status-active bid-status-btns' data-name='resv_status' data-status='Active' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>ON</button>";
						listHtml2 += "<button id='check-resvStatus' data-type='resvStatus' data-name='resv_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on resv-status-btn resv-status-Inactive bid-status-Inactives'>OFF</button>";
					}
					listHtml2 += "</div>";
					listHtml2 += "</td>";
					listHtml2 += "<td class='add-td-4'>";
					if (listValues[i].schedule_status == 'saved') {
						listHtml2 += "<button type='button' class='his_btn' data-key='" + listValues[i].kwd_id + "' data-name='booking' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/book_btn_on.png' alt='예약아이콘'></button>";
					} else {
						listHtml2 += "<button type='button' class='his_btn' data-key='" + listValues[i].kwd_id + "' data-name='booking' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/book_btn.png' alt='예약아이콘'></button>";
					}
					listHtml2 += "</td>";
					listHtml2 += "<td>";
					listHtml2 += "<button type='button' class='his_btn' data-key='" + listValues[i].kwd_id + "' data-name='history' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/history_icon.png' alt='이력아이콘'></button>";
					listHtml2 += "</td>";
					listHtml2 += "<td>";
					listHtml2 += "<button type='button' class='his_btn' data-key='" + listValues[i].kwd_id + "' data-name='chart1' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/chart_icon.png' alt='통계아이콘'></button>";
					listHtml2 += "</td>";
					listHtml2 += "</tr>";
				}
				//적용
				$count.text(listKeys.length);
				$list.show();
				$noList.hide();
			} else {
				$count.text(0);
				$('.none_date p').text('키워드 이력이 없습니다.');
				$list.hide();
				$noList.show();
			}
			if (subCheck == true) {
				$search.show();
			} else {
				$search.hide();
			}
			$listBodyPos.html(listHtml1);
			$listBodyFull.html(listHtml2);
			//상태값 온오프
			favoriteFunc.favoriteListStatusData(statusKwd);
			favoriteFunc.favoriteListBidEvent();
			favoriteFunc.favoriteBtnOnOffEvent();
		},
		favoriteBtnOnOffEvent: function favoriteBtnOnOffEvent() {
			if ($('.list-check:checked').length == 0) {
				$('.check-btn').prop('disabled', true);
			} else {
				$('.check-btn').prop('disabled', false);
			}
		},
		//즐겨찾기 리스트 입찰 이벤트
		favoriteListBidEvent: function favoriteListBidEvent() {
			var subEl = '.favorite_inner_table_wrap tbody tr';
			$(subEl).find('.list-btn-modify').click(function () {
				var $this = $(this);
				$(subEl).find('.bid_icon').show();
				$(subEl).find('.bid_price').show();
				$(subEl).find('.active-btn-area').hide();
				$this.parent().hide();
				$this.parent().next().hide();
				$this.parent().parent().find('.active-btn-area').show();
			});
			$(subEl).find('.list-btn-cancer').click(function () {
				var $this = $(this);
				var prevText = $this.parents('.bid_wrap').find('.bid_price').text();
				$(subEl).find('.bid_icon').show();
				$(subEl).find('.bid_price').show();
				$(subEl).find('.active-btn-area').hide();
				$this.parents('.bid_wrap').find('.active-input-area').val(uncomma(prevText));
			});
			//이력 이벤트 키워드
			$('.his_btn, .bidPop_btn').click(function () {
				var thisKey = $(this).attr('data-key');
				historyKey = thisKey;
			});
			//입찰가 맥스값 도달 ON 호버 처리
			$('.cur_bid_price.point,.cur_bid_price.point2,.group-td.point,.kwd-td.point,.comment-alert').mouseenter(function () {
				var comment = $(this).attr('data-comment');
				var html = "<div class='max-point-box'>";
				html += "<p class='text-p'>" + comment + "</p>";
				html += "</div>";
				$(this).append(html);
			}).mouseleave(function () {
				$(this).find('.max-point-box').remove();
			});
		},
		//즐겨찾기 등록 키워드
		favoriteGroupKeywordCallBack: function favoriteGroupKeywordCallBack(data) {
			groupKeyword = data.data;
		},
		//즐겨찾기 키워드 팝업
		favoriteKeywordPopCallBack: function favoriteKeywordPopCallBack() {
			//생성된 객체를 초기화 함
			keywordData = {};
			addKeywordData = {};
			pushKeywordData = {};
			$('.fixed-pop').fadeIn(200);
			favoriteFunc.favoriteAddKeywordListData(advKey);
			//광고주 키워드 등록 리스트
			favoriteFunc.favoriteGroupKeywordData();
		},
		//즐겨찾기 운영 키워드
		favoriteKeywordCallBack: function favoriteKeywordCallBack(data) {
			var dataCheck = Object.keys(data);
			var $ul = $('.keyword-list-inner');
			var html = '';
			var $count = $('#oper-count');
			if (dataCheck[0] == 'data') {
				keywordData = data.data;
				var dataKey = Object.keys(keywordData);
				var dataValue = dataKey.map(function (i) {
					return keywordData[i];
				});
				if (0 < dataKey.length) {
					for (var i = 0; i < dataKey.length; i++) {
						html += "<li class='" + dataKey[i] + "''>";
						html += "<div>";
						if (addKeywordData[dataKey[i]] == dataKey[i]) {
							html += "<input type='checkbox' class='keyword-list-check' checked value='" + dataKey[i] + "' id='keyword" + i + "' onchange='favoriteFunc.favoriteKeywordAddCallBack(this);'>";
						} else {
							html += "<input type='checkbox' class='keyword-list-check' value='" + dataKey[i] + "' id='keyword" + i + "' onchange='favoriteFunc.favoriteKeywordAddCallBack(this);'>";
						}
						html += "<label for='keyword" + i + "'>";
						html += "<span class='keyword-name'>" + dataValue[i].kwd_nm + "</span><span class='keyword-groups'>(" + advNm + " > " + dataValue[i].campaign_nm + " > " + dataValue[i].adgroup_nm + ")</span>";
						if (groupKeyword[dataKey[i]] != undefined) {
							html += "<span class='group-nm'>(" + groupKeyword[dataKey[i]] + ")</span>";
						}
						html += "</label>";
						html += "</div>";
						html += "</li>";
						if (i == 1000) {
							break;
						}
					}
					$ul.html(html);
					$count.text(dataKey.length);
				} else {
					alert('관련 키워드가 없습니다.');
					html += "<li class='keyword-comment'>검색된 키워드가 없습니다.</li>";
					$ul.html(html);
					$count.text(0);
				}
			} else {
				alert('관련 키워드가 없습니다.');
				html += "<li class='keyword-comment'>검색된 키워드가 없습니다.</li>";
				$ul.html(html);
				$count.text(0);
			}
		},
		//즐겨찾기 운영 키워드 추가
		favoriteKeywordAddCallBack: function favoriteKeywordAddCallBack(thisEl) {
			var $ul = $('.keyword-list-inner');
			var $addUl = $('.add-keyword-inner');
			var html = '';
			var $this = $(thisEl);
			var thisCheck = $this.prop('checked');
			var keywordKey = $this.val();
			var $count = $('#add-count');
			var addCount = $count.text();
	
			if (thisCheck == true) {
				html += "<li class='" + keywordKey + "'>";
				html += "<div class='add-keyword-box'>";
				html += "<span class='keyword-name'>" + keywordData[keywordKey].kwd_nm + "</span><span class='keyword-groups'>(" + advNm + " > " + keywordData[keywordKey].campaign_nm + " > " + keywordData[keywordKey].adgroup_nm + ")</span>";
	
				if (groupKeyword[keywordKey] != undefined) {
					html += "<span class='group-nm'>(" + groupKeyword[keywordKey] + ")</span>";
				}
	
				html += "<button type='button' class='delete-btn' onclick='favoriteFunc.favoriteKeywordDeleteCallBack(this);'>X</button>";
				html += "</div>";
				html += "</li>";
				//추가 리스트 카운트 증가
				addCount++;
				$count.text(addCount);
				//추가삭제 종합
				addKeywordData[keywordKey] = keywordKey;
				//추가된 키워드 저장
				pushKeywordData[keywordKey] = {
					"ad_med_id": 1,
					"campaign_id": keywordData[keywordKey].campaign_id,
					"campaign_nm": keywordData[keywordKey].campaign_nm,
					"adgroup_id": keywordData[keywordKey].adgroup_id,
					"adgroup_nm": keywordData[keywordKey].adgroup_nm,
					"kwd_id": keywordKey,
					"kwd_nm": keywordData[keywordKey].kwd_nm,
					"cur_bid_amt": keywordData[keywordKey].bid_amt
				};
			} else {
				//추가 리스트 카운트 감소
				addCount--;
				$count.text(addCount);
				//추가된 키워드 삭제
				delete addKeywordData[keywordKey];
				//추가된 키워드 저장
				delete pushKeywordData[keywordKey];
				$addUl.find('.' + keywordKey).remove();
			}
			$addUl.find('.keyword-comment').remove();
			$addUl.append(html);
		},
		//즐겨찾기 추가 키워드 삭제
		favoriteKeywordDeleteCallBack: function favoriteKeywordDeleteCallBack(thisEl) {
			var $count = $('#add-count');
			var addCount = $count.text();
			var keywordKey = $(thisEl).parents('li').attr('class');
	
			//추가 리스트 카운트 감소
			addCount--;
			$count.text(addCount);
			//삭제된 키워드 제거
			delete addKeywordData[keywordKey];
			delete pushKeywordData[keywordKey];
	
			$(thisEl).parents('li').remove();
			$('.' + keywordKey).find('input').prop('checked', false);
		},
		//즐겨찾기 신규 키워드1
		favoriteAddKeywordListCallBack: function favoriteAddKeywordListCallBack(data) {
			var dataFilter = data.data;
			var html = '';
			var addList = '#add-keyword-list-1';
			var $count = $('#new-cam-count');
			if (0 < dataFilter.length) {
				for (var i = 0; i < dataFilter.length; i++) {
					html += "<li><a href='javascript:void(0);' data-id='" + dataFilter[i].nccCampaignId + "' onclick='javascript:favoriteFunc.favoriteAddKeywordListData2(this);'>" + dataFilter[i].name + "</a></li>";
					addKeywordData[dataFilter[i].nccCampaignId] = dataFilter[i].name;
				}
	
				$count.text(dataFilter.length);
			} else {
				html += "<li class='keyword-comment'>해당 항목이 없습니다.</li>";
	
				$count.text(0);
			}
			$(addList).find('ul').html(html);
			keywordPopActive(addList);
		},
		//즐겨찾기 신규 키워드2
		favoriteAddKeywordList2CallBack: function favoriteAddKeywordList2CallBack(data) {
			var dataFilter = data.data;
			var html = '';
			var addList = '#add-keyword-list-2';
			var addList3 = '#add-keyword-list-3';
			var $count = $('#new-group-count');
			var addHtml3 = "<li class='keyword-comment'>광고그룹을 선택하세요.</li>";
			if (0 < dataFilter.length) {
				for (var i = 0; i < dataFilter.length; i++) {
					html += "<li><a href='javascript:void(0);' data-id='" + dataFilter[i].nccAdgroupId + "' onclick='javascript:favoriteFunc.favoriteAddKeywordListData3(this);'>" + dataFilter[i].name + "</a></li>";
					addKeywordData[dataFilter[i].nccAdgroupId] = dataFilter[i].name;
				}
	
				$count.text(dataFilter.length);
			} else {
				html += "<li class='keyword-comment'>해당 항목이 없습니다.</li>";
	
				$count.text(0);
			}
			$(addList).find('ul').html(html);
			$(addList3).find('ul').html(addHtml3);
			keywordPopActive(addList);
		},
		//즐겨찾기 신규 키워드3
		favoriteAddKeywordList3CallBack: function favoriteAddKeywordList3CallBack(data) {
			var dataFilter = data.data;
			var newKeywordKey = Object.keys(dataFilter);
			var html = '';
			var temp_obj = {};
			var addList = '#add-keyword-list-3';
			var $count = $('#new-key-count');
			var listFilterData = {};
			var $bidListTr = $('#bid-list-body-2 tr');
	
			//중복 데이터 필터
			$bidListTr.each(function () {
				var listKeywordCheck = $(this).attr('data-id');
				listFilterData[listKeywordCheck] = true;
			});
	
			if (0 < newKeywordKey.length) {
				newKeywordKey.map(function (key) {
					temp_obj[dataFilter[key].keyword] = dataFilter[key];
				});
				var newTempKeywordKey = Object.keys(temp_obj);
				newTempKeywordKey.sort();
				for (var i = 0; i < newTempKeywordKey.length; i++) {
					var _nccKeywordId = temp_obj[newTempKeywordKey[i]].nccKeywordId;
					var _keyword = temp_obj[newTempKeywordKey[i]].keyword;
					var _compare_nccKeywordId = addKeywordData[_nccKeywordId];
					var _keywordBid = temp_obj[newTempKeywordKey[i]].bidAmt;
					var _overlapData = listFilterData[_nccKeywordId] == true ? '(추가완료)' : '';
					html += "<li class='" + _nccKeywordId + "'>";
					html += "<div>";
					if (_compare_nccKeywordId == _nccKeywordId) {
						html += "<input type='checkbox' id='add-keyword-" + i + "'  data-name='" + _keyword + "' data-id='" + _nccKeywordId + "' checked onchange='favoriteFunc.favoriteAddKeywordCallBack(this);'>";
					} else if (listFilterData[_nccKeywordId] == true) {
						html += "<input type='checkbox' id='add-keyword-" + i + "' disabled  data-name='" + _keyword + "' data-bid='" + _keywordBid + "' data-id='" + _nccKeywordId + "' onchange='favoriteFunc.favoriteAddKeywordCallBack(this);'>";
					} else {
						html += "<input type='checkbox' id='add-keyword-" + i + "'  data-name='" + _keyword + "' data-bid='" + _keywordBid + "' data-id='" + _nccKeywordId + "' onchange='favoriteFunc.favoriteAddKeywordCallBack(this);'>";
					}
					html += "<label for='add-keyword-" + i + "'>" + _keyword + "<span style='color:red;'>" + _overlapData + "</span>" + "</label>";
					html += "</div>";
					html += "</li>";
				}
				$count.text(newKeywordKey.length);
			} else {
				html += "<li class='keyword-comment'>해당 항목이 없습니다.</li>";
				$count.text(0);
			}
			$(addList).find('ul').html(html);
			keywordPopActive(addList);
		},
		//즐겨찾기 신규 키워드 추가
		favoriteAddKeywordCallBack: function favoriteAddKeywordCallBack(thisEl) {
			var $this = $(thisEl);
			var $ul = $('.keyword-list-inner');
			var $addUl = $('.add-keyword-inner');
			var camId = $('#add-keyword-list-1').find('.active').attr('data-id');
			var groupId = $('#add-keyword-list-2').find('.active').attr('data-id');
			var keywordId = $this.attr('data-id');
			var keyText = $this.attr('data-name');
			var keyBid = $this.attr('data-bid');
			var html = '';
			var thisCheck = $this.prop('checked');
			var $count = $('#add-count');
			var addCount = $count.text();
			if (thisCheck == true) {
				html += "<li class='" + keywordId + "'>";
				html += "<div class='add-keyword-box'>";
				html += "<span class='keyword-name'>" + keyText + "</span><span class='keyword-groups'>(" + advNm + " > " + addKeywordData[camId] + " > " + addKeywordData[groupId] + ")</span>";
	
				if (groupKeyword[keywordId] != undefined) {
					html += "<span class='group-nm'>(" + groupKeyword[keywordId] + ")</span>";
				}
				html += "<button type='button' class='delete-btn' onclick='favoriteFunc.favoriteKeywordDeleteCallBack(this);'>X</button>";
				html += "</div>";
				html += "</li>";
	
				//추가 리스트 카운트 증가
				addCount++;
				$count.text(addCount);
				//추가삭제 종합
				addKeywordData[keywordId] = keywordId;
				//추가된 키워드 저장
	
				pushKeywordData[keywordId] = {
					"ad_med_id": 1,
					"campaign_id": camId,
					"campaign_nm": addKeywordData[camId],
					"adgroup_id": groupId,
					"adgroup_nm": addKeywordData[groupId],
					"kwd_id": keywordId,
					"kwd_nm": keyText,
					"cur_bid_amt": keyBid
				};
			} else {
				//추가 리스트 카운트 증가
				addCount--;
				$count.text(addCount);
				//추가된 키워드 삭제
				delete addKeywordData[keywordId];
				delete pushKeywordData[keywordId];
				$addUl.find('.' + keywordId).remove();
			}
			$addUl.find('.keyword-comment').remove();
			$addUl.append(html);
		},
	
		//즐겨찾기 팝업 데이터 변경 콜백
		favoriteChangeCallBack: function favoriteChangeCallBack() {
			layerPopup.close();
			$('#timeLoading').remove();
		},
	
		//즐겨찾기 키워드 이동 콜백
		favoriteKeywordPushCallBack: function favoriteKeywordPushCallBack(result) {
			if (result.data == 'OVER_BY_ADV_ID') {
				alert('광고주별 최대 즐겨찾기 개수를 초과하였습니다.');
			} else if (result.data == 'OVER_BY_ALL') {
				alert('입찰 솔루션에 등록 가능한 즐겨찾기 갯수가 초과하였습니다.');
			} else {
				var moveSubId = $('#move-group-select').val();
				layerPopup.close();
				if (moveSubId != null) {
					alwaysFunc.asideMenuSubData(advId, 'subMenu');
					setTimeout(function () {
						$(groupSubId).val(moveSubId);
						favoriteFunc.favoriteSubListData(moveSubId);
						$(groupSubId).val(moveSubId);
						$('.menu-sub-inner li a').removeClass('active');
						$('.menu-sub-inner').find('.' + moveSubId + ' a').addClass('active');
					}, 1000);
				} else {
					alwaysFunc.asideMenuSubData(advId, 'subMenu');
					setTimeout(function () {
						$(groupSubId).val(advSubId);
						favoriteFunc.favoriteSubListData(advSubId);
						$('.menu-sub-inner li a').removeClass('active');
						$('.menu-sub-inner').find('.' + advSubId + ' a').addClass('active');
					}, 1000);
				}
			}
		},
	
		//즐겨찾기 상태 값 콜백
		favoriteStatusCallBack: function favoriteStatusCallBack(data) {
			statusData = data.data;
			var statusKey = Object.keys(statusData);
			var statusValue = statusKey.map(function (key) {
				return statusData[key];
			});
			if (0 < statusKey.length) {
				for (var i = 0; i < statusKey.length; i++) {
					var statusCheck = statusValue[i].status;
					faListData[statusKey[i]]['status'] = statusCheck;
					$('.' + statusKey[i]).find('.on_off_btn .status-off, .status-on').removeClass('on');
					if (statusCheck != 'PAUSED') {
						$('.table-list-body .' + statusKey[i]).find('.status-on').addClass('on');
					} else {
						$('.table-list-body .' + statusKey[i]).find('.status-off').addClass('on');
					}
				}
			}
		},
	
		//즐겨찾기 키워드 이동 팝업 콜백
		favoriteKeywordMoveGroupCallBack: function favoriteKeywordMoveGroupCallBack(data, checkData) {
			var dataFilter = data.groups;
			var dataKey = Object.keys(dataFilter);
			var dataValue = dataKey.map(function (key) {
				return dataFilter[key];
			});
			var $select = $('#move-group-select');
			var $list = $('#move-keyword-list');
			var $count = $('#move-keyword-count');
			var html = '';
			var keywordHtml = '';
			if (0 < dataKey.length) {
				html += "<option value=''>선택</option>";
				for (var i = 0; i < dataKey.length; i++) {
					html += "<option value='" + dataValue[i].id + "'>" + dataValue[i].name + "</option>";
				}
			} else {
				html += "<option value=''>그룹이 없습니다.</option>";
			}
	
			if (0 < checkData.length) {
				for (var i = 0; i < checkData.length; i++) {
					keywordHtml += "<li class='" + checkData[i].kwd_id + "'>";
					keywordHtml += "<div>";
					keywordHtml += "<button type='button' data-id='" + checkData[i].kwd_id + "' onclick='favoriteFunc.favoriteMoveKeywordDelete(this);'><img src='image/common/bid_icon_04.png' alt='삭제''></button>";
					keywordHtml += "</div>";
					keywordHtml += "<div>" + checkData[i].kwd_nm + " ( " + advNm + ' > ' + checkData[i].campaign_nm + ' > ' + checkData[i].adgroup_nm + " )</div>";
					keywordHtml += "</li>";
					moveKeywordData[checkData[i].kwd_id] = {
						"ad_med_id": "1",
						"campaign_id": checkData[i].campaign_id,
						"campaign_nm": checkData[i].campaign_nm,
						"adgroup_id": checkData[i].adgroup_id,
						"adgroup_nm": checkData[i].adgroup_nm,
						"kwd_id": checkData[i].kwd_id,
						"kwd_nm": checkData[i].kwd_nm,
						"cur_bid_amt": checkData[i].cur_bid_amt
					};
				}
			} else {
				keywordHtml += "<li>선택된 키워드가 없습니다.</li>";
			}
			$select.html(html);
			$list.html(keywordHtml);
			$count.text(checkData.length);
			$('.fixed-pop').fadeIn(200);
		},
	
		//즐겨찾기 키워드 이동 선택 삭제
		favoriteMoveKeywordDelete: function favoriteMoveKeywordDelete(thisEl) {
			if (confirm("삭제하시겠습니까?") == true) {
				var $this = $(thisEl);
				var removeData = $this.attr('data-id');
				delete moveKeywordData[removeData];
				$this.parents('li').remove();
			}
		},
		//즐겨찾기 테이블 제어 필터 콜백
		favoriteFilterCallBack: function favoriteFilterCallBack(data, key) {
			//필터 소팅용(가나다순)
			var ascending = function ascending(a, b) {
				var a = a.toString().toLowerCase();
				var b = b.toString().toLowerCase();
				return a < b ? -1 : a == b ? 0 : 1;
			};
			//필터 소팅용(역순)
			var descending = function descending(a, b) {
				var a = a.toString();
				var b = b.toString();
				return b.localeCompare(a);
			};
			var dataKey = Object.keys(data).sort().sort(ascending);
			var dataKey = key == 'bid_status_c' ? dataKey.sort(descending) : dataKey;
			var html = '';
			var ulArray = ['#status-view-ul', '#target-view-ul', '#campaign-view-ul', '#group-view-ul', '#bidstatus-view-ul', '#bidstatus-view-ul-a', '#bidstatus-view-ul-b', '#bidstatus-view-ul-c', '#sStatus-view-ul'];
			var keyArray = ['status', 'target', 'campaign_nm', 'adgroup_nm', 'bid_status', 'bid_status_a', 'bid_status_b', 'bid_status_c', 'resv_status'];
			var filterKey = Object.keys(filterCheckSave);
			var check = false;
	
			var listHtml = function listHtml(i, textType, checks) {
				var checking = checks == true ? 'checked' : '';
				if (textType == 'PAUSED' || textType == 'Active' || textType == 'CpaActive' || textType == 'OppActive') {
					var textFilter = dataKey[i] == textType ? 'ON' : 'OFF';
					if (dataKey[i] == textType) {
						html += "<li><input type='checkbox' id='" + keyArray[str] + "-check" + i + "' data-key='" + dataKey[i] + "'" + checking + "><label for='" + keyArray[str] + "-check" + i + "'>" + textFilter + "</label></li>";
					} else if (dataKey[i] == 'Inactive') {
						html += "<li><input type='checkbox' id='" + keyArray[str] + "-check" + i + "' data-key='" + dataKey[i] + "'" + checking + "><label for='" + keyArray[str] + "-check" + i + "'>" + textFilter + "</label></li>";
					}
				} else {
					var textFilter = dataKey[i] == 'Active' ? '목표순위' : dataKey[i] == 'OppActive' ? '' : dataKey[i] == 'Inactive' ? '경쟁사 타겟' : dataKey[i] == 'CpaActive' ? '목표CPA' : dataKey[i] == 'all' ? '전체' : dataKey[i] == 'pc' ? 'PC' : dataKey[i] == 'mobile' ? 'Mobile' : dataKey[i] == 'null' ? '동기화요청' : dataKey[i];
					html += "<li><input type='checkbox' id='" + keyArray[str] + "-check" + i + "' data-key='" + dataKey[i] + "'" + checking + "><label for='" + keyArray[str] + "-check" + i + "'>" + textFilter + "</label></li>";
				}
			};
			var listCheckType = function listCheckType(i, type) {
				if (0 < filterKey.length) {
					for (var idx = 0; idx < filterKey.length; idx++) {
						if (filterKey[idx] == dataKey[i]) {
							listHtml(i, type, true);
							check = true;
							break;
						}
					}
				}
				if (0 === filterKey.length || check == false) {
					listHtml(i, type, false);
				}
			};
	
			if (key == 'status' || key == 'bid_status_a' || key == 'bid_status_b' || key == 'bid_status_c' || key == 'resv_status') {
				var types = key == 'status' ? 'PAUSED' : key == 'bid_status_a' ? 'Active' : key == 'bid_status_b' ? 'CpaActive' : key == 'bid_status_c' ? 'OppActive' : 'Active';
				var str = key == 'status' ? 0 : key == 'bid_status_a' ? 5 : key == 'bid_status_b' ? 6 : key == 'bid_status_c' ? 7 : 8;
				for (var i = 0; i < dataKey.length; i++) {
					listCheckType(i, types);
				}
				$(ulArray[str]).html(html);
			} else {
				for (var str = 0; str < keyArray.length; str++) {
					if (key == keyArray[str]) {
						for (var i = 0; i < dataKey.length; i++) {
							listCheckType(i, 'All');
						}
						$(ulArray[str]).html(html);
					}
				}
			}
		},
	
		//즐겨찾기 테이블 제어 이벤트
		favoriteFilterEvent: function favoriteFilterEvent(type, thisEl, allType) {
			var $this = $(thisEl);
			var $list = $('#bid-list-body-1');
			var $list2 = $('#bid-list-body-2');
			var checkLength = $this.find('li').find('input:checked').length;
			if (allType == true || 0 === checkLength) {
				$list.find('tr').removeClass('hide');
				$list2.find('tr').removeClass('hide');
				filterCheckSave = {};
			} else {
				$list.find('tr').addClass('hide');
				$list2.find('tr').addClass('hide');
				$this.find('li input').each(function (index) {
					var check = $(this).prop('checked');
					if (check == true) {
						var value = $(this).attr('data-key');
						var checkData = tableFilterData['data'][value];
						if (0 < checkData.length) {
							for (var i = 0; i < checkData.length; i++) {
								$list.find('.' + checkData[i]).removeClass('hide');
								$list2.find('.' + checkData[i]).removeClass('hide');
								filterCheckSave[value] = checkData[i];
							}
						} else {
							if (tableFilterData['key'] == 'status') {
								$list.find('tr').removeClass('hide');
								$list2.find('tr').removeClass('hide');
							} else {
								alert('관련 리스트를 찾을 수 없습니다.');
							}
						}
					}
				});
			}
			$('.all_view').removeClass('active').hide();
		},
	
		//최대 입찰가 일괄설정 콟백
		favoriteBidSetPopCallBack1: function favoriteBidSetPopCallBack1(data, checkData) {
			favoriteFunc.favoriteBtnOnOffEvent();
			favoriteFunc.favoriteBidSetPopCallBack();
			favoriteFunc.favoriteBidSetData('view', 'bidSet');
		},
		//CPA 일괄설정 콜백
		favoriteBidSetPopCallBack2: function favoriteBidSetPopCallBack2(data, checkData) {
			favoriteFunc.favoriteBtnOnOffEvent();
			favoriteFunc.favoriteBidCpaPopCallBack();
			favoriteFunc.favoriteBidSetData('view', 'bidCpa');
		},
		//경쟁사 타겟 일괄설정 콜백
		favoriteBidSetPopCallBack3: function favoriteBidSetPopCallBack3(data, checkData) {
			favoriteFunc.favoriteBtnOnOffEvent();
			favoriteFunc.favoriteBidCpaPopCallBack();
			favoriteFunc.favoriteBidSetData('view', 'bidOpp');
		},
		favoriteTargetCallBack: function favoriteTargetCallBack(data, checkData) {
			var keywords = faListData[data];
			var targetUrl = keywords['opp_site'];
			var targetGap = keywords['opp_gap'];
			var targetRank = keywords['opp_goal_rank'];
	
			$('#bid-set-save').attr('data-id', data);
			$('#target-url').val(targetUrl);
	
			$('#target-gap option').each(function () {
				var $this = $(this);
				var thisVal = $this.val();
				if (thisVal == targetGap) {
					$this.prop('selected', true);
				}
			});
	
			$('#target-rank option').each(function () {
				var $this = $(this);
				var thisVal = $this.val();
				if (thisVal == targetRank) {
					$this.prop('selected', true);
				}
			});
		},
	
		favoriteRateCallBack: function favoriteRateCallBack(data, checkData) {
			var data = data.data;
			var eachs = function eachs(el, data) {
				if (data !== null) {
					var newData = {};
					var keys = Object.keys(data);
					for (var i = 0; i < keys.length; i++) {
						newData[i + 1] = data[keys[i]];
					}
	
					$(el).each(function (i) {
						var value = 0;
						if (0 < i) {
							value = !newData[i] ? 0 : newData[i];
						}
						$(this).find('input').val(value);
					});
				} else {
					$(el).each(function (i) {
						if (0 < i) {
							$(this).find('input').val(0);
						}
					});
				}
			};
			if (checkData !== 'change') {
				$('#rate-type select option').each(function () {
					var check = $(this).val();
					if (check == data.type) {
						$(this).prop('selected', true);
					}
				});
				if (data.type !== 'pct') {
					$('.default-btn').hide();
				} else {
					$('.default-btn').show();
				}
			}
			//증액
			eachs('.rate-table-list tbody .inc td', JSON.parse(data.increse_json));
			//감액
			eachs('.rate-table-list tbody .dec td', JSON.parse(data.decrese_json));
		},
	
		//키워드 예약 일괄 설정 콜백
		favoriteBidSetPopCallBack5: function favoriteBidSetPopCallBack5(data) {
			bidScheAllData = data.data.bid_schedules;
			var scheKwd = Object.keys(bidScheAllData);
	
			var $this = $('#bid-list-body-1');
			var $list2 = $('#bid-list-body-2');
			var $addList = $('#add-key-list');
			var keywordList = [];
	
			var checkKwdList = function checkKwdList() {
				var html = '';
				$this.find('tr').each(function () {
					var $this = $(this);
					var kwdId = $this.attr('data-id');
					var $this2 = $list2.find('.' + kwdId);
					var checklist = faListData[kwdId];
					var bidStatusCheck = $this.find('.bidStatus-td > p').attr('data-status');
					var check = $this.find("input[type='checkbox']").prop('checked');
					if (check == true && bidStatusCheck != 'Inactive') {
						keywordList.push(checklist);
					}
				});
				for (var i = 0; i < keywordList.length; i++) {
					html += "<li class='keyword-p' data-kwd='" + keywordList[i].kwd_id + "'><span>" + keywordList[i].kwd_nm + '</span><button type="button" onclick="favoriteFunc.favoriteSetEvent5(this, \'remove\');">X<button></li>';
				}
				$addList.append(html);
			};
	
			var scheList = function scheList() {
				var $keyList = $('#all-key-list');
				var keywordSample = '';
				for (var i = 0; i < scheKwd.length; i++) {
					var kwdKey = scheKwd[i];
					var kwdName = faListData[kwdKey].kwd_nm;
					keywordSample += '<li><a href="javascript:void(0);" data-kwd="' + kwdKey + '" onclick="favoriteFunc.favoriteSetEvent5(this, \'add\');">' + kwdName + '</a></li>';
				}
				$keyList.html(keywordSample);
			};
			//키워드 리스트 실행
			scheList();
			checkKwdList();
	
			//예약 데이터 기반 UI 컨트롤
			favoriteFunc.bookingUi();
		},
		favoriteBidSetPopCallBack6: function favoriteBidSetPopCallBack6(data, type) {
	
			var $this = $('#bid-list-body-1');
			var $list2 = $('#bid-list-body-2');
			var $addList = $('#add-key-list');
			var keywordList = [];
	
			var checkKwdList = function checkKwdList() {
				var html = '';
				$this.find('tr').each(function () {
					var $this = $(this);
					var kwdId = $this.attr('data-id');
					var $this2 = $list2.find('.' + kwdId);
					var checklist = faListData[kwdId];
					var bidStatusCheck = $this.find('.bidStatus-td > p').attr('data-status');
					var check = $this.find("input[type='checkbox']").prop('checked');
					if (check == true && bidStatusCheck != 'Inactive') {
						keywordList.push(checklist);
					}
				});
				for (var i = 0; i < keywordList.length; i++) {
					html += "<li class='keyword-p' data-kwd='" + keywordList[i].kwd_id + "'><span>" + keywordList[i].kwd_nm + '</span><button type="button" onclick="favoriteFunc.favoriteSetEvent5(this, \'remove\');">X<button></li>';
				}
				$addList.append(html);
			};
	
			checkKwdList();
			favoriteFunc.favoriteBtnOnOffEvent();
		},
		favoriteChartCallBack: function favoriteChartCallBack(data, type) {
			var dataFilter = data.data;
			if (type == 'chart1') {
				dataFilter = dataFilter;
			} else {
				dataFilter = dataFilter;
			}
	
			if (typeof dataFilter.chart_data !== 'undefined') {
				chartDataCheck = true;
				chartUi.init(dataFilter, type);
			} else {
				//데이터가 없을경우 분기처리
				chartDataCheck = false;
			}
		},
	
		//예약 액션 UI Set
		favoriteBookingCallBack: function favoriteBookingCallBack(data, kwdKey) {
			var dataFilter = data.data;
			var scheData = dataFilter.bid_schedules[kwdKey[0]].bid_schedule;
			var typeData = dataFilter.bid_schedules[kwdKey[0]].bid_schedule_types;
			var deviceCheck = faListData[kwdKey].target;
			//예약 데이터 기반 UI 컨트롤
			favoriteFunc.bookingUi(scheData);
			dragChart.init(typeData, deviceCheck);
		},
		//예약 키워드 추가 이벤트
		favoriteSetEvent5: function favoriteSetEvent5(thisEl, Type) {
			var $this = $(thisEl);
			var $addList = $('#all-key-list');
			var html = '';
			if (Type == 'add') {
				var clickKwd = $this.attr('data-kwd');
				var clickSchedule = bidScheAllData[clickKwd].bid_schedule;
				var clickScheduleTypes = bidScheAllData[clickKwd].bid_schedule_types;
				bidScheAllClickKwd = clickKwd;
				$addList.find('a').removeClass('on');
				$this.addClass('on');
				//예약 데이터 기반 UI 컨트롤
				favoriteFunc.bookingUi(clickSchedule, clickScheduleTypes);
			} else if (Type == 'remove') {
				$this.parents('.keyword-p').remove();
			}
		},
		bookingUi: function bookingUi(data, hoverTypes) {
	
			var sampleData = {};
			var chartId = $('#drag-graph-box');
			var gridBoxEl = chartId.find('.grid-box');
			var $xBox = $('.x-name-box');
			var $yBox = $('.y-name-box');
			var gridBox = '';
			var xyGridBox = '';
			var yBox = '';
			var xBox = '';
			var yArray = ['월', '화', '수', '목', '금', '토', '일'];
	
			//호버 말풍선 기능
			var schedulehoverSetting = function schedulehoverSetting() {
				var data = hoverTypes;
				$('.grid-box .box-grid').mouseenter(function () {
					var $this = $(this);
					var thisColor = $this.attr('data-color');
					var commentUi = '';
					if (thisColor != 0) {
						if (typeof thisColor === 'string') {
							var thisData = data[thisColor];
							var thisType = thisData.bid_status;
							//코멘트 풍선
							commentUi += "<div class='comment-ui'>";
							if (thisType == 'Active') {
								commentUi += "<p class='comment-p'><strong>목표순위 자동입찰</strong></p>";
								commentUi += "<p class='comment-p'><strong>목표순위 : " + thisData.goal_rank + "</strong></p>";
								commentUi += "<p class='comment-p'><strong>최대 입찰가 : " + numberWithCommas(thisData.max_bid_amt) + "</strong></p>";
								commentUi += "<p class='comment-p'><strong>최소 입찰가 : " + numberWithCommas(thisData.min_bid_amt) + "</strong></p>";
							} else {
								commentUi += "<p class='comment-p'><strong>목표CPA 자동입찰</strong></p>";
								commentUi += "<p class='comment-p'><strong>목표CPA : " + numberWithCommas(thisData.goal_cpa) + "</strong></p>";
								commentUi += "<p class='comment-p'><strong>최대 입찰가 : " + numberWithCommas(thisData.max_bid_amt) + "</strong></p>";
								commentUi += "<p class='comment-p'><strong>최소 입찰가 : " + numberWithCommas(thisData.min_bid_amt) + "</strong></p>";
							}
							commentUi += "</div>";
						}
						$this.html(commentUi);
					}
				}).mouseleave(function () {
					$('.grid-box .box-grid > *').remove();
				});
			};
	
			//그리드 데이터
			var gridData = function gridData() {
				if (data != null) {
					var dataSplit = data.split(',');
					var returnData = [];
					var x = 0;
					var y = 0;
					for (var i = 0; i < dataSplit.length; i++) {
						$('.grid-box .box-grid-line' + y + ' .grid-' + x).addClass('active active-' + dataSplit[i]).attr('data-color', dataSplit[i]);
						x++;
						if (x == 24) {
							y++;
							x = 0;
						}
					}
				}
			};
	
			//x축 grid
			for (var i = 0; i < 24; i++) {
				xBox += "<p class='x-grid x-" + i + "' data-x='" + i + "'>" + i + "</p>";
			}
			//y축 grid
			for (var i = 0; i < 7; i++) {
				yBox += "<p class='y-grid y-" + i + "' data-y='" + i + "'>" + yArray[i] + "</p>";
			}
			$xBox.html(xBox);
			$yBox.html(yBox);
	
			//x,y grid
			for (var i = 0; i < 24; i++) {
				gridBox += "<p class='box-grid grid-" + i + "' data-x='" + i + "' data-color=''></p>";
			}
			for (var i = 0; i < 7; i++) {
				xyGridBox += "<div class='box-line box-grid-line" + i + "' data-y='" + i + "'>" + gridBox + "</div>";
			}
			gridBoxEl.html(xyGridBox);
	
			//데이터 반영 그리드
			gridData();
			//일괄설정 스케줄 호버기능 온
			if (hoverTypes != undefined) {
				schedulehoverSetting();
			}
		},
	
		//즐겨찾기 입찰가 일괄변경 팝업 콜백
		favoriteBidAllChangePopUpCallBack: function favoriteBidAllChangePopUpCallBack(data, checkData) {
			var $list = $('#bid_amt_preview_table tbody');
			var keywordHtml = '';
			if (0 < checkData.length) {
				for (var i = 0; i < checkData.length; i++) {
					keywordHtml += "<tr class='" + checkData[i].kwd_id + "' data-id='" + checkData[i].kwd_id + "' data-key='" + checkData[i].kwd_id + "'>";
					keywordHtml += '	<td>';
					keywordHtml += '		<div>';
					keywordHtml += '			<a href="https://search.naver.com/search.naver?query=' + checkData[i].kwd_nm + '" target="_blank"><button><img src="/image/common/keyword_icon.png" alt="돋보기버튼"></button></a>';
					keywordHtml += '		</div>';
					keywordHtml += '		<div>' + checkData[i].kwd_nm + '</div>';
					keywordHtml += '	</td>';
					keywordHtml += '	<td>';
					keywordHtml += '		<div><input type="text" value="' + numberWithCommas(checkData[i].cur_bid_amt) + '" readonly></div>';
					keywordHtml += '	</td>';
					keywordHtml += '	<td data-kwd_id="' + checkData[i].kwd_id + '">';
					keywordHtml += "<div class='bid_wrap'>";
					keywordHtml += "<div class='bid_icon'>";
					keywordHtml += "<button type='button' class='bid_02 list-btn-modify bid-cur-option'></button>";
					keywordHtml += "</div>";
					keywordHtml += "<div class='bid_price'>" + numberWithCommas(checkData[i].cur_bid_amt) + "</div>";
					keywordHtml += "<div class='active-btn-area hide'>";
					var curBtnId = '"#bid-save-btn-' + i + '"';
					keywordHtml += "<form onsubmit='favoriteFunc.favoriteBidChangeData(" + curBtnId + ");'>";
					keywordHtml += "<button type='button' id='bid-save-btn'" + i + "' data-type='curBid' onclick='favoriteFunc.favoriteBidChangeData(this);' class='list-btn-save'>저장</button>";
					keywordHtml += "<button type='button' class='list-btn-cancer'>취소</button>";
					keywordHtml += "<input type='number' name='cur_bid_amt' data-type='curBid' value='" + checkData[i].cur_bid_amt + "' class='bid-cur-input active-input-area'>";
					keywordHtml += "</div>";
					keywordHtml += "</div>";
					keywordHtml += '	</td>';
					keywordHtml += '</tr>';
					bidChangeList[checkData[i].kwd_id] = checkData[i];
				}
			}
			$list.html(keywordHtml);
			var fixedEl = '.fixed-pop';
			$(fixedEl).fadeIn(200);
			$(fixedEl).find('.list-btn-modify').click(function () {
				var $this = $(this);
				$(fixedEl).find('.bid_icon').show();
				$(fixedEl).find('.bid_price').show();
				$(fixedEl).find('.active-btn-area').hide();
				$this.parent().hide();
				$this.parent().next().hide();
				$this.parent().parent().find('.active-btn-area').show();
			});
			$(fixedEl).find('.list-btn-cancer').click(function () {
				var $this = $(this);
				var prevText = $this.parent().parent().find('.bid_price').text();
	
				$(fixedEl).find('.bid_icon').show();
				$(fixedEl).find('.bid_price').show();
				$(fixedEl).find('.active-btn-area').hide();
				$this.parent().parent().find('.active-input-area').val(uncomma(prevText));
			});
			favoriteFunc.favoriteBidOptionEvent();
		},
	
		//즐겨찾기 팝업 옵션 이벤트
		favoriteBidOptionEvent: function favoriteBidOptionEvent() {
			var optionCheck = $('#choice1').prop('checked');
			if (optionCheck == true) {
				$('#option, #option-max-bid-amt').prop('checked', false).prop('disabled', true);
			} else {
				$('#option, #option-max-bid-amt').prop('disabled', false);
			}
		},
	
		//입찰가 일괄변경 미리보기
		clickBidAmtPreviewBtn: function clickBidAmtPreviewBtn() {
			var $radio = $('.amt-choices:checked');
			var $table = $('#bid_amt_preview_table');
			var $parentLi = $radio.closest('li');
			var changeValue = Number($parentLi.find('.change-value').val());
			var changeValueType = $parentLi.find('.change-value-type').val();
			var selectValue = $parentLi.find('.select-value').val();
			var optionCheck = $('#option').prop('checked');
	
			if (changeValue == '') {
				alert('입찰가를 입력해주세요.');
				return;
			}
	
			switch ($radio.val()) {
				case 'SAME':
					$table.find('tbody tr').each(function () {
						var dataKey = $(this).attr('data-key');
	
						if (optionCheck == true) {
							var maxAmt = $('#option-max-bid-amt').val();
							if (maxAmt < changeValue) {
								changeValue = maxAmt;
							}
						}
						changeValue = favoriteFunc.bidAmtRound(Number(changeValue));
						$(this).find('.bid_price').text(numberWithCommas(changeValue));
					});
					break;
				case 'INCREASE':
					$table.find('tbody tr').each(function () {
						var dataKey = $(this).attr('data-key');
						if (changeValueType == '원') {
							var values = bidChangeList[dataKey].cur_bid_amt + changeValue;
						} else {
							var values = bidChangeList[dataKey].cur_bid_amt * (1 + changeValue / 100);
						}
	
						if (optionCheck == true) {
							var maxAmt = $('#option-max-bid-amt').val();
							if (maxAmt < values) {
								values = maxAmt;
							}
						}
						var price = favoriteFunc.bidAmtRound(Number(values));
	
						$(this).find('.bid_price').text(numberWithCommas(price));
					});
					break;
				case 'DECREASE':
					$table.find('tbody tr').each(function () {
						var dataKey = $(this).attr('data-key');
	
						if (changeValueType == '원') {
							var values = bidChangeList[dataKey].cur_bid_amt - changeValue;
						} else {
							var values = bidChangeList[dataKey].cur_bid_amt * (1 - changeValue / 100);
						}
	
						if (optionCheck == true) {
							var maxAmt = $('#option-max-bid-amt').val();
							if (maxAmt < values) {
								values = maxAmt;
							}
						}
						var price = favoriteFunc.bidAmtRound(Number(values));
	
						$(this).find('.bid_price').text(numberWithCommas(price));
					});
					break;
				case 'MID_AMT':
				case 'AVG_AMT':
					var params = '?na_customer=' + advKey;
					params += '&view_bid_type=' + selectValue;
					params += '&na_kwd_sers=' + favoriteFunc.makeCheckedBiddingListKeywordKeyCommaStr(bidChangeList);
					var dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'NaverApiAmt', params);
					_loading.AjaxLoading.pageLoading();
					_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.setCurBidAmtByNaverAPI);
					break;
			}
			$table.find('tbody tr').find('.bid_price').addClass('effect');
			setTimeout(function () {
				$table.find('tbody tr').find('.bid_price').removeClass('effect');
			}, 500);
		},
	
		//입찰가 일괄변경 배열 담기
		makeCheckedBiddingListKeywordKeyCommaStr: function makeCheckedBiddingListKeywordKeyCommaStr(checkedBiddingList) {
			var na_kwd_sers = '';
			for (var key in checkedBiddingList) {
				na_kwd_sers += key + ',';
			}
			na_kwd_sers = na_kwd_sers.substring(0, na_kwd_sers.length - 1);
			return na_kwd_sers;
		},
	
		//입찰가 일괄변경 데이터 저장
		setCurBidAmtByNaverSaveAPI: function setCurBidAmtByNaverSaveAPI(result) {
			naverSaveAPIData = result.data;
		},
	
		//입찰가 일괄변경 기능
		setCurBidAmtByNaverAPI: function setCurBidAmtByNaverAPI(result) {
			var midAmts = result.data;
			var $table = $('#bid_amt_preview_table');
			var optionCheck = $('#option').prop('checked');
			var maxAmt = 0;
			var calcValue = 0;
			for (var kwdId in midAmts) {
				calcValue = midAmts[kwdId].bid;
				calcValue = OPTION_MAX_BID_AMT < calcValue ? OPTION_MAX_BID_AMT : calcValue;
				if (optionCheck == true) {
					maxAmt = $('#option-max-bid-amt').val();
					if (maxAmt < calcValue) {
						calcValue = favoriteFunc.bidAmtRound(maxAmt);
					}
				}
				$table.find('tbody .' + kwdId).find('.bid_price').text(numberWithCommas(favoriteFunc.bidAmtRound(calcValue)));
			}
		},
	
		//즐겨찾기 동기화 콜백
		favoriteNaSyncCallBack: function favoriteNaSyncCallBack(data) {
			setTimeout(function () {
				favoriteFunc.favoriteSubListData(advSubId, 'sync');
				$('#timeLoading').remove();
			}, 2000);
		},
	
		//즐겨찾기 일괄설정 미리보기 디세이블처리
		favoriteBidSetPopCallBack: function favoriteBidSetPopCallBack() {
			$('#max-bid-input').bind('keydown', function () {
				var thisVal = $(this).val();
				if (thisVal != '') {
					$('.preview_btn button').prop('disabled', false);
				} else {
					$('.preview_btn button').prop('disabled', true);
				}
			});
		},
		//즐겨찾기 Cpa 일괄설정 미리보기 디세이블처리
		favoriteBidCpaPopCallBack: function favoriteBidCpaPopCallBack() {
			$('#goal-cpa').bind('keydown', function () {
				var thisVal = $(this).val();
				if (thisVal != '') {
					$('.preview_btn button').prop('disabled', false);
				} else {
					$('.preview_btn button').prop('disabled', true);
				}
			});
		},
	
		//즐겨찾기 일괄설정 미리보기 콜백
		favoriteBidSetViewCallBack: function favoriteBidSetViewCallBack(data, checkData, changeData, setType) {
			var $list = $('#bid-set-list');
			var keywordHtml = '';
			if (0 < checkData.length) {
				for (var i = 0; i < checkData.length; i++) {
					keywordHtml += '<tr>';
					keywordHtml += '	<td class="keyword_section">';
					keywordHtml += '		<div>';
					keywordHtml += "<a href='https://search.naver.com/search.naver?&query=" + checkData[i].kwd_nm + "' target='_blank'><img src='image/common/keyword_icon.png' alt=''></a>";
					keywordHtml += '		</div>';
					keywordHtml += '		<div>' + checkData[i].kwd_nm + '</div>';
					keywordHtml += '	</td>';
					if (setType == 'bidSet') {
						var before1 = checkData[i].goal_rank;
						var before2 = numberWithCommas(checkData[i].max_bid_amt);
						var after1 = changeData[0];
						var after2 = numberWithCommas(changeData[1]);
					} else if (setType == 'bidCpa') {
						var before1 = numberWithCommas(checkData[i].goal_cpa_amt);
						var before2 = numberWithCommas(checkData[i].max_bid_amt);
						var after1 = numberWithCommas(changeData[0]);
						var after2 = numberWithCommas(changeData[1]);
					} else {
						var before1 = checkData[i].opp_gap;
						var before2 = numberWithCommas(checkData[i].max_bid_amt);
						var after1 = changeData[0] + checkData[i].opp_gap;
						var after2 = numberWithCommas(changeData[1]);
					}
					keywordHtml += '	<td>' + before1 + '</td>';
					keywordHtml += '	<td>' + before2 + '</td>';
					keywordHtml += '	<td>' + after1 + '</td>';
					keywordHtml += '	<td>' + after2 + '</td>';
					keywordHtml += '</tr>';
				}
			}
			$list.html(keywordHtml);
		},
	
		//즐겨찾기 입찰가 일괄설정 저장 콜백
		favoriteBidSetSaveCallBack: function favoriteBidSetSaveCallBack(data, checkData, changeData, setType) {
			bidSetList = checkData;
			bidSetChange = changeData;
			if (0 < checkData.length) {
				for (var i = 0; i < checkData.length; i++) {
					if (setType == 'bidSet') {
						bidSetSaveKeywordData[checkData[i].kwd_id] = {
							"ad_med_id": "1",
							"goal_rank": bidSetChange[0],
							"max_bid_amt": bidSetChange[1],
							"min_bid_amt": bidSetChange[2]
						};
					} else if (setType == 'bidCpa') {
						bidCpaSaveKeywordData[checkData[i].kwd_id] = {
							"ad_med_id": "1",
							"goal_cpa_amt": changeData[0],
							"max_bid_amt": changeData[1],
							"min_bid_amt": changeData[2]
						};
					} else {
						bidOppSaveKeywordData[checkData[i].kwd_id] = {
							"ad_med_id": "1",
							"opp_site": changeData[3],
							"opp_gap": changeData[0],
							"opp_goal_rank": changeData[4],
							"max_bid_amt": changeData[1],
							"min_bid_amt": changeData[2]
						};
					}
				}
				favoriteFunc.favoriteBidChangeData('#bid-list-body-1', setType);
			}
		},
	
		//즐겨찾기 이력 팝업 콜백
		favoriteHistoryPopCallBack: function favoriteHistoryPopCallBack(data) {
			var dataFilter = data.data;
			var $list = $('#history-list');
			var html = "";
			var d = new Date();
			var yy = d.getFullYear();
			var mm = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
			var dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
			var todayText = yy + '-' + mm + '-' + dd;
	
			if (dataFilter != undefined) {
				if (0 < dataFilter.length) {
					for (var i = 0; i < dataFilter.length; i++) {
						html += "<tr>";
						html += "<td>" + dataFilter[i].type + "</td>";
						html += "<td>" + dataFilter[i].msg + "</td>";
						html += "<td>" + dataFilter[i].user_info + "</td>";
						html += "<td>" + dataFilter[i].updated_at + "</td>";
						html += "</tr>";
					}
				}
			} else {
				html += "<tr>";
				html += "<td class='none_search'>";
				html += "<div>최근 이력이 없습니다.</div>";
				html += "</td>";
				html += "</tr>";
			}
	
			$list.html(html);
			$('#create-date').attr('placeholder', todayText + '~' + todayText);
			$('.fixed-pop').fadeIn(200);
		},
	
		//최소 입찰가 설정
		bidAmtRound: function bidAmtRound(value) {
			var result = Math.floor(Math.round(Number(value) / 10)) * 10;
			if (result < 70) {
				result = 70;
			}
			return result;
		},
	
		//ADV키 변경
		setAdvKeyDirectly: function setAdvKeyDirectly(naAccKey) {
			advKey = naAccKey;
		},
	
		//즐겨찾기 기타 함수 콜백처리
		favoriteNoFunction: function favoriteNoFunction() {}
	};
	
	window.favoriteFunc = favoriteFunc;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// jquery.daterangepicker.js
	// author : Chunlong Liu
	// license : MIT
	// www.jszen.com
	
	(function (factory) {
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(201), __webpack_require__(721)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined') {
			// CommonJS. Register as a module
			module.exports = factory(require('jquery'), require('moment'));
		} else {
			// Browser globals
			factory(jQuery, moment);
		}
	})(function ($, moment) {
		'use strict';
	
		$.dateRangePickerLanguages = {
			'default': //default language: English
			{
				'selected': 'Selected:',
				'day': 'Day',
				'days': 'Days',
				'apply': 'Close',
				'week-1': 'mo',
				'week-2': 'tu',
				'week-3': 'we',
				'week-4': 'th',
				'week-5': 'fr',
				'week-6': 'sa',
				'week-7': 'su',
				'week-number': 'W',
				'month-name': ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
				'shortcuts': 'Shortcuts',
				'custom-values': 'Custom Values',
				'past': 'Past',
				'following': 'Following',
				'previous': 'Previous',
				'prev-week': 'Week',
				'prev-month': 'Month',
				'prev-year': 'Year',
				'next': 'Next',
				'next-week': 'Week',
				'next-month': 'Month',
				'next-year': 'Year',
				'less-than': 'Date range should not be more than %d days',
				'more-than': 'Date range should not be less than %d days',
				'default-more': 'Please select a date range longer than %d days',
				'default-single': 'Please select a date',
				'default-less': 'Please select a date range less than %d days',
				'default-range': 'Please select a date range between %d and %d days',
				'default-default': 'Please select a date range',
				'time': 'Time',
				'hour': 'Hour',
				'minute': 'Minute'
			},
			'id': {
				'selected': 'Terpilih:',
				'day': 'Hari',
				'days': 'Hari',
				'apply': 'Tutup',
				'week-1': 'sen',
				'week-2': 'sel',
				'week-3': 'rab',
				'week-4': 'kam',
				'week-5': 'jum',
				'week-6': 'sab',
				'week-7': 'min',
				'week-number': 'W',
				'month-name': ['januari', 'februari', 'maret', 'april', 'mei', 'juni', 'juli', 'agustus', 'september', 'oktober', 'november', 'desember'],
				'shortcuts': 'Pintas',
				'custom-values': 'Nilai yang ditentukan',
				'past': 'Yang Lalu',
				'following': 'Mengikuti',
				'previous': 'Sebelumnya',
				'prev-week': 'Minggu',
				'prev-month': 'Bulan',
				'prev-year': 'Tahun',
				'next': 'Selanjutnya',
				'next-week': 'Minggu',
				'next-month': 'Bulan',
				'next-year': 'Tahun',
				'less-than': 'Tanggal harus lebih dari %d hari',
				'more-than': 'Tanggal harus kurang dari %d hari',
				'default-more': 'Jarak tanggal harus lebih lama dari %d hari',
				'default-single': 'Silakan pilih tanggal',
				'default-less': 'Jarak rentang tanggal tidak boleh lebih lama dari %d hari',
				'default-range': 'Rentang tanggal harus antara %d dan %d hari',
				'default-default': 'Silakan pilih rentang tanggal',
				'time': 'Waktu',
				'hour': 'Jam',
				'minute': 'Menit'
			},
			'az': {
				'selected': 'Seçildi:',
				'day': ' gün',
				'days': ' gün',
				'apply': 'tətbiq',
				'week-1': '1',
				'week-2': '2',
				'week-3': '3',
				'week-4': '4',
				'week-5': '5',
				'week-6': '6',
				'week-7': '7',
				'month-name': ['yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun', 'iyul', 'avqust', 'sentyabr', 'oktyabr', 'noyabr', 'dekabr'],
				'shortcuts': 'Qısayollar',
				'past': 'Keçmiş',
				'following': 'Növbəti',
				'previous': '&nbsp;&nbsp;&nbsp;',
				'prev-week': 'Öncəki həftə',
				'prev-month': 'Öncəki ay',
				'prev-year': 'Öncəki il',
				'next': '&nbsp;&nbsp;&nbsp;',
				'next-week': 'Növbəti həftə',
				'next-month': 'Növbəti ay',
				'next-year': 'Növbəti il',
				'less-than': 'Tarix aralığı %d gündən çox olmamalıdır',
				'more-than': 'Tarix aralığı %d gündən az olmamalıdır',
				'default-more': '%d gündən çox bir tarix seçin',
				'default-single': 'Tarix seçin',
				'default-less': '%d gündən az bir tarix seçin',
				'default-range': '%d və %d gün aralığında tarixlər seçin',
				'default-default': 'Tarix aralığı seçin'
			},
			'bg': {
				'selected': 'Избрано:',
				'day': 'Ден',
				'days': 'Дни',
				'apply': 'Затвори',
				'week-1': 'пн',
				'week-2': 'вт',
				'week-3': 'ср',
				'week-4': 'чт',
				'week-5': 'пт',
				'week-6': 'сб',
				'week-7': 'нд',
				'week-number': 'С',
				'month-name': ['януари', 'февруари', 'март', 'април', 'май', 'юни', 'юли', 'август', 'септември', 'октомври', 'ноември', 'декември'],
				'shortcuts': 'Преки пътища',
				'custom-values': 'Персонализирани стойности',
				'past': 'Минал',
				'following': 'Следващ',
				'previous': 'Предишен',
				'prev-week': 'Седмица',
				'prev-month': 'Месец',
				'prev-year': 'Година',
				'next': 'Следващ',
				'next-week': 'Седмица',
				'next-month': 'Месец',
				'next-year': 'Година',
				'less-than': 'Периодът от време не трябва да е повече от %d дни',
				'more-than': 'Периодът от време не трябва да е по-малко от %d дни',
				'default-more': 'Моля изберете период по-дълъг от %d дни',
				'default-single': 'Моля изберете дата',
				'default-less': 'Моля изберете период по-къс от %d дни',
				'default-range': 'Моля изберете период между %d и %d дни',
				'default-default': 'Моля изберете период',
				'time': 'Време',
				'hour': 'Час',
				'minute': 'Минута'
			},
			'cn': //simplified chinese
			{
				'selected': '已选择:',
				'day': '天',
				'days': '天',
				'apply': '确定',
				'week-1': '一',
				'week-2': '二',
				'week-3': '三',
				'week-4': '四',
				'week-5': '五',
				'week-6': '六',
				'week-7': '日',
				'week-number': '周',
				'month-name': ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
				'shortcuts': '快捷选择',
				'past': '过去',
				'following': '将来',
				'previous': '&nbsp;&nbsp;&nbsp;',
				'prev-week': '上周',
				'prev-month': '上个月',
				'prev-year': '去年',
				'next': '&nbsp;&nbsp;&nbsp;',
				'next-week': '下周',
				'next-month': '下个月',
				'next-year': '明年',
				'less-than': '所选日期范围不能大于%d天',
				'more-than': '所选日期范围不能小于%d天',
				'default-more': '请选择大于%d天的日期范围',
				'default-less': '请选择小于%d天的日期范围',
				'default-range': '请选择%d天到%d天的日期范围',
				'default-single': '请选择一个日期',
				'default-default': '请选择一个日期范围',
				'time': '时间',
				'hour': '小时',
				'minute': '分钟'
			},
			'cz': {
				'selected': 'Vybráno:',
				'day': 'Den',
				'days': 'Dny',
				'apply': 'Zavřít',
				'week-1': 'po',
				'week-2': 'út',
				'week-3': 'st',
				'week-4': 'čt',
				'week-5': 'pá',
				'week-6': 'so',
				'week-7': 'ne',
				'month-name': ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'],
				'shortcuts': 'Zkratky',
				'past': 'po',
				'following': 'následující',
				'previous': 'předchozí',
				'prev-week': 'týden',
				'prev-month': 'měsíc',
				'prev-year': 'rok',
				'next': 'další',
				'next-week': 'týden',
				'next-month': 'měsíc',
				'next-year': 'rok',
				'less-than': 'Rozsah data by neměl být větší než %d dnů',
				'more-than': 'Rozsah data by neměl být menší než %d dnů',
				'default-more': 'Prosím zvolte rozsah data větší než %d dnů',
				'default-single': 'Prosím zvolte datum',
				'default-less': 'Prosím zvolte rozsah data menší než %d dnů',
				'default-range': 'Prosím zvolte rozsah data mezi %d a %d dny',
				'default-default': 'Prosím zvolte rozsah data'
			},
			'de': {
				'selected': 'Auswahl:',
				'day': 'Tag',
				'days': 'Tage',
				'apply': 'Schließen',
				'week-1': 'mo',
				'week-2': 'di',
				'week-3': 'mi',
				'week-4': 'do',
				'week-5': 'fr',
				'week-6': 'sa',
				'week-7': 'so',
				'month-name': ['januar', 'februar', 'märz', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'dezember'],
				'shortcuts': 'Schnellwahl',
				'past': 'Vorherige',
				'following': 'Folgende',
				'previous': 'Vorherige',
				'prev-week': 'Woche',
				'prev-month': 'Monat',
				'prev-year': 'Jahr',
				'next': 'Nächste',
				'next-week': 'Woche',
				'next-month': 'Monat',
				'next-year': 'Jahr',
				'less-than': 'Datumsbereich darf nicht größer sein als %d Tage',
				'more-than': 'Datumsbereich darf nicht kleiner sein als %d Tage',
				'default-more': 'Bitte mindestens %d Tage auswählen',
				'default-single': 'Bitte ein Datum auswählen',
				'default-less': 'Bitte weniger als %d Tage auswählen',
				'default-range': 'Bitte einen Datumsbereich zwischen %d und %d Tagen auswählen',
				'default-default': 'Bitte ein Start- und Enddatum auswählen',
				'Time': 'Zeit',
				'hour': 'Stunde',
				'minute': 'Minute'
			},
			'es': {
				'selected': 'Seleccionado:',
				'day': 'Día',
				'days': 'Días',
				'apply': 'Cerrar',
				'week-1': 'lu',
				'week-2': 'ma',
				'week-3': 'mi',
				'week-4': 'ju',
				'week-5': 'vi',
				'week-6': 'sa',
				'week-7': 'do',
				'month-name': ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
				'shortcuts': 'Accesos directos',
				'past': 'Pasado',
				'following': 'Siguiente',
				'previous': 'Anterior',
				'prev-week': 'Semana',
				'prev-month': 'Mes',
				'prev-year': 'Año',
				'next': 'Siguiente',
				'next-week': 'Semana',
				'next-month': 'Mes',
				'next-year': 'Año',
				'less-than': 'El rango no debería ser mayor de %d días',
				'more-than': 'El rango no debería ser menor de %d días',
				'default-more': 'Por favor selecciona un rango mayor a %d días',
				'default-single': 'Por favor selecciona un día',
				'default-less': 'Por favor selecciona un rango menor a %d días',
				'default-range': 'Por favor selecciona un rango entre %d y %d días',
				'default-default': 'Por favor selecciona un rango de fechas.'
			},
			'fr': {
				'selected': 'Sélection:',
				'day': 'Jour',
				'days': 'Jours',
				'apply': 'Fermer',
				'week-1': 'lu',
				'week-2': 'ma',
				'week-3': 'me',
				'week-4': 'je',
				'week-5': 've',
				'week-6': 'sa',
				'week-7': 'di',
				'month-name': ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
				'shortcuts': 'Raccourcis',
				'past': 'Passé',
				'following': 'Suivant',
				'previous': 'Précédent',
				'prev-week': 'Semaine',
				'prev-month': 'Mois',
				'prev-year': 'Année',
				'next': 'Suivant',
				'next-week': 'Semaine',
				'next-month': 'Mois',
				'next-year': 'Année',
				'less-than': 'L\'intervalle ne doit pas être supérieure à %d jours',
				'more-than': 'L\'intervalle ne doit pas être inférieure à %d jours',
				'default-more': 'Merci de choisir une intervalle supérieure à %d jours',
				'default-single': 'Merci de choisir une date',
				'default-less': 'Merci de choisir une intervalle inférieure %d jours',
				'default-range': 'Merci de choisir une intervalle comprise entre %d et %d jours',
				'default-default': 'Merci de choisir une date'
			},
			'hu': {
				'selected': 'Kiválasztva:',
				'day': 'Nap',
				'days': 'Nap',
				'apply': 'Ok',
				'week-1': 'h',
				'week-2': 'k',
				'week-3': 'sz',
				'week-4': 'cs',
				'week-5': 'p',
				'week-6': 'sz',
				'week-7': 'v',
				'month-name': ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'],
				'shortcuts': 'Gyorsválasztó',
				'past': 'Múlt',
				'following': 'Következő',
				'previous': 'Előző',
				'prev-week': 'Hét',
				'prev-month': 'Hónap',
				'prev-year': 'Év',
				'next': 'Következő',
				'next-week': 'Hét',
				'next-month': 'Hónap',
				'next-year': 'Év',
				'less-than': 'A kiválasztás nem lehet több %d napnál',
				'more-than': 'A kiválasztás nem lehet több %d napnál',
				'default-more': 'Válassz ki egy időszakot ami hosszabb mint %d nap',
				'default-single': 'Válassz egy napot',
				'default-less': 'Válassz ki egy időszakot ami rövidebb mint %d nap',
				'default-range': 'Válassz ki egy %d - %d nap hosszú időszakot',
				'default-default': 'Válassz ki egy időszakot'
			},
			'it': {
				'selected': 'Selezionati:',
				'day': 'Giorno',
				'days': 'Giorni',
				'apply': 'Chiudi',
				'week-1': 'lu',
				'week-2': 'ma',
				'week-3': 'me',
				'week-4': 'gi',
				'week-5': 've',
				'week-6': 'sa',
				'week-7': 'do',
				'month-name': ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'],
				'shortcuts': 'Scorciatoie',
				'past': 'Scorso',
				'following': 'Successivo',
				'previous': 'Precedente',
				'prev-week': 'Settimana',
				'prev-month': 'Mese',
				'prev-year': 'Anno',
				'next': 'Prossimo',
				'next-week': 'Settimana',
				'next-month': 'Mese',
				'next-year': 'Anno',
				'less-than': 'L\'intervallo non dev\'essere maggiore di %d giorni',
				'more-than': 'L\'intervallo non dev\'essere minore di %d giorni',
				'default-more': 'Seleziona un intervallo maggiore di %d giorni',
				'default-single': 'Seleziona una data',
				'default-less': 'Seleziona un intervallo minore di %d giorni',
				'default-range': 'Seleziona un intervallo compreso tra i %d e i %d giorni',
				'default-default': 'Seleziona un intervallo di date'
			},
			'ko': {
				'selected': '기간:',
				'day': '일',
				'days': '일간',
				'apply': '닫기',
				'week-1': '월',
				'week-2': '화',
				'week-3': '수',
				'week-4': '목',
				'week-5': '금',
				'week-6': '토',
				'week-7': '일',
				'week-number': '주',
				'month-name': ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
				'shortcuts': '단축키들',
				'past': '지난(오늘기준)',
				'following': '이후(오늘기준)',
				'previous': '이전',
				'prev-week': '1주',
				'prev-month': '1달',
				'prev-year': '1년',
				'next': '다음',
				'next-week': '1주',
				'next-month': '1달',
				'next-year': '1년',
				'less-than': '날짜 범위는 %d 일보다 많을 수 없습니다',
				'more-than': '날짜 범위는 %d 일보다 작을 수 없습니다',
				'default-more': '날짜 범위를 %d 일보다 길게 선택해 주세요',
				'default-single': '날짜를 선택해 주세요',
				'default-less': '%d 일보다 작은 날짜를 선택해 주세요',
				'default-range': '%d와 %d 일 사이의 날짜 범위를 선택해 주세요',
				'default-default': '날짜 범위를 선택해 주세요',
				'time': '시각',
				'hour': '시',
				'minute': '분'
			},
			'no': {
				'selected': 'Valgt:',
				'day': 'Dag',
				'days': 'Dager',
				'apply': 'Lukk',
				'week-1': 'ma',
				'week-2': 'ti',
				'week-3': 'on',
				'week-4': 'to',
				'week-5': 'fr',
				'week-6': 'lø',
				'week-7': 'sø',
				'month-name': ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'],
				'shortcuts': 'Snarveier',
				'custom-values': 'Egendefinerte Verdier',
				'past': 'Over', // Not quite sure about the context of this one
				'following': 'Følger',
				'previous': 'Forrige',
				'prev-week': 'Uke',
				'prev-month': 'Måned',
				'prev-year': 'År',
				'next': 'Neste',
				'next-week': 'Uke',
				'next-month': 'Måned',
				'next-year': 'År',
				'less-than': 'Datoperioden skal ikkje være lengre enn %d dager',
				'more-than': 'Datoperioden skal ikkje være kortere enn %d dager',
				'default-more': 'Vennligst velg ein datoperiode lengre enn %d dager',
				'default-single': 'Vennligst velg ein dato',
				'default-less': 'Vennligst velg ein datoperiode mindre enn %d dager',
				'default-range': 'Vennligst velg ein datoperiode mellom %d og %d dager',
				'default-default': 'Vennligst velg ein datoperiode',
				'time': 'Tid',
				'hour': 'Time',
				'minute': 'Minutter'
			},
			'nl': {
				'selected': 'Geselecteerd:',
				'day': 'Dag',
				'days': 'Dagen',
				'apply': 'Ok',
				'week-1': 'ma',
				'week-2': 'di',
				'week-3': 'wo',
				'week-4': 'do',
				'week-5': 'vr',
				'week-6': 'za',
				'week-7': 'zo',
				'month-name': ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
				'shortcuts': 'Snelkoppelingen',
				'custom-values': 'Aangepaste waarden',
				'past': 'Verleden',
				'following': 'Komend',
				'previous': 'Vorige',
				'prev-week': 'Week',
				'prev-month': 'Maand',
				'prev-year': 'Jaar',
				'next': 'Volgende',
				'next-week': 'Week',
				'next-month': 'Maand',
				'next-year': 'Jaar',
				'less-than': 'Interval moet langer dan %d dagen zijn',
				'more-than': 'Interval mag niet minder dan %d dagen zijn',
				'default-more': 'Selecteer een interval langer dan %dagen',
				'default-single': 'Selecteer een datum',
				'default-less': 'Selecteer een interval minder dan %d dagen',
				'default-range': 'Selecteer een interval tussen %d en %d dagen',
				'default-default': 'Selecteer een interval',
				'time': 'Tijd',
				'hour': 'Uur',
				'minute': 'Minuut'
			},
			'ru': {
				'selected': 'Выбрано:',
				'day': 'День',
				'days': 'Дней',
				'apply': 'Применить',
				'week-1': 'пн',
				'week-2': 'вт',
				'week-3': 'ср',
				'week-4': 'чт',
				'week-5': 'пт',
				'week-6': 'сб',
				'week-7': 'вс',
				'month-name': ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
				'shortcuts': 'Быстрый выбор',
				'custom-values': 'Пользовательские значения',
				'past': 'Прошедшие',
				'following': 'Следующие',
				'previous': '&nbsp;&nbsp;&nbsp;',
				'prev-week': 'Неделя',
				'prev-month': 'Месяц',
				'prev-year': 'Год',
				'next': '&nbsp;&nbsp;&nbsp;',
				'next-week': 'Неделя',
				'next-month': 'Месяц',
				'next-year': 'Год',
				'less-than': 'Диапазон не может быть больше %d дней',
				'more-than': 'Диапазон не может быть меньше %d дней',
				'default-more': 'Пожалуйста выберите диапазон больше %d дней',
				'default-single': 'Пожалуйста выберите дату',
				'default-less': 'Пожалуйста выберите диапазон меньше %d дней',
				'default-range': 'Пожалуйста выберите диапазон между %d и %d днями',
				'default-default': 'Пожалуйста выберите диапазон',
				'time': 'Время',
				'hour': 'Часы',
				'minute': 'Минуты'
			},
			'pl': {
				'selected': 'Wybrany:',
				'day': 'Dzień',
				'days': 'Dni',
				'apply': 'Zamknij',
				'week-1': 'pon',
				'week-2': 'wt',
				'week-3': 'śr',
				'week-4': 'czw',
				'week-5': 'pt',
				'week-6': 'so',
				'week-7': 'nd',
				'month-name': ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'],
				'shortcuts': 'Skróty',
				'custom-values': 'Niestandardowe wartości',
				'past': 'Przeszłe',
				'following': 'Następne',
				'previous': 'Poprzednie',
				'prev-week': 'tydzień',
				'prev-month': 'miesiąc',
				'prev-year': 'rok',
				'next': 'Następny',
				'next-week': 'tydzień',
				'next-month': 'miesiąc',
				'next-year': 'rok',
				'less-than': 'Okres nie powinien być dłuższy niż %d dni',
				'more-than': 'Okres nie powinien być krótszy niż  %d ni',
				'default-more': 'Wybierz okres dłuższy niż %d dni',
				'default-single': 'Wybierz datę',
				'default-less': 'Wybierz okres krótszy niż %d dni',
				'default-range': 'Wybierz okres trwający od %d do %d dni',
				'default-default': 'Wybierz okres',
				'time': 'Czas',
				'hour': 'Godzina',
				'minute': 'Minuta'
			},
			'se': {
				'selected': 'Vald:',
				'day': 'dag',
				'days': 'dagar',
				'apply': 'godkänn',
				'week-1': 'ma',
				'week-2': 'ti',
				'week-3': 'on',
				'week-4': 'to',
				'week-5': 'fr',
				'week-6': 'lö',
				'week-7': 'sö',
				'month-name': ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'],
				'shortcuts': 'genvägar',
				'custom-values': 'Anpassade värden',
				'past': 'över',
				'following': 'följande',
				'previous': 'förra',
				'prev-week': 'vecka',
				'prev-month': 'månad',
				'prev-year': 'år',
				'next': 'nästa',
				'next-week': 'vecka',
				'next-month': 'måned',
				'next-year': 'år',
				'less-than': 'Datumintervall bör inte vara mindre än %d dagar',
				'more-than': 'Datumintervall bör inte vara mer än %d dagar',
				'default-more': 'Välj ett datumintervall längre än %d dagar',
				'default-single': 'Välj ett datum',
				'default-less': 'Välj ett datumintervall mindre än %d dagar',
				'default-range': 'Välj ett datumintervall mellan %d och %d dagar',
				'default-default': 'Välj ett datumintervall',
				'time': 'tid',
				'hour': 'timme',
				'minute': 'minut'
			},
			'pt': //Portuguese (European)
			{
				'selected': 'Selecionado:',
				'day': 'Dia',
				'days': 'Dias',
				'apply': 'Fechar',
				'week-1': 'seg',
				'week-2': 'ter',
				'week-3': 'qua',
				'week-4': 'qui',
				'week-5': 'sex',
				'week-6': 'sab',
				'week-7': 'dom',
				'week-number': 'N',
				'month-name': ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
				'shortcuts': 'Atalhos',
				'custom-values': 'Valores Personalizados',
				'past': 'Passado',
				'following': 'Seguinte',
				'previous': 'Anterior',
				'prev-week': 'Semana',
				'prev-month': 'Mês',
				'prev-year': 'Ano',
				'next': 'Próximo',
				'next-week': 'Próxima Semana',
				'next-month': 'Próximo Mês',
				'next-year': 'Próximo Ano',
				'less-than': 'O período selecionado não deve ser maior que %d dias',
				'more-than': 'O período selecionado não deve ser menor que %d dias',
				'default-more': 'Selecione um período superior a %d dias',
				'default-single': 'Selecione uma data',
				'default-less': 'Selecione um período inferior a %d dias',
				'default-range': 'Selecione um período de %d a %d dias',
				'default-default': 'Selecione um período',
				'time': 'Tempo',
				'hour': 'Hora',
				'minute': 'Minuto'
			},
			'tc': // traditional chinese
			{
				'selected': '已選擇:',
				'day': '天',
				'days': '天',
				'apply': '確定',
				'week-1': '一',
				'week-2': '二',
				'week-3': '三',
				'week-4': '四',
				'week-5': '五',
				'week-6': '六',
				'week-7': '日',
				'week-number': '周',
				'month-name': ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
				'shortcuts': '快速選擇',
				'past': '過去',
				'following': '將來',
				'previous': '&nbsp;&nbsp;&nbsp;',
				'prev-week': '上週',
				'prev-month': '上個月',
				'prev-year': '去年',
				'next': '&nbsp;&nbsp;&nbsp;',
				'next-week': '下周',
				'next-month': '下個月',
				'next-year': '明年',
				'less-than': '所選日期範圍不能大於%d天',
				'more-than': '所選日期範圍不能小於%d天',
				'default-more': '請選擇大於%d天的日期範圍',
				'default-less': '請選擇小於%d天的日期範圍',
				'default-range': '請選擇%d天到%d天的日期範圍',
				'default-single': '請選擇一個日期',
				'default-default': '請選擇一個日期範圍',
				'time': '日期',
				'hour': '小時',
				'minute': '分鐘'
			},
			'ja': {
				'selected': '選択しました:',
				'day': '日',
				'days': '日々',
				'apply': '閉じる',
				'week-1': '月',
				'week-2': '火',
				'week-3': '水',
				'week-4': '木',
				'week-5': '金',
				'week-6': '土',
				'week-7': '日',
				'month-name': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
				'shortcuts': 'クイック選択',
				'past': '過去',
				'following': '将来',
				'previous': '&nbsp;&nbsp;&nbsp;',
				'prev-week': '先週、',
				'prev-month': '先月',
				'prev-year': '昨年',
				'next': '&nbsp;&nbsp;&nbsp;',
				'next-week': '来週',
				'next-month': '来月',
				'next-year': '来年',
				'less-than': '日付の範囲は ％d 日以上にすべきではありません',
				'more-than': '日付の範囲は ％d 日を下回ってはいけません',
				'default-more': '％d 日よりも長い期間を選択してください',
				'default-less': '％d 日未満の期間を選択してください',
				'default-range': '％d と％ d日の間の日付範囲を選択してください',
				'default-single': '日付を選択してください',
				'default-default': '日付範囲を選択してください',
				'time': '時間',
				'hour': '時間',
				'minute': '分'
			},
			'da': {
				'selected': 'Valgt:',
				'day': 'Dag',
				'days': 'Dage',
				'apply': 'Luk',
				'week-1': 'ma',
				'week-2': 'ti',
				'week-3': 'on',
				'week-4': 'to',
				'week-5': 'fr',
				'week-6': 'lö',
				'week-7': 'sö',
				'month-name': ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'],
				'shortcuts': 'genveje',
				'custom-values': 'Brugerdefinerede værdier',
				'past': 'Forbi',
				'following': 'Følgende',
				'previous': 'Forrige',
				'prev-week': 'uge',
				'prev-month': 'månad',
				'prev-year': 'år',
				'next': 'Næste',
				'next-week': 'Næste uge',
				'next-month': 'Næste måned',
				'next-year': 'Næste år',
				'less-than': 'Dato interval bør ikke være med end %d dage',
				'more-than': 'Dato interval bør ikke være mindre end %d dage',
				'default-more': 'Vælg datointerval længere end %d dage',
				'default-single': 'Vælg dato',
				'default-less': 'Vælg datointerval mindre end %d dage',
				'default-range': 'Vælg datointerval mellem %d og %d dage',
				'default-default': 'Vælg datointerval',
				'time': 'tid',
				'hour': 'time',
				'minute': 'minut'
			},
			'fi': // Finnish
			{
				'selected': 'Valittu:',
				'day': 'Päivä',
				'days': 'Päivää',
				'apply': 'Sulje',
				'week-1': 'ma',
				'week-2': 'ti',
				'week-3': 'ke',
				'week-4': 'to',
				'week-5': 'pe',
				'week-6': 'la',
				'week-7': 'su',
				'week-number': 'V',
				'month-name': ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu'],
				'shortcuts': 'Pikavalinnat',
				'custom-values': 'Mukautetut Arvot',
				'past': 'Menneet',
				'following': 'Tulevat',
				'previous': 'Edellinen',
				'prev-week': 'Viikko',
				'prev-month': 'Kuukausi',
				'prev-year': 'Vuosi',
				'next': 'Seuraava',
				'next-week': 'Viikko',
				'next-month': 'Kuukausi',
				'next-year': 'Vuosi',
				'less-than': 'Aikajakson tulisi olla vähemmän kuin %d päivää',
				'more-than': 'Aikajakson ei tulisi olla vähempää kuin %d päivää',
				'default-more': 'Valitse pidempi aikajakso kuin %d päivää',
				'default-single': 'Valitse päivä',
				'default-less': 'Valitse lyhyempi aikajakso kuin %d päivää',
				'default-range': 'Valitse aikajakso %d ja %d päivän väliltä',
				'default-default': 'Valitse aikajakso',
				'time': 'Aika',
				'hour': 'Tunti',
				'minute': 'Minuutti'
			}
		};
	
		$.fn.dateRangePicker = function (opt) {
			if (!opt) opt = {};
			opt = $.extend(true, {
				autoClose: false,
				format: 'YYYY-MM-DD',
				separator: ' to ',
				language: 'auto',
				startOfWeek: 'sunday', // or monday
				getValue: function getValue() {
					return $(this).val();
				},
				setValue: function setValue(s) {
					if (!$(this).attr('readonly') && !$(this).is(':disabled') && s != $(this).val()) {
						$(this).val(s);
					}
				},
				startDate: false,
				endDate: false,
				time: {
					enabled: false
				},
				minDays: 0,
				maxDays: 0,
				showShortcuts: false,
				shortcuts: {
					//'prev-days': [1,3,5,7],
					// 'next-days': [3,5,7],
					//'prev' : ['week','month','year'],
					// 'next' : ['week','month','year']
				},
				customShortcuts: [],
				inline: false,
				container: 'body',
				alwaysOpen: false,
				singleDate: false,
				lookBehind: false,
				batchMode: false,
				duration: 200,
				stickyMonths: false,
				dayDivAttrs: [],
				dayTdAttrs: [],
				selectForward: false,
				selectBackward: false,
				applyBtnClass: '',
				singleMonth: 'auto',
				hoveringTooltip: function hoveringTooltip(days, startTime, hoveringTime) {
					return days > 1 ? days + ' ' + lang('days') : '';
				},
				showTopbar: true,
				swapTime: false,
				showWeekNumbers: false,
				getWeekNumber: function getWeekNumber(date) //date will be the first day of a week
				{
					return moment(date).format('w');
				},
				customOpenAnimation: null,
				customCloseAnimation: null,
				customArrowPrevSymbol: null,
				customArrowNextSymbol: null
			}, opt);
	
			opt.start = false;
			opt.end = false;
	
			opt.startWeek = false;
	
			//detect a touch device
			opt.isTouchDevice = 'ontouchstart' in window || navigator.msMaxTouchPoints;
	
			//if it is a touch device, hide hovering tooltip
			if (opt.isTouchDevice) opt.hoveringTooltip = false;
	
			//show one month on mobile devices
			if (opt.singleMonth == 'auto') opt.singleMonth = $(window).width() < 480;
			if (opt.singleMonth) opt.stickyMonths = false;
	
			if (!opt.showTopbar) opt.autoClose = true;
	
			if (opt.startDate && typeof opt.startDate == 'string') opt.startDate = moment(opt.startDate, opt.format).toDate();
			if (opt.endDate && typeof opt.endDate == 'string') opt.endDate = moment(opt.endDate, opt.format).toDate();
	
			var langs = getLanguages();
			var box;
			var initiated = false;
			var self = this;
			var selfDom = $(self).get(0);
			var domChangeTimer;
	
			$(this).unbind('.datepicker').bind('click.datepicker', function (evt) {
				var isOpen = box.is(':visible');
				if (!isOpen) open(opt.duration);
			}).bind('change.datepicker', function (evt) {
				checkAndSetDefaultValue();
			}).bind('keyup.datepicker', function () {
				try {
					clearTimeout(domChangeTimer);
				} catch (e) {}
				domChangeTimer = setTimeout(function () {
					checkAndSetDefaultValue();
				}, 2000);
			});
	
			init_datepicker.call(this);
	
			if (opt.alwaysOpen) {
				open(0);
			}
	
			// expose some api
			$(this).data('dateRangePicker', {
				setStart: function setStart(d1) {
					if (typeof d1 == 'string') {
						d1 = moment(d1, opt.format).toDate();
					}
	
					opt.end = false;
					setSingleDate(d1);
	
					return this;
				},
				setEnd: function setEnd(d2, silent) {
					var start = new Date();
					start.setTime(opt.start);
					if (typeof d2 == 'string') {
						d2 = moment(d2, opt.format).toDate();
					}
					_setDateRange(start, d2, silent);
					return this;
				},
				setDateRange: function setDateRange(d1, d2, silent) {
					if (typeof d1 == 'string' && typeof d2 == 'string') {
						d1 = moment(d1, opt.format).toDate();
						d2 = moment(d2, opt.format).toDate();
					}
					_setDateRange(d1, d2, silent);
				},
				clear: clearSelection,
				close: closeDatePicker,
				open: open,
				redraw: redrawDatePicker,
				getDatePicker: getDatePicker,
				resetMonthsView: resetMonthsView,
				destroy: function destroy() {
					$(self).unbind('.datepicker');
					$(self).data('dateRangePicker', '');
					$(self).data('date-picker-opened', null);
					box.remove();
					$(window).unbind('resize.datepicker', calcPosition);
					$(document).unbind('click.datepicker', closeDatePicker);
				}
			});
	
			$(window).bind('resize.datepicker', calcPosition);
	
			return this;
	
			function IsOwnDatePickerClicked(evt, selfObj) {
				if (selfObj == undefined) {
					return true;
				} else {
					return selfObj.contains(evt.target) || evt.target == selfObj || selfObj.childNodes != undefined && $.inArray(evt.target, selfObj.childNodes) >= 0;
				}
			}
	
			function init_datepicker() {
				var self = this;
	
				if ($(this).data('date-picker-opened')) {
					closeDatePicker();
					return;
				}
				$(this).data('date-picker-opened', true);
	
				box = createDom().hide();
				box.append('<div class="date-range-length-tip"></div>');
	
				$(opt.container).append(box);
	
				if (!opt.inline) {
					calcPosition();
				} else {
					box.addClass('inline-wrapper');
				}
	
				if (opt.alwaysOpen) {
					box.find('.apply-btn').hide();
				}
	
				var defaultTime = getDefaultTime();
				resetMonthsView(defaultTime);
	
				if (opt.time.enabled) {
					if (opt.startDate && opt.endDate || opt.start && opt.end) {
						showTime(moment(opt.start || opt.startDate).toDate(), 'time1');
						showTime(moment(opt.end || opt.endDate).toDate(), 'time2');
					} else {
						var defaultEndTime = opt.defaultEndTime ? opt.defaultEndTime : defaultTime;
						showTime(defaultTime, 'time1');
						showTime(defaultEndTime, 'time2');
					}
				}
	
				//showSelectedInfo();
	
	
				var defaultTopText = '';
				if (opt.singleDate) defaultTopText = lang('default-single');else if (opt.minDays && opt.maxDays) defaultTopText = lang('default-range');else if (opt.minDays) defaultTopText = lang('default-more');else if (opt.maxDays) defaultTopText = lang('default-less');else defaultTopText = lang('default-default');
	
				box.find('.default-top').html(defaultTopText.replace(/\%d/, opt.minDays).replace(/\%d/, opt.maxDays));
				if (opt.singleMonth) {
					box.addClass('single-month');
				} else {
					box.addClass('two-months');
				}
	
				setTimeout(function () {
					updateCalendarWidth();
					initiated = true;
				}, 0);
	
				box.click(function (evt) {
					evt.stopPropagation();
				});
	
				//if user click other place of the webpage, close date range picker window
				$(document).bind('click.datepicker', function (evt) {
					if (!IsOwnDatePickerClicked(evt, self[0])) {
						if (box.is(':visible')) closeDatePicker();
					}
				});
	
				box.find('.next').click(function () {
					if (!opt.stickyMonths) gotoNextMonth(this);else gotoNextMonth_stickily(this);
				});
	
				function gotoNextMonth(self) {
					var isMonth2 = $(self).parents('table').hasClass('month2');
					var month = isMonth2 ? opt.month2 : opt.month1;
					month = nextMonth(month);
					if (!opt.singleMonth && !opt.singleDate && !isMonth2 && compare_month(month, opt.month2) >= 0 || isMonthOutOfBounds(month)) return;
					showMonth(month, isMonth2 ? 'month2' : 'month1');
					showGap();
				}
	
				function gotoNextMonth_stickily(self) {
					var nextMonth1 = nextMonth(opt.month1);
					var nextMonth2 = nextMonth(opt.month2);
					if (isMonthOutOfBounds(nextMonth2)) return;
					if (!opt.singleDate && compare_month(nextMonth1, nextMonth2) >= 0) return;
					showMonth(nextMonth1, 'month1');
					showMonth(nextMonth2, 'month2');
					showSelectedDays();
				}
	
				box.find('.prev').click(function () {
					if (!opt.stickyMonths) gotoPrevMonth(this);else gotoPrevMonth_stickily(this);
				});
	
				function gotoPrevMonth(self) {
					var isMonth2 = $(self).parents('table').hasClass('month2');
					var month = isMonth2 ? opt.month2 : opt.month1;
					month = prevMonth(month);
					if (isMonth2 && compare_month(month, opt.month1) <= 0 || isMonthOutOfBounds(month)) return;
					showMonth(month, isMonth2 ? 'month2' : 'month1');
					showGap();
				}
	
				function gotoPrevMonth_stickily(self) {
					var prevMonth1 = prevMonth(opt.month1);
					var prevMonth2 = prevMonth(opt.month2);
					if (isMonthOutOfBounds(prevMonth1)) return;
					if (!opt.singleDate && compare_month(prevMonth2, prevMonth1) <= 0) return;
					showMonth(prevMonth2, 'month2');
					showMonth(prevMonth1, 'month1');
					showSelectedDays();
				}
	
				box.attr('unselectable', 'on').css('user-select', 'none').bind('selectstart', function (e) {
					e.preventDefault();return false;
				});
	
				box.find('.apply-btn').click(function () {
					closeDatePicker();
					var dateRange = getDateString(new Date(opt.start)) + opt.separator + getDateString(new Date(opt.end));
					$(self).trigger('datepicker-apply', {
						'value': dateRange,
						'date1': new Date(opt.start),
						'date2': new Date(opt.end)
					});
				});
	
				box.find('[custom]').click(function () {
					var valueName = $(this).attr('custom');
					opt.start = false;
					opt.end = false;
					box.find('.day.checked').removeClass('checked');
					opt.setValue.call(selfDom, valueName);
					checkSelectionValid();
					showSelectedInfo(true);
					showSelectedDays();
					if (opt.autoClose) closeDatePicker();
				});
	
				box.find('[shortcut]').click(function () {
					var shortcut = $(this).attr('shortcut');
					var end = new Date(),
					    start = false;
					var dir;
					if (shortcut.indexOf('day') != -1) {
						var day = parseInt(shortcut.split(',', 2)[1], 10);
						start = new Date(new Date().getTime() + 86400000 * day);
						end = new Date(end.getTime() + 86400000 * (day > 0 ? 1 : -1));
					} else if (shortcut.indexOf('week') != -1) {
						dir = shortcut.indexOf('prev,') != -1 ? -1 : 1;
						var stopDay;
						if (dir == 1) stopDay = opt.startOfWeek == 'monday' ? 1 : 0;else stopDay = opt.startOfWeek == 'monday' ? 0 : 6;
	
						end = new Date(end.getTime() - 86400000);
						while (end.getDay() != stopDay) {
							end = new Date(end.getTime() + dir * 86400000);
						}start = new Date(end.getTime() + dir * 86400000 * 6);
					} else if (shortcut.indexOf('month') != -1) {
						dir = shortcut.indexOf('prev,') != -1 ? -1 : 1;
						if (dir == 1) start = nextMonth(end);else start = prevMonth(end);
						start.setDate(1);
						end = nextMonth(start);
						end.setDate(1);
						end = new Date(end.getTime() - 86400000);
					} else if (shortcut.indexOf('year') != -1) {
						dir = shortcut.indexOf('prev,') != -1 ? -1 : 1;
						start = new Date();
						start.setFullYear(end.getFullYear() + dir);
						start.setMonth(0);
						start.setDate(1);
						end.setFullYear(end.getFullYear() + dir);
						end.setMonth(11);
						end.setDate(31);
					} else if (shortcut == 'custom') {
						var name = $(this).html();
						if (opt.customShortcuts && opt.customShortcuts.length > 0) {
							for (var i = 0; i < opt.customShortcuts.length; i++) {
								var sh = opt.customShortcuts[i];
								if (sh.name == name) {
									var data = [];
									// try
									// {
									data = sh['dates'].call();
									//}catch(e){}
									if (data && data.length == 2) {
										start = data[0];
										end = data[1];
									}
	
									// if only one date is specified then just move calendars there
									// move calendars to show this date's month and next months
									if (data && data.length == 1) {
										var movetodate = data[0];
										showMonth(movetodate, 'month1');
										showMonth(nextMonth(movetodate), 'month2');
										showGap();
									}
	
									break;
								}
							}
						}
					}
					if (start && end) {
						_setDateRange(start, end);
						checkSelectionValid();
					}
				});
	
				box.find('.time1 input[type=range]').bind('change touchmove', function (e) {
					var target = e.target,
					    hour = target.name == 'hour' ? $(target).val().replace(/^(\d{1})$/, '0$1') : undefined,
					    min = target.name == 'minute' ? $(target).val().replace(/^(\d{1})$/, '0$1') : undefined;
					setTime('time1', hour, min);
				});
	
				box.find('.time2 input[type=range]').bind('change touchmove', function (e) {
					var target = e.target,
					    hour = target.name == 'hour' ? $(target).val().replace(/^(\d{1})$/, '0$1') : undefined,
					    min = target.name == 'minute' ? $(target).val().replace(/^(\d{1})$/, '0$1') : undefined;
					setTime('time2', hour, min);
				});
			}
	
			function calcPosition() {
				if (!opt.inline) {
					var offset = $(self).offset();
					if ($(opt.container).css('position') == 'relative') {
						var containerOffset = $(opt.container).offset();
						box.css({
							top: offset.top - containerOffset.top + $(self).outerHeight() + 4,
							left: offset.left - containerOffset.left
						});
					} else {
						if (offset.left < 460) //left to right
							{
								box.css({
									top: offset.top + $(self).outerHeight() + parseInt($('body').css('border-top') || 0, 10),
									left: offset.left
								});
							} else {
							box.css({
								top: offset.top + $(self).outerHeight() + parseInt($('body').css('border-top') || 0, 10),
								left: offset.left + $(self).width() - box.width() - 16
							});
						}
					}
				}
			}
	
			// Return the date picker wrapper element
			function getDatePicker() {
				return box;
			}
	
			function open(animationTime) {
				calcPosition();
				redrawDatePicker();
				checkAndSetDefaultValue();
				if (opt.customOpenAnimation) {
					opt.customOpenAnimation.call(box.get(0), function () {
						$(self).trigger('datepicker-opened', { relatedTarget: box });
					});
				} else {
					box.slideDown(animationTime, function () {
						$(self).trigger('datepicker-opened', { relatedTarget: box });
					});
				}
				$(self).trigger('datepicker-open', { relatedTarget: box });
				showGap();
				updateCalendarWidth();
			}
	
			function checkAndSetDefaultValue() {
				var __default_string = opt.getValue.call(selfDom);
				var defaults = __default_string ? __default_string.split(opt.separator) : '';
	
				if (defaults && (defaults.length == 1 && opt.singleDate || defaults.length >= 2)) {
					var ___format = opt.format;
					if (___format.match(/Do/)) {
	
						___format = ___format.replace(/Do/, 'D');
						defaults[0] = defaults[0].replace(/(\d+)(th|nd|st)/, '$1');
						if (defaults.length >= 2) {
							defaults[1] = defaults[1].replace(/(\d+)(th|nd|st)/, '$1');
						}
					}
					// set initiated  to avoid triggerring datepicker-change event
					initiated = false;
					if (defaults.length >= 2) {
						_setDateRange(getValidValue(defaults[0], ___format, moment.locale(opt.language)), getValidValue(defaults[1], ___format, moment.locale(opt.language)));
					} else if (defaults.length == 1 && opt.singleDate) {
						setSingleDate(getValidValue(defaults[0], ___format, moment.locale(opt.language)));
					}
	
					initiated = true;
				}
			}
	
			function getValidValue(date, format, locale) {
				if (moment(date, format, locale).isValid()) {
					return moment(date, format, locale).toDate();
				} else {
					return moment().toDate();
				}
			}
	
			function updateCalendarWidth() {
				var gapMargin = box.find('.gap').css('margin-left');
				if (gapMargin) gapMargin = parseInt(gapMargin);
				var w1 = box.find('.month1').width();
				var w2 = box.find('.gap').width() + (gapMargin ? gapMargin * 2 : 0);
				var w3 = box.find('.month2').width();
				box.find('.month-wrapper').width(w1 + w2 + w3);
			}
	
			function renderTime(name, date) {
				box.find('.' + name + ' input[type=range].hour-range').val(moment(date).hours());
				box.find('.' + name + ' input[type=range].minute-range').val(moment(date).minutes());
				setTime(name, moment(date).format('HH'), moment(date).format('mm'));
			}
	
			function changeTime(name, date) {
				opt[name] = parseInt(moment(parseInt(date)).startOf('day').add(moment(opt[name + 'Time']).format('HH'), 'h').add(moment(opt[name + 'Time']).format('mm'), 'm').valueOf());
			}
	
			function swapTime() {
				renderTime('time1', opt.start);
				renderTime('time2', opt.end);
			}
	
			function setTime(name, hour, minute) {
				hour && box.find('.' + name + ' .hour-val').text(hour);
				minute && box.find('.' + name + ' .minute-val').text(minute);
				switch (name) {
					case 'time1':
						if (opt.start) {
							setRange('start', moment(opt.start));
						}
						setRange('startTime', moment(opt.startTime || moment().valueOf()));
						break;
					case 'time2':
						if (opt.end) {
							setRange('end', moment(opt.end));
						}
						setRange('endTime', moment(opt.endTime || moment().valueOf()));
						break;
				}
				function setRange(name, timePoint) {
					var h = timePoint.format('HH'),
					    m = timePoint.format('mm');
					opt[name] = timePoint.startOf('day').add(hour || h, 'h').add(minute || m, 'm').valueOf();
				}
				checkSelectionValid();
				showSelectedInfo();
				showSelectedDays();
			}
	
			function clearSelection() {
				opt.start = false;
				opt.end = false;
				box.find('.day.checked').removeClass('checked');
				box.find('.day.last-date-selected').removeClass('last-date-selected');
				box.find('.day.first-date-selected').removeClass('first-date-selected');
				opt.setValue.call(selfDom, '');
				checkSelectionValid();
				showSelectedInfo();
				showSelectedDays();
			}
	
			function handleStart(time) {
				var r = time;
				if (opt.batchMode === 'week-range') {
					if (opt.startOfWeek === 'monday') {
						r = moment(parseInt(time)).startOf('isoweek').valueOf();
					} else {
						r = moment(parseInt(time)).startOf('week').valueOf();
					}
				} else if (opt.batchMode === 'month-range') {
					r = moment(parseInt(time)).startOf('month').valueOf();
				}
				return r;
			}
	
			function handleEnd(time) {
				var r = time;
				if (opt.batchMode === 'week-range') {
					if (opt.startOfWeek === 'monday') {
						r = moment(parseInt(time)).endOf('isoweek').valueOf();
					} else {
						r = moment(parseInt(time)).endOf('week').valueOf();
					}
				} else if (opt.batchMode === 'month-range') {
					r = moment(parseInt(time)).endOf('month').valueOf();
				}
				return r;
			}
	
			function dayClicked(day) {
				if (day.hasClass('invalid')) return;
				var time = day.attr('time');
				day.addClass('checked');
				if (opt.singleDate) {
					opt.start = time;
					opt.end = false;
				} else if (opt.batchMode === 'week') {
					if (opt.startOfWeek === 'monday') {
						opt.start = moment(parseInt(time)).startOf('isoweek').valueOf();
						opt.end = moment(parseInt(time)).endOf('isoweek').valueOf();
					} else {
						opt.end = moment(parseInt(time)).endOf('week').valueOf();
						opt.start = moment(parseInt(time)).startOf('week').valueOf();
					}
				} else if (opt.batchMode === 'workweek') {
					opt.start = moment(parseInt(time)).day(1).valueOf();
					opt.end = moment(parseInt(time)).day(5).valueOf();
				} else if (opt.batchMode === 'weekend') {
					opt.start = moment(parseInt(time)).day(6).valueOf();
					opt.end = moment(parseInt(time)).day(7).valueOf();
				} else if (opt.batchMode === 'month') {
					opt.start = moment(parseInt(time)).startOf('month').valueOf();
					opt.end = moment(parseInt(time)).endOf('month').valueOf();
				} else if (opt.start && opt.end || !opt.start && !opt.end) {
					opt.start = handleStart(time);
					opt.end = false;
				} else if (opt.start) {
					opt.end = handleEnd(time);
					if (opt.time.enabled) {
						changeTime('end', opt.end);
					}
				}
	
				//Update time in case it is enabled and timestamps are available
				if (opt.time.enabled) {
					if (opt.start) {
						changeTime('start', opt.start);
					}
					if (opt.end) {
						changeTime('end', opt.end);
					}
				}
	
				//In case the start is after the end, swap the timestamps
				if (!opt.singleDate && opt.start && opt.end && opt.start > opt.end) {
					var tmp = opt.end;
					opt.end = handleEnd(opt.start);
					opt.start = handleStart(tmp);
					if (opt.time.enabled && opt.swapTime) {
						swapTime();
					}
				}
	
				opt.start = parseInt(opt.start);
				opt.end = parseInt(opt.end);
	
				clearHovering();
				if (opt.start && !opt.end) {
					$(self).trigger('datepicker-first-date-selected', {
						'date1': new Date(opt.start)
					});
					dayHovering(day);
				}
				updateSelectableRange(time);
	
				checkSelectionValid();
				showSelectedInfo();
				showSelectedDays();
				autoclose();
			}
	
			function weekNumberClicked(weekNumberDom) {
				var thisTime = parseInt(weekNumberDom.attr('data-start-time'), 10);
				var date1, date2;
				if (!opt.startWeek) {
					opt.startWeek = thisTime;
					weekNumberDom.addClass('week-number-selected');
					date1 = new Date(thisTime);
					opt.start = moment(date1).day(opt.startOfWeek == 'monday' ? 1 : 0).valueOf();
					opt.end = moment(date1).day(opt.startOfWeek == 'monday' ? 7 : 6).valueOf();
				} else {
					box.find('.week-number-selected').removeClass('week-number-selected');
					date1 = new Date(thisTime < opt.startWeek ? thisTime : opt.startWeek);
					date2 = new Date(thisTime < opt.startWeek ? opt.startWeek : thisTime);
					opt.startWeek = false;
					opt.start = moment(date1).day(opt.startOfWeek == 'monday' ? 1 : 0).valueOf();
					opt.end = moment(date2).day(opt.startOfWeek == 'monday' ? 7 : 6).valueOf();
				}
				updateSelectableRange();
				checkSelectionValid();
				showSelectedInfo();
				showSelectedDays();
				autoclose();
			}
	
			function isValidTime(time) {
				time = parseInt(time, 10);
				if (opt.startDate && compare_day(time, opt.startDate) < 0) return false;
				if (opt.endDate && compare_day(time, opt.endDate) > 0) return false;
	
				if (opt.start && !opt.end && !opt.singleDate) {
					//check maxDays and minDays setting
					if (opt.maxDays > 0 && countDays(time, opt.start) > opt.maxDays) return false;
					if (opt.minDays > 0 && countDays(time, opt.start) < opt.minDays) return false;
	
					//check selectForward and selectBackward
					if (opt.selectForward && time < opt.start) return false;
					if (opt.selectBackward && time > opt.start) return false;
	
					//check disabled days
					if (opt.beforeShowDay && typeof opt.beforeShowDay == 'function') {
						var valid = true;
						var timeTmp = time;
						while (countDays(timeTmp, opt.start) > 1) {
							var arr = opt.beforeShowDay(new Date(timeTmp));
							if (!arr[0]) {
								valid = false;
								break;
							}
							if (Math.abs(timeTmp - opt.start) < 86400000) break;
							if (timeTmp > opt.start) timeTmp -= 86400000;
							if (timeTmp < opt.start) timeTmp += 86400000;
						}
						if (!valid) return false;
					}
				}
				return true;
			}
	
			function updateSelectableRange() {
				box.find('.day.invalid.tmp').removeClass('tmp invalid').addClass('valid');
				if (opt.start && !opt.end) {
					box.find('.day.toMonth.valid').each(function () {
						var time = parseInt($(this).attr('time'), 10);
						if (!isValidTime(time)) $(this).addClass('invalid tmp').removeClass('valid');else $(this).addClass('valid tmp').removeClass('invalid');
					});
				}
	
				return true;
			}
	
			function dayHovering(day) {
				var hoverTime = parseInt(day.attr('time'));
				var tooltip = '';
	
				if (day.hasClass('has-tooltip') && day.attr('data-tooltip')) {
					tooltip = '<span style="white-space:nowrap">' + day.attr('data-tooltip') + '</span>';
				} else if (!day.hasClass('invalid')) {
					if (opt.singleDate) {
						box.find('.day.hovering').removeClass('hovering');
						day.addClass('hovering');
					} else {
						box.find('.day').each(function () {
							var time = parseInt($(this).attr('time')),
							    start = opt.start,
							    end = opt.end;
	
							if (time == hoverTime) {
								$(this).addClass('hovering');
							} else {
								$(this).removeClass('hovering');
							}
	
							if (opt.start && !opt.end && (opt.start < time && hoverTime >= time || opt.start > time && hoverTime <= time)) {
								$(this).addClass('hovering');
							} else {
								$(this).removeClass('hovering');
							}
						});
	
						if (opt.start && !opt.end) {
							var days = countDays(hoverTime, opt.start);
							if (opt.hoveringTooltip) {
								if (typeof opt.hoveringTooltip == 'function') {
									tooltip = opt.hoveringTooltip(days, opt.start, hoverTime);
								} else if (opt.hoveringTooltip === true && days > 1) {
									tooltip = days + ' ' + lang('days');
								}
							}
						}
					}
				}
	
				if (tooltip) {
					var posDay = day.offset();
					var posBox = box.offset();
	
					var _left = posDay.left - posBox.left;
					var _top = posDay.top - posBox.top;
					_left += day.width() / 2;
	
					var $tip = box.find('.date-range-length-tip');
					var w = $tip.css({ 'visibility': 'hidden', 'display': 'none' }).html(tooltip).width();
					var h = $tip.height();
					_left -= w / 2;
					_top -= h;
					setTimeout(function () {
						$tip.css({ left: _left, top: _top, display: 'block', 'visibility': 'visible' });
					}, 10);
				} else {
					box.find('.date-range-length-tip').hide();
				}
			}
	
			function clearHovering() {
				box.find('.day.hovering').removeClass('hovering');
				box.find('.date-range-length-tip').hide();
			}
	
			function autoclose() {
				if (opt.singleDate === true) {
					if (initiated && opt.start) {
						if (opt.autoClose) closeDatePicker();
					}
				} else {
					if (initiated && opt.start && opt.end) {
						if (opt.autoClose) closeDatePicker();
					}
				}
			}
	
			function checkSelectionValid() {
				var days = Math.ceil((opt.end - opt.start) / 86400000) + 1;
				if (opt.singleDate) {
					// Validate if only start is there
					if (opt.start && !opt.end) box.find('.drp_top-bar').removeClass('error').addClass('normal');else box.find('.drp_top-bar').removeClass('error').removeClass('normal');
				} else if (opt.maxDays && days > opt.maxDays) {
					opt.start = false;
					opt.end = false;
					box.find('.day').removeClass('checked');
					box.find('.drp_top-bar').removeClass('normal').addClass('error').find('.error-top').html(lang('less-than').replace('%d', opt.maxDays));
				} else if (opt.minDays && days < opt.minDays) {
					opt.start = false;
					opt.end = false;
					box.find('.day').removeClass('checked');
					box.find('.drp_top-bar').removeClass('normal').addClass('error').find('.error-top').html(lang('more-than').replace('%d', opt.minDays));
				} else {
					if (opt.start || opt.end) box.find('.drp_top-bar').removeClass('error').addClass('normal');else box.find('.drp_top-bar').removeClass('error').removeClass('normal');
				}
	
				if (opt.singleDate && opt.start && !opt.end || !opt.singleDate && opt.start && opt.end) {
					box.find('.apply-btn').removeClass('disabled');
				} else {
					box.find('.apply-btn').addClass('disabled');
				}
	
				if (opt.batchMode) {
					if (opt.start && opt.startDate && compare_day(opt.start, opt.startDate) < 0 || opt.end && opt.endDate && compare_day(opt.end, opt.endDate) > 0) {
						opt.start = false;
						opt.end = false;
						box.find('.day').removeClass('checked');
					}
				}
			}
	
			function showSelectedInfo(forceValid, silent) {
				box.find('.start-day').html('...');
				box.find('.end-day').html('...');
				box.find('.selected-days').hide();
				if (opt.start) {
					box.find('.start-day').html(getDateString(new Date(parseInt(opt.start))));
				}
				if (opt.end) {
					box.find('.end-day').html(getDateString(new Date(parseInt(opt.end))));
				}
				var dateRange;
				if (opt.start && opt.singleDate) {
					box.find('.apply-btn').removeClass('disabled');
					dateRange = getDateString(new Date(opt.start));
					opt.setValue.call(selfDom, dateRange, getDateString(new Date(opt.start)), getDateString(new Date(opt.end)));
	
					if (initiated && !silent) {
						$(self).trigger('datepicker-change', {
							'value': dateRange,
							'date1': new Date(opt.start)
						});
					}
				} else if (opt.start && opt.end) {
					box.find('.selected-days').show().find('.selected-days-num').html(countDays(opt.end, opt.start));
					box.find('.apply-btn').removeClass('disabled');
					dateRange = getDateString(new Date(opt.start)) + opt.separator + getDateString(new Date(opt.end));
					opt.setValue.call(selfDom, dateRange, getDateString(new Date(opt.start)), getDateString(new Date(opt.end)));
					if (initiated && !silent) {
						$(self).trigger('datepicker-change', {
							'value': dateRange,
							'date1': new Date(opt.start),
							'date2': new Date(opt.end)
						});
					}
				} else if (forceValid) {
					box.find('.apply-btn').removeClass('disabled');
				} else {
					box.find('.apply-btn').addClass('disabled');
				}
			}
	
			function countDays(start, end) {
				return Math.abs(daysFrom1970(start) - daysFrom1970(end)) + 1;
			}
	
			function _setDateRange(date1, date2, silent) {
				if (date1.getTime() > date2.getTime()) {
					var tmp = date2;
					date2 = date1;
					date1 = tmp;
					tmp = null;
				}
				var valid = true;
				if (opt.startDate && compare_day(date1, opt.startDate) < 0) valid = false;
				if (opt.endDate && compare_day(date2, opt.endDate) > 0) valid = false;
				if (!valid) {
					showMonth(opt.startDate, 'month1');
					showMonth(nextMonth(opt.startDate), 'month2');
					showGap();
					return;
				}
	
				opt.start = date1.getTime();
				opt.end = date2.getTime();
	
				if (opt.time.enabled) {
					renderTime('time1', date1);
					renderTime('time2', date2);
				}
	
				if (opt.stickyMonths || compare_day(date1, date2) > 0 && compare_month(date1, date2) === 0) {
					if (opt.lookBehind) {
						date1 = prevMonth(date2);
					} else {
						date2 = nextMonth(date1);
					}
				}
	
				if (opt.stickyMonths && opt.endDate !== false && compare_month(date2, opt.endDate) > 0) {
					date1 = prevMonth(date1);
					date2 = prevMonth(date2);
				}
	
				if (!opt.stickyMonths) {
					if (compare_month(date1, date2) === 0) {
						if (opt.lookBehind) {
							date1 = prevMonth(date2);
						} else {
							date2 = nextMonth(date1);
						}
					}
				}
	
				showMonth(date1, 'month1');
				showMonth(date2, 'month2');
				showGap();
				checkSelectionValid();
				showSelectedInfo(false, silent);
				autoclose();
			}
	
			function setSingleDate(date1) {
	
				var valid = true;
				if (opt.startDate && compare_day(date1, opt.startDate) < 0) valid = false;
				if (opt.endDate && compare_day(date1, opt.endDate) > 0) valid = false;
				if (!valid) {
					showMonth(opt.startDate, 'month1');
					return;
				}
	
				opt.start = date1.getTime();
	
				if (opt.time.enabled) {
					renderTime('time1', date1);
				}
				showMonth(date1, 'month1');
				if (opt.singleMonth !== true) {
					var date2 = nextMonth(date1);
					showMonth(date2, 'month2');
				}
				showGap();
				showSelectedInfo();
				autoclose();
			}
	
			function showSelectedDays() {
				if (!opt.start && !opt.end) return;
				box.find('.day').each(function () {
					var time = parseInt($(this).attr('time')),
					    start = opt.start,
					    end = opt.end;
					if (opt.time.enabled) {
						time = moment(time).startOf('day').valueOf();
						start = moment(start || moment().valueOf()).startOf('day').valueOf();
						end = moment(end || moment().valueOf()).startOf('day').valueOf();
					}
					if (opt.start && opt.end && end >= time && start <= time || opt.start && !opt.end && moment(start).format('YYYY-MM-DD') == moment(time).format('YYYY-MM-DD')) {
						$(this).addClass('checked');
					} else {
						$(this).removeClass('checked');
					}
	
					//add first-date-selected class name to the first date selected
					if (opt.start && moment(start).format('YYYY-MM-DD') == moment(time).format('YYYY-MM-DD')) {
						$(this).addClass('first-date-selected');
					} else {
						$(this).removeClass('first-date-selected');
					}
					//add last-date-selected
					if (opt.end && moment(end).format('YYYY-MM-DD') == moment(time).format('YYYY-MM-DD')) {
						$(this).addClass('last-date-selected');
					} else {
						$(this).removeClass('last-date-selected');
					}
				});
	
				box.find('.week-number').each(function () {
					if ($(this).attr('data-start-time') == opt.startWeek) {
						$(this).addClass('week-number-selected');
					}
				});
			}
	
			function showMonth(date, month) {
				date = moment(date).toDate();
				var monthName = nameMonth(date.getMonth());
				box.find('.' + month + ' .month-name').html(monthName + ' ' + date.getFullYear());
				box.find('.' + month + ' tbody').html(createMonthHTML(date));
				opt[month] = date;
				updateSelectableRange();
				bindDayEvents();
			}
	
			function bindDayEvents() {
				box.find('.day').unbind("click").click(function (evt) {
					dayClicked($(this));
				});
	
				box.find('.day').unbind("mouseenter").mouseenter(function (evt) {
					dayHovering($(this));
				});
	
				box.find('.day').unbind("mouseleave").mouseleave(function (evt) {
					box.find('.date-range-length-tip').hide();
					if (opt.singleDate) {
						clearHovering();
					}
				});
	
				box.find('.week-number').unbind("click").click(function (evt) {
					weekNumberClicked($(this));
				});
			}
	
			function showTime(date, name) {
				box.find('.' + name).append(getTimeHTML());
				renderTime(name, date);
			}
	
			function nameMonth(m) {
				return lang('month-name')[m];
			}
	
			function getDateString(d) {
				return moment(d).format(opt.format);
			}
	
			function showGap() {
				showSelectedDays();
				var m1 = parseInt(moment(opt.month1).format('YYYYMM'));
				var m2 = parseInt(moment(opt.month2).format('YYYYMM'));
				var p = Math.abs(m1 - m2);
				var shouldShow = p > 1 && p != 89;
				if (shouldShow) {
					box.addClass('has-gap').removeClass('no-gap').find('.gap').css('visibility', 'visible');
				} else {
					box.removeClass('has-gap').addClass('no-gap').find('.gap').css('visibility', 'hidden');
				}
				var h1 = box.find('table.month1').height();
				var h2 = box.find('table.month2').height();
				box.find('.gap').height(Math.max(h1, h2) + 10);
			}
	
			function closeDatePicker() {
				if (opt.alwaysOpen) return;
	
				var afterAnim = function afterAnim() {
					$(self).data('date-picker-opened', false);
					$(self).trigger('datepicker-closed', { relatedTarget: box });
				};
				if (opt.customCloseAnimation) {
					opt.customCloseAnimation.call(box.get(0), afterAnim);
				} else {
					$(box).slideUp(opt.duration, afterAnim);
				}
				$(self).trigger('datepicker-close', { relatedTarget: box });
			}
	
			function redrawDatePicker() {
				showMonth(opt.month1, 'month1');
				showMonth(opt.month2, 'month2');
			}
	
			function compare_month(m1, m2) {
				var p = parseInt(moment(m1).format('YYYYMM')) - parseInt(moment(m2).format('YYYYMM'));
				if (p > 0) return 1;
				if (p === 0) return 0;
				return -1;
			}
	
			function compare_day(m1, m2) {
				var p = parseInt(moment(m1).format('YYYYMMDD')) - parseInt(moment(m2).format('YYYYMMDD'));
				if (p > 0) return 1;
				if (p === 0) return 0;
				return -1;
			}
	
			function nextMonth(month) {
				return moment(month).add(1, 'months').toDate();
			}
	
			function prevMonth(month) {
				return moment(month).add(-1, 'months').toDate();
			}
	
			function getTimeHTML() {
				return '<div>' + '<span>' + lang('Time') + ': <span class="hour-val">00</span>:<span class="minute-val">00</span></span>' + '</div>' + '<div class="hour">' + '<label>' + lang('Hour') + ': <input type="range" class="hour-range" name="hour" min="0" max="23"></label>' + '</div>' + '<div class="minute">' + '<label>' + lang('Minute') + ': <input type="range" class="minute-range" name="minute" min="0" max="59"></label>' + '</div>';
			}
	
			function createDom() {
				var html = '<div class="date-picker-wrapper';
				if (opt.extraClass) html += ' ' + opt.extraClass + ' ';
				if (opt.singleDate) html += ' single-date ';
				if (!opt.showShortcuts) html += ' no-shortcuts ';
				if (!opt.showTopbar) html += ' no-topbar ';
				if (opt.customTopBar) html += ' custom-topbar ';
				html += '">';
	
				if (opt.showTopbar) {
					html += '<div class="drp_top-bar">';
	
					if (opt.customTopBar) {
						if (typeof opt.customTopBar == 'function') opt.customTopBar = opt.customTopBar();
						html += '<div class="custom-top">' + opt.customTopBar + '</div>';
					} else {
						html += '<div class="normal-top">' + '<span style="color:#333">' + lang('selected') + ' </span> <b class="start-day">...</b>';
						if (!opt.singleDate) {
							html += ' <span class="separator-day">' + opt.separator + '</span> <b class="end-day">...</b> <i class="selected-days">(<span class="selected-days-num">3</span> ' + lang('days') + ')</i>';
						}
						html += '</div>';
						html += '<div class="error-top">error</div>' + '<div class="default-top">default</div>';
					}
	
					html += '<input type="button" class="apply-btn disabled' + getApplyBtnClass() + '" value="' + lang('apply') + '" />';
					html += '</div>';
				}
	
				var _colspan = opt.showWeekNumbers ? 6 : 5;
	
				var arrowPrev = '&lt;';
				if (opt.customArrowPrevSymbol) arrowPrev = opt.customArrowPrevSymbol;
	
				var arrowNext = '&gt;';
				if (opt.customArrowNextSymbol) arrowNext = opt.customArrowNextSymbol;
	
				html += '<div class="month-wrapper">' + '   <table class="month1" cellspacing="0" border="0" cellpadding="0">' + '       <thead>' + '           <tr class="caption">' + '               <th style="width:27px;">' + '                   <span class="prev">' + arrowPrev + '                   </span>' + '               </th>' + '               <th colspan="' + _colspan + '" class="month-name">' + '               </th>' + '               <th style="width:27px;">' + (opt.singleDate || !opt.stickyMonths ? '<span class="next">' + arrowNext + '</span>' : '') + '               </th>' + '           </tr>' + '           <tr class="week-name">' + getWeekHead() + '       </thead>' + '       <tbody></tbody>' + '   </table>';
	
				if (hasMonth2()) {
					html += '<div class="gap">' + getGapHTML() + '</div>' + '<table class="month2" cellspacing="0" border="0" cellpadding="0">' + '   <thead>' + '   <tr class="caption">' + '       <th style="width:27px;">' + (!opt.stickyMonths ? '<span class="prev">' + arrowPrev + '</span>' : '') + '       </th>' + '       <th colspan="' + _colspan + '" class="month-name">' + '       </th>' + '       <th style="width:27px;">' + '           <span class="next">' + arrowNext + '</span>' + '       </th>' + '   </tr>' + '   <tr class="week-name">' + getWeekHead() + '   </thead>' + '   <tbody></tbody>' + '</table>';
				}
				//+'</div>'
				html += '<div style="clear:both;height:0;font-size:0;"></div>' + '<div class="time">' + '<div class="time1"></div>';
				if (!opt.singleDate) {
					html += '<div class="time2"></div>';
				}
				html += '</div>' + '<div style="clear:both;height:0;font-size:0;"></div>' + '</div>';
	
				html += '<div class="footer">';
				if (opt.showShortcuts) {
					html += '<div class="shortcuts"><b>' + lang('shortcuts') + '</b>';
	
					var data = opt.shortcuts;
					if (data) {
						var name;
						if (data['prev-days'] && data['prev-days'].length > 0) {
							html += '&nbsp;<span class="prev-days">' + lang('past');
							for (var i = 0; i < data['prev-days'].length; i++) {
								name = data['prev-days'][i];
								name += data['prev-days'][i] > 1 ? lang('days') : lang('day');
								html += ' <a href="javascript:;" shortcut="day,-' + data['prev-days'][i] + '">' + name + '</a>';
							}
							html += '</span>';
						}
	
						if (data['next-days'] && data['next-days'].length > 0) {
							html += '&nbsp;<span class="next-days">' + lang('following');
							for (var i = 0; i < data['next-days'].length; i++) {
								name = data['next-days'][i];
								name += data['next-days'][i] > 1 ? lang('days') : lang('day');
								html += ' <a href="javascript:;" shortcut="day,' + data['next-days'][i] + '">' + name + '</a>';
							}
							html += '</span>';
						}
	
						if (data.prev && data.prev.length > 0) {
							html += '&nbsp;<span class="prev-buttons">' + lang('previous');
							for (var i = 0; i < data.prev.length; i++) {
								name = lang('prev-' + data.prev[i]);
								html += ' <a href="javascript:;" shortcut="prev,' + data.prev[i] + '">' + name + '</a>';
							}
							html += '</span>';
						}
	
						if (data.next && data.next.length > 0) {
							html += '&nbsp;<span class="next-buttons">' + lang('next');
							for (var i = 0; i < data.next.length; i++) {
								name = lang('next-' + data.next[i]);
								html += ' <a href="javascript:;" shortcut="next,' + data.next[i] + '">' + name + '</a>';
							}
							html += '</span>';
						}
					}
	
					if (opt.customShortcuts) {
						for (var i = 0; i < opt.customShortcuts.length; i++) {
							var sh = opt.customShortcuts[i];
							html += '&nbsp;<span class="custom-shortcut"><a href="javascript:;" shortcut="custom">' + sh.name + '</a></span>';
						}
					}
					html += '</div>';
				}
	
				// Add Custom Values Dom
				if (opt.showCustomValues) {
					html += '<div class="customValues"><b>' + (opt.customValueLabel || lang('custom-values')) + '</b>';
	
					if (opt.customValues) {
						for (var i = 0; i < opt.customValues.length; i++) {
							var val = opt.customValues[i];
							html += '&nbsp;<span class="custom-value"><a href="javascript:;" custom="' + val.value + '">' + val.name + '</a></span>';
						}
					}
				}
	
				html += '</div></div>';
	
				return $(html);
			}
	
			function getApplyBtnClass() {
				var klass = '';
				if (opt.autoClose === true) {
					klass += ' hide';
				}
				if (opt.applyBtnClass !== '') {
					klass += ' ' + opt.applyBtnClass;
				}
				return klass;
			}
	
			function getWeekHead() {
				var prepend = opt.showWeekNumbers ? '<th>' + lang('week-number') + '</th>' : '';
				if (opt.startOfWeek == 'monday') {
					return prepend + '<th>' + lang('week-1') + '</th>' + '<th>' + lang('week-2') + '</th>' + '<th>' + lang('week-3') + '</th>' + '<th>' + lang('week-4') + '</th>' + '<th>' + lang('week-5') + '</th>' + '<th>' + lang('week-6') + '</th>' + '<th>' + lang('week-7') + '</th>';
				} else {
					return prepend + '<th>' + lang('week-7') + '</th>' + '<th>' + lang('week-1') + '</th>' + '<th>' + lang('week-2') + '</th>' + '<th>' + lang('week-3') + '</th>' + '<th>' + lang('week-4') + '</th>' + '<th>' + lang('week-5') + '</th>' + '<th>' + lang('week-6') + '</th>';
				}
			}
	
			function isMonthOutOfBounds(month) {
				month = moment(month);
				if (opt.startDate && month.endOf('month').isBefore(opt.startDate)) {
					return true;
				}
				if (opt.endDate && month.startOf('month').isAfter(opt.endDate)) {
					return true;
				}
				return false;
			}
	
			function getGapHTML() {
				var html = ['<div class="gap-top-mask"></div><div class="gap-bottom-mask"></div><div class="gap-lines">'];
				for (var i = 0; i < 20; i++) {
					html.push('<div class="gap-line">' + '<div class="gap-1"></div>' + '<div class="gap-2"></div>' + '<div class="gap-3"></div>' + '</div>');
				}
				html.push('</div>');
				return html.join('');
			}
	
			function hasMonth2() {
				return !opt.singleMonth;
			}
	
			function attributesCallbacks(initialObject, callbacksArray, today) {
				var resultObject = $.extend(true, {}, initialObject);
	
				$.each(callbacksArray, function (cbAttrIndex, cbAttr) {
					var addAttributes = cbAttr(today);
					for (var attr in addAttributes) {
						if (resultObject.hasOwnProperty(attr)) {
							resultObject[attr] += addAttributes[attr];
						} else {
							resultObject[attr] = addAttributes[attr];
						}
					}
				});
	
				var attrString = '';
	
				for (var attr in resultObject) {
					if (resultObject.hasOwnProperty(attr)) {
						attrString += attr + '="' + resultObject[attr] + '" ';
					}
				}
	
				return attrString;
			}
	
			function daysFrom1970(t) {
				return Math.floor(toLocalTimestamp(t) / 86400000);
			}
	
			function toLocalTimestamp(t) {
				if (moment.isMoment(t)) t = t.toDate().getTime();
				if ((typeof t === 'undefined' ? 'undefined' : _typeof(t)) == 'object' && t.getTime) t = t.getTime();
				if (typeof t == 'string' && !t.match(/\d{13}/)) t = moment(t, opt.format).toDate().getTime();
				t = parseInt(t, 10) - new Date().getTimezoneOffset() * 60 * 1000;
				return t;
			}
	
			function createMonthHTML(d) {
				var days = [];
				d.setDate(1);
				var lastMonth = new Date(d.getTime() - 86400000);
				var now = new Date();
	
				var dayOfWeek = d.getDay();
				if (dayOfWeek === 0 && opt.startOfWeek === 'monday') {
					// add one week
					dayOfWeek = 7;
				}
				var today, valid;
	
				if (dayOfWeek > 0) {
					for (var i = dayOfWeek; i > 0; i--) {
						var day = new Date(d.getTime() - 86400000 * i);
						valid = isValidTime(day.getTime());
						if (opt.startDate && compare_day(day, opt.startDate) < 0) valid = false;
						if (opt.endDate && compare_day(day, opt.endDate) > 0) valid = false;
						days.push({
							date: day,
							type: 'lastMonth',
							day: day.getDate(),
							time: day.getTime(),
							valid: valid
						});
					}
				}
				var toMonth = d.getMonth();
				for (var i = 0; i < 40; i++) {
					today = moment(d).add(i, 'days').toDate();
					valid = isValidTime(today.getTime());
					if (opt.startDate && compare_day(today, opt.startDate) < 0) valid = false;
					if (opt.endDate && compare_day(today, opt.endDate) > 0) valid = false;
					days.push({
						date: today,
						type: today.getMonth() == toMonth ? 'toMonth' : 'nextMonth',
						day: today.getDate(),
						time: today.getTime(),
						valid: valid
					});
				}
				var html = [];
				for (var week = 0; week < 6; week++) {
					if (days[week * 7].type == 'nextMonth') break;
					html.push('<tr>');
	
					for (var day = 0; day < 7; day++) {
						var _day = opt.startOfWeek == 'monday' ? day + 1 : day;
						today = days[week * 7 + _day];
						var highlightToday = moment(today.time).format('L') == moment(now).format('L');
						today.extraClass = '';
						today.tooltip = '';
						if (today.valid && opt.beforeShowDay && typeof opt.beforeShowDay == 'function') {
							var _r = opt.beforeShowDay(moment(today.time).toDate());
							today.valid = _r[0];
							today.extraClass = _r[1] || '';
							today.tooltip = _r[2] || '';
							if (today.tooltip !== '') today.extraClass += ' has-tooltip ';
						}
	
						var todayDivAttr = {
							time: today.time,
							'data-tooltip': today.tooltip,
							'class': 'day ' + today.type + ' ' + today.extraClass + ' ' + (today.valid ? 'valid' : 'invalid') + ' ' + (highlightToday ? 'real-today' : '')
						};
	
						if (day === 0 && opt.showWeekNumbers) {
							html.push('<td><div class="week-number" data-start-time="' + today.time + '">' + opt.getWeekNumber(today.date) + '</div></td>');
						}
	
						html.push('<td ' + attributesCallbacks({}, opt.dayTdAttrs, today) + '><div ' + attributesCallbacks(todayDivAttr, opt.dayDivAttrs, today) + '>' + showDayHTML(today.time, today.day) + '</div></td>');
					}
					html.push('</tr>');
				}
				return html.join('');
			}
	
			function showDayHTML(time, date) {
				if (opt.showDateFilter && typeof opt.showDateFilter == 'function') return opt.showDateFilter(time, date);
				return date;
			}
	
			function getLanguages() {
				if (opt.language == 'auto') {
					var language = navigator.language ? navigator.language : navigator.browserLanguage;
					if (!language) return $.dateRangePickerLanguages['default'];
					language = language.toLowerCase();
					for (var key in $.dateRangePickerLanguages) {
						if (language.indexOf(key) !== -1) {
							return $.dateRangePickerLanguages[key];
						}
					}
					return $.dateRangePickerLanguages['default'];
				} else if (opt.language && opt.language in $.dateRangePickerLanguages) {
					return $.dateRangePickerLanguages[opt.language];
				} else {
					return $.dateRangePickerLanguages['default'];
				}
			}
	
			/**
	   * translate language string
	   */
			function lang(t) {
				var _t = t.toLowerCase();
				var re = t in langs ? langs[t] : _t in langs ? langs[_t] : null;
				var defaultLanguage = $.dateRangePickerLanguages['default'];
				if (re == null) re = t in defaultLanguage ? defaultLanguage[t] : _t in defaultLanguage ? defaultLanguage[_t] : '';
				return re;
			}
	
			function getDefaultTime() {
				var defaultTime = opt.defaultTime ? opt.defaultTime : new Date();
	
				if (opt.lookBehind) {
					if (opt.startDate && compare_month(defaultTime, opt.startDate) < 0) defaultTime = nextMonth(moment(opt.startDate).toDate());
					if (opt.endDate && compare_month(defaultTime, opt.endDate) > 0) defaultTime = moment(opt.endDate).toDate();
				} else {
					if (opt.startDate && compare_month(defaultTime, opt.startDate) < 0) defaultTime = moment(opt.startDate).toDate();
					if (opt.endDate && compare_month(nextMonth(defaultTime), opt.endDate) > 0) defaultTime = prevMonth(moment(opt.endDate).toDate());
				}
	
				if (opt.singleDate) {
					if (opt.startDate && compare_month(defaultTime, opt.startDate) < 0) defaultTime = moment(opt.startDate).toDate();
					if (opt.endDate && compare_month(defaultTime, opt.endDate) > 0) defaultTime = moment(opt.endDate).toDate();
				}
	
				return defaultTime;
			}
	
			function resetMonthsView(time) {
				if (!time) {
					time = getDefaultTime();
				}
	
				if (opt.lookBehind) {
					showMonth(prevMonth(time), 'month1');
					showMonth(time, 'month2');
				} else {
					showMonth(time, 'month1');
					showMonth(nextMonth(time), 'month2');
				}
	
				if (opt.singleDate) {
					showMonth(time, 'month1');
				}
	
				showSelectedDays();
				showGap();
			}
		};
	});

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(722)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.4';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(124)(module)))

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 723,
		"./af.js": 723,
		"./ar": 724,
		"./ar-dz": 725,
		"./ar-dz.js": 725,
		"./ar-kw": 726,
		"./ar-kw.js": 726,
		"./ar-ly": 727,
		"./ar-ly.js": 727,
		"./ar-ma": 728,
		"./ar-ma.js": 728,
		"./ar-sa": 729,
		"./ar-sa.js": 729,
		"./ar-tn": 730,
		"./ar-tn.js": 730,
		"./ar.js": 724,
		"./az": 731,
		"./az.js": 731,
		"./be": 732,
		"./be.js": 732,
		"./bg": 733,
		"./bg.js": 733,
		"./bm": 734,
		"./bm.js": 734,
		"./bn": 735,
		"./bn-bd": 736,
		"./bn-bd.js": 736,
		"./bn.js": 735,
		"./bo": 737,
		"./bo.js": 737,
		"./br": 738,
		"./br.js": 738,
		"./bs": 739,
		"./bs.js": 739,
		"./ca": 740,
		"./ca.js": 740,
		"./cs": 741,
		"./cs.js": 741,
		"./cv": 742,
		"./cv.js": 742,
		"./cy": 743,
		"./cy.js": 743,
		"./da": 744,
		"./da.js": 744,
		"./de": 745,
		"./de-at": 746,
		"./de-at.js": 746,
		"./de-ch": 747,
		"./de-ch.js": 747,
		"./de.js": 745,
		"./dv": 748,
		"./dv.js": 748,
		"./el": 749,
		"./el.js": 749,
		"./en-au": 750,
		"./en-au.js": 750,
		"./en-ca": 751,
		"./en-ca.js": 751,
		"./en-gb": 752,
		"./en-gb.js": 752,
		"./en-ie": 753,
		"./en-ie.js": 753,
		"./en-il": 754,
		"./en-il.js": 754,
		"./en-in": 755,
		"./en-in.js": 755,
		"./en-nz": 756,
		"./en-nz.js": 756,
		"./en-sg": 757,
		"./en-sg.js": 757,
		"./eo": 758,
		"./eo.js": 758,
		"./es": 759,
		"./es-do": 760,
		"./es-do.js": 760,
		"./es-mx": 761,
		"./es-mx.js": 761,
		"./es-us": 762,
		"./es-us.js": 762,
		"./es.js": 759,
		"./et": 763,
		"./et.js": 763,
		"./eu": 764,
		"./eu.js": 764,
		"./fa": 765,
		"./fa.js": 765,
		"./fi": 766,
		"./fi.js": 766,
		"./fil": 767,
		"./fil.js": 767,
		"./fo": 768,
		"./fo.js": 768,
		"./fr": 769,
		"./fr-ca": 770,
		"./fr-ca.js": 770,
		"./fr-ch": 771,
		"./fr-ch.js": 771,
		"./fr.js": 769,
		"./fy": 772,
		"./fy.js": 772,
		"./ga": 773,
		"./ga.js": 773,
		"./gd": 774,
		"./gd.js": 774,
		"./gl": 775,
		"./gl.js": 775,
		"./gom-deva": 776,
		"./gom-deva.js": 776,
		"./gom-latn": 777,
		"./gom-latn.js": 777,
		"./gu": 778,
		"./gu.js": 778,
		"./he": 779,
		"./he.js": 779,
		"./hi": 780,
		"./hi.js": 780,
		"./hr": 781,
		"./hr.js": 781,
		"./hu": 782,
		"./hu.js": 782,
		"./hy-am": 783,
		"./hy-am.js": 783,
		"./id": 784,
		"./id.js": 784,
		"./is": 785,
		"./is.js": 785,
		"./it": 786,
		"./it-ch": 787,
		"./it-ch.js": 787,
		"./it.js": 786,
		"./ja": 788,
		"./ja.js": 788,
		"./jv": 789,
		"./jv.js": 789,
		"./ka": 790,
		"./ka.js": 790,
		"./kk": 791,
		"./kk.js": 791,
		"./km": 792,
		"./km.js": 792,
		"./kn": 793,
		"./kn.js": 793,
		"./ko": 794,
		"./ko.js": 794,
		"./ku": 795,
		"./ku.js": 795,
		"./ky": 796,
		"./ky.js": 796,
		"./lb": 797,
		"./lb.js": 797,
		"./lo": 798,
		"./lo.js": 798,
		"./lt": 799,
		"./lt.js": 799,
		"./lv": 800,
		"./lv.js": 800,
		"./me": 801,
		"./me.js": 801,
		"./mi": 802,
		"./mi.js": 802,
		"./mk": 803,
		"./mk.js": 803,
		"./ml": 804,
		"./ml.js": 804,
		"./mn": 805,
		"./mn.js": 805,
		"./mr": 806,
		"./mr.js": 806,
		"./ms": 807,
		"./ms-my": 808,
		"./ms-my.js": 808,
		"./ms.js": 807,
		"./mt": 809,
		"./mt.js": 809,
		"./my": 810,
		"./my.js": 810,
		"./nb": 811,
		"./nb.js": 811,
		"./ne": 812,
		"./ne.js": 812,
		"./nl": 813,
		"./nl-be": 814,
		"./nl-be.js": 814,
		"./nl.js": 813,
		"./nn": 815,
		"./nn.js": 815,
		"./oc-lnc": 816,
		"./oc-lnc.js": 816,
		"./pa-in": 817,
		"./pa-in.js": 817,
		"./pl": 818,
		"./pl.js": 818,
		"./pt": 819,
		"./pt-br": 820,
		"./pt-br.js": 820,
		"./pt.js": 819,
		"./ro": 821,
		"./ro.js": 821,
		"./ru": 822,
		"./ru.js": 822,
		"./sd": 823,
		"./sd.js": 823,
		"./se": 824,
		"./se.js": 824,
		"./si": 825,
		"./si.js": 825,
		"./sk": 826,
		"./sk.js": 826,
		"./sl": 827,
		"./sl.js": 827,
		"./sq": 828,
		"./sq.js": 828,
		"./sr": 829,
		"./sr-cyrl": 830,
		"./sr-cyrl.js": 830,
		"./sr.js": 829,
		"./ss": 831,
		"./ss.js": 831,
		"./sv": 832,
		"./sv.js": 832,
		"./sw": 833,
		"./sw.js": 833,
		"./ta": 834,
		"./ta.js": 834,
		"./te": 835,
		"./te.js": 835,
		"./tet": 836,
		"./tet.js": 836,
		"./tg": 837,
		"./tg.js": 837,
		"./th": 838,
		"./th.js": 838,
		"./tk": 839,
		"./tk.js": 839,
		"./tl-ph": 840,
		"./tl-ph.js": 840,
		"./tlh": 841,
		"./tlh.js": 841,
		"./tr": 842,
		"./tr.js": 842,
		"./tzl": 843,
		"./tzl.js": 843,
		"./tzm": 844,
		"./tzm-latn": 845,
		"./tzm-latn.js": 845,
		"./tzm.js": 844,
		"./ug-cn": 846,
		"./ug-cn.js": 846,
		"./uk": 847,
		"./uk.js": 847,
		"./ur": 848,
		"./ur.js": 848,
		"./uz": 849,
		"./uz-latn": 850,
		"./uz-latn.js": 850,
		"./uz.js": 849,
		"./vi": 851,
		"./vi.js": 851,
		"./x-pseudo": 852,
		"./x-pseudo.js": 852,
		"./yo": 853,
		"./yo.js": 853,
		"./zh-cn": 854,
		"./zh-cn.js": 854,
		"./zh-hk": 855,
		"./zh-hk.js": 855,
		"./zh-mo": 856,
		"./zh-mo.js": 856,
		"./zh-tw": 857,
		"./zh-tw.js": 857
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 722;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                '_'
	            ),
	            standalone:
	                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                    '_'
	                ),
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(721)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	(function ($) {
	
	  var agent = navigator.userAgent.toLowerCase();
	
	  var dateRangeDays = 0;
	  $.fn.dateRangeCustomPicker = function (options) {
	    var $this = $(this);
	    var baseEl = '#create-date';
	    var $thisLayer = $(".date-rang-layer");
	    var $thisBtn = $this.find(baseEl);
	    var $flag = false;
	
	    var defaultSetting = { single: false, autoClose: true };
	    var setting = {
	      single: options.single == undefined || options.single == '' ? defaultSetting.single : options.single,
	      autoClose: options.autoClose == undefined || options.autoClose == '' ? defaultSetting.autoClose : options.autoClose
	    };
	
	    picker();
	    function picker() {
	      dateLayerSetting();
	      btnClickEv();
	    };
	    function btnClickEv() {
	      $thisLayer.find(".close").click(function () {
	        $thisLayer.hide();
	        return false;
	      });
	      $(baseEl).on("click", function () {
	        $thisBtn.data('dateRangePicker').resetMonthsView();
	        $thisLayer.show();
	      });
	    }
	
	    /* 0601 */
	    function reDateCal(eDate) {
	      var reDate;
	      if (eDate < 10) {
	        reDate = '0' + eDate;
	      } else {
	        reDate = eDate;
	      }
	      return reDate;
	    }
	    function FixLocaleDateString(localeDate) {
	      var newStr = "";
	      for (var i = 0; i < localeDate.length; i++) {
	        var code = localeDate.charCodeAt(i);
	        if (code >= 46 && code <= 57) {
	          newStr += localeDate.charAt(i);
	        }
	      }
	      return newStr;
	    }
	    /* 0601 */
	
	    function dateLayerSetting() {
	      $thisBtn.dateRangePicker({
	        inline: true,
	        container: '.create-date-td .calendar',
	        alwaysOpen: true,
	        format: 'YYYY-MM-DD',
	        language: 'ko',
	        stickyMonths: false,
	        duration: 0,
	        minDays: "-1y",
	        maxDays: "+0d",
	        minDate: '0',
	        hoveringTooltip: false,
	        endDate: new Date(),
	        selectForward: true,
	        singleMonth: setting.single,
	        setValue: function setValue(s, s1, s2) {
	          $(baseEl).val(s1 + '~' + s2);
	        }
	      }).bind('datepicker-first-date-selected', function (event, obj) {
	        var stDate = new Date();
	        var endDate = obj.date1;
	        var btDay = (endDate.getTime() - stDate.getTime()) / (1000 * 60 * 60 * 24);
	
	        /* 0601 firstDate value Start */
	        var lDate = endDate.toLocaleDateString();
	        if (Math.round(btDay) <= 59) {
	          if (navigator.appName == 'Netscape' && agent.indexOf('trident') != -1 || agent.indexOf("msie") != -1) {
	            var fixLoDate = FixLocaleDateString(lDate.replace(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g, '.')).replace(/\./g, '. ');
	            var dateReplace = fixLoDate.replace(/\./gi, '');
	            var strDate = getWeekday(dateReplace, 'click');
	          } else {
	            var dateReplace = lDate.replace(/\./gi, '');
	            var strDate = getWeekday(lDate, 'click');
	          }
	          var dateArray = dateReplace.split(' ');
	          var dateYy = dateArray[0];
	          var dateMm = reDateCal(dateArray[1]);
	          var dateDd = reDateCal(dateArray[2]);
	
	          var dateAll = dateYy + '-' + dateMm + '-' + dateDd;
	
	          $(baseEl).val(dateAll);
	        }
	        /* 0601 firstDate value End */
	
	        if (Math.round(btDay) > 59 && !$flag) {
	          $flag = true;
	          alert("체크 맥스멈 기준 체크");
	          $thisBtn.data('dateRangePicker').clear();
	          $thisBtn.data('dateRangePicker').resetMonthsView();
	          $this.removeClass("sel");
	          $(baseEl).val('');
	        } else {
	          $flag = false;
	        }
	      }).bind('datepicker-change', function () {
	        if (setting.autoClose) {
	          $thisLayer.hide();
	          $('#next').removeAttr('disabled').addClass('is-active');
	        }
	      });
	    }
	    function getWeekday(sDate, type) {
	      var txt = "" + sDate;
	      if (type == 'click') {
	        if (navigator.appName == 'Netscape' && agent.indexOf('trident') != -1 || agent.indexOf("msie") != -1) {
	          var yy = txt.substr(0, 4);
	          var mm = txt.substr(5, 2);
	          var dd = txt.substr(7, 2);
	        } else {
	          var yy = parseInt(txt.substr(0, 4), 10);
	          var mm = parseInt(txt.substr(5, 2), 10);
	          var dd = parseInt(txt.substr(8), 10);
	        }
	      } else {
	        var yy = parseInt(txt.substr(0, 4), 10);
	        var mm = parseInt(txt.substr(5, 2), 10);
	        var dd = parseInt(txt.substr(8), 10);
	      }
	      var d = new Date(yy, mm - 1, dd);
	      var weekday = new Array(7);
	      weekday[0] = "일";
	      weekday[1] = "월";
	      weekday[2] = "화";
	      weekday[3] = "수";
	      weekday[4] = "목";
	      weekday[5] = "금";
	      weekday[6] = "토";
	      return weekday[d.getDay()];
	    }
	  };
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.biddingFunc = undefined;
	
	var _ajaxForm = __webpack_require__(209);
	
	var _loading = __webpack_require__(210);
	
	var _dataUrl = __webpack_require__(718);
	
	var _formCheck = __webpack_require__(860);
	
	//데이터 API 목록
	//AJAX 프레임
	var numOfPaging = 200;
	//로딩 액션
	
	var currentAdvId = null;
	var currentNaverAccId = null;
	var checkedType = {
		btn: 'Compare',
		list: 'Compare'
	};
	var biddingList = null; // 페이지 열릴 때 서버에서 가져온 데이터 저장 변수
	var checkedBiddingList = null; // 체크박스 체크 된 데이터 임시 저장 변수
	var activeKeywordList = null; // 자동 키워드 리스트
	var keywordListInBidFavorite = null; // 즐겨찾기에 들어가있는 키워드 리스트 초기에 저장
	var campaignList = null;
	var haveBidFavoriteGroups = null; // 가지고 있는 즐겨찾기 그룹 초기에 저장
	var initCheck = false; // 페이지 초기화 여부
	var pagingIdx = 0; // 페이징 처리용
	var currentCs1Value = 'NA'; // 기준 값 선택되어 검색했는지
	var currentCs2Value = 'NA'; // 비교 값 선택되어 검색했는지
	var currentCheckedBtnCount = 0; //
	var currentCampaignsStr = null; // 현재 캠페인 리스트 문자열
	
	// 차후 스크롤용 변수
	var $TABLE1 = null;
	var $TABLES_OUTER = null;
	
	var AMT_MIN_VALUE = 70; // 입찰최소값
	var AMT_MAX_VALUE = 100000; // 입찰최대값
	var OPTION_MAX_BID_AMT = AMT_MAX_VALUE; // 일괄변경레이어 옵션 입찰최대값 저장변수
	
	
	// 검색 처리용
	var currentSearchKeyword = null; // 현재 검색 된 키워드명
	var currentSearchType = null; // 현재 검색 된 키워드의 검색 타입(like, equal, start)
	var advanceSearchUse = false; // 고급검색 사용 여부
	var advSrchGroupOptions = null; // 고급검색 유형선택 초기에 서버에서 가져와 저장
	
	var filter_fields = ''; // 고급검색 유형들 저장 변수(노출수, 클릭율 등)
	var filter_operations = ''; // 고급검색 범위 저장 변수(구간, 이상, 이하)
	var filter_values = ''; // 인풋박스 저장 변수
	
	var $currentAdvSearchRow = null;
	
	// 정렬 처리용
	var currentSort = null; // ASC, DESC
	var currentSortField = null; // 현재 정렬 된 필드
	
	// 하나의 행의 입찰가 레이어 띄울 때 그 행의 키워드 ID 임시 저장할 변수
	var clickedSingleKwdId = null;
	
	var biddingFunc = exports.biddingFunc = {
		init: function init() {},
	
		initReptJobHistoryDatesByAdvId: function initReptJobHistoryDatesByAdvId(advId) {
	
			$TABLE1 = $('.table_01');
			$TABLES_OUTER = $('#result-tables-outer');
	
			currentAdvId = advId;
			haveBidFavoriteGroups = {};
			keywordListInBidFavorite = {};
			activeKeywordList = {};
			currentNaverAccId = $('#advKey').val();
			favoriteFunc.setAdvKeyDirectly(currentNaverAccId);
			biddingFunc.initReptJobHistory();
	
			var dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'historyDate', currentAdvId + '&result_cd=complete');
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setReptJobHistoryDates);
	
			biddingFunc.refreshKeywordListInBidFavorite();
	
			biddingFunc.initAdvancedSearch();
	
			dataApi = _dataUrl.dataUrl.alwaysAPI('GET', 'subMenu', currentAdvId);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setHaveBidFavoriteGroups);
	
			dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'activeKeywordList', currentAdvId);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setActiveKeywordList);
		},
	
		// 리스트 가져오는 파라미터 설정
		makeGetBiddingListDataApiUrl: function makeGetBiddingListDataApiUrl() {
			var params = "?adv_id=" + currentAdvId;
			params += "&start=" + pagingIdx * numOfPaging;
			params += "&limit=" + numOfPaging;
			params += "&origin=" + currentCs1Value;
			if (checkedType.list == 'Compare') {
				params += "&control=" + currentCs2Value;
			}
	
			if (currentSearchKeyword != null) {
				params += "&search_type=" + currentSearchType;
				params += "&search_field=" + currentSearchKeyword;
			}
	
			if (advanceSearchUse == true) {
				params += "&filter_fields=" + filter_fields.substring(0, filter_fields.length - 1);
				params += "&filter_operations=" + filter_operations.substring(0, filter_operations.length - 1);
				params += "&filter_values=" + filter_values.substring(0, filter_values.length - 1);
			}
	
			if (currentSort != null && currentSortField != null) {
				params += "&sort=" + currentSort;
				params += "&sort_field=" + currentSortField;
			}
	
			if (currentCampaignsStr != null) {
				params += "&campaign_ids=" + currentCampaignsStr;
			}
	
			return params;
		},
	
		initReptJobHistory: function initReptJobHistory(cs1Value, cs2Value, searchType, searchKeyword) {
			biddingList = {};
			checkedBiddingList = {};
			initCheck = true;
			pagingIdx = 0;
			currentCheckedBtnCount = 0;
			currentCs1Value = cs1Value == undefined || cs1Value == null ? 'NA' : cs1Value;
			currentCs2Value = cs2Value == undefined || cs2Value == null ? 'NA' : cs2Value;
			currentSearchType = searchType == undefined || searchType == null ? null : searchType;
			currentSearchKeyword = searchKeyword == undefined || searchKeyword == null ? null : searchKeyword;
			currentSort = null;
			currentSortField = null;
	
			if (currentCs1Value != 'NA') {
				$('.main_search_wrap').show();
			} else {
				$('.main_search_wrap').hide();
			}
			$('.bidding_list_wrap').hide();
	
			if (currentSearchKeyword != null) {
				$('.bidding_none_wrap').hide();
				$('.none_search_wrap').show();
			} else {
				$('.bidding_none_wrap').show();
				$('.none_search_wrap').hide();
			}
		},
	
		setReptJobHistoryDates: function setReptJobHistoryDates(result) {
			var rjhArr = result.data;
			var rjh = null;
			var options = "<option value='NA'>선택</option>";
	
			if (rjhArr != undefined && rjhArr != null) {
				for (var idx = 0; idx < rjhArr.length; idx++) {
					rjh = rjhArr[idx];
					options += "<option data-id='" + rjh.id + "' data-update-at='" + rjh.update_at + "' value='" + rjh.job_group_ser + "'>" + rjh.work_name + "</option>";
				}
				$('#choice-select-1, #choice-select-2').html(options);
			} else {
				$('.bidding-sub-wrap').hide();
				$('.bidding_none_wrap').show();
			}
		},
	
		clickCampaignField: function clickCampaignField() {
			biddingFunc.setCampaignLiHtml();
			var $cvo = $('#campaign-view-outer');
			if ($cvo.css('display') == 'none') {
				$cvo.show();
			} else {
				$cvo.hide();
			}
		},
	
		initCampaignList: function initCampaignList(result) {
			currentCampaignsStr = null;
			campaignList = {};
			var campaigns = result.data;
			var length = campaigns.length;
			var campaign = null;
			for (var idx = 0; idx < length; idx++) {
				campaign = campaigns[idx];
				if (campaign.campaignTp == 'WEB_SITE' && campaign.status == 'ELIGIBLE') {
					campaignList[campaign.nccCampaignId] = campaign;
					campaignList[campaign.nccCampaignId]['checked'] = false;
				}
			}
		},
	
		setCampaignLiHtml: function setCampaignLiHtml() {
			var campaignHtml = '';
			var oneCamp = null;
			for (var cId in campaignList) {
				oneCamp = campaignList[cId];
				campaignHtml += '<li><input class="cLi-checkboxes" type="checkbox" ' + (oneCamp.checked ? 'checked' : '') + ' id="cLi-' + oneCamp.nccCampaignId + '" data-campaign-id="' + oneCamp.nccCampaignId + '"><label for="cLi-' + oneCamp.nccCampaignId + '">' + oneCamp.name + '</label></li>';
			}
			$('#campaign-view-ul').html(campaignHtml);
		},
	
		clickCampaignFieldConfirm: function clickCampaignFieldConfirm(uncheckAll) {
			currentCampaignsStr = '';
			var cId = null;
			if (uncheckAll != true) {
				$('.cLi-checkboxes:checked').each(function (i) {
					cId = $(this).data('campaign-id');
					campaignList[cId]['checked'] = true;
					currentCampaignsStr += cId + ',';
				});
			}
	
			if (cId != null) {
				currentCampaignsStr = currentCampaignsStr.substring(0, currentCampaignsStr.length - 1);
			} else {
				currentCampaignsStr = null;
			}
	
			biddingFunc.initReptJobHistory(currentCs1Value, currentCs2Value, currentSearchType, currentSearchKeyword);
			var dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'dateMatch', biddingFunc.makeGetBiddingListDataApiUrl());
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setBiddingList);
		},
	
		setActiveKeywordList: function setActiveKeywordList(result) {
			activeKeywordList = result.data;
		},
	
		clickDateRadioBtn: function clickDateRadioBtn(type) {
			checkedType.btn = type;
			if (type == 'Compare') {
				document.getElementById('choice-select-2').disabled = false;
			} else {
				document.getElementById('choice-select-2').disabled = true;
			}
		},
	
		clickConfirmForBiddingList: function clickConfirmForBiddingList() {
			var $cs1 = $('#choice-select-1');
			var cs1UpdateAt = $cs1.find('option:selected').data('update-at');
			var cs1Value = $cs1.val();
			var cs2Value = $('#choice-select-2').val() == 'NA' ? undefined : $('#choice-select-2').val();
	
			if (cs1Value == 'NA') {
				alert('기준데이터를 선택해주세요.');
				return;
			}
	
			if (checkedType.btn == 'Compare') {
				if (cs2Value == undefined) {
					alert('비교데이터를 선택해주세요.');
					return;
				}
			}
	
			// 기본 검색에 이전에 검색했던 텍스트 제거
			$('#bidding-default-search-keyword').val('');
	
			// 기준데이터 업데이트 날짜 설정
			$('#reference-update-at-txt').html(new Date(cs1UpdateAt).toISOString().slice(0, 19).replace('T', ' '));
			checkedType.list = checkedType.btn;
	
			// 해당 광고주 캠페인 목록 초기화
			var dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'NaverApiCampaign', currentNaverAccId);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.initCampaignList);
	
			// 고급검색초기화
			biddingFunc.initAdvancedSearch();
			biddingFunc.initReptJobHistory(cs1Value, cs2Value);
	
			dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'dateMatch', biddingFunc.makeGetBiddingListDataApiUrl());
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setBiddingList);
		},
	
		toggleSortArea: function toggleSortArea(obj) {
			var $this = $(obj);
			var sf = $this.data('sf');
	
			if ($this.find('.media_array').length != 0) {
				$('.media_array').remove();
			} else {
				$('.media_array').remove();
				var layer = '';
				layer += '<div class="media_array hide active">';
				layer += '	<ul>';
				layer += '		<li><button type="button" ' + (currentSortField == null && currentSort == null ? 'class="on"' : '') + 'onclick="biddingFunc.sortBiddingList(this);">기본정렬</button></li>';
				layer += '		<li><button type="button" ' + (currentSortField == sf && currentSort == 'ASC' ? 'class="on"' : '') + ' onclick="biddingFunc.sortBiddingList(this, \'ASC\');">오름차순</button></li>';
				layer += '		<li><button type="button" ' + (currentSortField == sf && currentSort == 'DESC' ? 'class="on"' : '') + ' onclick="biddingFunc.sortBiddingList(this, \'DESC\');">내림차순</button></li>';
				layer += '	</ul>';
				layer += '</div>';
				$this.append(layer);
			}
		},
	
		clickExcelDownload: function clickExcelDownload() {
			if (confirm('전체 데이터를 엑셀로 다운받으시겠습니까?')) {
				var excelDownloadParam = "?type=integrate&adv_id=" + currentAdvId;
				excelDownloadParam += "&work_name=" + $('#choice-select-1').find('option:selected').text();
				excelDownloadParam += "&origin=" + currentCs1Value;
				if (checkedType.list == 'Compare') excelDownloadParam += "&control=" + currentCs2Value;
				window.open(_dataUrl.dataUrl.biddingAPI('GET', 'excel', excelDownloadParam), 'zero_frame');
			}
		},
	
		sortBiddingList: function sortBiddingList(obj, sort) {
			var $this = $(obj);
			var sortField = $this.closest('th').data('sf');
			biddingFunc.initReptJobHistory(currentCs1Value, currentCs2Value, currentSearchType, currentSearchKeyword);
	
			if (sort == undefined) {
				currentSort = null;
				currentSortField = null;
			} else {
				currentSort = sort;
				currentSortField = sortField;
			}
	
			$('.field-sort-btn').not($this.addClass('on')).removeClass('on');
			var dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'dateMatch', biddingFunc.makeGetBiddingListDataApiUrl());
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setBiddingList);
		},
	
		clickShowAll: function clickShowAll() {
			$('#bidding-default-search-keyword').val('');
			biddingFunc.initAdvancedSearch();
			biddingFunc.initReptJobHistory(currentCs1Value, currentCs2Value);
	
			var dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'dateMatch', biddingFunc.makeGetBiddingListDataApiUrl());
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setBiddingList);
		},
	
		biddingResultDivOnScroll: function biddingResultDivOnScroll() {
			var leftOffset = $TABLES_OUTER.scrollLeft();
			$TABLE1.css('left', leftOffset);
		},
	
		setBiddingList: function setBiddingList(result) {
			var $table1 = $('.table_01');
			var $table2 = $('.table_02');
			var $table3 = $('.table_03');
			var $table4 = $('.table_04');
	
			if (initCheck == true) {
				initCheck = false;
				$('#error-wrap').hide();
				$table1.find('tbody').empty();
				$table2.find('tbody').empty();
				$table3.find('tbody').empty();
				$table4.find('tbody').empty();
				$('#total_cnt_strong').text(result.total_cnt);
			}
	
			biddingFunc.checkMoreBiddingListBtn(result.total_cnt);
	
			// Campaign Filter Area Hide
			$('#campaign-view-outer').hide();
	
			var biddingArr = result.data;
	
			if (biddingArr == 'ERROR') {
				$('#error-wrap').show();
				$('.none_search_wrap').hide();
				$('.bidding_none_wrap').hide();
				return;
			}
	
			var showTableSumWidth = 0;
			var length = biddingArr.length;
			var defaultRows = '';
			var resultRows = '';
			var refRows = '';
			var compRows = '';
			if (length > 0) {
	
				var compareAdd = checkedType.list == 'Compare' ? '_res' : '';
				$('#table2-thead th').each(function (idx) {
					var $this = $(this);
					var tempSf = $this.data('temp-sf');
					$this.data('sf', tempSf + compareAdd);
				});
	
				for (var idx = 0; idx < length; idx++) {
					biddingList[biddingArr[idx].kwd_id] = biddingArr[idx];
					defaultRows += biddingFunc.makeOneDefaultRow(biddingArr[idx]);
					resultRows += biddingFunc.makeOneResultRow(biddingArr[idx], checkedType.list == 'Lookup' ? '' : '_res');
	
					if (checkedType.list == 'Compare') {
						refRows += biddingFunc.makeOneReferenceRow(biddingArr[idx]);
						compRows += biddingFunc.makeOneComparisonRow(biddingArr[idx]);
					}
				}
	
				$table1.find('tbody').append(defaultRows);
				$table2.find('tbody').append(resultRows);
				if (checkedType.list == 'Lookup') {
					$table2.find('h3').text('조회결과');
					$table3.hide();
					$table4.hide();
				} else {
					// checkedType.list == 'Compare'
					$table2.find('h3').text('비교결과');
					$table3.show().find('tbody').append(refRows);
					$table4.show().find('tbody').append(compRows);
				}
				$('.bidding_list_wrap').show();
				$('.bidding_none_wrap').hide();
				$('.bidding-sub-wrap').show();
				$('.none_search_wrap').hide();
	
				// 동적으로 보여지는 테이블 너비 확인하여 테이블 감싸고있는 wrap div width 세팅
				var $dynamicGroups = checkedType.list == 'Lookup' ? $('.dynamic-group-1') : $('.dynamic-group-2');
				var wit = 0;
				for (var idx = 0; idx < $dynamicGroups.length; idx++) {
					showTableSumWidth += $($dynamicGroups[idx]).width();
				}
	
				//console.log(showTableSumWidth);
				var DTW = $('#default-table').width();
				//$('.table_01').width(DTW)
				$('.table_02').css('margin-left', DTW);
				$('.dynamic-follow-default-table').css('width', DTW);
				$('#bidding-list-width-outer').width(showTableSumWidth + 15);
			} else {
				// 검색 결과 없을 경우
				if (initCheck == false) {
					$('.biding_list_wrap').hide();
					$('.main_search_wrap').show();
					$('.none_search_wrap').show();
				} else {
					$('.bidding-sub-wrap').show();
					$('.bidding_none_wrap').hide();
					$('.none_search_wrap').show();
				}
			}
		},
	
		makeOneDefaultRow: function makeOneDefaultRow(rowData) {
			var activeCheck = activeKeywordList.hasOwnProperty(rowData.kwd_id);
			var row = "";
			row += "<tr id='row-" + rowData.kwd_id + "' data-kwd_id='" + rowData.kwd_id + "'>";
			row += "<td><input type='checkbox' onclick='biddingFunc.changeNeedCheckedBtn();' class='list-check " + (activeCheck ? 'active-row' : '') + "' data-kwd_id='" + rowData.kwd_id + "' id='tender" + rowData.id + "'><label for='tender" + rowData.id + "'></label></td>";
			row += "<td>";
			row += "<div class='on_off_btn' onclick='biddingFunc.oneBidStatusBtnClick(\"" + rowData.kwd_id + "\");'>";
			row += "<button class='status-on-btn " + (rowData.status == 'ELIGIBLE' ? 'on' : '') + "'>ON</button>";
			row += "<button class='status-off-btn " + (rowData.status == 'ELIGIBLE' ? '' : 'on') + "'>OFF</button>";
			row += "</div>";
			row += "</td>";
			row += "<td align='left'>" + rowData.campaign_nm + "</td>";
			row += "<td align='left'>" + rowData.adgroup_nm + "</td>";
			row += "<td align='left' class='keyword_contents'>";
			row += "<a href='https://search.naver.com/search.naver?query=" + rowData.kwd_nm + "' target='_blank'><button class='pc'></button></a>";
			row += "<a href='https://m.search.naver.com/search.naver?query=" + rowData.kwd_nm + "' target='_blank'><button class='mobile'></button></a>";
			row += "<span>" + rowData.kwd_nm + "</span>";
			row += "</td>";
			row += "<td align='left' data-id='" + rowData.id + "'>";
			row += "<div class='bid_wrap'>";
			row += "<div class='bid_icon'>";
			row += "<button type='button' class='bid_01' " + (activeCheck ? 'disabled' : '') + " data-name='bidChange' onclick='biddingFunc.setSingleKwdId(\"" + rowData.kwd_id + "\"); layerPopup.open(this, this.id);'></button>";
			row += "<button type='button' class='bid_02' " + (activeCheck ? 'disabled' : '') + " list-btn-modify' onclick='biddingFunc.clickOneCurrentAmtModifyBtn(this);'></button>";
			row += "<div class='bid_price'>" + numberWithCommas(rowData.cur_bid_amt) + "</div>";
			row += "</div>";
			row += "<div class='active-btn-area hide'>";
			row += "<form onsubmit='biddingFunc.clickOneCurrentAmtSaveBtn(this); return false;'>";
			row += "<button type='button' onclick='biddingFunc.clickOneCurrentAmtSaveBtn(this);' class='list-btn-save'>저장</button>";
			row += "<button type='button' class='list-btn-cancer' onclick='biddingFunc.clickOneCurrentAmtCancelBtn(this);'>취소</button>";
			row += "<input type='number' value='" + numberWithCommas(rowData.cur_bid_amt) + "' class='active-input-area'>";
			row += "</form>";
			row += "</div>";
			row += "</td>";
			row += "<td>";
			row += activeCheck ? '자동' : '수동';
			row += "</td>";
			row += "<td class='condition-" + rowData.id + "'>";
			row += "<button type='button' class='his_btn' data-key='" + rowData.kwd_id + "' data-name='history' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/history_icon.png' alt='이력아이콘'></button>";
	
			//row +=        "<button class='his_btn' data-id='" + rowData.id +"' data-name='history' onclick='layerPopup.open(this, this.id);'><img src='/image/common/history_icon.png' alt='이력아이콘'></button>";
			row += "</td>";
			row += "</tr>";
			return row;
		},
	
		makeOneResultRow: function makeOneResultRow(rowData, type) {
			var row = '';
	
			var avgRnk = eval('rowData["avg_rnk' + type + '"]');
			if (avgRnk < 0) {
				avgRnk = '<span style="color:red">▼</span> ' + avgRnk.toString().replace('-', '');
			} else if (avgRnk > 0) {
				avgRnk = '<span style="color:blue">▲</span> ' + avgRnk;
			}
	
			row += "<tr>";
			row += "<td>" + eval('numberWithCommas(rowData["imp_cnt' + type + '"])') + "</td>";
			row += "<td>" + eval('numberWithCommas(rowData["clk_cnt' + type + '"])') + "</td>";
			row += "<td>" + eval('rowData["ctr' + type + '"]') + "</td>";
			row += "<td>" + eval('numberWithCommas(rowData["recent_avg_cpc' + type + '"])') + "</td>";
			row += "<td>" + eval('numberWithCommas(rowData["sales_amt' + type + '"])') + "</td>";
			row += "<td>" + avgRnk + "</td>";
			row += "<td>" + eval('numberWithCommas(rowData["neo_kwd_ccnt' + type + '"])') + "</td>";
			row += "<td>" + eval('numberWithCommas(rowData["neo_price' + type + '"])') + "</td>";
			row += "<td>" + eval('rowData["cvtr' + type + '"]') + "</td>";
			row += "<td>" + eval('numberWithCommas(rowData["cvpc' + type + '"])') + "</td>";
			row += "<td>" + eval('rowData["roas' + type + '"]') + "%</td>";
			row += "</tr>";
			return row;
		},
	
		makeOneReferenceRow: function makeOneReferenceRow(rowData) {
			var row = '';
			row += "<tr>";
			row += "<td>" + numberWithCommas(rowData.imp_cnt_org) + "</td>";
			row += "<td>" + numberWithCommas(rowData.clk_cnt_org) + "</td>";
			row += "<td>" + rowData.ctr_org + "%</td>";
			row += "<td>" + numberWithCommas(rowData.recent_avg_cpc_org) + "</td>";
			row += "<td>" + numberWithCommas(rowData.sales_amt_org) + "</td>";
			row += "<td>" + rowData.avg_rnk_org + "</td>";
			row += "<td>" + numberWithCommas(rowData.neo_kwd_ccnt_org) + "</td>";
			row += "<td>" + numberWithCommas(rowData.neo_price_org) + "</td>";
			row += "<td>" + rowData.cvtr_org + "</td>";
			row += "<td>" + numberWithCommas(rowData.cvpc_org) + "</td>";
			row += "<td>" + rowData.roas_org + "</td>";
			row += "</tr>";
			return row;
		},
	
		makeOneComparisonRow: function makeOneComparisonRow(rowData) {
			var row = '';
			row += "<tr>";
			row += "<td>" + numberWithCommas(rowData.imp_cnt_ctl) + "</td>";
			row += "<td>" + numberWithCommas(rowData.clk_cnt_ctl) + "</td>";
			row += "<td>" + rowData.ctr_ctl + "%</td>";
			row += "<td>" + numberWithCommas(rowData.recent_avg_cpc_ctl) + "</td>";
			row += "<td>" + numberWithCommas(rowData.sales_amt_ctl) + "</td>";
			row += "<td>" + rowData.avg_rnk_ctl + "</td>";
			row += "<td>" + numberWithCommas(rowData.neo_kwd_ccnt_ctl) + "</td>";
			row += "<td>" + numberWithCommas(rowData.neo_price_ctl) + "</td>";
			row += "<td>" + rowData.cvtr_ctl + "</td>";
			row += "<td>" + numberWithCommas(rowData.cvpc_ctl) + "</td>";
			row += "<td>" + rowData.roas_ctl + "%</td>";
			row += "</tr>";
			return row;
		},
	
		// 현재 입찰가 관련 Start
		clickOneCurrentAmtModifyBtn: function clickOneCurrentAmtModifyBtn(obj) {
			var $this = $(obj);
			var $parent = $this.closest('tr');
			var kwdId = $parent.data('kwd_id');
			$parent = $parent.find('.bid_wrap');
			$parent.find('.active-input-area').val(biddingList[kwdId].cur_bid_amt);
			$parent.find('.bid_icon').hide();
			$parent.find('.active-btn-area').show();
		},
		clickOneCurrentAmtCancelBtn: function clickOneCurrentAmtCancelBtn(obj) {
			var $this = $(obj);
			var $parent = $this.closest('tr');
			var kwdId = $parent.data('kwd_id');
			$parent = $parent.find('.bid_wrap');
			var $bidPrice = $parent.find('.bid_icon').show().find('.bid_price').text(numberWithCommas(biddingList[kwdId].cur_bid_amt));
			$parent.find('.active-btn-area').hide();
	
			$bidPrice.css('color', 'red');
			setTimeout(function () {
				$bidPrice.css('color', '');
			}, 1000);
		},
		clickOneCurrentAmtSaveBtn: function clickOneCurrentAmtSaveBtn(obj) {
			var $this = $(obj);
			var $parent = $this.closest('tr');
			var kwdId = $parent.data('kwd_id');
			checkedBiddingList = {};
			checkedBiddingList[kwdId] = biddingList[kwdId];
			biddingFunc.setBeforeBidAmt();
			biddingFunc.setCurBidAmtBySame($parent.find('.active-input-area').val());
			biddingFunc.updateBidAmt();
		},
	
		bidAmtRound: function bidAmtRound(value) {
			var result = Math.floor(Math.round(Number(value) / 10)) * 10;
			if (result < AMT_MIN_VALUE) {
				result = AMT_MIN_VALUE;
			} else if (result > AMT_MAX_VALUE) {
				result = AMT_MAX_VALUE;
			}
			return result;
		},
	
		setBeforeBidAmt: function setBeforeBidAmt() {
			for (var kwdId in checkedBiddingList) {
				checkedBiddingList[kwdId].before_bid_amt = checkedBiddingList[kwdId].cur_bid_amt;
			}
		},
		setCurBidAmtBySame: function setCurBidAmtBySame(changeValue) {
			changeValue = OPTION_MAX_BID_AMT < changeValue ? OPTION_MAX_BID_AMT : changeValue;
			for (var kwdId in checkedBiddingList) {
				checkedBiddingList[kwdId].cur_bid_amt = biddingFunc.bidAmtRound(changeValue);
				$('#preview-' + kwdId).val(numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt));
			}
			OPTION_MAX_BID_AMT = AMT_MAX_VALUE;
		},
		setCurBidAmtByIncrease: function setCurBidAmtByIncrease(changeValue, changeValueType) {
			var calcValue = 0;
			if (changeValueType == '원') {
				for (var kwdId in checkedBiddingList) {
					calcValue = checkedBiddingList[kwdId].before_bid_amt + Number(changeValue);
					calcValue = OPTION_MAX_BID_AMT < calcValue ? OPTION_MAX_BID_AMT : calcValue;
					checkedBiddingList[kwdId].cur_bid_amt = biddingFunc.bidAmtRound(calcValue);
					$('#preview-' + kwdId).val(numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt));
				}
			} else {
				// changeValueType == '%'
				for (var kwdId in checkedBiddingList) {
					calcValue = checkedBiddingList[kwdId].before_bid_amt * (1 + Number(changeValue) / 100);
					calcValue = OPTION_MAX_BID_AMT < calcValue ? OPTION_MAX_BID_AMT : calcValue;
					checkedBiddingList[kwdId].cur_bid_amt = biddingFunc.bidAmtRound(calcValue);
					$('#preview-' + kwdId).val(numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt));
				}
			}
			OPTION_MAX_BID_AMT = AMT_MAX_VALUE;
		},
		setCurBidAmtByDecrease: function setCurBidAmtByDecrease(changeValue, changeValueType) {
			var calcValue = 0;
			if (changeValueType == '원') {
				for (var kwdId in checkedBiddingList) {
					calcValue = checkedBiddingList[kwdId].before_bid_amt - Number(changeValue);
					calcValue = OPTION_MAX_BID_AMT < calcValue ? OPTION_MAX_BID_AMT : calcValue;
					checkedBiddingList[kwdId].cur_bid_amt = biddingFunc.bidAmtRound(calcValue);
					$('#preview-' + kwdId).val(numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt));
				}
			} else {
				// changeValueType == '%'
				for (var kwdId in checkedBiddingList) {
					calcValue = checkedBiddingList[kwdId].before_bid_amt * (1 - Number(changeValue) / 100);
					calcValue = OPTION_MAX_BID_AMT < calcValue ? OPTION_MAX_BID_AMT : calcValue;
					checkedBiddingList[kwdId].cur_bid_amt = biddingFunc.bidAmtRound(calcValue);
					$('#preview-' + kwdId).val(numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt));
				}
			}
			OPTION_MAX_BID_AMT = AMT_MAX_VALUE;
		},
		setCurBidAmtByNaverAPI: function setCurBidAmtByNaverAPI(result) {
			var midAmts = result.data;
			var calcValue = 0;
			for (var kwdId in midAmts) {
				calcValue = midAmts[kwdId].bid;
				calcValue = OPTION_MAX_BID_AMT < calcValue ? OPTION_MAX_BID_AMT : calcValue;
				checkedBiddingList[kwdId].cur_bid_amt = biddingFunc.bidAmtRound(calcValue);
				$('#preview-' + kwdId).val(numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt));
			}
			OPTION_MAX_BID_AMT = AMT_MAX_VALUE;
		},
	
		updateBidAmt: function updateBidAmt() {
			if (confirm('변경하시겠습니까?') == false) {
				return;
			}
			var sendData = {
				adv_id: currentAdvId,
				keywords: new Array()
			};
			for (var key in checkedBiddingList) {
				sendData.keywords.push(checkedBiddingList[key]);
			}
			var dataApi = _dataUrl.dataUrl.favoriteAPI('POST', 'update_bid', '');
			_ajaxForm.ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, biddingFunc.afterSaveCurrentAmt, sendData);
		},
		afterSaveCurrentAmt: function afterSaveCurrentAmt(result) {
			var returnList = result.data;
			var curKwdId = null;
			var $changeRow = null;
			for (var idx = 0; idx < returnList.length; idx++) {
				curKwdId = returnList[idx].nccKeywordId;
				biddingList[curKwdId] = checkedBiddingList[curKwdId];
				$changeRow = $('#row-' + curKwdId);
				$changeRow.find('.list-btn-cancer').trigger('click');
			}
			$('.fixed-pop').fadeOut(200, function () {
				$(this).clearQueue();
			});
		},
	
		setSingleKwdId: function setSingleKwdId(kwdId) {
			clickedSingleKwdId = kwdId;
		},
	
		openBidAmtPopup: function openBidAmtPopup() {
			if (clickedSingleKwdId != null) {
				checkedBiddingList = {};
				checkedBiddingList[clickedSingleKwdId] = biddingList[clickedSingleKwdId];
				clickedSingleKwdId = null;
			} else {
				biddingFunc.setCheckedRows(true);
			}
	
			if (Object.keys(checkedBiddingList).length == 0) {
				alert('자동입찰 키워드만 선택되었습니다.\n다시 선택해주세요.');
				return;
			}
	
			biddingFunc.setBeforeBidAmt();
			var rows = '';
			for (var kwdId in checkedBiddingList) {
				rows += biddingFunc.makeOneBidAmtRow(checkedBiddingList[kwdId]);
			}
			$('#bid_amt_preview_table').find('tbody').html(rows);
			$('.fixed-pop').fadeIn(200, function () {
				$(this).clearQueue();
			});
		},
	
		makeOneBidAmtRow: function makeOneBidAmtRow(rowData) {
			var row = '';
			row += '<tr>';
			row += '	<td>';
			row += '		<div>';
			row += '			<a href="https://search.naver.com/search.naver?query=' + rowData.kwd_nm + '" target="_blank"><button><img src="/image/common/keyword_icon.png" alt="돋보기버튼"></button></a>';
			row += '		</div>';
			row += '		<div>' + rowData.kwd_nm + '</div>';
			row += '	</td>';
			row += '	<td>';
			row += '		<div><input type="text" value="' + numberWithCommas(rowData.cur_bid_amt) + '" readonly></div>';
			row += '	</td>';
			row += '	<td data-kwd_id="' + rowData.kwd_id + '">';
			row += '		<div>';
			row += '			<button class="lp4-btn-toggle-off" onclick="biddingFunc.clickBidAmtModifyBtnInPreview(this);"><img src="/image/common/bid_icon_02.png" alt="변경버튼"></button>';
			row += '			<button class="lp4-btn-toggle-on" onclick="biddingFunc.clickBidAmtStoreBtnInPreview(this);" style="display:none;"><img src="/image/common/bid_icon_03.png" alt="저장버튼"></button>';
			row += '			<button class="lp4-btn-toggle-on" onclick="biddingFunc.clickBidAmtCancelBtnInPreview(this);" style="display:none;"><img src="/image/common/bid_icon_04.png" alt="엑스버튼"></button>';
			row += '		</div>';
			row += '		<div><input type="text" id="preview-' + rowData.kwd_id + '" placeholder="최소 ' + AMT_MIN_VALUE + '원" value="' + numberWithCommas(rowData.cur_bid_amt) + '" class="change_input" readonly></div>';
			row += '	</td>';
			row += '</tr>';
			return row;
		},
	
		clickBidAmtModifyBtnInPreview: function clickBidAmtModifyBtnInPreview(obj) {
			var $this = $(obj).hide();
			var $parent = $this.closest('td');
			var kwdId = $parent.data('kwd_id');
			$parent.find('.lp4-btn-toggle-on').show();
			var $input = $parent.find('.change_input');
			$input.val(checkedBiddingList[kwdId].cur_bid_amt).prop('readonly', false);
		},
		clickBidAmtStoreBtnInPreview: function clickBidAmtStoreBtnInPreview(obj) {
			var $this = $(obj);
			var $parent = $this.closest('td');
			var kwdId = $parent.data('kwd_id');
			var $input = $parent.find('.change_input');
			biddingFunc.setCurBidAmtBySame($input.val());
			biddingFunc.clickBidAmtCancelBtnInPreview(obj);
		},
		clickBidAmtCancelBtnInPreview: function clickBidAmtCancelBtnInPreview(obj) {
			var $this = $(obj);
			var $parent = $this.closest('td');
			var kwdId = $parent.data('kwd_id');
			$parent.find('.lp4-btn-toggle-on').hide();
			$parent.find('.lp4-btn-toggle-off').show();
			var $input = $parent.find('.change_input');
			$input.val(numberWithCommas(checkedBiddingList[kwdId].cur_bid_amt)).prop('readonly', true);
		},
	
		clickBidAmtPreviewBtn: function clickBidAmtPreviewBtn() {
			var $radio = $('.amt-choices:checked');
			var $parentLi = $radio.closest('li');
			var changeValue = $parentLi.find('.change-value').val();
			var changeValueType = $parentLi.find('.change-value-type').val();
	
			if (changeValue == '') {
				alert('입찰가를 입력해주세요.');
				return;
			}
	
			// 최대입찰가 클릭되어 있을 시 Start
			var optionChecked = $('#option').prop('checked');
			var $optionMaxBidAmt = $('#option-max-bid-amt');
			var optionMaxBidAmtVal = $optionMaxBidAmt.val();
	
			if (optionChecked) {
				if (optionMaxBidAmtVal == '') {
					alert('옵션) 최대입찰가를 입력해주세요.');
					return;
				} else if (Number(optionMaxBidAmtVal) < AMT_MIN_VALUE || AMT_MAX_VALUE < Number(optionMaxBidAmtVal)) {
					alert('최대입찰가는 최소 ' + AMT_MIN_VALUE + '원에서 최대 100,000원입니다.');
					return;
				} else {
					OPTION_MAX_BID_AMT = Number(optionMaxBidAmtVal);
				}
			} else {
				OPTION_MAX_BID_AMT = AMT_MAX_VALUE;
			}
			// 최대입찰가 클릭되어 있을 시 End
	
			switch ($radio.val()) {
				case 'SAME':
					biddingFunc.setCurBidAmtBySame(changeValue);
					break;
				case 'INCREASE':
					biddingFunc.setCurBidAmtByIncrease(changeValue, changeValueType);
					break;
				case 'DECREASE':
					biddingFunc.setCurBidAmtByDecrease(changeValue, changeValueType);
					break;
				case 'MID_AMT':
				case 'AVG_AMT':
					var params = '?na_customer=' + currentNaverAccId;
					params += '&view_bid_type=' + changeValue;
					params += '&na_kwd_sers=' + biddingFunc.makeCheckedBiddingListKeywordKeyCommaStr();
					var dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'NaverApiAmt', params);
					_loading.AjaxLoading.pageLoading();
					_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setCurBidAmtByNaverAPI);
					break;
			}
		},
	
		makeCheckedBiddingListKeywordKeyCommaStr: function makeCheckedBiddingListKeywordKeyCommaStr() {
			var na_kwd_sers = '';
			for (var key in checkedBiddingList) {
				na_kwd_sers += key + ',';
			}
			na_kwd_sers = na_kwd_sers.substring(0, na_kwd_sers.length - 1);
			return na_kwd_sers;
		},
	
		clickCheckedBidAmtSaveBtn: function clickCheckedBidAmtSaveBtn() {
			biddingFunc.updateBidAmt();
		},
		// 현재 입찰가 관련 End
	
	
		// 더보기 버튼
		clickMoreBiddingListBtn: function clickMoreBiddingListBtn(obj) {
			var dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'dateMatch', biddingFunc.makeGetBiddingListDataApiUrl());
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setBiddingList);
		},
	
		// 더보기 버튼 노출 여부
		checkMoreBiddingListBtn: function checkMoreBiddingListBtn(total_cnt) {
			if (++pagingIdx * numOfPaging <= total_cnt) {
				$('#data-more-area').css('display', '');
			} else {
				$('#data-more-area').css('display', 'none');
			}
		},
	
		// 체크 된 행 세팅
		setCheckedRows: function setCheckedRows(notActive) {
			var $checkedList = $('.list-check:checked');
			if (notActive == true) {
				$checkedList = $checkedList.not('.active-row');
			}
			var cKwdId = null;
			checkedBiddingList = {};
			$checkedList.each(function (index) {
				cKwdId = $(this).data('kwd_id');
				checkedBiddingList[cKwdId] = JSON.parse(JSON.stringify(biddingList[cKwdId]));
			});
		},
	
		// 즐겨찾기 관련 Start
		refreshKeywordListInBidFavorite: function refreshKeywordListInBidFavorite() {
			var dataApi = _dataUrl.dataUrl.favoriteAPI('GET', 'groupKey', "?adv_id=" + currentAdvId);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setKeywordListInBidFavorite);
		},
		setKeywordListInBidFavorite: function setKeywordListInBidFavorite(result) {
			keywordListInBidFavorite = result.data;
		},
		setHaveBidFavoriteGroups: function setHaveBidFavoriteGroups(result) {
			var groups = result.data.groups;
			var oneGroup = null;
			for (var key in groups) {
				oneGroup = groups[key];
				haveBidFavoriteGroups[oneGroup['id']] = oneGroup['name'];
			}
		},
		changeNeedCheckedBtn: function changeNeedCheckedBtn() {
			if ($('.list-check:checked').length == 0) {
				$('.need-clicked-btn').prop('disabled', true);
			} else {
				$('.need-clicked-btn').prop('disabled', false);
			}
		},
	
		deleteCheckedOneRow: function deleteCheckedOneRow(obj) {
			var $this = $(obj);
			if (confirm('삭제하시겠습니까?')) {
				delete checkedBiddingList[$this.data('kwd_id')];
				$this.closest('li').remove();
				biddingFunc.setSelectedKeywordCount();
			}
		},
	
		setSelectedKeywordCount: function setSelectedKeywordCount() {
			$('#bf-selected-keyword-count').text("(" + Object.keys(checkedBiddingList).length + ")");
		},
	
		openBidFavoritePopUp: function openBidFavoritePopUp() {
			biddingFunc.setCheckedRows(false);
			biddingFunc.setSelectedKeywordCount();
			var rows = '';
	
			var $oldSelectbox = $('#bf-old-select');
			var options = '';
			for (var key in haveBidFavoriteGroups) {
				options += "<option value='" + key + "'>" + haveBidFavoriteGroups[key] + "</option>";
			}
			$oldSelectbox.html(options);
	
			for (var key in checkedBiddingList) {
				rows += biddingFunc.makeOneBidFavoriteRow(checkedBiddingList[key]);
			}
			$('.bf-selected-keywords-ul').html(rows);
			$('.fixed-pop').fadeIn(200, function () {
				$(this).clearQueue();
			});
		},
	
		makeOneBidFavoriteRow: function makeOneBidFavoriteRow(rowData) {
			var row = '';
			row += "<li>";
			row += "	<div>";
			row += "		<button data-kwd_id='" + rowData.kwd_id + "' onclick='biddingFunc.deleteCheckedOneRow(this);'>";
			row += "			<img src='image/common/bid_icon_04.png'>";
			row += "		</button>";
			row += "	</div>";
			row += "	<div>";
			row += rowData.kwd_nm + "( " + rowData.adgroup_nm + " > " + rowData.campaign_nm + " )";
			if (keywordListInBidFavorite[rowData.kwd_id] != undefined) {
				row += " ( " + keywordListInBidFavorite[rowData.kwd_id] + " )";
			}
			row += "	</div>";
			row += "</li>";
			return row;
		},
		clickSaveBidFavoriteBtn: function clickSaveBidFavoriteBtn() {
			var groupType = $('.bf-bid-favorite-radio:checked').val();
			var newGroupNameVal = $('#bf-new-input').val();
			var oldGroupSelectedVal = $('#bf-old-select option:checked').val();
			var keywordsArr = new Array();
			var sendData = {
				group: {
					advs_id: currentAdvId
				}
			};
	
			if (groupType == 'new') {
				if (newGroupNameVal == '') {
					alert('신규 그룹명을 입력해주세요.');
					return;
				}
				sendData['group']['name'] = newGroupNameVal;
			} else {
				// groupType == 'old'
				sendData['group']['id'] = oldGroupSelectedVal;
			}
	
			for (var key in checkedBiddingList) {
				keywordsArr.push(checkedBiddingList[key]);
			}
			sendData['keywords'] = keywordsArr;
			var dataApi = _dataUrl.dataUrl.favoriteAPI('POST', 'keywordPush', '');
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, biddingFunc.afterSaveBidFavorite, sendData);
		},
		afterSaveBidFavorite: function afterSaveBidFavorite(result) {
			if (result.success) {
				if (result.data == 'OVER_BY_ADV_ID') {
					alert('광고주별 최대 즐겨찾기 개수를 초과하였습니다.');
				} else if (result.data == 'OVER_BY_ALL') {
					alert('입찰 솔루션에 등록 가능한 즐겨찾기 갯수가 초과하였습니다.');
				} else {
					biddingFunc.refreshKeywordListInBidFavorite();
					alert('즐겨찾기가 추가되었습니다.');
					$('.fixed-pop').hide();
				}
			}
		},
		// 즐겨찾기 관련 End
	
	
		// 키워드 상태 관련 Start
		oneBidStatusBtnClick: function oneBidStatusBtnClick(kwd_id) {
			var keyword = biddingList[kwd_id];
			keyword['before_status'] = keyword['status'];
			keyword['status'] = keyword['status'] == 'ELIGIBLE' ? 'PAUSED' : 'ELIGIBLE';
			var keywords = new Array();
			keywords.push(keyword);
			biddingFunc.updateBidStatus(keywords);
		},
		checkedBidStatusBtnClick: function checkedBidStatusBtnClick(changeStatus) {
			biddingFunc.setCheckedRows();
			var keyword = null;
			var keywords = new Array();
			for (var key in checkedBiddingList) {
				keyword = checkedBiddingList[key];
				keyword['before_status'] = keyword['status'];
				keyword['status'] = changeStatus;
				keywords.push(keyword);
			}
			biddingFunc.updateBidStatus(keywords);
		},
		updateBidStatus: function updateBidStatus(keywords) {
			if (confirm('변경하시겠습니까?') == false) {
				return;
			}
			var sendData = {
				adv_id: currentAdvId,
				keywords: keywords
			};
			var dataApi = _dataUrl.dataUrl.favoriteAPI('POST', 'updateStatus', '');
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, biddingFunc.afterUpdateBidStatus, sendData);
		},
		afterUpdateBidStatus: function afterUpdateBidStatus(result) {
			var returnList = result.data;
			var kwdId = null;
			var changedStatus = returnList[0].status;
	
			for (var idx = 0; idx < returnList.length; idx++) {
				kwdId = returnList[idx].nccKeywordId;
				biddingList[kwdId]['status'] = changedStatus;
				$('#row-' + kwdId).find('.status-on-btn').attr('class', 'status-on-btn ' + (changedStatus == 'ELIGIBLE' ? 'on' : ''));
				$('#row-' + kwdId).find('.status-off-btn').attr('class', 'status-off-btn ' + (changedStatus == 'PAUSED' ? 'on' : ''));
			}
		},
		// 키워드 상태 관련 End
	
	
		// 검색 관련 Start
		initAdvancedSearch: function initAdvancedSearch() {
			advanceSearchUse = false;
			filter_fields = '';
			filter_operations = '';
			filter_values = '';
			$('#toggleAdvancedSearchBtn').text('고급검색열기');
			var param = "?field_name=group";
			var dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'addSelectField', param);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setAdvancedSearchGroupOptions);
		},
		setAdvancedSearchGroupOptions: function setAdvancedSearchGroupOptions(result) {
			advSrchGroupOptions = result.data;
			$('#bidding-advanced-search').hide().html(biddingFunc.makeOneAdvancedSearchRow('add'));
		},
	
		makeOneAdvancedSearchRow: function makeOneAdvancedSearchRow(btnType) {
			var row = '';
			row = '<div class="add_contents">';
			row += '		<div class="add_select">';
			row += '				<select class="type_select" onchange="biddingFunc.onChangeAdvancedGroupSelect(this);">';
			row += '          <option disabled selected value="NA">유형 선택</option>';
			for (var idx = 0; idx < advSrchGroupOptions.length; idx++) {
				if (checkedType.list == 'Lookup') {
					row += '        <option ' + (advSrchGroupOptions[idx].field_name != "origin" ? 'disabled' : '') + ' value="' + advSrchGroupOptions[idx].field_name + '">' + advSrchGroupOptions[idx].field_label + '</option>';
				} else {
					row += '				<option value="' + advSrchGroupOptions[idx].field_name + '">' + advSrchGroupOptions[idx].field_label + '</option>';
				}
			}
			row += '				</select>';
			row += '				<select class="data_select">';
			row += '          <option disabled selected value="NA">유형을 먼저 선택해주세요.</option>';
			row += '				</select>';
			row += '				<select class="section_select" onchange="biddingFunc.onChangeAdvancedSection(this);">';
			row += '						<option value="compare" selected>구간</option>';
			row += '						<option value="more">이상</option>';
			row += '						<option value="less">이하</option>';
			row += '				</select>';
			row += '		</div>';
			row += '		<div class="add_input">';
			row += '				<input type="number" class="adv-srch-value">';
			row += '				<span class="not-compare">~</span>';
			row += '				<input class="not-compare adv-srch-value" type="number">';
			row += '		</div>';
			row += '		<button type="button" class="add_btn box_model" data-btn-type="' + btnType + '" onclick="biddingFunc.clickAdvancedAMBtn(this);">' + (btnType == 'add' ? '+' : '-') + '</button>';
			row += '</div>';
			return row;
		},
		toggleAdvancedSearch: function toggleAdvancedSearch() {
			if (advanceSearchUse == false) {
				advanceSearchUse = true;
				$('#toggleAdvancedSearchBtn').text('고급검색닫기');
				$('#bidding-advanced-search').show();
			} else {
				advanceSearchUse = false;
				$('#toggleAdvancedSearchBtn').text('고급검색열기');
				$('#bidding-advanced-search').hide();
			}
		},
		clickAdvancedAMBtn: function clickAdvancedAMBtn(obj) {
			var $this = $(obj);
			var btnType = $this.data('btn-type');
	
			if (btnType == 'add') {
				$('#bidding-advanced-search').append(biddingFunc.makeOneAdvancedSearchRow('minus'));
			} else {
				$this.closest('.add_contents').remove();
			}
		},
		onChangeAdvancedSection: function onChangeAdvancedSection(obj) {
			var $this = $(obj);
			var optionType = $this.val();
			var $parent = $this.closest('.add_contents');
			if (optionType == 'compare') {
				$parent.find('.not-compare').show();
			} else {
				$parent.find('.not-compare').hide();
			}
		},
		onChangeAdvancedGroupSelect: function onChangeAdvancedGroupSelect(obj) {
			var $this = $(obj);
			$currentAdvSearchRow = $this.closest('.add_contents');
			var param = "?field_name=" + $this.val();
			var dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'addSelectField', param);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setAdvancedSearchDataOptions);
		},
		setAdvancedSearchDataOptions: function setAdvancedSearchDataOptions(result) {
			var $dataSelect = $currentAdvSearchRow.find('.data_select');
			var optionData = result.data;
	
			var options = '';
			for (var idx = 0; idx < optionData.length; idx++) {
				options += "<option value='" + optionData[idx].type + "'>" + optionData[idx].type_label + "</option>";
			}
			$dataSelect.html(options);
			$currentAdvSearchRow = null;
		},
		clickSearchKeywordBtn: function clickSearchKeywordBtn() {
			var searchKeyword = $('#bidding-default-search-keyword').val();
			var searchType = $('#bidding-default-search-type').val();
			if (searchKeyword == '' && advanceSearchUse == false) {
				alert('키워드를 입력해주세요.');
				return;
			}
	
			if (advanceSearchUse == true) {
				var $advancedRows = $('.add_contents');
				var $row = null;
				var $field = null;
				var fieldValue = null;
				var operationValue = null;
				var valueValue = null;
				var detailValueInputCheck = false;
				var $inputs = null;
	
				filter_fields = '';
				filter_operations = '';
				filter_values = '';
	
				$.each($advancedRows, function (idx, row) {
					$row = $(row);
	
					$field = $row.find('.type_select');
					fieldValue = $row.find('.data_select').val();
					fieldValue = checkedType.list == 'Compare' ? fieldValue : fieldValue.substring(0, fieldValue.length - 4); // 조회 일 경우 '_org' 제거
					operationValue = $row.find('.section_select').val();
	
					$inputs = $row.find('.adv-srch-value');
					if (operationValue == 'compare') {
						if ($inputs[0].value == '' || $inputs[1].value == '') {
							detailValueInputCheck = false;
						} else {
							detailValueInputCheck = true;
							valueValue = $inputs[0].value + '/' + $inputs[1].value;
						}
					} else {
						if ($inputs[0].value == '') {
							detailValueInputCheck = false;
						} else {
							detailValueInputCheck = true;
							valueValue = $inputs[0].value;
						}
					}
	
					// 상세 데이터 입력시에만 조건에 추가
					if (detailValueInputCheck) {
						filter_fields += fieldValue + ",";
						filter_operations += operationValue + ",";
						filter_values += valueValue + ",";
					}
				});
			}
			biddingFunc.initReptJobHistory(currentCs1Value, currentCs2Value, searchType, searchKeyword);
			var dataApi = _dataUrl.dataUrl.biddingAPI('GET', 'dateMatch', biddingFunc.makeGetBiddingListDataApiUrl());
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, biddingFunc.setBiddingList);
		}
		// 검색 관련 End
	
	};
	
	window.biddingFunc = biddingFunc;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.Formcheck = Formcheck;
	exports.valueFilter = valueFilter;
	exports.checkRadioShowAreaControl = checkRadioShowAreaControl;
	exports.numberWithCommas = numberWithCommas;
	exports.uncomma = uncomma;
	exports.upperCase = upperCase;
	//-- isEmpty 체크--//
	function isEmpty(val) {
		if (val == null || typeof val == 'undefind' || val.trim().length < 1) {
			return true;
		}
		return false;
	}
	function Formcheck(formName) {
		var valid = true;
		var form = $('#' + formName);
		var formData = null;
		form.find('input, textarea, select').each(function (key) {
			var obj = $(this);
			if (obj.attr('validation') == 'yes') {
				if (isEmpty(obj.val())) {
					alert(obj.attr('title') + '를 입력해주세요');
					$('#' + this.id).focus();
	
					valid = false;
					return false;
				}
			}
			var selectAttr = obj.attr('type');
			if (selectAttr == 'radio' || selectAttr == 'checkbox') {
				var selectCheck = obj.prop('checked');
				if (selectCheck == true) {
					formData = decodeURIComponent(form.serialize());
				}
			} else if (formName == 'loginForm') {
				formData = form.serializeArray();
			} else {
				formData = decodeURIComponent(form.serialize());
			}
		});
		if (valid == true && formData != null) {
			formAjaxCall(formName, formData);
		}
	}
	function formAjaxCall(formName, objVal) {
		if (formName == 'loginForm') {
			loginFunc.memberLogIn(objVal);
		} else if (formName == 'biddingForm') {
			biddingFunc.biddingListData('dateMatch', objVal);
		} else if (formName == 'biddingForm, #biddingSearchForm') {
			biddingFunc.biddingSearchData(objVal);
		} else if (formName == 'favoriteSearchForm') {
			favoriteFunc.favoriteSearchData(objVal);
		} else if (formName == 'operateKeywordSearch') {
			favoriteFunc.favoriteKeywordSearchData(objVal);
		}
	}
	function trim(obj) {
		return obj.replace(/(^\s*)|(\s*$)/gi, "");
	}
	//특수문자 제거
	function valueFilter(event) {
		var filter = "[A-Za-z0-9]+";
		if (filter) {
			var sKey = String.fromCharCode(event.keyCode);
			var re = new RegExp(filter);
			if (!re.test(sKey)) {
				event.returnValue = false;
				event.preventDefault();
			}
		}
	}
	
	function checkRadioShowAreaControl(obj) {
		var $this = $(obj);
		var name = $this.attr('name');
		$('.targets-' + name).hide();
		$('#' + $this.data('target')).show();
	}
	
	function numberWithCommas(n) {
		return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	
	function uncomma(str) {
		str = String(str);
		return str.replace(/[^\d]+/g, '');
	}
	function upperCase(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}
	
	window.uncomma = uncomma;
	window.numberWithCommas = numberWithCommas;
	window.checkRadioShowAreaControl = checkRadioShowAreaControl;
	window.Formcheck = Formcheck;
	window.valueFilter = valueFilter;
	window.upperCase = upperCase;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.createFunc = undefined;
	
	var _ajaxForm = __webpack_require__(209);
	
	var _loading = __webpack_require__(210);
	
	var _dataUrl = __webpack_require__(718);
	
	//로딩 액션
	var listData = {};
	//데이터 API 목록
	//AJAX 프레임
	
	var popUpId = null;
	var groupId = '#advId';
	var advId = $(groupId).val();
	var length = 50;
	var checkType;
	
	var createFunc = exports.createFunc = {
		init: function init() {},
		//데이터 생성 리스트
		createListCall: function createListCall(dataId, type) {
			advId = $(groupId).val();
			var param = "?adv_id=" + dataId;
			var dataApi = _dataUrl.dataUrl.createAPI('GET', 'history', param);
			if (type != 'sync') {
				_loading.AjaxLoading.pageLoading();
			}
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, createFunc.createHistoryCallBack);
			createFunc.createDayCheckData('day');
			createFunc.createWeekCheckData('week');
			setTimeout(function () {
				$(".create-date-td").dateRangeCustomPicker({ single: false, autoClose: false });
			}, 500);
		},
		createListReData: function createListReData() {
			var param = "?adv_id=" + advId;
			var dataApi = _dataUrl.dataUrl.createAPI('GET', 'history', param);
			_loading.AjaxLoading.pageLoading();
			setTimeout(function () {
				_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, createFunc.createHistoryCallBack);
				createFunc.createDayCheckData('day');
				createFunc.createWeekCheckData('week');
			}, 500);
		},
		//데이터 생성(생성)
		createAddData: function createAddData(data) {
			var valSplit = data.split('~');
			var firstDate = valSplit[0];
			var lastDate = valSplit[0];
			if (valSplit[1] != undefined) {
				lastDate = valSplit[1];
			}
			var request = {
				"adv_id": advId,
				"type": "custom",
				"data": {
					"from_date": firstDate,
					"to_date": lastDate
				}
			};
			var dataApi = _dataUrl.dataUrl.createAPI('POST', 'add');
			_loading.AjaxLoading.pageLoading('time');
			_ajaxForm.ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, createFunc.createAddCallBack, request);
		},
		//데이터 생성(저장)
		createSaveData: function createSaveData() {
			var daily = $('#daily').prop('checked');
			var weekly = $('#weekly').prop('checked');
			var request = {
				"adv_id": advId,
				"type": "reservation",
				"data": {
					"day": daily,
					"week": weekly
				}
			};
			var dataApi = _dataUrl.dataUrl.createAPI('POST', 'save');
			_loading.AjaxLoading.pageLoading('time');
			_ajaxForm.ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, createFunc.createSaveCallBack, request);
		},
		//데이터 리스트 삭제(단일)
		createListDeleteData: function createListDeleteData(obj) {
			var dataApi = _dataUrl.dataUrl.createAPI('DELETE', 'history', obj);
			var dataSplit = dataApi.split('?');
			var dataParam = dataSplit[1];
			_ajaxForm.ajaxFrame.ajaxDataCall('PUT', dataApi, 'json', true, createFunc.createListDeleteCallBack, dataParam);
		},
		//데이터 리스트 전체 삭제
		createListAllDeleteData: function createListAllDeleteData(obj) {
			var dataApi = _dataUrl.dataUrl.createAPI('DELETE', 'history', obj);
			var dataSplit = dataApi.split('?');
			var dataParam = dataSplit[1];
			_ajaxForm.ajaxFrame.ajaxDataCall('PUT', dataApi, 'json', true, createFunc.createListAllDeleteCallBack, dataParam);
		},
		//데이터 상태 팝업
		createConditionPopUpDate: function createConditionPopUpDate(obj) {
			popUpId = obj;
			var dataApi = _dataUrl.dataUrl.createAPI('GET', 'status', obj);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, createFunc.createConditionPopCallBack);
		},
		createDayCheckData: function createDayCheckData(obj) {
			if (advId != null) {
				var param = '?adv_id=' + advId + '&rept_type=' + obj;
				var dataApi = _dataUrl.dataUrl.createAPI('GET', 'saveCheck', param);
				_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', false, createFunc.createSaveDayCheckCallBack);
			}
		},
		createWeekCheckData: function createWeekCheckData(obj) {
			var param = '?adv_id=' + advId + '&rept_type=' + obj;
			var dataApi = _dataUrl.dataUrl.createAPI('GET', 'saveCheck', param);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', false, createFunc.createSaveWeekCheckCallBack);
		},
		createListHistoryIdData: function createListHistoryIdData() {},
		//CallBack Functions
		//데이터 생성 리스트
		createHistoryCallBack: function createHistoryCallBack(data) {
			var dataFilter = data.data;
			var historyHtml = '';
			var listCount = dataFilter.length;
			var $more = $('.data_more');
			var $count = $('#create-count');
			var $list = $('#create-list');
			if (listCount > 0) {
				for (var i = 0; i < listCount; i++) {
					var reptType = dataFilter[i].rept_type == 'custom' ? '일반' : '예약';
					var result = dataFilter[i].result_cd == 'complete' ? '완료' : dataFilter[i].result_cd == 'fail' ? '실패' : dataFilter[i].result_cd == 'ready' ? '' : '진행';
					var descriptionData = eval("(" + dataFilter[i].description_json + ")");
					var addDate = descriptionData.call_date_at;
					var comDate = descriptionData.complete_date_at;
					var conditionColor = result == '진행' ? 'blue' : result == '실패' ? 'red' : '';
	
					historyHtml += "<tr class='list-num-" + i + "' data-id='" + dataFilter[i].id + "'>";
					historyHtml += "<td><input type='checkbox' class='list-check' id='reservation" + i + "' onclick='createFunc.createBtnOnOffEvent();'><label for='reservation" + i + "'></label></td>";
					historyHtml += "<td>" + reptType + "</td>";
					historyHtml += "<td>" + dataFilter[i].work_name + "</td>";
					historyHtml += "<td class='condition_btn'>";
					historyHtml += "<span style='color:" + conditionColor + ";'>" + result + "</span>";
					historyHtml += "<span class='condition-icon'><a href='javascript:void(0);' id='condition-btn" + i + "' onclick='javascript:layerPopup.open(this, this.id);' class='layer-pop-open' data-name='createCondition' data-id='list-num-" + i + "'><img src='/image/common/eye_btn.png' alt=''></a></span>";
					historyHtml += "</td>";
					historyHtml += "<td>" + addDate + "</td>";
					if (result != '실패') {
						historyHtml += "<td>" + comDate + "</td>";
					} else {
						historyHtml += "<td></td>";
					}
					if (result != '실패' || result != '완료') {
						historyHtml += "<td align='center' class='box_btn' ><button type='button' data-comment='type-1' onclick='createList.listDeleteBtn(this);'' data-id='list-num-" + i + "'>삭제</button></td>";
					} else if (result == '진행') {
						historyHtml += "<td align='center' class='box_btn' ><button type='button' data-comment='type-2' onclick='createList.listDeleteBtn(this);'' data-id='list-num-" + i + "'>삭제</button></td>";
					} else {
						historyHtml += "<td align='center' class='box_btn' ><button type='button' data-comment='type-2' disabled onclick='createList.listDeleteBtn(this);'' data-id='list-num-" + i + "'>삭제</button></td>";
					}
					historyHtml += "</tr>";
	
					listData['type' + dataFilter[i].id] = reptType;
					listData['work' + dataFilter[i].id] = dataFilter[i].work_name;
				}
	
				$more.show();
			} else {
				historyHtml += "<tr>";
				historyHtml += "<td colspan='7'><div class='none_date'><img src='/image/none_date_img.jpg' alt=''></div></td>";
				historyHtml == "</tr>";
	
				$more.hide();
			}
			$count.text(listCount);
			$list.html(historyHtml);
		},
		//데이터 생성 (생성)
		createAddCallBack: function createAddCallBack(data) {
			setTimeout(function () {
				createFunc.createListCall(advId, 'sync');
				alwaysFunc.headerNewsData(advId);
				$('#timeLoading').remove();
			}, 2000);
		},
		//데이터 생성 (저장)
		createSaveCallBack: function createSaveCallBack(data) {
			setTimeout(function () {
				createFunc.createListCall(advId, 'sync');
				alwaysFunc.headerNewsData(advId);
				$('#timeLoading').remove();
				alert('저장 되었습니다');
			}, 2000);
		},
		//데이터 상태 팝업
		createConditionPopCallBack: function createConditionPopCallBack(data) {
			var dataFilter = data.data;
			var dataMessage = dataFilter.status == 'complete' ? '데이터 생성이 완료되었습니다' : dataFilter.status == 'fail' ? '데이터 생성에 실패하였습니다.' : '데이터 생성 진행중입니다.';
			var conditionData = {
				'status_neo_raw_data': dataFilter.status_neo_raw_data == 'complete' ? '완료' : dataFilter.status_neo_raw_data == 'fail' ? '실패' : dataFilter.status_neo_raw_data == 'ready' ? '' : '진행',
				'status_neo_duple_data': dataFilter.status_neo_duple_data == 'complete' ? '완료' : dataFilter.status_neo_duple_data == 'fail' ? '실패' : dataFilter.status_neo_duple_data == 'ready' ? '' : '진행',
				'status_naver_data': dataFilter.status_naver_data == 'complete' ? '완료' : dataFilter.status_naver_data == 'fail' ? '실패' : dataFilter.status_naver_data == 'ready' ? '' : '진행',
				'status_integrate_data': dataFilter.status_integrate_data == 'complete' ? '완료' : dataFilter.status_integrate_data == 'fail' ? '실패' : dataFilter.status_integrate_data == 'ready' ? '' : '진행',
				'status_save_db': dataFilter.status_save_db == 'complete' ? '완료' : dataFilter.status_save_db == 'fail' ? '실패' : dataFilter.status_save_db == 'ready' ? '' : '진행'
			};
			var $message = $('#layer-message');
			var $type = $('#layer-type');
			var $date = $('#layer-date');
			var $title = $('.popup-title');
			var $body = $('.popup-body');
			var $layer = $('.layer-pop');
	
			var popTitle = "상태";
			var popHtml = "<div id='condition-popup' class='condition-popup-wrap'>";
			popHtml += "<div class='condition-table-area'>";
			popHtml += "<div class='condition-list'>";
			popHtml += "<div class='condition-name'>NEO 데이터 수급</div>";
			popHtml += "<div class='condition-result'>" + conditionData.status_neo_raw_data + "</div>";
			popHtml += "</div>";
			popHtml += "<div class='condition-list'>";
			popHtml += "<div class='condition-name'>NEO 데이터 중복 필터</div>";
			popHtml += "<div class='condition-result'>" + conditionData.status_neo_duple_data + "</div>";
			popHtml += "</div>";
			popHtml += "<div class='condition-list'>";
			popHtml += "<div class='condition-name'>네이버 광고 데이터 수급</div>";
			popHtml += "<div class='condition-result'>" + conditionData.status_naver_data + "</div>";
			popHtml += "</div>";
			popHtml += "<div class='condition-list'>";
			popHtml += "<div class='condition-name'>전체 데이터 취합</div>";
			popHtml += "<div class='condition-result'>" + conditionData.status_integrate_data + "</div>";
			popHtml += "</div>";
			popHtml += "<div class='condition-list'>";
			popHtml += "<div class='condition-name'>데이터 정제(DB 저장)</div>";
			popHtml += "<div class='condition-result'>" + conditionData.status_save_db + "</div>";
			popHtml += "</div>";
			popHtml += "</div>";
			popHtml += "</div>";
	
			$message.text(dataMessage);
			$type.text(listData['type' + popUpId]);
			$date.text(listData['work' + popUpId]);
			$title.text(popTitle);
			$body.html(popHtml);
			$layer.fadeIn(200);
		},
		//데이터 생성 삭제 (단일)
		createListDeleteCallBack: function createListDeleteCallBack(data) {
			createFunc.createListCall(advId);
			alwaysFunc.headerNewsData(advId);
			var newsLength = null;
			$('#my-news-data').find('li').each(function (length) {
				newsLength = length;
			});
			if (newsLength == null) {
				$('.new-icon').removeClass('active');
			} else {
				$('.new-icon').addClass('active');
			}
		},
		//데이터 생성 선택 리스트 삭제
		createListAllDeleteCallBack: function createListAllDeleteCallBack(data) {
			alert('선택된 리스트가 삭제되었습니다');
			createFunc.createListCall(advId);
			alwaysFunc.headerNewsData(advId);
			var newsLength = null;
			$('#my-news-data').find('li').each(function (length) {
				newsLength = length;
			});
			if (newsLength == null) {
				$('.new-icon').removeClass('active');
			} else {
				$('.new-icon').addClass('active');
			}
		},
		createSaveDayCheckCallBack: function createSaveDayCheckCallBack(data) {
			var dataFilter = data.data;
			if (0 < dataFilter.length) {
				$("#daily").prop('checked', true);
			} else {
				$("#daily").prop('checked', false);
			}
		},
		createSaveWeekCheckCallBack: function createSaveWeekCheckCallBack(data) {
			var dataFilter = data.data;
			if (0 < dataFilter.length) {
				$("#weekly").prop('checked', true);
			} else {
				$("#weekly").prop('checked', false);
			}
		},
		createBtnOnOffEvent: function createBtnOnOffEvent() {
			if ($('.list-check:checked').length == 0) {
				$('.check-btn').prop('disabled', true);
			} else {
				$('.check-btn').prop('disabled', false);
			}
		}
	};
	
	favoriteFunc.init();
	window.createFunc = createFunc;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.settingFunc = undefined;
	
	var _ajaxForm = __webpack_require__(209);
	
	var _loading = __webpack_require__(210);
	
	var _dataUrl = __webpack_require__(718);
	
	//로딩 액션
	var currentAdvId = null;
	//데이터 API 목록
	//AJAX 프레임
	
	var currentNaverId = null;
	var neoIdList = {};
	var naverIdList = {};
	
	var settingFunc = exports.settingFunc = {
		init: function init() {
			//this.naverSettingListData(advId);
		},
		callSettingByAdvId: function callSettingByAdvId(adv_id) {
			currentAdvId = adv_id;
			var dataApi = _dataUrl.dataUrl.settingAPI('GET', 'naver', currentAdvId);
			_loading.AjaxLoading.pageLoading();
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, settingFunc.initLinkSetting);
	
			dataApi = _dataUrl.dataUrl.settingAPI('GET', 'filter', currentAdvId);
			_ajaxForm.ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, settingFunc.initDuplicationSetting);
		},
	
		initLinkSetting: function initLinkSetting(result) {
			var naverIds = null;
			var neoIdArr = result.data.neo_list;;
			var firstNaverKey = null;
			naverIdList = {};
			neoIdList = {};
	
			if (result.data.hasOwnProperty('naver_list')) {
				// 맵핑이 안된 경우
				naverIds = result.data.naver_list;
				firstNaverKey = naverIds[0];
				for (var idx = 0; idx < naverIds.length; idx++) {
					naverIdList[naverIds[idx]] = { count: 0 };
				}
				if (neoIdArr != undefined) {
					for (var idx = 0; idx < neoIdArr.length; idx++) {
						neoIdList[neoIdArr[idx]] = 'NA';
					}
				}
			} else {
				naverIds = result.data.match_list;
				if (neoIdArr != undefined) {
					for (var neoIdx = 0; neoIdx < neoIdArr.length; neoIdx++) {
						neoIdList[neoIdArr[neoIdx]] = 'NA';
					}
				}
				for (var naverId in naverIds) {
					if (firstNaverKey == null) {
						firstNaverKey = naverId;
					}
					naverIdList[naverId] = { count: 0 };
					if (neoIdArr != undefined) {
						for (var nvIdx = 0; naverIds[naverId] != null && nvIdx < naverIds[naverId].length; nvIdx++) {
							naverIdList[naverId]['count']++;
							neoIdList[naverIds[naverId][nvIdx]] = naverId;
						}
					}
				}
			}
	
			settingFunc.clickNaverCampaign(firstNaverKey);
		},
	
		clickNaverCampaign: function clickNaverCampaign(naverId) {
			currentNaverId = naverId;
	
			var $onCampaign = $('.on_campaign');
			var $noCampaign = $('.no_campaign');
	
			var campaignRow = "<li>" + "	<a href='javascript:void(0);' class='{{{clazz}}}' onclick='settingFunc.clickNaverCampaign(\"{{{naverId}}}\");' data-naver-id='{{{naverId}}}'>" + "		{{{naverId}}}" + "		<span class='campaignCount'>(<strong id='count-by-naver-id-{{{naverId}}}'>{{{count}}}</strong>)</span>" + "	</a>" + "</li>";
			var rows = '';
			for (var key in naverIdList) {
				if (currentNaverId == key) {
					rows += campaignRow.replace(/{{{naverId}}}/g, key).replace(/{{{count}}}/g, naverIdList[key]['count']).replace('{{{clazz}}}', 'active');
				} else {
					rows += campaignRow.replace(/{{{naverId}}}/g, key).replace(/{{{count}}}/g, naverIdList[key]['count']).replace('{{{clazz}}}', '');
				}
			}
			$onCampaign.find('ul').empty().append(rows);
			settingFunc.initNeoRows();
			settingFunc.calcSelectedNeoCountByNaverCampaign();
		},
	
		calcSelectedNeoCountByNaverCampaign: function calcSelectedNeoCountByNaverCampaign() {
			try {
				for (var key in naverIdList) {
					$('#count-by-naver-id-' + key).html(naverIdList[key]['count']);
				}
				settingFunc.showNaverCampaignArea();
				settingFunc.showNeoAccountArea();
				$('.no_special_characters').hide();
			} catch (e) {
				settingFunc.showNoSpecialCharacterErrorArear();
			}
		},
	
		showNaverCampaignArea: function showNaverCampaignArea() {
			var $onNaver = $('.on_campaign');
			var $noNaver = $('.no_campaign');
			if (Object.keys(naverIdList).length > 0) {
				$onNaver.show();
				$noNaver.hide();
			} else {
				$noNaver.show();
				$onNaver.hide();
			}
		},
	
		showNeoAccountArea: function showNeoAccountArea() {
			var $onNeo = $('.on_neo');
			var $noNeo = $('.no_neo');
			if (Object.keys(neoIdList).length > 0) {
				$onNeo.show();
				$noNeo.hide();
			} else {
				$noNeo.show();
				$onNeo.hide();
			}
		},
	
		showNoSpecialCharacterErrorArear: function showNoSpecialCharacterErrorArear() {
			alert('NAVER 캠페인명 또는 NEO 계정명에 띄어쓰기 또는\n허용되지 않는 특수문자가 포함되어있습니다.\n수정 후 다시 이용해주세요.');
			$('.on_campaign').hide();
			$('.no_campaign').hide();
			$('.on_neo').hide();
			$('.no_neo').hide();
			$('.no_special_characters').show();
		},
	
		initNeoRows: function initNeoRows() {
			var $onNeo = $('.on_neo');
			var $noNeo = $('.no_neo');
	
			var rows = '';
	
			var neoRow = "<li>" + "	<input id='neo-id-{{{neoId}}}' type='checkbox' onclick='settingFunc.clickNeoCheckBox(this);' data-neo-id='{{{neoId}}}' {{{checked}}} {{{disabled}}}>" + "		<label for='neo-id-{{{neoId}}}'>" + "			<span>{{{neoId}}}</span>" + "			<span class='naver-id-txt'>{{{naverId}}}</span>" + "	</label>" + "</li>";
	
			for (var key in neoIdList) {
				if (currentNaverId == neoIdList[key]) {
					rows += neoRow.replace(/{{{neoId}}}/g, key).replace(/{{{checked}}}/g, 'checked').replace(/{{{disabled}}}/g, '').replace(/{{{naverId}}}/g, '(' + neoIdList[key] + ')');
				} else if ('NA' == neoIdList[key]) {
					rows += neoRow.replace(/{{{neoId}}}/g, key).replace(/{{{checked}}}/g, '').replace(/{{{disabled}}}/g, '').replace(/{{{naverId}}}/g, '');
				} else {
					rows += neoRow.replace(/{{{neoId}}}/g, key).replace(/{{{checked}}}/g, 'checked').replace(/{{{disabled}}}/g, 'disabled').replace(/{{{naverId}}}/g, '(' + neoIdList[key] + ')');
				}
			}
			$onNeo.find('ul').empty().append(rows);
		},
	
		clickNeoCheckBox: function clickNeoCheckBox(obj) {
			var $this = $(obj);
	
			var currentNeoId = $this.data('neo-id');
			var checked = $this.prop('checked');
			var disabled = $this.prop('disabled');
	
			if (disabled == false) {
				if (checked == true) {
					naverIdList[currentNaverId]['count']++;
					neoIdList[currentNeoId] = currentNaverId;
					$this.closest('li').find('.naver-id-txt').text('(' + neoIdList[currentNeoId] + ')');
				} else {
					neoIdList[currentNeoId] = 'NA';
					naverIdList[currentNaverId]['count']--;
					$this.closest('li').find('.naver-id-txt').empty();
				}
				settingFunc.calcSelectedNeoCountByNaverCampaign();
			}
		},
	
		initDuplicationSetting: function initDuplicationSetting(result) {
			var $neoDupleCheckBoxes = $('.neoDupleCheckbox').prop('checked', false);
			if (result.data != null) {
				var ndfArr = result.data.neo_duple_fields.split(",");
				$neoDupleCheckBoxes.each(function (index) {
					for (var idx = 0; idx < ndfArr.length; idx++) {
						if (ndfArr[idx] == $(this).val()) {
							$(this).prop('checked', true);
							break;
						}
					}
				});
			}
		},
	
		save: function save() {
			var sendData = {
				adv_id: currentAdvId,
				rept_match_type: {
					'neo_field_type': 'neo_account_nm',
					'cus_field_type': 'campaign_nm'
				}
			};
	
			var neoStr = '';
			var matchOne = '';
			var matches = '';
			for (var naverKey in naverIdList) {
				matchOne = '';
				neoStr = '';
				for (var neoKey in neoIdList) {
					if (naverKey == neoIdList[neoKey]) {
						neoStr += neoKey + ",";
					}
				}
				if (neoStr != '') {
					neoStr = neoStr.substring(0, neoStr.length - 1);
					matchOne = {
						naver: naverKey,
						neo: neoStr
					};
					matches += JSON.stringify(matchOne) + ',';
				}
			}
			matches = matches.substring(0, matches.length - 1);
			sendData.rept_match_type.match_list = JSON.parse('[' + matches + ']');
	
			if (sendData.rept_match_type.match_list.length == 0) {
				alert('NAVER 캠페인과 NEO 계정이 최소 하나는 맵핑되어야합니다.');
				return;
			}
	
			var checkedNeoDupls = '';
			$('.neoDupleCheckbox').each(function (index) {
				if ($(this).prop('checked')) {
					checkedNeoDupls += $(this).val() + ',';
				}
			});
			if (checkedNeoDupls != '') {
				checkedNeoDupls = checkedNeoDupls.substring(0, checkedNeoDupls.length - 1);
			}
	
			sendData.rept_config = {
				neo_duple_fields: checkedNeoDupls
			};
	
			var dataApi = _dataUrl.dataUrl.settingAPI('POST', 'save');
			_ajaxForm.ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, settingFunc.saveCallback, sendData);
		},
	
		saveCallback: function saveCallback(result) {
			if (result.success == true) {
				alert('저장되었습니다.');
			} else {
				console.log(result.msg);
				alert('저장에 실패하였습니다.');
			}
		}
	};
	
	window.settingFunc = settingFunc;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.loginFunc = exports.sessionTime = undefined;
	
	var _ajaxForm = __webpack_require__(209);
	
	var _dataUrl = __webpack_require__(718);
	
	var _loading = __webpack_require__(210);
	
	var _cookies = __webpack_require__(207);
	
	//쿠키 시간 설정
	
	//로딩 액션
	//AJAX 프레임
	var sessionTime = exports.sessionTime = 3;
	//쿠키 호출
	
	//데이터 API 목록
	var loginFunc = exports.loginFunc = {
		memberLogIn: function memberLogIn(data) {
			var userId = data[0].value;
			var userPw = data[1].value;
			var param = '?user_name=' + userId + '&pwd=' + userPw + '&service_type=basic';
			var dataApi = _dataUrl.dataUrl.alwaysAPI('POST', 'login', param);
			_ajaxForm.ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, loginFunc.loginCallBack);
		},
		loginCallBack: function loginCallBack(data) {
			var data = data.data;
			var userDataArray = [data.token, data.user_id, data.user_name, data.name];
			var userKeyArray = ['token', 'user_id', 'user_name', 'user_nm'];
			var homeUrl = document.location.hostname;
			var moveHome = 'http://' + homeUrl;
			var urlPort = window.location.port;
			for (var i = 0; i < userKeyArray.length; i++) {
				if (userKeyArray[i] == 'user_nm') {
					var temp_key = userKeyArray[i];
					var temp_value = loginFunc.encodeURL(userDataArray[i]);
					_cookies.cookies.setCookies(temp_key, temp_value, sessionTime);
				} else {
					_cookies.cookies.setCookies(userKeyArray[i], userDataArray[i], sessionTime);
				}
			}
			if (urlPort != '') {
				moveHome = moveHome + ":" + urlPort;
			}
			location.href = moveHome;
		},
		memberLogOut: function memberLogOut() {
			var userKeyArray = ['token', 'user_id', 'user_name', 'user_nm'];
			for (var i = 0; i < userKeyArray.length; i++) {
				var userCheck = _cookies.cookies.getCookies(userKeyArray[i]);
				_cookies.cookies.setCookies(userKeyArray[i], userCheck, -sessionTime);
			}
			$("input[type='hidden']").val('');
			location.href = '#/member/login';
		},
		encodeURL: function encodeURL(str) {
			var s0, i, s, u;
			s0 = ""; // encoded str
			for (i = 0; i < str.length; i++) {
				// scan the source
				s = str.charAt(i);
				u = str.charCodeAt(i); // get unicode of the char
				if (s == " ") {
					s0 += "+"; // SP should be converted to "+"
				} else {
					if (u == 0x2a || u == 0x2d || u == 0x2e || u == 0x5f || u >= 0x30 && u <= 0x39 || u >= 0x41 && u <= 0x5a || u >= 0x61 && u <= 0x7a) {
						// check for escape
						s0 = s0 + s; // don't escape
					} else {
						// escape
						if (u >= 0x0 && u <= 0x7f) {
							// single byte format
							s = "0" + u.toString(16);
							s0 += "%" + s.substr(s.length - 2);
						} else if (u > 0x1fffff) {
							// quaternary byte format (extended)
							s0 += "%" + (oxf0 + ((u & 0x1c0000) >> 18)).toString(16);
							s0 += "%" + (0x80 + ((u & 0x3f000) >> 12)).toString(16);
							s0 += "%" + (0x80 + ((u & 0xfc0) >> 6)).toString(16);
							s0 += "%" + (0x80 + (u & 0x3f)).toString(16);
						} else if (u > 0x7ff) {
							// triple byte format
							s0 += "%" + (0xe0 + ((u & 0xf000) >> 12)).toString(16);
							s0 += "%" + (0x80 + ((u & 0xfc0) >> 6)).toString(16);
							s0 += "%" + (0x80 + (u & 0x3f)).toString(16);
						} else {
							// double byte format
							s0 += "%" + (0xc0 + ((u & 0x7c0) >> 6)).toString(16);
							s0 += "%" + (0x80 + (u & 0x3f)).toString(16);
						}
					}
				}
			}
			return s0;
		}
	
	};
	
	window.sessionTime = sessionTime;
	window.loginFunc = loginFunc;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(865);

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _biddingFunc = __webpack_require__(859);
	
	__webpack_require__(867);
	
	//환경설정 데이터
	var biddingList = {
		init: function init() {
			//검색 관련 함수
			this.searchCheck();
		},
		searchCheck: function searchCheck() {
			$('.bidding-radio, label').click(function () {
				var biddingType = $(this).parents('span').attr('id');
				var compareSel = '.comparison_select_wrap select';
				if (biddingType == 'look-box') {
					$(compareSel).prop('disabled', true).attr('validation', 'no');
				} else {
					$(compareSel).prop('disabled', false).attr('validation', 'yes');
				}
			});
		}
	};
	
	//Sass 컴파일
	
	biddingList.init();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.createList = undefined;
	
	var _createFunc = __webpack_require__(861);
	
	__webpack_require__(869);
	
	__webpack_require__(720);
	
	//Sass 컴파일
	var createList = exports.createList = {
		init: function init() {},
		userChoiceAddBtn: function userChoiceAddBtn(el) {
			var values = $(el).val();
			if (values != "") {
				var valSplit = values.split('~');
				if (valSplit[0] == valSplit[1] || valSplit[1] == undefined) {
					var comment = '하루 데이터를 생성하시겠습니까?';
					if (confirm(comment) == true) {
						_createFunc.createFunc.createAddData(values);
					} else {
						return;
					}
				} else {
					_createFunc.createFunc.createAddData(values);
				}
			} else {
				alert('선택된 날짜가 없습니다.');
			}
		},
		checkSaveBtn: function checkSaveBtn(el) {
			_createFunc.createFunc.createSaveData();
		},
		listDeleteBtn: function listDeleteBtn(e) {
			var commentType = $(e).data('comment');
			var typeMsg = commentType == 'type-1' ? '데이터와 이력을 삭제하시겠습니까?' : '데이터 생성을 취소하시겠습니까?';
			if (confirm(typeMsg) == true) {
				var thisEl = e.getAttribute("data-id");
				var thisListId = $('.' + thisEl).attr('data-id');
				_createFunc.createFunc.createListDeleteData(thisListId);
				$('.' + thisEl).remove();
			} else {
				return;
			}
		},
		listAlldeleteBtn: function listAlldeleteBtn(el) {
			var eachCheck = null;
			if (confirm('선택 된 데이터와 이력을 삭제하시겠습니까?') == true) {
				$(el).find('tr td .list-check:checked').each(function () {
					eachCheck = true;
					var thisListId = $(this).parents('tr').attr('data-id');
					_createFunc.createFunc.createListDeleteData(thisListId);
					$(this).parents('tr').remove();
				});
				if (eachCheck == null) {
					alert('선택 후 삭제 가능합니다.');
				}
			} else {
				return;
			}
		}
	
		//데이터 생성 페이지 단독 액션
	};
	//import datePicker
	window.createList = createList;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 869 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.keywordPopActive = keywordPopActive;
	
	__webpack_require__(871);
	
	function keywordPopActive(el) {
		$(el).find('ul li a').click(function () {
			$(el).find('ul li a').removeClass('active');
			$(this).addClass('active');
		});
	} //Sass 컴파일
	
	
	window.keywordPopActive = keywordPopActive;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.campaignActions = undefined;
	
	__webpack_require__(873);
	
	var campaignActions = exports.campaignActions = {
		init: function init() {},
		naverCampaign: function naverCampaign(thisEl) {
			var $this = $(thisEl);
			var eventOn = 'active';
			var activeCheck = $(this).hasClass(eventOn);
			if (activeCheck === false) {
				$('.on_campaign ul li a').removeClass(eventOn);
				$this.addClass(eventOn);
			}
		}
	
		//셋팅 페이지 단독 액션
	}; //Sass 컴파일
	window.campaignActions = campaignActions;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201)))

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// /bundle/main.min.js